export let bible = [
    '創1:1 起初，神創造天地。',
    '創1:2 地是空虛混沌，淵面黑暗；神的靈運行在水面上。',
    '創1:3 神說：要有光，就有了光。',
    '創1:4 神看光是好的，就把光暗分開了。',
    '創1:5 神稱光為晝，稱暗為夜。有晚上，有早晨，這是頭一日。',
    '創1:6 神說：諸水之間要有空氣，將水分為上下。',
    '創1:7 神就造出空氣，將空氣以下的水、空氣以上的水分開了。事就這樣成了。',
    '創1:8 神稱空氣為天。有晚上，有早晨，是第二日。',
    '創1:9 神說：天下的水要聚在一處，使旱地露出來。事就這樣成了。',
    '創1:10 神稱旱地為地，稱水的聚處為海。神看著是好的。',
    '創1:11 神說：地要發生青草和結種子的菜蔬，並結果子的樹木，各從其類，果子都包著核。事就這樣成了。',
    '創1:12 於是地發生了青草和結種子的菜蔬，各從其類；並結果子的樹木，各從其類；果子都包著核。神看著是好的。',
    '創1:13 有晚上，有早晨，是第三日。',
    '創1:14 神說：天上要有光體，可以分晝夜，作記號，定節令、日子、年歲，',
    '創1:15 並要發光在天空，普照在地上。事就這樣成了。',
    '創1:16 於是神造了兩個大光，大的管晝，小的管夜，又造眾星，',
    '創1:17 就把這些光擺列在天空，普照在地上，',
    '創1:18 管理晝夜，分別明暗。神看著是好的。',
    '創1:19 有晚上，有早晨，是第四日。',
    '創1:20 神說：水要多多滋生有生命的物；要有雀鳥飛在地面以上，天空之中。',
    '創1:21 神就造出大魚和水中所滋生各樣有生命的動物，各從其類；又造出各樣飛鳥，各從其類。神看著是好的。',
    '創1:22 神就賜福給這一切，說：滋生繁多，充滿海中的水；雀鳥也要多生在地上。',
    '創1:23 有晚上，有早晨，是第五日。',
    '創1:24 神說：地要生出活物來，各從其類；牲畜、昆蟲、野獸，各從其類。事就這樣成了。',
    '創1:25 於是神造出野獸，各從其類；牲畜，各從其類；地上一切昆蟲，各從其類。神看著是好的。',
    '創1:26 神說：我們要照著我們的形像、按著我們的樣式造人，使他們管理海裡的魚、空中的鳥、地上的牲畜，和全地，並地上所爬的一切昆蟲。',
    '創1:27 神就照著自己的形像造人，乃是照著他的形像造男造女。',
    '創1:28 神就賜福給他們，又對他們說：要生養眾多，遍滿地面，治理這地，也要管理海裡的魚、空中的鳥，和地上各樣行動的活物。',
    '創1:29 神說：看哪，我將遍地上一切結種子的菜蔬和一切樹上所結有核的果子全賜給你們作食物。',
    '創1:30 至於地上的走獸和空中的飛鳥，並各樣爬在地上有生命的物，我將青草賜給他們作食物。事就這樣成了。',
    '創1:31 神看著一切所造的都甚好。有晚上，有早晨，是第六日。',
    '創2:1 天地萬物都造齊了。',
    '創2:2 到第七日，神造物的工已經完畢，就在第七日歇了他一切的工，安息了。',
    '創2:3 神賜福給第七日，定為聖日；因為在這日，神歇了他一切創造的工，就安息了。',
    '創2:4 創造天地的來歷，在耶和華神造天地的日子，乃是這樣，',
    '創2:5 野地還沒有草木，田間的菜蔬還沒有長起來；因為耶和華神還沒有降雨在地上，也沒有人耕地，',
    '創2:6 但有霧氣從地上騰，滋潤遍地。',
    '創2:7 耶和華神用地上的塵土造人，將生氣吹在他鼻孔裡，他就成了有靈的活人，名叫亞當。',
    '創2:8 耶和華神在東方的伊甸立了一個園子，把所造的人安置在那裡。',
    '創2:9 耶和華神使各樣的樹從地裡長出來，可以悅人的眼目，其上的果子好作食物。園子當中又有生命樹和分別善惡的樹。',
    '創2:10 有河從伊甸流出來，滋潤那園子，從那裡分為四道：',
    '創2:11 第一道名叫比遜，就是環繞哈腓拉全地的。在那裡有金子，',
    '創2:12 並且那地的金子是好的；在那裡又有珍珠和紅瑪瑙。',
    '創2:13 第二道河名叫基訓，就是環繞古實全地的。',
    '創2:14 第三道河名叫希底結，流在亞述的東邊。第四道河就是伯拉河。',
    '創2:15 耶和華神將那人安置在伊甸園，使他修理，看守。',
    '創2:16 耶和華神吩咐他說：園中各樣樹上的果子，你可以隨意吃，',
    '創2:17 只是分別善惡樹上的果子，你不可吃，因為你吃的日子必定死！',
    '創2:18 耶和華神說：那人獨居不好，我要為他造一個配偶幫助他。',
    '創2:19 耶和華神用土所造成的野地各樣走獸和空中各樣飛鳥都帶到那人面前，看他叫什麼。那人怎樣叫各樣的活物，那就是他的名字。',
    '創2:20 那人便給一切牲畜和空中飛鳥、野地走獸都起了名；只是那人沒有遇見配偶幫助他。',
    '創2:21 耶和華神使他沉睡，他就睡了；於是取下他的一條肋骨，又把肉合起來。',
    '創2:22 耶和華神就用那人身上所取的肋骨造成一個女人，領他到那人跟前。',
    '創2:23 那人說：這是我骨中的骨，肉中的肉，可以稱他為女人，因為他是從男人身上取出來的。',
    '創2:24 因此，人要離開父母，與妻子連合，二人成為一體。',
    '創2:25 當時夫妻二人赤身露體，並不羞恥。',
    '創3:1 耶和華神所造的，惟有蛇比田野一切的活物更狡猾。蛇對女人說：神豈是真說不許你們吃園中所有樹上的果子嗎﹖',
    '創3:2 女人對蛇說：園中樹上的果子，我們可以吃，',
    '創3:3 惟有園當中那棵樹上的果子，神曾說：你們不可吃，也不可摸，免得你們死。',
    '創3:4 蛇對女人說：你們不一定死；',
    '創3:5 因為神知道，你們吃的日子眼睛就明亮了，你們便如神能知道善惡。',
    '創3:6 於是女人見那棵樹的果子好作食物，也悅人的眼目，且是可喜愛的，能使人有智慧，就摘下果子來吃了，又給他丈夫，他丈夫也吃了。',
    '創3:7 他們二人的眼睛就明亮了，才知道自己是赤身露體，便拿無花果樹的葉子為自己編做裙子。',
    '創3:8 天起了涼風，耶和華神在園中行走。那人和他妻子聽見神的聲音，就藏在園裡的樹木中，躲避耶和華神的面。',
    '創3:9 耶和華神呼喚那人，對他說：你在哪裡﹖',
    '創3:10 他說：我在園中聽見你的聲音，我就害怕；因為我赤身露體，我便藏了。',
    '創3:11 耶和華說：誰告訴你赤身露體呢﹖莫非你吃了我吩咐你不可吃的那樹上的果子嗎﹖',
    '創3:12 那人說：你所賜給我、與我同居的女人，他把那樹上的果子給我，我就吃了。',
    '創3:13 耶和華神對女人說：你做的是什麼事呢﹖女人說：那蛇引誘我，我就吃了。',
    '創3:14 耶和華神對蛇說：你既做了這事，就必受咒詛，比一切的牲畜野獸更甚。你必用肚子行走，終身吃土。',
    '創3:15 我又要叫你和女人彼此為仇；你的後裔和女人的後裔也彼此為仇。女人的後裔要傷你的頭；你要傷他的腳跟。',
    '創3:16 又對女人說：我必多多加增你懷胎的苦楚；你生產兒女必多受苦楚。你必戀慕你丈夫；你丈夫必管轄你。',
    '創3:17 又對亞當說：你既聽從妻子的話，吃了我所吩咐你不可吃的那樹上的果子，地必為你的緣故受咒詛；你必終身勞苦才能從地裡得吃的。',
    '創3:18 地必給你長出荊棘和蒺藜來；你也要吃田間的菜蔬。',
    '創3:19 你必汗流滿面才得糊口，直到你歸了土，因為你是從土而出的。你本是塵土，仍要歸於塵土。',
    '創3:20 亞當給他妻子起名叫夏娃，因為他是眾生之母。',
    '創3:21 耶和華神為亞當和他妻子用皮子做衣服給他們穿。',
    '創3:22 耶和華神說：那人已經與我們相似，能知道善惡；現在恐怕他伸手又摘生命樹的果子吃，就永遠活著。',
    '創3:23 耶和華神便打發他出伊甸園去，耕種他所自出之土。',
    '創3:24 於是把他趕出去了；又在伊甸園的東邊安設基路伯和四面轉動發火焰的劍，要把守生命樹的道路。',
    '創4:1 有一日，那人和他妻子夏娃同房，夏娃就懷孕，生了該隱【就是得的意思】，便說：耶和華使我得了一個男子。',
    '創4:2 又生了該隱的兄弟亞伯。亞伯是牧羊的；該隱是種地的。',
    '創4:3 有一日，該隱拿地裡的出產為供物獻給耶和華；',
    '創4:4 亞伯也將他羊群中頭生的和羊的脂油獻上。耶和華看中了亞伯和他的供物，',
    '創4:5 只是看不中該隱和他的供物。該隱就大大的發怒，變了臉色。',
    '創4:6 耶和華對該隱說：你為什麼發怒呢﹖你為什麼變了臉色呢﹖',
    '創4:7 你若行得好，豈不蒙悅納﹖你若行得不好，罪就伏在門前。他必戀慕你，你卻要制伏他。',
    '創4:8 該隱與他兄弟亞伯說話；二人正在田間。該隱起來打他兄弟亞伯，把他殺了。',
    '創4:9 耶和華對該隱說：你兄弟亞伯在哪裡﹖他說：我不知道！我豈是看守我兄弟的嗎﹖',
    '創4:10 耶和華說：你做了什麼事呢﹖你兄弟的血有聲音從地裡向我哀告。',
    '創4:11 地開了口，從你手裡接受你兄弟的血。現在你必從這地受咒詛。',
    '創4:12 你種地，地不再給你效力；你必流離飄蕩在地上。',
    '創4:13 該隱對耶和華說：我的刑罰太重，過於我所能當的。',
    '創4:14 你如今趕逐我離開這地，以致不見你面；我必流離飄蕩在地上，凡遇見我的必殺我。',
    '創4:15 耶和華對他說：凡殺該隱的，必遭報七倍。耶和華就給該隱立一個記號，免得人遇見他就殺他。',
    '創4:16 於是該隱離開耶和華的面，去住在伊甸東邊挪得之地。',
    '創4:17 該隱與妻子同房，他妻子就懷孕，生了以諾。該隱建造了一座城，就按著他兒子的名將那城叫做以諾。',
    '創4:18 以諾生以拿；以拿生米戶雅利；米戶雅利生瑪土撒利；瑪土撒利生拉麥。',
    '創4:19 拉麥娶了兩個妻：一個名叫亞大，一個名叫洗拉。',
    '創4:20 亞大生雅八；雅八就是住帳棚、牧養牲畜之人的祖師。',
    '創4:21 雅八的兄弟名叫猶八；他是一切彈琴吹簫之人的祖師。',
    '創4:22 洗拉又生了土八該隱；他是打造各樣銅鐵利器的【或作：是銅匠鐵匠的祖師】。土八該隱的妹子是拿瑪。',
    '創4:23 拉麥對他兩個妻子說：亞大、洗拉，聽我的聲音；拉麥的妻子，細聽我的話語：壯年人傷我，我把他殺了；少年人損我，我把他害了【或作我殺壯士卻傷自己，我害幼童卻損本身。】',
    '創4:24 若殺該隱，遭報七倍，殺拉麥，必遭報七十七倍。',
    '創4:25 亞當又與妻子同房，他就生了一個兒子，起名叫塞特，意思說：神另給我立了一個兒子代替亞伯，因為該隱殺了他。',
    '創4:26 塞特也生了一個兒子，起名叫以挪士。那時候，人才求告耶和華的名。',
    '創5:1 亞當的後代記在下面。（當神造人的日子，是照著自己的樣式造的，',
    '創5:2 並且造男造女。在他們被造的日子，神賜福給他們，稱他們為人。）',
    '創5:3 亞當活到一百三十歲，生了一個兒子，形像樣式和自己相似，就給他起名叫塞特。',
    '創5:4 亞當生塞特之後，又在世八百年，並且生兒養女。',
    '創5:5 亞當共活了九百三十歲就死了。',
    '創5:6 塞特活到一百零五歲，生了以挪士。',
    '創5:7 塞特生以挪士之後，又活了八百零七年，並且生兒養女。',
    '創5:8 塞特共活了九百一十二歲就死了。',
    '創5:9 以挪士活到九十歲，生了該南。',
    '創5:10 以挪士生該南之後，又活了八百一十五年，並且生兒養女。',
    '創5:11 以挪士共活了九百零五歲就死了。',
    '創5:12 該南活到七十歲，生了瑪勒列。',
    '創5:13 該南生瑪勒列之後，又活了八百四十年，並且生兒養女。',
    '創5:14 該南共活了九百一十歲就死了。',
    '創5:15 瑪勒列活到六十五歲，生了雅列。',
    '創5:16 瑪勒列生雅列之後，又活了八百三十年，並且生兒養女。',
    '創5:17 瑪勒列共活了八百九十五歲就死了。',
    '創5:18 雅列活到一百六十二歲，生了以諾。',
    '創5:19 雅列生以諾之後，又活了八百年，並且生兒養女。',
    '創5:20 雅列共活了九百六十二歲就死了。',
    '創5:21 以諾活到六十五歲，生了瑪土撒拉。',
    '創5:22 以諾生瑪土撒拉之後，與神同行三百年，並且生兒養女。',
    '創5:23 以諾共活了三百六十五歲。',
    '創5:24 以諾與神同行，神將他取去，他就不在世了。',
    '創5:25 瑪土撒拉活到一百八十七歲，生了拉麥。',
    '創5:26 瑪土撒拉生拉麥之後，又活了七百八十二年，並且生兒養女。',
    '創5:27 瑪土撒拉共活了九百六十九歲就死了。',
    '創5:28 拉麥活到一百八十二歲，生了一個兒子，',
    '創5:29 給他起名叫挪亞，說：這個兒子必為我們的操作和手中的勞苦安慰我們；這操作勞苦是因為耶和華咒詛地。',
    '創5:30 拉麥生挪亞之後，又活了五百九十五年，並且生兒養女。',
    '創5:31 拉麥共活了七百七十七歲就死了。',
    '創5:32 挪亞五百歲生了閃、含、雅弗。',
    '創6:1 當人在世上多起來、又生女兒的時候，',
    '創6:2 神的兒子們看見人的女子美貌，就隨意挑選，娶來為妻。',
    '創6:3 耶和華說：人既屬乎血氣，我的靈就不永遠住在他裡面；然而他的日子還可到一百二十年。',
    '創6:4 那時候有偉人在地上，後來神的兒子們和人的女子們交合生子；那就是上古英武有名的人。',
    '創6:5 耶和華見人在地上罪惡很大，終日所思想的盡都是惡，',
    '創6:6 耶和華就後悔造人在地上，心中憂傷。',
    '創6:7 耶和華說：我要將所造的人和走獸，並昆蟲，以及空中的飛鳥，都從地上除滅，因為我造他們後悔了。',
    '創6:8 惟有挪亞在耶和華眼前蒙恩。',
    '創6:9 挪亞的後代記在下面。挪亞是個義人，在當時的世代是個完全人。挪亞與神同行。',
    '創6:10 挪亞生了三個兒子，就是閃、含、雅弗。',
    '創6:11 世界在神面前敗壞，地上滿了強暴。',
    '創6:12 神觀看世界，見是敗壞了；凡有血氣的人在地上都敗壞了行為。',
    '創6:13 神就對挪亞說：凡有血氣的人，他的盡頭已經來到我面前；因為地上滿了他們的強暴，我要把他們和地一併毀滅。',
    '創6:14 你要用歌斐木造一隻方舟，分一間一間地造，裡外抹上松香。',
    '創6:15 方舟的造法乃是這樣：要長三百肘，寬五十肘，高三十肘。',
    '創6:16 方舟上邊要留透光處，高一肘。方舟的門要開在旁邊。方舟要分上、中、下三層。',
    '創6:17 看哪，我要使洪水氾濫在地上，毀滅天下；凡地上有血肉、有氣息的活物，無一不死。',
    '創6:18 我卻要與你立約；你同你的妻，與兒子兒婦，都要進入方舟。',
    '創6:19 凡有血肉的活物，每樣兩個，一公一母，你要帶進方舟，好在你那裡保全生命。',
    '創6:20 飛鳥各從其類，牲畜各從其類，地上的昆蟲各從其類，每樣兩個，要到你那裡，好保全生命。',
    '創6:21 你要拿各樣食物積蓄起來，好作你和他們的食物。',
    '創6:22 挪亞就這樣行。凡神所吩咐的，他都照樣行了。',
    '創7:1 耶和華對挪亞說：你和你的全家都要進入方舟；因為在這世代中，我見你在我面前是義人。',
    '創7:2 凡潔淨的畜類，你要帶七公七母；不潔淨的畜類，你要帶一公一母；',
    '創7:3 空中的飛鳥也要帶七公七母，可以留種，活在全地上；',
    '創7:4 因為再過七天，我要降雨在地上四十晝夜，把我所造的各種活物都從地上除滅。',
    '創7:5 挪亞就遵著耶和華所吩咐的行了。',
    '創7:6 當洪水氾濫在地上的時候，挪亞整六百歲。',
    '創7:7 挪亞就同他的妻和兒子兒婦都進入方舟，躲避洪水。',
    '創7:8 潔淨的畜類和不潔淨的畜類，飛鳥並地上一切的昆蟲，',
    '創7:9 都是一對一對的，有公有母，到挪亞那裡進入方舟，正如神所吩咐挪亞的。',
    '創7:10 過了那七天，洪水氾濫在地上。',
    '創7:11 當挪亞六百歲，二月十七日那一天，大淵的泉源都裂開了，天上的窗戶也敞開了，',
    '創7:12 四十晝夜降大雨在地上。',
    '創7:13 正當那日，挪亞和他三個兒子閃、含、雅弗，並挪亞的妻子和三個兒婦，都進入方舟。',
    '創7:14 他們和百獸，各從其類，一切牲畜，各從其類，爬在地上的昆蟲，各從其類，一切禽鳥，各從其類，都進入方舟。',
    '創7:15 凡有血肉、有氣息的活物，都一對一對地到挪亞那裡，進入方舟。',
    '創7:16 凡有血肉進入方舟的，都是有公有母，正如神所吩咐挪亞的。耶和華就把他關在方舟裡頭。',
    '創7:17 洪水氾濫在地上四十天，水往上長，把方舟從地上漂起。',
    '創7:18 水勢浩大，在地上大大地往上長，方舟在水面上漂來漂去。',
    '創7:19 水勢在地上極其浩大，天下的高山都淹沒了。',
    '創7:20 水勢比山高過十五肘，山嶺都淹沒了。',
    '創7:21 凡在地上有血肉的動物，就是飛鳥、牲畜、走獸，和爬在地上的昆蟲，以及所有的人，都死了。',
    '創7:22 凡在旱地上、鼻孔有氣息的生靈都死了。',
    '創7:23 凡地上各類的活物，連人帶牲畜、昆蟲，以及空中的飛鳥，都從地上除滅了，只留下挪亞和那些與他同在方舟裡的。',
    '創7:24 水勢浩大，在地上共一百五十天。',
    '創8:1 神記念挪亞和挪亞方舟裡的一切走獸牲畜。神叫風吹地，水勢漸落。',
    '創8:2 淵源和天上的窗戶都閉塞了，天上的大雨也止住了。',
    '創8:3 水從地上漸退。過了一百五十天，水就漸消。',
    '創8:4 七月十七日，方舟停在亞拉臘山上。',
    '創8:5 水又漸消，到十月初一日，山頂都現出來了。',
    '創8:6 過了四十天，挪亞開了方舟的窗戶，',
    '創8:7 放出一隻烏鴉去；那烏鴉飛來飛去，直到地上的水都乾了。',
    '創8:8 他又放出一隻鴿子去，要看看水從地上退了沒有。',
    '創8:9 但遍地上都是水，鴿子找不著落腳之地，就回到方舟挪亞那裡，挪亞伸手把鴿子接進方舟來。',
    '創8:10 他又等了七天，再把鴿子從方舟放出去。',
    '創8:11 到了晚上，鴿子回到他那裡，嘴裡叼著一個新擰下來的橄欖葉子，挪亞就知道地上的水退了。',
    '創8:12 他又等了七天，放出鴿子去，鴿子就不再回來了。',
    '創8:13 到挪亞六百零一歲，正月初一日，地上的水都乾了。挪亞撤去方舟的蓋觀看，便見地面上乾了。',
    '創8:14 到了二月二十七日，地就都乾了。',
    '創8:15 神對挪亞說：',
    '創8:16 你和你的妻子、兒子、兒婦都可以出方舟。',
    '創8:17 在你那裡凡有血肉的活物，就是飛鳥、牲畜，和一切爬在地上的昆蟲，都要帶出來，叫他在地上多多滋生，大大興旺。',
    '創8:18 於是挪亞和他的妻子、兒子、兒婦都出來了。',
    '創8:19 一切走獸、昆蟲、飛鳥，和地上所有的動物，各從其類，也都出了方舟。',
    '創8:20 挪亞為耶和華築了一座壇，拿各類潔淨的牲畜、飛鳥獻在壇上為燔祭。',
    '創8:21 耶和華聞那馨香之氣，就心裡說：我不再因人的緣故咒詛地（人從小時心裡懷著惡念），也不再按著我才行的滅各種的活物了。',
    '創8:22 地還存留的時候，稼穡、寒暑、冬夏、晝夜就永不停息了。',
    '創9:1 神賜福給挪亞和他的兒子，對他們說：你們要生養眾多，遍滿了地。',
    '創9:2 凡地上的走獸和空中的飛鳥都必驚恐，懼怕你們，連地上一切的昆蟲並海裡一切的魚都交付你們的手。',
    '創9:3 凡活著的動物都可以作你們的食物。這一切我都賜給你們，如同菜蔬一樣。',
    '創9:4 惟獨肉帶著血，那就是他的生命，你們不可吃。',
    '創9:5 流你們血、害你們命的，無論是獸是人，我必討他的罪，就是向各人的弟兄也是如此。',
    '創9:6 凡流人血的，他的血也必被人所流，因為神造人是照自己的形像造的。',
    '創9:7 你們要生養眾多，在地上昌盛繁茂。',
    '創9:8 神曉諭挪亞和他的兒子說：',
    '創9:9 我與你們和你們的後裔立約，',
    '創9:10 並與你們這裡的一切活物─就是飛鳥、牲畜、走獸，凡從方舟裡出來的活物─立約。',
    '創9:11 我與你們立約，凡有血肉的，不再被洪水滅絕，也不再有洪水毀壞地了。',
    '創9:12 神說：我與你們並你們這裡的各樣活物所立的永約是有記號的。',
    '創9:13 我把虹放在雲彩中，這就可作我與地立約的記號了。',
    '創9:14 我使雲彩蓋地的時候，必有虹現在雲彩中，',
    '創9:15 我便記念我與你們和各樣有血肉的活物所立的約，水就再不氾濫、毀壞一切有血肉的物了。',
    '創9:16 虹必現在雲彩中，我看見，就要記念我與地上各樣有血肉的活物所立的永約。',
    '創9:17 神對挪亞說：這就是我與地上一切有血肉之物立約的記號了。',
    '創9:18 出方舟挪亞的兒子就是閃、含、雅弗。含是迦南的父親。',
    '創9:19 這是挪亞的三個兒子，他們的後裔分散在全地。',
    '創9:20 挪亞作起農夫來，栽了一個葡萄園。',
    '創9:21 他喝了園中的酒便醉了，在帳棚裡赤著身子。',
    '創9:22 迦南的父親含看見他父親赤身，就到外邊告訴他兩個弟兄。',
    '創9:23 於是閃和雅弗拿件衣服搭在肩上，倒退著進去，給他父親蓋上；他們背著臉就看不見父親的赤身。',
    '創9:24 挪亞醒了酒，知道小兒子向他所做的事，',
    '創9:25 就說：迦南當受咒詛，必給他弟兄作奴僕的奴僕；',
    '創9:26 又說：耶和華─閃的神是應當稱頌的！願迦南作閃的奴僕。',
    '創9:27 願神使雅弗擴張，使他住在閃的帳棚裡；又願迦南作他的奴僕。',
    '創9:28 洪水以後，挪亞又活了三百五十年。',
    '創9:29 挪亞共活了九百五十歲就死了。',
    '創10:1 挪亞的兒子閃、含、雅弗的後代記在下面。洪水以後，他們都生了兒子。',
    '創10:2 雅弗的兒子是歌篾、瑪各、瑪代、雅完、土巴、米設、提拉。',
    '創10:3 歌篾的兒子是亞實基拿、利法、陀迦瑪。',
    '創10:4 雅完的兒子是以利沙、他施、基提、多單。',
    '創10:5 這些人的後裔將各國的地土、海島分開居住，各隨各的方言、宗族立國。',
    '創10:6 含的兒子是古實、麥西、弗、迦南。',
    '創10:7 古實的兒子是西巴、哈腓拉、撒弗他、拉瑪、撒弗提迦。拉瑪的兒子是示巴、底但。',
    '創10:8 古實又生寧錄，他為世上英雄之首。',
    '創10:9 他在耶和華面前是個英勇的獵戶，所以俗語說：像寧錄在耶和華面前是個英勇的獵戶。',
    '創10:10 他國的起頭是巴別、以力、亞甲、甲尼，都在示拿地。',
    '創10:11 他從那地出來往亞述去，建造尼尼微、利河伯、迦拉，',
    '創10:12 和尼尼微、迦拉中間的利鮮，這就是那大城。',
    '創10:13 麥西生路低人、亞拿米人、利哈比人、拿弗土希人、',
    '創10:14 帕斯魯細人、迦斯路希人、迦斐託人；從迦斐託出來的有非利士人。',
    '創10:15 迦南生長子西頓，又生赫',
    '創10:16 和耶布斯人、亞摩利人、革迦撒人、',
    '創10:17 希未人、亞基人、西尼人、',
    '創10:18 亞瓦底人、洗瑪利人、哈馬人，後來迦南的諸族分散了。',
    '創10:19 迦南的境界是從西頓向基拉耳的路上，直到迦薩，又向所多瑪、蛾摩拉、押瑪、洗扁的路上，直到拉沙。',
    '創10:20 這就是含的後裔，各隨他們的宗族、方言，所住的地土、邦國。',
    '創10:21 雅弗的哥哥閃，是希伯子孫之祖，他也生了兒子。',
    '創10:22 閃的兒子是以攔、亞述、亞法撒、路德、亞蘭。',
    '創10:23 亞蘭的兒子是烏斯、戶勒、基帖、瑪施。',
    '創10:24 亞法撒生沙拉；沙拉生希伯。',
    '創10:25 希伯生了兩個兒子，一個名叫法勒【法勒就是分的意思】，因為那時人就分地居住；法勒的兄弟名叫約坍。',
    '創10:26 約坍生亞摩答、沙列、哈薩瑪非、耶拉、',
    '創10:27 哈多蘭、烏薩、德拉、',
    '創10:28 俄巴路、亞比瑪利、示巴、',
    '創10:29 阿斐、哈腓拉、約巴，這都是約坍的兒子。',
    '創10:30 他們所住的地方是從米沙直到西發東邊的山。',
    '創10:31 這就是閃的子孫，各隨他們的宗族、方言，所住的地土、邦國。',
    '創10:32 這些都是挪亞三個兒子的宗族，各隨他們的支派立國。洪水以後，他們在地上分為邦國。',
    '創11:1 那時，天下人的口音、言語都是一樣。',
    '創11:2 他們往東邊遷移的時候，在示拿地遇見一片平原，就住在那裡。',
    '創11:3 他們彼此商量說：來吧！我們要做磚，把磚燒透了。他們就拿磚當石頭，又拿石漆當灰泥。',
    '創11:4 他們說：來吧！我們要建造一座城和一座塔，塔頂通天，為要傳揚我們的名，免得我們分散在全地上。',
    '創11:5 耶和華降臨，要看看世人所建造的城和塔。',
    '創11:6 耶和華說：看哪，他們成為一樣的人民，都是一樣的言語，如今既做起這事來，以後他們所要做的事就沒有不成就的了。',
    '創11:7 我們下去，在那裡變亂他們的口音，使他們的言語彼此不通。',
    '創11:8 於是耶和華使他們從那裡分散在全地上；他們就停工，不造那城了。',
    '創11:9 因為耶和華在那裡變亂天下人的言語，使眾人分散在全地上，所以那城名叫巴別【就是變亂的意思】。',
    '創11:10 閃的後代記在下面。洪水以後二年，閃一百歲生了亞法撒。',
    '創11:11 閃生亞法撒之後又活了五百年，並且生兒養女。',
    '創11:12 亞法撒活到三十五歲，生了沙拉。',
    '創11:13 亞法撒生沙拉之後又活了四百零三年，並且生兒養女。',
    '創11:14 沙拉活到三十歲，生了希伯。',
    '創11:15 沙拉生希伯之後又活了四百零三年，並且生兒養女。',
    '創11:16 希伯活到三十四歲，生了法勒。',
    '創11:17 希伯生法勒之後又活了四百三十年，並且生兒養女。',
    '創11:18 法勒活到三十歲，生了拉吳。',
    '創11:19 法勒生拉吳之後又活了二百零九年，並且生兒養女。',
    '創11:20 拉吳活到三十二歲，生了西鹿。',
    '創11:21 拉吳生西鹿之後又活了二百零七年，並且生兒養女。',
    '創11:22 西鹿活到三十歲，生了拿鶴。',
    '創11:23 西鹿生拿鶴之後又活了二百年，並且生兒養女。',
    '創11:24 拿鶴活到二十九歲，生了他拉。',
    '創11:25 拿鶴生他拉之後又活了一百一十九年，並且生兒養女。',
    '創11:26 他拉活到七十歲，生了亞伯蘭、拿鶴、哈蘭。',
    '創11:27 他拉的後代記在下面。他拉生亞伯蘭、拿鶴、哈蘭；哈蘭生羅得。',
    '創11:28 哈蘭死在他的本地迦勒底的吾珥，在他父親他拉之先。',
    '創11:29 亞伯蘭、拿鶴各娶了妻：亞伯蘭的妻子名叫撒萊；拿鶴的妻子名叫密迦，是哈蘭的女兒；哈蘭是密迦和亦迦的父親。',
    '創11:30 撒萊不生育，沒有孩子。',
    '創11:31 他拉帶著他兒子亞伯蘭和他孫子哈蘭的兒子羅得，並他兒婦亞伯蘭的妻子撒萊，出了迦勒底的吾珥，要往迦南地去；他們走到哈蘭，就住在那裡。',
    '創11:32 他拉共活了二百零五歲，就死在哈蘭。',
    '創12:1 耶和華對亞伯蘭說：你要離開本地、本族、父家，往我所要指示你的地去。',
    '創12:2 我必叫你成為大國。我必賜福給你，叫你的名為大；你也要叫別人得福。',
    '創12:3 為你祝福的，我必賜福與他；那咒詛你的，我必咒詛他。地上的萬族都要因你得福。',
    '創12:4 亞伯蘭就照著耶和華的吩咐去了；羅得也和他同去。亞伯蘭出哈蘭的時候年七十五歲。',
    '創12:5 亞伯蘭將他妻子撒萊和姪兒羅得，連他們在哈蘭所積蓄的財物、所得的人口，都帶往迦南地去。他們就到了迦南地。',
    '創12:6 亞伯蘭經過那地，到了示劍地方、摩利橡樹那裡。那時迦南人住在那地。',
    '創12:7 耶和華向亞伯蘭顯現，說：我要把這地賜給你的後裔。亞伯蘭就在那裡為向他顯現的耶和華築了一座壇。',
    '創12:8 從那裡他又遷到伯特利東邊的山，支搭帳棚；西邊是伯特利，東邊是艾。他在那裡又為耶和華築了一座壇，求告耶和華的名。',
    '創12:9 後來亞伯蘭又漸漸遷往南地去。',
    '創12:10 那地遭遇饑荒。因饑荒甚大，亞伯蘭就下埃及去，要在那裡暫居。',
    '創12:11 將近埃及，就對他妻子撒萊說：我知道你是容貌俊美的婦人。',
    '創12:12 埃及人看見你必說：這是他的妻子，他們就要殺我，卻叫你存活。',
    '創12:13 求你說，你是我的妹子，使我因你得平安，我的命也因你存活。',
    '創12:14 及至亞伯蘭到了埃及，埃及人看見那婦人極其美貌。',
    '創12:15 法老的臣宰看見了他，就在法老面前誇獎他。那婦人就被帶進法老的宮去。',
    '創12:16 法老因這婦人就厚待亞伯蘭，亞伯蘭得了許多牛、羊、駱駝、公驢、母驢、僕婢。',
    '創12:17 耶和華因亞伯蘭妻子撒萊的緣故，降大災與法老和他的全家。',
    '創12:18 法老就召了亞伯蘭來，說：你這向我做的是什麼事呢﹖為什麼沒有告訴我他是你的妻子﹖',
    '創12:19 為什麼說他是你的妹子，以致我把他取來要作我的妻子﹖現在你的妻子在這裡，可以帶他走吧。',
    '創12:20 於是法老吩咐人將亞伯蘭和他妻子，並他所有的都送走了。',
    '創13:1 亞伯蘭帶著他的妻子與羅得，並一切所有的，都從埃及上南地去。',
    '創13:2 亞伯蘭的金、銀、牲畜極多。',
    '創13:3 他從南地漸漸往伯特利去，到了伯特利和艾的中間，就是從前支搭帳棚的地方，',
    '創13:4 也是他起先築壇的地方；他又在那裡求告耶和華的名。',
    '創13:5 與亞伯蘭同行的羅得也有牛群、羊群、帳棚。',
    '創13:6 那地容不下他們；因為他們的財物甚多，使他們不能同居。',
    '創13:7 當時，迦南人與比利洗人在那地居住。亞伯蘭的牧人和羅得的牧人相爭。',
    '創13:8 亞伯蘭就對羅得說：你我不可相爭，你的牧人和我的牧人也不可相爭，因為我們是骨肉【原文作弟兄】。',
    '創13:9 遍地不都在你眼前嗎﹖請你離開我：你向左，我就向右；你向右，我就向左。',
    '創13:10 羅得舉目看見約但河的全平原，直到瑣珥，都是滋潤的，那地在耶和華未滅所多瑪、蛾摩拉以先如同耶和華的園子，也像埃及地。',
    '創13:11 於是羅得選擇約但河的全平原，往東遷移；他們就彼此分離了。',
    '創13:12 亞伯蘭住在迦南地，羅得住在平原的城邑，漸漸挪移帳棚，直到所多瑪。',
    '創13:13 所多瑪人在耶和華面前罪大惡極。',
    '創13:14 羅得離別亞伯蘭以後，耶和華對亞伯蘭說：從你所在的地方，你舉目向東西南北觀看；',
    '創13:15 凡你所看見的一切地，我都要賜給你和你的後裔，直到永遠。',
    '創13:16 我也要使你的後裔如同地上的塵沙那樣多，人若能數算地上的塵沙才能數算你的後裔。',
    '創13:17 你起來，縱橫走遍這地，因為我必把這地賜給你。',
    '創13:18 亞伯蘭就搬了帳棚，來到希伯崙幔利的橡樹那裡居住，在那裡為耶和華築了一座壇。',
    '創14:1 當暗拉非作示拿王，亞略作以拉撒王，基大老瑪作以攔王，提達作戈印王的時候，',
    '創14:2 他們都攻打所多瑪王比拉、蛾摩拉王比沙、押瑪王示納、洗扁王善以別，和比拉王；比拉就是瑣珥。',
    '創14:3 這五王都在西訂谷會合；西訂谷就是鹽海。',
    '創14:4 他們已經事奉基大老瑪十二年，到十三年就背叛了。',
    '創14:5 十四年，基大老瑪和同盟的王都來在亞特律加寧，殺敗了利乏音人，在哈麥殺敗了蘇西人，在沙微基列亭殺敗了以米人，',
    '創14:6 在何利人的西珥山殺敗了何利人，一直殺到靠近曠野的伊勒巴蘭。',
    '創14:7 他們回到安密巴，就是加低斯，殺敗了亞瑪力全地的人，以及住在哈洗遜他瑪的亞摩利人。',
    '創14:8 於是所多瑪王、蛾摩拉王、押瑪王、洗扁王，和比拉王（比拉就是瑣珥）都出來，在西訂谷擺陣，與他們交戰，',
    '創14:9 就是與以攔王基大老瑪、戈印王提達、示拿王暗拉非、以拉撒王亞略交戰；乃是四王與五王交戰。',
    '創14:10 西訂谷有許多石漆坑。所多瑪王和蛾摩拉王逃跑，有掉在坑裡的，其餘的人都往山上逃跑。',
    '創14:11 四王就把所多瑪和蛾摩拉所有的財物，並一切的糧食都擄掠去了；',
    '創14:12 又把亞伯蘭的姪兒羅得和羅得的財物擄掠去了。當時羅得正住在所多瑪。',
    '創14:13 有一個逃出來的人告訴希伯來人亞伯蘭；亞伯蘭正住在亞摩利人幔利的橡樹那裡。幔利和以實各並亞乃都是弟兄，曾與亞伯蘭聯盟。',
    '創14:14 亞伯蘭聽見他姪兒【原文作弟兄】被擄去，就率領他家裡生養的精練壯丁三百一十八人，直追到但，',
    '創14:15 便在夜間，自己同僕人分隊殺敗敵人，又追到大馬色左邊的何把，',
    '創14:16 將被擄掠的一切財物奪回來，連他姪兒羅得和他的財物，以及婦女、人民也都奪回來。',
    '創14:17 亞伯蘭殺敗基大老瑪和與他同盟的王回來的時候，所多瑪王出來，在沙微谷迎接他；沙微谷就是王谷。',
    '創14:18 又有撒冷王麥基洗德帶著餅和酒出來迎接；他是至高神的祭司。',
    '創14:19 他為亞伯蘭祝福，說：願天地的主、至高的神賜福與亞伯蘭！',
    '創14:20 至高的神把敵人交在你手裡，是應當稱頌的！亞伯蘭就把所得的拿出十分之一來，給麥基洗德。',
    '創14:21 所多瑪王對亞伯蘭說：你把人口給我，財物你自己拿去吧！',
    '創14:22 亞伯蘭對所多瑪王說：我已經向天地的主─至高的神耶和華起誓：',
    '創14:23 凡是你的東西，就是一根線、一根鞋帶，我都不拿，免得你說：我使亞伯蘭富足！',
    '創14:24 只有僕人所吃的，並與我同行的亞乃、以實各、幔利所應得的分，可以任憑他們拿去。',
    '創15:1 這事以後，耶和華在異象中有話對亞伯蘭說：亞伯蘭，你不要懼怕！我是你的盾牌，必大大的賞賜你。',
    '創15:2 亞伯蘭說：主耶和華啊，我既無子，你還賜我什麼呢﹖並且要承受我家業的是大馬色人以利以謝。',
    '創15:3 亞伯蘭又說：你沒有給我兒子；那生在我家中的人就是我的後嗣。',
    '創15:4 耶和華又有話對他說：這人必不成為你的後嗣；你本身所生的才成為你的後嗣。',
    '創15:5 於是領他走到外邊，說：你向天觀看，數算眾星，能數得過來嗎﹖又對他說：你的後裔將要如此。',
    '創15:6 亞伯蘭信耶和華，耶和華就以此為他的義。',
    '創15:7 耶和華又對他說：我是耶和華，曾領你出了迦勒底的吾珥，為要將這地賜你為業。',
    '創15:8 亞伯蘭說：主耶和華啊，我怎能知道必得這地為業呢﹖',
    '創15:9 他說：你為我取一隻三年的母牛，一隻三年的母山羊，一隻三年的公綿羊，一隻斑鳩，一隻雛鴿。',
    '創15:10 亞伯蘭就取了這些來，每樣劈開，分成兩半，一半對著一半地擺列，只有鳥沒有劈開。',
    '創15:11 有鷙鳥下來，落在那死畜的肉上，亞伯蘭就把他嚇飛了。',
    '創15:12 日頭正落的時候，亞伯蘭沉沉地睡了；忽然有驚人的大黑暗落在他身上。',
    '創15:13 耶和華對亞伯蘭說：你要的確知道，你的後裔必寄居別人的地，又服事那地的人；那地的人要苦待他們四百年。',
    '創15:14 並且他們所要服事的那國，我要懲罰，後來他們必帶著許多財物從那裡出來。',
    '創15:15 但你要享大壽數，平平安安地歸到你列祖那裡，被人埋葬。',
    '創15:16 到了第四代，他們必回到此地，因為亞摩利人的罪孽還沒有滿盈。',
    '創15:17 日落天黑，不料有冒煙的爐並燒著的火把從那些肉塊中經過。',
    '創15:18 當那日，耶和華與亞伯蘭立約，說：我已賜給你的後裔，從埃及河直到伯拉大河之地，',
    '創15:19 就是基尼人、基尼洗人、甲摩尼人、',
    '創15:20 赫人、比利洗人、利乏音人、',
    '創15:21 亞摩利人、迦南人、革迦撒人、耶布斯人之地。',
    '創16:1 亞伯蘭的妻子撒萊不給他生兒女。撒萊有一個使女，名叫夏甲，是埃及人。',
    '創16:2 撒萊對亞伯蘭說：耶和華使我不能生育。求你和我的使女同房，或者我可以因他得孩子【原文作被建立】。亞伯蘭聽從了撒萊的話。',
    '創16:3 於是亞伯蘭的妻子撒萊將使女埃及人夏甲給了丈夫為妾；那時亞伯蘭在迦南已經住了十年。',
    '創16:4 亞伯蘭與夏甲同房，夏甲就懷了孕；他見自己有孕，就小看他的主母。',
    '創16:5 撒萊對亞伯蘭說：我因你受屈。我將我的使女放在你懷中，他見自己有了孕，就小看我。願耶和華在你我中間判斷。',
    '創16:6 亞伯蘭對撒萊說：使女在你手下，你可以隨意待他。撒萊苦待他，他就從撒萊面前逃走了。',
    '創16:7 耶和華的使者在曠野書珥路上的水泉旁遇見他，',
    '創16:8 對他說：撒萊的使女夏甲，你從哪裡來﹖要往哪裡去﹖夏甲說：我從我的主母撒萊面前逃出來。',
    '創16:9 耶和華的使者對他說：你回到你主母那裡，服在他手下；',
    '創16:10 又說：我必使你的後裔極其繁多，甚至不可勝數；',
    '創16:11 並說：你如今懷孕要生一個兒子，可以給他起名叫以實瑪利，因為耶和華聽見了你的苦情。【以實瑪利就是神聽見的意思】',
    '創16:12 他為人必像野驢。他的手要攻打人，人的手也要攻打他；他必住在眾弟兄的東邊。',
    '創16:13 夏甲就稱那對他說話的耶和華為看顧人的神。因而說：在這裡我也看見那看顧我的嗎﹖',
    '創16:14 所以這井名叫庇耳拉海萊。這井正在加低斯和巴列中間。',
    '創16:15 後來夏甲給亞伯蘭生了一個兒子；亞伯蘭給他起名叫以實瑪利。',
    '創16:16 夏甲給亞伯蘭生以實瑪利的時候，亞伯蘭年八十六歲。',
    '創17:1 亞伯蘭年九十九歲的時候，耶和華向他顯現，對他說：我是全能的神。你當在我面前作完全人，',
    '創17:2 我就與你立約，使你的後裔極其繁多。',
    '創17:3 亞伯蘭俯伏在地；神又對他說：',
    '創17:4 我與你立約：你要作多國的父。',
    '創17:5 從此以後，你的名不再叫亞伯蘭，要叫亞伯拉罕，因為我已立你作多國的父。',
    '創17:6 我必使你的後裔極其繁多；國度從你而立，君王從你而出。',
    '創17:7 我要與你並你世世代代的後裔堅立我的約，作永遠的約，是要作你和你後裔的神。',
    '創17:8 我要將你現在寄居的地，就是迦南全地，賜給你和你的後裔永遠為業，我也必作他們的神。',
    '創17:9 神又對亞伯拉罕說：你和你的後裔必世世代代遵守我的約。',
    '創17:10 你們所有的男子都要受割禮；這就是我與你並你的後裔所立的約，是你們所當遵守的。',
    '創17:11 你們都要受割禮【原文作割陽皮；14，23，24，25節同】；這是我與你們立約的證據。',
    '創17:12 你們世世代代的男子，無論是家裡生的，是在你後裔之外用銀子從外人買的，生下來第八日，都要受割禮。',
    '創17:13 你家裡生的和你用銀子買的，都必須受割禮。這樣，我的約就立在你們肉體上作永遠的約。',
    '創17:14 但不受割禮的男子必從民中剪除，因他背了我的約。',
    '創17:15 神又對亞伯拉罕說：你的妻子撒萊不可再叫撒萊，他的名要叫撒拉。',
    '創17:16 我必賜福給他，也要使你從他得一個兒子。我要賜福給他，他也要作多國之母；必有百姓的君王從他而出。',
    '創17:17 亞伯拉罕就俯伏在地喜笑，心裡說：一百歲的人還能得孩子嗎﹖撒拉已經九十歲了，還能生養嗎﹖',
    '創17:18 亞伯拉罕對神說：但願以實瑪利活在你面前。',
    '創17:19 神說：不然，你妻子撒拉要給你生一個兒子，你要給他起名叫以撒。我要與他堅定所立的約，作他後裔永遠的約。',
    '創17:20 至於以實瑪利，我也應允你：我必賜福給他，使他昌盛，極其繁多。他必生十二個族長；我也要使他成為大國。',
    '創17:21 到明年這時節，撒拉必給你生以撒，我要與他堅定所立的約。',
    '創17:22 神和亞伯拉罕說完了話，就離開他上升去了。',
    '創17:23 正當那日，亞伯拉罕遵著神的命，給他的兒子以實瑪利和家裡的一切男子，無論是在家裡生的，是用銀子買的，都行了割禮。',
    '創17:24 亞伯拉罕受割禮的時候年九十九歲。',
    '創17:25 他兒子以實瑪利受割禮的時候年十三歲。',
    '創17:26 正當那日，亞伯拉罕和他兒子以實瑪利一同受了割禮。',
    '創17:27 家裡所有的人，無論是在家裡生的，是用銀子從外人買的，也都一同受了割禮。',
    '創18:1 耶和華在幔利橡樹那裡向亞伯拉罕顯現出來。那時正熱，亞伯拉罕坐在帳棚門口，',
    '創18:2 舉目觀看，見有三個人在對面站著。他一見，就從帳棚門口跑去迎接他們，俯伏在地，',
    '創18:3 說：我主，我若在你眼前蒙恩，求你不要離開僕人往前去。',
    '創18:4 容我拿點水來，你們洗洗腳，在樹下歇息歇息。',
    '創18:5 我再拿一點餅來，你們可以加添心力，然後往前去。你們既到僕人這裡來，理當如此。他們說：就照你說的行吧。',
    '創18:6 亞伯拉罕急忙進帳棚見撒拉，說：你速速拿三細亞細麵調和做餅。',
    '創18:7 亞伯拉罕又跑到牛群裡，牽了一隻又嫩又好的牛犢來，交給僕人，僕人急忙預備好了。',
    '創18:8 亞伯拉罕又取了奶油和奶，並預備好的牛犢來，擺在他們面前，自己在樹下站在旁邊，他們就吃了。',
    '創18:9 他們問亞伯拉罕說：你妻子撒拉在哪裡﹖他說：在帳棚裡。',
    '創18:10 三人中有一位說：到明年這時候，我必要回到你這裡；你的妻子撒拉必生一個兒子。撒拉在那人後邊的帳棚門口也聽見了這話。',
    '創18:11 亞伯拉罕和撒拉年紀老邁，撒拉的月經已斷絕了。',
    '創18:12 撒拉心裡暗笑，說：我既已衰敗，我主也老邁，豈能有這喜事呢﹖',
    '創18:13 耶和華對亞伯拉罕說：撒拉為什麼暗笑，說：我既已年老，果真能生養嗎﹖',
    '創18:14 耶和華豈有難成的事嗎﹖到了日期，明年這時候，我必回到你這裡，撒拉必生一個兒子。',
    '創18:15 撒拉就害怕，不承認，說：我沒有笑。那位說：不然，你實在笑了。',
    '創18:16 三人就從那裡起行，向所多瑪觀看，亞伯拉罕也與他們同行，要送他們一程。',
    '創18:17 耶和華說：我所要做的事豈可瞞著亞伯拉罕呢﹖',
    '創18:18 亞伯拉罕必要成為強大的國；地上的萬國都必因他得福。',
    '創18:19 我眷顧他，為要叫他吩咐他的眾子和他的眷屬遵守我的道，秉公行義，使我所應許亞伯拉罕的話都成就了。',
    '創18:20 耶和華說：所多瑪和蛾摩拉的罪惡甚重，聲聞於我。',
    '創18:21 我現在要下去，察看他們所行的，果然盡像那達到我耳中的聲音一樣嗎﹖若是不然，我也必知道。',
    '創18:22 二人轉身離開那裡，向所多瑪去；但亞伯拉罕仍舊站在耶和華面前。',
    '創18:23 亞伯拉罕近前來，說：無論善惡，你都要剿滅嗎﹖',
    '創18:24 假若那城裡有五十個義人，你還剿滅那地方嗎﹖不為城裡這五十個義人饒恕其中的人嗎﹖',
    '創18:25 將義人與惡人同殺，將義人與惡人一樣看待，這斷不是你所行的。審判全地的主豈不行公義嗎﹖',
    '創18:26 耶和華說：我若在所多瑪城裡見有五十個義人，我就為他們的緣故饒恕那地方的眾人。',
    '創18:27 亞伯拉罕說：我雖然是灰塵，還敢對主說話。',
    '創18:28 假若這五十個義人短了五個，你就因為短了五個毀滅全城嗎﹖他說：我在那裡若見有四十五個，也不毀滅那城。',
    '創18:29 亞伯拉罕又對他說：假若在那裡見有四十個怎麼樣呢﹖他說：為這四十個的緣故，我也不做這事。',
    '創18:30 亞伯拉罕說：求主不要動怒，容我說，假若在那裡見有三十個怎麼樣呢﹖他說：我在那裡若見有三十個，我也不做這事。',
    '創18:31 亞伯拉罕說：我還敢對主說話，假若在那裡見有二十個怎麼樣呢﹖他說：為這二十個的緣故，我也不毀滅那城。',
    '創18:32 亞伯拉罕說：求主不要動怒，我再說這一次，假若在那裡見有十個呢﹖他說：為這十個的緣故，我也不毀滅那城。',
    '創18:33 耶和華與亞伯拉罕說完了話就走了；亞伯拉罕也回到自己的地方去了。',
    '創19:1 那兩個天使晚上到了所多瑪；羅得正坐在所多瑪城門口，看見他們，就起來迎接，臉伏於地下拜，',
    '創19:2 說：我主啊，請你們到僕人家裡洗洗腳，住一夜，清早起來再走。他們說：不！我們要在街上過夜。',
    '創19:3 羅得切切的請他們，他們這才進去，到他屋裡。羅得為他們預備筵席，烤無酵餅，他們就吃了。',
    '創19:4 他們還沒有躺下，所多瑪城裡各處的人，連老帶少，都來圍住那房子，',
    '創19:5 呼叫羅得說：今日晚上到你這裡來的人在哪裡呢﹖把他們帶出來，任我們所為。',
    '創19:6 羅得出來，把門關上，到眾人那裡，',
    '創19:7 說：眾弟兄，請你們不要做這惡事。',
    '創19:8 我有兩個女兒，還是處女，容我領出來，任憑你們的心願而行；只是這兩個人既然到我舍下，不要向他們做什麼。',
    '創19:9 眾人說：退去吧！又說：這個人來寄居，還想要作官哪！現在我們要害你比害他們更甚。眾人就向前擁擠羅得，要攻破房門。',
    '創19:10 只是那二人伸出手來，將羅得拉進屋去，把門關上，',
    '創19:11 並且使門外的人，無論老少，眼都昏迷；他們摸來摸去，總尋不著房門。',
    '創19:12 二人對羅得說：你這裡還有什麼人嗎﹖無論是女婿是兒女，和這城中一切屬你的人，你都要將他們從這地方帶出去。',
    '創19:13 我們要毀滅這地方；因為城內罪惡的聲音在耶和華面前甚大，耶和華差我們來，要毀滅這地方。',
    '創19:14 羅得就出去，告訴娶了【或作將要娶】他女兒的女婿們說：你們起來離開這地方，因為耶和華要毀滅這城。他女婿們卻以為他說的是戲言。',
    '創19:15 天明了，天使催逼羅得說：起來！帶著你的妻子和你在這裡的兩個女兒出去，免得你因這城裡的罪惡同被剿滅。',
    '創19:16 但羅得遲延不走。二人因為耶和華憐恤羅得，就拉著他的手和他妻子的手，並他兩個女兒的手，把他們領出來，安置在城外；',
    '創19:17 領他們出來以後，就說：逃命吧！不可回頭看，也不可在平原站住。要往山上逃跑，免得你被剿滅。',
    '創19:18 羅得對他們說：我主啊，不要如此！',
    '創19:19 你僕人已經在你眼前蒙恩；你又向我顯出莫大的慈愛，救我的性命。我不能逃到山上去，恐怕這災禍臨到我，我便死了。',
    '創19:20 看哪，這座城又小又近，容易逃到，這不是一個小的嗎﹖求你容我逃到那裡，我的性命就得存活。',
    '創19:21 天使對他說：這事我也應允你；我不傾覆你所說的這城。',
    '創19:22 你要速速地逃到那城；因為你還沒有到那裡，我不能做什麼。因此那城名叫瑣珥【就是小的意思】。',
    '創19:23 羅得到了瑣珥，日頭已經出來了。',
    '創19:24 當時，耶和華將硫磺與火從天上耶和華那裡降與所多瑪和蛾摩拉，',
    '創19:25 把那些城和全平原，並城裡所有的居民，連地上生長的，都毀滅了。',
    '創19:26 羅得的妻子在後邊回頭一看，就變成了一根鹽柱。',
    '創19:27 亞伯拉罕清早起來，到了他從前站在耶和華面前的地方，',
    '創19:28 向所多瑪和蛾摩拉與平原的全地觀看，不料，那地方煙氣上騰，如同燒窰一般。',
    '創19:29 當神毀滅平原諸城的時候，他記念亞伯拉罕，正在傾覆羅得所住之城的時候，就打發羅得從傾覆之中出來。',
    '創19:30 羅得因為怕住在瑣珥，就同他兩個女兒從瑣珥上去，住在山裡；他和兩個女兒住在一個洞裡。',
    '創19:31 大女兒對小女兒說：我們的父親老了，地上又無人按著世上的常規進到我們這裡。',
    '創19:32 來！我們可以叫父親喝酒，與他同寢。這樣，我們好從他存留後裔。',
    '創19:33 於是，那夜他們叫父親喝酒，大女兒就進去和他父親同寢；他幾時躺下，幾時起來，父親都不知道。',
    '創19:34 第二天，大女兒對小女兒說：我昨夜與父親同寢。今夜我們再叫他喝酒，你可以進去與他同寢。這樣，我們好從父親存留後裔。',
    '創19:35 於是，那夜他們又叫父親喝酒，小女兒起來與他父親同寢；他幾時躺下，幾時起來，父親都不知道。',
    '創19:36 這樣，羅得的兩個女兒都從他父親懷了孕。',
    '創19:37 大女兒生了兒子，給他起名叫摩押，就是現今摩押人的始祖。',
    '創19:38 小女兒也生了兒子，給他起名叫便亞米，就是現今亞捫人的始祖。',
    '創20:1 亞伯拉罕從那裡向南地遷去，寄居在加低斯和書珥中間的基拉耳。',
    '創20:2 亞伯拉罕稱他的妻撒拉為妹子，基拉耳王亞比米勒差人把撒拉取了去。',
    '創20:3 但夜間，神來，在夢中對亞比米勒說：你是個死人哪！因為你取了那女人來；他原是別人的妻子。',
    '創20:4 亞比米勒卻還沒有親近撒拉；他說：主啊，連有義的國，你也要毀滅嗎﹖',
    '創20:5 那人豈不是自己對我說他是我的妹子嗎﹖就是女人也自己說：他是我的哥哥。我做這事是心正手潔的。',
    '創20:6 神在夢中對他說：我知道你做這事是心中正直；我也攔阻了你，免得你得罪我，所以我不容你沾著他。',
    '創20:7 現在你把這人的妻子歸還他；因為他是先知，他要為你禱告，使你存活。你若不歸還他，你當知道，你和你所有的人都必要死。',
    '創20:8 亞比米勒清早起來，召了眾臣僕來，將這些事都說給他們聽，他們都甚懼怕。',
    '創20:9 亞比米勒召了亞伯拉罕來，對他說：你怎麼向我這樣行呢﹖我在什麼事上得罪了你，你竟使我和我國裡的人陷在大罪裡﹖你向我行不當行的事了！',
    '創20:10 亞比米勒又對亞伯拉罕說：你見了什麼才作這事呢﹖',
    '創20:11 亞伯拉罕說：我以為這地方的人總不懼怕神，必為我妻子的緣故殺我。',
    '創20:12 況且他也實在是我的妹子；他與我是同父異母，後來作了我的妻子。',
    '創20:13 當神叫我離開父家、飄流在外的時候，我對他說：我們無論走到什麼地方，你可以對人說：他是我的哥哥；這就是你待我的恩典了。',
    '創20:14 亞比米勒把牛、羊、僕婢賜給亞伯拉罕，又把他的妻子撒拉歸還他。',
    '創20:15 亞比米勒又說：看哪，我的地都在你面前，你可以隨意居住；',
    '創20:16 又對撒拉說：我給你哥哥一千銀子，作為你在閤家人面前遮羞【原文作眼】的，你就在眾人面前沒有不是了。',
    '創20:17 亞伯拉罕禱告神，神就醫好了亞比米勒和他的妻子，並他的眾女僕，他們便能生育。',
    '創20:18 因耶和華為亞伯拉罕的妻子撒拉的緣故，已經使亞比米勒家中的婦人不能生育。',
    '創21:1 耶和華按著先前的話眷顧撒拉，便照他所說的給撒拉成就。',
    '創21:2 當亞伯拉罕年老的時候，撒拉懷了孕；到神所說的日期，就給亞伯拉罕生了一個兒子。',
    '創21:3 亞伯拉罕給撒拉所生的兒子起名叫以撒。',
    '創21:4 以撒生下來第八日，亞伯拉罕照著神所吩咐的，給以撒行了割禮。',
    '創21:5 他兒子以撒生的時候，亞伯拉罕年一百歲。',
    '創21:6 撒拉說：神使我喜笑，凡聽見的必與我一同喜笑；',
    '創21:7 又說：誰能預先對亞伯拉罕說撒拉要乳養嬰孩呢﹖因為在他年老的時候，我給他生了一個兒子。',
    '創21:8 孩子漸長，就斷了奶。以撒斷奶的日子，亞伯拉罕設擺豐盛的筵席。',
    '創21:9 當時，撒拉看見埃及人夏甲給亞伯拉罕所生的兒子戲笑，',
    '創21:10 就對亞伯拉罕說：你把這使女和他兒子趕出去！因為這使女的兒子不可與我的兒子以撒一同承受產業。',
    '創21:11 亞伯拉罕因他兒子的緣故很憂愁。',
    '創21:12 神對亞伯拉罕說：你不必為這童子和你的使女憂愁。凡撒拉對你說的話，你都該聽從；因為從以撒生的，才要稱為你的後裔。',
    '創21:13 至於使女的兒子，我也必使他的後裔成立一國，因為他是你所生的。',
    '創21:14 亞伯拉罕清早起來，拿餅和一皮袋水，給了夏甲，搭在他的肩上，又把孩子交給他，打發他走。夏甲就走了，在別是巴的曠野走迷了路。',
    '創21:15 皮袋的水用盡了，夏甲就把孩子撇在小樹底下，',
    '創21:16 自己走開約有一箭之遠，相對而坐，說：我不忍見孩子死，就相對而坐，放聲大哭。',
    '創21:17 神聽見童子的聲音；神的使者從天上呼叫夏甲說：夏甲，你為何這樣呢﹖不要害怕，神已經聽見童子的聲音了。',
    '創21:18 起來！把童子抱在懷【原文作手】中，我必使他的後裔成為大國。',
    '創21:19 神使夏甲的眼睛明亮，他就看見一口水井，便去將皮袋盛滿了水，給童子喝。',
    '創21:20 神保佑童子，他就漸長，住在曠野，成了弓箭手。',
    '創21:21 他住在巴蘭的曠野；他母親從埃及地給他娶了一個妻子。',
    '創21:22 當那時候，亞比米勒同他軍長非各對亞伯拉罕說：凡你所行的事都有神的保佑。',
    '創21:23 我願你如今在這裡指著神對我起誓，不要欺負我與我的兒子，並我的子孫。我怎樣厚待了你，你也要照樣厚待我與你所寄居這地的民。',
    '創21:24 亞伯拉罕說：我情願起誓。',
    '創21:25 從前，亞比米勒的僕人霸佔了一口水井，亞伯拉罕為這事指責亞比米勒。',
    '創21:26 亞比米勒說：誰做這事，我不知道，你也沒有告訴我，今日我才聽見了。',
    '創21:27 亞伯拉罕把羊和牛給了亞比米勒，二人就彼此立約。',
    '創21:28 亞伯拉罕把七隻母羊羔另放在一處。',
    '創21:29 亞比米勒問亞伯拉罕說：你把這七隻母羊羔另放在一處，是什麼意思呢﹖',
    '創21:30 他說：你要從我手裡受這七隻母羊羔，作我挖這口井的證據。',
    '創21:31 所以他給那地方起名叫別是巴，因為他們二人在那裡起了誓。【別是巴就是盟誓的井的意思】',
    '創21:32 他們在別是巴立了約，亞比米勒就同他軍長非各起身回非利士地去了。',
    '創21:33 亞伯拉罕在別是巴栽上一棵垂絲柳樹，又在那裡求告耶和華─永生神的名。',
    '創21:34 亞伯拉罕在非利士人的地寄居了多日。',
    '創22:1 這些事以後，神要試驗亞伯拉罕，就呼叫他說：亞伯拉罕！他說：我在這裡。',
    '創22:2 神說：你帶著你的兒子，就是你獨生的兒子，你所愛的以撒，往摩利亞地去，在我所要指示你的山上，把他獻為燔祭。',
    '創22:3 亞伯拉罕清早起來，備上驢，帶著兩個僕人和他兒子以撒，也劈好了燔祭的柴，就起身往神所指示他的地方去了。',
    '創22:4 到了第三日，亞伯拉罕舉目遠遠的看見那地方。',
    '創22:5 亞伯拉罕對他的僕人說：你們和驢在此等候，我與童子往那裡去拜一拜，就回到你們這裡來。',
    '創22:6 亞伯拉罕把燔祭的柴放在他兒子以撒身上，自己手裡拿著火與刀；於是二人同行。',
    '創22:7 以撒對他父親亞伯拉罕說：父親哪！亞伯拉罕說：我兒，我在這裡。以撒說：請看，火與柴都有了，但燔祭的羊羔在哪裡呢﹖',
    '創22:8 亞伯拉罕說：我兒，神必自己預備作燔祭的羊羔。於是二人同行。',
    '創22:9 他們到了神所指示的地方，亞伯拉罕在那裡築壇，把柴擺好，捆綁他的兒子以撒，放在壇的柴上。',
    '創22:10 亞伯拉罕就伸手拿刀，要殺他的兒子。',
    '創22:11 耶和華的使者從天上呼叫他說：亞伯拉罕！亞伯拉罕！他說：我在這裡。',
    '創22:12 天使說：你不可在這童子身上下手。一點不可害他！現在我知道你是敬畏神的了；因為你沒有將你的兒子，就是你獨生的兒子，留下不給我。',
    '創22:13 亞伯拉罕舉目觀看，不料，有一隻公羊，兩角扣在稠密的小樹中，亞伯拉罕就取了那隻公羊來，獻為燔祭，代替他的兒子。',
    '創22:14 亞伯拉罕給那地方起名叫耶和華以勒【就是耶和華必預備的意思】，直到今日人還說：在耶和華的山上必有預備。',
    '創22:15 耶和華的使者第二次從天上呼叫亞伯拉罕說：',
    '創22:16 耶和華說：你既行了這事，不留下你的兒子，就是你獨生的兒子，我便指著自己起誓說：',
    '創22:17 論福，我必賜大福給你；論子孫，我必叫你的子孫多起來，如同天上的星，海邊的沙。你子孫必得著仇敵的城門，',
    '創22:18 並且地上萬國都必因你的後裔得福，因為你聽從了我的話。',
    '創22:19 於是亞伯拉罕回到他僕人那裡，他們一同起身往別是巴去，亞伯拉罕就住在別是巴。',
    '創22:20 這事以後，有人告訴亞伯拉罕說：密迦給你兄弟拿鶴生了幾個兒子，',
    '創22:21 長子是烏斯，他的兄弟是布斯和亞蘭的父親基母利，',
    '創22:22 並基薛、哈瑣、必達、益拉、彼土利（彼土利生利百加）。',
    '創22:23 這八個人都是密迦給亞伯拉罕的兄弟拿鶴生的。',
    '創22:24 拿鶴的妾名叫流瑪，生了提八、迦含、他轄，和瑪迦。',
    '創23:1 撒拉享壽一百二十七歲，這是撒拉一生的歲數。',
    '創23:2 撒拉死在迦南地的基列亞巴，就是希伯崙。亞伯拉罕為他哀慟哭號。',
    '創23:3 後來亞伯拉罕從死人面前起來，對赫人說：',
    '創23:4 我在你們中間是外人，是寄居的。求你們在這裡給我一塊地，我好埋葬我的死人，使他不在我眼前。',
    '創23:5 赫人回答亞伯拉罕說：',
    '創23:6 我主請聽。你在我們中間是一位尊大的王子，只管在我們最好的墳地裡埋葬你的死人；我們沒有一人不容你在他的墳地裡埋葬你的死人。',
    '創23:7 亞伯拉罕就起來，向那地的赫人下拜，',
    '創23:8 對他們說：你們若有意叫我埋葬我的死人，使他不在我眼前，就請聽我的話，為我求瑣轄的兒子以弗崙，',
    '創23:9 把田頭上那麥比拉洞給我；他可以按著足價賣給我，作我在你們中間的墳地。',
    '創23:10 當時以弗崙正坐在赫人中間。於是，赫人以弗崙在城門出入的赫人面前對亞伯拉罕說：',
    '創23:11 不然，我主請聽。我送給你這塊田，連田間的洞也送給你，在我同族的人面前都給你，可以埋葬你的死人。',
    '創23:12 亞伯拉罕就在那地的人民面前下拜，',
    '創23:13 在他們面前對以弗崙說：你若應允，請聽我的話。我要把田價給你，求你收下，我就在那裡埋葬我的死人。',
    '創23:14 以弗崙回答亞伯拉罕說：',
    '創23:15 我主請聽。值四百舍客勒銀子的一塊田，在你我中間還算什麼呢﹖只管埋葬你的死人吧！',
    '創23:16 亞伯拉罕聽從了以弗崙，照著他在赫人面前所說的話，把買賣通用的銀子平了四百舍客勒給以弗崙。',
    '創23:17 於是，麥比拉、幔利前、以弗崙的那塊田和其中的洞，並田間四圍的樹木，',
    '創23:18 都定準歸與亞伯拉罕，乃是他在赫人面前並城門出入的人面前買妥的。',
    '創23:19 此後，亞伯拉罕把他妻子撒拉埋葬在迦南地幔利前的麥比拉田間的洞裡。（幔利就是希伯崙）。',
    '創23:20 從此，那塊田和田間的洞就藉著赫人定準歸與亞伯拉罕作墳地。',
    '創24:1 亞伯拉罕年紀老邁，向來在一切事上耶和華都賜福給他。',
    '創24:2 亞伯拉罕對管理他全業最老的僕人說：請你把手放在我大腿底下。',
    '創24:3 我要叫你指著耶和華─天地的主起誓，不要為我兒子娶這迦南地中的女子為妻。',
    '創24:4 你要往我本地本族去，為我的兒子以撒娶一個妻子。',
    '創24:5 僕人對他說：倘若女子不肯跟我到這地方來，我必須將你的兒子帶回你原出之地嗎﹖',
    '創24:6 亞伯拉罕對他說：你要謹慎，不要帶我的兒子回那裡去。',
    '創24:7 耶和華─天上的主曾帶領我離開父家和本族的地，對我說話，向我起誓說：我要將這地賜給你的後裔。他必差遣使者在你面前，你就可以從那裡為我兒子娶一個妻子。',
    '創24:8 倘若女子不肯跟你來，我使你起的誓就與你無干了，只是不可帶我的兒子回那裡去。',
    '創24:9 僕人就把手放在他主人亞伯拉罕的大腿底下，為這事向他起誓。',
    '創24:10 那僕人從他主人的駱駝裡取了十匹駱駝，並帶些他主人各樣的財物，起身往米所波大米去，到了拿鶴的城。',
    '創24:11 天將晚，眾女子出來打水的時候，他便叫駱駝跪在城外的水井那裡。',
    '創24:12 他說：耶和華─我主人亞伯拉罕的神啊，求你施恩給我主人亞伯拉罕，使我今日遇見好機會。',
    '創24:13 我現今站在井旁，城內居民的女子們正出來打水。',
    '創24:14 我向那一個女子說：請你拿下水瓶來，給我水喝，他若說：請喝！我也給你的駱駝喝，願那女子就作你所預定給你僕人以撒的妻。這樣，我便知道你施恩給我主人了。',
    '創24:15 話還沒有說完，不料，利百加肩頭上扛著水瓶出來。利百加是彼土利所生的；彼土利是亞伯拉罕兄弟拿鶴妻子密迦的兒子。',
    '創24:16 那女子容貌極其俊美，還是處女，也未曾有人親近他。他下到井旁，打滿了瓶，又上來。',
    '創24:17 僕人跑上前去迎著他，說：求你將瓶裡的水給我一點喝。',
    '創24:18 女子說：我主請喝！就急忙拿下瓶來，托在手上給他喝。',
    '創24:19 女子給他喝了，就說：我再為你的駱駝打水，叫駱駝也喝足。',
    '創24:20 他就急忙把瓶裡的水倒在槽裡，又跑到井旁打水，就為所有的駱駝打上水來。',
    '創24:21 那人定睛看他，一句話也不說，要曉得耶和華賜他通達的道路沒有。',
    '創24:22 駱駝喝足了，那人就拿一個金環，重半舍客勒，兩個金鐲，重十舍客勒，給了那女子，',
    '創24:23 說：請告訴我，你是誰的女兒﹖你父親家裡有我們住宿的地方沒有﹖',
    '創24:24 女子說：我是密迦與拿鶴之子彼土利的女兒；',
    '創24:25 又說：我們家裡足有糧草，也有住宿的地方。',
    '創24:26 那人就低頭向耶和華下拜，',
    '創24:27 說：耶和華─我主人亞伯拉罕的神是應當稱頌的，因他不斷地以慈愛誠實待我主人。至於我，耶和華在路上引領我，直走到我主人的兄弟家裡。',
    '創24:28 女子跑回去，照著這些話告訴他母親和他家裡的人。',
    '創24:29 利百加有一個哥哥，名叫拉班，看見金環，又看見金鐲在他妹子的手上，並聽見他妹子利百加的話，說那人對我如此如此說。拉班就跑出來往井旁去，到那人跟前，見他仍站在駱駝旁邊的井旁那裡，',
    '創24:30 併於上節。',
    '創24:31 便對他說：你這蒙耶和華賜福的，請進來，為什麼站在外邊﹖我已經收拾了房屋，也為駱駝預備了地方。',
    '創24:32 那人就進了拉班的家。拉班卸了駱駝，用草料餵上，拿水給那人和跟隨的人洗腳，',
    '創24:33 把飯擺在他面前，叫他吃，他卻說：我不吃，等我說明白我的事情再吃。拉班說：請說。',
    '創24:34 他說：我是亞伯拉罕的僕人。',
    '創24:35 耶和華大大地賜福給我主人，使他昌大，又賜給他羊群、牛群、金銀、僕婢、駱駝，和驢。',
    '創24:36 我主人的妻子撒拉年老的時候給我主人生了一個兒子；我主人也將一切所有的都給了這個兒子。',
    '創24:37 我主人叫我起誓說：你不要為我兒子娶迦南地的女子為妻。',
    '創24:38 你要往我父家、我本族那裡去，為我的兒子娶一個妻子。',
    '創24:39 我對我主人說：恐怕女子不肯跟我來。',
    '創24:40 他就說：我所事奉的耶和華必要差遣他的使者與你同去，叫你的道路通達，你就得以在我父家、我本族那裡，給我的兒子娶一個妻子。',
    '創24:41 只要你到了我本族那裡，我使你起的誓就與你無干。他們若不把女子交給你，我使你起的誓也與你無干。',
    '創24:42 我今日到了井旁，便說：耶和華─我主人亞伯拉罕的神啊，願你叫我所行的道路通達。',
    '創24:43 我如今站在井旁，對哪一個出來打水的女子說：請你把你瓶裡的水給我一點喝；',
    '創24:44 他若說：你只管喝，我也為你的駱駝打水；願那女子就作耶和華給我主人兒子所預定的妻。',
    '創24:45 我心裡的話還沒有說完，利百加就出來，肩頭上扛著水瓶，下到井旁打水。我便對他說：請你給我水喝。',
    '創24:46 他就急忙從肩頭上拿下瓶來，說：請喝！我也給你的駱駝喝。我便喝了；他又給我的駱駝喝了。',
    '創24:47 我問他說：你是誰的女兒﹖他說：我是密迦與拿鶴之子彼土利的女兒。我就把環子戴在他鼻子上，把鐲子戴在他兩手上。',
    '創24:48 隨後我低頭向耶和華下拜，稱頌耶和華─我主人亞伯拉罕的神；因為他引導我走合式的道路，使我得著我主人兄弟的孫女，給我主人的兒子為妻。',
    '創24:49 現在你們若願以慈愛誠實待我主人，就告訴我；若不然，也告訴我，使我可以或向左，或向右。',
    '創24:50 拉班和彼土利回答說：這事乃出於耶和華，我們不能向你說好說歹。',
    '創24:51 看哪，利百加在你面前，可以將他帶去，照著耶和華所說的，給你主人的兒子為妻。',
    '創24:52 亞伯拉罕的僕人聽見他們這話，就向耶和華俯伏在地。',
    '創24:53 當下僕人拿出金器、銀器，和衣服送給利百加，又將寶物送給他哥哥和他母親。',
    '創24:54 僕人和跟從他的人吃了喝了，住了一夜。早晨起來，僕人就說：請打發我回我主人那裡去吧。',
    '創24:55 利百加的哥哥和他母親說：讓女子同我們再住幾天，至少十天，然後他可以去。',
    '創24:56 僕人說：耶和華既賜給我通達的道路，你們不要耽誤我，請打發我走，回我主人那裡去吧。',
    '創24:57 他們說：我們把女子叫來問問他，',
    '創24:58 就叫了利百加來，問他說：你和這人同去嗎﹖利百加說：我去。',
    '創24:59 於是他們打發妹子利百加和他的乳母，同亞伯拉罕的僕人，並跟從僕人的，都走了。',
    '創24:60 他們就給利百加祝福說：我們的妹子啊，願你作千萬人的母！願你的後裔得著仇敵的城門！',
    '創24:61 利百加和他的使女們起來，騎上駱駝，跟著那僕人，僕人就帶著利百加走了。',
    '創24:62 那時，以撒住在南地，剛從庇耳‧拉海‧萊回來。',
    '創24:63 天將晚，以撒出來在田間默想，舉目一看，見來了些駱駝。',
    '創24:64 利百加舉目看見以撒，就急忙下了駱駝，',
    '創24:65 問那僕人說：這田間走來迎接我們的是誰﹖僕人說：是我的主人。利百加就拿帕子蒙上臉。',
    '創24:66 僕人就將所辦的一切事都告訴以撒。',
    '創24:67 以撒便領利百加進了他母親撒拉的帳棚，娶了他為妻，並且愛他。以撒自從他母親不在了，這才得了安慰。',
    '創25:1 亞伯拉罕又娶了一妻，名叫基土拉。',
    '創25:2 基土拉給他生了心蘭、約珊、米但、米甸、伊施巴，和書亞。',
    '創25:3 約珊生了示巴和底但。底但的子孫是亞書利族、利都是族，和利烏米族。',
    '創25:4 米甸的兒子是以法、以弗、哈諾、亞比大，和以勒大。這都是基土拉的子孫。',
    '創25:5 亞伯拉罕將一切所有的都給了以撒。',
    '創25:6 亞伯拉罕把財物分給他庶出的眾子，趁著自己還在世的時候打發他們離開他的兒子以撒，往東方去。',
    '創25:7 亞伯拉罕一生的年日是一百七十五歲。',
    '創25:8 亞伯拉罕壽高年邁，氣絕而死，歸到他列祖【原文作本民】那裡。',
    '創25:9 他兩個兒子以撒、以實瑪利把他埋葬在麥比拉洞裡。這洞在幔利前、赫人瑣轄的兒子以弗崙的田中，',
    '創25:10 就是亞伯拉罕向赫人買的那塊田。亞伯拉罕和他妻子撒拉都葬在那裡。',
    '創25:11 亞伯拉罕死了以後，神賜福給他的兒子以撒。以撒靠近庇耳拉海萊居住。',
    '創25:12 撒拉的使女埃及人夏甲給亞伯拉罕所生的兒子是以實瑪利。',
    '創25:13 以實瑪利兒子們的名字，按著他們的家譜記在下面。以實瑪利的長子是尼拜約，又有基達、亞德別、米比衫、',
    '創25:14 米施瑪、度瑪、瑪撒、',
    '創25:15 哈大、提瑪、伊突、拿非施、基底瑪。',
    '創25:16 這是以實瑪利眾子的名字，照著他們的村莊、營寨，作了十二族的族長。',
    '創25:17 以實瑪利享壽一百三十七歲，氣絕而死，歸到他列祖【原文作本民】那裡。',
    '創25:18 他子孫的住處在他眾弟兄東邊，從哈腓拉直到埃及前的書珥，正在亞述的道上。',
    '創25:19 亞伯拉罕的兒子以撒的後代記在下面。亞伯拉罕生以撒。',
    '創25:20 以撒娶利百加為妻的時候正四十歲。利百加是巴旦亞蘭地的亞蘭人彼土利的女兒，是亞蘭人拉班的妹子。',
    '創25:21 以撒因他妻子不生育，就為他祈求耶和華；耶和華應允他的祈求，他的妻子利百加就懷了孕。',
    '創25:22 孩子們在他腹中彼此相爭，他就說：若是這樣，我為什麼活著呢【或作我為什麼如此呢】﹖他就去求問耶和華。',
    '創25:23 耶和華對他說：兩國在你腹內；兩族要從你身上出來。這族必強於那族；將來大的要服事小的。',
    '創25:24 生產的日子到了，腹中果然是雙子。',
    '創25:25 先產的身體發紅，渾身有毛，如同皮衣，他們就給他起名叫以掃【就是有毛的意思】。',
    '創25:26 隨後又生了以掃的兄弟，手抓住以掃的腳跟，因此給他起名叫雅各【就是抓住的意思】。利百加生下兩個兒子的時候，以撒年正六十歲。',
    '創25:27 兩個孩子漸漸長大，以掃善於打獵，常在田野；雅各為人安靜，常住在帳棚裡。',
    '創25:28 以撒愛以掃，因為常吃他的野味；利百加卻愛雅各。',
    '創25:29 有一天，雅各熬湯，以掃從田野回來累昏了。',
    '創25:30 以掃對雅各說：我累昏了，求你把這紅湯給我喝。因此以掃又叫以東【就是紅的意思】。',
    '創25:31 雅各說：你今日把長子的名分賣給我吧。',
    '創25:32 以掃說：我將要死，這長子的名分於我有什麼益處呢﹖',
    '創25:33 雅各說：你今日對我起誓吧。以掃就對他起了誓，把長子的名分賣給雅各。',
    '創25:34 於是雅各將餅和紅豆湯給了以掃，以掃吃了喝了，便起來走了。這就是以掃輕看了他長子的名分。',
    '創26:1 在亞伯拉罕的日子，那地有一次饑荒；這時又有饑荒，以撒就往基拉耳去，到非利士人的王亞比米勒那裡。',
    '創26:2 耶和華向以撒顯現，說：你不要下埃及去，要住在我所指示你的地。',
    '創26:3 你寄居在這地，我必與你同在，賜福給你，因為我要將這些地都賜給你和你的後裔。我必堅定我向你父亞伯拉罕所起的誓。',
    '創26:4 我要加增你的後裔，像天上的星那樣多，又要將這些地都賜給你的後裔。並且地上萬國必因你的後裔得福─',
    '創26:5 都因亞伯拉罕聽從我的話，遵守我的吩咐和我的命令、律例、法度。',
    '創26:6 以撒就住在基拉耳。',
    '創26:7 那地方的人問到他的妻子，他便說：那是我的妹子。原來他怕說：是我的妻子；他心裡想：恐怕這地方的人為利百加的緣故殺我，因為他容貌俊美。',
    '創26:8 他在那裡住了許久。有一天，非利士人的王亞比米勒從窗戶裡往外觀看，見以撒和他的妻子利百加戲玩。',
    '創26:9 亞比米勒召了以撒來，對他說：他實在是你的妻子，你怎麼說他是你的妹子﹖以撒說：我心裡想，恐怕我因他而死。',
    '創26:10 亞比米勒說：你向我們做的是什麼事呢﹖民中險些有人和你的妻同寢，把我們陷在罪裡。',
    '創26:11 於是亞比米勒曉諭眾民說：凡沾著這個人，或是他妻子的，定要把他治死。',
    '創26:12 以撒在那地耕種，那一年有百倍的收成。耶和華賜福給他，',
    '創26:13 他就昌大，日增月盛，成了大富戶。',
    '創26:14 他有羊群牛群，又有許多僕人，非利士人就嫉妒他。',
    '創26:15 當他父親亞伯拉罕在世的日子，他父親的僕人所挖的井，非利士人全都塞住，填滿了土。',
    '創26:16 亞比米勒對以撒說：你離開我們去吧。因為你比我們強盛得多。',
    '創26:17 以撒就離開那裡，在基拉耳谷支搭帳棚，住在那裡。',
    '創26:18 當他父親亞伯拉罕在世之日所挖的水井因非利士人在亞伯拉罕死後塞住了，以撒就重新挖出來，仍照他父親所叫的叫那些井的名字。',
    '創26:19 以撒的僕人在谷中挖井，便得了一口活水井。',
    '創26:20 基拉耳的牧人與以撒的牧人爭競，說：這水是我們的。以撒就給那井起名叫埃色【就是相爭的意思】，因為他們和他相爭。',
    '創26:21 以撒的僕人又挖了一口井，他們又為這井爭競，因此以撒給這井起名叫西提拿【就是為敵的意思】。',
    '創26:22 以撒離開那裡，又挖了一口井，他們不為這井爭競了，他就給那井起名叫利河伯【就是寬闊的意思】。他說：耶和華現在給我們寬闊之地，我們必在這地昌盛。',
    '創26:23 以撒從那裡上別是巴去。',
    '創26:24 當夜耶和華向他顯現，說：我是你父親亞伯拉罕的神，不要懼怕！因為我與你同在，要賜福給你，並要為我僕人亞伯拉罕的緣故，使你的後裔繁多。',
    '創26:25 以撒就在那裡築了一座壇，求告耶和華的名，並且支搭帳棚；他的僕人便在那裡挖了一口井。',
    '創26:26 亞比米勒，同他的朋友亞戶撒和他的軍長非各，從基拉耳來見以撒。',
    '創26:27 以撒對他們說：你們既然恨我，打發我走了，為什麼到我這裡來呢﹖',
    '創26:28 他們說：我們明明的看見耶和華與你同在，便說，不如我們兩下彼此起誓，彼此立約，',
    '創26:29 使你不害我們，正如我們未曾害你，一味的厚待你，並且打發你平平安安地走。你是蒙耶和華賜福的了。',
    '創26:30 以撒就為他們設擺筵席，他們便吃了喝了。',
    '創26:31 他們清早起來彼此起誓。以撒打發他們走，他們就平平安安地離開他走了。',
    '創26:32 那一天，以撒的僕人來，將挖井的事告訴他說：我們得了水了。',
    '創26:33 他就給那井起名叫示巴；因此那城叫做別是巴，直到今日。',
    '創26:34 以掃四十歲的時候娶了赫人比利的女兒猶滴，與赫人以倫的女兒巴實抹為妻。',
    '創26:35 他們常使以撒和利百加心裡愁煩。',
    '創27:1 以撒年老，眼睛昏花，不能看見，就叫了他大兒子以掃來，說：我兒。以掃說：我在這裡。',
    '創27:2 他說：我如今老了，不知道哪一天死。',
    '創27:3 現在拿你的器械，就是箭囊和弓，往田野去為我打獵，',
    '創27:4 照我所愛的做成美味，拿來給我吃，使我在未死之先給你祝福。',
    '創27:5 以撒對他兒子以掃說話，利百加也聽見了。以掃往田野去打獵，要得野味帶來。',
    '創27:6 利百加就對他兒子雅各說：我聽見你父親對你哥哥以掃說：',
    '創27:7 你去把野獸帶來，做成美味給我吃，我好在未死之先，在耶和華面前給你祝福。',
    '創27:8 現在，我兒，你要照著我所吩咐你的，聽從我的話。',
    '創27:9 你到羊群裡去，給我拿兩隻肥山羊羔來，我便照你父親所愛的給他做成美味。',
    '創27:10 你拿到你父親那裡給他吃，使他在未死之先給你祝福。',
    '創27:11 雅各對他母親利百加說：我哥哥以掃渾身是有毛的，我身上是光滑的；',
    '創27:12 倘若我父親摸著我，必以我為欺哄人的，我就招咒詛，不得祝福。',
    '創27:13 他母親對他說：我兒，你招的咒詛歸到我身上；你只管聽我的話，去把羊羔給我拿來。',
    '創27:14 他便去拿來，交給他母親；他母親就照他父親所愛的做成美味。',
    '創27:15 利百加又把家裡所存大兒子以掃上好的衣服給他小兒子雅各穿上，',
    '創27:16 又用山羊羔皮包在雅各的手上和頸項的光滑處，',
    '創27:17 就把所做的美味和餅交在他兒子雅各的手裡。',
    '創27:18 雅各到他父親那裡說：我父親！他說：我在這裡。我兒，你是誰﹖',
    '創27:19 雅各對他父親說：我是你的長子以掃；我已照你所吩咐我的行了。請起來坐著，吃我的野味，好給我祝福。',
    '創27:20 以撒對他兒子說：我兒，你如何找得這麼快呢﹖他說：因為耶和華─你的神使我遇見好機會得著的。',
    '創27:21 以撒對雅各說：我兒，你近前來，我摸摸你，知道你真是我的兒子以掃不是﹖',
    '創27:22 雅各就挨近他父親以撒。以撒摸著他，說：聲音是雅各的聲音，手卻是以掃的手。',
    '創27:23 以撒就辨不出他來；因為他手上有毛，像他哥哥以掃的手一樣，就給他祝福；',
    '創27:24 又說：你真是我兒子以掃嗎﹖他說：我是。',
    '創27:25 以撒說：你遞給我，我好吃我兒子的野味，給你祝福。雅各就遞給他，他便吃了，又拿酒給他，他也喝了。',
    '創27:26 他父親以撒對他說：我兒，你上前來與我親嘴。',
    '創27:27 他就上前與父親親嘴。他父親一聞他衣服上的香氣，就給他祝福，說：我兒的香氣如同耶和華賜福之田地的香氣一樣。',
    '創27:28 願神賜你天上的甘露，地上的肥土，並許多五穀新酒。',
    '創27:29 願多民事奉你，多國跪拜你。願你作你弟兄的主；你母親的兒子向你跪拜。凡咒詛你的，願他受咒詛；為你祝福的，願他蒙福。',
    '創27:30 以撒為雅各祝福已畢，雅各從他父親那裡才出來，他哥哥以掃正打獵回來，',
    '創27:31 也做了美味，拿來給他父親，說：請父親起來，吃你兒子的野味，好給我祝福。',
    '創27:32 他父親以撒對他說：你是誰﹖他說：我是你的長子以掃。',
    '創27:33 以撒就大大地戰兢，說：你未來之先，是誰得了野味拿來給我呢﹖我已經吃了，為他祝福；他將來也必蒙福。',
    '創27:34 以掃聽了他父親的話，就放聲痛哭，說：我父啊，求你也為我祝福！',
    '創27:35 以撒說：你兄弟已經用詭計來將你的福分奪去了。',
    '創27:36 以掃說：他名雅各，豈不是正對嗎﹖因為他欺騙了我兩次：他從前奪了我長子的名分，你看，他現在又奪了我的福分。以掃又說：你沒有留下為我可祝的福嗎﹖',
    '創27:37 以撒回答以掃說：我已立他為你的主，使他的弟兄都給他作僕人，並賜他五穀新酒可以養生。我兒，現在我還能為你做什麼呢﹖',
    '創27:38 以掃對他父親說：父啊，你只有一樣可祝的福嗎﹖我父啊，求你也為我祝福！以掃就放聲而哭。',
    '創27:39 他父親以撒說：地上的肥土必為你所住；天上的甘露必為你所得。',
    '創27:40 你必倚靠刀劍度日，又必事奉你的兄弟；到你強盛的時候，必從你頸項上掙開他的軛。',
    '創27:41 以掃因他父親給雅各祝的福，就怨恨雅各，心裡說：為我父親居喪的日子近了，到那時候，我要殺我的兄弟雅各。',
    '創27:42 有人把利百加大兒子以掃的話告訴利百加，他就打發人去，叫了他小兒子雅各來，對他說：你哥哥以掃想要殺你，報仇雪恨。',
    '創27:43 現在，我兒，你要聽我的話：起來，逃往哈蘭、我哥哥拉班那裡去，',
    '創27:44 同他住些日子，直等你哥哥的怒氣消了。',
    '創27:45 你哥哥向你消了怒氣，忘了你向他所做的事，我便打發人去把你從那裡帶回來。為什麼一日喪你們二人呢﹖',
    '創27:46 利百加對以撒說：我因這赫人的女子連性命都厭煩了；倘若雅各也娶赫人的女子為妻，像這些一樣，我活著還有什麼益處呢﹖',
    '創28:1 以撒叫了雅各來，給他祝福，並囑咐他說：你不要娶迦南的女子為妻。',
    '創28:2 你起身往巴旦亞蘭去，到你外祖彼土利家裡，在你母舅拉班的女兒中娶一女為妻。',
    '創28:3 願全能的神賜福給你，使你生養眾多，成為多族，',
    '創28:4 將應許亞伯拉罕的福賜給你和你的後裔，使你承受你所寄居的地為業，就是神賜給亞伯拉罕的地。',
    '創28:5 以撒打發雅各走了，他就往巴旦亞蘭去，到亞蘭人彼土利的兒子拉班那裡。拉班是雅各、以掃的母舅。',
    '創28:6 以掃見以撒已經給雅各祝福，而且打發他往巴旦亞蘭去，在那裡娶妻，並見祝福的時候囑咐他說：不要娶迦南的女子為妻，',
    '創28:7 又見雅各聽從父母的話往巴旦亞蘭去了，',
    '創28:8 以掃就曉得他父親以撒看不中迦南的女子，',
    '創28:9 便往以實瑪利那裡去，在他二妻之外又娶了瑪哈拉為妻。他是亞伯拉罕兒子以實瑪利的女兒，尼拜約的妹子。',
    '創28:10 雅各出了別是巴，向哈蘭走去；',
    '創28:11 到了一個地方，因為太陽落了，就在那裡住宿，便拾起那地方的一塊石頭枕在頭下，在那裡躺臥睡了，',
    '創28:12 夢見一個梯子立在地上，梯子的頭頂著天，有神的使者在梯子上，上去下來。',
    '創28:13 耶和華站在梯子以上【或作站在他旁邊】，說：我是耶和華─你祖亞伯拉罕的神，也是以撒的神；我要將你現在所躺臥之地賜給你和你的後裔。',
    '創28:14 你的後裔必像地上的塵沙那樣多，必向東西南北開展；地上萬族必因你和你的後裔得福。',
    '創28:15 我也與你同在。你無論往哪裡去，我必保佑你，領你歸回這地，總不離棄你，直到我成全了向你所應許的。',
    '創28:16 雅各睡醒了，說：耶和華真在這裡，我竟不知道！',
    '創28:17 就懼怕，說：這地方何等可畏！這不是別的，乃是神的殿，也是天的門。',
    '創28:18 雅各清早起來，把所枕的石頭立作柱子，澆油在上面。',
    '創28:19 他就給那地方起名叫伯特利【就是神殿的意思】；但那地方起先名叫路斯。',
    '創28:20 雅各許願說：神若與我同在，在我所行的路上保佑我，又給我食物吃，衣服穿，',
    '創28:21 使我平平安安地回到我父親的家，我就必以耶和華為我的神。',
    '創28:22 我所立為柱子的石頭也必作神的殿，凡你所賜給我的，我必將十分之一獻給你。',
    '創29:1 雅各起行，到了東方人之地，',
    '創29:2 看見田間有一口井，有三群羊臥在井旁；因為人飲羊群都是用那井裡的水。井口上的石頭是大的。',
    '創29:3 常有羊群在那裡聚集，牧人把石頭轉離井口飲羊，隨後又把石頭放在井口的原處。',
    '創29:4 雅各對牧人說：弟兄們，你們是哪裡來的﹖他們說：我們是哈蘭來的。',
    '創29:5 他問他們說：拿鶴的孫子拉班，你們認識嗎﹖他們說：我們認識。',
    '創29:6 雅各說：他平安嗎﹖他們說：平安。看哪，他女兒拉結領著羊來了。',
    '創29:7 雅各說：日頭還高，不是羊群聚集的時候，你們不如飲羊，再去放一放。',
    '創29:8 他們說：我們不能，必等羊群聚齊，人把石頭轉離井口才可飲羊。',
    '創29:9 雅各正和他們說話的時候，拉結領著他父親的羊來了，因為那些羊是他牧放的。',
    '創29:10 雅各看見母舅拉班的女兒拉結和母舅拉班的羊群，就上前把石頭轉離井口，飲他母舅拉班的羊群。',
    '創29:11 雅各與拉結親嘴，就放聲而哭。',
    '創29:12 雅各告訴拉結，自己是他父親的外甥，是利百加的兒子，拉結就跑去告訴他父親。',
    '創29:13 拉班聽見外甥雅各的信息，就跑去迎接，抱著他，與他親嘴，領他到自己的家。雅各將一切的情由告訴拉班。',
    '創29:14 拉班對他說：你實在是我的骨肉。雅各就和他同住了一個月。',
    '創29:15 拉班對雅各說：你雖是我的骨肉【原文作弟兄】，豈可白白地服事我﹖請告訴我，你要什麼為工價﹖',
    '創29:16 拉班有兩個女兒，大的名叫利亞，小的名叫拉結。',
    '創29:17 利亞的眼睛沒有神氣，拉結卻生得美貌俊秀。',
    '創29:18 雅各愛拉結，就說：我願為你小女兒拉結服事你七年。',
    '創29:19 拉班說：我把他給你，勝似給別人，你與我同住吧！',
    '創29:20 雅各就為拉結服事了七年；他因為深愛拉結，就看這七年如同幾天。',
    '創29:21 雅各對拉班說：日期已經滿了，求你把我的妻子給我，我好與他同房。',
    '創29:22 拉班就擺設筵席，請齊了那地方的眾人。',
    '創29:23 到晚上，拉班將女兒利亞送來給雅各，雅各就與他同房。',
    '創29:24 拉班又將婢女悉帕給女兒利亞作使女。',
    '創29:25 到了早晨，雅各一看是利亞，就對拉班說：你向我做的是什麼事呢﹖我服事你，不是為拉結嗎﹖你為什麼欺哄我呢﹖',
    '創29:26 拉班說：大女兒還沒有給人，先把小女兒給人，在我們這地方沒有這規矩。',
    '創29:27 你為這個滿了七日，我就把那個也給你，你再為他服事我七年。',
    '創29:28 雅各就如此行。滿了利亞的七日，拉班便將女兒拉結給雅各為妻。',
    '創29:29 拉班又將婢女辟拉給女兒拉結作使女。',
    '創29:30 雅各也與拉結同房，並且愛拉結勝似愛利亞，於是又服事了拉班七年。',
    '創29:31 耶和華見利亞失寵【原文作被恨；下同】，就使他生育，拉結卻不生育。',
    '創29:32 利亞懷孕生子，就給他起名叫流便【就是有兒子的意思】，因而說：耶和華看見我的苦情，如今我的丈夫必愛我。',
    '創29:33 他又懷孕生子，就說：耶和華因為聽見我失寵，所以又賜給我這個兒子，於是給他起名叫西緬【就是聽見的意思】。',
    '創29:34 他又懷孕生子，起名叫利未【就是聯合的意思】，說：我給丈夫生了三個兒子，他必與我聯合。',
    '創29:35 他又懷孕生子，說：這回我要讚美耶和華，因此給他起名叫猶大【就是讚美的意思】。這才停了生育。',
    '創30:1 拉結見自己不給雅各生子，就嫉妒他姊姊，對雅各說：你給我孩子，不然我就死了。',
    '創30:2 雅各向拉結生氣，說：叫你不生育的是神，我豈能代替他作主呢﹖',
    '創30:3 拉結說：有我的使女辟拉在這裡，你可以與他同房，使他生子在我膝下，我便因他也得孩子【原文作被建立】。',
    '創30:4 拉結就把他的使女辟拉給丈夫為妾；雅各便與他同房，',
    '創30:5 辟拉就懷孕，給雅各生了一個兒子。',
    '創30:6 拉結說：神伸了我的冤，也聽了我的聲音，賜我一個兒子，因此給他起名叫但【就是伸冤的意思】。',
    '創30:7 拉結的使女辟拉又懷孕，給雅各生了第二個兒子。',
    '創30:8 拉結說：我與我姊姊大大相爭，並且得勝，於是給他起名叫拿弗他利【就是相爭的意思】。',
    '創30:9 利亞見自己停了生育，就把使女悉帕給雅各為妾。',
    '創30:10 利亞的使女悉帕給雅各生了一個兒子。',
    '創30:11 利亞說：萬幸！於是給他起名叫迦得【就是萬幸的意思】。',
    '創30:12 利亞的使女悉帕又給雅各生了第二個兒子。',
    '創30:13 利亞說：我有福啊，眾女子都要稱我是有福的，於是給他起名叫亞設【就是有福的意思】。',
    '創30:14 割麥子的時候，流便往田裡去，尋見風茄，拿來給他母親利亞。拉結對利亞說：請你把你兒子的風茄給我些。',
    '創30:15 利亞說：你奪了我的丈夫還算小事嗎﹖你又要奪我兒子的風茄嗎﹖拉結說：為你兒子的風茄，今夜他可以與你同寢。',
    '創30:16 到了晚上，雅各從田裡回來，利亞出來迎接他，說：你要與我同寢，因為我實在用我兒子的風茄把你雇下了。那一夜，雅各就與他同寢。',
    '創30:17 神應允了利亞，他就懷孕，給雅各生了第五個兒子。',
    '創30:18 利亞說：神給了我價值，因為我把使女給了我丈夫，於是給他起名叫以薩迦【就是價值的意思】。',
    '創30:19 利亞又懷孕，給雅各生了第六個兒子。',
    '創30:20 利亞說：神賜我厚賞；我丈夫必與我同住，因我給他生了六個兒子，於是給他起名西布倫【就是同住的意思】。',
    '創30:21 後來又生了一個女兒，給他起名叫底拿。',
    '創30:22 神顧念拉結，應允了他，使他能生育。',
    '創30:23 拉結懷孕生子，說：神除去了我的羞恥，',
    '創30:24 就給他起名叫約瑟【就是增添的意思】，意思說：願耶和華再增添我一個兒子。',
    '創30:25 拉結生約瑟之後，雅各對拉班說：請打發我走，叫我回到我本鄉本土去。',
    '創30:26 請你把我服事你所得的妻子和兒女給我，讓我走；我怎樣服事你，你都知道。',
    '創30:27 拉班對他說：我若在你眼前蒙恩，請你仍與我同住，因為我已算定，耶和華賜福與我是為你的緣故；',
    '創30:28 又說：請你定你的工價，我就給你。',
    '創30:29 雅各對他說：我怎樣服事你，你的牲畜在我手裡怎樣，是你知道的。',
    '創30:30 我未來之先，你所有的很少，現今卻發大眾多，耶和華隨我的腳步賜福與你。如今，我什麼時候才為自己興家立業呢﹖',
    '創30:31 拉班說：我當給你什麼呢﹖雅各說：什麼你也不必給我，只有一件事，你若應承，我便仍舊牧放你的羊群。',
    '創30:32 今天我要走遍你的羊群，把綿羊中凡有點的、有斑的，和黑色的，並山羊中凡有斑的、有點的，都挑出來；將來這一等的就算我的工價。',
    '創30:33 以後你來查看我的工價，凡在我手裡的山羊不是有點有斑的，綿羊不是黑色的，那就算是我偷的；這樣便可證出我的公義來。',
    '創30:34 拉班說：好啊！我情願照著你的話行。',
    '創30:35 當日，拉班把有紋的、有斑的公山羊，有點的、有斑的、有雜白紋的母山羊，並黑色的綿羊，都挑出來，交在他兒子們的手下，',
    '創30:36 又使自己和雅各相離三天的路程。雅各就牧養拉班其餘的羊。',
    '創30:37 雅各拿楊樹、杏樹、楓樹的嫩枝，將皮剝成白紋，使枝子露出白的來，',
    '創30:38 將剝了皮的枝子，對著羊群，插在飲羊的水溝裡和水槽裡，羊來喝的時候，牝牡配合。',
    '創30:39 羊對著枝子配合，就生下有紋的、有點的、有斑的來。',
    '創30:40 雅各把羊羔分出來，使拉班的羊與這有紋和黑色的羊相對，把自己的羊另放一處，不叫他和拉班的羊混雜。',
    '創30:41 到羊群肥壯配合的時候，雅各就把枝子插在水溝裡，使羊對著枝子配合。',
    '創30:42 只是到羊瘦弱配合的時候就不插枝子。這樣，瘦弱的就歸拉班，肥壯的就歸雅各。',
    '創30:43 於是雅各極其發大，得了許多的羊群、僕婢、駱駝，和驢。',
    '創31:1 雅各聽見拉班的兒子們有話說：雅各把我們父親所有的都奪了去，並藉著我們父親的，得了這一切的榮耀【或作財】。',
    '創31:2 雅各見拉班的氣色向他不如從前了。',
    '創31:3 耶和華對雅各說：你要回你祖、你父之地，到你親族那裡去，我必與你同在。',
    '創31:4 雅各就打發人，叫拉結和利亞到田野羊群那裡來，',
    '創31:5 對他們說：我看你們父親的氣色向我不如從前了；但我父親的神向來與我同在。',
    '創31:6 你們也知道，我盡了我的力量服事你們的父親。',
    '創31:7 你們的父親欺哄我，十次改了我的工價；然而神不容他害我。',
    '創31:8 他若說：有點的歸你作工價，羊群所生的都有點；他若說：有紋的歸你作工價，羊群所生的都有紋。',
    '創31:9 這樣，神把你們父親的牲畜奪來賜給我了。',
    '創31:10 羊配合的時候，我夢中舉目一看，見跳母羊的公羊都是有紋的、有點的、有花斑的。',
    '創31:11 神的使者在那夢中呼叫我說：雅各。我說：我在這裡。',
    '創31:12 他說：你舉目觀看，跳母羊的公羊都是有紋的、有點的、有花斑的；凡拉班向你所做的，我都看見了。',
    '創31:13 我是伯特利的神；你在那裡用油澆過柱子，向我許過願。現今你起來，離開這地，回你本地去吧！',
    '創31:14 拉結和利亞回答雅各說：在我們父親的家裡還有我們可得的分嗎﹖還有我們的產業嗎﹖',
    '創31:15 我們不是被他當作外人嗎﹖因為他賣了我們，吞了我們的價值。',
    '創31:16 神從我們父親所奪出來的一切財物，那就是我們和我們孩子們的。現今凡神所吩咐你的，你只管去行吧！',
    '創31:17 雅各起來，使他的兒子和妻子都騎上駱駝，',
    '創31:18 又帶著他在巴旦亞蘭所得的一切牲畜和財物，往迦南地、他父親以撒那裡去了。',
    '創31:19 當時拉班剪羊毛去了，拉結偷了他父親家中的神像。',
    '創31:20 雅各背著亞蘭人拉班偷走了，並不告訴他，',
    '創31:21 就帶著所有的逃跑。他起身過大河，面向基列山行去。',
    '創31:22 到第三日，有人告訴拉班，雅各逃跑了。',
    '創31:23 拉班帶領他的眾弟兄去追趕，追了七日，在基列山就追上了。',
    '創31:24 夜間，神到亞蘭人拉班那裡，在夢中對他說：你要小心，不可與雅各說好說歹。',
    '創31:25 拉班追上雅各。雅各在山上支搭帳棚；拉班和他的眾弟兄也在基列山上支搭帳棚。',
    '創31:26 拉班對雅各說：你做的是什麼事呢﹖你背著我偷走了，又把我的女兒們帶了去，如同用刀劍擄去的一般。',
    '創31:27 你為什麼暗暗地逃跑，偷著走，並不告訴我，叫我可以歡樂、唱歌、擊鼓、彈琴的送你回去﹖',
    '創31:28 又不容我與外孫和女兒親嘴﹖你所行的真是愚昧！',
    '創31:29 我手中原有能力害你，只是你父親的神昨夜對我說：你要小心，不可與雅各說好說歹。',
    '創31:30 現在你雖然想你父家，不得不去，為什麼又偷了我的神像呢﹖',
    '創31:31 雅各回答拉班說：恐怕你把你的女兒從我奪去，所以我逃跑。',
    '創31:32 至於你的神像，你在誰那裡搜出來，就不容誰存活。當著我們的眾弟兄，你認一認，在我這裡有什麼東西是你的，就拿去。原來雅各不知道拉結偷了那些神像。',
    '創31:33 拉班進了雅各、利亞，並兩個使女的帳棚，都沒有搜出來，就從利亞的帳棚出來，進了拉結的帳棚。',
    '創31:34 拉結已經把神像藏在駱駝的馱簍裡，便坐在上頭。拉班摸遍了那帳棚，並沒有摸著。',
    '創31:35 拉結對他父親說：現在我身上不便，不能在你面前起來，求我主不要生氣。這樣，拉班搜尋神像，竟沒有搜出來。',
    '創31:36 雅各就發怒斥責拉班說：我有什麼過犯，有什麼罪惡，你竟這樣火速地追我﹖',
    '創31:37 你摸遍了我一切的家具，你搜出什麼來呢﹖可以放在你我弟兄面前，叫他們在你我中間辨別辨別。',
    '創31:38 我在你家這二十年，你的母綿羊、母山羊沒有掉過胎。你群中的公羊，我沒有吃過；',
    '創31:39 被野獸撕裂的，我沒有帶來給你，是我自己賠上。無論是白日，是黑夜，被偷去的，你都向我索要。',
    '創31:40 我白日受盡乾熱，黑夜受盡寒霜，不得合眼睡著，我常是這樣。',
    '創31:41 我這二十年在你家裡，為你的兩個女兒服事你十四年，為你的羊群服事你六年，你又十次改了我的工價。',
    '創31:42 若不是我父親以撒所敬畏的神，就是亞伯拉罕的神與我同在，你如今必定打發我空手而去。神看見我的苦情和我的勞碌，就在昨夜責備你。',
    '創31:43 拉班回答雅各說：這女兒是我的女兒，這些孩子是我的孩子，這些羊群也是我的羊群；凡在你眼前的都是我的。我的女兒並他們所生的孩子，我今日能向他們做什麼呢﹖',
    '創31:44 來吧！你我二人可以立約，作你我中間的證據。',
    '創31:45 雅各就拿一塊石頭立作柱子，',
    '創31:46 又對眾弟兄說：你們堆聚石頭。他們就拿石頭來堆成一堆，大家便在旁邊吃喝。',
    '創31:47 拉班稱那石堆為伊迦爾撒哈杜他，雅各卻稱那石堆為迦累得【都是以石堆為證的意思】。',
    '創31:48 拉班說：今日這石堆作你我中間的證據。因此這地方名叫迦累得，',
    '創31:49 又叫米斯巴，意思說：我們彼此離別以後，願耶和華在你我中間鑒察。',
    '創31:50 你若苦待我的女兒，又在我的女兒以外另娶妻，雖沒有人知道，卻有神在你我中間作見證。',
    '創31:51 拉班又說：你看我在你我中間所立的這石堆和柱子。',
    '創31:52 這石堆作證據，這柱子也作證據。我必不過這石堆去害你；你也不可過這石堆和柱子來害我。',
    '創31:53 但願亞伯拉罕的神和拿鶴的神，就是他們父親的神，在你我中間判斷。雅各就指著他父親以撒所敬畏的神起誓，',
    '創31:54 又在山上獻祭，請眾弟兄來吃飯。他們吃了飯，便在山上住宿。',
    '創31:55 拉班清早起來，與他外孫和女兒親嘴，給他們祝福，回往自己的地方去了。',
    '創32:1 雅各仍舊行路，神的使者遇見他。',
    '創32:2 雅各看見他們就說：這是神的軍兵，於是給那地方起名叫瑪哈念【就是二軍兵的意思】。',
    '創32:3 雅各打發人先往西珥地去，就是以東地，見他哥哥以掃，',
    '創32:4 吩咐他們說：你們對我主以掃說：你的僕人雅各這樣說：我在拉班那裡寄居，直到如今。',
    '創32:5 我有牛、驢、羊群、僕婢，現在打發人來報告我主，為要在你眼前蒙恩。',
    '創32:6 所打發的人回到雅各那裡，說：我們到了你哥哥以掃那裡，他帶著四百人，正迎著你來。',
    '創32:7 雅各就甚懼怕，而且愁煩，便把那與他同在的人口和羊群、牛群、駱駝分做兩隊，',
    '創32:8 說：以掃若來擊殺這一隊，剩下的那一隊還可以逃避。',
    '創32:9 雅各說：耶和華─我祖亞伯拉罕的神，我父親以撒的神啊，你曾對我說：回你本地本族去，我要厚待你。',
    '創32:10 你向僕人所施的一切慈愛和誠實，我一點也不配得；我先前只拿著我的杖過這約但河，如今我卻成了兩隊了。',
    '創32:11 求你救我脫離我哥哥以掃的手；因為我怕他來殺我，連妻子帶兒女一同殺了。',
    '創32:12 你曾說：我必定厚待你，使你的後裔如同海邊的沙，多得不可勝數。',
    '創32:13 當夜，雅各在那裡住宿，就從他所有的物中拿禮物要送給他哥哥以掃：',
    '創32:14 母山羊二百隻，公山羊二十隻，母綿羊二百隻，公綿羊二十隻，',
    '創32:15 奶崽子的駱駝三十隻─各帶著崽子，母牛四十隻，公牛十隻，母驢二十匹，驢駒十匹；',
    '創32:16 每樣各分一群，交在僕人手下，就對僕人說：你們要在我前頭過去，使群群相離，有空閒的地方；',
    '創32:17 又吩咐儘先走的說：我哥哥以掃遇見你的時候，問你說：你是哪家的人﹖要往哪裡去﹖你前頭這些是誰的﹖',
    '創32:18 你就說：是你僕人雅各的，是送給我主以掃的禮物；他自己也在我們後邊。',
    '創32:19 又吩咐第二、第三，和一切趕群畜的人說：你們遇見以掃的時候也要這樣對他說；',
    '創32:20 並且你們要說：你僕人雅各在我們後邊。因雅各心裡說：我藉著在我前頭去的禮物解他的恨，然後再見他的面，或者他容納我。',
    '創32:21 於是禮物先過去了；那夜，雅各在隊中住宿。',
    '創32:22 他夜間起來，帶著兩個妻子，兩個使女，並十一個兒子，都過了雅博渡口，',
    '創32:23 先打發他們過河，又打發所有的都過去，',
    '創32:24 只剩下雅各一人。有一個人來和他摔跤，直到黎明。',
    '創32:25 那人見自己勝不過他，就將他的大腿窩摸了一把，雅各的大腿窩正在摔跤的時候就扭了。',
    '創32:26 那人說：天黎明了，容我去吧！雅各說：你不給我祝福，我就不容你去。',
    '創32:27 那人說：你名叫什麼﹖他說：我名叫雅各。',
    '創32:28 那人說：你的名不要再叫雅各，要叫以色列；因為你與神與人較力，都得了勝。',
    '創32:29 雅各問他說：請將你的名告訴我。那人說：何必問我的名﹖於是在那裡給雅各祝福。',
    '創32:30 雅各便給那地方起名叫毘努伊勒【就是神之面的意思】，意思說：我面對面見了神，我的性命仍得保全。',
    '創32:31 日頭剛出來的時候，雅各經過毘努伊勒，他的大腿就瘸了。',
    '創32:32 故此，以色列人不吃大腿窩的筋，直到今日，因為那人摸了雅各大腿窩的筋。',
    '創33:1 雅各舉目觀看，見以掃來了，後頭跟著四百人，他就把孩子們分開交給利亞、拉結，和兩個使女，',
    '創33:2 並且叫兩個使女和他們的孩子在前頭，利亞和他的孩子在後頭，拉結和約瑟在儘後頭。',
    '創33:3 他自己在他們前頭過去，一連七次俯伏在地才就近他哥哥。',
    '創33:4 以掃跑來迎接他，將他抱住，又摟著他的頸項，與他親嘴，兩個人就哭了。',
    '創33:5 以掃舉目看見婦人孩子，就說：這些和你同行的是誰呢﹖雅各說：這些孩子是神施恩給你的僕人的。',
    '創33:6 於是兩個使女和他們的孩子前來下拜；',
    '創33:7 利亞和他的孩子也前來下拜；隨後約瑟和拉結也前來下拜。',
    '創33:8 以掃說：我所遇見的這些群畜是什麼意思呢﹖雅各說：是要在我主面前蒙恩的。',
    '創33:9 以掃說：兄弟啊，我的已經夠了，你的仍歸你吧！',
    '創33:10 雅各說：不然，我若在你眼前蒙恩，就求你從我手裡收下這禮物；因為我見了你的面，如同見了神的面，並且你容納了我。',
    '創33:11 求你收下我帶來給你的禮物；因為神恩待我，使我充足。雅各再三地求他，他才收下了。',
    '創33:12 以掃說：我們可以起身前往，我在你前頭走。',
    '創33:13 雅各對他說：我主知道孩子們年幼嬌嫩，牛羊也正在乳養的時候，若是催趕一天，群畜都必死了。',
    '創33:14 求我主在僕人前頭走，我要量著在我面前群畜和孩子的力量慢慢地前行，直走到西珥我主那裡。',
    '創33:15 以掃說：容我把跟隨我的人留幾個在你這裡。雅各說：何必呢﹖只要在我主眼前蒙恩就是了。',
    '創33:16 於是，以掃當日起行，回往西珥去了。',
    '創33:17 雅各就往疏割去，在那裡為自己蓋造房屋，又為牲畜搭棚；因此那地方名叫疏割【就是棚的意思】。',
    '創33:18 雅各從巴旦亞蘭回來的時候，平平安安地到了迦南地的示劍城，在城東支搭帳棚，',
    '創33:19 就用一百塊銀子向示劍的父親、哈抹的子孫買了支帳棚的那塊地，',
    '創33:20 在那裡築了一座壇，起名叫伊利伊羅伊以色列【就是神、以色列神的意思】。',
    '創34:1 利亞給雅各所生的女兒底拿出去，要見那地的女子們。',
    '創34:2 那地的主─希未人、哈抹的兒子示劍看見他，就拉住他，與他行淫，玷辱他。',
    '創34:3 示劍的心繫戀雅各的女兒底拿，喜愛這女子，甜言蜜語地安慰他。',
    '創34:4 示劍對他父親哈抹說：求你為我聘這女子為妻。',
    '創34:5 雅各聽見示劍玷污了他的女兒底拿。那時他的兒子們正和群畜在田野，雅各就閉口不言，等他們回來。',
    '創34:6 示劍的父親哈抹出來見雅各，要和他商議。',
    '創34:7 雅各的兒子們聽見這事，就從田野回來，人人忿恨，十分惱怒；因示劍在以色列家做了醜事，與雅各的女兒行淫，這本是不該做的事。',
    '創34:8 哈抹和他們商議說：我兒子示劍的心戀慕這女子，求你們將他給我的兒子為妻。',
    '創34:9 你們與我們彼此結親；你們可以把女兒給我們，也可以娶我們的女兒。',
    '創34:10 你們與我們同住吧！這地都在你們面前，只管在此居住，做買賣，置產業。',
    '創34:11 示劍對女兒的父親和弟兄們說：但願我在你們眼前蒙恩，你們向我要什麼，我必給你們。',
    '創34:12 任憑向我要多重的聘金和禮物，我必照你們所說的給你們；只要把女子給我為妻。',
    '創34:13 雅各的兒子們因為示劍玷污了他們的妹子底拿，就用詭詐的話回答示劍和他父親哈抹，',
    '創34:14 對他們說：我們不能把我們的妹子給沒有受割禮的人為妻，因為那是我們的羞辱。',
    '創34:15 惟有一件才可以應允：若你們所有的男丁都受割禮，和我們一樣，',
    '創34:16 我們就把女兒給你們，也娶你們的女兒；我們便與你們同住，兩下成為一樣的人民。',
    '創34:17 倘若你們不聽從我們受割禮，我們就帶著妹子走了。',
    '創34:18 哈抹和他的兒子示劍喜歡這話。',
    '創34:19 那少年人做這事並不遲延，因為他喜愛雅各的女兒；他在他父親家中也是人最尊重的。',
    '創34:20 哈抹和他兒子示劍到本城的門口，對本城的人說：',
    '創34:21 這些人與我們和睦，不如許他們在這地居住，做買賣；這地也寬闊，足可容下他們。我們可以娶他們的女兒為妻，也可以把我們的女兒嫁給他們。',
    '創34:22 惟有一件事我們必須做，他們才肯應允和我們同住，成為一樣的人民：就是我們中間所有的男丁都要受割禮，和他們一樣。',
    '創34:23 他們的群畜、貨財，和一切的牲口豈不都歸我們嗎﹖只要依從他們，他們就與我們同住。',
    '創34:24 凡從城門出入的人就都聽從哈抹和他兒子示劍的話；於是凡從城門出入的男丁都受了割禮。',
    '創34:25 到第三天，眾人正在疼痛的時候，雅各的兩個兒子，就是底拿的哥哥西緬和利未，各拿刀劍，趁著眾人想不到的時候來到城中，把一切男丁都殺了，',
    '創34:26 又用刀殺了哈抹和他兒子示劍，把底拿從示劍家裡帶出來就走了。',
    '創34:27 雅各的兒子們因為他們的妹子受了玷污，就來到被殺的人那裡，擄掠那城，',
    '創34:28 奪了他們的羊群、牛群，和驢，並城裡田間所有的；',
    '創34:29 又把他們一切貨財、孩子、婦女，並各房中所有的，都擄掠去了。',
    '創34:30 雅各對西緬和利未說：你們連累我，使我在這地的居民中，就是在迦南人和比利洗人中，有了臭名。我的人丁既然稀少，他們必聚集來擊殺我，我和全家的人都必滅絕。',
    '創34:31 他們說：他豈可待我們的妹子如同妓女嗎﹖',
    '創35:1 神對雅各說：起來！上伯特利去，住在那裡；要在那裡築一座壇給神，就是你逃避你哥哥以掃的時候向你顯現的那位。',
    '創35:2 雅各就對他家中的人並一切與他同在的人說：你們要除掉你們中間的外邦神，也要自潔，更換衣裳。',
    '創35:3 我們要起來，上伯特利去，在那裡我要築一座壇給神，就是在我遭難的日子應允我的禱告、在我行的路上保佑我的那位。',
    '創35:4 他們就把外邦人的神像和他們耳朵上的環子交給雅各；雅各都藏在示劍那裡的橡樹底下。',
    '創35:5 他們便起行前往。神使那周圍城邑的人都甚驚懼，就不追趕雅各的眾子了。',
    '創35:6 於是雅各和一切與他同在的人到了迦南地的路斯，就是伯特利。',
    '創35:7 他在那裡築了一座壇，就給那地方起名叫伊勒伯特利【就是伯特利之神的意思】；因為他逃避他哥哥的時候，神在那裡向他顯現。',
    '創35:8 利百加的奶母底波拉死了，就葬在伯特利下邊橡樹底下；那棵樹名叫亞倫巴古。',
    '創35:9 雅各從巴旦亞蘭回來，神又向他顯現，賜福與他，',
    '創35:10 且對他說：你的名原是雅各，從今以後不要再叫雅各，要叫以色列。這樣，他就改名叫以色列。',
    '創35:11 神又對他說：我是全能的神；你要生養眾多，將來有一族和多國的民從你而生，又有君王從你而出。',
    '創35:12 我所賜給亞伯拉罕和以撒的地，我要賜給你與你的後裔。',
    '創35:13 神就從那與雅各說話的地方升上去了。',
    '創35:14 雅各便在那裡立了一根石柱，在柱子上奠酒，澆油。',
    '創35:15 雅各就給那地方起名叫伯特利。',
    '創35:16 他們從伯特利起行，離以法他還有一段路程，拉結臨產甚是艱難。',
    '創35:17 正在艱難的時候，收生婆對他說：不要怕，你又要得一個兒子了。',
    '創35:18 他將近於死，靈魂要走的時候，就給他兒子起名叫便俄尼；他父親卻給他起名叫便雅憫。',
    '創35:19 拉結死了，葬在以法他的路旁；以法他就是伯利恆。',
    '創35:20 雅各在他的墳上立了一統碑，就是拉結的墓碑，到今日還在。',
    '創35:21 以色列起行前往，在以得臺那邊支搭帳棚。',
    '創35:22 以色列住在那地的時候，流便去與他父親的妾辟拉同寢，以色列也聽見了。雅各共有十二個兒子。',
    '創35:23 利亞所生的是雅各的長子流便，還有西緬、利未、猶大、以薩迦、西布倫。',
    '創35:24 拉結所生的是約瑟、便雅憫。',
    '創35:25 拉結的使女辟拉所生的是但、拿弗他利。',
    '創35:26 利亞的使女悉帕所生的是迦得、亞設。這是雅各在巴旦亞蘭所生的兒子。',
    '創35:27 雅各來到他父親以撒那裡，到了基列亞巴的幔利，乃是亞伯拉罕和以撒寄居的地方；基列亞巴就是希伯崙。',
    '創35:28 以撒共活了一百八十歲。',
    '創35:29 以撒年紀老邁，日子滿足，氣絕而死，歸到他列祖【原文作本民】那裡。他兩個兒子以掃、雅各把他埋葬了。',
    '創36:1 以掃就是以東，他的後代記在下面。',
    '創36:2 以掃娶迦南的女子為妻，就是赫人以倫的女兒亞大和希未人祭便的孫女、亞拿的女兒阿何利巴瑪，',
    '創36:3 又娶了以實瑪利的女兒、尼拜約的妹子巴實抹。',
    '創36:4 亞大給以掃生了以利法；巴實抹生了流珥；',
    '創36:5 阿何利巴瑪生了耶烏施、雅蘭、可拉。這都是以掃的兒子，是在迦南地生的。',
    '創36:6 以掃帶著他的妻子、兒女，與家中一切的人口，並他的牛羊、牲畜，和一切貨財，就是他在迦南地所得的，往別處去，離了他兄弟雅各。',
    '創36:7 因為二人的財物群畜甚多，寄居的地方容不下他們，所以不能同居。',
    '創36:8 於是以掃住在西珥山裡；以掃就是以東。',
    '創36:9 以掃是西珥山裡以東人的始祖，他的後代記在下面。',
    '創36:10 以掃眾子的名字如下。以掃的妻子亞大生以利法；以掃的妻子巴實抹生流珥。',
    '創36:11 以利法的兒子是提幔、阿抹、洗玻、迦坦、基納斯。',
    '創36:12 亭納是以掃兒子以利法的妾；他給以利法生了亞瑪力。這是以掃的妻子亞大的子孫。',
    '創36:13 流珥的兒子是拿哈、謝拉、沙瑪、米撒。這是以掃妻子巴實抹的子孫。',
    '創36:14 以掃的妻子阿何利巴瑪是祭便的孫女，亞拿的女兒；他給以掃生了耶烏施、雅蘭、可拉。',
    '創36:15 以掃子孫中作族長的記在下面。以掃的長子以利法的子孫中，有提幔族長、阿抹族長、洗玻族長，基納斯族長、',
    '創36:16 可拉族長、迦坦族長、亞瑪力族長。這是在以東地從以利法所出的族長，都是亞大的子孫。',
    '創36:17 以掃的兒子流珥的子孫中，有拿哈族長、謝拉族長、沙瑪族長、米撒族長。這是在以東地從流珥所出的族長，都是以掃妻子巴實抹的子孫。',
    '創36:18 以掃的妻子阿何利巴瑪的子孫中，有耶烏施族長、雅蘭族長、可拉族長。這是從以掃妻子，亞拿的女兒，阿何利巴瑪子孫中所出的族長。',
    '創36:19 以上的族長都是以掃的子孫；以掃就是以東。',
    '創36:20 那地原有的居民─何利人西珥的子孫記在下面：就是羅坍、朔巴、祭便、亞拿、',
    '創36:21 底順、以察、底珊。這是從以東地的何利人西珥子孫中所出的族長。',
    '創36:22 羅坍的兒子是何利、希幔；羅坍的妹子是亭納。',
    '創36:23 朔巴的兒子是亞勒文、瑪拿轄、以巴錄、示玻、阿南。',
    '創36:24 祭便的兒子是亞雅、亞拿（當時在曠野放他父親祭便的驢，遇著溫泉的，就是這亞拿）。',
    '創36:25 亞拿的兒子是底順；亞拿的女兒是阿何利巴瑪。',
    '創36:26 底順的兒子是欣但、伊是班、益蘭、基蘭。',
    '創36:27 以察的兒子是辟罕、撒番、亞干。',
    '創36:28 底珊的兒子是烏斯、亞蘭。',
    '創36:29 從何利人所出的族長記在下面：就是羅坍族長、朔巴族長、祭便族長、亞拿族長、',
    '創36:30 底順族長、以察族長、底珊族長。這是從何利人所出的族長，都在西珥地，按著宗族作族長。',
    '創36:31 以色列人未有君王治理以先，在以東地作王的記在下面。',
    '創36:32 比珥的兒子比拉在以東作王，他的京城名叫亭哈巴。',
    '創36:33 比拉死了，波斯拉人謝拉的兒子約巴接續他作王。',
    '創36:34 約巴死了，提幔地的人戶珊接續他作王。',
    '創36:35 戶珊死了，比達的兒子哈達接續他作王；這哈達就是在摩押地殺敗米甸人的，他的京城名叫亞未得。',
    '創36:36 哈達死了，瑪士利加人桑拉接續他作王。',
    '創36:37 桑拉死了，大河邊的利河伯人掃羅接續他作王。',
    '創36:38 掃羅死了，亞革波的兒子巴勒哈南接續他作王。',
    '創36:39 亞革波的兒子巴勒哈南死了，哈達接續他作王，他的京城名叫巴烏；他的妻子名叫米希他別，是米薩合的孫女，瑪特列的女兒。',
    '創36:40 從以掃所出的族長，按著他們的宗族、住處、名字記在下面：就是亭納族長、亞勒瓦族長、耶帖族長、',
    '創36:41 阿何利巴瑪族長、以拉族長、比嫩族長、',
    '創36:42 基納斯族長、提幔族長、米比薩族長、',
    '創36:43 瑪基疊族長、以蘭族長。這是以東人在所得為業的地上，按著他們的住處。（所有的族長都是以東人的始祖以掃的後代。）',
    '創37:1 雅各住在迦南地，就是他父親寄居的地。',
    '創37:2 雅各的記略如下。約瑟十七歲與他哥哥們一同牧羊。他是個童子，與他父親的妾辟拉、悉帕的兒子們常在一處。約瑟將他哥哥們的惡行報給他們的父親。',
    '創37:3 以色列原來愛約瑟過於愛他的眾子，因為約瑟是他年老生的；他給約瑟做了一件彩衣。',
    '創37:4 約瑟的哥哥們見父親愛約瑟過於愛他們，就恨約瑟，不與他說和睦的話。',
    '創37:5 約瑟做了一夢，告訴他哥哥們，他們就越發恨他。',
    '創37:6 約瑟對他們說：請聽我所做的夢：',
    '創37:7 我們在田裡捆禾稼，我的捆起來站著，你們的捆來圍著我的捆下拜。',
    '創37:8 他的哥哥們回答說：難道你真要作我們的王嗎﹖難道你真要管轄我們嗎﹖他們就因為他的夢和他的話越發恨他。',
    '創37:9 後來他又做了一夢，也告訴他的哥哥們說：看哪，我又做了一夢，夢見太陽、月亮，與十一個星向我下拜。',
    '創37:10 約瑟將這夢告訴他父親和他哥哥們，他父親就責備他說：你做的這是什麼夢！難道我和你母親、你弟兄果然要來俯伏在地，向你下拜嗎﹖',
    '創37:11 他哥哥們都嫉妒他，他父親卻把這話存在心裡。',
    '創37:12 約瑟的哥哥們往示劍去放他們父親的羊。',
    '創37:13 以色列對約瑟說：你哥哥們不是在示劍放羊嗎﹖你來，我要打發你往他們那裡去。約瑟說：我在這裡。',
    '創37:14 以色列說：你去看看你哥哥們平安不平安，群羊平安不平安，就回來報信給我；於是打發他出希伯崙谷，他就往示劍去了。',
    '創37:15 有人遇見他在田野走迷了路，就問他說：你找什麼﹖',
    '創37:16 他說：我找我的哥哥們，求你告訴我，他們在何處放羊。',
    '創37:17 那人說：他們已經走了，我聽見他們說要往多坍去。約瑟就去追趕他哥哥們，遇見他們在多坍。',
    '創37:18 他們遠遠地看見他，趁他還沒有走到跟前，大家就同謀要害死他，',
    '創37:19 彼此說：你看！那做夢的來了。',
    '創37:20 來吧！我們將他殺了，丟在一個坑裡，就說有惡獸把他吃了。我們且看他的夢將來怎麼樣。',
    '創37:21 流便聽見了，要救他脫離他們的手，說：我們不可害他的性命；',
    '創37:22 又說：不可流他的血，可以把他丟在這野地的坑裡，不可下手害他。流便的意思是要救他脫離他們的手，把他歸還他的父親。',
    '創37:23 約瑟到了他哥哥們那裡，他們就剝了他的外衣，就是他穿的那件彩衣，',
    '創37:24 把他丟在坑裡；那坑是空的，裡頭沒有水。',
    '創37:25 他們坐下吃飯，舉目觀看，見有一夥米甸的以實瑪利人從基列來，用駱駝馱著香料、乳香、沒藥，要帶下埃及去。',
    '創37:26 猶大對眾弟兄說：我們殺我們的兄弟，藏了他的血有什麼益處呢﹖',
    '創37:27 我們不如將他賣給以實瑪利人，不可下手害他；因為他是我們的兄弟，我們的骨肉。眾弟兄就聽從了他。',
    '創37:28 有些米甸的商人從那裡經過，哥哥們就把約瑟從坑裡拉上來，講定二十舍客勒銀子，把約瑟賣給以實瑪利人。他們就把約瑟帶到埃及去了。',
    '創37:29 流便回到坑邊，見約瑟不在坑裡，就撕裂衣服，',
    '創37:30 回到兄弟們那裡，說：童子沒有了。我往哪裡去才好呢﹖',
    '創37:31 他們宰了一隻公山羊，把約瑟的那件彩衣染了血，',
    '創37:32 打發人送到他們的父親那裡，說：我們撿了這個；請認一認是你兒子的外衣不是﹖',
    '創37:33 他認得，就說：這是我兒子的外衣。有惡獸把他吃了，約瑟被撕碎了！撕碎了！',
    '創37:34 雅各便撕裂衣服，腰間圍上麻布，為他兒子悲哀了多日。',
    '創37:35 他的兒女都起來安慰他，他卻不肯受安慰，說：我必悲哀著下陰間，到我兒子那裡。約瑟的父親就為他哀哭。',
    '創37:36 米甸人帶約瑟到埃及，把他賣給法老的內臣─護衛長波提乏。',
    '創38:1 那時，猶大離開他弟兄下去，到一個亞杜蘭人名叫希拉的家裡去。',
    '創38:2 猶大在那裡看見一個迦南人名叫書亞的女兒，就娶他為妻，與他同房，',
    '創38:3 他就懷孕生了兒子，猶大給他起名叫珥。',
    '創38:4 他又懷孕生了兒子，母親給他起名叫俄南。',
    '創38:5 他復又生了兒子，給他起名叫示拉。他生示拉的時候，猶大正在基悉。',
    '創38:6 猶大為長子珥娶妻，名叫他瑪。',
    '創38:7 猶大的長子珥在耶和華眼中看為惡，耶和華就叫他死了。',
    '創38:8 猶大對俄南說：你當與你哥哥的妻子同房，向他盡你為弟的本分，為你哥哥生子立後。',
    '創38:9 俄南知道生子不歸自己，所以同房的時候便遺在地，免得給他哥哥留後。',
    '創38:10 俄南所做的在耶和華眼中看為惡，耶和華也就叫他死了。',
    '創38:11 猶大心裡說：恐怕示拉也死，像他兩個哥哥一樣，就對他兒婦他瑪說：你去，在你父親家裡守寡，等我兒子示拉長大。他瑪就回去，住在他父親家裡。',
    '創38:12 過了許久，猶大的妻子書亞的女兒死了。猶大得了安慰，就和他朋友亞杜蘭人希拉上亭拿去，到他剪羊毛的人那裡。',
    '創38:13 有人告訴他瑪說：你的公公上亭拿剪羊毛去了。',
    '創38:14 他瑪見示拉已經長大，還沒有娶他為妻，就脫了他作寡婦的衣裳，用帕子蒙著臉，又遮住身體，坐在亭拿路上的伊拿印城門口。',
    '創38:15 猶大看見他，以為是妓女，因為他蒙著臉。',
    '創38:16 猶大就轉到他那裡去，說：來吧！讓我與你同寢。他原不知道是他的兒婦。他瑪說：你要與我同寢，把什麼給我呢﹖',
    '創38:17 猶大說：我從羊群裡取一隻山羊羔，打發人送來給你。他瑪說：在未送以先，你願意給我一個當頭嗎﹖',
    '創38:18 他說：我給你什麼當頭呢﹖他瑪說：你的印、你的帶子，和你手裡的杖。猶大就給了他，與他同寢，他就從猶大懷了孕。',
    '創38:19 他瑪起來走了，除去帕子，仍舊穿上作寡婦的衣裳。',
    '創38:20 猶大託他朋友亞杜蘭人送一隻山羊羔去，要從那女人手裡取回當頭來，卻找不著他，',
    '創38:21 就問那地方的人說：伊拿印路旁的妓女在哪裡﹖他們說：這裡並沒有妓女。',
    '創38:22 他回去見猶大說：我沒有找著他，並且那地方的人說：這裡沒有妓女。',
    '創38:23 猶大說：我把這山羊羔送去了，你竟找不著他。任憑他拿去吧，免得我們被羞辱。',
    '創38:24 約過了三個月，有人告訴猶大說：你的兒婦他瑪作了妓女，且因行淫有了身孕。猶大說：拉出他來，把他燒了！',
    '創38:25 他瑪被拉出來的時候便打發人去見他公公，對他說：這些東西是誰的，我就是從誰懷的孕。請你認一認，這印和帶子並杖都是誰的﹖',
    '創38:26 猶大承認說：他比我更有義，因為我沒有將他給我的兒子示拉。從此猶大不再與他同寢了。',
    '創38:27 他瑪將要生產，不料他腹裡是一對雙生。',
    '創38:28 到生產的時候，一個孩子伸出一隻手來；收生婆拿紅線拴在他手上，說：這是頭生的。',
    '創38:29 隨後這孩子把手收回去，他哥哥生出來了；收生婆說：你為什麼搶著來呢﹖因此給他起名叫法勒斯。',
    '創38:30 後來，他兄弟那手上有紅線的也生出來，就給他起名叫謝拉。',
    '創39:1 約瑟被帶下埃及去。有一個埃及人，是法老的內臣─護衛長波提乏，從那些帶下他來的以實瑪利人手下買了他去。',
    '創39:2 約瑟住在他主人埃及人的家中，耶和華與他同在，他就百事順利。',
    '創39:3 他主人見耶和華與他同在，又見耶和華使他手裡所辦的盡都順利，',
    '創39:4 約瑟就在主人眼前蒙恩，伺候他主人，並且主人派他管理家務，把一切所有的都交在他手裡。',
    '創39:5 自從主人派約瑟管理家務和他一切所有的，耶和華就因約瑟的緣故賜福與那埃及人的家；凡家裡和田間一切所有的都蒙耶和華賜福。',
    '創39:6 波提乏將一切所有的都交在約瑟的手中，除了自己所吃的飯，別的事一概不知。約瑟原來秀雅俊美。',
    '創39:7 這事以後，約瑟主人的妻以目送情給約瑟，說：你與我同寢吧！',
    '創39:8 約瑟不從，對他主人的妻說：看哪，一切家務，我主人都不知道；他把所有的都交在我手裡。',
    '創39:9 在這家裡沒有比我大的；並且他沒有留下一樣不交給我，只留下了你，因為你是他的妻子。我怎能作這大惡，得罪神呢﹖',
    '創39:10 後來他天天和約瑟說，約瑟卻不聽從他，不與他同寢，也不和他在一處。',
    '創39:11 有一天，約瑟進屋裡去辦事，家中人沒有一個在那屋裡，',
    '創39:12 婦人就拉住他的衣裳，說：你與我同寢吧！約瑟把衣裳丟在婦人手裡，跑到外邊去了。',
    '創39:13 婦人看見約瑟把衣裳丟在他手裡跑出去了，',
    '創39:14 就叫了家裡的人來，對他們說：你們看！他帶了一個希伯來人進入我們家裡，要戲弄我們。他到我這裡來，要與我同寢，我就大聲喊叫。',
    '創39:15 他聽見我放聲喊起來，就把衣裳丟在我這裡，跑到外邊去了。',
    '創39:16 婦人把約瑟的衣裳放在自己那裡，等著他主人回家，',
    '創39:17 就對他如此如此說：你所帶到我們這裡的那希伯來僕人進來要戲弄我，',
    '創39:18 我放聲喊起來，他就把衣裳丟在我這裡，跑出去了。',
    '創39:19 約瑟的主人聽見他妻子對他所說的話，說：你的僕人如此如此待我，他就生氣，',
    '創39:20 把約瑟下在監裡，就是王的囚犯被囚的地方。於是約瑟在那裡坐監。',
    '創39:21 但耶和華與約瑟同在，向他施恩，使他在司獄的眼前蒙恩。',
    '創39:22 司獄就把監裡所有的囚犯都交在約瑟的手下；他們在那裡所辦的事都是經他的手。',
    '創39:23 凡在約瑟手下的事，司獄一概不察，因為耶和華與約瑟同在；耶和華使他所做的盡都順利。',
    '創40:1 這事以後，埃及王的酒政和膳長得罪了他們的主─埃及王，',
    '創40:2 法老就惱怒酒政和膳長這二臣，',
    '創40:3 把他們下在護衛長府內的監裡，就是約瑟被囚的地方。',
    '創40:4 護衛長把他們交給約瑟，約瑟便伺候他們；他們有些日子在監裡。',
    '創40:5 被囚在監之埃及王的酒政和膳長二人同夜各做一夢，各夢都有講解。',
    '創40:6 到了早晨，約瑟進到他們那裡，見他們有愁悶的樣子。',
    '創40:7 他便問法老的二臣，就是與他同囚在他主人府裡的，說：你們今日為什麼面帶愁容呢﹖',
    '創40:8 他們對他說：我們各人做了一夢，沒有人能解。約瑟說：解夢不是出於神嗎﹖請你們將夢告訴我。',
    '創40:9 酒政便將他的夢告訴約瑟說：我夢見在我面前有一棵葡萄樹，',
    '創40:10 樹上有三根枝子，好像發了芽，開了花，上頭的葡萄都成熟了。',
    '創40:11 法老的杯在我手中，我就拿葡萄擠在法老的杯裡，將杯遞在他手中。',
    '創40:12 約瑟對他說：你所做的夢是這樣解：三根枝子就是三天；',
    '創40:13 三天之內，法老必提你出監，叫你官復原職，你仍要遞杯在法老的手中，和先前作他的酒政一樣。',
    '創40:14 但你得好處的時候，求你記念我，施恩與我，在法老面前提說我，救我出這監牢。',
    '創40:15 我實在是從希伯來人之地被拐來的；我在這裡也沒有做過什麼，叫他們把我下在監裡。',
    '創40:16 膳長見夢解得好，就對約瑟說：我在夢中見我頭上頂著三筐白餅；',
    '創40:17 極上的筐子裡有為法老烤的各樣食物，有飛鳥來吃我頭上筐子裡的食物。',
    '創40:18 約瑟說：你的夢是這樣解：三個筐子就是三天；',
    '創40:19 三天之內，法老必斬斷你的頭，把你掛在木頭上，必有飛鳥來吃你身上的肉。',
    '創40:20 到了第三天，是法老的生日，他為眾臣僕設擺筵席，把酒政和膳長提出監來，',
    '創40:21 使酒政官復原職，他仍舊遞杯在法老手中；',
    '創40:22 但把膳長掛起來，正如約瑟向他們所解的話。',
    '創40:23 酒政卻不記念約瑟，竟忘了他。',
    '創41:1 過了兩年，法老做夢，夢見自己站在河邊，',
    '創41:2 有七隻母牛從河裡上來，又美好又肥壯，在蘆荻中吃草。',
    '創41:3 隨後又有七隻母牛從河裡上來，又醜陋又乾瘦，與那七隻母牛一同站在河邊。',
    '創41:4 這又醜陋又乾瘦的七隻母牛吃盡了那又美好又肥壯的七隻母牛。法老就醒了。',
    '創41:5 他又睡著，第二回做夢，夢見一棵麥子長了七個穗子，又肥大又佳美，',
    '創41:6 隨後又長了七個穗子，又細弱又被東風吹焦了。',
    '創41:7 這細弱的穗子吞了那七個又肥大又飽滿的穗子。法老醒了，不料是個夢。',
    '創41:8 到了早晨，法老心裡不安，就差人召了埃及所有的術士和博士來；法老就把所做的夢告訴他們，卻沒有人能給法老圓解。',
    '創41:9 那時酒政對法老說：我今日想起我的罪來。',
    '創41:10 從前法老惱怒臣僕，把我和膳長下在護衛長府內的監裡。',
    '創41:11 我們二人同夜各做一夢，各夢都有講解。',
    '創41:12 在那裡同著我們有一個希伯來的少年人，是護衛長的僕人，我們告訴他，他就把我們的夢圓解，是按著各人的夢圓解的。',
    '創41:13 後來正如他給我們圓解的成就了；我官復原職，膳長被掛起來了。',
    '創41:14 法老遂即差人去召約瑟，他們便急忙帶他出監，他就剃頭，刮臉，換衣裳，進到法老面前。',
    '創41:15 法老對約瑟說：我做了一夢，沒有人能解；我聽見人說，你聽了夢就能解。',
    '創41:16 約瑟回答法老說：這不在乎我，神必將平安的話回答法老。',
    '創41:17 法老對約瑟說：我夢見我站在河邊，',
    '創41:18 有七隻母牛從河裡上來，又肥壯又美好，在蘆荻中吃草。',
    '創41:19 隨後又有七隻母牛上來，又軟弱又醜陋又乾瘦，在埃及遍地，我沒有見過這樣不好的。',
    '創41:20 這又乾瘦又醜陋的母牛吃盡了那以先的七隻肥母牛，',
    '創41:21 吃了以後卻看不出是吃了，那醜陋的樣子仍舊和先前一樣。我就醒了。',
    '創41:22 我又夢見一棵麥子，長了七個穗子，又飽滿又佳美，',
    '創41:23 隨後又長了七個穗子，枯槁細弱，被東風吹焦了。',
    '創41:24 這些細弱的穗子吞了那七個佳美的穗子。我將這夢告訴了術士，卻沒有人能給我解說。',
    '創41:25 約瑟對法老說：法老的夢乃是一個。神已將所要做的事指示法老了。',
    '創41:26 七隻好母牛是七年，七個好穗子也是七年；這夢乃是一個。',
    '創41:27 那隨後上來的七隻又乾瘦又醜陋的母牛是七年，那七個虛空、被東風吹焦的穗子也是七年，都是七個荒年。',
    '創41:28 這就是我對法老所說，神已將所要做的事顯明給法老了。',
    '創41:29 埃及遍地必來七個大豐年，',
    '創41:30 隨後又要來七個荒年，甚至在埃及地都忘了先前的豐收，全地必被饑荒所滅。',
    '創41:31 因那以後的饑荒甚大，便不覺得先前的豐收了。',
    '創41:32 至於法老兩回做夢，是因神命定這事，而且必速速成就。',
    '創41:33 所以，法老當揀選一個有聰明有智慧的人，派他治理埃及地。',
    '創41:34 法老當這樣行，又派官員管理這地。當七個豐年的時候，征收埃及地的五分之一，',
    '創41:35 叫他們把將來豐年一切的糧食聚斂起來，積蓄五穀，收存在各城裡做食物，歸於法老的手下。',
    '創41:36 所積蓄的糧食可以防備埃及地將來的七個荒年，免得這地被饑荒所滅。',
    '創41:37 法老和他一切臣僕都以這事為妙。',
    '創41:38 法老對臣僕說：像這樣的人，有神的靈在他裡頭，我們豈能找得著呢﹖',
    '創41:39 法老對約瑟說：神既將這事都指示你，可見沒有人像你這樣有聰明有智慧。',
    '創41:40 你可以掌管我的家；我的民都必聽從你的話。惟獨在寶座上我比你大。',
    '創41:41 法老又對約瑟說：我派你治理埃及全地。',
    '創41:42 法老就摘下手上打印的戒指，戴在約瑟的手上，給他穿上細麻衣，把金鍊戴在他的頸項上，',
    '創41:43 又叫約瑟坐他的副車，喝道的在前呼叫說：跪下。這樣、法老派他治理埃及全地。',
    '創41:44 法老對約瑟說：我是法老，在埃及全地，若沒有你的命令，不許人擅自辦事【原文作動手動腳】。',
    '創41:45 法老賜名給約瑟，叫撒發那忒巴內亞，又將安城的祭司波提非拉的女兒亞西納給他為妻。約瑟就出去巡行埃及地。',
    '創41:46 約瑟見埃及王法老的時候年三十歲。他從法老面前出去，遍行埃及全地。',
    '創41:47 七個豐年之內，地的出產極豐極盛【原文作一把一把的】，',
    '創41:48 約瑟聚歛埃及地七個豐年一切的糧食，把糧食積存在各城裡；各城周圍田地的糧食都積存在本城裡。',
    '創41:49 約瑟積蓄五穀甚多，如同海邊的沙，無法計算，因為穀不可勝數。',
    '創41:50 荒年未到以前，安城的祭司波提非拉的女兒亞西納給約瑟生了兩個兒子。',
    '創41:51 約瑟給長子起名叫瑪拿西【就是使之忘了的意思】，因為他說：神使我忘了一切的困苦和我父的全家。',
    '創41:52 他給次子起名叫以法蓮【就是使之昌盛的意思】，因為他說：神使我在受苦的地方昌盛。',
    '創41:53 埃及地的七個豐年一完，',
    '創41:54 七個荒年就來了。正如約瑟所說的，各地都有饑荒；惟獨埃及全地有糧食。',
    '創41:55 及至埃及全地有了饑荒，眾民向法老哀求糧食，法老對他們說：你們往約瑟那裡去，凡他所說的，你們都要做。',
    '創41:56 當時饑荒遍滿天下，約瑟開了各處的倉，糶糧給埃及人；在埃及地饑荒甚大。',
    '創41:57 各地的人都往埃及去，到約瑟那裡糴糧，因為天下的饑荒甚大。',
    '創42:1 雅各見埃及有糧，就對兒子們說：你們為什麼彼此觀望呢﹖',
    '創42:2 我聽見埃及有糧，你們可以下去，從那裡為我們糴些來，使我們可以存活，不至於死。',
    '創42:3 於是，約瑟的十個哥哥都下埃及糴糧去了。',
    '創42:4 但約瑟的兄弟便雅憫，雅各沒有打發他和哥哥們同去，因為雅各說：恐怕他遭害。',
    '創42:5 來糴糧的人中有以色列的兒子們，因為迦南地也有饑荒。',
    '創42:6 當時治理埃及地的是約瑟；糶糧給那地眾民的就是他。約瑟的哥哥們來了，臉伏於地，向他下拜。',
    '創42:7 約瑟看見他哥哥們，就認得他們，卻裝作生人，向他們說些嚴厲話，問他們說：你們從哪裡來﹖他們說：我們從迦南地來糴糧。',
    '創42:8 約瑟認得他哥哥們，他們卻不認得他。',
    '創42:9 約瑟想起從前所做的那兩個夢，就對他們說：你們是奸細，來窺探這地的虛實。',
    '創42:10 他們對他說：我主啊，不是的。僕人們是糴糧來的。',
    '創42:11 我們都是一個人的兒子，是誠實人；僕人們並不是奸細。',
    '創42:12 約瑟說：不然，你們必是窺探這地的虛實來的。',
    '創42:13 他們說：僕人們本是弟兄十二人，是迦南地一個人的兒子，頂小的現今在我們的父親那裡，有一個沒有了。',
    '創42:14 約瑟說：我才說你們是奸細，這話實在不錯。',
    '創42:15 我指著法老的性命起誓，若是你們的小兄弟不到這裡來，你們就不得出這地方，從此就可以把你們證驗出來了。',
    '創42:16 須要打發你們中間一個人去，把你們的兄弟帶來。至於你們，都要囚在這裡，好證驗你們的話真不真，若不真，我指著法老的性命起誓，你們一定是奸細。',
    '創42:17 於是約瑟把他們都下在監裡三天。',
    '創42:18 到了第三天，約瑟對他們說：我是敬畏神的；你們照我的話行就可以存活。',
    '創42:19 你們如果是誠實人，可以留你們中間的一個人囚在監裡，但你們可以帶著糧食回去，救你們家裡的饑荒。',
    '創42:20 把你們的小兄弟帶到我這裡來，如此，你們的話便有證據，你們也不至於死。他們就照樣而行。',
    '創42:21 他們彼此說：我們在兄弟身上實在有罪。他哀求我們的時候，我們見他心裡的愁苦，卻不肯聽，所以這場苦難臨到我們身上。',
    '創42:22 流便說：我豈不是對你們說過，不可傷害那孩子嗎﹖只是你們不肯聽，所以流他血的罪向我們追討。',
    '創42:23 他們不知道約瑟聽得出來，因為在他們中間用通事傳話。',
    '創42:24 約瑟轉身退去，哭了一場，又回來對他們說話，就從他們中間挑出西緬來，在他們眼前把他捆綁。',
    '創42:25 約瑟吩咐人把糧食裝滿他們的器具，把各人的銀子歸還在各人的口袋裡，又給他們路上用的食物，人就照他的話辦了。',
    '創42:26 他們就把糧食馱在驢上，離開那裡去了。',
    '創42:27 到了住宿的地方，他們中間有一個人打開口袋，要拿料餵驢，才看見自己的銀子仍在口袋裡，',
    '創42:28 就對弟兄們說：我的銀子歸還了，看哪，仍在我口袋裡！他們就提心吊膽，戰戰兢兢地彼此說：這是神向我們做什麼呢﹖',
    '創42:29 他們來到迦南地、他們的父親雅各那裡，將所遭遇的事都告訴他，說：',
    '創42:30 那地的主對我們說嚴厲的話，把我們當作窺探那地的奸細。',
    '創42:31 我們對他說：我們是誠實人，並不是奸細。',
    '創42:32 我們本是弟兄十二人，都是一個父親的兒子，有一個沒有了，頂小的如今同我們的父親在迦南地。',
    '創42:33 那地的主對我們說：若要我知道你們是誠實人，可以留下你們中間的一個人在我這裡，你們可以帶著糧食回去，救你們家裡的饑荒。',
    '創42:34 把你們的小兄弟帶到我這裡來，我便知道你們不是奸細，乃是誠實人。這樣，我就把你們的弟兄交給你們，你們也可以在這地做買賣。',
    '創42:35 後來他們倒口袋，不料，各人的銀包都在口袋裡；他們和父親看見銀包就都害怕。',
    '創42:36 他們的父親雅各對他們說：你們使我喪失我的兒子：約瑟沒有了，西緬也沒有了，你們又要將便雅憫帶去；這些事都歸到我身上了。',
    '創42:37 流便對他父親說：我若不帶他回來交給你，你可以殺我的兩個兒子。只管把他交在我手裡，我必帶他回來交給你。',
    '創42:38 雅各說：我的兒子不可與你們一同下去；他哥哥死了，只剩下他，他若在你們所行的路上遭害，那便是你們使我白髮蒼蒼、悲悲慘慘地下陰間去了。',
    '創43:1 那地的饑荒甚大。',
    '創43:2 他們從埃及帶來的糧食吃盡了，他們的父親就對他們說：你們再去給我糴些糧來。',
    '創43:3 猶大對他說：那人諄諄地誥誡我們說：你們的兄弟若不與你們同來，你們就不得見我的面。',
    '創43:4 你若打發我們的兄弟與我們同去，我們就下去給你糴糧；',
    '創43:5 你若不打發他去，我們就不下去，因為那人對我們說：你們的兄弟若不與你們同來，你們就不得見我的面。',
    '創43:6 以色列說：你們為什麼這樣害我，告訴那人你們還有兄弟呢﹖',
    '創43:7 他們回答說：那人詳細問到我們和我們的親屬，說：你們的父親還在嗎﹖你們還有兄弟嗎﹖我們就按著他所問的告訴他，焉能知道他要說必須把你們的兄弟帶下來呢﹖',
    '創43:8 猶大又對他父親以色列說：你打發童子與我同去，我們就起身下去，好叫我們和你，並我們的婦人孩子，都得存活，不至於死。',
    '創43:9 我為他作保；你可以從我手中追討，我若不帶他回來交在你面前，我情願永遠擔罪。',
    '創43:10 我們若沒有耽擱，如今第二次都回來了。',
    '創43:11 他們的父親以色列說：若必須如此，你們就當這樣行：可以將這地土產中最好的乳香、蜂蜜、香料、沒藥、榧子、杏仁都取一點，收在器具裡，帶下去送給那人作禮物，',
    '創43:12 又要手裡加倍地帶銀子，並將歸還在你們口袋內的銀子仍帶在手裡；那或者是錯了。',
    '創43:13 也帶著你們的兄弟，起身去見那人。',
    '創43:14 但願全能的神使你們在那人面前蒙憐憫，釋放你們的那弟兄和便雅憫回來。我若喪了兒子，就喪了吧！',
    '創43:15 於是，他們拿著那禮物，又手裡加倍地帶銀子，並且帶著便雅憫，起身下到埃及，站在約瑟面前。',
    '創43:16 約瑟見便雅憫和他們同來，就對家宰說：將這些人領到屋裡。要宰殺牲畜，預備筵席，因為晌午這些人同我吃飯。',
    '創43:17 家宰就遵著約瑟的命去行，領他們進約瑟的屋裡。',
    '創43:18 他們因為被領到約瑟的屋裡，就害怕，說：領我們到這裡來，必是因為頭次歸還在我們口袋裡的銀子，找我們的錯縫，下手害我們，強取我們為奴僕，搶奪我們的驢。',
    '創43:19 他們就挨進約瑟的家宰，在屋門口和他說話，',
    '創43:20 說：我主啊，我們頭次下來實在是要糴糧。',
    '創43:21 後來到了住宿的地方，我們打開口袋，不料，各人的銀子，分量足數，仍在各人的口袋內，現在我們手裡又帶回來了。',
    '創43:22 另外又帶下銀子來糴糧。不知道先前誰把銀子放在我們的口袋裡。',
    '創43:23 家宰說：你們可以放心，不要害怕，是你們的神和你們父親的神賜給你們財寶在你們的口袋裡；你們的銀子，我早已收了。他就把西緬帶出來，交給他們。',
    '創43:24 家宰就領他們進約瑟的屋裡，給他們水洗腳，又給他們草料餵驢。',
    '創43:25 他們就預備那禮物，等候約瑟晌午來，因為他們聽見要在那裡吃飯。',
    '創43:26 約瑟來到家裡，他們就把手中的禮物拿進屋去給他，又俯伏在地，向他下拜。',
    '創43:27 約瑟問他們好，又問：你們的父親─就是你們所說的那老人家平安嗎﹖他還在嗎﹖',
    '創43:28 他們回答說：你僕人─我們的父親平安；他還在。於是他們低頭下拜。',
    '創43:29 約瑟舉目看見他同母的兄弟便雅憫，就說：你們向我所說那頂小的兄弟就是這位嗎﹖又說：小兒啊，願神賜恩給你！',
    '創43:30 約瑟愛弟之情發動，就急忙尋找可哭之地，進入自己的屋裡，哭了一場。',
    '創43:31 他洗了臉出來，勉強隱忍，吩咐人擺飯。',
    '創43:32 他們就為約瑟單擺了一席，為那些人又擺了一席，也為和約瑟同吃飯的埃及人另擺了一席，因為埃及人不可和希伯來人一同吃飯；那原是埃及人所厭惡的。',
    '創43:33 約瑟使眾弟兄在他面前排列坐席，都按著長幼的次序，眾弟兄就彼此詫異。',
    '創43:34 約瑟把他面前的食物分出來，送給他們；但便雅憫所得的比別人多五倍。他們就飲酒，和約瑟一同宴樂。',
    '創44:1 約瑟吩咐家宰說：把糧食裝滿這些人的口袋，儘著他們的驢所能馱的，又把各人的銀子放在各人的口袋裡，',
    '創44:2 並將我的銀杯和那少年人糴糧的銀子一同裝在他的口袋裡。家宰就照約瑟所說的話行了；',
    '創44:3 天一亮就打發那些人帶著驢走了。',
    '創44:4 他們出城走了不遠，約瑟對家宰說：起來，追那些人去，追上了就對他們說：你們為什麼以惡報善呢﹖',
    '創44:5 這不是我主人飲酒的杯嗎﹖豈不是他占卜用的嗎﹖你們這樣行是作惡了。',
    '創44:6 家宰追上他們，將這些話對他們說了。',
    '創44:7 他們回答說：我主為什麼說這樣的話呢﹖你僕人斷不能做這樣的事。',
    '創44:8 你看，我們從前在口袋裡所見的銀子，尚且從迦南地帶來還你，我們怎能從你主人家裡偷竊金銀呢﹖',
    '創44:9 你僕人中無論在誰那裡搜出來，就叫他死，我們也作我主的奴僕。',
    '創44:10 家宰說：現在就照你們的話行吧！在誰那裡搜出來，誰就作我的奴僕；其餘的都沒有罪。',
    '創44:11 於是他們各人急忙把口袋卸在地下，各人打開口袋。',
    '創44:12 家宰就搜查，從年長的起到年幼的為止，那杯竟在便雅憫的口袋裡搜出來。',
    '創44:13 他們就撕裂衣服，各人把馱子擡在驢上，回城去了。',
    '創44:14 猶大和他弟兄們來到約瑟的屋中，約瑟還在那裡，他們就在他面前俯伏於地。',
    '創44:15 約瑟對他們說：你們做的是什麼事呢﹖你們豈不知像我這樣的人必能占卜嗎﹖',
    '創44:16 猶大說：我們對我主說什麼呢﹖還有什麼話可說呢﹖我們怎能自己表白出來呢﹖神已經查出僕人的罪孽了。我們與那在他手中搜出杯來的都是我主的奴僕。',
    '創44:17 約瑟說：我斷不能這樣行！在誰的手中搜出杯來，誰就作我的奴僕；至於你們，可以平平安安地上你們父親那裡去。',
    '創44:18 猶大挨近他，說：我主啊，求你容僕人說一句話給我主聽，不要向僕人發烈怒，因為你如同法老一樣。',
    '創44:19 我主曾問僕人們說：你們有父親有兄弟沒有﹖',
    '創44:20 我們對我主說：我們有父親，已經年老，還有他老年所生的一個小孩子。他哥哥死了，他母親只撇下他一人，他父親疼愛他。',
    '創44:21 你對僕人說：把他帶到我這裡來，叫我親眼看看他。',
    '創44:22 我們對我主說：童子不能離開他父親，若是離開，他父親必死。',
    '創44:23 你對僕人說：你們的小兄弟若不與你們一同下來，你們就不得再見我的面。',
    '創44:24 我們上到你僕人─我們父親那裡，就把我主的話告訴了他。',
    '創44:25 我們的父親說：你們再去給我糴些糧來。',
    '創44:26 我們就說：我們不能下去。我們的小兄弟若和我們同往，我們就可以下去。因為，小兄弟若不與我們同往，我們必不得見那人的面。',
    '創44:27 你僕人─我父親對我們說：你們知道我的妻子給我生了兩個兒子。',
    '創44:28 一個離開我出去了；我說他必是被撕碎了，直到如今我也沒有見他。',
    '創44:29 現在你們又要把這個帶去離開我，倘若他遭害，那便是你們使我白髮蒼蒼、悲悲慘慘地下陰間去了。',
    '創44:30 我父親的命與這童子的命相連。如今我回到你僕人─我父親那裡，若沒有童子與我們同在，',
    '創44:31 我們的父親見沒有童子，他就必死。這便是我們使你僕人─我們的父親白髮蒼蒼、悲悲慘慘地下陰間去了。',
    '創44:32 因為僕人曾向我父親為這童子作保，說：我若不帶他回來交給父親，我便在父親面前永遠擔罪。',
    '創44:33 現在求你容僕人住下，替這童子作我主的奴僕，叫童子和他哥哥們一同上去。',
    '創44:34 若童子不和我同去，我怎能上去見我父親呢﹖恐怕我看見災禍臨到我父親身上。',
    '創45:1 約瑟在左右站著的人面前情不自禁，吩咐一聲說：人都要離開我出去！約瑟和弟兄們相認的時候並沒有一人站在他面前。',
    '創45:2 他就放聲大哭，埃及人和法老家中的人都聽見了。',
    '創45:3 約瑟對他弟兄們說：我是約瑟。我的父親還在嗎﹖他弟兄不能回答，因為在他面前都驚惶。',
    '創45:4 約瑟又對他弟兄們說：請你們近前來。他們就近前來。他說：我是你們的兄弟約瑟，就是你們所賣到埃及的。',
    '創45:5 現在，不要因為把我賣到這裡自憂自恨。這是神差我在你們以先來，為要保全生命。',
    '創45:6 現在這地的饑荒已經二年了，還有五年不能耕種，不能收成。',
    '創45:7 神差我在你們以先來，為要給你們存留餘種在世上，又要大施拯救，保全你們的生命。',
    '創45:8 這樣看來，差我到這裡來的不是你們，乃是神。他又使我如法老的父，作他全家的主，並埃及全地的宰相。',
    '創45:9 你們要趕緊上到我父親那裡。對他說：你兒子約瑟這樣說：神使我作全埃及的主，請你下到我這裡來，不要耽延。',
    '創45:10 你和你的兒子孫子，連牛群羊群，並一切所有的，都可以住在歌珊地，與我相近。',
    '創45:11 我要在那裡奉養你；因為還有五年的饑荒，免得你和你的眷屬，並一切所有的，都敗落了。',
    '創45:12 況且你們的眼和我兄弟便雅憫的眼都看見是我親口對你們說話。',
    '創45:13 你們也要將我在埃及一切的榮耀和你們所看見的事都告訴我父親，又要趕緊地將我父親搬到我這裡來。',
    '創45:14 於是約瑟伏在他兄弟便雅憫的頸項上哭，便雅憫也在他的頸項上哭。',
    '創45:15 他又與眾弟兄親嘴，抱著他們哭，隨後他弟兄們就和他說話。',
    '創45:16 這風聲傳到法老的宮裡，說：約瑟的弟兄們來了。法老和他的臣僕都很喜歡。',
    '創45:17 法老對約瑟說：你吩咐你的弟兄們說：你們要這樣行：把馱子擡在牲口上，起身往迦南地去。',
    '創45:18 將你們的父親和你們的眷屬都搬到我這裡來，我要把埃及地的美物賜給你們，你們也要吃這地肥美的出產。',
    '創45:19 現在我吩咐你們要這樣行：從埃及地帶著車輛去，把你們的孩子和妻子，並你們的父親都搬來。',
    '創45:20 你們眼中不要愛惜你們的家具，因為埃及全地的美物都是你們的。',
    '創45:21 以色列的兒子們就如此行。約瑟照著法老的吩咐給他們車輛和路上用的食物，',
    '創45:22 又給他們各人一套衣服，惟獨給便雅憫三百銀子，五套衣服；',
    '創45:23 送給他父親公驢十匹，馱著埃及的美物，母驢十匹，馱著糧食與餅和菜，為他父親路上用。',
    '創45:24 於是約瑟打發他弟兄們回去，又對他們說：你們不要在路上相爭。',
    '創45:25 他們從埃及上去，來到迦南地、他們的父親雅各那裡，',
    '創45:26 告訴他說：約瑟還在，並且作埃及全地的宰相。雅各心裡冰涼，因為不信他們。',
    '創45:27 他們便將約瑟對他們說的一切話都告訴了他。他們父親雅各又看見約瑟打發來接他的車輛，心就甦醒了。',
    '創45:28 以色列說：罷了！罷了！我的兒子約瑟還在，趁我未死以先，我要去見他一面。',
    '創46:1 以色列帶著一切所有的，起身來到別是巴，就獻祭給他父親以撒的神。',
    '創46:2 夜間，神在異象中對以色列說：雅各！雅各！他說：我在這裡。',
    '創46:3 神說：我是神，就是你父親的神。你下埃及去不要害怕，因為我必使你在那裡成為大族。',
    '創46:4 我要和你同下埃及去，也必定帶你上來；約瑟必給你送終【原文作將手按在你的眼睛上】。',
    '創46:5 雅各就從別是巴起行。以色列的兒子們使他們的父親雅各和他們的妻子、兒女都坐在法老為雅各送來的車上。',
    '創46:6 他們又帶著迦南地所得的牲畜、貨財來到埃及。雅各和他的一切子孫都一同來了，',
    '創46:7 雅各把他的兒子、孫子、女兒、孫女，並他的子子孫孫，一同帶到埃及。',
    '創46:8 來到埃及的以色列人名字記在下面。雅各和他的兒孫：雅各的長子是流便。',
    '創46:9 流便的兒子是哈諾、法路、希斯倫、迦米。',
    '創46:10 西緬的兒子是耶母利、雅憫、阿轄、雅斤、瑣轄，還有迦南女子所生的掃羅。',
    '創46:11 利未的兒子是革順、哥轄、米拉利。',
    '創46:12 猶大的兒子是珥，俄南、示拉、法勒斯、謝拉；惟有珥與俄南死在迦南地。法勒斯的兒子是希斯倫、哈母勒。',
    '創46:13 以薩迦的兒子是陀拉、普瓦、約伯、伸崙。',
    '創46:14 西布倫的兒子是西烈、以倫、雅利。',
    '創46:15 這是利亞在巴旦亞蘭給雅各所生的兒子，還有女兒底拿。兒孫共三十三人。',
    '創46:16 迦得的兒子是洗非芸、哈基、書尼、以斯本、以利、亞羅底、亞列利。',
    '創46:17 亞設的兒子是音拿、亦施瓦、亦施韋、比利亞，還有他們的妹子西拉。比利亞的兒子是希別、瑪結。',
    '創46:18 這是拉班給他女兒利亞的婢女悉帕從雅各所生的兒孫，共有十六人。',
    '創46:19 雅各之妻拉結的兒子是約瑟和便雅憫。',
    '創46:20 約瑟在埃及地生了瑪拿西和以法蓮，就是安城的祭司波提非拉的女兒亞西納給約瑟生的。',
    '創46:21 便雅憫的兒子是比拉、比結、亞實別、基拉、乃幔、以希、羅實、母平、戶平、亞勒。',
    '創46:22 這是拉結給雅各所生的兒孫，共有十四人。',
    '創46:23 但的兒子是戶伸。',
    '創46:24 拿弗他利的兒子是雅薛、沽尼、耶色、示冷。',
    '創46:25 這是拉班給他女兒拉結的婢女辟拉從雅各所生的兒孫，共有七人。',
    '創46:26 那與雅各同到埃及的，除了他兒婦之外，凡從他所生的，共有六十六人。',
    '創46:27 還有約瑟在埃及所生的兩個兒子。雅各家來到埃及的共有七十人。',
    '創46:28 雅各打發猶大先去見約瑟，請派人引路往歌珊去；於是他們來到歌珊地。',
    '創46:29 約瑟套車往歌珊去，迎接他父親以色列，及至見了面，就伏在父親的頸項，哭了許久。',
    '創46:30 以色列對約瑟說：我既得見你的面，知道你還在，就是死我也甘心。',
    '創46:31 約瑟對他的弟兄和他父的全家說：我要上去告訴法老，對他說：我的弟兄和我父的全家從前在迦南地，現今都到我這裡來了。',
    '創46:32 他們本是牧羊的人，以養牲畜為業；他們把羊群牛群和一切所有的都帶來了。',
    '創46:33 等法老召你們的時候，問你們說：你們以何事為業﹖',
    '創46:34 你們要說：你的僕人，從幼年直到如今，都以養牲畜為業，連我們的祖宗也都以此為業。這樣，你們可以住在歌珊地，因為凡牧羊的都被埃及人所厭惡。',
    '創47:1 約瑟進去告訴法老說：我的父親和我的弟兄帶著羊群牛群，並一切所有的，從迦南地來了，如今在歌珊地。',
    '創47:2 約瑟從他弟兄中挑出五個人來，引他們去見法老。',
    '創47:3 法老問約瑟的弟兄說：你們以何事為業﹖他們對法老說：你僕人是牧羊的，連我們的祖宗也是牧羊的。',
    '創47:4 他們又對法老說：迦南地的饑荒甚大，僕人的羊群沒有草吃，所以我們來到這地寄居。現在求你容僕人住在歌珊地。',
    '創47:5 法老對約瑟說：你父親和你弟兄到你這裡來了，',
    '創47:6 埃及地都在你面前，只管叫你父親和你弟兄住在國中最好的地；他們可以住在歌珊地。你若知道他們中間有什麼能人，就派他們看管我的牲畜。',
    '創47:7 約瑟領他父親雅各進到法老面前，雅各就給法老祝福。',
    '創47:8 法老問雅各說：你平生的年日是多少呢﹖',
    '創47:9 雅各對法老說：我寄居在世的年日是一百三十歲，我平生的年日又少又苦，不及我列祖在世寄居的年日。',
    '創47:10 雅各又給法老祝福，就從法老面前出去了。',
    '創47:11 約瑟遵著法老的命，把埃及國最好的地，就是蘭塞境內的地，給他父親和弟兄居住，作為產業。',
    '創47:12 約瑟用糧食奉養他父親和他弟兄，並他父親全家的眷屬，都是照各家的人口奉養他們。',
    '創47:13 饑荒甚大，全地都絕了糧，甚至埃及地和迦南地的人因那饑荒的緣故都餓昏了。',
    '創47:14 約瑟收聚了埃及地和迦南地所有的銀子，就是眾人糴糧的銀子，約瑟就把那銀子帶到法老的宮裡。',
    '創47:15 埃及地和迦南地的銀子都花盡了，埃及眾人都來見約瑟，說：我們的銀子都用盡了，求你給我們糧食，我們為什麼死在你面前呢﹖',
    '創47:16 約瑟說：若是銀子用盡了，可以把你們的牲畜給我，我就為你們的牲畜給你們糧食。',
    '創47:17 於是他們把牲畜趕到約瑟那裡，約瑟就拿糧食換了他們的牛、羊、驢、馬；那一年因換他們一切的牲畜，就用糧食養活他們。',
    '創47:18 那一年過去，第二年他們又來見約瑟，說：我們不瞞我主，我們的銀子都花盡了，牲畜也都歸了我主。我們在我主眼前，除了我們的身體和田地之外，一無所剩。',
    '創47:19 你何忍見我們人死地荒呢﹖求你用糧食買我們和我們的地，我們和我們的地就要給法老效力。又求你給我們種子，使我們得以存活，不致死亡，地土也不致荒涼。',
    '創47:20 於是，約瑟為法老買了埃及所有的地，埃及人因被饑荒所迫，各都賣了自己的田地；那地就都歸了法老。',
    '創47:21 至於百姓，約瑟叫他們，從埃及這邊直到埃及那邊，都各歸各城。',
    '創47:22 惟有祭司的地，約瑟沒有買，因為祭司有從法老所得的常俸。他們吃法老所給的常俸，所以他們不賣自己的地。',
    '創47:23 約瑟對百姓說：我今日為法老買了你們和你們的地，看哪，這裡有種子給你們，你們可以種地。',
    '創47:24 後來打糧食的時候，你們要把五分之一納給法老，四分可以歸你們做地裡的種子，也做你們和你們家口孩童的食物。',
    '創47:25 他們說：你救了我們的性命。但願我們在我主眼前蒙恩，我們就作法老的僕人。',
    '創47:26 於是約瑟為埃及地定下常例，直到今日：法老必得五分之一，惟獨祭司的地不歸法老。',
    '創47:27 以色列人住在埃及的歌珊地。他們在那裡置了產業，並且生育甚多。',
    '創47:28 雅各住在埃及地十七年，雅各平生的年日是一百四十七歲。',
    '創47:29 以色列的死期臨近了，他就叫了他兒子約瑟來，說：我若在你眼前蒙恩，請你把手放在我大腿底下，用慈愛和誠實待我，請你不要將我葬在埃及。',
    '創47:30 我與我祖我父同睡的時候，你要將我帶出埃及，葬在他們所葬的地方。約瑟說：我必遵著你的命而行。',
    '創47:31 雅各說：你要向我起誓。約瑟就向他起了誓，於是以色列在床頭上【或作扶著杖頭】敬拜神。',
    '創48:1 這事以後，有人告訴約瑟說：你的父親病了。他就帶著兩個兒子瑪拿西和以法蓮同去。',
    '創48:2 有人告訴雅各說：請看，你兒子約瑟到你這裡來了。以色列就勉強在床上坐起來。',
    '創48:3 雅各對約瑟說：全能的神曾在迦南地的路斯向我顯現，賜福與我，',
    '創48:4 對我說：我必使你生養眾多，成為多民，又要把這地賜給你的後裔，永遠為業。',
    '創48:5 我未到埃及見你之先，你在埃及地所生的以法蓮和瑪拿西這兩個兒子是我的，正如流便和西緬是我的一樣。',
    '創48:6 你在他們以後所生的就是你的，他們可以歸於他們弟兄的名下得產業。',
    '創48:7 至於我，我從巴旦來的時候，拉結死在我眼前，在迦南地的路上，離以法他還有一段路程，我就把他葬在以法他的路上（以法他就是伯利恆）。',
    '創48:8 以色列看見約瑟的兩個兒子，就說：這是誰﹖',
    '創48:9 約瑟對他父親說：這是神在這裡賜給我的兒子。以色列說：請你領他們到我跟前，我要給他們祝福。',
    '創48:10 以色列年紀老邁，眼睛昏花，不能看見。約瑟領他們到他跟前，他就和他們親嘴，抱著他們。',
    '創48:11 以色列對約瑟說：我想不到得見你的面，不料，神又使我得見你的兒子。',
    '創48:12 約瑟把兩個兒子從以色列兩膝中領出來，自己就臉伏於地下拜。',
    '創48:13 隨後，約瑟又拉著他們兩個，以法蓮在他的右手裡，對著以色列的左手，瑪拿西在他的左手裡，對著以色列的右手，領他們到以色列的跟前。',
    '創48:14 以色列伸出右手來，按在以法蓮的頭上（以法蓮乃是次子），又剪搭過左手來，按在瑪拿西的頭上（瑪拿西原是長子）。',
    '創48:15 他就給約瑟祝福說：願我祖亞伯拉罕和我父以撒所事奉的神，就是一生牧養我直到今日的神，',
    '創48:16 救贖我脫離一切患難的那使者，賜福與這兩個童子。願他們歸在我的名下和我祖亞伯拉罕、我父以撒的名下。又願他們在世界中生養眾多。',
    '創48:17 約瑟見他父親把右手按在以法蓮的頭上，就不喜悅，便提起他父親的手，要從以法蓮頭上挪到瑪拿西的頭上。',
    '創48:18 約瑟對他父親說：我父，不是這樣。這本是長子，求你把右手按在他的頭上。',
    '創48:19 他父親不從，說：我知道，我兒，我知道。他也必成為一族，也必昌大。只是他的兄弟將來比他還大；他兄弟的後裔要成為多族。',
    '創48:20 當日就給他們祝福說：以色列人要指著你們祝福說：願神使你如以法蓮、瑪拿西一樣。於是立以法蓮在瑪拿西以上。',
    '創48:21 以色列又對約瑟說：我要死了，但神必與你們同在，領你們回到你們列祖之地。',
    '創48:22 並且我從前用弓用刀從亞摩利人手下奪的那塊地，我都賜給你，使你比眾弟兄多得一分。',
    '創49:1 雅各叫了他的兒子們來，說：你們都來聚集，我好把你們日後必遇的事告訴你們。',
    '創49:2 雅各的兒子們，你們要聚集而聽，要聽你們父親以色列的話。',
    '創49:3 流便哪，你是我的長子，是我力量強壯的時候生的，本當大有尊榮，權力超眾。',
    '創49:4 但你放縱情慾，滾沸如水，必不得居首位；因為你上了你父親的床，污穢了我的榻。',
    '創49:5 西緬和利未是弟兄；他們的刀劍是殘忍的器具。',
    '創49:6 我的靈啊，不要與他們同謀；我的心哪，不要與他們聯絡；因為他們趁怒殺害人命，任意砍斷牛腿大筋。',
    '創49:7 他們的怒氣暴烈可咒；他們的忿恨殘忍可詛。我要使他們分居在雅各家裡，散住在以色列地中。',
    '創49:8 猶大啊，你弟兄們必讚美你；你手必掐住仇敵的頸項；你父親的兒子們必向你下拜。',
    '創49:9 猶大是個小獅子；我兒啊，你抓了食便上去。你屈下身去，臥如公獅，蹲如母獅，誰敢惹你﹖',
    '創49:10 圭必不離猶大，杖必不離他兩腳之間，直等細羅【就是賜平安者】來到，萬民都必歸順。',
    '創49:11 猶大把小驢拴在葡萄樹上，把驢駒拴在美好的葡萄樹上。他在葡萄酒中洗了衣服，在葡萄汁中洗了袍褂。',
    '創49:12 他的眼睛必因酒紅潤；他的牙齒必因奶白亮。',
    '創49:13 西布倫必住在海口，必成為停船的海口；他的境界必延到西頓。',
    '創49:14 以薩迦是個強壯的驢，臥在羊圈之中。',
    '創49:15 他以安靜為佳，以肥地為美，便低肩背重，成為服苦的僕人。',
    '創49:16 但必判斷他的民，作以色列支派之一。',
    '創49:17 但必作道上的蛇，路中的虺，咬傷馬蹄，使騎馬的墜落於後。',
    '創49:18 耶和華啊，我向來等候你的救恩。',
    '創49:19 迦得必被敵軍追逼，他卻要追逼他們的腳跟。',
    '創49:20 亞設之地必出肥美的糧食，且出君王的美味。',
    '創49:21 拿弗他利是被釋放的母鹿；他出嘉美的言語。',
    '創49:22 約瑟是多結果子的樹枝，是泉旁多結果的枝子；他的枝條探出牆外。',
    '創49:23 弓箭手將他苦害，向他射箭，逼迫他。',
    '創49:24 但他的弓仍舊堅硬；他的手健壯敏捷。這是因以色列的牧者，以色列的磐石─就是雅各的大能者。',
    '創49:25 你父親的神必幫助你；那全能者必將天上所有的福，地裡所藏的福，以及生產乳養的福，都賜給你。',
    '創49:26 你父親所祝的福，勝過我祖先所祝的福，如永世的山嶺，至極的邊界；這些福必降在約瑟的頭上，臨到那與弟兄迥別之人的頂上。',
    '創49:27 便雅憫是個撕掠的狼，早晨要吃他所抓的，晚上要分他所奪的。',
    '創49:28 這一切是以色列的十二支派；這也是他們的父親對他們所說的話，為他們所祝的福，都是按著各人的福分為他們祝福。',
    '創49:29 他又囑咐他們說：我將要歸到我列祖【原文作本民】那裡，你們要將我葬在赫人以弗崙田間的洞裡，與我祖我父在一處，',
    '創49:30 就是在迦南地幔利前、麥比拉田間的洞；那洞和田是亞伯拉罕向赫人以弗崙買來為業，作墳地的。',
    '創49:31 他們在那裡葬了亞伯拉罕和他妻撒拉，又在那裡葬了以撒和他的妻子利百加；我也在那裡葬了利亞。',
    '創49:32 那塊田和田間的洞原是向赫人買的。',
    '創49:33 雅各囑咐眾子已畢，就把腳收在床上，氣絕而死，歸他列祖【原文作本民】那裡去了。',
    '創50:1 約瑟伏在他父親的面上哀哭，與他親嘴。',
    '創50:2 約瑟吩咐伺候他的醫生用香料薰他父親，醫生就用香料薰了以色列。',
    '創50:3 薰屍的常例是四十天；那四十天滿了，埃及人為他哀哭了七十天。',
    '創50:4 為他哀哭的日子過了，約瑟對法老家中的人說：我若在你們眼前蒙恩，請你們報告法老說：',
    '創50:5 我父親要死的時候叫我起誓說：你要將我葬在迦南地，在我為自己所掘的墳墓裡。現在求你讓我上去葬我父親，以後我必回來。',
    '創50:6 法老說：你可以上去，照著你父親叫你起的誓，將他葬埋。',
    '創50:7 於是約瑟上去葬他父親。與他一同上去的，有法老的臣僕和法老家中的長老，並埃及國的長老，',
    '創50:8 還有約瑟的全家和他的弟兄們，並他父親的眷屬；只有他們的婦人孩子，和羊群牛群，都留在歌珊地。',
    '創50:9 又有車輛馬兵，和他一同上去；那一幫人甚多。',
    '創50:10 他們到了約但河外、亞達的禾場，就在那裡大大地號咷痛哭。約瑟為他父親哀哭了七天。',
    '創50:11 迦南的居民見亞達禾場上的哀哭，就說：這是埃及人一場極大的哀哭。因此那地方名叫亞伯麥西，是在約但河東。',
    '創50:12 雅各的兒子們就遵著他父親所吩咐的辦了，',
    '創50:13 把他搬到迦南地，葬在幔利前、麥比拉田間的洞裡；那洞和田是亞伯拉罕向赫人以弗崙買來為業，作墳地的。',
    '創50:14 約瑟葬了他父親以後，就和眾弟兄，並一切同他上去葬他父親的人，都回埃及去了。',
    '創50:15 約瑟的哥哥們見父親死了，就說：或者約瑟懷恨我們，照著我們從前待他一切的惡足足地報復我們。',
    '創50:16 他們就打發人去見約瑟，說：你父親未死以先吩咐說：',
    '創50:17 你們要對約瑟這樣說：從前你哥哥們惡待你，求你饒恕他們的過犯和罪惡。如今求你饒恕你父親神之僕人的過犯。他們對約瑟說這話，約瑟就哭了。',
    '創50:18 他的哥哥們又來俯伏在他面前，說：我們是你的僕人。',
    '創50:19 約瑟對他們說：不要害怕，我豈能代替神呢﹖',
    '創50:20 從前你們的意思是要害我，但神的意思原是好的，要保全許多人的性命，成就今日的光景。',
    '創50:21 現在你們不要害怕，我必養活你們和你們的婦人孩子。於是約瑟用親愛的話安慰他們。',
    '創50:22 約瑟和他父親的眷屬都住在埃及。約瑟活了一百一十歲。',
    '創50:23 約瑟得見以法蓮第三代的子孫。瑪拿西的孫子、瑪吉的兒子也養在約瑟的膝上。',
    '創50:24 約瑟對他弟兄們說：我要死了，但神必定看顧你們，領你們從這地上去，到他起誓所應許給亞伯拉罕、以撒、雅各之地。',
    '創50:25 約瑟叫以色列的子孫起誓說：神必定看顧你們；你們要把我的骸骨從這裡搬上去。',
    '創50:26 約瑟死了，正一百一十歲。人用香料將他薰了，把他收殮在棺材裡，停在埃及。',
    '出1:1 以色列的眾子，各帶家眷，和雅各一同來到埃及。他們的名字記在下面。',
    '出1:2 有流便、西緬、利未、猶大、',
    '出1:3 以薩迦、西布倫、便雅憫、',
    '出1:4 但、拿弗他利、迦得、亞設。',
    '出1:5 凡從雅各而生的，共有七十人。約瑟已經在埃及。',
    '出1:6 約瑟和他的弟兄，並那一代的人，都死了。',
    '出1:7 以色列人生養眾多，並且繁茂，極其強盛，滿了那地。',
    '出1:8 有不認識約瑟的新王起來，治理埃及，',
    '出1:9 對他的百姓說：看哪，這以色列民比我們還多，又比我們強盛。',
    '出1:10 來吧，我們不如用巧計待他們，恐怕他們多起來，日後若遇什麼爭戰的事，就連合我們的仇敵攻擊我們，離開這地去了。',
    '出1:11 於是埃及人派督工的轄制他們，加重擔苦害他們。他們為法老建造兩座積貨城，就是比東和蘭塞。',
    '出1:12 只是越發苦害他們，他們越發多起來，越發蔓延；埃及人就因以色列人愁煩。',
    '出1:13 埃及人嚴嚴地使以色列人做工，',
    '出1:14 使他們因做苦工覺得命苦；無論是和泥，是做磚，是做田間各樣的工，在一切的工上都嚴嚴地待他們。',
    '出1:15 有希伯來的兩個收生婆，一名施弗拉，一名普阿；埃及王對他們說：',
    '出1:16 你們為希伯來婦人收生，看他們臨盆的時候，若是男孩，就把他殺了；若是女孩，就留他存活。',
    '出1:17 但是收生婆敬畏神，不照埃及王的吩咐行，竟存留男孩的性命。',
    '出1:18 埃及王召了收生婆來，說：你們為什麼做這事，存留男孩的性命呢﹖',
    '出1:19 收生婆對法老說：因為希伯來婦人與埃及婦人不同；希伯來婦人本是健壯的（原文作活潑的），收生婆還沒有到，他們已經生產了。',
    '出1:20 神厚待收生婆。以色列人多起來，極其強盛。',
    '出1:21 收生婆因為敬畏神，神便叫他們成立家室。',
    '出1:22 法老吩咐他的眾民說：以色列人所生的男孩，你們都要丟在河裡；一切的女孩，你們要存留他的性命。',
    '出2:1 有一個利未家的人娶了一個利未女子為妻。',
    '出2:2 那女人懷孕，生一個兒子，見他俊美，就藏了他三個月，',
    '出2:3 後來不能再藏，就取了一個蒲草箱，抹上石漆和石油，將孩子放在裡頭，把箱子擱在河邊的蘆荻中。',
    '出2:4 孩子的姊姊遠遠站著，要知道他究竟怎麼樣。',
    '出2:5 法老的女兒來到河邊洗澡，他的使女們在河邊行走。他看見箱子在蘆荻中，就打發一個婢女拿來。',
    '出2:6 他打開箱子，看見那孩子。孩子哭了，他就可憐他，說：這是希伯來人的一個孩子。',
    '出2:7 孩子的姊姊對法老的女兒說：我去在希伯來婦人中叫一個奶媽來，為你奶這孩子，可以不可以﹖',
    '出2:8 法老的女兒說：可以。童女就去叫了孩子的母親來。',
    '出2:9 法老的女兒對他說：你把這孩子抱去，為我奶他，我必給你工價。婦人就抱了孩子去奶他。',
    '出2:10 孩子漸長，婦人把他帶到法老的女兒那裡，就作了他的兒子。他給孩子起名叫摩西，意思說：因我把他從水裡拉出來。',
    '出2:11 後來，摩西長大，他出去到他弟兄那裡，看他們的重擔，見一個埃及人打希伯來人的一個弟兄。',
    '出2:12 他左右觀看，見沒有人，就把埃及人打死了，藏在沙土裡。',
    '出2:13 第二天他出去，見有兩個希伯來人爭鬥，就對那欺負人的說：你為什麼打你同族的人呢﹖',
    '出2:14 那人說：誰立你作我們的首領和審判官呢﹖難道你要殺我，像殺那埃及人嗎﹖摩西便懼怕，說：這事必是被人知道了。',
    '出2:15 法老聽見這事，就想殺摩西，但摩西躲避法老，逃往米甸地居住。',
    '出2:16 一日，他在井旁坐下。米甸的祭司有七個女兒；他們來打水，打滿了槽，要飲父親的群羊。',
    '出2:17 有牧羊的人來，把他們趕走了，摩西卻起來幫助他們，又飲了他們的群羊。',
    '出2:18 他們來到父親流珥那裡；他說：今日你們為何來得這麼快呢﹖',
    '出2:19 他們說：有一個埃及人救我們脫離牧羊人的手，並且為我們打水飲了群羊。',
    '出2:20 他對女兒們說：那個人在哪裡﹖你們為什麼撇下他呢﹖你們去請他來吃飯。',
    '出2:21 摩西甘心和那人同住；那人把他的女兒西坡拉給摩西為妻。',
    '出2:22 西坡拉生了一個兒子，摩西給他起名叫革舜，意思說：因我在外邦作了寄居的。',
    '出2:23 過了多年，埃及王死了。以色列人因做苦工，就歎息哀求，他們的哀聲達於神。',
    '出2:24 神聽見他們的哀聲，就記念他與亞伯拉罕、以撒、雅各所立的約。',
    '出2:25 神看顧以色列人，也知道他們的苦情。',
    '出3:1 摩西牧養他岳父米甸祭司葉忒羅的羊群；一日領羊群往野外去，到了神的山，就是何烈山。',
    '出3:2 耶和華的使者從荊棘裡火焰中向摩西顯現。摩西觀看，不料，荊棘被火燒著，卻沒有燒毀。',
    '出3:3 摩西說：我要過去看這大異象，這荊棘為何沒有燒壞呢﹖',
    '出3:4 耶和華神見他過去要看，就從荊棘裡呼叫說：摩西！摩西！他說：我在這裡。',
    '出3:5 神說：不要近前來。當把你腳上的鞋脫下來，因為你所站之地是聖地；',
    '出3:6 又說：我是你父親的神，是亞伯拉罕的神，以撒的神，雅各的神。摩西蒙上臉，因為怕看神。',
    '出3:7 耶和華說：我的百姓在埃及所受的困苦，我實在看見了；他們因受督工的轄制所發的哀聲，我也聽見了。我原知道他們的痛苦，',
    '出3:8 我下來是要救他們脫離埃及人的手，領他們出了那地，到美好、寬闊、流奶與蜜之地，就是到迦南人、赫人、亞摩利人、比利洗人、希未人、耶布斯人之地。',
    '出3:9 現在以色列人的哀聲達到我耳中，我也看見埃及人怎樣欺壓他們。',
    '出3:10 故此，我要打發你去見法老，使你可以將我的百姓以色列人從埃及領出來。',
    '出3:11 摩西對神說：我是什麼人，竟能去見法老，將以色列人從埃及領出來呢﹖',
    '出3:12 神說：我必與你同在。你將百姓從埃及領出來之後，你們必在這山上事奉我；這就是我打發你去的證據。',
    '出3:13 摩西對神說：我到以色列人那裡，對他們說：你們祖宗的神打發我到你們這裡來。他們若問我說：他叫什麼名字﹖我要對他們說什麼呢﹖',
    '出3:14 神對摩西說：我是自有永有的；又說：你要對以色列人這樣說：那自有的打發我到你們這裡來。',
    '出3:15 神又對摩西說：你要對以色列人這樣說：耶和華─你們祖宗的神，就是亞伯拉罕的神，以撒的神，雅各的神，打發我到你們這裡來。耶和華是我的名，直到永遠；這也是我的記念，直到萬代。',
    '出3:16 你去招聚以色列的長老，對他們說：耶和華你們祖宗的神，就是亞伯拉罕的神，以撒的神，雅各的神，向我顯現，說：我實在眷顧了你們，我也看見埃及人怎樣待你們。',
    '出3:17 我也說：要將你們從埃及的困苦中領出來，往迦南人、赫人、亞摩利人、比利洗人、希未人、耶布斯人的地去，就是到流奶與蜜之地。',
    '出3:18 他們必聽你的話。你和以色列的長老要去見埃及王，對他說：耶和華希伯來人的神遇見了我們，現在求你容我們往曠野去，走三天的路程，為要祭祀耶和華我們的神。',
    '出3:19 我知道雖用大能的手，埃及王也不容你們去。',
    '出3:20 我必伸手在埃及中間施行我一切的奇事，攻擊那地，然後他才容你們去。',
    '出3:21 我必叫你們在埃及人眼前蒙恩，你們去的時候就不至於空手而去。',
    '出3:22 但各婦女必向他的鄰舍，並居住在他家裡的女人，要金器銀器和衣裳，好給你們的兒女穿戴。這樣你們就把埃及人的財物奪去了。',
    '出4:1 摩西回答說：他們必不信我，也不聽我的話，必說：耶和華並沒有向你顯現。',
    '出4:2 耶和華對摩西說：你手裡是什麼﹖他說：是杖。',
    '出4:3 耶和華說：丟在地上。他一丟下去，就變作蛇；摩西便跑開。',
    '出4:4 耶和華對摩西說：伸出手來，拿住他的尾巴，他必在你手中仍變為杖；',
    '出4:5 如此好叫他們信耶和華─他們祖宗的神，就是亞伯拉罕的神，以撒的神，雅各的神，是向你顯現了。',
    '出4:6 耶和華又對他說：把手放在懷裡。他就把手放在懷裡，及至抽出來，不料，手長了大痲瘋，有雪那樣白。',
    '出4:7 耶和華說：再把手放在懷裡。他就再把手放在懷裡，及至從懷裡抽出來，不料，手已經復原，與周身的肉一樣；',
    '出4:8 又說：倘或他們不聽你的話，也不信頭一個神蹟，他們必信第二個神蹟。',
    '出4:9 這兩個神蹟若都不信，也不聽你的話，你就從河裡取些水，倒在旱地上，你從河裡取的水必在旱地上變作血。',
    '出4:10 摩西對耶和華說：主啊，我素日不是能言的人，就是從你對僕人說話以後，也是這樣。我本是拙口笨舌的。',
    '出4:11 耶和華對他說：誰造人的口呢﹖誰使人口啞、耳聾、目明、眼瞎呢﹖豈不是我─耶和華嗎﹖',
    '出4:12 現在去吧，我必賜你口才，指教你所當說的話。',
    '出4:13 摩西說：主啊，你願意打發誰，就打發誰去吧！',
    '出4:14 耶和華向摩西發怒說：不是有你的哥哥利未人亞倫嗎﹖我知道他是能言的；現在他出來迎接你，他一見你，心裡就歡喜。',
    '出4:15 你要將當說的話傳給他；我也要賜你和他口才，又要指教你們所當行的事。',
    '出4:16 他要替你對百姓說話；你要以他當作口，他要以你當作神。',
    '出4:17 你手裡要拿這杖，好行神蹟。',
    '出4:18 於是，摩西回到他岳父葉忒羅那裡，對他說：求你容我回去見我在埃及的弟兄，看他們還在不在。葉忒羅對摩西說：你可以平平安安地去吧！',
    '出4:19 耶和華在米甸對摩西說：你要回埃及去，因為尋索你命的人都死了。',
    '出4:20 摩西就帶著妻子和兩個兒子，叫他們騎上驢，回埃及地去。摩西手裡拿著神的杖。',
    '出4:21 耶和華對摩西說：你回到埃及的時候，要留意將我指示你的一切奇事行在法老面前。但我要使（或作：任憑；下同）他的心剛硬，他必不容百姓去。',
    '出4:22 你要對法老說：耶和華這樣說：以色列是我的兒子，我的長子。',
    '出4:23 我對你說過：容我的兒子去，好事奉我。你還是不肯容他去。看哪，我要殺你的長子。',
    '出4:24 摩西在路上住宿的地方，耶和華遇見他，想要殺他。',
    '出4:25 西坡拉就拿一塊火石，割下他兒子的陽皮，丟在摩西腳前，說：你真是我的血郎了。',
    '出4:26 這樣，耶和華才放了他。西坡拉說：你因割禮就是血郎了。',
    '出4:27 耶和華對亞倫說：你往曠野去迎接摩西。他就去，在神的山遇見摩西，和他親嘴。',
    '出4:28 摩西將耶和華打發他所說的言語和囑咐他所行的神蹟都告訴了亞倫。',
    '出4:29 摩西、亞倫就去招聚以色列的眾長老。',
    '出4:30 亞倫將耶和華對摩西所說的一切話述說了一遍，又在百姓眼前行了那些神蹟，',
    '出4:31 百姓就信了。以色列人聽見耶和華眷顧他們，鑒察他們的困苦，就低頭下拜。',
    '出5:1 後來摩西、亞倫去對法老說：耶和華─以色列的神這樣說：容我的百姓去，在曠野向我守節。',
    '出5:2 法老說：耶和華是誰，使我聽他的話，容以色列人去呢﹖我不認識耶和華，也不容以色列人去！',
    '出5:3 他們說：希伯來人的神遇見了我們。求你容我們往曠野去，走三天的路程，祭祀耶和華─我們的神，免得他用瘟疫、刀兵攻擊我們。',
    '出5:4 埃及王對他們說：摩西、亞倫！你們為什麼叫百姓曠工呢﹖你們去擔你們的擔子吧！',
    '出5:5 又說：看哪，這地的以色列人如今眾多，你們竟叫他們歇下擔子！',
    '出5:6 當天，法老吩咐督工的和官長說：',
    '出5:7 你們不可照常把草給百姓做磚，叫他們自己去撿草。',
    '出5:8 他們素常做磚的數目，你們仍舊向他們要，一點不可減少；因為他們是懶惰的，所以呼求說：容我們去祭祀我們的神。',
    '出5:9 你們要把更重的工夫加在這些人身上，叫他們勞碌，不聽虛謊的言語。',
    '出5:10 督工的和官長出來對百姓說：法老這樣說：我不給你們草。',
    '出5:11 你們自己在哪裡能找草，就往那裡去找吧！但你們的工一點不可減少。',
    '出5:12 於是百姓散在埃及遍地，撿碎稭當作草。',
    '出5:13 督工的催著說：你們一天當完一天的工，與先前有草一樣。',
    '出5:14 法老督工的，責打他所派以色列人的官長，說：你們昨天今天為什麼沒有照向來的數目做磚、完你們的工作呢﹖',
    '出5:15 以色列人的官長就來哀求法老說：為什麼這樣待你的僕人﹖',
    '出5:16 督工的不把草給僕人，並且對我們說：做磚吧！看哪，你僕人挨了打，其實是你百姓的錯。',
    '出5:17 但法老說：你們是懶惰的！你們是懶惰的！所以說：容我們去祭祀耶和華。',
    '出5:18 現在你們去做工吧！草是不給你們的，磚卻要如數交納。',
    '出5:19 以色列人的官長聽說你們每天做磚的工作一點不可減少，就知道是遭遇禍患了。',
    '出5:20 他們離了法老出來，正遇見摩西、亞倫站在對面，',
    '出5:21 就向他們說：願耶和華鑒察你們，施行判斷；因你們使我們在法老和他臣僕面前有了臭名，把刀遞在他們手中殺我們。',
    '出5:22 摩西回到耶和華那裡，說：主啊，你為什麼苦待這百姓呢﹖為什麼打發我去呢﹖',
    '出5:23 自從我去見法老，奉你的名說話，他就苦待這百姓，你一點也沒有拯救他們。',
    '出6:1 耶和華對摩西說：現在你必看見我向法老所行的事，使他因我大能的手容以色列人去，且把他們趕出他的地。',
    '出6:2 神曉諭摩西說：我是耶和華。',
    '出6:3 我從前向亞伯拉罕、以撒、雅各顯現為全能的神；至於我名耶和華，他們未曾知道。',
    '出6:4 我與他們堅定所立的約，要把他們寄居的迦南地賜給他們。',
    '出6:5 我也聽見以色列人被埃及人苦待的哀聲，我也記念我的約。',
    '出6:6 所以你要對以色列人說：我是耶和華；我要用伸出來的膀臂重重地刑罰埃及人，救贖你們脫離他們的重擔，不做他們的苦工。',
    '出6:7 我要以你們為我的百姓，我也要作你們的神。你們要知道我是耶和華─你們的神，是救你們脫離埃及人之重擔的。',
    '出6:8 我起誓應許給亞伯拉罕、以撒、雅各的那地，我要把你們領進去，將那地賜給你們為業。我是耶和華。',
    '出6:9 摩西將這話告訴以色列人，只是他們因苦工愁煩，不肯聽他的話。',
    '出6:10 耶和華曉諭摩西說：',
    '出6:11 你進去對埃及王法老說，要容以色列人出他的地。',
    '出6:12 摩西在耶和華面前說：以色列人尚且不聽我的話，法老怎肯聽我這拙口笨舌的人呢﹖',
    '出6:13 耶和華吩咐摩西、亞倫往以色列人和埃及王法老那裡去，把以色列人從埃及地領出來。',
    '出6:14 以色列人家長的名字記在下面。以色列長子流便的兒子是哈諾、法路、希斯崙、迦米；這是流便的各家。',
    '出6:15 西緬的兒子是耶母利、雅憫、阿轄、雅斤、瑣轄，和迦南女子的兒子掃羅；這是西緬的各家。',
    '出6:16 利未眾子的名字按著他們的後代記在下面：就是革順、哥轄、米拉利。利未一生的歲數是一百三十七歲。',
    '出6:17 革順的兒子按著家室是立尼、示每。',
    '出6:18 哥轄的兒子是暗蘭、以斯哈、希伯倫、烏薛。哥轄一生的歲數是一百三十三歲。',
    '出6:19 米拉利的兒子是抹利和母示；這是利未的家，都按著他們的後代。',
    '出6:20 暗蘭娶了他父親的妹妹約基別為妻，他給他生了亞倫和摩西。暗蘭一生的歲數是一百三十七歲。',
    '出6:21 以斯哈的兒子是可拉、尼斐、細基利。',
    '出6:22 烏薛的兒子是米沙利、以利撒反、西提利。',
    '出6:23 亞倫娶了亞米拿達的女兒，拿順的妹妹，以利沙巴為妻，他給他生了拿答、亞比戶、以利亞撒、以他瑪。',
    '出6:24 可拉的兒子是亞惜、以利加拿、亞比亞撒；這是可拉的各家。',
    '出6:25 亞倫的兒子以利亞撒娶了普鐵的一個女兒為妻，他給他生了非尼哈。這是利未人的家長，都按著他們的家。',
    '出6:26 耶和華說：將以色列人按著他們的軍隊從埃及地領出來。這是對那亞倫、摩西說的。',
    '出6:27 對埃及王法老說要將以色列人從埃及領出來的，就是這摩西、亞倫。',
    '出6:28 當耶和華在埃及地對摩西說話的日子，',
    '出6:29 他向摩西說：我是耶和華；我對你說的一切話，你都要告訴埃及王法老。',
    '出6:30 摩西在耶和華面前說：看哪，我是拙口笨舌的人，法老怎肯聽我呢﹖',
    '出7:1 耶和華對摩西說：我使你在法老面前代替神，你的哥哥亞倫是替你說話的。',
    '出7:2 凡我所吩咐你的，你都要說。你的哥哥亞倫要對法老說，容以色列人出他的地。',
    '出7:3 我要使法老的心剛硬，也要在埃及地多行神蹟奇事。',
    '出7:4 但法老必不聽你們；我要伸手重重地刑罰埃及，將我的軍隊以色列民從埃及地領出來。',
    '出7:5 我伸手攻擊埃及，將以色列人從他們中間領出來的時候，埃及人就要知道我是耶和華。',
    '出7:6 摩西、亞倫這樣行；耶和華怎樣吩咐他們，他們就照樣行了。',
    '出7:7 摩西、亞倫與法老說話的時候，摩西八十歲，亞倫八十三歲。',
    '出7:8 耶和華曉諭摩西、亞倫說：',
    '出7:9 法老若對你們說：你們行件奇事吧！你就吩咐亞倫說：把杖丟在法老面前，使杖變作蛇。',
    '出7:10 摩西、亞倫進去見法老，就照耶和華所吩咐的行。亞倫把杖丟在法老和臣僕面前，杖就變作蛇。',
    '出7:11 於是法老召了博士和術士來；他們是埃及行法術的，也用邪術照樣而行。',
    '出7:12 他們各人丟下自己的杖，杖就變作蛇；但亞倫的杖吞了他們的杖。',
    '出7:13 法老心裡剛硬，不肯聽從摩西、亞倫，正如耶和華所說的。',
    '出7:14 耶和華對摩西說：法老心裡固執，不肯容百姓去。',
    '出7:15 明日早晨，他出來往水邊去，你要往河邊迎接他，手裡要拿著那變過蛇的杖，',
    '出7:16 對他說：耶和華─希伯來人的神打發我來見你，說：容我的百姓去，好在曠野事奉我。到如今你還是不聽。',
    '出7:17 耶和華這樣說：我要用我手裡的杖擊打河中的水，水就變作血；因此，你必知道我是耶和華。',
    '出7:18 河裡的魚必死，河也要腥臭，埃及人就要厭惡吃這河裡的水。',
    '出7:19 耶和華曉諭摩西說：你對亞倫說：把你的杖伸在埃及所有的水以上，就是在他們的江、河、池、塘以上，叫水都變作血。在埃及遍地，無論在木器中，石器中，都必有血。',
    '出7:20 摩西、亞倫就照耶和華所吩咐的行。亞倫在法老和臣僕眼前舉杖擊打河裡的水，河裡的水都變作血了。',
    '出7:21 河裡的魚死了，河也腥臭了，埃及人就不能吃這河裡的水；埃及遍地都有了血。',
    '出7:22 埃及行法術的，也用邪術照樣而行。法老心裡剛硬，不肯聽摩西、亞倫，正如耶和華所說的。',
    '出7:23 法老轉身進宮，也不把這事放在心上。',
    '出7:24 埃及人都在河的兩邊挖地，要得水喝，因為他們不能喝這河裡的水。',
    '出7:25 耶和華擊打河以後滿了七天。',
    '出8:1 耶和華吩咐摩西說：你進去見法老，對他說：耶和華這樣說：容我的百姓去，好事奉我。',
    '出8:2 你若不肯容他們去，我必使青蛙蹧蹋你的四境。',
    '出8:3 河裡要滋生青蛙；這青蛙要上來進你的宮殿和你的臥房，上你的床榻，進你臣僕的房屋，上你百姓的身上，進你的爐竈和你的摶麵盆，',
    '出8:4 又要上你和你百姓並你眾臣僕的身上。',
    '出8:5 耶和華曉諭摩西說：你對亞倫說：把你的杖伸在江、河、池以上，使青蛙到埃及地上來。',
    '出8:6 亞倫便伸杖在埃及的諸水以上，青蛙就上來，遮滿了埃及地。',
    '出8:7 行法術的也用他們的邪術照樣而行，叫青蛙上了埃及地。',
    '出8:8 法老召了摩西、亞倫來，說：請你們求耶和華使這青蛙離開我和我的民，我就容百姓去祭祀耶和華。',
    '出8:9 摩西對法老說：任憑你吧，我要何時為你和你的臣僕並你的百姓祈求，除滅青蛙離開你和你的宮殿只留在河裡呢﹖',
    '出8:10 他說：明天。摩西說：可以照你的話吧，好叫你知道沒有像耶和華─我們神的。',
    '出8:11 青蛙要離開你和你的宮殿，並你的臣僕與你的百姓，只留在河裡。',
    '出8:12 於是摩西、亞倫離開法老出去。摩西為擾害法老的青蛙呼求耶和華。',
    '出8:13 耶和華就照摩西的話行。凡在房裡、院中、田間的青蛙都死了。',
    '出8:14 眾人把青蛙聚攏成堆，遍地就都腥臭。',
    '出8:15 但法老見災禍鬆緩，就硬著心，不肯聽他們，正如耶和華所說的。',
    '出8:16 耶和華吩咐摩西說：你對亞倫說：伸出你的杖擊打地上的塵土，使塵土在埃及遍地變作虱子（或譯：虼蚤；下同）。',
    '出8:17 他們就這樣行。亞倫伸杖擊打地上的塵土，就在人身上和牲畜身上有了虱子；埃及遍地的塵土都變成虱子了。',
    '出8:18 行法術的也用邪術要生出虱子來，卻是不能。於是在人身上和牲畜身上都有了虱子。',
    '出8:19 行法術的就對法老說：這是神的手段。法老心裡剛硬，不肯聽摩西、亞倫，正如耶和華所說的。',
    '出8:20 耶和華對摩西說：你清早起來，法老來到水邊，你站在他面前，對他說：耶和華這樣說：容我的百姓去，好事奉我。',
    '出8:21 你若不容我的百姓去，我要叫成群的蒼蠅到你和你臣僕並你百姓的身上，進你的房屋，並且埃及人的房屋和他們所住的地都要滿了成群的蒼蠅。',
    '出8:22 當那日，我必分別我百姓所住的歌珊地，使那裡沒有成群的蒼蠅，好叫你知道我是天下的耶和華。',
    '出8:23 我要將我的百姓和你的百姓分別出來。明天必有這神蹟。',
    '出8:24 耶和華就這樣行。蒼蠅成了大群，進入法老的宮殿，和他臣僕的房屋；埃及遍地就因這成群的蒼蠅敗壞了。',
    '出8:25 法老召了摩西、亞倫來，說：你們去，在這地祭祀你們的神吧！',
    '出8:26 摩西說：這樣行本不相宜，因為我們要把埃及人所厭惡的祭祀耶和華─我們的神；若把埃及人所厭惡的在他們眼前獻為祭，他們豈不拿石頭打死我們嗎﹖',
    '出8:27 我們要往曠野去，走三天的路程，照著耶和華─我們神所要吩咐我們的祭祀他。',
    '出8:28 法老說：我容你們去，在曠野祭祀耶和華─你們的神；只是不要走得很遠。求你們為我祈禱。',
    '出8:29 摩西說：我要出去求耶和華，使成群的蒼蠅明天離開法老和法老的臣僕並法老的百姓；法老卻不可再行詭詐，不容百姓去祭祀耶和華。',
    '出8:30 於是摩西離開法老去求耶和華。',
    '出8:31 耶和華就照摩西的話行，叫成群的蒼蠅離開法老和他的臣僕並他的百姓，一個也沒有留下。',
    '出8:32 這一次法老又硬著心，不容百姓去。',
    '出9:1 耶和華吩咐摩西說：你進去見法老，對他說：耶和華─希伯來人的神這樣說：容我的百姓去，好事奉我。',
    '出9:2 你若不肯容他們去，仍舊強留他們，',
    '出9:3 耶和華的手加在你田間的牲畜上，就是在馬、驢、駱駝、牛群、羊群上，必有重重的瘟疫。',
    '出9:4 耶和華要分別以色列的牲畜和埃及的牲畜，凡屬以色列人的，一樣都不死。',
    '出9:5 耶和華就定了時候，說：明天耶和華必在此地行這事。',
    '出9:6 第二天，耶和華就行這事。埃及的牲畜幾乎都死了，只是以色列人的牲畜，一個都沒有死。',
    '出9:7 法老打發人去看，誰知以色列人的牲畜連一個都沒有死。法老的心卻是固執，不容百姓去。',
    '出9:8 耶和華吩咐摩西、亞倫說：你們取幾捧爐灰，摩西要在法老面前向天揚起來。',
    '出9:9 這灰要在埃及全地變作塵土，在人身上和牲畜身上成了起泡的瘡。',
    '出9:10 摩西、亞倫取了爐灰，站在法老面前。摩西向天揚起來，就在人身上和牲畜身上成了起泡的瘡。',
    '出9:11 行法術的在摩西面前站立不住，因為在他們身上和一切埃及人身上都有這瘡。',
    '出9:12 耶和華使法老的心剛硬，不聽他們，正如耶和華對摩西所說的。',
    '出9:13 耶和華對摩西說：你清早起來，站在法老面前，對他說：耶和華─希伯來人的神這樣說：容我的百姓去，好事奉我。',
    '出9:14 因為這一次我要叫一切的災殃臨到你和你臣僕並你百姓的身上，叫你知道在普天下沒有像我的。',
    '出9:15 我若伸手用瘟疫攻擊你和你的百姓，你早就從地上除滅了。',
    '出9:16 其實，我叫你存立，是特要向你顯我的大能，並要使我的名傳遍天下。',
    '出9:17 你還向我的百姓自高，不容他們去嗎﹖',
    '出9:18 到明天約在這時候，我必叫重大的冰雹降下，自從埃及開國以來，沒有這樣的冰雹。',
    '出9:19 現在你要打發人把你的牲畜和你田間一切所有的催進來；凡在田間不收回家的，無論是人是牲畜，冰雹必降在他們身上，他們就必死。',
    '出9:20 法老的臣僕中，懼怕耶和華這話的，便叫他的奴僕和牲畜跑進家來。',
    '出9:21 但那不把耶和華這話放在心上的，就將他的奴僕和牲畜留在田裡。',
    '出9:22 耶和華對摩西說：你向天伸杖，使埃及遍地的人身上和牲畜身上，並田間各樣菜蔬上，都有冰雹。',
    '出9:23 摩西向天伸杖，耶和華就打雷下雹，有火閃到地上；耶和華下雹在埃及地上。',
    '出9:24 那時，雹與火攙雜，甚是厲害，自從埃及成國以來，遍地沒有這樣的。',
    '出9:25 在埃及遍地，雹擊打了田間所有的人和牲畜，並一切的菜蔬，又打壞田間一切的樹木。',
    '出9:26 惟獨以色列人所住的歌珊地沒有冰雹。',
    '出9:27 法老打發人召摩西、亞倫來，對他們說：這一次我犯了罪了。耶和華是公義的；我和我的百姓是邪惡的。',
    '出9:28 這雷轟和冰雹已經夠了。請你們求耶和華，我就容你們去，不再留住你們。',
    '出9:29 摩西對他說：我一出城，就要向耶和華舉手禱告；雷必止住，也不再有冰雹，叫你知道全地都是屬耶和華的。',
    '出9:30 至於你和你的臣僕，我知道你們還是不懼怕耶和華神。',
    '出9:31 （那時，麻和大麥被雹擊打；因為大麥已經吐穗，麻也開了花。',
    '出9:32 只是小麥和粗麥沒有被擊打，因為還沒有長成。）',
    '出9:33 摩西離了法老出城，向耶和華舉手禱告；雷和雹就止住，雨也不再澆在地上了。',
    '出9:34 法老見雨和雹與雷止住，就越發犯罪；他和他的臣僕都硬著心。',
    '出9:35 法老的心剛硬，不容以色列人去，正如耶和華藉著摩西所說的。',
    '出10:1 耶和華對摩西說：你進去見法老。我使他和他臣僕的心剛硬，為要在他們中間顯我這些神蹟，',
    '出10:2 並要叫你將我向埃及人所做的事，和在他們中間所行的神蹟，傳於你兒子和你孫子的耳中，好叫你們知道我是耶和華。',
    '出10:3 摩西、亞倫就進去見法老，對他說：耶和華─希伯來人的神這樣說：你在我面前不肯自卑要到幾時呢﹖容我的百姓去，好事奉我。',
    '出10:4 你若不肯容我的百姓去，明天我要使蝗蟲進入你的境內，',
    '出10:5 遮滿地面，甚至看不見地，並且吃那冰雹所剩的和田間所長的一切樹木。',
    '出10:6 你的宮殿和你眾臣僕的房屋，並一切埃及人的房屋，都要被蝗蟲佔滿了；自從你祖宗和你祖宗的祖宗在世以來，直到今日，沒有見過這樣的災。摩西就轉身離開法老出去。',
    '出10:7 法老的臣僕對法老說：這人為我們的網羅要到幾時呢﹖容這些人去事奉耶和華─他們的神吧！埃及已經敗壞了，你還不知道嗎﹖',
    '出10:8 於是摩西、亞倫被召回來見法老；法老對他們說：你們去事奉耶和華─你們的神；但那要去的是誰呢﹖',
    '出10:9 摩西說：我們要和我們老的少的、兒子女兒同去，且把羊群牛群一同帶去，因為我們務要向耶和華守節。',
    '出10:10 法老對他們說：我容你們和你們婦人孩子去的時候，耶和華與你們同在吧！你們要謹慎；因為有禍在你們眼前（或作：你們存著惡意），',
    '出10:11 不可都去！你們這壯年人去事奉耶和華吧，因為這是你們所求的。於是把他們從法老面前攆出去。',
    '出10:12 耶和華對摩西說：你向埃及地伸杖，使蝗蟲到埃及地上來，吃地上一切的菜蔬，就是冰雹所剩的。',
    '出10:13 摩西就向埃及地伸杖，那一晝一夜，耶和華使東風颳在埃及地上；到了早晨，東風把蝗蟲颳了來。',
    '出10:14 蝗蟲上來，落在埃及的四境，甚是厲害；以前沒有這樣的，以後也必沒有。',
    '出10:15 因為這蝗蟲遮滿地面，甚至地都黑暗了，又吃地上一切的菜蔬和冰雹所剩樹上的果子。埃及遍地，無論是樹木，是田間的菜蔬，連一點青的也沒有留下。',
    '出10:16 於是法老急忙召了摩西、亞倫來，說：我得罪耶和華─你們的神，又得罪了你們。',
    '出10:17 現在求你，只這一次，饒恕我的罪，求耶和華─你們的神使我脫離這一次的死亡。',
    '出10:18 摩西就離開法老去求耶和華。',
    '出10:19 耶和華轉了極大的西風，把蝗蟲颳起，吹入紅海；在埃及的四境連一個也沒有留下。',
    '出10:20 但耶和華使法老的心剛硬，不容以色列人去。',
    '出10:21 耶和華對摩西說：你向天伸杖，使埃及地黑暗；這黑暗似乎摸得著。',
    '出10:22 摩西向天伸杖，埃及遍地就烏黑了三天。',
    '出10:23 三天之久，人不能相見，誰也不敢起來離開本處；惟有以色列人家中都有亮光。',
    '出10:24 法老就召摩西來，說：你們去事奉耶和華；只是你們的羊群牛群要留下；你們的婦人孩子可以和你們同去。',
    '出10:25 摩西說：你總要把祭物和燔祭牲交給我們，使我們可以祭祀耶和華─我們的神。',
    '出10:26 我們的牲畜也要帶去，連一蹄也不留下；因為我們要從其中取出來，事奉耶和華─我們的神。我們未到那裡，還不知道用什麼事奉耶和華。',
    '出10:27 但耶和華使法老的心剛硬，不肯容他們去。',
    '出10:28 法老對摩西說：你離開我去吧，你要小心，不要再見我的面！因為你見我面的那日你就必死！',
    '出10:29 摩西說：你說得好！我必不再見你的面了。',
    '出11:1 耶和華對摩西說：我再使一樣的災殃臨到法老和埃及，然後他必容你們離開這地。他容你們去的時候，總要催逼你們都從這地出去。',
    '出11:2 你要傳於百姓的耳中，叫他們男女各人向鄰舍要金器銀器。',
    '出11:3 耶和華叫百姓在埃及人眼前蒙恩，並且摩西在埃及地、法老臣僕，和百姓的眼中看為極大。',
    '出11:4 摩西說：耶和華這樣說：約到半夜，我必出去巡行埃及遍地。',
    '出11:5 凡在埃及地，從坐寶座的法老直到磨子後的婢女所有的長子，以及一切頭生的牲畜，都必死。',
    '出11:6 埃及遍地必有大哀號；從前沒有這樣的，後來也必沒有。',
    '出11:7 至於以色列中，無論是人是牲畜，連狗也不敢向他們搖舌，好叫你們知道耶和華是將埃及人和以色列人分別出來。',
    '出11:8 你這一切臣僕都要俯伏來見我，說：求你和跟從你的百姓都出去，然後我要出去。於是，摩西氣忿忿地離開法老，出去了。',
    '出11:9 耶和華對摩西說：法老必不聽你們，使我的奇事在埃及地多起來。',
    '出11:10 摩西、亞倫在法老面前行了這一切奇事；耶和華使法老的心剛硬，不容以色列人出離他的地。',
    '出12:1 耶和華在埃及地曉諭摩西、亞倫說：',
    '出12:2 你們要以本月為正月，為一年之首。',
    '出12:3 你們吩咐以色列全會眾說：本月初十日，各人要按著父家取羊羔，一家一隻。',
    '出12:4 若是一家的人太少，吃不了一隻羊羔，本人就要和他隔壁的鄰舍共取一隻。你們預備羊羔，要按著人數和飯量計算。',
    '出12:5 要無殘疾、一歲的公羊羔，你們或從綿羊裡取，或從山羊裡取，都可以。',
    '出12:6 要留到本月十四日，在黃昏的時候，以色列全會眾把羊羔宰了。',
    '出12:7 各家要取點血，塗在吃羊羔的房屋左右的門框上和門楣上。',
    '出12:8 當夜要吃羊羔的肉；用火烤了，與無酵餅和苦菜同吃。',
    '出12:9 不可吃生的，斷不可吃水煮的，要帶著頭、腿、五臟，用火烤了吃。',
    '出12:10 不可剩下一點留到早晨；若留到早晨，要用火燒了。',
    '出12:11 你們吃羊羔當腰間束帶，腳上穿鞋，手中拿杖，趕緊地吃；這是耶和華的逾越節。',
    '出12:12 因為那夜我要巡行埃及地，把埃及地一切頭生的，無論是人是牲畜，都擊殺了，又要敗壞埃及一切的神。我是耶和華。',
    '出12:13 這血要在你們所住的房屋上作記號；我一見這血，就越過你們去。我擊殺埃及地頭生的時候，災殃必不臨到你們身上滅你們。',
    '出12:14 你們要記念這日，守為耶和華的節，作為你們世世代代永遠的定例。',
    '出12:15 你們要吃無酵餅七日。頭一日要把酵從你們各家中除去；因為從頭一日起，到第七日為止，凡吃有酵之餅的，必從以色列中剪除。',
    '出12:16 頭一日你們當有聖會，第七日也當有聖會。這兩日之內，除了預備各人所要吃的以外，無論何工都不可做。',
    '出12:17 你們要守無酵節，因為我正當這日把你們的軍隊從埃及地領出來。所以，你們要守這日，作為世世代代永遠的定例。',
    '出12:18 從正月十四日晚上，直到二十一日晚上，你們要吃無酵餅。',
    '出12:19 在你們各家中，七日之內不可有酵；因為凡吃有酵之物的，無論是寄居的，是本地的，必從以色列的會中剪除。',
    '出12:20 有酵的物，你們都不可吃；在你們一切住處要吃無酵餅。',
    '出12:21 於是，摩西召了以色列的眾長老來，對他們說：你們要按著家口取出羊羔，把這逾越節的羊羔宰了。',
    '出12:22 拿一把牛膝草，蘸盆裡的血，打在門楣上和左右的門框上。你們誰也不可出自己的房門，直到早晨。',
    '出12:23 因為耶和華要巡行擊殺埃及人，他看見血在門楣上和左右的門框上，就必越過那門，不容滅命的進你們的房屋，擊殺你們。',
    '出12:24 這例，你們要守著，作為你們和你們子孫永遠的定例。',
    '出12:25 日後，你們到了耶和華按著所應許賜給你們的那地，就要守這禮。',
    '出12:26 你們的兒女問你們說：行這禮是什麼意思﹖',
    '出12:27 你們就說：這是獻給耶和華逾越節的祭。當以色列人在埃及的時候，他擊殺埃及人，越過以色列人的房屋，救了我們各家。於是百姓低頭下拜。',
    '出12:28 耶和華怎樣吩咐摩西、亞倫，以色列人就怎樣行。',
    '出12:29 到了半夜，耶和華把埃及地所有的長子，就是從坐寶座的法老，直到被擄囚在監裡之人的長子，以及一切頭生的牲畜，盡都殺了。',
    '出12:30 法老和一切臣僕，並埃及眾人，夜間都起來了。在埃及有大哀號，無一家不死一個人的。',
    '出12:31 夜間，法老召了摩西、亞倫來，說：起來！連你們帶以色列人，從我民中出去，依你們所說的，去事奉耶和華吧！',
    '出12:32 也依你們所說的，連羊群牛群帶著走吧！並要為我祝福。',
    '出12:33 埃及人催促百姓，打發他們快快出離那地，因為埃及人說：我們都要死了。',
    '出12:34 百姓就拿著沒有酵的生麵，把摶麵盆包在衣服中，扛在肩頭上。',
    '出12:35 以色列人照著摩西的話行，向埃及人要金器、銀器，和衣裳。',
    '出12:36 耶和華叫百姓在埃及人眼前蒙恩，以致埃及人給他們所要的。他們就把埃及人的財物奪去了。',
    '出12:37 以色列人從蘭塞起行，往疏割去；除了婦人孩子，步行的男人約有六十萬。',
    '出12:38 又有許多閒雜人，並有羊群牛群，和他們一同上去。',
    '出12:39 他們用埃及帶出來的生麵烤成無酵餅。這生麵原沒有發起；因為他們被催逼離開埃及，不能耽延，也沒有為自己預備什麼食物。',
    '出12:40 以色列人住在埃及共有四百三十年。',
    '出12:41 正滿了四百三十年的那一天，耶和華的軍隊都從埃及地出來了。',
    '出12:42 這夜是耶和華的夜；因耶和華領他們出了埃及地，所以當向耶和華謹守，是以色列眾人世世代代該謹守的。',
    '出12:43 耶和華對摩西、亞倫說：逾越節的例是這樣：外邦人都不可吃這羊羔。',
    '出12:44 但各人用銀子買的奴僕，既受了割禮就可以吃。',
    '出12:45 寄居的和雇工人都不可吃。',
    '出12:46 應當在一個房子裡吃；不可把一點肉從房子裡帶到外頭去。羊羔的骨頭一根也不可折斷。',
    '出12:47 以色列全會眾都要守這禮。',
    '出12:48 若有外人寄居在你們中間，願向耶和華守逾越節，他所有的男子務要受割禮，然後才容他前來遵守，他也就像本地人一樣；但未受割禮的，都不可吃這羊羔。',
    '出12:49 本地人和寄居在你們中間的外人同歸一例。',
    '出12:50 耶和華怎樣吩咐摩西、亞倫，以色列眾人就怎樣行了。',
    '出12:51 正當那日，耶和華將以色列人按著他們的軍隊，從埃及地領出來。',
    '出13:1 耶和華曉諭摩西說：',
    '出13:2 以色列中凡頭生的，無論是人是牲畜，都是我的，要分別為聖歸我。',
    '出13:3 摩西對百姓說：你們要記念從埃及為奴之家出來的這日，因為耶和華用大能的手將你們從這地方領出來。有酵的餅都不可吃。',
    '出13:4 亞筆月間的這日是你們出來的日子。',
    '出13:5 將來耶和華領你進迦南人、赫人、亞摩利人、希未人、耶布斯人之地，就是他向你的祖宗起誓應許給你那流奶與蜜之地，那時你要在這月間守這禮。',
    '出13:6 你要吃無酵餅七日，到第七日要向耶和華守節。',
    '出13:7 這七日之久，要吃無酵餅；在你四境之內不可見有酵的餅，也不可見發酵的物。',
    '出13:8 當那日，你要告訴你的兒子說：這是因耶和華在我出埃及的時候為我所行的事。',
    '出13:9 這要在你手上作記號，在你額上作記念，使耶和華的律法常在你口中，因為耶和華曾用大能的手將你從埃及領出來。',
    '出13:10 所以你每年要按著日期守這例。',
    '出13:11 將來，耶和華照他向你和你祖宗所起的誓將你領進迦南人之地，把這地賜給你，',
    '出13:12 那時你要將一切頭生的，並牲畜中頭生的，歸給耶和華；公的都要屬耶和華。',
    '出13:13 凡頭生的驢，你要用羊羔代贖；若不代贖，就要打折他的頸項。凡你兒子中頭生的都要贖出來。',
    '出13:14 日後，你的兒子問你說：這是什麼意思﹖你就說：耶和華用大能的手將我們從埃及為奴之家領出來。',
    '出13:15 那時法老幾乎不容我們去，耶和華就把埃及地所有頭生的，無論是人是牲畜，都殺了。因此，我把一切頭生的公牲畜獻給耶和華為祭，但將頭生的兒子都贖出來。',
    '出13:16 這要在你手上作記號，在你額上作經文，因為耶和華用大能的手將我們從埃及領出來。',
    '出13:17 法老容百姓去的時候，非利士地的道路雖近，神卻不領他們從那裡走；因為神說：恐怕百姓遇見打仗後悔，就回埃及去。',
    '出13:18 所以神領百姓繞道而行，走紅海曠野的路。以色列人出埃及地，都帶著兵器上去。',
    '出13:19 摩西把約瑟的骸骨一同帶去；因為約瑟曾叫以色列人嚴嚴地起誓，對他們說：神必眷顧你們，你們要把我的骸骨從這裡一同帶上去。',
    '出13:20 他們從疏割起行，在曠野邊的以倘安營。',
    '出13:21 日間，耶和華在雲柱中領他們的路；夜間，在火柱中光照他們，使他們日夜都可以行走。',
    '出13:22 日間雲柱，夜間火柱，總不離開百姓的面前。',
    '出14:1 耶和華曉諭摩西說：',
    '出14:2 你吩咐以色列人轉回，安營在比哈希錄前，密奪和海的中間，對著巴力洗分，靠近海邊安營。',
    '出14:3 法老必說：以色列人在地中繞迷了，曠野把他們困住了。',
    '出14:4 我要使法老的心剛硬，他要追趕他們，我便在法老和他全軍身上得榮耀；埃及人就知道我是耶和華。於是以色列人這樣行了。',
    '出14:5 有人告訴埃及王說：百姓逃跑。法老和他的臣僕就向百姓變心，說：我們容以色列人去，不再服事我們，這做的是什麼事呢﹖',
    '出14:6 法老就預備他的車輛，帶領軍兵同去，',
    '出14:7 並帶著六百輛特選的車和埃及所有的車，每輛都有車兵長。',
    '出14:8 耶和華使埃及王法老的心剛硬，他就追趕以色列人，因為以色列人是昂然無懼地出埃及。',
    '出14:9 埃及人追趕他們，法老一切的馬匹、車輛、馬兵，與軍兵就在海邊上，靠近比哈希錄，對著巴力洗分，在他們安營的地方追上了。',
    '出14:10 法老臨近的時候，以色列人舉目看見埃及人趕來，就甚懼怕，向耶和華哀求。',
    '出14:11 他們對摩西說：難道在埃及沒有墳地，你把我們帶來死在曠野嗎﹖你為什麼這樣待我們，將我們從埃及領出來呢﹖',
    '出14:12 我們在埃及豈沒有對你說過，不要攪擾我們，容我們服事埃及人嗎﹖因為服事埃及人比死在曠野還好。',
    '出14:13 摩西對百姓說：不要懼怕，只管站住！看耶和華今天向你們所要施行的救恩。因為，你們今天所看見的埃及人必永遠不再看見了。',
    '出14:14 耶和華必為你們爭戰；你們只管靜默，不要作聲。',
    '出14:15 耶和華對摩西說：你為什麼向我哀求呢﹖你吩咐以色列人往前走。',
    '出14:16 你舉手向海伸杖，把水分開。以色列人要下海中走乾地。',
    '出14:17 我要使埃及人的心剛硬，他們就跟著下去。我要在法老和他的全軍、車輛、馬兵上得榮耀。',
    '出14:18 我在法老和他的車輛、馬兵上得榮耀的時候，埃及人就知道我是耶和華了。',
    '出14:19 在以色列營前行走神的使者，轉到他們後邊去；雲柱也從他們前邊轉到他們後邊立住。',
    '出14:20 在埃及營和以色列營中間有雲柱，一邊黑暗，一邊發光，終夜兩下不得相近。',
    '出14:21 摩西向海伸杖，耶和華便用大東風，使海水一夜退去，水便分開，海就成了乾地。',
    '出14:22 以色列人下海中走乾地，水在他們的左右作了牆垣。',
    '出14:23 埃及人追趕他們，法老一切的馬匹、車輛，和馬兵都跟著下到海中。',
    '出14:24 到了晨更的時候，耶和華從雲火柱中向埃及的軍兵觀看，使埃及的軍兵混亂了；',
    '出14:25 又使他們的車輪脫落，難以行走，以致埃及人說：我們從以色列人面前逃跑吧！因耶和華為他們攻擊我們了。',
    '出14:26 耶和華對摩西說：你向海伸杖，叫水仍合在埃及人並他們的車輛、馬兵身上。',
    '出14:27 摩西就向海伸杖，到了天一亮，海水仍舊復原。埃及人避水逃跑的時候，耶和華把他們推翻在海中，',
    '出14:28 水就回流，淹沒了車輛和馬兵。那些跟著以色列人下海法老的全軍，連一個也沒有剩下。',
    '出14:29 以色列人卻在海中走乾地；水在他們的左右作了牆垣。',
    '出14:30 當日，耶和華這樣拯救以色列人脫離埃及人的手，以色列人看見埃及人的死屍都在海邊了。',
    '出14:31 以色列人看見耶和華向埃及人所行的大事，就敬畏耶和華，又信服他和他的僕人摩西。',
    '出15:1 那時，摩西和以色列人向耶和華唱歌說：我要向耶和華歌唱，因他大大戰勝，將馬和騎馬的投在海中。',
    '出15:2 耶和華是我的力量，我的詩歌，也成了我的拯救。這是我的神，我要讚美他，是我父親的神，我要尊崇他。',
    '出15:3 耶和華是戰士；他的名是耶和華。',
    '出15:4 法老的車輛、軍兵，耶和華已拋在海中；他特選的軍長都沉於紅海。',
    '出15:5 深水淹沒他們；他們如同石頭墜到深處。',
    '出15:6 耶和華啊，你的右手施展能力，顯出榮耀；耶和華啊，你的右手摔碎仇敵。',
    '出15:7 你大發威嚴，推翻那些起來攻擊你的；你發出烈怒如火，燒滅他們像燒碎稭一樣。',
    '出15:8 你發鼻中的氣，水便聚起成堆，大水直立如壘，海中的深水凝結。',
    '出15:9 仇敵說：我要追趕，我要追上；我要分擄物，我要在他們身上稱我的心願。我要拔出刀來，親手殺滅他們。',
    '出15:10 你叫風一吹，海就把他們淹沒；他們如鉛沉在大水之中。',
    '出15:11 耶和華啊，眾神之中，誰能像你﹖誰能像你─至聖至榮，可頌可畏，施行奇事﹖',
    '出15:12 你伸出右手，地便吞滅他們。',
    '出15:13 你憑慈愛領了你所贖的百姓；你憑能力引他們到了你的聖所。',
    '出15:14 外邦人聽見就發顫；疼痛抓住非利士的居民。',
    '出15:15 那時，以東的族長驚惶，摩押的英雄被戰兢抓住，迦南的居民心都消化了。',
    '出15:16 驚駭恐懼臨到他們。耶和華啊，因你膀臂的大能，他們如石頭寂然不動，等候你的百姓過去，等候你所贖的百姓過去。',
    '出15:17 你要將他們領進去，栽於你產業的山上─耶和華啊，就是你為自己所造的住處；主啊，就是你手所建立的聖所。',
    '出15:18 耶和華必作王，直到永永遠遠！',
    '出15:19 法老的馬匹、車輛，和馬兵下到海中，耶和華使海水回流，淹沒他們；惟有以色列人在海中走乾地。',
    '出15:20 亞倫的姊姊，女先知米利暗，手裡拿著鼓；眾婦女也跟他出去拿鼓跳舞。',
    '出15:21 米利暗應聲說：你們要歌頌耶和華，因他大大戰勝，將馬和騎馬的投在海中。',
    '出15:22 摩西領以色列人從紅海往前行，到了書珥的曠野，在曠野走了三天，找不著水。',
    '出15:23 到了瑪拉，不能喝那裡的水；因為水苦，所以那地名叫瑪拉。',
    '出15:24 百姓就向摩西發怨言，說：我們喝什麼呢﹖',
    '出15:25 摩西呼求耶和華，耶和華指示他一棵樹。他把樹丟在水裡，水就變甜了。耶和華在那裡為他們定了律例、典章，在那裡試驗他們；',
    '出15:26 又說：你若留意聽耶和華─你神的話，又行我眼中看為正的事，留心聽我的誡命，守我一切的律例，我就不將所加與埃及人的疾病加在你身上，因為我─耶和華是醫治你的。',
    '出15:27 他們到了以琳，在那裡有十二股水泉，七十棵棕樹；他們就在那裡的水邊安營。',
    '出16:1 以色列全會眾從以琳起行，在出埃及後第二個月十五日到了以琳和西乃中間、汛的曠野。',
    '出16:2 以色列全會眾在曠野向摩西、亞倫發怨言，',
    '出16:3 說：巴不得我們早死在埃及地、耶和華的手下；那時我們坐在肉鍋旁邊，吃得飽足。你們將我們領出來，到這曠野，是要叫這全會眾都餓死啊！',
    '出16:4 耶和華對摩西說：我要將糧食從天降給你們。百姓可以出去，每天收每天的分，我好試驗他們遵不遵我的法度。',
    '出16:5 到第六天，他們要把所收進來的預備好了，比每天所收的多一倍。',
    '出16:6 摩西、亞倫對以色列眾人說：到了晚上，你們要知道是耶和華將你們從埃及地領出來的。',
    '出16:7 早晨，你們要看見耶和華的榮耀，因為耶和華聽見你們向他所發的怨言了。我們算什麼，你們竟向我們發怨言呢﹖',
    '出16:8 摩西又說：耶和華晚上必給你們肉吃，早晨必給你們食物得飽；因為你們向耶和華發的怨言，他都聽見了。我們算什麼，你們的怨言不是向我們發的，乃是向耶和華發的。',
    '出16:9 摩西對亞倫說：你告訴以色列全會眾說：你們就近耶和華面前，因為他已經聽見你們的怨言了。',
    '出16:10 亞倫正對以色列全會眾說話的時候，他們向曠野觀看，不料，耶和華的榮光在雲中顯現。',
    '出16:11 耶和華曉諭摩西說：',
    '出16:12 我已經聽見以色列人的怨言。你告訴他們說：到黃昏的時候，你們要吃肉，早晨必有食物得飽，你們就知道我是耶和華─你們的神。',
    '出16:13 到了晚上，有鵪鶉飛來，遮滿了營；早晨在營四圍的地上有露水。',
    '出16:14 露水上升之後，不料，野地面上有如白霜的小圓物。',
    '出16:15 以色列人看見，不知道是什麼，就彼此對問說：這是什麼呢﹖摩西對他們說：這就是耶和華給你們吃的食物。',
    '出16:16 耶和華所吩咐的是這樣：你們要按著各人的飯量，為帳棚裡的人，按著人數收起來，各拿一俄梅珥。',
    '出16:17 以色列人就這樣行；有多收的，有少收的。',
    '出16:18 及至用俄梅珥量一量，多收的也沒有餘，少收的也沒有缺；各人按著自己的飯量收取。',
    '出16:19 摩西對他們說：所收的，不許什麼人留到早晨。',
    '出16:20 然而他們不聽摩西的話，內中有留到早晨的，就生蟲變臭了；摩西便向他們發怒。',
    '出16:21 他們每日早晨，按著各人的飯量收取，日頭一發熱，就消化了。',
    '出16:22 到第六天，他們收了雙倍的食物，每人兩俄梅珥。會眾的官長來告訴摩西；',
    '出16:23 摩西對他們說：耶和華這樣說：明天是聖安息日，是向耶和華守的聖安息日。你們要烤的就烤了，要煮的就煮了，所剩下的都留到早晨。',
    '出16:24 他們就照摩西的吩咐留到早晨，也不臭，裡頭也沒有蟲子。',
    '出16:25 摩西說：你們今天吃這個吧！因為今天是向耶和華守的安息日；你們在田野必找不著了。',
    '出16:26 六天可以收取，第七天乃是安息日，那一天必沒有了。',
    '出16:27 第七天，百姓中有人出去收，什麼也找不著。',
    '出16:28 耶和華對摩西說：你們不肯守我的誡命和律法，要到幾時呢﹖',
    '出16:29 你們看！耶和華既將安息日賜給你們，所以第六天他賜給你們兩天的食物，第七天各人要住在自己的地方，不許什麼人出去。',
    '出16:30 於是百姓第七天安息了。',
    '出16:31 這食物，以色列家叫嗎哪；樣子像芫荽子，顏色是白的，滋味如同攙蜜的薄餅。',
    '出16:32 摩西說：耶和華所吩咐的是這樣：要將一滿俄梅珥（俄梅珥就是伊法十分之一）嗎哪留到世世代代，使後人可以看見我當日將你們領出埃及地，在曠野所給你們吃的食物。',
    '出16:33 摩西對亞倫說：你拿一個罐子，盛一滿俄梅珥嗎哪，存在耶和華面前，要留到世世代代。',
    '出16:34 耶和華怎麼吩咐摩西，亞倫就怎麼行，把嗎哪放在法櫃前存留。',
    '出16:35 以色列人吃嗎哪共四十年，直到進了有人居住之地，就是迦南的境界。',
    '出16:36 （俄梅珥就是伊法十分之一。）',
    '出17:1 以色列全會眾都遵耶和華的吩咐，按著站口從汛的曠野往前行，在利非訂安營。百姓沒有水喝，',
    '出17:2 所以與摩西爭鬧，說：給我們水喝吧！摩西對他們說：你們為什麼與我爭鬧﹖為什麼試探耶和華呢﹖',
    '出17:3 百姓在那裡甚渴，要喝水，就向摩西發怨言，說：你為什麼將我們從埃及領出來，使我們和我們的兒女並牲畜都渴死呢﹖',
    '出17:4 摩西就呼求耶和華說：我向這百姓怎樣行呢﹖他們幾乎要拿石頭打死我。',
    '出17:5 耶和華對摩西說：你手裡拿著你先前擊打河水的杖，帶領以色列的幾個長老，從百姓面前走過去。',
    '出17:6 我必在何烈的磐石那裡，站在你面前。你要擊打磐石，從磐石裡必有水流出來，使百姓可以喝。摩西就在以色列的長老眼前這樣行了。',
    '出17:7 他給那地方起名叫瑪撒（就是試探的意思），又叫米利巴（就是爭鬧的意思）；因以色列人爭鬧，又因他們試探耶和華，說：耶和華是在我們中間不是﹖',
    '出17:8 那時，亞瑪力人來在利非訂，和以色列人爭戰。',
    '出17:9 摩西對約書亞說：你為我們選出人來，出去和亞瑪力人爭戰。明天我手裡要拿著神的杖，站在山頂上。',
    '出17:10 於是約書亞照著摩西對他所說的話行，和亞瑪力人爭戰。摩西、亞倫，與戶珥都上了山頂。',
    '出17:11 摩西何時舉手，以色列人就得勝，何時垂手，亞瑪力人就得勝。',
    '出17:12 但摩西的手發沉，他們就搬石頭來，放在他以下，他就坐在上面。亞倫與戶珥扶著他的手，一個在這邊，一個在那邊，他的手就穩住，直到日落的時候。',
    '出17:13 約書亞用刀殺了亞瑪力王和他的百姓。',
    '出17:14 耶和華對摩西說：我要將亞瑪力的名號從天下全然塗抹了；你要將這話寫在書上作記念，又念給約書亞聽。',
    '出17:15 摩西築了一座壇，起名叫耶和華尼西（就是耶和華是我旌旗的意思），',
    '出17:16 又說：耶和華已經起了誓，必世世代代和亞瑪力人爭戰。',
    '出18:1 摩西的岳父，米甸祭司葉忒羅，聽見神為摩西和神的百姓以色列所行的一切事，就是耶和華將以色列從埃及領出來的事，',
    '出18:2 便帶著摩西的妻子西坡拉，就是摩西從前打發回去的，',
    '出18:3 又帶著西坡拉的兩個兒子，一個名叫革舜，因為摩西說：我在外邦作了寄居的；',
    '出18:4 一個名叫以利以謝，因為他說：我父親的神幫助了我，救我脫離法老的刀。',
    '出18:5 摩西的岳父葉忒羅帶著摩西的妻子和兩個兒子來到神的山，就是摩西在曠野安營的地方。',
    '出18:6 他對摩西說：我是你岳父葉忒羅，帶著你的妻子和兩個兒子來到你這裡。',
    '出18:7 摩西迎接他的岳父，向他下拜，與他親嘴，彼此問安，都進了帳棚。',
    '出18:8 摩西將耶和華為以色列的緣故向法老和埃及人所行的一切事，以及路上所遭遇的一切艱難，並耶和華怎樣搭救他們，都述說與他岳父聽。',
    '出18:9 葉忒羅因耶和華待以色列的一切好處，就是拯救他們脫離埃及人的手，便甚歡喜。',
    '出18:10 葉忒羅說：耶和華是應當稱頌的；他救了你們脫離埃及人和法老的手，將這百姓從埃及人的手下救出來。',
    '出18:11 我現今在埃及人向這百姓發狂傲的事上得知，耶和華比萬神都大。',
    '出18:12 摩西的岳父葉忒羅把燔祭和平安祭獻給神。亞倫和以色列的眾長老都來了，與摩西的岳父在神面前吃飯。',
    '出18:13 第二天，摩西坐著審判百姓，百姓從早到晚都站在摩西的左右。',
    '出18:14 摩西的岳父看見他向百姓所做的一切事，就說：你向百姓做的是什麼事呢﹖你為什麼獨自坐著，眾百姓從早到晚都站在你的左右呢﹖',
    '出18:15 摩西對岳父說：這是因百姓到我這裡來求問神。',
    '出18:16 他們有事的時候就到我這裡來，我便在兩造之間施行審判；我又叫他們知道神的律例和法度。',
    '出18:17 摩西的岳父說：你這做的不好。',
    '出18:18 你和這些百姓必都疲憊；因為這事太重，你獨自一人辦理不了。',
    '出18:19 現在你要聽我的話。我為你出個主意，願神與你同在。你要替百姓到神面前，將案件奏告神；',
    '出18:20 又要將律例和法度教訓他們，指示他們當行的道，當做的事；',
    '出18:21 並要從百姓中揀選有才能的人，就是敬畏神、誠實無妄、恨不義之財的人，派他們作千夫長、百夫長、五十夫長、十夫長，管理百姓，',
    '出18:22 叫他們隨時審判百姓，大事都要呈到你這裡，小事他們自己可以審判。這樣，你就輕省些，他們也可以同當此任。',
    '出18:23 你若這樣行，神也這樣吩咐你，你就能受得住，這百姓也都平平安安歸回他們的住處。',
    '出18:24 於是，摩西聽從他岳父的話，按著他所說的去行。',
    '出18:25 摩西從以色列人中揀選了有才能的人，立他們為百姓的首領，作千夫長、百夫長、五十夫長、十夫長。',
    '出18:26 他們隨時審判百姓，有難斷的案件就呈到摩西那裡，但各樣小事他們自己審判。',
    '出18:27 此後，摩西讓他的岳父去，他就往本地去了。',
    '出19:1 以色列人出埃及地以後，滿了三個月的那一天，就來到西乃的曠野。',
    '出19:2 他們離了利非訂，來到西乃的曠野，就在那裡的山下安營。',
    '出19:3 摩西到神那裡，耶和華從山上呼喚他說：你要這樣告訴雅各家，曉諭以色列人說：',
    '出19:4 我向埃及人所行的事，你們都看見了，且看見我如鷹將你們背在翅膀上，帶來歸我。',
    '出19:5 如今你們若實在聽從我的話，遵守我的約，就要在萬民中作屬我的子民，因為全地都是我的。',
    '出19:6 你們要歸我作祭司的國度，為聖潔的國民。這些話你要告訴以色列人。',
    '出19:7 摩西去召了民間的長老來，將耶和華所吩咐他的話都在他們面前陳明。',
    '出19:8 百姓都同聲回答說：凡耶和華所說的，我們都要遵行。摩西就將百姓的話回覆耶和華。',
    '出19:9 耶和華對摩西說：我要在密雲中臨到你那裡，叫百姓在我與你說話的時候可以聽見，也可以永遠信你了。於是，摩西將百姓的話奏告耶和華。',
    '出19:10 耶和華又對摩西說：你往百姓那裡去，叫他們今天明天自潔，又叫他們洗衣服。',
    '出19:11 到第三天要預備好了，因為第三天耶和華要在眾百姓眼前降臨在西乃山上。',
    '出19:12 你要在山的四圍給百姓定界限，說：你們當謹慎，不可上山去，也不可摸山的邊界；凡摸這山的，必要治死他。',
    '出19:13 不可用手摸他，必用石頭打死，或用箭射透；無論是人是牲畜，都不得活。到角聲拖長的時候，他們才可到山根來。',
    '出19:14 摩西下山往百姓那裡去，叫他們自潔，他們就洗衣服。',
    '出19:15 他對百姓說：到第三天要預備好了。不可親近女人。',
    '出19:16 到了第三天早晨，在山上有雷轟、閃電，和密雲，並且角聲甚大，營中的百姓盡都發顫。',
    '出19:17 摩西率領百姓出營迎接神，都站在山下。',
    '出19:18 西乃全山冒煙，因為耶和華在火中降於山上。山的煙氣上騰，如燒窰一般，遍山大大的震動。',
    '出19:19 角聲漸漸地高而又高，摩西就說話，神有聲音答應他。',
    '出19:20 耶和華降臨在西乃山頂上，耶和華召摩西上山頂，摩西就上去。',
    '出19:21 耶和華對摩西說：你下去囑咐百姓，不可闖過來到我面前觀看，恐怕他們有多人死亡；',
    '出19:22 又叫親近我的祭司自潔，恐怕我忽然出來擊殺他們。',
    '出19:23 摩西對耶和華說：百姓不能上西乃山，因為你已經囑咐我們說：要在山的四圍定界限，叫山成聖。',
    '出19:24 耶和華對他說：下去吧，你要和亞倫一同上來；只是祭司和百姓不可闖過來上到我面前，恐怕我忽然出來擊殺他們。',
    '出19:25 於是摩西下到百姓那裡告訴他們。',
    '出20:1 神吩咐這一切的話說：',
    '出20:2 我是耶和華─你的神，曾將你從埃及地為奴之家領出來。',
    '出20:3 除了我以外，你不可有別的神。',
    '出20:4 不可為自己雕刻偶像，也不可做什麼形像彷彿上天、下地，和地底下、水中的百物。',
    '出20:5 不可跪拜那些像，也不可事奉他，因為我耶和華─你的神是忌邪的神。恨我的，我必追討他的罪，自父及子，直到三四代；',
    '出20:6 愛我、守我誡命的，我必向他們發慈愛，直到千代。',
    '出20:7 不可妄稱耶和華─你神的名；因為妄稱耶和華名的，耶和華必不以他為無罪。',
    '出20:8 當記念安息日，守為聖日。',
    '出20:9 六日要勞碌做你一切的工，',
    '出20:10 但第七日是向耶和華─你神當守的安息日。這一日你和你的兒女、僕婢、牲畜，並你城裡寄居的客旅，無論何工都不可做；',
    '出20:11 因為六日之內，耶和華造天、地、海，和其中的萬物，第七日便安息，所以耶和華賜福與安息日，定為聖日。',
    '出20:12 當孝敬父母，使你的日子在耶和華─你神所賜你的地上得以長久。',
    '出20:13 不可殺人。',
    '出20:14 不可姦淫。',
    '出20:15 不可偷盜。',
    '出20:16 不可作假見證陷害人。',
    '出20:17 不可貪戀人的房屋；也不可貪戀人的妻子、僕婢、牛驢，並他一切所有的。',
    '出20:18 眾百姓見雷轟、閃電、角聲、山上冒煙，就都發顫，遠遠的站立，',
    '出20:19 對摩西說：求你和我們說話，我們必聽；不要神和我們說話，恐怕我們死亡。',
    '出20:20 摩西對百姓說：不要懼怕；因為神降臨是要試驗你們，叫你們時常敬畏他，不致犯罪。',
    '出20:21 於是百姓遠遠地站立；摩西就挨近神所在的幽暗之中。',
    '出20:22 耶和華對摩西說：你要向以色列人這樣說：你們自己看見我從天上和你們說話了。',
    '出20:23 你們不可做什麼神像與我相配，不可為自己做金銀的神像。',
    '出20:24 你要為我築土壇，在上面以牛羊獻為燔祭和平安祭。凡記下我名的地方，我必到那裡賜福給你。',
    '出20:25 你若為我築一座石壇，不可用鑿成的石頭，因你在上頭一動家具，就把壇污穢了。',
    '出20:26 你上我的壇，不可用臺階，免得露出你的下體來。',
    '出21:1 你在百姓面前所要立的典章是這樣：',
    '出21:2 你若買希伯來人作奴僕，他必服事你六年；第七年他可以自由，白白地出去。',
    '出21:3 他若孤身來就可以孤身去；他若有妻，他的妻就可以同他出去。',
    '出21:4 他主人若給他妻子，妻子給他生了兒子或女兒，妻子和兒女要歸主人，他要獨自出去。',
    '出21:5 倘或奴僕明說：我愛我的主人和我的妻子兒女，不願意自由出去。',
    '出21:6 他的主人就要帶他到審判官（審判官或作：神；下同）那裡，又要帶他到門前，靠近門框，用錐子穿他的耳朵，他就永遠服事主人。',
    '出21:7 人若賣女兒作婢女，婢女不可像男僕那樣出去。',
    '出21:8 主人選定他歸自己，若不喜歡他，就要許他贖身；主人既然用詭詐待他，就沒有權柄賣給外邦人。',
    '出21:9 主人若選定他給自己的兒子，就當待他如同女兒。',
    '出21:10 若另娶一個，那女子的吃食、衣服，並好合的事，仍不可減少。',
    '出21:11 若不向他行這三樣，他就可以不用錢贖，白白地出去。',
    '出21:12 打人以致打死的，必要把他治死。',
    '出21:13 人若不是埋伏著殺人，乃是神交在他手中，我就設下一個地方，他可以往那裡逃跑。',
    '出21:14 人若任意用詭計殺了他的鄰舍，就是逃到我的壇那裡，也當捉去把他治死。',
    '出21:15 打父母的，必要把他治死。',
    '出21:16 拐帶人口，或是把人賣了，或是留在他手下，必要把他治死。',
    '出21:17 咒罵父母的，必要把他治死。',
    '出21:18 人若彼此相爭，這個用石頭或是拳頭打那個，尚且不至於死，不過躺臥在床，',
    '出21:19 若再能起來扶杖而出，那打他的可算無罪；但要將他耽誤的工夫用錢賠補，並要將他全然醫好。',
    '出21:20 人若用棍子打奴僕或婢女，立時死在他的手下，他必要受刑。',
    '出21:21 若過一兩天才死，就可以不受刑，因為是用錢買的。',
    '出21:22 人若彼此爭鬥，傷害有孕的婦人，甚至墜胎，隨後卻無別害，那傷害他的，總要按婦人的丈夫所要的，照審判官所斷的受罰。',
    '出21:23 若有別害，就要以命償命，',
    '出21:24 以眼還眼，以牙還牙，以手還手，以腳還腳，',
    '出21:25 以烙還烙，以傷還傷，以打還打。',
    '出21:26 人若打壞了他奴僕或是婢女的一隻眼，就要因他的眼放他去得以自由。',
    '出21:27 若打掉了他奴僕或是婢女的一個牙，就要因他的牙放他去得以自由。',
    '出21:28 牛若觸死男人或是女人，總要用石頭打死那牛，卻不可吃他的肉；牛的主人可算無罪。',
    '出21:29 倘若那牛素來是觸人的，有人報告了牛主，他竟不把牛拴著，以致把男人或是女人觸死，就要用石頭打死那牛，牛主也必治死。',
    '出21:30 若罰他贖命的價銀，他必照所罰的贖他的命。',
    '出21:31 牛無論觸了人的兒子或是女兒，必照這例辦理。',
    '出21:32 牛若觸了奴僕或是婢女，必將銀子三十舍客勒給他們的主人，也要用石頭把牛打死。',
    '出21:33 人若敞著井口，或挖井不遮蓋，有牛或驢掉在裡頭，',
    '出21:34 井主要拿錢賠還本主人，死牲畜要歸自己。',
    '出21:35 這人的牛若傷了那人的牛，以至於死，他們要賣了活牛，平分價值，也要平分死牛。',
    '出21:36 人若知道這牛素來是觸人的，主人竟不把牛拴著，他必要以牛還牛，死牛要歸自己。',
    '出22:1 人若偷牛或羊，無論是宰了，是賣了，他就要以五牛賠一牛，四羊賠一羊。',
    '出22:2 人若遇見賊挖窟窿，把賊打了，以至於死，就不能為他有流血的罪。',
    '出22:3 若太陽已經出來，就為他有流血的罪。賊若被拿，總要賠還。若他一無所有，就要被賣，頂他所偷的物。',
    '出22:4 若他所偷的，或牛，或驢，或羊，仍在他手下存活，他就要加倍賠還。',
    '出22:5 人若在田間或在葡萄園裡放牲畜，任憑牲畜上別人的田裡去吃，就必拿自己田間上好的和葡萄園上好的賠還。',
    '出22:6 若點火焚燒荊棘，以致將別人堆積的禾捆，站著的禾稼，或是田園，都燒盡了，那點火的必要賠還。',
    '出22:7 人若將銀錢或家具交付鄰舍看守，這物從那人的家被偷去，若把賊找到了，賊要加倍賠還；',
    '出22:8 若找不到賊，那家主必就近審判官，要看看他拿了原主的物件沒有。',
    '出22:9 兩個人的案件，無論是為什麼過犯，或是為牛，為驢，為羊，為衣裳，或是為什麼失掉之物，有一人說：這是我的，兩造就要將案件稟告審判官，審判官定誰有罪，誰就要加倍賠還。',
    '出22:10 人若將驢，或牛，或羊，或別的牲畜，交付鄰舍看守，牲畜或死，或受傷，或被趕去，無人看見，',
    '出22:11 那看守的人要憑著耶和華起誓，手裡未曾拿鄰舍的物，本主就要罷休，看守的人不必賠還。',
    '出22:12 牲畜若從看守的那裡被偷去，他就要賠還本主；',
    '出22:13 若被野獸撕碎，看守的要帶來當作證據，所撕的不必賠還。',
    '出22:14 人若向鄰舍借什麼，所借的或受傷，或死，本主沒有同在一處，借的人總要賠還；',
    '出22:15 若本主同在一處，他就不必賠還；若是雇的，也不必賠還，本是為雇價來的。',
    '出22:16 人若引誘沒有受聘的處女，與他行淫，他總要交出聘禮，娶他為妻。',
    '出22:17 若女子的父親決不肯將女子給他，他就要按處女的聘禮，交出錢來。',
    '出22:18 行邪術的女人，不可容他存活。',
    '出22:19 凡與獸淫合的，總要把他治死。',
    '出22:20 祭祀別神，不單單祭祀耶和華的，那人必要滅絕。',
    '出22:21 不可虧負寄居的，也不可欺壓他，因為你們在埃及地也作過寄居的。',
    '出22:22 不可苦待寡婦和孤兒；',
    '出22:23 若是苦待他們一點，他們向我一哀求，我總要聽他們的哀聲，',
    '出22:24 並要發烈怒，用刀殺你們，使你們的妻子為寡婦，兒女為孤兒。',
    '出22:25 我民中有貧窮人與你同住，你若借錢給他，不可如放債的向他取利。',
    '出22:26 你即或拿鄰舍的衣服作當頭，必在日落以先歸還他；',
    '出22:27 因他只有這一件當蓋頭，是他蓋身的衣服，若是沒有，他拿什麼睡覺呢﹖他哀求我，我就應允，因為我是有恩惠的。',
    '出22:28 不可毀謗神；也不可毀謗你百姓的官長。',
    '出22:29 你要從你莊稼中的穀和酒醡中滴出來的酒拿來獻上，不可遲延。你要將頭生的兒子歸給我。',
    '出22:30 你牛羊頭生的，也要這樣；七天當跟著母，第八天要歸給我。',
    '出22:31 你們要在我面前為聖潔的人。因此，田間被野獸撕裂牲畜的肉，你們不可吃，要丟給狗吃。',
    '出23:1 不可隨夥佈散謠言；不可與惡人連手妄作見證。',
    '出23:2 不可隨眾行惡；不可在爭訟的事上隨眾偏行，作見證屈枉正直；',
    '出23:3 也不可在爭訟的事上偏護窮人。',
    '出23:4 若遇見你仇敵的牛或驢失迷了路，總要牽回來交給他。',
    '出23:5 若看見恨你人的驢壓臥在重馱之下，不可走開，務要和驢主一同擡開重馱。',
    '出23:6 不可在窮人爭訟的事上屈枉正直。',
    '出23:7 當遠離虛假的事。不可殺無辜和有義的人，因我必不以惡人為義。',
    '出23:8 不可受賄賂；因為賄賂能叫明眼人變瞎了，又能顛倒義人的話。',
    '出23:9 不可欺壓寄居的；因為你們在埃及地作過寄居的，知道寄居的心。',
    '出23:10 六年你要耕種田地，收藏土產，',
    '出23:11 只是第七年要叫地歇息，不耕不種，使你民中的窮人有吃的；他們所剩下的，野獸可以吃。你的葡萄園和橄欖園也要照樣辦理。',
    '出23:12 六日你要做工，第七日要安息，使牛、驢可以歇息，並使你婢女的兒子和寄居的都可以舒暢。',
    '出23:13 凡我對你們說的話，你們要謹守。別神的名，你不可提，也不可從你口中傳說。',
    '出23:14 一年三次，你要向我守節。',
    '出23:15 你要守除酵節，照我所吩咐你的，在亞筆月內所定的日期，吃無酵餅七天。誰也不可空手朝見我，因為你是這月出了埃及。',
    '出23:16 又要守收割節，所收的是你田間所種、勞碌得來初熟之物。並在年底收藏，要守收藏節。',
    '出23:17 一切的男丁要一年三次朝見主耶和華。',
    '出23:18 不可將我祭牲的血和有酵的餅一同獻上；也不可將我節上祭牲的脂油留到早晨。',
    '出23:19 地裡首先初熟之物要送到耶和華─你神的殿。不可用山羊羔母的奶煮山羊羔。',
    '出23:20 看哪，我差遣使者在你前面，在路上保護你，領你到我所預備的地方去。',
    '出23:21 他是奉我名來的；你們要在他面前謹慎，聽從他的話，不可惹（惹或作：違背）他，因為他必不赦免你們的過犯。',
    '出23:22 你若實在聽從他的話，照著我一切所說的去行，我就向你的仇敵作仇敵，向你的敵人作敵人。',
    '出23:23 我的使者要在你前面行，領你到亞摩利人、赫人、比利洗人、迦南人、希未人、耶布斯人那裡去，我必將他們剪除。',
    '出23:24 你不可跪拜他們的神，不可事奉他，也不可效法他們的行為，卻要把神像盡行拆毀，打碎他們的柱像。',
    '出23:25 你們要事奉耶和華─你們的神，他必賜福與你的糧與你的水，也必從你們中間除去疾病。',
    '出23:26 你境內必沒有墜胎的，不生產的。我要使你滿了你年日的數目。',
    '出23:27 凡你所到的地方，我要使那裡的眾民在你面前驚駭，擾亂，又要使你一切仇敵轉背逃跑。',
    '出23:28 我要打發黃蜂飛在你前面，把希未人、迦南人、赫人攆出去。',
    '出23:29 我不在一年之內將他們從你面前攆出去，恐怕地成為荒涼，野地的獸多起來害你。',
    '出23:30 我要漸漸地將他們從你面前攆出去，等到你的人數加多，承受那地為業。',
    '出23:31 我要定你的境界，從紅海直到非利士海，又從曠野直到大河。我要將那地的居民交在你手中，你要將他們從你面前攆出去。',
    '出23:32 不可和他們並他們的神立約。',
    '出23:33 他們不可住在你的地上，恐怕他們使你得罪我。你若事奉他們的神，這必成為你的網羅。',
    '出24:1 耶和華對摩西說：你和亞倫、拿答、亞比戶，並以色列長老中的七十人，都要上到我這裡來，遠遠的下拜。',
    '出24:2 惟獨你可以親近耶和華；他們卻不可親近；百姓也不可和你一同上來。',
    '出24:3 摩西下山，將耶和華的命令典章都述說與百姓聽。眾百姓齊聲說：耶和華所吩咐的，我們都必遵行。',
    '出24:4 摩西將耶和華的命令都寫上。清早起來，在山下築一座壇，按以色列十二支派立十二根柱子，',
    '出24:5 又打發以色列人中的少年人去獻燔祭，又向耶和華獻牛為平安祭。',
    '出24:6 摩西將血一半盛在盆中，一半灑在壇上；',
    '出24:7 又將約書念給百姓聽。他們說：耶和華所吩咐的，我們都必遵行。',
    '出24:8 摩西將血灑在百姓身上，說：你看！這是立約的血，是耶和華按這一切話與你們立約的憑據。',
    '出24:9 摩西、亞倫、拿答、亞比戶，並以色列長老中的七十人，都上了山。',
    '出24:10 他們看見以色列的神，他腳下彷彿有平鋪的藍寶石，如同天色明淨。',
    '出24:11 他的手不加害在以色列的尊者身上。他們觀看神；他們又吃又喝。',
    '出24:12 耶和華對摩西說：你上山到我這裡來，住在這裡，我要將石版並我所寫的律法和誡命賜給你，使你可以教訓百姓。',
    '出24:13 摩西和他的幫手約書亞起來，上了神的山。',
    '出24:14 摩西對長老說：你們在這裡等著，等到我們再回來，有亞倫、戶珥與你們同在。凡有爭訟的，都可以就近他們去。',
    '出24:15 摩西上山，有雲彩把山遮蓋。',
    '出24:16 耶和華的榮耀停於西乃山；雲彩遮蓋山六天，第七天他從雲中召摩西。',
    '出24:17 耶和華的榮耀在山頂上，在以色列人眼前，形狀如烈火。',
    '出24:18 摩西進入雲中上山，在山上四十晝夜。',
    '出25:1 耶和華曉諭摩西說：',
    '出25:2 你告訴以色列人當為我送禮物來；凡甘心樂意的，你們就可以收下歸我。',
    '出25:3 所要收的禮物：就是金、銀、銅，',
    '出25:4 藍色、紫色、朱紅色線，細麻，山羊毛，',
    '出25:5 染紅的公羊皮，海狗皮，皂莢木，',
    '出25:6 點燈的油並做膏油和香的香料，',
    '出25:7 紅瑪瑙與別樣的寶石，可以鑲嵌在以弗得和胸牌上。',
    '出25:8 又當為我造聖所，使我可以住在他們中間。',
    '出25:9 製造帳幕和其中的一切器具都要照我所指示你的樣式。',
    '出25:10 要用皂莢木做一櫃，長二肘半，寬一肘半，高一肘半。',
    '出25:11 要裡外包上精金，四圍鑲上金牙邊。',
    '出25:12 也要鑄四個金環，安在櫃的四腳上；這邊兩環，那邊兩環。',
    '出25:13 要用皂莢木做兩根槓，用金包裹。',
    '出25:14 要把槓穿在櫃旁的環內，以便擡櫃。',
    '出25:15 這槓要常在櫃的環內，不可抽出來。',
    '出25:16 必將我所要賜給你的法版放在櫃裡。',
    '出25:17 要用精金做施恩座（施恩：或作蔽罪；下同），長二肘半，寬一肘半。',
    '出25:18 要用金子錘出兩個基路伯來，安在施恩座的兩頭。',
    '出25:19 這頭做一個基路伯，那頭做一個基路伯，二基路伯要接連一塊，在施恩座的兩頭。',
    '出25:20 二基路伯要高張翅膀，遮掩施恩座。基路伯要臉對臉，朝著施恩座。',
    '出25:21 要將施恩座安在櫃的上邊，又將我所要賜給你的法版放在櫃裡。',
    '出25:22 我要在那裡與你相會，又要從法櫃施恩座上二基路伯中間，和你說我所要吩咐你傳給以色列人的一切事。',
    '出25:23 要用皂莢木做一張桌子，長二肘，寬一肘，高一肘半。',
    '出25:24 要包上精金，四圍鑲上金牙邊。',
    '出25:25 桌子的四圍各做一掌寬的橫梁，橫梁上鑲著金牙邊。',
    '出25:26 要做四個金環，安在桌子的四角上，就是桌子四腳上的四角。',
    '出25:27 安環子的地方要挨近橫梁，可以穿槓擡桌子。',
    '出25:28 要用皂莢木做兩根槓，用金包裹，以便擡桌子。',
    '出25:29 要做桌子上的盤子、調羹，並奠酒的爵和瓶；這都要用精金製作。',
    '出25:30 又要在桌子上，在我面前，常擺陳設餅。',
    '出25:31 要用精金做一個燈臺。燈臺的座和幹與杯、球、花，都要接連一塊錘出來。',
    '出25:32 燈臺兩旁要杈出六個枝子：這旁三個，那旁三個。',
    '出25:33 這旁每枝上有三個杯，形狀像杏花，有球，有花；那旁每枝上也有三個杯，形狀像杏花，有球，有花。從燈臺杈出來的六個枝子都是如此。',
    '出25:34 燈臺上有四個杯，形狀像杏花，有球，有花。',
    '出25:35 燈臺每兩個枝子以下有球與枝子接連一塊。燈臺出的六個枝子都是如此。',
    '出25:36 球和枝子要接連一塊，都是一塊精金錘出來的。',
    '出25:37 要做燈臺的七個燈盞。祭司要點這燈，使燈光對照。',
    '出25:38 燈臺的蠟剪和蠟花盤也是要精金的。',
    '出25:39 做燈臺和這一切的器具要用精金一他連得。',
    '出25:40 要謹慎做這些物件，都要照著在山上指示你的樣式。',
    '出26:1 你要用十幅幔子做帳幕。這些幔子要用撚的細麻和藍色、紫色、朱紅色線製造，並用巧匠的手工繡上基路伯。',
    '出26:2 每幅幔子要長二十八肘，寬四肘，幔子都要一樣的尺寸。',
    '出26:3 這五幅幔子要幅幅相連；那五幅幔子也要幅幅相連。',
    '出26:4 在這相連的幔子末幅邊上要做藍色的鈕扣；在那相連的幔子末幅邊上也要照樣做。',
    '出26:5 要在這相連的幔子上做五十個鈕扣；在那相連的幔子上也做五十個鈕扣，都要兩兩相對。',
    '出26:6 又要做五十個金鉤，用鉤使幔子相連，這才成了一個帳幕。',
    '出26:7 你要用山羊毛織十一幅幔子，作為帳幕以上的罩棚。',
    '出26:8 每幅幔子要長三十肘，寬四肘；十一幅幔子都要一樣的尺寸。',
    '出26:9 要把五幅幔子連成一幅，又把六幅幔子連成一幅，這第六幅幔子要在罩棚的前面摺上去。',
    '出26:10 在這相連的幔子末幅邊上要做五十個鈕扣；在那相連的幔子末幅邊上也做五十個鈕扣。',
    '出26:11 又要做五十個銅鉤，鉤在鈕扣中，使罩棚連成一個。',
    '出26:12 罩棚的幔子所餘那垂下來的半幅幔子，要垂在帳幕的後頭。',
    '出26:13 罩棚的幔子所餘長的，這邊一肘，那邊一肘，要垂在帳幕的兩旁，遮蓋帳幕。',
    '出26:14 又要用染紅的公羊皮做罩棚的蓋；再用海狗皮做一層罩棚上的頂蓋。',
    '出26:15 你要用皂莢木做帳幕的豎板。',
    '出26:16 每塊要長十肘，寬一肘半；',
    '出26:17 每塊必有兩榫相對。帳幕一切的板都要這樣做。',
    '出26:18 帳幕的南面要做板二十塊。',
    '出26:19 在這二十塊板底下要做四十個帶卯的銀座，兩卯接這塊板上的兩榫，兩卯接那塊板上的兩榫。',
    '出26:20 帳幕第二面，就是北面，也要做板二十塊',
    '出26:21 和帶卯的銀座四十個；這板底下有兩卯，那板底下也有兩卯。',
    '出26:22 帳幕的後面，就是西面，要做板六塊。',
    '出26:23 帳幕後面的拐角要做板兩塊。',
    '出26:24 板的下半截要雙的，上半截要整的，直頂到第一個環子；兩塊都要這樣做兩個拐角。',
    '出26:25 必有八塊板和十六個帶卯的銀座；這板底下有兩卯，那板底下也有兩卯。',
    '出26:26 你要用皂莢木做閂：為帳幕這面的板做五閂，',
    '出26:27 為帳幕那面的板做五閂，又為帳幕後面的板做五閂。',
    '出26:28 板腰間的中閂要從這一頭通到那一頭。',
    '出26:29 板要用金子包裹，又要做板上的金環套閂；閂也要用金子包裹。',
    '出26:30 要照著在山上指示你的樣式立起帳幕。',
    '出26:31 你要用藍色、紫色、朱紅色線，和撚的細麻織幔子，以巧匠的手工繡上基路伯。',
    '出26:32 要把幔子掛在四根包金的皂莢木柱子上，柱子上當有金鉤，柱子安在四個帶卯的銀座上。',
    '出26:33 要使幔子垂在鉤子下，把法櫃擡進幔子內；這幔子要將聖所和至聖所隔開。',
    '出26:34 又要把施恩座安在至聖所內的法櫃上，',
    '出26:35 把桌子安在幔子外帳幕的北面；把燈臺安在帳幕的南面，彼此相對。',
    '出26:36 你要拿藍色、紫色、朱紅色線，和撚的細麻，用繡花的手工織帳幕的門簾。',
    '出26:37 要用皂莢木為簾子做五根柱子，用金子包裹。柱子上當有金鉤；又要為柱子用銅鑄造五個帶卯的座。',
    '出27:1 你要用皂莢木做壇。這壇要四方的，長五肘，寬五肘，高三肘。',
    '出27:2 要在壇的四拐角上做四個角，與壇接連一塊，用銅把壇包裹。',
    '出27:3 要做盆，收去壇上的灰，又做鏟子、盤子、肉鍤子、火鼎；壇上一切的器具都用銅做。',
    '出27:4 要為壇做一個銅網，在網的四角上做四個銅環，',
    '出27:5 把網安在壇四面的圍腰板以下，使網從下達到壇的半腰。',
    '出27:6 又要用皂莢木為壇做槓，用銅包裹。',
    '出27:7 這槓要穿在壇兩旁的環子內，用以擡壇。',
    '出27:8 要用板做壇，壇是空的，都照著在山上指示你的樣式做。',
    '出27:9 你要做帳幕的院子。院子的南面要用撚的細麻做帷子，長一百肘。',
    '出27:10 帷子的柱子要二十根，帶卯的銅座二十個。柱子上的鉤子和杆子都要用銀子做。',
    '出27:11 北面也當有帷子，長一百肘，帷子的柱子二十根，帶卯的銅座二十個。柱子上的鉤子和杆子都要用銀子做。',
    '出27:12 院子的西面當有帷子，寬五十肘，帷子的柱子十根，帶卯的座十個。',
    '出27:13 院子的東面要寬五十肘。',
    '出27:14 門這邊的帷子要十五肘，帷子的柱子三根，帶卯的座三個。',
    '出27:15 門那邊的帷子也要十五肘，帷子的柱子三根，帶卯的座三個。',
    '出27:16 院子的門當有簾子，長二十肘，要拿藍色、紫色、朱紅色線，和撚的細麻，用繡花的手工織成，柱子四根，帶卯的座四個。',
    '出27:17 院子四圍一切的柱子都要用銀杆連絡，柱子上的鉤子要用銀做，帶卯的座要用銅做。',
    '出27:18 院子要長一百肘，寬五十肘，高五肘，帷子要用撚的細麻做，帶卯的座要用銅做。',
    '出27:19 帳幕各樣用處的器具，並帳幕一切的橛子，和院子裡一切的橛子，都要用銅做。',
    '出27:20 你要吩咐以色列人，把那為點燈搗成的清橄欖油拿來給你，使燈常常點著。',
    '出27:21 在會幕中法櫃前的幔外，亞倫和他的兒子，從晚上到早晨，要在耶和華面前經理這燈。這要作以色列人世世代代永遠的定例。',
    '出28:1 你要從以色列人中，使你的哥哥亞倫和他的兒子拿答、亞比戶、以利亞撒、以他瑪一同就近你，給我供祭司的職分。',
    '出28:2 你要給你哥哥亞倫做聖衣為榮耀，為華美。',
    '出28:3 又要吩咐一切心中有智慧的，就是我用智慧的靈所充滿的，給亞倫做衣服，使他分別為聖，可以給我供祭司的職分。',
    '出28:4 所要做的就是胸牌、以弗得、外袍、雜色的內袍、冠冕、腰帶，使你哥哥亞倫和他兒子穿這聖服，可以給我供祭司的職分。',
    '出28:5 要用金線和藍色、紫色、朱紅色線，並細麻去做。',
    '出28:6 他們要拿金線和藍色、紫色、朱紅色線，並撚的細麻，用巧匠的手工做以弗得。',
    '出28:7 以弗得當有兩條肩帶，接上兩頭，使他相連。',
    '出28:8 其上巧工織的帶子，要和以弗得一樣的做法，用以束上，與以弗得接連一塊，要用金線和藍色、紫色、朱紅色線，並撚的細麻做成。',
    '出28:9 要取兩塊紅瑪瑙，在上面刻以色列兒子的名字：',
    '出28:10 六個名字在這塊寶石上，六個名字在那塊寶石上，都照他們生來的次序。',
    '出28:11 要用刻寶石的手工，彷彿刻圖書，按著以色列兒子的名字，刻這兩塊寶石，要鑲在金槽上。',
    '出28:12 要將這兩塊寶石安在以弗得的兩條肩帶上，為以色列人做記念石。亞倫要在兩肩上擔他們的名字，在耶和華面前作為記念。',
    '出28:13 要用金子做二槽，',
    '出28:14 又拿精金，用擰工彷彿擰繩子，做兩條鍊子，把這擰成的鍊子搭在二槽上。',
    '出28:15 你要用巧匠的手工做一個決斷的胸牌。要和以弗得一樣的做法：用金線和藍色、紫色、朱紅色線，並撚的細麻做成。',
    '出28:16 這胸牌要四方的，疊為兩層，長一虎口，寬一虎口。',
    '出28:17 要在上面鑲寶石四行：第一行是紅寶石、紅璧璽、紅玉；',
    '出28:18 第二行是綠寶石、藍寶石、金鋼石；',
    '出28:19 第三行是紫瑪瑙、白瑪瑙、紫晶；',
    '出28:20 第四行是水蒼玉、紅瑪瑙、碧玉。這都要鑲在金槽中。',
    '出28:21 這些寶石都要按著以色列十二個兒子的名字，彷彿刻圖書，刻十二個支派的名字。',
    '出28:22 要在胸牌上用精金擰成如繩的鍊子。',
    '出28:23 在胸牌上也要做兩個金環，安在胸牌的兩頭。',
    '出28:24 要把那兩條擰成的金鍊子，穿過胸牌兩頭的環子。',
    '出28:25 又要把鍊子的那兩頭接在兩槽上，安在以弗得前面肩帶上。',
    '出28:26 要做兩個金環，安在胸牌的兩頭，在以弗得裡面的邊上。',
    '出28:27 又要做兩個金環，安在以弗得前面兩條肩帶的下邊，挨近相接之處，在以弗得巧工織的帶子以上。',
    '出28:28 要用藍細帶子把胸牌的環子與以弗得的環子繫住，使胸牌貼在以弗得巧工織的帶子上，不可與以弗得離縫。',
    '出28:29 亞倫進聖所的時候，要將決斷胸牌，就是刻著以色列兒子名字的，帶在胸前，在耶和華面前常作記念。',
    '出28:30 又要將烏陵和土明放在決斷的胸牌裡；亞倫進到耶和華面前的時候，要帶在胸前，在耶和華面前常將以色列人的決斷牌帶在胸前。',
    '出28:31 你要做以弗得的外袍，顏色全是藍的。',
    '出28:32 袍上要為頭留一領口，口的周圍織出領邊來，彷彿鎧甲的領口，免得破裂。',
    '出28:33 袍子周圍底邊上要用藍色、紫色、朱紅色線做石榴。在袍子周圍的石榴中間要有金鈴鐺：',
    '出28:34 一個金鈴鐺一個石榴，一個金鈴鐺一個石榴，在袍子周圍的底邊上。',
    '出28:35 亞倫供職的時候要穿這袍子。他進聖所到耶和華面前，以及出來的時候，袍上的響聲必被聽見，使他不至於死亡。',
    '出28:36 你要用精金做一面牌，在上面按刻圖書之法刻著歸耶和華為聖。',
    '出28:37 要用一條藍細帶子將牌繫在冠冕的前面。',
    '出28:38 這牌必在亞倫的額上，亞倫要擔當干犯聖物條例的罪孽；這聖物是以色列人在一切的聖禮物上所分別為聖的。這牌要常在他的額上，使他們可以在耶和華面前蒙悅納。',
    '出28:39 要用雜色細麻線織內袍，用細麻布做冠冕，又用繡花的手工做腰帶。',
    '出28:40 你要為亞倫的兒子做內袍、腰帶、裹頭巾，為榮耀，為華美。',
    '出28:41 要把這些給你的哥哥亞倫和他的兒子穿戴，又要膏他們，將他們分別為聖，好給我供祭司的職分。',
    '出28:42 要給他們做細麻布褲子，遮掩下體；褲子當從腰達到大腿。',
    '出28:43 亞倫和他兒子進入會幕，或就近壇，在聖所供職的時候必穿上，免得擔罪而死。這要為亞倫和他的後裔作永遠的定例。',
    '出29:1 你使亞倫和他兒子成聖，給我供祭司的職分，要如此行：取一隻公牛犢，兩隻無殘疾的公綿羊，',
    '出29:2 無酵餅和調油的無酵餅，與抹油的無酵薄餅；這都要用細麥麵做成。',
    '出29:3 這餅要裝在一個筐子裡，連筐子帶來，又把公牛和兩隻公綿羊牽來。',
    '出29:4 要使亞倫和他兒子到會幕門口來，用水洗身。',
    '出29:5 要給亞倫穿上內袍和以弗得的外袍，並以弗得，又帶上胸牌，束上以弗得巧工織的帶子。',
    '出29:6 把冠冕戴在他頭上，將聖冠加在冠冕上，',
    '出29:7 就把膏油倒在他頭上膏他。',
    '出29:8 要叫他的兒子來，給他們穿上內袍。',
    '出29:9 給亞倫和他兒子束上腰帶，包上裹頭巾，他們就憑永遠的定例得了祭司的職任。又要將亞倫和他兒子分別為聖。',
    '出29:10 你要把公牛牽到會幕前，亞倫和他兒子要按手在公牛的頭上。',
    '出29:11 你要在耶和華面前，在會幕門口，宰這公牛。',
    '出29:12 要取些公牛的血，用指頭抹在壇的四角上，把血都倒在壇腳那裡。',
    '出29:13 要把一切蓋臟的脂油與肝上的網子，並兩個腰子和腰子上的脂油，都燒在壇上。',
    '出29:14 只是公牛的皮、肉、糞都要用火燒在營外。這牛是贖罪祭。',
    '出29:15 你要牽一隻公綿羊來，亞倫和他兒子要按手在這羊的頭上。',
    '出29:16 要宰這羊，把血灑在壇的周圍。',
    '出29:17 要把羊切成塊子，洗淨五臟和腿，連塊子帶頭，都放在一處。',
    '出29:18 要把全羊燒在壇上，是給耶和華獻的燔祭，是獻給耶和華為馨香的火祭。',
    '出29:19 你要將那一隻公綿羊牽來，亞倫和他兒子要按手在羊的頭上。',
    '出29:20 你要宰這羊，取點血抹在亞倫的右耳垂上和他兒子的右耳垂上，又抹在他們右手的大拇指上和右腳的大拇指上；並要把血灑在壇的四圍。',
    '出29:21 你要取點膏油和壇上的血，彈在亞倫和他的衣服上，並他兒子和他兒子的衣服上，他們和他們的衣服就一同成聖。',
    '出29:22 你要取這羊的脂油和肥尾巴，並蓋臟的脂油與肝上的網子，兩個腰子和腰子上的脂油並右腿（這是承接聖職所獻的羊）。',
    '出29:23 再從耶和華面前裝無酵餅的筐子中取一個餅，一個調油的餅和一個薄餅，',
    '出29:24 都放在亞倫的手上和他兒子的手上，作為搖祭，在耶和華面前搖一搖。',
    '出29:25 要從他們手中接過來，燒在耶和華面前壇上的燔祭上，是獻給耶和華為馨香的火祭。',
    '出29:26 你要取亞倫承接聖職所獻公羊的胸，作為搖祭，在耶和華面前搖一搖，這就可以作你的分。',
    '出29:27 那搖祭的胸和舉祭的腿，就是承接聖職所搖的、所舉的，是歸亞倫和他兒子的。這些你都要成為聖，',
    '出29:28 作亞倫和他子孫從以色列人中永遠所得的分，因為是舉祭。這要從以色列人的平安祭中，作為獻給耶和華的舉祭。',
    '出29:29 亞倫的聖衣要留給他的子孫，可以穿著受膏，又穿著承接聖職。',
    '出29:30 他的子孫接續他當祭司的，每逢進會幕在聖所供職的時候，要穿七天。',
    '出29:31 你要將承接聖職所獻公羊的肉煮在聖處。',
    '出29:32 亞倫和他兒子要在會幕門口吃這羊的肉和筐內的餅。',
    '出29:33 他們吃那些贖罪之物，好承接聖職，使他們成聖；只是外人不可吃，因為這是聖物。',
    '出29:34 那承接聖職所獻的肉或餅，若有一點留到早晨，就要用火燒了，不可吃這物，因為是聖物。',
    '出29:35 你要這樣照我一切所吩咐的，向亞倫和他兒子行承接聖職的禮七天。',
    '出29:36 每天要獻公牛一隻為贖罪祭。你潔淨壇的時候，壇就潔淨了；且要用膏抹壇，使壇成聖。',
    '出29:37 要潔淨壇七天，使壇成聖，壇就成為至聖。凡挨著壇的都成為聖。',
    '出29:38 你每天所要獻在壇上的就是兩隻一歲的羊羔；',
    '出29:39 早晨要獻這一隻，黃昏的時候要獻那一隻。',
    '出29:40 和這一隻羊羔同獻的，要用細麵伊法十分之一與搗成的油一欣四分之一調和，又用酒一欣四分之一作為奠祭。',
    '出29:41 那一隻羊羔要在黃昏的時候獻上，照著早晨的素祭和奠祭的禮辦理，作為獻給耶和華馨香的火祭。',
    '出29:42 這要在耶和華面前、會幕門口，作你們世世代代常獻的燔祭。我要在那裡與你們相會，和你們說話。',
    '出29:43 我要在那裡與以色列人相會，會幕就要因我的榮耀成為聖。',
    '出29:44 我要使會幕和壇成聖，也要使亞倫和他的兒子成聖，給我供祭司的職分。',
    '出29:45 我要住在以色列人中間，作他們的神。',
    '出29:46 他們必知道我是耶和華─他們的神，是將他們從埃及地領出來的，為要住在他們中間。我是耶和華─他們的神。',
    '出30:1 你要用皂莢木做一座燒香的壇。',
    '出30:2 這壇要四方的，長一肘，寬一肘，高二肘；壇的四角要與壇接連一塊。',
    '出30:3 要用精金把壇的上面與壇的四圍，並壇的四角包裹；又要在壇的四圍鑲上金牙邊。',
    '出30:4 要做兩個金環安在牙子邊以下，在壇的兩旁，兩根橫撐上，作為穿槓的用處，以便擡壇。',
    '出30:5 要用皂莢木做槓，用金包裹。',
    '出30:6 要把壇放在法櫃前的幔子外，對著法櫃上的施恩座，就是我要與你相會的地方。',
    '出30:7 亞倫在壇上要燒馨香料做的香；每早晨他收拾燈的時候，要燒這香。',
    '出30:8 黃昏點燈的時候，他要在耶和華面前燒這香，作為世世代代常燒的香。',
    '出30:9 在這壇上不可奉上異樣的香，不可獻燔祭、素祭，也不可澆上奠祭。',
    '出30:10 亞倫一年一次要在壇的角上行贖罪之禮。他一年一次要用贖罪祭牲的血在壇上行贖罪之禮，作為世世代代的定例。這壇在耶和華面前為至聖。',
    '出30:11 耶和華曉諭摩西說：',
    '出30:12 你要按以色列人被數的，計算總數，你數的時候，他們各人要為自己的生命把贖價奉給耶和華，免得數的時候在他們中間有災殃。',
    '出30:13 凡過去歸那些被數之人的，每人要按聖所的平，拿銀子半舍客勒；這半舍客勒是奉給耶和華的禮物（一舍客勒是二十季拉）。',
    '出30:14 凡過去歸那些被數的人，從二十歲以外的，要將這禮物奉給耶和華。',
    '出30:15 他們為贖生命將禮物奉給耶和華，富足的不可多出，貧窮的也不可少出，各人要出半舍客勒。',
    '出30:16 你要從以色列人收這贖罪銀，作為會幕的使用，可以在耶和華面前為以色列人作記念，贖生命。',
    '出30:17 耶和華曉諭摩西說：',
    '出30:18 你要用銅做洗濯盆和盆座，以便洗濯。要將盆放在會幕和壇的中間，在盆裡盛水。',
    '出30:19 亞倫和他的兒子要在這盆裡洗手洗腳。',
    '出30:20 他們進會幕，或是就近壇前供職給耶和華獻火祭的時候，必用水洗濯，免得死亡。',
    '出30:21 他們洗手洗腳就免得死亡。這要作亞倫和他後裔世世代代永遠的定例。',
    '出30:22 耶和華曉諭摩西說：',
    '出30:23 你要取上品的香料，就是流質的沒藥五百舍客勒，香肉桂一半，就是二百五十舍客勒，菖蒲二百五十舍客勒，',
    '出30:24 桂皮五百舍客勒，都按著聖所的平，又取橄欖油一欣，',
    '出30:25 按做香之法調和做成聖膏油。',
    '出30:26 要用這膏油抹會幕和法櫃，',
    '出30:27 桌子與桌子的一切器具，燈臺和燈臺的器具，並香壇、',
    '出30:28 燔祭壇，和壇的一切器具，洗濯盆和盆座。',
    '出30:29 要使這些物成為聖，好成為至聖；凡挨著的都成為聖。',
    '出30:30 要膏亞倫和他的兒子，使他們成為聖，可以給我供祭司的職分。',
    '出30:31 你要對以色列人說：這油，我要世世代代以為聖膏油。',
    '出30:32 不可倒在別人的身上，也不可按這調和之法做與此相似的。這膏油是聖的，你們也要以為聖。',
    '出30:33 凡調和與此相似的，或將這膏膏在別人身上的，這人要從民中剪除。',
    '出30:34 耶和華吩咐摩西說：你要取馨香的香料，就是拿他弗、施喜列、喜利比拿；這馨香的香料和淨乳香各樣要一般大的分量。',
    '出30:35 你要用這些加上鹽，按做香之法做成清淨聖潔的香。',
    '出30:36 這香要取點搗得極細，放在會幕內、法櫃前，我要在那裡與你相會。你們要以這香為至聖。',
    '出30:37 你們不可按這調和之法為自己做香；要以這香為聖，歸耶和華。',
    '出30:38 凡做香和這香一樣，為要聞香味的，這人要從民中剪除。',
    '出31:1 耶和華曉諭摩西說：',
    '出31:2 看哪，猶大支派中，戶珥的孫子、烏利的兒子比撒列，我已經提他的名召他。',
    '出31:3 我也以我的靈充滿了他，使他有智慧，有聰明，有知識，能做各樣的工，',
    '出31:4 能想出巧工，用金、銀、銅製造各物，',
    '出31:5 又能刻寶石，可以鑲嵌，能雕刻木頭，能做各樣的工。',
    '出31:6 我分派但支派中、亞希撒抹的兒子亞何利亞伯與他同工。凡心裡有智慧的，我更使他們有智慧，能做我一切所吩咐的，',
    '出31:7 就是會幕和法櫃，並其上的施恩座，與會幕中一切的器具，',
    '出31:8 桌子和桌子的器具，精金的燈臺和燈臺的一切器具並香壇，',
    '出31:9 燔祭壇和壇的一切器具，並洗濯盆與盆座，',
    '出31:10 精工做的禮服，和祭司亞倫並他兒子用以供祭司職分的聖衣，',
    '出31:11 膏油和為聖所用馨香的香料。他們都要照我一切所吩咐的去做。',
    '出31:12 耶和華曉諭摩西說：',
    '出31:13 你要吩咐以色列人說：你們務要守我的安息日；因為這是你我之間世世代代的證據，使你們知道我─耶和華是叫你們成為聖的。',
    '出31:14 所以你們要守安息日，以為聖日。凡干犯這日的，必要把他治死；凡在這日做工的，必從民中剪除。',
    '出31:15 六日要做工，但第七日是安息聖日，是向耶和華守為聖的。凡在安息日做工的，必要把他治死。',
    '出31:16 故此，以色列人要世世代代守安息日為永遠的約。',
    '出31:17 這是我和以色列人永遠的證據；因為六日之內耶和華造天地，第七日便安息舒暢。',
    '出31:18 耶和華在西乃山和摩西說完了話，就把兩塊法版交給他，是神用指頭寫的石版。',
    '出32:1 百姓見摩西遲延不下山，就大家聚集到亞倫那裡，對他說：起來！為我們做神像，可以在我們前面引路；因為領我們出埃及地的那個摩西，我們不知道他遭了什麼事。',
    '出32:2 亞倫對他們說：你們去摘下你們妻子、兒女耳上的金環，拿來給我。',
    '出32:3 百姓就都摘下他們耳上的金環，拿來給亞倫。',
    '出32:4 亞倫從他們手裡接過來，鑄了一隻牛犢，用雕刻的器具做成。他們就說：以色列啊，這是領你出埃及地的神。',
    '出32:5 亞倫看見，就在牛犢面前築壇，且宣告說：明日要向耶和華守節。',
    '出32:6 次日清早，百姓起來獻燔祭和平安祭，就坐下吃喝，起來玩耍。',
    '出32:7 耶和華吩咐摩西說：下去吧，因為你的百姓，就是你從埃及地領出來的，已經敗壞了。',
    '出32:8 他們快快偏離了我所吩咐的道，為自己鑄了一隻牛犢，向他下拜獻祭，說：以色列啊，這就是領你出埃及地的神。',
    '出32:9 耶和華對摩西說：我看這百姓真是硬著頸項的百姓。',
    '出32:10 你且由著我，我要向他們發烈怒，將他們滅絕，使你的後裔成為大國。',
    '出32:11 摩西便懇求耶和華─他的神說：耶和華啊，你為什麼向你的百姓發烈怒呢﹖這百姓是你用大力和大能的手從埃及地領出來的。',
    '出32:12 為什麼使埃及人議論說他領他們出去，是要降禍與他們，把他們殺在山中，將他們從地上除滅﹖求你轉意，不發你的烈怒；後悔，不降禍與你的百姓。',
    '出32:13 求你記念你的僕人亞伯拉罕、以撒、以色列。你曾指著自己起誓說：我必使你們的後裔像天上的星那樣多，並且我所應許的這全地，必給你們的後裔，他們要永遠承受為業。',
    '出32:14 於是耶和華後悔，不把所說的禍降與他的百姓。',
    '出32:15 摩西轉身下山，手裡拿著兩塊法版。這版是兩面寫的，這面那面都有字，',
    '出32:16 是神的工作，字是神寫的，刻在版上。',
    '出32:17 約書亞一聽見百姓呼喊的聲音，就對摩西說：在營裡有爭戰的聲音。',
    '出32:18 摩西說：這不是人打勝仗的聲音，也不是人打敗仗的聲音，我所聽見的乃是人歌唱的聲音。',
    '出32:19 摩西挨近營前就看見牛犢，又看見人跳舞，便發烈怒，把兩塊版扔在山下摔碎了，',
    '出32:20 又將他們所鑄的牛犢用火焚燒，磨得粉碎，撒在水面上，叫以色列人喝。',
    '出32:21 摩西對亞倫說：這百姓向你做了什麼﹖你竟使他們陷在大罪裡！',
    '出32:22 亞倫說：求我主不要發烈怒。這百姓專於作惡，是你知道的。',
    '出32:23 他們對我說：你為我們做神像，可以在我們前面引路；因為領我們出埃及地的那個摩西，我們不知道他遭了什麼事。',
    '出32:24 我對他們說：凡有金環的可以摘下來，他們就給了我。我把金環扔在火中，這牛犢便出來了。',
    '出32:25 摩西見百姓放肆（亞倫縱容他們，使他們在仇敵中間被譏刺），',
    '出32:26 就站在營門中，說：凡屬耶和華的，都要到我這裡來！於是利未的子孫都到他那裡聚集。',
    '出32:27 他對他們說：耶和華─以色列的神這樣說：你們各人把刀跨在腰間，在營中往來，從這門到那門，各人殺他的弟兄與同伴並鄰舍。',
    '出32:28 利未的子孫照摩西的話行了。那一天百姓中被殺的約有三千。',
    '出32:29 摩西說：今天你們要自潔，歸耶和華為聖，各人攻擊他的兒子和弟兄，使耶和華賜福與你們。',
    '出32:30 到了第二天，摩西對百姓說：你們犯了大罪。我如今要上耶和華那裡去，或者可以為你們贖罪。',
    '出32:31 摩西回到耶和華那裡，說：唉！這百姓犯了大罪，為自己做了金像。',
    '出32:32 倘或你肯赦免他們的罪……不然，求你從你所寫的冊上塗抹我的名。',
    '出32:33 耶和華對摩西說：誰得罪我，我就從我的冊上塗抹誰的名。',
    '出32:34 現在你去領這百姓，往我所告訴你的地方去，我的使者必在你前面引路；只是到我追討的日子，我必追討他們的罪。',
    '出32:35 耶和華殺百姓的緣故，是因他們同亞倫做了牛犢。',
    '出33:1 耶和華吩咐摩西說：我曾起誓應許亞伯拉罕、以撒、雅各說：要將迦南地賜給你的後裔。現在你和你從埃及地所領出來的百姓，要從這裡往那地去。',
    '出33:2 我要差遣使者在你前面，攆出迦南人、亞摩利人、赫人、比利洗人、希未人、耶布斯人，',
    '出33:3 領你到那流奶與蜜之地。我自己不同你們上去；因為你們是硬著頸項的百姓，恐怕我在路上把你們滅絕。',
    '出33:4 百姓聽見這凶信就悲哀，也沒有人佩戴妝飾。',
    '出33:5 耶和華對摩西說：你告訴以色列人說：耶和華說：你們是硬著頸項的百姓，我若一霎時臨到你們中間，必滅絕你們。現在你們要把身上的妝飾摘下來，使我可以知道怎樣待你們。',
    '出33:6 以色列人從住何烈山以後，就把身上的妝飾摘得乾淨。',
    '出33:7 摩西素常將帳棚支搭在營外，離營卻遠，他稱這帳棚為會幕。凡求問耶和華的，就到營外的會幕那裡去。',
    '出33:8 當摩西出營到會幕去的時候，百姓就都起來，各人站在自己帳棚的門口，望著摩西，直等到他進了會幕。',
    '出33:9 摩西進會幕的時候，雲柱降下來，立在會幕的門前，耶和華便與摩西說話。',
    '出33:10 眾百姓看見雲柱立在會幕門前，就都起來，各人在自己帳棚的門口下拜。',
    '出33:11 耶和華與摩西面對面說話，好像人與朋友說話一般。摩西轉到營裡去，惟有他的幫手─一個少年人嫩的兒子約書亞不離開會幕。',
    '出33:12 摩西對耶和華說：你吩咐我說：將這百姓領上去，卻沒有叫我知道你要打發誰與我同去，只說：我按你的名認識你，你在我眼前也蒙了恩。',
    '出33:13 我如今若在你眼前蒙恩，求你將你的道指示我，使我可以認識你，好在你眼前蒙恩。求你想到這民是你的民。',
    '出33:14 耶和華說：我必親自和你同去，使你得安息。',
    '出33:15 摩西說：你若不親自和我同去，就不要把我們從這裡領上去。',
    '出33:16 人在何事上得以知道我和你的百姓在你眼前蒙恩呢﹖豈不是因你與我們同去、使我和你的百姓與地上的萬民有分別嗎﹖',
    '出33:17 耶和華對摩西說：你這所求的我也要行；因為你在我眼前蒙了恩，並且我按你的名認識你。',
    '出33:18 摩西說：求你顯出你的榮耀給我看。',
    '出33:19 耶和華說：我要顯我一切的恩慈，在你面前經過，宣告我的名。我要恩待誰就恩待誰；要憐憫誰就憐憫誰；',
    '出33:20 又說：你不能看見我的面，因為人見我的面不能存活。',
    '出33:21 耶和華說：看哪，在我這裡有地方，你要站在磐石上。',
    '出33:22 我的榮耀經過的時候，我必將你放在磐石穴中，用我的手遮掩你，等我過去，',
    '出33:23 然後我要將我的手收回，你就得見我的背，卻不得見我的面。',
    '出34:1 耶和華吩咐摩西說：你要鑿出兩塊石版，和先前你摔碎的那版一樣；其上的字我要寫在這版上。',
    '出34:2 明日早晨，你要預備好了，上西乃山，在山頂上站在我面前。',
    '出34:3 誰也不可和你一同上去，遍山都不可有人，在山根也不可叫羊群牛群吃草。',
    '出34:4 摩西就鑿出兩塊石版，和先前的一樣。清晨起來，照耶和華所吩咐的上西乃山去，手裡拿著兩塊石版。',
    '出34:5 耶和華在雲中降臨，和摩西一同站在那裡，宣告耶和華的名。',
    '出34:6 耶和華在他面前宣告說：耶和華，耶和華，是有憐憫有恩典的神，不輕易發怒，並有豐盛的慈愛和誠實，',
    '出34:7 為千萬人存留慈愛，赦免罪孽、過犯，和罪惡，萬不以有罪的為無罪，必追討他的罪，自父及子，直到三、四代。',
    '出34:8 摩西急忙伏地下拜，',
    '出34:9 說：主啊，我若在你眼前蒙恩，求你在我們中間同行，因為這是硬著頸項的百姓。又求你赦免我們的罪孽和罪惡，以我們為你的產業。',
    '出34:10 耶和華說：我要立約，要在百姓面前行奇妙的事，是在遍地萬國中所未曾行的。在你四圍的外邦人就要看見耶和華的作為，因我向你所行的是可畏懼的事。',
    '出34:11 我今天所吩咐你的，你要謹守。我要從你面前攆出亞摩利人、迦南人、赫人、比利洗人、希未人、耶布斯人。',
    '出34:12 你要謹慎，不可與你所去那地的居民立約，恐怕成為你們中間的網羅；',
    '出34:13 卻要拆毀他們的祭壇，打碎他們的柱像，砍下他們的木偶。',
    '出34:14 不可敬拜別神；因為耶和華是忌邪的神，名為忌邪者。',
    '出34:15 只怕你與那地的居民立約，百姓隨從他們的神，就行邪淫，祭祀他們的神，有人叫你，你便吃他的祭物，',
    '出34:16 又為你的兒子娶他們的女兒為妻，他們的女兒隨從他們的神，就行邪淫，使你的兒子也隨從他們的神行邪淫。',
    '出34:17 不可為自己鑄造神像。',
    '出34:18 你要守除酵節，照我所吩咐你的，在亞筆月內所定的日期吃無酵餅七天，因為你是這亞筆月內出了埃及。',
    '出34:19 凡頭生的都是我的；一切牲畜頭生的，無論是牛是羊，公的都是我的。',
    '出34:20 頭生的驢要用羊羔代贖，若不代贖就要打折他的頸項。凡頭生的兒子都要贖出來。誰也不可空手朝見我。',
    '出34:21 你六日要做工，第七日要安息，雖在耕種收割的時候也要安息。',
    '出34:22 在收割初熟麥子的時候要守七七節；又在年底要守收藏節。',
    '出34:23 你們一切男丁要一年三次朝見主耶和華─以色列的神。',
    '出34:24 我要從你面前趕出外邦人，擴張你的境界。你一年三次上去朝見耶和華─你神的時候，必沒有人貪慕你的地土。',
    '出34:25 你不可將我祭物的血和有酵的餅一同獻上。逾越節的祭物也不可留到早晨。',
    '出34:26 地裡首先初熟之物要送到耶和華─你神的殿。不可用山羊羔母的奶煮山羊羔。',
    '出34:27 耶和華吩咐摩西說：你要將這些話寫上，因為我是按這話與你和以色列人立約。',
    '出34:28 摩西在耶和華那裡四十晝夜，也不吃飯也不喝水。耶和華將這約的話，就是十條誡，寫在兩塊版上。',
    '出34:29 摩西手裡拿著兩塊法版下西乃山的時候，不知道自己的面皮因耶和華和他說話就發了光。',
    '出34:30 亞倫和以色列眾人看見摩西的面皮發光就怕挨近他。',
    '出34:31 摩西叫他們來；於是亞倫和會眾的官長都到他那裡去，摩西就與他們說話。',
    '出34:32 隨後以色列眾人都近前來，他就把耶和華在西乃山與他所說的一切話都吩咐他們。',
    '出34:33 摩西與他們說完了話就用帕子蒙上臉。',
    '出34:34 但摩西進到耶和華面前與他說話就揭去帕子，及至出來的時候便將耶和華所吩咐的告訴以色列人。',
    '出34:35 以色列人看見摩西的面皮發光。摩西又用帕子蒙上臉，等到他進去與耶和華說話就揭去帕子。',
    '出35:1 摩西招聚以色列全會眾，對他們說：這是耶和華所吩咐的話，叫你們照著行：',
    '出35:2 六日要做工，第七日乃為聖日，當向耶和華守為安息聖日。凡這日之內做工的，必把他治死。',
    '出35:3 當安息日，不可在你們一切的住處生火。',
    '出35:4 摩西對以色列全會眾說：耶和華所吩咐的是這樣：',
    '出35:5 你們中間要拿禮物獻給耶和華，凡樂意獻的可以拿耶和華的禮物來，就是金、銀、銅，',
    '出35:6 藍色、紫色、朱紅色線，細麻，山羊毛，',
    '出35:7 染紅的公羊皮，海狗皮，皂莢木，',
    '出35:8 點燈的油，並做膏油和香的香料，',
    '出35:9 紅瑪瑙與別樣的寶石，可以鑲嵌在以弗得和胸牌上。',
    '出35:10 你們中間凡心裡有智慧的都要來做耶和華一切所吩咐的：',
    '出35:11 就是帳幕和帳幕的罩棚，並帳幕的蓋、鉤子、板、閂、柱子、帶卯的座，',
    '出35:12 櫃和櫃的槓，施恩座和遮掩櫃的幔子，',
    '出35:13 桌子和桌子的槓與桌子的一切器具，並陳設餅，',
    '出35:14 燈臺和燈臺的器具，燈盞並點燈的油，',
    '出35:15 香壇和壇的槓，膏油和馨香的香料，並帳幕門口的簾子，',
    '出35:16 燔祭壇和壇的銅網，壇的槓並壇的一切器具，洗濯盆和盆座，',
    '出35:17 院子的帷子和帷子的柱子，帶卯的座和院子的門簾，',
    '出35:18 帳幕的橛子並院子的橛子，和這兩處的繩子，',
    '出35:19 精工做的禮服和祭司亞倫並他兒子在聖所用以供祭司職分的聖衣。',
    '出35:20 以色列全會眾從摩西面前退去。',
    '出35:21 凡心裡受感和甘心樂意的都拿耶和華的禮物來，用以做會幕和其中一切的使用，又用以做聖衣。',
    '出35:22 凡心裡樂意獻禮物的，連男帶女，各將金器，就是胸前針、耳環（或作：鼻環）、打印的戒指，和手釧帶來獻給耶和華。',
    '出35:23 凡有藍色、紫色、朱紅色線，細麻，山羊毛，染紅的公羊皮，海狗皮的，都拿了來；',
    '出35:24 凡獻銀子和銅給耶和華為禮物的都拿了來；凡有皂莢木可做什麼使用的也拿了來。',
    '出35:25 凡心中有智慧的婦女親手紡線，把所紡的藍色、紫色、朱紅色線，和細麻都拿了來。',
    '出35:26 凡有智慧、心裡受感的婦女就紡山羊毛。',
    '出35:27 眾官長把紅瑪瑙和別樣的寶石，可以鑲嵌在以弗得與胸牌上的，都拿了來；',
    '出35:28 又拿香料做香，拿油點燈，做膏油。',
    '出35:29 以色列人，無論男女，凡甘心樂意獻禮物給耶和華的，都將禮物拿來，做耶和華藉摩西所吩咐的一切工。',
    '出35:30 摩西對以色列人說：猶大支派中，戶珥的孫子、烏利的兒子比撒列，耶和華已經提他的名召他，',
    '出35:31 又以神的靈充滿了他，使他有智慧、聰明、知識，能做各樣的工，',
    '出35:32 能想出巧工，用金、銀、銅製造各物，',
    '出35:33 又能刻寶石，可以鑲嵌，能雕刻木頭，能做各樣的巧工。',
    '出35:34 耶和華又使他，和但支派中亞希撒抹的兒子亞何利亞伯，心裡靈明，能教導人。',
    '出35:35 耶和華使他們的心滿有智慧，能做各樣的工，無論是雕刻的工，巧匠的工，用藍色、紫色、朱紅色線，和細麻、繡花的工，並機匠的工，他們都能做，也能想出奇巧的工。',
    '出36:1 比撒列和亞何利亞伯，並一切心裡有智慧的，就是蒙耶和華賜智慧聰明、叫他知道做聖所各樣使用之工的，都要照耶和華所吩咐的做工。',
    '出36:2 凡耶和華賜他心裡有智慧、而且受感前來做這工的，摩西把他們和比撒列並亞何利亞伯一同召來。',
    '出36:3 這些人就從摩西收了以色列人為做聖所並聖所使用之工所拿來的禮物。百姓每早晨還把甘心獻的禮物拿來。',
    '出36:4 凡做聖所一切工的智慧人各都離開他所做的工，',
    '出36:5 來對摩西說：百姓為耶和華吩咐使用之工所拿來的，富富有餘。',
    '出36:6 摩西傳命，他們就在全營中宣告說：無論男女，不必再為聖所拿什麼禮物來。這樣才攔住百姓不再拿禮物來。',
    '出36:7 因為他們所有的材料夠做一切當做的物，而且有餘。',
    '出36:8 他們中間，凡心裡有智慧做工的，用十幅幔子做帳幕。這幔子是比撒列用撚的細麻和藍色、紫色、朱紅色線製造的，並用巧匠的手工繡上基路伯。',
    '出36:9 每幅幔子長二十八肘，寬四肘，都是一樣的尺寸。',
    '出36:10 他使這五幅幔子幅幅相連，又使那五幅幔子幅幅相連；',
    '出36:11 在這相連的幔子末幅邊上做藍色的鈕扣，在那相連的幔子末幅邊上也照樣做；',
    '出36:12 在這相連的幔子上做五十個鈕扣，在那相連的幔子上也做五十個鈕扣，都是兩兩相對；',
    '出36:13 又做五十個金鉤，使幔子相連。這才成了一個帳幕。',
    '出36:14 他用山羊毛織十一幅幔子，作為帳幕以上的罩棚。',
    '出36:15 每幅幔子長三十肘，寬四肘；十一幅幔子都是一樣的尺寸。',
    '出36:16 他把五幅幔子連成一幅，又把六幅幔子連成一幅；',
    '出36:17 在這相連的幔子末幅邊上做五十個鈕扣，在那相連的幔子末幅邊上也做五十個鈕扣；',
    '出36:18 又做五十個銅鉤，使罩棚連成一個；',
    '出36:19 並用染紅的公羊皮做罩棚的蓋，再用海狗皮做一層罩棚上的頂蓋。',
    '出36:20 他用皂莢木做帳幕的豎板。',
    '出36:21 每塊長十肘，寬一肘半；',
    '出36:22 每塊有兩榫相對。帳幕一切的板都是這樣做。',
    '出36:23 帳幕的南面做板二十塊。',
    '出36:24 在這二十塊板底下又做四十個帶卯的銀座：兩卯接這塊板上的兩榫，兩卯接那塊板上的兩榫。',
    '出36:25 帳幕的第二面，就是北面，也做板二十塊',
    '出36:26 和帶卯的銀座四十個：這板底下有兩卯，那板底下也有兩卯。',
    '出36:27 帳幕的後面，就是西面，做板六塊。',
    '出36:28 帳幕後面的拐角做板兩塊。',
    '出36:29 板的下半截是雙的，上半截是整的，直到第一個環子；在帳幕的兩個拐角上都是這樣做。',
    '出36:30 有八塊板和十六個帶卯的銀座，每塊板底下有兩卯。',
    '出36:31 他用皂莢木做閂：為帳幕這面的板做五閂，',
    '出36:32 為帳幕那面的板做五閂，又為帳幕後面的板做五閂，',
    '出36:33 使板腰間的中閂從這一頭通到那一頭。',
    '出36:34 用金子將板包裹，又做板上的金環套閂；閂也用金子包裹。',
    '出36:35 他用藍色、紫色、朱紅色線，和撚的細麻織幔子，以巧匠的手工繡上基路伯。',
    '出36:36 為幔子做四根皂莢木柱子，用金包裹，柱子上有金鉤，又為柱子鑄了四個帶卯的銀座。',
    '出36:37 拿藍色、紫色、朱紅色線，和撚的細麻，用繡花的手工織帳幕的門簾；',
    '出36:38 又為簾子做五根柱子和柱子上的鉤子，用金子把柱頂和柱子上的杆子包裹。柱子有五個帶卯的座，是銅的。',
    '出37:1 比撒列用皂莢木做櫃，長二肘半，寬一肘半，高一肘半。',
    '出37:2 裡外包上精金，四圍鑲上金牙邊，',
    '出37:3 又鑄四個金環，安在櫃的四腳上：這邊兩環，那邊兩環。',
    '出37:4 用皂莢木做兩根槓，用金包裹。',
    '出37:5 把槓穿在櫃旁的環內，以便擡櫃。',
    '出37:6 用精金做施恩座，長二肘半，寬一肘半。',
    '出37:7 用金子錘出兩個基路伯來，安在施恩座的兩頭，',
    '出37:8 這頭做一個基路伯，那頭做一個基路伯，二基路伯接連一塊，在施恩座的兩頭。',
    '出37:9 二基路伯高張翅膀，遮掩施恩座；基路伯是臉對臉，朝著施恩座。',
    '出37:10 他用皂莢木做一張桌子，長二肘，寬一肘，高一肘半，',
    '出37:11 又包上精金，四圍鑲上金牙邊。',
    '出37:12 桌子的四圍各做一掌寬的橫梁，橫梁上鑲著金牙邊，',
    '出37:13 又鑄了四個金環，安在桌子四腳的四角上。',
    '出37:14 安環子的地方是挨近橫梁，可以穿槓擡桌子。',
    '出37:15 他用皂莢木做兩根槓，用金包裹，以便擡桌子；',
    '出37:16 又用精金做桌子上的器皿，就是盤子、調羹，並奠酒的瓶和爵。',
    '出37:17 他用精金做一個燈臺；這燈臺的座和幹，與杯、球、花，都是接連一塊錘出來的。',
    '出37:18 燈臺兩旁杈出六個枝子：這旁三個，那旁三個。',
    '出37:19 這旁每枝上有三個杯，形狀像杏花，有球有花；那旁每枝上也有三個杯，形狀像杏花，有球有花。從燈臺杈出來的六個枝子都是如此。',
    '出37:20 燈臺上有四個杯，形狀像杏花，有球有花。',
    '出37:21 燈臺每兩個枝子以下有球，與枝子接連一塊；燈臺杈出的六個枝子都是如此。',
    '出37:22 球和枝子是接連一塊，都是一塊精金錘出來的。',
    '出37:23 用精金做燈臺的七個燈盞，並燈臺的蠟剪和蠟花盤。',
    '出37:24 他用精金一他連得做燈臺和燈臺的一切器具。',
    '出37:25 他用皂莢木做香壇，是四方的，長一肘，寬一肘，高二肘，壇的四角與壇接連一塊；',
    '出37:26 又用精金把壇的上面與壇的四面並壇的四角包裹，又在壇的四圍鑲上金牙邊。',
    '出37:27 做兩個金環，安在牙子邊以下，在壇的兩旁、兩根橫撐上，作為穿槓的用處，以便擡壇。',
    '出37:28 用皂莢木做槓，用金包裹。',
    '出37:29 又按做香之法做聖膏油和馨香料的淨香。',
    '出38:1 他用皂莢木做燔祭壇，是四方的，長五肘，寬五肘，高三肘，',
    '出38:2 在壇的四拐角上做四個角，與壇接連一塊，用銅把壇包裹。',
    '出38:3 他做壇上的盆、鏟子、盤子、肉鍤子、火鼎；這一切器具都是用銅做的。',
    '出38:4 又為壇做一個銅網，安在壇四面的圍腰板以下，從下達到壇的半腰。',
    '出38:5 為銅網的四角鑄四個環子，作為穿槓的用處。',
    '出38:6 用皂莢木做槓，用銅包裹，',
    '出38:7 把槓穿在壇兩旁的環子內，用以擡壇，並用板做壇；壇是空的。',
    '出38:8 他用銅做洗濯盆和盆座，是用會幕門前伺候的婦人之鏡子做的。',
    '出38:9 他做帳幕的院子。院子的南面用撚的細麻做帷子，寬一百肘。',
    '出38:10 帷子的柱子二十根，帶卯的銅座二十個；柱子上的鉤子和杆子都是用銀子做的。',
    '出38:11 北面也有帷子，寬一百肘。帷子的柱子二十根，帶卯的銅座二十個；柱子上的鉤子和杆子都是用銀子做的。',
    '出38:12 院子的西面有帷子，寬五十肘。帷子的柱子十根，帶卯的座十個；柱子的鉤子和杆子都是用銀子做的。',
    '出38:13 院子的東面，寬五十肘。',
    '出38:14 門這邊的帷子十五肘，那邊也是一樣。帷子的柱子三根，帶卯的座三個。在門的左右各有帷子十五肘，帷子的柱子三根，帶卯的座三個。',
    '出38:15 併於上節。',
    '出38:16 院子四面的帷子都是用撚的細麻做的。',
    '出38:17 柱子帶卯的座是銅的，柱子上的鉤子和杆子是銀的，柱頂是用銀子包的。院子一切的柱子都是用銀杆連絡的。',
    '出38:18 院子的門簾是以繡花的手工，用藍色、紫色、朱紅色線，和撚的細麻織的，寬二十肘，高五肘，與院子的帷子相配。',
    '出38:19 帷子的柱子四根，帶卯的銅座四個；柱子上的鉤子和杆子是銀的；柱頂是用銀子包的。',
    '出38:20 帳幕一切的橛子和院子四圍的橛子都是銅的。',
    '出38:21 這是法櫃的帳幕中利未人所用物件的總數，是照摩西的吩咐，經祭司亞倫的兒子以他瑪的手數點的。',
    '出38:22 凡耶和華所吩咐摩西的都是猶大支派戶珥的孫子、烏利的兒子比撒列做的。',
    '出38:23 與他同工的有但支派中亞希撒抹的兒子亞何利亞伯；他是雕刻匠，又是巧匠，又能用藍色、紫色、朱紅色線，和細麻繡花。',
    '出38:24 為聖所一切工作使用所獻的金子，按聖所的平，有二十九他連得並七百三十舍客勒。',
    '出38:25 會中被數的人所出的銀子，按聖所的平，有一百他連得並一千七百七十五舍客勒。',
    '出38:26 凡過去歸那些被數之人的，從二十歲以外，有六十萬零三千五百五十人。按聖所的平，每人出銀半舍客勒，就是一比加。',
    '出38:27 用那一百他連得銀子鑄造聖所帶卯的座和幔子柱子帶卯的座；一百他連得共一百帶卯的座，每帶卯的座用一他連得。',
    '出38:28 用那一千七百七十五舍客勒銀子做柱子上的鉤子，包裹柱頂並柱子上的杆子。',
    '出38:29 所獻的銅有七十他連得並二千四百舍客勒。',
    '出38:30 用這銅做會幕門帶卯的座和銅壇，並壇上的銅網和壇的一切器具，',
    '出38:31 並院子四圍帶卯的座和院門帶卯的座，與帳幕一切的橛子和院子四圍所有的橛子。',
    '出39:1 比撒列用藍色、紫色、朱紅色線做精緻的衣服，在聖所用以供職，又為亞倫做聖衣，是照耶和華所吩咐摩西的。',
    '出39:2 他用金線和藍色、紫色、朱紅色線，並撚的細麻做以弗得；',
    '出39:3 把金子錘成薄片，剪出線來，與藍色、紫色、朱紅色線，用巧匠的手工一同繡上。',
    '出39:4 又為以弗得做兩條相連的肩帶，接連在以弗得的兩頭。',
    '出39:5 其上巧工織的帶子和以弗得一樣的做法，用以束上，與以弗得接連一塊，是用金線和藍色、紫色、朱紅色線，並撚的細麻做的，是照耶和華所吩咐摩西的。',
    '出39:6 又琢出兩塊紅瑪瑙，鑲在金槽上，彷彿刻圖書，按著以色列兒子的名字雕刻；',
    '出39:7 將這兩塊寶石安在以弗得的兩條肩帶上，為以色列人做記念石，是照耶和華所吩咐摩西的。',
    '出39:8 他用巧匠的手工做胸牌，和以弗得一樣的做法，用金線與藍色、紫色、朱紅色線，並撚的細麻做的。',
    '出39:9 胸牌是四方的，疊為兩層；這兩層長一虎口，寬一虎口，',
    '出39:10 上面鑲著寶石四行：第一行是紅寶石、紅璧璽、紅玉；',
    '出39:11 第二行是綠寶石、藍寶石、金鋼石；',
    '出39:12 第三行是紫瑪瑙、白瑪瑙、紫晶；',
    '出39:13 第四行是水蒼玉、紅瑪瑙、碧玉。這都鑲在金槽中。',
    '出39:14 這些寶石都是按著以色列十二個兒子的名字，彷彿刻圖書，刻十二個支派的名字。',
    '出39:15 在胸牌上，用精金擰成如繩子的鍊子。',
    '出39:16 又做兩個金槽和兩個金環，安在胸牌的兩頭。',
    '出39:17 把那兩條擰成的金鍊子穿過胸牌兩頭的環子，',
    '出39:18 又把鍊子的那兩頭接在兩槽上，安在以弗得前面肩帶上。',
    '出39:19 做兩個金環，安在胸牌的兩頭，在以弗得裡面的邊上，',
    '出39:20 又做兩個金環，安在以弗得前面兩條肩帶的下邊，挨近相接之處，在以弗得巧工織的帶子以上。',
    '出39:21 用一條藍細帶子把胸牌的環子和以弗得的環子繫住，使胸牌貼在以弗得巧工織的帶子上，不可與以弗得離縫，是照耶和華所吩咐摩西的。',
    '出39:22 他用織工做以弗得的外袍，顏色全是藍的。',
    '出39:23 袍上留一領口，口的周圍織出領邊來，彷彿鎧甲的領口，免得破裂。',
    '出39:24 在袍子底邊上，用藍色、紫色、朱紅色線，並撚的細麻做石榴，',
    '出39:25 又用精金做鈴鐺，把鈴鐺釘在袍子周圍底邊上的石榴中間：',
    '出39:26 一個鈴鐺一個石榴，一個鈴鐺一個石榴，在袍子周圍底邊上用以供職，是照耶和華所吩咐摩西的。',
    '出39:27 他用織成的細麻布為亞倫和他的兒子做內袍，',
    '出39:28 並用細麻布做冠冕和華美的裹頭巾，用撚的細麻布做褲子，',
    '出39:29 又用藍色、紫色、朱紅色線，並撚的細麻，以繡花的手工做腰帶，是照耶和華所吩咐摩西的。',
    '出39:30 他用精金做聖冠上的牌，在上面按刻圖書之法，刻著歸耶和華為聖。',
    '出39:31 又用一條藍細帶子將牌繫在冠冕上，是照耶和華所吩咐摩西的。',
    '出39:32 帳幕，就是會幕，一切的工就這樣做完了。凡耶和華所吩咐摩西的，以色列人都照樣做了。',
    '出39:33 他們送到摩西那裡。帳幕和帳幕的一切器具，就是鉤子、板、閂、柱子、帶卯的座，',
    '出39:34 染紅公羊皮的蓋、海狗皮的頂蓋，和遮掩櫃的幔子，',
    '出39:35 法櫃和櫃的槓並施恩座，',
    '出39:36 桌子和桌子的一切器具並陳設餅，',
    '出39:37 精金的燈臺和擺列的燈盞，與燈臺的一切器具，並點燈的油，',
    '出39:38 金壇、膏油、馨香的香料、會幕的門簾，',
    '出39:39 銅壇和壇上的銅網，壇的槓並壇的一切器具，洗濯盆和盆座，',
    '出39:40 院子的帷子和柱子，並帶卯的座，院子的門簾、繩子、橛子，並帳幕和會幕中一切使用的器具，',
    '出39:41 精工做的禮服，和祭司亞倫並他兒子在聖所用以供祭司職分的聖衣。',
    '出39:42 這一切工作都是以色列人照耶和華所吩咐摩西做的。',
    '出39:43 耶和華怎樣吩咐的，他們就怎樣做了。摩西看見一切的工都做成了，就給他們祝福。',
    '出40:1 耶和華曉諭摩西說：',
    '出40:2 正月初一日，你要立起帳幕，',
    '出40:3 把法櫃安放在裡面，用幔子將櫃遮掩。',
    '出40:4 把桌子搬進去，擺設上面的物。把燈臺搬進去，點其上的燈。',
    '出40:5 把燒香的金壇安在法櫃前，掛上帳幕的門簾。',
    '出40:6 把燔祭壇安在帳幕門前。',
    '出40:7 把洗濯盆安在會幕和壇的中間，在盆裡盛水。',
    '出40:8 又在四圍立院帷，把院子的門簾掛上。',
    '出40:9 用膏油把帳幕和其中所有的都抹上，使帳幕和一切器具成聖，就都成聖。',
    '出40:10 又要抹燔祭壇和一切器具，使壇成聖，就都成為至聖。',
    '出40:11 要抹洗濯盆和盆座，使盆成聖。',
    '出40:12 要使亞倫和他兒子到會幕門口來，用水洗身。',
    '出40:13 要給亞倫穿上聖衣，又膏他，使他成聖，可以給我供祭司的職分；',
    '出40:14 又要使他兒子來，給他們穿上內袍。',
    '出40:15 怎樣膏他們的父親，也要照樣膏他們，使他們給我供祭司的職分。他們世世代代凡受膏的，就永遠當祭司的職任。',
    '出40:16 摩西這樣行，都是照耶和華所吩咐他的。',
    '出40:17 第二年正月初一日，帳幕就立起來。',
    '出40:18 摩西立起帳幕，安上帶卯的座，立上板，穿上閂，立起柱子。',
    '出40:19 在帳幕以上搭罩棚，把罩棚的頂蓋蓋在其上，是照耶和華所吩咐他的。',
    '出40:20 又把法版放在櫃裡，把槓穿在櫃的兩旁，把施恩座安在櫃上。',
    '出40:21 把櫃擡進帳幕，掛上遮掩櫃的幔子，把法櫃遮掩了，是照耶和華所吩咐他的。',
    '出40:22 又把桌子安在會幕內，在帳幕北邊，在幔子外。',
    '出40:23 在桌子上將餅陳設在耶和華面前，是照耶和華所吩咐他的。',
    '出40:24 又把燈臺安在會幕內，在帳幕南邊，與桌子相對，',
    '出40:25 在耶和華面前點燈，是照耶和華所吩咐他的。',
    '出40:26 把金壇安在會幕內的幔子前，',
    '出40:27 在壇上燒了馨香料做的香，是照耶和華所吩咐他的。',
    '出40:28 又掛上帳幕的門簾。',
    '出40:29 在會幕的帳幕門前，安設燔祭壇，把燔祭和素祭獻在其上，是照耶和華所吩咐他的。',
    '出40:30 把洗濯盆安在會幕和壇的中間，盆中盛水，以便洗濯。',
    '出40:31 摩西和亞倫並亞倫的兒子在這盆裡洗手洗腳。',
    '出40:32 他們進會幕或就近壇的時候，便都洗濯，是照耶和華所吩咐他的。',
    '出40:33 在帳幕和壇的四圍立了院帷，把院子的門簾掛上。這樣，摩西就完了工。',
    '出40:34 當時，雲彩遮蓋會幕，耶和華的榮光就充滿了帳幕。',
    '出40:35 摩西不能進會幕；因為雲彩停在其上，並且耶和華的榮光充滿了帳幕。',
    '出40:36 每逢雲彩從帳幕收上去，以色列人就起程前往；',
    '出40:37 雲彩若不收上去，他們就不起程，直等到雲彩收上去。',
    '出40:38 日間，耶和華的雲彩是在帳幕以上；夜間，雲中有火，在以色列全家的眼前。在他們所行的路上都是這樣。',
    '利1:1 耶和華從會幕中呼叫摩西，對他說：',
    '利1:2 你曉諭以色列人說：你們中間若有人獻供物給耶和華，要從牛群羊群中獻牲畜為供物。',
    '利1:3 他的供物若以牛為燔祭，就要在會幕門口獻一隻沒有殘疾的公牛，可以在耶和華面前蒙悅納。',
    '利1:4 他要按手在燔祭牲的頭上，燔祭便蒙悅納，為他贖罪。',
    '利1:5 他要在耶和華面前宰公牛；亞倫子孫作祭司的，要奉上血，把血灑在會幕門口、壇的周圍。',
    '利1:6 那人要剝去燔祭牲的皮，把燔祭牲切成塊子。',
    '利1:7 祭司亞倫的子孫要把火放在壇上，把柴擺在火上。',
    '利1:8 亞倫子孫作祭司的，要把肉塊和頭並脂油擺在壇上火的柴上。',
    '利1:9 但燔祭的臟腑與腿要用水洗。祭司就要把一切全燒在壇上，當作燔祭，獻與耶和華為馨香的火祭。',
    '利1:10 人的供物若以綿羊或山羊為燔祭，就要獻上沒有殘疾的公羊。',
    '利1:11 要把羊宰於壇的北邊，在耶和華面前；亞倫子孫作祭司的，要把羊血灑在壇的周圍。',
    '利1:12 要把燔祭牲切成塊子，連頭和脂油，祭司就要擺在壇上火的柴上；',
    '利1:13 但臟腑與腿要用水洗，祭司就要全然奉獻，燒在壇上。這是燔祭，是獻與耶和華為馨香的火祭。',
    '利1:14 人奉給耶和華的供物，若以鳥為燔祭，就要獻斑鳩或是雛鴿為供物。',
    '利1:15 祭司要把鳥拿到壇前，揪下頭來，把鳥燒在壇上；鳥的血要流在壇的旁邊；',
    '利1:16 又要把鳥的嗉子和髒物（髒物：或作翎毛）除掉，丟在壇的東邊倒灰的地方。',
    '利1:17 要拿著鳥的兩個翅膀，把鳥撕開，只是不可撕斷；祭司要在壇上、在火的柴上焚燒。這是燔祭，是獻與耶和華為馨香的火祭。',
    '利2:1 若有人獻素祭為供物給耶和華，要用細麵澆上油，加上乳香，',
    '利2:2 帶到亞倫子孫作祭司的那裡；祭司就要從細麵中取出一把來，並取些油和所有的乳香，然後要把所取的這些作為記念，燒在壇上，是獻與耶和華為馨香的火祭。',
    '利2:3 素祭所剩的要歸給亞倫和他的子孫；這是獻與耶和華的火祭中為至聖的。',
    '利2:4 若用爐中烤的物為素祭，就要用調油的無酵細麵餅，或是抹油的無酵薄餅。',
    '利2:5 若用鐵鏊上做的物為素祭，就要用調油的無酵細麵，',
    '利2:6 分成塊子，澆上油；這是素祭。',
    '利2:7 若用煎盤做的物為素祭，就要用油與細麵做成。',
    '利2:8 要把這些東西做的素祭帶到耶和華面前，並奉給祭司，帶到壇前。',
    '利2:9 祭司要從素祭中取出作為記念的，燒在壇上，是獻與耶和華為馨香的火祭。',
    '利2:10 素祭所剩的要歸給亞倫和他的子孫。這是獻與耶和華的火祭中為至聖的。',
    '利2:11 凡獻給耶和華的素祭都不可有酵；因為你們不可燒一點酵、一點蜜當作火祭獻給耶和華。',
    '利2:12 這些物要獻給耶和華作為初熟的供物，只是不可在壇上獻為馨香的祭。',
    '利2:13 凡獻為素祭的供物都要用鹽調和，在素祭上不可缺了你神立約的鹽。一切的供物都要配鹽而獻。',
    '利2:14 若向耶和華獻初熟之物為素祭，要獻上烘了的禾穗子，就是軋了的新穗子，當作初熟之物的素祭。',
    '利2:15 並要抹上油，加上乳香；這是素祭。',
    '利2:16 祭司要把其中作為記念的，就是一些軋了的禾穗子和一些油，並所有的乳香，都焚燒，是向耶和華獻的火祭。',
    '利3:1 人獻供物為平安祭（平安：或作酬恩；下同），若是從牛群中獻，無論是公的是母的，必用沒有殘疾的獻在耶和華面前。',
    '利3:2 他要按手在供物的頭上，宰於會幕門口。亞倫子孫作祭司的，要把血灑在壇的周圍。',
    '利3:3 從平安祭中，將火祭獻給耶和華，也要把蓋臟的脂油和臟上所有的脂油，',
    '利3:4 並兩個腰子和腰子上的脂油，就是靠腰兩旁的脂油，與肝上的網子和腰子，一概取下。',
    '利3:5 亞倫的子孫要把這些燒在壇的燔祭上，就是在火的柴上，是獻與耶和華為馨香的火祭。',
    '利3:6 人向耶和華獻供物為平安祭，若是從羊群中獻，無論是公的是母的，必用沒有殘疾的。',
    '利3:7 若獻一隻羊羔為供物，必在耶和華面前獻上，',
    '利3:8 並要按手在供物的頭上，宰於會幕前。亞倫的子孫要把血灑在壇的周圍。',
    '利3:9 從平安祭中，將火祭獻給耶和華，其中的脂油和整肥尾巴都要在靠近脊骨處取下，並要把蓋臟的脂油和臟上所有的脂油，',
    '利3:10 兩個腰子和腰子上的脂油，就是靠腰兩旁的脂油，並肝上的網子和腰子，一概取下。',
    '利3:11 祭司要在壇上焚燒，是獻給耶和華為食物的火祭。',
    '利3:12 人的供物若是山羊，必在耶和華面前獻上。',
    '利3:13 要按手在山羊頭上，宰於會幕前。亞倫的子孫要把血灑在壇的周圍，',
    '利3:14 又把蓋臟的脂油和臟上所有的脂油，兩個腰子和腰子上的脂油，就是靠腰兩旁的脂油，並肝上的網子和腰子，一概取下，獻給耶和華為火祭。',
    '利3:15 併於上節。',
    '利3:16 祭司要在壇上焚燒，作為馨香火祭的食物。脂油都是耶和華的。',
    '利3:17 在你們一切的住處，脂油和血都不可吃；這要成為你們世世代代永遠的定例。',
    '利4:1 耶和華對摩西說：',
    '利4:2 你曉諭以色列人說：若有人在耶和華所吩咐不可行的什麼事上誤犯了一件，',
    '利4:3 或是受膏的祭司犯罪，使百姓陷在罪裡，就當為他所犯的罪把沒有殘疾的公牛犢獻給耶和華為贖罪祭。',
    '利4:4 他要牽公牛到會幕門口，在耶和華面前按手在牛的頭上，把牛宰於耶和華面前。',
    '利4:5 受膏的祭司要取些公牛的血帶到會幕，',
    '利4:6 把指頭蘸於血中，在耶和華面前對著聖所的幔子彈血七次，',
    '利4:7 又要把些血抹在會幕內、耶和華面前香壇的四角上，再把公牛所有的血倒在會幕門口、燔祭壇的腳那裡。',
    '利4:8 要把贖罪祭公牛所有的脂油，乃是蓋臟的脂油和臟上所有的脂油，',
    '利4:9 並兩個腰子和腰子上的脂油，就是靠腰兩旁的脂油，與肝上的網子和腰子，一概取下，',
    '利4:10 與平安祭公牛上所取的一樣；祭司要把這些燒在燔祭的壇上。',
    '利4:11 公牛的皮和所有的肉，並頭、腿、臟、腑、糞，',
    '利4:12 就是全公牛，要搬到營外潔淨之地、倒灰之所，用火燒在柴上。',
    '利4:13 以色列全會眾若行了耶和華所吩咐不可行的什麼事，誤犯了罪，是隱而未現，會眾看不出來的，',
    '利4:14 會眾一知道所犯的罪就要獻一隻公牛犢為贖罪祭，牽到會幕前。',
    '利4:15 會中的長老就要在耶和華面前按手在牛的頭上，將牛在耶和華面前宰了。',
    '利4:16 受膏的祭司要取些公牛的血帶到會幕，',
    '利4:17 把指頭蘸於血中，在耶和華面前對著幔子彈血七次，',
    '利4:18 又要把些血抹在會幕內、耶和華面前壇的四角上，再把所有的血倒在會幕門口、燔祭壇的腳那裡。',
    '利4:19 把牛所有的脂油都取下，燒在壇上；',
    '利4:20 收拾這牛，與那贖罪祭的牛一樣。祭司要為他們贖罪，他們必蒙赦免。',
    '利4:21 他要把牛搬到營外燒了，像燒頭一個牛一樣；這是會眾的贖罪祭。',
    '利4:22 官長若行了耶和華─他神所吩咐不可行的什麼事，誤犯了罪，',
    '利4:23 所犯的罪自己知道了，就要牽一隻沒有殘疾的公山羊為供物，',
    '利4:24 按手在羊的頭上，宰於耶和華面前、宰燔祭牲的地方；這是贖罪祭。',
    '利4:25 祭司要用指頭蘸些贖罪祭牲的血，抹在燔祭壇的四角上，把血倒在燔祭壇的腳那裡。',
    '利4:26 所有的脂油，祭司都要燒在壇上，正如平安祭的脂油一樣。至於他的罪，祭司要為他贖了，他必蒙赦免。',
    '利4:27 民中若有人行了耶和華所吩咐不可行的什麼事，誤犯了罪，',
    '利4:28 所犯的罪自己知道了，就要為所犯的罪牽一隻沒有殘疾的母山羊為供物，',
    '利4:29 按手在贖罪祭牲的頭上，在那宰燔祭牲的地方宰了。',
    '利4:30 祭司要用指頭蘸些羊的血，抹在燔祭壇的四角上，所有的血都要倒在壇的腳那裡，',
    '利4:31 又要把羊所有的脂油都取下，正如取平安祭牲的脂油一樣。祭司要在壇上焚燒，在耶和華面前作為馨香的祭，為他贖罪，他必蒙赦免。',
    '利4:32 人若牽一隻綿羊羔為贖罪祭的供物，必要牽一隻沒有殘疾的母羊，',
    '利4:33 按手在贖罪祭牲的頭上，在那宰燔祭牲的地方宰了作贖罪祭。',
    '利4:34 祭司要用指頭蘸些贖罪祭牲的血，抹在燔祭壇的四角上，所有的血都要倒在壇的腳那裡，',
    '利4:35 又要把所有的脂油都取下，正如取平安祭羊羔的脂油一樣。祭司要按獻給耶和華火祭的條例，燒在壇上。至於所犯的罪，祭司要為他贖了，他必蒙赦免。',
    '利5:1 若有人聽見發誓的聲音（或作：若有人聽見叫人發誓的聲音），他本是見證，卻不把所看見的、所知道的說出來，這就是罪；他要擔當他的罪孽。',
    '利5:2 或是有人摸了不潔的物，無論是不潔的死獸，是不潔的死畜，是不潔的死蟲，他卻不知道，因此成了不潔，就有了罪。',
    '利5:3 或是他摸了別人的污穢，無論是染了什麼污穢，他卻不知道，一知道了就有了罪。',
    '利5:4 或是有人嘴裡冒失發誓，要行惡，要行善，無論人在什麼事上冒失發誓，他卻不知道，一知道了就要在這其中的一件上有了罪。',
    '利5:5 他有了罪的時候，就要承認所犯的罪，',
    '利5:6 並要因所犯的罪，把他的贖愆祭牲─就是羊群中的母羊，或是一隻羊羔，或是一隻山羊─牽到耶和華面前為贖罪祭。至於他的罪，祭司要為他贖了。',
    '利5:7 他的力量若不夠獻一隻羊羔，就要因所犯的罪，把兩隻斑鳩或是兩隻雛鴿帶到耶和華面前為贖愆祭：一隻作贖罪祭，一隻作燔祭。',
    '利5:8 把這些帶到祭司那裡，祭司就要先把那贖罪祭獻上，從鳥的頸項上揪下頭來，只是不可把鳥撕斷，',
    '利5:9 也把些贖罪祭牲的血彈在壇的旁邊，剩下的血要流在壇的腳那裡；這是贖罪祭。',
    '利5:10 他要照例獻第二隻為燔祭。至於他所犯的罪，祭司要為他贖了，他必蒙赦免。',
    '利5:11 他的力量若不夠獻兩隻斑鳩或是兩隻雛鴿，就要因所犯的罪帶供物來，就是細麵伊法十分之一為贖罪祭；不可加上油，也不可加上乳香，因為是贖罪祭。',
    '利5:12 他要把供物帶到祭司那裡，祭司要取出自己的一把來作為記念，按獻給耶和華火祭的條例燒在壇上；這是贖罪祭。',
    '利5:13 至於他在這幾件事中所犯的罪，祭司要為他贖了，他必蒙赦免。剩下的麵都歸與祭司，和素祭一樣。',
    '利5:14 耶和華曉諭摩西說：',
    '利5:15 人若在耶和華的聖物上誤犯了罪，有了過犯，就要照你所估的，按聖所的舍客勒拿銀子，將贖愆祭牲─就是羊群中一隻沒有殘疾的公綿羊─牽到耶和華面前為贖愆祭；',
    '利5:16 並且他因在聖物上的差錯要償還，另外加五分之一，都給祭司。祭司要用贖愆祭的公綿羊為他贖罪，他必蒙赦免。',
    '利5:17 若有人犯罪，行了耶和華所吩咐不可行的什麼事，他雖然不知道，還是有了罪，就要擔當他的罪孽；',
    '利5:18 也要照你所估定的價，從羊群中牽一隻沒有殘疾的公綿羊來，給祭司作贖愆祭。至於他誤行的那錯事，祭司要為他贖罪，他必蒙赦免。',
    '利5:19 這是贖愆祭，因他在耶和華面前實在有了罪。',
    '利6:1 耶和華曉諭摩西說：',
    '利6:2 若有人犯罪，干犯耶和華，在鄰舍交付他的物上，或是在交易上行了詭詐，或是搶奪人的財物，或是欺壓鄰舍，',
    '利6:3 或是在撿了遺失的物上行了詭詐，說謊起誓，在這一切的事上犯了什麼罪；',
    '利6:4 他既犯了罪，有了過犯，就要歸還他所搶奪的，或是因欺壓所得的，或是人交付他的，或是人遺失他所撿的物，',
    '利6:5 或是他因什麼物起了假誓，就要如數歸還，另外加上五分之一，在查出他有罪的日子要交還本主。',
    '利6:6 也要照你所估定的價，把贖愆祭牲─就是羊群中一隻沒有殘疾的公綿羊─牽到耶和華面前，給祭司為贖愆祭。',
    '利6:7 祭司要在耶和華面前為他贖罪；他無論行了什麼事，使他有了罪，都必蒙赦免。',
    '利6:8 耶和華曉諭摩西說：',
    '利6:9 你要吩咐亞倫和他的子孫說，燔祭的條例乃是這樣：燔祭要放在壇的柴上，從晚上到天亮，壇上的火要常常燒著。',
    '利6:10 祭司要穿上細麻布衣服，又要把細麻布褲子穿在身上，把壇上所燒的燔祭灰收起來，倒在壇的旁邊；',
    '利6:11 隨後要脫去這衣服，穿上別的衣服，把灰拿到營外潔淨之處。',
    '利6:12 壇上的火要在其上常常燒著，不可熄滅。祭司要每日早晨在上面燒柴，並要把燔祭擺在壇上，在其上燒平安祭牲的脂油。',
    '利6:13 在壇上必有常常燒著的火，不可熄滅。',
    '利6:14 素祭的條例乃是這樣：亞倫的子孫要在壇前把這祭獻在耶和華面前。',
    '利6:15 祭司要從其中─就是從素祭的細麵中─取出自己的一把，又要取些油和素祭上所有的乳香，燒在壇上，奉給耶和華為馨香素祭的記念。',
    '利6:16 所剩下的，亞倫和他子孫要吃，必在聖處不帶酵而吃，要在會幕的院子裡吃。',
    '利6:17 烤的時候不可攙酵。這是從所獻給我的火祭中賜給他們的分，是至聖的，和贖罪祭並贖愆祭一樣。',
    '利6:18 凡獻給耶和華的火祭，亞倫子孫中的男丁都要吃這一分，直到萬代，作他們永得的分。摸這些祭物的，都要成為聖。',
    '利6:19 耶和華曉諭摩西說：',
    '利6:20 當亞倫受膏的日子，他和他子孫所要獻給耶和華的供物，就是細麵伊法十分之一，為常獻的素祭：早晨一半，晚上一半。',
    '利6:21 要在鐵鏊上用油調和做成，調勻了，你就拿進來；烤好了分成塊子，獻給耶和華為馨香的素祭。',
    '利6:22 亞倫的子孫中，接續他為受膏的祭司，要把這素祭獻上，要全燒給耶和華。這是永遠的定例。',
    '利6:23 祭司的素祭都要燒了，卻不可吃。',
    '利6:24 耶和華曉諭摩西說：',
    '利6:25 你對亞倫和他的子孫說，贖罪祭的條例乃是這樣：要在耶和華面前、宰燔祭牲的地方宰贖罪祭牲；這是至聖的。',
    '利6:26 為贖罪獻這祭的祭司要吃，要在聖處，就是在會幕的院子裡吃。',
    '利6:27 凡摸這祭肉的要成為聖；這祭牲的血若彈在什麼衣服上，所彈的那一件要在聖處洗淨。',
    '利6:28 惟有煮祭物的瓦器要打碎；若是煮在銅器裡，這銅器要擦磨，在水中涮淨。',
    '利6:29 凡祭司中的男丁都可以吃；這是至聖的。',
    '利6:30 凡贖罪祭，若將血帶進會幕在聖所贖罪，那肉都不可吃，必用火焚燒。',
    '利7:1 贖愆祭的條例乃是如此：這祭是至聖的。',
    '利7:2 人在哪裡宰燔祭牲，也要在那裡宰贖愆祭牲；其血，祭司要灑在壇的周圍。',
    '利7:3 又要將肥尾巴和蓋臟的脂油，',
    '利7:4 兩個腰子和腰子上的脂油，就是靠腰兩旁的脂油，並肝上的網子和腰子，一概取下。',
    '利7:5 祭司要在壇上焚燒，為獻給耶和華的火祭，是贖愆祭。',
    '利7:6 祭司中的男丁都可以吃這祭物；要在聖處吃，是至聖的。',
    '利7:7 贖罪祭怎樣，贖愆祭也是怎樣，兩個祭是一個條例。獻贖愆祭贖罪的祭司要得這祭物。',
    '利7:8 獻燔祭的祭司，無論為誰奉獻，要親自得他所獻那燔祭牲的皮。',
    '利7:9 凡在爐中烤的素祭和煎盤中做的，並鐵鏊上做的，都要歸那獻祭的祭司。',
    '利7:10 凡素祭，無論是油調和的是乾的，都要歸亞倫的子孫，大家均分。',
    '利7:11 人獻與耶和華平安祭的條例乃是這樣：',
    '利7:12 他若為感謝獻上，就要用調油的無酵餅和抹油的無酵薄餅，並用油調勻細麵做的餅，與感謝祭一同獻上。',
    '利7:13 要用有酵的餅和為感謝獻的平安祭，與供物一同獻上。',
    '利7:14 從各樣的供物中，他要把一個餅獻給耶和華為舉祭，是要歸給灑平安祭牲血的祭司。',
    '利7:15 為感謝獻平安祭牲的肉，要在獻的日子吃，一點不可留到早晨。',
    '利7:16 若所獻的是為還願，或是甘心獻的，必在獻祭的日子吃，所剩下的第二天也可以吃。',
    '利7:17 但所剩下的祭肉，到第三天要用火焚燒；',
    '利7:18 第三天若吃了平安祭的肉，這祭必不蒙悅納，人所獻的也不算為祭，反為可憎嫌的，吃這祭肉的，就必擔當他的罪孽。',
    '利7:19 挨了污穢物的肉就不可吃，要用火焚燒。至於平安祭的肉，凡潔淨的人都要吃；',
    '利7:20 只是獻與耶和華平安祭的肉，人若不潔淨而吃了，這人必從民中剪除。',
    '利7:21 有人摸了什麼不潔淨的物，或是人的不潔淨，或是不潔淨的牲畜，或是不潔可憎之物，吃了獻與耶和華平安祭的肉，這人必從民中剪除。',
    '利7:22 耶和華對摩西說：',
    '利7:23 你曉諭以色列人說：牛的脂油、綿羊的脂油、山羊的脂油，你們都不可吃。',
    '利7:24 自死的和被野獸撕裂的，那脂油可以做別的使用，只是你們萬不可吃。',
    '利7:25 無論何人吃了獻給耶和華當火祭牲畜的脂油，那人必從民中剪除。',
    '利7:26 在你們一切的住處，無論是雀鳥的血是野獸的血，你們都不可吃。',
    '利7:27 無論是誰吃血，那人必從民中剪除。',
    '利7:28 耶和華對摩西說：',
    '利7:29 你曉諭以色列人說：獻平安祭給耶和華的，要從平安祭中取些來奉給耶和華。',
    '利7:30 他親手獻給耶和華的火祭，就是脂油和胸，要帶來，好把胸在耶和華面前作搖祭，搖一搖。',
    '利7:31 祭司要把脂油在壇上焚燒，但胸要歸亞倫和他的子孫。',
    '利7:32 你們要從平安祭中把右腿作舉祭，奉給祭司。',
    '利7:33 亞倫子孫中，獻平安祭牲血和脂油的，要得這右腿為分；',
    '利7:34 因為我從以色列人的平安祭中，取了這搖的胸和舉的腿給祭司亞倫和他子孫，作他們從以色列人中所永得的分。',
    '利7:35 這是從耶和華火祭中，作亞倫受膏的分和他子孫受膏的分，正在摩西（原文是他）叫他們前來給耶和華供祭司職分的日子，',
    '利7:36 就是在摩西（原文是他）膏他們的日子，耶和華吩咐以色列人給他們的。這是他們世世代代永得的分。',
    '利7:37 這就是燔祭、素祭、贖罪祭、贖愆祭，和平安祭的條例，並承接聖職的禮，',
    '利7:38 都是耶和華在西乃山所吩咐摩西的，就是他在西乃曠野吩咐以色列人獻供物給耶和華之日所說的。',
    '利8:1 耶和華曉諭摩西說：',
    '利8:2 你將亞倫和他兒子一同帶來，並將聖衣、膏油，與贖罪祭的一隻公牛、兩隻公綿羊、一筐無酵餅都帶來，',
    '利8:3 又招聚會眾到會幕門口。',
    '利8:4 摩西就照耶和華所吩咐的行了；於是會眾聚集在會幕門口。',
    '利8:5 摩西告訴會眾說：這就是耶和華所吩咐當行的事。',
    '利8:6 摩西帶了亞倫和他兒子來，用水洗了他們。',
    '利8:7 給亞倫穿上內袍，束上腰帶，穿上外袍，又加上以弗得，用其上巧工織的帶子把以弗得繫在他身上，',
    '利8:8 又給他戴上胸牌，把烏陵和土明放在胸牌內，',
    '利8:9 把冠冕戴在他頭上，在冠冕的前面釘上金牌，就是聖冠，都是照耶和華所吩咐摩西的。',
    '利8:10 摩西用膏油抹帳幕和其中所有的，使他成聖；',
    '利8:11 又用膏油在壇上彈了七次，又抹了壇和壇的一切器皿，並洗濯盆和盆座，使他成聖；',
    '利8:12 又把膏油倒在亞倫的頭上膏他，使他成聖。',
    '利8:13 摩西帶了亞倫的兒子來，給他們穿上內袍，束上腰帶，包上裹頭巾，都是照耶和華所吩咐摩西的。',
    '利8:14 他牽了贖罪祭的公牛來，亞倫和他兒子按手在贖罪祭公牛的頭上，',
    '利8:15 就宰了公牛。摩西用指頭蘸血，抹在壇上四角的周圍，使壇潔淨，把血倒在壇的腳那裡，使壇成聖，壇就潔淨了；',
    '利8:16 又取臟上所有的脂油和肝上的網子，並兩個腰子與腰子上的脂油，都燒在壇上；',
    '利8:17 惟有公牛，連皮帶肉並糞，用火燒在營外，都是照耶和華所吩咐摩西的。',
    '利8:18 他奉上燔祭的公綿羊；亞倫和他兒子按手在羊的頭上，',
    '利8:19 就宰了公羊。摩西把血灑在壇的周圍，',
    '利8:20 把羊切成塊子，把頭和肉塊並脂油都燒了。',
    '利8:21 用水洗了臟腑和腿，就把全羊燒在壇上為馨香的燔祭，是獻給耶和華的火祭，都是照耶和華所吩咐摩西的。',
    '利8:22 他又奉上第二隻公綿羊，就是承接聖職之禮的羊；亞倫和他兒子按手在羊的頭上，',
    '利8:23 就宰了羊。摩西把些血抹在亞倫的右耳垂上和右手的大拇指上，並右腳的大拇指上，',
    '利8:24 又帶了亞倫的兒子來，把些血抹在他們的右耳垂上和右手的大拇指上，並右腳的大拇指上，又把血灑在壇的周圍。',
    '利8:25 取脂油和肥尾巴，並臟上一切的脂油與肝上的網子，兩個腰子和腰子上的脂油，並右腿，',
    '利8:26 再從耶和華面前、盛無酵餅的筐子裡取出一個無酵餅，一個油餅，一個薄餅，都放在脂油和右腿上，',
    '利8:27 把這一切放在亞倫的手上和他兒子的手上作搖祭，在耶和華面前搖一搖。',
    '利8:28 摩西從他們的手上拿下來，燒在壇上的燔祭上，都是為承接聖職獻給耶和華馨香的火祭。',
    '利8:29 摩西拿羊的胸作為搖祭，在耶和華面前搖一搖，是承接聖職之禮，歸摩西的分，都是照耶和華所吩咐摩西的。',
    '利8:30 摩西取點膏油和壇上的血，彈在亞倫和他的衣服上，並他兒子和他兒子的衣服上，使他和他們的衣服一同成聖。',
    '利8:31 摩西對亞倫和他兒子說：把肉煮在會幕門口，在那裡吃，又吃承接聖職筐子裡的餅，按我所吩咐的說（或作：按所吩咐我的說）：這是亞倫和他兒子要吃的。',
    '利8:32 剩下的肉和餅，你們要用火焚燒。',
    '利8:33 你們七天不可出會幕的門，等到你們承接聖職的日子滿了，因為主叫你們七天承接聖職。',
    '利8:34 像今天所行的都是耶和華吩咐行的，為你們贖罪。',
    '利8:35 七天你們要晝夜住在會幕門口，遵守耶和華的吩咐，免得你們死亡，因為所吩咐我的就是這樣。',
    '利8:36 於是亞倫和他兒子行了耶和華藉著摩西所吩咐的一切事。',
    '利9:1 到了第八天，摩西召了亞倫和他兒子，並以色列的眾長老來，',
    '利9:2 對亞倫說：你當取牛群中的一隻公牛犢作贖罪祭，一隻公綿羊作燔祭，都要沒有殘疾的，獻在耶和華面前。',
    '利9:3 你也要對以色列人說：你們當取一隻公山羊作贖罪祭，又取一隻牛犢和一隻綿羊羔，都要一歲、沒有殘疾的，作燔祭，',
    '利9:4 又取一隻公牛，一隻公綿羊作平安祭，獻在耶和華面前，並取調油的素祭，因為今天耶和華要向你們顯現。',
    '利9:5 於是他們把摩西所吩咐的，帶到會幕前；全會眾都近前來，站在耶和華面前。',
    '利9:6 摩西說：這是耶和華吩咐你們所當行的；耶和華的榮光就要向你們顯現。',
    '利9:7 摩西對亞倫說：你就近壇前，獻你的贖罪祭和燔祭，為自己與百姓贖罪，又獻上百姓的供物，為他們贖罪，都照耶和華所吩咐的。',
    '利9:8 於是，亞倫就近壇前，宰了為自己作贖罪祭的牛犢。',
    '利9:9 亞倫的兒子把血奉給他，他就把指頭蘸在血中，抹在壇的四角上，又把血倒在壇腳那裡。',
    '利9:10 惟有贖罪祭的脂油和腰子，並肝上取的網子，都燒在壇上，是照耶和華所吩咐摩西的；',
    '利9:11 又用火將肉和皮燒在營外。',
    '利9:12 亞倫宰了燔祭牲，他兒子把血遞給他，他就灑在壇的周圍，',
    '利9:13 又把燔祭一塊一塊地、連頭遞給他，他都燒在壇上；',
    '利9:14 又洗了臟腑和腿，燒在壇上的燔祭上。',
    '利9:15 他奉上百姓的供物，把那給百姓作贖罪祭的公山羊宰了，為罪獻上，和先獻的一樣；',
    '利9:16 也奉上燔祭，照例而獻。',
    '利9:17 他又奉上素祭，從其中取一滿把，燒在壇上；這是在早晨的燔祭以外。',
    '利9:18 亞倫宰了那給百姓作平安祭的公牛和公綿羊。他兒子把血遞給他，他就灑在壇的周圍；',
    '利9:19 又把公牛和公綿羊的脂油、肥尾巴，並蓋臟的脂油與腰子，和肝上的網子，都遞給他；',
    '利9:20 把脂油放在胸上，他就把脂油燒在壇上。',
    '利9:21 胸和右腿，亞倫當作搖祭，在耶和華面前搖一搖，都是照摩西所吩咐的。',
    '利9:22 亞倫向百姓舉手，為他們祝福。他獻了贖罪祭、燔祭、平安祭就下來了。',
    '利9:23 摩西、亞倫進入會幕，又出來為百姓祝福，耶和華的榮光就向眾民顯現。',
    '利9:24 有火從耶和華面前出來，在壇上燒盡燔祭和脂油；眾民一見，就都歡呼，俯伏在地。',
    '利10:1 亞倫的兒子拿答、亞比戶各拿自己的香爐，盛上火，加上香，在耶和華面前獻上凡火，是耶和華沒有吩咐他們的，',
    '利10:2 就有火從耶和華面前出來，把他們燒滅，他們就死在耶和華面前。',
    '利10:3 於是摩西對亞倫說：這就是耶和華所說：我在親近我的人中要顯為聖；在眾民面前，我要得榮耀。亞倫就默默不言。',
    '利10:4 摩西召了亞倫叔父烏薛的兒子米沙利、以利撒反來，對他們說：上前來，把你們的親屬從聖所前擡到營外。',
    '利10:5 於是二人上前來，把他們穿著袍子擡到營外，是照摩西所吩咐的。',
    '利10:6 摩西對亞倫和他兒子以利亞撒、以他瑪說：不可蓬頭散髮，也不可撕裂衣裳，免得你們死亡，又免得耶和華向會眾發怒；只要你們的弟兄以色列全家為耶和華所發的火哀哭。',
    '利10:7 你們也不可出會幕的門，恐怕你們死亡，因為耶和華的膏油在你們的身上。他們就照摩西的話行了。',
    '利10:8 耶和華曉諭亞倫說：',
    '利10:9 你和你兒子進會幕的時候，清酒、濃酒都不可喝，免得你們死亡；這要作你們世世代代永遠的定例。',
    '利10:10 使你們可以將聖的、俗的，潔淨的、不潔淨的，分別出來；',
    '利10:11 又使你們可以將耶和華藉摩西曉諭以色列人的一切律例教訓他們。',
    '利10:12 摩西對亞倫和他剩下的兒子以利亞撒、以他瑪說：你們獻給耶和華火祭中所剩的素祭，要在壇旁不帶酵而吃，因為是至聖的。',
    '利10:13 你們要在聖處吃；因為在獻給耶和華的火祭中，這是你的分和你兒子的分；所吩咐我的本是這樣。',
    '利10:14 所搖的胸，所舉的腿，你們要在潔淨地方吃。你和你的兒女都要同吃；因為這些是從以色列人平安祭中給你，當你的分和你兒子的分。',
    '利10:15 所舉的腿，所搖的胸，他們要與火祭的脂油一同帶來當搖祭，在耶和華面前搖一搖；這要歸你和你兒子，當作永得的分，都是照耶和華所吩咐的。',
    '利10:16 當下摩西急切地尋找作贖罪祭的公山羊，誰知已經焚燒了，便向亞倫剩下的兒子以利亞撒、以他瑪發怒，說：',
    '利10:17 這贖罪祭既是至聖的，主又給了你們，為要你們擔當會眾的罪孽，在耶和華面前為他們贖罪，你們為何沒有在聖所吃呢﹖',
    '利10:18 看哪，這祭牲的血並沒有拿到聖所裡去，你們本當照我所吩咐的，在聖所裡吃這祭肉。',
    '利10:19 亞倫對摩西說：今天他們在耶和華面前獻上贖罪祭和燔祭，我又遇見這樣的災，若今天吃了贖罪祭，耶和華豈能看為美呢﹖',
    '利10:20 摩西聽見這話，便以為美。',
    '利11:1 耶和華對摩西、亞倫說：',
    '利11:2 你們曉諭以色列人說，在地上一切走獸中可吃的乃是這些：',
    '利11:3 凡蹄分兩瓣、倒嚼的走獸，你們都可以吃。',
    '利11:4 但那倒嚼或分蹄之中不可吃的乃是：駱駝─因為倒嚼不分蹄，就與你們不潔淨；',
    '利11:5 沙番─因為倒嚼不分蹄，就與你們不潔淨；',
    '利11:6 兔子─因為倒嚼不分蹄，就與你們不潔淨；',
    '利11:7 豬─因為蹄分兩瓣，卻不倒嚼，就與你們不潔淨。',
    '利11:8 這些獸的肉，你們不可吃；死的，你們不可摸，都與你們不潔淨。',
    '利11:9 水中可吃的乃是這些：凡在水裡、海裡、河裡、有翅有鱗的，都可以吃。',
    '利11:10 凡在海裡、河裡，並一切水裡游動的活物，無翅無鱗的，你們都當以為可憎。',
    '利11:11 這些無翅無鱗、以為可憎的，你們不可吃他的肉；死的也當以為可憎。',
    '利11:12 凡水裡無翅無鱗的，你們都當以為可憎。',
    '利11:13 雀鳥中你們當以為可憎、不可吃的乃是：鵰、狗頭鵰、紅頭鵰、',
    '利11:14 鷂鷹、小鷹與其類；',
    '利11:15 烏鴉與其類；',
    '利11:16 鴕鳥、夜鷹、魚鷹、鷹與其類；',
    '利11:17 鴞鳥、鸕鶿、貓頭鷹、',
    '利11:18 角鴟、鵜鶘、禿鵰、',
    '利11:19 鸛、鷺鷥與其類；戴鵀與蝙蝠。',
    '利11:20 凡有翅膀用四足爬行的物，你們都當以為可憎。',
    '利11:21 只是有翅膀用四足爬行的物中，有足有腿，在地上蹦跳的，你們還可以吃。',
    '利11:22 其中有蝗蟲、螞蚱、蟋蟀與其類；蚱蜢與其類；這些你們都可以吃。',
    '利11:23 但是有翅膀有四足的爬物，你們都當以為可憎。',
    '利11:24 這些都能使你們不潔淨。凡摸了死的，必不潔淨到晚上。',
    '利11:25 凡拿了死的，必不潔淨到晚上，並要洗衣服。',
    '利11:26 凡走獸分蹄不成兩瓣、也不倒嚼的，是與你們不潔淨；凡摸了的就不潔淨。',
    '利11:27 凡四足的走獸，用掌行走的，是與你們不潔淨；摸其屍的，必不潔淨到晚上。',
    '利11:28 拿其屍的，必不潔淨到晚上，並要洗衣服。這些是與你們不潔淨的。',
    '利11:29 地上爬物與你們不潔淨的乃是這些：鼬鼠、鼫鼠、蜥蜴與其類；',
    '利11:30 壁虎、龍子、守宮、蛇醫、蝘蜓。',
    '利11:31 這些爬物都是與你們不潔淨的。在他死了以後，凡摸了的，必不潔淨到晚上。',
    '利11:32 其中死了的，掉在什麼東西上，這東西就不潔淨，無論是木器、衣服、皮子、口袋，不拘是做什麼工用的器皿，須要放在水中，必不潔淨到晚上，到晚上才潔淨了。',
    '利11:33 若有死了掉在瓦器裡的，其中不拘有什麼，就不潔淨，你們要把這瓦器打破了。',
    '利11:34 其中一切可吃的食物，沾水的就不潔淨，並且那樣器皿中一切可喝的，也必不潔淨。',
    '利11:35 其中已死的，若有一點掉在什麼物件上，那物件就不潔淨，不拘是爐子，是鍋臺，就要打碎，都不潔淨，也必與你們不潔淨。',
    '利11:36 但是泉源或是聚水的池子仍是潔淨；惟挨了那死的，就不潔淨。',
    '利11:37 若是死的，有一點掉在要種的子粒上，子粒仍是潔淨；',
    '利11:38 若水已經澆在子粒上，那死的有一點掉在上頭，這子粒就與你們不潔淨。',
    '利11:39 你們可吃的走獸若是死了，有人摸他，必不潔淨到晚上；',
    '利11:40 有人吃那死了的走獸，必不潔淨到晚上，並要洗衣服；拿了死走獸的，必不潔淨到晚上，並要洗衣服。',
    '利11:41 凡地上的爬物是可憎的，都不可吃。',
    '利11:42 凡用肚子行走的和用四足行走的，或是有許多足的，就是一切爬在地上的，你們都不可吃，因為是可憎的。',
    '利11:43 你們不可因什麼爬物使自己成為可憎的，也不可因這些使自己不潔淨，以致染了污穢。',
    '利11:44 我是耶和華─你們的神；所以你們要成為聖潔，因為我是聖潔的。你們也不可在地上的爬物污穢自己。',
    '利11:45 我是把你們從埃及地領出來的耶和華，要作你們的神；所以你們要聖潔，因為我是聖潔的。',
    '利11:46 這是走獸、飛鳥，和水中游動的活物，並地上爬物的條例。',
    '利11:47 要把潔淨的和不潔淨的，可吃的與不可吃的活物，都分別出來。',
    '利12:1 耶和華對摩西說：',
    '利12:2 你曉諭以色列人說：若有婦人懷孕生男孩，他就不潔淨七天，像在月經污穢的日子不潔淨一樣。',
    '利12:3 第八天，要給嬰孩行割禮。',
    '利12:4 婦人在產血不潔之中，要家居三十三天。他潔淨的日子未滿，不可摸聖物，也不可進入聖所。',
    '利12:5 他若生女孩，就不潔淨兩個七天，像污穢的時候一樣，要在產血不潔之中，家居六十六天。',
    '利12:6 滿了潔淨的日子，無論是為男孩是為女孩，他要把一歲的羊羔為燔祭，一隻雛鴿或是一隻斑鳩為贖罪祭，帶到會幕門口交給祭司。',
    '利12:7 祭司要獻在耶和華面前，為他贖罪，他的血源就潔淨了。這條例是為生育的婦人，無論是生男生女。',
    '利12:8 他的力量若不夠獻一隻羊羔，他就要取兩隻斑鳩或是兩隻雛鴿，一隻為燔祭，一隻為贖罪祭。祭司要為他贖罪，他就潔淨了。',
    '利13:1 耶和華曉諭摩西、亞倫說：',
    '利13:2 人的肉皮上若長了癤子，或長了癬，或長了火斑，在他肉皮上成了大痲瘋的災病，就要將他帶到祭司亞倫或亞倫作祭司的一個子孫面前。',
    '利13:3 祭司要察看肉皮上的災病，若災病處的毛已經變白，災病的現象深於肉上的皮，這便是大痲瘋的災病。祭司要察看他，定他為不潔淨。',
    '利13:4 若火斑在他肉皮上是白的，現象不深於皮，其上的毛也沒有變白，祭司就要將有災病的人關鎖七天。',
    '利13:5 第七天，祭司要察看他，若看災病止住了，沒有在皮上發散，祭司還要將他關鎖七天。',
    '利13:6 第七天，祭司要再察看他，若災病發暗，而且沒有在皮上發散，祭司要定他為潔淨，原來是癬；那人就要洗衣服，得為潔淨。',
    '利13:7 但他為得潔淨，將身體給祭司察看以後，癬若在皮上發散開了，他要再將身體給祭司察看。',
    '利13:8 祭司要察看，癬若在皮上發散，就要定他為不潔淨，是大痲瘋。',
    '利13:9 人有了大痲瘋的災病，就要將他帶到祭司面前。',
    '利13:10 祭司要察看，皮上若長了白癤，使毛變白，在長白癤之處有了紅瘀肉，',
    '利13:11 這是肉皮上的舊大痲瘋，祭司要定他為不潔淨，不用將他關鎖，因為他是不潔淨了。',
    '利13:12 大痲瘋若在皮上四外發散，長滿了患災病人的皮，據祭司察看，從頭到腳無處不有，',
    '利13:13 祭司就要察看，全身的肉若長滿了大痲瘋，就要定那患災病的為潔淨；全身都變為白，他乃潔淨了。',
    '利13:14 但紅肉幾時顯在他的身上就幾時不潔淨。',
    '利13:15 祭司一看那紅肉就定他為不潔淨。紅肉本是不潔淨，是大痲瘋。',
    '利13:16 紅肉若復原，又變白了，他就要來見祭司。',
    '利13:17 祭司要察看，災病處若變白了，祭司就要定那患災病的為潔淨，他乃潔淨了。',
    '利13:18 人若在皮肉上長瘡，卻治好了，',
    '利13:19 在長瘡之處又起了白癤，或是白中帶紅的火斑，就要給祭司察看。',
    '利13:20 祭司要察看，若現象窪於皮，其上的毛也變白了，就要定他為不潔淨，是大痲瘋的災病發在瘡中。',
    '利13:21 祭司若察看，其上沒有白毛，也沒有窪於皮，乃是發暗，就要將他關鎖七天。',
    '利13:22 若在皮上發散開了，祭司就要定他為不潔淨，是災病。',
    '利13:23 火斑若在原處止住，沒有發散，便是瘡的痕跡，祭司就要定他為潔淨。',
    '利13:24 人的皮肉上若起了火毒，火毒的瘀肉成了火斑，或是白中帶紅的，或是全白的，',
    '利13:25 祭司就要察看，火斑中的毛若變白了，現象又深於皮，是大痲瘋在火毒中發出，就要定他為不潔淨，是大痲瘋的災病。',
    '利13:26 但是祭司察看，在火斑中若沒有白毛，也沒有窪於皮，乃是發暗，就要將他關鎖七天。',
    '利13:27 到第七天，祭司要察看他，火斑若在皮上發散開了，就要定他為不潔淨，是大痲瘋的災病。',
    '利13:28 火斑若在原處止住，沒有在皮上發散，乃是發暗，是起的火毒，祭司要定他為潔淨，不過是火毒的痕跡。',
    '利13:29 無論男女，若在頭上有災病，或是男人鬍鬚上有災病，',
    '利13:30 祭司就要察看；這災病現象若深於皮，其間有細黃毛，就要定他為不潔淨，這是頭疥，是頭上或是鬍鬚上的大痲瘋。',
    '利13:31 祭司若察看頭疥的災病，現象不深於皮，其間也沒有黑毛，就要將長頭疥災病的關鎖七天。',
    '利13:32 第七天，祭司要察看災病，若頭疥沒有發散，其間也沒有黃毛，頭疥的現象不深於皮，',
    '利13:33 那人就要剃去鬚髮，但他不可剃頭疥之處。祭司要將那長頭疥的，再關鎖七天。',
    '利13:34 第七天，祭司要察看頭疥，頭疥若沒有在皮上發散，現象也不深於皮，就要定他為潔淨，他要洗衣服，便成為潔淨。',
    '利13:35 但他得潔淨以後，頭疥若在皮上發散開了，',
    '利13:36 祭司就要察看他。頭疥若在皮上發散，就不必找那黃毛，他是不潔淨了。',
    '利13:37 祭司若看頭疥已經止住，其間也長了黑毛，頭疥已然痊癒，那人是潔淨了，就要定他為潔淨。',
    '利13:38 無論男女，皮肉上若起了火斑，就是白火斑，',
    '利13:39 祭司就要察看，他們肉皮上的火斑若白中帶黑，這是皮上發出的白癬，那人是潔淨了。',
    '利13:40 人頭上的髮若掉了，他不過是頭禿，還是潔淨。',
    '利13:41 他頂前若掉了頭髮，他不過是頂門禿，還是潔淨。',
    '利13:42 頭禿處或是頂門禿處若有白中帶紅的災病，這就是大痲瘋發在他頭禿處或是頂門禿處，',
    '利13:43 祭司就要察看，他起的那災病若在頭禿處或是頂門禿處有白中帶紅的，像肉皮上大痲瘋的現象，',
    '利13:44 那人就是長大痲瘋，不潔淨的，祭司總要定他為不潔淨，他的災病是在頭上。',
    '利13:45 身上有長大痲瘋災病的，他的衣服要撕裂，也要蓬頭散髮，蒙著上唇，喊叫說：不潔淨了！不潔淨了！',
    '利13:46 災病在他身上的日子，他便是不潔淨；他既是不潔淨，就要獨居營外。',
    '利13:47 染了大痲瘋災病的衣服，無論是羊毛衣服、是麻布衣服，',
    '利13:48 無論是在經上、在緯上，是麻布的、是羊毛的，是在皮子上，或在皮子做的什麼物件上，',
    '利13:49 或在衣服上、皮子上，經上、緯上，或在皮子做的什麼物件上，這災病若是發綠，或是發紅，是大痲瘋的災病，要給祭司察看。',
    '利13:50 祭司就要察看那災病，把染了災病的物件關鎖七天。',
    '利13:51 第七天，他要察看那災病，災病或在衣服上，經上、緯上，皮子上，若發散，這皮子無論當作何用，這災病是蠶食的大痲瘋，都是不潔淨了。',
    '利13:52 那染了災病的衣服，或是經上、緯上，羊毛上，麻衣上，或是皮子做的什麼物件上，他都要焚燒；因為這是蠶食的大痲瘋，必在火中焚燒。',
    '利13:53 祭司要察看，若災病在衣服上，經上、緯上，或是皮子做的什麼物件上，沒有發散，',
    '利13:54 祭司就要吩咐他們，把染了災病的物件洗了，再關鎖七天。',
    '利13:55 洗過以後，祭司要察看，那物件若沒有變色，災病也沒有消散，那物件就不潔淨，是透重的災病，無論正面反面，都要在火中焚燒。',
    '利13:56 洗過以後，祭司要察看，若見那災病發暗，他就要把那災病從衣服上、皮子上、經上、緯上，都撕去。',
    '利13:57 若仍現在衣服上，或是經上、緯上、皮子做的什麼物件上，這就是災病又發了、必用火焚燒那染災病的物件。',
    '利13:58 所洗的衣服，或是經，或是緯，或是皮子做的什麼物件，若災病離開了，要再洗，就潔淨了。',
    '利13:59 這就是大痲瘋災病的條例，無論是在羊毛衣服上，麻布衣服上，經上、緯上，和皮子做的什麼物件上，可以定為潔淨或是不潔淨。',
    '利14:1 耶和華曉諭摩西說：',
    '利14:2 長大痲瘋得潔淨的日子，其例乃是這樣：要帶他去見祭司；',
    '利14:3 祭司要出到營外察看，若見他的大痲瘋痊癒了，',
    '利14:4 就要吩咐人為那求潔淨的拿兩隻潔淨的活鳥和香柏木、朱紅色線，並牛膝草來。',
    '利14:5 祭司要吩咐用瓦器盛活水，把一隻鳥宰在上面。',
    '利14:6 至於那隻活鳥，祭司要把他和香柏木、朱紅色線並牛膝草一同蘸於宰在活水上的鳥血中，',
    '利14:7 用以在那長大痲瘋求潔淨的人身上灑七次，就定他為潔淨，又把活鳥放在田野裡。',
    '利14:8 求潔淨的人當洗衣服，剃去毛髮，用水洗澡，就潔淨了；然後可以進營，只是要在自己的帳棚外居住七天。',
    '利14:9 第七天，再把頭上所有的頭髮與鬍鬚、眉毛，並全身的毛，都剃了；又要洗衣服，用水洗身，就潔淨了。',
    '利14:10 第八天，他要取兩隻沒有殘疾的公羊羔和一隻沒有殘疾、一歲的母羊羔，又要把調油的細麵伊法十分之三為素祭，並油一羅革，一同取來。',
    '利14:11 行潔淨之禮的祭司要將那求潔淨的人和這些東西安置在會幕門口、耶和華面前。',
    '利14:12 祭司要取一隻公羊羔獻為贖愆祭，和那一羅革油一同作搖祭，在耶和華面前搖一搖；',
    '利14:13 把公羊羔宰於聖地，就是宰贖罪祭牲和燔祭牲之地。贖愆祭要歸祭司，與贖罪祭一樣，是至聖的。',
    '利14:14 祭司要取些贖愆祭牲的血，抹在求潔淨人的右耳垂上和右手的大拇指上，並右腳的大拇指上。',
    '利14:15 祭司要從那一羅革油中取些倒在自己的左手掌裡，',
    '利14:16 把右手的一個指頭蘸在左手的油裡，在耶和華面前用指頭彈七次。',
    '利14:17 將手裡所剩的油抹在那求潔淨人的右耳垂上和右手的大拇指上，並右腳的大拇指上，就是抹在贖愆祭牲的血上。',
    '利14:18 祭司手裡所剩的油要抹在那求潔淨人的頭上，在耶和華面前為他贖罪。',
    '利14:19 祭司要獻贖罪祭，為那本不潔淨、求潔淨的人贖罪；然後要宰燔祭牲，',
    '利14:20 把燔祭和素祭獻在壇上，為他贖罪，他就潔淨了。',
    '利14:21 他若貧窮不能預備夠數，就要取一隻公羊羔作贖愆祭，可以搖一搖，為他贖罪；也要把調油的細麵伊法十分之一為素祭，和油一羅革一同取來；',
    '利14:22 又照他的力量取兩隻斑鳩或是兩隻雛鴿，一隻作贖罪祭，一隻作燔祭。',
    '利14:23 第八天，要為潔淨，把這些帶到會幕門口、耶和華面前，交給祭司。',
    '利14:24 祭司要把贖愆祭的羊羔和那一羅革油一同作搖祭，在耶和華面前搖一搖。',
    '利14:25 要宰了贖愆祭的羊羔，取些贖愆祭牲的血，抹在那求潔淨人的右耳垂上和右手的大拇指上，並右腳的大拇指上。',
    '利14:26 祭司要把些油倒在自己的左手掌裡，',
    '利14:27 把左手裡的油，在耶和華面前，用右手的一個指頭彈七次，',
    '利14:28 又把手裡的油抹些在那求潔淨人的右耳垂上和右手的大拇指上，並右腳的大拇指上，就是抹贖愆祭之血的原處。',
    '利14:29 祭司手裡所剩的油要抹在那求潔淨人的頭上，在耶和華面前為他贖罪。',
    '利14:30 那人又要照他的力量獻上一隻斑鳩或是一隻雛鴿，',
    '利14:31 就是他所能辦的，一隻為贖罪祭，一隻為燔祭，與素祭一同獻上；祭司要在耶和華面前為他贖罪。',
    '利14:32 這是那有大痲瘋災病的人、不能將關乎得潔淨之物預備夠數的條例。',
    '利14:33 耶和華曉諭摩西、亞倫說：',
    '利14:34 你們到了我賜給你們為業的迦南地，我若使你們所得為業之地的房屋中有大痲瘋的災病，',
    '利14:35 房主就要去告訴祭司說：據我看，房屋中似乎有災病。',
    '利14:36 祭司還沒有進去察看災病以前，就要吩咐人把房子騰空，免得房子裡所有的都成了不潔淨；然後祭司要進去察看房子。',
    '利14:37 他要察看那災病，災病若在房子的牆上有發綠或發紅的凹斑紋，現象窪於牆，',
    '利14:38 祭司就要出到房門外，把房子封鎖七天。',
    '利14:39 第七天，祭司要再去察看，災病若在房子的牆上發散，',
    '利14:40 就要吩咐人把那有災病的石頭挖出來，扔在城外不潔淨之處；',
    '利14:41 也要叫人刮房內的四圍，所刮掉的灰泥要倒在城外不潔淨之處；',
    '利14:42 又要用別的石頭代替那挖出來的石頭，要另用灰泥墁房子。',
    '利14:43 他挖出石頭，刮了房子，墁了以後，災病若在房子裡又發現，',
    '利14:44 祭司就要進去察看，災病若在房子裡發散，這就是房內蠶食的大痲瘋，是不潔淨。',
    '利14:45 他就要拆毀房子，把石頭、木頭、灰泥都搬到城外不潔淨之處。',
    '利14:46 在房子封鎖的時候，進去的人必不潔淨到晚上；',
    '利14:47 在房子裡躺著的必洗衣服；在房子裡吃飯的也必洗衣服。',
    '利14:48 房子墁了以後，祭司若進去察看，見災病在房內沒有發散，就要定房子為潔淨，因為災病已經消除。',
    '利14:49 要為潔淨房子取兩隻鳥和香柏木、朱紅色線並牛膝草，',
    '利14:50 用瓦器盛活水，把一隻鳥宰在上面，',
    '利14:51 把香柏木、牛膝草、朱紅色線，並那活鳥，都蘸在被宰的鳥血中與活水中，用以灑房子七次。',
    '利14:52 要用鳥血、活水、活鳥、香柏木、牛膝草，並朱紅色線，潔淨那房子。',
    '利14:53 但要把活鳥放在城外田野裡。這樣潔淨房子（原文是為房子贖罪），房子就潔淨了。',
    '利14:54 這是為各類大痲瘋的災病和頭疥，',
    '利14:55 並衣服與房子的大痲瘋，',
    '利14:56 以及癤子、癬、火斑所立的條例，',
    '利14:57 指明何時為潔淨，何時為不潔淨。這是大痲瘋的條例。',
    '利15:1 耶和華對摩西、亞倫說：',
    '利15:2 你們曉諭以色列人說：人若身患漏症，他因這漏症就不潔淨了。',
    '利15:3 他患漏症，無論是下流的，是止住的，都是不潔淨。',
    '利15:4 他所躺的床都為不潔淨，所坐的物也為不潔淨。',
    '利15:5 凡摸那床的，必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:6 那坐患漏症人所坐之物的，必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:7 那摸患漏症人身體的，必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:8 若患漏症人吐在潔淨的人身上，那人必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:9 患漏症人所騎的鞍子也為不潔淨。',
    '利15:10 凡摸了他身下之物的，必不潔淨到晚上；拿了那物的，必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:11 患漏症的人沒有用水涮手，無論摸了誰，誰必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:12 患漏症人所摸的瓦器就必打破；所摸的一切木器也必用水涮洗。',
    '利15:13 患漏症的人痊癒了，就要為潔淨自己計算七天，也必洗衣服，用活水洗身，就潔淨了。',
    '利15:14 第八天，要取兩隻斑鳩或是兩隻雛鴿，來到會幕門口、耶和華面前，把鳥交給祭司。',
    '利15:15 祭司要獻上一隻為贖罪祭，一隻為燔祭；因那人患的漏症，祭司要在耶和華面前為他贖罪。',
    '利15:16 人若夢遺，他必不潔淨到晚上，並要用水洗全身。',
    '利15:17 無論是衣服是皮子，被精所染，必不潔淨到晚上，並要用水洗。',
    '利15:18 若男女交合，兩個人必不潔淨到晚上，並要用水洗澡。',
    '利15:19 女人行經，必污穢七天；凡摸他的，必不潔淨到晚上。',
    '利15:20 女人在污穢之中，凡他所躺的物件都為不潔淨，所坐的物件也都不潔淨。',
    '利15:21 凡摸他床的，必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:22 凡摸他所坐什麼物件的，必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:23 在女人的床上，或在他坐的物上，若有別的物件，人一摸了，必不潔淨到晚上。',
    '利15:24 男人若與那女人同房，染了他的污穢，就要七天不潔淨；所躺的床也為不潔淨。',
    '利15:25 女人若在經期以外患多日的血漏，或是經期過長，有了漏症，他就因這漏症不潔淨，與他在經期不潔淨一樣。',
    '利15:26 他在患漏症的日子所躺的床、所坐的物都要看為不潔淨，與他月經的時候一樣。',
    '利15:27 凡摸這些物件的，就為不潔淨，必不潔淨到晚上，並要洗衣服，用水洗澡。',
    '利15:28 女人的漏症若好了，就要計算七天，然後才為潔淨。',
    '利15:29 第八天，要取兩隻斑鳩或是兩隻雛鴿，帶到會幕門口給祭司。',
    '利15:30 祭司要獻一隻為贖罪祭，一隻為燔祭；因那人血漏不潔，祭司要在耶和華面前為他贖罪。',
    '利15:31 你們要這樣使以色列人與他們的污穢隔絕，免得他們玷污我的帳幕，就因自己的污穢死亡。',
    '利15:32 這是患漏症和夢遺而不潔淨的，',
    '利15:33 並有月經病的和患漏症的，無論男女，並人與不潔淨女人同房的條例。',
    '利16:1 亞倫的兩個兒子近到耶和華面前死了。死了之後，耶和華曉諭摩西說：',
    '利16:2 要告訴你哥哥亞倫，不可隨時進聖所的幔子內、到櫃上的施恩座前，免得他死亡，因為我要從雲中顯現在施恩座上。',
    '利16:3 亞倫進聖所，要帶一隻公牛犢為贖罪祭，一隻公綿羊為燔祭。',
    '利16:4 要穿上細麻布聖內袍，把細麻布褲子穿在身上，腰束細麻布帶子，頭戴細麻布冠冕；這都是聖服。他要用水洗身，然後穿戴。',
    '利16:5 要從以色列會眾取兩隻公山羊為贖罪祭，一隻公綿羊為燔祭。',
    '利16:6 亞倫要把贖罪祭的公牛奉上，為自己和本家贖罪；',
    '利16:7 也要把兩隻公山羊安置在會幕門口、耶和華面前，',
    '利16:8 為那兩隻羊拈鬮，一鬮歸與耶和華，一鬮歸與阿撒瀉勒。',
    '利16:9 亞倫要把那拈鬮歸與耶和華的羊獻為贖罪祭，',
    '利16:10 但那拈鬮歸與阿撒瀉勒的羊要活著安置在耶和華面前，用以贖罪，打發人送到曠野去，歸與阿撒瀉勒。',
    '利16:11 亞倫要把贖罪祭的公牛牽來宰了，為自己和本家贖罪；',
    '利16:12 拿香爐，從耶和華面前的壇上盛滿火炭，又拿一捧搗細的香料，都帶入幔子內，',
    '利16:13 在耶和華面前，把香放在火上，使香的煙雲遮掩法櫃上的施恩座，免得他死亡；',
    '利16:14 也要取些公牛的血，用指頭彈在施恩座的東面，又在施恩座的前面彈血七次。',
    '利16:15 隨後他要宰那為百姓作贖罪祭的公山羊，把羊的血帶入幔子內，彈在施恩座的上面和前面，好像彈公牛的血一樣。',
    '利16:16 他因以色列人諸般的污穢、過犯，就是他們一切的罪愆，當這樣在聖所行贖罪之禮，並因會幕在他們污穢之中，也要照樣而行。',
    '利16:17 他進聖所贖罪的時候，會幕裡不可有人，直等到他為自己和本家並以色列全會眾贖了罪出來。',
    '利16:18 他出來，要到耶和華面前的壇那裡，在壇上行贖罪之禮，又要取些公牛的血和公山羊的血，抹在壇上四角的周圍；',
    '利16:19 也要用指頭把血彈在壇上七次，潔淨了壇，從壇上除掉以色列人諸般的污穢，使壇成聖。',
    '利16:20 亞倫為聖所和會幕並壇獻完了贖罪祭，就要把那隻活著的公山羊奉上。',
    '利16:21 兩手按在羊頭上，承認以色列人諸般的罪孽過犯，就是他們一切的罪愆，把這罪都歸在羊的頭上，藉著所派之人的手，送到曠野去。',
    '利16:22 要把這羊放在曠野，這羊要擔當他們一切的罪孽，帶到無人之地。',
    '利16:23 亞倫要進會幕，把他進聖所時所穿的細麻布衣服脫下，放在那裡，',
    '利16:24 又要在聖處用水洗身，穿上衣服，出來，把自己的燔祭和百姓的燔祭獻上，為自己和百姓贖罪。',
    '利16:25 贖罪祭牲的脂油要在壇上焚燒。',
    '利16:26 那放羊歸與阿撒瀉勒的人要洗衣服，用水洗身，然後進營。',
    '利16:27 作贖罪祭的公牛和公山羊的血既帶入聖所贖罪，這牛羊就要搬到營外，將皮、肉、糞用火焚燒。',
    '利16:28 焚燒的人要洗衣服，用水洗身，然後進營。',
    '利16:29 每逢七月初十日，你們要刻苦己心，無論是本地人，是寄居在你們中間的外人，什麼工都不可做；這要作你們永遠的定例。',
    '利16:30 因在這日要為你們贖罪，使你們潔淨。你們要在耶和華面前得以潔淨，脫盡一切的罪愆。',
    '利16:31 這日你們要守為聖安息日，要刻苦己心；這為永遠的定例。',
    '利16:32 那受膏、接續他父親承接聖職的祭司要穿上細麻布的聖衣，行贖罪之禮。',
    '利16:33 他要在至聖所和會幕與壇行贖罪之禮，並要為眾祭司和會眾的百姓贖罪。',
    '利16:34 這要作你們永遠的定例─就是因以色列人一切的罪，要一年一次為他們贖罪。於是，亞倫照耶和華所吩咐摩西的行了。',
    '利17:1 耶和華對摩西說：',
    '利17:2 你曉諭亞倫和他兒子並以色列眾人說，耶和華所吩咐的乃是這樣：',
    '利17:3 凡以色列家中的人宰公牛，或是綿羊羔，或是山羊，不拘宰於營內營外，',
    '利17:4 若未曾牽到會幕門口、耶和華的帳幕前獻給耶和華為供物，流血的罪必歸到那人身上。他流了血，要從民中剪除。',
    '利17:5 這是為要使以色列人把他們在田野裡所獻的祭帶到會幕門口、耶和華面前，交給祭司，獻與耶和華為平安祭。',
    '利17:6 祭司要把血灑在會幕門口、耶和華的壇上，把脂油焚燒，獻給耶和華為馨香的祭。',
    '利17:7 他們不可再獻祭給他們行邪淫所隨從的鬼魔（原文作公山羊）；這要作他們世世代代永遠的定例。',
    '利17:8 你要曉諭他們說：凡以色列家中的人，或是寄居在他們中間的外人，獻燔祭或是平安祭，',
    '利17:9 若不帶到會幕門口獻給耶和華，那人必從民中剪除。',
    '利17:10 凡以色列家中的人，或是寄居在他們中間的外人，若吃什麼血，我必向那吃血的人變臉，把他從民中剪除。',
    '利17:11 因為活物的生命是在血中。我把這血賜給你們，可以在壇上為你們的生命贖罪；因血裡有生命，所以能贖罪。',
    '利17:12 因此，我對以色列人說：你們都不可吃血；寄居在你們中間的外人也不可吃血。',
    '利17:13 凡以色列人，或是寄居在他們中間的外人，若打獵得了可吃的禽獸，必放出他的血來，用土掩蓋。',
    '利17:14 論到一切活物的生命，就在血中。所以我對以色列人說：無論什麼活物的血，你們都不可吃，因為一切活物的血就是他的生命。凡吃了血的，必被剪除。',
    '利17:15 凡吃自死的，或是被野獸撕裂的，無論是本地人，是寄居的，必不潔淨到晚上，都要洗衣服，用水洗身，到了晚上才為潔淨。',
    '利17:16 但他若不洗衣服，也不洗身，就必擔當他的罪孽。',
    '利18:1 耶和華對摩西說：',
    '利18:2 你曉諭以色列人說：我是耶和華─你們的神。',
    '利18:3 你們從前住的埃及地，那裡人的行為，你們不可效法，我要領你們到的迦南地，那裡人的行為也不可效法，也不可照他們的惡俗行。',
    '利18:4 你們要遵我的典章，守我的律例，按此而行。我是耶和華─你們的神。',
    '利18:5 所以，你們要守我的律例典章；人若遵行，就必因此活著。我是耶和華。',
    '利18:6 你們都不可露骨肉之親的下體，親近他們。我是耶和華。',
    '利18:7 不可露你母親的下體，羞辱了你父親。他是你的母親，不可露他的下體。',
    '利18:8 不可露你繼母的下體；這本是你父親的下體。',
    '利18:9 你的姊妹，不拘是異母同父的，是異父同母的，無論是生在家生在外的，都不可露他們的下體。',
    '利18:10 不可露你孫女或是外孫女的下體，露了他們的下體就是露了自己的下體。',
    '利18:11 你繼母從你父親生的女兒本是你的妹妹，不可露他的下體。',
    '利18:12 不可露你姑母的下體；他是你父親的骨肉之親。',
    '利18:13 不可露你姨母的下體；他是你母親的骨肉之親。',
    '利18:14 不可親近你伯叔之妻，羞辱了你伯叔；他是你的伯叔母。',
    '利18:15 不可露你兒婦的下體；他是你兒子的妻，不可露他的下體。',
    '利18:16 不可露你弟兄妻子的下體；這本是你弟兄的下體。',
    '利18:17 不可露了婦人的下體，又露他女兒的下體，也不可娶他孫女或是外孫女，露他們的下體；他們是骨肉之親，這本是大惡。',
    '利18:18 你妻還在的時候，不可另娶他的姊妹作對頭，露他的下體。',
    '利18:19 女人行經不潔淨的時候，不可露他的下體，與他親近。',
    '利18:20 不可與鄰舍的妻行淫，玷污自己。',
    '利18:21 不可使你的兒女經火歸與摩洛，也不可褻瀆你神的名。我是耶和華。',
    '利18:22 不可與男人苟合，像與女人一樣；這本是可憎惡的。',
    '利18:23 不可與獸淫合，玷污自己。女人也不可站在獸前，與他淫合；這本是逆性的事。',
    '利18:24 在這一切的事上，你們都不可玷污自己；因為我在你們面前所逐出的列邦，在這一切的事上玷污了自己；',
    '利18:25 連地也玷污了，所以我追討那地的罪孽，那地也吐出他的居民。',
    '利18:26 故此，你們要守我的律例典章。這一切可憎惡的事，無論是本地人，是寄居在你們中間的外人，都不可行，',
    '利18:27 在你們以先居住那地的人行了這一切可憎惡的事，地就玷污了，',
    '利18:28 免得你們玷污那地的時候，地就把你們吐出，像吐出在你們以先的國民一樣。',
    '利18:29 無論什麼人，行了其中可憎的一件事，必從民中剪除。',
    '利18:30 所以，你們要守我所吩咐的，免得你們隨從那些可憎的惡俗，就是在你們以先的人所常行的，以致玷污了自己。我是耶和華─你們的神。',
    '利19:1 耶和華對摩西說：',
    '利19:2 你曉諭以色列全會眾說：你們要聖潔，因為我耶和華─你們的神是聖潔的。',
    '利19:3 你們各人都當孝敬父母，也要守我的安息日。我是耶和華─你們的神。',
    '利19:4 你們不可偏向虛無的神，也不可為自己鑄造神像。我是耶和華─你們的神。',
    '利19:5 你們獻平安祭給耶和華的時候，要獻得可蒙悅納。',
    '利19:6 這祭物要在獻的那一天和第二天吃，若有剩到第三天的，就必用火焚燒。',
    '利19:7 第三天若再吃，這就為可憎惡的，必不蒙悅納。',
    '利19:8 凡吃的人必擔當他的罪孽；因為他褻瀆了耶和華的聖物，那人必從民中剪除。',
    '利19:9 在你們的地收割莊稼，不可割盡田角，也不可拾取所遺落的。',
    '利19:10 不可摘盡葡萄園的果子，也不可拾取葡萄園所掉的果子；要留給窮人和寄居的。我是耶和華─你們的神。',
    '利19:11 你們不可偷盜，不可欺騙，也不可彼此說謊。',
    '利19:12 不可指著我的名起假誓，褻瀆你神的名。我是耶和華。',
    '利19:13 不可欺壓你的鄰舍，也不可搶奪他的物。雇工人的工價，不可在你那裡過夜，留到早晨。',
    '利19:14 不可咒罵聾子，也不可將絆腳石放在瞎子面前，只要敬畏你的神。我是耶和華。',
    '利19:15 你們施行審判，不可行不義；不可偏護窮人，也不可重看有勢力的人，只要按著公義審判你的鄰舍。',
    '利19:16 不可在民中往來搬弄是非，也不可與鄰舍為敵，置之於死（原文作流他的血）。我是耶和華。',
    '利19:17 不可心裡恨你的弟兄；總要指摘你的鄰舍，免得因他擔罪。',
    '利19:18 不可報仇，也不可埋怨你本國的子民，卻要愛人如己。我是耶和華。',
    '利19:19 你們要守我的律例。不可叫你的牲畜與異類配合；不可用兩樣攙雜的種種你的地，也不可用兩樣攙雜的料做衣服穿在身上。',
    '利19:20 婢女許配了丈夫，還沒有被贖、得釋放，人若與他行淫，二人要受刑罰，卻不把他們治死，因為婢女還沒有得自由。',
    '利19:21 那人要把贖愆祭，就是一隻公綿羊牽到會幕門口、耶和華面前。',
    '利19:22 祭司要用贖愆祭的羊在耶和華面前贖他所犯的罪，他的罪就必蒙赦免。',
    '利19:23 你們到了迦南地，栽種各樣結果子的樹木，就要以所結的果子如未受割禮的一樣。三年之久，你們要以這些果子，如未受割禮的，是不可吃的。',
    '利19:24 但第四年所結的果子全要成為聖，用以讚美耶和華。',
    '利19:25 第五年，你們要吃那樹上的果子，好叫樹給你們結果子更多。我是耶和華─你們的神。',
    '利19:26 你們不可吃帶血的物；不可用法術，也不可觀兆。',
    '利19:27 頭的周圍（周圍或作：兩鬢）不可剃，鬍鬚的周圍也不可損壞。',
    '利19:28 不可為死人用刀劃身，也不可在身上刺花紋。我是耶和華。',
    '利19:29 不可辱沒你的女兒，使他為娼妓，恐怕地上的人專向淫亂，地就滿了大惡。',
    '利19:30 你們要守我的安息日，敬我的聖所。我是耶和華。',
    '利19:31 不可偏向那些交鬼的和行巫術的；不可求問他們，以致被他們玷污了。我是耶和華─你們的神。',
    '利19:32 在白髮的人面前，你要站起來；也要尊敬老人，又要敬畏你的神。我是耶和華。',
    '利19:33 若有外人在你們國中和你同居，就不可欺負他。',
    '利19:34 和你們同居的外人，你們要看他如本地人一樣，並要愛他如己，因為你們在埃及地也作過寄居的。我是耶和華─你們的神。',
    '利19:35 你們施行審判，不可行不義；在尺、秤、升、斗上也是如此。',
    '利19:36 要用公道天平、公道法碼、公道升斗、公道秤。我是耶和華─你們的神，曾把你們從埃及地領出來的。',
    '利19:37 你們要謹守遵行我一切的律例典章。我是耶和華。',
    '利20:1 耶和華對摩西說：',
    '利20:2 你還要曉諭以色列人說：凡以色列人，或是在以色列中寄居的外人，把自己的兒女獻給摩洛的，總要治死他；本地人要用石頭把他打死。',
    '利20:3 我也要向那人變臉，把他從民中剪除；因為他把兒女獻給摩洛，玷污我的聖所，褻瀆我的聖名。',
    '利20:4 那人把兒女獻給摩洛，本地人若佯為不見，不把他治死，',
    '利20:5 我就要向這人和他的家變臉，把他和一切隨他與摩洛行邪淫的人都從民中剪除。',
    '利20:6 人偏向交鬼的和行巫術的，隨他們行邪淫，我要向那人變臉，把他從民中剪除。',
    '利20:7 所以你們要自潔成聖，因為我是耶和華─你們的神。',
    '利20:8 你們要謹守遵行我的律例；我是叫你們成聖的耶和華。',
    '利20:9 凡咒罵父母的，總要治死他；他咒罵了父母，他的罪（罪原文作血；本章同）要歸到他身上。',
    '利20:10 與鄰舍之妻行淫的，姦夫淫婦都必治死。',
    '利20:11 與繼母行淫的，就是羞辱了他父親，總要把他們二人治死，罪要歸到他們身上。',
    '利20:12 與兒婦同房的，總要把他們二人治死；他們行了逆倫的事，罪要歸到他們身上。',
    '利20:13 人若與男人苟合，像與女人一樣，他們二人行了可憎的事，總要把他們治死，罪要歸到他們身上。',
    '利20:14 人若娶妻，並娶其母，便是大惡，要把這三人用火焚燒，使你們中間免去大惡。',
    '利20:15 人若與獸淫合，總要治死他，也要殺那獸。',
    '利20:16 女人若與獸親近，與他淫合，你要殺那女人和那獸，總要把他們治死，罪要歸到他們身上。',
    '利20:17 人若娶他的姊妹，無論是異母同父的，是異父同母的，彼此見了下體，這是可恥的事；他們必在本民的眼前被剪除。他露了姊妹的下體，必擔當自己的罪孽。',
    '利20:18 婦人有月經，若與他同房，露了他的下體，就是露了婦人的血源，婦人也露了自己的血源，二人必從民中剪除。',
    '利20:19 不可露姨母或是姑母的下體，這是露了骨肉之親的下體；二人必擔當自己的罪孽。',
    '利20:20 人若與伯叔之妻同房，就羞辱了他的伯叔；二人要擔當自己的罪，必無子女而死。',
    '利20:21 人若娶弟兄之妻，這本是污穢的事，羞辱了他的弟兄；二人必無子女。',
    '利20:22 所以，你們要謹守遵行我一切的律例典章，免得我領你們去住的那地把你們吐出。',
    '利20:23 我在你們面前所逐出的國民，你們不可隨從他們的風俗；因為他們行了這一切的事，所以我厭惡他們。',
    '利20:24 但我對你們說過，你們要承受他們的地，就是我要賜給你們為業、流奶與蜜之地。我是耶和華─你們的神，使你們與萬民有分別的。',
    '利20:25 所以，你們要把潔淨和不潔淨的禽獸分別出來；不可因我給你們分為不潔淨的禽獸，或是滋生在地上的活物，使自己成為可憎惡的。',
    '利20:26 你們要歸我為聖，因為我─耶和華是聖的，並叫你們與萬民有分別，使你們作我的民。',
    '利20:27 無論男女，是交鬼的或行巫術的，總要治死他們。人必用石頭把他們打死，罪要歸到他們身上。',
    '利21:1 耶和華對摩西說：你告訴亞倫子孫作祭司的說：祭司不可為民中的死人沾染自己，',
    '利21:2 除非為他骨肉之親的父母、兒女、弟兄，',
    '利21:3 和未曾出嫁、作處女的姊妹，才可以沾染自己。',
    '利21:4 祭司既在民中為首，就不可從俗沾染自己。',
    '利21:5 不可使頭光禿；不可剃除鬍鬚的周圍，也不可用刀劃身。',
    '利21:6 要歸神為聖，不可褻瀆神的名；因為耶和華的火祭，就是神的食物，是他們獻的，所以他們要成為聖。',
    '利21:7 不可娶妓女或被污的女人為妻，也不可娶被休的婦人為妻，因為祭司是歸神為聖。',
    '利21:8 所以你要使他成聖，因為他奉獻你神的食物；你要以他為聖，因為我─使你們成聖的耶和華─是聖的。',
    '利21:9 祭司的女兒若行淫辱沒自己，就辱沒了父親，必用火將他焚燒。',
    '利21:10 在弟兄中作大祭司、頭上倒了膏油、又承接聖職，穿了聖衣的，不可蓬頭散髮，也不可撕裂衣服。',
    '利21:11 不可挨近死屍，也不可為父母沾染自己。',
    '利21:12 不可出聖所，也不可褻瀆神的聖所，因為神膏油的冠冕在他頭上。我是耶和華。',
    '利21:13 他要娶處女為妻。',
    '利21:14 寡婦或是被休的婦人，或是被污為妓的女人，都不可娶；只可娶本民中的處女為妻。',
    '利21:15 不可在民中辱沒他的兒女，因為我是叫他成聖的耶和華。',
    '利21:16 耶和華對摩西說：',
    '利21:17 你告訴亞倫說：你世世代代的後裔，凡有殘疾的，都不可近前來獻他神的食物。',
    '利21:18 因為凡有殘疾的，無論是瞎眼的、瘸腿的、塌鼻子的、肢體有餘的、',
    '利21:19 折腳折手的、',
    '利21:20 駝背的、矮矬的、眼睛有毛病的、長癬的、長疥的，或是損壞腎子的，都不可近前來。',
    '利21:21 祭司亞倫的後裔，凡有殘疾的，都不可近前來，將火祭獻給耶和華。他有殘疾，不可近前來獻神的食物。',
    '利21:22 神的食物，無論是聖的，至聖的，他都可以吃。',
    '利21:23 但不可進到幔子前，也不可就近壇前；因為他有殘疾，免得褻瀆我的聖所。我是叫他成聖的耶和華。',
    '利21:24 於是，摩西曉諭亞倫和亞倫的子孫，並以色列眾人。',
    '利22:1 耶和華對摩西說：',
    '利22:2 你吩咐亞倫和他子孫說：要遠離以色列人所分別為聖、歸給我的聖物，免得褻瀆我的聖名。我是耶和華。',
    '利22:3 你要對他們說：你們世世代代的後裔，凡身上有污穢、親近以色列人所分別為聖、歸耶和華聖物的，那人必在我面前剪除。我是耶和華。',
    '利22:4 亞倫的後裔，凡長大痲瘋的，或是有漏症的，不可吃聖物，直等他潔淨了。無論誰摸那因死屍不潔淨的物（物或作：人），或是遺精的人，',
    '利22:5 或是摸什麼使他不潔淨的爬物，或是摸那使他不潔淨的人（不拘那人有什麼不潔淨），',
    '利22:6 摸了這些人、物的，必不潔淨到晚上；若不用水洗身，就不可吃聖物。',
    '利22:7 日落的時候，他就潔淨了，然後可以吃聖物，因為這是他的食物。',
    '利22:8 自死的或是被野獸撕裂的，他不可吃，因此污穢自己。我是耶和華。',
    '利22:9 所以他們要守我所吩咐的，免得輕忽了，因此擔罪而死。我是叫他們成聖的耶和華。',
    '利22:10 凡外人不可吃聖物；寄居在祭司家的，或是雇工人，都不可吃聖物；',
    '利22:11 倘若祭司買人，是他的錢買的，那人就可以吃聖物；生在他家的人也可以吃。',
    '利22:12 祭司的女兒若嫁外人，就不可吃舉祭的聖物。',
    '利22:13 但祭司的女兒若是寡婦，或是被休的，沒有孩子，又歸回父家，與他青年一樣，就可以吃他父親的食物；只是外人不可吃。',
    '利22:14 若有人誤吃了聖物，要照聖物的原數加上五分之一交給祭司。',
    '利22:15 祭司不可褻瀆以色列人所獻給耶和華的聖物，',
    '利22:16 免得他們在吃聖物上自取罪孽，因為我是叫他們成聖的耶和華。',
    '利22:17 耶和華對摩西說：',
    '利22:18 你曉諭亞倫和他子孫，並以色列眾人說：以色列家中的人，或在以色列中寄居的，凡獻供物，無論是所許的願，是甘心獻的，就是獻給耶和華作燔祭的，',
    '利22:19 要將沒有殘疾的公牛，或是綿羊，或是山羊獻上，如此方蒙悅納。',
    '利22:20 凡有殘疾的，你們不可獻上，因為這不蒙悅納。',
    '利22:21 凡從牛群或是羊群中，將平安祭獻給耶和華，為要還特許的願，或是作甘心獻的，所獻的必純全無殘疾的才蒙悅納。',
    '利22:22 瞎眼的、折傷的、殘廢的、有瘤子的、長癬的、長疥的都不可獻給耶和華，也不可在壇上作為火祭獻給耶和華。',
    '利22:23 無論是公牛是綿羊羔，若肢體有餘的，或是缺少的，只可作甘心祭獻上；用以還願，卻不蒙悅納。',
    '利22:24 腎子損傷的，或是壓碎的，或是破裂的，或是騸了的，不可獻給耶和華，在你們的地上也不可這樣行。',
    '利22:25 這類的物，你們從外人的手，一樣也不可接受作你們神的食物獻上；因為這些都有損壞，有殘疾，不蒙悅納。',
    '利22:26 耶和華曉諭摩西說：',
    '利22:27 才生的公牛，或是綿羊或是山羊，七天當跟著母；從第八天以後，可以當供物蒙悅納，作為耶和華的火祭。',
    '利22:28 無論是母牛是母羊，不可同日宰母和子。',
    '利22:29 你們獻感謝祭給耶和華，要獻得可蒙悅納。',
    '利22:30 要當天吃，一點不可留到早晨。我是耶和華。',
    '利22:31 你們要謹守遵行我的誡命。我是耶和華。',
    '利22:32 你們不可褻瀆我的聖名；我在以色列人中，卻要被尊為聖。我是叫你們成聖的耶和華，',
    '利22:33 把你們從埃及地領出來，作你們的神。我是耶和華。',
    '利23:1 耶和華對摩西說：',
    '利23:2 你曉諭以色列人說：耶和華的節期，你們要宣告為聖會的節期。',
    '利23:3 六日要做工，第七日是聖安息日，當有聖會；你們什麼工都不可做。這是在你們一切的住處向耶和華守的安息日。',
    '利23:4 耶和華的節期，就是你們到了日期要宣告為聖會的，乃是這些。',
    '利23:5 正月十四日，黃昏的時候，是耶和華的逾越節。',
    '利23:6 這月十五日是向耶和華守的無酵節；你們要吃無酵餅七日。',
    '利23:7 第一日當有聖會，什麼勞碌的工都不可做；',
    '利23:8 要將火祭獻給耶和華七日。第七日是聖會，什麼勞碌的工都不可做。',
    '利23:9 耶和華對摩西說：',
    '利23:10 你曉諭以色列人說：你們到了我賜給你們的地，收割莊稼的時候，要將初熟的莊稼一捆帶給祭司。',
    '利23:11 他要把這一捆在耶和華面前搖一搖，使你們得蒙悅納。祭司要在安息日的次日把這捆搖一搖。',
    '利23:12 搖這捆的日子，你們要把一歲、沒有殘疾的公綿羊羔獻給耶和華為燔祭。',
    '利23:13 同獻的素祭，就是調油的細麵伊法十分之二，作為馨香的火祭，獻給耶和華。同獻的奠祭，要酒一欣四分之一。',
    '利23:14 無論是餅，是烘的子粒，是新穗子，你們都不可吃，直等到把你們獻給神的供物帶來的那一天才可以吃。這在你們一切的住處作為世世代代永遠的定例。',
    '利23:15 你們要從安息日的次日，獻禾捆為搖祭的那日算起，要滿了七個安息日。',
    '利23:16 到第七個安息日的次日，共計五十天，又要將新素祭獻給耶和華。',
    '利23:17 要從你們的住處取出細麵伊法十分之二，加酵，烤成兩個搖祭的餅，當作初熟之物獻給耶和華。',
    '利23:18 又要將一歲、沒有殘疾的羊羔七隻、公牛犢一隻、公綿羊兩隻，和餅一同奉上。這些與同獻的素祭和奠祭要作為燔祭獻給耶和華，就是作馨香的火祭獻給耶和華。',
    '利23:19 你們要獻一隻公山羊為贖罪祭，兩隻一歲的公綿羊羔為平安祭。',
    '利23:20 祭司要把這些和初熟麥子做的餅一同作搖祭，在耶和華面前搖一搖；這是獻與耶和華為聖物歸給祭司的。',
    '利23:21 當這日，你們要宣告聖會；什麼勞碌的工都不可做。這在你們一切的住處作為世世代代永遠的定例。',
    '利23:22 在你們的地收割莊稼，不可割盡田角，也不可拾取所遺落的；要留給窮人和寄居的。我是耶和華─你們的神。',
    '利23:23 耶和華對摩西說：',
    '利23:24 你曉諭以色列人說：七月初一，你們要守為聖安息日，要吹角作記念，當有聖會。',
    '利23:25 什麼勞碌的工都不可做；要將火祭獻給耶和華。',
    '利23:26 耶和華曉諭摩西說：',
    '利23:27 七月初十是贖罪日；你們要守為聖會，並要刻苦己心，也要將火祭獻給耶和華。',
    '利23:28 當這日，什麼工都不可做；因為是贖罪日，要在耶和華─你們的神面前贖罪。',
    '利23:29 當這日，凡不刻苦己心的，必從民中剪除。',
    '利23:30 凡這日做什麼工的，我必將他從民中除滅。',
    '利23:31 你們什麼工都不可做。這在你們一切的住處作為世世代代永遠的定例。',
    '利23:32 你們要守這日為聖安息日，並要刻苦己心。從這月初九日晚上到次日晚上，要守為安息日。',
    '利23:33 耶和華對摩西說：',
    '利23:34 你曉諭以色列人說：這七月十五日是住棚節，要在耶和華面前守這節七日。',
    '利23:35 第一日當有聖會，什麼勞碌的工都不可做。',
    '利23:36 七日內要將火祭獻給耶和華。第八日當守聖會，要將火祭獻給耶和華。這是嚴肅會，什麼勞碌的工都不可做。',
    '利23:37 這是耶和華的節期，就是你們要宣告為聖會的節期；要將火祭、燔祭、素祭、祭物，並奠祭，各歸各日，獻給耶和華。',
    '利23:38 這是在耶和華的安息日以外，又在你們的供物和所許的願，並甘心獻給耶和華的以外。',
    '利23:39 你們收藏了地的出產，就從七月十五日起，要守耶和華的節七日。第一日為聖安息；第八日也為聖安息。',
    '利23:40 第一日要拿美好樹上的果子和棕樹上的枝子，與茂密樹的枝條並河旁的柳枝，在耶和華─你們的神面前歡樂七日。',
    '利23:41 每年七月間，要向耶和華守這節七日。這為你們世世代代永遠的定例。',
    '利23:42 你們要住在棚裡七日；凡以色列家的人都要住在棚裡，',
    '利23:43 好叫你們世世代代知道，我領以色列人出埃及地的時候曾使他們住在棚裡。我是耶和華─你們的神。',
    '利23:44 於是，摩西將耶和華的節期傳給以色列人。',
    '利24:1 耶和華曉諭摩西說：',
    '利24:2 要吩咐以色列人，把那為點燈搗成的清橄欖油拿來給你，使燈常常點著。',
    '利24:3 在會幕中法櫃的幔子外，亞倫從晚上到早晨必在耶和華面前經理這燈。這要作你們世世代代永遠的定例。',
    '利24:4 他要在耶和華面前常收拾精金燈臺上的燈。',
    '利24:5 你要取細麵，烤成十二個餅，每餅用麵伊法十分之二。',
    '利24:6 要把餅擺列兩行（或作：摞；下同），每行六個，在耶和華面前精金的桌子上；',
    '利24:7 又要把淨乳香放在每行餅上，作為記念，就是作為火祭獻給耶和華。',
    '利24:8 每安息日要常擺在耶和華面前；這為以色列人作永遠的約。',
    '利24:9 這餅是要給亞倫和他子孫的；他們要在聖處吃，為永遠的定例，因為在獻給耶和華的火祭中是至聖的。',
    '利24:10 有一個以色列婦人的兒子，他父親是埃及人，一日閒遊在以色列人中。這以色列婦人的兒子和一個以色列人在營裡爭鬥。',
    '利24:11 這以色列婦人的兒子褻瀆了聖名，並且咒詛，就有人把他送到摩西那裡。（他母親名叫示羅密，是但支派底伯利的女兒。）',
    '利24:12 他們把那人收在監裡，要得耶和華所指示的話。',
    '利24:13 耶和華曉諭摩西說：',
    '利24:14 把那咒詛聖名的人帶到營外。叫聽見的人都放手在他頭上；全會眾就要用石頭打死他。',
    '利24:15 你要曉諭以色列人說：凡咒詛神的，必擔當他的罪。',
    '利24:16 那褻瀆耶和華名的，必被治死；全會眾總要用石頭打死他。不管是寄居的是本地人，他褻瀆耶和華名的時候，必被治死。',
    '利24:17 打死人的，必被治死；',
    '利24:18 打死牲畜的，必賠上牲畜，以命償命。',
    '利24:19 人若使他鄰舍的身體有殘疾，他怎樣行，也要照樣向他行：',
    '利24:20 以傷還傷，以眼還眼，以牙還牙。他怎樣叫人的身體有殘疾，也要照樣向他行。',
    '利24:21 打死牲畜的，必賠上牲畜；打死人的，必被治死。',
    '利24:22 不管是寄居的是本地人，同歸一例。我是耶和華─你們的神。',
    '利24:23 於是，摩西曉諭以色列人，他們就把那咒詛聖名的人帶到營外，用石頭打死。以色列人就照耶和華所吩咐摩西的行了。',
    '利25:1 耶和華在西乃山對摩西說：',
    '利25:2 你曉諭以色列人說：你們到了我所賜你們那地的時候，地就要向耶和華守安息。',
    '利25:3 六年要耕種田地，也要修理葡萄園，收藏地的出產。',
    '利25:4 第七年，地要守聖安息，就是向耶和華守的安息，不可耕種田地，也不可修理葡萄園。',
    '利25:5 遺落自長的莊稼不可收割；沒有修理的葡萄樹也不可摘取葡萄。這年，地要守聖安息。',
    '利25:6 地在安息年所出的，要給你和你的僕人、婢女、雇工人，並寄居的外人當食物。',
    '利25:7 這年的土產也要給你的牲畜和你地上的走獸當食物。',
    '利25:8 你要計算七個安息年，就是七七年。這便為你成了七個安息年，共是四十九年。',
    '利25:9 當年七月初十日，你要大發角聲；這日就是贖罪日，要在遍地發出角聲。',
    '利25:10 第五十年，你們要當作聖年，在遍地給一切的居民宣告自由。這年必為你們的禧年，各人要歸自己的產業，各歸本家。',
    '利25:11 第五十年要作為你們的禧年。這年不可耕種；地中自長的，不可收割；沒有修理的葡萄樹也不可摘取葡萄。',
    '利25:12 因為這是禧年，你們要當作聖年，吃地中自出的土產。',
    '利25:13 這禧年，你們各人要歸自己的地業。',
    '利25:14 你若賣什麼給鄰舍，或是從鄰舍的手中買什麼，彼此不可虧負。',
    '利25:15 你要按禧年以後的年數向鄰舍買；他也要按年數的收成賣給你。',
    '利25:16 年歲若多，要照數加添價值；年歲若少，要照數減去價值，因為他照收成的數目賣給你。',
    '利25:17 你們彼此不可虧負，只要敬畏你們的神，因為我是耶和華─你們的神。',
    '利25:18 我的律例，你們要遵行，我的典章，你們要謹守，就可以在那地上安然居住。',
    '利25:19 地必出土產，你們就要吃飽，在那地上安然居住。',
    '利25:20 你們若說：這第七年我們不耕種，也不收藏土產，吃什麼呢﹖',
    '利25:21 我必在第六年將我所命的福賜給你們，地便生三年的土產。',
    '利25:22 第八年，你們要耕種，也要吃陳糧，等到第九年出產收來的時候，你們還吃陳糧。',
    '利25:23 地不可永賣，因為地是我的；你們在我面前是客旅，是寄居的。',
    '利25:24 在你們所得為業的全地，也要准人將地贖回。',
    '利25:25 你的弟兄（弟兄是指本國人說；下同）若漸漸窮乏，賣了幾分地業，他至近的親屬就要來把弟兄所賣的贖回。',
    '利25:26 若沒有能給他贖回的，他自己漸漸富足，能夠贖回，',
    '利25:27 就要算出賣地的年數，把餘剩年數的價值還那買主，自己便歸回自己的地業。',
    '利25:28 倘若不能為自己得回所賣的，仍要存在買主的手裡直到禧年；到了禧年，地業要出買主的手，自己便歸回自己的地業。',
    '利25:29 人若賣城內的住宅，賣了以後，一年之內可以贖回；在一整年，必有贖回的權柄。',
    '利25:30 若在一整年之內不贖回，這城內的房屋就定準永歸買主，世世代代為業；在禧年也不得出買主的手。',
    '利25:31 但房屋在無城牆的村莊裡，要看如鄉下的田地一樣，可以贖回；到了禧年，都要出買主的手。',
    '利25:32 然而利未人所得為業的城邑，其中的房屋，利未人可以隨時贖回。',
    '利25:33 若是一個利未人不將所賣的房屋贖回，是在所得為業的城內，到了禧年就要出買主的手，因為利未人城邑的房屋是他們在以色列人中的產業。',
    '利25:34 只是他們各城郊野之地不可賣，因為是他們永遠的產業。',
    '利25:35 你的弟兄在你那裡若漸漸貧窮，手中缺乏，你就要幫補他，使他與你同住，像外人和寄居的一樣。',
    '利25:36 不可向他取利，也不可向他多要；只要敬畏你的神，使你的弟兄與你同住。',
    '利25:37 你借錢給他，不可向他取利；借糧給他，也不可向他多要。',
    '利25:38 我是耶和華─你們的神，曾領你們從埃及地出來，為要把迦南地賜給你們，要作你們的神。',
    '利25:39 你的弟兄若在你那裡漸漸窮乏，將自己賣給你，不可叫他像奴僕服事你。',
    '利25:40 他要在你那裡像雇工人和寄居的一樣，要服事你直到禧年。',
    '利25:41 到了禧年，他和他兒女要離開你，一同出去歸回本家，到他祖宗的地業那裡去。',
    '利25:42 因為他們是我的僕人，是我從埃及地領出來的，不可賣為奴僕。',
    '利25:43 不可嚴嚴地轄管他，只要敬畏你的神。',
    '利25:44 至於你的奴僕、婢女，可以從你四圍的國中買。',
    '利25:45 並且那寄居在你們中間的外人和他們的家屬，在你們地上所生的，你們也可以從其中買人；他們要作你們的產業。',
    '利25:46 你們要將他們遺留給你們的子孫為產業，要永遠從他們中間揀出奴僕；只是你們的弟兄以色列人，你們不可嚴嚴地轄管。',
    '利25:47 住在你那裡的外人，或是寄居的，若漸漸富足，你的弟兄卻漸漸窮乏，將自己賣給那外人，或是寄居的，或是外人的宗族，',
    '利25:48 賣了以後，可以將他贖回。無論是他的弟兄，',
    '利25:49 或伯叔、伯叔的兒子，本家的近支，都可以贖他。他自己若漸漸富足，也可以自贖。',
    '利25:50 他要和買主計算，從賣自己的那年起，算到禧年；所賣的價值照著年數多少，好像工人每年的工價。',
    '利25:51 若缺少的年數多，就要按著年數從買價中償還他的贖價。',
    '利25:52 若到禧年只缺少幾年，就要按著年數和買主計算，償還他的贖價。',
    '利25:53 他和買主同住，要像每年雇的工人，買主不可嚴嚴地轄管他。',
    '利25:54 他若不這樣被贖，到了禧年，要和他的兒女一同出去。',
    '利25:55 因為以色列人都是我的僕人，是我從埃及地領出來的。我是耶和華─你們的神。',
    '利26:1 你們不可做什麼虛無的神像，不可立雕刻的偶像或是柱像，也不可在你們的地上安什麼鏨成的石像，向他跪拜，因為我是耶和華─你們的神。',
    '利26:2 你們要守我的安息日，敬我的聖所。我是耶和華。',
    '利26:3 你們若遵行我的律例，謹守我的誡命，',
    '利26:4 我就給你們降下時雨，叫地生出土產，田野的樹木結果子。',
    '利26:5 你們打糧食要打到摘葡萄的時候，摘葡萄要摘到撒種的時候；並且要吃得飽足，在你們的地上安然居住。',
    '利26:6 我要賜平安在你們的地上；你們躺臥，無人驚嚇。我要叫惡獸從你們的地上息滅；刀劍也必不經過你們的地。',
    '利26:7 你們要追趕仇敵，他們必倒在你們刀下。',
    '利26:8 你們五個人要追趕一百人，一百人要追趕一萬人；仇敵必倒在你們刀下。',
    '利26:9 我要眷顧你們，使你們生養眾多，也要與你們堅定所立的約。',
    '利26:10 你們要吃陳糧，又因新糧挪開陳糧。',
    '利26:11 我要在你們中間立我的帳幕；我的心也不厭惡你們。',
    '利26:12 我要在你們中間行走；我要作你們的神，你們要作我的子民。',
    '利26:13 我是耶和華─你們的神，曾將你們從埃及地領出來，使你們不作埃及人的奴僕；我也折斷你們所負的軛，叫你們挺身而走。',
    '利26:14 你們若不聽從我，不遵行我的誡命，',
    '利26:15 厭棄我的律例，厭惡我的典章，不遵行我一切的誡命，背棄我的約，',
    '利26:16 我待你們就要這樣：我必命定驚惶，叫眼目乾癟、精神消耗的癆病熱病轄制你們。你們也要白白地撒種，因為仇敵要吃你們所種的。',
    '利26:17 我要向你們變臉，你們就要敗在仇敵面前。恨惡你們的，必轄管你們；無人追趕，你們卻要逃跑。',
    '利26:18 你們因這些事若還不聽從我，我就要為你們的罪加七倍懲罰你們。',
    '利26:19 我必斷絕你們因勢力而有的驕傲，又要使覆你們的天如鐵，載你們的地如銅。',
    '利26:20 你們要白白地勞力；因為你們的地不出土產，其上的樹木也不結果子。',
    '利26:21 你們行事若與我反對，不肯聽從我，我就要按你們的罪加七倍降災與你們。',
    '利26:22 我也要打發野地的走獸到你們中間，搶吃你們的兒女，吞滅你們的牲畜，使你們的人數減少，道路荒涼。',
    '利26:23 你們因這些事若仍不改正歸我，行事與我反對，',
    '利26:24 我就要行事與你們反對，因你們的罪擊打你們七次。',
    '利26:25 我又要使刀劍臨到你們，報復你們背約的仇；聚集你們在各城內，降瘟疫在你們中間，也必將你們交在仇敵的手中。',
    '利26:26 我要折斷你們的杖，就是斷絕你們的糧。那時，必有十個女人在一個爐子給你們烤餅，按分量秤給你們；你們要吃，也吃不飽。',
    '利26:27 你們因這一切的事若不聽從我，卻行事與我反對，',
    '利26:28 我就要發烈怒，行事與你們反對，又因你們的罪懲罰你們七次。',
    '利26:29 並且你們要吃兒子的肉，也要吃女兒的肉。',
    '利26:30 我又要毀壞你們的邱壇，砍下你們的日像，把你們的屍首扔在你們偶像的身上；我的心也必厭惡你們。',
    '利26:31 我要使你們的城邑變為荒涼，使你們的眾聖所成為荒場；我也不聞你們馨香的香氣。',
    '利26:32 我要使地成為荒場，住在其上的仇敵就因此詫異。',
    '利26:33 我要把你們散在列邦中；我也要拔刀追趕你們。你們的地要成為荒場；你們的城邑要變為荒涼。',
    '利26:34 你們在仇敵之地居住的時候，你們的地荒涼，要享受眾安息；正在那時候，地要歇息，享受安息。',
    '利26:35 地多時為荒場，就要多時歇息；地這樣歇息，是你們住在其上的安息年所不能得的。',
    '利26:36 至於你們剩下的人，我要使他們在仇敵之地心驚膽怯。葉子被風吹的響聲，要追趕他們；他們要逃避，像人逃避刀劍，無人追趕，卻要跌倒。',
    '利26:37 無人追趕，他們要彼此撞跌，像在刀劍之前。你們在仇敵面前也必站立不住。',
    '利26:38 你們要在列邦中滅亡；仇敵之地要吞吃你們。',
    '利26:39 你們剩下的人必因自己的罪孽和祖宗的罪孽在仇敵之地消滅。',
    '利26:40 他們要承認自己的罪和他們祖宗的罪，就是干犯我的那罪，並且承認自己行事與我反對，',
    '利26:41 我所以行事與他們反對，把他們帶到仇敵之地。那時，他們未受割禮的心若謙卑了，他們也服了罪孽的刑罰，',
    '利26:42 我就要記念我與雅各所立的約，與以撒所立的約，與亞伯拉罕所立的約，並要記念這地。',
    '利26:43 他們離開這地，地在荒廢無人的時候就要享受安息。並且他們要服罪孽的刑罰；因為他們厭棄了我的典章，心中厭惡了我的律例。',
    '利26:44 雖是這樣，他們在仇敵之地，我卻不厭棄他們，也不厭惡他們，將他們盡行滅絕，也不背棄我與他們所立的約，因為我是耶和華─他們的神。',
    '利26:45 我卻要為他們的緣故記念我與他們先祖所立的約。他們的先祖是我在列邦人眼前、從埃及地領出來的，為要作他們的神。我是耶和華。',
    '利26:46 這些律例、典章，和法度是耶和華與以色列人在西乃山藉著摩西立的。',
    '利27:1 耶和華對摩西說：',
    '利27:2 你曉諭以色列人說：人還特許的願，被許的人要按你所估的價值歸給耶和華。',
    '利27:3 你估定的，從二十歲到六十歲的男人，要按聖所的平，估定價銀五十舍客勒。',
    '利27:4 若是女人，你要估定三十舍客勒。',
    '利27:5 若是從五歲到二十歲，男子你要估定二十舍客勒，女子估定十舍客勒。',
    '利27:6 若是從一月到五歲，男子你要估定五舍客勒，女子估定三舍客勒。',
    '利27:7 若是從六十歲以上，男人你要估定十五舍客勒，女人估定十舍客勒。',
    '利27:8 他若貧窮，不能照你所估定的價，就要把他帶到祭司面前，祭司要按許願人的力量估定他的價。',
    '利27:9 所許的若是牲畜，就是人獻給耶和華為供物的，凡這一類獻給耶和華的，都要成為聖。',
    '利27:10 人不可改換，也不可更換，或是好的換壞的，或是壞的換好的。若以牲畜更換牲畜，所許的與所換的都要成為聖。',
    '利27:11 若牲畜不潔淨，是不可獻給耶和華為供物的，就要把牲畜安置在祭司面前。',
    '利27:12 祭司就要估定價值；牲畜是好是壞，祭司怎樣估定，就要以怎樣為是。',
    '利27:13 他若一定要贖回，就要在你所估定的價值以外加上五分之一。',
    '利27:14 人將房屋分別為聖，歸給耶和華，祭司就要估定價值。房屋是好是壞，祭司怎樣估定，就要以怎樣為定。',
    '利27:15 將房屋分別為聖的人，若要贖回房屋，就必在你所估定的價值以外加上五分之一，房屋仍舊歸他。',
    '利27:16 人若將承受為業的幾分地分別為聖，歸給耶和華，你要按這地撒種多少估定價值，若撒大麥一賀梅珥，要估價五十舍客勒。',
    '利27:17 他若從禧年將地分別為聖，就要以你所估定的價為定。',
    '利27:18 倘若他在禧年以後將地分別為聖，祭司就要按著未到禧年所剩的年數推算價值，也要從你所估的減去價值。',
    '利27:19 將地分別為聖的人若定要把地贖回，他便要在你所估的價值以外加上五分之一，地就准定歸他。',
    '利27:20 他若不贖回那地，或是將地賣給別人，就再不能贖了。',
    '利27:21 但到了禧年，那地從買主手下出來的時候，就要歸耶和華為聖，和永獻的地一樣，要歸祭司為業。',
    '利27:22 他若將所買的一塊地，不是承受為業的，分別為聖歸給耶和華，',
    '利27:23 祭司就要將你所估的價值給他推算到禧年。當日，他要以你所估的價銀為聖，歸給耶和華。',
    '利27:24 到了禧年，那地要歸賣主，就是那承受為業的原主。',
    '利27:25 凡你所估定的價銀都要按著聖所的平：二十季拉為一舍客勒。',
    '利27:26 惟獨牲畜中頭生的，無論是牛是羊，既歸耶和華，誰也不可再分別為聖，因為這是耶和華的。',
    '利27:27 若是不潔淨的牲畜生的，就要按你所估定的價值加上五分之一贖回；若不贖回，就要按你所估定的價值賣了。',
    '利27:28 但一切永獻的，就是人從他所有永獻給耶和華的，無論是人，是牲畜，是他承受為業的地，都不可賣，也不可贖。凡永獻的是歸給耶和華為至聖。',
    '利27:29 凡從人中當滅的都不可贖，必被治死。',
    '利27:30 地上所有的，無論是地上的種子是樹上的果子，十分之一是耶和華的，是歸給耶和華為聖的。',
    '利27:31 人若要贖這十分之一的什麼物，就要加上五分之一。',
    '利27:32 凡牛群羊群中，一切從杖下經過的，每第十隻要歸給耶和華為聖。',
    '利27:33 不可問是好是壞，也不可更換；若定要更換，所更換的與本來的牲畜都要成為聖，不可贖回。',
    '利27:34 這就是耶和華在西乃山為以色列人所吩咐摩西的命令。',
    '民1:1 以色列人出埃及地後，第二年二月初一日，耶和華在西乃的曠野、會幕中曉諭摩西說：',
    '民1:2 你要按以色列全會眾的家室、宗族、人名的數目計算所有的男丁。',
    '民1:3 凡以色列中，從二十歲以外，能出去打仗的，你和亞倫要照他們的軍隊數點。',
    '民1:4 每支派中必有一人作本支派的族長，幫助你們。',
    '民1:5 他們的名字：屬流便的，有示丟珥的兒子以利蓿；',
    '民1:6 屬西緬的，有蘇利沙代的兒子示路蔑；',
    '民1:7 屬猶大的，有亞米拿達的兒子拿順；',
    '民1:8 屬以薩迦的，有蘇押的兒子拿坦業；',
    '民1:9 屬西布倫的，有希倫的兒子以利押；',
    '民1:10 約瑟子孫、屬以法蓮的，有亞米忽的兒子以利沙瑪；屬瑪拿西的，有比大蓿的兒子迦瑪列；',
    '民1:11 屬便雅憫的，有基多尼的兒子亞比但；',
    '民1:12 屬但的，有亞米沙代的兒子亞希以謝；',
    '民1:13 屬亞設的，有俄蘭的兒子帕結；',
    '民1:14 屬迦得的，有丟珥的兒子以利雅薩；',
    '民1:15 屬拿弗他利的，有以南的兒子亞希拉。',
    '民1:16 這都是從會中選召的，各作本支派的首領，都是以色列軍中的統領。',
    '民1:17 於是，摩西、亞倫帶著這些按名指定的人，',
    '民1:18 當二月初一日招聚全會眾。會眾就照他們的家室、宗族、人名的數目，從二十歲以外的，都述說自己的家譜。',
    '民1:19 耶和華怎樣吩咐摩西，他就怎樣在西乃的曠野數點他們。',
    '民1:20 以色列的長子，流便子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的男丁，共有四萬六千五百名。',
    '民1:21 併於上節。',
    '民1:22 西緬子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的男丁，共有五萬九千三百名。',
    '民1:23 併於上節。',
    '民1:24 迦得子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有四萬五千六百五十名。',
    '民1:25 併於上節。',
    '民1:26 猶大子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有七萬四千六百名。',
    '民1:27 併於上節。',
    '民1:28 以薩迦子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有五萬四千四百名。',
    '民1:29 併於上節。',
    '民1:30 西布倫子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有五萬七千四百名。',
    '民1:31 併於上節。',
    '民1:32 約瑟子孫屬以法蓮子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有四萬零五百名。',
    '民1:33 併於上節。',
    '民1:34 瑪拿西子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有三萬二千二百名。',
    '民1:35 併於上節。',
    '民1:36 便雅憫子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有三萬五千四百名。',
    '民1:37 併於上節。',
    '民1:38 但子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗，被數的，共有六萬二千七百名。',
    '民1:39 併於上節。',
    '民1:40 亞設子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有四萬一千五百名。',
    '民1:41 併於上節。',
    '民1:42 拿弗他利子孫的後代，照著家室、宗族、人名的數目，從二十歲以外，凡能出去打仗、被數的，共有五萬三千四百名。',
    '民1:43 併於上節。',
    '民1:44 這些就是被數點的，是摩西、亞倫，和以色列中十二個首領所數點的；這十二個人各作各宗族的代表。',
    '民1:45 這樣，凡以色列人中被數的，照著宗族，從二十歲以外，能出去打仗、被數的，共有六十萬零三千五百五十名。',
    '民1:46 併於上節。',
    '民1:47 利未人卻沒有按著支派數在其中，',
    '民1:48 因為耶和華曉諭摩西說：',
    '民1:49 惟獨利未支派你不可數點，也不可在以色列人中計算他們的總數。',
    '民1:50 只要派利未人管法櫃的帳幕和其中的器具，並屬乎帳幕的；他們要擡（擡或作：搬運）帳幕和其中的器具，並要辦理帳幕的事，在帳幕的四圍安營。',
    '民1:51 帳幕將往前行的時候，利未人要拆卸；將支搭的時候，利未人要豎起。近前來的外人必被治死。',
    '民1:52 以色列人支搭帳棚，要照他們的軍隊，各歸本營，各歸本纛。',
    '民1:53 但利未人要在法櫃帳幕的四圍安營，免得忿怒臨到以色列會眾；利未人並要謹守法櫃的帳幕。',
    '民1:54 以色列人就這樣行。凡耶和華所吩咐摩西的，他們就照樣行了。',
    '民2:1 耶和華曉諭摩西、亞倫說：',
    '民2:2 以色列人要各歸自己的纛下，在本族的旗號那裡，對著會幕的四圍安營。',
    '民2:3 在東邊，向日出之地，照著軍隊安營的是猶大營的纛。有亞米拿達的兒子拿順作猶大人的首領。',
    '民2:4 他軍隊被數的，共有七萬四千六百名。',
    '民2:5 挨著他安營的是以薩迦支派。有蘇押的兒子拿坦業作以薩迦人的首領。',
    '民2:6 他軍隊被數的，共有五萬四千四百名。',
    '民2:7 又有西布倫支派。希倫的兒子以利押作西布倫人的首領。',
    '民2:8 他軍隊被數的，共有五萬七千四百名。',
    '民2:9 凡屬猶大營、按著軍隊被數的，共有十八萬六千四百名，要作第一隊往前行。',
    '民2:10 在南邊，按著軍隊是流便營的纛。有示丟珥的兒子以利蓿作流便人的首領。',
    '民2:11 他軍隊被數的，共有四萬六千五百名。',
    '民2:12 挨著他安營的是西緬支派。蘇利沙代的兒子示路蔑作西緬人的首領。',
    '民2:13 他軍隊被數的，共有五萬九千三百名。',
    '民2:14 又有迦得支派。丟珥的兒子以利雅薩作迦得人的首領。',
    '民2:15 他軍隊被數的，共有四萬五千六百五十名，',
    '民2:16 凡屬流便營、按著軍隊被數的，共有十五萬一千四百五十名，要作第二隊往前行。',
    '民2:17 隨後，會幕要往前行，有利未營在諸營中間。他們怎樣安營就怎樣往前行，各按本位，各歸本纛。',
    '民2:18 在西邊，按著軍隊是以法蓮營的纛。亞米忽的兒子以利沙瑪作以法蓮人的首領。',
    '民2:19 他軍隊被數的，共有四萬零五百名。',
    '民2:20 挨著他的是瑪拿西支派。比大蓿的兒子迦瑪列作瑪拿西人的首領。',
    '民2:21 他軍隊被數的，共有三萬二千二百名。',
    '民2:22 又有便雅憫支派。基多尼的兒子亞比但作便雅憫人的首領。',
    '民2:23 他軍隊被數的，共有三萬五千四百名。',
    '民2:24 凡屬以法蓮營、按著軍隊被數的，共有十萬零八千一百名，要作第三隊往前行。',
    '民2:25 在北邊，按著軍隊是但營的纛。亞米沙代的兒子亞希以謝作但人的首領。',
    '民2:26 他軍隊被數的，共有六萬二千七百名。',
    '民2:27 挨著他安營的是亞設支派。俄蘭的兒子帕結作亞設人的首領。',
    '民2:28 他軍隊被數的，共有四萬一千五百名。',
    '民2:29 又有拿弗他利支派。以南的兒子亞希拉作拿弗他利人的首領。',
    '民2:30 他軍隊被數的，共有五萬三千四百名。',
    '民2:31 凡但營被數的，共有十五萬七千六百名，要歸本纛作末隊往前行。',
    '民2:32 這些以色列人，照他們的宗族，按他們的軍隊，在諸營中被數的，共有六十萬零三千五百五十名。',
    '民2:33 惟獨利未人沒有數在以色列人中，是照耶和華所吩咐摩西的。',
    '民2:34 以色列人就這樣行，各人照他們的家室、宗族歸於本纛，安營起行，都是照耶和華所吩咐摩西的。',
    '民3:1 耶和華在西乃山曉諭摩西的日子，亞倫和摩西的後代如下：',
    '民3:2 亞倫的兒子，長子名叫拿答，還有亞比戶、以利亞撒、以他瑪。',
    '民3:3 這是亞倫兒子的名字，都是受膏的祭司，是摩西叫他們承接聖職供祭司職分的。',
    '民3:4 拿答、亞比戶在西乃的曠野向耶和華獻凡火的時候就死在耶和華面前了。他們也沒有兒子。以利亞撒、以他瑪在他們的父親亞倫面前供祭司的職分。',
    '民3:5 耶和華曉諭摩西說：',
    '民3:6 你使利未支派近前來，站在祭司亞倫面前好服事他，',
    '民3:7 替他和會眾在會幕前守所吩咐的，辦理帳幕的事。',
    '民3:8 又要看守會幕的器具，並守所吩咐以色列人的，辦理帳幕的事。',
    '民3:9 你要將利未人給亞倫和他的兒子，因為他們是從以色列人中選出來給他的。',
    '民3:10 你要囑咐亞倫和他的兒子謹守自己祭司的職任。近前來的外人必被治死。',
    '民3:11 耶和華曉諭摩西說：',
    '民3:12 我從以色列人中揀選了利未人，代替以色列人一切頭生的；利未人要歸我。',
    '民3:13 因為凡頭生的是我的；我在埃及地擊殺一切頭生的那日就把以色列中一切頭生的，連人帶牲畜都分別為聖歸我；他們定要屬我。我是耶和華。',
    '民3:14 耶和華在西乃的曠野曉諭摩西說：',
    '民3:15 你要照利未人的宗族、家室數點他們。凡一個月以外的男子都要數點。',
    '民3:16 於是摩西照耶和華所吩咐的數點他們。',
    '民3:17 利未眾子的名字是革順、哥轄、米拉利。',
    '民3:18 革順的兒子，按著家室，是立尼、示每。',
    '民3:19 哥轄的兒子，按著家室，是暗蘭、以斯哈、希伯倫、烏薛。',
    '民3:20 米拉利的兒子，按著家室，是抹利、母示。這些按著宗族是利未人的家室。',
    '民3:21 屬革順的，有立尼族、示每族。這是革順的二族。',
    '民3:22 其中被數、從一個月以外所有的男子共有七千五百名。',
    '民3:23 這革順的二族要在帳幕後西邊安營。',
    '民3:24 拉伊勒的兒子以利雅薩作革順人宗族的首領。',
    '民3:25 革順的子孫在會幕中所要看守的，就是帳幕和罩棚，並罩棚的蓋與會幕的門簾，',
    '民3:26 院子的帷子和門簾（院子是圍帳幕和壇的），並一切使用的繩子。',
    '民3:27 屬哥轄的，有暗蘭族、以斯哈族、希伯倫族、烏薛族。這是哥轄的諸族。',
    '民3:28 按所有男子的數目，從一個月以外看守聖所的，共有八千六百名。',
    '民3:29 哥轄兒子的諸族要在帳幕的南邊安營。',
    '民3:30 烏薛的兒子以利撒反作哥轄宗族家室的首領。',
    '民3:31 他們所要看守的是約櫃、桌子、燈臺、兩座壇與聖所內使用的器皿，並簾子和一切使用之物。',
    '民3:32 祭司亞倫的兒子以利亞撒作利未人眾首領的領袖，要監察那些看守聖所的人。',
    '民3:33 屬米拉利的，有抹利族、母示族。這是米拉利的二族。',
    '民3:34 他們被數的，按所有男子的數目，從一個月以外的，共有六千二百名。',
    '民3:35 亞比亥的兒子蘇列作米拉利二宗族的首領。他們要在帳幕的北邊安營。',
    '民3:36 米拉利子孫的職分是看守帳幕的板、閂、柱子、帶卯的座，和帳幕一切所使用的器具，',
    '民3:37 院子四圍的柱子、帶卯的座、橛子，和繩子。',
    '民3:38 在帳幕前東邊，向日出之地安營的是摩西、亞倫，和亞倫的兒子。他們看守聖所，替以色列人守耶和華所吩咐的。近前來的外人必被治死。',
    '民3:39 凡被數的利未人，就是摩西、亞倫照耶和華吩咐所數的，按著家室，從一個月以外的男子，共有二萬二千名。',
    '民3:40 耶和華對摩西說：你要從以色列人中數點一個月以外、凡頭生的男子，把他們的名字記下。',
    '民3:41 我是耶和華。你要揀選利未人歸我，代替以色列人所有頭生的，也取利未人的牲畜代替以色列所有頭生的牲畜。',
    '民3:42 摩西就照耶和華所吩咐的把以色列人頭生的都數點了。',
    '民3:43 按人名的數目，從一個月以外、凡頭生的男子，共有二萬二千二百七十三名。',
    '民3:44 耶和華曉諭摩西說：',
    '民3:45 你揀選利未人代替以色列人所有頭生的，也取利未人的牲畜代替以色列人的牲畜。利未人要歸我；我是耶和華。',
    '民3:46 以色列人中頭生的男子比利未人多二百七十三個，必當將他們贖出來。',
    '民3:47 你要按人丁，照聖所的平，每人取贖銀五舍客勒（一舍客勒是二十季拉），',
    '民3:48 把那多餘之人的贖銀交給亞倫和他的兒子。',
    '民3:49 於是摩西從那被利未人所贖以外的人取了贖銀。',
    '民3:50 從以色列人頭生的所取之銀，按聖所的平，有一千三百六十五舍客勒。',
    '民3:51 摩西照耶和華的話把這贖銀給亞倫和他的兒子，正如耶和華所吩咐的。',
    '民4:1 耶和華曉諭摩西、亞倫說：',
    '民4:2 你從利未人中，將哥轄子孫的總數，照他們的家室、宗族，',
    '民4:3 從三十歲直到五十歲，凡前來任職、在會幕裡辦事的，全都計算。',
    '民4:4 哥轄子孫在會幕搬運至聖之物，所辦的事乃是這樣：',
    '民4:5 起營的時候，亞倫和他兒子要進去摘下遮掩櫃的幔子，用以蒙蓋法櫃，',
    '民4:6 又用海狗皮蓋在上頭，再蒙上純藍色的毯子，把槓穿上。',
    '民4:7 又用藍色毯子鋪在陳設餅的桌子上，將盤子、調羹、奠酒的爵，和杯擺在上頭。桌子上也必有常設的餅。',
    '民4:8 在其上又要蒙朱紅色的毯子，再蒙上海狗皮，把槓穿上。',
    '民4:9 要拿藍色毯子，把燈臺和燈臺上所用的燈盞、剪子、蠟花盤，並一切盛油的器皿，全都遮蓋。',
    '民4:10 又要把燈臺和燈臺的一切器具包在海狗皮裡，放在擡架上。',
    '民4:11 在金壇上要鋪藍色毯子，蒙上海狗皮，把槓穿上。',
    '民4:12 又要把聖所用的一切器具包在藍色毯子裡，用海狗皮蒙上，放在擡架上。',
    '民4:13 要收去壇上的灰，把紫色毯子鋪在壇上；',
    '民4:14 又要把所用的一切器具，就是火鼎、肉鍤子、鏟子、盤子，一切屬壇的器具都擺在壇上，又蒙上海狗皮，把槓穿上。',
    '民4:15 將要起營的時候，亞倫和他兒子把聖所和聖所的一切器具遮蓋完了，哥轄的子孫就要來擡，只是不可摸聖物，免得他們死亡。會幕裡這些物件是哥轄子孫所當擡的。',
    '民4:16 祭司亞倫的兒子以利亞撒所要看守的是點燈的油與香料，並當獻的素祭和膏油，也要看守全帳幕與其中所有的，並聖所和聖所的器具。',
    '民4:17 耶和華曉諭摩西、亞倫說：',
    '民4:18 你們不可將哥轄人的支派從利未人中剪除。',
    '民4:19 他們挨近至聖物的時候，亞倫和他兒子要進去派他們各人所當辦的，所當擡的。這樣待他們，好使他們活著，不致死亡。',
    '民4:20 只是他們連片時不可進去觀看聖所，免得他們死亡。',
    '民4:21 耶和華曉諭摩西說：',
    '民4:22 你要將革順子孫的總數，照著宗族、家室，',
    '民4:23 從三十歲直到五十歲，凡前來任職、在會幕裡辦事的，全都數點。',
    '民4:24 革順人各族所辦的事、所擡的物乃是這樣：',
    '民4:25 他們要擡帳幕的幔子和會幕，並會幕的蓋與其上的海狗皮，和會幕的門簾，',
    '民4:26 院子的帷子和門簾（院子是圍帳幕和壇的）、繩子，並所用的器具，不論是做什麼用的，他們都要經理。',
    '民4:27 革順的子孫在一切擡物辦事之上都要憑亞倫和他兒子的吩咐；他們所當擡的，要派他們看守。',
    '民4:28 這是革順子孫的各族在會幕裡所辦的事；他們所看守的，必在祭司亞倫兒子以他瑪的手下。',
    '民4:29 至於米拉利的子孫，你要照著家室、宗族把他們數點。',
    '民4:30 從三十歲直到五十歲，凡前來任職、在會幕裡辦事的，你都要數點。',
    '民4:31 他們辦理會幕的事，就是擡帳幕的板、閂、柱子，和帶卯的座，',
    '民4:32 院子四圍的柱子和其上帶卯的座、橛子、繩子，並一切使用的器具。他們所擡的器具，你們要按名指定。',
    '民4:33 這是米拉利子孫各族在會幕裡所辦的事，都在祭司亞倫兒子以他瑪的手下。',
    '民4:34 摩西、亞倫與會眾的諸首領將哥轄的子孫，照著家室、宗族，',
    '民4:35 從三十歲直到五十歲，凡前來任職、在會幕裡辦事的，都數點了。',
    '民4:36 被數的共有二千七百五十名。',
    '民4:37 這是哥轄各族中被數的，是在會幕裡辦事的，就是摩西、亞倫照耶和華藉摩西所吩咐數點的。',
    '民4:38 革順子孫被數的，照著家室、宗族，',
    '民4:39 從三十歲直到五十歲，凡前來任職、在會幕裡辦事的，共有二千六百三十名。',
    '民4:40 併於上節。',
    '民4:41 這是革順子孫各族中被數的，是在會幕裡辦事的，就是摩西、亞倫照耶和華藉摩西所吩咐數點的。',
    '民4:42 米拉利子孫中各族被數的，照著家室、宗族，',
    '民4:43 從三十歲直到五十歲，凡前來任職、在會幕裡辦事的，共有三千二百名。',
    '民4:44 併於上節。',
    '民4:45 這是米拉利子孫各族中被數的，就是摩西、亞倫照耶和華藉摩西所吩咐數點的。',
    '民4:46 凡被數的利未人，就是摩西、亞倫並以色列眾首領，照著家室、宗族所數點的，',
    '民4:47 從三十歲直到五十歲，凡前來任職、在會幕裡做擡物之工的，共有八千五百八十名。',
    '民4:48 併於上節。',
    '民4:49 摩西按他們所辦的事、所擡的物，憑耶和華的吩咐數點他們；他們這樣被摩西數點，正如耶和華所吩咐他的。',
    '民5:1 耶和華曉諭摩西說：',
    '民5:2 你吩咐以色列人，使一切長大痲瘋的，患漏症的，並因死屍不潔淨的，都出營外去。',
    '民5:3 無論男女都要使他們出到營外，免得污穢他們的營；這營是我所住的。',
    '民5:4 以色列人就這樣行，使他們出到營外。耶和華怎樣吩咐摩西，以色列人就怎樣行了。',
    '民5:5 耶和華對摩西說：',
    '民5:6 你曉諭以色列人說：無論男女，若犯了人所常犯的罪，以致干犯耶和華，那人就有了罪。',
    '民5:7 他要承認所犯的罪，將所虧負人的，如數賠還，另外加上五分之一，也歸與所虧負的人。',
    '民5:8 那人若沒有親屬可受所賠還的，那所賠還的就要歸與服事耶和華的祭司；至於那為他贖罪的公羊是在外。',
    '民5:9 以色列人一切的聖物中，所奉給祭司的舉祭都要歸與祭司。',
    '民5:10 各人所分別為聖的物，無論是什麼，都要歸給祭司。',
    '民5:11 耶和華對摩西說：',
    '民5:12 你曉諭以色列人說：人的妻若有邪行，得罪他丈夫，',
    '民5:13 有人與他行淫，事情嚴密，瞞過他丈夫，而且他被玷污，沒有作見證的人，當他行淫的時候也沒有被捉住，',
    '民5:14 他丈夫生了疑恨的心，疑恨他，他是被玷污，或是他丈夫生了疑恨的心，疑恨他，他並沒有被玷污，',
    '民5:15 這人就要將妻送到祭司那裡，又為他帶著大麥麵伊法十分之一作供物，不可澆上油，也不可加上乳香；因為這是疑恨的素祭，是思念的素祭，使人思念罪孽。',
    '民5:16 祭司要使那婦人近前來，站在耶和華面前。',
    '民5:17 祭司要把聖水盛在瓦器裡，又從帳幕的地上取點塵土，放在水中。',
    '民5:18 祭司要叫那婦人蓬頭散髮，站在耶和華面前，把思念的素祭，就是疑恨的素祭，放在他手中。祭司手裡拿著致咒詛的苦水，',
    '民5:19 要叫婦人起誓，對他說：若沒有人與你行淫，也未曾背著丈夫做污穢的事，你就免受這致咒詛苦水的災。',
    '民5:20 你若背著丈夫行了污穢的事，在你丈夫以外有人與你行淫，',
    '民5:21 （祭司叫婦人發咒起誓），願耶和華叫你大腿消瘦，肚腹發脹，使你在你民中被人咒詛，成了誓語；',
    '民5:22 並且這致咒詛的水入你的腸中，要叫你的肚腹發脹，大腿消瘦。婦人要回答說：阿們，阿們。',
    '民5:23 祭司要寫這咒詛的話，將所寫的字抹在苦水裡，',
    '民5:24 又叫婦人喝這致咒詛的苦水；這水要進入他裡面變苦了。',
    '民5:25 祭司要從婦人的手中取那疑恨的素祭，在耶和華面前搖一搖，拿到壇前；',
    '民5:26 又要從素祭中取出一把，作為這事的記念，燒在壇上，然後叫婦人喝這水。',
    '民5:27 叫他喝了以後，他若被玷污，得罪了丈夫，這致咒詛的水必進入他裡面變苦了，他的肚腹就要發脹，大腿就要消瘦，那婦人便要在他民中被人咒詛。',
    '民5:28 若婦人沒有被玷污，卻是清潔的，就要免受這災，且要懷孕。',
    '民5:29 妻子背著丈夫行了污穢的事，',
    '民5:30 或是人生了疑恨的心，疑恨他的妻，就有這疑恨的條例。那時他要叫婦人站在耶和華面前，祭司要在他身上照這條例而行。',
    '民5:31 男人就為無罪，婦人必擔當自己的罪孽。',
    '民6:1 耶和華對摩西說：',
    '民6:2 你曉諭以色列人說：無論男女許了特別的願，就是拿細耳人的願（拿細耳就是歸主的意思；下同），要離俗歸耶和華。',
    '民6:3 他就要遠離清酒濃酒，也不可喝什麼清酒濃酒做的醋；不可喝什麼葡萄汁，也不可吃鮮葡萄和乾葡萄。',
    '民6:4 在一切離俗的日子，凡葡萄樹上結的，自核至皮所做的物，都不可吃。',
    '民6:5 在他一切許願離俗的日子，不可用剃頭刀剃頭，要由髮綹長長了。他要聖潔，直到離俗歸耶和華的日子滿了。',
    '民6:6 在他離俗歸耶和華的一切日子，不可挨近死屍。',
    '民6:7 他的父母或是弟兄姊妹死了的時候，他不可因他們使自己不潔淨，因為那離俗歸神的憑據是在他頭上。',
    '民6:8 在他一切離俗的日子是歸耶和華為聖。',
    '民6:9 若在他旁邊忽然有人死了，以致沾染了他離俗的頭，他要在第七日，得潔淨的時候，剃頭。',
    '民6:10 第八日，他要把兩隻斑鳩或兩隻雛鴿帶到會幕門口，交給祭司。',
    '民6:11 祭司要獻一隻作贖罪祭，一隻作燔祭，為他贖那因死屍而有的罪，並要當日使他的頭成為聖潔。',
    '民6:12 他要另選離俗歸耶和華的日子，又要牽一隻一歲的公羊羔來作贖愆祭；但先前的日子要歸徒然，因為他在離俗之間被玷污了。',
    '民6:13 拿細耳人滿了離俗的日子乃有這條例：人要領他到會幕門口，',
    '民6:14 他要將供物奉給耶和華，就是一隻沒有殘疾、一歲的公羊羔作燔祭，一隻沒有殘疾、一歲的母羊羔作贖罪祭，和一隻沒有殘疾的公綿羊作平安祭，',
    '民6:15 並一筐子無酵調油的細麵餅，與抹油的無酵薄餅，並同獻的素祭和奠祭。',
    '民6:16 祭司要在耶和華面前獻那人的贖罪祭和燔祭；',
    '民6:17 也要把那隻公羊和那筐無酵餅獻給耶和華作平安祭，又要將同獻的素祭和奠祭獻上。',
    '民6:18 拿細耳人要在會幕門口剃離俗的頭，把離俗頭上的髮放在平安祭下的火上。',
    '民6:19 他剃了以後，祭司就要取那已煮的公羊一條前腿，又從筐子裡取一個無酵餅和一個無酵薄餅，都放在他手上。',
    '民6:20 祭司要拿這些作為搖祭，在耶和華面前搖一搖；這與所搖的胸、所舉的腿同為聖物，歸給祭司。然後拿細耳人可以喝酒。',
    '民6:21 許願的拿細耳人為離俗所獻的供物，和他以外所能得的獻給耶和華，就有這條例。他怎樣許願就當照離俗的條例行。',
    '民6:22 耶和華曉諭摩西說：',
    '民6:23 你告訴亞倫和他兒子說：你們要這樣為以色列人祝福，說：',
    '民6:24 願耶和華賜福給你，保護你。',
    '民6:25 願耶和華使他的臉光照你，賜恩給你。',
    '民6:26 願耶和華向你仰臉，賜你平安。',
    '民6:27 他們要如此奉我的名為以色列人祝福；我也要賜福給他們。',
    '民7:1 摩西立完了帳幕，就把帳幕用膏抹了，使他成聖，又把其中的器具和壇，並壇上的器具，都抹了，使他成聖。',
    '民7:2 當天，以色列的眾首領，就是各族的族長，都來奉獻。他們是各支派的首領，管理那些被數的人。',
    '民7:3 他們把自己的供物送到耶和華面前，就是六輛篷子車和十二隻公牛。每兩個首領奉獻一輛車，每首領奉獻一隻牛。他們把這些都奉到帳幕前。',
    '民7:4 耶和華曉諭摩西說：',
    '民7:5 你要收下這些，好作會幕的使用，都要照利未人所辦的事交給他們。',
    '民7:6 於是摩西收了車和牛，交給利未人，',
    '民7:7 把兩輛車，四隻牛，照革順子孫所辦的事交給他們，',
    '民7:8 又把四輛車，八隻牛，照米拉利子孫所辦的事交給他們；他們都在祭司亞倫的兒子以他瑪手下。',
    '民7:9 但車與牛都沒有交給哥轄子孫；因為他們辦的是聖所的事，在肩頭上擡聖物。',
    '民7:10 用膏抹壇的日子，首領都來行奉獻壇的禮，眾首領就在壇前獻供物。',
    '民7:11 耶和華對摩西說：眾首領為行奉獻壇的禮，要每天一個首領來獻供物。',
    '民7:12 頭一日獻供物的是猶大支派的亞米拿達的兒子拿順。',
    '民7:13 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:14 一個金盂，重十舍客勒，盛滿了香；',
    '民7:15 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:16 一隻公山羊作贖罪祭；',
    '民7:17 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是亞米拿達兒子拿順的供物。',
    '民7:18 第二日來獻的是以薩迦子孫的首領、蘇押的兒子拿坦業。',
    '民7:19 他獻為供物的是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:20 一個金盂，重十舍客勒，盛滿了香；',
    '民7:21 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:22 一隻公山羊作贖罪祭；',
    '民7:23 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是蘇押兒子拿坦業的供物。',
    '民7:24 第三日來獻的是西布倫子孫的首領、希倫的兒子以利押。',
    '民7:25 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:26 一個金盂，重十舍客勒，盛滿了香；',
    '民7:27 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:28 一隻公山羊作贖罪祭；',
    '民7:29 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是希倫兒子以利押的供物。',
    '民7:30 第四日來獻的是流便子孫的首領、示丟珥的兒子以利蓿。',
    '民7:31 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:32 一個金盂，重十舍客勒，盛滿了香；',
    '民7:33 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:34 一隻公山羊作贖罪祭；',
    '民7:35 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是示丟珥的兒子以利蓿的供物。',
    '民7:36 第五日來獻的是西緬子孫的首領、蘇利沙代的兒子示路蔑。',
    '民7:37 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:38 一個金盂，重十舍客勒，盛滿了香；',
    '民7:39 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:40 一隻公山羊作贖罪祭；',
    '民7:41 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是蘇利沙代兒子示路蔑的供物。',
    '民7:42 第六日來獻的是迦得子孫的首領、丟珥的兒子以利雅薩。',
    '民7:43 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:44 一個金盂，重十舍客勒，盛滿了香；',
    '民7:45 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:46 一隻公山羊作贖罪祭；',
    '民7:47 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是丟珥的兒子以利雅薩的供物。',
    '民7:48 第七日來獻的是以法蓮子孫的首領、亞米忽的兒子以利沙瑪。',
    '民7:49 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:50 一個金盂，重十舍客勒，盛滿了香；',
    '民7:51 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:52 一隻公山羊作贖罪祭；',
    '民7:53 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是亞米忽兒子以利沙瑪的供物。',
    '民7:54 第八日來獻的是瑪拿西子孫的首領、比大蓿的兒子迦瑪列。',
    '民7:55 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:56 一個金盂，重十舍客勒，盛滿了香；',
    '民7:57 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:58 一隻公山羊作贖罪祭；',
    '民7:59 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是比大蓿兒子迦瑪列的供物。',
    '民7:60 第九日來獻的是便雅憫子孫的首領、基多尼的兒子亞比但。',
    '民7:61 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:62 一個金盂，重十舍客勒，盛滿了香；',
    '民7:63 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:64 一隻公山羊作贖罪祭；',
    '民7:65 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是基多尼兒子亞比但的供物。',
    '民7:66 第十日來獻的是但子孫的首領、亞米沙代的兒子亞希以謝。',
    '民7:67 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:68 一個金盂，重十舍客勒，盛滿了香；',
    '民7:69 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:70 一隻公山羊作贖罪祭；',
    '民7:71 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是亞米沙代兒子亞希以謝的供物。',
    '民7:72 第十一日來獻的是亞設子孫的首領、俄蘭的兒子帕結。',
    '民7:73 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:74 一個金盂，重十舍客勒，盛滿了香；',
    '民7:75 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:76 一隻公山羊作贖罪祭；',
    '民7:77 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是俄蘭兒子帕結的供物。',
    '民7:78 第十二日來獻的是拿弗他利子孫的首領、以南兒子亞希拉。',
    '民7:79 他的供物是：一個銀盤子，重一百三十舍客勒，一個銀碗，重七十舍客勒，都是按聖所的平，也都盛滿了調油的細麵作素祭；',
    '民7:80 一個金盂，重十舍客勒，盛滿了香；',
    '民7:81 一隻公牛犢，一隻公綿羊，一隻一歲的公羊羔作燔祭；',
    '民7:82 一隻公山羊作贖罪祭；',
    '民7:83 兩隻公牛，五隻公綿羊，五隻公山羊，五隻一歲的公羊羔作平安祭。這是以南兒子亞希拉的供物。',
    '民7:84 用膏抹壇的日子，以色列的眾首領為行獻壇之禮所獻的是：銀盤子十二個，銀碗十二個，金盂十二個；',
    '民7:85 每盤子重一百三十舍客勒，每碗重七十舍客勒。一切器皿的銀子，按聖所的平，共有二千四百舍客勒。',
    '民7:86 十二個金盂盛滿了香，按聖所的平，每盂重十舍客勒，所有的金子共一百二十舍客勒。',
    '民7:87 作燔祭的，共有公牛十二隻，公羊十二隻，一歲的公羊羔十二隻，並同獻的素祭作贖罪祭的公山羊十二隻；',
    '民7:88 作平安祭的，共有公牛二十四隻，公綿羊六十隻，公山羊六十隻，一歲的公羊羔六十隻。這就是用膏抹壇之後，為行奉獻壇之禮所獻的。',
    '民7:89 摩西進會幕要與耶和華說話的時候，聽見法櫃的施恩座以上、二基路伯中間有與他說話的聲音，就是耶和華與他說話。',
    '民8:1 耶和華曉諭摩西說：',
    '民8:2 你告訴亞倫說：點燈的時候，七盞燈都要向燈臺前面發光。',
    '民8:3 亞倫便這樣行。他點燈臺上的燈，使燈向前發光，是照耶和華所吩咐摩西的。',
    '民8:4 這燈臺的做法是用金子錘出來的，連座帶花都是錘出來的。摩西製造燈臺，是照耶和華所指示的樣式。',
    '民8:5 耶和華曉諭摩西說：',
    '民8:6 你從以色列人中選出利未人來，潔淨他們。',
    '民8:7 潔淨他們當這樣行：用除罪水彈在他們身上，又叫他們用剃頭刀刮全身，洗衣服，潔淨自己。',
    '民8:8 然後叫他們取一隻公牛犢，並同獻的素祭，就是調油的細麵；你要另取一隻公牛犢作贖罪祭。',
    '民8:9 將利未人奉到會幕前，招聚以色列全會眾。',
    '民8:10 將利未人奉到耶和華面前，以色列人要按手在他們頭上。',
    '民8:11 亞倫也將他們奉到耶和華面前，為以色列人當作搖祭，使他們好辦耶和華的事。',
    '民8:12 利未人要按手在那兩隻牛的頭上；你要將一隻作贖罪祭，一隻作燔祭，獻給耶和華，為利未人贖罪。',
    '民8:13 你也要使利未人站在亞倫和他兒子面前，將他們當作搖祭奉給耶和華。',
    '民8:14 這樣，你從以色列人中將利未人分別出來，利未人便要歸我。',
    '民8:15 此後利未人要進去辦會幕的事，你要潔淨他們，將他們當作搖祭奉上；',
    '民8:16 因為他們是從以色列人中全然給我的，我揀選他們歸我，是代替以色列人中一切頭生的。',
    '民8:17 以色列人中一切頭生的，連人帶牲畜，都是我的。我在埃及地擊殺一切頭生的那天，將他們分別為聖歸我。',
    '民8:18 我揀選利未人代替以色列人中一切頭生的。',
    '民8:19 我從以色列人中將利未人當作賞賜給亞倫和他的兒子，在會幕中辦以色列人的事，又為以色列人贖罪，免得他們挨近聖所，有災殃臨到他們中間。',
    '民8:20 摩西、亞倫，並以色列全會眾便向利未人如此行。凡耶和華指著利未人所吩咐摩西的，以色列人就向他們這樣行。',
    '民8:21 於是利未人潔淨自己，除了罪，洗了衣服；亞倫將他們當作搖祭奉到耶和華面前，又為他們贖罪，潔淨他們。',
    '民8:22 然後利未人進去，在亞倫和他兒子面前，在會幕中辦事。耶和華指著利未人怎樣吩咐摩西，以色列人就怎樣向他們行了。',
    '民8:23 耶和華曉諭摩西說：',
    '民8:24 利未人是這樣：從二十五歲以外，他們要前來任職，辦會幕的事。',
    '民8:25 到了五十歲要停工退任，不再辦事，',
    '民8:26 只要在會幕裡，和他們的弟兄一同伺候，謹守所吩咐的，不再辦事了。至於所吩咐利未人的，你要這樣向他們行。',
    '民9:1 以色列人出埃及地以後，第二年正月，耶和華在西乃的曠野吩咐摩西說：',
    '民9:2 以色列人應當在所定的日期守逾越節，',
    '民9:3 就是本月十四日黃昏的時候，你們要在所定的日期守這節，要按這節的律例典章而守。',
    '民9:4 於是摩西吩咐以色列人守逾越節。',
    '民9:5 他們就在西乃的曠野，正月十四日黃昏的時候，守逾越節。凡耶和華所吩咐摩西的，以色列人都照樣行了。',
    '民9:6 有幾個人因死屍而不潔淨，不能在那日守逾越節。當日他們到摩西、亞倫面前，',
    '民9:7 說：我們雖因死屍而不潔淨，為何被阻止、不得同以色列人在所定的日期獻耶和華的供物呢﹖',
    '民9:8 摩西對他們說：你們暫且等候，我可以去聽耶和華指著你們是怎樣吩咐的。',
    '民9:9 耶和華對摩西說：',
    '民9:10 你曉諭以色列人說：你們和你們後代中，若有人因死屍而不潔淨，或在遠方行路，還要向耶和華守逾越節。',
    '民9:11 他們要在二月十四日黃昏的時候，守逾越節。要用無酵餅與苦菜，和逾越節的羊羔同吃。',
    '民9:12 一點不可留到早晨；羊羔的骨頭一根也不可折斷。他們要照逾越節的一切律例而守。',
    '民9:13 那潔淨而不行路的人若推辭不守逾越節，那人要從民中剪除；因為他在所定的日期不獻耶和華的供物，應該擔當他的罪。',
    '民9:14 若有外人寄居在你們中間，願意向耶和華守逾越節，他要照逾越節的律例典章行，不管是寄居的是本地人，同歸一例。',
    '民9:15 立起帳幕的那日，有雲彩遮蓋帳幕，就是法櫃的帳幕；從晚上到早晨，雲彩在其上，形狀如火。',
    '民9:16 常是這樣，雲彩遮蓋帳幕，夜間形狀如火。',
    '民9:17 雲彩幾時從帳幕收上去，以色列人就幾時起行；雲彩在哪裡停住，以色列人就在那裡安營。',
    '民9:18 以色列人遵耶和華的吩咐起行，也遵耶和華的吩咐安營。雲彩在帳幕上停住幾時，他們就住營幾時。',
    '民9:19 雲彩在帳幕上停留許多日子，以色列人就守耶和華所吩咐的不起行。',
    '民9:20 有時雲彩在帳幕上幾天，他們就照耶和華的吩咐住營，也照耶和華的吩咐起行。',
    '民9:21 有時從晚上到早晨，有這雲彩在帳幕上；早晨雲彩收上去，他們就起行。有時晝夜雲彩停在帳幕上，收上去的時候，他們就起行。',
    '民9:22 雲彩停留在帳幕上，無論是兩天，是一月，是一年，以色列人就住營不起行；但雲彩收上去，他們就起行。',
    '民9:23 他們遵耶和華的吩咐安營，也遵耶和華的吩咐起行。他們守耶和華所吩咐的，都是憑耶和華吩咐摩西的。',
    '民10:1 耶和華曉諭摩西說：',
    '民10:2 你要用銀子做兩枝號，都要錘出來的，用以招聚會眾，並叫眾營起行。',
    '民10:3 吹這號的時候，全會眾要到你那裡，聚集在會幕門口。',
    '民10:4 若單吹一枝，眾首領，就是以色列軍中的統領，要聚集到你那裡。',
    '民10:5 吹出大聲的時候，東邊安的營都要起行。',
    '民10:6 二次吹出大聲的時候，南邊安的營都要起行。他們將起行，必吹出大聲。',
    '民10:7 但招聚會眾的時候，你們要吹號，卻不要吹出大聲。',
    '民10:8 亞倫子孫作祭司的要吹這號；這要作你們世世代代永遠的定例。',
    '民10:9 你們在自己的地，與欺壓你們的敵人打仗，就要用號吹出大聲，便在耶和華─你們的神面前得蒙記念，也蒙拯救脫離仇敵。',
    '民10:10 在你們快樂的日子和節期，並月朔，獻燔祭和平安祭，也要吹號，這都要在你們的神面前作為記念。我是耶和華─你們的神。',
    '民10:11 第二年二月二十日，雲彩從法櫃的帳幕收上去。',
    '民10:12 以色列人就按站往前行，離開西乃的曠野，雲彩停住在巴蘭的曠野。',
    '民10:13 這是他們照耶和華藉摩西所吩咐的，初次往前行。',
    '民10:14 按著軍隊首先往前行的是猶大營的纛。統領軍隊的是亞米拿達的兒子拿順。',
    '民10:15 統領以薩迦支派軍隊的是蘇押的兒子拿坦業。',
    '民10:16 統領西布倫支派軍隊的是希倫的兒子以利押。',
    '民10:17 帳幕拆卸，革順的子孫和米拉利的子孫就擡著帳幕先往前行。',
    '民10:18 按著軍隊往前行的是流便營的纛。統領軍隊的是示丟珥的兒子以利蓿。',
    '民10:19 統領西緬支派軍隊的是蘇利沙代的兒子示路蔑。',
    '民10:20 統領迦得支派軍隊的是丟珥的兒子以利雅薩。',
    '民10:21 哥轄人擡著聖物先往前行。他們未到以前，擡帳幕的已經把帳幕支好。',
    '民10:22 按著軍隊往前行的是以法蓮營的纛，統領軍隊的是亞米忽的兒子以利沙瑪。',
    '民10:23 統領瑪拿西支派軍隊的是比大蓿的兒子迦瑪列。',
    '民10:24 統領便雅憫支派軍隊的是基多尼的兒子亞比但。',
    '民10:25 在諸營末後的是但營的纛，按著軍隊往前行。統領軍隊的是亞米沙代的兒子亞希以謝。',
    '民10:26 統領亞設支派軍隊的是俄蘭的兒子帕結。',
    '民10:27 統領拿弗他利支派軍隊的是以南的兒子亞希拉。',
    '民10:28 以色列人按著軍隊往前行，就是這樣。',
    '民10:29 摩西對他岳父（或作：內兄）─米甸人流珥的兒子何巴─說：我們要行路，往耶和華所應許之地去；他曾說：我要將這地賜給你們。現在求你和我們同去，我們必厚待你，因為耶和華指著以色列人已經應許給好處。',
    '民10:30 何巴回答說：我不去；我要回本地本族那裡去。',
    '民10:31 摩西說：求你不要離開我們；因為你知道我們要在曠野安營，你可以當作我們的眼目。',
    '民10:32 你若和我們同去，將來耶和華有什麼好處待我們，我們也必以什麼好處待你。',
    '民10:33 以色列人離開耶和華的山，往前行了三天的路程；耶和華的約櫃在前頭行了三天的路程，為他們尋找安歇的地方。',
    '民10:34 他們拔營往前行，日間有耶和華的雲彩在他們以上。',
    '民10:35 約櫃往前行的時候，摩西就說：耶和華啊，求你興起！願你的仇敵四散！願恨你的人從你面前逃跑！',
    '民10:36 約櫃停住的時候，他就說：耶和華啊，求你回到以色列的千萬人中！',
    '民11:1 眾百姓發怨言，他們的惡語達到耶和華的耳中。耶和華聽見了就怒氣發作，使火在他們中間焚燒，直燒到營的邊界。',
    '民11:2 百姓向摩西哀求，摩西祈求耶和華，火就熄了。',
    '民11:3 那地方便叫做他備拉，因為耶和華的火燒在他們中間。',
    '民11:4 他們中間的閒雜人大起貪慾的心；以色列人又哭號說：誰給我們肉吃呢﹖',
    '民11:5 我們記得，在埃及的時候不花錢就吃魚，也記得有黃瓜、西瓜、韮菜、葱、蒜。',
    '民11:6 現在我們的心血枯竭了，除這嗎哪以外，在我們眼前並沒有別的東西。',
    '民11:7 （這嗎哪彷彿芫荽子，又好像珍珠。',
    '民11:8 百姓周圍行走，把嗎哪收起來，或用磨推，或用臼搗，煮在鍋中，又做成餅，滋味好像新油。',
    '民11:9 夜間露水降在營中，嗎哪也隨著降下。）',
    '民11:10 摩西聽見百姓各在各家的帳棚門口哭號。耶和華的怒氣便大發作，摩西就不喜悅。',
    '民11:11 摩西對耶和華說：你為何苦待僕人﹖我為何不在你眼前蒙恩，竟把這管理百姓的重任加在我身上呢﹖',
    '民11:12 這百姓豈是我懷的胎，豈是我生下來的呢﹖你竟對我說：把他們抱在懷裡，如養育之父抱吃奶的孩子，直抱到你起誓應許給他們祖宗的地去。',
    '民11:13 我從哪裡得肉給這百姓吃呢﹖他們都向我哭號說：你給我們肉吃吧！',
    '民11:14 管理這百姓的責任太重了，我獨自擔當不起。',
    '民11:15 你這樣待我，我若在你眼前蒙恩，求你立時將我殺了，不叫我見自己的苦情。',
    '民11:16 耶和華對摩西說：你從以色列的長老中招聚七十個人，就是你所知道作百姓的長老和官長的，到我這裡來，領他們到會幕前，使他們和你一同站立。',
    '民11:17 我要在那裡降臨，與你說話，也要把降於你身上的靈分賜他們，他們就和你同當這管百姓的重任，免得你獨自擔當。',
    '民11:18 又要對百姓說：你們應當自潔，預備明天吃肉，因為你們哭號說：誰給我們肉吃！我們在埃及很好。這聲音達到了耶和華的耳中，所以他必給你們肉吃。',
    '民11:19 你們不止吃一天、兩天、五天、十天、二十天，',
    '民11:20 要吃一個整月，甚至肉從你們鼻孔裡噴出來，使你們厭惡了，因為你們厭棄住在你們中間的耶和華，在他面前哭號說：我們為何出了埃及呢！',
    '民11:21 摩西對耶和華說：這與我同住的百姓、步行的男人有六十萬，你還說：我要把肉給他們，使他們可以吃一個整月。',
    '民11:22 難道給他們宰了羊群牛群，或是把海中所有的魚都聚了來，就夠他們吃嗎﹖',
    '民11:23 耶和華對摩西說：耶和華的膀臂豈是縮短了嗎﹖現在要看我的話向你應驗不應驗。',
    '民11:24 摩西出去，將耶和華的話告訴百姓，又招聚百姓的長老中七十個人來，使他們站在會幕的四圍。',
    '民11:25 耶和華在雲中降臨，對摩西說話，把降與他身上的靈分賜那七十個長老。靈停在他們身上的時候，他們就受感說話，以後卻沒有再說。',
    '民11:26 但有兩個人仍在營裡，一個名叫伊利達，一個名叫米達。他們本是在那些被錄的人中，卻沒有到會幕那裡去。靈停在他們身上，他們就在營裡說預言。',
    '民11:27 有個少年人跑來告訴摩西說：伊利達、米達在營裡說預言。',
    '民11:28 摩西的幫手，嫩的兒子約書亞，就是摩西所揀選的一個人，說：請我主摩西禁止他們。',
    '民11:29 摩西對他說：你為我的緣故嫉妒人嗎﹖惟願耶和華的百姓都受感說話！願耶和華把他的靈降在他們身上！',
    '民11:30 於是，摩西和以色列的長老都回到營裡去。',
    '民11:31 有風從耶和華那裡颳起，把鵪鶉由海面颳來，飛散在營邊和營的四圍；這邊約有一天的路程，那邊約有一天的路程，離地面約有二肘。',
    '民11:32 百姓起來，終日終夜，並次日一整天，捕取鵪鶉；至少的也取了十賀梅珥，為自己擺列在營的四圍。',
    '民11:33 肉在他們牙齒之間尚未嚼爛，耶和華的怒氣就向他們發作，用最重的災殃擊殺了他們。',
    '民11:34 那地方便叫做基博羅哈他瓦（就是貪慾之人的墳墓），因為他們在那裡葬埋那起貪慾之心的人。',
    '民11:35 百姓從基博羅哈他瓦走到哈洗錄，就住在哈洗錄。',
    '民12:1 摩西娶了古實女子為妻。米利暗和亞倫因他所娶的古實女子就毀謗他，說：',
    '民12:2 難道耶和華單與摩西說話，不也與我們說話嗎﹖這話耶和華聽見了。',
    '民12:3 （摩西為人極其謙和，勝過世上的眾人。）',
    '民12:4 耶和華忽然對摩西、亞倫、米利暗說：你們三個人都出來，到會幕這裡。他們三個人就出來了。',
    '民12:5 耶和華在雲柱中降臨，站在會幕門口，召亞倫和米利暗，二人就出來了。',
    '民12:6 耶和華說：你們且聽我的話：你們中間若有先知，我─耶和華必在異象中向他顯現，在夢中與他說話。',
    '民12:7 我的僕人摩西不是這樣；他是在我全家盡忠的。',
    '民12:8 我要與他面對面說話，乃是明說，不用謎語，並且他必見我的形像。你們毀謗我的僕人摩西，為何不懼怕呢﹖',
    '民12:9 耶和華就向他們二人發怒而去。',
    '民12:10 雲彩從會幕上挪開了，不料，米利暗長了大痲瘋，',
    '民12:11 有雪那樣白。亞倫一看米利暗長了大痲瘋，就對摩西說：我主啊，求你不要因我們愚昧犯罪，便將這罪加在我們身上。',
    '民12:12 求你不要使他像那出母腹、肉已半爛的死胎。',
    '民12:13 於是摩西哀求耶和華說：神啊，求你醫治他！',
    '民12:14 耶和華對摩西說：他父親若吐唾沫在他臉上，他豈不蒙羞七天嗎﹖現在要把他在營外關鎖七天，然後才可以領他進來。',
    '民12:15 於是米利暗關鎖在營外七天。百姓沒有行路，直等到把米利暗領進來。',
    '民12:16 以後百姓從哈洗錄起行，在巴蘭的曠野安營。',
    '民13:1 耶和華曉諭摩西說：',
    '民13:2 你打發人去窺探我所賜給以色列人的迦南地，他們每支派中要打發一個人，都要作首領的。',
    '民13:3 摩西就照耶和華的吩咐從巴蘭的曠野打發他們去；他們都是以色列人的族長。',
    '民13:4 他們的名字：屬流便支派的有撒刻的兒子沙母亞。',
    '民13:5 屬西緬支派的有何利的兒子的沙法。',
    '民13:6 屬猶大支派的有耶孚尼的兒子迦勒。',
    '民13:7 屬以薩迦支派的有約色的兒子以迦。',
    '民13:8 屬以法蓮支派的有嫩的兒子何西阿。',
    '民13:9 屬便雅憫支派的有拉孚的兒子帕提。',
    '民13:10 屬西布倫支派的有梭底的兒子迦疊。',
    '民13:11 約瑟的子孫，屬瑪拿西支派的有穌西的兒子迦底。',
    '民13:12 屬但支派的有基瑪利的兒子亞米利。',
    '民13:13 屬亞設支派的有米迦勒的兒子西帖。',
    '民13:14 屬拿弗他利支派的有縛西的兒子拿比。',
    '民13:15 屬迦得支派的有瑪基的兒子臼利。',
    '民13:16 這就是摩西所打發、窺探那地之人的名字。摩西就稱嫩的兒子何西阿為約書亞。',
    '民13:17 摩西打發他們去窺探迦南地，說：你們從南地上山地去，',
    '民13:18 看那地如何，其中所住的民是強是弱，是多是少，',
    '民13:19 所住之地是好是歹，所住之處是營盤是堅城。',
    '民13:20 又看那地土是肥美是瘠薄，其中有樹木沒有。你們要放開膽量，把那地的果子帶些來。（那時正是葡萄初熟的時候。）',
    '民13:21 他們上去窺探那地，從尋的曠野到利合，直到哈馬口。',
    '民13:22 他們從南地上去，到了希伯崙；在那裡有亞衲族人亞希幔、示篩、撻買。（原來希伯崙城被建造比埃及的鎖安城早七年。）',
    '民13:23 他們到了以實各谷，從那裡砍了葡萄樹的一枝，上頭有一掛葡萄，兩個人用槓擡著，又帶了些石榴和無花果來。',
    '民13:24 （因為以色列人從那裡砍來的那掛葡萄，所以那地方叫做以實各谷。）',
    '民13:25 過了四十天，他們窺探那地才回來，',
    '民13:26 到了巴蘭曠野的加低斯，見摩西、亞倫，並以色列的全會眾，回報摩西、亞倫，並全會眾，又把那地的果子給他們看；',
    '民13:27 又告訴摩西說：我們到了你所打發我們去的那地，果然是流奶與蜜之地；這就是那地的果子。',
    '民13:28 然而住那地的民強壯，城邑也堅固寬大，並且我們在那裡看見了亞衲族的人。',
    '民13:29 亞瑪力人住在南地；赫人、耶布斯人、亞摩利人住在山地；迦南人住在海邊並約但河旁。',
    '民13:30 迦勒在摩西面前安撫百姓，說：我們立刻上去得那地吧！我們足能得勝。',
    '民13:31 但那些和他同去的人說：我們不能上去攻擊那民，因為他們比我們強壯。',
    '民13:32 探子中有人論到所窺探之地，向以色列人報惡信，說：我們所窺探、經過之地是吞吃居民之地，我們在那裡所看見的人民都身量高大。',
    '民13:33 我們在那裡看見亞衲族人，就是偉人；他們是偉人的後裔。據我們看，自己就如蚱蜢一樣；據他們看，我們也是如此。',
    '民14:1 當下，全會眾大聲喧嚷；那夜百姓都哭號。',
    '民14:2 以色列眾人向摩西、亞倫發怨言；全會眾對他們說：巴不得我們早死在埃及地，或是死在這曠野。',
    '民14:3 耶和華為什麼把我們領到那地，使我們倒在刀下呢﹖我們的妻子和孩子必被擄掠。我們回埃及去豈不好嗎﹖',
    '民14:4 眾人彼此說：我們不如立一個首領回埃及去吧！',
    '民14:5 摩西、亞倫就俯伏在以色列全會眾面前。',
    '民14:6 窺探地的人中，嫩的兒子約書亞和耶孚尼的兒子迦勒撕裂衣服，',
    '民14:7 對以色列全會眾說：我們所窺探、經過之地是極美之地。',
    '民14:8 耶和華若喜悅我們，就必將我們領進那地，把地賜給我們；那地原是流奶與蜜之地。',
    '民14:9 但你們不可背叛耶和華，也不要怕那地的居民；因為他們是我們的食物，並且蔭庇他們的已經離開他們。有耶和華與我們同在，不要怕他們！',
    '民14:10 但全會眾說：拿石頭打死他們二人。忽然，耶和華的榮光在會幕中向以色列眾人顯現。',
    '民14:11 耶和華對摩西說：這百姓藐視我要到幾時呢﹖我在他們中間行了這一切神蹟，他們還不信我要到幾時呢﹖',
    '民14:12 我要用瘟疫擊殺他們，使他們不得承受那地，叫你的後裔成為大國，比他們強勝。',
    '民14:13 摩西對耶和華說：埃及人必聽見這事；因為你曾施展大能，將這百姓從他們中間領上來。',
    '民14:14 埃及人要將這事傳給迦南地的居民；那民已經聽見你─耶和華是在這百姓中間；因為你面對面被人看見，有你的雲彩停在他們以上。你日間在雲柱中，夜間在火柱中，在他們前面行。',
    '民14:15 如今你若把這百姓殺了，如殺一人，那些聽見你名聲的列邦必議論說：',
    '民14:16 耶和華因為不能把這百姓領進他向他們起誓應許之地，所以在曠野把他們殺了。',
    '民14:17 現在求主大顯能力，照你所說過的話說：',
    '民14:18 耶和華不輕易發怒，並有豐盛的慈愛，赦免罪孽和過犯；萬不以有罪的為無罪，必追討他的罪，自父及子，直到三、四代。',
    '民14:19 求你照你的大慈愛赦免這百姓的罪孽，好像你從埃及到如今常赦免他們一樣。',
    '民14:20 耶和華說：我照著你的話赦免了他們。',
    '民14:21 然我指著我的永生起誓，遍地要被我的榮耀充滿。',
    '民14:22 這些人雖看見我的榮耀和我在埃及與曠野所行的神蹟，仍然試探我這十次，不聽從我的話，',
    '民14:23 他們斷不得看見我向他們的祖宗所起誓應許之地。凡藐視我的，一個也不得看見；',
    '民14:24 惟獨我的僕人迦勒，因他另有一個心志，專一跟從我，我就把他領進他所去過的那地；他的後裔也必得那地為業。',
    '民14:25 亞瑪力人和迦南人住在谷中，明天你們要轉回，從紅海的路往曠野去。',
    '民14:26 耶和華對摩西、亞倫說：',
    '民14:27 這惡會眾向我發怨言，我忍耐他們要到幾時呢﹖以色列人向我所發的怨言，我都聽見了。',
    '民14:28 你們告訴他們，耶和華說：我指著我的永生起誓，我必要照你們達到我耳中的話待你們。',
    '民14:29 你們的屍首必倒在這曠野，並且你們中間凡被數點、從二十歲以外、向我發怨言的，',
    '民14:30 必不得進我起誓應許叫你們住的那地；惟有耶孚尼的兒子迦勒和嫩的兒子約書亞才能進去。',
    '民14:31 但你們的婦人孩子，就是你們所說、要被擄掠的，我必把他們領進去，他們就得知你們所厭棄的那地。',
    '民14:32 至於你們，你們的屍首必倒在這曠野；',
    '民14:33 你們的兒女必在曠野飄流四十年，擔當你們淫行的罪，直到你們的屍首在曠野消滅。',
    '民14:34 按你們窺探那地的四十日，一年頂一日，你們要擔當罪孽四十年，就知道我與你們疏遠了，',
    '民14:35 我─耶和華說過，我總要這樣待這一切聚集敵我的惡會眾；他們必在這曠野消滅，在這裡死亡。',
    '民14:36 摩西所打發、窺探那地的人回來，報那地的惡信，叫全會眾向摩西發怨言，',
    '民14:37 這些報惡信的人都遭瘟疫，死在耶和華面前。',
    '民14:38 其中惟有嫩的兒子約書亞和耶孚尼的兒子迦勒仍然存活。',
    '民14:39 摩西將這些話告訴以色列眾人，他們就甚悲哀。',
    '民14:40 清早起來，上山頂去，說：我們在這裡，我們有罪了；情願上耶和華所應許的地方去。',
    '民14:41 摩西說：你們為何違背耶和華的命令呢﹖這事不能順利了。',
    '民14:42 不要上去；因為耶和華不在你們中間，恐怕你們被仇敵殺敗了。',
    '民14:43 亞瑪力人和迦南人都在你們面前，你們必倒在刀下；因你們退回不跟從耶和華，所以他必不與你們同在。',
    '民14:44 他們卻擅敢上山頂去，然而耶和華的約櫃和摩西沒有出營。',
    '民14:45 於是亞瑪力人和住在那山上的迦南人都下來擊打他們，把他們殺退了，直到何珥瑪。',
    '民15:1 耶和華對摩西說：',
    '民15:2 你曉諭以色列人說：你們到了我所賜給你們居住的地，',
    '民15:3 若願意從牛群羊群中取牛羊作火祭，獻給耶和華，無論是燔祭是平安祭，為要還特許的願，或是作甘心祭，或是逢你們節期獻的，都要奉給耶和華為馨香之祭。',
    '民15:4 那獻供物的就要將細麵伊法十分之一，並油一欣四分之一，調和作素祭，獻給耶和華。',
    '民15:5 無論是燔祭是平安祭，你要為每隻綿羊羔，一同預備奠祭的酒一欣四分之一。',
    '民15:6 為公綿羊預備細麵伊法十分之二，並油一欣三分之一，調和作素祭，',
    '民15:7 又用酒一欣三分之一作奠祭，獻給耶和華為馨香之祭。',
    '民15:8 你預備公牛作燔祭，或是作平安祭，為要還特許的願，或是作平安祭，獻給耶和華，',
    '民15:9 就要把細麵伊法十分之三，並油半欣，調和作素祭，和公牛一同獻上，',
    '民15:10 又用酒半欣作奠祭，獻給耶和華為馨香的火祭。',
    '民15:11 獻公牛、公綿羊、綿羊羔、山羊羔，每隻都要這樣辦理。',
    '民15:12 照你們所預備的數目，按著隻數都要這樣辦理。',
    '民15:13 凡本地人將馨香的火祭獻給耶和華，都要這樣辦理。',
    '民15:14 若有外人和你們同居，或有人世世代代住在你們中間，願意將馨香的火祭獻給耶和華，你們怎樣辦理，他也要照樣辦理。',
    '民15:15 至於會眾，你們和同居的外人都歸一例，作為你們世世代代永遠的定例，在耶和華面前，你們怎樣，寄居的也要怎樣。',
    '民15:16 你們並與你們同居的外人當有一樣的條例，一樣的典章。',
    '民15:17 耶和華對摩西說：',
    '民15:18 你曉諭以色列人說：你們到了我所領你們進去的那地，',
    '民15:19 吃那地的糧食，就要把舉祭獻給耶和華。',
    '民15:20 你們要用初熟的麥子磨麵，做餅當舉祭奉獻；你們舉上，好像舉禾場的舉祭一樣，',
    '民15:21 你們世世代代要用初熟的麥子磨麵，當舉祭獻給耶和華。',
    '民15:22 你們有錯誤的時候，不守耶和華所曉諭摩西的這一切命令，',
    '民15:23 就是耶和華藉摩西一切所吩咐你們的，自那日以至你們的世世代代，',
    '民15:24 若有誤行，是會眾所不知道的，後來全會眾就要將一隻公牛犢作燔祭，並照典章把素祭和奠祭一同獻給耶和華為馨香之祭，又獻一隻公山羊作贖罪祭。',
    '民15:25 祭司要為以色列全會眾贖罪，他們就必蒙赦免，因為這是錯誤。他們又因自己的錯誤，把供物，就是向耶和華獻的火祭和贖罪祭，一併奉到耶和華面前。',
    '民15:26 以色列全會眾和寄居在他們中間的外人就必蒙赦免，因為這罪是百姓誤犯的。',
    '民15:27 若有一個人誤犯了罪，他就要獻一歲的母山羊作贖罪祭。',
    '民15:28 那誤行的人犯罪的時候，祭司要在耶和華面前為他贖罪，他就必蒙赦免。',
    '民15:29 以色列中的本地人和寄居在他們中間的外人，若誤行了什麼事，必歸一樣的條例，',
    '民15:30 但那擅敢行事的，無論是本地人是寄居的，他褻瀆了耶和華，必從民中剪除。',
    '民15:31 因他藐視耶和華的言語，違背耶和華的命令，那人總要剪除；他的罪孽要歸到他身上。',
    '民15:32 以色列人在曠野的時候，遇見一個人在安息日撿柴。',
    '民15:33 遇見他撿柴的人，就把他帶到摩西、亞倫並全會眾那裡，',
    '民15:34 將他收在監內；因為當怎樣辦他，還沒有指明。',
    '民15:35 耶和華吩咐摩西說：總要把那人治死；全會眾要在營外用石頭把他打死。',
    '民15:36 於是全會眾將他帶到營外，用石頭打死他，是照耶和華所吩咐摩西的。',
    '民15:37 耶和華曉諭摩西說：',
    '民15:38 你吩咐以色列人，叫他們世世代代在衣服邊上做繸子，又在底邊的繸子上釘一根藍細帶子。',
    '民15:39 你們佩帶這繸子，好叫你們看見就記念遵行耶和華一切的命令，不隨從自己的心意、眼目行邪淫，像你們素常一樣；',
    '民15:40 使你們記念遵行我一切的命令，成為聖潔，歸與你們的神。',
    '民15:41 我是耶和華─你們的神，曾把你們從埃及地領出來，要作你們的神。我是耶和華─你們的神。',
    '民16:1 利未的曾孫、哥轄的孫子、以斯哈的兒子可拉，和流便子孫中以利押的兒子大坍、亞比蘭，與比勒的兒子安，',
    '民16:2 並以色列會中的二百五十個首領，就是有名望選入會中的人，在摩西面前一同起來，',
    '民16:3 聚集攻擊摩西、亞倫，說：你們擅自專權！全會眾個個既是聖潔，耶和華也在他們中間，你們為什麼自高，超過耶和華的會眾呢﹖',
    '民16:4 摩西聽見這話就俯伏在地，',
    '民16:5 對可拉和他一黨的人說：到了早晨，耶和華必指示誰是屬他的，誰是聖潔的，就叫誰親近他；他所揀選的是誰，必叫誰親近他。',
    '民16:6 可拉啊，你們要這樣行，你和你的一黨要拿香爐來。',
    '民16:7 明日，在耶和華面前，把火盛在爐中，把香放在其上。耶和華揀選誰，誰就為聖潔。你們這利未的子孫擅自專權了！',
    '民16:8 摩西又對可拉說：利未的子孫哪，你們聽我說！',
    '民16:9 以色列的神從以色列會中將你們分別出來，使你們親近他，辦耶和華帳幕的事，並站在會眾面前替他們當差。',
    '民16:10 耶和華又使你和你一切弟兄─利未的子孫─一同親近他，這豈為小事﹖你們還要求祭司的職任嗎﹖',
    '民16:11 你和你一黨的人聚集是要攻擊耶和華。亞倫算什麼，你們竟向他發怨言呢﹖',
    '民16:12 摩西打發人去召以利押的兒子大坍、亞比蘭。他們說：我們不上去！',
    '民16:13 你將我們從流奶與蜜之地領上來，要在曠野殺我們，這豈為小事﹖你還要自立為王轄管我們嗎﹖',
    '民16:14 並且你沒有將我們領到流奶與蜜之地，也沒有把田地和葡萄園給我們為業。難道你要剜這些人的眼睛嗎﹖我們不上去！',
    '民16:15 摩西就甚發怒，對耶和華說：求你不要享受他們的供物。我並沒有奪過他們一匹驢，也沒有害過他們一個人。',
    '民16:16 摩西對可拉說：明天，你和你一黨的人，並亞倫，都要站在耶和華面前；',
    '民16:17 各人要拿一個香爐，共二百五十個，把香放在上面，到耶和華面前。你和亞倫也各拿自己的香爐。',
    '民16:18 於是他們各人拿一個香爐，盛上火，加上香，同摩西、亞倫站在會幕門前。',
    '民16:19 可拉招聚全會眾到會幕門前，要攻擊摩西、亞倫；耶和華的榮光就向全會眾顯現。',
    '民16:20 耶和華曉諭摩西、亞倫說：',
    '民16:21 你們離開這會眾，我好在轉眼之間把他們滅絕。',
    '民16:22 摩西、亞倫就俯伏在地，說：神，萬人之靈的神啊，一人犯罪，你就要向全會眾發怒嗎﹖',
    '民16:23 耶和華曉諭摩西說：',
    '民16:24 你吩咐會眾說：你們離開可拉、大坍、亞比蘭帳棚的四圍。',
    '民16:25 摩西起來，往大坍、亞比蘭那裡去；以色列的長老也隨著他去。',
    '民16:26 他吩咐會眾說：你們離開這惡人的帳棚吧，他們的物件，什麼都不可摸，恐怕你們陷在他們的罪中，與他們一同消滅。',
    '民16:27 於是眾人離開可拉、大坍、亞比蘭帳棚的四圍。大坍、亞比蘭帶著妻子、兒女、小孩子，都出來，站在自己的帳棚門口。',
    '民16:28 摩西說：我行的這一切事本不是憑我自己心意行的，乃是耶和華打發我行的，必有證據使你們知道。',
    '民16:29 這些人死若與世人無異，或是他們所遭的與世人相同，就不是耶和華打發我來的。',
    '民16:30 倘若耶和華創作一件新事，使地開口，把他們和一切屬他們的都吞下去，叫他們活活地墜落陰間，你們就明白這些人是藐視耶和華了。',
    '民16:31 摩西剛說完了這一切話，他們腳下的地就開了口，',
    '民16:32 把他們和他們的家眷，並一切屬可拉的人丁、財物，都吞下去。',
    '民16:33 這樣，他們和一切屬他們的，都活活地墜落陰間；地口在他們上頭照舊合閉，他們就從會中滅亡。',
    '民16:34 在他們四圍的以色列眾人聽他們呼號，就都逃跑，說：恐怕地也把我們吞下去。',
    '民16:35 又有火從耶和華那裡出來，燒滅了那獻香的二百五十個人。',
    '民16:36 耶和華曉諭摩西說：',
    '民16:37 你吩咐祭司亞倫的兒子以利亞撒從火中撿起那些香爐來，把火撒在別處，因為那些香爐是聖的。',
    '民16:38 把那些犯罪、自害己命之人的香爐，叫人錘成片子，用以包壇。那些香爐本是他們在耶和華面前獻過的，所以是聖的，並且可以給以色列人作記號。',
    '民16:39 於是祭司以利亞撒將被燒之人所獻的銅香爐拿來，人就錘出來，用以包壇，',
    '民16:40 給以色列人作記念，使亞倫後裔之外的人不得近前來在耶和華面前燒香，免得他遭可拉和他一黨所遭的。這乃是照耶和華藉著摩西所吩咐的。',
    '民16:41 第二天，以色列全會眾都向摩西、亞倫發怨言說：你們殺了耶和華的百姓了。',
    '民16:42 會眾聚集攻擊摩西、亞倫的時候，向會幕觀看，不料，有雲彩遮蓋了，耶和華的榮光顯現。',
    '民16:43 摩西、亞倫就來到會幕前。',
    '民16:44 耶和華吩咐摩西說：',
    '民16:45 你們離開這會眾，我好在轉眼之間把他們滅絕。他們二人就俯伏於地。',
    '民16:46 摩西對亞倫說：拿你的香爐，把壇上的火盛在其中，又加上香，快快帶到會眾那裡，為他們贖罪；因為有忿怒從耶和華那裡出來，瘟疫已經發作了。',
    '民16:47 亞倫照著摩西所說的拿來，跑到會中，不料，瘟疫在百姓中已經發作了。他就加上香，為百姓贖罪。',
    '民16:48 他站在活人死人中間，瘟疫就止住了。',
    '民16:49 除了因可拉事情死的以外，遭瘟疫死的，共有一萬四千七百人。',
    '民16:50 亞倫回到會幕門口，到摩西那裡，瘟疫已經止住了。',
    '民17:1 耶和華對摩西說：',
    '民17:2 你曉諭以色列人，從他們手下取杖，每支派一根；從他們所有的首領，按著支派，共取十二根。你要將各人的名字寫在各人的杖上，',
    '民17:3 並要將亞倫的名字寫在利未的杖上，因為各族長必有一根杖。',
    '民17:4 你要把這些杖存在會幕內法櫃前，就是我與你們相會之處。',
    '民17:5 後來我所揀選的那人，他的杖必發芽。這樣，我必使以色列人向你們所發的怨言止息，不再達到我耳中。',
    '民17:6 於是摩西曉諭以色列人，他們的首領就把杖交給他，按著支派，每首領一根，共有十二根；亞倫的杖也在其中。',
    '民17:7 摩西就把杖存在法櫃的帳幕內，在耶和華面前。',
    '民17:8 第二天，摩西進法櫃的帳幕去。誰知利未族亞倫的杖已經發了芽，生了花苞，開了花，結了熟杏。',
    '民17:9 摩西就把所有的杖從耶和華面前拿出來，給以色列眾人看；他們看見了，各首領就把自己的杖拿去。',
    '民17:10 耶和華吩咐摩西說：把亞倫的杖還放在法櫃前，給這些背叛之子留作記號。這樣，你就使他們向我發的怨言止息，免得他們死亡。',
    '民17:11 摩西就這樣行。耶和華怎樣吩咐他，他就怎樣行了。',
    '民17:12 以色列人對摩西說：我們死啦！我們滅亡啦！都滅亡啦！',
    '民17:13 凡挨近耶和華帳幕的是必死的。我們都要死亡嗎﹖',
    '民18:1 耶和華對亞倫說：你和你的兒子，並你本族的人，要一同擔當干犯聖所的罪孽。你和你的兒子也要一同擔當干犯祭司職任的罪孽。',
    '民18:2 你要帶你弟兄利未人，就是你祖宗支派的人前來，使他們與你聯合，服事你，只是你和你的兒子，要一同在法櫃的帳幕前供職。',
    '民18:3 他們要守所吩咐你的，並守全帳幕，只是不可挨近聖所的器具和壇，免得他們和你們都死亡。',
    '民18:4 他們要與你聯合，也要看守會幕，辦理帳幕一切的事，只是外人不可挨近你們。',
    '民18:5 你們要看守聖所和壇，免得忿怒再臨到以色列人。',
    '民18:6 我已將你們的弟兄利未人從以色列人中揀選出來歸耶和華，是給你們為賞賜的，為要辦理會幕的事。',
    '民18:7 你和你的兒子要為一切屬壇和幔子內的事一同守祭司的職任。你們要這樣供職；我將祭司的職任給你們當作賞賜事奉我。凡挨近的外人必被治死。',
    '民18:8 耶和華曉諭亞倫說：我已將歸我的舉祭，就是以色列人一切分別為聖的物，交給你經管；因你受過膏，把這些都賜給你和你的子孫，當作永得的分。',
    '民18:9 以色列人歸給我至聖的供物，就是一切的素祭、贖罪祭、贖愆祭，其中所有存留不經火的，都為至聖之物，要歸給你和你的子孫。',
    '民18:10 你要拿這些當至聖物吃；凡男丁都可以吃。你當以此物為聖。',
    '民18:11 以色列人所獻的舉祭並搖祭都是你的；我已賜給你和你的兒女，當作永得的分；凡在你家中的潔淨人都可以吃。',
    '民18:12 凡油中、新酒中、五穀中至好的，就是以色列人所獻給耶和華初熟之物，我都賜給你。',
    '民18:13 凡從他們地上所帶來給耶和華初熟之物也都要歸與你。你家中的潔淨人都可以吃。',
    '民18:14 以色列中一切永獻的都必歸與你。',
    '民18:15 他們所有奉給耶和華的，連人帶牲畜，凡頭生的，都要歸給你；只是人頭生的，總要贖出來；不潔淨牲畜頭生的，也要贖出來。',
    '民18:16 其中在一月之外所當贖的，要照你所估定的價，按聖所的平，用銀子五舍客勒贖出來（一舍客勒是二十季拉）。',
    '民18:17 只是頭生的牛，或是頭生的綿羊和山羊，必不可贖，都是聖的，要把他的血灑在壇上，把他的脂油焚燒，當作馨香的火祭獻給耶和華。',
    '民18:18 他的肉必歸你，像被搖的胸、被舉的右腿歸你一樣。',
    '民18:19 凡以色列人所獻給耶和華聖物中的舉祭，我都賜給你和你的兒女，當作永得的分。這是給你和你的後裔、在耶和華面前作為永遠的鹽約（鹽即不廢壞的意思）。',
    '民18:20 耶和華對亞倫說：你在以色列人的境內不可有產業，在他們中間也不可有分。我就是你的分，是你的產業。',
    '民18:21 凡以色列中出產的十分之一，我已賜給利未的子孫為業；因他們所辦的是會幕的事，所以賜給他們為酬他們的勞。',
    '民18:22 從今以後，以色列人不可挨近會幕，免得他們擔罪而死。',
    '民18:23 惟獨利未人要辦會幕的事，擔當罪孽；這要作你們世世代代永遠的定例。他們在以色列人中不可有產業；',
    '民18:24 因為以色列人中出產的十分之一，就是獻給耶和華為舉祭的，我已賜給利未人為業。所以我對他們說：在以色列人中不可有產業。',
    '民18:25 耶和華吩咐摩西說：',
    '民18:26 你曉諭利未人說：你們從以色列人中所取的十分之一，就是我給你們為業的，要再從那十分之一中取十分之一作為舉祭獻給耶和華，',
    '民18:27 這舉祭要算為你們場上的穀，又如滿酒醡的酒。',
    '民18:28 這樣，你們從以色列人中所得的十分之一也要作舉祭獻給耶和華，從這十分之一中，將所獻給耶和華的舉祭歸給祭司亞倫。',
    '民18:29 奉給你們的一切禮物，要從其中將至好的，就是分別為聖的，獻給耶和華為舉祭。',
    '民18:30 所以你要對利未人說：你們從其中將至好的舉起，這就算為你們場上的糧，又如酒醡的酒。',
    '民18:31 你們和你們家屬隨處可以吃；這原是你們的賞賜，是酬你們在會幕裡辦事的勞。',
    '民18:32 你們從其中將至好的舉起，就不致因這物擔罪。你們不可褻瀆以色列人的聖物，免得死亡。',
    '民19:1 耶和華曉諭摩西、亞倫說：',
    '民19:2 耶和華命定律法中的一條律例乃是這樣說：你要吩咐以色列人，把一隻沒有殘疾、未曾負軛、純紅的母牛牽到你這裡來，',
    '民19:3 交給祭司以利亞撒；他必牽到營外，人就把牛宰在他面前。',
    '民19:4 祭司以利亞撒要用指頭蘸這牛的血，向會幕前面彈七次。',
    '民19:5 人要在他眼前把這母牛焚燒；牛的皮、肉、血、糞都要焚燒。',
    '民19:6 祭司要把香柏木、牛膝草、朱紅色線都丟在燒牛的火中。',
    '民19:7 祭司必不潔淨到晚上，要洗衣服，用水洗身，然後可以進營。',
    '民19:8 燒牛的人必不潔淨到晚上，也要洗衣服，用水洗身。',
    '民19:9 必有一個潔淨的人收起母牛的灰，存在營外潔淨的地方，為以色列會眾調做除污穢的水。這本是除罪的。',
    '民19:10 收起母牛灰的人必不潔淨到晚上，要洗衣服。這要給以色列人和寄居在他們中間的外人作為永遠的定例。',
    '民19:11 摸了人死屍的，就必七天不潔淨。',
    '民19:12 那人到第三天要用這除污穢的水潔淨自己，第七天就潔淨了。他若在第三天不潔淨自己，第七天就不潔淨了。',
    '民19:13 凡摸了人死屍、不潔淨自己的，就玷污了耶和華的帳幕，這人必從以色列中剪除；因為那除污穢的水沒有灑在他身上，他就為不潔淨，污穢還在他身上。',
    '民19:14 人死在帳棚裡的條例乃是這樣：凡進那帳棚的，和一切在帳棚裡的，都必七天不潔淨。',
    '民19:15 凡敞口的器皿，就是沒有紮上蓋的，也是不潔淨。',
    '民19:16 無論何人在田野裡摸了被刀殺的，或是屍首，或是人的骨頭，或是墳墓，就要七天不潔淨。',
    '民19:17 要為這不潔淨的人拿些燒成的除罪灰放在器皿裡，倒上活水。',
    '民19:18 必當有一個潔淨的人拿牛膝草蘸在這水中，把水灑在帳棚上，和一切器皿並帳棚內的眾人身上，又灑在摸了骨頭，或摸了被殺的，或摸了自死的，或摸了墳墓的那人身上。',
    '民19:19 第三天和第七天，潔淨的人要灑水在不潔淨的人身上，第七天就使他成為潔淨。那人要洗衣服，用水洗澡，到晚上就潔淨了。',
    '民19:20 但那污穢而不潔淨自己的，要將他從會中剪除，因為他玷污了耶和華的聖所。除污穢的水沒有灑在他身上，他是不潔淨的。',
    '民19:21 這要給你們作為永遠的定例。並且那灑除污穢水的人要洗衣服。凡摸除污穢水的，必不潔淨到晚上。',
    '民19:22 不潔淨人所摸的一切物就不潔淨；摸了這物的人必不潔淨到晚上。',
    '民20:1 正月間，以色列全會眾到了尋的曠野，就住在加低斯。米利暗死在那裡，就葬在那裡。',
    '民20:2 會眾沒有水喝，就聚集攻擊摩西、亞倫。',
    '民20:3 百姓向摩西爭鬧說：我們的弟兄曾死在耶和華面前，我們恨不得與他們同死。',
    '民20:4 你們為何把耶和華的會眾領到這曠野、使我們和牲畜都死在這裡呢﹖',
    '民20:5 你們為何逼著我們出埃及、領我們到這壞地方呢﹖這地方不好撒種，也沒有無花果樹、葡萄樹、石榴樹，又沒有水喝。',
    '民20:6 摩西、亞倫離開會眾，到會幕門口，俯伏在地；耶和華的榮光向他們顯現。',
    '民20:7 耶和華曉諭摩西說：',
    '民20:8 你拿著杖去，和你的哥哥亞倫招聚會眾，在他們眼前吩咐磐石發出水來，水就從磐石流出，給會眾和他們的牲畜喝。',
    '民20:9 於是摩西照耶和華所吩咐的，從耶和華面前取了杖去。',
    '民20:10 摩西、亞倫就招聚會眾到磐石前。摩西說：你們這些背叛的人聽我說：我為你們使水從這磐石中流出來嗎﹖',
    '民20:11 摩西舉手，用杖擊打磐石兩下，就有許多水流出來，會眾和他們的牲畜都喝了。',
    '民20:12 耶和華對摩西、亞倫說：因為你們不信我，不在以色列人眼前尊我為聖，所以你們必不得領這會眾進我所賜給他們的地去。',
    '民20:13 這水名叫米利巴水（米利巴就是爭鬧的意思），是因以色列人向耶和華爭鬧，耶和華就在他們面前顯為聖。',
    '民20:14 摩西從加低斯差遣使者去見以東王，說：你的弟兄以色列人這樣說：我們所遭遇的一切艱難，',
    '民20:15 就是我們的列祖下到埃及，我們在埃及久住；埃及人惡待我們的列祖和我們，',
    '民20:16 我們哀求耶和華的時候，他聽了我們的聲音，差遣使者把我們從埃及領出來。這事你都知道。如今，我們在你邊界上的城加低斯。',
    '民20:17 求你容我們從你的地經過。我們不走田間和葡萄園，也不喝井裡的水，只走大道（原文作王道），不偏左右，直到過了你的境界。',
    '民20:18 以東王說：你不可從我的地經過，免得我帶刀出去攻擊你。',
    '民20:19 以色列人說：我們要走大道上去；我們和牲畜若喝你的水，必給你價值。不求別的，只求你容我們步行過去。',
    '民20:20 以東王說：你們不可經過！就率領許多人出來，要用強硬的手攻擊以色列人。',
    '民20:21 這樣，以東王不肯容以色列人從他的境界過去。於是他們轉去，離開他。',
    '民20:22 以色列全會眾從加低斯起行，到了何珥山。',
    '民20:23 耶和華在附近以東邊界的何珥山上曉諭摩西、亞倫說：',
    '民20:24 亞倫要歸到他列祖（原文作本民）那裡。他必不得入我所賜給以色列人的地；因為在米利巴水，你們違背了我的命。',
    '民20:25 你帶亞倫和他的兒子以利亞撒上何珥山，',
    '民20:26 把亞倫的聖衣脫下來，給他的兒子以利亞撒穿上；亞倫必死在那裡，歸他列祖。',
    '民20:27 摩西就照耶和華所吩咐的行。三人當著會眾的眼前上了何珥山。',
    '民20:28 摩西把亞倫的聖衣脫下來，給他的兒子以利亞撒穿上，亞倫就死在山頂那裡。於是摩西和以利亞撒下了山。',
    '民20:29 全會眾，就是以色列全家，見亞倫已經死了，便都為亞倫哀哭了三十天。',
    '民21:1 住南地的迦南人亞拉得王，聽說以色列人從亞他林路來，就和以色列人爭戰，擄了他們幾個人。',
    '民21:2 以色列人向耶和華發願說：你若將這民交付我手，我就把他們的城邑盡行毀滅。',
    '民21:3 耶和華應允了以色列人，把迦南人交付他們，他們就把迦南人和迦南人的城邑盡行毀滅。那地方的名便叫何珥瑪（何珥瑪就是毀滅的意思）。',
    '民21:4 他們從何珥山起行，往紅海那條路走，要繞過以東地。百姓因這路難行，心中甚是煩躁，',
    '民21:5 就怨讟神和摩西說：你們為什麼把我們從埃及領出來、使我們死在曠野呢﹖這裡沒有糧，沒有水，我們的心厭惡這淡薄的食物。',
    '民21:6 於是耶和華使火蛇進入百姓中間，蛇就咬他們。以色列人中死了許多。',
    '民21:7 百姓到摩西那裡，說：我們怨讟耶和華和你，有罪了。求你禱告耶和華，叫這些蛇離開我們。於是摩西為百姓禱告。',
    '民21:8 耶和華對摩西說：你製造一條火蛇，掛在杆子上；凡被咬的，一望這蛇，就必得活。',
    '民21:9 摩西便製造一條銅蛇，掛在杆子上；凡被蛇咬的，一望這銅蛇就活了。',
    '民21:10 以色列人起行，安營在阿伯。',
    '民21:11 又從阿伯起行，安營在以耶亞巴琳，與摩押相對的曠野，向日出之地。',
    '民21:12 從那裡起行，安營在撒烈谷。',
    '民21:13 從那裡起行，安營在亞嫩河那邊。這亞嫩河是在曠野，從亞摩利的境界流出來的；原來亞嫩河是摩押的邊界，在摩押和亞摩利人搭界的地方。',
    '民21:14 所以耶和華的戰記上說：蘇法的哇哈伯與亞嫩河的谷，',
    '民21:15 並向亞珥城眾谷的下坡，是靠近摩押的境界。',
    '民21:16 以色列人從那裡起行，到了比珥（比珥就是井的意思）。從前耶和華吩咐摩西說：招聚百姓，我好給他們水喝，說的就是這井。',
    '民21:17 當時，以色列人唱歌說：井啊，湧上水來！你們要向這井歌唱。',
    '民21:18 這井是首領和民中的尊貴人用圭用杖所挖所掘的。以色列人從曠野往瑪他拿去，',
    '民21:19 從瑪他拿到拿哈列，從拿哈列到巴末，',
    '民21:20 從巴末到摩押地的谷，又到那下望曠野之毘斯迦的山頂。',
    '民21:21 以色列人差遣使者去見亞摩利人的王西宏，說：',
    '民21:22 求你容我們從你的地經過；我們不偏入田間和葡萄園，也不喝井裡的水，只走大道（原文作王道），直到過了你的境界。',
    '民21:23 西宏不容以色列人從他的境界經過，就招聚他的眾民出到曠野，要攻擊以色列人，到了雅雜與以色列人爭戰。',
    '民21:24 以色列人用刀殺了他，得了他的地，從亞嫩河到雅博河，直到亞捫人的境界，因為亞捫人的境界多有堅壘。',
    '民21:25 以色列人奪取這一切的城邑，也住亞摩利人的城邑，就是希實本與希實本的一切鄉村。',
    '民21:26 這希實本是亞摩利王西宏的京城；西宏曾與摩押的先王爭戰，從他手中奪取了全地，直到亞嫩河。',
    '民21:27 所以那些作詩歌的說：你們來到希實本；願西宏的城被修造，被建立。',
    '民21:28 因為有火從希實本發出，有火焰出於西宏的城，燒盡摩押的亞珥和亞嫩河邱壇的祭司（祭司原文作主）。',
    '民21:29 摩押啊，你有禍了！基抹的民哪，你們滅亡了！基抹的男子逃奔，女子被擄，交付亞摩利的王西宏。',
    '民21:30 我們射了他們；希實本直到底本盡皆毀滅。我們使地變成荒場，直到挪法；這挪法直延到米底巴。',
    '民21:31 這樣，以色列人就住在亞摩利人之地。',
    '民21:32 摩西打發人去窺探雅謝，以色列人就佔了雅謝的鎮市，趕出那裡的亞摩利人。',
    '民21:33 以色列人轉回，向巴珊去。巴珊王噩和他的眾民都出來，在以得來與他們交戰。',
    '民21:34 耶和華對摩西說：不要怕他！因我已將他和他的眾民，並他的地，都交在你手中；你要待他像從前待住希實本的亞摩利王西宏一般。',
    '民21:35 於是他們殺了他和他的眾子，並他的眾民，沒有留下一個，就得了他的地。',
    '民22:1 以色列人起行，在摩押平原、約但河東，對著耶利哥安營。',
    '民22:2 以色列人向亞摩利人所行的一切事，西撥的兒子巴勒都看見了。',
    '民22:3 摩押人因以色列民甚多，就大大懼怕，心內憂急，',
    '民22:4 對米甸的長老說：現在這眾人要把我們四圍所有的一概餂盡，就如牛餂盡田間的草一般。那時西撥的兒子巴勒作摩押王。',
    '民22:5 他差遣使者往大河邊的毘奪去，到比珥的兒子巴蘭本鄉那裡，召巴蘭來，說：有一宗民從埃及出來，遮滿地面，與我對居。',
    '民22:6 這民比我強盛，現在求你來為我咒詛他們，或者我能得勝，攻打他們，趕出此地。因為我知道，你為誰祝福，誰就得福；你咒詛誰，誰就受咒詛。',
    '民22:7 摩押的長老和米甸的長老手裡拿著卦金，到了巴蘭那裡，將巴勒的話都告訴了他。',
    '民22:8 巴蘭說：你們今夜在這裡住宿，我必照耶和華所曉諭我的回報你們。摩押的使臣就在巴蘭那裡住下了。',
    '民22:9 神臨到巴蘭那裡，說：在你這裡的人都是誰﹖',
    '民22:10 巴蘭回答說：是摩押王西撥的兒子巴勒打發人到我這裡來，說：',
    '民22:11 從埃及出來的民遮滿地面，你來為我咒詛他們，或者我能與他們爭戰，把他們趕出去。',
    '民22:12 神對巴蘭說：你不可同他們去，也不可咒詛那民，因為那民是蒙福的。',
    '民22:13 巴蘭早晨起來，對巴勒的使臣說：你們回本地去吧，因為耶和華不容我和你們同去。',
    '民22:14 摩押的使臣就起來，回巴勒那裡去，說：巴蘭不肯和我們同來。',
    '民22:15 巴勒又差遣使臣，比先前的又多又尊貴。',
    '民22:16 他們到了巴蘭那裡，對他說：西撥的兒子巴勒這樣說：求你不容什麼事攔阻你不到我這裡來，',
    '民22:17 因為我必使你得極大的尊榮。你向我要什麼，我就給你什麼；只求你來為我咒詛這民。',
    '民22:18 巴蘭回答巴勒的臣僕說：巴勒就是將他滿屋的金銀給我，我行大事小事也不得越過耶和華─我神的命。',
    '民22:19 現在我請你們今夜在這裡住宿，等我得知耶和華還要對我說什麼。',
    '民22:20 當夜，神臨到巴蘭那裡，說：這些人若來召你，你就起來同他們去，你只要遵行我對你所說的話。',
    '民22:21 巴蘭早晨起來，備上驢，和摩押的使臣一同去了。',
    '民22:22 神因他去就發了怒；耶和華的使者站在路上敵擋他。他騎著驢，有兩個僕人跟隨他。',
    '民22:23 驢看見耶和華的使者站在路上，手裡有拔出來的刀，就從路上跨進田間，巴蘭便打驢，要叫他回轉上路。',
    '民22:24 耶和華的使者就站在葡萄園的窄路上；這邊有牆，那邊也有牆。',
    '民22:25 驢看見耶和華的使者，就貼靠牆，將巴蘭的腳擠傷了；巴蘭又打驢。',
    '民22:26 耶和華的使者又往前去，站在狹窄之處，左右都沒有轉折的地方。',
    '民22:27 驢看見耶和華的使者，就臥在巴蘭底下，巴蘭發怒，用杖打驢。',
    '民22:28 耶和華叫驢開口，對巴蘭說：我向你行了什麼，你竟打我這三次呢﹖',
    '民22:29 巴蘭對驢說：因為你戲弄我，我恨不能手中有刀，把你殺了。',
    '民22:30 驢對巴蘭說：我不是你從小時直到今日所騎的驢嗎﹖我素常向你這樣行過嗎﹖巴蘭說：沒有。',
    '民22:31 當時，耶和華使巴蘭的眼目明亮，他就看見耶和華的使者站在路上，手裡有拔出來的刀，巴蘭便低頭俯伏在地。',
    '民22:32 耶和華的使者對他說：你為何這三次打你的驢呢﹖我出來敵擋你，因你所行的，在我面前偏僻。',
    '民22:33 驢看見我就三次從我面前偏過去；驢若沒有偏過去，我早把你殺了，留他存活。',
    '民22:34 巴蘭對耶和華的使者說：我有罪了。我不知道你站在路上阻擋我；你若不喜歡我去，我就轉回。',
    '民22:35 耶和華的使者對巴蘭說：你同這些人去吧！你只要說我對你說的話。於是巴蘭同著巴勒的使臣去了。',
    '民22:36 巴勒聽見巴蘭來了，就往摩押京城去迎接他；這城是在邊界上，在亞嫩河旁。',
    '民22:37 巴勒對巴蘭說：我不是急急地打發人到你那裡去召你嗎﹖你為何不到我這裡來呢﹖我豈不能使你得尊榮嗎﹖',
    '民22:38 巴蘭說：我已經到你這裡來了！現在我豈能擅自說什麼呢﹖神將什麼話傳給我，我就說什麼。',
    '民22:39 巴蘭和巴勒同行，來到基列胡瑣。',
    '民22:40 巴勒宰了（原文作獻）牛羊，送給巴蘭和陪伴的使臣。',
    '民22:41 到了早晨，巴勒領巴蘭到巴力的高處；巴蘭從那裡觀看以色列營的邊界。',
    '民23:1 巴蘭對巴勒說：你在這裡給我築七座壇，為我預備七隻公牛，七隻公羊。',
    '民23:2 巴勒照巴蘭的話行了。巴勒和巴蘭在每座壇上獻一隻公牛，一隻公羊。',
    '民23:3 巴蘭對巴勒說：你站在你的燔祭旁邊，我且往前去，或者耶和華來迎見我。他指示我什麼，我必告訴你。於是巴蘭上一淨光的高處。',
    '民23:4 神迎見巴蘭；巴蘭說：我預備了七座壇，在每座壇上獻了一隻公牛，一隻公羊。',
    '民23:5 耶和華將話傳給巴蘭，又說：你回到巴勒那裡，要如此如此說。',
    '民23:6 他就回到巴勒那裡，見他同摩押的使臣都站在燔祭旁邊。',
    '民23:7 巴蘭便題起詩歌說：巴勒引我出亞蘭，摩押王引我出東山，說：來啊，為我咒詛雅各；來啊，怒罵以色列。',
    '民23:8 神沒有咒詛的，我焉能咒詛﹖耶和華沒有怒罵的，我焉能怒罵﹖',
    '民23:9 我從高峰看他，從小山望他；這是獨居的民，不列在萬民中。',
    '民23:10 誰能數點雅各的塵土﹖誰能計算以色列的四分之一﹖我願如義人之死而死；我願如義人之終而終。',
    '民23:11 巴勒對巴蘭說：你向我做的是什麼事呢﹖我領你來咒詛我的仇敵，不料，你竟為他們祝福。',
    '民23:12 他回答說：耶和華傳給我的話，我能不謹慎傳說嗎﹖',
    '民23:13 巴勒說：求你同我往別處去，在那裡可以看見他們；你不能全看見，只能看見他們邊界上的人。在那裡要為我咒詛他們。',
    '民23:14 於是領巴蘭到了瑣腓田，上了毘斯迦山頂，築了七座壇；每座壇上獻一隻公牛，一隻公羊。',
    '民23:15 巴蘭對巴勒說：你站在這燔祭旁邊，等我往那邊去迎見耶和華。',
    '民23:16 耶和華臨到巴蘭那裡，將話傳給他；又說：你回到巴勒那裡，要如此如此說。',
    '民23:17 他就回到巴勒那裡，見他站在燔祭旁邊；摩押的使臣也和他在一處。巴勒問他說：耶和華說了什麼話呢﹖',
    '民23:18 巴蘭就題詩歌說：巴勒，你起來聽；西撥的兒子，你聽我言。',
    '民23:19 神非人，必不致說謊，也非人子，必不致後悔。他說話豈不照著行呢﹖他發言豈不要成就呢﹖',
    '民23:20 我奉命祝福；神也曾賜福，此事我不能翻轉。',
    '民23:21 他未見雅各中有罪孽，也未見以色列中有奸惡。耶和華─他的神和他同在；有歡呼王的聲音在他們中間。',
    '民23:22 神領他們出埃及；他們似乎有野牛之力。',
    '民23:23 斷沒有法術可以害雅各，也沒有占卜可以害以色列。現在必有人論及雅各，就是論及以色列說：神為他行了何等的大事！',
    '民23:24 這民起來，彷彿母獅，挺身，好像公獅，未曾吃野食，未曾喝被傷者之血，決不躺臥。',
    '民23:25 巴勒對巴蘭說：你一點不要咒詛他們，也不要為他們祝福。',
    '民23:26 巴蘭回答巴勒說：我豈不是告訴你說凡耶和華所說的，我必須遵行嗎﹖',
    '民23:27 巴勒對巴蘭說：來吧，我領你往別處去，或者神喜歡你在那裡為我咒詛他們。',
    '民23:28 巴勒就領巴蘭到那下望曠野的毘珥山頂上。',
    '民23:29 巴蘭對巴勒說：你在這裡為我築七座壇，又在這裡為我預備七隻公牛，七隻公羊。',
    '民23:30 巴勒就照巴蘭的話行，在每座壇上獻一隻公牛，一隻公羊。',
    '民24:1 巴蘭見耶和華喜歡賜福與以色列，就不像前兩次去求法術，卻面向曠野。',
    '民24:2 巴蘭舉目，看見以色列人照著支派居住。神的靈就臨到他身上，',
    '民24:3 他便題起詩歌說：比珥的兒子巴蘭說，眼目閉住（閉住或作：睜開）的人說，',
    '民24:4 得聽神的言語，得見全能者的異象，眼目睜開而仆倒的人說：',
    '民24:5 雅各啊，你的帳棚何等華美！以色列啊，你的帳幕何其華麗！',
    '民24:6 如接連的山谷，如河旁的園子，如耶和華所栽的沉香樹，如水邊的香柏木。',
    '民24:7 水要從他的桶裡流出；種子要撒在多水之處。他的王必超過亞甲；他的國必要振興。',
    '民24:8 神領他出埃及；他似乎有野牛之力。他要吞吃敵國，折斷他們的骨頭，用箭射透他們。',
    '民24:9 他蹲如公獅，臥如母獅，誰敢惹他﹖凡給你祝福的，願他蒙福；凡咒詛你的，願他受咒詛。',
    '民24:10 巴勒向巴蘭生氣，就拍起手來，對巴蘭說：我召你來為我咒詛仇敵，不料，你這三次竟為他們祝福。',
    '民24:11 如今你快回本地去吧！我想使你得大尊榮，耶和華卻阻止你不得尊榮。',
    '民24:12 巴蘭對巴勒說：我豈不是對你所差遣到我那裡的使者說：',
    '民24:13 巴勒就是將他滿屋的金銀給我，我也不得越過耶和華的命，憑自己的心意行好行歹。耶和華說什麼，我就要說什麼﹖',
    '民24:14 現在我要回本族去。你來，我告訴你這民日後要怎樣待你的民。',
    '民24:15 他就題起詩歌說：比珥的兒子巴蘭說：眼目閉住（閉住或作：睜開）的人說，',
    '民24:16 得聽神的言語，明白至高者的意旨，看見全能者的異象，眼目睜開而仆倒的人說：',
    '民24:17 我看他卻不在現時；我望他卻不在近日。有星要出於雅各，有杖要興於以色列，必打破摩押的四角，毀壞擾亂之子。',
    '民24:18 他必得以東為基業，又得仇敵之地西珥為產業；以色列必行事勇敢。',
    '民24:19 有一位出於雅各的，必掌大權；他要除滅城中的餘民。',
    '民24:20 巴蘭觀看亞瑪力，就題起詩歌說：亞瑪力原為諸國之首，但他終必沉淪。',
    '民24:21 巴蘭觀看基尼人，就題起詩歌說：你的住處本是堅固；你的窩巢做在巖穴中。',
    '民24:22 然而基尼必至衰微，直到亞述把你擄去。',
    '民24:23 巴蘭又題起詩歌說：哀哉！神行這事，誰能得活﹖',
    '民24:24 必有人乘船從基提界而來，苦害亞述，苦害希伯；他也必至沉淪。',
    '民24:25 於是巴蘭起來，回他本地去；巴勒也回去了。',
    '民25:1 以色列人住在什亭，百姓與摩押女子行起淫亂。',
    '民25:2 因為這女子叫百姓來，一同給他們的神獻祭，百姓就吃他們的祭物，跪拜他們的神。',
    '民25:3 以色列人與巴力毘珥連合，耶和華的怒氣就向以色列人發作。',
    '民25:4 耶和華吩咐摩西說：將百姓中所有的族長在我面前對著日頭懸掛，使我向以色列人所發的怒氣可以消了。',
    '民25:5 於是摩西吩咐以色列的審判官說：凡屬你們的人，有與巴力毘珥連合的，你們各人要把他們殺了。',
    '民25:6 摩西和以色列全會眾正在會幕門前哭泣的時候，誰知，有以色列中的一個人，當他們眼前，帶著一個米甸女人到他弟兄那裡去。',
    '民25:7 祭司亞倫的孫子，以利亞撒的兒子非尼哈看見了，就從會中起來，手裡拿著槍，',
    '民25:8 跟隨那以色列人進亭子裡去，便將以色列人和那女人由腹中刺透。這樣，在以色列人中瘟疫就止息了。',
    '民25:9 那時遭瘟疫死的，有二萬四千人。',
    '民25:10 耶和華曉諭摩西說：',
    '民25:11 祭司亞倫的孫子，以利亞撒的兒子非尼哈，使我向以色列人所發的怒消了；因他在他們中間，以我的忌邪為心，使我不在忌邪中把他們除滅。',
    '民25:12 因此，你要說：我將我平安的約賜給他。',
    '民25:13 這約要給他和他的後裔，作為永遠當祭司職任的約；因他為神有忌邪的心，為以色列人贖罪。',
    '民25:14 那與米甸女人一同被殺的以色列人，名叫心利，是撒路的兒子，是西緬一個宗族的首領。',
    '民25:15 那被殺的米甸女人，名叫哥斯比，是蘇珥的女兒；這蘇珥是米甸一個宗族的首領。',
    '民25:16 耶和華曉諭摩西說：',
    '民25:17 你要擾害米甸人，擊殺他們；',
    '民25:18 因為他們用詭計擾害你們，在毘珥的事上和他們的姊妹、米甸首領的女兒哥斯比的事上，用這詭計誘惑了你們；這哥斯比，當瘟疫流行的日子，因毘珥的事被殺了。',
    '民26:1 瘟疫之後，耶和華曉諭摩西和祭司亞倫的兒子以利亞撒說：',
    '民26:2 你們要將以色列全會眾，按他們的宗族，凡以色列中從二十歲以外、能出去打仗的，計算總數。',
    '民26:3 摩西和祭司以利亞撒在摩押平原與耶利哥相對的約但河邊向以色列人說：',
    '民26:4 將你們中間從二十歲以外的計算總數；是照耶和華吩咐出埃及地的摩西和以色列人的話。',
    '民26:5 以色列的長子是流便。流便的眾子：屬哈諾的，有哈諾族；屬法路的，有法路族；',
    '民26:6 屬希斯倫的，有希斯倫族；屬迦米的，有迦米族；',
    '民26:7 這就是流便的各族；其中被數的，共有四萬三千七百三十名。',
    '民26:8 法路的兒子是以利押。',
    '民26:9 以利押的眾子是尼母利、大坍、亞比蘭。這大坍、亞比蘭，就是從會中選召的，與可拉一黨同向耶和華爭鬧的時候也向摩西、亞倫爭鬧；',
    '民26:10 地便開口吞了他們，和可拉、可拉的黨類一同死亡。那時火燒滅了二百五十個人；他們就作了警戒。',
    '民26:11 然而可拉的眾子沒有死亡。',
    '民26:12 按著家族，西緬的眾子：屬尼母利的，有尼母利族；屬雅憫的，有雅憫族；屬雅斤的，有雅斤族；',
    '民26:13 屬謝拉的，有謝拉族；屬掃羅的，有掃羅族。',
    '民26:14 這就是西緬的各族，共有二萬二千二百名。',
    '民26:15 按著家族，迦得的眾子：屬洗分的，有洗分族；屬哈基的，有哈基族；屬書尼的，有書尼族；',
    '民26:16 屬阿斯尼的，有阿斯尼族；屬以利的，有以利族；',
    '民26:17 屬亞律的，有亞律族；屬亞列利的，有亞列利族。',
    '民26:18 這就是迦得子孫的各族，照他們中間被數的，共有四萬零五百名。',
    '民26:19 猶大的兒子是珥和俄南。這珥和俄南死在迦南地。',
    '民26:20 按著家族，猶大其餘的眾子：屬示拉的，有示拉族；屬法勒斯的，有法勒斯族；屬謝拉的有謝拉族。',
    '民26:21 法勒斯的兒子：屬希斯倫的，有希斯倫族；屬哈母勒的，有哈母勒族。',
    '民26:22 這就是猶大的各族，照他們中間被數的，共有七萬六千五百名。',
    '民26:23 按著家族，以薩迦的眾子：屬陀拉的，有陀拉族；屬普瓦的，有普瓦族；',
    '民26:24 屬雅述的，有雅述族；屬伸崙的，有伸崙族。',
    '民26:25 這就是以薩迦的各族，照他們中間被數的，共有六萬四千三百名。',
    '民26:26 按著家族，西布倫的眾子：屬西烈的，有西烈族；屬以倫的，有以倫族；屬雅利的，有雅利族。',
    '民26:27 這就是西布倫的各族，照他們中間被數的，共有六萬零五百名。',
    '民26:28 按著家族，約瑟的兒子有瑪拿西、以法蓮。',
    '民26:29 瑪拿西的眾子：屬瑪吉的，有瑪吉族；瑪吉生基列；屬基列的，有基列族。',
    '民26:30 基列的眾子：屬伊以謝的，有伊以謝族；屬希勒的，有希勒族；',
    '民26:31 屬亞斯烈的，有亞斯烈族；屬示劍的，有示劍族；',
    '民26:32 屬示米大的，有示米大族；屬希弗的，有希弗族。',
    '民26:33 希弗的兒子：西羅非哈沒兒子，只有女兒。西羅非哈女兒的名字就是瑪拉、挪阿、曷拉、密迦、得撒。',
    '民26:34 這就是瑪拿西的各族；他們中間被數的，共有五萬二千七百名。',
    '民26:35 按著家族，以法蓮的眾子：屬書提拉的，有書提拉族；屬比結的，有比結族；屬他罕的，有他罕族。',
    '民26:36 書提拉的眾子：屬以蘭的，有以蘭族。',
    '民26:37 這就是以法蓮子孫的各族，照他們中間被數的，共有三萬二千五百名。按著家族，這都是約瑟的子孫。',
    '民26:38 按著家族，便雅憫的眾子：屬比拉的，有比拉族；屬亞實別的，有亞實別族；屬亞希蘭的，有亞希蘭族；',
    '民26:39 屬書反的，有書反族；屬戶反的，有戶反族。',
    '民26:40 比拉的眾子是亞勒、乃幔。屬亞勒的，有亞勒族；屬乃幔的，有乃幔族。',
    '民26:41 按著家族，這就是便雅憫的子孫，其中被數的，共有四萬五千六百名。',
    '民26:42 按著家族，但的眾子：屬書含的，有書含族。按著家族，這就是但的各族。',
    '民26:43 照其中被數的，書含所有的各族，共有六萬四千四百名。',
    '民26:44 按著家族，亞設的眾子：屬音拿的，有音拿族；屬亦施韋的，有亦施韋族；屬比利亞的，有比利亞族。',
    '民26:45 比利亞的眾子：屬希別的，有希別族；屬瑪結的，有瑪結族。',
    '民26:46 亞設的女兒名叫西拉。',
    '民26:47 這就是亞設子孫的各族，照他們中間被數的，共有五萬三千四百名。',
    '民26:48 按著家族，拿弗他利的眾子：屬雅薛的，有雅薛族；屬沽尼的，有沽尼族；',
    '民26:49 屬耶色的，有耶色族；屬示冷的，有示冷族。',
    '民26:50 按著家族，這就是拿弗他利的各族；他們中間被數的，共有四萬五千四百名。',
    '民26:51 以色列人中被數的，共有六十萬零一千七百三十名。',
    '民26:52 耶和華曉諭摩西說：',
    '民26:53 你要按著人名的數目將地分給這些人為業。',
    '民26:54 人多的，你要把產業多分給他們；人少的，你要把產業少分給他們；要照被數的人數，把產業分給各人。',
    '民26:55 雖是這樣，還要拈鬮分地。他們要按著祖宗各支派的名字承受為業。',
    '民26:56 要按著所拈的鬮，看人數多，人數少，把產業分給他們。',
    '民26:57 利未人，按著他們的各族被數的：屬革順的，有革順族；屬哥轄的，有哥轄族；屬米拉利的，有米拉利族。',
    '民26:58 利未的各族有立尼族、希伯倫族、瑪利族、母示族、可拉族。哥轄生暗蘭。',
    '民26:59 暗蘭的妻名叫約基別，是利未女子，生在埃及。他給暗蘭生了亞倫、摩西，並他們的姊姊米利暗。',
    '民26:60 亞倫生拿答、亞比戶、以利亞撒、以他瑪。',
    '民26:61 拿答、亞比戶在耶和華面前獻凡火的時候就死了。',
    '民26:62 利未人中，凡一個月以外、被數的男丁，共有二萬三千。他們本來沒有數在以色列人中；因為在以色列人中，沒有分給他們產業。',
    '民26:63 這些就是被摩西和祭司以利亞撒所數的；他們在摩押平原與耶利哥相對的約但河邊數點以色列人。',
    '民26:64 但被數的人中，沒有一個是摩西和祭司亞倫從前在西乃的曠野所數的以色列人，',
    '民26:65 因為耶和華論到他們說：他們必要死在曠野。所以，除了耶孚尼的兒子迦勒和嫩的兒子約書亞以外，連一個人也沒有存留。',
    '民27:1 屬約瑟的兒子瑪拿西的各族，有瑪拿西的玄孫，瑪吉的曾孫，基列的孫子，希弗的兒子西羅非哈的女兒，名叫瑪拉、挪阿、曷拉、密迦、得撒。他們前來，',
    '民27:2 站在會幕門口，在摩西和祭司以利亞撒，並眾首領與全會眾面前，說：',
    '民27:3 我們的父親死在曠野。他不與可拉同黨聚集攻擊耶和華，是在自己罪中死的；他也沒有兒子。',
    '民27:4 為什麼因我們的父親沒有兒子就把他的名從他族中除掉呢﹖求你們在我們父親的弟兄中分給我們產業。',
    '民27:5 於是，摩西將他們的案件呈到耶和華面前。',
    '民27:6 耶和華曉諭摩西說：',
    '民27:7 西羅非哈的女兒說得有理。你定要在他們父親的弟兄中，把地分給他們為業；要將他們父親的產業歸給他們。',
    '民27:8 你也要曉諭以色列人說：人若死了沒有兒子，就要把他的產業歸給他的女兒。',
    '民27:9 他若沒有女兒，就要把他的產業給他的弟兄。',
    '民27:10 他若沒有弟兄，就要把他的產業給他父親的弟兄。',
    '民27:11 他父親若沒有弟兄，就要把他的產業給他族中最近的親屬，他便要得為業。這要作以色列人的律例典章，是照耶和華吩咐摩西的。',
    '民27:12 耶和華對摩西說：你上這亞巴琳山，觀看我所賜給以色列人的地。',
    '民27:13 看了以後，你也必歸到你列祖（原文作本民）那裡，像你哥哥亞倫一樣。',
    '民27:14 因為你們在尋的曠野，當會眾爭鬧的時候，違背了我的命，沒有在湧水之地、會眾眼前尊我為聖。（這水就是尋的曠野加低斯米利巴水。）',
    '民27:15 摩西對耶和華說：',
    '民27:16 願耶和華萬人之靈的神，立一個人治理會眾，',
    '民27:17 可以在他們面前出入，也可以引導他們，免得耶和華的會眾如同沒有牧人的羊群一般。',
    '民27:18 耶和華對摩西說：嫩的兒子約書亞是心中有聖靈的；你將他領來，按手在他頭上，',
    '民27:19 使他站在祭司以利亞撒和全會眾面前，囑咐他，',
    '民27:20 又將你的尊榮給他幾分，使以色列全會眾都聽從他。',
    '民27:21 他要站在祭司以利亞撒面前；以利亞撒要憑烏陵的判斷，在耶和華面前為他求問。他和以色列全會眾都要遵以利亞撒的命出入。',
    '民27:22 於是摩西照耶和華所吩咐的將約書亞領來，使他站在祭司以利亞撒和全會眾面前。',
    '民27:23 按手在他頭上，囑咐他，是照耶和華藉摩西所說的話。',
    '民28:1 耶和華曉諭摩西說：',
    '民28:2 你要吩咐以色列人說：獻給我的供物，就是獻給我作馨香火祭的食物，你們要按日期獻給我；',
    '民28:3 又要對他們說：你們要獻給耶和華的火祭，就是沒有殘疾、一歲的公羊羔，每日兩隻，作為常獻的燔祭。',
    '民28:4 早晨要獻一隻，黃昏的時候要獻一隻；',
    '民28:5 又用細麵伊法十分之一，並搗成的油一欣四分之一，調和作為素祭。',
    '民28:6 這是西乃山所命定為常獻的燔祭，是獻給耶和華為馨香的火祭。',
    '民28:7 為這一隻羊羔，要同獻奠祭的酒一欣四分之一。在聖所中，你要將醇酒奉給耶和華為奠祭。',
    '民28:8 晚上，你要獻那一隻羊羔，必照早晨的素祭和同獻的奠祭獻上，作為馨香的火祭，獻給耶和華。',
    '民28:9 當安息日，要獻兩隻沒有殘疾、一歲的公羊羔，並用調油的細麵伊法十分之二為素祭，又將同獻的奠祭獻上。',
    '民28:10 這是每安息日獻的燔祭；那常獻的燔祭和同獻的奠祭在外。',
    '民28:11 每月朔，你們要將兩隻公牛犢，一隻公綿羊，七隻沒有殘疾、一歲的公羊羔，獻給耶和華為燔祭。',
    '民28:12 每隻公牛要用調油的細麵伊法十分之三作為素祭；那隻公羊也用調油的細麵伊法十分之二作為素祭；',
    '民28:13 每隻羊羔要用調油的細麵伊法十分之一作為素祭和馨香的燔祭，是獻給耶和華的火祭。',
    '民28:14 一隻公牛要奠酒半欣，一隻公羊要奠酒一欣三分之一，一隻羊羔也奠酒一欣四分之一。這是每月的燔祭，一年之中要月月如此。',
    '民28:15 又要將一隻公山羊為贖罪祭，獻給耶和華；要獻在常獻的燔祭和同獻的奠祭以外。',
    '民28:16 正月十四日是耶和華的逾越節。',
    '民28:17 這月十五日是節期，要吃無酵餅七日。',
    '民28:18 第一日當有聖會；什麼勞碌的工都不可做。',
    '民28:19 當將公牛犢兩隻，公綿羊一隻，一歲的公羊羔七隻，都要沒有殘疾的，用火獻給耶和華為燔祭。',
    '民28:20 同獻的素祭用調油的細麵；為一隻公牛要獻伊法十分之三；為一隻公羊要獻伊法十分之二；',
    '民28:21 為那七隻羊羔，每隻要獻伊法十分之一。',
    '民28:22 並獻一隻公山羊作贖罪祭，為你們贖罪。',
    '民28:23 你們獻這些，要在早晨常獻的燔祭以外。',
    '民28:24 一連七日，每日要照這例把馨香火祭的食物獻給耶和華，是在常獻的燔祭和同獻的奠祭以外。',
    '民28:25 第七日當有聖會，什麼勞碌的工都不可做。',
    '民28:26 七七節莊稼初熟，你們獻新素祭給耶和華的日子，當有聖會；什麼勞碌的工都不可做。',
    '民28:27 只要將公牛犢兩隻，公綿羊一隻，一歲的公羊羔七隻，作為馨香的燔祭獻給耶和華。',
    '民28:28 同獻的素祭用調油的細麵；為每隻公牛要獻伊法十分之三；為一隻公羊要獻伊法十分之二；',
    '民28:29 為那七隻羊羔，每隻要獻伊法十分之一。',
    '民28:30 並獻一隻公山羊為你們贖罪。',
    '民28:31 這些，你們要獻在常獻的燔祭和同獻的素祭並同獻的奠祭以外，都要沒有殘疾的。',
    '民29:1 七月初一日，你們當有聖會；什麼勞碌的工都不可做，是你們當守為吹角的日子。',
    '民29:2 你們要將公牛犢一隻，公綿羊一隻，沒有殘疾、一歲的公羊羔七隻，作為馨香的燔祭獻給耶和華。',
    '民29:3 同獻的素祭用調油的細麵；為一隻公牛要獻伊法十分之三；為一隻公羊要獻伊法十分之二；',
    '民29:4 為那七隻羊羔，每隻要獻伊法十分之一。',
    '民29:5 又獻一隻公山羊作贖罪祭，為你們贖罪。',
    '民29:6 這些是在月朔的燔祭和同獻的素祭，並常獻的燔祭與同獻的素祭，以及照例同獻的奠祭以外，都作為馨香的火祭獻給耶和華。',
    '民29:7 七月初十日，你們當有聖會；要刻苦己心，什麼工都不可做。',
    '民29:8 只要將公牛犢一隻，公綿羊一隻，一歲的公羊羔七隻，都要沒有殘疾的，作為馨香的燔祭獻給耶和華。',
    '民29:9 同獻的素祭用調油的細麵：為一隻公牛要獻伊法十分之三；為一隻公羊要獻伊法十分之二；',
    '民29:10 為那七隻羊羔，每隻要獻伊法十分之一。',
    '民29:11 又獻一隻公山羊為贖罪祭。這是在贖罪祭和常獻的燔祭，與同獻的素祭並同獻的奠祭以外。',
    '民29:12 七月十五日，你們當有聖會；什麼勞碌的工都不可做，要向耶和華守節七日。',
    '民29:13 又要將公牛犢十三隻，公綿羊兩隻，一歲的公羊羔十四隻，都要沒有殘疾的，用火獻給耶和華為馨香的燔祭。',
    '民29:14 同獻的素祭用調油的細麵；為那十三隻公牛，每隻要獻伊法十分之三；為那兩隻公羊，每隻要獻伊法十分之二；',
    '民29:15 為那十四隻羊羔，每隻要獻伊法十分之一。',
    '民29:16 並獻一隻公山羊為贖罪祭，這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:17 第二日要獻公牛犢十二隻，公綿羊兩隻，沒有殘疾、一歲的公羊羔十四隻；',
    '民29:18 並為公牛、公羊，和羊羔，按數照例，獻同獻的素祭和同獻的奠祭。',
    '民29:19 又要獻一隻公山羊為贖罪祭。這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:20 第三日要獻公牛十一隻，公羊兩隻，沒有殘疾、一歲的公羊羔十四隻；',
    '民29:21 並為公牛、公羊，和羊羔，按數照例，獻同獻的素祭和同獻的奠祭。',
    '民29:22 又要獻一隻公山羊為贖罪祭。這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:23 第四日要獻公牛十隻，公羊兩隻，沒有殘疾、一歲的公羊羔十四隻；',
    '民29:24 並為公牛、公羊，和羊羔，按數照例，獻同獻的素祭和同獻的奠祭。',
    '民29:25 又要獻一隻公山羊為贖罪祭。這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:26 第五日要獻公牛九隻，公羊兩隻，沒有殘疾、一歲的公羊羔十四隻；',
    '民29:27 並為公牛、公羊，和羊羔，按數照例，獻同獻的素祭和同獻的奠祭。',
    '民29:28 又要獻一隻公山羊為贖罪祭。這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:29 第六日要獻公牛八隻，公羊兩隻，沒有殘疾、一歲的公羊羔十四隻；',
    '民29:30 並為公牛、公羊，和羊羔，按數照例，獻同獻的素祭和同獻的奠祭。',
    '民29:31 又要獻一隻公山羊為贖罪祭。這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:32 第七日要獻公牛七隻，公羊兩隻，沒有殘疾、一歲的公羊羔十四隻；',
    '民29:33 並為公牛、公羊，和羊羔，按數照例，獻同獻的素祭和同獻的奠祭。',
    '民29:34 又要獻一隻公山羊為贖罪祭。這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:35 第八日你們當有嚴肅會；什麼勞碌的工都不可做；',
    '民29:36 只要將公牛一隻，公羊一隻，沒有殘疾、一歲的公羊羔七隻作火祭，獻給耶和華為馨香的燔祭；',
    '民29:37 並為公牛、公羊，和羊羔，按數照例，獻同獻的素祭和同獻的奠祭。',
    '民29:38 又要獻一隻公山羊為贖罪祭。這是在常獻的燔祭和同獻的素祭並同獻的奠祭以外。',
    '民29:39 這些祭要在你們的節期獻給耶和華，都在所許的願並甘心所獻的以外，作為你們的燔祭、素祭、奠祭，和平安祭。',
    '民29:40 於是，摩西照耶和華所吩咐他的一切話告訴以色列人。',
    '民30:1 摩西曉諭以色列各支派的首領說：耶和華所吩咐的乃是這樣：',
    '民30:2 人若向耶和華許願或起誓，要約束自己，就不可食言，必要按口中所出的一切話行。',
    '民30:3 女子年幼、還在父家的時候，若向耶和華許願，要約束自己，',
    '民30:4 他父親也聽見他所許的願並約束自己的話，卻向他默默不言，他所許的願並約束自己的話就都要為定。',
    '民30:5 但他父親聽見的日子若不應承他所許的願和約束自己的話，就都不得為定；耶和華也必赦免他，因為他父親不應承。',
    '民30:6 他若出了嫁，有願在身，或是口中出了約束自己的冒失話，',
    '民30:7 他丈夫聽見的日子，卻向他默默不言，他所許的願並約束自己的話就都要為定。',
    '民30:8 但他丈夫聽見的日子，若不應承，就算廢了他所許的願和他出口約束自己的冒失話；耶和華也必赦免他。',
    '民30:9 寡婦或是被休的婦人所許的願，就是他約束自己的話，都要為定。',
    '民30:10 他若在丈夫家裡許了願或起了誓，約束自己，',
    '民30:11 丈夫聽見，卻向他默默不言，也沒有不應承，他所許的願並約束自己的話就都要為定。',
    '民30:12 丈夫聽見的日子，若把這兩樣全廢了，婦人口中所許的願或是約束自己的話就都不得為定，因他丈夫已經把這兩樣廢了；耶和華也必赦免他。',
    '民30:13 凡他所許的願和刻苦約束自己所起的誓，他丈夫可以堅定，也可以廢去。',
    '民30:14 倘若他丈夫天天向他默默不言，就算是堅定他所許的願和約束自己的話；因丈夫聽見的日子向他默默不言，就使這兩樣堅定。',
    '民30:15 但他丈夫聽見以後，若使這兩樣全廢了，就要擔當婦人的罪孽。',
    '民30:16 這是丈夫待妻子，父親待女兒，女兒年幼、還在父家，耶和華所吩咐摩西的律例。',
    '民31:1 耶和華吩咐摩西說：',
    '民31:2 你要在米甸人身上報以色列人的仇，後來要歸到你列祖（原文作本民）那裡。',
    '民31:3 摩西吩咐百姓說：要從你們中間叫人帶兵器出去攻擊米甸，好在米甸人身上為耶和華報仇。',
    '民31:4 從以色列眾支派中，每支派要打發一千人去打仗。',
    '民31:5 於是從以色列千萬人中，每支派交出一千人，共一萬二千人，帶著兵器預備打仗。',
    '民31:6 摩西就打發每支派的一千人去打仗，並打發祭司以利亞撒的兒子非尼哈同去；非尼哈手裡拿著聖所的器皿和吹大聲的號筒。',
    '民31:7 他們就照耶和華所吩咐摩西的，與米甸人打仗，殺了所有的男丁。',
    '民31:8 在所殺的人中，殺了米甸的五王，就是以未、利金、蘇珥、戶珥、利巴，又用刀殺了比珥的兒子巴蘭。',
    '民31:9 以色列人擄了米甸人的婦女孩子，並將他們的牲畜、羊群，和所有的財物都奪了來，當作擄物，',
    '民31:10 又用火焚燒他們所住的城邑和所有的營寨，',
    '民31:11 把一切所奪的、所擄的，連人帶牲畜都帶了去，',
    '民31:12 將所擄的人，所奪的牲畜、財物，都帶到摩押平原，在約但河邊與耶利哥相對的營盤，交給摩西和祭司以利亞撒，並以色列的會眾。',
    '民31:13 摩西和祭司以利亞撒，並會眾一切的首領，都出到營外迎接他們。',
    '民31:14 摩西向打仗回來的軍長，就是千夫長、百夫長，發怒，',
    '民31:15 對他們說：你們要存留這一切婦女的活命嗎﹖',
    '民31:16 這些婦女因巴蘭的計謀，叫以色列人在毘珥的事上得罪耶和華，以致耶和華的會眾遭遇瘟疫。',
    '民31:17 所以，你們要把一切的男孩和所有已嫁的女子都殺了。',
    '民31:18 但女孩子中，凡沒有出嫁的，你們都可以存留他的活命。',
    '民31:19 你們要在營外駐紮七日；凡殺了人的，和一切摸了被殺的，並你們所擄來的人口，第三日，第七日，都要潔淨自己，',
    '民31:20 也要因一切的衣服、皮物、山羊毛織的物，和各樣的木器，潔淨自己。',
    '民31:21 祭司以利亞撒對打仗回來的兵丁說：耶和華所吩咐摩西律法中的條例乃是這樣：',
    '民31:22 金、銀、銅、鐵、錫、鉛，',
    '民31:23 凡能見火的，你們要叫他經火就為潔淨，然而還要用除污穢的水潔淨他；凡不能見火的，你們要叫他過水。',
    '民31:24 第七日，你們要洗衣服，就為潔淨，然後可以進營。',
    '民31:25 耶和華曉諭摩西說：',
    '民31:26 你和祭司以利亞撒，並會眾的各族長，要計算所擄來的人口和牲畜的總數。',
    '民31:27 把所擄來的分作兩半：一半歸與出去打仗的精兵，一半歸與全會眾。',
    '民31:28 又要從出去打仗所得的人口、牛、驢、羊群中，每五百取一，作為貢物奉給耶和華。',
    '民31:29 從他們一半之中，要取出來交給祭司以利亞撒，作為耶和華的舉祭。',
    '民31:30 從以色列人的一半之中，就是從人口、牛、驢、羊群、各樣牲畜中，每五十取一，交給看守耶和華帳幕的利未人。',
    '民31:31 於是摩西和祭司以利亞撒照耶和華所吩咐摩西的行了。',
    '民31:32 除了兵丁所奪的財物以外，所擄來的：羊六十七萬五千隻；',
    '民31:33 牛七萬二千隻；',
    '民31:34 驢六萬一千匹；',
    '民31:35 女人共三萬二千口，都是沒有出嫁的。',
    '民31:36 出去打仗之人的分，就是他們所得的那一半，共計羊三十三萬七千五百隻，',
    '民31:37 從其中歸耶和華為貢物的，有六百七十五隻；',
    '民31:38 牛三萬六千隻，從其中歸耶和華為貢物的，有七十二隻；',
    '民31:39 驢三萬零五百匹，從其中歸耶和華為貢物的，有六十一匹；',
    '民31:40 人一萬六千口，從其中歸耶和華的，有三十二口。',
    '民31:41 摩西把貢物，就是歸與耶和華的舉祭，交給祭司以利亞撒，是照耶和華所吩咐摩西的。',
    '民31:42 以色列人所得的那一半，就是摩西從打仗的人取來分給他們的。',
    '民31:43 （會眾的那一半有：羊三十三萬七千五百隻；',
    '民31:44 牛三萬六千隻；',
    '民31:45 驢三萬零五百匹；',
    '民31:46 人一萬六千口。）',
    '民31:47 無論是人口是牲畜，摩西每五十取一，交給看守耶和華帳幕的利未人，是照耶和華所吩咐摩西的。',
    '民31:48 帶領千軍的各軍長，就是千夫長、百夫長，都近前來見摩西，',
    '民31:49 對他說：僕人權下的兵已經計算總數，並不短少一人。',
    '民31:50 如今我們將各人所得的金器，就是腳鍊子、鐲子、打印的戒指、耳環、手釧，都送來為耶和華的供物，好在耶和華面前為我們的生命贖罪。',
    '民31:51 摩西和祭司以利亞撒就收了他們的金子，都是打成的器皿。',
    '民31:52 千夫長、百夫長所獻給耶和華為舉祭的金子共有一萬六千七百五十舍客勒。',
    '民31:53 各兵丁都為自己奪了財物。',
    '民31:54 摩西和祭司以利亞撒收了千夫長、百夫長的金子，就帶進會幕，在耶和華面前作為以色列人的記念。',
    '民32:1 流便子孫和迦得子孫的牲畜極其眾多；他們看見雅謝地和基列地是可牧放牲畜之地，',
    '民32:2 就來見摩西和祭司以利亞撒，並會眾的首領，說：',
    '民32:3 亞大錄、底本、雅謝、寧拉、希實本、以利亞利、示班、尼波、比穩，',
    '民32:4 就是耶和華在以色列會眾前面所攻取之地，是可牧放牲畜之地，你僕人也有牲畜；',
    '民32:5 又說：我們若在你眼前蒙恩，求你把這地給我們為業，不要領我們過約但河。',
    '民32:6 摩西對迦得子孫和流便子孫說：難道你們的弟兄去打仗，你們竟坐在這裡嗎﹖',
    '民32:7 你們為何使以色列人灰心喪膽、不過去進入耶和華所賜給他們的那地呢﹖',
    '民32:8 我先前從加低斯巴尼亞打發你們先祖去窺探那地，他們也是這樣行。',
    '民32:9 他們上以實各谷，去窺探那地回來的時候，使以色列人灰心喪膽，不進入耶和華所賜給他們的地。',
    '民32:10 當日，耶和華的怒氣發作，就起誓說：',
    '民32:11 凡從埃及上來、二十歲以外的人斷不得看見我對亞伯拉罕、以撒、雅各起誓應許之地，因為他們沒有專心跟從我。',
    '民32:12 惟有基尼洗族耶孚尼的兒子迦勒和嫩的兒子約書亞可以看見，因為他們專心跟從我。',
    '民32:13 耶和華的怒氣向以色列人發作，使他們在曠野飄流四十年，等到在耶和華眼前行惡的那一代人都消滅了。',
    '民32:14 誰知，你們起來接續先祖，增添罪人的數目，使耶和華向以色列大發烈怒。',
    '民32:15 你們若退後不跟從他，他還要把以色列人撇在曠野，便是你們使這眾民滅亡。',
    '民32:16 兩支派的人挨近摩西，說：我們要在這裡為牲畜壘圈，為婦人孩子造城。',
    '民32:17 我們自己要帶兵器行在以色列人的前頭，好把他們領到他們的地方；但我們的婦人孩子，因這地居民的緣故，要住在堅固的城內。',
    '民32:18 我們不回家，直等到以色列人各承受自己的產業。',
    '民32:19 我們不和他們在約但河那邊一帶之地同受產業，因為我們的產業是坐落在約但河東邊這裡。',
    '民32:20 摩西對他們說：你們若這樣行，在耶和華面前帶著兵器出去打仗，',
    '民32:21 所有帶兵器的人都要在耶和華面前過約但河，等他趕出他的仇敵，',
    '民32:22 那地被耶和華制伏了，然後你們可以回來，向耶和華和以色列才為無罪，這地也必在耶和華面前歸你們為業。',
    '民32:23 倘若你們不這樣行，就得罪耶和華，要知道你們的罪必追上你們。',
    '民32:24 如今你們口中所出的，只管去行，為你們的婦人孩子造城，為你們的羊群壘圈。',
    '民32:25 迦得子孫和流便子孫對摩西說：僕人要照我主所吩咐的去行。',
    '民32:26 我們的妻子、孩子、羊群，和所有的牲畜都要留在基列的各城。',
    '民32:27 但你的僕人，凡帶兵器的，都要照我主所說的話，在耶和華面前過去打仗。',
    '民32:28 於是，摩西為他們囑咐祭司以利亞撒和嫩的兒子約書亞，並以色列眾支派的族長，說：',
    '民32:29 迦得子孫和流便子孫，凡帶兵器在耶和華面前去打仗的，若與你們一同過約但河，那地被你們制伏了，你們就要把基列地給他們為業。',
    '民32:30 倘若他們不帶兵器和你們一同過去，就要在迦南地你們中間得產業。',
    '民32:31 迦得子孫和流便子孫回答說：耶和華怎樣吩咐僕人，僕人就怎樣行。',
    '民32:32 我們要帶兵器，在耶和華面前過去，進入迦南地，只是約但河這邊、我們所得為業之地仍歸我們。',
    '民32:33 摩西將亞摩利王西宏的國和巴珊王噩的國，連那地和周圍的城邑，都給了迦得子孫和流便子孫，並約瑟的兒子瑪拿西半個支派。',
    '民32:34 迦得子孫建造底本、亞他錄、亞羅珥、',
    '民32:35 亞他錄朔反、雅謝、約比哈、',
    '民32:36 伯寧拉、伯哈蘭，都是堅固城。他們又壘羊圈。',
    '民32:37 流便子孫建造希實本、以利亞利、基列亭、',
    '民32:38 尼波、巴力免、西比瑪（尼波、巴力免，名字是改了的），又給他們所建造的城另起別名。',
    '民32:39 瑪拿西的兒子瑪吉，他的子孫往基列去，佔了那地，趕出那裡的亞摩利人。',
    '民32:40 摩西將基列賜給瑪拿西的兒子瑪吉，他子孫就住在那裡。',
    '民32:41 瑪拿西的子孫睚珥去佔了基列的村莊，就稱這些村莊為哈倭特睚珥。',
    '民32:42 挪巴去佔了基納和基納的鄉村，就按自己的名稱基納為挪巴。',
    '民33:1 以色列人按著軍隊，在摩西、亞倫的手下出埃及地所行的路程（或作：站口；下同）記在下面。',
    '民33:2 摩西遵著耶和華的吩咐記載他們所行的路程，其路程乃是這樣：',
    '民33:3 正月十五日，就是逾越節的次日，以色列人從蘭塞起行，在一切埃及人眼前昂然無懼地出去。',
    '民33:4 那時，埃及人正葬埋他們的長子，就是耶和華在他們中間所擊殺的；耶和華也敗壞他們的神。',
    '民33:5 以色列人從蘭塞起行，安營在疏割。',
    '民33:6 從疏割起行，安營在曠野邊的以倘。',
    '民33:7 從以倘起行，轉到比哈希錄，是在巴力洗分對面，就在密奪安營。',
    '民33:8 從比哈希錄對面起行，經過海中到了書珥曠野，又在伊坦的曠野走了三天的路程，就安營在瑪拉。',
    '民33:9 從瑪拉起行，來到以琳（以琳有十二股水泉，七十棵棕樹），就在那裡安營。',
    '民33:10 從以琳起行，安營在紅海邊。',
    '民33:11 從紅海邊起行，安營在汛的曠野。',
    '民33:12 從汛的曠野起行，安營在脫加。',
    '民33:13 從脫加起行，安營在亞錄。',
    '民33:14 從亞錄起行，安營在利非訂；在那裡，百姓沒有水喝。',
    '民33:15 從利非訂起行，安營在西乃的曠野。',
    '民33:16 從西乃的曠野起行，安營在基博羅哈他瓦。',
    '民33:17 從基博羅哈他瓦起行，安營在哈洗錄。',
    '民33:18 從哈洗錄起行，安營在利提瑪。',
    '民33:19 從利提瑪起行，安營在臨門帕烈。',
    '民33:20 從臨門帕烈起行，安營在立拿。',
    '民33:21 從立拿起行，安營在勒撒。',
    '民33:22 從勒撒起行，安營在基希拉他。',
    '民33:23 從基希拉他起行，安營在沙斐山。',
    '民33:24 從沙斐山起行，安營在哈拉大。',
    '民33:25 從哈拉大起行，安營在瑪吉希錄。',
    '民33:26 從瑪吉希錄起行，安營在他哈。',
    '民33:27 從他哈起行，安營在他拉。',
    '民33:28 從他拉起行，安營在密加。',
    '民33:29 從密加起行，安營在哈摩拿。',
    '民33:30 從哈摩拿起行，安營在摩西錄。',
    '民33:31 從摩西錄起行，安營在比尼亞干。',
    '民33:32 從比尼亞干起行，安營在曷哈及甲。',
    '民33:33 從曷哈及甲起行，安營在約巴他。',
    '民33:34 從約巴他起行，安營在阿博拿。',
    '民33:35 從阿博拿起行，安營在以旬迦別。',
    '民33:36 從以旬迦別起行，安營在尋的曠野，就是加低斯。',
    '民33:37 從加低斯起行，安營在何珥山，以東地的邊界。',
    '民33:38 以色列人出了埃及地後四十年，五月初一日，祭司亞倫遵著耶和華的吩咐上何珥山，就死在那裡。',
    '民33:39 亞倫死在何珥山的時候年一百二十三歲。',
    '民33:40 住在迦南南地的迦南人亞拉得王聽說以色列人來了。',
    '民33:41 以色列人從何珥山起行，安營在撒摩拿。',
    '民33:42 從撒摩拿起行，安營在普嫩。',
    '民33:43 從普嫩起行，安營在阿伯。',
    '民33:44 從阿伯起行，安營在以耶亞巴琳，摩押的邊界。',
    '民33:45 從以耶亞巴琳起行，安營在底本迦得。',
    '民33:46 從底本迦得起行，安營在亞門低比拉太音。',
    '民33:47 從亞門低比拉太音起行，安營在尼波對面的亞巴琳山裡。',
    '民33:48 從亞巴琳山起行，安營在摩押平原─約但河邊、耶利哥對面。',
    '民33:49 他們在摩押平原沿約但河邊安營，從伯耶施末直到亞伯什亭。',
    '民33:50 耶和華在摩押平原─約但河邊、耶利哥對面曉諭摩西說：',
    '民33:51 你吩咐以色列人說：你們過約但河進迦南地的時候，',
    '民33:52 就要從你們面前趕出那裡所有的居民，毀滅他們一切鏨成的石像和他們一切鑄成的偶像，又拆毀他們一切的邱壇。',
    '民33:53 你們要奪那地，住在其中，因我把那地賜給你們為業。',
    '民33:54 你們要按家室拈鬮，承受那地；人多的，要把產業多分給他們；人少的，要把產業少分給他們。拈出何地給何人，就要歸何人。你們要按宗族的支派承受。',
    '民33:55 倘若你們不趕出那地的居民，所容留的居民就必作你們眼中的刺，肋下的荊棘，也必在你們所住的地上擾害你們。',
    '民33:56 而且我素常有意怎樣待他們，也必照樣待你們。',
    '民34:1 耶和華曉諭摩西說：',
    '民34:2 你吩咐以色列人說：你們到了迦南地，就是歸你們為業的迦南四境之地，',
    '民34:3 南角要從尋的曠野，貼著以東的邊界；南界要從鹽海東頭起，',
    '民34:4 繞到亞克拉濱坡的南邊，接連到尋，直通到加低斯巴尼亞的南邊，又通到哈薩亞達，接連到押們，',
    '民34:5 從押們轉到埃及小河，直通到海為止。',
    '民34:6 西邊要以大海為界；這就是你們的西界。',
    '民34:7 北界要從大海起，畫到何珥山，',
    '民34:8 從何珥山劃到哈馬口，通到西達達，',
    '民34:9 又通到西斐崙，直到哈薩以難。這要作你們的北界。',
    '民34:10 你們要從哈薩以難劃到示番為東界。',
    '民34:11 這界要從示番下到亞延東邊的利比拉，又要達到基尼烈湖的東邊。',
    '民34:12 這界要下到約但河，通到鹽海為止。這四圍的邊界以內，要作你們的地。',
    '民34:13 摩西吩咐以色列人說：這地就是耶和華吩咐拈鬮給九個半支派承受為業的；',
    '民34:14 因為流便支派和迦得支派按著宗族受了產業，瑪拿西半個支派也受了產業。',
    '民34:15 這兩個半支派已經在耶利哥對面、約但河東、向日出之地受了產業。',
    '民34:16 耶和華曉諭摩西說：',
    '民34:17 要給你們分地為業之人的名字是祭司以利亞撒和嫩的兒子約書亞。',
    '民34:18 又要從每支派中選一個首領幫助他們。',
    '民34:19 這些人的名字：猶大支派有耶孚尼的兒子迦勒。',
    '民34:20 西緬支派有亞米忽的兒子示母利。',
    '民34:21 便雅憫支派有基斯倫的兒子以利達。',
    '民34:22 但支派有一個首領，約利的兒子布基。',
    '民34:23 約瑟的子孫瑪拿西支派有一個首領，以弗的兒子漢聶。',
    '民34:24 以法蓮支派有一個首領，拾弗但的兒子基母利。',
    '民34:25 西布倫支派有一個首領，帕納的兒子以利撒番。',
    '民34:26 以薩迦支派有一個首領，阿散的兒子帕鐵。',
    '民34:27 亞設支派有一個首領，示羅米的兒子亞希忽。',
    '民34:28 拿弗他利支派有一個首領，亞米忽的兒子比大黑。',
    '民34:29 這些人就是耶和華所吩咐、在迦南地把產業分給以色列人的。',
    '民35:1 耶和華在摩押平原─約但河邊、耶利哥對面曉諭摩西說：',
    '民35:2 你吩咐以色列人，要從所得為業的地中把些城給利未人居住，也要把這城四圍的郊野給利未人。',
    '民35:3 這城邑要歸他們居住，城邑的郊野可以牧養他們的牛羊和各樣的牲畜，又可以安置他們的財物。',
    '民35:4 你們給利未人的郊野，要從城根起，四圍往外量一千肘。',
    '民35:5 另外東量二千肘，南量二千肘，西量二千肘，北量二千肘，為邊界，城在當中；這要歸他們作城邑的郊野。',
    '民35:6 你們給利未人的城邑，其中當有六座逃城，使誤殺人的可以逃到那裡。此外還要給他們四十二座城。',
    '民35:7 你們要給利未人的城，共有四十八座，連城帶郊野都要給他們。',
    '民35:8 以色列人所得的地業從中要把些城邑給利未人；人多的就多給，人少的就少給；各支派要按所承受為業之地把城邑給利未人。',
    '民35:9 耶和華曉諭摩西說：',
    '民35:10 你吩咐以色列人說：你們過約但河，進了迦南地，',
    '民35:11 就要分出幾座城，為你們作逃城，使誤殺人的可以逃到那裡。',
    '民35:12 這些城可以作逃避報仇人的城，使誤殺人的不至於死，等他站在會眾面前聽審判。',
    '民35:13 你們所分出來的城，要作六座逃城。',
    '民35:14 在約但河東要分出三座城，在迦南地也要分出三座城，都作逃城。',
    '民35:15 這六座城要給以色列人和他們中間的外人，並寄居的，作為逃城，使誤殺人的都可以逃到那裡。',
    '民35:16 倘若人用鐵器打人，以致打死，他就是故殺人的；故殺人的必被治死。',
    '民35:17 若用可以打死人的石頭打死了人，他就是故殺人的；故殺人的必被治死。',
    '民35:18 若用可以打死人的木器打死了人，他就是故殺人的；故殺人的必被治死。',
    '民35:19 報血仇的必親自殺那故殺人的，一遇見就殺他。',
    '民35:20 人若因怨恨把人推倒，或是埋伏往人身上扔物，以致於死，',
    '民35:21 或是因仇恨用手打人，以致於死，那打人的必被治死。他是故殺人的；報血仇的一遇見就殺他。',
    '民35:22 倘若人沒有仇恨，忽然將人推倒，或是沒有埋伏把物扔在人身上，',
    '民35:23 或是沒有看見的時候用可以打死人的石頭扔在人身上，以致於死，本來與他無仇，也無意害他。',
    '民35:24 會眾就要照典章，在打死人的和報血仇的中間審判。',
    '民35:25 會眾要救這誤殺人的脫離報血仇人的手，也要使他歸入逃城。他要住在其中，直等到受聖膏的大祭司死了。',
    '民35:26 但誤殺人的，無論什麼時候，若出了逃城的境外，',
    '民35:27 報血仇的在逃城境外遇見他，將他殺了，報血仇的就沒有流血之罪。',
    '民35:28 因為誤殺人的該住在逃城裡，等到大祭司死了。大祭司死了以後，誤殺人的才可以回到他所得為業之地。',
    '民35:29 這在你們一切的住處，要作你們世世代代的律例典章。',
    '民35:30 無論誰故殺人，要憑幾個見證人的口把那故殺人的殺了，只是不可憑一個見證的口叫人死。',
    '民35:31 故殺人、犯死罪的，你們不可收贖價代替他的命；他必被治死。',
    '民35:32 那逃到逃城的人，你們不可為他收贖價，使他在大祭司未死以先再來住在本地。',
    '民35:33 這樣，你們就不污穢所住之地，因為血是污穢地的；若有在地上流人血的，非流那殺人者的血，那地就不得潔淨（潔淨原文作贖）。',
    '民35:34 你們不可玷污所住之地，就是我住在其中之地，因為我─耶和華住在以色列人中間。',
    '民36:1 約瑟的後裔，瑪拿西的孫子，瑪吉的兒子基列，他子孫中的諸族長來到摩西和作首領的以色列人族長面前，說：',
    '民36:2 耶和華曾吩咐我主拈鬮分地給以色列人為業，我主也受了耶和華的吩咐將我們兄弟西羅非哈的產業分給他的眾女兒。',
    '民36:3 他們若嫁以色列別支派的人，就必將我們祖宗所遺留的產業加在他們丈夫支派的產業中。這樣，我們拈鬮所得的產業就要減少了。',
    '民36:4 到了以色列人的禧年，這女兒的產業就必加在他們丈夫支派的產業上。這樣，我們祖宗支派的產業就減少了。',
    '民36:5 摩西照耶和華的話吩咐以色列人說：約瑟支派的人說得有理。',
    '民36:6 論到西羅非哈的眾女兒，耶和華這樣吩咐說：他們可以隨意嫁人，只是要嫁同宗支派的人。',
    '民36:7 這樣，以色列人的產業就不從這支派歸到那支派，因為以色列人要各守各祖宗支派的產業。',
    '民36:8 凡在以色列支派中得了產業的女子必作同宗支派人的妻，好叫以色列人各自承受他祖宗的產業。',
    '民36:9 這樣，他們的產業就不從這支派歸到那支派，因為以色列支派的人要各守各的產業。',
    '民36:10 耶和華怎樣吩咐摩西，西羅非哈的眾女兒就怎樣行。',
    '民36:11 西羅非哈的女兒瑪拉、得撒、曷拉、密迦、挪阿都嫁了他們伯叔的兒子。',
    '民36:12 他們嫁入約瑟兒子、瑪拿西子孫的族中；他們的產業仍留在同宗支派中。',
    '民36:13 這是耶和華在摩押平原─約但河邊、耶利哥對面─藉著摩西所吩咐以色列人的命令典章。',
    '申1:1 以下所記的是摩西在約但河東的曠野、疏弗對面的亞拉巴─就是巴蘭、陀弗、拉班、哈洗錄、底撒哈中間─向以色列眾人所說的話。',
    '申1:2 （從何烈山經過西珥山到加低斯巴尼亞有十一天的路程。）',
    '申1:3 出埃及第四十年十一月初一日，摩西照耶和華藉著他所吩咐以色列人的話都曉諭他們。',
    '申1:4 那時，他已經擊殺了住希實本的亞摩利王西宏和住以得來、亞斯她錄的巴珊王噩。',
    '申1:5 摩西在約但河東的摩押地講律法說：',
    '申1:6 耶和華─我們的神在何烈山曉諭我們說：你們在這山上住的日子夠了；',
    '申1:7 要起行轉到亞摩利人的山地和靠近這山地的各處，就是亞拉巴、山地、高原、南地，沿海一帶迦南人的地，並利巴嫩山又到伯拉大河。',
    '申1:8 如今我將這地擺在你們面前；你們要進去得這地，就是耶和華向你們列祖亞伯拉罕、以撒、雅各起誓應許賜給他們和他們後裔為業之地。',
    '申1:9 那時，我對你們說：管理你們的重任，我獨自擔當不起。',
    '申1:10 耶和華─你們的神使你們多起來。看哪，你們今日像天上的星那樣多。',
    '申1:11 惟願耶和華─你們列祖的神使你們比如今更多千倍，照他所應許你們的話賜福與你們。',
    '申1:12 但你們的麻煩，和管理你們的重任，並你們的爭訟，我獨自一人怎能擔當得起呢﹖',
    '申1:13 你們要按著各支派選舉有智慧、有見識、為眾人所認識的，我立他們為你們的首領。',
    '申1:14 你們回答我說：照你所說的行了為妙。',
    '申1:15 我便將你們各支派的首領，有智慧、為眾人所認識的，照你們的支派，立他們為官長、千夫長、百夫長、五十夫長、十夫長，管理你們。',
    '申1:16 當時，我囑咐你們的審判官說：你們聽訟，無論是弟兄彼此爭訟，是與同居的外人爭訟，都要按公義判斷。',
    '申1:17 審判的時候，不可看人的外貌；聽訟不可分貴賤，不可懼怕人，因為審判是屬乎神的。若有難斷的案件，可以呈到我這裡，我就判斷。',
    '申1:18 那時，我將你們所當行的事都吩咐你們了。',
    '申1:19 我們照著耶和華─我們神所吩咐的從何烈山起行，經過你們所看見那大而可怕的曠野，往亞摩利人的山地去，到了加低斯巴尼亞。',
    '申1:20 我對你們說：你們已經到了耶和華─我們神所賜給我們的亞摩利人之山地。',
    '申1:21 看哪，耶和華─你的神已將那地擺在你面前，你要照耶和華─你列祖的神所說的上去得那地為業；不要懼怕，也不要驚惶。',
    '申1:22 你們都就近我來說：我們要先打發人去，為我們窺探那地，將我們上去該走何道，必進何城，都回報我們。',
    '申1:23 這話我以為美，就從你們中間選了十二個人，每支派一人。',
    '申1:24 於是他們起身上山地去，到以實各谷，窺探那地。',
    '申1:25 他們手裡拿著那地的果子下來，到我們那裡，回報說：耶和華─我們的神所賜給我們的是美地。',
    '申1:26 你們卻不肯上去，竟違背了耶和華─你們神的命令，',
    '申1:27 在帳棚內發怨言說：耶和華因為恨我們，所以將我們從埃及地領出來，要交在亞摩利人手中，除滅我們。',
    '申1:28 我們上哪裡去呢﹖我們的弟兄使我們的心消化，說那地的民比我們又大又高，城邑又廣大又堅固，高得頂天，並且我們在那裡看見亞衲族的人。',
    '申1:29 我就對你們說：不要驚恐，也不要怕他們。',
    '申1:30 在你們前面行的耶和華─你們的神必為你們爭戰，正如他在埃及和曠野，在你們眼前所行的一樣。',
    '申1:31 你們在曠野所行的路上，也曾見耶和華─你們的神撫養你們，如同人撫養兒子一般，直等你們來到這地方。',
    '申1:32 你們在這事上卻不信耶和華─你們的神。',
    '申1:33 他在路上，在你們前面行，為你們找安營的地方；夜間在火柱裡，日間在雲柱裡，指示你們所當行的路。',
    '申1:34 耶和華聽見你們這話，就發怒，起誓說：',
    '申1:35 這惡世代的人，連一個也不得見我起誓應許賜給你們列祖的美地；',
    '申1:36 惟有耶孚尼的兒子迦勒必得看見，並且我要將他所踏過的地賜給他和他的子孫，因為他專心跟從我。',
    '申1:37 耶和華為你的緣故也向我發怒，說：你必不得進入那地。',
    '申1:38 伺候你、嫩的兒子約書亞，他必得進入那地；你要勉勵他，因為他要使以色列人承受那地為業。',
    '申1:39 並且你們的婦人孩子，就是你們所說、必被擄掠的，和今日不知善惡的兒女，必進入那地。我要將那地賜給他們，他們必得為業。',
    '申1:40 至於你們，要轉回，從紅海的路往曠野去。',
    '申1:41 那時，你們回答我說：我們得罪了耶和華，情願照耶和華─我們神一切所吩咐的上去爭戰。於是你們各人帶著兵器，爭先上山地去了。',
    '申1:42 耶和華吩咐我說：你對他們說：不要上去，也不要爭戰；因我不在你們中間，恐怕你們被仇敵殺敗了。',
    '申1:43 我就告訴了你們，你們卻不聽從，竟違背耶和華的命令，擅自上山地去了。',
    '申1:44 住那山地的亞摩利人就出來攻擊你們，追趕你們，如蜂擁一般，在西珥殺退你們，直到何珥瑪。',
    '申1:45 你們便回來，在耶和華面前哭號；耶和華卻不聽你們的聲音，也不向你們側耳。',
    '申1:46 於是你們在加低斯住了許多日子。',
    '申2:1 此後，我們轉回，從紅海的路往曠野去，是照耶和華所吩咐我的。我們在西珥山繞行了許多日子。',
    '申2:2 耶和華對我說：',
    '申2:3 你們繞行這山的日子夠了，要轉向北去。',
    '申2:4 你吩咐百姓說：你們弟兄以掃的子孫住在西珥，你們要經過他們的境界。他們必懼怕你們，所以你們要分外謹慎。',
    '申2:5 不可與他們爭戰；他們的地，連腳掌可踏之處，我都不給你們，因我已將西珥山賜給以掃為業。',
    '申2:6 你們要用錢向他們買糧吃，也要用錢向他們買水喝。',
    '申2:7 因為耶和華─你的神在你手裡所辦的一切事上已賜福與你。你走這大曠野，他都知道了。這四十年，耶和華─你的神常與你同在，故此你一無所缺。',
    '申2:8 於是，我們離了我們弟兄以掃子孫所住的西珥，從亞拉巴的路，經過以拉他、以旬迦別，轉向摩押曠野的路去。',
    '申2:9 耶和華吩咐我說：不可擾害摩押人，也不可與他們爭戰。他們的地，我不賜給你為業，因我已將亞珥賜給羅得的子孫為業。',
    '申2:10 （先前，有以米人住在那裡，民數眾多，身體高大，像亞衲人一樣。',
    '申2:11 這以米人像亞衲人；也算為利乏音人；摩押人稱他們為以米人。',
    '申2:12 先前，何利人也住在西珥，但以掃的子孫將他們除滅，得了他們的地，接著居住，就如以色列在耶和華賜給他為業之地所行的一樣。）',
    '申2:13 現在，起來過撒烈溪！於是我們過了撒烈溪。',
    '申2:14 自從離開加低斯巴尼亞，到過了撒烈溪的時候，共有三十八年，等那世代的兵丁都從營中滅盡，正如耶和華向他們所起的誓。',
    '申2:15 耶和華的手也攻擊他們，將他們從營中除滅，直到滅盡。',
    '申2:16 兵丁從民中都滅盡死亡以後，',
    '申2:17 耶和華吩咐我說：',
    '申2:18 你今天要從摩押的境界亞珥經過，',
    '申2:19 走近亞捫人之地，不可擾害他們，也不可與他們爭戰。亞捫人的地，我不賜給你們為業，因我已將那地賜給羅得的子孫為業。',
    '申2:20 （那地也算為利乏音人之地，先前利乏音人住在那裡，亞捫人稱他們為散送冥。',
    '申2:21 那民眾多，身體高大，像亞衲人一樣，但耶和華從亞捫人面前除滅他們，亞捫人就得了他們的地，接著居住。',
    '申2:22 正如耶和華從前為住西珥的以掃子孫將何利人從他們面前除滅、他們得了何利人的地、接著居住一樣，直到今日。',
    '申2:23 從迦斐託出來的迦斐託人將先前住在鄉村直到迦薩的亞衛人除滅，接著居住。）',
    '申2:24 你們起來前往，過亞嫩谷；我已將亞摩利人希實本王西宏和他的地交在你手中，你要與他爭戰，得他的地為業。',
    '申2:25 從今日起，我要使天下萬民聽見你的名聲都驚恐懼怕，且因你發顫傷慟。',
    '申2:26 我從基底莫的曠野差遣使者去見希實本王西宏，用和睦的話說：',
    '申2:27 求你容我從你的地經過，只走大道，不偏左右。',
    '申2:28 你可以賣糧給我吃，也可以賣水給我喝，只要容我步行過去，',
    '申2:29 就如住西珥的以掃子孫和住亞珥的摩押人待我一樣，等我過了約但河，好進入耶和華─我們神所賜給我們的地。',
    '申2:30 但希實本王西宏不容我們從他那裡經過；因為耶和華─你的神使他心中剛硬，性情頑梗，為要將他交在你手中，像今日一樣。',
    '申2:31 耶和華對我說：從此起首，我要將西宏和他的地交給你；你要得他的地為業。',
    '申2:32 那時，西宏和他的眾民出來攻擊我們，在雅雜與我們交戰。',
    '申2:33 耶和華─我們的神將他交給我們，我們就把他和他的兒子，並他的眾民，都擊殺了。',
    '申2:34 我們奪了他的一切城邑，將有人煙的各城，連女人帶孩子，盡都毀滅，沒有留下一個。',
    '申2:35 惟有牲畜和所奪的各城，並其中的財物，都取為自己的掠物。',
    '申2:36 從亞嫩谷邊的亞羅珥和谷中的城，直到基列，耶和華─我們的神都交給我們了，沒有一座城高得使我們不能攻取的。',
    '申2:37 惟有亞捫人之地，凡靠近雅博河的地，並山地的城邑，與耶和華─我們神所禁止我們去的地方，都沒有挨近。',
    '申3:1 以後，我們轉回，向巴珊去。巴珊王噩和他的眾民都出來，在以得來與我們交戰。',
    '申3:2 耶和華對我說：不要怕他！因我已將他和他的眾民，並他的地，都交在你手中；你要待他像從前待住希實本的亞摩利王西宏一樣。',
    '申3:3 於是耶和華─我們的神也將巴珊王噩和他的眾民都交在我們手中；我們殺了他們，沒有留下一個。',
    '申3:4 那時，我們奪了他所有的城，共有六十座，沒有一座城不被我們所奪。這為亞珥歌伯的全境，就是巴珊地噩王的國。',
    '申3:5 這些城都有堅固的高牆，有門有閂。此外還有許多無城牆的鄉村。',
    '申3:6 我們將這些都毀滅了，像從前待希實本王西宏一樣，把有人煙的各城，連女人帶孩子，盡都毀滅；',
    '申3:7 惟有一切牲畜和城中的財物都取為自己的掠物。',
    '申3:8 那時，我們從約但河東兩個亞摩利王的手將亞嫩谷直到黑門山之地奪過來',
    '申3:9 （這黑門山，西頓人稱為西連，亞摩利人稱為示尼珥），',
    '申3:10 就是奪了平原的各城、基列全地、巴珊全地，直到撒迦和以得來，都是巴珊王噩國內的城邑。',
    '申3:11 （利乏音人所剩下的只有巴珊王噩。他的床是鐵的，長九肘，寬四肘，都是以人肘為度。現今豈不是在亞捫人的拉巴嗎﹖）',
    '申3:12 那時，我們得了這地。從亞嫩谷邊的亞羅珥起，我將基列山地的一半，並其中的城邑，都給了流便人和迦得人。',
    '申3:13 其餘的基列地和巴珊全地，就是噩王的國，我給了瑪拿西半支派。亞珥歌伯全地乃是巴珊全地；這叫做利乏音人之地。',
    '申3:14 瑪拿西的子孫睚珥佔了亞珥歌伯全境，直到基述人和瑪迦人的交界，就按自己的名稱這巴珊地為哈倭特睚珥，直到今日。',
    '申3:15 我又將基列給了瑪吉。',
    '申3:16 從基列到亞嫩谷，以谷中為界，直到亞捫人交界的雅博河，我給了流便人和迦得人，',
    '申3:17 又將亞拉巴和靠近約但河之地，從基尼烈直到亞拉巴海，就是鹽海，並毘斯迦山根東邊之地，都給了他們。',
    '申3:18 那時，我吩咐你們說：耶和華─你們的神已將這地賜給你們為業；你們所有的勇士都要帶著兵器，在你們的弟兄以色列人前面過去。',
    '申3:19 但你們的妻子、孩子、牲畜（我知道你們有許多的牲畜）可以住在我所賜給你們的各城裡。',
    '申3:20 等到你們弟兄在約但河那邊，也得耶和華─你們神所賜給他們的地，又使他們得享平安，與你們一樣，你們才可以回到我所賜給你們為業之地。',
    '申3:21 那時我吩咐約書亞說：你親眼看見了耶和華─你神向這二王所行的；耶和華也必向你所要去的各國照樣行。',
    '申3:22 你不要怕他們，因那為你爭戰的是耶和華─你的神。',
    '申3:23 那時，我懇求耶和華說：',
    '申3:24 主耶和華啊，你已將你的大力大能顯給僕人看。在天上，在地下，有什麼神能像你行事、像你有大能的作為呢﹖',
    '申3:25 求你容我過去，看約但河那邊的美地，就是那佳美的山地和利巴嫩。',
    '申3:26 但耶和華因你們的緣故向我發怒，不應允我，對我說：罷了！你不要向我再提這事。',
    '申3:27 你且上毘斯迦山頂去，向東、西、南、北舉目觀望，因為你必不能過這約但河。',
    '申3:28 你卻要囑咐約書亞，勉勵他，使他膽壯；因為他必在這百姓前面過去，使他們承受你所要觀看之地。',
    '申3:29 於是我們住在伯毘珥對面的谷中。',
    '申4:1 以色列人哪，現在我所教訓你們的律例典章，你們要聽從遵行，好叫你們存活，得以進入耶和華─你們列祖之神所賜給你們的地，承受為業。',
    '申4:2 所吩咐你們的話，你們不可加添，也不可刪減，好叫你們遵守我所吩咐的，就是耶和華─你們神的命令。',
    '申4:3 耶和華因巴力毘珥的事所行的，你們親眼看見了。凡隨從巴力毘珥的人，耶和華─你們的神都從你們中間除滅了。',
    '申4:4 惟有你們專靠耶和華─你們神的人，今日全都存活。',
    '申4:5 我照著耶和華─我神所吩咐的將律例典章教訓你們，使你們在所要進去得為業的地上遵行。',
    '申4:6 所以你們要謹守遵行；這就是你們在萬民眼前的智慧、聰明。他們聽見這一切律例，必說：這大國的人真是有智慧，有聰明！',
    '申4:7 哪一大國的人有神與他們相近，像耶和華─我們的神、在我們求告他的時候與我們相近呢﹖',
    '申4:8 又哪一大國有這樣公義的律例典章、像我今日在你們面前所陳明的這一切律法呢﹖',
    '申4:9 你只要謹慎，殷勤保守你的心靈，免得忘記你親眼所看見的事，又免得你一生這事離開你的心；總要傳給你的子子孫孫。',
    '申4:10 你在何烈山站在耶和華─你神面前的那日，耶和華對我說：你為我招聚百姓，我要叫他們聽見我的話，使他們存活在世的日子，可以學習敬畏我，又可以教訓兒女這樣行。',
    '申4:11 那時你們近前來，站在山下；山上有火焰沖天，並有昏黑、密雲、幽暗。',
    '申4:12 耶和華從火焰中對你們說話，你們只聽見聲音，卻沒有看見形像。',
    '申4:13 他將所吩咐你們當守的約指示你們，就是十條誡，並將這誡寫在兩塊石版上。',
    '申4:14 那時耶和華又吩咐我將律例典章教訓你們，使你們在所要過去得為業的地上遵行。',
    '申4:15 所以，你們要分外謹慎；因為耶和華在何烈山、從火中對你們說話的那日，你們沒有看見什麼形像。',
    '申4:16 惟恐你們敗壞自己，雕刻偶像，彷彿什麼男像女像，',
    '申4:17 或地上走獸的像，或空中飛鳥的像，',
    '申4:18 或地上爬物的像，或地底下水中魚的像。',
    '申4:19 又恐怕你向天舉目觀看，見耶和華─你的神為天下萬民所擺列的日月星，就是天上的萬象，自己便被勾引敬拜事奉他。',
    '申4:20 耶和華將你們從埃及領出來，脫離鐵爐，要特作自己產業的子民，像今日一樣。',
    '申4:21 耶和華又因你們的緣故向我發怒，起誓必不容我過約但河，也不容我進入耶和華─你神所賜你為業的那美地。',
    '申4:22 我只得死在這地，不能過約但河；但你們必過去得那美地。',
    '申4:23 你們要謹慎，免得忘記耶和華─你們神與你們所立的約，為自己雕刻偶像，就是耶和華─你神所禁止你做的偶像；',
    '申4:24 因為耶和華─你的神乃是烈火，是忌邪的神。',
    '申4:25 你們在那地住久了，生子生孫，就雕刻偶像，彷彿什麼形像，敗壞自己，行耶和華─你神眼中看為惡的事，惹他發怒。',
    '申4:26 我今日呼天喚地向你們作見證，你們必在過約但河得為業的地上速速滅盡！你們不能在那地上長久，必盡行除滅。',
    '申4:27 耶和華必使你們分散在萬民中；在他所領你們到的萬國裡，你們剩下的人數稀少。',
    '申4:28 在那裡，你們必事奉人手所造的神，就是用木石造成、不能看、不能聽、不能吃、不能聞的神。',
    '申4:29 但你們在那裡必尋求耶和華─你的神。你盡心盡性尋求他的時候，就必尋見。',
    '申4:30 日後你遭遇一切患難的時候，你必歸回耶和華─你的神，聽從他的話。',
    '申4:31 耶和華─你神原是有憐憫的神；他總不撇下你，不滅絕你，也不忘記他起誓與你列祖所立的約。',
    '申4:32 你且考察在你以前的世代，自神造人在世以來，從天這邊到天那邊，曾有何民聽見神在火中說話的聲音，像你聽見還能存活呢﹖',
    '申4:33 這樣的大事何曾有、何曾聽見呢﹖',
    '申4:34 神何曾從別的國中將一國的人民領出來，用試驗、神蹟、奇事、爭戰、大能的手，和伸出來的膀臂，並大可畏的事，像耶和華─你們的神在埃及，在你們眼前為你們所行的一切事呢﹖',
    '申4:35 這是顯給你看，要使你知道，惟有耶和華─他是神，除他以外，再無別神。',
    '申4:36 他從天上使你聽見他的聲音，為要教訓你，又在地上使你看見他的烈火，並且聽見他從火中所說的話。',
    '申4:37 因他愛你的列祖，所以揀選他們的後裔，用大能親自領你出了埃及，',
    '申4:38 要將比你強大的國民從你面前趕出，領你進去，將他們的地賜你為業，像今日一樣。',
    '申4:39 所以，今日你要知道，也要記在心上，天上地下惟有耶和華他是神，除他以外，再無別神。',
    '申4:40 我今日將他的律例誡命曉諭你，你要遵守，使你和你的子孫可以得福，並使你的日子在耶和華─你神所賜的地上得以長久。',
    '申4:41 那時，摩西在約但河東，向日出之地，分定三座城，',
    '申4:42 使那素無仇恨、無心殺了人的，可以逃到這三城之中的一座城，就得存活：',
    '申4:43 為流便人分定曠野平原的比悉；為迦得人分定基列的拉末；為瑪拿西人分定巴珊的哥蘭。',
    '申4:44 摩西在以色列人面前所陳明的律法─',
    '申4:45 就是摩西在以色列人出埃及後所傳給他們的法度、律例、典章；',
    '申4:46 在約但河東伯毘珥對面的谷中，在住希實本、亞摩利王西宏之地；這西宏是摩西和以色列人出埃及後所擊殺的。',
    '申4:47 他們得了他的地，又得了巴珊王噩的地，就是兩個亞摩利王，在約但河東向日出之地。',
    '申4:48 從亞嫩谷邊的亞羅珥，直到西雲山，就是黑門山。',
    '申4:49 還有約但河東的全亞拉巴，直到亞拉巴海，靠近毘斯迦山根。',
    '申5:1 摩西將以色列眾人召了來，對他們說：以色列人哪，我今日曉諭你們的律例典章，你們要聽，可以學習，謹守遵行。',
    '申5:2 耶和華─我們的神在何烈山與我們立約。',
    '申5:3 這約不是與我們列祖立的，乃是與我們今日在這裡存活之人立的。',
    '申5:4 耶和華在山上，從火中，面對面與你們說話─',
    '申5:5 那時我站在耶和華和你們中間，要將耶和華的話傳給你們；因為你們懼怕那火，沒有上山─說：',
    '申5:6 我是耶和華─你的神，曾將你從埃及地為奴之家領出來。',
    '申5:7 除了我以外，你不可有別的神。',
    '申5:8 不可為自己雕刻偶像，也不可做什麼形像，彷彿上天、下地和地底下、水中的百物。',
    '申5:9 不可跪拜那些像，也不可事奉他，因為我耶和華─你的神是忌邪的神。恨我的，我必追討他的罪，自父及子，直到三、四代；',
    '申5:10 愛我、守我誡命的，我必向他們發慈愛，直到千代。',
    '申5:11 不可妄稱耶和華─你神的名；因為妄稱耶和華名的，耶和華必不以他為無罪。',
    '申5:12 當照耶和華─你神所吩咐的守安息日為聖日。',
    '申5:13 六日要勞碌做你一切的工，',
    '申5:14 但第七日是向耶和華─你神當守的安息日。這一日，你和你的兒女、僕婢、牛、驢、牲畜，並在你城裡寄居的客旅，無論何工都不可做，使你的僕婢可以和你一樣安息。',
    '申5:15 你也要記念你在埃及地作過奴僕；耶和華─你神用大能的手和伸出來的膀臂將你從那裡領出來。因此，耶和華─你的神吩咐你守安息日。',
    '申5:16 當照耶和華─你神所吩咐的孝敬父母，使你得福，並使你的日子在耶和華─你神所賜你的地上得以長久。',
    '申5:17 不可殺人。',
    '申5:18 不可姦淫。',
    '申5:19 不可偷盜。',
    '申5:20 不可作假見證陷害人。',
    '申5:21 不可貪戀人的妻子；也不可貪圖人的房屋、田地、僕婢、牛、驢，並他一切所有的。',
    '申5:22 這些話是耶和華在山上，從火中、雲中、幽暗中，大聲曉諭你們全會眾的；此外並沒有添別的話。他就把這話寫在兩塊石版上，交給我了。',
    '申5:23 那時，火焰燒山，你們聽見從黑暗中出來的聲音；你們支派中所有的首領和長老都來就近我，',
    '申5:24 說：看哪，耶和華─我們神將他的榮光和他的大能顯給我們看，我們又聽見他的聲音從火中出來。今日我們得見神與人說話，人還存活。',
    '申5:25 現在這大火將要燒滅我們，我們何必冒死呢﹖若再聽見耶和華─我們神的聲音就必死亡。',
    '申5:26 凡屬血氣的，曾有何人聽見永生神的聲音從火中出來，像我們聽見還能存活呢﹖',
    '申5:27 求你近前去，聽耶和華─我們神所要說的一切話，將他對你說的話都傳給我們，我們就聽從遵行。',
    '申5:28 你們對我說的話，耶和華都聽見了。耶和華對我說：這百姓的話，我聽見了；他們所說的都是。',
    '申5:29 惟願他們存這樣的心敬畏我，常遵守我的一切誡命，使他們和他們的子孫永遠得福。',
    '申5:30 你去對他們說：你們回帳棚去吧！',
    '申5:31 至於你，可以站在我這裡，我要將一切誡命、律例、典章傳給你；你要教訓他們，使他們在我賜他們為業的地上遵行。',
    '申5:32 所以，你們要照耶和華─你們神所吩咐的謹守遵行，不可偏離左右。',
    '申5:33 耶和華─你們神所吩咐你們行的，你們都要去行，使你們可以存活得福，並使你們的日子在所要承受的地上得以長久。',
    '申6:1 這是耶和華─你們神所吩咐教訓你們的誡命、律例、典章，使你們在所要過去得為業的地上遵行，',
    '申6:2 好叫你和你子子孫孫一生敬畏耶和華─你的神，謹守他的一切律例誡命，就是我所吩咐你的，使你的日子得以長久。',
    '申6:3 以色列啊，你要聽，要謹守遵行，使你可以在那流奶與蜜之地得以享福，人數極其增多，正如耶和華─你列祖的神所應許你的。',
    '申6:4 以色列啊，你要聽！耶和華─我們神是獨一的主。',
    '申6:5 你要盡心、盡性、盡力愛耶和華─你的神。',
    '申6:6 我今日所吩咐你的話都要記在心上，',
    '申6:7 也要殷勤教訓你的兒女。無論你坐在家裡，行在路上，躺下，起來，都要談論。',
    '申6:8 也要繫在手上為記號，戴在額上為經文；',
    '申6:9 又要寫在你房屋的門框上，並你的城門上。',
    '申6:10 耶和華─你的神領你進他向你列祖亞伯拉罕、以撒、雅各起誓應許給你的地。那裡有城邑，又大又美，非你所建造的；',
    '申6:11 有房屋，裝滿各樣美物，非你所裝滿的；有鑿成的水井，非你所鑿成的；還有葡萄園、橄欖園，非你所栽種的；你吃了而且飽足。',
    '申6:12 那時你要謹慎，免得你忘記將你從埃及地、為奴之家領出來的耶和華。',
    '申6:13 你要敬畏耶和華─你的神，事奉他，指著他的名起誓。',
    '申6:14 不可隨從別神，就是你們四圍國民的神；',
    '申6:15 因為在你們中間的耶和華─你神是忌邪的神，惟恐耶和華─你神的怒氣向你發作，就把你從地上除滅。',
    '申6:16 你們不可試探耶和華─你們的神，像你們在瑪撒那樣試探他。',
    '申6:17 要留意遵守耶和華─你們神所吩咐的誡命、法度、律例。',
    '申6:18 耶和華眼中看為正、看為善的，你都要遵行，使你可以享福，並可以進去得耶和華向你列祖起誓應許的那美地，',
    '申6:19 照耶和華所說的，從你面前攆出你的一切仇敵。',
    '申6:20 日後，你的兒子問你說：耶和華─我們神吩咐你們的這些法度、律例、典章是什麼意思呢﹖',
    '申6:21 你就告訴你的兒子說：我們在埃及作過法老的奴僕；耶和華用大能的手將我們從埃及領出來，',
    '申6:22 在我們眼前，將重大可怕的神蹟奇事施行在埃及地和法老並他全家的身上，',
    '申6:23 將我們從那裡領出來，要領我們進入他向我們列祖起誓應許之地，把這地賜給我們。',
    '申6:24 耶和華又吩咐我們遵行這一切律例，要敬畏耶和華─我們的神，使我們常得好處，蒙他保全我們的生命，像今日一樣。',
    '申6:25 我們若照耶和華─我們神所吩咐的一切誡命謹守遵行，這就是我們的義了。',
    '申7:1 耶和華─你神領你進入要得為業之地，從你面前趕出許多國民，就是赫人、革迦撒人、亞摩利人、迦南人、比利洗人、希未人、耶布斯人，共七國的民，都比你強大。',
    '申7:2 耶和華─你神將他們交給你擊殺，那時你要把他們滅絕淨盡，不可與他們立約，也不可憐恤他們。',
    '申7:3 不可與他們結親。不可將你的女兒嫁他們的兒子，也不可叫你的兒子娶他們的女兒；',
    '申7:4 因為他必使你兒子轉離不跟從主，去事奉別神，以致耶和華的怒氣向你們發作，就速速地將你們滅絕。',
    '申7:5 你們卻要這樣待他們：拆毀他們的祭壇，打碎他們的柱像，砍下他們的木偶，用火焚燒他們雕刻的偶像。',
    '申7:6 因為你歸耶和華─你神為聖潔的民；耶和華─你神從地上的萬民中揀選你，特作自己的子民。',
    '申7:7 耶和華專愛你們，揀選你們，並非因你們的人數多於別民，原來你們的人數在萬民中是最少的。',
    '申7:8 只因耶和華愛你們，又因要守他向你們列祖所起的誓，就用大能的手領你們出來，從為奴之家救贖你們脫離埃及王法老的手。',
    '申7:9 所以，你要知道耶和華─你的神，他是神，是信實的神；向愛他、守他誡命的人守約，施慈愛，直到千代；',
    '申7:10 向恨他的人當面報應他們，將他們滅絕。凡恨他的人必報應他們，決不遲延。',
    '申7:11 所以，你要謹守遵行我今日所吩咐你的誡命、律例、典章。',
    '申7:12 你們果然聽從這些典章，謹守遵行，耶和華─你神就必照他向你列祖所起的誓守約，施慈愛。',
    '申7:13 他必愛你，賜福與你，使你人數增多，也必在他向你列祖起誓應許給你的地上賜福與你身所生的，地所產的，並你的五穀、新酒，和油，以及牛犢、羊羔。',
    '申7:14 你必蒙福勝過萬民；你們的男女沒有不能生養的，牲畜也沒有不能生育的。',
    '申7:15 耶和華必使一切的病症離開你；你所知道埃及各樣的惡疾，他不加在你身上，只加在一切恨你的人身上。',
    '申7:16 耶和華─你神所要交給你的一切人民，你要將他們除滅；你眼不可顧惜他們。你也不可事奉他們的神，因這必成為你的網羅。',
    '申7:17 你若心裡說，這些國的民比我更多，我怎能趕出他們呢﹖',
    '申7:18 你不要懼怕他們，要牢牢記念耶和華─你神向法老和埃及全地所行的事，',
    '申7:19 就是你親眼所看見的大試驗、神蹟、奇事，和大能的手，並伸出來的膀臂，都是耶和華─你神領你出來所用的。耶和華─你神必照樣待你所懼怕的一切人民。',
    '申7:20 並且耶和華─你神必打發黃蜂飛到他們中間，直到那剩下而藏躲的人從你面前滅亡。',
    '申7:21 你不要因他們驚恐，因為耶和華─你神在你們中間是大而可畏的神。',
    '申7:22 耶和華─你神必將這些國的民從你面前漸漸趕出；你不可把他們速速滅盡，恐怕野地的獸多起來害你。',
    '申7:23 耶和華─你神必將他們交給你，大大的擾亂他們，直到他們滅絕了；',
    '申7:24 又要將他們的君王交在你手中，你就使他們的名從天下消滅。必無一人能在你面前站立得住，直到你將他們滅絕了。',
    '申7:25 他們雕刻的神像，你們要用火焚燒；其上的金銀，你不可貪圖，也不可收取，免得你因此陷入網羅；這原是耶和華─你神所憎惡的。',
    '申7:26 可憎的物，你不可帶進家去；不然，你就成了當毀滅的，與那物一樣。你要十分厭惡，十分憎嫌，因為這是當毀滅的物。',
    '申8:1 我今日所吩咐的一切誡命，你們要謹守遵行，好叫你們存活，人數增多，且進去得耶和華向你們列祖起誓應許的那地。',
    '申8:2 你也要記念耶和華─你的神在曠野引導你這四十年，是要苦煉你，試驗你，要知道你心內如何，肯守他的誡命不肯。',
    '申8:3 他苦煉你，任你飢餓，將你和你列祖所不認識的嗎哪賜給你吃，使你知道，人活著不是單靠食物，乃是靠耶和華口裡所出的一切話。',
    '申8:4 這四十年，你的衣服沒有穿破，你的腳也沒有腫。',
    '申8:5 你當心裡思想，耶和華─你神管教你，好像人管教兒子一樣。',
    '申8:6 你要謹守耶和華─你神的誡命，遵行他的道，敬畏他。',
    '申8:7 因為耶和華─你神領你進入美地，那地有河，有泉，有源，從山谷中流出水來。',
    '申8:8 那地有小麥、大麥、葡萄樹、無花果樹、石榴樹、橄欖樹，和蜜。',
    '申8:9 你在那地不缺食物，一無所缺。那地的石頭是鐵，山內可以挖銅。',
    '申8:10 你吃得飽足，就要稱頌耶和華─你的神，因他將那美地賜給你了。',
    '申8:11 你要謹慎，免得忘記耶和華─你的神，不守他的誡命、典章、律例，就是我今日所吩咐你的；',
    '申8:12 恐怕你吃得飽足，建造美好的房屋居住，',
    '申8:13 你的牛羊加多，你的金銀增添，並你所有的全都加增，',
    '申8:14 你就心高氣傲，忘記耶和華─你的神，就是將你從埃及地為奴之家領出來的，',
    '申8:15 引你經過那大而可怕的曠野，那裡有火蛇、蠍子、乾旱無水之地。他曾為你使水從堅硬的磐石中流出來，',
    '申8:16 又在曠野將你列祖所不認識的嗎哪賜給你吃，是要苦煉你，試驗你，叫你終久享福；',
    '申8:17 恐怕你心裡說：這貨財是我力量、我能力得來的。',
    '申8:18 你要記念耶和華─你的神，因為得貨財的力量是他給你的，為要堅定他向你列祖起誓所立的約，像今日一樣。',
    '申8:19 你若忘記耶和華─你的神，隨從別神，事奉敬拜，你們必定滅亡；這是我今日警戒你們的。',
    '申8:20 耶和華在你們面前怎樣使列國的民滅亡，你們也必照樣滅亡，因為你們不聽從耶和華─你們神的話。',
    '申9:1 以色列啊，你當聽！你今日要過約但河，進去趕出比你強大的國民，得著廣大堅固、高得頂天的城邑。',
    '申9:2 那民是亞衲族的人，又大又高，是你所知道的；也曾聽見有人指著他們說：誰能在亞衲族人面前站立得住呢﹖',
    '申9:3 你今日當知道，耶和華─你的神在你前面過去，如同烈火，要滅絕他們，將他們制伏在你面前。這樣，你就要照耶和華所說的趕出他們，使他們速速滅亡。',
    '申9:4 耶和華─你的神將這些國民從你面前攆出以後，你心裡不可說：耶和華將我領進來得這地是因我的義。其實，耶和華將他們從你面前趕出去是因他們的惡。',
    '申9:5 你進去得他們的地，並不是因你的義，也不是因你心裡正直，乃是因這些國民的惡，耶和華─你的神將他們從你面前趕出去，又因耶和華要堅定他向你列祖亞伯拉罕、以撒、雅各起誓所應許的話。',
    '申9:6 你當知道，耶和華─你神將這美地賜你為業，並不是因你的義；你本是硬著頸項的百姓。',
    '申9:7 你當記念不忘，你在曠野怎樣惹耶和華─你神發怒。自從你出了埃及地的那日，直到你們來到這地方，你們時常悖逆耶和華。',
    '申9:8 你們在何烈山又惹耶和華發怒；他惱怒你們，要滅絕你們。',
    '申9:9 我上了山，要領受兩塊石版，就是耶和華與你們立約的版。那時我在山上住了四十晝夜，沒有吃飯，也沒有喝水。',
    '申9:10 耶和華把那兩塊石版交給我，是神用指頭寫的。版上所寫的是照耶和華在大會的日子、在山上、從火中對你們所說的一切話。',
    '申9:11 過了四十晝夜，耶和華把那兩塊石版，就是約版，交給我。',
    '申9:12 對我說：你起來，趕快下去！因為你從埃及領出來的百姓已經敗壞了自己；他們快快地偏離了我所吩咐的道，為自己鑄成了偶像。',
    '申9:13 耶和華又對我說：我看這百姓是硬著頸項的百姓。',
    '申9:14 你且由著我，我要滅絕他們，將他們的名從天下塗抹，使你的後裔比他們成為更大更強的國。',
    '申9:15 於是我轉身下山，山被火燒著，兩塊約版在我兩手之中。',
    '申9:16 我一看見你們得罪了耶和華─你們的神，鑄成了牛犢，快快地偏離了耶和華所吩咐你們的道，',
    '申9:17 我就把那兩塊版從我手中扔下去，在你們眼前摔碎了。',
    '申9:18 因你們所犯的一切罪，行了耶和華眼中看為惡的事，惹他發怒，我就像從前俯伏在耶和華面前四十晝夜，沒有吃飯，也沒有喝水。',
    '申9:19 我因耶和華向你們大發烈怒，要滅絕你們，就甚害怕；但那次耶和華又應允了我。',
    '申9:20 耶和華也向亞倫甚是發怒，要滅絕他；那時我又為亞倫祈禱。',
    '申9:21 我把那叫你們犯罪所鑄的牛犢用火焚燒，又搗碎磨得很細，以致細如灰塵，我就把這灰塵撒在從山上流下來的溪水中。',
    '申9:22 你們在他備拉、瑪撒、基博羅哈他瓦又惹耶和華發怒。',
    '申9:23 耶和華打發你們離開加低斯巴尼亞，說：你們上去得我所賜給你們的地。那時你們違背了耶和華─你們神的命令，不信服他，不聽從他的話。',
    '申9:24 自從我認識你們以來，你們常常悖逆耶和華。',
    '申9:25 我因耶和華說要滅絕你們，就在耶和華面前照舊俯伏四十晝夜。',
    '申9:26 我祈禱耶和華說：主耶和華啊，求你不要滅絕你的百姓。他們是你的產業，是你用大力救贖的，用大能從埃及領出來的。',
    '申9:27 求你記念你的僕人亞伯拉罕、以撒、雅各，不要想念這百姓的頑梗、邪惡、罪過，',
    '申9:28 免得你領我們出來的那地之人說，耶和華因為不能將這百姓領進他所應許之地，又因恨他們，所以領他們出去，要在曠野殺他們。',
    '申9:29 其實他們是你的百姓，你的產業，是你用大能和伸出來的膀臂領出來的。',
    '申10:1 那時，耶和華吩咐我說：你要鑿出兩塊石版，和先前的一樣，上山到我這裡來，又要做一木櫃。',
    '申10:2 你先前摔碎的那版，其上的字我要寫在這版上；你要將這版放在櫃中。',
    '申10:3 於是我用皂莢木做了一櫃，又鑿出兩塊石版，和先前的一樣，手裡拿這兩塊版上山去了。',
    '申10:4 耶和華將那大會之日、在山上從火中所傳與你們的十條誡，照先前所寫的，寫在這版上，將版交給我了。',
    '申10:5 我轉身下山，將這版放在我所做的櫃中，現今還在那裡，正如耶和華所吩咐我的。',
    '申10:6 （以色列人從比羅比尼亞干（或作：亞干井）起行，到了摩西拉。亞倫死在那裡，就葬在那裡。他兒子以利亞撒接續他供祭司的職分。',
    '申10:7 他們從那裡起行，到了谷歌大，又從谷歌大到了有溪水之地的約巴他。',
    '申10:8 那時，耶和華將利未支派分別出來，擡耶和華的約櫃，又侍立在耶和華面前事奉他，奉他的名祝福，直到今日。',
    '申10:9 所以利未人在他弟兄中無分無業，耶和華是他的產業，正如耶和華─你神所應許他的。）',
    '申10:10 我又像從前在山上住了四十晝夜。那次耶和華也應允我，不忍將你滅絕。',
    '申10:11 耶和華吩咐我說：你起來引導這百姓，使他們進去得我向他們列祖起誓應許所賜之地。',
    '申10:12 以色列啊，現在耶和華─你神向你所要的是什麼呢﹖只要你敬畏耶和華─你的神，遵行他的道，愛他，盡心盡性事奉他，',
    '申10:13 遵守他的誡命律例，就是我今日所吩咐你的，為要叫你得福。',
    '申10:14 看哪，天和天上的天，地和地上所有的，都屬耶和華─你的神。',
    '申10:15 耶和華但喜悅你的列祖，愛他們，從萬民中揀選他們的後裔，就是你們，像今日一樣。',
    '申10:16 所以你們要將心裡的污穢除掉，不可再硬著頸項。',
    '申10:17 因為耶和華─你們的神─他是萬神之神，萬主之主，至大的神，大有能力，大而可畏，不以貌取人，也不受賄賂。',
    '申10:18 他為孤兒寡婦伸冤，又憐愛寄居的，賜給他衣食。',
    '申10:19 所以你們要憐愛寄居的，因為你們在埃及地也作過寄居的。',
    '申10:20 你要敬畏耶和華─你的神，事奉他，專靠他，也要指著他的名起誓。',
    '申10:21 他是你所讚美的，是你的神，為你做了那大而可畏的事，是你親眼所看見的。',
    '申10:22 你的列祖七十人下埃及；現在耶和華─你的神使你如同天上的星那樣多。',
    '申11:1 你要愛耶和華─你的神，常守他的吩咐、律例、典章、誡命。',
    '申11:2 你們今日當知道，我本不是和你們的兒女說話；因為他們不知道，也沒有看見耶和華─你們神的管教、威嚴、大能的手，和伸出來的膀臂，',
    '申11:3 並他在埃及中向埃及王法老和其全地所行的神蹟奇事；',
    '申11:4 也沒有看見他怎樣待埃及的軍兵、車馬，他們追趕你們的時候，耶和華怎樣使紅海的水淹沒他們，將他們滅絕，直到今日，',
    '申11:5 並他在曠野怎樣待你們，以致你們來到這地方；',
    '申11:6 也沒有看見他怎樣待流便子孫以利押的兒子大坍、亞比蘭，地怎樣在以色列人中間開口，吞了他們和他們的家眷，並帳棚與跟他們的一切活物。',
    '申11:7 惟有你們親眼看見耶和華所做的一切大事。',
    '申11:8 所以，你們要守我今日所吩咐的一切誡命，使你們膽壯，能以進去，得你們所要得的那地，',
    '申11:9 並使你們的日子在耶和華向你們列祖起誓、應許給他們和他們後裔的地上得以長久；那是流奶與蜜之地。',
    '申11:10 你要進去得為業的那地，本不像你出來的埃及地。你在那裡撒種，用腳澆灌，像澆灌菜園一樣。',
    '申11:11 你們要過去得為業的那地乃是有山有谷、雨水滋潤之地，',
    '申11:12 是耶和華─你神所眷顧的；從歲首到年終，耶和華─你神的眼目時常看顧那地。',
    '申11:13 你們若留意聽從我今日所吩咐的誡命，愛耶和華─你們的神，盡心盡性事奉他，',
    '申11:14 他（原文是我）必按時降秋雨春雨在你們的地上，使你們可以收藏五穀、新酒和油，',
    '申11:15 也必使你吃得飽足，並使田野為你的牲畜長草。',
    '申11:16 你們要謹慎，免得心中受迷惑，就偏離正路，去事奉敬拜別神。',
    '申11:17 耶和華的怒氣向你們發作，就使天閉塞不下雨，地也不出產，使你們在耶和華所賜給你們的美地上速速滅亡。',
    '申11:18 你們要將我這話存在心內，留在意中，繫在手上為記號，戴在額上為經文；',
    '申11:19 也要教訓你們的兒女，無論坐在家裡，行在路上，躺下，起來，都要談論；',
    '申11:20 又要寫在房屋的門框上，並城門上，',
    '申11:21 使你們和你們子孫的日子在耶和華向你們列祖起誓、應許給他們的地上得以增多，如天覆地的日子那樣多。',
    '申11:22 你們若留意謹守遵行我所吩咐這一切的誡命，愛耶和華─你們的神，行他的道，專靠他，',
    '申11:23 他必從你們面前趕出這一切國民，就是比你們更大更強的國民，你們也要得他們的地。',
    '申11:24 凡你們腳掌所踏之地都必歸你們；從曠野和利巴嫩，並伯拉大河，直到西海，都要作你們的境界。',
    '申11:25 必無一人能在你們面前站立得住；耶和華─你們的神必照他所說的，使懼怕驚恐臨到你們所踏之地的居民。',
    '申11:26 看哪，我今日將祝福與咒詛的話都陳明在你們面前。',
    '申11:27 你們若聽從耶和華─你們神的誡命，就是我今日所吩咐你們的，就必蒙福。',
    '申11:28 你們若不聽從耶和華─你們神的誡命，偏離我今日所吩咐你們的道，去事奉你們素來所不認識的別神，就必受禍。',
    '申11:29 及至耶和華─你的神領你進入要去得為業的那地，你就要將祝福的話陳明在基利心山上，將咒詛的話陳明在以巴路山上。',
    '申11:30 這二山豈不是在約但河那邊，日落之處，在住亞拉巴的迦南人之地與吉甲相對，靠近摩利橡樹嗎﹖',
    '申11:31 你們要過約但河，進去得耶和華─你們神所賜你們為業之地，在那地居住。',
    '申11:32 你們要謹守遵行我今日在你們面前所陳明的一切律例典章。',
    '申12:1 你們存活於世的日子，在耶和華─你們列祖的神所賜你們為業的地上，要謹守遵行的律例典章乃是這些：',
    '申12:2 你們要將所趕出的國民事奉神的各地方，無論是在高山，在小山，在各青翠樹下，都毀壞了；',
    '申12:3 也要拆毀他們的祭壇，打碎他們的柱像，用火焚燒他們的木偶，砍下他們雕刻的神像，並將其名從那地方除滅。',
    '申12:4 你們不可照他們那樣事奉耶和華─你們的神。',
    '申12:5 但耶和華─你們的神從你們各支派中選擇何處為立他名的居所，你們就當往那裡去求問，',
    '申12:6 將你們的燔祭、平安祭、十分取一之物，和手中的舉祭，並還願祭、甘心祭，以及牛群羊群中頭生的，都奉到那裡。',
    '申12:7 在那裡，耶和華─你們神的面前，你們和你們的家屬都可以吃，並且因你手所辦的一切事蒙耶和華─你的神賜福，就都歡樂。',
    '申12:8 我們今日在這裡所行的是各人行自己眼中看為正的事，你們將來不可這樣行；',
    '申12:9 因為你們還沒有到耶和華─你神所賜你的安息地，所給你的產業。',
    '申12:10 但你們過了約但河，得以住在耶和華─你們神使你們承受為業之地，又使你們太平，不被四圍的一切仇敵擾亂，安然居住。',
    '申12:11 那時要將我所吩咐你們的燔祭、平安祭、十分取一之物，和手中的舉祭，並向耶和華許願獻的一切美祭，都奉到耶和華─你們神所選擇要立為他名的居所。',
    '申12:12 你們和兒女、僕婢，並住在你們城裡無分無業的利未人，都要在耶和華─你們的神面前歡樂。',
    '申12:13 你要謹慎，不可在你所看中的各處獻燔祭。',
    '申12:14 惟獨耶和華從你那一支派中所選擇的地方，你就要在那裡獻燔祭，行我一切所吩咐你的。',
    '申12:15 然而，在你各城裡都可以照耶和華─你神所賜你的福分，隨心所欲宰牲吃肉；無論潔淨人不潔淨人都可以吃，就如吃羚羊與鹿一般。',
    '申12:16 只是不可吃血，要倒在地上，如同倒水一樣。',
    '申12:17 你的五穀、新酒，和油的十分之一，或是牛群羊群中頭生的，或是你許願獻的，甘心獻的，或是手中的舉祭，都不可在你城裡吃。',
    '申12:18 但要在耶和華─你的神面前吃，在耶和華─你神所要選擇的地方，你和兒女、僕婢，並住在你城裡的利未人，都可以吃；也要因你手所辦的，在耶和華─你神面前歡樂。',
    '申12:19 你要謹慎，在你所住的地方永不可丟棄利未人。',
    '申12:20 耶和華─你的神照他所應許擴張你境界的時候，你心裡想要吃肉，說：我要吃肉，就可以隨心所欲地吃肉。',
    '申12:21 耶和華─你神所選擇要立他名的地方若離你太遠，就可以照我所吩咐的，將耶和華賜給你的牛羊取些宰了，可以隨心所欲在你城裡吃。',
    '申12:22 你吃那肉，要像吃羚羊與鹿一般；無論潔淨人不潔淨人都可以吃。',
    '申12:23 只是你要心意堅定，不可吃血，因為血是生命；不可將血（原文作生命）與肉同吃。',
    '申12:24 不可吃血，要倒在地上，如同倒水一樣。',
    '申12:25 不可吃血。這樣，你行耶和華眼中看為正的事，你和你的子孫就可以得福。',
    '申12:26 只是你分別為聖的物和你的還願祭要奉到耶和華所選擇的地方去。',
    '申12:27 你的燔祭，連肉帶血，都要獻在耶和華─你神的壇上。平安祭的血要倒在耶和華─你神的壇上；平安祭的肉，你自己可以吃。',
    '申12:28 你要謹守聽從我所吩咐的一切話，行耶和華─你神眼中看為善，看為正的事。這樣，你和你的子孫就可以永遠享福。',
    '申12:29 耶和華─你神將你要去趕出的國民從你面前剪除，你得了他們的地居住，',
    '申12:30 那時就要謹慎，不可在他們除滅之後隨從他們的惡俗，陷入網羅，也不可訪問他們的神說：這些國民怎樣事奉他們的神，我也要照樣行。',
    '申12:31 你不可向耶和華─你的神這樣行，因為他們向他們的神行了耶和華所憎嫌所恨惡的一切事，甚至將自己的兒女用火焚燒，獻與他們的神。',
    '申12:32 凡我所吩咐的，你們都要謹守遵行，不可加添，也不可刪減。',
    '申13:1 你們中間若有先知或是做夢的起來，向你顯個神蹟奇事，',
    '申13:2 對你說：我們去隨從你素來所不認識的別神，事奉他吧。他所顯的神蹟奇事雖有應驗，',
    '申13:3 你也不可聽那先知或是那做夢之人的話；因為這是耶和華─你們的神試驗你們，要知道你們是盡心盡性愛耶和華─你們的神不是。',
    '申13:4 你們要順從耶和華─你們的神，敬畏他，謹守他的誡命，聽從他的話，事奉他，專靠他。',
    '申13:5 那先知或是那做夢的既用言語叛逆那領你們出埃及地、救贖你脫離為奴之家的耶和華─你們的神，要勾引你離開耶和華─你神所吩咐你行的道，你便要將他治死。這樣，就把那惡從你們中間除掉。',
    '申13:6 你的同胞弟兄，或是你的兒女，或是你懷中的妻，或是如同你性命的朋友，若暗中引誘你，說：我們不如去事奉你和你列祖素來所不認識的別神─',
    '申13:7 是你四圍列國的神。無論是離你近，離你遠，從地這邊到地那邊的神，',
    '申13:8 你不可依從他，也不可聽從他，眼不可顧惜他。你不可憐恤他，也不可遮庇他，',
    '申13:9 總要殺他；你先下手，然後眾民也下手，將他治死。',
    '申13:10 要用石頭打死他，因為他想要勾引你離開那領你出埃及地為奴之家的耶和華─你的神。',
    '申13:11 以色列眾人都要聽見害怕，就不敢在你們中間再行這樣的惡了。',
    '申13:12 在耶和華─你神所賜你居住的各城中，你若聽人說，有些匪類從你們中間的一座城出來勾引本城的居民，說：我們不如去事奉你們素來所不認識的別神；',
    '申13:13 併於上節。',
    '申13:14 你就要探聽，查究，細細地訪問，果然是真，準有這可憎惡的事行在你們中間，',
    '申13:15 你必要用刀殺那城裡的居民，把城裡所有的，連牲畜，都用刀殺盡。',
    '申13:16 你從那城裡所奪的財物都要堆積在街市上，用火將城和其內所奪的財物都在耶和華─你神面前燒盡；那城就永為荒堆，不可再建造。',
    '申13:17 那當毀滅的物連一點都不可粘你的手。你要聽從耶和華─你神的話，遵守我今日所吩咐你的一切誡命，行耶和華─你神眼中看為正的事，耶和華就必轉意，不發烈怒，恩待你，憐恤你，照他向你列祖所起的誓使你人數增多。',
    '申13:18 併於上節。',
    '申14:1 你們是耶和華─你們神的兒女。不可為死人用刀劃身，也不可將額上剃光。',
    '申14:2 因為你歸耶和華─你神為聖潔的民，耶和華從地上的萬民中揀選你特作自己的子民。',
    '申14:3 凡可憎的物都不可吃。',
    '申14:4 可吃的牲畜就是牛、綿羊、山羊、',
    '申14:5 鹿、羚羊、麅子、野山羊、麋鹿、黃羊、青羊。',
    '申14:6 凡分蹄成為兩瓣又倒嚼的走獸，你們都可以吃。',
    '申14:7 但那些倒嚼或是分蹄之中不可吃的乃是駱駝、兔子、沙番─因為是倒嚼不分蹄，就與你們不潔淨；',
    '申14:8 豬─因為是分蹄卻不倒嚼，就與你們不潔淨。這些獸的肉，你們不可吃，死的也不可摸。',
    '申14:9 水中可吃的乃是這些：凡有翅有鱗的都可以吃；',
    '申14:10 凡無翅無鱗的都不可吃，是與你們不潔淨。',
    '申14:11 凡潔淨的鳥，你們都可以吃。',
    '申14:12 不可吃的乃是鵰、狗頭鵰、紅頭鵰、',
    '申14:13 鸇、小鷹、鷂鷹與其類，',
    '申14:14 烏鴉與其類，',
    '申14:15 鴕鳥、夜鷹、魚鷹、鷹與其類，',
    '申14:16 鴞鳥、貓頭鷹、角鴟、',
    '申14:17 鵜鶘、禿鵰、鸕鶿、',
    '申14:18 鸛、鷺鷥與其類，戴鵀與蝙蝠。',
    '申14:19 凡有翅膀爬行的物是與你們不潔淨，都不可吃。',
    '申14:20 凡潔淨的鳥，你們都可以吃。',
    '申14:21 凡自死的，你們都不可吃，可以給你城裡寄居的吃，或賣與外人吃，因為你是歸耶和華─你神為聖潔的民。不可用山羊羔母的奶煮山羊羔。',
    '申14:22 你要把你撒種所產的，就是你田地每年所出的，十分取一分；',
    '申14:23 又要把你的五穀、新酒、和油的十分之一，並牛群羊群中頭生的，吃在耶和華─你神面前，就是他所選擇要立為他名的居所。這樣，你可以學習時常敬畏耶和華─你的神。',
    '申14:24 當耶和華─你神賜福與你的時候，耶和華─你神所選擇要立為他名的地方若離你太遠，那路也太長，使你不能把這物帶到那裡去，',
    '申14:25 你就可以換成銀子，將銀子包起來，拿在手中，往耶和華─你神所要選擇的地方去。',
    '申14:26 你用這銀子，隨心所欲，或買牛羊，或買清酒濃酒，凡你心所想的都可以買；你和你的家屬在耶和華─你神的面前吃喝快樂。',
    '申14:27 住在你城裡的利未人，你不可丟棄他，因為他在你們中間無分無業。',
    '申14:28 每逢三年的末一年，你要將本年的土產十分之一都取出來，積存在你的城中。',
    '申14:29 在你城裡無分無業的利未人，和你城裡寄居的，並孤兒寡婦，都可以來，吃得飽足。這樣，耶和華─你的神必在你手裡所辦的一切事上賜福與你。',
    '申15:1 每逢七年末一年，你要施行豁免。',
    '申15:2 豁免的定例乃是這樣：凡債主要把所借給鄰舍的豁免了；不可向鄰舍和弟兄追討，因為耶和華的豁免年已經宣告了。',
    '申15:3 若借給外邦人，你可以向他追討；但借給你弟兄，無論是什麼，你要鬆手豁免了。',
    '申15:4 你若留意聽從耶和華─你神的話，謹守遵行我今日所吩咐你這一切的命令，就必在你們中間沒有窮人了（在耶和華─你神所賜你為業的地上，耶和華必大大賜福與你。）',
    '申15:5 併於上節。',
    '申15:6 因為耶和華─你的神必照他所應許你的賜福與你。你必借給許多國民，卻不致向他們借貸；你必管轄許多國民，他們卻不能管轄你。',
    '申15:7 在耶和華─你神所賜你的地上，無論哪一座城裡，你弟兄中若有一個窮人，你不可忍著心、揝著手不幫補你窮乏的弟兄。',
    '申15:8 總要向他鬆開手，照他所缺乏的借給他，補他的不足。',
    '申15:9 你要謹慎，不可心裡起惡念，說：第七年的豁免年快到了，你便惡眼看你窮乏的弟兄，什麼都不給他，以致他因你求告耶和華，罪便歸於你了。',
    '申15:10 你總要給他，給他的時候心裡不可愁煩；因耶和華─你的神必在你這一切所行的，並你手裡所辦的事上，賜福與你。',
    '申15:11 原來那地上的窮人永不斷絕；所以我吩咐你說：總要向你地上困苦窮乏的弟兄鬆開手。',
    '申15:12 你弟兄中，若有一個希伯來男人或希伯來女人被賣給你，服事你六年，到第七年就要任他自由出去。',
    '申15:13 你任他自由的時候，不可使他空手而去，',
    '申15:14 要從你羊群、禾場、酒醡之中多多地給他；耶和華─你的神怎樣賜福與你，你也要照樣給他。',
    '申15:15 要記念你在埃及地作過奴僕，耶和華─你的神將你救贖；因此，我今日吩咐你這件事。',
    '申15:16 他若對你說：我不願意離開你，是因他愛你和你的家，且因在你那裡很好，',
    '申15:17 你就要拿錐子將他的耳朵在門上刺透，他便永為你的奴僕了。你待婢女也要這樣。',
    '申15:18 你任他自由的時候，不可以為難事，因他服事你六年，較比雇工的工價多加一倍了。耶和華─你的神就必在你所做的一切事上賜福與你。',
    '申15:19 你牛群羊群中頭生的，凡是公的，都要分別為聖，歸耶和華─你的神。牛群中頭生的，不可用他耕地；羊群中頭生的，不可剪毛。',
    '申15:20 這頭生的，你和你的家屬，每年要在耶和華所選擇的地方，在耶和華─你神面前吃。',
    '申15:21 這頭生的若有什麼殘疾，就如瘸腿的、瞎眼的，無論有什麼惡殘疾，都不可獻給耶和華─你的神；',
    '申15:22 可以在你城裡吃；潔淨人與不潔淨人都可以吃，就如吃羚羊與鹿一般。',
    '申15:23 只是不可吃他的血；要倒在地上，如同倒水一樣。',
    '申16:1 你要注意亞筆月，向耶和華─你的神守逾越節，因為耶和華─你的神在亞筆月夜間領你出埃及。',
    '申16:2 你當在耶和華所選擇要立為他名的居所，從牛群羊群中，將逾越節的祭牲獻給耶和華─你的神。',
    '申16:3 你吃這祭牲，不可吃有酵的餅；七日之內要吃無酵餅，就是困苦餅─你本是急忙出了埃及地─要叫你一生一世記念你從埃及地出來的日子。',
    '申16:4 在你四境之內，七日不可見麵酵，頭一日晚上所獻的肉，一點不可留到早晨。',
    '申16:5 在耶和華─你神所賜的各城中，你不可獻逾越節的祭；',
    '申16:6 只當在耶和華─你神所選擇要立為他名的居所，晚上日落的時候，乃是你出埃及的時候，獻逾越節的祭。',
    '申16:7 當在耶和華─你神所選擇的地方把肉烤了吃（烤：或作煮），次日早晨就回到你的帳棚去。',
    '申16:8 你要吃無酵餅六日，第七日要向耶和華─你的神守嚴肅會，不可做工。',
    '申16:9 你要計算七七日：從你開鐮收割禾稼時算起，共計七七日。',
    '申16:10 你要照耶和華─你神所賜你的福，手裡拿著甘心祭，獻在耶和華─你的神面前，守七七節。',
    '申16:11 你和你兒女、僕婢，並住在你城裡的利未人，以及在你們中間寄居的與孤兒寡婦，都要在耶和華─你神所選擇立為他名的居所，在耶和華─你的神面前歡樂。',
    '申16:12 你也要記念你在埃及作過奴僕。你要謹守遵行這些律例。',
    '申16:13 你把禾場的穀、酒醡的酒收藏以後，就要守住棚節七日。',
    '申16:14 守節的時候，你和你兒女、僕婢，並住在你城裡的利未人，以及寄居的與孤兒寡婦，都要歡樂。',
    '申16:15 在耶和華所選擇的地方，你當向耶和華─你的神守節七日；因為耶和華─你神在你一切的土產上和你手裡所辦的事上要賜福與你，你就非常地歡樂。',
    '申16:16 你一切的男丁要在除酵節、七七節、住棚節，一年三次，在耶和華─你神所選擇的地方朝見他，卻不可空手朝見。',
    '申16:17 各人要按自己的力量，照耶和華─你神所賜的福分，奉獻禮物。',
    '申16:18 你要在耶和華─你神所賜的各城裡，按著各支派設立審判官和官長。他們必按公義的審判判斷百姓。',
    '申16:19 不可屈枉正直；不可看人的外貌。也不可受賄賂；因為賄賂能叫智慧人的眼變瞎了，又能顛倒義人的話。',
    '申16:20 你要追求至公至義，好叫你存活，承受耶和華─你神所賜你的地。',
    '申16:21 你為耶和華─你的神築壇，不可在壇旁栽什麼樹木作為木偶。',
    '申16:22 也不可為自己設立柱像；這是耶和華─你神所恨惡的。',
    '申17:1 凡有殘疾，或有什麼惡病的牛羊，你都不可獻給耶和華─你的神，因為這是耶和華─你神所憎惡的。',
    '申17:2 在你們中間，在耶和華─你神所賜你的諸城中，無論哪座城裡，若有人，或男或女，行耶和華─你神眼中看為惡的事，違背了他的約，',
    '申17:3 去事奉敬拜別神，或拜日頭，或拜月亮，或拜天象，是主不曾吩咐的；',
    '申17:4 有人告訴你，你也聽見了，就要細細地探聽，果然是真，準有這可憎惡的事行在以色列中，',
    '申17:5 你就要將行這惡事的男人或女人拉到城門外，用石頭將他打死。',
    '申17:6 要憑兩三個人的口作見證將那當死的人治死；不可憑一個人的口作見證將他治死。',
    '申17:7 見證人要先下手，然後眾民也下手將他治死。這樣，就把那惡從你們中間除掉。',
    '申17:8 你城中若起了爭訟的事，或因流血，或因爭競，或因毆打，是你難斷的案件，你就當起來，往耶和華─你神所選擇的地方',
    '申17:9 去見祭司利未人，並當時的審判官，求問他們，他們必將判語指示你。',
    '申17:10 他們在耶和華所選擇的地方指示你的判語，你必照著他們所指教你的一切話謹守遵行。',
    '申17:11 要按他們所指教你的律法，照他們所斷定的去行；他們所指示你的判語，你不可偏離左右。',
    '申17:12 若有人擅敢不聽從那侍立在耶和華─你神面前的祭司，或不聽從審判官，那人就必治死；這樣，便將那惡從以色列中除掉。',
    '申17:13 眾百姓都要聽見害怕，不再擅敢行事。',
    '申17:14 到了耶和華─你神所賜你的地，得了那地居住的時候，若說：我要立王治理我，像四圍的國一樣。',
    '申17:15 你總要立耶和華─你神所揀選的人為王。必從你弟兄中立一人；不可立你弟兄以外的人為王。',
    '申17:16 只是王不可為自己加添馬匹，也不可使百姓回埃及去，為要加添他的馬匹，因耶和華曾吩咐你們說：不可再回那條路去。',
    '申17:17 他也不可為自己多立妃嬪，恐怕他的心偏邪；也不可為自己多積金銀。',
    '申17:18 他登了國位，就要將祭司利未人面前的這律法書，為自己抄錄一本，',
    '申17:19 存在他那裡，要平生誦讀，好學習敬畏耶和華─他的神，謹守遵行這律法書上的一切言語和這些律例，',
    '申17:20 免得他向弟兄心高氣傲，偏左偏右，離了這誡命。這樣，他和他的子孫便可在以色列中，在國位上年長日久。',
    '申18:1 祭司利未人和利未全支派必在以色列中無分無業；他們所吃用的就是獻給耶和華的火祭和一切所捐的。',
    '申18:2 他們在弟兄中必沒有產業；耶和華是他們的產業，正如耶和華所應許他們的。',
    '申18:3 祭司從百姓所當得的分乃是這樣：凡獻牛或羊為祭的，要把前腿和兩腮並脾胃給祭司。',
    '申18:4 初收的五穀、新酒和油，並初剪的羊毛，也要給他；',
    '申18:5 因為耶和華─你的神從你各支派中將他揀選出來，使他和他子孫永遠奉耶和華的名侍立事奉。',
    '申18:6 利未人無論寄居在以色列中的哪一座城，若從那裡出來，一心願意到耶和華所選擇的地方，',
    '申18:7 就要奉耶和華─他神的名事奉，像他眾弟兄利未人侍立在耶和華面前事奉一樣。',
    '申18:8 除了他賣祖父產業所得的以外，還要得一分祭物與他們同吃。',
    '申18:9 你到了耶和華─你神所賜之地，那些國民所行可憎惡的事，你不可學著行。',
    '申18:10 你們中間不可有人使兒女經火，也不可有占卜的、觀兆的、用法術的、行邪術的、',
    '申18:11 用迷術的、交鬼的、行巫術的、過陰的。',
    '申18:12 凡行這些事的都為耶和華所憎惡；因那些國民行這可憎惡的事，所以耶和華─你的神將他們從你面前趕出。',
    '申18:13 你要在耶和華─你的神面前作完全人。',
    '申18:14 因你所要趕出的那些國民都聽信觀兆的和占卜的，至於你，耶和華─你的神從來不許你這樣行。',
    '申18:15 耶和華─你的神要從你們弟兄中間給你興起一位先知像我，你們要聽從他。',
    '申18:16 正如你在何烈山大會的日子求耶和華─你神一切的話，說：求你不再叫我聽見耶和華─我神的聲音，也不再叫我看見這大火，免得我死亡。',
    '申18:17 耶和華就對我說：他們所說的是。',
    '申18:18 我必在他們弟兄中間給他們興起一位先知像你。我要將當說的話傳給他；他要將我一切所吩咐的都傳給他們。',
    '申18:19 誰不聽他奉我名所說的話，我必討誰的罪。',
    '申18:20 若有先知擅敢託我的名說我所未曾吩咐他說的話，或是奉別神的名說話，那先知就必治死。',
    '申18:21 你心裡若說：耶和華所未曾吩咐的話，我們怎能知道呢﹖',
    '申18:22 先知託耶和華的名說話，所說的若不成就，也無效驗，這就是耶和華所未曾吩咐的，是那先知擅自說的，你不要怕他。',
    '申19:1 耶和華─你神將列國之民剪除的時候，耶和華─你神也將他們的地賜給你，你接著住他們的城邑並他們的房屋，',
    '申19:2 就要在耶和華─你神所賜你為業的地上分定三座城。',
    '申19:3 要將耶和華─你神使你承受為業的地分為三段；又要預備道路，使誤殺人的，都可以逃到那裡去。',
    '申19:4 誤殺人的逃到那裡可以存活，定例乃是這樣：凡素無仇恨，無心殺了人的，',
    '申19:5 就如人與鄰舍同入樹林砍伐樹木，手拿斧子一砍，本想砍下樹木，不料，斧頭脫了把，飛落在鄰舍身上，以致於死，這人逃到那些城的一座城，就可以存活，',
    '申19:6 免得報血仇的，心中火熱追趕他，因路遠就追上，將他殺死；其實他不該死，因為他與被殺的素無仇恨。',
    '申19:7 所以我吩咐你說，要分定三座城。',
    '申19:8 耶和華─你神若照他向你列祖所起的誓擴張你的境界，將所應許賜你列祖的地全然給你，',
    '申19:9 你若謹守遵行我今日所吩咐的這一切誡命，愛耶和華─你的神，常常遵行他的道，就要在這三座城之外，再添三座城，',
    '申19:10 免得無辜之人的血流在耶和華─你神所賜你為業的地上，流血的罪就歸於你。',
    '申19:11 若有人恨他的鄰舍，埋伏著起來擊殺他，以致於死，便逃到這些城的一座城，',
    '申19:12 本城的長老就要打發人去，從那裡帶出他來，交在報血仇的手中，將他治死。',
    '申19:13 你眼不可顧惜他，卻要從以色列中除掉流無辜血的罪，使你可以得福。',
    '申19:14 在耶和華─你神所賜你承受為業之地，不可挪移你鄰舍的地界，那是先人所定的。',
    '申19:15 人無論犯什麼罪，作什麼惡，不可憑一個人的口作見證，總要憑兩三個人的口作見證才可定案。',
    '申19:16 若有凶惡的見證人起來，見證某人作惡，',
    '申19:17 這兩個爭訟的人就要站在耶和華面前，和當時的祭司，並審判官面前，',
    '申19:18 審判官要細細地查究，若見證人果然是作假見證的，以假見證陷害弟兄，',
    '申19:19 你們就要待他如同他想要待的弟兄。這樣，就把那惡從你們中間除掉。',
    '申19:20 別人聽見都要害怕，就不敢在你們中間再行這樣的惡了。',
    '申19:21 你眼不可顧惜，要以命償命，以眼還眼，以牙還牙，以手還手，以腳還腳。',
    '申20:1 你出去與仇敵爭戰的時候，看見馬匹、車輛，並有比你多的人民，不要怕他們，因為領你出埃及地的耶和華─你神與你同在。',
    '申20:2 你們將要上陣的時候，祭司要到百姓面前宣告',
    '申20:3 說：以色列人哪，你們當聽，你們今日將要與仇敵爭戰，不要膽怯，不要懼怕戰兢，也不要因他們驚恐；',
    '申20:4 因為耶和華─你們的神與你們同去，要為你們與仇敵爭戰，拯救你們。',
    '申20:5 官長也要對百姓宣告說：誰建造房屋，尚未奉獻，他可以回家去，恐怕他陣亡，別人去奉獻。',
    '申20:6 誰種葡萄園，尚未用所結的果子，他可以回家去，恐怕他陣亡，別人去用。',
    '申20:7 誰聘定了妻，尚未迎娶，他可以回家去，恐怕他陣亡，別人去娶。',
    '申20:8 官長又要對百姓宣告說：誰懼怕膽怯，他可以回家去，恐怕他弟兄的心消化，和他一樣。',
    '申20:9 官長對百姓宣告完了，就當派軍長率領他們。',
    '申20:10 你臨近一座城、要攻打的時候，先要對城裡的民宣告和睦的話。',
    '申20:11 他們若以和睦的話回答你，給你開了城，城裡所有的人都要給你效勞，服事你；',
    '申20:12 若不肯與你和好，反要與你打仗，你就要圍困那城。',
    '申20:13 耶和華─你的神把城交付你手，你就要用刀殺盡這城的男丁。',
    '申20:14 惟有婦女、孩子、牲畜，和城內一切的財物，你可以取為自己的掠物。耶和華─你神把你仇敵的財物賜給你，你可以吃用。',
    '申20:15 離你甚遠的各城，不是這些國民的城，你都要這樣待他。',
    '申20:16 但這些國民的城，耶和華─你神既賜你為業，其中凡有氣息的，一個不可存留；',
    '申20:17 只要照耶和華─你神所吩咐的將這赫人、亞摩利人、迦南人、比利洗人、希未人、耶布斯人都滅絕淨盡，',
    '申20:18 免得他們教導你們學習一切可憎惡的事，就是他們向自己神所行的，以致你們得罪耶和華─你們的神。',
    '申20:19 你若許久圍困、攻打所要取的一座城，就不可舉斧子砍壞樹木；因為你可以吃那樹上的果子，不可砍伐。田間的樹木豈是人，叫你蹧蹋嗎﹖',
    '申20:20 惟獨你所知道不是結果子的樹木可以毀壞、砍伐，用以修築營壘，攻擊那與你打仗的城，直到攻塌了。',
    '申21:1 在耶和華─你神所賜你為業的地上，若遇見被殺的人倒在田野，不知道是誰殺的，',
    '申21:2 長老和審判官就要出去，從被殺的人那裡量起，直量到四圍的城邑，',
    '申21:3 看哪城離被殺的人最近，那城的長老就要從牛群中取一隻未曾耕地、未曾負軛的母牛犢，',
    '申21:4 把母牛犢牽到流水、未曾耕種的山谷去，在谷中打折母牛犢的頸項。',
    '申21:5 祭司利未的子孫要近前來；因為耶和華─你的神揀選了他們事奉他，奉耶和華的名祝福，所有爭訟毆打的事都要憑他們判斷。',
    '申21:6 那城的眾長老，就是離被殺的人最近的，要在那山谷中，在所打折頸項的母牛犢以上洗手，',
    '申21:7 禱告（原文作回答）說：我們的手未曾流這人的血；我們的眼也未曾看見這事。',
    '申21:8 耶和華啊，求你赦免你所救贖的以色列民，不要使流無辜血的罪歸在你的百姓以色列中間。這樣，流血的罪必得赦免。',
    '申21:9 你行耶和華眼中看為正的事，就可以從你們中間除掉流無辜血的罪。',
    '申21:10 你出去與仇敵爭戰的時候，耶和華─你的神將他們交在你手中，你就擄了他們去。',
    '申21:11 若在被擄的人中見有美貌的女子，戀慕他，要娶他為妻，',
    '申21:12 就可以領他到你家裡去；他便要剃頭髮，修指甲，',
    '申21:13 脫去被擄時所穿的衣服，住在你家裡哀哭父母一個整月，然後可以與他同房。你作他的丈夫，他作你的妻子。',
    '申21:14 後來你若不喜悅他，就要由他隨意出去，決不可為錢賣他，也不可當婢女待他，因為你玷污了他。',
    '申21:15 人若有二妻，一為所愛，一為所惡，所愛的、所惡的都給他生了兒子，但長子是所惡之妻生的。',
    '申21:16 到了把產業分給兒子承受的時候，不可將所愛之妻生的兒子立為長子，在所惡之妻生的兒子以上，',
    '申21:17 卻要認所惡之妻生的兒子為長子，將產業多加一分給他；因這兒子是他力量強壯的時候生的，長子的名分本當歸他。',
    '申21:18 人若有頑梗悖逆的兒子，不聽從父母的話，他們雖懲治他，他仍不聽從，',
    '申21:19 父母就要抓住他，將他帶到本地的城門、本城的長老那裡，',
    '申21:20 對長老說：我們這兒子頑梗悖逆，不聽從我們的話，是貪食好酒的人。',
    '申21:21 本城的眾人就要用石頭將他打死。這樣，就把那惡從你們中間除掉，以色列眾人都要聽見害怕。',
    '申21:22 人若犯該死的罪，被治死了，你將他掛在木頭上，',
    '申21:23 他的屍首不可留在木頭上過夜，必要當日將他葬埋，免得玷污了耶和華─你神所賜你為業之地。因為被掛的人是在神面前受咒詛的。',
    '申22:1 你若看見弟兄的牛或羊失迷了路，不可佯為不見，總要把他牽回來交給你的弟兄。',
    '申22:2 你弟兄若離你遠，或是你不認識他，就要牽到你家去，留在你那裡，等你弟兄來尋找就還給他。',
    '申22:3 你的弟兄無論失落什麼，或是驢，或是衣服，你若遇見，都要這樣行，不可佯為不見。',
    '申22:4 你若看見弟兄的牛或驢跌倒在路上，不可佯為不見，總要幫助他拉起來。',
    '申22:5 婦女不可穿戴男子所穿戴的，男子也不可穿婦女的衣服，因為這樣行都是耶和華─你神所憎惡的。',
    '申22:6 你若路上遇見鳥窩，或在樹上或在地上，裡頭有雛或有蛋，母鳥伏在雛上或在蛋上，你不可連母帶雛一併取去。',
    '申22:7 總要放母，只可取雛，這樣你就可以享福，日子得以長久。',
    '申22:8 你若建造房屋，要在房上的四圍安欄杆，免得有人從房上掉下來，流血的罪就歸於你家。',
    '申22:9 不可把兩樣種子種在你的葡萄園裡，免得你撒種所結的和葡萄園的果子都要充公。',
    '申22:10 不可並用牛、驢耕地。',
    '申22:11 不可穿羊毛、細麻兩樣攙雜料做的衣服。',
    '申22:12 你要在所披的外衣上四圍做繸子。',
    '申22:13 人若娶妻，與他同房之後恨惡他，',
    '申22:14 信口說他，將醜名加在他身上，說：我娶了這女子，與他同房，見他沒有貞潔的憑據；',
    '申22:15 女子的父母就要把女子貞潔的憑據拿出來，帶到本城門長老那裡。',
    '申22:16 女子的父親要對長老說：我將我的女兒給這人為妻，他恨惡他，',
    '申22:17 信口說他，說：我見你的女兒沒有貞潔的憑據；其實這就是我女兒貞潔的憑據。父母就把那布鋪在本城的長老面前。',
    '申22:18 本城的長老要拿住那人，懲治他，',
    '申22:19 並要罰他一百舍客勒銀子，給女子的父親，因為他將醜名加在以色列的一個處女身上。女子仍作他的妻，終身不可休他。',
    '申22:20 但這事若是真的，女子沒有貞潔的憑據，',
    '申22:21 就要將女子帶到他父家的門口，本城的人要用石頭將他打死；因為他在父家行了淫亂，在以色列中做了醜事。這樣，就把那惡從你們中間除掉。',
    '申22:22 若遇見人與有丈夫的婦人行淫，就要將姦夫淫婦一併治死。這樣，就把那惡從以色列中除掉。',
    '申22:23 若有處女已經許配丈夫，有人在城裡遇見他，與他行淫，',
    '申22:24 你們就要把這二人帶到本城門，用石頭打死─女子是因為雖在城裡卻沒有喊叫；男子是因為玷污別人的妻。這樣，就把那惡從你們中間除掉。',
    '申22:25 若有男子在田野遇見已經許配人的女子，強與他行淫，只要將那男子治死。',
    '申22:26 但不可辦女子；他本沒有該死的罪，這事就類乎人起來攻擊鄰舍，將他殺了一樣。',
    '申22:27 因為男子是在田野遇見那已經許配人的女子，女子喊叫，並無人救他。',
    '申22:28 若有男子遇見沒有許配人的處女，抓住他，與他行淫，被人看見，',
    '申22:29 這男子就要拿五十舍客勒銀子給女子的父親；因他玷污了這女子，就要娶他為妻，終身不可休他。',
    '申22:30 人不可娶繼母為妻；不可掀開他父親的衣襟。',
    '申23:1 凡外腎受傷的，或被閹割的，不可入耶和華的會。',
    '申23:2 私生子不可入耶和華的會；他的子孫，直到十代，也不可入耶和華的會。',
    '申23:3 亞捫人或是摩押人不可入耶和華的會；他們的子孫，雖過十代，也永不可入耶和華的會。',
    '申23:4 因為你們出埃及的時候，他們沒有拿食物和水在路上迎接你們，又因他們雇了米所波大米的毘奪人比珥的兒子巴蘭來咒詛你們。',
    '申23:5 然而耶和華─你的神不肯聽從巴蘭，卻使那咒詛的言語變為祝福的話，因為耶和華─你的神愛你。',
    '申23:6 你一生一世永不可求他們的平安和他們的利益。',
    '申23:7 不可憎惡以東人，因為他是你的弟兄。不可憎惡埃及人，因為你在他的地上作過寄居的。',
    '申23:8 他們第三代子孫可以入耶和華的會。',
    '申23:9 你出兵攻打仇敵，就要遠避諸惡。',
    '申23:10 你們中間，若有人夜間偶然夢遺，不潔淨，就要出到營外，不可入營；',
    '申23:11 到傍晚的時候，他要用水洗澡，及至日落了才可以入營。',
    '申23:12 你在營外也該定出一個地方作為便所。',
    '申23:13 在你器械之中當預備一把鍬，你出營外便溺以後，用以鏟土，轉身掩蓋。',
    '申23:14 因為耶和華─你的神常在你營中行走，要救護你，將仇敵交給你，所以你的營理當聖潔，免得他見你那裡有污穢，就離開你。',
    '申23:15 若有奴僕脫了主人的手，逃到你那裡，你不可將他交付他的主人。',
    '申23:16 他必在你那裡與你同住，在你的城邑中，要由他選擇一個所喜悅的地方居住；你不可欺負他。',
    '申23:17 以色列的女子中不可有妓女；以色列的男子中不可有孌童。',
    '申23:18 娼妓所得的錢，或孌童（原文作狗）所得的價，你不可帶入耶和華─你神的殿還願，因為這兩樣都是耶和華─你神所憎惡的。',
    '申23:19 你借給你弟兄的，或是錢財或是糧食，無論什麼可生利的物，都不可取利。',
    '申23:20 借給外邦人可以取利，只是借給你弟兄不可取利。這樣，耶和華─你神必在你所去得為業的地上和你手裡所辦的一切事上賜福與你。',
    '申23:21 你向耶和華─你的神許願，償還不可遲延；因為耶和華─你的神必定向你追討，你不償還就有罪。',
    '申23:22 你若不許願，倒無罪。',
    '申23:23 你嘴裡所出的，就是你口中應許甘心所獻的，要照你向耶和華─你神所許的願謹守遵行。',
    '申23:24 你進了鄰舍的葡萄園，可以隨意吃飽了葡萄，只是不可裝在器皿中。',
    '申23:25 你進了鄰舍站著的禾稼，可以用手摘穗子，只是不可用鐮刀割取禾稼。',
    '申24:1 人若娶妻以後，見他有什麼不合理的事，不喜悅他，就可以寫休書交在他手中，打發他離開夫家。',
    '申24:2 婦人離開夫家以後，可以去嫁別人。',
    '申24:3 後夫若恨惡他，寫休書交在他手中，打發他離開夫家，或是娶他為妻的後夫死了，',
    '申24:4 打發他去的前夫不可在婦人玷污之後再娶他為妻，因為這是耶和華所憎惡的；不可使耶和華─你神所賜為業之地被玷污了。',
    '申24:5 新娶妻之人不可從軍出征，也不可託他辦理什麼公事，可以在家清閒一年，使他所娶的妻快活。',
    '申24:6 不可拿人的全盤磨石或是上磨石作當頭，因為這是拿人的命作當頭。',
    '申24:7 若遇見人拐帶以色列中的一個弟兄，當奴才待他，或是賣了他，那拐帶人的就必治死。這樣，便將那惡從你們中間除掉。',
    '申24:8 在大痲瘋的災病上，你們要謹慎，照祭司利未人一切所指教你們的留意遵行。我怎樣吩咐他們，你們要怎樣遵行。',
    '申24:9 當記念出埃及後，在路上，耶和華─你神向米利暗所行的事。',
    '申24:10 你借給鄰舍，不拘是什麼，不可進他家拿他的當頭。',
    '申24:11 要站在外面，等那向你借貸的人把當頭拿出來交給你。',
    '申24:12 他若是窮人，你不可留他的當頭過夜。',
    '申24:13 日落的時候，總要把當頭還他，使他用那件衣服蓋著睡覺，他就為你祝福；這在耶和華─你神面前就是你的義了。',
    '申24:14 困苦窮乏的雇工，無論是你的弟兄或是在你城裡寄居的，你不可欺負他。',
    '申24:15 要當日給他工價，不可等到日落─因為他窮苦，把心放在工價上─恐怕他因你求告耶和華，罪便歸你了。',
    '申24:16 不可因子殺父，也不可因父殺子；凡被殺的都為本身的罪。',
    '申24:17 你不可向寄居的和孤兒屈枉正直，也不可拿寡婦的衣裳作當頭。',
    '申24:18 要記念你在埃及作過奴僕。耶和華─你的神從那裡將你救贖，所以我吩咐你這樣行。',
    '申24:19 你在田間收割莊稼，若忘下一捆，不可回去再取，要留給寄居的與孤兒寡婦。這樣，耶和華─你神必在你手裡所辦的一切事上賜福與你。',
    '申24:20 你打橄欖樹，枝上剩下的，不可再打；要留給寄居的與孤兒寡婦。',
    '申24:21 你摘葡萄園的葡萄，所剩下的，不可再摘；要留給寄居的與孤兒寡婦。',
    '申24:22 你也要記念你在埃及地作過奴僕，所以我吩咐你這樣行。',
    '申25:1 人若有爭訟，來聽審判，審判官就要定義人有理，定惡人有罪。',
    '申25:2 惡人若該受責打，審判官就要叫他當面伏在地上，按著他的罪照數責打。',
    '申25:3 只可打他四十下，不可過數；若過數，便是輕賤你的弟兄了。',
    '申25:4 牛在場上踹穀的時候，不可籠住他的嘴。',
    '申25:5 弟兄同居，若死了一個，沒有兒子，死人的妻不可出嫁外人，他丈夫的兄弟當盡弟兄的本分，娶他為妻，與他同房。',
    '申25:6 婦人生的長子必歸死兄的名下，免得他的名在以色列中塗抹了。',
    '申25:7 那人若不願意娶他哥哥的妻，他哥哥的妻就要到城門長老那裡，說：我丈夫的兄弟不肯在以色列中興起他哥哥的名字，不給我盡弟兄的本分。',
    '申25:8 本城的長老就要召那人來問他，他若執意說：我不願意娶他，',
    '申25:9 他哥哥的妻就要當著長老到那人的跟前，脫了他的鞋，吐唾沫在他臉上，說：凡不為哥哥建立家室的都要這樣待他。',
    '申25:10 在以色列中，他的名必稱為脫鞋之家。',
    '申25:11 若有二人爭鬥，這人的妻近前來，要救他丈夫脫離那打他丈夫之人的手，抓住那人的下體，',
    '申25:12 就要砍斷婦人的手，眼不可顧惜他。',
    '申25:13 你囊中不可有一大一小兩樣的法碼。',
    '申25:14 你家裡不可有一大一小兩樣的升斗。',
    '申25:15 當用對準公平的法碼，公平的升斗。這樣，在耶和華─你神所賜你的地上，你的日子就可以長久。',
    '申25:16 因為行非義之事的人都是耶和華─你神所憎惡的。',
    '申25:17 你要記念你們出埃及的時候，亞瑪力人在路上怎樣待你。',
    '申25:18 他們在路上遇見你，趁你疲乏困倦擊殺你儘後邊軟弱的人，並不敬畏神。',
    '申25:19 所以耶和華─你神使你不被四圍一切的仇敵擾亂，在耶和華─你神賜你為業的地上得享平安。那時，你要將亞瑪力的名號從天下塗抹了，不可忘記。',
    '申26:1 你進去得了耶和華─你神所賜你為業之地居住，',
    '申26:2 就要從耶和華─你神賜你的地上將所收的各種初熟的土產取些來，盛在筐子裡，往耶和華─你神所選擇要立為他名的居所去，',
    '申26:3 見當時作祭司的，對他說：我今日向耶和華─你神明認，我已來到耶和華向我們列祖起誓應許賜給我們的地。',
    '申26:4 祭司就從你手裡取過筐子來，放在耶和華─你神的壇前。',
    '申26:5 你要在耶和華─你神面前說：我祖原是一個將亡的亞蘭人，下到埃及寄居。他人口稀少，在那裡卻成了又大又強、人數很多的國民。',
    '申26:6 埃及人惡待我們，苦害我們，將苦工加在我們身上。',
    '申26:7 於是我們哀求耶和華─我們列祖的神，耶和華聽見我們的聲音，看見我們所受的困苦、勞碌、欺壓，',
    '申26:8 他就用大能的手和伸出來的膀臂，並大可畏的事與神蹟奇事，領我們出了埃及，',
    '申26:9 將我們領進這地方，把這流奶與蜜之地賜給我們。',
    '申26:10 耶和華啊，現在我把你所賜給我地上初熟的土產奉了來。隨後你要把筐子放在耶和華─你神面前，向耶和華─你的神下拜。',
    '申26:11 你和利未人，並在你們中間寄居的，要因耶和華─你神所賜你和你家的一切福分歡樂。',
    '申26:12 每逢三年，就是十分取一之年，你取完了一切土產的十分之一，要分給利未人和寄居的，與孤兒寡婦，使他們在你城中可以吃得飽足。',
    '申26:13 你又要在耶和華─你神面前說：我已將聖物從我家裡拿出來，給了利未人和寄居的，與孤兒寡婦，是照你所吩咐我的一切命令。你的命令我都沒有違背，也沒有忘記。',
    '申26:14 我守喪的時候，沒有吃這聖物；不潔淨的時候，也沒有拿出來，又沒有為死人送去。我聽從了耶和華─我神的話，都照你所吩咐的行了。',
    '申26:15 求你從天上、你的聖所垂看，賜福給你的百姓以色列與你所賜給我們的地，就是你向我們列祖起誓賜我們流奶與蜜之地。',
    '申26:16 耶和華─你的神今日吩咐你行這些律例典章，所以你要盡心盡性謹守遵行。',
    '申26:17 你今日認耶和華為你的神，應許遵行他的道，謹守他的律例、誡命、典章，聽從他的話。',
    '申26:18 耶和華今日照他所應許你的，也認你為他的子民，使你謹守他的一切誡命，',
    '申26:19 又使你得稱讚、美名、尊榮，超乎他所造的萬民之上，並照他所應許的使你歸耶和華─你神為聖潔的民。',
    '申27:1 摩西和以色列的眾長老吩咐百姓說：你們要遵守我今日所吩咐的一切誡命。',
    '申27:2 你們過約但河，到了耶和華─你神所賜給你的地，當天要立起幾塊大石頭，墁上石灰，',
    '申27:3 把這律法的一切話寫在石頭上。你過了河，可以進入耶和華─你神所賜你流奶與蜜之地，正如耶和華─你列祖之神所應許你的。',
    '申27:4 你們過了約但河，就要在以巴路山上照我今日所吩咐的，將這些石頭立起來，墁上石灰。',
    '申27:5 在那裡要為耶和華─你的神築一座石壇；在石頭上不可動鐵器。',
    '申27:6 要用沒有鑿過的石頭築耶和華─你神的壇，在壇上要將燔祭獻給耶和華─你的神。',
    '申27:7 又要獻平安祭，且在那裡吃，在耶和華─你的神面前歡樂。',
    '申27:8 你要將這律法的一切話明明的寫在石頭上。',
    '申27:9 摩西和祭司利未人曉諭以色列眾人說：以色列啊，要默默靜聽。你今日成為耶和華─你神的百姓了。',
    '申27:10 所以要聽從耶和華─你神的話，遵行他的誡命律例，就是我今日所吩咐你的。',
    '申27:11 當日，摩西囑咐百姓說：',
    '申27:12 你們過了約但河，西緬、利未、猶大、以薩迦、約瑟、便雅憫六個支派的人都要站在基利心山上為百姓祝福。',
    '申27:13 流便、迦得、亞設、西布倫、但、拿弗他利六個支派的人都要站在以巴路山上宣布咒詛。',
    '申27:14 利未人要向以色列眾人高聲說：',
    '申27:15 有人製造耶和華所憎惡的偶像，或雕刻，或鑄造，就是工匠手所做的，在暗中設立，那人必受咒詛！百姓都要答應說：阿們！',
    '申27:16 輕慢父母的，必受咒詛！百姓都要說：阿們！',
    '申27:17 挪移鄰舍地界的，必受咒詛！百姓都要說：阿們！',
    '申27:18 使瞎子走差路的，必受咒詛！百姓都要說：阿們！',
    '申27:19 向寄居的和孤兒寡婦屈枉正直的，必受咒詛！百姓都要說：阿們！',
    '申27:20 與繼母行淫的，必受咒詛！因為掀開他父親的衣襟。百姓都要說：阿們！',
    '申27:21 與獸淫合的，必受咒詛！百姓都要說：阿們！',
    '申27:22 與異母同父，或異父同母的姊妹行淫的，必受咒詛！百姓都要說：阿們！',
    '申27:23 與岳母行淫的，必受咒詛！百姓都要說：阿們！',
    '申27:24 暗中殺人的，必受咒詛！百姓都要說：阿們！',
    '申27:25 受賄賂害死無辜之人的，必受咒詛！百姓都要說：阿們！',
    '申27:26 不堅守遵行這律法言語的，必受咒詛！百姓都要說：阿們！',
    '申28:1 你若留意聽從耶和華─你神的話，謹守遵行他的一切誡命，就是我今日所吩咐你的，他必使你超乎天下萬民之上。',
    '申28:2 你若聽從耶和華─你神的話，這以下的福必追隨你，臨到你身上：',
    '申28:3 你在城裡必蒙福，在田間也必蒙福。',
    '申28:4 你身所生的，地所產的，牲畜所下的，以及牛犢、羊羔，都必蒙福。',
    '申28:5 你的筐子和你的摶麵盆都必蒙福。',
    '申28:6 你出也蒙福，入也蒙福。',
    '申28:7 仇敵起來攻擊你，耶和華必使他們在你面前被你殺敗；他們從一條路來攻擊你，必從七條路逃跑。',
    '申28:8 在你倉房裡，並你手所辦的一切事上，耶和華所命的福必臨到你。耶和華─你神也要在所給你的地上賜福與你。',
    '申28:9 你若謹守耶和華─你神的誡命，遵行他的道，他必照著向你所起的誓立你作為自己的聖民。',
    '申28:10 天下萬民見你歸在耶和華的名下，就要懼怕你。',
    '申28:11 你在耶和華向你列祖起誓應許賜你的地上，他必使你身所生的，牲畜所下的，地所產的，都綽綽有餘。',
    '申28:12 耶和華必為你開天上的府庫，按時降雨在你的地上。在你手裡所辦的一切事上賜福與你。你必借給許多國民，卻不致向他們借貸。',
    '申28:13 你若聽從耶和華─你神的誡命，就是我今日所吩咐你的，謹守遵行，不偏左右，也不隨從事奉別神，耶和華就必使你作首不作尾，但居上不居下。',
    '申28:14 併於上節。',
    '申28:15 你若不聽從耶和華─你神的話，不謹守遵行他的一切誡命律例，就是我今日所吩咐你的，這以下的咒詛都必追隨你，臨到你身上：',
    '申28:16 你在城裡必受咒詛，在田間也必受咒詛。',
    '申28:17 你的筐子和你的摶麵盆都必受咒詛。',
    '申28:18 你身所生的，地所產的，以及牛犢、羊羔，都必受咒詛。',
    '申28:19 你出也受咒詛，入也受咒詛。',
    '申28:20 耶和華因你行惡離棄他，必在你手裡所辦的一切事上，使咒詛、擾亂、責罰臨到你，直到你被毀滅，速速地滅亡。',
    '申28:21 耶和華必使瘟疫貼在你身上，直到他將你從所進去得為業的地上滅絕。',
    '申28:22 耶和華要用癆病、熱病、火症、瘧疾、刀劍、旱風（或作：乾旱）、霉爛攻擊你。這都要追趕你，直到你滅亡。',
    '申28:23 你頭上的天要變為銅，腳下的地要變為鐵。',
    '申28:24 耶和華要使那降在你地上的雨變為塵沙，從天臨在你身上，直到你滅亡。',
    '申28:25 耶和華必使你敗在仇敵面前，你從一條路去攻擊他們，必從七條路逃跑。你必在天下萬國中拋來拋去。',
    '申28:26 你的屍首必給空中的飛鳥和地上的走獸作食物，並無人鬨趕。',
    '申28:27 耶和華必用埃及人的瘡並痔瘡、牛皮癬與疥攻擊你，使你不能醫治。',
    '申28:28 耶和華必用癲狂、眼瞎、心驚攻擊你。',
    '申28:29 你必在午間摸索，好像瞎子在暗中摸索一樣。你所行的必不亨通，時常遭遇欺壓、搶奪，無人搭救。',
    '申28:30 你聘定了妻，別人必與他同房；你建造房屋，不得住在其內；你栽種葡萄園，也不得用其中的果子。',
    '申28:31 你的牛在你眼前宰了，你必不得吃他的肉；你的驢在你眼前被搶奪，不得歸還；你的羊歸了仇敵，無人搭救。',
    '申28:32 你的兒女必歸與別國的民；你的眼目終日切望，甚至失明，你手中無力拯救。',
    '申28:33 你的土產和你勞碌得來的，必被你所不認識的國民吃盡。你時常被欺負，受壓制，',
    '申28:34 甚至你因眼中所看見的，必致瘋狂。',
    '申28:35 耶和華必攻擊你，使你膝上腿上，從腳掌到頭頂，長毒瘡無法醫治。',
    '申28:36 耶和華必將你和你所立的王領到你和你列祖素不認識的國去；在那裡你必事奉木頭石頭的神。',
    '申28:37 你在耶和華領你到的各國中，要令人驚駭、笑談、譏誚。',
    '申28:38 你帶到田間的種子雖多，收進來的卻少，因為被蝗蟲吃了。',
    '申28:39 你栽種、修理葡萄園，卻不得收葡萄，也不得喝葡萄酒，因為被蟲子吃了。',
    '申28:40 你全境有橄欖樹，卻不得其油抹身，因為樹上的橄欖不熟自落了。',
    '申28:41 你生兒養女，卻不算是你的，因為必被擄去。',
    '申28:42 你所有的樹木和你地裡的出產必被蝗蟲所吃。',
    '申28:43 在你中間寄居的，必漸漸上升，比你高而又高；你必漸漸下降，低而又低。',
    '申28:44 他必借給你，你卻不能借給他；他必作首，你必作尾。',
    '申28:45 這一切咒詛必追隨你，趕上你，直到你滅亡；因為你不聽從耶和華─你神的話，不遵守他所吩咐的誡命律例。',
    '申28:46 這些咒詛必在你和你後裔的身上成為異蹟奇事，直到永遠！',
    '申28:47 因為你富有的時候，不歡心樂意地事奉耶和華─你的神，',
    '申28:48 所以你必在飢餓、乾渴、赤露、缺乏之中事奉耶和華所打發來攻擊你的仇敵。他必把鐵軛加在你的頸項上，直到將你滅絕。',
    '申28:49 耶和華要從遠方、地極帶一國的民，如鷹飛來攻擊你。這民的言語，你不懂得。',
    '申28:50 這民的面貌凶惡，不顧恤年老的，也不恩待年少的。',
    '申28:51 他們必吃你牲畜所下的和你地土所產的，直到你滅亡。你的五穀、新酒，和油，以及牛犢、羊羔，都不給你留下，直到將你滅絕。',
    '申28:52 他們必將你困在你各城裡，直到你所倚靠、高大堅固的城牆都被攻塌。他們必將你困在耶和華─你神所賜你遍地的各城裡。',
    '申28:53 你在仇敵圍困窘迫之中，必吃你本身所生的，就是耶和華─你神所賜給你的兒女之肉。',
    '申28:54 你們中間，柔弱嬌嫩的人必惡眼看他弟兄和他懷中的妻，並他餘剩的兒女；',
    '申28:55 甚至在你受仇敵圍困窘迫的城中，他要吃兒女的肉，不肯分一點給他的親人，因為他一無所剩。',
    '申28:56 你們中間，柔弱嬌嫩的婦人，是因嬌嫩柔弱不肯把腳踏地的，必惡眼看他懷中的丈夫和他的兒女。',
    '申28:57 他兩腿中間出來的嬰孩與他所要生的兒女，他因缺乏一切就要在你受仇敵圍困窘迫的城中將他們暗暗地吃了。',
    '申28:58 這書上所寫律法的一切話是叫你敬畏耶和華─你神可榮可畏的名。你若不謹守遵行，耶和華就必將奇災，就是至大至長的災，至重至久的病，加在你和你後裔的身上，',
    '申28:59 併於上節。',
    '申28:60 也必使你所懼怕、埃及人的病都臨到你，貼在你身上，',
    '申28:61 又必將沒有寫在這律法書上的各樣疾病、災殃降在你身上，直到你滅亡。',
    '申28:62 你們先前雖然像天上的星那樣多，卻因不聽從耶和華─你神的話，所剩的人數就稀少了。',
    '申28:63 先前耶和華怎樣喜悅善待你們，使你們眾多，也要照樣喜悅毀滅你們，使你們滅亡；並且你們從所要進去得的地上必被拔除。',
    '申28:64 耶和華必使你們分散在萬民中，從地這邊到地那邊，你必在那裡事奉你和你列祖素不認識、木頭石頭的神。',
    '申28:65 在那些國中，你必不得安逸，也不得落腳之地；耶和華卻使你在那裡心中跳動，眼目失明，精神消耗。',
    '申28:66 你的性命必懸懸無定；你晝夜恐懼，自料性命難保。',
    '申28:67 你因心裡所恐懼的，眼中所看見的，早晨必說，巴不得到晚上才好；晚上必說，巴不得到早晨才好。',
    '申28:68 耶和華必使你坐船回埃及去，走我曾告訴你不得再見的路；在那裡你必賣己身與仇敵作奴婢，卻無人買。',
    '申29:1 這是耶和華在摩押地吩咐摩西與以色列人立約的話，是在他和他們於何烈山所立的約之外。',
    '申29:2 摩西召了以色列眾人來，對他們說：耶和華在埃及地，在你們眼前向法老和他眾臣僕，並他全地所行的一切事，你們都看見了，',
    '申29:3 就是你親眼看見的大試驗和神蹟，並那些大奇事。',
    '申29:4 但耶和華到今日沒有使你們心能明白，眼能看見，耳能聽見。',
    '申29:5 我領你們在曠野四十年，你們身上的衣服並沒有穿破，腳上的鞋也沒有穿壞。',
    '申29:6 你們沒有吃餅，也沒有喝清酒濃酒。這要使你們知道，耶和華是你們的神。',
    '申29:7 你們來到這地方，希實本王西宏、巴珊王噩都出來與我們交戰，我們就擊殺了他們，',
    '申29:8 取了他們的地給流便支派、迦得支派，和瑪拿西半支派為業。',
    '申29:9 所以你們要謹守遵行這約的話，好叫你們在一切所行的事上亨通。',
    '申29:10 今日，你們的首領、族長（原文作支派）、長老、官長、以色列的男丁，你們的妻子兒女，和營中寄居的，以及為你們劈柴挑水的人，都站在耶和華─你們的神面前，',
    '申29:11 併於上節。',
    '申29:12 為要你順從耶和華─你神今日與你所立的約，向你所起的誓。',
    '申29:13 這樣，他要照他向你所應許的話，又向你列祖亞伯拉罕、以撒、雅各所起的誓，今日立你作他的子民，他作你的神。',
    '申29:14 我不但與你們立這約，起這誓，',
    '申29:15 凡與我們一同站在耶和華─我們神面前的，並今日不在我們這裡的人，我也與他們立這約，起這誓。',
    '申29:16 我們曾住過埃及地，也從列國經過；這是你們知道的。',
    '申29:17 你們也看見他們中間可憎之物，並他們木、石、金、銀的偶像。',
    '申29:18 惟恐你們中間，或男或女，或族長或支派長，今日心裡偏離耶和華─我們的神，去事奉那些國的神；又怕你們中間有惡根生出苦菜和茵蔯來，',
    '申29:19 聽見這咒詛的話，心裡仍是自誇說：我雖然行事心裡頑梗，連累眾人，卻還是平安。',
    '申29:20 耶和華必不饒恕他；耶和華的怒氣與憤恨要向他發作，如煙冒出，將這書上所寫的一切咒詛都加在他身上。耶和華又要從天下塗抹他的名，',
    '申29:21 也必照著寫在律法書上、約中的一切咒詛將他從以色列眾支派中分別出來，使他受禍。',
    '申29:22 你們的後代，就是以後興起來的子孫，和遠方來的外人，看見這地的災殃，並耶和華所降與這地的疾病，',
    '申29:23 又看見遍地有硫磺，有鹽鹵，有火跡，沒有耕種，沒有出產，連草都不生長─好像耶和華在忿怒中所傾覆的所多瑪、蛾摩拉、押瑪、洗扁一樣─',
    '申29:24 所看見的人，連萬國人，都必問說：耶和華為何向此地這樣行呢﹖這樣大發烈怒是什麼意思呢﹖',
    '申29:25 人必回答說：是因這地的人離棄了耶和華─他們列祖的神，領他們出埃及地的時候與他們所立的約，',
    '申29:26 去事奉敬拜素不認識的別神，是耶和華所未曾給他們安排的。',
    '申29:27 所以耶和華的怒氣向這地發作，將這書上所寫的一切咒詛都降在這地上。',
    '申29:28 耶和華在怒氣、忿怒、大惱恨中將他們從本地拔出來，扔在別的地上，像今日一樣。',
    '申29:29 隱祕的事是屬耶和華─我們神的；惟有明顯的事是永遠屬我們和我們子孫的，好叫我們遵行這律法上的一切話。',
    '申30:1 我所陳明在你面前的這一切咒詛都臨到你身上；你在耶和華─你神追趕你到的萬國中必心裡追念祝福的話；',
    '申30:2 你和你的子孫若盡心盡性歸向耶和華─你的神，照著我今日一切所吩咐的聽從他的話；',
    '申30:3 那時，耶和華─你的神必憐恤你，救回你這被擄的子民；耶和華─你的神要回轉過來，從分散你到的萬民中將你招聚回來。',
    '申30:4 你被趕散的人，就是在天涯的，耶和華─你的神也必從那裡將你招聚回來。',
    '申30:5 耶和華─你的神必領你進入你列祖所得的地，使你可以得著；又必善待你，使你的人數比你列祖眾多。',
    '申30:6 耶和華─你神必將你心裡和你後裔心裡的污穢除掉，好叫你盡心盡性愛耶和華─你的神，使你可以存活。',
    '申30:7 耶和華─你的神必將這一切咒詛加在你仇敵和恨惡你、逼迫你的人身上。',
    '申30:8 你必歸回，聽從耶和華的話，遵行他的一切誡命，就是我今日所吩咐你的。',
    '申30:9 你若聽從耶和華─你神的話，謹守這律法書上所寫的誡命律例，又盡心盡性歸向耶和華─你的神，他必使你手裡所辦的一切事，並你身所生的，牲畜所下的，地土所產的，都綽綽有餘；因為耶和華必再喜悅你，降福與你，像從前喜悅你列祖一樣。',
    '申30:10 併於上節。',
    '申30:11 我今日所吩咐你的誡命不是你難行的，也不是離你遠的；',
    '申30:12 不是在天上，使你說：誰替我們上天取下來，使我們聽見可以遵行呢﹖',
    '申30:13 也不是在海外，使你說：誰替我們過海取了來，使我們聽見可以遵行呢﹖',
    '申30:14 這話卻離你甚近，就在你口中，在你心裡，使你可以遵行。',
    '申30:15 看哪，我今日將生與福，死與禍，陳明在你面前。',
    '申30:16 吩咐你愛耶和華─你的神，遵行他的道，謹守他的誡命、律例、典章，使你可以存活，人數增多，耶和華─你神就必在你所要進去得為業的地上賜福與你。',
    '申30:17 倘若你心裡偏離，不肯聽從，卻被勾引去敬拜事奉別神，',
    '申30:18 我今日明明告訴你們，你們必要滅亡；在你過約但河、進去得為業的地上，你的日子必不長久。',
    '申30:19 我今日呼天喚地向你作見證；我將生死禍福陳明在你面前，所以你要揀選生命，使你和你的後裔都得存活；',
    '申30:20 且愛耶和華─你的神，聽從他的話，專靠他；因為他是你的生命，你的日子長久也在乎他。這樣，你就可以在耶和華向你列祖亞伯拉罕、以撒、雅各起誓應許所賜的地上居住。',
    '申31:1 摩西去告訴以色列眾人',
    '申31:2 說：我現在一百二十歲了，不能照常出入；耶和華也曾對我說：你必不得過這約但河。',
    '申31:3 耶和華─你們的神必引導你們過去，將這些國民在你們面前滅絕，你們就得他們的地。約書亞必引導你們過去，正如耶和華所說的。',
    '申31:4 耶和華必待他們，如同從前待他所滅絕的亞摩利二王西宏與噩以及他們的國一樣。',
    '申31:5 耶和華必將他們交給你們；你們要照我所吩咐的一切命令待他們。',
    '申31:6 你們當剛強壯膽，不要害怕，也不要畏懼他們，因為耶和華─你的神和你同去。他必不撇下你，也不丟棄你。',
    '申31:7 摩西召了約書亞來，在以色列眾人眼前對他說：你當剛強壯膽！因為，你要和這百姓一同進入耶和華向他們列祖起誓應許所賜之地；你也要使他們承受那地為業。',
    '申31:8 耶和華必在你前面行；他必與你同在，必不撇下你，也不丟棄你。不要懼怕，也不要驚惶。',
    '申31:9 摩西將這律法寫出來，交給擡耶和華約櫃的祭司利未子孫和以色列的眾長老。',
    '申31:10 摩西吩咐他們說：每逢七年的末一年，就在豁免年的定期住棚節的時候，',
    '申31:11 以色列眾人來到耶和華─你神所選擇的地方朝見他。那時，你要在以色列眾人面前將這律法念給他們聽。',
    '申31:12 要招聚他們男、女、孩子，並城裡寄居的，使他們聽，使他們學習，好敬畏耶和華─你們的神，謹守、遵行這律法的一切話，',
    '申31:13 也使他們未曾曉得這律法的兒女得以聽見，學習敬畏耶和華─你們的神，在你們過約但河要得為業之地，存活的日子，常常這樣行。',
    '申31:14 耶和華對摩西說：你的死期臨近了；要召約書亞來，你們二人站在會幕裡，我好囑咐他。於是摩西和約書亞去站在會幕裡。',
    '申31:15 耶和華在會幕裡雲柱中顯現，雲柱停在會幕門以上。',
    '申31:16 耶和華又對摩西說：你必和你列祖同睡。這百姓要起來，在他們所要去的地上，在那地的人中，隨從外邦神行邪淫，離棄我，違背我與他們所立的約。',
    '申31:17 那時，我的怒氣必向他們發作；我也必離棄他們，掩面不顧他們，以致他們被吞滅，並有許多的禍患災難臨到他們。那日他們必說：這些禍患臨到我們，豈不是因我們的神不在我們中間嗎﹖',
    '申31:18 那時，因他們偏向別神所行的一切惡，我必定掩面不顧他們。',
    '申31:19 現在你要寫一篇歌，教導以色列人，傳給他們，使這歌見證他們的不是；',
    '申31:20 因為我將他們領進我向他們列祖起誓應許那流奶與蜜之地，他們在那裡吃得飽足，身體肥胖，就必偏向別神，事奉他們，藐視我，背棄我的約。',
    '申31:21 那時，有許多禍患災難臨到他們，這歌必在他們面前作見證，他們後裔的口中必念誦不忘。我未領他們到我所起誓應許之地以先，他們所懷的意念我都知道了。',
    '申31:22 當日摩西就寫了一篇歌，教導以色列人。',
    '申31:23 耶和華囑咐嫩的兒子約書亞說：你當剛強壯膽，因為你必領以色列人進我所起誓應許他們的地；我必與你同在。',
    '申31:24 摩西將這律法的話寫在書上，及至寫完了，',
    '申31:25 就吩咐擡耶和華約櫃的利未人說：',
    '申31:26 將這律法書放在耶和華─你們神的約櫃旁，可以在那裡見證以色列人的不是；',
    '申31:27 因為我知道你們是悖逆的，是硬著頸項的。我今日還活著與你們同在，你們尚且悖逆耶和華，何況我死後呢﹖',
    '申31:28 你們要將你們支派的眾長老和官長都招聚了來，我好將這些話說與他們聽，並呼天喚地見證他們的不是。',
    '申31:29 我知道我死後，你們必全然敗壞，偏離我所吩咐你們的道，行耶和華眼中看為惡的事，以手所做的惹他發怒；日後必有禍患臨到你們。',
    '申31:30 摩西將這一篇歌的話都說與以色列全會眾聽。',
    '申32:1 諸天哪，側耳，我要說話；願地也聽我口中的言語。',
    '申32:2 我的教訓要淋漓如雨；我的言語要滴落如露，如細雨降在嫩草上，如甘霖降在菜蔬中。',
    '申32:3 我要宣告耶和華的名；你們要將大德歸與我們的神。',
    '申32:4 他是磐石，他的作為完全；他所行的無不公平，是誠實無偽的神，又公義，又正直。',
    '申32:5 這乖僻彎曲的世代向他行事邪僻；有這弊病就不是他的兒女。',
    '申32:6 愚昧無知的民哪，你們這樣報答耶和華嗎﹖他豈不是你的父、將你買來的嗎﹖他是製造你、建立你的。',
    '申32:7 你當追想上古之日，思念歷代之年；問你的父親，他必指示你；問你的長者，他必告訴你。',
    '申32:8 至高者將地業賜給列邦，將世人分開，就照以色列人的數目立定萬民的疆界。',
    '申32:9 耶和華的分本是他的百姓；他的產業本是雅各。',
    '申32:10 耶和華遇見他在曠野─荒涼野獸吼叫之地，就環繞他，看顧他，保護他，如同保護眼中的瞳人。',
    '申32:11 又如鷹攪動巢窩，在雛鷹以上兩翅搧展，接取雛鷹，背在兩翼之上。',
    '申32:12 這樣，耶和華獨自引導他，並無外邦神與他同在。',
    '申32:13 耶和華使他乘駕地的高處，得吃田間的土產；又使他從磐石中咂蜜，從堅石中吸油；',
    '申32:14 也吃牛的奶油，羊的奶，羊羔的脂油，巴珊所出的公綿羊和山羊，與上好的麥子，也喝葡萄汁釀的酒。',
    '申32:15 但耶書崙漸漸肥胖，粗壯，光潤，踢跳，奔跑，便離棄造他的神，輕看救他的磐石；',
    '申32:16 敬拜別神，觸動神的憤恨，行可憎惡的事，惹了他的怒氣。',
    '申32:17 所祭祀的鬼魔並非真神，乃是素不認識的神，是近來新興的，是你列祖所不畏懼的。',
    '申32:18 你輕忽生你的磐石，忘記產你的神。',
    '申32:19 耶和華看見他的兒女惹動他，就厭惡他們，說：',
    '申32:20 我要向他們掩面，看他們的結局如何。他們本是極乖僻的族類，心中無誠實的兒女。',
    '申32:21 他們以那不算為神的觸動我的憤恨，以虛無的神惹了我的怒氣。我也要以那不成子民的觸動他們的憤恨，以愚昧的國民惹了他們的怒氣。',
    '申32:22 因為在我怒中有火燒起，直燒到極深的陰間，把地和地的出產盡都焚燒，山的根基也燒著了。',
    '申32:23 我要將禍患堆在他們身上，把我的箭向他們射盡。',
    '申32:24 他們必因飢餓消瘦，被炎熱苦毒吞滅。我要打發野獸用牙齒咬他們，並土中腹行的，用毒氣害他們。',
    '申32:25 外頭有刀劍，內室有驚恐，使人喪亡，使少男、童女、吃奶的、白髮的，盡都滅絕。',
    '申32:26 我說，我必將他們分散遠方，使他們的名號從人間除滅。',
    '申32:27 惟恐仇敵惹動我，只怕敵人錯看，說：是我們手的能力，並非耶和華所行的。',
    '申32:28 因為以色列民毫無計謀，心中沒有聰明。',
    '申32:29 惟願他們有智慧，能明白這事，肯思念他們的結局。',
    '申32:30 若不是他們的磐石賣了他們，若不是耶和華交出他們，一人焉能追趕他們千人﹖二人焉能使萬人逃跑呢﹖',
    '申32:31 據我們的仇敵自己斷定，他們的磐石不如我們的磐石。',
    '申32:32 他們的葡萄樹是所多瑪的葡萄樹，蛾摩拉田園所生的；他們的葡萄是毒葡萄，全掛都是苦的。',
    '申32:33 他們的酒是大蛇的毒氣，是虺蛇殘害的惡毒。',
    '申32:34 這不都是積蓄在我這裡，封鎖在我府庫中嗎﹖',
    '申32:35 他們失腳的時候，伸冤報應在我；因他們遭災的日子近了；那要臨在他們身上的必速速來到。',
    '申32:36 耶和華見他百姓毫無能力，無論困住的、自由的都沒有剩下，就必為他們伸冤，為他的僕人後悔。',
    '申32:37 他必說：他們的神，他們所投靠的磐石，',
    '申32:38 就是向來吃他們祭牲的脂油，喝他們奠祭之酒的，在哪裡呢﹖他可以興起幫助你們，護衛你們。',
    '申32:39 你們如今要知道：我，惟有我是神；在我以外並無別神。我使人死，我使人活；我損傷，我也醫治，並無人能從我手中救出來。',
    '申32:40 我向天舉手說：我憑我的永生起誓：',
    '申32:41 我若磨我閃亮的刀，手掌審判之權，就必報復我的敵人，報應恨我的人。',
    '申32:42 我要使我的箭飲血飲醉，就是被殺被擄之人的血。我的刀要吃肉，乃是仇敵中首領之頭的肉。',
    '申32:43 你們外邦人當與主的百姓一同歡呼；因他要伸他僕人流血的冤，報應他的敵人，潔淨他的地，救贖他的百姓。',
    '申32:44 摩西和嫩的兒子約書亞去將這歌的一切話說給百姓聽。',
    '申32:45 摩西向以色列眾人說完了這一切的話，',
    '申32:46 又說：我今日所警教你們的，你們都要放在心上；要吩咐你們的子孫謹守遵行這律法上的話。',
    '申32:47 因為這不是虛空、與你們無關的事，乃是你們的生命；在你們過約但河要得為業的地上必因這事日子得以長久。',
    '申32:48 當日，耶和華吩咐摩西說：',
    '申32:49 你上這亞巴琳山中的尼波山去，在摩押地與耶利哥相對，觀看我所要賜給以色列人為業的迦南地。',
    '申32:50 你必死在你所登的山上，歸你列祖（原文作本民）去，像你哥哥亞倫死在何珥山上，歸他的列祖一樣。',
    '申32:51 因為你們在尋的曠野，加低斯的米利巴水，在以色列人中沒有尊我為聖，得罪了我。',
    '申32:52 我所賜給以色列人的地，你可以遠遠地觀看，卻不得進去。',
    '申33:1 以下是神人摩西在未死之先為以色列人所祝的福：',
    '申33:2 他說：耶和華從西乃而來，從西珥向他們顯現，從巴蘭山發出光輝，從萬萬聖者中來臨，從他右手為百姓傳出烈火的律法。',
    '申33:3 他疼愛百姓；眾聖徒都在他手中。他們坐在他的腳下，領受他的言語。',
    '申33:4 摩西將律法傳給我們，作為雅各會眾的產業。',
    '申33:5 百姓的眾首領，以色列的各支派，一同聚會的時候，耶和華（原文作他）在耶書崙中為王。',
    '申33:6 願流便存活，不致死亡；願他人數不致稀少。',
    '申33:7 為猶大祝福說：求耶和華俯聽猶大的聲音，引導他歸於本族；他曾用手為自己爭戰，你必幫助他攻擊敵人。',
    '申33:8 論利未說：耶和華啊，你的土明和烏陵都在你的虔誠人那裡。你在瑪撒曾試驗他，在米利巴水與他爭論。',
    '申33:9 他論自己的父母說：我未曾看見；他也不承認弟兄，也不認識自己的兒女。這是因利未人遵行你的話，謹守你的約。',
    '申33:10 他們要將你的典章教訓雅各，將你的律法教訓以色列。他們要把香焚在你面前，把全牲的燔祭獻在你的壇上。',
    '申33:11 求耶和華降福在他的財物上，悅納他手裡所辦的事。那些起來攻擊他和恨惡他的人，願你刺透他們的腰，使他們不得再起來。',
    '申33:12 論便雅憫說：耶和華所親愛的必同耶和華安然居住；耶和華終日遮蔽他，也住在他兩肩之中。',
    '申33:13 論約瑟說：願他的地蒙耶和華賜福，得天上的寶物、甘露，以及地裡所藏的泉水；',
    '申33:14 得太陽所曬熟的美果，月亮所養成的寶物；',
    '申33:15 得上古之山的至寶，永世之嶺的寶物；',
    '申33:16 得地和其中所充滿的寶物，並住荊棘中上主的喜悅。願這些福都歸於約瑟的頭上，歸於那與弟兄迥別之人的頂上。',
    '申33:17 他為牛群中頭生的，有威嚴；他的角是野牛的角，用以牴觸萬邦，直到地極。這角是以法蓮的萬萬，瑪拿西的千千。',
    '申33:18 論西布倫說：西布倫哪，你出外可以歡喜。以薩迦啊，在你帳棚裡可以快樂。',
    '申33:19 他們要將列邦召到山上，在那裡獻公義的祭；因為他們要吸取海裡的豐富，並沙中所藏的珍寶。',
    '申33:20 論迦得說：使迦得擴張的應當稱頌！迦得住如母獅；他撕裂膀臂，連頭頂也撕裂。',
    '申33:21 他為自己選擇頭一段地，因在那裡有設立律法者的分存留。他與百姓的首領同來；他施行耶和華的公義和耶和華與以色列所立的典章。',
    '申33:22 論但說：但為小獅子，從巴珊跳出來。',
    '申33:23 論拿弗他利說：拿弗他利啊，你足沾恩惠，滿得耶和華的福，可以得西方和南方為業。',
    '申33:24 論亞設說：願亞設享受多子的福樂，得他弟兄的喜悅，可以把腳蘸在油中。',
    '申33:25 你的門閂（門閂或作：鞋）是銅的，鐵的。你的日子如何，你的力量也必如何。',
    '申33:26 耶書崙哪，沒有能比神的。他為幫助你，乘在天空，顯其威榮，駕行穹蒼。',
    '申33:27 永生的神是你的居所；他永久的膀臂在你以下。他在你前面攆出仇敵，說：毀滅吧。',
    '申33:28 以色列安然居住；雅各的本源獨居五穀新酒之地。他的天也滴甘露。',
    '申33:29 以色列啊，你是有福的！誰像你這蒙耶和華所拯救的百姓呢﹖他是你的盾牌，幫助你，是你威榮的刀劍。你的仇敵必投降你；你必踏在他們的高處。',
    '申34:1 摩西從摩押平原登尼波山，上了那與耶利哥相對的毘斯迦山頂。耶和華把基列全地直到但，',
    '申34:2 拿弗他利全地，以法蓮、瑪拿西的地，猶大全地直到西海，',
    '申34:3 南地和棕樹城耶利哥的平原，直到瑣珥，都指給他看。',
    '申34:4 耶和華對他說：這就是我向亞伯拉罕、以撒、雅各起誓應許之地，說：我必將這地賜給你的後裔。現在我使你眼睛看見了，你卻不得過到那裡去。',
    '申34:5 於是，耶和華的僕人摩西死在摩押地，正如耶和華所說的。',
    '申34:6 耶和華將他埋葬在摩押地、伯毘珥對面的谷中，只是到今日沒有人知道他的墳墓。',
    '申34:7 摩西死的時候年一百二十歲；眼目沒有昏花，精神沒有衰敗。',
    '申34:8 以色列人在摩押平原為摩西哀哭了三十日，為摩西居喪哀哭的日子就滿了。',
    '申34:9 嫩的兒子約書亞；因為摩西曾按手在他頭上，就被智慧的靈充滿，以色列人便聽從他，照著耶和華吩咐摩西的行了。',
    '申34:10 以後以色列中再沒有興起先知像摩西的。他是耶和華面對面所認識的。',
    '申34:11 耶和華打發他在埃及地向法老和他的一切臣僕，並他的全地，行各樣神蹟奇事，',
    '申34:12 又在以色列眾人眼前顯大能的手，行一切大而可畏的事。',
    '書1:1 耶和華的僕人摩西死了以後，耶和華曉諭摩西的幫手，嫩的兒子約書亞，說：',
    '書1:2 我的僕人摩西死了。現在你要起來，和眾百姓過這約但河，往我所要賜給以色列人的地去。',
    '書1:3 凡你們腳掌所踏之地，我都照著我所應許摩西的話賜給你們了。',
    '書1:4 從曠野和這利巴嫩，直到伯拉大河，赫人的全地，又到大海日落之處，都要作你們的境界。',
    '書1:5 你平生的日子，必無一人能在你面前站立得住。我怎樣與摩西同在，也必照樣與你同在；我必不撇下你，也不丟棄你。',
    '書1:6 你當剛強壯膽！因為你必使這百姓承受那地為業，就是我向他們列祖起誓應許賜給他們的地。',
    '書1:7 只要剛強，大大壯膽，謹守遵行我僕人摩西所吩咐你的一切律法，不可偏離左右，使你無論往哪裡去，都可以順利。',
    '書1:8 這律法書不可離開你的口，總要晝夜思想，好使你謹守遵行這書上所寫的一切話。如此，你的道路就可以亨通，凡事順利。',
    '書1:9 我豈沒有吩咐你嗎﹖你當剛強壯膽！不要懼怕，也不要驚惶；因為你無論往哪裡去，耶和華─你的神必與你同在。',
    '書1:10 於是，約書亞吩咐百姓的官長說：',
    '書1:11 你們要走遍營中，吩咐百姓說：當預備食物；因為三日之內你們要過這約但河，進去得耶和華─你們神賜你們為業之地。',
    '書1:12 約書亞對流便人、迦得人，和瑪拿西半支派的人說：',
    '書1:13 你們要追念耶和華的僕人摩西所吩咐你們的話說：耶和華─你們的神使你們得享平安，也必將這地賜給你們。',
    '書1:14 你們的妻子、孩子，和牲畜都可以留在約但河東、摩西所給你們的地；但你們中間一切大能的勇士都要帶著兵器在你們的弟兄前面過去，幫助他們，',
    '書1:15 等到耶和華使你們的弟兄像你們一樣得享平安，並且得著耶和華─你們神所賜他們為業之地，那時才可以回你們所得之地，承受為業，就是耶和華的僕人摩西在約但河東、向日出之地所給你們的。',
    '書1:16 他們回答約書亞說：你所吩咐我們行的，我們都必行；你所差遣我們去的，我們都必去。',
    '書1:17 我們從前在一切事上怎樣聽從摩西，現在也必照樣聽從你；惟願耶和華─你的神與你同在，像與摩西同在一樣。',
    '書1:18 無論什麼人違背你的命令，不聽從你所吩咐他的一切話，就必治死他。你只要剛強壯膽！',
    '書2:1 當下，嫩的兒子約書亞從什亭暗暗打發兩個人作探子，吩咐說：你們去窺探那地和耶利哥。於是二人去了，來到一個妓女名叫喇合的家裡，就在那裡躺臥。',
    '書2:2 有人告訴耶利哥王說：今夜有以色列人來到這裡窺探此地。',
    '書2:3 耶利哥王打發人去見喇合說：那來到你這裡、進了你家的人要交出來，因為他們來窺探全地。',
    '書2:4 女人將二人隱藏，就回答說：那人果然到我這裡來；他們是哪裡來的我卻不知道。',
    '書2:5 天黑、要關城門的時候，他們出去了，往哪裡去我卻不知道。你們快快地去追趕，就必追上。',
    '書2:6 （先是女人領二人上了房頂，將他們藏在那裡所擺的麻稭中。）',
    '書2:7 那些人就往約但河的渡口追趕他們去了。追趕他們的人一出去，城門就關了。',
    '書2:8 二人還沒有躺臥，女人就上房頂，到他們那裡，',
    '書2:9 對他們說：我知道耶和華已經把這地賜給你們，並且因你們的緣故我們都驚慌了。這地的一切居民在你們面前心都消化了；',
    '書2:10 因為我們聽見你們出埃及的時候，耶和華怎樣在你們前面使紅海的水乾了，並且你們怎樣待約但河東的兩個亞摩利王西宏和噩，將他們盡行毀滅。',
    '書2:11 我們一聽見這些事，心就消化了。因你們的緣故，並無一人有膽氣。耶和華─你們的神本是上天下地的神。',
    '書2:12 現在我既是恩待你們，求你們指著耶和華向我起誓，也要恩待我父家，並給我一個實在的證據，',
    '書2:13 要救活我的父母、弟兄、姊妹，和一切屬他們的，拯救我們性命不死。',
    '書2:14 二人對他說：你若不洩漏我們這件事，我們情願替你們死。耶和華將這地賜給我們的時候，我們必以慈愛誠實待你。',
    '書2:15 於是女人用繩子將二人從窗戶裡縋下去；因他的房子是在城牆邊上，他也住在城牆上。',
    '書2:16 他對他們說：你們且往山上去，恐怕追趕的人碰見你們；要在那裡隱藏三天，等追趕的人回來，然後才可以走你們的路。',
    '書2:17 二人對他說：你要這樣行。不然，你叫我們所起的誓就與我們無干了。',
    '書2:18 我們來到這地的時候，你要把這條朱紅線繩繫在縋我們下去的窗戶上，並要使你的父母、弟兄，和你父的全家都聚集在你家中。',
    '書2:19 凡出了你家門往街上去的，他的罪（原文是血）必歸到自己的頭上，與我們無干了。凡在你家裡的，若有人下手害他，流他血的罪就歸到我們的頭上。',
    '書2:20 你若洩漏我們這件事，你叫我們所起的誓就與我們無干了。',
    '書2:21 女人說：照你們的話行吧！於是打發他們去了，又把朱紅線繩繫在窗戶上。',
    '書2:22 二人到山上，在那裡住了三天，等著追趕的人回去了。追趕的人一路找他們，卻找不著。',
    '書2:23 二人就下山回來，過了河，到嫩的兒子約書亞那裡，向他述說所遭遇的一切事；',
    '書2:24 又對約書亞說：耶和華果然將那全地交在我們手中；那地的一切居民在我們面前心都消化了。',
    '書3:1 約書亞清早起來，和以色列眾人都離開什亭，來到約但河，就住在那裡，等候過河。',
    '書3:2 過了三天，官長走遍營中，',
    '書3:3 吩咐百姓說：你們看見耶和華─你們神的約櫃，又見祭司利未人擡著，就要離開所住的地方，跟著約櫃去。',
    '書3:4 只是你們和約櫃相離要量二千肘，不可與約櫃相近，使你們知道所當走的路，因為這條路你們向來沒有走過。',
    '書3:5 約書亞吩咐百姓說：你們要自潔，因為明天耶和華必在你們中間行奇事。',
    '書3:6 約書亞又吩咐祭司說：你們擡起約櫃，在百姓前頭過去。於是他們擡起約櫃，在百姓前頭走。',
    '書3:7 耶和華對約書亞說：從今日起，我必使你在以色列眾人眼前尊大，使他們知道我怎樣與摩西同在，也必照樣與你同在。',
    '書3:8 你要吩咐擡約櫃的祭司說：你們到了約但河的水邊上，就要在約但河水裡站住。',
    '書3:9 約書亞對以色列人說：你們近前來，聽耶和華─你們神的話。',
    '書3:10 約書亞說：看哪，普天下主的約櫃必在你們前頭過去，到約但河裡，因此你們就知道在你們中間有永生神；並且他必在你們面前趕出迦南人、赫人、希未人、比利洗人、革迦撒人、亞摩利人、耶布斯人。',
    '書3:11 併於上節。',
    '書3:12 你們現在要從以色列支派中揀選十二個人，每支派一人，',
    '書3:13 等到擡普天下主耶和華約櫃的祭司把腳站在約但河水裡，約但河的水，就是從上往下流的水，必然斷絕，立起成壘。',
    '書3:14 百姓離開帳棚要過約但河的時候，擡約櫃的祭司乃在百姓的前頭。',
    '書3:15 他們到了約但河，腳一入水（原來約但河水在收割的日子漲過兩岸），',
    '書3:16 那從上往下流的水便在極遠之地、撒拉但旁的亞當城那裡停住，立起成壘；那往亞拉巴的海，就是鹽海，下流的水全然斷絕。於是百姓在耶利哥的對面過去了。',
    '書3:17 擡耶和華約櫃的祭司在約但河中的乾地上站定，以色列眾人都從乾地上過去，直到國民盡都過了約但河。',
    '書4:1 國民盡都過了約但河，耶和華就對約書亞說：',
    '書4:2 你從民中要揀選十二個人，每支派一人，',
    '書4:3 吩咐他們說：你們從這裡，從約但河中、祭司腳站定的地方，取十二塊石頭帶過去，放在你們今夜要住宿的地方。',
    '書4:4 於是，約書亞將他從以色列人中所預備的那十二個人，每支派一人，都召了來。',
    '書4:5 對他們說：你們下約但河中，過到耶和華─你們神的約櫃前頭，按著以色列人十二支派的數目，每人取一塊石頭扛在肩上。',
    '書4:6 這些石頭在你們中間可以作為證據。日後，你們的子孫問你們說：這些石頭是什麼意思﹖',
    '書4:7 你們就對他們說：這是因為約但河的水在耶和華的約櫃前斷絕；約櫃過約但河的時候，約但河的水就斷絕了。這些石頭要作以色列人永遠的記念。',
    '書4:8 以色列人就照約書亞所吩咐的，按著以色列人支派的數目，從約但河中取了十二塊石頭，都遵耶和華所吩咐約書亞的行了。他們把石頭帶過去，到他們所住宿的地方，就放在那裡。',
    '書4:9 約書亞另把十二塊石頭立在約但河中，在擡約櫃的祭司腳站立的地方；直到今日，那石頭還在那裡。',
    '書4:10 擡約櫃的祭司站在約但河中，等到耶和華曉諭約書亞吩咐百姓的事辦完了，是照摩西所吩咐約書亞的一切話。於是百姓急速過去了。',
    '書4:11 眾百姓盡都過了河，耶和華的約櫃和祭司就在百姓面前過去。',
    '書4:12 流便人、迦得人、瑪拿西半支派的人都照摩西所吩咐他們的，帶著兵器在以色列人前頭過去。',
    '書4:13 約有四萬人都準備打仗，在耶和華面前過去，到耶利哥的平原，等候上陣。',
    '書4:14 當那日，耶和華使約書亞在以色列眾人眼前尊大。在他平生的日子，百姓敬畏他，像從前敬畏摩西一樣。',
    '書4:15 耶和華曉諭約書亞說：',
    '書4:16 你吩咐擡法櫃的祭司從約但河裡上來。',
    '書4:17 約書亞就吩咐祭司說：你們從約但河裡上來。',
    '書4:18 擡耶和華約櫃的祭司從約但河裡上來，腳掌剛落旱地，約但河的水就流到原處，仍舊漲過兩岸。',
    '書4:19 正月初十日，百姓從約但河裡上來，就在吉甲，在耶利哥的東邊安營。',
    '書4:20 他們從約但河中取來的那十二塊石頭，約書亞就立在吉甲，',
    '書4:21 對以色列人說：日後你們的子孫問他們的父親說：這些石頭是什麼意思﹖',
    '書4:22 你們就告訴他們說：以色列人曾走乾地過這約但河；',
    '書4:23 因為耶和華─你們的神在你們前面使約但河的水乾了，等著你們過來，就如耶和華─你們的神從前在我們前面使紅海乾了，等著我們過來一樣，',
    '書4:24 要使地上萬民都知道，耶和華的手大有能力，也要使你們永遠敬畏耶和華─你們的神。',
    '書5:1 約但河西亞摩利人的諸王和靠海迦南人的諸王，聽見耶和華在以色列人前面使約但河的水乾了，等到我們過去，他們的心因以色列人的緣故就消化了，不再有膽氣。',
    '書5:2 那時，耶和華吩咐約書亞說：你製造火石刀，第二次給以色列人行割禮。',
    '書5:3 約書亞就製造了火石刀，在除皮山那裡給以色列人行割禮。',
    '書5:4 約書亞行割禮的緣故，是因為從埃及出來的眾民，就是一切能打仗的男丁，出了埃及以後，都死在曠野的路上。',
    '書5:5 因為出來的眾民都受過割禮；惟獨出埃及以後、在曠野的路上所生的眾民都沒有受過割禮。',
    '書5:6 以色列人在曠野走了四十年，等到國民，就是出埃及的兵丁，都消滅了，因為他們沒有聽從耶和華的話。耶和華曾向他們起誓，必不容他們看見耶和華向他們列祖起誓、應許賜給我們的地，就是流奶與蜜之地。',
    '書5:7 他們的子孫，就是耶和華所興起來接續他們的，都沒有受過割禮；因為在路上沒有給他們行割禮，約書亞這才給他們行了。',
    '書5:8 國民都受完了割禮，就住在營中自己的地方，等到痊癒了。',
    '書5:9 耶和華對約書亞說：我今日將埃及的羞辱從你們身上滾去了。因此，那地方名叫吉甲（吉甲就是滾的意思），直到今日。',
    '書5:10 以色列人在吉甲安營。正月十四日晚上，在耶利哥的平原守逾越節。',
    '書5:11 逾越節的次日，他們就吃了那地的出產；正當那日吃無酵餅和烘的穀。',
    '書5:12 他們吃了那地的出產，第二日嗎哪就止住了，以色列人也不再有嗎哪了。那一年，他們卻吃迦南地的出產。',
    '書5:13 約書亞靠近耶利哥的時候，舉目觀看，不料，有一個人手裡有拔出來的刀，對面站立。約書亞到他那裡，問他說：你是幫助我們呢，是幫助我們敵人呢﹖',
    '書5:14 他回答說：不是的，我來是要作耶和華軍隊的元帥。約書亞就俯伏在地下拜，說：我主有什麼話吩咐僕人。',
    '書5:15 耶和華軍隊的元帥對約書亞說：把你腳上的鞋脫下來，因為你所站的地方是聖的。約書亞就照著行了。',
    '書6:1 耶利哥的城門因以色列人就關得嚴緊，無人出入。',
    '書6:2 耶和華曉諭約書亞說：看哪，我已經把耶利哥和耶利哥的王，並大能的勇士，都交在你手中。',
    '書6:3 你們的一切兵丁要圍繞這城，一日圍繞一次，六日都要這樣行。',
    '書6:4 七個祭司要拿七個羊角走在約櫃前。到第七日，你們要繞城七次，祭司也要吹角。',
    '書6:5 他們吹的角聲拖長，你們聽見角聲，眾百姓要大聲呼喊，城牆就必塌陷，各人都要往前直上。',
    '書6:6 嫩的兒子約書亞召了祭司來，吩咐他們說：你們擡起約櫃來，要有七個祭司拿七個羊角走在耶和華的約櫃前；',
    '書6:7 又對百姓說：你們前去繞城，帶兵器的要走在耶和華的約櫃前。',
    '書6:8 約書亞對百姓說完了話，七個祭司拿七個羊角走在耶和華面前吹角；耶和華的約櫃在他們後面跟隨。',
    '書6:9 帶兵器的走在吹角的祭司前面，後隊隨著約櫃行。祭司一面走一面吹。',
    '書6:10 約書亞吩咐百姓說：你們不可呼喊，不可出聲，連一句話也不可出你們的口，等到我吩咐你們呼喊的日子，那時才可以呼喊。',
    '書6:11 這樣，他使耶和華的約櫃繞城，把城繞了一次；眾人回到營裡，就在營裡住宿。',
    '書6:12 約書亞清早起來，祭司又擡起耶和華的約櫃。',
    '書6:13 七個祭司拿七個羊角在耶和華的約櫃前，時常行走吹角；帶兵器的在他們前面走，後隊隨著耶和華的約櫃行。祭司一面走一面吹。',
    '書6:14 第二日，眾人把城繞了一次，就回營裡去。六日都是這樣行。',
    '書6:15 第七日清早，黎明的時候，他們起來，照樣繞城七次；惟獨這日把城繞了七次。',
    '書6:16 到了第七次，祭司吹角的時候，約書亞吩咐百姓說：呼喊吧，因為耶和華已經把城交給你們了！',
    '書6:17 這城和其中所有的都要在耶和華面前毀滅；只有妓女喇合與他家中所有的可以存活，因為他隱藏了我們所打發的使者。',
    '書6:18 至於你們，務要謹慎，不可取那當滅的物，恐怕你們取了那當滅的物就連累以色列的全營，使全營受咒詛。',
    '書6:19 惟有金子、銀子，和銅鐵的器皿都要歸耶和華為聖，必入耶和華的庫中。',
    '書6:20 於是百姓呼喊，祭司也吹角。百姓聽見角聲，便大聲呼喊，城牆就塌陷，百姓便上去進城，各人往前直上，將城奪取。',
    '書6:21 又將城中所有的，不拘男女老少，牛羊和驢，都用刀殺盡。',
    '書6:22 約書亞吩咐窺探地的兩個人說：你們進那妓女的家，照著你們向他所起的誓，將那女人和他所有的都從那裡帶出來。',
    '書6:23 當探子的兩個少年人就進去，將喇合與他的父母、弟兄，和他所有的，並他一切的親眷，都帶出來，安置在以色列的營外。',
    '書6:24 眾人就用火將城和其中所有的焚燒了；惟有金子、銀子，和銅鐵的器皿都放在耶和華殿的庫中。',
    '書6:25 約書亞卻把妓女喇合與他父家，並他所有的，都救活了；因為他隱藏了約書亞所打發窺探耶利哥的使者，他就住在以色列中，直到今日。',
    '書6:26 當時，約書亞叫眾人起誓說：有興起重修這耶利哥城的人，當在耶和華面前受咒詛。他立根基的時候，必喪長子，安門的時候，必喪幼子。',
    '書6:27 耶和華與約書亞同在，約書亞的聲名傳揚遍地。',
    '書7:1 以色列人在當滅的物上犯了罪；因為猶大支派中，謝拉的曾孫，撒底的孫子，迦米的兒子亞干取了當滅的物；耶和華的怒氣就向以色列人發作。',
    '書7:2 當下，約書亞從耶利哥打發人往伯特利東邊、靠近伯亞文的艾城去，吩咐他們說：你們上去窺探那地。他們就上去窺探艾城。',
    '書7:3 他們回到約書亞那裡，對他說：眾民不必都上去，只要二三千人上去就能攻取艾城；不必勞累眾民都去，因為那裡的人少。',
    '書7:4 於是民中約有三千人上那裡去，竟在艾城人面前逃跑了。',
    '書7:5 艾城的人擊殺了他們三十六人，從城門前追趕他們，直到示巴琳，在下坡殺敗他們；眾民的心就消化如水。',
    '書7:6 約書亞便撕裂衣服；他和以色列的長老把灰撒在頭上，在耶和華的約櫃前俯伏在地，直到晚上。',
    '書7:7 約書亞說：哀哉！主耶和華啊，你為什麼竟領這百姓過約但河，將我們交在亞摩利人的手中，使我們滅亡呢﹖我們不如住在約但河那邊倒好。',
    '書7:8 主啊，以色列人既在仇敵面前轉背逃跑，我還有什麼可說的呢﹖',
    '書7:9 迦南人和這地一切的居民聽見了就必圍困我們，將我們的名從地上除滅。那時你為你的大名要怎樣行呢﹖',
    '書7:10 耶和華吩咐約書亞說：起來！你為何這樣俯伏在地呢﹖',
    '書7:11 以色列人犯了罪，違背了我所吩咐他們的約，取了當滅的物；又偷竊，又行詭詐，又把那當滅的放在他們的家具裡。',
    '書7:12 因此，以色列人在仇敵面前站立不住。他們在仇敵面前轉背逃跑，是因成了被咒詛的；你們若不把當滅的物從你們中間除掉，我就不再與你們同在了。',
    '書7:13 你起來，叫百姓自潔，對他們說：你們要自潔，預備明天，因為耶和華─以色列的神這樣說：以色列啊，你們中間有當滅的物，你們若不除掉，在仇敵面前必站立不住！',
    '書7:14 到了早晨，你們要按著支派近前來；耶和華所取的支派，要按著宗族近前來；耶和華所取的宗族，要按著家室近前來；耶和華所取的家室，要按著人丁，一個一個的近前來。',
    '書7:15 被取的人有當滅的物在他那裡，他和他所有的必被火焚燒；因他違背了耶和華的約，又因他在以色列中行了愚妄的事。',
    '書7:16 於是，約書亞清早起來，使以色列人按著支派近前來，取出來的是猶大支派；',
    '書7:17 使猶大支派（原文是宗族）近前來，就取了謝拉的宗族；使謝拉的宗族，按著家室人丁，一個一個的近前來，取出來的是撒底；',
    '書7:18 使撒底的家室，按著人丁，一個一個的近前來，就取出猶大支派的人謝拉的曾孫，撒底的孫子，迦米的兒子亞干。',
    '書7:19 約書亞對亞干說：我兒，我勸你將榮耀歸給耶和華─以色列的神，在他面前認罪，將你所做的事告訴我，不要向我隱瞞。',
    '書7:20 亞干回答約書亞說：我實在得罪了耶和華─以色列的神。我所做的事如此如此：',
    '書7:21 我在所奪的財物中看見一件美好的示拿衣服，二百舍客勒銀子，一條金子重五十舍客勒，我就貪愛這些物件，便拿去了。現今藏在我帳棚內的地裡，銀子在衣服底下。',
    '書7:22 約書亞就打發人跑到亞干的帳棚裡。那件衣服果然藏在他帳棚內，銀子在底下。',
    '書7:23 他們就從帳棚裡取出來，拿到約書亞和以色列眾人那裡，放在耶和華面前。',
    '書7:24 約書亞和以色列眾人把謝拉的曾孫亞干和那銀子、那件衣服、那條金子，並亞干的兒女、牛、驢、羊、帳棚，以及他所有的，都帶到亞割谷去。',
    '書7:25 約書亞說：你為什麼連累我們呢﹖今日耶和華必叫你受連累。於是以色列眾人用石頭打死他，將石頭扔在其上，又用火焚燒他所有的（他所有的原文作他們）。',
    '書7:26 眾人在亞干身上堆成一大堆石頭，直存到今日。於是耶和華轉意，不發他的烈怒。因此那地方名叫亞割谷（亞割就是連累的意思），直到今日。',
    '書8:1 耶和華對約書亞說：不要懼怕，也不要驚惶。你起來，率領一切兵丁上艾城去，我已經把艾城的王和他的民、他的城，並他的地，都交在你手裡。',
    '書8:2 你怎樣待耶利哥和耶利哥的王，也當照樣待艾城和艾城的王。只是城內所奪的財物和牲畜，你們可以取為自己的掠物。你要在城後設下伏兵。',
    '書8:3 於是，約書亞和一切兵丁都起來，要上艾城去。約書亞選了三萬大能的勇士，夜間打發他們前往，',
    '書8:4 吩咐他們說：你們要在城後埋伏，不可離城太遠，都要各自準備。',
    '書8:5 我與我所帶領的眾民要向城前往。城裡的人像初次出來攻擊我們的時候，我們就在他們面前逃跑，',
    '書8:6 他們必出來追趕我們，直到我們引誘他們離開城；因為他們必說：這些人像初次在我們面前逃跑。所以我們要在他們面前逃跑，',
    '書8:7 你們就從埋伏的地方起來，奪取那城，因為耶和華─你們的神必把城交在你們手裡。',
    '書8:8 你們奪了城以後，就放火燒城，要照耶和華的話行。這是我吩咐你們的。',
    '書8:9 約書亞打發他們前往，他們就上埋伏的地方去，住在伯特利和艾城的中間，就是在艾城的西邊。這夜約書亞卻在民中住宿。',
    '書8:10 約書亞清早起來，點齊百姓，他和以色列的長老在百姓前面上艾城去。',
    '書8:11 眾民，就是他所帶領的兵丁，都上去，向前直往，來到城前，在艾城北邊安營。在約書亞和艾城中間有一山谷。',
    '書8:12 他挑了約有五千人，使他們埋伏在伯特利和艾城的中間，就是在艾城的西邊，',
    '書8:13 於是安置了百姓，就是城北的全軍和城西的伏兵。這夜約書亞進入山谷之中。',
    '書8:14 艾城的王看見這景況，就和全城的人，清早急忙起來，按所定的時候，出到亞拉巴前，要與以色列人交戰；王卻不知道在城後有伏兵。',
    '書8:15 約書亞和以色列眾人在他們面前裝敗，往那通曠野的路逃跑。',
    '書8:16 城內的眾民都被招聚，追趕他們；艾城人追趕的時候，就被引誘離開城。',
    '書8:17 艾城和伯特利城沒有一人不出來追趕以色列人的，撇了敞開的城門，去追趕以色列人。',
    '書8:18 耶和華吩咐約書亞說：你向艾城伸出手裡的短鎗，因為我要將城交在你手裡。約書亞就向城伸出手裡的短鎗。',
    '書8:19 他一伸手，伏兵就從埋伏的地方急忙起來，奪了城，跑進城去，放火焚燒。',
    '書8:20 艾城的人回頭一看，不料，城中煙氣沖天，他們就無力向左向右逃跑。那往曠野逃跑的百姓便轉身攻擊追趕他們的人。',
    '書8:21 約書亞和以色列眾人見伏兵已經奪了城，城中煙氣飛騰，就轉身回去，擊殺艾城的人。',
    '書8:22 伏兵也出城迎擊艾城人，艾城人就困在以色列人中間，前後都是以色列人。於是以色列人擊殺他們，沒有留下一個，也沒有一個逃脫的，',
    '書8:23 生擒了艾城的王，將他解到約書亞那裡。',
    '書8:24 以色列人在田間和曠野殺盡所追趕一切艾城的居民。艾城人倒在刀下，直到滅盡；以色列眾人就回到艾城，用刀殺了城中的人。',
    '書8:25 當日殺斃的人，連男帶女共有一萬二千，就是艾城所有的人。',
    '書8:26 約書亞沒有收回手裡所伸出來的短鎗，直到把艾城的一切居民盡行殺滅。',
    '書8:27 惟獨城中的牲畜和財物，以色列人都取為自己的掠物，是照耶和華所吩咐約書亞的話。',
    '書8:28 約書亞將艾城焚燒，使城永為高堆、荒場，直到今日；',
    '書8:29 又將艾城王掛在樹上，直到晚上。日落的時候，約書亞吩咐人把屍首從樹上取下來，丟在城門口，在屍首上堆成一大堆石頭，直存到今日。',
    '書8:30 那時，約書亞在以巴路山上為耶和華─以色列的神築一座壇，',
    '書8:31 是用沒有動過鐵器的整石頭築的，照著耶和華僕人摩西所吩咐以色列人的話，正如摩西律法書上所寫的。眾人在這壇上給耶和華奉獻燔祭和平安祭。',
    '書8:32 約書亞在那裡，當著以色列人面前，將摩西所寫的律法抄寫在石頭上。',
    '書8:33 以色列眾人，無論是本地人、是寄居的，和長老、官長，並審判官，都站在約櫃兩旁，在擡耶和華約櫃的祭司利未人面前，一半對著基利心山，一半對著以巴路山，為以色列民祝福，正如耶和華僕人摩西先前所吩咐的。',
    '書8:34 隨後，約書亞將律法上祝福、咒詛的話，照著律法書上一切所寫的，都宣讀了一遍。',
    '書8:35 摩西所吩咐的一切話，約書亞在以色列全會眾和婦女、孩子，並他們中間寄居的外人面前，沒有一句不宣讀的。',
    '書9:1 約但河西，住山地、高原，並對著利巴嫩山沿大海一帶的諸王，就是赫人、亞摩利人、迦南人、比利洗人、希未人、耶布斯人的諸王，聽見這事，',
    '書9:2 就都聚集，同心合意的要與約書亞和以色列人爭戰。',
    '書9:3 基遍的居民聽見約書亞向耶利哥和艾城所行的事，',
    '書9:4 就設詭計，假充使者，拿舊口袋和破裂縫補的舊皮酒袋馱在驢上，',
    '書9:5 將補過的舊鞋穿在腳上，把舊衣服穿在身上；他們所帶的餅都是乾的，長了霉了。',
    '書9:6 他們到吉甲營中見約書亞，對他和以色列人說：我們是從遠方來的，現在求你與我們立約。',
    '書9:7 以色列人對這些希未人說：只怕你們是住在我們中間的；若是這樣，怎能和你們立約呢﹖',
    '書9:8 他們對約書亞說：我們是你的僕人。約書亞問他們說：你們是什麼人﹖是從哪裡來的﹖',
    '書9:9 他們回答說：僕人從極遠之地而來，是因聽見耶和華─你神的名聲和他在埃及所行的一切事，',
    '書9:10 並他向約但河東的兩個亞摩利王，就是希實本王西宏和在亞斯她錄的巴珊王噩一切所行的事。',
    '書9:11 我們的長老和我們那地的一切居民對我們說：你們手裡要帶著路上用的食物去迎接以色列人，對他們說：我們是你們的僕人；現在求你們與我們立約。',
    '書9:12 我們出來要往你們這裡來的日子，從家裡帶出來的這餅還是熱的；看哪，現在都乾了，長了霉了。',
    '書9:13 這皮酒袋，我們盛酒的時候還是新的；看哪，現在已經破裂。我們這衣服和鞋，因為道路甚遠，也都穿舊了。',
    '書9:14 以色列人受了他們些食物，並沒有求問耶和華。',
    '書9:15 於是約書亞與他們講和，與他們立約，容他們活著；會眾的首領也向他們起誓。',
    '書9:16 以色列人與他們立約之後，過了三天才聽見他們是近鄰，住在以色列人中間的。',
    '書9:17 以色列人起行，第三天到了他們的城邑，就是基遍、基非拉、比錄、基列耶琳。',
    '書9:18 因為會眾的首領已經指著耶和華─以色列的神向他們起誓，所以以色列人不擊殺他們；全會眾就向首領發怨言。',
    '書9:19 眾首領對全會眾說：我們已經指著耶和華─以色列的神向他們起誓，現在我們不能害他們。',
    '書9:20 我們要如此待他們，容他們活著，免得有忿怒因我們所起的誓臨到我們身上。',
    '書9:21 首領又對會眾說：要容他們活著。於是他們為全會眾作了劈柴挑水的人，正如首領對他們所說的話。',
    '書9:22 約書亞召了他們來，對他們說：為什麼欺哄我們說我們離你們甚遠呢﹖其實你們是住在我們中間。',
    '書9:23 現在你們是被咒詛的！你們中間的人必斷不了作奴僕，為我神的殿作劈柴挑水的人。',
    '書9:24 他們回答約書亞說：因為有人實在告訴你的僕人，耶和華─你的神曾吩咐他的僕人摩西，把這全地賜給你們，並在你們面前滅絕這地的一切居民，所以我們為你們的緣故甚怕喪命，就行了這事。',
    '書9:25 現在我們在你手中，你以怎樣待我們為善為正，就怎樣做吧！',
    '書9:26 於是約書亞這樣待他們，救他們脫離以色列人的手，以色列人就沒有殺他們。',
    '書9:27 當日約書亞使他們在耶和華所要選擇的地方，為會眾和耶和華的壇作劈柴挑水的人，直到今日。',
    '書10:1 耶路撒冷王亞多尼洗德聽見約書亞奪了艾城，盡行毀滅，怎樣待耶利哥和耶利哥的王，也照樣待艾城和艾城的王，又聽見基遍的居民與以色列人立了和約，住在他們中間，',
    '書10:2 就甚懼怕；因為基遍是一座大城，如都城一般，比艾城更大，並且城內的人都是勇士。',
    '書10:3 所以耶路撒冷王亞多尼洗德打發人去見希伯崙王何咸、耶末王毘蘭、拉吉王雅非亞，和伊磯倫王底璧，說：',
    '書10:4 求你們上來幫助我，我們好攻打基遍，因為他們與約書亞和以色列人立了和約。',
    '書10:5 於是五個亞摩利王，就是耶路撒冷王、希伯崙王、耶末王、拉吉王、伊磯倫王，大家聚集，率領他們的眾軍上去，對著基遍安營，攻打基遍。',
    '書10:6 基遍人就打發人往吉甲的營中去見約書亞，說：你不要袖手不顧你的僕人，求你速速上來拯救我們，幫助我們，因為住山地亞摩利人的諸王都聚集攻擊我們。',
    '書10:7 於是約書亞和他一切兵丁，並大能的勇士，都從吉甲上去。',
    '書10:8 耶和華對約書亞說：不要怕他們；因為我已將他們交在你手裡，他們無一人能在你面前站立得住。',
    '書10:9 約書亞就終夜從吉甲上去，猛然臨到他們那裡。',
    '書10:10 耶和華使他們在以色列人面前潰亂。約書亞在基遍大大的殺敗他們，追趕他們，在伯和崙的上坡路擊殺他們，直到亞西加和瑪基大。',
    '書10:11 他們在以色列人面前逃跑，正在伯和崙下坡的時候，耶和華從天上降大冰雹在他們身上（冰雹原文作石頭），直降到亞西加，打死他們。被冰雹打死的，比以色列人用刀殺死的還多。',
    '書10:12 當耶和華將亞摩利人交付以色列人的日子，約書亞就禱告耶和華，在以色列人眼前說：日頭啊，你要停在基遍；月亮啊，你要止在亞雅崙谷。',
    '書10:13 於是日頭停留，月亮止住，直等國民向敵人報仇。這事豈不是寫在雅煞珥書上嗎﹖日頭在天當中停住，不急速下落，約有一日之久。',
    '書10:14 在這日以前，這日以後，耶和華聽人的禱告，沒有像這日的，是因耶和華為以色列爭戰。',
    '書10:15 約書亞和以色列眾人回到吉甲的營中。',
    '書10:16 那五王逃跑，藏在瑪基大洞裡。',
    '書10:17 有人告訴約書亞說：那五王已經找到了，都藏在瑪基大洞裡。',
    '書10:18 約書亞說：你們把幾塊大石頭滾到洞口，派人看守，',
    '書10:19 你們卻不可耽延，要追趕你們的仇敵，擊殺他們儘後邊的人，不容他們進自己的城邑，因為耶和華─你們的神已經把他們交在你們手裡。',
    '書10:20 約書亞和以色列人大大殺敗他們，直到將他們滅盡；其中剩下的人都進了堅固的城。',
    '書10:21 眾百姓就安然回瑪基大營中，到約書亞那裡。沒有一人敢向以色列人饒舌。',
    '書10:22 約書亞說：打開洞口，將那五王從洞裡帶出來，領到我面前。',
    '書10:23 眾人就這樣行，將那五王，就是耶路撒冷王、希伯崙王、耶末王、拉吉王、伊磯倫王，從洞裡帶出來，領到約書亞面前。',
    '書10:24 帶出那五王到約書亞面前的時候，約書亞就召了以色列眾人來，對那些和他同去的軍長說：你們近前來，把腳踏在這些王的頸項上。他們就近前來，把腳踏在這些王的頸項上。',
    '書10:25 約書亞對他們說：你們不要懼怕，也不要驚惶。應當剛強壯膽，因為耶和華必這樣待你們所要攻打的一切仇敵。',
    '書10:26 隨後約書亞將這五王殺死，掛在五棵樹上。他們就在樹上直掛到晚上。',
    '書10:27 日頭要落的時候，約書亞一吩咐，人就把屍首從樹上取下來，丟在他們藏過的洞裡，把幾塊大石頭放在洞口，直存到今日。',
    '書10:28 當日，約書亞奪了瑪基大，用刀擊殺城中的人和王；將其中一切人口盡行殺滅，沒有留下一個。他待瑪基大王，像從前待耶利哥王一樣。',
    '書10:29 約書亞和以色列眾人從瑪基大往立拿去，攻打立拿。',
    '書10:30 耶和華將立拿和立拿的王也交在以色列人手裡。約書亞攻打這城，用刀擊殺了城中的一切人口，沒有留下一個。他待立拿王，像從前待耶利哥王一樣。',
    '書10:31 約書亞和以色列眾人從立拿往拉吉去，對著拉吉安營，攻打這城。',
    '書10:32 耶和華將拉吉交在以色列人的手裡。第二天約書亞就奪了拉吉，用刀擊殺了城中的一切人口，是照他向立拿一切所行的。',
    '書10:33 那時基色王荷蘭上來幫助拉吉，約書亞就把他和他的民都擊殺了，沒有留下一個。',
    '書10:34 約書亞和以色列眾人從拉吉往伊磯倫去，對著伊磯倫安營，攻打這城。',
    '書10:35 當日就奪了城，用刀擊殺了城中的人。那日，約書亞將城中的一切人口盡行殺滅，是照他向拉吉一切所行的。',
    '書10:36 約書亞和以色列眾人從伊磯倫上希伯崙去，攻打這城，',
    '書10:37 就奪了希伯崙和屬希伯崙的諸城邑，用刀將城中的人與王，並那些城邑中的人口，都擊殺了，沒有留下一個，是照他向伊磯倫所行的，把城中的一切人口盡行殺滅。',
    '書10:38 約書亞和以色列眾人回到底璧，攻打這城，',
    '書10:39 就奪了底璧和屬底璧的城邑，又擒獲底璧的王，用刀將這些城中的人口盡行殺滅，沒有留下一個。他待底璧和底璧王，像從前待希伯崙和立拿與立拿王一樣。',
    '書10:40 這樣，約書亞擊殺全地的人，就是山地、南地、高原、山坡的人，和那些地的諸王，沒有留下一個。將凡有氣息的盡行殺滅，正如耶和華─以色列的神所吩咐的。',
    '書10:41 約書亞從加低斯巴尼亞攻擊到迦薩，又攻擊歌珊全地，直到基遍。',
    '書10:42 約書亞一時殺敗了這些王，並奪了他們的地，因為耶和華─以色列的神為以色列爭戰。',
    '書10:43 於是約書亞和以色列眾人回到吉甲的營中。',
    '書11:1 夏瑣王耶賓聽見這事，就打發人去見瑪頓王約巴、伸崙王、押煞王，',
    '書11:2 與北方山地、基尼烈南邊的亞拉巴高原，並西邊多珥山岡的諸王；',
    '書11:3 又去見東方和西方的迦南人，與山地的亞摩利人、赫人、比利洗人、耶布斯人，並黑門山根米斯巴地的希未人。',
    '書11:4 這些王和他們的眾軍都出來，人數多如海邊的沙，並有許多馬匹車輛。',
    '書11:5 這諸王會合，來到米倫水邊，一同安營，要與以色列人爭戰。',
    '書11:6 耶和華對約書亞說：你不要因他們懼怕。明日這時，我必將他們交付以色列人全然殺了。你要砍斷他們馬的蹄筋，用火焚燒他們的車輛。',
    '書11:7 於是約書亞率領一切兵丁，在米倫水邊突然向前攻打他們。',
    '書11:8 耶和華將他們交在以色列人手裡，以色列人就擊殺他們，追趕他們到西頓大城，到米斯利弗瑪音，直到東邊米斯巴的平原，將他們擊殺，沒有留下一個。',
    '書11:9 約書亞就照耶和華所吩咐他的去行，砍斷他們馬的蹄筋，用火焚燒他們的車輛。',
    '書11:10 當時，約書亞轉回奪了夏瑣，用刀擊殺夏瑣王。（素來夏瑣在這諸國中是為首的。）',
    '書11:11 以色列人用刀擊殺城中的人口，將他們盡行殺滅；凡有氣息的沒有留下一個。約書亞又用火焚燒夏瑣。',
    '書11:12 約書亞奪了這些王的一切城邑，擒獲其中的諸王，用刀擊殺他們，將他們盡行殺滅，正如耶和華僕人摩西所吩咐的。',
    '書11:13 至於造在山岡上的城，除了夏瑣以外，以色列人都沒有焚燒。約書亞只將夏瑣焚燒了。',
    '書11:14 那些城邑所有的財物和牲畜，以色列人都取為自己的掠物；惟有一切人口都用刀擊殺，直到殺盡；凡有氣息的沒有留下一個。',
    '書11:15 耶和華怎樣吩咐他僕人摩西，摩西就照樣吩咐約書亞，約書亞也照樣行。凡耶和華所吩咐摩西的，約書亞沒有一件懈怠不行的。',
    '書11:16 約書亞奪了那全地，就是山地、一帶南地、歌珊全地、高原、亞拉巴、以色列的山地，和山下的高原。',
    '書11:17 從上西珥的哈拉山，直到黑門山下利巴嫩平原的巴力迦得，並且擒獲那些地的諸王，將他們殺死。',
    '書11:18 約書亞和這諸王爭戰了許多年日。',
    '書11:19 除了基遍的希未人之外，沒有一城與以色列人講和的，都是以色列人爭戰奪來的。',
    '書11:20 因為耶和華的意思是要使他們心裡剛硬，來與以色列人爭戰，好叫他們盡被殺滅，不蒙憐憫，正如耶和華所吩咐摩西的。',
    '書11:21 當時約書亞來到，將住山地、希伯崙、底璧、亞拿伯、猶大山地、以色列山地所有的亞衲族人剪除了。約書亞將他們和他們的城邑盡都毀滅。',
    '書11:22 在以色列人的地沒有留下一個亞衲族人，只在迦薩、迦特，和亞實突有留下的。',
    '書11:23 這樣，約書亞照著耶和華所吩咐摩西的一切話奪了那全地，就按著以色列支派的宗族將地分給他們為業。於是國中太平，沒有爭戰了。',
    '書12:1 以色列人在約但河外向日出之地擊殺二王，得他們的地，就是從亞嫩谷直到黑門山，並東邊的全亞拉巴之地。',
    '書12:2 這二王，有住希實本、亞摩利人的王西宏。他所管之地是從亞嫩谷邊的亞羅珥和谷中的城，並基列一半，直到亞捫人的境界，雅博河',
    '書12:3 與約但河東邊的亞拉巴，直到基尼烈海，又到亞拉巴的海，就是鹽海，通伯耶西末的路，以及南方，直到毘斯迦的山根。',
    '書12:4 又有巴珊王噩。他是利乏音人所剩下的，住在亞斯她錄和以得來。',
    '書12:5 他所管之地是黑門山、撒迦、巴珊全地，直到基述人和瑪迦人的境界，並基列一半，直到希實本王西宏的境界。',
    '書12:6 這二王是耶和華僕人摩西和以色列人所擊殺的；耶和華僕人摩西將他們的地賜給流便人、迦得人，和瑪拿西半支派的人為業。',
    '書12:7 約書亞和以色列人在約但河西擊殺了諸王。他們的地是從利巴嫩平原的巴力迦得，直到上西珥的哈拉山。約書亞就將那地按著以色列支派的宗族分給他們為業，',
    '書12:8 就是赫人、亞摩利人，迦南人、比利洗人、希未人、耶布斯人的山地、高原亞拉巴、山坡、曠野，和南地。',
    '書12:9 他們的王：一個是耶利哥王，一個是靠近伯特利的艾城王，',
    '書12:10 一個是耶路撒冷王，一個是希伯崙王，',
    '書12:11 一個是耶末王，一個是拉吉王，',
    '書12:12 一個是伊磯倫王，一個是基色王，',
    '書12:13 一個是底璧王，一個是基德王，',
    '書12:14 一個是何珥瑪王，一個是亞拉得王，',
    '書12:15 一個是立拿王，一個是亞杜蘭王，',
    '書12:16 一個是瑪基大王，一個是伯特利王，',
    '書12:17 一個是他普亞王，一個是希弗王，',
    '書12:18 一個是亞弗王，一個是拉沙崙王，',
    '書12:19 一個是瑪頓王，一個是夏瑣王，',
    '書12:20 一個是伸崙米崙王，一個是押煞王，',
    '書12:21 一個是他納王，一個是米吉多王，',
    '書12:22 一個是基低斯王，一個是靠近迦密的約念王，',
    '書12:23 一個是多珥山岡的多珥王，一個是吉甲的戈印王，',
    '書12:24 一個是得撒王；共計三十一個王。',
    '書13:1 約書亞年紀老邁，耶和華對他說：你年紀老邁了，還有許多未得之地，',
    '書13:2 就是非利士人的全境和基述人的全地。',
    '書13:3 從埃及前的西曷河往北，直到以革倫的境界，就算屬迦南人之地。有非利士人五個首領所管的迦薩人、亞實突人、亞實基倫人、迦特人、以革倫人之地，並有南方亞衛人之地。',
    '書13:4 又有迦南人的全地，並屬西頓人的米亞拉到亞弗，直到亞摩利人的境界。',
    '書13:5 還有迦巴勒人之地，並向日出的全利巴嫩，就是從黑門山根的巴力迦得，直到哈馬口。',
    '書13:6 山地的一切居民，從利巴嫩直到米斯利弗瑪音，就是所有的西頓人，我必在以色列人面前趕出他們去。你只管照我所吩咐的，將這地拈鬮分給以色列人為業。',
    '書13:7 現在你要把這地分給九個支派和瑪拿西半個支派為業。',
    '書13:8 瑪拿西那半支派和流便、迦得二支派已經受了產業，就是耶和華的僕人摩西在約但河東所賜給他們的：',
    '書13:9 是從亞嫩谷邊的亞羅珥和谷中的城，並米底巴的全平原，直到底本，',
    '書13:10 和在希實本作王亞摩利王西宏的諸城，直到亞捫人的境界；',
    '書13:11 又有基列地、基述人、瑪迦人的地界，並黑門全山、巴珊全地，直到撒迦；',
    '書13:12 又有巴珊王噩的全國─他在亞斯她錄和以得來作王（利乏音人所存留的只剩下他）。這些地的人都是摩西所擊殺、所趕逐的。',
    '書13:13 以色列人卻沒有趕逐基述人、瑪迦人；這些人仍住在以色列中，直到今日。',
    '書13:14 只是利未支派，摩西（原文作他）沒有把產業分給他們。他們的產業乃是獻與耶和華─以色列神的火祭，正如耶和華所應許他們的。',
    '書13:15 摩西按著流便支派的宗族分給他們產業。',
    '書13:16 他們的境界是亞嫩谷邊的亞羅珥和谷中的城，靠近米底巴的全平原；',
    '書13:17 希實本並屬希實本平原的各城，底本、巴末巴力、伯巴力勉、',
    '書13:18 雅雜、基底莫、米法押、',
    '書13:19 基列亭、西比瑪、谷中山的細列哈沙轄、',
    '書13:20 伯毘珥、毘斯迦山坡、伯耶西末；',
    '書13:21 平原的各城，並亞摩利王西宏的全國。這西宏曾在希實本作王，摩西把他和米甸的族長以未、利金、蘇珥、戶珥、利巴擊殺了；這都是住那地屬西宏為首領的。',
    '書13:22 那時以色列人在所殺的人中，也用刀殺了比珥的兒子術士巴蘭。',
    '書13:23 流便人的境界就是約但河與靠近約但河的地。以上是流便人按著宗族所得為業的諸城，並屬城的村莊。',
    '書13:24 摩西按著迦得支派的宗族分給他們產業。',
    '書13:25 他們的境界是雅謝和基列的各城，並亞捫人的一半地，直到拉巴前的亞羅珥；',
    '書13:26 從希實本到拉抹米斯巴和比多寧，又從瑪哈念到底璧的境界，',
    '書13:27 並谷中的伯亞蘭、伯寧拉、疏割、撒分，就是希實本王西宏國中的餘地，以及約但河與靠近約但河的地，直到基尼烈海的極邊，都在約但河東。',
    '書13:28 以上是迦得人按著宗族所得為業的諸城，並屬城的村莊。',
    '書13:29 摩西把產業分給瑪拿西半支派，是按著瑪拿西半支派的宗族所分的。',
    '書13:30 他們的境界是從瑪哈念起，包括巴珊全地，就是巴珊王噩的全國，並在巴珊、睚珥的一切城邑，共六十個。',
    '書13:31 基列的一半，並亞斯她錄、以得來，就是屬巴珊王噩國的二城，是按著宗族給瑪拿西的兒子瑪吉的一半子孫。',
    '書13:32 以上是摩西在約但河東對著耶利哥的摩押平原所分給他們的產業。',
    '書13:33 只是利未支派，摩西沒有把產業分給他們。耶和華─以色列的神是他們的產業，正如耶和華所應許他們的。',
    '書14:1 以色列人在迦南地所得的產業，就是祭司以利亞撒和嫩的兒子約書亞，並以色列各支派的族長所分給他們的，都記在下面，',
    '書14:2 是照耶和華藉摩西所吩咐的，把產業拈鬮分給九個半支派。',
    '書14:3 原來，摩西在約但河東已經把產業分給那兩個半支派，只是在他們中間沒有把產業分給利未人。',
    '書14:4 因為約瑟的子孫是兩個支派，就是瑪拿西和以法蓮，所以沒有把地分給利未人，但給他們城邑居住，並城邑的郊野，可以牧養他們的牲畜，安置他們的財物。',
    '書14:5 耶和華怎樣吩咐摩西，以色列人就照樣行，把地分了。',
    '書14:6 那時，猶大人來到吉甲見約書亞，有基尼洗族耶孚尼的兒子迦勒對約書亞說：耶和華在加低斯巴尼亞指著我與你對神人摩西所說的話，你都知道了。',
    '書14:7 耶和華的僕人摩西從加低斯巴尼亞打發我窺探這地，那時我正四十歲；我按著心意回報他。',
    '書14:8 然而，同我上去的眾弟兄使百姓的心消化；但我專心跟從耶和華─我的神。',
    '書14:9 當日摩西起誓說：你腳所踏之地定要歸你和你的子孫永遠為業，因為你專心跟從耶和華─我的神。',
    '書14:10 自從耶和華對摩西說這話的時候，耶和華照他所應許的使我存活這四十五年；其間以色列人在曠野行走。看哪，現今我八十五歲了，',
    '書14:11 我還是強壯，像摩西打發我去的那天一樣；無論是爭戰，是出入，我的力量那時如何，現在還是如何。',
    '書14:12 求你將耶和華那日應許我的這山地給我；那裡有亞衲族人，並寬大堅固的城，你也曾聽見了。或者耶和華照他所應許的與我同在，我就把他們趕出去。',
    '書14:13 於是約書亞為耶孚尼的兒子迦勒祝福，將希伯崙給他為業。',
    '書14:14 所以希伯崙作了基尼洗族耶孚尼的兒子迦勒的產業，直到今日，因為他專心跟從耶和華─以色列的神。',
    '書14:15 希伯崙從前名叫基列亞巴；亞巴是亞衲族中最尊大的人。於是國中太平，沒有爭戰了。',
    '書15:1 猶大支派按著宗族拈鬮所得之地是在儘南邊，到以東的交界，向南直到尋的曠野。',
    '書15:2 他們的南界是從鹽海的儘邊，就是從朝南的海汊起，',
    '書15:3 通到亞克拉濱坡的南邊，接連到尋，上到加低斯巴尼亞的南邊，又過希斯崙，上到亞達珥，繞到甲加，',
    '書15:4 接連到押們，通到埃及小河，直通到海為止。這就是他們的南界。',
    '書15:5 東界是從鹽海南邊到約但河口。北界是從約但河口的海汊起，',
    '書15:6 上到伯曷拉，過伯亞拉巴的北邊，上到流便之子波罕的磐石；',
    '書15:7 從亞割谷往北，上到底璧，直向河南亞都冥坡對面的吉甲；又接連到隱示麥泉，直通到隱羅結，',
    '書15:8 上到欣嫩子谷，貼近耶布斯的南界（耶布斯就是耶路撒冷）；又上到欣嫩谷西邊的山頂，就是在利乏音谷極北的邊界；',
    '書15:9 又從山頂延到尼弗多亞的水源，通到以弗崙山的城邑，又延到巴拉（巴拉就是基列耶琳）；',
    '書15:10 又從巴拉往西繞到西珥山，接連到耶琳山的北邊（耶琳就是基撒崙）；又下到伯示麥過亭納，',
    '書15:11 通到以革倫北邊，延到施基崙，接連到巴拉山；又通到雅比聶，直通到海為止。',
    '書15:12 西界就是大海和靠近大海之地。這是猶大人按著宗族所得之地四圍的交界。',
    '書15:13 約書亞照耶和華所吩咐的，將猶大人中的一段地，就是基列亞巴，分給耶孚尼的兒子迦勒。亞巴是亞衲族的始祖（基列亞巴就是希伯崙）。',
    '書15:14 迦勒就從那裡趕出亞衲族的三個族長，就是示篩、亞希幔、撻買；',
    '書15:15 又從那裡上去，攻擊底璧的居民。（這底璧從前名叫基列西弗。）',
    '書15:16 迦勒說：誰能攻打基列西弗將城奪取，我就把我女兒押撒給他為妻。',
    '書15:17 迦勒兄弟基納斯的兒子俄陀聶奪取了那城，迦勒就把女兒押撒給他為妻。',
    '書15:18 押撒過門的時候，勸丈夫向他父親求一塊田，押撒一下驢，迦勒問他說：你要什麼﹖',
    '書15:19 他說：求你賜福給我，你既將我安置在南地，求你也給我水泉。他父親就把上泉下泉賜給他。',
    '書15:20 以下是猶大支派按著宗族所得的產業。',
    '書15:21 猶大支派儘南邊的城邑，與以東交界相近的，就是甲薛、以得、雅姑珥、',
    '書15:22 基拿、底摩拿、亞大達、',
    '書15:23 基低斯、夏瑣、以提楠、',
    '書15:24 西弗、提鍊、比亞綠、',
    '書15:25 夏瑣哈大他、加略希斯崙（加略希斯崙就是夏瑣）、',
    '書15:26 亞曼、示瑪、摩拉大、',
    '書15:27 哈薩迦大、黑實門、伯帕列、',
    '書15:28 哈薩書亞、別是巴、比斯約他、',
    '書15:29 巴拉、以因、以森、',
    '書15:30 伊勒多臘、基失、何珥瑪、',
    '書15:31 洗革拉、麥瑪拿、三撒拿、',
    '書15:32 利巴勿、實忻、亞因、臨門，共二十九座城，還有屬城的村莊。',
    '書15:33 在高原有以實陶、瑣拉、亞實拿、',
    '書15:34 撒挪亞、隱干寧、他普亞、以楠、',
    '書15:35 耶末、亞杜蘭、梭哥、亞西加、',
    '書15:36 沙拉音、亞底他音、基底拉、基底羅他音，共十四座城，還有屬城的村莊。',
    '書15:37 又有洗楠、哈大沙、麥大迦得、',
    '書15:38 底連、米斯巴、約帖、',
    '書15:39 拉吉、波斯加、伊磯倫、',
    '書15:40 迦本、拉幔、基提利、',
    '書15:41 基低羅、伯大袞、拿瑪、瑪基大，共十六座城，還有屬城的村莊。',
    '書15:42 又有立拿、以帖、亞珊、',
    '書15:43 益弗他、亞實拿、尼悉、',
    '書15:44 基伊拉、亞革悉、瑪利沙，共九座城，還有屬城的村莊。',
    '書15:45 又有以革倫和屬以革倫的鎮市村莊；',
    '書15:46 從以革倫直到海，一切靠近亞實突之地，並屬其地的村莊。',
    '書15:47 亞實突和屬亞實突的鎮市村莊；迦薩和屬迦薩的鎮市村莊；直到埃及小河，並大海和靠近大海之地。',
    '書15:48 在山地有沙密、雅提珥、梭哥、',
    '書15:49 大拿、基列薩拿（基列薩拿就是底璧）、',
    '書15:50 亞拿伯、以實提莫、亞念、',
    '書15:51 歌珊、何倫、基羅，共十一座城，還有屬城的村莊。',
    '書15:52 又有亞拉、度瑪、以珊、',
    '書15:53 雅農、伯他普亞、亞非加、',
    '書15:54 宏他、基列亞巴（基列亞巴就是希伯崙）、洗珥，共九座城，還有屬城的村莊。',
    '書15:55 又有瑪雲、迦密、西弗、淤他、',
    '書15:56 耶斯列、約甸、撒挪亞、',
    '書15:57 該隱、基比亞、亭納，共十座城，還有屬城的村莊。',
    '書15:58 又有哈忽、伯夙、基突、',
    '書15:59 瑪臘、伯亞諾、伊勒提君，共六座城，還有屬城的村莊。',
    '書15:60 又有基列巴力（基列巴力就是基列耶琳）、拉巴，共兩座城，還有屬城的村莊。',
    '書15:61 在曠野有伯亞拉巴、密丁、西迦迦、',
    '書15:62 匿珊、鹽城、隱基底，共六座城，還有屬城的村莊。',
    '書15:63 至於住耶路撒冷的耶布斯人，猶大人不能把他們趕出去，耶布斯人卻在耶路撒冷與猶大人同住，直到今日。',
    '書16:1 約瑟的子孫拈鬮所得之地是從靠近耶利哥的約但河起，以耶利哥東邊的水為界：從耶利哥上去，通過山地的曠野，到伯特利；',
    '書16:2 又從伯特利到路斯，接連到亞基人的境界，至亞他綠；',
    '書16:3 又往西下到押利提人的境界，到下伯和崙的境界，直到基色，通到海為止。',
    '書16:4 約瑟的兒子瑪拿西、以法蓮就得了他們的地業。',
    '書16:5 以法蓮子孫的境界，按著宗族所得的，記在下面：他們地業的東界是亞他綠亞達到上伯和崙；',
    '書16:6 往西通到北邊的密米他，又向東繞到他納示羅，又接連到雅挪哈的東邊；',
    '書16:7 從雅挪哈下到亞他綠，又到拿拉，達到耶利哥，通到約但河為止；',
    '書16:8 從他普亞往西，到加拿河，直通到海為止。這就是以法蓮支派按著宗族所得的地業。',
    '書16:9 另外在瑪拿西人地業中得了些城邑和屬城的村莊。這都是分給以法蓮子孫的。',
    '書16:10 他們沒有趕出住基色的迦南人；迦南人卻住在以法蓮人中間，成為做苦工的僕人，直到今日。',
    '書17:1 瑪拿西是約瑟的長子，他的支派拈鬮所得之地記在下面。至於瑪拿西的長子基列之父（父或作：主）瑪吉，因為是勇士就得了基列和巴珊。',
    '書17:2 瑪拿西其餘的子孫，按著宗族拈鬮分地，就是亞比以謝子孫，希勒子孫，亞斯列子孫，示劍子孫，希弗子孫，示米大子孫；這些按著宗族，都是約瑟兒子瑪拿西子孫的男丁。',
    '書17:3 瑪拿西的玄孫，瑪吉的曾孫，基列的孫子，希弗的兒子西羅非哈沒有兒子，只有女兒。他的女兒名叫瑪拉、挪阿、曷拉、密迦、得撒；',
    '書17:4 他們來到祭司以利亞撒和嫩的兒子約書亞並眾首領面前，說：耶和華曾吩咐摩西在我們弟兄中分給我們產業。於是約書亞照耶和華所吩咐的，在他們伯叔中，把產業分給他們。',
    '書17:5 除了約但河東的基列和巴珊地之外，還有十分地歸瑪拿西，',
    '書17:6 因為瑪拿西的孫女們在瑪拿西的孫子中得了產業。基列地是屬瑪拿西其餘的子孫。',
    '書17:7 瑪拿西的境界：從亞設起，到示劍前的密米他，往北到隱他普亞居民之地。',
    '書17:8 他普亞地歸瑪拿西，只是瑪拿西境界上的他普亞城歸以法蓮子孫。',
    '書17:9 其界下到加拿河的南邊。在瑪拿西城邑中的這些城邑都歸以法蓮。瑪拿西的地界是在河北直通到海為止；',
    '書17:10 南歸以法蓮，北歸瑪拿西，以海為界；北邊到亞設，東邊到以薩迦。',
    '書17:11 瑪拿西在以薩迦和亞設境內，有伯善和屬伯善的鎮市，以伯蓮和屬以伯蓮的鎮市，多珥的居民和屬多珥的鎮市；又有三處山岡，就是隱多珥和屬隱多珥的鎮市；他納的居民和屬他納的鎮市，米吉多的居民和屬米吉多的鎮市。',
    '書17:12 只是瑪拿西子孫不能趕出這些城的居民，迦南人偏要住在那地。',
    '書17:13 及至以色列人強盛了，就使迦南人做苦工，沒有把他們全然趕出。',
    '書17:14 約瑟的子孫對約書亞說：耶和華到如今既然賜福與我們，我們也族大人多，你為什麼僅將一鬮一段之地分給我們為業呢﹖',
    '書17:15 約書亞說：你們如果族大人多，嫌以法蓮山地窄小，就可以上比利洗人、利乏音人之地，在樹林中砍伐樹木。',
    '書17:16 約瑟的子孫說：那山地容不下我們，並且住平原的迦南人，就是住伯善和屬伯善的鎮市，並住耶斯列平原的人，都有鐵車。',
    '書17:17 約書亞對約瑟家，就是以法蓮和瑪拿西人，說：你是族大人多，並且強盛，不可僅有一鬮之地，',
    '書17:18 山地也要歸你，雖是樹林，你也可以砍伐；靠近之地必歸你。迦南人雖有鐵車，雖是強盛，你也能把他們趕出去。',
    '書18:1 以色列的全會眾都聚集在示羅，把會幕設立在那裡，那地已經被他們制伏了。',
    '書18:2 以色列人中其餘的七個支派還沒有分給他們地業。',
    '書18:3 約書亞對以色列人說：耶和華─你們列祖的神所賜給你們的地，你們耽延不去得，要到幾時呢﹖',
    '書18:4 你們每支派當選舉三個人，我要打發他們去，他們就要起身走遍那地，按著各支派應得的地業寫明（或作：畫圖），就回到我這裡來。',
    '書18:5 他們要將地分做七分；猶大仍在南方，住在他的境內。約瑟家仍在北方，住在他的境內。',
    '書18:6 你們要將地分做七分，寫明了拿到我這裡來。我要在耶和華─我們神面前，為你們拈鬮。',
    '書18:7 利未人在你們中間沒有分，因為供耶和華祭司的職任就是他們的產業。迦得支派、流便支派，和瑪拿西半支派已經在約但河東得了地業，就是耶和華僕人摩西所給他們的。',
    '書18:8 劃地勢的人起身去的時候，約書亞囑咐他們說：你們去走遍那地，劃明地勢，就回到我這裡來。我要在示羅這裡，耶和華面前，為你們拈鬮。',
    '書18:9 他們就去了，走遍那地，按著城邑分做七分，寫在冊子上，回到示羅營中見約書亞。',
    '書18:10 約書亞就在示羅，耶和華面前，為他們拈鬮。約書亞在那裡，按著以色列人的支派，將地分給他們。',
    '書18:11 便雅憫支派，按著宗族拈鬮所得之地，是在猶大、約瑟子孫中間。',
    '書18:12 他們的北界是從約但河起，往上貼近耶利哥的北邊；又往西通過山地，直到伯亞文的曠野；',
    '書18:13 從那裡往南接連到路斯，貼近路斯（路斯就是伯特利），又下到亞他綠亞達，靠近下伯和崙南邊的山；',
    '書18:14 從那裡往西，又轉向南，從伯和崙南對面的山，直達到猶大人的城基列巴力（基列巴力就是基列耶琳）；這是西界。',
    '書18:15 南界是從基列耶琳的儘邊起，往西達到尼弗多亞的水源；',
    '書18:16 又下到欣嫩子谷對面山的儘邊，就是利乏音谷北邊的山；又下到欣嫩谷，貼近耶布斯的南邊；又下到隱羅結；',
    '書18:17 又往北通到隱示麥，達到亞都冥坡對面的基利綠；又下到流便之子波罕的磐石；',
    '書18:18 又接連到亞拉巴對面，往北下到亞拉巴；',
    '書18:19 又接連到伯曷拉的北邊，直通到鹽海的北汊，就是約但河的南頭；這是南界。',
    '書18:20 東界是約但河。這是便雅憫人按著宗族，照他們四圍的交界所得的地業。',
    '書18:21 便雅憫支派按著宗族所得的城邑就是：耶利哥、伯曷拉、伊麥基悉、',
    '書18:22 伯亞拉巴、洗瑪臉、伯特利、',
    '書18:23 亞文、巴拉、俄弗拉、',
    '書18:24 基法阿摩尼、俄弗尼、迦巴，共十二座城，還有屬城的村莊；',
    '書18:25 又有基遍、拉瑪、比錄、',
    '書18:26 米斯巴、基非拉、摩撒、',
    '書18:27 利堅、伊利毘勒、他拉拉、',
    '書18:28 洗拉、以利弗、耶布斯（耶布斯就是耶路撒冷）、基比亞、基列，共十四座城，還有屬城的村莊。這是便雅憫人按著宗族所得的地業。',
    '書19:1 為西緬支派的人，按著宗族，拈出第二鬮。他們所得的地業是在猶大人地業中間。',
    '書19:2 他們所得為業之地就是：別是巴（或名示巴）、摩拉大、',
    '書19:3 哈薩書亞、巴拉、以森、',
    '書19:4 伊利多拉、比土力、何珥瑪、',
    '書19:5 洗革拉、伯瑪加博、哈薩蘇撒、',
    '書19:6 伯利巴勿、沙魯險，共十三座城，還有屬城的村莊；',
    '書19:7 又有亞因、利門、以帖、亞珊，共四座城，還有屬城的村莊；',
    '書19:8 並有這些城邑四圍一切的村莊，直到巴拉比珥，就是南地的拉瑪。這是西緬支派按著宗族所得的地業。',
    '書19:9 西緬人的地業是從猶大人地業中得來的；因為猶大人的分過多，所以西緬人在他們的地業中得了地業。',
    '書19:10 為西布倫人，按著宗族，拈出第三鬮。他們地業的境界是到撒立；',
    '書19:11 往西上到瑪拉拉，達到大巴設，又達到約念前的河；',
    '書19:12 又從撒立往東轉向日出之地，到吉斯綠他泊的境界，又通到大比拉，上到雅非亞；',
    '書19:13 從那裡往東，接連到迦特希弗，至以特加汛，通到臨門，臨門延到尼亞；',
    '書19:14 又繞過尼亞的北邊，轉到哈拿頓，通到伊弗他伊勒谷。',
    '書19:15 還有加他、拿哈拉、伸崙、以大拉、伯利恆，共十二座城，還有屬城的村莊。',
    '書19:16 這些城並屬城的村莊就是西布倫人按著宗族所得的地業。',
    '書19:17 為以薩迦人，按著宗族，拈出第四鬮。',
    '書19:18 他們的境界是到耶斯列、基蘇律、書念、',
    '書19:19 哈弗連、示按、亞拿哈拉、',
    '書19:20 拉璧、基善、亞別、',
    '書19:21 利篾、隱干寧、隱哈大、伯帕薛；',
    '書19:22 又達到他泊、沙哈洗瑪、伯示麥，直通到約但河為止，共十六座城，還有屬城的村莊。',
    '書19:23 這些城並屬城的村莊就是以薩迦支派按著宗族所得的地業。',
    '書19:24 為亞設支派，按著宗族，拈出第五鬮。',
    '書19:25 他們的境界是黑甲、哈利、比田、押煞、',
    '書19:26 亞拉米勒、亞末、米沙勒；往西達到迦密，又到希曷立納，',
    '書19:27 轉向日出之地，到伯大袞，達到細步綸；往北到伊弗他伊勒谷，到伯以墨和尼業，也通到迦步勒的左邊；',
    '書19:28 又到義伯崙、利合、哈們、加拿，直到西頓大城；',
    '書19:29 轉到拉瑪和堅固城推羅；又轉到何薩，靠近亞革悉一帶地方，直通到海；',
    '書19:30 又有烏瑪、亞弗、利合，共二十二座城，還有屬城的村莊。',
    '書19:31 這些城並屬城的村莊就是亞設支派按著宗族所得的地業。',
    '書19:32 為拿弗他利人，按著宗族，拈出第六鬮。',
    '書19:33 他們的境界是從希利弗從撒拿音的橡樹，從亞大米尼吉和雅比聶，直到拉共，通到約但河；',
    '書19:34 又轉向西到亞斯納他泊，從那裡通到戶割，南邊到西布倫，西邊到亞設，又向日出之地，達到約但河那裡的猶大。',
    '書19:35 堅固的城就是：西丁、側耳、哈末、拉甲、基尼烈、',
    '書19:36 亞大瑪、拉瑪、夏瑣、',
    '書19:37 基低斯、以得來、隱夏瑣、',
    '書19:38 以利穩、密大伊勒、和璉、伯亞納、伯示麥，共十九座城，還有屬城的村莊。',
    '書19:39 這些城並屬城的村莊就是拿弗他利支派按著宗族所得的地業。',
    '書19:40 為但支派，按著宗族，拈出第七鬮。',
    '書19:41 他們地業的境界是瑣拉、以實陶、伊珥示麥、',
    '書19:42 沙拉賓、亞雅崙、伊提拉、',
    '書19:43 以倫、亭拿他、以革倫、',
    '書19:44 伊利提基、基比頓、巴拉、',
    '書19:45 伊胡得、比尼比拉、迦特臨門、',
    '書19:46 美耶昆、拉昆，並約帕對面的地界。',
    '書19:47 但人的地界越過原得的地界；因為但人上去攻取利善，用刀擊殺城中的人，得了那城，住在其中，以他們先祖但的名將利善改名為但。',
    '書19:48 這些城並屬城的村莊就是但支派按著宗族所得的地業。',
    '書19:49 以色列人按著境界分完了地業，就在他們中間將地給嫩的兒子約書亞為業，',
    '書19:50 是照耶和華的吩咐，將約書亞所求的城，就是以法蓮山地的亭拿西拉城，給了他。他就修那城，住在其中。',
    '書19:51 這就是祭司以利亞撒和嫩的兒子約書亞，並以色列各支派的族長，在示羅會幕門口，耶和華面前，拈鬮所分的地業。這樣，他們把地分完了。',
    '書20:1 耶和華曉諭約書亞說：',
    '書20:2 你吩咐以色列人說：你們要照著我藉摩西所曉諭你們的，為自己設立逃城，',
    '書20:3 使那無心而誤殺人的，可以逃到那裡。這些城可以作你們逃避報血仇人的地方。',
    '書20:4 那殺人的要逃到這些城中的一座城，站在城門口，將他的事情說給城內的長老們聽。他們就把他收進城裡，給他地方，使他住在他們中間。',
    '書20:5 若是報血仇的追了他來，長老不可將他交在報血仇的手裡；因為他是素無仇恨，無心殺了人的。',
    '書20:6 他要住在那城裡，站在會眾面前聽審判，等到那時的大祭司死了，殺人的才可以回到本城本家，就是他所逃出來的那城。',
    '書20:7 於是，以色列人在拿弗他利山地分定加利利的基低斯；在以法蓮山地分定示劍；在猶大山地分定基列亞巴（基列亞巴就是希伯崙）；',
    '書20:8 又在約但河外耶利哥東，從流便支派中，在曠野的平原，設立比悉；從迦得支派中設立基列的拉末；從瑪拿西支派中設立巴珊的哥蘭。',
    '書20:9 這都是為以色列眾人和在他們中間寄居的外人所分定的地邑，使誤殺人的都可以逃到那裡，不死在報血仇人的手中，等他站在會眾面前聽審判。',
    '書21:1 那時，利未人的眾族長來到祭司以利亞撒和嫩的兒子約書亞，並以色列各支派的族長面前，',
    '書21:2 在迦南地的示羅對他們說：從前耶和華藉著摩西吩咐給我們城邑居住，並城邑的郊野可以牧養我們的牲畜。',
    '書21:3 於是以色列人照耶和華所吩咐的，從自己的地業中，將以下所記的城邑和城邑的郊野給了利未人。',
    '書21:4 為哥轄族拈鬮：利未人的祭司、亞倫的子孫，從猶大支派、西緬支派、便雅憫支派的地業中，按鬮得了十三座城。',
    '書21:5 哥轄其餘的子孫，從以法蓮支派、但支派、瑪拿西半支派的地業中，按鬮得了十座城。',
    '書21:6 革順的子孫，從以薩迦支派、亞設支派、拿弗他利支派、住巴珊的瑪拿西半支派的地業中，按鬮得了十三座城。',
    '書21:7 米拉利的子孫，按著宗族，從流便支派、迦得支派、西布倫支派的地業中，按鬮得了十二座城。',
    '書21:8 以色列人照著耶和華藉摩西所吩咐的，將這些城邑和城邑的郊野，按鬮分給利未人。',
    '書21:9 從猶大支派、西緬支派的地業中，將以下所記的城給了利未支派哥轄宗族亞倫的子孫；因為給他們拈出頭一鬮，',
    '書21:10 併於上節。',
    '書21:11 將猶大山地的基列亞巴和四圍的郊野給了他們。亞巴是亞衲族的始祖。（基列亞巴就是希伯崙）。',
    '書21:12 惟將屬城的田地和村莊給了耶孚尼的兒子迦勒為業。',
    '書21:13 以色列人將希伯崙，就是誤殺人的逃城和屬城的郊野，給了祭司亞倫的子孫；又給他們立拿和屬城的郊野，',
    '書21:14 雅提珥和屬城的郊野，以實提莫和屬城的郊野，',
    '書21:15 何崙和屬城的郊野，底璧和屬城的郊野，',
    '書21:16 亞因和屬城的郊野，淤他和屬城的郊野，伯示麥和屬城的郊野，共九座城，都是從這二支派中分出來的。',
    '書21:17 又從便雅憫支派的地業中給了他們基遍和屬城的郊野，迦巴和屬城的郊野，',
    '書21:18 亞拿突和屬城的郊野，亞勒們和屬城的郊野，共四座城。',
    '書21:19 亞倫子孫作祭司的共有十三座城，還有屬城的郊野。',
    '書21:20 利未支派中哥轄的宗族，就是哥轄其餘的子孫，拈鬮所得的城有從以法蓮支派中分出來的。',
    '書21:21 以色列人將以法蓮山地的示劍，就是誤殺人的逃城和屬城的郊野，給了他們；又給他們基色和屬城的郊野，',
    '書21:22 基伯先和屬城的郊野，伯和崙和屬城的郊野，共四座城；',
    '書21:23 又從但支派的地業中給了他們伊利提基和屬城的郊野，基比頓和屬城的郊野，',
    '書21:24 亞雅崙和屬城的郊野，迦特臨門和屬城的郊野，共四座城；',
    '書21:25 又從瑪拿西半支派的地業中給了他們他納和屬城的郊野，迦特臨門和屬城的郊野，共兩座城。',
    '書21:26 哥轄其餘的子孫共有十座城，還有屬城的郊野。',
    '書21:27 以色列人又從瑪拿西半支派的地業中將巴珊的哥蘭，就是誤殺人的逃城和屬城的郊野，給了利未支派革順的子孫；又給他們比施提拉和屬城的郊野，共兩座城；',
    '書21:28 又從以薩迦支派的地業中給了他們基善和屬城的郊野，大比拉和屬城的郊野，',
    '書21:29 耶末和屬城的郊野，隱干寧和屬城的郊野，共四座城；',
    '書21:30 又從亞設支派的地業中給了他們米沙勒和屬城的郊野，押頓和屬城的郊野，',
    '書21:31 黑甲和屬城的郊野，利合和屬城的郊野，共四座城；',
    '書21:32 又從拿弗他利支派的地業中將加利利的基低斯，就是誤殺人的逃城和屬城的郊野，給了他們；又給他們哈末多珥和屬城的郊野，加珥坦和屬城的郊野，共三座城。',
    '書21:33 革順人按著宗族所得的城，共十三座，還有屬城的郊野。',
    '書21:34 其餘利未支派米拉利子孫，從西布倫支派的地業中所得的，就是約念和屬城的郊野，加珥他和屬城的郊野，',
    '書21:35 丁拿和屬城的郊野，拿哈拉和屬城的郊野，共四座城；',
    '書21:36 又從流便支派的地業中給了他們比悉和屬城的郊野，雅雜和屬城的郊野，',
    '書21:37 基底莫和屬城的郊野，米法押和屬城的郊野，共四座城；',
    '書21:38 又從迦得支派的地業中，將基列的拉末，就是誤殺人的逃城和屬城的郊野，給了他們；又給他們瑪哈念和屬城的郊野，',
    '書21:39 希實本和屬城的郊野，雅謝和屬城的郊野，共四座城。',
    '書21:40 其餘利未支派的人，就是米拉利的子孫，按著宗族拈鬮所得的，共十二座城。',
    '書21:41 利未人在以色列人的地業中所得的城，共四十八座，並有屬城的郊野。',
    '書21:42 這些城四圍都有屬城的郊野，城城都是如此。',
    '書21:43 這樣，耶和華將從前向他們列祖起誓所應許的全地賜給以色列人，他們就得了為業，住在其中。',
    '書21:44 耶和華照著向他們列祖起誓所應許的一切話，使他們四境平安；他們一切仇敵中，沒有一人在他們面前站立得住。耶和華把一切仇敵都交在他們手中。',
    '書21:45 耶和華應許賜福給以色列家的話一句也沒有落空，都應驗了。',
    '書22:1 當時，約書亞召了流便人、迦得人，和瑪拿西半支派的人來，',
    '書22:2 對他們說：耶和華僕人摩西所吩咐你們的，你們都遵守了；我所吩咐你們的，你們也都聽從了。',
    '書22:3 你們這許多日子，總沒有撇離你們的弟兄，直到今日，並守了耶和華─你們神所吩咐你們當守的。',
    '書22:4 如今耶和華─你們神照著他所應許的，使你們弟兄得享平安，現在可以轉回你們的帳棚，到耶和華的僕人摩西在約但河東所賜你們為業之地。',
    '書22:5 只要切切的謹慎遵行耶和華僕人摩西所吩咐你們的誡命律法，愛耶和華─你們的神，行他一切的道，守他的誡命，專靠他，盡心盡性事奉他。',
    '書22:6 於是約書亞為他們祝福，打發他們去，他們就回自己的帳棚去了。',
    '書22:7 瑪拿西那半支派，摩西早已在巴珊分給他們地業。這半支派，約書亞在約但河西，在他們弟兄中，分給他們地業。約書亞打發他們回帳棚的時候為他們祝福，',
    '書22:8 對他們說：你們帶許多財物，許多牲畜和金、銀、銅、鐵，並許多衣服，回你們的帳棚去，要將你們從仇敵奪來的物，與你們眾弟兄同分。',
    '書22:9 於是流便人、迦得人、瑪拿西半支派的人從迦南地的示羅起行，離開以色列人，回往他們得為業的基列地，就是照耶和華藉摩西所吩咐的得了為業之地。',
    '書22:10 流便人、迦得人，和瑪拿西半支派的人到了靠近約但河的一帶迦南地，就在約但河那裡築了一座壇；那壇看著高大。',
    '書22:11 以色列人聽說流便人、迦得人、瑪拿西半支派的人靠近約但河邊，在迦南地屬以色列人的那邊築了一座壇。',
    '書22:12 全會眾一聽見，就聚集在示羅，要上去攻打他們。',
    '書22:13 以色列人打發祭司以利亞撒的兒子非尼哈，往基列地去見流便人、迦得人、瑪拿西半支派的人；',
    '書22:14 又打發十個首領與非尼哈同去，就是以色列每支派的一個首領，都是以色列軍中的統領。',
    '書22:15 他們到了基列地，見流便人、迦得人，和瑪拿西半支派的人，對他們說：',
    '書22:16 耶和華全會眾這樣說，你們今日轉去不跟從耶和華，干犯以色列的神，為自己築一座壇，悖逆了耶和華，這犯的是什麼罪呢﹖',
    '書22:17 從前拜毘珥的罪孽還算小嗎﹖雖然瘟疫臨到耶和華的會眾，到今日我們還沒有洗淨這罪。',
    '書22:18 你們今日竟轉去不跟從耶和華嗎﹖你們今日既悖逆耶和華，明日他必向以色列全會眾發怒。',
    '書22:19 你們所得為業之地，若嫌不潔淨，就可以過到耶和華之地，就是耶和華的帳幕所住之地，在我們中間得地業。只是不可悖逆耶和華，也不可得罪我們，在耶和華─我們神的壇以外為自己築壇。',
    '書22:20 從前謝拉的曾孫亞干豈不是在那當滅的物上犯了罪，就有忿怒臨到以色列全會眾嗎﹖那人在所犯的罪中不獨一人死亡。',
    '書22:21 於是流便人、迦得人、瑪拿西半支派的人回答以色列軍中的統領說：',
    '書22:22 大能者神耶和華！大能者神耶和華！他是知道的！以色列人也必知道！我們若有悖逆的意思，或是干犯耶和華（願你今日不保佑我們），',
    '書22:23 為自己築壇，要轉去不跟從耶和華，或是要將燔祭、素祭、平安祭獻在壇上，願耶和華親自討我們的罪。',
    '書22:24 我們行這事並非無故，是特意做的，說：恐怕日後你們的子孫對我們的子孫說：你們與耶和華─以色列的神有何關涉呢﹖',
    '書22:25 因為耶和華把約但河定為我們和你們這流便人、迦得人的交界，你們與耶和華無分了。這樣，你們的子孫就使我們的子孫不再敬畏耶和華了。',
    '書22:26 因此我們說：不如為自己築一座壇，不是為獻燔祭，也不是為獻別的祭，',
    '書22:27 乃是為你我中間和你我後人中間作證據，好叫我們也在耶和華面前獻燔祭、平安祭，和別的祭事奉他，免得你們的子孫日後對我們的子孫說，你們與耶和華無分了。',
    '書22:28 所以我們說：日後你們對我們，或對我們的後人這樣說，我們就可以回答說，你們看我們列祖所築的壇是耶和華壇的樣式；這並不是為獻燔祭，也不是為獻別的祭，乃是為作你我中間的證據。',
    '書22:29 我們在耶和華─我們神帳幕前的壇以外，另築一座壇，為獻燔祭、素祭，和別的祭，悖逆耶和華，今日轉去不跟從他，我們斷沒有這個意思。',
    '書22:30 祭司非尼哈與會中的首領，就是與他同來以色列軍中的統領，聽見流便人、迦得人、瑪拿西人所說的話，就都以為美。',
    '書22:31 祭司以利亞撒的兒子非尼哈對流便人、迦得人、瑪拿西人說：今日我們知道耶和華在我們中間，因為你們沒有向他犯了這罪。現在你們救以色列人脫離耶和華的手了。',
    '書22:32 祭司以利亞撒的兒子非尼哈與眾首領離了流便人、迦得人，從基列地回往迦南地，到了以色列人那裡，便將這事回報他們。',
    '書22:33 以色列人以這事為美，就稱頌神，不再提上去攻打流便人、迦得人、毀壞他們所住的地了。',
    '書22:34 流便人、迦得人給壇起名叫證壇，意思說：這壇在我們中間證明耶和華是神。',
    '書23:1 耶和華使以色列人安靜，不與四圍的一切仇敵爭戰，已經多日。約書亞年紀老邁，',
    '書23:2 就把以色列眾人的長老、族長、審判官，並官長都召了來，對他們說：我年紀已經老邁。',
    '書23:3 耶和華─你們的神因你們的緣故向那些國所行的一切事，你們親眼看見了，因那為你們爭戰的是耶和華─你們的神。',
    '書23:4 我所剪除和所剩下的各國，從約但河起到日落之處的大海，我已經拈鬮分給你們各支派為業。',
    '書23:5 耶和華─你們的神必將他們從你們面前趕出去，使他們離開你們，你們就必得他們的地為業，正如耶和華─你們的神所應許的。',
    '書23:6 所以，你們要大大壯膽，謹守遵行寫在摩西律法書上的一切話，不可偏離左右。',
    '書23:7 不可與你們中間所剩下的這些國民攙雜。他們的神，你們不可提他的名，不可指著他起誓，也不可事奉、叩拜；',
    '書23:8 只要照著你們到今日所行的，專靠耶和華─你們的神。',
    '書23:9 因為耶和華已經把又大又強的國民從你們面前趕出；直到今日，沒有一人在你們面前站立得住。',
    '書23:10 你們一人必追趕千人，因耶和華─你們的神照他所應許的，為你們爭戰。',
    '書23:11 你們要分外謹慎，愛耶和華─你們的神。',
    '書23:12 你們若稍微轉去，與你們中間所剩下的這些國民聯絡，彼此結親，互相往來，',
    '書23:13 你們要確實知道，耶和華─你們的神必不再將他們從你們眼前趕出；他們卻要成為你們的網羅、機檻、肋上的鞭、眼中的刺，直到你們在耶和華─你們神所賜的這美地上滅亡。',
    '書23:14 我現在要走世人必走的路。你們是一心一意地知道，耶和華─你們神所應許賜福與你們的話沒有一句落空，都應驗在你們身上了。',
    '書23:15 耶和華─你們神所應許的一切福氣怎樣臨到你們身上，耶和華也必照樣使各樣禍患臨到你們身上，直到把你們從耶和華─你們神所賜的這美地上除滅。',
    '書23:16 你們若違背耶和華─你們神吩咐你們所守的約，去事奉別神，叩拜他，耶和華的怒氣必向你們發作，使你們在他所賜的美地上速速滅亡。',
    '書24:1 約書亞將以色列的眾支派聚集在示劍，召了以色列的長老、族長、審判官，並官長來，他們就站在神面前。',
    '書24:2 約書亞對眾民說：耶和華─以色列的神如此說：古時你們的列祖，就是亞伯拉罕和拿鶴的父親他拉，住在大河那邊事奉別神，',
    '書24:3 我將你們的祖宗亞伯拉罕從大河那邊帶來，領他走遍迦南全地，又使他的子孫眾多，把以撒賜給他；',
    '書24:4 又把雅各和以掃賜給以撒，將西珥山賜給以掃為業；後來雅各和他的子孫下到埃及去了。',
    '書24:5 我差遣摩西、亞倫，並照我在埃及中所行的降災與埃及，然後把你們領出來。',
    '書24:6 我領你們列祖出埃及，他們就到了紅海；埃及人帶領車輛馬兵追趕你們列祖到紅海。',
    '書24:7 你們列祖哀求耶和華，他就使你們和埃及人中間黑暗了，又使海水淹沒埃及人。我在埃及所行的事，你們親眼見過。你們在曠野也住了許多年日。',
    '書24:8 我領你們到約但河東亞摩利人所住之地。他們與你們爭戰，我將他們交在你們手中，你們便得了他們的地為業；我也在你們面前將他們滅絕。',
    '書24:9 那時，摩押王西撥的兒子巴勒起來攻擊以色列人，打發人召了比珥的兒子巴蘭來咒詛你們。',
    '書24:10 我不肯聽巴蘭的話，所以他倒為你們連連祝福。這樣，我便救你們脫離巴勒的手。',
    '書24:11 你們過了約但河，到了耶利哥；耶利哥人、亞摩利人、比利洗人、迦南人、赫人、革迦撒人、希未人、耶布斯人都與你們爭戰；我把他們交在你們手裡。',
    '書24:12 我打發黃蜂飛在你們前面，將亞摩利人的二王從你們面前攆出，並不是用你的刀，也不是用你的弓。',
    '書24:13 我賜給你們地土，非你們所修治的；我賜給你們城邑，非你們所建造的。你們就住在其中，又得吃非你們所栽種的葡萄園、橄欖園的果子。',
    '書24:14 現在你們要敬畏耶和華，誠心實意地事奉他，將你們列祖在大河那邊和在埃及所事奉的神除掉，去事奉耶和華。',
    '書24:15 若是你們以事奉耶和華為不好，今日就可以選擇所要事奉的：是你們列祖在大河那邊所事奉的神呢﹖是你們所住這地的亞摩利人的神呢﹖至於我和我家，我們必定事奉耶和華。',
    '書24:16 百姓回答說：我們斷不敢離棄耶和華去事奉別神；',
    '書24:17 因耶和華─我們的神曾將我們和我們列祖從埃及地的為奴之家領出來，在我們眼前行了那些大神蹟，在我們所行的道上，所經過的諸國，都保護了我們。',
    '書24:18 耶和華又把住此地的亞摩利人都從我們面前趕出去。所以，我們必事奉耶和華，因為他是我們的神。',
    '書24:19 約書亞對百姓說：你們不能事奉耶和華；因為他是聖潔的神，是忌邪的神，必不赦免你們的過犯罪惡。',
    '書24:20 你們若離棄耶和華去事奉外邦神，耶和華在降福之後，必轉而降禍與你們，把你們滅絕。',
    '書24:21 百姓回答約書亞說：不然，我們定要事奉耶和華。',
    '書24:22 約書亞對百姓說：你們選定耶和華，要事奉他，你們自己作見證吧！他們說：我們願意作見證。',
    '書24:23 約書亞說：你們現在要除掉你們中間的外邦神，專心歸向耶和華─以色列的神。',
    '書24:24 百姓回答約書亞說：我們必事奉耶和華─我們的神，聽從他的話。',
    '書24:25 當日，約書亞就與百姓立約，在示劍為他們立定律例典章。',
    '書24:26 約書亞將這些話都寫在神的律法書上，又將一塊大石頭立在橡樹下耶和華的聖所旁邊。',
    '書24:27 約書亞對百姓說：看哪，這石頭可以向我們作見證；因為是聽見了耶和華所吩咐我們的一切話，倘或你們背棄你們的神，這石頭就可以向你們作見證（倘或云云：或作所以要向你們作見證，免得你們背棄耶和華─你們的神）。',
    '書24:28 於是約書亞打發百姓各歸自己的地業去了。',
    '書24:29 這些事以後，耶和華的僕人嫩的兒子約書亞，正一百一十歲，就死了。',
    '書24:30 以色列人將他葬在他地業的境內，就是在以法蓮山地的亭拿西拉，在迦實山的北邊。',
    '書24:31 約書亞在世和約書亞死後，那些知道耶和華為以色列人所行諸事的長老還在的時候，以色列人事奉耶和華。',
    '書24:32 以色列人從埃及所帶來約瑟的骸骨，葬埋在示劍，就是在雅各從前用一百塊銀子向示劍的父親、哈抹的子孫所買的那塊地裡；這就作了約瑟子孫的產業。',
    '書24:33 亞倫的兒子以利亞撒也死了，就把他葬在他兒子非尼哈所得、以法蓮山地的小山上。',
    '士1:1 約書亞死後，以色列人求問耶和華說：我們中間誰當首先上去攻擊迦南人，與他們爭戰﹖',
    '士1:2 耶和華說：猶大當先上去，我已將那地交在他手中。',
    '士1:3 猶大對他哥哥西緬說：請你同我到拈鬮所得之地去，好與迦南人爭戰；以後我也同你到你拈鬮所得之地去。於是西緬與他同去。',
    '士1:4 猶大就上去；耶和華將迦南人和比利洗人交在他們手中。他們在比色擊殺了一萬人，',
    '士1:5 又在那裡遇見亞多尼比色，與他爭戰，殺敗迦南人和比利洗人。',
    '士1:6 亞多尼比色逃跑；他們追趕，拿住他，砍斷他手腳的大姆指。',
    '士1:7 亞多尼比色說：從前有七十個王，手腳的大姆指都被我砍斷，在我桌子底下拾取零碎食物。現在神按著我所行的報應我了。於是他們將亞多尼比色帶到耶路撒冷，他就死在那裡。',
    '士1:8 猶大人攻打耶路撒冷，將城攻取，用刀殺了城內的人，並且放火燒城。',
    '士1:9 後來猶大人下去，與住山地、南地，和高原的迦南人爭戰。',
    '士1:10 猶大人去攻擊住希伯崙的迦南人，殺了示篩、亞希幔、撻買。希伯崙從前名叫基列亞巴。',
    '士1:11 他們從那裡去攻擊底壁的居民；底壁從前名叫基列西弗。',
    '士1:12 迦勒說：誰能攻打基列西弗，將城奪取，我就把我女兒押撒給他為妻。',
    '士1:13 迦勒兄弟基納斯的兒子俄陀聶奪取了那城，迦勒就把女兒押撒給他為妻。',
    '士1:14 押撒過門的時候，勸丈夫向他父親求一塊田。押撒一下驢，迦勒問他說：你要什麼﹖',
    '士1:15 他說：求你賜福給我，你既將我安置在南地，求你也給我水泉。迦勒就把上泉下泉賜給他。',
    '士1:16 摩西的內兄（或譯：岳父）是基尼人，他的子孫與猶大人一同離了棕樹城，往亞拉得以南的猶大曠野去，就住在民中。',
    '士1:17 猶大和他哥哥西緬同去，擊殺了住洗法的迦南人，將城盡行毀滅，那城的名便叫何珥瑪。',
    '士1:18 猶大又取了迦薩和迦薩的四境，亞實基倫和亞實基倫的四境，以革倫和以革倫的四境。',
    '士1:19 耶和華與猶大同在，猶大就趕出山地的居民，只是不能趕出平原的居民，因為他們有鐵車。',
    '士1:20 以色列人照摩西所說的，將希伯崙給了迦勒；迦勒就從那裡趕出亞衲族的三個族長。',
    '士1:21 便雅憫人沒有趕出住耶路撒冷的耶布斯人。耶布斯人仍在耶路撒冷與便雅憫人同住，直到今日。',
    '士1:22 約瑟家也上去攻打伯特利；耶和華與他們同在。',
    '士1:23 約瑟家打發人去窺探伯特利（那城起先名叫路斯）。',
    '士1:24 窺探的人看見一個人從城裡出來，就對他說：求你將進城的路指示我們，我們必恩待你。',
    '士1:25 那人將進城的路指示他們，他們就用刀擊殺了城中的居民，但將那人和他全家放去。',
    '士1:26 那人往赫人之地去，築了一座城，起名叫路斯。那城到如今還叫這名。',
    '士1:27 瑪拿西沒有趕出伯善和屬伯善鄉村的居民，他納和屬他納鄉村的居民，多珥和屬多珥鄉村的居民，以伯蓮和屬以伯蓮鄉村的居民，米吉多和屬米吉多鄉村的居民；迦南人卻執意住在那些地方。',
    '士1:28 及至以色列強盛了，就使迦南人做苦工，沒有把他們全然趕出。',
    '士1:29 以法蓮沒有趕出住基色的迦南人。於是迦南人仍住在基色，在以法蓮中間。',
    '士1:30 西布倫沒有趕出基倫的居民和拿哈拉的居民。於是迦南人仍住在西布倫中間，成了服苦的人。',
    '士1:31 亞設沒有趕出亞柯和西頓的居民，亞黑拉和亞革悉的居民，黑巴、亞弗革與利合的居民。',
    '士1:32 於是，亞設因為沒有趕出那地的迦南人，就住在他們中間。',
    '士1:33 拿弗他利沒有趕出伯示麥和伯亞納的居民，於是拿弗他利就住在那地的迦南人中間；然而伯示麥和伯亞納的居民成了服苦的人。',
    '士1:34 亞摩利人強逼但人住在山地，不容他們下到平原；',
    '士1:35 亞摩利人卻執意住在希烈山和亞雅倫並沙賓。然而約瑟家勝了他們，使他們成了服苦的人。',
    '士1:36 亞摩利人的境界，是從亞克拉濱坡，從西拉而上。',
    '士2:1 耶和華的使者從吉甲上到波金，對以色列人說：我使你們從埃及上來，領你們到我向你們列祖起誓應許之地。我又說：我永不廢棄與你們所立的約。',
    '士2:2 你們也不可與這地的居民立約，要拆毀他們的祭壇。你們竟沒有聽從我的話！為何這樣行呢﹖',
    '士2:3 因此我又說：我必不將他們從你們面前趕出；他們必作你們肋下的荊棘。他們的神必作你們的網羅。',
    '士2:4 耶和華的使者向以色列眾人說這話的時候，百姓就放聲而哭；',
    '士2:5 於是給那地方起名叫波金（就是哭的意思）。眾人在那裡向耶和華獻祭。',
    '士2:6 從前約書亞打發以色列百姓去的時候，他們各歸自己的地業，佔據地土。',
    '士2:7 約書亞在世和約書亞死後，那些見耶和華為以色列人所行大事的長老還在的時候，百姓都事奉耶和華。',
    '士2:8 耶和華的僕人、嫩的兒子約書亞，正一百一十歲就死了。',
    '士2:9 以色列人將他葬在他地業的境內，就是在以法蓮山地的亭拿希烈，在迦實山的北邊。',
    '士2:10 那世代的人也都歸了自己的列祖。後來有別的世代興起，不知道耶和華，也不知道耶和華為以色列人所行的事。',
    '士2:11 以色列人行耶和華眼中看為惡的事，去事奉諸巴力，',
    '士2:12 離棄了領他們出埃及地的耶和華─他們列祖的神，去叩拜別神，就是四圍列國的神，惹耶和華發怒；',
    '士2:13 並離棄耶和華，去事奉巴力和亞斯她錄。',
    '士2:14 耶和華的怒氣向以色列人發作，就把他們交在搶奪他們的人手中，又將他們付與四圍仇敵的手中，甚至他們在仇敵面前再不能站立得住。',
    '士2:15 他們無論往何處去，耶和華都以災禍攻擊他們，正如耶和華所說的話，又如耶和華向他們所起的誓；他們便極其困苦。',
    '士2:16 耶和華興起士師，士師就拯救他們脫離搶奪他們人的手。',
    '士2:17 他們卻不聽從士師，竟隨從叩拜別神，行了邪淫，速速地偏離他們列祖所行的道，不如他們列祖順從耶和華的命令。',
    '士2:18 耶和華為他們興起士師，就與那士師同在。士師在世的一切日子，耶和華拯救他們脫離仇敵的手。他們因受欺壓擾害，就哀聲歎氣，所以耶和華後悔了。',
    '士2:19 及至士師死後，他們就轉去行惡，比他們列祖更甚，去事奉叩拜別神，總不斷絕頑梗的惡行。',
    '士2:20 於是耶和華的怒氣向以色列人發作。他說：因這民違背我吩咐他們列祖所守的約，不聽從我的話，',
    '士2:21 所以約書亞死的時候所剩下的各族，我必不再從他們面前趕出，',
    '士2:22 為要藉此試驗以色列人，看他們肯照他們列祖謹守遵行我的道不肯。',
    '士2:23 這樣耶和華留下各族，不將他們速速趕出，也沒有交付約書亞的手。',
    '士3:1 耶和華留下這幾族，為要試驗那不曾知道與迦南爭戰之事的以色列人，',
    '士3:2 好叫以色列的後代又知道又學習未曾曉得的戰事。',
    '士3:3 所留下的就是非利士的五個首領和一切迦南人、西頓人，並住利巴嫩山的希未人，從巴力黑們山直到哈馬口。',
    '士3:4 留下這幾族，為要試驗以色列人，知道他們肯聽從耶和華藉摩西吩咐他們列祖的誡命不肯。',
    '士3:5 以色列人竟住在迦南人、赫人、亞摩利人、比利洗人、希未人、耶布斯人中間，',
    '士3:6 娶他們的女兒為妻，將自己的女兒嫁給他們的兒子，並事奉他們的神。',
    '士3:7 以色列人行耶和華眼中看為惡的事，忘記耶和華─他們的神，去事奉諸巴力和亞舍拉，',
    '士3:8 所以耶和華的怒氣向以色列人發作，就把他們交在米所波大米王古珊利薩田的手中。以色列人服事古珊利薩田八年。',
    '士3:9 以色列人呼求耶和華的時候，耶和華就為他們興起一位拯救者救他們，就是迦勒兄弟基納斯的兒子俄陀聶。',
    '士3:10 耶和華的靈降在他身上，他就作了以色列的士師，出去爭戰。耶和華將米所波大米王古珊利薩田交在他手中，他便勝了古珊利薩田。',
    '士3:11 於是國中太平四十年。基納斯的兒子俄陀聶死了。',
    '士3:12 以色列人又行耶和華眼中看為惡的事，耶和華就使摩押王伊磯倫強盛，攻擊以色列人。',
    '士3:13 伊磯倫招聚亞捫人和亞瑪力人，去攻打以色列人，佔據棕樹城。',
    '士3:14 於是以色列人服事摩押王伊磯倫十八年。',
    '士3:15 以色列人呼求耶和華的時候，耶和華就為他們興起一位拯救者，就是便雅憫人基拉的兒子以笏；他是左手便利的。以色列人託他送禮物給摩押王伊磯倫。',
    '士3:16 以笏打了一把兩刃的劍，長一肘，帶在右腿上衣服裡面。',
    '士3:17 他將禮物獻給摩押王伊磯倫（原來伊磯倫極其肥胖）；',
    '士3:18 以笏獻完禮物，便將擡禮物的人打發走了，',
    '士3:19 自己卻從靠近吉甲鑿石之地回來，說：王啊，我有一件機密事奏告你。王說：迴避吧！於是左右侍立的人都退去了。',
    '士3:20 以笏來到王面前；王獨自一人坐在涼樓上。以笏說：我奉神的命報告你一件事。王就從座位上站起來。',
    '士3:21 以笏便伸左手，從右腿上拔出劍來，刺入王的肚腹，',
    '士3:22 連劍把都刺進去了。劍被肥肉夾住，他沒有從王的肚腹拔出來，且穿通了後身。',
    '士3:23 以笏就出到遊廊，將樓門盡都關鎖。',
    '士3:24 以笏出來之後，王的僕人到了，看見樓門關鎖，就說：他必是在樓上大解。',
    '士3:25 他們等煩了，見仍不開樓門，就拿鑰匙開了，不料，他們的主人已死，倒在地上。',
    '士3:26 他們耽延的時候，以笏就逃跑了，經過鑿石之地，逃到西伊拉；',
    '士3:27 到了，就在以法蓮山地吹角。以色列人隨著他下了山地，他在前頭引路，',
    '士3:28 對他們說：你們隨我來，因為耶和華已經把你們的仇敵摩押人交在你們手中。於是他們跟著他下去，把守約但河的渡口，不容摩押一人過去。',
    '士3:29 那時擊殺了摩押人約有一萬，都是強壯的勇士，沒有一人逃脫。',
    '士3:30 這樣，摩押就被以色列人制伏了。國中太平八十年。',
    '士3:31 以笏之後，有亞拿的兒子珊迦，他用趕牛的棍子打死六百非利士人。他也救了以色列人。',
    '士4:1 以笏死後，以色列人又行耶和華眼中看為惡的事，',
    '士4:2 耶和華就把他們付與在夏瑣作王的迦南王耶賓手中；他的將軍是西西拉，住在外邦人的夏羅設。',
    '士4:3 耶賓王有鐵車九百輛。他大大欺壓以色列人二十年，以色列人就呼求耶和華。',
    '士4:4 有一位女先知名叫底波拉，是拉比多的妻，當時作以色列的士師。',
    '士4:5 她住在以法蓮山地拉瑪和伯特利中間，在底波拉的棕樹下。以色列人都上他那裡去聽判斷。',
    '士4:6 她打發人從拿弗他利的基低斯將亞比挪菴的兒子巴拉召了來，對他說：耶和華─以色列的神吩咐你說：你率領一萬拿弗他利和西布倫人上他泊山去。',
    '士4:7 我必使耶賓的將軍西西拉率領他的車輛和全軍往基順河，到你那裡去；我必將他交在你手中。',
    '士4:8 巴拉說：你若同我去，我就去；你若不同我去，我就不去。',
    '士4:9 底波拉說：我必與你同去，只是你在所行的路上得不著榮耀，因為耶和華要將西西拉交在一個婦人手裡。於是底波拉起來，與巴拉一同往基低斯去了。',
    '士4:10 巴拉就招聚西布倫人和拿弗他利人到基低斯，跟他上去的有一萬人。底波拉也同他上去。',
    '士4:11 摩西岳父（或譯：內兄）何巴的後裔，基尼人希百曾離開基尼族，到靠近基低斯撒拿音的橡樹旁支搭帳棚。',
    '士4:12 有人告訴西西拉說：亞比挪菴的兒子巴拉已經上他泊山了。',
    '士4:13 西西拉就聚集所有的鐵車九百輛和跟隨他的全軍，從外邦人的夏羅設出來，到了基順河。',
    '士4:14 底波拉對巴拉說：你起來，今日就是耶和華將西西拉交在你手的日子。耶和華豈不在你前頭行嗎﹖於是巴拉下了他泊山，跟隨他有一萬人。',
    '士4:15 耶和華使西西拉和他一切車輛全軍潰亂，在巴拉面前被刀殺敗；西西拉下車步行逃跑。',
    '士4:16 巴拉追趕車輛、軍隊，直到外邦人的夏羅設。西西拉的全軍都倒在刀下，沒有留下一人。',
    '士4:17 只有西西拉步行逃跑，到了基尼人希百之妻雅億的帳棚，因為夏瑣王耶賓與基尼人希百家和好。',
    '士4:18 雅億出來迎接西西拉，對他說：請我主進來，不要懼怕；西西拉就進了他的帳棚。雅億用被將他遮蓋。',
    '士4:19 西西拉對雅億說：我渴了，求你給我一點水喝。雅億就打開皮袋，給他奶子喝，仍舊把他遮蓋。',
    '士4:20 西西拉又對雅億說：請你站在帳棚門口，若有人來問你說：有人在這裡沒有﹖你就說：沒有。',
    '士4:21 西西拉疲乏沉睡。希百的妻雅億取了帳棚的橛子，手裡拿著錘子，輕悄悄地到他旁邊，將橛子從他鬢邊釘進去，釘入地裡。西西拉就死了。',
    '士4:22 巴拉追趕西西拉的時候，雅億出來迎接他說：來吧，我將你所尋找的人給你看。他就進入帳棚，看見西西拉已經死了，倒在地上，橛子還在他鬢中。',
    '士4:23 這樣，神使迦南王耶賓被以色列人制伏了。',
    '士4:24 從此以色列人的手越發有力，勝了迦南王耶賓，直到將他滅絕了。',
    '士5:1 那時，底波拉和亞比挪菴的兒子巴拉作歌，說：',
    '士5:2 因為以色列中有軍長率領，百姓也甘心犧牲自己，你們應當頌讚耶和華！',
    '士5:3 君王啊，要聽！王子啊，要側耳而聽！我要向耶和華歌唱；我要歌頌耶和華─以色列的神。',
    '士5:4 耶和華啊，你從西珥出來，由以東地行走。那時地震天漏，雲也落雨。',
    '士5:5 山見耶和華的面就震動，西乃山見耶和華─以色列神的面也是如此。',
    '士5:6 在亞拿之子珊迦的時候，又在雅億的日子，大道無人行走，都是繞道而行。',
    '士5:7 以色列中的官長停職，直到我底波拉興起，等我興起作以色列的母。',
    '士5:8 以色列人選擇新神，爭戰的事就臨到城門。那時，以色列四萬人中豈能見盾牌槍矛呢﹖',
    '士5:9 我心傾向以色列的首領，他們在民中甘心犧牲自己。你們應當頌讚耶和華！',
    '士5:10 騎白驢的、坐繡花毯子的、行路的，你們都當傳揚！',
    '士5:11 在遠離弓箭響聲打水之處，人必述說耶和華公義的作為，就是他治理以色列公義的作為。那時耶和華的民下到城門。',
    '士5:12 底波拉啊，興起！興起！你當興起，興起，唱歌。亞比挪菴的兒子巴拉啊，你當奮興，擄掠你的敵人。',
    '士5:13 那時有餘剩的貴冑和百姓一同下來；耶和華降臨，為我攻擊勇士。',
    '士5:14 有根本在亞瑪力人的地，從以法蓮下來的；便雅憫在民中跟隨你。有掌權的從瑪吉下來；有持杖檢點民數的從西布倫下來；',
    '士5:15 以薩迦的首領與底波拉同來；以薩迦怎樣，巴拉也怎樣。眾人都跟隨巴拉衝下平原；在流便的溪水旁有心中定大志的。',
    '士5:16 你為何坐在羊圈內聽群中吹笛的聲音呢﹖在流便的溪水旁有心中設大謀的。',
    '士5:17 基列人安居在約但河外。但人為何等在船上﹖亞設人在海口靜坐，在港口安居。',
    '士5:18 西布倫人是拚命敢死的；拿弗他利人在田野的高處也是如此。',
    '士5:19 君王都來爭戰。那時迦南諸王在米吉多水旁的他納爭戰，卻未得擄掠銀錢。',
    '士5:20 星宿從天上爭戰，從其軌道攻擊西西拉。',
    '士5:21 基順古河把敵人沖沒；我的靈啊，應當努力前行。',
    '士5:22 那時壯馬馳驅，踢跳，奔騰。',
    '士5:23 耶和華的使者說：應當咒詛米羅斯，大大咒詛其中的居民；因為他們不來幫助耶和華，不來幫助耶和華攻擊勇士。',
    '士5:24 願基尼人希百的妻雅億比眾婦人多得福氣，比住帳棚的婦人更蒙福祉。',
    '士5:25 西西拉求水，雅億給他奶子，用寶貴的盤子給他奶油。',
    '士5:26 雅億左手拿著帳棚的橛子，右手拿著匠人的錘子，擊打西西拉，打傷他的頭，把他的鬢角打破穿通。',
    '士5:27 西西拉在他腳前曲身仆倒，在他腳前曲身倒臥；在那裡曲身，就在那裡死亡。',
    '士5:28 西西拉的母親從窗戶裡往外觀看，從窗櫺中呼叫說：他的戰車為何耽延不來呢﹖他的車輪為何行得慢呢﹖',
    '士5:29 聰明的宮女安慰他（原文是回答他），他也自言自語地說：',
    '士5:30 他們莫非得財而分﹖每人得了一兩個女子﹖西西拉得了彩衣為擄物，得繡花的彩衣為掠物。這彩衣兩面繡花，乃是披在被擄之人頸項上的。',
    '士5:31 耶和華啊，願你的仇敵都這樣滅亡！願愛你的人如日頭出現，光輝烈烈！這樣，國中太平四十年。',
    '士6:1 以色列人又行耶和華眼中看為惡的事，耶和華就把他們交在米甸人手裡七年。',
    '士6:2 米甸人壓制以色列人；以色列人因為米甸人，就在山中挖穴、挖洞、建造營寨。',
    '士6:3 以色列人每逢撒種之後，米甸人、亞瑪力人，和東方人都上來攻打他們，',
    '士6:4 對著他們安營，毀壞土產，直到迦薩，沒有給以色列人留下食物，牛、羊、驢也沒有留下；',
    '士6:5 因為那些人帶著牲畜帳棚來，像蝗蟲那樣多，人和駱駝無數，都進入國內，毀壞全地。',
    '士6:6 以色列人因米甸人的緣故，極其窮乏，就呼求耶和華。',
    '士6:7 以色列人因米甸人的緣故，呼求耶和華，',
    '士6:8 耶和華就差遣先知到以色列人那裡，對他們說：耶和華─以色列的神如此說：我曾領你們從埃及上來，出了為奴之家，',
    '士6:9 救你們脫離埃及人的手，並脫離一切欺壓你們之人的手，把他們從你們面前趕出，將他們的地賜給你們；',
    '士6:10 又對你們說：我是耶和華─你們的神。你們住在亞摩利人的地，不可敬畏他們的神。你們竟不聽從我的話。',
    '士6:11 耶和華的使者到了俄弗拉，坐在亞比以謝族人約阿施的橡樹下。約阿施的兒子基甸正在酒醡那裡打麥子，為要防備米甸人。',
    '士6:12 耶和華的使者向基甸顯現，對他說：大能的勇士啊，耶和華與你同在！',
    '士6:13 基甸說：主啊，耶和華若與我們同在，我們何至遭遇這一切事呢﹖我們的列祖不是向我們說耶和華領我們從埃及上來嗎﹖他那樣奇妙的作為在哪裡呢﹖現在他卻丟棄我們，將我們交在米甸人手裡。',
    '士6:14 耶和華觀看基甸，說：你靠著你這能力去從米甸人手裡拯救以色列人，不是我差遣你去的嗎﹖',
    '士6:15 基甸說：主啊，我有何能拯救以色列人呢﹖我家在瑪拿西支派中是至貧窮的。我在我父家是至微小的。',
    '士6:16 耶和華對他說：我與你同在，你就必擊打米甸人，如擊打一人一樣。',
    '士6:17 基甸說：我若在你眼前蒙恩，求你給我一個證據，使我知道與我說話的就是主。',
    '士6:18 求你不要離開這裡，等我歸回將禮物帶來供在你面前。主說：我必等你回來。',
    '士6:19 基甸去預備了一隻山羊羔，用一伊法細麵做了無酵餅，將肉放在筐內，把湯盛在壺中，帶到橡樹下，獻在使者面前。',
    '士6:20 神的使者吩咐基甸說：將肉和無酵餅放在這磐石上，把湯倒出來。他就這樣行了。',
    '士6:21 耶和華的使者伸出手內的杖，杖頭挨了肉和無酵餅，就有火從磐石中出來，燒盡了肉和無酵餅。耶和華的使者也就不見了。',
    '士6:22 基甸見他是耶和華的使者，就說：哀哉！主耶和華啊，我不好了，因為我覿面看見耶和華的使者。',
    '士6:23 耶和華對他說：你放心，不要懼怕，你必不致死。',
    '士6:24 於是基甸在那裡為耶和華築了一座壇，起名叫耶和華沙龍（就是耶和華賜平安的意思）。（這壇在亞比以謝族的俄弗拉直到如今。）',
    '士6:25 當那夜，耶和華吩咐基甸說：你取你父親的牛來，就是（或譯：和）那七歲的第二隻牛，並拆毀你父親為巴力所築的壇，砍下壇旁的木偶，',
    '士6:26 在這磐石（原文是保障）上整整齊齊地為耶和華─你的神築一座壇，將第二隻牛獻為燔祭，用你所砍下的木偶作柴。',
    '士6:27 基甸就從他僕人中挑了十個人，照著耶和華吩咐他的行了。他因怕父家和本城的人，不敢在白晝行這事，就在夜間行了。',
    '士6:28 城裡的人清早起來，見巴力的壇拆毀，壇旁的木偶砍下，第二隻牛獻在新築的壇上，',
    '士6:29 就彼此說：這事是誰做的呢﹖他們訪查之後，就說：這是約阿施的兒子基甸做的。',
    '士6:30 城裡的人對約阿施說：將你兒子交出來，好治死他；因為他拆毀了巴力的壇，砍下壇旁的木偶。',
    '士6:31 約阿施回答站著攻擊他的眾人說：你們是為巴力爭論嗎﹖你們要救他嗎﹖誰為他爭論，趁早將誰治死！巴力若果是神，有人拆毀他的壇，讓他為自己爭論吧！',
    '士6:32 所以當日人稱基甸為耶路巴力，意思說：他拆毀巴力的壇，讓巴力與他爭論。',
    '士6:33 那時，米甸人、亞瑪力人，和東方人都聚集過河，在耶斯列平原安營。',
    '士6:34 耶和華的靈降在基甸身上，他就吹角；亞比以謝族都聚集跟隨他。',
    '士6:35 他打發人走遍瑪拿西地，瑪拿西人也聚集跟隨他；又打發人去見亞設人、西布倫人、拿弗他利人，他們也都出來與他們會合。',
    '士6:36 基甸對神說：你若果照著所說的話，藉我手拯救以色列人，',
    '士6:37 我就把一團羊毛放在禾場上：若單是羊毛上有露水，別的地方都是乾的，我就知道你必照著所說的話，藉我手拯救以色列人。',
    '士6:38 次日早晨基甸起來，見果然是這樣；將羊毛擠一擠，從羊毛中擰出滿盆的露水來。',
    '士6:39 基甸又對神說：求你不要向我發怒，我再說這一次：讓我將羊毛再試一次。但願羊毛是乾的，別的地方都有露水。',
    '士6:40 這夜神也如此行：獨羊毛上是乾的，別的地方都有露水。',
    '士7:1 耶路巴力就是基甸，他和一切跟隨的人早晨起來，在哈律泉旁安營。米甸營在他們北邊的平原，靠近摩利岡。',
    '士7:2 耶和華對基甸說：跟隨你的人過多，我不能將米甸人交在他們手中，免得以色列人向我誇大，說：是我們自己的手救了我們。',
    '士7:3 現在你要向這些人宣告說：凡懼怕膽怯的，可以離開基列山回去。於是有二萬二千人回去，只剩下一萬。',
    '士7:4 耶和華對基甸說：人還是過多；你要帶他們下到水旁，我好在那裡為你試試他們。我指點誰說：這人可以同你去，他就可以同你去；我指點誰說：這人不可同你去，他就不可同你去。',
    '士7:5 基甸就帶他們下到水旁。耶和華對基甸說：凡用舌頭舔水，像狗舔的，要使他單站在一處；凡跪下喝水的，也要使他單站在一處。',
    '士7:6 於是用手捧著舔水的有三百人，其餘的都跪下喝水。',
    '士7:7 耶和華對基甸說：我要用這舔水的三百人拯救你們，將米甸人交在你手中；其餘的人都可以各歸各處去。',
    '士7:8 這三百人就帶著食物和角；其餘的以色列人，基甸都打發他們各歸各的帳棚，只留下這三百人。米甸營在他下邊的平原裡。',
    '士7:9 當那夜，耶和華吩咐基甸說：起來，下到米甸營裡去，因我已將他們交在你手中。',
    '士7:10 倘若你怕下去，就帶你的僕人普拉下到那營裡去。',
    '士7:11 你必聽見他們所說的，然後你就有膽量下去攻營。於是基甸帶著僕人普拉下到營旁。',
    '士7:12 米甸人、亞瑪力人，和一切東方人都布散在平原，如同蝗蟲那樣多。他們的駱駝無數，多如海邊的沙。',
    '士7:13 基甸到了，就聽見一人將夢告訴同伴說：我做了一夢，夢見一個大麥餅滾入米甸營中，到了帳幕，將帳幕撞倒，帳幕就翻轉傾覆了。',
    '士7:14 那同伴說：這不是別的，乃是以色列人約阿施的兒子基甸的刀；神已將米甸和全軍都交在他的手中。',
    '士7:15 基甸聽見這夢和夢的講解，就敬拜神，回到以色列營中，說：起來吧！耶和華已將米甸的軍隊交在你們手中了。',
    '士7:16 於是基甸將三百人分作三隊，把角和空瓶交在各人手裡（瓶內都藏著火把），',
    '士7:17 吩咐他們說：你們要看我行事：我到了營的旁邊怎樣行，你們也要怎樣行。',
    '士7:18 我和一切跟隨我的人吹角的時候，你們也要在營的四圍吹角，喊叫說：耶和華和基甸的刀！',
    '士7:19 基甸和跟隨他的一百人，在三更之初才換更的時候，來到營旁，就吹角，打破手中的瓶。',
    '士7:20 三隊的人就都吹角，打破瓶子，左手拿著火把，右手拿著角，喊叫說：耶和華和基甸的刀！',
    '士7:21 他們在營的四圍各站各的地方；全營的人都亂竄。三百人吶喊，使他們逃跑。',
    '士7:22 三百人就吹角，耶和華使全營的人用刀互相擊殺，逃到西利拉的伯哈示他，直逃到靠近他巴的亞伯米何拉。',
    '士7:23 以色列人就從拿弗他利、亞設，和瑪拿西全地聚集來追趕米甸人。',
    '士7:24 基甸打發人走遍以法蓮山地，說：你們下來攻擊米甸人，爭先把守約但河的渡口，直到伯巴拉。於是以法蓮的眾人聚集，把守約但河的渡口，直到伯巴拉，',
    '士7:25 捉住了米甸人的兩個首領：一名俄立，一名西伊伯；將俄立殺在俄立磐石上，將西伊伯殺在西伊伯酒醡那裡；又追趕米甸人，將俄立和西伊伯的首級帶過約但河，到基甸那裡。',
    '士8:1 以法蓮人對基甸說：你去與米甸人爭戰，沒有招我們同去，為什麼這樣待我們呢﹖他們就與基甸大大地爭吵。',
    '士8:2 基甸對他們說：我所行的豈能比你們所行的呢﹖以法蓮拾取剩下的葡萄不強過亞比以謝所摘的葡萄嗎﹖',
    '士8:3 神已將米甸人的兩個首領俄立和西伊伯交在你們手中；我所行的豈能比你們所行的呢﹖基甸說了這話，以法蓮人的怒氣就消了。',
    '士8:4 基甸和跟隨他的三百人到約但河過渡，雖然疲乏，還是追趕。',
    '士8:5 基甸對疏割人說：求你們拿餅來給跟隨我的人吃，因為他們疲乏了；我們追趕米甸人的兩個王西巴和撒慕拿。',
    '士8:6 疏割人的首領回答說：西巴和撒慕拿已經在你手裡，你使我們將餅給你的軍兵嗎﹖',
    '士8:7 基甸說：耶和華將西巴和撒慕拿交在我手之後，我就用野地的荊條和枳棘打傷你們。',
    '士8:8 基甸從那裡上到毘努伊勒，對那裡的人也是這樣說；毘努伊勒人也與疏割人回答他的話一樣。',
    '士8:9 他向毘努伊勒人說：我平平安安回來的時候，我必拆毀這樓。',
    '士8:10 那時西巴和撒慕拿，並跟隨他們的軍隊都在加各，約有一萬五千人，就是東方人全軍所剩下的；已經被殺約有十二萬拿刀的。',
    '士8:11 基甸就由挪巴和約比哈東邊，從住帳棚人的路上去，殺敗了米甸人的軍兵，因為他們坦然無懼。',
    '士8:12 西巴和撒慕拿逃跑；基甸追趕他們，捉住米甸的二王西巴和撒慕拿，驚散全軍。',
    '士8:13 約阿施的兒子基甸由希列斯坡從陣上回來，',
    '士8:14 捉住疏割的一個少年人，問他：疏割的首領長老是誰﹖他就將首領長老七十七個人的名字寫出來。',
    '士8:15 基甸到了疏割，對那裡的人說：你們從前譏誚我說：西巴和撒慕拿已經在你手裡，你使我們將餅給跟隨你的疲乏人嗎﹖現在西巴和撒慕拿在這裡。',
    '士8:16 於是捉住那城內的長老，用野地的荊條和枳棘責打（原文是指教）疏割人；',
    '士8:17 又拆了毘努伊勒的樓，殺了那城裡的人。',
    '士8:18 基甸問西巴和撒慕拿說：你們在他泊山所殺的人是什麼樣式﹖回答說：他們好像你，各人都有王子的樣式。',
    '士8:19 基甸說：他們是我同母的弟兄，我指著永生的耶和華起誓，你們從前若存留他們的性命，我如今就不殺你們了。',
    '士8:20 於是對他的長子益帖說：你起來殺他們。但益帖因為是童子，害怕，不敢拔刀。',
    '士8:21 西巴和撒慕拿說：你自己起來殺我們吧！因為人如何，力量也是如何。基甸就起來，殺了西巴和撒慕拿，奪獲他們駱駝項上戴的月牙圈。',
    '士8:22 以色列人對基甸說：你既救我們脫離米甸人的手，願你和你的兒孫管理我們。',
    '士8:23 基甸說：我不管理你們，我的兒子也不管理你們，惟有耶和華管理你們。',
    '士8:24 基甸又對他們說：我有一件事求你們：請你們各人將所奪的耳環給我。（原來仇敵是以實瑪利人，都是戴金耳環的。）',
    '士8:25 他們說：我們情願給你。就鋪開一件外衣，各人將所奪的耳環丟在其上。',
    '士8:26 基甸所要出來的金耳環重一千七百舍客勒金子。此外還有米甸王所戴的月環、耳墜，和所穿的紫色衣服，並駱駝項上的金鍊子。',
    '士8:27 基甸以此製造了一個以弗得，設立在本城俄弗拉。後來以色列人拜那以弗得行了邪淫；這就作了基甸和他全家的網羅。',
    '士8:28 這樣，米甸人被以色列人制伏了，不敢再擡頭。基甸還在的日子，國中太平四十年。',
    '士8:29 約阿施的兒子耶路巴力回去，住在自己家裡。',
    '士8:30 基甸有七十個親生的兒子，因為他有許多的妻。',
    '士8:31 他的妾住在示劍，也給他生了一個兒子。基甸與他起名叫亞比米勒。',
    '士8:32 約阿施的兒子基甸，年紀老邁而死，葬在亞比以謝族的俄弗拉，在他父親約阿施的墳墓裡。',
    '士8:33 基甸死後，以色列人又去隨從諸巴力行邪淫，以巴力比利土為他們的神。',
    '士8:34 以色列人不記念耶和華─他們的神，就是拯救他們脫離四圍仇敵之手的，',
    '士8:35 也不照著耶路巴力，就是基甸向他們所施的恩惠厚待他的家。',
    '士9:1 耶路巴力的兒子亞比米勒到了示劍見他的眾母舅，對他們和他外祖全家的人說：',
    '士9:2 請你們問示劍的眾人說，是耶路巴力的眾子七十人都管理你們好呢﹖還是一人管理你們好呢﹖你們又要記念我是你們的骨肉。',
    '士9:3 他的眾母舅便將這一切話為他說給示劍人聽，示劍人的心就歸向亞比米勒。他們說：他原是我們的弟兄；',
    '士9:4 就從巴力比利土的廟中取了七十舍客勒銀子給亞比米勒；亞比米勒用以雇了些匪徒跟隨他。',
    '士9:5 他往俄弗拉到他父親的家，將他弟兄、耶路巴力的眾子七十人都殺在一塊磐石上；只剩下耶路巴力的小兒子約坦，因為他躲藏了。',
    '士9:6 示劍人和米羅人都一同聚集，往示劍橡樹旁的柱子那裡，立亞比米勒為王。',
    '士9:7 有人將這事告訴約坦，他就去站在基利心山頂上，向眾人大聲喊叫說：示劍人哪，你們要聽我的話，神也就聽你們的話。',
    '士9:8 有一時樹木要膏一樹為王，管理他們，就去對橄欖樹說：請你作我們的王。',
    '士9:9 橄欖樹回答說：我豈肯止住供奉神和尊重人的油，飄颻在眾樹之上呢﹖',
    '士9:10 樹木對無花果樹說：請你來作我們的王。',
    '士9:11 無花果樹回答說：我豈肯止住所結甜美的果子，飄颻在眾樹之上呢﹖',
    '士9:12 樹木對葡萄樹說：請你來作我們的王。',
    '士9:13 葡萄樹回答說：我豈肯止住使神和人喜樂的新酒，飄颻在眾樹之上呢。',
    '士9:14 眾樹對荊棘說：請你來作我們的王。',
    '士9:15 荊棘回答說：你們若誠誠實實地膏我為王，就要投在我的蔭下；不然，願火從荊棘裡出來，燒滅利巴嫩的香柏樹。',
    '士9:16 現在你們立亞比米勒為王，若按誠實正直善待耶路巴力和他的全家，這就是酬他的勞。',
    '士9:17 從前我父冒死為你們爭戰，救了你們脫離米甸人的手。',
    '士9:18 你們如今起來攻擊我的父家，將他眾子七十人殺在一塊磐石上，又立他婢女所生的兒子亞比米勒為示劍人的王；他原是你們的弟兄。',
    '士9:19 你們如今若按誠實正直待耶路巴力和他的家，就可因亞比米勒得歡樂，他也可因你們得歡樂；',
    '士9:20 不然，願火從亞比米勒發出，燒滅示劍人和米羅眾人，又願火從示劍人和米羅人中出來，燒滅亞比米勒。',
    '士9:21 約坦因怕他弟兄亞比米勒，就逃跑，來到比珥，住在那裡。',
    '士9:22 亞比米勒管理以色列人三年。',
    '士9:23 神使惡魔降在亞比米勒和示劍人中間，示劍人就以詭詐待亞比米勒。',
    '士9:24 這是要叫耶路巴力七十個兒子所受的殘害歸與他們的哥哥亞比米勒，又叫那流他們血的罪歸與幫助他殺弟兄的示劍人。',
    '士9:25 示劍人在山頂上設埋伏，等候亞比米勒。凡從他們那裡經過的人，他們就搶奪。有人將這事告訴亞比米勒。',
    '士9:26 以別的兒子迦勒和他的弟兄來到示劍，示劍人都信靠他。',
    '士9:27 示劍人出城到田間去，摘下葡萄，踹酒，設擺筵宴，進他們神的廟中吃喝，咒詛亞比米勒。',
    '士9:28 以別的兒子迦勒說：亞比米勒是誰﹖示劍是誰﹖使我們服事他呢﹖他不是耶路巴力的兒子嗎﹖他的幫手不是西布勒嗎﹖你們可以服事示劍的父親哈抹的後裔。我們為何服事亞比米勒呢﹖',
    '士9:29 惟願這民歸我的手下，我就除掉亞比米勒。迦勒又對亞比米勒說：增添你的軍兵出來吧。',
    '士9:30 邑宰西布勒聽見以別的兒子迦勒的話，就發怒，',
    '士9:31 悄悄地打發人去見亞比米勒，說：以別的兒子迦勒和他的弟兄到了示劍，煽惑城中的民攻擊你。',
    '士9:32 現在你和跟隨你的人今夜起來，在田間埋伏。',
    '士9:33 到早晨太陽一出，你就起來闖城。迦勒和跟隨他的人出來攻擊你的時候，你便向他們見機而做。',
    '士9:34 於是，亞比米勒和跟隨他的眾人夜間起來，分作四隊，埋伏等候示劍人。',
    '士9:35 以別的兒子迦勒出去，站在城門口。亞比米勒和跟隨他的人從埋伏之處起來。',
    '士9:36 迦勒看見那些人，就對西布勒說：看哪，有人從山頂上下來了。西布勒說：你看見山的影子，以為是人。',
    '士9:37 迦勒又說：看哪，有人從高處下來，又有一隊從米惡尼尼橡樹的路上而來。',
    '士9:38 西布勒對他說：你曾說，亞比米勒是誰，叫我們服事他﹖你所誇的口在哪裡呢﹖這不是你所藐視的民嗎﹖你現在出去，與他們交戰吧！',
    '士9:39 於是迦勒率領示劍人出去，與亞比米勒交戰。',
    '士9:40 亞比米勒追趕迦勒；迦勒在他面前逃跑，有許多受傷仆倒的，直到城門。',
    '士9:41 亞比米勒住在亞魯瑪。西布勒趕出迦勒和他弟兄，不准他們住在示劍。',
    '士9:42 次日，民出到田間，有人告訴亞比米勒；',
    '士9:43 他就把他的人分作三隊，埋伏在田間，看見示劍人從城裡出來，就起來擊殺他們。',
    '士9:44 亞比米勒和跟隨他的一隊向前闖去，站在城門口；那兩隊直闖到田間，擊殺了眾人。',
    '士9:45 亞比米勒整天攻打城，將城奪取，殺了其中的居民，將城拆毀，撒上了鹽。',
    '士9:46 示劍樓的人聽見了，就躲入巴力比利土廟的衛所。',
    '士9:47 有人告訴亞比米勒說：示劍樓的人都聚在一處。',
    '士9:48 亞比米勒和跟隨他的人就都上撒們山。亞比米勒手拿斧子，砍下一根樹枝，扛在肩上，對跟隨他的人說：你們看我所行的，也當趕緊照樣行。',
    '士9:49 眾人就各砍一枝，跟隨亞比米勒，把樹枝堆在衛所的四圍，放火燒了衛所，以致示劍樓的人都死了，男女約有一千。',
    '士9:50 亞比米勒到提備斯，向提備斯安營，就攻取了那城。',
    '士9:51 城中有一座堅固的樓；城裡的眾人，無論男女，都逃進樓去，關上門，上了樓頂。',
    '士9:52 亞比米勒到了樓前攻打，挨近樓門，要用火焚燒。',
    '士9:53 有一個婦人把一塊上磨石拋在亞比米勒的頭上，打破了他的腦骨。',
    '士9:54 他就急忙喊叫拿他兵器的少年人，對他說：拔出你的刀來，殺了我吧！免得人議論我說，他為一個婦人所殺。於是少年人把他刺透，他就死了。',
    '士9:55 以色列人見亞比米勒死了，便各回自己的地方去了。',
    '士9:56 這樣，神報應亞比米勒向他父親所行的惡，就是殺了弟兄七十個人的惡。',
    '士9:57 示劍人的一切惡，神也都報應在他們頭上；耶路巴力的兒子約坦的咒詛歸到他們身上了。',
    '士10:1 亞比米勒以後，有以薩迦人朵多的孫子、普瓦的兒子陀拉興起，拯救以色列人。他住在以法蓮山地的沙密。',
    '士10:2 陀拉作以色列的士師二十三年，就死了，葬在沙密。',
    '士10:3 在他以後有基列人睚珥興起，作以色列的士師二十二年。',
    '士10:4 他有三十個兒子，騎著三十匹驢駒。他們有三十座城邑，叫做哈倭特睚珥，直到如今，都是在基列地。',
    '士10:5 睚珥死了，就葬在加們。',
    '士10:6 以色列人又行耶和華眼中看為惡的事，去事奉諸巴力和亞斯她錄，並亞蘭的神、西頓的神、摩押的神、亞捫人的神、非利士人的神，離棄耶和華，不事奉他。',
    '士10:7 耶和華的怒氣向以色列人發作，就把他們交在非利士人和亞捫人的手中。',
    '士10:8 從那年起，他們擾害欺壓約但河那邊、住亞摩利人之基列地的以色列人，共有十八年。',
    '士10:9 亞捫人又渡過約但河去攻打猶大和便雅憫，並以法蓮族。以色列人就甚覺窘迫。',
    '士10:10 以色列人哀求耶和華說：我們得罪了你；因為離棄了我們神，去事奉諸巴力。',
    '士10:11 耶和華對以色列人說：我豈沒有救過你們脫離埃及人、亞摩利人、亞捫人，和非利士人嗎﹖',
    '士10:12 西頓人、亞瑪力人、馬雲人也都欺壓你們；你們哀求我，我也拯救你們脫離他們的手。',
    '士10:13 你們竟離棄我，事奉別神！所以我不再救你們了。',
    '士10:14 你們去哀求所選擇的神；你們遭遇急難的時候，讓他救你們吧！',
    '士10:15 以色列人對耶和華說：我們犯罪了，任憑你隨意待我們吧！只求你今日拯救我們。',
    '士10:16 以色列人就除掉他們中間的外邦神，事奉耶和華。耶和華因以色列人受的苦難，就心中擔憂。',
    '士10:17 當時亞捫人聚集，安營在基列。以色列人也聚集，安營在米斯巴。',
    '士10:18 基列的民和眾首領彼此商議說：誰能先去攻打亞捫人，誰必作基列一切居民的領袖。',
    '士11:1 基列人耶弗他是個大能的勇士，是妓女的兒子。耶弗他是基列所生的。',
    '士11:2 基列的妻也生了幾個兒子：他妻所生的兒子長大了，就趕逐耶弗他，說：你不可在我們父家承受產業，因為你是妓女的兒子。',
    '士11:3 耶弗他就逃避他的弟兄，去住在陀伯地，有些匪徒到他那裡聚集，與他一同出入。',
    '士11:4 過了些日子，亞捫人攻打以色列。',
    '士11:5 亞捫人攻打以色列的時候，基列的長老到陀伯地去，要叫耶弗他回來；',
    '士11:6 對耶弗他說：請你來作我們的元帥，我們好與亞捫人爭戰。',
    '士11:7 耶弗他回答基列的長老說：從前你們不是恨我、趕逐我出離父家嗎﹖現在你們遭遇急難為何到我這裡來呢﹖',
    '士11:8 基列的長老回答耶弗他說：現在我們到你這裡來，是要你同我們去，與亞捫人爭戰；你可以作基列一切居民的領袖。',
    '士11:9 耶弗他對基列的長老說：你們叫我回去，與亞捫人爭戰，耶和華把他交給我，我可以作你們的領袖嗎﹖',
    '士11:10 基列的長老回答耶弗他說：有耶和華在你我中間作見證，我們必定照你的話行。',
    '士11:11 於是耶弗他同基列的長老回去，百姓就立耶弗他作領袖、作元帥。耶弗他在米斯巴將自己的一切話陳明在耶和華面前。',
    '士11:12 耶弗他打發使者去見亞捫人的王，說：你與我有什麼相干，竟來到我國中攻打我呢﹖',
    '士11:13 亞捫人的王回答耶弗他的使者說：因為以色列人從埃及上來的時候佔據我的地，從亞嫩河到雅博河，直到約但河。現在你要好好地將這地歸還吧！',
    '士11:14 耶弗他又打發使者去見亞捫人的王，',
    '士11:15 對他說：耶弗他如此說，以色列人並沒有佔據摩押地和亞捫人的地。',
    '士11:16 以色列人從埃及上來乃是經過曠野到紅海，來到加低斯，',
    '士11:17 就打發使者去見以東王，說：求你容我從你的地經過。以東王卻不應允。又照樣打發使者去見摩押王，他也不允准。以色列人就住在加低斯。',
    '士11:18 他們又經過曠野，繞著以東和摩押地，從摩押地的東邊過來，在亞嫩河邊安營，並沒有入摩押的境內，因為亞嫩河是摩押的邊界。',
    '士11:19 以色列人打發使者去見亞摩利王西宏，就是希實本的王，對他說：求你容我們從你的地經過，往我們自己的地方去。',
    '士11:20 西宏卻不信服以色列人，不容他們經過他的境界，乃招聚他的眾民在雅雜安營，與以色列人爭戰。',
    '士11:21 耶和華─以色列的神將西宏和他的眾民都交在以色列人手中，以色列人就擊殺他們，得了亞摩利人的全地：',
    '士11:22 從亞嫩河到雅博河，從曠野直到約但河。',
    '士11:23 耶和華─以色列的神在他百姓以色列面前趕出亞摩利人，你竟要得他們的地嗎﹖',
    '士11:24 你的神基抹所賜你的地你不是得為業嗎﹖耶和華─我們的神在我們面前所趕出的人，我們就得他的地。',
    '士11:25 難道你比摩押王西撥的兒子巴勒還強嗎﹖他曾與以色列人爭競，或是與他們爭戰嗎﹖',
    '士11:26 以色列人住希實本和屬希實本的鄉村，亞羅珥和屬亞羅珥的鄉村，並沿亞嫩河的一切城邑，已經有三百年了；在這三百年之內，你們為什麼沒有取回這些地方呢﹖',
    '士11:27 原來我沒有得罪你，你卻攻打我，惡待我。願審判人的耶和華今日在以色列人和亞捫人中間判斷是非。',
    '士11:28 但亞捫人的王不肯聽耶弗他打發人說的話。',
    '士11:29 耶和華的靈降在耶弗他身上，他就經過基列和瑪拿西，來到基列的米斯巴，又從米斯巴來到亞捫人那裡。',
    '士11:30 耶弗他就向耶和華許願，說：你若將亞捫人交在我手中，',
    '士11:31 我從亞捫人那裡平平安安回來的時候，無論什麼人，先從我家門出來迎接我，就必歸你，我也必將他獻上為燔祭。',
    '士11:32 於是耶弗他往亞捫人那裡去，與他們爭戰；耶和華將他們交在他手中，',
    '士11:33 他就大大殺敗他們，從亞羅珥到米匿，直到亞備勒基拉明，攻取了二十座城。這樣亞捫人就被以色列人制伏了。',
    '士11:34 耶弗他回米斯巴到了自己的家，不料，他女兒拿著鼓跳舞出來迎接他，是他獨生的，此外無兒無女。',
    '士11:35 耶弗他看見他，就撕裂衣服，說：哀哉！我的女兒啊，你使我甚是愁苦，叫我作難了；因為我已經向耶和華開口許願，不能挽回。',
    '士11:36 他女兒回答說：父啊，你既向耶和華開口，就當照你口中所說的向我行，因耶和華已經在仇敵亞捫人身上為你報仇；',
    '士11:37 又對父親說：有一件事求你允准：容我去兩個月，與同伴在山上，好哀哭我終為處女。',
    '士11:38 耶弗他說：你去吧！就容他去兩個月。他便和同伴去了，在山上為他終為處女哀哭。',
    '士11:39 兩月已滿，他回到父親那裡，父親就照所許的願向他行了。女兒終身沒有親近男子。',
    '士11:40 此後以色列中有個規矩，每年以色列的女子去為基列人耶弗他的女兒哀哭四天。',
    '士12:1 以法蓮人聚集，到了北方，對耶弗他說：你去與亞捫人爭戰，為什麼沒有招我們同去呢﹖我們必用火燒你和你的房屋。',
    '士12:2 耶弗他對他們說：我和我的民與亞捫人大大爭戰；我招你們來，你們竟沒有來救我脫離他們的手。',
    '士12:3 我見你們不來救我，我就拚命前去攻擊亞捫人，耶和華將他們交在我手中。你們今日為什麼上我這裡來攻打我呢﹖',
    '士12:4 於是耶弗他招聚基列人，與以法蓮人爭戰。基列人擊殺以法蓮人，是因他們說：你們基列人在以法蓮、瑪拿西中間，不過是以法蓮逃亡的人。',
    '士12:5 基列人把守約但河的渡口，不容以法蓮人過去。以法蓮逃走的人若說：容我過去。基列人就問他說：你是以法蓮人不是﹖他若說：不是，',
    '士12:6 就對他說：你說示播列。；以法蓮人因為咬不真字音，便說西播列。基列人就將他拿住，殺在約但河的渡口。那時以法蓮人被殺的有四萬二千人。',
    '士12:7 耶弗他作以色列的士師六年。基列人耶弗他死了，葬在基列的一座城裡。',
    '士12:8 耶弗他以後，有伯利恆人以比讚作以色列的士師。',
    '士12:9 他有三十個兒子，三十個女兒；女兒都嫁出去了。他給眾子從外鄉娶了三十個媳婦。他作以色列的士師七年。',
    '士12:10 以比讚死了，葬在伯利恆。',
    '士12:11 以比讚之後，有西布倫人以倫，作以色列的士師十年。',
    '士12:12 西布倫人以倫死了，葬在西布倫地的亞雅崙。',
    '士12:13 以倫之後，有比拉頓人希列的兒子押頓作以色列的士師。',
    '士12:14 他有四十個兒子，三十個孫子，騎著七十匹驢駒。押頓作以色列的士師八年。',
    '士12:15 比拉頓人希列的兒子押頓死了，葬在以法蓮地的比拉頓，在亞瑪力人的山地。',
    '士13:1 以色列人又行耶和華眼中看為惡的事，耶和華將他們交在非利士人手中四十年。',
    '士13:2 那時，有一個瑣拉人，是屬但族的，名叫瑪挪亞。他的妻不懷孕，不生育。',
    '士13:3 耶和華的使者向那婦人顯現，對他說：向來你不懷孕，不生育，如今你必懷孕生一個兒子。',
    '士13:4 所以你當謹慎，清酒濃酒都不可喝，一切不潔之物也不可吃。',
    '士13:5 你必懷孕生一個兒子，不可用剃頭刀剃他的頭，因為這孩子一出胎就歸神作拿細耳人。他必起首拯救以色列人脫離非利士人的手。',
    '士13:6 婦人就回去對丈夫說：有一個神人到我面前來，他的相貌如神使者的相貌，甚是可畏。我沒有問他從哪裡來，他也沒有將他的名告訴我，',
    '士13:7 卻對我說：你要懷孕生一個兒子，所以清酒濃酒都不可喝，一切不潔之物也不可吃；因為這孩子從出胎一直到死，必歸神作拿細耳人。',
    '士13:8 瑪挪亞就祈求耶和華說：主啊，求你再差遣那神人到我們這裡來，好指教我們怎樣待這將要生的孩子。',
    '士13:9 神應允瑪挪亞的話；婦人正坐在田間的時候，神的使者又到他那裡，他丈夫瑪挪亞卻沒有同他在一處。',
    '士13:10 婦人急忙跑去告訴丈夫說：那日到我面前來的人，又向我顯現。',
    '士13:11 瑪挪亞起來跟隨他的妻來到那人面前，對他說：與這婦人說話的就是你嗎﹖他說：是我。',
    '士13:12 瑪挪亞說：願你的話應驗！我們當怎樣待這孩子，他後來當怎樣呢﹖',
    '士13:13 耶和華的使者對瑪挪亞說：我告訴婦人的一切事，他都當謹慎。',
    '士13:14 葡萄樹所結的都不可吃，清酒濃酒都不可喝，一切不潔之物也不可吃。凡我所吩咐的，他都當遵守。',
    '士13:15 瑪挪亞對耶和華的使者說：求你容我們款留你，好為你預備一隻山羊羔。',
    '士13:16 耶和華的使者對瑪挪亞說：你雖然款留我，我卻不吃你的食物，你若預備燔祭就當獻與耶和華。原來瑪挪亞不知道他是耶和華的使者。',
    '士13:17 瑪挪亞對耶和華的使者說：請將你的名告訴我，到你話應驗的時候，我們好尊敬你。',
    '士13:18 耶和華的使者對他說：你何必問我的名，我名是奇妙的。',
    '士13:19 瑪挪亞將一隻山羊羔和素祭在磐石上獻與耶和華，使者行奇妙的事；瑪挪亞和他的妻觀看，',
    '士13:20 見火焰從壇上往上升，耶和華的使者在壇上的火焰中也升上去了。瑪挪亞和他的妻看見，就俯伏於地。',
    '士13:21 耶和華的使者不再向瑪挪亞和他的妻顯現，瑪挪亞才知道他是耶和華的使者。',
    '士13:22 瑪挪亞對他的妻說：我們必要死，因為看見了神。',
    '士13:23 他的妻卻對他說：耶和華若要殺我們，必不從我們手裡收納燔祭和素祭，並不將這一切事指示我們，今日也不將這些話告訴我們。',
    '士13:24 後來婦人生了一個兒子，給他起名叫參孫。孩子長大，耶和華賜福與他。',
    '士13:25 在瑪哈尼但，就是瑣拉和以實陶中間，耶和華的靈才感動他。',
    '士14:1 參孫下到亭拿，在那裡看見一個女子，是非利士人的女兒。',
    '士14:2 參孫上來稟告他父母說：我在亭拿看見一個女子，是非利士人的女兒，願你們給我娶來為妻。',
    '士14:3 他父母說：在你弟兄的女兒中，或在本國的民中，豈沒有一個女子，何至你去在未受割禮的非利士人中娶妻呢﹖參孫對他父親說：願你給我娶那女子，因我喜悅他。',
    '士14:4 他的父母卻不知道這事是出於耶和華，因為他找機會攻擊非利士人。那時，非利士人轄制以色列人。',
    '士14:5 參孫跟他父母下亭拿去，到了亭拿的葡萄園，見有一隻少壯獅子向他吼叫。',
    '士14:6 耶和華的靈大大感動參孫，他雖然手無器械，卻將獅子撕裂，如同撕裂山羊羔一樣。他行這事並沒有告訴父母。',
    '士14:7 參孫下去與女子說話，就喜悅他；',
    '士14:8 過了些日子，再下去要娶那女子，轉向道旁要看死獅，見有一群蜂子和蜜在死獅之內，',
    '士14:9 就用手取蜜，且吃且走；到了父母那裡，給他父母，他們也吃了；只是沒有告訴這蜜是從死獅之內取來的。',
    '士14:10 他父親下去見女子。參孫在那裡設擺筵宴，因為向來少年人都有這個規矩。',
    '士14:11 眾人看見參孫，就請了三十個人陪伴他。',
    '士14:12 參孫對他們說：我給你們出一個謎語，你們在七日筵宴之內，若能猜出意思告訴我，我就給你們三十件裡衣，三十套衣裳；',
    '士14:13 你們若不能猜出意思告訴我，你們就給我三十件裡衣，三十套衣裳。他們說：請將謎語說給我們聽。',
    '士14:14 參孫對他們說：吃的從吃者出來；甜的從強者出來。他們三日不能猜出謎語的意思。',
    '士14:15 到第七天，他們對參孫的妻說：你誆哄你丈夫，探出謎語的意思告訴我們，免得我們用火燒你和你父家。你們請了我們來，是要奪我們所有的嗎﹖',
    '士14:16 參孫的妻在丈夫面前啼哭說：你是恨我，不是愛我，你給我本國的人出謎語，卻沒有將意思告訴我。參孫回答說：連我父母我都沒有告訴，豈可告訴你呢﹖',
    '士14:17 七日筵宴之內，他在丈夫面前啼哭，到第七天逼著他，他才將謎語的意思告訴他妻，他妻就告訴本國的人。',
    '士14:18 到第七天，日頭未落以前，那城裡的人對參孫說：有什麼比蜜還甜呢﹖有什麼比獅子還強呢﹖參孫對他們說：你們若非用我的母牛犢耕地，就猜不出我謎語的意思來。',
    '士14:19 耶和華的靈大大感動參孫，他就下到亞實基倫，擊殺了三十個人，奪了他們的衣裳，將衣裳給了猜出謎語的人。參孫發怒，就上父家去了。',
    '士14:20 參孫的妻便歸了參孫的陪伴，就是作過他朋友的。',
    '士15:1 過了些日子，到割麥子的時候，參孫帶著一隻山羊羔去看他的妻，說：我要進內室見我的妻。他岳父不容他進去，',
    '士15:2 說：我估定你是極其恨他，因此我將他給了你的陪伴。他的妹子不是比他還美麗嗎﹖你可以娶來代替他吧！',
    '士15:3 參孫說：這回我加害於非利士人不算有罪。',
    '士15:4 於是參孫去捉了三百隻狐狸（或譯：野狗），將狐狸尾巴一對一對地捆上，將火把捆在兩條尾巴中間，',
    '士15:5 點著火把，就放狐狸進入非利士人站著的禾稼，將堆集的禾捆和未割的禾稼，並橄欖園盡都燒了。',
    '士15:6 非利士人說：這事是誰做的呢﹖有人說：是亭拿人的女婿參孫，因為他岳父將他的妻給了他的陪伴。於是非利士人上去，用火燒了婦人和他的父親。',
    '士15:7 參孫對非利士人說：你們既然這樣行，我必向你們報仇才肯罷休。',
    '士15:8 參孫就大大擊殺他們，連腿帶腰都砍斷了。他便下去，住在以坦磐的穴內。',
    '士15:9 非利士人上去安營在猶大，布散在利希。',
    '士15:10 猶大人說：你們為何上來攻擊我們呢﹖他們說：我們上來是要捆綁參孫；他向我們怎樣行，我們也要向他怎樣行。',
    '士15:11 於是有三千猶大人下到以坦磐的穴內，對參孫說：非利士人轄制我們，你不知道嗎﹖你向我們行的是什麼事呢﹖他回答說：他們向我怎樣行，我也要向他們怎樣行。',
    '士15:12 猶大人對他說：我們下來是要捆綁你，將你交在非利士人手中。參孫說：你們要向我起誓，應承你們自己不害死我。',
    '士15:13 他們說：我們斷不殺你，只要將你捆綁交在非利士人手中。於是用兩條新繩捆綁參孫，將他從以坦磐帶上去。',
    '士15:14 參孫到了利希，非利士人都迎著喧嚷。耶和華的靈大大感動參孫，他臂上的繩就像火燒的麻一樣，他的綁繩都從他手上脫落下來。',
    '士15:15 他見一塊未乾的驢腮骨，就伸手拾起來，用以擊殺一千人。',
    '士15:16 參孫說：我用驢腮骨殺人成堆，用驢腮骨殺了一千人。',
    '士15:17 說完這話，就把那腮骨從手裡拋出去了。那地便叫拉末‧利希。',
    '士15:18 參孫甚覺口渴，就求告耶和華說：你既藉僕人的手施行這麼大的拯救，豈可任我渴死、落在未受割禮的人手中呢﹖',
    '士15:19 神就使利希的窪處裂開，有水從其中湧出來。參孫喝了，精神復原；因此那泉名叫隱哈歌利，那泉直到今日還在利希。',
    '士15:20 當非利士人轄制以色列人的時候，參孫作以色列的士師二十年。',
    '士16:1 參孫到了迦薩，在那裡看見一個妓女，就與他親近。',
    '士16:2 有人告訴迦薩人說：參孫到這裡來了！他們就把他團團圍住，終夜在城門悄悄埋伏，說：等到天亮我們便殺他。',
    '士16:3 參孫睡到半夜，起來，將城門的門扇、門框、門閂，一齊拆下來，扛在肩上，扛到希伯崙前的山頂上。',
    '士16:4 後來，參孫在梭烈谷喜愛一個婦人，名叫大利拉。',
    '士16:5 非利士人的首領上去見那婦人，對他說：求你誆哄參孫，探探他因何有這麼大的力氣，我們用何法能勝他，捆綁剋制他。我們就每人給你一千一百舍客勒銀子。',
    '士16:6 大利拉對參孫說：求你告訴我，你因何有這麼大的力氣，當用何法捆綁剋制你。',
    '士16:7 參孫回答說：人若用七條未乾的青繩子捆綁我，我就軟弱像別人一樣。',
    '士16:8 於是非利士人的首領拿了七條未乾的青繩子來，交給婦人，他就用繩子捆綁參孫。',
    '士16:9 有人預先埋伏在婦人的內室裡。婦人說：參孫哪，非利士人拿你來了！參孫就掙斷繩子，如掙斷經火的麻線一般。這樣，他力氣的根由人還是不知道。',
    '士16:10 大利拉對參孫說：你欺哄我，向我說謊言。現在求你告訴我當用何法捆綁你。',
    '士16:11 參孫回答說：人若用沒有使過的新繩捆綁我，我就軟弱像別人一樣。',
    '士16:12 大利拉就用新繩捆綁他，對他說：參孫哪，非利士人拿你來了！有人預先埋伏在內室裡。參孫將臂上的繩掙斷了，如掙斷一條線一樣。',
    '士16:13 大利拉對參孫說：你到如今還是欺哄我，向我說謊言。求你告訴我，當用何法捆綁你。參孫回答說：你若將我頭上的七條髮綹，與緯線同織就可以了。',
    '士16:14 於是大利拉將他的髮綹與緯線同織，用橛子釘住，對他說：參孫哪，非利士人拿你來了！參孫從睡中醒來，將機上的橛子和緯線一齊都拔出來了。',
    '士16:15 大利拉對參孫說：你既不與我同心，怎麼說你愛我呢﹖你這三次欺哄我，沒有告訴我，你因何有這麼大的力氣。',
    '士16:16 大利拉天天用話催逼他，甚至他心裡煩悶要死。',
    '士16:17 參孫就把心中所藏的都告訴了他，對他說：向來人沒有用剃頭刀剃我的頭，因為我自出母胎就歸神作拿細耳人；若剃了我的頭髮，我的力氣就離開我，我便軟弱像別人一樣。',
    '士16:18 大利拉見他把心中所藏的都告訴了他，就打發人到非利士人的首領那裡，對他們說：他已經把心中所藏的都告訴了我，請你們再上來一次。於是非利士人的首領手裡拿著銀子，上到婦人那裡。',
    '士16:19 大利拉使參孫枕著他的膝睡覺，叫了一個人來剃除他頭上的七條髮綹。於是大利拉剋制他，他的力氣就離開他了。',
    '士16:20 大利拉說：參孫哪，非利士人拿你來了！參孫從睡中醒來，心裡說：我要像前幾次出去活動身體；他卻不知道耶和華已經離開他了。',
    '士16:21 非利士人將他拿住，剜了他的眼睛，帶他下到迦薩，用銅鍊拘索他；他就在監裡推磨。',
    '士16:22 然而他的頭髮被剃之後，又漸漸長起來了。',
    '士16:23 非利士人的首領聚集，要給他們的神大袞獻大祭，並且歡樂，因為他們說：我們的神將我們的仇敵參孫交在我們手中了。',
    '士16:24 眾人看見參孫，就讚美他們的神說：我們的神將毀壞我們地、殺害我們許多人的仇敵交在我們手中了。',
    '士16:25 他們正宴樂的時候，就說：叫參孫來，在我們面前戲耍戲耍。於是將參孫從監裡提出來，他就在眾人面前戲耍。他們使他站在兩柱中間。',
    '士16:26 參孫向拉他手的童子說：求你讓我摸著托房的柱子，我要靠一靠。',
    '士16:27 那時房內充滿男女，非利士人的眾首領也都在那裡。房的平頂上約有三千男女觀看參孫戲耍。',
    '士16:28 參孫求告耶和華說：主耶和華啊，求你眷念我。神啊，求你賜我這一次的力量，使我在非利士人身上報那剜我雙眼的仇。',
    '士16:29 參孫就抱住托房的那兩根柱子：左手抱一根，右手抱一根，',
    '士16:30 說：我情願與非利士人同死！就盡力屈身，房子倒塌，壓住首領和房內的眾人。這樣，參孫死時所殺的人比活著所殺的還多。',
    '士16:31 參孫的弟兄和他父的全家都下去取他的屍首，擡上來葬在瑣拉和以實陶中間，在他父瑪挪亞的墳墓裡。參孫作以色列的士師二十年。',
    '士17:1 以法蓮山地有一個人名叫米迦。',
    '士17:2 他對母親說：你那一千一百舍客勒銀子被人拿去，你因此咒詛，並且告訴了我。看哪，這銀子在我這裡，是我拿去了。他母親說：我兒啊，願耶和華賜福與你！',
    '士17:3 米迦就把這一千一百舍客勒銀子還他母親。他母親說：我分出這銀子來為你獻給耶和華，好雕刻一個像，鑄成一個像。現在我還是交給你。',
    '士17:4 米迦將銀子還他母親，他母親將二百舍客勒銀子交給銀匠，雕刻一個像，鑄成一個像，安置在米迦的屋內。',
    '士17:5 這米迦有了神堂，又製造以弗得和家中的神像，分派他一個兒子作祭司。',
    '士17:6 那時以色列中沒有王，各人任意而行。',
    '士17:7 猶大的伯利恆有一個少年人，是猶大族的利未人，他在那裡寄居。',
    '士17:8 這人離開猶大的伯利恆城，要找一個可住的地方。行路的時候，到了以法蓮山地，走到米迦的家。',
    '士17:9 米迦問他說：你從哪裡來﹖他回答說：從猶大的伯利恆來。我是利未人，要找一個可住的地方。',
    '士17:10 米迦說：你可以住在我這裡，我以你為父、為祭司。我每年給你十舍客勒銀子，一套衣服和度日的食物。利未人就進了他的家。',
    '士17:11 利未人情願與那人同住；那人看這少年人如自己的兒子一樣。',
    '士17:12 米迦分派這少年的利未人作祭司，他就住在米迦的家裡。',
    '士17:13 米迦說：現在我知道耶和華必賜福與我，因我有一個利未人作祭司。',
    '士18:1 那時，以色列中沒有王。但支派的人仍是尋地居住；因為到那日子，他們還沒有在以色列支派中得地為業。',
    '士18:2 但人從瑣拉和以實陶打發本族中的五個勇士，去仔細窺探那地，吩咐他們說：你們去窺探那地。他們來到以法蓮山地，進了米迦的住宅，就在那裡住宿。',
    '士18:3 他們臨近米迦的住宅，聽出那少年利未人的口音來，就進去問他說：誰領你到這裡來﹖你在這裡做什麼﹖你在這裡得什麼﹖',
    '士18:4 他回答說：米迦待我如此如此，請我作祭司。',
    '士18:5 他們對他說：請你求問神，使我們知道所行的道路通達不通達。',
    '士18:6 祭司對他們說：你們可以平平安安地去，你們所行的道路是在耶和華面前的。',
    '士18:7 五人就走了，來到拉億，見那裡的民安居無慮，如同西頓人安居一樣。在那地沒有人掌權擾亂他們；他們離西頓人也遠，與別人沒有來往。',
    '士18:8 五人回到瑣拉和以實陶，見他們的弟兄；弟兄問他們說：你們有什麼話﹖',
    '士18:9 他們回答說：起來，我們上去攻擊他們吧！我們已經窺探那地，見那地甚好。你們為何靜坐不動呢﹖要急速前往得那地為業，不可遲延。',
    '士18:10 你們到了那裡，必看見安居無慮的民，地也寬闊。神已將那地交在你們手中；那地百物俱全，一無所缺。',
    '士18:11 於是但族中的六百人，各帶兵器，從瑣拉和以實陶前往，',
    '士18:12 上到猶大的基列耶琳，在基列耶琳後邊安營。因此那地方名叫瑪哈尼但，直到今日。',
    '士18:13 他們從那裡往以法蓮山地去，來到米迦的住宅。',
    '士18:14 從前窺探拉億地的五個人對他們的弟兄說：這宅子裡有以弗得和家中的神像，並雕刻的像與鑄成的像，你們知道嗎﹖現在你們要想一想當怎樣行。',
    '士18:15 五人就進入米迦的住宅，到了那少年利未人的房內問他好。',
    '士18:16 那六百但人各帶兵器，站在門口。',
    '士18:17 窺探地的五個人走進去，將雕刻的像、以弗得、家中的神像，並鑄成的像，都拿了去。祭司和帶兵器的六百人，一同站在門口。',
    '士18:18 那五個人進入米迦的住宅，拿出雕刻的像、以弗得、家中的神像，並鑄成的像，祭司就問他們說：你們做什麼呢﹖',
    '士18:19 他們回答說：不要作聲，用手摀口，跟我們去吧！我們必以你為父、為祭司。你作一家的祭司好呢﹖還是作以色列一族一支派的祭司好呢﹖',
    '士18:20 祭司心裡喜悅，便拿著以弗得和家中的神像，並雕刻的像，進入他們中間。',
    '士18:21 他們就轉身離開那裡，妻子、兒女、牲畜、財物都在前頭。',
    '士18:22 離米迦的住宅已遠，米迦的近鄰都聚集來，追趕但人，',
    '士18:23 呼叫但人。但人回頭問米迦說：你聚集這許多人來做什麼呢﹖',
    '士18:24 米迦說：你們將我所做的神像和祭司都帶了去，我還有所剩的嗎﹖怎麼還問我說做什麼呢﹖',
    '士18:25 但人對米迦說：你不要使我們聽見你的聲音，恐怕有性暴的人攻擊你，以致你和你的全家盡都喪命。',
    '士18:26 但人還是走他們的路。米迦見他們的勢力比自己強盛，就轉身回家去了。',
    '士18:27 但人將米迦所做的神像和他的祭司都帶到拉億，見安居無慮的民，就用刀殺了那民，又放火燒了那城，',
    '士18:28 並無人搭救；因為離西頓遠，他們又與別人沒有來往。城在平原，那平原靠近伯利合。但人又在那裡修城居住，',
    '士18:29 照著他們始祖以色列之子但的名字，給那城起名叫但；原先那城名叫拉億。',
    '士18:30 但人就為自己設立那雕刻的像。摩西的孫子、革舜的兒子約拿單，和他的子孫作但支派的祭司，直到那地遭擄掠的日子。',
    '士18:31 神的殿在示羅多少日子，但人為自己設立米迦所雕刻的像也在但多少日子。',
    '士19:1 當以色列中沒有王的時候，有住以法蓮山地那邊的一個利未人，娶了一個猶大伯利恆的女子為妾。',
    '士19:2 妾行淫離開丈夫，回猶大的伯利恆，到了父家，在那裡住了四個月。',
    '士19:3 他丈夫起來，帶著一個僕人、兩匹驢去見他，用好話勸他回來。女子就引丈夫進入父家。他父見了那人，便歡歡喜喜地迎接。',
    '士19:4 那人的岳父，就是女子的父親，將那人留下住了三天。於是二人一同吃喝、住宿。',
    '士19:5 到第四天，利未人清早起來要走，女子的父親對女婿說：請你吃點飯，加添心力，然後可以行路。',
    '士19:6 於是二人坐下一同吃喝。女子的父親對那人說：請你再住一夜，暢快你的心。',
    '士19:7 那人起來要走，他岳父強留他，他又住了一宿。',
    '士19:8 到第五天，他清早起來要走，女子的父親說：請你吃點飯，加添心力，等到日頭偏西再走。於是二人一同吃飯。',
    '士19:9 那人同他的妾和僕人起來要走，他岳父，就是女子的父親，對他說：看哪，日頭偏西了，請你再住一夜；天快晚了，可以在這裡住宿，暢快你的心。明天早早起行回家去。',
    '士19:10 那人不願再住一夜，就備上那兩匹驢，帶著妾起身走了，來到耶布斯的對面（耶布斯就是耶路撒冷。）',
    '士19:11 臨近耶布斯的時候，日頭快要落了，僕人對主人說：我們不如進這耶布斯人的城裡住宿。',
    '士19:12 主人回答說：我們不可進不是以色列人住的外邦城，不如過到基比亞去；',
    '士19:13 又對僕人說：我們可以到一個地方，或住在基比亞，或住在拉瑪。',
    '士19:14 他們就往前走。將到便雅憫的基比亞，日頭已經落了；',
    '士19:15 他們進入基比亞要在那裡住宿，就坐在城裡的街上，因為無人接他們進家住宿。',
    '士19:16 晚上，有一個老年人從田間做工回來。他原是以法蓮山地的人，住在基比亞；那地方的人卻是便雅憫人。',
    '士19:17 老年人舉目看見客人坐在城裡的街上，就問他說：你從哪裡來﹖要往哪裡去﹖',
    '士19:18 他回答說：我們從猶大的伯利恆來，要往以法蓮山地那邊去。我原是那裡的人，到過猶大的伯利恆，現在我往耶和華的殿去，在這裡無人接我進他的家。',
    '士19:19 其實我有糧草可以餵驢，我與我的妾，並我的僕人，有餅有酒，並不缺少什麼。',
    '士19:20 老年人說：願你平安！你所需用的我都給你，只是不可在街上過夜。',
    '士19:21 於是領他們到家裡，餵上驢，他們就洗腳吃喝。',
    '士19:22 他們心裡正歡暢的時候，城中的匪徒圍住房子，連連叩門，對房主老人說：你把那進你家的人帶出來，我們要與他交合。',
    '士19:23 那房主出來對他們說：弟兄們哪，不要這樣作惡；這人既然進了我的家，你們就不要行這醜事。',
    '士19:24 我有個女兒，還是處女，並有這人的妾，我將他們領出來任憑你們玷辱他們，只是向這人不可行這樣的醜事。',
    '士19:25 那些人卻不聽從他的話。那人就把他的妾拉出去交給他們，他們便與他交合，終夜凌辱他，直到天色快亮才放他去。',
    '士19:26 天快亮的時候，婦人回到他主人住宿的房門前，就仆倒在地，直到天亮。',
    '士19:27 早晨，他的主人起來開了房門，出去要行路，不料那婦人仆倒在房門前，兩手搭在門檻上；',
    '士19:28 就對婦人說：起來，我們走吧！婦人卻不回答。那人便將他馱在驢上，起身回本處去了。',
    '士19:29 到了家裡，用刀將妾的屍身切成十二塊，使人拿著傳送以色列的四境。',
    '士19:30 凡看見的人都說：從以色列人出埃及地，直到今日，這樣的事沒有行過，也沒有見過。現在應當思想，大家商議當怎樣辦理。',
    '士20:1 於是以色列從但到別是巴，以及住基列地的眾人都出來，如同一人，聚集在米斯巴耶和華面前。',
    '士20:2 以色列民的首領，就是各支派的軍長，都站在神百姓的會中；拿刀的步兵共有四十萬。',
    '士20:3 以色列人上到米斯巴，便雅憫人都聽見了。以色列人說：請你將這件惡事的情由對我們說明。',
    '士20:4 那利未人，就是被害之婦人的丈夫，回答說：我和我的妾到了便雅憫的基比亞住宿。',
    '士20:5 基比亞人夜間起來，圍了我住的房子，想要殺我，又將我的妾強姦致死。',
    '士20:6 我就把我妾的屍身切成塊子，使人拿著傳送以色列得為業的全地，因為基比亞人在以色列中行了兇淫醜惡的事。',
    '士20:7 你們以色列人都當籌劃商議。',
    '士20:8 眾民都起來如同一人，說：我們連一人都不回自己帳棚、自己房屋去。',
    '士20:9 我們向基比亞人必這樣行，照所掣的籤去攻擊他們。',
    '士20:10 我們要在以色列各支派中，一百人挑取十人，一千人挑取百人，一萬人挑取千人，為民運糧，等大眾到了便雅憫的基比亞，就照基比亞人在以色列中所行的醜事征伐他們。',
    '士20:11 於是以色列眾人彼此連合如同一人，聚集攻擊那城。',
    '士20:12 以色列眾支派打發人去，問便雅憫支派的各家說：你們中間怎麼做了這樣的惡事呢﹖',
    '士20:13 現在你們要將基比亞的那些匪徒交出來，我們好治死他們，從以色列中除掉這惡。便雅憫人卻不肯聽從他們弟兄以色列人的話。',
    '士20:14 便雅憫人從他們的各城裡出來，聚集到了基比亞，要與以色列人打仗。',
    '士20:15 那時便雅憫人從各城裡點出拿刀的，共有二萬六千；另外還有基比亞人點出七百精兵。',
    '士20:16 在眾軍之中有揀選的七百精兵，都是左手便利的，能用機弦甩石打人，毫髮不差。',
    '士20:17 便雅憫人之外，點出以色列人拿刀的，共有四十萬，都是戰士。',
    '士20:18 以色列人就起來，到伯特利去求問神說：我們中間誰當首先上去與便雅憫人爭戰呢﹖耶和華說：猶大當先上去。',
    '士20:19 以色列人早晨起來，對著基比亞安營。',
    '士20:20 以色列人出來，要與便雅憫人打仗，就在基比亞前擺陣。',
    '士20:21 便雅憫人就從基比亞出來，當日殺死以色列人二萬二千。',
    '士20:22 以色列人彼此奮勇，仍在頭一日擺陣的地方又擺陣。',
    '士20:23 未擺陣之先，以色列人上去，在耶和華面前哭號，直到晚上，求問耶和華說：我們再去與我們弟兄便雅憫人打仗可以不可以﹖耶和華說：可以上去攻擊他們。',
    '士20:24 第二日，以色列人就上前攻擊便雅憫人。',
    '士20:25 便雅憫人也在這日從基比亞出來，與以色列人接戰，又殺死他們一萬八千，都是拿刀的。',
    '士20:26 以色列眾人就上到伯特利，坐在耶和華面前哭號，當日禁食直到晚上；又在耶和華面前獻燔祭和平安祭。',
    '士20:27 那時，神的約櫃在那裡；亞倫的孫子、以利亞撒的兒子非尼哈侍立在約櫃前。以色列人問耶和華說：我們當再出去與我們弟兄便雅憫人打仗呢﹖還是罷兵呢﹖耶和華說：你們當上去，因為明日我必將他們交在你們手中。',
    '士20:28 併於上節。',
    '士20:29 以色列人在基比亞的四圍設下伏兵。',
    '士20:30 第三日，以色列人又上去攻擊便雅憫人，在基比亞前擺陣，與前兩次一樣。',
    '士20:31 便雅憫人也出來迎敵，就被引誘離城；在田間兩條路上，一通伯特利，一通基比亞，像前兩次，動手殺死以色列人約有三十個。',
    '士20:32 便雅憫人說：他們仍舊敗在我們面前。但以色列人說：我們不如逃跑，引誘他們離開城到路上來。',
    '士20:33 以色列眾人都起來，在巴力他瑪擺陣，以色列的伏兵從馬利迦巴埋伏的地方衝上前去。',
    '士20:34 有以色列人中的一萬精兵，來到基比亞前接戰，勢派甚是凶猛；便雅憫人卻不知道災禍臨近了。',
    '士20:35 耶和華使以色列人殺敗便雅憫人。那日，以色列人殺死便雅憫人二萬五千一百，都是拿刀的。',
    '士20:36 於是便雅憫人知道自己敗了。先是以色列人；因為靠著在基比亞前所設的伏兵，就在便雅憫人面前詐敗。',
    '士20:37 伏兵急忙闖進基比亞，用刀殺死全城的人。',
    '士20:38 以色列人預先同伏兵約定在城內放火，以煙氣上騰為號。',
    '士20:39 以色列人臨退陣的時候，便雅憫人動手殺死以色列人，約有三十個，就說：他們仍像前次被我們殺敗了。',
    '士20:40 當煙氣如柱從城中上騰的時候，便雅憫人回頭觀看，見全城的煙氣沖天。',
    '士20:41 以色列人又轉身回來，便雅憫人就甚驚惶，因為看見災禍臨到自己了。',
    '士20:42 他們在以色列人面前轉身往曠野逃跑；以色列人在後面追殺。那從各城裡出來的，也都夾攻殺滅他們。',
    '士20:43 以色列人圍繞便雅憫人，追趕他們，在他們歇腳之處、對著日出之地的基比亞踐踏他們。',
    '士20:44 便雅憫人死了的有一萬八千，都是勇士。',
    '士20:45 其餘的人轉身向曠野逃跑，往臨門磐去。以色列人在道路上殺了他們五千人，如拾取遺穗一樣，追到基頓又殺了他們二千人。',
    '士20:46 那日便雅憫死了的共有二萬五千人，都是拿刀的勇士。',
    '士20:47 只剩下六百人，轉身向曠野逃跑，到了臨門磐，就在那裡住了四個月。',
    '士20:48 以色列人又轉到便雅憫地，將各城的人和牲畜，並一切所遇見的，都用刀殺盡，又放火燒了一切城邑。',
    '士21:1 以色列人在米斯巴曾起誓說：我們都不將女兒給便雅憫人為妻。',
    '士21:2 以色列人來到伯特利，坐在神面前直到晚上，放聲痛哭，',
    '士21:3 說：耶和華─以色列的神啊，為何以色列中有這樣缺了一支派的事呢﹖',
    '士21:4 次日清早，百姓起來，在那裡築了一座壇，獻燔祭和平安祭。',
    '士21:5 以色列人彼此問說：以色列各支派中，誰沒有同會眾上到耶和華面前來呢﹖先是以色列人起過大誓說，凡不上米斯巴到耶和華面前來的，必將他治死。',
    '士21:6 以色列人為他們的弟兄便雅憫後悔，說：如今以色列中絕了一個支派了。',
    '士21:7 我們既在耶和華面前起誓說，必不將我們的女兒給便雅憫人為妻，現在我們當怎樣辦理、使他們剩下的人有妻呢﹖',
    '士21:8 又彼此問說：以色列支派中誰沒有上米斯巴到耶和華面前來呢﹖他們就查出基列雅比沒有一人進營到會眾那裡；',
    '士21:9 因為百姓被數的時候，沒有一個基列雅比人在那裡。',
    '士21:10 會眾就打發一萬二千大勇士，吩咐他們說：你們去用刀將基列雅比人連婦女帶孩子都擊殺了。',
    '士21:11 所當行的就是這樣：要將一切男子和已嫁的女子盡行殺戮。',
    '士21:12 他們在基列雅比人中，遇見了四百個未嫁的處女，就帶到迦南地的示羅營裡。',
    '士21:13 全會眾打發人到臨門磐的便雅憫人那裡，向他們說和睦的話。',
    '士21:14 當時便雅憫人回來了，以色列人就把所存活基列雅比的女子給他們為妻，還是不夠。',
    '士21:15 百姓為便雅憫人後悔，因為耶和華使以色列人缺了一個支派（原文是使以色列中有了破口）。',
    '士21:16 會中的長老說：便雅憫中的女子既然除滅了，我們當怎樣辦理、使那餘剩的人有妻呢﹖',
    '士21:17 又說：便雅憫逃脫的人當有地業，免得以色列中塗抹了一個支派。',
    '士21:18 只是我們不能將自己的女兒給他們為妻；因為以色列人曾起誓說，有將女兒給便雅憫人為妻的，必受咒詛。',
    '士21:19 他們又說：在利波拿以南，伯特利以北，在示劍大路以東的示羅，年年有耶和華的節期；',
    '士21:20 就吩咐便雅憫人說：你們去，在葡萄園中埋伏。',
    '士21:21 若看見示羅的女子出來跳舞，就從葡萄園出來，在示羅的女子中各搶一個為妻，回便雅憫地去。',
    '士21:22 他們的父親或是弟兄若來與我們爭競，我們就說：求你們看我們的情面，施恩給這些人，因我們在爭戰的時候沒有給他們留下女子為妻。這也不是你們將女子給他們的；若是你們給的，就算有罪。',
    '士21:23 於是便雅憫人照樣而行，按著他們的數目從跳舞的女子中搶去為妻，就回自己的地業去，又重修城邑居住。',
    '士21:24 當時以色列人離開那裡，各歸本支派、本宗族、本地業去了。',
    '士21:25 那時，以色列中沒有王，各人任意而行。',
    '得1:1 當士師秉政的時候，國中遭遇饑荒。在猶大、伯利恆，有一個人帶著妻子和兩個兒子往摩押地去寄居。',
    '得1:2 這人名叫以利米勒，他的妻名叫拿俄米；他兩個兒子，一個名叫瑪倫，一個名叫基連，都是猶大伯利恆的以法他人。他們到了摩押地，就住在那裡。',
    '得1:3 後來拿俄米的丈夫以利米勒死了，剩下婦人和他兩個兒子。',
    '得1:4 這兩個兒子娶了摩押女子為妻，一個名叫俄珥巴，一個名叫路得，在那裡住了約有十年。',
    '得1:5 瑪倫和基連二人也死了，剩下拿俄米，沒有丈夫，也沒有兒子。',
    '得1:6 他就與兩個兒婦起身，要從摩押地歸回；因為他在摩押地聽見耶和華眷顧自己的百姓，賜糧食與他們。',
    '得1:7 於是他和兩個兒婦起行離開所住的地方，要回猶大地去。',
    '得1:8 拿俄米對兩個兒婦說：你們各人回娘家去吧。願耶和華恩待你們，像你們恩待已死的人與我一樣！',
    '得1:9 願耶和華使你們各在新夫家中得平安！於是拿俄米與他們親嘴。他們就放聲而哭，',
    '得1:10 說：不然，我們必與你一同回你本國去。',
    '得1:11 拿俄米說：我女兒們哪，回去吧！為何要跟我去呢﹖我還能生子作你們的丈夫嗎﹖',
    '得1:12 我女兒們哪，回去吧！我年紀老邁，不能再有丈夫；即或說，我還有指望，今夜有丈夫可以生子，',
    '得1:13 你們豈能等著他們長大呢﹖你們豈能等著他們不嫁別人呢﹖我女兒們哪，不要這樣。我為你們的緣故甚是愁苦，因為耶和華伸手攻擊我。',
    '得1:14 兩個兒婦又放聲而哭，俄珥巴與婆婆親嘴而別，只是路得捨不得拿俄米。',
    '得1:15 拿俄米說：看哪，你嫂子已經回他本國和他所拜的神那裡去了，你也跟著你嫂子回去吧！',
    '得1:16 路得說：不要催我回去不跟隨你。你往哪裡去，我也往那裡去；你在哪裡住宿，我也在那裡住宿；你的國就是我的國，你的神就是我的神。',
    '得1:17 你在哪裡死，我也在那裡死，也葬在那裡。除非死能使你我相離！不然，願耶和華重重地降罰與我。',
    '得1:18 拿俄米見路得定意要跟隨自己去，就不再勸他了。',
    '得1:19 於是二人同行，來到伯利恆。他們到了伯利恆，合城的人就都驚訝。婦女們說：這是拿俄米嗎﹖',
    '得1:20 拿俄米對他們說：不要叫我拿俄米（就是甜的意思），要叫我瑪拉（就是苦的意思），因為全能者使我受了大苦。',
    '得1:21 我滿滿地出去，耶和華使我空空地回來。耶和華降禍與我，全能者使我受苦。既是這樣，你們為何還叫我拿俄米呢﹖',
    '得1:22 拿俄米和他兒婦摩押女子路得，從摩押地回來到伯利恆，正是動手割大麥的時候。',
    '得2:1 拿俄米的丈夫以利米勒的親族中，有一個人名叫波阿斯，是個大財主。',
    '得2:2 摩押女子路得對拿俄米說：容我往田間去，我蒙誰的恩，就在誰的身後拾取麥穗。拿俄米說：女兒啊，你只管去。',
    '得2:3 路得就去了，來到田間，在收割的人身後拾取麥穗。他恰巧到了以利米勒本族的人波阿斯那塊田裡。',
    '得2:4 波阿斯正從伯利恆來，對收割的人說：願耶和華與你們同在！他們回答說：願耶和華賜福與你！',
    '得2:5 波阿斯問監管收割的僕人說：那是誰家的女子﹖',
    '得2:6 監管收割的僕人回答說：是那摩押女子，跟隨拿俄米從摩押地回來的。',
    '得2:7 他說：請你容我跟著收割的人拾取打捆剩下的麥穗。他從早晨直到如今，除了在屋子裡坐一會兒，常在這裡。',
    '得2:8 波阿斯對路得說：女兒啊，聽我說，不要往別人田裡拾取麥穗，也不要離開這裡，要常與我使女們在一處。',
    '得2:9 我的僕人在那塊田收割，你就跟著他們去。我已經吩咐僕人不可欺負你；你若渴了，就可以到器皿那裡喝僕人打來的水。',
    '得2:10 路得就俯伏在地叩拜，對他說：我既是外邦人，怎麼蒙你的恩，這樣顧恤我呢﹖',
    '得2:11 波阿斯回答說：自從你丈夫死後，凡你向婆婆所行的，並你離開父母和本地，到素不認識的民中，這些事人全都告訴我了。',
    '得2:12 願耶和華照你所行的賞賜你。你來投靠耶和華─以色列神的翅膀下，願你滿得他的賞賜。',
    '得2:13 路得說：我主啊，願在你眼前蒙恩。我雖然不及你的一個使女，你還用慈愛的話安慰我的心。',
    '得2:14 到了吃飯的時候，波阿斯對路得說：你到這裡來吃餅，將餅蘸在醋裡。路得就在收割的人旁邊坐下；他們把烘了的穗子遞給他。他吃飽了，還有餘剩的。',
    '得2:15 他起來又拾取麥穗，波阿斯吩咐僕人說：他就是在捆中拾取麥穗，也可以容他，不可羞辱他；',
    '得2:16 並要從捆裡抽出些來，留在地下任他拾取，不可叱嚇他。',
    '得2:17 這樣，路得在田間拾取麥穗，直到晚上，將所拾取的打了，約有一伊法大麥。',
    '得2:18 他就把所拾取的帶進城去給婆婆看，又把他吃飽了所剩的給了婆婆。',
    '得2:19 婆婆問他說：你今日在哪裡拾取麥穗，在哪裡做工呢﹖願那顧恤你的得福。路得就告訴婆婆說：我今日在一個名叫波阿斯的人那裡做工。',
    '得2:20 拿俄米對兒婦說：願那人蒙耶和華賜福，因為他不斷地恩待活人死人。拿俄米又說：那是我們本族的人，是一個至近的親屬。',
    '得2:21 摩押女子路得說：他對我說：你要緊隨我的僕人拾取麥穗，直等他們收完了我的莊稼。',
    '得2:22 拿俄米對兒婦路得說：女兒啊，你跟著他的使女出去，不叫人遇見你在別人田間，這才為好。',
    '得2:23 於是路得與波阿斯的使女常在一處拾取麥穗，直到收完了大麥和小麥。路得仍與婆婆同住。',
    '得3:1 路得的婆婆拿俄米對他說：女兒啊，我不當為你找個安身之處，使你享福嗎﹖',
    '得3:2 你與波阿斯的使女常在一處，波阿斯不是我們的親族嗎﹖他今夜在場上簸大麥；',
    '得3:3 你要沐浴抹膏，換上衣服，下到場上，卻不要使那人認出你來。你等他吃喝完了，',
    '得3:4 到他睡的時候，你看準他睡的地方，就進去掀開他腳上的被，躺臥在那裡，他必告訴你所當做的事。',
    '得3:5 路得說：凡你所吩咐的，我必遵行。',
    '得3:6 路得就下到場上，照他婆婆所吩咐他的而行。',
    '得3:7 波阿斯吃喝完了，心裡歡暢，就去睡在麥堆旁邊。路得便悄悄地來掀開他腳上的被，躺臥在那裡。',
    '得3:8 到了夜半，那人忽然驚醒，翻過身來，不料有女子躺在他的腳下。',
    '得3:9 他就說：你是誰﹖回答說：我是你的婢女路得。求你用你的衣襟遮蓋我，因為你是我一個至近的親屬。',
    '得3:10 波阿斯說：女兒啊，願你蒙耶和華賜福。你末後的恩比先前更大；因為少年人無論貧富，你都沒有跟從。',
    '得3:11 女兒啊，現在不要懼怕，凡你所說的，我必照著行；我本城的人都知道你是個賢德的女子。',
    '得3:12 我實在是你一個至近的親屬，只是還有一個人比我更近。',
    '得3:13 你今夜在這裡住宿，明早他若肯為你盡親屬的本分，就由他吧！倘若不肯，我指著永生的耶和華起誓，我必為你盡了本分，你只管躺到天亮。',
    '得3:14 路得便在他腳下躺到天快亮，人彼此不能辨認的時候就起來了。波阿斯說：不可使人知道有女子到場上來；',
    '得3:15 又對路得說：打開你所披的外衣。他打開了，波阿斯就撮了六簸箕大麥，幫他扛在肩上，他便進城去了。',
    '得3:16 路得回到婆婆那裡，婆婆說：女兒啊，怎麼樣了﹖路得就將那人向他所行的述說了一遍，',
    '得3:17 又說：那人給了我六簸箕大麥，對我說：你不可空手回去見你的婆婆。',
    '得3:18 婆婆說：女兒啊，你只管安坐等候，看這事怎樣成就，因為那人今日不辦成這事必不休息。',
    '得4:1 波阿斯到了城門，坐在那裡，恰巧波阿斯所說的那至近的親屬經過。波阿斯說：某人哪，你來坐在這裡。他就來坐下。',
    '得4:2 波阿斯又從本城的長老中揀選了十人，對他們說：請你們坐在這裡。他們就都坐下。',
    '得4:3 波阿斯對那至近的親屬說：從摩押地回來的拿俄米，現在要賣我們族兄以利米勒的那塊地；',
    '得4:4 我想當贖那塊地的是你，其次是我，以外再沒有別人了。你可以在這裡的人面前和我本國的長老面前說明，你若肯贖就贖，若不肯贖就告訴我。那人回答說：我肯贖。',
    '得4:5 波阿斯說：你從拿俄米手中買這地的時候，也當娶（原文是買；10節同）死人的妻摩押女子路得，使死人在產業上存留他的名。',
    '得4:6 那人說：這樣我就不能贖了，恐怕於我的產業有礙。你可以贖我所當贖的，我不能贖了。',
    '得4:7 從前，在以色列中要定奪什麼事，或贖回，或交易，這人就脫鞋給那人。以色列人都以此為證據。',
    '得4:8 那人對波阿斯說：你自己買吧！於是將鞋脫下來了。',
    '得4:9 波阿斯對長老和眾民說：你們今日作見證，凡屬以利米勒和基連、瑪倫的，我都從拿俄米手中置買了；',
    '得4:10 又娶了瑪倫的妻摩押女子路得為妻，好在死人的產業上存留他的名，免得他的名在本族本鄉滅沒。你們今日可以作見證。',
    '得4:11 在城門坐著的眾民和長老都說：我們作見證。願耶和華使進你家的這女子，像建立以色列家的拉結、利亞二人一樣。又願你在以法他得亨通，在伯利恆得名聲。',
    '得4:12 願耶和華從這少年女子賜你後裔，使你的家像他瑪從猶大所生法勒斯的家一般。',
    '得4:13 於是，波阿斯娶了路得為妻，與他同房。耶和華使他懷孕生了一個兒子。',
    '得4:14 婦人們對拿俄米說：耶和華是應當稱頌的！因為今日沒有撇下你，使你無至近的親屬。願這孩子在以色列中得名聲。',
    '得4:15 他必提起你的精神，奉養你的老，因為是愛慕你的那兒婦所生的。有這兒婦比有七個兒子還好！',
    '得4:16 拿俄米就把孩子抱在懷中，作他的養母。',
    '得4:17 鄰舍的婦人說：拿俄米得孩子了！就給孩子起名叫俄備得。這俄備得是耶西的父，耶西是大衛的父。',
    '得4:18 法勒斯的後代記在下面：法勒斯生希斯崙；',
    '得4:19 希斯崙生蘭；蘭生亞米拿達；',
    '得4:20 亞米拿達生拿順；拿順生撒門；',
    '得4:21 撒門生波阿斯；波阿斯生俄備得；',
    '得4:22 俄備得生耶西；耶西生大衛。',
    '撒上1:1 以法蓮山地的拉瑪瑣非有一個以法蓮人，名叫以利加拿，是蘇弗的玄孫，託戶的曾孫，以利戶的孫子，耶羅罕的兒子。',
    '撒上1:2 他有兩個妻：一名哈拿，一名毘尼拿。毘尼拿有兒女，哈拿沒有兒女。',
    '撒上1:3 這人每年從本城上到示羅，敬拜祭祀萬軍之耶和華；在那裡有以利的兩個兒子何弗尼、非尼哈當耶和華的祭司。',
    '撒上1:4 以利加拿每逢獻祭的日子，將祭肉分給他的妻毘尼拿和毘尼拿所生的兒女；',
    '撒上1:5 給哈拿的卻是雙分，因為他愛哈拿。無奈耶和華不使哈拿生育。',
    '撒上1:6 毘尼拿見耶和華不使哈拿生育，就作他的對頭，大大激動他，要使他生氣。',
    '撒上1:7 每年上到耶和華殿的時候，以利加拿都以雙分給哈拿；毘尼拿仍是激動他，以致他哭泣不吃飯。',
    '撒上1:8 他丈夫以利加拿對他說：哈拿啊，你為何哭泣，不吃飯，心裡愁悶呢﹖有我不比十個兒子還好嗎﹖',
    '撒上1:9 他們在示羅吃喝完了，哈拿就站起來。祭司以利在耶和華殿的門框旁邊，坐在自己的位上。',
    '撒上1:10 哈拿心裡愁苦，就痛痛哭泣，祈禱耶和華，',
    '撒上1:11 許願說：萬軍之耶和華啊，你若垂顧婢女的苦情，眷念不忘婢女，賜我一個兒子，我必使他終身歸與耶和華，不用剃頭刀剃他的頭。',
    '撒上1:12 哈拿在耶和華面前不住地祈禱，以利定睛看他的嘴。',
    '撒上1:13 （原來哈拿心中默禱，只動嘴唇，不出聲音，因此以利以為他喝醉了。）',
    '撒上1:14 以利對他說：你要醉到幾時呢﹖你不應該喝酒。',
    '撒上1:15 哈拿回答說：主啊，不是這樣。我是心裡愁苦的婦人，清酒濃酒都沒有喝，但在耶和華面前傾心吐意。',
    '撒上1:16 不要將婢女看作不正經的女子。我因被人激動，愁苦太多，所以祈求到如今。',
    '撒上1:17 以利說：你可以平平安安地回去。願以色列的神允准你向他所求的！',
    '撒上1:18 哈拿說：願婢女在你眼前蒙恩。於是婦人走去吃飯，面上再不帶愁容了。',
    '撒上1:19 次日清早，他們起來，在耶和華面前敬拜，就回拉瑪。到了家裡，以利加拿和妻哈拿同房，耶和華顧念哈拿，',
    '撒上1:20 哈拿就懷孕。日期滿足，生了一個兒子，給他起名叫撒母耳，說：這是我從耶和華那裡求來的。',
    '撒上1:21 以利加拿和他全家都上示羅去，要向耶和華獻年祭，並還所許的願。',
    '撒上1:22 哈拿卻沒有上去，對丈夫說：等孩子斷了奶，我便帶他上去朝見耶和華，使他永遠住在那裡。',
    '撒上1:23 他丈夫以利加拿說：就隨你的意行吧！可以等兒子斷了奶。但願耶和華應驗他的話。於是婦人在家裡乳養兒子，直到斷了奶；',
    '撒上1:24 既斷了奶，就把孩子帶上示羅，到了耶和華的殿；又帶了三隻公牛，一伊法細麵，一皮袋酒。（那時，孩子還小。）',
    '撒上1:25 宰了一隻公牛，就領孩子到以利面前。',
    '撒上1:26 婦人說：主啊，我敢在你面前起誓，從前在你這裡站著祈求耶和華的那婦人，就是我。',
    '撒上1:27 我祈求為要得這孩子；耶和華已將我所求的賜給我了。',
    '撒上1:28 所以，我將這孩子歸與耶和華，使他終身歸與耶和華。於是在那裡敬拜耶和華。',
    '撒上2:1 哈拿禱告說：我的心因耶和華快樂；我的角因耶和華高舉。我的口向仇敵張開；我因耶和華的救恩歡欣。',
    '撒上2:2 只有耶和華為聖；除他以外沒有可比的，也沒有磐石像我們的神。',
    '撒上2:3 人不要誇口說驕傲的話，也不要出狂妄的言語；因耶和華是大有智識的神，人的行為被他衡量。',
    '撒上2:4 勇士的弓都已折斷；跌倒的人以力量束腰。',
    '撒上2:5 素來飽足的，反作用人求食；飢餓的，再不飢餓。不生育的，生了七個兒子；多有兒女的，反倒衰微。',
    '撒上2:6 耶和華使人死，也使人活，使人下陰間，也使人往上升。',
    '撒上2:7 他使人貧窮，也使人富足，使人卑微，也使人高貴。',
    '撒上2:8 他從灰塵裡擡舉貧寒人，從糞堆中提拔窮乏人，使他們與王子同坐，得著榮耀的座位。地的柱子屬於耶和華；他將世界立在其上。',
    '撒上2:9 他必保護聖民的腳步，使惡人在黑暗中寂然不動；人都不能靠力量得勝。',
    '撒上2:10 與耶和華爭競的，必被打碎；耶和華必從天上以雷攻擊他，必審判地極的人，將力量賜與所立的王，高舉受膏者的角。',
    '撒上2:11 以利加拿往拉瑪回家去了。那孩子在祭司以利面前事奉耶和華。',
    '撒上2:12 以利的兩個兒子是惡人，不認識耶和華。',
    '撒上2:13 這二祭司待百姓是這樣的規矩：凡有人獻祭，正煮肉的時候，祭司的僕人就來，手拿三齒的叉子，',
    '撒上2:14 將叉子往罐裡，或鼎裡，或釜裡，或鍋裡一插，插上來的肉，祭司都取了去。凡上到示羅的以色列人，他們都是這樣看待。',
    '撒上2:15 又在未燒脂油以前，祭司的僕人就來對獻祭的人說：將肉給祭司，叫他烤吧。他不要煮過的，要生的。',
    '撒上2:16 獻祭的人若說：必須先燒脂油，然後你可以隨意取肉。僕人就說：你立時給我，不然我便搶去。',
    '撒上2:17 如此，這二少年人的罪在耶和華面前甚重了，因為他們藐視耶和華的祭物（或譯：他們使人厭棄給耶和華獻祭）。',
    '撒上2:18 那時，撒母耳還是孩子，穿著細麻布的以弗得，侍立在耶和華面前。',
    '撒上2:19 他母親每年為他做一件小外袍，同著丈夫上來獻年祭的時候帶來給他。',
    '撒上2:20 以利為以利加拿和他的妻祝福，說：願耶和華由這婦人再賜你後裔，代替你從耶和華求來的孩子。他們就回本鄉去了。',
    '撒上2:21 耶和華眷顧哈拿，他就懷孕生了三個兒子，兩個女兒。那孩子撒母耳在耶和華面前漸漸長大。',
    '撒上2:22 以利年甚老邁，聽見他兩個兒子待以色列眾人的事，又聽見他們與會幕門前伺候的婦人苟合，',
    '撒上2:23 他就對他們說：你們為何行這樣的事呢﹖我從這眾百姓聽見你們的惡行。',
    '撒上2:24 我兒啊，不可這樣！我聽見你們的風聲不好，你們使耶和華的百姓犯了罪。',
    '撒上2:25 人若得罪人，有士師審判他；人若得罪耶和華，誰能為他祈求呢﹖然而他們還是不聽父親的話，因為耶和華想要殺他們。',
    '撒上2:26 孩子撒母耳漸漸長大，耶和華與人越發喜愛他。',
    '撒上2:27 有神人來見以利，對他說：耶和華如此說：你祖父在埃及法老家作奴僕的時候，我不是向他們顯現嗎﹖',
    '撒上2:28 在以色列眾支派中，我不是揀選人作我的祭司，使他燒香，在我壇上獻祭，在我面前穿以弗得，又將以色列人所獻的火祭都賜給你父家嗎﹖',
    '撒上2:29 我所吩咐獻在我居所的祭物，你們為何踐踏﹖尊重你的兒子過於尊重我，將我民以色列所獻美好的祭物肥己呢﹖',
    '撒上2:30 因此，耶和華─以色列的神說：我曾說，你和你父家必永遠行在我面前；現在我卻說，決不容你們這樣行。因為尊重我的，我必重看他；藐視我的，他必被輕視。',
    '撒上2:31 日子必到，我要折斷你的膀臂和你父家的膀臂，使你家中沒有一個老年人。',
    '撒上2:32 在神使以色列人享福的時候，你必看見我居所的敗落。在你家中必永遠沒有一個老年人。',
    '撒上2:33 我必不從我壇前滅盡你家中的人；那未滅的必使你眼目乾癟、心中憂傷。你家中所生的人都必死在中年。',
    '撒上2:34 你的兩個兒子何弗尼、非尼哈所遭遇的事可作你的證據：他們二人必一日同死。',
    '撒上2:35 我要為自己立一個忠心的祭司；他必照我的心意而行。我要為他建立堅固的家；他必永遠行在我的受膏者面前。',
    '撒上2:36 你家所剩下的人都必來叩拜他，求塊銀子，求個餅，說：求你賜我祭司的職分，好叫我得點餅吃。',
    '撒上3:1 童子撒母耳在以利面前事奉耶和華。當那些日子，耶和華的言語稀少，不常有默示。',
    '撒上3:2 一日，以利睡臥在自己的地方；他眼目昏花，看不分明。',
    '撒上3:3 神的燈在神耶和華殿內約櫃那裡，還沒有熄滅，撒母耳已經睡了。',
    '撒上3:4 耶和華呼喚撒母耳。撒母耳說：我在這裡！',
    '撒上3:5 就跑到以利那裡，說：你呼喚我﹖我在這裡。以利回答說：我沒有呼喚你，你去睡吧。他就去睡了。',
    '撒上3:6 耶和華又呼喚撒母耳。撒母耳起來，到以利那裡，說：你呼喚我﹖我在這裡。以利回答說：我的兒，我沒有呼喚你，你去睡吧。',
    '撒上3:7 那時撒母耳還未認識耶和華，也未得耶和華的默示。',
    '撒上3:8 耶和華第三次呼喚撒母耳。撒母耳起來，到以利那裡，說：你又呼喚我﹖我在這裡。以利才明白是耶和華呼喚童子。',
    '撒上3:9 因此以利對撒母耳說：你仍去睡吧；若再呼喚你，你就說：耶和華啊，請說，僕人敬聽！撒母耳就去，仍睡在原處。',
    '撒上3:10 耶和華又來站著，像前三次呼喚說：撒母耳啊！撒母耳啊！撒母耳回答說：請說，僕人敬聽！',
    '撒上3:11 耶和華對撒母耳說：我在以色列中必行一件事，叫聽見的人都必耳鳴。',
    '撒上3:12 我指著以利家所說的話，到了時候，我必始終應驗在以利身上。',
    '撒上3:13 我曾告訴他必永遠降罰與他的家，因他知道兒子作孽，自招咒詛，卻不禁止他們。',
    '撒上3:14 所以我向以利家起誓說：以利家的罪孽，雖獻祭奉禮物，永不能得贖去。',
    '撒上3:15 撒母耳睡到天亮，就開了耶和華的殿門，不敢將默示告訴以利。',
    '撒上3:16 以利呼喚撒母耳說：我兒撒母耳啊！撒母耳回答說：我在這裡！',
    '撒上3:17 以利說：耶和華對你說什麼，你不要向我隱瞞；你若將神對你所說的隱瞞一句，願他重重地降罰與你。',
    '撒上3:18 撒母耳就把一切話都告訴了以利，並沒有隱瞞。以利說：這是出於耶和華，願他憑自己的意旨而行。',
    '撒上3:19 撒母耳長大了，耶和華與他同在，使他所說的話一句都不落空。',
    '撒上3:20 從但到別是巴所有的以色列人都知道耶和華立撒母耳為先知。',
    '撒上3:21 耶和華又在示羅顯現；因為耶和華將自己的話默示撒母耳，撒母耳就把這話傳遍以色列地。',
    '撒上4:1 以色列人出去與非利士人打仗，安營在以便以謝；非利士人安營在亞弗。',
    '撒上4:2 非利士人向以色列人擺陣。兩軍交戰的時候，以色列人敗在非利士人面前；非利士人在戰場上殺了他們的軍兵約有四千人。',
    '撒上4:3 百姓回到營裡，以色列的長老說：耶和華今日為何使我們敗在非利士人面前呢﹖我們不如將耶和華的約櫃從示羅擡到我們這裡來，好在我們中間救我們脫離敵人的手。',
    '撒上4:4 於是百姓打發人到示羅，從那裡將坐在二基路伯上萬軍之耶和華的約櫃擡來。以利的兩個兒子何弗尼、非尼哈與神的約櫃同來。',
    '撒上4:5 耶和華的約櫃到了營中，以色列眾人就大聲歡呼，地便震動。',
    '撒上4:6 非利士人聽見歡呼的聲音，就說：在希伯來人營裡大聲歡呼，是什麼緣故呢﹖隨後就知道耶和華的約櫃到了營中。',
    '撒上4:7 非利士人就懼怕起來，說：有神到了他們營中；又說：我們有禍了！向來不曾有這樣的事。',
    '撒上4:8 我們有禍了！誰能救我們脫離這些大能之神的手呢﹖從前在曠野用各樣災殃擊打埃及人的，就是這些神。',
    '撒上4:9 非利士人哪，你們要剛強，要作大丈夫，免得作希伯來人的奴僕，如同他們作你們的奴僕一樣。你們要作大丈夫，與他們爭戰。',
    '撒上4:10 非利士人和以色列人打仗，以色列人敗了，各向各家奔逃，被殺的人甚多，以色列的步兵仆倒了三萬。',
    '撒上4:11 神的約櫃被擄去，以利的兩個兒子何弗尼、非尼哈也都被殺了。',
    '撒上4:12 當日，有一個便雅憫人從陣上逃跑，衣服撕裂，頭蒙灰塵，來到示羅。',
    '撒上4:13 到了的時候，以利正在道旁坐在自己的位上觀望，為神的約櫃心裡擔憂。那人進城報信，合城的人就都呼喊起來。',
    '撒上4:14 以利聽見呼喊的聲音就問說：這喧嚷是什麼緣故呢﹖那人急忙來報信給以利。',
    '撒上4:15 那時以利九十八歲了，眼目發直，不能看見。',
    '撒上4:16 那人對以利說：我是從陣上來的，今日我從陣上逃回。以利說：我兒，事情怎樣﹖',
    '撒上4:17 報信的回答說：以色列人在非利士人面前逃跑，民中被殺的甚多！你的兩個兒子何弗尼、非尼哈也都死了，並且神的約櫃被擄去。',
    '撒上4:18 他一提神的約櫃，以利就從他的位上往後跌倒，在門旁折斷頸項而死；因為他年紀老邁，身體沉重。以利作以色列的士師四十年。',
    '撒上4:19 以利的兒婦、非尼哈的妻懷孕將到產期，他聽見神的約櫃被擄去，公公和丈夫都死了，就猛然疼痛，曲身生產；',
    '撒上4:20 將要死的時候，旁邊站著的婦人們對他說：不要怕！你生了男孩子了。他卻不回答，也不放在心上。',
    '撒上4:21 他給孩子起名叫以迦博，說：榮耀離開以色列了！這是因神的約櫃被擄去，又因他公公和丈夫都死了。',
    '撒上4:22 他又說：榮耀離開以色列，因為神的約櫃被擄去了。',
    '撒上5:1 非利士人將神的約櫃從以便以謝擡到亞實突。',
    '撒上5:2 非利士人將神的約櫃擡進大袞廟，放在大袞的旁邊。',
    '撒上5:3 次日清早，亞實突人起來，見大袞仆倒在耶和華的約櫃前，臉伏於地，就把大袞仍立在原處。',
    '撒上5:4 又次日清早起來，見大袞仆倒在耶和華的約櫃前，臉伏於地，並且大袞的頭和兩手都在門檻上折斷，只剩下大袞的殘體。',
    '撒上5:5 （因此，大袞的祭司和一切進亞實突、大袞廟的人都不踏大袞廟的門檻，直到今日。）',
    '撒上5:6 耶和華的手重重加在亞實突人身上，敗壞他們，使他們生痔瘡。亞實突和亞實突的四境都是如此。',
    '撒上5:7 亞實突人見這光景，就說：以色列神的約櫃不可留在我們這裡，因為他的手重重加在我們和我們神大袞的身上；',
    '撒上5:8 就打發人去請非利士的眾首領來聚集，問他們說：我們向以色列神的約櫃應當怎樣行呢﹖他們回答說：可以將以色列神的約櫃運到迦特去。於是將以色列神的約櫃運到那裡去。',
    '撒上5:9 運到之後，耶和華的手攻擊那城，使那城的人大大驚慌，無論大小都生痔瘡。',
    '撒上5:10 他們就把神的約櫃送到以革倫。神的約櫃到了，以革倫人就喊嚷起來說：他們將以色列神的約櫃運到我們這裡，要害我們和我們的眾民！',
    '撒上5:11 於是打發人去請非利士的眾首領來，說：願你們將以色列神的約櫃送回原處，免得害了我們和我們的眾民！原來神的手重重攻擊那城，城中的人有因驚慌而死的；',
    '撒上5:12 未曾死的人都生了痔瘡。合城呼號，聲音上達於天。',
    '撒上6:1 耶和華的約櫃在非利士人之地七個月。',
    '撒上6:2 非利士人將祭司和占卜的聚了來，問他們說：我們向耶和華的約櫃應當怎樣行﹖請指示我們用何法將約櫃送回原處。',
    '撒上6:3 他們說：若要將以色列神的約櫃送回去，不可空空地送去，必要給他獻賠罪的禮物，然後你們可得痊癒，並知道他的手為何不離開你們。',
    '撒上6:4 非利士人說：應當用什麼獻為賠罪的禮物呢﹖他們回答說：當照非利士首領的數目，用五個金痔瘡，五個金老鼠，因為在你們眾人和你們首領的身上都是一樣的災。',
    '撒上6:5 所以當製造你們痔瘡的像和毀壞你們田地老鼠的像，並要歸榮耀給以色列的神，或者他向你們和你們的神，並你們的田地，把手放輕些。',
    '撒上6:6 你們為何硬著心像埃及人和法老一樣呢﹖神在埃及人中間行奇事，埃及人豈不釋放以色列人，他們就去了嗎﹖',
    '撒上6:7 現在你們應當造一輛新車，將兩隻未曾負軛有乳的母牛套在車上，使牛犢回家去，離開母牛。',
    '撒上6:8 把耶和華的約櫃放在車上，將所獻賠罪的金物裝在匣子裡，放在櫃旁，將櫃送去。',
    '撒上6:9 你們要看看：車若直行以色列的境界到伯示麥去，這大災就是耶和華降在我們身上的；若不然，便可以知道不是他的手擊打我們，是我們偶然遇見的。',
    '撒上6:10 非利士人就這樣行：將兩隻有乳的母牛套在車上，將牛犢關在家裡，',
    '撒上6:11 把耶和華的約櫃和裝金老鼠並金痔瘡像的匣子都放在車上。',
    '撒上6:12 牛直行大道，往伯示麥去，一面走一面叫，不偏左右。非利士的首領跟在後面，直到伯示麥的境界。',
    '撒上6:13 伯示麥人正在平原收割麥子，舉目看見約櫃，就歡喜了。',
    '撒上6:14 車到了伯示麥人約書亞的田間，就站住了。在那裡有一塊大磐石，他們把車劈了，將兩隻母牛獻給耶和華為燔祭。',
    '撒上6:15 利未人將耶和華的約櫃和裝金物的匣子拿下來，放在大磐石上。當日伯示麥人將燔祭和平安祭獻給耶和華。',
    '撒上6:16 非利士人的五個首領看見，當日就回以革倫去了。',
    '撒上6:17 非利士人獻給耶和華作賠罪的金痔瘡像，就是這些：一個是為亞實突，一個是為迦薩，一個是為亞實基倫，一個是為迦特，一個是為以革倫。',
    '撒上6:18 金老鼠的數目是照非利士五個首領的城邑，就是堅固的城邑和鄉村，以及大磐石。這磐石是放耶和華約櫃的，到今日還在伯示麥人約書亞的田間。',
    '撒上6:19 耶和華因伯示麥人擅觀他的約櫃，就擊殺了他們七十人；那時有五萬人在那裡（原文是七十人加五萬人）。百姓因耶和華大大擊殺他們，就哀哭了。',
    '撒上6:20 伯示麥人說：誰能在耶和華這聖潔的神面前侍立呢﹖這約櫃可以從我們這裡送到誰那裡去呢﹖',
    '撒上6:21 於是打發人去見基列‧耶琳的居民，說：非利士人將耶和華的約櫃送回來了，你們下來將約櫃接到你們那裡去吧！',
    '撒上7:1 基列‧耶琳人就下來，將耶和華的約櫃接上去，放在山上亞比拿達的家中，分派他兒子以利亞撒看守耶和華的約櫃。',
    '撒上7:2 約櫃在基列‧耶琳許久。過了二十年，以色列全家都傾向耶和華。',
    '撒上7:3 撒母耳對以色列全家說：你們若一心歸順耶和華，就要把外邦的神和亞斯她錄從你們中間除掉，專心歸向耶和華，單單地事奉他。他必救你們脫離非利士人的手。',
    '撒上7:4 以色列人就除掉諸巴力和亞斯她錄，單單地事奉耶和華。',
    '撒上7:5 撒母耳說：要使以色列眾人聚集在米斯巴，我好為你們禱告耶和華。',
    '撒上7:6 他們就聚集在米斯巴，打水澆在耶和華面前，當日禁食，說：我們得罪了耶和華。於是撒母耳在米斯巴審判以色列人。',
    '撒上7:7 非利士人聽見以色列人聚集在米斯巴，非利士的首領就上來要攻擊以色列人。以色列人聽見，就懼怕非利士人。',
    '撒上7:8 以色列人對撒母耳說：願你不住地為我們呼求耶和華─我們的神，救我們脫離非利士人的手。',
    '撒上7:9 撒母耳就把一隻吃奶的羊羔獻與耶和華作全牲的燔祭，為以色列人呼求耶和華；耶和華就應允他。',
    '撒上7:10 撒母耳正獻燔祭的時候，非利士人前來要與以色列人爭戰。當日，耶和華大發雷聲，驚亂非利士人，他們就敗在以色列人面前。',
    '撒上7:11 以色列人從米斯巴出來，追趕非利士人，擊殺他們，直到伯甲的下邊。',
    '撒上7:12 撒母耳將一塊石頭立在米斯巴和善的中間，給石頭起名叫以便以謝，說：到如今耶和華都幫助我們。',
    '撒上7:13 從此，非利士人就被制伏，不敢再入以色列人的境內。撒母耳作士師的時候，耶和華的手攻擊非利士人。',
    '撒上7:14 非利士人所取以色列人的城邑，從以革倫直到迦特，都歸以色列人了。屬這些城的四境，以色列人也從非利士人手下收回。那時以色列人與亞摩利人和好。',
    '撒上7:15 撒母耳平生作以色列的士師。',
    '撒上7:16 他每年巡行到伯特利、吉甲、米斯巴，在這幾處審判以色列人。',
    '撒上7:17 隨後回到拉瑪，因為他的家在那裡；也在那裡審判以色列人，且為耶和華築了一座壇。',
    '撒上8:1 撒母耳年紀老邁，就立他兒子作以色列的士師。',
    '撒上8:2 長子名叫約珥，次子名叫亞比亞；他們在別是巴作士師。',
    '撒上8:3 他兒子不行他的道，貪圖財利，收受賄賂，屈枉正直。',
    '撒上8:4 以色列的長老都聚集，來到拉瑪見撒母耳，',
    '撒上8:5 對他說：你年紀老邁了，你兒子不行你的道。現在求你為我們立一個王治理我們，像列國一樣。',
    '撒上8:6 撒母耳不喜悅他們說立一個王治理我們，他就禱告耶和華。',
    '撒上8:7 耶和華對撒母耳說：百姓向你說的一切話，你只管依從；因為他們不是厭棄你，乃是厭棄我，不要我作他們的王。',
    '撒上8:8 自從我領他們出埃及到如今，他們常常離棄我，事奉別神。現在他們向你所行的，是照他們素來所行的。',
    '撒上8:9 故此你要依從他們的話，只是當警戒他們，告訴他們將來那王怎樣管轄他們。',
    '撒上8:10 撒母耳將耶和華的話都傳給求他立王的百姓，說：',
    '撒上8:11 管轄你們的王必這樣行：他必派你們的兒子為他趕車、跟馬，奔走在車前；',
    '撒上8:12 又派他們作千夫長、五十夫長，為他耕種田地，收割莊稼，打造軍器和車上的器械；',
    '撒上8:13 必取你們的女兒為他製造香膏，做飯烤餅；',
    '撒上8:14 也必取你們最好的田地、葡萄園、橄欖園賜給他的臣僕。',
    '撒上8:15 你們的糧食和葡萄園所出的，他必取十分之一給他的太監和臣僕；',
    '撒上8:16 又必取你們的僕人婢女，健壯的少年人和你們的驢，供他的差役。',
    '撒上8:17 你們的羊群，他必取十分之一，你們也必作他的僕人。',
    '撒上8:18 那時你們必因所選的王哀求耶和華，耶和華卻不應允你們。',
    '撒上8:19 百姓竟不肯聽撒母耳的話，說：不然！我們定要一個王治理我們，',
    '撒上8:20 使我們像列國一樣，有王治理我們，統領我們，為我們爭戰。',
    '撒上8:21 撒母耳聽見百姓這一切話，就將這話陳明在耶和華面前。',
    '撒上8:22 耶和華對撒母耳說：你只管依從他們的話，為他們立王。撒母耳對以色列人說：你們各歸各城去吧！',
    '撒上9:1 有一個便雅憫人，名叫基士，是便雅憫人亞斐亞的玄孫，比歌拉的曾孫，洗羅的孫子，亞別的兒子，是個大能的勇士（或譯：大財主）。',
    '撒上9:2 他有一個兒子，名叫掃羅，又健壯、又俊美，在以色列人中沒有一個能比他的；身體比眾民高過一頭。',
    '撒上9:3 掃羅的父親基士丟了幾頭驢，他就吩咐兒子掃羅說：你帶一個僕人去尋找驢。',
    '撒上9:4 掃羅就走過以法蓮山地，又過沙利沙地，都沒有找著；又過沙琳地，驢也不在那裡；又過便雅憫地，還沒有找著。',
    '撒上9:5 到了蘇弗地，掃羅對跟隨他的僕人說：我們不如回去，恐怕我父親不為驢掛心，反為我們擔憂。',
    '撒上9:6 僕人說：這城裡有一位神人，是眾人所尊重的，凡他所說的全都應驗。我們不如往他那裡去，或者他能將我們當走的路指示我們。',
    '撒上9:7 掃羅對僕人說：我們若去，有什麼可以送那人呢﹖我們囊中的食物都吃盡了，也沒有禮物可以送那神人，我們還有什麼沒有﹖',
    '撒上9:8 僕人回答掃羅說：我手裡有銀子一舍客勒的四分之一，可以送那神人，請他指示我們當走的路。',
    '撒上9:9 （從前以色列中，若有人去問神，就說：我們問先見去吧！現在稱為先知的，從前稱為先見。）',
    '撒上9:10 掃羅對僕人說：你說的是，我們可以去。於是他們往神人所住的城裡去了。',
    '撒上9:11 他們上坡要進城，就遇見幾個少年女子出來打水，問他們說：先見在這裡沒有﹖',
    '撒上9:12 女子回答說：在這裡，他在你們前面。快去吧！他今日正到城裡，因為今日百姓要在邱壇獻祭。',
    '撒上9:13 在他還沒有上邱壇吃祭物之先，你們一進城必遇見他；因他未到，百姓不能吃，必等他先祝祭，然後請的客才吃。現在你們上去，這時候必遇見他。',
    '撒上9:14 二人就上去；將進城的時候，撒母耳正迎著他們來，要上邱壇去。',
    '撒上9:15 掃羅未到的前一日，耶和華已經指示撒母耳說：',
    '撒上9:16 明日這時候，我必使一個人從便雅憫地到你這裡來，你要膏他作我民以色列的君。他必救我民脫離非利士人的手；因我民的哀聲上達於我，我就眷顧他們。',
    '撒上9:17 撒母耳看見掃羅的時候，耶和華對他說：看哪，這人就是我對你所說的，他必治理我的民。',
    '撒上9:18 掃羅在城門裡走到撒母耳跟前，說：請告訴我，先見的寓所在哪裡﹖',
    '撒上9:19 撒母耳回答說：我就是先見。你在我前面上邱壇去，因為你們今日必與我同席；明日早晨我送你去，將你心裡的事都告訴你。',
    '撒上9:20 至於你前三日所丟的那幾頭驢，你心裡不必掛念，已經找著了。以色列眾人所仰慕的是誰呢﹖不是仰慕你和你父的全家嗎﹖',
    '撒上9:21 掃羅說：我不是以色列支派中至小的便雅憫人嗎﹖我家不是便雅憫支派中至小的家嗎﹖你為何對我說這樣的話呢﹖',
    '撒上9:22 撒母耳領掃羅和他僕人進了客堂，使他們在請來的客中坐首位；客約有三十個人。',
    '撒上9:23 撒母耳對廚役說：我交給你收存的那一分祭肉現在可以拿來。',
    '撒上9:24 廚役就把收存的腿拿來，擺在掃羅面前，撒母耳說：這是所留下的，放在你面前。吃吧！因我請百姓的時候，特意為你存留這肉到此時。當日，掃羅就與撒母耳同席。',
    '撒上9:25 眾人從邱壇下來進城，撒母耳和掃羅在房頂上說話。',
    '撒上9:26 次日清早起來，黎明的時候，掃羅在房頂上。撒母耳呼叫他說：起來吧，我好送你回去。掃羅就起來，和撒母耳一同出去。',
    '撒上9:27 二人下到城角，撒母耳對掃羅說：要吩咐僕人先走（僕人就先走了）；你且站在這裡，等我將神的話傳與你聽。',
    '撒上10:1 撒母耳拿瓶膏油倒在掃羅的頭上，與他親嘴，說：這不是耶和華膏你作他產業的君嗎﹖',
    '撒上10:2 你今日與我離別之後，在便雅憫境內的泄撒，靠近拉結的墳墓，要遇見兩個人。他們必對你說：你去找的那幾頭驢已經找著了。現在你父親不為驢掛心，反為你擔憂，說：我為兒子怎麼才好呢﹖',
    '撒上10:3 你從那裡往前行，到了他泊的橡樹那裡，必遇見三個往伯特利去拜神的人：一個帶著三隻山羊羔，一個帶著三個餅，一個帶著一皮袋酒。',
    '撒上10:4 他們必問你安，給你兩個餅，你就從他們手中接過來。',
    '撒上10:5 此後你到神的山，在那裡有非利士人的防兵。你到了城的時候，必遇見一班先知從邱壇下來，前面有鼓瑟的、擊鼓的、吹笛的、彈琴的，他們都受感說話。',
    '撒上10:6 耶和華的靈必大大感動你，你就與他們一同受感說話；你要變為新人。',
    '撒上10:7 這兆頭臨到你，你就可以趁時而做，因為神與你同在。',
    '撒上10:8 你當在我以先下到吉甲，我也必下到那裡獻燔祭和平安祭。你要等候七日，等我到了那裡，指示你當行的事。',
    '撒上10:9 掃羅轉身離別撒母耳，神就賜他一個新心。當日這一切兆頭都應驗了。',
    '撒上10:10 掃羅到了那山，有一班先知遇見他，神的靈大大感動他，他就在先知中受感說話。',
    '撒上10:11 素來認識掃羅的，看見他和先知一同受感說話，就彼此說：基士的兒子遇見什麼了﹖掃羅也列在先知中嗎﹖',
    '撒上10:12 那地方有一個人說：這些人的父親是誰呢﹖此後有句俗語說：掃羅也列在先知中嗎﹖',
    '撒上10:13 掃羅受感說話已畢，就上邱壇去了。',
    '撒上10:14 掃羅的叔叔問掃羅和他僕人說：你們往哪裡去了﹖回答說：找驢去了。我們見沒有驢，就到了撒母耳那裡。',
    '撒上10:15 掃羅的叔叔說：請將撒母耳向你們所說的話告訴我。',
    '撒上10:16 掃羅對他叔叔說：他明明地告訴我們驢已經找著了。至於撒母耳所說的國事，掃羅卻沒有告訴叔叔。',
    '撒上10:17 撒母耳將百姓招聚到米斯巴耶和華那裡，',
    '撒上10:18 對他們說：耶和華─以色列的神如此說：我領你們以色列人出埃及，救你們脫離埃及人的手，又救你們脫離欺壓你們各國之人的手。',
    '撒上10:19 你們今日卻厭棄了救你們脫離一切災難的神，說：求你立一個王治理我們。現在你們應當按著支派、宗族都站在耶和華面前。',
    '撒上10:20 於是，撒母耳使以色列眾支派近前來掣籤，就掣出便雅憫支派來；',
    '撒上10:21 又使便雅憫支派按著宗族近前來，就掣出瑪特利族，從其中又掣出基士的兒子掃羅。眾人尋找他卻尋不著，',
    '撒上10:22 就問耶和華說：那人到這裡來了沒有﹖耶和華說：他藏在器具中了。',
    '撒上10:23 眾人就跑去從那裡領出他來。他站在百姓中間，身體比眾民高過一頭。',
    '撒上10:24 撒母耳對眾民說：你們看耶和華所揀選的人，眾民中有可比他的嗎﹖眾民就大聲歡呼說：願王萬歲！',
    '撒上10:25 撒母耳將國法對百姓說明，又記在書上，放在耶和華面前，然後遣散眾民，各回各家去了。',
    '撒上10:26 掃羅往基比亞回家去，有神感動的一群人跟隨他。',
    '撒上10:27 但有些匪徒說：這人怎能救我們呢﹖就藐視他，沒有送他禮物；掃羅卻不理會。',
    '撒上11:1 亞捫人的王拿轄上來，對著基列‧雅比安營。雅比眾人對拿轄說：你與我們立約，我們就服事你。',
    '撒上11:2 亞捫人拿轄說：你們若由我剜出你們各人的右眼，以此凌辱以色列眾人，我就與你們立約。',
    '撒上11:3 雅比的長老對他說：求你寬容我們七日，等我們打發人往以色列的全境去；若沒有人救我們，我們就出來歸順你。',
    '撒上11:4 使者到了掃羅住的基比亞，將這話說給百姓聽，百姓就都放聲而哭。',
    '撒上11:5 掃羅正從田間趕牛回來，問說：百姓為什麼哭呢﹖眾人將雅比人的話告訴他。',
    '撒上11:6 掃羅聽見這話，就被神的靈大大感動，甚是發怒。',
    '撒上11:7 他將一對牛切成塊子，託付使者傳送以色列的全境，說：凡不出來跟隨掃羅和撒母耳的，也必這樣切開他的牛。於是耶和華使百姓懼怕，他們就都出來，如同一人。',
    '撒上11:8 掃羅在比色數點他們：以色列人有三十萬，猶大人有三萬。',
    '撒上11:9 眾人對那使者說：你們要回覆基列‧雅比人說，明日太陽近午的時候，你們必得解救。使者回去告訴雅比人，他們就歡喜了。',
    '撒上11:10 於是雅比人對亞捫人說：明日我們出來歸順你們，你們可以隨意待我們。',
    '撒上11:11 第二日，掃羅將百姓分為三隊，在晨更的時候入了亞捫人的營，擊殺他們直到太陽近午，剩下的人都逃散，沒有二人同在一處的。',
    '撒上11:12 百姓對撒母耳說：那說掃羅豈能管理我們的是誰呢﹖可以將他交出來，我們好殺死他。',
    '撒上11:13 掃羅說：今日耶和華在以色列中施行拯救，所以不可殺人。',
    '撒上11:14 撒母耳對百姓說：我們要往吉甲去，在那裡立國。',
    '撒上11:15 眾百姓就到了吉甲那裡，在耶和華面前立掃羅為王，又在耶和華面前獻平安祭。掃羅和以色列眾人大大歡喜。',
    '撒上12:1 撒母耳對以色列眾人說：你們向我所求的，我已應允了，為你們立了一個王；',
    '撒上12:2 現在有這王在你們前面行。我已年老髮白，我的兒子都在你們這裡。我從幼年直到今日都在你們前面行。',
    '撒上12:3 我在這裡，你們要在耶和華和他的受膏者面前給我作見證。我奪過誰的牛，搶過誰的驢，欺負過誰，虐待過誰，從誰手裡受過賄賂因而眼瞎呢﹖若有，我必償還。',
    '撒上12:4 眾人說：你未曾欺負我們，虐待我們，也未曾從誰手裡受過什麼。',
    '撒上12:5 撒母耳對他們說：你們在我手裡沒有找著什麼，有耶和華和他的受膏者今日為證。他們說：願他為證。',
    '撒上12:6 撒母耳對百姓說：從前立摩西、亞倫，又領你們列祖出埃及地的是耶和華。',
    '撒上12:7 現在你們要站住，等我在耶和華面前對你們講論耶和華向你們和你們列祖所行一切公義的事。',
    '撒上12:8 從前雅各到了埃及，後來你們列祖呼求耶和華，耶和華就差遣摩西、亞倫領你們列祖出埃及，使他們在這地方居住。',
    '撒上12:9 他們卻忘記耶和華─他們的神，他就把他們付與夏瑣將軍西西拉的手裡，和非利士人並摩押王的手裡。於是這些人常來攻擊他們。',
    '撒上12:10 他們就呼求耶和華說：我們離棄耶和華，事奉巴力和亞斯她錄，是有罪了。現在求你救我們脫離仇敵的手，我們必事奉你。',
    '撒上12:11 耶和華就差遣耶路巴力、比但、耶弗他、撒母耳救你們脫離四圍仇敵的手，你們才安然居住。',
    '撒上12:12 你們見亞捫人的王拿轄來攻擊你們，就對我說：我們定要一個王治理我們。其實耶和華─你們的神是你們的王。',
    '撒上12:13 現在，你們所求所選的王在這裡。看哪，耶和華已經為你們立王了。',
    '撒上12:14 你們若敬畏耶和華，事奉他，聽從他的話，不違背他的命令，你們和治理你們的王也都順從耶和華─你們的神就好了。',
    '撒上12:15 倘若不聽從耶和華的話，違背他的命令，耶和華的手必攻擊你們，像從前攻擊你們列祖一樣。',
    '撒上12:16 現在你們要站住，看耶和華在你們眼前要行一件大事。',
    '撒上12:17 這不是割麥子的時候嗎﹖我求告耶和華，他必打雷降雨，使你們又知道又看出，你們求立王的事是在耶和華面前犯大罪了。',
    '撒上12:18 於是撒母耳求告耶和華，耶和華就在這日打雷降雨，眾民便甚懼怕耶和華和撒母耳。',
    '撒上12:19 眾民對撒母耳說：求你為僕人們禱告耶和華─你的神，免得我們死亡，因為我們求立王的事正是罪上加罪了。',
    '撒上12:20 撒母耳對百姓說：不要懼怕！你們雖然行了這惡，卻不要偏離耶和華，只要盡心事奉他。',
    '撒上12:21 若偏離耶和華去順從那不能救人的虛神是無益的。',
    '撒上12:22 耶和華既喜悅選你們作他的子民，就必因他的大名不撇棄你們。',
    '撒上12:23 至於我，斷不停止為你們禱告，以致得罪耶和華。我必以善道正路指教你們。',
    '撒上12:24 只要你們敬畏耶和華，誠誠實實地盡心事奉他，想念他向你們所行的事何等大。',
    '撒上12:25 你們若仍然作惡，你們和你們的王必一同滅亡。',
    '撒上13:1 掃羅登基年四十歲；作以色列王二年的時候，',
    '撒上13:2 就從以色列中揀選了三千人：二千跟隨掃羅在密抹和伯特利山，一千跟隨約拿單在便雅憫的基比亞；其餘的人掃羅都打發各回各家去了。',
    '撒上13:3 約拿單攻擊迦巴、非利士人的防營，非利士人聽見了。掃羅就在遍地吹角，意思說，要使希伯來人聽見。',
    '撒上13:4 以色列眾人聽見掃羅攻擊非利士人的防營，又聽見以色列人為非利士人所憎惡，就跟隨掃羅聚集在吉甲。',
    '撒上13:5 非利士人聚集，要與以色列人爭戰，有車三萬輛，馬兵六千，步兵像海邊的沙那樣多，就上來在伯亞文東邊的密抹安營。',
    '撒上13:6 以色列百姓見自己危急窘迫，就藏在山洞、叢林、石穴、隱密處，和坑中。',
    '撒上13:7 有些希伯來人過了約但河，逃到迦得和基列地。掃羅還是在吉甲，百姓都戰戰兢兢地跟隨他。',
    '撒上13:8 掃羅照著撒母耳所定的日期等了七日。撒母耳還沒有來到吉甲，百姓也離開掃羅散去了。',
    '撒上13:9 掃羅說：把燔祭和平安祭帶到我這裡來。掃羅就獻上燔祭。',
    '撒上13:10 剛獻完燔祭，撒母耳就到了。掃羅出去迎接他，要問他好。',
    '撒上13:11 撒母耳說：你做的是什麼事呢﹖掃羅說：因為我見百姓離開我散去，你也不照所定的日期來到，而且非利士人聚集在密抹。',
    '撒上13:12 所以我心裡說：恐怕我沒有禱告耶和華。非利士人下到吉甲攻擊我，我就勉強獻上燔祭。',
    '撒上13:13 撒母耳對掃羅說：你做了糊塗事了，沒有遵守耶和華─你神所吩咐你的命令。若遵守，耶和華必在以色列中堅立你的王位，直到永遠。',
    '撒上13:14 現在你的王位必不長久。耶和華已經尋著一個合他心意的人，立他作百姓的君，因為你沒有遵守耶和華所吩咐你的。',
    '撒上13:15 撒母耳就起來，從吉甲上到便雅憫的基比亞。掃羅數點跟隨他的，約有六百人。',
    '撒上13:16 掃羅和他兒子約拿單，並跟隨他們的人，都住在便雅憫的迦巴；但非利士人安營在密抹。',
    '撒上13:17 有掠兵從非利士營中出來，分為三隊：一隊往俄弗拉向書亞地去，',
    '撒上13:18 一隊往伯和崙去，一隊往洗波音谷對面的地境向曠野去。',
    '撒上13:19 那時，以色列全地沒有一個鐵匠；因為非利士人說，恐怕希伯來人製造刀槍。',
    '撒上13:20 以色列人要磨鋤、犁、斧、鏟，就下到非利士人那裡去磨。',
    '撒上13:21 但有銼可以銼鏟、犁、三齒叉、斧子，並趕牛錐。',
    '撒上13:22 所以到了爭戰的日子，跟隨掃羅和約拿單的人沒有一個手裡有刀有槍的，惟獨掃羅和他兒子約拿單有。',
    '撒上13:23 非利士人的一隊防兵到了密抹的隘口。',
    '撒上14:1 有一日，掃羅的兒子約拿單對拿他兵器的少年人說：我們不如過到那邊，到非利士人的防營那裡去。但他沒有告訴父親。',
    '撒上14:2 掃羅在基比亞的儘邊，坐在米磯崙的石榴樹下，跟隨他的約有六百人。',
    '撒上14:3 在那裡有亞希突的兒子亞希亞，穿著以弗得。（亞希突是以迦博的哥哥，非尼哈的兒子，以利的孫子。以利從前在示羅作耶和華的祭司。）約拿單去了，百姓卻不知道。',
    '撒上14:4 約拿單要從隘口過到非利士防營那裡去。這隘口兩邊各有一個山峰：一名播薛，一名西尼；',
    '撒上14:5 一峰向北，與密抹相對，一峰向南，與迦巴相對。',
    '撒上14:6 約拿單對拿兵器的少年人說：我們不如過到未受割禮人的防營那裡去，或者耶和華為我們施展能力；因為耶和華使人得勝，不在乎人多人少。',
    '撒上14:7 拿兵器的對他說：隨你的心意行吧。你可以上去，我必跟隨你，與你同心。',
    '撒上14:8 約拿單說：我們要過到那些人那裡去，使他們看見我們。',
    '撒上14:9 他們若對我們說：你們站住，等我們到你們那裡去，我們就站住，不上他們那裡去。',
    '撒上14:10 他們若說：你們上到我們這裡來，這話就是我們的證據；我們便上去，因為耶和華將他們交在我們手裡了。',
    '撒上14:11 二人就使非利士的防兵看見。非利士人說：希伯來人從所藏的洞穴裡出來了！',
    '撒上14:12 防兵對約拿單和拿兵器的人說：你們上到這裡來，我們有一件事指示你們。約拿單就對拿兵器的人說：你跟隨我上去，因為耶和華將他們交在以色列人手裡了。',
    '撒上14:13 約拿單就爬上去，拿兵器的人跟隨他。約拿單殺倒非利士人，拿兵器的人也隨著殺他們。',
    '撒上14:14 約拿單和拿兵器的人起頭所殺的約有二十人，都在一畝地的半犁溝之內。',
    '撒上14:15 於是在營中、在田野、在眾民內都有戰兢，防兵和掠兵也都戰兢，地也震動，戰兢之勢甚大。',
    '撒上14:16 在便雅憫的基比亞，掃羅的守望兵看見非利士的軍眾潰散，四圍亂竄。',
    '撒上14:17 掃羅就對跟隨他的民說：你們查點查點，看從我們這裡出去的是誰﹖他們一查點，就知道約拿單和拿兵器的人沒有在這裡。',
    '撒上14:18 那時神的約櫃在以色列人那裡。掃羅對亞希亞說：你將神的約櫃運了來。',
    '撒上14:19 掃羅正與祭司說話的時候，非利士營中的喧嚷越發大了；掃羅就對祭司說：停手吧！',
    '撒上14:20 掃羅和跟隨他的人都聚集，來到戰場，看見非利士人用刀互相擊殺，大大惶亂。',
    '撒上14:21 從前由四方來跟隨非利士軍的希伯來人現在也轉過來，幫助跟隨掃羅和約拿單的以色列人了。',
    '撒上14:22 那藏在以法蓮山地的以色列人聽說非利士人逃跑，就出來緊緊地追殺他們。',
    '撒上14:23 那日，耶和華使以色列人得勝，一直戰到伯亞文。',
    '撒上14:24 掃羅叫百姓起誓說，凡不等到晚上向敵人報完了仇吃什麼的，必受咒詛。因此這日百姓沒有吃什麼，就極其困憊。',
    '撒上14:25 眾民進入樹林，見有蜜在地上。',
    '撒上14:26 他們進了樹林，見有蜜流下來，卻沒有人敢用手取蜜入口，因為他們怕那誓言。',
    '撒上14:27 約拿單沒有聽見他父親叫百姓起誓，所以伸手中的杖，用杖頭蘸在蜂房裡，轉手送入口內，眼睛就明亮了。',
    '撒上14:28 百姓中有一人對他說：你父親曾叫百姓嚴嚴地起誓說，今日吃什麼的，必受咒詛；因此百姓就疲乏了。',
    '撒上14:29 約拿單說：我父親連累你們了。你看，我嘗了這一點蜜，眼睛就明亮了。',
    '撒上14:30 今日百姓若任意吃了從仇敵所奪的物，擊殺的非利士人豈不更多嗎﹖',
    '撒上14:31 這日，以色列人擊殺非利士人，從密抹直到亞雅崙。百姓甚是疲乏，',
    '撒上14:32 就急忙將所奪的牛羊和牛犢宰於地上，肉還帶血就吃了。',
    '撒上14:33 有人告訴掃羅說：百姓吃帶血的肉，得罪耶和華了。掃羅說：你們有罪了，今日要將大石頭滾到我這裡來。',
    '撒上14:34 掃羅又說：你們散在百姓中，對他們說，你們各人將牛羊牽到我這裡來宰了吃，不可吃帶血的肉得罪耶和華。這夜，百姓就把牛羊牽到那裡宰了。',
    '撒上14:35 掃羅為耶和華築了一座壇，這是他初次為耶和華築的壇。',
    '撒上14:36 掃羅說：我們不如夜裡下去追趕非利士人，搶掠他們，直到天亮，不留他們一人。眾民說：你看怎樣好就去行吧！祭司說：我們先當親近神。',
    '撒上14:37 掃羅求問神說：我下去追趕非利士人可以不可以﹖你將他們交在以色列人手裡不交﹖這日神沒有回答他。',
    '撒上14:38 掃羅說：你們百姓中的長老都上這裡來，查明今日是誰犯了罪。',
    '撒上14:39 我指著救以色列─永生的耶和華起誓，就是我兒子約拿單犯了罪，他也必死。但百姓中無一人回答他。',
    '撒上14:40 掃羅就對以色列眾人說：你們站在一邊，我與我兒子約拿單也站在一邊。百姓對掃羅說：你看怎樣好就去行吧！',
    '撒上14:41 掃羅禱告耶和華─以色列的神說：求你指示實情。於是掣籤掣出掃羅和約拿單來；百姓盡都無事。',
    '撒上14:42 掃羅說：你們再掣籤，看是我，是我兒子約拿單，就掣出約拿單來。',
    '撒上14:43 掃羅對約拿單說：你告訴我，你做了什麼事﹖約拿單說：我實在以手裡的杖，用杖頭蘸了一點蜜嘗了一嘗。這樣我就死嗎（或譯：吧）﹖',
    '撒上14:44 掃羅說：約拿單哪，你定要死！若不然，願神重重地降罰與我。',
    '撒上14:45 百姓對掃羅說：約拿單在以色列人中這樣大行拯救，豈可使他死呢﹖斷乎不可！我們指著永生的耶和華起誓，連他的一根頭髮也不可落地，因為他今日與神一同做事。於是百姓救約拿單免了死亡。',
    '撒上14:46 掃羅回去，不追趕非利士人；非利士人也回本地去了。',
    '撒上14:47 掃羅執掌以色列的國權，常常攻擊他四圍的一切仇敵，就是摩押人、亞捫人、以東人，和瑣巴諸王，並非利士人。他無論往何處去，都打敗仇敵。',
    '撒上14:48 掃羅奮勇攻擊亞瑪力人，救了以色列人脫離搶掠他們之人的手。',
    '撒上14:49 掃羅的兒子是約拿單、亦施韋、麥基舒亞。他的兩個女兒：長女名米拉，次女名米甲。',
    '撒上14:50 掃羅的妻名叫亞希暖，是亞希瑪斯的女兒。掃羅的元帥名叫押尼珥，是尼珥的兒子；尼珥是掃羅的叔叔。',
    '撒上14:51 掃羅的父親基士，押尼珥的父親尼珥，都是亞別的兒子。',
    '撒上14:52 掃羅平生常與非利士人大大爭戰。掃羅遇見有能力的人或勇士，都招募了來跟隨他。',
    '撒上15:1 撒母耳對掃羅說：耶和華差遣我膏你為王，治理他的百姓以色列；所以你當聽從耶和華的話。',
    '撒上15:2 萬軍之耶和華如此說：以色列人出埃及的時候，在路上亞瑪力人怎樣待他們，怎樣抵擋他們，我都沒忘。',
    '撒上15:3 現在你要去擊打亞瑪力人，滅盡他們所有的，不可憐惜他們，將男女、孩童、吃奶的，並牛、羊、駱駝，和驢盡行殺死。',
    '撒上15:4 於是掃羅招聚百姓在提拉因，數點他們，共有步兵二十萬，另有猶大人一萬。',
    '撒上15:5 掃羅到了亞瑪力的京城，在谷中設下埋伏。',
    '撒上15:6 掃羅對基尼人說：你們離開亞瑪力人下去吧，恐怕我將你們和亞瑪力人一同殺滅；因為以色列人出埃及的時候，你們曾恩待他們。於是基尼人離開亞瑪力人去了。',
    '撒上15:7 掃羅擊打亞瑪力人，從哈腓拉直到埃及前的書珥，',
    '撒上15:8 生擒了亞瑪力王亞甲，用刀殺盡亞瑪力的眾民。',
    '撒上15:9 掃羅和百姓卻憐惜亞甲，也愛惜上好的牛、羊、牛犢、羊羔，並一切美物，不肯滅絕。凡下賤瘦弱的，盡都殺了。',
    '撒上15:10 耶和華的話臨到撒母耳說：',
    '撒上15:11 我立掃羅為王，我後悔了；因為他轉去不跟從我，不遵守我的命令。撒母耳便甚憂愁，終夜哀求耶和華。',
    '撒上15:12 撒母耳清早起來，迎接掃羅。有人告訴撒母耳說：掃羅到了迦密，在那裡立了記念碑，又轉身下到吉甲。',
    '撒上15:13 撒母耳到了掃羅那裡，掃羅對他說：願耶和華賜福與你，耶和華的命令我已遵守了。',
    '撒上15:14 撒母耳說：我耳中聽見有羊叫、牛鳴，是從哪裡來的呢﹖',
    '撒上15:15 掃羅說：這是百姓從亞瑪力人那裡帶來的；因為他們愛惜上好的牛羊，要獻與耶和華─你的神；其餘的，我們都滅盡了。',
    '撒上15:16 撒母耳對掃羅說：你住口吧！等我將耶和華昨夜向我所說的話告訴你。掃羅說：請講。',
    '撒上15:17 撒母耳對掃羅說：從前你雖然以自己為小，豈不是被立為以色列支派的元首嗎﹖耶和華膏你作以色列的王。',
    '撒上15:18 耶和華差遣你，吩咐你說，你去擊打那些犯罪的亞瑪力人，將他們滅絕淨盡。',
    '撒上15:19 你為何沒有聽從耶和華的命令，急忙擄掠財物，行耶和華眼中看為惡的事呢﹖',
    '撒上15:20 掃羅對撒母耳說：我實在聽從了耶和華的命令，行了耶和華所差遣我行的路，擒了亞瑪力王亞甲來，滅盡了亞瑪力人。',
    '撒上15:21 百姓卻在所當滅的物中取了最好的牛羊，要在吉甲獻與耶和華─你的神。',
    '撒上15:22 撒母耳說：耶和華喜悅燔祭和平安祭，豈如喜悅人聽從他的話呢﹖聽命勝於獻祭；順從勝於公羊的脂油。',
    '撒上15:23 悖逆的罪與行邪術的罪相等；頑梗的罪與拜虛神和偶像的罪相同。你既厭棄耶和華的命令，耶和華也厭棄你作王。',
    '撒上15:24 掃羅對撒母耳說：我有罪了，我因懼怕百姓，聽從他們的話，就違背了耶和華的命令和你的言語。',
    '撒上15:25 現在求你赦免我的罪，同我回去，我好敬拜耶和華。',
    '撒上15:26 撒母耳對掃羅說：我不同你回去；因為你厭棄耶和華的命令，耶和華也厭棄你作以色列的王。',
    '撒上15:27 撒母耳轉身要走，掃羅就扯住他外袍的衣襟，衣襟就撕斷了。',
    '撒上15:28 撒母耳對他說：如此，今日耶和華使以色列國與你斷絕，將這國賜與比你更好的人。',
    '撒上15:29 以色列的大能者必不致說謊，也不致後悔；因為他迥非世人，決不後悔。',
    '撒上15:30 掃羅說：我有罪了，雖然如此，求你在我百姓的長老和以色列人面前擡舉我，同我回去，我好敬拜耶和華─你的神。',
    '撒上15:31 於是撒母耳轉身跟隨掃羅回去，掃羅就敬拜耶和華。',
    '撒上15:32 撒母耳說：要把亞瑪力王亞甲帶到我這裡來。亞甲就歡歡喜喜地來到他面前，心裡說，死亡的苦難必定過去了。',
    '撒上15:33 撒母耳說：你既用刀使婦人喪子，這樣，你母親在婦人中也必喪子。於是，撒母耳在吉甲耶和華面前將亞甲殺死。',
    '撒上15:34 撒母耳回了拉瑪。掃羅上他所住的基比亞，回自己的家去了。',
    '撒上15:35 撒母耳直到死的日子，再沒有見掃羅；但撒母耳為掃羅悲傷，是因耶和華後悔立他為以色列的王。',
    '撒上16:1 耶和華對撒母耳說：我既厭棄掃羅作以色列的王，你為他悲傷要到幾時呢﹖你將膏油盛滿了角，我差遣你往伯利恆人耶西那裡去；因為我在他眾子之內，預定一個作王的。',
    '撒上16:2 撒母耳說：我怎能去呢﹖掃羅若聽見，必要殺我。耶和華說：你可以帶一隻牛犢去，就說：我來是要向耶和華獻祭。',
    '撒上16:3 你要請耶西來吃祭肉，我就指示你所當行的事。我所指給你的人，你要膏他。',
    '撒上16:4 撒母耳就照耶和華的話去行。到了伯利恆，那城裡的長老都戰戰兢兢地出來迎接他，問他說：你是為平安來的嗎﹖',
    '撒上16:5 他說：為平安來的，我是給耶和華獻祭。你們當自潔，來與我同吃祭肉。撒母耳就使耶西和他眾子自潔，請他們來吃祭肉。',
    '撒上16:6 他們來的時候，撒母耳看見以利押，就心裡說，耶和華的受膏者必定在他面前。',
    '撒上16:7 耶和華卻對撒母耳說：不要看他的外貌和他身材高大，我不揀選他。因為，耶和華不像人看人：人是看外貌；耶和華是看內心。',
    '撒上16:8 耶西叫亞比拿達從撒母耳面前經過，撒母耳說：耶和華也不揀選他。',
    '撒上16:9 耶西又叫沙瑪從撒母耳面前經過，撒母耳說：耶和華也不揀選他。',
    '撒上16:10 耶西叫他七個兒子都從撒母耳面前經過，撒母耳說：這都不是耶和華所揀選的。',
    '撒上16:11 撒母耳對耶西說：你的兒子都在這裡嗎﹖他回答說：還有個小的，現在放羊。撒母耳對耶西說：你打發人去叫他來；他若不來，我們必不坐席。',
    '撒上16:12 耶西就打發人去叫了他來。他面色光紅，雙目清秀，容貌俊美。耶和華說：這就是他，你起來膏他。',
    '撒上16:13 撒母耳就用角裡的膏油，在他諸兄中膏了他。從這日起，耶和華的靈就大大感動大衛。撒母耳起身回拉瑪去了。',
    '撒上16:14 耶和華的靈離開掃羅，有惡魔從耶和華那裡來擾亂他。',
    '撒上16:15 掃羅的臣僕對他說：現在有惡魔從神那裡來擾亂你。',
    '撒上16:16 我們的主可以吩咐面前的臣僕，找一個善於彈琴的來，等神那裡來的惡魔臨到你身上的時候，使他用手彈琴，你就好了。',
    '撒上16:17 掃羅對臣僕說：你們可以為我找一個善於彈琴的，帶到我這裡來。',
    '撒上16:18 其中有一個少年人說：我曾見伯利恆人耶西的一個兒子善於彈琴，是大有勇敢的戰士，說話合宜，容貌俊美，耶和華也與他同在。',
    '撒上16:19 於是掃羅差遣使者去見耶西，說：請你打發你放羊的兒子大衛到我這裡來。',
    '撒上16:20 耶西就把幾個餅和一皮袋酒，並一隻山羊羔，都馱在驢上，交給他兒子大衛，送與掃羅。',
    '撒上16:21 大衛到了掃羅那裡，就侍立在掃羅面前。掃羅甚喜愛他，他就作了掃羅拿兵器的人。',
    '撒上16:22 掃羅差遣人去見耶西，說：求你容大衛侍立在我面前，因為他在我眼前蒙了恩。',
    '撒上16:23 從神那裡來的惡魔臨到掃羅身上的時候，大衛就拿琴，用手而彈，掃羅便舒暢爽快，惡魔離了他。',
    '撒上17:1 非利士人招聚他們的軍旅，要來爭戰；聚集在屬猶大的梭哥，安營在梭哥和亞西加中間的以弗大憫。',
    '撒上17:2 掃羅和以色列人也聚集，在以拉谷安營，擺列隊伍，要與非利士人打仗。',
    '撒上17:3 非利士人站在這邊山上，以色列人站在那邊山上，當中有谷。',
    '撒上17:4 從非利士營中出來一個討戰的人，名叫歌利亞，是迦特人，身高六肘零一虎口；',
    '撒上17:5 頭戴銅盔，身穿鎧甲，甲重五千舍客勒；',
    '撒上17:6 腿上有銅護膝，兩肩之中背負銅戟；',
    '撒上17:7 槍桿粗如織布的機軸，鐵槍頭重六百舍客勒。有一個拿盾牌的人在他前面走。',
    '撒上17:8 歌利亞對著以色列的軍隊站立，呼叫說：你們出來擺列隊伍做什麼呢﹖我不是非利士人嗎﹖你們不是掃羅的僕人嗎﹖可以從你們中間揀選一人，使他下到我這裡來。',
    '撒上17:9 他若能與我戰鬥，將我殺死，我們就作你們的僕人；我若勝了他，將他殺死，你們就作我們的僕人，服事我們。',
    '撒上17:10 那非利士人又說：我今日向以色列人的軍隊罵陣。你們叫一個人出來，與我戰鬥。',
    '撒上17:11 掃羅和以色列眾人聽見非利士人的這些話，就驚惶，極其害怕。',
    '撒上17:12 大衛是猶大、伯利恆的以法他人耶西的兒子。耶西有八個兒子。當掃羅的時候，耶西已經老邁。',
    '撒上17:13 耶西的三個大兒子跟隨掃羅出征。這出征的三個兒子：長子名叫以利押，次子名叫亞比拿達，三子名叫沙瑪。',
    '撒上17:14 大衛是最小的；那三個大兒子跟隨掃羅。',
    '撒上17:15 大衛有時離開掃羅，回伯利恆放他父親的羊。',
    '撒上17:16 那非利士人早晚都出來站著，如此四十日。',
    '撒上17:17 一日，耶西對他兒子大衛說：你拿一伊法烘了的穗子和十個餅，速速地送到營裡去，交給你哥哥們；',
    '撒上17:18 再拿這十塊奶餅，送給他們的千夫長，且問你哥哥們好，向他們要一封信來。',
    '撒上17:19 掃羅與大衛的三個哥哥和以色列眾人，在以拉谷與非利士人打仗。',
    '撒上17:20 大衛早晨起來，將羊交託一個看守的人，照著他父親所吩咐的話，帶著食物去了。到了輜重營，軍兵剛出到戰場，吶喊要戰。',
    '撒上17:21 以色列人和非利士人都擺列隊伍，彼此相對。',
    '撒上17:22 大衛把他帶來的食物留在看守物件人的手下，跑到戰場，問他哥哥們安。',
    '撒上17:23 與他們說話的時候，那討戰的，就是屬迦特的非利士人歌利亞，從非利士隊中出來，說從前所說的話；大衛都聽見了。',
    '撒上17:24 以色列眾人看見那人，就逃跑，極其害怕。',
    '撒上17:25 以色列人彼此說：這上來的人你看見了嗎﹖他上來是要向以色列人罵陣。若有能殺他的，王必賞賜他大財，將自己的女兒給他為妻，並在以色列人中免他父家納糧當差。',
    '撒上17:26 大衛問站在旁邊的人說：有人殺這非利士人，除掉以色列人的恥辱，怎樣待他呢﹖這未受割禮的非利士人是誰呢﹖竟敢向永生神的軍隊罵陣嗎﹖',
    '撒上17:27 百姓照先前的話回答他說：有人能殺這非利士人，必如此如此待他。',
    '撒上17:28 大衛的長兄以利押聽見大衛與他們所說的話，就向他發怒，說：你下來做什麼呢﹖在曠野的那幾隻羊，你交託了誰呢﹖我知道你的驕傲和你心裡的惡意，你下來特為要看爭戰！',
    '撒上17:29 大衛說：我做了什麼呢﹖我來豈沒有緣故嗎﹖',
    '撒上17:30 大衛就離開他轉向別人，照先前的話而問；百姓仍照先前的話回答他。',
    '撒上17:31 有人聽見大衛所說的話，就告訴了掃羅；掃羅便打發人叫他來。',
    '撒上17:32 大衛對掃羅說：人都不必因那非利士人膽怯。你的僕人要去與那非利士人戰鬥。',
    '撒上17:33 掃羅對大衛說：你不能去與那非利士人戰鬥；因為你年紀太輕，他自幼就作戰士。',
    '撒上17:34 大衛對掃羅說：你僕人為父親放羊，有時來了獅子，有時來了熊，從群中啣一隻羊羔去。',
    '撒上17:35 我就追趕他，擊打他，將羊羔從他口中救出來。他起來要害我，我就揪著他的鬍子，將他打死。',
    '撒上17:36 你僕人曾打死獅子和熊，這未受割禮的非利士人向永生神的軍隊罵陣，也必像獅子和熊一般。',
    '撒上17:37 大衛又說：耶和華救我脫離獅子和熊的爪，也必救我脫離這非利士人的手。掃羅對大衛說：你可以去吧！耶和華必與你同在。',
    '撒上17:38 掃羅就把自己的戰衣給大衛穿上，將銅盔給他戴上，又給他穿上鎧甲。',
    '撒上17:39 大衛把刀跨在戰衣外，試試能走不能走；因為素來沒有穿慣，就對掃羅說：我穿戴這些不能走，因為素來沒有穿慣。於是摘脫了。',
    '撒上17:40 他手中拿杖，又在溪中挑選了五塊光滑石子，放在袋裡，就是牧人帶的囊裡；手中拿著甩石的機弦，就去迎那非利士人。',
    '撒上17:41 非利士人也漸漸地迎著大衛來，拿盾牌的走在前頭。',
    '撒上17:42 非利士人觀看，見了大衛，就藐視他；因為他年輕，面色光紅，容貌俊美。',
    '撒上17:43 非利士人對大衛說：你拿杖到我這裡來，我豈是狗呢﹖非利士人就指著自己的神咒詛大衛。',
    '撒上17:44 非利士人又對大衛說：來吧！我將你的肉給空中的飛鳥、田野的走獸吃。',
    '撒上17:45 大衛對非利士人說：你來攻擊我，是靠著刀槍和銅戟；我來攻擊你，是靠著萬軍之耶和華的名，就是你所怒罵帶領以色列軍隊的神。',
    '撒上17:46 今日耶和華必將你交在我手裡。我必殺你，斬你的頭，又將非利士軍兵的屍首給空中的飛鳥、地上的野獸吃，使普天下的人都知道以色列中有神；',
    '撒上17:47 又使這眾人知道耶和華使人得勝，不是用刀用槍，因為爭戰的勝敗全在乎耶和華。他必將你們交在我們手裡。',
    '撒上17:48 非利士人起身，迎著大衛前來。大衛急忙迎著非利士人，往戰場跑去。',
    '撒上17:49 大衛用手從囊中掏出一塊石子來，用機弦甩去，打中非利士人的額，石子進入額內，他就仆倒，面伏於地。',
    '撒上17:50 這樣，大衛用機弦甩石，勝了那非利士人，打死他；大衛手中卻沒有刀。',
    '撒上17:51 大衛跑去，站在非利士人身旁，將他的刀從鞘中拔出來，殺死他，割了他的頭。非利士眾人看見他們討戰的勇士死了，就都逃跑。',
    '撒上17:52 以色列人和猶大人便起身吶喊，追趕非利士人，直到迦特（或譯：該）和以革倫的城門。被殺的非利士人倒在沙拉音的路上，直到迦特和以革倫。',
    '撒上17:53 以色列人追趕非利士人回來，就奪了他們的營盤。',
    '撒上17:54 大衛將那非利士人的頭拿到耶路撒冷，卻將他軍裝放在自己的帳棚裡。',
    '撒上17:55 掃羅看見大衛去攻擊非利士人，就問元帥押尼珥說：押尼珥啊，那少年人是誰的兒子﹖押尼珥說：我敢在王面前起誓，我不知道。',
    '撒上17:56 王說：你可以問問那幼年人是誰的兒子。',
    '撒上17:57 大衛打死非利士人回來，押尼珥領他到掃羅面前，他手中拿著非利士人的頭。',
    '撒上17:58 掃羅問他說：少年人哪，你是誰的兒子﹖大衛說：我是你僕人伯利恆人耶西的兒子。',
    '撒上18:1 大衛對掃羅說完了話，約拿單的心與大衛的心深相契合。約拿單愛大衛，如同愛自己的性命。',
    '撒上18:2 那日掃羅留住大衛，不容他再回父家。',
    '撒上18:3 約拿單愛大衛如同愛自己的性命，就與他結盟。',
    '撒上18:4 約拿單從身上脫下外袍，給了大衛，又將戰衣、刀、弓、腰帶都給了他。',
    '撒上18:5 掃羅無論差遣大衛往何處去，他都做事精明。掃羅就立他作戰士長，眾百姓和掃羅的臣僕無不喜悅。',
    '撒上18:6 大衛打死了那非利士人，同眾人回來的時候，婦女們從以色列各城裡出來，歡歡喜喜，打鼓擊磬，歌唱跳舞，迎接掃羅王。',
    '撒上18:7 眾婦女舞蹈唱和，說：掃羅殺死千千，大衛殺死萬萬。',
    '撒上18:8 掃羅甚發怒，不喜悅這話，就說：將萬萬歸大衛，千千歸我，只剩下王位沒有給他了。',
    '撒上18:9 從這日起，掃羅就怒視大衛。',
    '撒上18:10 次日，從神那裡來的惡魔大大降在掃羅身上，他就在家中胡言亂語。大衛照常彈琴，掃羅手裡拿著槍。',
    '撒上18:11 掃羅把槍一掄，心裡說，我要將大衛刺透，釘在牆上。大衛躲避他兩次。',
    '撒上18:12 掃羅懼怕大衛；因為耶和華離開自己，與大衛同在。',
    '撒上18:13 所以掃羅使大衛離開自己，立他為千夫長，他就領兵出入。',
    '撒上18:14 大衛做事無不精明，耶和華也與他同在。',
    '撒上18:15 掃羅見大衛做事精明，就甚怕他。',
    '撒上18:16 但以色列和猶大眾人都愛大衛，因為他領他們出入。',
    '撒上18:17 掃羅對大衛說：我將大女兒米拉給你為妻，只要你為我奮勇，為耶和華爭戰。掃羅心裡說：我不好親手害他，要藉非利士人的手害他。',
    '撒上18:18 大衛對掃羅說：我是誰，我是什麼出身，我父家在以色列中是何等的家，豈敢作王的女婿呢﹖',
    '撒上18:19 掃羅的女兒米拉到了當給大衛的時候，掃羅卻給了米何拉人亞得列為妻。',
    '撒上18:20 掃羅的次女米甲愛大衛。有人告訴掃羅，掃羅就喜悅。',
    '撒上18:21 掃羅心裡說：我將這女兒給大衛，作他的網羅，好藉非利士人的手害他。所以掃羅對大衛說：你今日可以第二次作我的女婿。',
    '撒上18:22 掃羅吩咐臣僕說：你們暗中對大衛說：王喜悅你，王的臣僕也都喜愛你，所以你當作王的女婿。',
    '撒上18:23 掃羅的臣僕就照這話說給大衛聽。大衛說：你們以為作王的女婿是一件小事嗎﹖我是貧窮卑微的人。',
    '撒上18:24 掃羅的臣僕回奏說，大衛所說的如此如此。',
    '撒上18:25 掃羅說：你們要對大衛這樣說：王不要什麼聘禮，只要一百非利士人的陽皮，好在王的仇敵身上報仇。掃羅的意思要使大衛喪在非利士人的手裡。',
    '撒上18:26 掃羅的臣僕將這話告訴大衛，大衛就歡喜作王的女婿。日期還沒有到，',
    '撒上18:27 大衛和跟隨他的人起身前往，殺了二百非利士人，將陽皮滿數交給王，為要作王的女婿。於是掃羅將女兒米甲給大衛為妻。',
    '撒上18:28 掃羅見耶和華與大衛同在，又知道女兒米甲愛大衛，',
    '撒上18:29 就更怕大衛，常作大衛的仇敵。',
    '撒上18:30 每逢非利士軍長出來打仗，大衛比掃羅的臣僕做事精明，因此他的名被人尊重。',
    '撒上19:1 掃羅對他兒子約拿單和眾臣僕說，要殺大衛；掃羅的兒子約拿單卻甚喜愛大衛。',
    '撒上19:2 約拿單告訴大衛說：我父掃羅想要殺你，所以明日早晨你要小心，到一個僻靜地方藏身。',
    '撒上19:3 我就出到你所藏的田裡，站在我父親旁邊與他談論。我看他情形怎樣，我必告訴你。',
    '撒上19:4 約拿單向他父親掃羅替大衛說好話，說：王不可得罪王的僕人大衛；因為他未曾得罪你，他所行的都於你大有益處。',
    '撒上19:5 他拚命殺那非利士人，耶和華為以色列眾人大行拯救；那時你看見，甚是歡喜，現在為何無故要殺大衛，流無辜人的血，自己取罪呢﹖',
    '撒上19:6 掃羅聽了約拿單的話，就指著永生的耶和華起誓說：我必不殺他。',
    '撒上19:7 約拿單叫大衛來，把這一切事告訴他，帶他去見掃羅。他就仍然侍立在掃羅面前。',
    '撒上19:8 此後又有爭戰的事。大衛出去與非利士人打仗，大大殺敗他們，他們就在他面前逃跑。',
    '撒上19:9 從耶和華那裡來的惡魔又降在掃羅身上（掃羅手裡拿槍坐在屋裡），大衛就用手彈琴。',
    '撒上19:10 掃羅用槍想要刺透大衛，釘在牆上；他卻躲開，掃羅的槍刺入牆內。當夜大衛逃走，躲避了。',
    '撒上19:11 掃羅打發人到大衛的房屋那裡窺探他，要等到天亮殺他。大衛的妻米甲對他說：你今夜若不逃命，明日你要被殺。',
    '撒上19:12 於是米甲將大衛從窗戶裡縋下去；大衛就逃走，躲避了。',
    '撒上19:13 米甲把家中的神像放在床上，頭枕在山羊毛裝的枕頭上，用被遮蓋。',
    '撒上19:14 掃羅打發人去捉拿大衛，米甲說：他病了。',
    '撒上19:15 掃羅又打發人去看大衛，說：當連床將他擡來，我好殺他。',
    '撒上19:16 使者進去，看見床上有神像，頭枕在山羊毛裝的枕頭上。',
    '撒上19:17 掃羅對米甲說：你為什麼這樣欺哄我，放我仇敵逃走呢﹖米甲回答說：他對我說：你放我走，不然我要殺你。',
    '撒上19:18 大衛逃避，來到拉瑪見撒母耳，將掃羅向他所行的事述說了一遍。他和撒母耳就往拿約去居住。',
    '撒上19:19 有人告訴掃羅，說大衛在拉瑪的拿約。',
    '撒上19:20 掃羅打發人去捉拿大衛。去的人見有一班先知都受感說話，撒母耳站在其中監管他們；打發去的人也受神的靈感動說話。',
    '撒上19:21 有人將這事告訴掃羅，他又打發人去，他們也受感說話。掃羅第三次打發人去，他們也受感說話。',
    '撒上19:22 然後掃羅自己往拉瑪去，到了西沽的大井，問人說：撒母耳和大衛在哪裡呢﹖有人說：在拉瑪的拿約。',
    '撒上19:23 他就往拉瑪的拿約去。神的靈也感動他，一面走一面說話，直到拉瑪的拿約。',
    '撒上19:24 他就脫了衣服，在撒母耳面前受感說話，一晝一夜露體躺臥。因此有句俗語說：掃羅也列在先知中嗎﹖',
    '撒上20:1 大衛從拉瑪的拿約逃跑，來到約拿單那裡，對他說：我做了什麼﹖有什麼罪孽呢﹖在你父親面前犯了什麼罪，他竟尋索我的性命呢﹖',
    '撒上20:2 約拿單回答說：斷然不是！你必不致死。我父做事，無論大小，沒有不叫我知道的。怎麼獨有這事隱瞞我呢﹖決不如此。',
    '撒上20:3 大衛又起誓說：你父親準知我在你眼前蒙恩。他心裡說，不如不叫約拿單知道，恐怕他愁煩。我指著永生的耶和華，又敢在你面前起誓，我離死不過一步。',
    '撒上20:4 約拿單對大衛說：你心裡所求的，我必為你成就。',
    '撒上20:5 大衛對約拿單說：明日是初一，我當與王同席，求你容我去藏在田野，直到第三日晚上。',
    '撒上20:6 你父親若見我不在席上，你就說：大衛切求我許他回本城伯利恆去，因為他全家在那裡獻年祭。',
    '撒上20:7 你父親若說好，僕人就平安了；他若發怒，你就知道他決意要害我。',
    '撒上20:8 求你施恩與僕人，因你在耶和華面前曾與僕人結盟。我若有罪，不如你自己殺我，何必將我交給你父親呢﹖',
    '撒上20:9 約拿單說：斷無此事！我若知道我父親決意害你，我豈不告訴你呢﹖',
    '撒上20:10 大衛對約拿單說：你父親若用厲言回答你，誰來告訴我呢﹖',
    '撒上20:11 約拿單對大衛說：你我且往田野去。二人就往田野去了。',
    '撒上20:12 約拿單對大衛說：願耶和華─以色列的神為證。明日約在這時候，或第三日，我探我父親的意思，若向你有好意，我豈不打發人告訴你嗎﹖',
    '撒上20:13 我父親若有意害你，我不告訴你使你平平安安地走，願耶和華重重地降罰與我。願耶和華與你同在，如同從前與我父親同在一樣。',
    '撒上20:14 你要照耶和華的慈愛恩待我，不但我活著的時候免我死亡，',
    '撒上20:15 就是我死後，耶和華從地上剪除你仇敵的時候，你也永不可向我家絕了恩惠。',
    '撒上20:16 於是約拿單與大衛家結盟，說：願耶和華藉大衛的仇敵追討背約的罪。',
    '撒上20:17 約拿單因愛大衛如同愛自己的性命，就使他再起誓。',
    '撒上20:18 約拿單對他說：明日是初一，你的座位空設，人必理會你不在那裡。',
    '撒上20:19 你等三日，就要速速下去，到你從前遇事所藏的地方，在以色磐石那裡等候。',
    '撒上20:20 我要向磐石旁邊射三箭，如同射箭靶一樣。',
    '撒上20:21 我要打發童子，說：去把箭找來。我若對童子說：箭在後頭，把箭拿來，你就可以回來；我指著永生的耶和華起誓，你必平安無事。',
    '撒上20:22 我若對童子說：箭在前頭，你就要去，因為是耶和華打發你去的。',
    '撒上20:23 至於你我今日所說的話，有耶和華在你我中間為證，直到永遠。',
    '撒上20:24 大衛就去藏在田野。到了初一日，王坐席要吃飯。',
    '撒上20:25 王照常坐在靠牆的位上，約拿單侍立，押尼珥坐在掃羅旁邊，大衛的座位空設。',
    '撒上20:26 然而這日掃羅沒有說什麼，他想大衛遇事，偶染不潔，他必定是不潔。',
    '撒上20:27 初二日大衛的座位還空設。掃羅問他兒子約拿單說：耶西的兒子為何昨日、今日沒有來吃飯呢﹖',
    '撒上20:28 約拿單回答掃羅說：大衛切求我容他往伯利恆去。',
    '撒上20:29 他說：求你容我去，因為我家在城裡有獻祭的事；我長兄吩咐我去。如今我若在你眼前蒙恩，求你容我去見我的弟兄；所以大衛沒有赴王的席。',
    '撒上20:30 掃羅向約拿單發怒，對他說：你這頑梗背逆之婦人所生的，我豈不知道你喜悅耶西的兒子，自取羞辱，以致你母親露體蒙羞嗎﹖',
    '撒上20:31 耶西的兒子若在世間活著，你和你的國位必站立不住。現在你要打發人去，將他捉拿交給我；他是該死的。',
    '撒上20:32 約拿單對父親掃羅說：他為什麼該死呢﹖他做了什麼呢﹖',
    '撒上20:33 掃羅向約拿單掄槍要刺他，約拿單就知道他父親決意要殺大衛。',
    '撒上20:34 於是約拿單氣忿忿地從席上起來，在這初二日沒有吃飯。他因見父親羞辱大衛，就為大衛愁煩。',
    '撒上20:35 次日早晨，約拿單按著與大衛約會的時候出到田野，有一個童子跟隨。',
    '撒上20:36 約拿單對童子說：你跑去，把我所射的箭找來。童子跑去，約拿單就把箭射在童子前頭。',
    '撒上20:37 童子到了約拿單落箭之地，約拿單呼叫童子說：箭不是在你前頭嗎﹖',
    '撒上20:38 約拿單又呼叫童子說：速速地去，不要遲延！童子就拾起箭來，回到主人那裡。',
    '撒上20:39 童子卻不知道這是什麼意思，只有約拿單和大衛知道。',
    '撒上20:40 約拿單將弓箭交給童子，吩咐說：你拿到城裡去。',
    '撒上20:41 童子一去，大衛就從磐石的南邊出來，俯伏在地，拜了三拜；二人親嘴，彼此哭泣，大衛哭得更慟。',
    '撒上20:42 約拿單對大衛說：我們二人曾指著耶和華的名起誓說：願耶和華在你我中間，並你我後裔中間為證，直到永遠。如今你平平安安地去吧！大衛就起身走了；約拿單也回城裡去了。',
    '撒上21:1 大衛到了挪伯祭司亞希米勒那裡，亞希米勒戰戰兢兢地出來迎接他，問他說：你為什麼獨自來，沒有人跟隨呢﹖',
    '撒上21:2 大衛回答祭司亞希米勒說：王吩咐我一件事說：我差遣你委託你的這件事，不要使人知道。故此我已派定少年人在某處等候我。',
    '撒上21:3 現在你手下有什麼﹖求你給我五個餅或是別樣的食物。',
    '撒上21:4 祭司對大衛說：我手下沒有尋常的餅，只有聖餅；若少年人沒有親近婦人才可以給。',
    '撒上21:5 大衛對祭司說：實在約有三日我們沒有親近婦人；我出來的時候，雖是尋常行路，少年人的器皿還是潔淨的；何況今日不更是潔淨嗎﹖',
    '撒上21:6 祭司就拿聖餅給他；因為在那裡沒有別樣餅，只有更換新餅，從耶和華面前撤下來的陳設餅。',
    '撒上21:7 （當日有掃羅的一個臣子留在耶和華面前。他名叫多益，是以東人，作掃羅的司牧長。）',
    '撒上21:8 大衛問亞希米勒說：你手下有槍有刀沒有﹖因為王的事甚急，連刀劍器械我都沒有帶。',
    '撒上21:9 祭司說：你在以拉谷殺非利士人歌利亞的那刀在這裡，裹在布中，放在以弗得後邊，你要就可以拿去；除此以外，再沒有別的。大衛說：這刀沒有可比的！求你給我。',
    '撒上21:10 那日大衛起來，躲避掃羅，逃到迦特王亞吉那裡。',
    '撒上21:11 亞吉的臣僕對亞吉說：這不是以色列國王大衛嗎﹖那裡的婦女跳舞唱和，不是指著他說掃羅殺死千千，大衛殺死萬萬嗎﹖',
    '撒上21:12 大衛將這話放在心裡，甚懼怕迦特王亞吉，',
    '撒上21:13 就在眾人面前改變了尋常的舉動，在他們手下假裝瘋癲，在城門的門扇上胡寫亂畫，使唾沫流在鬍子上。',
    '撒上21:14 亞吉對臣僕說：你們看，這人是瘋子。為什麼帶他到我這裡來呢﹖',
    '撒上21:15 我豈缺少瘋子，你們帶這人來在我面前瘋癲嗎﹖這人豈可進我的家呢﹖',
    '撒上22:1 大衛就離開那裡，逃到亞杜蘭洞。他的弟兄和他父親的全家聽見了，就都下到他那裡。',
    '撒上22:2 凡受窘迫的、欠債的、心裡苦惱的都聚集到大衛那裡；大衛就作他們的頭目，跟隨他的約有四百人。',
    '撒上22:3 大衛從那裡往摩押的米斯巴去，對摩押王說：求你容我父母搬來，住在你們這裡，等我知道神要為我怎樣行。',
    '撒上22:4 大衛領他父母到摩押王面前。大衛住山寨多少日子，他父母也住摩押王那裡多少日子。',
    '撒上22:5 先知迦得對大衛說：你不要住在山寨，要往猶大地去。大衛就離開那裡，進入哈列的樹林。',
    '撒上22:6 掃羅在基比亞的拉瑪，坐在垂絲柳樹下，手裡拿著槍，眾臣僕侍立在左右。掃羅聽見大衛和跟隨他的人在何處，',
    '撒上22:7 就對左右侍立的臣僕說：便雅憫人哪，你們要聽我的話！耶西的兒子能將田地和葡萄園賜給你們各人嗎﹖能立你們各人作千夫長百夫長嗎﹖',
    '撒上22:8 你們竟都結黨害我！我的兒子與耶西的兒子結盟的時候，無人告訴我；我的兒子挑唆我的臣子謀害我，就如今日的光景，也無人告訴我，為我憂慮。',
    '撒上22:9 那時以東人多益站在掃羅的臣僕中，對他說：我曾看見耶西的兒子到了挪伯，亞希突的兒子亞希米勒那裡。',
    '撒上22:10 亞希米勒為他求問耶和華，又給他食物，並給他殺非利士人歌利亞的刀。',
    '撒上22:11 王就打發人將祭司亞希突的兒子亞希米勒和他父親的全家，就是住挪伯的祭司都召了來；他們就來見王。',
    '撒上22:12 掃羅說：亞希突的兒子，要聽我的話！他回答說：主啊，我在這裡。',
    '撒上22:13 掃羅對他說：你為什麼與耶西的兒子結黨害我，將食物和刀給他，又為他求問神，使他起來謀害我，就如今日的光景﹖',
    '撒上22:14 亞希米勒回答王說：王的臣僕中有誰比大衛忠心呢﹖他是王的女婿，又是王的參謀，並且在王家中是尊貴的。',
    '撒上22:15 我豈是從今日才為他求問神呢﹖斷不是這樣！王不要將罪歸我和我父的全家；因為這事，無論大小，僕人都不知道。',
    '撒上22:16 王說：亞希米勒啊，你和你父的全家都是該死的！',
    '撒上22:17 王就吩咐左右的侍衛說：你們去殺耶和華的祭司；因為他們幫助大衛，又知道大衛逃跑，竟沒有告訴我。掃羅的臣子卻不肯伸手殺耶和華的祭司。',
    '撒上22:18 王吩咐多益說：你去殺祭司吧！以東人多益就去殺祭司，那日殺了穿細麻布以弗得的八十五人；',
    '撒上22:19 又用刀將祭司城挪伯中的男女、孩童、吃奶的，和牛、羊、驢盡都殺滅。',
    '撒上22:20 亞希突的兒子亞希米勒有一個兒子，名叫亞比亞他，逃到大衛那裡。',
    '撒上22:21 亞比亞他將掃羅殺耶和華祭司的事告訴大衛。',
    '撒上22:22 大衛對亞比亞他說：那日我見以東人多益在那裡，就知道他必告訴掃羅。你父的全家喪命，都是因我的緣故。',
    '撒上22:23 你可以住在我這裡，不要懼怕。因為尋索你命的就是尋索我的命；你在我這裡可得保全。',
    '撒上23:1 有人告訴大衛說：非利士人攻擊基伊拉，搶奪禾場。',
    '撒上23:2 所以大衛求問耶和華說：我去攻打那些非利士人可以不可以﹖耶和華對大衛說：你可以去攻打非利士人，拯救基伊拉。',
    '撒上23:3 跟隨大衛的人對他說：我們在猶大地這裡尚且懼怕，何況往基伊拉去攻打非利士人的軍旅呢﹖',
    '撒上23:4 大衛又求問耶和華。耶和華回答說：你起身下基伊拉去，我必將非利士人交在你手裡。',
    '撒上23:5 大衛和跟隨他的人往基伊拉去，與非利士人打仗，大大殺敗他們，又奪獲他們的牲畜。這樣，大衛救了基伊拉的居民。',
    '撒上23:6 亞希米勒的兒子亞比亞他逃到基伊拉見大衛的時候，手裡拿著以弗得。',
    '撒上23:7 有人告訴掃羅說：大衛到了基伊拉。掃羅說：他進了有門有閂的城，困閉在裡頭；這是神將他交在我手裡了。',
    '撒上23:8 於是掃羅招聚眾民，要下去攻打基伊拉城，圍困大衛和跟隨他的人。',
    '撒上23:9 大衛知道掃羅設計謀害他，就對祭司亞比亞他說：將以弗得拿過來。',
    '撒上23:10 大衛禱告說：耶和華─以色列的神啊，你僕人聽真了掃羅要往基伊拉來，為我的緣故滅城。',
    '撒上23:11 基伊拉人將我交在掃羅手裡不交﹖掃羅照著你僕人所聽的話下來不下來﹖耶和華─以色列的神啊，求你指示僕人！耶和華說：掃羅必下來。',
    '撒上23:12 大衛又說：基伊拉人將我和跟隨我的人交在掃羅手裡不交﹖耶和華說：必交出來。',
    '撒上23:13 大衛和跟隨他的約有六百人，就起身出了基伊拉，往他們所能往的地方去。有人告訴掃羅，大衛離開基伊拉逃走；於是掃羅不出來了。',
    '撒上23:14 大衛住在曠野的山寨裡，常在西弗曠野的山地。掃羅天天尋索大衛，神卻不將大衛交在他手裡。',
    '撒上23:15 大衛知道掃羅出來尋索他的命。那時，他住在西弗曠野的樹林裡；',
    '撒上23:16 掃羅的兒子約拿單起身，往那樹林裡去見大衛，使他倚靠神得以堅固，',
    '撒上23:17 對他說：不要懼怕！我父掃羅的手必不加害於你；你必作以色列的王，我也作你的宰相。這事我父掃羅知道了。',
    '撒上23:18 於是二人在耶和華面前立約。大衛仍住在樹林裡，約拿單回家去了。',
    '撒上23:19 西弗人上到基比亞見掃羅，說：大衛不是在我們那裡的樹林裡山寨中、曠野南邊的哈基拉山藏著嗎﹖',
    '撒上23:20 王啊，請你隨你的心願下來，我們必親自將他交在王的手裡。',
    '撒上23:21 掃羅說：願耶和華賜福與你們，因你們顧恤我。',
    '撒上23:22 請你們回去，再確實查明他的住處和行蹤，是誰看見他在那裡，因為我聽見人說他甚狡猾。',
    '撒上23:23 所以要看準他藏匿的地方，回來據實地告訴我，我就與你們同去。他若在猶大的境內，我必從千門萬戶中搜出他來。',
    '撒上23:24 西弗人就起身，在掃羅以先往西弗去。大衛和跟隨他的人卻在瑪雲曠野南邊的亞拉巴。',
    '撒上23:25 掃羅和跟隨他的人去尋找大衛；有人告訴大衛，他就下到磐石，住在瑪雲的曠野。掃羅聽見，便在瑪雲的曠野追趕大衛。',
    '撒上23:26 掃羅在山這邊走，大衛和跟隨他的人在山那邊走。大衛急忙躲避掃羅；因為掃羅和跟隨他的人，四面圍住大衛和跟隨他的人，要拿獲他們。',
    '撒上23:27 忽有使者來報告掃羅說：非利士人犯境搶掠，請王快快回去！',
    '撒上23:28 於是掃羅不追趕大衛，回去攻打非利士人。因此那地方名叫西拉哈瑪希羅結。',
    '撒上23:29 大衛從那裡上去，住在隱‧基底的山寨裡。',
    '撒上24:1 掃羅追趕非利士人回來，有人告訴他說：大衛在隱‧基底的曠野。',
    '撒上24:2 掃羅就從以色列人中挑選三千精兵，率領他們往野羊的磐石去，尋索大衛和跟隨他的人。',
    '撒上24:3 到了路旁的羊圈，在那裡有洞，掃羅進去大解。大衛和跟隨他的人正藏在洞裡的深處。',
    '撒上24:4 跟隨的人對大衛說：耶和華曾應許你說：我要將你的仇敵交在你手裡，你可以任意待他。如今時候到了！大衛就起來，悄悄地割下掃羅外袍的衣襟。',
    '撒上24:5 隨後大衛心中自責，因為割下掃羅的衣襟；',
    '撒上24:6 對跟隨他的人說：我的主乃是耶和華的受膏者，我在耶和華面前萬不敢伸手害他，因他是耶和華的受膏者。',
    '撒上24:7 大衛用這話攔住跟隨他的人，不容他們起來害掃羅。掃羅起來，從洞裡出去行路。',
    '撒上24:8 隨後大衛也起來，從洞裡出去，呼叫掃羅說：我主，我王！掃羅回頭觀看，大衛就屈身、臉伏於地下拜。',
    '撒上24:9 大衛對掃羅說：你為何聽信人的讒言，說大衛想要害你呢﹖',
    '撒上24:10 今日你親眼看見在洞中，耶和華將你交在我手裡；有人叫我殺你，我卻愛惜你，說：我不敢伸手害我的主，因為他是耶和華的受膏者。',
    '撒上24:11 我父啊，看看你外袍的衣襟在我手中。我割下你的衣襟，沒有殺你；你由此可以知道我沒有惡意叛逆你。你雖然獵取我的命，我卻沒有得罪你。',
    '撒上24:12 願耶和華在你我中間判斷是非，在你身上為我伸冤，我卻不親手加害於你。',
    '撒上24:13 古人有句俗語說：惡事出於惡人。我卻不親手加害於你。',
    '撒上24:14 以色列王出來要尋找誰呢﹖追趕誰呢﹖不過追趕一條死狗，一個虼蚤就是了。',
    '撒上24:15 願耶和華在你我中間施行審判，斷定是非，並且鑒察，為我伸冤，救我脫離你的手。',
    '撒上24:16 大衛向掃羅說完這話，掃羅說：我兒大衛，這是你的聲音嗎﹖就放聲大哭，',
    '撒上24:17 對大衛說：你比我公義；因為你以善待我，我卻以惡待你。',
    '撒上24:18 你今日顯明是以善待我；因為耶和華將我交在你手裡，你卻沒有殺我。',
    '撒上24:19 人若遇見仇敵，豈肯放他平安無事地去呢﹖願耶和華因你今日向我所行的，以善報你。',
    '撒上24:20 我也知道你必要作王，以色列的國必堅立在你手裡。',
    '撒上24:21 現在你要指著耶和華向我起誓，不剪除我的後裔，在我父家不滅沒我的名。',
    '撒上24:22 於是大衛向掃羅起誓，掃羅就回家去；大衛和跟隨他的人上山寨去了。',
    '撒上25:1 撒母耳死了，以色列眾人聚集，為他哀哭，將他葬在拉瑪─他自己的墳墓（原文是房屋）裡。大衛起身，下到巴蘭的曠野。',
    '撒上25:2 在瑪雲有一個人，他的產業在迦密，是一個大富戶，有三千綿羊，一千山羊；他正在迦密剪羊毛。',
    '撒上25:3 那人名叫拿八，是迦勒族的人；他的妻名叫亞比該，是聰明俊美的婦人。拿八為人剛愎凶惡。',
    '撒上25:4 大衛在曠野聽見說拿八剪羊毛，',
    '撒上25:5 大衛就打發十個僕人，吩咐他們說：你們上迦密去見拿八，提我的名問他安。',
    '撒上25:6 要對那富戶如此說：願你平安，願你家平安，願你一切所有的都平安。',
    '撒上25:7 現在我聽說有人為你剪羊毛，你的牧人在迦密的時候和我們在一處，我們沒有欺負他們，他們也未曾失落什麼。',
    '撒上25:8 可以問你的僕人，他們必告訴你。所以願我的僕人在你眼前蒙恩，因為是在好日子來的。求你隨手取點賜與僕人和你兒子大衛。',
    '撒上25:9 大衛的僕人到了，將這話提大衛的名都告訴了拿八，就住了口。',
    '撒上25:10 拿八回答大衛的僕人說：大衛是誰﹖耶西的兒子是誰﹖近來悖逆主人奔逃的僕人甚多，',
    '撒上25:11 我豈可將飲食和為我剪羊毛人所宰的肉給我不知道從哪裡來的人呢﹖',
    '撒上25:12 大衛的僕人就轉身從原路回去，照這話告訴大衛。',
    '撒上25:13 大衛向跟隨他的人說：你們各人都要帶上刀！眾人就都帶上刀，大衛也帶上刀。跟隨大衛上去的約有四百人，留下二百人看守器具。',
    '撒上25:14 有拿八的一個僕人告訴拿八的妻亞比該說：大衛從曠野打發使者來問我主人的安，主人卻辱罵他們。',
    '撒上25:15 但是那些人待我們甚好；我們在田野與他們來往的時候，沒有受他們的欺負，也未曾失落什麼。',
    '撒上25:16 我們在他們那裡牧羊的時候，他們晝夜作我們的保障。',
    '撒上25:17 所以你當籌劃，看怎樣行才好；不然，禍患定要臨到我主人和他全家。他性情凶暴，無人敢與他說話。',
    '撒上25:18 亞比該急忙將二百餅，兩皮袋酒，五隻收拾好了的羊，五細亞烘好了的穗子，一百葡萄餅，二百無花果餅，都馱在驢上，',
    '撒上25:19 對僕人說：你們前頭走，我隨著你們去。這事他卻沒有告訴丈夫拿八。',
    '撒上25:20 亞比該騎著驢，正下山坡，見大衛和跟隨他的人從對面下來，亞比該就迎接他們。',
    '撒上25:21 大衛曾說：我在曠野為那人看守所有的，以致他一樣不失落，實在是徒然了！他向我以惡報善。',
    '撒上25:22 凡屬拿八的男丁，我若留一個到明日早晨，願神重重降罰與我！',
    '撒上25:23 亞比該見大衛，便急忙下驢，在大衛面前臉伏於地叩拜，',
    '撒上25:24 俯伏在大衛的腳前，說：我主啊，願這罪歸我！求你容婢女向你進言，更求你聽婢女的話。',
    '撒上25:25 我主不要理這壞人拿八，他的性情與他的名相稱；他名叫拿八（就是愚頑的意思），他為人果然愚頑。但我主所打發的僕人，婢女並沒有看見。',
    '撒上25:26 我主啊，耶和華既然阻止你親手報仇，取流血的罪，所以我指著永生的耶和華，又敢在你面前起誓說：願你的仇敵和謀害你的人都像拿八一樣。',
    '撒上25:27 如今求你將婢女送來的禮物給跟隨你的僕人。',
    '撒上25:28 求你饒恕婢女的罪過。耶和華必為我主建立堅固的家，因我主為耶和華爭戰；並且在你平生的日子查不出有什麼過來。',
    '撒上25:29 雖有人起來追逼你，尋索你的性命，你的性命卻在耶和華─你的神那裡蒙保護，如包裹寶器一樣；你仇敵的性命，耶和華必拋去，如用機弦甩石一樣。',
    '撒上25:30 我主現在若不親手報仇流無辜人的血，到了耶和華照所應許你的話賜福與你，立你作以色列的王，那時我主必不致心裡不安，覺得良心有虧。耶和華賜福與我主的時候，求你記念婢女。',
    '撒上25:31 併於上節。',
    '撒上25:32 大衛對亞比該說：耶和華─以色列的神是應當稱頌的，因為他今日使你來迎接我。',
    '撒上25:33 你和你的見識也當稱讚；因為你今日攔阻我親手報仇、流人的血。',
    '撒上25:34 我指著阻止我加害於你的耶和華─以色列永生的神起誓，你若不速速地來迎接我，到明日早晨，凡屬拿八的男丁必定不留一個。',
    '撒上25:35 大衛受了亞比該送來的禮物，就對他說：我聽了你的話，准了你的情面，你可以平平安安地回家吧！',
    '撒上25:36 亞比該到拿八那裡，見他在家裡設擺筵席，如同王的筵席；拿八快樂大醉。亞比該無論大小事都沒有告訴他，就等到次日早晨。',
    '撒上25:37 到了早晨，拿八醒了酒，他的妻將這些事都告訴他，他就魂不附體，身僵如石頭一般。',
    '撒上25:38 過了十天，耶和華擊打拿八，他就死了。',
    '撒上25:39 大衛聽見拿八死了，就說：應當稱頌耶和華，因他伸了拿八羞辱我的冤，又阻止僕人行惡；也使拿八的惡歸到拿八的頭上。於是大衛打發人去，與亞比該說，要娶他為妻。',
    '撒上25:40 大衛的僕人到了迦密見亞比該，對他說：大衛打發我們來見你，想要娶你為妻。',
    '撒上25:41 亞比該就起來，俯伏在地，說：我情願作婢女，洗我主僕人的腳。',
    '撒上25:42 亞比該立刻起身，騎上驢，帶著五個使女，跟從大衛的使者去了，就作了大衛的妻。',
    '撒上25:43 大衛先娶了耶斯列人亞希暖，他們二人都作了他的妻。',
    '撒上25:44 掃羅已將他的女兒米甲，就是大衛的妻，給了迦琳人拉億的兒子帕提為妻。',
    '撒上26:1 西弗人到基比亞見掃羅，說：大衛不是在曠野前的哈基拉山藏著嗎﹖',
    '撒上26:2 掃羅就起身，帶領以色列人中挑選的三千精兵下到西弗的曠野，要在那裡尋索大衛。',
    '撒上26:3 掃羅在曠野前的哈基拉山，在道路上安營。大衛住在曠野，聽說掃羅到曠野來追尋他，',
    '撒上26:4 就打發人去探聽，便知道掃羅果然來到。',
    '撒上26:5 大衛起來，到掃羅安營的地方，看見掃羅和他的元帥尼珥的兒子押尼珥睡臥之處；掃羅睡在輜重營裡，百姓安營在他周圍。',
    '撒上26:6 大衛對赫人亞希米勒和洗魯雅的兒子約押的兄弟亞比篩說：誰同我下到掃羅營裡去﹖亞比篩說：我同你下去。',
    '撒上26:7 於是大衛和亞比篩夜間到了百姓那裡，見掃羅睡在輜重營裡；他的槍在頭旁，插在地上。押尼珥和百姓睡在他周圍。',
    '撒上26:8 亞比篩對大衛說：現在神將你的仇敵交在你手裡，求你容我拿槍將他刺透在地，一刺就成，不用再刺。',
    '撒上26:9 大衛對亞比篩說：不可害死他。有誰伸手害耶和華的受膏者而無罪呢﹖',
    '撒上26:10 大衛又說：我指著永生的耶和華起誓，他或被耶和華擊打，或是死期到了，或是出戰陣亡；',
    '撒上26:11 我在耶和華面前，萬不敢伸手害耶和華的受膏者。現在你可以將他頭旁的槍和水瓶拿來，我們就走。',
    '撒上26:12 大衛從掃羅的頭旁拿了槍和水瓶，二人就走了，沒有人看見，沒有人知道，也沒有人醒起，都睡著了，因為耶和華使他們沉沉地睡了。',
    '撒上26:13 大衛過到那邊去，遠遠地站在山頂上，與他們相離甚遠。',
    '撒上26:14 大衛呼叫百姓和尼珥的兒子押尼珥說：押尼珥啊，你為何不答應呢﹖押尼珥說：你是誰﹖竟敢呼叫王呢﹖',
    '撒上26:15 大衛對押尼珥說：你不是個勇士嗎﹖以色列中誰能比你呢﹖民中有人進來要害死王─你的主，你為何沒有保護王─你的主呢﹖',
    '撒上26:16 你這樣是不好的！我指著永生的耶和華起誓，你們都是該死的；因為沒有保護你們的主，就是耶和華的受膏者。現在你看看王頭旁的槍和水瓶在哪裡。',
    '撒上26:17 掃羅聽出是大衛的聲音，就說：我兒大衛，這是你的聲音嗎﹖大衛說：主─我的王啊，是我的聲音；',
    '撒上26:18 又說：我做了什麼﹖我手裡有什麼惡事﹖我主竟追趕僕人呢﹖',
    '撒上26:19 求我主我王聽僕人的話：若是耶和華激發你攻擊我，願耶和華收納祭物；若是人激發你，願他在耶和華面前受咒詛；因為他現今趕逐我，不容我在耶和華的產業上有分，說：你去事奉別神吧！',
    '撒上26:20 現在求王不要使我的血流在離耶和華遠的地方。以色列王出來是尋找一個虼蚤，如同人在山上獵取一個鷓鴣一般。',
    '撒上26:21 掃羅說：我有罪了！我兒大衛，你可以回來，因你今日看我的性命為寶貴；我必不再加害於你。我是糊塗人，大大錯了。',
    '撒上26:22 大衛說：王的槍在這裡，可以吩咐一個僕人過來拿去。',
    '撒上26:23 今日耶和華將王交在我手裡，我卻不肯伸手害耶和華的受膏者。耶和華必照各人的公義誠實報應他。',
    '撒上26:24 我今日重看你的性命，願耶和華也重看我的性命，並且拯救我脫離一切患難。',
    '撒上26:25 掃羅對大衛說：我兒大衛，願你得福！你必做大事，也必得勝。於是大衛起行，掃羅回他的本處去了。',
    '撒上27:1 大衛心裡說：必有一日我死在掃羅手裡，不如逃奔非利士地去。掃羅見我不在以色列的境內，就必絕望，不再尋索我；這樣我可以脫離他的手。',
    '撒上27:2 於是大衛起身，和跟隨他的六百人投奔迦特王─瑪俄的兒子亞吉去了。',
    '撒上27:3 大衛和他的兩個妻，就是耶斯列人亞希暖和作過拿八妻的迦密人亞比該，並跟隨他的人，連各人的眷屬，都住在迦特的亞吉那裡。',
    '撒上27:4 有人告訴掃羅說：大衛逃到迦特。掃羅就不再尋索他了。',
    '撒上27:5 大衛對亞吉說：我若在你眼前蒙恩，求你在京外的城邑中賜我一個地方居住。僕人何必與王同住京都呢﹖',
    '撒上27:6 當日亞吉將洗革拉賜給他，因此洗革拉屬猶大王，直到今日。',
    '撒上27:7 大衛在非利士地住了一年零四個月。',
    '撒上27:8 大衛和跟隨他的人上去，侵奪基述人、基色人、亞瑪力人之地。這幾族歷來住在那地，從書珥直到埃及。',
    '撒上27:9 大衛擊殺那地的人，無論男女都沒有留下一個，又奪獲牛、羊、駱駝、驢，並衣服，回來見亞吉。',
    '撒上27:10 亞吉說：你們今日侵奪了什麼地方呢﹖大衛說：侵奪了猶大的南方、耶拉篾的南方、基尼的南方。',
    '撒上27:11 無論男女，大衛沒有留下一個帶到迦特來。他說：恐怕他們將我們的事告訴人，說大衛住在非利士地的時候常常這樣行。',
    '撒上27:12 亞吉信了大衛，心裡說：大衛使本族以色列人憎惡他，所以他必永遠作我的僕人了。',
    '撒上28:1 那時，非利士人聚集軍旅，要與以色列人打仗。亞吉對大衛說：你當知道，你和跟隨你的人都要隨我出戰。',
    '撒上28:2 大衛對亞吉說：僕人所能做的事，王必知道。亞吉對大衛說：這樣，我立你永遠作我的護衛長。',
    '撒上28:3 那時撒母耳已經死了，以色列眾人為他哀哭，葬他在拉瑪，就是在他本城裡。掃羅曾在國內不容有交鬼的和行巫術的人。',
    '撒上28:4 非利士人聚集，來到書念安營；掃羅聚集以色列眾人在基利波安營。',
    '撒上28:5 掃羅看見非利士的軍旅就懼怕，心中發顫。',
    '撒上28:6 掃羅求問耶和華，耶和華卻不藉夢，或烏陵，或先知回答他。',
    '撒上28:7 掃羅吩咐臣僕說：當為我找一個交鬼的婦人，我好去問他。臣僕說：在隱多珥有一個交鬼的婦人。',
    '撒上28:8 於是掃羅改了裝，穿上別的衣服，帶著兩個人，夜裡去見那婦人。掃羅說：求你用交鬼的法術，將我所告訴你的死人，為我招上來。',
    '撒上28:9 婦人對他說：你知道掃羅從國中剪除交鬼的和行巫術的。你為何陷害我的性命，使我死呢﹖',
    '撒上28:10 掃羅向婦人指著耶和華起誓說：我指著永生的耶和華起誓，你必不因這事受刑。',
    '撒上28:11 婦人說：我為你招誰上來呢﹖回答說：為我招撒母耳上來。',
    '撒上28:12 婦人看見撒母耳，就大聲呼叫，對掃羅說：你是掃羅，為什麼欺哄我呢﹖',
    '撒上28:13 王對婦人說：不要懼怕，你看見了什麼呢﹖婦人對掃羅說：我看見有神從地裡上來。',
    '撒上28:14 掃羅說：他是怎樣的形狀﹖婦人說：有一個老人上來，身穿長衣。掃羅知道是撒母耳，就屈身，臉伏於地下拜。',
    '撒上28:15 撒母耳對掃羅說：你為什麼攪擾我，招我上來呢﹖掃羅回答說：我甚窘急；因為非利士人攻擊我，神也離開我，不再藉先知或夢回答我。因此請你上來，好指示我應當怎樣行。',
    '撒上28:16 撒母耳說：耶和華已經離開你，且與你為敵，你何必問我呢﹖',
    '撒上28:17 耶和華照他藉我說的話，已經從你手裡奪去國權，賜與別人，就是大衛。',
    '撒上28:18 因你沒有聽從耶和華的命令；他惱怒亞瑪力人，你沒有滅絕他們，所以今日耶和華向你這樣行，',
    '撒上28:19 並且耶和華必將你和以色列人交在非利士人的手裡。明日你和你眾子必與我在一處了；耶和華必將以色列的軍兵交在非利士人手裡。',
    '撒上28:20 掃羅猛然仆倒，挺身在地，因撒母耳的話甚是懼怕；那一晝一夜沒有吃什麼，就毫無氣力。',
    '撒上28:21 婦人到掃羅面前，見他極其驚恐，對他說：婢女聽從你的話，不顧惜自己的性命，遵從你所吩咐的。',
    '撒上28:22 現在求你聽婢女的話，容我在你面前擺上一點食物，你吃了，可以有氣力行路。',
    '撒上28:23 掃羅不肯，說：我不吃。但他的僕人和婦人再三勸他，他才聽了他們的話，從地上起來，坐在床上。',
    '撒上28:24 婦人急忙將家裡的一隻肥牛犢宰了，又拿麵摶成無酵餅烤了，',
    '撒上28:25 擺在掃羅和他僕人面前。他們吃完，當夜就起身走了。',
    '撒上29:1 非利士人將他們的軍旅聚到亞弗；以色列人在耶斯列的泉旁安營。',
    '撒上29:2 非利士人的首領各率軍隊，或百或千，挨次前進；大衛和跟隨他的人同著亞吉跟在後邊。',
    '撒上29:3 非利士人的首領說：這些希伯來人在這裡做什麼呢﹖亞吉對他們說：這不是以色列王掃羅的臣子大衛嗎﹖他在我這裡有些年日了。自從他投降我直到今日，我未曾見他有過錯。',
    '撒上29:4 非利士人的首領向亞吉發怒，對他說：你要叫這人回你所安置他的地方，不可叫他同我們出戰，恐怕他在陣上反為我們的敵人。他用什麼與他主人復和呢﹖豈不是用我們這些人的首級嗎﹖',
    '撒上29:5 從前以色列的婦女跳舞唱和說：掃羅殺死千千，大衛殺死萬萬，所說的不是這個大衛嗎﹖',
    '撒上29:6 亞吉叫大衛來，對他說：我指著永生的耶和華起誓，你是正直人。你隨我在軍中出入，我看你甚好。自從你投奔我到如今，我未曾見你有什麼過失；只是眾首領不喜悅你。',
    '撒上29:7 現在你可以平平安安地回去，免得非利士人的首領不歡喜你。',
    '撒上29:8 大衛對亞吉說：我做了什麼呢﹖自從僕人到你面前，直到今日，你查出我有什麼過錯，使我不去攻擊主─我王的仇敵呢﹖',
    '撒上29:9 亞吉說：我知道你在我眼前是好人，如同神的使者一般；只是非利士人的首領說：這人不可同我們出戰。',
    '撒上29:10 故此你和跟隨你的人，就是你本主的僕人，要明日早晨起來，等到天亮回去吧！',
    '撒上29:11 於是大衛和跟隨他的人早晨起來，回往非利士地去。非利士人也上耶斯列去了。',
    '撒上30:1 第三日，大衛和跟隨他的人到了洗革拉。亞瑪力人已經侵奪南地，攻破洗革拉，用火焚燒，',
    '撒上30:2 擄了城內的婦女和其中的大小人口，卻沒有殺一個，都帶著走了。',
    '撒上30:3 大衛和跟隨他的人到了那城，不料，城已燒毀，他們的妻子兒女都被擄去了。',
    '撒上30:4 大衛和跟隨他的人就放聲大哭，直哭得沒有氣力。',
    '撒上30:5 大衛的兩個妻─耶斯列人亞希暖和作過拿八妻的迦密人亞比該，也被擄去了。',
    '撒上30:6 大衛甚是焦急，因眾人為自己的兒女苦惱，說：要用石頭打死他。大衛卻倚靠耶和華─他的神，心裡堅固。',
    '撒上30:7 大衛對亞希米勒的兒子祭司亞比亞他說：請你將以弗得拿過來。亞比亞他就將以弗得拿到大衛面前。',
    '撒上30:8 大衛求問耶和華說：我追趕敵軍，追得上追不上呢﹖耶和華說：你可以追，必追得上，都救得回來。',
    '撒上30:9 於是，大衛和跟隨他的六百人來到比梭溪；有不能前去的就留在那裡。',
    '撒上30:10 大衛卻帶著四百人往前追趕，有二百人疲乏，不能過比梭溪，所以留在那裡。',
    '撒上30:11 這四百人在田野遇見一個埃及人，就帶他到大衛面前，給他餅吃，給他水喝，',
    '撒上30:12 又給他一塊無花果餅，兩個葡萄餅。他吃了，就精神復原；因為他三日三夜沒有吃餅，沒有喝水。',
    '撒上30:13 大衛問他說：你是屬誰的﹖你是哪裡的人﹖他回答說：我是埃及的少年人，是亞瑪力人的奴僕；因我三日前患病，我主人就把我撇棄了。',
    '撒上30:14 我們侵奪了基利提的南方和屬猶大的地，並迦勒地的南方，又用火燒了洗革拉。',
    '撒上30:15 大衛問他說：你肯領我們到敵軍那裡不肯﹖他回答說：你要向我指著神起誓，不殺我，也不將我交在我主人手裡，我就領你下到敵軍那裡。',
    '撒上30:16 那人領大衛下去，見他們散在地上，吃喝跳舞，因為從非利士地和猶大地所擄來的財物甚多。',
    '撒上30:17 大衛從黎明直到次日晚上，擊殺他們，除了四百騎駱駝的少年人之外，沒有一個逃脫的。',
    '撒上30:18 亞瑪力人所擄去的財物，大衛全都奪回，並救回他的兩個妻來。',
    '撒上30:19 凡亞瑪力人所擄去的，無論大小、兒女、財物，大衛都奪回來，沒有失落一個。',
    '撒上30:20 大衛所奪來的牛群羊群，跟隨他的人趕在原有的群畜前邊，說：這是大衛的掠物。',
    '撒上30:21 大衛到了那疲乏不能跟隨、留在比梭溪的二百人那裡。他們出來迎接大衛並跟隨的人。大衛前來問他們安。',
    '撒上30:22 跟隨大衛人中的惡人和匪類說：這些人既然沒有和我們同去，我們所奪的財物就不分給他們，只將他們各人的妻子兒女給他們，使他們帶去就是了。',
    '撒上30:23 大衛說：弟兄們，耶和華所賜給我們的，不可不分給他們；因為他保佑我們，將那攻擊我們的敵軍交在我們手裡。',
    '撒上30:24 這事誰肯依從你們呢﹖上陣的得多少，看守器具的也得多少；應當大家平分。',
    '撒上30:25 大衛定此為以色列的律例典章，從那日直到今日。',
    '撒上30:26 大衛到了洗革拉，從掠物中取些送給他朋友猶大的長老，說：這是從耶和華仇敵那裡奪來的，送你們為禮物。',
    '撒上30:27 他送禮物給住伯特利的，南地拉末的，雅提珥的；',
    '撒上30:28 住亞羅珥的，息末的，以實提莫的；',
    '撒上30:29 住拉哈勒的，耶拉篾各城的，基尼各城的；',
    '撒上30:30 住何珥瑪的，歌拉珊的，亞撻的；',
    '撒上30:31 住希伯崙的，並大衛和跟隨他的人素來所到之處的人。',
    '撒上31:1 非利士人與以色列人爭戰。以色列人在非利士人面前逃跑，在基利波有被殺仆倒的。',
    '撒上31:2 非利士人緊追掃羅和他兒子們，就殺了掃羅的兒子約拿單、亞比拿達、麥基舒亞。',
    '撒上31:3 勢派甚大，掃羅被弓箭手追上，射傷甚重，',
    '撒上31:4 就吩咐拿他兵器的人說：你拔出刀來，將我刺死，免得那些未受割禮的人來刺我，凌辱我。但拿兵器的人甚懼怕，不肯刺他；掃羅就自己伏在刀上死了。',
    '撒上31:5 拿兵器的人見掃羅已死，也伏在刀上死了。',
    '撒上31:6 這樣，掃羅和他三個兒子，與拿他兵器的人，以及跟隨他的人，都一同死亡。',
    '撒上31:7 住平原那邊並約但河西的以色列人，見以色列軍兵逃跑，掃羅和他兒子都死了，也就棄城逃跑。非利士人便來住在其中。',
    '撒上31:8 次日，非利士人來剝那被殺之人的衣服，看見掃羅和他三個兒子仆倒在基利波山，',
    '撒上31:9 就割下他的首級，剝了他的軍裝，打發人到（或譯：送到）非利士地的四境，報信與他們廟裡的偶像和眾民；',
    '撒上31:10 又將掃羅的軍裝放在亞斯她錄廟裡，將他的屍身釘在伯珊的城牆上。',
    '撒上31:11 基列雅比的居民聽見非利士人向掃羅所行的事，',
    '撒上31:12 他們中間所有的勇士就起身，走了一夜，將掃羅和他兒子的屍身從伯珊城牆上取下來，送到雅比那裡，用火燒了；',
    '撒上31:13 將他們骸骨葬在雅比的垂絲柳樹下，就禁食七日。',
    '撒下1:1 掃羅死後，大衛擊殺亞瑪力人回來，在洗革拉住了兩天。',
    '撒下1:2 第三天，有一人從掃羅的營裡出來，衣服撕裂，頭蒙灰塵，到大衛面前伏地叩拜。',
    '撒下1:3 大衛問他說：你從哪裡來﹖他說：我從以色列的營裡逃來。',
    '撒下1:4 大衛又問他說：事情怎樣﹖請你告訴我。他回答說：百姓從陣上逃跑，也有許多人仆倒死亡；掃羅和他兒子約拿單也死了。',
    '撒下1:5 大衛問報信的少年人說：你怎麼知道掃羅和他兒子約拿單死了呢﹖',
    '撒下1:6 報信的少年人說：我偶然到基利波山，看見掃羅伏在自己槍上，有戰車、馬兵緊緊地追他。',
    '撒下1:7 他回頭看見我，就呼叫我。我說：我在這裡。',
    '撒下1:8 他問我說：你是什麼人﹖我說：我是亞瑪力人。',
    '撒下1:9 他說：請你來，將我殺死；因為痛苦抓住我，我的生命尚存。',
    '撒下1:10 我準知他仆倒必不能活，就去將他殺死，把他頭上的冠冕、臂上的鐲子拿到我主這裡。',
    '撒下1:11 大衛就撕裂衣服，跟隨他的人也是如此，',
    '撒下1:12 而且悲哀哭號，禁食到晚上，是因掃羅和他兒子約拿單，並耶和華的民以色列家的人，倒在刀下。',
    '撒下1:13 大衛問報信的少年人說：你是哪裡的人﹖他說：我是亞瑪力客人的兒子。',
    '撒下1:14 大衛說：你伸手殺害耶和華的受膏者，怎麼不畏懼呢﹖',
    '撒下1:15 大衛叫了一個少年人來，說：你去殺他吧！',
    '撒下1:16 大衛對他說：你流人血的罪歸到自己的頭上，因為你親口作見證說：我殺了耶和華的受膏者。少年人就把他殺了。',
    '撒下1:17 大衛作哀歌，弔掃羅和他兒子約拿單，',
    '撒下1:18 且吩咐將這歌教導猶大人。這歌名叫弓歌，寫在雅煞珥書上。',
    '撒下1:19 歌中說：以色列啊，你尊榮者在山上被殺！大英雄何竟死亡！',
    '撒下1:20 不要在迦特報告；不要在亞實基倫街上傳揚；免得非利士的女子歡樂；免得未受割禮之人的女子矜誇。',
    '撒下1:21 基利波山哪，願你那裡沒有雨露！願你田地無土產可作供物！因為英雄的盾牌在那裡被污丟棄；掃羅的盾牌彷彿未曾抹油。',
    '撒下1:22 約拿單的弓箭非流敵人的血不退縮；掃羅的刀劍非剖勇士的油不收回。',
    '撒下1:23 掃羅和約拿單─活時相悅相愛，死時也不分離─他們比鷹更快，比獅子還強。',
    '撒下1:24 以色列的女子啊，當為掃羅哭號！他曾使你們穿朱紅色的美衣，使你們衣服有黃金的妝飾。',
    '撒下1:25 英雄何竟在陣上仆倒！約拿單何竟在山上被殺！',
    '撒下1:26 我兄約拿單哪，我為你悲傷！我甚喜悅你！你向我發的愛情奇妙非常，過於婦女的愛情。',
    '撒下1:27 英雄何竟仆倒！戰具何竟滅沒！',
    '撒下2:1 此後，大衛問耶和華說：我上猶大的一個城去可以嗎﹖耶和華說：可以。大衛說：我上哪一個城去呢﹖耶和華說：上希伯崙去。',
    '撒下2:2 於是大衛和他的兩個妻─一個是耶斯列人亞希暖，一個是作過迦密人拿八妻的亞比該─都上那裡去了。',
    '撒下2:3 大衛也將跟隨他的人和他們各人的眷屬一同帶上去，住在希伯崙的城邑中。',
    '撒下2:4 猶大人來到希伯崙，在那裡膏大衛作猶大家的王。有人告訴大衛說：葬埋掃羅的是基列雅比人。',
    '撒下2:5 大衛就差人去見基列雅比人，對他們說：你們厚待你們的主─掃羅，將他葬埋。願耶和華賜福與你們！',
    '撒下2:6 你們既行了這事，願耶和華以慈愛誠實待你們，我也要為此厚待你們。',
    '撒下2:7 現在你們的主─掃羅死了，猶大家已經膏我作他們的王，所以你們要剛強奮勇。',
    '撒下2:8 掃羅的元帥尼珥的兒子押尼珥，曾將掃羅的兒子伊施波設帶過河，到瑪哈念，',
    '撒下2:9 立他作王，治理基列、亞書利、耶斯列、以法蓮、便雅憫，和以色列眾人。',
    '撒下2:10 掃羅的兒子伊施波設登基的時候年四十歲，作以色列王二年；惟獨猶大家歸從大衛。',
    '撒下2:11 大衛在希伯崙作猶大家的王，共七年零六個月。',
    '撒下2:12 尼珥的兒子押尼珥和掃羅的兒子伊施波設的僕人從瑪哈念出來，往基遍去。',
    '撒下2:13 洗魯雅的兒子約押和大衛的僕人也出來，在基遍池旁與他們相遇；一班坐在池這邊，一班坐在池那邊。',
    '撒下2:14 押尼珥對約押說：讓少年人起來，在我們面前戲耍吧！約押說：可以。',
    '撒下2:15 就按著定數起來：屬掃羅兒子伊施波設的便雅憫人過去十二名，大衛的僕人也過去十二名，',
    '撒下2:16 彼此揪頭，用刀刺肋，一同仆倒。所以，那地叫做希利甲哈素林，就在基遍。',
    '撒下2:17 那日的戰事凶猛，押尼珥和以色列人敗在大衛的僕人面前。',
    '撒下2:18 在那裡有洗魯雅的三個兒子：約押、亞比篩、亞撒黑。亞撒黑腳快如野鹿一般；',
    '撒下2:19 亞撒黑追趕押尼珥，直追趕他不偏左右。',
    '撒下2:20 押尼珥回頭說：你是亞撒黑嗎﹖回答說：是。',
    '撒下2:21 押尼珥對他說：你或轉向左轉向右，拿住一個少年人，剝去他的戰衣。亞撒黑卻不肯轉開不追趕他。',
    '撒下2:22 押尼珥又對亞撒黑說：你轉開不追趕我吧！我何必殺你呢﹖若殺你，有什麼臉見你哥哥約押呢﹖',
    '撒下2:23 亞撒黑仍不肯轉開。故此，押尼珥就用槍鐏刺入他的肚腹，甚至槍從背後透出，亞撒黑就在那裡仆倒而死。眾人趕到亞撒黑仆倒而死的地方，就都站住。',
    '撒下2:24 約押和亞比篩追趕押尼珥，日落的時候，到了通基遍曠野的路旁，基亞對面的亞瑪山。',
    '撒下2:25 便雅憫人聚集，跟隨押尼珥站在一個山頂上。',
    '撒下2:26 押尼珥呼叫約押說：刀劍豈可永遠殺人嗎﹖你豈不知終久必有苦楚嗎﹖你要等何時才叫百姓回去、不追趕弟兄呢﹖',
    '撒下2:27 約押說：我指著永生的神起誓：你若不說戲耍的那句話，今日早晨百姓就回去，不追趕弟兄了。',
    '撒下2:28 於是約押吹角，眾民就站住，不再追趕以色列人，也不再打仗了。',
    '撒下2:29 押尼珥和跟隨他的人整夜經過亞拉巴，過約但河，走過畢倫，到了瑪哈念。',
    '撒下2:30 約押追趕押尼珥回來，聚集眾民，見大衛的僕人中缺少了十九個人和亞撒黑。',
    '撒下2:31 但大衛的僕人殺了便雅憫人和跟隨押尼珥的人，共三百六十名。',
    '撒下2:32 眾人將亞撒黑送到伯利恆，葬在他父親的墳墓裡。約押和跟隨他的人走了一夜，天亮的時候到了希伯崙。',
    '撒下3:1 掃羅家和大衛家爭戰許久。大衛家日見強盛；掃羅家日見衰弱。',
    '撒下3:2 大衛在希伯崙得了幾個兒子：長子暗嫩是耶斯列人亞希暖所生的；',
    '撒下3:3 次子基利押（在歷代上三章一節作但以利）是作過迦密人拿八的妻亞比該所生的；三子押沙龍是基述王達買的女兒瑪迦所生的；',
    '撒下3:4 四子亞多尼雅是哈及所生的；五子示法提雅是亞比他所生的；',
    '撒下3:5 六子以特念是大衛的妻以格拉所生的。大衛這六個兒子都是在希伯崙生的。',
    '撒下3:6 掃羅家和大衛家爭戰的時候，押尼珥在掃羅家大有權勢。',
    '撒下3:7 掃羅有一妃嬪，名叫利斯巴，是愛亞的女兒。一日，伊施波設對押尼珥說：你為什麼與我父的妃嬪同房呢﹖',
    '撒下3:8 押尼珥因伊施波設的話就甚發怒，說：我豈是猶大的狗頭呢﹖我恩待你父掃羅的家和他的弟兄、朋友，不將你交在大衛手裡，今日你竟為這婦人責備我嗎﹖',
    '撒下3:9 我若不照著耶和華起誓應許大衛的話行，廢去掃羅的位，建立大衛的位，使他治理以色列和猶大，從但直到別是巴，願神重重地降罰與我！',
    '撒下3:10 併於上節。',
    '撒下3:11 伊施波設懼怕押尼珥，不敢回答一句。',
    '撒下3:12 押尼珥打發人去見大衛，替他說：這國歸誰呢﹖又說：你與我立約，我必幫助你，使以色列人都歸服你。',
    '撒下3:13 大衛說：好！我與你立約。但有一件，你來見我面的時候，若不將掃羅的女兒米甲帶來，必不得見我的面。',
    '撒下3:14 大衛就打發人去見掃羅的兒子伊施波設，說：你要將我的妻米甲歸還我；他是我從前用一百非利士人的陽皮所聘定的。',
    '撒下3:15 伊施波設就打發人去，將米甲從拉億的兒子、他丈夫帕鐵那裡接回來。',
    '撒下3:16 米甲的丈夫跟著他，一面走一面哭，直跟到巴戶琳。押尼珥說：你回去吧！帕鐵就回去了。',
    '撒下3:17 押尼珥對以色列長老說：從前你們願意大衛作王治理你們，',
    '撒下3:18 現在你們可以照心願而行。因為耶和華曾論到大衛說：我必藉我僕人大衛的手，救我民以色列脫離非利士人和眾仇敵的手。',
    '撒下3:19 押尼珥也用這話說給便雅憫人聽，又到希伯崙，將以色列人和便雅憫全家一切所喜悅的事說給大衛聽。',
    '撒下3:20 押尼珥帶著二十個人來到希伯崙見大衛，大衛就為押尼珥和他帶來的人設擺筵席。',
    '撒下3:21 押尼珥對大衛說：我要起身去招聚以色列眾人來見我主我王，與你立約，你就可以照著心願作王。於是大衛送押尼珥去，押尼珥就平平安安地去了。',
    '撒下3:22 約押和大衛的僕人攻擊敵軍，帶回許多的掠物。那時押尼珥不在希伯崙大衛那裡，因大衛已經送他去，他也平平安安地去了。',
    '撒下3:23 約押和跟隨他的全軍到了，就有人告訴約押說：尼珥的兒子押尼珥來見王，王送他去，他也平平安安地去了。',
    '撒下3:24 約押去見王說：你這是做什麼呢﹖押尼珥來見你，你為何送他去，他就蹤影不見了呢﹖',
    '撒下3:25 你當曉得，尼珥的兒子押尼珥來是要誆哄你，要知道你的出入和你一切所行的事。',
    '撒下3:26 約押從大衛那裡出來，就打發人去追趕押尼珥，在西拉井追上他，將他帶回來，大衛卻不知道。',
    '撒下3:27 押尼珥回到希伯崙，約押領他到城門的甕洞，假作要與他說機密話，就在那裡刺透他的肚腹，他便死了。這是報殺他兄弟亞撒黑的仇。',
    '撒下3:28 大衛聽見了，就說：流尼珥的兒子押尼珥的血，這罪在耶和華面前必永不歸我和我的國。',
    '撒下3:29 願流他血的罪歸到約押頭上和他父的全家；又願約押家不斷有患漏症的，長大痲瘋的，架柺而行的，被刀殺死的，缺乏飲食的。',
    '撒下3:30 約押和他兄弟亞比篩殺了押尼珥，是因押尼珥在基遍爭戰的時候殺了他們的兄弟亞撒黑。',
    '撒下3:31 大衛吩咐約押和跟隨他的眾人說：你們當撕裂衣服，腰束麻布，在押尼珥棺前哀哭。大衛王也跟在棺後。',
    '撒下3:32 他們將押尼珥葬在希伯崙。王在押尼珥的墓旁放聲而哭，眾民也都哭了。',
    '撒下3:33 王為押尼珥舉哀，說：押尼珥何竟像愚頑人死呢﹖',
    '撒下3:34 你手未曾捆綁，腳未曾鎖住。你死，如人死在罪孽之輩手下一樣。於是眾民又為押尼珥哀哭。',
    '撒下3:35 日頭未落的時候，眾民來勸大衛吃飯，但大衛起誓說：我若在日頭未落以前吃飯，或吃別物，願神重重地降罰與我！',
    '撒下3:36 眾民知道了就都喜悅。凡王所行的，眾民無不喜悅。',
    '撒下3:37 那日，以色列眾民才知道殺尼珥的兒子押尼珥並非出於王意。',
    '撒下3:38 王對臣僕說：你們豈不知今日以色列人中死了一個作元帥的大丈夫嗎﹖',
    '撒下3:39 我雖然受膏為王，今日還是軟弱；這洗魯雅的兩個兒子比我剛強。願耶和華照著惡人所行的惡報應他。',
    '撒下4:1 掃羅的兒子伊施波設聽見押尼珥死在希伯崙，手就發軟；以色列眾人也都驚惶。',
    '撒下4:2 掃羅的兒子伊施波設有兩個軍長，一名巴拿，一名利甲，是便雅憫支派、比錄人臨門的兒子。比錄也屬便雅憫。',
    '撒下4:3 比錄人早先逃到基他音，在那裡寄居，直到今日。',
    '撒下4:4 掃羅的兒子約拿單有一個兒子名叫米非波設，是瘸腿的。掃羅和約拿單死亡的消息從耶斯列傳到的時候，他才五歲。他乳母抱著他逃跑；因為跑得太急，孩子掉在地上，腿就瘸了。',
    '撒下4:5 一日，比錄人臨門的兩個兒子利甲和巴拿出去，約在午熱的時候到了伊施波設的家；伊施波設正睡午覺。',
    '撒下4:6 他們進了房子，假作要取麥子，就刺透伊施波設的肚腹，逃跑了。',
    '撒下4:7 他們進房子的時候，伊施波設正在臥房裡躺在床上，他們將他殺死，割了他的首級，拿著首級在亞拉巴走了一夜，',
    '撒下4:8 將伊施波設的首級拿到希伯崙見大衛王，說：王的仇敵掃羅曾尋索王的性命。看哪，這是他兒子伊施波設的首級；耶和華今日為我主我王在掃羅和他後裔的身上報了仇。',
    '撒下4:9 大衛對比錄人臨門的兒子利甲和他兄弟巴拿說：我指著救我性命脫離一切苦難、永生的耶和華起誓：',
    '撒下4:10 從前有人報告我說，掃羅死了，他自以為報好消息；我就拿住他，將他殺在洗革拉，這就作了他報消息的賞賜。',
    '撒下4:11 何況惡人將義人殺在他的床上，我豈不向你們討流他血的罪、從世上除滅你們呢﹖',
    '撒下4:12 於是大衛吩咐少年人將他們殺了，砍斷他們的手腳，掛在希伯崙的池旁，卻將伊施波設的首級葬在希伯崙押尼珥的墳墓裡。',
    '撒下5:1 以色列眾支派來到希伯崙見大衛，說：我們原是你的骨肉。',
    '撒下5:2 從前掃羅作我們王的時候，率領以色列人出入的是你；耶和華也曾應許你說：你必牧養我的民以色列，作以色列的君。',
    '撒下5:3 於是以色列的長老都來到希伯崙見大衛王，大衛在希伯崙耶和華面前與他們立約，他們就膏大衛作以色列的王。',
    '撒下5:4 大衛登基的時候年三十歲，在位四十年；',
    '撒下5:5 在希伯崙作猶大王七年零六個月，在耶路撒冷作以色列和猶大王三十三年。',
    '撒下5:6 大衛和跟隨他的人到了耶路撒冷，要攻打住那地方的耶布斯人。耶布斯人對大衛說：你若不趕出瞎子、瘸子，必不能進這地方；心裡想大衛決不能進去。',
    '撒下5:7 然而大衛攻取錫安的保障，就是大衛的城。',
    '撒下5:8 當日，大衛說：誰攻打耶布斯人，當上水溝攻打我心裡所恨惡的瘸子、瞎子。從此有俗語說：在那裡有瞎子、瘸子，他不能進屋去。',
    '撒下5:9 大衛住在保障裡，給保障起名叫大衛城。大衛又從米羅以裡，周圍築牆。',
    '撒下5:10 大衛日見強盛，因為耶和華─萬軍之神與他同在。',
    '撒下5:11 推羅王希蘭將香柏木運到大衛那裡，又差遣使者和木匠、石匠給大衛建造宮殿。',
    '撒下5:12 大衛就知道耶和華堅立他作以色列王，又為自己的民以色列使他的國興旺。',
    '撒下5:13 大衛離開希伯崙之後，在耶路撒冷又立后妃，又生兒女。',
    '撒下5:14 在耶路撒冷所生的兒子是沙母亞、朔罷、拿單、所羅門、',
    '撒下5:15 益轄、以利書亞、尼斐、雅非亞、',
    '撒下5:16 以利沙瑪、以利雅大、以利法列。',
    '撒下5:17 非利士人聽見人膏大衛作以色列王，非利士眾人就上來尋索大衛；大衛聽見，就下到保障。',
    '撒下5:18 非利士人來了，布散在利乏音谷。',
    '撒下5:19 大衛求問耶和華說：我可以上去攻打非利士人嗎﹖你將他們交在我手裡嗎﹖耶和華說：你可以上去，我必將非利士人交在你手裡。',
    '撒下5:20 大衛來到巴力毘拉心，在那裡擊殺非利士人，說：耶和華在我面前沖破敵人，如同水沖去一般。因此稱那地方為巴力毘拉心。',
    '撒下5:21 非利士人將偶像撇在那裡，大衛和跟隨他的人拿去了。',
    '撒下5:22 非利士人又上來，布散在利乏音谷。',
    '撒下5:23 大衛求問耶和華；耶和華說：不要一直地上去，要轉到他們後頭，從桑林對面攻打他們。',
    '撒下5:24 你聽見桑樹梢上有腳步的聲音，就要急速前去，因為那時耶和華已經在你前頭去攻打非利士人的軍隊。',
    '撒下5:25 大衛就遵著耶和華所吩咐的去行，攻打非利士人，從迦巴直到基色。',
    '撒下6:1 大衛又聚集以色列中所有挑選的人三萬。',
    '撒下6:2 大衛起身，率領跟隨他的眾人前往，要從巴拉猶大將神的約櫃運來；這約櫃就是坐在二基路伯上萬軍之耶和華留名的約櫃。',
    '撒下6:3 他們將神的約櫃從岡上亞比拿達的家裡擡出來，放在新車上；亞比拿達的兩個兒子烏撒和亞希約趕這新車。',
    '撒下6:4 他們將神的約櫃從岡上亞比拿達家裡擡出來的時候，亞希約在櫃前行走。',
    '撒下6:5 大衛和以色列的全家在耶和華面前，用松木製造的各樣樂器和琴、瑟、鼓、鈸、鑼，作樂跳舞。',
    '撒下6:6 到了拿艮的禾場，因為牛失前蹄（或譯：驚跳），烏撒就伸手扶住神的約櫃。',
    '撒下6:7 神耶和華向烏撒發怒，因這錯誤擊殺他，他就死在神的約櫃旁。',
    '撒下6:8 大衛因耶和華擊殺（原文是闖殺）烏撒，心裡愁煩，就稱那地方為毘列斯烏撒，直到今日。',
    '撒下6:9 那日，大衛懼怕耶和華，說：耶和華的約櫃怎可運到我這裡來﹖',
    '撒下6:10 於是大衛不肯將耶和華的約櫃運進大衛的城，卻運到迦特人俄別以東的家中。',
    '撒下6:11 耶和華的約櫃在迦特人俄別以東家中三個月；耶和華賜福給俄別以東和他的全家。',
    '撒下6:12 有人告訴大衛王說：耶和華因為約櫃賜福給俄別以東的家和一切屬他的。大衛就去，歡歡喜喜地將神的約櫃從俄別以東家中擡到大衛的城裡。',
    '撒下6:13 擡耶和華約櫃的人走了六步，大衛就獻牛與肥羊為祭。',
    '撒下6:14 大衛穿著細麻布的以弗得，在耶和華面前極力跳舞。',
    '撒下6:15 這樣，大衛和以色列的全家歡呼吹角，將耶和華的約櫃擡上來。',
    '撒下6:16 耶和華的約櫃進了大衛城的時候，掃羅的女兒米甲從窗戶裡觀看，見大衛王在耶和華面前踴躍跳舞，心裡就輕視他。',
    '撒下6:17 眾人將耶和華的約櫃請進去，安放在所預備的地方，就是在大衛所搭的帳幕裡。大衛在耶和華面前獻燔祭和平安祭。',
    '撒下6:18 大衛獻完了燔祭和平安祭，就奉萬軍之耶和華的名給民祝福，',
    '撒下6:19 並且分給以色列眾人，無論男女，每人一個餅，一塊肉，一個葡萄餅；眾人就各回各家去了。',
    '撒下6:20 大衛回家要給眷屬祝福；掃羅的女兒米甲出來迎接他，說：以色列王今日在臣僕的婢女眼前露體，如同一個輕賤人無恥露體一樣，有好大的榮耀啊！',
    '撒下6:21 大衛對米甲說：這是在耶和華面前；耶和華已揀選我，廢了你父和你父的全家，立我作耶和華民以色列的君，所以我必在耶和華面前跳舞。',
    '撒下6:22 我也必更加卑微，自己看為輕賤。你所說的那些婢女，他們倒要尊敬我。',
    '撒下6:23 掃羅的女兒米甲，直到死日，沒有生養兒女。',
    '撒下7:1 王住在自己宮中，耶和華使他安靖，不被四圍的仇敵擾亂。',
    '撒下7:2 那時，王對先知拿單說：看哪，我住在香柏木的宮中，神的約櫃反在幔子裡。',
    '撒下7:3 拿單對王說：你可以照你的心意而行，因為耶和華與你同在。',
    '撒下7:4 當夜，耶和華的話臨到拿單說：',
    '撒下7:5 你去告訴我僕人大衛，說耶和華如此說：你豈可建造殿宇給我居住呢﹖',
    '撒下7:6 自從我領以色列人出埃及直到今日，我未曾住過殿宇，常在會幕和帳幕中行走。',
    '撒下7:7 凡我同以色列人所走的地方，我何曾向以色列一支派的士師，就是我吩咐牧養我民以色列的說：你們為何不給我建造香柏木的殿宇呢﹖',
    '撒下7:8 現在，你要告訴我僕人大衛，說萬軍之耶和華如此說：我從羊圈中將你召來，叫你不再跟從羊群，立你作我民以色列的君。',
    '撒下7:9 你無論往哪裡去，我常與你同在，剪除你的一切仇敵。我必使你得大名，好像世上大大有名的人一樣。',
    '撒下7:10 我必為我民以色列選定一個地方，栽培他們，使他們住自己的地方，不再遷移；凶惡之子也不像從前擾害他們，',
    '撒下7:11 並不像我命士師治理我民以色列的時候一樣。我必使你安靖，不被一切仇敵擾亂，並且我─耶和華應許你，必為你建立家室。',
    '撒下7:12 你壽數滿足、與你列祖同睡的時候，我必使你的後裔接續你的位；我也必堅定他的國。',
    '撒下7:13 他必為我的名建造殿宇；我必堅定他的國位，直到永遠。',
    '撒下7:14 我要作他的父，他要作我的子；他若犯了罪，我必用人的杖責打他，用人的鞭責罰他。',
    '撒下7:15 但我的慈愛仍不離開他，像離開在你面前所廢棄的掃羅一樣。',
    '撒下7:16 你的家和你的國必在我（原文是你）面前永遠堅立。你的國位也必堅定，直到永遠。',
    '撒下7:17 拿單就按這一切話，照這默示，告訴大衛。',
    '撒下7:18 於是大衛王進去，坐在耶和華面前，說：主耶和華啊，我是誰﹖我的家算什麼﹖你竟使我到這地步呢﹖',
    '撒下7:19 主耶和華啊，這在你眼中還看為小，又應許你僕人的家至於久遠。主耶和華啊，這豈是人所常遇的事嗎﹖',
    '撒下7:20 主耶和華啊，我還有何言可以對你說呢﹖因為你知道你的僕人。',
    '撒下7:21 你行這大事使僕人知道，是因你所應許的話，也是照你的心意。',
    '撒下7:22 主耶和華啊，你本為大，照我們耳中聽見，沒有可比你的；除你以外再無神。',
    '撒下7:23 世上有何民能比你的民以色列呢﹖你從埃及救贖他們作自己的子民，又在你贖出來的民面前行大而可畏的事，驅逐列邦人和他們的神，顯出你的大名。',
    '撒下7:24 你曾堅立你的民以色列作你的子民，直到永遠；你─耶和華也作了他們的神。',
    '撒下7:25 耶和華神啊，你所應許僕人和僕人家的話，求你堅定，直到永遠；照你所說的而行。',
    '撒下7:26 願人永遠尊你的名為大，說：萬軍之耶和華是治理以色列的神。這樣，你僕人大衛的家必在你面前堅立。',
    '撒下7:27 萬軍之耶和華─以色列的神啊，因你啟示你的僕人說：我必為你建立家室，所以僕人大膽向你如此祈禱。',
    '撒下7:28 主耶和華啊，惟有你是神。你的話是真實的；你也應許將這福氣賜給僕人。',
    '撒下7:29 現在求你賜福與僕人的家，可以永存在你面前。主耶和華啊，這是你所應許的。願你永遠賜福與僕人的家！',
    '撒下8:1 此後，大衛攻打非利士人，把他們治服，從他們手下奪取了京城的權柄（原文是母城的嚼環）；',
    '撒下8:2 又攻打摩押人，使他們躺臥在地上，用繩量一量：量二繩的殺了，量一繩的存留。摩押人就歸服大衛，給他進貢。',
    '撒下8:3 瑣巴王利合的兒子哈大底謝往大河去，要奪回他的國權。大衛就攻打他，',
    '撒下8:4 擒拿了他的馬兵一千七百，步兵二萬，將拉戰車的馬砍斷蹄筋，但留下一百輛車的馬。',
    '撒下8:5 大馬色的亞蘭人來幫助瑣巴王哈大底謝，大衛就殺了亞蘭人二萬二千。',
    '撒下8:6 於是大衛在大馬色的亞蘭地設立防營，亞蘭人就歸服他，給他進貢。大衛無論往哪裡去，耶和華都使他得勝。',
    '撒下8:7 他奪了哈大底謝臣僕所拿的金盾牌，帶到耶路撒冷。',
    '撒下8:8 大衛王又從屬哈大底謝的比他和比羅他城中奪取了許多的銅。',
    '撒下8:9 哈馬王陀以聽見大衛殺敗哈大底謝的全軍，',
    '撒下8:10 就打發他兒子約蘭去見大衛王，問他的安，為他祝福，因為他殺敗了哈大底謝（原來陀以與哈大底謝常常爭戰）。約蘭帶了金銀銅的器皿來，',
    '撒下8:11 大衛王將這些器皿和他治服各國所得來的金銀都分別為聖，獻給耶和華，',
    '撒下8:12 就是從亞蘭、摩押、亞捫、非利士、亞瑪力人所得來的，以及從瑣巴王利合的兒子哈大底謝所掠之物。',
    '撒下8:13 大衛在鹽谷擊殺了亞蘭（或譯：以東，見詩篇六十篇詩題）一萬八千人回來，就得了大名；',
    '撒下8:14 又在以東全地設立防營，以東人就都歸服大衛。大衛無論往哪裡去，耶和華都使他得勝。',
    '撒下8:15 大衛作以色列眾人的王，又向眾民秉公行義。',
    '撒下8:16 洗魯雅的兒子約押作元帥；亞希律的兒子約沙法作史官；',
    '撒下8:17 亞希突的兒子撒督和亞比亞他的兒子亞希米勒作祭司長；西萊雅作書記；',
    '撒下8:18 耶何耶大的兒子比拿雅統轄基利提人和比利提人。大衛的眾子都作領袖。',
    '撒下9:1 大衛問說：掃羅家還有剩下的人沒有﹖我要因約拿單的緣故向他施恩。',
    '撒下9:2 掃羅家有一個僕人，名叫洗巴，有人叫他來見大衛，王問他說：你是洗巴嗎？回答說：僕人是。',
    '撒下9:3 王說：掃羅家還有人沒有﹖我要照神的慈愛恩待他。洗巴對王說：還有約拿單的一個兒子，是瘸腿的。',
    '撒下9:4 王說：他在哪裡﹖洗巴對王說：他在羅底巴，亞米利的兒子瑪吉家裡。',
    '撒下9:5 於是大衛王打發人去，從羅底巴亞米利的兒子瑪吉家裡召了他來。',
    '撒下9:6 掃羅的孫子、約拿單的兒子米非波設來見大衛，伏地叩拜。大衛說：米非波設！米非波設說：僕人在此。',
    '撒下9:7 大衛說：你不要懼怕，我必因你父親約拿單的緣故施恩與你，將你祖父掃羅的一切田地都歸還你；你也可以常與我同席吃飯。',
    '撒下9:8 米非波設又叩拜，說：僕人算什麼，不過如死狗一般，竟蒙王這樣眷顧！',
    '撒下9:9 王召了掃羅的僕人洗巴來，對他說：我已將屬掃羅和他的一切家產都賜給你主人的兒子了。',
    '撒下9:10 你和你的眾子、僕人要為你主人的兒子米非波設耕種田地，把所產的拿來供他食用；他卻要常與我同席吃飯。洗巴有十五個兒子，二十個僕人。',
    '撒下9:11 洗巴對王說：凡我主我王吩咐僕人的，僕人都必遵行。王又說：米非波設必與我同席吃飯，如王的兒子一樣。',
    '撒下9:12 米非波設有一個小兒子，名叫米迦。凡住在洗巴家裡的人都作了米非波設的僕人。',
    '撒下9:13 於是米非波設住在耶路撒冷，常與王同席吃飯。他兩腿都是瘸的。',
    '撒下10:1 此後，亞捫人的王死了，他兒子哈嫩接續他作王。',
    '撒下10:2 大衛說：我要照哈嫩的父親拿轄厚待我的恩典厚待哈嫩。於是大衛差遣臣僕，為他喪父安慰他。大衛的臣僕到了亞捫人的境內。',
    '撒下10:3 但亞捫人的首領對他們的主哈嫩說：大衛差人來安慰你，你想他是尊敬你父親嗎﹖他差臣僕來不是詳察窺探、要傾覆這城嗎﹖',
    '撒下10:4 哈嫩便將大衛臣僕的鬍鬚剃去一半，又割斷他們下半截的衣服，使他們露出下體，打發他們回去。',
    '撒下10:5 有人告訴大衛，他就差人去迎接他們，（因為他們甚覺羞恥），告訴他們說：可以住在耶利哥，等到鬍鬚長起再回來。',
    '撒下10:6 亞捫人知道大衛憎惡他們，就打發人去，招募伯利合的亞蘭人和瑣巴的亞蘭人，步兵二萬，與瑪迦王的人一千、陀伯人一萬二千。',
    '撒下10:7 大衛聽見了，就差派約押統帶勇猛的全軍出去。',
    '撒下10:8 亞捫人出來，在城門前擺陣；瑣巴與利合的亞蘭人、陀伯人，並瑪迦人，另在郊野擺陣。',
    '撒下10:9 約押看見敵人在他前後擺陣，就從以色列軍中挑選精兵，使他們對著亞蘭人擺陣。',
    '撒下10:10 其餘的兵交與他兄弟亞比篩，對著亞捫人擺陣。',
    '撒下10:11 約押對亞比篩說：亞蘭人若強過我，你就來幫助我；亞捫人若強過你，我就去幫助你。',
    '撒下10:12 我們都當剛強，為本國的民和神的城邑作大丈夫。願耶和華憑他的意旨而行！',
    '撒下10:13 於是，約押和跟隨他的人前進攻打亞蘭人；亞蘭人在約押面前逃跑。',
    '撒下10:14 亞捫人見亞蘭人逃跑，他們也在亞比篩面前逃跑進城。約押就離開亞捫人那裡，回耶路撒冷去了。',
    '撒下10:15 亞蘭人見自己被以色列人打敗，就又聚集。',
    '撒下10:16 哈大底謝差遣人，將大河那邊的亞蘭人調來；他們到了希蘭，哈大底謝的將軍朔法率領他們。',
    '撒下10:17 有人告訴大衛，他就聚集以色列眾人，過約但河，來到希蘭。亞蘭人迎著大衛擺陣，與他打仗。',
    '撒下10:18 亞蘭人在以色列人面前逃跑；大衛殺了亞蘭七百輛戰車的人，四萬馬兵，又殺了亞蘭的將軍朔法。',
    '撒下10:19 屬哈大底謝的諸王見自己被以色列人打敗，就與以色列人和好，歸服他們。於是亞蘭人不敢再幫助亞捫人了。',
    '撒下11:1 過了一年，到列王出戰的時候，大衛又差派約押，率領臣僕和以色列眾人出戰。他們就打敗亞捫人，圍攻拉巴。大衛仍住在耶路撒冷。',
    '撒下11:2 一日，太陽平西，大衛從床上起來，在王宮的平頂上遊行，看見一個婦人沐浴，容貌甚美，',
    '撒下11:3 大衛就差人打聽那婦人是誰。有人說：他是以連的女兒，赫人烏利亞的妻拔示巴。',
    '撒下11:4 大衛差人去，將婦人接來；那時他的月經才得潔淨。他來了，大衛與他同房，他就回家去了。',
    '撒下11:5 於是他懷了孕，打發人去告訴大衛說：我懷了孕。',
    '撒下11:6 大衛差人到約押那裡，說：你打發赫人烏利亞到我這裡來。約押就打發烏利亞去見大衛。',
    '撒下11:7 烏利亞來了，大衛問約押好，也問兵好，又問爭戰的事怎樣。',
    '撒下11:8 大衛對烏利亞說：你回家去，洗洗腳吧！烏利亞出了王宮，隨後王送他一分食物。',
    '撒下11:9 烏利亞卻和他主人的僕人一同睡在宮門外，沒有回家去。',
    '撒下11:10 有人告訴大衛說：烏利亞沒有回家去。大衛就問烏利亞說：你從遠路上來，為什麼不回家去呢﹖',
    '撒下11:11 烏利亞對大衛說：約櫃和以色列與猶大兵都住在棚裡，我主約押和我主（或譯：王）的僕人都在田野安營，我豈可回家吃喝、與妻子同寢呢﹖我敢在王面前起誓（原文是我指著王和王的性命起誓）：我決不行這事！',
    '撒下11:12 大衛吩咐烏利亞說：你今日仍住在這裡，明日我打發你去。於是烏利亞那日和次日住在耶路撒冷。',
    '撒下11:13 大衛召了烏利亞來，叫他在自己面前吃喝，使他喝醉。到了晚上，烏利亞出去與他主的僕人一同住宿，還沒有回到家裡去。',
    '撒下11:14 次日早晨，大衛寫信與約押，交烏利亞隨手帶去。',
    '撒下11:15 信內寫著說：要派烏利亞前進，到陣勢極險之處，你們便退後，使他被殺。',
    '撒下11:16 約押圍城的時候，知道敵人哪裡有勇士，便將烏利亞派在那裡。',
    '撒下11:17 城裡的人出來和約押打仗；大衛的僕人中有幾個被殺的，赫人烏利亞也死了。',
    '撒下11:18 於是，約押差人去將爭戰的一切事告訴大衛，',
    '撒下11:19 又囑咐使者說：你把爭戰的一切事對王說完了，',
    '撒下11:20 王若發怒，問你說：你們打仗為什麼挨近城牆呢﹖豈不知敵人必從城上射箭嗎﹖',
    '撒下11:21 從前打死耶路比設（就是耶路巴力，見士師記九章一節）兒子亞比米勒的是誰呢﹖豈不是一個婦人從城上拋下一塊上磨石來，打在他身上，他就死在提備斯嗎﹖你們為什麼挨近城牆呢﹖你就說：王的僕人─赫人烏利亞也死了。',
    '撒下11:22 使者起身，來見大衛，照著約押所吩咐他的話奏告大衛。',
    '撒下11:23 使者對大衛說：敵人強過我們，出到郊野與我們打仗，我們追殺他們，直到城門口。',
    '撒下11:24 射箭的從城上射王的僕人，射死幾個，赫人烏利亞也死了。',
    '撒下11:25 王向使者說：你告訴約押說：不要因這事愁悶，刀劍或吞滅這人或吞滅那人，沒有一定的；你只管竭力攻城，將城傾覆。可以用這話勉勵約押。',
    '撒下11:26 烏利亞的妻聽見丈夫烏利亞死了，就為他哀哭。',
    '撒下11:27 哀哭的日子過了，大衛差人將他接到宮裡，他就作了大衛的妻，給大衛生了一個兒子。但大衛所行的這事，耶和華甚不喜悅。',
    '撒下12:1 耶和華差遣拿單去見大衛。拿單到了大衛那裡，對他說：在一座城裡有兩個人：一個是富戶，一個是窮人。',
    '撒下12:2 富戶有許多牛群羊群；',
    '撒下12:3 窮人除了所買來養活的一隻小母羊羔之外，別無所有。羊羔在他家裡和他兒女一同長大，吃他所吃的，喝他所喝的，睡在他懷中，在他看來如同女兒一樣。',
    '撒下12:4 有一客人來到這富戶家裡；富戶捨不得從自己的牛群羊群中取一隻預備給客人吃，卻取了那窮人的羊羔，預備給客人吃。',
    '撒下12:5 大衛就甚惱怒那人，對拿單說：我指著永生的耶和華起誓，行這事的人該死！',
    '撒下12:6 他必償還羊羔四倍；因為他行這事，沒有憐恤的心。',
    '撒下12:7 拿單對大衛說：你就是那人！耶和華─以色列的神如此說：我膏你作以色列的王，救你脫離掃羅的手。',
    '撒下12:8 我將你主人的家業賜給你，將你主人的妻交在你懷裡，又將以色列和猶大家賜給你；你若還以為不足，我早就加倍地賜給你。',
    '撒下12:9 你為什麼藐視耶和華的命令，行他眼中看為惡的事呢﹖你借亞捫人的刀殺害赫人烏利亞，又娶了他的妻為妻。',
    '撒下12:10 你既藐視我，娶了赫人烏利亞的妻為妻，所以刀劍必永不離開你的家。',
    '撒下12:11 耶和華如此說：我必從你家中興起禍患攻擊你；我必在你眼前把你的妃嬪賜給別人，他在日光之下就與他們同寢。',
    '撒下12:12 你在暗中行這事，我卻要在以色列眾人面前，日光之下，報應你。',
    '撒下12:13 大衛對拿單說：我得罪耶和華了！拿單說：耶和華已經除掉你的罪，你必不至於死。',
    '撒下12:14 只是你行這事，叫耶和華的仇敵大得褻瀆的機會，故此，你所得的孩子必定要死。',
    '撒下12:15 拿單就回家去了。耶和華擊打烏利亞妻給大衛所生的孩子，使他得重病。',
    '撒下12:16 所以大衛為這孩子懇求神，而且禁食，進入內室，終夜躺在地上。',
    '撒下12:17 他家中的老臣來到他旁邊，要把他從地上扶起來，他卻不肯起來，也不同他們吃飯。',
    '撒下12:18 到第七日，孩子死了。大衛的臣僕不敢告訴他孩子死了，因他們說：孩子還活著的時候，我們勸他，他尚且不肯聽我們的話，若告訴他孩子死了，豈不更加憂傷嗎﹖',
    '撒下12:19 大衛見臣僕彼此低聲說話，就知道孩子死了，問臣僕說：孩子死了嗎﹖他們說：死了。',
    '撒下12:20 大衛就從地上起來，沐浴，抹膏，換了衣裳，進耶和華的殿敬拜；然後回宮，吩咐人擺飯，他便吃了。',
    '撒下12:21 臣僕問他說：你所行的是什麼意思﹖孩子活著的時候，你禁食哭泣；孩子死了，你倒起來吃飯。',
    '撒下12:22 大衛說：孩子還活著，我禁食哭泣；因為我想，或者耶和華憐恤我，使孩子不死也未可知。',
    '撒下12:23 孩子死了，我何必禁食，我豈能使他返回呢﹖我必往他那裡去，他卻不能回我這裡來。',
    '撒下12:24 大衛安慰他的妻拔示巴，與他同寢，他就生了兒子，給他起名叫所羅門。耶和華也喜愛他，',
    '撒下12:25 就藉先知拿單賜他一個名字，叫耶底底亞，因為耶和華愛他。',
    '撒下12:26 約押攻取亞捫人的京城拉巴。',
    '撒下12:27 約押打發使者去見大衛，說：我攻打拉巴，取其水城。',
    '撒下12:28 現在你要聚集其餘的軍兵來，安營圍攻這城，恐怕我取了這城，人就以我的名叫這城。',
    '撒下12:29 於是大衛聚集眾軍，往拉巴去攻城，就取了這城，',
    '撒下12:30 奪了亞捫人之王所戴的金冠冕（王：或譯瑪勒堪；瑪勒堪就是米勒公，又名摩洛，亞捫族之神名），其上的金子重一他連得，又嵌著寶石。人將這冠冕戴在大衛頭上。大衛從城裡奪了許多財物，',
    '撒下12:31 將城裡的人拉出來，放在鋸下，或鐵耙下，或鐵斧下，或叫他經過磚窰（或譯：強他們用鋸，或用打糧食的鐵器，或用鐵斧做工，或使在磚窰裡服役）；大衛待亞捫各城的居民都是如此。其後，大衛和眾軍都回耶路撒冷去了。',
    '撒下13:1 大衛的兒子押沙龍有一個美貌的妹子，名叫他瑪。大衛的兒子暗嫩愛他。',
    '撒下13:2 暗嫩為他妹子他瑪憂急成病。他瑪還是處女，暗嫩以為難向他行事。',
    '撒下13:3 暗嫩有一個朋友，名叫約拿達，是大衛長兄示米亞的兒子。這約拿達為人極其狡猾。',
    '撒下13:4 他問暗嫩說：王的兒子啊，為何一天比一天瘦弱呢﹖請你告訴我。暗嫩回答說：我愛我兄弟押沙龍的妹子他瑪。',
    '撒下13:5 約拿達說：你不如躺在床上裝病；你父親來看你，就對他說：求父叫我妹子他瑪來，在我眼前預備食物，遞給我吃，使我看見，好從他手裡接過來吃。',
    '撒下13:6 於是暗嫩躺臥裝病。王來看他，他對王說：求父叫我妹子他瑪來，在我眼前為我做兩個餅，我好從他手裡接過來吃。',
    '撒下13:7 大衛就打發人到宮裡，對他瑪說：你往你哥哥暗嫩的屋裡去，為他預備食物。',
    '撒下13:8 他瑪就到他哥哥暗嫩的屋裡；暗嫩正躺臥。他瑪摶麵，在他眼前做餅，且烤熟了，',
    '撒下13:9 在他面前將餅從鍋裡倒出來，他卻不肯吃，便說：眾人離開我出去吧！眾人就都離開他，出去了。',
    '撒下13:10 暗嫩對他瑪說：你把食物拿進臥房，我好從你手裡接過來吃。他瑪就把所做的餅拿進臥房，到他哥哥暗嫩那裡，',
    '撒下13:11 拿著餅上前給他吃，他便拉住他瑪，說：我妹妹，你來與我同寢。',
    '撒下13:12 他瑪說：我哥哥，不要玷辱我。以色列人中不當這樣行，你不要做這醜事；',
    '撒下13:13 你玷辱了我，我何以掩蓋我的羞恥呢﹖你在以色列中也成了愚妄人。你可以求王，他必不禁止我歸你。',
    '撒下13:14 但暗嫩不肯聽他的話，因比他力大，就玷辱他，與他同寢。',
    '撒下13:15 隨後，暗嫩極其恨他，那恨他的心比先前愛他的心更甚，對他說：你起來，去吧！',
    '撒下13:16 他瑪說：不要這樣！你趕出我去的這罪比你才行的更重！但暗嫩不肯聽他的話，',
    '撒下13:17 就叫伺候自己的僕人來，說：將這個女子趕出去！他一出去，你就關門，上閂。',
    '撒下13:18 那時他瑪穿著彩衣，因為沒有出嫁的公主都是這樣穿。暗嫩的僕人就把他趕出去，關門上閂。',
    '撒下13:19 他瑪把灰塵撒在頭上，撕裂所穿的彩衣，以手抱頭，一面行走，一面哭喊。',
    '撒下13:20 他胞兄押沙龍問他說：莫非你哥哥暗嫩與你親近了嗎﹖我妹妹，暫且不要作聲，他是你的哥哥，不要將這事放在心上。他瑪就孤孤單單地住在他胞兄押沙龍家裡。',
    '撒下13:21 大衛王聽見這事，就甚發怒。',
    '撒下13:22 押沙龍並不和他哥哥暗嫩說好說歹；因為暗嫩玷辱他妹妹他瑪，所以押沙龍恨惡他。',
    '撒下13:23 過了二年，在靠近以法蓮的巴力夏瑣有人為押沙龍剪羊毛；押沙龍請王的眾子與他同去。',
    '撒下13:24 押沙龍來見王，說：現在有人為僕人剪羊毛，請王和王的臣僕與僕人同去。',
    '撒下13:25 王對押沙龍說：我兒，我們不必都去，恐怕使你耗費太多。押沙龍再三請王，王仍是不肯去，只為他祝福。',
    '撒下13:26 押沙龍說：王若不去，求王許我哥哥暗嫩同去。王說：何必要他去呢﹖',
    '撒下13:27 押沙龍再三求王，王就許暗嫩和王的眾子與他同去。',
    '撒下13:28 押沙龍吩咐僕人說：你們注意，看暗嫩飲酒暢快的時候，我對你們說殺暗嫩，你們便殺他，不要懼怕。這不是我吩咐你們的嗎﹖你們只管壯膽奮勇！',
    '撒下13:29 押沙龍的僕人就照押沙龍所吩咐的，向暗嫩行了。王的眾子都起來，各人騎上騾子，逃跑了。',
    '撒下13:30 他們還在路上，有風聲傳到大衛那裡，說：押沙龍將王的眾子都殺了，沒有留下一個。',
    '撒下13:31 王就起來，撕裂衣服，躺在地上。王的臣僕也都撕裂衣服，站在旁邊。',
    '撒下13:32 大衛的長兄，示米亞的兒子約拿達說：我主，不要以為王的眾子─少年人都殺了，只有暗嫩一個人死了。自從暗嫩玷辱押沙龍妹子他瑪的那日，押沙龍就定意殺暗嫩了。',
    '撒下13:33 現在，我主我王，不要把這事放在心上，以為王的眾子都死了，只有暗嫩一個人死了。',
    '撒下13:34 押沙龍逃跑了。守望的少年人舉目觀看，見有許多人從山坡的路上來。',
    '撒下13:35 約拿達對王說：看哪，王的眾子都來了，果然與你僕人所說的相合。',
    '撒下13:36 話才說完，王的眾子都到了，放聲大哭；王和臣僕也都哭得甚慟。',
    '撒下13:37 押沙龍逃到基述王亞米忽的兒子達買那裡去了。大衛天天為他兒子悲哀。',
    '撒下13:38 押沙龍逃到基述，在那裡住了三年。',
    '撒下13:39 暗嫩死了以後，大衛王得了安慰，心裡切切想念押沙龍。',
    '撒下14:1 洗魯雅的兒子約押，知道王心裡想念押沙龍，',
    '撒下14:2 就打發人往提哥亞去，從那裡叫了一個聰明的婦人來，對他說：請你假裝居喪的，穿上孝衣，不要用膏抹身，要裝作為死者許久悲哀的婦人；',
    '撒下14:3 進去見王，對王如此如此說。於是約押將當說的話教導了婦人。',
    '撒下14:4 提哥亞婦人到王面前，伏地叩拜，說：王啊，求你拯救！',
    '撒下14:5 王問他說：你有什麼事呢﹖回答說：婢女實在是寡婦，我丈夫死了。',
    '撒下14:6 我有兩個兒子，一日在田間爭鬥，沒有人解勸，這個就打死那個。',
    '撒下14:7 現在全家的人都起來攻擊婢女，說：你將那打死兄弟的交出來，我們好治死他，償他打死兄弟的命，滅絕那承受家業的。這樣，他們要將我剩下的炭火滅盡，不與我丈夫留名留後在世上。',
    '撒下14:8 王對婦人說：你回家去吧！我必為你下令。',
    '撒下14:9 提哥亞婦人又對王說：我主我王，願這罪歸我和我父家，與王和王的位無干。',
    '撒下14:10 王說：凡難為你的，你就帶他到我這裡來，他必不再攪擾你。',
    '撒下14:11 婦人說：願王記念耶和華─你的神，不許報血仇的人施行滅絕，恐怕他們滅絕我的兒子。王說：我指著永生的耶和華起誓：你的兒子連一根頭髮也不致落在地上。',
    '撒下14:12 婦人說：求我主我王容婢女再說一句話。王說：你說吧！',
    '撒下14:13 婦人說：王為何也起意要害神的民呢﹖王不使那逃亡的人回來，王的這話就是自證己錯了！',
    '撒下14:14 我們都是必死的，如同水潑在地上，不能收回。神並不奪取人的性命，乃設法使逃亡的人不致成為趕出、回不來的。',
    '撒下14:15 我來將這話告訴我主我王，是因百姓使我懼怕。婢女想，不如將這話告訴王，或者王成就婢女所求的。',
    '撒下14:16 人要將我和我兒子從神的地業上一同除滅，王必應允救我脫離他的手。',
    '撒下14:17 婢女又想，我主我王的話必安慰我；因為我主我王能辨別是非，如同神的使者一樣。惟願耶和華─你的神與你同在！',
    '撒下14:18 王對婦人說：我要問你一句話，你一點不要瞞我。婦人說：願我主我王說。',
    '撒下14:19 王說：你這些話莫非是約押的主意嗎﹖婦人說：我敢在我主我王面前起誓：王的話正對，不偏左右，是王的僕人約押吩咐我的，這些話是他教導我的。',
    '撒下14:20 王的僕人約押如此行，為要挽回這事。我主的智慧卻如神使者的智慧，能知世上一切事。',
    '撒下14:21 王對約押說：我應允你這事。你可以去，把那少年人押沙龍帶回來。',
    '撒下14:22 約押就面伏於地叩拜，祝謝於王，又說：王既應允僕人所求的，僕人今日知道在我主我王眼前蒙恩了。',
    '撒下14:23 於是約押起身往基述去，將押沙龍帶回耶路撒冷。',
    '撒下14:24 王說：使他回自己家裡去，不要見我的面。押沙龍就回自己家裡去，沒有見王的面。',
    '撒下14:25 以色列全地之中，無人像押沙龍那樣俊美，得人的稱讚，從腳底到頭頂毫無瑕疵。',
    '撒下14:26 他的頭髮甚重，每到年底剪髮一次；所剪下來的，按王的平稱一稱，重二百舍客勒。',
    '撒下14:27 押沙龍生了三個兒子，一個女兒。女兒名叫他瑪，是個容貌俊美的女子。',
    '撒下14:28 押沙龍住在耶路撒冷足有二年，沒有見王的面。',
    '撒下14:29 押沙龍打發人去叫約押來，要託他去見王，約押卻不肯來。第二次打發人去叫他，他仍不肯來。',
    '撒下14:30 所以押沙龍對僕人說：你們看，約押有一塊田，與我的田相近，其中有大麥，你們去放火燒了。押沙龍的僕人就去放火燒了那田。',
    '撒下14:31 於是約押起來，到了押沙龍家裡，問他說：你的僕人為何放火燒了我的田呢﹖',
    '撒下14:32 押沙龍回答約押說：我打發人去請你來，好託你去見王，替我說：我為何從基述回來呢﹖不如仍在那裡。現在要許我見王的面；我若有罪，任憑王殺我就是了。',
    '撒下14:33 於是約押去見王，將這話奏告王，王便叫押沙龍來。押沙龍來見王，在王面前俯伏於地，王就與押沙龍親嘴。',
    '撒下15:1 此後，押沙龍為自己預備車馬，又派五十人在他前頭奔走。',
    '撒下15:2 押沙龍常常早晨起來，站在城門的道旁，凡有爭訟要去求王判斷的，押沙龍就叫他過來，問他說：你是哪一城的人﹖回答說：僕人是以色列某支派的人。',
    '撒下15:3 押沙龍對他說：你的事有情有理，無奈王沒有委人聽你伸訴。',
    '撒下15:4 押沙龍又說：恨不得我作國中的士師！凡有爭訟求審判的到我這裡來，我必秉公判斷。',
    '撒下15:5 若有人近前來要拜押沙龍，押沙龍就伸手拉住他，與他親嘴。',
    '撒下15:6 以色列人中，凡去見王求判斷的，押沙龍都是如此待他們。這樣，押沙龍暗中得了以色列人的心。',
    '撒下15:7 滿了四十年（有作四年的），押沙龍對王說：求你准我往希伯崙去，還我向耶和華所許的願。',
    '撒下15:8 因為僕人住在亞蘭的基述，曾許願說：耶和華若使我再回耶路撒冷，我必事奉他。',
    '撒下15:9 王說：你平平安安地去吧！押沙龍就起身，往希伯崙去了。',
    '撒下15:10 押沙龍打發探子走遍以色列各支派，說：你們一聽見角聲就說：押沙龍在希伯崙作王了！',
    '撒下15:11 押沙龍在耶路撒冷請了二百人與他同去，都是誠誠實實去的，並不知道其中的真情。',
    '撒下15:12 押沙龍獻祭的時候，打發人去將大衛的謀士、基羅人亞希多弗從他本城請了來。於是叛逆的勢派甚大；因為隨從押沙龍的人民，日漸增多。',
    '撒下15:13 有人報告大衛說：以色列人的心都歸向押沙龍了！',
    '撒下15:14 大衛就對耶路撒冷跟隨他的臣僕說：我們要起來逃走，不然都不能躲避押沙龍了；要速速地去，恐怕他忽然來到，加害於我們，用刀殺盡合城的人。',
    '撒下15:15 王的臣僕對王說：我主我王所定的，僕人都願遵行。',
    '撒下15:16 於是王帶著全家的人出去了，但留下十個妃嬪看守宮殿。',
    '撒下15:17 王出去，眾民都跟隨他，到伯墨哈，就住下了。',
    '撒下15:18 王的臣僕都在他面前過去。基利提人、比利提人，就是從迦特跟隨王來的六百人，也都在他面前過去。',
    '撒下15:19 王對迦特人以太說：你是外邦逃來的人，為什麼與我們同去呢﹖你可以回去與新王同住，或者回你本地去吧！',
    '撒下15:20 你來的日子不多，我今日怎好叫你與我們一同飄流、沒有一定的住處呢﹖你不如帶你的弟兄回去吧！願耶和華用慈愛誠實待你。',
    '撒下15:21 以太對王說：我指著永生的耶和華起誓，又敢在王面前起誓：無論生死，王在哪裡，僕人也必在那裡。',
    '撒下15:22 大衛對以太說：你前去過河吧！於是迦特人以太帶著跟隨他的人和所有的婦人孩子，就都過去了。',
    '撒下15:23 本地的人都放聲大哭。眾民盡都過去，王也過了汲淪溪；眾民往曠野去了。',
    '撒下15:24 撒督和擡神約櫃的利未人也一同來了，將神的約櫃放下。亞比亞他上來，等著眾民從城裡出來過去。',
    '撒下15:25 王對撒督說：你將神的約櫃擡回城去。我若在耶和華眼前蒙恩，他必使我回來，再見約櫃和他的居所。',
    '撒下15:26 倘若他說：我不喜悅你，看哪，我在這裡，願他憑自己的意旨待我！',
    '撒下15:27 王又對祭司撒督說：你不是先見嗎﹖你可以安然回城；你兒子亞希瑪斯和亞比亞他的兒子約拿單都可以與你同去。',
    '撒下15:28 我在曠野的渡口那裡等你們報信給我。',
    '撒下15:29 於是撒督和亞比亞他將神的約櫃擡回耶路撒冷，他們就住在那裡。',
    '撒下15:30 大衛蒙頭赤腳上橄欖山，一面上一面哭。跟隨他的人也都蒙頭哭著上去；',
    '撒下15:31 有人告訴大衛說：亞希多弗也在叛黨之中，隨從押沙龍。大衛禱告說：耶和華啊，求你使亞希多弗的計謀變為愚拙！',
    '撒下15:32 大衛到了山頂、敬拜神的地方，見亞基人戶篩，衣服撕裂，頭蒙灰塵來迎接他。',
    '撒下15:33 大衛對他說：你若與我同去，必累贅我；',
    '撒下15:34 你若回城去，對押沙龍說：王啊，我願作你的僕人；我向來作你父親的僕人，現在我也照樣作你的僕人。這樣，你就可以為我破壞亞希多弗的計謀。',
    '撒下15:35 祭司撒督和亞比亞他豈不都在那裡嗎﹖你在王宮裡聽見什麼，就要告訴祭司撒督和亞比亞他。',
    '撒下15:36 撒督的兒子亞希瑪斯，亞比亞他的兒子約拿單，也都在那裡。凡你們所聽見的可以託這二人來報告我。',
    '撒下15:37 於是，大衛的朋友戶篩進了城；押沙龍也進了耶路撒冷。',
    '撒下16:1 大衛剛過山頂，見米非波設的僕人洗巴拉著備好了的兩匹驢，驢上馱著二百麵餅，一百葡萄餅，一百個夏天的果餅，一皮袋酒來迎接他。',
    '撒下16:2 王問洗巴說：你帶這些來是什麼意思呢﹖洗巴說：驢是給王的家眷騎的；麵餅和夏天的果餅是給少年人吃的；酒是給在曠野疲乏人喝的。',
    '撒下16:3 王問說：你主人的兒子在哪裡呢﹖洗巴回答王說：他仍在耶路撒冷，因他說：以色列人今日必將我父的國歸還我。',
    '撒下16:4 王對洗巴說：凡屬米非波設的都歸你了。洗巴說：我叩拜我主我王，願我在你眼前蒙恩。',
    '撒下16:5 大衛王到了巴戶琳，見有一個人出來，是掃羅族基拉的兒子，名叫示每。他一面走一面咒罵，',
    '撒下16:6 又拿石頭砍大衛王和王的臣僕；眾民和勇士都在王的左右。',
    '撒下16:7 示每咒罵說：你這流人血的壞人哪，去吧去吧！',
    '撒下16:8 你流掃羅全家的血，接續他作王；耶和華把這罪歸在你身上，將這國交給你兒子押沙龍。現在你自取其禍，因為你是流人血的人。',
    '撒下16:9 洗魯雅的兒子亞比篩對王說：這死狗豈可咒罵我主我王呢﹖求你容我過去，割下他的頭來。',
    '撒下16:10 王說：洗魯雅的兒子，我與你們有何關涉呢﹖他咒罵是因耶和華吩咐他說：你要咒罵大衛。如此，誰敢說你為什麼這樣行呢﹖',
    '撒下16:11 大衛又對亞比篩和眾臣僕說：我親生的兒子尚且尋索我的性命，何況這便雅憫人呢﹖由他咒罵吧！因為這是耶和華吩咐他的。',
    '撒下16:12 或者耶和華見我遭難，為我今日被這人咒罵，就施恩與我。',
    '撒下16:13 於是大衛和跟隨他的人往前行走。示每在大衛對面山坡，一面行走一面咒罵，又拿石頭砍他，拿土揚他。',
    '撒下16:14 王和跟隨他的眾人疲疲乏乏地到了一個地方，就在那裡歇息歇息。',
    '撒下16:15 押沙龍和以色列眾人來到耶路撒冷；亞希多弗也與他同來。',
    '撒下16:16 大衛的朋友亞基人戶篩去見押沙龍，對他說：願王萬歲！願王萬歲！',
    '撒下16:17 押沙龍問戶篩說：這是你恩待朋友嗎﹖為什麼不與你的朋友同去呢﹖',
    '撒下16:18 戶篩對押沙龍說：不然，耶和華和這民，並以色列眾人所揀選的，我必歸順他，與他同住。',
    '撒下16:19 再者，我當服事誰呢﹖豈不是前王的兒子嗎﹖我怎樣服事你父親，也必照樣服事你。',
    '撒下16:20 押沙龍對亞希多弗說：你們出個主意，我們怎樣行才好﹖',
    '撒下16:21 亞希多弗對押沙龍說：你父所留下看守宮殿的妃嬪，你可以與他們親近。以色列眾人聽見你父親憎惡你，凡歸順你人的手就更堅強。',
    '撒下16:22 於是人為押沙龍在宮殿的平頂上支搭帳棚；押沙龍在以色列眾人眼前，與他父的妃嬪親近。',
    '撒下16:23 那時亞希多弗所出的主意好像人問神的話一樣；他昔日給大衛，今日給押沙龍所出的主意，都是這樣。',
    '撒下17:1 亞希多弗又對押沙龍說：求你准我挑選一萬二千人，今夜我就起身追趕大衛，',
    '撒下17:2 趁他疲乏手軟，我忽然追上他，使他驚惶；跟隨他的民必都逃跑，我就單殺王一人，',
    '撒下17:3 使眾民都歸順你。你所尋找的人既然死了，眾民就如已經歸順你；這樣，也都平安無事了。',
    '撒下17:4 押沙龍和以色列的長老都以這話為美。',
    '撒下17:5 押沙龍說：要召亞基人戶篩來，我們也要聽他怎樣說。',
    '撒下17:6 戶篩到了押沙龍面前，押沙龍向他說：亞希多弗是如此如此說的，我們照著他的話行可以不可以﹖若不可，你就說吧！',
    '撒下17:7 戶篩對押沙龍說：亞希多弗這次所定的謀不善。',
    '撒下17:8 戶篩又說：你知道，你父親和跟隨他的人都是勇士，現在他們心裡惱怒，如同田野丟崽子的母熊一般，而且你父親是個戰士，必不和民一同住宿。',
    '撒下17:9 他現今或藏在坑中或在別處，若有人首先被殺，凡聽見的必說：跟隨押沙龍的民被殺了。',
    '撒下17:10 雖有人膽大如獅子，他的心也必消化；因為以色列人都知道你父親是英雄，跟隨他的人也都是勇士。',
    '撒下17:11 依我之計，不如將以色列眾人─從但直到別是巴，如同海邊的沙那樣多─聚集到你這裡來，你也親自率領他們出戰。',
    '撒下17:12 這樣，我們在何處遇見他，就下到他那裡，如同露水下在地上一般，連他帶跟隨他的人，一個也不留下。',
    '撒下17:13 他若進了哪一座城，以色列眾人必帶繩子去，將那城拉到河裡，甚至連一塊小石頭都不剩下。',
    '撒下17:14 押沙龍和以色列眾人說：亞基人戶篩的計謀比亞希多弗的計謀更好！這是因耶和華定意破壞亞希多弗的良謀，為要降禍與押沙龍。',
    '撒下17:15 戶篩對祭司撒督和亞比亞他說：亞希多弗為押沙龍和以色列的長老所定的計謀是如此如此，我所定的計謀是如此如此。',
    '撒下17:16 現在你們要急速打發人去，告訴大衛說：今夜不可住在曠野的渡口，務要過河，免得王和跟隨他的人都被吞滅。',
    '撒下17:17 那時，約拿單和亞希瑪斯在隱羅結那裡等候，不敢進城，恐怕被人看見。有一個使女出來，將這話告訴他們，他們就去報信給大衛王。',
    '撒下17:18 然而有一個童子看見他們，就去告訴押沙龍。他們急忙跑到巴戶琳某人的家裡；那人院中有一口井，他們就下到井裡。',
    '撒下17:19 那家的婦人用蓋蓋上井口，又在上頭鋪上碎麥，事就沒有洩漏。',
    '撒下17:20 押沙龍的僕人來到那家，問婦人說：亞希瑪斯和約拿單在哪裡﹖婦人說：他們過了河了。僕人找他們，找不著，就回耶路撒冷去了。',
    '撒下17:21 他們走後，二人從井裡上來，去告訴大衛王說：亞希多弗如此如此定計害你，你們務要起來，快快過河。',
    '撒下17:22 於是大衛和跟隨他的人都起來，過約但河。到了天亮，無一人不過約但河的。',
    '撒下17:23 亞希多弗見不依從他的計謀，就備上驢，歸回本城；到了家，留下遺言，便吊死了，葬在他父親的墳墓裡。',
    '撒下17:24 大衛到了瑪哈念，押沙龍和跟隨他的以色列人也都過了約但河。',
    '撒下17:25 押沙龍立亞瑪撒作元帥，代替約押。亞瑪撒是以實瑪利人（又作以色列人）以特拉的兒子。以特拉曾與拿轄的女兒亞比該親近；這亞比該與約押的母親洗魯雅是姊妹。',
    '撒下17:26 押沙龍和以色列人都安營在基列地。',
    '撒下17:27 大衛到了瑪哈念，亞捫族的拉巴人拿轄的兒子朔比，羅底巴人亞米利的兒子瑪吉，基列的羅基琳人巴西萊，',
    '撒下17:28 帶著被、褥、盆、碗、瓦器、小麥、大麥、麥麵、炒穀、豆子、紅豆、炒豆、',
    '撒下17:29 蜂蜜、奶油、綿羊、奶餅，供給大衛和跟隨他的人吃；他們說：民在曠野，必飢渴困乏了。',
    '撒下18:1 大衛數點跟隨他的人，立千夫長、百夫長率領他們。',
    '撒下18:2 大衛打發軍兵出戰，分為三隊：一隊在約押手下，一隊在洗魯雅的兒子、約押兄弟亞比篩手下，一隊在迦特人以太手下。大衛對軍兵說：我必與你們一同出戰。',
    '撒下18:3 軍兵卻說：你不可出戰。若是我們逃跑，敵人必不介意；我們陣亡一半，敵人也不介意。因為你一人強似我們萬人，你不如在城裡預備幫助我們。',
    '撒下18:4 王向他們說：你們以為怎樣好，我就怎樣行。於是王站在城門旁，軍兵或百或千地挨次出去了。',
    '撒下18:5 王囑咐約押、亞比篩、以太說：你們要為我的緣故寬待那少年人押沙龍。王為押沙龍囑咐眾將的話，兵都聽見了。',
    '撒下18:6 兵就出到田野迎著以色列人，在以法蓮樹林裡交戰。',
    '撒下18:7 以色列人敗在大衛的僕人面前；那日陣亡的甚多，共有二萬人。',
    '撒下18:8 因為在那裡四面打仗，死於樹林的比死於刀劍的更多。',
    '撒下18:9 押沙龍偶然遇見大衛的僕人。押沙龍騎著騾子，從大橡樹密枝底下經過，他的頭髮被樹枝繞住，就懸掛起來，所騎的騾子便離他去了。',
    '撒下18:10 有個人看見，就告訴約押說：我看見押沙龍掛在橡樹上了。',
    '撒下18:11 約押對報信的人說：你既看見他，為什麼不將他打死落在地上呢﹖你若打死他，我就賞你十舍客勒銀子，一條帶子。',
    '撒下18:12 那人對約押說：我就是得你一千舍客勒銀子，我也不敢伸手害王的兒子；因為我們聽見王囑咐你和亞比篩並以太說：你們要謹慎，不可害那少年人押沙龍。',
    '撒下18:13 我若妄為害了他的性命，就是你自己也必與我為敵（原來，無論何事都瞞不過王。）',
    '撒下18:14 約押說：我不能與你留連。約押手拿三杆短槍，趁押沙龍在橡樹上還活著，就刺透他的心。',
    '撒下18:15 給約押拿兵器的十個少年人圍繞押沙龍，將他殺死。',
    '撒下18:16 約押吹角，攔阻眾人，他們就回來，不再追趕以色列人。',
    '撒下18:17 他們將押沙龍丟在林中一個大坑裡，上頭堆起一大堆石頭。以色列眾人都逃跑，各回各家去了。',
    '撒下18:18 押沙龍活著的時候，在王谷立了一根石柱，因他說：我沒有兒子為我留名。他就以自己的名稱那石柱叫押沙龍柱，直到今日。',
    '撒下18:19 撒督的兒子亞希瑪斯說：容我跑去，將耶和華向仇敵給王報仇的信息報與王知。',
    '撒下18:20 約押對他說：你今日不可去報信，改日可以報信；因為今日王的兒子死了，所以你不可去報信。',
    '撒下18:21 約押對古示人說：你去將你所看見的告訴王。古示人在約押面前下拜，就跑去了。',
    '撒下18:22 撒督的兒子亞希瑪斯又對約押說：無論怎樣，求你容我隨著古示人跑去。約押說：我兒，你報這信息，既不得賞賜，何必要跑去呢﹖',
    '撒下18:23 他又說：無論怎樣，我要跑去。約押說：你跑去吧！亞希瑪斯就從平原往前跑，跑過古示人去了。',
    '撒下18:24 大衛正坐在城甕裡。守望的人上城門樓的頂上，舉目觀看，見有一個人獨自跑來。',
    '撒下18:25 守望的人就大聲告訴王。王說：他若獨自來，必是報口信的。那人跑得漸漸近了。',
    '撒下18:26 守望的人又見一人跑來，就對守城門的人說：又有一人獨自跑來。王說：這也必是報信的。',
    '撒下18:27 守望的人說：我看前頭人的跑法，好像撒督的兒子亞希瑪斯的跑法一樣。王說：他是個好人，必是報好信息。',
    '撒下18:28 亞希瑪斯向王呼叫說：平安了！就在王面前臉伏於地叩拜，說：耶和華─你的神是應當稱頌的，因他已將那舉手攻擊我主我王的人交給王了。',
    '撒下18:29 王問說：少年人押沙龍平安不平安﹖亞希瑪斯回答說：約押打發王的僕人，那時僕人聽見眾民大聲喧嘩，卻不知道是什麼事。',
    '撒下18:30 王說：你退去，站在旁邊。他就退去，站在旁邊。',
    '撒下18:31 古示人也來到，說：有信息報給我主我王！耶和華今日向一切興起攻擊你的人給你報仇了。',
    '撒下18:32 王問古示人說：少年人押沙龍平安不平安﹖古示人回答說：願我主我王的仇敵，和一切興起要殺害你的人，都與那少年人一樣。',
    '撒下18:33 王就心裡傷慟，上城門樓去哀哭，一面走一面說：我兒押沙龍啊！我兒，我兒押沙龍啊！我恨不得替你死，押沙龍啊，我兒！我兒！',
    '撒下19:1 有人告訴約押說：王為押沙龍哭泣悲哀。',
    '撒下19:2 眾民聽說王為他兒子憂愁，他們得勝的歡樂卻變成悲哀。',
    '撒下19:3 那日眾民暗暗地進城，就如敗陣逃跑、慚愧的民一般。',
    '撒下19:4 王蒙著臉，大聲哭號說：我兒押沙龍啊！押沙龍，我兒，我兒啊！',
    '撒下19:5 約押進去見王，說：你今日使你一切僕人臉面慚愧了！他們今日救了你的性命和你兒女妻妾的性命，',
    '撒下19:6 你卻愛那恨你的人，恨那愛你的人。你今日明明地不以將帥、僕人為念。我今日看明，若押沙龍活著，我們都死亡，你就喜悅了。',
    '撒下19:7 現在你當出去，安慰你僕人的心。我指著耶和華起誓：你若不出去，今夜必無一人與你同在一處；這禍患就比你從幼年到如今所遭的更甚！',
    '撒下19:8 於是王起來，坐在城門口。眾民聽說王坐在城門口，就都到王面前。以色列人已經逃跑，各回各家去了。',
    '撒下19:9 以色列眾支派的人紛紛議論說：王曾救我們脫離仇敵的手，又救我們脫離非利士人的手，現在他躲避押沙龍逃走了。',
    '撒下19:10 我們膏押沙龍治理我們，他已經陣亡。現在為什麼不出一言請王回來呢﹖',
    '撒下19:11 大衛王差人去見祭司撒督和亞比亞他，說：你們當向猶大長老說：以色列眾人已經有話請王回宮，你們為什麼落在他們後頭呢﹖',
    '撒下19:12 你們是我的弟兄，是我的骨肉，為什麼在人後頭請王回來呢﹖',
    '撒下19:13 也要對亞瑪撒說：你不是我的骨肉嗎﹖我若不立你替約押常作元帥，願神重重地降罰與我！',
    '撒下19:14 如此就挽回猶大眾人的心，如同一人的心。他們便打發人去見王，說：請王和王的一切臣僕回來。',
    '撒下19:15 王就回來，到了約但河。猶大人來到吉甲，要去迎接王，請他過約但河。',
    '撒下19:16 巴戶琳的便雅憫人、基拉的兒子示每急忙與猶大人一同下去迎接大衛王。',
    '撒下19:17 跟從示每的有一千便雅憫人，還有掃羅家的僕人洗巴和他十五個兒子，二十個僕人；他們都逿過約但河迎接王。',
    '撒下19:18 有擺渡船過去，渡王的家眷，任王使用。王要過約但河的時候，基拉的兒子示每就俯伏在王面前，',
    '撒下19:19 對王說：我主我王出耶路撒冷的時候，僕人行悖逆的事，現在求我主不要因此加罪與僕人，不要記念，也不要放在心上。',
    '撒下19:20 僕人明知自己有罪，所以約瑟全家之中，今日我首先下來迎接我主我王。',
    '撒下19:21 洗魯雅的兒子亞比篩說：示每既咒罵耶和華的受膏者，不應當治死他嗎﹖',
    '撒下19:22 大衛說：洗魯雅的兒子，我與你們有何關涉，使你們今日與我反對呢﹖今日在以色列中豈可治死人呢﹖我豈不知今日我作以色列的王嗎﹖',
    '撒下19:23 於是王對示每說：你必不死。王就向他起誓。',
    '撒下19:24 掃羅的孫子米非波設也下去迎接王。他自從王去的日子，直到王平平安安地回來，沒有修腳，沒有剃鬍鬚，也沒有洗衣服。',
    '撒下19:25 他來到耶路撒冷迎接王的時候，王問他說：米非波設，你為什麼沒有與我同去呢﹖',
    '撒下19:26 他回答說：我主我王，僕人是瘸腿的。那日我想要備驢騎上，與王同去，無奈我的僕人欺哄了我，',
    '撒下19:27 又在我主我王面前讒毀我。然而我主我王如同神的使者一般，你看怎樣好，就怎樣行吧！',
    '撒下19:28 因為我祖全家的人，在我主我王面前都算為死人，王卻使僕人在王的席上同人吃飯，我現在向王還能辨理訴冤嗎﹖',
    '撒下19:29 王對他說：你何必再提你的事呢﹖我說，你與洗巴均分地土。',
    '撒下19:30 米非波設對王說：我主我王既平平安安地回宮，就任憑洗巴都取了也可以。',
    '撒下19:31 基列人巴西萊從羅基琳下來，要送王過約但河，就與王一同過了約但河。',
    '撒下19:32 巴西萊年紀老邁，已經八十歲了。王住在瑪哈念的時候，他就拿食物來供給王；他原是大富戶。',
    '撒下19:33 王對巴西萊說：你與我同去，我要在耶路撒冷那裡養你的老。',
    '撒下19:34 巴西萊對王說：我在世的年日還能有多少，使我與王同上耶路撒冷呢﹖',
    '撒下19:35 僕人現在八十歲了，還能嘗出飲食的滋味、辨別美惡嗎﹖還能聽男女歌唱的聲音嗎﹖僕人何必累贅我主我王呢﹖',
    '撒下19:36 僕人只要送王過約但河，王何必賜我這樣的恩典呢﹖',
    '撒下19:37 求你准我回去，好死在我本城，葬在我父母的墓旁。這裡有王的僕人金罕，讓他同我主我王過去，可以隨意待他。',
    '撒下19:38 王說：金罕可以與我同去，我必照你的心願待他。你向我求什麼，我都必為你成就。',
    '撒下19:39 於是眾民過約但河，王也過去。王與巴西萊親嘴，為他祝福，巴西萊就回本地去了。',
    '撒下19:40 王過去，到了吉甲，金罕也跟他過去。猶大眾民和以色列民的一半也都送王過去。',
    '撒下19:41 以色列眾人來見王，對他說：我們弟兄猶大人為什麼暗暗送王和王的家眷，並跟隨王的人過約但河﹖',
    '撒下19:42 猶大眾人回答以色列人說：因為王與我們是親屬，你們為何因這事發怒呢﹖我們吃了王的什麼呢﹖王賞賜了我們什麼呢﹖',
    '撒下19:43 以色列人回答猶大人說：按支派，我們與王有十分的情分；在大衛身上，我們也比你們更有情分。你們為何藐視我們，請王回來不先與我們商量呢﹖但猶大人的話比以色列人的話更硬。',
    '撒下20:1 在那裡恰巧有一個匪徒，名叫示巴，是便雅憫人比基利的兒子。他吹角，說：我們與大衛無分，與耶西的兒子無涉。以色列人哪，你們各回各家去吧！',
    '撒下20:2 於是以色列人都離開大衛，跟隨比基利的兒子示巴。但猶大人從約但河直到耶路撒冷，都緊緊跟隨他們的王。',
    '撒下20:3 大衛王來到耶路撒冷，進了宮殿，就把從前留下看守宮殿的十個妃嬪禁閉在冷宮，養活他們，不與他們親近。他們如同寡婦被禁，直到死的日子。',
    '撒下20:4 王對亞瑪撒說：你要在三日之內將猶大人招聚了來，你也回到這裡來。',
    '撒下20:5 亞瑪撒就去招聚猶大人，卻耽延過了王所限的日期。',
    '撒下20:6 大衛對亞比篩說：現在恐怕比基利的兒子示巴加害於我們比押沙龍更甚。你要帶領你主的僕人追趕他，免得他得了堅固城，躲避我們。',
    '撒下20:7 約押的人和基利提人、比利提人，並所有的勇士，都跟著亞比篩，從耶路撒冷出去追趕比基利的兒子示巴。',
    '撒下20:8 他們到了基遍的大磐石那裡，亞瑪撒來迎接他們。那時約押穿著戰衣，腰束佩刀的帶子，刀在鞘內；約押前行，刀從鞘內掉出來。',
    '撒下20:9 約押左手拾起刀來，對亞瑪撒說：我兄弟，你好啊！就用右手抓住亞瑪撒的鬍子，要與他親嘴。',
    '撒下20:10 亞瑪撒沒有防備約押手裡所拿的刀；約押用刀刺入他的肚腹，他的腸子流在地上，沒有再刺他，就死了。約押和他兄弟亞比篩往前追趕比基利的兒子示巴。',
    '撒下20:11 有約押的一個少年人站在亞瑪撒屍身旁邊，對眾人說：誰喜悅約押，誰歸順大衛，就當跟隨約押去。',
    '撒下20:12 亞瑪撒在道路上滾在自己的血裡。那人見眾民經過都站住，就把亞瑪撒的屍身從路上挪到田間，用衣服遮蓋。',
    '撒下20:13 屍身從路上挪移之後，眾民就都跟隨約押去追趕比基利的兒子示巴。',
    '撒下20:14 他走遍以色列各支派，直到伯瑪迦的亞比拉，並比利人的全地；那些地方的人也都聚集跟隨他。',
    '撒下20:15 約押和跟隨的人到了伯瑪迦的亞比拉，圍困示巴，就對著城築壘；跟隨約押的眾民用錘撞城，要使城塌陷。',
    '撒下20:16 有一個聰明婦人從城上呼叫說：聽啊，聽啊，請約押近前來，我好與他說話。',
    '撒下20:17 約押就近前來，婦人問他說：你是約押不是﹖他說：我是。婦人說：求你聽婢女的話。約押說：我聽。',
    '撒下20:18 婦人說：古時有話說，當先在亞比拉求問，然後事就定妥。',
    '撒下20:19 我們這城的人在以色列人中是和平、忠厚的。你為何要毀壞以色列中的大城，吞滅耶和華的產業呢﹖',
    '撒下20:20 約押回答說：我決不吞滅毀壞，',
    '撒下20:21 乃因以法蓮山地的一個人─比基利的兒子示巴─舉手攻擊大衛王，你們若將他一人交出來，我便離城而去。婦人對約押說：那人的首級必從城牆上丟給你。',
    '撒下20:22 婦人就憑他的智慧去勸眾人。他們便割下比基利的兒子示巴的首級，丟給約押。約押吹角，眾人就離城而散，各歸各家去了。約押回耶路撒冷，到王那裡。',
    '撒下20:23 約押作以色列全軍的元帥；耶何耶大的兒子比拿雅統轄基利提人和比利提人；',
    '撒下20:24 亞多蘭掌管服苦的人；亞希律的兒子約沙法作史官；',
    '撒下20:25 示法作書記；撒督和亞比亞他作祭司長；',
    '撒下20:26 睚珥人以拉作大衛的宰相。',
    '撒下21:1 大衛年間有饑荒，一連三年，大衛就求問耶和華。耶和華說：這饑荒是因掃羅和他流人血之家殺死基遍人。',
    '撒下21:2 原來這基遍人不是以色列人，乃是亞摩利人中所剩的；以色列人曾向他們起誓，不殺滅他們，掃羅卻為以色列人和猶大人發熱心，想要殺滅他們。大衛王召了他們來，',
    '撒下21:3 問他們說：我當為你們怎樣行呢﹖可用什麼贖這罪，使你們為耶和華的產業祝福呢﹖',
    '撒下21:4 基遍人回答說：我們和掃羅與他家的事並不關乎金銀，也不要因我們的緣故殺一個以色列人。大衛說：你們怎樣說，我就為你們怎樣行。',
    '撒下21:5 他們對王說：那從前謀害我們、要滅我們、使我們不得再住以色列境內的人，',
    '撒下21:6 現在願將他的子孫七人交給我們，我們好在耶和華面前，將他們懸掛在耶和華揀選掃羅的基比亞。王說：我必交給你們。',
    '撒下21:7 王因為曾與掃羅的兒子約拿單指著耶和華起誓結盟，就愛惜掃羅的孫子、約拿單的兒子米非波設，不交出來，',
    '撒下21:8 卻把愛雅的女兒利斯巴給掃羅所生的兩個兒子亞摩尼、米非波設，和掃羅女兒米甲的姊姊給米何拉人巴西萊兒子亞得列所生的五個兒子',
    '撒下21:9 交在基遍人的手裡。基遍人就把他們，在耶和華面前，懸掛在山上，這七人就一同死亡。被殺的時候正是收割的日子，就是動手割大麥的時候。',
    '撒下21:10 愛雅的女兒利斯巴用麻布在磐石上搭棚，從動手收割的時候直到天降雨在屍身上的時候，日間不容空中的雀鳥落在屍身上，夜間不讓田野的走獸前來糟踐。',
    '撒下21:11 有人將掃羅的妃嬪愛雅女兒利斯巴所行的這事告訴大衛。',
    '撒下21:12 大衛就去，從基列雅比人那裡將掃羅和他兒子約拿單的骸骨搬了來（是因非利士人從前在基利波殺掃羅，將屍身懸掛在伯珊的街市上，基列雅比人把屍身偷了去。）',
    '撒下21:13 大衛將掃羅和他兒子約拿單的骸骨從那裡搬了來，又收殮被懸掛七人的骸骨，',
    '撒下21:14 將掃羅和他兒子約拿單的骸骨葬在便雅憫的洗拉，在掃羅父親基士的墳墓裡；眾人行了王所吩咐的。此後神垂聽國民所求的。',
    '撒下21:15 非利士人與以色列人打仗；大衛帶領僕人下去，與非利士人接戰，大衛就疲乏了。',
    '撒下21:16 偉人的一個兒子以實比諾要殺大衛；他的銅槍重三百舍客勒，又佩著新刀。',
    '撒下21:17 但洗魯雅的兒子亞比篩幫助大衛，攻打非利士人，將他殺死。當日，跟隨大衛的人向大衛起誓說：以後你不可再與我們一同出戰，恐怕熄滅以色列的燈。',
    '撒下21:18 後來，以色列人在歌伯與非利士人打仗，戶沙人西比該殺了偉人的一個兒子撒弗。',
    '撒下21:19 又在歌伯與非利士人打仗，伯利恆人雅雷俄珥金的兒子伊勒哈難殺了迦特人歌利亞。這人的槍桿粗如織布的機軸。',
    '撒下21:20 又在迦特打仗，那裡有一個身量高大的人，手腳都是六指，共有二十四個指頭；他也是偉人的兒子。',
    '撒下21:21 這人向以色列人罵陣，大衛的哥哥示米亞的兒子約拿單就殺了他。',
    '撒下21:22 這四個人是迦特偉人的兒子，都死在大衛和他僕人的手下。',
    '撒下22:1 當耶和華救大衛脫離一切仇敵和掃羅之手的日子，他向耶和華念這詩，',
    '撒下22:2 說：耶和華是我的巖石，我的山寨，我的救主，',
    '撒下22:3 我的神，我的磐石，我所投靠的。他是我的盾牌，是拯救我的角，是我的高臺，是我的避難所。我的救主啊，你是救我脫離強暴的。',
    '撒下22:4 我要求告當讚美的耶和華，這樣，我必從仇敵手中被救出來。',
    '撒下22:5 曾有死亡的波浪環繞我，匪類的急流使我驚懼，',
    '撒下22:6 陰間的繩索纏繞我，死亡的網羅臨到我。',
    '撒下22:7 我在急難中求告耶和華，向我的神呼求。他從殿中聽了我的聲音；我的呼求入了他的耳中。',
    '撒下22:8 那時因他發怒，地就搖撼戰抖；天的根基也震動搖撼。',
    '撒下22:9 從他鼻孔冒煙上騰；從他口中發火焚燒，連炭也著了。',
    '撒下22:10 他又使天下垂，親自降臨；有黑雲在他腳下。',
    '撒下22:11 他坐著基路伯飛行，在風的翅膀上顯現。',
    '撒下22:12 他以黑暗和聚集的水、天空的厚雲為他四圍的行宮。',
    '撒下22:13 因他面前的光輝炭都著了。',
    '撒下22:14 耶和華從天上打雷；至高者發出聲音。',
    '撒下22:15 他射出箭來，使仇敵四散，發出閃電，使他們擾亂。',
    '撒下22:16 耶和華的斥責一發，鼻孔的氣一出，海底就出現，大地的根基也顯露。',
    '撒下22:17 他從高天伸手抓住我，把我從大水中拉上來。',
    '撒下22:18 他救我脫離我的勁敵和那些恨我的人，因為他們比我強盛。',
    '撒下22:19 我遭遇災難的日子，他們來攻擊我；但耶和華是我的倚靠。',
    '撒下22:20 他又領我到寬闊之處；他救拔我，因他喜悅我。',
    '撒下22:21 耶和華按著我的公義報答我，按著我手中的清潔賞賜我。',
    '撒下22:22 因為我遵守了耶和華的道，未曾作惡離開我的神。',
    '撒下22:23 他的一切典章常在我面前；他的律例，我也未曾離棄。',
    '撒下22:24 我在他面前作了完全人；我也保守自己遠離我的罪孽。',
    '撒下22:25 所以耶和華按我的公義，按我在他眼前的清潔賞賜我。',
    '撒下22:26 慈愛的人，你以慈愛待他；完全的人，你以完全待他；',
    '撒下22:27 清潔的人，你以清潔待他；乖僻的人，你以彎曲待他。',
    '撒下22:28 困苦的百姓，你必拯救；但你的眼目察看高傲的人，使他降卑。',
    '撒下22:29 耶和華啊，你是我的燈；耶和華必照明我的黑暗。',
    '撒下22:30 我藉著你衝入敵軍，藉著我的神跳過牆垣。',
    '撒下22:31 至於神，他的道是完全的；耶和華的話是煉淨的。凡投靠他的，他便作他們的盾牌。',
    '撒下22:32 除了耶和華，誰是神呢﹖除了我們的神，誰是磐石呢﹖',
    '撒下22:33 神是我堅固的保障；他引導完全人行他的路。',
    '撒下22:34 他使我的腳快如母鹿的蹄，又使我在高處安穩。',
    '撒下22:35 他教導我的手能以爭戰，甚至我的膀臂能開銅弓。',
    '撒下22:36 你把你的救恩給我作盾牌；你的溫和使我為大。',
    '撒下22:37 你使我腳下的地步寬闊；我的腳未曾滑跌。',
    '撒下22:38 我追趕我的仇敵，滅絕了他們，未滅以先，我沒有歸回。',
    '撒下22:39 我滅絕了他們，打傷了他們，使他們不能起來；他們都倒在我的腳下。',
    '撒下22:40 因為你曾以力量束我的腰，使我能爭戰；你也使那起來攻擊我的都服在我以下。',
    '撒下22:41 你又使我的仇敵在我面前轉背逃跑，叫我能以剪除那恨我的人。',
    '撒下22:42 他們仰望，卻無人拯救；就是呼求耶和華，他也不應允。',
    '撒下22:43 我搗碎他們，如同地上的灰塵，踐踏他們，四散在地，如同街上的泥土。',
    '撒下22:44 你救我脫離我百姓的爭競，保護我作列國的元首；我素不認識的民必事奉我。',
    '撒下22:45 外邦人要投降我，一聽見我的名聲就必順從我。',
    '撒下22:46 外邦人要衰殘，戰戰兢兢地出他們的營寨。',
    '撒下22:47 耶和華是活神，願我的磐石被人稱頌！願神─那拯救我的磐石被人尊崇！',
    '撒下22:48 這位神就是那為我伸冤、使眾民服在我以下的。',
    '撒下22:49 你救我脫離仇敵，又把我舉起，高過那些起來攻擊我的；你救我脫離強暴的人。',
    '撒下22:50 耶和華啊，因此我要在外邦中稱謝你，歌頌你的名。',
    '撒下22:51 耶和華賜極大的救恩給他所立的王，施慈愛給他的受膏者，就是給大衛和他的後裔，直到永遠！',
    '撒下23:1 以下是大衛末了的話。耶西的兒子大衛得居高位，是雅各神所膏的，作以色列的美歌者，說：',
    '撒下23:2 耶和華的靈藉著我說：他的話在我口中。',
    '撒下23:3 以色列的神、以色列的磐石曉諭我說：那以公義治理人民的，敬畏神執掌權柄，',
    '撒下23:4 他必像日出的晨光，如無雲的清晨，雨後的晴光，使地發生嫩草。',
    '撒下23:5 我家在神面前並非如此；神卻與我立永遠的約。這約凡事堅穩，關乎我的一切救恩和我一切所想望的，他豈不為我成就嗎﹖',
    '撒下23:6 但匪類都必像荊棘被丟棄；人不敢用手拿他；',
    '撒下23:7 拿他的人必帶鐵器和槍桿，終久他必被火焚燒。',
    '撒下23:8 大衛勇士的名字記在下面：他革捫人約設巴設，又稱伊斯尼人亞底挪，他是軍長的統領，一時擊殺了八百人。',
    '撒下23:9 其次是亞合人朵多的兒子以利亞撒。從前非利士人聚集要打仗，以色列人迎著上去，有跟隨大衛的三個勇士向非利士人罵陣，其中有以利亞撒。',
    '撒下23:10 他起來擊殺非利士人，直到手臂疲乏，手黏住刀把。那日耶和華使以色列人大獲全勝；眾民在以利亞撒後頭專奪財物。',
    '撒下23:11 其次是哈拉人亞基的兒子沙瑪。一日，非利士人聚集成群，在一塊長滿紅豆的田裡，眾民就在非利士人面前逃跑。',
    '撒下23:12 沙瑪卻站在那田間擊殺非利士人，救護了那田。耶和華使以色列人大獲全勝。',
    '撒下23:13 收割的時候，有三十個勇士中的三個人下到亞杜蘭洞見大衛。非利士的軍兵在利乏音谷安營。',
    '撒下23:14 那時大衛在山寨，非利士人的防營在伯利恆。',
    '撒下23:15 大衛渴想，說：甚願有人將伯利恆城門旁、井裡的水打來給我喝。',
    '撒下23:16 這三個勇士就闖過非利士人的營盤，從伯利恆城門旁的井裡打水，拿來奉給大衛。他卻不肯喝，將水奠在耶和華面前，',
    '撒下23:17 說：耶和華啊，這三個人冒死去打水；這水好像他們的血一般，我斷不敢喝。如此，大衛不肯喝。這是三個勇士所做的事。',
    '撒下23:18 洗魯雅的兒子、約押的兄弟亞比篩是這三個勇士的首領；他舉槍殺了三百人，就在三個勇士裡得了名。',
    '撒下23:19 他在這三個勇士裡是最尊貴的，所以作他們的首領，只是不及前三個勇士。',
    '撒下23:20 有甲薛勇士耶何耶大的兒子比拿雅行過大能的事；他殺了摩押人亞利伊勒的兩個兒子，又在下雪的時候下坑裡去，殺了一個獅子，',
    '撒下23:21 又殺了一個強壯的埃及人；埃及人手裡拿著槍，比拿雅只拿著棍子下去，從埃及人手裡奪過槍來，用那槍將他殺死。',
    '撒下23:22 這是耶何耶大的兒子比拿雅所行的事，就在三個勇士裡得了名。',
    '撒下23:23 他比那三十個勇士都尊貴，只是不及前三個勇士。大衛立他作護衛長。',
    '撒下23:24 三十個勇士裡有約押的兄弟亞撒黑，伯利恆人朵多的兒子伊勒哈難，',
    '撒下23:25 哈律人沙瑪，哈律人以利加，',
    '撒下23:26 帕勒提人希利斯，提哥亞人益吉的兒子以拉，',
    '撒下23:27 亞拿突人亞比以謝，戶沙人米本乃，',
    '撒下23:28 亞合人撒們，尼陀法人瑪哈萊，',
    '撒下23:29 尼陀法人巴拿的兒子希立，便雅憫族、基比亞人利拜的兒子以太，',
    '撒下23:30 比拉頓人比拿雅，迦實溪人希太，',
    '撒下23:31 伯亞拉巴人亞比亞本，巴魯米人押斯瑪弗，',
    '撒下23:32 沙本人以利雅哈巴，雅善兒子中的約拿單，',
    '撒下23:33 哈拉人沙瑪，哈拉人沙拉的兒子亞希暗，',
    '撒下23:34 瑪迦人亞哈拜的兒子以利法列，基羅人亞希多弗的兒子以連，',
    '撒下23:35 迦密人希斯萊，亞巴人帕萊，',
    '撒下23:36 瑣巴人拿單的兒子以甲，迦得人巴尼，',
    '撒下23:37 亞捫人洗勒，比錄人拿哈萊（是給洗魯雅的兒子約押拿兵器的），',
    '撒下23:38 以帖人以拉，以帖人迦立，',
    '撒下23:39 赫人烏利亞，共有三十七人。',
    '撒下24:1 耶和華又向以色列人發怒，就激動大衛，使他吩咐人去數點以色列人和猶大人。',
    '撒下24:2 大衛就吩咐跟隨他的元帥約押說：你去走遍以色列眾支派，從但直到別是巴，數點百姓，我好知道他們的數目。',
    '撒下24:3 約押對王說：無論百姓多少，願耶和華─你的神再加增百倍，使我主我王親眼得見。我主我王何必喜悅行這事呢﹖',
    '撒下24:4 但王的命令勝過約押和眾軍長。約押和眾軍長就從王面前出去，數點以色列的百姓。',
    '撒下24:5 他們過了約但河，在迦得谷中、城的右邊亞羅珥安營，與雅謝相對，',
    '撒下24:6 又到了基列和他停合示地，又到了但雅安，繞到西頓，',
    '撒下24:7 來到推羅的保障，並希未人和迦南人的各城，又到猶大南方的別是巴。',
    '撒下24:8 他們走遍全地，過了九個月零二十天，就回到耶路撒冷。',
    '撒下24:9 約押將百姓的總數奏告於王：以色列拿刀的勇士有八十萬；猶大有五十萬。',
    '撒下24:10 大衛數點百姓以後，就心中自責，禱告耶和華說：我行這事大有罪了。耶和華啊，求你除掉僕人的罪孽，因我所行的甚是愚昧。',
    '撒下24:11 大衛早晨起來，耶和華的話臨到先知迦得，就是大衛的先見，說：',
    '撒下24:12 你去告訴大衛，說耶和華如此說：我有三樣災，隨你選擇一樣，我好降與你。',
    '撒下24:13 於是迦得來見大衛，對他說：你願意國中有七年的饑荒呢﹖是在你敵人面前逃跑，被追趕三個月呢﹖是在你國中有三日的瘟疫呢﹖現在你要揣摩思想，我好回覆那差我來的。',
    '撒下24:14 大衛對迦得說：我甚為難！我願落在耶和華的手裡，因為他有豐盛的憐憫。我不願落在人的手裡。',
    '撒下24:15 於是，耶和華降瘟疫與以色列人，自早晨到所定的時候；從但直到別是巴，民間死了七萬人。',
    '撒下24:16 天使向耶路撒冷伸手要滅城的時候，耶和華後悔，就不降這災了，吩咐滅民的天使說：夠了！住手吧！那時耶和華的使者在耶布斯人亞勞拿的禾場那裡。',
    '撒下24:17 大衛看見滅民的天使，就禱告耶和華說：我犯了罪，行了惡；但這群羊做了什麼呢﹖願你的手攻擊我和我的父家。',
    '撒下24:18 當日，迦得來見大衛，對他說：你上去，在耶布斯人亞勞拿的禾場上為耶和華築一座壇。',
    '撒下24:19 大衛就照著迦得奉耶和華名所說的話上去了。',
    '撒下24:20 亞勞拿觀看，見王和他臣僕前來，就迎接出去，臉伏於地，向王下拜，',
    '撒下24:21 說：我主我王為何來到僕人這裡呢﹖大衛說：我要買你這禾場，為耶和華築一座壇，使民間的瘟疫止住。',
    '撒下24:22 亞勞拿對大衛說：我主我王，你喜悅用什麼，就拿去獻祭。看哪，這裡有牛可以作燔祭，有打糧的器具和套牛的軛可以當柴燒。',
    '撒下24:23 王啊，這一切，我亞勞拿都奉給你；又對王說：願耶和華─你的神悅納你。',
    '撒下24:24 王對亞勞拿說：不然。我必要按著價值向你買；我不肯用白得之物作燔祭獻給耶和華─我的神。大衛就用五十舍客勒銀子買了那禾場與牛。',
    '撒下24:25 大衛在那裡為耶和華築了一座壇，獻燔祭和平安祭。如此，耶和華垂聽國民所求的，瘟疫在以色列人中就止住了。',
    '王上1:1 大衛王年紀老邁，雖用被遮蓋，仍不覺暖。',
    '王上1:2 所以臣僕對他說：不如為我主我王尋找一個處女，使他伺候王，奉養王，睡在王的懷中，好叫我主我王得暖。',
    '王上1:3 於是在以色列全境尋找美貌的童女，尋得書念的一個童女亞比煞，就帶到王那裡。',
    '王上1:4 這童女極其美貌，他奉養王，伺候王，王卻沒有與他親近。',
    '王上1:5 那時，哈及的兒子亞多尼雅自尊，說：我必作王，就為自己預備車輛、馬兵，又派五十人在他前頭奔走。',
    '王上1:6 他父親素來沒有使他憂悶，說：你是做什麼呢﹖他甚俊美，生在押沙龍之後。',
    '王上1:7 亞多尼雅與洗魯雅的兒子約押，和祭司亞比亞他商議；二人就順從他，幫助他。',
    '王上1:8 但祭司撒督、耶何耶大的兒子比拿雅、先知拿單、示每、利以，並大衛的勇士都不順從亞多尼雅。',
    '王上1:9 一日，亞多尼雅在隱羅結旁、瑣希列磐石那裡宰了牛羊、肥犢，請他的諸弟兄，就是王的眾子，並所有作王臣僕的猶大人；',
    '王上1:10 惟獨先知拿單和比拿雅並勇士，與他的兄弟所羅門，他都沒有請。',
    '王上1:11 拿單對所羅門的母親拔示巴說：哈及的兒子亞多尼雅作王了，你沒有聽見嗎﹖我們的主大衛卻不知道。',
    '王上1:12 現在我可以給你出個主意，好保全你和你兒子所羅門的性命。',
    '王上1:13 你進去見大衛王，對他說：我主我王啊，你不曾向婢女起誓說：你兒子所羅門必接續我作王，坐在我的位上嗎﹖現在亞多尼雅怎麼作了王呢﹖',
    '王上1:14 你還與王說話的時候，我也隨後進去，證實你的話。',
    '王上1:15 拔示巴進入內室見王，王甚老邁，書念的童女亞比煞正伺候王。',
    '王上1:16 拔示巴向王屈身下拜；王說：你要什麼﹖',
    '王上1:17 他說：我主啊，你曾向婢女指著耶和華─你的神起誓說：你兒子所羅門必接續我作王，坐在我的位上。',
    '王上1:18 現在亞多尼雅作王了，我主我王卻不知道。',
    '王上1:19 他宰了許多牛羊、肥犢，請了王的眾子和祭司亞比亞他，並元帥約押；惟獨王的僕人所羅門，他沒有請。',
    '王上1:20 我主我王啊，以色列眾人的眼目都仰望你，等你曉諭他們，在我主我王之後誰坐你的位。',
    '王上1:21 若不然，到我主我王與列祖同睡以後，我和我兒子所羅門必算為罪人了。',
    '王上1:22 拔示巴還與王說話的時候，先知拿單也進來了。',
    '王上1:23 有人奏告王說：先知拿單來了。拿單進到王前，臉伏於地。',
    '王上1:24 拿單說：我主我王果然應許亞多尼雅說你必接續我作王，坐在我的位上嗎﹖',
    '王上1:25 他今日下去，宰了許多牛羊、肥犢，請了王的眾子和軍長，並祭司亞比亞他；他們正在亞多尼雅面前吃喝，說：願亞多尼雅王萬歲！',
    '王上1:26 惟獨我，就是你的僕人和祭司撒督，耶何耶大的兒子比拿雅，並王的僕人所羅門，他都沒有請。',
    '王上1:27 這事果然出乎我主我王嗎﹖王卻沒有告訴僕人們，在我主我王之後誰坐你的位。',
    '王上1:28 大衛王吩咐說：叫拔示巴來。拔示巴就進來，站在王面前。',
    '王上1:29 王起誓說：我指著救我性命脫離一切苦難、永生的耶和華起誓。',
    '王上1:30 我既然指著耶和華─以色列的神向你起誓說：你兒子所羅門必接續我作王，坐在我的位上。我今日就必照這話而行。',
    '王上1:31 於是，拔示巴臉伏於地，向王下拜，說：願我主大衛王萬歲！',
    '王上1:32 大衛王又吩咐說：將祭司撒督、先知拿單、耶何耶大的兒子比拿雅召來！他們就都來到王面前。',
    '王上1:33 王對他們說：要帶領你們主的僕人，使我兒子所羅門騎我的騾子，送他下到基訓；',
    '王上1:34 在那裡，祭司撒督和先知拿單要膏他作以色列的王；你們也要吹角，說：願所羅門王萬歲！',
    '王上1:35 然後要跟隨他上來，使他坐在我的位上，接續我作王。我已立他作以色列和猶大的君。',
    '王上1:36 耶何耶大的兒子比拿雅對王說：阿們！願耶和華─我主我王的神也這樣命定。',
    '王上1:37 耶和華怎樣與我主我王同在，願他照樣與所羅門同在，使他的國位比我主大衛王的國位更大。',
    '王上1:38 於是，祭司撒督、先知拿單、耶何耶大的兒子比拿雅，和基利提人、比利提人都下去使所羅門騎大衛王的騾子，將他送到基訓。',
    '王上1:39 祭司撒督就從帳幕中取了盛膏油的角來，用膏膏所羅門。人就吹角，眾民都說：願所羅門王萬歲！',
    '王上1:40 眾民跟隨他上來，且吹笛，大大歡呼，聲音震地。',
    '王上1:41 亞多尼雅和所請的眾客筵宴方畢，聽見這聲音；約押聽見角聲就說：城中為何有這響聲呢﹖',
    '王上1:42 他正說話的時候，祭司亞比亞他的兒子約拿單來了。亞多尼雅對他說：進來吧！你是個忠義的人，必是報好信息。',
    '王上1:43 約拿單對亞多尼雅說：我們的主大衛王誠然立所羅門為王了。',
    '王上1:44 王差遣祭司撒督、先知拿單、耶何耶大的兒子比拿雅，和基利提人、比利提人都去使所羅門騎王的騾子。',
    '王上1:45 祭司撒督和先知拿單在基訓已經膏他作王。眾人都從那裡歡呼著上來，聲音使城震動，這就是你們所聽見的聲音；',
    '王上1:46 並且所羅門登了國位。',
    '王上1:47 王的臣僕也來為我們的主大衛王祝福，說：願王的神使所羅門的名比王的名更尊榮；使他的國位比王的國位更大。王就在床上屈身下拜。',
    '王上1:48 王又說：耶和華─以色列的神是應當稱頌的；因他賜我一人今日坐在我的位上，我也親眼看見了。',
    '王上1:49 亞多尼雅的眾客聽見這話就都驚懼，起來四散。',
    '王上1:50 亞多尼雅懼怕所羅門，就起來，去抓住祭壇的角。',
    '王上1:51 有人告訴所羅門說：亞多尼雅懼怕所羅門王，現在抓住祭壇的角，說：願所羅門王今日向我起誓，必不用刀殺僕人。',
    '王上1:52 所羅門說：他若作忠義的人，連一根頭髮也不致落在地上；他若行惡，必要死亡。',
    '王上1:53 於是所羅門王差遣人，使亞多尼雅從壇上下來，他就來，向所羅門王下拜；所羅門對他說：你回家去吧！',
    '王上2:1 大衛的死期臨近了，就囑咐他兒子所羅門說：',
    '王上2:2 我現在要走世人必走的路。所以，你當剛強，作大丈夫，',
    '王上2:3 遵守耶和華─你神所吩咐的，照著摩西律法上所寫的行主的道，謹守他的律例、誡命、典章、法度。這樣，你無論做什麼事，不拘往何處去，盡都亨通。',
    '王上2:4 耶和華必成就向我所應許的話說：你的子孫若謹慎自己的行為，盡心盡意誠誠實實地行在我面前，就不斷人坐以色列的國位。',
    '王上2:5 你知道洗魯雅的兒子約押向我所行的，就是殺了以色列的兩個元帥：尼珥的兒子押尼珥和益帖的兒子亞瑪撒。他在太平之時流這二人的血，如在爭戰之時一樣，將這血染了腰間束的帶和腳上穿的鞋。',
    '王上2:6 所以你要照你的智慧行，不容他白頭安然下陰間。',
    '王上2:7 你當恩待基列人巴西萊的眾子，使他們常與你同席吃飯；因為我躲避你哥哥押沙龍的時候，他們拿食物來迎接我。',
    '王上2:8 在你這裡有巴戶琳的便雅憫人，基拉的兒子示每；我往瑪哈念去的那日，他用狠毒的言語咒罵我，後來卻下約但河迎接我，我就指著耶和華向他起誓說：我必不用刀殺你。',
    '王上2:9 現在你不要以他為無罪。你是聰明人，必知道怎樣待他，使他白頭見殺，流血下到陰間。',
    '王上2:10 大衛與他列祖同睡，葬在大衛城。',
    '王上2:11 大衛作以色列王四十年：在希伯崙作王七年，在耶路撒冷作王三十三年。',
    '王上2:12 所羅門坐他父親大衛的位，他的國甚是堅固。',
    '王上2:13 哈及的兒子亞多尼雅去見所羅門的母親拔示巴，拔示巴問他說：你來是為平安嗎﹖回答說：是為平安；',
    '王上2:14 又說：我有話對你說。拔示巴說：你說吧。',
    '王上2:15 亞多尼雅說：你知道國原是歸我的，以色列眾人也都仰望我作王，不料，國反歸了我兄弟，因他得國是出乎耶和華。',
    '王上2:16 現在我有一件事求你，望你不要推辭。拔示巴說：你說吧。',
    '王上2:17 他說：求你請所羅門王將書念的女子亞比煞賜我為妻，因他必不推辭你。',
    '王上2:18 拔示巴說：好，我必為你對王提說。',
    '王上2:19 於是，拔示巴去見所羅門王，要為亞多尼雅提說；王起來迎接，向他下拜，就坐在位上，吩咐人為王母設一座位，他便坐在王的右邊。',
    '王上2:20 拔示巴說：我有一件小事求你，望你不要推辭。王說：請母親說，我必不推辭。',
    '王上2:21 拔示巴說：求你將書念的女子亞比煞賜給你哥哥亞多尼雅為妻。',
    '王上2:22 所羅門王對他母親說：為何單替他求書念的女子亞比煞呢﹖也可以為他求國吧！他是我的哥哥，他有祭司亞比亞他和洗魯雅的兒子約押為輔佐。',
    '王上2:23 所羅門王就指著耶和華起誓說：亞多尼雅這話是自己送命，不然，願神重重地降罰與我。',
    '王上2:24 耶和華堅立我，使我坐在父親大衛的位上，照著所應許的話為我建立家室；現在我指著永生的耶和華起誓，亞多尼雅今日必被治死。',
    '王上2:25 於是所羅門王差遣耶何耶大的兒子比拿雅，將亞多尼雅殺死。',
    '王上2:26 王對祭司亞比亞他說：你回亞拿突歸自己的田地去吧！你本是該死的，但因你在我父親大衛面前擡過主耶和華的約櫃，又與我父親同受一切苦難，所以我今日不將你殺死。',
    '王上2:27 所羅門就革除亞比亞他，不許他作耶和華的祭司。這樣，便應驗耶和華在示羅論以利家所說的話。',
    '王上2:28 約押雖然沒有歸從押沙龍，卻歸從了亞多尼雅。他聽見這風聲，就逃到耶和華的帳幕，抓住祭壇的角。',
    '王上2:29 有人告訴所羅門王說：約押逃到耶和華的帳幕，現今在祭壇的旁邊。所羅門就差遣耶何耶大的兒子比拿雅，說：你去將他殺死。',
    '王上2:30 比拿雅來到耶和華的帳幕，對約押說：王吩咐說，你出來吧！他說：我不出去，我要死在這裡。比拿雅就去回覆王，說約押如此如此回答我。',
    '王上2:31 王說：你可以照著他的話行，殺死他，將他葬埋，好叫約押流無辜人血的罪不歸我和我的父家了。',
    '王上2:32 耶和華必使約押流人血的罪歸到他自己的頭上；因為他用刀殺了兩個比他又義又好的人，就是以色列元帥尼珥的兒子押尼珥和猶大元帥益帖的兒子亞瑪撒，我父親大衛卻不知道。',
    '王上2:33 故此，流這二人血的罪必歸到約押和他後裔的頭上，直到永遠；惟有大衛和他的後裔，並他的家與國，必從耶和華那裡得平安，直到永遠。',
    '王上2:34 於是耶何耶大的兒子比拿雅上去，將約押殺死，葬在曠野約押自己的墳墓【原文作房屋】裡。',
    '王上2:35 王就立耶何耶大的兒子比拿雅作元帥，代替約押，又使祭司撒督代替亞比亞他。',
    '王上2:36 王差遣人將示每召來，對他說：你要在耶路撒冷建造房屋居住，不可出來往別處去。',
    '王上2:37 你當確實地知道，你何日出來過汲淪溪，何日必死！你的罪【原文作血】必歸到自己的頭上。',
    '王上2:38 示每對王說：這話甚好！我主我王怎樣說，僕人必怎樣行。於是示每多日住在耶路撒冷。',
    '王上2:39 過了三年，示每的兩個僕人逃到迦特王瑪迦的兒子亞吉那裡去。有人告訴示每說：你的僕人在迦特。',
    '王上2:40 示每起來，備上驢，往迦特到亞吉那裡去找他的僕人，就從迦特帶他僕人回來。',
    '王上2:41 有人告訴所羅門說：示每出耶路撒冷往迦特去，回來了。',
    '王上2:42 王就差遣人將示每召了來，對他說：我豈不是叫你指著耶和華起誓，並且警戒你說你當確實地知道，你哪日出來往別處去，那日必死嗎﹖你也對我說：這話甚好，我必聽從。',
    '王上2:43 現在你為何不遵守你指著耶和華起的誓和我所吩咐你的命令呢﹖',
    '王上2:44 王又對示每說：你向我父親大衛所行的一切惡事，你自己心裡也知道，所以耶和華必使你的罪惡歸到自己的頭上；',
    '王上2:45 惟有所羅門王必得福，並且大衛的國位必在耶和華面前堅定，直到永遠。',
    '王上2:46 於是王吩咐耶何耶大的兒子比拿雅，他就去殺死示每。這樣，便堅定了所羅門的國位。',
    '王上3:1 所羅門與埃及王法老結親，娶了法老的女兒為妻，接他進入大衛城，直等到造完了自己的宮和耶和華的殿，並耶路撒冷周圍的城牆。',
    '王上3:2 當那些日子，百姓仍在邱壇獻祭，因為還沒有為耶和華的名建殿。',
    '王上3:3 所羅門愛耶和華，遵行他父親大衛的律例，只是還在邱壇獻祭燒香。',
    '王上3:4 所羅門王上基遍去獻祭；因為在那裡有極大【或作出名】的邱壇，他在那壇上獻一千犧牲作燔祭。',
    '王上3:5 在基遍，夜間夢中，耶和華向所羅門顯現，對他說：你願我賜你什麼﹖你可以求。',
    '王上3:6 所羅門說：你僕人─我父親大衛用誠實、公義、正直的心行在你面前，你就向他大施恩典，又為他存留大恩，賜他一個兒子坐在他的位上，正如今日一樣。',
    '王上3:7 耶和華─我的神啊，如今你使僕人接續我父親大衛作王；但我是幼童，不知道應當怎樣出入。',
    '王上3:8 僕人住在你所揀選的民中，這民多得不可勝數。',
    '王上3:9 所以求你賜我智慧，可以判斷你的民，能辨別是非。不然，誰能判斷這眾多的民呢﹖',
    '王上3:10 所羅門因為求這事，就蒙主喜悅。',
    '王上3:11 神對他說：你既然求這事，不為自己求壽、求富，也不求滅絕你仇敵的性命，單求智慧可以聽訟，',
    '王上3:12 我就應允你所求的，賜你聰明智慧，甚至在你以前沒有像你的，在你以後也沒有像你的。',
    '王上3:13 你所沒有求的，我也賜給你，就是富足、尊榮，使你在世的日子，列王中沒有一個能比你的。',
    '王上3:14 你若效法你父親大衛，遵行我的道，謹守我的律例、誡命，我必使你長壽。',
    '王上3:15 所羅門醒了，不料是個夢。他就回到耶路撒冷，站在耶和華的約櫃前，獻燔祭和平安祭，又為他眾臣僕設擺筵席。',
    '王上3:16 一日，有兩個妓女來，站在王面前。',
    '王上3:17 一個說：我主啊，我和這婦人同住一房；他在房中的時候，我生了一個男孩。',
    '王上3:18 我生孩子後第三日，這婦人也生了孩子。我們是同住的，除了我們二人之外，房中再沒有別人。',
    '王上3:19 夜間，這婦人睡著的時候，壓死了他的孩子。',
    '王上3:20 他半夜起來，趁我睡著，從我旁邊把我的孩子抱去，放在他懷裡，將他的死孩子放在我懷裡。',
    '王上3:21 天要亮的時候，我起來要給我的孩子吃奶，不料，孩子死了；及至天亮，我細細地察看，不是我所生的孩子。',
    '王上3:22 那婦人說：不然，活孩子是我的，死孩子是你的。這婦人說：不然，死孩子是你的，活孩子是我的。他們在王面前如此爭論。',
    '王上3:23 王說：這婦人說活孩子是我的，死孩子是你的，那婦人說不然，死孩子是你的，活孩子是我的，',
    '王上3:24 就吩咐說：拿刀來！人就拿刀來。',
    '王上3:25 王說：將活孩子劈成兩半，一半給那婦人，一半給這婦人。',
    '王上3:26 活孩子的母親為自己的孩子心裡急痛，就說：求我主將活孩子給那婦人吧，萬不可殺他！那婦人說：這孩子也不歸我，也不歸你，把他劈了吧！',
    '王上3:27 王說：將活孩子給這婦人，萬不可殺他；這婦人實在是他的母親。',
    '王上3:28 以色列眾人聽見王這樣判斷，就都敬畏他；因為見他心裡有神的智慧，能以斷案。',
    '王上4:1 所羅門作以色列眾人的王。',
    '王上4:2 他的臣子記在下面：撒督的兒子亞撒利雅作祭司，',
    '王上4:3 示沙的兩個兒子以利何烈、亞希亞作書記，亞希律的兒子約沙法作史官，',
    '王上4:4 耶何耶大的兒子比拿雅作元帥，撒督和亞比亞他作祭司長，',
    '王上4:5 拿單的兒子亞撒利雅作眾吏長，王的朋友拿單的兒子撒布得作領袖，',
    '王上4:6 亞希煞作家宰，亞比大的兒子亞多尼蘭掌管服苦的人。',
    '王上4:7 所羅門在以色列全地立了十二個官吏，使他們供給王和王家的食物，每年各人供給一月。',
    '王上4:8 他們的名字記在下面：在以法蓮山地有便戶珥；',
    '王上4:9 在瑪迦斯、沙賓、伯示麥、以倫伯哈南有便底甲；',
    '王上4:10 在亞魯泊有便希悉，他管理梭哥和希弗全地；',
    '王上4:11 在多珥山岡【或作全境】有便亞比拿達，他娶了所羅門的女兒他法為妻；',
    '王上4:12 在他納和米吉多，並靠近撒拉他拿、耶斯列下邊的伯善全地，從伯善到亞伯米何拉直到約念之外，有亞希律的兒子巴拿；',
    '王上4:13 在基列的拉末有便基別，他管理在基列的瑪拿西子孫睚珥的城邑，巴珊的亞珥歌伯地的大城六十座，都有城牆和銅閂；',
    '王上4:14 在瑪哈念有易多的兒子亞希拿達；',
    '王上4:15 在拿弗他利有亞希瑪斯，他也娶了所羅門的一個女兒巴實抹為妻；',
    '王上4:16 在亞設和亞祿有戶篩的兒子巴拿；',
    '王上4:17 在以薩迦有帕路亞的兒子約沙法；',
    '王上4:18 在便雅憫有以拉的兒子示每；',
    '王上4:19 在基列地，就是從前屬亞摩利王西宏和巴珊王噩之地，有烏利的兒子基別一人管理。',
    '王上4:20 猶大人和以色列人如同海邊的沙那樣多，都吃喝快樂。',
    '王上4:21 所羅門統管諸國，從大河到非利士地，直到埃及的邊界。所羅門在世的日子，這些國都進貢服事他。',
    '王上4:22 所羅門每日所用的食物：細麵三十歌珥，粗麵六十歌珥，',
    '王上4:23 肥牛十隻，草場的牛二十隻，羊一百隻，還有鹿、羚羊、麅子，並肥禽。',
    '王上4:24 所羅門管理大河西邊的諸王，以及從提弗薩直到迦薩的全地，四境盡都平安。',
    '王上4:25 所羅門在世的日子，從但到別是巴的猶大人和以色列人都在自己的葡萄樹下和無花果樹下安然居住。',
    '王上4:26 所羅門有套車的馬四萬，還有馬兵一萬二千。',
    '王上4:27 那十二個官吏各按各月供給所羅門王，並一切與他同席之人的食物，一無所缺。',
    '王上4:28 眾人各按各分，將養馬與快馬的大麥和乾草送到官吏那裡。',
    '王上4:29 神賜給所羅門極大的智慧聰明和廣大的心，如同海沙不可測量。',
    '王上4:30 所羅門的智慧超過東方人和埃及人的一切智慧。',
    '王上4:31 他的智慧勝過萬人，勝過以斯拉人以探，並瑪曷的兒子希幔、甲各、達大的智慧。他的名聲傳揚在四圍的列國。',
    '王上4:32 他作箴言三千句，詩歌一千零五首。',
    '王上4:33 他講論草木，自利巴嫩的香柏樹直到牆上長的牛膝草，又講論飛禽走獸、昆蟲水族。',
    '王上4:34 天下列王聽見所羅門的智慧，就都差人來聽他的智慧話。',
    '王上5:1 推羅王希蘭，平素愛大衛；他聽見以色列人膏所羅門，接續他父親作王，就差遣臣僕來見他。',
    '王上5:2 所羅門也差遣人去見希蘭，說：',
    '王上5:3 你知道我父親大衛因四圍的爭戰，不能為耶和華─他神的名建殿，直等到耶和華使仇敵都服在他腳下。',
    '王上5:4 現在耶和華─我的神使我四圍平安，沒有仇敵，沒有災禍。',
    '王上5:5 我定意要為耶和華─我神的名建殿，是照耶和華應許我父親大衛的話說：我必使你兒子接續你坐你的位，他必為我的名建殿。',
    '王上5:6 所以求你吩咐你的僕人在利巴嫩為我砍伐香柏木，我的僕人也必幫助他們，我必照你所定的，給你僕人的工價；因為你知道，在我們中間沒有人像西頓人善於砍伐樹木。',
    '王上5:7 希蘭聽見所羅門的話，就甚喜悅，說：今日應當稱頌耶和華；因他賜給大衛一個有智慧的兒子，治理這眾多的民。',
    '王上5:8 希蘭打發人去見所羅門，說：你差遣人向我所提的那事，我都聽見了；論到香柏木和松木，我必照你的心願而行。',
    '王上5:9 我的僕人必將這木料從利巴嫩運到海裡，紮成筏子，浮海運到你所指定我的地方，在那裡拆開，你就可以收取；你也要成全我的心願，將食物給我的家。',
    '王上5:10 於是希蘭照著所羅門所要的，給他香柏木和松木；',
    '王上5:11 所羅門給希蘭麥子二萬歌珥，清油二十歌珥，作他家的食物。所羅門每年都是這樣給希蘭。',
    '王上5:12 耶和華照著所應許的賜智慧給所羅門。希蘭與所羅門和好，彼此立約。',
    '王上5:13 所羅門王從以色列人中挑取服苦的人共有三萬，',
    '王上5:14 派他們輪流每月一萬人上利巴嫩去；一個月在利巴嫩，兩個月在家裡。亞多尼蘭掌管他們。',
    '王上5:15 所羅門用七萬扛擡的，八萬在山上鑿石頭的。',
    '王上5:16 此外，所羅門用三千三百督工的，監管工人。',
    '王上5:17 王下令，人就鑿出又大又寶貴的石頭來，用以立殿的根基。',
    '王上5:18 所羅門的匠人和希蘭的匠人，並迦巴勒人，都將石頭鑿好，預備木料和石頭建殿。',
    '王上6:1 以色列人出埃及地後四百八十年，所羅門作以色列王第四年西弗月，就是二月，開工建造耶和華的殿。',
    '王上6:2 所羅門王為耶和華所建的殿，長六十肘，寬二十肘，高三十肘。',
    '王上6:3 殿前的廊子長二十肘，與殿的寬窄一樣，闊十肘；',
    '王上6:4 又為殿做了嚴緊的窗櫺。',
    '王上6:5 靠著殿牆，圍著外殿內殿，造了三層旁屋；',
    '王上6:6 下層寬五肘，中層寬六肘，上層寬七肘。殿外旁屋的梁木擱在殿牆坎上，免得插入殿牆。',
    '王上6:7 建殿是用山中鑿成的石頭。建殿的時候，鎚子、斧子，和別樣鐵器的響聲都沒有聽見。',
    '王上6:8 在殿右邊當中的旁屋有門，門內有旋螺的樓梯，可以上到第二層，從第二層可以上到第三層。',
    '王上6:9 所羅門建殿，安置香柏木的棟梁，又用香柏木板遮蓋。',
    '王上6:10 靠著殿所造的旁屋，每層高五肘，香柏木的棟梁擱在殿牆坎上。',
    '王上6:11 耶和華的話臨到所羅門說：',
    '王上6:12 論到你所建的這殿，你若遵行我的律例，謹守我的典章，遵從我的一切誡命，我必向你應驗我所應許你父親大衛的話。',
    '王上6:13 我必住在以色列人中間，並不丟棄我民以色列。',
    '王上6:14 所羅門建造殿宇。',
    '王上6:15 殿裡面用香柏木板貼牆，從地到棚頂都用木板遮蔽，又用松木板鋪地。',
    '王上6:16 內殿，就是至聖所，長二十肘，從地到棚頂用香柏木板遮蔽【或作隔斷】。',
    '王上6:17 內殿前的外殿，長四十肘。',
    '王上6:18 殿裡一點石頭都不顯露，一概用香柏木遮蔽；上面刻著野瓜和初開的花。',
    '王上6:19 殿裡預備了內殿，好安放耶和華的約櫃。',
    '王上6:20 內殿長二十肘，寬二十肘，高二十肘，牆面都貼上精金；又用香柏木做壇，包上精金。',
    '王上6:21 所羅門用精金貼了殿內的牆，又用金鍊子掛在內殿前門扇，用金包裹。',
    '王上6:22 全殿都貼上金子，直到貼完；內殿前的壇，也都用金包裹。',
    '王上6:23 他用橄欖木做兩個基路伯，各高十肘，安在內殿。',
    '王上6:24 這一個基路伯有兩個翅膀，各長五肘，從這翅膀尖到那翅膀尖共有十肘；',
    '王上6:25 那一個基路伯的兩個翅膀也是十肘，兩個基路伯的尺寸、形像都是一樣。',
    '王上6:26 這基路伯高十肘，那基路伯也是如此。',
    '王上6:27 他將兩個基路伯安在內殿裡；基路伯的翅膀是張開的，這基路伯的一個翅膀挨著這邊的牆，那基路伯的一個翅膀挨著那邊的牆，裡邊的兩個翅膀在殿中間彼此相接；',
    '王上6:28 又用金子包裹二基路伯。',
    '王上6:29 內殿、外殿周圍的牆上都刻著基路伯、棕樹，和初開的花。',
    '王上6:30 內殿、外殿的地板都貼上金子。',
    '王上6:31 又用橄欖木製造內殿的門扇、門楣、門框；門口有牆的五分之一。',
    '王上6:32 在橄欖木做的兩門扇上刻著基路伯、棕樹，和初開的花，都貼上金子。',
    '王上6:33 又用橄欖木製造外殿的門框，門口有牆的四分之一。',
    '王上6:34 用松木做門兩扇。這扇分兩扇，是摺疊的；那扇分兩扇；也是摺疊的。',
    '王上6:35 上面刻著基路伯、棕樹，和初開的花，都用金子貼了。',
    '王上6:36 他又用鑿成的石頭三層、香柏木一層建築內院。',
    '王上6:37 所羅門在位第四年西弗月，立了耶和華殿的根基。',
    '王上6:38 到十一年布勒月，就是八月，殿和一切屬殿的都按著樣式造成。他建殿的工夫共有七年。',
    '王上7:1 所羅門為自己建造宮室，十三年方才造成；',
    '王上7:2 又建造利巴嫩林宮，長一百肘，寬五十肘，高三十肘，有香柏木柱三【原文作四】行，柱上有香柏木柁梁。',
    '王上7:3 其上以香柏木為蓋，每行柱子十五根，共有四十五根。',
    '王上7:4 有窗戶三層，窗與窗相對。',
    '王上7:5 所有的門框都是厚木見方的，有窗戶三層，窗與窗相對。',
    '王上7:6 並建造有柱子的廊子，長五十肘，寬三十肘；在這廊前又有廊子，廊外有柱子和臺階。',
    '王上7:7 又建造一廊，其中設立審判的座位，這廊從地到頂都用香柏木遮蔽。',
    '王上7:8 廊後院內有所羅門住的宮室；工作與這工作相同。所羅門又為所娶法老的女兒建造一宮，做法與這廊子一樣。',
    '王上7:9 建造這一切所用的石頭都是寶貴的，是按著尺寸鑿成的，是用鋸裡外鋸齊的；從根基直到檐石，從外頭直到大院，都是如此。',
    '王上7:10 根基是寶貴的大石頭，有長十肘的，有長八肘的；',
    '王上7:11 上面有香柏木和按著尺寸鑿成寶貴的石頭。',
    '王上7:12 大院周圍有鑿成的石頭三層、香柏木一層，都照耶和華殿的內院和殿廊的樣式。',
    '王上7:13 所羅門王差遣人往推羅去，將戶蘭召了來。',
    '王上7:14 他是拿弗他利支派中一個寡婦的兒子，他父親是推羅人，作銅匠的。戶蘭滿有智慧、聰明、技能，善於各樣銅作。他來到所羅門王那裡，做王一切所要做的。',
    '王上7:15 他製造兩根銅柱，每根高十八肘，圍十二肘；',
    '王上7:16 又用銅鑄了兩個柱頂安在柱上，各高五肘。',
    '王上7:17 柱頂上有裝修的網子和擰成的鍊索，每頂七個。',
    '王上7:18 網子周圍有兩行石榴遮蓋柱頂，兩個柱頂都是如此。',
    '王上7:19 廊子的柱頂徑四肘，刻著百合花。',
    '王上7:20 兩柱頂的鼓肚上挨著網子，各有兩行石榴環繞，兩行共有二百。',
    '王上7:21 他將兩根柱子立在殿廊前頭：右邊立一根，起名叫雅斤；左邊立一根，起名叫波阿斯。',
    '王上7:22 在柱頂上刻著百合花。這樣，造柱子的工就完畢了。',
    '王上7:23 他又鑄一個銅海，樣式是圓的，高五肘，徑十肘，圍三十肘。',
    '王上7:24 在海邊之下，周圍有野瓜的樣式；每肘十瓜，共有兩行，是鑄海的時候鑄上的。',
    '王上7:25 有十二隻銅牛馱海：三隻向北，三隻向西，三隻向南，三隻向東；海在牛上，牛尾都向內。',
    '王上7:26 海厚一掌，邊如杯邊，又如百合花，可容二千罷特。',
    '王上7:27 他用銅製造十個盆座，每座長四肘，寬四肘，高三肘。',
    '王上7:28 座的造法是這樣：四面都有心子，心子在邊子當中，',
    '王上7:29 心子上有獅子和牛，並基路伯；邊上有小座，獅子和牛以下有垂下的瓔珞。',
    '王上7:30 每盆座有四個銅輪和銅軸。小座的四角上在盆以下，有鑄成的盆架，其旁都有瓔珞。',
    '王上7:31 小座高一肘，口是圓的，彷彿座的樣式，徑一肘半，在口上有雕工，心子是方的，不是圓的。',
    '王上7:32 四個輪子在心子以下，輪軸與座相連，每輪高一肘半。',
    '王上7:33 輪的樣式如同車輪；軸、輞、輻、轂都是鑄的。',
    '王上7:34 每座四角上都有盆架，是與座一同鑄成的。',
    '王上7:35 座上有圓架，高半肘；座上有撐子和心子，是與座一同鑄的。',
    '王上7:36 在撐子和心子上刻著基路伯、獅子，和棕樹，周圍有瓔珞。',
    '王上7:37 十個盆座都是這樣，鑄法、尺寸、樣式相同。',
    '王上7:38 又用銅製造十個盆，每盆可容四十罷特。盆徑四肘，在那十座上，每座安設一盆。',
    '王上7:39 五個安在殿門的右邊，五個放在殿門的左邊；又將海放在殿門的右旁，就是南邊。',
    '王上7:40 戶蘭又造了盆、鏟子，和盤子。這樣，他為所羅門王做完了耶和華殿的一切工。',
    '王上7:41 所造的就是：兩根柱子和柱上兩個如球的頂；並兩個蓋柱頂的網子；',
    '王上7:42 和四百石榴，安在兩個網子上，每網兩行，蓋著兩個柱上如球的頂；',
    '王上7:43 十個座和其上的十個盆；',
    '王上7:44 海和海下的十二隻牛；',
    '王上7:45 盆、鏟子、盤子。這一切都是戶蘭給所羅門王用光亮的銅為耶和華的殿造成的，',
    '王上7:46 是遵王命在約但平原、疏割和撒拉但中間藉膠泥鑄成的。',
    '王上7:47 這一切所羅門都沒有過秤；因為甚多，銅的輕重也無法可查。',
    '王上7:48 所羅門又造耶和華殿裡的金壇和陳設餅的金桌子；',
    '王上7:49 內殿前的精金燈臺：右邊五個，左邊五個，並其上的金花、燈盞、蠟剪，',
    '王上7:50 與精金的杯、盤、鑷子、調羹、火鼎，以及至聖所、內殿的門樞，和外殿的門樞。',
    '王上7:51 所羅門王做完了耶和華殿的一切工，就把他父大衛分別為聖的金銀和器皿都帶來放在耶和華殿的府庫裡。',
    '王上8:1 那時，所羅門將以色列的長老和各支派的首領，並以色列的族長，招聚到耶路撒冷，要把耶和華的約櫃從大衛城─就是錫安─運上來。',
    '王上8:2 以他念月，就是七月，在節前，以色列人都聚集到所羅門王那裡。',
    '王上8:3 以色列長老來到，祭司便擡起約櫃，',
    '王上8:4 祭司和利未人將耶和華的約櫃運上來，又將會幕和會幕的一切聖器具都帶上來。',
    '王上8:5 所羅門王和聚集到他那裡的以色列全會眾，一同在約櫃前獻牛羊為祭，多得不可勝數。',
    '王上8:6 祭司將耶和華的約櫃擡進內殿，就是至聖所，放在兩個基路伯的翅膀底下。',
    '王上8:7 基路伯張著翅膀在約櫃之上，遮掩約櫃和擡櫃的槓。',
    '王上8:8 這槓甚長，槓頭在內殿前的聖所可以看見，在殿外卻不能看見，直到如今還在那裡。',
    '王上8:9 約櫃裡惟有兩塊石版，就是以色列人出埃及地後，耶和華與他們立約的時候摩西在何烈山所放的。除此以外，並無別物。',
    '王上8:10 祭司從聖所出來的時候，有雲充滿耶和華的殿；',
    '王上8:11 甚至祭司不能站立供職，因為耶和華的榮光充滿了殿。',
    '王上8:12 那時所羅門說：耶和華曾說，他必住在幽暗之處。',
    '王上8:13 我已經建造殿宇作你的居所，為你永遠的住處。',
    '王上8:14 王轉臉為以色列會眾祝福，以色列會眾就都站立。',
    '王上8:15 所羅門說：耶和華─以色列的神是應當稱頌的！因他親口向我父大衛所應許的，也親手成就了。',
    '王上8:16 他說：自從我領我民以色列出埃及以來，我未曾在以色列各支派中選擇一城建造殿宇─為我名的居所，但揀選大衛治理我民以色列。',
    '王上8:17 所羅門說：我父大衛曾立意，要為耶和華─以色列神的名建殿。',
    '王上8:18 耶和華卻對我父大衛說：你立意為我的名建殿，這意思甚好。',
    '王上8:19 只是你不可建殿，惟你所生的兒子必為我名建殿。',
    '王上8:20 現在耶和華成就了他所應許的話，使我接續我父大衛坐以色列的國位，又為耶和華─以色列神的名建造了殿。',
    '王上8:21 我也在其中為約櫃預備一處。約櫃內有耶和華的約，就是他領我們列祖出埃及地的時候，與他們所立的約。',
    '王上8:22 所羅門當著以色列會眾，站在耶和華的壇前，向天舉手說：',
    '王上8:23 耶和華─以色列的神啊，天上地下沒有神可比你的！你向那盡心行在你面前的僕人守約施慈愛；',
    '王上8:24 向你僕人─我父大衛所應許的話現在應驗了。你親口應許，親手成就，正如今日一樣。',
    '王上8:25 耶和華─以色列的神啊，你所應許你僕人─我父大衛的話說：你的子孫若謹慎自己的行為，在我面前行事像你所行的一樣，就不斷人坐以色列的國位。現在求你應驗這話。',
    '王上8:26 以色列的神啊，求你成就向你僕人─我父大衛所應許的話。',
    '王上8:27 神果真住在地上嗎﹖看哪，天和天上的天尚且不足你居住的，何況我所建的這殿呢﹖',
    '王上8:28 惟求耶和華─我的神垂顧僕人的禱告祈求，俯聽僕人今日在你面前的祈禱呼籲。',
    '王上8:29 願你晝夜看顧這殿，就是你應許立為你名的居所；求你垂聽僕人向此處禱告的話。',
    '王上8:30 你僕人和你民以色列向此處祈禱的時候，求你在天上你的居所垂聽，垂聽而赦免。',
    '王上8:31 人若得罪鄰舍，有人叫他起誓，他來到這殿在你的壇前起誓，',
    '王上8:32 求你在天上垂聽，判斷你的僕人：定惡人有罪，照他所行的報應在他頭上；定義人有理，照他的義賞賜他。',
    '王上8:33 你的民以色列若得罪你，敗在仇敵面前，又歸向你，承認你的名，在這殿裡祈求禱告，',
    '王上8:34 求你在天上垂聽，赦免你民以色列的罪，使他們歸回你賜給他們列祖之地。',
    '王上8:35 你的民因得罪你，你懲罰他們，使天閉塞不下雨；他們若向此處禱告，承認你的名，離開他們的罪，',
    '王上8:36 求你在天上垂聽，赦免你僕人以色列民的罪，將當行的善道指教他們，且降雨在你的地，就是你賜給你民為業之地。',
    '王上8:37 國中若有饑荒、瘟疫、旱風、霉爛、蝗蟲、螞蚱，或有仇敵犯境圍困城邑，無論遭遇什麼災禍疾病，',
    '王上8:38 你的民以色列，或是眾人，或是一人，自覺有罪【原文作災】，向這殿舉手，無論祈求什麼，禱告什麼，',
    '王上8:39 求你在天上你的居所垂聽赦免。你是知道人心的，要照各人所行的待他們（惟有你知道世人的心），',
    '王上8:40 使他們在你賜給我們列祖之地上一生一世敬畏你。',
    '王上8:41 論到不屬你民以色列的外邦人，為你名從遠方而來，',
    '王上8:42 （他們聽人論說你的大名和大能的手，並伸出來的膀臂）向這殿禱告，',
    '王上8:43 求你在天上你的居所垂聽，照著外邦人所祈求的而行，使天下萬民都認識你的名，敬畏你像你的民以色列一樣；又使他們知道我建造的這殿是稱為你名下的。',
    '王上8:44 你的民若奉你的差遣，無論往何處去與仇敵爭戰，向耶和華所選擇的城與我為你名所建造的殿禱告，',
    '王上8:45 求你在天上垂聽他們的禱告祈求，使他們得勝。',
    '王上8:46 你的民若得罪你（世上沒有不犯罪的人），你向他們發怒，將他們交給仇敵擄到仇敵之地，或遠或近，',
    '王上8:47 他們若在擄到之地想起罪來，回心轉意，懇求你說：我們有罪了，我們悖逆了，我們作惡了；',
    '王上8:48 他們若在擄到之地盡心盡性歸服你，又向自己的地，就是你賜給他們列祖之地和你所選擇的城，並我為你名所建造的殿禱告，',
    '王上8:49 求你在天上你的居所垂聽他們的禱告祈求，為他們伸冤；',
    '王上8:50 饒恕得罪你的民，赦免他們的一切過犯，使他們在擄他們的人面前蒙憐恤。',
    '王上8:51 因為他們是你的子民，你的產業，是你從埃及領出來脫離鐵爐的。',
    '王上8:52 願你的眼目看顧僕人，聽你民以色列的祈求，無論何時向你祈求，願你垂聽。',
    '王上8:53 主耶和華啊，你將他們從地上的萬民中分別出來作你的產業，是照你領我們列祖出埃及的時候，藉你僕人摩西所應許的話。',
    '王上8:54 所羅門在耶和華的壇前屈膝跪著，向天舉手，在耶和華面前禱告祈求已畢，就起來，',
    '王上8:55 站著，大聲為以色列全會眾祝福，說：',
    '王上8:56 耶和華是應當稱頌的！因為他照著一切所應許的賜平安給他的民以色列人，凡藉他僕人摩西應許賜福的話，一句都沒有落空。',
    '王上8:57 願耶和華─我們的神與我們同在，像與我們列祖同在一樣，不撇下我們，不丟棄我們，',
    '王上8:58 使我們的心歸向他，遵行他的道，謹守他吩咐我們列祖的誡命、律例、典章。',
    '王上8:59 我在耶和華面前祈求的這些話，願耶和華─我們的神晝夜垂念，每日為他僕人與他民以色列伸冤，',
    '王上8:60 使地上的萬民都知道惟獨耶和華是神，並無別神。',
    '王上8:61 所以你們當向耶和華─我們的神存誠實的心，遵行他的律例，謹守他的誡命，至終如今日一樣。',
    '王上8:62 王和以色列眾民一同在耶和華面前獻祭。',
    '王上8:63 所羅門向耶和華獻平安祭，用牛二萬二千，羊十二萬。這樣，王和以色列眾民為耶和華的殿行奉獻之禮。',
    '王上8:64 當日，王因耶和華殿前的銅壇太小，容不下燔祭、素祭，和平安祭牲的脂油，便將耶和華殿前院子當中分別為聖，在那裡獻燔祭、素祭，和平安祭牲的脂油。',
    '王上8:65 那時，所羅門和以色列眾人，就是從哈馬口直到埃及小河所有的以色列人，都聚集成為大會，在耶和華─我們的神面前守節七日又七日，共十四日。',
    '王上8:66 第八日，王遣散眾民；他們都為王祝福。因見耶和華向他僕人大衛和他民以色列所施的一切恩惠，就都心中喜樂，各歸各家去了。',
    '王上9:1 所羅門建造耶和華殿和王宮，並一切所願意建造的都完畢了，',
    '王上9:2 耶和華就二次向所羅門顯現，如先前在基遍向他顯現一樣，',
    '王上9:3 對他說：你向我所禱告祈求的，我都應允了。我已將你所建的這殿分別為聖，使我的名永遠在其中；我的眼、我的心也必常在那裡。',
    '王上9:4 你若效法你父大衛，存誠實正直的心行在我面前，遵行我一切所吩咐你的，謹守我的律例典章，',
    '王上9:5 我就必堅固你的國位在以色列中，直到永遠，正如我應許你父大衛說：你的子孫必不斷人坐以色列的國位。',
    '王上9:6 倘若你們和你們的子孫轉去不跟從我，不守我指示你們的誡命律例，去事奉敬拜別神，',
    '王上9:7 我就必將以色列人從我賜給他們的地上剪除，並且我為己名所分別為聖的殿也必捨棄不顧，使以色列人在萬民中作笑談，被譏誚。',
    '王上9:8 這殿雖然甚高，將來經過的人必驚訝、嗤笑，說：耶和華為何向這地和這殿如此行呢﹖',
    '王上9:9 人必回答說：是因此地的人離棄領他們列祖出埃及地之耶和華─他們的神，去親近別神，事奉敬拜他，所以耶和華使這一切災禍臨到他們。',
    '王上9:10 所羅門建造耶和華殿和王宮，這兩所二十年才完畢了。',
    '王上9:11 推羅王希蘭曾照所羅門所要的，資助他香柏木、松木，和金子；所羅門王就把加利利地的二十座城給了希蘭。',
    '王上9:12 希蘭從推羅出來，察看所羅門給他的城邑，就不喜悅，',
    '王上9:13 說：我兄啊，你給我的是什麼城邑呢﹖他就給這城邑之地起名叫迦步勒，直到今日。',
    '王上9:14 希蘭給所羅門一百二十他連得金子。',
    '王上9:15 所羅門王挑取服苦的人，是為建造耶和華的殿、自己的宮、米羅、耶路撒冷的城牆、夏瑣、米吉多，並基色。',
    '王上9:16 先前埃及王法老上來攻取基色，用火焚燒，殺了城內居住的迦南人，將城賜給他女兒所羅門的妻作妝奩。',
    '王上9:17 所羅門建造基色、下伯和崙、',
    '王上9:18 巴拉，並國中曠野裡的達莫，',
    '王上9:19 又建造所有的積貨城，並屯車和馬兵的城，與耶路撒冷、利巴嫩，以及自己治理的全國中所願建造的。',
    '王上9:20 至於國中所剩下不屬以色列人的亞摩利人、赫人、比利洗人、希未人、耶布斯人，',
    '王上9:21 就是以色列人不能滅盡的，所羅門挑取他們的後裔作服苦的奴僕，直到今日。',
    '王上9:22 惟有以色列人，所羅門不使他們作奴僕，乃是作他的戰士、臣僕、統領、軍長、車兵長、馬兵長。',
    '王上9:23 所羅門有五百五十督工的，監管工人。',
    '王上9:24 法老的女兒從大衛城搬到所羅門為他建造的宮裡。那時，所羅門才建造米羅。',
    '王上9:25 所羅門每年三次在他為耶和華所築的壇上獻燔祭和平安祭，又在耶和華面前的壇上燒香。這樣，他建造殿的工程完畢了。',
    '王上9:26 所羅門王在以東地紅海邊，靠近以祿的以旬迦別製造船隻。',
    '王上9:27 希蘭差遣他的僕人，就是熟悉泛海的船家，與所羅門的僕人一同坐船航海。',
    '王上9:28 他們到了俄斐，從那裡得了四百二十他連得金子，運到所羅門王那裡。',
    '王上10:1 示巴女王聽見所羅門因耶和華之名所得的名聲，就來要用難解的話試問所羅門。',
    '王上10:2 跟隨他到耶路撒冷的人甚多，又有駱駝馱著香料、寶石，和許多金子。他來見了所羅門王，就把心裡所有的對所羅門都說出來。',
    '王上10:3 所羅門王將他所問的都答上了，沒有一句不明白、不能答的。',
    '王上10:4 示巴女王見所羅門大有智慧，和他所建造的宮室，',
    '王上10:5 席上的珍饈美味，群臣分列而坐，僕人兩旁侍立，以及他們的衣服裝飾和酒政的衣服裝飾，又見他上耶和華殿的臺階【或作他在耶和華殿裡所獻的燔祭】，就詫異得神不守舍；',
    '王上10:6 對王說：我在本國裡所聽見論到你的事和你的智慧實在是真的！',
    '王上10:7 我先不信那些話，及至我來親眼見了才知道人所告訴我的還不到一半。你的智慧和你的福分越過我所聽見的風聲。',
    '王上10:8 你的臣子、你的僕人常侍立在你面前聽你智慧的話是有福的！',
    '王上10:9 耶和華─你的神是應當稱頌的！他喜悅你，使你坐以色列的國位；因為他永遠愛以色列，所以立你作王，使你秉公行義。',
    '王上10:10 於是，示巴女王將一百二十他連得金子和寶石，與極多的香料，送給所羅門王。他送給王的香料，以後奉來的不再有這樣多。',
    '王上10:11 （希蘭的船隻從俄斐運了金子來，又從俄斐運了許多檀香木【或作烏木；下同】和寶石來。',
    '王上10:12 王用檀香木為耶和華殿和王宮做欄杆，又為歌唱的人做琴瑟。以後再沒有這樣的檀香木進國來，也沒有人看見過，直到如今。）',
    '王上10:13 示巴女王一切所要所求的，所羅門王都送給他，另外照自己的厚意餽送他。於是女王和他臣僕轉回本國去了。',
    '王上10:14 所羅門每年所得的金子共有六百六十六他連得。',
    '王上10:15 另外還有商人和雜族【歷代下九章14節作亞拉伯】的諸王，與國中的省長所進的金子。',
    '王上10:16 所羅門王用錘出來的金子打成擋牌二百面，每面用金子六百舍客勒；',
    '王上10:17 又用錘出來的金子打成盾牌三百面，每面用金子三彌那，都放在利巴嫩林宮裡。',
    '王上10:18 王用象牙製造一個寶座，用精金包裹。',
    '王上10:19 寶座有六層臺階，座的後背是圓的，兩旁有扶手，靠近扶手有兩個獅子站立。',
    '王上10:20 六層臺階上有十二個獅子站立，每層有兩個：左邊一個，右邊一個；在列國中沒有這樣做的。',
    '王上10:21 所羅門王一切的飲器都是金子的。利巴嫩林宮裡的一切器皿都是精金的。所羅門年間，銀子算不了什麼。',
    '王上10:22 因為王有他施船隻與希蘭的船隻一同航海，三年一次，裝載金銀、象牙、猿猴、孔雀回來。',
    '王上10:23 所羅門王的財寶與智慧勝過天下的列王。',
    '王上10:24 普天下的王都求見所羅門，要聽神賜給他智慧的話。',
    '王上10:25 他們各帶貢物，就是金器、銀器、衣服、軍械、香料、騾馬，每年有一定之例。',
    '王上10:26 所羅門聚集戰車馬兵，有戰車一千四百輛，馬兵一萬二千名，安置在屯車的城邑和耶路撒冷，就是王那裡。',
    '王上10:27 王在耶路撒冷使銀子多如石頭，香柏木多如高原的桑樹。',
    '王上10:28 所羅門的馬是從埃及帶來的，是王的商人一群一群按著定價買來的。',
    '王上10:29 從埃及買來的車，每輛價銀六百舍客勒，馬每匹一百五十舍客勒。赫人諸王和亞蘭諸王所買的車馬，也是按這價值經他們手買來的。',
    '王上11:1 所羅門王在法老的女兒之外，又寵愛許多外邦女子，就是摩押女子、亞捫女子、以東女子、西頓女子、赫人女子。',
    '王上11:2 論到這些國的人，耶和華曾曉諭以色列人說：你們不可與他們往來相通，因為他們必誘惑你們的心去隨從他們的神。所羅門卻戀愛這些女子。',
    '王上11:3 所羅門有妃七百，都是公主；還有嬪三百。這些妃嬪誘惑他的心。',
    '王上11:4 所羅門年老的時候，他的妃嬪誘惑他的心去隨從別神，不效法他父親大衛誠誠實實地順服耶和華─他的神。',
    '王上11:5 因為所羅門隨從西頓人的女神亞斯她錄和亞捫人可憎的神米勒公。',
    '王上11:6 所羅門行耶和華眼中看為惡的事，不效法他父親大衛專心順從耶和華。',
    '王上11:7 所羅門為摩押可憎的神基抹和亞捫人可憎的神摩洛，在耶路撒冷對面的山上建築邱壇。',
    '王上11:8 他為那些向自己的神燒香獻祭的外邦女子，就是他娶來的妃嬪也是這樣行。',
    '王上11:9 耶和華向所羅門發怒，因為他的心偏離向他兩次顯現的耶和華─以色列的神。',
    '王上11:10 耶和華曾吩咐他不可隨從別神，他卻沒有遵守耶和華所吩咐的。',
    '王上11:11 所以耶和華對他說：你既行了這事，不遵守我所吩咐你守的約和律例，我必將你的國奪回，賜給你的臣子。',
    '王上11:12 然而，因你父親大衛的緣故，我不在你活著的日子行這事，必從你兒子的手中將國奪回。',
    '王上11:13 只是我不將全國奪回，要因我僕人大衛和我所選擇的耶路撒冷，還留一支派給你的兒子。',
    '王上11:14 耶和華使以東人哈達興起，作所羅門的敵人；他是以東王的後裔。',
    '王上11:15 先前大衛攻擊以東，元帥約押上去葬埋陣亡的人，將以東的男丁都殺了。',
    '王上11:16 約押和以色列眾人在以東住了六個月，直到將以東的男丁盡都剪除。',
    '王上11:17 那時哈達還是幼童；他和他父親的臣僕，幾個以東人逃往埃及。',
    '王上11:18 他們從米甸起行，到了巴蘭；從巴蘭帶著幾個人來到埃及見埃及王法老；法老為他派定糧食，又給他房屋田地。',
    '王上11:19 哈達在法老面前大蒙恩惠，以致法老將王后答比匿的妹子賜他為妻。',
    '王上11:20 答比匿的妹子給哈達生了一個兒子，名叫基努拔。答比匿使基努拔在法老的宮裡斷奶，基努拔就與法老的眾子一同住在法老的宮裡。',
    '王上11:21 哈達在埃及聽見大衛與他列祖同睡，元帥約押也死了，就對法老說：求王容我回本國去。',
    '王上11:22 法老對他說：你在我這裡有什麼缺乏，你竟要回你本國去呢﹖他回答說：我沒有缺乏什麼，只是求王容我回去。',
    '王上11:23 神又使以利亞大的兒子利遜興起，作所羅門的敵人。他先前逃避主人瑣巴王哈大底謝。',
    '王上11:24 大衛擊殺瑣巴人的時候，利遜招聚了一群人，自己作他們的頭目，往大馬色居住，在那裡作王。',
    '王上11:25 所羅門活著的時候，哈達為患之外，利遜也作以色列的敵人。他恨惡以色列人，且作了亞蘭人的王。',
    '王上11:26 所羅門的臣僕、尼八的兒子耶羅波安也舉手攻擊王。他是以法蓮支派的洗利達人，他母親是寡婦，名叫洗魯阿。',
    '王上11:27 他舉手攻擊王的緣故，乃由先前所羅門建造米羅，修補他父親大衛城的破口。',
    '王上11:28 耶羅波安是大有才能的人。所羅門見這少年人殷勤，就派他監管約瑟家的一切工程。',
    '王上11:29 一日，耶羅波安出了耶路撒冷，示羅人先知亞希雅在路上遇見他；亞希雅身上穿著一件新衣。他們二人在田野，以外並無別人。',
    '王上11:30 亞希雅將自己穿的那件新衣撕成十二片，',
    '王上11:31 對耶羅波安說：你可以拿十片。耶和華─以色列的神如此說：我必將國從所羅門手裡奪回，將十個支派賜給你。',
    '王上11:32 （我因僕人大衛和我在以色列眾支派中所選擇的耶路撒冷城的緣故，仍給所羅門留一個支派。）',
    '王上11:33 因為他離棄我，敬拜西頓人的女神亞斯她錄、摩押的神基抹，和亞捫人的神米勒公，沒有遵從我的道，行我眼中看為正的事，守我的律例典章，像他父親大衛一樣。',
    '王上11:34 但我不從他手裡將全國奪回；使他終身為君，是因我所揀選的僕人大衛謹守我的誡命律例。',
    '王上11:35 我必從他兒子的手裡將國奪回，以十個支派賜給你，',
    '王上11:36 還留一個支派給他的兒子，使我僕人大衛在我所選擇立我名的耶路撒冷城裡，在我面前長有燈光。',
    '王上11:37 我必揀選你，使你照心裡一切所願的，作王治理以色列。',
    '王上11:38 你若聽從我一切所吩咐你的，遵行我的道，行我眼中看為正的事，謹守我的律例誡命，像我僕人大衛所行的，我就與你同在，為你立堅固的家，像我為大衛所立的一樣，將以色列人賜給你。',
    '王上11:39 我必因所羅門所行的使大衛後裔受患難，但不至於永遠。',
    '王上11:40 所羅門因此想要殺耶羅波安。耶羅波安卻起身逃往埃及；到了埃及王示撒那裡，就住在埃及，直到所羅門死了。',
    '王上11:41 所羅門其餘的事，凡他所行的和他的智慧都寫在所羅門記上。',
    '王上11:42 所羅門在耶路撒冷作以色列眾人的王共四十年。',
    '王上11:43 所羅門與他列祖同睡，葬在他父親大衛的城裡。他兒子羅波安接續他作王。',
    '王上12:1 羅波安往示劍去；因為以色列人都到了示劍要立他作王。',
    '王上12:2 尼八的兒子耶羅波安先前躲避所羅門王，逃往埃及，住在那裡（他聽見這事。）',
    '王上12:3 以色列人打發人去請他來，他就和以色列會眾都來見羅波安，對他說：',
    '王上12:4 你父親使我們負重軛，做苦工，現在求你使我們做的苦工、負的重軛輕鬆些，我們就事奉你。',
    '王上12:5 羅波安對他們說：你們暫且去，第三日再來見我。民就去了。',
    '王上12:6 羅波安之父所羅門在世的日子，有侍立在他面前的老年人，羅波安王和他們商議，說：你們給我出個什麼主意，我好回覆這民。',
    '王上12:7 老年人對他說：現在王若服事這民如僕人，用好話回答他們，他們就永遠作王的僕人。',
    '王上12:8 王卻不用老年人給他出的主意，就和那些與他一同長大、在他面前侍立的少年人商議，',
    '王上12:9 說：這民對我說：你父親使我們負重軛，求你使我們輕鬆些。你們給我出個什麼主意，我好回覆他們。',
    '王上12:10 那同他長大的少年人說：這民對王說：你父親使我們負重軛，求你使我們輕鬆些。王要對他們如此說：我的小拇指頭比我父親的腰還粗。',
    '王上12:11 我父親使你們負重軛，我必使你們負更重的軛！我父親用鞭子責打你們，我要用蠍子鞭責打你們！',
    '王上12:12 耶羅波安和眾百姓遵著羅波安王所說你們第三日再來見我的那話，第三日他們果然來了。',
    '王上12:13 王用嚴厲的話回答百姓，不用老年人給他所出的主意，',
    '王上12:14 照著少年人所出的主意對民說：我父親使你們負重軛，我必使你們負更重的軛！我父親用鞭子責打你們，我要用蠍子鞭責打你們！',
    '王上12:15 王不肯依從百姓，這事乃出於耶和華，為要應驗他藉示羅人亞希雅對尼八的兒子耶羅波安所說的話。',
    '王上12:16 以色列眾民見王不依從他們，就對王說：我們與大衛有什麼分兒呢﹖與耶西的兒子並沒有關涉。以色列人哪，各回各家去吧！大衛家啊，自己顧自己吧！於是，以色列人都回自己家裡去了，',
    '王上12:17 惟獨住猶大城邑的以色列人，羅波安仍作他們的王。',
    '王上12:18 羅波安王差遣掌管服苦之人的亞多蘭往以色列人那裡去，以色列人就用石頭打死他。羅波安王急忙上車，逃回耶路撒冷去了。',
    '王上12:19 這樣，以色列人背叛大衛家，直到今日。',
    '王上12:20 以色列眾人聽見耶羅波安回來了，就打發人去請他到會眾面前，立他作以色列眾人的王。除了猶大支派以外，沒有順從大衛家的。',
    '王上12:21 羅波安來到耶路撒冷，招聚猶大全家和便雅憫支派的人共十八萬，都是挑選的戰士，要與以色列家爭戰，好將國奪回，再歸所羅門的兒子羅波安。',
    '王上12:22 但神的話臨到神人示瑪雅，說：',
    '王上12:23 你去告訴所羅門的兒子猶大王羅波安和猶大、便雅憫全家，並其餘的民說：',
    '王上12:24 耶和華如此說：你們不可上去與你們的弟兄以色列人爭戰。各歸各家去吧！因為這事出於我。眾人就聽從耶和華的話，遵著耶和華的命回去了。',
    '王上12:25 耶羅波安在以法蓮山地建築示劍，就住在其中；又從示劍出去，建築毘努伊勒。',
    '王上12:26 耶羅波安心裡說：恐怕這國仍歸大衛家；',
    '王上12:27 這民若上耶路撒冷去，在耶和華的殿裡獻祭，他們的心必歸向他們的主─猶大王羅波安，就把我殺了，仍歸猶大王羅波安。',
    '王上12:28 耶羅波安王就籌劃定妥，鑄造了兩個金牛犢，對眾民說：以色列人哪，你們上耶路撒冷去實在是難；這就是領你們出埃及地的神。',
    '王上12:29 他就把牛犢一隻安在伯特利，一隻安在但。',
    '王上12:30 這事叫百姓陷在罪裡，因為他們往但去拜那牛犢。',
    '王上12:31 耶羅波安在邱壇那裡建殿，將那不屬利未人的凡民立為祭司。',
    '王上12:32 耶羅波安定八月十五日為節期，像在猶大的節期一樣，自己上壇獻祭。他在伯特利也這樣向他所鑄的牛犢獻祭，又將立為邱壇的祭司安置在伯特利。',
    '王上12:33 他在八月十五日，就是他私自所定的月日，為以色列人立作節期的日子，在伯特利上壇燒香。',
    '王上13:1 那時，有一個神人奉耶和華的命從猶大來到伯特利。耶羅波安正站在壇旁要燒香；',
    '王上13:2 神人奉耶和華的命向壇呼叫，說：壇哪，壇哪！耶和華如此說：大衛家裡必生一個兒子，名叫約西亞，他必將邱壇的祭司，就是在你上面燒香的，殺在你上面，人的骨頭也必燒在你上面。',
    '王上13:3 當日，神人設個預兆，說：這壇必破裂，壇上的灰必傾撒，這是耶和華說的預兆。',
    '王上13:4 耶羅波安王聽見神人向伯特利的壇所呼叫的話，就從壇上伸手，說：拿住他吧！王向神人所伸的手就枯乾了，不能彎回；',
    '王上13:5 壇也破裂了，壇上的灰傾撒了，正如神人奉耶和華的命所設的預兆。',
    '王上13:6 王對神人說：請你為我禱告，求耶和華─你神的恩典使我的手復原。於是神人祈禱耶和華，王的手就復了原，仍如尋常一樣。',
    '王上13:7 王對神人說：請你同我回去吃飯，加添心力，我也必給你賞賜。',
    '王上13:8 神人對王說：你就是把你的宮一半給我，我也不同你進去，也不在這地方吃飯喝水；',
    '王上13:9 因為有耶和華的話囑咐我，說不可在伯特利吃飯喝水，也不可從你去的原路回來。',
    '王上13:10 於是神人從別的路回去，不從伯特利來的原路回去。',
    '王上13:11 有一個老先知住在伯特利，他兒子們來，將神人當日在伯特利所行的一切事和向王所說的話都告訴了父親。',
    '王上13:12 父親問他們說：神人從哪條路去了呢﹖兒子們就告訴他；原來他們看見那從猶大來的神人所去的路。',
    '王上13:13 老先知就吩咐他兒子們說：你們為我備驢。他們備好了驢，他就騎上，',
    '王上13:14 去追趕神人，遇見他坐在橡樹底下，就問他說：你是從猶大來的神人不是﹖他說：是。',
    '王上13:15 老先知對他說：請你同我回家吃飯。',
    '王上13:16 神人說：我不可同你回去進你的家，也不可在這裡同你吃飯喝水；',
    '王上13:17 因為有耶和華的話囑咐我說：你在那裡不可吃飯喝水，也不可從你去的原路回來。',
    '王上13:18 老先知對他說：我也是先知，和你一樣。有天使奉耶和華的命對我說：你去把他帶回你的家，叫他吃飯喝水。這都是老先知誆哄他。',
    '王上13:19 於是神人同老先知回去，在他家裡吃飯喝水。',
    '王上13:20 二人坐席的時候，耶和華的話臨到那帶神人回來的先知，',
    '王上13:21 他就對那從猶大來的神人說：耶和華如此說：你既違背耶和華的話，不遵守耶和華─你神的命令，',
    '王上13:22 反倒回來，在耶和華禁止你吃飯喝水的地方吃了喝了，因此你的屍身不得入你列祖的墳墓。',
    '王上13:23 吃喝完了，老先知為所帶回來的先知備驢。',
    '王上13:24 他就去了，在路上有個獅子遇見他，將他咬死，屍身倒在路上，驢站在屍身旁邊，獅子也站在屍身旁邊。',
    '王上13:25 有人從那裡經過，看見屍身倒在路上，獅子站在屍身旁邊，就來到老先知所住的城裡述說這事。',
    '王上13:26 那帶神人回來的先知聽見這事，就說：這是那違背了耶和華命令的神人，所以耶和華把他交給獅子；獅子抓傷他，咬死他，是應驗耶和華對他說的話。',
    '王上13:27 老先知就吩咐他兒子們說：你們為我備驢。他們就備了驢。',
    '王上13:28 他去了，看見神人的屍身倒在路上，驢和獅子站在屍身旁邊，獅子卻沒有吃屍身，也沒有抓傷驢。',
    '王上13:29 老先知就把神人的屍身馱在驢上，帶回自己的城裡，要哀哭他，葬埋他；',
    '王上13:30 就把他的屍身葬在自己的墳墓裡，哀哭他，說：哀哉！我兄啊。',
    '王上13:31 安葬之後，老先知對他兒子們說：我死了，你們要葬我在神人的墳墓裡，使我的屍骨靠近他的屍骨，',
    '王上13:32 因為他奉耶和華的命指著伯特利的壇和撒瑪利亞各城有邱壇之殿所說的話必定應驗。',
    '王上13:33 這事以後，耶羅波安仍不離開他的惡道，將凡民立為邱壇的祭司；凡願意的，他都分別為聖，立為邱壇的祭司。',
    '王上13:34 這事叫耶羅波安的家陷在罪裡，甚至他的家從地上除滅了。',
    '王上14:1 那時，耶羅波安的兒子亞比雅病了。',
    '王上14:2 耶羅波安對他的妻說：你可以起來改裝，使人不知道你是耶羅波安的妻，往示羅去，在那裡有先知亞希雅。他曾告訴我說，你必作這民的王。',
    '王上14:3 現在你要帶十個餅，與幾個薄餅，和一瓶蜜去見他，他必告訴你兒子將要怎樣。',
    '王上14:4 耶羅波安的妻就這樣行，起身往示羅去，到了亞希雅的家。亞希雅因年紀老邁，眼目發直，不能看見。',
    '王上14:5 耶和華先曉諭亞希雅說：耶羅波安的妻要來問你，因他兒子病了，你當如此如此告訴他。他進來的時候必裝作別的婦人。',
    '王上14:6 他剛進門，亞希雅聽見他腳步的響聲，就說：耶羅波安的妻，進來吧！你為何裝作別的婦人呢﹖我奉差遣將凶事告訴你。',
    '王上14:7 你回去告訴耶羅波安說：耶和華─以色列的神如此說：我從民中將你高舉，立你作我民以色列的君，',
    '王上14:8 將國從大衛家奪回賜給你；你卻不效法我僕人大衛，遵守我的誡命，一心順從我，行我眼中看為正的事。',
    '王上14:9 你竟行惡，比那在你以先的更甚，為自己立了別神，鑄了偶像，惹我發怒，將我丟在背後。',
    '王上14:10 因此，我必使災禍臨到耶羅波安的家，將屬耶羅波安的男丁，無論困住的、自由的都從以色列中剪除，必除盡耶羅波安的家，如人除盡糞土一般。',
    '王上14:11 凡屬耶羅波安的人，死在城中的必被狗吃，死在田野的必被空中的鳥吃。這是耶和華說的。',
    '王上14:12 所以你起身回家去吧！你的腳一進城，你兒子就必死了。',
    '王上14:13 以色列眾人必為他哀哭，將他葬埋。凡屬耶羅波安的人，惟有他得入墳墓；因為在耶羅波安的家中，只有他向耶和華─以色列的神顯出善行。',
    '王上14:14 耶和華必另立一王治理以色列。到了日期，他必剪除耶羅波安的家；那日期已經到了。',
    '王上14:15 耶和華必擊打以色列人，使他們搖動，像水中的蘆葦一般；又將他們從耶和華賜給他們列祖的美地上拔出來，分散在大河那邊；因為他們做木偶，惹耶和華發怒。',
    '王上14:16 因耶羅波安所犯的罪，又使以色列人陷在罪裡，耶和華必將以色列人交給仇敵。',
    '王上14:17 耶羅波安的妻起身回去，到了得撒，剛到門檻，兒子就死了。',
    '王上14:18 以色列眾人將他葬埋，為他哀哭，正如耶和華藉他僕人先知亞希雅所說的話。',
    '王上14:19 耶羅波安其餘的事，他怎樣爭戰，怎樣作王，都寫在以色列諸王記上。',
    '王上14:20 耶羅波安作王二十二年，就與他列祖同睡。他兒子拿答接續他作王。',
    '王上14:21 所羅門的兒子羅波安作猶大王。他登基的時候年四十一歲，在耶路撒冷，就是耶和華從以色列眾支派中所選擇立他名的城，作王十七年。羅波安的母親名叫拿瑪，是亞捫人。',
    '王上14:22 猶大人行耶和華眼中看為惡的事，犯罪觸動他的憤恨，比他們列祖更甚。',
    '王上14:23 因為他們在各高岡上，各青翠樹下築壇，立柱像和木偶。',
    '王上14:24 國中也有孌童。猶大人效法耶和華在以色列人面前所趕出的外邦人，行一切可憎惡的事。',
    '王上14:25 羅波安王第五年，埃及王示撒上來攻取耶路撒冷，',
    '王上14:26 奪了耶和華殿和王宮裡的寶物，盡都帶走，又奪去所羅門製造的金盾牌。',
    '王上14:27 羅波安王製造銅盾牌代替那金盾牌，交給守王宮門的護衛長看守。',
    '王上14:28 王每逢進耶和華的殿，護衛兵就拿這盾牌，隨後仍將盾牌送回，放在護衛房。',
    '王上14:29 羅波安其餘的事，凡他所行的，都寫在猶大列王記上。',
    '王上14:30 羅波安與耶羅波安時常爭戰。',
    '王上14:31 羅波安與他列祖同睡，葬在大衛城他列祖的墳地裡。他母親名叫拿瑪，是亞捫人。他兒子亞比央【又名亞比雅】接續他作王。',
    '王上15:1 尼八的兒子耶羅波安王十八年，亞比央登基作猶大王，',
    '王上15:2 在耶路撒冷作王三年。他母親名叫瑪迦，是押沙龍的女兒。',
    '王上15:3 亞比央行他父親在他以前所行的一切惡，他的心不像他祖大衛的心，誠誠實實地順服耶和華─他的神。',
    '王上15:4 然而耶和華─他的神因大衛的緣故，仍使他在耶路撒冷有燈光，叫他兒子接續他作王，堅立耶路撒冷。',
    '王上15:5 因為大衛除了赫人烏利亞那件事，都是行耶和華眼中看為正的事，一生沒有違背耶和華一切所吩咐的。',
    '王上15:6 羅波安在世的日子常與耶羅波安爭戰。',
    '王上15:7 亞比央其餘的事，凡他所行的，都寫在猶大列王記上。亞比央常與耶羅波安爭戰。',
    '王上15:8 亞比央與他列祖同睡，葬在大衛的城裡。他兒子亞撒接續他作王。',
    '王上15:9 以色列王耶羅波安二十年，亞撒登基作猶大王，',
    '王上15:10 在耶路撒冷作王四十一年。他祖母名叫瑪迦，是押沙龍的女兒。',
    '王上15:11 亞撒效法他祖大衛行耶和華眼中看為正的事，',
    '王上15:12 從國中除去孌童，又除掉他列祖所造的一切偶像；',
    '王上15:13 並且貶了他祖母瑪迦太后的位，因他造了可憎的偶像亞舍拉。亞撒砍下他的偶像，燒在汲淪溪邊，',
    '王上15:14 只是邱壇還沒有廢去。亞撒一生卻向耶和華存誠實的心。',
    '王上15:15 亞撒將他父親所分別為聖與自己所分別為聖的金銀和器皿都奉到耶和華的殿裡。',
    '王上15:16 亞撒和以色列王巴沙在世的日子常常爭戰。',
    '王上15:17 以色列王巴沙上來要攻擊猶大，修築拉瑪，不許人從猶大王亞撒那裡出入。',
    '王上15:18 於是亞撒將耶和華殿和王宮府庫裡所剩下的金銀都交在他臣僕手中，打發他們往住大馬色的亞蘭王─希旬的孫子、他伯利們的兒子便哈達那裡去，',
    '王上15:19 說：你父曾與我父立約，我與你也要立約。現在我將金銀送你為禮物，求你廢掉你與以色列王巴沙所立的約，使他離開我。',
    '王上15:20 便哈達聽從亞撒王的話，派軍長去攻擊以色列的城邑；他們就攻破以雲、但、亞伯伯瑪迦、基尼烈全境、拿弗他利全境。',
    '王上15:21 巴沙聽見，就停工不修築拉瑪了，仍住在得撒。',
    '王上15:22 於是亞撒王宣告猶大眾人，不准一個推辭，吩咐他們將巴沙修築拉瑪所用的石頭、木頭都運去，用以修築便雅憫的迦巴和米斯巴。',
    '王上15:23 亞撒其餘的事，凡他所行的，並他的勇力與他所建築的城邑，都寫在猶大列王記上。亞撒年老的時候，腳上有病。',
    '王上15:24 亞撒與他列祖同睡，葬在他祖大衛城他列祖的墳地裡。他兒子約沙法接續他作王。',
    '王上15:25 猶大王亞撒第二年，耶羅波安的兒子拿答登基作以色列王共二年，',
    '王上15:26 拿答行耶和華眼中看為惡的事，行他父親所行的，犯他父親使以色列人陷在罪裡的那罪。',
    '王上15:27 以薩迦人亞希雅的兒子巴沙背叛拿答，在非利士的基比頓殺了他。那時拿答和以色列眾人正圍困基比頓。',
    '王上15:28 在猶大王亞撒第三年巴沙殺了他，篡了他的位。',
    '王上15:29 巴沙一作王就殺了耶羅波安的全家，凡有氣息的沒有留下一個，都滅盡了，正應驗耶和華藉他僕人示羅人亞希雅所說的話。',
    '王上15:30 這是因為耶羅波安所犯的罪使以色列人陷在罪裡，惹動耶和華─以色列神的怒氣。',
    '王上15:31 拿答其餘的事，凡他所行的，都寫在以色列諸王記上。',
    '王上15:32 亞撒和以色列王巴沙在世的日子常常爭戰。',
    '王上15:33 猶大王亞撒第三年，亞希雅的兒子巴沙在得撒登基作以色列眾人的王共廿四年。',
    '王上15:34 他行耶和華眼中看為惡的事，行耶羅波安所行的道，犯他使以色列人陷在罪裡的那罪。',
    '王上16:1 耶和華的話臨到哈拿尼的兒子耶戶，責備巴沙說：',
    '王上16:2 我既從塵埃中提拔你，立你作我民以色列的君，你竟行耶羅波安所行的道，使我民以色列陷在罪裡，惹我發怒，',
    '王上16:3 我必除盡你和你的家，使你的家像尼八的兒子耶羅波安的家一樣。',
    '王上16:4 凡屬巴沙的人，死在城中的必被狗吃，死在田野的必被空中的鳥吃。',
    '王上16:5 巴沙其餘的事，凡他所行的和他的勇力，都寫在以色列諸王記上。',
    '王上16:6 巴沙與他列祖同睡，葬在得撒。他兒子以拉接續他作王。',
    '王上16:7 耶和華的話臨到哈拿尼的兒子先知耶戶，責備巴沙和他的家，因他行耶和華眼中看為惡的一切事，以他手所做的惹耶和華發怒，像耶羅波安的家一樣，又因他殺了耶羅波安的全家。',
    '王上16:8 猶大王亞撒二十六年，巴沙的兒子以拉在得撒登基作以色列王共二年。',
    '王上16:9 有管理他一半戰車的臣子心利背叛他。當他在得撒家宰亞雜家裡喝醉的時候，',
    '王上16:10 心利就進去殺了他，篡了他的位。這是猶大王亞撒二十七年的事。',
    '王上16:11 心利一坐王位就殺了巴沙的全家，連他的親屬、朋友也沒有留下一個男丁。',
    '王上16:12 心利這樣滅絕巴沙的全家，正如耶和華藉先知耶戶責備巴沙的話。',
    '王上16:13 這是因巴沙和他兒子以拉的一切罪，就是他們使以色列人陷在罪裡的那罪，以虛無的神惹耶和華─以色列神的怒氣。',
    '王上16:14 以拉其餘的事，凡他所行的，都寫在以色列諸王記上。',
    '王上16:15 猶大王亞撒二十七年，心利在得撒作王七日。那時民正安營圍攻非利士的基比頓。',
    '王上16:16 民在營中聽說心利背叛，又殺了王，故此以色列眾人當日在營中立元帥暗利作以色列王。',
    '王上16:17 暗利率領以色列眾人，從基比頓上去，圍困得撒。',
    '王上16:18 心利見城破失，就進了王宮的衛所，放火焚燒宮殿，自焚而死。',
    '王上16:19 這是因他犯罪，行耶和華眼中看為惡的事，行耶羅波安所行的，犯他使以色列人陷在罪裡的那罪。',
    '王上16:20 心利其餘的事和他背叛的情形都寫在以色列諸王記上。',
    '王上16:21 那時，以色列民分為兩半：一半隨從基納的兒子提比尼，要立他作王；一半隨從暗利。',
    '王上16:22 但隨從暗利的民勝過隨從基納的兒子提比尼的民。提比尼死了，暗利就作了王。',
    '王上16:23 猶大王亞撒三十一年，暗利登基作以色列王共十二年；在得撒作王六年。',
    '王上16:24 暗利用二他連得銀子向撒瑪買了撒瑪利亞山，在山上造城，就按著山的原主撒瑪的名，給所造的城起名叫撒瑪利亞。',
    '王上16:25 暗利行耶和華眼中看為惡的事，比他以前的列王作惡更甚。',
    '王上16:26 因他行了尼八的兒子耶羅波安所行的，犯他使以色列人陷在罪裡的那罪，以虛無的神惹耶和華─以色列神的怒氣。',
    '王上16:27 暗利其餘的事和他所顯出的勇力都寫在以色列諸王記上。',
    '王上16:28 暗利與他列祖同睡，葬在撒瑪利亞。他兒子亞哈接續他作王。',
    '王上16:29 猶大王亞撒三十八年，暗利的兒子亞哈登基作了以色列王。暗利的兒子亞哈在撒瑪利亞作以色列王二十二年。',
    '王上16:30 暗利的兒子亞哈行耶和華眼中看為惡的事，比他以前的列王更甚，',
    '王上16:31 犯了尼八的兒子耶羅波安所犯的罪；他還以為輕，又娶了西頓王謁巴力的女兒耶洗別為妻，去事奉敬拜巴力，',
    '王上16:32 在撒瑪利亞建造巴力的廟，在廟裡為巴力築壇。',
    '王上16:33 亞哈又做亞舍拉，他所行的惹耶和華─以色列神的怒氣，比他以前的以色列諸王更甚。',
    '王上16:34 亞哈在位的時候，有伯特利人希伊勒重修耶利哥城；立根基的時候，喪了長子亞比蘭；安門的時候，喪了幼子西割，正如耶和華藉嫩的兒子約書亞所說的話。',
    '王上17:1 基列寄居的提斯比人以利亞對亞哈說：我指著所事奉永生耶和華─以色列的神起誓，這幾年我若不禱告，必不降露，不下雨。',
    '王上17:2 耶和華的話臨到以利亞說：',
    '王上17:3 你離開這裡往東去，藏在約但河東邊的基立溪旁。',
    '王上17:4 你要喝那溪裡的水，我已吩咐烏鴉在那裡供養你。',
    '王上17:5 於是以利亞照著耶和華的話，去住在約但河東的基立溪旁。',
    '王上17:6 烏鴉早晚給他叼餅和肉來，他也喝那溪裡的水。',
    '王上17:7 過了些日子，溪水就乾了，因為雨沒有下在地上。',
    '王上17:8 耶和華的話臨到他說：',
    '王上17:9 你起身往西頓的撒勒法【撒勒法與路四26同】去，住在那裡；我已吩咐那裡的一個寡婦供養你。',
    '王上17:10 以利亞就起身往撒勒法去。到了城門，見有一個寡婦在那裡撿柴，以利亞呼叫他說：求你用器皿取點水來給我喝。',
    '王上17:11 他去取水的時候，以利亞又呼叫他說：也求你拿點餅來給我！',
    '王上17:12 他說：我指著永生耶和華─你的神起誓，我沒有餅，罈內只有一把麵，瓶裡只有一點油；我現在找兩根柴，回家要為我和我兒子做餅；我們吃了，死就死吧！',
    '王上17:13 以利亞對他說：不要懼怕！可以照你所說的去做吧！只要先為我做一個小餅拿來給我，然後為你和你的兒子做餅。',
    '王上17:14 因為耶和華─以色列的神如此說：罈內的麵必不減少，瓶裡的油必不缺短，直到耶和華使雨降在地上的日子。',
    '王上17:15 婦人就照以利亞的話去行。他和他家中的人，並以利亞，吃了許多日子。',
    '王上17:16 罈內的麵果不減少，瓶裡的油也不缺短，正如耶和華藉以利亞所說的話。',
    '王上17:17 這事以後，作那家主母的婦人，他兒子病了；病得甚重，以致身無氣息。',
    '王上17:18 婦人對以利亞說：神人哪，我與你何干﹖你竟到我這裡來，使神想念我的罪，以致我的兒子死呢﹖',
    '王上17:19 以利亞對他說：把你兒子交給我。以利亞就從婦人懷中將孩子接過來，抱到他所住的樓中，放在自己的床上，',
    '王上17:20 就求告耶和華說：耶和華─我的神啊，我寄居在這寡婦的家裡，你就降禍與他，使他的兒子死了嗎﹖',
    '王上17:21 以利亞三次伏在孩子的身上，求告耶和華說：耶和華─我的神啊，求你使這孩子的靈魂仍入他的身體！',
    '王上17:22 耶和華應允以利亞的話，孩子的靈魂仍入他的身體，他就活了。',
    '王上17:23 以利亞將孩子從樓上抱下來，進屋子交給他母親，說：看哪，你的兒子活了！',
    '王上17:24 婦人對以利亞說：現在我知道你是神人，耶和華藉你口所說的話是真的。',
    '王上18:1 過了許久，到第三年，耶和華的話臨到以利亞說：你去，使亞哈得見你；我要降雨在地上。',
    '王上18:2 以利亞就去，要使亞哈得見他。那時，撒瑪利亞有大饑荒；',
    '王上18:3 亞哈將他的家宰俄巴底召了來。（俄巴底甚是敬畏耶和華，',
    '王上18:4 耶洗別殺耶和華眾先知的時候，俄巴底將一百個先知藏了，每五十人藏在一個洞裡，拿餅和水供養他們。）',
    '王上18:5 亞哈對俄巴底說：我們走遍這地，到一切水泉旁和一切溪邊，或者找得著青草，可以救活騾馬，免得絕了牲畜。',
    '王上18:6 於是二人分地遊行，亞哈獨走一路，俄巴底獨走一路。',
    '王上18:7 俄巴底在路上恰與以利亞相遇，俄巴底認出他來，就俯伏在地，說：你是我主以利亞不是﹖',
    '王上18:8 回答說：是。你去告訴你主人說，以利亞在這裡。',
    '王上18:9 俄巴底說：僕人有什麼罪，你竟要將我交在亞哈手裡，使他殺我呢﹖',
    '王上18:10 我指著永生耶和華─你的神起誓，無論哪一邦哪一國，我主都打發人去找你。若說你沒有在那裡，就必使那邦那國的人起誓說，實在是找不著你。',
    '王上18:11 現在你說，要去告訴你主人說，以利亞在這裡；',
    '王上18:12 恐怕我一離開你，耶和華的靈就提你到我所不知道的地方去。這樣，我去告訴亞哈，他若找不著你，就必殺我；僕人卻是自幼敬畏耶和華的。',
    '王上18:13 耶洗別殺耶和華眾先知的時候，我將耶和華的一百個先知藏了，每五十人藏在一個洞裡，拿餅和水供養他們，豈沒有人將這事告訴我主嗎﹖',
    '王上18:14 現在你說，要去告訴你主人說，以利亞在這裡，他必殺我。',
    '王上18:15 以利亞說：我指著所事奉永生的萬軍之耶和華起誓，我今日必使亞哈得見我。',
    '王上18:16 於是俄巴底去迎著亞哈，告訴他；亞哈就去迎著以利亞。',
    '王上18:17 亞哈見了以利亞，便說：使以色列遭災的就是你嗎﹖',
    '王上18:18 以利亞說：使以色列遭災的不是我，乃是你和你父家；因為你們離棄耶和華的誡命，去隨從巴力。',
    '王上18:19 現在你當差遣人，招聚以色列眾人和事奉巴力的那四百五十個先知，並耶洗別所供養事奉亞舍拉的那四百個先知，使他們都上迦密山去見我。',
    '王上18:20 亞哈就差遣人招聚以色列眾人和先知都上迦密山。',
    '王上18:21 以利亞前來對眾民說：你們心持兩意要到幾時呢﹖若耶和華是神，就當順從耶和華；若巴力是神，就當順從巴力。眾民一言不答。',
    '王上18:22 以利亞對眾民說：作耶和華先知的只剩下我一個人；巴力的先知卻有四百五十個人。',
    '王上18:23 當給我們兩隻牛犢，巴力的先知可以挑選一隻，切成塊子，放在柴上，不要點火；我也預備一隻牛犢放在柴上，也不點火。',
    '王上18:24 你們求告你們神的名，我也求告耶和華的名。那降火顯應的神，就是神。眾民回答說：這話甚好。',
    '王上18:25 以利亞對巴力的先知說：你們既是人多，當先挑選一隻牛犢，預備好了，就求告你們神的名，卻不要點火。',
    '王上18:26 他們將所得的牛犢預備好了，從早晨到午間，求告巴力的名說：巴力啊，求你應允我們！卻沒有聲音，沒有應允的。他們在所築的壇四圍踊跳。',
    '王上18:27 到了正午，以利亞嬉笑他們，說：大聲求告吧！因為他是神，他或默想，或走到一邊，或行路，或睡覺，你們當叫醒他。',
    '王上18:28 他們大聲求告，按著他們的規矩，用刀槍自割、自刺，直到身體流血。',
    '王上18:29 從午後直到獻晚祭的時候，他們狂呼亂叫，卻沒有聲音，沒有應允的，也沒有理會的。',
    '王上18:30 以利亞對眾民說：你們到我這裡來。眾民就到他那裡。他便重修已經毀壞耶和華的壇。',
    '王上18:31 以利亞照雅各子孫支派的數目，取了十二塊石頭（耶和華的話曾臨到雅各說：你的名要叫以色列），',
    '王上18:32 用這些石頭為耶和華的名築一座壇，在壇的四圍挖溝，可容穀種二細亞，',
    '王上18:33 又在壇上擺好了柴，把牛犢切成塊子放在柴上，對眾人說：你們用四個桶盛滿水，倒在燔祭和柴上；',
    '王上18:34 又說：倒第二次。他們就倒第二次；又說：倒第三次。他們就倒第三次。',
    '王上18:35 水流在壇的四圍，溝裡也滿了水。',
    '王上18:36 到了獻晚祭的時候，先知以利亞近前來，說：亞伯拉罕、以撒、以色列的神，耶和華啊，求你今日使人知道你是以色列的神，也知道我是你的僕人，又是奉你的命行這一切事。',
    '王上18:37 耶和華啊，求你應允我，應允我！使這民知道你─耶和華是神，又知道是你叫這民的心回轉。',
    '王上18:38 於是，耶和華降下火來，燒盡燔祭、木柴、石頭、塵土，又燒乾溝裡的水。',
    '王上18:39 眾民看見了，就俯伏在地，說：耶和華是神！耶和華是神！',
    '王上18:40 以利亞對他們說：拿住巴力的先知，不容一人逃脫！眾人就拿住他們。以利亞帶他們到基順河邊，在那裡殺了他們。',
    '王上18:41 以利亞對亞哈說：你現在可以上去吃喝，因為有多雨的響聲了。',
    '王上18:42 亞哈就上去吃喝。以利亞上了迦密山頂，屈身在地，將臉伏在兩膝之中；',
    '王上18:43 對僕人說：你上去，向海觀看。僕人就上去觀看，說：沒有什麼。他說：你再去觀看。如此七次。',
    '王上18:44 第七次僕人說：我看見有一小片雲從海裡上來，不過如人手那樣大。以利亞說：你上去告訴亞哈，當套車下去，免得被雨阻擋。',
    '王上18:45 霎時間，天因風雲黑暗，降下大雨。亞哈就坐車往耶斯列去了。',
    '王上18:46 耶和華的靈【原文是手】降在以利亞身上，他就束上腰，奔在亞哈前頭，直到耶斯列的城門。',
    '王上19:1 亞哈將以利亞一切所行的和他用刀殺眾先知的事都告訴耶洗別。',
    '王上19:2 耶洗別就差遣人去見以利亞，告訴他說：明日約在這時候，我若不使你的性命像那些人的性命一樣，願神明重重地降罰與我。',
    '王上19:3 以利亞見這光景就起來逃命，到了猶大的別是巴，將僕人留在那裡，',
    '王上19:4 自己在曠野走了一日的路程，來到一棵羅騰【小樹名，松類；下同】樹下，就坐在那裡求死，說：耶和華啊，罷了！求你取我的性命，因為我不勝於我的列祖。',
    '王上19:5 他就躺在羅騰樹下，睡著了。有一個天使拍他，說：起來吃吧！',
    '王上19:6 他觀看，見頭旁有一瓶水與炭火燒的餅，他就吃了喝了，仍然躺下。',
    '王上19:7 耶和華的使者第二次來拍他，說：起來吃吧！因為你當走的路甚遠。',
    '王上19:8 他就起來吃了喝了，仗著這飲食的力，走了四十晝夜，到了神的山，就是何烈山。',
    '王上19:9 他在那裡進了一個洞，就住在洞中。耶和華的話臨到他說：以利亞啊，你在這裡做什麼﹖',
    '王上19:10 他說：我為耶和華─萬軍之神大發熱心；因為以色列人背棄了你的約，毀壞了你的壇，用刀殺了你的先知，只剩下我一個人，他們還要尋索我的命。',
    '王上19:11 耶和華說：你出來站在山上，在我面前。那時耶和華從那裡經過，在他面前有烈風大作，崩山碎石，耶和華卻不在風中；風後地震，耶和華卻不在其中；',
    '王上19:12 地震後有火，耶和華也不在火中；火後有微小的聲音。',
    '王上19:13 以利亞聽見，就用外衣蒙上臉，出來站在洞口。有聲音向他說：以利亞啊，你在這裡做什麼﹖',
    '王上19:14 他說：我為耶和華─萬軍之神大發熱心；因為以色列人背棄了你的約，毀壞了你的壇，用刀殺了你的先知，只剩下我一個人，他們還要尋索我的命。',
    '王上19:15 耶和華對他說：你回去，從曠野往大馬色去。到了那裡，就要膏哈薛作亞蘭王，',
    '王上19:16 又膏寧示的孫子耶戶作以色列王，並膏亞伯米何拉人沙法的兒子以利沙作先知接續你。',
    '王上19:17 將來躲避哈薛之刀的，必被耶戶所殺；躲避耶戶之刀的，必被以利沙所殺。',
    '王上19:18 但我在以色列人中為自己留下七千人，是未曾向巴力屈膝的，未曾與巴力親嘴的。',
    '王上19:19 於是，以利亞離開那裡走了，遇見沙法的兒子以利沙耕地；在他前頭有十二對牛，自己趕著第十二對。以利亞到他那裡去，將自己的外衣搭在他身上。',
    '王上19:20 以利沙就離開牛，跑到以利亞那裡，說：求你容我先與父母親嘴，然後我便跟隨你。以利亞對他說：你回去吧，我向你做了什麼呢﹖',
    '王上19:21 以利沙就離開他回去，宰了一對牛，用套牛的器具煮肉給民吃，隨後就起身跟隨以利亞，服事他。',
    '王上20:1 亞蘭王便哈達聚集他的全軍，率領三十二個王，帶著車馬上來圍攻撒瑪利亞；',
    '王上20:2 又差遣使者進城見以色列王亞哈，對他說：便哈達如此說：',
    '王上20:3 你的金銀都要歸我，你妻子兒女中最美的也要歸我。',
    '王上20:4 以色列王回答說：我主我王啊，可以依著你的話，我與我所有的都歸你。',
    '王上20:5 使者又來說：便哈達如此說：我已差遣人去見你，要你將你的金銀、妻子、兒女都給我。',
    '王上20:6 但明日約在這時候，我還要差遣臣僕到你那裡，搜查你的家和你僕人的家，將你眼中一切所喜愛的都拿了去。',
    '王上20:7 以色列王召了國中的長老來，對他們說：請你們看看，這人是怎樣地謀害我，他先差遣人到我這裡來，要我的妻子、兒女，和金銀，我並沒有推辭他。',
    '王上20:8 長老和百姓對王說：不要聽從他，也不要應允他。',
    '王上20:9 故此，以色列王對便哈達的使者說：你們告訴我主我王說：王頭一次差遣人向僕人所要的，僕人都依從；但這次所要的，我不能依從。使者就去回覆便哈達。',
    '王上20:10 便哈達又差遣人去見亞哈說：撒瑪利亞的塵土若夠跟從我的人每人捧一捧的，願神明重重地降罰與我！',
    '王上20:11 以色列王說：你告訴他說，才頂盔貫甲的，休要像摘盔卸甲的誇口。',
    '王上20:12 便哈達和諸王正在帳幕裡喝酒，聽見這話，就對他臣僕說：擺隊吧！他們就擺隊攻城。',
    '王上20:13 有一個先知來見以色列王亞哈，說：耶和華如此說：這一大群人你看見了嗎﹖今日我必將他們交在你手裡，你就知道我是耶和華。',
    '王上20:14 亞哈說：藉著誰呢﹖他回答說：耶和華說，藉著跟從省長的少年人。亞哈說：要誰率領呢﹖他說：要你親自率領。',
    '王上20:15 於是亞哈數點跟從省長的少年人，共有二百三十二名，後又數點以色列的眾兵，共有七千名。',
    '王上20:16 午間，他們就出城；便哈達和幫助他的三十二個王正在帳幕裡痛飲。',
    '王上20:17 跟從省長的少年人先出城；便哈達差遣人去探望，他們回報說：有人從撒瑪利亞出來了。',
    '王上20:18 他說：他們若為講和出來，要活捉他們；若為打仗出來，也要活捉他們。',
    '王上20:19 跟從省長的少年人出城，軍兵跟隨他們；',
    '王上20:20 各人遇見敵人就殺。亞蘭人逃跑，以色列人追趕他們；亞蘭王便哈達騎著馬和馬兵一同逃跑。',
    '王上20:21 以色列王出城攻打車馬，大大擊殺亞蘭人。',
    '王上20:22 那先知來見以色列王，對他說：你當自強，留心怎樣防備；因為到明年這時候，亞蘭王必上來攻擊你。',
    '王上20:23 亞蘭王的臣僕對亞蘭王說：以色列人的神是山神，所以他們勝過我們；但在平原與他們打仗，我們必定得勝。',
    '王上20:24 王當這樣行：把諸王革去，派軍長代替他們，',
    '王上20:25 又照著王喪失軍兵之數，再招募一軍，馬補馬，車補車，我們在平原與他們打仗，必定得勝。王便聽臣僕的話去行。',
    '王上20:26 次年，便哈達果然點齊亞蘭人上亞弗去，要與以色列人打仗。',
    '王上20:27 以色列人也點齊軍兵，預備食物，迎著亞蘭人出去，對著他們安營，好像兩小群山羊羔；亞蘭人卻滿了地面。',
    '王上20:28 有神人來見以色列王，說：耶和華如此說：亞蘭人既說我─耶和華是山神，不是平原的神，所以我必將這一大群人都交在你手中，你們就知道我是耶和華。',
    '王上20:29 以色列人與亞蘭人相對安營七日，到第七日兩軍交戰；那一日以色列人殺了亞蘭人步兵十萬，',
    '王上20:30 其餘的逃入亞弗城；城牆塌倒，壓死剩下的二萬七千人。便哈達也逃入城，藏在嚴密的屋子裡。',
    '王上20:31 他的臣僕對他說：我們聽說以色列王都是仁慈的王，現在我們不如腰束麻布，頭套繩索，出去投降以色列王，或者他存留王的性命。',
    '王上20:32 於是他們腰束麻布，頭套繩索，去見以色列王，說：王的僕人便哈達說，求王存留我的性命。亞哈說：他還活著嗎﹖他是我的兄弟。',
    '王上20:33 這些人留心探出他的口氣來，便急忙就著他的話說：便哈達是王的兄弟！王說：你們去請他來。便哈達出來見王，王就請他上車。',
    '王上20:34 便哈達對王說：我父從你父那裡所奪的城邑，我必歸還。你可以在大馬色立街市，像我父在撒瑪利亞所立的一樣。亞哈說：我照此立約，放你回去，就與他立約，放他去了。',
    '王上20:35 有先知的一個門徒奉耶和華的命對他的同伴說：你打我吧！那人不肯打他。',
    '王上20:36 他就對那人說：你既不聽從耶和華的話，你一離開我，必有獅子咬死你。那人一離開他，果然遇見獅子，把他咬死了。',
    '王上20:37 先知的門徒又遇見一個人，對他說：你打我吧！那人就打他，將他打傷。',
    '王上20:38 他就去了，用頭巾蒙眼，改換面目，在路旁等候王。',
    '王上20:39 王從那裡經過，他向王呼叫說：僕人在陣上的時候，有人帶了一個人來，對我說：你看守這人，若把他失了，你的性命必代替他的性命；不然，你必交出一他連得銀子來。',
    '王上20:40 僕人正在忙亂之間，那人就不見了。以色列王對他說：你自己定妥了，必照樣判斷你。',
    '王上20:41 他急忙除掉蒙眼的頭巾，以色列王就認出他是一個先知。',
    '王上20:42 他對王說：耶和華如此說：因你將我定要滅絕的人放去，你的命就必代替他的命，你的民也必代替他的民。',
    '王上20:43 於是以色列王悶悶不樂地回到撒瑪利亞，進了他的宮。',
    '王上21:1 這事以後，又有一事。耶斯列人拿伯在耶斯列有一個葡萄園，靠近撒瑪利亞王亞哈的宮。',
    '王上21:2 亞哈對拿伯說：你將你的葡萄園給我作菜園，因為是靠近我的宮；我就把更好的葡萄園換給你，或是你要銀子，我就按著價值給你。',
    '王上21:3 拿伯對亞哈說：我敬畏耶和華，萬不敢將我先人留下的產業給你。',
    '王上21:4 亞哈因耶斯列人拿伯說我不敢將我先人留下的產業給你，就悶悶不樂地回宮，躺在床上，轉臉向內，也不吃飯。',
    '王上21:5 王后耶洗別來問他說：你為什麼心裡這樣憂悶，不吃飯呢﹖',
    '王上21:6 他回答說：因我向耶斯列人拿伯說：你將你的葡萄園給我，我給你價銀，或是你願意，我就把別的葡萄園換給你；他卻說：我不將我的葡萄園給你。',
    '王上21:7 王后耶洗別對亞哈說：你現在是治理以色列國不是﹖只管起來，心裡暢暢快快地吃飯，我必將耶斯列人拿伯的葡萄園給你。',
    '王上21:8 於是託亞哈的名寫信，用王的印印上，送給那些與拿伯同城居住的長老貴冑。',
    '王上21:9 信上寫著說：你們當宣告禁食，叫拿伯坐在民間的高位上，',
    '王上21:10 又叫兩個匪徒坐在拿伯對面，作見證告他說：你謗瀆神和王了；隨後就把他拉出去用石頭打死。',
    '王上21:11 那些與拿伯同城居住的長老貴冑得了耶洗別的信，就照信而行，',
    '王上21:12 宣告禁食，叫拿伯坐在民間的高位上。',
    '王上21:13 有兩個匪徒來，坐在拿伯的對面，當著眾民作見證告他說：拿伯謗瀆神和王了！眾人就把他拉到城外，用石頭打死。',
    '王上21:14 於是打發人去見耶洗別，說：拿伯被石頭打死了。',
    '王上21:15 耶洗別聽見拿伯被石頭打死，就對亞哈說：你起來得耶斯列人拿伯不肯為價銀給你的葡萄園吧！現在他已經死了。',
    '王上21:16 亞哈聽見拿伯死了，就起來，下去要得耶斯列人拿伯的葡萄園。',
    '王上21:17 耶和華的話臨到提斯比人以利亞說：',
    '王上21:18 你起來，去見住撒瑪利亞的以色列王亞哈，他下去要得拿伯的葡萄園，現今正在那園裡。',
    '王上21:19 你要對他說：耶和華如此說：你殺了人，又得他的產業嗎﹖又要對他說：耶和華如此說：狗在何處舔拿伯的血，也必在何處舔你的血。',
    '王上21:20 亞哈對以利亞說：我仇敵啊，你找到我嗎﹖他回答說：我找到你了；因為你賣了自己，行耶和華眼中看為惡的事。',
    '王上21:21 耶和華說：我必使災禍臨到你，將你除盡。凡屬你的男丁，無論困住的、自由的，都從以色列中剪除。',
    '王上21:22 我必使你的家像尼八的兒子耶羅波安的家，又像亞希雅的兒子巴沙的家；因為你惹我發怒，又使以色列人陷在罪裡。',
    '王上21:23 論到耶洗別，耶和華也說：狗在耶斯列的外郭必吃耶洗別的肉。',
    '王上21:24 凡屬亞哈的人，死在城中的必被狗吃，死在田野的必被空中的鳥吃。',
    '王上21:25 （從來沒有像亞哈的，因他自賣，行耶和華眼中看為惡的事，受了王后耶洗別的聳動；',
    '王上21:26 就照耶和華在以色列人面前所趕出的亞摩利人，行了最可憎惡的事，信從偶像。）',
    '王上21:27 亞哈聽見這話，就撕裂衣服，禁食，身穿麻布，睡臥也穿著麻布，並且緩緩而行。',
    '王上21:28 耶和華的話臨到提斯比人以利亞說：',
    '王上21:29 亞哈在我面前這樣自卑，你看見了嗎﹖因他在我面前自卑，他還在世的時候，我不降這禍；到他兒子的時候，我必降這禍與他的家。',
    '王上22:1 亞蘭國和以色列國三年沒有爭戰。',
    '王上22:2 到第三年，猶大王約沙法下去見以色列王。',
    '王上22:3 以色列王對臣僕說：你們不知道基列的拉末是屬我們的嗎﹖我們豈可靜坐不動，不從亞蘭王手裡奪回來嗎﹖',
    '王上22:4 亞哈問約沙法說：你肯同我去攻取基列的拉末嗎﹖約沙法對以色列王說：你我不分彼此，我的民與你的民一樣，我的馬與你的馬一樣。',
    '王上22:5 約沙法對以色列王說：請你先求問耶和華。',
    '王上22:6 於是以色列王招聚先知，約有四百人，問他們說：我上去攻取基列的拉末可以不可以﹖他們說：可以上去，因為主必將那城交在王的手裡。',
    '王上22:7 約沙法說：這裡不是還有耶和華的先知，我們可以求問他嗎﹖',
    '王上22:8 以色列王對約沙法說：還有一個人，是音拉的兒子米該雅，我們可以託他求問耶和華。只是我恨他；因為他指著我所說的預言，不說吉語，單說凶言。約沙法說：王不必這樣說。',
    '王上22:9 以色列王就召了一個太監來，說：你快去，將音拉的兒子米該雅召來。',
    '王上22:10 以色列王和猶大王約沙法在撒瑪利亞城門前的空場上，各穿朝服，坐在位上，所有的先知都在他們面前說預言。',
    '王上22:11 基拿拿的兒子西底家造了兩個鐵角，說：耶和華如此說：你要用這角牴觸亞蘭人，直到將他們滅盡。',
    '王上22:12 所有的先知也都這樣預言說：可以上基列的拉末去，必然得勝，因為耶和華必將那城交在王的手中。',
    '王上22:13 那去召米該雅的使者對米該雅說；眾先知一口同音地都向王說吉言，你不如與他們說一樣的話，也說吉言。',
    '王上22:14 米該雅說：我指著永生的耶和華起誓，耶和華對我說什麼，我就說什麼。',
    '王上22:15 米該雅到王面前，王問他說：米該雅啊，我們上去攻取基列的拉末可以不可以﹖他回答說：可以上去，必然得勝，耶和華必將那城交在王的手中。',
    '王上22:16 王對他說：我當囑咐你幾次，你才奉耶和華的名向我說實話呢﹖',
    '王上22:17 米該雅說：我看見以色列眾民散在山上，如同沒有牧人的羊群一般。耶和華說：這民沒有主人，他們可以平平安安地各歸各家去。',
    '王上22:18 以色列王對約沙法說：我豈沒有告訴你，這人指著我所說的預言，不說吉語單說凶言嗎﹖',
    '王上22:19 米該雅說：你要聽耶和華的話！我看見耶和華坐在寶座上，天上的萬軍侍立在他左右。',
    '王上22:20 耶和華說：誰去引誘亞哈上基列的拉末去陣亡呢﹖這個就這樣說，那個就那樣說。',
    '王上22:21 隨後有一個神靈出來，站在耶和華面前，說：我去引誘他。',
    '王上22:22 耶和華問他說：你用何法呢﹖他說：我去，要在他眾先知口中作謊言的靈。耶和華說：這樣，你必能引誘他，你去如此行吧！',
    '王上22:23 現在耶和華使謊言的靈入了你這些先知的口，並且耶和華已經命定降禍與你。',
    '王上22:24 基拿拿的兒子西底家前來，打米該雅的臉，說：耶和華的靈從哪裡離開我與你說話呢﹖',
    '王上22:25 米該雅說：你進嚴密的屋子藏躲的那日，就必看見了。',
    '王上22:26 以色列王說：將米該雅帶回，交給邑宰亞們和王的兒子約阿施，說',
    '王上22:27 王如此說，把這個人下在監裡，使他受苦，吃不飽喝不足，等候我平平安安地回來。',
    '王上22:28 米該雅說：你若能平平安安地回來，那就是耶和華沒有藉我說這話了；又說：眾民哪，你們都要聽！',
    '王上22:29 以色列王和猶大王約沙法上基列的拉末去了。',
    '王上22:30 以色列王對約沙法說：我要改裝上陣，你可以仍穿王服。以色列王就改裝上陣。',
    '王上22:31 先是亞蘭王吩咐他的三十二個車兵長說：他們的兵將，無論大小，你們都不可與他們爭戰，只要與以色列王爭戰。',
    '王上22:32 車兵長看見約沙法，便說：這必是以色列王！就轉過去與他爭戰，約沙法便呼喊。',
    '王上22:33 車兵長見不是以色列王，就轉去不追他了。',
    '王上22:34 有一人隨便開弓，恰巧射入以色列王的甲縫裡。王對趕車的說：我受了重傷，你轉過車來，拉我出陣吧！',
    '王上22:35 那日，陣勢越戰越猛，有人扶王站在車上，抵擋亞蘭人。到晚上，王就死了，血從傷處流在車中。',
    '王上22:36 約在日落的時候，有號令傳遍軍中，說：各歸本城，各歸本地吧！',
    '王上22:37 王既死了，眾人將他送到撒瑪利亞，就葬在那裡；',
    '王上22:38 又有人把他的車洗在撒瑪利亞的池旁（妓女在那裡洗澡），狗來舔他的血，正如耶和華所說的話。',
    '王上22:39 亞哈其餘的事，凡他所行的和他所修造的象牙宮，並所建築的一切城邑，都寫在以色列諸王記上。',
    '王上22:40 亞哈與他列祖同睡。他兒子亞哈謝接續他作王。',
    '王上22:41 以色列王亞哈第四年，亞撒的兒子約沙法登基作了猶大王。',
    '王上22:42 約沙法登基的時候年三十五歲，在耶路撒冷作王二十五年。他母親名叫阿蘇巴，乃示利希的女兒。',
    '王上22:43 約沙法行他父親亞撒所行的道，不偏離左右，行耶和華眼中看為正的事；只是邱壇還沒有廢去，百姓仍在那裡獻祭燒香。',
    '王上22:44 約沙法與以色列王和好。',
    '王上22:45 約沙法其餘的事和他所顯出的勇力，並他怎樣爭戰，都寫在猶大列王記上。',
    '王上22:46 約沙法將他父親亞撒在世所剩下的孌童都從國中除去了。',
    '王上22:47 那時以東沒有王，有總督治理。',
    '王上22:48 約沙法製造他施船隻，要往俄斐去，將金子運來；只是沒有去，因為船在以旬迦別破壞了。',
    '王上22:49 亞哈的兒子亞哈謝對約沙法說：容我的僕人和你的僕人坐船同去吧！約沙法卻不肯。',
    '王上22:50 約沙法與列祖同睡。葬在大衛城他列祖的墳地裡。他兒子約蘭接續他作王。',
    '王上22:51 猶大王約沙法十七年，亞哈的兒子亞哈謝在撒瑪利亞登基，作以色列王共二年。',
    '王上22:52 他行耶和華眼中看為惡的事，效法他的父母，又行尼八的兒子耶羅波安使以色列人陷在罪裡的事。',
    '王上22:53 他照他父親一切所行的，事奉敬拜巴力，惹耶和華─以色列神的怒氣。',
    '王下1:1 亞哈死後，摩押背叛以色列。',
    '王下1:2 亞哈謝在撒瑪利亞，一日從樓上的欄杆裡掉下來，就病了；於是差遣使者說：你們去問以革倫的神巴力西卜，我這病能好不能好。',
    '王下1:3 但耶和華的使者對提斯比人以利亞說：你起來，去迎著撒瑪利亞王的使者，對他們說：你們去問以革倫神巴力西卜，豈因以色列中沒有神嗎﹖',
    '王下1:4 所以耶和華如此說：你必不下你所上的床，必定要死！以利亞就去了。',
    '王下1:5 使者回來見王，王問他們說：你們為什麼回來呢﹖',
    '王下1:6 使者回答說：有一個人迎著我們來，對我們說：你們回去見差你們來的王，對他說：耶和華如此說，你差人去問以革倫神巴力西卜，豈因以色列中沒有神嗎﹖所以你必不下所上的床，必定要死。',
    '王下1:7 王問他們說：迎著你們來告訴你們這話的，是怎樣的人﹖',
    '王下1:8 回答說：他身穿毛衣，腰束皮帶。王說：這必是提斯比人以利亞。',
    '王下1:9 於是，王差遣五十夫長，帶領五十人去見以利亞，他就上到以利亞那裡；以利亞正坐在山頂上。五十夫長對他說：神人哪，王吩咐你下來！',
    '王下1:10 以利亞回答說：我若是神人，願火從天上降下來，燒滅你和你那五十人！於是有火從天上降下來，燒滅五十夫長和他那五十人。',
    '王下1:11 王第二次差遣一個五十夫長，帶領五十人去見以利亞。五十夫長對以利亞說：神人哪，王吩咐你快快下來！',
    '王下1:12 以利亞回答說：我若是神人，願火從天上降下來，燒滅你和你那五十人！於是神的火從天上降下來，燒滅五十夫長和他那五十人。',
    '王下1:13 王第三次差遣一個五十夫長，帶領五十人去。這五十夫長上去，雙膝跪在以利亞面前，哀求他說：神人哪，願我的性命和你這五十個僕人的性命在你眼前看為寶貴！',
    '王下1:14 已經有火從天上降下來，燒滅前兩次來的五十夫長和他們各自帶的五十人；現在願我的性命在你眼前看為寶貴！',
    '王下1:15 耶和華的使者對以利亞說：你同著他下去，不要怕他！以利亞就起來，同著他下去見王，',
    '王下1:16 對王說：耶和華如此說：你差人去問以革倫神巴力西卜，豈因以色列中沒有神可以求問嗎﹖所以你必不下所上的床，必定要死！',
    '王下1:17 亞哈謝果然死了，正如耶和華藉以利亞所說的話。因他沒有兒子，他兄弟約蘭接續他作王，正在猶大王約沙法的兒子約蘭第二年。',
    '王下1:18 亞哈謝其餘所行的事都寫在以色列諸王記上。',
    '王下2:1 耶和華要用旋風接以利亞升天的時候，以利亞與以利沙從吉甲前往。',
    '王下2:2 以利亞對以利沙說：耶和華差我往伯特利去，你可以在這裡等候。以利沙說：我指著永生的耶和華，又敢在你面前起誓，我必不離開你。於是二人下到伯特利。',
    '王下2:3 住伯特利的先知門徒出來見以利沙，對他說：耶和華今日要接你的師傅離開你，你知道不知道﹖他說：我知道，你們不要作聲。',
    '王下2:4 以利亞對以利沙說：耶和華差遣我往耶利哥去，你可以在這裡等候。以利沙說：我指著永生的耶和華，又敢在你面前起誓，我必不離開你。於是二人到了耶利哥。',
    '王下2:5 住耶利哥的先知門徒就近以利沙，對他說：耶和華今日要接你的師傅離開你，你知道不知道﹖他說：我知道，你們不要作聲。',
    '王下2:6 以利亞對以利沙說：耶和華差遣我往約但河去，你可以在這裡等候。以利沙說：我指著永生的耶和華，又敢在你面前起誓，我必不離開你。於是二人一同前往。',
    '王下2:7 有先知門徒去了五十人，遠遠地站在他們對面；二人在約但河邊站住。',
    '王下2:8 以利亞將自己的外衣捲起來，用以打水，水就左右分開，二人走乾地而過。',
    '王下2:9 過去之後，以利亞對以利沙說：我未曾被接去離開你，你要我為你做什麼，只管求我。以利沙說：願感動你的靈加倍地感動我。',
    '王下2:10 以利亞說：你所求的難得。雖然如此，我被接去離開你的時候，你若看見我，就必得著；不然，必得不著了。',
    '王下2:11 他們正走著說話，忽有火車火馬將二人隔開，以利亞就乘旋風升天去了。',
    '王下2:12 以利沙看見，就呼叫說：我父啊！我父啊！以色列的戰車馬兵啊！以後不再見他了。於是以利沙把自己的衣服撕為兩片。',
    '王下2:13 他拾起以利亞身上掉下來的外衣，回去站在約但河邊。',
    '王下2:14 他用以利亞身上掉下來的外衣打水，說：耶和華─以利亞的神在哪裡呢﹖打水之後，水也左右分開，以利沙就過來了。',
    '王下2:15 住耶利哥的先知門徒從對面看見他，就說：感動以利亞的靈感動以利沙了。他們就來迎接他，在他面前俯伏於地，',
    '王下2:16 對他說：僕人們這裡有五十個壯士，求你容他們去尋找你師傅，或者耶和華的靈將他提起來，投在某山某谷。以利沙說：你們不必打發人去。',
    '王下2:17 他們再三催促他，他難以推辭，就說：你們打發人去吧！他們便打發五十人去，尋找了三天，也沒有找著。',
    '王下2:18 以利沙仍然在耶利哥等候他們回到他那裡；他對他們說：我豈沒有告訴你們不必去嗎﹖',
    '王下2:19 耶利哥城的人對以利沙說：這城的地勢美好，我主看見了；只是水惡劣，土產不熟而落。',
    '王下2:20 以利沙說：你們拿一個新瓶來，裝鹽給我；他們就拿來給他。',
    '王下2:21 他出到水源，將鹽倒在水中，說：耶和華如此說：我治好了這水，從此必不再使人死，也不再使地土不生產。',
    '王下2:22 於是那水治好了，直到今日，正如以利沙所說的。',
    '王下2:23 以利沙從那裡上伯特利去，正上去的時候，有些童子從城裡出來，戲笑他說：禿頭的上去吧！禿頭的上去吧！',
    '王下2:24 他回頭看見，就奉耶和華的名咒詛他們。於是有兩個母熊從林中出來，撕裂他們中間四十二個童子。',
    '王下2:25 以利沙從伯特利上迦密山，又從迦密山回到撒瑪利亞。',
    '王下3:1 猶大王約沙法十八年，亞哈的兒子約蘭在撒瑪利亞登基作了以色列王十二年。',
    '王下3:2 他行耶和華眼中看為惡的事，但不致像他父母所行的，因為除掉他父所造巴力的柱像。',
    '王下3:3 然而，他貼近尼八的兒子耶羅波安使以色列人陷在罪裡的那罪，總不離開。',
    '王下3:4 摩押王米沙牧養許多羊，每年將十萬羊羔的毛和十萬公綿羊的毛給以色列王進貢。',
    '王下3:5 亞哈死後，摩押王背叛以色列王。',
    '王下3:6 那時約蘭王出撒瑪利亞，數點以色列眾人。',
    '王下3:7 前行的時候，差人去見猶大王約沙法，說：摩押王背叛我，你肯同我去攻打摩押嗎﹖他說：我肯上去，你我不分彼此，我的民與你的民一樣，我的馬與你的馬一樣。',
    '王下3:8 約蘭說：我們從哪條路上去呢﹖回答說：從以東曠野的路上去。',
    '王下3:9 於是，以色列王和猶大王，並以東王，都一同去繞行七日的路程；軍隊和所帶的牲畜沒有水喝。',
    '王下3:10 以色列王說：哀哉！耶和華招聚我們這三王，乃要交在摩押人的手裡。',
    '王下3:11 約沙法說：這裡不是有耶和華的先知嗎﹖我們可以託他求問耶和華。以色列王的一個臣子回答說：這裡有沙法的兒子以利沙，就是從前服事以利亞的【原文作倒水在以利亞手上的】。',
    '王下3:12 約沙法說：他必有耶和華的話。於是以色列王和約沙法，並以東王都下去見他。',
    '王下3:13 以利沙對以色列王說：我與你何干﹖去問你父親的先知和你母親的先知吧！以色列王對他說：不要這樣說，耶和華招聚我們這三王，乃要交在摩押人的手裡。',
    '王下3:14 以利沙說：我指著所事奉永生的萬軍耶和華起誓，我若不看猶大王約沙法的情面，必不理你，不顧你。',
    '王下3:15 現在你們給我找一個彈琴的來。彈琴的時候，耶和華的靈【原文作手】就降在以利沙身上。',
    '王下3:16 他便說：耶和華如此說：你們要在這谷中滿處挖溝；',
    '王下3:17 因為耶和華如此說：你們雖不見風，不見雨，這谷必滿了水，使你們和牲畜有水喝。',
    '王下3:18 在耶和華眼中這還算為小事，他也必將摩押人交在你們手中。',
    '王下3:19 你們必攻破一切堅城美邑，砍伐各種佳樹，塞住一切水泉，用石頭糟踏一切美田。',
    '王下3:20 次日早晨，約在獻祭的時候，有水從以東而來，遍地就滿了水。',
    '王下3:21 摩押眾人聽見這三王上來要與他們爭戰，凡能頂盔貫甲的，無論老少，盡都聚集站在邊界上。',
    '王下3:22 次日早晨，日光照在水上，摩押人起來，看見對面水紅如血，',
    '王下3:23 就說：這是血啊！必是三王互相擊殺，俱都滅亡。摩押人哪，我們現在去搶奪財物吧！',
    '王下3:24 摩押人到了以色列營，以色列人就起來攻打他們，以致他們在以色列人面前逃跑。以色列人往前追殺摩押人，直殺入摩押的境內，',
    '王下3:25 拆毀摩押的城邑，各人拋石填滿一切美田，塞住一切水泉，砍伐各種佳樹，只剩下吉珥‧哈列設的石牆；甩石的兵在四圍攻打那城。',
    '王下3:26 摩押王見陣勢甚大，難以對敵，就率領七百拿刀的兵，要衝過陣去到以東王那裡，卻是不能；',
    '王下3:27 便將那應當接續他作王的長子，在城上獻為燔祭。以色列人遭遇耶和華的大怒【或作招人痛恨】，於是三王離開摩押王，各回本國去了。',
    '王下4:1 有一個先知門徒的妻哀求以利沙說：你僕人─我丈夫死了，他敬畏耶和華是你所知道的。現在有債主來，要取我兩個兒子作奴僕。',
    '王下4:2 以利沙問他說：我可以為你做什麼呢﹖你告訴我，你家裡有什麼﹖他說：婢女家中除了一瓶油之外，沒有什麼。',
    '王下4:3 以利沙說：你去，向你眾鄰舍借空器皿，不要少借；',
    '王下4:4 回到家裡，關上門，你和你兒子在裡面將油倒在所有的器皿裡，倒滿了的放在一邊。',
    '王下4:5 於是，婦人離開以利沙去了，關上門，自己和兒子在裡面；兒子把器皿拿來，他就倒油。',
    '王下4:6 器皿都滿了，他對兒子說：再給我拿器皿來。兒子說：再沒有器皿了。油就止住了。',
    '王下4:7 婦人去告訴神人，神人說：你去賣油還債，所剩的你和你兒子可以靠著度日。',
    '王下4:8 一日，以利沙走到書念，在那裡有一個大戶的婦人強留他吃飯。此後，以利沙每從那裡經過就進去吃飯。',
    '王下4:9 婦人對丈夫說：我看出那常從我們這裡經過的是聖潔的神人。',
    '王下4:10 我們可以為他在牆上蓋一間小樓，在其中安放床榻、桌子、椅子、燈臺，他來到我們這裡，就可以住在其間。',
    '王下4:11 一日，以利沙來到那裡，就進了那樓躺臥。',
    '王下4:12 以利沙吩咐僕人基哈西說：你叫這書念婦人來。他就把婦人叫了來，婦人站在以利沙面前。',
    '王下4:13 以利沙吩咐僕人說：你對他說：你既為我們費了許多心思，可以為你做什麼呢﹖你向王或元帥有所求的沒有﹖他回答說：我在我本鄉安居無事。',
    '王下4:14 以利沙對僕人說：究竟當為他做什麼呢﹖基哈西說：他沒有兒子，他丈夫也老了。',
    '王下4:15 以利沙說：再叫他來。於是叫了他來，他就站在門口。',
    '王下4:16 以利沙說：明年到這時候，你必抱一個兒子。他說：神人，我主啊，不要那樣欺哄婢女。',
    '王下4:17 婦人果然懷孕，到了那時候，生了一個兒子，正如以利沙所說的。',
    '王下4:18 孩子漸漸長大，一日到他父親和收割的人那裡，',
    '王下4:19 他對父親說：我的頭啊，我的頭啊！他父親對僕人說：把他抱到他母親那裡。',
    '王下4:20 僕人抱去，交給他母親；孩子坐在母親的膝上，到晌午就死了。',
    '王下4:21 他母親抱他上了樓，將他放在神人的床上，關上門出來，',
    '王下4:22 呼叫他丈夫說：你叫一個僕人給我牽一匹驢來，我要快快地去見神人，就回來。',
    '王下4:23 丈夫說：今日不是月朔，也不是安息日，你為何要去見他呢﹖婦人說：平安無事。',
    '王下4:24 於是備上驢，對僕人說：你快快趕著走，我若不吩咐你，就不要遲慢。',
    '王下4:25 婦人就往迦密山去見神人。神人遠遠地看見他，對僕人基哈西說：看哪，書念的婦人來了！',
    '王下4:26 你跑去迎接他，問他說：你平安嗎﹖你丈夫平安嗎﹖孩子平安嗎﹖他說：平安。',
    '王下4:27 婦人上了山，到神人那裡，就抱住神人的腳。基哈西前來要推開他，神人說：由他吧！因為他心裡愁苦，耶和華向我隱瞞，沒有指示我。',
    '王下4:28 婦人說：我何嘗向我主求過兒子呢﹖我豈沒有說過，不要欺哄我嗎﹖',
    '王下4:29 以利沙吩咐基哈西說：你束上腰，手拿我的杖前去；若遇見人，不要向他問安；人若向你問安，也不要回答；要把我的杖放在孩子臉上。',
    '王下4:30 孩子的母親說：我指著永生的耶和華，又敢在你面前起誓，我必不離開你。於是以利沙起身，隨著他去了。',
    '王下4:31 基哈西先去，把杖放在孩子臉上，卻沒有聲音，也沒有動靜。基哈西就迎著以利沙回來，告訴他說：孩子還沒有醒過來。',
    '王下4:32 以利沙來到，進了屋子，看見孩子死了，放在自己的床上。',
    '王下4:33 他就關上門，只有自己和孩子在裡面，他便祈禱耶和華，',
    '王下4:34 上床伏在孩子身上，口對口，眼對眼，手對手；既伏在孩子身上，孩子的身體就漸漸溫和了。',
    '王下4:35 然後他下來，在屋裡來往走了一趟，又上去伏在孩子身上，孩子打了七個噴嚏，就睜開眼睛了。',
    '王下4:36 以利沙叫基哈西說：你叫這書念婦人來；於是叫了他來。以利沙說：將你兒子抱起來。',
    '王下4:37 婦人就進來，在以利沙腳前俯伏於地，抱起他兒子出去了。',
    '王下4:38 以利沙又來到吉甲，那地正有饑荒。先知門徒坐在他面前，他吩咐僕人說：你將大鍋放在火上，給先知門徒熬湯。',
    '王下4:39 有一個人去到田野掐菜，遇見一棵野瓜籐，就摘了一兜野瓜回來，切了擱在熬湯的鍋中，因為他們不知道是什麼東西；',
    '王下4:40 倒出來給眾人吃，吃的時候，都喊叫說：神人哪，鍋中有致死的毒物！所以眾人不能吃了。',
    '王下4:41 以利沙說：拿點麵來，就把麵撒在鍋中，說：倒出來，給眾人吃吧！鍋中就沒有毒了。',
    '王下4:42 有一個人從巴力‧沙利沙來，帶著初熟大麥做的餅二十個，並新穗子，裝在口袋裡送給神人。神人說：把這些給眾人吃。',
    '王下4:43 僕人說：這一點豈可擺給一百人吃呢﹖以利沙說：你只管給眾人吃吧！因為耶和華如此說，眾人必吃了，還剩下。',
    '王下4:44 僕人就擺在眾人面前，他們吃了，果然還剩下，正如耶和華所說的。',
    '王下5:1 亞蘭王的元帥乃縵在他主人面前為尊為大，因耶和華曾藉他使亞蘭人得勝；他又是大能的勇士，只是長了大痲瘋。',
    '王下5:2 先前亞蘭人成群地出去，從以色列國擄了一個小女子，這女子就服事乃縵的妻。',
    '王下5:3 他對主母說：巴不得我主人去見撒瑪利亞的先知，必能治好他的大痲瘋。',
    '王下5:4 乃縵進去，告訴他主人說，以色列國的女子如此如此說。',
    '王下5:5 亞蘭王說：你可以去，我也達信於以色列王。於是乃縵帶銀子十他連得，金子六千舍客勒，衣裳十套，就去了；',
    '王下5:6 且帶信給以色列王，信上說：我打發臣僕乃縵去見你，你接到這信，就要治好他的大痲瘋。',
    '王下5:7 以色列王看了信就撕裂衣服，說：我豈是神，能使人死使人活呢﹖這人竟打發人來，叫我治好他的大痲瘋。你們看一看，這人何以尋隙攻擊我呢﹖',
    '王下5:8 神人以利沙聽見以色列王撕裂衣服，就打發人去見王，說：你為什麼撕了衣服呢﹖可使那人到我這裡來，他就知道以色列中有先知了。',
    '王下5:9 於是，乃縵帶著車馬到了以利沙的家，站在門前。',
    '王下5:10 以利沙打發一個使者，對乃縵說：你去在約但河中沐浴七回，你的肉就必復原，而得潔淨。',
    '王下5:11 乃縵卻發怒走了，說：我想他必定出來見我，站著求告耶和華─他神的名，在患處以上搖手，治好這大痲瘋。',
    '王下5:12 大馬色的河亞罷拿和法珥法豈不比以色列的一切水更好嗎﹖我在那裡沐浴不得潔淨嗎﹖於是氣忿忿地轉身去了。',
    '王下5:13 他的僕人進前來，對他說：我父啊，先知若吩咐你做一件大事，你豈不做嗎﹖何況說你去沐浴而得潔淨呢﹖',
    '王下5:14 於是乃縵下去，照著神人的話，在約但河裡沐浴七回；他的肉復原，好像小孩子的肉，他就潔淨了。',
    '王下5:15 乃縵帶著一切跟隨他的人，回到神人那裡，站在他面前，說：如今我知道，除了以色列之外，普天下沒有神。現在求你收點僕人的禮物。',
    '王下5:16 以利沙說：我指著所事奉永生的耶和華起誓，我必不受。乃縵再三地求他，他卻不受。',
    '王下5:17 乃縵說：你若不肯受，請將兩騾子馱的土賜給僕人。從今以後，僕人必不再將燔祭或平安祭獻與別神，只獻給耶和華。',
    '王下5:18 惟有一件事，願耶和華饒恕你僕人：我主人進臨門廟叩拜的時候，我用手攙他在臨門廟，我也屈身。我在臨門廟屈身的這事，願耶和華饒恕我。',
    '王下5:19 以利沙對他說：你可以平平安安地回去！乃縵就離開他去了；走了不遠，',
    '王下5:20 神人以利沙的僕人基哈西心裡說：我主人不願從這亞蘭人乃縵手裡受他帶來的禮物，我指著永生的耶和華起誓，我必跑去追上他，向他要些。',
    '王下5:21 於是基哈西追趕乃縵。乃縵看見有人追趕，就急忙下車迎著他，說：都平安嗎﹖',
    '王下5:22 說：都平安。我主人打發我來說：剛才有兩個少年人，是先知門徒，從以法蓮山地來見我，請你賜他們一他連得銀子，兩套衣裳。',
    '王下5:23 乃縵說：請受二他連得；再三地請受，便將二他連得銀子裝在兩個口袋裡，又將兩套衣裳交給兩個僕人；他們就在基哈西前頭擡著走。',
    '王下5:24 到了山岡，基哈西從他們手中接過來，放在屋裡，打發他們回去。',
    '王下5:25 基哈西進去，站在他主人面前。以利沙問他說：基哈西你從哪裡來﹖回答說：僕人沒有往哪裡去。',
    '王下5:26 以利沙對他說：那人下車轉回迎你的時候，我的心豈沒有去呢﹖這豈是受銀子、衣裳、買橄欖園、葡萄園、牛羊、僕婢的時候呢﹖',
    '王下5:27 因此，乃縵的大痲瘋必沾染你和你的後裔，直到永遠。基哈西從以利沙面前退出去，就長了大痲瘋，像雪那樣白。',
    '王下6:1 先知門徒對以利沙說：看哪，我們同你所住的地方過於窄小，',
    '王下6:2 求你容我們往約但河去，各人從那裡取一根木料建造房屋居住。他說：你們去吧！',
    '王下6:3 有一人說：求你與僕人同去。回答說：我可以去。',
    '王下6:4 於是以利沙與他們同去。到了約但河，就砍伐樹木。',
    '王下6:5 有一人砍樹的時候，斧頭掉在水裡，他就呼叫說：哀哉！我主啊，這斧子是借的。',
    '王下6:6 神人問說：掉在哪裡了﹖他將那地方指給以利沙看。以利沙砍了一根木頭，拋在水裡，斧頭就漂上來了。',
    '王下6:7 以利沙說：拿起來吧！那人就伸手拿起來了。',
    '王下6:8 亞蘭王與以色列人爭戰，和他的臣僕商議說：我要在某處某處安營。',
    '王下6:9 神人打發人去見以色列王，說：你要謹慎，不要從某處經過，因為亞蘭人從那裡下來了。',
    '王下6:10 以色列王差人去窺探神人所告訴所警戒他去的地方，就防備未受其害，不止一兩次。',
    '王下6:11 亞蘭王因這事心裡驚疑，召了臣僕來，對他們說：我們這裡有誰幫助以色列王，你們不指給我嗎﹖',
    '王下6:12 有一個臣僕說：我主，我王！無人幫助他，只有以色列中的先知以利沙，將王在臥房所說的話告訴以色列王了。',
    '王下6:13 王說：你們去探他在哪裡，我好打發人去捉拿他。有人告訴王說：他在多坍。',
    '王下6:14 王就打發車馬和大軍往那裡去，夜間到了，圍困那城。',
    '王下6:15 神人的僕人清早起來出去，看見車馬軍兵圍困了城。僕人對神人說：哀哉！我主啊，我們怎樣行才好呢﹖',
    '王下6:16 神人說：不要懼怕！與我們同在的比與他們同在的更多。',
    '王下6:17 以利沙禱告說：耶和華啊，求你開這少年人的眼目，使他能看見。耶和華開他的眼目，他就看見滿山有火車火馬圍繞以利沙。',
    '王下6:18 敵人下到以利沙那裡，以利沙禱告耶和華說：求你使這些人的眼目昏迷。耶和華就照以利沙的話，使他們的眼目昏迷。',
    '王下6:19 以利沙對他們說：這不是那道，也不是那城；你們跟我去，我必領你們到所尋找的人那裡。於是領他們到了撒瑪利亞。',
    '王下6:20 他們進了撒瑪利亞，以利沙禱告說：耶和華啊，求你開這些人的眼目，使他們能看見。耶和華開他們的眼目，他們就看見了，不料，是在撒瑪利亞的城中。',
    '王下6:21 以色列王見了他們，就問以利沙說：我父啊，我可以擊殺他們嗎﹖',
    '王下6:22 回答說：不可擊殺他們！就是你用刀用弓擄來的，豈可擊殺他們嗎【或作也不可擊殺，何況這些人呢】﹖當在他們面前設擺飲食，使他們吃喝回到他們的主人那裡。',
    '王下6:23 王就為他們預備了許多食物；他們吃喝完了，打發他們回到他們主人那裡。從此，亞蘭軍不再犯以色列境了。',
    '王下6:24 此後，亞蘭王便哈達聚集他的全軍，上來圍困撒瑪利亞。',
    '王下6:25 於是撒瑪利亞被圍困，有饑荒，甚至一個驢頭值銀八十舍客勒，二升鴿子糞值銀五舍客勒。',
    '王下6:26 一日，以色列王在城上經過，有一個婦人向他呼叫說：我主，我王啊！求你幫助。',
    '王下6:27 王說：耶和華不幫助你，我從何處幫助你﹖是從禾場，是從酒醡呢﹖',
    '王下6:28 王問婦人說：你有什麼苦處﹖他回答說：這婦人對我說：將你的兒子取來，我們今日可以吃，明日可以吃我的兒子。',
    '王下6:29 我們就煮了我的兒子吃了。次日我對他說：要將你的兒子取來，我們可以吃。他卻將他的兒子藏起來了。',
    '王下6:30 王聽見婦人的話，就撕裂衣服；（王在城上經過）百姓看見王貼身穿著麻衣。',
    '王下6:31 王說：我今日若容沙法的兒子以利沙的頭仍在他項上，願神重重地降罰與我！',
    '王下6:32 那時，以利沙正坐在家中，長老也與他同坐。王打發一個伺候他的人去；他還沒有到，以利沙對長老說：你們看這兇手之子，打發人來斬我的頭；你們看著使者來到，就關上門，用門將他推出去。在他後頭不是有他主人腳步的響聲嗎﹖',
    '王下6:33 正說話的時候，使者來到，王也到了，說：這災禍是從耶和華那裡來的，我何必再仰望耶和華呢﹖',
    '王下7:1 以利沙說：你們要聽耶和華的話，耶和華如此說：明日約到這時候，在撒瑪利亞城門口，一細亞細麵要賣銀一舍客勒，二細亞大麥也要賣銀一舍客勒。',
    '王下7:2 有一個攙扶王的軍長對神人說：即便耶和華使天開了窗戶，也不能有這事。以利沙說：你必親眼看見，卻不得吃。',
    '王下7:3 在城門那裡有四個長大痲瘋的人，他們彼此說：我們為何坐在這裡等死呢﹖',
    '王下7:4 我們若說，進城去吧！城裡有饑荒，必死在那裡；若在這裡坐著不動，也必是死。來吧，我們去投降亞蘭人的軍隊，他們若留我們的活命，就活著；若殺我們，就死了吧！',
    '王下7:5 黃昏的時候，他們起來往亞蘭人的營盤去；到了營邊，不見一人在那裡。',
    '王下7:6 因為主使亞蘭人的軍隊聽見車馬的聲音，是大軍的聲音；他們就彼此說：這必是以色列王賄買赫人的諸王和埃及人的諸王來攻擊我們。',
    '王下7:7 所以，在黃昏的時候他們起來逃跑，撇下帳棚、馬、驢，營盤照舊，只顧逃命。',
    '王下7:8 那些長大痲瘋的到了營邊，進了帳棚，吃了喝了，且從其中拿出金銀和衣服來，去收藏了；回來又進了一座帳棚，從其中拿出財物來去收藏了。',
    '王下7:9 那時，他們彼此說：我們所做的不好！今日是有好信息的日子，我們竟不作聲！若等到天亮，罪必臨到我們。來吧，我們與王家報信去！',
    '王下7:10 他們就去叫守城門的，告訴他們說：我們到了亞蘭人的營，不見一人在那裡，也無人聲，只有拴著的馬和驢，帳棚都照舊。',
    '王下7:11 守城門的叫了眾守門的人來，他們就進去與王家報信。',
    '王下7:12 王夜間起來，對臣僕說：我告訴你們亞蘭人向我們如何行。他們知道我們飢餓，所以離營，埋伏在田野，說：以色列人出城的時候，我們就活捉他們，得以進城。',
    '王下7:13 有一個臣僕對王說：我們不如用城裡剩下之馬中的五匹馬（馬和城裡剩下的以色列人都是一樣，快要滅絕），打發人去窺探。',
    '王下7:14 於是取了兩輛車和馬，王差人去追尋亞蘭軍，說：你們去窺探窺探。',
    '王下7:15 他們就追尋到約但河，看見滿道上都是亞蘭人急跑時丟棄的衣服器具，使者就回來報告王。',
    '王下7:16 眾人就出去，擄掠亞蘭人的營盤。於是一細亞細麵賣銀一舍客勒，二細亞大麥也賣銀一舍客勒，正如耶和華所說的。',
    '王下7:17 王派攙扶他的那軍長在城門口彈壓，眾人在那裡將他踐踏，他就死了，正如神人在王下來見他的時候所說的。',
    '王下7:18 神人曾對王說：明日約到這時候，在撒瑪利亞城門口，二細亞大麥要賣銀一舍客勒，一細亞細麵也要賣銀一舍客勒。',
    '王下7:19 那軍長對神人說：即便耶和華使天開了窗戶，也不能有這事。神人說：你必親眼看見，卻不得吃。',
    '王下7:20 這話果然應驗在他身上；因為眾人在城門口將他踐踏，他就死了。',
    '王下8:1 以利沙曾對所救活之子的那婦人說：你和你的全家要起身往你可住的地方去住，因為耶和華命饑荒降在這地七年。',
    '王下8:2 婦人就起身，照神人的話帶著全家往非利士地去，住了七年。',
    '王下8:3 七年完了，那婦人從非利士地回來，就出去為自己的房屋田地哀告王。',
    '王下8:4 那時王正與神人的僕人基哈西說：請你將以利沙所行的一切大事告訴我。',
    '王下8:5 基哈西告訴王以利沙如何使死人復活，恰巧以利沙所救活、他兒子的那婦人為自己的房屋田地來哀告王。基哈西說：我主我王，這就是那婦人，這是他的兒子，就是以利沙所救活的。',
    '王下8:6 王問那婦人，他就把那事告訴王。於是王為他派一個太監，說：凡屬這婦人的都還給他，自從他離開本地直到今日，他田地的出產也都還給他。',
    '王下8:7 以利沙來到大馬色，亞蘭王便哈達正患病。有人告訴王說：神人來到這裡了。',
    '王下8:8 王就吩咐哈薛說：你帶著禮物去見神人，託他求問耶和華，我這病能好不能好﹖',
    '王下8:9 於是哈薛用四十個駱駝，馱著大馬色的各樣美物為禮物，去見以利沙。到了他那裡，站在他面前，說：你兒子亞蘭王便哈達打發我來見你，他問說：我這病能好不能好﹖',
    '王下8:10 以利沙對哈薛說：你回去告訴他說，這病必能好；但耶和華指示我，他必要死。',
    '王下8:11 神人定睛看著哈薛，甚至他慚愧。神人就哭了；',
    '王下8:12 哈薛說：我主為什麼哭？回答說：因為我知道你必苦害以色列人，用火焚燒他們的保障，用刀殺死他們的壯丁，摔死他們的嬰孩，剖開他們的孕婦。',
    '王下8:13 哈薛說：你僕人算什麼，不過是一條狗，焉能行這大事呢﹖以利沙回答說：耶和華指示我，你必作亞蘭王。',
    '王下8:14 哈薛離開以利沙，回去見他的主人。主人問他說：以利沙對你說什麼﹖回答說：他告訴我你必能好。',
    '王下8:15 次日，哈薛拿被窩浸在水中，蒙住王的臉，王就死了。於是哈薛篡了他的位。',
    '王下8:16 以色列王亞哈的兒子約蘭第五年，猶大王約沙法還在位的時候，約沙法的兒子約蘭登基作了猶大王。',
    '王下8:17 約蘭登基的時候年三十二歲，在耶路撒冷作王八年。',
    '王下8:18 他行以色列諸王所行的，與亞哈家一樣；因為他娶了亞哈的女兒為妻，行耶和華眼中看為惡的事。',
    '王下8:19 耶和華卻因他僕人大衛的緣故，仍不肯滅絕猶大，照他所應許大衛的話，永遠賜燈光與他的子孫。',
    '王下8:20 約蘭年間，以東人背叛猶大，脫離他的權下，自己立王。',
    '王下8:21 約蘭率領所有的戰車往撒益去，夜間起來，攻打圍困他的以東人和車兵長；猶大兵就逃跑，各回各家去了。',
    '王下8:22 這樣，以東人背叛猶大，脫離他的權下，直到今日。那時立拿人也背叛了。',
    '王下8:23 約蘭其餘的事，凡他所行的，都寫在猶大列王記上。',
    '王下8:24 約蘭與他列祖同睡，葬在大衛城他列祖的墳地裡。他兒子亞哈謝接續他作王。',
    '王下8:25 以色列王亞哈的兒子約蘭十二年，猶大王約蘭的兒子亞哈謝登基。',
    '王下8:26 他登基的時候年二十二歲，在耶路撒冷作王一年。他母親名叫亞他利雅，是以色列王暗利的孫女。',
    '王下8:27 亞哈謝效法亞哈家行耶和華眼中看為惡的事，與亞哈家一樣，因為他是亞哈家的女婿。',
    '王下8:28 他與亞哈的兒子約蘭同往基列的拉末去，與亞蘭王哈薛爭戰。亞蘭人打傷了約蘭，',
    '王下8:29 約蘭王回到耶斯列，醫治在拉末與亞蘭王哈薛打仗的時候所受的傷。猶大王約蘭的兒子亞哈謝因為亞哈的兒子約蘭病了，就下到耶斯列看望他。',
    '王下9:1 先知以利沙叫了一個先知門徒來，吩咐他說：你束上腰，手拿這瓶膏油往基列的拉末去。',
    '王下9:2 到了那裡，要尋找寧示的孫子、約沙法的兒子耶戶，使他從同僚中起來，帶他進嚴密的屋子，',
    '王下9:3 將瓶裡的膏油倒在他頭上，說：耶和華如此說：我膏你作以色列王。說完了，就開門逃跑，不要遲延。',
    '王下9:4 於是那少年先知往基列的拉末去了。',
    '王下9:5 到了那裡，看見眾軍長都坐著，就說：將軍哪，我有話對你說。耶戶說：我們眾人裡，你要對哪一個說呢﹖回答說：將軍哪，我要對你說。',
    '王下9:6 耶戶就起來，進了屋子，少年人將膏油倒在他頭上，對他說：耶和華─以色列的神如此說：我膏你作耶和華民以色列的王。',
    '王下9:7 你要擊殺你主人亞哈的全家，我好在耶洗別身上伸我僕人眾先知和耶和華一切僕人流血的冤。',
    '王下9:8 亞哈全家必都滅亡，凡屬亞哈的男丁，無論是困住的、自由的，我必從以色列中剪除，',
    '王下9:9 使亞哈的家像尼八兒子耶羅波安的家，又像亞希雅兒子巴沙的家。',
    '王下9:10 耶洗別必在耶斯列田裡被狗所吃，無人葬埋。說完了，少年人就開門逃跑了。',
    '王下9:11 耶戶出來，回到他主人的臣僕那裡，有一人問他說：平安嗎﹖這狂妄的人來見你有什麼事呢﹖回答說：你們認得那人，也知道他說什麼。',
    '王下9:12 他們說：這是假話，你據實地告訴我們。回答說：他如此如此對我說。他說：耶和華如此說：我膏你作以色列王。',
    '王下9:13 他們就急忙各將自己的衣服鋪在上層臺階，使耶戶坐在其上；他們吹角，說：耶戶作王了！',
    '王下9:14 這樣，寧示的孫子、約沙法的兒子耶戶背叛約蘭。先是約蘭和以色列眾人因為亞蘭王哈薛的緣故，把守基列的拉末；',
    '王下9:15 但約蘭王回到耶斯列，醫治與亞蘭王哈薛打仗所受的傷。耶戶說：若合你們的意思，就不容人逃出城往耶斯列報信去。',
    '王下9:16 於是耶戶坐車往耶斯列去，因為約蘭病臥在那裡。猶大王亞哈謝已經下去看望他。',
    '王下9:17 有一個守望的人站在耶斯列的樓上，看見耶戶帶著一群人來，就說：我看見一群人。約蘭說：打發一個騎馬的去迎接他們，問說：平安不平安﹖',
    '王下9:18 騎馬的就去迎接耶戶，說：王問說，平安不平安﹖耶戶說：平安不平安與你何干﹖你轉在我後頭吧！守望的人又說：使者到了他們那裡，卻不回來。',
    '王下9:19 王又打發一個騎馬的去。這人到了他們那裡，說：王問說，平安不平安﹖耶戶說：平安不平安與你何干﹖你轉在我後頭吧！',
    '王下9:20 守望的人又說：他到了他們那裡，也不回來；車趕得甚猛，像寧示的孫子耶戶的趕法。',
    '王下9:21 約蘭吩咐說：套車！人就給他套車。以色列王約蘭和猶大王亞哈謝各坐自己的車出去迎接耶戶，在耶斯列人拿伯的田那裡遇見他。',
    '王下9:22 約蘭見耶戶就說：耶戶啊，平安嗎﹖耶戶說：你母親耶洗別的淫行邪術這樣多，焉能平安呢﹖',
    '王下9:23 約蘭就轉車逃跑，對亞哈謝說：亞哈謝啊，反了！',
    '王下9:24 耶戶開滿了弓，射中約蘭的脊背，箭從心窩穿出，約蘭就仆倒在車上。',
    '王下9:25 耶戶對他的軍長畢甲說：你把他拋在耶斯列人拿伯的田間。你當追想，你我一同坐車跟隨他父亞哈的時候，耶和華對亞哈所說的預言，',
    '王下9:26 說：我昨日看見拿伯的血和他眾子的血，我必在這塊田上報應你。這是耶和華說的，現在你要照著耶和華的話，把他拋在這田間。',
    '王下9:27 猶大王亞哈謝見這光景，就從園亭之路逃跑。耶戶追趕他，說：把這人也殺在車上。到了靠近以伯蓮的姑珥坡上擊傷了他。他逃到米吉多，就死在那裡。',
    '王下9:28 他的臣僕用車將他的屍首送到耶路撒冷，葬在大衛城他自己的墳墓裡，與他列祖同葬。',
    '王下9:29 亞哈謝登基作猶大王的時候，是在亞哈的兒子約蘭第十一年。',
    '王下9:30 耶戶到了耶斯列；耶洗別聽見就擦粉、梳頭，從窗戶裡往外觀看。',
    '王下9:31 耶戶進門的時候，耶洗別說：殺主人的心利啊，平安嗎﹖',
    '王下9:32 耶戶擡頭向窗戶觀看，說：誰順從我﹖有兩三個太監從窗戶往外看他。',
    '王下9:33 耶戶說：把他扔下來！他們就把他扔下來。他的血濺在牆上和馬上；於是把他踐踏了。',
    '王下9:34 耶戶進去，吃了喝了，吩咐說：你們把這被咒詛的婦人葬埋了，因為他是王的女兒。',
    '王下9:35 他們就去葬埋他，只尋得他的頭骨和腳，並手掌。',
    '王下9:36 他們回去告訴耶戶，耶戶說：這正應驗耶和華藉他僕人提斯比人以利亞所說的話，說：在耶斯列田間，狗必吃耶洗別的肉；',
    '王下9:37 耶洗別的屍首必在耶斯列田間如同糞土，甚至人不能說這是耶洗別。',
    '王下10:1 亞哈有七十個兒子在撒瑪利亞。耶戶寫信送到撒瑪利亞，通知耶斯列的首領，就是長老和教養亞哈眾子的人，說：',
    '王下10:2 你們那裡既有你們主人的眾子和車馬、器械、堅固城，',
    '王下10:3 接了這信，就可以在你們主人的眾子中選擇一個賢能合宜的，使他坐他父親的位，你們也可以為你們主人的家爭戰。',
    '王下10:4 他們卻甚懼怕，彼此說：二王在他面前尚且站立不住，我們怎能站得住呢？',
    '王下10:5 家宰、邑宰，和長老，並教養眾子的人，打發人去見耶戶，說：我們是你的僕人，凡你所吩咐我們的都必遵行，我們不立誰作王，你看怎樣好就怎樣行。',
    '王下10:6 耶戶又給他們寫信說：你們若歸順我，聽從我的話，明日這時候，要將你們主人眾子的首級帶到耶斯列來見我。那時王的兒子七十人都住在教養他們那城中的尊貴人家裡。',
    '王下10:7 信一到，他們就把王的七十個兒子殺了，將首級裝在筐裡，送到在耶斯列的耶戶那裡。',
    '王下10:8 有使者來告訴耶戶說：他們將王眾子的首級送來了。耶戶說：將首級在城門口堆作兩堆，擱到明日。',
    '王下10:9 次日早晨，耶戶出來，站著對眾民說：你們都是公義的，我背叛我主人，將他殺了；這些人卻是誰殺的呢﹖',
    '王下10:10 由此可知，耶和華指著亞哈家所說的話一句沒有落空，因為耶和華藉他僕人以利亞所說的話都成就了。',
    '王下10:11 凡亞哈家在耶斯列所剩下的人和他的大臣、密友、祭司，耶戶盡都殺了，沒有留下一個。',
    '王下10:12 耶戶起身往撒瑪利亞去。在路上、牧人剪羊毛之處，',
    '王下10:13 遇見猶大王亞哈謝的弟兄，問他們說：你們是誰﹖回答說：我們是亞哈謝的弟兄，現在下去要問王和太后的眾子安。',
    '王下10:14 耶戶吩咐說：活捉他們！跟從的人就活捉了他們，將他們殺在剪羊毛之處的坑邊，共四十二人，沒有留下一個。',
    '王下10:15 耶戶從那裡前行，恰遇利甲的兒子約拿達來迎接他，耶戶問他安，對他說：你誠心待我像我誠心待你嗎﹖約拿達回答說：是。耶戶說：若是這樣，你向我伸手，他就伸手；耶戶拉他上車。',
    '王下10:16 耶戶說：你和我同去，看我為耶和華怎樣熱心；於是請他坐在車上，',
    '王下10:17 到了撒瑪利亞，就把撒瑪利亞的亞哈家剩下的人都殺了，直到滅盡，正如耶和華對以利亞所說的。',
    '王下10:18 耶戶招聚眾民，對他們說：亞哈事奉巴力還冷淡，耶戶卻更熱心。',
    '王下10:19 現在我要給巴力獻大祭。應當叫巴力的眾先知和一切拜巴力的人，並巴力的眾祭司，都到我這裡來，不可缺少一個；凡不來的必不得活。耶戶這樣行，是用詭計要殺盡拜巴力的人。',
    '王下10:20 耶戶說：要為巴力宣告嚴肅會！於是宣告了。',
    '王下10:21 耶戶差人走遍以色列地；凡拜巴力的人都來齊了，沒有一個不來的。他們進了巴力廟，巴力廟中從前邊直到後邊都滿了人。',
    '王下10:22 耶戶吩咐掌管禮服的人說：拿出禮服來，給一切拜巴力的人穿。他就拿出禮服來給了他們。',
    '王下10:23 耶戶和利甲的兒子約拿達進了巴力廟，對拜巴力的人說：你們察看察看，在你們這裡不可有耶和華的僕人，只可容留拜巴力的人。',
    '王下10:24 耶戶和約拿達進去，獻平安祭和燔祭。耶戶先安排八十人在廟外，吩咐說：我將這些人交在你們手中，若有一人脫逃，誰放的必叫他償命！',
    '王下10:25 耶戶獻完了燔祭，就出來吩咐護衛兵和眾軍長說：你們進去殺他們，不容一人出來！護衛兵和軍長就用刀殺他們，將屍首拋出去，便到巴力廟的城去了，',
    '王下10:26 將巴力廟中的柱像都拿出來燒了；',
    '王下10:27 毀壞了巴力柱像，拆毀了巴力廟作為廁所，直到今日。',
    '王下10:28 這樣，耶戶在以色列中滅了巴力。',
    '王下10:29 只是耶戶不離開尼八的兒子耶羅波安使以色列人陷在罪裡的那罪，就是拜伯特利和但的金牛犢。',
    '王下10:30 耶和華對耶戶說：因你辦好我眼中看為正的事，照我的心意待亞哈家，你的子孫必接續你坐以色列的國位，直到四代。',
    '王下10:31 只是耶戶不盡心遵守耶和華─以色列神的律法，不離開耶羅波安使以色列人陷在罪裡的那罪。',
    '王下10:32 在那些日子，耶和華才割裂以色列國，使哈薛攻擊以色列的境界，',
    '王下10:33 乃是約但河東、基列全地，從靠近亞嫩谷邊的亞羅珥起，就是基列和巴珊的迦得人、流便人、瑪拿西人之地。',
    '王下10:34 耶戶其餘的事，凡他所行的和他的勇力都寫在以色列諸王記上。',
    '王下10:35 耶戶與他列祖同睡，葬在撒瑪利亞；他兒子約哈斯接續他作王。',
    '王下10:36 耶戶在撒瑪利亞作以色列王二十八年。',
    '王下11:1 亞哈謝的母親亞他利雅見他兒子死了，就起來剿滅王室。',
    '王下11:2 但約蘭王的女兒，亞哈謝的妹子約示巴，將亞哈謝的兒子約阿施從那被殺的王子中偷出來，把他和他的乳母都藏在臥房裡，躲避亞他利雅，免得被殺。',
    '王下11:3 約阿施和他的乳母藏在耶和華的殿裡六年；亞他利雅篡了國位。',
    '王下11:4 第七年，耶何耶大打發人叫迦利人【或作親兵】和護衛兵的眾百夫長來，領他們進了耶和華的殿，與他們立約，使他們在耶和華殿裡起誓，又將王的兒子指給他們看，',
    '王下11:5 吩咐他們說：你們當這樣行：凡安息日進班的三分之一要看守王宮，',
    '王下11:6 三分之一要在蘇珥門，三分之一要在護衛兵院的後門。這樣把守王宮，攔阻閒人。',
    '王下11:7 你們安息日所有出班的三分之二要在耶和華的殿裡護衛王；',
    '王下11:8 各人手拿兵器，四圍護衛王。凡擅入你們班次的必當治死，王出入的時候，你們當跟隨他。',
    '王下11:9 眾百夫長就照著祭司耶何耶大一切所吩咐的去行，各帶所管安息日進班出班的人來見祭司耶何耶大。',
    '王下11:10 祭司便將耶和華殿裡所藏大衛王的槍和盾牌交給百夫長。',
    '王下11:11 護衛兵手中各拿兵器，在壇和殿那裡，從殿右直到殿左，站在王子的四圍。',
    '王下11:12 祭司領王子出來，給他戴上冠冕，將律法書交給他，膏他作王；眾人就拍掌說：願王萬歲！',
    '王下11:13 亞他利雅聽見護衛兵和民的聲音，就到民那裡，進耶和華的殿，',
    '王下11:14 看見王照例站在柱旁，百夫長和吹號的人侍立在王左右，國中的眾民歡樂吹號；亞他利雅就撕裂衣服，喊叫說：反了！反了！',
    '王下11:15 祭司耶何耶大吩咐管轄軍兵的百夫長說：將他趕出班外，凡跟隨他的必用刀殺死！因為祭司說不可在耶和華殿裡殺他，',
    '王下11:16 眾兵就閃開讓他去；他從馬路上王宮去，便在那裡被殺。',
    '王下11:17 耶何耶大使王和民與耶和華立約，作耶和華的民；又使王與民立約。',
    '王下11:18 於是國民都到巴力廟，拆毀了廟，打碎壇和像，又在壇前將巴力的祭司瑪坦殺了。祭司耶何耶大派官看守耶和華的殿，',
    '王下11:19 又率領百夫長和迦利人【或作親兵】與護衛兵，以及國中的眾民，請王從耶和華殿下來，由護衛兵的門進入王宮，他就坐了王位。',
    '王下11:20 國民都歡樂，閤城都安靜。眾人已將亞他利雅在王宮那裡用刀殺了。',
    '王下11:21 約阿施登基的時候年方七歲。',
    '王下12:1 耶戶第七年，約阿施登基，在耶路撒冷作王四十年。他母親名叫西比亞，是別是巴人。',
    '王下12:2 約阿施在祭司耶何耶大教訓他的時候，就行耶和華眼中看為正的事；',
    '王下12:3 只是邱壇還沒有廢去，百姓仍在那裡獻祭燒香。',
    '王下12:4 約阿施對眾祭司說：凡奉到耶和華殿分別為聖之物所值通用的銀子，或各人當納的身價，或樂意奉到耶和華殿的銀子，',
    '王下12:5 你們當從所認識的人收了來，修理殿的一切破壞之處。',
    '王下12:6 無奈到了約阿施王二十三年，祭司仍未修理殿的破壞之處。',
    '王下12:7 所以約阿施王召了大祭司耶何耶大和眾祭司來，對他們說：你們怎麼不修理殿的破壞之處呢﹖從今以後，你們不要從所認識的人再收銀子，要將所收的交出來，修理殿的破壞之處。',
    '王下12:8 眾祭司答應不再收百姓的銀子，也不修理殿的破壞之處。',
    '王下12:9 祭司耶何耶大取了一個櫃子，在櫃蓋上鑽了一個窟窿，放於壇旁，在進耶和華殿的右邊；守門的祭司將奉到耶和華殿的一切銀子投在櫃裡。',
    '王下12:10 他們見櫃裡的銀子多了，便叫王的書記和大祭司上來，將耶和華殿裡的銀子數算包起來。',
    '王下12:11 把所平的銀子交給督工的，就是耶和華殿裡辦事的人；他們把銀子轉交修理耶和華殿的木匠和工人，',
    '王下12:12 並瓦匠、石匠，又買木料和鑿成的石頭，修理耶和華殿的破壞之處，以及修理殿的各樣使用。',
    '王下12:13 但那奉到耶和華殿的銀子，沒有用以做耶和華殿裡的銀杯、蠟剪、碗、號，和別樣的金銀器皿，',
    '王下12:14 乃將那銀子交給督工的人修理耶和華的殿；',
    '王下12:15 且將銀子交給辦事的人轉交做工的人，不與他們算帳，因為他們辦事誠實。',
    '王下12:16 惟有贖愆祭、贖罪祭的銀子沒有奉到耶和華的殿，都歸祭司。',
    '王下12:17 那時，亞蘭王哈薛上來攻打迦特，攻取了，就定意上來攻打耶路撒冷。',
    '王下12:18 猶大王約阿施將他列祖猶大王約沙法、約蘭、亞哈謝所分別為聖的物和自己所分別為聖的物，並耶和華殿與王宮府庫裡所有的金子都送給亞蘭王哈薛；哈薛就不上耶路撒冷來了。',
    '王下12:19 約阿施其餘的事，凡他所行的都寫在猶大列王記上。',
    '王下12:20 約阿施的臣僕起來背叛，在下悉拉的米羅宮那裡將他殺了。',
    '王下12:21 殺他的那臣僕就是示米押的兒子約撒甲和朔默的兒子約薩拔。眾人將他葬在大衛城他列祖的墳地裡。他兒子亞瑪謝接續他作王。',
    '王下13:1 猶大王亞哈謝的兒子約阿施二十三年，耶戶的兒子約哈斯在撒瑪利亞登基作以色列王十七年。',
    '王下13:2 約哈斯行耶和華眼中看為惡的事，效法尼八的兒子耶羅波安使以色列人陷在罪裡的那罪，總不離開。',
    '王下13:3 於是，耶和華的怒氣向以色列人發作，將他們屢次交在亞蘭王哈薛和他兒子便哈達的手裡。',
    '王下13:4 約哈斯懇求耶和華，耶和華就應允他，因為見以色列人所受亞蘭王的欺壓。',
    '王下13:5 耶和華賜給以色列人一位拯救者，使他們脫離亞蘭人的手；於是以色列人仍舊安居在家裡。',
    '王下13:6 然而，他們不離開耶羅波安家使以色列人陷在罪裡的那罪，仍然去行，並且在撒瑪利亞留下亞舍拉。',
    '王下13:7 亞蘭王滅絕約哈斯的民，踐踏他們如禾場上的塵沙，只給約哈斯留下五十馬兵，十輛戰車，一萬步兵。',
    '王下13:8 約哈斯其餘的事，凡他所行的和他的勇力都寫在以色列諸王記上。',
    '王下13:9 約哈斯與他列祖同睡，葬在撒瑪利亞。他兒子約阿施接續他作王。',
    '王下13:10 猶大王約阿施三十七年，約哈斯的兒子約阿施在撒瑪利亞登基作以色列王十六年。',
    '王下13:11 他行耶和華眼中看為惡的事，不離開尼八的兒子耶羅波安使以色列人陷在罪裡的一切罪，仍然去行。',
    '王下13:12 約阿施其餘的事，凡他所行的和他與猶大王亞瑪謝爭戰的勇力，都寫在以色列諸王記上。',
    '王下13:13 約阿施與他列祖同睡，耶羅波安坐了他的位。約阿施與以色列諸王一同葬在撒瑪利亞。',
    '王下13:14 以利沙得了必死的病，以色列王約阿施下來看他，伏在他臉上哭泣，說：我父啊！我父啊！以色列的戰車馬兵啊！',
    '王下13:15 以利沙對他說：你取弓箭來。王就取了弓箭來；',
    '王下13:16 又對以色列王說：你用手拿弓。王就用手拿弓。以利沙按手在王的手上，',
    '王下13:17 說：你開朝東的窗戶。他就開了。以利沙說：射箭吧！他就射箭。以利沙說：這是耶和華的得勝箭，就是戰勝亞蘭人的箭；因為你必在亞弗攻打亞蘭人，直到滅盡他們。',
    '王下13:18 以利沙又說：取幾枝箭來。他就取了來。以利沙說：打地吧！他打了三次，便止住了。',
    '王下13:19 神人向他發怒，說：應當擊打五六次，就能攻打亞蘭人直到滅盡；現在只能打敗亞蘭人三次。',
    '王下13:20 以利沙死了，人將他葬埋。到了新年，有一群摩押人犯境，',
    '王下13:21 有人正葬死人，忽然看見一群人，就把死人拋在以利沙的墳墓裡，一碰著以利沙的骸骨，死人就復活，站起來了。',
    '王下13:22 約哈斯年間，亞蘭王哈薛屢次欺壓以色列人。',
    '王下13:23 耶和華卻因與亞伯拉罕、以撒、雅各所立的約，仍施恩給以色列人，憐恤他們，眷顧他們，不肯滅盡他們，尚未趕逐他們離開自己面前。',
    '王下13:24 亞蘭王哈薛死了，他兒子便哈達接續他作王。',
    '王下13:25 從前哈薛和約阿施的父親約哈斯爭戰，攻取了些城邑，現在約哈斯的兒子約阿施三次打敗哈薛的兒子便哈達，就收回了以色列的城邑。',
    '王下14:1 以色列王約哈斯的兒子約阿施第二年，猶大王約阿施的兒子亞瑪謝登基。',
    '王下14:2 他登基的時候年二十五歲，在耶路撒冷作王二十九年。他母親名叫約耶但，是耶路撒冷人。',
    '王下14:3 亞瑪謝行耶和華眼中看為正的事，但不如他祖大衛，乃效法他父約阿施一切所行的；',
    '王下14:4 只是邱壇還沒有廢去，百姓仍在那裡獻祭燒香。',
    '王下14:5 國一堅定，就把殺他父王的臣僕殺了，',
    '王下14:6 卻沒有治死殺王之人的兒子，是照摩西律法書上耶和華所吩咐的說：不可因子殺父，也不可因父殺子，各人要為本身的罪而死。',
    '王下14:7 亞瑪謝在鹽谷殺了以東人一萬，又攻取了西拉，改名叫約帖，直到今日。',
    '王下14:8 那時，亞瑪謝差遣使者去見耶戶的孫子約哈斯的兒子以色列王約阿施，說：你來，我們二人相見於戰場。',
    '王下14:9 以色列王約阿施差遣使者去見猶大王亞瑪謝，說：利巴嫩的蒺藜差遣使者去見利巴嫩的香柏樹，說：將你的女兒給我兒子為妻。後來利巴嫩有一個野獸經過，把蒺藜踐踏了。',
    '王下14:10 你打敗了以東人就心高氣傲，你以此為榮耀，在家裡安居就罷了，為何要惹禍，使自己和猶大國一同敗亡呢﹖',
    '王下14:11 亞瑪謝卻不肯聽這話。於是以色列王約阿施上來，在猶大的伯示麥與猶大王亞瑪謝相見於戰場。',
    '王下14:12 猶大人敗在以色列人面前，各自逃回家裡去了。',
    '王下14:13 以色列王約阿施在伯示麥擒住亞哈謝的孫子、約阿施的兒子猶大王亞瑪謝，就來到耶路撒冷，拆毀耶路撒冷的城牆，從以法蓮門直到角門共四百肘，',
    '王下14:14 又將耶和華殿裡與王宮府庫裡所有的金銀和器皿都拿了去，並帶人去為質，就回撒瑪利亞去了。',
    '王下14:15 約阿施其餘所行的事和他的勇力，並與猶大王亞瑪謝爭戰的事，都寫在以色列諸王記上。',
    '王下14:16 約阿施與他列祖同睡，葬在撒瑪利亞，以色列諸王的墳地裡。他兒子耶羅波安接續他作王。',
    '王下14:17 以色列王約哈斯的兒子約阿施死後，猶大王約阿施的兒子亞瑪謝又活了十五年。',
    '王下14:18 亞瑪謝其餘的事都寫在猶大列王記上。',
    '王下14:19 耶路撒冷有人背叛亞瑪謝，他就逃到拉吉；叛黨卻打發人到拉吉將他殺了。',
    '王下14:20 人就用馬將他的屍首馱到耶路撒冷，葬在大衛城他列祖的墳地裡。',
    '王下14:21 猶大眾民立亞瑪謝的兒子亞撒利雅【又名烏西雅】接續他父作王，那時他年十六歲。',
    '王下14:22 亞瑪謝與他列祖同睡之後，亞撒利雅收回以拉他仍歸猶大，又重新修理。',
    '王下14:23 猶大王約阿施的兒子亞瑪謝十五年，以色列王約阿施的兒子耶羅波安在撒瑪利亞登基，作王四十一年。',
    '王下14:24 他行耶和華眼中看為惡的事，不離開尼八的兒子耶羅波安使以色列人陷在罪裡的一切罪。',
    '王下14:25 他收回以色列邊界之地，從哈馬口直到亞拉巴海，正如耶和華─以色列的神藉他僕人迦特希弗人亞米太的兒子先知約拿所說的。',
    '王下14:26 因為耶和華看見以色列人甚是艱苦，無論困住的、自由的都沒有了，也無人幫助以色列人。',
    '王下14:27 耶和華並沒有說要將以色列的名從天下塗抹，乃藉約阿施的兒子耶羅波安拯救他們。',
    '王下14:28 耶羅波安其餘的事，凡他所行的和他的勇力，他怎樣爭戰，怎樣收回大馬色和先前屬猶大的哈馬歸以色列，都寫在以色列諸王記上。',
    '王下14:29 耶羅波安與他列祖以色列諸王同睡。他兒子撒迦利雅接續他作王。',
    '王下15:1 以色列王耶羅波安二十七年，猶大王亞瑪謝的兒子亞撒利雅登基，',
    '王下15:2 他登基的時候年十六歲，在耶路撒冷作王五十二年。他母親名叫耶可利雅，是耶路撒冷人。',
    '王下15:3 亞撒利雅行耶和華眼中看為正的事，效法他父親亞瑪謝一切所行的；',
    '王下15:4 只是邱壇還沒有廢去，百姓仍在那裡獻祭燒香。',
    '王下15:5 耶和華降災與王，使他長大痲瘋，直到死日，他就住在別的宮裡。他的兒子約坦管理家事，治理國民。',
    '王下15:6 亞撒利雅其餘的事，凡他所行的都寫在猶大列王記上。',
    '王下15:7 亞撒利雅與他列祖同睡，葬在大衛城他列祖的墳地裡。他兒子約坦接續他作王。',
    '王下15:8 猶大王亞撒利雅三十八年，耶羅波安的兒子撒迦利雅在撒瑪利亞作以色列王六個月。',
    '王下15:9 他行耶和華眼中看為惡的事，效法他列祖所行的，不離開尼八的兒子耶羅波安使以色列人陷在罪裡的那罪。',
    '王下15:10 雅比的兒子沙龍背叛他，在百姓面前擊殺他，篡了他的位。',
    '王下15:11 撒迦利雅其餘的事都寫在以色列諸王記上。',
    '王下15:12 這是從前耶和華應許耶戶說：你的子孫必坐以色列的國位直到四代。這話果然應驗了。',
    '王下15:13 猶大王烏西雅【就是亞撒利雅】三十九年，雅比的兒子沙龍登基在撒瑪利亞作王一個月。',
    '王下15:14 迦底的兒子米拿現從得撒上撒瑪利亞，殺了雅比的兒子沙龍，篡了他的位。',
    '王下15:15 沙龍其餘的事和他背叛的情形都寫在以色列諸王記上。',
    '王下15:16 那時米拿現從得撒起攻打提斐薩和其四境，擊殺城中一切的人，剖開其中所有的孕婦，都因他們沒有給他開城。',
    '王下15:17 猶大王亞撒利雅三十九年，迦底的兒子米拿現登基，在撒瑪利亞作以色列王十年。',
    '王下15:18 他行耶和華眼中看為惡的事，終身不離開尼八的兒子耶羅波安使以色列人陷在罪裡的那罪。',
    '王下15:19 亞述王普勒來攻擊以色列國，米拿現給他一千他連得銀子，請普勒幫助他堅定國位。',
    '王下15:20 米拿現向以色列一切大富戶索要銀子，使他們各出五十舍客勒，就給了亞述王。於是亞述王回去，不在國中停留。',
    '王下15:21 米拿現其餘的事，凡他所行的都寫在以色列諸王記上。',
    '王下15:22 米拿現與他列祖同睡。他兒子比加轄接續他作王。',
    '王下15:23 猶大王亞撒利雅五十年，米拿現的兒子比加轄在撒瑪利亞登基作以色列王二年。',
    '王下15:24 他行耶和華眼中看為惡的事，不離開尼八的兒子耶羅波安使以色列人陷在罪裡的那罪。',
    '王下15:25 比加轄的將軍、利瑪利的兒子比加背叛他，在撒瑪利亞王宮裡的衛所殺了他。亞珥歌伯和亞利耶並基列的五十人幫助比加；比加擊殺他，篡了他的位。',
    '王下15:26 比加轄其餘的事，凡他所行的都寫在以色列諸王記上。',
    '王下15:27 猶大王亞撒利雅五十二年，利瑪利的兒子比加在撒瑪利亞登基作以色列王二十年。',
    '王下15:28 他行耶和華眼中看為惡的事，不離開尼八的兒子耶羅波安使以色列人陷在罪裡的那罪。',
    '王下15:29 以色列王比加年間，亞述王提革拉‧毘列色來奪了以雲、亞伯伯瑪迦、亞挪、基低斯、夏瑣、基列、加利利，和拿弗他利全地，將這些地方的居民都擄到亞述去了。',
    '王下15:30 烏西雅的兒子約坦二十年，以拉的兒子何細亞背叛利瑪利的兒子比加，擊殺他，篡了他的位。',
    '王下15:31 比加其餘的事，凡他所行的都寫在以色列諸王記上。',
    '王下15:32 以色列王利瑪利的兒子比加第二年，猶大王烏西雅的兒子約坦登基。',
    '王下15:33 他登基的時候年二十五歲，在耶路撒冷作王十六年。他母親名叫耶路沙，是撒督的女兒。',
    '王下15:34 約坦行耶和華眼中看為正的事，效法他父親烏西雅一切所行的；',
    '王下15:35 只是邱壇還沒有廢去，百姓仍在那裡獻祭燒香。約坦建立耶和華殿的上門。',
    '王下15:36 約坦其餘的事，凡他所行的都寫在猶大列王記上。',
    '王下15:37 在那些日子，耶和華才使亞蘭王利汛和利瑪利的兒子比加去攻擊猶大。',
    '王下15:38 約坦與他列祖同睡，葬在他祖大衛城他列祖的墳地裡。他兒子亞哈斯接續他作王。',
    '王下16:1 利瑪利的兒子比加十七年，猶大王約坦的兒子亞哈斯登基。',
    '王下16:2 他登基的時候年二十歲，在耶路撒冷作王十六年；不像他祖大衛行耶和華─他神眼中看為正的事，',
    '王下16:3 卻效法以色列諸王所行的，又照著耶和華從以色列人面前趕出的外邦人所行可憎的事，使他的兒子經火，',
    '王下16:4 並在邱壇上、山岡上、各青翠樹下獻祭燒香。',
    '王下16:5 亞蘭王利汛和以色列王利瑪利的兒子比加上來攻打耶路撒冷，圍困亞哈斯，卻不能勝他。',
    '王下16:6 當時亞蘭王利汛收回以拉他歸與亞蘭，將猶大人從以拉他趕出去。亞蘭人【有作以東人的】就來到以拉他，住在那裡，直到今日。',
    '王下16:7 亞哈斯差遣使者去見亞述王提革拉‧毘列色，說：我是你的僕人、你的兒子。現在亞蘭王和以色列王攻擊我，求你來救我脫離他們的手。',
    '王下16:8 亞哈斯將耶和華殿裡和王宮府庫裡所有的金銀都送給亞述王為禮物。',
    '王下16:9 亞述王應允了他，就上去攻打大馬色，將城攻取，殺了利汛，把居民擄到吉珥。',
    '王下16:10 亞哈斯王上大馬色去迎接亞述王提革拉‧毘列色，在大馬色看見一座壇，就照壇的規模樣式作法畫了圖樣，送到祭司烏利亞那裡。',
    '王下16:11 祭司烏利亞照著亞哈斯王從大馬色送來的圖樣，在亞哈斯王沒有從大馬色回來之先，建築一座壇。',
    '王下16:12 王從大馬色回來看見壇，就近前來，在壇上獻祭；',
    '王下16:13 燒燔祭、素祭、澆奠祭，將平安祭牲的血灑在壇上，',
    '王下16:14 又將耶和華面前的銅壇從耶和華殿和新壇的中間搬到新壇的北邊。',
    '王下16:15 亞哈斯王吩咐祭司烏利亞說：早晨的燔祭、晚上的素祭，王的燔祭、素祭，國內眾民的燔祭、素祭、奠祭都要燒在大壇上。燔祭牲和平安祭牲的血也要灑在這壇上，只是銅壇我要用以求問耶和華。',
    '王下16:16 祭司烏利亞就照著亞哈斯王所吩咐的行了。',
    '王下16:17 亞哈斯王打掉盆座四面鑲著的心子，把盆從座上挪下來，又將銅海從馱海的銅牛上搬下來，放在鋪石地；',
    '王下16:18 又因亞述王的緣故，將耶和華殿為安息日所蓋的廊子和王從外入殿的廊子挪移，圍繞耶和華的殿。',
    '王下16:19 亞哈斯其餘所行的事都寫在猶大列王記上。',
    '王下16:20 亞哈斯與他列祖同睡，葬在大衛城他列祖的墳地裡。他兒子希西家接續他作王。',
    '王下17:1 猶大王亞哈斯十二年，以拉的兒子何細亞在撒瑪利亞登基作以色列王九年。',
    '王下17:2 他行耶和華眼中看為惡的事，只是不像在他以前的以色列諸王。',
    '王下17:3 亞述王撒縵以色上來攻擊何細亞，何細亞就服事他，給他進貢。',
    '王下17:4 何細亞背叛，差人去見埃及王梭，不照往年所行的與亞述王進貢。亞述王知道了，就把他鎖禁，囚在監裡。',
    '王下17:5 亞述王上來攻擊以色列遍地，上到撒瑪利亞，圍困三年。',
    '王下17:6 何細亞第九年亞述王攻取了撒瑪利亞，將以色列人擄到亞述，把他們安置在哈臘與歌散的哈博河邊，並瑪代人的城邑。',
    '王下17:7 這是因以色列人得罪那領他們出埃及地、脫離埃及王法老手的耶和華─他們的神，去敬畏別神，',
    '王下17:8 隨從耶和華在他們面前所趕出外邦人的風俗和以色列諸王所立的條規。',
    '王下17:9 以色列人暗中行不正的事，違背耶和華─他們的神，在他們所有的城邑，從瞭望樓直到堅固城，建築邱壇；',
    '王下17:10 在各高岡上、各青翠樹下立柱像和木偶；',
    '王下17:11 在邱壇上燒香，效法耶和華在他們面前趕出的外邦人所行的，又行惡事惹動耶和華的怒氣；',
    '王下17:12 且事奉偶像，就是耶和華警戒他們不可行的。',
    '王下17:13 但耶和華藉眾先知、先見勸戒以色列人和猶大人說：當離開你們的惡行，謹守我的誡命律例，遵行我吩咐你們列祖，並藉我僕人眾先知所傳給你們的律法。',
    '王下17:14 他們卻不聽從，竟硬著頸項，效法他們列祖，不信服耶和華─他們的神，',
    '王下17:15 厭棄他的律例和他與他們列祖所立的約，並勸戒他們的話，隨從虛無的神，自己成為虛妄，效法周圍的外邦人，就是耶和華囑咐他們不可效法的；',
    '王下17:16 離棄耶和華─他們神的一切誡命，為自己鑄了兩個牛犢的像，立了亞舍拉，敬拜天上的萬象，事奉巴力，',
    '王下17:17 又使他們的兒女經火，用占卜，行法術賣了自己，行耶和華眼中看為惡的事，惹動他的怒氣。',
    '王下17:18 所以耶和華向以色列人大大發怒，從自己面前趕出他們，只剩下猶大一個支派。',
    '王下17:19 猶大人也不遵守耶和華─他們神的誡命，隨從以色列人所立的條規。',
    '王下17:20 耶和華就厭棄以色列全族，使他們受苦，把他們交在搶奪他們的人手中，以致趕出他們離開自己面前，',
    '王下17:21 將以色列國從大衛家奪回；他們就立尼八的兒子耶羅波安作王。耶羅波安引誘以色列人不隨從耶和華，陷在大罪裡。',
    '王下17:22 以色列人犯耶羅波安所犯的一切罪，總不離開，',
    '王下17:23 以致耶和華從自己面前趕出他們，正如藉他僕人眾先知所說的。這樣，以色列人從本地被擄到亞述，直到今日。',
    '王下17:24 亞述王從巴比倫、古他、亞瓦、哈馬，和西法瓦音遷移人來，安置在撒瑪利亞的城邑，代替以色列人；他們就得了撒瑪利亞，住在其中。',
    '王下17:25 他們才住那裡的時候，不敬畏耶和華，所以耶和華叫獅子進入他們中間，咬死了些人。',
    '王下17:26 有人告訴亞述王說：你所遷移安置在撒瑪利亞各城的那些民，不知道那地之神的規矩，所以那神叫獅子進入他們中間，咬死他們。',
    '王下17:27 亞述王就吩咐說：叫所擄來的祭司回去一個，使他住在那裡，將那地之神的規矩指教那些民。',
    '王下17:28 於是有一個從撒瑪利亞擄去的祭司回來，住在伯特利，指教他們怎樣敬畏耶和華。',
    '王下17:29 然而，各族之人在所住的城裡各為自己製造神像，安置在撒瑪利亞人所造有邱壇的殿中。',
    '王下17:30 巴比倫人造疏割‧比訥像；古他人造匿甲像；哈馬人造亞示瑪像；',
    '王下17:31 亞瓦人造匿哈和他珥他像；西法瓦音人用火焚燒兒女，獻給西法瓦音的神亞得米勒和亞拿米勒。',
    '王下17:32 他們懼怕耶和華，也從他們中間立邱壇的祭司，為他們在有邱壇的殿中獻祭。',
    '王下17:33 他們又懼怕耶和華，又事奉自己的神，從何邦遷移，就隨何邦的風俗。',
    '王下17:34 他們直到如今仍照先前的風俗去行，不專心敬畏耶和華，不全守自己的規矩、典章，也不遵守耶和華吩咐雅各後裔的律法、誡命。（雅各，就是從前耶和華起名叫以色列的。）',
    '王下17:35 耶和華曾與他們立約，囑咐他們說：不可敬畏別神，不可跪拜事奉他，也不可向他獻祭。',
    '王下17:36 但那用大能和伸出來的膀臂領你們出埃及地的耶和華，你們當敬畏，跪拜，向他獻祭。',
    '王下17:37 他給你們寫的律例、典章、律法、誡命，你們應當永遠謹守遵行，不可敬畏別神。',
    '王下17:38 我─耶和華與你們所立的約你們不可忘記，也不可敬畏別神。',
    '王下17:39 但要敬畏耶和華─你們的神，他必救你們脫離一切仇敵的手。',
    '王下17:40 他們卻不聽從，仍照先前的風俗去行。',
    '王下17:41 如此這些民又懼怕耶和華，又事奉他們的偶像。他們子子孫孫也都照樣行，效法他們的祖宗，直到今日。',
    '王下18:1 以色列王以拉的兒子何細亞第三年，猶大王亞哈斯的兒子希西家登基。',
    '王下18:2 他登基的時候年二十五歲，在耶路撒冷作王二十九年。他母親名叫亞比，是撒迦利雅的女兒。',
    '王下18:3 希西家行耶和華眼中看為正的事，效法他祖大衛一切所行的。',
    '王下18:4 他廢去邱壇，毀壞柱像，砍下木偶，打碎摩西所造的銅蛇，因為到那時以色列人仍向銅蛇燒香。希西家叫銅蛇為銅塊【或作人稱銅蛇為銅像】。',
    '王下18:5 希西家倚靠耶和華─以色列的神，在他前後的猶大列王中沒有一個及他的。',
    '王下18:6 因為他專靠耶和華，總不離開，謹守耶和華所吩咐摩西的誡命。',
    '王下18:7 耶和華與他同在，他無論往何處去盡都亨通。他背叛、不肯事奉亞述王。',
    '王下18:8 希西家攻擊非利士人，直到迦薩，並迦薩的四境，從瞭望樓到堅固城。',
    '王下18:9 希西家王第四年，就是以色列王以拉的兒子何細亞第七年，亞述王撒縵以色上來圍困撒瑪利亞；',
    '王下18:10 過了三年就攻取了城。希西家第六年，以色列王何細亞第九年，撒瑪利亞被攻取了。',
    '王下18:11 亞述王將以色列人擄到亞述，把他們安置在哈臘與歌散的哈博河邊，並瑪代人的城邑；',
    '王下18:12 都因他們不聽從耶和華─他們神的話，違背他的約，就是耶和華僕人摩西吩咐他們所當守的。',
    '王下18:13 希西家王十四年，亞述王西拿基立上來攻擊猶大的一切堅固城，將城攻取。',
    '王下18:14 猶大王希西家差人往拉吉去見亞述王，說：我有罪了，求你離開我；凡你罰我的，我必承當。於是亞述王罰猶大王希西家銀子三百他連得，金子三十他連得。',
    '王下18:15 希西家就把耶和華殿裡和王宮府庫裡所有的銀子都給了他。',
    '王下18:16 那時，猶大王希西家將耶和華殿門上的金子和他自己包在柱上的金子都刮下來，給了亞述王。',
    '王下18:17 亞述王從拉吉差遣他珥探、拉伯撒利，和拉伯沙基率領大軍往耶路撒冷，到希西家王那裡去。他們上到耶路撒冷，就站在上池的水溝旁，在漂布地的大路上。',
    '王下18:18 他們呼叫王的時候，就有希勒家的兒子家宰以利亞敬，並書記舍伯那和亞薩的兒子史官約亞，出來見他們。',
    '王下18:19 拉伯沙基說：你們去告訴希西家說，亞述大王如此說：你所倚靠的有什麼可仗賴的呢﹖',
    '王下18:20 你說有打仗的計謀和能力，我看不過是虛話。你到底倚靠誰才背叛我呢﹖',
    '王下18:21 看哪，你所倚靠的埃及是那壓傷的葦杖；人若靠這杖，就必刺透他的手。埃及王法老向一切倚靠他的人也是這樣。',
    '王下18:22 你們若對我說：我們倚靠耶和華─我們的神，希西家豈不是將神的邱壇和祭壇廢去，且對猶大和耶路撒冷的人說：你們當在耶路撒冷這壇前敬拜嗎﹖',
    '王下18:23 現在你把當頭給我主亞述王，我給你二千匹馬，看你這一面騎馬的人夠不夠。',
    '王下18:24 若不然，怎能打敗我主臣僕中最小的軍長呢﹖你竟倚靠埃及的戰車馬兵嗎﹖',
    '王下18:25 現在我上來攻擊毀滅這地，豈沒有耶和華的意思嗎﹖耶和華吩咐我說：你上去攻擊毀滅這地吧！',
    '王下18:26 希勒家的兒子以利亞敬和舍伯那，並約亞，對拉伯沙基說：求你用亞蘭言語和僕人說話，因為我們懂得；不要用猶大言語和我們說話，達到城上百姓的耳中。',
    '王下18:27 拉伯沙基說：我主差遣我來，豈是單對你和你的主說這些話嗎﹖不也是對這些坐在城上、要與你們一同吃自己糞、喝自己尿的人說嗎﹖',
    '王下18:28 於是拉伯沙基站著，用猶大言語大聲喊著說：你們當聽亞述大王的話！',
    '王下18:29 王如此說：你們不要被希西家欺哄了；因他不能救你們脫離我的手。',
    '王下18:30 也不要聽希西家使你們倚靠耶和華，說耶和華必要拯救我們，這城必不交在亞述王的手中。',
    '王下18:31 不要聽希西家的話！因亞述王如此說：你們要與我和好，出來投降我，各人就可以吃自己葡萄樹和無花果樹的果子，喝自己井裡的水。',
    '王下18:32 等我來領你們到一個地方與你們本地一樣，就是有五穀和新酒之地，有糧食和葡萄園之地，有橄欖樹和蜂蜜之地，好使你們存活，不至於死。希西家勸導你們，說耶和華必拯救我們；你們不要聽他的話。',
    '王下18:33 列國的神有哪一個救他本國脫離亞述王的手呢﹖',
    '王下18:34 哈馬、亞珥拔的神在哪裡呢﹖西法瓦音、希拿、以瓦的神在哪裡呢﹖他們曾救撒瑪利亞脫離我的手嗎﹖',
    '王下18:35 這些國的神有誰曾救自己的國脫離我的手呢﹖難道耶和華能救耶路撒冷脫離我的手嗎﹖',
    '王下18:36 百姓靜默不言，並不回答一句，因為王曾吩咐說：不要回答他。',
    '王下18:37 當下，希勒家的兒子家宰以利亞敬和書記舍伯那，並亞薩的兒子史官約亞，都撕裂衣服，來到希西家那裡，將拉伯沙基的話告訴了他。',
    '王下19:1 希西家王聽見，就撕裂衣服，披上麻布，進了耶和華的殿；',
    '王下19:2 使家宰以利亞敬和書記舍伯那，並祭司中的長老，都披上麻布，去見亞摩斯的兒子先知以賽亞，',
    '王下19:3 對他說：希西家如此說：今日是急難、責罰、凌辱的日子，就如婦人將要生產嬰孩，卻沒有力量生產。',
    '王下19:4 或者耶和華─你的神聽見拉伯沙基的一切話，就是他主人亞述王打發他來辱罵永生神的話，耶和華─你的神聽見這話，就發斥責。故此，求你為餘剩的民揚聲禱告。',
    '王下19:5 希西家王的臣僕就去見以賽亞。',
    '王下19:6 以賽亞對他們說：要這樣對你們的主人說，耶和華如此說：你聽見亞述王的僕人褻瀆我的話，不要懼怕。',
    '王下19:7 我必驚動【原文作使靈進入】他的心，他要聽見風聲就歸回本地。我必使他在那裡倒在刀下。',
    '王下19:8 拉伯沙基回去，正遇見亞述王攻打立拿，原來他早聽見亞述王拔營離開拉吉。',
    '王下19:9 亞述王聽見人論古實王特哈加說：他出來要與你爭戰。於是亞述王又打發使者去見希西家，吩咐他們說：',
    '王下19:10 你們對猶大王希西家如此說：不要聽你所倚靠的神欺哄你，說耶路撒冷必不交在亞述王的手中。',
    '王下19:11 你總聽說亞述諸王向列國所行的，乃是盡行滅絕，難道你還能得救嗎﹖',
    '王下19:12 我列祖所毀滅的，就是歌散、哈蘭、利色，和屬提‧拉撒的伊甸人，這些國的神何曾拯救這些國呢﹖',
    '王下19:13 哈馬的王、亞珥拔的王、西法瓦音城的王、希拿，和以瓦的王都在哪裡呢﹖',
    '王下19:14 希西家從使者手裡接過書信來，看完了，就上耶和華的殿，將書信在耶和華面前展開。',
    '王下19:15 希西家向耶和華禱告說：坐在二基路伯上耶和華─以色列的神啊，你是天下萬國的神，你曾創造天地。',
    '王下19:16 耶和華啊，求你側耳而聽！耶和華啊，求你睜眼而看！要聽西拿基立打發使者來辱罵永生神的話。',
    '王下19:17 耶和華啊，亞述諸王果然使列國和列國之地變為荒涼，',
    '王下19:18 將列國的神像都扔在火裡；因為他本不是神，乃是人手所造的，是木頭石頭的，所以滅絕他。',
    '王下19:19 耶和華─我們的神啊，現在求你救我們脫離亞述王的手，使天下萬國都知道惟獨你─耶和華是神！',
    '王下19:20 亞摩斯的兒子以賽亞就打發人去見希西家，說：耶和華─以色列的神如此說：你既然求我攻擊亞述王西拿基立，我已聽見了。',
    '王下19:21 耶和華論他這樣說：錫安的處女藐視你，嗤笑你；耶路撒冷的女子向你搖頭。',
    '王下19:22 你辱罵誰﹖褻瀆誰﹖揚起聲來，高舉眼目攻擊誰呢﹖乃是攻擊以色列的聖者！',
    '王下19:23 你藉你的使者辱罵主，並說：我率領許多戰車上山頂，到利巴嫩極深之處；我要砍伐其中高大的香柏樹和佳美的松樹；我必上極高之處，進入肥田的樹林。',
    '王下19:24 我已經在外邦挖井喝水；我必用腳掌踏乾埃及的一切河。',
    '王下19:25 耶和華說，我早先所做的，古時所立的，就是現在藉你使堅固城荒廢，變為亂堆，這事你豈沒有聽見嗎﹖',
    '王下19:26 所以其中的居民力量甚小，驚惶羞愧。他們像野草，像青菜，如房頂上的草，又如未長成而枯乾的禾稼。',
    '王下19:27 你坐下，你出去，你進來，你向我發烈怒，我都知道。',
    '王下19:28 因你向我發烈怒，又因你狂傲的話達到我耳中，我就要用鉤子鉤上你的鼻子，把嚼環放在你口裡，使你從你來的路轉回去。',
    '王下19:29 以色列人哪，我賜你們一個證據：你們今年要吃自生的，明年也要吃自長的；至於後年，你們要耕種收割，栽植葡萄園，吃其中的果子。',
    '王下19:30 猶大家所逃脫餘剩的，仍要往下扎根，向上結果。',
    '王下19:31 必有餘剩的民從耶路撒冷而出；必有逃脫的人從錫安山而來。耶和華的熱心必成就這事。',
    '王下19:32 所以，耶和華論亞述王如此說：他必不得來到這城，也不在這裡射箭，不得拿盾牌到城前，也不築壘攻城。',
    '王下19:33 他從哪條路來，必從那條路回去，必不得來到這城。這是耶和華說的。',
    '王下19:34 因我為自己的緣故，又為我僕人大衛的緣故，必保護拯救這城。',
    '王下19:35 當夜，耶和華的使者出去，在亞述營中殺了十八萬五千人。清早有人起來，一看，都是死屍了。',
    '王下19:36 亞述王西拿基立就拔營回去，住在尼尼微。',
    '王下19:37 一日在他的神尼斯洛廟裡叩拜，他兒子亞得米勒和沙利色用刀殺了他，就逃到亞拉臘地。他兒子以撒哈頓接續他作王。',
    '王下20:1 那時，希西家病得要死。亞摩斯的兒子先知以賽亞去見他，對他說：耶和華如此說：你當留遺命與你的家，因為你必死，不能活了。',
    '王下20:2 希西家就轉臉朝牆，禱告耶和華說：',
    '王下20:3 耶和華啊，求你記念我在你面前怎樣存完全的心，按誠實行事，又做你眼中所看為善的。希西家就痛哭了。',
    '王下20:4 以賽亞出來，還沒有到中院【院或作城】，耶和華的話就臨到他，說：',
    '王下20:5 你回去告訴我民的君希西家說：耶和華─你祖大衛的神如此說：我聽見了你的禱告，看見了你的眼淚，我必醫治你；到第三日，你必上到耶和華的殿。',
    '王下20:6 我必加增你十五年的壽數，並且我要救你和這城脫離亞述王的手。我為自己和我僕人大衛的緣故，必保護這城。',
    '王下20:7 以賽亞說：當取一塊無花果餅來。人就取了來，貼在瘡上，王便痊癒了。',
    '王下20:8 希西家問以賽亞說：耶和華必醫治我，到第三日，我能上耶和華的殿，有什麼兆頭呢﹖',
    '王下20:9 以賽亞說：耶和華必成就他所說的。這是他給你的兆頭：你要日影向前進十度呢﹖是要往後退十度呢﹖',
    '王下20:10 希西家回答說：日影向前進十度容易，我要日影往後退十度。',
    '王下20:11 先知以賽亞求告耶和華，耶和華就使亞哈斯的日晷向前進的日影，往後退了十度。',
    '王下20:12 那時，巴比倫王巴拉但的兒子比羅達‧巴拉但聽見希西家病而痊癒，就送書信和禮物給他。',
    '王下20:13 希西家聽從使者的話，就把他寶庫的金子、銀子、香料、貴重的膏油，和他武庫的一切軍器，並他所有的財寶，都給他們看。他家中和他全國之內，希西家沒有一樣不給他們看的。',
    '王下20:14 於是先知以賽亞來見希西家王，問他說：這些人說什麼﹖他們從哪裡來見你﹖希西家說：他們從遠方的巴比倫來。',
    '王下20:15 以賽亞說：他們在你家裡看見了什麼﹖希西家說：凡我家中所有的，他們都看見了；我財寶中沒有一樣不給他們看的。',
    '王下20:16 以賽亞對希西家說：你要聽耶和華的話，',
    '王下20:17 日子必到，凡你家裡所有的，並你列祖積蓄到如今的，都要被擄到巴比倫去，不留下一樣。這是耶和華說的。',
    '王下20:18 並且從你本身所生的眾子，其中必有被擄去在巴比倫王宮裡當太監的。',
    '王下20:19 希西家對以賽亞說：你所說耶和華的話甚好！若在我的年日中有太平和穩固的景況，豈不是好嗎﹖',
    '王下20:20 希西家其餘的事和他的勇力，他怎樣挖池、挖溝、引水入城，都寫在猶大列王記上。',
    '王下20:21 希西家與他列祖同睡。他兒子瑪拿西接續他作王。',
    '王下21:1 瑪拿西登基的時候年十二歲，在耶路撒冷作王五十五年。他母親名叫協西巴。',
    '王下21:2 瑪拿西行耶和華眼中看為惡的事，效法耶和華在以色列人面前趕出的外邦人所行可憎的事。',
    '王下21:3 重新建築他父希西家所毀壞的邱壇，又為巴力築壇，做亞舍拉像，效法以色列王亞哈所行的，且敬拜事奉天上的萬象；',
    '王下21:4 在耶和華殿宇中築壇。耶和華曾指著這殿說：我必立我的名在耶路撒冷。',
    '王下21:5 他在耶和華殿的兩院中為天上的萬象築壇，',
    '王下21:6 並使他的兒子經火，又觀兆，用法術，立交鬼的和行巫術的，多行耶和華眼中看為惡的事，惹動他的怒氣；',
    '王下21:7 又在殿內立雕刻的亞舍拉像。耶和華曾對大衛和他兒子所羅門說：我在以色列眾支派中所選擇的耶路撒冷和這殿，必立我的名，直到永遠。',
    '王下21:8 以色列人若謹守遵行我一切所吩咐他們的和我僕人摩西所吩咐他們的一切律法，我就不再使他們挪移離開我所賜給他們列祖之地。',
    '王下21:9 他們卻不聽從。瑪拿西引誘他們行惡，比耶和華在以色列人面前所滅的列國更甚。',
    '王下21:10 耶和華藉他僕人眾先知說：',
    '王下21:11 因猶大王瑪拿西行這些可憎的惡事比先前亞摩利人所行的更甚，使猶大人拜他的偶像，陷在罪裡；',
    '王下21:12 所以耶和華─以色列的神如此說：我必降禍與耶路撒冷和猶大，叫一切聽見的人無不耳鳴。',
    '王下21:13 我必用量撒瑪利亞的準繩和亞哈家的線鉈拉在耶路撒冷上，必擦淨耶路撒冷，如人擦盤，將盤倒扣。',
    '王下21:14 我必棄掉所餘剩的子民【原文作產業】，把他們交在仇敵手中，使他們成為一切仇敵擄掠之物；',
    '王下21:15 是因他們自從列祖出埃及直到如今，常行我眼中看為惡的事，惹動我的怒氣。',
    '王下21:16 瑪拿西行耶和華眼中看為惡的事，使猶大人陷在罪裡，又流許多無辜人的血，充滿了耶路撒冷，從這邊直到那邊。',
    '王下21:17 瑪拿西其餘的事，凡他所行的和他所犯的罪都寫在猶大列王記上。',
    '王下21:18 瑪拿西與他列祖同睡，葬在自己宮院烏撒的園內；他兒子亞們接續他作王。',
    '王下21:19 亞們登基的時候年二十二歲，在耶路撒冷作王二年。他母親名叫米舒利密，是約提巴人哈魯斯的女兒。',
    '王下21:20 亞們行耶和華眼中看為惡的事，與他父親瑪拿西所行的一樣；',
    '王下21:21 行他父親一切所行的，敬奉他父親所敬奉的偶像，',
    '王下21:22 離棄耶和華─他列祖的神，不遵行耶和華的道。',
    '王下21:23 亞們王的臣僕背叛他，在宮裡殺了他。',
    '王下21:24 但國民殺了那些背叛亞們王的人，立他兒子約西亞接續他作王。',
    '王下21:25 亞們其餘所行的事都寫在猶大列王記上。',
    '王下21:26 亞們葬在烏撒的園內自己的墳墓裡。他兒子約西亞接續他作王。',
    '王下22:1 約西亞登基的時候年八歲，在耶路撒冷作王三十一年。他母親名叫耶底大，是波斯加人亞大雅的女兒。',
    '王下22:2 約西亞行耶和華眼中看為正的事，行他祖大衛一切所行的，不偏左右。',
    '王下22:3 約西亞王十八年，王差遣米書蘭的孫子、亞薩利的兒子─書記沙番上耶和華殿去，吩咐他說：',
    '王下22:4 你去見大祭司希勒家，使他將奉到耶和華殿的銀子，就是守門的從民中收聚的銀子，數算數算，',
    '王下22:5 交給耶和華殿裡辦事的人，使他們轉交耶和華殿裡做工的人，好修理殿的破壞之處，',
    '王下22:6 就是轉交木匠和工人，並瓦匠，又買木料和鑿成的石頭修理殿宇，',
    '王下22:7 將銀子交在辦事的人手裡，不與他們算帳，因為他們辦事誠實。',
    '王下22:8 大祭司希勒家對書記沙番說：我在耶和華殿裡得了律法書。希勒家將書遞給沙番，沙番就看了。',
    '王下22:9 書記沙番到王那裡，回覆王說：你的僕人已將殿裡的銀子倒出數算，交給耶和華殿裡辦事的人了。',
    '王下22:10 書記沙番又對王說：祭司希勒家遞給我一卷書。沙番就在王面前讀那書。',
    '王下22:11 王聽見律法書上的話，便撕裂衣服，',
    '王下22:12 吩咐祭司希勒家與沙番的兒子亞希甘、米該亞的兒子亞革波、書記沙番和王的臣僕亞撒雅，說：',
    '王下22:13 你們去為我、為民、為猶大眾人，以這書上的話求問耶和華；因為我們列祖沒有聽從這書上的言語，沒有遵著書上所吩咐我們的去行，耶和華就向我們大發烈怒。',
    '王下22:14 於是，祭司希勒家和亞希甘、亞革波、沙番、亞撒雅都去見女先知戶勒大。戶勒大是掌管禮服沙龍的妻；沙龍是哈珥哈斯的孫子、特瓦的兒子。戶勒大住在耶路撒冷第二區。他們請問於他。',
    '王下22:15 他對他們說：耶和華─以色列的神如此說：你們可以回覆那差遣你們來見我的人說，',
    '王下22:16 耶和華如此說：我必照著猶大王所讀那書上的一切話，降禍與這地和其上的居民。',
    '王下22:17 因為他們離棄我，向別神燒香，用他們手所做的惹我發怒，所以我的忿怒必向這地發作，總不止息。',
    '王下22:18 然而，差遣你們來求問耶和華的猶大王，你們要這樣回覆他說：耶和華─以色列的神如此說：至於你所聽見的話，',
    '王下22:19 就是聽見我指著這地和其上的居民所說、要使這地變為荒場、民受咒詛的話，你便心裡敬服，在我面前自卑，撕裂衣服，向我哭泣，因此我應允了你。這是我─耶和華說的。',
    '王下22:20 我必使你平平安安地歸到墳墓到你列祖那裡；我要降與這地的一切災禍，你也不致親眼看見。他們就回覆王去了。',
    '王下23:1 王差遣人招聚猶大和耶路撒冷的眾長老來。',
    '王下23:2 王和猶大眾人與耶路撒冷的居民，並祭司、先知，和所有的百姓，無論大小，都一同上到耶和華的殿；王就把耶和華殿裡所得的約書念給他們聽。',
    '王下23:3 王站在柱旁，在耶和華面前立約，要盡心盡性地順從耶和華，遵守他的誡命、法度、律例，成就這書上所記的約言。眾民都服從這約。',
    '王下23:4 王吩咐大祭司希勒家和副祭司，並把門的，將那為巴力和亞舍拉，並天上萬象所造的器皿，都從耶和華殿裡搬出來，在耶路撒冷外汲淪溪旁的田間燒了，把灰拿到伯特利去。',
    '王下23:5 從前猶大列王所立拜偶像的祭司，在猶大城邑的邱壇和耶路撒冷的周圍燒香，現在王都廢去，又廢去向巴力和日、月、行星【或作十二宮】，並天上萬象燒香的人；',
    '王下23:6 又從耶和華殿裡將亞舍拉搬到耶路撒冷外汲淪溪邊焚燒，打碎成灰，將灰撒在平民的墳上；',
    '王下23:7 又拆毀耶和華殿裡孌童的屋子，就是婦女為亞舍拉織帳子的屋子，',
    '王下23:8 並且從猶大的城邑帶眾祭司來，污穢祭司燒香的邱壇，從迦巴直到別是巴，又拆毀城門旁的邱壇，這邱壇在邑宰約書亞門前，進城門的左邊。',
    '王下23:9 但是邱壇的祭司不登耶路撒冷耶和華的壇，只在他們弟兄中間吃無酵餅。',
    '王下23:10 又污穢欣嫩子谷的陀斐特，不許人在那裡使兒女經火獻給摩洛；',
    '王下23:11 又將猶大列王在耶和華殿門旁、太監拿單米勒靠近遊廊的屋子、向日頭所獻的馬廢去，且用火焚燒日車。',
    '王下23:12 猶大列王在亞哈斯樓頂上所築的壇和瑪拿西在耶和華殿兩院中所築的壇，王都拆毀打碎了，就把灰倒在汲淪溪中。',
    '王下23:13 從前以色列王所羅門在耶路撒冷前、邪僻山右邊為西頓人可憎的神亞斯她錄、摩押人可憎的神基抹、亞捫人可憎的神米勒公所築的邱壇，王都污穢了，',
    '王下23:14 又打碎柱像，砍下木偶，將人的骨頭充滿了那地方。',
    '王下23:15 他將伯特利的壇，就是叫以色列人陷在罪裡、尼八的兒子耶羅波安所築的那壇，都拆毀焚燒，打碎成灰，並焚燒了亞舍拉。',
    '王下23:16 約西亞回頭，看見山上的墳墓，就打發人將墳墓裡的骸骨取出來，燒在壇上，污穢了壇，正如從前神人宣傳耶和華的話。',
    '王下23:17 約西亞問說：我所看見的是什麼碑﹖那城裡的人回答說：先前有神人從猶大來，預先說王現在向伯特利壇所行的事，這就是他的墓碑。',
    '王下23:18 約西亞說：由他吧！不要挪移他的骸骨。他們就不動他的骸骨，也不動從撒瑪利亞來那先知的骸骨。',
    '王下23:19 從前以色列諸王在撒瑪利亞的城邑建築邱壇的殿，惹動耶和華的怒氣，現在約西亞都廢去了，就如他在伯特利所行的一般；',
    '王下23:20 又將邱壇的祭司都殺在壇上，並在壇上燒人的骨頭，就回耶路撒冷去了。',
    '王下23:21 王吩咐眾民說：你們當照這約書上所寫的，向耶和華─你們的神守逾越節。',
    '王下23:22 自從士師治理以色列人和以色列王、猶大王的時候，直到如今，實在沒有守過這樣的逾越節；',
    '王下23:23 只有約西亞王十八年在耶路撒冷向耶和華守這逾越節。',
    '王下23:24 凡猶大國和耶路撒冷所有交鬼的、行巫術的，與家中的神像和偶像，並一切可憎之物，約西亞盡都除掉，成就了祭司希勒家在耶和華殿裡所得律法書上所寫的話。',
    '王下23:25 在約西亞以前沒有王像他盡心、盡性、盡力地歸向耶和華，遵行摩西的一切律法；在他以後也沒有興起一個王像他。',
    '王下23:26 然而，耶和華向猶大所發猛烈的怒氣仍不止息，是因瑪拿西諸事惹動他。',
    '王下23:27 耶和華說：我必將猶大人從我面前趕出，如同趕出以色列人一般；我必棄掉我從前所選擇的這城─耶路撒冷和我所說立我名的殿。',
    '王下23:28 約西亞其餘的事，凡他所行的都寫在猶大列王記上。',
    '王下23:29 約西亞年間，埃及王法老尼哥上到伯拉河攻擊亞述王；約西亞王去抵擋他。埃及王遇見約西亞在米吉多，就殺了他。',
    '王下23:30 他的臣僕用車將他的屍首從米吉多送到耶路撒冷，葬在他自己的墳墓裡。國民膏約西亞的兒子約哈斯接續他父親作王。',
    '王下23:31 約哈斯登基的時候年二十三歲，在耶路撒冷作王三個月。他母親名叫哈慕他，是立拿人耶利米的女兒。',
    '王下23:32 約哈斯行耶和華眼中看為惡的事，效法他列祖一切所行的。',
    '王下23:33 法老尼哥將約哈斯鎖禁在哈馬地的利比拉，不許他在耶路撒冷作王，又罰猶大國銀子一百他連得，金子一他連得。',
    '王下23:34 法老尼哥立約西亞的兒子以利亞敬接續他父親約西亞作王，給他改名叫約雅敬，卻將約哈斯帶到埃及，他就死在那裡。',
    '王下23:35 約雅敬將金銀給法老，遵著法老的命向國民徵取金銀，按著各人的力量派定，索要金銀，好給法老尼哥。',
    '王下23:36 約雅敬登基的時候年二十五歲，在耶路撒冷作王十一年。他母親名叫西布大，是魯瑪人毘大雅的女兒。',
    '王下23:37 約雅敬行耶和華眼中看為惡的事，效法他列祖一切所行的。',
    '王下24:1 約雅敬年間，巴比倫王尼布甲尼撒上到猶大；約雅敬服事他三年，然後背叛他。',
    '王下24:2 耶和華使迦勒底軍、亞蘭軍、摩押軍，和亞捫人的軍來攻擊約雅敬，毀滅猶大，正如耶和華藉他僕人眾先知所說的。',
    '王下24:3 這禍臨到猶大人，誠然是耶和華所命的，要將他們從自己面前趕出，是因瑪拿西所犯的一切罪；',
    '王下24:4 又因他流無辜人的血，充滿了耶路撒冷；耶和華決不肯赦免。',
    '王下24:5 約雅敬其餘的事，凡他所行的都寫在猶大列王記上。',
    '王下24:6 約雅敬與他列祖同睡。他兒子約雅斤接續他作王。',
    '王下24:7 埃及王不再從他國中出來；因為巴比倫王將埃及王所管之地，從埃及小河直到伯拉河都奪去了。',
    '王下24:8 約雅斤登基的時候年十八歲，在耶路撒冷作王三個月。他母親名叫尼護施他，是耶路撒冷人以利拿單的女兒。',
    '王下24:9 約雅斤行耶和華眼中看為惡的事，效法他父親一切所行的。',
    '王下24:10 那時，巴比倫王尼布甲尼撒的軍兵上到耶路撒冷，圍困城。',
    '王下24:11 當他軍兵圍困城的時候，巴比倫王尼布甲尼撒就親自來了。',
    '王下24:12 猶大王約雅斤和他母親、臣僕、首領、太監一同出城，投降巴比倫王；巴比倫王便拿住他。那時是巴比倫王第八年。',
    '王下24:13 巴比倫王將耶和華殿和王宮裡的寶物都拿去了，將以色列王所羅門所造耶和華殿裡的金器都毀壞了，正如耶和華所說的；',
    '王下24:14 又將耶路撒冷的眾民和眾首領，並所有大能的勇士，共一萬人，連一切木匠、鐵匠都擄了去；除了國中極貧窮的人以外，沒有剩下的；',
    '王下24:15 並將約雅斤和王母、后妃、太監，與國中的大官，都從耶路撒冷擄到巴比倫去了；',
    '王下24:16 又將一切勇士七千人和木匠、鐵匠一千人，都是能上陣的勇士，全擄到巴比倫去了。',
    '王下24:17 巴比倫王立約雅斤的叔叔瑪探雅代替他作王，給瑪探雅改名叫西底家。',
    '王下24:18 西底家登基的時候年二十一歲，在耶路撒冷作王十一年。他母親名叫哈慕他，是立拿人耶利米的女兒。',
    '王下24:19 西底家行耶和華眼中看為惡的事，是照約雅敬一切所行的。',
    '王下24:20 因此耶和華的怒氣在耶路撒冷和猶大發作，以致將人民從自己面前趕出。',
    '王下25:1 西底家背叛巴比倫王。他作王第九年十月初十日，巴比倫王尼布甲尼撒率領全軍來攻擊耶路撒冷，對城安營，四圍築壘攻城。',
    '王下25:2 於是城被圍困，直到西底家王十一年。',
    '王下25:3 四月初九日，城裡有大饑荒，甚至百姓都沒有糧食。',
    '王下25:4 城被攻破，一切兵丁就在夜間從靠近王園兩城中間的門逃跑。迦勒底人正在四圍攻城，王就向亞拉巴逃走。',
    '王下25:5 迦勒底的軍隊追趕王，在耶利哥的平原追上他；他的全軍都離開他四散了。',
    '王下25:6 迦勒底人就拿住王，帶他到在利比拉的巴比倫王那裡審判他。',
    '王下25:7 在西底家眼前殺了他的眾子，並且剜了西底家的眼睛，用銅鍊鎖著他，帶到巴比倫去。',
    '王下25:8 巴比倫王尼布甲尼撒十九年五月初七日，巴比倫王的臣僕、護衛長尼布撒拉旦來到耶路撒冷，',
    '王下25:9 用火焚燒耶和華的殿和王宮，又焚燒耶路撒冷的房屋，就是各大戶家的房屋。',
    '王下25:10 跟從護衛長迦勒底的全軍就拆毀耶路撒冷四圍的城牆。',
    '王下25:11 那時護衛長尼布撒拉旦將城裡所剩下的百姓，並已經投降巴比倫王的人，以及大眾所剩下的人，都擄去了。',
    '王下25:12 但護衛長留下些民中最窮的，使他們修理葡萄園，耕種田地。',
    '王下25:13 耶和華殿的銅柱，並耶和華殿的盆座和銅海，迦勒底人都打碎了，將那銅運到巴比倫去了，',
    '王下25:14 又帶去鍋、鏟子、蠟剪、調羹，並所用的一切銅器，',
    '王下25:15 火鼎、碗，無論金的銀的，護衛長也都帶去了。',
    '王下25:16 所羅門為耶和華殿所造的兩根銅柱、一個銅海，和幾個盆座，這一切的銅，多得無法可稱。',
    '王下25:17 這一根柱子高十八肘，柱上有銅頂，高三肘；銅頂的周圍有網子和石榴，都是銅的。那一根柱子，照此一樣，也有網子。',
    '王下25:18 護衛長拿住大祭司西萊雅、副祭司西番亞，和三個把門的，',
    '王下25:19 又從城中拿住一個管理兵丁的官【或作太監】，並在城裡所遇常見王面的五個人和檢點國民軍長的書記，以及城裡遇見的國民六十個人。',
    '王下25:20 護衛長尼布撒拉旦將這些人帶到在利比拉的巴比倫王那裡。',
    '王下25:21 巴比倫王就把他們擊殺在哈馬地的利比拉。這樣，猶大人被擄去離開本地。',
    '王下25:22 至於猶大國剩下的民，就是巴比倫王尼布甲尼撒所剩下的，巴比倫王立了沙番的孫子、亞希甘的兒子基大利作他們的省長。',
    '王下25:23 眾軍長和屬他們的人聽見巴比倫王立了基大利作省長，於是軍長尼探雅的兒子以實瑪利、加利亞的兒子約哈難、尼陀法人單戶蔑的兒子西萊雅、瑪迦人的兒子雅撒尼亞，和屬他們的人都到米斯巴見基大利。',
    '王下25:24 基大利向他們和屬他們的人起誓說：你們不必懼怕迦勒底臣僕，只管住在這地服事巴比倫王，就可以得福。',
    '王下25:25 七月間，宗室以利沙瑪的孫子、尼探雅的兒子以實瑪利帶著十個人來，殺了基大利和同他在米斯巴的猶大人與迦勒底人。',
    '王下25:26 於是眾民，無論大小，連眾軍長；因為懼怕迦勒底人，都起身往埃及去了。',
    '王下25:27 猶大王約雅斤被擄後三十七年，巴比倫王以未米羅達元年十二月二十七日，使猶大王約雅斤擡頭，提他出監；',
    '王下25:28 又對他說恩言，使他的位高過與他一同在巴比倫眾王的位，',
    '王下25:29 給他脫了囚服。他終身常在巴比倫王面前吃飯。',
    '王下25:30 王賜他所需用的食物，日日賜他一分，終身都是這樣。',
    '代上1:1 亞當生塞特；塞特生以挪士；',
    '代上1:2 以挪士生該南；該南生瑪勒列；瑪勒列生雅列；',
    '代上1:3 雅列生以諾；以諾生瑪土撒拉；瑪土撒拉生拉麥；',
    '代上1:4 拉麥生挪亞；挪亞生閃、含、雅弗。',
    '代上1:5 雅弗的兒子是歌篾、瑪各、瑪代、雅完、土巴、米設、提拉。',
    '代上1:6 歌篾的兒子是亞實基拿、低法【創十章三節作利法】、陀迦瑪。',
    '代上1:7 雅完的兒子是以利沙、他施、基提、多單【有作羅單的】。',
    '代上1:8 含的兒子是古實、麥西、弗、迦南。',
    '代上1:9 古實的兒子是西巴、哈腓拉、撒弗他、拉瑪、撒弗提迦。拉瑪的兒子是示巴、底但。',
    '代上1:10 古實生寧錄；他為世上英雄之首。',
    '代上1:11 麥西生路低人、亞拿米人、利哈比人、拿弗土希人、',
    '代上1:12 帕斯魯細人、迦斯路希人、迦斐託人；從迦斐託出來的有非利士人。',
    '代上1:13 迦南生長子西頓，又生赫',
    '代上1:14 和耶布斯人、亞摩利人、革迦撒人、',
    '代上1:15 希未人、亞基人、西尼人、',
    '代上1:16 亞瓦底人、洗瑪利人，並哈馬人。',
    '代上1:17 閃的兒子是以攔、亞述、亞法撒、路德、亞蘭、烏斯、戶勒、基帖、米設【創十23作瑪施】。',
    '代上1:18 亞法撒生沙拉；沙拉生希伯。',
    '代上1:19 希伯生了兩個兒子：一個名叫法勒【就是分的意思】，因為那時人就分地居住；法勒的兄弟名叫約坍。',
    '代上1:20 約坍生亞摩答、沙列、哈薩瑪非、耶拉、',
    '代上1:21 哈多蘭、烏薩、德拉、',
    '代上1:22 以巴錄、亞比瑪利、示巴、',
    '代上1:23 阿斐、哈腓拉、約巴。這都是約坍的兒子。',
    '代上1:24 閃生亞法撒；亞法撒生沙拉；',
    '代上1:25 沙拉生希伯；希伯生法勒；法勒生拉吳；',
    '代上1:26 拉吳生西鹿；西鹿生拿鶴；拿鶴生他拉；',
    '代上1:27 他拉生亞伯蘭，亞伯蘭就是亞伯拉罕。',
    '代上1:28 亞伯拉罕的兒子是以撒、以實瑪利。',
    '代上1:29 以實瑪利的兒子記在下面：以實瑪利的長子是尼拜約，其次是基達、押德別、米比衫、',
    '代上1:30 米施瑪、度瑪、瑪撒、哈達、提瑪、',
    '代上1:31 伊突、拿非施、基底瑪。這都是以實瑪利的兒子。',
    '代上1:32 亞伯拉罕的妾基土拉所生的兒子，就是心蘭、約珊、米但、米甸、伊施巴、書亞。約珊的兒子是示巴、底但。',
    '代上1:33 米甸的兒子是以法、以弗、哈諾、亞比大、以勒大。這都是基土拉的子孫。',
    '代上1:34 亞伯拉罕生以撒；以撒的兒子是以掃和以色列。',
    '代上1:35 以掃的兒子是以利法、流珥、耶烏施、雅蘭、可拉。',
    '代上1:36 以利法的兒子是提幔、阿抹、洗玻、迦坦、基納斯、亭納、亞瑪力。',
    '代上1:37 流珥的兒子是拿哈、謝拉、沙瑪、米撒。',
    '代上1:38 西珥的兒子是羅坍、朔巴、祭便、亞拿、底順、以察、底珊。',
    '代上1:39 羅坍的兒子是何利、荷幔；羅坍的妹子是亭納。',
    '代上1:40 朔巴的兒子是亞勒文、瑪拿轄、以巴錄、示非、阿南。祭便的兒子是亞雅、亞拿。',
    '代上1:41 亞拿的兒子是底順。底順的兒子是哈默蘭、伊是班、益蘭、基蘭。',
    '代上1:42 以察的兒子是辟罕、撒番、亞干。底珊的兒子是烏斯、亞蘭。',
    '代上1:43 以色列人未有君王治理之先，在以東地作王的記在下面：有比珥的兒子比拉，他的京城名叫亭哈巴。',
    '代上1:44 比拉死了，波斯拉人謝拉的兒子約巴接續他作王。',
    '代上1:45 約巴死了，提幔地的人戶珊接續他作王。',
    '代上1:46 戶珊死了，比達的兒子哈達接續他作王。這哈達就是在摩押地殺敗米甸人的，他的京城名叫亞未得。',
    '代上1:47 哈達死了，瑪士利加人桑拉接續他作王。',
    '代上1:48 桑拉死了，大河邊的利河伯人掃羅接續他作王。',
    '代上1:49 掃羅死了，亞革波的兒子巴勒哈南接續他作王。',
    '代上1:50 巴勒哈南死了，哈達接續他作王。他的京城名叫巴伊，他的妻子名叫米希他別，是米薩合的孫女，瑪特列的女兒。',
    '代上1:51 哈達死了，以東人的族長有亭納族長、亞勒瓦族長、耶帖族長、',
    '代上1:52 亞何利巴瑪族長、以拉族長、比嫩族長、',
    '代上1:53 基納斯族長、提幔族長、米比薩族長、',
    '代上1:54 瑪基疊族長、以蘭族長。這都是以東人的族長。',
    '代上2:1 以色列的兒子是流便、西緬、利未、猶大、以薩迦、西布倫、',
    '代上2:2 但、約瑟、便雅憫、拿弗他利、迦得、亞設。',
    '代上2:3 猶大的兒子是珥、俄南、示拉，這三人是迦南人書亞女兒所生的。猶大的長子珥在耶和華眼中看為惡，耶和華就使他死了。',
    '代上2:4 猶大的兒婦他瑪給猶大生法勒斯和謝拉。猶大共有五個兒子。',
    '代上2:5 法勒斯的兒子是希斯崙、哈母勒。',
    '代上2:6 謝拉的兒子是心利、以探、希幔、甲各、大拉【即達大】，共五人。',
    '代上2:7 迦米的兒子是亞干，這亞干在當滅的物上犯了罪，連累了以色列人。',
    '代上2:8 以探的兒子是亞撒利雅。',
    '代上2:9 希斯崙所生的兒子是耶拉篾、蘭、基路拜。',
    '代上2:10 蘭生亞米拿達；亞米拿達生拿順。拿順作猶大人的首領。',
    '代上2:11 拿順生撒門；撒門生波阿斯；',
    '代上2:12 波阿斯生俄備得；俄備得生耶西；',
    '代上2:13 耶西生長子以利押，次子亞比拿達，三子示米亞【即沙瑪，見撒上十六章九節】，',
    '代上2:14 四子拿坦業，五子拉代，',
    '代上2:15 六子阿鮮，七子大衛。',
    '代上2:16 他們的姊妹是洗魯雅和亞比該。洗魯雅的兒子是亞比篩、約押、亞撒黑，共三人。',
    '代上2:17 亞比該生亞瑪撒；亞瑪撒的父親是以實瑪利人益帖。',
    '代上2:18 希斯崙的兒子迦勒娶阿蘇巴和耶略為妻，阿蘇巴的兒子是耶設、朔罷、押墩。',
    '代上2:19 阿蘇巴死了，迦勒又娶以法他，生了戶珥。',
    '代上2:20 戶珥生烏利；烏利生比撒列。',
    '代上2:21 希斯崙正六十歲娶了基列父親瑪吉的女兒，與他同房；瑪吉的女兒生了西割；',
    '代上2:22 西割生睚珥。睚珥在基列地有二十三個城邑。',
    '代上2:23 後來基述人和亞蘭人奪了睚珥的城邑，並基納和其鄉村，共六十個。這都是基列父親瑪吉之子的。',
    '代上2:24 希斯崙在迦勒以法他死後，他的妻亞比雅給他生了亞施戶；亞施戶是提哥亞的父親。',
    '代上2:25 希斯崙的長子耶拉篾生長子蘭，又生布拿、阿連、阿鮮、亞希雅。',
    '代上2:26 耶拉篾又娶一妻名叫亞他拉，是阿南的母親。',
    '代上2:27 耶拉篾長子蘭的兒子是瑪斯、雅憫、以結。',
    '代上2:28 阿南的兒子是沙買、雅大。沙買的兒子是拿答、亞比述。',
    '代上2:29 亞比述的妻名叫亞比孩，亞比孩給他生了亞辦和摩利。',
    '代上2:30 拿答的兒子是西列、亞遍；西列死了沒有兒子。',
    '代上2:31 亞遍的兒子是以示；以示的兒子是示珊；示珊的兒子是亞來。',
    '代上2:32 沙買兄弟雅大的兒子是益帖、約拿單；益帖死了沒有兒子。',
    '代上2:33 約拿單的兒子是比勒、撒薩。這都是耶拉篾的子孫。',
    '代上2:34 示珊沒有兒子，只有女兒。示珊有一個僕人名叫耶哈，是埃及人。',
    '代上2:35 示珊將女兒給了僕人耶哈為妻，給他生了亞太。',
    '代上2:36 亞太生拿單；拿單生撒拔；',
    '代上2:37 撒拔生以弗拉；以弗拉生俄備得；',
    '代上2:38 俄備得生耶戶；耶戶生亞撒利雅；',
    '代上2:39 亞撒利雅生希利斯；希利斯生以利亞薩；',
    '代上2:40 以利亞薩生西斯買；西斯買生沙龍；',
    '代上2:41 沙龍生耶加米雅；耶加米雅生以利沙瑪。',
    '代上2:42 耶拉篾兄弟迦勒的長子米沙，是西弗之祖瑪利沙的兒子，是希伯崙之祖。',
    '代上2:43 希伯崙的兒子是可拉、他普亞、利肯、示瑪。',
    '代上2:44 示瑪生拉含，是約干之祖。利肯生沙買。',
    '代上2:45 沙買的兒子是瑪雲；瑪雲是伯夙之祖。',
    '代上2:46 迦勒的妾以法生哈蘭、摩撒、迦謝；哈蘭生迦卸。',
    '代上2:47 （雅代的兒子是利健、約坦、基珊、毘力、以法、沙亞弗。）',
    '代上2:48 迦勒的妾瑪迦生示別、特哈拿，',
    '代上2:49 又生麥瑪拿之祖沙亞弗、抹比拿和基比亞之祖示法。迦勒的女兒是押撒。',
    '代上2:50 迦勒的子孫就是以法他的長子、戶珥的兒子，記在下面：基列耶琳之祖朔巴，',
    '代上2:51 伯利恆之祖薩瑪，伯迦得之祖哈勒。',
    '代上2:52 基列耶琳之祖朔巴的子孫是哈羅以和一半米努哈人【即瑪拿哈人】。',
    '代上2:53 基列耶琳的諸族是以帖人、布特人、舒瑪人、密來人，又從這些族中生出瑣拉人和以實陶人來。',
    '代上2:54 薩瑪的子孫是伯利恆人、尼陀法人、亞他綠伯約押人、一半瑪拿哈人、瑣利人，',
    '代上2:55 和住雅比斯眾文士家的特拉人、示米押人、蘇甲人。這都是基尼人利甲家之祖哈末所生的。',
    '代上3:1 大衛在希伯崙所生的兒子記在下面：長子暗嫩是耶斯列人亞希暖生的。次子但以利是迦密人亞比該生的。',
    '代上3:2 三子押沙龍是基述王達買的女兒瑪迦生的。四子亞多尼雅是哈及生的。',
    '代上3:3 五子示法提雅是亞比他生的。六子以特念是大衛的妻以格拉生的。',
    '代上3:4 這六人都是大衛在希伯崙生的。大衛在希伯崙作王七年零六個月，在耶路撒冷作王三十三年。',
    '代上3:5 大衛在耶路撒冷所生的兒子是示米亞、朔罷、拿單、所羅門。這四人是亞米利的女兒拔書亞生的。',
    '代上3:6 還有益轄、以利沙瑪、以利法列、',
    '代上3:7 挪迦、尼斐、雅非亞、',
    '代上3:8 以利沙瑪、以利雅大、以利法列，共九人。',
    '代上3:9 這都是大衛的兒子，還有他們的妹子他瑪，妃嬪的兒子不在其內。',
    '代上3:10 所羅門的兒子是羅波安；羅波安的兒子是亞比雅；亞比雅的兒子是亞撒；亞撒的兒子是約沙法；',
    '代上3:11 約沙法的兒子是約蘭；約蘭的兒子是亞哈謝；亞哈謝的兒子是約阿施；',
    '代上3:12 約阿施的兒子是亞瑪謝；亞瑪謝的兒子是亞撒利雅；亞撒利雅的兒子是約坦；',
    '代上3:13 約坦的兒子是亞哈斯；亞哈斯的兒子是希西家；希西家的兒子是瑪拿西；',
    '代上3:14 瑪拿西的兒子是亞們；亞們的兒子是約西亞；',
    '代上3:15 約西亞的長子是約哈難，次子是約雅敬，三子是西底家，四子是沙龍。',
    '代上3:16 約雅敬的兒子是耶哥尼雅和西底家。',
    '代上3:17 耶哥尼雅被擄。他的兒子是撒拉鐵、',
    '代上3:18 瑪基蘭、毘大雅、示拿薩、耶加米、何沙瑪、尼大比雅。',
    '代上3:19 毘大雅的兒子是所羅巴伯、示每。所羅巴伯的兒子是米書蘭、哈拿尼雅，他們的妹子名叫示羅密。',
    '代上3:20 米書蘭的兒子是哈舒巴、阿黑、比利家、哈撒底、于沙希悉，共五人。',
    '代上3:21 哈拿尼雅的兒子是毘拉提、耶篩亞。還有利法雅的眾子，亞珥難的眾子，俄巴底亞的眾子，示迦尼的眾子。',
    '代上3:22 示迦尼的兒子是示瑪雅；示瑪雅的兒子是哈突、以甲、巴利亞、尼利雅、沙法，共六人。',
    '代上3:23 尼利雅的兒子是以利約乃、希西家、亞斯利干，共三人。',
    '代上3:24 以利約乃的兒子是何大雅、以利亞實、毘萊雅、阿谷、約哈難、第萊雅、阿拿尼，共七人。',
    '代上4:1 猶大的兒子是法勒斯、希斯崙、迦米、戶珥、朔巴。',
    '代上4:2 朔巴的兒子利亞雅生雅哈；雅哈生亞戶買和拉哈。這是瑣拉人的諸族。',
    '代上4:3 以坦之祖的兒子是耶斯列、伊施瑪、伊得巴；他們的妹子名叫哈悉勒玻尼。',
    '代上4:4 基多之祖是毘努伊勒。戶沙之祖是以謝珥。這都是伯利恆之祖以法他的長子戶珥所生的。',
    '代上4:5 提哥亞之祖亞施戶有兩個妻子：一名希拉，一名拿拉。',
    '代上4:6 拿拉給亞施戶生亞戶撒、希弗、提米尼、哈轄斯他利。這都是拿拉的兒子。',
    '代上4:7 希拉的兒子是洗列、瑣轄、伊提南。',
    '代上4:8 哥斯生亞諾、瑣比巴，並哈崙兒子亞哈黑的諸族。',
    '代上4:9 雅比斯比他眾弟兄更尊貴，他母親給他起名叫雅比斯，意思說：我生他甚是痛苦。',
    '代上4:10 雅比斯求告以色列的神說：甚願你賜福與我，擴張我的境界，常與我同在，保佑我不遭患難，不受艱苦。神就應允他所求的。',
    '代上4:11 書哈的弟兄基綠生米黑，米黑是伊施屯之祖。',
    '代上4:12 伊施屯生伯拉巴、巴西亞，並珥拿轄之祖提欣拿，這都是利迦人。',
    '代上4:13 基納斯的兒子是俄陀聶、西萊雅。俄陀聶的兒子是哈塔。',
    '代上4:14 憫挪太生俄弗拉；西萊雅生革夏納欣人之祖約押。他們都是匠人。',
    '代上4:15 耶孚尼的兒子是迦勒；迦勒的兒子是以路、以拉、拿安。以拉的兒子是基納斯。',
    '代上4:16 耶哈利勒的兒子是西弗、西法、提利、亞撒列。',
    '代上4:17 以斯拉的兒子是益帖、米列、以弗、雅倫。米列娶法老女兒比提雅為妻，生米利暗、沙買，和以實提摩之祖益巴。米列又娶猶大女子為妻，生基多之祖雅列，梭哥之祖希伯，和撒挪亞之祖耶古鐵。',
    '代上4:18 併於上節。',
    '代上4:19 荷第雅的妻是拿含的妹子，他所生的兒子是迦米人基伊拉和瑪迦人以實提摩之祖。',
    '代上4:20 示門的兒子是暗嫩、林拿、便哈南、提倫。以示的兒子是梭黑與便梭黑。',
    '代上4:21 猶大的兒子是示拉；示拉的兒子是利迦之祖珥，瑪利沙之祖拉大，和屬亞實比族織細麻布的各家。',
    '代上4:22 還有約敬、哥西巴人、約阿施、薩拉，就是在摩押地掌權的，又有雅叔比利恆。這都是古時所記載的。',
    '代上4:23 這些人都是窰匠，是尼他應和基低拉的居民；與王同處，為王做工。',
    '代上4:24 西緬的兒子是尼母利、雅憫、雅立、謝拉、掃羅。',
    '代上4:25 掃羅的兒子是沙龍；沙龍的兒子是米比衫；米比衫的兒子是米施瑪；',
    '代上4:26 米施瑪的兒子是哈母利；哈母利的兒子是撒刻；撒刻的兒子是示每。',
    '代上4:27 示每有十六個兒子，六個女兒，他弟兄的兒女不多，他們各家不如猶大族的人丁增多。',
    '代上4:28 西緬人住在別是巴、摩拉大、哈薩書亞、',
    '代上4:29 辟拉、以森、陀臘、',
    '代上4:30 彼土利、何珥瑪、洗革拉、',
    '代上4:31 伯瑪嘉博、哈薩蘇撒、伯比利、沙拉音，這些城邑直到大衛作王的時候都是屬西緬人的。',
    '代上4:32 他們的五個城邑是以坦、亞因、臨門、陀健、亞珊；',
    '代上4:33 還有屬城的鄉村，直到巴力。這是他們的住處，他們都有家譜。',
    '代上4:34 還有米所巴、雅米勒、亞瑪謝的兒子約沙、',
    '代上4:35 約珥、約示比的兒子耶戶；約示比是西萊雅的兒子；西萊雅是亞薛的兒子。',
    '代上4:36 還有以利約乃、雅哥巴、約朔海、亞帥雅、亞底業、耶西篾、比拿雅、',
    '代上4:37 示非的兒子細撒。示非是亞龍的兒子；亞龍是耶大雅的兒子；耶大雅是申利的兒子；申利是示瑪雅的兒子。',
    '代上4:38 以上所記的人名都是作族長的，他們宗族的人數增多。',
    '代上4:39 他們往平原東邊基多口去，尋找牧放羊群的草場，',
    '代上4:40 尋得肥美的草場地，又寬闊又平靜。從前住那裡的是含族的人。',
    '代上4:41 以上錄名的人，在猶大王希西家年間，來攻擊含族人的帳棚和那裡所有的米烏尼人，將他們滅盡，就住在他們的地方，直到今日，因為那裡有草場可以牧放羊群。',
    '代上4:42 這西緬人中，有五百人上西珥山，率領他們的是以示的兒子毘拉提、尼利雅、利法雅，和烏薛，',
    '代上4:43 殺了逃脫剩下的亞瑪力人，就住在那裡直到今日。',
    '代上5:1 以色列的長子原是流便；因他污穢了父親的床，他長子的名分就歸了約瑟。只是按家譜他不算長子。',
    '代上5:2 猶大勝過一切弟兄，君王也是從他而出；長子的名分卻歸約瑟。',
    '代上5:3 以色列長子流便的兒子是哈諾、法路、希斯倫、迦米。',
    '代上5:4 約珥的兒子是示瑪雅；示瑪雅的兒子是歌革；歌革的兒子是示每；',
    '代上5:5 示每的兒子是米迦；米迦的兒子是利亞雅；利亞雅的兒子是巴力；',
    '代上5:6 巴力的兒子是備拉。這備拉作流便支派的首領，被亞述王提革拉毘尼色擄去。',
    '代上5:7 他的弟兄照著宗族，按著家譜作族長的是耶利、撒迦利雅、比拉。',
    '代上5:8 比拉是亞撒的兒子；亞撒是示瑪的兒子；示瑪是約珥的兒子；約珥所住的地方是從亞羅珥直到尼波和巴力免，',
    '代上5:9 又向東延到伯拉河這邊的曠野，因為他們在基列地牲畜增多。',
    '代上5:10 掃羅年間，他們與夏甲人爭戰，夏甲人倒在他們手下，他們就在基列東邊的全地，住在夏甲人的帳棚裡。',
    '代上5:11 迦得的子孫在流便對面，住在巴珊地，延到撒迦。',
    '代上5:12 他們中間有作族長的約珥，有作副族長的沙番，還有雅乃和住在巴珊的沙法。',
    '代上5:13 他們族弟兄是米迦勒、米書蘭、示巴、約賴、雅干、細亞、希伯，共七人。',
    '代上5:14 這都是亞比孩的兒子。亞比孩是戶利的兒子；戶利是耶羅亞的兒子；耶羅亞是基列的兒子；基列是米迦勒的兒子；米迦勒是耶示篩的兒子；耶示篩是耶哈多的兒子；耶哈多是布斯的兒子。',
    '代上5:15 還有古尼的孫子、押比疊的兒子亞希。這都是作族長的。',
    '代上5:16 他們住在基列與巴珊和巴珊的鄉村，並沙崙的郊野，直到四圍的交界。',
    '代上5:17 這些人在猶大王約坦並在以色列王耶羅波安年間，都載入家譜。',
    '代上5:18 流便人、迦得人，和瑪拿西半支派的人，能拿盾牌和刀劍、拉弓射箭、出征善戰的勇士共有四萬四千七百六十名。',
    '代上5:19 他們與夏甲人、伊突人、拿非施人、挪答人爭戰。',
    '代上5:20 他們得了神的幫助，夏甲人和跟隨夏甲的人都交在他們手中；因為他們在陣上呼求神，倚賴神，神就應允他們。',
    '代上5:21 他們擄掠了夏甲人的牲畜，有駱駝五萬，羊二十五萬，驢二千；又有人十萬。',
    '代上5:22 敵人被殺仆倒的甚多，因為這爭戰是出乎神。他們就住在敵人的地上，直到被擄的時候。',
    '代上5:23 瑪拿西半支派的人住在那地。從巴珊延到巴力黑們、示尼珥與黑門山。',
    '代上5:24 他們的族長是以弗、以示、以列、亞斯列、耶利米、何達威雅、雅疊，都是大能的勇士，是有名的人，也是作族長的。',
    '代上5:25 他們得罪了他們列祖的神，隨從那地之民的神行邪淫；這民就是神在他們面前所除滅的。',
    '代上5:26 故此，以色列的神激動亞述王普勒和亞述王提革拉毘尼色的心，他們就把流便人、迦得人、瑪拿西半支派的人擄到哈臘、哈博、哈拉與歌散河邊，直到今日還在那裡。',
    '代上6:1 利未的兒子是革順、哥轄、米拉利。',
    '代上6:2 哥轄的兒子是暗蘭、以斯哈、希伯倫、烏薛。',
    '代上6:3 暗蘭的兒子是亞倫、摩西，還有女兒米利暗。亞倫的兒子是拿答、亞比戶、以利亞撒、以他瑪。',
    '代上6:4 以利亞撒生非尼哈；非尼哈生亞比書；',
    '代上6:5 亞比書生布基；布基生烏西；',
    '代上6:6 烏西生西拉希雅；西拉希雅生米拉約；',
    '代上6:7 米拉約生亞瑪利雅；亞瑪利雅生亞希突；',
    '代上6:8 亞希突生撒督；撒督生亞希瑪斯；',
    '代上6:9 亞希瑪斯生亞撒利雅；亞撒利雅生約哈難；',
    '代上6:10 約哈難生亞撒利雅（這亞撒利雅在所羅門於耶路撒冷所建造的殿中，供祭司的職分）；',
    '代上6:11 亞撒利雅生亞瑪利雅；亞瑪利雅生亞希突；',
    '代上6:12 亞希突生撒督；撒督生沙龍；',
    '代上6:13 沙龍生希勒家；希勒家生亞撒利雅；',
    '代上6:14 亞撒利雅生西萊雅；西萊雅生約薩答。',
    '代上6:15 當耶和華藉尼布甲尼撒的手擄掠猶大和耶路撒冷人的時候，這約薩答也被擄去。',
    '代上6:16 利未的兒子是革順、哥轄、米拉利。',
    '代上6:17 革順的兒子名叫立尼、示每。',
    '代上6:18 哥轄的兒子是暗蘭、以斯哈、希伯倫、烏薛。',
    '代上6:19 米拉利的兒子是抹利、母示。這是按著利未人宗族分的各家。',
    '代上6:20 革順的兒子是立尼；立尼的兒子是雅哈；雅哈的兒子是薪瑪；',
    '代上6:21 薪瑪的兒子是約亞；約亞的兒子是易多；易多的兒子是謝拉；謝拉的兒子是耶特賴。',
    '代上6:22 哥轄的兒子是亞米拿達；亞米拿達的兒子是可拉；可拉的兒子是亞惜；',
    '代上6:23 亞惜的兒子是以利加拿；以利加拿的兒子是以比雅撒；以比雅撒的兒子是亞惜；',
    '代上6:24 亞惜的兒子是他哈；他哈的兒子是烏列；烏列的兒子是烏西雅；烏西雅的兒子是少羅。',
    '代上6:25 以利加拿的兒子是亞瑪賽和亞希摩。',
    '代上6:26 亞希摩的兒子是以利加拿；以利加拿的兒子是瑣菲；瑣菲的兒子是拿哈；',
    '代上6:27 拿哈的兒子是以利押；以利押的兒子是耶羅罕；耶羅罕的兒子是以利加拿；以利加拿的兒子是撒母耳。',
    '代上6:28 撒母耳的長子是約珥，次子是亞比亞。',
    '代上6:29 米拉利的兒子是抹利；抹利的兒子是立尼；立尼的兒子是示每；示每的兒子是烏撒；',
    '代上6:30 烏撒的兒子是示米亞；示米亞的兒子是哈基雅；哈基雅的兒子是亞帥雅。',
    '代上6:31 約櫃安設之後，大衛派人在耶和華殿中管理歌唱的事。',
    '代上6:32 他們就在會幕前當歌唱的差，及至所羅門在耶路撒冷建造了耶和華的殿，他們便按著班次供職。',
    '代上6:33 供職的人和他們的子孫記在下面：哥轄的子孫中有歌唱的希幔。希幔是約珥的兒子；約珥是撒母耳的兒子；',
    '代上6:34 撒母耳是以利加拿的兒子；以利加拿是耶羅罕的兒子；耶羅罕是以列的兒子；以列是陀亞的兒子；',
    '代上6:35 陀亞是蘇弗的兒子；蘇弗是以利加拿的兒子；以利加拿是瑪哈的兒子；瑪哈是亞瑪賽的兒子；',
    '代上6:36 亞瑪賽是以利加拿的兒子；以利加拿是約珥的兒子；約珥是亞撒利雅的兒子；亞撒利雅是西番雅的兒子；',
    '代上6:37 西番雅是他哈的兒子；他哈是亞惜的兒子；亞惜是以比雅撒的兒子；以比雅撒是可拉的兒子；',
    '代上6:38 可拉是以斯哈的兒子；以斯哈是哥轄的兒子；哥轄是利未的兒子；利未是以色列的兒子。',
    '代上6:39 希幔的族兄亞薩是比利家的兒子，亞薩在希幔右邊供職。比利家是示米亞的兒子；',
    '代上6:40 示米亞是米迦勒的兒子；米迦勒是巴西雅的兒子；巴西雅是瑪基雅的兒子；',
    '代上6:41 瑪基雅是伊特尼的兒子；伊特尼是謝拉的兒子；謝拉是亞大雅的兒子；',
    '代上6:42 亞大雅是以探的兒子；以探是薪瑪的兒子；薪瑪是示每的兒子；',
    '代上6:43 示每是雅哈的兒子；雅哈是革順的兒子。革順是利未的兒子。',
    '代上6:44 他們的族弟兄米拉利的子孫，在他們左邊供職的有以探。以探是基示的兒子；基示是亞伯底的兒子；亞伯底是瑪鹿的兒子；',
    '代上6:45 瑪鹿是哈沙比雅的兒子；哈沙比雅是亞瑪謝的兒子；亞瑪謝是希勒家的兒子；',
    '代上6:46 希勒家是暗西的兒子；暗西是巴尼的兒子；巴尼是沙麥的兒子；',
    '代上6:47 沙麥是末力的兒子；末力是母示的兒子；母示是米拉利的兒子；米拉利是利未的兒子。',
    '代上6:48 他們的族弟兄利未人也被派辦神殿中的一切事。',
    '代上6:49 亞倫和他的子孫在燔祭壇和香壇上獻祭燒香，又在至聖所辦理一切的事，為以色列人贖罪，是照神僕人摩西所吩咐的。',
    '代上6:50 亞倫的兒子是以利亞撒；以利亞撒的兒子是非尼哈；非尼哈的兒子是亞比書；',
    '代上6:51 亞比書的兒子是布基；布基的兒子是烏西；烏西的兒子是西拉希雅；',
    '代上6:52 西拉希雅的兒子是米拉約；米拉約的兒子是亞瑪利雅；亞瑪利雅的兒子是亞希突；',
    '代上6:53 亞希突的兒子是撒督；撒督的兒子是亞希瑪斯。',
    '代上6:54 他們的住處按著境內的營寨，記在下面：哥轄族亞倫的子孫先拈鬮得地，',
    '代上6:55 在猶大地中得了希伯崙和四圍的郊野；',
    '代上6:56 只是屬城的田地和村莊都為耶孚尼的兒子迦勒所得。',
    '代上6:57 亞倫的子孫得了逃城希伯崙，又得了立拿與其郊野，雅提珥、以實提莫與其郊野；',
    '代上6:58 希崙與其郊野，底璧與其郊野，',
    '代上6:59 亞珊與其郊野，伯示麥與其郊野。',
    '代上6:60 在便雅憫支派的地中，得了迦巴與其郊野，阿勒篾與其郊野，亞拿突與其郊野。他們諸家所得的城共十三座。',
    '代上6:61 哥轄族其餘的人又拈鬮，在瑪拿西半支派的地中得了十座城。',
    '代上6:62 革順族按著宗族，在以薩迦支派的地中，亞設支派的地中，拿弗他利支派的地中，巴珊內瑪拿西支派的地中，得了十三座城。',
    '代上6:63 米拉利族按著宗族拈鬮，在流便支派的地中，迦得支派的地中，西布倫支派的地中，得了十二座城。',
    '代上6:64 以色列人將這些城與其郊野給了利未人。',
    '代上6:65 這以上錄名的城，在猶大、西緬、便雅憫三支派的地中，以色列人拈鬮給了他們。',
    '代上6:66 哥轄族中有幾家在以法蓮支派的地中也得了城邑，',
    '代上6:67 在以法蓮山地得了逃城示劍與其郊野，又得了基色與其郊野，',
    '代上6:68 約緬與其郊野，伯和崙與其郊野，',
    '代上6:69 亞雅崙與其郊野，迦特臨門與其郊野。',
    '代上6:70 哥轄族其餘的人在瑪拿西半支派的地中得了亞乃與其郊野，比連與其郊野。',
    '代上6:71 革順族在瑪拿西半支派的地中得了巴珊的哥蘭與其郊野，亞斯她錄與其郊野；',
    '代上6:72 又在以薩迦支派的地中得了基低斯與其郊野，大比拉與其郊野，',
    '代上6:73 拉末與其郊野，亞年與其郊野；',
    '代上6:74 在亞設支派的地中得了瑪沙與其郊野，押頓與其郊野，',
    '代上6:75 戶割與其郊野，利合與其郊野；',
    '代上6:76 在拿弗他利支派的地中得了加利利的基低斯與其郊野，哈們與其郊野，基列亭與其郊野。',
    '代上6:77 還有米拉利族的人在西布倫支派的地中得了臨摩挪與其郊野，他泊與其郊野；',
    '代上6:78 又在耶利哥的約但河東，在流便支派的地中得了曠野的比悉與其郊野，雅哈撒與其郊野，',
    '代上6:79 基底莫與其郊野，米法押與其郊野；',
    '代上6:80 又在迦得支派的地中得了基列的拉末與其郊野，瑪哈念與其郊野，',
    '代上6:81 希實本與其郊野，雅謝與其郊野。',
    '代上7:1 以薩迦的兒子是陀拉、普瓦、雅述【創四六13是約伯】、伸崙，共四人。',
    '代上7:2 陀拉的兒子是烏西、利法雅、耶勒、雅買、易伯散、示母利，都是陀拉的族長，是大能的勇士。到大衛年間，他們的人數共有二萬二千六百名。',
    '代上7:3 烏西的兒子是伊斯拉希；伊斯拉希的兒子是米迦勒、俄巴底亞、約珥、伊示雅，共五人，都是族長。',
    '代上7:4 他們所率領的，按著宗族出戰的軍隊，共有三萬六千人，因為他們的妻和子眾多。',
    '代上7:5 他們的族弟兄在以薩迦各族中都是大能的勇士，按著家譜計算共有八萬七千人。',
    '代上7:6 便雅憫的兒子是比拉、比結、耶疊，共三人。',
    '代上7:7 比拉的兒子是以斯本、烏西、烏薛、耶利摩、以利，共五人，都是族長，是大能的勇士。按著家譜計算，他們的子孫共有二萬二千零三十四人。',
    '代上7:8 比結的兒子是細米拉、約阿施、以利以謝、以利約乃、暗利、耶利摩、亞比雅、亞拿突、亞拉篾。這都是比結的兒子。',
    '代上7:9 他們都是族長，是大能的勇士。按著家譜計算，他們的子孫共有二萬零二百人。',
    '代上7:10 耶疊的兒子是比勒罕；比勒罕的兒子是耶烏施、便雅憫、以忽、基拿拿、細坦、他施、亞希沙哈。',
    '代上7:11 這都是耶疊的兒子，都是族長，是大能的勇士；他們的子孫能上陣打仗的，共有一萬七千二百人。',
    '代上7:12 還有以珥的兒子書品、戶品，並亞黑的兒子戶伸。',
    '代上7:13 拿弗他利的兒子是雅薛、沽尼、耶色、沙龍。這都是辟拉的子孫。',
    '代上7:14 瑪拿西的兒子亞斯列是他妾亞蘭人所生的，又生了基列之父瑪吉。',
    '代上7:15 瑪吉娶的妻是戶品、書品的妹子，名叫瑪迦。瑪拿西的次子名叫西羅非哈；西羅非哈但有幾個女兒。',
    '代上7:16 瑪吉的妻瑪迦生了一個兒子，起名叫毘利施。毘利施的兄弟名叫示利施；示利施的兒子是烏蘭和利金。',
    '代上7:17 烏蘭的兒子是比但。這都是基列的子孫。基列是瑪吉的兒子，瑪吉是瑪拿西的兒子。',
    '代上7:18 基列的妹子哈摩利吉生了伊施荷、亞比以謝、瑪拉。',
    '代上7:19 （示米大的兒子是亞現、示劍、利克希、阿尼安。）',
    '代上7:20 以法蓮的兒子是書提拉；書提拉的兒子是比列；比列的兒子是他哈；他哈的兒子是以拉大；以拉大的兒子是他哈；',
    '代上7:21 他哈的兒子是撒拔；撒拔的兒子是書提拉。以法蓮又生以謝、以列；這二人因為下去奪取迦特人的牲畜，被本地的迦特人殺了。',
    '代上7:22 他們的父親以法蓮為他們悲哀了多日，他的弟兄都來安慰他。',
    '代上7:23 以法蓮與妻同房，他妻就懷孕生了一子，以法蓮因為家裡遭禍，就給這兒子起名叫比利亞。',
    '代上7:24 他的女兒名叫舍伊拉，就是建築上伯和崙、下伯和崙與烏羨舍伊拉的。',
    '代上7:25 比利阿的兒子是利法和利悉。利悉的兒子是他拉；他拉的兒子是他罕；',
    '代上7:26 他罕的兒子是拉但；拉但的兒子是亞米忽；亞米忽的兒子是以利沙瑪；',
    '代上7:27 以利沙瑪的兒子是嫩；嫩的兒子是約書亞。',
    '代上7:28 以法蓮人的地業和住處是伯特利與其村莊；東邊拿蘭，西邊基色與其村莊；示劍與其村莊，直到迦薩與其村莊；',
    '代上7:29 還有靠近瑪拿西人的境界，伯善與其村莊；他納與其村莊；米吉多與其村莊；多珥與其村莊。以色列兒子約瑟的子孫住在這些地方。',
    '代上7:30 亞設的兒子是音拿、亦施瓦、亦施韋、比利亞，還有他們的妹子西拉。',
    '代上7:31 比利亞的兒子是希別、瑪結；瑪結是比撒威的父親。',
    '代上7:32 希別生雅弗勒、朔默、何坦，和他們的妹子書雅。',
    '代上7:33 雅弗勒的兒子是巴薩、賓哈、亞施法。這都是雅弗勒的兒子。',
    '代上7:34 朔默的兒子是亞希、羅迦、耶戶巴、亞蘭。',
    '代上7:35 朔默兄弟希連的兒子是瑣法、音那、示利斯、亞抹。',
    '代上7:36 瑣法的兒子是書亞、哈尼弗、書阿勒、比利、音拉、',
    '代上7:37 比悉、河得、珊瑪、施沙、益蘭、比拉。',
    '代上7:38 益帖的兒子是耶孚尼、毘斯巴、亞拉。',
    '代上7:39 烏拉的兒子是亞拉、漢尼業、利寫。',
    '代上7:40 這都是亞設的子孫，都是族長，是精壯大能的勇士，也是首領中的頭目，按著家譜計算，他們的子孫能出戰的共有二萬六千人。',
    '代上8:1 便雅憫的長子比拉，次子亞實別，三子亞哈拉，',
    '代上8:2 四子挪哈，五子拉法。',
    '代上8:3 比拉的兒子是亞大、基拉、亞比忽、',
    '代上8:4 亞比書、乃幔、亞何亞、',
    '代上8:5 基拉、示孚汛、戶蘭。',
    '代上8:6 以忽的兒子作迦巴居民的族長，被擄到瑪拿轄；',
    '代上8:7 以忽的兒子乃幔、亞希亞、基拉也被擄去。基拉生烏撒、亞希忽。',
    '代上8:8 沙哈連休他二妻戶伸和巴拉之後，在摩押地生了兒子。',
    '代上8:9 他與妻賀得同房，生了約巴、洗比雅、米沙、瑪拉干、',
    '代上8:10 耶烏斯、沙迦、米瑪。他這些兒子都是族長。',
    '代上8:11 他的妻戶伸給他生的兒子有亞比突、以利巴力。',
    '代上8:12 以利巴力的兒子是希伯、米珊、沙麥。沙麥建立阿挪和羅德二城與其村莊。',
    '代上8:13 又有比利亞和示瑪是亞雅崙居民的族長，是驅逐迦特人的。',
    '代上8:14 亞希約、沙煞、耶利末、',
    '代上8:15 西巴第雅、亞拉得、亞得、',
    '代上8:16 米迦勒、伊施巴、約哈都是比利亞的兒子。',
    '代上8:17 西巴第雅、米書蘭、希西基、希伯、',
    '代上8:18 伊施米萊、伊斯利亞、約巴都是以利巴力的兒子。',
    '代上8:19 雅金、細基利、撒底、',
    '代上8:20 以利乃、洗勒太、以列、',
    '代上8:21 亞大雅、比拉雅、申拉都是示每的兒子。',
    '代上8:22 伊施班、希伯、以列、',
    '代上8:23 亞伯頓、細基利、哈難、',
    '代上8:24 哈拿尼雅、以攔、安陀提雅、',
    '代上8:25 伊弗底雅、毘努伊勒都是沙煞的兒子。',
    '代上8:26 珊示萊、示哈利、亞他利雅、',
    '代上8:27 雅利西、以利亞、細基利都是耶羅罕的兒子。',
    '代上8:28 這些人都是著名的族長，住在耶路撒冷。',
    '代上8:29 在基遍住的有基遍的父親耶利。他的妻名叫瑪迦；',
    '代上8:30 他長子是亞伯頓。他又生蘇珥、基士、巴力、拿答、',
    '代上8:31 基多、亞希約、撒迦、米基羅。',
    '代上8:32 米基羅生示米暗。這些人和他們的弟兄在耶路撒冷對面居住。',
    '代上8:33 尼珥生基士；基士生掃羅；掃羅生約拿單、麥基舒亞、亞比拿達、伊施巴力。',
    '代上8:34 約拿單的兒子是米力巴力【撒下四章四節作米非波設】；米力巴力生米迦。',
    '代上8:35 米迦的兒子是毘敦、米勒、他利亞、亞哈斯；',
    '代上8:36 亞哈斯生耶何阿達；耶何阿達生亞拉篾、亞斯瑪威、心利；心利生摩撒；',
    '代上8:37 摩撒生比尼亞；比尼亞的兒子是拉法；拉法的兒子是以利亞薩；以利亞薩的兒子是亞悉。',
    '代上8:38 亞悉有六個兒子，他們的名字是亞斯利干、波基路、以實瑪利、示亞利雅、俄巴底雅、哈難。這都是亞悉的兒子。',
    '代上8:39 亞悉兄弟以設的長子是烏蘭，次子耶烏施，三子是以利法列。',
    '代上8:40 烏蘭的兒子都是大能的勇士，是弓箭手，他們有許多的子孫，共一百五十名，都是便雅憫人。',
    '代上9:1 以色列人都按家譜計算，寫在以色列諸王記上。猶大人因犯罪就被擄到巴比倫。',
    '代上9:2 先從巴比倫回來，住在自己地業城邑中的有以色列人、祭司、利未人、尼提寧的首領。',
    '代上9:3 住在耶路撒冷的有猶大人、便雅憫人、以法蓮人、瑪拿西人。',
    '代上9:4 猶大兒子法勒斯的子孫中有烏太。烏太是亞米忽的兒子；亞米忽是暗利的兒子；暗利是音利的兒子；音利是巴尼的兒子。',
    '代上9:5 示羅的子孫中有長子亞帥雅和他的眾子。',
    '代上9:6 謝拉的子孫中有耶烏利和他的弟兄，共六百九十人。',
    '代上9:7 便雅憫人中有哈西努的曾孫、何達威雅的孫子、米書蘭的兒子撒路，',
    '代上9:8 又有耶羅罕的兒子伊比尼雅，米基立的孫子、烏西的兒子以拉，伊比尼雅的曾孫、流珥的孫子、示法提雅的兒子米書蘭，',
    '代上9:9 和他們的族弟兄，按著家譜計算共有九百五十六名。這些人都是他們的族長。',
    '代上9:10 祭司中有耶大雅、耶何雅立、雅斤，',
    '代上9:11 還有管理神殿希勒家的兒子亞薩利雅。希勒家是米書蘭的兒子；米書蘭是撒督的兒子；撒督是米拉約的兒子；米拉約是亞希突的兒子。',
    '代上9:12 有瑪基雅的曾孫、巴施戶珥的孫子、耶羅罕的兒子亞大雅，又有亞第業的兒子瑪賽；亞第業是雅希細拉的兒子；雅希細拉是米書蘭的兒子；米書蘭是米實利密的兒子；米實利密是音麥的兒子。',
    '代上9:13 他們和眾弟兄都是族長，共有一千七百六十人，是善於做神殿使用之工的。',
    '代上9:14 利未人米拉利的子孫中，有哈沙比雅的曾孫、押利甘的孫子、哈述的兒子示瑪雅。',
    '代上9:15 有拔巴甲、黑勒施、迦拉，並亞薩的曾孫、細基利的孫子、米迦的兒子瑪探雅，',
    '代上9:16 又有耶杜頓的曾孫、迦拉的孫子、示瑪雅的兒子俄巴底，還有以利加拿的孫子、亞撒的兒子比利家。他們都住在尼陀法人的村莊。',
    '代上9:17 守門的是沙龍、亞谷、達們、亞希幔，和他們的弟兄；沙龍為長。',
    '代上9:18 從前這些人看守朝東的王門，如今是利未營中守門的。',
    '代上9:19 可拉的曾孫、以比雅撒的孫子、可利的兒子沙龍，和他的族弟兄可拉人都管理使用之工，並守會幕的門。他們的祖宗曾管理耶和華的營盤，又把守營門。',
    '代上9:20 從前以利亞撒的兒子非尼哈管理他們，耶和華也與他同在。',
    '代上9:21 米施利米雅的兒子撒迦利雅是看守會幕之門的。',
    '代上9:22 被選守門的人共有二百一十二名。他們在自己的村莊，按著家譜計算，是大衛和先見撒母耳所派當這緊要職任的。',
    '代上9:23 他們和他們的子孫按著班次看守耶和華殿的門，就是會幕的門。',
    '代上9:24 在東西南北，四方都有守門的。',
    '代上9:25 他們的族弟兄住在村莊，每七日來與他們換班。',
    '代上9:26 這四個門領都是利未人，各有緊要的職任，看守神殿的倉庫。',
    '代上9:27 他們住在神殿的四圍，是因委託他們守殿，要每日早晨開門。',
    '代上9:28 利未人中有管理使用器皿的，按著數目拿出拿入；',
    '代上9:29 又有人管理器具和聖所的器皿，並細麵、酒、油、乳香、香料。',
    '代上9:30 祭司中有人用香料做膏油。',
    '代上9:31 利未人瑪他提雅是可拉族沙龍的長子，他緊要的職任是管理盤中烤的物。',
    '代上9:32 他們族弟兄哥轄子孫中，有管理陳設餅的，每安息日預備擺列。',
    '代上9:33 歌唱的有利未人的族長，住在屬殿的房屋，晝夜供職，不做別樣的工。',
    '代上9:34 以上都是利未人著名的族長，住在耶路撒冷。',
    '代上9:35 在基遍住的有基遍的父親耶利。他的妻名叫瑪迦；',
    '代上9:36 他長子是亞伯頓。他又生蘇珥、基士、巴力、尼珥、拿答、',
    '代上9:37 基多、亞希約、撒迦利雅、米基羅。',
    '代上9:38 米基羅生示米暗。這些人和他們的弟兄在耶路撒冷對面居住。',
    '代上9:39 尼珥生基士；基士生掃羅；掃羅生約拿單、麥基舒亞、亞比拿達、伊施巴力。',
    '代上9:40 約拿單的兒子是米力巴力【即米非波設】；米力巴力生米迦。',
    '代上9:41 米迦的兒子是毘敦、米勒、他利亞、亞哈斯。',
    '代上9:42 亞哈斯生雅拉；雅拉生亞拉篾、亞斯瑪威、心利；心利生摩撒；',
    '代上9:43 摩撒生比尼亞；比尼亞生利法雅；利法雅的兒子是以利亞薩；以利亞薩的兒子是亞悉。',
    '代上9:44 亞悉有六個兒子，他們的名字是亞斯利干、波基路、以實瑪利、示亞利雅、俄巴底雅、哈難。這都是亞悉的兒子。',
    '代上10:1 非利士人與以色列人爭戰，以色列人在非利士人面前逃跑，在基利波山有被殺仆倒的。',
    '代上10:2 非利士人緊追掃羅和他兒子們，就殺了掃羅的兒子約拿單、亞比拿達、麥基舒亞。',
    '代上10:3 勢派甚大，掃羅被弓箭手追上，射傷甚重，',
    '代上10:4 就吩咐拿他兵器的人說：你拔出刀來，將我刺死，免得那些未受割禮的人來凌辱我。但拿兵器的人甚懼怕，不肯刺他；',
    '代上10:5 掃羅就自己伏在刀上死了。拿兵器的人見掃羅已死，也伏在刀上死了。',
    '代上10:6 這樣，掃羅和他三個兒子，並他的全家都一同死亡。',
    '代上10:7 住平原的以色列眾人見以色列軍兵逃跑，掃羅和他兒子都死了，也就棄城逃跑，非利士人便來住在其中。',
    '代上10:8 次日，非利士人來剝那被殺之人的衣服，看見掃羅和他兒子仆倒在基利波山，',
    '代上10:9 就剝了他的軍裝，割下他的首級，打發人到【或作送到】非利士地的四境報信與他們的偶像和眾民，',
    '代上10:10 又將掃羅的軍裝放在他們神的廟裡，將他的首級釘在大袞廟中。',
    '代上10:11 基列雅比人聽見非利士人向掃羅所行的一切事，',
    '代上10:12 他們中間所有的勇士就起身前去，將掃羅和他兒子的屍身送到雅比，將他們的屍骨葬在雅比的橡樹下，就禁食七日。',
    '代上10:13 這樣，掃羅死了。因為他干犯耶和華，沒有遵守耶和華的命；又因他求問交鬼的婦人，',
    '代上10:14 沒有求問耶和華，所以耶和華使他被殺，把國歸於耶西的兒子大衛。',
    '代上11:1 以色列眾人聚集到希伯崙見大衛，說：我們原是你的骨肉。',
    '代上11:2 從前掃羅作王的時候，率領以色列人出入的是你；耶和華─你的神也曾應許你說：你必牧養我的民以色列，作以色列的君。',
    '代上11:3 於是以色列的長老都來到希伯崙見大衛王。大衛在希伯崙耶和華面前與他們立約，他們就膏大衛作以色列的王，是照耶和華藉撒母耳所說的話。',
    '代上11:4 大衛和以色列眾人到了耶路撒冷，就是耶布斯；那時耶布斯人住在那裡。',
    '代上11:5 耶布斯人對大衛說：你決不能進這地方。然而大衛攻取錫安的保障，就是大衛的城。',
    '代上11:6 大衛說：誰先攻打耶布斯人，必作首領元帥。洗魯雅的兒子約押先上去，就作了元帥。',
    '代上11:7 大衛住在保障裡，所以那保障叫做大衛城。',
    '代上11:8 大衛又從米羅起，四圍建築城牆，其餘的是約押修理。',
    '代上11:9 大衛日見強盛，因為萬軍之耶和華與他同在。',
    '代上11:10 以下記錄跟隨大衛勇士的首領，就是奮勇幫助他得國、照著耶和華吩咐以色列人的話、與以色列人一同立他作王的。',
    '代上11:11 大衛勇士的數目記在下面：哈革摩尼的兒子雅朔班，他是軍長的統領，一時舉槍殺了三百人。',
    '代上11:12 其次是亞合人朵多的兒子以利亞撒，他是三個勇士裡的一個。',
    '代上11:13 他從前與大衛在巴斯達閔，非利士人聚集要打仗。那裡有一塊長滿大麥的田，眾民就在非利士人面前逃跑；',
    '代上11:14 這勇士便站在那田間擊殺非利士人，救護了那田。耶和華使以色列人大獲全勝。',
    '代上11:15 三十個勇士中的三個人下到磐石那裡，進了亞杜蘭洞見大衛；非利士的軍隊在利乏音谷安營。',
    '代上11:16 那時大衛在山寨，非利士人的防營在伯利恆。',
    '代上11:17 大衛渴想，說：甚願有人將伯利恆城門旁井裡的水打來給我喝！',
    '代上11:18 這三個勇士就闖過非利士人的營盤，從伯利恆城門旁的井裡打水，拿來奉給大衛。他卻不肯喝，將水奠在耶和華面前，',
    '代上11:19 說：我的神啊，這三個人冒死去打水，這水好像他們的血一般，我斷不敢喝！如此，大衛不肯喝。這是三個勇士所做的事。',
    '代上11:20 約押的兄弟亞比篩是這三個勇士的首領；他舉槍殺了三百人，就在三個勇士裡得了名。',
    '代上11:21 他在這三個勇士裡是最尊貴的，所以作他們的首領；只是不及前三個勇士。',
    '代上11:22 有甲薛勇士耶何耶大的兒子比拿雅行過大能的事：他殺了摩押人亞利伊勒的兩個兒子，又在下雪的時候下坑裡去殺了一個獅子，',
    '代上11:23 又殺了一個埃及人。埃及人身高五肘，手裡拿著槍，槍桿粗如織布的機軸；比拿雅只拿著棍子下去，從埃及人手裡奪過槍來，用那槍將他刺死。',
    '代上11:24 這是耶何耶大的兒子比拿雅所行的事，就在三個勇士裡得了名。',
    '代上11:25 他比那三十個勇士都尊貴，只是不及前三個勇士。大衛立他作護衛長。',
    '代上11:26 軍中的勇士有約押的兄弟亞撒黑，伯利恆人朵多的兒子伊勒哈難，',
    '代上11:27 哈律人沙瑪，比倫人希利斯，',
    '代上11:28 提哥亞人益吉的兒子以拉，亞拿突人亞比以謝，',
    '代上11:29 戶沙人西比該，亞合人以來，',
    '代上11:30 尼陀法人瑪哈萊，尼陀法人巴拿的兒子希立，',
    '代上11:31 便雅憫族基比亞人利拜的兒子以太，比拉頓人比拿雅，',
    '代上11:32 迦實溪人戶萊，亞拉巴人亞比，',
    '代上11:33 巴路米人押斯瑪弗，沙本人以利雅哈巴，',
    '代上11:34 基孫人哈深的眾子，哈拉人沙基的兒子約拿單，',
    '代上11:35 哈拉人沙甲的兒子亞希暗，吾珥的兒子以利法勒，',
    '代上11:36 米基拉人希弗，比倫人亞希雅，',
    '代上11:37 迦密人希斯羅，伊斯拜的兒子拿萊，',
    '代上11:38 拿單的兄弟約珥，哈基利的兒子彌伯哈，',
    '代上11:39 亞捫人洗勒，比錄人拿哈萊（拿哈萊是給洗魯雅的兒子約押拿兵器的），',
    '代上11:40 以帖人以拉，以帖人迦立，',
    '代上11:41 赫人烏利亞，亞萊的兒子撒拔，',
    '代上11:42 流便人示撒的兒子亞第拿（他是流便支派中的一個族長，率領三十人），',
    '代上11:43 瑪迦的兒子哈難，彌特尼人約沙法，',
    '代上11:44 亞施他拉人烏西亞，亞羅珥人何坦的兒子沙瑪、耶利，',
    '代上11:45 提洗人申利的兒子耶疊和他的兄弟約哈，',
    '代上11:46 瑪哈未人以利業，伊利拿安的兒子耶利拜、約沙未雅，摩押人伊特瑪、',
    '代上11:47 以利業、俄備得，並米瑣八人雅西業。',
    '代上12:1 大衛因怕基士的兒子掃羅，躲在洗革拉的時候，有勇士到他那裡幫助他打仗。',
    '代上12:2 他們善於拉弓，能用左右兩手甩石射箭，都是便雅憫人掃羅的族弟兄。',
    '代上12:3 為首的是亞希以謝，其次是約阿施，都是基比亞人示瑪的兒子。還有亞斯瑪威的兒子耶薛和毘力，又有比拉迦，並亞拿突人耶戶，',
    '代上12:4 基遍人以實買雅（他在三十人中是勇士，管理他們），且有耶利米、雅哈悉、約哈難，和基得拉人約撒拔、',
    '代上12:5 伊利烏賽、耶利摩、比亞利雅、示瑪利雅，哈律弗人示法提雅，',
    '代上12:6 可拉人以利加拿、耶西亞、亞薩列、約以謝、雅朔班，',
    '代上12:7 基多人耶羅罕的兒子猶拉和西巴第雅。',
    '代上12:8 迦得支派中有人到曠野的山寨投奔大衛，都是大能的勇士，能拿盾牌和槍的戰士。他們的面貌好像獅子，快跑如同山上的鹿。',
    '代上12:9 第一以薛，第二俄巴底雅，第三以利押，',
    '代上12:10 第四彌施瑪拿，第五耶利米，',
    '代上12:11 第六亞太，第七以利業，',
    '代上12:12 第八約哈難，第九以利薩巴，',
    '代上12:13 第十耶利米，第十一末巴奈。',
    '代上12:14 這都是迦得人中的軍長，至小的能抵一百人，至大的能抵一千人。',
    '代上12:15 正月，約但河水漲過兩岸的時候，他們過河，使一切住平原的人東奔西逃。',
    '代上12:16 又有便雅憫和猶大人到山寨大衛那裡。',
    '代上12:17 大衛出去迎接他們，對他們說：你們若是和和平平地來幫助我，我心就與你們相契；你們若是將我這無罪的人賣在敵人手裡，願我們列祖的神察看責罰。',
    '代上12:18 那時神的靈感動那三十個勇士的首領亞瑪撒，他就說：大衛啊，我們是歸於你的！耶西的兒子啊，我們是幫助你的！願你平平安安，願幫助你的也都平安！因為你的神幫助你。大衛就收留他們，立他們作軍長。',
    '代上12:19 大衛從前與非利士人同去，要與掃羅爭戰，有些瑪拿西人來投奔大衛，他們卻沒有幫助非利士人；因為非利士人的首領商議，打發他們回去，說：恐怕大衛拿我們的首級，歸降他的主人掃羅。',
    '代上12:20 大衛往洗革拉去的時候，有瑪拿西人的千夫長押拿、約撒拔、耶疊、米迦勒、約撒拔、以利戶、洗勒太都來投奔他。',
    '代上12:21 這些人幫助大衛攻擊群賊；他們都是大能的勇士，且作軍長。',
    '代上12:22 那時天天有人來幫助大衛，以致成了大軍，如神的軍一樣。',
    '代上12:23 預備打仗的兵來到希伯崙見大衛，要照著耶和華的話將掃羅的國位歸與大衛。他們的數目如下：',
    '代上12:24 猶大支派，拿盾牌和槍預備打仗的有六千八百人。',
    '代上12:25 西緬支派，能上陣大能的勇士有七千一百人。',
    '代上12:26 利未支派有四千六百人。',
    '代上12:27 耶何耶大是亞倫家的首領，跟從他的有三千七百人。',
    '代上12:28 還有少年大能的勇士撒督，同著他的有族長二十二人。',
    '代上12:29 便雅憫支派，掃羅的族弟兄也有三千人，他們向來大半歸順掃羅家。',
    '代上12:30 以法蓮支派大能的勇士，在本族著名的有二萬零八百人。',
    '代上12:31 瑪拿西半支派，冊上有名的共一萬八千人，都來立大衛作王。',
    '代上12:32 以薩迦支派，有二百族長都通達時務，知道以色列人所當行的；他們族弟兄都聽從他們的命令。',
    '代上12:33 西布倫支派，能上陣用各樣兵器打仗、行伍整齊、不生二心的有五萬人。',
    '代上12:34 拿弗他利支派，有一千軍長；跟從他們、拿盾牌和槍的有三萬七千人。',
    '代上12:35 但支派，能擺陣的有二萬八千六百人。',
    '代上12:36 亞設支派，能上陣打仗的有四萬人。',
    '代上12:37 約但河東的流便支派、迦得支派、瑪拿西半支派，拿著各樣兵器打仗的有十二萬人。',
    '代上12:38 以上都是能守行伍的戰士，他們都誠心來到希伯崙，要立大衛作以色列的王。以色列其餘的人也都一心要立大衛作王。',
    '代上12:39 他們在那裡三日，與大衛一同吃喝，因為他們的族弟兄給他們預備了。',
    '代上12:40 靠近他們的人以及以薩迦、西布倫、拿弗他利人將許多麵餅、無花果餅、乾葡萄、酒、油，用驢、駱駝、騾子、牛馱來，又帶了許多的牛和羊來，因為以色列人甚是歡樂。',
    '代上13:1 大衛與千夫長、百夫長，就是一切首領商議。',
    '代上13:2 大衛對以色列全會眾說：你們若以為美，見這事是出於耶和華─我們的神，我們就差遣人走遍以色列地，見我們未來的弟兄，又見住在有郊野之城的祭司利未人，使他們都到這裡來聚集。',
    '代上13:3 我們要把神的約櫃運到我們這裡來；因為在掃羅年間，我們沒有在約櫃前求問神。',
    '代上13:4 全會眾都說可以如此行；這事在眾民眼中都看為好。',
    '代上13:5 於是，大衛將以色列人從埃及的西曷河直到哈馬口都招聚了來，要從基列耶琳將神的約櫃運來。',
    '代上13:6 大衛率領以色列眾人上到巴拉，就是屬猶大的基列耶琳，要從那裡將約櫃運來。這約櫃就是坐在二基路伯上耶和華神留名的約櫃。',
    '代上13:7 他們將神的約櫃從亞比拿達的家裡擡出來，放在新車上。烏撒和亞希約趕車。',
    '代上13:8 大衛和以色列眾人在神前用琴、瑟、鑼、鼓、號作樂，極力跳舞歌唱。',
    '代上13:9 到了基頓【撒下六章六節作拿艮】的禾場；因為牛失前蹄【或作驚跳】，烏撒就伸手扶住約櫃。',
    '代上13:10 耶和華向他發怒，因他伸手扶住約櫃擊殺他，他就死在神面前。',
    '代上13:11 大衛因耶和華擊殺【原文作闖殺】烏撒，心裡愁煩，就稱那地方為毘列斯烏撒，直到今日。',
    '代上13:12 那日，大衛懼怕神，說：神的約櫃怎可運到我這裡來﹖',
    '代上13:13 於是大衛不將約櫃運進大衛的城，卻運到迦特人俄別以東的家中。',
    '代上13:14 神的約櫃在俄別以東家中三個月，耶和華賜福給俄別以東的家和他一切所有的。',
    '代上14:1 推羅王希蘭將香柏木運到大衛那裡，又差遣使者和石匠、木匠給大衛建造宮殿。',
    '代上14:2 大衛就知道耶和華堅立他作以色列王，又為自己的民以色列，使他的國興旺。',
    '代上14:3 大衛在耶路撒冷又立后妃，又生兒女。',
    '代上14:4 在耶路撒冷所生的眾子是沙母亞、朔罷、拿單、所羅門、',
    '代上14:5 益轄、以利書亞、以法列、',
    '代上14:6 挪迦、尼斐、雅非亞、',
    '代上14:7 以利沙瑪、比利雅大、以利法列。',
    '代上14:8 非利士人聽見大衛受膏作以色列眾人的王，非利士眾人就上來尋索大衛。大衛聽見，就出去迎敵。',
    '代上14:9 非利士人來了，布散在利乏音谷。',
    '代上14:10 大衛求問神，說：我可以上去攻打非利士人嗎﹖你將他們交在我手裡嗎﹖耶和華說：你可以上去，我必將他們交在你手裡。',
    '代上14:11 非利士人來到巴力毘拉心，大衛在那裡殺敗他們。大衛說：神藉我的手沖破敵人，如同水沖去一般；因此稱那地方為巴力毘拉心。',
    '代上14:12 非利士人將神像撇在那裡，大衛吩咐人用火焚燒了。',
    '代上14:13 非利士人又布散在利乏音谷。',
    '代上14:14 大衛又求問神。神說：不要一直地上去，要轉到他們後頭，從桑林對面攻打他們。',
    '代上14:15 你聽見桑樹梢上有腳步的聲音，就要出戰，因為神已經在你前頭去攻打非利士人的軍隊。',
    '代上14:16 大衛就遵著神所吩咐的，攻打非利士人的軍隊，從基遍直到基色。',
    '代上14:17 於是大衛的名傳揚到列國，耶和華使列國都懼怕他。',
    '代上15:1 大衛在大衛城為自己建造宮殿，又為神的約櫃預備地方，支搭帳幕。',
    '代上15:2 那時大衛說：除了利未人之外，無人可擡神的約櫃；因為耶和華揀選他們擡神的約櫃，且永遠事奉他。',
    '代上15:3 大衛招聚以色列眾人到耶路撒冷，要將耶和華的約櫃擡到他所預備的地方。',
    '代上15:4 大衛又聚集亞倫的子孫和利未人。',
    '代上15:5 哥轄子孫中有族長烏列和他的弟兄一百二十人。',
    '代上15:6 米拉利子孫中有族長亞帥雅和他的弟兄二百二十人。',
    '代上15:7 革順子孫中有族長約珥和他的弟兄一百三十人。',
    '代上15:8 以利撒反子孫中有族長示瑪雅和他的弟兄二百人。',
    '代上15:9 希伯崙子孫中有族長以列和他的弟兄八十人。',
    '代上15:10 烏薛子孫中有族長亞米拿達和他的弟兄一百一十二人。',
    '代上15:11 大衛將祭司撒督和亞比亞他，並利未人烏列、亞帥雅、約珥、示瑪雅、以列、亞米拿達召來，',
    '代上15:12 對他們說：你們是利未人的族長，你們和你們的弟兄應當自潔，好將耶和華─以色列神的約櫃擡到我所預備的地方。',
    '代上15:13 因你們先前沒有擡這約櫃，按定例求問耶和華─我們的神，所以他刑罰【原文作闖殺】我們。',
    '代上15:14 於是祭司利未人自潔，好將耶和華─以色列神的約櫃擡上來。',
    '代上15:15 利未子孫就用槓，肩擡神的約櫃，是照耶和華藉摩西所吩咐的。',
    '代上15:16 大衛吩咐利未人的族長，派他們歌唱的弟兄用琴瑟和鈸作樂，歡歡喜喜地大聲歌頌。',
    '代上15:17 於是利未人派約珥的兒子希幔和他弟兄中比利家的兒子亞薩，並他們族弟兄米拉利子孫裡古沙雅的兒子以探。',
    '代上15:18 其次還有他們的弟兄撒迦利雅、便雅薛、示米拉末、耶歇、烏尼、以利押、比拿雅、瑪西雅、瑪他提雅、以利斐利戶、彌克尼雅，並守門的俄別以東和耶利。',
    '代上15:19 這樣，派歌唱的希幔、亞薩、以探敲銅鈸，大發響聲；',
    '代上15:20 派撒迦利雅、雅薛、示米拉末、耶歇、烏尼、以利押、瑪西雅、比拿雅鼓瑟，調用女音；',
    '代上15:21 又派瑪他提雅、以利斐利戶、彌克尼雅、俄別以東、耶利、亞撒西雅領首彈琴，調用第八。',
    '代上15:22 利未人的族長基拿尼雅是歌唱人的首領，又教訓人歌唱，因為他精通此事。',
    '代上15:23 比利家、以利加拿是約櫃前守門的。',
    '代上15:24 祭司示巴尼、約沙法、拿坦業、亞瑪賽、撒迦利雅、比拿亞、以利以謝在神的約櫃前吹號。俄別以東和耶希亞也是約櫃前守門的。',
    '代上15:25 於是，大衛和以色列的長老，並千夫長都去從俄別以東的家歡歡喜喜地將耶和華的約櫃擡上來。',
    '代上15:26 神賜恩與擡耶和華約櫃的利未人，他們就獻上七隻公牛，七隻公羊。',
    '代上15:27 大衛和擡約櫃的利未人，並歌唱人的首領基拿尼雅，以及歌唱的人，都穿著細麻布的外袍；大衛另外穿著細麻布的以弗得。',
    '代上15:28 這樣，以色列眾人歡呼吹角、吹號、敲鈸、鼓瑟、彈琴，大發響聲，將耶和華的約櫃擡上來。',
    '代上15:29 耶和華的約櫃進了大衛城的時候，掃羅的女兒米甲從窗戶裡觀看，見大衛王踴躍跳舞，心裡就輕視他。',
    '代上16:1 眾人將神的約櫃請進去，安放在大衛所搭的帳幕裡，就在神面前獻燔祭和平安祭。',
    '代上16:2 大衛獻完了燔祭和平安祭，就奉耶和華的名給民祝福，',
    '代上16:3 並且分給以色列人，無論男女，每人一個餅，一塊肉，一個葡萄餅。',
    '代上16:4 大衛派幾個利未人在耶和華的約櫃前事奉，頌揚，稱謝，讚美耶和華─以色列的神：',
    '代上16:5 為首的是亞薩，其次是撒迦利雅、雅薛、示米拉末、耶歇、瑪他提雅、以利押、比拿雅、俄別以東、耶利，鼓瑟彈琴；惟有亞薩敲鈸，大發響聲；',
    '代上16:6 祭司比拿雅和雅哈悉常在神的約櫃前吹號。',
    '代上16:7 那日，大衛初次藉亞薩和他的弟兄以詩歌稱頌耶和華，說：',
    '代上16:8 你們要稱謝耶和華，求告他的名，在萬民中傳揚他的作為！',
    '代上16:9 要向他唱詩、歌頌，談論他一切奇妙的作為。',
    '代上16:10 要以他的聖名誇耀；尋求耶和華的人，心中應當歡喜。',
    '代上16:11 要尋求耶和華與他的能力，時常尋求他的面。',
    '代上16:12 他僕人以色列的後裔，他所揀選雅各的子孫哪，你們要記念他奇妙的作為和他的奇事，並他口中的判語。',
    '代上16:13 併於上節。',
    '代上16:14 他是耶和華─我們的神，全地都有他的判斷。',
    '代上16:15 你們要記念他的約，直到永遠；他所吩咐的話，直到千代，',
    '代上16:16 就是與亞伯拉罕所立的約，向以撒所起的誓。',
    '代上16:17 他又將這約向雅各定為律例，向以色列定為永遠的約，',
    '代上16:18 說：我必將迦南地賜給你，作你產業的分。',
    '代上16:19 當時你們人丁有限，數目稀少，並且在那地為寄居的；',
    '代上16:20 他們從這邦游到那邦，從這國行到那國。',
    '代上16:21 耶和華不容什麼人欺負他們，為他們的緣故責備君王，',
    '代上16:22 說：不可難為我受膏的人，也不可惡待我的先知！',
    '代上16:23 全地都要向耶和華歌唱！天天傳揚他的救恩，',
    '代上16:24 在列邦中述說他的榮耀，在萬民中述說他的奇事。',
    '代上16:25 因耶和華為大，當受極大的讚美；他在萬神之上，當受敬畏。',
    '代上16:26 外邦的神都屬虛無，惟獨耶和華創造諸天。',
    '代上16:27 有尊榮和威嚴在他面前，有能力和喜樂在他聖所。',
    '代上16:28 民中的萬族啊，你們要將榮耀能力歸給耶和華，都歸給耶和華！',
    '代上16:29 要將耶和華的名所當得的榮耀歸給他，拿供物來奉到他面前；當以聖潔的【的或作為】妝飾敬拜耶和華。',
    '代上16:30 全地要在他面前戰抖，世界也堅定不得動搖。',
    '代上16:31 願天歡喜，願地快樂；願人在列邦中說：耶和華作王了！',
    '代上16:32 願海和其中所充滿的澎湃；願田和其中所有的都歡樂。',
    '代上16:33 那時，林中的樹木都要在耶和華面前歡呼，因為他來要審判全地。',
    '代上16:34 應當稱謝耶和華；因他本為善，他的慈愛永遠長存！',
    '代上16:35 要說：拯救我們的神啊，求你救我們，聚集我們，使我們脫離外邦，我們好稱讚你的聖名，以讚美你為誇勝。',
    '代上16:36 耶和華─以色列的神，從亙古直到永遠，是應當稱頌的！眾民都說：阿們！並且讚美耶和華。',
    '代上16:37 大衛派亞薩和他的弟兄在約櫃前常常事奉耶和華，一日盡一日的職分；',
    '代上16:38 又派俄別以東和他的弟兄六十八人，與耶杜頓的兒子俄別以東，並何薩作守門的；',
    '代上16:39 且派祭司撒督和他弟兄眾祭司在基遍的邱壇、耶和華的帳幕前燔祭壇上，每日早晚，照著耶和華律法書上所吩咐以色列人的，常給耶和華獻燔祭。',
    '代上16:40 併於上節。',
    '代上16:41 與他們一同被派的有希幔、耶杜頓，和其餘被選名字錄在冊上的，稱謝耶和華，因他的慈愛永遠長存。',
    '代上16:42 希幔、耶杜頓同著他們吹號、敲鈸，大發響聲，並用別的樂器隨著歌頌神。耶杜頓的子孫作守門的。',
    '代上16:43 於是眾民各歸各家；大衛也回去為家眷祝福。',
    '代上17:1 大衛住在自己宮中，對先知拿單說：看哪，我住在香柏木的宮中，耶和華的約櫃反在幔子裡。',
    '代上17:2 拿單對大衛說：你可以照你的心意而行，因為神與你同在。',
    '代上17:3 當夜，神的話臨到拿單，說：',
    '代上17:4 你去告訴我僕人大衛，說耶和華如此說：你不可建造殿宇給我居住。',
    '代上17:5 自從我領以色列人出埃及，直到今日，我未曾住過殿宇，乃從這會幕到那會幕，從這帳幕到那帳幕。',
    '代上17:6 凡我同以色列人所走的地方，我何曾向以色列的一個士師，就是我吩咐牧養我民的說：你為何不給我建造香柏木的殿宇呢﹖',
    '代上17:7 現在你要告訴我僕人大衛，說萬軍之耶和華如此說：我從羊圈中將你召來，叫你不再跟從羊群，立你作我民以色列的君。',
    '代上17:8 你無論往哪裡去，我常與你同在，剪除你的一切仇敵；我必使你得大名，好像世上大大有名的人一樣。',
    '代上17:9 我必為我民以色列選定一個地方，栽培他們，使他們住自己的地方，不再遷移；凶惡之子也不像從前擾害他們，',
    '代上17:10 並不像我命士師治理我民以色列的時候一樣。我必治服你的一切仇敵，並且我─耶和華應許你，必為你建立家室。',
    '代上17:11 你壽數滿足歸你列祖的時候，我必使你的後裔接續你的位，我也必堅定他的國。',
    '代上17:12 他必為我建造殿宇；我必堅定他的國位直到永遠。',
    '代上17:13 我要作他的父，他要作我的子；並不使我的慈愛離開他，像離開在你以前的掃羅一樣。',
    '代上17:14 我卻要將他永遠堅立在我家裡和我國裡；他的國位也必堅定，直到永遠。',
    '代上17:15 拿單就按這一切話，照這默示告訴大衛。',
    '代上17:16 於是大衛王進去，坐在耶和華面前，說：耶和華神啊，我是誰，我的家算什麼，你竟使我到這地步呢﹖',
    '代上17:17 神啊，這在你眼中還看為小，又應許你僕人的家至於久遠。耶和華神啊，你看顧我好像看顧高貴的人。',
    '代上17:18 你加於僕人的尊榮，我還有何言可說呢﹖因為你知道你的僕人。',
    '代上17:19 耶和華啊，你行了這大事，並且顯明出來，是因你僕人的緣故，也是照你的心意。',
    '代上17:20 耶和華啊，照我們耳中聽見，沒有可比你的，除你以外再無神。',
    '代上17:21 世上有何民能比你的民以色列呢﹖你神從埃及救贖他們作自己的子民，又在你贖出來的民面前行大而可畏的事，驅逐列邦人，顯出你的大名。',
    '代上17:22 你使以色列人作你的子民，直到永遠；你─耶和華也作他們的神。',
    '代上17:23 耶和華啊，你所應許僕人和僕人家的話，求你堅定，直到永遠，照你所說的而行。',
    '代上17:24 願你的名永遠堅立，被尊為大，說：萬軍之耶和華是以色列的神，是治理以色列的神。這樣，你僕人大衛的家必在你面前堅立。',
    '代上17:25 我的神啊，因你啟示僕人說，我必為你建立家室，所以僕人大膽在你面前祈禱。',
    '代上17:26 耶和華啊，惟有你是神，你也應許將這福氣賜給僕人。',
    '代上17:27 現在你喜悅賜福與僕人的家，可以永存在你面前。耶和華啊，你已經賜福，還要賜福到永遠。',
    '代上18:1 此後，大衛攻打非利士人，把他們治服，從他們手下奪取了迦特和屬迦特的村莊；',
    '代上18:2 又攻打摩押，摩押人就歸服大衛，給他進貢。',
    '代上18:3 瑣巴王哈大利謝【撒下八章三節作哈大底謝】往伯拉河去，要堅定自己的國權，大衛就攻打他，直到哈馬，',
    '代上18:4 奪了他的戰車一千，馬兵七千，步兵二萬，將拉戰車的馬砍斷蹄筋，但留下一百輛車的馬。',
    '代上18:5 大馬色的亞蘭人來幫助瑣巴王哈大利謝，大衛就殺了亞蘭人二萬二千。',
    '代上18:6 於是大衛在大馬色的亞蘭地設立防營，亞蘭人就歸服他，給他進貢。大衛無論往哪裡去，耶和華都使他得勝。',
    '代上18:7 他奪了哈大利謝臣僕所拿的金盾牌帶到耶路撒冷。',
    '代上18:8 大衛又從屬哈大利謝的提巴【或作比他】和均二城中奪取了許多的銅。後來所羅門用此製造銅海、銅柱，和一切的銅器。',
    '代上18:9 哈馬王陀烏聽見大衛殺敗瑣巴王哈大利謝的全軍，',
    '代上18:10 就打發他兒子哈多蘭去見大衛王，問他的安，為他祝福，因為他殺敗了哈大利謝（原來陀烏與哈大利謝常常爭戰）。哈多蘭帶了金銀銅的各樣器皿來。',
    '代上18:11 大衛王將這些器皿，並從各國奪來的金銀，就是從以東、摩押、亞捫、非利士、亞瑪力人所奪來的，都分別為聖獻給耶和華。',
    '代上18:12 洗魯雅的兒子亞比篩在鹽谷擊殺了以東一萬八千人。',
    '代上18:13 大衛在以東地設立防營，以東人就都歸服他。大衛無論往哪裡去，耶和華都使他得勝。',
    '代上18:14 大衛作以色列眾人的王，又向眾民秉公行義。',
    '代上18:15 洗魯雅的兒子約押作元帥；亞希律的兒子約沙法作史官；',
    '代上18:16 亞希突的兒子撒督和亞比亞他的兒子亞希米勒作祭司長；沙威沙作書記；',
    '代上18:17 耶何耶大的兒子比拿雅統轄基利提人和比利提人。大衛的眾子都在王的左右作領袖。',
    '代上19:1 此後，亞捫人的王拿轄死了，他兒子接續他作王。',
    '代上19:2 大衛說：我要照哈嫩的父親拿轄厚待我的恩典厚待哈嫩。於是大衛差遣使者為他喪父安慰他。大衛的臣僕到了亞捫人的境內見哈嫩，要安慰他，',
    '代上19:3 但亞捫人的首領對哈嫩說：大衛差人來安慰你，你想他是尊敬你父親嗎﹖他的臣僕來見你不是為詳察窺探、傾覆這地嗎﹖',
    '代上19:4 哈嫩便將大衛臣僕的鬍鬚剃去一半，又割斷他們下半截的衣服，使他們露出下體，打發他們回去。',
    '代上19:5 有人將臣僕所遇的事告訴大衛，他就差人去迎接他們，因為他們甚覺羞恥；告訴他們說：可以住在耶利哥，等到鬍鬚長起再回來。',
    '代上19:6 亞捫人知道大衛憎惡他們，哈嫩和亞捫人就打發人拿一千他連得銀子，從米所波大米、亞蘭、瑪迦、瑣巴雇戰車和馬兵，',
    '代上19:7 於是雇了三萬二千輛戰車和瑪迦王並他的軍兵；他們來安營在米底巴前。亞捫人也從他們的城裡出來，聚集交戰。',
    '代上19:8 大衛聽見了，就差派約押統帶勇猛的全軍出去。',
    '代上19:9 亞捫人出來在城門前擺陣，所來的諸王另在郊野擺陣。',
    '代上19:10 約押看見敵人在他前後擺陣，就從以色列軍中挑選精兵，使他們對著亞蘭人擺陣；',
    '代上19:11 其餘的兵交與他兄弟亞比篩，對著亞捫人擺陣。',
    '代上19:12 約押對亞比篩說：亞蘭人若強過我，你就來幫助我；亞捫人若強過你，我就去幫助你。',
    '代上19:13 我們都當剛強，為本國的民和神的城邑作大丈夫，願耶和華憑他的意旨而行。',
    '代上19:14 於是約押和跟隨他的人前進攻打亞蘭人；亞蘭人在約押面前逃跑。',
    '代上19:15 亞捫人見亞蘭人逃跑，他們也在約押的兄弟亞比篩面前逃跑進城。約押就回耶路撒冷去了。',
    '代上19:16 亞蘭人見自己被以色列人打敗，就打發使者將大河那邊的亞蘭人調來，哈大利謝的將軍朔法率領他們。',
    '代上19:17 有人告訴大衛，他就聚集以色列眾人過約但河，來到亞蘭人那裡，迎著他們擺陣。大衛既擺陣攻擊亞蘭人，亞蘭人就與他打仗。',
    '代上19:18 亞蘭人在以色列人面前逃跑。大衛殺了亞蘭七千輛戰車的人，四萬步兵，又殺了亞蘭的將軍朔法。',
    '代上19:19 屬哈大利謝的諸王見自己被以色列人打敗，就與大衛和好，歸服他。於是亞蘭人不敢再幫助亞捫人了。',
    '代上20:1 過了一年，到列王出戰的時候，約押率領軍兵毀壞亞捫人的地，圍攻拉巴；大衛仍住在耶路撒冷。約押攻打拉巴，將城傾覆。',
    '代上20:2 大衛奪了亞捫人之王【王或作瑪勒堪。瑪勒堪即米勒公，是亞捫族之神名】所戴的金冠冕，其上的金子重一他連得，又嵌著寶石；人將這冠冕戴在大衛頭上。大衛從城裡奪了許多財物，',
    '代上20:3 將城裡的人拉出來，放在鋸下，或鐵耙下，或鐵斧下【或作強他們用鋸，或用打糧食的鐵器，或用鐵斧做工】，大衛待亞捫各城的居民都是如此。其後大衛和眾軍都回耶路撒冷去了。',
    '代上20:4 後來，以色列人在基色與非利士人打仗。戶沙人西比該殺了偉人的一個兒子細派，非利士人就被制伏了。',
    '代上20:5 又與非利士人打仗。睚珥的兒子伊勒哈難殺了迦特人歌利亞的兄弟拉哈米；這人的槍桿粗如織布的機軸。',
    '代上20:6 又在迦特打仗。那裡有一個身量高大的人，手腳都是六指，共有二十四個指頭，他也是偉人的兒子。',
    '代上20:7 這人向以色列人罵陣，大衛的哥哥示米亞的兒子約拿單就殺了他。',
    '代上20:8 這三個人是迦特偉人的兒子，都死在大衛和他僕人的手下。',
    '代上21:1 撒但起來攻擊以色列人，激動大衛數點他們。',
    '代上21:2 大衛就吩咐約押和民中的首領說：你們去數點以色列人，從別是巴直到但，回來告訴我，我好知道他們的數目。',
    '代上21:3 約押說：願耶和華使他的百姓比現在加增百倍。我主我王啊，他們不都是你的僕人嗎﹖我主為何吩咐行這事，為何使以色列人陷在罪裡呢﹖',
    '代上21:4 但王的命令勝過約押。約押就出去，走遍以色列地，回到耶路撒冷，',
    '代上21:5 將百姓的總數奏告大衛：以色列人拿刀的有一百一十萬；猶大人拿刀的有四十七萬。',
    '代上21:6 惟有利未人和便雅憫人沒有數在其中，因為約押厭惡王的這命令。',
    '代上21:7 神不喜悅這數點百姓的事，便降災給以色列人。',
    '代上21:8 大衛禱告神說：我行這事大有罪了！現在求你除掉僕人的罪孽，因我所行的甚是愚昧。',
    '代上21:9 耶和華吩咐大衛的先見迦得說：',
    '代上21:10 你去告訴大衛說，耶和華如此說：我有三樣災，隨你選擇一樣，我好降與你。',
    '代上21:11 於是，迦得來見大衛，對他說：耶和華如此說：你可以隨意選擇：',
    '代上21:12 或三年的饑荒；或敗在你敵人面前，被敵人的刀追殺三個月；或在你國中有耶和華的刀，就是三日的瘟疫，耶和華的使者在以色列的四境施行毀滅。現在你要想一想，我好回覆那差我來的。',
    '代上21:13 大衛對迦得說：我甚為難。我願落在耶和華的手裡，因為他有豐盛的憐憫；我不願落在人的手裡。',
    '代上21:14 於是，耶和華降瘟疫與以色列人，以色列人就死了七萬。',
    '代上21:15 神差遣使者去滅耶路撒冷，剛要滅的時候，耶和華看見後悔，就不降這災了，吩咐滅城的天使說：夠了，住手吧！那時，耶和華的使者站在耶布斯人阿珥楠的禾場那裡。',
    '代上21:16 大衛舉目，看見耶和華的使者站在天地間，手裡有拔出來的刀，伸在耶路撒冷以上。大衛和長老都身穿麻衣，面伏於地。',
    '代上21:17 大衛禱告神說：吩咐數點百姓的不是我嗎﹖我犯了罪，行了惡，但這群羊做了什麼呢﹖願耶和華─我神的手攻擊我和我的父家，不要攻擊你的民，降瘟疫與他們。',
    '代上21:18 耶和華的使者吩咐迦得去告訴大衛，叫他上去，在耶布斯人阿珥楠的禾場上為耶和華築一座壇；',
    '代上21:19 大衛就照著迦得奉耶和華名所說的話上去了。',
    '代上21:20 那時阿珥楠正打麥子，回頭看見天使，就和他四個兒子都藏起來了。',
    '代上21:21 大衛到了阿珥楠那裡，阿珥楠看見大衛，就從禾場上出去，臉伏於地，向他下拜。',
    '代上21:22 大衛對阿珥楠說：你將這禾場與相連之地賣給我，我必給你足價，我好在其上為耶和華築一座壇，使民間的瘟疫止住。',
    '代上21:23 阿珥楠對大衛說：你可以用這禾場，願我主我王照你所喜悅的去行。我也將牛給你作燔祭，把打糧的器具當柴燒，拿麥子作素祭。這些我都送給你。',
    '代上21:24 大衛王對阿珥楠說：不然！我必要用足價向你買。我不用你的物獻給耶和華，也不用白得之物獻為燔祭。',
    '代上21:25 於是大衛為那塊地平了六百舍客勒金子給阿珥楠。',
    '代上21:26 大衛在那裡為耶和華築了一座壇，獻燔祭和平安祭，求告耶和華。耶和華就應允他，使火從天降在燔祭壇上。',
    '代上21:27 耶和華吩咐使者，他就收刀入鞘。',
    '代上21:28 那時，大衛見耶和華在耶布斯人阿珥楠的禾場上應允了他，就在那裡獻祭。',
    '代上21:29 摩西在曠野所造之耶和華的帳幕和燔祭壇都在基遍的高處；',
    '代上21:30 只是大衛不敢前去求問神，因為懼怕耶和華使者的刀。',
    '代上21:31 大衛說：這就是耶和華神的殿，為以色列人獻燔祭的壇。',
    '代上22:1 大衛吩咐聚集住以色列地的外邦人，從其中派石匠鑿石頭，要建造神的殿。',
    '代上22:2 大衛預備許多鐵做門上的釘子和鉤子，又預備許多銅，多得無法可稱；',
    '代上22:3 又預備無數的香柏木，因為西頓人和推羅人給大衛運了許多香柏木來。',
    '代上22:4 大衛說：我兒子所羅門還年幼嬌嫩，要為耶和華建造的殿宇必須高大輝煌，使名譽榮耀傳遍萬國；所以我要為殿預備材料。於是，大衛在未死之先預備的材料甚多。',
    '代上22:5 大衛召了他兒子所羅門來，囑咐他給耶和華─以色列的神建造殿宇，',
    '代上22:6 對所羅門說：我兒啊，我心裡本想為耶和華─我神的名建造殿宇，',
    '代上22:7 只是耶和華的話臨到我說：你流了多人的血，打了多次大仗，你不可為我的名建造殿宇，因為你在我眼前使多人的血流在地上。',
    '代上22:8 你要生一個兒子，他必作太平的人；我必使他安靜，不被四圍的仇敵擾亂。他的名要叫所羅門【即太平之意】。他在位的日子，我必使以色列人平安康泰。',
    '代上22:9 他必為我的名建造殿宇。他要作我的子；我要作他的父。他作以色列王；我必堅定他的國位，直到永遠。',
    '代上22:10 我兒啊，現今願耶和華與你同在，使你亨通，照他指著你說的話，建造耶和華─你神的殿。',
    '代上22:11 但願耶和華賜你聰明智慧，好治理以色列國，遵行耶和華─你神的律法。',
    '代上22:12 你若謹守遵行耶和華藉摩西吩咐以色列的律例典章，就得亨通。你當剛強壯膽，不要懼怕，也不要驚惶。',
    '代上22:13 我在困難之中為耶和華的殿預備了金子十萬他連得，銀子一百萬他連得，銅和鐵多得無法可稱；我也預備了木頭、石頭，你還可以增添。',
    '代上22:14 你有許多匠人，就是石匠、木匠，和一切能做各樣工的巧匠，',
    '代上22:15 並有無數的金銀銅鐵。你當起來辦事，願耶和華與你同在。',
    '代上22:16 大衛又吩咐以色列的眾首領幫助他兒子所羅門，說：',
    '代上22:17 耶和華─你們的神不是與你們同在嗎﹖不是叫你們四圍都平安嗎﹖因他已將這地的居民交在我手中，這地就在耶和華與他百姓面前制伏了。',
    '代上22:18 現在你們應當立定心意，尋求耶和華─你們的神；也當起來建造耶和華神的聖所，好將耶和華的約櫃和供奉神的聖器皿都搬進為耶和華名建造的殿裡。',
    '代上23:1 大衛年紀老邁，日子滿足，就立他兒子所羅門作以色列的王。',
    '代上23:2 大衛招聚以色列的眾首領和祭司利未人。',
    '代上23:3 利未人從三十歲以外的都被數點，他們男丁的數目共有三萬八千；',
    '代上23:4 其中有二萬四千人管理耶和華殿的事，有六千人作官長和士師，',
    '代上23:5 有四千人作守門的，又有四千人用大衛所做的樂器頌讚耶和華。',
    '代上23:6 大衛將利未人革順、哥轄、米拉利的子孫分了班次。',
    '代上23:7 革順的子孫有拉但和示每。',
    '代上23:8 拉但的長子是耶歇，還有細坦和約珥，共三人。',
    '代上23:9 示每的兒子是示羅密、哈薛、哈蘭三人。這是拉但族的族長。',
    '代上23:10 示每的兒子是雅哈、細拿、耶烏施、比利亞共四人。',
    '代上23:11 雅哈是長子，細撒是次子。但耶烏施和比利亞的子孫不多，所以算為一族。',
    '代上23:12 哥轄的兒子是暗蘭、以斯哈、希伯倫、烏薛共四人。',
    '代上23:13 暗蘭的兒子是亞倫、摩西。亞倫和他的子孫分出來，好分別至聖的物，在耶和華面前燒香、事奉他，奉他的名祝福，直到永遠。',
    '代上23:14 至於神人摩西，他的子孫名字記在利未支派的冊上。',
    '代上23:15 摩西的兒子是革舜和以利以謝。',
    '代上23:16 革舜的長子是細布業；',
    '代上23:17 以利以謝的兒子是利哈比雅。以利以謝沒有別的兒子，但利哈比雅的子孫甚多。',
    '代上23:18 以斯哈的長子是示羅密。',
    '代上23:19 希伯倫的長子是耶利雅，次子是亞瑪利亞，三子是雅哈悉，四子是耶加面。',
    '代上23:20 烏薛的長子是米迦，次子是耶西雅。',
    '代上23:21 米拉利的兒子是抹利、母示。抹利的兒子是以利亞撒、基士。',
    '代上23:22 以利亞撒死了，沒有兒子，只有女兒，他們本族基士的兒子娶了他們為妻。',
    '代上23:23 母示的兒子是末力、以得、耶利摩共三人。',
    '代上23:24 以上利未子孫作族長的，照著男丁的數目，從二十歲以外，都辦耶和華殿的事務。',
    '代上23:25 大衛說：耶和華─以色列的神已經使他的百姓平安，他永遠住在耶路撒冷。',
    '代上23:26 利未人不必再擡帳幕和其中所用的一切器皿了。',
    '代上23:27 照著大衛臨終所吩咐的，利未人從二十歲以外的都被數點。',
    '代上23:28 他們的職任是服事亞倫的子孫，在耶和華的殿和院子，並屋中辦事，潔淨一切聖物，就是辦神殿的事務，',
    '代上23:29 並管理陳設餅，素祭的細麵，或無酵薄餅，或用盤烤，或用油調和的物，又管理各樣的升斗尺度；',
    '代上23:30 每日早晚，站立稱謝讚美耶和華，',
    '代上23:31 又在安息日、月朔，並節期，按數照例，將燔祭常常獻給耶和華；',
    '代上23:32 又看守會幕和聖所，並守耶和華吩咐他們弟兄亞倫子孫的，辦耶和華殿的事。',
    '代上24:1 亞倫子孫的班次記在下面：亞倫的兒子是拿答、亞比戶、以利亞撒、以他瑪。',
    '代上24:2 拿答、亞比戶死在他們父親之先，沒有留下兒子；故此，以利亞撒、以他瑪供祭司的職分。',
    '代上24:3 以利亞撒的子孫撒督和以他瑪的子孫亞希米勒，同著大衛將他們的族弟兄分成班次。',
    '代上24:4 以利亞撒子孫中為首的比以他瑪子孫中為首的更多，分班如下：以利亞撒的子孫中有十六個族長，以他瑪的子孫中有八個族長；',
    '代上24:5 都掣籤分立，彼此一樣。在聖所和神面前作首領的有以利亞撒的子孫，也有以他瑪的子孫。',
    '代上24:6 作書記的利未人拿坦業的兒子示瑪雅在王和首領，與祭司撒督、亞比亞他的兒子亞希米勒，並祭司利未人的族長面前記錄他們的名字。在以利亞撒的子孫中取一族，在以他瑪的子孫中取一族。',
    '代上24:7 掣籤的時候，第一掣出來的是耶何雅立，第二是耶大雅，',
    '代上24:8 第三是哈琳，第四是梭琳，',
    '代上24:9 第五是瑪基雅，第六是米雅民，',
    '代上24:10 第七是哈歌斯，第八是亞比雅，',
    '代上24:11 第九是耶書亞，第十是示迦尼，',
    '代上24:12 第十一是以利亞實，第十二是雅金，',
    '代上24:13 第十三是胡巴，第十四是耶是比押，',
    '代上24:14 第十五是璧迦，第十六是音麥，',
    '代上24:15 第十七是希悉，第十八是哈闢悉，',
    '代上24:16 第十九是毘他希雅，第二十是以西結，',
    '代上24:17 第二十一是雅斤，第二十二是迦末，',
    '代上24:18 第二十三是第來雅，第二十四是瑪西亞。',
    '代上24:19 這就是他們的班次，要照耶和華─以色列的神藉他們祖宗亞倫所吩咐的條例進入耶和華的殿辦理事務。',
    '代上24:20 利未其餘的子孫如下：暗蘭的子孫裡有書巴業；書巴業的子孫裡有耶希底亞。',
    '代上24:21 利哈比雅的子孫裡有長子伊示雅。',
    '代上24:22 以斯哈的子孫裡有示羅摩；示羅摩的子孫裡有雅哈。',
    '代上24:23 希伯倫的子孫裡有長子耶利雅，次子亞瑪利亞，三子雅哈悉，四子耶加面。',
    '代上24:24 烏薛的子孫裡有米迦；米迦的子孫裡有沙密。',
    '代上24:25 米迦的兄弟是伊示雅；伊示雅的子孫裡有撒迦利雅。',
    '代上24:26 米拉利的兒子是抹利、母示、雅西雅；雅西雅的兒子有比挪；',
    '代上24:27 米拉利的子孫裡有雅西雅的兒子比挪、朔含、撒刻、伊比利。',
    '代上24:28 抹利的兒子是以利亞撒；以利亞撒沒有兒子。',
    '代上24:29 基士的子孫裡有耶拉篾。',
    '代上24:30 母示的兒子是末力、以得、耶利摩。按著宗族這都是利未的子孫。',
    '代上24:31 他們在大衛王和撒督，並亞希米勒與祭司利未人的族長面前掣籤，正如他們弟兄亞倫的子孫一般。各族的長者與兄弟沒有分別。',
    '代上25:1 大衛和眾首領分派亞薩、希幔，並耶杜頓的子孫彈琴、鼓瑟、敲鈸、唱歌【原文作說預言；本章同】。他們供職的人數記在下面：',
    '代上25:2 亞薩的兒子撒刻、約瑟、尼探雅、亞薩利拉都歸亞薩指教，遵王的旨意唱歌。',
    '代上25:3 耶杜頓的兒子基大利、西利、耶篩亞、哈沙比雅、瑪他提雅、示每共六人，都歸他們父親耶杜頓指教，彈琴，唱歌，稱謝，頌讚耶和華。',
    '代上25:4 希幔的兒子布基雅、瑪探雅、烏薛、細布業、耶利摩、哈拿尼雅、哈拿尼、以利亞他、基大利提、羅幔提‧以謝、約施比加沙、瑪羅提、何提、瑪哈秀；',
    '代上25:5 這都是希幔的兒子，吹角頌讚。希幔奉神之命作王的先見。神賜給希幔十四個兒子，三個女兒，',
    '代上25:6 都歸他們父親指教，在耶和華的殿唱歌、敲鈸、彈琴、鼓瑟，辦神殿的事務。亞薩、耶杜頓、希幔都是王所命定的。',
    '代上25:7 他們和他們的弟兄學習頌讚耶和華；善於歌唱的共有二百八十八人。',
    '代上25:8 這些人無論大小，為師的、為徒的，都一同掣籤分了班次。',
    '代上25:9 掣籤的時候，第一掣出來的是亞薩的兒子約瑟。第二是基大利；他和他弟兄並兒子共十二人。',
    '代上25:10 第三是撒刻；他和他兒子並弟兄共十二人。',
    '代上25:11 第四是伊洗利；他和他兒子並弟兄共十二人。',
    '代上25:12 第五是尼探雅；他和他兒子並弟兄共十二人。',
    '代上25:13 第六是布基雅；他和他兒子並弟兄共十二人。',
    '代上25:14 第七是耶薩利拉；他和他兒子並弟兄共十二人。',
    '代上25:15 第八是耶篩亞；他和他兒子並弟兄共十二人。',
    '代上25:16 第九是瑪探雅；他和他兒子並弟兄共十二人。',
    '代上25:17 第十是示每；他和他兒子並弟兄共十二人。',
    '代上25:18 第十一是亞薩烈；他和他兒子並弟兄共十二人。',
    '代上25:19 第十二是哈沙比雅；他和他兒子並弟兄共十二人。',
    '代上25:20 第十三是書巴業；他和他兒子並弟兄共十二人。',
    '代上25:21 第十四是瑪他提雅；他和他兒子並弟兄共十二人。',
    '代上25:22 第十五是耶利摩；他和他兒子並弟兄共十二人。',
    '代上25:23 第十六是哈拿尼雅；他和他兒子並弟兄共十二人。',
    '代上25:24 第十七是約施比加沙；他和他兒子並弟兄共十二人。',
    '代上25:25 第十八是哈拿尼；他和他兒子並弟兄共十二人。',
    '代上25:26 第十九是瑪羅提；他和他兒子並弟兄共十二人。',
    '代上25:27 第二十是以利亞他；他和他兒子並弟兄共十二人。',
    '代上25:28 第二十一是何提；他和他兒子並弟兄共十二人。',
    '代上25:29 第二十二是基大利提；他和他兒子並弟兄共十二人。',
    '代上25:30 第二十三是瑪哈秀；他和他兒子並弟兄共十二人。',
    '代上25:31 第二十四是羅幔提‧以謝；他和他兒子並弟兄共十二人。',
    '代上26:1 守門的班次記在下面：可拉族亞薩的子孫中，有可利的兒子米施利米雅。',
    '代上26:2 米施利米雅的長子是撒迦利亞，次子是耶疊，三子是西巴第雅，四子是耶提聶，',
    '代上26:3 五子是以攔，六子是約哈難，七子是以利約乃。',
    '代上26:4 俄別以東的長子是示瑪雅，次子是約薩拔，三子是約亞，四子是沙甲，五子是拿坦業，',
    '代上26:5 六子是亞米利，七子是以薩迦，八子是毘烏利太，因為神賜福與俄別以東。',
    '代上26:6 他的兒子示瑪雅有幾個兒子，都是大能的壯士，掌管父親的家。',
    '代上26:7 示瑪雅的兒子是俄得尼、利法益、俄備得、以利薩巴。以利薩巴的弟兄是壯士，還有以利戶和西瑪迦。',
    '代上26:8 這都是俄別以東的子孫，他們和他們的兒子並弟兄，都是善於辦事的壯士。俄別以東的子孫共六十二人。',
    '代上26:9 米施利米雅的兒子和弟兄都是壯士，共十八人。',
    '代上26:10 米拉利子孫何薩有幾個兒子：長子是申利，他原不是長子，是他父親立他作長子。',
    '代上26:11 次子是希勒家，三子是底巴利雅，四子是撒迦利亞。何薩的兒子並弟兄共十三人。',
    '代上26:12 這些人都是守門的班長，與他們的弟兄一同在耶和華殿裡按班供職。',
    '代上26:13 他們無論大小，都按著宗族掣籤分守各門。',
    '代上26:14 掣籤守東門的是示利米雅；他的兒子撒迦利亞是精明的謀士，掣籤守北門。',
    '代上26:15 俄別以東守南門，他的兒子守庫房。',
    '代上26:16 書聘與何薩守西門，在靠近沙利基門、通著往上去的街道上，班與班相對。',
    '代上26:17 每日東門有六個利未人，北門有四個，南門有四個，庫房有兩個，又有兩個輪班替換。',
    '代上26:18 在西面街道上有四個，在遊廊上有兩個。',
    '代上26:19 以上是可拉子孫和米拉利子孫守門的班次。',
    '代上26:20 利未子孫中有亞希雅掌管神殿的府庫和聖物的府庫。',
    '代上26:21 革順族、拉但子孫裡，作族長的是革順族拉但的子孫耶希伊利。',
    '代上26:22 耶希伊利的兒子西坦和他兄弟約珥掌管耶和華殿裡的府庫。',
    '代上26:23 暗蘭族、以斯哈族、希伯倫族、烏泄族也有職分。',
    '代上26:24 摩西的孫子、革舜的兒子細布業掌管府庫。',
    '代上26:25 還有他的弟兄以利以謝。以利以謝的兒子是利哈比雅；利哈比雅的兒子是耶篩亞；耶篩亞的兒子是約蘭；約蘭的兒子是細基利；細基利的兒子是示羅密。',
    '代上26:26 這示羅密和他的弟兄掌管府庫的聖物，就是大衛王和眾族長、千夫長、百夫長，並軍長所分別為聖的物。',
    '代上26:27 他們將爭戰時所奪的財物分別為聖，以備修造耶和華的殿。',
    '代上26:28 先見撒母耳、基士的兒子掃羅、尼珥的兒子押尼珥、洗魯雅的兒子約押所分別為聖的物都歸示羅密和他的弟兄掌管。',
    '代上26:29 以斯哈族有基拿尼雅和他眾子作官長和士師，管理以色列的外事。',
    '代上26:30 希伯倫族有哈沙比雅和他弟兄一千七百人，都是壯士，在約但河西、以色列地辦理耶和華與王的事。',
    '代上26:31 希伯倫族中有耶利雅作族長。大衛作王第四十年，在基列的雅謝，從這族中尋得大能的勇士。',
    '代上26:32 耶利雅的弟兄有二千七百人，都是壯士，且作族長；大衛王派他們在流便支派、迦得支派、瑪拿西半支派中辦理神和王的事。',
    '代上27:1 以色列人的族長、千夫長、百夫長，和官長都分定班次，每班是二萬四千人，週年按月輪流，替換出入服事王。',
    '代上27:2 正月第一班的班長是撒巴第業的兒子雅朔班；他班內有二萬四千人。',
    '代上27:3 他是法勒斯的子孫，統管正月班的一切軍長。',
    '代上27:4 二月的班長是亞哈希人朵代，還有副官密基羅；他班內有二萬四千人。',
    '代上27:5 三月第三班的班長【原文作軍長；下同】是祭司耶何耶大的兒子比拿雅；他班內有二萬四千人。',
    '代上27:6 這比拿雅是那三十人中的勇士，管理那三十人；他班內又有他兒子暗米薩拔。',
    '代上27:7 四月第四班的班長是約押的兄弟亞撒黑。接續他的是他兒子西巴第雅；他班內有二萬四千人。',
    '代上27:8 五月第五班的班長是伊斯拉人珊合；他班內有二萬四千人。',
    '代上27:9 六月第六班的班長是提哥亞人益吉的兒子以拉；他班內有二萬四千人。',
    '代上27:10 七月第七班的班長是以法蓮族比倫人希利斯；他班內有二萬四千人。',
    '代上27:11 八月第八班的班長是謝拉族戶沙人西比該；他班內有二萬四千人。',
    '代上27:12 九月第九班的班長是便雅憫族亞拿突人亞比以謝；他班內有二萬四千人。',
    '代上27:13 十月第十班的班長是謝拉族尼陀法人瑪哈萊；他班內有二萬四千人。',
    '代上27:14 十一月第十一班的班長是以法蓮族比拉頓人比拿雅；他班內有二萬四千人。',
    '代上27:15 十二月第十二班的班長是俄陀聶族尼陀法人黑玳；他班內有二萬四千人。',
    '代上27:16 管理以色列眾支派的記在下面：管流便人的是細基利的兒子以利以謝；管西緬人的是瑪迦的兒子示法提雅；',
    '代上27:17 管利未人的是基母利的兒子哈沙比雅；管亞倫子孫的是撒督；',
    '代上27:18 管猶大人的是大衛的一個哥哥以利戶，管以薩迦人的是米迦勒的兒子暗利；',
    '代上27:19 管西布倫人的是俄巴第雅的兒子伊施瑪雅；管拿弗他利人的是亞斯列的兒子耶利摩；',
    '代上27:20 管以法蓮人的是阿撒細雅的兒子何細亞；管瑪拿西半支派的是毘大雅的兒子約珥；',
    '代上27:21 管基列地瑪拿西那半支派的是撒迦利亞的兒子易多；管便雅憫人的是押尼珥的兒子雅西業；',
    '代上27:22 管但人的是耶羅罕的兒子亞薩列。以上是以色列眾支派的首領。',
    '代上27:23 以色列人二十歲以內的，大衛沒有記其數目；因耶和華曾應許說，必加增以色列人如天上的星那樣多。',
    '代上27:24 洗魯雅的兒子約押動手數點，當時耶和華的烈怒臨到以色列人；因此，沒有點完，數目也沒有寫在大衛王記上。',
    '代上27:25 掌管王府庫的是亞疊的兒子押斯馬威。掌管田野城邑村莊保障之倉庫的是烏西雅的兒子約拿單。',
    '代上27:26 掌管耕田種地的是基綠的兒子以斯利。',
    '代上27:27 掌管葡萄園的是拉瑪人示每。掌管葡萄園酒窖的是實弗米人撒巴底。',
    '代上27:28 掌管高原橄欖樹和桑樹的是基第利人巴勒哈南。掌管油庫的是約阿施。',
    '代上27:29 掌管沙崙牧放牛群的是沙崙人施提賚。掌管山谷牧養牛群的是亞第賚的兒子沙法。',
    '代上27:30 掌管駝群的是以實瑪利人阿比勒。掌管驢群的是米崙人耶希底亞。掌管羊群的是夏甲人雅悉。',
    '代上27:31 這都是給大衛王掌管產業的。',
    '代上27:32 大衛的叔叔約拿單作謀士；這人有智慧，又作書記。哈摩尼的兒子耶歇作王眾子的師傅。',
    '代上27:33 亞希多弗也作王的謀士。亞基人戶篩作王的陪伴。',
    '代上27:34 亞希多弗之後，有比拿雅的兒子耶何耶大和亞比亞他接續他作謀士。約押作王的元帥。',
    '代上28:1 大衛招聚以色列各支派的首領和輪班服事王的軍長，與千夫長、百夫長，掌管王和王子產業牲畜的，並太監，以及大能的勇士，都到耶路撒冷來。',
    '代上28:2 大衛王就站起來，說：我的弟兄，我的百姓啊，你們當聽我言，我心裡本想建造殿宇，安放耶和華的約櫃，作為我神的腳凳；我已經預備建造的材料。',
    '代上28:3 只是神對我說：你不可為我的名建造殿宇；因你是戰士，流了人的血。',
    '代上28:4 然而，耶和華─以色列的神在我父的全家揀選我作以色列的王，直到永遠。因他揀選猶大為首領；在猶大支派中揀選我父家，在我父的眾子裡喜悅我，立我作以色列眾人的王。',
    '代上28:5 耶和華賜我許多兒子，在我兒子中揀選所羅門坐耶和華的國位，治理以色列人。',
    '代上28:6 耶和華對我說：你兒子所羅門必建造我的殿和院宇；因為我揀選他作我的子，我也必作他的父。',
    '代上28:7 他若恆久遵行我的誡命典章如今日一樣，我就必堅定他的國位，直到永遠。',
    '代上28:8 現今在耶和華的會中，以色列眾人眼前所說的，我們的神也聽見了。你們應當尋求耶和華─你們神的一切誡命，謹守遵行，如此你們可以承受這美地，遺留給你們的子孫，永遠為業。',
    '代上28:9 我兒所羅門哪，你當認識耶和華─你父的神，誠心樂意地事奉他；因為他鑒察眾人的心，知道一切心思意念。你若尋求他，他必使你尋見；你若離棄他，他必永遠丟棄你。',
    '代上28:10 你當謹慎，因耶和華揀選你建造殿宇作為聖所。你當剛強去行。',
    '代上28:11 大衛將殿的遊廊、旁屋、府庫、樓房、內殿，和施恩所的樣式指示他兒子所羅門，',
    '代上28:12 又將被靈感動所得的樣式，就是耶和華神殿的院子、周圍的房屋、殿的府庫，和聖物府庫的一切樣式都指示他；',
    '代上28:13 又指示他祭司和利未人的班次與耶和華殿裡各樣的工作，並耶和華殿裡一切器皿的樣式，',
    '代上28:14 以及各樣應用金器的分兩和各樣應用銀器的分兩，',
    '代上28:15 金燈臺和金燈的分兩，銀燈臺和銀燈的分兩，輕重各都合宜；',
    '代上28:16 陳設餅金桌子的分兩，銀桌子的分兩，',
    '代上28:17 精金的肉叉子、盤子，和爵的分兩，各金碗與各銀碗的分兩，',
    '代上28:18 精金香壇的分兩，並用金子做基路伯【原文作用金子做車式的基路伯】；基路伯張開翅膀，遮掩耶和華的約櫃。',
    '代上28:19 大衛說：這一切工作的樣式都是耶和華用手劃出來使我明白的。',
    '代上28:20 大衛又對他兒子所羅門說：你當剛強壯膽去行！不要懼怕，也不要驚惶。因為耶和華神就是我的神，與你同在；他必不撇下你，也不丟棄你，直到耶和華殿的工作都完畢了。',
    '代上28:21 有祭司和利未人的各班，為要辦理神殿各樣的事，又有靈巧的人在各樣的工作上樂意幫助你；並有眾首領和眾民一心聽從你的命令。',
    '代上29:1 大衛王對會眾說：我兒子所羅門是神特選的，還年幼嬌嫩；這工程甚大，因這殿不是為人，乃是為耶和華神建造的。',
    '代上29:2 我為我神的殿已經盡力，預備金子做金器，銀子做銀器，銅做銅器，鐵做鐵器，木做木器，還有紅瑪瑙可鑲嵌的寶石，彩石和一切的寶石，並許多漢白玉。',
    '代上29:3 且因我心中愛慕我神的殿，就在預備建造聖殿的材料之外，又將我自己積蓄的金銀獻上，建造我神的殿，',
    '代上29:4 就是俄斐金三千他連得、精鍊的銀子七千他連得，以貼殿牆。',
    '代上29:5 金子做金器，銀子做銀器，並藉匠人的手製造一切。今日有誰樂意將自己獻給耶和華呢﹖',
    '代上29:6 於是，眾族長和以色列各支派的首領、千夫長、百夫長，並監管王工的官長，都樂意獻上。',
    '代上29:7 他們為神殿的使用獻上金子五千他連得零一萬達利克，銀子一萬他連得，銅一萬八千他連得，鐵十萬他連得。',
    '代上29:8 凡有寶石的都交給革順人耶歇，送入耶和華殿的府庫。',
    '代上29:9 因這些人誠心樂意獻給耶和華，百姓就歡喜，大衛王也大大歡喜。',
    '代上29:10 所以，大衛在會眾面前稱頌耶和華說：耶和華─我們的父，以色列的神是應當稱頌，直到永永遠遠的！',
    '代上29:11 耶和華啊，尊大、能力、榮耀、強勝、威嚴都是你的；凡天上地下的都是你的；國度也是你的，並且你為至高，為萬有之首。',
    '代上29:12 豐富尊榮都從你而來，你也治理萬物。在你手裡有大能大力，使人尊大強盛都出於你。',
    '代上29:13 我們的神啊，現在我們稱謝你，讚美你榮耀之名！',
    '代上29:14 我算什麼，我的民算什麼，竟能如此樂意奉獻﹖因為萬物都從你而來，我們把從你而得的獻給你。',
    '代上29:15 我們在你面前是客旅，是寄居的，與我們列祖一樣。我們在世的日子如影兒，不能長存【或作沒有長存的指望】。',
    '代上29:16 耶和華─我們的神啊，我們預備這許多材料，要為你的聖名建造殿宇，都是從你而來，都是屬你的。',
    '代上29:17 我的神啊，我知道你察驗人心，喜悅正直；我以正直的心樂意獻上這一切物。現在我喜歡見你的民在這裡都樂意奉獻與你。',
    '代上29:18 耶和華─我們列祖亞伯拉罕、以撒、以色列的神啊，求你使你的民常存這樣的心思意念，堅定他們的心歸向你，',
    '代上29:19 又求你賜我兒子所羅門誠實的心，遵守你的命令、法度、律例，成就這一切的事，用我所預備的建造殿宇。',
    '代上29:20 大衛對全會眾說：你們應當稱頌耶和華─你們的神。於是會眾稱頌耶和華─他們列祖的神，低頭拜耶和華與王。',
    '代上29:21 次日，他們向耶和華獻平安祭和燔祭，就是獻公牛一千隻，公綿羊一千隻，羊羔一千隻，並同獻的奠祭；又為以色列眾人獻許多的祭。那日，他們在耶和華面前吃喝，大大歡樂。',
    '代上29:22 他們奉耶和華的命再膏大衛的兒子所羅門作王，又膏撒督作祭司。',
    '代上29:23 於是所羅門坐在耶和華所賜的位上，接續他父親大衛作王，萬事亨通；以色列眾人也都聽從他。',
    '代上29:24 眾首領和勇士，並大衛王的眾子，都順服所羅門王。',
    '代上29:25 耶和華使所羅門在以色列眾人眼前甚為尊大，極其威嚴，勝過在他以前的以色列王。',
    '代上29:26 耶西的兒子大衛作以色列眾人的王，',
    '代上29:27 作王共四十年：在希伯崙作王七年，在耶路撒冷作王三十三年。',
    '代上29:28 他年紀老邁，日子滿足，享受豐富、尊榮，就死了。他兒子所羅門接續他作王。',
    '代上29:29 大衛王始終的事都寫在先見撒母耳的書上和先知拿單並先見迦得的書上。',
    '代上29:30 他的國事和他的勇力，以及他和以色列並列國所經過的事都寫在這書上。',
    '代下1:1 大衛的兒子所羅門國位堅固；耶和華─他的神與他同在，使他甚為尊大。',
    '代下1:2 所羅門吩咐以色列眾人，就是千夫長、百夫長、審判官、首領與族長都來。',
    '代下1:3 所羅門和會眾都往基遍的邱壇去，因那裡有神的會幕，就是耶和華僕人摩西在曠野所製造的。',
    '代下1:4 只是神的約櫃，大衛已經從基列耶琳搬到他所預備的地方，因他曾在耶路撒冷為約櫃支搭了帳幕，',
    '代下1:5 並且戶珥的孫子、烏利的兒子比撒列所造的銅壇也在基遍耶和華的會幕前。所羅門和會眾都就近壇前。',
    '代下1:6 所羅門上到耶和華面前會幕的銅壇那裡，獻一千犧牲為燔祭。',
    '代下1:7 當夜，神向所羅門顯現，對他說：你願我賜你什麼，你可以求。',
    '代下1:8 所羅門對神說：你曾向我父大衛大施慈愛，使我接續他作王。',
    '代下1:9 耶和華神啊，現在求你成就向我父大衛所應許的話；因你立我作這民的王，他們如同地上塵沙那樣多。',
    '代下1:10 求你賜我智慧聰明，我好在這民前出入；不然，誰能判斷這眾多的民呢﹖',
    '代下1:11 神對所羅門說：我已立你作我民的王。你既有這心意，並不求資財、豐富、尊榮，也不求滅絕那恨你之人的性命，又不求大壽數，只求智慧聰明好判斷我的民；',
    '代下1:12 我必賜你智慧聰明，也必賜你資財、豐富、尊榮。在你以前的列王都沒有這樣，在你以後也必沒有這樣的。',
    '代下1:13 於是，所羅門從基遍邱壇會幕前回到耶路撒冷，治理以色列人。',
    '代下1:14 所羅門聚集戰車馬兵，有戰車一千四百輛，馬兵一萬二千名，安置在屯車的城邑和耶路撒冷，就是王那裡。',
    '代下1:15 王在耶路撒冷使金銀多如石頭，香柏木多如高原的桑樹。',
    '代下1:16 所羅門的馬是從埃及帶來的，是王的商人一群一群按著定價買來的。',
    '代下1:17 他們從埃及買來的車，每輛價銀七百舍客勒，馬每匹一百五十舍客勒。赫人諸王和亞蘭諸王所買的車馬，也是按這價值經他們手買來的。',
    '代下2:1 所羅門定意要為耶和華的名建造殿宇，又為自己的國建造宮室。',
    '代下2:2 所羅門就挑選七萬扛擡的，八萬在山上鑿石頭的，三千六百督工的。',
    '代下2:3 所羅門差人去見推羅王希蘭，說：你曾運香柏木與我父大衛建宮居住，求你也這樣待我。',
    '代下2:4 我要為耶和華─我神的名建造殿宇，分別為聖獻給他，在他面前焚燒美香，常擺陳設餅，每早晚、安息日、月朔，並耶和華─我們神所定的節期獻燔祭。這是以色列人永遠的定例。',
    '代下2:5 我所要建造的殿宇甚大；因為我們的神至大，超乎諸神。',
    '代下2:6 天和天上的天，尚且不足他居住的，誰能為他建造殿宇呢﹖我是誰﹖能為他建造殿宇嗎﹖不過在他面前燒香而已。',
    '代下2:7 現在求你差一個巧匠來，就是善用金、銀、銅、鐵，和紫色、朱紅色、藍色線，並精於雕刻之工的巧匠，與我父大衛在猶大和耶路撒冷所預備的巧匠一同做工；',
    '代下2:8 又求你從利巴嫩運些香柏木、松木、檀香木到我這裡來，因我知道你的僕人善於砍伐利巴嫩的樹木。我的僕人也必與你的僕人同工。',
    '代下2:9 這樣，可以給我預備許多的木料，因我要建造的殿宇高大出奇。',
    '代下2:10 你的僕人砍伐樹木，我必給他們打好了的小麥二萬歌珥，大麥二萬歌珥，酒二萬罷特，油二萬罷特。',
    '代下2:11 推羅王希蘭寫信回答所羅門說：耶和華因為愛他的子民，所以立你作他們的王；',
    '代下2:12 又說：創造天地的耶和華─以色列的神是應當稱頌的！他賜給大衛王一個有智慧的兒子，使他有謀略聰明，可以為耶和華建造殿宇，又為自己的國建造宮室。',
    '代下2:13 現在我打發一個精巧有聰明的人去，他是我父親希蘭所用的，',
    '代下2:14 是但支派一個婦人的兒子。他父親是推羅人，他善用金、銀、銅、鐵、石、木，和紫色、藍色、朱紅色線與細麻製造各物，並精於雕刻，又能想出各樣的巧工。請你派定這人，與你的巧匠和你父─我主大衛的巧匠一同做工。',
    '代下2:15 我主所說的小麥、大麥、酒、油，願我主運來給眾僕人。',
    '代下2:16 我們必照你所需用的，從利巴嫩砍伐樹木，紮成筏子，浮海運到約帕；你可以從那裡運到耶路撒冷。',
    '代下2:17 所羅門仿照他父大衛數點住在以色列地所有寄居的外邦人，共有十五萬三千六百名；',
    '代下2:18 使七萬人扛擡材料，八萬人在山上鑿石頭，三千六百人督理工作。',
    '代下3:1 所羅門就在耶路撒冷、耶和華向他父大衛顯現的摩利亞山上，就是耶布斯人阿珥楠的禾場上、大衛所指定的地方預備好了，開工建造耶和華的殿。',
    '代下3:2 所羅門作王第四年二月初二日開工建造。',
    '代下3:3 所羅門建築神殿的根基，乃是這樣：長六十肘，寬二十肘，都按著古時的尺寸。',
    '代下3:4 殿前的廊子長二十肘，與殿的寬窄一樣，高一百二十肘；裡面貼上精金。',
    '代下3:5 大殿的牆都用松木板遮蔽，又貼了精金，上面雕刻棕樹和鍊子；',
    '代下3:6 又用寶石裝飾殿牆，使殿華美；所用的金子都是巴瓦音的金子。',
    '代下3:7 又用金子貼殿和殿的棟梁、門檻、牆壁、門扇；牆上雕刻基路伯。',
    '代下3:8 又建造至聖所，長二十肘，與殿的寬窄一樣，寬也是二十肘；貼上精金，共用金子六百他連得。',
    '代下3:9 金釘重五十舍客勒。樓房都貼上金子。',
    '代下3:10 在至聖所按造像的法子造兩個基路伯，用金子包裹。',
    '代下3:11 兩個基路伯的翅膀共長二十肘。這基路伯的一個翅膀長五肘，挨著殿這邊的牆；那一個翅膀也長五肘，與那基路伯翅膀相接。',
    '代下3:12 那基路伯的一個翅膀長五肘，挨著殿那邊的牆；那一個翅膀也長五肘，與這基路伯的翅膀相接。',
    '代下3:13 兩個基路伯張開翅膀，共長二十肘，面向外殿而立。',
    '代下3:14 又用藍色、紫色、朱紅色線和細麻織幔子，在其上繡出基路伯來。',
    '代下3:15 在殿前造了兩根柱子，高三十五肘；每柱頂高五肘。',
    '代下3:16 又照聖所內鍊子的樣式做鍊子，安在柱頂上；又做一百石榴，安在鍊子上。',
    '代下3:17 將兩根柱子立在殿前，一根在右邊，一根在左邊；右邊的起名叫雅斤，左邊的起名叫波阿斯。',
    '代下4:1 他又製造一座銅壇，長二十肘，寬二十肘，高十肘；',
    '代下4:2 又鑄一個銅海，樣式是圓的，高五肘，徑十肘，圍三十肘；',
    '代下4:3 海周圍有野瓜【原文作牛】的樣式，每肘十瓜，共有兩行，是鑄海的時候鑄上的；',
    '代下4:4 有十二隻銅牛馱海：三隻向北，三隻向西，三隻向南，三隻向東；海在牛上，牛尾向內；',
    '代下4:5 海厚一掌，邊如杯邊，又如百合花，可容三千罷特；',
    '代下4:6 又製造十個盆：五個放在右邊，五個放在左邊，獻燔祭所用之物都洗在其內；但海是為祭司沐浴的。',
    '代下4:7 他又照所定的樣式造十個金燈臺放在殿裡：五個在右邊，五個在左邊；',
    '代下4:8 又造十張桌子放在殿裡：五張在右邊，五張在左邊；又造一百個金碗；',
    '代下4:9 又建立祭司院和大院，並院門，用銅包裹門扇；',
    '代下4:10 將海安在殿門的右邊，就是南邊。',
    '代下4:11 戶蘭又造了盆、鏟、碗。這樣，他為所羅門王做完了神殿的工。',
    '代下4:12 所造的就是：兩根柱子和柱上兩個如球的頂，並兩個蓋柱頂的網子',
    '代下4:13 和四百石榴，安在兩個網子上（每網兩行蓋著兩個柱上如球的頂）。',
    '代下4:14 盆座和其上的盆，',
    '代下4:15 海和海下的十二隻牛，',
    '代下4:16 盆、鏟子、肉鍤子，與耶和華殿裡的一切器皿，都是巧匠戶蘭用光亮的銅為所羅門王造成的，',
    '代下4:17 是在約但平原疏割和撒利但中間藉膠泥鑄成的。',
    '代下4:18 所羅門製造的這一切甚多，銅的輕重無法可查。',
    '代下4:19 所羅門又造神殿裡的金壇和陳設餅的桌子，',
    '代下4:20 並精金的燈臺和燈盞，可以照例點在內殿前。',
    '代下4:21 燈臺上的花和燈盞，並蠟剪都是金的，且是純金的；',
    '代下4:22 又用精金製造鑷子、盤子、調羹、火鼎。至於殿門和至聖所的門扇，並殿的門扇，都是金子妝飾的。',
    '代下5:1 所羅門做完了耶和華殿的一切工，就把他父大衛分別為聖的金銀和器皿都帶來，放在神殿的府庫裡。',
    '代下5:2 那時，所羅門將以色列的長老、各支派的首領，並以色列的族長招聚到耶路撒冷，要把耶和華的約櫃從大衛城─就是錫安─運上來。',
    '代下5:3 於是以色列眾人在七月節前都聚集到王那裡。',
    '代下5:4 以色列眾長老來到，利未人便擡起約櫃。',
    '代下5:5 祭司利未人將約櫃運上來，又將會幕和會幕的一切聖器具都帶上來。',
    '代下5:6 所羅門王和聚集到他那裡的以色列全會眾都在約櫃前獻牛羊為祭，多得不可勝數。',
    '代下5:7 祭司將耶和華的約櫃擡進內殿，就是至聖所，放在兩個基路伯的翅膀底下。',
    '代下5:8 基路伯張著翅膀在約櫃之上，遮掩約櫃和擡櫃的槓。',
    '代下5:9 這槓甚長，槓頭在內殿前可以看見，在殿外卻不能看見，直到如今還在那裡。',
    '代下5:10 約櫃裡惟有兩塊石版，就是以色列人出埃及後，耶和華與他們立約的時候，摩西在何烈山所放的。除此以外，並無別物。',
    '代下5:11 當時，在那裡所有的祭司都已自潔，並不分班供職。',
    '代下5:12 他們出聖所的時候，歌唱的利未人亞薩、希幔、耶杜頓，和他們的眾子眾弟兄都穿細麻布衣服，站在壇的東邊，敲鈸、鼓瑟、彈琴，同著他們有一百二十個祭司吹號。',
    '代下5:13 吹號的、歌唱的都一齊發聲，聲合為一，讚美感謝耶和華。吹號、敲鈸，用各種樂器，揚聲讚美耶和華說：耶和華本為善，他的慈愛永遠長存！那時，耶和華的殿有雲充滿，',
    '代下5:14 甚至祭司不能站立供職，因為耶和華的榮光充滿了神的殿。',
    '代下6:1 那時，所羅門說：耶和華曾說他必住在幽暗之處。',
    '代下6:2 但我已經建造殿宇作你的居所，為你永遠的住處。',
    '代下6:3 王轉臉為以色列會眾祝福，以色列會眾就都站立。',
    '代下6:4 所羅門說：耶和華─以色列的神是應當稱頌的！因他親口向我父大衛所應許的，也親手成就了。',
    '代下6:5 他說：自從我領我民出埃及地以來，我未曾在以色列眾支派中選擇一城建造殿宇為我名的居所，也未曾揀選一人作我民以色列的君；',
    '代下6:6 但選擇耶路撒冷為我名的居所，又揀選大衛治理我民以色列。',
    '代下6:7 所羅門說：我父大衛曾立意要為耶和華─以色列神的名建殿，',
    '代下6:8 耶和華卻對我父大衛說：你立意要為我的名建殿，這意思甚好；',
    '代下6:9 只是你不可建殿，惟你所生的兒子必為我名建殿。',
    '代下6:10 現在耶和華成就了他所應許的話，使我接續我父大衛坐以色列的國位，是照耶和華所說的，又為耶和華─以色列神的名建造了殿。',
    '代下6:11 我將約櫃安置在其中，櫃內有耶和華的約，就是他與以色列人所立的約。',
    '代下6:12 所羅門當著以色列會眾，站在耶和華的壇前，舉起手來，',
    '代下6:13 （所羅門曾造一個銅臺，長五肘，寬五肘，高三肘，放在院中）就站在臺上，當著以色列的會眾跪下，向天舉手，',
    '代下6:14 說：耶和華─以色列的神啊，天上地下沒有神可比你的！你向那盡心行在你面前的僕人守約施慈愛；',
    '代下6:15 向你僕人─我父大衛所應許的話現在應驗了。你親口應許，親手成就，正如今日一樣。',
    '代下6:16 耶和華─以色列的神啊，你所應許你僕人─我父大衛的話說：你的子孫若謹慎自己的行為，遵守我的律法，像你在我面前所行的一樣，就不斷人坐以色列的國位。現在求你應驗這話。',
    '代下6:17 耶和華─以色列的神啊，求你成就向你僕人大衛所應許的話。',
    '代下6:18 神果真與世人同住在地上嗎﹖看哪，天和天上的天尚且不足你居住的，何況我所建的這殿呢﹖',
    '代下6:19 惟求耶和華─我的神垂顧僕人的禱告祈求，俯聽僕人在你面前的祈禱呼籲。',
    '代下6:20 願你晝夜看顧這殿，就是你應許立為你名的居所；求你垂聽僕人向此處禱告的話。',
    '代下6:21 你僕人和你民以色列向此處祈禱的時候，求你從天上你的居所垂聽，垂聽而赦免。',
    '代下6:22 人若得罪鄰舍，有人叫他起誓，他來到這殿，在你的壇前起誓，',
    '代下6:23 求你從天上垂聽，判斷你的僕人，定惡人有罪，照他所行的報應在他頭上；定義人有理，照他的義賞賜他。',
    '代下6:24 你的民以色列若得罪你，敗在仇敵面前，又回心轉意承認你的名，在這殿裡向你祈求禱告，',
    '代下6:25 求你從天上垂聽，赦免你民以色列的罪，使他們歸回你賜給他們和他們列祖之地。',
    '代下6:26 你的民因得罪你，你懲罰他們，使天閉塞不下雨，他們若向此處禱告，承認你的名，離開他們的罪，',
    '代下6:27 求你在天上垂聽，赦免你僕人和你民以色列的罪，將當行的善道指教他們，且降雨在你的地，就是你賜給你民為業之地。',
    '代下6:28 國中若有饑荒、瘟疫、旱風、霉爛、蝗蟲、螞蚱，或有仇敵犯境，圍困城邑，無論遭遇什麼災禍疾病，',
    '代下6:29 你的民以色列，或是眾人，或是一人，自覺災禍甚苦，向這殿舉手，無論祈求什麼，禱告什麼，',
    '代下6:30 求你從天上你的居所垂聽赦免。你是知道人心的，要照各人所行的待他們（惟有你知道世人的心），',
    '代下6:31 使他們在你賜給我們列祖之地上一生一世敬畏你，遵行你的道。',
    '代下6:32 論到不屬你民以色列的外邦人，為你的大名和大能的手，並伸出來的膀臂，從遠方而來，向這殿禱告，',
    '代下6:33 求你從天上你的居所垂聽，照著外邦人所祈求的而行，使天下萬民都認識你的名，敬畏你，像你的民以色列一樣，又使他們知道我建造的這殿是稱為你名下的。',
    '代下6:34 你的民若奉你的差遣，無論往何處去與仇敵爭戰，向你所選擇的城與我為你名所建造的殿禱告，',
    '代下6:35 求你從天上垂聽他們的禱告祈求，使他們得勝。',
    '代下6:36 你的民若得罪你（世上沒有不犯罪的人），你向他們發怒，將他們交給仇敵擄到或遠或近之地；',
    '代下6:37 他們若在擄到之地想起罪來，回心轉意，懇求你說：我們有罪了，我們悖逆了，我們作惡了；',
    '代下6:38 他們若在擄到之地盡心盡性歸服你，又向自己的地，就是你賜給他們列祖之地和你所選擇的城，並我為你名所建造的殿禱告，',
    '代下6:39 求你從天上你的居所垂聽你民的禱告祈求，為他們伸冤，赦免他們的過犯。',
    '代下6:40 我的神啊，現在求你睜眼看，側耳聽在此處所獻的禱告。',
    '代下6:41 耶和華神啊，求你起來，和你有能力的約櫃同入安息之所。耶和華神啊，願你的祭司披上救恩；願你的聖民蒙福歡樂。',
    '代下6:42 耶和華神啊，求你不要厭棄你的受膏者，要記念向你僕人大衛所施的慈愛。',
    '代下7:1 所羅門祈禱已畢，就有火從天上降下來，燒盡燔祭和別的祭。耶和華的榮光充滿了殿；',
    '代下7:2 因耶和華的榮光充滿了耶和華殿，所以祭司不能進殿。',
    '代下7:3 那火降下、耶和華的榮光在殿上的時候，以色列眾人看見，就在鋪石地俯伏叩拜，稱謝耶和華說：耶和華本為善，他的慈愛永遠長存！',
    '代下7:4 王和眾民在耶和華面前獻祭。',
    '代下7:5 所羅門王用牛二萬二千，羊十二萬獻祭。這樣，王和眾民為神的殿行奉獻之禮。',
    '代下7:6 祭司侍立，各供其職；利未人也拿著耶和華的樂器，就是大衛王造出來、藉利未人頌讚耶和華的。（他的慈愛永遠長存！）祭司在眾人面前吹號，以色列人都站立。',
    '代下7:7 所羅門因他所造的銅壇容不下燔祭、素祭，和脂油，便將耶和華殿前院子當中分別為聖，在那裡獻燔祭和平安祭牲的脂油。',
    '代下7:8 那時所羅門和以色列眾人，就是從哈馬口直到埃及小河，所有的以色列人都聚集成為大會，守節七日。',
    '代下7:9 第八日設立嚴肅會，行奉獻壇的禮七日，守節七日。',
    '代下7:10 七月二十三日，王遣散眾民；他們因見耶和華向大衛和所羅門與他民以色列所施的恩惠，就都心中喜樂，各歸各家去了。',
    '代下7:11 所羅門造成了耶和華殿和王宮；在耶和華殿和王宮凡他心中所要做的，都順順利利地做成了。',
    '代下7:12 夜間耶和華向所羅門顯現，對他說：我已聽了你的禱告，也選擇這地方作為祭祀我的殿宇。',
    '代下7:13 我若使天閉塞不下雨，或使蝗蟲吃這地的出產，或使瘟疫流行在我民中，',
    '代下7:14 這稱為我名下的子民，若是自卑、禱告，尋求我的面，轉離他們的惡行，我必從天上垂聽，赦免他們的罪，醫治他們的地。',
    '代下7:15 我必睜眼看、側耳聽在此處所獻的禱告。',
    '代下7:16 現在我已選擇這殿，分別為聖，使我的名永在其中，我的眼、我的心也必常在那裡。',
    '代下7:17 你若在我面前效法你父大衛所行的，遵行我一切所吩咐你的，謹守我的律例典章，',
    '代下7:18 我就必堅固你的國位，正如我與你父大衛所立的約，說：你的子孫必不斷人作以色列的王。',
    '代下7:19 倘若你們轉去丟棄我指示你們的律例誡命，去事奉敬拜別神，',
    '代下7:20 我就必將以色列人從我賜給他們的地上拔出根來，並且我為己名所分別為聖的殿也必捨棄不顧，使他在萬民中作笑談，被譏誚。',
    '代下7:21 這殿雖然甚高，將來經過的人必驚訝說：耶和華為何向這地和這殿如此行呢﹖',
    '代下7:22 人必回答說：是因此地的人離棄耶和華─他們列祖的神，就是領他們出埃及地的神，去親近別神，敬拜事奉他，所以耶和華使這一切災禍臨到他們。',
    '代下8:1 所羅門建造耶和華殿和王宮，二十年才完畢了。',
    '代下8:2 以後所羅門重新修築希蘭送給他的那些城邑，使以色列人住在那裡。',
    '代下8:3 所羅門往哈馬瑣巴去，攻取了那地方。',
    '代下8:4 所羅門建造曠野裡的達莫，又建造哈馬所有的積貨城，',
    '代下8:5 又建造上伯和崙、下伯和崙作為保障，都有牆，有門，有閂；',
    '代下8:6 又建造巴拉和所有的積貨城，並屯車輛馬兵的城，與耶路撒冷、利巴嫩，以及自己治理的全國中所願意建造的。',
    '代下8:7 至於國中所剩下不屬以色列人的赫人、亞摩利人、比利洗人、希未人、耶布斯人，',
    '代下8:8 就是以色列人未曾滅絕的，所羅門挑取他們的後裔作服苦的奴僕，直到今日。',
    '代下8:9 惟有以色列人，所羅門不使他們當奴僕做工，乃是作他的戰士、軍長的統領、車兵長、馬兵長。',
    '代下8:10 所羅門王有二百五十督工的，監管工人。',
    '代下8:11 所羅門將法老的女兒帶出大衛城，上到為他建造的宮裡；因所羅門說：耶和華約櫃所到之處都為聖地，所以我的妻不可住在以色列王大衛的宮裡。',
    '代下8:12 所羅門在耶和華的壇上，就是在廊子前他所築的壇上，與耶和華獻燔祭；',
    '代下8:13 又遵著摩西的吩咐在安息日、月朔，並一年三節，就是除酵節、七七節、住棚節，獻每日所當獻的祭。',
    '代下8:14 所羅門照著他父大衛所定的例，派定祭司的班次，使他們各供己事，又使利未人各盡其職，讚美耶和華，在祭司面前做每日所當做的；又派守門的按著班次看守各門，因為神人大衛是這樣吩咐的。',
    '代下8:15 王所吩咐眾祭司和利未人的，無論是管府庫或辦別的事，他們都不違背。',
    '代下8:16 所羅門建造耶和華的殿，從立根基直到成功的日子，工料俱備。這樣，耶和華的殿全然完畢。',
    '代下8:17 那時，所羅門往以東地靠海的以旬迦別和以祿去。',
    '代下8:18 希蘭差遣他的臣僕，將船隻和熟悉泛海的僕人送到所羅門那裡。他們同著所羅門的僕人到了俄斐，得了四百五十他連得金子，運到所羅門王那裡。',
    '代下9:1 示巴女王聽見所羅門的名聲，就來到耶路撒冷，要用難解的話試問所羅門；跟隨他的人甚多，又有駱駝馱著香料、寶石，和許多金子。他來見了所羅門，就把心裡所有的對所羅門都說出來。',
    '代下9:2 所羅門將他所問的都答上了，沒有一句不明白、不能答的。',
    '代下9:3 示巴女王見所羅門的智慧和他所建造的宮室、',
    '代下9:4 席上的珍饈美味、群臣分列而坐、僕人兩旁侍立，以及他們的衣服裝飾、酒政，和酒政的衣服裝飾，又見他上耶和華殿的臺階，就詫異得神不守舍，',
    '代下9:5 對王說：我在本國裡所聽見論到你的事和你的智慧實在是真的！',
    '代下9:6 我先不信那些話，及至我來親眼見了，才知道你的大智慧；人所告訴我的，還不到一半；你的實跡越過我所聽見的名聲。',
    '代下9:7 你的群臣、你的僕人常侍立在你面前聽你智慧的話是有福的。',
    '代下9:8 耶和華─你的神是應當稱頌的！他喜悅你，使你坐他的國位，為耶和華─你的神作王；因為你的神愛以色列人，要永遠堅立他們，所以立你作他們的王，使你秉公行義。',
    '代下9:9 於是示巴女王將一百二十他連得金子和寶石，與極多的香料送給所羅門王；他送給王的香料，以後再沒有這樣的。',
    '代下9:10 希蘭的僕人和所羅門的僕人從俄斐運了金子來，也運了檀香木【或作烏木；下同】和寶石來。',
    '代下9:11 王用檀香木為耶和華殿和王宮做臺，又為歌唱的人做琴瑟；猶大地從來沒有見過這樣的。',
    '代下9:12 所羅門王按示巴女王所帶來的，還他禮物，另外照他一切所要所求的，都送給他。於是女王和他臣僕轉回本國去了。',
    '代下9:13 所羅門每年所得的金子共有六百六十六他連得，',
    '代下9:14 另外還有商人所進的金子，並且亞拉伯諸王與屬國的省長都帶金銀給所羅門。',
    '代下9:15 所羅門王用錘出來的金子打成擋牌二百面，每面用金子六百舍客勒；',
    '代下9:16 又用錘出來的金子打成盾牌三百面，每面用金子三百舍客勒，都放在利巴嫩林宮裡。',
    '代下9:17 王用象牙製造一個大寶座，用精金包裹。',
    '代下9:18 寶座有六層臺階，又有金腳凳，與寶座相連。寶座兩旁有扶手，靠近扶手有兩個獅子站立。',
    '代下9:19 六層臺階上有十二個獅子站立，每層有兩個：左邊一個，右邊一個；在列國中沒有這樣做的。',
    '代下9:20 所羅門王一切的飲器都是金的，利巴嫩林宮裡的一切器皿都是精金的。所羅門年間，銀子算不了什麼。',
    '代下9:21 因為王的船隻與希蘭的僕人一同往他施去；他施船隻三年一次裝載金、銀、象牙、猿猴、孔雀回來。',
    '代下9:22 所羅門王的財寶與智慧勝過天下的列王。',
    '代下9:23 普天下的王都求見所羅門，要聽神賜給他智慧的話。',
    '代下9:24 他們各帶貢物，就是金器、銀器、衣服、軍械、香料、騾馬，每年有一定之例。',
    '代下9:25 所羅門有套車的馬四千棚，有馬兵一萬二千，安置在屯車的城邑和耶路撒冷，就是王那裡。',
    '代下9:26 所羅門統管諸王，從大河到非利士地，直到埃及的邊界。',
    '代下9:27 王在耶路撒冷使銀子多如石頭，香柏木多如高原的桑樹。',
    '代下9:28 有人從埃及和各國為所羅門趕馬群來。',
    '代下9:29 所羅門其餘的事，自始至終，不都寫在先知拿單的書上和示羅人亞希雅的預言書上，並先見易多論尼八兒子耶羅波安的默示書上嗎﹖',
    '代下9:30 所羅門在耶路撒冷作以色列眾人的王共四十年。',
    '代下9:31 所羅門與他列祖同睡，葬在他父大衛城裡。他兒子羅波安接續他作王。',
    '代下10:1 羅波安往示劍去，因為以色列人都到了示劍，要立他作王。',
    '代下10:2 尼八的兒子耶羅波安先前躲避所羅門王，逃往埃及，住在那裡；他聽見這事，就從埃及回來。',
    '代下10:3 以色列人打發人去請他，他就和以色列眾人來見羅波安，對他說：',
    '代下10:4 你父親使我們負重軛做苦工，現在求你使我們做的苦工負的重軛輕鬆些，我們就事奉你。',
    '代下10:5 羅波安對他們說：第三日再來見我吧！民就去了。',
    '代下10:6 羅波安之父所羅門在世的日子，有侍立在他面前的老年人，羅波安王和他們商議，說：你們給我出個什麼主意，我好回覆這民。',
    '代下10:7 老年人對他說：王若恩待這民，使他們喜悅，用好話回覆他們，他們就永遠作王的僕人。',
    '代下10:8 王卻不用老年人給他出的主意，就和那些與他一同長大、在他面前侍立的少年人商議，',
    '代下10:9 說：這民對我說：你父親使我們負重軛，求你使我們輕鬆些；你們給我出個什麼主意，我好回覆他們。',
    '代下10:10 那同他長大的少年人說：這民對王說：你父親使我們負重軛，求你使我們輕鬆些；王要對他們如此說：我的小拇指比我父親的腰還粗；',
    '代下10:11 我父親使你們負重軛，我必使你們負更重的軛；我父親用鞭子責打你們，我要用蠍子鞭責打你們。',
    '代下10:12 耶羅波安和眾百姓遵著羅波安王所說你們第三日再來見我的那話，第三日他們果然來了。',
    '代下10:13 羅波安王用嚴厲的話回覆他們，不用老年人所出的主意，',
    '代下10:14 照著少年人所出的主意對他們說：我父親使你們負重軛，我必使你們負更重的軛；我父親用鞭子責打你們，我要用蠍子鞭責打你們。',
    '代下10:15 王不肯依從百姓；這事乃出於神，為要應驗耶和華藉示羅人亞希雅對尼八兒子耶羅波安所說的話。',
    '代下10:16 以色列眾民見王不依從他們，就對王說：我們與大衛有什麼分兒呢﹖與耶西的兒子並沒有關涉！以色列人哪，各回各家去吧！大衛家啊，自己顧自己吧！於是，以色列眾人都回自己家裡去了。',
    '代下10:17 惟獨住在猶大城邑的以色列人，羅波安仍作他們的王。',
    '代下10:18 羅波安王差遣掌管服苦之人的哈多蘭往以色列人那裡去，以色列人就用石頭打死他。羅波安王急忙上車，逃回耶路撒冷去了。',
    '代下10:19 這樣，以色列人背叛大衛家，直到今日。',
    '代下11:1 羅波安來到耶路撒冷，招聚猶大家和便雅憫家，共十八萬人，都是挑選的戰士，要與以色列人爭戰，好將國奪回再歸自己。',
    '代下11:2 但耶和華的話臨到神人示瑪雅說：',
    '代下11:3 你去告訴所羅門的兒子猶大王羅波安和住猶大、便雅憫的以色列眾人說，',
    '代下11:4 耶和華如此說：你們不可上去與你們的弟兄爭戰，各歸各家去吧！因為這事出於我。眾人就聽從耶和華的話歸回，不去與耶羅波安爭戰。',
    '代下11:5 羅波安住在耶路撒冷，在猶大地修築城邑，',
    '代下11:6 為保障修築伯利恆、以坦、提哥亞、',
    '代下11:7 伯夙、梭哥、亞杜蘭、',
    '代下11:8 迦特、瑪利沙、西弗、',
    '代下11:9 亞多萊音、拉吉、亞西加、',
    '代下11:10 瑣拉、亞雅崙、希伯崙。這都是猶大和便雅憫的堅固城。',
    '代下11:11 羅波安又堅固各處的保障，在其中安置軍長，又預備下糧食、油、酒。',
    '代下11:12 他在各城裡預備盾牌和槍，且使城極其堅固。猶大和便雅憫都歸了他。',
    '代下11:13 以色列全地的祭司和利未人都從四方來歸羅波安。',
    '代下11:14 利未人撇下他們的郊野和產業，來到猶大與耶路撒冷，是因耶羅波安和他的兒子拒絕他們，不許他們供祭司職分事奉耶和華。',
    '代下11:15 耶羅波安為邱壇、為鬼魔【原文作公山羊】、為自己所鑄造的牛犢設立祭司。',
    '代下11:16 以色列各支派中，凡立定心意尋求耶和華─以色列神的，都隨從利未人，來到耶路撒冷祭祀耶和華─他們列祖的神。',
    '代下11:17 這樣，就堅固猶大國，使所羅門的兒子羅波安強盛三年，因為他們三年遵行大衛和所羅門的道。',
    '代下11:18 羅波安娶大衛兒子耶利摩的女兒瑪哈拉為妻，又娶耶西兒子以利押的女兒亞比孩為妻。',
    '代下11:19 從他生了幾個兒子，就是耶烏施、示瑪利雅、撒罕。',
    '代下11:20 後來又娶押沙龍的女兒瑪迦【十三章二節作烏列的女兒米該雅】，從他生了亞比雅、亞太、細撒、示羅密。',
    '代下11:21 羅波安娶十八個妻，立六十個妾，生二十八個兒子，六十個女兒；他卻愛押沙龍的女兒瑪迦，比愛別的妻妾更甚。',
    '代下11:22 羅波安立瑪迦的兒子亞比雅作太子，在他弟兄中為首，因為想要立他接續作王。',
    '代下11:23 羅波安辦事精明，使他眾子分散在猶大和便雅憫全地各堅固城裡，又賜他們許多糧食，為他們多尋妻子。',
    '代下12:1 羅波安的國堅立，他強盛的時候就離棄耶和華的律法，以色列人也都隨從他。',
    '代下12:2 羅波安王第五年，埃及王示撒上來攻打耶路撒冷，因為王和民得罪了耶和華。',
    '代下12:3 示撒帶戰車一千二百輛，馬兵六萬，並且跟從他出埃及的路比人、蘇基人，和古實人，多得不可勝數。',
    '代下12:4 他攻取了猶大的堅固城，就來到耶路撒冷。',
    '代下12:5 那時，猶大的首領因為示撒就聚集在耶路撒冷。有先知示瑪雅去見羅波安和眾首領，對他們說：耶和華如此說：你們離棄了我，所以我使你們落在示撒手裡。',
    '代下12:6 於是王和以色列的眾首領都自卑說：耶和華是公義的。',
    '代下12:7 耶和華見他們自卑，耶和華的話就臨到示瑪雅說：他們既自卑，我必不滅絕他們；必使他們略得拯救，我不藉著示撒的手將我的怒氣倒在耶路撒冷。',
    '代下12:8 然而他們必作示撒的僕人，好叫他們知道，服事我與服事外邦人有何分別。',
    '代下12:9 於是，埃及王示撒上來攻取耶路撒冷，奪了耶和華殿和王宮裡的寶物，盡都帶走，又奪去所羅門製造的金盾牌。',
    '代下12:10 羅波安王製造銅盾牌代替那金盾牌，交給守王宮門的護衛長看守。',
    '代下12:11 王每逢進耶和華的殿，護衛兵就拿這盾牌，隨後仍將盾牌送回，放在護衛房。',
    '代下12:12 王自卑的時候，耶和華的怒氣就轉消了，不將他滅盡，並且在猶大中間也有善益的事。',
    '代下12:13 羅波安王自強，在耶路撒冷作王。他登基的時候年四十一歲，在耶路撒冷，就是耶和華從以色列眾支派中所選擇立他名的城，作王十七年。羅波安的母親名叫拿瑪，是亞捫人。',
    '代下12:14 羅波安行惡，因他不立定心意尋求耶和華。',
    '代下12:15 羅波安所行的事，自始至終不都寫在先知示瑪雅和先見易多的史記上嗎﹖羅波安與耶羅波安時常爭戰。',
    '代下12:16 羅波安與他列祖同睡，葬在大衛城裡。他兒子亞比雅接續他作王。',
    '代下13:1 耶羅波安王十八年，亞比雅登基作猶大王，',
    '代下13:2 在耶路撒冷作王三年。他母親名叫米該亞【又作瑪迦】，是基比亞人烏列的女兒。亞比雅常與耶羅波安爭戰。',
    '代下13:3 有一次亞比雅率領挑選的兵四十萬擺陣，都是勇敢的戰士；耶羅波安也挑選大能的勇士八十萬，對亞比雅擺陣。',
    '代下13:4 亞比雅站在以法蓮山地中的洗瑪臉山上，說：耶羅波安和以色列眾人哪，要聽我說！',
    '代下13:5 耶和華─以色列的神曾立鹽【即不廢壞的意思】約，將以色列國永遠賜給大衛和他的子孫，你們不知道嗎﹖',
    '代下13:6 無奈大衛兒子所羅門的臣僕、尼八兒子耶羅波安起來背叛他的主人。',
    '代下13:7 有些無賴的匪徒聚集跟從他，逞強攻擊所羅門的兒子羅波安；那時羅波安還幼弱，不能抵擋他們。',
    '代下13:8 現在你們有意抗拒大衛子孫手下所治耶和華的國，你們的人也甚多，你們那裡又有耶羅波安為你們所造當作神的金牛犢。',
    '代下13:9 你們不是驅逐耶和華的祭司亞倫的後裔和利未人嗎﹖不是照著外邦人的惡俗為自己立祭司嗎﹖無論何人牽一隻公牛犢、七隻公綿羊將自己分別出來，就可作虛無之神的祭司。',
    '代下13:10 至於我們，耶和華是我們的神，我們並沒有離棄他。我們有事奉耶和華的祭司，都是亞倫的後裔，並有利未人各盡其職，',
    '代下13:11 每日早晚向耶和華獻燔祭，燒美香，又在精金的桌子上擺陳設餅；又有金燈臺和燈盞，每晚點起，因為我們遵守耶和華─我們神的命；惟有你們離棄了他。',
    '代下13:12 率領我們的是神，我們這裡也有神的祭司拿號向你們吹出大聲。以色列人哪，不要與耶和華─你們列祖的神爭戰，因你們必不能亨通。',
    '代下13:13 耶羅波安卻在猶大人的後頭設伏兵。這樣，以色列人在猶大人的前頭，伏兵在猶大人的後頭。',
    '代下13:14 猶大人回頭觀看，見前後都有敵兵，就呼求耶和華，祭司也吹號。',
    '代下13:15 於是猶大人吶喊；猶大人吶喊的時候，神就使耶羅波安和以色列眾人敗在亞比雅與猶大人面前。',
    '代下13:16 以色列人在猶大人面前逃跑，神將他們交在猶大人手裡。',
    '代下13:17 亞比雅和他的軍兵大大殺戮以色列人，以色列人仆倒死亡的精兵有五十萬。',
    '代下13:18 那時，以色列人被制伏了，猶大人得勝，是因倚靠耶和華─他們列祖的神。',
    '代下13:19 亞比雅追趕耶羅波安，攻取了他的幾座城，就是伯特利和屬伯特利的鎮市，耶沙拿和屬耶沙拿的鎮市，以法拉音【或作以弗倫】和屬以法拉音的鎮市。',
    '代下13:20 亞比雅在世的時候，耶羅波安不能再強盛；耶和華攻擊他，他就死了。',
    '代下13:21 亞比雅卻漸漸強盛，娶妻妾十四個，生了二十二個兒子，十六個女兒。',
    '代下13:22 亞比雅其餘的事和他的言行都寫在先知易多的傳上。',
    '代下14:1 亞比雅與他列祖同睡，葬在大衛城裡。他兒子亞撒接續他作王。亞撒年間，國中太平十年。',
    '代下14:2 亞撒行耶和華─他神眼中看為善為正的事，',
    '代下14:3 除掉外邦神的壇和邱壇，打碎柱像，砍下木偶，',
    '代下14:4 吩咐猶大人尋求耶和華─他們列祖的神，遵行他的律法、誡命；',
    '代下14:5 又在猶大各城邑除掉邱壇和日像，那時國享太平；',
    '代下14:6 又在猶大建造了幾座堅固城。國中太平數年，沒有戰爭，因為耶和華賜他平安。',
    '代下14:7 他對猶大人說：我們要建造這些城邑，四圍築牆，蓋樓，安門，做閂；地還屬我們，是因尋求耶和華─我們的神；我們既尋求他，他就賜我們四境平安。於是建造城邑，諸事亨通。',
    '代下14:8 亞撒的軍兵，出自猶大拿盾牌拿槍的三十萬人；出自便雅憫拿盾牌拉弓的二十八萬人。這都是大能的勇士。',
    '代下14:9 有古實王謝拉率領軍兵一百萬，戰車三百輛，出來攻擊猶大人，到了瑪利沙。',
    '代下14:10 於是亞撒出去與他迎敵，就在瑪利沙的洗法谷彼此擺陣。',
    '代下14:11 亞撒呼求耶和華─他的神說：耶和華啊，惟有你能幫助軟弱的，勝過強盛的。耶和華─我們的神啊，求你幫助我們；因為我們仰賴你，奉你的名來攻擊這大軍。耶和華啊，你是我們的神，不要容人勝過你。',
    '代下14:12 於是耶和華使古實人敗在亞撒和猶大人面前，古實人就逃跑了；',
    '代下14:13 亞撒和跟隨他的軍兵追趕他們，直到基拉耳。古實人被殺的甚多，不能再強盛，因為敗在耶和華與他軍兵面前。猶大人就奪了許多財物，',
    '代下14:14 又打破基拉耳四圍的城邑；耶和華使其中的人都甚恐懼。猶大人又將所有的城擄掠一空，因其中的財物甚多，',
    '代下14:15 又毀壞了群畜的圈，奪取許多的羊和駱駝，就回耶路撒冷去了。',
    '代下15:1 神的靈感動俄德的兒子亞撒利雅。',
    '代下15:2 他出來迎接亞撒，對他說：亞撒和猶大、便雅憫眾人哪，要聽我說：你們若順從耶和華，耶和華必與你們同在；你們若尋求他，就必尋見；你們若離棄他，他必離棄你們。',
    '代下15:3 以色列人不信真神，沒有訓誨的祭司，也沒有律法，已經好久了；',
    '代下15:4 但他們在急難的時候歸向耶和華─以色列的神，尋求他，他就被他們尋見。',
    '代下15:5 那時，出入的人不得平安，列國的居民都遭大亂；',
    '代下15:6 這國攻擊那國，這城攻擊那城，互相破壞，因為神用各樣災難擾亂他們。',
    '代下15:7 現在你們要剛強，不要手軟，因你們所行的必得賞賜。',
    '代下15:8 亞撒聽見這話和俄德兒子先知亞撒利雅的預言，就壯起膽來，在猶大、便雅憫全地，並以法蓮山地所奪的各城，將可憎之物盡都除掉，又在耶和華殿的廊前重新修築耶和華的壇；',
    '代下15:9 又招聚猶大、便雅憫的眾人，並他們中間寄居的以法蓮人、瑪拿西人、西緬人。有許多以色列人歸降亞撒，因見耶和華─他的神與他同在。',
    '代下15:10 亞撒十五年三月，他們都聚集在耶路撒冷。',
    '代下15:11 當日他們從所取的擄物中，將牛七百隻、羊七千隻獻給耶和華。',
    '代下15:12 他們就立約，要盡心盡性地尋求耶和華─他們列祖的神。',
    '代下15:13 凡不尋求耶和華─以色列神的，無論大小、男女，必被治死。',
    '代下15:14 他們就大聲歡呼，吹號吹角，向耶和華起誓。',
    '代下15:15 猶大眾人為所起的誓歡喜；因他們是盡心起誓，盡意尋求耶和華，耶和華就被他們尋見，且賜他們四境平安。',
    '代下15:16 亞撒王貶了他祖母瑪迦太后的位，因他造了可憎的偶像亞舍拉。亞撒砍下他的偶像，搗得粉碎，燒在汲淪溪邊。',
    '代下15:17 只是邱壇還沒有從以色列中廢去，然而亞撒的心一生誠實。',
    '代下15:18 亞撒將他父所分別為聖、與自己所分別為聖的金銀和器皿都奉到神的殿裡。',
    '代下15:19 從這時直到亞撒三十五年，都沒有爭戰的事。',
    '代下16:1 亞撒三十六年，以色列王巴沙上來攻擊猶大，修築拉瑪，不許人從猶大王亞撒那裡出入。',
    '代下16:2 於是亞撒從耶和華殿和王宮的府庫裡拿出金銀來，送與住大馬色的亞蘭王便哈達，說：',
    '代下16:3 你父曾與我父立約，我與你也要立約。現在我將金銀送給你，求你廢掉你與以色列王巴沙所立的約，使他離開我。',
    '代下16:4 便哈達聽從亞撒王的話，派軍長去攻擊以色列的城邑。他們就攻破以雲、但、亞伯瑪音，和拿弗他利一切的積貨城。',
    '代下16:5 巴沙聽見就停工，不修築拉瑪了。',
    '代下16:6 於是亞撒王率領猶大眾人，將巴沙修築拉瑪所用的石頭、木頭都運去，用以修築迦巴和米斯巴。',
    '代下16:7 那時，先見哈拿尼來見猶大王亞撒，對他說：因你仰賴亞蘭王，沒有仰賴耶和華─你的神，所以亞蘭王的軍兵脫離了你的手。',
    '代下16:8 古實人、路比人的軍隊不是甚大嗎﹖戰車馬兵不是極多嗎﹖只因你仰賴耶和華，他便將他們交在你手裡。',
    '代下16:9 耶和華的眼目遍察全地，要顯大能幫助向他心存誠實的人。你這事行得愚昧；此後，你必有爭戰的事。',
    '代下16:10 亞撒因此惱恨先見，將他囚在監裡。那時亞撒也虐待一些人民。',
    '代下16:11 亞撒所行的事，自始至終都寫在猶大和以色列諸王記上。',
    '代下16:12 亞撒作王三十九年，他腳上有病，而且甚重。病的時候沒有求耶和華，只求醫生。',
    '代下16:13 他作王四十一年而死，與他列祖同睡，',
    '代下16:14 葬在大衛城自己所鑿的墳墓裡，放在床上，其床堆滿各樣馨香的香料，就是按做香的作法調和的香料，又為他燒了許多的物件。',
    '代下17:1 亞撒的兒子約沙法接續他作王，奮勇自強，防備以色列人，',
    '代下17:2 安置軍兵在猶大一切堅固城裡，又安置防兵在猶大地和他父亞撒所得以法蓮的城邑中。',
    '代下17:3 耶和華與約沙法同在；因為他行他祖大衛初行的道，不尋求巴力，',
    '代下17:4 只尋求他父親的神，遵行他的誡命，不效法以色列人的行為。',
    '代下17:5 所以耶和華堅定他的國，猶大眾人給他進貢；約沙法大有尊榮資財。',
    '代下17:6 他高興遵行耶和華的道，並且從猶大除掉一切邱壇和木偶。',
    '代下17:7 他作王第三年，就差遣臣子便亥伊勒、俄巴底、撒迦利雅、拿坦業、米該亞往猶大各城去教訓百姓。',
    '代下17:8 同著他們有利未人示瑪雅、尼探雅、西巴第雅、亞撒黑、示米拉末、約拿單、亞多尼雅、多比雅、駝巴多尼雅，又有祭司以利沙瑪、約蘭同著他們。',
    '代下17:9 他們帶著耶和華的律法書，走遍猶大各城教訓百姓。',
    '代下17:10 耶和華使猶大四圍的列國都甚恐懼，不敢與約沙法爭戰。',
    '代下17:11 有些非利士人與約沙法送禮物，納貢銀。亞拉伯人也送他公綿羊七千七百隻，公山羊七千七百隻。',
    '代下17:12 約沙法日漸強大，在猶大建造營寨和積貨城。',
    '代下17:13 他在猶大城邑中有許多工程，又在耶路撒冷有戰士，就是大能的勇士。',
    '代下17:14 他們的數目，按著宗族，記在下面：猶大族的，千夫長押拿為首率領大能的勇士─三十萬；',
    '代下17:15 其次是，千夫長約哈難率領大能的勇士─二十八萬；',
    '代下17:16 其次是，細基利的兒子亞瑪斯雅（他為耶和華犧牲自己）率領大能的勇士─二十萬。',
    '代下17:17 便雅憫族，是大能的勇士以利雅大率領，拿弓箭和盾牌的─二十萬；',
    '代下17:18 其次是，約薩拔率領預備打仗的─十八萬。',
    '代下17:19 這都是伺候王的，還有王在猶大全地堅固城所安置的不在其內。',
    '代下18:1 約沙法大有尊榮資財，就與亞哈結親。',
    '代下18:2 過了幾年，他下到撒瑪利亞去見亞哈；亞哈為他和跟從他的人宰了許多牛羊，勸他與自己同去攻取基列的拉末。',
    '代下18:3 以色列王亞哈問猶大王約沙法說：你肯同我去攻取基列的拉末嗎﹖他回答說：你我不分彼此，我的民與你的民一樣，必與你同去爭戰。',
    '代下18:4 約沙法對以色列王說：請你先求問耶和華。',
    '代下18:5 於是以色列王招聚先知四百人，問他們說：我們上去攻取基列的拉末可以不可以﹖他們說：可以上去，因為神必將那城交在王的手裡。',
    '代下18:6 約沙法說：這裡不是還有耶和華的先知，我們可以求問他嗎﹖',
    '代下18:7 以色列王對約沙法說：還有一個人，是音拉的兒子米該雅。我們可以託他求問耶和華，只是我恨他；因為他指著我所說的預言，不說吉語，常說凶言。約沙法說：王不必這樣說。',
    '代下18:8 以色列王就召了一個太監來，說：你快去將音拉的兒子米該雅召來。',
    '代下18:9 以色列王和猶大王約沙法在撒瑪利亞城門前的空場上，各穿朝服坐在位上，所有的先知都在他們面前說預言。',
    '代下18:10 基拿拿的兒子西底家造了兩個鐵角，說：耶和華如此說：你要用這角牴觸亞蘭人，直到將他們滅盡。',
    '代下18:11 所有的先知也都這樣預言說：可以上基列的拉末去，必然得勝，因為耶和華必將那城交在王的手中。',
    '代下18:12 那去召米該雅的使者對米該雅說：眾先知一口同音地都向王說吉言，你不如與他們說一樣的話，也說吉言。',
    '代下18:13 米該雅說：我指著永生的耶和華起誓，我的神說什麼，我就說什麼。',
    '代下18:14 米該雅到王面前，王問他說：米該雅啊，我們上去攻取基列的拉末可以不可以﹖他說：可以上去，必然得勝，敵人必交在你們手裡。',
    '代下18:15 王對他說：我當囑咐你幾次，你才奉耶和華的名向我說實話呢﹖',
    '代下18:16 米該雅說：我看見以色列眾民散在山上，如同沒有牧人的羊群一般。耶和華說：這民沒有主人，他們可以平平安安地各歸各家去。',
    '代下18:17 以色列王對約沙法說：我豈沒有告訴你，這人指著我所說的預言，不說吉語，單說凶言嗎﹖',
    '代下18:18 米該雅說：你們要聽耶和華的話。我看見耶和華坐在寶座上，天上的萬軍侍立在他左右。',
    '代下18:19 耶和華說：誰去引誘以色列王亞哈上基列的拉末去陣亡呢﹖這個就這樣說，那個就那樣說。',
    '代下18:20 隨後，有一個神靈出來，站在耶和華面前說：我去引誘他。耶和華問他說：你用何法呢﹖',
    '代下18:21 他說：我去，要在他眾先知口中作謊言的靈。耶和華說：這樣，你必能引誘他，你去如此行吧！',
    '代下18:22 現在耶和華使謊言的靈入了你這些先知的口，並且耶和華已經命定降禍與你。',
    '代下18:23 基拿拿的兒子西底家前來打米該雅的臉，說：耶和華的靈從哪裡離開我與你說話呢﹖',
    '代下18:24 米該雅說：你進嚴密的屋子藏躲的那日，就必看見了。',
    '代下18:25 以色列王說：將米該雅帶回，交給邑宰亞們和王的兒子約阿施，說：',
    '代下18:26 王如此說：把這個人下在監裡，使他受苦，吃不飽喝不足，等候我平平安安地回來。',
    '代下18:27 米該雅說：你若能平安回來，那就是耶和華沒有藉我說這話了；又說：眾民哪，你們都要聽！',
    '代下18:28 以色列王和猶大王約沙法上基列的拉末去了。',
    '代下18:29 以色列王對約沙法說：我要改裝上陣，你可以仍穿王服。於是以色列王改裝，他們就上陣去了。',
    '代下18:30 先是亞蘭王吩咐車兵長說：他們的兵將，無論大小，你們都不可與他們爭戰，只要與以色列王爭戰。',
    '代下18:31 車兵長看見約沙法便說，這必是以色列王，就轉過去與他爭戰。約沙法一呼喊，耶和華就幫助他，神又感動他們離開他。',
    '代下18:32 車兵長見不是以色列王，就轉去不追他了。',
    '代下18:33 有一人隨便開弓，恰巧射入以色列王的甲縫裡。王對趕車的說：我受了重傷，你轉過車來，拉我出陣吧！',
    '代下18:34 那日陣勢越戰越猛，以色列王勉強站在車上抵擋亞蘭人，直到晚上。約在日落的時候，王就死了。',
    '代下19:1 猶大王約沙法平平安安地回耶路撒冷，到宮裡去了。',
    '代下19:2 先見哈拿尼的兒子耶戶出來迎接約沙法王，對他說：你豈當幫助惡人，愛那恨惡耶和華的人呢﹖因此耶和華的忿怒臨到你。',
    '代下19:3 然而你還有善行，因你從國中除掉木偶，立定心意尋求神。',
    '代下19:4 約沙法住在耶路撒冷，以後又出巡民間，從別是巴直到以法蓮山地，引導民歸向耶和華─他們列祖的神；',
    '代下19:5 又在猶大國中遍地的堅固城裡設立審判官，',
    '代下19:6 對他們說：你們辦事應當謹慎；因為你們判斷不是為人，乃是為耶和華。判斷的時候，他必與你們同在。',
    '代下19:7 現在你們應當敬畏耶和華，謹慎辦事；因為耶和華─我們的神沒有不義，不偏待人，也不受賄賂。',
    '代下19:8 約沙法從利未人和祭司，並以色列族長中派定人，在耶路撒冷為耶和華判斷，聽民間的爭訟，就回耶路撒冷去了。',
    '代下19:9 約沙法囑咐他們說：你們當敬畏耶和華，忠心誠實辦事。',
    '代下19:10 住在各城裡你們的弟兄，若有爭訟的事來到你們這裡，或為流血，或犯律法、誡命、律例、典章，你們要警戒他們，免得他們得罪耶和華，以致他的忿怒臨到你們和你們的弟兄；這樣行，你們就沒有罪了。',
    '代下19:11 凡屬耶和華的事，有大祭司亞瑪利雅管理你們；凡屬王的事，有猶大支派的族長以實瑪利的兒子西巴第雅管理你們；在你們面前有利未人作官長。你們應當壯膽辦事，願耶和華與善人同在。',
    '代下20:1 此後，摩押人和亞捫人，又有米烏尼人，一同來攻擊約沙法。',
    '代下20:2 有人來報告約沙法說：從海外亞蘭【又作以東】那邊有大軍來攻擊你，如今他們在哈洗遜他瑪，就是隱基底。',
    '代下20:3 約沙法便懼怕，定意尋求耶和華，在猶大全地宣告禁食。',
    '代下20:4 於是猶大人聚會，求耶和華幫助。猶大各城都有人出來尋求耶和華。',
    '代下20:5 約沙法就在猶大和耶路撒冷的會中，站在耶和華殿的新院前，',
    '代下20:6 說：耶和華─我們列祖的神啊，你不是天上的神嗎﹖你不是萬邦萬國的主宰嗎﹖在你手中有大能大力，無人能抵擋你。',
    '代下20:7 我們的神啊，你不是曾在你民以色列人面前驅逐這地的居民，將這地賜給你朋友亞伯拉罕的後裔永遠為業嗎﹖',
    '代下20:8 他們住在這地，又為你的名建造聖所，說：',
    '代下20:9 倘有禍患臨到我們，或刀兵災殃，或瘟疫饑荒，我們在急難的時候，站在這殿前向你呼求，你必垂聽而拯救，因為你的名在這殿裡。',
    '代下20:10 從前以色列人出埃及地的時候，你不容以色列人侵犯亞捫人、摩押人，和西珥山人，以色列人就離開他們，不滅絕他們。',
    '代下20:11 看哪，他們怎樣報復我們，要來驅逐我們出離你的地，就是你賜給我們為業之地。',
    '代下20:12 我們的神啊，你不懲罰他們嗎﹖因為我們無力抵擋這來攻擊我們的大軍，我們也不知道怎樣行，我們的眼目單仰望你。',
    '代下20:13 猶大眾人和他們的嬰孩、妻子、兒女都站在耶和華面前。',
    '代下20:14 那時，耶和華的靈在會中臨到利未人亞薩的後裔─瑪探雅的玄孫，耶利的曾孫，比拿雅的孫子，撒迦利雅的兒子雅哈悉。',
    '代下20:15 他說：猶大眾人、耶路撒冷的居民，和約沙法王，你們請聽。耶和華對你們如此說：不要因這大軍恐懼驚惶；因為勝敗不在乎你們，乃在乎神。',
    '代下20:16 明日你們要下去迎敵，他們是從洗斯坡上來，你們必在耶魯伊勒曠野前的谷口遇見他們。',
    '代下20:17 猶大和耶路撒冷人哪，這次你們不要爭戰，要擺陣站著，看耶和華為你們施行拯救。不要恐懼，也不要驚惶。明日當出去迎敵，因為耶和華與你們同在。',
    '代下20:18 約沙法就面伏於地，猶大眾人和耶路撒冷的居民也俯伏在耶和華面前，叩拜耶和華。',
    '代下20:19 哥轄族和可拉族的利未人都起來，用極大的聲音讚美耶和華以色列的神。',
    '代下20:20 次日清早，眾人起來往提哥亞的曠野去。出去的時候，約沙法站著說：猶大人和耶路撒冷的居民哪，要聽我說：信耶和華─你們的神就必立穩；信他的先知就必亨通。',
    '代下20:21 約沙法既與民商議了，就設立歌唱的人，頌讚耶和華，使他們穿上聖潔的禮服，走在軍前讚美耶和華說：當稱謝耶和華，因他的慈愛永遠長存！',
    '代下20:22 眾人方唱歌讚美的時候，耶和華就派伏兵擊殺那來攻擊猶大人的亞捫人、摩押人，和西珥山人，他們就被打敗了。',
    '代下20:23 因為亞捫人和摩押人起來，擊殺住西珥山的人，將他們滅盡；滅盡住西珥山的人之後，他們又彼此自相擊殺。',
    '代下20:24 猶大人來到曠野的望樓，向那大軍觀看，見屍橫遍地，沒有一個逃脫的。',
    '代下20:25 約沙法和他的百姓就來收取敵人的財物，在屍首中見了許多財物、珍寶，他們剝脫下來的多得不可攜帶；因為甚多，直收取了三日。',
    '代下20:26 第四日眾人聚集在比拉迦谷【就是稱頌的意思】，在那裡稱頌耶和華。因此那地方名叫比拉迦谷，直到今日。',
    '代下20:27 猶大人和耶路撒冷人都歡歡喜喜地回耶路撒冷，約沙法率領他們；因為耶和華使他們戰勝仇敵，就歡喜快樂。',
    '代下20:28 他們彈琴、鼓瑟、吹號來到耶路撒冷，進了耶和華的殿。',
    '代下20:29 列邦諸國聽見耶和華戰敗以色列的仇敵，就甚懼怕。',
    '代下20:30 這樣，約沙法的國得享太平，因為神賜他四境平安。',
    '代下20:31 約沙法作猶大王，登基的時候年三十五歲，在耶路撒冷作王二十五年。他母親名叫阿蘇巴，乃示利希的女兒。',
    '代下20:32 約沙法效法他父亞撒所行的，不偏左右，行耶和華眼中看為正的事。',
    '代下20:33 只是邱壇還沒有廢去，百姓也沒有立定心意歸向他們列祖的神。',
    '代下20:34 約沙法其餘的事，自始至終都寫在哈拿尼的兒子耶戶的書上，也載入以色列諸王記上。',
    '代下20:35 此後，猶大王約沙法與以色列王亞哈謝交好；亞哈謝行惡太甚。',
    '代下20:36 二王合夥造船要往他施去，遂在以旬迦別造船。',
    '代下20:37 那時瑪利沙人、多大瓦的兒子以利以謝向約沙法預言說：因你與亞哈謝交好，耶和華必破壞你所造的。後來那船果然破壞，不能往他施去了。',
    '代下21:1 約沙法與他列祖同睡，葬在大衛城他列祖的墳地裡。他兒子約蘭接續他作王。',
    '代下21:2 約蘭有幾個兄弟，就是約沙法的兒子亞撒利雅、耶歇、撒迦利雅、亞撒利雅、米迦勒、示法提雅。這都是猶大王約沙法的兒子。',
    '代下21:3 他們的父親將許多金銀、財寶，和猶大地的堅固城賜給他們；但將國賜給約蘭，因為他是長子。',
    '代下21:4 約蘭興起坐他父的位，奮勇自強，就用刀殺了他的眾兄弟和以色列的幾個首領。',
    '代下21:5 約蘭登基的時候年三十二歲，在耶路撒冷作王八年。',
    '代下21:6 他行以色列諸王的道，與亞哈家一樣；因他娶了亞哈的女兒為妻，行耶和華眼中看為惡的事。',
    '代下21:7 耶和華卻因自己與大衛所立的約，不肯滅大衛的家，照他所應許的，永遠賜燈光與大衛和他的子孫。',
    '代下21:8 約蘭年間，以東人背叛猶大，脫離他的權下，自己立王。',
    '代下21:9 約蘭就率領軍長和所有的戰車，夜間起來，攻擊圍困他的以東人和車兵長。',
    '代下21:10 這樣，以東人背叛猶大，脫離他的權下，直到今日。那時，立拿人也背叛了，因為約蘭離棄耶和華─他列祖的神。',
    '代下21:11 他又在猶大諸山建築邱壇，使耶路撒冷的居民行邪淫，誘惑猶大人。',
    '代下21:12 先知以利亞達信與約蘭說：耶和華─你祖大衛的神如此說：因為你不行你父約沙法和猶大王亞撒的道，',
    '代下21:13 乃行以色列諸王的道，使猶大人和耶路撒冷的居民行邪淫，像亞哈家一樣，又殺了你父家比你好的諸兄弟。',
    '代下21:14 故此，耶和華降大災與你的百姓和你的妻子、兒女，並你一切所有的。',
    '代下21:15 你的腸子必患病，日加沉重，以致你的腸子墜落下來。',
    '代下21:16 以後，耶和華激動非利士人和靠近古實的亞拉伯人來攻擊約蘭。',
    '代下21:17 他們上來攻擊猶大，侵入境內，擄掠了王宮裡所有的財貨和他的妻子、兒女，除了他小兒子約哈斯【又名亞哈謝】之外，沒有留下一個兒子。',
    '代下21:18 這些事以後，耶和華使約蘭的腸子患不能醫治的病。',
    '代下21:19 他患此病纏綿日久，過了二年，腸子墜落下來，病重而死。他的民沒有為他燒什麼物件，像從前為他列祖所燒的一樣。',
    '代下21:20 約蘭登基的時候年三十二歲，在耶路撒冷作王八年。他去世無人思慕，眾人葬他在大衛城，只是不在列王的墳墓裡。',
    '代下22:1 耶路撒冷的居民立約蘭的小兒子亞哈謝接續他作王；因為跟隨亞拉伯人來攻營的軍兵曾殺了亞哈謝的眾兄長。這樣，猶大王約蘭的兒子亞哈謝作了王。',
    '代下22:2 亞哈謝登基的時候年四十二歲【王下八26作二十二歲】，在耶路撒冷作王一年。他母親名叫亞他利雅，是暗利的孫女。',
    '代下22:3 亞哈謝也行亞哈家的道；因為他母親給他主謀，使他行惡。',
    '代下22:4 他行耶和華眼中看為惡的事，像亞哈家一樣；因他父親死後有亞哈家的人給他主謀，以致敗壞。',
    '代下22:5 他聽從亞哈家的計謀，同以色列王亞哈的兒子約蘭往基列的拉末去，與亞蘭王哈薛爭戰；亞蘭人打傷了約蘭。',
    '代下22:6 約蘭回到耶斯列，醫治在拉末與亞蘭王哈薛打仗所受的傷，猶大王約蘭的兒子亞撒利雅【即亞哈謝】因為亞哈的兒子約蘭病了，就下到耶斯列看望他。',
    '代下22:7 亞哈謝去見約蘭就被害了，這是出乎神；因為他到了，就同約蘭出去攻擊寧示的孫子耶戶。這耶戶是耶和華所膏、使他剪除亞哈家的。',
    '代下22:8 耶戶討亞哈家罪的時候，遇見猶大的眾首領和亞哈謝的眾姪子服事亞哈謝，就把他們都殺了。',
    '代下22:9 亞哈謝藏在撒瑪利亞，耶戶尋找他，眾人將他拿住，送到耶戶那裡，就殺了他，將他葬埋；因他們說，他是那盡心尋求耶和華之約沙法的兒子。這樣，亞哈謝的家無力保守國權。',
    '代下22:10 亞哈謝的母親亞他利雅見他兒子死了，就起來剿滅猶大王室。',
    '代下22:11 但王的女兒約示巴將亞哈謝的兒子約阿施從那被殺的王子中偷出來，把他和他的乳母都藏在臥房裡。約示巴是約蘭王的女兒，亞哈謝的妹子，祭司耶何耶大的妻。他收藏約阿施，躲避亞他利雅，免得被殺。',
    '代下22:12 約阿施和他們一同藏在神殿裡六年；亞他利雅篡了國位。',
    '代下23:1 第七年，耶何耶大奮勇自強，將百夫長耶羅罕的兒子亞撒利雅，約哈難的兒子以實瑪利，俄備得的兒子亞撒利雅，亞大雅的兒子瑪西雅，細基利的兒子以利沙法召來，與他們立約。',
    '代下23:2 他們走遍猶大，從猶大各城裡招聚利未人和以色列的眾族長到耶路撒冷來。',
    '代下23:3 會眾在神殿裡與王立約。耶何耶大對他們說：看哪，王的兒子必當作王，正如耶和華指著大衛子孫所應許的話；',
    '代下23:4 又說：你們當這樣行：祭司和利未人凡安息日進班的，三分之一要把守各門，',
    '代下23:5 三分之一要在王宮，三分之一要在基址門；眾百姓要在耶和華殿的院內。',
    '代下23:6 除了祭司和供職的利未人之外，不准別人進耶和華的殿；惟獨他們可以進去，因為他們聖潔。眾百姓要遵守耶和華所吩咐的。',
    '代下23:7 利未人要手中各拿兵器，四圍護衛王；凡擅入殿宇的，必當治死。王出入的時候，你們當跟隨他。',
    '代下23:8 利未人和猶大眾人都照著祭司耶何耶大一切所吩咐的去行，各帶所管安息日進班出班的人來，因為祭司耶何耶大不許他們下班。',
    '代下23:9 祭司耶何耶大便將神殿裡所藏大衛王的槍、盾牌、擋牌交給百夫長，',
    '代下23:10 又分派眾民手中各拿兵器，在壇和殿那裡，從殿右直到殿左，站在王子的四圍；',
    '代下23:11 於是領王子出來，給他戴上冠冕，將律法書交給他，立他作王。耶何耶大和眾子膏他，眾人說：願王萬歲！',
    '代下23:12 亞他利雅聽見民奔走讚美王的聲音，就到民那裡，進耶和華的殿，',
    '代下23:13 看見王站在殿門的柱旁，百夫長和吹號的人侍立在王左右，國民都歡樂吹號，又有歌唱的，用各樣的樂器領人歌唱讚美；亞他利雅就撕裂衣服，喊叫說：反了！反了！',
    '代下23:14 祭司耶何耶大帶管轄軍兵的百夫長出來，吩咐他們說：將他趕到班外，凡跟隨他的必用刀殺死！因為祭司說：不可在耶和華殿裡殺他。',
    '代下23:15 眾兵就閃開，讓他去；他走到王宮的馬門，便在那裡把他殺了。',
    '代下23:16 耶何耶大與眾民和王立約，都要作耶和華的民。',
    '代下23:17 於是眾民都到巴力廟，拆毀了廟，打碎壇和像，又在壇前將巴力的祭司瑪坦殺了。',
    '代下23:18 耶何耶大派官看守耶和華的殿，是在祭司利未人手下。這祭司利未人是大衛分派在耶和華殿中、照摩西律法上所寫的，給耶和華獻燔祭，又按大衛所定的例，歡樂歌唱；',
    '代下23:19 且設立守門的把守耶和華殿的各門，無論為何事，不潔淨的人都不准進去。',
    '代下23:20 又率領百夫長和貴冑，與民間的官長，並國中的眾民，請王從耶和華殿下來，由上門進入王宮，立王坐在國位上。',
    '代下23:21 國民都歡樂，合城都安靜。眾人已將亞他利雅用刀殺了。',
    '代下24:1 約阿施登基的時候年七歲，在耶路撒冷作王四十年。他母親名叫西比亞，是別是巴人。',
    '代下24:2 祭司耶何耶大在世的時候，約阿施行耶和華眼中看為正的事。',
    '代下24:3 耶何耶大為他娶了兩個妻，並且生兒養女。',
    '代下24:4 此後，約阿施有意重修耶和華的殿，',
    '代下24:5 便召聚眾祭司和利未人，吩咐他們說：你們要往猶大各城去，使以色列眾人捐納銀子，每年可以修理你們神的殿；你們要急速辦理這事。只是利未人不急速辦理。',
    '代下24:6 王召了大祭司耶何耶大來，對他說：從前耶和華的僕人摩西，為法櫃的帳幕與以色列會眾所定的捐項，你為何不叫利未人照這例從猶大和耶路撒冷帶來作殿的費用呢﹖',
    '代下24:7 （因為那惡婦亞他利雅的眾子曾拆毀神的殿，又用耶和華殿中分別為聖的物供奉巴力。）',
    '代下24:8 於是王下令，眾人做了一櫃，放在耶和華殿的門外，',
    '代下24:9 又通告猶大和耶路撒冷的百姓，要將神僕人摩西在曠野所吩咐以色列人的捐項給耶和華送來。',
    '代下24:10 眾首領和百姓都歡歡喜喜地將銀子送來，投入櫃中，直到捐完。',
    '代下24:11 利未人見銀子多了，就把櫃擡到王所派的司事面前；王的書記和大祭司的屬員來將櫃倒空，仍放在原處。日日都是這樣，積蓄的銀子甚多。',
    '代下24:12 王與耶何耶大將銀子交給耶和華殿裡辦事的人，他們就雇了石匠、木匠重修耶和華的殿，又雇了鐵匠、銅匠修理耶和華的殿。',
    '代下24:13 工人操作，漸漸修成，將神殿修造得與從前一樣，而且甚是堅固。',
    '代下24:14 工程完了，他們就把其餘的銀子拿到王與耶何耶大面前，用以製造耶和華殿供奉所用的器皿和調羹，並金銀的器皿。耶何耶大在世的時候，眾人常在耶和華殿裡獻燔祭。',
    '代下24:15 耶何耶大年紀老邁，日子滿足而死。死的時候年一百三十歲，',
    '代下24:16 葬在大衛城列王的墳墓裡；因為他在以色列人中行善，又事奉神，修理神的殿。',
    '代下24:17 耶何耶大死後，猶大的眾首領來朝拜王；王就聽從他們。',
    '代下24:18 他們離棄耶和華─他們列祖神的殿，去事奉亞舍拉和偶像；因他們這罪，就有忿怒臨到猶大和耶路撒冷。',
    '代下24:19 但神仍遣先知到他們那裡，引導他們歸向耶和華。這先知警戒他們，他們卻不肯聽。',
    '代下24:20 那時，神的靈感動祭司耶何耶大的兒子撒迦利亞，他就站在上面對民說：神如此說：你們為何干犯耶和華的誡命，以致不得亨通呢﹖因為你們離棄耶和華，所以他也離棄你們。',
    '代下24:21 眾民同心謀害撒迦利亞，就照王的吩咐，在耶和華殿的院內用石頭打死他。',
    '代下24:22 這樣，約阿施王不想念撒迦利亞的父親耶何耶大向自己所施的恩，殺了他的兒子。撒迦利亞臨死的時候說：願耶和華鑒察伸冤！',
    '代下24:23 滿了一年，亞蘭的軍兵上來攻擊約阿施，來到猶大和耶路撒冷，殺了民中的眾首領，將所掠的財貨送到大馬色王那裡。',
    '代下24:24 亞蘭的軍兵雖來了一小隊，耶和華卻將大隊的軍兵交在他們手裡，是因猶大人離棄耶和華─他們列祖的神，所以藉亞蘭人懲罰約阿施。',
    '代下24:25 亞蘭人離開約阿施的時候，他患重病；臣僕背叛他，要報祭司耶何耶大兒子流血之仇，殺他在床上，葬他在大衛城，只是不葬在列王的墳墓裡。',
    '代下24:26 背叛他的是亞捫婦人示米押的兒子撒拔和摩押婦人示米利的兒子約薩拔。',
    '代下24:27 至於他的眾子和他所受的警戒，並他重修神殿的事，都寫在列王的傳上。他兒子亞瑪謝接續他作王。',
    '代下25:1 亞瑪謝登基的時候年二十五歲，在耶路撒冷作王二十九年。他母親名叫約耶但，是耶路撒冷人。',
    '代下25:2 亞瑪謝行耶和華眼中看為正的事，只是心不專誠。',
    '代下25:3 國一堅定，就把殺他父王的臣僕殺了，',
    '代下25:4 卻沒有治死他們的兒子，是照摩西律法書上耶和華所吩咐的說：不可因子殺父，也不可因父殺子，各人要為本身的罪而死。',
    '代下25:5 亞瑪謝招聚猶大人，按著猶大和便雅憫的宗族設立千夫長、百夫長，又數點人數，從二十歲以外，能拿槍拿盾牌出去打仗的精兵共有三十萬；',
    '代下25:6 又用銀子一百他連得，從以色列招募了十萬大能的勇士。',
    '代下25:7 有一個神人來見亞瑪謝，對他說：王啊，不要使以色列的軍兵與你同去，因為耶和華不與以色列人以法蓮的後裔同在。',
    '代下25:8 你若一定要去，就奮勇爭戰吧！但神必使你敗在敵人面前；因為神能助人得勝，也能使人傾敗。',
    '代下25:9 亞瑪謝問神人說：我給了以色列軍的那一百他連得銀子怎麼樣呢﹖神人回答說：耶和華能把更多的賜給你。',
    '代下25:10 於是亞瑪謝將那從以法蓮來的軍兵分別出來，叫他們回家去。故此，他們甚惱怒猶大人，氣忿忿地回家去了。',
    '代下25:11 亞瑪謝壯起膽來，率領他的民到鹽谷，殺了西珥人一萬。',
    '代下25:12 猶大人又生擒了一萬帶到山崖上，從那裡把他們扔下去，以致他們都摔碎了。',
    '代下25:13 但亞瑪謝所打發回去、不許一同出征的那些軍兵攻打猶大各城，從撒瑪利亞直到伯和崙，殺了三千人，搶了許多財物。',
    '代下25:14 亞瑪謝殺了以東人回來，就把西珥的神像帶回，立為自己的神，在他面前叩拜燒香。',
    '代下25:15 因此，耶和華的怒氣向亞瑪謝發作，就差一個先知去見他，說：這些神不能救他的民脫離你的手，你為何尋求他呢﹖',
    '代下25:16 先知與王說話的時候，王對他說：誰立你作王的謀士呢﹖你住口吧！為何找打呢﹖先知就止住了，又說：你行這事，不聽從我的勸戒，我知道神定意要滅你。',
    '代下25:17 猶大王亞瑪謝與群臣商議，就差遣使者去見耶戶的孫子、約哈斯的兒子、以色列王約阿施，說：你來，我們二人相見於戰場。',
    '代下25:18 以色列王約阿施差遣使者去見猶大王亞瑪謝，說：利巴嫩的蒺藜差遣使者去見利巴嫩的香柏樹，說：將你的女兒給我兒子為妻。後來利巴嫩有一個野獸經過，把蒺藜踐踏了。',
    '代下25:19 你說：看哪，我打敗了以東人，你就心高氣傲，以致矜誇。你在家裡安居就罷了，為何要惹禍使自己和猶大國一同敗亡呢﹖',
    '代下25:20 亞瑪謝卻不肯聽從。這是出乎神，好將他們交在敵人手裡，因為他們尋求以東的神。',
    '代下25:21 於是以色列王約阿施上來，在猶大的伯示麥與猶大王亞瑪謝相見於戰場。',
    '代下25:22 猶大人敗在以色列人面前，各自逃回家裡去了。',
    '代下25:23 以色列王約阿施在伯示麥擒住約哈斯【就是亞哈謝】的孫子、約阿施的兒子、猶大王亞瑪謝，將他帶到耶路撒冷，又拆毀耶路撒冷的城牆，從以法蓮門直到角門，共四百肘；',
    '代下25:24 又將俄別以東所看守神殿裡的一切金銀和器皿，與王宮裡的財寶都拿了去，並帶人去為質，就回撒瑪利亞去了。',
    '代下25:25 以色列王約哈斯的兒子約阿施死後，猶大王約阿施的兒子亞瑪謝又活了十五年。',
    '代下25:26 亞瑪謝其餘的事，自始至終不都寫在猶大和以色列諸王記上嗎﹖',
    '代下25:27 自從亞瑪謝離棄耶和華之後，在耶路撒冷有人背叛他，他就逃到拉吉；叛黨卻打發人到拉吉，將他殺了。',
    '代下25:28 人就用馬將他的屍首馱回，葬在猶大京城他列祖的墳地裡。',
    '代下26:1 猶大眾民立亞瑪謝的兒子烏西雅【又名亞撒利雅】接續他父作王，那時他年十六歲。',
    '代下26:2 （亞瑪謝與他列祖同睡之後，烏西雅收回以祿仍歸猶大，又重新修理。）',
    '代下26:3 烏西雅登基的時候年十六歲，在耶路撒冷作王五十二年。他母親名叫耶可利雅，是耶路撒冷人。',
    '代下26:4 烏西雅行耶和華眼中看為正的事，效法他父亞瑪謝一切所行的；',
    '代下26:5 通曉神默示，撒迦利亞在世的時候，烏西雅定意尋求神；他尋求耶和華，神就使他亨通。',
    '代下26:6 他出去攻擊非利士人，拆毀了迦特城、雅比尼城，和亞實突城；在非利士人中，在亞實突境內，又建築了些城。',
    '代下26:7 神幫助他攻擊非利士人和住在姑珥巴力的亞拉伯人，並米烏尼人。',
    '代下26:8 亞捫人給烏西雅進貢。他的名聲傳到埃及，因他甚是強盛。',
    '代下26:9 烏西雅在耶路撒冷的角門和谷門，並城牆轉彎之處，建築城樓，且甚堅固；',
    '代下26:10 又在曠野與高原和平原，建築望樓，挖了許多井，因他的牲畜甚多；又在山地和佳美之地，有農夫和修理葡萄園的人，因為他喜悅農事。',
    '代下26:11 烏西雅又有軍兵，照書記耶利和官長瑪西雅所數點的，在王的一個將軍哈拿尼雅手下，分隊出戰。',
    '代下26:12 族長、大能勇士的總數共有二千六百人，',
    '代下26:13 他們手下的軍兵共有三十萬七千五百人，都有大能，善於爭戰，幫助王攻擊仇敵。',
    '代下26:14 烏西雅為全軍預備盾牌、槍、盔、甲、弓，和甩石的機弦，',
    '代下26:15 又在耶路撒冷使巧匠做機器，安在城樓和角樓上，用以射箭發石。烏西雅的名聲傳到遠方；因為他得了非常的幫助，甚是強盛。',
    '代下26:16 他既強盛，就心高氣傲，以致行事邪僻，干犯耶和華─他的神，進耶和華的殿，要在香壇上燒香。',
    '代下26:17 祭司亞撒利雅率領耶和華勇敢的祭司八十人，跟隨他進去。',
    '代下26:18 他們就阻擋烏西雅王，對他說：烏西雅啊，給耶和華燒香不是你的事，乃是亞倫子孫承接聖職祭司的事。你出聖殿吧！因為你犯了罪。你行這事，耶和華神必不使你得榮耀。',
    '代下26:19 烏西雅就發怒，手拿香爐要燒香。他向祭司發怒的時候，在耶和華殿中香壇旁眾祭司面前，額上忽然發出大痲瘋。',
    '代下26:20 大祭司亞撒利雅和眾祭司觀看，見他額上發出大痲瘋，就催他出殿；他自己也急速出去，因為耶和華降災與他。',
    '代下26:21 烏西雅王長大痲瘋直到死日，因此住在別的宮裡，與耶和華的殿隔絕。他兒子約坦管理家事，治理國民。',
    '代下26:22 烏西雅其餘的事，自始至終都是亞摩斯的兒子先知以賽亞所記的。',
    '代下26:23 烏西雅與他列祖同睡，葬在王陵的田間他列祖的墳地裡；因為人說，他是長大痲瘋的。他兒子約坦接續他作王。',
    '代下27:1 約坦登基的時候年二十五歲，在耶路撒冷作王十六年，他母親名叫耶路沙，是撒督的女兒。',
    '代下27:2 約坦行耶和華眼中看為正的事，效法他父烏西雅一切所行的，只是不入耶和華的殿。百姓還行邪僻的事。',
    '代下27:3 約坦建立耶和華殿的上門，在俄斐勒城上多有建造，',
    '代下27:4 又在猶大山地建造城邑，在樹林中建築營寨和高樓。',
    '代下27:5 約坦與亞捫人的王打仗勝了他們，當年他們進貢銀一百他連得，小麥一萬歌珥，大麥一萬歌珥；第二年、第三年也是這樣。',
    '代下27:6 約坦在耶和華─他神面前行正道，以致日漸強盛。',
    '代下27:7 約坦其餘的事和一切爭戰，並他的行為，都寫在以色列和猶大列王記上。',
    '代下27:8 他登基的時候年二十五歲，在耶路撒冷作王十六年。',
    '代下27:9 約坦與他列祖同睡，葬在大衛城裡。他兒子亞哈斯接續他作王。',
    '代下28:1 亞哈斯登基的時候年二十歲，在耶路撒冷作王十六年；不像他祖大衛行耶和華眼中看為正的事，',
    '代下28:2 卻行以色列諸王的道，又鑄造巴力的像，',
    '代下28:3 並且在欣嫩子谷燒香，用火焚燒他的兒女，行耶和華在以色列人面前所驅逐的外邦人那可憎的事；',
    '代下28:4 並在邱壇上、山岡上、各青翠樹下獻祭燒香。',
    '代下28:5 所以，耶和華─他的神將他交在亞蘭王手裡。亞蘭王打敗他，擄了他許多的民，帶到大馬色去。神又將他交在以色列王手裡，以色列王向他大行殺戮。',
    '代下28:6 利瑪利的兒子比加一日殺了猶大人十二萬，都是勇士，因為他們離棄了耶和華─他們列祖的神。',
    '代下28:7 有一個以法蓮中的勇士，名叫細基利，殺了王的兒子瑪西雅和管理王宮的押斯利甘，並宰相以利加拿。',
    '代下28:8 以色列人擄了他們的弟兄，連婦人帶兒女共有二十萬，又掠了許多的財物，帶到撒瑪利亞去了。',
    '代下28:9 但那裡有耶和華的一個先知，名叫俄德，出來迎接往撒瑪利亞去的軍兵，對他們說：因為耶和華─你們列祖的神惱怒猶大人，所以將他們交在你們手裡，你們竟怒氣沖天，大行殺戮。',
    '代下28:10 如今你們又有意強逼猶大人和耶路撒冷人作你們的奴婢，你們豈不也有得罪耶和華─你們神的事嗎﹖',
    '代下28:11 現在你們當聽我說，要將擄來的弟兄釋放回去，因為耶和華向你們已經大發烈怒。',
    '代下28:12 於是，以法蓮人的幾個族長─就是約哈難的兒子亞撒利雅、米實利末的兒子比利家、沙龍的兒子耶希西家、哈得萊的兒子亞瑪撒─起來攔擋出兵回來的人，',
    '代下28:13 對他們說：你們不可帶進這被擄的人來！你們想要使我們得罪耶和華，加增我們的罪惡過犯﹖因為我們的罪過甚大，已經有烈怒臨到以色列人了。',
    '代下28:14 於是帶兵器的人將擄來的人口和掠來的財物都留在眾首領和會眾的面前。',
    '代下28:15 以上提名的那些人就站起，使被擄的人前來；其中有赤身的，就從所掠的財物中拿出衣服和鞋來，給他們穿，又給他們吃喝，用膏抹他們；其中有軟弱的，就使他們騎驢，送到棕樹城耶利哥他們弟兄那裡；隨後就回撒瑪利亞去了。',
    '代下28:16 那時，亞哈斯王差遣人去見亞述諸王，求他們幫助；',
    '代下28:17 因為以東人又來攻擊猶大，擄掠子民。',
    '代下28:18 非利士人也來侵佔高原和猶大南方的城邑，取了伯示麥、亞雅崙、基低羅，梭哥和屬梭哥的鄉村，亭納和屬亭納的鄉村，瑾鎖和屬瑾鎖的鄉村，就住在那裡。',
    '代下28:19 因為以色列王亞哈斯在猶大放肆，大大干犯耶和華，所以耶和華使猶大卑微。',
    '代下28:20 亞述王提革拉毘尼色上來，卻沒有幫助他，反倒欺凌他。',
    '代下28:21 亞哈斯從耶和華殿裡和王宮中，並首領家內所取的財寶給了亞述王，這也無濟於事。',
    '代下28:22 這亞哈斯王在急難的時候，越發得罪耶和華。',
    '代下28:23 他祭祀攻擊他的大馬色之神，說：因為亞蘭王的神幫助他們，我也獻祭與他，他好幫助我。但那些神使他和以色列眾人敗亡了。',
    '代下28:24 亞哈斯將神殿裡的器皿都聚了來，毀壞了，且封鎖耶和華殿的門；在耶路撒冷各處的拐角建築祭壇，',
    '代下28:25 又在猶大各城建立邱壇，與別神燒香，惹動耶和華─他列祖神的怒氣。',
    '代下28:26 亞哈斯其餘的事和他的行為，自始至終都寫在猶大和以色列諸王記上。',
    '代下28:27 亞哈斯與他列祖同睡，葬在耶路撒冷城裡，沒有送入以色列諸王的墳墓中。他兒子希西家接續他作王。',
    '代下29:1 希西家登基的時候年二十五歲，在耶路撒冷作王二十九年。他母親名叫亞比雅，是撒迦利雅的女兒。',
    '代下29:2 希西家行耶和華眼中看為正的事，效法他祖大衛一切所行的。',
    '代下29:3 元年正月，開了耶和華殿的門，重新修理。',
    '代下29:4 他召眾祭司和利未人來，聚集在東邊的寬闊處，',
    '代下29:5 對他們說：利未人哪，當聽我說：現在你們要潔淨自己，又潔淨耶和華─你們列祖神的殿，從聖所中除去污穢之物。',
    '代下29:6 我們列祖犯了罪，行耶和華─我們神眼中看為惡的事，離棄他，轉臉背向他的居所，',
    '代下29:7 封鎖廊門，吹滅燈火，不在聖所中向以色列神燒香，或獻燔祭。',
    '代下29:8 因此，耶和華的忿怒臨到猶大和耶路撒冷，將其中的人拋來拋去，令人驚駭、嗤笑，正如你們親眼所見的。',
    '代下29:9 所以我們的祖宗倒在刀下，我們的妻子兒女也被擄掠。',
    '代下29:10 現在我心中有意與耶和華─以色列的神立約，好使他的烈怒轉離我們。',
    '代下29:11 我的眾子啊，現在不要懈怠；因為耶和華揀選你們站在他面前事奉他，與他燒香。',
    '代下29:12 於是，利未人哥轄的子孫、亞瑪賽的兒子瑪哈，亞撒利雅的兒子約珥；米拉利的子孫、亞伯底的兒子基士，耶哈利勒的兒子亞撒利雅；革順的子孫、薪瑪的兒子約亞，約亞的兒子伊甸；',
    '代下29:13 以利撒反的子孫申利和耶利；亞薩的子孫撒迦利雅和瑪探雅；',
    '代下29:14 希幔的子孫耶歇和示每；耶杜頓的子孫示瑪雅和烏薛；',
    '代下29:15 起來聚集他們的弟兄，潔淨自己，照著王的吩咐、耶和華的命令，進去潔淨耶和華的殿。',
    '代下29:16 祭司進入耶和華的殿要潔淨殿，將殿中所有污穢之物搬到耶和華殿的院內，利未人接去，搬到外頭汲淪溪邊。',
    '代下29:17 從正月初一日潔淨起，初八日到了耶和華的殿廊，用八日的工夫潔淨耶和華的殿，到正月十六日才潔淨完了。',
    '代下29:18 於是，他們晉見希西家王，說：我們已將耶和華的全殿和燔祭壇，並壇的一切器皿、陳設餅的桌子，與桌子的一切器皿都潔淨了；',
    '代下29:19 並且亞哈斯王在位犯罪的時候所廢棄的器皿，我們預備齊全，且潔淨了，現今都在耶和華的壇前。',
    '代下29:20 希西家王清早起來，聚集城裡的首領都上耶和華的殿；',
    '代下29:21 牽了七隻公牛，七隻公羊，七隻羊羔，七隻公山羊，要為國、為殿、為猶大人作贖罪祭。王吩咐亞倫的子孫眾祭司，獻在耶和華的壇上，',
    '代下29:22 就宰了公牛，祭司接血灑在壇上，宰了公羊，把血灑在壇上，又宰了羊羔，也把血灑在壇上；',
    '代下29:23 把那作贖罪祭的公山羊牽到王和會眾面前，他們就按手在其上。',
    '代下29:24 祭司宰了羊，將血獻在壇上作贖罪祭，為以色列眾人贖罪，因為王吩咐將燔祭和贖罪祭為以色列眾人獻上。',
    '代下29:25 王又派利未人在耶和華殿中敲鈸，鼓瑟，彈琴，乃照大衛和他先見迦得，並先知拿單所吩咐的，就是耶和華藉先知所吩咐的。',
    '代下29:26 利未人拿大衛的樂器，祭司拿號，一同站立。',
    '代下29:27 希西家吩咐在壇上獻燔祭，燔祭一獻，就唱讚美耶和華的歌，用號，並用以色列王大衛的樂器相和。',
    '代下29:28 會眾都敬拜，歌唱的歌唱，吹號的吹號，如此直到燔祭獻完了。',
    '代下29:29 獻完了祭，王和一切跟隨的人都俯伏敬拜。',
    '代下29:30 希西家王與眾首領又吩咐利未人用大衛和先見亞薩的詩詞頌讚耶和華；他們就歡歡喜喜地頌讚耶和華，低頭敬拜。',
    '代下29:31 希西家說：你們既然歸耶和華為聖，就要前來把祭物和感謝祭奉到耶和華殿裡。會眾就把祭物和感謝祭奉來，凡甘心樂意的也將燔祭奉來。',
    '代下29:32 會眾所奉的燔祭如下：公牛七十隻，公羊一百隻，羊羔二百隻，這都是作燔祭獻給耶和華的；',
    '代下29:33 又有分別為聖之物，公牛六百隻，綿羊三千隻。',
    '代下29:34 但祭司太少，不能剝盡燔祭牲的皮，所以他們的弟兄利未人幫助他們，直等燔祭的事完了，又等別的祭司自潔了；因為利未人誠心自潔，勝過祭司。',
    '代下29:35 燔祭和平安祭牲的脂油，並燔祭同獻的奠祭甚多。這樣，耶和華殿中的事務俱都齊備了【或作就整頓了】。',
    '代下29:36 這事辦的甚速，希西家和眾民都喜樂，是因神為眾民所預備的。',
    '代下30:1 希西家差遣人去見以色列和猶大眾人，又寫信給以法蓮和瑪拿西人，叫他們到耶路撒冷耶和華的殿，向耶和華─以色列的神守逾越節；',
    '代下30:2 因為王和眾首領，並耶路撒冷全會眾已經商議，要在二月內守逾越節。',
    '代下30:3 正月【原文作那時】間他們不能守；因為自潔的祭司尚不敷用，百姓也沒有聚集在耶路撒冷；',
    '代下30:4 王與全會眾都以這事為善。',
    '代下30:5 於是定了命令，傳遍以色列，從別是巴直到但，使他們都來，在耶路撒冷向耶和華─以色列的神守逾越節；因為照所寫的例，守這節的不多了【或作因為民許久沒有照所寫的例守節了】。',
    '代下30:6 驛卒就把王和眾首領的信，遵著王命傳遍以色列和猶大。信內說：以色列人哪，你們當轉向耶和華─亞伯拉罕、以撒、以色列的神，好叫他轉向你們這脫離亞述王手的餘民。',
    '代下30:7 你們不要效法你們列祖和你們的弟兄；他們干犯耶和華─他們列祖的神，以致耶和華丟棄他們，使他們敗亡【或作令人驚駭】，正如你們所見的。',
    '代下30:8 現在不要像你們列祖硬著頸項，只要歸順耶和華，進入他的聖所，就是永遠成聖的居所；又要事奉耶和華─你們的神，好使他的烈怒轉離你們。',
    '代下30:9 你們若轉向耶和華，你們的弟兄和兒女必在擄掠他們的人面前蒙憐恤，得以歸回這地，因為耶和華─你們的神有恩典、施憐憫。你們若轉向他，他必不轉臉不顧你們。',
    '代下30:10 驛卒就由這城跑到那城，傳遍了以法蓮、瑪拿西，直到西布倫。那裡的人卻戲笑他們，譏誚他們。',
    '代下30:11 然而亞設、瑪拿西、西布倫中也有人自卑，來到耶路撒冷。',
    '代下30:12 神也感動猶大人，使他們一心遵行王與眾首領憑耶和華之言所發的命令。',
    '代下30:13 二月，有許多人在耶路撒冷聚集，成為大會，要守除酵節。',
    '代下30:14 他們起來，把耶路撒冷的祭壇和燒香的壇盡都除去，拋在汲淪溪中。',
    '代下30:15 二月十四日，宰了逾越節的羊羔。祭司與利未人覺得慚愧，就潔淨自己，把燔祭奉到耶和華殿中，',
    '代下30:16 遵著神人摩西的律法，照例站在自己的地方；祭司從利未人手裡接過血來，灑在壇上。',
    '代下30:17 會中有許多人尚未自潔，所以利未人為一切不潔之人宰逾越節的羊羔，使他們在耶和華面前成為聖潔。',
    '代下30:18 以法蓮、瑪拿西、以薩迦、西布倫有許多人尚未自潔，他們卻也吃逾越節的羊羔，不合所記錄的定例。希西家為他們禱告說：凡專心尋求神，就是耶和華─他列祖之神的，雖不照著聖所潔淨之禮自潔，求至善的耶和華也饒恕他。',
    '代下30:19 併於上節。',
    '代下30:20 耶和華垂聽希西家的禱告，就饒恕【原文作醫治】百姓。',
    '代下30:21 在耶路撒冷的以色列人大大喜樂，守除酵節七日。利未人和祭司用響亮的樂器，日日頌讚耶和華。',
    '代下30:22 希西家慰勞一切善於事奉耶和華的利未人。於是眾人吃節筵七日，又獻平安祭，且向耶和華─他們列祖的神認罪。',
    '代下30:23 全會眾商議，要再守節七日；於是歡歡喜喜地又守節七日。',
    '代下30:24 猶大王希西家賜給會眾公牛一千隻，羊七千隻為祭物；眾首領也賜給會眾公牛一千隻，羊一萬隻，並有許多的祭司潔淨自己。',
    '代下30:25 猶大全會眾、祭司、利未人，並那從以色列地來的會眾和寄居的人，以及猶大寄居的人，盡都喜樂。',
    '代下30:26 這樣，在耶路撒冷大有喜樂，自從以色列王大衛兒子所羅門的時候，在耶路撒冷沒有這樣的喜樂。',
    '代下30:27 那時，祭司、利未人起來，為民祝福。他們的聲音蒙神垂聽，他們的禱告達到天上的聖所。',
    '代下31:1 這事既都完畢，在那裡的以色列眾人就到猶大的城邑，打碎柱像，砍斷木偶，又在猶大、便雅憫、以法蓮、瑪拿西遍地將邱壇和祭壇拆毀淨盡。於是以色列眾人各回各城，各歸各地。',
    '代下31:2 希西家派定祭司利未人的班次，各按各職獻燔祭和平安祭，又在耶和華殿【原文作營】門內事奉，稱謝頌讚耶和華。',
    '代下31:3 王又從自己的產業中定出分來為燔祭，就是早晚的燔祭和安息日、月朔，並節期的燔祭，都是按耶和華律法上所載的；',
    '代下31:4 又吩咐住耶路撒冷的百姓將祭司、利未人所應得的分給他們，使他們專心遵守耶和華的律法。',
    '代下31:5 諭旨一出，以色列人就把初熟的五穀、新酒、油、蜜，和田地的出產多多送來，又把各物的十分之一送來的極多。',
    '代下31:6 住猶大各城的以色列人和猶大人也將牛羊的十分之一，並分別為聖歸耶和華─他們神之物，就是十分取一之物，盡都送來，積成堆壘；',
    '代下31:7 從三月積起，到七月才完。',
    '代下31:8 希西家和眾首領來，看見堆壘，就稱頌耶和華，又為耶和華的民以色列人祝福。',
    '代下31:9 希西家向祭司、利未人查問這堆壘。',
    '代下31:10 撒督家的大祭司亞撒利雅回答說：自從民將供物送到耶和華殿以來，我們不但吃飽，且剩下的甚多；因為耶和華賜福給他的民，所剩下的才這樣豐盛。',
    '代下31:11 希西家吩咐在耶和華殿裡預備倉房，他們就預備了。',
    '代下31:12 他們誠心將供物和十分取一之物，並分別為聖之物，都搬入倉內。利未人歌楠雅掌管這事，他兄弟示每為副管。',
    '代下31:13 耶歇、亞撒細雅、拿哈、亞撒黑、耶利末、約撒拔、以列、伊斯瑪基雅、瑪哈、比拿雅都是督理，在歌楠雅和他兄弟示每的手下，是希西家王和管理神殿的亞撒利雅所派的。',
    '代下31:14 守東門的利未人音拿的兒子可利，掌管樂意獻與神的禮物，發放獻與耶和華的供物和至聖的物。',
    '代下31:15 在他手下有伊甸、珉雅珉、耶書亞、示瑪雅、亞瑪利雅、示迦尼雅，在祭司的各城裡供緊要的職任，無論弟兄大小，都按著班次分給他們。',
    '代下31:16 按家譜，三歲以外的男丁，凡每日進耶和華殿、按班次供職的，也分給他；',
    '代下31:17 又按宗族家譜分給祭司，按班次職任分給二十歲以外的利未人，',
    '代下31:18 又按家譜計算，分給他們會中的妻子、兒女；因他們身供要職，自潔成聖。',
    '代下31:19 按名派定的人要把應得的分給亞倫子孫，住在各城郊野、祭司所有的男丁和一切載入家譜的利未人。',
    '代下31:20 希西家在猶大遍地這樣辦理，行耶和華─他神眼中看為善為正為忠的事。',
    '代下31:21 凡他所行的，無論是辦神殿的事，是遵律法守誡命，是尋求他的神，都是盡心去行，無不亨通。',
    '代下32:1 這虔誠的事以後，亞述王西拿基立來侵入猶大，圍困一切堅固城，想要攻破佔據。',
    '代下32:2 希西家見西拿基立來，定意要攻打耶路撒冷，',
    '代下32:3 就與首領和勇士商議，塞住城外的泉源；他們就都幫助他。',
    '代下32:4 於是有許多人聚集，塞了一切泉源，並通流國中的小河，說：亞述王來，為何讓他得著許多水呢﹖',
    '代下32:5 希西家力圖自強，就修築所有拆毀的城牆，高與城樓相齊；在城外又築一城，堅固大衛城的米羅，製造了許多軍器、盾牌；',
    '代下32:6 設立軍長管理百姓，將他們招聚在城門的寬闊處，用話勉勵他們，說：',
    '代下32:7 你們當剛強壯膽，不要因亞述王和跟隨他的大軍恐懼、驚慌；因為與我們同在的，比與他們同在的更大。',
    '代下32:8 與他們同在的是肉臂，與我們同在的是耶和華─我們的神，他必幫助我們，為我們爭戰。百姓就靠猶大王希西家的話，安然無懼了。',
    '代下32:9 此後，亞述王西拿基立和他的全軍攻打拉吉，就差遣臣僕到耶路撒冷見猶大王希西家和一切在耶路撒冷的猶大人，說：',
    '代下32:10 亞述王西拿基立如此說：你們倚靠什麼，還在耶路撒冷受困呢﹖',
    '代下32:11 希西家對你們說耶和華─我們的神必救我們脫離亞述王的手，這不是誘惑你們，使你們受飢渴而死嗎﹖',
    '代下32:12 這希西家豈不是廢去耶和華的邱壇和祭壇，吩咐猶大與耶路撒冷的人說你們當在一個壇前敬拜，在其上燒香嗎﹖',
    '代下32:13 我與我列祖向列邦所行的，你們豈不知道嗎﹖列邦的神何嘗能救自己的國脫離我手呢﹖',
    '代下32:14 我列祖所滅的國，那些神中誰能救自己的民脫離我手呢﹖難道你們的神能救你們脫離我手嗎﹖',
    '代下32:15 所以你們不要叫希西家這樣欺哄誘惑你們，也不要信他；因為沒有一國一邦的神能救自己的民脫離我手和我列祖的手，何況你們的神更不能救你們脫離我的手。',
    '代下32:16 西拿基立的臣僕還有別的話毀謗耶和華神和他僕人希西家。',
    '代下32:17 西拿基立也寫信毀謗耶和華─以色列的神說：列邦的神既不能救他的民脫離我手，希西家的神也不能救他的民脫離我手了。',
    '代下32:18 亞述王的臣僕用猶大言語向耶路撒冷城上的民大聲呼叫，要驚嚇他們，擾亂他們，以便取城。',
    '代下32:19 他們論耶路撒冷的神，如同論世上人手所造的神一樣。',
    '代下32:20 希西家王和亞摩斯的兒子先知以賽亞因此禱告，向天呼求。',
    '代下32:21 耶和華就差遣一個使者進入亞述王營中，把所有大能的勇士和官長、將帥盡都滅了。亞述王滿面含羞地回到本國，進了他神的廟中，有他親生的兒子在那裡用刀殺了他。',
    '代下32:22 這樣，耶和華救希西家和耶路撒冷的居民脫離亞述王西拿基立的手，也脫離一切仇敵的手，又賜他們四境平安。',
    '代下32:23 有許多人到耶路撒冷，將供物獻與耶和華，又將寶物送給猶大王希西家。此後，希西家在列邦人的眼中看為尊大。',
    '代下32:24 那時希西家病得要死，就禱告耶和華，耶和華應允他，賜他一個兆頭。',
    '代下32:25 希西家卻沒有照他所蒙的恩報答耶和華；因他心裡驕傲，所以忿怒要臨到他和猶大並耶路撒冷。',
    '代下32:26 但希西家和耶路撒冷的居民覺得心裡驕傲，就一同自卑，以致耶和華的忿怒在希西家的日子沒有臨到他們。',
    '代下32:27 希西家大有尊榮資財，建造府庫，收藏金銀、寶石、香料、盾牌，和各樣的寶器，',
    '代下32:28 又建造倉房，收藏五穀、新酒，和油，又為各類牲畜蓋棚立圈；',
    '代下32:29 並且建立城邑，還有許多的羊群牛群，因為神賜他極多的財產。',
    '代下32:30 這希西家也塞住基訓的上源，引水直下，流在大衛城的西邊。希西家所行的事盡都亨通。',
    '代下32:31 惟有一件事，就是巴比倫王差遣使者來見希西家，訪問國中所現的奇事；這件事神離開他，要試驗他，好知道他心內如何。',
    '代下32:32 希西家其餘的事和他的善行都寫在亞摩斯的兒子先知以賽亞的默示書上和猶大、以色列的諸王記上。',
    '代下32:33 希西家與他列祖同睡，葬在大衛子孫的高陵上。他死的時候，猶大人和耶路撒冷的居民都尊敬他。他兒子瑪拿西接續他作王。',
    '代下33:1 瑪拿西登基的時候年十二歲，在耶路撒冷作王五十五年。',
    '代下33:2 他行耶和華眼中看為惡的事，效法耶和華在以色列人面前趕出的外邦人那可憎的事，',
    '代下33:3 重新建築他父希西家所拆毀的邱壇，又為巴力築壇，做木偶，且敬拜事奉天上的萬象，',
    '代下33:4 在耶和華的殿宇中築壇─耶和華曾指著這殿說：我的名必永遠在耶路撒冷。',
    '代下33:5 他在耶和華殿的兩院中為天上的萬象築壇，',
    '代下33:6 並在欣嫩子谷使他的兒女經火，又觀兆，用法術，行邪術，立交鬼的和行巫術的，多行耶和華眼中看為惡的事，惹動他的怒氣，',
    '代下33:7 又在神殿內立雕刻的偶像。神曾對大衛和他兒子所羅門說：我在以色列各支派中所選擇的耶路撒冷和這殿，必立我的名直到永遠。',
    '代下33:8 以色列人若謹守遵行我藉摩西所吩咐他們的一切法度、律例、典章，我就不再使他們挪移離開我所賜給他們列祖之地。',
    '代下33:9 瑪拿西引誘猶大和耶路撒冷的居民，以致他們行惡比耶和華在以色列人面前所滅的列國更甚。',
    '代下33:10 耶和華警戒瑪拿西和他的百姓，他們卻是不聽。',
    '代下33:11 所以耶和華使亞述王的將帥來攻擊他們，用鐃鉤鉤住瑪拿西，用銅鍊鎖住他，帶到巴比倫去。',
    '代下33:12 他在急難的時候，就懇求耶和華─他的神，且在他列祖的神面前極其自卑。',
    '代下33:13 他祈禱耶和華，耶和華就允准他的祈求，垂聽他的禱告，使他歸回耶路撒冷，仍坐國位。瑪拿西這才知道惟獨耶和華是神。',
    '代下33:14 此後，瑪拿西在大衛城外，從谷內基訓西邊直到魚門口，建築城牆，環繞俄斐勒，這牆築得甚高；又在猶大各堅固城內設立勇敢的軍長；',
    '代下33:15 並除掉外邦人的神像與耶和華殿中的偶像，又將他在耶和華殿的山上和耶路撒冷所築的各壇都拆毀拋在城外；',
    '代下33:16 重修耶和華的祭壇，在壇上獻平安祭、感謝祭，吩咐猶大人事奉耶和華─以色列的神。',
    '代下33:17 百姓卻仍在邱壇上獻祭，只獻給耶和華─他們的神。',
    '代下33:18 瑪拿西其餘的事和禱告他神的話，並先見奉耶和華─以色列神的名警戒他的言語，都寫在以色列諸王記上。',
    '代下33:19 他的禱告，與神怎樣應允他，他未自卑以前的罪愆過犯，並在何處建築邱壇，設立亞舍拉和雕刻的偶像，都寫在何賽的書上。',
    '代下33:20 瑪拿西與他列祖同睡，葬在自己的宮院裡。他兒子亞們接續他作王。',
    '代下33:21 亞們登基的時候年二十二歲，在耶路撒冷作王二年。',
    '代下33:22 他行耶和華眼中看為惡的事，效法他父瑪拿西所行的，祭祀事奉他父瑪拿西所雕刻的偶像，',
    '代下33:23 不在耶和華面前像他父瑪拿西自卑。這亞們所犯的罪越犯越大。',
    '代下33:24 他的臣僕背叛，在宮裡殺了他。',
    '代下33:25 但國民殺了那些背叛亞們王的人，立他兒子約西亞接續他作王。',
    '代下34:1 約西亞登基的時候年八歲，在耶路撒冷作王三十一年。',
    '代下34:2 他行耶和華眼中看為正的事，效法他祖大衛所行的，不偏左右。',
    '代下34:3 他作王第八年，尚且年幼，就尋求他祖大衛的神。到了十二年才潔淨猶大和耶路撒冷，除掉邱壇、木偶、雕刻的像，和鑄造的像。',
    '代下34:4 眾人在他面前拆毀巴力的壇，砍斷壇上高高的日像，又把木偶和雕刻的像，並鑄造的像打碎成灰，撒在祭偶像人的墳上，',
    '代下34:5 將他們祭司的骸骨燒在壇上，潔淨了猶大和耶路撒冷；',
    '代下34:6 又在瑪拿西、以法蓮、西緬、拿弗他利各城，和四圍破壞之處，都這樣行；',
    '代下34:7 又拆毀祭壇，把木偶和雕刻的像打碎成灰，砍斷以色列遍地所有的日像，就回耶路撒冷去了。',
    '代下34:8 約西亞王十八年，淨地淨殿之後，就差遣亞薩利雅的兒子沙番、邑宰瑪西雅、約哈斯的兒子史官約亞去修理耶和華─他神的殿。',
    '代下34:9 他們就去見大祭司希勒家，將奉到神殿的銀子交給他；這銀子是看守殿門的利未人從瑪拿西、以法蓮，和一切以色列剩下的人，以及猶大、便雅憫眾人，並耶路撒冷的居民收來的。',
    '代下34:10 又將這銀子交給耶和華殿裡督工的，轉交修理耶和華殿的工匠，',
    '代下34:11 就是交給木匠、石匠，買鑿成的石頭和架木與棟梁，修猶大王所毀壞的殿。',
    '代下34:12 這些人辦事誠實，督工的是利未人米拉利的子孫雅哈、俄巴底；督催的是哥轄的子孫撒迦利亞、米書蘭；還有善於作樂的利未人。',
    '代下34:13 他們又監管扛擡的人，督催一切做工的。利未人中也有作書記、作司事、作守門的。',
    '代下34:14 他們將奉到耶和華殿的銀子運出來的時候，祭司希勒家偶然得了摩西所傳耶和華的律法書。',
    '代下34:15 希勒家對書記沙番說：我在耶和華殿裡得了律法書。遂將書遞給沙番。',
    '代下34:16 沙番把書拿到王那裡，回覆王說：凡交給僕人們辦的都辦理了。',
    '代下34:17 耶和華殿裡的銀子倒出來，交給督工的和匠人的手裡了。',
    '代下34:18 書記沙番又對王說：祭司希勒家遞給我一卷書。沙番就在王面前讀那書。',
    '代下34:19 王聽見律法上的話，就撕裂衣服，',
    '代下34:20 吩咐希勒家與沙番的兒子亞希甘、米迦的兒子亞比頓、書記沙番，和王的臣僕亞撒雅說：',
    '代下34:21 你們去為我、為以色列和猶大剩下的人，以這書上的話求問耶和華；因我們列祖沒有遵守耶和華的言語，沒有照這書上所記的去行，耶和華的烈怒就倒在我們身上。',
    '代下34:22 於是，希勒家和王所派的眾人都去見女先知戶勒大。戶勒大是掌管禮服沙龍的妻，沙龍是哈斯拉的孫子、特瓦的兒子。戶勒大住在耶路撒冷第二區；他們請問於他。',
    '代下34:23 他對他們說：耶和華─以色列的神如此說：你們可以回覆那差遣你們來見我的人說，',
    '代下34:24 耶和華如此說：我必照著在猶大王面前所讀那書上的一切咒詛，降禍與這地和其上的居民；',
    '代下34:25 因為他們離棄我，向別神燒香，用他們手所做的惹我發怒，所以我的忿怒如火倒在這地上，總不息滅。',
    '代下34:26 然而差遣你們來求問耶和華的猶大王，你們要這樣回覆他說：耶和華─以色列的神如此說：至於你所聽見的話，',
    '代下34:27 就是聽見我指著這地和其上居民所說的話，你便心裡敬服，在我面前自卑，撕裂衣服，向我哭泣，因此我應允了你。這是我─耶和華說的。',
    '代下34:28 我必使你平平安安地歸到墳墓，到你列祖那裡，我要降與這地和其上居民的一切災禍，你也不致親眼看見。他們就回覆王去了。',
    '代下34:29 王差遣人招聚猶大和耶路撒冷的眾長老來。',
    '代下34:30 王和猶大眾人，與耶路撒冷的居民，並祭司利未人，以及所有的百姓，無論大小，都一同上到耶和華的殿；王就把殿裡所得的約書念給他們聽。',
    '代下34:31 王站在他的地位上，在耶和華面前立約，要盡心盡性地順從耶和華，遵守他的誡命、法度、律例，成就這書上所記的約言；',
    '代下34:32 又使住耶路撒冷和便雅憫的人都服從這約。於是耶路撒冷的居民都遵行他們列祖之神的約。',
    '代下34:33 約西亞從以色列各處將一切可憎之物盡都除掉，使以色列境內的人都事奉耶和華─他們的神。約西亞在世的日子，就跟從耶和華─他們列祖的神，總不離開。',
    '代下35:1 約西亞在耶路撒冷向耶和華守逾越節。正月十四日，就宰了逾越節的羊羔。',
    '代下35:2 王分派祭司各盡其職，又勉勵他們辦耶和華殿中的事；',
    '代下35:3 又對那歸耶和華為聖、教訓以色列人的利未人說：你們將聖約櫃安放在以色列王大衛兒子所羅門建造的殿裡，不必再用肩扛擡。現在要事奉耶和華─你們的神，服事他的民以色列。',
    '代下35:4 你們應當按著宗族，照著班次，遵以色列王大衛和他兒子所羅門所寫的，自己預備。',
    '代下35:5 要按著你們的弟兄，這民宗族的班次，站在聖所，每班中要利未宗族的幾個人。',
    '代下35:6 要宰逾越節的羊羔，潔淨自己，為你們的弟兄預備了，好遵守耶和華藉摩西所吩咐的話。',
    '代下35:7 約西亞從群畜中賜給在那裡所有的人民，綿羊羔和山羊羔三萬隻，牛三千隻，作逾越節的祭物；這都是出自王的產業中。',
    '代下35:8 約西亞的眾首領也樂意將犧牲給百姓和祭司利未人；又有管理神殿的希勒家、撒迦利亞、耶歇將羊羔二千六百隻，牛三百隻，給祭司作逾越節的祭物。',
    '代下35:9 利未人的族長歌楠雅和他兩個兄弟示瑪雅、拿坦業，與哈沙比雅、耶利、約撒拔將羊羔五千隻，牛五百隻，給利未人作逾越節的祭物。',
    '代下35:10 這樣，供獻的事齊備了。祭司站在自己的地方，利未人按著班次站立，都是照王所吩咐的。',
    '代下35:11 利未人宰了逾越節的羊羔，祭司從他們手裡接過血來灑在壇上；利未人剝皮，',
    '代下35:12 將燔祭搬來，按著宗族的班次分給眾民，好照摩西書上所寫的，獻給耶和華；獻牛也是這樣。',
    '代下35:13 他們按著常例，用火烤逾越節的羊羔。別的聖物用鍋，用釜，用罐煮了，速速地送給眾民。',
    '代下35:14 然後為自己和祭司預備祭物；因為祭司亞倫的子孫獻燔祭和脂油，直到晚上。所以利未人為自己和祭司亞倫的子孫，預備祭物。',
    '代下35:15 歌唱的亞薩之子孫，照著大衛、亞薩、希幔，和王的先見耶杜頓所吩咐的，站在自己的地位上。守門的看守各門，不用離開他們的職事，因為他們的弟兄利未人給他們預備祭物。',
    '代下35:16 當日，供奉耶和華的事齊備了，就照約西亞王的吩咐守逾越節，獻燔祭在耶和華的壇上。',
    '代下35:17 當時在耶路撒冷的以色列人守逾越節，又守除酵節七日。',
    '代下35:18 自從先知撒母耳以來，在以色列中沒有守過這樣的逾越節，以色列諸王也沒有守過，像約西亞、祭司、利未人、在那裡的猶大人，和以色列人，以及耶路撒冷居民所守的逾越節。',
    '代下35:19 這逾越節是約西亞作王十八年守的。',
    '代下35:20 這事以後，約西亞修完了殿，有埃及王尼哥上來，要攻擊靠近伯拉河的迦基米施；約西亞出去抵擋他。',
    '代下35:21 他差遣使者來見約西亞，說：猶大王啊，我與你何干﹖我今日來不是要攻擊你，乃是要攻擊與我爭戰之家，並且神吩咐我速行，你不要干預神的事，免得他毀滅你，因為神是與我同在。',
    '代下35:22 約西亞卻不肯轉去離開他，改裝要與他打仗，不聽從神藉尼哥之口所說的話，便來到米吉多平原爭戰。',
    '代下35:23 弓箭手射中約西亞王。王對他的臣僕說：我受了重傷，你拉我出陣吧！',
    '代下35:24 他的臣僕扶他下了戰車，上了次車，送他到耶路撒冷，他就死了，葬在他列祖的墳墓裡。猶大人和耶路撒冷人都為他悲哀。',
    '代下35:25 耶利米為約西亞作哀歌。所有歌唱的男女也唱哀歌，追悼約西亞，直到今日；而且在以色列中成了定例。這歌載在哀歌書上。',
    '代下35:26 約西亞其餘的事和他遵著耶和華律法上所記而行的善事，',
    '代下35:27 並他自始至終所行的，都寫在以色列和猶大列王記上。',
    '代下36:1 國民立約西亞的兒子約哈斯在耶路撒冷接續他父作王。',
    '代下36:2 約哈斯登基的時候年二十三歲，在耶路撒冷作王三個月。',
    '代下36:3 埃及王在耶路撒冷廢了他，又罰猶大國銀子一百他連得，金子一他連得。',
    '代下36:4 埃及王尼哥立約哈斯的哥哥以利雅敬作猶大和耶路撒冷的王，改名叫約雅敬，又將約哈斯帶到埃及去了。',
    '代下36:5 約雅敬登基的時候年二十五歲，在耶路撒冷作王十一年，行耶和華─他神眼中看為惡的事。',
    '代下36:6 巴比倫王尼布甲尼撒上來攻擊他，用銅鍊鎖著他，要將他帶到巴比倫去。',
    '代下36:7 尼布甲尼撒又將耶和華殿裡的器皿帶到巴比倫，放在他神的廟裡【或作自己的宮裡】。',
    '代下36:8 約雅敬其餘的事和他所行可憎的事，並他一切的行為，都寫在以色列和猶大列王記上。他兒子約雅斤接續他作王。',
    '代下36:9 約雅斤登基的時候年八歲【王下二四章八節作十八歲】，在耶路撒冷作王三個月零十天，行耶和華眼中看為惡的事。',
    '代下36:10 過了一年，尼布甲尼撒差遣人將約雅斤和耶和華殿裡各樣寶貴的器皿帶到巴比倫，就立約雅斤的叔叔（原文是兄）西底家作猶大和耶路撒冷的王。',
    '代下36:11 西底家登基的時候年二十一歲，在耶路撒冷作王十一年，',
    '代下36:12 行耶和華─他神眼中看為惡的事。先知耶利米以耶和華的話勸他，他仍不在耶利米面前自卑。',
    '代下36:13 尼布甲尼撒曾使他指著神起誓，他卻背叛，強項硬心，不歸服耶和華─以色列的神。',
    '代下36:14 眾祭司長和百姓也大大犯罪，效法外邦人一切可憎的事，污穢耶和華在耶路撒冷分別為聖的殿。',
    '代下36:15 耶和華─他們列祖的神因為愛惜自己的民和他的居所，從早起來差遣使者去警戒他們。',
    '代下36:16 他們卻嘻笑神的使者，藐視他的言語，譏誚他的先知，以致耶和華的忿怒向他的百姓發作，無法可救。',
    '代下36:17 所以，耶和華使迦勒底人的王來攻擊他們，在他們聖殿裡用刀殺了他們的壯丁，不憐恤他們的少男處女、老人白叟。耶和華將他們都交在迦勒底王手裡。',
    '代下36:18 迦勒底王將神殿裡的大小器皿與耶和華殿裡的財寶，並王和眾首領的財寶，都帶到巴比倫去了。',
    '代下36:19 迦勒底人焚燒神的殿，拆毀耶路撒冷的城牆，用火燒了城裡的宮殿，毀壞了城裡寶貴的器皿。',
    '代下36:20 凡脫離刀劍的，迦勒底王都擄到巴比倫去，作他和他子孫的僕婢，直到波斯國興起來。',
    '代下36:21 這就應驗耶和華藉耶利米口所說的話：地享受安息；因為地土荒涼便守安息，直滿了七十年。',
    '代下36:22 波斯王古列元年，耶和華為要應驗藉耶利米口所說的話，就激動波斯王古列的心，使他下詔通告全國，說：',
    '代下36:23 波斯王古列如此說：耶和華─天上的神已將天下萬國賜給我，又囑咐我在猶大的耶路撒冷為他建造殿宇。你們中間凡作他子民的，可以上去，願耶和華─他的神與他同在。',
    '拉1:1 波斯王古列元年，耶和華為要應驗藉耶利米口所說的話，就激動波斯王古列的心，使他下詔通告全國說：',
    '拉1:2 波斯王古列如此說：耶和華天上的神已將天下萬國賜給我，又囑咐我在猶大的耶路撒冷為他建造殿宇。',
    '拉1:3 在你們中間凡作他子民的，可以上猶大的耶路撒冷，在耶路撒冷重建耶和華─以色列神的殿（只有他是神）。願神與這人同在。',
    '拉1:4 凡剩下的人，無論寄居何處，那地的人要用金銀、財物、牲畜幫助他，另外也要為耶路撒冷神的殿甘心獻上禮物。',
    '拉1:5 於是，猶大和便雅憫的族長、祭司、利未人，就是一切被神激動他心的人，都起來要上耶路撒冷去建造耶和華的殿。',
    '拉1:6 他們四圍的人就拿銀器、金子、財物、牲畜、珍寶幫助他們（原文是堅固他們的手），另外還有甘心獻的禮物。',
    '拉1:7 古列王也將耶和華殿的器皿拿出來，這器皿是尼布甲尼撒從耶路撒冷掠來、放在自己神之廟中的。',
    '拉1:8 波斯王古列派庫官米提利達將這器皿拿出來，按數交給猶大的首領設巴薩。',
    '拉1:9 器皿的數目記在下面：金盤三十個，銀盤一千個，刀二十九把，',
    '拉1:10 金碗三十個，銀碗之次的四百一十個，別樣的器皿一千件。',
    '拉1:11 金銀器皿共有五千四百件。被擄的人從巴比倫上耶路撒冷的時候，設巴薩將這一切都帶上來。',
    '拉2:1 巴比倫王尼布甲尼撒從前擄到巴比倫之猶大省的人，現在他們的子孫從被擄到之地回耶路撒冷和猶大，各歸本城。',
    '拉2:2 他們是同著所羅巴伯、耶書亞、尼希米、西萊雅、利來雅、末底改、必珊、米斯拔、比革瓦伊、利宏、巴拿回來的。',
    '拉2:3 以色列人民的數目記在下面：巴錄的子孫二千一百七十二名；',
    '拉2:4 示法提雅的子孫三百七十二名；',
    '拉2:5 亞拉的子孫七百七十五名；',
    '拉2:6 巴哈摩押的後裔，就是耶書亞和約押的子孫二千八百一十二名；',
    '拉2:7 以攔的子孫一千二百五十四名；',
    '拉2:8 薩土的子孫九百四十五名；',
    '拉2:9 薩改的子孫七百六十名；',
    '拉2:10 巴尼的子孫六百四十二名；',
    '拉2:11 比拜的子孫六百二十三名；',
    '拉2:12 押甲的子孫一千二百二十二名；',
    '拉2:13 亞多尼干的子孫六百六十六名；',
    '拉2:14 比革瓦伊的子孫二千零五十六名；',
    '拉2:15 亞丁的子孫四百五十四名；',
    '拉2:16 亞特的後裔，就是希西家的子孫九十八名；',
    '拉2:17 比賽的子孫三百二十三名；',
    '拉2:18 約拉的子孫一百一十二名；',
    '拉2:19 哈順的子孫二百二十三名；',
    '拉2:20 吉罷珥人九十五名；',
    '拉2:21 伯利恆人一百二十三名；',
    '拉2:22 尼陀法人五十六名；',
    '拉2:23 亞拿突人一百二十八名；',
    '拉2:24 亞斯瑪弗人四十二名；',
    '拉2:25 基列耶琳人、基非拉人、比錄人共七百四十三名；',
    '拉2:26 拉瑪人、迦巴人共六百二十一名；',
    '拉2:27 默瑪人一百二十二名；',
    '拉2:28 伯特利人、艾人共二百二十三名；',
    '拉2:29 尼波人五十二名；',
    '拉2:30 末必人一百五十六名；',
    '拉2:31 別的以攔子孫一千二百五十四名；',
    '拉2:32 哈琳的子孫三百二十名；',
    '拉2:33 羅德人、哈第人、阿挪人共七百二十五名；',
    '拉2:34 耶利哥人三百四十五名；',
    '拉2:35 西拿人三千六百三十名。',
    '拉2:36 祭司：耶書亞家耶大雅的子孫九百七十三名；',
    '拉2:37 音麥的子孫一千零五十二名；',
    '拉2:38 巴施戶珥的子孫一千二百四十七名；',
    '拉2:39 哈琳的子孫一千零一十七名。',
    '拉2:40 利未人：何達威雅的後裔，就是耶書亞和甲篾的子孫七十四名。',
    '拉2:41 歌唱的：亞薩的子孫一百二十八名。',
    '拉2:42 守門的：沙龍的子孫、亞特的子孫、達們的子孫、亞谷的子孫、哈底大的子孫、朔拜的子孫，共一百三十九名。',
    '拉2:43 尼提寧（就是殿役）：西哈的子孫、哈蘇巴的子孫、答巴俄的子孫、',
    '拉2:44 基綠的子孫、西亞的子孫、巴頓的子孫、',
    '拉2:45 利巴拿的子孫、哈迦巴的子孫、亞谷的子孫、',
    '拉2:46 哈甲的子孫、薩買的子孫、哈難的子孫、',
    '拉2:47 吉德的子孫、迦哈的子孫、利亞雅的子孫、',
    '拉2:48 利汛的子孫、尼哥大的子孫、迦散的子孫、',
    '拉2:49 烏撒的子孫、巴西亞的子孫、比賽的子孫、',
    '拉2:50 押拿的子孫、米烏寧的子孫、尼普心的子孫、',
    '拉2:51 巴卜的子孫、哈古巴的子孫、哈忽的子孫、',
    '拉2:52 巴洗律的子孫、米希大的子孫、哈沙的子孫、',
    '拉2:53 巴柯的子孫、西西拉的子孫、答瑪的子孫、',
    '拉2:54 尼細亞的子孫、哈提法的子孫。',
    '拉2:55 所羅門僕人的後裔，就是瑣太的子孫、瑣斐列的子孫、比路大的子孫、',
    '拉2:56 雅拉的子孫、達昆的子孫、吉德的子孫、',
    '拉2:57 示法提雅的子孫、哈替的子孫、玻黑列哈斯巴音的子孫、亞米的子孫。',
    '拉2:58 尼提寧和所羅門僕人的後裔共三百九十二名。',
    '拉2:59 從特米拉、特哈薩、基綠、押但、音麥上來的，不能指明他們的宗族譜系是以色列人不是；',
    '拉2:60 他們是第來雅的子孫、多比雅的子孫、尼哥大的子孫，共六百五十二名。',
    '拉2:61 祭司中，哈巴雅的子孫、哈哥斯的子孫、巴西萊的子孫；因為他們的先祖娶了基列人巴西萊的女兒為妻，所以起名叫巴西萊。',
    '拉2:62 這三家的人在族譜之中尋查自己的譜系，卻尋不著，因此算為不潔，不准供祭司的職任。',
    '拉2:63 省長對他們說：不可吃至聖的物，直到有用烏陵和土明決疑的祭司興起來。',
    '拉2:64 會眾共有四萬二千三百六十名。',
    '拉2:65 此外，還有他們的僕婢七千三百三十七名，又有歌唱的男女二百名。',
    '拉2:66 他們有馬七百三十六匹，騾子二百四十五匹，',
    '拉2:67 駱駝四百三十五隻，驢六千七百二十匹。',
    '拉2:68 有些族長到了耶路撒冷耶和華殿的地方，便為神的殿甘心獻上禮物，要重新建造。',
    '拉2:69 他們量力捐入工程庫的金子六萬一千達利克，銀子五千彌拿，並祭司的禮服一百件。',
    '拉2:70 於是祭司、利未人、民中的一些人、歌唱的、守門的、尼提寧，並以色列眾人，各住在自己的城裡。',
    '拉3:1 到了七月，以色列人住在各城；那時他們如同一人，聚集在耶路撒冷。',
    '拉3:2 約薩達的兒子耶書亞和他的弟兄眾祭司，並撒拉鐵的兒子所羅巴伯與他的弟兄，都起來建築以色列神的壇，要照神人摩西律法書上所寫的，在壇上獻燔祭。',
    '拉3:3 他們在原有的根基上築壇，因懼怕鄰國的民，又在其上向耶和華早晚獻燔祭，',
    '拉3:4 又照律法書上所寫的守住棚節，按數照例獻每日所當獻的燔祭；',
    '拉3:5 其後獻常獻的燔祭，並在月朔與耶和華的一切聖節獻祭，又向耶和華獻各人的甘心祭。',
    '拉3:6 從七月初一日起，他們就向耶和華獻燔祭。但耶和華殿的根基尚未立定。',
    '拉3:7 他們又將銀子給石匠、木匠，把糧食、酒、油給西頓人、推羅人，使他們將香柏樹從利巴嫩運到海裡，浮海運到約帕，是照波斯王古列所允准的。',
    '拉3:8 百姓到了耶路撒冷神殿的地方。第二年二月，撒拉鐵的兒子所羅巴伯，約薩達的兒子耶書亞和其餘的弟兄，就是祭司、利未人，並一切被擄歸回耶路撒冷的人，都興工建造；又派利未人，從二十歲以外的，督理建造耶和華殿的工作。',
    '拉3:9 於是猶大（在二章四十節作何達威雅）的後裔，就是耶書亞和他的子孫與弟兄，甲篾和他的子孫，利未人希拿達的子孫與弟兄，都一同起來，督理那在神殿做工的人。',
    '拉3:10 匠人立耶和華殿根基的時候，祭司皆穿禮服吹號，亞薩的子孫利未人敲鈸，照以色列王大衛所定的例，都站著讚美耶和華。',
    '拉3:11 他們彼此唱和，讚美稱謝耶和華說：他本為善，他向以色列人永發慈愛。他們讚美耶和華的時候，眾民大聲呼喊，因耶和華殿的根基已經立定。',
    '拉3:12 然而有許多祭司、利未人、族長，就是見過舊殿的老年人，現在親眼看見立這殿的根基，便大聲哭號，也有許多人大聲歡呼，',
    '拉3:13 甚至百姓不能分辨歡呼的聲音和哭號的聲音；因為眾人大聲呼喊，聲音聽到遠處。',
    '拉4:1 猶大和便雅憫的敵人聽說被擄歸回的人為耶和華─以色列的神建造殿宇，',
    '拉4:2 就去見所羅巴伯和以色列的族長，對他們說：請容我們與你們一同建造；因為我們尋求你們的神，與你們一樣。自從亞述王以撒哈頓帶我們上這地以來，我們常祭祀神。',
    '拉4:3 但所羅巴伯、耶書亞，和其餘以色列的族長對他們說：我們建造神的殿與你們無干，我們自己為耶和華─以色列的神協力建造，是照波斯王古列所吩咐的。',
    '拉4:4 那地的民，就在猶大人建造的時候，使他們的手發軟，擾亂他們；',
    '拉4:5 從波斯王古列年間，直到波斯王大利烏登基的時候，賄買謀士，要敗壞他們的謀算。',
    '拉4:6 在亞哈隨魯才登基的時候，上本控告猶大和耶路撒冷的居民。',
    '拉4:7 亞達薛西年間，比施蘭、米特利達、他別，和他們的同黨上本奏告波斯王亞達薛西。本章是用亞蘭文字，亞蘭方言。',
    '拉4:8 省長利宏、書記伸帥要控告耶路撒冷人，也上本奏告亞達薛西王。',
    '拉4:9 省長利宏、書記伸帥，和同黨的底拿人、亞法薩提迦人、他毘拉人、亞法撒人、亞基衛人、巴比倫人、書珊迦人、底亥人、以攔人，',
    '拉4:10 和尊大的亞斯那巴所遷移、安置在撒瑪利亞城，並大河西一帶地方的人等，',
    '拉4:11 上奏亞達薛西王說：河西的臣民云云：',
    '拉4:12 王該知道，從王那裡上到我們這裡的猶大人，已經到耶路撒冷重建這反叛惡劣的城，築立根基，建造城牆。',
    '拉4:13 如今王該知道，他們若建造這城，城牆完畢就不再與王進貢，交課，納稅，終久王必受虧損。',
    '拉4:14 我們既食御鹽，不忍見王吃虧，因此奏告於王。',
    '拉4:15 請王考察先王的實錄，必在其上查知這城是反叛的城，與列王和各省有害；自古以來，其中常有悖逆的事，因此這城曾被拆毀。',
    '拉4:16 我們謹奏王知，這城若再建造，城牆完畢，河西之地王就無分了。',
    '拉4:17 那時王諭覆省長利宏、書記伸帥，和他們的同黨，就是住撒瑪利亞並河西一帶地方的人，說：願你們平安云云。',
    '拉4:18 你們所上的本，已經明讀在我面前。',
    '拉4:19 我已命人考查，得知此城古來果然背叛列王，其中常有反叛悖逆的事。',
    '拉4:20 從前耶路撒冷也有大君王統管河西全地，人就給他們進貢，交課，納稅。',
    '拉4:21 現在你們要出告示命這些人停工，使這城不得建造，等我降旨。',
    '拉4:22 你們當謹慎，不可遲延，為何容害加重，使王受虧損呢﹖',
    '拉4:23 亞達薛西王的上諭讀在利宏和書記伸帥，並他們的同黨面前，他們就急忙往耶路撒冷去見猶大人，用勢力強迫他們停工。',
    '拉4:24 於是，在耶路撒冷神殿的工程就停止了，直停到波斯王大利烏第二年。',
    '拉5:1 那時，先知哈該和易多的孫子撒迦利亞奉以色列神的名向猶大和耶路撒冷的猶大人說勸勉的話。',
    '拉5:2 於是撒拉鐵的兒子所羅巴伯和約薩達的兒子耶書亞都起來動手建造耶路撒冷神的殿，有神的先知在那裡幫助他們。',
    '拉5:3 當時河西的總督達乃和示他波斯乃，並他們的同黨來問說：誰降旨讓你們建造這殿，修成這牆呢﹖',
    '拉5:4 我們便告訴他們建造這殿的人叫什麼名字。',
    '拉5:5 神的眼目看顧猶大的長老，以致總督等沒有叫他們停工，直到這事奏告大利烏，得著他的回諭。',
    '拉5:6 河西的總督達乃和示他波斯乃，並他們的同黨，就是住河西的亞法薩迦人，上本奏告大利烏王。',
    '拉5:7 本上寫著說：願大利烏王諸事平安。',
    '拉5:8 王該知道，我們往猶大省去，到了至大神的殿，這殿是用大石建造的。梁木插入牆內，工作甚速，他們手下亨通。',
    '拉5:9 我們就問那些長老說：誰降旨讓你們建造這殿，修成這牆呢﹖',
    '拉5:10 又問他們的名字，要記錄他們首領的名字，奏告於王。',
    '拉5:11 他們回答說：我們是天地之神的僕人，重建前多年所建造的殿，就是以色列的一位大君王建造修成的。',
    '拉5:12 只因我們列祖惹天上的神發怒，神把他們交在迦勒底人巴比倫王尼布甲尼撒的手中，他就拆毀這殿，又將百姓擄到巴比倫。',
    '拉5:13 然而巴比倫王古列元年，他降旨允准建造神的這殿。',
    '拉5:14 神殿中的金、銀器皿，就是尼布甲尼撒從耶路撒冷的殿中掠去帶到巴比倫廟裡的，古列王從巴比倫廟裡取出來，交給派為省長的，名叫設巴薩，',
    '拉5:15 對他說可以將這些器皿帶去，放在耶路撒冷的殿中，在原處建造神的殿。',
    '拉5:16 於是這設巴薩來建立耶路撒冷神殿的根基。這殿從那時直到如今尚未造成。',
    '拉5:17 現在王若以為美，請察巴比倫王的府庫，看古列王降旨允准在耶路撒冷建造神的殿沒有，王的心意如何﹖請降旨曉諭我們。',
    '拉6:1 於是大利烏王降旨，要尋察典籍庫內，就是在巴比倫藏寶物之處；',
    '拉6:2 在瑪代省亞馬他城的宮內尋得一卷，其中記著說：',
    '拉6:3 古列王元年，他降旨論到耶路撒冷神的殿，要建造這殿為獻祭之處，堅立殿的根基。殿高六十肘，，寬六十肘，',
    '拉6:4 用三層大石頭，一層新木頭，經費要出於王庫；',
    '拉6:5 並且神殿的金銀器皿，就是尼布甲尼撒從耶路撒冷的殿中掠到巴比倫的，要歸還帶到耶路撒冷的殿中，各按原處放在神的殿裡。',
    '拉6:6 現在河西的總督達乃和示他波斯乃，並你們的同黨，就是住河西的亞法薩迦人，你們當遠離他們。',
    '拉6:7 不要攔阻神殿的工作，任憑猶大人的省長和猶大人的長老在原處建造神的這殿。',
    '拉6:8 我又降旨，吩咐你們向猶大人的長老為建造神的殿當怎樣行，就是從河西的款項中，急速撥取貢銀作他們的經費，免得耽誤工作。',
    '拉6:9 他們與天上的神獻燔祭所需用的公牛犢、公綿羊、綿羊羔，並所用的麥子、鹽、酒、油，都要照耶路撒冷祭司的話，每日供給他們，不得有誤；',
    '拉6:10 好叫他們獻馨香的祭給天上的神，又為王和王眾子的壽命祈禱。',
    '拉6:11 我再降旨，無論誰更改這命令，必從他房屋中拆出一根梁來，把他舉起，懸在其上，又使他的房屋成為糞堆。',
    '拉6:12 若有王和民伸手更改這命令，拆毀這殿，願那使耶路撒冷的殿作為他名居所的神將他們滅絕。我─大利烏降這旨意，當速速遵行。',
    '拉6:13 於是，河西總督達乃和示他波斯乃，並他們的同黨，因大利烏王所發的命令，就急速遵行。',
    '拉6:14 猶大長老因先知哈該和易多的孫子撒迦利亞所說勸勉的話就建造這殿，凡事亨通。他們遵著以色列神的命令和波斯王古列、大利烏、亞達薛西的旨意，建造完畢。',
    '拉6:15 大利烏王第六年，亞達月初三日，這殿修成了。',
    '拉6:16 以色列的祭司和利未人，並其餘被擄歸回的人都歡歡喜喜地行奉獻神殿的禮。',
    '拉6:17 行奉獻神殿的禮就獻公牛一百隻，公綿羊二百隻，綿羊羔四百隻，又照以色列支派的數目獻公山羊十二隻，為以色列眾人作贖罪祭；',
    '拉6:18 且派祭司和利未人按著班次在耶路撒冷事奉神，是照摩西律法書上所寫的。',
    '拉6:19 正月十四日，被擄歸回的人守逾越節。',
    '拉6:20 原來，祭司和利未人一同自潔，無一人不潔淨。利未人為被擄歸回的眾人和他們的弟兄眾祭司，並為自己宰逾越節的羊羔。',
    '拉6:21 從擄到之地歸回的以色列人和一切除掉所染外邦人污穢、歸附他們、要尋求耶和華─以色列神的人都吃這羊羔，',
    '拉6:22 歡歡喜喜地守除酵節七日；因為耶和華使他們歡喜，又使亞述王的心轉向他們，堅固他們的手，作以色列神殿的工程。',
    '拉7:1 這事以後，波斯王亞達薛西年間，有個以斯拉，他是西萊雅的兒子，西萊雅是亞撒利雅的兒子，亞撒利雅是希勒家的兒子，',
    '拉7:2 希勒家是沙龍的兒子，沙龍是撒督的兒子，撒督是亞希突的兒子，',
    '拉7:3 亞希突是亞瑪利雅的兒子，亞瑪利雅是亞撒利雅的兒子，亞撒利雅是米拉約的兒子，',
    '拉7:4 米拉約是西拉希雅的兒子，西拉希雅是烏西的兒子，烏西是布基的兒子，',
    '拉7:5 布基是亞比書的兒子，亞比書是非尼哈的兒子，非尼哈是以利亞撒的兒子，以利亞撒是大祭司亞倫的兒子。',
    '拉7:6 這以斯拉從巴比倫上來，他是敏捷的文士，通達耶和華─以色列神所賜摩西的律法書。王允准他一切所求的，是因耶和華─他神的手幫助他。',
    '拉7:7 亞達薛西王第七年，以色列人、祭司、利未人、歌唱的、守門的、尼提寧，有上耶路撒冷的。',
    '拉7:8 王第七年五月，以斯拉到了耶路撒冷。',
    '拉7:9 正月初一日，他從巴比倫起程；因他神施恩的手幫助他，五月初一日就到了耶路撒冷。',
    '拉7:10 以斯拉定志考究遵行耶和華的律法，又將律例典章教訓以色列人。',
    '拉7:11 祭司以斯拉是通達耶和華誡命和賜以色列之律例的文士。亞達薛西王賜給他們諭旨，上面寫著說：',
    '拉7:12 諸王之王亞達薛西，達於祭司以斯拉通達天上神律法大德的文士，云云。',
    '拉7:13 住在我國中的以色列人、祭司、利未人，凡甘心上耶路撒冷去的，我降旨准他們與你同去。',
    '拉7:14 王與七個謀士既然差你去，照你手中神的律法書察問猶大和耶路撒冷的景況；',
    '拉7:15 又帶金銀，就是王和謀士甘心獻給住耶路撒冷、以色列神的，',
    '拉7:16 並帶你在巴比倫全省所得的金銀，和百姓、祭司樂意獻給耶路撒冷─他們神殿的禮物。',
    '拉7:17 所以你當用這金銀，急速買公牛、公綿羊、綿羊羔，和同獻的素祭奠祭之物，獻在耶路撒冷─你們神殿的壇上。',
    '拉7:18 剩下的金銀，你和你的弟兄看著怎樣好，就怎樣用，總要遵著你們神的旨意。',
    '拉7:19 所交給你神殿中使用的器皿，你要交在耶路撒冷神面前。',
    '拉7:20 你神殿裡若再有需用的經費，你可以從王的府庫裡支取。',
    '拉7:21 我─亞達薛西王又降旨與河西的一切庫官，說：通達天上神律法的文士祭司以斯拉，無論向你們要什麼，你們要速速地備辦，',
    '拉7:22 就是銀子直到一百他連得，麥子一百柯珥，酒一百罷特，油一百罷特，鹽不計其數，也要給他。',
    '拉7:23 凡天上之神所吩咐的，當為天上神的殿詳細辦理。為何使忿怒臨到王和王眾子的國呢﹖',
    '拉7:24 我又曉諭你們，至於祭司、利未人、歌唱的、守門的，和尼提寧，並在神殿當差的人，不可叫他們進貢，交課，納稅。',
    '拉7:25 以斯拉啊，要照著你神賜你的智慧，將所有明白你神律法的人立為士師、審判官，治理河西的百姓，使他們教訓一切不明白神律法的人。',
    '拉7:26 凡不遵行你神律法和王命令的人就當速速定他的罪，或治死，或充軍，或抄家，或囚禁。',
    '拉7:27 以斯拉說：耶和華─我們列祖的神是應當稱頌的！因他使王起這心意修飾耶路撒冷耶和華的殿，',
    '拉7:28 又在王和謀士，並大能的軍長面前施恩於我。因耶和華─我神的手幫助我，我就得以堅強，從以色列中招聚首領，與我一同上來。',
    '拉8:1 當亞達薛西王年間，同我從巴比倫上來的人，他們的族長和他們的家譜記在下面：',
    '拉8:2 屬非尼哈的子孫有革順；屬以他瑪的子孫有但以理；屬大衛的子孫有哈突；',
    '拉8:3 屬巴錄的後裔，就是示迦尼的子孫有撒迦利亞，同著他，按家譜計算，男丁一百五十人；',
    '拉8:4 屬巴哈摩押的子孫有西拉希雅的兒子以利約乃，同著他有男丁二百；',
    '拉8:5 屬示迦尼的子孫有雅哈悉的兒子，同著他有男丁三百；',
    '拉8:6 屬亞丁的子孫有約拿單的兒子以別，同著他有男丁五十；',
    '拉8:7 屬以攔的子孫有亞他利雅的兒子耶篩亞，同著他有男丁七十；',
    '拉8:8 屬示法提雅的子孫有米迦勒的兒子西巴第雅，同著他有男丁八十；',
    '拉8:9 屬約押的子孫有耶歇的兒子俄巴底亞，同著他有男丁二百一十八；',
    '拉8:10 屬示羅密的子孫有約細斐的兒子，同著他有男丁一百六十；',
    '拉8:11 屬比拜的子孫有比拜的兒子撒迦利亞，同著他有男丁二十八；',
    '拉8:12 屬押甲的子孫有哈加坦的兒子約哈難，同著他有男丁一百一十；',
    '拉8:13 屬亞多尼干的子孫，就是末尾的，他們的名字是以利法列、耶利、示瑪雅，同著他們有男丁六十；',
    '拉8:14 屬比革瓦伊的子孫有烏太和撒布，同著他們有男丁七十。',
    '拉8:15 我招聚這些人在流入亞哈瓦的河邊，我們在那裡住了三日。我查看百姓和祭司，見沒有利未人在那裡，',
    '拉8:16 就召首領以利以謝、亞列、示瑪雅、以利拿單、雅立、以利拿單、拿單、撒迦利亞、米書蘭，又召教習約雅立和以利拿單。',
    '拉8:17 我打發他們往迦西斐雅地方去見那裡的首領易多，又告訴他們當向易多和他的弟兄尼提寧說什麼話，叫他們為我們神的殿帶使用的人來。',
    '拉8:18 蒙我們神施恩的手幫助我們，他們在以色列的曾孫、利未的孫子、抹利的後裔中帶一個通達人來；還有示利比和他的眾子與弟兄共一十八人。',
    '拉8:19 又有哈沙比雅，同著他有米拉利的子孫耶篩亞，並他的眾子和弟兄共二十人。',
    '拉8:20 從前大衛和眾首領派尼提寧服事利未人，現在從這尼提寧中也帶了二百二十人來，都是按名指定的。',
    '拉8:21 那時，我在亞哈瓦河邊宣告禁食，為要在我們神面前克苦己心，求他使我們和婦人孩子，並一切所有的，都得平坦的道路。',
    '拉8:22 我求王撥步兵馬兵幫助我們抵擋路上的仇敵，本以為羞恥；因我曾對王說：我們神施恩的手必幫助一切尋求他的；但他的能力和忿怒必攻擊一切離棄他的。',
    '拉8:23 所以我們禁食祈求我們的神，他就應允了我們。',
    '拉8:24 我分派祭司長十二人，就是示利比、哈沙比雅，和他們的弟兄十人，',
    '拉8:25 將王和謀士、軍長，並在那裡的以色列眾人為我們神殿所獻的金銀和器皿，都秤了交給他們。',
    '拉8:26 我秤了交在他們手中的銀子有六百五十他連得；銀器重一百他連得；金子一百他連得；',
    '拉8:27 金碗二十個，重一千達利克；上等光銅的器皿兩個，寶貴如金。',
    '拉8:28 我對他們說：你們歸耶和華為聖，器皿也為聖；金銀是甘心獻給耶和華─你們列祖之神的。',
    '拉8:29 你們當警醒看守，直到你們在耶路撒冷耶和華殿的庫內，在祭司長和利未族長，並以色列的各族長面前過了秤。',
    '拉8:30 於是，祭司、利未人按著分量接受金銀和器皿，要帶到耶路撒冷我們神的殿裡。',
    '拉8:31 正月十二日，我們從亞哈瓦河邊起行，要往耶路撒冷去。我們神的手保佑我們，救我們脫離仇敵和路上埋伏之人的手。',
    '拉8:32 我們到了耶路撒冷，在那裡住了三日。',
    '拉8:33 第四日，在我們神的殿裡把金銀和器皿都秤了，交在祭司烏利亞的兒子米利末的手中。同著他有非尼哈的兒子以利亞撒，還有利未人耶書亞的兒子約撒拔和賓內的兒子挪亞底。',
    '拉8:34 當時都點了數目，按著分量寫在冊上。',
    '拉8:35 從擄到之地歸回的人向以色列的神獻燔祭，就是為以色列眾人獻公牛十二隻，公綿羊九十六隻，綿羊羔七十七隻，又獻公山羊十二隻作贖罪祭，這都是向耶和華焚獻的。',
    '拉8:36 他們將王的諭旨交給王所派的總督與河西的省長，他們就幫助百姓，又供給神殿裡所需用的。',
    '拉9:1 這事做完了，眾首領來見我，說：以色列民和祭司並利未人，沒有離絕迦南人、赫人、比利洗人、耶布斯人、亞捫人、摩押人、埃及人、亞摩利人，仍效法這些國的民，行可憎的事。',
    '拉9:2 因他們為自己和兒子娶了這些外邦女子為妻，以致聖潔的種類和這些國的民混雜；而且首領和官長在這事上為罪魁。',
    '拉9:3 我一聽見這事，就撕裂衣服和外袍，拔了頭髮和鬍鬚，驚懼憂悶而坐。',
    '拉9:4 凡為以色列神言語戰兢的，都因這被擄歸回之人所犯的罪聚集到我這裡來。我就驚懼憂悶而坐，直到獻晚祭的時候。',
    '拉9:5 獻晚祭的時候我起來，心中愁苦，穿著撕裂的衣袍，雙膝跪下向耶和華─我的神舉手，',
    '拉9:6 說：我的神啊，我抱愧蒙羞，不敢向我神仰面；因為我們的罪孽滅頂，我們的罪惡滔天。',
    '拉9:7 從我們列祖直到今日，我們的罪惡甚重；因我們的罪孽，我們和君王、祭司都交在外邦列王的手中，殺害、擄掠、搶奪、臉上蒙羞正如今日的光景。',
    '拉9:8 現在耶和華─我們的神暫且施恩與我們，給我們留些逃脫的人，使我們安穩如釘子釘在他的聖所，我們的神好光照我們的眼目，使我們在受轄制之中稍微復興。',
    '拉9:9 我們是奴僕，然而在受轄制之中，我們的神仍沒有丟棄我們，在波斯王眼前向我們施恩，叫我們復興，能重建我們神的殿，修其毀壞之處，使我們在猶大和耶路撒冷有牆垣。',
    '拉9:10 我們的神啊，既是如此，我們還有什麼話可說呢﹖因為我們已經離棄你的命令，',
    '拉9:11 就是你藉你僕人眾先知所吩咐的說：你們要去得為業之地是污穢之地；因列國之民的污穢和可憎的事，叫全地從這邊直到那邊滿了污穢。',
    '拉9:12 所以不可將你們的女兒嫁他們的兒子，也不可為你們的兒子娶他們的女兒，永不可求他們的平安和他們的利益，這樣你們就可以強盛，吃這地的美物，並遺留這地給你們的子孫永遠為業。',
    '拉9:13 神啊，我們因自己的惡行和大罪，遭遇了這一切的事，並且你刑罰我們輕於我們罪所當得的，又給我們留下這些人。',
    '拉9:14 我們豈可再違背你的命令，與這行可憎之事的民結親呢﹖若這樣行，你豈不向我們發怒，將我們滅絕，以致沒有一個剩下逃脫的人嗎﹖',
    '拉9:15 耶和華─以色列的神啊，因你是公義的，我們這剩下的人才得逃脫，正如今日的光景。看哪，我們在你面前有罪惡，因此無人在你面前站立得住。',
    '拉10:1 以斯拉禱告，認罪，哭泣，俯伏在神殿前的時候，有以色列中的男女孩童聚集到以斯拉那裡，成了大會，眾民無不痛哭。',
    '拉10:2 屬以攔的子孫、耶歇的兒子示迦尼對以斯拉說：我們在此地娶了外邦女子為妻，干犯了我們的神，然而以色列人還有指望。',
    '拉10:3 現在當與我們的神立約，休這一切的妻，離絕他們所生的，照著我主和那因神命令戰兢之人所議定的，按律法而行。',
    '拉10:4 你起來，這是你當辦的事，我們必幫助你，你當奮勉而行。',
    '拉10:5 以斯拉便起來，使祭司長和利未人，並以色列眾人起誓說，必照這話去行；他們就起了誓。',
    '拉10:6 以斯拉從神殿前起來，進入以利亞實的兒子約哈難的屋裡，到了那裡不吃飯，也不喝水；因為被擄歸回之人所犯的罪，心裡悲傷。',
    '拉10:7 他們通告猶大和耶路撒冷被擄歸回的人，叫他們在耶路撒冷聚集。',
    '拉10:8 凡不遵首領和長老所議定、三日之內不來的，就必抄他的家，使他離開被擄歸回之人的會。',
    '拉10:9 於是，猶大和便雅憫眾人，三日之內都聚集在耶路撒冷。那日正是九月二十日，眾人都坐在神殿前的寬闊處；因這事，又因下大雨，就都戰兢。',
    '拉10:10 祭司以斯拉站起來，對他們說：你們有罪了；因你們娶了外邦的女子為妻，增添以色列人的罪惡。',
    '拉10:11 現在當向耶和華─你們列祖的神認罪，遵行他的旨意，離絕這些國的民和外邦的女子。',
    '拉10:12 會眾都大聲回答說：我們必照著你的話行，',
    '拉10:13 只是百姓眾多，又逢大雨的時令，我們不能站在外頭，這也不是一兩天辦完的事，因我們在這事上犯了大罪；',
    '拉10:14 不如為全會眾派首領辦理。凡我們城邑中娶外邦女子為妻的，當按所定的日期，同著本城的長老和士師而來，直到辦完這事，神的烈怒就轉離我們了。',
    '拉10:15 惟有亞撒黑的兒子約拿單，特瓦的兒子雅哈謝阻擋（或譯：總辦）這事，並有米書蘭和利未人沙比太幫助他們。',
    '拉10:16 被擄歸回的人如此而行。祭司以斯拉和些族長按著宗族都指名見派；在十月初一日，一同在座查辦這事，',
    '拉10:17 到正月初一日，才查清娶外邦女子的人數。',
    '拉10:18 在祭司中查出娶外邦女子為妻的，就是耶書亞的子孫約薩達的兒子，和他弟兄瑪西雅、以利以謝、雅立、基大利；',
    '拉10:19 他們便應許必休他們的妻。他們因有罪，就獻群中的一隻公綿羊贖罪。',
    '拉10:20 音麥的子孫中，有哈拿尼、西巴第雅。',
    '拉10:21 哈琳的子孫中，有瑪西雅、以利雅、示瑪雅、耶歇、烏西雅。',
    '拉10:22 巴施戶珥的子孫中，有以利約乃、瑪西雅、以實瑪利、拿坦業、約撒拔、以利亞撒。',
    '拉10:23 利未人中，有約撒拔、示每、基拉雅（基拉雅就是基利他），還有毘他希雅、猶大、以利以謝。',
    '拉10:24 歌唱的人中有以利亞實。守門的人中，有沙龍、提聯、烏利。',
    '拉10:25 以色列人巴錄的子孫中，有拉米、耶西雅、瑪基雅、米雅民、以利亞撒、瑪基雅、比拿雅。',
    '拉10:26 以攔的子孫中，有瑪他尼、撒迦利亞、耶歇、押底、耶利末、以利雅。',
    '拉10:27 薩土的子孫中，有以利約乃、以利亞實、瑪他尼、耶利末、撒拔、亞西撒。',
    '拉10:28 比拜的子孫中，有約哈難、哈拿尼雅、薩拜、亞勒。',
    '拉10:29 巴尼的子孫中，有米書蘭、瑪鹿、亞大雅、雅述、示押、耶利末。',
    '拉10:30 巴哈摩押的子孫中，有阿底拿、基拉、比拿雅、瑪西雅、瑪他尼、比撒列、賓內、瑪拿西。',
    '拉10:31 哈琳的子孫中，有以利以謝、伊示雅、瑪基雅、示瑪雅、西緬、',
    '拉10:32 便雅憫、瑪鹿、示瑪利雅。',
    '拉10:33 哈順的子孫中，有瑪特乃、瑪達他、撒拔、以利法列、耶利買、瑪拿西、示每。',
    '拉10:34 巴尼的子孫中，有瑪玳、暗蘭、烏益、',
    '拉10:35 比拿雅、比底雅、基祿、',
    '拉10:36 瓦尼雅、米利末、以利亞實、',
    '拉10:37 瑪他尼、瑪特乃、雅掃、',
    '拉10:38 巴尼、賓內、示每、',
    '拉10:39 示利米雅、拿單、亞大雅、',
    '拉10:40 瑪拿底拜、沙賽、沙賴、',
    '拉10:41 亞薩利、示利米雅、示瑪利雅、',
    '拉10:42 沙龍、亞瑪利雅、約瑟。',
    '拉10:43 尼波的子孫中，有耶利、瑪他提雅、撒拔、西比拿、雅玳、約珥、比拿雅。',
    '拉10:44 這些人都娶了外邦女子為妻，其中也有生了兒女的。',
    '尼1:1 哈迦利亞的兒子尼希米的言語如下：亞達薛西王二十年基斯流月，我在書珊城的宮中。',
    '尼1:2 那時，有我一個弟兄哈拿尼，同著幾個人從猶大來。我問他們那些被擄歸回、剩下逃脫的猶大人和耶路撒冷的光景。',
    '尼1:3 他們對我說：那些被擄歸回剩下的人在猶大省遭大難，受凌辱；並且耶路撒冷的城牆拆毀，城門被火焚燒。',
    '尼1:4 我聽見這話，就坐下哭泣，悲哀幾日，在天上的神面前禁食祈禱，說：',
    '尼1:5 耶和華─天上的神，大而可畏的神啊，你向愛你、守你誡命的人守約施慈愛。',
    '尼1:6 願你睜眼看，側耳聽，你僕人晝夜在你面前為你眾僕人以色列民的祈禱，承認我們以色列人向你所犯的罪；我與我父家都有罪了。',
    '尼1:7 我們向你所行的甚是邪惡，沒有遵守你藉著僕人摩西所吩咐的誡命、律例、典章。',
    '尼1:8 求你記念所吩咐你僕人摩西的話，說：你們若犯罪，我就把你們分散在萬民中；',
    '尼1:9 但你們若歸向我，謹守遵行我的誡命，你們被趕散的人雖在天涯，我也必從那裡將他們招聚回來，帶到我所選擇立為我名的居所。',
    '尼1:10 這都是你的僕人、你的百姓，就是你用大力和大能的手所救贖的。',
    '尼1:11 主啊，求你側耳聽你僕人的祈禱，和喜愛敬畏你名眾僕人的祈禱，使你僕人現今亨通，在王面前蒙恩。我是作王酒政的。',
    '尼2:1 亞達薛西王二十年尼散月，在王面前擺酒，我拿起酒來奉給王。我素來在王面前沒有愁容。',
    '尼2:2 王對我說：你既沒有病，為什麼面帶愁容呢﹖這不是別的，必是你心中愁煩。於是我甚懼怕。',
    '尼2:3 我對王說：願王萬歲！我列祖墳墓所在的那城荒涼，城門被火焚燒，我豈能面無愁容嗎﹖',
    '尼2:4 王問我說：你要求什麼﹖於是我默禱天上的神。',
    '尼2:5 我對王說：僕人若在王眼前蒙恩，王若喜歡，求王差遣我往猶大，到我列祖墳墓所在的那城去，我好重新建造。',
    '尼2:6 那時王后坐在王的旁邊。王問我說：你去要多少日子﹖幾時回來﹖我就定了日期。於是王喜歡差遣我去。',
    '尼2:7 我又對王說：王若喜歡，求王賜我詔書，通知大河西的省長准我經過，直到猶大；',
    '尼2:8 又賜詔書，通知管理王園林的亞薩，使他給我木料，做屬殿營樓之門的橫梁和城牆，與我自己房屋使用的。王就允准我，因我神施恩的手幫助我。',
    '尼2:9 王派了軍長和馬兵護送我。我到了河西的省長那裡，將王的詔書交給他們。',
    '尼2:10 和倫人參巴拉，並為奴的亞捫人多比雅，聽見有人來為以色列人求好處，就甚惱怒。',
    '尼2:11 我到了耶路撒冷，在那裡住了三日。',
    '尼2:12 我夜間起來，有幾個人也一同起來；但神使我心裡要為耶路撒冷做什麼事，我並沒有告訴人。除了我騎的牲口以外，也沒有別的牲口在我那裡。',
    '尼2:13 當夜我出了谷門，往野狗井去（野狗：或譯龍），到了糞廠門，察看耶路撒冷的城牆，見城牆拆毀，城門被火焚燒。',
    '尼2:14 我又往前，到了泉門和王池，但所騎的牲口沒有地方過去。',
    '尼2:15 於是夜間沿溪而上，察看城牆，又轉身進入谷門，就回來了。',
    '尼2:16 我往哪裡去，我做什麼事，官長都不知道。我還沒有告訴猶大平民、祭司、貴冑、官長，和其餘做工的人。',
    '尼2:17 以後，我對他們說：我們所遭的難，耶路撒冷怎樣荒涼，城門被火焚燒，你們都看見了。來吧，我們重建耶路撒冷的城牆，免得再受凌辱！',
    '尼2:18 我告訴他們我神施恩的手怎樣幫助我，並王對我所說的話。他們就說：我們起來建造吧！於是他們奮勇做這善工。',
    '尼2:19 但和倫人參巴拉，並為奴的亞捫人多比雅和亞拉伯人基善聽見就嗤笑我們，藐視我們，說：你們做什麼呢﹖要背叛王嗎﹖',
    '尼2:20 我回答他們說：天上的神必使我們亨通。我們作他僕人的，要起來建造；你們卻在耶路撒冷無分、無權、無記念。',
    '尼3:1 那時，大祭司以利亞實和他的弟兄眾祭司起來建立羊門，分別為聖，安立門扇，又築城牆到哈米亞樓，直到哈楠業樓，分別為聖。',
    '尼3:2 其次是耶利哥人建造。其次是音利的兒子撒刻建造。',
    '尼3:3 哈西拿的子孫建立魚門，架橫梁、安門扇，和閂鎖。',
    '尼3:4 其次是哈哥斯的孫子、烏利亞的兒子米利末修造。其次是米示薩別的孫子、比利迦的兒子米書蘭修造。其次是巴拿的兒子撒督修造。',
    '尼3:5 其次是提哥亞人修造；但是他們的貴冑不用肩（原文是頸項）擔他們主的工作。',
    '尼3:6 巴西亞的兒子耶何耶大與比所玳的兒子米書蘭修造古門，架橫梁，安門扇和閂鎖。',
    '尼3:7 其次是基遍人米拉提，米倫人雅頓與基遍人，並屬河西總督所管的米斯巴人修造。',
    '尼3:8 其次是銀匠哈海雅的兒子烏薛修造。其次是做香的哈拿尼雅修造。這些人修堅耶路撒冷，直到寬牆。',
    '尼3:9 其次是管理耶路撒冷一半、戶珥的兒子利法雅修造。',
    '尼3:10 其次是哈路抹的兒子耶大雅對著自己的房屋修造。其次是哈沙尼的兒子哈突修造。',
    '尼3:11 哈琳的兒子瑪基雅和巴哈摩押的兒子哈述修造一段，並修造爐樓。',
    '尼3:12 其次是管理耶路撒冷那一半、哈羅黑的兒子沙龍和他的女兒們修造。',
    '尼3:13 哈嫩和撒挪亞的居民修造谷門，立門，安門扇和閂鎖，又建築城牆一千肘，直到糞廠門。',
    '尼3:14 管理伯哈基琳、利甲的兒子瑪基雅修造糞廠門，立門，安門扇和閂鎖。',
    '尼3:15 管理米斯巴、各荷西的兒子沙崙修造泉門，立門，蓋門頂，安門扇和閂鎖，又修造靠近王園西羅亞池的牆垣，直到那從大衛城下來的臺階。',
    '尼3:16 其次是管理伯夙一半、押卜的兒子尼希米修造，直到大衛墳地的對面，又到挖成的池子，並勇士的房屋。',
    '尼3:17 其次是利未人巴尼的兒子利宏修造。其次是管理基伊拉一半、哈沙比雅為他所管的本境修造。',
    '尼3:18 其次是利未人弟兄中管理基伊拉那一半、希拿達的兒子巴瓦伊修造。',
    '尼3:19 其次是管理米斯巴、耶書亞的兒子以謝修造一段，對著武庫的上坡、城牆轉彎之處。',
    '尼3:20 其次是薩拜的兒子巴錄竭力修造一段，從城牆轉彎，直到大祭司以利亞實的府門。',
    '尼3:21 其次是哈哥斯的孫子、烏利亞的兒子米利末修造一段，從以利亞實的府門，直到以利亞實府的盡頭。',
    '尼3:22 其次是住平原的祭司修造。',
    '尼3:23 其次是便雅憫與哈述對著自己的房屋修造。其次是亞難尼的孫子、瑪西雅的兒子亞撒利雅在靠近自己的房屋修造。',
    '尼3:24 其次是希拿達的兒子賓內修造一段，從亞撒利雅的房屋直到城牆轉彎，又到城角。',
    '尼3:25 烏賽的兒子巴拉修造對著城牆的轉彎和王上宮凸出來的城樓，靠近護衛院的那一段。其次是巴錄的兒子毘大雅修造。',
    '尼3:26 （尼提寧住在俄斐勒，直到朝東水門的對面和凸出來的城樓。）',
    '尼3:27 其次是提哥亞人又修一段，對著那凸出來的大樓，直到俄斐勒的牆。',
    '尼3:28 從馬門往上，眾祭司各對自己的房屋修造。',
    '尼3:29 其次是音麥的兒子撒督對著自己的房屋修造。其次是守東門、示迦尼的兒子示瑪雅修造。',
    '尼3:30 其次是示利米雅的兒子哈拿尼雅和薩拉的第六子哈嫩又修一段。其次是比利迦的兒子米書蘭對著自己的房屋修造。',
    '尼3:31 其次是銀匠瑪基雅修造到尼提寧和商人的房屋，對著哈米弗甲門，直到城的角樓。',
    '尼3:32 銀匠與商人在城的角樓和羊門中間修造。',
    '尼4:1 參巴拉聽見我們修造城牆就發怒，大大惱恨，嗤笑猶大人，',
    '尼4:2 對他弟兄和撒瑪利亞的軍兵說：這些軟弱的猶大人做什麼呢﹖要保護自己嗎﹖要獻祭嗎﹖要一日成功嗎﹖要從土堆裡拿出火燒的石頭再立牆嗎﹖',
    '尼4:3 亞捫人多比雅站在旁邊，說：他們所修造的石牆，就是狐狸上去也必跐倒。',
    '尼4:4 我們的神啊，求你垂聽，因為我們被藐視。求你使他們的毀謗歸於他們的頭上，使他們在擄到之地作為掠物。',
    '尼4:5 不要遮掩他們的罪孽，不要使他們的罪惡從你面前塗抹，因為他們在修造的人眼前惹動你的怒氣。',
    '尼4:6 這樣，我們修造城牆，城牆就都連絡，高至一半，因為百姓專心做工。',
    '尼4:7 參巴拉、多比雅、亞拉伯人、亞捫人、亞實突人聽見修造耶路撒冷城牆，著手進行堵塞破裂的地方，就甚發怒。',
    '尼4:8 大家同謀要來攻擊耶路撒冷，使城內擾亂。',
    '尼4:9 然而，我們禱告我們的神，又因他們的緣故，就派人看守，晝夜防備。',
    '尼4:10 猶大人說：灰土尚多，扛擡的人力氣已經衰敗，所以我們不能建造城牆。',
    '尼4:11 我們的敵人且說：趁他們不知不見，我們進入他們中間，殺他們，使工作止住。',
    '尼4:12 那靠近敵人居住的猶大人十次從各處來見我們，說：你們必要回到我們那裡。',
    '尼4:13 所以我使百姓各按宗族拿刀、拿槍、拿弓站在城牆後邊低窪的空處。',
    '尼4:14 我察看了，就起來對貴冑、官長，和其餘的人說：不要怕他們！當記念主是大而可畏的。你們要為弟兄、兒女、妻子、家產爭戰。',
    '尼4:15 仇敵聽見我們知道他們的心意，見神也破壞他們的計謀，就不來了。我們都回到城牆那裡，各做各的工。',
    '尼4:16 從那日起，我的僕人一半做工，一半拿槍、拿盾牌、拿弓、穿（或譯：拿）鎧甲，官長都站在猶大眾人的後邊。',
    '尼4:17 修造城牆的，扛擡材料的，都一手做工一手拿兵器。',
    '尼4:18 修造的人都腰間佩刀修造，吹角的人在我旁邊。',
    '尼4:19 我對貴冑、官長，和其餘的人說：這工程浩大，我們在城牆上相離甚遠；',
    '尼4:20 你們聽見角聲在哪裡，就聚集到我們那裡去。我們的神必為我們爭戰。',
    '尼4:21 於是，我們做工，一半拿兵器，從天亮直到星宿出現的時候。',
    '尼4:22 那時，我又對百姓說：各人和他的僕人當在耶路撒冷住宿，好在夜間保守我們，白晝做工。',
    '尼4:23 這樣，我和弟兄僕人，並跟從我的護兵都不脫衣服，出去打水也帶兵器。',
    '尼5:1 百姓和他們的妻大大呼號，埋怨他們的弟兄猶大人。',
    '尼5:2 有的說：我們和兒女人口眾多，要去得糧食度命；',
    '尼5:3 有的說：我們典了田地、葡萄園、房屋，要得糧食充飢；',
    '尼5:4 有的說：我們已經指著田地、葡萄園，借了錢給王納稅。',
    '尼5:5 我們的身體與我們弟兄的身體一樣；我們的兒女與他們的兒女一般。現在我們將要使兒女作人的僕婢，我們的女兒已有為婢的；我們並無力拯救，因為我們的田地、葡萄園已經歸了別人。',
    '尼5:6 我聽見他們呼號說這些話，便甚發怒。',
    '尼5:7 我心裡籌劃，就斥責貴冑和官長說：你們各人向弟兄取利！於是我招聚大會攻擊他們。',
    '尼5:8 我對他們說：我們盡力贖回我們弟兄，就是賣與外邦的猶大人；你們還要賣弟兄，使我們贖回來嗎﹖他們就靜默不語，無話可答。',
    '尼5:9 我又說：你們所行的不善！你們行事不當敬畏我們的神嗎﹖不然，難免我們的仇敵外邦人毀謗我們。',
    '尼5:10 我和我的弟兄與僕人也將銀錢糧食借給百姓；我們大家都當免去利息。',
    '尼5:11 如今我勸你們將他們的田地、葡萄園、橄欖園、房屋，並向他們所取的銀錢、糧食、新酒，和油，百分之一的利息都歸還他們。',
    '尼5:12 眾人說：我們必歸還，不再向他們索要，必照你的話行。我就召了祭司來，叫眾人起誓，必照著所應許的而行。',
    '尼5:13 我也抖著胸前的衣襟，說：凡不成就這應許的，願神照樣抖他離開家產和他勞碌得來的，直到抖空了。會眾都說：阿們！又讚美耶和華。百姓就照著所應許的去行。',
    '尼5:14 自從我奉派作猶大地的省長，就是從亞達薛西王二十年直到三十二年，共十二年之久，我與我弟兄都沒有吃省長的俸祿。',
    '尼5:15 在我以前的省長加重百姓的擔子，每日索要糧食和酒，並銀子四十舍客勒，就是他們的僕人也轄制百姓；但我因敬畏神不這樣行。',
    '尼5:16 並且我恆心修造城牆，並沒有置買田地；我的僕人也都聚集在那裡做工。',
    '尼5:17 除了從四圍外邦中來的猶大人以外，有猶大平民和官長一百五十人在我席上吃飯。',
    '尼5:18 每日預備一隻公牛，六隻肥羊，又預備些飛禽；每十日一次，多預備各樣的酒。雖然如此，我並不要省長的俸祿，因為百姓服役甚重。',
    '尼5:19 我的神啊，求你記念我為這百姓所行的一切事，施恩與我。',
    '尼6:1 參巴拉、多比雅、亞拉伯人基善和我們其餘的仇敵聽見我已經修完了城牆，其中沒有破裂之處（那時我還沒有安門扇），',
    '尼6:2 參巴拉和基善就打發人來見我，說：請你來，我們在阿挪平原的一個村莊相會。他們卻想害我。',
    '尼6:3 於是我差遣人去見他們，說：我現在辦理大工，不能下去。焉能停工下去見你們呢﹖',
    '尼6:4 他們這樣四次打發人來見我，我都如此回答他們。',
    '尼6:5 參巴拉第五次打發僕人來見我，手裡拿著未封的信，',
    '尼6:6 信上寫著說：外邦人中有風聲，迦施慕（就是基善，見二章十九節）也說，你和猶大人謀反，修造城牆，你要作他們的王；',
    '尼6:7 你又派先知在耶路撒冷指著你宣講，說在猶大有王。現在這話必傳與王知；所以請你來，與我們彼此商議。',
    '尼6:8 我就差遣人去見他，說：你所說的這事，一概沒有，是你心裡捏造的。',
    '尼6:9 他們都要使我們懼怕，意思說，他們的手必軟弱，以致工作不能成就。神啊，求你堅固我的手。',
    '尼6:10 我到了米希大別的孫子、第來雅的兒子示瑪雅家裡；那時，他閉門不出。他說：我們不如在神的殿裡會面，將殿門關鎖；因為他們要來殺你，就是夜裡來殺你。',
    '尼6:11 我說：像我這樣的人豈要逃跑呢﹖像我這樣的人豈能進入殿裡保全生命呢﹖我不進去！',
    '尼6:12 我看明神沒有差遣他，是他自己說這話攻擊我，是多比雅和參巴拉賄買了他。',
    '尼6:13 賄買他的緣故，是要叫我懼怕，依從他犯罪，他們好傳揚惡言毀謗我。',
    '尼6:14 我的神啊，多比雅、參巴拉、女先知挪亞底，和其餘的先知要叫我懼怕，求你記念他們所行的這些事。',
    '尼6:15 以祿月二十五日，城牆修完了，共修了五十二天。',
    '尼6:16 我們一切仇敵、四圍的外邦人聽見了便懼怕，愁眉不展；因為見這工作完成是出乎我們的神。',
    '尼6:17 在那些日子，猶大的貴冑屢次寄信與多比雅，多比雅也來信與他們。',
    '尼6:18 在猶大有許多人與多比雅結盟；因他是亞拉的兒子，示迦尼的女婿，並且他的兒子約哈難娶了比利迦兒子米書蘭的女兒為妻。',
    '尼6:19 他們常在我面前說多比雅的善行，也將我的話傳與他。多比雅又常寄信來，要叫我懼怕。',
    '尼7:1 城牆修完，我安了門扇，守門的、歌唱的，和利未人都已派定。',
    '尼7:2 我就派我的弟兄哈拿尼和營樓的宰官哈拿尼雅管理耶路撒冷；因為哈拿尼雅是忠信的，又敬畏神過於眾人。',
    '尼7:3 我吩咐他們說：等到太陽上升才可開耶路撒冷的城門；人尚看守的時候就要關門上閂；也當派耶路撒冷的居民各按班次看守自己房屋對面之處。',
    '尼7:4 城是廣大，其中的民卻稀少，房屋還沒有建造。',
    '尼7:5 我的神感動我心，招聚貴冑、官長，和百姓，要照家譜計算。我找著第一次上來之人的家譜，其上寫著：',
    '尼7:6 巴比倫王尼布甲尼撒從前擄去猶大省的人，現在他們的子孫從被擄到之地回耶路撒冷和猶大，各歸本城。',
    '尼7:7 他們是同著所羅巴伯、耶書亞、尼希米、亞撒利雅、拉米、拿哈瑪尼、末底改、必珊、米斯毘列、比革瓦伊、尼宏、巴拿回來的。',
    '尼7:8 以色列人民的數目記在下面：巴錄的子孫二千一百七十二名；',
    '尼7:9 示法提雅的子孫三百七十二名；',
    '尼7:10 亞拉的子孫六百五十二名；',
    '尼7:11 巴哈摩押的後裔，就是耶書亞和約押的子孫二千八百一十八名；',
    '尼7:12 以攔的子孫一千二百五十四名；',
    '尼7:13 薩土的子孫八百四十五名；',
    '尼7:14 薩改的子孫七百六十名；',
    '尼7:15 賓內的子孫六百四十八名；',
    '尼7:16 比拜的子孫六百二十八名；',
    '尼7:17 押甲的子孫二千三百二十二名；',
    '尼7:18 亞多尼干的子孫六百六十七名；',
    '尼7:19 比革瓦伊的子孫二千零六十七名；',
    '尼7:20 亞丁的子孫六百五十五名；',
    '尼7:21 亞特的後裔，就是希西家的子孫九十八名；',
    '尼7:22 哈順的子孫三百二十八名；',
    '尼7:23 比賽的子孫三百二十四名；',
    '尼7:24 哈拉的子孫一百一十二名；',
    '尼7:25 基遍人九十五名；',
    '尼7:26 伯利恆人和尼陀法人共一百八十八名；',
    '尼7:27 亞拿突人一百二十八名；',
    '尼7:28 伯亞斯瑪弗人四十二名；',
    '尼7:29 基列耶琳人、基非拉人、比錄人共七百四十三名；',
    '尼7:30 拉瑪人和迦巴人共六百二十一名；',
    '尼7:31 默瑪人一百二十二名；',
    '尼7:32 伯特利人和艾人共一百二十三名；',
    '尼7:33 別的尼波人五十二名；',
    '尼7:34 別的以攔子孫一千二百五十四名；',
    '尼7:35 哈琳的子孫三百二十名；',
    '尼7:36 耶利哥人三百四十五名；',
    '尼7:37 羅德人、哈第人、阿挪人共七百二十一名；',
    '尼7:38 西拿人三千九百三十名。',
    '尼7:39 祭司：耶書亞家，耶大雅的子孫九百七十三名；',
    '尼7:40 音麥的子孫一千零五十二名；',
    '尼7:41 巴施戶珥的子孫一千二百四十七名；',
    '尼7:42 哈琳的子孫一千零一十七名。',
    '尼7:43 利未人：何達威的後裔，就是耶書亞和甲篾的子孫七十四名。',
    '尼7:44 歌唱的：亞薩的子孫一百四十八名。',
    '尼7:45 守門的：沙龍的子孫、亞特的子孫、達們的子孫、亞谷的子孫、哈底大的子孫、朔拜的子孫，共一百三十八名。',
    '尼7:46 尼提寧（就是殿役）：西哈的子孫、哈蘇巴的子孫、答巴俄的子孫、',
    '尼7:47 基綠的子孫、西亞的子孫、巴頓的子孫、',
    '尼7:48 利巴拿的子孫、哈迦巴的子孫、薩買的子孫、',
    '尼7:49 哈難的子孫、吉德的子孫、迦哈的子孫、',
    '尼7:50 利亞雅的子孫、利汛的子孫、尼哥大的子孫、',
    '尼7:51 迦散的子孫、烏撒的子孫、巴西亞的子孫、',
    '尼7:52 比賽的子孫、米烏寧的子孫、尼普心的子孫、',
    '尼7:53 巴卜的子孫、哈古巴的子孫、哈忽的子孫、',
    '尼7:54 巴洗律的子孫、米希大的子孫、哈沙的子孫、',
    '尼7:55 巴柯的子孫、西西拉的子孫、答瑪的子孫、',
    '尼7:56 尼細亞的子孫、哈提法的子孫。',
    '尼7:57 所羅門僕人的後裔，就是瑣太的子孫、瑣斐列的子孫、比路大的子孫、',
    '尼7:58 雅拉的子孫、達昆的子孫、吉德的子孫、',
    '尼7:59 示法提雅的子孫、哈替的子孫、玻黑列哈斯巴音的子孫、亞們的子孫。',
    '尼7:60 尼提寧和所羅門僕人的後裔共三百九十二名。',
    '尼7:61 從特米拉、特哈薩、基綠、亞頓、音麥上來的，不能指明他們的宗族譜系是以色列人不是；',
    '尼7:62 他們是第萊雅的子孫、多比雅的子孫、尼哥大的子孫，共六百四十二名。',
    '尼7:63 祭司中，哈巴雅的子孫、哈哥斯的子孫、巴西萊的子孫；因為他們的先祖娶了基列人巴西萊的女兒為妻，所以起名叫巴西萊。',
    '尼7:64 這三家的人在族譜之中尋查自己的譜系，卻尋不著，因此算為不潔，不准供祭司的職任。',
    '尼7:65 省長對他們說：不可吃至聖的物，直到有用烏陵和土明決疑的祭司興起來。',
    '尼7:66 會眾共有四萬二千三百六十名。',
    '尼7:67 此外，還有他們的僕婢七千三百三十七名，又有歌唱的男女二百四十五名。',
    '尼7:68 他們有馬七百三十六匹，騾子二百四十五匹，',
    '尼7:69 駱駝四百三十五隻，驢六千七百二十匹。',
    '尼7:70 有些族長為工程捐助。省長捐入庫中的金子一千達利克，碗五十個，祭司的禮服五百三十件。',
    '尼7:71 又有族長捐入工程庫的金子二萬達利克，銀子二千二百彌拿。',
    '尼7:72 其餘百姓所捐的金子二萬達利克，銀子二千彌拿，祭司的禮服六十七件。',
    '尼7:73 於是祭司、利未人、守門的、歌唱的、民中的一些人、尼提寧，並以色列眾人，各住在自己的城裡。',
    '尼8:1 到了七月，以色列人住在自己的城裡。那時，他們如同一人聚集在水門前的寬闊處，請文士以斯拉將耶和華藉摩西傳給以色列人的律法書帶來。',
    '尼8:2 七月初一日，祭司以斯拉將律法書帶到聽了能明白的男女會眾面前。',
    '尼8:3 在水門前的寬闊處，從清早到晌午，在眾男女、一切聽了能明白的人面前讀這律法書。眾民側耳而聽。',
    '尼8:4 文士以斯拉站在為這事特備的木臺上。瑪他提雅、示瑪、亞奈雅、烏利亞、希勒家，和瑪西雅站在他的右邊；毘大雅、米沙利、瑪基雅、哈順、哈拔大拿、撒迦利亞，和米書蘭站在他的左邊。',
    '尼8:5 以斯拉站在眾民以上，在眾民眼前展開這書。他一展開，眾民就都站起來。',
    '尼8:6 以斯拉稱頌耶和華至大的神；眾民都舉手應聲說：阿們！阿們！就低頭，面伏於地，敬拜耶和華。',
    '尼8:7 耶書亞、巴尼、示利比、雅憫、亞谷、沙比太、荷第雅、瑪西雅、基利他、亞撒利雅、約撒拔、哈難、毘萊雅，和利未人使百姓明白律法；百姓都站在自己的地方。',
    '尼8:8 他們清清楚楚地念神的律法書，講明意思，使百姓明白所念的。',
    '尼8:9 省長尼希米和作祭司的文士以斯拉，並教訓百姓的利未人，對眾民說：今日是耶和華─你們神的聖日，不要悲哀哭泣。這是因為眾民聽見律法書上的話都哭了；',
    '尼8:10 又對他們說：你們去吃肥美的，喝甘甜的，有不能預備的就分給他，因為今日是我們主的聖日。你們不要憂愁，因靠耶和華而得的喜樂是你們的力量。',
    '尼8:11 於是利未人使眾民靜默，說：今日是聖日；不要作聲，也不要憂愁。',
    '尼8:12 眾民都去吃喝，也分給人，大大快樂，因為他們明白所教訓他們的話。',
    '尼8:13 次日，眾民的族長、祭司，和利未人都聚集到文士以斯拉那裡，要留心聽律法上的話。',
    '尼8:14 他們見律法上寫著，耶和華藉摩西吩咐以色列人要在七月節住棚，',
    '尼8:15 並要在各城和耶路撒冷宣傳報告說：你們當上山，將橄欖樹、野橄欖樹、番石榴樹、棕樹，和各樣茂密樹的枝子取來，照著所寫的搭棚。',
    '尼8:16 於是百姓出去，取了樹枝來，各人在自己的房頂上，或院內，或神殿的院內，或水門的寬闊處，或以法蓮門的寬闊處搭棚。',
    '尼8:17 從擄到之地歸回的全會眾就搭棚，住在棚裡。從嫩的兒子約書亞的時候直到這日，以色列人沒有這樣行。於是眾人大大喜樂。',
    '尼8:18 從頭一天直到末一天，以斯拉每日念神的律法書。眾人守節七日，第八日照例有嚴肅會。',
    '尼9:1 這月二十四日，以色列人聚集禁食，身穿麻衣，頭蒙灰塵。',
    '尼9:2 以色列人（人：原文是種類）就與一切外邦人離絕，站著承認自己的罪惡和列祖的罪孽。',
    '尼9:3 那日的四分之一站在自己的地方念耶和華─他們神的律法書，又四分之一認罪，敬拜耶和華─他們的神。',
    '尼9:4 耶書亞、巴尼、甲篾、示巴尼、布尼、示利比、巴尼、基拿尼站在利未人的臺上，大聲哀求耶和華─他們的神。',
    '尼9:5 利未人耶書亞、甲篾、巴尼、哈沙尼、示利比、荷第雅、示巴尼、毘他希雅說：你們要站起來稱頌耶和華─你們的神，永世無盡。耶和華啊，你榮耀之名是應當稱頌的！超乎一切稱頌和讚美。',
    '尼9:6 你，惟獨你是耶和華！你造了天和天上的天，並天上的萬象，地和地上的萬物，海和海中所有的；這一切都是你所保存的。天軍也都敬拜你。',
    '尼9:7 你是耶和華神，曾揀選亞伯蘭，領他出迦勒底的吾珥，給他改名叫亞伯拉罕。',
    '尼9:8 你見他在你面前心裡誠實，就與他立約，應許把迦南人、赫人、亞摩利人、比利洗人、耶布斯人、革迦撒人之地賜給他的後裔，且應驗了你的話，因為你是公義的。',
    '尼9:9 你曾看見我們列祖在埃及所受的困苦，垂聽他們在紅海邊的哀求，',
    '尼9:10 就施行神蹟奇事在法老和他一切臣僕，並他國中的眾民身上。你也得了名聲，正如今日一樣，因為你知道他們向我們列祖行事狂傲。',
    '尼9:11 你又在我們列祖面前把海分開，使他們在海中行走乾地，將追趕他們的人拋在深海，如石頭拋在大水中；',
    '尼9:12 並且白晝用雲柱引導他們，黑夜用火柱照亮他們當行的路。',
    '尼9:13 你也降臨在西乃山，從天上與他們說話，賜給他們正直的典章、真實的律法、美好的條例與誡命，',
    '尼9:14 又使他們知道你的安息聖日，並藉你僕人摩西傳給他們誡命、條例、律法。',
    '尼9:15 從天上賜下糧食充他們的飢，從磐石使水流出解他們的渴，又吩咐他們進去得你起誓應許賜給他們的地。',
    '尼9:16 但我們的列祖行事狂傲，硬著頸項不聽從你的誡命；',
    '尼9:17 不肯順從，也不記念你在他們中間所行的奇事，竟硬著頸項，居心背逆，自立首領，要回他們為奴之地。但你是樂意饒恕人，有恩典，有憐憫，不輕易發怒，有豐盛慈愛的神，並不丟棄他們。',
    '尼9:18 他們雖然鑄了一隻牛犢，彼此說這是領你出埃及的神，因而大大惹動你的怒氣；',
    '尼9:19 你還是大施憐憫，在曠野不丟棄他們。白晝，雲柱不離開他們，仍引導他們行路；黑夜，火柱也不離開他們，仍照亮他們當行的路。',
    '尼9:20 你也賜下你良善的靈教訓他們；未嘗不賜嗎哪使他們糊口，並賜水解他們的渴。',
    '尼9:21 在曠野四十年，你養育他們，他們就一無所缺：衣服沒有穿破，腳也沒有腫。',
    '尼9:22 並且你將列國之地照分賜給他們，他們就得了西宏之地、希實本王之地，和巴珊王噩之地。',
    '尼9:23 你也使他們的子孫多如天上的星，帶他們到你所應許他們列祖進入得為業之地。',
    '尼9:24 這樣，他們進去得了那地，你在他們面前制伏那地的居民，就是迦南人；將迦南人和其君王，並那地的居民，都交在他們手裡，讓他們任意而待。',
    '尼9:25 他們得了堅固的城邑、肥美的地土、充滿各樣美物的房屋、鑿成的水井、葡萄園、橄欖園，並許多果木樹。他們就吃而得飽，身體肥胖，因你的大恩，心中快樂。',
    '尼9:26 然而，他們不順從，竟背叛你，將你的律法丟在背後，殺害那勸他們歸向你的眾先知，大大惹動你的怒氣。',
    '尼9:27 所以你將他們交在敵人的手中，磨難他們。他們遭難的時候哀求你，你就從天上垂聽，照你的大憐憫賜給他們拯救者，救他們脫離敵人的手。',
    '尼9:28 但他們得平安之後，又在你面前行惡，所以你丟棄他們在仇敵的手中，使仇敵轄制他們。然而他們轉回哀求你，你仍從天上垂聽，屢次照你的憐憫拯救他們，',
    '尼9:29 又警戒他們，要使他們歸服你的律法。他們卻行事狂傲，不聽從你的誡命，干犯你的典章（人若遵行就必因此活著），扭轉肩頭，硬著頸項，不肯聽從。',
    '尼9:30 但你多年寬容他們，又用你的靈藉眾先知勸戒他們，他們仍不聽從，所以你將他們交在列國之民的手中。',
    '尼9:31 然而你大發憐憫，不全然滅絕他們，也不丟棄他們；因為你是有恩典、有憐憫的神。',
    '尼9:32 我們的神啊，你是至大、至能、至可畏、守約施慈愛的神。我們的君王、首領、祭司、先知、列祖，和你的眾民，從亞述列王的時候直到今日所遭遇的苦難，現在求你不要以為小。',
    '尼9:33 在一切臨到我們的事上，你卻是公義的；因你所行的是誠實，我們所做的是邪惡。',
    '尼9:34 我們的君王、首領、祭司、列祖都不遵守你的律法，不聽從你的誡命和你警戒他們的話。',
    '尼9:35 他們在本國裡沾你大恩的時候，在你所賜給他們這廣大肥美之地上不事奉你，也不轉離他們的惡行。',
    '尼9:36 我們現今作了奴僕；至於你所賜給我們列祖享受其上的土產，並美物之地，看哪，我們在這地上作了奴僕！',
    '尼9:37 這地許多出產歸了列王，就是你因我們的罪所派轄制我們的。他們任意轄制我們的身體和牲畜，我們遭了大難。',
    '尼9:38 因這一切的事，我們立確實的約，寫在冊上。我們的首領、利未人，和祭司都簽了名。',
    '尼10:1 簽名的是：哈迦利亞的兒子─省長尼希米，和西底家；',
    '尼10:2 祭司：西萊雅、亞撒利雅、耶利米、',
    '尼10:3 巴施戶珥、亞瑪利雅、瑪基雅、',
    '尼10:4 哈突、示巴尼、瑪鹿、',
    '尼10:5 哈琳、米利末、俄巴底亞、',
    '尼10:6 但以理、近頓、巴錄、',
    '尼10:7 米書蘭、亞比雅、米雅民、',
    '尼10:8 瑪西亞、璧該、示瑪雅；',
    '尼10:9 又有利未人，就是亞散尼的兒子耶書亞、希拿達的子孫賓內、甲篾；',
    '尼10:10 還有他們的弟兄示巴尼、荷第雅、基利他、毘萊雅、哈難、',
    '尼10:11 米迦、利合、哈沙比雅、',
    '尼10:12 撒刻、示利比、示巴尼、',
    '尼10:13 荷第雅、巴尼、比尼努；',
    '尼10:14 又有民的首領，就是巴錄、巴哈摩押、以攔、薩土、巴尼、',
    '尼10:15 布尼、押甲、比拜、',
    '尼10:16 亞多尼雅、比革瓦伊、亞丁、',
    '尼10:17 亞特、希西家、押朔、',
    '尼10:18 荷第雅、哈順、比賽、',
    '尼10:19 哈拉、亞拿突、尼拜、',
    '尼10:20 抹比押、米書蘭、希悉、',
    '尼10:21 米示薩別、撒督、押杜亞、',
    '尼10:22 毘拉提、哈難、亞奈雅、',
    '尼10:23 何細亞、哈拿尼雅、哈述、',
    '尼10:24 哈羅黑、毘利哈、朔百、',
    '尼10:25 利宏、哈沙拿、瑪西雅、',
    '尼10:26 亞希雅、哈難、亞難、',
    '尼10:27 瑪鹿、哈琳、巴拿。',
    '尼10:28 其餘的民、祭司、利未人、守門的、歌唱的、尼提寧，和一切離絕鄰邦居民歸服神律法的，並他們的妻子、兒女，凡有知識能明白的，',
    '尼10:29 都隨從他們貴冑的弟兄，發咒起誓，必遵行神藉他僕人摩西所傳的律法，謹守遵行耶和華─我們主的一切誡命、典章、律例；',
    '尼10:30 並不將我們的女兒嫁給這地的居民，也不為我們的兒子娶他們的女兒。',
    '尼10:31 這地的居民若在安息日，或什麼聖日，帶了貨物或糧食來賣給我們，我們必不買。每逢第七年必不耕種，凡欠我們債的必不追討。',
    '尼10:32 我們又為自己定例，每年各人捐銀一舍客勒三分之一，為我們神殿的使用，',
    '尼10:33 就是為陳設餅、常獻的素祭，和燔祭，安息日、月朔、節期所獻的與聖物，並以色列人的贖罪祭，以及我們神殿裡一切的費用。',
    '尼10:34 我們的祭司、利未人，和百姓都掣籤，看每年是哪一族按定期將獻祭的柴奉到我們神的殿裡，照著律法上所寫的，燒在耶和華─我們神的壇上。',
    '尼10:35 又定每年將我們地上初熟的土產和各樣樹上初熟的果子都奉到耶和華的殿裡。',
    '尼10:36 又照律法上所寫的，將我們頭胎的兒子和首生的牛羊都奉到我們神的殿，交給我們神殿裡供職的祭司；',
    '尼10:37 並將初熟之麥子所磨的麵和舉祭、各樣樹上初熟的果子、新酒與油奉給祭司，收在我們神殿的庫房裡，把我們地上所產的十分之一奉給利未人，因利未人在我們一切城邑的土產中當取十分之一。',
    '尼10:38 利未人取十分之一的時候，亞倫的子孫中，當有一個祭司與利未人同在。利未人也當從十分之一中取十分之一，奉到我們神殿的屋子裡，收在庫房中。',
    '尼10:39 以色列人和利未人要將五穀、新酒，和油為舉祭，奉到收存聖所器皿的屋子裡，就是供職的祭司、守門的、歌唱的所住的屋子。這樣，我們就不離棄我們神的殿。',
    '尼11:1 百姓的首領住在耶路撒冷。其餘的百姓掣籤，每十人中使一人來住在聖城耶路撒冷，那九人住在別的城邑。',
    '尼11:2 凡甘心樂意住在耶路撒冷的，百姓都為他們祝福。',
    '尼11:3 以色列人、祭司、利未人、尼提寧，和所羅門僕人的後裔都住在猶大城邑，各在自己的地業中。本省的首領住在耶路撒冷的記在下面：',
    '尼11:4 其中有些猶大人和便雅憫人。猶大人中有法勒斯的子孫、烏西雅的兒子亞他雅。烏西雅是撒迦利雅的兒子；撒迦利雅是亞瑪利雅的兒子；亞瑪利雅是示法提雅的兒子；示法提雅是瑪勒列的兒子。',
    '尼11:5 又有巴錄的兒子瑪西雅。巴錄是谷何西的兒子；谷何西是哈賽雅的兒子；哈賽雅是亞大雅的兒子；亞大雅是約雅立的兒子；約雅立是撒迦利雅的兒子；撒迦利雅是示羅尼的兒子。',
    '尼11:6 住在耶路撒冷、法勒斯的子孫共四百六十八名，都是勇士。',
    '尼11:7 便雅憫人中有米書蘭的兒子撒路。米書蘭是約葉的兒子；約葉是毘大雅的兒子；毘大雅是哥賴雅的兒子；哥賴雅是瑪西雅的兒子；瑪西雅是以鐵的兒子；以鐵是耶篩亞的兒子。',
    '尼11:8 其次有迦拜、撒來的子孫，共九百二十八名。',
    '尼11:9 細基利的兒子約珥是他們的長官。哈西努亞的兒子猶大是耶路撒冷的副官。',
    '尼11:10 祭司中有雅斤，又有約雅立的兒子耶大雅；',
    '尼11:11 還有管理神殿的西萊雅。西萊雅是希勒家的兒子；希勒家是米書蘭的兒子；米書蘭是撒督的兒子；撒督是米拉約的兒子；米拉約是亞希突的兒子。',
    '尼11:12 還有他們的弟兄在殿裡供職的，共八百二十二名；又有耶羅罕的兒子亞大雅。耶羅罕是毘拉利的兒子；毘拉利是暗洗的兒子；暗洗是撒迦利亞的兒子；撒迦利亞是巴施戶珥的兒子；巴施戶珥是瑪基雅的兒子。',
    '尼11:13 還有他的弟兄作族長的，二百四十二名；又有亞薩列的兒子亞瑪帥。亞薩列是亞哈賽的兒子；亞哈賽是米實利末的兒子；米實利末是音麥的兒子。',
    '尼11:14 還有他們弟兄、大能的勇士共一百二十八名。哈基多琳的兒子撒巴第業是他們的長官。',
    '尼11:15 利未人中有哈述的兒子示瑪雅。哈述是押利甘的兒子；押利甘是哈沙比雅的兒子；哈沙比雅是布尼的兒子。',
    '尼11:16 又有利未人的族長沙比太和約撒拔管理神殿的外事。',
    '尼11:17 祈禱的時候，為稱謝領首的是米迦的兒子瑪他尼。米迦是撒底的兒子；撒底是亞薩的兒子；又有瑪他尼弟兄中的八布迦為副。還有沙母亞的兒子押大。沙母亞是加拉的兒子；加拉是耶杜頓的兒子。',
    '尼11:18 在聖城的利未人共二百八十四名。',
    '尼11:19 守門的是亞谷和達們，並守門的弟兄，共一百七十二名。',
    '尼11:20 其餘的以色列人、祭司、利未人都住在猶大的一切城邑，各在自己的地業中。',
    '尼11:21 尼提寧卻住在俄斐勒；西哈和基斯帕管理他們。',
    '尼11:22 在耶路撒冷、利未人的長官，管理神殿事務的是歌唱者亞薩的子孫、巴尼的兒子烏西。巴尼是哈沙比雅的兒子；哈沙比雅是瑪他尼的兒子；瑪他尼是米迦的兒子。',
    '尼11:23 王為歌唱的出命令，每日供給他們必有一定之糧。',
    '尼11:24 猶大兒子謝拉的子孫、米示薩別的兒子毘他希雅輔助王辦理猶大民的事。',
    '尼11:25 至於村莊和屬村莊的田地，有猶大人住在基列亞巴和屬基列亞巴的鄉村；底本和屬底本的鄉村；葉甲薛和屬葉甲薛的村莊；',
    '尼11:26 耶書亞、摩拉大、伯帕列、',
    '尼11:27 哈薩書亞、別是巴，和屬別是巴的鄉村；',
    '尼11:28 洗革拉、米哥拿，和屬米哥拿的鄉村；',
    '尼11:29 音臨門、瑣拉、耶末、',
    '尼11:30 撒挪亞、亞杜蘭，和屬這兩處的村莊；拉吉和屬拉吉的田地；亞西加和屬亞西加的鄉村。他們所住的地方是從別是巴直到欣嫩谷。',
    '尼11:31 便雅憫人從迦巴起，住在密抹、亞雅、伯特利和屬伯特利的鄉村。',
    '尼11:32 亞拿突、挪伯、亞難雅、',
    '尼11:33 夏瑣、拉瑪、基他音、',
    '尼11:34 哈疊、洗編、尼八拉、',
    '尼11:35 羅德、阿挪、匠人之谷。',
    '尼11:36 利未人中有幾班曾住在猶大地歸於便雅憫的。',
    '尼12:1 同著撒拉鐵的兒子所羅巴伯和耶書亞回來的祭司與利未人記在下面：祭司是西萊雅、耶利米、以斯拉、',
    '尼12:2 亞瑪利雅、瑪鹿、哈突、',
    '尼12:3 示迦尼、利宏、米利末、',
    '尼12:4 易多、近頓、亞比雅、',
    '尼12:5 米雅民、瑪底雅、璧迦、',
    '尼12:6 示瑪雅、約雅立、耶大雅、',
    '尼12:7 撒路、亞木、希勒家、耶大雅。這些人在耶書亞的時候作祭司和他們弟兄的首領。',
    '尼12:8 利未人是耶書亞、賓內、甲篾、示利比、猶大、瑪他尼。這瑪他尼和他的弟兄管理稱謝的事。',
    '尼12:9 他們的弟兄八布迦和烏尼照自己的班次與他們相對。',
    '尼12:10 耶書亞生約雅金；約雅金生以利亞實；以利亞實生耶何耶大；',
    '尼12:11 耶何耶大生約拿單；約拿單生押杜亞。',
    '尼12:12 在約雅金的時候，祭司作族長的西萊雅族（或譯：班；本段同）有米拉雅；耶利米族有哈拿尼雅；',
    '尼12:13 以斯拉族有米書蘭；亞瑪利雅族有約哈難；',
    '尼12:14 米利古族有約拿單；示巴尼族有約瑟；',
    '尼12:15 哈琳族有押拿；米拉約族有希勒愷；',
    '尼12:16 易多族有撒迦利亞；近頓族有米書蘭；',
    '尼12:17 亞比雅族有細基利；米拿民族某；摩亞底族有毘勒太；',
    '尼12:18 璧迦族有沙母亞；示瑪雅族有約拿單；',
    '尼12:19 約雅立族有瑪特乃；耶大雅族有烏西；',
    '尼12:20 撒來族有加萊；亞木族有希伯；',
    '尼12:21 希勒家族有哈沙比雅；耶大雅族有拿坦業。',
    '尼12:22 至於利未人，當以利亞實、耶何耶大、約哈難、押杜亞的時候，他們的族長記在冊上。波斯王大利烏在位的時候，作族長的祭司也記在冊上。',
    '尼12:23 利未人作族長的記在歷史上，直到以利亞實的兒子約哈難的時候。',
    '尼12:24 利未人的族長是哈沙比雅、示利比、甲篾的兒子耶書亞，與他們弟兄的班次相對，照著神人大衛的命令一班一班地讚美稱謝。',
    '尼12:25 瑪他尼、八布迦、俄巴底亞、米書蘭、達們、亞谷是守門的，就是在庫房那裡守門。',
    '尼12:26 這都是在約撒達的孫子、耶書亞的兒子約雅金和省長尼希米，並祭司文士以斯拉的時候，有職任的。',
    '尼12:27 耶路撒冷城牆告成的時候，眾民就把各處的利未人招到耶路撒冷，要稱謝、歌唱、敲鈸、鼓瑟、彈琴，歡歡喜喜地行告成之禮。',
    '尼12:28 歌唱的人從耶路撒冷的周圍和尼陀法的村莊與伯吉甲，又從迦巴和押瑪弗的田地聚集，因為歌唱的人在耶路撒冷四圍為自己立了村莊。',
    '尼12:29 併於上節。',
    '尼12:30 祭司和利未人就潔淨自己，也潔淨百姓和城門，並城牆。',
    '尼12:31 我帶猶大的首領上城，使稱謝的人分為兩大隊，排列而行：第一隊在城上往右邊向糞廠門行走，',
    '尼12:32 在他們後頭的有何沙雅與猶大首領的一半，',
    '尼12:33 又有亞撒利雅、以斯拉、米書蘭、',
    '尼12:34 猶大、便雅憫、示瑪雅、耶利米。',
    '尼12:35 還有些吹號之祭司的子孫，約拿單的兒子撒迦利亞。約拿單是示瑪雅的兒子；示瑪雅是瑪他尼的兒子；瑪他尼是米該亞的兒子；米該亞是撒刻的兒子；撒刻是亞薩的兒子；',
    '尼12:36 又有撒迦利亞的弟兄示瑪雅、亞撒利、米拉萊、基拉萊、瑪艾、拿坦業、猶大、哈拿尼，都拿著神人大衛的樂器，文士以斯拉引領他們。',
    '尼12:37 他們經過泉門往前，從大衛城的臺階隨地勢而上，在大衛宮殿以上，直行到朝東的水門。',
    '尼12:38 第二隊稱謝的人要與那一隊相迎而行。我和民的一半跟隨他們，在城牆上過了爐樓，直到寬牆；',
    '尼12:39 又過了以法蓮門、古門、魚門、哈楠業樓、哈米亞樓，直到羊門，就在護衛門站住。',
    '尼12:40 於是，這兩隊稱謝的人連我和官長的一半，站在神的殿裡。',
    '尼12:41 還有祭司以利亞金、瑪西雅、米拿民、米該雅、以利約乃、撒迦利亞、哈楠尼亞吹號；',
    '尼12:42 又有瑪西雅、示瑪雅、以利亞撒、烏西、約哈難、瑪基雅、以攔，和以謝奏樂。歌唱的就大聲歌唱，伊斯拉希雅管理他們。',
    '尼12:43 那日，眾人獻大祭而歡樂；因為神使他們大大歡樂，連婦女帶孩童也都歡樂，甚至耶路撒冷中的歡聲聽到遠處。',
    '尼12:44 當日，派人管理庫房，將舉祭、初熟之物和所取的十分之一，就是按各城田地，照律法所定歸給祭司和利未人的分，都收在裡頭。猶大人因祭司和利未人供職，就歡樂了。',
    '尼12:45 祭司利未人遵守神所吩咐的，並守潔淨的禮。歌唱的、守門的，照著大衛和他兒子所羅門的命令也如此行。',
    '尼12:46 古時，在大衛和亞薩的日子，有歌唱的伶長，並有讚美稱謝神的詩歌。',
    '尼12:47 當所羅巴伯和尼希米的時候，以色列眾人將歌唱的、守門的，每日所當得的分供給他們，又給利未人當得的分；利未人又給亞倫的子孫當得的分。',
    '尼13:1 當日，人念摩西的律法書給百姓聽，遇見書上寫著說，亞捫人和摩押人永不可入神的會；',
    '尼13:2 因為他們沒有拿食物和水來迎接以色列人，且雇了巴蘭咒詛他們，但我們的神使那咒詛變為祝福。',
    '尼13:3 以色列民聽見這律法，就與一切閒雜人絕交',
    '尼13:4 先是蒙派管理我們神殿中庫房的祭司以利亞實與多比雅結親，',
    '尼13:5 便為他預備一間大屋子，就是從前收存素祭、乳香、器皿，和照命令供給利未人、歌唱的、守門的五穀、新酒，和油的十分之一，並歸祭司舉祭的屋子。',
    '尼13:6 那時我不在耶路撒冷；因為巴比倫王亞達薛西三十二年，我回到王那裡。過了多日，我向王告假。',
    '尼13:7 我來到耶路撒冷，就知道以利亞實為多比雅在神殿的院內預備屋子的那件惡事。',
    '尼13:8 我甚惱怒，就把多比雅的一切家具從屋裡都拋出去，',
    '尼13:9 吩咐人潔淨這屋子，遂將神殿的器皿和素祭、乳香又搬進去。',
    '尼13:10 我見利未人所當得的分無人供給他們，甚至供職的利未人與歌唱的俱各奔回自己的田地去了。',
    '尼13:11 我就斥責官長說：為何離棄神的殿呢﹖我便招聚利未人，使他們照舊供職。',
    '尼13:12 猶大眾人就把五穀、新酒，和油的十分之一送入庫房。',
    '尼13:13 我派祭司示利米雅、文士撒督，和利未人毘大雅作庫官管理庫房；副官是哈難。哈難是撒刻的兒子；撒刻是瑪他尼的兒子。這些人都是忠信的，他們的職分是將所供給的分給他們的弟兄。',
    '尼13:14 我的神啊，求你因這事記念我，不要塗抹我為神的殿與其中的禮節所行的善。',
    '尼13:15 那些日子，我在猶大見有人在安息日醡酒（原文是踹酒醡），搬運禾捆馱在驢上，又把酒、葡萄、無花果，和各樣的擔子在安息日擔入耶路撒冷，我就在他們賣食物的那日警戒他們。',
    '尼13:16 又有推羅人住在耶路撒冷；他們把魚和各樣貨物運進來，在安息日賣給猶大人。',
    '尼13:17 我就斥責猶大的貴冑說：你們怎麼行這惡事犯了安息日呢﹖',
    '尼13:18 從前你們列祖豈不是這樣行，以致我們神使一切災禍臨到我們和這城嗎﹖現在你們還犯安息日，使忿怒越發臨到以色列！',
    '尼13:19 在安息日的前一日，耶路撒冷城門有黑影的時候，我就吩咐人將門關鎖，不過安息日不准開放。我又派我幾個僕人管理城門，免得有人在安息日擔什麼擔子進城。',
    '尼13:20 於是商人和販賣各樣貨物的，一兩次住宿在耶路撒冷城外。',
    '尼13:21 我就警戒他們說：你們為何在城外住宿呢﹖若再這樣，我必下手拿辦你們。從此以後，他們在安息日不再來了。',
    '尼13:22 我吩咐利未人潔淨自己，來守城門，使安息日為聖。我的神啊，求你因這事記念我，照你的大慈愛憐恤我。',
    '尼13:23 那些日子，我也見猶大人娶了亞實突、亞捫、摩押的女子為妻。',
    '尼13:24 他們的兒女說話，一半是亞實突的話，不會說猶大的話，所說的是照著各族的方言。',
    '尼13:25 我就斥責他們，咒詛他們，打了他們幾個人，拔下他們的頭髮，叫他們指著神起誓，必不將自己的女兒嫁給外邦人的兒子，也不為自己和兒子娶他們的女兒。',
    '尼13:26 我又說：以色列王所羅門不是在這樣的事上犯罪嗎﹖在多國中並沒有一王像他，且蒙他神所愛，神立他作以色列全國的王；然而連他也被外邦女子引誘犯罪。',
    '尼13:27 如此，我豈聽你們行這大惡，娶外邦女子干犯我們的神呢﹖',
    '尼13:28 大祭司以利亞實的孫子、耶何耶大的一個兒子是和倫人參巴拉的女婿，我就從我這裡把他趕出去。',
    '尼13:29 我的神啊，求你記念他們的罪；因為他們玷污了祭司的職任，違背你與祭司利未人所立的約。',
    '尼13:30 這樣，我潔淨他們，使他們離絕一切外邦人，派定祭司和利未人的班次，使他們各盡其職。',
    '尼13:31 我又派百姓按定期獻柴和初熟的土產。我的神啊，求你記念我，施恩與我。',
    '斯1:1 亞哈隨魯作王，從印度直到古實，統管一百二十七省。',
    '斯1:2 亞哈隨魯王在書珊城的宮登基；',
    '斯1:3 在位第三年，為他一切首領臣僕設擺筵席，有波斯和瑪代的權貴，就是各省的貴冑與首領，在他面前。',
    '斯1:4 他把他榮耀之國的豐富和他美好威嚴的尊貴給他們看了許多日，就是一百八十日。',
    '斯1:5 這日子滿了，又為所有住書珊城的大小人民在御園的院子裡設擺筵席七日。',
    '斯1:6 有白色、綠色、藍色的帳子，用細麻繩、紫色繩從銀環內繫在白玉石柱上；有金銀的床榻擺在紅、白、黃、黑玉石鋪的石地上。',
    '斯1:7 用金器皿賜酒，器皿各有不同。御酒甚多，足顯王的厚意。',
    '斯1:8 喝酒有例，不准勉強人，因王吩咐宮裡的一切臣宰，讓人各隨己意。',
    '斯1:9 王后瓦實提在亞哈隨魯王的宮內也為婦女設擺筵席。',
    '斯1:10 第七日，亞哈隨魯王飲酒，心中快樂，就吩咐在他面前侍立的七個太監米戶幔、比斯他、哈波拿、比革他、亞拔他、西達、甲迦，',
    '斯1:11 請王后瓦實提頭戴王后的冠冕到王面前，使各等臣民看他的美貌，因為他容貌甚美。',
    '斯1:12 王后瓦實提卻不肯遵太監所傳的王命而來，所以王甚發怒，心如火燒。',
    '斯1:13 那時，在王左右常見王面、國中坐高位的，有波斯和瑪代的七個大臣，就是甲示拿、示達、押瑪他、他施斯、米力、瑪西拿、米母干，都是達時務的明哲人。按王的常規，辦事必先詢問知例明法的人。王問他們說：',
    '斯1:14 併於上節。',
    '斯1:15 王后瓦實提不遵太監所傳的王命，照例應當怎樣辦理呢﹖',
    '斯1:16 米母干在王和眾首領面前回答說：王后瓦實提這事，不但得罪王，並且有害於王各省的臣民；',
    '斯1:17 因為王后這事必傳到眾婦人的耳中，說：亞哈隨魯王吩咐王后瓦實提到王面前，他卻不來，他們就藐視自己的丈夫。',
    '斯1:18 今日波斯和瑪代的眾夫人聽見王后這事，必向王的大臣照樣行；從此必大開藐視和忿怒之端。',
    '斯1:19 王若以為美，就降旨寫在波斯和瑪代人的例中，永不更改，不准瓦實提再到王面前，將他王后的位分賜給比他還好的人。',
    '斯1:20 所降的旨意傳遍通國（國度本來廣大），所有的婦人，無論丈夫貴賤都必尊敬他。',
    '斯1:21 王和眾首領都以米母干的話為美，王就照這話去行，',
    '斯1:22 發詔書，用各省的文字、各族的方言通知各省，使為丈夫的在家中作主，各說本地的方言。',
    '斯2:1 這事以後，亞哈隨魯王的忿怒止息，就想念瓦實提和他所行的，並怎樣降旨辦他。',
    '斯2:2 於是王的侍臣對王說：不如為王尋找美貌的處女。',
    '斯2:3 王可以派官在國中的各省招聚美貌的處女到書珊城（或譯：宮）的女院，交給掌管女子的太監希該，給他們當用的香品。',
    '斯2:4 王所喜愛的女子可以立為王后，代替瓦實提。王以這事為美，就如此行。',
    '斯2:5 書珊城有一個猶大人，名叫末底改，是便雅憫人基士的曾孫，示每的孫子，睚珥的兒子。',
    '斯2:6 從前巴比倫王尼布甲尼撒將猶大王耶哥尼雅（又名約雅斤）和百姓從耶路撒冷擄去，末底改也在其內。',
    '斯2:7 末底改撫養他叔叔的女兒哈大沙（後名以斯帖），因為他沒有父母。這女子又容貌俊美；他父母死了，末底改就收他為自己的女兒。',
    '斯2:8 王的諭旨傳出，就招聚許多女子到書珊城，交給掌管女子的希該；以斯帖也送入王宮，交付希該。',
    '斯2:9 希該喜悅以斯帖，就恩待他，急忙給他需用的香品和他所當得的分，又派所當得的七個宮女服事他，使他和他的宮女搬入女院上好的房屋。',
    '斯2:10 以斯帖未曾將籍貫宗族告訴人，因為末底改囑咐他不可叫人知道。',
    '斯2:11 末底改天天在女院前邊行走，要知道以斯帖平安不平安，並後事如何。',
    '斯2:12 眾女子照例先潔淨身體十二個月：六個月用沒藥油，六個月用香料和潔身之物。滿了日期，然後挨次進去見亞哈隨魯王。',
    '斯2:13 女子進去見王是這樣：從女院到王宮的時候，凡他所要的都必給他。',
    '斯2:14 晚上進去，次日回到女子第二院，交給掌管妃嬪的太監沙甲；除非王喜愛他，再提名召他，就不再進去見王。',
    '斯2:15 末底改叔叔亞比孩的女兒，就是末底改收為自己女兒的以斯帖，按次序當進去見王的時候，除了掌管女子的太監希該所派定給他的，他別無所求。凡看見以斯帖的都喜悅他。',
    '斯2:16 亞哈隨魯王第七年十月，就是提別月，以斯帖被引入宮見王。',
    '斯2:17 王愛以斯帖過於愛眾女，他在王眼前蒙寵愛比眾處女更甚。王就把王后的冠冕戴在他頭上，立他為王后，代替瓦實提。',
    '斯2:18 王因以斯帖的緣故給眾首領和臣僕設擺大筵席，又豁免各省的租稅，並照王的厚意大頒賞賜。',
    '斯2:19 第二次招聚處女的時候，末底改坐在朝門。',
    '斯2:20 以斯帖照著末底改所囑咐的，還沒有將籍貫宗族告訴人；因為以斯帖遵末底改的命，如撫養他的時候一樣。',
    '斯2:21 當那時候，末底改坐在朝門，王的太監中有兩個守門的，辟探和提列，惱恨亞哈隨魯王，想要下手害他。',
    '斯2:22 末底改知道了，就告訴王后以斯帖。以斯帖奉末底改的名，報告於王；',
    '斯2:23 究察這事，果然是實，就把二人掛在木頭上，將這事在王面前寫於歷史上。',
    '斯3:1 這事以後，亞哈隨魯王擡舉亞甲族哈米大他的兒子哈曼，使他高升，叫他的爵位超過與他同事的一切臣宰。',
    '斯3:2 在朝門的一切臣僕都跪拜哈曼，因為王如此吩咐；惟獨末底改不跪不拜。',
    '斯3:3 在朝門的臣僕問末底改說：你為何違背王的命令呢﹖',
    '斯3:4 他們天天勸他，他還是不聽，他們就告訴哈曼，要看末底改的事站得住站不住，因他已經告訴他們自己是猶大人。',
    '斯3:5 哈曼見末底改不跪不拜，他就怒氣填胸。',
    '斯3:6 他們已將末底改的本族告訴哈曼；他以為下手害末底改一人是小事，就要滅絕亞哈隨魯王通國所有的猶大人，就是末底改的本族。',
    '斯3:7 亞哈隨魯王十二年正月，就是尼散月，人在哈曼面前，按日日月月掣普珥，就是掣籤，要定何月何日為吉，擇定了十二月，就是亞達月。',
    '斯3:8 哈曼對亞哈隨魯王說：有一種民散居在王國各省的民中；他們的律例與萬民的律例不同，也不守王的律例，所以容留他們於王無益。',
    '斯3:9 王若以為美，請下旨意滅絕他們；我就捐一萬他連得銀子交給掌管國帑的人，納入王的府庫。',
    '斯3:10 於是王從自己手上摘下戒指給猶大人的仇敵─亞甲族哈米大他的兒子哈曼。',
    '斯3:11 王對哈曼說：這銀子仍賜給你，這民也交給你，你可以隨意待他們。',
    '斯3:12 正月十三日，就召了王的書記來，照著哈曼一切所吩咐的，用各省的文字、各族的方言，奉亞哈隨魯王的名寫旨意，傳與總督和各省的省長，並各族的首領；又用王的戒指蓋印，',
    '斯3:13 交給驛卒傳到王的各省，吩咐將猶大人，無論老少婦女孩子，在一日之間，十二月，就是亞達月十三日，全然剪除，殺戮滅絕，並奪他們的財為掠物。',
    '斯3:14 抄錄這旨意，頒行各省，宣告各族，使他們預備等候那日。',
    '斯3:15 驛卒奉王命急忙起行，旨意也傳遍書珊城。王同哈曼坐下飲酒，書珊城的民卻都慌亂。',
    '斯4:1 末底改知道所做的這一切事，就撕裂衣服，穿麻衣，蒙灰塵，在城中行走，痛哭哀號。',
    '斯4:2 到了朝門前停住腳步，因為穿麻衣的不可進朝門。',
    '斯4:3 王的諭旨所到的各省各處，猶大人大大悲哀，禁食哭泣哀號，穿麻衣躺在灰中的甚多。',
    '斯4:4 王后以斯帖的宮女和太監來把這事告訴以斯帖，他甚是憂愁，就送衣服給末底改穿，要他脫下麻衣，他卻不受。',
    '斯4:5 以斯帖就把王所派伺候他的一個太監，名叫哈他革召來，吩咐他去見末底改，要知道這是什麼事，是什麼緣故。',
    '斯4:6 於是哈他革出到朝門前的寬闊處見末底改。',
    '斯4:7 末底改將自己所遇的事，並哈曼為滅絕猶大人應許捐入王庫的銀數都告訴了他；',
    '斯4:8 又將所抄寫傳遍書珊城要滅絕猶大人的旨意交給哈他革，要給以斯帖看，又要給他說明，並囑咐他進去見王，為本族的人在王面前懇切祈求。',
    '斯4:9 哈他革回來，將末底改的話告訴以斯帖；',
    '斯4:10 以斯帖就吩咐哈他革去見末底改，說：',
    '斯4:11 王的一切臣僕和各省的人民都知道有一個定例：若不蒙召，擅入內院見王的，無論男女必被治死；除非王向他伸出金杖，不得存活。現在我沒有蒙召進去見王已經三十日了。',
    '斯4:12 人就把以斯帖這話告訴末底改。',
    '斯4:13 末底改託人回覆以斯帖說：你莫想在王宮裡強過一切猶大人，得免這禍。',
    '斯4:14 此時你若閉口不言，猶大人必從別處得解脫，蒙拯救；你和你父家必致滅亡。焉知你得了王后的位分不是為現今的機會嗎﹖',
    '斯4:15 以斯帖就吩咐人回報末底改說：',
    '斯4:16 你當去招聚書珊城所有的猶大人，為我禁食三晝三夜，不吃不喝；我和我的宮女也要這樣禁食。然後我違例進去見王，我若死就死吧！',
    '斯4:17 於是末底改照以斯帖一切所吩咐的去行。',
    '斯5:1 第三日，以斯帖穿上朝服，進王宮的內院，對殿站立。王在殿裡坐在寶座上，對著殿門。',
    '斯5:2 王見王后以斯帖站在院內，就施恩於他，向他伸出手中的金杖；以斯帖便向前摸杖頭。',
    '斯5:3 王對他說：王后以斯帖啊，你要什麼﹖你求什麼，就是國的一半也必賜給你。',
    '斯5:4 以斯帖說：王若以為美，就請王帶著哈曼今日赴我所預備的筵席。',
    '斯5:5 王說：叫哈曼速速照以斯帖的話去行。於是王帶著哈曼赴以斯帖所預備的筵席。',
    '斯5:6 在酒席筵前，王又問以斯帖說：你要什麼，我必賜給你；你求什麼，就是國的一半也必為你成就。',
    '斯5:7 以斯帖回答說：我有所要，我有所求。',
    '斯5:8 我若在王眼前蒙恩，王若願意賜我所要的，准我所求的，就請王帶著哈曼再赴我所要預備的筵席。明日我必照王所問的說明。',
    '斯5:9 那日哈曼心中快樂，歡歡喜喜地出來；但見末底改在朝門不站起來，連身也不動，就滿心惱怒末底改。',
    '斯5:10 哈曼暫且忍耐回家，叫人請他朋友和他妻子細利斯來。',
    '斯5:11 哈曼將他富厚的榮耀、眾多的兒女，和王擡舉他使他超乎首領臣僕之上，都述說給他們聽。',
    '斯5:12 哈曼又說：王后以斯帖預備筵席，除了我之外不許別人隨王赴席。明日王后又請我隨王赴席；',
    '斯5:13 只是我見猶大人末底改坐在朝門，雖有這一切榮耀，也於我無益。',
    '斯5:14 他的妻細利斯和他一切的朋友對他說：不如立一個五丈高的木架，明早求王將末底改掛在其上，然後你可以歡歡喜喜地隨王赴席。哈曼以這話為美，就叫人做了木架。',
    '斯6:1 那夜王睡不著覺，就吩咐人取歷史來，念給他聽。',
    '斯6:2 正遇見書上寫著說：王的太監中有兩個守門的，辟探和提列，想要下手害亞哈隨魯王，末底改將這事告訴王后。',
    '斯6:3 王說：末底改行了這事，賜他什麼尊榮爵位沒有﹖伺候王的臣僕回答說：沒有賜他什麼。',
    '斯6:4 王說：誰在院子裡﹖（那時哈曼正進王宮的外院，要求王將末底改掛在他所預備的木架上。）',
    '斯6:5 臣僕說：哈曼站在院內。王說：叫他進來。',
    '斯6:6 哈曼就進去。王問他說：王所喜悅尊榮的人，當如何待他呢﹖哈曼心裡說：王所喜悅尊榮的，不是我是誰呢﹖',
    '斯6:7 哈曼就回答說：王所喜悅尊榮的，',
    '斯6:8 當將王常穿的朝服和戴冠的御馬，',
    '斯6:9 都交給王極尊貴的一個大臣，命他將衣服給王所喜悅尊榮的人穿上，使他騎上馬，走遍城裡的街市，在他面前宣告說：王所喜悅尊榮的人，就如此待他。',
    '斯6:10 王對哈曼說：你速速將這衣服和馬，照你所說的，向坐在朝門的猶大人末底改去行。凡你所說的，一樣不可缺。',
    '斯6:11 於是哈曼將朝服給末底改穿上，使他騎上馬，走遍城裡的街市，在他面前宣告說：王所喜悅尊榮的人，就如此待他。',
    '斯6:12 末底改仍回到朝門，哈曼卻憂憂悶悶地蒙著頭，急忙回家去了，',
    '斯6:13 將所遇的一切事詳細說給他的妻細利斯和他的眾朋友聽。他的智慧人和他的妻細利斯對他說：你在末底改面前始而敗落，他如果是猶大人，你必不能勝他，終必在他面前敗落。',
    '斯6:14 他們還與哈曼說話的時候，王的太監來催哈曼快去赴以斯帖所預備的筵席。',
    '斯7:1 王帶著哈曼來赴王后以斯帖的筵席。',
    '斯7:2 這第二次在酒席筵前，王又問以斯帖說：王后以斯帖啊，你要什麼，我必賜給你；你求什麼，就是國的一半也必為你成就。',
    '斯7:3 王后以斯帖回答說：我若在王眼前蒙恩，王若以為美，我所願的，是願王將我的性命賜給我；我所求的，是求王將我的本族賜給我。',
    '斯7:4 因我和我的本族被賣了，要剪除殺戮滅絕我們。我們若被賣為奴為婢，我也閉口不言；但王的損失，敵人萬不能補足。',
    '斯7:5 亞哈隨魯王問王后以斯帖說：擅敢起意如此行的是誰﹖這人在哪裡呢﹖',
    '斯7:6 以斯帖說：仇人敵人就是這惡人哈曼！哈曼在王和王后面前就甚驚惶。',
    '斯7:7 王便大怒，起來離開酒席往御園去了。哈曼見王定意要加罪與他，就起來，求王后以斯帖救命。',
    '斯7:8 王從御園回到酒席之處，見哈曼伏在以斯帖所靠的榻上；王說：他竟敢在宮內、在我面前凌辱王后嗎﹖這話一出王口，人就蒙了哈曼的臉。',
    '斯7:9 伺候王的一個太監名叫哈波拿，說：哈曼為那救王有功的末底改做了五丈高的木架，現今立在哈曼家裡。王說：把哈曼掛在其上。',
    '斯7:10 於是人將哈曼掛在他為末底改所預備的木架上。王的忿怒這才止息。',
    '斯8:1 當日，亞哈隨魯王把猶大人仇敵哈曼的家產賜給王后以斯帖。末底改也來到王面前，因為以斯帖已經告訴王，末底改是他的親屬。',
    '斯8:2 王摘下自己的戒指，就是從哈曼追回的，給了末底改。以斯帖派末底改管理哈曼的家產。',
    '斯8:3 以斯帖又俯伏在王腳前，流淚哀告，求他除掉亞甲族哈曼害猶大人的惡謀。',
    '斯8:4 王向以斯帖伸出金杖；以斯帖就起來，站在王前，',
    '斯8:5 說：亞甲族哈米大他的兒子哈曼設謀傳旨，要殺滅在王各省的猶大人。現今王若願意，我若在王眼前蒙恩，王若以為美，若喜悅我，請王另下旨意，廢除哈曼所傳的那旨意。',
    '斯8:6 我何忍見我本族的人受害﹖何忍見我同宗的人被滅呢﹖',
    '斯8:7 亞哈隨魯王對王后以斯帖和猶大人末底改說：因哈曼要下手害猶大人，我已將他的家產賜給以斯帖，人也將哈曼掛在木架上。',
    '斯8:8 現在你們可以隨意奉王的名寫諭旨給猶大人，用王的戒指蓋印；因為奉王名所寫、用王戒指蓋印的諭旨，人都不能廢除。',
    '斯8:9 三月，就是西彎月二十三日，將王的書記召來，按著末底改所吩咐的，用各省的文字、各族的方言，並猶大人的文字方言寫諭旨，傳給那從印度直到古實一百二十七省的猶大人和總督省長首領。',
    '斯8:10 末底改奉亞哈隨魯王的名寫諭旨，用王的戒指蓋印，交給騎御馬圈快馬的驛卒，傳到各處。',
    '斯8:11 諭旨中，王准各省各城的猶大人在一日之間，十二月，就是亞達月十三日，聚集保護性命，剪除殺戮滅絕那要攻擊猶大人的一切仇敵和他們的妻子兒女，奪取他們的財為掠物。',
    '斯8:12 併於上節。',
    '斯8:13 抄錄這諭旨，頒行各省，宣告各族，使猶大人預備等候那日，在仇敵身上報仇。',
    '斯8:14 於是騎快馬的驛卒被王命催促，急忙起行；諭旨也傳遍書珊城。',
    '斯8:15 末底改穿著藍色白色的朝服，頭戴大金冠冕，又穿紫色細麻布的外袍，從王面前出來；書珊城的人民都歡呼快樂。',
    '斯8:16 猶大人有光榮，歡喜快樂而得尊貴。',
    '斯8:17 王的諭旨所到的各省各城，猶大人都歡喜快樂，設擺筵宴，以那日為吉日。那國的人民，有許多因懼怕猶大人，就入了猶大籍。',
    '斯9:1 十二月，乃亞達月十三日，王的諭旨將要舉行，就是猶大人的仇敵盼望轄制他們的日子，猶大人反倒轄制恨他們的人。',
    '斯9:2 猶大人在亞哈隨魯王各省的城裡聚集，下手擊殺那要害他們的人。無人能敵擋他們，因為各族都懼怕他們。',
    '斯9:3 各省的首領、總督、省長，和辦理王事的人，因懼怕末底改，就都幫助猶大人。',
    '斯9:4 末底改在朝中為大，名聲傳遍各省，日漸昌盛。',
    '斯9:5 猶大人用刀擊殺一切仇敵，任意殺滅恨他們的人。',
    '斯9:6 在書珊城，猶大人殺滅了五百人；',
    '斯9:7 又殺巴珊大他、達分、亞斯帕他、',
    '斯9:8 破拉他、亞大利雅、亞利大他、',
    '斯9:9 帕瑪斯他、亞利賽、亞利代、瓦耶撒他；',
    '斯9:10 這十人都是哈米大他的孫子、猶大人仇敵哈曼的兒子。猶大人卻沒有下手奪取財物。',
    '斯9:11 當日，將書珊城被殺的人數呈在王前。',
    '斯9:12 王對王后以斯帖說：猶大人在書珊城殺滅了五百人，又殺了哈曼的十個兒子，在王的各省不知如何呢﹖現在你要什麼，我必賜給你；你還求什麼，也必為你成就。',
    '斯9:13 以斯帖說：王若以為美，求你准書珊的猶大人，明日也照今日的旨意行，並將哈曼十個兒子的屍首掛在木架上。',
    '斯9:14 王便允准如此行。旨意傳在書珊，人就把哈曼十個兒子的屍首掛起來了。',
    '斯9:15 亞達月十四日書珊的猶大人又聚集在書珊，殺了三百人，卻沒有下手奪取財物。',
    '斯9:16 在王各省其餘的猶大人也都聚集保護性命，殺了恨他們的人七萬五千，卻沒有下手奪取財物。這樣，就脫離仇敵，得享平安。',
    '斯9:17 亞達月十三日，行了這事；十四日安息，以這日為設筵歡樂的日子。',
    '斯9:18 但書珊的猶大人，這十三日、十四日聚集殺戮仇敵；十五日安息，以這日為設筵歡樂的日子。',
    '斯9:19 所以住無城牆鄉村的猶大人，如今都以亞達月十四日為設筵歡樂的吉日，彼此餽送禮物。',
    '斯9:20 末底改記錄這事，寫信與亞哈隨魯王各省遠近所有的猶大人，',
    '斯9:21 囑咐他們每年守亞達月十四、十五兩日，',
    '斯9:22 以這月的兩日為猶大人脫離仇敵得平安、轉憂為喜、轉悲為樂的吉日。在這兩日設筵歡樂，彼此餽送禮物，賙濟窮人。',
    '斯9:23 於是，猶大人按著末底改所寫與他們的信，應承照初次所守的守為永例；',
    '斯9:24 是因猶大人的仇敵亞甲族哈米大他的兒子哈曼設謀殺害猶大人，掣普珥，就是掣籤，為要殺盡滅絕他們；',
    '斯9:25 這事報告於王，王便降旨使哈曼謀害猶大人的惡事歸到他自己的頭上，並吩咐把他和他的眾子都掛在木架上。',
    '斯9:26 照著普珥的名字，猶大人就稱這兩日為普珥日。他們因這信上的話，又因所看見所遇見的事，',
    '斯9:27 就應承自己與後裔，並歸附他們的人，每年按時必守這兩日，永遠不廢。',
    '斯9:28 各省各城、家家戶戶、世世代代記念遵守這兩日，使這普珥日在猶大人中不可廢掉，在他們後裔中也不可忘記。',
    '斯9:29 亞比孩的女兒─王后以斯帖和猶大人末底改以全權寫第二封信，堅囑猶大人守這普珥日，',
    '斯9:30 用和平誠實話寫信給亞哈隨魯王國中一百二十七省所有的猶大人，',
    '斯9:31 勸他們按時守這普珥日，禁食呼求，是照猶大人末底改和王后以斯帖所囑咐的，也照猶大人為自己與後裔所應承的。',
    '斯9:32 以斯帖命定守普珥日，這事也記錄在書上。',
    '斯10:1 亞哈隨魯王使旱地和海島的人民都進貢。',
    '斯10:2 他以權柄能力所行的，並他擡舉末底改使他高升的事，豈不都寫在瑪代和波斯王的歷史上嗎﹖',
    '斯10:3 猶大人末底改作亞哈隨魯王的宰相，在猶大人中為大，得他眾弟兄的喜悅，為本族的人求好處，向他們說和平的話。',
    '伯1:1 烏斯地有一個人名叫約伯；那人完全正直，敬畏神，遠離惡事。',
    '伯1:2 他生了七個兒子，三個女兒。',
    '伯1:3 他的家產有七千羊，三千駱駝，五百對牛，五百母驢，並有許多僕婢。這人在東方人中就為至大。',
    '伯1:4 他的兒子按著日子各在自己家裡設擺筵宴，就打發人去，請了他們的三個姊妹來，與他們一同吃喝。',
    '伯1:5 筵宴的日子過了，約伯打發人去叫他們自潔。他清早起來，按著他們眾人的數目獻燔祭；因為他說：恐怕我兒子犯了罪，心中棄掉神。約伯常常這樣行。',
    '伯1:6 有一天，神的眾子來侍立在耶和華面前，撒但也來在其中。',
    '伯1:7 耶和華問撒但說：你從哪裡來﹖撒但回答說：我從地上走來走去，往返而來。',
    '伯1:8 耶和華問撒但說：你曾用心察看我的僕人約伯沒有﹖地上再沒有人像他完全正直，敬畏神，遠離惡事。',
    '伯1:9 撒但回答耶和華說：約伯敬畏神，豈是無故呢﹖',
    '伯1:10 你豈不是四面圈上籬笆圍護他和他的家，並他一切所有的嗎﹖他手所做的都蒙你賜福；他的家產也在地上增多。',
    '伯1:11 你且伸手毀他一切所有的；他必當面棄掉你。',
    '伯1:12 耶和華對撒但說：凡他所有的都在你手中；只是不可伸手加害於他。於是撒但從耶和華面前退去。',
    '伯1:13 有一天，約伯的兒女正在他們長兄的家裡吃飯喝酒，',
    '伯1:14 有報信的來見約伯，說：牛正耕地，驢在旁邊吃草，',
    '伯1:15 示巴人忽然闖來，把牲畜擄去，並用刀殺了僕人；惟有我一人逃脫，來報信給你。',
    '伯1:16 他還說話的時候，又有人來說：神從天上降下火來，將群羊和僕人都燒滅了；惟有我一人逃脫，來報信給你。',
    '伯1:17 他還說話的時候，又有人來說：迦勒底人分作三隊忽然闖來，把駱駝擄去，並用刀殺了僕人；惟有我一人逃脫，來報信給你。',
    '伯1:18 他還說話的時候，又有人來說：你的兒女正在他們長兄的家裡吃飯喝酒，',
    '伯1:19 不料，有狂風從曠野颳來，擊打房屋的四角，房屋倒塌在少年人身上，他們就都死了；惟有我一人逃脫，來報信給你。',
    '伯1:20 約伯便起來，撕裂外袍，剃了頭，伏在地上下拜，',
    '伯1:21 說：我赤身出於母胎，也必赤身歸回；賞賜的是耶和華，收取的也是耶和華。耶和華的名是應當稱頌的。',
    '伯1:22 在這一切的事上約伯並不犯罪，也不以神為愚妄（或譯：也不妄評神）。',
    '伯2:1 又有一天，神的眾子來侍立在耶和華面前，撒但也來在其中。',
    '伯2:2 耶和華問撒但說：你從哪裡來﹖撒但回答說：我從地上走來走去，往返而來。',
    '伯2:3 耶和華問撒但說：你曾用心察看我的僕人約伯沒有﹖地上再沒有人像他完全正直，敬畏神，遠離惡事。你雖激動我攻擊他，無故地毀滅他，他仍然持守他的純正。',
    '伯2:4 撒但回答耶和華說：人以皮代皮，情願捨去一切所有的，保全性命。',
    '伯2:5 你且伸手傷他的骨頭和他的肉，他必當面棄掉你。',
    '伯2:6 耶和華對撒但說：他在你手中，只要存留他的性命。',
    '伯2:7 於是撒但從耶和華面前退去，擊打約伯，使他從腳掌到頭頂長毒瘡。',
    '伯2:8 約伯就坐在爐灰中，拿瓦片刮身體。',
    '伯2:9 他的妻子對他說：你仍然持守你的純正嗎﹖你棄掉神，死了吧！',
    '伯2:10 約伯卻對他說：你說話像愚頑的婦人一樣。噯！難道我們從神手裡得福，不也受禍嗎﹖在這一切的事上約伯並不以口犯罪。',
    '伯2:11 約伯的三個朋友─提幔人以利法、書亞人比勒達、拿瑪人瑣法─聽說有這一切的災禍臨到他身上，各人就從本處約會同來，為他悲傷，安慰他。',
    '伯2:12 他們遠遠地舉目觀看，認不出他來，就放聲大哭。各人撕裂外袍，把塵土向天揚起來，落在自己的頭上。',
    '伯2:13 他們就同他七天七夜坐在地上，一個人也不向他說句話，因為他極其痛苦。',
    '伯3:1 此後，約伯開口咒詛自己的生日，',
    '伯3:2 說：',
    '伯3:3 願我生的那日和說懷了男胎的那夜都滅沒。',
    '伯3:4 願那日變為黑暗；願神不從上面尋找他；願亮光不照於其上。',
    '伯3:5 願黑暗和死蔭索取那日；願密雲停在其上；願日蝕恐嚇他。',
    '伯3:6 願那夜被幽暗奪取，不在年中的日子同樂，也不入月中的數目。',
    '伯3:7 願那夜沒有生育，其間也沒有歡樂的聲音。',
    '伯3:8 願那咒詛日子且能惹動鱷魚的咒詛那夜。',
    '伯3:9 願那夜黎明的星宿變為黑暗，盼亮卻不亮，也不見早晨的光線（原文是眼皮）；',
    '伯3:10 因沒有把懷我胎的門關閉，也沒有將患難對我的眼隱藏。',
    '伯3:11 我為何不出母胎而死﹖為何不出母腹絕氣﹖',
    '伯3:12 為何有膝接收我﹖為何有奶哺養我﹖',
    '伯3:13 不然，我就早已躺臥安睡，',
    '伯3:14 和地上為自己重造荒邱的君王、謀士，',
    '伯3:15 或與有金子、將銀子裝滿了房屋的王子一同安息；',
    '伯3:16 或像隱而未現、不到期而落的胎，歸於無有，如同未見光的嬰孩。',
    '伯3:17 在那裡惡人止息攪擾，困乏人得享安息，',
    '伯3:18 被囚的人同得安逸，不聽見督工的聲音。',
    '伯3:19 大小都在那裡；奴僕脫離主人的轄制。',
    '伯3:20 受患難的人為何有光賜給他呢﹖心中愁苦的人為何有生命賜給他呢﹖',
    '伯3:21 他們切望死，卻不得死；求死，勝於求隱藏的珍寶。',
    '伯3:22 他們尋見墳墓就快樂，極其歡喜。',
    '伯3:23 人的道路既然遮隱，神又把他四面圍困，為何有光賜給他呢﹖',
    '伯3:24 我未曾吃飯就發出歎息；我唉哼的聲音湧出如水。',
    '伯3:25 因我所恐懼的臨到我身，我所懼怕的迎我而來。',
    '伯3:26 我不得安逸，不得平靜，也不得安息，卻有患難來到。',
    '伯4:1 提幔人以利法回答說：',
    '伯4:2 人若想與你說話，你就厭煩嗎﹖但誰能忍住不說呢﹖',
    '伯4:3 你素來教導許多的人，又堅固軟弱的手。',
    '伯4:4 你的言語曾扶助那將要跌倒的人；你又使軟弱的膝穩固。',
    '伯4:5 但現在禍患臨到你，你就昏迷，挨近你，你便驚惶。',
    '伯4:6 你的倚靠不是在你敬畏神嗎﹖你的盼望不是在你行事純正嗎﹖',
    '伯4:7 請你追想：無辜的人有誰滅亡﹖正直的人在何處剪除﹖',
    '伯4:8 按我所見，耕罪孽、種毒害的人都照樣收割。',
    '伯4:9 神一出氣，他們就滅亡；神一發怒，他們就消沒。',
    '伯4:10 獅子的吼叫和猛獅的聲音盡都止息；少壯獅子的牙齒也都敲掉。',
    '伯4:11 老獅子因絕食而死；母獅之子也都離散。',
    '伯4:12 我暗暗地得了默示；我耳朵也聽其細微的聲音。',
    '伯4:13 在思念夜中、異象之間，世人沉睡的時候，',
    '伯4:14 恐懼、戰兢臨到我身，使我百骨打戰。',
    '伯4:15 有靈從我面前經過，我身上的毫毛直立。',
    '伯4:16 那靈停住，我卻不能辨其形狀；有影像在我眼前。我在靜默中聽見有聲音說：',
    '伯4:17 必死的人豈能比神公義嗎﹖人豈能比造他的主潔淨嗎﹖',
    '伯4:18 主不信靠他的臣僕，並且指他的使者為愚昧；',
    '伯4:19 何況那住在土房、根基在塵土裡、被蠹蟲所毀壞的人呢﹖',
    '伯4:20 早晚之間，就被毀滅，永歸無有，無人理會。',
    '伯4:21 他帳棚的繩索豈不從中抽出來呢﹖他死，且是無智慧而死。',
    '伯5:1 你且呼求，有誰答應你﹖諸聖者之中，你轉向哪一位呢﹖',
    '伯5:2 忿怒害死愚妄人；嫉妒殺死癡迷人。',
    '伯5:3 我曾見愚妄人扎下根，但我忽然咒詛他的住處。',
    '伯5:4 他的兒女遠離穩妥的地步，在城門口被壓，並無人搭救。',
    '伯5:5 他的莊稼有飢餓的人吃盡了，就是在荊棘裡的也搶去了；他的財寶有網羅張口吞滅了。',
    '伯5:6 禍患原不是從土中出來；患難也不是從地裡發生。',
    '伯5:7 人生在世必遇患難，如同火星飛騰。',
    '伯5:8 至於我，我必仰望神，把我的事情託付他。',
    '伯5:9 他行大事不可測度，行奇事不可勝數：',
    '伯5:10 降雨在地上，賜水於田裡；',
    '伯5:11 將卑微的安置在高處，將哀痛的舉到穩妥之地；',
    '伯5:12 破壞狡猾人的計謀，使他們所謀的不得成就。',
    '伯5:13 他叫有智慧的中了自己的詭計，使狡詐人的計謀速速滅亡。',
    '伯5:14 他們白晝遇見黑暗，午間摸索如在夜間。',
    '伯5:15 神拯救窮乏人脫離他們口中的刀和強暴人的手。',
    '伯5:16 這樣，貧寒的人有指望，罪孽之輩必塞口無言。',
    '伯5:17 神所懲治的人是有福的！所以你不可輕看全能者的管教。',
    '伯5:18 因為他打破，又纏裹；他擊傷，用手醫治。',
    '伯5:19 你六次遭難，他必救你；就是七次，災禍也無法害你。',
    '伯5:20 在饑荒中，他必救你脫離死亡；在爭戰中，他必救你脫離刀劍的權力。',
    '伯5:21 你必被隱藏，不受口舌之害；災殃臨到，你也不懼怕。',
    '伯5:22 你遇見災害饑饉，就必嬉笑；地上的野獸，你也不懼怕。',
    '伯5:23 因為你必與田間的石頭立約；田裡的野獸也必與你和好。',
    '伯5:24 你必知道你帳棚平安，要查看你的羊圈，一無所失；',
    '伯5:25 也必知道你的後裔將來發達，你的子孫像地上的青草。',
    '伯5:26 你必壽高年邁才歸墳墓，好像禾捆到時收藏。',
    '伯5:27 這理，我們已經考察，本是如此。你須要聽，要知道是於自己有益。',
    '伯6:1 約伯回答說：',
    '伯6:2 惟願我的煩惱稱一稱，我一切的災害放在天平裡；',
    '伯6:3 現今都比海沙更重，所以我的言語急躁。',
    '伯6:4 因全能者的箭射入我身；其毒，我的靈喝盡了；神的驚嚇擺陣攻擊我。',
    '伯6:5 野驢有草豈能叫喚﹖牛有料豈能吼叫﹖',
    '伯6:6 物淡而無鹽豈可吃嗎﹖蛋青有什麼滋味呢﹖',
    '伯6:7 看為可厭的食物，我心不肯挨近。',
    '伯6:8 惟願我得著所求的，願神賜我所切望的；',
    '伯6:9 就是願神把我壓碎，伸手將我剪除。',
    '伯6:10 我因沒有違棄那聖者的言語，就仍以此為安慰，在不止息的痛苦中還可踴躍。',
    '伯6:11 我有什麼氣力使我等候﹖我有什麼結局使我忍耐﹖',
    '伯6:12 我的氣力豈是石頭的氣力﹖我的肉身豈是銅的呢﹖',
    '伯6:13 在我豈不是毫無幫助嗎﹖智慧豈不是從我心中趕出淨盡嗎﹖',
    '伯6:14 那將要灰心、離棄全能者、不敬畏神的人，他的朋友當以慈愛待他。',
    '伯6:15 我的弟兄詭詐，好像溪水，又像溪水流乾的河道。',
    '伯6:16 這河因結冰發黑，有雪藏在其中；',
    '伯6:17 天氣漸暖就隨時消化，日頭炎熱便從原處乾涸。',
    '伯6:18 結伴的客旅離棄大道，順河偏行，到荒野之地死亡。',
    '伯6:19 提瑪結伴的客旅瞻望；示巴同夥的人等候。',
    '伯6:20 他們因失了盼望就抱愧，來到那裡便蒙羞。',
    '伯6:21 現在你們正是這樣，看見驚嚇的事便懼怕。',
    '伯6:22 我豈說：請你們供給我，從你們的財物中送禮物給我﹖',
    '伯6:23 豈說：拯救我脫離敵人的手嗎﹖救贖我脫離強暴人的手嗎﹖',
    '伯6:24 請你們教導我，我便不作聲；使我明白在何事上有錯。',
    '伯6:25 正直的言語力量何其大！但你們責備是責備什麼呢﹖',
    '伯6:26 絕望人的講論既然如風，你們還想要駁正言語嗎﹖',
    '伯6:27 你們想為孤兒拈鬮，以朋友當貨物。',
    '伯6:28 現在請你們看看我，我決不當面說謊。',
    '伯6:29 請你們轉意，不要不公；請再轉意，我的事有理。',
    '伯6:30 我的舌上豈有不義嗎﹖我的口裡豈不辨奸惡嗎﹖',
    '伯7:1 人在世上豈無爭戰嗎﹖他的日子不像雇工人的日子嗎﹖',
    '伯7:2 像奴僕切慕黑影，像雇工人盼望工價；',
    '伯7:3 我也照樣經過困苦的日月，夜間的疲乏為我而定。',
    '伯7:4 我躺臥的時候便說：我何時起來，黑夜就過去呢﹖我盡是反來覆去，直到天亮。',
    '伯7:5 我的肉體以蟲子和塵土為衣；我的皮膚才收了口又重新破裂。',
    '伯7:6 我的日子比梭更快，都消耗在無指望之中。',
    '伯7:7 求你想念，我的生命不過是一口氣；我的眼睛必不再見福樂。',
    '伯7:8 觀看我的人，他的眼必不再見我；你的眼目要看我，我卻不在了。',
    '伯7:9 雲彩消散而過；照樣，人下陰間也不再上來。',
    '伯7:10 他不再回自己的家；故土也不再認識他。',
    '伯7:11 我不禁止我口；我靈愁苦，要發出言語；我心苦惱，要吐露哀情。',
    '伯7:12 我對神說：我豈是洋海，豈是大魚，你竟防守我呢﹖',
    '伯7:13 若說：我的床必安慰我，我的榻必解釋我的苦情，',
    '伯7:14 你就用夢驚駭我，用異象恐嚇我，',
    '伯7:15 甚至我寧肯噎死，寧肯死亡，勝似留我這一身的骨頭。',
    '伯7:16 我厭棄性命，不願永活。你任憑我吧，因我的日子都是虛空。',
    '伯7:17 人算什麼，你竟看他為大，將他放在心上﹖',
    '伯7:18 每早鑒察他，時刻試驗他﹖',
    '伯7:19 你到何時才轉眼不看我，才任憑我咽下唾沫呢﹖',
    '伯7:20 鑒察人的主啊，我若有罪，於你何妨﹖為何以我當你的箭靶子，使我厭棄自己的性命﹖',
    '伯7:21 為何不赦免我的過犯，除掉我的罪孽﹖我現今要躺臥在塵土中；你要殷勤地尋找我，我卻不在了。',
    '伯8:1 書亞人比勒達回答說：',
    '伯8:2 這些話你要說到幾時﹖口中的言語如狂風要到幾時呢﹖',
    '伯8:3 神豈能偏離公平﹖全能者豈能偏離公義﹖',
    '伯8:4 或者你的兒女得罪了他；他使他們受報應。',
    '伯8:5 你若殷勤地尋求神，向全能者懇求；',
    '伯8:6 你若清潔正直，他必定為你起來，使你公義的居所興旺。',
    '伯8:7 你起初雖然微小，終久必甚發達。',
    '伯8:8 請你考問前代，追念他們的列祖所查究的。',
    '伯8:9 我們不過從昨日才有，一無所知；我們在世的日子好像影兒。',
    '伯8:10 他們豈不指教你，告訴你，從心裡發出言語來呢﹖',
    '伯8:11 蒲草沒有泥豈能發長﹖蘆荻沒有水豈能生發﹖',
    '伯8:12 尚青的時候，還沒有割下，比百樣的草先枯槁。',
    '伯8:13 凡忘記神的人，景況也是這樣；不虔敬人的指望要滅沒。',
    '伯8:14 他所仰賴的必折斷；他所倚靠的是蜘蛛網。',
    '伯8:15 他要倚靠房屋，房屋卻站立不住；他要抓住房屋，房屋卻不能存留。',
    '伯8:16 他在日光之下發青，蔓子爬滿了園子；',
    '伯8:17 他的根盤繞石堆，扎入石地。',
    '伯8:18 他若從本地被拔出，那地就不認識他，說：我沒有見過你。',
    '伯8:19 看哪，這就是他道中之樂；以後必另有人從地而生。',
    '伯8:20 神必不丟棄完全人，也不扶助邪惡人。',
    '伯8:21 他還要以喜笑充滿你的口，以歡呼充滿你的嘴。',
    '伯8:22 恨惡你的要披戴慚愧；惡人的帳棚必歸於無有。',
    '伯9:1 約伯回答說：',
    '伯9:2 我真知道是這樣；但人在神面前怎能成為義呢﹖',
    '伯9:3 若願意與他爭辯，千中之一也不能回答。',
    '伯9:4 他心裡有智慧，且大有能力。誰向神剛硬而得亨通呢﹖',
    '伯9:5 他發怒，把山翻倒挪移，山並不知覺。',
    '伯9:6 他使地震動，離其本位，地的柱子就搖撼。',
    '伯9:7 他吩咐日頭不出來，就不出來，又封閉眾星。',
    '伯9:8 他獨自鋪張蒼天，步行在海浪之上。',
    '伯9:9 他造北斗、參星、昴星，並南方的密宮；',
    '伯9:10 他行大事，不可測度，行奇事，不可勝數。',
    '伯9:11 他從我旁邊經過，我卻不看見；他在我面前行走，我倒不知覺。',
    '伯9:12 他奪取，誰能阻擋﹖誰敢問他：你做什麼﹖',
    '伯9:13 神必不收回他的怒氣；扶助拉哈伯的，屈身在他以下。',
    '伯9:14 既是這樣，我怎敢回答他，怎敢選擇言語與他辯論呢﹖',
    '伯9:15 我雖有義，也不回答他，只要向那審判我的懇求。',
    '伯9:16 我若呼籲，他應允我；我仍不信他真聽我的聲音。',
    '伯9:17 他用暴風折斷我，無故地加增我的損傷。',
    '伯9:18 我就是喘一口氣，他都不容，倒使我滿心苦惱。',
    '伯9:19 若論力量，他真有能力！若論審判，他說誰能將我傳來呢﹖',
    '伯9:20 我雖有義，自己的口要定我為有罪；我雖完全，我口必顯我為彎曲。',
    '伯9:21 我本完全，不顧自己；我厭惡我的性命。',
    '伯9:22 善惡無分，都是一樣；所以我說，完全人和惡人，他都滅絕。',
    '伯9:23 若忽然遭殺害之禍，他必戲笑無辜的人遇難。',
    '伯9:24 世界交在惡人手中；蒙蔽世界審判官的臉，若不是他，是誰呢﹖',
    '伯9:25 我的日子比跑信的更快，急速過去，不見福樂。',
    '伯9:26 我的日子過去如快船，如急落抓食的鷹。',
    '伯9:27 我若說：我要忘記我的哀情，除去我的愁容，心中暢快；',
    '伯9:28 我因愁苦而懼怕，知道你必不以我為無辜。',
    '伯9:29 我必被你定為有罪，我何必徒然勞苦呢﹖',
    '伯9:30 我若用雪水洗身，用鹼潔淨我的手，',
    '伯9:31 你還要扔我在坑裡，我的衣服都憎惡我。',
    '伯9:32 他本不像我是人，使我可以回答他，又使我們可以同聽審判。',
    '伯9:33 我們中間沒有聽訟的人可以向我們兩造按手。',
    '伯9:34 願他把杖離開我，不使驚惶威嚇我。',
    '伯9:35 我就說話，也不懼怕他，現在我卻不是那樣。',
    '伯10:1 我厭煩我的性命，必由著自己述說我的哀情；因心裡苦惱，我要說話，',
    '伯10:2 對神說：不要定我有罪，要指示我，你為何與我爭辯﹖',
    '伯10:3 你手所造的，你又欺壓，又藐視，卻光照惡人的計謀。這事你以為美嗎﹖',
    '伯10:4 你的眼豈是肉眼﹖你查看豈像人查看嗎﹖',
    '伯10:5 你的日子豈像人的日子，你的年歲豈像人的年歲，',
    '伯10:6 就追問我的罪孽，尋察我的罪過嗎﹖',
    '伯10:7 其實，你知道我沒有罪惡，並沒有能救我脫離你手的。',
    '伯10:8 你的手創造我，造就我的四肢百體，你還要毀滅我。',
    '伯10:9 求你記念─製造我如摶泥一般，你還要使我歸於塵土嗎﹖',
    '伯10:10 你不是倒出我來好像奶，使我凝結如同奶餅嗎﹖',
    '伯10:11 你以皮和肉為衣給我穿上，用骨與筋把我全體聯絡。',
    '伯10:12 你將生命和慈愛賜給我；你也眷顧保全我的心靈。',
    '伯10:13 然而，你待我的這些事早已藏在你心裡；我知道你久有此意。',
    '伯10:14 我若犯罪，你就察看我，並不赦免我的罪孽。',
    '伯10:15 我若行惡，便有了禍；我若為義，也不敢擡頭，正是滿心羞愧，眼見我的苦情。',
    '伯10:16 我若昂首自得，你就追捕我如獅子，又在我身上顯出奇能。',
    '伯10:17 你重立見證攻擊我，向我加增惱怒，如軍兵更換著攻擊我。',
    '伯10:18 你為何使我出母胎呢﹖不如我當時氣絕，無人得見我；',
    '伯10:19 這樣，就如沒有我一般，一出母胎就被送入墳墓。',
    '伯10:20 我的日子不是甚少嗎﹖求你停手寬容我，叫我在往而不返之先─就是往黑暗和死蔭之地以先─可以稍得暢快。',
    '伯10:21 併於上節。',
    '伯10:22 那地甚是幽暗，是死蔭混沌之地；那裡的光好像幽暗。',
    '伯11:1 拿瑪人瑣法回答說：',
    '伯11:2 這許多的言語豈不該回答嗎﹖多嘴多舌的人豈可稱為義嗎﹖',
    '伯11:3 你誇大的話豈能使人不作聲嗎﹖你戲笑的時候豈沒有人叫你害羞嗎﹖',
    '伯11:4 你說：我的道理純全；我在你眼前潔淨。',
    '伯11:5 惟願神說話；願他開口攻擊你，',
    '伯11:6 並將智慧的奧祕指示你；他有諸般的智識。所以當知道神追討你比你罪孽該得的還少。',
    '伯11:7 你考察就能測透神嗎﹖你豈能盡情測透全能者嗎﹖',
    '伯11:8 他的智慧高於天，你還能做什麼﹖深於陰間，你還能知道什麼﹖',
    '伯11:9 其量比地長，比海寬。',
    '伯11:10 他若經過，將人拘禁，招人受審，誰能阻擋他呢﹖',
    '伯11:11 他本知道虛妄的人；人的罪孽，他雖不留意，還是無所不見。',
    '伯11:12 空虛的人卻毫無知識；人生在世好像野驢的駒子。',
    '伯11:13 你若將心安正，又向主舉手；',
    '伯11:14 你手裡若有罪孽，就當遠遠地除掉，也不容非義住在你帳棚之中。',
    '伯11:15 那時，你必仰起臉來毫無斑點；你也必堅固，無所懼怕。',
    '伯11:16 你必忘記你的苦楚，就是想起也如流過去的水一樣。',
    '伯11:17 你在世的日子要比正午更明，雖有黑暗仍像早晨。',
    '伯11:18 你因有指望就必穩固，也必四圍巡查，坦然安息。',
    '伯11:19 你躺臥，無人驚嚇，且有許多人向你求恩。',
    '伯11:20 但惡人的眼目必要失明。他們無路可逃；他們的指望就是氣絕。',
    '伯12:1 約伯回答說：',
    '伯12:2 你們真是子民哪，你們死亡，智慧也就滅沒了。',
    '伯12:3 但我也有聰明，與你們一樣，並非不及你們。你們所說的，誰不知道呢﹖',
    '伯12:4 我這求告神、蒙他應允的人竟成了朋友所譏笑的；公義完全人竟受了人的譏笑。',
    '伯12:5 安逸的人心裡藐視災禍；這災禍常常等待滑腳的人。',
    '伯12:6 強盜的帳棚興旺，惹神的人穩固，神多將財物送到他們手中。',
    '伯12:7 你且問走獸，走獸必指教你；又問空中的飛鳥，飛鳥必告訴你；',
    '伯12:8 或與地說話，地必指教你；海中的魚也必向你說明。',
    '伯12:9 看這一切，誰不知道是耶和華的手做成的呢﹖',
    '伯12:10 凡活物的生命和人類的氣息都在他手中。',
    '伯12:11 耳朵豈不試驗言語，正如上膛嘗食物嗎﹖',
    '伯12:12 年老的有智慧；壽高的有知識。',
    '伯12:13 在神有智慧和能力；他有謀略和知識。',
    '伯12:14 他拆毀的，就不能再建造；他捆住人，便不得開釋。',
    '伯12:15 他把水留住，水便枯乾；他再發出水來，水就翻地。',
    '伯12:16 在他有能力和智慧，被誘惑的與誘惑人的都是屬他。',
    '伯12:17 他把謀士剝衣擄去，又使審判官變成愚人。',
    '伯12:18 他放鬆君王的綁，又用帶子捆他們的腰。',
    '伯12:19 他把祭司剝衣擄去，又使有能的人傾敗。',
    '伯12:20 他廢去忠信人的講論，又奪去老人的聰明。',
    '伯12:21 他使君王蒙羞被辱，放鬆有力之人的腰帶。',
    '伯12:22 他將深奧的事從黑暗中彰顯，使死蔭顯為光明。',
    '伯12:23 他使邦國興旺而又毀滅；他使邦國開廣而又擄去。',
    '伯12:24 他將地上民中首領的聰明奪去，使他們在荒廢無路之地漂流；',
    '伯12:25 他們無光，在黑暗中摸索，又使他們東倒西歪，像醉酒的人一樣。',
    '伯13:1 這一切，我眼都見過；我耳都聽過，而且明白。',
    '伯13:2 你們所知道的，我也知道，並非不及你們。',
    '伯13:3 我真要對全能者說話；我願與神理論。',
    '伯13:4 你們是編造謊言的，都是無用的醫生。',
    '伯13:5 惟願你們全然不作聲；這就算為你們的智慧！',
    '伯13:6 請你們聽我的辯論，留心聽我口中的分訴。',
    '伯13:7 你們要為神說不義的話嗎﹖為他說詭詐的言語嗎﹖',
    '伯13:8 你們要為神徇情嗎﹖要為他爭論嗎﹖',
    '伯13:9 他查出你們來，這豈是好嗎﹖人欺哄人，你們也要照樣欺哄他嗎﹖',
    '伯13:10 你們若暗中徇情，他必要責備你們。',
    '伯13:11 他的尊榮豈不叫你們懼怕嗎﹖他的驚嚇豈不臨到你們嗎﹖',
    '伯13:12 你們以為可記念的箴言是爐灰的箴言；你們以為可靠的堅壘是淤泥的堅壘。',
    '伯13:13 你們不要作聲，任憑我吧！讓我說話，無論如何我都承當。',
    '伯13:14 我何必把我的肉掛在牙上，將我的命放在手中。',
    '伯13:15 他必殺我；我雖無指望，然而我在他面前還要辯明我所行的。',
    '伯13:16 這要成為我的拯救，因為不虔誠的人不得到他面前。',
    '伯13:17 你們要細聽我的言語，使我所辯論的入你們的耳中。',
    '伯13:18 我已陳明我的案，知道自己有義。',
    '伯13:19 有誰與我爭論，我就情願緘默不言，氣絕而亡。',
    '伯13:20 惟有兩件不要向我施行，我就不躲開你的面：',
    '伯13:21 就是把你的手縮回，遠離我身；又不使你的驚惶威嚇我。',
    '伯13:22 這樣，你呼叫，我就回答；或是讓我說話，你回答我。',
    '伯13:23 我的罪孽和罪過有多少呢﹖求你叫我知道我的過犯與罪愆。',
    '伯13:24 你為何掩面、拿我當仇敵呢﹖',
    '伯13:25 你要驚動被風吹的葉子嗎﹖要追趕枯乾的碎稭嗎﹖',
    '伯13:26 你按罪狀刑罰我，又使我擔當幼年的罪孽；',
    '伯13:27 也把我的腳上了木狗，並窺察我一切的道路，為我的腳掌劃定界限。',
    '伯13:28 我已經像滅絕的爛物，像蟲蛀的衣裳。',
    '伯14:1 人為婦人所生，日子短少，多有患難；',
    '伯14:2 出來如花，又被割下，飛去如影，不能存留。',
    '伯14:3 這樣的人你豈睜眼看他嗎﹖又叫我來受審嗎﹖',
    '伯14:4 誰能使潔淨之物出於污穢之中呢﹖無論誰也不能！',
    '伯14:5 人的日子既然限定，他的月數在你那裡，你也派定他的界限，使他不能越過，',
    '伯14:6 便求你轉眼不看他，使他得歇息，直等他像雇工人完畢他的日子。',
    '伯14:7 樹若被砍下，還可指望發芽，嫩枝生長不息；',
    '伯14:8 其根雖然衰老在地裡，幹也死在土中，',
    '伯14:9 及至得了水氣，還要發芽，又長枝條，像新栽的樹一樣。',
    '伯14:10 但人死亡而消滅；他氣絕，竟在何處呢﹖',
    '伯14:11 海中的水絕盡，江河消散乾涸。',
    '伯14:12 人也是如此，躺下不再起來，等到天沒有了，仍不得復醒，也不得從睡中喚醒。',
    '伯14:13 惟願你把我藏在陰間，存於隱密處，等你的忿怒過去；願你為我定了日期，記念我。',
    '伯14:14 人若死了豈能再活呢﹖我只要在我一切爭戰的日子，等我被釋放（或譯：改變）的時候來到。',
    '伯14:15 你呼叫，我便回答；你手所做的，你必羨慕。',
    '伯14:16 但如今你數點我的腳步，豈不窺察我的罪過嗎﹖',
    '伯14:17 我的過犯被你封在囊中，也縫嚴了我的罪孽。',
    '伯14:18 山崩變為無有；磐石挪開原處。',
    '伯14:19 水流消磨石頭，所流溢的洗去地上的塵土；你也照樣滅絕人的指望。',
    '伯14:20 你攻擊人常常得勝，使他去世；你改變他的容貌，叫他往而不回。',
    '伯14:21 他兒子得尊榮，他也不知道，降為卑，他也不覺得。',
    '伯14:22 但知身上疼痛，心中悲哀。',
    '伯15:1 提幔人以利法回答說：',
    '伯15:2 智慧人豈可用虛空的知識回答，用東風充滿肚腹呢﹖',
    '伯15:3 他豈可用無益的話和無濟於事的言語理論呢﹖',
    '伯15:4 你是廢棄敬畏的意，在神面前阻止敬虔的心。',
    '伯15:5 你的罪孽指教你的口；你選用詭詐人的舌頭。',
    '伯15:6 你自己的口定你有罪，並非是我；你自己的嘴見證你的不是。',
    '伯15:7 你豈是頭一個被生的人嗎﹖你受造在諸山之先嗎﹖',
    '伯15:8 你曾聽見神的密旨嗎﹖你還將智慧獨自得盡嗎﹖',
    '伯15:9 你知道什麼是我們不知道的呢﹖你明白什麼是我們不明白的呢﹖',
    '伯15:10 我們這裡有白髮的和年紀老邁的，比你父親還老。',
    '伯15:11 神用溫和的話安慰你，你以為太小嗎﹖',
    '伯15:12 你的心為何將你逼去﹖你的眼為何冒出火星，',
    '伯15:13 使你的靈反對神，也任你的口發這言語﹖',
    '伯15:14 人是什麼，竟算為潔淨呢﹖婦人所生的是什麼，竟算為義呢﹖',
    '伯15:15 神不信靠他的眾聖者；在他眼前，天也不潔淨，',
    '伯15:16 何況那污穢可憎、喝罪孽如水的世人呢！',
    '伯15:17 我指示你，你要聽；我要述說所看見的，',
    '伯15:18 就是智慧人從列祖所受，傳說而不隱瞞的。',
    '伯15:19 （這地惟獨賜給他們，並沒有外人從他們中間經過。）',
    '伯15:20 惡人一生之日劬勞痛苦；強暴人一生的年數也是如此。',
    '伯15:21 驚嚇的聲音常在他耳中；在平安時，搶奪的必臨到他那裡。',
    '伯15:22 他不信自己能從黑暗中轉回；他被刀劍等候。',
    '伯15:23 他漂流在外求食，說：哪裡有食物呢﹖他知道黑暗的日子在他手邊預備好了。',
    '伯15:24 急難困苦叫他害怕，而且勝了他，好像君王預備上陣一樣。',
    '伯15:25 他伸手攻擊神，以驕傲攻擊全能者，',
    '伯15:26 挺著頸項，用盾牌的厚凸面向全能者直闖；',
    '伯15:27 是因他的臉蒙上脂油，腰積成肥肉。',
    '伯15:28 他曾住在荒涼城邑，無人居住、將成亂堆的房屋。',
    '伯15:29 他不得富足，財物不得常存，產業在地上也不加增。',
    '伯15:30 他不得出離黑暗。火焰要將他的枝子燒乾；因神口中的氣，他要滅亡（原文是走去）。',
    '伯15:31 他不用倚靠虛假欺哄自己，因虛假必成為他的報應。',
    '伯15:32 他的日期未到之先，這事必成就；他的枝子不得青綠。',
    '伯15:33 他必像葡萄樹的葡萄，未熟而落；又像橄欖樹的花，一開而謝。',
    '伯15:34 原來不敬虔之輩必無生育；受賄賂之人的帳棚必被火燒。',
    '伯15:35 他們所懷的是毒害，所生的是罪孽；心裡所預備的是詭詐。',
    '伯16:1 約伯回答說：',
    '伯16:2 這樣的話我聽了許多；你們安慰人，反叫人愁煩。',
    '伯16:3 虛空的言語有窮盡嗎﹖有什麼話惹動你回答呢﹖',
    '伯16:4 我也能說你們那樣的話；你們若處在我的境遇，我也會聯絡言語攻擊你們，又能向你們搖頭。',
    '伯16:5 但我必用口堅固你們，用嘴消解你們的憂愁。',
    '伯16:6 我雖說話，憂愁仍不得消解；我雖停住不說，憂愁就離開我嗎﹖',
    '伯16:7 但現在神使我困倦，使親友遠離我，',
    '伯16:8 又抓住我，作見證攻擊我；我身體的枯瘦也當面見證我的不是。',
    '伯16:9 主發怒撕裂我，逼迫我，向我切齒；我的敵人怒目看我。',
    '伯16:10 他們向我開口，打我的臉羞辱我，聚會攻擊我。',
    '伯16:11 神把我交給不敬虔的人，把我扔到惡人的手中。',
    '伯16:12 我素來安逸，他折斷我，掐住我的頸項，把我摔碎，又立我為他的箭靶子。',
    '伯16:13 他的弓箭手四面圍繞我；他破裂我的肺腑，並不留情，把我的膽傾倒在地上，',
    '伯16:14 將我破裂又破裂，如同勇士向我直闖。',
    '伯16:15 我縫麻布在我皮膚上，把我的角放在塵土中。',
    '伯16:16 我的臉因哭泣發紫，在我的眼皮上有死蔭。',
    '伯16:17 我的手中卻無強暴；我的祈禱也是清潔。',
    '伯16:18 地啊，不要遮蓋我的血！不要阻擋我的哀求！',
    '伯16:19 現今，在天有我的見證，在上有我的中保。',
    '伯16:20 我的朋友譏誚我，我卻向神眼淚汪汪。',
    '伯16:21 願人得與神辯白，如同人與朋友辯白一樣；',
    '伯16:22 因為再過幾年，我必走那往而不返之路。',
    '伯17:1 我的心靈消耗，我的日子滅盡；墳墓為我預備好了。',
    '伯17:2 真有戲笑我的在我這裡，我眼常見他們惹動我。',
    '伯17:3 願主拿憑據給我，自己為我作保。在你以外誰肯與我擊掌呢﹖',
    '伯17:4 因你使他們心不明理，所以你必不高舉他們。',
    '伯17:5 控告他的朋友、以朋友為可搶奪的，連他兒女的眼睛也要失明。',
    '伯17:6 神使我作了民中的笑談；他們也吐唾沫在我臉上。',
    '伯17:7 我的眼睛因憂愁昏花；我的百體好像影兒。',
    '伯17:8 正直人因此必驚奇；無辜的人要興起攻擊不敬虔之輩。',
    '伯17:9 然而，義人要持守所行的道；手潔的人要力上加力。',
    '伯17:10 至於你們眾人，可以再來辯論吧！你們中間，我找不著一個智慧人。',
    '伯17:11 我的日子已經過了；我的謀算、我心所想望的已經斷絕。',
    '伯17:12 他們以黑夜為白晝，說：亮光近乎黑暗。',
    '伯17:13 我若盼望陰間為我的房屋，若下榻在黑暗中，',
    '伯17:14 若對朽壞說：你是我的父；對蟲說：你是我的母親姊妹；',
    '伯17:15 這樣，我的指望在哪裡呢﹖我所指望的誰能看見呢﹖',
    '伯17:16 等到安息在塵土中，這指望必下到陰間的門閂那裡了。',
    '伯18:1 書亞人比勒達回答說：',
    '伯18:2 你尋索言語要到幾時呢﹖你可以揣摩思想，然後我們就說話。',
    '伯18:3 我們為何算為畜生，在你眼中看作污穢呢﹖',
    '伯18:4 你這惱怒將自己撕裂的，難道大地為你見棄、磐石挪開原處嗎﹖',
    '伯18:5 惡人的亮光必要熄滅；他的火焰必不照耀。',
    '伯18:6 他帳棚中的亮光要變為黑暗；他以上的燈也必熄滅。',
    '伯18:7 他堅強的腳步必見狹窄；自己的計謀必將他絆倒。',
    '伯18:8 因為他被自己的腳陷入網中，走在纏人的網羅上。',
    '伯18:9 圈套必抓住他的腳跟；機關必擒獲他。',
    '伯18:10 活扣為他藏在土內；羈絆為他藏在路上。',
    '伯18:11 四面的驚嚇要使他害怕，並且追趕他的腳跟。',
    '伯18:12 他的力量必因飢餓衰敗；禍患要在他旁邊等候。',
    '伯18:13 他本身的肢體要被吞吃；死亡的長子要吞吃他的肢體。',
    '伯18:14 他要從所倚靠的帳棚被拔出來，帶到驚嚇的王那裡。',
    '伯18:15 不屬他的必住在他的帳棚裡；硫磺必撒在他所住之處。',
    '伯18:16 下邊，他的根本要枯乾；上邊，他的枝子要剪除。',
    '伯18:17 他的記念在地上必然滅亡；他的名字在街上也不存留。',
    '伯18:18 他必從光明中被攆到黑暗裡，必被趕出世界。',
    '伯18:19 在本民中必無子無孫；在寄居之地也無一人存留。',
    '伯18:20 以後來的要驚奇他的日子，好像以前去的受了驚駭。',
    '伯18:21 不義之人的住處總是這樣；此乃不認識神之人的地步。',
    '伯19:1 約伯回答說：',
    '伯19:2 你們攪擾我的心，用言語壓碎我要到幾時呢﹖',
    '伯19:3 你們這十次羞辱我；你們苦待我也不以為恥。',
    '伯19:4 果真我有錯，這錯乃是在我。',
    '伯19:5 你們果然要向我誇大，以我的羞辱為證指責我，',
    '伯19:6 就該知道是神傾覆我，用網羅圍繞我。',
    '伯19:7 我因委曲呼叫，卻不蒙應允；我呼求，卻不得公斷。',
    '伯19:8 神用籬笆攔住我的道路，使我不得經過；又使我的路徑黑暗。',
    '伯19:9 他剝去我的榮光，摘去我頭上的冠冕。',
    '伯19:10 他在四圍攻擊我，我便歸於死亡，將我的指望如樹拔出來。',
    '伯19:11 他的忿怒向我發作，以我為敵人。',
    '伯19:12 他的軍旅一齊上來，修築戰路攻擊我，在我帳棚的四圍安營。',
    '伯19:13 他把我的弟兄隔在遠處，使我所認識的全然與我生疏。',
    '伯19:14 我的親戚與我斷絕；我的密友都忘記我。',
    '伯19:15 在我家寄居的，和我的使女都以我為外人；我在他們眼中看為外邦人。',
    '伯19:16 我呼喚僕人，雖用口求他，他還是不回答。',
    '伯19:17 我口的氣味，我妻子厭惡；我的懇求，我同胞也憎嫌。',
    '伯19:18 連小孩子也藐視我；我若起來，他們都嘲笑我。',
    '伯19:19 我的密友都憎惡我；我平日所愛的人向我翻臉。',
    '伯19:20 我的皮肉緊貼骨頭；我只剩牙皮逃脫了。',
    '伯19:21 我朋友啊，可憐我！可憐我！因為神的手攻擊我。',
    '伯19:22 你們為什麼彷彿神逼迫我，吃我的肉還以為不足呢﹖',
    '伯19:23 惟願我的言語現在寫上，都記錄在書上；',
    '伯19:24 用鐵筆鐫刻，用鉛灌在磐石上，直存到永遠。',
    '伯19:25 我知道我的救贖主活著，末了必站立在地上。',
    '伯19:26 我這皮肉滅絕之後，我必在肉體之外得見神。',
    '伯19:27 我自己要見他，親眼要看他，並不像外人。我的心腸在我裡面消滅了！',
    '伯19:28 你們若說：我們逼迫他要何等地重呢﹖惹事的根乃在乎他；',
    '伯19:29 你們就當懼怕刀劍；因為忿怒惹動刀劍的刑罰，使你們知道有報應（原文是審判）。',
    '伯20:1 拿瑪人瑣法回答說：',
    '伯20:2 我心中急躁，所以我的思念叫我回答。',
    '伯20:3 我已聽見那羞辱我，責備我的話；我的悟性叫我回答。',
    '伯20:4 你豈不知亙古以來，自從人生在地，',
    '伯20:5 惡人誇勝是暫時的，不敬虔人的喜樂不過轉眼之間嗎﹖',
    '伯20:6 他的尊榮雖達到天上，頭雖頂到雲中，',
    '伯20:7 他終必滅亡，像自己的糞一樣；素來見他的人要說：他在哪裡呢﹖',
    '伯20:8 他必飛去如夢，不再尋見，速被趕去，如夜間的異象。',
    '伯20:9 親眼見過他的，必不再見他；他的本處也再見不著他。',
    '伯20:10 他的兒女要求窮人的恩；他的手要賠還不義之財。',
    '伯20:11 他的骨頭雖然有青年之力，卻要和他一同躺臥在塵土中。',
    '伯20:12 他口內雖以惡為甘甜，藏在舌頭底下，',
    '伯20:13 愛戀不捨，含在口中；',
    '伯20:14 他的食物在肚裡卻要化為酸，在他裡面成為虺蛇的惡毒。',
    '伯20:15 他吞了財寶，還要吐出；神要從他腹中掏出來。',
    '伯20:16 他必吸飲虺蛇的毒氣；蝮蛇的舌頭也必殺他。',
    '伯20:17 流奶與蜜之河，他不得再見。',
    '伯20:18 他勞碌得來的要賠還，不得享用（原文是吞下）；不能照所得的財貨歡樂。',
    '伯20:19 他欺壓窮人，且又離棄；強取非自己所蓋的房屋（或譯：強取房屋不得再建造）。',
    '伯20:20 他因貪而無厭，所喜悅的連一樣也不能保守。',
    '伯20:21 其餘的沒有一樣他不吞滅，所以他的福樂不能長久。',
    '伯20:22 他在滿足有餘的時候，必到狹窄的地步；凡受苦楚的人都必加手在他身上。',
    '伯20:23 他正要充滿肚腹的時候，神必將猛烈的忿怒降在他身上；正在他吃飯的時候，要將這忿怒像雨降在他身上。',
    '伯20:24 他要躲避鐵器；銅弓的箭要將他射透。',
    '伯20:25 他把箭一抽，就從他身上出來；發光的箭頭從他膽中出來，有驚惶臨在他身上。',
    '伯20:26 他的財寶歸於黑暗；人所不吹的火要把他燒滅，要把他帳棚中所剩下的燒毀。',
    '伯20:27 天要顯明他的罪孽；地要興起攻擊他。',
    '伯20:28 他的家產必然過去；神發怒的日子，他的貨物都要消滅。',
    '伯20:29 這是惡人從神所得的分，是神為他所定的產業。',
    '伯21:1 約伯回答說：',
    '伯21:2 你們要細聽我的言語，就算是你們安慰我。',
    '伯21:3 請寬容我，我又要說話；說了以後，任憑你們嗤笑吧！',
    '伯21:4 我豈是向人訴冤﹖為何不焦急呢﹖',
    '伯21:5 你們要看著我而驚奇，用手摀口。',
    '伯21:6 我每逢思想，心就驚惶，渾身戰兢。',
    '伯21:7 惡人為何存活，享大壽數，勢力強盛呢﹖',
    '伯21:8 他們眼見兒孫，和他們一同堅立。',
    '伯21:9 他們的家宅平安無懼；神的杖也不加在他們身上。',
    '伯21:10 他們的公牛孳生而不斷絕；母牛下犢而不掉胎。',
    '伯21:11 他們打發小孩子出去，多如羊群；他們的兒女踴躍跳舞。',
    '伯21:12 他們隨著琴鼓歌唱，又因簫聲歡喜。',
    '伯21:13 他們度日諸事亨通，轉眼下入陰間。',
    '伯21:14 他們對神說：離開我們吧！我們不願曉得你的道。',
    '伯21:15 全能者是誰，我們何必事奉他呢﹖求告他有什麼益處呢﹖',
    '伯21:16 看哪，他們亨通不在乎自己；惡人所謀定的離我好遠。',
    '伯21:17 惡人的燈何嘗熄滅﹖患難何嘗臨到他們呢﹖神何嘗發怒，向他們分散災禍呢﹖',
    '伯21:18 他們何嘗像風前的碎稭，如暴風颳去的糠粃呢﹖',
    '伯21:19 你們說：神為惡人的兒女積蓄罪孽；我說：不如本人受報，好使他親自知道。',
    '伯21:20 願他親眼看見自己敗亡，親自飲全能者的忿怒。',
    '伯21:21 他的歲月既盡，他還顧他本家嗎﹖',
    '伯21:22 神既審判那在高位的，誰能將知識教訓他呢﹖',
    '伯21:23 有人至死身體強壯，盡得平靖安逸；',
    '伯21:24 他的奶桶充滿，他的骨髓滋潤。',
    '伯21:25 有人至死心中痛苦，終身未嘗福樂的滋味；',
    '伯21:26 他們一樣躺臥在塵土中，都被蟲子遮蓋。',
    '伯21:27 我知道你們的意思，並誣害我的計謀。',
    '伯21:28 你們說：霸者的房屋在哪裡﹖惡人住過的帳棚在哪裡﹖',
    '伯21:29 你們豈沒有詢問過路的人嗎﹖不知道他們所引的證據嗎﹖',
    '伯21:30 就是惡人在禍患的日子得存留，在發怒的日子得逃脫。',
    '伯21:31 他所行的，有誰當面給他說明？他所做的，有誰報應他呢﹖',
    '伯21:32 然而他要被擡到塋地；並有人看守墳墓。',
    '伯21:33 他要以谷中的土塊為甘甜；在他以先去的無數，在他以後去的更多。',
    '伯21:34 你們對答的話中既都錯謬，怎麼徒然安慰我呢﹖',
    '伯22:1 提幔人以利法回答說：',
    '伯22:2 人豈能使神有益呢﹖智慧人但能有益於己。',
    '伯22:3 你為人公義，豈叫全能者喜悅呢﹖你行為完全，豈能使他得利呢﹖',
    '伯22:4 豈是因你敬畏他就責備你、審判你嗎﹖',
    '伯22:5 你的罪惡豈不是大嗎﹖你的罪孽也沒有窮盡；',
    '伯22:6 因你無故強取弟兄的物為當頭，剝去貧寒人的衣服。',
    '伯22:7 困乏的人，你沒有給他水喝；飢餓的人，你沒有給他食物。',
    '伯22:8 有能力的人就得地土；尊貴的人也住在其中。',
    '伯22:9 你打發寡婦空手回去，折斷孤兒的膀臂。',
    '伯22:10 因此，有網羅環繞你，有恐懼忽然使你驚惶；',
    '伯22:11 或有黑暗蒙蔽你，並有洪水淹沒你。',
    '伯22:12 神豈不是在高天嗎﹖你看星宿何其高呢！',
    '伯22:13 你說：神知道什麼﹖他豈能看透幽暗施行審判呢﹖',
    '伯22:14 密雲將他遮蓋，使他不能看見；他周遊穹蒼。',
    '伯22:15 你要依從上古的道嗎﹖這道是惡人所行的。',
    '伯22:16 他們未到死期，忽然除滅；根基毀壞，好像被江河沖去。',
    '伯22:17 他們向神說：離開我們吧！又說：全能者能把我們怎麼樣呢﹖',
    '伯22:18 哪知神以美物充滿他們的房屋；但惡人所謀定的離我好遠。',
    '伯22:19 義人看見他們的結局就歡喜；無辜的人嗤笑他們，',
    '伯22:20 說：那起來攻擊我們的果然被剪除，其餘的都被火燒滅。',
    '伯22:21 你要認識神，就得平安；福氣也必臨到你。',
    '伯22:22 你當領受他口中的教訓，將他的言語存在心裡。',
    '伯22:23 你若歸向全能者，從你帳棚中遠除不義，就必得建立。',
    '伯22:24 要將你的珍寶丟在塵土裡，將俄斐的黃金丟在溪河石頭之間；',
    '伯22:25 全能者就必為你的珍寶，作你的寶銀。',
    '伯22:26 你就要以全能者為喜樂，向神仰起臉來。',
    '伯22:27 你要禱告他，他就聽你；你也要還你的願。',
    '伯22:28 你定意要做何事，必然給你成就；亮光也必照耀你的路。',
    '伯22:29 人使你降卑，你仍可說：必得高升；謙卑的人，神必然拯救。',
    '伯22:30 人非無辜，神且要搭救他；他因你手中清潔，必蒙拯救。',
    '伯23:1 約伯回答說：',
    '伯23:2 如今我的哀告還算為悖逆；我的責罰比我的唉哼還重。',
    '伯23:3 惟願我能知道在哪裡可以尋見神，能到他的臺前，',
    '伯23:4 我就在他面前將我的案件陳明，滿口辯白。',
    '伯23:5 我必知道他回答我的言語，明白他向我所說的話。',
    '伯23:6 他豈用大能與我爭辯嗎﹖必不這樣！他必理會我。',
    '伯23:7 在他那裡正直人可以與他辯論；這樣，我必永遠脫離那審判我的。',
    '伯23:8 只是，我往前行，他不在那裡，往後退，也不能見他。',
    '伯23:9 他在左邊行事，我卻不能看見，在右邊隱藏，我也不能見他。',
    '伯23:10 然而他知道我所行的路；他試煉我之後，我必如精金。',
    '伯23:11 我腳追隨他的步履；我謹守他的道，並不偏離。',
    '伯23:12 他嘴唇的命令，我未曾背棄；我看重他口中的言語，過於我需用的飲食。',
    '伯23:13 只是他心志已定，誰能使他轉意呢﹖他心裡所願的，就行出來。',
    '伯23:14 他向我所定的，就必做成；這類的事他還有許多。',
    '伯23:15 所以我在他面前驚惶；我思念這事便懼怕他。',
    '伯23:16 神使我喪膽；全能者使我驚惶。',
    '伯23:17 我的恐懼不是因為黑暗，也不是因為幽暗蒙蔽我的臉。',
    '伯24:1 全能者既定期罰惡，為何不使認識他的人看見那日子呢﹖',
    '伯24:2 有人挪移地界，搶奪群畜而牧養。',
    '伯24:3 他們拉去孤兒的驢，強取寡婦的牛為當頭。',
    '伯24:4 他們使窮人離開正道；世上的貧民盡都隱藏。',
    '伯24:5 這些貧窮人如同野驢出到曠野，殷勤尋找食物；他們靠著野地給兒女糊口，',
    '伯24:6 收割別人田間的禾稼，摘取惡人餘剩的葡萄，',
    '伯24:7 終夜赤身無衣，天氣寒冷毫無遮蓋，',
    '伯24:8 在山上被大雨淋濕，因沒有避身之處就挨近磐石。',
    '伯24:9 又有人從母懷中搶奪孤兒，強取窮人的衣服為當頭，',
    '伯24:10 使人赤身無衣，到處流行，且因飢餓扛擡禾捆，',
    '伯24:11 在那些人的圍牆內造油，醡酒，自己還口渴。',
    '伯24:12 在多民的城內有人唉哼，受傷的人哀號；神卻不理會那惡人的愚妄。',
    '伯24:13 又有人背棄光明，不認識光明的道，不住在光明的路上。',
    '伯24:14 殺人的黎明起來，殺害困苦窮乏人，夜間又作盜賊。',
    '伯24:15 姦夫等候黃昏，說：必無眼能見我，就把臉蒙蔽。',
    '伯24:16 盜賊黑夜挖窟窿；白日躲藏，並不認識光明。',
    '伯24:17 他們看早晨如幽暗，因為他們曉得幽暗的驚駭。',
    '伯24:18 這些惡人猶如浮萍快快飄去。他們所得的分在世上被咒詛；他們不得再走葡萄園的路。',
    '伯24:19 乾旱炎熱消沒雪水；陰間也如此消沒犯罪之輩。',
    '伯24:20 懷他的母（原文是胎）要忘記他；蟲子要吃他，覺得甘甜；他不再被人記念。不義的人必如樹折斷。',
    '伯24:21 他惡待（或譯：他吞滅）不懷孕不生養的婦人，不善待寡婦。',
    '伯24:22 然而神用能力保全有勢力的人；那性命難保的人仍然興起。',
    '伯24:23 神使他們安穩，他們就有所倚靠；神的眼目也看顧他們的道路。',
    '伯24:24 他們被高舉，不過片時就沒有了；他們降為卑，被除滅，與眾人一樣，又如穀穗被割。',
    '伯24:25 若不是這樣，誰能證實我是說謊的，將我的言語駁為虛空呢﹖',
    '伯25:1 書亞人比勒達回答說：',
    '伯25:2 神有治理之權，有威嚴可畏；他在高處施行和平。',
    '伯25:3 他的諸軍豈能數算﹖他的光亮一發，誰不蒙照呢﹖',
    '伯25:4 這樣在神面前，人怎能稱義﹖婦人所生的怎能潔淨﹖',
    '伯25:5 在神眼前，月亮也無光亮，星宿也不清潔。',
    '伯25:6 何況如蟲的人，如蛆的世人呢！',
    '伯26:1 約伯回答說：',
    '伯26:2 無能的人蒙你何等的幫助！膀臂無力的人蒙你何等的拯救！',
    '伯26:3 無智慧的人蒙你何等的指教！你向他多顯大知識！',
    '伯26:4 你向誰發出言語來﹖誰的靈從你而出﹖',
    '伯26:5 在大水和水族以下的陰魂戰兢。',
    '伯26:6 在神面前，陰間顯露；滅亡也不得遮掩。',
    '伯26:7 神將北極鋪在空中，將大地懸在虛空；',
    '伯26:8 將水包在密雲中，雲卻不破裂；',
    '伯26:9 遮蔽他的寶座，將雲鋪在其上；',
    '伯26:10 在水面的周圍劃出界限，直到光明黑暗的交界。',
    '伯26:11 天的柱子因他的斥責震動驚奇。',
    '伯26:12 他以能力攪動（或譯：平靜）大海；他藉知識打傷拉哈伯，',
    '伯26:13 藉他的靈使天有妝飾；他的手刺殺快蛇。',
    '伯26:14 看哪，這不過是神工作的些微；我們所聽於他的是何等細微的聲音！他大能的雷聲誰能明透呢﹖',
    '伯27:1 約伯接著說：',
    '伯27:2 神奪去我的理，全能者使我心中愁苦。我指著永生的神起誓：',
    '伯27:3 我的生命尚在我裡面；神所賜呼吸之氣仍在我的鼻孔內。',
    '伯27:4 我的嘴決不說非義之言；我的舌也不說詭詐之語。',
    '伯27:5 我斷不以你們為是；我至死必不以自己為不正！',
    '伯27:6 我持定我的義，必不放鬆；在世的日子，我心必不責備我。',
    '伯27:7 願我的仇敵如惡人一樣；願那起來攻擊我的，如不義之人一般。',
    '伯27:8 不敬虔的人雖然得利，神奪取其命的時候還有什麼指望呢﹖',
    '伯27:9 患難臨到他，神豈能聽他的呼求﹖',
    '伯27:10 他豈以全能者為樂，隨時求告神呢﹖',
    '伯27:11 神的作為，我要指教你們；全能者所行的，我也不隱瞞。',
    '伯27:12 你們自己也都見過，為何全然變為虛妄呢﹖',
    '伯27:13 神為惡人所定的分，強暴人從全能者所得的報（原文是產業）乃是這樣：',
    '伯27:14 倘或他的兒女增多，還是被刀所殺；他的子孫必不得飽食。',
    '伯27:15 他所遺留的人必死而埋葬；他的寡婦也不哀哭。',
    '伯27:16 他雖積蓄銀子如塵沙，預備衣服如泥土；',
    '伯27:17 他只管預備，義人卻要穿上；他的銀子，無辜的人要分取。',
    '伯27:18 他建造房屋如蟲做窩，又如守望者所搭的棚。',
    '伯27:19 他雖富足躺臥，卻不得收殮，轉眼之間就不在了。',
    '伯27:20 驚恐如波濤將他追上；暴風在夜間將他颳去。',
    '伯27:21 東風把他飄去，又颳他離開本處。',
    '伯27:22 神要向他射箭，並不留情；他恨不得逃脫神的手。',
    '伯27:23 人要向他拍掌，並要發叱聲，使他離開本處。',
    '伯28:1 銀子有礦；煉金有方。',
    '伯28:2 鐵從地裡挖出；銅從石中鎔化。',
    '伯28:3 人為黑暗定界限，查究幽暗陰翳的石頭，直到極處，',
    '伯28:4 在無人居住之處刨開礦穴，過路的人也想不到他們；又與人遠離，懸在空中搖來搖去。',
    '伯28:5 至於地，能出糧食，地內好像被火翻起來。',
    '伯28:6 地中的石頭有藍寶石，並有金沙。',
    '伯28:7 礦中的路鷙鳥不得知道；鷹眼也未見過。',
    '伯28:8 狂傲的野獸未曾行過；猛烈的獅子也未曾經過。',
    '伯28:9 人伸手鑿開堅石，傾倒山根，',
    '伯28:10 在磐石中鑿出水道，親眼看見各樣寶物。',
    '伯28:11 他封閉水不得滴流，使隱藏的物顯露出來。',
    '伯28:12 然而，智慧有何處可尋﹖聰明之處在哪裡呢﹖',
    '伯28:13 智慧的價值無人能知，在活人之地也無處可尋。',
    '伯28:14 深淵說：不在我內；滄海說：不在我中。',
    '伯28:15 智慧非用黃金可得，也不能平白銀為他的價值。',
    '伯28:16 俄斐金和貴重的紅瑪瑙，並藍寶石，不足與較量；',
    '伯28:17 黃金和玻璃不足與比較；精金的器皿不足與兌換。',
    '伯28:18 珊瑚、水晶都不足論；智慧的價值勝過珍珠（或譯：紅寶石）。',
    '伯28:19 古實的紅璧璽不足與比較；精金也不足與較量。',
    '伯28:20 智慧從何處來呢﹖聰明之處在哪裡呢﹖',
    '伯28:21 是向一切有生命的眼目隱藏，向空中的飛鳥掩蔽。',
    '伯28:22 滅沒和死亡說：我們風聞其名。',
    '伯28:23 神明白智慧的道路，曉得智慧的所在。',
    '伯28:24 因他鑒察直到地極，遍觀普天之下，',
    '伯28:25 要為風定輕重，又度量諸水；',
    '伯28:26 他為雨露定命令，為雷電定道路。',
    '伯28:27 那時他看見智慧，而且述說；他堅定，並且查究。',
    '伯28:28 他對人說：敬畏主就是智慧；遠離惡便是聰明。',
    '伯29:1 約伯又接著說：',
    '伯29:2 惟願我的景況如從前的月份，如神保守我的日子。',
    '伯29:3 那時他的燈照在我頭上；我藉他的光行過黑暗。',
    '伯29:4 我願如壯年的時候：那時我在帳棚中，神待我有密友之情；',
    '伯29:5 全能者仍與我同在；我的兒女都環繞我。',
    '伯29:6 奶多可洗我的腳；磐石為我出油成河。',
    '伯29:7 我出到城門，在街上設立座位；',
    '伯29:8 少年人見我而迴避，老年人也起身站立；',
    '伯29:9 王子都停止說話，用手摀口；',
    '伯29:10 首領靜默無聲，舌頭貼住上膛。',
    '伯29:11 耳朵聽我的，就稱我有福；眼睛看我的，便稱讚我；',
    '伯29:12 因我拯救哀求的困苦人和無人幫助的孤兒。',
    '伯29:13 將要滅亡的為我祝福；我也使寡婦心中歡樂。',
    '伯29:14 我以公義為衣服，以公平為外袍和冠冕。',
    '伯29:15 我為瞎子的眼，瘸子的腳。',
    '伯29:16 我為窮乏人的父；素不認識的人，我查明他的案件。',
    '伯29:17 我打破不義之人的牙床，從他牙齒中奪了所搶的。',
    '伯29:18 我便說：我必死在家中（原文是窩中），必增添我的日子，多如塵沙。',
    '伯29:19 我的根長到水邊；露水終夜霑在我的枝上。',
    '伯29:20 我的榮耀在身上增新；我的弓在手中日強。',
    '伯29:21 人聽見我而仰望，靜默等候我的指教。',
    '伯29:22 我說話之後，他們就不再說；我的言語像雨露滴在他們身上。',
    '伯29:23 他們仰望我如仰望雨，又張開口如切慕春雨。',
    '伯29:24 他們不敢自信，我就向他們含笑；他們不使我臉上的光改變。',
    '伯29:25 我為他們選擇道路，又坐首位；我如君王在軍隊中居住，又如弔喪的安慰傷心的人。',
    '伯30:1 但如今，比我年少的人戲笑我；其人之父我曾藐視，不肯安在看守我羊群的狗中。',
    '伯30:2 他們壯年的氣力既已衰敗，其手之力於我何益呢﹖',
    '伯30:3 他們因窮乏飢餓，身體枯瘦，在荒廢淒涼的幽暗中齦乾燥之地，',
    '伯30:4 在草叢之中採鹹草，羅騰（小樹名，松類）的根為他們的食物。',
    '伯30:5 他們從人中被趕出；人追喊他們如賊一般，',
    '伯30:6 以致他們住在荒谷之間，在地洞和巖穴中；',
    '伯30:7 在草叢中叫喚，在荊棘下聚集。',
    '伯30:8 這都是愚頑下賤人的兒女；他們被鞭打，趕出境外。',
    '伯30:9 現在這些人以我為歌曲，以我為笑談。',
    '伯30:10 他們厭惡我，躲在旁邊站著，不住地吐唾沫在我臉上。',
    '伯30:11 鬆開他們的繩索苦待我，在我面前脫去轡頭。',
    '伯30:12 這等下流人在我右邊起來，推開我的腳，築成戰路來攻擊我。',
    '伯30:13 這些無人幫助的，毀壞我的道，加增我的災。',
    '伯30:14 他們來如同闖進大破口，在毀壞之間滾在我身上。',
    '伯30:15 驚恐臨到我，驅逐我的尊榮如風；我的福祿如雲過去。',
    '伯30:16 現在我心極其悲傷；困苦的日子將我抓住。',
    '伯30:17 夜間，我裡面的骨頭刺我，疼痛不止，好像齦我。',
    '伯30:18 因神的大力，我的外衣污穢不堪，又如裡衣的領子將我纏住。',
    '伯30:19 神把我扔在淤泥中，我就像塵土和爐灰一般。',
    '伯30:20 主啊，我呼求你，你不應允我；我站起來，你就定睛看我。',
    '伯30:21 你向我變心，待我殘忍，又用大能追逼我，',
    '伯30:22 把我提在風中，使我駕風而行，又使我消滅在烈風中。',
    '伯30:23 我知道要使我臨到死地，到那為眾生所定的陰宅。',
    '伯30:24 然而，人仆倒豈不伸手﹖遇災難豈不求救呢﹖',
    '伯30:25 人遭難，我豈不為他哭泣呢﹖人窮乏，我豈不為他憂愁呢﹖',
    '伯30:26 我仰望得好處，災禍就到了；我等待光明，黑暗便來了。',
    '伯30:27 我心裡煩擾不安，困苦的日子臨到我身。',
    '伯30:28 我沒有日光就哀哭行去（或譯：我面發黑並非因日曬）；我在會中站著求救。',
    '伯30:29 我與野狗為弟兄，與鴕鳥為同伴。',
    '伯30:30 我的皮膚黑而脫落；我的骨頭因熱燒焦。',
    '伯30:31 所以，我的琴音變為悲音；我的簫聲變為哭聲。',
    '伯31:1 我與眼睛立約，怎能戀戀瞻望處女呢﹖',
    '伯31:2 從至上的神所得之分，從至高全能者所得之業是什麼呢﹖',
    '伯31:3 豈不是禍患臨到不義的，災害臨到作孽的呢﹖',
    '伯31:4 神豈不是察看我的道路，數點我的腳步呢﹖',
    '伯31:5 我若與虛謊同行，腳若追隨詭詐；',
    '伯31:6 （我若被公道的天平稱度，使神可以知道我的純正；）',
    '伯31:7 我的腳步若偏離正路，我的心若隨著我的眼目，若有玷污粘在我手上；',
    '伯31:8 就願我所種的有別人吃，我田所產的被拔出來。',
    '伯31:9 我若受迷惑，向婦人起淫念，在鄰舍的門外蹲伏，',
    '伯31:10 就願我的妻子給別人推磨，別人也與他同室。',
    '伯31:11 因為這是大罪，是審判官當罰的罪孽。',
    '伯31:12 這本是火焚燒，直到毀滅，必拔除我所有的家產。',
    '伯31:13 我的僕婢與我爭辯的時候，我若藐視不聽他們的情節；',
    '伯31:14 神興起，我怎樣行呢﹖他察問，我怎樣回答呢﹖',
    '伯31:15 造我在腹中的，不也是造他嗎﹖將他與我摶在腹中的豈不是一位嗎﹖',
    '伯31:16 我若不容貧寒人得其所願，或叫寡婦眼中失望，',
    '伯31:17 或獨自吃我一點食物，孤兒沒有與我同吃；',
    '伯31:18 （從幼年時孤兒與我同長，好像父子一樣；我從出母腹就扶助[原文是引領]寡婦。）',
    '伯31:19 我若見人因無衣死亡，或見窮乏人身無遮蓋；',
    '伯31:20 我若不使他因我羊的毛得暖，為我祝福；',
    '伯31:21 我若在城門口見有幫助我的，舉手攻擊孤兒；',
    '伯31:22 情願我的肩頭從缺盆骨脫落，我的膀臂從羊矢骨折斷。',
    '伯31:23 因神降的災禍使我恐懼；因他的威嚴，我不能妄為。',
    '伯31:24 我若以黃金為指望，對精金說：你是我的倚靠；',
    '伯31:25 我若因財物豐裕，因我手多得資財而歡喜；',
    '伯31:26 我若見太陽發光，明月行在空中，',
    '伯31:27 心就暗暗被引誘，口便親手；',
    '伯31:28 這也是審判官當罰的罪孽，又是我背棄在上的神。',
    '伯31:29 我若見恨我的遭報就歡喜，見他遭災便高興；',
    '伯31:30 （我沒有容口犯罪，咒詛他的生命；）',
    '伯31:31 若我帳棚的人未嘗說，誰不以主人的食物吃飽呢﹖',
    '伯31:32 （從來我沒有容客旅在街上住宿，卻開門迎接行路的人；）',
    '伯31:33 我若像亞當（或譯：別人）遮掩我的過犯，將罪孽藏在懷中；',
    '伯31:34 因懼怕大眾，又因宗族藐視我使我驚恐，以致閉口無言，杜門不出；',
    '伯31:35 惟願有一位肯聽我！（看哪，在這裡有我所劃的押，願全能者回答我！）',
    '伯31:36 願那敵我者所寫的狀詞在我這裡！我必帶在肩上，又綁在頭上為冠冕。',
    '伯31:37 我必向他述說我腳步的數目，必如君王進到他面前。',
    '伯31:38 我若奪取田地，這地向我喊冤，犁溝一同哭泣；',
    '伯31:39 我若吃地的出產不給價值，或叫原主喪命；',
    '伯31:40 願這地長蒺藜代替麥子，長惡草代替大麥。約伯的話說完了。',
    '伯32:1 於是這三個人，因約伯自以為義就不再回答他。',
    '伯32:2 那時有布西人蘭族巴拉迦的兒子以利戶向約伯發怒；因約伯自以為義，不以神為義。',
    '伯32:3 他又向約伯的三個朋友發怒；因為他們想不出回答的話來，仍以約伯為有罪。',
    '伯32:4 以利戶要與約伯說話，就等候他們，因為他們比自己年老。',
    '伯32:5 以利戶見這三個人口中無話回答，就怒氣發作。',
    '伯32:6 布西人巴拉迦的兒子以利戶回答說：我年輕，你們老邁；因此我退讓，不敢向你們陳說我的意見。',
    '伯32:7 我說，年老的當先說話；壽高的當以智慧教訓人。',
    '伯32:8 但在人裡面有靈；全能者的氣使人有聰明。',
    '伯32:9 尊貴的不都有智慧；壽高的不都能明白公平。',
    '伯32:10 因此我說：你們要聽我言；我也要陳說我的意見。',
    '伯32:11 你們查究所要說的話；那時我等候你們的話，側耳聽你們的辯論，',
    '伯32:12 留心聽你們；誰知你們中間無一人折服約伯，駁倒他的話。',
    '伯32:13 你們切不可說：我們尋得智慧；神能勝他，人卻不能。',
    '伯32:14 約伯沒有向我爭辯；我也不用你們的話回答他。',
    '伯32:15 他們驚奇不再回答，一言不發。',
    '伯32:16 我豈因他們不說話，站住不再回答，仍舊等候呢﹖',
    '伯32:17 我也要回答我的一分話，陳說我的意見。',
    '伯32:18 因為我的言語滿懷；我裡面的靈激動我。',
    '伯32:19 我的胸懷如盛酒之囊沒有出氣之縫，又如新皮袋快要破裂。',
    '伯32:20 我要說話，使我舒暢；我要開口回答。',
    '伯32:21 我必不看人的情面，也不奉承人。',
    '伯32:22 我不曉得奉承；若奉承，造我的主必快快除滅我。',
    '伯33:1 約伯啊，請聽我的話，留心聽我一切的言語。',
    '伯33:2 我現在開口，用舌發言。',
    '伯33:3 我的言語要發明心中所存的正直；我所知道的，我嘴唇要誠實地說出。',
    '伯33:4 神的靈造我；全能者的氣使我得生。',
    '伯33:5 你若回答我，就站起來，在我面前陳明。',
    '伯33:6 我在神面前與你一樣，也是用土造成。',
    '伯33:7 我不用威嚴驚嚇你，也不用勢力重壓你。',
    '伯33:8 你所說的，我聽見了，也聽見你的言語，說：',
    '伯33:9 我是清潔無過的，我是無辜的；在我裡面也沒有罪孽。',
    '伯33:10 神找機會攻擊我，以我為仇敵，',
    '伯33:11 把我的腳上了木狗，窺察我一切的道路。',
    '伯33:12 我要回答你說：你這話無理，因神比世人更大。',
    '伯33:13 你為何與他爭論呢﹖因他的事都不對人解說﹖',
    '伯33:14 神說一次、兩次，世人卻不理會。',
    '伯33:15 人躺在床上沉睡的時候，神就用夢和夜間的異象，',
    '伯33:16 開通他們的耳朵，將當受的教訓印在他們心上，',
    '伯33:17 好叫人不從自己的謀算，不行驕傲的事（原文是將驕傲向人隱藏），',
    '伯33:18 攔阻人不陷於坑裡，不死在刀下。',
    '伯33:19 人在床上被懲治，骨頭中不住地疼痛，',
    '伯33:20 以致他的口厭棄食物，心厭惡美味。',
    '伯33:21 他的肉消瘦，不得再見；先前不見的骨頭都凸出來。',
    '伯33:22 他的靈魂臨近深坑；他的生命近於滅命的。',
    '伯33:23 一千天使中，若有一個作傳話的與神同在，指示人所當行的事，',
    '伯33:24 神就給他開恩，說：救贖他免得下坑；我已經得了贖價。',
    '伯33:25 他的肉要比孩童的肉更嫩；他就返老還童。',
    '伯33:26 他禱告神，神就喜悅他，使他歡呼朝見神的面；神又看他為義。',
    '伯33:27 他在人前歌唱說：我犯了罪，顛倒是非，這竟於我無益。',
    '伯33:28 神救贖我的靈魂免入深坑；我的生命也必見光。',
    '伯33:29 神兩次、三次向人行這一切的事，',
    '伯33:30 為要從深坑救回人的靈魂，使他被光照耀，與活人一樣。',
    '伯33:31 約伯啊，你當側耳聽我的話，不要作聲，等我講說。',
    '伯33:32 你若有話說，就可以回答我；你只管說，因我願以你為是。',
    '伯33:33 若不然，你就聽我說；你不要作聲，我便將智慧教訓你。',
    '伯34:1 以利戶又說：',
    '伯34:2 你們智慧人要聽我的話；有知識的人要留心聽我說。',
    '伯34:3 因為耳朵試驗話語，好像上膛嘗食物。',
    '伯34:4 我們當選擇何為是，彼此知道何為善。',
    '伯34:5 約伯曾說：我是公義，神奪去我的理；',
    '伯34:6 我雖有理，還算為說謊言的；我雖無過，受的傷還不能醫治。',
    '伯34:7 誰像約伯，喝譏誚如同喝水呢﹖',
    '伯34:8 他與作孽的結伴，和惡人同行。',
    '伯34:9 他說：人以神為樂，總是無益。',
    '伯34:10 所以，你們明理的人要聽我的話。神斷不致行惡；全能者斷不致作孽。',
    '伯34:11 他必按人所做的報應人，使各人照所行的得報。',
    '伯34:12 神必不作惡；全能者也不偏離公平。',
    '伯34:13 誰派他治理地，安定全世界呢﹖',
    '伯34:14 他若專心為己，將靈和氣收歸自己，',
    '伯34:15 凡有血氣的就必一同死亡；世人必仍歸塵土。',
    '伯34:16 你若明理，就當聽我的話，留心聽我言語的聲音。',
    '伯34:17 難道恨惡公平的可以掌權嗎﹖那有公義的、有大能的，豈可定他有罪嗎﹖',
    '伯34:18 他對君王說：你是鄙陋的；對貴臣說：你是邪惡的。',
    '伯34:19 他待王子不徇情面，也不看重富足的過於貧窮的，因為都是他手所造。',
    '伯34:20 在轉眼之間，半夜之中，他們就死亡。百姓被震動而去世；有權力的被奪去非借人手。',
    '伯34:21 神注目觀看人的道路，看明人的腳步。',
    '伯34:22 沒有黑暗、陰翳能給作孽的藏身。',
    '伯34:23 神審判人，不必使人到他面前再三鑒察。',
    '伯34:24 他用難測之法打破有能力的人，設立別人代替他們。',
    '伯34:25 他原知道他們的行為，使他們在夜間傾倒滅亡。',
    '伯34:26 他在眾人眼前擊打他們，如同擊打惡人一樣。',
    '伯34:27 因為他們偏行不跟從他，也不留心他的道，',
    '伯34:28 甚至使貧窮人的哀聲達到他那裡；他也聽了困苦人的哀聲。',
    '伯34:29 他使人安靜，誰能擾亂（或譯：定罪）呢﹖他掩面，誰能見他呢﹖無論待一國或一人都是如此─',
    '伯34:30 使不虔敬的人不得作王，免得有人牢籠百姓。',
    '伯34:31 有誰對神說：我受了責罰，不再犯罪；',
    '伯34:32 我所看不明的，求你指教我；我若作了孽，必不再作﹖',
    '伯34:33 他施行報應，豈要隨你的心願、叫你推辭不受嗎﹖選定的是你，不是我。你所知道的只管說吧！',
    '伯34:34 明理的人和聽我話的智慧人必對我說：',
    '伯34:35 約伯說話沒有知識，言語中毫無智慧。',
    '伯34:36 願約伯被試驗到底，因他回答像惡人一樣。',
    '伯34:37 他在罪上又加悖逆；在我們中間拍手，用許多言語輕慢神。',
    '伯35:1 以利戶又說：',
    '伯35:2 你以為有理，或以為你的公義勝於神的公義，',
    '伯35:3 才說這於我有什麼益處﹖我不犯罪比犯罪有什麼好處呢﹖',
    '伯35:4 我要回答你和在你這裡的朋友。',
    '伯35:5 你要向天觀看，瞻望那高於你的穹蒼。',
    '伯35:6 你若犯罪，能使神受何害呢﹖你的過犯加增，能使神受何損呢﹖',
    '伯35:7 你若是公義，還能加增他什麼呢﹖他從你手裡還接受什麼呢﹖',
    '伯35:8 你的過惡或能害你這類的人；你的公義或能叫世人得益處。',
    '伯35:9 人因多受欺壓就哀求，因受能者的轄制（原文是膀臂）便求救，',
    '伯35:10 卻無人說：造我的神在哪裡﹖他使人夜間歌唱，',
    '伯35:11 教訓我們勝於地上的走獸，使我們有聰明勝於空中的飛鳥。',
    '伯35:12 他們在那裡，因惡人的驕傲呼求，卻無人答應。',
    '伯35:13 虛妄的呼求，神必不垂聽；全能者也必不眷顧。',
    '伯35:14 何況你說，你不得見他；你的案件在他面前，你等候他吧。',
    '伯35:15 但如今因他未曾發怒降罰，也不甚理會狂傲，',
    '伯35:16 所以約伯開口說虛妄的話，多發無知識的言語。',
    '伯36:1 以利戶又接著說：',
    '伯36:2 你再容我片時，我就指示你，因我還有話為神說。',
    '伯36:3 我要將所知道的從遠處引來，將公義歸給造我的主。',
    '伯36:4 我的言語真不虛謊；有知識全備的與你同在。',
    '伯36:5 神有大能，並不藐視人；他的智慧甚廣。',
    '伯36:6 他不保護惡人的性命，卻為困苦人伸冤。',
    '伯36:7 他時常看顧義人，使他們和君王同坐寶座，永遠要被高舉。',
    '伯36:8 他們若被鎖鍊捆住，被苦難的繩索纏住，',
    '伯36:9 他就把他們的作為和過犯指示他們，叫他們知道有驕傲的行動。',
    '伯36:10 他也開通他們的耳朵得受教訓，吩咐他們離開罪孽轉回。',
    '伯36:11 他們若聽從事奉他，就必度日亨通，歷年福樂；',
    '伯36:12 若不聽從，就要被刀殺滅，無知無識而死。',
    '伯36:13 那心中不敬虔的人積蓄怒氣；神捆綁他們，他們竟不求救；',
    '伯36:14 必在青年時死亡，與污穢人一樣喪命。',
    '伯36:15 神藉著困苦救拔困苦人，趁他們受欺壓開通他們的耳朵。',
    '伯36:16 神也必引你出離患難，進入寬闊不狹窄之地；擺在你席上的必滿有肥甘。',
    '伯36:17 但你滿口有惡人批評的言語；判斷和刑罰抓住你。',
    '伯36:18 不可容忿怒觸動你，使你不服責罰；也不可因贖價大就偏行。',
    '伯36:19 你的呼求（或譯：資財），或是你一切的勢力，果有靈驗，叫你不受患難嗎﹖',
    '伯36:20 不要切慕黑夜，就是眾民在本處被除滅的時候。',
    '伯36:21 你要謹慎，不可重看罪孽，因你選擇罪孽過於選擇苦難。',
    '伯36:22 神行事有高大的能力；教訓人的有誰像他呢﹖',
    '伯36:23 誰派定他的道路﹖誰能說：你所行的不義﹖',
    '伯36:24 你不可忘記稱讚他所行的為大，就是人所歌頌的。',
    '伯36:25 他所行的，萬人都看見；世人也從遠處觀看。',
    '伯36:26 神為大，我們不能全知；他的年數不能測度。',
    '伯36:27 他吸取水點，這水點從雲霧中就變成雨；',
    '伯36:28 雲彩將雨落下，沛然降與世人。',
    '伯36:29 誰能明白雲彩如何鋪張，和神行宮的雷聲呢﹖',
    '伯36:30 他將亮光普照在自己的四圍；他又遮覆海底。',
    '伯36:31 他用這些審判眾民，且賜豐富的糧食。',
    '伯36:32 他以電光遮手，命閃電擊中敵人（或譯：中了靶子）。',
    '伯36:33 所發的雷聲顯明他的作為，又向牲畜指明要起暴風。',
    '伯37:1 因此我心戰兢，從原處移動。',
    '伯37:2 聽啊，神轟轟的聲音是他口中所發的響聲。',
    '伯37:3 他發響聲震遍天下，發電光閃到地極。',
    '伯37:4 隨後人聽見有雷聲轟轟，大發威嚴，雷電接連不斷。',
    '伯37:5 神發出奇妙的雷聲；他行大事，我們不能測透。',
    '伯37:6 他對雪說：要降在地上；對大雨和暴雨也是這樣說。',
    '伯37:7 他封住各人的手，叫所造的萬人都曉得他的作為。',
    '伯37:8 百獸進入穴中，臥在洞內。',
    '伯37:9 暴風出於南宮；寒冷出於北方。',
    '伯37:10 神噓氣成冰；寬闊之水也都凝結。',
    '伯37:11 他使密雲盛滿水氣，布散電光之雲；',
    '伯37:12 這雲是藉他的指引游行旋轉，得以在全地面上行他一切所吩咐的，',
    '伯37:13 或為責罰，或為潤地，或為施行慈愛。',
    '伯37:14 約伯啊，你要留心聽，要站立思想神奇妙的作為。',
    '伯37:15 神如何吩咐這些，如何使雲中的電光照耀，你知道嗎﹖',
    '伯37:16 雲彩如何浮於空中，那知識全備者奇妙的作為，你知道嗎﹖',
    '伯37:17 南風使地寂靜，你的衣服就如火熱，你知道嗎﹖',
    '伯37:18 你豈能與神同鋪穹蒼嗎﹖這穹蒼堅硬，如同鑄成的鏡子。',
    '伯37:19 我們愚昧不能陳說；請你指教我們該對他說什麼話。',
    '伯37:20 人豈可說：我願與他說話﹖豈有人自願滅亡嗎﹖',
    '伯37:21 現在有雲遮蔽，人不得見穹蒼的光亮；但風吹過，天又發晴。',
    '伯37:22 金光出於北方，在神那裡有可怕的威嚴。',
    '伯37:23 論到全能者，我們不能測度；他大有能力，有公平和大義，必不苦待人。',
    '伯37:24 所以，人敬畏他；凡自以為心中有智慧的人，他都不顧念。',
    '伯38:1 那時，耶和華從旋風中回答約伯說：',
    '伯38:2 誰用無知的言語使我的旨意暗昧不明？',
    '伯38:3 你要如勇士束腰；我問你，你可以指示我。',
    '伯38:4 我立大地根基的時候，你在哪裡呢﹖你若有聰明，只管說吧！',
    '伯38:5 你若曉得就說，是誰定地的尺度﹖是誰把準繩拉在其上﹖',
    '伯38:6 地的根基安置在何處﹖地的角石是誰安放的﹖',
    '伯38:7 那時，晨星一同歌唱；神的眾子也都歡呼。',
    '伯38:8 海水衝出，如出胎胞，那時誰將他關閉呢﹖',
    '伯38:9 是我用雲彩當海的衣服，用幽暗當包裹他的布，',
    '伯38:10 為他定界限，又安門和閂，',
    '伯38:11 說：你只可到這裡，不可越過；你狂傲的浪要到此止住。',
    '伯38:12 你自生以來，曾命定晨光，使清晨的日光知道本位，',
    '伯38:13 叫這光普照地的四極，將惡人從其中驅逐出來嗎﹖',
    '伯38:14 因這光，地面改變如泥上印印，萬物出現如衣服一樣。',
    '伯38:15 亮光不照惡人；強橫的膀臂也必折斷。',
    '伯38:16 你曾進到海源，或在深淵的隱密處行走嗎﹖',
    '伯38:17 死亡的門曾向你顯露嗎﹖死蔭的門你曾見過嗎﹖',
    '伯38:18 地的廣大你能明透嗎﹖你若全知道，只管說吧！',
    '伯38:19 光明的居所從何而至﹖黑暗的本位在於何處﹖',
    '伯38:20 你能帶到本境，能看明其室之路嗎﹖',
    '伯38:21 你總知道，因為你早已生在世上，你日子的數目也多。',
    '伯38:22 你曾進入雪庫，或見過雹倉嗎﹖',
    '伯38:23 這雪雹乃是我為降災，並打仗和爭戰的日子所預備的。',
    '伯38:24 光亮從何路分開﹖東風從何路分散遍地﹖',
    '伯38:25 誰為雨水分道﹖誰為雷電開路﹖',
    '伯38:26 使雨降在無人之地、無人居住的曠野﹖',
    '伯38:27 使荒廢淒涼之地得以豐足，青草得以發生﹖',
    '伯38:28 雨有父嗎﹖露水珠是誰生的呢﹖',
    '伯38:29 冰出於誰的胎﹖天上的霜是誰生的呢﹖',
    '伯38:30 諸水堅硬（或譯：隱藏）如石頭；深淵之面凝結成冰。',
    '伯38:31 你能繫住昴星的結嗎﹖能解開參星的帶嗎﹖',
    '伯38:32 你能按時領出十二宮嗎﹖能引導北斗和隨他的眾星（星：原文是子）嗎﹖',
    '伯38:33 你知道天的定例嗎﹖能使地歸在天的權下嗎﹖',
    '伯38:34 你能向雲彩揚起聲來，使傾盆的雨遮蓋你嗎﹖',
    '伯38:35 你能發出閃電，叫他行去，使他對你說：我們在這裡﹖',
    '伯38:36 誰將智慧放在懷中﹖誰將聰明賜於心內﹖',
    '伯38:37 誰能用智慧數算雲彩呢﹖塵土聚集成團，土塊緊緊結連；那時，誰能傾倒天上的瓶呢﹖',
    '伯38:38 併於上節。',
    '伯38:39 母獅子在洞中蹲伏，少壯獅子在隱密處埋伏；你能為他們抓取食物，使他們飽足嗎﹖',
    '伯38:40 併於上節。',
    '伯38:41 烏鴉之雛因無食物飛來飛去，哀告神；那時，誰為他預備食物呢﹖',
    '伯39:1 山巖間的野山羊幾時生產，你知道嗎﹖母鹿下犢之期，你能察定嗎﹖',
    '伯39:2 他們懷胎的月數，你能數算嗎﹖他們幾時生產，你能曉得嗎﹖',
    '伯39:3 他們屈身，將子生下，就除掉疼痛。',
    '伯39:4 這子漸漸肥壯，在荒野長大，去而不回。',
    '伯39:5 誰放野驢出去自由﹖誰解開快驢的繩索﹖',
    '伯39:6 我使曠野作他的住處，使鹹地當他的居所。',
    '伯39:7 他嗤笑城內的喧嚷，不聽趕牲口的喝聲。',
    '伯39:8 遍山是他的草場；他尋找各樣青綠之物。',
    '伯39:9 野牛豈肯服事你﹖豈肯住在你的槽旁﹖',
    '伯39:10 你豈能用套繩將野牛籠在犁溝之間﹖他豈肯隨你耙山谷之地﹖',
    '伯39:11 豈可因他的力大就倚靠他﹖豈可把你的工交給他做嗎﹖',
    '伯39:12 豈可信靠他把你的糧食運到家，又收聚你禾場上的穀嗎﹖',
    '伯39:13 鴕鳥的翅膀歡然搧展，豈是顯慈愛的翎毛和羽毛嗎﹖',
    '伯39:14 因他把蛋留在地上，在塵土中使得溫暖；',
    '伯39:15 卻想不到被腳踹碎，或被野獸踐踏。',
    '伯39:16 他忍心待雛，似乎不是自己的；雖然徒受勞苦，也不為雛懼怕；',
    '伯39:17 因為神使他沒有智慧，也未將悟性賜給他。',
    '伯39:18 他幾時挺身展開翅膀，就嗤笑馬和騎馬的人。',
    '伯39:19 馬的大力是你所賜的嗎﹖他頸項上挓挱的騌是你給他披上的嗎﹖',
    '伯39:20 是你叫他跳躍像蝗蟲嗎﹖他噴氣之威使人驚惶。',
    '伯39:21 他在谷中刨地，自喜其力；他出去迎接佩帶兵器的人。',
    '伯39:22 他嗤笑可怕的事並不驚惶，也不因刀劍退回。',
    '伯39:23 箭袋和發亮的槍，並短槍在他身上錚錚有聲。',
    '伯39:24 他發猛烈的怒氣將地吞下；一聽角聲就不耐站立。',
    '伯39:25 角每發聲，他說呵哈；他從遠處聞著戰氣，又聽見軍長大發雷聲和兵丁吶喊。',
    '伯39:26 鷹雀飛翔，展開翅膀一直向南，豈是藉你的智慧嗎﹖',
    '伯39:27 大鷹上騰在高處搭窩，豈是聽你的吩咐嗎﹖',
    '伯39:28 他住在山巖，以山峰和堅固之所為家，',
    '伯39:29 從那裡窺看食物，眼睛遠遠觀望。',
    '伯39:30 他的雛也咂血；被殺的人在哪裡，他也在那裡。',
    '伯40:1 耶和華又對約伯說：',
    '伯40:2 強辯的豈可與全能者爭論嗎﹖與神辯駁的可以回答這些吧！',
    '伯40:3 於是，約伯回答耶和華說：',
    '伯40:4 我是卑賤的！我用什麼回答你呢﹖只好用手摀口。',
    '伯40:5 我說了一次，再不回答；說了兩次，就不再說。',
    '伯40:6 於是，耶和華從旋風中回答約伯說：',
    '伯40:7 你要如勇士束腰；我問你，你可以指示我。',
    '伯40:8 你豈可廢棄我所擬定的﹖豈可定我有罪，好顯自己為義嗎﹖',
    '伯40:9 你有神那樣的膀臂嗎﹖你能像他發雷聲嗎﹖',
    '伯40:10 你要以榮耀莊嚴為妝飾，以尊榮威嚴為衣服；',
    '伯40:11 要發出你滿溢的怒氣，見一切驕傲的人，使他降卑；',
    '伯40:12 見一切驕傲的人，將他制伏，把惡人踐踏在本處；',
    '伯40:13 將他們一同隱藏在塵土中，把他們的臉蒙蔽在隱密處；',
    '伯40:14 我就認你右手能以救自己。',
    '伯40:15 你且觀看河馬；我造你也造他。他吃草與牛一樣；',
    '伯40:16 他的氣力在腰間，能力在肚腹的筋上。',
    '伯40:17 他搖動尾巴如香柏樹；他大腿的筋互相聯絡。',
    '伯40:18 他的骨頭好像銅管；他的肢體彷彿鐵棍。',
    '伯40:19 他在神所造的物中為首；創造他的給他刀劍。',
    '伯40:20 諸山給他出食物，也是百獸遊玩之處。',
    '伯40:21 他伏在蓮葉之下，臥在蘆葦隱密處和水窪子裡。',
    '伯40:22 蓮葉的陰涼遮蔽他；溪旁的柳樹環繞他。',
    '伯40:23 河水泛濫，他不發戰；就是約但河的水漲到他口邊，也是安然。',
    '伯40:24 在他防備的時候，誰能捉拿他﹖誰能牢籠他穿他的鼻子呢﹖',
    '伯41:1 你能用魚鉤釣上鱷魚嗎﹖能用繩子壓下他的舌頭嗎﹖',
    '伯41:2 你能用繩索穿他的鼻子嗎﹖能用鉤穿他的腮骨嗎﹖',
    '伯41:3 他豈向你連連懇求，說柔和的話嗎﹖',
    '伯41:4 豈肯與你立約，使你拿他永遠作奴僕嗎﹖',
    '伯41:5 你豈可拿他當雀鳥玩耍嗎﹖豈可為你的幼女將他拴住嗎﹖',
    '伯41:6 搭夥的漁夫豈可拿他當貨物嗎﹖能把他分給商人嗎﹖',
    '伯41:7 你能用倒鉤槍扎滿他的皮，能用魚叉叉滿他的頭嗎﹖',
    '伯41:8 你按手在他身上，想與他爭戰，就不再這樣行吧！',
    '伯41:9 人指望捉拿他是徒然的；一見他，豈不喪膽嗎﹖',
    '伯41:10 沒有那麼兇猛的人敢惹他。這樣，誰能在我面前站立得住呢﹖',
    '伯41:11 誰先給我什麼，使我償還呢﹖天下萬物都是我的。',
    '伯41:12 論到鱷魚的肢體和其大力，並美好的骨骼，我不能緘默不言。',
    '伯41:13 誰能剝他的外衣﹖誰能進他上下牙骨之間呢﹖',
    '伯41:14 誰能開他的腮頰﹖他牙齒四圍是可畏的。',
    '伯41:15 他以堅固的鱗甲為可誇，緊緊合閉，封得嚴密。',
    '伯41:16 這鱗甲一一相連，甚至氣不得透入其間，',
    '伯41:17 都是互相聯絡、膠結，不能分離。',
    '伯41:18 他打噴嚏就發出光來；他眼睛好像早晨的光線（原文是眼皮）。',
    '伯41:19 從他口中發出燒著的火把，與飛迸的火星；',
    '伯41:20 從他鼻孔冒出煙來，如燒開的鍋和點著的蘆葦。',
    '伯41:21 他的氣點著煤炭，有火焰從他口中發出。',
    '伯41:22 他頸項中存著勁力；在他面前的都恐嚇蹦跳。',
    '伯41:23 他的肉塊互相聯絡，緊貼其身，不能搖動。',
    '伯41:24 他的心結實如石頭，如下磨石那樣結實。',
    '伯41:25 他一起來，勇士都驚恐，心裡慌亂，便都昏迷。',
    '伯41:26 人若用刀，用槍，用標槍，用尖槍扎他，都是無用。',
    '伯41:27 他以鐵為乾草，以銅為爛木。',
    '伯41:28 箭不能恐嚇他使他逃避；彈石在他看為碎稭。',
    '伯41:29 棍棒算為禾稭；他嗤笑短槍颼的響聲。',
    '伯41:30 他肚腹下如尖瓦片；他如釘耙經過淤泥。',
    '伯41:31 他使深淵開滾如鍋，使洋海如鍋中的膏油。',
    '伯41:32 他行的路隨後發光，令人想深淵如同白髮。',
    '伯41:33 在地上沒有像他造的那樣，無所懼怕。',
    '伯41:34 凡高大的，他無不藐視；他在驕傲的水族上作王。',
    '伯42:1 約伯回答耶和華說：',
    '伯42:2 我知道，你萬事都能做；你的旨意不能攔阻。',
    '伯42:3 誰用無知的言語使你的旨意隱藏呢﹖我所說的是我不明白的；這些事太奇妙，是我不知道的。',
    '伯42:4 求你聽我，我要說話；我問你，求你指示我。',
    '伯42:5 我從前風聞有你，現在親眼看見你。',
    '伯42:6 因此我厭惡自己（或譯：我的言語），在塵土和爐灰中懊悔。',
    '伯42:7 耶和華對約伯說話以後，就對提幔人以利法說：我的怒氣向你和你兩個朋友發作，因為你們議論我不如我的僕人約伯說的是。',
    '伯42:8 現在你們要取七隻公牛，七隻公羊，到我僕人約伯那裡去，為自己獻上燔祭，我的僕人約伯就為你們祈禱。我因悅納他，就不按你們的愚妄辦你們。你們議論我，不如我的僕人約伯說的是。',
    '伯42:9 於是提幔人以利法、書亞人比勒達、拿瑪人瑣法照著耶和華所吩咐的去行；耶和華就悅納約伯。',
    '伯42:10 約伯為他的朋友祈禱。耶和華就使約伯從苦境（原文是擄掠）轉回，並且耶和華賜給他的比他從前所有的加倍。',
    '伯42:11 約伯的弟兄、姊妹，和以先所認識的人都來見他，在他家裡一同吃飯；又論到耶和華所降與他的一切災禍，都為他悲傷安慰他。每人也送他一塊銀子和一個金環。',
    '伯42:12 這樣，耶和華後來賜福給約伯比先前更多。他有一萬四千羊，六千駱駝，一千對牛，一千母驢。',
    '伯42:13 他也有七個兒子，三個女兒。',
    '伯42:14 他給長女起名叫耶米瑪，次女叫基洗亞，三女叫基連哈樸。',
    '伯42:15 在那全地的婦女中找不著像約伯的女兒那樣美貌。他們的父親使他們在弟兄中得產業。',
    '伯42:16 此後，約伯又活了一百四十年，得見他的兒孫，直到四代。',
    '伯42:17 這樣，約伯年紀老邁，日子滿足而死。',
    '詩1:1 不從惡人的計謀，不站罪人的道路，不坐褻慢人的座位，',
    '詩1:2 惟喜愛耶和華的律法，晝夜思想，這人便為有福！',
    '詩1:3 他要像一棵樹栽在溪水旁，按時候結果子，葉子也不枯乾。凡他所做的盡都順利。',
    '詩1:4 惡人並不是這樣，乃像糠粃被風吹散。',
    '詩1:5 因此，當審判的時候惡人必站立不住；罪人在義人的會中也是如此。',
    '詩1:6 因為耶和華知道義人的道路；惡人的道路卻必滅亡。',
    '詩2:1 外邦為什麼爭鬧﹖萬民為什麼謀算虛妄的事﹖',
    '詩2:2 世上的君王一齊起來，臣宰一同商議，要敵擋耶和華並他的受膏者，',
    '詩2:3 說：我們要掙開他們的捆綁，脫去他們的繩索。',
    '詩2:4 那坐在天上的必發笑；主必嗤笑他們。',
    '詩2:5 那時，他要在怒中責備他們，在烈怒中驚嚇他們，',
    '詩2:6 說：我已經立我的君在錫安─我的聖山上了。',
    '詩2:7 受膏者說：我要傳聖旨。耶和華曾對我說：你是我的兒子，我今日生你。',
    '詩2:8 你求我，我就將列國賜你為基業，將地極賜你為田產。',
    '詩2:9 你必用鐵杖打破他們；你必將他們如同窰匠的瓦器摔碎。',
    '詩2:10 現在，你們君王應當省悟！你們世上的審判官該受管教！',
    '詩2:11 當存畏懼事奉耶和華，又當存戰兢而快樂。',
    '詩2:12 當以嘴親子，恐怕他發怒，你們便在道中滅亡，因為他的怒氣快要發作。凡投靠他的，都是有福的。',
    '詩3:1 （大衛逃避他兒子押沙龍的時候作的詩。）耶和華啊，我的敵人何其加增；有許多人起來攻擊我。',
    '詩3:2 有許多人議論我說：他得不著神的幫助。（細拉）',
    '詩3:3 但你─耶和華是我四圍的盾牌，是我的榮耀，又是叫我擡起頭來的。',
    '詩3:4 我用我的聲音求告耶和華，他就從他的聖山上應允我。（細拉）',
    '詩3:5 我躺下睡覺，我醒著，耶和華都保佑我。',
    '詩3:6 雖有成萬的百姓來周圍攻擊我，我也不怕。',
    '詩3:7 耶和華啊，求你起來！我的神啊，求你救我！因為你打了我一切仇敵的腮骨，敲碎了惡人的牙齒。',
    '詩3:8 救恩屬乎耶和華；願你賜福給你的百姓。（細拉）',
    '詩4:1 （大衛的詩，交與伶長。用絲弦的樂器。）顯我為義的神啊，我呼籲的時候，求你應允我！我在困苦中，你曾使我寬廣；現在求你憐恤我，聽我的禱告！',
    '詩4:2 你們這上流人哪，你們將我的尊榮變為羞辱要到幾時呢﹖你們喜愛虛妄，尋找虛假，要到幾時呢﹖（細拉）',
    '詩4:3 你們要知道，耶和華已經分別虔誠人歸他自己；我求告耶和華，他必聽我。',
    '詩4:4 你們應當畏懼，不可犯罪；在床上的時候，要心裡思想，並要肅靜。（細拉）',
    '詩4:5 當獻上公義的祭，又當倚靠耶和華。',
    '詩4:6 有許多人說：誰能指示我們什麼好處﹖耶和華啊，求你仰起臉來，光照我們。',
    '詩4:7 你使我心裡快樂，勝過那豐收五穀新酒的人。',
    '詩4:8 我必安然躺下睡覺，因為獨有你─耶和華使我安然居住。',
    '詩5:1 （大衛的詩，交與伶長。用吹的樂器。）耶和華啊，求你留心聽我的言語，顧念我的心思！',
    '詩5:2 我的王我的神啊，求你垂聽我呼求的聲音！因為我向你祈禱。',
    '詩5:3 耶和華啊，早晨你必聽我的聲音；早晨我必向你陳明我的心意，並要警醒！',
    '詩5:4 因為你不是喜悅惡事的神，惡人不能與你同居。',
    '詩5:5 狂傲人不能站在你眼前；凡作孽的，都是你所恨惡的。',
    '詩5:6 說謊言的，你必滅絕；好流人血弄詭詐的，都為耶和華所憎惡。',
    '詩5:7 至於我，我必憑你豐盛的慈愛進入你的居所；我必存敬畏你的心向你的聖殿下拜。',
    '詩5:8 耶和華啊，求你因我的仇敵，憑你的公義引領我，使你的道路在我面前正直。',
    '詩5:9 因為，他們的口中沒有誠實；他們的心裡滿有邪惡；他們的喉嚨是敞開的墳墓；他們用舌頭諂媚人。',
    '詩5:10 神啊，求你定他們的罪！願他們因自己的計謀跌倒；願你在他們許多的過犯中把他們逐出，因為他們背叛了你。',
    '詩5:11 凡投靠你的，願他們喜樂，時常歡呼，因為你護庇他們；又願那愛你名的人都靠你歡欣。',
    '詩5:12 因為你必賜福與義人；耶和華啊，你必用恩惠如同盾牌四面護衛他。',
    '詩6:1 （大衛的詩，交與伶長。用絲弦的樂器，調用第八。）耶和華啊，求你不要在怒中責備我，也不要在烈怒中懲罰我！',
    '詩6:2 耶和華啊，求你可憐我，因為我軟弱。耶和華啊，求你醫治我，因為我的骨頭發戰。',
    '詩6:3 我心也大大地驚惶。耶和華啊，你要到幾時才救我呢﹖',
    '詩6:4 耶和華啊，求你轉回搭救我！因你的慈愛拯救我。',
    '詩6:5 因為，在死地無人記念你，在陰間有誰稱謝你﹖',
    '詩6:6 我因唉哼而困乏；我每夜流淚，把床榻漂起，把褥子濕透。',
    '詩6:7 我因憂愁眼睛乾癟，又因我一切的敵人眼睛昏花。',
    '詩6:8 你們一切作孽的人，離開我吧！因為耶和華聽了我哀哭的聲音。',
    '詩6:9 耶和華聽了我的懇求；耶和華必收納我的禱告。',
    '詩6:10 我的一切仇敵都必羞愧，大大驚惶；他們必要退後，忽然羞愧。',
    '詩7:1 （大衛指著便雅憫人古實的話，向耶和華唱的流離歌。）耶和華─我的神啊，我投靠你！求你救我脫離一切追趕我的人，將我救拔出來！',
    '詩7:2 恐怕他們像獅子撕裂我，甚至撕碎，無人搭救。',
    '詩7:3 耶和華─我的神啊，我若行了這事，若有罪孽在我手裡，',
    '詩7:4 我若以惡報那與我交好的人─連那無故與我為敵的，我也救了他，',
    '詩7:5 就任憑仇敵追趕我，直到追上，將我的性命踏在地下，使我的榮耀歸於灰塵。（細拉）',
    '詩7:6 耶和華啊，求你在怒中起來，挺身而立，抵擋我敵人的暴怒！求你為我興起！你已經命定施行審判！',
    '詩7:7 願眾民的會環繞你！願你從其上歸於高位！',
    '詩7:8 耶和華向眾民施行審判；耶和華啊，求你按我的公義和我心中的純正判斷我。',
    '詩7:9 願惡人的惡斷絕！願你堅立義人！因為公義的神察驗人的心腸肺腑。',
    '詩7:10 神是我的盾牌；他拯救心裡正直的人。',
    '詩7:11 神是公義的審判者，又是天天向惡人發怒的神。',
    '詩7:12 若有人不回頭，他的刀必磨快，弓必上弦，預備妥當了。',
    '詩7:13 他也預備了殺人的器械；他所射的是火箭。',
    '詩7:14 試看惡人因奸惡而劬勞，所懷的是毒害，所生的是虛假。',
    '詩7:15 他掘了坑，又挖深了，竟掉在自己所挖的阱裡。',
    '詩7:16 他的毒害必臨到他自己的頭上；他的強暴必落到他自己的腦袋上。',
    '詩7:17 我要照著耶和華的公義稱謝他，歌頌耶和華至高者的名。',
    '詩8:1 （大衛的詩，交與伶長。用迦特樂器。）耶和華─我們的主啊，你的名在全地何其美！你將你的榮耀彰顯於天。',
    '詩8:2 你因敵人的緣故，從嬰孩和吃奶的口中，建立了能力，使仇敵和報仇的閉口無言。',
    '詩8:3 我觀看你指頭所造的天，並你所陳設的月亮星宿，',
    '詩8:4 便說：人算什麼，你竟顧念他﹖世人算什麼，你竟眷顧他﹖',
    '詩8:5 你叫他比天使（或譯：神）微小一點，並賜他榮耀尊貴為冠冕。',
    '詩8:6 你派他管理你手所造的，使萬物，就是一切的牛羊、田野的獸、空中的鳥、海裡的魚，凡經行海道的，都服在他的腳下。',
    '詩8:7 併於上節。',
    '詩8:8 併於上節。',
    '詩8:9 耶和華─我們的主啊，你的名在全地何其美！',
    '詩9:1 （大衛的詩，交與伶長。調用慕拉便。）我要一心稱謝耶和華；我要傳揚你一切奇妙的作為。',
    '詩9:2 我要因你歡喜快樂；至高者啊，我要歌頌你的名！',
    '詩9:3 我的仇敵轉身退去的時候，他們一見你的面就跌倒滅亡。',
    '詩9:4 因你已經為我伸冤，為我辨屈；你坐在寶座上，按公義審判。',
    '詩9:5 你曾斥責外邦，你曾滅絕惡人；你曾塗抹他們的名，直到永永遠遠。',
    '詩9:6 仇敵到了盡頭；他們被毀壞，直到永遠。你拆毀他們的城邑，連他們的名號都歸於無有。',
    '詩9:7 惟耶和華坐著為王，直到永遠；他已經為審判設擺他的寶座。',
    '詩9:8 他要按公義審判世界，按正直判斷萬民。',
    '詩9:9 耶和華又要給受欺壓的人作高臺，在患難的時候作高臺。',
    '詩9:10 耶和華啊，認識你名的人要倚靠你，因你沒有離棄尋求你的人。',
    '詩9:11 應當歌頌居錫安的耶和華，將他所行的傳揚在眾民中。',
    '詩9:12 因為那追討流人血之罪的─他記念受屈的人，不忘記困苦人的哀求。',
    '詩9:13 耶和華啊，你是從死門把我提拔起來的；求你憐恤我，看那恨我的人所加給我的苦難，',
    '詩9:14 好叫我述說你一切的美德；我必在錫安城（原文是女子）的門因你的救恩歡樂。',
    '詩9:15 外邦人陷在自己所掘的坑中；他們的腳在自己暗設的網羅裡纏住了。',
    '詩9:16 耶和華已將自己顯明了，他已施行審判；惡人被自己手所做的纏住了（或譯：他叫惡人被自己手所做的累住了）。（細拉）',
    '詩9:17 惡人，就是忘記神的外邦人，都必歸到陰間。',
    '詩9:18 窮乏人必不永久被忘；困苦人的指望必不永遠落空。',
    '詩9:19 耶和華啊，求你起來，不容人得勝！願外邦人在你面前受審判！',
    '詩9:20 耶和華啊，求你使外邦人恐懼；願他們知道自己不過是人。（細拉）',
    '詩10:1 耶和華啊，你為什麼站在遠處﹖在患難的時候為什麼隱藏﹖',
    '詩10:2 惡人在驕橫中把困苦人追得火急；願他們陷在自己所設的計謀裡。',
    '詩10:3 因為惡人以心願自誇；貪財的背棄耶和華，並且輕慢他（或譯：他祝福貪財的，卻輕慢耶和華）。',
    '詩10:4 惡人面帶驕傲，說：耶和華必不追究；他一切所想的都以為沒有神。',
    '詩10:5 凡他所做的，時常穩固；你的審判超過他的眼界。至於他一切的敵人，他都向他們噴氣。',
    '詩10:6 他心裡說：我必不動搖，世世代代不遭災難。',
    '詩10:7 他滿口是咒罵、詭詐、欺壓，舌底是毒害、奸惡。',
    '詩10:8 他在村莊埋伏等候；他在隱密處殺害無辜的人。他的眼睛窺探無倚無靠的人；',
    '詩10:9 他埋伏在暗地，如獅子蹲在洞中。他埋伏，要擄去困苦人；他拉網，就把困苦人擄去。',
    '詩10:10 他屈身蹲伏，無倚無靠的人就倒在他爪牙（爪牙：或譯強暴人）之下。',
    '詩10:11 他心裡說：神竟忘記了；他掩面永不觀看。',
    '詩10:12 耶和華啊，求你起來！神啊，求你舉手，不要忘記困苦人！',
    '詩10:13 惡人為何輕慢神，心裡說：你必不追究﹖',
    '詩10:14 其實你已經觀看；因為奸惡毒害，你都看見了，為要以手施行報應。無倚無靠的人把自己交託你；你向來是幫助孤兒的。',
    '詩10:15 願你打斷惡人的膀臂；至於壞人，願你追究他的惡，直到淨盡。',
    '詩10:16 耶和華永永遠遠為王；外邦人從他的地已經滅絕了。',
    '詩10:17 耶和華啊，謙卑人的心願，你早已知道（原文是聽見）。你必預備他們的心，也必側耳聽他們的祈求，',
    '詩10:18 為要給孤兒和受欺壓的人伸冤，使強橫的人不再威嚇他們。',
    '詩11:1 （大衛的詩，交與伶長。）我是投靠耶和華；你們怎麼對我說：你當像鳥飛往你的山去。',
    '詩11:2 看哪，惡人彎弓，把箭搭在弦上，要在暗中射那心裡正直的人。',
    '詩11:3 根基若毀壞，義人還能做什麼呢﹖',
    '詩11:4 耶和華在他的聖殿裡；耶和華的寶座在天上；他的慧眼察看世人。',
    '詩11:5 耶和華試驗義人；惟有惡人和喜愛強暴的人，他心裡恨惡。',
    '詩11:6 他要向惡人密布網羅；有烈火、硫磺、熱風，作他們杯中的分。',
    '詩11:7 因為耶和華是公義的，他喜愛公義；正直人必得見他的面。',
    '詩12:1 （大衛的詩，交與伶長。調用第八。）耶和華啊，求你幫助，因虔誠人斷絕了；世人中間的忠信人沒有了。',
    '詩12:2 人人向鄰舍說謊；他們說話，是嘴唇油滑，心口不一。',
    '詩12:3 凡油滑的嘴唇和誇大的舌頭，耶和華必要剪除。',
    '詩12:4 他們曾說：我們必能以舌頭得勝；我們的嘴唇是我們自己的，誰能作我們的主呢﹖',
    '詩12:5 耶和華說：因為困苦人的冤屈和貧窮人的歎息，我現在要起來，把他安置在他所切慕的穩妥之地。',
    '詩12:6 耶和華的言語是純淨的言語，如同銀子在泥爐中煉過七次。',
    '詩12:7 耶和華啊，你必保護他們；你必保佑他們永遠脫離這世代的人。',
    '詩12:8 下流人在世人中升高，就有惡人到處遊行。',
    '詩13:1 （大衛的詩，交與伶長。）耶和華啊，你忘記我要到幾時呢﹖要到永遠嗎﹖你掩面不顧我要到幾時呢﹖',
    '詩13:2 我心裡籌算，終日愁苦，要到幾時呢﹖我的仇敵升高壓制我，要到幾時呢﹖',
    '詩13:3 耶和華─我的神啊，求你看顧我，應允我！使我眼目光明，免得我沉睡至死；',
    '詩13:4 免得我的仇敵說：我勝了他；免得我的敵人在我搖動的時候喜樂。',
    '詩13:5 但我倚靠你的慈愛；我的心因你的救恩快樂。',
    '詩13:6 我要向耶和華歌唱，因他用厚恩待我。',
    '詩14:1 （大衛的詩，交與伶長。）愚頑人心裡說：沒有神。他們都是邪惡，行了可憎惡的事；沒有一個人行善。',
    '詩14:2 耶和華從天上垂看世人，要看有明白的沒有，有尋求神的沒有。',
    '詩14:3 他們都偏離正路，一同變為污穢；並沒有行善的，連一個也沒有。',
    '詩14:4 作孽的都沒有知識嗎﹖他們吞吃我的百姓，如同吃飯一樣，並不求告耶和華。',
    '詩14:5 他們在那裡大大地害怕，因為神在義人的族類中。',
    '詩14:6 你們叫困苦人的謀算變為羞辱；然而耶和華是他的避難所。',
    '詩14:7 但願以色列的救恩從錫安而出。耶和華救回他被擄的子民那時，雅各要快樂，以色列要歡喜。',
    '詩15:1 （大衛的詩。）耶和華啊，誰能寄居你的帳幕﹖誰能住在你的聖山﹖',
    '詩15:2 就是行為正直、做事公義、心裡說實話的人。',
    '詩15:3 他不以舌頭讒謗人，不惡待朋友，也不隨夥毀謗鄰里。',
    '詩15:4 他眼中藐視匪類，卻尊重那敬畏耶和華的人。他發了誓，雖然自己吃虧也不更改。',
    '詩15:5 他不放債取利，不受賄賂以害無辜。行這些事的人必永不動搖。',
    '詩16:1 （大衛的金詩。）神啊，求你保佑我，因為我投靠你。',
    '詩16:2 我的心哪，你曾對耶和華說：你是我的主；我的好處不在你以外。',
    '詩16:3 論到世上的聖民，他們又美又善，是我最喜悅的。',
    '詩16:4 以別神代替耶和華的（或譯：送禮物給別神的），他們的愁苦必加增；他們所澆奠的血我不獻上；我嘴唇也不提別神的名號。',
    '詩16:5 耶和華是我的產業，是我杯中的分；我所得的，你為我持守。',
    '詩16:6 用繩量給我的地界，坐落在佳美之處；我的產業實在美好。',
    '詩16:7 我必稱頌那指教我的耶和華；我的心腸在夜間也警戒我。',
    '詩16:8 我將耶和華常擺在我面前，因他在我右邊，我便不致搖動。',
    '詩16:9 因此，我的心歡喜，我的靈（原文是榮耀）快樂；我的肉身也要安然居住。',
    '詩16:10 因為你必不將我的靈魂撇在陰間，也不叫你的聖者見朽壞。',
    '詩16:11 你必將生命的道路指示我。在你面前有滿足的喜樂；在你右手中有永遠的福樂。',
    '詩17:1 （大衛的祈禱。）耶和華啊，求你聽聞公義，側耳聽我的呼籲！求你留心聽我這不出於詭詐嘴唇的祈禱！',
    '詩17:2 願我的判語從你面前發出；願你的眼睛觀看公正。',
    '詩17:3 你已經試驗我的心；你在夜間鑒察我；你熬煉我，卻找不著什麼；我立志叫我口中沒有過失。',
    '詩17:4 論到人的行為，我藉著你嘴唇的言語自己謹守，不行強暴人的道路。',
    '詩17:5 我的腳踏定了你的路徑；我的兩腳未曾滑跌。',
    '詩17:6 神啊，我曾求告你，因為你必應允我；求你向我側耳，聽我的言語。',
    '詩17:7 求你顯出你奇妙的慈愛來；你是那用右手拯救投靠你的脫離起來攻擊他們的人。',
    '詩17:8 求你保護我，如同保護眼中的瞳人；將我隱藏在你翅膀的蔭下，',
    '詩17:9 使我脫離那欺壓我的惡人，就是圍困我要害我命的仇敵。',
    '詩17:10 他們的心被脂油包裹；他們用口說驕傲的話。',
    '詩17:11 他們圍困了我們的腳步；他們瞪著眼，要把我們推倒在地。',
    '詩17:12 他像獅子急要抓食，又像少壯獅子蹲伏在暗處。',
    '詩17:13 耶和華啊，求你起來，前去迎敵，將他打倒！用你的刀救護我命脫離惡人。',
    '詩17:14 耶和華啊，求你用手救我脫離世人，脫離那只在今生有福分的世人！你把你的財寶充滿他們的肚腹；他們因有兒女就心滿意足，將其餘的財物留給他們的嬰孩。',
    '詩17:15 至於我，我必在義中見你的面；我醒了的時候，得見（或譯：看）你的形像就心滿意足了。',
    '詩18:1 （耶和華的僕人大衛的詩，交與伶長。當耶和華救他脫離一切仇敵和掃羅之手的日子，他向耶和華念這詩的話。說：）耶和華，我的力量啊，我愛你！',
    '詩18:2 耶和華是我的巖石，我的山寨，我的救主，我的神，我的磐石，我所投靠的。他是我的盾牌，是拯救我的角，是我的高臺。',
    '詩18:3 我要求告當讚美的耶和華；這樣我必從仇敵手中被救出來。',
    '詩18:4 曾有死亡的繩索纏繞我，匪類的急流使我驚懼，',
    '詩18:5 陰間的繩索纏繞我，死亡的網羅臨到我。',
    '詩18:6 我在急難中求告耶和華，向我的神呼求。他從殿中聽了我的聲音；我在他面前的呼求入了他的耳中。',
    '詩18:7 那時，因他發怒，地就搖撼戰抖；山的根基也震動搖撼。',
    '詩18:8 從他鼻孔冒煙上騰；從他口中發火焚燒，連炭也著了。',
    '詩18:9 他又使天下垂，親自降臨，有黑雲在他腳下。',
    '詩18:10 他坐著基路伯飛行；他藉著風的翅膀快飛。',
    '詩18:11 他以黑暗為藏身之處，以水的黑暗、天空的厚雲為他四圍的行宮。',
    '詩18:12 因他面前的光輝，他的厚雲行過便有冰雹火炭。',
    '詩18:13 耶和華也在天上打雷；至高者發出聲音便有冰雹火炭。',
    '詩18:14 他射出箭來，使仇敵四散；多多發出閃電，使他們擾亂。',
    '詩18:15 耶和華啊，你的斥責一發，你鼻孔的氣一出，海底就出現，大地的根基也顯露。',
    '詩18:16 他從高天伸手抓住我，把我從大水中拉上來。',
    '詩18:17 他救我脫離我的勁敵和那些恨我的人，因為他們比我強盛。',
    '詩18:18 我遭遇災難的日子，他們來攻擊我；但耶和華是我的倚靠。',
    '詩18:19 他又領我到寬闊之處；他救拔我，因他喜悅我。',
    '詩18:20 耶和華按著我的公義報答我，按著我手中的清潔賞賜我。',
    '詩18:21 因為我遵守了耶和華的道，未曾作惡離開我的神。',
    '詩18:22 他的一切典章常在我面前；他的律例我也未曾丟棄。',
    '詩18:23 我在他面前作了完全人；我也保守自己遠離我的罪孽。',
    '詩18:24 所以，耶和華按我的公義，按我在他眼前手中的清潔償還我。',
    '詩18:25 慈愛的人，你以慈愛待他；完全的人，你以完全待他。',
    '詩18:26 清潔的人，你以清潔待他；乖僻的人，你以彎曲待他。',
    '詩18:27 困苦的百姓，你必拯救；高傲的眼目，你必使他降卑。',
    '詩18:28 你必點著我的燈；耶和華─我的神必照明我的黑暗。',
    '詩18:29 我藉著你衝入敵軍，藉著我的神跳過牆垣。',
    '詩18:30 至於神，他的道是完全的；耶和華的話是煉淨的。凡投靠他的，他便作他們的盾牌。',
    '詩18:31 除了耶和華，誰是神呢﹖除了我們的神，誰是磐石呢﹖',
    '詩18:32 惟有那以力量束我的腰、使我行為完全的，他是神。',
    '詩18:33 他使我的腳快如母鹿的蹄，又使我在高處安穩。',
    '詩18:34 他教導我的手能以爭戰，甚至我的膀臂能開銅弓。',
    '詩18:35 你把你的救恩給我作盾牌；你的右手扶持我；你的溫和使我為大。',
    '詩18:36 你使我腳下的地步寬闊；我的腳未曾滑跌。',
    '詩18:37 我要追趕我的仇敵，並要追上他們；不將他們滅絕，我總不歸回。',
    '詩18:38 我要打傷他們，使他們不能起來；他們必倒在我的腳下。',
    '詩18:39 因為你曾以力量束我的腰，使我能爭戰；你也使那起來攻擊我的都服在我以下。',
    '詩18:40 你又使我的仇敵在我面前轉背逃跑，叫我能以剪除那恨我的人。',
    '詩18:41 他們呼求，卻無人拯救；就是呼求耶和華，他也不應允。',
    '詩18:42 我搗碎他們，如同風前的灰塵，倒出他們，如同街上的泥土。',
    '詩18:43 你救我脫離百姓的爭競，立我作列國的元首；我素不認識的民必事奉我。',
    '詩18:44 他們一聽見我的名聲就必順從我；外邦人要投降我。',
    '詩18:45 外邦人要衰殘，戰戰兢兢地出他們的營寨。',
    '詩18:46 耶和華是活神。願我的磐石被人稱頌；願救我的神被人尊崇。',
    '詩18:47 這位神，就是那為我伸冤、使眾民服在我以下的。',
    '詩18:48 你救我脫離仇敵，又把我舉起，高過那些起來攻擊我的；你救我脫離強暴的人。',
    '詩18:49 耶和華啊，因此我要在外邦中稱謝你，歌頌你的名。',
    '詩18:50 耶和華賜極大的救恩給他所立的王，施慈愛給他的受膏者，就是給大衛和他的後裔，直到永遠。',
    '詩19:1 （大衛的詩，交與伶長。）諸天述說神的榮耀；穹蒼傳揚他的手段。',
    '詩19:2 這日到那日發出言語；這夜到那夜傳出知識。',
    '詩19:3 無言無語，也無聲音可聽。',
    '詩19:4 他的量帶通遍天下，他的言語傳到地極。神在其間為太陽安設帳幕；',
    '詩19:5 太陽如同新郎出洞房，又如勇士歡然奔路。',
    '詩19:6 他從天這邊出來，繞到天那邊，沒有一物被隱藏不得他的熱氣。',
    '詩19:7 耶和華的律法全備，能甦醒人心；耶和華的法度確定，能使愚人有智慧。',
    '詩19:8 耶和華的訓詞正直，能快活人的心；耶和華的命令清潔，能明亮人的眼目。',
    '詩19:9 耶和華的道理潔淨，存到永遠；耶和華的典章真實，全然公義─',
    '詩19:10 都比金子可羨慕，且比極多的精金可羨慕；比蜜甘甜，且比蜂房下滴的蜜甘甜。',
    '詩19:11 況且你的僕人因此受警戒，守著這些便有大賞。',
    '詩19:12 誰能知道自己的錯失呢﹖願你赦免我隱而未現的過錯。',
    '詩19:13 求你攔阻僕人不犯任意妄為的罪，不容這罪轄制我，我便完全，免犯大罪。',
    '詩19:14 耶和華─我的磐石，我的救贖主啊，願我口中的言語、心裡的意念在你面前蒙悅納。',
    '詩20:1 （大衛的詩，交與伶長。）願耶和華在你遭難的日子應允你；願名為雅各神的高舉你。',
    '詩20:2 願他從聖所救助你，從錫安堅固你，',
    '詩20:3 記念你的一切供獻，悅納你的燔祭，（細拉）',
    '詩20:4 將你心所願的賜給你，成就你的一切籌算。',
    '詩20:5 我們要因你的救恩誇勝，要奉我們神的名豎立旌旗。願耶和華成就你一切所求的！',
    '詩20:6 現在我知道耶和華救護他的受膏者，必從他的聖天上應允他，用右手的能力救護他。',
    '詩20:7 有人靠車，有人靠馬，但我們要提到耶和華─我們神的名。',
    '詩20:8 他們都屈身仆倒，我們卻起來，立得正直。',
    '詩20:9 求耶和華施行拯救；我們呼求的時候，願王應允我們！',
    '詩21:1 （大衛的詩，交與伶長。）耶和華啊，王必因你的能力歡喜；因你的救恩，他的快樂何其大！',
    '詩21:2 他心裡所願的，你已經賜給他；他嘴唇所求的，你未嘗不應允。（細拉）',
    '詩21:3 你以美福迎接他，把精金的冠冕戴在他頭上。',
    '詩21:4 他向你求壽，你便賜給他，就是日子長久，直到永遠。',
    '詩21:5 他因你的救恩大有榮耀；你又將尊榮威嚴加在他身上。',
    '詩21:6 你使他有洪福，直到永遠，又使他在你面前歡喜快樂。',
    '詩21:7 王倚靠耶和華，因至高者的慈愛必不搖動。',
    '詩21:8 你的手要搜出你的一切仇敵；你的右手要搜出那些恨你的人。',
    '詩21:9 你發怒的時候，要使他們如在炎熱的火爐中。耶和華要在他的震怒中吞滅他們；那火要把他們燒盡了。',
    '詩21:10 你必從世上滅絕他們的子孫（原文是果子），從人間滅絕他們的後裔。',
    '詩21:11 因為他們有意加害於你；他們想出計謀，卻不能做成。',
    '詩21:12 你必使他們轉背逃跑，向他們的臉搭箭在弦。',
    '詩21:13 耶和華啊，願你因自己的能力顯為至高！這樣，我們就唱詩，歌頌你的大能。',
    '詩22:1 （大衛的詩，交與伶長。調用朝鹿。）我的神，我的神！為什麼離棄我﹖為什麼遠離不救我﹖不聽我唉哼的言語﹖',
    '詩22:2 我的神啊，我白日呼求，你不應允，夜間呼求，並不住聲。',
    '詩22:3 但你是聖潔的，是用以色列的讚美為寶座（或譯：居所）的。',
    '詩22:4 我們的祖宗倚靠你；他們倚靠你，你便解救他們。',
    '詩22:5 他們哀求你，便蒙解救；他們倚靠你，就不羞愧。',
    '詩22:6 但我是蟲，不是人，被眾人羞辱，被百姓藐視。',
    '詩22:7 凡看見我的都嗤笑我；他們撇嘴搖頭，說：',
    '詩22:8 他把自己交託耶和華，耶和華可以救他吧！耶和華既喜悅他，可以搭救他吧！',
    '詩22:9 但你是叫我出母腹的；我在母懷裡，你就使我有倚靠的心。',
    '詩22:10 我自出母胎就被交在你手裡；從我母親生我，你就是我的神。',
    '詩22:11 求你不要遠離我！因為急難臨近了，沒有人幫助我。',
    '詩22:12 有許多公牛圍繞我，巴珊大力的公牛四面困住我。',
    '詩22:13 他們向我張口，好像抓撕吼叫的獅子。',
    '詩22:14 我如水被倒出來；我的骨頭都脫了節；我心在我裡面如蠟鎔化。',
    '詩22:15 我的精力枯乾，如同瓦片；我的舌頭貼在我牙床上。你將我安置在死地的塵土中。',
    '詩22:16 犬類圍著我，惡黨環繞我；他們扎了我的手，我的腳。',
    '詩22:17 我的骨頭，我都能數過；他們瞪著眼看我。',
    '詩22:18 他們分我的外衣，為我的裡衣拈鬮。',
    '詩22:19 耶和華啊，求你不要遠離我！我的救主啊，求你快來幫助我！',
    '詩22:20 求你救我的靈魂脫離刀劍，救我的生命（生命：原文是獨一者）脫離犬類，',
    '詩22:21 救我脫離獅子的口；你已經應允我，使我脫離野牛的角。',
    '詩22:22 我要將你的名傳與我的弟兄，在會中我要讚美你。',
    '詩22:23 你們敬畏耶和華的人要讚美他！雅各的後裔都要榮耀他！以色列的後裔都要懼怕他！',
    '詩22:24 因為他沒有藐視憎惡受苦的人，也沒有向他掩面；那受苦之人呼籲的時候，他就垂聽。',
    '詩22:25 我在大會中讚美你的話是從你而來的；我要在敬畏耶和華的人面前還我的願。',
    '詩22:26 謙卑的人必吃得飽足；尋求耶和華的人必讚美他。願你們的心永遠活著！',
    '詩22:27 地的四極都要想念耶和華，並且歸順他；列國的萬族都要在你面前敬拜。',
    '詩22:28 因為國權是耶和華的；他是管理萬國的。',
    '詩22:29 地上一切豐肥的人必吃喝而敬拜；凡下到塵土中─不能存活自己性命的人─都要在他面前下拜。',
    '詩22:30 他必有後裔事奉他；主所行的事必傳與後代。',
    '詩22:31 他們必來把他的公義傳給將要生的民，言明這事是他所行的。',
    '詩23:1 （大衛的詩。）耶和華是我的牧者，我必不致缺乏。',
    '詩23:2 他使我躺臥在青草地上，領我在可安歇的水邊。',
    '詩23:3 他使我的靈魂甦醒，為自己的名引導我走義路。',
    '詩23:4 我雖然行過死蔭的幽谷，也不怕遭害，因為你與我同在；你的杖，你的竿，都安慰我。',
    '詩23:5 在我敵人面前，你為我擺設筵席；你用油膏了我的頭，使我的福杯滿溢。',
    '詩23:6 我一生一世必有恩惠慈愛隨著我；我且要住在耶和華的殿中，直到永遠。',
    '詩24:1 （大衛的詩。）地和其中所充滿的，世界和住在其間的，都屬耶和華。',
    '詩24:2 他把地建立在海上，安定在大水之上。',
    '詩24:3 誰能登耶和華的山﹖誰能站在他的聖所﹖',
    '詩24:4 就是手潔心清、不向虛妄、起誓不懷詭詐的人。',
    '詩24:5 他必蒙耶和華賜福，又蒙救他的神使他成義。',
    '詩24:6 這是尋求耶和華的族類，是尋求你面的雅各。（細拉）',
    '詩24:7 眾城門哪，你們要擡起頭來！永久的門戶，你們要被舉起！那榮耀的王將要進來！',
    '詩24:8 榮耀的王是誰呢﹖就是有力有能的耶和華，在戰場上有能的耶和華！',
    '詩24:9 眾城門哪，你們要擡起頭來！永久的門戶，你們要把頭擡起！那榮耀的王將要進來！',
    '詩24:10 榮耀的王是誰呢﹖萬軍之耶和華，他是榮耀的王！（細拉）',
    '詩25:1 （大衛的詩。）耶和華啊，我的心仰望你。',
    '詩25:2 我的神啊，我素來倚靠你；求你不要叫我羞愧，不要叫我的仇敵向我誇勝。',
    '詩25:3 凡等候你的必不羞愧；惟有那無故行奸詐的必要羞愧。',
    '詩25:4 耶和華啊，求你將你的道指示我，將你的路教訓我！',
    '詩25:5 求你以你的真理引導我，教訓我，因為你是救我的神。我終日等候你。',
    '詩25:6 耶和華啊，求你記念你的憐憫和慈愛，因為這是亙古以來所常有的。',
    '詩25:7 求你不要記念我幼年的罪愆和我的過犯；耶和華啊，求你因你的恩惠，按你的慈愛記念我。',
    '詩25:8 耶和華是良善正直的，所以他必指示罪人走正路。',
    '詩25:9 他必按公平引領謙卑人，將他的道教訓他們。',
    '詩25:10 凡遵守他的約和他法度的人，耶和華都以慈愛誠實待他。',
    '詩25:11 耶和華啊，求你因你的名赦免我的罪，因為我的罪重大。',
    '詩25:12 誰敬畏耶和華，耶和華必指示他當選擇的道路。',
    '詩25:13 他必安然居住；他的後裔必承受地土。',
    '詩25:14 耶和華與敬畏他的人親密；他必將自己的約指示他們。',
    '詩25:15 我的眼目時常仰望耶和華，因為他必將我的腳從網裡拉出來。',
    '詩25:16 求你轉向我，憐恤我，因為我是孤獨困苦。',
    '詩25:17 我心裡的愁苦甚多，求你救我脫離我的禍患。',
    '詩25:18 求你看顧我的困苦，我的艱難，赦免我一切的罪。',
    '詩25:19 求你察看我的仇敵，因為他們人多，並且痛痛地恨我。',
    '詩25:20 求你保護我的性命，搭救我，使我不致羞愧，因為我投靠你。',
    '詩25:21 願純全、正直保守我，因為我等候你。',
    '詩25:22 神啊，求你救贖以色列脫離他一切的愁苦。',
    '詩26:1 （大衛的詩。）耶和華啊，求你為我伸冤，因我向來行事純全；我又倚靠耶和華，並不搖動。',
    '詩26:2 耶和華啊，求你察看我，試驗我，熬煉我的肺腑心腸。',
    '詩26:3 因為你的慈愛常在我眼前，我也按你的真理而行。',
    '詩26:4 我沒有和虛謊人同坐，也不與瞞哄人的同群。',
    '詩26:5 我恨惡惡人的會，必不與惡人同坐。',
    '詩26:6 耶和華啊，我要洗手表明無辜，才環繞你的祭壇；',
    '詩26:7 我好發稱謝的聲音，也要述說你一切奇妙的作為。',
    '詩26:8 耶和華啊，我喜愛你所住的殿和你顯榮耀的居所。',
    '詩26:9 不要把我的靈魂和罪人一同除掉；不要把我的性命和流人血的一同除掉。',
    '詩26:10 他們的手中有奸惡，右手滿有賄賂。',
    '詩26:11 至於我，卻要行事純全；求你救贖我，憐恤我！',
    '詩26:12 我的腳站在平坦地方；在眾會中我要稱頌耶和華！',
    '詩27:1 （大衛的詩。）耶和華是我的亮光，是我的拯救，我還怕誰呢﹖耶和華是我性命的保障（或譯：力量），我還懼誰呢﹖',
    '詩27:2 那作惡的就是我的仇敵，前來吃我肉的時候就絆跌仆倒。',
    '詩27:3 雖有軍兵安營攻擊我，我的心也不害怕；雖然興起刀兵攻擊我，我必仍舊安穩。',
    '詩27:4 有一件事，我曾求耶和華，我仍要尋求：就是一生一世住在耶和華的殿中，瞻仰他的榮美，在他的殿裡求問。',
    '詩27:5 因為我遭遇患難，他必暗暗地保守我；在他亭子裡，把我藏在他帳幕的隱密處，將我高舉在磐石上。',
    '詩27:6 現在我得以昂首，高過四面的仇敵。我要在他的帳幕裡歡然獻祭；我要唱詩歌頌耶和華。',
    '詩27:7 耶和華啊，我用聲音呼籲的時候，求你垂聽；並求你憐恤我，應允我。',
    '詩27:8 你說：你們當尋求我的面。那時我心向你說：耶和華啊，你的面我正要尋求。',
    '詩27:9 不要向我掩面。不要發怒趕逐僕人，你向來是幫助我的。救我的神啊，不要丟掉我，也不要離棄我。',
    '詩27:10 我父母離棄我，耶和華必收留我。',
    '詩27:11 耶和華啊，求你將你的道指教我，因我仇敵的緣故引導我走平坦的路。',
    '詩27:12 求你不要把我交給敵人，遂其所願；因為妄作見證的和口吐凶言的，起來攻擊我。',
    '詩27:13 我若不信在活人之地得見耶和華的恩惠，就早已喪膽了。',
    '詩27:14 要等候耶和華！當壯膽，堅固你的心！我再說，要等候耶和華！',
    '詩28:1 （大衛的詩。）耶和華啊，我要求告你！我的磐石啊，不要向我緘默！倘若你向我閉口，我就如將死的人一樣。',
    '詩28:2 我呼求你，向你至聖所舉手的時候，求你垂聽我懇求的聲音！',
    '詩28:3 不要把我和惡人並作孽的一同除掉；他們與鄰舍說和平話，心裡卻是奸惡。',
    '詩28:4 願你按著他們所做的，並他們所行的惡事待他們。願你照著他們手所做的待他們，將他們所應得的報應加給他們。',
    '詩28:5 他們既然不留心耶和華所行的和他手所做的，他就必毀壞他們，不建立他們。',
    '詩28:6 耶和華是應當稱頌的，因為他聽了我懇求的聲音。',
    '詩28:7 耶和華是我的力量，是我的盾牌；我心裡倚靠他就得幫助。所以我心中歡樂，我必用詩歌頌讚他。',
    '詩28:8 耶和華是他百姓的力量，又是他受膏者得救的保障。',
    '詩28:9 求你拯救你的百姓，賜福給你的產業，牧養他們，扶持他們，直到永遠。',
    '詩29:1 （大衛的詩。）神的眾子啊，你們要將榮耀、能力歸給耶和華，歸給耶和華！',
    '詩29:2 要將耶和華的名所當得的榮耀歸給他，以聖潔的（的：或譯為）妝飾敬拜耶和華。',
    '詩29:3 耶和華的聲音發在水上；榮耀的神打雷，耶和華打雷在大水之上。',
    '詩29:4 耶和華的聲音大有能力；耶和華的聲音滿有威嚴。',
    '詩29:5 耶和華的聲音震破香柏樹；耶和華震碎利巴嫩的香柏樹。',
    '詩29:6 他也使之跳躍如牛犢，使利巴嫩和西連跳躍如野牛犢。',
    '詩29:7 耶和華的聲音使火焰分岔。',
    '詩29:8 耶和華的聲音震動曠野；耶和華震動加低斯的曠野。',
    '詩29:9 耶和華的聲音驚動母鹿落胎，樹木也脫落淨光。凡在他殿中的，都稱說他的榮耀。',
    '詩29:10 洪水泛濫之時，耶和華坐著為王；耶和華坐著為王，直到永遠。',
    '詩29:11 耶和華必賜力量給他的百姓；耶和華必賜平安的福給他的百姓。',
    '詩30:1 （大衛在獻殿的時候，作這詩歌。）耶和華啊，我要尊崇你，因為你曾提拔我，不叫仇敵向我誇耀。',
    '詩30:2 耶和華─我的神啊，我曾呼求你，你醫治了我。',
    '詩30:3 耶和華啊，你曾把我的靈魂從陰間救上來，使我存活，不至於下坑。',
    '詩30:4 耶和華的聖民哪，你們要歌頌他，稱讚他可記念的聖名。',
    '詩30:5 因為，他的怒氣不過是轉眼之間；他的恩典乃是一生之久。一宿雖然有哭泣，早晨便必歡呼。',
    '詩30:6 至於我，我凡事平順便說：我永不動搖。',
    '詩30:7 耶和華啊，你曾施恩，叫我的江山穩固；你掩了面，我就驚惶。',
    '詩30:8 耶和華啊，我曾求告你；我向耶和華懇求，說：',
    '詩30:9 我被害流血，下到坑中，有什麼益處呢﹖塵土豈能稱讚你，傳說你的誠實嗎﹖',
    '詩30:10 耶和華啊，求你應允我，憐恤我！耶和華啊，求你幫助我！',
    '詩30:11 你已將我的哀哭變為跳舞，將我的麻衣脫去，給我披上喜樂，',
    '詩30:12 好叫我的靈（原文是榮耀）歌頌你，並不住聲。耶和華─我的神啊，我要稱謝你，直到永遠！',
    '詩31:1 （大衛的詩，交與伶長。）耶和華啊，我投靠你；求你使我永不羞愧；憑你的公義搭救我！',
    '詩31:2 求你側耳而聽，快快救我！作我堅固的磐石，拯救我的保障！',
    '詩31:3 因為你是我的巖石，我的山寨；所以，求你為你名的緣故引導我，指點我。',
    '詩31:4 求你救我脫離人為我暗設的網羅，因為你是我的保障。',
    '詩31:5 我將我的靈魂交在你手裡；耶和華誠實的神啊，你救贖了我。',
    '詩31:6 我恨惡那信奉虛無之神的人；我卻倚靠耶和華。',
    '詩31:7 我要為你的慈愛高興歡喜；因為你見過我的困苦，知道我心中的艱難。',
    '詩31:8 你未曾把我交在仇敵手裡；你使我的腳站在寬闊之處。',
    '詩31:9 耶和華啊，求你憐恤我，因為我在急難之中；我的眼睛因憂愁而乾癟，連我的身心也不安舒。',
    '詩31:10 我的生命為愁苦所消耗；我的年歲為歎息所曠廢。我的力量因我的罪孽衰敗；我的骨頭也枯乾。',
    '詩31:11 我因一切敵人成了羞辱，在我的鄰舍跟前更甚；那認識我的都懼怕我，在外頭看見我的都躲避我。',
    '詩31:12 我被人忘記，如同死人，無人記念；我好像破碎的器皿。',
    '詩31:13 我聽見了許多人的讒謗，四圍都是驚嚇；他們一同商議攻擊我的時候，就圖謀要害我的性命。',
    '詩31:14 耶和華啊，我仍舊倚靠你；我說：你是我的神。',
    '詩31:15 我終身的事在你手中；求你救我脫離仇敵的手和那些逼迫我的人。',
    '詩31:16 求你使你的臉光照僕人，憑你的慈愛拯救我。',
    '詩31:17 耶和華啊，求你叫我不致羞愧，因為我曾呼籲你；求你使惡人羞愧，使他們在陰間緘默無聲。',
    '詩31:18 那撒謊的人逞驕傲輕慢，出狂妄的話攻擊義人；願他的嘴啞而無言。',
    '詩31:19 敬畏你、投靠你的人，你為他們所積存的，在世人面前所施行的恩惠是何等大呢！',
    '詩31:20 你必把他們藏在你面前的隱密處，免得遇見人的計謀；你必暗暗地保守他們在亭子裡，免受口舌的爭鬧。',
    '詩31:21 耶和華是應當稱頌的，因為他在堅固城裡向我施展奇妙的慈愛。',
    '詩31:22 至於我，我曾急促地說：我從你眼前被隔絕。然而，我呼求你的時候，你仍聽我懇求的聲音。',
    '詩31:23 耶和華的聖民哪，你們都要愛他！耶和華保護誠實人，足足報應行事驕傲的人。',
    '詩31:24 凡仰望耶和華的人，你們都要壯膽，堅固你們的心！',
    '詩32:1 （大衛的訓誨詩。）得赦免其過、遮蓋其罪的，這人是有福的！',
    '詩32:2 凡心裡沒有詭詐、耶和華不算為有罪的，這人是有福的！',
    '詩32:3 我閉口不認罪的時候，因終日唉哼而骨頭枯乾。',
    '詩32:4 黑夜白日，你的手在我身上沉重；我的精液耗盡，如同夏天的乾旱。（細拉）',
    '詩32:5 我向你陳明我的罪，不隱瞞我的惡。我說：我要向耶和華承認我的過犯，你就赦免我的罪惡。（細拉）',
    '詩32:6 為此，凡虔誠人都當趁你可尋找的時候禱告你；大水泛溢的時候，必不能到他那裡。',
    '詩32:7 你是我藏身之處；你必保佑我脫離苦難，以得救的樂歌四面環繞我。（細拉）',
    '詩32:8 我要教導你，指示你當行的路；我要定睛在你身上勸戒你。',
    '詩32:9 你不可像那無知的騾馬，必用嚼環轡頭勒住他；不然，就不能馴服。',
    '詩32:10 惡人必多受苦楚；惟獨倚靠耶和華的必有慈愛四面環繞他。',
    '詩32:11 你們義人應當靠耶和華歡喜快樂；你們心裡正直的人都當歡呼。',
    '詩33:1 義人哪，你們應當靠耶和華歡樂；正直人的讚美是合宜的。',
    '詩33:2 你們應當彈琴稱謝耶和華，用十弦瑟歌頌他。',
    '詩33:3 應當向他唱新歌，彈得巧妙，聲音洪亮。',
    '詩33:4 因為耶和華的言語正直；凡他所做的盡都誠實。',
    '詩33:5 他喜愛仁義公平；遍地滿了耶和華的慈愛。',
    '詩33:6 諸天藉耶和華的命而造；萬象藉他口中的氣而成。',
    '詩33:7 他聚集海水如壘，收藏深洋在庫房。',
    '詩33:8 願全地都敬畏耶和華！願世上的居民都懼怕他！',
    '詩33:9 因為他說有，就有，命立，就立。',
    '詩33:10 耶和華使列國的籌算歸於無有，使眾民的思念無有功效。',
    '詩33:11 耶和華的籌算永遠立定；他心中的思念萬代常存。',
    '詩33:12 以耶和華為神的，那國是有福的！他所揀選為自己產業的，那民是有福的！',
    '詩33:13 耶和華從天上觀看；他看見一切的世人。',
    '詩33:14 從他的居所往外察看地上一切的居民─',
    '詩33:15 他是那造成他們眾人心的，留意他們一切作為的。',
    '詩33:16 君王不能因兵多得勝；勇士不能因力大得救。',
    '詩33:17 靠馬得救是枉然的；馬也不能因力大救人。',
    '詩33:18 耶和華的眼目看顧敬畏他的人和仰望他慈愛的人，',
    '詩33:19 要救他們的命脫離死亡，並使他們在饑荒中存活。',
    '詩33:20 我們的心向來等候耶和華；他是我們的幫助，我們的盾牌。',
    '詩33:21 我們的心必靠他歡喜，因為我們向來倚靠他的聖名。',
    '詩33:22 耶和華啊，求你照著我們所仰望你的，向我們施行慈愛！',
    '詩34:1 （大衛在亞比米勒面前裝瘋，被他趕出去，就作這詩。）我要時時稱頌耶和華；讚美他的話必常在我口中。',
    '詩34:2 我的心必因耶和華誇耀；謙卑人聽見就要喜樂。',
    '詩34:3 你們和我當稱耶和華為大，一同高舉他的名。',
    '詩34:4 我曾尋求耶和華，他就應允我，救我脫離了一切的恐懼。',
    '詩34:5 凡仰望他的，便有光榮；他們的臉必不蒙羞。',
    '詩34:6 我這困苦人呼求，耶和華便垂聽，救我脫離一切患難。',
    '詩34:7 耶和華的使者在敬畏他的人四圍安營，搭救他們。',
    '詩34:8 你們要嘗嘗主恩的滋味，便知道他是美善；投靠他的人有福了！',
    '詩34:9 耶和華的聖民哪，你們當敬畏他，因敬畏他的一無所缺。',
    '詩34:10 少壯獅子還缺食忍餓，但尋求耶和華的什麼好處都不缺。',
    '詩34:11 眾弟子啊，你們當來聽我的話！我要將敬畏耶和華的道教訓你們。',
    '詩34:12 有何人喜好存活，愛慕長壽，得享美福，',
    '詩34:13 就要禁止舌頭不出惡言，嘴唇不說詭詐的話。',
    '詩34:14 要離惡行善，尋求和睦，一心追趕。',
    '詩34:15 耶和華的眼目看顧義人；他的耳朵聽他們的呼求。',
    '詩34:16 耶和華向行惡的人變臉，要從世上除滅他們的名號。',
    '詩34:17 義人呼求，耶和華聽見了，便救他們脫離一切患難。',
    '詩34:18 耶和華靠近傷心的人，拯救靈性痛悔的人。',
    '詩34:19 義人多有苦難，但耶和華救他脫離這一切，',
    '詩34:20 又保全他一身的骨頭，連一根也不折斷。',
    '詩34:21 惡必害死惡人；恨惡義人的，必被定罪。',
    '詩34:22 耶和華救贖他僕人的靈魂；凡投靠他的，必不致定罪。',
    '詩35:1 （大衛的詩。）耶和華啊，與我相爭的，求你與他們相爭！與我相戰的，求你與他們相戰！',
    '詩35:2 拿著大小的盾牌，起來幫助我。',
    '詩35:3 抽出槍來，擋住那追趕我的；求你對我的靈魂說：我是拯救你的。',
    '詩35:4 願那尋索我命的，蒙羞受辱！願那謀害我的，退後羞愧！',
    '詩35:5 願他們像風前的糠，有耶和華的使者趕逐他們。',
    '詩35:6 願他們的道路又暗又滑，有耶和華的使者追趕他們。',
    '詩35:7 因他們無故地為我暗設網羅，無故地挖坑，要害我的性命。',
    '詩35:8 願災禍忽然臨到他身上！願他暗設的網纏住自己！願他落在其中遭災禍！',
    '詩35:9 我的心必靠耶和華快樂，靠他的救恩高興。',
    '詩35:10 我的骨頭都要說：耶和華啊，誰能像你救護困苦人脫離那比他強壯的，救護困苦窮乏人脫離那搶奪他的﹖',
    '詩35:11 凶惡的見證人起來，盤問我所不知道的事。',
    '詩35:12 他們向我以惡報善，使我的靈魂孤苦。',
    '詩35:13 至於我，當他們有病的時候，我便穿麻衣，禁食，刻苦己心；我所求的都歸到自己的懷中。',
    '詩35:14 我這樣行，好像他是我的朋友，我的弟兄；我屈身悲哀，如同人為母親哀痛。',
    '詩35:15 我在患難中，他們卻歡喜，大家聚集。我所不認識的那些下流人聚集攻擊我；他們不住地把我撕裂。',
    '詩35:16 他們如同席上好嬉笑的狂妄人向我咬牙。',
    '詩35:17 主啊，你看著不理要到幾時呢﹖求你救我的靈魂脫離他們的殘害！救我的生命（生命：原文是獨一者）脫離少壯獅子！',
    '詩35:18 我在大會中要稱謝你，在眾民中要讚美你。',
    '詩35:19 求你不容那無理與我為仇的向我誇耀！不容那無故恨我的向我擠眼！',
    '詩35:20 因為他們不說和平話，倒想出詭詐的言語害地上的安靜人。',
    '詩35:21 他們大大張口攻擊我，說：阿哈，阿哈，我們的眼已經看見了！',
    '詩35:22 耶和華啊，你已經看見了，求你不要閉口！主啊，求你不要遠離我！',
    '詩35:23 我的神我的主啊，求你奮興醒起，判清我的事，伸明我的冤！',
    '詩35:24 耶和華─我的神啊，求你按你的公義判斷我，不容他們向我誇耀！',
    '詩35:25 不容他們心裡說：阿哈，遂我們的心願了！不容他們說：我們已經把他吞了！',
    '詩35:26 願那喜歡我遭難的一同抱愧蒙羞！願那向我妄自尊大的披慚愧，蒙羞辱！',
    '詩35:27 願那喜悅我冤屈得伸的（冤屈得伸：原文是公義）歡呼快樂；願他們常說：當尊耶和華為大！耶和華喜悅他的僕人平安。',
    '詩35:28 我的舌頭要終日論說你的公義，時常讚美你。',
    '詩36:1 （耶和華的僕人大衛的詩，交與伶長。）惡人的罪過在他心裡說：我眼中不怕神！',
    '詩36:2 他自誇自媚，以為他的罪孽終不顯露，不被恨惡。',
    '詩36:3 他口中的言語盡是罪孽詭詐；他與智慧善行已經斷絕。',
    '詩36:4 他在床上圖謀罪孽，定意行不善的道，不憎惡惡事。',
    '詩36:5 耶和華啊，你的慈愛上及諸天；你的信實達到穹蒼。',
    '詩36:6 你的公義好像高山；你的判斷如同深淵。耶和華啊，人民、牲畜，你都救護。',
    '詩36:7 神啊，你的慈愛何其寶貴！世人投靠在你翅膀的蔭下。',
    '詩36:8 他們必因你殿裡的肥甘得以飽足；你也必叫他們喝你樂河的水。',
    '詩36:9 因為，在你那裡有生命的源頭；在你的光中，我們必得見光。',
    '詩36:10 願你常施慈愛給認識你的人，常以公義待心裡正直的人。',
    '詩36:11 不容驕傲人的腳踐踏我；不容凶惡人的手趕逐我。',
    '詩36:12 在那裡，作孽的人已經仆倒；他們被推倒，不能再起來。',
    '詩37:1 （大衛的詩。）不要為作惡的心懷不平，也不要向那行不義的生出嫉妒。',
    '詩37:2 因為他們如草快被割下，又如青菜快要枯乾。',
    '詩37:3 你當倚靠耶和華而行善，住在地上，以他的信實為糧；',
    '詩37:4 又要以耶和華為樂，他就將你心裡所求的賜給你。',
    '詩37:5 當將你的事交託耶和華，並倚靠他，他就必成全。',
    '詩37:6 他要使你的公義如光發出，使你的公平明如正午。',
    '詩37:7 你當默然倚靠耶和華，耐性等候他；不要因那道路通達的和那惡謀成就的心懷不平。',
    '詩37:8 當止住怒氣，離棄忿怒；不要心懷不平，以致作惡。',
    '詩37:9 因為作惡的必被剪除；惟有等候耶和華的必承受地土。',
    '詩37:10 還有片時，惡人要歸於無有；你就是細察他的住處也要歸於無有。',
    '詩37:11 但謙卑人必承受地土，以豐盛的平安為樂。',
    '詩37:12 惡人設謀害義人，又向他咬牙。',
    '詩37:13 主要笑他，因見他受罰的日子將要來到。',
    '詩37:14 惡人已經弓上弦，刀出鞘，要打倒困苦窮乏的人，要殺害行動正直的人。',
    '詩37:15 他們的刀必刺入自己的心；他們的弓必被折斷。',
    '詩37:16 一個義人所有的雖少，強過許多惡人的富餘。',
    '詩37:17 因為惡人的膀臂必被折斷；但耶和華是扶持義人。',
    '詩37:18 耶和華知道完全人的日子；他們的產業要存到永遠。',
    '詩37:19 他們在急難的時候不致羞愧，在饑荒的日子必得飽足。',
    '詩37:20 惡人卻要滅亡。耶和華的仇敵要像羊羔的脂油（或譯：像草地的華美）；他們要消滅，要如煙消滅。',
    '詩37:21 惡人借貸而不償還；義人卻恩待人，並且施捨。',
    '詩37:22 蒙耶和華賜福的必承受地土；被他咒詛的必被剪除。',
    '詩37:23 義人的腳步被耶和華立定；他的道路，耶和華也喜愛。',
    '詩37:24 他雖失腳也不致全身仆倒，因為耶和華用手攙扶他（或譯：攙扶他的手）。',
    '詩37:25 我從前年幼，現在年老，卻未見過義人被棄，也未見過他的後裔討飯。',
    '詩37:26 他終日恩待人，借給人；他的後裔也蒙福！',
    '詩37:27 你當離惡行善，就可永遠安居。',
    '詩37:28 因為，耶和華喜愛公平，不撇棄他的聖民；他們永蒙保佑，但惡人的後裔必被剪除。',
    '詩37:29 義人必承受地土，永居其上。',
    '詩37:30 義人的口談論智慧；他的舌頭講說公平。',
    '詩37:31 神的律法在他心裡；他的腳總不滑跌。',
    '詩37:32 惡人窺探義人，想要殺他。',
    '詩37:33 耶和華必不撇他在惡人手中；當審判的時候，也不定他的罪。',
    '詩37:34 你當等候耶和華，遵守他的道，他就擡舉你，使你承受地土；惡人被剪除的時候，你必看見。',
    '詩37:35 我見過惡人大有勢力，好像一根青翠樹在本土生發。',
    '詩37:36 有人從那裡經過，不料，他沒有了；我也尋找他，卻尋不著。',
    '詩37:37 你要細察那完全人，觀看那正直人，因為和平人有好結局。',
    '詩37:38 至於犯法的人，必一同滅絕；惡人終必剪除。',
    '詩37:39 但義人得救是由於耶和華；他在患難時作他們的營寨。',
    '詩37:40 耶和華幫助他們，解救他們；他解救他們脫離惡人，把他們救出來，因為他們投靠他。',
    '詩38:1 （大衛的記念詩。）耶和華啊，求你不要在怒中責備我，不要在烈怒中懲罰我！',
    '詩38:2 因為，你的箭射入我身；你的手壓住我。',
    '詩38:3 因你的惱怒，我的肉無一完全；因我的罪過，我的骨頭也不安寧。',
    '詩38:4 我的罪孽高過我的頭，如同重擔叫我擔當不起。',
    '詩38:5 因我的愚昧，我的傷發臭流膿。',
    '詩38:6 我疼痛，大大拳曲，終日哀痛。',
    '詩38:7 我滿腰是火；我的肉無一完全。',
    '詩38:8 我被壓傷，身體疲倦；因心裡不安，我就唉哼。',
    '詩38:9 主啊，我的心願都在你面前；我的歎息不向你隱瞞。',
    '詩38:10 我心跳動，我力衰微，連我眼中的光也沒有了。',
    '詩38:11 我的良朋密友因我的災病都躲在旁邊站著；我的親戚本家也遠遠地站立。',
    '詩38:12 那尋索我命的設下網羅；那想要害我的口出惡言，終日思想詭計。',
    '詩38:13 但我如聾子不聽，像啞巴不開口。',
    '詩38:14 我如不聽見的人，口中沒有回話。',
    '詩38:15 耶和華啊，我仰望你！主─我的神啊，你必應允我！',
    '詩38:16 我曾說：恐怕他們向我誇耀；我失腳的時候，他們向我誇大。',
    '詩38:17 我幾乎跌倒；我的痛苦常在我面前。',
    '詩38:18 我要承認我的罪孽；我要因我的罪憂愁。',
    '詩38:19 但我的仇敵又活潑又強壯，無理恨我的增多了。',
    '詩38:20 以惡報善的與我作對，因我是追求良善。',
    '詩38:21 耶和華啊，求你不要撇棄我！我的神啊，求你不要遠離我！',
    '詩38:22 拯救我的主啊，求你快快幫助我！',
    '詩39:1 （大衛的詩，交與伶長耶杜頓。）我曾說：我要謹慎我的言行，免得我舌頭犯罪；惡人在我面前的時候，我要用嚼環勒住我的口。',
    '詩39:2 我默然無聲，連好話也不出口；我的愁苦就發動了，',
    '詩39:3 我的心在我裡面發熱。我默想的時候，火就燒起，我便用舌頭說話。',
    '詩39:4 耶和華啊，求你叫我曉得我身之終！我的壽數幾何﹖叫我知道我的生命不長！',
    '詩39:5 你使我的年日窄如手掌；我一生的年數，在你面前如同無有。各人最穩妥的時候，真是全然虛幻。（細拉）',
    '詩39:6 世人行動實係幻影。他們忙亂，真是枉然；積蓄財寶，不知將來有誰收取。',
    '詩39:7 主啊，如今我等什麼呢﹖我的指望在乎你！',
    '詩39:8 求你救我脫離一切的過犯，不要使我受愚頑人的羞辱。',
    '詩39:9 因我所遭遇的是出於你，我就默然不語。',
    '詩39:10 求你把你的責罰從我身上免去；因你手的責打，我便消滅。',
    '詩39:11 你因人的罪惡懲罰他的時候，叫他的笑容（的笑容：或譯所喜愛的）消滅，如衣被蟲所咬。世人真是虛幻！（細拉）',
    '詩39:12 耶和華啊，求你聽我的禱告，留心聽我的呼求！我流淚，求你不要靜默無聲！因為我在你面前是客旅，是寄居的，像我列祖一般。',
    '詩39:13 求你寬容我，使我在去而不返之先可以力量復原。',
    '詩40:1 （大衛的詩，交與伶長。）我曾耐性等候耶和華；他垂聽我的呼求。',
    '詩40:2 他從禍坑裡，從淤泥中，把我拉上來，使我的腳立在磐石上，使我腳步穩當。',
    '詩40:3 他使我口唱新歌，就是讚美我們神的話。許多人必看見而懼怕，並要倚靠耶和華。',
    '詩40:4 那倚靠耶和華、不理會狂傲和偏向虛假之輩的，這人便為有福！',
    '詩40:5 耶和華─我的神啊，你所行的奇事，並你向我們所懷的意念甚多，不能向你陳明。若要陳明，其事不可勝數。',
    '詩40:6 祭物和禮物，你不喜悅；你已經開通我的耳朵。燔祭和贖罪祭非你所要。',
    '詩40:7 那時我說：看哪，我來了！我的事在經卷上已經記載了。',
    '詩40:8 我的神啊，我樂意照你的旨意行；你的律法在我心裡。',
    '詩40:9 我在大會中宣傳公義的佳音；我必不止住我的嘴唇。耶和華啊，這是你所知道的。',
    '詩40:10 我未曾把你的公義藏在心裡；我已陳明你的信實和你的救恩；我在大會中未曾隱瞞你的慈愛和誠實。',
    '詩40:11 耶和華啊，求你不要向我止住你的慈悲！願你的慈愛和誠實常常保佑我！',
    '詩40:12 因有無數的禍患圍困我，我的罪孽追上了我，使我不能昂首；這罪孽比我的頭髮還多，我就心寒膽戰。',
    '詩40:13 耶和華啊，求你開恩搭救我！耶和華啊，求你速速幫助我！',
    '詩40:14 願那些尋找我、要滅我命的，一同抱愧蒙羞！願那些喜悅我受害的，退後受辱！',
    '詩40:15 願那些對我說阿哈、阿哈的，因羞愧而敗亡！',
    '詩40:16 願一切尋求你的，因你高興歡喜！願那些喜愛你救恩的，常說：當尊耶和華為大！',
    '詩40:17 但我是困苦窮乏的，主仍顧念我；你是幫助我的，搭救我的。神啊，求你不要耽延！',
    '詩41:1 （大衛的詩，交與伶長。）眷顧貧窮的有福了！他遭難的日子，耶和華必搭救他。',
    '詩41:2 耶和華必保全他，使他存活；他必在地上享福。求你不要把他交給仇敵，遂其所願。',
    '詩41:3 他病重在榻，耶和華必扶持他；他在病中，你必給他鋪床。',
    '詩41:4 我曾說：耶和華啊，求你憐恤我，醫治我！因為我得罪了你。',
    '詩41:5 我的仇敵用惡言議論我說：他幾時死，他的名才滅亡呢﹖',
    '詩41:6 他來看我就說假話；他心存奸惡，走到外邊才說出來。',
    '詩41:7 一切恨我的，都交頭接耳地議論我；他們設計要害我。',
    '詩41:8 他們說：有怪病貼在他身上；他已躺臥，必不能再起來。',
    '詩41:9 連我知己的朋友，我所倚靠、吃過我飯的也用腳踢我。',
    '詩41:10 耶和華啊，求你憐恤我，使我起來，好報復他們！',
    '詩41:11 因我的仇敵不得向我誇勝，我從此便知道你喜愛我。',
    '詩41:12 你因我純正就扶持我，使我永遠站在你的面前。',
    '詩41:13 耶和華─以色列的神是應當稱頌的，從亙古直到永遠。阿們！阿們！',
    '詩42:1 （可拉後裔的訓誨詩，交與伶長。）神啊，我的心切慕你，如鹿切慕溪水。',
    '詩42:2 我的心渴想神，就是永生神；我幾時得朝見神呢﹖',
    '詩42:3 我晝夜以眼淚當飲食；人不住地對我說：你的神在哪裡呢﹖',
    '詩42:4 我從前與眾人同往，用歡呼稱讚的聲音領他們到神的殿裡，大家守節。我追想這些事，我的心極其悲傷。',
    '詩42:5 我的心哪，你為何憂悶﹖為何在我裡面煩躁﹖應當仰望神，因他笑臉幫助我；我還要稱讚他。',
    '詩42:6 我的神啊，我的心在我裡面憂悶，所以我從約但地，從黑門嶺，從米薩山記念你。',
    '詩42:7 你的瀑布發聲，深淵就與深淵響應；你的波浪洪濤漫過我身。',
    '詩42:8 白晝，耶和華必向我施慈愛；黑夜，我要歌頌禱告賜我生命的神。',
    '詩42:9 我要對神─我的磐石說：你為何忘記我呢﹖我為何因仇敵的欺壓時常哀痛呢﹖',
    '詩42:10 我的敵人辱罵我，好像打碎我的骨頭，不住地對我說：你的神在哪裡呢﹖',
    '詩42:11 我的心哪，你為何憂悶﹖為何在我裡面煩躁﹖應當仰望神，因我還要稱讚他。他是我臉上的光榮（原文是幫助），是我的神。',
    '詩43:1 神啊，求你伸我的冤，向不虔誠的國為我辨屈；求你救我脫離詭詐不義的人。',
    '詩43:2 因為你是賜我力量的神，為何丟棄我呢﹖我為何因仇敵的欺壓時常哀痛呢﹖',
    '詩43:3 求你發出你的亮光和真實，好引導我，帶我到你的聖山，到你的居所！',
    '詩43:4 我就走到神的祭壇，到我最喜樂的神那裡。神啊，我的神，我要彈琴稱讚你！',
    '詩43:5 我的心哪，你為何憂悶﹖為何在我裡面煩躁﹖應當仰望神，因我還要稱讚他。他是我臉上的光榮（原文是幫助），是我的神。',
    '詩44:1 （可拉後裔的訓誨詩，交與伶長。）神啊，你在古時，我們列祖的日子所行的事，我們親耳聽見了；我們的列祖也給我們述說過。',
    '詩44:2 你曾用手趕出外邦人，卻栽培了我們列祖；你苦待列邦，卻叫我們列祖發達。',
    '詩44:3 因為他們不是靠自己的刀劍得地土，也不是靠自己的膀臂得勝，乃是靠你的右手、你的膀臂，和你臉上的亮光，因為你喜悅他們。',
    '詩44:4 神啊，你是我的王；求你出令使雅各得勝。',
    '詩44:5 我們靠你要推倒我們的敵人，靠你的名要踐踏那起來攻擊我們的人。',
    '詩44:6 因為，我必不靠我的弓；我的刀也不能使我得勝。',
    '詩44:7 惟你救了我們脫離敵人，使恨我們的人羞愧。',
    '詩44:8 我們終日因神誇耀，還要永遠稱謝你的名。（細拉）',
    '詩44:9 但如今你丟棄了我們，使我們受辱，不和我們的軍兵同去。',
    '詩44:10 你使我們向敵人轉身退後；那恨我們的人任意搶奪。',
    '詩44:11 你使我們當作快要被吃的羊，把我們分散在列邦中。',
    '詩44:12 你賣了你的子民也不賺利，所得的價值並不加添你的資財。',
    '詩44:13 你使我們受鄰國的羞辱，被四圍的人嗤笑譏刺。',
    '詩44:14 你使我們在列邦中作了笑談，使眾民向我們搖頭。',
    '詩44:15 我的凌辱終日在我面前，我臉上的羞愧將我遮蔽，',
    '詩44:16 都因那辱罵毀謗人的聲音，又因仇敵和報仇人的緣故。',
    '詩44:17 這都臨到我們身上，我們卻沒有忘記你，也沒有違背你的約。',
    '詩44:18 我們的心沒有退後；我們的腳也沒有偏離你的路。',
    '詩44:19 你在野狗之處壓傷我們，用死蔭遮蔽我們。',
    '詩44:20 倘若我們忘了神的名，或向別神舉手，',
    '詩44:21 神豈不鑒察這事嗎﹖因為他曉得人心裡的隱祕。',
    '詩44:22 我們為你的緣故終日被殺；人看我們如將宰的羊。',
    '詩44:23 主啊，求你睡醒，為何儘睡呢﹖求你興起，不要永遠丟棄我們！',
    '詩44:24 你為何掩面，不顧我們所遭的苦難和所受的欺壓﹖',
    '詩44:25 我們的性命伏於塵土；我們的肚腹緊貼地面。',
    '詩44:26 求你起來幫助我們！憑你的慈愛救贖我們！',
    '詩45:1 （可拉後裔的訓誨詩，又是愛慕歌，交與伶長。調用百合花。）我心裡湧出美辭；我論到我為王做的事，我的舌頭是快手筆。',
    '詩45:2 你比世人更美；在你嘴裡滿有恩惠；所以神賜福給你，直到永遠。',
    '詩45:3 大能者啊，願你腰間佩刀，大有榮耀和威嚴！',
    '詩45:4 為真理、謙卑、公義赫然坐車前往，無不得勝；你的右手必顯明可畏的事。',
    '詩45:5 你的箭鋒快，射中王敵之心；萬民仆倒在你以下。',
    '詩45:6 神啊，你的寶座是永永遠遠的；你的國權是正直的。',
    '詩45:7 你喜愛公義，恨惡罪惡；所以神─就是你的神─用喜樂油膏你，勝過膏你的同伴。',
    '詩45:8 你的衣服都有沒藥、沉香、肉桂的香氣；象牙宮中有絲弦樂器的聲音使你歡喜。',
    '詩45:9 有君王的女兒在你尊貴婦女之中；王后佩戴俄斐金飾站在你右邊。',
    '詩45:10 女子啊，你要聽，要想，要側耳而聽！不要記念你的民和你的父家，',
    '詩45:11 王就羨慕你的美貌；因為他是你的主，你當敬拜他。',
    '詩45:12 推羅的民（原文是女子）必來送禮；民中的富足人也必向你求恩。',
    '詩45:13 王女在宮裡極其榮華；他的衣服是用金線繡的。',
    '詩45:14 他要穿錦繡的衣服，被引到王前；隨從他的陪伴童女也要被帶到你面前。',
    '詩45:15 他們要歡喜快樂被引導；他們要進入王宮。',
    '詩45:16 你的子孫要接續你的列祖；你要立他們在全地作王。',
    '詩45:17 我必叫你的名被萬代記念，所以萬民要永永遠遠稱謝你。',
    '詩46:1 （可拉後裔的詩歌，交與伶長。調用女音。）神是我們的避難所，是我們的力量，是我們在患難中隨時的幫助。',
    '詩46:2 所以，地雖改變，山雖搖動到海心，',
    '詩46:3 其中的水雖匉訇翻騰，山雖因海漲而戰抖，我們也不害怕。（細拉）',
    '詩46:4 有一道河，這河的分汊使神的城歡喜；這城就是至高者居住的聖所。',
    '詩46:5 神在其中，城必不動搖；到天一亮，神必幫助這城。',
    '詩46:6 外邦喧嚷，列國動搖；神發聲，地便鎔化。',
    '詩46:7 萬軍之耶和華與我們同在；雅各的神是我們的避難所！（細拉）',
    '詩46:8 你們來看耶和華的作為，看他使地怎樣荒涼。',
    '詩46:9 他止息刀兵，直到地極；他折弓、斷槍，把戰車焚燒在火中。',
    '詩46:10 你們要休息，要知道我是神！我必在外邦中被尊崇，在遍地上也被尊崇。',
    '詩46:11 萬軍之耶和華與我們同在；雅各的神是我們的避難所！',
    '詩47:1 （可拉後裔的詩，交與伶長。）萬民哪，你們都要拍掌！要用誇勝的聲音向神呼喊！',
    '詩47:2 因為耶和華至高者是可畏的；他是治理全地的大君王。',
    '詩47:3 他叫萬民服在我們以下，又叫列邦服在我們腳下。',
    '詩47:4 他為我們選擇產業，就是他所愛之雅各的榮耀。（細拉）',
    '詩47:5 神上升，有喊聲相送；耶和華上升，有角聲相送。',
    '詩47:6 你們要向神歌頌，歌頌！向我們王歌頌，歌頌！',
    '詩47:7 因為神是全地的王；你們要用悟性歌頌。',
    '詩47:8 神作王治理萬國；神坐在他的聖寶座上。',
    '詩47:9 列邦的君王聚集要作亞伯拉罕之神的民。因為世界的盾牌是屬神的；他為至高！',
    '詩48:1 （可拉後裔的詩歌。）耶和華本為大！在我們神的城中，在他的聖山上，該受大讚美。',
    '詩48:2 錫安山─大君王的城，在北面居高華美，為全地所喜悅。',
    '詩48:3 神在其宮中，自顯為避難所。',
    '詩48:4 看哪，眾王會合，一同經過。',
    '詩48:5 他們見了這城就驚奇喪膽，急忙逃跑。',
    '詩48:6 他們在那裡被戰兢疼痛抓住，好像產難的婦人一樣。',
    '詩48:7 神啊，你用東風打破他施的船隻。',
    '詩48:8 我們在萬軍之耶和華的城中─就是我們神的城中─所看見的，正如我們所聽見的。神必堅立這城，直到永遠。（細拉）',
    '詩48:9 神啊，我們在你的殿中想念你的慈愛。',
    '詩48:10 神啊，你受的讚美正與你的名相稱，直到地極！你的右手滿了公義。',
    '詩48:11 因你的判斷，錫安山應當歡喜，猶大的城邑（原文是女子）應當快樂。',
    '詩48:12 你們當周遊錫安，四圍旋繞，數點城樓，',
    '詩48:13 細看他的外郭，察看他的宮殿，為要傳說到後代。',
    '詩48:14 因為這神永永遠遠為我們的神；他必作我們引路的，直到死時。',
    '詩49:1 （可拉後裔的詩，交與伶長。）萬民哪，你們都當聽這話！世上一切的居民，',
    '詩49:2 無論上流下流，富足貧窮，都當留心聽！',
    '詩49:3 我口要說智慧的言語；我心要想通達的道理。',
    '詩49:4 我要側耳聽比喻，用琴解謎語。',
    '詩49:5 在患難的日子，奸惡隨我腳跟，四面環繞我，我何必懼怕﹖',
    '詩49:6 那些倚仗財貨自誇錢財多的人，',
    '詩49:7 一個也無法贖自己的弟兄，也不能替他將贖價給神，',
    '詩49:8 叫他長遠活著，不見朽壞；因為贖他生命的價值極貴，只可永遠罷休。',
    '詩49:9 併於上節。',
    '詩49:10 他必見智慧人死，又見愚頑人和畜類人一同滅亡，將他們的財貨留給別人。',
    '詩49:11 他們心裡思想：他們的家室必永存，住宅必留到萬代；他們以自己的名稱自己的地。',
    '詩49:12 但人居尊貴中不能長久，如同死亡的畜類一樣。',
    '詩49:13 他們行的這道本為自己的愚昧；但他們以後的人還佩服他們的話語。（細拉）',
    '詩49:14 他們如同羊群派定下陰間；死亡必作他們的牧者。到了早晨，正直人必管轄他們；他們的美容必被陰間所滅，以致無處可存。',
    '詩49:15 只是神必救贖我的靈魂脫離陰間的權柄，因他必收納我。（細拉）',
    '詩49:16 見人發財、家室增榮的時候，你不要懼怕；',
    '詩49:17 因為，他死的時候什麼也不能帶去；他的榮耀不能隨他下去。',
    '詩49:18 他活著的時候，雖然自誇為有福（你若利己，人必誇獎你）；',
    '詩49:19 他仍必歸到他歷代的祖宗那裡，永不見光。',
    '詩49:20 人在尊貴中而不醒悟，就如死亡的畜類一樣。',
    '詩50:1 （亞薩的詩。）大能者神─耶和華已經發言招呼天下，從日出之地到日落之處。',
    '詩50:2 從全美的錫安中，神已經發光了。',
    '詩50:3 我們的神要來，決不閉口。有烈火在他面前吞滅；有暴風在他四圍大颳。',
    '詩50:4 他招呼上天下地，為要審判他的民，',
    '詩50:5 說：招聚我的聖民到我這裡來，就是那些用祭物與我立約的人。',
    '詩50:6 諸天必表明他的公義，因為神是施行審判的。（細拉）',
    '詩50:7 我的民哪，你們當聽我的話！以色列啊，我要勸戒你；我是神，是你的神！',
    '詩50:8 我並不因你的祭物責備你；你的燔祭常在我面前。',
    '詩50:9 我不從你家中取公牛，也不從你圈內取山羊；',
    '詩50:10 因為，樹林中的百獸是我的，千山上的牲畜也是我的。',
    '詩50:11 山中的飛鳥，我都知道；野地的走獸也都屬我。',
    '詩50:12 我若是飢餓，我不用告訴你，因為世界和其中所充滿的都是我的。',
    '詩50:13 我豈吃公牛的肉呢﹖我豈喝山羊的血呢﹖',
    '詩50:14 你們要以感謝為祭獻與神，又要向至高者還你的願，',
    '詩50:15 並要在患難之日求告我；我必搭救你，你也要榮耀我。',
    '詩50:16 但神對惡人說：你怎敢傳說我的律例，口中提到我的約呢﹖',
    '詩50:17 其實你恨惡管教，將我的言語丟在背後。',
    '詩50:18 你見了盜賊就樂意與他同夥，又與行姦淫的人一同有分。',
    '詩50:19 你口任說惡言；你舌編造詭詐。',
    '詩50:20 你坐著毀謗你的兄弟，讒毀你親母的兒子。',
    '詩50:21 你行了這些事，我還閉口不言，你想我恰和你一樣；其實我要責備你，將這些事擺在你眼前。',
    '詩50:22 你們忘記神的，要思想這事，免得我把你們撕碎，無人搭救。',
    '詩50:23 凡以感謝獻上為祭的便是榮耀我；那按正路而行的，我必使他得著我的救恩。',
    '詩51:1 （大衛與拔示巴同室以後，先知拿單來見他；他作這詩，交與伶長。）神啊，求你按你的慈愛憐恤我！按你豐盛的慈悲塗抹我的過犯！',
    '詩51:2 求你將我的罪孽洗除淨盡，並潔除我的罪！',
    '詩51:3 因為，我知道我的過犯；我的罪常在我面前。',
    '詩51:4 我向你犯罪，惟獨得罪了你；在你眼前行了這惡，以致你責備我的時候顯為公義，判斷我的時候顯為清正。',
    '詩51:5 我是在罪孽裡生的，在我母親懷胎的時候就有了罪。',
    '詩51:6 你所喜愛的是內裡誠實；你在我隱密處，必使我得智慧。',
    '詩51:7 求你用牛膝草潔淨我，我就乾淨；求你洗滌我，我就比雪更白。',
    '詩51:8 求你使我得聽歡喜快樂的聲音，使你所壓傷的骨頭可以踴躍。',
    '詩51:9 求你掩面不看我的罪，塗抹我一切的罪孽。',
    '詩51:10 神啊，求你為我造清潔的心，使我裡面重新有正直（或譯：堅定）的靈。',
    '詩51:11 不要丟棄我，使我離開你的面；不要從我收回你的聖靈。',
    '詩51:12 求你使我仍得救恩之樂，賜我樂意的靈扶持我，',
    '詩51:13 我就把你的道指教有過犯的人，罪人必歸順你。',
    '詩51:14 神啊，你是拯救我的神；求你救我脫離流人血的罪！我的舌頭就高聲歌唱你的公義。',
    '詩51:15 主啊，求你使我嘴唇張開，我的口便傳揚讚美你的話！',
    '詩51:16 你本不喜愛祭物，若喜愛，我就獻上；燔祭，你也不喜悅。',
    '詩51:17 神所要的祭就是憂傷的靈；神啊，憂傷痛悔的心，你必不輕看。',
    '詩51:18 求你隨你的美意善待錫安，建造耶路撒冷的城牆。',
    '詩51:19 那時，你必喜愛公義的祭和燔祭並全牲的燔祭；那時，人必將公牛獻在你壇上。',
    '詩52:1 （以東人多益來告訴掃羅說：大衛到了亞希米勒家。那時，大衛作這訓誨詩，交與伶長。）勇士啊，你為何以作惡自誇﹖神的慈愛是常存的。',
    '詩52:2 你的舌頭邪惡詭詐，好像剃頭刀，快利傷人。',
    '詩52:3 你愛惡勝似愛善，又愛說謊，不愛說公義。（細拉）',
    '詩52:4 詭詐的舌頭啊，你愛說一切毀滅的話！',
    '詩52:5 神也要毀滅你，直到永遠；他要把你拿去，從你的帳棚中抽出，從活人之地將你拔出。（細拉）',
    '詩52:6 義人要看見而懼怕，並要笑他，',
    '詩52:7 說：看哪，這就是那不以神為他力量的人，只倚仗他豐富的財物，在邪惡上堅立自己。',
    '詩52:8 至於我，就像神殿中的青橄欖樹；我永永遠遠倚靠神的慈愛。',
    '詩52:9 我要稱謝你，直到永遠，因為你行了這事。我也要在你聖民面前仰望你的名；這名本為美好。',
    '詩53:1 （大衛的訓誨詩，交與伶長。調用麻哈拉。）愚頑人心裡說：沒有神。他們都是邪惡，行了可憎惡的罪孽；沒有一個人行善。',
    '詩53:2 神從天上垂看世人，要看有明白的沒有﹖有尋求他的沒有﹖',
    '詩53:3 他們各人都退後，一同變為污穢；並沒有行善的，連一個也沒有。',
    '詩53:4 作孽的沒有知識嗎﹖他們吞吃我的百姓如同吃飯一樣，並不求告神。',
    '詩53:5 他們在無可懼怕之處就大大害怕，因為神把那安營攻擊你之人的骨頭散開了。你使他們蒙羞，因為神棄絕了他們。',
    '詩53:6 但願以色列的救恩從錫安而出。神救回他被擄的子民那時，雅各要快樂，以色列要歡喜。',
    '詩54:1 （西弗人來對掃羅說：大衛豈不是在我們那裡藏身嗎﹖那時，大衛作這訓誨詩，交與伶長。用絲弦的樂器。）神啊，求你以你的名救我，憑你的大能為我伸冤。',
    '詩54:2 神啊，求你聽我的禱告，留心聽我口中的言語。',
    '詩54:3 因為，外人起來攻擊我，強暴人尋索我的命；他們眼中沒有神。（細拉）',
    '詩54:4 神是幫助我的，是扶持我命的。',
    '詩54:5 他要報應我仇敵所行的惡；求你憑你的誠實滅絕他們。',
    '詩54:6 我要把甘心祭獻給你。耶和華啊，我要稱讚你的名；這名本為美好。',
    '詩54:7 他從一切的急難中把我救出來；我的眼睛也看見了我仇敵遭報。',
    '詩55:1 （大衛的訓誨詩，交與伶長。用絲弦的樂器。）神啊，求你留心聽我的禱告，不要隱藏不聽我的懇求！',
    '詩55:2 求你側耳聽我，應允我。我哀歎不安，發聲唉哼，',
    '詩55:3 都因仇敵的聲音，惡人的欺壓；因為他們將罪孽加在我身上，發怒氣逼迫我。',
    '詩55:4 我心在我裡面甚是疼痛；死的驚惶臨到我身。',
    '詩55:5 恐懼戰兢歸到我身；驚恐漫過了我。',
    '詩55:6 我說：但願我有翅膀像鴿子，我就飛去，得享安息。',
    '詩55:7 我必遠遊，宿在曠野。（細拉）',
    '詩55:8 我必速速逃到避所，脫離狂風暴雨。',
    '詩55:9 主啊，求你吞滅他們，變亂他們的舌頭！因為我在城中見了強暴爭競的事。',
    '詩55:10 他們在城牆上晝夜繞行；在城內也有罪孽和奸惡。',
    '詩55:11 邪惡在其中；欺壓和詭詐不離街市。',
    '詩55:12 原來不是仇敵辱罵我，若是仇敵，還可忍耐；也不是恨我的人向我狂大，若是恨我的人就必躲避他。',
    '詩55:13 不料是你；你原與我平等，是我的同伴，是我知己的朋友！',
    '詩55:14 我們素常彼此談論，以為甘甜；我們與群眾在神的殿中同行。',
    '詩55:15 願死亡忽然臨到他們！願他們活活地下入陰間！因為他們的住處，他們的心中，都是邪惡。',
    '詩55:16 至於我，我要求告神；耶和華必拯救我。',
    '詩55:17 我要晚上、早晨、晌午哀聲悲歎；他也必聽我的聲音。',
    '詩55:18 他救贖我命脫離攻擊我的人，使我得享平安，因為與我相爭的人甚多。',
    '詩55:19 那沒有更變、不敬畏神的人，從太古常存的神必聽見而苦待他。',
    '詩55:20 他背了約，伸手攻擊與他和好的人。',
    '詩55:21 他的口如奶油光滑，他的心卻懷著爭戰；他的話比油柔和，其實是拔出來的刀。',
    '詩55:22 你要把你的重擔卸給耶和華，他必撫養你；他永不叫義人動搖。',
    '詩55:23 神啊，你必使惡人下入滅亡的坑；流人血、行詭詐的人必活不到半世，但我要倚靠你。',
    '詩56:1 （非利士人在迦特拿住大衛。那時，他作這金詩，交與伶長。調用遠方無聲鴿。）神啊，求你憐憫我，因為人要把我吞了，終日攻擊欺壓我。',
    '詩56:2 我的仇敵終日要把我吞了，因逞驕傲攻擊我的人甚多。',
    '詩56:3 我懼怕的時候要倚靠你。',
    '詩56:4 我倚靠神，我要讚美他的話；我倚靠神，必不懼怕。血氣之輩能把我怎麼樣呢﹖',
    '詩56:5 他們終日顛倒我的話；他們一切的心思都是要害我。',
    '詩56:6 他們聚集，埋伏窺探我的腳蹤，等候要害我的命。',
    '詩56:7 他們豈能因罪孽逃脫嗎﹖神啊，求你在怒中使眾民墮落！',
    '詩56:8 我幾次流離，你都記數；求你把我眼淚裝在你的皮袋裡。這不都記在你冊子上嗎﹖',
    '詩56:9 我呼求的日子，我的仇敵都要轉身退後。神幫助我，這是我所知道的。',
    '詩56:10 我倚靠神，我要讚美他的話；我倚靠耶和華，我要讚美他的話。',
    '詩56:11 我倚靠神，必不懼怕。人能把我怎麼樣呢﹖',
    '詩56:12 神啊，我向你所許的願在我身上；我要將感謝祭獻給你。',
    '詩56:13 因為你救我的命脫離死亡。你豈不是救護我的腳不跌倒、使我在生命光中行在神面前嗎﹖',
    '詩57:1 （大衛逃避掃羅，藏在洞裡。那時，他作這金詩，交與伶長。調用休要毀壞。）神啊，求你憐憫我，憐憫我！因為我的心投靠你。我要投靠在你翅膀的蔭下，等到災害過去。',
    '詩57:2 我要求告至高的神，就是為我成全諸事的神。',
    '詩57:3 那要吞我的人辱罵我的時候，神從天上必施恩救我，也必向我發出慈愛和誠實。',
    '詩57:4 我的性命在獅子中間；我躺臥在性如烈火的世人當中。他們的牙齒是槍、箭；他們的舌頭是快刀。',
    '詩57:5 神啊，願你崇高過於諸天！願你的榮耀高過全地！',
    '詩57:6 他們為我的腳設下網羅，壓制我的心；他們在我面前挖了坑，自己反掉在其中。（細拉）',
    '詩57:7 神啊，我心堅定，我心堅定；我要唱詩，我要歌頌！',
    '詩57:8 我的靈（原文是榮耀）啊，你當醒起！琴瑟啊，你們當醒起！我自己要極早醒起！',
    '詩57:9 主啊，我要在萬民中稱謝你，在列邦中歌頌你！',
    '詩57:10 因為，你的慈愛高及諸天；你的誠實達到穹蒼。',
    '詩57:11 神啊，願你崇高過於諸天！願你的榮耀高過全地！',
    '詩58:1 （大衛的金詩，交與伶長。調用休要毀壞。）世人哪，你們默然不語，真合公義嗎﹖施行審判，豈按正直嗎﹖',
    '詩58:2 不然！你們是心中作惡；你們在地上秤出你們手所行的強暴。',
    '詩58:3 惡人一出母胎就與神疏遠，一離母腹便走錯路，說謊話。',
    '詩58:4 他們的毒氣好像蛇的毒氣；他們好像塞耳的聾虺，',
    '詩58:5 不聽行法術的聲音，雖用極靈的咒語也是不聽。',
    '詩58:6 神啊，求你敲碎他們口中的牙！耶和華啊，求你敲掉少壯獅子的大牙！',
    '詩58:7 願他們消滅，如急流的水一般；他們瞅準射箭的時候，願箭頭彷彿砍斷。',
    '詩58:8 願他們像蝸牛消化過去，又像婦人墜落未見天日的胎。',
    '詩58:9 你們用荊棘燒火，鍋還未熱，他要用旋風把青的和燒著的一齊颳去。',
    '詩58:10 義人見仇敵遭報就歡喜，要在惡人的血中洗腳。',
    '詩58:11 因此，人必說：義人誠然有善報；在地上果有施行判斷的神！',
    '詩59:1 （掃羅打發人窺探大衛的房屋，要殺他。那時，大衛作這金詩，交與伶長。調用休要毀壞。）我的神啊，求你救我脫離仇敵，把我安置在高處，得脫那些起來攻擊我的人。',
    '詩59:2 求你救我脫離作孽的人和喜愛流人血的人！',
    '詩59:3 因為，他們埋伏要害我的命；有能力的人聚集來攻擊我。耶和華啊，這不是為我的過犯，也不是為我的罪愆。',
    '詩59:4 我雖然無過，他們預備整齊，跑來攻擊我。求你興起鑒察，幫助我！',
    '詩59:5 萬軍之神─耶和華以色列的神啊！求你興起，懲治萬邦！不要憐憫行詭詐的惡人！（細拉）',
    '詩59:6 他們晚上轉回，叫號如狗，圍城繞行。',
    '詩59:7 他們口中噴吐惡言，嘴裡有刀；他們說：有誰聽見﹖',
    '詩59:8 但你─耶和華必笑話他們；你要嗤笑萬邦。',
    '詩59:9 我的力量啊，我必仰望你，因為神是我的高臺。',
    '詩59:10 我的神要以慈愛迎接我；神要叫我看見我仇敵遭報。',
    '詩59:11 不要殺他們，恐怕我的民忘記。主啊，你是我們的盾牌；求你用你的能力使他們四散，且降為卑。',
    '詩59:12 因他們口中的罪和嘴裡的言語，並咒罵虛謊的話，願他們在驕傲之中被纏住了。',
    '詩59:13 求你發怒，使他們消滅，以致歸於無有，叫他們知道神在雅各中間掌權，直到地極。（細拉）',
    '詩59:14 到了晚上，任憑他們轉回；任憑他們叫號如狗，圍城繞行。',
    '詩59:15 他們必走來走去，尋找食物，若不得飽就終夜在外。',
    '詩59:16 但我要歌頌你的力量，早晨要高唱你的慈愛；因為你作過我的高臺，在我急難的日子作過我的避難所。',
    '詩59:17 我的力量啊，我要歌頌你；因為神是我的高臺，是賜恩與我的神。',
    '詩60:1 （大衛與兩河間的亞蘭並瑣巴的亞蘭爭戰的時候，約押轉回，在鹽谷攻擊以東，殺了一萬二千人。那時，大衛作這金詩叫人學習，交與伶長。調用為證的百合花。）神啊，你丟棄了我們，使我們破敗；你向我們發怒，求你使我們復興！',
    '詩60:2 你使地震動，而且崩裂；求你將裂口醫好，因為地搖動。',
    '詩60:3 你叫你的民遇見艱難；你叫我們喝那使人東倒西歪的酒。',
    '詩60:4 你把旌旗賜給敬畏你的人，可以為真理揚起來。（細拉）',
    '詩60:5 求你應允我們，用右手拯救我們，好叫你所親愛的人得救。',
    '詩60:6 神已經指著他的聖潔說（說：或譯應許我）：我要歡樂；我要分開示劍，丈量疏割谷。',
    '詩60:7 基列是我的，瑪拿西也是我的。以法蓮是護衛我頭的；猶大是我的杖。',
    '詩60:8 摩押是我的沐浴盆；我要向以東拋鞋。非利士啊，你還能因我歡呼嗎﹖',
    '詩60:9 誰能領我進堅固城﹖誰能引我到以東地﹖',
    '詩60:10 神啊，你不是丟棄了我們嗎﹖神啊，你不和我們的軍兵同去嗎﹖',
    '詩60:11 求你幫助我們攻擊敵人，因為人的幫助是枉然的。',
    '詩60:12 我們倚靠神才得施展大能，因為踐踏我們敵人的就是他。',
    '詩61:1 （大衛的詩，交與伶長。用絲弦的樂器。）神啊，求你聽我的呼求，側耳聽我的禱告！',
    '詩61:2 我心裡發昏的時候，我要從地極求告你。求你領我到那比我更高的磐石！',
    '詩61:3 因為你作過我的避難所，作過我的堅固臺，脫離仇敵。',
    '詩61:4 我要永遠住在你的帳幕裡！我要投靠在你翅膀下的隱密處！（細拉）',
    '詩61:5 神啊，你原是聽了我所許的願；你將產業賜給敬畏你名的人。',
    '詩61:6 你要加添王的壽數；他的年歲必存到世世。',
    '詩61:7 他必永遠坐在神面前；願你預備慈愛和誠實保佑他！',
    '詩61:8 這樣，我要歌頌你的名，直到永遠，好天天還我所許的願。',
    '詩62:1 （大衛的詩，照耶杜頓的作法，交與伶長。）我的心默默無聲，專等候神；我的救恩是從他而來。',
    '詩62:2 惟獨他是我的磐石，我的拯救；他是我的高臺，我必不很動搖。',
    '詩62:3 你們大家攻擊一人，把他毀壞，如同毀壞歪斜的牆、將倒的壁，要到幾時呢﹖',
    '詩62:4 他們彼此商議，專要從他的尊位上把他推下；他們喜愛謊話，口雖祝福，心卻咒詛。（細拉）',
    '詩62:5 我的心哪，你當默默無聲，專等候神，因為我的盼望是從他而來。',
    '詩62:6 惟獨他是我的磐石，我的拯救；他是我的高臺，我必不動搖。',
    '詩62:7 我的拯救、我的榮耀都在乎神；我力量的磐石、我的避難所都在乎神。',
    '詩62:8 你們眾民當時時倚靠他，在他面前傾心吐意；神是我們的避難所。（細拉）',
    '詩62:9 下流人真是虛空；上流人也是虛假；放在天平裡就必浮起；他們一共比空氣還輕。',
    '詩62:10 不要仗勢欺人，也不要因搶奪而驕傲；若財寶加增，不要放在心上。',
    '詩62:11 神說了一次、兩次，我都聽見：就是能力都屬乎神。',
    '詩62:12 主啊，慈愛也是屬乎你，因為你照著各人所行的報應他。',
    '詩63:1 （大衛在猶大曠野的時候，作了這詩。）神啊，你是我的神，我要切切地尋求你，在乾旱疲乏無水之地，我渴想你；我的心切慕你。',
    '詩63:2 我在聖所中曾如此瞻仰你，為要見你的能力和你的榮耀。',
    '詩63:3 因你的慈愛比生命更好，我的嘴唇要頌讚你。',
    '詩63:4 我還活的時候要這樣稱頌你；我要奉你的名舉手。',
    '詩63:5 我在床上記念你，在夜更的時候思想你；我的心就像飽足了骨髓肥油，我也要以歡樂的嘴唇讚美你。',
    '詩63:6 併於上節。',
    '詩63:7 因為你曾幫助我，我就在你翅膀的蔭下歡呼。',
    '詩63:8 我心緊緊地跟隨你；你的右手扶持我。',
    '詩63:9 但那些尋索要滅我命的人必往地底下去；',
    '詩63:10 他們必被刀劍所殺，被野狗所吃。',
    '詩63:11 但是王必因神歡喜。凡指著他發誓的必要誇口，因為說謊之人的口必被塞住。',
    '詩64:1 （大衛的詩，交與伶長。）神啊，我哀歎的時候，求你聽我的聲音！求你保護我的性命，不受仇敵的驚恐！',
    '詩64:2 求你把我隱藏，使我脫離作惡之人的暗謀和作孽之人的擾亂。',
    '詩64:3 他們磨舌如刀，發出苦毒的言語，好像比準了的箭，',
    '詩64:4 要在暗地射完全人；他們忽然射他，並不懼怕。',
    '詩64:5 他們彼此勉勵設下惡計；他們商量暗設網羅，說：誰能看見﹖',
    '詩64:6 他們圖謀奸惡，說：我們是極力圖謀的。他們各人的意念心思是深的。',
    '詩64:7 但神要射他們；他們忽然被箭射傷。',
    '詩64:8 他們必然絆跌，被自己的舌頭所害；凡看見他們的必都搖頭。',
    '詩64:9 眾人都要害怕，要傳揚神的工作，並且明白他的作為。',
    '詩64:10 義人必因耶和華歡喜，並要投靠他；凡心裡正直的人都要誇口。',
    '詩65:1 （大衛的詩歌，交與伶長。）神啊，錫安的人都等候讚美你；所許的願也要向你償還。',
    '詩65:2 聽禱告的主啊，凡有血氣的都要來就你。',
    '詩65:3 罪孽勝了我；至於我們的過犯，你都要赦免。',
    '詩65:4 你所揀選、使他親近你、住在你院中的，這人便為有福！我們必因你居所、你聖殿的美福知足了。',
    '詩65:5 拯救我們的神啊，你必以威嚴秉公義應允我們；你本是一切地極和海上遠處的人所倚靠的。',
    '詩65:6 他既以大能束腰，就用力量安定諸山，',
    '詩65:7 使諸海的響聲和其中波浪的響聲，並萬民的喧嘩，都平靜了。',
    '詩65:8 住在地極的人因你的神蹟懼怕；你使日出日落之地都歡呼。',
    '詩65:9 你眷顧地，降下透雨，使地大得肥美。神的河滿了水；你這樣澆灌了地，好為人預備五穀。',
    '詩65:10 你澆透地的犁溝，潤平犁脊，降甘霖，使地軟和；其中發長的，蒙你賜福。',
    '詩65:11 你以恩典為年歲的冠冕；你的路徑都滴下脂油，',
    '詩65:12 滴在曠野的草場上。小山以歡樂束腰；',
    '詩65:13 草場以羊群為衣；谷中也長滿了五穀。這一切都歡呼歌唱。',
    '詩66:1 （一篇詩歌，交與伶長。）全地都當向神歡呼！',
    '詩66:2 歌頌他名的榮耀！用讚美的言語將他的榮耀發明！',
    '詩66:3 當對神說：你的作為何等可畏！因你的大能，仇敵要投降你。',
    '詩66:4 全地要敬拜你，歌頌你，要歌頌你的名。（細拉）',
    '詩66:5 你們來看神所行的，他向世人所做之事是可畏的。',
    '詩66:6 他將海變成乾地，眾民步行過河；我們在那裡因他歡喜。',
    '詩66:7 他用權能治理萬民，直到永遠。他的眼睛鑒察列邦；悖逆的人不可自高。（細拉）',
    '詩66:8 萬民哪，你們當稱頌我們的神，使人得聽讚美他的聲音。',
    '詩66:9 他使我們的性命存活，也不叫我們的腳搖動。',
    '詩66:10 神啊，你曾試驗我們，熬煉我們，如熬煉銀子一樣。',
    '詩66:11 你使我們進入網羅，把重擔放在我們的身上。',
    '詩66:12 你使人坐車軋我們的頭；我們經過水火，你卻使我們到豐富之地。',
    '詩66:13 我要用燔祭進你的殿，向你還我的願，',
    '詩66:14 就是在急難時我嘴唇所發的、口中所許的。',
    '詩66:15 我要把肥牛作燔祭，將公羊的香祭獻給你，又把公牛和山羊獻上。（細拉）',
    '詩66:16 凡敬畏神的人，你們都來聽！我要述說他為我所行的事。',
    '詩66:17 我曾用口求告他；我的舌頭也稱他為高。',
    '詩66:18 我若心裡注重罪孽，主必不聽。',
    '詩66:19 但神實在聽見了；他側耳聽了我禱告的聲音。',
    '詩66:20 神是應當稱頌的！他並沒有推卻我的禱告，也沒有叫他的慈愛離開我。',
    '詩67:1 （一篇詩歌，交與伶長。用絲弦的樂器。）願神憐憫我們，賜福與我們，用臉光照我們，（細拉）',
    '詩67:2 好叫世界得知你的道路，萬國得知你的救恩。',
    '詩67:3 神啊，願列邦稱讚你！願萬民都稱讚你！',
    '詩67:4 願萬國都快樂歡呼；因為你必按公正審判萬民，引導世上的萬國。（細拉）',
    '詩67:5 神啊，願列邦稱讚你！願萬民都稱讚你！',
    '詩67:6 地已經出了土產；神─就是我們的神要賜福與我們。',
    '詩67:7 神要賜福與我們；地的四極都要敬畏他！',
    '詩68:1 （大衛的詩歌，交與伶長。）願神興起，使他的仇敵四散，叫那恨他的人從他面前逃跑。',
    '詩68:2 他們被驅逐，如煙被風吹散；惡人見神之面而消滅，如蠟被火鎔化。',
    '詩68:3 惟有義人必然歡喜，在神面前高興快樂。',
    '詩68:4 你們當向神唱詩，歌頌他的名；為那坐車行過曠野的修平大路。他的名是耶和華，要在他面前歡樂！',
    '詩68:5 神在他的聖所作孤兒的父，作寡婦的伸冤者。',
    '詩68:6 神叫孤獨的有家，使被囚的出來享福；惟有悖逆的住在乾燥之地。',
    '詩68:7 神啊，你曾在你百姓前頭出來，在曠野行走。（細拉）',
    '詩68:8 那時，地見神的面而震動，天也落雨；西乃山見以色列神的面也震動。',
    '詩68:9 神啊，你降下大雨；你產業以色列疲乏的時候，你使他堅固。',
    '詩68:10 你的會眾住在其中；神啊，你的恩惠是為困苦人預備的。',
    '詩68:11 主發命令，傳好信息的婦女成了大群。',
    '詩68:12 統兵的君王逃跑了，逃跑了；在家等候的婦女分受所奪的。',
    '詩68:13 你們安臥在羊圈的時候，好像鴿子的翅膀鍍白銀，翎毛鍍黃金一般。',
    '詩68:14 全能者在境內趕散列王的時候，勢如飄雪在撒們。',
    '詩68:15 巴珊山是神的山；巴珊山是多峰多嶺的山。',
    '詩68:16 你們多峰多嶺的山哪，為何斜看神所願居住的山﹖耶和華必住這山，直到永遠！',
    '詩68:17 神的車輦累萬盈千；主在其中，好像在西乃聖山一樣。',
    '詩68:18 你已經升上高天，擄掠仇敵；你在人間，就是在悖逆的人間，受了供獻，叫耶和華神可以與他們同住。',
    '詩68:19 天天背負我們重擔的主，就是拯救我們的神，是應當稱頌的！（細拉）',
    '詩68:20 神是為我們施行諸般救恩的神；人能脫離死亡是在乎主耶和華。',
    '詩68:21 但神要打破他仇敵的頭，就是那常犯罪之人的髮頂。',
    '詩68:22 主說：我要使眾民從巴珊而歸，使他們從深海而回，',
    '詩68:23 使你打碎仇敵，你的腳踹在血中，使你狗的舌頭從其中得分。',
    '詩68:24 神啊，你是我的神，我的王；人已經看見你行走，進入聖所。',
    '詩68:25 歌唱的行在前，作樂的隨在後，都在擊鼓的童女中間。',
    '詩68:26 從以色列源頭而來的，當在各會中稱頌主神！',
    '詩68:27 在那裡，有統管他們的小便雅憫，有猶大的首領和他們的群眾，有西布倫的首領，有拿弗他利的首領。',
    '詩68:28 以色列的能力是神所賜的；神啊，求你堅固你為我們所成全的事！',
    '詩68:29 因你耶路撒冷的殿，列王必帶貢物獻給你。',
    '詩68:30 求你叱喝蘆葦中的野獸和群公牛，並列邦中的牛犢。把銀塊踹在腳下；神已經趕散好爭戰的列邦。',
    '詩68:31 埃及的公侯要出來朝見神；古實人要急忙舉手禱告。',
    '詩68:32 世上的列國啊，你們要向神歌唱；願你們歌頌主！',
    '詩68:33 歌頌那自古駕行在諸天以上的主！他發出聲音，是極大的聲音。',
    '詩68:34 你們要將能力歸給神。他的威榮在以色列之上；他的能力是在穹蒼。',
    '詩68:35 神啊，你從聖所顯為可畏；以色列的神是那將力量權能賜給他百姓的。神是應當稱頌的！',
    '詩69:1 （大衛的詩，交與伶長。調用百合花。）神啊，求你救我！因為眾水要淹沒我。',
    '詩69:2 我陷在深淤泥中，沒有立腳之地；我到了深水中，大水漫過我身。',
    '詩69:3 我因呼求困乏，喉嚨發乾；我因等候神，眼睛失明。',
    '詩69:4 無故恨我的，比我頭髮還多；無理與我為仇、要把我剪除的，甚為強盛。我沒有搶奪的，要叫我償還。',
    '詩69:5 神啊，我的愚昧，你原知道；我的罪愆不能隱瞞。',
    '詩69:6 萬軍的主─耶和華啊，求你叫那等候你的，不要因我蒙羞！以色列的神啊，求你叫那尋求你的，不要因我受辱！',
    '詩69:7 因我為你的緣故受了辱罵，滿面羞愧。',
    '詩69:8 我的弟兄看我為外路人；我的同胞看我為外邦人。',
    '詩69:9 因我為你的殿心裡焦急，如同火燒，並且辱罵你人的辱罵都落在我身上。',
    '詩69:10 我哭泣，以禁食刻苦我心；這倒算為我的羞辱。',
    '詩69:11 我拿麻布當衣裳，就成了他們的笑談。',
    '詩69:12 坐在城門口的談論我；酒徒也以我為歌曲。',
    '詩69:13 但我在悅納的時候向你─耶和華祈禱。神啊，求你按你豐盛的慈愛，憑你拯救的誠實應允我！',
    '詩69:14 求你搭救我出離淤泥，不叫我陷在其中；求你使我脫離那些恨我的人，使我出離深水。',
    '詩69:15 求你不容大水漫過我，不容深淵吞滅我，不容坑坎在我以上合口。',
    '詩69:16 耶和華啊，求你應允我！因為你的慈愛本為美好；求你按你豐盛的慈悲回轉眷顧我！',
    '詩69:17 不要掩面不顧你的僕人；我是在急難之中，求你速速地應允我！',
    '詩69:18 求你親近我，救贖我！求你因我的仇敵把我贖回！',
    '詩69:19 你知道我受的辱罵、欺凌、羞辱；我的敵人都在你面前。',
    '詩69:20 辱罵傷破了我的心，我又滿了憂愁。我指望有人體恤，卻沒有一個；我指望有人安慰，卻找不著一個。',
    '詩69:21 他們拿苦膽給我當食物；我渴了，他們拿醋給我喝。',
    '詩69:22 願他們的筵席在他們面前變為網羅，在他們平安的時候變為機檻。',
    '詩69:23 願他們的眼睛昏矇，不得看見；願你使他們的腰常常戰抖。',
    '詩69:24 求你將你的惱恨倒在他們身上，叫你的烈怒追上他們。',
    '詩69:25 願他們的住處變為荒場；願他們的帳棚無人居住。',
    '詩69:26 因為，你所擊打的，他們就逼迫；你所擊傷的，他們戲說他的愁苦。',
    '詩69:27 願你在他們的罪上加罪，不容他們在你面前稱義。',
    '詩69:28 願他們從生命冊上被塗抹，不得記錄在義人之中。',
    '詩69:29 但我是困苦憂傷的；神啊，願你的救恩將我安置在高處。',
    '詩69:30 我要以詩歌讚美神的名，以感謝稱他為大！',
    '詩69:31 這便叫耶和華喜悅，勝似獻牛，或是獻有角有蹄的公牛。',
    '詩69:32 謙卑的人看見了就喜樂；尋求神的人，願你們的心甦醒。',
    '詩69:33 因為耶和華聽了窮乏人，不藐視被囚的人。',
    '詩69:34 願天和地、洋海和其中一切的動物都讚美他！',
    '詩69:35 因為神要拯救錫安，建造猶大的城邑；他的民要在那裡居住，得以為業。',
    '詩69:36 他僕人的後裔要承受為業；愛他名的人也要住在其中。',
    '詩70:1 （大衛的記念詩，交與伶長。）神啊，求你快快搭救我！耶和華啊，求你速速幫助我！',
    '詩70:2 願那些尋索我命的，抱愧蒙羞；願那些喜悅我遭害的，退後受辱。',
    '詩70:3 願那些對我說阿哈、阿哈的，因羞愧退後。',
    '詩70:4 願一切尋求你的，因你高興歡喜；願那些喜愛你救恩的，常說：當尊神為大！',
    '詩70:5 但我是困苦窮乏的；神啊，求你速速到我這裡來！你是幫助我的，搭救我的。耶和華啊，求你不要耽延！',
    '詩71:1 耶和華啊，我投靠你；求你叫我永不羞愧！',
    '詩71:2 求你憑你的公義搭救我，救拔我；側耳聽我，拯救我！',
    '詩71:3 求你作我常住的磐石；你已經命定要救我，因為你是我的巖石，我的山寨。',
    '詩71:4 我的神啊，求你救我脫離惡人的手，脫離不義和殘暴之人的手。',
    '詩71:5 主─耶和華啊，你是我所盼望的；從我年幼，你是我所倚靠的。',
    '詩71:6 我從出母胎被你扶持；使我出母腹的是你。我必常常讚美你！',
    '詩71:7 許多人以我為怪，但你是我堅固的避難所。',
    '詩71:8 你的讚美，你的榮耀終日必滿了我的口。',
    '詩71:9 我年老的時候，求你不要丟棄我！我力氣衰弱的時候，求你不要離棄我！',
    '詩71:10 我的仇敵議論我；那些窺探要害我命的彼此商議，',
    '詩71:11 說：神已經離棄他；我們追趕他，捉拿他吧！因為沒有人搭救。',
    '詩71:12 神啊，求你不要遠離我！我的神啊，求你速速幫助我！',
    '詩71:13 願那與我性命為敵的，羞愧被滅；願那謀害我的，受辱蒙羞。',
    '詩71:14 我卻要常常盼望，並要越發讚美你。',
    '詩71:15 我的口終日要述說你的公義和你的救恩，因我不計其數。',
    '詩71:16 我要來說主─耶和華大能的事；我單要提說你的公義。',
    '詩71:17 神啊，自我年幼時，你就教訓我；直到如今，我傳揚你奇妙的作為。',
    '詩71:18 神啊，我到年老髮白的時候，求你不要離棄我！等我將你的能力指示下代，將你的大能指示後世的人。',
    '詩71:19 神啊，你的公義甚高；行過大事的神啊，誰能像你！',
    '詩71:20 你是叫我們多經歷重大急難的，必使我們復活，從地的深處救上來。',
    '詩71:21 求你使我越發昌大，又轉來安慰我。',
    '詩71:22 我的神啊，我要鼓瑟稱讚你，稱讚你的誠實！以色列的聖者啊，我要彈琴歌頌你！',
    '詩71:23 我歌頌你的時候，我的嘴唇和你所贖我的靈魂都必歡呼；',
    '詩71:24 並且我的舌頭必終日講論你的公義，因為那些謀害我的人已經蒙羞受辱了。',
    '詩72:1 （所羅門的詩。）神啊，求你將判斷的權柄賜給王，將公義賜給王的兒子。',
    '詩72:2 他要按公義審判你的民，按公平審判你的困苦人。',
    '詩72:3 大山小山都要因公義使民得享平安。',
    '詩72:4 他必為民中的困苦人伸冤，拯救窮乏之輩，壓碎那欺壓人的。',
    '詩72:5 太陽還存，月亮還在，人要敬畏你，直到萬代！',
    '詩72:6 他必降臨，像雨降在已割的草地上，如甘霖滋潤田地。',
    '詩72:7 在他的日子，義人要發旺，大有平安，好像月亮長存。',
    '詩72:8 他要執掌權柄，從這海直到那海，從大河直到地極。',
    '詩72:9 住在曠野的，必在他面前下拜；他的仇敵必要舔土。',
    '詩72:10 他施和海島的王要進貢；示巴和西巴的王要獻禮物。',
    '詩72:11 諸王都要叩拜他；萬國都要事奉他。',
    '詩72:12 因為，窮乏人呼求的時候，他要搭救；沒有人幫助的困苦人，他也要搭救。',
    '詩72:13 他要憐恤貧寒和窮乏的人，拯救窮苦人的性命。',
    '詩72:14 他要救贖他們脫離欺壓和強暴；他們的血在他眼中看為寶貴。',
    '詩72:15 他們要存活。示巴的金子要奉給他；人要常常為他禱告，終日稱頌他。',
    '詩72:16 在地的山頂上，五穀必然茂盛（或譯：有一把五穀）；所結的穀實要響動，如利巴嫩的樹林；城裡的人要發旺，如地上的草。',
    '詩72:17 他的名要存到永遠，要留傳如日之久。人要因他蒙福；萬國要稱他有福。',
    '詩72:18 獨行奇事的耶和華─以色列的神是應當稱頌的！',
    '詩72:19 他榮耀的名也當稱頌，直到永遠。願他的榮耀充滿全地！阿們！阿們！',
    '詩72:20 耶西的兒子─大衛的祈禱完畢。',
    '詩73:1 （亞薩的詩。）神實在恩待以色列那些清心的人！',
    '詩73:2 至於我，我的腳幾乎失閃；我的腳險些滑跌。',
    '詩73:3 我見惡人和狂傲人享平安就心懷不平。',
    '詩73:4 他們死的時候沒有疼痛；他們的力氣卻也壯實。',
    '詩73:5 他們不像別人受苦，也不像別人遭災。',
    '詩73:6 所以，驕傲如鏈子戴在他們的項上；強暴像衣裳遮住他們的身體。',
    '詩73:7 他們的眼睛因體胖而凸出；他們所得的，過於心裡所想的。',
    '詩73:8 他們譏笑人，憑惡意說欺壓人的話；他們說話自高。',
    '詩73:9 他們的口褻瀆上天；他們的舌毀謗全地。',
    '詩73:10 所以神的民歸到這裡，喝盡了滿杯的苦水。',
    '詩73:11 他們說：神怎能曉得﹖至高者豈有知識呢﹖',
    '詩73:12 看哪，這就是惡人；他們既是常享安逸，財寶便加增。',
    '詩73:13 我實在徒然潔淨了我的心，徒然洗手表明無辜。',
    '詩73:14 因為，我終日遭災難；每早晨受懲治。',
    '詩73:15 我若說，我要這樣講，這就是以奸詐待你的眾子。',
    '詩73:16 我思索怎能明白這事，眼看實係為難，',
    '詩73:17 等我進了神的聖所，思想他們的結局。',
    '詩73:18 你實在把他們安在滑地，使他們掉在沉淪之中。',
    '詩73:19 他們轉眼之間成了何等的荒涼！他們被驚恐滅盡了。',
    '詩73:20 人睡醒了，怎樣看夢；主啊，你醒了也必照樣輕看他們的影像。',
    '詩73:21 因而，我心裡發酸，肺腑被刺。',
    '詩73:22 我這樣愚昧無知，在你面前如畜類一般。',
    '詩73:23 然而，我常與你同在；你攙著我的右手。',
    '詩73:24 你要以你的訓言引導我，以後必接我到榮耀裡。',
    '詩73:25 除你以外，在天上我有誰呢﹖除你以外，在地上我也沒有所愛慕的。',
    '詩73:26 我的肉體和我的心腸衰殘；但神是我心裡的力量，又是我的福分，直到永遠。',
    '詩73:27 遠離你的，必要死亡；凡離棄你行邪淫的，你都滅絕了。',
    '詩73:28 但我親近神是於我有益；我以主耶和華為我的避難所，好叫我述說你一切的作為。',
    '詩74:1 （亞薩的訓誨詩。）神啊，你為何永遠丟棄我們呢﹖你為何向你草場的羊發怒，如煙冒出呢﹖',
    '詩74:2 求你記念你古時所得來的會眾，就是你所贖、作你產業支派的，並記念你向來所居住的錫安山。',
    '詩74:3 求你舉步去看那日久荒涼之地，仇敵在聖所中所行的一切惡事。',
    '詩74:4 你的敵人在你會中吼叫；他們豎了自己的旗為記號。',
    '詩74:5 他們好像人揚起斧子，砍伐林中的樹。',
    '詩74:6 聖所中一切雕刻的，他們現在用斧子錘子打壞了。',
    '詩74:7 他們用火焚燒你的聖所，褻瀆你名的居所，拆毀到地。',
    '詩74:8 他們心裡說：我們要盡行毀滅；他們就在遍地把神的會所都燒毀了。',
    '詩74:9 我們不見我們的標幟，不再有先知；我們內中也沒有人知道這災禍要到幾時呢！',
    '詩74:10 神啊，敵人辱罵要到幾時呢﹖仇敵褻瀆你的名要到永遠嗎﹖',
    '詩74:11 你為什麼縮回你的右手﹖求你從懷中伸出來，毀滅他們。',
    '詩74:12 神自古以來為我的王，在地上施行拯救。',
    '詩74:13 你曾用能力將海分開，將水中大魚的頭打破。',
    '詩74:14 你曾砸碎鱷魚的頭，把他給曠野的禽獸（禽獸：原文是民）為食物。',
    '詩74:15 你曾分裂磐石，水便成了溪河；你使長流的江河乾了。',
    '詩74:16 白晝屬你，黑夜也屬你；亮光和日頭是你所預備的。',
    '詩74:17 地的一切疆界是你所立的；夏天和冬天是你所定的。',
    '詩74:18 耶和華啊，仇敵辱罵，愚頑民褻瀆了你的名，求你記念這事。',
    '詩74:19 不要將你斑鳩的性命交給野獸；不要永遠忘記你困苦人的性命。',
    '詩74:20 求你顧念所立的約，因為地上黑暗之處都滿了強暴的居所。',
    '詩74:21 不要叫受欺壓的人蒙羞回去；要叫困苦窮乏的人讚美你的名。',
    '詩74:22 神啊，求你起來為自己伸訴！要記念愚頑人怎樣終日辱罵你。',
    '詩74:23 不要忘記你敵人的聲音；那起來敵你之人的喧嘩時常上升。',
    '詩75:1 （亞薩的詩歌，交與伶長。調用休要毀壞。）神啊，我們稱謝你，我們稱謝你！因為你的名相近，人都述說你奇妙的作為。',
    '詩75:2 我到了所定的日期，必按正直施行審判。',
    '詩75:3 地和其上的居民都消化了；我曾立了地的柱子。（細拉）',
    '詩75:4 我對狂傲人說：不要行事狂傲！對凶惡人說：不要舉角！',
    '詩75:5 不要把你們的角高舉；不要挺著頸項說話。',
    '詩75:6 因為高舉非從東，非從西，也非從南而來。',
    '詩75:7 惟有神斷定；他使這人降卑，使那人升高。',
    '詩75:8 耶和華手裡有杯，其中的酒起沫，杯內滿了攙雜的酒；他倒出來，地上的惡人必都喝這酒的渣滓，而且喝盡。',
    '詩75:9 但我要宣揚，直到永遠！我要歌頌雅各的神！',
    '詩75:10 惡人一切的角，我要砍斷；惟有義人的角必被高舉。',
    '詩76:1 （亞薩的詩歌，交與伶長。用絲弦的樂器。）在猶大，神為人所認識；在以色列，他的名為大。',
    '詩76:2 在撒冷有他的帳幕；在錫安有他的居所。',
    '詩76:3 他在那裡折斷弓上的火箭，並盾牌、刀劍，和爭戰的兵器。（細拉）',
    '詩76:4 你從有野食之山而來，有光華和榮美。',
    '詩76:5 心中勇敢的人都被搶奪；他們睡了長覺，沒有一個英雄能措手。',
    '詩76:6 雅各的神啊，你的斥責一發，坐車的﹔騎馬的都沉睡了。',
    '詩76:7 惟獨你是可畏的！你怒氣一發，誰能在你面前站得住呢﹖',
    '詩76:8 你從天上使人聽判斷。神起來施行審判，要救地上一切謙卑的人；那時地就懼怕而靜默。（細拉）',
    '詩76:9 併於上節。',
    '詩76:10 人的忿怒要成全你的榮美；人的餘怒，你要禁止。',
    '詩76:11 你們許願，當向耶和華─你們的神還願；在他四面的人都當拿貢物獻給那可畏的主。',
    '詩76:12 他要挫折王子的驕氣；他向地上的君王顯威可畏。',
    '詩77:1 （亞薩的詩，照耶杜頓的作法，交與伶長。）我要向神發聲呼求；我向神發聲，他必留心聽我。',
    '詩77:2 我在患難之日尋求主；我在夜間不住地舉手禱告；我的心不肯受安慰。',
    '詩77:3 我想念神，就煩燥不安；我沉吟悲傷，心便發昏。（細拉）',
    '詩77:4 你叫我不能閉眼；我煩亂不安，甚至不能說話。',
    '詩77:5 我追想古時之日，上古之年。',
    '詩77:6 我想起我夜間的歌曲，捫心自問；我心裡也仔細省察。',
    '詩77:7 難道主要永遠丟棄我，不再施恩嗎﹖',
    '詩77:8 難道他的慈愛永遠窮盡，他的應許世世廢棄嗎﹖',
    '詩77:9 難道神忘記開恩，因發怒就止住他的慈悲嗎﹖（細拉）',
    '詩77:10 我便說：這是我的懦弱，但我要追念至高者顯出右手之年代。',
    '詩77:11 我要提說耶和華所行的；我要記念你古時的奇事。',
    '詩77:12 我也要思想你的經營，默念你的作為。',
    '詩77:13 神啊，你的作為是潔淨的；有何神大如神呢﹖',
    '詩77:14 你是行奇事的神；你曾在列邦中彰顯你的能力。',
    '詩77:15 你曾用你的膀臂贖了你的民，就是雅各和約瑟的子孫。（細拉）',
    '詩77:16 神啊，諸水見你，一見就都驚惶；深淵也都戰抖。',
    '詩77:17 雲中倒出水來；天空發出響聲；你的箭也飛行四方。',
    '詩77:18 你的雷聲在旋風中；電光照亮世界；大地戰抖震動。',
    '詩77:19 你的道在海中；你的路在大水中；你的腳蹤無人知道。',
    '詩77:20 你曾藉摩西和亞倫的手引導你的百姓，好像羊群一般。',
    '詩78:1 （亞薩的訓誨詩。）我的民哪，你們要留心聽我的訓誨，側耳聽我口中的話。',
    '詩78:2 我要開口說比喻；我要說出古時的謎語，',
    '詩78:3 是我們所聽見、所知道的，也是我們的祖宗告訴我們的。',
    '詩78:4 我們不將這些事向他們的子孫隱瞞，要將耶和華的美德和他的能力，並他奇妙的作為，述說給後代聽。',
    '詩78:5 因為，他在雅各中立法度，在以色列中設律法；是他吩咐我們祖宗要傳給子孫的，',
    '詩78:6 使將要生的後代子孫可以曉得；他們也要起來告訴他們的子孫，',
    '詩78:7 好叫他們仰望神，不忘記神的作為，惟要守他的命令。',
    '詩78:8 不要像他們的祖宗，是頑梗悖逆、居心不正之輩，向著神，心不誠實。',
    '詩78:9 以法蓮的子孫帶著兵器，拿著弓，臨陣之日轉身退後。',
    '詩78:10 他們不遵守神的約，不肯照他的律法行；',
    '詩78:11 又忘記他所行的和他顯給他們奇妙的作為。',
    '詩78:12 他在埃及地，在瑣安田，在他們祖宗的眼前施行奇事。',
    '詩78:13 他將海分裂，使他們過去，又叫水立起如壘。',
    '詩78:14 他白日用雲彩，終夜用火光引導他們。',
    '詩78:15 他在曠野分裂磐石，多多地給他們水喝，如從深淵而出。',
    '詩78:16 他使水從磐石湧出，叫水如江河下流。',
    '詩78:17 他們卻仍舊得罪他，在乾燥之地悖逆至高者。',
    '詩78:18 他們心中試探神，隨自己所欲的求食物，',
    '詩78:19 並且妄論神說：神在曠野豈能擺設筵席嗎﹖',
    '詩78:20 他曾擊打磐石，使水湧出，成了江河；他還能賜糧食嗎﹖還能為他的百姓預備肉嗎﹖',
    '詩78:21 所以，耶和華聽見就發怒；有烈火向雅各燒起；有怒氣向以色列上騰；',
    '詩78:22 因為他們不信服神，不倚賴他的救恩。',
    '詩78:23 他卻吩咐天空，又敞開天上的門，',
    '詩78:24 降嗎哪，像雨給他們吃，將天上的糧食賜給他們。',
    '詩78:25 各人（或譯：人）吃大能者的食物；他賜下糧食，使他們飽足。',
    '詩78:26 他領東風起在天空，又用能力引了南風來。',
    '詩78:27 他降肉，像雨在他們當中，多如塵土，又降飛鳥，多如海沙，',
    '詩78:28 落在他們的營中，在他們住處的四面。',
    '詩78:29 他們吃了，而且飽足；這樣就隨了他們所欲的。',
    '詩78:30 他們貪而無厭，食物還在他們口中的時候，',
    '詩78:31 神的怒氣就向他們上騰，殺了他們內中的肥壯人，打倒以色列的少年人。',
    '詩78:32 雖是這樣，他們仍舊犯罪，不信他奇妙的作為。',
    '詩78:33 因此，他叫他們的日子全歸虛空，叫他們的年歲盡屬驚恐。',
    '詩78:34 他殺他們的時候，他們才求問他，回心轉意，切切地尋求神。',
    '詩78:35 他們也追念神是他們的磐石，至高的神是他們的救贖主。',
    '詩78:36 他們卻用口諂媚他，用舌向他說謊。',
    '詩78:37 因他們的心向他不正，在他的約上也不忠心。',
    '詩78:38 但他有憐憫，赦免他們的罪孽，不滅絕他們，而且屢次消他的怒氣，不發盡他的忿怒。',
    '詩78:39 他想到他們不過是血氣，是一陣去而不返的風。',
    '詩78:40 他們在曠野悖逆他，在荒地叫他擔憂，何其多呢！',
    '詩78:41 他們再三試探神，惹動以色列的聖者。',
    '詩78:42 他們不追念他的能力（原文是手）和贖他們脫離敵人的日子；',
    '詩78:43 他怎樣在埃及地顯神蹟，在瑣安田顯奇事，',
    '詩78:44 把他們的江河並河汊的水都變為血，使他們不能喝。',
    '詩78:45 他叫蒼蠅成群落在他們當中，嘬盡他們，又叫青蛙滅了他們，',
    '詩78:46 把他們的土產交給螞蚱，把他們辛苦得來的交給蝗蟲。',
    '詩78:47 他降冰雹打壞他們的葡萄樹，下嚴霜打壞他們的桑樹，',
    '詩78:48 又把他們的牲畜交給冰雹，把他們的群畜交給閃電。',
    '詩78:49 他使猛烈的怒氣和忿怒、惱恨、苦難成了一群降災的使者，臨到他們。',
    '詩78:50 他為自己的怒氣修平了路，將他們交給瘟疫，使他們死亡，',
    '詩78:51 在埃及擊殺一切長子，在含的帳棚中擊殺他們強壯時頭生的。',
    '詩78:52 他卻領出自己的民如羊，在曠野引他們如羊群。',
    '詩78:53 他領他們穩穩妥妥地，使他們不致害怕；海卻淹沒他們的仇敵。',
    '詩78:54 他帶他們到自己聖地的邊界，到他右手所得的這山地。',
    '詩78:55 他在他們面前趕出外邦人，用繩子將外邦的地量給他們為業，叫以色列支派的人住在他們的帳棚裡。',
    '詩78:56 他們仍舊試探、悖逆至高的神，不守他的法度，',
    '詩78:57 反倒退後，行詭詐，像他們的祖宗一樣；他們改變，如同翻背的弓。',
    '詩78:58 因他們的邱壇惹了他的怒氣；因他們雕刻的偶像觸動他的憤恨。',
    '詩78:59 神聽見就發怒，極其憎惡以色列人。',
    '詩78:60 甚至他離棄示羅的帳幕，就是他在人間所搭的帳棚；',
    '詩78:61 又將他的約櫃（原文是能力）交與人擄去，將他的榮耀交在敵人手中；',
    '詩78:62 並將他的百姓交與刀劍，向他的產業發怒。',
    '詩78:63 少年人被火燒滅；處女也無喜歌。',
    '詩78:64 祭司倒在刀下，寡婦卻不哀哭。',
    '詩78:65 那時，主像世人睡醒，像勇士飲酒呼喊。',
    '詩78:66 他就打退了他的敵人，叫他們永蒙羞辱；',
    '詩78:67 並且他棄掉約瑟的帳棚，不揀選以法蓮支派，',
    '詩78:68 卻揀選猶大支派─他所喜愛的錫安山；',
    '詩78:69 蓋造他的聖所，好像高峰，又像他建立永存之地；',
    '詩78:70 又揀選他的僕人大衛，從羊圈中將他召來，',
    '詩78:71 叫他不再跟從那些帶奶的母羊，為要牧養自己的百姓雅各和自己的產業以色列。',
    '詩78:72 於是，他按心中的純正牧養他們，用手中的巧妙引導他們。',
    '詩79:1 （亞薩的詩。）神啊，外邦人進入你的產業，污穢你的聖殿，使耶路撒冷變成荒堆，',
    '詩79:2 把你僕人的屍首交與天空的飛鳥為食，把你聖民的肉交與地上的野獸，',
    '詩79:3 在耶路撒冷周圍流他們的血如水，無人葬埋。',
    '詩79:4 我們成為鄰國的羞辱，成為我們四圍人的嗤笑譏刺。',
    '詩79:5 耶和華啊，這到幾時呢﹖你要動怒到永遠嗎﹖你的憤恨要如火焚燒嗎﹖',
    '詩79:6 願你將你的忿怒倒在那不認識你的外邦和那不求告你名的國度。',
    '詩79:7 因為他們吞了雅各，把他的住處變為荒場。',
    '詩79:8 求你不要記念我們先祖的罪孽，向我們追討；願你的慈悲快迎著我們，因為我們落到極卑微的地步。',
    '詩79:9 拯救我們的神啊，求你因你名的榮耀幫助我們！為你名的緣故搭救我們，赦免我們的罪。',
    '詩79:10 為何容外邦人說他們的神在哪裡呢﹖願你使外邦人知道你在我們眼前伸你僕人流血的冤。',
    '詩79:11 願被囚之人的歎息達到你面前；願你按你的大能力存留那些將要死的人。',
    '詩79:12 主啊，願你將我們鄰邦所羞辱你的羞辱加七倍歸到他們身上。',
    '詩79:13 這樣，你的民，你草場的羊，要稱謝你，直到永遠；要述說讚美你的話，直到萬代。',
    '詩80:1 （亞薩的詩，交與伶長。調用為證的百合花。）領約瑟如領羊群之以色列的牧者啊，求你留心聽！坐在二基路伯上的啊，求你發出光來！',
    '詩80:2 在以法蓮、便雅憫、瑪拿西前面施展你的大能，來救我們。',
    '詩80:3 神啊，求你使我們回轉（或譯：復興），使你的臉發光，我們便要得救！',
    '詩80:4 耶和華─萬軍之神啊，你向你百姓的禱告發怒，要到幾時呢﹖',
    '詩80:5 你以眼淚當食物給他們吃，又多量出眼淚給他們喝。',
    '詩80:6 你使鄰邦因我們紛爭；我們的仇敵彼此戲笑。',
    '詩80:7 萬軍之神啊，求你使我們回轉，使你的臉發光，我們便要得救！',
    '詩80:8 你從埃及挪出一棵葡萄樹，趕出外邦人，把這樹栽上。',
    '詩80:9 你在這樹根前預備了地方，他就深深扎根，爬滿了地。',
    '詩80:10 他的影子遮滿了山，枝子好像佳美的香柏樹。',
    '詩80:11 他發出枝子，長到大海，發出蔓子，延到大河。',
    '詩80:12 你為何拆毀這樹的籬笆，任憑一切過路的人摘取？',
    '詩80:13 林中出來的野豬把他糟踏；野地的走獸拿他當食物。',
    '詩80:14 萬軍之神啊，求你回轉！從天上垂看，眷顧這葡萄樹，',
    '詩80:15 保護你右手所栽的和你為自己所堅固的枝子。',
    '詩80:16 這樹已經被火焚燒，被刀砍伐；他們因你臉上的怒容就滅亡了。',
    '詩80:17 願你的手扶持你右邊的人，就是你為自己所堅固的人子。',
    '詩80:18 這樣，我們便不退後離開你；求你救活我們，我們就要求告你的名。',
    '詩80:19 耶和華─萬軍之神啊，求你使我們回轉，使你的臉發光，我們便要得救！',
    '詩81:1 （亞薩的詩，交與伶長。用迦特樂器。）你們當向神─我們的力量大聲歡呼，向雅各的神發聲歡樂！',
    '詩81:2 唱起詩歌，打手鼓，彈美琴與瑟。',
    '詩81:3 當在月朔並月望─我們過節的日期吹角，',
    '詩81:4 因這是為以色列定的律例，是雅各神的典章。',
    '詩81:5 他去攻擊埃及地的時候，在約瑟中間立此為證。我在那裡聽見我所不明白的言語：',
    '詩81:6 神說：我使你的肩得脫重擔，你的手放下筐子。',
    '詩81:7 你在急難中呼求，我就搭救你；我在雷的隱密處應允你，在米利巴水那裡試驗你。（細拉）',
    '詩81:8 我的民哪，你當聽，我要勸戒你；以色列啊，甚願你肯聽從我。',
    '詩81:9 在你當中，不可有別的神；外邦的神，你也不可下拜。',
    '詩81:10 我是耶和華─你的神，曾把你從埃及地領上來；你要大大張口，我就給你充滿。',
    '詩81:11 無奈，我的民不聽我的聲音；以色列全不理我。',
    '詩81:12 我便任憑他們心裡剛硬，隨自己的計謀而行。',
    '詩81:13 甚願我的民肯聽從我，以色列肯行我的道，',
    '詩81:14 我便速速治服他們的仇敵，反手攻擊他們的敵人。',
    '詩81:15 恨耶和華的人必來投降，但他的百姓必永久長存。',
    '詩81:16 他也必拿上好的麥子給他們吃，又拿從磐石出的蜂蜜叫他們飽足。',
    '詩82:1 （亞薩的詩。）神站在有權力者的會中，在諸神中行審判，',
    '詩82:2 說：你們審判不秉公義，徇惡人的情面，要到幾時呢﹖（細拉）',
    '詩82:3 你們當為貧寒的人和孤兒伸冤；當為困苦和窮乏的人施行公義。',
    '詩82:4 當保護貧寒和窮乏的人，救他們脫離惡人的手。',
    '詩82:5 你們仍不知道，也不明白，在黑暗中走來走去；地的根基都搖動了。',
    '詩82:6 我曾說：你們是神，都是至高者的兒子。',
    '詩82:7 然而，你們要死，與世人一樣，要仆倒，像王子中的一位。',
    '詩82:8 神啊，求你起來審判世界，因為你要得萬邦為業。',
    '詩83:1 （亞薩的詩歌。）神啊，求你不要靜默！神啊，求你不要閉口，也不要不作聲！',
    '詩83:2 因為你的仇敵喧嚷，恨你的擡起頭來。',
    '詩83:3 他們同謀奸詐要害你的百姓，彼此商議要害你所隱藏的人。',
    '詩83:4 他們說：來吧，我們將他們剪滅，使他們不再成國！使以色列的名不再被人記念！',
    '詩83:5 他們同心商議，彼此結盟，要抵擋你，',
    '詩83:6 就是住帳棚的以東人和以實瑪利人，摩押和夏甲人，',
    '詩83:7 迦巴勒、亞捫，和亞瑪力、非利士並推羅的居民。',
    '詩83:8 亞述也與他們連合；他們作羅得子孫的幫手。（細拉）',
    '詩83:9 求你待他們，如待米甸，如在基順河待西西拉和耶賓一樣。',
    '詩83:10 他們在隱多珥滅亡，成了地上的糞土。',
    '詩83:11 求你叫他們的首領像俄立和西伊伯，叫他們的王子都像西巴和撒慕拿。',
    '詩83:12 他們說：我們要得神的住處，作為自己的產業。',
    '詩83:13 我的神啊，求你叫他們像旋風的塵土，像風前的碎稭。',
    '詩83:14 火怎樣焚燒樹林，火焰怎樣燒著山嶺，',
    '詩83:15 求你也照樣用狂風追趕他們，用暴雨恐嚇他們。',
    '詩83:16 願你使他們滿面羞恥，好叫他們尋求你─耶和華的名！',
    '詩83:17 願他們永遠羞愧驚惶！願他們慚愧滅亡！',
    '詩83:18 使他們知道：惟獨你─名為耶和華的─是全地以上的至高者！',
    '詩84:1 （可拉後裔的詩，交與伶長。用迦特樂器。）萬軍之耶和華啊，你的居所何等可愛！',
    '詩84:2 我羨慕渴想耶和華的院宇；我的心腸，我的肉體向永生神呼籲（或譯：歡呼）。',
    '詩84:3 萬軍之耶和華─我的王，我的神啊，在你祭壇那裡，麻雀為自己找著房屋，燕子為自己找著菢雛之窩。',
    '詩84:4 如此住在你殿中的便為有福！他們仍要讚美你。（細拉）',
    '詩84:5 靠你有力量、心中想往錫安大道的，這人便為有福！',
    '詩84:6 他們經過流淚谷，叫這谷變為泉源之地；並有秋雨之福蓋滿了全谷。',
    '詩84:7 他們行走，力上加力，各人到錫安朝見神。',
    '詩84:8 耶和華─萬軍之神啊，求你聽我的禱告！雅各的神啊，求你留心聽！（細拉）',
    '詩84:9 神啊，你是我們的盾牌；求你垂顧觀看你受膏者的面！',
    '詩84:10 在你的院宇住一日，勝似在別處住千日；寧可在我神殿中看門，不願住在惡人的帳棚裡。',
    '詩84:11 因為耶和華─神是日頭，是盾牌，要賜下恩惠和榮耀。他未嘗留下一樣好處不給那些行動正直的人。',
    '詩84:12 萬軍之耶和華啊，倚靠你的人便為有福！',
    '詩85:1 （可拉後裔的詩，交與伶長。）耶和華啊，你已經向你的地施恩，救回被擄的雅各。',
    '詩85:2 你赦免了你百姓的罪孽，遮蓋了他們一切的過犯。（細拉）',
    '詩85:3 你收轉了所發的忿怒和你猛烈的怒氣。',
    '詩85:4 拯救我們的神啊，求你使我們回轉，叫你的惱恨向我們止息。',
    '詩85:5 你要向我們發怒到永遠嗎﹖你要將你的怒氣延留到萬代嗎﹖',
    '詩85:6 你不再將我們救活，使你的百姓靠你歡喜嗎﹖',
    '詩85:7 耶和華啊，求你使我們得見你的慈愛，又將你的救恩賜給我們。',
    '詩85:8 我要聽神─耶和華所說的話；因為他必應許將平安賜給他的百姓─他的聖民；他們卻不可再轉去妄行。',
    '詩85:9 他的救恩誠然與敬畏他的人相近，叫榮耀住在我們的地上。',
    '詩85:10 慈愛和誠實彼此相遇；公義和平安彼此相親。',
    '詩85:11 誠實從地而生；公義從天而現。',
    '詩85:12 耶和華必將好處賜給我們；我們的地也要多出土產。',
    '詩85:13 公義要行在他面前，叫他的腳蹤成為可走的路。',
    '詩86:1 （大衛的祈禱。）耶和華啊，求你側耳應允我，因我是困苦窮乏的。',
    '詩86:2 求你保存我的性命，因我是虔誠人。我的神啊，求你拯救這倚靠你的僕人！',
    '詩86:3 主啊，求你憐憫我，因我終日求告你。',
    '詩86:4 主啊，求你使僕人心裡歡喜，因為我的心仰望你。',
    '詩86:5 主啊，你本為良善，樂意饒恕人，有豐盛的慈愛賜給凡求告你的人。',
    '詩86:6 耶和華啊，求你留心聽我的禱告，垂聽我懇求的聲音。',
    '詩86:7 我在患難之日要求告你，因為你必應允我。',
    '詩86:8 主啊，諸神之中沒有可比你的；你的作為也無可比。',
    '詩86:9 主啊，你所造的萬民都要來敬拜你；他們也要榮耀你的名。',
    '詩86:10 因你為大，且行奇妙的事；惟獨你是神。',
    '詩86:11 耶和華啊，求你將你的道指教我；我要照你的真理行；求你使我專心敬畏你的名！',
    '詩86:12 主─我的神啊，我要一心稱讚你；我要榮耀你的名，直到永遠。',
    '詩86:13 因為，你向我發的慈愛是大的；你救了我的靈魂免入極深的陰間。',
    '詩86:14 神啊，驕傲的人起來攻擊我，又有一黨強橫的人尋索我的命；他們沒有將你放在眼中。',
    '詩86:15 主啊，你是有憐憫有恩典的神，不輕易發怒，並有豐盛的慈愛和誠實。',
    '詩86:16 求你向我轉臉，憐恤我，將你的力量賜給僕人，救你婢女的兒子。',
    '詩86:17 求你向我顯出恩待我的憑據，叫恨我的人看見便羞愧，因為你─耶和華幫助我，安慰我。',
    '詩87:1 （可拉後裔的詩歌。）耶和華所立的根基在聖山上。',
    '詩87:2 他愛錫安的門，勝於愛雅各一切的住處。',
    '詩87:3 神的城啊，有榮耀的事乃指著你說的。（細拉）',
    '詩87:4 我要提起拉哈伯和巴比倫人，是在認識我之中的；看哪，非利士和推羅並古實人，個個生在那裡。',
    '詩87:5 論到錫安，必說：這一個、那一個都生在其中，而且至高者必親自堅立這城。',
    '詩87:6 當耶和華記錄萬民的時候，他要點出這一個生在那裡。（細拉）',
    '詩87:7 歌唱的，跳舞的，都要說：我的泉源都在你裡面。',
    '詩88:1 （可拉後裔的詩歌，就是以斯拉人希幔的訓誨詩，交與伶長。調用麻哈拉利暗俄。）耶和華─拯救我的神啊，我晝夜在你面前呼籲。',
    '詩88:2 願我的禱告達到你面前；求你側耳聽我的呼求！',
    '詩88:3 因為我心裡滿了患難；我的性命臨近陰間。',
    '詩88:4 我算和下坑的人同列，如同無力（或譯：沒有幫助）的人一樣。',
    '詩88:5 我被丟在死人中，好像被殺的人躺在墳墓裡。他們是你不再記念的，與你隔絕了。',
    '詩88:6 你把我放在極深的坑裡，在黑暗地方，在深處。',
    '詩88:7 你的忿怒重壓我身；你用一切的波浪困住我。（細拉）',
    '詩88:8 你把我所認識的隔在遠處，使我為他們所憎惡；我被拘困，不得出來。',
    '詩88:9 我的眼睛因困苦而乾癟。耶和華啊，我天天求告你，向你舉手。',
    '詩88:10 你豈要行奇事給死人看嗎﹖難道陰魂還能起來稱讚你嗎﹖（細拉）',
    '詩88:11 豈能在墳墓裡述說你的慈愛嗎﹖豈能在滅亡中述說你的信實嗎﹖',
    '詩88:12 你的奇事豈能在幽暗裡被知道嗎﹖你的公義豈能在忘記之地被知道嗎﹖',
    '詩88:13 耶和華啊，我呼求你；我早晨的禱告要達到你面前。',
    '詩88:14 耶和華啊，你為何丟棄我﹖為何掩面不顧我﹖',
    '詩88:15 我自幼受苦，幾乎死亡；我受你的驚恐，甚至慌張。',
    '詩88:16 你的烈怒漫過我身；你的驚嚇把我剪除。',
    '詩88:17 這些終日如水環繞我，一齊都來圍困我。',
    '詩88:18 你把我的良朋密友隔在遠處，使我所認識的人進入黑暗裡。',
    '詩89:1 （以斯拉人以探的訓誨詩。）我要歌唱耶和華的慈愛，直到永遠；我要用口將你的信實傳與萬代。',
    '詩89:2 因我曾說：你的慈悲必建立到永遠；你的信實必堅立在天上。',
    '詩89:3 我與我所揀選的人立了約，向我的僕人大衛起了誓：',
    '詩89:4 我要建立你的後裔，直到永遠；要建立你的寶座，直到萬代。（細拉）',
    '詩89:5 耶和華啊，諸天要稱讚你的奇事；在聖者的會中，要稱讚你的信實。',
    '詩89:6 在天空誰能比耶和華呢﹖神的眾子中，誰能像耶和華呢﹖',
    '詩89:7 他在聖者的會中，是大有威嚴的神，比一切在他四圍的更可畏懼。',
    '詩89:8 耶和華─萬軍之神啊，哪一個大能者像你耶和華﹖你的信實是在你的四圍。',
    '詩89:9 你管轄海的狂傲；波浪翻騰，你就使他平靜了。',
    '詩89:10 你打碎了拉哈伯，似乎是已殺的人；你用有能的膀臂打散了你的仇敵。',
    '詩89:11 天屬你，地也屬你；世界和其中所充滿的都為你所建立。',
    '詩89:12 南北為你所創造；他泊和黑門都因你的名歡呼。',
    '詩89:13 你有大能的膀臂；你的手有力，你的右手也高舉。',
    '詩89:14 公義和公平是你寶座的根基；慈愛和誠實行在你前面。',
    '詩89:15 知道向你歡呼的，那民是有福的！耶和華啊，他們在你臉上的光裡行走。',
    '詩89:16 他們因你的名終日歡樂，因你的公義得以高舉。',
    '詩89:17 你是他們力量的榮耀；因為你喜悅我們，我們的角必被高舉。',
    '詩89:18 我們的盾牌屬耶和華；我們的王屬以色列的聖者。',
    '詩89:19 當時，你在異象中曉諭你的聖民，說：我已把救助之力加在那有能者的身上；我高舉那從民中所揀選的。',
    '詩89:20 我尋得我的僕人大衛，用我的聖膏膏他。',
    '詩89:21 我的手必使他堅立；我的膀臂也必堅固他。',
    '詩89:22 仇敵必不勒索他；凶惡之子也不苦害他。',
    '詩89:23 我要在他面前打碎他的敵人，擊殺那恨他的人。',
    '詩89:24 只是我的信實和我的慈愛要與他同在；因我的名，他的角必被高舉。',
    '詩89:25 我要使他的左手伸到海上，右手伸到河上。',
    '詩89:26 他要稱呼我說：你是我的父，是我的神，是拯救我的磐石。',
    '詩89:27 我也要立他為長子，為世上最高的君王。',
    '詩89:28 我要為他存留我的慈愛，直到永遠；我與他立的約必要堅定。',
    '詩89:29 我也要使他的後裔存到永遠，使他的寶座如天之久。',
    '詩89:30 倘若他的子孫離棄我的律法，不照我的典章行，',
    '詩89:31 背棄我的律例，不遵守我的誡命，',
    '詩89:32 我就要用杖責罰他們的過犯，用鞭責罰他們的罪孽。',
    '詩89:33 只是我必不將我的慈愛全然收回，也必不叫我的信實廢棄。',
    '詩89:34 我必不背棄我的約，也不改變我口中所出的。',
    '詩89:35 我一次指著自己的聖潔起誓：我決不向大衛說謊！',
    '詩89:36 他的後裔要存到永遠；他的寶座在我面前如日之恆一般，',
    '詩89:37 又如月亮永遠堅立，如天上確實的見證。（細拉）',
    '詩89:38 但你惱怒你的受膏者，就丟掉棄絕他。',
    '詩89:39 你厭惡了與僕人所立的約，將他的冠冕踐踏於地。',
    '詩89:40 你拆毀了他一切的籬笆，使他的保障變為荒場。',
    '詩89:41 凡過路的人都搶奪他；他成為鄰邦的羞辱。',
    '詩89:42 你高舉了他敵人的右手；你叫他一切的仇敵歡喜。',
    '詩89:43 你叫他的刀劍捲刃，叫他在爭戰之中站立不住。',
    '詩89:44 你使他的光輝止息，將他的寶座推倒於地。',
    '詩89:45 你減少他青年的日子，又使他蒙羞。（細拉）',
    '詩89:46 耶和華啊，這要到幾時呢﹖你要將自己隱藏到永遠嗎﹖你的忿怒如火焚燒要到幾時呢﹖',
    '詩89:47 求你想念我的時候是何等的短少；你創造世人，要使他們歸何等的虛空呢﹖',
    '詩89:48 誰能常活免死、救他的靈魂脫離陰間的權柄呢﹖（細拉）',
    '詩89:49 主啊，你從前憑你的信實向大衛立誓要施行的慈愛在哪裡呢﹖',
    '詩89:50 主啊，求你記念僕人們所受的羞辱，記念我怎樣將一切強盛民的羞辱存在我懷裡。',
    '詩89:51 耶和華啊，你的仇敵用這羞辱羞辱了你的僕人，羞辱了你受膏者的腳蹤。',
    '詩89:52 耶和華是應當稱頌的，直到永遠。阿們！阿們！',
    '詩90:1 （神人摩西的祈禱）主啊，你世世代代作我們的居所。',
    '詩90:2 諸山未曾生出，地與世界你未曾造成，從亙古到永遠，你是神。',
    '詩90:3 你使人歸於塵土，說：你們世人要歸回。',
    '詩90:4 在你看來，千年如已過的昨日，又如夜間的一更。',
    '詩90:5 你叫他們如水沖去；他們如睡一覺。早晨，他們如生長的草，',
    '詩90:6 早晨發芽生長，晚上割下枯乾。',
    '詩90:7 我們因你的怒氣而消滅，因你的忿怒而驚惶。',
    '詩90:8 你將我們的罪孽擺在你面前，將我們的隱惡擺在你面光之中。',
    '詩90:9 我們經過的日子都在你震怒之下；我們度盡的年歲好像一聲歎息。',
    '詩90:10 我們一生的年日是七十歲，若是強壯可到八十歲；但其中所矜誇的不過是勞苦愁煩，轉眼成空，我們便如飛而去。',
    '詩90:11 誰曉得你怒氣的權勢﹖誰按著你該受的敬畏曉得你的忿怒呢﹖',
    '詩90:12 求你指教我們怎樣數算自己的日子，好叫我們得著智慧的心。',
    '詩90:13 耶和華啊，我們要等到幾時呢﹖求你轉回，為你的僕人後悔。',
    '詩90:14 求你使我們早早飽得你的慈愛，好叫我們一生一世歡呼喜樂。',
    '詩90:15 求你照著你使我們受苦的日子，和我們遭難的年歲，叫我們喜樂。',
    '詩90:16 願你的作為向你僕人顯現；願你的榮耀向他們子孫顯明。',
    '詩90:17 願主─我們神的榮美歸於我們身上。願你堅立我們手所做的工；我們手所做的工，願你堅立。',
    '詩91:1 住在至高者隱密處的，必住在全能者的蔭下。',
    '詩91:2 我要論到耶和華說：他是我的避難所，是我的山寨，是我的神，是我所倚靠的。',
    '詩91:3 他必救你脫離捕鳥人的網羅和毒害的瘟疫。',
    '詩91:4 他必用自己的翎毛遮蔽你；你要投靠在他的翅膀底下；他的誠實是大小的盾牌。',
    '詩91:5 你必不怕黑夜的驚駭，或是白日飛的箭，',
    '詩91:6 也不怕黑夜行的瘟疫，或是午間滅人的毒病。',
    '詩91:7 雖有千人仆倒在你旁邊，萬人仆倒在你右邊，這災卻不得臨近你。',
    '詩91:8 你惟親眼觀看，見惡人遭報。',
    '詩91:9 耶和華是我的避難所；你已將至高者當你的居所，',
    '詩91:10 禍患必不臨到你，災害也不挨近你的帳棚。',
    '詩91:11 因他要為你吩咐他的使者，在你行的一切道路上保護你。',
    '詩91:12 他們要用手托著你，免得你的腳碰在石頭上。',
    '詩91:13 你要踹在獅子和虺蛇的身上，踐踏少壯獅子和大蛇。',
    '詩91:14 神說：因為他專心愛我，我就要搭救他；因為他知道我的名，我要把他安置在高處。',
    '詩91:15 他若求告我，我就應允他；他在急難中，我要與他同在；我要搭救他，使他尊貴。',
    '詩91:16 我要使他足享長壽，將我的救恩顯明給他。',
    '詩92:1 （安息日的詩歌。）稱謝耶和華！歌頌你至高者的名！',
    '詩92:2 用十弦的樂器和瑟，用琴彈幽雅的聲音，早晨傳揚你的慈愛；每夜傳揚你的信實。這本為美事。',
    '詩92:3 併於上節。',
    '詩92:4 因你─耶和華藉著你的作為叫我高興，我要因你手的工作歡呼。',
    '詩92:5 耶和華啊，你的工作何其大！你的心思極其深！',
    '詩92:6 畜類人不曉得；愚頑人也不明白。',
    '詩92:7 惡人茂盛如草，一切作孽之人發旺的時候，正是他們要滅亡，直到永遠。',
    '詩92:8 惟你─耶和華是至高，直到永遠。',
    '詩92:9 耶和華啊，你的仇敵都要滅亡；一切作孽的也要離散。',
    '詩92:10 你卻高舉了我的角，如野牛的角；我是被新油膏了的。',
    '詩92:11 我眼睛看見仇敵遭報；我耳朵聽見那些起來攻擊我的惡人受罰。',
    '詩92:12 義人要發旺如棕樹，生長如利巴嫩的香柏樹。',
    '詩92:13 他們栽於耶和華的殿中，發旺在我們神的院裡。',
    '詩92:14 他們年老的時候仍要結果子，要滿了汁漿而常發青，',
    '詩92:15 好顯明耶和華是正直的。他是我的磐石，在他毫無不義。',
    '詩93:1 耶和華作王！他以威嚴為衣穿上；耶和華以能力為衣，以能力束腰，世界就堅定，不得動搖。',
    '詩93:2 你的寶座從太初立定；你從亙古就有。',
    '詩93:3 耶和華啊，大水揚起，大水發聲，波浪澎湃。',
    '詩93:4 耶和華在高處大有能力，勝過諸水的響聲，洋海的大浪。',
    '詩93:5 耶和華啊，你的法度最的確；你的殿永稱為聖，是合宜的。',
    '詩94:1 耶和華啊，你是伸冤的神；伸冤的神啊，求你發出光來！',
    '詩94:2 審判世界的主啊，求你挺身而立，使驕傲人受應得的報應！',
    '詩94:3 耶和華啊，惡人誇勝要到幾時呢﹖要到幾時呢﹖',
    '詩94:4 他們絮絮叨叨說傲慢的話；一切作孽的人都自己誇張。',
    '詩94:5 耶和華啊，他們強壓你的百姓，苦害你的產業。',
    '詩94:6 他們殺死寡婦和寄居的，又殺害孤兒。',
    '詩94:7 他們說：耶和華必不看見；雅各的神必不思念。',
    '詩94:8 你們民間的畜類人當思想；你們愚頑人到幾時才有智慧呢﹖',
    '詩94:9 造耳朵的，難道自己不聽見嗎﹖造眼睛的，難道自己不看見嗎﹖',
    '詩94:10 管教列邦的，就是叫人得知識的，難道自己不懲治人嗎﹖',
    '詩94:11 耶和華知道人的意念是虛妄的。',
    '詩94:12 耶和華啊，你所管教、用律法所教訓的人是有福的！',
    '詩94:13 你使他在遭難的日子得享平安；惟有惡人陷在所挖的坑中。',
    '詩94:14 因為耶和華必不丟棄他的百姓，也不離棄他的產業。',
    '詩94:15 審判要轉向公義；心裡正直的，必都隨從。',
    '詩94:16 誰肯為我起來攻擊作惡的﹖誰肯為我站起抵擋作孽的﹖',
    '詩94:17 若不是耶和華幫助我，我就住在寂靜之中了。',
    '詩94:18 我正說我失了腳，耶和華啊，那時你的慈愛扶助我。',
    '詩94:19 我心裡多憂多疑，你安慰我，就使我歡樂。',
    '詩94:20 那藉著律例架弄殘害、在位上行奸惡的，豈能與你相交嗎﹖',
    '詩94:21 他們大家聚集攻擊義人，將無辜的人定為死罪。',
    '詩94:22 但耶和華向來作了我的高臺；我的神作了我投靠的磐石。',
    '詩94:23 他叫他們的罪孽歸到他們身上。他們正在行惡之中，他要剪除他們；耶和華─我們的神要把他們剪除。',
    '詩95:1 來啊，我們要向耶和華歌唱，向拯救我們的磐石歡呼！',
    '詩95:2 我們要來感謝他，用詩歌向他歡呼！',
    '詩95:3 因耶和華為大神，為大王，超乎萬神之上。',
    '詩95:4 地的深處在他手中；山的高峰也屬他。',
    '詩95:5 海洋屬他，是他造的；旱地也是他手造成的。',
    '詩95:6 來啊，我們要屈身敬拜，在造我們的耶和華面前跪下。',
    '詩95:7 因為他是我們的神；我們是他草場的羊，是他手下的民。惟願你們今天聽他的話：',
    '詩95:8 你們不可硬著心，像當日在米利巴，就是在曠野的瑪撒。',
    '詩95:9 那時，你們的祖宗試我探我，並且觀看我的作為。',
    '詩95:10 四十年之久，我厭煩那世代，說：這是心裡迷糊的百姓，竟不曉得我的作為！',
    '詩95:11 所以，我在怒中起誓，說：他們斷不可進入我的安息！',
    '詩96:1 你們要向耶和華唱新歌！全地都要向耶和華歌唱！',
    '詩96:2 要向耶和華歌唱，稱頌他的名！天天傳揚他的救恩！',
    '詩96:3 在列邦中述說他的榮耀！在萬民中述說他的奇事！',
    '詩96:4 因耶和華為大，當受極大的讚美；他在萬神之上，當受敬畏。',
    '詩96:5 外邦的神都屬虛無；惟獨耶和華創造諸天。',
    '詩96:6 有尊榮和威嚴在他面前；有能力與華美在他聖所。',
    '詩96:7 民中的萬族啊，你們要將榮耀、能力歸給耶和華，都歸給耶和華！',
    '詩96:8 要將耶和華的名所當得的榮耀歸給他，拿供物來進入他的院宇。',
    '詩96:9 當以聖潔的（的：或譯為）妝飾敬拜耶和華；全地要在他面前戰抖！',
    '詩96:10 人在列邦中要說：耶和華作王！世界就堅定，不得動搖；他要按公正審判眾民。',
    '詩96:11 願天歡喜，願地快樂！願海和其中所充滿的澎湃！',
    '詩96:12 願田和其中所有的都歡樂！那時，林中的樹木都要在耶和華面前歡呼。',
    '詩96:13 因為他來了，他來要審判全地。他要按公義審判世界，按他的信實審判萬民。',
    '詩97:1 耶和華作王！願地快樂！願眾海島歡喜！',
    '詩97:2 密雲和幽暗在他的四圍；公義和公平是他寶座的根基。',
    '詩97:3 有烈火在他前頭行，燒滅他四圍的敵人。',
    '詩97:4 他的閃電光照世界，大地看見便震動。',
    '詩97:5 諸山見耶和華的面，就是全地之主的面，便消化如蠟。',
    '詩97:6 諸天表明他的公義；萬民看見他的榮耀。',
    '詩97:7 願一切事奉雕刻的偶像、靠虛無之神自誇的，都蒙羞愧。萬神哪，你們都當拜他。',
    '詩97:8 耶和華啊，錫安聽見你的判斷就歡喜；猶大的城邑（原文是女子）也都快樂。',
    '詩97:9 因為你─耶和華至高，超乎全地；你被尊崇，遠超萬神之上。',
    '詩97:10 你們愛耶和華的，都當恨惡罪惡；他保護聖民的性命，搭救他們脫離惡人的手。',
    '詩97:11 散布亮光是為義人；預備喜樂是為正直人。',
    '詩97:12 你們義人當靠耶和華歡喜，稱謝他可記念的聖名。',
    '詩98:1 （一篇詩。）你們要向耶和華唱新歌！因為他行過奇妙的事；他的右手和聖臂施行救恩。',
    '詩98:2 耶和華發明了他的救恩，在列邦人眼前顯出公義；',
    '詩98:3 記念他向以色列家所發的慈愛，所憑的信實。地的四極都看見我們神的救恩。',
    '詩98:4 全地都要向耶和華歡樂；要發起大聲，歡呼歌頌！',
    '詩98:5 要用琴歌頌耶和華，用琴和詩歌的聲音歌頌他！',
    '詩98:6 用號和角聲，在大君王耶和華面前歡呼！',
    '詩98:7 願海和其中所充滿的澎湃；世界和住在其間的也要發聲。',
    '詩98:8 願大水拍手；願諸山在耶和華面前一同歡呼；',
    '詩98:9 因為他來要審判遍地。他要按公義審判世界，按公正審判萬民。',
    '詩99:1 耶和華作王；萬民當戰抖！他坐在二基路伯上，地當動搖。',
    '詩99:2 耶和華在錫安為大；他超乎萬民之上。',
    '詩99:3 他們當稱讚他大而可畏的名；他本為聖！',
    '詩99:4 王有能力，喜愛公平，堅立公正，在雅各中施行公平和公義。',
    '詩99:5 你們當尊崇耶和華─我們的神，在他腳凳前下拜。他本為聖！',
    '詩99:6 在他的祭司中有摩西和亞倫；在求告他名的人中有撒母耳。他們求告耶和華，他就應允他們。',
    '詩99:7 他在雲柱中對他們說話；他們遵守他的法度和他所賜給他們的律例。',
    '詩99:8 耶和華─我們的神啊，你應允他們；你是赦免他們的神，卻按他們所行的報應他們。',
    '詩99:9 你們要尊崇耶和華─我們的神，在他的聖山下拜，因為耶和華─我們的神本為聖！',
    '詩100:1 （稱謝詩。）普天下當向耶和華歡呼！',
    '詩100:2 你們當樂意事奉耶和華，當來向他歌唱！',
    '詩100:3 你們當曉得耶和華是神！我們是他造的，也是屬他的；我們是他的民，也是他草場的羊。',
    '詩100:4 當稱謝進入他的門；當讚美進入他的院。當感謝他，稱頌他的名！',
    '詩100:5 因為耶和華本為善。他的慈愛存到永遠；他的信實直到萬代。',
    '詩101:1 （大衛的詩）我要歌唱慈愛和公平；耶和華啊，我要向你歌頌！',
    '詩101:2 我要用智慧行完全的道。你幾時到我這裡來呢﹖我要存完全的心行在我家中。',
    '詩101:3 邪僻的事，我都不擺在我眼前；悖逆人所做的事，我甚恨惡，不容沾在我身上。',
    '詩101:4 彎曲的心思，我必遠離；一切的惡人（或譯：惡事），我不認識。',
    '詩101:5 在暗中讒謗他鄰居的，我必將他滅絕；眼目高傲、心裡驕縱的，我必不容他。',
    '詩101:6 我眼要看國中的誠實人，叫他們與我同住；行為完全的，他要伺候我。',
    '詩101:7 行詭詐的，必不得住在我家裡；說謊話的，必不得立在我眼前。',
    '詩101:8 我每日早晨要滅絕國中所有的惡人，好把一切作孽的從耶和華的城裡剪除。',
    '詩102:1 （困苦人發昏的時候，在耶和華面前吐露苦情的禱告。）耶和華啊，求你聽我的禱告，容我的呼求達到你面前！',
    '詩102:2 我在急難的日子，求你向我側耳；不要向我掩面！我呼求的日子，求你快快應允我！',
    '詩102:3 因為，我的年日如煙雲消滅；我的骨頭如火把燒著。',
    '詩102:4 我的心被傷，如草枯乾，甚至我忘記吃飯。',
    '詩102:5 因我唉哼的聲音，我的肉緊貼骨頭。',
    '詩102:6 我如同曠野的鵜鶘；我好像荒場的鴞鳥。',
    '詩102:7 我警醒不睡；我像房頂上孤單的麻雀。',
    '詩102:8 我的仇敵終日辱罵我；向我猖狂的人指著我賭咒。',
    '詩102:9 我吃過爐灰，如同吃飯；我所喝的與眼淚攙雜。',
    '詩102:10 這都因你的惱恨和忿怒；你把我拾起來，又把我摔下去。',
    '詩102:11 我的年日如日影偏斜；我也如草枯乾。',
    '詩102:12 惟你─耶和華必存到永遠；你可記念的名也存到萬代。',
    '詩102:13 你必起來憐恤錫安，因現在是可憐他的時候，日期已經到了。',
    '詩102:14 你的僕人原來喜悅他的石頭，可憐他的塵土。',
    '詩102:15 列國要敬畏耶和華的名；世上諸王都敬畏你的榮耀。',
    '詩102:16 因為耶和華建造了錫安，在他榮耀裡顯現。',
    '詩102:17 他垂聽窮人的禱告，並不藐視他們的祈求。',
    '詩102:18 這必為後代的人記下，將來受造的民要讚美耶和華。',
    '詩102:19 因為，他從至高的聖所垂看；耶和華從天向地觀察，',
    '詩102:20 要垂聽被囚之人的歎息，要釋放將要死的人，',
    '詩102:21 使人在錫安傳揚耶和華的名，在耶路撒冷傳揚讚美他的話，',
    '詩102:22 就是在萬民和列國聚會事奉耶和華的時候。',
    '詩102:23 他使我的力量中道衰弱，使我的年日短少。',
    '詩102:24 我說：我的神啊，不要使我中年去世。你的年數世世無窮！',
    '詩102:25 你起初立了地的根基；天也是你手所造的。',
    '詩102:26 天地都要滅沒，你卻要長存；天地都要如外衣漸漸舊了。你要將天地如裡衣更換，天地就改變了。',
    '詩102:27 惟有你永不改變；你的年數沒有窮盡。',
    '詩102:28 你僕人的子孫要長存；他們的後裔要堅立在你面前。',
    '詩103:1 （大衛的詩。）我的心哪，你要稱頌耶和華！凡在我裡面的，也要稱頌他的聖名！',
    '詩103:2 我的心哪，你要稱頌耶和華！不可忘記他的一切恩惠！',
    '詩103:3 他赦免你的一切罪孽，醫治你的一切疾病。',
    '詩103:4 他救贖你的命脫離死亡，以仁愛和慈悲為你的冠冕。',
    '詩103:5 他用美物使你所願的得以知足，以致你如鷹返老還童。',
    '詩103:6 耶和華施行公義，為一切受屈的人伸冤。',
    '詩103:7 他使摩西知道他的法則，叫以色列人曉得他的作為。',
    '詩103:8 耶和華有憐憫，有恩典，不輕易發怒，且有豐盛的慈愛。',
    '詩103:9 他不長久責備，也不永遠懷怒。',
    '詩103:10 他沒有按我們的罪過待我們，也沒有照我們的罪孽報應我們。',
    '詩103:11 天離地何等的高，他的慈愛向敬畏他的人也是何等的大！',
    '詩103:12 東離西有多遠，他叫我們的過犯離我們也有多遠！',
    '詩103:13 父親怎樣憐恤他的兒女，耶和華也怎樣憐恤敬畏他的人！',
    '詩103:14 因為他知道我們的本體，思念我們不過是塵土。',
    '詩103:15 至於世人，他的年日如草一樣。他發旺如野地的花，',
    '詩103:16 經風一吹，便歸無有；他的原處也不再認識他。',
    '詩103:17 但耶和華的慈愛歸於敬畏他的人，從亙古到永遠；他的公義也歸於子子孫孫',
    '詩103:18 就是那些遵守他的約、記念他的訓詞而遵行的人。',
    '詩103:19 耶和華在天上立定寶座；他的權柄（原文是國）統管萬有。',
    '詩103:20 聽從他命令、成全他旨意、有大能的天使，都要稱頌耶和華！',
    '詩103:21 你們作他的諸軍，作他的僕役，行他所喜悅的，都要稱頌耶和華！',
    '詩103:22 你們一切被他造的，在他所治理的各處，都要稱頌耶和華！我的心哪，你要稱頌耶和華！',
    '詩104:1 我的心哪，你要稱頌耶和華！耶和華─我的神啊，你為至大！你以尊榮威嚴為衣服，',
    '詩104:2 披上亮光，如披外袍，鋪張穹蒼，如鋪幔子，',
    '詩104:3 在水中立樓閣的棟梁，用雲彩為車輦，藉著風的翅膀而行，',
    '詩104:4 以風為使者，以火焰為僕役，',
    '詩104:5 將地立在根基上，使地永不動搖。',
    '詩104:6 你用深水遮蓋地面，猶如衣裳；諸水高過山嶺。',
    '詩104:7 你的斥責一發，水便奔逃；你的雷聲一發，水便奔流。',
    '詩104:8 諸山升上，諸谷沉下（或譯：隨山上翻，隨谷下流），歸你為他所安定之地。',
    '詩104:9 你定了界限，使水不能過去，不再轉回遮蓋地面。',
    '詩104:10 耶和華使泉源湧在山谷，流在山間，',
    '詩104:11 使野地的走獸有水喝，野驢得解其渴。',
    '詩104:12 天上的飛鳥在水旁住宿，在樹枝上啼叫。',
    '詩104:13 他從樓閣中澆灌山嶺；因他作為的功效，地就豐足。',
    '詩104:14 他使草生長，給六畜吃，使菜蔬發長，供給人用，使人從地裡能得食物，',
    '詩104:15 又得酒能悅人心，得油能潤人面，得糧能養人心。',
    '詩104:16 佳美的樹木，就是利巴嫩的香柏樹，是耶和華所栽種的，都滿了汁漿。',
    '詩104:17 雀鳥在其上搭窩；至於鶴，松樹是他的房屋。',
    '詩104:18 高山為野山羊的住所；巖石為沙番的藏處。',
    '詩104:19 你安置月亮為定節令；日頭自知沉落。',
    '詩104:20 你造黑暗為夜，林中的百獸就都爬出來。',
    '詩104:21 少壯獅子吼叫，要抓食，向神尋求食物。',
    '詩104:22 日頭一出，獸便躲避，臥在洞裡。',
    '詩104:23 人出去做工，勞碌直到晚上。',
    '詩104:24 耶和華啊，你所造的何其多！都是你用智慧造成的；遍地滿了你的豐富。',
    '詩104:25 那裡有海，又大又廣；其中有無數的動物，大小活物都有。',
    '詩104:26 那裡有船行走，有你所造的鱷魚游泳在其中。',
    '詩104:27 這都仰望你按時給他食物。',
    '詩104:28 你給他們，他們便拾起來；你張手，他們飽得美食。',
    '詩104:29 你掩面，他們便驚惶；你收回他們的氣，他們就死亡，歸於塵土。',
    '詩104:30 你發出你的靈，他們便受造；你使地面更換為新。',
    '詩104:31 願耶和華的榮耀存到永遠！願耶和華喜悅自己所造的！',
    '詩104:32 他看地，地便震動；他摸山，山就冒煙。',
    '詩104:33 我要一生向耶和華唱詩！我還活的時候，要向我神歌頌！',
    '詩104:34 願他以我的默念為甘甜！我要因耶和華歡喜！',
    '詩104:35 願罪人從世上消滅！願惡人歸於無有！我的心哪，要稱頌耶和華！你們要讚美耶和華（原文是哈利路亞；下同）！',
    '詩105:1 你們要稱謝耶和華，求告他的名，在萬民中傳揚他的作為！',
    '詩105:2 要向他唱詩歌頌，談論他一切奇妙的作為！',
    '詩105:3 要以他的聖名誇耀！尋求耶和華的人，心中應當歡喜！',
    '詩105:4 要尋求耶和華與他的能力，時常尋求他的面。',
    '詩105:5 他僕人亞伯拉罕的後裔，他所揀選雅各的子孫哪，你們要記念他奇妙的作為和他的奇事，並他口中的判語。',
    '詩105:6 併於上節。',
    '詩105:7 他是耶和華─我們的神；全地都有他的判斷。',
    '詩105:8 他記念他的約，直到永遠；他所吩咐的話，直到千代─',
    '詩105:9 就是與亞伯拉罕所立的約，向以撒所起的誓。',
    '詩105:10 他又將這約向雅各定為律例，向以色列定為永遠的約，',
    '詩105:11 說：我必將迦南地賜給你，作你產業的分。',
    '詩105:12 當時，他們人丁有限，數目稀少，並且在那地為寄居的。',
    '詩105:13 他們從這邦遊到那邦，從這國行到那國。',
    '詩105:14 他不容什麼人欺負他們，為他們的緣故責備君王，',
    '詩105:15 說：不可難為我受膏的人，也不可惡待我的先知。',
    '詩105:16 他命饑荒降在那地上，將所倚靠的糧食全行斷絕，',
    '詩105:17 在他們以先打發一個人去─約瑟被賣為奴僕。',
    '詩105:18 人用腳鐐傷他的腳；他被鐵鍊捆拘。',
    '詩105:19 耶和華的話試煉他，直等到他所說的應驗了。',
    '詩105:20 王打發人把他解開，就是治理眾民的，把他釋放，',
    '詩105:21 立他作王家之主，掌管他一切所有的，',
    '詩105:22 使他隨意捆綁他的臣宰，將智慧教導他的長老。',
    '詩105:23 以色列也到了埃及；雅各在含地寄居。',
    '詩105:24 耶和華使他的百姓生養眾多，使他們比敵人強盛，',
    '詩105:25 使敵人的心轉去恨他的百姓，並用詭計待他的僕人。',
    '詩105:26 他打發他的僕人摩西和他所揀選的亞倫，',
    '詩105:27 在敵人中間顯他的神蹟，在含地顯他的奇事。',
    '詩105:28 他命黑暗，就有黑暗；沒有違背他話的。',
    '詩105:29 他叫埃及的水變為血，叫他們的魚死了。',
    '詩105:30 在他們的地上以及王宮的內室，青蛙多多滋生。',
    '詩105:31 他說一聲，蒼蠅就成群而來，並有虱子進入他們四境。',
    '詩105:32 他給他們降下冰雹為雨，在他們的地上降下火焰。',
    '詩105:33 他也擊打他們的葡萄樹和無花果樹，毀壞他們境內的樹木。',
    '詩105:34 他說一聲，就有蝗蟲螞蚱上來，不計其數，',
    '詩105:35 吃盡了他們地上各樣的菜蔬和田地的出產。',
    '詩105:36 他又擊殺他們國內一切的長子，就是他們強壯時頭生的。',
    '詩105:37 他領自己的百姓帶銀子金子出來；他支派中沒有一個軟弱的。',
    '詩105:38 他們出來的時候，埃及人便歡喜；原來埃及人懼怕他們。',
    '詩105:39 他鋪張雲彩當遮蓋，夜間使火光照。',
    '詩105:40 他們一求，他就使鵪鶉飛來，並用天上的糧食叫他們飽足。',
    '詩105:41 他打開磐石，水就湧出；在乾旱之處，水流成河。',
    '詩105:42 這都因他記念他的聖言和他的僕人亞伯拉罕。',
    '詩105:43 他帶領百姓歡樂而出，帶領選民歡呼前往。',
    '詩105:44 他將列國的地賜給他們，他們便承受眾民勞碌得來的，',
    '詩105:45 好使他們遵他的律例，守他的律法。你們要讚美耶和華！',
    '詩106:1 你們要讚美耶和華！要稱謝耶和華，因他本為善；他的慈愛永遠長存！',
    '詩106:2 誰能傳說耶和華的大能﹖誰能表明他一切的美德﹖',
    '詩106:3 凡遵守公平﹔常行公義的，這人便為有福！',
    '詩106:4 耶和華啊，你用恩惠待你的百姓；求你也用這恩惠記念我，開你的救恩眷顧我，',
    '詩106:5 使我見你選民的福，樂你國民的樂，與你的產業一同誇耀。',
    '詩106:6 我們與我們的祖宗一同犯罪；我們作了孽，行了惡。',
    '詩106:7 我們的祖宗在埃及不明白你的奇事，不記念你豐盛的慈愛，反倒在紅海行了悖逆。',
    '詩106:8 然而，他因自己的名拯救他們，為要彰顯他的大能，',
    '詩106:9 並且斥責紅海，海便乾了；他帶領他們經過深處，如同經過曠野。',
    '詩106:10 他拯救他們脫離恨他們人的手，從仇敵手中救贖他們。',
    '詩106:11 水淹沒他們的敵人，沒有一個存留。',
    '詩106:12 那時，他們才信了他的話，歌唱讚美他。',
    '詩106:13 等不多時，他們就忘了他的作為，不仰望他的指教，',
    '詩106:14 反倒在曠野大起慾心，在荒地試探神。',
    '詩106:15 他將他們所求的賜給他們，卻使他們的心靈軟弱。',
    '詩106:16 他們又在營中嫉妒摩西和耶和華的聖者亞倫。',
    '詩106:17 地裂開，吞下大坍，掩蓋亞比蘭一黨的人。',
    '詩106:18 有火在他們的黨中發起；有火焰燒毀了惡人。',
    '詩106:19 他們在何烈山造了牛犢，叩拜鑄成的像。',
    '詩106:20 如此將他們榮耀的主換為吃草之牛的像，',
    '詩106:21 忘了神─他們的救主；他曾在埃及行大事，',
    '詩106:22 在含地行奇事，在紅海行可畏的事。',
    '詩106:23 所以，他說要滅絕他們；若非有他所揀選的摩西站在當中（原文是破口），使他的忿怒轉消，恐怕他就滅絕他們。',
    '詩106:24 他們又藐視那美地，不信他的話，',
    '詩106:25 在自己帳棚內發怨言，不聽耶和華的聲音。',
    '詩106:26 所以，他對他們起誓：必叫他們倒在曠野，',
    '詩106:27 叫他們的後裔倒在列國之中，分散在各地。',
    '詩106:28 他們又與巴力‧毘珥連合，且吃了祭死神（或譯：人）的物。',
    '詩106:29 他們這樣行，惹耶和華發怒，便有瘟疫流行在他們中間。',
    '詩106:30 那時，非尼哈站起，刑罰惡人，瘟疫這才止息。',
    '詩106:31 那就算為他的義，世世代代，直到永遠。',
    '詩106:32 他們在米利巴水又叫耶和華發怒，甚至摩西也受了虧損，',
    '詩106:33 是因他們惹動他的靈，摩西（原文是他）用嘴說了急躁的話。',
    '詩106:34 他們不照耶和華所吩咐的滅絕外邦人，',
    '詩106:35 反與他們混雜相合，學習他們的行為，',
    '詩106:36 事奉他們的偶像，這就成了自己的網羅，',
    '詩106:37 把自己的兒女祭祀鬼魔，',
    '詩106:38 流無辜人的血，就是自己兒女的血，把他們祭祀迦南的偶像，那地就被血污穢了。',
    '詩106:39 這樣，他們被自己所做的污穢了，在行為上犯了邪淫。',
    '詩106:40 所以，耶和華的怒氣向他的百姓發作，憎惡他的產業，',
    '詩106:41 將他們交在外邦人的手裡；恨他們的人就轄制他們。',
    '詩106:42 他們的仇敵也欺壓他們，他們就伏在敵人手下。',
    '詩106:43 他屢次搭救他們，他們卻設謀背逆，因自己的罪孽降為卑下。',
    '詩106:44 然而，他聽見他們哀告的時候，就眷顧他們的急難，',
    '詩106:45 為他們記念他的約，照他豐盛的慈愛後悔。',
    '詩106:46 他也使他們在凡擄掠他們的人面前蒙憐恤。',
    '詩106:47 耶和華─我們的神啊，求你拯救我們，從外邦中招聚我們，我們好稱讚你的聖名，以讚美你為誇勝。',
    '詩106:48 耶和華─以色列的神是應當稱頌的，從亙古直到永遠。願眾民都說：阿們！你們要讚美耶和華！',
    '詩107:1 你們要稱謝耶和華，因他本為善；他的慈愛永遠長存！',
    '詩107:2 願耶和華的贖民說這話，就是他從敵人手中所救贖的，',
    '詩107:3 從各地，從東從西，從南從北，所招聚來的。',
    '詩107:4 他們在曠野荒地漂流，尋不見可住的城邑，',
    '詩107:5 又飢又渴，心裡發昏。',
    '詩107:6 於是，他們在苦難中哀求耶和華；他從他們的禍患中搭救他們，',
    '詩107:7 又領他們行走直路，使他們往可居住的城邑。',
    '詩107:8 但願人因耶和華的慈愛和他向人所行的奇事都稱讚他；',
    '詩107:9 因他使心裡渴慕的人得以知足，使心裡飢餓的人得飽美物。',
    '詩107:10 那些坐在黑暗中、死蔭裡的人被困苦和鐵鍊捆鎖，',
    '詩107:11 是因他們違背神的話語，藐視至高者的旨意。',
    '詩107:12 所以，他用勞苦治服他們的心；他們仆倒，無人扶助。',
    '詩107:13 於是，他們在苦難中哀求耶和華；他從他們的禍患中拯救他們。',
    '詩107:14 他從黑暗中和死蔭裡領他們出來，折斷他們的綁索。',
    '詩107:15 但願人因耶和華的慈愛和他向人所行的奇事都稱讚他；',
    '詩107:16 因為他打破了銅門，砍斷了鐵閂。',
    '詩107:17 愚妄人因自己的過犯和自己的罪孽便受苦楚。',
    '詩107:18 他們心裡厭惡各樣的食物，就臨近死門。',
    '詩107:19 於是，他們在苦難中哀求耶和華；他從他們的禍患中拯救他們。',
    '詩107:20 他發命醫治他們，救他們脫離死亡。',
    '詩107:21 但願人因耶和華的慈愛和他向人所行的奇事都稱讚他。',
    '詩107:22 願他們以感謝為祭獻給他，歡呼述說他的作為！',
    '詩107:23 在海上坐船，在大水中經理事務的，',
    '詩107:24 他們看見耶和華的作為，並他在深水中的奇事。',
    '詩107:25 因他一吩咐，狂風就起來，海中的波浪也揚起。',
    '詩107:26 他們上到天空，下到海底；他們的心因患難便消化。',
    '詩107:27 他們搖搖幌幌，東倒西歪，好像醉酒的人；他們的智慧無法可施。',
    '詩107:28 於是，他們在苦難中哀求耶和華，他從他們的禍患中領出他們來。',
    '詩107:29 他使狂風止息，波浪就平靜。',
    '詩107:30 風息浪靜，他們便歡喜；他就引他們到所願去的海口。',
    '詩107:31 但願人因耶和華的慈愛和他向人所行的奇事都稱讚他。',
    '詩107:32 願他們在民的會中尊崇他，在長老的位上讚美他！',
    '詩107:33 他使江河變為曠野，叫水泉變為乾渴之地，',
    '詩107:34 使肥地變為鹼地；這都因其間居民的罪惡。',
    '詩107:35 他使曠野變為水潭，叫旱地變為水泉。',
    '詩107:36 他使飢餓的人住在那裡，好建造可住的城邑，',
    '詩107:37 又種田地，栽葡萄園，得享所出的土產。',
    '詩107:38 他又賜福給他們，叫他們生養眾多，也不叫他們的牲畜減少。',
    '詩107:39 他們又因暴虐、患難、愁苦，就減少且卑下。',
    '詩107:40 他使君王蒙羞被辱，使他們在荒廢無路之地漂流。',
    '詩107:41 他卻將窮乏人安置在高處，脫離苦難，使他的家屬多如羊群。',
    '詩107:42 正直人看見就歡喜；罪孽之輩必塞口無言。',
    '詩107:43 凡有智慧的，必在這些事上留心，也必思想耶和華的慈愛。',
    '詩108:1 （大衛的詩歌。）神啊，我心堅定；我口（原文是榮耀）要唱詩歌頌！',
    '詩108:2 琴瑟啊，你們當醒起！我自己要極早醒起！',
    '詩108:3 耶和華啊，我要在萬民中稱謝你，在列邦中歌頌你！',
    '詩108:4 因為，你的慈愛大過諸天；你的誠實達到穹蒼。',
    '詩108:5 神啊，願你崇高過於諸天！願你的榮耀高過全地！',
    '詩108:6 求你應允我們，用右手拯救我們，好叫你所親愛的人得救。',
    '詩108:7 神已經指著他的聖潔說（說：或譯應許我）：我要歡樂；我要分開示劍，丈量疏割谷。',
    '詩108:8 基列是我的；瑪拿西是我的；以法蓮是護衛我頭的；猶大是我的杖；',
    '詩108:9 摩押是我的沐浴盆；我要向以東拋鞋；我必因勝非利士呼喊。',
    '詩108:10 誰能領我進堅固城﹖誰能引我到以東地﹖',
    '詩108:11 神啊，你不是丟棄了我們嗎﹖神啊，你不和我們的軍兵同去嗎﹖',
    '詩108:12 求你幫助我們攻擊敵人，因為人的幫助是枉然的。',
    '詩108:13 我們倚靠神才得施展大能，因為踐踏我們敵人的就是他。',
    '詩109:1 （大衛的詩，交與伶長。）我所讚美的神啊，求你不要閉口不言。',
    '詩109:2 因為惡人的嘴和詭詐人的口已經張開攻擊我；他們用撒謊的舌頭對我說話。',
    '詩109:3 他們圍繞我，說怨恨的話，又無故地攻打我。',
    '詩109:4 他們與我為敵以報我愛，但我專心祈禱。',
    '詩109:5 他們向我以惡報善，以恨報愛。',
    '詩109:6 願你派一個惡人轄制他，派一個對頭站在他右邊！',
    '詩109:7 他受審判的時候，願他出來擔當罪名！願他的祈禱反成為罪！',
    '詩109:8 願他的年日短少！願別人得他的職分！',
    '詩109:9 願他的兒女為孤兒，他的妻子為寡婦！',
    '詩109:10 願他的兒女漂流討飯，從他們荒涼之處出來求食！',
    '詩109:11 願強暴的債主牢籠他一切所有的！願外人搶他勞碌得來的！',
    '詩109:12 願無人向他延綿施恩！願無人可憐他的孤兒！',
    '詩109:13 願他的後人斷絕，名字被塗抹，不傳於下代！',
    '詩109:14 願他祖宗的罪孽被耶和華記念！願他母親的罪過不被塗抹！',
    '詩109:15 願這些罪常在耶和華面前，使他的名號斷絕於世！',
    '詩109:16 因為他不想施恩，卻逼迫困苦窮乏的和傷心的人，要把他們治死。',
    '詩109:17 他愛咒罵，咒罵就臨到他；他不喜愛福樂，福樂就與他遠離！',
    '詩109:18 他拿咒罵當衣服穿上；這咒罵就如水進他裡面，像油入他的骨頭。',
    '詩109:19 願這咒罵當他遮身的衣服，當他常束的腰帶！',
    '詩109:20 這就是我對頭和用惡言議論我的人從耶和華那裡所受的報應。',
    '詩109:21 主─耶和華啊，求你為你的名恩待我；因你的慈愛美好，求你搭救我！',
    '詩109:22 因為我困苦窮乏，內心受傷。',
    '詩109:23 我如日影漸漸偏斜而去；我如蝗蟲被抖出來。',
    '詩109:24 我因禁食，膝骨軟弱；我身上的肉也漸漸瘦了。',
    '詩109:25 我受他們的羞辱，他們看見我便搖頭。',
    '詩109:26 耶和華─我的神啊，求你幫助我，照你的慈愛拯救我，',
    '詩109:27 使他們知道這是你的手，是你─耶和華所行的事。',
    '詩109:28 任憑他們咒罵，惟願你賜福；他們幾時起來就必蒙羞，你的僕人卻要歡喜。',
    '詩109:29 願我的對頭披戴羞辱！願他們以自己的羞愧為外袍遮身！',
    '詩109:30 我要用口極力稱謝耶和華；我要在眾人中間讚美他；',
    '詩109:31 因為他必站在窮乏人的右邊，要救他脫離審判他靈魂的人。',
    '詩110:1 （大衛的詩。）耶和華對我主說：你坐在我的右邊，等我使你仇敵作你的腳凳。',
    '詩110:2 耶和華必使你從錫安伸出能力的杖來；你要在你仇敵中掌權。',
    '詩110:3 當你掌權的日子（或譯：行軍的日子），你的民要以聖潔的妝飾為衣（或譯：以聖潔為妝飾），甘心犧牲自己；你的民多如清晨的甘露（或譯：你少年時光耀如清晨的甘露）。',
    '詩110:4 耶和華起了誓，決不後悔，說：你是照著麥基洗德的等次永遠為祭司。',
    '詩110:5 在你右邊的主，當他發怒的日子，必打傷列王。',
    '詩110:6 他要在列邦中刑罰惡人，屍首就遍滿各處；他要在許多國中打破仇敵的頭。',
    '詩110:7 他要喝路旁的河水，因此必擡起頭來。',
    '詩111:1 你們要讚美耶和華！我要在正直人的大會中，並公會中，一心稱謝耶和華。',
    '詩111:2 耶和華的作為本為大；凡喜愛的都必考察。',
    '詩111:3 他所行的是尊榮和威嚴；他的公義存到永遠。',
    '詩111:4 他行了奇事，使人記念；耶和華有恩惠，有憐憫。',
    '詩111:5 他賜糧食給敬畏他的人；他必永遠記念他的約。',
    '詩111:6 他向百姓顯出大能的作為，把外邦的地賜給他們為業。',
    '詩111:7 他手所行的是誠實公平；他的訓詞都是確實的，',
    '詩111:8 是永永遠遠堅定的，是按誠實正直設立的。',
    '詩111:9 他向百姓施行救贖，命定他的約，直到永遠；他的名聖而可畏。',
    '詩111:10 敬畏耶和華是智慧的開端；凡遵行他命令的是聰明人。耶和華是永遠當讚美的！',
    '詩112:1 你們要讚美耶和華！敬畏耶和華，甚喜愛他命令的，這人便為有福！',
    '詩112:2 他的後裔在世必強盛；正直人的後代必要蒙福。',
    '詩112:3 他家中有貨物，有錢財；他的公義存到永遠。',
    '詩112:4 正直人在黑暗中，有光向他發現；他有恩惠，有憐憫，有公義。',
    '詩112:5 施恩與人、借貸與人的，這人事情順利；他被審判的時候要訴明自己的冤。',
    '詩112:6 他永不動搖；義人被記念，直到永遠。',
    '詩112:7 他必不怕凶惡的信息；他心堅定，倚靠耶和華。',
    '詩112:8 他心確定，總不懼怕，直到他看見敵人遭報。',
    '詩112:9 他施捨錢財，賙濟貧窮；他的仁義存到永遠。他的角必被高舉，大有榮耀。',
    '詩112:10 惡人看見便惱恨，必咬牙而消化；惡人的心願要歸滅絕。',
    '詩113:1 你們要讚美耶和華！耶和華的僕人哪，你們要讚美，讚美耶和華的名！',
    '詩113:2 耶和華的名是應當稱頌的，從今時直到永遠！',
    '詩113:3 從日出之地到日落之處，耶和華的名是應當讚美的！',
    '詩113:4 耶和華超乎萬民之上；他的榮耀高過諸天。',
    '詩113:5 誰像耶和華─我們的神呢﹖他坐在至高之處，',
    '詩113:6 自己謙卑，觀看天上地下的事。',
    '詩113:7 他從灰塵裡擡舉貧寒人，從糞堆中提拔窮乏人，',
    '詩113:8 使他們與王子同坐，就是與本國的王子同坐。',
    '詩113:9 他使不能生育的婦人安居家中，為多子的樂母。你們要讚美耶和華！',
    '詩114:1 以色列出了埃及，雅各家離開說異言之民；',
    '詩114:2 那時，猶大為主的聖所，以色列為他所治理的國度。',
    '詩114:3 滄海看見就奔逃；約但河也倒流。',
    '詩114:4 大山踴躍，如公羊；小山跳舞，如羊羔。',
    '詩114:5 滄海啊，你為何奔逃﹖約但哪，你為何倒流﹖',
    '詩114:6 大山哪，你為何踴躍，如公羊﹖小山哪，你為何跳舞，如羊羔﹖',
    '詩114:7 大地啊，你因見主的面，就是雅各神的面，便要震動。',
    '詩114:8 他叫磐石變為水池，叫堅石變為泉源。',
    '詩115:1 耶和華啊，榮耀不要歸與我們，不要歸與我們；要因你的慈愛和誠實歸在你的名下！',
    '詩115:2 為何容外邦人說：他們的神在哪裡呢﹖',
    '詩115:3 然而，我們的神在天上，都隨自己的意旨行事。',
    '詩115:4 他們的偶像是金的，銀的，是人手所造的，',
    '詩115:5 有口卻不能言，有眼卻不能看，',
    '詩115:6 有耳卻不能聽，有鼻卻不能聞，',
    '詩115:7 有手卻不能摸，有腳卻不能走，有喉嚨也不能出聲。',
    '詩115:8 造他的要和他一樣；凡靠他的也要如此。',
    '詩115:9 以色列啊，你要倚靠耶和華！他是你的幫助和你的盾牌。',
    '詩115:10 亞倫家啊，你們要倚靠耶和華！他是你們的幫助和你們的盾牌。',
    '詩115:11 你們敬畏耶和華的，要倚靠耶和華！他是你們的幫助和你們的盾牌。',
    '詩115:12 耶和華向來眷念我們；他還要賜福給我們：要賜福給以色列的家，賜福給亞倫的家。',
    '詩115:13 凡敬畏耶和華的，無論大小，主必賜福給他。',
    '詩115:14 願耶和華叫你們和你們的子孫日見加增。',
    '詩115:15 你們蒙了造天地之耶和華的福！',
    '詩115:16 天，是耶和華的天；地，他卻給了世人。',
    '詩115:17 死人不能讚美耶和華；下到寂靜中的也都不能。',
    '詩115:18 但我們要稱頌耶和華，從今時直到永遠。你們要讚美耶和華！',
    '詩116:1 我愛耶和華，因為他聽了我的聲音和我的懇求。',
    '詩116:2 他既向我側耳，我一生要求告他。',
    '詩116:3 死亡的繩索纏繞我；陰間的痛苦抓住我；我遭遇患難愁苦。',
    '詩116:4 那時，我便求告耶和華的名，說：耶和華啊，求你救我的靈魂！',
    '詩116:5 耶和華有恩惠，有公義；我們的神以憐憫為懷。',
    '詩116:6 耶和華保護愚人；我落到卑微的地步，他救了我。',
    '詩116:7 我的心哪！你要仍歸安樂，因為耶和華用厚恩待你。',
    '詩116:8 主啊，你救我的命免了死亡，救我的眼免了流淚，救我的腳免了跌倒。',
    '詩116:9 我要在耶和華面前行活人之路。',
    '詩116:10 我因信，所以如此說話；我受了極大的困苦。',
    '詩116:11 我曾急促地說：人都是說謊的！',
    '詩116:12 我拿什麼報答耶和華向我所賜的一切厚恩﹖',
    '詩116:13 我要舉起救恩的杯，稱揚耶和華的名。',
    '詩116:14 我要在他眾民面前向耶和華還我的願。',
    '詩116:15 在耶和華眼中，看聖民之死極為寶貴。',
    '詩116:16 耶和華啊，我真是你的僕人；我是你的僕人，是你婢女的兒子。你已經解開我的綁索。',
    '詩116:17 我要以感謝為祭獻給你，又要求告耶和華的名。',
    '詩116:18 我要在他眾民面前，在耶和華殿的院內，在耶路撒冷當中，向耶和華還我的願。你們要讚美耶和華！',
    '詩116:19 併於上節。',
    '詩117:1 萬國啊，你們都當讚美耶和華！萬民哪，你們都當頌讚他！',
    '詩117:2 因為他向我們大施慈愛；耶和華的誠實存到永遠。你們要讚美耶和華！',
    '詩118:1 你們要稱謝耶和華，因他本為善；他的慈愛永遠長存！',
    '詩118:2 願以色列說：他的慈愛永遠長存！',
    '詩118:3 願亞倫的家說：他的慈愛永遠長存！',
    '詩118:4 願敬畏耶和華的說：他的慈愛永遠長存！',
    '詩118:5 我在急難中求告耶和華，他就應允我，把我安置在寬闊之地。',
    '詩118:6 有耶和華幫助我，我必不懼怕，人能把我怎麼樣呢﹖',
    '詩118:7 在那幫助我的人中，有耶和華幫助我，所以我要看見那恨我的人遭報。',
    '詩118:8 投靠耶和華，強似倚賴人；',
    '詩118:9 投靠耶和華，強似倚賴王子。',
    '詩118:10 萬民圍繞我，我靠耶和華的名必剿滅他們。',
    '詩118:11 他們環繞我，圍困我，我靠耶和華的名必剿滅他們。',
    '詩118:12 他們如同蜂子圍繞我，好像燒荊棘的火，必被熄滅；我靠耶和華的名，必剿滅他們。',
    '詩118:13 你推我，要叫我跌倒，但耶和華幫助了我。',
    '詩118:14 耶和華是我的力量，是我的詩歌；他也成了我的拯救。',
    '詩118:15 在義人的帳棚裡，有歡呼拯救的聲音；耶和華的右手施展大能。',
    '詩118:16 耶和華的右手高舉；耶和華的右手施展大能。',
    '詩118:17 我必不致死，仍要存活，並要傳揚耶和華的作為。',
    '詩118:18 耶和華雖嚴嚴地懲治我，卻未曾將我交於死亡。',
    '詩118:19 給我敞開義門；我要進去稱謝耶和華！',
    '詩118:20 這是耶和華的門；義人要進去！',
    '詩118:21 我要稱謝你，因為你已經應允我，又成了我的拯救！',
    '詩118:22 匠人所棄的石頭已成了房角的頭塊石頭。',
    '詩118:23 這是耶和華所做的，在我們眼中看為希奇。',
    '詩118:24 這是耶和華所定的日子，我們在其中要高興歡喜！',
    '詩118:25 耶和華啊，求你拯救！耶和華啊，求你使我們亨通！',
    '詩118:26 奉耶和華名來的是應當稱頌的！我們從耶和華的殿中為你們祝福！',
    '詩118:27 耶和華是神；他光照了我們。理當用繩索把祭牲拴住，牽到壇角那裡。',
    '詩118:28 你是我的神，我要稱謝你！你是我的神，我要尊崇你！',
    '詩118:29 你們要稱謝耶和華，因他本為善；他的慈愛永遠長存！',
    '詩119:1 行為完全、遵行耶和華律法的，這人便為有福！',
    '詩119:2 遵守他的法度、一心尋求他的，這人便為有福！',
    '詩119:3 這人不做非義的事，但遵行他的道。',
    '詩119:4 耶和華啊，你曾將你的訓詞吩咐我們，為要我們殷勤遵守。',
    '詩119:5 但願我行事堅定，得以遵守你的律例。',
    '詩119:6 我看重你的一切命令，就不至於羞愧。',
    '詩119:7 我學了你公義的判語，就要以正直的心稱謝你。',
    '詩119:8 我必守你的律例；求你總不要丟棄我！',
    '詩119:9 少年人用什麼潔淨他的行為呢﹖是要遵行你的話！',
    '詩119:10 我一心尋求了你；求你不要叫我偏離你的命令。',
    '詩119:11 我將你的話藏在心裡，免得我得罪你。',
    '詩119:12 耶和華啊，你是應當稱頌的！求你將你的律例教訓我！',
    '詩119:13 我用嘴唇傳揚你口中的一切典章。',
    '詩119:14 我喜悅你的法度，如同喜悅一切的財物。',
    '詩119:15 我要默想你的訓詞，看重你的道路。',
    '詩119:16 我要在你的律例中自樂；我不忘記你的話。',
    '詩119:17 求你用厚恩待你的僕人，使我存活，我就遵守你的話。',
    '詩119:18 求你開我的眼睛，使我看出你律法中的奇妙。',
    '詩119:19 我是在地上作寄居的；求你不要向我隱瞞你的命令！',
    '詩119:20 我時常切慕你的典章，甚至心碎。',
    '詩119:21 受咒詛、偏離你命令的驕傲人，你已經責備他們。',
    '詩119:22 求你除掉我所受的羞辱和藐視，因我遵守你的法度。',
    '詩119:23 雖有首領坐著妄論我，你僕人卻思想你的律例。',
    '詩119:24 你的法度是我所喜樂的，是我的謀士。',
    '詩119:25 我的性命幾乎歸於塵土；求你照你的話將我救活！',
    '詩119:26 我述說我所行的，你應允了我；求你將你的律例教訓我！',
    '詩119:27 求你使我明白你的訓詞，我就思想你的奇事。',
    '詩119:28 我的心因愁苦而消化；求你照你的話使我堅立！',
    '詩119:29 求你使我離開奸詐的道，開恩將你的律法賜給我！',
    '詩119:30 我揀選了忠信的道，將你的典章擺在我面前。',
    '詩119:31 我持守你的法度；耶和華啊，求你不要叫我羞愧！',
    '詩119:32 你開廣我心的時候，我就往你命令的道上直奔。',
    '詩119:33 耶和華啊，求你將你的律例指教我，我必遵守到底！',
    '詩119:34 求你賜我悟性，我便遵守你的律法，且要一心遵守。',
    '詩119:35 求你叫我遵行你的命令，因為這是我所喜樂的。',
    '詩119:36 求你使我的心趨向你的法度，不趨向非義之財。',
    '詩119:37 求你叫我轉眼不看虛假，又叫我在你的道中生活。',
    '詩119:38 你向敬畏你的人所應許的話，求你向僕人堅定！',
    '詩119:39 求你使我所怕的羞辱遠離我，因你的典章本為美。',
    '詩119:40 我羨慕你的訓詞；求你使我在你的公義上生活！',
    '詩119:41 耶和華啊，願你照你的話，使你的慈愛，就是你的救恩，臨到我身上，',
    '詩119:42 我就有話回答那羞辱我的，因我倚靠你的話。',
    '詩119:43 求你叫真理的話總不離開我口，因我仰望你的典章。',
    '詩119:44 我要常守你的律法，直到永永遠遠。',
    '詩119:45 我要自由而行（或譯：我要行在寬闊之地），因我素來考究你的訓詞。',
    '詩119:46 我也要在君王面前論說你的法度，並不至於羞愧。',
    '詩119:47 我要在你的命令中自樂；這命令素來是我所愛的。',
    '詩119:48 我又要遵行（原文是舉手）你的命令，這命令素來是我所愛的；我也要思想你的律例。',
    '詩119:49 求你記念向你僕人所應許的話，叫我有盼望。',
    '詩119:50 這話將我救活了；我在患難中，因此得安慰。',
    '詩119:51 驕傲的人甚侮慢我，我卻未曾偏離你的律法。',
    '詩119:52 耶和華啊，我記念你從古以來的典章，就得了安慰。',
    '詩119:53 我見惡人離棄你的律法，就怒氣發作，猶如火燒。',
    '詩119:54 我在世寄居，素來以你的律例為詩歌。',
    '詩119:55 耶和華啊，我夜間記念你的名，遵守你的律法。',
    '詩119:56 我所以如此，是因我守你的訓詞。',
    '詩119:57 耶和華是我的福分；我曾說，我要遵守你的言語。',
    '詩119:58 我一心求過你的恩；願你照你的話憐憫我！',
    '詩119:59 我思想我所行的道，就轉步歸向你的法度。',
    '詩119:60 我急忙遵守你的命令，並不遲延。',
    '詩119:61 惡人的繩索纏繞我，我卻沒有忘記你的律法。',
    '詩119:62 我因你公義的典章，半夜必起來稱謝你。',
    '詩119:63 凡敬畏你、守你訓詞的人，我都與他作伴。',
    '詩119:64 耶和華啊，你的慈愛遍滿大地；求你將你的律例教訓我！',
    '詩119:65 耶和華啊，你向來是照你的話善待僕人。',
    '詩119:66 求你將精明和知識賜給我，因我信了你的命令。',
    '詩119:67 我未受苦以先走迷了路，現在卻遵守你的話。',
    '詩119:68 你本為善，所行的也善；求你將你的律例教訓我！',
    '詩119:69 驕傲人編造謊言攻擊我，我卻要一心守你的訓詞。',
    '詩119:70 他們心蒙脂油，我卻喜愛你的律法。',
    '詩119:71 我受苦是於我有益，為要使我學習你的律例。',
    '詩119:72 你口中的訓言（或譯：律法）於我有益，勝於千萬的金銀。',
    '詩119:73 你的手製造我，建立我；求你賜我悟性，可以學習你的命令！',
    '詩119:74 敬畏你的人見我就要歡喜，因我仰望你的話。',
    '詩119:75 耶和華啊，我知道你的判語是公義的；你使我受苦是以誠實待我。',
    '詩119:76 求你照著應許僕人的話，以慈愛安慰我。',
    '詩119:77 願你的慈悲臨到我，使我存活，因你的律法是我所喜愛的。',
    '詩119:78 願驕傲人蒙羞，因為他們無理地傾覆我；但我要思想你的訓詞。',
    '詩119:79 願敬畏你的人歸向我，他們就知道你的法度。',
    '詩119:80 願我的心在你的律例上完全，使我不致蒙羞。',
    '詩119:81 我心渴想你的救恩，仰望你的應許。',
    '詩119:82 我因盼望你的應許眼睛失明，說：你何時安慰我﹖',
    '詩119:83 我好像煙薰的皮袋，卻不忘記你的律例。',
    '詩119:84 你僕人的年日有多少呢﹖你幾時向逼迫我的人施行審判呢﹖',
    '詩119:85 不從你律法的驕傲人為我掘了坑。',
    '詩119:86 你的命令盡都誠實；他們無理地逼迫我，求你幫助我！',
    '詩119:87 他們幾乎把我從世上滅絕，但我沒有離棄你的訓詞。',
    '詩119:88 求你照你的慈愛將我救活，我就遵守你口中的法度。',
    '詩119:89 耶和華啊，你的話安定在天，直到永遠。',
    '詩119:90 你的誠實存到萬代；你堅定了地，地就長存。',
    '詩119:91 天地照你的安排存到今日；萬物都是你的僕役。',
    '詩119:92 我若不是喜愛你的律法，早就在苦難中滅絕了！',
    '詩119:93 我永不忘記你的訓詞，因你用這訓詞將我救活了。',
    '詩119:94 我是屬你的，求你救我，因我尋求了你的訓詞。',
    '詩119:95 惡人等待我，要滅絕我，我卻要揣摩你的法度。',
    '詩119:96 我看萬事盡都有限，惟有你的命令極其寬廣。',
    '詩119:97 我何等愛慕你的律法，終日不住地思想。',
    '詩119:98 你的命令常存在我心裡，使我比仇敵有智慧。',
    '詩119:99 我比我的師傅更通達，因我思想你的法度。',
    '詩119:100 我比年老的更明白，因我守了你的訓詞。',
    '詩119:101 我禁止我腳走一切的邪路，為要遵守你的話。',
    '詩119:102 我沒有偏離你的典章，因為你教訓了我。',
    '詩119:103 你的言語在我上膛何等甘美，在我口中比蜜更甜！',
    '詩119:104 我藉著你的訓詞得以明白，所以我恨一切的假道。',
    '詩119:105 你的話是我腳前的燈，是我路上的光。',
    '詩119:106 你公義的典章，我曾起誓遵守，我必按誓而行。',
    '詩119:107 我甚是受苦；耶和華啊，求你照你的話將我救活！',
    '詩119:108 耶和華啊，求你悅納我口中的讚美為供物，又將你的典章教訓我！',
    '詩119:109 我的性命常在危險之中，我卻不忘記你的律法。',
    '詩119:110 惡人為我設下網羅，我卻沒有偏離你的訓詞。',
    '詩119:111 我以你的法度為永遠的產業，因這是我心中所喜愛的。',
    '詩119:112 我的心專向你的律例，永遠遵行，一直到底。',
    '詩119:113 心懷二意的人為我所恨；但你的律法為我所愛。',
    '詩119:114 你是我藏身之處，又是我的盾牌；我甚仰望你的話語。',
    '詩119:115 作惡的人哪，你們離開我吧！我好遵守我神的命令。',
    '詩119:116 求你照你的話扶持我，使我存活，也不叫我因失望而害羞。',
    '詩119:117 求你扶持我，我便得救，時常看重你的律例。',
    '詩119:118 凡偏離你律例的人，你都輕棄他們，因為他們的詭詐必歸虛空。',
    '詩119:119 凡地上的惡人，你除掉他，好像除掉渣滓；因此我愛你的法度。',
    '詩119:120 我因懼怕你，肉就發抖；我也怕你的判語。',
    '詩119:121 我行過公平和公義，求你不要撇下我給欺壓我的人！',
    '詩119:122 求你為僕人作保，使我得好處，不容驕傲人欺壓我！',
    '詩119:123 我因盼望你的救恩和你公義的話眼睛失明。',
    '詩119:124 求你照你的慈愛待僕人，將你的律例教訓我。',
    '詩119:125 我是你的僕人，求你賜我悟性，使我得知你的法度。',
    '詩119:126 這是耶和華降罰的時候，因人廢了你的律法。',
    '詩119:127 所以，我愛你的命令勝於金子，更勝於精金。',
    '詩119:128 你一切的訓詞，在萬事上我都以為正直；我卻恨惡一切假道。',
    '詩119:129 你的法度奇妙，所以我一心謹守。',
    '詩119:130 你的言語一解開就發出亮光，使愚人通達。',
    '詩119:131 我張口而氣喘，因我切慕你的命令。',
    '詩119:132 求你轉向我，憐憫我，好像你素常待那些愛你名的人。',
    '詩119:133 求你用你的話使我腳步穩當，不許什麼罪孽轄制我。',
    '詩119:134 求你救我脫離人的欺壓，我要遵守你的訓詞。',
    '詩119:135 求你用臉光照僕人，又將你的律例教訓我。',
    '詩119:136 我的眼淚下流成河，因為他們不守你的律法。',
    '詩119:137 耶和華啊，你是公義的；你的判語也是正直的！',
    '詩119:138 你所命定的法度是憑公義和至誠。',
    '詩119:139 我心焦急，如同火燒，因我敵人忘記你的言語。',
    '詩119:140 你的話極其精煉，所以你的僕人喜愛。',
    '詩119:141 我微小，被人藐視，卻不忘記你的訓詞。',
    '詩119:142 你的公義永遠長存；你的律法盡都真實。',
    '詩119:143 我遭遇患難愁苦，你的命令卻是我所喜愛的。',
    '詩119:144 你的法度永遠是公義的；求你賜我悟性，我就活了。',
    '詩119:145 耶和華啊，我一心呼籲你；求你應允我，我必謹守你的律例！',
    '詩119:146 我向你呼籲，求你救我！我要遵守你的法度。',
    '詩119:147 我趁天未亮呼求；我仰望了你的言語。',
    '詩119:148 我趁夜更未換將眼睜開，為要思想你的話語。',
    '詩119:149 求你照你的慈愛聽我的聲音；耶和華啊，求你照你的典章將我救活！',
    '詩119:150 追求奸惡的人臨近了；他們遠離你的律法。',
    '詩119:151 耶和華啊，你與我相近；你一切的命令盡都真實！',
    '詩119:152 我因學你的法度，久已知道是你永遠立定的。',
    '詩119:153 求你看顧我的苦難，搭救我，因我不忘記你的律法。',
    '詩119:154 求你為我辨屈，救贖我，照你的話將我救活。',
    '詩119:155 救恩遠離惡人，因為他們不尋求你的律例。',
    '詩119:156 耶和華啊，你的慈悲本為大；求你照你的典章將我救活。',
    '詩119:157 逼迫我的，抵擋我的，很多，我卻沒有偏離你的法度。',
    '詩119:158 我看見奸惡的人就甚憎惡，因為他們不遵守你的話。',
    '詩119:159 你看我怎樣愛你的訓詞！耶和華啊，求你照你的慈愛將我救活！',
    '詩119:160 你話的總綱是真實；你一切公義的典章是永遠長存。',
    '詩119:161 首領無故地逼迫我，但我的心畏懼你的言語。',
    '詩119:162 我喜愛你的話，好像人得了許多擄物。',
    '詩119:163 謊話是我所恨惡所憎嫌的；惟你的律法是我所愛的。',
    '詩119:164 我因你公義的典章一天七次讚美你。',
    '詩119:165 愛你律法的人有大平安，什麼都不能使他們絆腳。',
    '詩119:166 耶和華啊，我仰望了你的救恩，遵行了你的命令。',
    '詩119:167 我心裡守了你的法度；這法度我甚喜愛。',
    '詩119:168 我遵守了你的訓詞和法度，因我一切所行的都在你面前。',
    '詩119:169 耶和華啊，願我的呼籲達到你面前，照你的話賜我悟性。',
    '詩119:170 願我的懇求達到你面前，照你的話搭救我。',
    '詩119:171 願我的嘴發出讚美的話，因為你將律例教訓我。',
    '詩119:172 願我的舌頭歌唱你的話，因你一切的命令盡都公義。',
    '詩119:173 願你用手幫助我，因我揀選了你的訓詞。',
    '詩119:174 耶和華啊，我切慕你的救恩！你的律法也是我所喜愛的。',
    '詩119:175 願我的性命存活，得以讚美你！願你的典章幫助我！',
    '詩119:176 我如亡羊走迷了路，求你尋找僕人，因我不忘記你的命令。',
    '詩120:1 （上行（或作登階，下同）之詩。）我在急難中求告耶和華，他就應允我。',
    '詩120:2 耶和華啊，求你救我脫離說謊的嘴唇和詭詐的舌頭！',
    '詩120:3 詭詐的舌頭啊，要給你什麼呢﹖要拿什麼加給你呢﹖',
    '詩120:4 就是勇士的利箭和羅騰木（小樹名，松類）的炭火。',
    '詩120:5 我寄居在米設，住在基達帳棚之中，有禍了！',
    '詩120:6 我與那恨惡和睦的人許久同住。',
    '詩120:7 我願和睦，但我發言，他們就要爭戰。',
    '詩121:1 （上行之詩。）我要向山舉目；我的幫助從何而來﹖',
    '詩121:2 我的幫助從造天地的耶和華而來。',
    '詩121:3 他必不叫你的腳搖動；保護你的必不打盹！',
    '詩121:4 保護以色列的，也不打盹也不睡覺。',
    '詩121:5 保護你的是耶和華；耶和華在你右邊蔭庇你。',
    '詩121:6 白日，太陽必不傷你；夜間，月亮必不害你。',
    '詩121:7 耶和華要保護你，免受一切的災害；他要保護你的性命。',
    '詩121:8 你出你入，耶和華要保護你，從今時直到永遠。',
    '詩122:1 （大衛上行之詩。）人對我說：我們往耶和華的殿去，我就歡喜。',
    '詩122:2 耶路撒冷啊，我們的腳站在你的門內。',
    '詩122:3 耶路撒冷被建造，如同連絡整齊的一座城。',
    '詩122:4 眾支派，就是耶和華的支派，上那裡去，按以色列的常例（或譯：作以色列的證據）稱讚耶和華的名。',
    '詩122:5 因為在那裡設立審判的寶座，就是大衛家的寶座。',
    '詩122:6 你們要為耶路撒冷求平安！耶路撒冷啊，愛你的人必然興旺！',
    '詩122:7 願你城中平安！願你宮內興旺！',
    '詩122:8 因我弟兄和同伴的緣故，我要說：願平安在你中間！',
    '詩122:9 因耶和華─我們神殿的緣故，我要為你求福！',
    '詩123:1 （上行之詩。）坐在天上的主啊，我向你舉目。',
    '詩123:2 看哪，僕人的眼睛怎樣望主人的手，使女的眼睛怎樣望主母的手，我們的眼睛也照樣望耶和華─我們的神，直到他憐憫我們。',
    '詩123:3 耶和華啊，求你憐憫我們，憐憫我們！因為我們被藐視，已到極處。',
    '詩123:4 我們被那些安逸人的譏誚和驕傲人的藐視，已到極處。',
    '詩124:1 （大衛上行之詩。）以色列人要說：若不是耶和華幫助我們，',
    '詩124:2 若不是耶和華幫助我們，當人起來攻擊我們、',
    '詩124:3 向我們發怒的時候，就把我們活活地吞了。',
    '詩124:4 那時，波濤必漫過我們，河水必淹沒我們，',
    '詩124:5 狂傲的水必淹沒我們。',
    '詩124:6 耶和華是應當稱頌的！他沒有把我們當野食交給他們吞吃（原文是牙齒）。',
    '詩124:7 我們好像雀鳥，從捕鳥人的網羅裡逃脫；網羅破裂，我們逃脫了。',
    '詩124:8 我們得幫助，是在乎倚靠造天地之耶和華的名。',
    '詩125:1 （上行之詩。）倚靠耶和華的人好像錫安山，永不動搖。',
    '詩125:2 眾山怎樣圍繞耶路撒冷，耶和華也照樣圍繞他的百姓，從今時直到永遠。',
    '詩125:3 惡人的杖不常落在義人的分上，免得義人伸手作惡。',
    '詩125:4 耶和華啊，求你善待那些為善和心裡正直的人。',
    '詩125:5 至於那偏行彎曲道路的人，耶和華必使他和作惡的人一同出去受刑。願平安歸於以色列！',
    '詩126:1 （上行之詩。）當耶和華將那些被擄的帶回錫安的時候，我們好像做夢的人。',
    '詩126:2 我們滿口喜笑、滿舌歡呼的時候，外邦中就有人說：耶和華為他們行了大事！',
    '詩126:3 耶和華果然為我們行了大事，我們就歡喜。',
    '詩126:4 耶和華啊，求你使我們被擄的人歸回，好像南地的河水復流。',
    '詩126:5 流淚撒種的，必歡呼收割！',
    '詩126:6 那帶種流淚出去的，必要歡歡樂樂地帶禾捆回來！',
    '詩127:1 （所羅門上行之詩。）若不是耶和華建造房屋，建造的人就枉然勞力；若不是耶和華看守城池，看守的人就枉然警醒。',
    '詩127:2 你們清晨早起，夜晚安歇，吃勞碌得來的飯，本是枉然；惟有耶和華所親愛的，必叫他安然睡覺。',
    '詩127:3 兒女是耶和華所賜的產業；所懷的胎是他所給的賞賜。',
    '詩127:4 少年時所生的兒女好像勇士手中的箭。',
    '詩127:5 箭袋充滿的人便為有福；他們在城門口和仇敵說話的時候，必不至於羞愧。',
    '詩128:1 （上行之詩。）凡敬畏耶和華、遵行他道的人便為有福！',
    '詩128:2 你要吃勞碌得來的；你要享福，事情順利。',
    '詩128:3 你妻子在你的內室，好像多結果子的葡萄樹；你兒女圍繞你的桌子，好像橄欖栽子。',
    '詩128:4 看哪，敬畏耶和華的人必要這樣蒙福！',
    '詩128:5 願耶和華從錫安賜福給你！願你一生一世看見耶路撒冷的好處！',
    '詩128:6 願你看見你兒女的兒女！願平安歸於以色列！',
    '詩129:1 （上行之詩。）以色列當說：從我幼年以來，敵人屢次苦害我，',
    '詩129:2 從我幼年以來，敵人屢次苦害我，卻沒有勝了我。',
    '詩129:3 如同扶犁的在我背上扶犁而耕，耕的犁溝甚長。',
    '詩129:4 耶和華是公義的；他砍斷了惡人的繩索。',
    '詩129:5 願恨惡錫安的都蒙羞退後！',
    '詩129:6 願他們像房頂上的草，未長成而枯乾，',
    '詩129:7 收割的不夠一把，捆禾的也不滿懷。',
    '詩129:8 過路的也不說：願耶和華所賜的福歸與你們！我們奉耶和華的名給你們祝福！',
    '詩130:1 （上行之詩。）耶和華啊，我從深處向你求告！',
    '詩130:2 主啊，求你聽我的聲音！願你側耳聽我懇求的聲音！',
    '詩130:3 主─耶和華啊，你若究察罪孽，誰能站得住呢﹖',
    '詩130:4 但在你有赦免之恩，要叫人敬畏你。',
    '詩130:5 我等候耶和華，我的心等候；我也仰望他的話。',
    '詩130:6 我的心等候主，勝於守夜的，等候天亮，勝於守夜的，等候天亮。',
    '詩130:7 以色列啊，你當仰望耶和華！因他有慈愛，有豐盛的救恩。',
    '詩130:8 他必救贖以色列脫離一切的罪孽。',
    '詩131:1 （大衛上行之詩。）耶和華啊，我的心不狂傲，我的眼不高大；重大和測不透的事，我也不敢行。',
    '詩131:2 我的心平穩安靜，好像斷過奶的孩子在他母親的懷中；我的心在我裡面真像斷過奶的孩子。',
    '詩131:3 以色列啊，你當仰望耶和華，從今時直到永遠！',
    '詩132:1 （上行之詩。）耶和華啊，求你記念大衛所受的一切苦難！',
    '詩132:2 他怎樣向耶和華起誓，向雅各的大能者許願，',
    '詩132:3 說：我必不進我的帳幕，也不上我的床榻；',
    '詩132:4 我不容我的眼睛睡覺，也不容我的眼目打盹；',
    '詩132:5 直等我為耶和華尋得所在，為雅各的大能者尋得居所。',
    '詩132:6 我們聽說約櫃在以法他，我們在基列‧耶琳就尋見了。',
    '詩132:7 我們要進他的居所，在他腳凳前下拜。',
    '詩132:8 耶和華啊，求你興起，和你有能力的約櫃同入安息之所！',
    '詩132:9 願你的祭司披上公義！願你的聖民歡呼！',
    '詩132:10 求你因你僕人大衛的緣故，不要厭棄你的受膏者！',
    '詩132:11 耶和華向大衛、憑誠實起了誓，必不反覆，說：我要使你所生的坐在你的寶座上。',
    '詩132:12 你的眾子若守我的約和我所教訓他們的法度，他們的子孫必永遠坐在你的寶座上。',
    '詩132:13 因為耶和華揀選了錫安，願意當作自己的居所，',
    '詩132:14 說：這是我永遠安息之所；我要住在這裡，因為是我所願意的。',
    '詩132:15 我要使其中的糧食豐滿，使其中的窮人飽足。',
    '詩132:16 我要使祭司披上救恩，聖民大聲歡呼！',
    '詩132:17 我要叫大衛的角在那裡發生；我為我的受膏者預備明燈。',
    '詩132:18 我要使他的仇敵披上羞恥；但他的冠冕要在頭上發光。',
    '詩133:1 （大衛上行之詩。）看哪，弟兄和睦同居是何等地善，何等地美！',
    '詩133:2 這好比那貴重的油澆在亞倫的頭上，流到鬍鬚，又流到他的衣襟；',
    '詩133:3 又好比黑門的甘露降在錫安山；因為在那裡有耶和華所命定的福，就是永遠的生命。',
    '詩134:1 （上行之詩。）耶和華的僕人夜間站在耶和華殿中的，你們當稱頌耶和華！',
    '詩134:2 你們當向聖所舉手，稱頌耶和華！',
    '詩134:3 願造天地的耶和華，從錫安賜福給你們！',
    '詩135:1 你們要讚美耶和華！你們要讚美耶和華的名！耶和華的僕人站在耶和華殿中；站在我們神殿院中的，你們要讚美他！',
    '詩135:2 併於上節。',
    '詩135:3 你們要讚美耶和華！耶和華本為善；要歌頌他的名，因為這是美好的。',
    '詩135:4 耶和華揀選雅各歸自己，揀選以色列特作自己的子民。',
    '詩135:5 原來我知道耶和華為大，也知道我們的主超乎萬神之上。',
    '詩135:6 耶和華在天上，在地下，在海中，在一切的深處，都隨自己的意旨而行。',
    '詩135:7 他使雲霧從地極上騰，造電隨雨而閃，從府庫中帶出風來。',
    '詩135:8 他將埃及頭生的，連人帶牲畜都擊殺了。',
    '詩135:9 埃及啊，他施行神蹟奇事，在你當中，在法老和他一切臣僕身上。',
    '詩135:10 他擊殺許多的民，又殺戮大能的王，',
    '詩135:11 就是亞摩利王西宏和巴珊王噩，並迦南一切的國王，',
    '詩135:12 將他們的地賞賜他的百姓以色列為業。',
    '詩135:13 耶和華啊，你的名存到永遠！耶和華啊，你可記念的名存到萬代！',
    '詩135:14 耶和華要為他的百姓伸冤，為他的僕人後悔。',
    '詩135:15 外邦的偶像是金的，銀的，是人手所造的；',
    '詩135:16 有口卻不能言，有眼卻不能看，',
    '詩135:17 有耳卻不能聽，口中也沒有氣息。',
    '詩135:18 造他的要和他一樣，凡靠他的也要如此。',
    '詩135:19 以色列家啊，你們要稱頌耶和華！亞倫家啊，你們要稱頌耶和華！',
    '詩135:20 利未家啊，你們要稱頌耶和華！你們敬畏耶和華的，要稱頌耶和華！',
    '詩135:21 住在耶路撒冷的耶和華該從錫安受稱頌。你們要讚美耶和華！',
    '詩136:1 你們要稱謝耶和華，因他本為善；他的慈愛永遠長存。',
    '詩136:2 你們要稱謝萬神之神，因他的慈愛永遠長存。',
    '詩136:3 你們要稱謝萬主之主，因他的慈愛永遠長存。',
    '詩136:4 稱謝那獨行大奇事的，因他的慈愛永遠長存。',
    '詩136:5 稱謝那用智慧造天的，因他的慈愛永遠長存。',
    '詩136:6 稱謝那鋪地在水以上的，因他的慈愛永遠長存。',
    '詩136:7 稱謝那造成大光的，因他的慈愛永遠長存。',
    '詩136:8 他造日頭管白晝，因他的慈愛永遠長存。',
    '詩136:9 他造月亮星宿管黑夜，因他的慈愛永遠長存。',
    '詩136:10 稱謝那擊殺埃及人之長子的，因他的慈愛永遠長存。',
    '詩136:11 他領以色列人從他們中間出來，因他的慈愛永遠長存。',
    '詩136:12 他施展大能的手和伸出來的膀臂，因他的慈愛永遠長存。',
    '詩136:13 稱謝那分裂紅海的，因他的慈愛永遠長存。',
    '詩136:14 他領以色列從其中經過，因他的慈愛永遠長存；',
    '詩136:15 卻把法老和他的軍兵推翻在紅海裡，因他的慈愛永遠長存。',
    '詩136:16 稱謝那引導自己的民行走曠野的，因他的慈愛永遠長存。',
    '詩136:17 稱謝那擊殺大君王的，因他的慈愛永遠長存。',
    '詩136:18 他殺戮有名的君王，因他的慈愛永遠長存；',
    '詩136:19 就是殺戮亞摩利王西宏，因他的慈愛永遠長存；',
    '詩136:20 又殺巴珊王噩，因他的慈愛永遠長存。',
    '詩136:21 他將他們的地賜他的百姓為業，因他的慈愛永遠長存；',
    '詩136:22 就是賜他的僕人以色列為業，因他的慈愛永遠長存。',
    '詩136:23 他顧念我們在卑微的地步，因他的慈愛永遠長存。',
    '詩136:24 他救拔我們脫離敵人，因他的慈愛永遠長存。',
    '詩136:25 他賜糧食給凡有血氣的，因他的慈愛永遠長存。',
    '詩136:26 你們要稱謝天上的神，因他的慈愛永遠長存。',
    '詩137:1 我們曾在巴比倫的河邊坐下，一追想錫安就哭了。',
    '詩137:2 我們把琴掛在那裡的柳樹上；',
    '詩137:3 因為在那裡，擄掠我們的要我們唱歌，搶奪我們的要我們作樂，說：給我們唱一首錫安歌吧！',
    '詩137:4 我們怎能在外邦唱耶和華的歌呢﹖',
    '詩137:5 耶路撒冷啊，我若忘記你，情願我的右手忘記技巧！',
    '詩137:6 我若不記念你，若不看耶路撒冷過於我所最喜樂的，情願我的舌頭貼於上膛！',
    '詩137:7 耶路撒冷遭難的日子，以東人說：拆毀！拆毀！直拆到根基！耶和華啊，求你記念這仇！',
    '詩137:8 將要被滅的巴比倫城啊（城：原文是女子），報復你像你待我們的，那人便為有福！',
    '詩137:9 拿你的嬰孩摔在磐石上的，那人便為有福！',
    '詩138:1 （大衛的詩。）我要一心稱謝你，在諸神面前歌頌你。',
    '詩138:2 我要向你的聖殿下拜，為你的慈愛和誠實稱讚你的名；因你使你的話顯為大，過於你所應許的（或譯：超乎你的名聲）。',
    '詩138:3 我呼求的日子，你就應允我，鼓勵我，使我心裡有能力。',
    '詩138:4 耶和華啊，地上的君王都要稱謝你，因他們聽見了你口中的言語。',
    '詩138:5 他們要歌頌耶和華的作為，因耶和華大有榮耀。',
    '詩138:6 耶和華雖高，仍看顧低微的人；他卻從遠處看出驕傲的人。',
    '詩138:7 我雖行在患難中，你必將我救活；我的仇敵發怒，你必伸手抵擋他們；你的右手也必救我。',
    '詩138:8 耶和華必成全關乎我的事；耶和華啊，你的慈愛永遠長存！求你不要離棄你手所造的。',
    '詩139:1 （大衛的詩，交與伶長。）耶和華啊，你已經鑒察我，認識我。',
    '詩139:2 我坐下，我起來，你都曉得；你從遠處知道我的意念。',
    '詩139:3 我行路，我躺臥，你都細察；你也深知我一切所行的。',
    '詩139:4 耶和華啊，我舌頭上的話，你沒有一句不知道的。',
    '詩139:5 你在我前後環繞我，按手在我身上。',
    '詩139:6 這樣的知識奇妙，是我不能測的，至高，是我不能及的。',
    '詩139:7 我往哪裡去躲避你的靈﹖我往哪裡逃、躲避你的面﹖',
    '詩139:8 我若升到天上，你在那裡；我若在陰間下榻，你也在那裡。',
    '詩139:9 我若展開清晨的翅膀，飛到海極居住，',
    '詩139:10 就是在那裡，你的手必引導我；你的右手也必扶持我。',
    '詩139:11 我若說：黑暗必定遮蔽我，我周圍的亮光必成為黑夜；',
    '詩139:12 黑暗也不能遮蔽我，使你不見，黑夜卻如白晝發亮。黑暗和光明，在你看都是一樣。',
    '詩139:13 我的肺腑是你所造的；我在母腹中，你已覆庇我。',
    '詩139:14 我要稱謝你，因我受造，奇妙可畏；你的作為奇妙，這是我心深知道的。',
    '詩139:15 我在暗中受造，在地的深處被聯絡；那時，我的形體並不向你隱藏。',
    '詩139:16 我未成形的體質，你的眼早已看見了；你所定的日子，我尚未度一日（或譯：我被造的肢體尚未有其一），你都寫在你的冊上了。',
    '詩139:17 神啊，你的意念向我何等寶貴！其數何等眾多！',
    '詩139:18 我若數點，比海沙更多；我睡醒的時候，仍和你同在。',
    '詩139:19 神啊，你必要殺戮惡人；所以，你們好流人血的，離開我去吧！',
    '詩139:20 因為他們說惡言頂撞你；你的仇敵也妄稱你的名。',
    '詩139:21 耶和華啊，恨惡你的，我豈不恨惡他們嗎﹖攻擊你的，我豈不憎嫌他們嗎﹖',
    '詩139:22 我切切地恨惡他們，以他們為仇敵。',
    '詩139:23 神啊，求你鑒察我，知道我的心思，試煉我，知道我的意念，',
    '詩139:24 看在我裡面有什麼惡行沒有，引導我走永生的道路。',
    '詩140:1 （大衛的詩，交與伶長。）耶和華啊，求你拯救我脫離凶惡的人，保護我脫離強暴的人！',
    '詩140:2 他們心中圖謀奸惡，常常聚集要爭戰。',
    '詩140:3 他們使舌頭尖利如蛇，嘴裡有虺蛇的毒氣。（細拉）',
    '詩140:4 耶和華啊，求你拯救我脫離惡人的手，保護我脫離強暴的人！他們圖謀推我跌倒。',
    '詩140:5 驕傲人為我暗設網羅和繩索；他們在路旁鋪下網，設下圈套。（細拉）',
    '詩140:6 我曾對耶和華說：你是我的神。耶和華啊，求你留心聽我懇求的聲音！',
    '詩140:7 主─耶和華、我救恩的力量啊，在爭戰的日子，你遮蔽了我的頭。',
    '詩140:8 耶和華啊，求你不要遂惡人的心願；不要成就他們的計謀，恐怕他們自高。（細拉）',
    '詩140:9 至於那些昂首圍困我的人，願他們嘴唇的奸惡陷害（原文是遮蔽）自己！',
    '詩140:10 願火炭落在他們身上！願他們被丟在火中，拋在深坑裡，不能再起來。',
    '詩140:11 說惡言的人在地上必堅立不住；禍患必獵取強暴的人，將他打倒。',
    '詩140:12 我知道耶和華必為困苦人伸冤，必為窮乏人辨屈。',
    '詩140:13 義人必要稱讚你的名；正直人必住在你面前。',
    '詩141:1 （大衛的詩。）耶和華啊，我曾求告你，求你快快臨到我這裡！我求告你的時候，願你留心聽我的聲音！',
    '詩141:2 願我的禱告如香陳列在你面前！願我舉手祈求，如獻晚祭！',
    '詩141:3 耶和華啊，求你禁止我的口，把守我的嘴！',
    '詩141:4 求你不叫我的心偏向邪惡，以致我和作孽的人同行惡事；也不叫我吃他們的美食。',
    '詩141:5 任憑義人擊打我，這算為仁慈；任憑他責備我，這算為頭上的膏油；我的頭不要躲閃。正在他們行惡的時候，我仍要祈禱。',
    '詩141:6 他們的審判官被扔在巖下；眾人要聽我的話，因為這話甘甜。',
    '詩141:7 我們的骨頭散在墓旁，好像人耕田、刨地的土塊。',
    '詩141:8 主─耶和華啊，我的眼目仰望你；我投靠你，求你不要將我撇得孤苦！',
    '詩141:9 求你保護我脫離惡人為我設的網羅和作孽之人的圈套！',
    '詩141:10 願惡人落在自己的網裡，我卻得以逃脫。',
    '詩142:1 （大衛在洞裡作的訓誨詩，乃是祈禱。）我發聲哀告耶和華，發聲懇求耶和華。',
    '詩142:2 我在他面前吐露我的苦情，陳說我的患難。',
    '詩142:3 我的靈在我裡面發昏的時候，你知道我的道路。在我行的路上，敵人為我暗設網羅。',
    '詩142:4 求你向我右邊觀看，因為沒有人認識我；我無處避難，也沒有人眷顧我。',
    '詩142:5 耶和華啊，我曾向你哀求。我說：你是我的避難所；在活人之地，你是我的福分。',
    '詩142:6 求你側耳聽我的呼求，因我落到極卑之地；求你救我脫離逼迫我的人，因為他們比我強盛。',
    '詩142:7 求你領我出離被囚之地，我好稱讚你的名。義人必環繞我，因為你是用厚恩待我。',
    '詩143:1 （大衛的詩。）耶和華啊，求你聽我的禱告，留心聽我的懇求，憑你的信實和公義應允我。',
    '詩143:2 求你不要審問僕人；因為在你面前，凡活著的人沒有一個是義的。',
    '詩143:3 原來仇敵逼迫我，將我打倒在地，使我住在幽暗之處，像死了許久的人一樣。',
    '詩143:4 所以，我的靈在我裡面發昏；我的心在我裡面悽慘。',
    '詩143:5 我追想古時之日，思想你的一切作為，默念你手的工作。',
    '詩143:6 我向你舉手；我的心渴想你，如乾旱之地盼雨一樣。（細拉）',
    '詩143:7 耶和華啊，求你速速應允我！我心神耗盡！不要向我掩面，免得我像那些下坑的人一樣。',
    '詩143:8 求你使我清晨得聽你慈愛之言，因我倚靠你；求你使我知道當行的路，因我的心仰望你。',
    '詩143:9 耶和華啊，求你救我脫離我的仇敵！我往你那裡藏身。',
    '詩143:10 求你指教我遵行你的旨意，因你是我的神。你的靈本為善；求你引我到平坦之地。',
    '詩143:11 耶和華啊，求你為你的名將我救活，憑你的公義，將我從患難中領出來，',
    '詩143:12 憑你的慈愛剪除我的仇敵，滅絕一切苦待我的人，因我是你的僕人。',
    '詩144:1 （大衛的詩。）耶和華─我的磐石是應當稱頌的！他教導我的手爭戰，教導我的指頭打仗。',
    '詩144:2 他是我慈愛的主，我的山寨，我的高臺，我的救主，我的盾牌，是我所投靠的；他使我的百姓服在我以下。',
    '詩144:3 耶和華啊，人算什麼，你竟認識他！世人算什麼，你竟顧念他！',
    '詩144:4 人好像一口氣；他的年日如同影兒快快過去。',
    '詩144:5 耶和華啊，求你使天下垂，親自降臨，摸山，山就冒煙。',
    '詩144:6 求你發出閃電，使他們四散，射出你的箭，使他們擾亂。',
    '詩144:7 求你從上伸手救拔我，救我出離大水，救我脫離外邦人的手。',
    '詩144:8 他們的口說謊話；他們的右手起假誓。',
    '詩144:9 神啊，我要向你唱新歌，用十弦瑟向你歌頌。',
    '詩144:10 你是那拯救君王的；你是那救僕人大衛脫離害命之刀的。',
    '詩144:11 求你救拔我，救我脫離外邦人的手。他們的口說謊話；他們的右手起假誓。',
    '詩144:12 我們的兒子從幼年好像樹栽子長大；我們的女兒如同殿角石，是按建宮的樣式鑿成的。',
    '詩144:13 我們的倉盈滿，能出各樣的糧食；我們的羊在田間孳生千萬。',
    '詩144:14 我們的牛馱著滿馱，沒有人闖進來搶奪，也沒有人出去爭戰；我們的街市上也沒有哭號的聲音。',
    '詩144:15 遇見這光景的百姓便為有福！有耶和華為他們的神，這百姓便為有福！',
    '詩145:1 （大衛的讚美詩。）我的神我的王啊，我要尊崇你！我要永永遠遠稱頌你的名！',
    '詩145:2 我要天天稱頌你，也要永永遠遠讚美你的名！',
    '詩145:3 耶和華本為大，該受大讚美；其大無法測度。',
    '詩145:4 這代要對那代頌讚你的作為，也要傳揚你的大能。',
    '詩145:5 我要默念你威嚴的尊榮和你奇妙的作為。',
    '詩145:6 人要傳說你可畏之事的能力；我也要傳揚你的大德。',
    '詩145:7 他們記念你的大恩就要傳出來，並要歌唱你的公義。',
    '詩145:8 耶和華有恩惠，有憐憫，不輕易發怒，大有慈愛。',
    '詩145:9 耶和華善待萬民；他的慈悲覆庇他一切所造的。',
    '詩145:10 耶和華啊，你一切所造的都要稱謝你；你的聖民也要稱頌你，',
    '詩145:11 傳說你國的榮耀，談論你的大能，',
    '詩145:12 好叫世人知道你大能的作為，並你國度威嚴的榮耀。',
    '詩145:13 你的國是永遠的國！你執掌的權柄存到萬代！',
    '詩145:14 凡跌倒的，耶和華將他們扶持；凡被壓下的，將他們扶起。',
    '詩145:15 萬民都舉目仰望你；你隨時給他們食物。',
    '詩145:16 你張手，使有生氣的都隨願飽足。',
    '詩145:17 耶和華在他一切所行的，無不公義；在他一切所做的都有慈愛。',
    '詩145:18 凡求告耶和華的，就是誠心求告他的，耶和華便與他們相近。',
    '詩145:19 敬畏他的，他必成就他們的心願，也必聽他們的呼求，拯救他們。',
    '詩145:20 耶和華保護一切愛他的人，卻要滅絕一切的惡人。',
    '詩145:21 我的口要說出讚美耶和華的話；惟願凡有血氣的都永永遠遠稱頌他的聖名。',
    '詩146:1 你們要讚美耶和華！我的心哪，你要讚美耶和華！',
    '詩146:2 我一生要讚美耶和華！我還活的時候要歌頌我的神！',
    '詩146:3 你們不要倚靠君王，不要倚靠世人；他一點不能幫助。',
    '詩146:4 他的氣一斷，就歸回塵土；他所打算的，當日就消滅了。',
    '詩146:5 以雅各的神為幫助、仰望耶和華─他神的，這人便為有福！',
    '詩146:6 耶和華造天、地、海，和其中的萬物；他守誠實，直到永遠。',
    '詩146:7 他為受屈的伸冤，賜食物與飢餓的。耶和華釋放被囚的；',
    '詩146:8 耶和華開了瞎子的眼睛；耶和華扶起被壓下的人。耶和華喜愛義人。',
    '詩146:9 耶和華保護寄居的，扶持孤兒和寡婦，卻使惡人的道路彎曲。',
    '詩146:10 耶和華要作王，直到永遠！錫安哪，你的神要作王，直到萬代！你們要讚美耶和華！',
    '詩147:1 你們要讚美耶和華！因歌頌我們的神為善為美；讚美的話是合宜的。',
    '詩147:2 耶和華建造耶路撒冷，聚集以色列中被趕散的人。',
    '詩147:3 他醫好傷心的人，裹好他們的傷處。',
    '詩147:4 他數點星宿的數目，一一稱他的名。',
    '詩147:5 我們的主為大，最有能力；他的智慧無法測度。',
    '詩147:6 耶和華扶持謙卑人，將惡人傾覆於地。',
    '詩147:7 你們要以感謝向耶和華歌唱，用琴向我們的神歌頌。',
    '詩147:8 他用雲遮天，為地降雨，使草生長在山上。',
    '詩147:9 他賜食給走獸和啼叫的小烏鴉。',
    '詩147:10 他不喜悅馬的力大，不喜愛人的腿快。',
    '詩147:11 耶和華喜愛敬畏他和盼望他慈愛的人。',
    '詩147:12 耶路撒冷啊，你要頌讚耶和華！錫安哪，你要讚美你的神！',
    '詩147:13 因為他堅固了你的門閂，賜福給你中間的兒女。',
    '詩147:14 他使你境內平安，用上好的麥子使你滿足。',
    '詩147:15 他發命在地；他的話頒行最快。',
    '詩147:16 他降雪如羊毛，撒霜如爐灰。',
    '詩147:17 他擲下冰雹如碎渣；他發出寒冷，誰能當得起呢﹖',
    '詩147:18 他一出令，這些就都消化；他使風颳起，水便流動。',
    '詩147:19 他將他的道指示雅各，將他的律例典章指示以色列。',
    '詩147:20 別國他都沒有這樣待過；至於他的典章，他們向來沒有知道。你們要讚美耶和華！',
    '詩148:1 你們要讚美耶和華！從天上讚美耶和華，在高處讚美他！',
    '詩148:2 他的眾使者都要讚美他！他的諸軍都要讚美他！',
    '詩148:3 日頭月亮，你們要讚美他！放光的星宿，你們都要讚美他！',
    '詩148:4 天上的天和天上的水，你們都要讚美他！',
    '詩148:5 願這些都讚美耶和華的名！因他一吩咐便都造成。',
    '詩148:6 他將這些立定，直到永永遠遠；他定了命，不能廢去（或譯：越過）。',
    '詩148:7 所有在地上的，大魚和一切深洋，',
    '詩148:8 火與冰雹，雪和霧氣，成就他命的狂風，',
    '詩148:9 大山和小山，結果的樹木和一切香柏樹，',
    '詩148:10 野獸和一切牲畜，昆蟲和飛鳥，',
    '詩148:11 世上的君王和萬民，首領和世上一切審判官，',
    '詩148:12 少年人和處女，老年人和孩童，都當讚美耶和華！',
    '詩148:13 願這些都讚美耶和華的名！因為獨有他的名被尊崇；他的榮耀在天地之上。',
    '詩148:14 他將他百姓的角高舉，因此他（或譯：他使）一切聖民以色列人，就是與他相近的百姓，都讚美他！你們要讚美耶和華！',
    '詩149:1 你們要讚美耶和華！向耶和華唱新歌，在聖民的會中讚美他！',
    '詩149:2 願以色列因造他的主歡喜！願錫安的民因他們的王快樂！',
    '詩149:3 願他們跳舞讚美他的名，擊鼓彈琴歌頌他！',
    '詩149:4 因為耶和華喜愛他的百姓；他要用救恩當作謙卑人的妝飾。',
    '詩149:5 願聖民因所得的榮耀高興！願他們在床上歡呼！',
    '詩149:6 願他們口中稱讚神為高，手裡有兩刃的刀，',
    '詩149:7 為要報復列邦，刑罰萬民。',
    '詩149:8 要用鍊子捆他們的君王，用鐵鐐鎖他們的大臣；',
    '詩149:9 要在他們身上施行所記錄的審判。他的聖民都有這榮耀。你們要讚美耶和華！',
    '詩150:1 你們要讚美耶和華！在神的聖所讚美他！在他顯能力的穹蒼讚美他！',
    '詩150:2 要因他大能的作為讚美他，按著他極美的大德讚美他！',
    '詩150:3 要用角聲讚美他，鼓瑟彈琴讚美他！',
    '詩150:4 擊鼓跳舞讚美他！用絲弦的樂器和簫的聲音讚美他！',
    '詩150:5 用大響的鈸讚美他！用高聲的鈸讚美他！',
    '詩150:6 凡有氣息的都要讚美耶和華！你們要讚美耶和華！',
    '箴1:1 以色列王大衛兒子所羅門的箴言：',
    '箴1:2 要使人曉得智慧和訓誨，分辨通達的言語，',
    '箴1:3 使人處事領受智慧、仁義、公平、正直的訓誨，',
    '箴1:4 使愚人靈明，使少年人有知識和謀略，',
    '箴1:5 使智慧人聽見，增長學問，使聰明人得著智謀，',
    '箴1:6 使人明白箴言和譬喻，懂得智慧人的言詞和謎語。',
    '箴1:7 敬畏耶和華是知識的開端；愚妄人藐視智慧和訓誨。',
    '箴1:8 我兒，要聽你父親的訓誨，不可離棄你母親的法則（或譯：指教）；',
    '箴1:9 因為這要作你頭上的華冠，你項上的金鍊。',
    '箴1:10 我兒，惡人若引誘你，你不可隨從。',
    '箴1:11 他們若說：你與我們同去，我們要埋伏流人之血，要蹲伏害無罪之人；',
    '箴1:12 我們好像陰間，把他們活活吞下；他們如同下坑的人，被我們囫圇吞了；',
    '箴1:13 我們必得各樣寶物，將所擄來的，裝滿房屋；',
    '箴1:14 你與我們大家同分，我們共用一個囊袋；',
    '箴1:15 我兒，不要與他們同行一道，禁止你腳走他們的路。',
    '箴1:16 因為，他們的腳奔跑行惡；他們急速流人的血，',
    '箴1:17 好像飛鳥，網羅設在眼前仍不躲避。',
    '箴1:18 這些人埋伏，是為自流己血；蹲伏，是為自害己命。',
    '箴1:19 凡貪戀財利的，所行之路都是如此；這貪戀之心乃奪去得財者之命。',
    '箴1:20 智慧在街市上呼喊，在寬闊處發聲，',
    '箴1:21 在熱鬧街頭喊叫，在城門口，在城中發出言語，',
    '箴1:22 說：你們愚昧人喜愛愚昧，褻慢人喜歡褻慢，愚頑人恨惡知識，要到幾時呢﹖',
    '箴1:23 你們當因我的責備回轉；我要將我的靈澆灌你們，將我的話指示你們。',
    '箴1:24 我呼喚，你們不肯聽從；我伸手，無人理會；',
    '箴1:25 反輕棄我一切的勸戒，不肯受我的責備。',
    '箴1:26 你們遭災難，我就發笑；驚恐臨到你們，我必嗤笑。',
    '箴1:27 驚恐臨到你們，好像狂風；災難來到，如同暴風；急難痛苦臨到你們身上。',
    '箴1:28 那時，你們必呼求我，我卻不答應，懇切地尋找我，卻尋不見。',
    '箴1:29 因為，你們恨惡知識，不喜愛敬畏耶和華，',
    '箴1:30 不聽我的勸戒，藐視我一切的責備，',
    '箴1:31 所以必吃自結的果子，充滿自設的計謀。',
    '箴1:32 愚昧人背道，必殺己身；愚頑人安逸，必害己命。',
    '箴1:33 惟有聽從我的，必安然居住，得享安靜，不怕災禍。',
    '箴2:1 我兒，你若領受我的言語，存記我的命令，',
    '箴2:2 側耳聽智慧，專心求聰明，',
    '箴2:3 呼求明哲，揚聲求聰明，',
    '箴2:4 尋找他，如尋找銀子，搜求他，如搜求隱藏的珍寶，',
    '箴2:5 你就明白敬畏耶和華，得以認識神。',
    '箴2:6 因為，耶和華賜人智慧；知識和聰明都由他口而出。',
    '箴2:7 他給正直人存留真智慧，給行為純正的人作盾牌，',
    '箴2:8 為要保守公平人的路，護庇虔敬人的道。',
    '箴2:9 你也必明白仁義、公平、正直、一切的善道。',
    '箴2:10 智慧必入你心；你的靈要以知識為美。',
    '箴2:11 謀略必護衛你；聰明必保守你，',
    '箴2:12 要救你脫離惡道（或譯：惡人的道），脫離說乖謬話的人。',
    '箴2:13 那等人捨棄正直的路，行走黑暗的道，',
    '箴2:14 歡喜作惡，喜愛惡人的乖僻，',
    '箴2:15 在他們的道中彎曲，在他們的路上偏僻。',
    '箴2:16 智慧要救你脫離淫婦，就是那油嘴滑舌的外女。',
    '箴2:17 他離棄幼年的配偶，忘了神的盟約。',
    '箴2:18 他的家陷入死地；他的路偏向陰間。',
    '箴2:19 凡到他那裡去的，不得轉回，也得不著生命的路。',
    '箴2:20 智慧必使你行善人的道，守義人的路。',
    '箴2:21 正直人必在世上居住；完全人必在地上存留。',
    '箴2:22 惟有惡人必然剪除；奸詐的，必然拔出。',
    '箴3:1 我兒，不要忘記我的法則（或譯：指教）；你心要謹守我的誡命；',
    '箴3:2 因為他必將長久的日子，生命的年數與平安，加給你。',
    '箴3:3 不可使慈愛、誠實離開你，要繫在你頸項上，刻在你心版上。',
    '箴3:4 這樣，你必在神和世人眼前蒙恩寵，有聰明。',
    '箴3:5 你要專心仰賴耶和華，不可倚靠自己的聰明，',
    '箴3:6 在你一切所行的事上都要認定他，他必指引你的路。',
    '箴3:7 不要自以為有智慧；要敬畏耶和華，遠離惡事。',
    '箴3:8 這便醫治你的肚臍，滋潤你的百骨。',
    '箴3:9 你要以財物和一切初熟的土產尊榮耶和華。',
    '箴3:10 這樣，你的倉房必充滿有餘；你的酒醡有新酒盈溢。',
    '箴3:11 我兒，你不可輕看耶和華的管教（或譯：懲治），也不可厭煩他的責備；',
    '箴3:12 因為耶和華所愛的，他必責備，正如父親責備所喜愛的兒子。',
    '箴3:13 得智慧，得聰明的，這人便為有福。',
    '箴3:14 因為得智慧勝過得銀子，其利益強如精金，',
    '箴3:15 比珍珠（或譯：紅寶石）寶貴；你一切所喜愛的，都不足與比較。',
    '箴3:16 他右手有長壽，左手有富貴。',
    '箴3:17 他的道是安樂；他的路全是平安。',
    '箴3:18 他與持守他的作生命樹；持定他的，俱各有福。',
    '箴3:19 耶和華以智慧立地，以聰明定天，',
    '箴3:20 以知識使深淵裂開，使天空滴下甘露。',
    '箴3:21 我兒，要謹守真智慧和謀略，不可使他離開你的眼目。',
    '箴3:22 這樣，他必作你的生命，頸項的美飾。',
    '箴3:23 你就坦然行路，不致碰腳。',
    '箴3:24 你躺下，必不懼怕；你躺臥，睡得香甜。',
    '箴3:25 忽然來的驚恐，不要害怕；惡人遭毀滅，也不要恐懼。',
    '箴3:26 因為耶和華是你所倚靠的；他必保守你的腳不陷入網羅。',
    '箴3:27 你手若有行善的力量，不可推辭，就當向那應得的人施行。',
    '箴3:28 你那裡若有現成的，不可對鄰舍說：去吧，明天再來，我必給你。',
    '箴3:29 你的鄰舍既在你附近安居，你不可設計害他。',
    '箴3:30 人未曾加害與你，不可無故與他相爭。',
    '箴3:31 不可嫉妒強暴的人，也不可選擇他所行的路。',
    '箴3:32 因為，乖僻人為耶和華所憎惡；正直人為他所親密。',
    '箴3:33 耶和華咒詛惡人的家庭，賜福與義人的居所。',
    '箴3:34 他譏誚那好譏誚的人，賜恩給謙卑的人。',
    '箴3:35 智慧人必承受尊榮；愚昧人高升也成為羞辱。',
    '箴4:1 眾子啊，要聽父親的教訓，留心得知聰明。',
    '箴4:2 因我所給你們的是好教訓；不可離棄我的法則（或譯：指教）。',
    '箴4:3 我在父親面前為孝子，在母親眼中為獨一的嬌兒。',
    '箴4:4 父親教訓我說：你心要存記我的言語，遵守我的命令，便得存活。',
    '箴4:5 要得智慧，要得聰明，不可忘記，也不可偏離我口中的言語。',
    '箴4:6 不可離棄智慧，智慧就護衛你；要愛他，他就保守你。',
    '箴4:7 智慧為首；所以，要得智慧。在你一切所得之內必得聰明（或譯：用你一切所得的去換聰明）。',
    '箴4:8 高舉智慧，他就使你高升；懷抱智慧，他就使你尊榮。',
    '箴4:9 他必將華冠加在你頭上，把榮冕交給你。',
    '箴4:10 我兒，你要聽受我的言語，就必延年益壽。',
    '箴4:11 我已指教你走智慧的道，引導你行正直的路。',
    '箴4:12 你行走，腳步必不致狹窄；你奔跑，也不致跌倒。',
    '箴4:13 要持定訓誨，不可放鬆；必當謹守，因為他是你的生命。',
    '箴4:14 不可行惡人的路；不要走壞人的道。',
    '箴4:15 要躲避，不可經過；要轉身而去。',
    '箴4:16 這等人若不行惡，不得睡覺；不使人跌倒，睡臥不安；',
    '箴4:17 因為他們以奸惡吃餅，以強暴喝酒。',
    '箴4:18 但義人的路好像黎明的光，越照越明，直到日午。',
    '箴4:19 惡人的道好像幽暗，自己不知因什麼跌倒。',
    '箴4:20 我兒，要留心聽我的言詞，側耳聽我的話語，',
    '箴4:21 都不可離你的眼目，要存記在你心中。',
    '箴4:22 因為得著他的，就得了生命，又得了醫全體的良藥。',
    '箴4:23 你要保守你心，勝過保守一切（或譯：你要切切保守你心），因為一生的果效是由心發出。',
    '箴4:24 你要除掉邪僻的口，棄絕乖謬的嘴。',
    '箴4:25 你的眼目要向前正看；你的眼睛（原文是皮）當向前直觀。',
    '箴4:26 要修平你腳下的路，堅定你一切的道。',
    '箴4:27 不可偏向左右；要使你的腳離開邪惡。',
    '箴5:1 我兒，要留心我智慧的話語，側耳聽我聰明的言詞，',
    '箴5:2 為要使你謹守謀略，嘴唇保存知識。',
    '箴5:3 因為淫婦的嘴滴下蜂蜜；他的口比油更滑，',
    '箴5:4 至終卻苦似茵蔯，快如兩刃的刀。',
    '箴5:5 他的腳下入死地；他腳步踏住陰間，',
    '箴5:6 以致他找不著生命平坦的道。他的路變遷不定，自己還不知道。',
    '箴5:7 眾子啊，現在要聽從我；不可離棄我口中的話。',
    '箴5:8 你所行的道要離他遠，不可就近他的房門，',
    '箴5:9 恐怕將你的尊榮給別人，將你的歲月給殘忍的人；',
    '箴5:10 恐怕外人滿得你的力量，你勞碌得來的，歸入外人的家；',
    '箴5:11 終久，你皮肉和身體消毀，你就悲歎，',
    '箴5:12 說：我怎麼恨惡訓誨，心中藐視責備，',
    '箴5:13 也不聽從我師傅的話，又不側耳聽那教訓我的人﹖',
    '箴5:14 我在聖會裡，幾乎落在諸般惡中。',
    '箴5:15 你要喝自己池中的水，飲自己井裡的活水。',
    '箴5:16 你的泉源豈可漲溢在外﹖你的河水豈可流在街上﹖',
    '箴5:17 惟獨歸你一人，不可與外人同用。',
    '箴5:18 要使你的泉源蒙福；要喜悅你幼年所娶的妻。',
    '箴5:19 他如可愛的麀鹿，可喜的母鹿；願他的胸懷使你時時知足，他的愛情使你常常戀慕。',
    '箴5:20 我兒，你為何戀慕淫婦﹖為何抱外女的胸懷﹖',
    '箴5:21 因為，人所行的道都在耶和華眼前；他也修平人一切的路。',
    '箴5:22 惡人必被自己的罪孽捉住；他必被自己的罪惡如繩索纏繞。',
    '箴5:23 他因不受訓誨就必死亡；又因愚昧過甚，必走差了路。',
    '箴6:1 我兒，你若為朋友作保，替外人擊掌，',
    '箴6:2 你就被口中的話語纏住，被嘴裡的言語捉住。',
    '箴6:3 我兒，你既落在朋友手中，就當這樣行才可救自己：你要自卑，去懇求你的朋友。',
    '箴6:4 不要容你的眼睛睡覺；不要容你的眼皮打盹。',
    '箴6:5 要救自己，如鹿脫離獵戶的手，如鳥脫離捕鳥人的手。',
    '箴6:6 懶惰人哪，你去察看螞蟻的動作就可得智慧。',
    '箴6:7 螞蟻沒有元帥，沒有官長，沒有君王，',
    '箴6:8 尚且在夏天預備食物，在收割時聚斂糧食。',
    '箴6:9 懶惰人哪，你要睡到幾時呢﹖你何時睡醒呢﹖',
    '箴6:10 再睡片時，打盹片時，抱著手躺臥片時，',
    '箴6:11 你的貧窮就必如強盜速來，你的缺乏彷彿拿兵器的人來到。',
    '箴6:12 無賴的惡徒，行動就用乖僻的口，',
    '箴6:13 用眼傳神，用腳示意，用指點劃，',
    '箴6:14 心中乖僻，常設惡謀，布散紛爭。',
    '箴6:15 所以，災難必忽然臨到他身；他必頃刻敗壞，無法可治。',
    '箴6:16 耶和華所恨惡的有六樣，連他心所憎惡的共有七樣：',
    '箴6:17 就是高傲的眼，撒謊的舌，流無辜人血的手，',
    '箴6:18 圖謀惡計的心，飛跑行惡的腳，',
    '箴6:19 吐謊言的假見證，並弟兄中布散紛爭的人。',
    '箴6:20 我兒，要謹守你父親的誡命；不可離棄你母親的法則（或譯：指教），',
    '箴6:21 要常繫在你心上，掛在你項上。',
    '箴6:22 你行走，他必引導你；你躺臥，他必保守你；你睡醒，他必與你談論。',
    '箴6:23 因為誡命是燈，法則（或譯：指教）是光，訓誨的責備是生命的道，',
    '箴6:24 能保你遠離惡婦，遠離外女諂媚的舌頭。',
    '箴6:25 你心中不要戀慕他的美色，也不要被他眼皮勾引。',
    '箴6:26 因為，妓女能使人只剩一塊餅；淫婦獵取人寶貴的生命。',
    '箴6:27 人若懷裡搋火，衣服豈能不燒呢﹖',
    '箴6:28 人若在火炭上走，腳豈能不燙呢﹖',
    '箴6:29 親近鄰舍之妻的，也是如此；凡挨近他的，不免受罰。',
    '箴6:30 賊因飢餓偷竊充飢，人不藐視他，',
    '箴6:31 若被找著，他必賠還七倍，必將家中所有的盡都償還。',
    '箴6:32 與婦人行淫的，便是無知；行這事的，必喪掉生命。',
    '箴6:33 他必受傷損，必被凌辱；他的羞恥不得塗抹。',
    '箴6:34 因為人的嫉恨成了烈怒，報仇的時候決不留情。',
    '箴6:35 什麼贖價，他都不顧；你雖送許多禮物，他也不肯干休。',
    '箴7:1 我兒，你要遵守我的言語，將我的命令存記在心。',
    '箴7:2 遵守我的命令就得存活；保守我的法則（或譯：指教），好像保守眼中的瞳人，',
    '箴7:3 繫在你指頭上，刻在你心版上。',
    '箴7:4 對智慧說：你是我的姊妹，稱呼聰明為你的親人，',
    '箴7:5 他就保你遠離淫婦，遠離說諂媚話的外女。',
    '箴7:6 我曾在我房屋的窗戶內，從我窗櫺之間往外觀看：',
    '箴7:7 見愚蒙人內，少年人中，分明有一個無知的少年人，',
    '箴7:8 從街上經過，走近淫婦的巷口，直往通他家的路去，',
    '箴7:9 在黃昏，或晚上，或半夜，或黑暗之中。',
    '箴7:10 看哪，有一個婦人來迎接他，是妓女的打扮，有詭詐的心思。',
    '箴7:11 這婦人喧嚷，不守約束，在家裡停不住腳，',
    '箴7:12 有時在街市上，有時在寬闊處，或在各巷口蹲伏，',
    '箴7:13 拉住那少年人，與他親嘴，臉無羞恥對他說：',
    '箴7:14 平安祭在我這裡，今日才還了我所許的願。',
    '箴7:15 因此，我出來迎接你，懇切求見你的面，恰巧遇見了你。',
    '箴7:16 我已經用繡花毯子和埃及線織的花紋布鋪了我的床。',
    '箴7:17 我又用沒藥、沉香、桂皮薰了我的榻。',
    '箴7:18 你來，我們可以飽享愛情，直到早晨；我們可以彼此親愛歡樂。',
    '箴7:19 因為我丈夫不在家，出門行遠路；',
    '箴7:20 他手拿銀囊，必到月望才回家。',
    '箴7:21 淫婦用許多巧言誘他隨從，用諂媚的嘴逼他同行。',
    '箴7:22 少年人立刻跟隨他，好像牛往宰殺之地，又像愚昧人帶鎖鍊去受刑罰，',
    '箴7:23 直等箭穿他的肝，如同雀鳥急入網羅，卻不知是自喪己命。',
    '箴7:24 眾子啊，現在要聽從我，留心聽我口中的話。',
    '箴7:25 你的心不可偏向淫婦的道，不要入他的迷途。',
    '箴7:26 因為，被他傷害仆倒的不少；被他殺戮的而且甚多。',
    '箴7:27 他的家是在陰間之路，下到死亡之宮。',
    '箴8:1 智慧豈不呼叫﹖聰明豈不發聲﹖',
    '箴8:2 他在道旁高處的頂上，在十字路口站立，',
    '箴8:3 在城門旁，在城門口，在城門洞，大聲說：',
    '箴8:4 眾人哪，我呼叫你們，我向世人發聲。',
    '箴8:5 說：愚蒙人哪，你們要會悟靈明；愚昧人哪，你們當心裡明白。',
    '箴8:6 你們當聽，因我要說極美的話；我張嘴要論正直的事。',
    '箴8:7 我的口要發出真理；我的嘴憎惡邪惡。',
    '箴8:8 我口中的言語都是公義，並無彎曲乖僻。',
    '箴8:9 有聰明的，以為明顯，得知識的，以為正直。',
    '箴8:10 你們當受我的教訓，不受白銀；寧得知識，勝過黃金。',
    '箴8:11 因為智慧比珍珠（或譯：紅寶石）更美；一切可喜愛的都不足與比較。',
    '箴8:12 我─智慧以靈明為居所，又尋得知識和謀略。',
    '箴8:13 敬畏耶和華在乎恨惡邪惡；那驕傲、狂妄，並惡道，以及乖謬的口，都為我所恨惡。',
    '箴8:14 我有謀略和真知識；我乃聰明，我有能力。',
    '箴8:15 帝王藉我坐國位；君王藉我定公平。',
    '箴8:16 王子和首領，世上一切的審判官，都是藉我掌權。',
    '箴8:17 愛我的，我也愛他；懇切尋求我的，必尋得見。',
    '箴8:18 豐富尊榮在我；恆久的財並公義也在我。',
    '箴8:19 我的果實勝過黃金，強如精金；我的出產超乎高銀。',
    '箴8:20 我在公義的道上走，在公平的路中行，',
    '箴8:21 使愛我的，承受貨財，並充滿他們的府庫。',
    '箴8:22 在耶和華造化的起頭，在太初創造萬物之先，就有了我。',
    '箴8:23 從亙古，從太初，未有世界以前，我已被立。',
    '箴8:24 沒有深淵，沒有大水的泉源，我已生出。',
    '箴8:25 大山未曾奠定，小山未有之先，我已生出。',
    '箴8:26 耶和華還沒有創造大地和田野，並世上的土質，我已生出。',
    '箴8:27 他立高天，我在那裡；他在淵面的周圍，劃出圓圈。',
    '箴8:28 上使穹蒼堅硬，下使淵源穩固，',
    '箴8:29 為滄海定出界限，使水不越過他的命令，立定大地的根基。',
    '箴8:30 那時，我在他那裡為工師，日日為他所喜愛，常常在他面前踴躍，',
    '箴8:31 踴躍在他為人預備可住之地，也喜悅住在世人之間。',
    '箴8:32 眾子啊，現在要聽從我，因為謹守我道的，便為有福。',
    '箴8:33 要聽教訓就得智慧，不可棄絕。',
    '箴8:34 聽從我、日日在我門口仰望、在我門框旁邊等候的，那人便為有福。',
    '箴8:35 因為尋得我的，就尋得生命，也必蒙耶和華的恩惠。',
    '箴8:36 得罪我的，卻害了自己的性命；恨惡我的，都喜愛死亡。',
    '箴9:1 智慧建造房屋，鑿成七根柱子，',
    '箴9:2 宰殺牲畜，調和旨酒，設擺筵席；',
    '箴9:3 打發使女出去，自己在城中至高處呼叫，',
    '箴9:4 說：誰是愚蒙人，可以轉到這裡來！又對那無知的人說：',
    '箴9:5 你們來，吃我的餅，喝我調和的酒。',
    '箴9:6 你們愚蒙人，要捨棄愚蒙，就得存活，並要走光明的道。',
    '箴9:7 指斥褻慢人的，必受辱罵；責備惡人的，必被玷污。',
    '箴9:8 不要責備褻慢人，恐怕他恨你；要責備智慧人，他必愛你。',
    '箴9:9 教導智慧人，他就越發有智慧；指示義人，他就增長學問。',
    '箴9:10 敬畏耶和華是智慧的開端；認識至聖者便是聰明。',
    '箴9:11 你藉著我，日子必增多，年歲也必加添。',
    '箴9:12 你若有智慧，是於自己有益；你若褻慢，就必獨自擔當。',
    '箴9:13 愚昧的婦人喧嚷；他是愚蒙，一無所知。',
    '箴9:14 他坐在自己的家門口，坐在城中高處的座位上，',
    '箴9:15 呼叫過路的，就是直行其道的人，',
    '箴9:16 說：誰是愚蒙人，可以轉到這裡來！又對那無知的人說：',
    '箴9:17 偷來的水是甜的，暗吃的餅是好的。',
    '箴9:18 人卻不知有陰魂在他那裡；他的客在陰間的深處。',
    '箴10:1 所羅門的箴言：智慧之子使父親歡樂；愚昧之子叫母親擔憂。',
    '箴10:2 不義之財毫無益處；惟有公義能救人脫離死亡。',
    '箴10:3 耶和華不使義人受飢餓；惡人所欲的，他必推開。',
    '箴10:4 手懶的，要受貧窮；手勤的，卻要富足。',
    '箴10:5 夏天聚斂的，是智慧之子；收割時沉睡的，是貽羞之子。',
    '箴10:6 福祉臨到義人的頭；強暴蒙蔽惡人的口。',
    '箴10:7 義人的記念被稱讚；惡人的名字必朽爛。',
    '箴10:8 心中智慧的，必受命令；口裡愚妄的，必致傾倒。',
    '箴10:9 行正直路的，步步安穩；走彎曲道的，必致敗露。',
    '箴10:10 以眼傳神的，使人憂患；口裡愚妄的，必致傾倒。',
    '箴10:11 義人的口是生命的泉源；強暴蒙蔽惡人的口。',
    '箴10:12 恨能挑啟爭端；愛能遮掩一切過錯。',
    '箴10:13 明哲人嘴裡有智慧；無知人背上受刑杖。',
    '箴10:14 智慧人積存知識；愚妄人的口速致敗壞。',
    '箴10:15 富戶的財物是他的堅城；窮人的貧乏是他的敗壞。',
    '箴10:16 義人的勤勞致生；惡人的進項致死（死：原文是罪）。',
    '箴10:17 謹守訓誨的，乃在生命的道上；違棄責備的，便失迷了路。',
    '箴10:18 隱藏怨恨的，有說謊的嘴；口出讒謗的，是愚妄的人。',
    '箴10:19 多言多語難免有過；禁止嘴唇是有智慧。',
    '箴10:20 義人的舌乃似高銀；惡人的心所值無幾。',
    '箴10:21 義人的口教養多人；愚昧人因無知而死亡。',
    '箴10:22 耶和華所賜的福使人富足，並不加上憂慮。',
    '箴10:23 愚妄人以行惡為戲耍；明哲人卻以智慧為樂。',
    '箴10:24 惡人所怕的，必臨到他；義人所願的，必蒙應允。',
    '箴10:25 暴風一過，惡人歸於無有；義人的根基卻是永久。',
    '箴10:26 懶惰人叫差他的人如醋倒牙，如煙薰目。',
    '箴10:27 敬畏耶和華使人日子加多；但惡人的年歲必被減少。',
    '箴10:28 義人的盼望必得喜樂；惡人的指望必致滅沒。',
    '箴10:29 耶和華的道是正直人的保障，卻成了作孽人的敗壞。',
    '箴10:30 義人永不挪移；惡人不得住在地上。',
    '箴10:31 義人的口滋生智慧；乖謬的舌必被割斷。',
    '箴10:32 義人的嘴能令人喜悅；惡人的口說乖謬的話。',
    '箴11:1 詭詐的天平為耶和華所憎惡；公平的法碼為他所喜悅。',
    '箴11:2 驕傲來，羞恥也來；謙遜人卻有智慧。',
    '箴11:3 正直人的純正必引導自己；奸詐人的乖僻必毀滅自己。',
    '箴11:4 發怒的日子資財無益；惟有公義能救人脫離死亡。',
    '箴11:5 完全人的義必指引他的路；但惡人必因自己的惡跌倒。',
    '箴11:6 正直人的義必拯救自己；奸詐人必陷在自己的罪孽中。',
    '箴11:7 惡人一死，他的指望必滅絕；罪人的盼望也必滅沒。',
    '箴11:8 義人得脫離患難，有惡人來代替他。',
    '箴11:9 不虔敬的人用口敗壞鄰舍；義人卻因知識得救。',
    '箴11:10 義人享福，合城喜樂；惡人滅亡，人都歡呼。',
    '箴11:11 城因正直人祝福便高舉，卻因邪惡人的口就傾覆。',
    '箴11:12 藐視鄰舍的，毫無智慧；明哲人卻靜默不言。',
    '箴11:13 往來傳舌的，洩漏密事；心中誠實的，遮隱事情。',
    '箴11:14 無智謀，民就敗落；謀士多，人便安居。',
    '箴11:15 為外人作保的，必受虧損；恨惡擊掌的，卻得安穩。',
    '箴11:16 恩德的婦女得尊榮；強暴的男子得資財。',
    '箴11:17 仁慈的人善待自己；殘忍的人擾害己身。',
    '箴11:18 惡人經營，得虛浮的工價；撒義種的，得實在的果效。',
    '箴11:19 恆心為義的，必得生命；追求邪惡的，必致死亡。',
    '箴11:20 心中乖僻的，為耶和華所憎惡；行事完全的，為他所喜悅。',
    '箴11:21 惡人雖然連手，必不免受罰；義人的後裔必得拯救。',
    '箴11:22 婦女美貌而無見識，如同金環帶在豬鼻上。',
    '箴11:23 義人的心願盡得好處；惡人的指望致干忿怒。',
    '箴11:24 有施散的，卻更增添；有吝惜過度的，反致窮乏。',
    '箴11:25 好施捨的，必得豐裕；滋潤人的，必得滋潤。',
    '箴11:26 屯糧不賣的，民必咒詛他；情願出賣的，人必為他祝福。',
    '箴11:27 懇切求善的，就求得恩惠；惟獨求惡的，惡必臨到他身。',
    '箴11:28 倚仗自己財物的，必跌倒；義人必發旺，如青葉。',
    '箴11:29 擾害己家的，必承受清風；愚昧人必作慧心人的僕人。',
    '箴11:30 義人所結的果子就是生命樹；有智慧的，必能得人。',
    '箴11:31 看哪，義人在世尚且受報，何況惡人和罪人呢﹖',
    '箴12:1 喜愛管教的，就是喜愛知識；恨惡責備的，卻是畜類。',
    '箴12:2 善人必蒙耶和華的恩惠；設詭計的人，耶和華必定他的罪。',
    '箴12:3 人靠惡行不能堅立；義人的根必不動搖。',
    '箴12:4 才德的婦人是丈夫的冠冕；貽羞的婦人如同朽爛在他丈夫的骨中。',
    '箴12:5 義人的思念是公平；惡人的計謀是詭詐。',
    '箴12:6 惡人的言論是埋伏流人的血；正直人的口必拯救人。',
    '箴12:7 惡人傾覆，歸於無有；義人的家必站得住。',
    '箴12:8 人必按自己的智慧被稱讚；心中乖謬的，必被藐視。',
    '箴12:9 被人輕賤，卻有僕人，強如自尊，缺少食物。',
    '箴12:10 義人顧惜他牲畜的命；惡人的憐憫也是殘忍。',
    '箴12:11 耕種自己田地的，必得飽食；追隨虛浮的，卻是無知。',
    '箴12:12 惡人想得壞人的網羅；義人的根得以結實。',
    '箴12:13 惡人嘴中的過錯是自己的網羅；但義人必脫離患難。',
    '箴12:14 人因口所結的果子，必飽得美福；人手所做的，必為自己的報應。',
    '箴12:15 愚妄人所行的，在自己眼中看為正直；惟智慧人肯聽人的勸教。',
    '箴12:16 愚妄人的惱怒立時顯露；通達人能忍辱藏羞。',
    '箴12:17 說出真話的，顯明公義；作假見證的，顯出詭詐。',
    '箴12:18 說話浮躁的，如刀刺人；智慧人的舌頭卻為醫人的良藥。',
    '箴12:19 口吐真言，永遠堅立；舌說謊話，只存片時。',
    '箴12:20 圖謀惡事的，心存詭詐；勸人和睦的，便得喜樂。',
    '箴12:21 義人不遭災害；惡人滿受禍患。',
    '箴12:22 說謊言的嘴為耶和華所憎惡；行事誠實的，為他所喜悅。',
    '箴12:23 通達人隱藏知識；愚昧人的心彰顯愚昧。',
    '箴12:24 殷勤人的手必掌權；懶惰的人必服苦。',
    '箴12:25 人心憂慮，屈而不伸；一句良言，使心歡樂。',
    '箴12:26 義人引導他的鄰舍；惡人的道叫人失迷。',
    '箴12:27 懶惰的人不烤打獵所得的；殷勤的人卻得寶貴的財物。',
    '箴12:28 在公義的道上有生命；其路之中並無死亡。',
    '箴13:1 智慧子聽父親的教訓；褻慢人不聽責備。',
    '箴13:2 人因口所結的果子，必享美福；奸詐人必遭強暴。',
    '箴13:3 謹守口的，得保生命；大張嘴的，必致敗亡。',
    '箴13:4 懶惰人羨慕，卻無所得；殷勤人必得豐裕。',
    '箴13:5 義人恨惡謊言；惡人有臭名，且致慚愧。',
    '箴13:6 行為正直的，有公義保守；犯罪的，被邪惡傾覆。',
    '箴13:7 假作富足的，卻一無所有；裝作窮乏的，卻廣有財物。',
    '箴13:8 人的資財是他生命的贖價；窮乏人卻聽不見威嚇的話。',
    '箴13:9 義人的光明亮（原文是歡喜）；惡人的燈要熄滅。',
    '箴13:10 驕傲只啟爭競；聽勸言的，卻有智慧。',
    '箴13:11 不勞而得之財必然消耗；勤勞積蓄的，必見加增。',
    '箴13:12 所盼望的遲延未得，令人心憂；所願意的臨到，卻是生命樹。',
    '箴13:13 藐視訓言的，自取滅亡；敬畏誡命的，必得善報。',
    '箴13:14 智慧人的法則（或譯：指教）是生命的泉源，可以使人離開死亡的網羅。',
    '箴13:15 美好的聰明使人蒙恩；奸詐人的道路崎嶇難行。',
    '箴13:16 凡通達人都憑知識行事；愚昧人張揚自己的愚昧。',
    '箴13:17 奸惡的使者必陷在禍患裡；忠信的使臣乃醫人的良藥。',
    '箴13:18 棄絕管教的，必致貧受辱；領受責備的，必得尊榮。',
    '箴13:19 所欲的成就，心覺甘甜；遠離惡事，為愚昧人所憎惡。',
    '箴13:20 與智慧人同行的，必得智慧；和愚昧人作伴的，必受虧損。',
    '箴13:21 禍患追趕罪人；義人必得善報。',
    '箴13:22 善人給子孫遺留產業；罪人為義人積存資財。',
    '箴13:23 窮人耕種多得糧食，但因不義，有消滅的。',
    '箴13:24 不忍用杖打兒子的，是恨惡他；疼愛兒子的，隨時管教。',
    '箴13:25 義人吃得飽足；惡人肚腹缺糧。',
    '箴14:1 智慧婦人建立家室；愚妄婦人親手拆毀。',
    '箴14:2 行動正直的，敬畏耶和華；行事乖僻的，卻藐視他。',
    '箴14:3 愚妄人口中驕傲，如杖責打己身；智慧人的嘴必保守自己。',
    '箴14:4 家裡無牛，槽頭乾淨；土產加多乃憑牛力。',
    '箴14:5 誠實見證人不說謊話；假見證人吐出謊言。',
    '箴14:6 褻慢人尋智慧，卻尋不著；聰明人易得知識。',
    '箴14:7 到愚昧人面前，不見他嘴中有知識。',
    '箴14:8 通達人的智慧在乎明白己道；愚昧人的愚妄乃是詭詐（或譯：自歎）。',
    '箴14:9 愚妄人犯罪，以為戲耍（或譯：贖愆祭愚弄愚妄人）；正直人互相喜悅。',
    '箴14:10 心中的苦楚，自己知道；心裡的喜樂，外人無干。',
    '箴14:11 奸惡人的房屋必傾倒；正直人的帳棚必興盛。',
    '箴14:12 有一條路，人以為正，至終成為死亡之路。',
    '箴14:13 人在喜笑中，心也憂愁；快樂至極就生愁苦。',
    '箴14:14 心中背道的，必滿得自己的結果；善人必從自己的行為得以知足。',
    '箴14:15 愚蒙人是話都信；通達人步步謹慎。',
    '箴14:16 智慧人懼怕，就遠離惡事；愚妄人卻狂傲自恃。',
    '箴14:17 輕易發怒的，行事愚妄；設立詭計的，被人恨惡。',
    '箴14:18 愚蒙人得愚昧為產業；通達人得知識為冠冕。',
    '箴14:19 壞人俯伏在善人面前；惡人俯伏在義人門口。',
    '箴14:20 貧窮人連鄰舍也恨他；富足人朋友最多。',
    '箴14:21 藐視鄰舍的，這人有罪；憐憫貧窮的，這人有福。',
    '箴14:22 謀惡的，豈非走入迷途嗎﹖謀善的，必得慈愛和誠實。',
    '箴14:23 諸般勤勞都有益處；嘴上多言乃致窮乏。',
    '箴14:24 智慧人的財為自己的冠冕；愚妄人的愚昧終是愚昧。',
    '箴14:25 作真見證的，救人性命；吐出謊言的，施行詭詐。',
    '箴14:26 敬畏耶和華的，大有倚靠；他的兒女也有避難所。',
    '箴14:27 敬畏耶和華就是生命的泉源，可以使人離開死亡的網羅。',
    '箴14:28 帝王榮耀在乎民多；君王衰敗在乎民少。',
    '箴14:29 不輕易發怒的，大有聰明；性情暴躁的，大顯愚妄。',
    '箴14:30 心中安靜是肉體的生命；嫉妒是骨中的朽爛。',
    '箴14:31 欺壓貧寒的，是辱沒造他的主；憐憫窮乏的，乃是尊敬主。',
    '箴14:32 惡人在所行的惡上必被推倒；義人臨死，有所投靠。',
    '箴14:33 智慧存在聰明人心中；愚昧人心裡所存的，顯而易見。',
    '箴14:34 公義使邦國高舉；罪惡是人民的羞辱。',
    '箴14:35 智慧的臣子蒙王恩惠；貽羞的僕人遭其震怒。',
    '箴15:1 回答柔和，使怒消退；言語暴戾，觸動怒氣。',
    '箴15:2 智慧人的舌善發知識；愚昧人的口吐出愚昧。',
    '箴15:3 耶和華的眼目無處不在；惡人善人，他都鑒察。',
    '箴15:4 溫良的舌是生命樹；乖謬的嘴使人心碎。',
    '箴15:5 愚妄人藐視父親的管教；領受責備的，得著見識。',
    '箴15:6 義人家中多有財寶；惡人得利反受擾害。',
    '箴15:7 智慧人的嘴播揚知識；愚昧人的心並不如此。',
    '箴15:8 惡人獻祭，為耶和華所憎惡；正直人祈禱，為他所喜悅。',
    '箴15:9 惡人的道路，為耶和華所憎惡；追求公義的，為他所喜愛。',
    '箴15:10 捨棄正路的，必受嚴刑；恨惡責備的，必致死亡。',
    '箴15:11 陰間和滅亡尚在耶和華眼前，何況世人的心呢﹖',
    '箴15:12 褻慢人不愛受責備；他也不就近智慧人。',
    '箴15:13 心中喜樂，面帶笑容；心裡憂愁，靈被損傷。',
    '箴15:14 聰明人心求知識；愚昧人口吃愚昧。',
    '箴15:15 困苦人的日子都是愁苦；心中歡暢的，常享豐筵。',
    '箴15:16 少有財寶，敬畏耶和華，強如多有財寶，煩亂不安。',
    '箴15:17 吃素菜，彼此相愛，強如吃肥牛，彼此相恨。',
    '箴15:18 暴怒的人挑啟爭端；忍怒的人止息紛爭。',
    '箴15:19 懶惰人的道像荊棘的籬笆；正直人的路是平坦的大道。',
    '箴15:20 智慧子使父親喜樂；愚昧人藐視母親。',
    '箴15:21 無知的人以愚妄為樂；聰明的人按正直而行。',
    '箴15:22 不先商議，所謀無效；謀士眾多，所謀乃成。',
    '箴15:23 口善應對，自覺喜樂；話合其時，何等美好。',
    '箴15:24 智慧人從生命的道上升，使他遠離在下的陰間。',
    '箴15:25 耶和華必拆毀驕傲人的家，卻要立定寡婦的地界。',
    '箴15:26 惡謀為耶和華所憎惡；良言乃為純淨。',
    '箴15:27 貪戀財利的，擾害己家；恨惡賄賂的，必得存活。',
    '箴15:28 義人的心，思量如何回答；惡人的口吐出惡言。',
    '箴15:29 耶和華遠離惡人，卻聽義人的禱告。',
    '箴15:30 眼有光，使心喜樂；好信息，使骨滋潤。',
    '箴15:31 聽從生命責備的，必常在智慧人中。',
    '箴15:32 棄絕管教的，輕看自己的生命；聽從責備的，卻得智慧。',
    '箴15:33 敬畏耶和華是智慧的訓誨；尊榮以前，必有謙卑。',
    '箴16:1 心中的謀算在乎人；舌頭的應對由於耶和華。',
    '箴16:2 人一切所行的，在自己眼中看為清潔；惟有耶和華衡量人心。',
    '箴16:3 你所做的，要交託耶和華，你所謀的，就必成立。',
    '箴16:4 耶和華所造的，各適其用；就是惡人也為禍患的日子所造。',
    '箴16:5 凡心裡驕傲的，為耶和華所憎惡；雖然連手，他必不免受罰。',
    '箴16:6 因憐憫誠實，罪孽得贖；敬畏耶和華的，遠離惡事。',
    '箴16:7 人所行的，若蒙耶和華喜悅，耶和華也使他的仇敵與他和好。',
    '箴16:8 多有財利，行事不義，不如少有財利，行事公義。',
    '箴16:9 人心籌算自己的道路；惟耶和華指引他的腳步。',
    '箴16:10 王的嘴中有神語，審判之時，他的口必不差錯。',
    '箴16:11 公道的天平和秤都屬耶和華；囊中一切法碼都為他所定。',
    '箴16:12 作惡，為王所憎惡，因國位是靠公義堅立。',
    '箴16:13 公義的嘴為王所喜悅；說正直話的，為王所喜愛。',
    '箴16:14 王的震怒如殺人的使者；但智慧人能止息王怒。',
    '箴16:15 王的臉光使人有生命；王的恩典好像春雲時雨。',
    '箴16:16 得智慧勝似得金子；選聰明強如選銀子。',
    '箴16:17 正直人的道是遠離惡事；謹守己路的，是保全性命。',
    '箴16:18 驕傲在敗壞以先；狂心在跌倒之前。',
    '箴16:19 心裡謙卑與窮乏人來往，強如將擄物與驕傲人同分。',
    '箴16:20 謹守訓言的，必得好處；倚靠耶和華的，便為有福。',
    '箴16:21 心中有智慧，必稱為通達人；嘴中的甜言，加增人的學問。',
    '箴16:22 人有智慧就有生命的泉源；愚昧人必被愚昧懲治。',
    '箴16:23 智慧人的心教訓他的口，又使他的嘴增長學問。',
    '箴16:24 良言如同蜂房，使心覺甘甜，使骨得醫治。',
    '箴16:25 有一條路，人以為正，至終成為死亡之路。',
    '箴16:26 勞力人的胃口使他勞力，因為他的口腹催逼他。',
    '箴16:27 匪徒圖謀奸惡，嘴上彷彿有燒焦的火。',
    '箴16:28 乖僻人播散紛爭；傳舌的，離間密友。',
    '箴16:29 強暴人誘惑鄰舍，領他走不善之道。',
    '箴16:30 眼目緊合的，圖謀乖僻；嘴唇緊閉的，成就邪惡。',
    '箴16:31 白髮是榮耀的冠冕，在公義的道上必能得著。',
    '箴16:32 不輕易發怒的，勝過勇士；治服己心的，強如取城。',
    '箴16:33 籤放在懷裡，定事由耶和華。',
    '箴17:1 設筵滿屋，大家相爭，不如有塊乾餅，大家相安。',
    '箴17:2 僕人辦事聰明，必管轄貽羞之子，又在眾子中同分產業。',
    '箴17:3 鼎為煉銀，爐為煉金；惟有耶和華熬煉人心。',
    '箴17:4 行惡的，留心聽奸詐之言；說謊的，側耳聽邪惡之語。',
    '箴17:5 戲笑窮人的，是辱沒造他的主；幸災樂禍的，必不免受罰。',
    '箴17:6 子孫為老人的冠冕；父親是兒女的榮耀。',
    '箴17:7 愚頑人說美言本不相宜，何況君王說謊話呢﹖',
    '箴17:8 賄賂在餽送的人眼中看為寶玉，隨處運動都得順利。',
    '箴17:9 遮掩人過的，尋求人愛；屢次挑錯的，離間密友。',
    '箴17:10 一句責備話深入聰明人的心，強如責打愚昧人一百下。',
    '箴17:11 惡人只尋背叛，所以必有嚴厲的使者奉差攻擊他。',
    '箴17:12 寧可遇見丟崽子的母熊，不可遇見正行愚妄的愚昧人。',
    '箴17:13 以惡報善的，禍患必不離他的家。',
    '箴17:14 紛爭的起頭如水放開，所以，在爭鬧之先必當止息爭競。',
    '箴17:15 定惡人為義的，定義人為惡的，這都為耶和華所憎惡。',
    '箴17:16 愚昧人既無聰明，為何手拿價銀買智慧呢﹖',
    '箴17:17 朋友乃時常親愛，弟兄為患難而生。',
    '箴17:18 在鄰舍面前擊掌作保乃是無知的人。',
    '箴17:19 喜愛爭競的，是喜愛過犯；高立家門的，乃自取敗壞。',
    '箴17:20 心存邪僻的，尋不著好處；舌弄是非的，陷在禍患中。',
    '箴17:21 生愚昧子的，必自愁苦；愚頑人的父毫無喜樂。',
    '箴17:22 喜樂的心乃是良藥；憂傷的靈使骨枯乾。',
    '箴17:23 惡人暗中受賄賂，為要顛倒判斷。',
    '箴17:24 明哲人眼前有智慧；愚昧人眼望地極。',
    '箴17:25 愚昧子使父親愁煩，使母親憂苦。',
    '箴17:26 刑罰義人為不善；責打君子為不義。',
    '箴17:27 寡少言語的，有知識；性情溫良的，有聰明。',
    '箴17:28 愚昧人若靜默不言也可算為智慧；閉口不說也可算為聰明。',
    '箴18:1 與眾寡合的，獨自尋求心願，並惱恨一切真智慧。',
    '箴18:2 愚昧人不喜愛明哲，只喜愛顯露心意。',
    '箴18:3 惡人來，藐視隨來；羞恥到，辱罵同到。',
    '箴18:4 人口中的言語如同深水；智慧的泉源好像湧流的河水。',
    '箴18:5 瞻徇惡人的情面，偏斷義人的案件，都為不善。',
    '箴18:6 愚昧人張嘴啟爭端，開口招鞭打。',
    '箴18:7 愚昧人的口自取敗壞；他的嘴是他生命的網羅。',
    '箴18:8 傳舌人的言語如同美食，深入人的心腹。',
    '箴18:9 做工懈怠的，與浪費人為弟兄。',
    '箴18:10 耶和華的名是堅固臺；義人奔入便得安穩。',
    '箴18:11 富足人的財物是他的堅城，在他心想，猶如高牆。',
    '箴18:12 敗壞之先，人心驕傲；尊榮以前，必有謙卑。',
    '箴18:13 未曾聽完先回答的，便是他的愚昧和羞辱。',
    '箴18:14 人有疾病，心能忍耐；心靈憂傷，誰能承當呢﹖',
    '箴18:15 聰明人的心得知識；智慧人的耳求知識。',
    '箴18:16 人的禮物為他開路，引他到高位的人面前。',
    '箴18:17 先訴情由的，似乎有理；但鄰舍來到，就察出實情。',
    '箴18:18 掣籤能止息爭競，也能解散強勝的人。',
    '箴18:19 弟兄結怨，勸他和好，比取堅固城還難；這樣的爭競如同堅寨的門閂。',
    '箴18:20 人口中所結的果子，必充滿肚腹；他嘴所出的，必使他飽足。',
    '箴18:21 生死在舌頭的權下，喜愛他的，必吃他所結的果子。',
    '箴18:22 得著賢妻的，是得著好處，也是蒙了耶和華的恩惠。',
    '箴18:23 貧窮人說哀求的話；富足人用威嚇的話回答。',
    '箴18:24 濫交朋友的，自取敗壞；但有一朋友比弟兄更親密。',
    '箴19:1 行為純正的貧窮人勝過乖謬愚妄的富足人。',
    '箴19:2 心無知識的，乃為不善；腳步急快的，難免犯罪。',
    '箴19:3 人的愚昧傾敗他的道；他的心也抱怨耶和華。',
    '箴19:4 財物使朋友增多；但窮人朋友遠離。',
    '箴19:5 作假見證的，必不免受罰；吐出謊言的，終不能逃脫。',
    '箴19:6 好施散的，有多人求他的恩情；愛送禮的，人都為他的朋友。',
    '箴19:7 貧窮人，弟兄都恨他；何況他的朋友，更遠離他！他用言語追隨，他們卻走了。',
    '箴19:8 得著智慧的，愛惜生命；保守聰明的，必得好處。',
    '箴19:9 作假見證的，不免受罰；吐出謊言的，也必滅亡。',
    '箴19:10 愚昧人宴樂度日是不合宜的；何況僕人管轄王子呢﹖',
    '箴19:11 人有見識就不輕易發怒；寬恕人的過失便是自己的榮耀。',
    '箴19:12 王的忿怒好像獅子吼叫；他的恩典卻如草上的甘露。',
    '箴19:13 愚昧的兒子是父親的禍患；妻子的爭吵如雨連連滴漏。',
    '箴19:14 房屋錢財是祖宗所遺留的；惟有賢慧的妻是耶和華所賜的。',
    '箴19:15 懶惰使人沉睡；懈怠的人必受飢餓。',
    '箴19:16 謹守誡命的，保全生命；輕忽己路的，必致死亡。',
    '箴19:17 憐憫貧窮的，就是借給耶和華；他的善行，耶和華必償還。',
    '箴19:18 趁有指望，管教你的兒子；你的心不可任他死亡。',
    '箴19:19 暴怒的人必受刑罰；你若救他，必須再救。',
    '箴19:20 你要聽勸教，受訓誨，使你終久有智慧。',
    '箴19:21 人心多有計謀；惟有耶和華的籌算才能立定。',
    '箴19:22 施行仁慈的，令人愛慕；窮人強如說謊言的。',
    '箴19:23 敬畏耶和華的，得著生命；他必恆久知足，不遭禍患。',
    '箴19:24 懶惰人放手在盤子裡，就是向口撤回，他也不肯。',
    '箴19:25 鞭打褻慢人，愚蒙人必長見識；責備明哲人，他就明白知識。',
    '箴19:26 虐待父親、攆出母親的，是貽羞致辱之子。',
    '箴19:27 我兒，不可聽了教訓而又偏離知識的言語。',
    '箴19:28 匪徒作見證戲笑公平；惡人的口吞下罪孽。',
    '箴19:29 刑罰是為褻慢人預備的；鞭打是為愚昧人的背預備的。',
    '箴20:1 酒能使人褻慢，濃酒使人喧嚷；凡因酒錯誤的，就無智慧。',
    '箴20:2 王的威嚇如同獅子吼叫；惹動他怒的，是自害己命。',
    '箴20:3 遠離紛爭是人的尊榮；愚妄人都愛爭鬧。',
    '箴20:4 懶惰人因冬寒不肯耕種，到收割的時候，他必討飯而無所得。',
    '箴20:5 人心懷藏謀略，好像深水，惟明哲人才能汲引出來。',
    '箴20:6 人多述說自己的仁慈，但忠信人誰能遇著呢﹖',
    '箴20:7 行為純正的義人，他的子孫是有福的！',
    '箴20:8 王坐在審判的位上，以眼目驅散諸惡。',
    '箴20:9 誰能說，我潔淨了我的心，我脫淨了我的罪﹖',
    '箴20:10 兩樣的法碼，兩樣的升斗，都為耶和華所憎惡。',
    '箴20:11 孩童的動作是清潔，是正直，都顯明他的本性。',
    '箴20:12 能聽的耳，能看的眼，都是耶和華所造的。',
    '箴20:13 不要貪睡，免致貧窮；眼要睜開，你就吃飽。',
    '箴20:14 買物的說：不好，不好；及至買去，他便自誇。',
    '箴20:15 有金子和許多珍珠（或譯：紅寶石），惟有知識的嘴乃為貴重的珍寶。',
    '箴20:16 誰為生人作保，就拿誰的衣服；誰為外人作保，誰就要承當。',
    '箴20:17 以虛謊而得的食物，人覺甘甜；但後來，他的口必充滿塵沙。',
    '箴20:18 計謀都憑籌算立定；打仗要憑智謀。',
    '箴20:19 往來傳舌的，洩漏密事；大張嘴的，不可與他結交。',
    '箴20:20 咒罵父母的，他的燈必滅，變為漆黑的黑暗。',
    '箴20:21 起初速得的產業，終久卻不為福。',
    '箴20:22 你不要說，我要以惡報惡；要等候耶和華，他必拯救你。',
    '箴20:23 兩樣的法碼為耶和華所憎惡；詭詐的天平也為不善。',
    '箴20:24 人的腳步為耶和華所定；人豈能明白自己的路呢﹖',
    '箴20:25 人冒失說，這是聖物，許願之後才查問，就是自陷網羅。',
    '箴20:26 智慧的王簸散惡人，用碌碡滾軋他們。',
    '箴20:27 人的靈是耶和華的燈，鑒察人的心腹。',
    '箴20:28 王因仁慈和誠實得以保全他的國位，也因仁慈立穩。',
    '箴20:29 強壯乃少年人的榮耀；白髮為老年人的尊榮。',
    '箴20:30 鞭傷除淨人的罪惡；責打能入人的心腹。',
    '箴21:1 王的心在耶和華手中，好像隴溝的水隨意流轉。',
    '箴21:2 人所行的，在自己眼中都看為正；惟有耶和華衡量人心。',
    '箴21:3 行仁義公平比獻祭更蒙耶和華悅納。',
    '箴21:4 惡人發達（發達：原文是燈），眼高心傲，這乃是罪。',
    '箴21:5 殷勤籌劃的，足致豐裕；行事急躁的，都必缺乏。',
    '箴21:6 用詭詐之舌求財的，就是自己取死；所得之財乃是吹來吹去的浮雲。',
    '箴21:7 惡人的強暴必將自己掃除，因他們不肯按公平行事。',
    '箴21:8 負罪之人的路甚是彎曲；至於清潔的人，他所行的乃是正直。',
    '箴21:9 寧可住在房頂的角上，不在寬闊的房屋與爭吵的婦人同住。',
    '箴21:10 惡人的心樂人受禍；他眼並不憐恤鄰舍。',
    '箴21:11 褻慢的人受刑罰，愚蒙的人就得智慧；智慧人受訓誨，便得知識。',
    '箴21:12 義人思想惡人的家，知道惡人傾倒，必致滅亡。',
    '箴21:13 塞耳不聽窮人哀求的，他將來呼籲也不蒙應允。',
    '箴21:14 暗中送的禮物挽回怒氣；懷中搋的賄賂止息暴怒。',
    '箴21:15 秉公行義使義人喜樂，使作孽的人敗壞。',
    '箴21:16 迷離通達道路的，必住在陰魂的會中。',
    '箴21:17 愛宴樂的，必致窮乏；好酒，愛膏油的，必不富足。',
    '箴21:18 惡人作了義人的贖價；奸詐人代替正直人。',
    '箴21:19 寧可住在曠野，不與爭吵使氣的婦人同住。',
    '箴21:20 智慧人家中積蓄寶物膏油；愚昧人隨得來隨吞下。',
    '箴21:21 追求公義仁慈的，就尋得生命、公義，和尊榮。',
    '箴21:22 智慧人爬上勇士的城牆，傾覆他所倚靠的堅壘。',
    '箴21:23 謹守口與舌的，就保守自己免受災難。',
    '箴21:24 心驕氣傲的人名叫褻慢；他行事狂妄，都出於驕傲。',
    '箴21:25 懶惰人的心願將他殺害，因為他手不肯做工。',
    '箴21:26 有終日貪得無饜的；義人施捨而不吝惜。',
    '箴21:27 惡人的祭物是可憎的；何況他存惡意來獻呢﹖',
    '箴21:28 作假見證的必滅亡；惟有聽真情而言的，其言長存。',
    '箴21:29 惡人臉無羞恥；正直人行事堅定。',
    '箴21:30 沒有人能以智慧、聰明、謀略敵擋耶和華。',
    '箴21:31 馬是為打仗之日預備的；得勝乃在乎耶和華。',
    '箴22:1 美名勝過大財；恩寵強如金銀。',
    '箴22:2 富戶窮人在世相遇，都為耶和華所造。',
    '箴22:3 通達人見禍藏躲；愚蒙人前往受害。',
    '箴22:4 敬畏耶和華心存謙卑，就得富有、尊榮、生命為賞賜。',
    '箴22:5 乖僻人的路上有荊棘和網羅；保守自己生命的，必要遠離。',
    '箴22:6 教養孩童，使他走當行的道，就是到老他也不偏離。',
    '箴22:7 富戶管轄窮人；欠債的是債主的僕人。',
    '箴22:8 撒罪孽的，必收災禍；他逞怒的杖也必廢掉。',
    '箴22:9 眼目慈善的，就必蒙福，因他將食物分給窮人。',
    '箴22:10 趕出褻慢人，爭端就消除；紛爭和羞辱也必止息。',
    '箴22:11 喜愛清心的人因他嘴上的恩言，王必與他為友。',
    '箴22:12 耶和華的眼目眷顧聰明人，卻傾敗奸詐人的言語。',
    '箴22:13 懶惰人說：外頭有獅子；我在街上就必被殺。',
    '箴22:14 淫婦的口為深坑；耶和華所憎惡的，必陷在其中。',
    '箴22:15 愚蒙迷住孩童的心，用管教的杖可以遠遠趕除。',
    '箴22:16 欺壓貧窮為要利己的，並送禮與富戶的，都必缺乏。',
    '箴22:17 你須側耳聽受智慧人的言語，留心領會我的知識。',
    '箴22:18 你若心中存記，嘴上咬定，這便為美。',
    '箴22:19 我今日以此特特指教你，為要使你倚靠耶和華。',
    '箴22:20 謀略和知識的美事，我豈沒有寫給你嗎﹖',
    '箴22:21 要使你知道真言的實理，你好將真言回覆那打發你來的人。',
    '箴22:22 貧窮人，你不可因他貧窮就搶奪他的物，也不可在城門口欺壓困苦人；',
    '箴22:23 因耶和華必為他辨屈；搶奪他的，耶和華必奪取那人的命。',
    '箴22:24 好生氣的人，不可與他結交；暴怒的人，不可與他來往；',
    '箴22:25 恐怕你效法他的行為，自己就陷在網羅裡。',
    '箴22:26 不要與人擊掌，不要為欠債的作保。',
    '箴22:27 你若沒有什麼償還，何必使人奪去你睡臥的床呢﹖',
    '箴22:28 你先祖所立的地界，你不可挪移。',
    '箴22:29 你看見辦事殷勤的人嗎﹖他必站在君王面前，必不站在下賤人面前。',
    '箴23:1 你若與官長坐席，要留意在你面前的是誰。',
    '箴23:2 你若是貪食的，就當拿刀放在喉嚨上。',
    '箴23:3 不可貪戀他的美食，因為是哄人的食物。',
    '箴23:4 不要勞碌求富，休仗自己的聰明。',
    '箴23:5 你豈要定睛在虛無的錢財上嗎﹖因錢財必長翅膀，如鷹向天飛去。',
    '箴23:6 不要吃惡眼人的飯，也不要貪他的美味；',
    '箴23:7 因為他心怎樣思量，他為人就是怎樣。他雖對你說，請吃，請喝，他的心卻與你相背。',
    '箴23:8 你所吃的那點食物必吐出來；你所說的甘美言語也必落空。',
    '箴23:9 你不要說話給愚昧人聽，因他必藐視你智慧的言語。',
    '箴23:10 不可挪移古時的地界，也不可侵入孤兒的田地；',
    '箴23:11 因他們的救贖主大有能力，他必向你為他們辨屈。',
    '箴23:12 你要留心領受訓誨，側耳聽從知識的言語。',
    '箴23:13 不可不管教孩童；你用杖打他，他必不至於死。',
    '箴23:14 你要用杖打他，就可以救他的靈魂免下陰間。',
    '箴23:15 我兒，你心若存智慧，我的心也甚歡喜。',
    '箴23:16 你的嘴若說正直話，我的心腸也必快樂。',
    '箴23:17 你心中不要嫉妒罪人，只要終日敬畏耶和華；',
    '箴23:18 因為至終必有善報，你的指望也不致斷絕。',
    '箴23:19 我兒，你當聽，當存智慧，好在正道上引導你的心。',
    '箴23:20 好飲酒的，好吃肉的，不要與他們來往；',
    '箴23:21 因為好酒貪食的，必致貧窮；好睡覺的，必穿破爛衣服。',
    '箴23:22 你要聽從生你的父親；你母親老了，也不可藐視他。',
    '箴23:23 你當買真理；就是智慧、訓誨，和聰明也都不可賣。',
    '箴23:24 義人的父親必大得快樂；人生智慧的兒子，必因他歡喜。',
    '箴23:25 你要使父母歡喜，使生你的快樂。',
    '箴23:26 我兒，要將你的心歸我；你的眼目也要喜悅我的道路。',
    '箴23:27 妓女是深坑；外女是窄阱。',
    '箴23:28 他埋伏好像強盜；他使人中多有奸詐的。',
    '箴23:29 誰有禍患﹖誰有憂愁﹖誰有爭鬥﹖誰有哀歎（或譯：怨言）﹖誰無故受傷﹖誰眼目紅赤﹖',
    '箴23:30 就是那流連飲酒、常去尋找調和酒的人。',
    '箴23:31 酒發紅，在杯中閃爍，你不可觀看，雖然下咽舒暢，終久是咬你如蛇，刺你如毒蛇。',
    '箴23:32 併於上節。',
    '箴23:33 你眼必看見異怪的事（或譯：淫婦）；你心必發出乖謬的話。',
    '箴23:34 你必像躺在海中，或像臥在桅杆上。',
    '箴23:35 你必說：人打我，我卻未受傷；人鞭打我，我竟不覺得。我幾時清醒，我仍去尋酒。',
    '箴24:1 你不要嫉妒惡人，也不要起意與他們相處；',
    '箴24:2 因為，他們的心圖謀強暴，他們的口談論奸惡。',
    '箴24:3 房屋因智慧建造，又因聰明立穩；',
    '箴24:4 其中因知識充滿各樣美好寶貴的財物。',
    '箴24:5 智慧人大有能力；有知識的人力上加力。',
    '箴24:6 你去打仗，要憑智謀；謀士眾多，人便得勝。',
    '箴24:7 智慧極高，非愚昧人所能及，所以在城門內不敢開口。',
    '箴24:8 設計作惡的，必稱為奸人。',
    '箴24:9 愚妄人的思念乃是罪惡；褻慢者為人所憎惡。',
    '箴24:10 你在患難之日若膽怯，你的力量就微小。',
    '箴24:11 人被拉到死地，你要解救；人將被殺，你須攔阻。',
    '箴24:12 你若說：這事我未曾知道，那衡量人心的豈不明白嗎﹖保守你命的豈不知道嗎﹖他豈不按各人所行的報應各人嗎﹖',
    '箴24:13 我兒，你要吃蜜，因為是好的；吃蜂房下滴的蜜便覺甘甜。',
    '箴24:14 你心得了智慧，也必覺得如此。你若找著，至終必有善報；你的指望也不致斷絕。',
    '箴24:15 你這惡人，不要埋伏攻擊義人的家；不要毀壞他安居之所。',
    '箴24:16 因為，義人雖七次跌倒，仍必興起；惡人卻被禍患傾倒。',
    '箴24:17 你仇敵跌倒，你不要歡喜；他傾倒，你心不要快樂；',
    '箴24:18 恐怕耶和華看見就不喜悅，將怒氣從仇敵身上轉過來。',
    '箴24:19 不要為作惡的心懷不平，也不要嫉妒惡人；',
    '箴24:20 因為，惡人終不得善報；惡人的燈也必熄滅。',
    '箴24:21 我兒，你要敬畏耶和華與君王，不要與反覆無常的人結交，',
    '箴24:22 因為他們的災難必忽然而起。耶和華與君王所施行的毀滅，誰能知道呢﹖',
    '箴24:23 以下也是智慧人的箴言：審判時看人情面是不好的。',
    '箴24:24 對惡人說：你是義人的，這人萬民必咒詛，列邦必憎惡。',
    '箴24:25 責備惡人的，必得喜悅；美好的福也必臨到他。',
    '箴24:26 應對正直的，猶如與人親嘴。',
    '箴24:27 你要在外頭預備工料，在田間辦理整齊，然後建造房屋。',
    '箴24:28 不可無故作見證陷害鄰舍，也不可用嘴欺騙人。',
    '箴24:29 不可說：人怎樣待我，我也怎樣待他；我必照他所行的報復他。',
    '箴24:30 我經過懶惰人的田地、無知人的葡萄園，',
    '箴24:31 荊棘長滿了地皮，刺草遮蓋了田面，石牆也坍塌了。',
    '箴24:32 我看見就留心思想；我看著就領了訓誨。',
    '箴24:33 再睡片時，打盹片時，抱著手躺臥片時，',
    '箴24:34 你的貧窮就必如強盜速來，你的缺乏彷彿拿兵器的人來到。',
    '箴25:1 以下也是所羅門的箴言，是猶大王希西家的人所謄錄的。',
    '箴25:2 將事隱祕乃神的榮耀；將事察清乃君王的榮耀。',
    '箴25:3 天之高，地之厚，君王之心也測不透。',
    '箴25:4 除去銀子的渣滓就有銀子出來，銀匠能以做器皿。',
    '箴25:5 除去王面前的惡人，國位就靠公義堅立。',
    '箴25:6 不要在王面前妄自尊大；不要在大人的位上站立。',
    '箴25:7 寧可有人說：請你上來，強如在你覲見的王子面前叫你退下。',
    '箴25:8 不要冒失出去與人爭競，免得至終被他羞辱，你就不知道怎樣行了。',
    '箴25:9 你與鄰舍爭訟，要與他一人辯論，不可洩漏人的密事，',
    '箴25:10 恐怕聽見的人罵你，你的臭名就難以脫離。',
    '箴25:11 一句話說得合宜，就如金蘋果在銀網子裡。',
    '箴25:12 智慧人的勸戒，在順從的人耳中，好像金耳環和精金的妝飾。',
    '箴25:13 忠信的使者叫差他的人心裡舒暢，就如在收割時有冰雪的涼氣。',
    '箴25:14 空誇贈送禮物的，好像無雨的風雲。',
    '箴25:15 恆常忍耐可以勸動君王；柔和的舌頭能折斷骨頭。',
    '箴25:16 你得了蜜嗎﹖只可吃夠而已，恐怕你過飽就嘔吐出來。',
    '箴25:17 你的腳要少進鄰舍的家，恐怕他厭煩你，恨惡你。',
    '箴25:18 作假見證陷害鄰舍的，就是大槌，是利刀，是快箭。',
    '箴25:19 患難時倚靠不忠誠的人，好像破壞的牙，錯骨縫的腳。',
    '箴25:20 對傷心的人唱歌，就如冷天脫衣服，又如鹼上倒醋。',
    '箴25:21 你的仇敵若餓了，就給他飯吃；若渴了，就給他水喝；',
    '箴25:22 因為，你這樣行就是把炭火堆在他的頭上；耶和華也必賞賜你。',
    '箴25:23 北風生雨，讒謗人的舌頭也生怒容。',
    '箴25:24 寧可住在房頂的角上，不在寬闊的房屋與爭吵的婦人同住。',
    '箴25:25 有好消息從遠方來，就如拿涼水給口渴的人喝。',
    '箴25:26 義人在惡人面前退縮，好像逿渾之泉，弄濁之井。',
    '箴25:27 吃蜜過多是不好的；考究自己的榮耀也是可厭的。',
    '箴25:28 人不制伏自己的心，好像毀壞的城邑沒有牆垣。',
    '箴26:1 夏天落雪，收割時下雨，都不相宜；愚昧人得尊榮也是如此。',
    '箴26:2 麻雀往來，燕子翻飛；這樣，無故的咒詛也必不臨到。',
    '箴26:3 鞭子是為打馬，轡頭是為勒驢；刑杖是為打愚昧人的背。',
    '箴26:4 不要照愚昧人的愚妄話回答他，恐怕你與他一樣。',
    '箴26:5 要照愚昧人的愚妄話回答他，免得他自以為有智慧。',
    '箴26:6 藉愚昧人手寄信的，是砍斷自己的腳，自受（原文是：喝）損害。',
    '箴26:7 瘸子的腳空存無用；箴言在愚昧人的口中也是如此。',
    '箴26:8 將尊榮給愚昧人的，好像人把石子包在機弦裡。',
    '箴26:9 箴言在愚昧人的口中，好像荊棘刺入醉漢的手。',
    '箴26:10 雇愚昧人的，與雇過路人的，就像射傷眾人的弓箭手。',
    '箴26:11 愚昧人行愚妄事，行了又行，就如狗轉過來吃他所吐的。',
    '箴26:12 你見自以為有智慧的人嗎﹖愚昧人比他更有指望。',
    '箴26:13 懶惰人說：道上有猛獅，街上有壯獅。',
    '箴26:14 門在樞紐轉動，懶惰人在床上也是如此。',
    '箴26:15 懶惰人放手在盤子裡，就是向口撤回也以為勞乏。',
    '箴26:16 懶惰人看自己比七個善於應對的人更有智慧。',
    '箴26:17 過路被事激動，管理不干己的爭競，好像人揪住狗耳。',
    '箴26:18 人欺凌鄰舍，卻說：我豈不是戲耍嗎﹖他就像瘋狂的人拋擲火把、利箭，與殺人的兵器（原文是死亡）。',
    '箴26:19 併於上節。',
    '箴26:20 火缺了柴就必熄滅；無人傳舌，爭競便止息。',
    '箴26:21 好爭競的人煽惑爭端，就如餘火加炭，火上加柴一樣。',
    '箴26:22 傳舌人的言語，如同美食，深入人的心腹。',
    '箴26:23 火熱的嘴，奸惡的心，好像銀渣包的瓦器。',
    '箴26:24 怨恨人的，用嘴粉飾，心裡卻藏著詭詐；',
    '箴26:25 他用甜言蜜語，你不可信他，因為他心中有七樣可憎惡的。',
    '箴26:26 他雖用詭詐遮掩自己的怨恨，他的邪惡必在會中顯露。',
    '箴26:27 挖陷坑的，自己必掉在其中；滾石頭的，石頭必反滾在他身上。',
    '箴26:28 虛謊的舌恨他所壓傷的人；諂媚的口敗壞人的事。',
    '箴27:1 不要為明日自誇，因為一日要生何事，你尚且不能知道。',
    '箴27:2 要別人誇獎你，不可用口自誇；等外人稱讚你，不可用嘴自稱。',
    '箴27:3 石頭重，沙土沉，愚妄人的惱怒比這兩樣更重。',
    '箴27:4 忿怒為殘忍，怒氣為狂瀾，惟有嫉妒，誰能敵得住呢﹖',
    '箴27:5 當面的責備強如背地的愛情。',
    '箴27:6 朋友加的傷痕出於忠誠；仇敵連連親嘴卻是多餘。',
    '箴27:7 人吃飽了，厭惡蜂房的蜜；人飢餓了，一切苦物都覺甘甜。',
    '箴27:8 人離本處飄流，好像雀鳥離窩遊飛。',
    '箴27:9 膏油與香料使人心喜悅；朋友誠實的勸教也是如此甘美。',
    '箴27:10 你的朋友和父親的朋友，你都不可離棄。你遭難的日子，不要上弟兄的家去；相近的鄰舍強如遠方的弟兄。',
    '箴27:11 我兒，你要作智慧人，好叫我的心歡喜，使我可以回答那譏誚我的人。',
    '箴27:12 通達人見禍藏躲；愚蒙人前往受害。',
    '箴27:13 誰為生人作保，就拿誰的衣服；誰為外女作保，誰就承當。',
    '箴27:14 清晨起來，大聲給朋友祝福的，就算是咒詛他。',
    '箴27:15 大雨之日連連滴漏，和爭吵的婦人一樣；',
    '箴27:16 想攔阻他的，便是攔阻風，也是右手抓油。',
    '箴27:17 鐵磨鐵，磨出刃來；朋友相感（原文是磨朋友的臉）也是如此。',
    '箴27:18 看守無花果樹的，必吃樹上的果子；敬奉主人的，必得尊榮。',
    '箴27:19 水中照臉，彼此相符；人與人，心也相對。',
    '箴27:20 陰間和滅亡永不滿足；人的眼目也是如此。',
    '箴27:21 鼎為煉銀，爐為煉金，人的稱讚也試煉人。',
    '箴27:22 你雖用杵將愚妄人與打碎的麥子一同搗在臼中，他的愚妄還是離不了他。',
    '箴27:23 你要詳細知道你羊群的景況，留心料理你的牛群；',
    '箴27:24 因為資財不能永有，冠冕豈能存到萬代﹖',
    '箴27:25 乾草割去，嫩草發現，山上的菜蔬也被收斂。',
    '箴27:26 羊羔之毛是為你作衣服；山羊是為作田地的價值，',
    '箴27:27 並有母山羊奶夠你吃，也夠你的家眷吃，且夠養你的婢女。',
    '箴28:1 惡人雖無人追趕也逃跑；義人卻膽壯像獅子。',
    '箴28:2 邦國因有罪過，君王就多更換；因有聰明知識的人，國必長存。',
    '箴28:3 窮人欺壓貧民，好像暴雨沖沒糧食。',
    '箴28:4 違棄律法的，誇獎惡人；遵守律法的，卻與惡人相爭。',
    '箴28:5 壞人不明白公義；惟有尋求耶和華的，無不明白。',
    '箴28:6 行為純正的窮乏人勝過行事乖僻的富足人。',
    '箴28:7 謹守律法的，是智慧之子；與貪食人作伴的，卻羞辱其父。',
    '箴28:8 人以厚利加增財物，是給那憐憫窮人者積蓄的。',
    '箴28:9 轉耳不聽律法的，他的祈禱也為可憎。',
    '箴28:10 誘惑正直人行惡道的，必掉在自己的坑裡；惟有完全人必承受福分。',
    '箴28:11 富足人自以為有智慧，但聰明的貧窮人能將他查透。',
    '箴28:12 義人得志，有大榮耀；惡人興起，人就躲藏。',
    '箴28:13 遮掩自己罪過的，必不亨通；承認離棄罪過的，必蒙憐恤。',
    '箴28:14 常存敬畏的，便為有福；心存剛硬的，必陷在禍患裡。',
    '箴28:15 暴虐的君王轄制貧民，好像吼叫的獅子、覓食的熊。',
    '箴28:16 無知的君多行暴虐；以貪財為可恨的，必年長日久。',
    '箴28:17 背負流人血之罪的，必往坑裡奔跑，誰也不可攔阻他。',
    '箴28:18 行動正直的，必蒙拯救；行事彎曲的，立時跌倒。',
    '箴28:19 耕種自己田地的，必得飽食；追隨虛浮的，足受窮乏。',
    '箴28:20 誠實人必多得福；想要急速發財的，不免受罰。',
    '箴28:21 看人的情面乃為不好；人因一塊餅枉法也為不好。',
    '箴28:22 人有惡眼想要急速發財，卻不知窮乏必臨到他身。',
    '箴28:23 責備人的，後來蒙人喜悅，多於那用舌頭諂媚人的。',
    '箴28:24 偷竊父母的，說：這不是罪，此人就是與強盜同類。',
    '箴28:25 心中貪婪的，挑起爭端；倚靠耶和華的，必得豐裕。',
    '箴28:26 心中自是的，便是愚昧人；憑智慧行事的，必蒙拯救。',
    '箴28:27 賙濟貧窮的，不致缺乏；佯為不見的，必多受咒詛。',
    '箴28:28 惡人興起，人就躲藏；惡人敗亡，義人增多。',
    '箴29:1 人屢次受責罰，仍然硬著頸項；他必頃刻敗壞，無法可治。',
    '箴29:2 義人增多，民就喜樂；惡人掌權，民就歎息。',
    '箴29:3 愛慕智慧的，使父親喜樂；與妓女結交的，卻浪費錢財。',
    '箴29:4 王藉公平，使國堅定；索要賄賂，使國傾敗。',
    '箴29:5 諂媚鄰舍的，就是設網羅絆他的腳。',
    '箴29:6 惡人犯罪，自陷網羅；惟獨義人歡呼喜樂。',
    '箴29:7 義人知道查明窮人的案；惡人沒有聰明，就不得而知。',
    '箴29:8 褻慢人煽惑通城；智慧人止息眾怒。',
    '箴29:9 智慧人與愚妄人相爭，或怒或笑，總不能使他止息。',
    '箴29:10 好流人血的，恨惡完全人，索取正直人的性命。',
    '箴29:11 愚妄人怒氣全發；智慧人忍氣含怒。',
    '箴29:12 君王若聽謊言，他一切臣僕都是奸惡。',
    '箴29:13 貧窮人、強暴人在世相遇；他們的眼目都蒙耶和華光照。',
    '箴29:14 君王憑誠實判斷窮人；他的國位必永遠堅立。',
    '箴29:15 杖打和責備能加增智慧；放縱的兒子使母親羞愧。',
    '箴29:16 惡人加多，過犯也加多，義人必看見他們跌倒。',
    '箴29:17 管教你的兒子，他就使你得安息，也必使你心裡喜樂。',
    '箴29:18 沒有異象（或譯：默示），民就放肆；惟遵守律法的，便為有福。',
    '箴29:19 只用言語，僕人不肯受管教；他雖然明白，也不留意。',
    '箴29:20 你見言語急躁的人嗎﹖愚昧人比他更有指望。',
    '箴29:21 人將僕人從小嬌養，這僕人終久必成了他的兒子。',
    '箴29:22 好氣的人挑啟爭端；暴怒的人多多犯罪。',
    '箴29:23 人的高傲必使他卑下；心裡謙遜的，必得尊榮。',
    '箴29:24 人與盜賊分贓，是恨惡自己的性命；他聽見叫人發誓的聲音，卻不言語。',
    '箴29:25 懼怕人的，陷入網羅；惟有倚靠耶和華的，必得安穩。',
    '箴29:26 求王恩的人多；定人事乃在耶和華。',
    '箴29:27 為非作歹的，被義人憎嫌；行事正直的，被惡人憎惡。',
    '箴30:1 雅基的兒子亞古珥的言語就是真言。這人對以鐵和烏甲說：',
    '箴30:2 我比眾人更蠢笨，也沒有人的聰明。',
    '箴30:3 我沒有學好智慧，也不認識至聖者。',
    '箴30:4 誰升天又降下來﹖誰聚風在掌握中﹖誰包水在衣服裡﹖誰立定地的四極﹖他名叫什麼﹖他兒子名叫什麼﹖你知道嗎﹖',
    '箴30:5 神的言語句句都是煉淨的；投靠他的，他便作他們的盾牌。',
    '箴30:6 他的言語，你不可加添，恐怕他責備你，你就顯為說謊言的。',
    '箴30:7 我求你兩件事，在我未死之先，不要不賜給我：',
    '箴30:8 求你使虛假和謊言遠離我；使我也不貧窮也不富足；賜給我需用的飲食，',
    '箴30:9 恐怕我飽足不認你，說：耶和華是誰呢﹖又恐怕我貧窮就偷竊，以致褻瀆我神的名。',
    '箴30:10 你不要向主人讒謗僕人，恐怕他咒詛你，你便算為有罪。',
    '箴30:11 有一宗人（宗：原文是代；下同），咒詛父親，不給母親祝福。',
    '箴30:12 有一宗人，自以為清潔，卻沒有洗去自己的污穢。',
    '箴30:13 有一宗人，眼目何其高傲，眼皮也是高舉。',
    '箴30:14 有一宗人，牙如劍，齒如刀，要吞滅地上的困苦人和世間的窮乏人。',
    '箴30:15 螞蟥有兩個女兒，常說：給呀，給呀！有三樣不知足的，連不說夠的共有四樣：',
    '箴30:16 就是陰間和石胎，浸水不足的地，並火。',
    '箴30:17 戲笑父親、藐視而不聽從母親的，他的眼睛必為谷中的烏鴉啄出來，為鷹雛所吃。',
    '箴30:18 我所測不透的奇妙有三樣，連我所不知道的共有四樣：',
    '箴30:19 就是鷹在空中飛的道；蛇在磐石上爬的道；船在海中行的道；男與女交合的道。',
    '箴30:20 淫婦的道也是這樣：他吃了，把嘴一擦就說：我沒有行惡。',
    '箴30:21 使地震動的有三樣，連地擔不起的共有四樣：',
    '箴30:22 就是僕人作王；愚頑人吃飽；',
    '箴30:23 醜惡的女子出嫁；婢女接續主母。',
    '箴30:24 地上有四樣小物，卻甚聰明：',
    '箴30:25 螞蟻是無力之類，卻在夏天預備糧食。',
    '箴30:26 沙番是軟弱之類，卻在磐石中造房。',
    '箴30:27 蝗蟲沒有君王，卻分隊而出。',
    '箴30:28 守宮用爪抓牆，卻住在王宮。',
    '箴30:29 步行威武的有三樣，連行走威武的共有四樣：',
    '箴30:30 就是獅子─乃百獸中最為猛烈、無所躲避的，',
    '箴30:31 獵狗，公山羊，和無人能敵的君王。',
    '箴30:32 你若行事愚頑，自高自傲，或是懷了惡念，就當用手摀口。',
    '箴30:33 搖牛奶必成奶油；扭鼻子必出血。照樣，激動怒氣必起爭端。',
    '箴31:1 利慕伊勒王的言語，是他母親教訓他的真言。',
    '箴31:2 我的兒啊，我腹中生的兒啊，我許願得的兒啊！我當怎樣教訓你呢﹖',
    '箴31:3 不要將你的精力給婦女；也不要有敗壞君王的行為。',
    '箴31:4 利慕伊勒啊，君王喝酒，君王喝酒不相宜；王子說濃酒在那裡也不相宜；',
    '箴31:5 恐怕喝了就忘記律例，顛倒一切困苦人的是非。',
    '箴31:6 可以把濃酒給將亡的人喝，把清酒給苦心的人喝，',
    '箴31:7 讓他喝了，就忘記他的貧窮，不再記念他的苦楚。',
    '箴31:8 你當為啞巴（或譯：不能自辯的）開口，為一切孤獨的伸冤。',
    '箴31:9 你當開口按公義判斷，為困苦和窮乏的辨屈。',
    '箴31:10 才德的婦人誰能得著呢﹖他的價值遠勝過珍珠。',
    '箴31:11 他丈夫心裡倚靠他，必不缺少利益；',
    '箴31:12 他一生使丈夫有益無損。',
    '箴31:13 他尋找羊羢和麻，甘心用手做工。',
    '箴31:14 他好像商船從遠方運糧來，',
    '箴31:15 未到黎明他就起來，把食物分給家中的人，將當做的工分派婢女。',
    '箴31:16 他想得田地就買來；用手所得之利栽種葡萄園。',
    '箴31:17 他以能力束腰，使膀臂有力。',
    '箴31:18 他覺得所經營的有利；他的燈終夜不滅。',
    '箴31:19 他手拿撚線竿，手把紡線車。',
    '箴31:20 他張手賙濟困苦人，伸手幫補窮乏人。',
    '箴31:21 他不因下雪為家裡的人擔心，因為全家都穿著朱紅衣服。',
    '箴31:22 他為自己製作繡花毯子；他的衣服是細麻和紫色布做的。',
    '箴31:23 他丈夫在城門口與本地的長老同坐，為眾人所認識。',
    '箴31:24 他做細麻布衣裳出賣，又將腰帶賣與商家。',
    '箴31:25 能力和威儀是他的衣服；他想到日後的景況就喜笑。',
    '箴31:26 他開口就發智慧；他舌上有仁慈的法則。',
    '箴31:27 他觀察家務，並不吃閒飯。',
    '箴31:28 他的兒女起來稱他有福；他的丈夫也稱讚他，',
    '箴31:29 說：才德的女子很多，惟獨你超過一切。',
    '箴31:30 艷麗是虛假的，美容是虛浮的；惟敬畏耶和華的婦女必得稱讚。',
    '箴31:31 願他享受操作所得的；願他的工作在城門口榮耀他。',
    '傳1:1 在耶路撒冷作王、大衛的兒子、傳道者的言語。',
    '傳1:2 傳道者說：虛空的虛空，虛空的虛空，凡事都是虛空。',
    '傳1:3 人一切的勞碌，就是他在日光之下的勞碌，有什麼益處呢﹖',
    '傳1:4 一代過去，一代又來，地卻永遠長存。',
    '傳1:5 日頭出來，日頭落下，急歸所出之地。',
    '傳1:6 風往南颳，又向北轉，不住地旋轉，而且返回轉行原道。',
    '傳1:7 江河都往海裡流，海卻不滿；江河從何處流，仍歸還何處。',
    '傳1:8 萬事令人厭煩（或譯：萬物滿有困乏），人不能說盡。眼看，看不飽；耳聽，聽不足。',
    '傳1:9 已有的事後必再有；已行的事後必再行。日光之下並無新事。',
    '傳1:10 豈有一件事人能指著說這是新的﹖哪知，在我們以前的世代早已有了。',
    '傳1:11 已過的世代，無人記念；將來的世代，後來的人也不記念。',
    '傳1:12 我傳道者在耶路撒冷作過以色列的王。',
    '傳1:13 我專心用智慧尋求、查究天下所做的一切事，乃知神叫世人所經練的是極重的勞苦。',
    '傳1:14 我見日光之下所做的一切事，都是虛空，都是捕風。',
    '傳1:15 彎曲的，不能變直；缺少的，不能足數。',
    '傳1:16 我心裡議論說：我得了大智慧，勝過我以前在耶路撒冷的眾人，而且我心中多經歷智慧和知識的事。',
    '傳1:17 我又專心察明智慧、狂妄，和愚昧，乃知這也是捕風。',
    '傳1:18 因為多有智慧，就多有愁煩；加增知識的，就加增憂傷。',
    '傳2:1 我心裡說：來吧，我以喜樂試試你，你好享福！誰知，這也是虛空。',
    '傳2:2 我指嬉笑說：這是狂妄。論喜樂說：有何功效呢﹖',
    '傳2:3 我心裡察究，如何用酒使我肉體舒暢，我心卻仍以智慧引導我；又如何持住愚昧，等我看明世人，在天下一生當行何事為美。',
    '傳2:4 我為自己動大工程，建造房屋，栽種葡萄園，',
    '傳2:5 修造園囿，在其中栽種各樣果木樹；',
    '傳2:6 挖造水池，用以澆灌嫩小的樹木。',
    '傳2:7 我買了僕婢，也有生在家中的僕婢；又有許多牛群羊群，勝過以前在耶路撒冷眾人所有的。',
    '傳2:8 我又為自己積蓄金銀和君王的財寶，並各省的財寶；又得唱歌的男女和世人所喜愛的物，並許多的妃嬪。',
    '傳2:9 這樣，我就日見昌盛，勝過以前在耶路撒冷的眾人。我的智慧仍然存留。',
    '傳2:10 凡我眼所求的，我沒有留下不給他的；我心所樂的，我沒有禁止不享受的；因我的心為我一切所勞碌的快樂，這就是我從勞碌中所得的分。',
    '傳2:11 後來，我察看我手所經營的一切事和我勞碌所成的功。誰知都是虛空，都是捕風；在日光之下毫無益處。',
    '傳2:12 我轉念觀看智慧、狂妄，和愚昧。在王以後而來的人還能做什麼呢﹖也不過行早先所行的就是了。',
    '傳2:13 我便看出智慧勝過愚昧，如同光明勝過黑暗。',
    '傳2:14 智慧人的眼目光明（光明原文是在他頭上），愚昧人在黑暗裡行。我卻看明有一件事，這兩等人都必遇見。',
    '傳2:15 我就心裡說：愚昧人所遇見的，我也必遇見，我為何更有智慧呢﹖我心裡說，這也是虛空。',
    '傳2:16 智慧人和愚昧人一樣，永遠無人記念，因為日後都被忘記；可歎智慧人死亡，與愚昧人無異。',
    '傳2:17 我所以恨惡生命；因為在日光之下所行的事我都以為煩惱，都是虛空，都是捕風。',
    '傳2:18 我恨惡一切的勞碌，就是我在日光之下的勞碌，因為我得來的必留給我以後的人。',
    '傳2:19 那人是智慧是愚昧，誰能知道﹖他竟要管理我勞碌所得的，就是我在日光之下用智慧所得的。這也是虛空。',
    '傳2:20 故此，我轉想我在日光之下所勞碌的一切工作，心便絕望。',
    '傳2:21 因為有人用智慧、知識、靈巧所勞碌得來的，卻要留給未曾勞碌的人為分。這也是虛空，也是大患。',
    '傳2:22 人在日光之下勞碌累心，在他一切的勞碌上得著什麼呢﹖',
    '傳2:23 因為他日日憂慮，他的勞苦成為愁煩，連夜間心也不安。這也是虛空。',
    '傳2:24 人莫強如吃喝，且在勞碌中享福，我看這也是出於神的手。',
    '傳2:25 論到吃用、享福，誰能勝過我呢﹖',
    '傳2:26 神喜悅誰，就給誰智慧、知識，和喜樂；惟有罪人，神使他勞苦，叫他將所收聚的、所堆積的歸給神所喜悅的人。這也是虛空，也是捕風。',
    '傳3:1 凡事都有定期，天下萬務都有定時。',
    '傳3:2 生有時，死有時；栽種有時，拔出所栽種的也有時；',
    '傳3:3 殺戮有時，醫治有時；拆毀有時，建造有時；',
    '傳3:4 哭有時，笑有時；哀慟有時，跳舞有時；',
    '傳3:5 拋擲石頭有時，堆聚石頭有時；懷抱有時，不懷抱有時；',
    '傳3:6 尋找有時，失落有時；保守有時，捨棄有時；',
    '傳3:7 撕裂有時，縫補有時；靜默有時，言語有時；',
    '傳3:8 喜愛有時，恨惡有時；爭戰有時，和好有時。',
    '傳3:9 這樣看來，做事的人在他的勞碌上有什麼益處呢﹖',
    '傳3:10 我見神叫世人勞苦，使他們在其中受經練。',
    '傳3:11 神造萬物，各按其時成為美好，又將永生（原文是永遠）安置在世人心裡。然而神從始至終的作為，人不能參透。',
    '傳3:12 我知道世人，莫強如終身喜樂行善；',
    '傳3:13 並且人人吃喝，在他一切勞碌中享福，這也是神的恩賜。',
    '傳3:14 我知道神一切所做的都必永存；無所增添，無所減少。神這樣行，是要人在他面前存敬畏的心。',
    '傳3:15 現今的事早先就有了，將來的事早已也有了，並且神使已過的事重新再來（或譯：並且神再尋回已過的事）。',
    '傳3:16 我又見日光之下，在審判之處有奸惡，在公義之處也有奸惡。',
    '傳3:17 我心裡說，神必審判義人和惡人；因為在那裡，各樣事務，一切工作，都有定時。',
    '傳3:18 我心裡說，這乃為世人的緣故，是神要試驗他們，使他們覺得自己不過像獸一樣。',
    '傳3:19 因為世人遭遇的，獸也遭遇，所遭遇的都是一樣：這個怎樣死，那個也怎樣死，氣息都是一樣。人不能強於獸，都是虛空。',
    '傳3:20 都歸一處，都是出於塵土，也都歸於塵土。',
    '傳3:21 誰知道人的靈是往上升，獸的魂是下入地呢﹖',
    '傳3:22 故此，我見人莫強如在他經營的事上喜樂，因為這是他的分。他身後的事誰能使他回來得見呢﹖',
    '傳4:1 我又轉念，見日光之下所行的一切欺壓。看哪，受欺壓的流淚，且無人安慰；欺壓他們的有勢力，也無人安慰他們。',
    '傳4:2 因此，我讚歎那早已死的死人，勝過那還活著的活人。',
    '傳4:3 並且我以為那未曾生的，就是未見過日光之下惡事的，比這兩等人更強。',
    '傳4:4 我又見人為一切的勞碌和各樣靈巧的工作就被鄰舍嫉妒。這也是虛空，也是捕風。',
    '傳4:5 愚昧人抱著手，吃自己的肉。',
    '傳4:6 滿了一把，得享安靜，強如滿了兩把，勞碌捕風。',
    '傳4:7 我又轉念，見日光之下有一件虛空的事：',
    '傳4:8 有人孤單無二，無子無兄，竟勞碌不息，眼目也不以錢財為足。他說：我勞勞碌碌，刻苦自己，不享福樂，到底是為誰呢﹖這也是虛空，是極重的勞苦。',
    '傳4:9 兩個人總比一個人好，因為二人勞碌同得美好的果效。',
    '傳4:10 若是跌倒，這人可以扶起他的同伴；若是孤身跌倒，沒有別人扶起他來，這人就有禍了。',
    '傳4:11 再者，二人同睡就都暖和，一人獨睡怎能暖和呢﹖',
    '傳4:12 有人攻勝孤身一人，若有二人便能敵擋他；三股合成的繩子不容易折斷。',
    '傳4:13 貧窮而有智慧的少年人勝過年老不肯納諫的愚昧王。',
    '傳4:14 這人是從監牢中出來作王，在他國中，生來原是貧窮的。',
    '傳4:15 我見日光之下一切行動的活人都隨從那第二位，就是起來代替老王的少年人。',
    '傳4:16 他所治理的眾人就是他的百姓，多得無數；在他後來的人尚且不喜悅他。這真是虛空，也是捕風。',
    '傳5:1 你到神的殿要謹慎腳步；因為近前聽，勝過愚昧人獻祭（或譯：勝過獻愚昧人的祭），他們本不知道所做的是惡。',
    '傳5:2 你在神面前不可冒失開口，也不可心急發言；因為神在天上，你在地下，所以你的言語要寡少。',
    '傳5:3 事務多，就令人做夢；言語多，就顯出愚昧。',
    '傳5:4 你向神許願，償還不可遲延，因他不喜悅愚昧人，所以你許的願應當償還。',
    '傳5:5 你許願不還，不如不許。',
    '傳5:6 不可任你的口使肉體犯罪，也不可在祭司（原文是使者）面前說是錯許了。為何使神因你的聲音發怒，敗壞你手所做的呢﹖',
    '傳5:7 多夢和多言，其中多有虛幻，你只要敬畏神。',
    '傳5:8 你若在一省之中見窮人受欺壓，並奪去公義公平的事，不要因此詫異；因有一位高過居高位的鑒察，在他們以上還有更高的。',
    '傳5:9 況且地的益處歸眾人，就是君王也受田地的供應。',
    '傳5:10 貪愛銀子的，不因得銀子知足；貪愛豐富的，也不因得利益知足。這也是虛空。',
    '傳5:11 貨物增添，吃的人也增添，物主得什麼益處呢﹖不過眼看而已！',
    '傳5:12 勞碌的人不拘吃多吃少，睡得香甜；富足人的豐滿卻不容他睡覺。',
    '傳5:13 我見日光之下有一宗大禍患，就是財主積存資財，反害自己。',
    '傳5:14 因遭遇禍患，這些資財就消滅；那人若生了兒子，手裡也一無所有。',
    '傳5:15 他怎樣從母胎赤身而來，也必照樣赤身而去；他所勞碌得來的，手中分毫不能帶去。',
    '傳5:16 他來的情形怎樣，他去的情形也怎樣。這也是一宗大禍患。他為風勞碌有什麼益處呢﹖',
    '傳5:17 並且他終身在黑暗中吃喝，多有煩惱，又有病患嘔氣。',
    '傳5:18 我所見為善為美的，就是人在神賜他一生的日子吃喝，享受日光之下勞碌得來的好處，因為這是他的分。',
    '傳5:19 神賜人資財豐富，使他能以吃用，能取自己的分，在他勞碌中喜樂，這乃是神的恩賜。',
    '傳5:20 他不多思念自己一生的年日，因為神應他的心使他喜樂。',
    '傳6:1 我見日光之下有一宗禍患重壓在人身上，',
    '傳6:2 就是人蒙神賜他資財、豐富、尊榮，以致他心裡所願的一樣都不缺，只是神使他不能吃用，反有外人來吃用。這是虛空，也是禍患。',
    '傳6:3 人若生一百個兒子，活許多歲數，以致他的年日甚多，心裡卻不得滿享福樂，又不得埋葬；據我說，那不到期而落的胎比他倒好。',
    '傳6:4 因為虛虛而來，暗暗而去，名字被黑暗遮蔽，',
    '傳6:5 並且沒有見過天日，也毫無知覺；這胎，比那人倒享安息。',
    '傳6:6 那人雖然活千年，再活千年，卻不享福，眾人豈不都歸一個地方去嗎﹖',
    '傳6:7 人的勞碌都為口腹，心裡卻不知足。',
    '傳6:8 這樣看來，智慧人比愚昧人有什麼長處呢﹖窮人在眾人面前知道如何行，有什麼長處呢﹖',
    '傳6:9 眼睛所看的比心裡妄想的倒好。這也是虛空，也是捕風。',
    '傳6:10 先前所有的，早已起了名，並知道何為人，他也不能與那比自己力大的相爭。',
    '傳6:11 加增虛浮的事既多，這於人有什麼益處呢﹖',
    '傳6:12 人一生虛度的日子，就如影兒經過，誰知道什麼於他有益呢﹖誰能告訴他身後在日光之下有什麼事呢﹖',
    '傳7:1 名譽強如美好的膏油；人死的日子勝過人生的日子。',
    '傳7:2 往遭喪的家去，強如往宴樂的家去；因為死是眾人的結局，活人也必將這事放在心上。',
    '傳7:3 憂愁強如喜笑；因為面帶愁容，終必使心喜樂。',
    '傳7:4 智慧人的心在遭喪之家；愚昧人的心在快樂之家。',
    '傳7:5 聽智慧人的責備，強如聽愚昧人的歌唱。',
    '傳7:6 愚昧人的笑聲，好像鍋下燒荊棘的爆聲；這也是虛空。',
    '傳7:7 勒索使智慧人變為愚妄；賄賂能敗壞人的慧心。',
    '傳7:8 事情的終局強如事情的起頭；存心忍耐的，勝過居心驕傲的。',
    '傳7:9 你不要心裡急躁惱怒，因為惱怒存在愚昧人的懷中。',
    '傳7:10 不要說：先前的日子強過如今的日子，是什麼緣故呢﹖你這樣問，不是出於智慧。',
    '傳7:11 智慧和產業並好，而且見天日的人得智慧更為有益。',
    '傳7:12 因為智慧護庇人，好像銀錢護庇人一樣。惟獨智慧能保全智慧人的生命。這就是知識的益處。',
    '傳7:13 你要察看神的作為；因神使為曲的，誰能變為直呢﹖',
    '傳7:14 遇亨通的日子你當喜樂；遭患難的日子你當思想；因為神使這兩樣並列，為的是叫人查不出身後有什麼事。',
    '傳7:15 有義人行義，反致滅亡；有惡人行惡，倒享長壽。這都是我在虛度之日中所見過的。',
    '傳7:16 不要行義過分，也不要過於自逞智慧，何必自取敗亡呢﹖',
    '傳7:17 不要行惡過分，也不要為人愚昧，何必不到期而死呢﹖',
    '傳7:18 你持守這個為美，那個也不要鬆手；因為敬畏神的人，必從這兩樣出來。',
    '傳7:19 智慧使有智慧的人比城中十個官長更有能力。',
    '傳7:20 時常行善而不犯罪的義人，世上實在沒有。',
    '傳7:21 人所說的一切話，你不要放在心上，恐怕聽見你的僕人咒詛你。',
    '傳7:22 因為你心裡知道，自己也曾屢次咒詛別人。',
    '傳7:23 我曾用智慧試驗這一切事；我說，要得智慧，智慧卻離我遠。',
    '傳7:24 萬事之理，離我甚遠，而且最深，誰能測透呢﹖',
    '傳7:25 我轉念，一心要知道，要考察，要尋求智慧和萬事的理由；又要知道邪惡為愚昧，愚昧為狂妄。',
    '傳7:26 我得知有等婦人比死還苦：他的心是網羅，手是鎖鍊。凡蒙神喜悅的人必能躲避他；有罪的人卻被他纏住了。',
    '傳7:27 傳道者說：看哪，一千男子中，我找到一個正直人，但眾女子中，沒有找到一個。我將這事一一比較，要尋求其理，我心仍要尋找，卻未曾找到。',
    '傳7:28 併於上節。',
    '傳7:29 我所找到的只有一件，就是神造人原是正直，但他們尋出許多巧計。',
    '傳8:1 誰如智慧人呢﹖誰知道事情的解釋呢﹖人的智慧使他的臉發光，並使他臉上的暴氣改變。',
    '傳8:2 我勸你遵守王的命令；既指神起誓，理當如此。',
    '傳8:3 不要急躁離開王的面前，不要固執行惡，因為他凡事都隨自己的心意而行。',
    '傳8:4 王的話本有權力，誰敢問他說你做什麼呢﹖',
    '傳8:5 凡遵守命令的，必不經歷禍患；智慧人的心能辨明時候和定理（原文是審判；下節同）。',
    '傳8:6 各樣事務成就都有時候和定理，因為人的苦難重壓在他身上。',
    '傳8:7 他不知道將來的事，因為將來如何，誰能告訴他呢﹖',
    '傳8:8 無人有權力掌管生命，將生命留住；也無人有權力掌管死期；這場爭戰，無人能免；邪惡也不能救那好行邪惡的人。',
    '傳8:9 這一切我都見過，也專心查考日光之下所做的一切事。有時這人管轄那人，令人受害。',
    '傳8:10 我見惡人埋葬，歸入墳墓；又見行正直事的離開聖地，在城中被人忘記。這也是虛空。',
    '傳8:11 因為斷定罪名不立刻施刑，所以世人滿心作惡。',
    '傳8:12 罪人雖然作惡百次，倒享長久的年日；然而我準知道，敬畏神的，就是在他面前敬畏的人，終久必得福樂。',
    '傳8:13 惡人卻不得福樂，也不得長久的年日；這年日好像影兒，因他不敬畏神。',
    '傳8:14 世上有一件虛空的事，就是義人所遭遇的，反照惡人所行的；又有惡人所遭遇的，反照義人所行的。我說，這也是虛空。',
    '傳8:15 我就稱讚快樂，原來人在日光之下，莫強如吃喝快樂；因為他在日光之下，神賜他一生的年日，要從勞碌中，時常享受所得的。',
    '傳8:16 我專心求智慧，要看世上所做的事。（有晝夜不睡覺不合眼的。）',
    '傳8:17 我就看明神一切的作為，知道人查不出日光之下所做的事；任憑他費多少力尋查，都查不出來，就是智慧人雖想知道，也是查不出來。',
    '傳9:1 我將這一切事放在心上，詳細考究，就知道義人和智慧人，並他們的作為都在神手中；或是愛，或是恨，都在他們的前面，人不能知道。',
    '傳9:2 凡臨到眾人的事都是一樣：義人和惡人都遭遇一樣的事；好人，潔淨人和不潔淨人，獻祭的與不獻祭的，也是一樣。好人如何，罪人也如何；起誓的如何，怕起誓的也如何。',
    '傳9:3 在日光之下所行的一切事上有一件禍患，就是眾人所遭遇的都是一樣，並且世人的心充滿了惡；活著的時候心裡狂妄，後來就歸死人那裡去了。',
    '傳9:4 與一切活人相連的，那人還有指望，因為活著的狗比死了的獅子更強。',
    '傳9:5 活著的人知道必死；死了的人毫無所知，也不再得賞賜；他們的名無人記念。',
    '傳9:6 他們的愛，他們的恨，他們的嫉妒，早都消滅了。在日光之下所行的一切事上，他們永不再有分了。',
    '傳9:7 你只管去歡歡喜喜吃你的飯，心中快樂喝你的酒，因為神已經悅納你的作為。',
    '傳9:8 你的衣服當時常潔白，你頭上也不要缺少膏油。',
    '傳9:9 在你一生虛空的年日，就是神賜你在日光之下虛空的年日，當同你所愛的妻，快活度日，因為那是你生前在日光之下勞碌的事上所得的分。',
    '傳9:10 凡你手所當做的事要盡力去做；因為在你所必去的陰間沒有工作，沒有謀算，沒有知識，也沒有智慧。',
    '傳9:11 我又轉念：見日光之下，快跑的未必能贏；力戰的未必得勝；智慧的未必得糧食；明哲的未必得資財；靈巧的未必得喜悅。所臨到眾人的是在乎當時的機會。',
    '傳9:12 原來人也不知道自己的定期。魚被惡網圈住，鳥被網羅捉住，禍患忽然臨到的時候，世人陷在其中也是如此。',
    '傳9:13 我見日光之下有一樣智慧，據我看乃是廣大，',
    '傳9:14 就是有一小城，其中的人數稀少，有大君王來攻擊，修築營壘，將城圍困。',
    '傳9:15 城中有一個貧窮的智慧人，他用智慧救了那城，卻沒有人記念那窮人。',
    '傳9:16 我就說，智慧勝過勇力；然而那貧窮人的智慧被人藐視，他的話也無人聽從。',
    '傳9:17 寧可在安靜之中聽智慧人的言語，不聽掌管愚昧人的喊聲。',
    '傳9:18 智慧勝過打仗的兵器；但一個罪人能敗壞許多善事。',
    '傳10:1 死蒼蠅使做香的膏油發出臭氣；這樣，一點愚昧也能敗壞智慧和尊榮。',
    '傳10:2 智慧人的心居右；愚昧人的心居左。',
    '傳10:3 並且愚昧人行路顯出無知，對眾人說，他是愚昧人。',
    '傳10:4 掌權者的心若向你發怒，不要離開你的本位，因為柔和能免大過。',
    '傳10:5 我見日光之下有一件禍患，似乎出於掌權的錯誤，',
    '傳10:6 就是愚昧人立在高位；富足人坐在低位。',
    '傳10:7 我見過僕人騎馬，王子像僕人在地上步行。',
    '傳10:8 挖陷坑的，自己必掉在其中；拆牆垣的，必為蛇所咬。',
    '傳10:9 鑿開（或譯：挪移）石頭的，必受損傷；劈開木頭的，必遭危險。',
    '傳10:10 鐵器鈍了，若不將刃磨快，就必多費氣力；但得智慧指教，便有益處。',
    '傳10:11 未行法術以先，蛇若咬人，後行法術也是無益。',
    '傳10:12 智慧人的口說出恩言；愚昧人的嘴吞滅自己。',
    '傳10:13 他口中的言語起頭是愚昧；他話的末尾是奸惡的狂妄。',
    '傳10:14 愚昧人多有言語，人卻不知將來有什麼事；他身後的事誰能告訴他呢﹖',
    '傳10:15 凡愚昧人，他的勞碌使自己困乏，因為連進城的路，他也不知道。',
    '傳10:16 邦國啊，你的王若是孩童，你的群臣早晨宴樂，你就有禍了！',
    '傳10:17 邦國啊，你的王若是貴冑之子，你的群臣按時吃喝，為要補力，不為酒醉，你就有福了！',
    '傳10:18 因人懶惰，房頂塌下；因人手懶，房屋滴漏。',
    '傳10:19 設擺筵席是為喜笑。酒能使人快活；錢能叫萬事應心。',
    '傳10:20 你不可咒詛君王，也不可心懷此念；在你臥房也不可咒詛富戶。因為空中的鳥必傳揚這聲音，有翅膀的也必述說這事。',
    '傳11:1 當將你的糧食撒在水面，因為日久必能得著。',
    '傳11:2 你要分給七人，或分給八人，因為你不知道將來有什麼災禍臨到地上。',
    '傳11:3 雲若滿了雨，就必傾倒在地上。樹若向南倒，或向北倒，樹倒在何處，就存在何處。',
    '傳11:4 看風的，必不撒種；望雲的，必不收割。',
    '傳11:5 風從何道來，骨頭在懷孕婦人的胎中如何長成，你尚且不得知道；這樣，行萬事之神的作為，你更不得知道。',
    '傳11:6 早晨要撒你的種，晚上也不要歇你的手，因為你不知道哪一樣發旺；或是早撒的，或是晚撒的，或是兩樣都好。',
    '傳11:7 光本是佳美的，眼見日光也是可悅的。',
    '傳11:8 人活多年，就當快樂多年；然而也當想到黑暗的日子。因為這日子必多，所要來的都是虛空。',
    '傳11:9 少年人哪，你在幼年時當快樂。在幼年的日子，使你的心歡暢，行你心所願行的，看你眼所愛看的；卻要知道，為這一切的事，神必審問你。',
    '傳11:10 所以，你當從心中除掉愁煩，從肉體克去邪惡；因為一生的開端和幼年之時，都是虛空的。',
    '傳12:1 你趁著年幼、衰敗的日子尚未來到，就是你所說，我毫無喜樂的那些年日未曾臨近之先，當記念造你的主。',
    '傳12:2 不要等到日頭、光明、月亮、星宿變為黑暗，雨後雲彩反回，',
    '傳12:3 看守房屋的發顫，有力的屈身，推磨的稀少就止息，從窗戶往外看的都昏暗；',
    '傳12:4 街門關閉，推磨的響聲微小，雀鳥一叫，人就起來，唱歌的女子也都衰微。',
    '傳12:5 人怕高處，路上有驚慌，杏樹開花，蚱蜢成為重擔，人所願的也都廢掉；因為人歸他永遠的家，弔喪的在街上往來。',
    '傳12:6 銀鍊折斷，金罐破裂，瓶子在泉旁損壞，水輪在井口破爛，',
    '傳12:7 塵土仍歸於地，靈仍歸於賜靈的神。',
    '傳12:8 傳道者說：虛空的虛空，凡事都是虛空。',
    '傳12:9 再者，傳道者因有智慧，仍將知識教訓眾人；又默想，又考查，又陳說許多箴言。',
    '傳12:10 傳道者專心尋求可喜悅的言語，是憑正直寫的誠實話。',
    '傳12:11 智慧人的言語好像刺棍；會中之師的言語又像釘穩的釘子，都是一個牧者所賜的。',
    '傳12:12 我兒，還有一層，你當受勸戒：著書多，沒有窮盡；讀書多，身體疲倦。',
    '傳12:13 這些事都已聽見了，總意就是：敬畏神，謹守他的誡命，這是人所當盡的本分（或譯：這是眾人的本分）。',
    '傳12:14 因為人所做的事，連一切隱藏的事，無論是善是惡，神都必審問。',
    '歌1:1 所羅門的歌，是歌中的雅歌。（新娘）',
    '歌1:2 願他用口與我親嘴；因你的愛情比酒更美。',
    '歌1:3 你的膏油馨香；你的名如同倒出來的香膏，所以眾童女都愛你。',
    '歌1:4 願你吸引我，我們就快跑跟隨你。王帶我進了內室，我們必因你歡喜快樂。我們要稱讚你的愛情，勝似稱讚美酒。他們愛你是理所當然的。',
    '歌1:5 耶路撒冷的眾女子啊，我雖然黑，卻是秀美，如同基達的帳棚，好像所羅門的幔子。',
    '歌1:6 不要因日頭把我曬黑了就輕看我。我同母的弟兄向我發怒，他們使我看守葡萄園；我自己的葡萄園卻沒有看守。',
    '歌1:7 我心所愛的啊，求你告訴我，你在何處牧羊﹖晌午在何處使羊歇臥﹖我何必在你同伴的羊群旁邊好像蒙著臉的人呢﹖（新郎）',
    '歌1:8 你這女子中極美麗的，你若不知道，只管跟隨羊群的腳蹤去，把你的山羊羔牧放在牧人帳棚的旁邊。',
    '歌1:9 我的佳偶，我將你比法老車上套的駿馬。',
    '歌1:10 你的兩腮因髮辮而秀美；你的頸項因珠串而華麗。',
    '歌1:11 我們要為你編上金辮，鑲上銀釘。（新娘）',
    '歌1:12 王正坐席的時候，我的哪噠香膏發出香味。',
    '歌1:13 我以我的良人為一袋沒藥，常在我懷中。',
    '歌1:14 我以我的良人為一棵鳳仙花，在隱基底葡萄園中。（新郎）',
    '歌1:15 我的佳偶，你甚美麗！你甚美麗！你的眼好像鴿子眼。（新娘）',
    '歌1:16 我的良人哪，你甚美麗可愛！我們以青草為床榻，',
    '歌1:17 以香柏樹為房屋的棟梁，以松樹為椽子。',
    '歌2:1 我是沙崙的玫瑰花（或譯：水仙花），是谷中的百合花。（新郎）',
    '歌2:2 我的佳偶在女子中，好像百合花在荊棘內。（新娘）',
    '歌2:3 我的良人在男子中，如同蘋果樹在樹林中。我歡歡喜喜坐在他的蔭下，嘗他果子的滋味，覺得甘甜。',
    '歌2:4 他帶我入筵宴所，以愛為旗在我以上。',
    '歌2:5 求你們給我葡萄乾增補我力，給我蘋果暢快我心，因我思愛成病。',
    '歌2:6 他的左手在我頭下；他的右手將我抱住。',
    '歌2:7 耶路撒冷的眾女子啊，我指著羚羊或田野的母鹿囑咐你們：不要驚動、不要叫醒我所親愛的，等他自己情願（不要叫醒……情願：或譯不要激動愛情，等他自發）。',
    '歌2:8 聽啊！是我良人的聲音；看哪！他躥山越嶺而來。',
    '歌2:9 我的良人好像羚羊，或像小鹿。他站在我們牆壁後，從窗戶往裡觀看，從窗櫺往裡窺探。',
    '歌2:10 我良人對我說：（新郎）我的佳偶，我的美人，起來，與我同去！',
    '歌2:11 因為冬天已往，雨水止住過去了。',
    '歌2:12 地上百花開放，百鳥鳴叫的時候（或譯：修理葡萄樹的時候）已經來到；斑鳩的聲音在我們境內也聽見了。',
    '歌2:13 無花果樹的果子漸漸成熟；葡萄樹開花放香。我的佳偶，我的美人，起來，與我同去！',
    '歌2:14 我的鴿子啊，你在磐石穴中，在陡巖的隱密處。求你容我得見你的面貌，得聽你的聲音；因為你的聲音柔和，你的面貌秀美。',
    '歌2:15 要給我們擒拿狐狸，就是毀壞葡萄園的小狐狸，因為我們的葡萄正在開花。（新娘）',
    '歌2:16 良人屬我，我也屬他；他在百合花中牧放群羊。',
    '歌2:17 我的良人哪，求你等到天起涼風、日影飛去的時候，你要轉回，好像羚羊，或像小鹿在比特山上。',
    '歌3:1 我夜間躺臥在床上，尋找我心所愛的；我尋找他，卻尋不見。',
    '歌3:2 我說：我要起來，遊行城中，在街市上，在寬闊處，尋找我心所愛的。我尋找他，卻尋不見。',
    '歌3:3 城中巡邏看守的人遇見我；我問他們：你們看見我心所愛的沒有﹖',
    '歌3:4 我剛離開他們就遇見我心所愛的。我拉住他，不容他走，領他入我母家，到懷我者的內室。',
    '歌3:5 耶路撒冷的眾女子啊，我指著羚羊或田野的母鹿囑咐你們：不要驚動、不要叫醒我所親愛的，等他自己情願（不要叫醒……情願：或譯不要激動愛情，等他自發）。',
    '歌3:6 那從曠野上來、形狀如煙柱、以沒藥和乳香並商人各樣香粉薰的是誰呢﹖',
    '歌3:7 看哪，是所羅門的轎；四圍有六十個勇士，都是以色列中的勇士；',
    '歌3:8 手都持刀，善於爭戰，腰間佩刀，防備夜間有驚慌。',
    '歌3:9 所羅門王用利巴嫩木為自己製造一乘華轎。',
    '歌3:10 轎柱是用銀做的，轎底是用金做的；坐墊是紫色的，其中所鋪的乃耶路撒冷眾女子的愛情。',
    '歌3:11 錫安的眾女子啊，你們出去觀看所羅門王！頭戴冠冕，就是在他婚筵的日子、心中喜樂的時候，他母親給他戴上的。',
    '歌4:1 我的佳偶，你甚美麗！你甚美麗！你的眼在帕子內好像鴿子眼。你的頭髮如同山羊群臥在基列山旁。',
    '歌4:2 你的牙齒如新剪毛的一群母羊，洗淨上來，個個都有雙生，沒有一隻喪掉子的。',
    '歌4:3 你的唇好像一條朱紅線；你的嘴也秀美。你的兩太陽在帕子內，如同一塊石榴。',
    '歌4:4 你的頸項好像大衛建造收藏軍器的高臺，其上懸掛一千盾牌，都是勇士的籐牌。',
    '歌4:5 你的兩乳好像百合花中吃草的一對小鹿，就是母鹿雙生的。',
    '歌4:6 我要往沒藥山和乳香岡去，直等到天起涼風、日影飛去的時候回來。',
    '歌4:7 我的佳偶，你全然美麗，毫無瑕疵！',
    '歌4:8 我的新婦，求你與我一同離開利巴嫩，與我一同離開利巴嫩。從亞瑪拿頂，從示尼珥與黑門頂，從有獅子的洞，從有豹子的山往下觀看。',
    '歌4:9 我妹子，我新婦，你奪了我的心。你用眼一看，用你項上的一條金鍊，奪了我的心！',
    '歌4:10 我妹子，我新婦，你的愛情何其美！你的愛情比酒更美！你膏油的香氣勝過一切香品！',
    '歌4:11 我新婦，你的嘴唇滴蜜，好像蜂房滴蜜；你的舌下有蜜，有奶。你衣服的香氣如利巴嫩的香氣。',
    '歌4:12 我妹子，我新婦，乃是關鎖的園，禁閉的井，封閉的泉源。',
    '歌4:13 你園內所種的結了石榴，有佳美的果子，並鳳仙花與哪噠樹。',
    '歌4:14 有哪噠和番紅花，菖蒲和桂樹，並各樣乳香木、沒藥、沉香，與一切上等的果品。',
    '歌4:15 你是園中的泉，活水的井，從利巴嫩流下來的溪水。（新娘）',
    '歌4:16 北風啊，興起！南風啊，吹來！吹在我的園內，使其中的香氣發出來。願我的良人進入自己園裡，吃他佳美的果子。',
    '歌5:1 我妹子，我新婦，我進了我的園中，採了我的沒藥和香料，吃了我的蜜房和蜂蜜，喝了我的酒和奶。（耶路撒冷的眾女子）我的朋友們，請吃！我所親愛的，請喝，且多多地喝！',
    '歌5:2 我身睡臥，我心卻醒。這是我良人的聲音；他敲門說：（新郎）我的妹子，我的佳偶，我的鴿子，我的完全人，求你給我開門；因我的頭滿了露水，我的頭髮被夜露滴濕。（新娘）',
    '歌5:3 我回答說：我脫了衣裳，怎能再穿上呢﹖我洗了腳，怎能再玷污呢﹖',
    '歌5:4 我的良人從門孔裡伸進手來，我便因他動了心。',
    '歌5:5 我起來，要給我良人開門。我的兩手滴下沒藥；我的指頭有沒藥汁滴在門閂上。',
    '歌5:6 我給我的良人開了門；我的良人卻已轉身走了。他說話的時候，我神不守舍；我尋找他，竟尋不見；我呼叫他，他卻不回答。',
    '歌5:7 城中巡邏看守的人遇見我，打了我，傷了我；看守城牆的人奪去我的披肩。',
    '歌5:8 耶路撒冷的眾女子啊，我囑咐你們：若遇見我的良人，要告訴他，我因思愛成病。（耶路撒冷的眾女子）',
    '歌5:9 你這女子中極美麗的，你的良人比別人的良人有何強處﹖你的良人比別人的良人有何強處，你就這樣囑咐我們﹖（新娘）',
    '歌5:10 我的良人白而且紅，超乎萬人之上。',
    '歌5:11 他的頭像至精的金子；他的頭髮厚密纍垂，黑如烏鴉。',
    '歌5:12 他的眼如溪水旁的鴿子眼，用奶洗淨，安得合式。',
    '歌5:13 他的兩腮如香花畦，如香草臺；他的嘴唇像百合花，且滴下沒藥汁。',
    '歌5:14 他的兩手好像金管，鑲嵌水蒼玉；他的身體如同雕刻的象牙，周圍鑲嵌藍寶石。',
    '歌5:15 他的腿好像白玉石柱，安在精金座上；他的形狀如利巴嫩，且佳美如香柏樹。',
    '歌5:16 他的口極其甘甜；他全然可愛。耶路撒冷的眾女子啊，這是我的良人；這是我的朋友。',
    '歌6:1 你這女子中極美麗的，你的良人往何處去了﹖你的良人轉向何處去了，我們好與你同去尋找他。（新娘）',
    '歌6:2 我的良人下入自己園中，到香花畦，在園內牧放群羊，採百合花。',
    '歌6:3 我屬我的良人，我的良人也屬我；他在百合花中牧放群羊。',
    '歌6:4 我的佳偶啊，你美麗如得撒，秀美如耶路撒冷，威武如展開旌旗的軍隊。',
    '歌6:5 求你掉轉眼目不看我，因你的眼目使我驚亂。你的頭髮如同山羊群臥在基列山旁。',
    '歌6:6 你的牙齒如一群母羊洗淨上來，個個都有雙生，沒有一隻喪掉子的。',
    '歌6:7 你的兩太陽在帕子內，如同一塊石榴。',
    '歌6:8 有六十王后八十妃嬪，並有無數的童女。',
    '歌6:9 我的鴿子，我的完全人，只有這一個是他母親獨生的，是生養他者所寶愛的。眾女子見了就稱他有福；王后妃嬪見了也讚美他。',
    '歌6:10 那向外觀看、如晨光發現、美麗如月亮、皎潔如日頭、威武如展開旌旗軍隊的是誰呢﹖',
    '歌6:11 我下入核桃園，要看谷中青綠的植物，要看葡萄發芽沒有，石榴開花沒有。',
    '歌6:12 不知不覺，我的心將我安置在我尊長的車中。（耶路撒冷的眾女子）',
    '歌6:13 回來，回來，書拉密女；你回來，你回來，使我們得觀看你。（新娘）你們為何要觀看書拉密女，像觀看瑪哈念跳舞的呢﹖',
    '歌7:1 王女啊，你的腳在鞋中何其美好！你的大腿圓潤，好像美玉，是巧匠的手做成的。',
    '歌7:2 你的肚臍如圓杯，不缺調和的酒；你的腰如一堆麥子，周圍有百合花。',
    '歌7:3 你的兩乳好像一對小鹿，就是母鹿雙生的。',
    '歌7:4 你的頸項如象牙臺；你的眼目像希實本、巴特拉併門旁的水池；你的鼻子彷彿朝大馬色的利巴嫩塔。',
    '歌7:5 你的頭在你身上好像迦密山；你頭上的髮是紫黑色；王的心因這下垂的髮綹繫住了。',
    '歌7:6 我所愛的，你何其美好！何其可悅，使人歡暢喜樂！',
    '歌7:7 你的身量好像棕樹；你的兩乳如同其上的果子，纍纍下垂。',
    '歌7:8 我說：我要上這棕樹，抓住枝子。願你的兩乳好像葡萄纍纍下垂，你鼻子的氣味香如蘋果；',
    '歌7:9 你的口如上好的酒。（新娘）女子說：為我的良人下咽舒暢，流入睡覺人的嘴中。',
    '歌7:10 我屬我的良人，他也戀慕我。',
    '歌7:11 我的良人，來吧！你我可以往田間去；你我可以在村莊住宿。',
    '歌7:12 我們早晨起來往葡萄園去，看看葡萄發芽開花沒有，石榴放蕊沒有；我在那裡要將我的愛情給你。',
    '歌7:13 風茄放香，在我們的門內有各樣新陳佳美的果子；我的良人，這都是我為你存留的。',
    '歌8:1 巴不得你像我的兄弟，像吃我母親奶的兄弟；我在外頭遇見你就與你親嘴，誰也不輕看我。',
    '歌8:2 我必引導你，領你進我母親的家；我可以領受教訓，也就使你喝石榴汁釀的香酒。',
    '歌8:3 他的左手必在我頭下；他的右手必將我抱住。',
    '歌8:4 耶路撒冷的眾女子啊，我囑咐你們：不要驚動、不要叫醒我所親愛的，等他自己情願（不要叫醒……情願：或譯不要激動愛情，等他自發）。',
    '歌8:5 那靠著良人從曠野上來的是誰呢﹖（新娘）我在蘋果樹下叫醒你。你母親在那裡為你劬勞；生養你的在那裡為你劬勞。',
    '歌8:6 求你將我放在你心上如印記，帶在你臂上如戳記。因為愛情如死之堅強，嫉恨如陰間之殘忍；所發的電光是火焰的電光，是耶和華的烈焰。',
    '歌8:7 愛情，眾水不能息滅，大水也不能淹沒。若有人拿家中所有的財寶要換愛情，就全被藐視。（新娘的兄弟）',
    '歌8:8 我們有一小妹；他的兩乳尚未長成，人來提親的日子，我們當為他怎樣辦理﹖',
    '歌8:9 他若是牆，我們要在其上建造銀塔；他若是門，我們要用香柏木板圍護他。（新娘）',
    '歌8:10 我是牆；我兩乳像其上的樓。那時，我在他眼中像得平安的人。（新郎）',
    '歌8:11 所羅門在巴力哈們有一葡萄園；他將這葡萄園交給看守的人，為其中的果子必交一千舍客勒銀子。',
    '歌8:12 我自己的葡萄園在我面前。所羅門哪，一千舍客勒歸你，二百舍客勒歸看守果子的人。',
    '歌8:13 你這住在園中的，同伴都要聽你的聲音，求你使我也得聽見。（新娘）',
    '歌8:14 我的良人哪，求你快來！如羚羊或小鹿在香草山上。',
    '賽1:1 當烏西雅、約坦、亞哈斯、希西家作猶大王的時候，亞摩斯的兒子以賽亞得默示，論到猶大和耶路撒冷。',
    '賽1:2 天哪，要聽！地啊，側耳而聽！因為耶和華說：我養育兒女，將他們養大，他們竟悖逆我。',
    '賽1:3 牛認識主人，驢認識主人的槽，以色列卻不認識；我的民卻不留意。',
    '賽1:4 嗐！犯罪的國民，擔著罪孽的百姓；行惡的種類，敗壞的兒女！他們離棄耶和華，藐視以色列的聖者，與他生疏，往後退步。',
    '賽1:5 你們為什麼屢次悖逆，還要受責打嗎﹖你們已經滿頭疼痛，全心發昏。',
    '賽1:6 從腳掌到頭頂，沒有一處完全的，盡是傷口、青腫，與新打的傷痕，都沒有收口，沒有纏裹，也沒有用膏滋潤。',
    '賽1:7 你們的地土已經荒涼；你們的城邑被火焚毀。你們的田地在你們眼前為外邦人所侵吞，既被外邦人傾覆就成為荒涼。',
    '賽1:8 僅存錫安城（原文是女子），好像葡萄園的草棚，瓜田的茅屋，被圍困的城邑。',
    '賽1:9 若不是萬軍之耶和華給我們稍留餘種，我們早已像所多瑪、蛾摩拉的樣子了。',
    '賽1:10 你們這所多瑪的官長啊，要聽耶和華的話！你們這蛾摩拉的百姓啊，要側耳聽我們神的訓誨！',
    '賽1:11 耶和華說：你們所獻的許多祭物於我何益呢﹖公綿羊的燔祭和肥畜的脂油，我已經夠了；公牛的血，羊羔的血，公山羊的血，我都不喜悅。',
    '賽1:12 你們來朝見我，誰向你們討這些，使你們踐踏我的院宇呢﹖',
    '賽1:13 你們不要再獻虛浮的供物。香品是我所憎惡的；月朔和安息日，並宣召的大會，也是我所憎惡的；作罪孽，又守嚴肅會，我也不能容忍。',
    '賽1:14 你們的月朔和節期，我心裡恨惡，我都以為麻煩；我擔當，便不耐煩。',
    '賽1:15 你們舉手禱告，我必遮眼不看；就是你們多多地祈禱，我也不聽。你們的手都滿了殺人的血。',
    '賽1:16 你們要洗濯、自潔，從我眼前除掉你們的惡行，要止住作惡，',
    '賽1:17 學習行善，尋求公平，解救受欺壓的；給孤兒伸冤，為寡婦辨屈。',
    '賽1:18 耶和華說：你們來，我們彼此辯論。你們的罪雖像硃紅，必變成雪白；雖紅如丹顏，必白如羊毛。',
    '賽1:19 你們若甘心聽從，必吃地上的美物，',
    '賽1:20 若不聽從，反倒悖逆，必被刀劍吞滅。這是耶和華親口說的。',
    '賽1:21 可歎，忠信的城變為妓女！從前充滿了公平，公義居在其中，現今卻有兇手居住。',
    '賽1:22 你的銀子變為渣滓；你的酒用水攙對。',
    '賽1:23 你的官長居心悖逆，與盜賊作伴，各都喜愛賄賂，追求贓私。他們不為孤兒伸冤；寡婦的案件也不得呈到他們面前。',
    '賽1:24 因此，主─萬軍之耶和華、以色列的大能者說：哎！我要向我的對頭雪恨，向我的敵人報仇。',
    '賽1:25 我必反手加在你身上，煉盡你的渣滓，除淨你的雜質。',
    '賽1:26 我也必復還你的審判官，像起初一樣，復還你的謀士，像起先一般。然後，你必稱為公義之城，忠信之邑。',
    '賽1:27 錫安必因公平得蒙救贖；其中歸正的人必因公義得蒙救贖。',
    '賽1:28 但悖逆的和犯罪的必一同敗亡；離棄耶和華的必致消滅。',
    '賽1:29 那等人必因你們所喜愛的橡樹抱愧；你們必因所選擇的園子蒙羞。',
    '賽1:30 因為，你們必如葉子枯乾的橡樹，好像無水澆灌的園子。',
    '賽1:31 有權勢的必如麻瓤；他的工作好像火星，都要一同焚毀，無人撲滅。',
    '賽2:1 亞摩斯的兒子以賽亞得默示，論到猶大和耶路撒冷。',
    '賽2:2 末後的日子，耶和華殿的山必堅立，超乎諸山，高舉過於萬嶺；萬民都要流歸這山。',
    '賽2:3 必有許多國的民前往，說：來吧，我們登耶和華的山，奔雅各神的殿。主必將他的道教訓我們；我們也要行他的路。因為訓誨必出於錫安；耶和華的言語必出於耶路撒冷。',
    '賽2:4 他必在列國中施行審判，為許多國民斷定是非。他們要將刀打成犁頭，把槍打成鐮刀。這國不舉刀攻擊那國；他們也不再學習戰事。',
    '賽2:5 雅各家啊，來吧！我們在耶和華的光明中行走。',
    '賽2:6 耶和華，你離棄了你百姓雅各家，是因他們充滿了東方的風俗，作觀兆的，像非利士人一樣，並與外邦人擊掌。',
    '賽2:7 他們的國滿了金銀，財寶也無窮；他們的地滿了馬匹，車輛也無數。',
    '賽2:8 他們的地滿了偶像；他們跪拜自己手所造的，就是自己指頭所做的。',
    '賽2:9 卑賤人屈膝；尊貴人下跪；所以不可饒恕他們。',
    '賽2:10 你當進入巖穴，藏在土中，躲避耶和華的驚嚇和他威嚴的榮光。',
    '賽2:11 到那日，眼目高傲的必降為卑；性情狂傲的都必屈膝；惟獨耶和華被尊崇。',
    '賽2:12 必有萬軍耶和華降罰的一個日子，要臨到驕傲狂妄的；一切自高的都必降為卑；',
    '賽2:13 又臨到利巴嫩高大的香柏樹和巴珊的橡樹；',
    '賽2:14 又臨到一切高山的峻嶺；',
    '賽2:15 又臨到高臺和堅固城牆；',
    '賽2:16 又臨到他施的船隻並一切可愛的美物。',
    '賽2:17 驕傲的必屈膝；狂妄的必降卑。在那日，惟獨耶和華被尊崇；',
    '賽2:18 偶像必全然廢棄。',
    '賽2:19 耶和華興起，使地大震動的時候，人就進入石洞，進入土穴，躲避耶和華的驚嚇和他威嚴的榮光。',
    '賽2:20 到那日，人必將為拜而造的金偶像、銀偶像拋給田鼠和蝙蝠。',
    '賽2:21 到耶和華興起，使地大震動的時候，人好進入磐石洞中和巖石穴裡，躲避耶和華的驚嚇和他威嚴的榮光。',
    '賽2:22 你們休要倚靠世人。他鼻孔裡不過有氣息；他在一切事上可算什麼呢﹖',
    '賽3:1 主─萬軍之耶和華從耶路撒冷和猶大，除掉眾人所倚靠的，所仗賴的，就是所倚靠的糧，所仗賴的水；',
    '賽3:2 除掉勇士和戰士，審判官和先知，占卜的和長老，',
    '賽3:3 五十夫長和尊貴人，謀士和有巧藝的，以及妙行法術的。',
    '賽3:4 主說：我必使孩童作他們的首領，使嬰孩轄管他們。',
    '賽3:5 百姓要彼此欺壓；各人受鄰舍的欺壓。少年人必侮慢老年人；卑賤人必侮慢尊貴人。',
    '賽3:6 人在父家拉住弟兄，說：你有衣服，可以作我們的官長。這敗落的事歸在你手下吧！',
    '賽3:7 那時，他必揚聲說：我不作醫治你們的人；因我家中沒有糧食，也沒有衣服，你們不可立我作百姓的官長。',
    '賽3:8 耶路撒冷敗落，猶大傾倒；因為他們的舌頭和行為與耶和華反對，惹了他榮光的眼目。',
    '賽3:9 他們的面色證明自己的不正；他們述說自己的罪惡，並不隱瞞，好像所多瑪一樣。他們有禍了！因為作惡自害。',
    '賽3:10 你們要論義人說：他必享福樂，因為要吃自己行為所結的果子。',
    '賽3:11 惡人有禍了！他必遭災難！因為要照自己手所行的受報應。',
    '賽3:12 至於我的百姓，孩童欺壓他們，婦女轄管他們。我的百姓啊，引導你的使你走錯，並毀壞你所行的道路。',
    '賽3:13 耶和華起來辯論，站著審判眾民。',
    '賽3:14 耶和華必審問他民中的長老和首領，說：吃盡葡萄園果子的就是你們；向貧窮人所奪的都在你們家中。',
    '賽3:15 主─萬軍之耶和華說：你們為何壓制我的百姓，搓磨貧窮人的臉呢﹖',
    '賽3:16 耶和華又說：因為錫安的女子狂傲，行走挺項，賣弄眼目，俏步徐行，腳下玎璫，',
    '賽3:17 所以，主必使錫安的女子頭長禿瘡；耶和華又使他們赤露下體。',
    '賽3:18 到那日，主必除掉他們華美的腳釧、髮網、月牙圈、',
    '賽3:19 耳環、手鐲、蒙臉的帕子、',
    '賽3:20 華冠、足鍊、華帶、香盒、符囊、',
    '賽3:21 戒指、鼻環、',
    '賽3:22 吉服、外套、雲肩、荷包、',
    '賽3:23 手鏡、細麻衣、裹頭巾、蒙身的帕子。',
    '賽3:24 必有臭爛代替馨香，繩子代替腰帶，光禿代替美髮，麻衣繫腰代替華服，烙傷代替美容。',
    '賽3:25 你的男丁必倒在刀下；你的勇士必死在陣上。',
    '賽3:26 錫安（原文是他）的城門必悲傷、哀號；他必荒涼坐在地上。',
    '賽4:1 在那日，七個女人必拉住一個男人，說：我們吃自己的食物，穿自己的衣服，但求你許我們歸你名下；求你除掉我們的羞恥。',
    '賽4:2 到那日，耶和華發生的苗必華美尊榮，地的出產必為以色列逃脫的人顯為榮華茂盛。',
    '賽4:3 主以公義的靈和焚燒的靈，將錫安女子的污穢洗去，又將耶路撒冷中殺人的血除淨。那時，剩在錫安、留在耶路撒冷的，就是一切住耶路撒冷、在生命冊上記名的，必稱為聖。',
    '賽4:4 併於上節。',
    '賽4:5 耶和華也必在錫安全山，並各會眾以上，使白日有煙雲，黑夜有火焰的光。因為在全榮耀之上必有遮蔽。',
    '賽4:6 必有亭子，白日可以得蔭避暑，也可以作為藏身之處，躲避狂風暴雨。',
    '賽5:1 我要為我所親愛的唱歌，是我所愛者的歌，論他葡萄園的事：我所親愛的有葡萄園在肥美的山岡上。',
    '賽5:2 他刨挖園子，撿去石頭，栽種上等的葡萄樹，在園中蓋了一座樓，又鑿出壓酒池；指望結好葡萄，反倒結了野葡萄。',
    '賽5:3 耶路撒冷的居民和猶大人哪，請你們現今在我與我的葡萄園中，斷定是非。',
    '賽5:4 我為我葡萄園所做之外，還有什麼可做的呢﹖我指望結好葡萄，怎麼倒結了野葡萄呢﹖',
    '賽5:5 現在我告訴你們，我要向我葡萄園怎樣行：我必撤去籬笆，使他被吞滅，拆毀牆垣，使他被踐踏。',
    '賽5:6 我必使他荒廢，不再修理，不再鋤刨，荊棘蒺藜倒要生長。我也必命雲不降雨在其上。',
    '賽5:7 萬軍之耶和華的葡萄園就是以色列家；他所喜愛的樹就是猶大人。他指望的是公平，誰知倒有暴虐（或譯：倒流人血）；指望的是公義，誰知倒有冤聲。',
    '賽5:8 禍哉！那些以房接房，以地連地，以致不留餘地的，只顧自己獨居境內。',
    '賽5:9 我耳聞萬軍之耶和華說：必有許多又大又美的房屋成為荒涼，無人居住。',
    '賽5:10 三十畝葡萄園只出一罷特酒；一賀梅珥穀種只結一伊法糧食。',
    '賽5:11 禍哉！那些清早起來追求濃酒，留連到夜深，甚至因酒發燒的人。',
    '賽5:12 他們在筵席上彈琴，鼓瑟，擊鼓，吹笛，飲酒，卻不顧念耶和華的作為，也不留心他手所做的。',
    '賽5:13 所以，我的百姓因無知就被擄去；他們的尊貴人甚是飢餓，群眾極其乾渴。',
    '賽5:14 故此，陰間擴張其欲，開了無限量的口；他們的榮耀、群眾、繁華，並快樂的人都落在其中。',
    '賽5:15 卑賤人被壓服；尊貴人降為卑；眼目高傲的人也降為卑。',
    '賽5:16 惟有萬軍之耶和華因公平而崇高；聖者神因公義顯為聖。',
    '賽5:17 那時，羊羔必來吃草，如同在自己的草場；豐肥人的荒場被遊行的人吃盡。',
    '賽5:18 禍哉！那些以虛假之細繩牽罪孽的人！他們又像以套繩拉罪惡，',
    '賽5:19 說：任他急速行，趕快成就他的作為，使我們看看；任以色列聖者所謀劃的臨近成就，使我們知道。',
    '賽5:20 禍哉！那些稱惡為善，稱善為惡，以暗為光，以光為暗，以苦為甜，以甜為苦的人。',
    '賽5:21 禍哉！那些自以為有智慧，自看為通達的人。',
    '賽5:22 禍哉！那些勇於飲酒，以能力調濃酒的人。',
    '賽5:23 他們因受賄賂，就稱惡人為義，將義人的義奪去。',
    '賽5:24 火苗怎樣吞滅碎稭，乾草怎樣落在火焰之中，照樣，他們的根必像朽物，他們的花必像灰塵飛騰；因為他們厭棄萬軍之耶和華的訓誨，藐視以色列聖者的言語。',
    '賽5:25 所以，耶和華的怒氣向他的百姓發作。他的手伸出攻擊他們，山嶺就震動；他們的屍首在街市上好像糞土。雖然如此，他的怒氣還未轉消；他的手仍伸不縮。',
    '賽5:26 他必豎立大旗，招遠方的國民，發嘶聲叫他們從地極而來；看哪，他們必急速奔來。',
    '賽5:27 其中沒有疲倦的，絆跌的；沒有打盹的，睡覺的；腰帶並不放鬆，鞋帶也不折斷。',
    '賽5:28 他們的箭快利，弓也上了弦。馬蹄算如堅石，車輪好像旋風。',
    '賽5:29 他們要吼叫，像母獅子，咆哮，像少壯獅子；他們要咆哮抓食，坦然叼去，無人救回。',
    '賽5:30 那日，他們要向以色列人吼叫，像海浪匉訇；人若望地，只見黑暗艱難，光明在雲中變為昏暗。',
    '賽6:1 當烏西雅王崩的那年，我見主坐在高高的寶座上。他的衣裳垂下，遮滿聖殿。',
    '賽6:2 其上有撒拉弗侍立，各有六個翅膀：用兩個翅膀遮臉，兩個翅膀遮腳，兩個翅膀飛翔；',
    '賽6:3 彼此呼喊說：聖哉！聖哉！聖哉！萬軍之耶和華；他的榮光充滿全地！',
    '賽6:4 因呼喊者的聲音，門檻的根基震動，殿充滿了煙雲。',
    '賽6:5 那時我說：禍哉！我滅亡了！因為我是嘴唇不潔的人，又住在嘴唇不潔的民中，又因我眼見大君王─萬軍之耶和華。',
    '賽6:6 有一撒拉弗飛到我跟前，手裡拿著紅炭，是用火剪從壇上取下來的，',
    '賽6:7 將炭沾我的口，說：看哪，這炭沾了你的嘴，你的罪孽便除掉，你的罪惡就赦免了。',
    '賽6:8 我又聽見主的聲音說：我可以差遣誰呢﹖誰肯為我們去呢﹖我說：我在這裡，請差遣我！',
    '賽6:9 他說：你去告訴這百姓說：你們聽是要聽見，卻不明白；看是要看見，卻不曉得。',
    '賽6:10 要使這百姓心蒙脂油，耳朵發沉，眼睛昏迷；恐怕眼睛看見，耳朵聽見，心裡明白，回轉過來，便得醫治。',
    '賽6:11 我就說：主啊，這到幾時為止呢﹖他說：直到城邑荒涼，無人居住，房屋空閒無人，地土極其荒涼。',
    '賽6:12 並且耶和華將人遷到遠方，在這境內撇下的地土很多。',
    '賽6:13 境內剩下的人若還有十分之一，也必被吞滅，像栗樹、橡樹雖被砍伐，樹丕子卻仍存留。這聖潔的種類在國中也是如此。',
    '賽7:1 烏西雅的孫子、約坦的兒子、猶大王亞哈斯在位的時候，亞蘭王利汛和利瑪利的兒子、以色列王比加上來攻打耶路撒冷，卻不能攻取。',
    '賽7:2 有人告訴大衛家說：亞蘭與以法蓮已經同盟。王的心和百姓的心就都跳動，好像林中的樹被風吹動一樣。',
    '賽7:3 耶和華對以賽亞說：你和你的兒子施亞雅述出去，到上池的水溝頭，在漂布地的大路上，去迎接亞哈斯，',
    '賽7:4 對他說：你要謹慎安靜，不要因亞蘭王利汛和利瑪利的兒子這兩個冒煙的火把頭所發的烈怒害怕，也不要心裡膽怯。',
    '賽7:5 因為亞蘭和以法蓮，並利瑪利的兒子，設惡謀害你，',
    '賽7:6 說：我們可以上去攻擊猶大，擾亂他，攻破他，在其中立他比勒的兒子為王。',
    '賽7:7 所以主耶和華如此說：這所謀的必立不住，也不得成就。',
    '賽7:8 原來亞蘭的首城是大馬色；大馬色的首領是利汛。（六十五年之內，以法蓮必然破壞，不再成為國民。）',
    '賽7:9 以法蓮的首城是撒瑪利亞；撒瑪利亞的首領是利瑪利的兒子。你們若是不信，定然不得立穩。',
    '賽7:10 耶和華又曉諭亞哈斯說：',
    '賽7:11 你向耶和華─你的神求一個兆頭：或求顯在深處，或求顯在高處。',
    '賽7:12 亞哈斯說：我不求；我不試探耶和華。',
    '賽7:13 以賽亞說：大衛家啊，你們當聽！你們使人厭煩豈算小事，還要使我的神厭煩嗎﹖',
    '賽7:14 因此，主自己要給你們一個兆頭，必有童女懷孕生子，給他起名叫以馬內利（就是神與我們同在的意思）。',
    '賽7:15 到他曉得棄惡擇善的時候，他必吃奶油與蜂蜜。',
    '賽7:16 因為在這孩子還不曉得棄惡擇善之先，你所憎惡的那二王之地必致見棄。',
    '賽7:17 耶和華必使亞述王攻擊你的日子臨到你和你的百姓，並你的父家，自從以法蓮離開猶大以來，未曾有這樣的日子。',
    '賽7:18 那時，耶和華要發嘶聲，使埃及江河源頭的蒼蠅和亞述地的蜂子飛來；',
    '賽7:19 都必飛來，落在荒涼的谷內、磐石的穴裡，和一切荊棘籬笆中，並一切的草場上。',
    '賽7:20 那時，主必用大河外賃的剃頭刀，就是亞述王，剃去頭髮和腳上的毛，並要剃淨鬍鬚。',
    '賽7:21 那時，一個人要養活一隻母牛犢，兩隻母綿羊；',
    '賽7:22 因為出的奶多，他就得吃奶油，在境內所剩的人都要吃奶油與蜂蜜。',
    '賽7:23 從前，凡種一千棵葡萄樹、值銀一千舍客勒的地方，到那時必長荊棘和蒺藜。',
    '賽7:24 人上那裡去，必帶弓箭，因為遍地滿了荊棘和蒺藜。',
    '賽7:25 所有用鋤刨挖的山地，你因怕荊棘和蒺藜，不敢上那裡去；只可成了放牛之處，為羊踐踏之地。',
    '賽8:1 耶和華對我說：你取一個大牌，拿人所用的筆（或譯：人常用的字），寫上瑪黑珥沙拉勒哈施罷斯（就是擄掠速臨、搶奪快到的意思）。',
    '賽8:2 我要用誠實的見證人，祭司烏利亞和耶比利家的兒子撒迦利亞記錄這事。',
    '賽8:3 我─以賽亞與妻子（原文是女先知）同室；他懷孕生子，耶和華就對我說：給他起名叫瑪黑珥沙拉勒哈施罷斯；',
    '賽8:4 因為在這小孩子不曉得叫父叫母之先，大馬色的財寶和撒瑪利亞的擄物必在亞述王面前搬了去。',
    '賽8:5 耶和華又曉諭我說：',
    '賽8:6 這百姓既厭棄西羅亞緩流的水，喜悅利汛和利瑪利的兒子；',
    '賽8:7 因此，主必使大河翻騰的水猛然沖來，就是亞述王和他所有的威勢，必漫過一切的水道，漲過兩岸；',
    '賽8:8 必沖入猶大，漲溢氾濫，直到頸項。以馬內利啊，他展開翅膀，遍滿你的地。',
    '賽8:9 列國的人民哪，任憑你們喧嚷，終必破壞；遠方的眾人哪，當側耳而聽！任憑你們束起腰來，終必破壞；你們束起腰來，終必破壞。',
    '賽8:10 任憑你們同謀，終歸無有；任憑你們言定，終不成立；因為神與我們同在。',
    '賽8:11 耶和華以大能的手，指教我不可行這百姓所行的道，對我這樣說：',
    '賽8:12 這百姓說同謀背叛，你們不要說同謀背叛。他們所怕的，你們不要怕，也不要畏懼。',
    '賽8:13 但要尊萬軍之耶和華為聖，以他為你們所當怕的，所當畏懼的。',
    '賽8:14 他必作為聖所，卻向以色列兩家作絆腳的石頭，跌人的磐石；向耶路撒冷的居民作為圈套和網羅。',
    '賽8:15 許多人必在其上絆腳跌倒，而且跌碎，並陷入網羅，被纏住。',
    '賽8:16 你要捲起律法書，在我門徒中間封住訓誨。',
    '賽8:17 我要等候那掩面不顧雅各家的耶和華；我也要仰望他。',
    '賽8:18 看哪，我與耶和華所給我的兒女，就是從住在錫安山萬軍之耶和華來的，在以色列中作為預兆和奇蹟。',
    '賽8:19 有人對你們說：當求問那些交鬼的和行巫術的，就是聲音綿蠻，言語微細的。你們便回答說：百姓不當求問自己的神嗎﹖豈可為活人求問死人呢﹖',
    '賽8:20 人當以訓誨和法度為標準；他們所說的，若不與此相符，必不得見晨光。',
    '賽8:21 他們必經過這地，受艱難，受飢餓；飢餓的時候，心中焦躁，咒罵自己的君王和自己的神。',
    '賽8:22 仰觀上天，俯察下地，不料，盡是艱難、黑暗，和幽暗的痛苦。他們必被趕入烏黑的黑暗中去。',
    '賽9:1 但那受過痛苦的必不再見幽暗。從前神使西布倫地和拿弗他利地被藐視，末後卻使這沿海的路，約但河外，外邦人的加利利地得著榮耀。',
    '賽9:2 在黑暗中行走的百姓看見了大光，住在死蔭之地的人有光照耀他們。',
    '賽9:3 你使這國民繁多，加增他們的喜樂；他們在你面前歡喜，好像收割的歡喜，像人分擄物那樣的快樂。',
    '賽9:4 因為他們所負的重軛和肩頭上的杖，並欺壓他們人的棍，你都已經折斷，好像在米甸的日子一樣。',
    '賽9:5 戰士在亂殺之間所穿戴的盔甲，並那滾在血中的衣服，都必作為可燒的，當作火柴。',
    '賽9:6 因有一嬰孩為我們而生；有一子賜給我們。政權必擔在他的肩頭上；他名稱為奇妙策士、全能的神、永在的父、和平的君。',
    '賽9:7 他的政權與平安必加增無窮。他必在大衛的寶座上治理他的國，以公平公義使國堅定穩固，從今直到永遠。萬軍之耶和華的熱心必成就這事。',
    '賽9:8 主使一言入於雅各家，落於以色列家。',
    '賽9:9 這眾百姓，就是以法蓮和撒瑪利亞的居民，都要知道；他們憑驕傲自大的心說：',
    '賽9:10 磚牆塌了，我們卻要鑿石頭建築；桑樹砍了，我們卻要換香柏樹。',
    '賽9:11 因此，耶和華要高舉利汛的敵人來攻擊以色列，並要激動以色列的仇敵。',
    '賽9:12 東有亞蘭人，西有非利士人；他們張口要吞吃以色列。雖然如此，耶和華的怒氣還未轉消；他的手仍伸不縮。',
    '賽9:13 這百姓還沒有歸向擊打他們的主，也沒有尋求萬軍之耶和華。',
    '賽9:14 因此，耶和華一日之間必從以色列中剪除頭與尾，棕枝與蘆葦─',
    '賽9:15 長老和尊貴人就是頭，以謊言教人的先知就是尾。',
    '賽9:16 因為，引導這百姓的使他們走錯了路；被引導的都必敗亡。',
    '賽9:17 所以，主必不喜悅他們的少年人，也不憐恤他們的孤兒寡婦；因為，各人是褻瀆的，是行惡的，並且各人的口都說愚妄的話。雖然如此，耶和華的怒氣還未轉消；他的手仍伸不縮。',
    '賽9:18 邪惡像火焚燒，燒滅荊棘和蒺藜，在稠密的樹林中著起來，就成為煙柱，旋轉上騰。',
    '賽9:19 因萬軍之耶和華的烈怒，地都燒遍；百姓成為火柴；無人憐愛弟兄。',
    '賽9:20 有人右邊搶奪，仍受飢餓，左邊吞吃，仍不飽足；各人吃自己膀臂上的肉。',
    '賽9:21 瑪拿西吞吃（或譯：攻擊；下同）以法蓮；以法蓮吞吃瑪拿西，又一同攻擊猶大。雖然如此，耶和華的怒氣還未轉消；他的手仍伸不縮。',
    '賽10:1 禍哉！那些設立不義之律例的和記錄奸詐之判語的，',
    '賽10:2 為要屈枉窮乏人，奪去我民中困苦人的理，以寡婦當作擄物，以孤兒當作掠物。',
    '賽10:3 到降罰的日子，有災禍從遠方臨到，那時，你們怎樣行呢﹖你們向誰逃奔求救呢﹖你們的榮耀（或譯：財寶）存留何處呢﹖',
    '賽10:4 他們只得屈身在被擄的人以下，仆倒在被殺的人以下。雖然如此，耶和華的怒氣還未轉消；他的手仍伸不縮。',
    '賽10:5 亞述是我怒氣的棍，手中拿我惱恨的杖。',
    '賽10:6 我要打發他攻擊褻瀆的國民，吩咐他攻擊我所惱怒的百姓，搶財為擄物，奪貨為掠物，將他們踐踏，像街上的泥土一樣。',
    '賽10:7 然而，他不是這樣的意思；他心也不這樣打算。他心裡倒想毀滅，剪除不少的國。',
    '賽10:8 他說：我的臣僕豈不都是王嗎﹖',
    '賽10:9 迦勒挪豈不像迦基米施嗎﹖哈馬豈不像亞珥拔嗎﹖撒瑪利亞豈不像大馬色嗎﹖',
    '賽10:10 我手已經搆到有偶像的國；這些國雕刻的偶像過於耶路撒冷和撒瑪利亞的偶像。',
    '賽10:11 我怎樣待撒瑪利亞和其中的偶像，豈不照樣待耶路撒冷和其中的偶像嗎﹖',
    '賽10:12 主在錫安山和耶路撒冷成就他一切工作的時候，主說：我必罰亞述王自大的心和他高傲眼目的榮耀。',
    '賽10:13 因為他說：我所成就的事是靠我手的能力和我的智慧，我本有聰明。我挪移列國的地界，搶奪他們所積蓄的財寶；並且我像勇士，使坐寶座的降為卑。',
    '賽10:14 我的手搆到列國的財寶，好像人搆到鳥窩；我也得了全地，好像人拾起所棄的雀蛋。沒有動翅膀的；沒有張嘴的，也沒有鳴叫的。',
    '賽10:15 斧豈可向用斧砍木的自誇呢﹖鋸豈可向用鋸的自大呢﹖好比棍掄起那舉棍的，好比杖舉起那非木的人。',
    '賽10:16 因此，主─萬軍之耶和華必使亞述王的肥壯人變為瘦弱，在他的榮華之下必有火著起，如同焚燒一樣。',
    '賽10:17 以色列的光必如火；他的聖者必如火焰。在一日之間，將亞述王的荊棘和蒺藜焚燒淨盡；',
    '賽10:18 又將他樹林和肥田的榮耀全然燒盡，好像拿軍旗的昏過去一樣。',
    '賽10:19 他林中剩下的樹必稀少，就是孩子也能寫其數。',
    '賽10:20 到那日，以色列所剩下的和雅各家所逃脫的，不再倚靠那擊打他們的，卻要誠實倚靠耶和華─以色列的聖者。',
    '賽10:21 所剩下的，就是雅各家所剩下的，必歸回全能的神。',
    '賽10:22 以色列啊，你的百姓雖多如海沙，惟有剩下的歸回。原來滅絕的事已定，必有公義施行，如水漲溢。',
    '賽10:23 因為主─萬軍之耶和華在全地之中必成就所定規的結局。',
    '賽10:24 所以，主─萬軍之耶和華如此說：住錫安我的百姓啊，亞述王雖然用棍擊打你，又照埃及的樣子舉杖攻擊你，你卻不要怕他。',
    '賽10:25 因為還有一點點時候，向你們發的忿恨就要完畢，我的怒氣要向他發作，使他滅亡。',
    '賽10:26 萬軍之耶和華要興起鞭來攻擊他，好像在俄立磐石那裡殺戮米甸人一樣。耶和華的杖要向海伸出，把杖舉起，像在埃及一樣。',
    '賽10:27 到那日，亞述王的重擔必離開你的肩頭；他的軛必離開你的頸項；那軛也必因肥壯的緣故撐斷（或譯：因膏油的緣故毀壞）。',
    '賽10:28 亞述王來到亞葉，經過米磯崙，在密抹安放輜重。',
    '賽10:29 他們過了隘口，在迦巴住宿。拉瑪人戰兢；掃羅的基比亞人逃跑。',
    '賽10:30 迦琳的居民（原文是女子）哪，要高聲呼喊！萊煞人哪，須聽！哀哉！困苦的亞拿突啊。',
    '賽10:31 瑪得米那人躲避；基柄的居民逃遁。',
    '賽10:32 當那日，亞述王要在挪伯歇兵，向錫安女子的山─就是耶路撒冷的山─掄手攻他。',
    '賽10:33 看哪，主─萬軍之耶和華以驚嚇削去樹枝；長高的必被砍下，高大的必被伐倒。',
    '賽10:34 稠密的樹林，他要用鐵器砍下；利巴嫩的樹木必被大能者伐倒。',
    '賽11:1 從耶西的本（原文是丕）必發一條；從他根生的枝子必結果實。',
    '賽11:2 耶和華的靈必住在他身上，就是使他有智慧和聰明的靈，謀略和能力的靈，知識和敬畏耶和華的靈。',
    '賽11:3 他必以敬畏耶和華為樂；行審判不憑眼見，斷是非也不憑耳聞；',
    '賽11:4 卻要以公義審判貧窮人，以正直判斷世上的謙卑人，以口中的杖擊打世界，以嘴裡的氣殺戮惡人。',
    '賽11:5 公義必當他的腰帶；信實必當他脅下的帶子。',
    '賽11:6 豺狼必與綿羊羔同居，豹子與山羊羔同臥；少壯獅子與牛犢並肥畜同群；小孩子要牽引他們。',
    '賽11:7 牛必與熊同食；牛犢必與小熊同臥；獅子必吃草，與牛一樣。',
    '賽11:8 吃奶的孩子必玩耍在虺蛇的洞口；斷奶的嬰兒必按手在毒蛇的穴上。',
    '賽11:9 在我聖山的遍處，這一切都不傷人，不害物；因為認識耶和華的知識要充滿遍地，好像水充滿洋海一般。',
    '賽11:10 到那日，耶西的根立作萬民的大旗；外邦人必尋求他，他安息之所大有榮耀。',
    '賽11:11 當那日，主必二次伸手救回自己百姓中所餘剩的，就是在亞述、埃及、巴忒羅、古實、以攔、示拿、哈馬，並眾海島所剩下的。',
    '賽11:12 他必向列國豎立大旗，招回以色列被趕散的人，又從地的四方聚集分散的猶大人。',
    '賽11:13 以法蓮的嫉妒就必消散；擾害猶大的必被剪除。以法蓮必不嫉妒猶大，猶大也不擾害以法蓮。',
    '賽11:14 他們要向西飛，撲在非利士人的肩頭上（肩頭上：或譯西界），一同擄掠東方人，伸手按住以東和摩押；亞捫人也必順服他們。',
    '賽11:15 耶和華必使埃及海汊枯乾，掄手用暴熱的風使大河分為七條，令人過去不致濕腳。',
    '賽11:16 為主餘剩的百姓，就是從亞述剩下回來的，必有一條大道，如當日以色列從埃及地上來一樣。',
    '賽12:1 到那日，你必說：耶和華啊，我要稱謝你！因為你雖然向我發怒，你的怒氣卻已轉消；你又安慰了我。',
    '賽12:2 看哪！神是我的拯救；我要倚靠他，並不懼怕。因為主耶和華是我的力量，是我的詩歌，他也成了我的拯救。',
    '賽12:3 所以，你們必從救恩的泉源歡然取水。',
    '賽12:4 在那日，你們要說：當稱謝耶和華，求告他的名；將他所行的傳揚在萬民中，提說他的名已被尊崇。',
    '賽12:5 你們要向耶和華唱歌，因他所行的甚是美好；但願這事普傳天下。',
    '賽12:6 錫安的居民哪，當揚聲歡呼，因為在你們中間的以色列聖者乃為至大。',
    '賽13:1 亞摩斯的兒子以賽亞得默示，論巴比倫。',
    '賽13:2 應當在淨光的山豎立大旗，向群眾揚聲招手，使他們進入貴冑的門。',
    '賽13:3 我吩咐我所挑出來的人；我招呼我的勇士─就是那矜誇高傲之輩，為要成就我怒中所定的。',
    '賽13:4 山間有多人的聲音，好像是大國人民。有許多國的民聚集鬨嚷的聲音；這是萬軍之耶和華點齊軍隊，預備打仗。',
    '賽13:5 他們從遠方來，從天邊來，就是耶和華並他惱恨的兵器要毀滅這全地。',
    '賽13:6 你們要哀號，因為耶和華的日子臨近了！這日來到，好像毀滅從全能者來到。',
    '賽13:7 所以，人手都必軟弱；人心都必消化。',
    '賽13:8 他們必驚惶悲痛；愁苦必將他們抓住。他們疼痛，好像產難的婦人一樣，彼此驚奇相看，臉如火焰。',
    '賽13:9 耶和華的日子臨到，必有殘忍、忿恨、烈怒，使這地荒涼，從其中除滅罪人。',
    '賽13:10 天上的眾星群宿都不發光，日頭一出就變黑暗；月亮也不放光。',
    '賽13:11 我必因邪惡刑罰世界，因罪孽刑罰惡人，使驕傲人的狂妄止息，制伏強暴人的狂傲。',
    '賽13:12 我必使人比精金還少，使人比俄斐純金更少。',
    '賽13:13 我─萬軍之耶和華在忿恨中發烈怒的日子，必使天震動，使地搖撼，離其本位。',
    '賽13:14 人必像被追趕的鹿，像無人收聚的羊，各歸回本族，各逃到本土。',
    '賽13:15 凡被仇敵追上的必被刺死；凡被捉住的必被刀殺。',
    '賽13:16 他們的嬰孩必在他們眼前摔碎；他們的房屋必被搶奪；他們的妻子必被玷污。',
    '賽13:17 我必激動瑪代人來攻擊他們。瑪代人不注重銀子，也不喜愛金子。',
    '賽13:18 他們必用弓擊碎少年人，不憐憫婦人所生的，眼也不顧惜孩子。',
    '賽13:19 巴比倫素來為列國的榮耀，為迦勒底人所矜誇的華美，必像神所傾覆的所多瑪、蛾摩拉一樣。',
    '賽13:20 其內必永無人煙，世世代代無人居住。亞拉伯人也不在那裡支搭帳棚；牧羊的人也不使羊群臥在那裡。',
    '賽13:21 只有曠野的走獸臥在那裡；咆哮的獸滿了房屋。鴕鳥住在那裡；野山羊在那裡跳舞。',
    '賽13:22 豺狼必在他宮中呼號；野狗必在他華美殿內吼叫。巴比倫受罰的時候臨近；他的日子必不長久。',
    '賽14:1 耶和華要憐恤雅各，必再揀選以色列，將他們安置在本地。寄居的必與他們聯合，緊貼雅各家。',
    '賽14:2 外邦人必將他們帶回本土；以色列家必在耶和華的地上得外邦人為僕婢，也要擄掠先前擄掠他們的，轄制先前欺壓他們的。',
    '賽14:3 當耶和華使你脫離愁苦、煩惱，並人勉強你做的苦工，得享安息的日子，',
    '賽14:4 你必題這詩歌論巴比倫王說：欺壓人的何竟息滅﹖強暴的何竟止息﹖',
    '賽14:5 耶和華折斷了惡人的杖，轄制人的圭，',
    '賽14:6 就是在忿怒中連連攻擊眾民的，在怒氣中轄制列國，行逼迫無人阻止的。',
    '賽14:7 現在全地得安息，享平靜；人皆發聲歡呼。',
    '賽14:8 松樹和利巴嫩的香柏樹都因你歡樂，說：自從你仆倒，再無人上來砍伐我們。',
    '賽14:9 你下到陰間，陰間就因你震動來迎接你，又因你驚動在世曾為首領的陰魂，並使那曾為列國君王的，都離位站起。',
    '賽14:10 他們都要發言對你說：你也變為軟弱像我們一樣嗎﹖你也成了我們的樣子嗎﹖',
    '賽14:11 你的威勢和你琴瑟的聲音都下到陰間。你下鋪的是蟲，上蓋的是蛆。',
    '賽14:12 明亮之星，早晨之子啊，你何竟從天墜落﹖你這攻敗列國的何竟被砍倒在地上﹖',
    '賽14:13 你心裡曾說：我要升到天上；我要高舉我的寶座在神眾星以上；我要坐在聚會的山上，在北方的極處。',
    '賽14:14 我要升到高雲之上；我要與至上者同等。',
    '賽14:15 然而，你必墜落陰間，到坑中極深之處。',
    '賽14:16 凡看見你的都要定睛看你，留意看你，說：使大地戰抖，使列國震動，',
    '賽14:17 使世界如同荒野，使城邑傾覆，不釋放被擄的人歸家，是這個人嗎﹖',
    '賽14:18 列國的君王俱各在自己陰宅的榮耀中安睡。',
    '賽14:19 惟獨你被拋棄，不得入你的墳墓，好像可憎的枝子，以被殺的人為衣，就是被刀刺透，墜落坑中石頭那裡的；你又像被踐踏的屍首一樣。',
    '賽14:20 你不得與君王同葬；因為你敗壞你的國，殺戮你的民。惡人後裔的名，必永不提說。',
    '賽14:21 先人既有罪孽，就要預備殺戮他的子孫，免得他們興起來，得了遍地，在世上修滿城邑。',
    '賽14:22 萬軍之耶和華說：我必興起攻擊他們，將巴比倫的名號和所餘剩的人，連子帶孫一併剪除。這是耶和華說的。',
    '賽14:23 我必使巴比倫為箭豬所得，又變為水池；我要用滅亡的掃帚掃淨他。這是萬軍之耶和華說的。',
    '賽14:24 萬軍之耶和華起誓說：我怎樣思想，必照樣成就；我怎樣定意，必照樣成立，',
    '賽14:25 就是在我地上打折亞述人，在我山上將他踐踏。他加的軛必離開以色列人；他加的重擔必離開他們的肩頭。',
    '賽14:26 這是向全地所定的旨意；這是向萬國所伸出的手。',
    '賽14:27 萬軍之耶和華既然定意，誰能廢棄呢﹖他的手已經伸出，誰能轉回呢﹖',
    '賽14:28 亞哈斯王崩的那年，就有以下的默示：',
    '賽14:29 非利士全地啊，不要因擊打你的杖折斷就喜樂。因為從蛇的根必生出毒蛇；他所生的是火焰的飛龍。',
    '賽14:30 貧寒人的長子必有所食；窮乏人必安然躺臥。我必以饑荒治死你的根；你所餘剩的人必被殺戮。',
    '賽14:31 門哪，應當哀號！城啊，應當呼喊！非利士全地啊，你都消化了！因為有煙從北方出來，他行伍中並無亂隊的。',
    '賽14:32 可怎樣回答外邦（或指非利士）的使者呢﹖必說：耶和華建立了錫安；他百姓中的困苦人必投奔在其中。',
    '賽15:1 論摩押的默示：一夜之間，摩押的亞珥變為荒廢，歸於無有；一夜之間，摩押的基珥變為荒廢，歸於無有。',
    '賽15:2 他們上巴益，又往底本，到高處去哭泣。摩押人因尼波和米底巴哀號，各人頭上光禿，鬍鬚剃淨。',
    '賽15:3 他們在街市上都腰束麻布，在房頂上和寬闊處俱各哀號，眼淚汪汪。',
    '賽15:4 希實本和以利亞利悲哀的聲音達到雅雜，所以摩押帶兵器的高聲喊嚷，人心戰兢。',
    '賽15:5 我心為摩押悲哀；他的貴冑（或譯：逃民）逃到瑣珥，到伊基拉施利施亞。他們上魯希坡，隨走隨哭。在何羅念的路上，因毀滅舉起哀聲。',
    '賽15:6 因為寧林的水成為乾涸，青草枯乾，嫩草滅沒，青綠之物，一無所有。',
    '賽15:7 因此，摩押人所得的財物和所積蓄的都要運過柳樹河。',
    '賽15:8 哀聲遍聞摩押的四境；哀號的聲音達到以基蓮；哀號的聲音達到比珥以琳。',
    '賽15:9 底們的水充滿了血；我還要加增底們的災難，叫獅子來追上摩押逃脫的民和那地上所餘剩的人。',
    '賽16:1 你們當將羊羔奉給那地掌權的，從西拉往曠野，送到錫安城（原文是女子）的山。',
    '賽16:2 摩押的居民（原文是女子）在亞嫩渡口，必像遊飛的鳥，如拆窩的雛。',
    '賽16:3 求你獻謀略，行公平，使你的影子在午間如黑夜，隱藏被趕散的人，不可顯露逃民。',
    '賽16:4 求你容我這被趕散的人和你同居。至於摩押，求你作他的隱密處，脫離滅命者的面。勒索人的歸於無有，毀滅的事止息了，欺壓人的從國中除滅了，',
    '賽16:5 必有寶座因慈愛堅立；必有一位誠誠實實坐在其上，在大衛帳幕中施行審判，尋求公平，速行公義。',
    '賽16:6 我們聽說摩押人驕傲，是極其驕傲；聽說他狂妄、驕傲、忿怒；他誇大的話是虛空的。',
    '賽16:7 因此，摩押人必為摩押哀號；人人都要哀號。你們摩押人要為吉珥哈列設的葡萄餅哀歎，極其憂傷。',
    '賽16:8 因為希實本的田地和西比瑪的葡萄樹都衰殘了。列國的君主折斷其上美好的枝子；這枝子長到雅謝延到曠野，嫩枝向外探出，直探過鹽海。',
    '賽16:9 因此，我要為西比瑪的葡萄樹哀哭，與雅謝人哀哭一樣。希實本、以利亞利啊，我要以眼淚澆灌你；因為有交戰吶喊的聲音臨到你夏天的果子，並你收割的莊稼。',
    '賽16:10 從肥美的田中奪去了歡喜快樂；在葡萄園裡必無歌唱，也無歡呼的聲音。踹酒的在酒醡中不得踹出酒來；我使他歡呼的聲音止息。',
    '賽16:11 因此，我心腹為摩押哀鳴如琴；我心腸為吉珥哈列設也是如此。',
    '賽16:12 摩押人朝見的時候，在高處疲乏，又到他聖所祈禱，也不蒙應允。',
    '賽16:13 這是耶和華從前論摩押的話。',
    '賽16:14 但現在耶和華說：三年之內，照雇工的年數，摩押的榮耀與他的群眾必被藐視，餘剩的人甚少無幾。',
    '賽17:1 論大馬色的默示：看哪，大馬色已被廢棄，不再為城，必變作亂堆。',
    '賽17:2 亞羅珥的城邑已被撇棄，必成為牧羊之處；羊在那裡躺臥，無人驚嚇。',
    '賽17:3 以法蓮不再有保障；大馬色不再有國權；亞蘭所剩下的必像以色列人的榮耀消滅一樣。這是萬軍之耶和華說的。',
    '賽17:4 到那日，雅各的榮耀必至枵薄；他肥胖的身體必漸瘦弱。',
    '賽17:5 就必像收割的人收斂禾稼，用手割取穗子，又像人在利乏音谷拾取遺落的穗子。',
    '賽17:6 其間所剩下的不多，好像人打橄欖樹─在儘上的枝梢上只剩兩三個果子；在多果樹的旁枝上只剩四五個果子。這是耶和華─以色列的神說的。',
    '賽17:7 當那日，人必仰望造他們的主，眼目重看以色列的聖者。',
    '賽17:8 他們必不仰望祭壇，就是自己手所築的，也不重看自己指頭所做的，無論是木偶是日像。',
    '賽17:9 在那日，他們的堅固城必像樹林中和山頂上所撇棄的地方，就是從前在以色列人面前被人撇棄的。這樣，地就荒涼了。',
    '賽17:10 因你忘記救你的神，不記念你能力的磐石；所以，你栽上佳美的樹秧子，插上異樣的栽子。',
    '賽17:11 栽種的日子，你周圍圈上籬笆，又到早晨使你所種的開花；但在愁苦極其傷痛的日子，所收割的都飛去了。',
    '賽17:12 唉！多民鬨嚷，好像海浪匉訇；列邦奔騰，好像猛水滔滔；',
    '賽17:13 列邦奔騰，好像多水滔滔；但神斥責他們，他們就遠遠逃避，又被追趕，如同山上的風前糠，又如暴風前的旋風土。',
    '賽17:14 到晚上有驚嚇，未到早晨他們就沒有了。這是擄掠我們之人所得的分，是搶奪我們之人的報應。',
    '賽18:1 唉！古實河外翅膀刷刷響聲之地，',
    '賽18:2 差遣使者在水面上，坐蒲草船過海。先知說：你們快行的使者，要到高大光滑的民那裡去。自從開國以來，那民極其可畏，是分地界踐踏人的；他們的地有江河分開。',
    '賽18:3 世上一切的居民和地上所住的人哪，山上豎立大旗的時候你們要看；吹角的時候你們要聽。',
    '賽18:4 耶和華對我這樣說：我要安靜，在我的居所觀看，如同日光中的清熱，又如露水的雲霧在收割的熱天。',
    '賽18:5 收割之先，花開已謝，花也成了將熟的葡萄；他必用鐮刀削去嫩枝，又砍掉蔓延的枝條，',
    '賽18:6 都要撇給山間的鷙鳥和地上的野獸。夏天，鷙鳥要宿在其上；冬天，野獸都臥在其中。',
    '賽18:7 到那時，這高大光滑的民，就是從開國以來極其可畏、分地界踐踏人的，他們的地有江河分開；他們必將禮物奉給萬軍之耶和華，就是奉到錫安山─耶和華安置他名的地方。',
    '賽19:1 論埃及的默示：看哪，耶和華乘駕快雲，臨到埃及。埃及的偶像在他面前戰兢；埃及人的心在裡面消化。',
    '賽19:2 我必激動埃及人攻擊埃及人─弟兄攻擊弟兄，鄰舍攻擊鄰舍；這城攻擊那城，這國攻擊那國。',
    '賽19:3 埃及人的心神必在裡面耗盡；我必敗壞他們的謀略。他們必求問偶像和念咒的、交鬼的、行巫術的。',
    '賽19:4 我必將埃及人交在殘忍主的手中；強暴王必轄制他們。這是主─萬軍之耶和華說的。',
    '賽19:5 海中的水必絕盡，河也消沒乾涸。',
    '賽19:6 江河要變臭；埃及的河水都必減少枯乾。葦子和蘆荻都必衰殘；',
    '賽19:7 靠尼羅河旁的草田，並沿尼羅河所種的田，都必枯乾。莊稼被風吹去，歸於無有。',
    '賽19:8 打魚的必哀哭。在尼羅河一切釣魚的必悲傷；在水上撒網的必都衰弱。',
    '賽19:9 用梳好的麻造物的和織白布的都必羞愧；',
    '賽19:10 國柱必被打碎，所有傭工的，心必愁煩。',
    '賽19:11 瑣安的首領極其愚昧；法老大有智慧的謀士，所籌劃的成為愚謀。你們怎敢對法老說：我是智慧人的子孫，我是古王的後裔﹖',
    '賽19:12 你的智慧人在哪裡呢﹖萬軍之耶和華向埃及所定的旨意，他們可以知道，可以告訴你吧！',
    '賽19:13 瑣安的首領都變為愚昧；挪弗的首領都受了迷惑。當埃及支派房角石的，使埃及人走錯了路。',
    '賽19:14 耶和華使乖謬的靈攙入埃及中間；首領使埃及一切所做的都有差錯，好像醉酒之人嘔吐的時候東倒西歪一樣。',
    '賽19:15 埃及中，無論是頭與尾，棕枝與蘆葦，所做之工都不成就。',
    '賽19:16 到那日，埃及人必像婦人一樣，他們必因萬軍之耶和華在埃及以上所掄的手，戰兢懼怕。',
    '賽19:17 猶大地必使埃及驚恐，向誰提起猶大地，誰就懼怕。這是因萬軍之耶和華向埃及所定的旨意。',
    '賽19:18 當那日，埃及地必有五城的人說迦南的方言，又指著萬軍之耶和華起誓。有一城必稱為滅亡城。',
    '賽19:19 當那日，在埃及地中必有為耶和華築的一座壇；在埃及的邊界上必有為耶和華立的一根柱。',
    '賽19:20 這都要在埃及地為萬軍之耶和華作記號和證據。埃及人因為受人的欺壓哀求耶和華，他就差遣一位救主作護衛者，拯救他們。',
    '賽19:21 耶和華必被埃及人所認識。在那日，埃及人必認識耶和華，也要獻祭物和供物敬拜他，並向耶和華許願還願。',
    '賽19:22 耶和華必擊打埃及，又擊打又醫治，埃及人就歸向耶和華。他必應允他們的禱告，醫治他們。',
    '賽19:23 當那日，必有從埃及通亞述去的大道。亞述人要進入埃及，埃及人也進入亞述；埃及人要與亞述人一同敬拜耶和華。',
    '賽19:24 當那日，以色列必與埃及、亞述三國一律，使地上的人得福；',
    '賽19:25 因為萬軍之耶和華賜福給他們，說：埃及─我的百姓，亞述─我手的工作，以色列─我的產業，都有福了！',
    '賽20:1 亞述王撒珥根打發他珥探到亞實突的那年，他珥探就攻打亞實突，將城攻取。',
    '賽20:2 那時，耶和華曉諭亞摩斯的兒子以賽亞說：你去解掉你腰間的麻布，脫下你腳上的鞋。以賽亞就這樣做，露身赤腳行走。',
    '賽20:3 耶和華說：我僕人以賽亞怎樣露身赤腳行走三年，作為關乎埃及和古實的預兆奇蹟。',
    '賽20:4 照樣，亞述王也必擄去埃及人，掠去古實人，無論老少，都露身赤腳，現出下體，使埃及蒙羞。',
    '賽20:5 以色列人必因所仰望的古實，所誇耀的埃及，驚惶羞愧。',
    '賽20:6 那時，這沿海一帶的居民必說：看哪，我們素所仰望的，就是我們為脫離亞述王逃往求救的，不過是如此！我們怎能逃脫呢﹖',
    '賽21:1 論海旁曠野的默示：有仇敵從曠野，從可怕之地而來，好像南方的旋風，猛然掃過。',
    '賽21:2 令人悽慘的異象已默示於我。詭詐的行詭詐，毀滅的行毀滅。以攔哪，你要上去！瑪代啊，你要圍困！主說：我使一切歎息止住。',
    '賽21:3 所以，我滿腰疼痛；痛苦將我抓住，好像產難的婦人一樣。我疼痛甚至不能聽；我驚惶甚至不能看。',
    '賽21:4 我心慌張，驚恐威嚇我。我所羨慕的黃昏，變為我的戰兢。',
    '賽21:5 他們擺設筵席，派人守望，又吃又喝。首領啊，你們起來，用油抹盾牌。',
    '賽21:6 主對我如此說：你去設立守望的，使他將所看見的述說。',
    '賽21:7 他看見軍隊，就是騎馬的一對一對地來，又看見驢隊，駱駝隊，就要側耳細聽。',
    '賽21:8 他像獅子吼叫，說：主啊，我白日常站在望樓上，整夜立在我守望所。',
    '賽21:9 看哪，有一隊軍兵騎著馬，一對一對地來。他就說：巴比倫傾倒了！傾倒了！他一切雕刻的神像都打碎於地。',
    '賽21:10 我被打的禾稼，我場上的穀啊，我從萬軍之耶和華─以色列的神那裡所聽見的，都告訴你們了。',
    '賽21:11 論度瑪的默示：有人聲從西珥呼問我說：守望的啊，夜裡如何﹖守望的啊，夜裡如何﹖',
    '賽21:12 守望的說：早晨將到，黑夜也來。你們若要問就可以問，可以回頭再來。',
    '賽21:13 論亞拉伯的默示：底但結伴的客旅啊，你們必在亞拉伯的樹林中住宿。',
    '賽21:14 提瑪地的居民拿水來，送給口渴的，拿餅來迎接逃避的。',
    '賽21:15 因為他們逃避刀劍和出了鞘的刀，並上了弦的弓與刀兵的重災。',
    '賽21:16 主對我這樣說：一年之內，照雇工的年數，基達的一切榮耀必歸於無有。',
    '賽21:17 弓箭手所餘剩的，就是基達人的勇士，必然稀少，因為這是耶和華─以色列的神說的。',
    '賽22:1 論異象谷的默示：有什麼事使你這滿城的人都上房頂呢﹖',
    '賽22:2 你這滿處吶喊、大有喧嘩的城，歡樂的邑啊，你中間被殺的並不是被刀殺，也不是因打仗死亡。',
    '賽22:3 你所有的官長一同逃跑，都為弓箭手所捆綁。你中間一切被找到的都一同被捆綁；他們本是逃往遠方的。',
    '賽22:4 所以我說：你們轉眼不看我，我要痛哭。不要因我眾民（原文是民女）的毀滅，就竭力安慰我。',
    '賽22:5 因為主─萬軍之耶和華使異象谷有潰亂、踐踏、煩擾的日子。城被攻破，哀聲達到山間。',
    '賽22:6 以攔帶著箭袋，還有坐戰車的和馬兵；吉珥揭開盾牌。',
    '賽22:7 你嘉美的谷遍滿戰車，也有馬兵在城門前排列。',
    '賽22:8 他去掉猶大的遮蓋。那日，你就仰望林庫內的軍器。',
    '賽22:9 你們看見大衛城的破口很多，便聚積下池的水，',
    '賽22:10 又數點耶路撒冷的房屋，將房屋拆毀，修補城牆，',
    '賽22:11 又在兩道城牆中間挖一個聚水池可盛舊池的水，卻不仰望做這事的主，也不顧念從古定這事的。',
    '賽22:12 當那日，主─萬軍之耶和華叫人哭泣哀號，頭上光禿，身披麻布。',
    '賽22:13 誰知，人倒歡喜快樂，宰牛殺羊，吃肉喝酒，說：我們吃喝吧！因為明天要死了。',
    '賽22:14 萬軍之耶和華親自默示我說：這罪孽直到你們死，斷不得赦免！這是主─萬軍之耶和華說的。',
    '賽22:15 主─萬軍之耶和華這樣說：你去見掌銀庫的，就是家宰舍伯那，對他說：',
    '賽22:16 你在這裡做什麼呢﹖有什麼人竟在這裡鑿墳墓，就是在高處為自己鑿墳墓，在磐石中為自己鑿出安身之所﹖',
    '賽22:17 看哪，耶和華必像大有力的人，將你緊緊纏裹，竭力拋去。',
    '賽22:18 他必將你滾成一團，拋在寬闊之地，好像拋球一樣。你這主人家的羞辱，必在那裡坐你榮耀的車，也必在那裡死亡。',
    '賽22:19 我必趕逐你離開官職；你必從你的原位撤下。',
    '賽22:20 到那日，我必召我僕人希勒家的兒子以利亞敬來，',
    '賽22:21 將你的外袍給他穿上，將你的腰帶給他繫緊，將你的政權交在他手中。他必作耶路撒冷居民和猶大家的父。',
    '賽22:22 我必將大衛家的鑰匙放在他肩頭上。他開，無人能關；他關，無人能開。',
    '賽22:23 我必將他安穩，像釘子釘在堅固處；他必作為他父家榮耀的寶座。',
    '賽22:24 他父家所有的榮耀，連兒女帶子孫，都掛在他身上，好像一切小器皿，從杯子到酒瓶掛上一樣。',
    '賽22:25 萬軍之耶和華說：當那日，釘在堅固處的釘子必壓斜，被砍斷落地；掛在其上的重擔必被剪斷。因為這是耶和華說的。',
    '賽23:1 論推羅的默示：他施的船隻都要哀號；因為推羅變為荒場，甚至沒有房屋，沒有可進之路。這消息是從基提地得來的。',
    '賽23:2 沿海的居民，就是素來靠航海西頓的商家得豐盛的，你們當靜默無言。',
    '賽23:3 在大水之上，西曷的糧食、尼羅河的莊稼是推羅的進項；他作列國的大碼頭。',
    '賽23:4 西頓哪，你當慚愧；因為大海說，就是海中的保障說：我沒有劬勞，也沒有生產，沒有養育男子，也沒有撫養童女。',
    '賽23:5 這風聲傳到埃及；埃及人為推羅的風聲極其疼痛。',
    '賽23:6 推羅人哪，你們當過到他施去；沿海的居民哪，你們都當哀號。',
    '賽23:7 這是你們歡樂的城，從上古而有的嗎﹖其中的居民往遠方寄居。',
    '賽23:8 推羅本是賜冠冕的。他的商家是王子；他的買賣人是世上的尊貴人。遭遇如此是誰定的呢﹖',
    '賽23:9 是萬軍之耶和華所定的！為要污辱一切高傲的榮耀，使地上一切的尊貴人被藐視。',
    '賽23:10 他施的民（原文是女）哪，可以流行你的地，好像尼羅河；不再有腰帶拘緊你。',
    '賽23:11 耶和華已經向海伸手，震動列國。至於迦南，他已經吩咐拆毀其中的保障。',
    '賽23:12 他又說：受欺壓西頓的居民（原文是處女）哪，你必不得再歡樂。起來！過到基提去；就是在那裡也不得安歇。',
    '賽23:13 （看哪，迦勒底人之地向來沒有這民，這國是亞述人為住曠野的人所立的。現在他們建築戍樓，拆毀推羅的宮殿，使他成為荒涼。）',
    '賽23:14 他施的船隻都要哀號，因為你們的保障變為荒場。',
    '賽23:15 到那時，推羅必被忘記七十年，照著一王的年日。七十年後，推羅的景況必像妓女所唱的歌：',
    '賽23:16 你這被忘記的妓女啊，拿琴周流城內，巧彈多唱，使人再想念你。',
    '賽23:17 七十年後，耶和華必眷顧推羅，他就仍得利息（原文是雇價；下同），與地上的萬國交易（原文是行淫）。',
    '賽23:18 他的貨財和利息要歸耶和華為聖，必不積攢存留；因為他的貨財必為住在耶和華面前的人所得，使他們吃飽，穿耐久的衣服。',
    '賽24:1 看哪，耶和華使地空虛，變為荒涼；又翻轉大地，將居民分散。',
    '賽24:2 那時百姓怎樣，祭司也怎樣；僕人怎樣，主人也怎樣；婢女怎樣，主母也怎樣；買物的怎樣，賣物的也怎樣；放債的怎樣，借債的也怎樣；取利的怎樣，出利的也怎樣。',
    '賽24:3 地必全然空虛，盡都荒涼；因為這話是耶和華說的。',
    '賽24:4 地上悲哀衰殘，世界敗落衰殘；地上居高位的人也敗落了。',
    '賽24:5 地被其上的居民污穢；因為他們犯了律法，廢了律例，背了永約。',
    '賽24:6 所以，地被咒詛吞滅；住在其上的顯為有罪。地上的居民被火焚燒，剩下的人稀少。',
    '賽24:7 新酒悲哀，葡萄樹衰殘；心中歡樂的俱都歎息。',
    '賽24:8 擊鼓之樂止息；宴樂人的聲音完畢，彈琴之樂也止息了。',
    '賽24:9 人必不得飲酒唱歌；喝濃酒的，必以為苦。',
    '賽24:10 荒涼的城拆毀了；各家關門閉戶，使人都不得進去。',
    '賽24:11 在街上因酒有悲歎的聲音；一切喜樂變為昏暗；地上的歡樂歸於無有。',
    '賽24:12 城中只有荒涼；城門拆毀淨盡。',
    '賽24:13 在地上的萬民中，必像打過的橄欖樹，又像已摘的葡萄所剩無幾。',
    '賽24:14 這些人要高聲歡呼；他們為耶和華的威嚴，從海那裡揚起聲來。',
    '賽24:15 因此，你們要在東方榮耀耶和華；在眾海島榮耀耶和華─以色列神的名。',
    '賽24:16 我們聽見從地極有人歌唱，說：榮耀歸於義人。我卻說：我消滅了！我消滅了，我有禍了！詭詐的行詭詐；詭詐的大行詭詐。',
    '賽24:17 地上的居民哪，恐懼、陷坑、網羅都臨近你。',
    '賽24:18 躲避恐懼聲音的必墜入陷坑；從陷坑上來的必被網羅纏住；因為天上的窗戶都開了，地的根基也震動了。',
    '賽24:19 地全然破壞，盡都崩裂，大大地震動了。',
    '賽24:20 地要東倒西歪，好像醉酒的人；又搖來搖去，好像吊床。罪過在其上沉重，必然塌陷，不能復起。',
    '賽24:21 到那日，耶和華在高處必懲罰高處的眾軍，在地上必懲罰地上的列王。',
    '賽24:22 他們必被聚集，像囚犯被聚在牢獄中，並要囚在監牢裡，多日之後便被討罪（或譯：眷顧）。',
    '賽24:23 那時，月亮要蒙羞，日頭要慚愧；因為萬軍之耶和華必在錫安山，在耶路撒冷作王；在敬畏他的長老面前，必有榮耀。',
    '賽25:1 耶和華啊，你是我的神；我要尊崇你，我要稱讚你的名。因為你以忠信誠實行過奇妙的事，成就你古時所定的。',
    '賽25:2 你使城變為亂堆，使堅固城變為荒場，使外邦人宮殿的城不再為城，永遠不再建造。',
    '賽25:3 所以，剛強的民必榮耀你；強暴之國的城必敬畏你。',
    '賽25:4 因為當強暴人催逼人的時候，如同暴風直吹牆壁，你就作貧窮人的保障，作困乏人急難中的保障，作躲暴風之處，作避炎熱的陰涼。',
    '賽25:5 你要壓制外邦人的喧嘩，好像乾燥地的熱氣下落；禁止強暴人的凱歌，好像熱氣被雲影消化。',
    '賽25:6 在這山上，萬軍之耶和華必為萬民用肥甘設擺筵席，用陳酒和滿髓的肥甘，並澄清的陳酒，設擺筵席。',
    '賽25:7 他又必在這山上除滅遮蓋萬民之物和遮蔽萬國蒙臉的帕子。',
    '賽25:8 他已經吞滅死亡直到永遠。主耶和華必擦去各人臉上的眼淚，又除掉普天下他百姓的羞辱，因為這是耶和華說的。',
    '賽25:9 到那日，人必說：看哪，這是我們的神；我們素來等候他，他必拯救我們。這是耶和華，我們素來等候他，我們必因他的救恩歡喜快樂。',
    '賽25:10 耶和華的手必按在這山上；摩押人在所居之地必被踐踏，好像乾草被踐踏在糞池的水中。',
    '賽25:11 他必在其中伸開手，好像洑水的伸開手洑水一樣；但耶和華必使他的驕傲和他手所行的詭計一併敗落。',
    '賽25:12 耶和華使你城上的堅固高臺傾倒，拆平，直到塵埃。',
    '賽26:1 當那日，在猶大地人必唱這歌說：我們有堅固的城。耶和華要將救恩定為城牆，為外郭。',
    '賽26:2 敞開城門，使守信的義民得以進入。',
    '賽26:3 堅心倚賴你的，你必保守他十分平安，因為他倚靠你。',
    '賽26:4 你們當倚靠耶和華直到永遠，因為耶和華是永久的磐石。',
    '賽26:5 他使住高處的與高城一併敗落，將城拆毀，拆平，直到塵埃，',
    '賽26:6 要被腳踐踏，就是被困苦人的腳和窮乏人的腳踐踏。',
    '賽26:7 義人的道是正直的；你為正直的主，必修平義人的路。',
    '賽26:8 耶和華啊，我們在你行審判的路上等候你；我們心裡所羨慕的是你的名，就是你那可記念的名。',
    '賽26:9 夜間，我心中羨慕你；我裡面的靈切切尋求你。因為你在世上行審判的時候，地上的居民就學習公義。',
    '賽26:10 以恩惠待惡人，他仍不學習公義；在正直的地上，他必行事不義，也不注意耶和華的威嚴。',
    '賽26:11 耶和華啊，你的手高舉，他們仍然不看；卻要看你為百姓發的熱心，因而抱愧，並且有火燒滅你的敵人。',
    '賽26:12 耶和華啊，你必派定我們得平安，因為我們所做的事都是你給我們成就的。',
    '賽26:13 耶和華─我們的神啊，在你以外曾有別的主管轄我們，但我們專要倚靠你，提你的名。',
    '賽26:14 他們死了，必不能再活；他們去世，必不能再起；因為你刑罰他們，毀滅他們，他們的名號就全然消滅。',
    '賽26:15 耶和華啊，你增添國民，你增添國民；你得了榮耀，又擴張地的四境。',
    '賽26:16 耶和華啊，他們在急難中尋求你；你的懲罰臨到他們身上，他們就傾心吐膽禱告你。',
    '賽26:17 婦人懷孕，臨產疼痛，在痛苦之中喊叫；耶和華啊，我們在你面前也是如此。',
    '賽26:18 我們也曾懷孕疼痛，所產的竟像風一樣。我們在地上未曾行什麼拯救的事；世上的居民也未曾敗落。',
    '賽26:19 死人（原文是你的死人）要復活，屍首（原文是我的屍首）要興起。睡在塵埃的啊，要醒起歌唱！因你的甘露好像菜蔬上的甘露，地也要交出死人來。',
    '賽26:20 我的百姓啊，你們要來進入內室，關上門，隱藏片時，等到忿怒過去。',
    '賽26:21 因為耶和華從他的居所出來，要刑罰地上居民的罪孽。地也必露出其中的血，不再掩蓋被殺的人。',
    '賽27:1 到那日，耶和華必用他剛硬有力的大刀刑罰鱷魚─就是那快行的蛇，刑罰鱷魚─就是那曲行的蛇，並殺海中的大魚。',
    '賽27:2 當那日，有出酒的葡萄園，你們要指這園唱歌說：',
    '賽27:3 我─耶和華是看守葡萄園的；我必時刻澆灌，晝夜看守，免得有人損害。',
    '賽27:4 我心中不存忿怒。惟願荊棘蒺藜與我交戰，我就勇往直前，把他一同焚燒。',
    '賽27:5 不然，讓他持住我的能力，使他與我和好，願他與我和好。',
    '賽27:6 將來雅各要扎根，以色列要發芽開花；他們的果實必充滿世界。',
    '賽27:7 主擊打他們，豈像擊打那些擊打他們的人嗎﹖他們被殺戮，豈像被他們所殺戮的嗎﹖',
    '賽27:8 你打發他們去，是相機宜與他們相爭；颳東風的日子，就用暴風將他們逐去。',
    '賽27:9 所以，雅各的罪孽得赦免，他的罪過得除掉的果效，全在乎此：就是他叫祭壇的石頭變為打碎的灰石，以致木偶和日像不再立起。',
    '賽27:10 因為堅固城變為淒涼，成了撇下離棄的居所，像曠野一樣；牛犢必在那裡吃草，在那裡躺臥，並吃盡其中的樹枝。',
    '賽27:11 枝條枯乾，必被折斷；婦女要來點火燒著。因為這百姓蒙昧無知，所以，創造他們的必不憐恤他們；造成他們的也不施恩與他們。',
    '賽27:12 以色列人哪，到那日，耶和華必從大河，直到埃及小河，將你們一一地收集，如同人打樹拾果一樣。',
    '賽27:13 當那日，必大發角聲，在亞述地將要滅亡的，並在埃及地被趕散的，都要來，他們就在耶路撒冷聖山上敬拜耶和華。',
    '賽28:1 禍哉！以法蓮的酒徒，住在肥美谷的山上，他們心裡高傲，以所誇的為冠冕，猶如將殘之花。',
    '賽28:2 看哪，主有一大能大力者，像一陣冰雹，像毀滅的暴風，像漲溢的大水，他必用手將冠冕摔落於地。',
    '賽28:3 以法蓮高傲的酒徒，他的冠冕必被踏在腳下。',
    '賽28:4 那榮美將殘之花，就是在肥美谷山上的，必像夏令以前初熟的無花果；看見這果的就注意，一到手中就吞吃了。',
    '賽28:5 到那日，萬軍之耶和華必作他餘剩之民的榮冠華冕，',
    '賽28:6 也作了在位上行審判者公平之靈，並城門口打退仇敵者的力量。',
    '賽28:7 就是這地的人也因酒搖搖晃晃，因濃酒東倒西歪。祭司和先知因濃酒搖搖晃晃，被酒所困，因濃酒東倒西歪。他們錯解默示，謬行審判。',
    '賽28:8 因為各席上滿了嘔吐的污穢，無一處乾淨。',
    '賽28:9 譏誚先知的說：他要將知識指教誰呢﹖要使誰明白傳言呢﹖是那剛斷奶離懷的嗎﹖',
    '賽28:10 他竟命上加命，令上加令，律上加律，例上加例，這裡一點，那裡一點。',
    '賽28:11 先知說：不然，主要藉異邦人的嘴唇和外邦人的舌頭對這百姓說話。',
    '賽28:12 他曾對他們說：你們要使疲乏人得安息，這樣才得安息，才得舒暢，他們卻不肯聽。',
    '賽28:13 所以，耶和華向他們說的話是命上加命，令上加令，律上加律，例上加例，這裡一點，那裡一點，以致他們前行仰面跌倒，而且跌碎，並陷入網羅被纏住。',
    '賽28:14 所以，你們這些褻慢的人，就是轄管住在耶路撒冷這百姓的，要聽耶和華的話。',
    '賽28:15 你們曾說：我們與死亡立約，與陰間結盟；敵軍（原文是鞭子）如水漲漫經過的時候，必不臨到我們；因我們以謊言為避所，在虛假以下藏身。',
    '賽28:16 所以，主耶和華如此說：看哪，我在錫安放一塊石頭作為根基，是試驗過的石頭，是穩固根基，寶貴的房角石；信靠的人必不著急。',
    '賽28:17 我必以公平為準繩，以公義為線鉈。冰雹必沖去謊言的避所；大水必漫過藏身之處。',
    '賽28:18 你們與死亡所立的約必然廢掉，與陰間所結的盟必立不住。敵軍（原文是鞭子）如水漲漫經過的時候，你們必被他踐踏；',
    '賽28:19 每逢經過必將你們擄去。因為每早晨他必經過，白晝黑夜都必如此。明白傳言的必受驚恐。',
    '賽28:20 原來，床榻短，使人不能舒身；被窩窄，使人不能遮體。',
    '賽28:21 耶和華必興起，像在毘拉心山；他必發怒，像在基遍谷，好做成他的工，就是非常的工；成就他的事，就是奇異的事。',
    '賽28:22 現在你們不可褻慢，恐怕捆你們的綁索更結實了；因為我從主─萬軍之耶和華那裡聽見，已經決定在全地上施行滅絕的事。',
    '賽28:23 你們當側耳聽我的聲音，留心聽我的言語。',
    '賽28:24 那耕地為要撒種的，豈是常常耕地呢﹖豈是常常開墾耙地呢﹖',
    '賽28:25 他拉平了地面，豈不就撒種小茴香，播種大茴香，按行列種小麥，在定處種大麥，在田邊種粗麥呢﹖',
    '賽28:26 因為他的神教導他務農相宜，並且指教他。',
    '賽28:27 原來打小茴香，不用尖利的器具，軋大茴香，也不用碌碡（原文是車輪；下同）；但用杖打小茴香，用棍打大茴香。',
    '賽28:28 做餅的糧食是用磨磨碎，因他不必常打；雖用碌碡和馬打散，卻不磨他。',
    '賽28:29 這也是出於萬軍之耶和華─他的謀略奇妙；他的智慧廣大。',
    '賽29:1 唉！亞利伊勒，亞利伊勒，大衛安營的城，任憑你年上加年，節期照常周流。',
    '賽29:2 我終必使亞利伊勒困難；他必悲傷哀號，我卻仍以他為亞利伊勒。',
    '賽29:3 我必四圍安營攻擊你，屯兵圍困你，築壘攻擊你。',
    '賽29:4 你必敗落，從地中說話；你的言語必微細出於塵埃。你的聲音必像那交鬼者的聲音出於地；你的言語低低微微出於塵埃。',
    '賽29:5 你仇敵的群眾，卻要像細塵；強暴人的群眾，也要像飛糠。這事必頃刻之間忽然臨到。',
    '賽29:6 萬軍之耶和華必用雷轟、地震、大聲、旋風、暴風，並吞滅的火焰，向他討罪。',
    '賽29:7 那時，攻擊亞利伊勒列國的群眾，就是一切攻擊亞利伊勒和他的保障，並使他困難的，必如夢景，如夜間的異象；',
    '賽29:8 又必像飢餓的人夢中吃飯，醒了仍覺腹空；或像口渴的人夢中喝水，醒了仍覺發昏，心裡想喝。攻擊錫安山列國的群眾也必如此。',
    '賽29:9 你們等候驚奇吧！你們宴樂昏迷吧！他們醉了，卻非因酒；他們東倒西歪，卻非因濃酒。',
    '賽29:10 因為耶和華將沉睡的靈澆灌你們，封閉你們的眼，蒙蓋你們的頭。你們的眼就是先知；你們的頭就是先見。',
    '賽29:11 所有的默示，你們看如封住的書卷，人將這書卷交給識字的，說：請念吧！他說：我不能念，因為是封住了。',
    '賽29:12 又將這書卷交給不識字的人，說：請念吧！他說：我不識字。',
    '賽29:13 主說：因為這百姓親近我，用嘴唇尊敬我，心卻遠離我；他們敬畏我，不過是領受人的吩咐。',
    '賽29:14 所以，我在這百姓中要行奇妙的事，就是奇妙又奇妙的事。他們智慧人的智慧必然消滅，聰明人的聰明必然隱藏。',
    '賽29:15 禍哉！那些向耶和華深藏謀略的，又在暗中行事，說：誰看見我們呢﹖誰知道我們呢﹖',
    '賽29:16 你們把事顛倒了，豈可看窰匠如泥嗎﹖被製作的物豈可論製作物的說：他沒有製作我﹖或是被創造的物論造物的說：他沒有聰明。',
    '賽29:17 利巴嫩變為肥田，肥田看如樹林，不是只有一點點時候嗎﹖',
    '賽29:18 那時，聾子必聽見這書上的話；瞎子的眼必從迷矇黑暗中得以看見。',
    '賽29:19 謙卑人必因耶和華增添歡喜；人間貧窮的必因以色列的聖者快樂。',
    '賽29:20 因為，強暴人已歸無有，褻慢人已經滅絕，一切找機會作孽的都被剪除。',
    '賽29:21 他們在爭訟的事上定無罪的為有罪，為城門口責備人的設下網羅，用虛無的事屈枉義人。',
    '賽29:22 所以，救贖亞伯拉罕的耶和華論雅各家如此說：雅各必不再羞愧，面容也不致變色。',
    '賽29:23 但他看見他的眾子，就是我手的工作在他那裡，他們必尊我的名為聖，必尊雅各的聖者為聖，必敬畏以色列的神。',
    '賽29:24 心中迷糊的必得明白；發怨言的必受訓誨。',
    '賽30:1 耶和華說：禍哉！這悖逆的兒女。他們同謀，卻不由於我，結盟，卻不由於我的靈，以致罪上加罪；',
    '賽30:2 起身下埃及去，並沒有求問我；要靠法老的力量加添自己的力量，並投在埃及的蔭下。',
    '賽30:3 所以，法老的力量必作你們的羞辱；投在埃及的蔭下，要為你們的慚愧。',
    '賽30:4 他們的首領已在瑣安；他們的使臣到了哈內斯。',
    '賽30:5 他們必因那不利於他們的民蒙羞。那民並非幫助，也非利益，只作羞恥凌辱。',
    '賽30:6 論南方牲畜的默示：他們把財物馱在驢駒的脊背上，將寶物馱在駱駝的肉鞍上，經過艱難困苦之地，就是公獅、母獅、蝮蛇、火焰的飛龍之地，往那不利於他們的民那裡去。',
    '賽30:7 埃及的幫助是徒然無益的；所以我稱他為坐而不動的拉哈伯。',
    '賽30:8 現今你去，在他們面前將這話刻在版上，寫在書上，以便傳留後世，直到永永遠遠。',
    '賽30:9 因為他們是悖逆的百姓、說謊的兒女，不肯聽從耶和華訓誨的兒女。',
    '賽30:10 他們對先見說：不要望見不吉利的事，對先知說：不要向我們講正直的話；要向我們說柔和的話，言虛幻的事。',
    '賽30:11 你們要離棄正道，偏離直路，不要在我們面前再提說以色列的聖者。',
    '賽30:12 所以，以色列的聖者如此說：因為你們藐視這訓誨的話，倚賴欺壓和乖僻，以此為可靠的，',
    '賽30:13 故此，這罪孽在你們身上，好像將要破裂凸出來的高牆，頃刻之間忽然坍塌；',
    '賽30:14 要被打碎，好像把窰匠的瓦器打碎，毫不顧惜，甚至碎塊中找不到一片可用以從爐內取火，從池中舀水。',
    '賽30:15 主耶和華─以色列的聖者曾如此說：你們得救在乎歸回安息；你們得力在乎平靜安穩；你們竟自不肯。',
    '賽30:16 你們卻說：不然，我們要騎馬奔走。所以你們必然奔走；又說：我們要騎飛快的牲口。所以追趕你們的，也必飛快。',
    '賽30:17 一人叱喝，必令千人逃跑；五人叱喝，你們都必逃跑；以致剩下的，好像山頂的旗杆，岡上的大旗。',
    '賽30:18 耶和華必然等候，要施恩給你們；必然興起，好憐憫你們。因為耶和華是公平的神；凡等候他的都是有福的！',
    '賽30:19 百姓必在錫安、在耶路撒冷居住；你不要哭泣。主必因你哀求的聲音施恩給你；他聽見的時候就必應允你。',
    '賽30:20 主雖以艱難給你當餅，以困苦給你當水，你的教師卻不再隱藏；你眼必看見你的教師。',
    '賽30:21 你或向左或向右，你必聽見後邊有聲音說：這是正路，要行在其間。',
    '賽30:22 你雕刻偶像所包的銀子和鑄造偶像所鍍的金子，你要玷污，要拋棄，好像污穢之物，對偶像說：去吧！',
    '賽30:23 你將種子撒在地裡，主必降雨在其上，並使地所出的糧肥美豐盛。到那時，你的牲畜必在寬闊的草場吃草。',
    '賽30:24 耕地的牛和驢駒必吃加鹽的料；這料是用木杴和杈子揚淨的。',
    '賽30:25 在大行殺戮的日子，高臺倒塌的時候，各高山岡陵必有川流河湧。',
    '賽30:26 當耶和華纏裹他百姓的損處，醫治他民鞭傷的日子，月光必像日光，日光必加七倍，像七日的光一樣。',
    '賽30:27 看哪，耶和華的名從遠方來，怒氣燒起，密煙上騰。他的嘴唇滿有忿恨；他的舌頭像吞滅的火。',
    '賽30:28 他的氣如漲溢的河水，直漲到頸項，要用毀滅的篩籮篩淨列國，並且在眾民的口中必有使人錯行的嚼環。',
    '賽30:29 你們必唱歌，像守聖節的夜間一樣，並且心中喜樂，像人吹笛，上耶和華的山，到以色列的磐石那裡。',
    '賽30:30 耶和華必使人聽他威嚴的聲音，又顯他降罰的膀臂和他怒中的忿恨，並吞滅的火焰與霹雷、暴風、冰雹。',
    '賽30:31 亞述人必因耶和華的聲音驚惶；耶和華必用杖擊打他。',
    '賽30:32 耶和華必將命定的杖加在他身上；每打一下，人必擊鼓彈琴。打杖的時候，耶和華必掄起手來，與他交戰。',
    '賽30:33 原來陀斐特又深又寬，早已為王預備好了；其中堆的是火與許多木柴。耶和華的氣如一股硫磺火使他著起來。',
    '賽31:1 禍哉！那些下埃及求幫助的，是因仗賴馬匹，倚靠甚多的車輛，並倚靠強壯的馬兵，卻不仰望以色列的聖者，也不求問耶和華。',
    '賽31:2 其實，耶和華有智慧；他必降災禍，並不反悔自己的話，卻要興起攻擊那作惡之家，又攻擊那作孽幫助人的。',
    '賽31:3 埃及人不過是人，並不是神；他們的馬不過是血肉，並不是靈。耶和華一伸手，那幫助人的必絆跌，那受幫助的也必跌倒，都一同滅亡。',
    '賽31:4 耶和華對我如此說：獅子和少壯獅子護食咆哮，就是喊許多牧人來攻擊他，他總不因他們的聲音驚惶，也不因他們的喧嘩縮伏。如此，萬軍之耶和華也必降臨在錫安山岡上爭戰。',
    '賽31:5 雀鳥怎樣搧翅覆雛，萬軍之耶和華也要照樣保護耶路撒冷。他必保護拯救，要越門保守。',
    '賽31:6 以色列人哪，你們深深地悖逆耶和華，現今要歸向他。',
    '賽31:7 到那日，各人必將他金偶像銀偶像，就是親手所造、陷自己在罪中的，都拋棄了。',
    '賽31:8 亞述人必倒在刀下，並非人的刀；有刀要將他吞滅，並非人的刀。他必逃避這刀；他的少年人必成為服苦的。',
    '賽31:9 他的磐石必因驚嚇挪去；他的首領必因大旗驚惶。這是那有火在錫安、有爐在耶路撒冷的耶和華說的。',
    '賽32:1 看哪，必有一王憑公義行政；必有首領藉公平掌權。',
    '賽32:2 必有一人像避風所和避暴雨的隱密處，又像河流在乾旱之地，像大磐石的影子在疲乏之地。',
    '賽32:3 那能看的人，眼不再昏迷；能聽的人，耳必得聽聞。',
    '賽32:4 冒失人的心必明白知識；結吧人的舌必說話通快。',
    '賽32:5 愚頑人不再稱為高明，吝嗇人不再稱為大方。',
    '賽32:6 因為愚頑人必說愚頑話，心裡想作罪孽，慣行褻瀆的事，說錯謬的話攻擊耶和華，使飢餓的人無食可吃，使口渴的人無水可喝。',
    '賽32:7 吝嗇人所用的法子是惡的；他圖謀惡計，用謊言毀滅謙卑人；窮乏人講公理的時候，他也是這樣行。',
    '賽32:8 高明人卻謀高明事，在高明事上也必永存。',
    '賽32:9 安逸的婦女啊，起來聽我的聲音！無慮的女子啊，側耳聽我的言語！',
    '賽32:10 無慮的女子啊，再過一年多，必受騷擾；因為無葡萄可摘，無果子（或譯：禾稼）可收。',
    '賽32:11 安逸的婦女啊，要戰兢；無慮的女子啊，要受騷擾。脫去衣服，赤著身體，腰束麻布。',
    '賽32:12 他們必為美好的田地和多結果的葡萄樹，搥胸哀哭。',
    '賽32:13 荊棘蒺藜必長在我百姓的地上，又長在歡樂的城中和一切快樂的房屋上。',
    '賽32:14 因為宮殿必被撇下，多民的城必被離棄；山岡望樓永為洞穴，作野驢所喜樂的，為羊群的草場。',
    '賽32:15 等到聖靈從上澆灌我們，曠野就變為肥田，肥田看如樹林。',
    '賽32:16 那時，公平要居在曠野；公義要居在肥田。',
    '賽32:17 公義的果效必是平安；公義的效驗必是平穩，直到永遠。',
    '賽32:18 我的百姓必住在平安的居所，安穩的住處，平靜的安歇所。',
    '賽32:19 （但要降冰雹打倒樹林；城必全然拆平。）',
    '賽32:20 你們在各水邊撒種、牧放牛驢的有福了！',
    '賽33:1 禍哉！你這毀滅人的，自己倒不被毀滅；行事詭詐的，人倒不以詭詐待你。你毀滅罷休了，自己必被毀滅；你行完了詭詐，人必以詭詐待你。',
    '賽33:2 耶和華啊，求你施恩於我們；我們等候你。求你每早晨作我們的膀臂，遭難的時候為我們的拯救。',
    '賽33:3 喧嚷的響聲一發，眾民奔逃；你一興起，列國四散。',
    '賽33:4 你們所擄的必被斂盡，好像螞蚱吃（原文是斂）盡禾稼。人要蹦在其上，好像蝗蟲一樣。',
    '賽33:5 耶和華被尊崇，因他居在高處；他以公平公義充滿錫安。',
    '賽33:6 你一生一世必得安穩─有豐盛的救恩，並智慧和知識；你以敬畏耶和華為至寶。',
    '賽33:7 看哪，他們的豪傑在外頭哀號；求和的使臣痛痛哭泣。',
    '賽33:8 大路荒涼，行人止息；敵人背約，藐視城邑，不顧人民。',
    '賽33:9 地上悲哀衰殘；利巴嫩羞愧枯乾；沙崙像曠野；巴珊和迦密的樹林凋殘。',
    '賽33:10 耶和華說：現在我要起來；我要興起；我要勃然而興。',
    '賽33:11 你們要懷的是糠粃，要生的是碎稭；你們的氣就是吞滅自己的火。',
    '賽33:12 列邦必像已燒的石灰，像已割的荊棘在火中焚燒。',
    '賽33:13 你們遠方的人當聽我所行的；你們近處的人當承認我的大能。',
    '賽33:14 錫安中的罪人都懼怕；不敬虔的人被戰兢抓住。我們中間誰能與吞滅的火同住﹖我們中間誰能與永火同住呢﹖',
    '賽33:15 行事公義、說話正直、憎惡欺壓的財利、擺手不受賄賂、塞耳不聽流血的話，閉眼不看邪惡事的，',
    '賽33:16 他必居高處；他的保障是磐石的堅壘；他的糧必不缺乏（原文是賜給）；他的水必不斷絕。',
    '賽33:17 你的眼必見王的榮美，必見遼闊之地。',
    '賽33:18 你的心必思想那驚嚇的事，自問說：記數目的在哪裡呢﹖平貢銀的在哪裡呢﹖數戍樓的在哪裡呢﹖',
    '賽33:19 你必不見那強暴的民，就是說話深奧，你不能明白，言語呢喃，你不能懂得的。',
    '賽33:20 你要看錫安─我們守聖節的城！你的眼必見耶路撒冷為安靜的居所，為不挪移的帳幕，橛子永不拔出，繩索一根也不折斷。',
    '賽33:21 在那裡，耶和華必顯威嚴與我們同在，當作江河寬闊之地；其中必沒有盪槳搖櫓的船來往，也沒有威武的船經過。',
    '賽33:22 因為，耶和華是審判我們的；耶和華是給我們設律法的；耶和華是我們的王；他必拯救我們。',
    '賽33:23 你的繩索鬆開：不能栽穩桅杆，也不能揚起篷來。那時許多擄來的物被分了；瘸腿的把掠物奪去了。',
    '賽33:24 城內居民必不說：我病了；其中居住的百姓，罪孽都赦免了。',
    '賽34:1 列國啊，要近前來聽！眾民哪，要側耳而聽！地和其上所充滿的，世界和其中一切所出的都應當聽！',
    '賽34:2 因為耶和華向萬國發忿恨，向他們的全軍發烈怒，將他們滅盡，交出他們受殺戮。',
    '賽34:3 被殺的必然拋棄，屍首臭氣上騰；諸山被他們的血融化。',
    '賽34:4 天上的萬象都要消沒；天被捲起，好像書卷。其上的萬象要殘敗，像葡萄樹的葉子殘敗，又像無花果樹的葉子殘敗一樣。',
    '賽34:5 因為我的刀在天上已經喝足；這刀必臨到以東和我所咒詛的民，要施行審判。',
    '賽34:6 耶和華的刀滿了血，用脂油和羊羔、公山羊的血，並公綿羊腰子的脂油滋潤的；因為耶和華在波斯拉有獻祭的事，在以東地大行殺戮。',
    '賽34:7 野牛、牛犢，和公牛要一同下來。他們的地喝醉了血；他們的塵土因脂油肥潤。',
    '賽34:8 因耶和華有報仇之日，為錫安的爭辯有報應之年。',
    '賽34:9 以東的河水要變為石油，塵埃要變為硫磺；地土成為燒著的石油，',
    '賽34:10 晝夜總不熄滅，煙氣永遠上騰，必世世代代成為荒廢，永永遠遠無人經過。',
    '賽34:11 鵜鶘、箭豬卻要得為業；貓頭鷹、烏鴉要住在其間。耶和華必將空虛的準繩，混沌的線鉈，拉在其上。',
    '賽34:12 以東人要召貴冑來治國；那裡卻無一個，首領也都歸於無有。',
    '賽34:13 以東的宮殿要長荊棘；保障要長蒺藜和刺草；要作野狗的住處，鴕鳥的居所。',
    '賽34:14 曠野的走獸要和豺狼相遇；野山羊要與伴偶對叫。夜間的怪物必在那裡棲身，自找安歇之處。',
    '賽34:15 箭蛇要在那裡做窩，下蛋，菢蛋，生子，聚子在其影下；鷂鷹各與伴偶聚集在那裡。',
    '賽34:16 你們要查考宣讀耶和華的書。這都無一缺少，無一沒有伴偶；因為我的口已經吩咐，他的靈將他們聚集。',
    '賽34:17 他也為他們拈鬮，又親手用準繩給他們分地；他們必永得為業，世世代代住在其間。',
    '賽35:1 曠野和乾旱之地必然歡喜；沙漠也必快樂；又像玫瑰開花，',
    '賽35:2 必開花繁盛，樂上加樂，而且歡呼。利巴嫩的榮耀，並迦密與沙崙的華美，必賜給他。人必看見耶和華的榮耀，我們神的華美。',
    '賽35:3 你們要使軟弱的手堅壯，無力的膝穩固。',
    '賽35:4 對膽怯的人說：你們要剛強，不要懼怕。看哪，你們的神必來報仇，必來施行極大的報應；他必來拯救你們。',
    '賽35:5 那時，瞎子的眼必睜開；聾子的耳必開通。',
    '賽35:6 那時，瘸子必跳躍像鹿；啞巴的舌頭必能歌唱。在曠野必有水發出；在沙漠必有河湧流。',
    '賽35:7 發光的沙（或譯：蜃樓）要變為水池；乾渴之地要變為泉源。在野狗躺臥之處，必有青草、蘆葦，和蒲草。',
    '賽35:8 在那裡必有一條大道，稱為聖路。污穢人不得經過，必專為贖民行走；行路的人雖愚昧，也不致失迷。',
    '賽35:9 在那裡必沒有獅子，猛獸也不登這路；在那裡都遇不見，只有贖民在那裡行走。',
    '賽35:10 並且耶和華救贖的民必歸回，歌唱來到錫安；永樂必歸到他們的頭上；他們必得著歡喜快樂，憂愁歎息盡都逃避。',
    '賽36:1 希西家王十四年，亞述王西拿基立上來攻擊猶大的一切堅固城，將城攻取。',
    '賽36:2 亞述王從拉吉差遣拉伯沙基率領大軍往耶路撒冷，到希西家王那裡去。他就站在上池的水溝旁，在漂布地的大路上。',
    '賽36:3 於是希勒家的兒子家宰以利亞敬，並書記舍伯那和亞薩的兒子史官約亞，出來見拉伯沙基。',
    '賽36:4 拉伯沙基對他們說：你們去告訴希西家說，亞述大王如此說：你所倚靠的有什麼可仗賴的呢﹖',
    '賽36:5 你說，有打仗的計謀和能力，我看不過是虛話。你到底倚靠誰才背叛我呢﹖',
    '賽36:6 看哪，你所倚靠的埃及是那壓傷的葦杖，人若靠這杖，就必刺透他的手。埃及王法老向一切倚靠他的人也是這樣。',
    '賽36:7 你若對我說：我們倚靠耶和華─我們的神。希西家豈不是將神的邱壇和祭壇廢去，且對猶大和耶路撒冷的人說：你們當在這壇前敬拜嗎﹖',
    '賽36:8 現在你把當頭給我主亞述王，我給你二千匹馬，看你這一面騎馬的人夠不夠。',
    '賽36:9 若不然，怎能打敗我主臣僕中最小的軍長呢﹖你竟倚靠埃及的戰車馬兵嗎﹖',
    '賽36:10 現在我上來攻擊毀滅這地，豈沒有耶和華的意思嗎﹖耶和華吩咐我說，你上去攻擊毀滅這地吧！',
    '賽36:11 以利亞敬、舍伯那、約亞對拉伯沙基說：求你用亞蘭言語和僕人說話，因為我們懂得；不要用猶大言語和我們說話，達到城上百姓的耳中。',
    '賽36:12 拉伯沙基說：我主差遣我來，豈是單對你和你的主說這些話嗎﹖不也是對這些坐在城上、要與你們一同吃自己糞喝自己尿的人說嗎﹖',
    '賽36:13 於是，拉伯沙基站著，用猶大言語大聲喊著說：你們當聽亞述大王的話。',
    '賽36:14 王如此說：你們不要被希西家欺哄了，因他不能拯救你們。',
    '賽36:15 也不要聽希西家使你們倚靠耶和華說：耶和華必要拯救我們，這城必不交在亞述王的手中。',
    '賽36:16 不要聽希西家的話，因亞述王如此說：你們要與我和好。出來投降我，各人就可以吃自己葡萄樹和無花果樹的果子，喝自己井裡的水。',
    '賽36:17 等我來領你們到一個地方，與你們本地一樣，就是有五殼和新酒之地，有糧食和葡萄園之地。',
    '賽36:18 你們要謹防，恐怕希西家勸導你們說：耶和華必拯救我們。列國的神有哪一個救他本國脫離亞述王的手呢﹖',
    '賽36:19 哈馬和亞珥拔的神在哪裡呢﹖西法瓦音的神在哪裡呢﹖他們曾救撒瑪利亞脫離我的手嗎﹖',
    '賽36:20 這些國的神有誰曾救自己的國脫離我的手呢﹖難道耶和華能救耶路撒冷脫離我的手嗎﹖',
    '賽36:21 百姓靜默不言，並不回答一句，因為王曾吩咐說：不要回答他。',
    '賽36:22 當下希勒家的兒子家宰以利亞敬和書記舍伯那，並亞薩的兒子史官約亞，都撕裂衣服，來到希西家那裡，將拉伯沙基的話告訴了他。',
    '賽37:1 希西家王聽見就撕裂衣服，披上麻布，進了耶和華的殿，',
    '賽37:2 使家宰以利亞敬和書記舍伯那，並祭司中的長老，都披上麻布，去見亞摩斯的兒子先知以賽亞，',
    '賽37:3 對他說：希西家如此說：今日是急難、責罰、凌辱的日子，就如婦人將要生產嬰孩，卻沒有力量生產。',
    '賽37:4 或者耶和華─你的神聽見拉伯沙基的話，就是他主人亞述王打發他來辱罵永生神的話；耶和華─你的神聽見這話就發斥責。故此，求你為餘剩的民揚聲禱告。',
    '賽37:5 希西家王的臣僕就去見以賽亞。',
    '賽37:6 以賽亞對他們說：要這樣對你們的主人說，耶和華如此說：你聽見亞述王的僕人褻瀆我的話，不要懼怕。',
    '賽37:7 我必驚動（原文是使靈進入）他的心；他要聽見風聲就歸回本地，我必使他在那裡倒在刀下。',
    '賽37:8 拉伯沙基回去，正遇見亞述王攻打立拿；原來他早聽見亞述王拔營離開拉吉。',
    '賽37:9 亞述王聽見人論古實王特哈加說：他出來要與你爭戰。亞述王一聽見，就打發使者去見希西家，吩咐他們說：',
    '賽37:10 你們對猶大王希西家如此說：不要聽你所倚靠的神欺哄你說：耶路撒冷必不交在亞述王的手中。',
    '賽37:11 你總聽說亞述諸王向列國所行的乃是盡行滅絕，難道你還能得救嗎﹖',
    '賽37:12 我列祖所毀滅的，就是歌散、哈蘭、利色，和屬提拉撒的伊甸人；這些國的神何曾拯救這些國呢﹖',
    '賽37:13 哈馬的王，亞珥拔的王，西法瓦音城的王，希拿和以瓦的王，都在哪裡呢﹖',
    '賽37:14 希西家從使者手裡接過書信來，看完了，就上耶和華的殿，將書信在耶和華面前展開。',
    '賽37:15 希西家向耶和華禱告說：',
    '賽37:16 坐在二基路伯上萬軍之耶和華─以色列的神啊，你─惟有你是天下萬國的神，你曾創造天地。',
    '賽37:17 耶和華啊，求你側耳而聽；耶和華啊，求你睜眼而看，要聽西拿基立的一切話，他是打發使者來辱罵永生神的。',
    '賽37:18 耶和華啊，亞述諸王果然使列國和列國之地變為荒涼，',
    '賽37:19 將列國的神像都扔在火裡；因為他本不是神，乃是人手所造的，是木頭、石頭的，所以滅絕他。',
    '賽37:20 耶和華─我們的神啊，現在求你救我們脫離亞述王的手，使天下萬國都知道唯有你是耶和華。',
    '賽37:21 亞摩斯的兒子以賽亞就打發人去見希西家，說：耶和華─以色列的神如此說，你既然求我攻擊亞述王西拿基立，',
    '賽37:22 所以耶和華論他這樣說：錫安的處女藐視你，嗤笑你；耶路撒冷的女子向你搖頭。',
    '賽37:23 你辱罵誰，褻瀆誰﹖揚起聲來，高舉眼目攻擊誰呢﹖乃是攻擊以色列的聖者。',
    '賽37:24 你藉你的臣僕辱罵主說：我率領許多戰車上山頂，到利巴嫩極深之處；我要砍伐其中高大的香柏樹和佳美的松樹。我必上極高之處，進入肥田的樹林。',
    '賽37:25 我已經挖井喝水；我必用腳掌踏乾埃及的一切河。',
    '賽37:26 耶和華說：你豈沒有聽見我早先所做的、古時所立的嗎﹖現在藉你使堅固城荒廢，變為亂堆。',
    '賽37:27 所以其中的居民力量甚小，驚惶羞愧。他們像野草，像青菜，如房頂上的草，又如田間未長成的禾稼。',
    '賽37:28 你坐下，你出去，你進來，你向我發烈怒，我都知道。',
    '賽37:29 因你向我發烈怒，又因你狂傲的話達到我耳中，我就要用鉤子鉤上你的鼻子，把嚼環放在你口裡，使你從原路轉回去。',
    '賽37:30 以色列人哪，我賜你們一個證據：你們今年要吃自生的，明年也要吃自長的，至於後年，你們要耕種收割，栽植葡萄園，吃其中的果子。',
    '賽37:31 猶大家所逃脫餘剩的，仍要往下扎根，向上結果。',
    '賽37:32 必有餘剩的民從耶路撒冷而出；必有逃脫的人從錫安山而來。萬軍之耶和華的熱心必成就這事。',
    '賽37:33 所以耶和華論亞述王如此說：他必不得來到這城，也不在這裡射箭，不得拿盾牌到城前，也不築壘攻城。',
    '賽37:34 他從哪條路來，必從那條路回去，必不得來到這城。這是耶和華說的。',
    '賽37:35 因我為自己的緣故，又為我僕人大衛的緣故，必保護拯救這城。',
    '賽37:36 耶和華的使者出去，在亞述營中殺了十八萬五千人。清早有人起來一看，都是死屍了。',
    '賽37:37 亞述王西拿基立就拔營回去，住在尼尼微。',
    '賽37:38 一日在他的神─尼斯洛廟裡叩拜，他兒子亞得米勒和沙利色用刀殺了他，就逃到亞拉臘地。他兒子以撒哈頓接續他作王。',
    '賽38:1 那時希西家病得要死，亞摩斯的兒子先知以賽亞去見他，對他說：耶和華如此說：你當留遺命與你的家，因為你必死不能活了。',
    '賽38:2 希西家就轉臉朝牆，禱告耶和華說：',
    '賽38:3 耶和華啊，求你記念我在你面前怎樣存完全的心，按誠實行事，又做你眼中所看為善的。希西家就痛哭了。',
    '賽38:4 耶和華的話臨到以賽亞說：',
    '賽38:5 你去告訴希西家說，耶和華─你祖大衛的神如此說：我聽見了你的禱告，看見了你的眼淚。我必加增你十五年的壽數；',
    '賽38:6 並且我要救你和這城脫離亞述王的手，也要保護這城。',
    '賽38:7 我─耶和華必成就我所說的。我先給你一個兆頭，',
    '賽38:8 就是叫亞哈斯的日晷，向前進的日影往後退十度。於是，前進的日影果然在日晷上往後退了十度。',
    '賽38:9 猶大王希西家患病已經痊癒，就作詩說：',
    '賽38:10 我說：正在我中年（或譯：晌午）之日必進入陰間的門；我餘剩的年歲不得享受。',
    '賽38:11 我說：我必不得見耶和華，就是在活人之地不見耶和華；我與世上的居民不再見面。',
    '賽38:12 我的住處被遷去離開我，好像牧人的帳棚一樣；我將性命捲起，像織布的捲布一樣。耶和華必將我從機頭剪斷，從早到晚，他要使我完結。',
    '賽38:13 我使自己安靜直到天亮；他像獅子折斷我一切的骨頭，從早到晚，他要使我完結。',
    '賽38:14 我像燕子呢喃，像白鶴鳴叫，又像鴿子哀鳴；我因仰觀，眼睛困倦。耶和華啊，我受欺壓，求你為我作保。',
    '賽38:15 我可說什麼呢﹖他應許我的，也給我成就了。我因心裡的苦楚，在一生的年日必悄悄而行。',
    '賽38:16 主啊，人得存活乃在乎此。我靈存活也全在此。所以求你使我痊癒，仍然存活。',
    '賽38:17 看哪，我受大苦，本為使我得平安；你因愛我的靈魂（或譯：生命）便救我脫離敗壞的坑，因為你將我一切的罪扔在你的背後。',
    '賽38:18 原來，陰間不能稱謝你，死亡不能頌揚你；下坑的人不能盼望你的誠實。',
    '賽38:19 只有活人，活人必稱謝你，像我今日稱謝你一樣。為父的，必使兒女知道你的誠實。',
    '賽38:20 耶和華肯救我，所以，我們要一生一世在耶和華殿中用絲弦的樂器唱我的詩歌。',
    '賽38:21 以賽亞說：當取一塊無花果餅來，貼在瘡上，王必痊癒。',
    '賽38:22 希西家問說：我能上耶和華的殿，有什麼兆頭呢﹖',
    '賽39:1 那時，巴比倫王巴拉但的兒子米羅達巴拉但聽見希西家病而痊癒，就送書信和禮物給他。',
    '賽39:2 希西家喜歡見使者，就把自己寶庫的金子、銀子、香料、貴重的膏油，和他武庫的一切軍器，並所有的財寶都給他們看；他家中和全國之內，希西家沒有一樣不給他們看的。',
    '賽39:3 於是先知以賽亞來見希西家王，問他說：這些人說什麼﹖他們從哪裡來見你﹖希西家說：他們從遠方的巴比倫來見我。',
    '賽39:4 以賽亞說：他們在你家裡看見了什麼﹖希西家說：凡我家中所有的，他們都看見了；我財寶中沒有一樣不給他們看的。',
    '賽39:5 以賽亞對希西家說：你要聽萬軍之耶和華的話：',
    '賽39:6 日子必到，凡你家裡所有的，並你列祖積蓄到如今的，都要被擄到巴比倫去，不留下一樣；這是耶和華說的。',
    '賽39:7 並且從你本身所生的眾子，其中必有被擄去、在巴比倫王宮裡當太監的。',
    '賽39:8 希西家對以賽亞說：你所說耶和華的話甚好，因為在我的年日中必有太平和穩固的景況。',
    '賽40:1 你們的神說：你們要安慰，安慰我的百姓。',
    '賽40:2 要對耶路撒冷說安慰的話，又向他宣告說，他爭戰的日子已滿了；他的罪孽赦免了；他為自己的一切罪，從耶和華手中加倍受罰。',
    '賽40:3 有人聲喊著說：在曠野預備耶和華的路（或譯：在曠野，有人聲喊著說：當預備耶和華的路），在沙漠地修平我們神的道。',
    '賽40:4 一切山窪都要填滿，大小山岡都要削平；高高低低的要改為平坦，崎崎嶇嶇的必成為平原。',
    '賽40:5 耶和華的榮耀必然顯現；凡有血氣的必一同看見；因為這是耶和華親口說的。',
    '賽40:6 有人聲說：你喊叫吧！有一個說：我喊叫什麼呢﹖說：凡有血氣的盡都如草；他的美容都像野地的花。',
    '賽40:7 草必枯乾，花必凋殘，因為耶和華的氣吹在其上；百姓誠然是草。',
    '賽40:8 草必枯乾，花必凋殘，惟有我們神的話必永遠立定。',
    '賽40:9 報好信息給錫安的啊，你要登高山；報好信息給耶路撒冷的啊，你要極力揚聲。揚聲不要懼怕，對猶大的城邑說：看哪，你們的神！',
    '賽40:10 主耶和華必像大能者臨到；他的膀臂必為他掌權。他的賞賜在他那裡；他的報應在他面前。',
    '賽40:11 他必像牧人牧養自己的羊群，用膀臂聚集羊羔抱在懷中，慢慢引導那乳養小羊的。',
    '賽40:12 誰曾用手心量諸水，用手虎口量蒼天，用升斗盛大地的塵土，用秤稱山嶺，用天平平岡陵呢﹖',
    '賽40:13 誰曾測度耶和華的心（或譯：誰曾指示耶和華的靈），或作他的謀士指教他呢﹖',
    '賽40:14 他與誰商議，誰教導他，誰將公平的路指示他，又將知識教訓他，將通達的道指教他呢﹖',
    '賽40:15 看哪，萬民都像水桶的一滴，又算如天平上的微塵；他舉起眾海島，好像極微之物。',
    '賽40:16 利巴嫩的樹林不夠當柴燒；其中的走獸也不夠作燔祭。',
    '賽40:17 萬民在他面前好像虛無，被他看為不及虛無，乃為虛空。',
    '賽40:18 你們究竟將誰比神，用什麼形像與神比較呢﹖',
    '賽40:19 偶像是匠人鑄造，銀匠用金包裹，為他鑄造銀鍊。',
    '賽40:20 窮乏獻不起這樣供物的，就揀選不能朽壞的樹木，為自己尋找巧匠，立起不能搖動的偶像。',
    '賽40:21 你們豈不曾知道嗎﹖你們豈不曾聽見嗎﹖從起初豈沒有人告訴你們嗎﹖自從立地的根基，你們豈沒有明白嗎﹖',
    '賽40:22 神坐在地球大圈之上；地上的居民好像蝗蟲。他鋪張穹蒼如幔子，展開諸天如可住的帳棚。',
    '賽40:23 他使君王歸於虛無，使地上的審判官成為虛空。',
    '賽40:24 他們是剛才（或譯：不曾；下同）栽上，剛才種上，根也剛才扎在地裡，他一吹在其上，便都枯乾；旋風將他們吹去，像碎稭一樣。',
    '賽40:25 那聖者說：你們將誰比我，叫他與我相等呢﹖',
    '賽40:26 你們向上舉目，看誰創造這萬象，按數目領出，他一一稱其名；因他的權能，又因他的大能大力，連一個都不缺。',
    '賽40:27 雅各啊，你為何說，我的道路向耶和華隱藏﹖以色列啊，你為何言，我的冤屈神並不查問﹖',
    '賽40:28 你豈不曾知道嗎﹖你豈不曾聽見嗎﹖永在的神耶和華，創造地極的主，並不疲乏，也不困倦；他的智慧無法測度。',
    '賽40:29 疲乏的，他賜能力；軟弱的，他加力量。',
    '賽40:30 就是少年人也要疲乏困倦；強壯的也必全然跌倒。',
    '賽40:31 但那等候耶和華的必從新得力。他們必如鷹展翅上騰；他們奔跑卻不困倦，行走卻不疲乏。',
    '賽41:1 眾海島啊，當在我面前靜默；眾民當從新得力，都要近前來才可以說話，我們可以彼此辯論。',
    '賽41:2 誰從東方興起一人，憑公義召他來到腳前呢﹖耶和華將列國交給他，使他管轄君王，把他們如灰塵交與他的刀，如風吹的碎稭交與他的弓。',
    '賽41:3 他追趕他們，走他所未走的道，坦然前行。',
    '賽41:4 誰行做成就這事，從起初宣召歷代呢﹖就是我─耶和華！我是首先的，也與末後的同在。',
    '賽41:5 海島看見就都害怕；地極也都戰兢，就近前來。',
    '賽41:6 他們各人幫助鄰舍，各人對弟兄說：壯膽吧！',
    '賽41:7 木匠勉勵銀匠，用鎚打光的勉勵打砧的，論銲工說，銲得好；又用釘子釘穩，免得偶像動搖。',
    '賽41:8 惟你以色列─我的僕人，雅各─我所揀選的，我朋友亞伯拉罕的後裔，',
    '賽41:9 你是我從地極所領（原文是抓）來的，從地角所召來的，且對你說：你是我的僕人；我揀選你，並不棄絕你。',
    '賽41:10 你不要害怕，因為我與你同在；不要驚惶，因為我是你的神。我必堅固你，我必幫助你；我必用我公義的右手扶持你。',
    '賽41:11 凡向你發怒的必都抱愧蒙羞；與你相爭的必如無有，並要滅亡。',
    '賽41:12 與你爭競的，你要找他們也找不著；與你爭戰的必如無有，成為虛無。',
    '賽41:13 因為我耶和華─你的神必攙扶你的右手，對你說：不要害怕！我必幫助你。',
    '賽41:14 你這蟲雅各和你們以色列人，不要害怕！耶和華說：我必幫助你。你的救贖主就是以色列的聖者。',
    '賽41:15 看哪，我已使你成為有快齒打糧的新器具；你要把山嶺打得粉碎，使岡陵如同糠粃。',
    '賽41:16 你要把他簸揚，風要吹去；旋風要把他颳散。你倒要以耶和華為喜樂，以以色列的聖者為誇耀。',
    '賽41:17 困苦窮乏人尋求水卻沒有；他們因口渴，舌頭乾燥。我─耶和華必應允他們；我─以色列的神必不離棄他們。',
    '賽41:18 我要在淨光的高處開江河，在谷中開泉源；我要使沙漠變為水池，使乾地變為湧泉。',
    '賽41:19 我要在曠野種上香柏樹、皂莢樹、番石榴樹，和野橄欖樹。我在沙漠要把松樹、杉樹，並黃楊樹一同栽植；',
    '賽41:20 好叫人看見、知道、思想、明白；這是耶和華的手所做的，是以色列的聖者所造的。',
    '賽41:21 耶和華對假神說：你們要呈上你們的案件；雅各的君說：你們要聲明你們確實的理由。',
    '賽41:22 可以聲明，指示我們將來必遇的事，說明先前的是什麼事，好叫我們思索，得知事的結局，或者把將來的事指示我們。',
    '賽41:23 要說明後來的事，好叫我們知道你們是神。你們或降福，或降禍，使我們驚奇，一同觀看。',
    '賽41:24 看哪，你們屬乎虛無；你們的作為也屬乎虛空。那選擇你們的是可憎惡的。',
    '賽41:25 我從北方興起一人；他是求告我名的，從日出之地而來。他必臨到掌權的，好像臨到灰泥，彷彿窰匠踹泥一樣。',
    '賽41:26 誰從起初指明這事，使我們知道呢﹖誰從先前說明，使我們說他不錯呢﹖誰也沒有指明，誰也沒有說明。誰也沒有聽見你們的話。',
    '賽41:27 我首先對錫安說：看哪，我要將一位報好信息的賜給耶路撒冷。',
    '賽41:28 我看的時候並沒有人；我問的時候，他們中間也沒有謀士可以回答一句。',
    '賽41:29 看哪，他們和他們的工作都是虛空，且是虛無。他們所鑄的偶像都是風，都是虛的。',
    '賽42:1 看哪，我的僕人─我所扶持所揀選、心裡所喜悅的！我已將我的靈賜給他；他必將公理傳給外邦。',
    '賽42:2 他不喧嚷，不揚聲，也不使街上聽見他的聲音。',
    '賽42:3 壓傷的蘆葦，他不折斷；將殘的燈火，他不吹滅。他憑真實將公理傳開。',
    '賽42:4 他不灰心，也不喪膽，直到他在地上設立公理；海島都等候他的訓誨。',
    '賽42:5 創造諸天，鋪張穹蒼，將地和地所出的一併鋪開，賜氣息給地上的眾人，又賜靈性給行在其上之人的神耶和華，他如此說：',
    '賽42:6 我─耶和華憑公義召你，必攙扶你的手，保守你，使你作眾民的中保（中保：原文是約），作外邦人的光，',
    '賽42:7 開瞎子的眼，領被囚的出牢獄，領坐黑暗的出監牢。',
    '賽42:8 我是耶和華，這是我的名；我必不將我的榮耀歸給假神，也不將我的稱讚歸給雕刻的偶像。',
    '賽42:9 看哪，先前的事已經成就，現在我將新事說明，這事未發以先，我就說給你們聽。',
    '賽42:10 航海的和海中所有的，海島和其上的居民，都當向耶和華唱新歌，從地極讚美他。',
    '賽42:11 曠野和其中的城邑，並基達人居住的村莊都當揚聲；西拉的居民當歡呼，在山頂上吶喊。',
    '賽42:12 他們當將榮耀歸給耶和華，在海島中傳揚他的頌讚。',
    '賽42:13 耶和華必像勇士出去，必像戰士激動熱心，要喊叫，大聲吶喊，要用大力攻擊仇敵。',
    '賽42:14 我許久閉口不言，靜默不語；現在我要喊叫，像產難的婦人；我要急氣而喘哮。',
    '賽42:15 我要使大山小岡變為荒場，使其上的花草都枯乾；我要使江河變為洲島，使水池都乾涸。',
    '賽42:16 我要引瞎子行不認識的道，領他們走不知道的路；在他們面前使黑暗變為光明，使彎曲變為平直。這些事我都要行，並不離棄他們。',
    '賽42:17 倚靠雕刻的偶像，對鑄造的偶像說：你是我們的神；這等人要退後，全然蒙羞。',
    '賽42:18 你們這耳聾的，聽吧！你們這眼瞎的，看吧！使你們能看見。',
    '賽42:19 誰比我的僕人眼瞎呢﹖誰比我差遣的使者耳聾呢﹖誰瞎眼像那與我和好的﹖誰瞎眼像耶和華的僕人呢﹖',
    '賽42:20 你看見許多事卻不領會，耳朵開通卻不聽見。',
    '賽42:21 耶和華因自己公義的緣故，喜歡使律法（或譯：訓誨）為大，為尊。',
    '賽42:22 但這百姓是被搶被奪的，都牢籠在坑中，隱藏在獄裡；他們作掠物，無人拯救，作擄物，無人說交還。',
    '賽42:23 你們中間誰肯側耳聽此，誰肯留心而聽，以防將來呢﹖',
    '賽42:24 誰將雅各交出當作擄物，將以色列交給搶奪的呢﹖豈不是耶和華嗎﹖就是我們所得罪的那位。他們不肯遵行他的道，也不聽從他的訓誨。',
    '賽42:25 所以，他將猛烈的怒氣和爭戰的勇力傾倒在以色列的身上。在他四圍如火著起，他還不知道，燒著他，他也不介意。',
    '賽43:1 雅各啊，創造你的耶和華，以色列啊，造成你的那位，現在如此說：你不要害怕！因為我救贖了你。我曾提你的名召你，你是屬我的。',
    '賽43:2 你從水中經過，我必與你同在；你逿過江河，水必不漫過你；你從火中行過，必不被燒，火焰也不著在你身上。',
    '賽43:3 因為我是耶和華─你的神，是以色列的聖者─你的救主；我已經使埃及作你的贖價，使古實和西巴代替你。',
    '賽43:4 因我看你為寶為尊；又因我愛你，所以我使人代替你，使列邦人替換你的生命。',
    '賽43:5 不要害怕，因我與你同在；我必領你的後裔從東方來，又從西方招聚你。',
    '賽43:6 我要對北方說，交出來！對南方說，不要拘留！將我的眾子從遠方帶來，將我的眾女從地極領回，',
    '賽43:7 就是凡稱為我名下的人，是我為自己的榮耀創造的，是我所做成，所造作的。',
    '賽43:8 你要將有眼而瞎、有耳而聾的民都帶出來！',
    '賽43:9 任憑萬國聚集；任憑眾民會合。其中誰能將此聲明，並將先前的事說給我們聽呢﹖他們可以帶出見證來，自顯為是；或者他們聽見便說：這是真的。',
    '賽43:10 耶和華說：你們是我的見證，我所揀選的僕人。既是這樣，便可以知道，且信服我，又明白我就是耶和華。在我以前沒有真神（真：原文是造作的）；在我以後也必沒有。',
    '賽43:11 惟有我是耶和華；除我以外沒有救主。',
    '賽43:12 我曾指示，我曾拯救，我曾說明，並且在你們中間沒有別神。所以耶和華說：你們是我的見證。我也是神；',
    '賽43:13 自從有日子以來，我就是神；誰也不能救人脫離我手。我要行事誰能阻止呢﹖',
    '賽43:14 耶和華─你們的救贖主、以色列的聖者如此說：因你們的緣故，我已經打發人到巴比倫去；並且我要使迦勒底人如逃民，都坐自己喜樂的船下來。',
    '賽43:15 我是耶和華─你們的聖者，是創造以色列的，是你們的君王。',
    '賽43:16 耶和華在滄海中開道，在大水中開路，',
    '賽43:17 使車輛、馬匹、軍兵、勇士都出來，一同躺下，不再起來；他們滅沒，好像熄滅的燈火。',
    '賽43:18 耶和華如此說：你們不要記念從前的事，也不要思想古時的事。',
    '賽43:19 看哪，我要做一件新事；如今要發現，你們豈不知道嗎﹖我必在曠野開道路，在沙漠開江河。',
    '賽43:20 野地的走獸必尊重我；野狗和鴕鳥也必如此。因我使曠野有水，使沙漠有河，好賜給我的百姓、我的選民喝。',
    '賽43:21 這百姓是我為自己所造的，好述說我的美德。',
    '賽43:22 雅各啊，你並沒有求告我；以色列啊，你倒厭煩我。',
    '賽43:23 你沒有將你的羊帶來給我作燔祭，也沒有用祭物尊敬我；我沒有因供物使你服勞，也沒有因乳香使你厭煩。',
    '賽43:24 你沒有用銀子為我買菖蒲，也沒有用祭物的脂油使我飽足；倒使我因你的罪惡服勞，使我因你的罪孽厭煩。',
    '賽43:25 惟有我為自己的緣故塗抹你的過犯；我也不記念你的罪惡。',
    '賽43:26 你要提醒我，你我可以一同辯論；你可以將你的理陳明，自顯為義。',
    '賽43:27 你的始祖犯罪；你的師傅違背我。',
    '賽43:28 所以，我要辱沒聖所的首領，使雅各成為咒詛，使以色列成為辱罵。',
    '賽44:1 我的僕人雅各，我所揀選的以色列啊，現在你當聽。',
    '賽44:2 造作你，又從你出胎造就你，並要幫助你的耶和華如此說：我的僕人雅各，我所揀選的耶書崙哪，不要害怕！',
    '賽44:3 因為我要將水澆灌口渴的人，將河澆灌乾旱之地。我要將我的靈澆灌你的後裔，將我的福澆灌你的子孫。',
    '賽44:4 他們要發生在草中，像溪水旁的柳樹。',
    '賽44:5 這個要說：我是屬耶和華的；那個要以雅各的名自稱；又一個要親手寫：歸耶和華的（或譯：在手上寫歸耶和華），並自稱為以色列。',
    '賽44:6 耶和華─以色列的君，以色列的救贖主─萬軍之耶和華如此說：我是首先的，我是末後的；除我以外再沒有真神。',
    '賽44:7 自從我設立古時的民，誰能像我宣告，並且指明，又為自己陳說呢﹖讓他將未來的事和必成的事說明。',
    '賽44:8 你們不要恐懼，也不要害怕。我豈不是從上古就說明指示你們嗎﹖並且你們是我的見證！除我以外，豈有真神嗎﹖誠然沒有磐石，我不知道一個！',
    '賽44:9 製造雕刻偶像的盡都虛空；他們所喜悅的都無益處；他們的見證無所看見，無所知曉，他們便覺羞愧。',
    '賽44:10 誰製造神像，鑄造無益的偶像﹖',
    '賽44:11 看哪，他的同伴都必羞愧。工匠也不過是人，任他們聚會，任他們站立，都必懼怕，一同羞愧。',
    '賽44:12 鐵匠把鐵在火炭中燒熱，用鎚打鐵器，用他有力的膀臂錘成；他飢餓而無力，不喝水而發倦。',
    '賽44:13 木匠拉線，用筆劃出樣子，用鉋子鉋成形狀，用圓尺劃了模樣，仿照人的體態，做成人形，好住在房屋中。',
    '賽44:14 他砍伐香柏樹，又取柞（或譯：青桐）樹和橡樹，在樹林中選定了一棵。他栽種松樹，得雨長養。',
    '賽44:15 這樹，人可用以燒火；他自己取些烤火，又燒著烤餅，而且做神像跪拜，做雕刻的偶像向他叩拜。',
    '賽44:16 他把一分燒在火中，把一分烤肉吃飽。自己烤火說：啊哈，我暖和了，我見火了。',
    '賽44:17 他用剩下的做了一神，就是雕刻的偶像。他向這偶像俯伏叩拜，禱告他說：求你拯救我，因你是我的神。',
    '賽44:18 他們不知道，也不思想；因為耶和華閉住他們的眼，不能看見，塞住他們的心，不能明白。',
    '賽44:19 誰心裡也不醒悟，也沒有知識，沒有聰明，能說：我曾拿一分在火中燒了，在炭火上烤過餅；我也烤過肉吃。這剩下的，我豈要作可憎的物嗎﹖我豈可向木丕子叩拜呢﹖',
    '賽44:20 他以灰為食，心中昏迷，使他偏邪，他不能自救，也不能說：我右手中豈不是有虛謊嗎﹖',
    '賽44:21 雅各，以色列啊，你是我的僕人，要記念這些事。以色列啊，你是我的僕人，我造就你必不忘記你。',
    '賽44:22 我塗抹了你的過犯，像厚雲消散；我塗抹了你的罪惡，如薄雲滅沒。你當歸向我，因我救贖了你。',
    '賽44:23 諸天哪，應當歌唱，因為耶和華做成這事。地的深處啊，應當歡呼；眾山應當發聲歌唱；樹林和其中所有的樹都當如此！因為耶和華救贖了雅各，並要因以色列榮耀自己。',
    '賽44:24 從你出胎，造就你的救贖主─耶和華如此說：我─耶和華是創造萬物的，是獨自鋪張諸天、鋪開大地的。誰與我同在呢﹖',
    '賽44:25 使說假話的兆頭失效，使占卜的癲狂，使智慧人退後，使他的知識變為愚拙；',
    '賽44:26 使我僕人的話語立定，我使者的謀算成就。論到耶路撒冷說：必有人居住；論到猶大的城邑說：必被建造，其中的荒場我也必興起。',
    '賽44:27 對深淵說：你乾了吧！我也要使你的江河乾涸。',
    '賽44:28 論古列說：他是我的牧人，必成就我所喜悅的，必下令建造耶路撒冷，發命立穩聖殿的根基。',
    '賽45:1 我─耶和華所膏的古列；我攙扶他的右手，使列國降伏在他面前。我也要放鬆列王的腰帶，使城門在他面前敞開，不得關閉。我對他如此說：',
    '賽45:2 我必在你前面行，修平崎嶇之地。我必打破銅門，砍斷鐵閂。',
    '賽45:3 我要將暗中的寶物和隱密的財寶賜給你，使你知道提名召你的，就是我─耶和華、以色列的神。',
    '賽45:4 因我僕人雅各，我所揀選以色列的緣故，我就提名召你；你雖不認識我，我也加給你名號。',
    '賽45:5 我是耶和華，在我以外並沒有別神；除了我以外再沒有神。你雖不認識我，我必給你束腰。',
    '賽45:6 從日出之地到日落之處使人都知道除了我以外，沒有別神。我是耶和華；在我以外並沒有別神。',
    '賽45:7 我造光，又造暗；我施平安，又降災禍；造作這一切的是我─耶和華。',
    '賽45:8 諸天哪，自上而滴，穹蒼降下公義；地面開裂，產出救恩，使公義一同發生；這都是我─耶和華所造的。',
    '賽45:9 禍哉，那與造他的主爭論的！他不過是地上瓦片中的一塊瓦片。泥土豈可對摶弄他的說：你做什麼呢﹖所做的物豈可說：你沒有手呢﹖',
    '賽45:10 禍哉，那對父親說：你生的是什麼呢﹖或對母親（原文是婦人）說：你產的是什麼呢﹖',
    '賽45:11 耶和華─以色列的聖者，就是造就以色列的如此說：將來的事，你們可以問我；至於我的眾子，並我手的工作，你們可以求我命定（原文是吩咐我）。',
    '賽45:12 我造地，又造人在地上。我親手鋪張諸天；天上萬象也是我所命定的。',
    '賽45:13 我憑公義興起古列（原文是他），又要修直他一切道路。他必建造我的城，釋放我被擄的民；不是為工價，也不是為賞賜。這是萬軍之耶和華說的。',
    '賽45:14 耶和華如此說：埃及勞碌得來的和古實的貨物必歸你；身量高大的西巴人必投降你，也要屬你。他們必帶著鎖鍊過來隨從你，又向你下拜，祈求你說：神真在你們中間，此外再沒有別神；再沒有別的神。',
    '賽45:15 救主─以色列的神啊，你實在是自隱的神。',
    '賽45:16 凡製造偶像的都必抱愧蒙羞，都要一同歸於慚愧。',
    '賽45:17 惟有以色列必蒙耶和華的拯救，得永遠的救恩。你們必不蒙羞，也不抱愧，直到永世無盡。',
    '賽45:18 創造諸天的耶和華，製造成全大地的神，他創造堅定大地，並非使地荒涼，是要給人居住。他如此說：我是耶和華，再沒有別神。',
    '賽45:19 我沒有在隱密黑暗之地說話；我沒有對雅各的後裔說：你們尋求我是徒然的。我─耶和華所講的是公義，所說的是正直。',
    '賽45:20 你們從列國逃脫的人，要一同聚集前來。那些擡著雕刻木偶、禱告不能救人之神的，毫無知識。',
    '賽45:21 你們要述說陳明你們的理，讓他們彼此商議。誰從古時指明？誰從上古述說﹖不是我─耶和華嗎﹖除了我以外，再沒有神；我是公義的神，又是救主；除了我以外，再沒有別神。',
    '賽45:22 地極的人都當仰望我，就必得救；因為我是神，再沒有別神。',
    '賽45:23 我指著自己起誓，我口所出的話是憑公義，並不反回：萬膝必向我跪拜；萬口必憑我起誓。',
    '賽45:24 人論我說，公義、能力，惟獨在乎耶和華；人都必歸向他。凡向他發怒的必至蒙羞。',
    '賽45:25 以色列的後裔都必因耶和華得稱為義，並要誇耀。',
    '賽46:1 彼勒屈身，尼波彎腰；巴比倫的偶像馱在獸和牲畜上。他們所擡的如今成了重馱，使牲畜疲乏，',
    '賽46:2 都一同彎腰屈身，不能保全重馱，自己倒被擄去。',
    '賽46:3 雅各家，以色列家一切餘剩的要聽我言：你們自從生下，就蒙我保抱，自從出胎，便蒙我懷搋。',
    '賽46:4 直到你們年老，我仍這樣；直到你們髮白，我仍懷搋。我已造作，也必保抱；我必懷抱，也必拯救。',
    '賽46:5 你們將誰與我相比，與我同等，可以與我比較，使我們相同呢﹖',
    '賽46:6 那從囊中抓金子，用天平平銀子的人，雇銀匠製造神像，他們又俯伏，又叩拜。',
    '賽46:7 他們將神像擡起，扛在肩上，安置在定處，他就站立，不離本位；人呼求他，他不能答應，也不能救人脫離患難。',
    '賽46:8 你們當想念這事，自己作大丈夫。悖逆的人哪，要心裡思想。',
    '賽46:9 你們要追念上古的事。因為我是神，並無別神；我是神，再沒有能比我的。',
    '賽46:10 我從起初指明末後的事，從古時言明未成的事，說：我的籌算必立定；凡我所喜悅的，我必成就。',
    '賽46:11 我召鷙鳥從東方來，召那成就我籌算的人從遠方來。我已說出，也必成就；我已謀定，也必做成。',
    '賽46:12 你們這些心中頑梗、遠離公義的，當聽我言。',
    '賽46:13 我使我的公義臨近，必不遠離。我的救恩必不遲延；我要為以色列─我的榮耀，在錫安施行救恩。',
    '賽47:1 巴比倫的處女啊，下來坐在塵埃；迦勒底的閨女啊，沒有寶座，要坐在地上；因為你不再稱為柔弱嬌嫩的。',
    '賽47:2 要用磨磨麵，揭去帕子，脫去長衣，露腿逿河。',
    '賽47:3 你的下體必被露出；你的醜陋必被看見。我要報仇，誰也不寬容。',
    '賽47:4 我們救贖主的名是萬軍之耶和華─以色列的聖者。',
    '賽47:5 迦勒底的閨女啊，你要默然靜坐，進入暗中，因為你不再稱為列國的主母。',
    '賽47:6 我向我的百姓發怒，使我的產業被褻瀆，將他們交在你手中，你毫不憐憫他們，把極重的軛加在老年人身上。',
    '賽47:7 你自己說：我必永為主母，所以你不將這事放在心上，也不思想這事的結局。',
    '賽47:8 你這專好宴樂、安然居住的，現在當聽這話。你心中說：惟有我，除我以外再沒有別的。我必不致寡居，也不遭喪子之事。',
    '賽47:9 哪知，喪子、寡居這兩件事在一日轉眼之間必臨到你；正在你多行邪術、廣施符咒的時候，這兩件事必全然臨到你身上。',
    '賽47:10 你素來倚仗自己的惡行，說：無人看見我。你的智慧聰明使你偏邪，並且你心裡說：惟有我，除我以外再沒有別的。',
    '賽47:11 因此，禍患要臨到你身；你不知何時發現（或譯：如何驅逐）災害落在你身上，你也不能除掉；所不知道的毀滅也必忽然臨到你身。',
    '賽47:12 站起來吧！用你從幼年勞神施行的符咒和你許多的邪術；或者可得益處，或者可得強勝。',
    '賽47:13 你籌劃太多，以致疲倦。讓那些觀天象的，看星宿的，在月朔說預言的，都站起來，救你脫離所要臨到你的事。',
    '賽47:14 他們要像碎稭被火焚燒，不能救自己脫離火焰之力；這火並非可烤的炭火，也不是可以坐在其前的火。',
    '賽47:15 你所勞神的事都要這樣於你無益；從幼年與你貿易的也都各奔各鄉，無人救你。',
    '賽48:1 雅各家，稱為以色列名下，從猶大水源出來的，當聽我言！你們指著耶和華的名起誓，提說以色列的神，卻不憑誠實，不憑公義。',
    '賽48:2 他們自稱為聖城的人，所倚靠的是名為萬軍之耶和華─以色列的神。',
    '賽48:3 主說：早先的事，我從古時說明，已經出了我的口，也是我所指示的；我忽然行做，事便成就。',
    '賽48:4 因為我素來知道你是頑梗的─你的頸項是鐵的；你的額是銅的。',
    '賽48:5 所以，我從古時將這事給你說明，在未成以先指示你，免得你說：這些事是我的偶像所行的，是我雕刻的偶像和我鑄造的偶像所命定的。',
    '賽48:6 你已經聽見，現在要看見這一切；你不說明嗎﹖從今以後，我將新事，就是你所不知道的隱密事指示你。',
    '賽48:7 這事是現今造的，並非從古就有；在今日以先，你也未曾聽見，免得你說：這事我早已知道了。',
    '賽48:8 你未曾聽見，未曾知道；你的耳朵從來未曾開通。我原知道你行事極其詭詐，你自從出胎以來，便稱為悖逆的。',
    '賽48:9 我為我的名暫且忍怒，為我的頌讚向你容忍，不將你剪除。',
    '賽48:10 我熬煉你，卻不像熬煉銀子；你在苦難的爐中，我揀選你。',
    '賽48:11 我為自己的緣故必行這事，我焉能使我的名被褻瀆﹖我必不將我的榮耀歸給假神。',
    '賽48:12 雅各─我所選召的以色列啊，當聽我言：我是耶和華，我是首先的，也是末後的。',
    '賽48:13 我手立了地的根基；我右手鋪張諸天；我一招呼便都立住。',
    '賽48:14 你們都當聚集而聽，他們（或譯：偶像）內中誰說過這些事﹖耶和華所愛的人必向巴比倫行他所喜悅的事；他的膀臂也要加在迦勒底人身上。',
    '賽48:15 惟有我曾說過，我又選召他，領他來，他的道路就必亨通。',
    '賽48:16 你們要就近我來聽這話：我從起頭並未曾在隱密處說話；自從有這事，我就在那裡。現在，主耶和華差遣我和他的靈來（或譯：耶和華和他的靈差遣我來）。',
    '賽48:17 耶和華─你的救贖主，以色列的聖者如此說：我是耶和華─你的神，教訓你，使你得益處，引導你所當行的路。',
    '賽48:18 甚願你素來聽從我的命令！你的平安就如河水；你的公義就如海浪。',
    '賽48:19 你的後裔也必多如海沙；你腹中所生的也必多如沙粒。他的名在我面前必不剪除，也不滅絕。',
    '賽48:20 你們要從巴比倫出來，從迦勒底人中逃脫，以歡呼的聲音傳揚說：耶和華救贖了他的僕人雅各！你們要將這事宣揚到地極。',
    '賽48:21 耶和華引導他們經過沙漠。他們並不乾渴；他為他們使水從磐石而流，分裂磐石，水就湧出。',
    '賽48:22 耶和華說：惡人必不得平安！',
    '賽49:1 眾海島啊，當聽我言！遠方的眾民哪，留心而聽！自我出胎，耶和華就選召我；自出母腹，他就提我的名。',
    '賽49:2 他使我的口如快刀，將我藏在他手蔭之下；又使我成為磨亮的箭，將我藏在他箭袋之中；',
    '賽49:3 對我說：你是我的僕人以色列；我必因你得榮耀。',
    '賽49:4 我卻說：我勞碌是徒然；我盡力是虛無虛空。然而，我當得的理必在耶和華那裡；我的賞賜必在我神那裡。',
    '賽49:5 耶和華從我出胎，造就我作他的僕人，要使雅各歸向他，使以色列到他那裡聚集。原來耶和華看我為尊貴；我的神也成為我的力量。',
    '賽49:6 現在他說：你作我的僕人，使雅各眾支派復興，使以色列中得保全的歸回尚為小事，我還要使你作外邦人的光，叫你施行我的救恩，直到地極。',
    '賽49:7 救贖主─以色列的聖者耶和華對那被人所藐視、本國所憎惡、官長所虐待的如此說：君王要看見就站起，首領也要下拜；都因信實的耶和華，就是揀選你─以色列的聖者。',
    '賽49:8 耶和華如此說：在悅納的時候，我應允了你；在拯救的日子，我濟助了你。我要保護你，使你作眾民的中保（中保：原文是約）；復興遍地，使人承受荒涼之地為業。',
    '賽49:9 對那被捆綁的人說：出來吧！對那在黑暗的人說：顯露吧！他們在路上必得飲食，在一切淨光的高處必有食物。',
    '賽49:10 不飢不渴，炎熱和烈日必不傷害他們；因為憐恤他們的必引導他們，領他們到水泉旁邊。',
    '賽49:11 我必使我的眾山成為大道；我的大路也被修高。',
    '賽49:12 看哪，這些從遠方來；這些從北方、從西方來；這些從秦（原文是希尼）國來。',
    '賽49:13 諸天哪，應當歡呼！大地啊，應當快樂！眾山哪，應當發聲歌唱！因為耶和華已經安慰他的百姓，也要憐恤他困苦之民。',
    '賽49:14 錫安說：耶和華離棄了我；主忘記了我。',
    '賽49:15 婦人焉能忘記他吃奶的嬰孩，不憐恤他所生的兒子﹖即或有忘記的，我卻不忘記你。',
    '賽49:16 看哪，我將你銘刻在我掌上；你的牆垣常在我眼前。',
    '賽49:17 你的兒女必急速歸回；毀壞你的，使你荒廢的，必都離你出去，',
    '賽49:18 你舉目向四方觀看；他們都聚集來到你這裡。耶和華說：我指著我的永生起誓：你必要以他們為妝飾佩戴，以他們為華帶束腰，像新婦一樣。',
    '賽49:19 至於你荒廢淒涼之處，並你被毀壞之地，現今眾民居住必顯為太窄；吞滅你的必離你遙遠。',
    '賽49:20 你必聽見喪子之後所生的兒女說：這地方我居住太窄，求你給我地方居住。',
    '賽49:21 那時你心裡必說：我既喪子獨居，是被擄的，漂流在外。誰給我生這些﹖誰將這些養大呢﹖撇下我一人獨居的時候，這些在哪裡呢﹖',
    '賽49:22 主耶和華如此說：我必向列國舉手，向萬民豎立大旗；他們必將你的眾子懷中抱來，將你的眾女肩上扛來。',
    '賽49:23 列王必作你的養父；王后必作你的乳母。他們必將臉伏地，向你下拜，並舔你腳上的塵土。你便知道我是耶和華；等候我的必不致羞愧。',
    '賽49:24 勇士搶去的豈能奪回﹖該擄掠的豈能解救嗎﹖',
    '賽49:25 但耶和華如此說：就是勇士所擄掠的，也可以奪回；強暴人所搶的，也可以解救。與你相爭的，我必與他相爭；我要拯救你的兒女。',
    '賽49:26 並且我必使那欺壓你的吃自己的肉，也要以自己的血喝醉，好像喝甜酒一樣。凡有血氣的必都知道我─耶和華是你的救主，是你的救贖主，是雅各的大能者。',
    '賽50:1 耶和華如此說：我休你們的母親，休書在哪裡呢﹖我將你們賣給我哪一個債主呢﹖你們被賣，是因你們的罪孽；你們的母親被休，是因你們的過犯。',
    '賽50:2 我來的時候，為何無人等候呢﹖我呼喚的時候，為何無人答應呢﹖我的膀臂豈是縮短、不能救贖嗎﹖我豈無拯救之力嗎﹖看哪，我一斥責，海就乾了；我使江河變為曠野；其中的魚因無水腥臭，乾渴而死。',
    '賽50:3 我使諸天以黑暗為衣服，以麻布為遮蓋。',
    '賽50:4 主耶和華賜我受教者的舌頭，使我知道怎樣用言語扶助疲乏的人。主每早晨提醒，提醒我的耳朵，使我能聽，像受教者一樣。',
    '賽50:5 主耶和華開通我的耳朵；我並沒有違背，也沒有退後。',
    '賽50:6 人打我的背，我任他打；人拔我腮頰的鬍鬚，我由他拔；人辱我，吐我，我並不掩面。',
    '賽50:7 主耶和華必幫助我，所以我不抱愧。我硬著臉面好像堅石；我也知道我必不致蒙羞。',
    '賽50:8 稱我為義的與我相近；誰與我爭論，可以與我一同站立；誰與我作對，可以就近我來。',
    '賽50:9 主耶和華要幫助我；誰能定我有罪呢﹖他們都像衣服漸漸舊了，為蛀蟲所咬。',
    '賽50:10 你們中間誰是敬畏耶和華、聽從他僕人之話的﹖這人行在暗中，沒有亮光。當倚靠耶和華的名，仗賴自己的神。',
    '賽50:11 凡你們點火，用火把圍繞自己的可以行在你們的火焰裡，並你們所點的火把中。這是我手所定的；你們必躺在悲慘之中，',
    '賽51:1 你們這追求公義、尋求耶和華的，當聽我言！你們要追想被鑿而出的磐石，被挖而出的巖穴。',
    '賽51:2 要追想你們的祖宗亞伯拉罕和生養你們的撒拉；因為亞伯拉罕獨自一人的時候，我選召他，賜福與他，使他人數增多。',
    '賽51:3 耶和華已經安慰錫安和錫安一切的荒場，使曠野像伊甸，使沙漠像耶和華的園囿；在其中必有歡喜、快樂、感謝，和歌唱的聲音。',
    '賽51:4 我的百姓啊，要向我留心；我的國民哪，要向我側耳；因為訓誨必從我而出；我必堅定我的公理為萬民之光。',
    '賽51:5 我的公義臨近；我的救恩發出。我的膀臂要審判萬民；海島都要等候我，倚賴我的膀臂。',
    '賽51:6 你們要向天舉目，觀看下地；因為天必像煙雲消散，地必如衣服漸漸舊了；其上的居民也要如此死亡（如此死亡：或譯像蠓蟲死亡）。惟有我的救恩永遠長存；我的公義也不廢掉。',
    '賽51:7 知道公義、將我訓誨存在心中的民，要聽我言！不要怕人的辱罵，也不要因人的毀謗驚惶。',
    '賽51:8 因為蛀蟲必咬他們，好像咬衣服；蟲子必咬他們，如同咬羊絨。惟有我的公義永遠長存，我的救恩直到萬代。',
    '賽51:9 耶和華的膀臂啊，興起！興起！以能力為衣穿上，像古時的年日、上古的世代興起一樣。從前砍碎拉哈伯、刺透大魚的，不是你嗎﹖',
    '賽51:10 使海與深淵的水乾涸、使海的深處變為贖民經過之路的，不是你嗎﹖',
    '賽51:11 耶和華救贖的民必歸回，歌唱來到錫安；永樂必歸到他們的頭上。他們必得著歡喜快樂；憂愁歎息盡都逃避。',
    '賽51:12 惟有我，是安慰你們的。你是誰，竟怕那必死的人﹖怕那要變如草的世人﹖',
    '賽51:13 卻忘記鋪張諸天、立定地基、創造你的耶和華﹖又因欺壓者圖謀毀滅要發的暴怒，整天害怕，其實那欺壓者的暴怒在哪裡呢﹖',
    '賽51:14 被擄去的快得釋放，必不死而下坑；他的食物也不致缺乏。',
    '賽51:15 我是耶和華─你的神─攪動大海，使海中的波浪匉訇─萬軍之耶和華是我的名。',
    '賽51:16 我將我的話傳給你，用我的手影遮蔽你，為要栽定諸天，立定地基，又對錫安說：你是我的百姓。',
    '賽51:17 耶路撒冷啊，興起！興起！站起來！你從耶和華手中喝了他忿怒之杯，喝了那使人東倒西歪的爵，以致喝盡。',
    '賽51:18 他所生育的諸子中，沒有一個引導他的；他所養大的諸子中，沒有一個攙扶他的。',
    '賽51:19 荒涼、毀滅、饑荒、刀兵，這幾樣臨到你，誰為你舉哀﹖我如何能安慰你呢﹖',
    '賽51:20 你的眾子發昏，在各市口上躺臥，好像黃羊在網羅之中，都滿了耶和華的忿怒─你神的斥責。',
    '賽51:21 因此，你這困苦卻非因酒而醉的，要聽我言。',
    '賽51:22 你的主耶和華─就是為他百姓辨屈的神如此說：看哪，我已將那使人東倒西歪的杯，就是我忿怒的爵，從你手中接過來；你必不致再喝。',
    '賽51:23 我必將這杯遞在苦待你的人手中；他們曾對你說：你屈身，由我們踐踏過去吧！你便以背為地，好像街市，任人經過。',
    '賽52:1 錫安哪，興起！興起！披上你的能力！聖城耶路撒冷啊，穿上你華美的衣服！因為從今以後，未受割禮、不潔淨的必不再進入你中間。',
    '賽52:2 耶路撒冷啊，要抖下塵土！起來坐在位上！錫安被擄的居民（原文是女子）哪，要解開你頸項的鎖鍊！',
    '賽52:3 耶和華如此說：你們是無價被賣的，也必無銀被贖。',
    '賽52:4 主耶和華如此說：起先我的百姓下到埃及，在那裡寄居，又有亞述人無故欺壓他們。',
    '賽52:5 耶和華說：我的百姓既是無價被擄去，如今我在這裡做什麼呢﹖耶和華說：轄制他們的人呼叫，我的名整天受褻瀆。',
    '賽52:6 所以，我的百姓必知道我的名；到那日他們必知道說這話的就是我。看哪，是我！',
    '賽52:7 那報佳音，傳平安，報好信，傳救恩的，對錫安說：你的神作王了！這人的腳登山何等佳美！',
    '賽52:8 聽啊，你守望之人的聲音，他們揚起聲來，一同歌唱；因為耶和華歸回錫安的時候，他們必親眼看見。',
    '賽52:9 耶路撒冷的荒場啊，要發起歡聲，一同歌唱；因為耶和華安慰了他的百姓，救贖了耶路撒冷。',
    '賽52:10 耶和華在萬國眼前露出聖臂；地極的人都看見我們神的救恩了。',
    '賽52:11 你們離開吧！離開吧！從巴比倫出來。不要沾不潔淨的物；要從其中出來。你們扛擡耶和華器皿的人哪，務要自潔。',
    '賽52:12 你們出來必不致急忙，也不致奔逃。因為，耶和華必在你們前頭行；以色列的神必作你們的後盾。',
    '賽52:13 我的僕人行事必有智慧（或譯：行事通達），必被高舉上升，且成為至高。',
    '賽52:14 許多人因他（原文是你）驚奇；他的面貌比別人憔悴；他的形容比世人枯槁。',
    '賽52:15 這樣，他必洗淨（或譯：鼓動）許多國民；君王要向他閉口。因所未曾傳與他們的，他們必看見；未曾聽見的，他們要明白。',
    '賽53:1 我們所傳的（或譯：所傳與我們的）有誰信呢﹖耶和華的膀臂向誰顯露呢﹖',
    '賽53:2 他在耶和華面前生長如嫩芽，像根出於乾地。他無佳形美容；我們看見他的時候，也無美貌使我們羨慕他。',
    '賽53:3 他被藐視，被人厭棄；多受痛苦，常經憂患。他被藐視，好像被人掩面不看的一樣；我們也不尊重他。',
    '賽53:4 他誠然擔當我們的憂患，背負我們的痛苦；我們卻以為他受責罰，被神擊打苦待了。',
    '賽53:5 哪知他為我們的過犯受害，為我們的罪孽壓傷。因他受的刑罰，我們得平安；因他受的鞭傷，我們得醫治。',
    '賽53:6 我們都如羊走迷；各人偏行己路；耶和華使我們眾人的罪孽都歸在他身上。',
    '賽53:7 他被欺壓，在受苦的時候卻不開口（或譯：他受欺壓，卻自卑不開口）；他像羊羔被牽到宰殺之地，又像羊在剪毛的人手下無聲，他也是這樣不開口。',
    '賽53:8 因受欺壓和審判，他被奪去，至於他同世的人，誰想他受鞭打、從活人之地被剪除，是因我百姓的罪過呢﹖',
    '賽53:9 他雖然未行強暴，口中也沒有詭詐，人還使他與惡人同埋；誰知死的時候與財主同葬。',
    '賽53:10 耶和華卻定意（或譯：喜悅）將他壓傷，使他受痛苦。耶和華以他為贖罪祭（譯：他獻本身為贖罪祭）。他必看見後裔，並且延長年日。耶和華所喜悅的事必在他手中亨通。',
    '賽53:11 他必看見自己勞苦的功效，便心滿意足。有許多人因認識我的義僕得稱為義；並且他要擔當他們的罪孽。',
    '賽53:12 所以，我要使他與位大的同分，與強盛的均分擄物。因為他將命傾倒，以致於死；他也被列在罪犯之中。他卻擔當多人的罪，又為罪犯代求。',
    '賽54:1 你這不懷孕、不生養的要歌唱；你這未曾經過產難的要發聲歌唱，揚聲歡呼；因為沒有丈夫的比有丈夫的兒女更多。這是耶和華說的。',
    '賽54:2 要擴張你帳幕之地，張大你居所的幔子，不要限止；要放長你的繩子，堅固你的橛子。',
    '賽54:3 因為你要向左向右開展；你的後裔必得多國為業，又使荒涼的城邑有人居住。',
    '賽54:4 不要懼怕，因你必不致蒙羞；也不要抱愧，因你必不致受辱。你必忘記幼年的羞愧，不再記念你寡居的羞辱。',
    '賽54:5 因為造你的是你的丈夫；萬軍之耶和華是他的名。救贖你的是以色列的聖者；他必稱為全地之神。',
    '賽54:6 耶和華召你，如召被離棄心中憂傷的妻，就是幼年所娶被棄的妻。這是你神所說的。',
    '賽54:7 我離棄你不過片時，卻要施大恩將你收回。',
    '賽54:8 我的怒氣漲溢，頃刻之間向你掩面，卻要以永遠的慈愛憐恤你。這是耶和華─你的救贖主說的。',
    '賽54:9 這事在我好像挪亞的洪水。我怎樣起誓不再使挪亞的洪水漫過遍地，我也照樣起誓不再向你發怒，也不斥責你。',
    '賽54:10 大山可以挪開，小山可以遷移；但我的慈愛必不離開你；我平安的約也不遷移。這是憐恤你的耶和華說的。',
    '賽54:11 你這受困苦、被風飄蕩不得安慰的人哪，我必以彩色安置你的石頭，以藍寶石立定你的根基；',
    '賽54:12 又以紅寶石造你的女牆，以紅玉造你的城門，以寶石造你四圍的邊界（或譯：外郭）。',
    '賽54:13 你的兒女都要受耶和華的教訓；你的兒女必大享平安。',
    '賽54:14 你必因公義得堅立，必遠離欺壓，不致害怕；你必遠離驚嚇，驚嚇必不臨近你。',
    '賽54:15 即或有人聚集，卻不由於我；凡聚集攻擊你的，必因你仆倒（或譯：投降你）。',
    '賽54:16 吹噓炭火、打造合用器械的鐵匠是我所造；殘害人、行毀滅的也是我所造。',
    '賽54:17 凡為攻擊你造成的器械必不利用；凡在審判時興起用舌攻擊你的，你必定他為有罪。這是耶和華僕人的產業，是他們從我所得的義。這是耶和華說的。',
    '賽55:1 你們一切乾渴的都當就近水來；沒有銀錢的也可以來。你們都來，買了吃；不用銀錢，不用價值，也來買酒和奶。',
    '賽55:2 你們為何花錢（原文是平銀）買那不足為食物的﹖用勞碌得來的買那不使人飽足的呢﹖你們要留意聽我的話就能吃那美物，得享肥甘，心中喜樂。',
    '賽55:3 你們當就近我來；側耳而聽，就必得活。我必與你們立永約，就是應許大衛那可靠的恩典。',
    '賽55:4 我已立他作萬民的見證，為萬民的君王和司令。',
    '賽55:5 你素不認識的國民，你也必召來；素不認識你的國民也必向你奔跑，都因耶和華─你的神以色列的聖者，因為他已經榮耀你。',
    '賽55:6 當趁耶和華可尋找的時候尋找他，相近的時候求告他。',
    '賽55:7 惡人當離棄自己的道路；不義的人當除掉自己的意念。歸向耶和華，耶和華就必憐恤他；當歸向我們的神，因為神必廣行赦免。',
    '賽55:8 耶和華說：我的意念非同你們的意念；我的道路非同你們的道路。',
    '賽55:9 天怎樣高過地，照樣，我的道路高過你們的道路；我的意念高過你們的意念。',
    '賽55:10 雨雪從天而降，並不返回，卻滋潤地土，使地上發芽結實，使撒種的有種，使要吃的有糧。',
    '賽55:11 我口所出的話也必如此，決不徒然返回，卻要成就我所喜悅的，在我發他去成就（發他去成就：或譯所命定）的事上必然亨通。',
    '賽55:12 你們必歡歡喜喜而出來，平平安安蒙引導。大山小山必在你們面前發聲歌唱；田野的樹木也都拍掌。',
    '賽55:13 松樹長出，代替荊棘；番石榴長出，代替蒺藜。這要為耶和華留名，作為永遠的證據，不能剪除。',
    '賽56:1 耶和華如此說：你們當守公平，行公義；因我的救恩臨近，我的公義將要顯現。',
    '賽56:2 謹守安息日而不干犯，禁止己手而不作惡；如此行、如此持守的人便為有福。',
    '賽56:3 與耶和華聯合的外邦人不要說：耶和華必定將我從他民中分別出來。太監也不要說：我是枯樹。',
    '賽56:4 因為耶和華如此說：那些謹守我的安息日，揀選我所喜悅的事，持守我約的太監，',
    '賽56:5 我必使他們在我殿中，在我牆內，有記念，有名號，比有兒女的更美。我必賜他們永遠的名，不能剪除。',
    '賽56:6 還有那些與耶和華聯合的外邦人，要事奉他，要愛耶和華的名，要作他的僕人─就是凡守安息日不干犯，又持守他（原文是我）約的人。',
    '賽56:7 我必領他們到我的聖山，使他們在禱告我的殿中喜樂。他們的燔祭和平安祭，在我壇上必蒙悅納，因我的殿必稱為萬民禱告的殿。',
    '賽56:8 主耶和華，就是招聚以色列被趕散的，說：在這被招聚的人以外，我還要招聚別人歸併他們。',
    '賽56:9 田野的諸獸都來吞吃吧！林中的諸獸也要如此。',
    '賽56:10 他看守的人是瞎眼的，都沒有知識，都是啞巴狗，不能叫喚；但知做夢，躺臥，貪睡，',
    '賽56:11 這些狗貪食，不知飽足。這些牧人不能明白─各人偏行己路，各從各方求自己的利益。',
    '賽56:12 他們說：來吧！我去拿酒，我們飽飲濃酒；明日必和今日一樣，就是宴樂無量極大之日。',
    '賽57:1 義人死亡，無人放在心上；虔誠人被收去，無人思念。這義人被收去是免了將來的禍患；',
    '賽57:2 他們得享（原文是進入）平安。素行正直的，各人在墳裡（原文是床上）安歇。',
    '賽57:3 你們這些巫婆的兒子，姦夫和妓女的種子，都要前來！',
    '賽57:4 你們向誰戲笑﹖向誰張口吐舌呢﹖你們豈不是悖逆的兒女，虛謊的種類呢﹖',
    '賽57:5 你們在橡樹中間，在各青翠樹下慾火攻心；在山谷間，在石穴下殺了兒女；',
    '賽57:6 在谷中光滑石頭裡有你的分。這些就是你所得的分；你也向他澆了奠祭，獻了供物，因這事我豈能容忍嗎﹖',
    '賽57:7 你在高而又高的山上安設床榻，也上那裡去獻祭。',
    '賽57:8 你在門後，在門框後，立起你的記念；向外人赤露，又上去擴張床榻，與他們立約；你在那裡看見他們的床就甚喜愛。',
    '賽57:9 你把油帶到王那裡，又多加香料，打發使者往遠方去，自卑自賤直到陰間，',
    '賽57:10 你因路遠疲倦，卻不說這是枉然；你以為有復興之力，所以不覺疲憊。',
    '賽57:11 你怕誰﹖因誰恐懼﹖竟說謊，不記念我，又不將這事放在心上。我不是許久閉口不言，你仍不怕我嗎﹖',
    '賽57:12 我要指明你的公義；至於你所行的都必於你無益。',
    '賽57:13 你哀求的時候，讓你所聚集的拯救你吧！風要把他們颳散，一口氣要把他們都吹去。但那投靠我的必得地土，必承受我的聖山為業。',
    '賽57:14 耶和華要說：你們修築修築，預備道路，將絆腳石從我百姓的路中除掉。',
    '賽57:15 因為那至高至上、永遠長存（原文是住在永遠）名為聖者的如此說：我住在至高至聖的所在，也與心靈痛悔謙卑的人同居；要使謙卑人的靈甦醒，也使痛悔人的心甦醒。',
    '賽57:16 我必不永遠相爭，也不長久發怒，恐怕我所造的人與靈性都必發昏。',
    '賽57:17 因他貪婪的罪孽，我就發怒擊打他；我向他掩面發怒，他卻仍然隨心背道。',
    '賽57:18 我看見他所行的道，也要醫治他；又要引導他，使他和那一同傷心的人再得安慰。',
    '賽57:19 我造就嘴唇的果子；願平安康泰歸與遠處的人，也歸與近處的人；並且我要醫治他。這是耶和華說的。',
    '賽57:20 惟獨惡人，好像翻騰的海，不得平靜；其中的水常湧出污穢和淤泥來。',
    '賽57:21 我的神說：惡人必不得平安！',
    '賽58:1 你要大聲喊叫，不可止息；揚起聲來，好像吹角。向我百姓說明他們的過犯；向雅各家說明他們的罪惡。',
    '賽58:2 他們天天尋求我，樂意明白我的道，好像行義的國民，不離棄他們神的典章，向我求問公義的判語，喜悅親近神。',
    '賽58:3 他們說：我們禁食，你為何不看見呢﹖我們刻苦己心，你為何不理會呢﹖看哪，你們禁食的日子仍求利益，勒逼人為你們做苦工。',
    '賽58:4 你們禁食，卻互相爭競，以凶惡的拳頭打人。你們今日禁食，不得使你們的聲音聽聞於上。',
    '賽58:5 這樣禁食豈是我所揀選、使人刻苦己心的日子嗎﹖豈是叫人垂頭像葦子，用麻布和爐灰鋪在他以下嗎﹖你這可稱為禁食、為耶和華所悅納的日子嗎﹖',
    '賽58:6 我所揀選的禁食不是要鬆開凶惡的繩，解下軛上的索，使被欺壓的得自由，折斷一切的軛嗎﹖',
    '賽58:7 不是要把你的餅分給飢餓的人，將飄流的窮人接到你家中，見赤身的給他衣服遮體，顧恤自己的骨肉而不掩藏嗎﹖',
    '賽58:8 這樣，你的光就必發現如早晨的光，你所得的醫治要速速發明。你的公義必在你前面行；耶和華的榮光必作你的後盾。',
    '賽58:9 那時你求告，耶和華必應允；你呼求，他必說：我在這裡。你若從你中間除掉重軛和指摘人的指頭，並發惡言的事，',
    '賽58:10 你心若向飢餓的人發憐憫，使困苦的人得滿足，你的光就必在黑暗中發現；你的幽暗必變如正午。',
    '賽58:11 耶和華也必時常引導你，在乾旱之地使你心滿意足，骨頭強壯。你必像澆灌的園子，又像水流不絕的泉源。',
    '賽58:12 那些出於你的人必修造久已荒廢之處；你要建立拆毀累代的根基。你必稱為補破口的，和重修路徑與人居住的。',
    '賽58:13 你若在安息日掉轉（或譯：謹慎）你的腳步，在我聖日不以操作為喜樂，稱安息日為可喜樂的，稱耶和華的聖日為可尊重的；而且尊敬這日，不辦自己的私事，不隨自己的私意，不說自己的私話，',
    '賽58:14 你就以耶和華為樂。耶和華要使你乘駕地的高處，又以你祖雅各的產業養育你。這是耶和華親口說的。',
    '賽59:1 耶和華的膀臂並非縮短，不能拯救，耳朵並非發沉，不能聽見，',
    '賽59:2 但你們的罪孽使你們與神隔絕；你們的罪惡使他掩面不聽你們。',
    '賽59:3 因你們的手被血沾染，你們的指頭被罪孽沾污，你們的嘴唇說謊言，你們的舌頭出惡語。',
    '賽59:4 無一人按公義告狀，無一人憑誠實辨白；都倚靠虛妄，說謊言。所懷的是毒害；所生的是罪孽。',
    '賽59:5 他們菢毒蛇蛋，結蜘蛛網；人吃這蛋必死。這蛋被踏，必出蝮蛇。',
    '賽59:6 所結的網不能成為衣服；所做的也不能遮蓋自己。他們的行為都是罪孽；手所做的都是強暴。',
    '賽59:7 他們的腳奔跑行惡；他們急速流無辜人的血；意念都是罪孽，所經過的路都荒涼毀滅。',
    '賽59:8 平安的路，他們不知道；所行的事沒有公平。他們為自己修彎曲的路；凡行此路的都不知道平安。',
    '賽59:9 因此，公平離我們遠，公義追不上我們。我們指望光亮，卻是黑暗，指望光明，卻行幽暗。',
    '賽59:10 我們摸索牆壁，好像瞎子；我們摸索，如同無目之人。我們晌午絆腳，如在黃昏一樣；我們在肥壯人中，像死人一般。',
    '賽59:11 我們咆哮如熊，哀鳴如鴿；指望公平，卻是沒有；指望救恩，卻遠離我們。',
    '賽59:12 我們的過犯在你面前增多，罪惡作見證告我們；過犯與我們同在。至於我們的罪孽，我們都知道：',
    '賽59:13 就是悖逆、不認識耶和華，轉去不跟從我們的神，說欺壓和叛逆的話，心懷謊言，隨即說出。',
    '賽59:14 並且公平轉而退後，公義站在遠處；誠實在街上仆倒，正直也不得進入。',
    '賽59:15 誠實少見；離惡的人反成掠物。那時，耶和華看見沒有公平，甚不喜悅。',
    '賽59:16 他見無人拯救，無人代求，甚為詫異，就用自己的膀臂施行拯救，以公義扶持自己。',
    '賽59:17 他以公義為鎧甲（或譯：護心鏡），以拯救為頭盔，以報仇為衣服，以熱心為外袍。',
    '賽59:18 他必按人的行為施報，惱怒他的敵人，報復他的仇敵向眾海島施行報應。',
    '賽59:19 如此，人從日落之處必敬畏耶和華的名，從日出之地也必敬畏他的榮耀；因為仇敵好像急流的河水沖來，是耶和華之氣所驅逐的。',
    '賽59:20 必有一位救贖主來到錫安─雅各族中轉離過犯的人那裡。這是耶和華說的。',
    '賽59:21 耶和華說：至於我與他們所立的約乃是這樣：我加給你的靈，傳給你的話，必不離你的口，也不離你後裔與你後裔之後裔的口，從今直到永遠；這是耶和華說的。',
    '賽60:1 興起，發光！因為你的光已經來到！耶和華的榮耀發現照耀你。',
    '賽60:2 看哪，黑暗遮蓋大地，幽暗遮蓋萬民，耶和華卻要顯現照耀你；他的榮耀要現在你身上。',
    '賽60:3 萬國要來就你的光，君王要來就你發現的光輝。',
    '賽60:4 你舉目向四方觀看；眾人都聚集來到你這裡。你的眾子從遠方而來；你的眾女也被懷抱而來。',
    '賽60:5 那時，你看見就有光榮；你心又跳動又寬暢；因為大海豐盛的貨物必轉來歸你；列國的財寶也必來歸你。',
    '賽60:6 成群的駱駝，並米甸和以法的獨峰駝必遮滿你；示巴的眾人都必來到；要奉上黃金乳香，又要傳說耶和華的讚美。',
    '賽60:7 基達的羊群都必聚集到你這裡，尼拜約的公羊要供你使用，在我壇上必蒙悅納；我必榮耀我榮耀的殿。',
    '賽60:8 那些飛來如雲、又如鴿子向窗戶飛回的是誰呢﹖',
    '賽60:9 眾海島必等候我，首先是他施的船隻，將你的眾子連他們的金銀從遠方一同帶來，都為耶和華─你神的名，又為以色列的聖者，因為他已經榮耀了你。',
    '賽60:10 外邦人必建築你的城牆；他們的王必服事你。我曾發怒擊打你，現今卻施恩憐恤你。',
    '賽60:11 你的城門必時常開放，晝夜不關；使人把列國的財物帶來歸你，並將他們的君王牽引而來。',
    '賽60:12 哪一邦哪一國不事奉你，就必滅亡，也必全然荒廢。',
    '賽60:13 利巴嫩的榮耀，就是松樹、杉樹、黃楊樹，都必一同歸你，為要修飾我聖所之地；我也要使我腳踏之處得榮耀。',
    '賽60:14 素來苦待你的，他的子孫都必屈身來就你；藐視你的，都要在你腳下跪拜。他們要稱你為耶和華的城，為以色列聖者的錫安。',
    '賽60:15 你雖然被撇棄被厭惡，甚至無人經過，我卻使你變為永遠的榮華，成為累代的喜樂。',
    '賽60:16 你也必吃萬國的奶，又吃君王的奶。你便知道我─耶和華是你的救主，是你的救贖主，雅各的大能者。',
    '賽60:17 我要拿金子代替銅，拿銀子代替鐵，拿銅代替木頭，拿鐵代替石頭；並要以和平為你的官長，以公義為你的監督。',
    '賽60:18 你地上不再聽見強暴的事，境內不再聽見荒涼毀滅的事。你必稱你的牆為拯救，稱你的門為讚美。',
    '賽60:19 日頭不再作你白晝的光，月亮也不再發光照耀你。耶和華卻要作你永遠的光，你神要為你的榮耀。',
    '賽60:20 你的日頭不再下落；你的月亮也不退縮；因為耶和華必作你永遠的光。你悲哀的日子也完畢了。',
    '賽60:21 你的居民都成為義人，永遠得地為業；是我種的栽子，我手的工作，使我得榮耀。',
    '賽60:22 至小的族要加增千倍；微弱的國必成為強盛。我─耶和華要按定期速成這事。',
    '賽61:1 主耶和華的靈在我身上；因為耶和華用膏膏我，叫我傳好信息給謙卑的人（或譯：傳福音給貧窮的人），差遣我醫好傷心的人，報告被擄的得釋放，被囚的出監牢；',
    '賽61:2 報告耶和華的恩年，和我們神報仇的日子；安慰一切悲哀的人，',
    '賽61:3 賜華冠與錫安悲哀的人，代替灰塵；喜樂油代替悲哀；讚美衣代替憂傷之靈；使他們稱為公義樹，是耶和華所栽的，叫他得榮耀。',
    '賽61:4 他們必修造已久的荒場，建立先前淒涼之處，重修歷代荒涼之城。',
    '賽61:5 那時，外人必起來牧放你們的羊群；外邦人必作你們耕種田地的，修理葡萄園的。',
    '賽61:6 你們倒要稱為耶和華的祭司；人必稱你們為我們神的僕役。你們必吃用列國的財物，因得他們的榮耀自誇。',
    '賽61:7 你們必得加倍的好處，代替所受的羞辱；分中所得的喜樂，必代替所受的凌辱。在境內必得加倍的產業；永遠之樂必歸與你們（原文是他們）。',
    '賽61:8 因為我─耶和華喜愛公平，恨惡搶奪和罪孽；我要憑誠實施行報應，並要與我的百姓立永約。',
    '賽61:9 他們的後裔必在列國中被人認識；他們的子孫在眾民中也是如此。凡看見他們的必認他們是耶和華賜福的後裔。',
    '賽61:10 我因耶和華大大歡喜；我的心靠神快樂。因他以拯救為衣給我穿上，以公義為袍給我披上，好像新郎戴上華冠，又像新婦佩戴妝飾。',
    '賽61:11 田地怎樣使百穀發芽，園子怎樣使所種的發生，主耶和華必照樣使公義和讚美在萬民中發出。',
    '賽62:1 我因錫安必不靜默，為耶路撒冷必不息聲，直到他的公義如光輝發出，他的救恩如明燈發亮。',
    '賽62:2 列國必見你的公義；列王必見你的榮耀。你必得新名的稱呼，是耶和華親口所起的。',
    '賽62:3 你在耶和華的手中要作為華冠，在你神的掌上必作為冕旒。',
    '賽62:4 你必不再稱為撇棄的；你的地也不再稱為荒涼的。你卻要稱為我所喜悅的；你的地也必稱為有夫之婦。因為耶和華喜悅你，你的地也必歸他。',
    '賽62:5 少年人怎樣娶處女，你的眾民（民：原文是子）也要照樣娶你；新郎怎樣喜悅新婦，你的神也要照樣喜悅你。',
    '賽62:6 耶路撒冷啊，我在你城上設立守望的，他們晝夜必不靜默。呼籲耶和華的，你們不要歇息，',
    '賽62:7 也不要使他歇息，直等他建立耶路撒冷，使耶路撒冷在地上成為可讚美的。',
    '賽62:8 耶和華指著自己的右手和大能的膀臂起誓說：我必不再將你的五穀給你仇敵作食物；外邦人也不再喝你勞碌得來的新酒。',
    '賽62:9 惟有那收割的要吃，並讚美耶和華；那聚斂的要在我聖所的院內喝。',
    '賽62:10 你們當從門經過經過，預備百姓的路；修築修築大道，撿去石頭，為萬民豎立大旗，',
    '賽62:11 看哪，耶和華曾宣告到地極，對錫安的居民（原文是女子）說：你的拯救者來到。他的賞賜在他那裡；他的報應在他面前。',
    '賽62:12 人必稱他們為聖民，為耶和華的贖民；你也必稱為被眷顧、不撇棄的城。',
    '賽63:1 這從以東的波斯拉來，穿紅衣服，裝扮華美，能力廣大，大步行走的是誰呢﹖就是我，是憑公義說話，以大能施行拯救。',
    '賽63:2 你的裝扮為何有紅色﹖你的衣服為何像踹酒醡的呢﹖',
    '賽63:3 我獨自踹酒醡；眾民中無一人與我同在。我發怒將他們踹下，發烈怒將他們踐踏。他們的血濺在我衣服上，並且污染了我一切的衣裳。',
    '賽63:4 因為，報仇之日在我心中；救贖我民之年已經來到。',
    '賽63:5 我仰望，見無人幫助；我詫異，沒有人扶持。所以，我自己的膀臂為我施行拯救；我的烈怒將我扶持。',
    '賽63:6 我發怒，踹下眾民；發烈怒，使他們沉醉，又將他們的血倒在地上。',
    '賽63:7 我要照耶和華一切所賜給我們的，提起他的慈愛和美德，並他向以色列家所施的大恩；這恩是照他的憐恤和豐盛的慈愛賜給他們的。',
    '賽63:8 他說：他們誠然是我的百姓，不行虛假的子民；這樣，他就作了他們的救主。',
    '賽63:9 他們在一切苦難中，他也同受苦難；並且他面前的使者拯救他們；他以慈愛和憐憫救贖他們；在古時的日子常保抱他們，懷搋他們。',
    '賽63:10 他們竟悖逆，使主的聖靈擔憂。他就轉作他們的仇敵，親自攻擊他們。',
    '賽63:11 那時，他們（原文是他）想起古時的日子─摩西和他百姓，說：將百姓和牧養他全群的人從海裡領上來的在哪裡呢﹖將他的聖靈降在他們中間的在哪裡呢﹖',
    '賽63:12 使他榮耀的膀臂在摩西的右手邊行動，在他們前面將水分開，要建立自己永遠的名，',
    '賽63:13 帶領他們經過深處，如馬行走曠野，使他們不致絆跌的在哪裡呢﹖',
    '賽63:14 耶和華的靈使他們得安息，彷彿牲畜下到山谷；照樣，你也引導你的百姓，要建立自己榮耀的名。',
    '賽63:15 求你從天上垂顧，從你聖潔榮耀的居所觀看。你的熱心和你大能的作為在哪裡呢﹖你愛慕的心腸和憐憫向我們止住了。',
    '賽63:16 亞伯拉罕雖然不認識我們，以色列也不承認我們，你卻是我們的父。耶和華啊，你是我們的父；從萬古以來，你名稱為我們的救贖主。',
    '賽63:17 耶和華啊，你為何使我們走差離開你的道，使我們心裡剛硬、不敬畏你呢﹖求你為你僕人，為你產業支派的緣故，轉回來。',
    '賽63:18 你的聖民不過暫時得這產業；我們的敵人已經踐踏你的聖所。',
    '賽63:19 我們好像你未曾治理的人，又像未曾得稱你名下的人。',
    '賽64:1 願你裂天而降；願山在你面前震動─',
    '賽64:2 好像火燒乾柴，又像火將水燒開，使你敵人知道你的名，使列國在你面前發顫！',
    '賽64:3 你曾行我們不能逆料可畏的事。那時你降臨，山嶺在你面前震動。',
    '賽64:4 從古以來，人未曾聽見、未曾耳聞、未曾眼見在你以外有什麼神為等候他的人行事。',
    '賽64:5 你迎接那歡喜行義、記念你道的人；你曾發怒，我們仍犯罪；這景況已久，我們還能得救嗎﹖',
    '賽64:6 我們都像不潔淨的人；所有的義都像污穢的衣服。我們都像葉子漸漸枯乾；我們的罪孽好像風把我們吹去。',
    '賽64:7 並且無人求告你的名；無人奮力抓住你。原來你掩面不顧我們，使我們因罪孽消化。',
    '賽64:8 耶和華啊，現在你仍是我們的父！我們是泥，你是窰匠；我們都是你手的工作。',
    '賽64:9 耶和華啊，求你不要大發震怒，也不要永遠記念罪孽。求你垂顧我們，我們都是你的百姓。',
    '賽64:10 你的聖邑變為曠野。錫安變為曠野；耶路撒冷成為荒場。',
    '賽64:11 我們聖潔華美的殿─就是我們列祖讚美你的所在被火焚燒；我們所羨慕的美地盡都荒廢。',
    '賽64:12 耶和華啊，有這些事，你還忍得住嗎﹖你仍靜默使我們深受苦難嗎﹖',
    '賽65:1 素來沒有訪問我的，現在求問我；沒有尋找我的，我叫他們遇見；沒有稱為我名下的，我對他們說：我在這裡！我在這裡！',
    '賽65:2 我整天伸手招呼那悖逆的百姓；他們隨自己的意念行不善之道。',
    '賽65:3 這百姓時常當面惹我發怒；在園中獻祭，在壇（原文是磚）上燒香；',
    '賽65:4 在墳墓間坐著，在隱密處住宿，吃豬肉；他們器皿中有可憎之物做的湯；',
    '賽65:5 且對人說：你站開吧！不要挨近我，因為我比你聖潔。主說：這些人是我鼻中的煙，是整天燒著的火。',
    '賽65:6 看哪，這都寫在我面前。我必不靜默，必施行報應，必將你們的罪孽和你們列祖的罪孽，就是在山上燒香，在岡上褻瀆我的罪孽，一同報應在他們後人懷中，我先要把他們所行的量給他們；這是耶和華說的。',
    '賽65:7 併於上節。',
    '賽65:8 耶和華如此說：葡萄中尋得新酒，人就說：不要毀壞，因為福在其中。我因我僕人的緣故也必照樣而行，不將他們全然毀滅。',
    '賽65:9 我必從雅各中領出後裔，從猶大中領出承受我眾山的。我的選民必承受；我的僕人要在那裡居住。',
    '賽65:10 沙崙平原必成為羊群的圈；亞割谷必成為牛群躺臥之處，都為尋求我的民所得。',
    '賽65:11 但你們這些離棄耶和華、忘記我的聖山、給時運擺筵席（原文是桌子）、給天命盛滿調和酒的，',
    '賽65:12 我要命定你們歸在刀下，都必屈身被殺；因為我呼喚，你們沒有答應；我說話，你們沒有聽從；反倒行我眼中看為惡的，揀選我所不喜悅的。',
    '賽65:13 所以，主耶和華如此說：我的僕人必得吃，你們卻飢餓；我的僕人必得喝，你們卻乾渴；我的僕人必歡喜，你們卻蒙羞。',
    '賽65:14 我的僕人因心中高興歡呼，你們卻因心中憂愁哀哭，又因心裡憂傷哀號。',
    '賽65:15 你們必留下自己的名，為我選民指著賭咒。主耶和華必殺你們，另起別名稱呼他的僕人。',
    '賽65:16 這樣，在地上為自己求福的，必憑真實的神求福；在地上起誓的，必指真實的神起誓。因為，從前的患難已經忘記，也從我眼前隱藏了。',
    '賽65:17 看哪！我造新天新地；從前的事不再被記念，也不再追想。',
    '賽65:18 你們當因我所造的永遠歡喜快樂；因我造耶路撒冷為人所喜，造其中的居民為人所樂。',
    '賽65:19 我必因耶路撒冷歡喜，因我的百姓快樂；其中必不再聽見哭泣的聲音和哀號的聲音。',
    '賽65:20 其中必沒有數日夭亡的嬰孩，也沒有壽數不滿的老者；因為百歲死的仍算孩童，有百歲死的罪人算被咒詛。',
    '賽65:21 他們要建造房屋，自己居住；栽種葡萄園，吃其中的果子。',
    '賽65:22 他們建造的，別人不得住；他們栽種的，別人不得吃；因為我民的日子必像樹木的日子；我選民親手勞碌得來的必長久享用。',
    '賽65:23 他們必不徒然勞碌，所生產的，也不遭災害，因為都是蒙耶和華賜福的後裔；他們的子孫也是如此。',
    '賽65:24 他們尚未求告，我就應允；正說話的時候，我就垂聽。',
    '賽65:25 豺狼必與羊羔同食；獅子必吃草與牛一樣；塵土必作蛇的食物。在我聖山的遍處，這一切都不傷人，不害物。這是耶和華說的。',
    '賽66:1 耶和華如此說：天是我的座位；地是我的腳凳。你們要為我造何等的殿宇﹖哪裡是我安息的地方呢﹖',
    '賽66:2 耶和華說：這一切都是我手所造的，所以就都有了。但我所看顧的，就是虛心（原文是貧窮）痛悔、因我話而戰兢的人。',
    '賽66:3 假冒為善的宰牛，好像殺人，獻羊羔，好像打折狗項，獻供物，好像獻豬血，燒乳香，好像稱頌偶像。這等人揀選自己的道路，心裡喜悅行可憎惡的事。',
    '賽66:4 我也必揀選迷惑他們的事，使他們所懼怕的臨到他們；因為我呼喚，無人答應；我說話，他們不聽從；反倒行我眼中看為惡的，揀選我所不喜悅的。',
    '賽66:5 你們因耶和華言語戰兢的人當聽他的話：你們的弟兄─就是恨惡你們，因我名趕出你們的，曾說：願耶和華得榮耀，使我們得見你們的喜樂；但蒙羞的究竟是他們！',
    '賽66:6 有喧嘩的聲音出自城中！有聲音出於殿中！是耶和華向仇敵施行報應的聲音！',
    '賽66:7 錫安未曾劬勞就生產，未覺疼痛就生出男孩。',
    '賽66:8 國豈能一日而生﹖民豈能一時而產﹖因為錫安一劬勞便生下兒女，這樣的事誰曾聽見﹖誰曾看見呢﹖',
    '賽66:9 耶和華說：我既使他臨產，豈不使他生產呢﹖你的神說：我既使他生產，豈能使他閉胎不生呢﹖',
    '賽66:10 你們愛慕耶路撒冷的都要與他一同歡喜快樂；你們為他悲哀的都要與他一同樂上加樂；',
    '賽66:11 使你們在他安慰的懷中吃奶得飽，使他們得他豐盛的榮耀，猶如擠奶，滿心喜樂。',
    '賽66:12 耶和華如此說：我要使平安延及他，好像江河，使列國的榮耀延及他，如同漲溢的河。你們要從中享受（原文是咂）；你們必蒙抱在肋旁，搖弄在膝上。',
    '賽66:13 母親怎樣安慰兒子，我就照樣安慰你們；你們也必因（或譯：在）耶路撒冷得安慰。',
    '賽66:14 你們看見，就心中快樂；你們的骨頭必得滋潤像嫩草一樣；而且耶和華的手向他僕人所行的必被人知道；他也要向仇敵發惱恨。',
    '賽66:15 看哪，耶和華必在火中降臨；他的車輦像旋風，以烈怒施行報應，以火焰施行責罰；',
    '賽66:16 因為耶和華在一切有血氣的人身上，必以火與刀施行審判；被耶和華所殺的必多。',
    '賽66:17 那些分別為聖、潔淨自己的，進入園內跟在其中一個人的後頭，吃豬肉和倉鼠並可憎之物，他們必一同滅絕；這是耶和華說的。',
    '賽66:18 我知道他們的行為和他們的意念。時候將到，我必將萬民萬族（族：原文是舌）聚來，看見我的榮耀，',
    '賽66:19 我要顯神蹟（或譯：記號）在他們中間。逃脫的，我要差到列國去，就是到他施、普勒、拉弓的路德和土巴、雅完，並素來沒有聽見我名聲、沒有看見我榮耀遼遠的海島；他們必將我的榮耀傳揚在列國中。',
    '賽66:20 他們必將你們的弟兄從列國中送回，使他們或騎馬，或坐車，坐轎，騎騾子，騎獨峰駝，到我的聖山耶路撒冷，作為供物獻給耶和華，好像以色列人用潔淨的器皿盛供物奉到耶和華的殿中；這是耶和華說的。',
    '賽66:21 耶和華說：我也必從他們中間取人為祭司，為利未人。',
    '賽66:22 耶和華說：我所要造的新天新地，怎樣在我面前長存；你們的後裔和你們的名字也必照樣長存。',
    '賽66:23 每逢月朔、安息日，凡有血氣的必來在我面前下拜。這是耶和華說的。',
    '賽66:24 他們必出去觀看那些違背我人的屍首；因為他們的蟲是不死的；他們的火是不滅的；凡有血氣的都必憎惡他們。',
    '耶1:1 便雅憫地亞拿突城的祭司中，希勒家的兒子耶利米的話記在下面。',
    '耶1:2 猶大王亞們的兒子約西亞在位十三年，耶和華的話臨到耶利米。',
    '耶1:3 從猶大王約西亞的兒子約雅敬在位的時候，直到猶大王約西亞的兒子西底家在位的末年，就是十一年五月間耶路撒冷人被擄的時候，耶和華的話也常臨到耶利米。',
    '耶1:4 耶利米說，耶和華的話臨到我說：',
    '耶1:5 我未將你造在腹中，我已曉得你；你未出母胎，我已分別你為聖；我已派你作列國的先知。',
    '耶1:6 我就說：主耶和華啊，我不知怎樣說，因為我是年幼的。',
    '耶1:7 耶和華對我說：你不要說我是年幼的，因為我差遣你到誰那裡去，你都要去；我吩咐你說什麼話，你都要說。',
    '耶1:8 你不要懼怕他們，因為我與你同在，要拯救你。這是耶和華說的。',
    '耶1:9 於是耶和華伸手按我的口，對我說：我已將當說的話傳給你。',
    '耶1:10 看哪，我今日立你在列邦列國之上，為要施行拔出、拆毀、毀壞、傾覆，又要建立、栽植。',
    '耶1:11 耶和華的話又臨到我說：耶利米，你看見什麼﹖我說：我看見一根杏樹枝。',
    '耶1:12 耶和華對我說：你看得不錯；因為我留意保守我的話，使得成就。',
    '耶1:13 耶和華的話第二次臨到我說：你看見什麼﹖我說：我看見一個燒開的鍋，從北而傾。',
    '耶1:14 耶和華對我說：必有災禍從北方發出，臨到這地的一切居民。',
    '耶1:15 耶和華說：看哪，我要召北方列國的眾族；他們要來，各安座位在耶路撒冷的城門口，周圍攻擊城牆，又要攻擊猶大的一切城邑。',
    '耶1:16 至於這民的一切惡，就是離棄我、向別神燒香、跪拜自己手所造的，我要發出我的判語，攻擊他們。',
    '耶1:17 所以你當束腰，起來將我所吩咐你的一切話告訴他們；不要因他們驚惶，免得我使你在他們面前驚惶。',
    '耶1:18 看哪，我今日使你成為堅城、鐵柱、銅牆，與全地和猶大的君王、首領、祭司，並地上的眾民反對。',
    '耶1:19 他們要攻擊你，卻不能勝你；因為我與你同在，要拯救你。這是耶和華說的。',
    '耶2:1 耶和華的話臨到我說：',
    '耶2:2 你去向耶路撒冷人的耳中喊叫說，耶和華如此說：你幼年的恩愛，婚姻的愛情，你怎樣在曠野，在未曾耕種之地跟隨我，我都記得。',
    '耶2:3 那時以色列歸耶和華為聖，作為土產初熟的果子；凡吞吃他的必算為有罪，災禍必臨到他們。這是耶和華說的。',
    '耶2:4 雅各家、以色列家的各族啊，你們當聽耶和華的話。',
    '耶2:5 耶和華如此說：你們的列祖見我有什麼不義，竟遠離我，隨從虛無的神，自己成為虛妄的呢﹖',
    '耶2:6 他們也不說：那領我們從埃及地上來，引導我們經過曠野，沙漠有深坑之地，和乾旱死蔭、無人經過、無人居住之地的耶和華在哪裡呢﹖',
    '耶2:7 我領你們進入肥美之地，使你們得吃其中的果子和美物；但你們進入的時候就玷污我的地，使我的產業成為可憎的。',
    '耶2:8 祭司都不說，耶和華在哪裡呢﹖傳講律法的都不認識我。官長違背我；先知藉巴力說預言，隨從無益的神。',
    '耶2:9 耶和華說：我因此必與你們爭辯，也必與你們的子孫爭辯。',
    '耶2:10 你們且過到基提海島去察看，打發人往基達去留心查考，看曾有這樣的事沒有。',
    '耶2:11 豈有一國換了他的神嗎﹖其實這不是神！但我的百姓將他們的榮耀換了那無益的神。',
    '耶2:12 諸天哪，要因此驚奇，極其恐慌，甚為淒涼！這是耶和華說的。',
    '耶2:13 因為我的百姓做了兩件惡事，就是離棄我這活水的泉源，為自己鑿出池子，是破裂不能存水的池子。',
    '耶2:14 以色列是僕人嗎﹖是家中生的奴僕嗎﹖為何成為掠物呢﹖',
    '耶2:15 少壯獅子向他咆哮，大聲吼叫，使他的地荒涼；城邑也都焚燒，無人居住。',
    '耶2:16 挪弗人和答比匿人也打破你的頭頂。',
    '耶2:17 這事臨到你身上，不是你自招的嗎﹖不是因耶和華─你神引你行路的時候，你離棄他嗎﹖',
    '耶2:18 現今你為何在埃及路上要喝西曷的水呢﹖你為何在亞述路上要喝大河的水呢﹖',
    '耶2:19 你自己的惡必懲治你；你背道的事必責備你。由此可知可見，你離棄耶和華─你的神，不存敬畏我的心，乃為惡事，為苦事。這是主─萬軍之耶和華說的。',
    '耶2:20 我在古時折斷你的軛，解開你的繩索。你說：我必不事奉耶和華；因為你在各高岡上、各青翠樹下屈身行淫（或譯：我在古時折斷你的軛，解開你的繩索，你就說：我必不事奉別神。誰知你在各高岡上、各青翠樹下仍屈身行淫）。',
    '耶2:21 然而，我栽你是上等的葡萄樹，全然是真種子；你怎麼向我變為外邦葡萄樹的壞枝子呢﹖',
    '耶2:22 你雖用鹼、多用肥皂洗濯，你罪孽的痕跡仍然在我面前顯出。這是主耶和華說的。',
    '耶2:23 你怎能說：我沒有玷污、沒有隨從眾巴力﹖你看你谷中的路，就知道你所行的如何。你是快行的獨峰駝，狂奔亂走。',
    '耶2:24 你是野驢，慣在曠野，慾心發動就吸風；起性的時候誰能使他轉去呢﹖凡尋找他的必不致疲乏；在他的月分必能尋見。',
    '耶2:25 我說：你不要使腳上無鞋，喉嚨乾渴。你倒說：這是枉然。我喜愛別神，我必隨從他們。',
    '耶2:26 賊被捉拿，怎樣羞愧，以色列家和他們的君王、首領、祭司、先知也都照樣羞愧。',
    '耶2:27 他們向木頭說：你是我的父；向石頭說：你是生我的。他們以背向我，不以面向我；及至遭遇患難的時候卻說：起來拯救我們。',
    '耶2:28 你為自己做的神在哪裡呢﹖你遭遇患難的時候，叫他們起來拯救你吧！猶大啊，你神的數目與你城的數目相等。',
    '耶2:29 耶和華說：你們為何與我爭辯呢﹖你們都違背了我。',
    '耶2:30 我責打你們的兒女是徒然的，他們不受懲治。你們自己的刀吞滅你們的先知，好像殘害的獅子。',
    '耶2:31 這世代的人哪，你們要看明耶和華的話。我豈向以色列作曠野呢﹖或作幽暗之地呢﹖我的百姓為何說：我們脫離約束，再不歸向你了﹖',
    '耶2:32 處女豈能忘記他的妝飾呢﹖新婦豈能忘記他的美衣呢﹖我的百姓卻忘記了我無數的日子！',
    '耶2:33 你怎麼修飾你的道路要求愛情呢﹖就是惡劣的婦人你也叫他們行你的路。',
    '耶2:34 並且你的衣襟上有無辜窮人的血；你殺他們並不是遇見他們挖窟窿，乃是因這一切的事。',
    '耶2:35 你還說：我無辜；耶和華的怒氣必定向我消了。看哪，我必審問你；因你自說：我沒有犯罪。',
    '耶2:36 你為何東跑西奔要更換你的路呢﹖你必因埃及蒙羞，像從前因亞述蒙羞一樣。',
    '耶2:37 你也必兩手抱頭從埃及出來；因為耶和華已經棄絕你所倚靠的，你必不因他們得順利。',
    '耶3:1 有話說：人若休妻，妻離他而去，作了別人的妻，前夫豈能再收回他來﹖若收回他來，那地豈不是大大玷污了嗎﹖但你和許多親愛的行邪淫，還可以歸向我。這是耶和華說的。',
    '耶3:2 你向淨光的高處舉目觀看，你在何處沒有淫行呢﹖你坐在道旁等候，好像亞拉伯人在曠野埋伏一樣，並且你的淫行邪惡玷污了全地。',
    '耶3:3 因此甘霖停止，春（原文是晚）雨不降。你還是有娼妓之臉，不顧羞恥。',
    '耶3:4 從今以後，你豈不向我呼叫說：我父啊，你是我幼年的恩主。',
    '耶3:5 耶和華豈永遠懷怒，存留到底嗎﹖看哪，你又發惡言又行壞事，隨自己的私意而行（或譯：你雖這樣說，還是行惡放縱慾心）。',
    '耶3:6 約西亞王在位的時候，耶和華又對我說：背道的以色列所行的，你看見沒有﹖他上各高山，在各青翠樹下行淫。',
    '耶3:7 他行這些事以後，我說他必歸向我，他卻不歸向我。他奸詐的妹妹猶大也看見了。',
    '耶3:8 背道的以色列行淫，我為這緣故給他休書休他；我看見他奸詐的妹妹猶大，還不懼怕，也去行淫。',
    '耶3:9 因以色列輕忽了他的淫亂，和石頭木頭行淫，地就被玷污了。',
    '耶3:10 雖有這一切的事，他奸詐的妹妹猶大還不一心歸向我，不過是假意歸我。這是耶和華說的。',
    '耶3:11 耶和華對我說：背道的以色列比奸詐的猶大還顯為義。',
    '耶3:12 你去向北方宣告說：耶和華說：背道的以色列啊，回來吧！我必不怒目看你們；因為我是慈愛的，我必不永遠存怒。這是耶和華說的。',
    '耶3:13 只要承認你的罪孽，就是你違背耶和華─你的神，在各青翠樹下向別神東奔西跑，沒有聽從我的話。這是耶和華說的。',
    '耶3:14 耶和華說：背道的兒女啊，回來吧！因為我作你們的丈夫，並且我必將你們從一城取一人，從一族取兩人，帶到錫安。',
    '耶3:15 我也必將合我心的牧者賜給你們。他們必以知識和智慧牧養你們。',
    '耶3:16 耶和華說：你們在國中生養眾多；當那些日子，人必不再提說耶和華的約櫃，不追想，不記念，不覺缺少，也不再製造。',
    '耶3:17 那時，人必稱耶路撒冷為耶和華的寶座；萬國必到耶路撒冷，在耶和華立名的地方聚集。他們必不再隨從自己頑梗的惡心行事。',
    '耶3:18 當那些日子，猶大家要和以色列家同行，從北方之地一同來到我賜給你們列祖為業之地。',
    '耶3:19 我說：我怎樣將你安置在兒女之中，賜給你美地，就是萬國中肥美的產業。我又說：你們必稱我為父，也不再轉去不跟從我。',
    '耶3:20 以色列家，你們向我行詭詐，真像妻子行詭詐離開他丈夫一樣。這是耶和華說的。',
    '耶3:21 在淨光的高處聽見人聲，就是以色列人哭泣懇求之聲，乃因他們走彎曲之道，忘記耶和華─他們的神。',
    '耶3:22 你們這背道的兒女啊，回來吧！我要醫治你們背道的病。看哪，我們來到你這裡，因你是耶和華─我們的神。',
    '耶3:23 仰望從小山或從大山的喧嚷中得幫助，真是枉然的。以色列得救，誠然在乎耶和華─我們的神。',
    '耶3:24 從我們幼年以來，那可恥的偶像將我們列祖所勞碌得來的羊群、牛群，和他們的兒女都吞吃了。',
    '耶3:25 我們在羞恥中躺臥吧！願慚愧將我們遮蓋；因為從立國（原文是幼年）以來，我們和我們的列祖常常得罪耶和華─我們的神，沒有聽從耶和華─我們神的話。',
    '耶4:1 耶和華說：以色列啊，你若回來歸向我，若從我眼前除掉你可憎的偶像，你就不被遷移。',
    '耶4:2 你必憑誠實、公平、公義，指著永生的耶和華起誓；列國必因耶和華稱自己為有福，也必因他誇耀。',
    '耶4:3 耶和華對猶大和耶路撒冷人如此說：要開墾你們的荒地，不要撒種在荊棘中。',
    '耶4:4 猶大人和耶路撒冷的居民哪，你們當自行割禮，歸耶和華，將心裡的污穢除掉；恐怕我的忿怒因你們的惡行發作，如火著起，甚至無人能以熄滅！',
    '耶4:5 你們當傳揚在猶大，宣告在耶路撒冷說：你們當在國中吹角，高聲呼叫說：你們當聚集！我們好進入堅固城！',
    '耶4:6 應當向錫安豎立大旗。要逃避，不要遲延，因我必使災禍與大毀滅從北方來到。',
    '耶4:7 有獅子從密林中上來，是毀壞列國的。他已經動身出離本處，要使你的地荒涼，使你的城邑變為荒場無人居住。',
    '耶4:8 因此，你們當腰束麻布，大聲哀號，因為耶和華的烈怒沒有向我們轉消。',
    '耶4:9 耶和華說：到那時，君王和首領的心都要消滅；祭司都要驚奇，先知都要詫異。',
    '耶4:10 我說：哀哉！主耶和華啊，你真是大大地欺哄這百姓和耶路撒冷，說：你們必得平安。其實刀劍害及性命了。',
    '耶4:11 那時，必有話對這百姓和耶路撒冷說：有一陣熱風從曠野淨光的高處向我的眾民（原文是民女）颳來，不是為簸揚，也不是為揚淨。',
    '耶4:12 必有一陣更大的風從這些地方為我颳來；現在我又必發出判語，攻擊他們。',
    '耶4:13 看哪，仇敵必如雲上來；他的戰車如旋風，他的馬匹比鷹更快。我們有禍了！我們敗落了！',
    '耶4:14 耶路撒冷啊，你當洗去心中的惡，使你可以得救。惡念存在你心裡要到幾時呢﹖',
    '耶4:15 有聲音從但傳揚，從以法蓮山報禍患。',
    '耶4:16 你們當傳給列國，報告攻擊耶路撒冷的事說：有探望的人從遠方來到，向猶大的城邑大聲吶喊。',
    '耶4:17 他們周圍攻擊耶路撒冷，好像看守田園的，因為他背叛了我。這是耶和華說的。',
    '耶4:18 你的行動，你的作為，招惹這事；這是你罪惡的結果，實在是苦，是害及你心了！',
    '耶4:19 我的肺腑啊，我的肺腑啊，我心疼痛！我心在我裡面煩躁不安。我不能靜默不言，因為我已經聽見角聲和打仗的喊聲。',
    '耶4:20 毀壞的信息連絡不絕，因為全地荒廢。我的帳棚忽然毀壞；我的幔子頃刻破裂。',
    '耶4:21 我看見大旗，聽見角聲，要到幾時呢﹖',
    '耶4:22 耶和華說：我的百性愚頑，不認識我；他們是愚昧無知的兒女，有智慧行惡，沒有知識行善。',
    '耶4:23 先知說：我觀看地，不料，地是空虛混沌；我觀看天，天也無光。',
    '耶4:24 我觀看大山，不料，盡都震動，小山也都搖來搖去。',
    '耶4:25 我觀看，不料，無人；空中的飛鳥也都躲避。',
    '耶4:26 我觀看，不料，肥田變為荒地；一切城邑在耶和華面前，因他的烈怒都被拆毀。',
    '耶4:27 耶和華如此說：全地必然荒涼，我卻不毀滅淨盡。',
    '耶4:28 因此，地要悲哀，在上的天也必黑暗；因為我言已出，我意已定，必不後悔，也不轉意不做。',
    '耶4:29 各城的人因馬兵和弓箭手的響聲就都逃跑，進入密林，爬上磐石；各城被撇下，無人住在其中。',
    '耶4:30 你淒涼的時候要怎樣行呢﹖你雖穿上朱紅衣服，佩戴黃金裝飾，用顏料修飾眼目，這樣標緻是枉然的！戀愛你的藐視你，並且尋索你的性命。',
    '耶4:31 我聽見有聲音，彷彿婦人產難的聲音，好像生頭胎疼痛的聲音，是錫安女子（就是指民的意思）的聲音；他喘著氣、挓挱手，說：我有禍了！在殺人的跟前，我的心發昏了。',
    '耶5:1 你們當在耶路撒冷的街上跑來跑去，在寬闊處尋找，看看有一人行公義求誠實沒有﹖若有，我就赦免這城。',
    '耶5:2 其中的人雖然指著永生的耶和華起誓，所起的誓實在是假的。',
    '耶5:3 耶和華啊，你的眼目不是看顧誠實嗎﹖你擊打他們，他們卻不傷慟；你毀滅他們，他們仍不受懲治。他們使臉剛硬過於磐石，不肯回頭。',
    '耶5:4 我說：這些人實在是貧窮的，是愚昧的，因為不曉得耶和華的作為和他們神的法則。',
    '耶5:5 我要去見尊大的人，對他們說話，因為他們曉得耶和華的作為和他們神的法則。哪知，這些人齊心將軛折斷，掙開繩索。',
    '耶5:6 因此，林中的獅子必害死他們；晚上（或譯：野地）的豺狼必滅絕他們；豹子要在城外窺伺他們。凡出城的必被撕碎；因為他們的罪過極多，背道的事也加增了。',
    '耶5:7 我怎能赦免你呢﹖你的兒女離棄我，又指著那不是神的起誓。我使他們飽足，他們就行姦淫，成群地聚集在娼妓家裡。',
    '耶5:8 他們像餵飽的馬到處亂跑，各向他鄰舍的妻發嘶聲。',
    '耶5:9 耶和華說：我豈不因這些事討罪呢﹖豈不報復這樣的國民呢﹖',
    '耶5:10 你們要上他葡萄園的牆施行毀壞，但不可毀壞淨盡，只可除掉他的枝子，因為不屬耶和華。',
    '耶5:11 原來以色列家和猶大家大行詭詐攻擊我。這是耶和華說的。',
    '耶5:12 他們不認耶和華，說：這並不是他，災禍必不臨到我們；刀劍和饑荒，我們也看不見。',
    '耶5:13 先知的話必成為風；道也不在他們裡面。這災必臨到他們身上。',
    '耶5:14 所以耶和華─萬軍之神如此說：因為百姓說這話，我必使我的話在你口中為火，使他們為柴；這火便將他們燒滅。',
    '耶5:15 耶和華說：以色列家啊，我必使一國的民從遠方來攻擊你，是強盛的國，是從古而有的國。他們的言語你不曉得，他們的話你不明白。',
    '耶5:16 他們的箭袋是敞開的墳墓；他們都是勇士。',
    '耶5:17 他們必吃盡你的莊稼和你的糧食，是你兒女該吃的；必吃盡你的牛羊，吃盡你的葡萄和無花果；又必用刀毀壞你所倚靠的堅固城。',
    '耶5:18 耶和華說：就是到那時，我也不將你們毀滅淨盡。',
    '耶5:19 百姓若說：耶和華─我們的神為什麼向我們行這一切事呢﹖你就對他們說：你們怎樣離棄耶和華（原文是我），在你們的地上事奉外邦神，也必照樣在不屬你們的地上事奉外邦人。',
    '耶5:20 當傳揚在雅各家，報告在猶大說：',
    '耶5:21 愚昧無知的百姓啊，你們有眼不看，有耳不聽，現在當聽這話。',
    '耶5:22 耶和華說：你們怎麼不懼怕我呢﹖我以永遠的定例，用沙為海的界限，水不得越過。因此，你們在我面前還不戰兢嗎﹖波浪雖然翻騰，卻不能逾越；雖然匉訇，卻不能過去。',
    '耶5:23 但這百姓有背叛忤逆的心；他們叛我而去，',
    '耶5:24 心內也不說：我們應當敬畏耶和華─我們的神；他按時賜雨，就是秋雨春雨，又為我們定收割的節令，永存不廢。',
    '耶5:25 你們的罪孽使這些事轉離你們；你們的罪惡使你們不能得福。',
    '耶5:26 因為在我民中有惡人。他們埋伏窺探，好像捕鳥的人；他們設立圈套陷害人。',
    '耶5:27 籠內怎樣滿了雀鳥，他們的房中也照樣充滿詭詐；所以他們得成為大，而且富足。',
    '耶5:28 他們肥胖光潤，作惡過甚，不為人伸冤！就是不為孤兒伸冤，不使他亨通，也不為窮人辨屈。',
    '耶5:29 耶和華說：我豈不因這些事討罪呢﹖豈不報復這樣的國民呢﹖',
    '耶5:30 國中有可驚駭、可憎惡的事：',
    '耶5:31 就是先知說假預言，祭司藉他們把持權柄；我的百姓也喜愛這些事，到了結局你們怎樣行呢﹖',
    '耶6:1 便雅憫人哪，你們要逃出耶路撒冷，在提哥亞吹角，在伯‧哈基琳立號旗；因為有災禍與大毀滅從北方張望。',
    '耶6:2 那秀美嬌嫩的錫安女子（就是指民的意思），我必剪除。',
    '耶6:3 牧人必引他們的羊群到他那裡，在他周圍支搭帳棚，各在自己所佔之地使羊吃草。',
    '耶6:4 你們要準備攻擊他。起來吧，我們可以趁午時上去。哀哉！日已漸斜，晚影拖長了。',
    '耶6:5 起來吧，我們夜間上去，毀壞他的宮殿。',
    '耶6:6 因為萬軍之耶和華如此說：你們要砍伐樹木，築壘攻打耶路撒冷。這就是那該罰的城，其中盡是欺壓。',
    '耶6:7 井怎樣湧出水來，這城也照樣湧出惡來；在其間常聽見有強暴毀滅的事，病患損傷也常在我面前。',
    '耶6:8 耶路撒冷啊，你當受教，免得我心與你生疏，免得我使你荒涼，成為無人居住之地。',
    '耶6:9 萬軍之耶和華曾如此說：敵人必擄盡以色列剩下的民，如同摘淨葡萄一樣。你要像摘葡萄的人摘了又摘，回手放在筐子裡。',
    '耶6:10 現在我可以向誰說話作見證，使他們聽呢﹖他們的耳朵未受割禮，不能聽見。看哪，耶和華的話他們以為羞辱，不以為喜悅。',
    '耶6:11 因此我被耶和華的忿怒充滿，難以含忍。我要傾在街中的孩童和聚會的少年人身上，連夫帶妻，並年老的與日子滿足的都必被擒拿。',
    '耶6:12 他們的房屋、田地，和妻子都必轉歸別人；我要伸手攻擊這地的居民。這是耶和華說的。',
    '耶6:13 因為他們從最小的到至大的都一味地貪婪，從先知到祭司都行事虛謊。',
    '耶6:14 他們輕輕忽忽地醫治我百姓的損傷，說：平安了！平安了！其實沒有平安。',
    '耶6:15 他們行可憎的事知道慚愧嗎﹖不然，他們毫不慚愧，也不知羞恥。因此，他們必在仆倒的人中仆倒；我向他們討罪的時候，他們必致跌倒。這是耶和華說的。',
    '耶6:16 耶和華如此說：你們當站在路上察看，訪問古道，哪是善道，便行在其間；這樣，你們心裡必得安息。他們卻說：我們不行在其間。',
    '耶6:17 我設立守望的人照管你們，說：要聽角聲。他們卻說：我們不聽。',
    '耶6:18 列國啊，因此你們當聽！會眾啊，要知道他們必遭遇的事。',
    '耶6:19 地啊，當聽！我必使災禍臨到這百姓，就是他們意念所結的果子；因為他們不聽從我的言語，至於我的訓誨（或譯：律法），他們也厭棄了。',
    '耶6:20 從示巴出的乳香，從遠方出的菖蒲（或譯：甘蔗）奉來給我有何益呢﹖你們的燔祭不蒙悅納；你們的平安祭，我也不喜悅。',
    '耶6:21 所以耶和華如此說：我要將絆腳石放在這百姓前面。父親和兒子要一同跌在其上；鄰舍與朋友也都滅亡。',
    '耶6:22 耶和華如此說：看哪，有一種民從北方而來，並有一大國被激動，從地極來到。',
    '耶6:23 他們拿弓和槍，性情殘忍，不施憐憫；他們的聲音像海浪匉訇。錫安城（原文是女子）啊，他們騎馬都擺隊伍，如上戰場的人要攻擊你。',
    '耶6:24 我們聽見他們的風聲，手就發軟；痛苦將我們抓住，疼痛彷彿產難的婦人。',
    '耶6:25 你們不要往田野去，也不要行在路上，因四圍有仇敵的刀劍和驚嚇。',
    '耶6:26 我民（原文是民女）哪，應當腰束麻布，滾在灰中。你要悲傷，如喪獨生子痛痛哭號，因為滅命的要忽然臨到我們。',
    '耶6:27 我使你在我民中為高臺（或譯：試驗人的），為保障，使你知道試驗他們的行動。',
    '耶6:28 他們都是極悖逆的，往來讒謗人。他們是銅是鐵，都行壞事。',
    '耶6:29 風箱吹火，鉛被燒毀；他們煉而又煉，終是徒然；因為惡劣的還未除掉。',
    '耶6:30 人必稱他們為被棄的銀渣，因為耶和華已經棄掉他們。',
    '耶7:1 耶和華的話臨到耶利米說：',
    '耶7:2 你當站在耶和華殿的門口，在那裡宣傳這話說：你們進這些門敬拜耶和華的一切猶大人，當聽耶和華的話。',
    '耶7:3 萬軍之耶和華─以色列的神如此說：你們改正行動作為，我就使你們在這地方仍然居住。',
    '耶7:4 你們不要倚靠虛謊的話，說：這些是耶和華的殿，是耶和華的殿，是耶和華的殿！',
    '耶7:5 你們若實在改正行動作為，在人和鄰舍中間誠然施行公平，',
    '耶7:6 不欺壓寄居的和孤兒寡婦；在這地方不流無辜人的血，也不隨從別神陷害自己；',
    '耶7:7 我就使你們在這地方仍然居住，就是我古時所賜給你們列祖的地，直到永遠。',
    '耶7:8 看哪，你們倚靠虛謊無益的話。',
    '耶7:9 你們偷盜，殺害，姦淫，起假誓，向巴力燒香，並隨從素不認識的別神，',
    '耶7:10 且來到這稱為我名下的殿，在我面前敬拜；又說：我們可以自由了。你們這樣的舉動是要行那些可憎的事嗎﹖',
    '耶7:11 這稱為我名下的殿在你們眼中豈可看為賊窩嗎﹖我都看見了。這是耶和華說的。',
    '耶7:12 你們且往示羅去，就是我先前立為我名的居所，察看我因這百姓以色列的罪惡向那地所行的如何。',
    '耶7:13 耶和華說：現在因你們行了這一切的事，我也從早起來警戒你們，你們卻不聽從；呼喚你們，你們卻不答應。',
    '耶7:14 所以我要向這稱為我名下、你們所倚靠的殿，與我所賜給你們和你們列祖的地施行，照我從前向示羅所行的一樣。',
    '耶7:15 我必將你們從我眼前趕出，正如趕出你們的眾弟兄，就是以法蓮的一切後裔。',
    '耶7:16 所以，你不要為這百姓祈禱；不要為他們呼求禱告，也不要向我為他們祈求，因我不聽允你。',
    '耶7:17 他們在猶大城邑中和耶路撒冷街上所行的，你沒有看見嗎﹖',
    '耶7:18 孩子撿柴，父親燒火，婦女摶麵做餅，獻給天后，又向別神澆奠祭，惹我發怒。',
    '耶7:19 耶和華說：他們豈是惹我發怒呢﹖不是自己惹禍，以致臉上慚愧嗎﹖',
    '耶7:20 所以主耶和華如此說：看哪，我必將我的怒氣和忿怒傾在這地方的人和牲畜身上，並田野的樹木和地裡的出產上，必如火著起，不能熄滅。',
    '耶7:21 萬軍之耶和華─以色列的神如此說：你們將燔祭加在平安祭上，吃肉吧！',
    '耶7:22 因為我將你們列祖從埃及地領出來的那日，燔祭平安祭的事我並沒有提說，也沒有吩咐他們。',
    '耶7:23 我只吩咐他們這一件說：你們當聽從我的話，我就作你們的神，你們也作我的子民。你們行我所吩咐的一切道，就可以得福。',
    '耶7:24 他們卻不聽從，不側耳而聽，竟隨從自己的計謀和頑梗的惡心，向後不向前。',
    '耶7:25 自從你們列祖出埃及地的那日，直到今日，我差遣我的僕人眾先知到你們那裡去，每日從早起來差遣他們。',
    '耶7:26 你們卻不聽從，不側耳而聽，竟硬著頸項行惡，比你們列祖更甚。',
    '耶7:27 你要將這一切的話告訴他們，他們卻不聽從；呼喚他們，他們卻不答應。',
    '耶7:28 你要對他們說：這就是不聽從耶和華─他們神的話、不受教訓的國民；從他們的口中，誠實滅絕了。',
    '耶7:29 耶路撒冷啊，要剪髮拋棄，在淨光的高處舉哀；因為耶和華丟掉離棄了惹他忿怒的世代。',
    '耶7:30 耶和華說：猶大人行我眼中看為惡的事，將可憎之物設立在稱為我名下的殿中，污穢這殿。',
    '耶7:31 他們在欣嫩子谷建築陀斐特的邱壇，好在火中焚燒自己的兒女。這並不是我所吩咐的，也不是我心所起的意。',
    '耶7:32 耶和華說：因此，日子將到，這地方不再稱為陀斐特和欣嫩子谷，反倒稱為殺戮谷。因為要在陀斐特葬埋屍首，甚至無處可葬；',
    '耶7:33 並且這百姓的屍首必給空中的飛鳥和地上的野獸作食物，並無人鬨趕。',
    '耶7:34 那時，我必使猶大城邑中和耶路撒冷街上，歡喜和快樂的聲音，新郎和新婦的聲音，都止息了，因為地必成為荒場。',
    '耶8:1 耶和華說：到那時，人必將猶大王的骸骨和他首領的骸骨、祭司的骸骨、先知的骸骨，並耶路撒冷居民的骸骨，都從墳墓中取出來，',
    '耶8:2 拋散在日頭、月亮，和天上眾星之下，就是他們從前所喜愛、所事奉、所隨從、所求問、所敬拜的。這些骸骨不再收殮，不再葬埋，必在地面上成為糞土；',
    '耶8:3 並且這惡族所剩下的民在我所趕他們到的各處，寧可揀死不揀生。這是萬軍之耶和華說的。',
    '耶8:4 你要對他們說，耶和華如此說：人跌倒，不再起來嗎﹖人轉去，不再轉來嗎﹖',
    '耶8:5 這耶路撒冷的民，為何恆久背道呢﹖他們守定詭詐，不肯回頭。',
    '耶8:6 我留心聽，聽見他們說不正直的話。無人悔改惡行，說：我做的是什麼呢﹖他們各人轉奔己路，如馬直闖戰場。',
    '耶8:7 空中的鸛鳥知道來去的定期；斑鳩燕子與白鶴也守候當來的時令；我的百姓卻不知道耶和華的法則。',
    '耶8:8 你們怎麼說：我們有智慧，耶和華的律法在我們這裡﹖看哪，文士的假筆舞弄虛假。',
    '耶8:9 智慧人慚愧，驚惶，被擒拿；他們棄掉耶和華的話，心裡還有什麼智慧呢﹖',
    '耶8:10 所以我必將他們的妻子給別人，將他們的田地給別人為業；因為他們從最小的到至大的都一味地貪婪，從先知到祭司都行事虛謊。',
    '耶8:11 他們輕輕忽忽地醫治我百姓的損傷，說：平安了！平安了！其實沒有平安。',
    '耶8:12 他們行可憎的事知道慚愧嗎﹖不然，他們毫不慚愧，也不知羞恥。因此他們必在仆倒的人中仆倒；我向他們討罪的時候，他們必致跌倒。這是耶和華說的。',
    '耶8:13 耶和華說：我必使他們全然滅絕；葡萄樹上必沒有葡萄，無花果樹上必沒有果子，葉子也必枯乾。我所賜給他們的，必離開他們過去。',
    '耶8:14 我們為何靜坐不動呢﹖我們當聚集，進入堅固城，在那裡靜默不言；因為耶和華─我們的神使我們靜默不言，又將苦膽水給我們喝，都因我們得罪了耶和華。',
    '耶8:15 我們指望平安，卻得不著好處；指望痊癒的時候，不料，受了驚惶。',
    '耶8:16 聽見從但那裡敵人的馬噴鼻氣，他的壯馬發嘶聲，全地就都震動；因為他們來吞滅這地和其上所有的，吞滅這城與其中的居民。',
    '耶8:17 看哪，我必使毒蛇到你們中間，是不服法術的，必咬你們。這是耶和華說的。',
    '耶8:18 我有憂愁，願能自慰；我心在我裡面發昏。',
    '耶8:19 聽啊，是我百姓的哀聲從極遠之地而來，說：耶和華不在錫安嗎﹖錫安的王不在其中嗎﹖耶和華說：他們為什麼以雕刻的偶像和外邦虛無的神惹我發怒呢﹖',
    '耶8:20 麥秋已過，夏令已完，我們還未得救！',
    '耶8:21 先知說：因我百姓的損傷，我也受了損傷。我哀痛，驚惶將我抓住。',
    '耶8:22 在基列豈沒有乳香呢﹖在那裡豈沒有醫生呢﹖我百姓為何不得痊癒呢﹖',
    '耶9:1 但願我的頭為水，我的眼為淚的泉源，我好為我百姓（原文是民女；七節同）中被殺的人晝夜哭泣。',
    '耶9:2 惟願我在曠野有行路人住宿之處，使我可以離開我的民出去；因他們都是行姦淫的，是行詭詐的一黨。',
    '耶9:3 他們彎起舌頭像弓一樣，為要說謊話。他們在國中增長勢力，不是為行誠實，乃是惡上加惡，並不認識我。這是耶和華說的。',
    '耶9:4 你們各人當謹防鄰舍，不可信靠弟兄；因為弟兄盡行欺騙，鄰舍都往來讒謗人。',
    '耶9:5 他們各人欺哄鄰舍，不說真話；他們教舌頭學習說謊，勞勞碌碌地作孽。',
    '耶9:6 你的住處在詭詐的人中；他們因行詭詐，不肯認識我。這是耶和華說的。',
    '耶9:7 所以萬軍之耶和華如此說：看哪，我要將他們融化熬煉；不然，我因我百姓的罪該怎樣行呢﹖',
    '耶9:8 他們的舌頭是毒箭，說話詭詐；人與鄰舍口說和平話，心卻謀害他。',
    '耶9:9 耶和華說：我豈不因這些事討他們的罪呢﹖豈不報復這樣的國民呢﹖',
    '耶9:10 我要為山嶺哭泣悲哀，為曠野的草場揚聲哀號；因為都已乾焦，甚至無人經過。人也聽不見牲畜鳴叫，空中的飛鳥和地上的野獸都已逃去。',
    '耶9:11 我必使耶路撒冷變為亂堆，為野狗的住處，也必使猶大的城邑變為荒場，無人居住。',
    '耶9:12 誰是智慧人，可以明白這事﹖耶和華的口向誰說過，使他可以傳說﹖遍地為何滅亡，乾焦好像曠野，甚至無人經過呢﹖',
    '耶9:13 耶和華說：因為這百姓離棄我在他們面前所設立的律法，沒有遵行、也沒有聽從我的話；',
    '耶9:14 只隨從自己頑梗的心行事，照他們列祖所教訓的隨從眾巴力。',
    '耶9:15 所以萬軍之耶和華─以色列的神如此說：看哪，我必將茵蔯給這百姓吃，又將苦膽水給他們喝。',
    '耶9:16 我要把他們散在列邦中，就是他們和他們列祖素不認識的列邦。我也要使刀劍追殺他們，直到將他們滅盡。',
    '耶9:17 萬軍之耶和華如此說：你們應當思想，將善唱哀歌的婦女召來，又打發人召善哭的婦女來，',
    '耶9:18 叫他們速速為我們舉哀，使我們眼淚汪汪，使我們的眼皮湧出水來。',
    '耶9:19 因為聽見哀聲出於錫安，說：我們怎樣敗落了！我們大大地慚愧！我們撇下地土；人也拆毀了我們的房屋。',
    '耶9:20 婦女們哪，你們當聽耶和華的話，領受他口中的言語；又當教導你們的兒女舉哀，各人教導鄰舍唱哀歌。',
    '耶9:21 因為死亡上來，進了我們的窗戶，入了我們的宮殿；要從外邊剪除孩童，從街上剪除少年人。',
    '耶9:22 你當說，耶和華如此說：人的屍首必倒在田野像糞土，又像收割的人遺落的一把禾稼，無人收取。',
    '耶9:23 耶和華如此說：智慧人不要因他的智慧誇口，勇士不要因他的勇力誇口，財主不要因他的財物誇口。',
    '耶9:24 誇口的卻因他有聰明，認識我是耶和華，又知道我喜悅在世上施行慈愛、公平，和公義，以此誇口。這是耶和華說的。',
    '耶9:25 耶和華說：看哪，日子將到，我要刑罰一切受過割禮、心卻未受割禮的，',
    '耶9:26 就是埃及、猶大、以東、亞捫人、摩押人，和一切住在曠野剃周圍頭髮的；因為列國人都沒有受割禮，以色列人心中也沒有受割禮。',
    '耶10:1 以色列家啊，要聽耶和華對你們所說的話。',
    '耶10:2 耶和華如此說：你們不要效法列國的行為，也不要為天象驚惶，因列國為此事驚惶。',
    '耶10:3 眾民的風俗是虛空的；他們在樹林中用斧子砍伐一棵樹，匠人用手工造成偶像。',
    '耶10:4 他們用金銀妝飾他，用釘子和錘子釘穩，使他不動搖。',
    '耶10:5 他好像棕樹，是鏇成的，不能說話，不能行走，必須有人擡著。你們不要怕他；他不能降禍，也無力降福。',
    '耶10:6 耶和華啊，沒有能比你的！你本為大，有大能大力的名。',
    '耶10:7 萬國的王啊，誰不敬畏你﹖敬畏你本是合宜的；因為在列國的智慧人中，雖有政權的尊榮，也不能比你。',
    '耶10:8 他們盡都是畜類，是愚昧的。偶像的訓誨算什麼呢﹖偶像不過是木頭。',
    '耶10:9 有銀子打成片，是從他施帶來的，並有從烏法來的金子，都是匠人和銀匠的手工，又有藍色紫色料的衣服，都是巧匠的工作。',
    '耶10:10 惟耶和華是真神，是活神，是永遠的王。他一發怒，大地震動；他一惱恨，列國都擔當不起。',
    '耶10:11 （你們要對他們如此說：不是那創造天地的神，必從地上從天下被除滅！）',
    '耶10:12 耶和華用能力創造大地，用智慧建立世界，用聰明鋪張穹蒼。',
    '耶10:13 他一發聲，空中便有多水激動；他使雲霧從地極上騰；他造電隨雨而閃，從他府庫中帶出風來。',
    '耶10:14 各人都成了畜類，毫無知識；各銀匠都因他雕刻的偶像羞愧。他所鑄的偶像本是虛假的，其中並無氣息，',
    '耶10:15 都是虛無的，是迷惑人的工作；到追討的時候必被除滅。',
    '耶10:16 雅各的分不像這些，因他是造作萬有的主。以色列也是他產業的支派，萬軍之耶和華是他的名。',
    '耶10:17 受圍困的人哪，當收拾你的財物，從國中帶出去。',
    '耶10:18 因為耶和華如此說：這時候，我必將此地的居民，好像用機弦甩出去，又必加害在他們身上，使他們覺悟。',
    '耶10:19 民說：禍哉！我受損傷；我的傷痕極其重大。我卻說：這真是我的痛苦，必須忍受。',
    '耶10:20 我的帳棚毀壞；我的繩索折斷。我的兒女離我出去，沒有了。無人再支搭我的帳棚，掛起我的幔子。',
    '耶10:21 因為牧人都成為畜類，沒有求問耶和華，所以不得順利；他們的羊群也都分散。',
    '耶10:22 有風聲！看哪，敵人來了！有大擾亂從北方出來，要使猶大城邑變為荒涼，成為野狗的住處。',
    '耶10:23 耶和華啊，我曉得人的道路不由自己，行路的人也不能定自己的腳步。',
    '耶10:24 耶和華啊，求你從寬懲治我，不要在你的怒中懲治我，恐怕使我歸於無有。',
    '耶10:25 願你將忿怒傾在不認識你的列國中，和不求告你名的各族上；因為他們吞了雅各，不但吞了，而且滅絕，把他的住處變為荒場。',
    '耶11:1 耶和華的話臨到耶利米說：',
    '耶11:2 當聽這約的話，告訴猶大人和耶路撒冷的居民，',
    '耶11:3 對他們說，耶和華─以色列的神如此說：不聽從這約之話的人必受咒詛。',
    '耶11:4 這約是我將你們列祖從埃及地領出來、脫離鐵爐的那日所吩咐他們的，說：你們要聽從我的話，照我一切所吩咐的去行。這樣，你們就作我的子民，我也作你們的神；',
    '耶11:5 我好堅定向你們列祖所起的誓，給他們流奶與蜜之地，正如今日一樣。我就回答說：耶和華啊，阿們！',
    '耶11:6 耶和華對我說：你要在猶大城邑中和耶路撒冷街市上，宣告這一切話說：你們當聽從遵行這約的話。',
    '耶11:7 因為我將你們列祖從埃及地領出來的那日，直到今日，都是從早起來，切切誥誡他們說：你們當聽從我的話。',
    '耶11:8 他們卻不聽從，不側耳而聽，竟隨從自己頑梗的惡心去行。所以我使這約中一切咒詛的話臨到他們身上；這約是我吩咐他們行的，他們卻不去行。',
    '耶11:9 耶和華對我說：在猶大人和耶路撒冷居民中有同謀背叛的事。',
    '耶11:10 他們轉去效法他們的先祖，不肯聽我的話，犯罪作孽，又隨從別神，事奉他。以色列家和猶大家背了我與他們列祖所立的約。',
    '耶11:11 所以耶和華如此說：我必使災禍臨到他們，是他們不能逃脫的。他們必向我哀求，我卻不聽。',
    '耶11:12 那時，猶大城邑的人和耶路撒冷的居民要去哀求他們燒香所供奉的神；只是遭難的時候，這些神毫不拯救他們。',
    '耶11:13 猶大啊，你神的數目與你城的數目相等；你為那可恥的巴力所築燒香的壇也與耶路撒冷街道的數目相等。',
    '耶11:14 所以你不要為這百姓祈禱，不要為他們呼求禱告；因為他們遭難向我哀求的時候，我必不應允。',
    '耶11:15 我所親愛的，既行許多淫亂，聖肉也離了你，你在我殿中做什麼呢﹖你作惡就喜樂。',
    '耶11:16 從前耶和華給你起名叫青橄欖樹，又華美又結好果子；如今他用鬨嚷之聲，點火在其上，枝子也被折斷。',
    '耶11:17 原來栽培你的萬軍之耶和華已經說，要降禍攻擊你，是因以色列家和猶大家行惡，向巴力燒香，惹我發怒，是自作自受。',
    '耶11:18 耶和華指示我，我就知道；你將他們所行的給我指明。',
    '耶11:19 我卻像柔順的羊羔被牽到宰殺之地；我並不知道他們設計謀害我，說：我們把樹連果子都滅了吧！將他從活人之地剪除，使他的名不再被記念。',
    '耶11:20 按公義判斷、察驗人肺腑心腸的萬軍之耶和華啊，我卻要見你在他們身上報仇，因我將我的案件向你稟明了。',
    '耶11:21 所以，耶和華論到尋索你命的亞拿突人如此說：他們說：你不要奉耶和華的名說預言，免得你死在我們手中。',
    '耶11:22 所以萬軍之耶和華如此說：看哪，我必刑罰他們；他們的少年人必被刀劍殺死，他們的兒女必因饑荒滅亡，',
    '耶11:23 並且沒有餘剩的人留給他們；因為在追討之年，我必使災禍臨到亞拿突人。',
    '耶12:1 耶和華啊，我與你爭辯的時候，你顯為義；但有一件，我還要與你理論：惡人的道路為何亨通呢﹖大行詭詐的為何得安逸呢﹖',
    '耶12:2 你栽培了他們，他們也扎了根，長大，而且結果。他們的口是與你相近，心卻與你遠離。',
    '耶12:3 耶和華啊，你曉得我，看見我，察驗我向你是怎樣的心。求你將他們拉出來，好像將宰的羊，叫他們等候殺戮的日子。',
    '耶12:4 這地悲哀，通國的青草枯乾，要到幾時呢﹖因其上居民的惡行，牲畜和飛鳥都滅絕了。他們曾說：他看不見我們的結局。',
    '耶12:5 耶和華說：你若與步行的人同跑，尚且覺累，怎能與馬賽跑呢﹖你在平安之地，雖然安穩，在約但河邊的叢林要怎樣行呢﹖',
    '耶12:6 因為連你弟兄和你父家都用奸詐待你。他們也在你後邊大聲喊叫，雖向你說好話，你也不要信他們。',
    '耶12:7 我離了我的殿宇，撇棄我的產業，將我心裡所親愛的交在他仇敵的手中。',
    '耶12:8 我的產業向我如林中的獅子，他發聲攻擊我，因此我恨惡他。',
    '耶12:9 我的產業向我豈如斑點的鷙鳥呢﹖鷙鳥豈在他四圍攻擊他呢﹖你們要去聚集田野的百獸，帶來吞吃吧！',
    '耶12:10 許多牧人毀壞我的葡萄園，踐踏我的分，使我美好的分變為荒涼的曠野。',
    '耶12:11 他們使地荒涼；地既荒涼，便向我悲哀。全地荒涼，因無人介意。',
    '耶12:12 滅命的都來到曠野中一切淨光的高處；耶和華的刀從地這邊直到地那邊盡行殺滅。凡有血氣的都不得平安。',
    '耶12:13 他們種的是麥子，收的是荊棘；勞勞苦苦卻毫無益處。因耶和華的烈怒，你們必為自己的土產羞愧。',
    '耶12:14 耶和華如此說：一切惡鄰，就是佔據我使百姓以色列所承受產業的，我要將他們拔出本地，又要將猶大家從他們中間拔出來。',
    '耶12:15 我拔出他們以後，我必轉過來憐憫他們，把他們再帶回來，各歸本業，各歸故土。',
    '耶12:16 他們若殷勤學習我百姓的道，指著我的名起誓說：我指著永生的耶和華起誓，正如他們從前教我百姓指著巴力起誓，他們就必建立在我百姓中間。',
    '耶12:17 他們若是不聽，我必拔出那國，拔出而且毀滅。這是耶和華說的。',
    '耶13:1 耶和華對我如此說：你去買一根麻布帶子束腰，不可放在水中。',
    '耶13:2 我就照著耶和華的話，買了一根帶子束腰。',
    '耶13:3 耶和華的話第二次臨到我說：',
    '耶13:4 要拿著你所買的腰帶，就是你腰上的帶子，起來往伯拉河去，將腰帶藏在那裡的磐石穴中。',
    '耶13:5 我就去，照著耶和華所吩咐我的，將腰帶藏在伯拉河邊。',
    '耶13:6 過了多日，耶和華對我說：你起來往伯拉河去，將我吩咐你藏在那裡的腰帶取出來。',
    '耶13:7 我就往伯拉河去，將腰帶從我所藏的地方刨出來，見腰帶已經變壞，毫無用了。',
    '耶13:8 耶和華的話臨到我說：',
    '耶13:9 耶和華如此說：我必照樣敗壞猶大的驕傲和耶路撒冷的大驕傲。',
    '耶13:10 這惡民不肯聽我的話，按自己頑梗的心而行，隨從別神，事奉敬拜，他們也必像這腰帶變為無用。',
    '耶13:11 耶和華說：腰帶怎樣緊貼人腰，照樣，我也使以色列全家和猶大全家緊貼我，好叫他們屬我為子民，使我得名聲，得頌讚，得榮耀；他們卻不肯聽。',
    '耶13:12 所以你要對他們說：耶和華─以色列的神如此說：各罈都要盛滿了酒。他們必對你說：我們豈不確知各罈都要盛滿了酒呢﹖',
    '耶13:13 你就要對他們說：耶和華如此說：我必使這地的一切居民，就是坐大衛寶座的君王和祭司，與先知，並耶路撒冷的一切居民，都酩酊大醉。',
    '耶13:14 耶和華說：我要使他們彼此相碰，就是父與子彼此相碰；我必不可憐，不顧惜，不憐憫，以致滅絕他們。',
    '耶13:15 你們當聽，當側耳而聽。不要驕傲，因為耶和華已經說了。',
    '耶13:16 耶和華─你們的神未使黑暗來到，你們的腳未在昏暗山上絆跌之先，當將榮耀歸給他；免得你們盼望光明，他使光明變為死蔭，成為幽暗。',
    '耶13:17 你們若不聽這話，我必因你們的驕傲在暗地哭泣；我眼必痛哭流淚，因為耶和華的群眾被擄去了。',
    '耶13:18 你要對君王和太后說：你們當自卑，坐在下邊；因你們的頭巾，就是你們的華冠，已經脫落了。',
    '耶13:19 南方的城盡都關閉，無人開放；猶大全被擄掠，且擄掠淨盡。',
    '耶13:20 你們要舉目觀看從北方來的人。先前賜給你的群眾，就是你佳美的群眾，如今在哪裡呢﹖',
    '耶13:21 耶和華立你自己所交的朋友為首，轄制你，那時你還有什麼話說呢﹖痛苦豈不將你抓住像產難的婦人嗎﹖',
    '耶13:22 你若心裡說：這一切事為何臨到我呢﹖你的衣襟揭起，你的腳跟受傷，是因你的罪孽甚多。',
    '耶13:23 古實人豈能改變皮膚呢﹖豹豈能改變斑點呢﹖若能，你們這習慣行惡的便能行善了。',
    '耶13:24 所以我必用曠野的風吹散他們，像吹過的碎稭一樣。',
    '耶13:25 耶和華說：這是你所當得的，是我量給你的分；因為你忘記我，倚靠虛假（或譯：偶像）。',
    '耶13:26 所以我要揭起你的衣襟，蒙在你臉上，顯出你的醜陋。',
    '耶13:27 你那些可憎惡之事─就是在田野的山上行姦淫，發嘶聲，做淫亂的事─我都看見了。耶路撒冷啊，你有禍了！你不肯潔淨，還要到幾時呢﹖',
    '耶14:1 耶和華論到乾旱之災的話臨到耶利米：',
    '耶14:2 猶大悲哀，城門衰敗。眾人披上黑衣坐在地上；耶路撒冷的哀聲上達。',
    '耶14:3 他們的貴冑打發家僮打水；他們來到水池，見沒有水，就拿著空器皿，蒙羞慚愧，抱頭而回。',
    '耶14:4 耕地的也蒙羞抱頭；因為無雨降在地上，地都乾裂。',
    '耶14:5 田野的母鹿生下小鹿，就撇棄，因為無草。',
    '耶14:6 野驢站在淨光的高處，喘氣好像野狗；因為無草，眼目失明。',
    '耶14:7 耶和華啊，我們的罪孽雖然作見證告我們，還求你為你名的緣故行事。我們本是多次背道，得罪了你。',
    '耶14:8 以色列所盼望、在患難時作他救主的啊，你為何在這地像寄居的，又像行路的只住一宵呢﹖',
    '耶14:9 你為何像受驚的人，像不能救人的勇士呢﹖耶和華啊，你仍在我們中間；我們也稱為你名下的人，求你不要離開我們。',
    '耶14:10 耶和華對這百姓如此說：這百姓喜愛妄行（原文是飄流），不禁止腳步，所以耶和華不悅納他們。現今要記念他們的罪孽，追討他們的罪惡。',
    '耶14:11 耶和華又對我說：不要為這百姓祈禱求好處。',
    '耶14:12 他們禁食的時候，我不聽他們的呼求；他們獻燔祭和素祭，我也不悅納；我卻要用刀劍、饑荒、瘟疫滅絕他們。',
    '耶14:13 我就說：唉！主耶和華啊，那些先知常對他們說：你們必不看見刀劍，也不遭遇饑荒；耶和華要在這地方賜你們長久的平安。',
    '耶14:14 耶和華對我說：那些先知託我的名說假預言，我並沒有打發他們，沒有吩咐他們，也沒有對他們說話；他們向你們預言的，乃是虛假的異象和占卜，並虛無的事，以及本心的詭詐。',
    '耶14:15 所以耶和華如此說：論到託我名說預言的那些先知，我並沒有打發他們；他們還說這地不能有刀劍饑荒，其實那些先知必被刀劍饑荒滅絕。',
    '耶14:16 聽他們說預言的百姓必因饑荒刀劍拋在耶路撒冷的街道上，無人葬埋。他們連妻子帶兒女，都是如此。我必將他們的惡倒在他們身上（或譯：我必使他們罪惡的報應臨到他們身上）。',
    '耶14:17 你要將這話對他們說：願我眼淚汪汪，晝夜不息，因為我百姓（原文是民的處女）受了裂口破壞的大傷。',
    '耶14:18 我若出往田間，就見有被刀殺的；我若進入城內，就見有因饑荒患病的；連先知帶祭司在國中往來，也是毫無知識（或譯：不知怎樣才好）。',
    '耶14:19 你全然棄掉猶大嗎﹖你心厭惡錫安嗎﹖為何擊打我們，以致無法醫治呢﹖我們指望平安，卻得不著好處；指望痊癒，不料，受了驚惶。',
    '耶14:20 耶和華啊，我們承認自己的罪惡，和我們列祖的罪孽，因我們得罪了你。',
    '耶14:21 求你為你名的緣故，不厭惡我們，不辱沒你榮耀的寶座。求你追念，不要背了與我們所立的約。',
    '耶14:22 外邦人虛無的神中有能降雨的嗎﹖天能自降甘霖嗎﹖耶和華─我們的神啊，能如此的不是你嗎﹖所以，我們仍要等候你，因為這一切都是你所造的。',
    '耶15:1 耶和華對我說：雖有摩西和撒母耳站在我面前代求，我的心也不顧惜這百姓。你將他們從我眼前趕出，叫他們去吧！',
    '耶15:2 他們問你說：我們往哪裡去呢﹖你便告訴他們，耶和華如此說：定為死亡的，必致死亡；定為刀殺的，必交刀殺；定為饑荒的，必遭饑荒；定為擄掠的，必被擄掠。',
    '耶15:3 耶和華說：我命定四樣害他們，就是刀劍殺戮、狗類撕裂、空中的飛鳥，和地上的野獸吞吃毀滅；',
    '耶15:4 又必使他們在天下萬國中拋來拋去，都因猶大王希西家的兒子瑪拿西在耶路撒冷所行的事。',
    '耶15:5 耶路撒冷啊，誰可憐你呢﹖誰為你悲傷呢﹖誰轉身問你的安呢﹖',
    '耶15:6 耶和華說：你棄絕了我，轉身退後；因此我伸手攻擊你，毀壞你。我後悔甚不耐煩。',
    '耶15:7 我在境內各城門口（或譯：我在這地邊界的關口），用簸箕簸了我的百姓，使他們喪掉兒女。我毀滅他們，他們仍不轉離所行的道。',
    '耶15:8 他們的寡婦在我面前比海沙更多；我使滅命的午間來，攻擊少年人的母親，使痛苦驚嚇忽然臨到他身上。',
    '耶15:9 生過七子的婦人力衰氣絕；尚在白晝，日頭忽落；他抱愧蒙羞。其餘的人，我必在他們敵人跟前，交與刀劍。這是耶和華說的。',
    '耶15:10 我的母親哪，我有禍了！因你生我作為遍地相爭相競的人。我素來沒有借貸與人，人也沒有借貸與我，人人卻都咒罵我。',
    '耶15:11 耶和華說：我必要堅固你，使你得好處。災禍苦難臨到的時候，我必要使仇敵央求你。',
    '耶15:12 （人豈能將銅與鐵，就是北方的鐵折斷呢﹖）',
    '耶15:13 我必因你在四境之內所犯的一切罪，把你的貨物財寶當掠物，白白地交給仇敵。',
    '耶15:14 我也必使仇敵帶這掠物到你所不認識的地去，因我怒中起的火要將你們焚燒。',
    '耶15:15 耶和華啊，你是知道的；求你記念我，眷顧我，向逼迫我的人為我報仇；不要向他們忍怒取我的命，要知道我為你的緣故受了凌辱。',
    '耶15:16 耶和華─萬軍之神啊，我得著你的言語就當食物吃了；你的言語是我心中的歡喜快樂，因我是稱為你名下的人。',
    '耶15:17 我沒有坐在宴樂人的會中，也沒有歡樂；我因你的感動（原文是手）獨自靜坐，因你使我滿心憤恨。',
    '耶15:18 我的痛苦為何長久不止呢﹖我的傷痕為何無法醫治、不能痊癒呢﹖難道你待我有詭詐，像流乾的河道嗎﹖',
    '耶15:19 耶和華如此說：你若歸回，我就將你再帶來，使你站在我面前；你若將寶貴的和下賤的分別出來，你就可以當作我的口。他們必歸向你，你卻不可歸向他們。',
    '耶15:20 我必使你向這百姓成為堅固的銅牆；他們必攻擊你，卻不能勝你；因我與你同在，要拯救你，搭救你。這是耶和華說的。',
    '耶15:21 我必搭救你脫離惡人的手，救贖你脫離強暴人的手。',
    '耶16:1 耶和華的話又臨到我說：',
    '耶16:2 你在這地方不可娶妻，生兒養女。',
    '耶16:3 因為論到在這地方所生的兒女，又論到在這國中生養他們的父母，耶和華如此說：',
    '耶16:4 他們必死得甚苦，無人哀哭，必不得葬埋，必在地上像糞土，必被刀劍和饑荒滅絕；他們的屍首必給空中的飛鳥和地上的野獸作食物。',
    '耶16:5 耶和華如此說：不要進入喪家，不要去哀哭，也不要為他們悲傷，因我已將我的平安、慈愛、憐憫從這百姓奪去了。這是耶和華說的。',
    '耶16:6 連大帶小，都必在這地死亡，不得葬埋。人必不為他們哀哭，不用刀劃身，也不使頭光禿。',
    '耶16:7 他們有喪事，人必不為他們擘餅，因死人安慰他們；他們喪父喪母，人也不給他們一杯酒安慰他們。',
    '耶16:8 你不可進入宴樂的家，與他們同坐吃喝。',
    '耶16:9 因為萬軍之耶和華─以色列的神如此說：你們還活著的日子在你們眼前，我必使歡喜和快樂的聲音，新郎和新婦的聲音，從這地方止息了。',
    '耶16:10 你將這一切的話指示這百姓。他們問你說：耶和華為什麼說，要降這大災禍攻擊我們呢﹖我們有什麼罪孽呢﹖我們向耶和華─我們的神犯了什麼罪呢﹖',
    '耶16:11 你就對他們說：耶和華說：因為你們列祖離棄我，隨從別神，事奉敬拜，不遵守我的律法，',
    '耶16:12 而且你們行惡比你們列祖更甚；因為各人隨從自己頑梗的惡心行事，甚至不聽從我，',
    '耶16:13 所以我必將你們從這地趕出，直趕到你們和你們列祖素不認識的地。你們在那裡必晝夜事奉別神，因為我必不向你們施恩。',
    '耶16:14 耶和華說：日子將到，人必不再指著那領以色列人從埃及地上來之永生的耶和華起誓，',
    '耶16:15 卻要指著那領以色列人從北方之地，並趕他們到的各國上來之永生的耶和華起誓，並且我要領他們再入我從前賜給他們列祖之地。',
    '耶16:16 耶和華說：我要召許多打魚的把以色列人打上來，然後我要召許多打獵的，從各山上、各岡上、各石穴中獵取他們。',
    '耶16:17 因我的眼目察看他們的一切行為；他們不能在我面前遮掩，他們的罪孽也不能在我眼前隱藏。',
    '耶16:18 我先要加倍報應他們的罪孽和罪惡；因為他們用可憎之屍玷污我的地土，又用可厭之物充滿我的產業。',
    '耶16:19 耶和華啊，你是我的力量，是我的保障；在苦難之日是我的避難所。列國人必從地極來到你這裡，說：我們列祖所承受的，不過是虛假，是虛空無益之物。',
    '耶16:20 人豈可為自己製造神呢﹖其實這不是神。',
    '耶16:21 耶和華說：我要使他們知道，就是這一次使他們知道我的手和我的能力。他們就知道我的名是耶和華了。',
    '耶17:1 猶大的罪是用鐵筆、用金鋼鑽記錄的，銘刻在他們的心版上和壇角上。',
    '耶17:2 他們的兒女記念他們高岡上、青翠樹旁的壇和木偶。',
    '耶17:3 我田野的山哪，我必因你在四境之內所犯的罪，把你的貨物、財寶，並邱壇當掠物交給仇敵；',
    '耶17:4 並且你因自己的罪必失去我所賜給你的產業。我也必使你在你所不認識的地上服事你的仇敵；因為你使我怒中起火，直燒到永遠。',
    '耶17:5 耶和華如此說：倚靠人血肉的膀臂，心中離棄耶和華的，那人有禍了！',
    '耶17:6 因他必像沙漠的杜松，不見福樂來到，卻要住曠野乾旱之處，無人居住的鹼地。',
    '耶17:7 倚靠耶和華、以耶和華為可靠的，那人有福了！',
    '耶17:8 他必像樹栽於水旁，在河邊扎根，炎熱來到，並不懼怕，葉子仍必青翠，在乾旱之年毫無掛慮，而且結果不止。',
    '耶17:9 人心比萬物都詭詐，壞到極處，誰能識透呢﹖',
    '耶17:10 我─耶和華是鑒察人心、試驗人肺腑的，要照各人所行的和他做事的結果報應他。',
    '耶17:11 那不按正道得財的，好像鷓鴣菢不是自己下的蛋；到了中年，那財都必離開他，他終久成為愚頑人。',
    '耶17:12 我們的聖所是榮耀的寶座，從太初安置在高處。',
    '耶17:13 耶和華─以色列的盼望啊，凡離棄你的必致蒙羞。耶和華說：離開我的，他們的名字必寫在土裡，因為他們離棄我這活水的泉源。',
    '耶17:14 耶和華啊，求你醫治我，我便痊癒，拯救我，我便得救；因你是我所讚美的。',
    '耶17:15 他們對我說：耶和華的話在哪裡呢﹖叫這話應驗吧！',
    '耶17:16 至於我，那跟從你作牧人的職分，我並沒有急忙離棄，也沒有想那災殃的日子；這是你知道的。我口中所出的言語都在你面前。',
    '耶17:17 不要使我因你驚恐；當災禍的日子，你是我的避難所。',
    '耶17:18 願那些逼迫我的蒙羞，卻不要使我蒙羞；使他們驚惶，卻不要使我驚惶；使災禍的日子臨到他們，以加倍的毀壞毀壞他們。',
    '耶17:19 耶和華對我如此說：你去站在平民的門口，就是猶大君王出入的門，又站在耶路撒冷的各門口，',
    '耶17:20 對他們說：你們這猶大君王和猶大眾人，並耶路撒冷的一切居民，凡從這些門進入的都當聽耶和華的話。',
    '耶17:21 耶和華如此說：你們要謹慎，不要在安息日擔什麼擔子進入耶路撒冷的各門；',
    '耶17:22 也不要在安息日從家中擔出擔子去。無論何工都不可做，只要以安息日為聖日，正如我所吩咐你們列祖的。',
    '耶17:23 他們卻不聽從，不側耳而聽，竟硬著頸項不聽，不受教訓。',
    '耶17:24 耶和華說：你們若留意聽從我，在安息日不擔什麼擔子進入這城的各門，只以安息日為聖日，在那日無論何工都不做；',
    '耶17:25 那時就有坐大衛寶座的君王和首領，他們與猶大人，並耶路撒冷的居民，或坐車，或騎馬，進入這城的各門，而且這城必存到永遠。',
    '耶17:26 也必有人從猶大城邑和耶路撒冷四圍的各處，從便雅憫地、高原、山地，並南地而來，都帶燔祭、平安祭、素祭，和乳香，並感謝祭，到耶和華的殿去。',
    '耶17:27 你們若不聽從我，不以安息日為聖日，仍在安息日擔擔子，進入耶路撒冷的各門，我必在各門中點火；這火也必燒毀耶路撒冷的宮殿，不能熄滅。',
    '耶18:1 耶和華的話臨到耶利米說：',
    '耶18:2 你起來，下到窰匠的家裡去，我在那裡要使你聽我的話。',
    '耶18:3 我就下到窰匠的家裡去，正遇他轉輪做器皿。',
    '耶18:4 窰匠用泥做的器皿，在他手中做壞了，他又用這泥另做別的器皿；窰匠看怎樣好，就怎樣做。',
    '耶18:5 耶和華的話就臨到我說：',
    '耶18:6 耶和華說：以色列家啊，我待你們，豈不能照這窰匠弄泥嗎﹖以色列家啊，泥在窰匠的手中怎樣，你們在我的手中也怎樣。',
    '耶18:7 我何時論到一邦或一國說，要拔出、拆毀、毀壞；',
    '耶18:8 我所說的那一邦，若是轉意離開他們的惡，我就必後悔，不將我想要施行的災禍降與他們。',
    '耶18:9 我何時論到一邦或一國說，要建立、栽植；',
    '耶18:10 他們若行我眼中看為惡的事，不聽從我的話，我就必後悔，不將我所說的福氣賜給他們。',
    '耶18:11 現在你要對猶大人和耶路撒冷的居民說：耶和華如此說：我造出災禍攻擊你們，定意刑罰你們。你們各人當回頭離開所行的惡道，改正你們的行動作為。',
    '耶18:12 他們卻說：這是枉然。我們要照自己的計謀去行。各人隨自己頑梗的惡心做事。',
    '耶18:13 所以，耶和華如此說：你們且往各國訪問，有誰聽見這樣的事﹖以色列民（原文是處女）行了一件極可憎惡的事。',
    '耶18:14 利巴嫩的雪從田野的磐石上豈能斷絕呢﹖從遠處流下的涼水豈能乾涸呢﹖',
    '耶18:15 我的百姓竟忘記我，向假神燒香，使他們在所行的路上，在古道上絆跌，使他們行沒有修築的斜路，',
    '耶18:16 以致他們的地令人驚駭，常常嗤笑；凡經過這地的必驚駭搖頭。',
    '耶18:17 我必在仇敵面前分散他們，好像用東風吹散一樣。遭難的日子，我必以背向他們，不以面向他們。',
    '耶18:18 他們就說：來吧！我們可以設計謀害耶利米；因為我們有祭司講律法，智慧人設謀略，先知說預言，都不能斷絕。來吧！我們可以用舌頭擊打他，不要理會他的一切話。',
    '耶18:19 耶和華啊，求你理會我，且聽那些與我爭競之人的話。',
    '耶18:20 豈可以惡報善呢﹖他們竟挖坑要害我的性命！求你記念我怎樣站在你面前為他們代求，要使你的忿怒向他們轉消。',
    '耶18:21 故此，願你將他們的兒女交與饑荒和刀劍；願他們的妻無子，且作寡婦；又願他們的男人被死亡所滅，他們的少年人在陣上被刀擊殺。',
    '耶18:22 你使敵軍忽然臨到他們的時候，願人聽見哀聲從他們的屋內發出；因他們挖坑要捉拿我，暗設網羅要絆我的腳。',
    '耶18:23 耶和華啊，他們要殺我的那一切計謀，你都知道。不要赦免他們的罪孽，也不要從你面前塗抹他們的罪惡，要叫他們在你面前跌倒；願你發怒的時候罰辦他們。',
    '耶19:1 耶和華如此說：你去買窰匠的瓦瓶，又帶百姓中的長老和祭司中的長老，',
    '耶19:2 出去到欣嫩子谷、哈珥西（就是瓦片的意思）的門口那裡，宣告我所吩咐你的話，',
    '耶19:3 說：猶大君王和耶路撒冷的居民哪，當聽耶和華的話。萬軍之耶和華─以色列的神如此說：我必使災禍臨到這地方，凡聽見的人都必耳鳴；',
    '耶19:4 因為他們和他們列祖，並猶大君王離棄我，將這地方看為平常，在這裡向素不認識的別神燒香，又使這地方滿了無辜人的血，',
    '耶19:5 又建築巴力的邱壇，好在火中焚燒自己的兒子，作為燔祭獻給巴力。這不是我所吩咐的，不是我所提說的，也不是我心所起的意。',
    '耶19:6 耶和華說：因此，日子將到，這地方不再稱為陀斐特和欣嫩子谷，反倒稱為殺戮谷。',
    '耶19:7 我必在這地方使猶大和耶路撒冷的計謀落空，也必使他們在仇敵面前倒於刀下，並尋索其命的人手下。他們的屍首，我必給空中的飛鳥和地上的野獸作食物。',
    '耶19:8 我必使這城令人驚駭嗤笑；凡經過的人，必因這城所遭的災驚駭嗤笑。',
    '耶19:9 我必使他們在圍困窘迫之中，就是仇敵和尋索其命的人窘迫他們的時候，各人吃自己兒女的肉和朋友的肉。',
    '耶19:10 你要在同去的人眼前打碎那瓶，',
    '耶19:11 對他們說：萬軍之耶和華如此說：我要照樣打碎這民和這城，正如人打碎窰匠的瓦器，以致不能再囫圇。並且人要在陀斐特葬埋屍首，甚至無處可葬。',
    '耶19:12 耶和華說：我必向這地方和其中的居民如此行，使這城與陀斐特一樣。',
    '耶19:13 耶路撒冷的房屋和猶大君王的宮殿是已經被玷污的，就是他們在其上向天上的萬象燒香、向別神澆奠祭的宮殿房屋，都必與陀斐特一樣。',
    '耶19:14 耶利米從陀斐特─就是耶和華差他去說預言的地方─回來，站在耶和華殿的院中，對眾人說：',
    '耶19:15 萬軍之耶和華─以色列的神如此說：我必使我所說的一切災禍臨到這城和屬城的一切城邑，因為他們硬著頸項不聽我的話。',
    '耶20:1 祭司音麥的兒子巴施戶珥作耶和華殿的總管，聽見耶利米預言這些事，',
    '耶20:2 他就打先知耶利米，用耶和華殿裡便雅憫高門內的枷，將他枷在那裡。',
    '耶20:3 次日，巴施戶珥將耶利米開枷釋放。於是耶利米對他說：耶和華不是叫你的名為巴施戶珥，乃是叫你瑪歌珥‧米撒畢（就是四面驚嚇的意思），',
    '耶20:4 因耶和華如此說：我必使你自覺驚嚇，你也必使眾朋友驚嚇；他們必倒在仇敵的刀下，你也必親眼看見；我必將猶大人全交在巴比倫王的手中，他要將他們擄到巴比倫去，也要用刀將他們殺戮。',
    '耶20:5 並且我要將這城中的一切貨財和勞碌得來的，並一切珍寶，以及猶大君王所有的寶物，都交在他們仇敵的手中；仇敵要當作掠物帶到巴比倫去。',
    '耶20:6 你這巴施戶珥和一切住在你家中的人都必被擄去；你和你的眾朋友，就是你向他們說假預言的，都必到巴比倫去，要死在那裡，葬在那裡。',
    '耶20:7 耶和華啊，你曾勸導我，我也聽了你的勸導。你比我有力量，且勝了我。我終日成為笑話，人人都戲弄我。',
    '耶20:8 我每逢講論的時候，就發出哀聲，我喊叫說：有強暴和毀滅！因為耶和華的話終日成了我的凌辱、譏刺。',
    '耶20:9 我若說：我不再提耶和華，也不再奉他的名講論，我便心裡覺得似乎有燒著的火閉塞在我骨中，我就含忍不住，不能自禁。',
    '耶20:10 我聽見了許多人的讒謗，四圍都是驚嚇；就是我知己的朋友也都窺探我，願我跌倒，說：告他吧，我們也要告他！或者他被引誘，我們就能勝他，在他身上報仇。',
    '耶20:11 然而，耶和華與我同在，好像甚可怕的勇士。因此，逼迫我的必都絆跌，不能得勝；他們必大大蒙羞，就是受永不忘記的羞辱，因為他們行事沒有智慧。',
    '耶20:12 試驗義人、察看人肺腑心腸的萬軍之耶和華啊，求你容我見你在他們身上報仇，因我將我的案件向你稟明了。',
    '耶20:13 你們要向耶和華唱歌；讚美耶和華！因他救了窮人的性命脫離惡人的手。',
    '耶20:14 願我生的那日受咒詛；願我母親產我的那日不蒙福！',
    '耶20:15 給我父親報信說你得了兒子，使我父親甚歡喜的，願那人受咒詛。',
    '耶20:16 願那人像耶和華所傾覆而不後悔的城邑；願他早晨聽見哀聲，晌午聽見吶喊；',
    '耶20:17 因他在我未出胎的時候不殺我，使我母親成了我的墳墓，胎就時常重大。',
    '耶20:18 我為何出胎見勞碌愁苦，使我的年日因羞愧消滅呢﹖',
    '耶21:1 耶和華的話臨到耶利米。那時，西底家王打發瑪基雅的兒子巴施戶珥和瑪西雅的兒子祭司西番雅去見耶利米，說：',
    '耶21:2 請你為我們求問耶和華；因為巴比倫王尼布甲尼撒來攻擊我們，或者耶和華照他一切奇妙的作為待我們，使巴比倫王離開我們上去。',
    '耶21:3 耶利米對他們說：你們當對西底家這樣說：',
    '耶21:4 耶和華─以色列的神如此說：我要使你們手中的兵器，就是你們在城外與巴比倫王和圍困你們的迦勒底人打仗的兵器翻轉過來，又要使這些都聚集在這城中。',
    '耶21:5 並且我要在怒氣、忿怒，和大惱恨中，用伸出來的手，並大能的膀臂，親自攻擊你們；',
    '耶21:6 又要擊打這城的居民，連人帶牲畜都必遭遇大瘟疫死亡。',
    '耶21:7 以後我要將猶大王西底家和他的臣僕百姓，就是在城內，從瘟疫、刀劍、饑荒中剩下的人，都交在巴比倫王尼布甲尼撒的手中和他們仇敵，並尋索其命的人手中。巴比倫王必用刀擊殺他們，不顧惜，不可憐，不憐憫。這是耶和華說的。',
    '耶21:8 你要對這百姓說：耶和華如此說：看哪，我將生命的路和死亡的路擺在你們面前。',
    '耶21:9 住在這城裡的必遭刀劍、饑荒、瘟疫而死；但出去歸降圍困你們迦勒底人的必得存活，要以自己的命為掠物。',
    '耶21:10 耶和華說：我向這城變臉，降禍不降福；這城必交在巴比倫王的手中，他必用火焚燒。',
    '耶21:11 至於猶大王的家，你們當聽耶和華的話。',
    '耶21:12 大衛家啊，耶和華如此說：你們每早晨要施行公平，拯救被搶奪的脫離欺壓人的手，恐怕我的忿怒因你們的惡行發作，如火著起，甚至無人能以熄滅。',
    '耶21:13 耶和華說：住山谷和平原磐石上的居民，你們說：誰能下來攻擊我們﹖誰能進入我們的住處呢﹖看哪，我與你們為敵。',
    '耶21:14 耶和華又說：我必按你們做事的結果刑罰你們；我也必使火在耶路撒冷的林中著起，將他四圍所有的盡行燒滅。',
    '耶22:1 耶和華如此說：你下到猶大王的宮中，在那裡說這話，',
    '耶22:2 說：坐大衛寶座的猶大王啊，你和你的臣僕，並進入城門的百姓，都當聽耶和華的話。',
    '耶22:3 耶和華如此說：你們要施行公平和公義，拯救被搶奪的脫離欺壓人的手，不可虧負寄居的和孤兒寡婦，不可以強暴待他們，在這地方也不可流無辜人的血。',
    '耶22:4 你們若認真行這事，就必有坐大衛寶座的君王和他的臣僕百姓，或坐車或騎馬，從這城的各門進入。',
    '耶22:5 你們若不聽這些話，耶和華說：我指著自己起誓，這城必變為荒場。',
    '耶22:6 耶和華論到猶大王的家如此說：我看你如基列，如利巴嫩頂；然而，我必使你變為曠野，為無人居住的城邑。',
    '耶22:7 我要預備行毀滅的人，各拿器械攻擊你；他們要砍下你佳美的香柏樹，扔在火中。',
    '耶22:8 許多國的民要經過這城，各人對鄰舍說：耶和華為何向這大城如此行呢﹖',
    '耶22:9 他們必回答說：是因離棄了耶和華─他們神的約，事奉敬拜別神。',
    '耶22:10 不要為死人哭號；不要為他悲傷，卻要為離家出外的人大大哭號；因為他不得再回來，也不得再見他的本國。',
    '耶22:11 因為耶和華論到從這地方出去的猶大王約西亞的兒子沙龍（在王下23：30名約哈斯），就是接續他父親約西亞作王的，這樣說：他必不得再回到這裡來，',
    '耶22:12 卻要死在被擄去的地方，必不得再見這地。',
    '耶22:13 那行不義蓋房、行不公造樓、白白使用人的手工不給工價的有禍了！',
    '耶22:14 他說：我要為自己蓋廣大的房、寬敞的樓，為自己開窗戶。這樓房的護牆板是香柏木的，樓房是丹色油漆的。',
    '耶22:15 難道你作王是在乎造香柏木樓房爭勝嗎﹖你的父親豈不是也吃也喝、也施行公平和公義嗎﹖那時他得了福樂。',
    '耶22:16 他為困苦和窮乏人伸冤，那時就得了福樂。認識我不在乎此嗎﹖這是耶和華說的。',
    '耶22:17 惟有你的眼和你的心專顧貪婪，流無辜人的血，行欺壓和強暴。',
    '耶22:18 所以，耶和華論到猶大王約西亞的兒子約雅敬如此說：人必不為他舉哀說：哀哉！我的哥哥；或說：哀哉！我的姊姊；也不為他舉哀說：哀哉！我的主；或說：哀哉！我主的榮華。',
    '耶22:19 他被埋葬，好像埋驢一樣，要拉出去扔在耶路撒冷的城門之外。',
    '耶22:20 你要上利巴嫩哀號，在巴珊揚聲，從亞巴琳哀號，因為你所親愛的都毀滅了。',
    '耶22:21 你興盛的時候，我對你說話；你卻說：我不聽。你自幼年以來總是這樣，不聽從我的話。',
    '耶22:22 你的牧人要被風吞吃，你所親愛的必被擄去；那時你必因你一切的惡抱愧蒙羞。',
    '耶22:23 你這住利巴嫩、在香柏樹上搭窩的，有痛苦臨到你，好像疼痛臨到產難的婦人，那時你何等可憐！',
    '耶22:24 耶和華說：猶大王約雅敬的兒子哥尼雅（又名耶哥尼雅；下同），雖是我右手上帶印的戒指，我憑我的永生起誓，也必將你從其上摘下來，',
    '耶22:25 並且我必將你交給尋索你命的人和你所懼怕的人手中，就是巴比倫王尼布甲尼撒和迦勒底人的手中。',
    '耶22:26 我也必將你和生你的母親趕到別國，並不是你們生的地方；你們必死在那裡，',
    '耶22:27 但心中甚想歸回之地，必不得歸回。',
    '耶22:28 哥尼雅這人是被輕看、破壞的器皿嗎﹖是無人喜愛的器皿嗎﹖他和他的後裔為何被趕到不認識之地呢﹖',
    '耶22:29 地啊，地啊，地啊，當聽耶和華的話！',
    '耶22:30 耶和華如此說：要寫明這人算為無子，是平生不得亨通的；因為他後裔中再無一人得亨通，能坐在大衛的寶座上治理猶大。',
    '耶23:1 耶和華說：那些殘害、趕散我草場之羊的牧人有禍了！',
    '耶23:2 耶和華─以色列的神斥責那些牧養他百姓的牧人，如此說：你們趕散我的羊群，並沒有看顧他們；我必討你們這行惡的罪。這是耶和華說的。',
    '耶23:3 我要將我羊群中所餘剩的，從我趕他們到的各國內招聚出來，領他們歸回本圈；他們也必生養眾多。',
    '耶23:4 我必設立照管他們的牧人，牧養他們。他們不再懼怕，不再驚惶，也不缺少一個；這是耶和華說的。',
    '耶23:5 耶和華說：日子將到，我要給大衛興起一個公義的苗裔；他必掌王權，行事有智慧，在地上施行公平和公義。',
    '耶23:6 在他的日子，猶大必得救，以色列也安然居住。他的名必稱為耶和華─我們的義。',
    '耶23:7 耶和華說：日子將到，人必不再指著那領以色列人從埃及地上來永生的耶和華起誓，',
    '耶23:8 卻要指著那領以色列家的後裔從北方和趕他們到的各國中上來、永生的耶和華起誓。他們必住在本地。',
    '耶23:9 論到那些先知，我心在我裡面憂傷，我骨頭都發顫；因耶和華和他的聖言，我像醉酒的人，像被酒所勝的人。',
    '耶23:10 地滿了行淫的人！因妄自賭咒，地就悲哀；曠野的草場都枯乾了。他們所行的道乃是惡的；他們的勇力使得不正。',
    '耶23:11 連先知帶祭司都是褻瀆的，就是在我殿中我也看見他們的惡。這是耶和華說的。',
    '耶23:12 因此，他們的道路必像黑暗中的滑地，他們必被追趕，在這路中仆倒；因為當追討之年，我必使災禍臨到他們。這是耶和華說的。',
    '耶23:13 我在撒瑪利亞的先知中曾見愚妄；他們藉巴力說預言，使我的百姓以色列走錯了路。',
    '耶23:14 我在耶路撒冷的先知中曾見可憎惡的事；他們行姦淫，做事虛妄，又堅固惡人的手，甚至無人回頭離開他的惡。他們在我面前都像所多瑪；耶路撒冷的居民都像蛾摩拉。',
    '耶23:15 所以萬軍之耶和華論到先知如此說：我必將茵蔯給他們吃，又將苦膽水給他們喝；因為褻瀆的事出於耶路撒冷的先知，流行遍地。',
    '耶23:16 萬軍之耶和華如此說：這些先知向你們說預言，你們不要聽他們的話。他們以虛空教訓你們，所說的異象是出於自己的心，不是出於耶和華的口。',
    '耶23:17 他們常對藐視我的人說：耶和華說：你們必享平安；又對一切按自己頑梗之心而行的人說：必沒有災禍臨到你們。',
    '耶23:18 有誰站在耶和華的會中得以聽見並會悟他的話呢﹖有誰留心聽他的話呢﹖',
    '耶23:19 看哪！耶和華的忿怒好像暴風，已經發出；是暴烈的旋風，必轉到惡人的頭上。',
    '耶23:20 耶和華的怒氣必不轉消，直到他心中所擬定的成就了。末後的日子你們要全然明白。',
    '耶23:21 我沒有打發那些先知，他們竟自奔跑；我沒有對他們說話，他們竟自預言。',
    '耶23:22 他們若是站在我的會中，就必使我的百姓聽我的話，又使他們回頭離開惡道和他們所行的惡。',
    '耶23:23 耶和華說：我豈為近處的神呢﹖不也為遠處的神嗎﹖',
    '耶23:24 耶和華說：人豈能在隱密處藏身，使我看不見他呢﹖耶和華說：我豈不充滿天地嗎﹖',
    '耶23:25 我已聽見那些先知所說的，就是託我名說的假預言，他們說：我做了夢！我做了夢！',
    '耶23:26 說假預言的先知，就是預言本心詭詐的先知，他們這樣存心要到幾時呢﹖',
    '耶23:27 他們各人將所做的夢對鄰舍述說，想要使我的百姓忘記我的名，正如他們列祖因巴力忘記我的名一樣。',
    '耶23:28 得夢的先知可以述說那夢；得我話的人可以誠實講說我的話。糠粃怎能與麥子比較呢﹖這是耶和華說的。',
    '耶23:29 耶和華說：我的話豈不像火，又像能打碎磐石的大錘嗎﹖',
    '耶23:30 耶和華說：那些先知各從鄰舍偷竊我的言語，因此我必與他們反對。',
    '耶23:31 耶和華說：那些先知用舌頭，說是耶和華說的；我必與他們反對。',
    '耶23:32 耶和華說：那些以幻夢為預言，又述說這夢，以謊言和矜誇使我百姓走錯了路的，我必與他們反對。我沒有打發他們，也沒有吩咐他們。他們於這百姓毫無益處。這是耶和華說的。',
    '耶23:33 無論是百姓，是先知，是祭司，問你說：耶和華有什麼默示呢﹖你就對他們說：什麼默示啊﹖耶和華說：我要撇棄你們。',
    '耶23:34 無論是先知，是祭司，是百姓，說耶和華的默示，我必刑罰那人和他的家。',
    '耶23:35 你們各人要對鄰舍，各人要對弟兄如此說：耶和華回答什麼﹖耶和華說了什麼呢﹖',
    '耶23:36 耶和華的默示你們不可再提，各人所說的話必作自己的重擔（重擔和默示原文同），因為你們謬用永生神、萬軍之耶和華─我們神的言語。',
    '耶23:37 你們要對先知如此說：耶和華回答你什麼﹖耶和華說了什麼呢﹖',
    '耶23:38 你們若說耶和華的默示，耶和華就如此說：因你們說耶和華的默示這句話，我也打發人到你們那裡去，告訴你們不可說耶和華的默示。',
    '耶23:39 所以我必全然忘記你們，將你們和我所賜給你們並你們列祖的城撇棄了；',
    '耶23:40 又必使永遠的凌辱和長久的羞恥臨到你們，是不能忘記的。',
    '耶24:1 巴比倫王尼布甲尼撒將猶大王約雅敬的兒子耶哥尼雅和猶大的首領，並工匠、鐵匠從耶路撒冷擄去，帶到巴比倫。這事以後，耶和華指給我看，有兩筐無花果放在耶和華的殿前。',
    '耶24:2 一筐是極好的無花果，好像是初熟的；一筐是極壞的無花果，壞得不可吃。',
    '耶24:3 於是耶和華問我說：耶利米你看見什麼﹖我說：我看見無花果，好的極好，壞的極壞，壞得不可吃。',
    '耶24:4 耶和華的話臨到我說：',
    '耶24:5 耶和華─以色列的神如此說：被擄去的猶大人，就是我打發離開這地到迦勒底人之地去的，我必看顧他們如這好無花果，使他們得好處。',
    '耶24:6 我要眷顧他們，使他們得好處，領他們歸回這地。我也要建立他們，必不拆毀；栽植他們，並不拔出。',
    '耶24:7 我要賜他們認識我的心，知道我是耶和華。他們要作我的子民，我要作他們的神，因為他們要一心歸向我。',
    '耶24:8 耶和華如此說：我必將猶大王西底家和他的首領，以及剩在這地耶路撒冷的餘民，並住在埃及地的猶大人都交出來，好像那極壞、壞得不可吃的無花果。',
    '耶24:9 我必使他們交出來，在天下萬國中拋來拋去，遭遇災禍；在我趕逐他們到的各處成為凌辱、笑談、譏刺、咒詛。',
    '耶24:10 我必使刀劍、饑荒、瘟疫臨到他們，直到他們從我所賜給他們和他們列祖之地滅絕。',
    '耶25:1 猶大王約西亞的兒子約雅敬第四年，就是巴比倫王尼布甲尼撒的元年，耶和華論猶大眾民的話臨到耶利米。',
    '耶25:2 先知耶利米就將這話對猶大眾人和耶路撒冷的一切居民說：',
    '耶25:3 從猶大王亞們的兒子約西亞十三年直到今日，這二十三年之內，常有耶和華的話臨到我；我也對你們傳說，就是從早起來傳說，只是你們沒有聽從。',
    '耶25:4 耶和華也從早起來，差遣他的僕人眾先知到你們這裡來（只是你們沒有聽從，也沒有側耳而聽），',
    '耶25:5 說：你們各人當回頭，離開惡道和所作的惡，便可居住耶和華古時所賜給你們和你們列祖之地，直到永遠。',
    '耶25:6 不可隨從別神事奉敬拜，以你們手所做的惹我發怒；這樣，我就不加害與你們。',
    '耶25:7 然而你們沒有聽從我，竟以手所做的惹我發怒，陷害自己。這是耶和華說的。',
    '耶25:8 所以萬軍之耶和華如此說：因為你們沒有聽從我的話，',
    '耶25:9 我必召北方的眾族和我僕人巴比倫王尼布甲尼撒來攻擊這地和這地的居民，並四圍一切的國民。我要將他們盡行滅絕，以致他們令人驚駭、嗤笑，並且永久荒涼。這是耶和華說的。',
    '耶25:10 我又要使歡喜和快樂的聲音，新郎和新婦的聲音，推磨的聲音和燈的亮光，從他們中間止息。',
    '耶25:11 這全地必然荒涼，令人驚駭。這些國民要服事巴比倫王七十年。',
    '耶25:12 七十年滿了以後，我必刑罰巴比倫王和那國民，並迦勒底人之地，因他們的罪孽使那地永遠荒涼。這是耶和華說的。',
    '耶25:13 我也必使我向那地所說的話，就是記在這書上的話，是耶利米向這些國民說的預言，都臨到那地。',
    '耶25:14 因為有多國和大君王必使迦勒底人作奴僕；我也必照他們的行為，按他們手所做的報應他們。',
    '耶25:15 耶和華─以色列的神對我如此說：你從我手中接這杯忿怒的酒，使我所差遣你去的各國的民喝。',
    '耶25:16 他們喝了就要東倒西歪，並要發狂，因我使刀劍臨到他們中間。',
    '耶25:17 我就從耶和華的手中接了這杯，給耶和華所差遣我去的各國的民喝，',
    '耶25:18 就是耶路撒冷和猶大的城邑，並耶路撒冷的君王與首領，使這城邑荒涼，令人驚駭、嗤笑、咒詛，正如今日一樣。',
    '耶25:19 又有埃及王法老和他的臣僕、首領，以及他的眾民，',
    '耶25:20 並雜族的人民和烏斯地的諸王，與非利士地的諸王（亞實基倫、迦薩、以革倫，以及亞實突剩下的人）；',
    '耶25:21 以東、摩押、亞捫人、',
    '耶25:22 推羅的諸王、西頓的諸王、海島的諸王、',
    '耶25:23 底但、提瑪、布斯，和一切剃周圍頭髮的；',
    '耶25:24 亞拉伯的諸王、住曠野雜族人民的諸王、',
    '耶25:25 心利的諸王、以攔的諸王、瑪代的諸王、',
    '耶25:26 北方遠近的諸王，以及天下地上的萬國喝了，以後示沙克（就是巴比倫）王也要喝。',
    '耶25:27 你要對他們說：萬軍之耶和華─以色列的神如此說：你們要喝，且要喝醉，要嘔吐，且要跌倒，不得再起來，都因我使刀劍臨到你們中間。',
    '耶25:28 他們若不肯從你手接這杯喝，你就要對他們說：萬軍之耶和華如此說：你們一定要喝！',
    '耶25:29 我既從稱為我名下的城起首施行災禍，你們能盡免刑罰嗎﹖你們必不能免，因為我要命刀劍臨到地上一切的居民。這是萬軍之耶和華說的。',
    '耶25:30 所以你要向他們預言這一切的話，攻擊他們，說：耶和華必從高天吼叫，從聖所發聲，向自己的羊群大聲吼叫；他要向地上一切的居民吶喊，像踹葡萄的一樣。',
    '耶25:31 必有響聲達到地極，因為耶和華與列國相爭；凡有血氣的，他必審問；至於惡人，他必交給刀劍。這是耶和華說的。',
    '耶25:32 萬軍之耶和華如此說：看哪，必有災禍從這國發到那國，並有大暴風從地極颳起。',
    '耶25:33 到那日，從地這邊直到地那邊都有耶和華所殺戮的。必無人哀哭，不得收殮，不得葬埋，必在地上成為糞土。',
    '耶25:34 牧人哪，你們當哀號，呼喊；群眾的頭目啊，你們要滾在灰中；因為你們被殺戮分散的日子足足來到。你們要跌碎，好像美器打碎一樣。',
    '耶25:35 牧人無路逃跑；群眾的頭目也無法逃脫。',
    '耶25:36 聽啊，有牧人呼喊，有群眾頭目哀號的聲音，因為耶和華使他們的草場變為荒場。',
    '耶25:37 耶和華發出猛烈的怒氣，平安的羊圈就都寂靜無聲。',
    '耶25:38 他離了隱密處像獅子一樣，他們的地，因刀劍凶猛的欺壓，又因他猛烈的怒氣都成為可驚駭的。',
    '耶26:1 猶大王約西亞的兒子約雅敬登基的時候，有這話從耶和華臨到耶利米說：',
    '耶26:2 耶和華如此說：你站在耶和華殿的院內，對猶大眾城邑的人，就是到耶和華殿來禮拜的，說我所吩咐你的一切話，一字不可刪減。',
    '耶26:3 或者他們肯聽從，各人回頭離開惡道，使我後悔不將我因他們所行的惡，想要施行的災禍降與他們。',
    '耶26:4 你要對他們說，耶和華如此說：你們若不聽從我，不遵行我設立在你們面前的律法，',
    '耶26:5 不聽我從早起來差遣到你們那裡去我僕人眾先知的話（你們還是沒有聽從），',
    '耶26:6 我就必使這殿如示羅，使這城為地上萬國所咒詛的。',
    '耶26:7 耶利米在耶和華殿中說的這些話，祭司、先知與眾民都聽見了。',
    '耶26:8 耶利米說完了耶和華所吩咐他對眾人說的一切話，祭司、先知與眾民都來抓住他，說：你必要死！',
    '耶26:9 你為何託耶和華的名預言，說這殿必如示羅，這城必變為荒場無人居住呢﹖於是眾民都在耶和華的殿中聚集到耶利米那裡。',
    '耶26:10 猶大的首領聽見這事，就從王宮上到耶和華的殿，坐在耶和華殿的新門口。',
    '耶26:11 祭司、先知對首領和眾民說：這人是該死的；因為他說預言攻擊這城，正如你們親耳所聽見的。',
    '耶26:12 耶利米就對眾首領和眾民說：耶和華差遣我預言，攻擊這殿和這城，說你們所聽見的這一切話。',
    '耶26:13 現在要改正你們的行動作為，聽從耶和華─你們神的話，他就必後悔，不將所說的災禍降與你們。',
    '耶26:14 至於我，我在你們手中，你們眼看何為善，何為正，就那樣待我吧！',
    '耶26:15 但你們要確實地知道，若把我治死，就使無辜人的血歸到你們和這城，並其中的居民了；因為耶和華實在差遣我到你們這裡來，將這一切話傳與你們耳中。',
    '耶26:16 首領和眾民就對祭司、先知說：這人是不該死的，因為他是奉耶和華─我們神的名向我們說話。',
    '耶26:17 國中的長老就有幾個人起來，對聚會的眾民說：',
    '耶26:18 當猶大王希西家的日子，有摩利沙人彌迦對猶大眾人預言說：萬軍之耶和華如此說：錫安必被耕種像一塊田；耶路撒冷必變為亂堆；這殿的山必像叢林的高處。',
    '耶26:19 猶大王希西家和猶大眾人豈是把他治死呢﹖希西家豈不是敬畏耶和華、懇求他的恩嗎﹖耶和華就後悔，不把自己所說的災禍降與他們。若治死這人，我們就作了大惡，自害己命。',
    '耶26:20 （又有一個人奉耶和華的名說預言，是基列‧耶琳人示瑪雅的兒子烏利亞，他照耶利米的一切話說預言，攻擊這城和這地。',
    '耶26:21 約雅敬王和他眾勇士、眾首領聽見了烏利亞的話，王就想要把他治死。烏利亞聽見就懼怕，逃往埃及去了。',
    '耶26:22 約雅敬王便打發亞革波的兒子以利拿單，帶領幾個人往埃及去。',
    '耶26:23 他們就從埃及將烏利亞帶出來，送到約雅敬王那裡；王用刀殺了他，把他的屍首拋在平民的墳地中。）',
    '耶26:24 然而，沙番的兒子亞希甘保護耶利米，不交在百姓的手中治死他。',
    '耶27:1 猶大王約西亞的兒子約雅敬（約雅敬是西底家的別名，看第三節）登基的時候，有這話從耶和華臨到耶利米說：',
    '耶27:2 耶和華對我如此說：你做繩索與軛，加在自己的頸項上，',
    '耶27:3 藉那些來到耶路撒冷見猶大王西底家的使臣之手，把繩索與軛送到以東王、摩押王、亞捫王、推羅王、西頓王那裡，',
    '耶27:4 且囑咐使臣，傳與他們的主人說，萬軍之耶和華─以色列的神如此說：',
    '耶27:5 我用大能和伸出來的膀臂，創造大地和地上的人民、牲畜。我看給誰相宜，就把地給誰。',
    '耶27:6 現在我將這些地都交給我僕人巴比倫王尼布甲尼撒的手，我也將田野的走獸給他使用。',
    '耶27:7 列國都必服事他和他的兒孫，直到他本國遭報的日期來到。那時，多國和大君王要使他作他們的奴僕。',
    '耶27:8 無論哪一邦哪一國，不肯服事這巴比倫王尼布甲尼撒，也不把頸項放在巴比倫王的軛下，我必用刀劍、饑荒、瘟疫刑罰那邦，直到我藉巴比倫王的手將他們毀滅。這是耶和華說的。',
    '耶27:9 至於你們，不可聽從你們的先知和占卜的、圓夢的、觀兆的，以及行邪術的；他們告訴你們說：你們不致服事巴比倫王。',
    '耶27:10 他們向你們說假預言，要叫你們遷移，遠離本地，以致我將你們趕出去，使你們滅亡。',
    '耶27:11 但哪一邦肯把頸項放在巴比倫王的軛下服事他，我必使那邦仍在本地存留，得以耕種居住。這是耶和華說的。',
    '耶27:12 我就照這一切的話對猶大王西底家說：要把你們的頸項放在巴比倫王的軛下，服事他和他的百姓，便得存活。',
    '耶27:13 你和你的百姓為何要因刀劍、饑荒、瘟疫死亡，正如耶和華論到不服事巴比倫王的那國說的話呢﹖',
    '耶27:14 不可聽那些先知對你們所說的話；他們說：你們不致服事巴比倫王，其實他們向你們說假預言。',
    '耶27:15 耶和華說：我並沒有打發他們，他們卻託我的名說假預言，好使我將你們和向你們說預言的那些先知趕出去，一同滅亡。',
    '耶27:16 我又對祭司和這眾民說：耶和華如此說：你們不可聽那先知對你們所說的預言。他們說：耶和華殿中的器皿快要從巴比倫帶回來；其實他們向你們說假預言。',
    '耶27:17 不可聽從他們，只管服事巴比倫王便得存活。這城何致變為荒場呢﹖',
    '耶27:18 他們若果是先知，有耶和華的話臨到他們，讓他們祈求萬軍之耶和華，使那在耶和華殿中和猶大王宮內，並耶路撒冷剩下的器皿，不被帶到巴比倫去。',
    '耶27:19 （因為萬軍之耶和華論到柱子、銅海、盆座，並剩在這城裡的器皿，',
    '耶27:20 就是巴比倫王尼布甲尼撒擄掠猶大王約雅敬的兒子耶哥尼雅，和猶大、耶路撒冷一切貴冑的時候所沒有掠去的器皿。）',
    '耶27:21 論到那在耶和華殿中和猶大王宮內，並耶路撒冷剩下的器皿，萬軍之耶和華─以色列的神如此說：',
    '耶27:22 必被帶到巴比倫存在那裡，直到我眷顧以色列人的日子。那時，我必將這器皿帶回來，交還此地。這是耶和華說的。',
    '耶28:1 當年，就是猶大王西底家登基第四年五月，基遍人押朔的兒子，先知哈拿尼雅，在耶和華的殿中當著祭司和眾民對我說：',
    '耶28:2 萬軍之耶和華─以色列的神如此說：我已經折斷巴比倫王的軛。',
    '耶28:3 二年之內，我要將巴比倫王尼布甲尼撒從這地掠到巴比倫的器皿，就是耶和華殿中的一切器皿都帶回此地。',
    '耶28:4 我又要將猶大王約雅敬的兒子耶哥尼雅和被擄到巴比倫去的一切猶大人帶回此地，因為我要折斷巴比倫王的軛。這是耶和華說的。',
    '耶28:5 先知耶利米當著祭司和站在耶和華殿裡的眾民對先知哈拿尼雅說：',
    '耶28:6 阿們！願耶和華如此行，願耶和華成就你所預言的話，將耶和華殿中的器皿和一切被擄去的人從巴比倫帶回此地。',
    '耶28:7 然而我向你和眾民耳中所要說的話，你應當聽。',
    '耶28:8 從古以來，在你我以前的先知，向多國和大邦說預言，論到爭戰、災禍、瘟疫的事。',
    '耶28:9 先知預言的平安，到話語成就的時候，人便知道他真是耶和華所差來的。',
    '耶28:10 於是，先知哈拿尼雅將先知耶利米頸項上的軛取下來，折斷了。',
    '耶28:11 哈拿尼雅又當著眾民說：耶和華如此說：二年之內我必照樣從列國人的頸項上折斷巴比倫王尼布甲尼撒的軛。於是先知耶利米就走了。',
    '耶28:12 先知哈拿尼雅把先知耶利米頸項上的軛折斷以後，耶和華的話臨到耶利米說：',
    '耶28:13 你去告訴哈拿尼雅說，耶和華如此說：你折斷木軛，卻換了鐵軛！',
    '耶28:14 因為萬軍之耶和華─以色列的神如此說：我已將鐵軛加在這些國的頸項上，使他們服事巴比倫王尼布甲尼撒，他們總要服事他；我也把田野的走獸給了他。',
    '耶28:15 於是先知耶利米對先知哈拿尼雅說：哈拿尼雅啊，你應當聽！耶和華並沒有差遣你，你竟使這百姓倚靠謊言。',
    '耶28:16 所以耶和華如此說：看哪，我要叫你去世，你今年必死，因為你向耶和華說了叛逆的話。',
    '耶28:17 這樣，先知哈拿尼雅當年七月間就死了。',
    '耶29:1 先知耶利米從耶路撒冷寄信與被擄的祭司、先知，和眾民，並生存的長老，就是尼布甲尼撒從耶路撒冷擄到巴比倫去的。',
    '耶29:2 （這在耶哥尼雅王和太后、太監，並猶大、耶路撒冷的首領，以及工匠、鐵匠都離了耶路撒冷以後。）',
    '耶29:3 他藉沙番的兒子以利亞薩和希勒家的兒子基瑪利的手寄去。他們二人是猶大王西底家打發往巴比倫去見尼布甲尼撒王的。',
    '耶29:4 信上說：萬軍之耶和華─以色列的神對一切被擄去的（就是我使他們從耶路撒冷被擄到巴比倫的人）如此說：',
    '耶29:5 你們要蓋造房屋，住在其中；栽種田園，吃其中所產的；',
    '耶29:6 娶妻生兒女，為你們的兒子娶妻，使你們的女兒嫁人，生兒養女。在那裡生養眾多，不致減少。',
    '耶29:7 我所使你們被擄到的那城，你們要為那城求平安，為那城禱告耶和華；因為那城得平安，你們也隨著得平安。',
    '耶29:8 萬軍之耶和華─以色列的神如此說：不要被你們中間的先知和占卜的誘惑，也不要聽信自己所做的夢；',
    '耶29:9 因為他們託我的名對你們說假預言，我並沒有差遣他們。這是耶和華說的。',
    '耶29:10 耶和華如此說：為巴比倫所定的七十年滿了以後，我要眷顧你們，向你們成就我的恩言，使你們仍回此地。',
    '耶29:11 耶和華說：我知道我向你們所懷的意念是賜平安的意念，不是降災禍的意念，要叫你們末後有指望。',
    '耶29:12 你們要呼求我，禱告我，我就應允你們。',
    '耶29:13 你們尋求我，若專心尋求我，就必尋見。',
    '耶29:14 耶和華說：我必被你們尋見，我也必使你們被擄的人歸回，將你們從各國中和我所趕你們到的各處招聚了來，又將你們帶回我使你們被擄掠離開的地方。這是耶和華說的。',
    '耶29:15 你們說：耶和華在巴比倫為我們興起先知；',
    '耶29:16 所以耶和華論到坐大衛寶座的王和住在這城裡的一切百姓，就是未曾與你們一同被擄的弟兄，',
    '耶29:17 萬軍之耶和華如此說：看哪，我必使刀劍、饑荒、瘟疫臨到他們，使他們像極壞的無花果，壞得不可吃。',
    '耶29:18 我必用刀劍、饑荒、瘟疫追趕他們，使他們在天下萬國拋來拋去，在我所趕他們到的各國中，令人咒詛、驚駭、嗤笑、羞辱。',
    '耶29:19 耶和華說：這是因為他們沒有聽從我的話，就是我從早起來差遣我僕人眾先知去說的，無奈他們不聽。這是耶和華說的。',
    '耶29:20 所以你們一切被擄去的，就是我從耶路撒冷打發到巴比倫去的，當聽耶和華的話。',
    '耶29:21 萬軍之耶和華─以色列的神論到哥賴雅的兒子亞哈，並瑪西雅的兒子西底家，如此說：他們是託我名向你們說假預言的，我必將他們交在巴比倫王尼布甲尼撒的手中；他要在你們眼前殺害他們。',
    '耶29:22 住巴比倫一切被擄的猶大人必藉這二人賭咒說：願耶和華使你像巴比倫王在火中燒的西底家和亞哈一樣。',
    '耶29:23 這二人是在以色列中行了醜事，與鄰舍的妻行淫，又假託我名說我未曾吩咐他們的話。知道的是我，作見證的也是我。這是耶和華說的。',
    '耶29:24 論到尼希蘭人示瑪雅，你當說，',
    '耶29:25 萬軍之耶和華─以色列的神如此說：你曾用自己的名寄信給耶路撒冷的眾民和祭司瑪西雅的兒子西番雅，並眾祭司，說：',
    '耶29:26 耶和華已經立你西番雅為祭司，代替祭司耶何耶大，使耶和華殿中有官長，好將一切狂妄自稱為先知的人用枷枷住，用鎖鎖住。',
    '耶29:27 現在亞拿突人耶利米向你們自稱為先知，你們為何沒有責備他呢﹖',
    '耶29:28 因為他寄信給我們在巴比倫的人說：被擄的事必長久。你們要蓋造房屋，住在其中；栽種田園，吃其中所產的。',
    '耶29:29 祭司西番雅就把這信念給先知耶利米聽。',
    '耶29:30 於是耶和華的話臨到耶利米說：',
    '耶29:31 你當寄信給一切被擄的人說：耶和華論到尼希蘭人示瑪雅說：因為示瑪雅向你們說預言，我並沒有差遣他，他使你們倚靠謊言；',
    '耶29:32 所以耶和華如此說：我必刑罰尼希蘭人示瑪雅和他的後裔，他必無一人存留住在這民中，也不得見我所要賜與我百姓的福樂，因為他向耶和華說了叛逆的話。這是耶和華說的。',
    '耶30:1 耶和華的話臨到耶利米說：',
    '耶30:2 耶和華─以色列的神如此說：你將我對你說過的一切話都寫在書上。',
    '耶30:3 耶和華說：日子將到，我要使我的百姓以色列和猶大被擄的人歸回；我也要使他們回到我所賜給他們列祖之地，他們就得這地為業。這是耶和華說的。',
    '耶30:4 以下是耶和華論到以色列和猶大所說的話：',
    '耶30:5 耶和華如此說：我們聽見聲音，是戰抖懼怕而不平安的聲音。',
    '耶30:6 你們且訪問看看，男人有產難嗎﹖我怎麼看見人人用手掐腰，像產難的婦人，臉面都變青了呢﹖',
    '耶30:7 哀哉！那日為大，無日可比；這是雅各遭難的時候，但他必被救出來。',
    '耶30:8 萬軍之耶和華說：到那日，我必從你頸項上折斷仇敵的軛，扭開他的繩索；外邦人不得再使你作他們的奴僕。',
    '耶30:9 你們卻要事奉耶和華─你們的神和我為你們所要興起的王大衛。',
    '耶30:10 故此，耶和華說：我的僕人雅各啊，不要懼怕；以色列啊，不要驚惶；因我要從遠方拯救你，從被擄到之地拯救你的後裔；雅各必回來得享平靖安逸，無人使他害怕。',
    '耶30:11 因我與你同在，要拯救你，也要將所趕散你到的那些國滅絕淨盡，卻不將你滅絕淨盡，倒要從寬懲治你，萬不能不罰你（不罰你：或譯以你為無罪）。這是耶和華說的。',
    '耶30:12 耶和華如此說：你的損傷無法醫治；你的傷痕極其重大。',
    '耶30:13 無人為你分訴，使你的傷痕得以纏裹；你沒有醫治的良藥。',
    '耶30:14 你所親愛的都忘記你，不來探問（或譯：理會）你。我因你的罪孽甚大，罪惡眾多，曾用仇敵加的傷害傷害你，用殘忍者的懲治懲治你。',
    '耶30:15 你為何因損傷哀號呢﹖你的痛苦無法醫治。我因你的罪孽甚大，罪惡眾多，曾將這些加在你身上。',
    '耶30:16 故此，凡吞吃你的必被吞吃；你的敵人個個都被擄去；擄掠你的必成為擄物；搶奪你的必成為掠物。',
    '耶30:17 耶和華說：我必使你痊癒，醫好你的傷痕，都因人稱你為被趕散的，說：這是錫安，無人來探問（或譯：理會）的！',
    '耶30:18 耶和華如此說：我必使雅各被擄去的帳棚歸回，也必顧惜他的住處。城必建造在原舊的山岡；宮殿也照舊有人居住。',
    '耶30:19 必有感謝和歡樂的聲音從其中發出，我要使他們增多，不致減少；使他們尊榮，不致卑微。',
    '耶30:20 他們的兒女要如往日；他們的會眾堅立在我面前；凡欺壓他們的，我必刑罰他。',
    '耶30:21 他們的君王必是屬乎他們的；掌權的必從他們中間而出。我要使他就近我，他也要親近我；不然，誰有膽量親近我呢﹖這是耶和華說的。',
    '耶30:22 你們要作我的子民，我要作你們的神。',
    '耶30:23 看哪，耶和華的忿怒好像暴風已經發出；是掃滅的暴風，必轉到惡人的頭上。',
    '耶30:24 耶和華的烈怒必不轉消，直到他心中所擬定的成就了；末後的日子你們要明白。',
    '耶31:1 耶和華說：那時，我必作以色列各家的神；他們必作我的子民。',
    '耶31:2 耶和華如此說：脫離刀劍的就是以色列人。我使他享安息的時候，他曾在曠野蒙恩。',
    '耶31:3 古時（或譯：從遠方）耶和華向以色列（原文是我）顯現，說：我以永遠的愛愛你，因此我以慈愛吸引你。',
    '耶31:4 以色列的民（原文是處女）哪，我要再建立你，你就被建立；你必再以擊鼓為美，與歡樂的人一同跳舞而出；',
    '耶31:5 又必在撒瑪利亞的山上栽種葡萄園，栽種的人要享用所結的果子。',
    '耶31:6 日子必到，以法蓮山上守望的人必呼叫說：起來吧！我們可以上錫安，到耶和華─我們的神那裡去。',
    '耶31:7 耶和華如此說：你們當為雅各歡樂歌唱，因萬國中為首的歡呼。當傳揚頌讚說：耶和華啊，求你拯救你的百姓以色列所剩下的人。',
    '耶31:8 我必將他們從北方領來，從地極招聚；同著他們來的有瞎子、瘸子、孕婦、產婦；他們必成為大幫回到這裡來。',
    '耶31:9 他們要哭泣而來。我要照他們懇求的引導他們，使他們在河水旁走正直的路，在其上不致絆跌；因為我是以色列的父，以法蓮是我的長子。',
    '耶31:10 列國啊，要聽耶和華的話，傳揚在遠處的海島說：趕散以色列的必招聚他，又看守他，好像牧人看守羊群。',
    '耶31:11 因耶和華救贖了雅各，救贖他脫離比他更強之人的手。',
    '耶31:12 他們要來到錫安的高處歌唱，又流歸耶和華施恩之地，就是有五穀、新酒，和油，並羊羔、牛犢之地。他們的心必像澆灌的園子；他們也不再有一點愁煩。',
    '耶31:13 那時，處女必歡樂跳舞；年少的、年老的，也必一同歡樂；因為我要使他們的悲哀變為歡喜，並要安慰他們，使他們的愁煩轉為快樂。',
    '耶31:14 我必以肥油使祭司的心滿足；我的百姓也要因我的恩惠知足。這是耶和華說的。',
    '耶31:15 耶和華如此說：在拉瑪聽見號咷痛哭的聲音，是拉結哭他兒女，不肯受安慰，因為他們都不在了。',
    '耶31:16 耶和華如此說：你禁止聲音不要哀哭，禁止眼目不要流淚，因你所做之工必有賞賜；他們必從敵國歸回。這是耶和華說的。',
    '耶31:17 耶和華說：你末後必有指望；你的兒女必回到自己的境界。',
    '耶31:18 我聽見以法蓮為自己悲歎說：你責罰我，我便受責罰，像不慣負軛的牛犢一樣。求你使我回轉，我便回轉，因為你是耶和華─我的神。',
    '耶31:19 我回轉以後就真正懊悔；受教以後就拍腿歎息；我因擔當幼年的凌辱就抱愧蒙羞。',
    '耶31:20 耶和華說：以法蓮是我的愛子嗎﹖是可喜悅的孩子嗎﹖我每逢責備他，仍深顧念他；所以我的心腸戀慕他；我必要憐憫他。',
    '耶31:21 以色列民（原文是處女）哪，你當為自己設立指路碑，豎起引路柱。你要留心向大路，就是你所去的原路；你當回轉，回轉到你這些城邑。',
    '耶31:22 背道的民（原文是女子）哪，你反來覆去要到幾時呢﹖耶和華在地上造了一件新事，就是女子護衛男子。',
    '耶31:23 萬軍之耶和華─以色列的神如此說：我使被擄之人歸回的時候，他們在猶大地和其中的城邑必再這樣說：公義的居所啊，聖山哪，願耶和華賜福給你。',
    '耶31:24 猶大和屬猶大城邑的人，農夫和放羊的人，要一同住在其中。',
    '耶31:25 疲乏的人，我使他飽飫；愁煩的人，我使他知足。',
    '耶31:26 先知說：我醒了，覺著睡得香甜！',
    '耶31:27 耶和華說：日子將到，我要把人的種和牲畜的種播種在以色列家和猶大家。',
    '耶31:28 我先前怎樣留意將他們拔出、拆毀、毀壞、傾覆、苦害，也必照樣留意將他們建立、栽植。這是耶和華說的。',
    '耶31:29 當那些日子，人不再說：父親吃了酸葡萄，兒子的牙酸倒了。',
    '耶31:30 但各人必因自己的罪死亡；凡吃酸葡萄的，自己的牙必酸倒。',
    '耶31:31 耶和華說：日子將到，我要與以色列家和猶大家另立新約，',
    '耶31:32 不像我拉著他們祖宗的手，領他們出埃及地的時候，與他們所立的約。我雖作他們的丈夫，他們卻背了我的約。這是耶和華說的。',
    '耶31:33 耶和華說：那些日子以後，我與以色列家所立的約乃是這樣：我要將我的律法放在他們裡面，寫在他們心上。我要作他們的神，他們要作我的子民。',
    '耶31:34 他們各人不再教導自己的鄰舍和自己的弟兄說：你該認識耶和華，因為他們從最小的到至大的都必認識我。我要赦免他們的罪孽，不再記念他們的罪惡。這是耶和華說的。',
    '耶31:35 那使太陽白日發光，使星月有定例，黑夜發亮，又攪動大海，使海中波浪匉訇的，萬軍之耶和華是他的名。他如此說：',
    '耶31:36 這些定例若能在我面前廢掉，以色列的後裔也就在我面前斷絕，永遠不再成國。這是耶和華說的。',
    '耶31:37 耶和華如此說：若能量度上天，尋察下地的根基，我就因以色列後裔一切所行的棄絕他們。這是耶和華說的。',
    '耶31:38 耶和華說：日子將到，這城必為耶和華建造，從哈楠業樓直到角門。',
    '耶31:39 準繩要往外量出，直到迦立山，又轉到歌亞。',
    '耶31:40 拋屍的全谷和倒灰之處，並一切田地，直到汲淪溪，又直到東方馬門的拐角，都要歸耶和華為聖，不再拔出，不再傾覆，直到永遠。',
    '耶32:1 猶大王西底家第十年，就是尼布甲尼撒十八年，耶和華的話臨到耶利米。',
    '耶32:2 那時巴比倫王的軍隊圍困耶路撒冷，先知耶利米囚在護衛兵的院內，在猶大王的宮中；',
    '耶32:3 因為猶大王西底家已將他囚禁，說：你為什麼預言說，耶和華如此說：我必將這城交在巴比倫王的手中，他必攻取這城。',
    '耶32:4 猶大王西底家必不能逃脫迦勒底人的手，定要交在巴比倫王的手中，要口對口彼此說話，眼對眼彼此相看。',
    '耶32:5 巴比倫王必將西底家帶到巴比倫；西底家必住在那裡，直到我眷顧他的時候。你們雖與迦勒底人爭戰，卻不順利。這是耶和華說的。',
    '耶32:6 耶利米說：耶和華的話臨到我說：',
    '耶32:7 你叔叔沙龍的兒子哈拿篾必來見你，說：我在亞拿突的那塊地，求你買來；因你買這地是合乎贖回之理。',
    '耶32:8 我叔叔的兒子哈拿篾果然照耶和華的話來到護衛兵的院內，對我說：我在便雅憫境內、亞拿突的那塊地，求你買來；因你買來是合乎承受之理，是你當贖的。你為自己買來吧！我─耶利米就知道這是耶和華的話。',
    '耶32:9 我便向我叔叔的兒子哈拿篾買了亞拿突的那塊地，平了十七舍客勒銀子給他。',
    '耶32:10 我在契上畫押，將契封緘，又請見證人來，並用天平將銀子平給他。',
    '耶32:11 我便將照例按規所立的買契，就是封緘的那一張和敞著的那一張，',
    '耶32:12 當著我叔叔的兒子哈拿篾和畫押作見證的人，並坐在護衛兵院內的一切猶大人眼前，交給瑪西雅的孫子尼利亞的兒子巴錄。',
    '耶32:13 當著他們眾人眼前，我囑咐巴錄說：',
    '耶32:14 萬軍之耶和華─以色列的神如此說：要將這封緘的和敞著的兩張契放在瓦器裡，可以存留多日。',
    '耶32:15 因為萬軍之耶和華─以色列的神如此說：將來在這地必有人再買房屋、田地，和葡萄園。',
    '耶32:16 我將買契交給尼利亞的兒子巴錄以後，便禱告耶和華說：',
    '耶32:17 主耶和華啊，你曾用大能和伸出來的膀臂創造天地，在你沒有難成的事。',
    '耶32:18 你施慈愛與千萬人，又將父親的罪孽報應在他後世子孫的懷中，是至大全能的神，萬軍之耶和華是你的名。',
    '耶32:19 謀事有大略，行事有大能，注目觀看世人一切的舉動，為要照各人所行的和他做事的結果報應他。',
    '耶32:20 在埃及地顯神蹟奇事，直到今日在以色列和別人中間也是如此，使自己得了名聲，正如今日一樣。',
    '耶32:21 用神蹟奇事和大能的手，並伸出來的膀臂與大可畏的事，領你的百姓以色列出了埃及。',
    '耶32:22 將這地賜給他們，就是你向他們列祖起誓應許賜給他們流奶與蜜之地。',
    '耶32:23 他們進入這地得了為業，卻不聽從你的話，也不遵行你的律法；你一切所吩咐他們行的，他們一無所行，因此你使這一切的災禍臨到他們。',
    '耶32:24 看哪，敵人已經來到，築壘要攻取這城；城也因刀劍、饑荒、瘟疫交在攻城的迦勒底人手中。你所說的話都成就了，你也看見了。',
    '耶32:25 主耶和華啊，你對我說：要用銀子為自己買那塊地，又請見證人。其實這城已交在迦勒底人的手中了。',
    '耶32:26 耶和華的話臨到耶利米說：',
    '耶32:27 我是耶和華，是凡有血氣者的神，豈有我難成的事嗎﹖',
    '耶32:28 耶和華如此說：我必將這城交付迦勒底人的手和巴比倫王尼布甲尼撒的手，他必攻取這城。',
    '耶32:29 攻城的迦勒底人必來放火焚燒這城和其中的房屋。在這房屋上，人曾向巴力燒香，向別神澆奠，惹我發怒。',
    '耶32:30 以色列人和猶大人自從幼年以來，專行我眼中看為惡的事；以色列人盡以手所做的惹我發怒。這是耶和華說的。',
    '耶32:31 這城自從建造的那日直到今日，常惹我的怒氣和忿怒，使我將這城從我面前除掉；',
    '耶32:32 是因以色列人和猶大人一切的邪惡，就是他們和他們的君王、首領、祭司、先知，並猶大的眾人，以及耶路撒冷的居民所行的，惹我發怒。',
    '耶32:33 他們以背向我，不以面向我；我雖從早起來教訓他們，他們卻不聽從，不受教訓，',
    '耶32:34 竟把可憎之物設立在稱為我名下的殿中，污穢了這殿。',
    '耶32:35 他們在欣嫩子谷建築巴力的邱壇，好使自己的兒女經火歸摩洛；他們行這可憎的事，使猶大陷在罪裡，這並不是我所吩咐的，也不是我心所起的意。',
    '耶32:36 現在論到這城，就是你們所說、已經因刀劍、饑荒、瘟疫交在巴比倫王手中的，耶和華─以色列的神如此說：',
    '耶32:37 我在怒氣、忿怒，和大惱恨中，將以色列人趕到各國。日後我必從那裡將他們招聚出來，領他們回到此地，使他們安然居住。',
    '耶32:38 他們要作我的子民，我要作他們的神。',
    '耶32:39 我要使他們彼此同心同道，好叫他們永遠敬畏我，使他們和他們後世的子孫得福樂，',
    '耶32:40 又要與他們立永遠的約，必隨著他們施恩，並不離開他們，且使他們有敬畏我的心，不離開我。',
    '耶32:41 我必歡喜施恩與他們，要盡心盡意、誠誠實實將他們栽於此地。',
    '耶32:42 因為耶和華如此說：我怎樣使這一切大禍臨到這百姓，我也要照樣使我所應許他們的一切福樂都臨到他們。',
    '耶32:43 你們說，這地是荒涼、無人民、無牲畜，是交付迦勒底人手之地。日後在這境內，必有人置買田地。',
    '耶32:44 在便雅憫地、耶路撒冷四圍的各處、猶大的城邑、山地的城邑、高原的城邑，並南地的城邑，人必用銀子買田地，在契上畫押，將契封緘，請出見證人，因為我必使被擄的人歸回。這是耶和華說的。',
    '耶33:1 耶利米還囚在護衛兵的院內，耶和華的話第二次臨到他說：',
    '耶33:2 成就的是耶和華，造作、為要建立的也是耶和華；耶和華是他的名。他如此說：',
    '耶33:3 你求告我，我就應允你，並將你所不知道、又大又難的事指示你。',
    '耶33:4 論到這城中的房屋和猶大王的宮室，就是拆毀為擋敵人高壘和刀劍的，耶和華─以色列的神如此說：',
    '耶33:5 人要與迦勒底人爭戰，正是拿死屍充滿這房屋，就是我在怒氣和忿怒中所殺的人，因他們的一切惡，我就掩面不顧這城。',
    '耶33:6 看哪，我要使這城得以痊癒安舒，使城中的人得醫治，又將豐盛的平安和誠實顯明與他們。',
    '耶33:7 我也要使猶大被擄的和以色列被擄的歸回，並建立他們和起初一樣。',
    '耶33:8 我要除淨他們的一切罪，就是向我所犯的罪；又要赦免他們的一切罪，就是干犯我、違背我的罪。',
    '耶33:9 這城要在地上萬國人面前使我得頌讚，得榮耀，名為可喜可樂之城。萬國人因聽見我向這城所賜的福樂、所施的恩惠平安，就懼怕戰兢。',
    '耶33:10 耶和華如此說：你們論這地方，說是荒廢無人民無牲畜之地，但在這荒涼無人民無牲畜的猶大城邑和耶路撒冷的街上，',
    '耶33:11 必再聽見有歡喜和快樂的聲音、新郎和新婦的聲音，並聽見有人說：要稱謝萬軍之耶和華，因耶和華本為善；他的慈愛永遠長存！又有奉感謝祭到耶和華殿中之人的聲音；因為我必使這地被擄的人歸回，和起初一樣。這是耶和華說的。',
    '耶33:12 萬軍之耶和華如此說：在這荒廢無人民無牲畜之地，並其中所有的城邑，必再有牧人的住處；他們要使羊群躺臥在那裡。',
    '耶33:13 在山地的城邑、高原的城邑、南地的城邑、便雅憫地、耶路撒冷四圍的各處，和猶大的城邑必再有羊群從數點的人手下經過。這是耶和華說的。',
    '耶33:14 耶和華說：日子將到，我應許以色列家和猶大家的恩言必然成就。',
    '耶33:15 當那日子，那時候，我必使大衛公義的苗裔長起來；他必在地上施行公平和公義。',
    '耶33:16 在那日子猶大必得救，耶路撒冷必安然居住，他的名必稱為耶和華─我們的義。',
    '耶33:17 因為耶和華如此說：大衛必永不斷人坐在以色列家的寶座上；',
    '耶33:18 祭司、利未人在我面前也不斷人獻燔祭、燒素祭，時常辦理獻祭的事。',
    '耶33:19 耶和華的話臨到耶利米說：',
    '耶33:20 耶和華如此說：你們若能廢棄我所立白日黑夜的約，使白日黑夜不按時輪轉，',
    '耶33:21 就能廢棄我與我僕人大衛所立的約，使他沒有兒子在他的寶座上為王，並能廢棄我與事奉我的祭司、利未人所立的約。',
    '耶33:22 天上的萬象不能數算，海邊的塵沙也不能斗量；我必照樣使我僕人大衛的後裔和事奉我的利未人多起來。',
    '耶33:23 耶和華的話臨到耶利米說：',
    '耶33:24 你沒有揣摩這百姓的話嗎﹖他們說：耶和華所揀選的二族，他已經棄絕了。他們這樣藐視我的百姓，以為不再成國。',
    '耶33:25 耶和華如此說：若是我立白日黑夜的約不能存住，若是我未曾安排天地的定例，',
    '耶33:26 我就棄絕雅各的後裔和我僕人大衛的後裔，不使大衛的後裔治理亞伯拉罕、以撒、雅各的後裔；因為我必使他們被擄的人歸回，也必憐憫他們。',
    '耶34:1 巴比倫王尼布甲尼撒率領他的全軍和地上屬他的各國各邦，攻打耶路撒冷和屬耶路撒冷所有的城邑。那時，耶和華的話臨到耶利米說：',
    '耶34:2 耶和華─以色列的神說，你去告訴猶大王西底家，耶和華如此說：我要將這城交付巴比倫王的手，他必用火焚燒。',
    '耶34:3 你必不能逃脫他的手，定被拿住，交在他的手中。你的眼要見巴比倫王的眼，他要口對口和你說話，你也必到巴比倫去。',
    '耶34:4 猶大王西底家啊，你還要聽耶和華的話。耶和華論到你如此說：你必不被刀劍殺死，',
    '耶34:5 你必平安而死，人必為你焚燒物件，好像為你列祖，就是在你以前的先王焚燒一般。人必為你舉哀說：哀哉！我主啊。耶和華說：這話是我說的。',
    '耶34:6 於是，先知耶利米在耶路撒冷將這一切話告訴猶大王西底家。',
    '耶34:7 那時，巴比倫王的軍隊正攻打耶路撒冷，又攻打猶大所剩下的城邑，就是拉吉和亞西加。原來猶大的堅固城只剩下這兩座。',
    '耶34:8 西底家王與耶路撒冷的眾民立約，要向他們宣告自由，叫各人任他希伯來的僕人和婢女自由出去，誰也不可使他的一個猶大弟兄作奴僕。（此後，有耶和華的話臨到耶利米。）',
    '耶34:9 併於上節。',
    '耶34:10 所有立約的首領和眾民就任他的僕人婢女自由出去，誰也不再叫他們作奴僕。大家都順從，將他們釋放了；',
    '耶34:11 後來卻又反悔，叫所任去自由的僕人婢女回來，勉強他們仍為僕婢。',
    '耶34:12 因此耶和華的話臨到耶利米說：',
    '耶34:13 耶和華─以色列的神如此說：我將你們的列祖從埃及地為奴之家領出來的時候，與他們立約說：',
    '耶34:14 你的一個希伯來弟兄若賣給你，服事你六年，到第七年你們各人就要任他自由出去。只是你們列祖不聽從我，也不側耳而聽。',
    '耶34:15 如今你們回轉，行我眼中看為正的事，各人向鄰舍宣告自由，並且在稱為我名下的殿中、在我面前立約。',
    '耶34:16 你們卻又反悔，褻瀆我的名，各人叫所任去隨意自由的僕人婢女回來，勉強他們仍為僕婢。',
    '耶34:17 所以耶和華如此說：你們沒有聽從我，各人向弟兄鄰舍宣告自由。看哪！我向你們宣告一樣自由，就是使你們自由於刀劍、饑荒、瘟疫之下，並且使你們在天下萬國中拋來拋去。這是耶和華說的。',
    '耶34:18 猶大的首領、耶路撒冷的首領、太監、祭司，和國中的眾民曾將牛犢劈開，分成兩半，從其中經過，在我面前立約。後來又違背我的約，不遵行這約上的話。',
    '耶34:19 併於上節。',
    '耶34:20 我必將他們交在仇敵和尋索其命的人手中；他們的屍首必給空中的飛鳥和地上的野獸作食物。',
    '耶34:21 並且我必將猶大王西底家和他的首領交在他們仇敵和尋索其命的人，與那暫離你們而去巴比倫王軍隊的手中。',
    '耶34:22 耶和華說：我必吩咐他們回到這城，攻打這城，將城攻取，用火焚燒。我也要使猶大的城邑變為荒場，無人居住。',
    '耶35:1 當猶大王約西亞之子約雅敬的時候，耶和華的話臨到耶利米說：',
    '耶35:2 你去見利甲族的人，和他們說話，領他們進入耶和華殿的一間屋子，給他們酒喝。',
    '耶35:3 我就將哈巴洗尼雅的孫子雅利米雅的兒子雅撒尼亞和他弟兄，並他眾子，以及利甲全族的人，',
    '耶35:4 領到耶和華的殿，進入神人伊基大利的兒子哈難眾子的屋子。那屋子在首領的屋子旁邊，在沙龍之子把門的瑪西雅屋子以上。',
    '耶35:5 於是我在利甲族人面前設擺盛滿酒的碗和杯，對他們說：請你們喝酒。',
    '耶35:6 他們卻說：我們不喝酒；因為我們先祖利甲的兒子約拿達曾吩咐我們說：你們與你們的子孫永不可喝酒，',
    '耶35:7 也不可蓋房、撒種、栽種葡萄園，但一生的年日要住帳棚，使你們的日子在寄居之地得以延長。',
    '耶35:8 凡我們先祖利甲的兒子約拿達所吩咐我們的話，我們都聽從了。我們和我們的妻子兒女一生的年日都不喝酒，',
    '耶35:9 也不蓋房居住，也沒有葡萄園、田地，和種子，',
    '耶35:10 但住帳棚，聽從我們先祖約拿達的話，照他所吩咐我們的去行。',
    '耶35:11 巴比倫王尼布甲尼撒上此地來，我們因怕迦勒底的軍隊和亞蘭的軍隊，就說：來吧，我們到耶路撒冷去。這樣，我們才住在耶路撒冷。',
    '耶35:12 耶和華的話臨到耶利米說：',
    '耶35:13 萬軍之耶和華─以色列的神如此說：你去對猶大人和耶路撒冷的居民說，耶和華說：你們不受教訓，不聽從我的話嗎﹖',
    '耶35:14 利甲的兒子約拿達所吩咐他子孫不可喝酒的話，他們已經遵守，直到今日也不喝酒，因為他們聽從先祖的吩咐。我從早起來警戒你們，你們卻不聽從我。',
    '耶35:15 我從早起來，差遣我的僕人眾先知去，說：你們各人當回頭，離開惡道，改正行為，不隨從事奉別神，就必住在我所賜給你們和你們列祖的地上。只是你們沒有聽從我，也沒有側耳而聽。',
    '耶35:16 利甲的兒子約拿達的子孫能遵守先人所吩咐他們的命，這百姓卻沒有聽從我！',
    '耶35:17 因此，耶和華─萬軍之神、以色列的神如此說：我要使我所說的一切災禍臨到猶大人和耶路撒冷的一切居民。因為我對他們說話，他們沒有聽從；我呼喚他們，他們沒有答應。',
    '耶35:18 耶利米對利甲族的人說：萬軍之耶和華─以色列的神如此說：因你們聽從你們先祖約拿達的吩咐，謹守他的一切誡命，照他所吩咐你們的去行，',
    '耶35:19 所以萬軍之耶和華─以色列的神如此說：利甲的兒子約拿達必永不缺人侍立在我面前。',
    '耶36:1 猶大王約西亞的兒子約雅敬第四年，耶和華的話臨到耶利米說：',
    '耶36:2 你取一書卷，將我對你說攻擊以色列和猶大，並各國的一切話，從我對你說話的那日，就是從約西亞的日子起直到今日，都寫在其上。',
    '耶36:3 或者猶大家聽見我想要降與他們的一切災禍，各人就回頭，離開惡道，我好赦免他們的罪孽和罪惡。',
    '耶36:4 所以，耶利米召了尼利亞的兒子巴錄來；巴錄就從耶利米口中，將耶和華對耶利米所說的一切話寫在書卷上。',
    '耶36:5 耶利米吩咐巴錄說：我被拘管，不能進耶和華的殿。',
    '耶36:6 所以你要去趁禁食的日子，在耶和華殿中將耶和華的話，就是你從我口中所寫在書卷上的話，念給百姓和一切從猶大城邑出來的人聽。',
    '耶36:7 或者他們在耶和華面前懇求各人回頭，離開惡道，因為耶和華向這百姓所說要發的怒氣和忿怒是大的。',
    '耶36:8 尼利亞的兒子巴錄就照先知耶利米一切所吩咐的去行，在耶和華的殿中從書上念耶和華的話。',
    '耶36:9 猶大王約西亞的兒子約雅敬第五年九月，耶路撒冷的眾民和那從猶大城邑來到耶路撒冷的眾民，在耶和華面前宣告禁食的日子，',
    '耶36:10 巴錄就在耶和華殿的上院，耶和華殿的新門口，沙番的兒子文士基瑪利雅的屋內，念書上耶利米的話給眾民聽。',
    '耶36:11 沙番的孫子、基瑪利雅的兒子米該亞聽見書上耶和華的一切話，',
    '耶36:12 他就下到王宮，進入文士的屋子。眾首領，就是文士以利沙瑪、示瑪雅的兒子第萊雅、亞革波的兒子以利拿單、沙番的兒子基瑪利雅、哈拿尼雅的兒子西底家，和其餘的首領都坐在那裡。',
    '耶36:13 於是米該亞對他們述說他所聽見的一切話，就是巴錄向百姓念那書的時候所聽見的。',
    '耶36:14 眾首領就打發古示的曾孫、示利米雅的孫子、尼探雅的兒子猶底到巴錄那裡，對他說：你將所念給百姓聽的書卷拿在手中到我們這裡來。尼利亞的兒子巴錄就手拿書卷來到他們那裡。',
    '耶36:15 他們對他說：請你坐下，念給我們聽。巴錄就念給他們聽。',
    '耶36:16 他們聽見這一切話就害怕，面面相觀，對巴錄說：我們必須將這一切話告訴王。',
    '耶36:17 他們問巴錄說：請你告訴我們，你怎樣從他口中寫這一切話呢﹖',
    '耶36:18 巴錄回答說：他用口向我說這一切話，我就用筆墨寫在書上。',
    '耶36:19 眾首領對巴錄說：你和耶利米要去藏起來，不可叫人知道你們在哪裡。',
    '耶36:20 眾首領進院見王，卻先把書卷存在文士以利沙瑪的屋內，以後將這一切話說給王聽。',
    '耶36:21 王就打發猶底去拿這書卷來，他便從文士以利沙瑪的屋內取來，念給王和王左右侍立的眾首領聽。',
    '耶36:22 那時正是九月，王坐在過冬的房屋裡，王的前面火盆中有燒著的火。',
    '耶36:23 猶底念了三四篇（或譯：行），王就用文士的刀將書卷割破，扔在火盆中，直到全卷在火中燒盡了。',
    '耶36:24 王和聽見這一切話的臣僕都不懼怕，也不撕裂衣服。',
    '耶36:25 以利拿單和第萊雅，並基瑪利雅懇求王不要燒這書卷，他卻不聽。',
    '耶36:26 王就吩咐哈米勒的兒子（或譯：王的兒子）耶拉篾和亞斯列的兒子西萊雅，並亞伯疊的兒子示利米雅，去捉拿文士巴錄和先知耶利米。耶和華卻將他們隱藏。',
    '耶36:27 王燒了書卷（其上有巴錄從耶利米口中所寫的話）以後，耶和華的話臨到耶利米說：',
    '耶36:28 你再取一卷，將猶大王約雅敬所燒第一卷上的一切話寫在其上。',
    '耶36:29 論到猶大王約雅敬你要說，耶和華如此說：你燒了書卷，說：你為什麼在其上寫著，說巴比倫王必要來毀滅這地，使這地上絕了人民牲畜呢﹖',
    '耶36:30 所以耶和華論到猶大王約雅敬說：他後裔中必沒有人坐在大衛的寶座上；他的屍首必被拋棄，白日受炎熱，黑夜受寒霜。',
    '耶36:31 我必因他和他後裔，並他臣僕的罪孽刑罰他們。我要使我所說的一切災禍臨到他們和耶路撒冷的居民，並猶大人；只是他們不聽。',
    '耶36:32 於是，耶利米又取一書卷交給尼利亞的兒子文士巴錄，他就從耶利米的口中寫了猶大王約雅敬所燒前卷上的一切話，另外又添了許多相彷的話。',
    '耶37:1 約西亞的兒子西底家代替約雅敬的兒子哥尼雅為王，是巴比倫王尼布甲尼撒立在猶大地作王的。',
    '耶37:2 但西底家和他的臣僕，並國中的百姓，都不聽從耶和華藉先知耶利米所說的話。',
    '耶37:3 西底家王打發示利米雅的兒子猶甲和祭司瑪西雅的兒子西番雅去見先知耶利米，說：求你為我們禱告耶和華─我們的神。',
    '耶37:4 那時耶利米在民中出入，因為他們還沒有把他囚在監裡。',
    '耶37:5 法老的軍隊已經從埃及出來，那圍困耶路撒冷的迦勒底人聽見他們的風聲，就拔營離開耶路撒冷去了。',
    '耶37:6 耶和華的話臨到先知耶利米說：',
    '耶37:7 耶和華─以色列的神如此說：猶大王打發你們來求問我，你們要如此對他說：那出來幫助你們法老的軍隊必回埃及本國去。',
    '耶37:8 迦勒底人必再來攻打這城，並要攻取，用火焚燒。',
    '耶37:9 耶和華如此說：你們不要自欺說迦勒底人必定離開我們，因為他們必不離開。',
    '耶37:10 你們即便殺敗了與你們爭戰的迦勒底全軍，但剩下受傷的人也必各人從帳棚裡起來，用火焚燒這城。',
    '耶37:11 迦勒底的軍隊因怕法老的軍隊，拔營離開耶路撒冷的時候，',
    '耶37:12 耶利米就雜在民中出離耶路撒冷，要往便雅憫地去，在那裡得自己的地業。',
    '耶37:13 他到了便雅憫門那裡，有守門官名叫伊利雅，是哈拿尼亞的孫子、示利米雅的兒子，他就拿住先知耶利米，說：你是投降迦勒底人哪！',
    '耶37:14 耶利米說：你這是謊話，我並不是投降迦勒底人。伊利雅不聽他的話，就拿住他，解到首領那裡。',
    '耶37:15 首領惱怒耶利米，就打了他，將他囚在文士約拿單的房屋中，因為他們以這房屋當作監牢。',
    '耶37:16 耶利米來到獄中，進入牢房，在那裡囚了多日。',
    '耶37:17 西底家王打發人提出他來，在自己的宮內私下問他說：從耶和華有什麼話臨到沒有﹖耶利米說：有！又說：你必交在巴比倫王手中。',
    '耶37:18 耶利米又對西底家王說：我在什麼事上得罪你，或你的臣僕，或這百姓，你竟將我囚在監裡呢﹖',
    '耶37:19 對你們預言巴比倫王必不來攻擊你們和這地的先知，現今在哪裡呢﹖',
    '耶37:20 主─我的王啊，求你現在垂聽，准我在你面前的懇求：不要使我回到文士約拿單的房屋中，免得我死在那裡。',
    '耶37:21 於是，西底家王下令，他們就把耶利米交在護衛兵的院中，每天從餅舖街取一個餅給他，直到城中的餅用盡了。這樣，耶利米仍在護衛兵的院中。',
    '耶38:1 瑪坦的兒子示法提雅、巴施戶珥的兒子基大利、示利米雅的兒子猶甲、瑪基雅的兒子巴示戶珥聽見耶利米對眾人所說的話，說：',
    '耶38:2 耶和華如此說：住在這城裡的必遭刀劍、饑荒、瘟疫而死；但出去歸降迦勒底人的必得存活，就是以自己命為掠物的，必得存活。',
    '耶38:3 耶和華如此說：這城必要交在巴比倫王軍隊的手中，他必攻取這城。',
    '耶38:4 於是首領對王說：求你將這人治死；因他向城裡剩下的兵丁和眾民說這樣的話，使他們的手發軟。這人不是求這百姓得平安，乃是叫他們受災禍。',
    '耶38:5 西底家王說：他在你們手中，無論何事，王也不能與你們反對。',
    '耶38:6 他們就拿住耶利米，下在哈米勒的兒子（或譯：王的兒子）瑪基雅的牢獄裡；那牢獄在護衛兵的院中。他們用繩子將耶利米繫下去。牢獄裡沒有水，只有淤泥，耶利米就陷在淤泥中。',
    '耶38:7 在王宮的太監古實人以伯‧米勒，聽見他們將耶利米下了牢獄（那時王坐在便雅憫門口），',
    '耶38:8 以伯‧米勒就從王宮裡出來，對王說：',
    '耶38:9 主─我的王啊，這些人向先知耶利米一味地行惡，將他下在牢獄中；他在那裡必因飢餓而死，因為城中再沒有糧食。',
    '耶38:10 王就吩咐古實人以伯‧米勒說：你從這裡帶領三十人，趁著先知耶利米未死以前，將他從牢獄中提上來。',
    '耶38:11 於是以伯‧米勒帶領這些人同去，進入王宮，到庫房以下，從那裡取了些碎布和破爛的衣服，用繩子縋下牢獄去到耶利米那裡。',
    '耶38:12 古實人以伯‧米勒對耶利米說：你用這些碎布和破爛的衣服放在繩子上，墊你的胳肢窩。耶利米就照樣行了。',
    '耶38:13 這樣，他們用繩子將耶利米從牢獄裡拉上來。耶利米仍在護衛兵的院中。',
    '耶38:14 西底家王打發人帶領先知耶利米，進耶和華殿中第三門裡見王。王就對耶利米說：我要問你一件事，你絲毫不可向我隱瞞。',
    '耶38:15 耶利米對西底家說：我若告訴你，你豈不定要殺我嗎﹖我若勸戒你，你必不聽從我。',
    '耶38:16 西底家王就私下向耶利米說：我指著那造我們生命之永生的耶和華起誓：我必不殺你，也不將你交在尋索你命的人手中。',
    '耶38:17 耶利米對西底家說：耶和華─萬軍之神、以色列的神如此說：你若出去歸降巴比倫王的首領，你的命就必存活，這城也不致被火焚燒，你和你的全家都必存活。',
    '耶38:18 你若不出去歸降巴比倫王的首領，這城必交在迦勒底人手中。他們必用火焚燒，你也不得脫離他們的手。',
    '耶38:19 西底家王對耶利米說：我怕那些投降迦勒底人的猶大人，恐怕迦勒底人將我交在他們手中，他們戲弄我。',
    '耶38:20 耶利米說：迦勒底人必不將你交出。求你聽從我對你所說耶和華的話，這樣你必得好處，你的命也必存活。',
    '耶38:21 你若不肯出去，耶和華指示我的話乃是這樣：',
    '耶38:22 猶大王宮裡所剩的婦女必都帶到巴比倫王的首領那裡。這些婦女必說：你知己的朋友催逼你，勝過你；見你的腳陷入淤泥中，就轉身退後了。',
    '耶38:23 人必將你的后妃和你的兒女帶到迦勒底人那裡；你也不得脫離他們的手，必被巴比倫王的手捉住；你也必使這城被火焚燒。',
    '耶38:24 西底家對耶利米說：不要使人知道這些話，你就不至於死。',
    '耶38:25 首領若聽見了我與你說話，就來見你，問你說：你對王說什麼話不要向我們隱瞞，我們就不殺你。王向你說什麼話也要告訴我們。',
    '耶38:26 你就對他們說：我在王面前懇求不要叫我回到約拿單的房屋死在那裡。',
    '耶38:27 隨後眾首領來見耶利米，問他，他就照王所吩咐的一切話回答他們。他們不再與他說話，因為事情沒有洩漏。',
    '耶38:28 於是耶利米仍在護衛兵的院中，直到耶路撒冷被攻取的日子。',
    '耶39:1 猶大王西底家第九年十月，巴比倫王尼布甲尼撒率領全軍來圍困耶路撒冷。',
    '耶39:2 西底家十一年四月初九日，城被攻破。',
    '耶39:3 耶路撒冷被攻取的時候，巴比倫王的首領尼甲‧沙利薛、三甲‧尼波、撒西金─拉撒力、尼甲‧沙利薛─拉墨，並巴比倫王其餘的一切首領都來坐在中門。',
    '耶39:4 猶大王西底家和一切兵丁看見他們，就在夜間從靠近王園兩城中間的門出城逃跑，往亞拉巴逃去。',
    '耶39:5 迦勒底的軍隊追趕他們，在耶利哥的平原追上西底家，將他拿住，帶到哈馬地的利比拉、巴比倫王尼布甲尼撒那裡；尼布甲尼撒就審判他。',
    '耶39:6 巴比倫王在利比拉、西底家眼前殺了他的眾子，又殺了猶大的一切貴冑，',
    '耶39:7 並且剜西底家的眼睛，用銅鍊鎖著他，要帶到巴比倫去。',
    '耶39:8 迦勒底人用火焚燒王宮和百姓的房屋，又拆毀耶路撒冷的城牆。',
    '耶39:9 那時，護衛長尼布撒拉旦將城裡所剩下的百姓和投降他的逃民，以及其餘的民都擄到巴比倫去了。',
    '耶39:10 護衛長尼布撒拉旦卻將民中毫無所有的窮人留在猶大地，當時給他們葡萄園和田地。',
    '耶39:11 巴比倫王尼布甲尼撒提到耶利米，囑咐護衛長尼布撒拉旦說：',
    '耶39:12 你領他去，好好地看待他，切不可害他；他對你怎麼說，你就向他怎麼行。',
    '耶39:13 護衛長尼布撒拉旦和尼布沙斯班─拉撒力、尼甲‧沙利薛─拉墨，並巴比倫王的一切官長，',
    '耶39:14 打發人去，將耶利米從護衛兵院中提出來，交與沙番的孫子亞希甘的兒子基大利，帶回家去。於是耶利米住在民中。',
    '耶39:15 耶利米還囚在護衛兵院中的時候，耶和華的話臨到他說：',
    '耶39:16 你去告訴古實人以伯‧米勒說，萬軍之耶和華─以色列的神如此說：我說降禍不降福的話必臨到這城，到那時必在你面前成就了。',
    '耶39:17 耶和華說：到那日我必拯救你，你必不致交在你所怕的人手中。',
    '耶39:18 我定要搭救你，你不致倒在刀下，卻要以自己的命為掠物，因你倚靠我。這是耶和華說的。',
    '耶40:1 耶利米鎖在耶路撒冷和猶大被擄到巴比倫的人中，護衛長尼布撒拉旦將他從拉瑪釋放以後，耶和華的話臨到耶利米。',
    '耶40:2 護衛長將耶利米叫來，對他說：耶和華─你的神曾說要降這禍與此地。',
    '耶40:3 耶和華使這禍臨到，照他所說的行了；因為你們得罪耶和華，沒有聽從他的話，所以這事臨到你們。',
    '耶40:4 現在我解開你手上的鍊子，你若看與我同往巴比倫去好，就可以去，我必厚待你；你若看與我同往巴比倫去不好，就不必去。看哪，全地在你面前，你以為哪裡美好，哪裡合宜，只管上那裡去吧！',
    '耶40:5 耶利米還沒有回去，護衛長說：你可以回到沙番的孫子亞希甘的兒子基大利那裡去；現在巴比倫王立他作猶大城邑的省長。你可以在他那裡住在民中，不然，你看哪裡合宜就可以上那裡去。於是護衛長送他糧食和禮物，釋放他去了。',
    '耶40:6 耶利米就到米斯巴見亞希甘的兒子基大利，在他那裡住在境內剩下的民中。',
    '耶40:7 在田野的一切軍長和屬他們的人聽見巴比倫王立了亞希甘的兒子基大利作境內的省長，並將沒有擄到巴比倫的男人、婦女、孩童，和境內極窮的人全交給他。',
    '耶40:8 於是軍長尼探雅的兒子以實瑪利，加利亞的兩個兒子約哈難和約拿單，單戶篾的兒子西萊雅，並尼陀法人以斐的眾子，瑪迦人的兒子耶撒尼亞和屬他們的人，都到米斯巴見基大利。',
    '耶40:9 沙番的孫子亞希甘的兒子基大利向他們和屬他們的人起誓說：不要怕服事迦勒底人，只管住在這地，服事巴比倫王，就可以得福。',
    '耶40:10 至於我，我要住在米斯巴，伺候那到我們這裡來的迦勒底人；只是你們當積蓄酒、油，和夏天的果子，收在器皿裡，住在你們所佔的城邑中。',
    '耶40:11 在摩押地和亞捫人中，在以東地和各國的一切猶大人，聽見巴比倫王留下些猶大人，並立沙番的孫子亞希甘的兒子基大利管理他們。',
    '耶40:12 這一切猶大人就從所趕到的各處回來，到猶大地米斯巴的基大利那裡，又積蓄了許多的酒，並夏天的果子。',
    '耶40:13 加利亞的兒子約哈難和在田野的一切軍長來到米斯巴見基大利，',
    '耶40:14 對他說：亞捫人的王巴利斯打發尼探雅的兒子以實瑪利來要你的命，你知道嗎﹖亞希甘的兒子基大利卻不信他們的話。',
    '耶40:15 加利亞的兒子約哈難在米斯巴私下對基大利說：求你容我去殺尼探雅的兒子以實瑪利，必無人知道。何必讓他要你的命，使聚集到你這裡來的猶大人都分散，以致猶大剩下的人都滅亡呢﹖',
    '耶40:16 亞希甘的兒子基大利對加利亞的兒子約哈難說：你不可行這事，你所論以實瑪利的話是假的。',
    '耶41:1 七月間，王的大臣宗室以利沙瑪的孫子、尼探雅的兒子以實瑪利帶著十個人，來到米斯巴見亞希甘的兒子基大利。他們在米斯巴一同吃飯。',
    '耶41:2 尼探雅的兒子以實瑪利和同他來的那十個人起來，用刀殺了沙番的孫子亞希甘的兒子基大利，就是巴比倫王所立為全地省長的。',
    '耶41:3 以實瑪利又殺了在米斯巴、基大利那裡的一切猶大人和所遇見的迦勒底兵丁。',
    '耶41:4 他殺了基大利，無人知道。',
    '耶41:5 第二天，有八十人從示劍和示羅，並撒瑪利亞來，鬍鬚剃去，衣服撕裂，身體劃破，手拿素祭和乳香，要奉到耶和華的殿。',
    '耶41:6 尼探雅的兒子以實瑪利出米斯巴迎接他們，隨走隨哭；遇見了他們，就對他們說：你們可以來見亞希甘的兒子基大利。',
    '耶41:7 他們到了城中，尼探雅的兒子以實瑪利和同著他的人就將他們殺了，拋在坑中。',
    '耶41:8 只是他們中間有十個人對以實瑪利說：不要殺我們，因為我們有許多大麥、小麥、油、蜜藏在田間。於是他住了手，沒有將他們殺在弟兄中間。',
    '耶41:9 以實瑪利將所殺之人的屍首都拋在坑裡基大利的旁邊；這坑是從前亞撒王因怕以色列王巴沙所挖的。尼探雅的兒子以實瑪利將那些被殺的人填滿了坑。',
    '耶41:10 以實瑪利將米斯巴剩下的人，就是眾公主和仍住在米斯巴所有的百姓，原是護衛長尼布撒拉旦交給亞希甘的兒子基大利的，都擄去了。尼探雅的兒子以實瑪利擄了他們，要往亞捫人那裡去。',
    '耶41:11 加利亞的兒子約哈難和同著他的眾軍長聽見尼探雅的兒子以實瑪利所行的一切惡，',
    '耶41:12 就帶領眾人前往，要和尼探雅的兒子以實瑪利爭戰，在基遍的大水旁（或譯：大水池旁）遇見他。',
    '耶41:13 以實瑪利那裡的眾人看見加利亞的兒子約哈難和同著他的眾軍長，就都歡喜。',
    '耶41:14 這樣，以實瑪利從米斯巴所擄去的眾人都轉身歸加利亞的兒子約哈難去了。',
    '耶41:15 尼探雅的兒子以實瑪利和八個人脫離約哈難的手，逃往亞捫人那裡去了。',
    '耶41:16 尼探雅的兒子以實瑪利殺了亞希甘的兒子基大利，從米斯巴將剩下的一切百姓、兵丁、婦女、孩童、太監擄到基遍之後，加利亞的兒子約哈難和同著他的眾軍長將他們都奪回來，',
    '耶41:17 帶到靠近伯利恆的金罕寓（或譯：基羅特金罕）住下，要進入埃及去；',
    '耶41:18 因為尼探雅的兒子以實瑪利殺了巴比倫王所立為省長的亞希甘的兒子基大利，約哈難懼怕迦勒底人。',
    '耶42:1 眾軍長和加利亞的兒子約哈難，並何沙雅的兒子耶撒尼亞（又名亞撒利雅，見43:2）以及眾百姓，從最小的到至大的都進前來，',
    '耶42:2 對先知耶利米說：求你准我們在你面前祈求，為我們這剩下的人禱告耶和華─你的神。我們本來眾多，現在剩下的極少，這是你親眼所見的。',
    '耶42:3 願耶和華─你的神指示我們所當走的路，所當做的事。',
    '耶42:4 先知耶利米對他們說：我已經聽見你們了，我必照著你們的話禱告耶和華─你們的神。耶和華無論回答什麼，我必都告訴你們，毫不隱瞞。',
    '耶42:5 於是他們對耶利米說：我們若不照耶和華─你的神差遣你來說的一切話行，願耶和華在我們中間作真實誠信的見證。',
    '耶42:6 我們現在請你到耶和華─我們的神面前，他說的無論是好是歹，我們都必聽從；我們聽從耶和華─我們神的話，就可以得福。',
    '耶42:7 過了十天，耶和華的話臨到耶利米。',
    '耶42:8 他就將加利亞的兒子約哈難和同著他的眾軍長，並眾百姓，從最小的到至大的都叫了來，',
    '耶42:9 對他們說：耶和華─以色列的神，就是你們請我在他面前為你們祈求的主，如此說：',
    '耶42:10 你們若仍住在這地，我就建立你們，必不拆毀，栽植你們，並不拔出，因我為降與你們的災禍後悔了。',
    '耶42:11 不要怕你們所怕的巴比倫王。耶和華說：不要怕他！因為我與你們同在，要拯救你們脫離他的手。',
    '耶42:12 我也要使他發憐憫，好憐憫你們，叫你們歸回本地。',
    '耶42:13 倘若你們說：我們不住在這地，以致不聽從耶和華─你們神的話，',
    '耶42:14 說：我們不住這地，卻要進入埃及地，在那裡看不見爭戰，聽不見角聲，也不致無食飢餓。我們必住在那裡。',
    '耶42:15 你們所剩下的猶大人哪，現在要聽耶和華的話。萬軍之耶和華─以色列的神如此說：你們若定意要進入埃及，在那裡寄居，',
    '耶42:16 你們所懼怕的刀劍在埃及地必追上你們！你們所懼怕的饑荒在埃及要緊緊地跟隨你們！你們必死在那裡！',
    '耶42:17 凡定意要進入埃及在那裡寄居的必遭刀劍、饑荒、瘟疫而死，無一人存留，逃脫我所降與他們的災禍。',
    '耶42:18 萬軍之耶和華─以色列的神如此說：我怎樣將我的怒氣和忿怒傾在耶路撒冷的居民身上，你們進入埃及的時候，我也必照樣將我的忿怒傾在你們身上，以致你們令人辱罵、驚駭、咒詛、羞辱，你們不得再見這地方。',
    '耶42:19 所剩下的猶大人哪，耶和華論到你們說：不要進入埃及去。你們要確實地知道我今日警教你們了。',
    '耶42:20 你們行詭詐自害；因為你們請我到耶和華─你們的神那裡，說：求你為我們禱告耶和華─我們神，照耶和華─我們的神一切所說的告訴我們，我們就必遵行。',
    '耶42:21 我今日將這話告訴你們，耶和華─你們的神為你們的事差遣我到你們那裡說的，你們卻一樣沒有聽從。',
    '耶42:22 現在你們要確實地知道，你們在所要去寄居之地必遭刀劍、饑荒、瘟疫而死。',
    '耶43:1 耶利米向眾百姓說完了耶和華─他們神的一切話，就是耶和華─他們神差遣他去所說的一切話。',
    '耶43:2 何沙雅的兒子亞撒利雅和加利亞的兒子約哈難，並一切狂傲的人，就對耶利米說：你說謊言！耶和華─我們的神並沒有差遣你來說：你們不可進入埃及，在那裡寄居。',
    '耶43:3 這是尼利亞的兒子巴錄挑唆你害我們，要將我們交在迦勒底人的手中，使我們有被殺的，有被擄到巴比倫去的。',
    '耶43:4 於是加利亞的兒子約哈難和一切軍長，並眾百姓，不聽從耶和華的話住在猶大地。',
    '耶43:5 加利亞的兒子約哈難和一切軍長卻將所剩下的猶大人，就是從被趕到各國回來在猶大地寄居的男人、婦女、孩童，和眾公主，並護衛長尼布撒拉旦所留在沙番的孫子亞希甘的兒子基大利那裡的眾人，與先知耶利米，以及尼利亞的兒子巴錄，',
    '耶43:6 併於上節。',
    '耶43:7 都帶入埃及地，到了答比匿。這是因他們不聽從耶和華的話。',
    '耶43:8 在答比匿，耶和華的話臨到耶利米說：',
    '耶43:9 你在猶大人眼前要用手拿幾塊大石頭，藏在砌磚的灰泥中，就是在答比匿法老的宮門那裡，',
    '耶43:10 對他們說：萬軍之耶和華─以色列的神如此說：我必召我的僕人巴比倫王尼布甲尼撒來。在所藏的石頭上我要安置他的寶座；他必將光華的寶帳支搭在其上。',
    '耶43:11 他要來攻擊埃及地，定為死亡的，必致死亡；定為擄掠的，必被擄掠；定為刀殺的，必交刀殺。',
    '耶43:12 我要在埃及神的廟中使火著起，巴比倫王要將廟宇焚燒，神像擄去；他要得（原文是披上）埃及地，好像牧人披上外衣，從那裡安然而去。',
    '耶43:13 他必打碎埃及地伯示麥的柱像，用火焚燒埃及神的廟宇。',
    '耶44:1 有臨到耶利米的話，論及一切住在埃及地的猶大人，就是住在密奪、答比匿、挪弗、巴忒羅境內的猶大人，說：',
    '耶44:2 萬軍之耶和華─以色列的神如此說：我所降與耶路撒冷和猶大各城的一切災禍你們都看見了。那些城邑今日荒涼，無人居住；',
    '耶44:3 這是因居民所行的惡，去燒香事奉別神，就是他們和你們，並你們列祖所不認識的神，惹我發怒。',
    '耶44:4 我從早起來差遣我的僕人眾先知去說，你們切不要行我所厭惡這可憎之事。',
    '耶44:5 他們卻不聽從，不側耳而聽，不轉離惡事，仍向別神燒香。',
    '耶44:6 因此，我的怒氣和忿怒都倒出來，在猶大城邑中和耶路撒冷的街市上，如火著起，以致都荒廢淒涼，正如今日一樣。',
    '耶44:7 現在耶和華─萬軍之神、以色列的神如此說：你們為何作這大惡自害己命，使你們的男人、婦女、嬰孩，和吃奶的都從猶大中剪除、不留一人呢﹖',
    '耶44:8 就是因你們手所做的，在所去寄居的埃及地向別神燒香惹我發怒，使你們被剪除，在天下萬國中令人咒詛羞辱。',
    '耶44:9 你們列祖的惡行，猶大列王和他們后妃的惡行，你們自己和你們妻子的惡行，就是在猶大地、耶路撒冷街上所行的，你們都忘了嗎﹖',
    '耶44:10 到如今還沒有懊悔，沒有懼怕，沒有遵行我在你們和你們列祖面前所設立的法度律例。',
    '耶44:11 所以萬軍之耶和華─以色列的神如此說：我必向你們變臉降災，以致剪除猶大眾人。',
    '耶44:12 那定意進入埃及地、在那裡寄居的，就是所剩下的猶大人，我必使他們盡都滅絕，必在埃及地仆倒，必因刀劍饑荒滅絕；從最小的到至大的都必遭刀劍饑荒而死，以致令人辱罵、驚駭、咒詛、羞辱。',
    '耶44:13 我怎樣用刀劍、饑荒、瘟疫刑罰耶路撒冷，也必照樣刑罰那些住在埃及地的猶大人；',
    '耶44:14 甚至那進入埃及地寄居的，就是所剩下的猶大人，都不得逃脫，也不得存留歸回猶大地。他們心中甚想歸回居住之地；除了逃脫的以外，一個都不能歸回。',
    '耶44:15 那些住在埃及地巴忒羅知道自己妻子向別神燒香的，與旁邊站立的眾婦女，聚集成群，回答耶利米說：',
    '耶44:16 論到你奉耶和華的名向我們所說的話，我們必不聽從。',
    '耶44:17 我們定要成就我們口中所出的一切話，向天后燒香、澆奠祭，按著我們與我們列祖、君王、首領在猶大的城邑中和耶路撒冷的街市上素常所行的一樣；因為那時我們吃飽飯、享福樂，並不見災禍。',
    '耶44:18 自從我們停止向天后燒香、澆奠祭，我們倒缺乏一切，又因刀劍饑荒滅絕。',
    '耶44:19 婦女說：我們向天后燒香、澆奠祭，做天后像的餅供奉他，向他澆奠祭，是外乎我們的丈夫嗎﹖',
    '耶44:20 耶利米對一切那樣回答他的男人婦女說：',
    '耶44:21 你們與你們列祖、君王、首領，並國內的百姓，在猶大城邑中和耶路撒冷街市上所燒的香，耶和華豈不記念，心中豈不思想嗎﹖',
    '耶44:22 耶和華因你們所作的惡、所行可憎的事，不能再容忍，所以你們的地荒涼，令人驚駭咒詛，無人居住，正如今日一樣。',
    '耶44:23 你們燒香，得罪耶和華，沒有聽從他的話，沒有遵行他的律法、條例、法度，所以你們遭遇這災禍，正如今日一樣。',
    '耶44:24 耶利米又對眾民和眾婦女說：你們在埃及地的一切猶大人當聽耶和華的話。',
    '耶44:25 萬軍之耶和華─以色列的神如此說：你們和你們的妻都口中說、手裡做，說：我們定要償還所許的願，向天后燒香、澆奠祭。現在你們只管堅定所許的願而償還吧！',
    '耶44:26 所以你們住在埃及地的一切猶大人當聽耶和華的話。耶和華說：我指著我的大名起誓，在埃及全地，我的名不再被猶大一個人的口稱呼說：我指著主─永生的耶和華起誓。',
    '耶44:27 我向他們留意降禍不降福；在埃及地的一切猶大人必因刀劍、饑荒所滅，直到滅盡。',
    '耶44:28 脫離刀劍、從埃及地歸回猶大地的人數很少；那進入埃及地要在那裡寄居的，就是所剩下的猶大人，必知道是誰的話立得住，是我的話呢﹖是他們的話呢﹖',
    '耶44:29 耶和華說：我在這地方刑罰你們，必有預兆，使你們知道我降禍與你們的話必要立得住。',
    '耶44:30 耶和華如此說：我必將埃及王法老合弗拉交在他仇敵和尋索其命的人手中，像我將猶大王西底家交在他仇敵和尋索其命的巴比倫王尼布甲尼撒手中一樣。',
    '耶45:1 猶大王約西亞的兒子約雅敬第四年，尼利亞的兒子巴錄將先知耶利米口中所說的話寫在書上。耶利米說：',
    '耶45:2 巴錄啊，耶和華─以色列的神說：',
    '耶45:3 巴錄（原文是你）曾說：哀哉！耶和華將憂愁加在我的痛苦上，我因唉哼而困乏，不得安歇。',
    '耶45:4 你要這樣告訴他，耶和華如此說：我所建立的，我必拆毀；我所栽植的，我必拔出；在全地我都如此行。',
    '耶45:5 你為自己圖謀大事嗎﹖不要圖謀！我必使災禍臨到凡有血氣的。但你無論往哪裡去，我必使你以自己的命為掠物。這是耶和華說的。',
    '耶46:1 耶和華論列國的話臨到先知耶利米。',
    '耶46:2 論到關乎埃及王法老尼哥的軍隊：這軍隊安營在伯拉河邊的迦基米施，是巴比倫王尼布甲尼撒在猶大王約西亞的兒子約雅敬第四年所打敗的。',
    '耶46:3 你們要預備大小盾牌，往前上陣。',
    '耶46:4 你們套上車，騎上馬！頂盔站立，磨槍貫甲！',
    '耶46:5 我為何看見他們驚惶轉身退後呢﹖他們的勇士打敗了，急忙逃跑，並不回頭；驚嚇四圍都有！這是耶和華說的。',
    '耶46:6 不要容快跑的逃避；不要容勇士逃脫（或譯：快跑的不能逃避；勇士不能逃脫）；他們在北方伯拉河邊絆跌仆倒。',
    '耶46:7 像尼羅河漲發，像江河之水翻騰的是誰呢﹖',
    '耶46:8 埃及像尼羅河漲發，像江河的水翻騰。他說：我要漲發遮蓋遍地；我要毀滅城邑和其中的居民。',
    '耶46:9 馬匹上去吧！車輛急行吧！勇士，就是手拿盾牌的古實人和弗人（又作呂彼亞人），並拉弓的路德族，都出去吧！',
    '耶46:10 那日是主─萬軍之耶和華報仇的日子，要向敵人報仇。刀劍必吞吃得飽，飲血飲足；因為主─萬軍之耶和華在北方伯拉河邊有獻祭的事。',
    '耶46:11 埃及的民（原文是處女）哪，可以上基列取乳香去；你雖多服良藥，總是徒然，不得治好。',
    '耶46:12 列國聽見你的羞辱，遍地滿了你的哀聲；勇士與勇士彼此相碰，一齊跌倒。',
    '耶46:13 耶和華對先知耶利米所說的話，論到巴比倫王尼布甲尼撒要來攻擊埃及地：',
    '耶46:14 你們要傳揚在埃及，宣告在密奪，報告在挪弗、答比匿說：要站起出隊，自作準備，因為刀劍在你四圍施行吞滅的事。',
    '耶46:15 你的壯士為何被沖去呢﹖他們站立不住；因為耶和華驅逐他們，',
    '耶46:16 使多人絆跌；他們也彼此撞倒，說：起來吧！我們再往本民本地去，好躲避欺壓的刀劍。',
    '耶46:17 他們在那裡喊叫說：埃及王法老不過是個聲音（或譯：已經敗亡）；他已錯過所定的時候了。',
    '耶46:18 君王─名為萬軍之耶和華的說：我指著我的永生起誓：尼布甲尼撒（原文是他）來的勢派必像他泊在眾山之中，像迦密在海邊一樣。',
    '耶46:19 住在埃及的民哪（原文是女子），要預備擄去時所用的物件；因為挪弗必成為荒場，且被燒毀，無人居住。',
    '耶46:20 埃及是肥美的母牛犢；但出於北方的毀滅（或譯：牛虻）來到了！來到了！',
    '耶46:21 其中的雇勇好像圈裡的肥牛犢，他們轉身退後，一齊逃跑，站立不住；因為他們遭難的日子、追討的時候已經臨到。',
    '耶46:22 其中的聲音好像蛇行一樣。敵人要成隊而來，如砍伐樹木的手拿斧子攻擊他。',
    '耶46:23 耶和華說：埃及的樹林雖然不能尋察（或譯：穿不過），敵人卻要砍伐，因他們多於蝗蟲，不可勝數。',
    '耶46:24 埃及的民（原文是女子）必然蒙羞，必交在北方人的手中。',
    '耶46:25 萬軍之耶和華─以色列的神說：我必刑罰挪的亞捫（埃及尊大之神）和法老，並埃及與埃及的神，以及君王，也必刑罰法老和倚靠他的人。',
    '耶46:26 我要將他們交付尋索其命之人的手和巴比倫王尼布甲尼撒與他臣僕的手；以後埃及必再有人居住，與從前一樣。這是耶和華說的。',
    '耶46:27 我的僕人雅各啊，不要懼怕！以色列啊，不要驚惶！因我要從遠方拯救你，從被擄到之地拯救你的後裔。雅各必回來，得享平靖安逸，無人使他害怕。',
    '耶46:28 我的僕人雅各啊，不要懼怕！因我與你同在。我要將我所趕你到的那些國滅絕淨盡，卻不將你滅絕淨盡，倒要從寬懲治你，萬不能不罰你（不罰你：或譯以你為無罪）。這是耶和華說的。',
    '耶47:1 法老攻擊迦薩之先，有耶和華論非利士人的話臨到先知耶利米。',
    '耶47:2 耶和華如此說：有水從北方發起，成為漲溢的河，要漲過遍地和其中所有的，並城和其中所住的。人必呼喊；境內的居民都必哀號。',
    '耶47:3 聽見敵人壯馬蹄跳的響聲和戰車隆隆、車輪轟轟；為父的手就發軟，不回頭看顧兒女。',
    '耶47:4 因為日子將到，要毀滅一切非利士人，剪除幫助推羅、西頓所剩下的人。原來耶和華必毀滅非利士人，就是迦斐託海島餘剩的人。',
    '耶47:5 迦薩成了光禿；平原中所剩的亞實基倫歸於無有。你用刀劃身，要到幾時呢﹖',
    '耶47:6 耶和華的刀劍哪，你到幾時才止息呢﹖你要入鞘，安靖不動。',
    '耶47:7 耶和華既吩咐你攻擊亞實基倫和海邊之地，他已經派定你，焉能止息呢﹖',
    '耶48:1 論摩押。萬軍之耶和華─以色列的神如此說：尼波有禍了！因變為荒場。基列亭蒙羞被攻取；米斯迦蒙羞被毀壞；',
    '耶48:2 摩押不再被稱讚。有人在希實本設計謀害他，說：來吧！我們將他剪除，不再成國。瑪得緬哪，你也必默默無聲；刀劍必追趕你。',
    '耶48:3 從何羅念有喊荒涼大毀滅的哀聲：',
    '耶48:4 摩押毀滅了！他的孩童（或譯：家僮）發哀聲，使人聽見。',
    '耶48:5 人上魯希坡隨走隨哭，因為在何羅念的下坡聽見毀滅的哀聲。',
    '耶48:6 你們要奔逃，自救性命，獨自居住，好像曠野的杜松。',
    '耶48:7 你因倚靠自己所做的和自己的財寶必被攻取。基抹和屬他的祭司、首領也要一同被擄去。',
    '耶48:8 行毀滅的必來到各城，並無一城得免。山谷必致敗落，平原必被毀壞；正如耶和華所說的。',
    '耶48:9 要將翅膀給摩押，使他可以飛去。他的城邑必致荒涼，無人居住。',
    '耶48:10 （懶惰為耶和華行事的，必受咒詛；禁止刀劍不經血的，必受咒詛。）',
    '耶48:11 摩押自幼年以來常享安逸，如酒在渣滓上澄清，沒有從這器皿倒在那器皿裡，也未曾被擄去。因此，他的原味尚存，香氣未變。',
    '耶48:12 耶和華說：日子將到，我必打發倒酒的往他那裡去，將他倒出來，倒空他的器皿，打碎他的罈子。',
    '耶48:13 摩押必因基抹羞愧，像以色列家從前倚靠伯特利的神羞愧一樣。',
    '耶48:14 你們怎麼說：我們是勇士，是有勇力打仗的呢﹖',
    '耶48:15 摩押變為荒場，敵人上去進了他的城邑。他所特選的少年人下去遭了殺戮；這是君王─名為萬軍之耶和華說的。',
    '耶48:16 摩押的災殃臨近；他的苦難速速來到。',
    '耶48:17 凡在他四圍的和認識他名的，你們都要為他悲傷，說：那結實的杖和那美好的棍，何竟折斷了呢﹖',
    '耶48:18 住在底本的民哪（原文是女子），要從你榮耀的位上下來，坐受乾渴；因毀滅摩押的上來攻擊你，毀壞了你的保障。',
    '耶48:19 住亞羅珥的啊，要站在道旁觀望，問逃避的男人和逃脫的女人說：是什麼事呢﹖',
    '耶48:20 摩押因毀壞蒙羞；你們要哀號呼喊，要在亞嫩旁報告說：摩押變為荒場！',
    '耶48:21 刑罰臨到平原之地的何倫、雅雜、米法押、',
    '耶48:22 底本、尼波、伯‧低比拉太音、',
    '耶48:23 基列亭、伯‧迦末、伯‧米恩、',
    '耶48:24 加略、波斯拉，和摩押地遠近所有的城邑。',
    '耶48:25 摩押的角砍斷了，摩押的膀臂折斷了。這是耶和華說的。',
    '耶48:26 你們要使摩押沉醉，因他向耶和華誇大。他要在自己所吐之中打滾，又要被人嗤笑。',
    '耶48:27 摩押啊，你不曾嗤笑以色列嗎﹖他豈是在賊中查出來的呢﹖你每逢提到他便搖頭。',
    '耶48:28 摩押的居民哪，要離開城邑，住在山崖裡，像鴿子在深淵口上搭窩。',
    '耶48:29 我們聽說摩押人驕傲，是極其驕傲；聽說他自高自傲，並且狂妄，居心自大。',
    '耶48:30 耶和華說：我知道他的忿怒是虛空的；他誇大的話一無所成。',
    '耶48:31 因此，我要為摩押哀號，為摩押全地呼喊；人必為吉珥‧哈列設人歎息。',
    '耶48:32 西比瑪的葡萄樹啊，我為你哀哭，甚於雅謝人哀哭。你的枝子蔓延過海，直長到雅謝海。那行毀滅的已經臨到你夏天的果子和你所摘的葡萄。',
    '耶48:33 肥田和摩押地的歡喜快樂都被奪去；我使酒醡的酒絕流，無人踹酒歡呼；那歡呼卻變為仇敵的吶喊（原文是那歡呼卻不是歡呼）。',
    '耶48:34 希實本人發的哀聲達到以利亞利，直達到雅雜；從瑣珥達到何羅念，直到伊基拉施利施亞，因為寧林的水必然乾涸。',
    '耶48:35 耶和華說：我必在摩押地使那在邱壇獻祭的，和那向他的神燒香的都斷絕了。',
    '耶48:36 我心腹為摩押哀鳴如簫，我心腸為吉珥‧哈列設人也是如此，因摩押人所得的財物都滅沒了。',
    '耶48:37 各人頭上光禿，鬍鬚剪短，手有劃傷，腰束麻布。',
    '耶48:38 在摩押的各房頂上和街市上處處有人哀哭；因我打碎摩押，好像打碎無人喜悅的器皿。這是耶和華說的。',
    '耶48:39 摩押何等毀壞！何等哀號！何等羞愧轉背！這樣，摩押必令四圍的人嗤笑驚駭。',
    '耶48:40 耶和華如此說：仇敵必如大鷹飛起，展開翅膀，攻擊摩押。',
    '耶48:41 加略被攻取，保障也被佔據。到那日，摩押的勇士心中疼痛如臨產的婦人。',
    '耶48:42 摩押必被毀滅，不再成國，因他向耶和華誇大。',
    '耶48:43 耶和華說：摩押的居民哪，恐懼、陷坑、網羅都臨近你。',
    '耶48:44 躲避恐懼的必墜入陷坑；從陷坑上來的必被網羅纏住；因我必使追討之年臨到摩押。這是耶和華說的。',
    '耶48:45 躲避的人無力站在希實本的影下；因為有火從希實本發出，有火焰出於西宏的城，燒盡摩押的角和鬨嚷人的頭頂。',
    '耶48:46 摩押啊，你有禍了！屬基抹的民滅亡了！因你的眾子都被擄去，你的眾女也被擄去。',
    '耶48:47 耶和華說：到末後，我還要使被擄的摩押人歸回。摩押受審判的話到此為止。',
    '耶49:1 論亞捫人。耶和華如此說：以色列沒有兒子嗎﹖沒有後嗣嗎﹖瑪勒堪為何得迦得之地為業呢﹖屬他的民為何住其中的城邑呢﹖',
    '耶49:2 耶和華說：日子將到，我必使人聽見打仗的喊聲，是攻擊亞捫人拉巴的喊聲。拉巴要成為亂堆；屬他的鄉村（原文是女子）要被火焚燒。先前得以色列地為業的，此時以色列倒要得他們的地為業。這是耶和華說的。',
    '耶49:3 希實本哪，你要哀號，因為愛地變為荒場。拉巴的居民（原文是女子）哪，要呼喊，以麻布束腰；要哭號，在籬笆中跑來跑去；因瑪勒堪和屬他的祭司、首領要一同被擄去。',
    '耶49:4 背道的民（原文是女子）哪，你們為何因有山谷，就是水流的山谷誇張呢﹖為何倚靠財寶說：誰能來到我們這裡呢﹖',
    '耶49:5 主─萬軍之耶和華說：我要使恐嚇從四圍的人中臨到你們；你們必被趕出，各人一直前往，沒有人收聚逃民。',
    '耶49:6 後來我還要使被擄的亞捫人歸回。這是耶和華說的。',
    '耶49:7 論以東。萬軍之耶和華如此說：提幔中再沒有智慧嗎﹖明哲人不再有謀略嗎﹖他們的智慧盡歸無有嗎﹖',
    '耶49:8 底但的居民哪，要轉身逃跑，住在深密處；因為我向以掃追討的時候，必使災殃臨到他。',
    '耶49:9 摘葡萄的若來到他那裡，豈不剩下些葡萄呢﹖盜賊若夜間而來，豈不毀壞直到夠了呢﹖',
    '耶49:10 我卻使以掃赤露，顯出他的隱密處；他不能自藏。他的後裔、弟兄、鄰舍盡都滅絕；他也歸於無有。',
    '耶49:11 你撇下孤兒，我必保全他們的命；你的寡婦可以倚靠我。',
    '耶49:12 耶和華如此說：原不該喝那杯的一定要喝。你能盡免刑罰嗎﹖你必不能免，一定要喝！',
    '耶49:13 耶和華說：我指著自己起誓，波斯拉必令人驚駭、羞辱、咒詛，並且荒涼。他的一切城邑必變為永遠的荒場。',
    '耶49:14 我從耶和華那裡聽見信息，並有使者被差往列國去，說：你們聚集來攻擊以東，要起來爭戰。',
    '耶49:15 我使你在列國中為最小，在世人中被藐視。',
    '耶49:16 住在山穴中據守山頂的啊，論到你的威嚇，你因心中的狂傲自欺；你雖如大鷹高高搭窩，我卻從那裡拉下你來。這是耶和華說的。',
    '耶49:17 以東必令人驚駭；凡經過的人就受驚駭，又因他一切的災禍嗤笑。',
    '耶49:18 耶和華說：必無人住在那裡，也無人在其中寄居，要像所多瑪、蛾摩拉，和鄰近的城邑傾覆的時候一樣。',
    '耶49:19 仇敵必像獅子從約但河邊的叢林上來，攻擊堅固的居所。轉眼之間，我要使以東人逃跑，離開這地。誰蒙揀選，我就派誰治理這地。誰能比我呢﹖誰能給我定規日期呢﹖有何牧人能在我面前站立得住呢﹖',
    '耶49:20 你們要聽耶和華攻擊以東所說的謀略和他攻擊提幔居民所定的旨意。仇敵定要將他們群眾微弱的拉去，定要使他們的居所荒涼。',
    '耶49:21 因他們仆倒的聲音，地就震動。人在紅海那裡必聽見呼喊的聲音。',
    '耶49:22 仇敵必如大鷹飛起，展開翅膀攻擊波斯拉。到那日，以東的勇士心中疼痛如臨產的婦人。',
    '耶49:23 論大馬色。哈馬和亞珥拔蒙羞，因他們聽見凶惡的信息就消化了。海上有憂愁，不得平靜。',
    '耶49:24 大馬色發軟，轉身逃跑。戰兢將他捉住；痛苦憂愁將他抓住，如產難的婦人一樣。',
    '耶49:25 我所喜樂可稱讚的城，為何被撇棄了呢﹖',
    '耶49:26 他的少年人必仆倒在街上；當那日，一切兵丁必默默無聲。這是萬軍之耶和華說的。',
    '耶49:27 我必在大馬色城中使火著起，燒滅便哈達的宮殿。',
    '耶49:28 論巴比倫王尼布甲尼撒所攻打的基達和夏瑣的諸國。耶和華如此說：迦勒底人哪，起來上基達去，毀滅東方人。',
    '耶49:29 他們的帳棚和羊群都要奪去，將幔子和一切器皿，並駱駝為自己掠去。人向他們喊著說：四圍都有驚嚇。',
    '耶49:30 耶和華說：夏瑣的居民哪，要逃奔遠方，住在深密處；因為巴比倫王尼布甲尼撒設計謀害你們，起意攻擊你們。',
    '耶49:31 耶和華說：迦勒底人哪，起來！上安逸無慮的居民那裡去；他們是無門無閂、獨自居住的。',
    '耶49:32 他們的駱駝必成為掠物；他們眾多的牲畜必成為擄物。我必將剃周圍頭髮的人分散四方（原文是風），使災殃從四圍臨到他們。這是耶和華說的。',
    '耶49:33 夏瑣必成為野狗的住處，永遠淒涼；必無人住在那裡，也無人在其中寄居。',
    '耶49:34 猶大王西底家登基的時候，耶和華論以攔的話臨到先知耶利米說：',
    '耶49:35 萬軍之耶和華如此說：我必折斷以攔人的弓，就是他們為首的權力。',
    '耶49:36 我要使四風從天的四方颳來，臨到以攔人，將他們分散四方（原文是風）。這被趕散的人沒有一國不到的。',
    '耶49:37 耶和華說：我必使以攔人在仇敵和尋索其命的人面前驚惶；我也必使災禍，就是我的烈怒臨到他們，又必使刀劍追殺他們，直到將他們滅盡。',
    '耶49:38 我要在以攔設立我的寶座，從那裡除滅君王和首領。這是耶和華說的。',
    '耶49:39 到末後，我還要使被擄的以攔人歸回。這是耶和華說的。',
    '耶50:1 耶和華藉先知耶利米論巴比倫和迦勒底人之地所說的話。',
    '耶50:2 你們要在萬國中傳揚報告，豎立大旗；要報告，不可隱瞞，說：巴比倫被攻取，彼勒蒙羞，米羅達驚惶。巴比倫的神像都蒙羞；他的偶像都驚惶。',
    '耶50:3 因有一國從北方上來攻擊他，使他的地荒涼，無人居住，連人帶牲畜都逃走了。',
    '耶50:4 耶和華說：當那日子、那時候，以色列人要和猶大人同來，隨走隨哭，尋求耶和華─他們的神。',
    '耶50:5 他們必訪問錫安，又面向這裡，說：來吧，你們要與耶和華聯合為永遠不忘的約。',
    '耶50:6 我的百姓作了迷失的羊，牧人使他們走差路，使他們轉到山上。他們從大山走到小山，竟忘了安歇之處。',
    '耶50:7 凡遇見他們的，就把他們吞滅。敵人說：我們沒有罪；因他們得罪那作公義居所的耶和華，就是他們列祖所仰望的耶和華。',
    '耶50:8 我民哪，你們要從巴比倫中逃走，從迦勒底人之地出去，要像羊群前面走的公山羊。',
    '耶50:9 因我必激動聯合的大國從北方上來攻擊巴比倫，他們要擺陣攻擊他；他必從那裡被攻取。他們的箭好像善射之勇士的箭，一枝也不徒然返回。',
    '耶50:10 迦勒底必成為掠物；凡擄掠他的都必心滿意足。這是耶和華說的。',
    '耶50:11 搶奪我產業的啊，你們因歡喜快樂，且像踹穀撒歡的母牛犢，又像發嘶聲的壯馬。',
    '耶50:12 你們的母巴比倫就極其抱愧，生你們的必然蒙羞。他要列在諸國之末，成為曠野、旱地、沙漠。',
    '耶50:13 因耶和華的忿怒，必無人居住，要全然荒涼。凡經過巴比倫的要受驚駭，又因他所遭的災殃嗤笑。',
    '耶50:14 所有拉弓的，你們要在巴比倫的四圍擺陣，射箭攻擊他。不要愛惜箭枝，因他得罪了耶和華。',
    '耶50:15 你們要在他四圍吶喊；他已經投降。外郭坍塌了，城牆拆毀了，因為這是耶和華報仇的事。你們要向巴比倫報仇；他怎樣待人，也要怎樣待他。',
    '耶50:16 你們要將巴比倫撒種的和收割時拿鐮刀的都剪除了。他們各人因怕欺壓的刀劍，必歸回本族，逃到本土。',
    '耶50:17 以色列是打散的羊，是被獅子趕出的。首先是亞述王將他吞滅，末後是巴比倫王尼布甲尼撒將他的骨頭折斷。',
    '耶50:18 所以萬軍之耶和華─以色列的神如此說：我必罰巴比倫王和他的地，像我從前罰亞述王一樣。',
    '耶50:19 我必再領以色列回他的草場，他必在迦密和巴珊吃草，又在以法蓮山上和基列境內得以飽足。',
    '耶50:20 耶和華說：當那日子、那時候，雖尋以色列的罪孽，一無所有；雖尋猶大的罪惡，也無所見；因為我所留下的人，我必赦免。',
    '耶50:21 耶和華說：上去攻擊米拉大翁之地，又攻擊比割的居民。要追殺滅盡，照我一切所吩咐你的去行。',
    '耶50:22 境內有打仗和大毀滅的響聲。',
    '耶50:23 全地的大錘何竟砍斷破壞﹖巴比倫在列國中何竟荒涼﹖',
    '耶50:24 巴比倫哪，我為你設下網羅，你不知不覺被纏住。你被尋著，也被捉住；因為你與耶和華爭競。',
    '耶50:25 耶和華已經開了武庫，拿出他惱恨的兵器；因為主─萬軍之耶和華在迦勒底人之地有當做的事。',
    '耶50:26 你們要從極遠的邊界來攻擊他，開他的倉廩，將他堆如高堆，毀滅淨盡，絲毫不留。',
    '耶50:27 要殺他的一切牛犢，使他們下去遭遇殺戮。他們有禍了，因為追討他們的日子已經來到。',
    '耶50:28 （有從巴比倫之地逃避出來的人，在錫安揚聲報告耶和華─我們的神報仇，就是為他的殿報仇。）',
    '耶50:29 招集一切弓箭手來攻擊巴比倫。要在巴比倫四圍安營，不要容一人逃脫，照著他所做的報應他；他怎樣待人，也要怎樣待他，因為他向耶和華─以色列的聖者發了狂傲。',
    '耶50:30 所以他的少年人必仆倒在街上。當那日，一切兵丁必默默無聲。這是耶和華說的。',
    '耶50:31 主─萬軍之耶和華說：你這狂傲的啊，我與你反對，因為我追討你的日子已經來到。',
    '耶50:32 狂傲的必絆跌仆倒，無人扶起。我也必使火在他的城邑中著起來，將他四圍所有的盡行燒滅。',
    '耶50:33 萬軍之耶和華如此說：以色列人和猶大人一同受欺壓；凡擄掠他們的都緊緊抓住他們，不肯釋放。',
    '耶50:34 他們的救贖主大有能力，萬軍之耶和華是他的名。他必伸清他們的冤，好使全地得平安，並攪擾巴比倫的居民。',
    '耶50:35 耶和華說：有刀劍臨到迦勒底人和巴比倫的居民，並他的首領與智慧人。',
    '耶50:36 有刀劍臨到矜誇的人，他們就成為愚昧；有刀劍臨到他的勇士，他們就驚惶。',
    '耶50:37 有刀劍臨到他的馬匹、車輛，和其中雜族的人民；他們必像婦女一樣。有刀劍臨到他的寶物，就被搶奪。',
    '耶50:38 有乾旱臨到他的眾水，就必乾涸；因為這是有雕刻偶像之地，人因偶像而顛狂。',
    '耶50:39 所以曠野的走獸和豺狼必住在那裡，鴕鳥也住在其中，永無人煙，世世代代無人居住。',
    '耶50:40 耶和華說：必無人住在那裡，也無人在其中寄居，要像我傾覆所多瑪、蛾摩拉，和鄰近的城邑一樣。',
    '耶50:41 看哪，有一種民從北方而來，並有一大國和許多君王被激動，從地極來到。',
    '耶50:42 他們拿弓和槍，性情殘忍，不施憐憫；他們的聲音像海浪匉訇。巴比倫城（原文是女子）啊，他們騎馬，都擺隊伍如上戰場的人，要攻擊你。',
    '耶50:43 巴比倫王聽見他們的風聲，手就發軟，痛苦將他抓住，疼痛彷彿產難的婦人。',
    '耶50:44 仇敵必像獅子從約但河邊的叢林上來，攻擊堅固的居所。轉眼之間，我要使他們逃跑，離開這地。誰蒙揀選，我就派誰治理這地。誰能比我呢﹖誰能給我定規日期呢﹖有何牧人能在我面前站立得住呢﹖',
    '耶50:45 你們要聽耶和華攻擊巴比倫所說的謀略和他攻擊迦勒底人之地所定的旨意。仇敵定要將他們群眾微弱的拉去，定要使他們的居所荒涼。',
    '耶50:46 因巴比倫被取的聲音，地就震動，人在列邦都聽見呼喊的聲音。',
    '耶51:1 耶和華如此說：我必使毀滅的風颳起，攻擊巴比倫和住在立加米的人。',
    '耶51:2 我要打發外邦人來到巴比倫，簸揚他，使他的地空虛。在他遭禍的日子，他們要周圍攻擊他。',
    '耶51:3 拉弓的，要向拉弓的和貫甲挺身的射箭。不要憐惜他的少年人；要滅盡他的全軍。',
    '耶51:4 他們必在迦勒底人之地被殺仆倒，在巴比倫的街上被刺透。',
    '耶51:5 以色列和猶大雖然境內充滿違背以色列聖者的罪，卻沒有被他的神─萬軍之耶和華丟棄。',
    '耶51:6 你們要從巴比倫中逃奔，各救自己的性命！不要陷在他的罪孽中一同滅亡；因為這是耶和華報仇的時候，他必向巴比倫施行報應。',
    '耶51:7 巴比倫素來是耶和華手中的金杯，使天下沉醉；萬國喝了他的酒就顛狂了。',
    '耶51:8 巴比倫忽然傾覆毀壞；要為他哀號；為止他的疼痛，拿乳香或者可以治好。',
    '耶51:9 我們想醫治巴比倫，他卻沒有治好。離開他吧！我們各人歸回本國；因為他受的審判通於上天，達到穹蒼。',
    '耶51:10 耶和華已經彰顯我們的公義。來吧！我們可以在錫安報告耶和華─我們神的作為。',
    '耶51:11 你們要磨尖了箭頭，抓住盾牌。耶和華定意攻擊巴比倫，將他毀滅，所以激動了瑪代君王的心；因這是耶和華報仇，就是為自己的殿報仇。',
    '耶51:12 你們要豎立大旗，攻擊巴比倫的城牆；要堅固瞭望臺，派定守望的設下埋伏；因為耶和華指著巴比倫居民所說的話、所定的意，他已經作成。',
    '耶51:13 住在眾水之上多有財寶的啊，你的結局到了！你貪婪之量滿了！',
    '耶51:14 萬軍之耶和華指著自己起誓說：我必使敵人充滿你，像螞蚱一樣；他們必吶喊攻擊你。',
    '耶51:15 耶和華用能力創造大地，用智慧建立世界，用聰明鋪張穹蒼。',
    '耶51:16 他一發聲，空中便有多水激動；他使雲霧從地極上騰。他造電隨雨而閃，從他府庫中帶出風來。',
    '耶51:17 各人都成了畜類，毫無知識。各銀匠都因他的偶像羞愧；他所鑄的偶像本是虛假的，其中並無氣息，',
    '耶51:18 都是虛無的，是迷惑人的工作，到追討的時候，必被除滅。',
    '耶51:19 雅各的分不像這些，因他是造作萬有的主；以色列也是他產業的支派。萬軍之耶和華是他的名。',
    '耶51:20 你是我爭戰的斧子和打仗的兵器；我要用你打碎列國，用你毀滅列邦；',
    '耶51:21 用你打碎馬和騎馬的；用你打碎戰車和坐在其上的；',
    '耶51:22 用你打碎男人和女人；用你打碎老年人和少年人；用你打碎壯丁和處女；',
    '耶51:23 用你打碎牧人和他的群畜；用你打碎農夫和他一對牛；用你打碎省長和副省長。',
    '耶51:24 耶和華說：我必在你們眼前報復巴比倫人和迦勒底居民在錫安所行的諸惡。',
    '耶51:25 耶和華說：你這行毀滅的山哪，就是毀滅天下的山，我與你反對。我必向你伸手，將你從山巖滾下去，使你成為燒毀的山。',
    '耶51:26 人必不從你那裡取石頭為房角石，也不取石頭為根基石；你必永遠荒涼。這是耶和華說的。',
    '耶51:27 要在境內豎立大旗，在各國中吹角，使列國預備攻擊巴比倫，將亞拉臘、米尼、亞實基拿各國招來攻擊他；又派軍長來攻擊他，使馬匹上來如螞蚱，',
    '耶51:28 使列國和瑪代君王，與省長和副省長，並他們所管全地之人，都預備攻擊他。',
    '耶51:29 地必震動而瘠苦；因耶和華向巴比倫所定的旨意成立了，使巴比倫之地荒涼，無人居住。',
    '耶51:30 巴比倫的勇士止息爭戰，藏在堅壘之中。他們的勇力衰盡，好像婦女一樣。巴比倫的住處有火著起，門閂都折斷了。',
    '耶51:31 通報的要彼此相遇，送信的要互相迎接，報告巴比倫王說：城的四方被攻取了，',
    '耶51:32 渡口被佔據了，葦塘被火燒了，兵丁也驚慌了。',
    '耶51:33 萬軍之耶和華─以色列的神如此說：巴比倫（原文作女子）城好像踹穀的禾場；再過片時，收割他的時候就到了。',
    '耶51:34 以色列人說：巴比倫王尼布甲尼撒吞滅我，壓碎我，使我成為空虛的器皿。他像大魚將我吞下，用我的美物充滿他的肚腹，又將我趕出去。',
    '耶51:35 錫安的居民要說：巴比倫以強暴待我，損害我的身體，願這罪歸給他。耶路撒冷人要說：願流我們血的罪歸到迦勒底的居民。',
    '耶51:36 所以，耶和華如此說：我必為你伸冤，為你報仇；我必使巴比倫的海枯竭，使他的泉源乾涸。',
    '耶51:37 巴比倫必成為亂堆，為野狗的住處，令人驚駭、嗤笑，並且無人居住。',
    '耶51:38 他們要像少壯獅子咆哮，像小獅子吼叫。',
    '耶51:39 他們火熱的時候，我必為他們設擺酒席，使他們沉醉，好叫他們快樂，睡了長覺，永不醒起。這是耶和華說的。',
    '耶51:40 我必使他們像羊羔、像公綿羊和公山羊下到宰殺之地。',
    '耶51:41 示沙克（就是巴比倫）何竟被攻取？天下所稱讚的何竟被佔據﹖巴比倫在列國中何竟變為荒場﹖',
    '耶51:42 海水漲起，漫過巴比倫；他被許多海浪遮蓋。',
    '耶51:43 他的城邑變為荒場、旱地、沙漠，無人居住，無人經過之地。',
    '耶51:44 我必刑罰巴比倫的彼勒，使他吐出所吞的。萬民必不再流歸他那裡；巴比倫的城牆也必坍塌了。',
    '耶51:45 我的民哪，你們要從其中出去！各人拯救自己，躲避耶和華的烈怒。',
    '耶51:46 你們不要心驚膽怯，也不要因境內所聽見的風聲懼怕；因為這年有風聲傳來；那年也有風聲傳來，境內有強暴的事，官長攻擊官長。',
    '耶51:47 日子將到，我必刑罰巴比倫雕刻的偶像。他全地必然抱愧；他被殺的人必在其中仆倒。',
    '耶51:48 那時，天地和其中所有的，必因巴比倫歡呼，因為行毀滅的要從北方來到他那裡。這是耶和華說的。',
    '耶51:49 巴比倫怎樣使以色列被殺的人仆倒，照樣他全地被殺的人也必在巴比倫仆倒。',
    '耶51:50 你們躲避刀劍的要快走，不要站住！要在遠方記念耶和華，心中追想耶路撒冷。',
    '耶51:51 我們聽見辱罵就蒙羞，滿面慚愧，因為外邦人進入耶和華殿的聖所。',
    '耶51:52 耶和華說：日子將到，我必刑罰巴比倫雕刻的偶像，通國受傷的人必唉哼。',
    '耶51:53 巴比倫雖升到天上，雖使他堅固的高處更堅固，還有行毀滅的從我這裡到他那裡。這是耶和華說的。',
    '耶51:54 有哀號的聲音從巴比倫出來；有大毀滅的響聲從迦勒底人之地發出。',
    '耶51:55 因耶和華使巴比倫變為荒場，使其中的大聲滅絕。仇敵彷彿眾水，波浪匉訇，響聲已經發出。',
    '耶51:56 這是行毀滅的臨到巴比倫。巴比倫的勇士被捉住，他們的弓折斷了；因為耶和華是施行報應的神，必定施行報應。',
    '耶51:57 君王─名為萬軍之耶和華的說：我必使巴比倫的首領、智慧人、省長、副省長，和勇士都沉醉，使他們睡了長覺，永不醒起。',
    '耶51:58 萬軍之耶和華如此說：巴比倫寬闊的城牆必全然傾倒；他高大的城門必被火焚燒。眾民所勞碌的必致虛空；列國所勞碌的被火焚燒，他們都必困乏。',
    '耶51:59 猶大王西底家在位第四年，上巴比倫去的時候，瑪西雅的孫子、尼利亞的兒子西萊雅與王同去（西萊雅是王宮的大臣），先知耶利米有話吩咐他。',
    '耶51:60 耶利米將一切要臨到巴比倫的災禍，就是論到巴比倫的一切話，寫在書上。',
    '耶51:61 耶利米對西萊雅說：你到了巴比倫務要念這書上的話；',
    '耶51:62 又說：耶和華啊，你曾論到這地方說：要剪除，甚至連人帶牲畜沒有在這裡居住的，必永遠荒涼。',
    '耶51:63 你念完了這書，就把一塊石頭拴在書上，扔在伯拉河中，',
    '耶51:64 說：巴比倫因耶和華所要降與他的災禍，必如此沉下去，不再興起，人民也必困乏。耶利米的話到此為止。',
    '耶52:1 西底家登基的時候年二十一歲，在耶路撒冷作王十一年。他母親名叫哈慕他，是立拿人耶利米的女兒。',
    '耶52:2 西底家行耶和華眼中看為惡的事，是照約雅敬一切所行的。',
    '耶52:3 因此耶和華的怒氣在耶路撒冷和猶大發作，以致將人民從自己的面前趕出。',
    '耶52:4 西底家背叛巴比倫王。他作王第九年十月初十日，巴比倫王尼布甲尼撒率領全軍來攻擊耶路撒冷，對城安營，四圍築壘攻城。',
    '耶52:5 於是城被圍困直到西底家王十一年。',
    '耶52:6 四月初九日，城裡有大饑荒，甚至百姓都沒有糧食。',
    '耶52:7 城被攻破，一切兵丁就在夜間從靠近王園兩城中間的門，出城逃跑；迦勒底人正在四圍攻城。他們就往亞拉巴逃去。',
    '耶52:8 迦勒底的軍隊追趕西底家王，在耶利哥的平原追上他。他的全軍都離開他四散了。',
    '耶52:9 迦勒底人就拿住王，帶他到在哈馬地利比拉的巴比倫王那裡；巴比倫王便審判他。',
    '耶52:10 巴比倫王在西底家眼前殺了他的眾子，又在利比拉殺了猶大的一切首領，',
    '耶52:11 並且剜了西底家的眼睛，用銅鍊鎖著他，帶到巴比倫去，將他囚在監裡，直到他死的日子。',
    '耶52:12 巴比倫王尼布甲尼撒十九年五月初十日，在巴比倫王面前侍立的護衛長尼布撒拉旦進入耶路撒冷，',
    '耶52:13 用火焚燒耶和華的殿和王宮，又焚燒耶路撒冷的房屋，就是各大戶家的房屋。',
    '耶52:14 跟從護衛長迦勒底的全軍就拆毀耶路撒冷四圍的城牆。',
    '耶52:15 那時護衛長尼布撒拉旦將民中最窮的和城裡所剩下的百姓，並已經投降巴比倫王的人，以及大眾所剩下的人，都擄去了。',
    '耶52:16 但護衛長尼布撒拉旦留下些民中最窮的，使他們修理葡萄園，耕種田地。',
    '耶52:17 耶和華殿的銅柱並殿內的盆座和銅海，迦勒底人都打碎了，將那銅運到巴比倫去了，',
    '耶52:18 又帶去鍋、鏟子、蠟剪、盤子、調羹，並所用的一切銅器、',
    '耶52:19 杯、火鼎、碗、盆、燈臺、調羹、爵，無論金的銀的，護衛長也都帶去了。',
    '耶52:20 所羅門為耶和華殿所造的兩根銅柱、一個銅海，並座下的十二隻銅牛，這一切的銅多得無法可稱。',
    '耶52:21 這一根柱子高十八肘，厚四指，是空的，圍十二肘。',
    '耶52:22 柱上有銅頂，高五肘；銅頂的周圍有網子和石榴，都是銅的。那一根柱子照此一樣，也有石榴。',
    '耶52:23 柱子四面有九十六個石榴，在網子周圍，共有一百石榴。',
    '耶52:24 護衛長拿住大祭司西萊雅、副祭司西番亞，和三個把門的，',
    '耶52:25 又從城中拿住一個管理兵丁的官（或譯：太監），並在城裡所遇常見王面的七個人和檢點國民軍長的書記，以及城裡所遇見的國民六十個人。',
    '耶52:26 護衛長尼布撒拉旦將這些人帶到利比拉的巴比倫王那裡。',
    '耶52:27 巴比倫王就把他們擊殺在哈馬地的利比拉。這樣，猶大人被擄去離開本地。',
    '耶52:28 尼布甲尼撒所擄的民數記在下面：在他第七年擄去猶大人三千零二十三名；',
    '耶52:29 尼布甲尼撒十八年從耶路撒冷擄去八百三十二人；',
    '耶52:30 尼布甲尼撒二十三年，護衛長尼布撒拉旦擄去猶大人七百四十五名；共有四千六百人。',
    '耶52:31 猶大王約雅斤被擄後三十七年，巴比倫王以未米羅達元年十二月二十五日，使猶大王約雅斤擡頭，提他出監，',
    '耶52:32 又對他說恩言，使他的位高過與他一同在巴比倫眾王的位，',
    '耶52:33 給他脫了囚服。他終身在巴比倫王面前吃飯。',
    '耶52:34 巴比倫王賜他所需用的食物，日日賜他一分，終身是這樣，直到他死的日子。',
    '哀1:1 先前滿有人民的城，現在何竟獨坐！先前在列國中為大的，現在竟如寡婦；先前在諸省中為王后的，現在成為進貢的。',
    '哀1:2 他夜間痛哭，淚流滿腮；在一切所親愛的中間沒有一個安慰他的。他的朋友都以詭詐待他，成為他的仇敵。',
    '哀1:3 猶大因遭遇苦難，又因多服勞苦就遷到外邦。他住在列國中，尋不著安息；追逼他的都在狹窄之地將他追上。',
    '哀1:4 錫安的路徑因無人來守聖節就悲傷；他的城門淒涼；他的祭司歎息；他的處女受艱難，自己也愁苦。',
    '哀1:5 他的敵人為首；他的仇敵亨通；因耶和華為他許多的罪過使他受苦；他的孩童被敵人擄去。',
    '哀1:6 錫安城（原文是女子；下同）的威榮全都失去。他的首領像找不著草場的鹿；在追趕的人前無力行走。',
    '哀1:7 耶路撒冷在困苦窘迫之時，就追想古時一切的樂境。他百姓落在敵人手中，無人救濟；敵人看見，就因他的荒涼嗤笑。',
    '哀1:8 耶路撒冷大大犯罪，所以成為不潔之物；素來尊敬他的，見他赤露就都藐視他；他自己也歎息退後。',
    '哀1:9 他的污穢是在衣襟上；他不思想自己的結局，所以非常地敗落，無人安慰他。他說：耶和華啊，求你看我的苦難，因為仇敵誇大。',
    '哀1:10 敵人伸手，奪取他的美物；他眼見外邦人進入他的聖所─論這外邦人，你曾吩咐不可入你的會中。',
    '哀1:11 他的民都歎息，尋求食物；他們用美物換糧食，要救性命。他們說：耶和華啊，求你觀看，因為我甚是卑賤。',
    '哀1:12 你們一切過路的人哪，這事你們不介意嗎﹖你們要觀看：有像這臨到我的痛苦沒有─就是耶和華在他發烈怒的日子使我所受的苦﹖',
    '哀1:13 他從高天使火進入我的骨頭，剋制了我；他鋪下網羅，絆我的腳，使我轉回；他使我終日淒涼發昏。',
    '哀1:14 我罪過的軛是他手所綁的，猶如軛繩縛在我頸項上；他使我的力量衰敗。主將我交在我所不能敵擋的人手中。',
    '哀1:15 主輕棄我中間的一切勇士，招聚多人（原文是大會）攻擊我，要壓碎我的少年人。主將猶大居民踹下，像在酒醡中一樣。',
    '哀1:16 我因這些事哭泣；我眼淚汪汪；因為那當安慰我、救我性命的，離我甚遠。我的兒女孤苦，因為仇敵得了勝。',
    '哀1:17 錫安舉手，無人安慰。耶和華論雅各已經出令，使四圍的人作他仇敵；耶路撒冷在他們中間像不潔之物。',
    '哀1:18 耶和華是公義的！他這樣待我，是因我違背他的命令。眾民哪，請聽我的話，看我的痛苦；我的處女和少年人都被擄去。',
    '哀1:19 我招呼我所親愛的，他們卻愚弄我。我的祭司和長老正尋求食物、救性命的時候，就在城中絕氣。',
    '哀1:20 耶和華啊，求你觀看，因為我在急難中。我心腸擾亂；我心在我裡面翻轉，因我大大悖逆。在外，刀劍使人喪子；在家，猶如死亡。',
    '哀1:21 聽見我歎息的有人；安慰我的卻無人！我的仇敵都聽見我所遭的患難；因你做這事，他們都喜樂。你必使你報告的日子來到，他們就像我一樣。',
    '哀1:22 願他們的惡行都呈在你面前；你怎樣因我的一切罪過待我，求你照樣待他們；因我歎息甚多，心中發昏。',
    '哀2:1 主何竟發怒，使黑雲遮蔽錫安城！他將以色列的華美從天扔在地上；在他發怒的日子並不記念自己的腳凳。',
    '哀2:2 主吞滅雅各一切的住處，並不顧惜。他發怒傾覆猶大民的保障，使這保障坍倒在地；他辱沒這國和其中的首領。',
    '哀2:3 他發烈怒，把以色列的角全然砍斷，在仇敵面前收回右手。他像火焰四圍吞滅，將雅各燒毀。',
    '哀2:4 他張弓好像仇敵；他站著舉起右手，如同敵人將悅人眼目的，盡行殺戮。在錫安百姓的帳棚上倒出他的忿怒，像火一樣。',
    '哀2:5 主如仇敵吞滅以色列和錫安的一切宮殿，拆毀百姓的保障；在猶大民中加增悲傷哭號。',
    '哀2:6 他強取自己的帳幕，好像是園中的窩棚，毀壞他的聚會之處。耶和華使聖節和安息日在錫安都被忘記，又在怒氣的憤恨中藐視君王和祭司。',
    '哀2:7 耶和華丟棄自己的祭壇，憎惡自己的聖所，將宮殿的牆垣交付仇敵。他們在耶和華的殿中喧嚷，像在聖會之日一樣。',
    '哀2:8 耶和華定意拆毀錫安的城牆；他拉了準繩，不將手收回，定要毀滅。他使外郭和城牆都悲哀，一同衰敗。',
    '哀2:9 錫安的門都陷入地內；主將他的門閂毀壞，折斷。他的君王和首領落在沒有律法的列國中；他的先知不得見耶和華的異象。',
    '哀2:10 錫安城的長老坐在地上默默無聲；他們揚起塵土落在頭上，腰束麻布；耶路撒冷的處女垂頭至地。',
    '哀2:11 我眼中流淚，以致失明，我的心腸擾亂，肝膽塗地，都因我眾民遭毀滅，又因孩童和吃奶的在城內街上發昏。',
    '哀2:12 那時，他們在城內街上發昏，好像受傷的，在母親的懷裡，將要喪命；對母親說：穀、酒在哪裡呢﹖',
    '哀2:13 耶路撒冷的民哪，我可用什麼向你證明呢﹖我可用什麼與你相比呢﹖錫安的民哪，我可拿什麼和你比較，好安慰你呢﹖因為你的裂口大如海，誰能醫治你呢﹖',
    '哀2:14 你的先知為你見虛假和愚昧的異象，並沒有顯露你的罪孽，使你被擄的歸回；卻為你見虛假的默示和使你被趕出本境的緣故。',
    '哀2:15 凡過路的都向你拍掌。他們向耶路撒冷城嗤笑，搖頭，說：難道人所稱為全美的，稱為全地所喜悅的，就是這城嗎﹖',
    '哀2:16 你的仇敵都向你大大張口；他們嗤笑，又切齒說：我們吞滅他。這真是我們所盼望的日子臨到了！我們親眼看見了！',
    '哀2:17 耶和華成就了他所定的，應驗了他古時所命定的。他傾覆了，並不顧惜，使你的仇敵向你誇耀；使你敵人的角也被高舉。',
    '哀2:18 錫安民的心哀求主。錫安的城牆啊，願你流淚如河，晝夜不息；願你眼中的瞳人淚流不止。',
    '哀2:19 夜間，每逢交更的時候要起來呼喊，在主面前傾心如水。你的孩童在各市口上受餓發昏；你要為他們的性命向主舉手禱告。',
    '哀2:20 耶和華啊，求你觀看！見你向誰這樣行﹖婦人豈可吃自己所生育手裡所搖弄的嬰孩嗎﹖祭司和先知豈可在主的聖所中被殺戮嗎﹖',
    '哀2:21 少年人和老年人都在街上躺臥；我的處女和壯丁都倒在刀下；你發怒的日子殺死他們。你殺了，並不顧惜。',
    '哀2:22 你招聚四圍驚嚇我的，像在大會的日子招聚人一樣。耶和華發怒的日子，無人逃脫，無人存留。我所搖弄所養育的嬰孩，仇敵都殺淨了。',
    '哀3:1 我是因耶和華忿怒的杖，遭遇困苦的人。',
    '哀3:2 他引導我，使我行在黑暗中，不行在光明裡。',
    '哀3:3 他真是終日再三反手攻擊我。',
    '哀3:4 他使我的皮肉枯乾；他折斷（或譯：壓傷）我的骨頭。',
    '哀3:5 他築壘攻擊我，用苦楚（原文是苦膽）和艱難圍困我。',
    '哀3:6 他使我住在幽暗之處，像死了許久的人一樣。',
    '哀3:7 他用籬笆圍住我，使我不能出去；他使我的銅鍊沉重。',
    '哀3:8 我哀號求救；他使我的禱告不得上達。',
    '哀3:9 他用鑿過的石頭擋住我的道；他使我的路彎曲。',
    '哀3:10 他向我如熊埋伏，如獅子在隱密處。',
    '哀3:11 他使我轉離正路，將我撕碎，使我淒涼。',
    '哀3:12 他張弓將我當作箭靶子。',
    '哀3:13 他把箭袋中的箭射入我的肺腑。',
    '哀3:14 我成了眾民的笑話；他們終日以我為歌曲。',
    '哀3:15 他用苦楚充滿我，使我飽用茵蔯。',
    '哀3:16 他又用沙石磣斷我的牙，用灰塵將我蒙蔽。',
    '哀3:17 你使我遠離平安，我忘記好處。',
    '哀3:18 我就說：我的力量衰敗；我在耶和華那裡毫無指望！',
    '哀3:19 耶和華啊，求你記念我如茵蔯和苦膽的困苦窘迫。',
    '哀3:20 我心想念這些，就在裡面憂悶。',
    '哀3:21 我想起這事，心裡就有指望。',
    '哀3:22 我們不致消滅，是出於耶和華諸般的慈愛；是因他的憐憫不致斷絕。',
    '哀3:23 每早晨，這都是新的；你的誠實極其廣大！',
    '哀3:24 我心裡說：耶和華是我的分，因此，我要仰望他。',
    '哀3:25 凡等候耶和華，心裡尋求他的，耶和華必施恩給他。',
    '哀3:26 人仰望耶和華，靜默等候他的救恩，這原是好的。',
    '哀3:27 人在幼年負軛，這原是好的。',
    '哀3:28 他當獨坐無言，因為這是耶和華加在他身上的。',
    '哀3:29 他當口貼塵埃，或者有指望。',
    '哀3:30 他當由人打他的腮頰，要滿受凌辱。',
    '哀3:31 因為主必不永遠丟棄人。',
    '哀3:32 主雖使人憂愁，還要照他諸般的慈愛發憐憫。',
    '哀3:33 因他並不甘心使人受苦，使人憂愁。',
    '哀3:34 人將世上被囚的踹（原文是壓）在腳下，',
    '哀3:35 或在至高者面前屈枉人，',
    '哀3:36 或在人的訟事上顛倒是非，這都是主看不上的。',
    '哀3:37 除非主命定，誰能說成就成呢﹖',
    '哀3:38 禍福不都出於至高者的口嗎﹖',
    '哀3:39 活人因自己的罪受罰，為何發怨言呢﹖',
    '哀3:40 我們當深深考察自己的行為，再歸向耶和華。',
    '哀3:41 我們當誠心向天上的神舉手禱告。',
    '哀3:42 我們犯罪背逆，你並不赦免。',
    '哀3:43 你自被怒氣遮蔽，追趕我們；你施行殺戮，並不顧惜。',
    '哀3:44 你以黑雲遮蔽自己，以致禱告不得透入。',
    '哀3:45 你使我們在萬民中成為污穢和渣滓。',
    '哀3:46 我們的仇敵都向我們大大張口。',
    '哀3:47 恐懼和陷坑，殘害和毀滅，都臨近我們。',
    '哀3:48 因我眾民遭的毀滅，我就眼淚下流如河。',
    '哀3:49 我的眼多多流淚，總不止息，',
    '哀3:50 直等耶和華垂顧，從天觀看。',
    '哀3:51 因我本城的眾民，我的眼，使我的心傷痛。',
    '哀3:52 無故與我為仇的追逼我，像追雀鳥一樣。',
    '哀3:53 他們使我的命在牢獄中斷絕，並將一塊石頭拋在我身上。',
    '哀3:54 眾水流過我頭，我說：我命斷絕了！',
    '哀3:55 耶和華啊，我從深牢中求告你的名。',
    '哀3:56 你曾聽見我的聲音；我求你解救，你不要掩耳不聽。',
    '哀3:57 我求告你的日子，你臨近我，說：不要懼怕！',
    '哀3:58 主啊，你伸明了我的冤；你救贖了我的命。',
    '哀3:59 耶和華啊，你見了我受的委屈；求你為我伸冤。',
    '哀3:60 他們仇恨我，謀害我，你都看見了。',
    '哀3:61 耶和華啊，你聽見他們辱罵我的話，知道他們向我所設的計，',
    '哀3:62 並那些起來攻擊我的人口中所說的話，以及終日向我所設的計謀。',
    '哀3:63 求你觀看，他們坐下，起來，都以我為歌曲。',
    '哀3:64 耶和華啊，你要按著他們手所做的向他們施行報應。',
    '哀3:65 你要使他們心裡剛硬，使你的咒詛臨到他們。',
    '哀3:66 你要發怒追趕他們，從耶和華的天下除滅他們。',
    '哀4:1 黃金何其失光！純金何其變色！聖所的石頭倒在各市口上。',
    '哀4:2 錫安寶貴的眾子好比精金，現在何竟算為窰匠手所做的瓦瓶﹖',
    '哀4:3 野狗尚且把奶乳哺其子，我民的婦人倒成為殘忍，好像曠野的鴕鳥一般。',
    '哀4:4 吃奶孩子的舌頭因乾渴貼住上膛；孩童求餅，無人擘給他們。',
    '哀4:5 素來吃美好食物的，現今在街上變為孤寒；素來臥朱紅褥子的，現今躺臥糞堆。',
    '哀4:6 都因我眾民的罪孽比所多瑪的罪還大；所多瑪雖然無人加手於他，還是轉眼之間被傾覆。',
    '哀4:7 錫安的貴冑素來比雪純淨，比奶更白；他們的身體比紅寶玉（或譯：珊瑚）更紅，像光潤的藍寶石一樣。',
    '哀4:8 現在他們的面貌比煤炭更黑，以致在街上無人認識；他們的皮膚緊貼骨頭，枯乾如同槁木。',
    '哀4:9 餓死的不如被刀殺的，因為這是缺了田間的土產，就身體衰弱，漸漸消滅。',
    '哀4:10 慈悲的婦人，當我眾民被毀滅的時候，親手煮自己的兒女作為食物。',
    '哀4:11 耶和華發怒成就他所定的，倒出他的烈怒；在錫安使火著起，燒毀錫安的根基。',
    '哀4:12 地上的君王和世上的居民都不信敵人和仇敵能進耶路撒冷的城門。',
    '哀4:13 這都因他先知的罪惡和祭司的罪孽；他們在城中流了義人的血。',
    '哀4:14 他們在街上如瞎子亂走，又被血玷污，以致人不能摸他們的衣服。',
    '哀4:15 人向他們喊著說：不潔淨的，躲開，躲開！不要挨近我！他們逃走飄流的時候，列國中有人說：他們不可仍在這裡寄居。',
    '哀4:16 耶和華發怒，將他們分散，不再眷顧他們；人不重看祭司，也不厚待長老。',
    '哀4:17 我們仰望人來幫助，以致眼目失明，還是枉然；我們所盼望的，竟盼望一個不能救人的國！',
    '哀4:18 仇敵追趕我們的腳步像打獵的，以致我們不敢在自己的街上行走。我們的結局臨近；我們的日子滿足；我們的結局來到了。',
    '哀4:19 追趕我們的比空中的鷹更快；他們在山上追逼我們，在曠野埋伏，等候我們。',
    '哀4:20 耶和華的受膏者好比我們鼻中的氣，在他們的坑中被捉住；我們曾論到他說：我們必在他蔭下，在列國中存活。',
    '哀4:21 住烏斯地的以東民哪，只管歡喜快樂；苦杯也必傳到你那裡；你必喝醉，以致露體。',
    '哀4:22 錫安的民哪，你罪孽的刑罰受足了，耶和華必不使你再被擄去。以東的民哪，他必追討你的罪孽，顯露你的罪惡。',
    '哀5:1 耶和華啊，求你記念我們所遭遇的事，觀看我們所受的凌辱。',
    '哀5:2 我們的產業歸與外邦人；我們的房屋歸與外路人。',
    '哀5:3 我們是無父的孤兒；我們的母親好像寡婦。',
    '哀5:4 我們出錢才得水喝；我們的柴是人賣給我們的。',
    '哀5:5 追趕我們的，到了我們的頸項上；我們疲乏不得歇息。',
    '哀5:6 我們投降埃及人和亞述人，為要得糧吃飽。',
    '哀5:7 我們列祖犯罪，而今不在了；我們擔當他們的罪孽。',
    '哀5:8 奴僕轄制我們，無人救我們脫離他們的手。',
    '哀5:9 因為曠野的刀劍，我們冒著險才得糧食。',
    '哀5:10 因飢餓燥熱，我們的皮膚就黑如爐。',
    '哀5:11 敵人在錫安玷污婦人，在猶大的城邑玷污處女。',
    '哀5:12 他們吊起首領的手，也不尊敬老人的面。',
    '哀5:13 少年人扛磨石，孩童背木柴，都絆跌了。',
    '哀5:14 老年人在城門口斷絕；少年人不再作樂。',
    '哀5:15 我們心中的快樂止息，跳舞變為悲哀。',
    '哀5:16 冠冕從我們的頭上落下；我們犯罪了，我們有禍了！',
    '哀5:17 這些事我們心裡發昏，我們的眼睛昏花。',
    '哀5:18 錫安山荒涼，野狗（或譯：狐狸）行在其上。',
    '哀5:19 耶和華啊，你存到永遠；你的寶座存到萬代。',
    '哀5:20 你為何永遠忘記我們﹖為何許久離棄我們﹖',
    '哀5:21 耶和華啊，求你使我們向你回轉，我們便得回轉。求你復新我們的日子，像古時一樣。',
    '哀5:22 你竟全然棄絕我們，向我們大發烈怒﹖',
    '結1:1 當三十年四月初五日，以西結（原文是我）在迦巴魯河邊被擄的人中，天就開了，得見神的異象。',
    '結1:2 正是約雅斤王被擄去第五年四月初五日，',
    '結1:3 在迦勒底人之地、迦巴魯河邊，耶和華的話特特臨到布西的兒子祭司以西結；耶和華的靈（原文是手）降在他身上。',
    '結1:4 我觀看，見狂風從北方颳來，隨著有一朵包括閃爍火的大雲，周圍有光輝；從其中的火內發出好像光耀的精金；',
    '結1:5 又從其中顯出四個活物的形像來。他們的形狀是這樣：有人的形像，',
    '結1:6 各有四個臉面，四個翅膀。',
    '結1:7 他們的腿是直的，腳掌好像牛犢之蹄，都燦爛如光明的銅。',
    '結1:8 在四面的翅膀以下有人的手。這四個活物的臉和翅膀乃是這樣：',
    '結1:9 翅膀彼此相接，行走並不轉身，俱各直往前行。',
    '結1:10 至於臉的形像：前面各有人的臉，右面各有獅子的臉，左面各有牛的臉，後面各有鷹的臉。',
    '結1:11 各展開上邊的兩個翅膀相接，各以下邊的兩個翅膀遮體。',
    '結1:12 他們俱各直往前行。靈往哪裡去，他們就往那裡去，行走並不轉身。',
    '結1:13 至於四活物的形像，就如燒著火炭的形狀，又如火把的形狀。火在四活物中間上去下來，這火有光輝，從火中發出閃電。',
    '結1:14 這活物往來奔走，好像電光一閃。',
    '結1:15 我正觀看活物的時候，見活物的臉旁各有一輪在地上。',
    '結1:16 輪的形狀和顏色（原文是作法）好像水蒼玉。四輪都是一個樣式，形狀和作法好像輪中套輪。',
    '結1:17 輪行走的時候，向四方都能直行，並不掉轉。',
    '結1:18 至於輪輞，高而可畏；四個輪輞周圍滿有眼睛。',
    '結1:19 活物行走，輪也在旁邊行走；活物從地上升，輪也都上升。',
    '結1:20 靈往哪裡去，活物就往那裡去；活物上升，輪也在活物旁邊上升，因為活物的靈在輪中。',
    '結1:21 那些行走，這些也行走；那些站住，這些也站住；那些從地上升，輪也在旁邊上升，因為活物的靈在輪中。',
    '結1:22 活物的頭以上有穹蒼的形像，看著像可畏的水晶，鋪張在活物的頭以上。',
    '結1:23 穹蒼以下，活物的翅膀直張，彼此相對；每活物有兩個翅膀遮體。',
    '結1:24 活物行走的時候，我聽見翅膀的響聲，像大水的聲音，像全能者的聲音，也像軍隊鬨嚷的聲音。活物站住的時候，便將翅膀垂下。',
    '結1:25 在他們頭以上的穹蒼之上有聲音。他們站住的時候，便將翅膀垂下。',
    '結1:26 在他們頭以上的穹蒼之上有寶座的形像，彷彿藍寶石；在寶座形像以上有彷彿人的形狀。',
    '結1:27 我見從他腰以上有彷彿光耀的精金，周圍都有火的形狀，又見從他腰以下有彷彿火的形狀，周圍也有光輝。',
    '結1:28 下雨的日子，雲中虹的形狀怎樣，周圍光輝的形狀也是怎樣。這就是耶和華榮耀的形像。我一看見就俯伏在地，又聽見一位說話的聲音。',
    '結2:1 他對我說：人子啊，你站起來，我要和你說話。',
    '結2:2 他對我說話的時候，靈就進入我裡面，使我站起來，我便聽見那位對我說話的聲音。',
    '結2:3 他對我說：人子啊，我差你往悖逆的國民以色列人那裡去。他們是悖逆我的，他們和他們的列祖違背我，直到今日。',
    '結2:4 這眾子面無羞恥，心裡剛硬。我差你往他們那裡去，你要對他們說：主耶和華如此說。',
    '結2:5 他們或聽，或不聽，（他們是悖逆之家），必知道在他們中間有了先知。',
    '結2:6 人子啊，雖有荊棘和蒺藜在你那裡，你又住在蠍子中間，總不要怕他們，也不要怕他們的話；他們雖是悖逆之家，還不要怕他們的話，也不要因他們的臉色驚惶。',
    '結2:7 他們或聽，或不聽，你只管將我的話告訴他們；他們是極其悖逆的。',
    '結2:8 人子啊，要聽我對你所說的話，不要悖逆像那悖逆之家，你要開口吃我所賜給你的。',
    '結2:9 我觀看，見有一隻手向我伸出來，手中有一書卷。',
    '結2:10 他將書卷在我面前展開，內外都寫著字，其上所寫的有哀號、歎息、悲痛的話。',
    '結3:1 他對我說：人子啊，要吃你所得的，要吃這書卷，好去對以色列家講說。',
    '結3:2 於是我開口，他就使我吃這書卷，',
    '結3:3 又對我說：人子啊，要吃我所賜給你的這書卷，充滿你的肚腹。我就吃了，口中覺得其甜如蜜。',
    '結3:4 他對我說：人子啊，你往以色列家那裡去，將我的話對他們講說。',
    '結3:5 你奉差遣不是往那說話深奧、言語難懂的民那裡去，乃是往以色列家去；',
    '結3:6 不是往那說話深奧、言語難懂的多國去，他們的話語是你不懂得的。我若差你往他們那裡去，他們必聽從你。',
    '結3:7 以色列家卻不肯聽從你，因為他們不肯聽從我；原來以色列全家是額堅心硬的人。',
    '結3:8 看哪，我使你的臉硬過他們的臉，使你的額硬過他們的額。',
    '結3:9 我使你的額像金鋼鑽，比火石更硬。他們雖是悖逆之家，你不要怕他們，也不要因他們的臉色驚惶。',
    '結3:10 他又對我說：人子啊，我對你所說的一切話，要心裡領會，耳中聽聞。',
    '結3:11 你往你本國被擄的子民那裡去，他們或聽，或不聽，你要對他們講說，告訴他們這是主耶和華說的。',
    '結3:12 那時，靈將我舉起，我就聽見在我身後有震動轟轟的聲音，說：從耶和華的所在顯出來的榮耀是該稱頌的！',
    '結3:13 我又聽見那活物翅膀相碰，與活物旁邊輪子旋轉震動轟轟的響聲。',
    '結3:14 於是靈將我舉起，帶我而去。我心中甚苦，靈性忿激，並且耶和華的靈（原文是手）在我身上大有能力。',
    '結3:15 我就來到提勒亞畢，住在迦巴魯河邊被擄的人那裡，到他們所住的地方，在他們中間憂憂悶悶地坐了七日。',
    '結3:16 過了七日，耶和華的話臨到我說：',
    '結3:17 人子啊，我立你作以色列家守望的人，所以你要聽我口中的話，替我警戒他們。',
    '結3:18 我何時指著惡人說：他必要死；你若不警戒他，也不勸戒他，使他離開惡行，拯救他的性命，這惡人必死在罪孽之中；我卻要向你討他喪命的罪（原文是血）。',
    '結3:19 倘若你警戒惡人，他仍不轉離罪惡，也不離開惡行，他必死在罪孽之中，你卻救自己脫離了罪。',
    '結3:20 再者，義人何時離義而犯罪，我將絆腳石放在他面前，他就必死；因你沒有警戒他，他必死在罪中，他素來所行的義不被記念；我卻要向你討他喪命的罪（原文是血）。',
    '結3:21 倘若你警戒義人，使他不犯罪，他就不犯罪；他因受警戒就必存活，你也救自己脫離了罪。',
    '結3:22 耶和華的靈（原文是手）在那裡降在我身上。他對我說：你起來往平原去，我要在那裡和你說話。',
    '結3:23 於是我起來往平原去，不料，耶和華的榮耀正如我在迦巴魯河邊所見的一樣，停在那裡，我就俯伏於地。',
    '結3:24 靈就進入我裡面，使我站起來。耶和華對我說：你進房屋去，將門關上。',
    '結3:25 人子啊，人必用繩索捆綁你，你就不能出去在他們中間來往。',
    '結3:26 我必使你的舌頭貼住上膛，以致你啞口，不能作責備他們的人；他們原是悖逆之家。',
    '結3:27 但我對你說話的時候，必使你開口，你就要對他們說：主耶和華如此說。聽的可以聽，不聽的任他不聽，因為他們是悖逆之家。',
    '結4:1 人子啊，你要拿一塊磚，擺在你面前，將一座耶路撒冷城畫在其上，',
    '結4:2 又圍困這城，造臺築壘，安營攻擊，在四圍安設撞錘攻城，',
    '結4:3 又要拿個鐵鏊，放在你和城的中間，作為鐵牆。你要對面攻擊這城，使城被困；這樣，好作以色列家的預兆。',
    '結4:4 你要向左側臥，承當以色列家的罪孽；要按你向左側臥的日數，擔當他們的罪孽。',
    '結4:5 因為我已將他們作孽的年數定為你向左側臥的日數，就是三百九十日，你要這樣擔當以色列家的罪孽。',
    '結4:6 再者，你滿了這些日子，還要向右側臥，擔當猶大家的罪孽。我給你定規側臥四十日，一日頂一年。',
    '結4:7 你要露出膀臂，面向被困的耶路撒冷，說預言攻擊這城。',
    '結4:8 我用繩索捆綁你，使你不能輾轉，直等你滿了困城的日子。',
    '結4:9 你要取小麥、大麥、豆子、紅豆、小米、粗麥，裝在一個器皿中，用以為自己做餅；要按你側臥的三百九十日吃這餅。',
    '結4:10 你所吃的要按分兩吃，每日二十舍客勒，按時而吃。',
    '結4:11 你喝水也要按制子，每日喝一欣六分之一，按時而喝。',
    '結4:12 你吃這餅像吃大麥餅一樣，要用人糞在眾人眼前燒烤。',
    '結4:13 耶和華說：以色列人在我所趕他們到的各國中，也必這樣吃不潔淨的食物。',
    '結4:14 我說：哎！主耶和華啊，我素來未曾被玷污，從幼年到如今沒有吃過自死的，或被野獸撕裂的，那可憎的肉也未曾入我的口。',
    '結4:15 於是他對我說：看哪，我給你牛糞代替人糞，你要將你的餅烤在其上。',
    '結4:16 他又對我說：人子啊，我必在耶路撒冷折斷他們的杖，就是斷絕他們的糧。他們吃餅要按分兩，憂慮而吃；喝水也要按制子，驚惶而喝；',
    '結4:17 使他們缺糧缺水，彼此驚惶，因自己的罪孽消滅。',
    '結5:1 人子啊，你要拿一把快刀，當作剃頭刀，用這刀剃你的頭髮和你的鬍鬚，用天平將鬚髮平分。',
    '結5:2 圍困城的日子滿了，你要將三分之一在城中用火焚燒，將三分之一在城的四圍用刀砍碎，將三分之一任風吹散；我也要拔刀追趕。',
    '結5:3 你要從其中取幾根包在衣襟裡，',
    '結5:4 再從這幾根中取些扔在火中焚燒，從裡面必有火出來燒入以色列全家。',
    '結5:5 主耶和華如此說：這就是耶路撒冷。我曾將他安置在列邦之中；列國都在他的四圍。',
    '結5:6 他行惡，違背我的典章，過於列國；干犯我的律例，過於四圍的列邦，因為他棄掉我的典章。至於我的律例，他並沒有遵行。',
    '結5:7 所以主耶和華如此說：因為你們紛爭過於四圍的列國，也不遵行我的律例，不謹守我的典章，並以遵從四圍列國的惡規尚不滿意，',
    '結5:8 所以主耶和華如此說：看哪，我與你反對，必在列國的眼前，在你中間，施行審判；',
    '結5:9 並且因你一切可憎的事，我要在你中間行我所未曾行的，以後我也不再照著行。',
    '結5:10 在你中間父親要吃兒子，兒子要吃父親。我必向你施行審判，我必將你所剩下的分散四方（方：原文是風）。',
    '結5:11 主耶和華說：我指著我的永生起誓，因你用一切可憎的物、可厭的事玷污了我的聖所，故此，我定要使你人數減少，我眼必不顧惜你，也不可憐你。',
    '結5:12 你的民三分之一必遭瘟疫而死，在你中間必因饑荒消滅；三分之一必在你四圍倒在刀下；我必將三分之一分散四方（方：原文是風），並要拔刀追趕他們。',
    '結5:13 我要這樣成就怒中所定的；我向他們發的忿怒止息了，自己就得著安慰。我在他們身上成就怒中所定的那時，他們就知道我─耶和華所說的是出於熱心；',
    '結5:14 並且我必使你在四圍的列國中，在經過的眾人眼前，成了荒涼和羞辱。',
    '結5:15 這樣，我必以怒氣和忿怒，並烈怒的責備，向你施行審判。那時，你就在四圍的列國中成為羞辱、譏刺、警戒、驚駭。這是我─耶和華說的。',
    '結5:16 那時，我要將滅人、使人饑荒的惡箭，就是射去滅人的，射在你們身上，並要加增你們的饑荒，斷絕你們所倚靠的糧食；',
    '結5:17 又要使饑荒和惡獸到你那裡，叫你喪子，瘟疫和流血的事也必盛行在你那裡；我也要使刀劍臨到你。這是我─耶和華說的。',
    '結6:1 耶和華的話臨到我說：',
    '結6:2 人子啊，你要面向以色列的眾山說預言，',
    '結6:3 說：以色列的眾山哪，要聽主耶和華的話。主耶和華對大山、小岡、水溝、山谷如此說：我必使刀劍臨到你們，也必毀滅你們的邱壇。',
    '結6:4 你們的祭壇必然荒涼，你們的日像必被打碎。我要使你們被殺的人倒在你們的偶像面前；',
    '結6:5 我也要將以色列人的屍首放在他們的偶像面前，將你們的骸骨拋散在你們祭壇的四圍。',
    '結6:6 在你們一切的住處，城邑要變為荒場，邱壇必然淒涼，使你們的祭壇荒廢，將你們的偶像打碎。你們的日像被砍倒，你們的工作被毀滅。',
    '結6:7 被殺的人必倒在你們中間，你們就知道我是耶和華。',
    '結6:8 你們分散在各國的時候，我必在列邦中使你們有剩下脫離刀劍的人。',
    '結6:9 那脫離刀劍的人必在所擄到的各國中記念我，為他們心中何等傷破，是因他們起淫心，遠離我，眼對偶像行邪淫。他們因行一切可憎的惡事，必厭惡自己。',
    '結6:10 他們必知道我是耶和華；我說要使這災禍臨到他們身上，並非空話。',
    '結6:11 主耶和華如此說：你當拍手頓足，說：哀哉！以色列家行這一切可憎的惡事，他們必倒在刀劍、饑荒、瘟疫之下。',
    '結6:12 在遠處的，必遭瘟疫而死；在近處的，必倒在刀劍之下；那存留被圍困的，必因饑荒而死；我必這樣在他們身上成就我怒中所定的。',
    '結6:13 他們被殺的人倒在他們祭壇四圍的偶像中，就是各高岡、各山頂、各青翠樹下、各茂密的橡樹下，乃是他們獻馨香的祭牲給一切偶像的地方。那時，他們就知道我是耶和華。',
    '結6:14 我必伸手攻擊他們，使他們的地從曠野到第伯拉他一切住處極其荒涼，他們就知道我是耶和華。',
    '結7:1 耶和華的話又臨到我說：',
    '結7:2 人子啊，主耶和華對以色列地如此說：結局到了，結局到了地的四境！',
    '結7:3 現在你的結局已經臨到，我必使我的怒氣歸與你，也必按你的行為審判你，照你一切可憎的事刑罰你。',
    '結7:4 我眼必不顧惜你，也不可憐你，卻要按你所行的報應你，照你中間可憎的事刑罰你。你就知道我是耶和華。',
    '結7:5 主耶和華如此說：有一災，獨有一災；看哪，臨近了！',
    '結7:6 結局來了，結局來了，向你興起。看哪，來到了！',
    '結7:7 境內的居民哪，所定的災臨到你，時候到了，日子近了，乃是鬨嚷並非在山上歡呼的日子。',
    '結7:8 我快要將我的忿怒傾在你身上，向你成就我怒中所定的，按你的行為審判你，照你一切可憎的事刑罰你。',
    '結7:9 我眼必不顧惜你，也不可憐你，必按你所行的報應你，照你中間可憎的事刑罰你。你就知道擊打你的是我耶和華。',
    '結7:10 看哪，看哪，日子快到了，所定的災已經發出。杖已經開花，驕傲已經發芽。',
    '結7:11 強暴興起，成了罰惡的杖。以色列人，或是他們的群眾，或是他們的財寶，無一存留，他們中間也沒有得尊榮的。',
    '結7:12 時候到了，日子近了，買主不可歡喜，賣主不可愁煩，因為烈怒已經臨到他們眾人身上。',
    '結7:13 賣主雖然存活，卻不能歸回再得所賣的，因為這異象關乎他們眾人。誰都不得歸回，也沒有人在他的罪孽中堅立自己。',
    '結7:14 他們已經吹角，預備齊全，卻無一人出戰，因為我的烈怒臨到他們眾人身上。',
    '結7:15 在外有刀劍，在內有瘟疫、饑荒；在田野的，必遭刀劍而死；在城中的，必有饑荒、瘟疫吞滅他。',
    '結7:16 其中所逃脫的就必逃脫，各人因自己的罪孽在山上發出悲聲，好像谷中的鴿子哀鳴。',
    '結7:17 手都發軟，膝弱如水。',
    '結7:18 要用麻布束腰，被戰兢所蓋；各人臉上羞愧，頭上光禿。',
    '結7:19 他們要將銀子拋在街上，金子看如污穢之物。當耶和華發怒的日子，他們的金銀不能救他們，不能使心裡知足，也不能使肚腹飽滿，因為這金銀作了他們罪孽的絆腳石。',
    '結7:20 論到耶和華妝飾華美的殿，他建立得威嚴，他們卻在其中製造可憎可厭的偶像，所以這殿我使他們看如污穢之物。',
    '結7:21 我必將這殿交付外邦人為掠物，交付地上的惡人為擄物；他們也必褻瀆這殿。',
    '結7:22 我必轉臉不顧以色列人，他們褻瀆我隱密之所，強盜也必進去褻瀆。',
    '結7:23 要製造鎖鍊；因為這地遍滿流血的罪，城邑充滿強暴的事，',
    '結7:24 所以我必使列國中最惡的人來佔據他們的房屋；我必使強暴人的驕傲止息，他們的聖所都要被褻瀆。',
    '結7:25 毀滅臨近了，他們要求平安，卻無平安可得。',
    '結7:26 災害加上災害，風聲接連風聲；他們必向先知求異象，但祭司講的律法、長老設的謀略都必斷絕。',
    '結7:27 君要悲哀，王要披淒涼為衣，國民的手都發顫。我必照他們的行為待他們，按他們應得的審判他們，他們就知道我是耶和華。',
    '結8:1 第六年六月初五日，我坐在家中；猶大的眾長老坐在我面前。在那裡主耶和華的靈（原文是手）降在我身上。',
    '結8:2 我觀看，見有形像彷彿火的形狀，從他腰以下的形狀有火，從他腰以上有光輝的形狀，彷彿光耀的精金。',
    '結8:3 他伸出彷彿一隻手的樣式，抓住我的一綹頭髮，靈就將我舉到天地中間，在神的異象中，帶我到耶路撒冷朝北的內院門口，在那裡有觸動主怒偶像的坐位，就是惹動忌邪的。',
    '結8:4 誰知，在那裡有以色列神的榮耀，形狀與我在平原所見的一樣。',
    '結8:5 神對我說：人子啊，你舉目向北觀看。我就舉目向北觀看，見祭壇門的北邊，在門口有這惹忌邪的偶像；',
    '結8:6 又對我說：人子啊，以色列家所行的，就是在此行這大可憎的事，使我遠離我的聖所，你看見了嗎﹖你還要看見另有大可憎的事。',
    '結8:7 他領我到院門口。我觀看，見牆上有個窟窿。',
    '結8:8 他對我說：人子啊，你要挖牆。我一挖牆，見有一門。',
    '結8:9 他說：你進去，看他們在這裡所行可憎的惡事。',
    '結8:10 我進去一看，誰知，在四面牆上畫著各樣爬物和可憎的走獸，並以色列家一切的偶像。',
    '結8:11 在這些像前有以色列家的七十個長老站立，沙番的兒子雅撒尼亞也站在其中。各人手拿香爐，煙雲的香氣上騰。',
    '結8:12 他對我說：人子啊，以色列家的長老暗中在各人畫像屋裡所行的，你看見了嗎﹖他們常說：耶和華看不見我們；耶和華已經離棄這地。',
    '結8:13 他又說：你還要看見他們另外行大可憎的事。',
    '結8:14 他領我到耶和華殿外院朝北的門口。誰知，在那裡有婦女坐著，為搭模斯哭泣。',
    '結8:15 他對我說：人子啊，你看見了嗎﹖你還要看見比這更可憎的事。',
    '結8:16 他又領我到耶和華殿的內院。誰知，在耶和華的殿門口、廊子和祭壇中間，約有二十五個人背向耶和華的殿，面向東方拜日頭。',
    '結8:17 他對我說：人子啊，你看見了嗎﹖猶大家在此行這可憎的事還算為小嗎﹖他們在這地遍行強暴，再三惹我發怒，他們手拿枝條舉向鼻前。',
    '結8:18 因此，我也要以忿怒行事，我眼必不顧惜，也不可憐他們；他們雖向我耳中大聲呼求，我還是不聽。',
    '結9:1 他向我耳中大聲喊叫說：要使那監管這城的人手中各拿滅命的兵器前來。',
    '結9:2 忽然有六個人從朝北的上門而來，各人手拿殺人的兵器；內中有一人身穿細麻衣，腰間帶著墨盒子。他們進來，站在銅祭壇旁。',
    '結9:3 以色列神的榮耀本在基路伯上，現今從那裡升到殿的門檻。神將那身穿細麻衣、腰間帶著墨盒子的人召來。',
    '結9:4 耶和華對他說：你去走遍耶路撒冷全城，那些因城中所行可憎之事歎息哀哭的人，畫記號在額上。',
    '結9:5 我耳中聽見他對其餘的人說：要跟隨他走遍全城，以行擊殺。你們的眼不要顧惜，也不要可憐他們。',
    '結9:6 要將年老的、年少的，並處女、嬰孩，和婦女，從聖所起全都殺盡，只是凡有記號的人不要挨近他。於是他們從殿前的長老殺起。',
    '結9:7 他對他們說：要污穢這殿，使院中充滿被殺的人。你們出去吧！他們就出去，在城中擊殺。',
    '結9:8 他們擊殺的時候，我被留下，我就俯伏在地，說：哎！主耶和華啊，你將忿怒傾在耶路撒冷，豈要將以色列所剩下的人都滅絕嗎﹖',
    '結9:9 他對我說：以色列家和猶大家的罪孽極其重大。遍地有流血的事，滿城有冤屈，因為他們說：耶和華已經離棄這地，他看不見我們。',
    '結9:10 故此，我眼必不顧惜，也不可憐他們，要照他們所行的報應在他們頭上。',
    '結9:11 那穿細麻衣、腰間帶著墨盒子的人將這事回覆說：我已經照你所吩咐的行了。',
    '結10:1 我觀看，見基路伯頭上的穹蒼之中，顯出藍寶石的形狀，彷彿寶座的形像。',
    '結10:2 主對那穿細麻衣的人說：你進去，在旋轉的輪內基路伯以下，從基路伯中間將火炭取滿兩手，撒在城上。我就見他進去。',
    '結10:3 那人進去的時候，基路伯站在殿的右邊，雲彩充滿了內院。',
    '結10:4 耶和華的榮耀從基路伯那裡上升，停在門檻以上；殿內滿了雲彩，院宇也被耶和華榮耀的光輝充滿。',
    '結10:5 基路伯翅膀的響聲聽到外院，好像全能神說話的聲音。',
    '結10:6 他吩咐那穿細麻衣的人說：要從旋轉的輪內基路伯中間取火。那人就進去站在一個輪子旁邊。',
    '結10:7 有一個基路伯從基路伯中伸手到基路伯中間的火那裡，取些放在那穿細麻衣的人兩手中，那人就拿出去了。',
    '結10:8 在基路伯翅膀之下，顯出有人手的樣式。',
    '結10:9 我又觀看，見基路伯旁邊有四個輪子。這基路伯旁有一個輪子，那基路伯旁有一個輪子，每基路伯都是如此；輪子的顏色（原文是形狀）彷彿水蒼玉。',
    '結10:10 至於四輪的形狀，都是一個樣式，彷彿輪中套輪。',
    '結10:11 輪行走的時候，向四方都能直行，並不掉轉。頭向何方，他們也隨向何方，行走的時候並不掉轉。',
    '結10:12 他們全身，連背帶手和翅膀，並輪周圍都滿了眼睛。這四個基路伯的輪子都是如此。',
    '結10:13 至於這些輪子，我耳中聽見說是旋轉的。',
    '結10:14 基路伯各有四臉：第一是基路伯的臉，第二是人的臉，第三是獅子的臉，第四是鷹的臉。',
    '結10:15 基路伯升上去了；這是我在迦巴魯河邊所見的活物。',
    '結10:16 基路伯行走，輪也在旁邊行走。基路伯展開翅膀，離地上升，輪也不轉離他們旁邊。',
    '結10:17 那些站住，這些也站住；那些上升，這些也一同上升，因為活物的靈在輪中。',
    '結10:18 耶和華的榮耀從殿的門檻那裡出去，停在基路伯以上。',
    '結10:19 基路伯出去的時候，就展開翅膀，在我眼前離地上升。輪也在他們的旁邊，都停在耶和華殿的東門口。在他們以上有以色列神的榮耀。',
    '結10:20 這是我在迦巴魯河邊所見、以色列神榮耀以下的活物，我就知道他們是基路伯。',
    '結10:21 各有四個臉面，四個翅膀，翅膀以下有人手的樣式。',
    '結10:22 至於他們臉的模樣，並身體的形像，是我從前在迦巴魯河邊所看見的。他們俱各直往前行。',
    '結11:1 靈將我舉起，帶到耶和華殿向東的東門。誰知，在門口有二十五個人，我見其中有民間的首領押朔的兒子雅撒尼亞和比拿雅的兒子毘拉提。',
    '結11:2 耶和華對我說：人子啊，這就是圖謀罪孽的人，在這城中給人設惡謀。',
    '結11:3 他們說：蓋房屋的時候尚未臨近；這城是鍋，我們是肉。',
    '結11:4 人子啊，因此你當說預言，說預言攻擊他們。',
    '結11:5 耶和華的靈降在我身上，對我說：你當說，耶和華如此說：以色列家啊，你們口中所說的，心裡所想的，我都知道。',
    '結11:6 你們在這城中殺人增多，使被殺的人充滿街道。',
    '結11:7 所以主耶和華如此說：你們殺在城中的人就是肉，這城就是鍋；你們卻要從其中被帶出去。',
    '結11:8 你們怕刀劍，我必使刀劍臨到你們。這是主耶和華說的。',
    '結11:9 我必從這城中帶出你們去，交在外邦人的手中，且要在你們中間施行審判。',
    '結11:10 你們必倒在刀下；我必在以色列的境界審判你們，你們就知道我是耶和華。',
    '結11:11 這城必不作你們的鍋，你們也不作其中的肉。我必在以色列的境界審判你們，',
    '結11:12 你們就知道我是耶和華；因為你們沒有遵行我的律例，也沒有順從我的典章，卻隨從你們四圍列國的惡規。',
    '結11:13 我正說預言的時候，比拿雅的兒子毘拉提死了。於是我俯伏在地，大聲呼叫說：哎！主耶和華啊，你要將以色列剩下的人滅絕淨盡嗎﹖',
    '結11:14 耶和華的話臨到我說：',
    '結11:15 人子啊，耶路撒冷的居民對你的弟兄、你的本族、你的親屬、以色列全家，就是對大眾說：你們遠離耶和華吧！這地是賜給我們為業的。',
    '結11:16 所以你當說：耶和華如此說：我雖將以色列全家遠遠遷移到列國中，將他們分散在列邦內，我還要在他們所到的列邦，暫作他們的聖所。',
    '結11:17 你當說：主耶和華如此說：我必從萬民中招聚你們，從分散的列國內聚集你們，又要將以色列地賜給你們。',
    '結11:18 他們必到那裡，也必從其中除掉一切可憎可厭的物。',
    '結11:19 我要使他們有合一的心，也要將新靈放在他們裡面，又從他們肉體中除掉石心，賜給他們肉心，',
    '結11:20 使他們順從我的律例，謹守遵行我的典章。他們要作我的子民，我要作他們的神。',
    '結11:21 至於那些心中隨從可憎可厭之物的，我必照他們所行的報應在他們頭上。這是主耶和華說的。',
    '結11:22 於是，基路伯展開翅膀，輪子都在他們旁邊；在他們以上有以色列神的榮耀。',
    '結11:23 耶和華的榮耀從城中上升，停在城東的那座山上。',
    '結11:24 靈將我舉起，在異象中藉著神的靈將我帶進迦勒底地，到被擄的人那裡；我所見的異象就離我上升去了。',
    '結11:25 我便將耶和華所指示我的一切事都說給被擄的人聽。',
    '結12:1 耶和華的話又臨到我說：',
    '結12:2 人子啊，你住在悖逆的家中。他們有眼睛看不見，有耳朵聽不見，因為他們是悖逆之家。',
    '結12:3 所以人子啊，你要預備擄去使用的物件，在白日當他們眼前從你所住的地方移到別處去；他們雖是悖逆之家，或者可以揣摩思想。',
    '結12:4 你要在白日當他們眼前帶出你的物件去，好像預備擄去使用的物件。到了晚上，你要在他們眼前親自出去，像被擄的人出去一樣。',
    '結12:5 你要在他們眼前挖通了牆，從其中將物件帶出去。',
    '結12:6 到天黑時，你要當他們眼前搭在肩頭上帶出去，並要蒙住臉看不見地，因為我立你作以色列家的預兆。',
    '結12:7 我就照著所吩咐的去行，白日帶出我的物件，好像預備擄去使用的物件。到了晚上，我用手挖通了牆。天黑的時候，就當他們眼前搭在肩頭上帶出去。',
    '結12:8 次日早晨，耶和華的話臨到我說：',
    '結12:9 人子啊，以色列家，就是那悖逆之家，豈不是問你說：你作什麼呢﹖',
    '結12:10 你要對他們說：主耶和華如此說：這是關乎耶路撒冷的君王和他周圍以色列全家的預表（原文是擔子）。',
    '結12:11 你要說：我作你們的預兆：我怎樣行，他們所遭遇的也必怎樣，他們必被擄去。',
    '結12:12 他們中間的君王也必在天黑的時候將物件搭在肩頭上帶出去。他們要挖通了牆，從其中帶出去。他必蒙住臉，眼看不見地。',
    '結12:13 我必將我的網撒在他身上，他必在我的網羅中纏住。我必帶他到迦勒底人之地的巴比倫；他雖死在那裡，卻看不見那地。',
    '結12:14 周圍一切幫助他的和他所有的軍隊，我必分散四方（方：原文是風），也要拔刀追趕他們。',
    '結12:15 我將他們四散在列國、分散在列邦的時候，他們就知道我是耶和華。',
    '結12:16 我卻要留下他們幾個人得免刀劍、饑荒、瘟疫，使他們在所到的各國中述說他們一切可憎的事，人就知道我是耶和華。',
    '結12:17 耶和華的話又臨到我說：',
    '結12:18 人子啊，你吃飯必膽戰，喝水必惶惶憂慮。',
    '結12:19 你要對這地的百姓說：主耶和華論耶路撒冷和以色列地的居民如此說，他們吃飯必憂慮，喝水必驚惶。因其中居住的眾人所行強暴的事，這地必然荒廢，一無所存。',
    '結12:20 有居民的城邑必變為荒場，地也必變為荒廢；你們就知道我是耶和華。',
    '結12:21 耶和華的話臨到我說：',
    '結12:22 人子啊，在你們以色列地怎麼有這俗語，說日子遲延，一切異象都落了空呢﹖',
    '結12:23 你要告訴他們說：主耶和華如此說：我必使這俗語止息，以色列中不再用這俗語。你卻要對他們說：日子臨近，一切的異象必都應驗。',
    '結12:24 從此，在以色列家中必不再有虛假的異象和奉承的占卜。',
    '結12:25 我─耶和華說話，所說的必定成就，不再耽延。你們這悖逆之家，我所說的話必趁你們在世的日子成就。這是主耶和華說的。',
    '結12:26 耶和華的話又臨到我說：',
    '結12:27 人子啊，以色列家的人說：他所見的異象是關乎後來許多的日子，所說的預言是指著極遠的時候。',
    '結12:28 所以你要對他們說：主耶和華如此說：我的話沒有一句再耽延的，我所說的必定成就。這是主耶和華說的。',
    '結13:1 耶和華的話臨到我說：',
    '結13:2 人子啊，你要說預言攻擊以色列中說預言的先知，對那些本己心發預言的說：你們當聽耶和華的話。',
    '結13:3 主耶和華如此說：愚頑的先知有禍了，他們隨從自己的心意，卻一無所見。',
    '結13:4 以色列啊，你的先知好像荒場中的狐狸，',
    '結13:5 沒有上去堵擋破口，也沒有為以色列家重修牆垣，使他們當耶和華的日子在陣上站立得住。',
    '結13:6 這些人所見的是虛假，是謊詐的占卜。他們說是耶和華說的，其實耶和華並沒有差遣他們，他們倒使人指望那話必然立定。',
    '結13:7 你們豈不是見了虛假的異象嗎﹖豈不是說了謊詐的占卜嗎﹖你們說，這是耶和華說的，其實我沒有說。',
    '結13:8 所以主耶和華如此說：因你們說的是虛假，見的是謊詐，我就與你們反對。這是主耶和華說的。',
    '結13:9 我的手必攻擊那見虛假異象、用謊詐占卜的先知，他們必不列在我百姓的會中，不錄在以色列家的冊上，也不進入以色列地；你們就知道我是主耶和華。',
    '結13:10 因為他們誘惑我的百姓，說：平安！其實沒有平安，就像有人立起牆壁，他們倒用未泡透的灰抹上。',
    '結13:11 所以你要對那些抹上未泡透灰的人說：牆要倒塌，必有暴雨漫過。大冰雹啊，你們要降下，狂風也要吹裂這牆。',
    '結13:12 這牆倒塌之後，人豈不問你們說：你們抹上未泡透的灰在哪裡呢﹖',
    '結13:13 所以主耶和華如此說：我要發怒，使狂風吹裂這牆，在怒中使暴雨漫過，又發怒降下大冰雹，毀滅這牆。',
    '結13:14 我要這樣拆毀你們那未泡透灰所抹的牆，拆平到地，以致根基露出，牆必倒塌，你們也必在其中滅亡；你們就知道我是耶和華。',
    '結13:15 我要這樣向牆和用未泡透灰抹牆的人成就我怒中所定的，並要對你們說：牆和抹牆的人都沒有了。',
    '結13:16 這抹牆的就是以色列的先知，他們指著耶路撒冷說預言，為這城見了平安的異象，其實沒有平安。這是主耶和華說的。',
    '結13:17 人子啊，你要面向本民中、從己心發預言的女子說預言，攻擊他們，',
    '結13:18 說主耶和華如此說：這些婦女有禍了！他們為眾人的膀臂縫靠枕，給高矮之人做下垂的頭巾，為要獵取人的性命。難道你們要獵取我百姓的性命，為利己將人救活嗎﹖',
    '結13:19 你們為兩把大麥，為幾塊餅，在我民中褻瀆我，對肯聽謊言的民說謊，殺死不該死的人，救活不該活的人。',
    '結13:20 所以主耶和華如此說：看哪，我與你們的靠枕反對，就是你們用以獵取人、使人的性命如鳥飛的。我要將靠枕從你們的膀臂上扯去，釋放你們獵取如鳥飛的人。',
    '結13:21 我也必撕裂你們下垂的頭巾，救我百姓脫離你們的手，不再被獵取，落在你們手中。你們就知道我是耶和華。',
    '結13:22 我不使義人傷心，你們卻以謊話使他傷心，又堅固惡人的手，使他不回頭離開惡道得以救活。',
    '結13:23 你們就不再見虛假的異象，也不再行占卜的事；我必救我的百姓脫離你們的手；你們就知道我是耶和華。',
    '結14:1 有幾個以色列長老到我這裡來，坐在我面前。',
    '結14:2 耶和華的話就臨到我說：',
    '結14:3 人子啊，這些人已將他們的假神接到心裡，把陷於罪的絆腳石放在面前，我豈能絲毫被他們求問嗎﹖',
    '結14:4 所以你要告訴他們：主耶和華如此說：以色列家的人中，凡將他的假神接到心裡，把陷於罪的絆腳石放在面前，又就了先知來的，我─耶和華在他所求的事上，必按他眾多的假神回答他（或譯：必按他拜許多假神的罪報應他），',
    '結14:5 好在以色列家的心事上捉住他們，因為他們都藉著假神與我生疏。',
    '結14:6 所以你要告訴以色列家說：主耶和華如此說：回頭吧！離開你們的偶像，轉臉莫從你們一切可憎的事。',
    '結14:7 因為以色列家的人，或在以色列中寄居的外人，凡與我隔絕，將他的假神接到心裡，把陷於罪的絆腳石放在面前，又就了先知來要為自己的事求問我的，我─耶和華必親自回答他。',
    '結14:8 我必向那人變臉，使他作了警戒，笑談，令人驚駭，並且我要將他從我民中剪除；你們就知道我是耶和華。',
    '結14:9 先知若被迷惑說一句預言，是我─耶和華任那先知受迷惑，我也必向他伸手，將他從我民以色列中除滅。',
    '結14:10 他們必擔當自己的罪孽。先知的罪孽和求問之人的罪孽都是一樣，',
    '結14:11 好使以色列家不再走迷離開我，不再因各樣的罪過玷污自己，只要作我的子民，我作他們的神。這是主耶和華說的。',
    '結14:12 耶和華的話臨到我說：',
    '結14:13 人子啊，若有一國犯罪干犯我，我也向他伸手折斷他們的杖，就是斷絕他們的糧，使饑荒臨到那地，將人與牲畜從其中剪除；',
    '結14:14 其中雖有挪亞、但以理、約伯這三人，他們只能因他們的義救自己的性命。這是主耶和華說的。',
    '結14:15 我若使惡獸經過糟踐那地，使地荒涼，以致因這些獸，人都不得經過；',
    '結14:16 雖有這三人在其中，主耶和華說：我指著我的永生起誓，他們連兒帶女都不能得救，只能自己得救，那地仍然荒涼。',
    '結14:17 或者我使刀劍臨到那地，說：刀劍哪，要經過那地，以致我將人與牲畜從其中剪除；',
    '結14:18 雖有這三人在其中，主耶和華說：我指著我的永生起誓，他們連兒帶女都不能得救，只能自己得救。',
    '結14:19 或者我叫瘟疫流行那地，使我滅命（原文是帶血）的忿怒傾在其上，好將人與牲畜從其中剪除；',
    '結14:20 雖有挪亞、但以理、約伯在其中，主耶和華說：我指著我的永生起誓，他們連兒帶女都不能救，只能因他們的義救自己的性命。',
    '結14:21 主耶和華如此說：我將這四樣大災─就是刀劍、饑荒、惡獸、瘟疫降在耶路撒冷，將人與牲畜從其中剪除，豈不更重嗎﹖',
    '結14:22 然而其中必有剩下的人，他們連兒帶女必帶到你們這裡來，你們看見他們所行所為的，要因我降給耶路撒冷的一切災禍，便得了安慰。',
    '結14:23 你們看見他們所行所為的，得了安慰，就知道我在耶路撒冷中所行的並非無故。這是主耶和華說的。',
    '結15:1 耶和華的話臨到我說：',
    '結15:2 人子啊，葡萄樹比別樣樹有什麼強處﹖葡萄枝比眾樹枝有什麼好處﹖',
    '結15:3 其上可以取木料做什麼工用，可以取來做釘子掛什麼器皿嗎﹖',
    '結15:4 看哪，已經拋在火中當作柴燒，火既燒了兩頭，中間也被燒了，還有益於工用嗎﹖',
    '結15:5 完全的時候尚且不合乎什麼工用，何況被火燒壞，還能合乎什麼工用嗎﹖',
    '結15:6 所以，主耶和華如此說：眾樹以內的葡萄樹，我怎樣使他在火中當柴，也必照樣待耶路撒冷的居民。',
    '結15:7 我必向他們變臉；他們雖從火中出來，火卻要燒滅他們。我向他們變臉的時候，你們就知道我是耶和華。',
    '結15:8 我必使地土荒涼，因為他們行事干犯我。這是主耶和華說的。',
    '結16:1 耶和華的話又臨到我說：',
    '結16:2 人子啊，你要使耶路撒冷知道他那些可憎的事，',
    '結16:3 說主耶和華對耶路撒冷如此說：你根本，你出世，是在迦南地；你父親是亞摩利人，你母親是赫人。',
    '結16:4 論到你出世的景況，在你初生的日子沒有為你斷臍帶，也沒有用水洗你，使你潔淨，絲毫沒有撒鹽在你身上，也沒有用布裹你。',
    '結16:5 誰的眼也不可憐你，為你做一件這樣的事憐恤你；但你初生的日子扔在田野，是因你被厭惡。',
    '結16:6 我從你旁邊經過，見你滾在血中，就對你說：你雖在血中，仍可存活；你雖在血中，仍可存活。',
    '結16:7 我使你生長好像田間所長的，你就漸漸長大，以致極其俊美，兩乳成形，頭髮長成，你卻仍然赤身露體。',
    '結16:8 我從你旁邊經過，看見你的時候正動愛情，便用衣襟搭在你身上，遮蓋你的赤體；又向你起誓，與你結盟，你就歸於我。這是主耶和華說的。',
    '結16:9 那時我用水洗你，洗淨你身上的血，又用油抹你。',
    '結16:10 我也使你身穿繡花衣服，腳穿海狗皮鞋，並用細麻布給你束腰，用絲綢為衣披在你身上，',
    '結16:11 又用妝飾打扮你，將鐲子戴在你手上，將金鍊戴在你項上。',
    '結16:12 我也將環子戴在你鼻子上，將耳環戴在你耳朵上，將華冠戴在你頭上。',
    '結16:13 這樣，你就有金銀的妝飾，穿的是細麻衣和絲綢，並繡花衣；吃的是細麵、蜂蜜，並油。你也極其美貌，發達到王后的尊榮。',
    '結16:14 你美貌的名聲傳在列邦中，你十分美貌，是因我加在你身上的威榮。這是主耶和華說的。',
    '結16:15 只是你仗著自己的美貌，又因你的名聲就行邪淫。你縱情淫亂，使過路的任意而行。',
    '結16:16 你用衣服為自己在高處結彩，在其上行邪淫。這樣的事將來必沒有，也必不再行了。',
    '結16:17 你又將我所給你那華美的金銀、寶器為自己製造人像，與他行邪淫；',
    '結16:18 又用你的繡花衣服給他披上，並將我的膏油和香料擺在他跟前；',
    '結16:19 又將我賜給你的食物，就是我賜給你吃的細麵、油，和蜂蜜，都擺在他跟前為馨香的供物。這是主耶和華說的。',
    '結16:20 並且你將給我所生的兒女焚獻給他。',
    '結16:21 你行淫亂豈是小事，竟將我的兒女殺了，使他們經火歸與他嗎﹖',
    '結16:22 你行這一切可憎和淫亂的事，並未追念你幼年赤身露體滾在血中的日子。',
    '結16:23 你行這一切惡事之後（主耶和華說：你有禍了！有禍了！）',
    '結16:24 又為自己建造圓頂花樓，在各街上做了高臺。',
    '結16:25 你在一切市口上建造高臺，使你的美貌變為可憎的，又與一切過路的多行淫亂。',
    '結16:26 你也和你鄰邦放縱情慾的埃及人行淫，加增你的淫亂，惹我發怒。',
    '結16:27 因此我伸手攻擊你，減少你應用的糧食，又將你交給恨你的非利士眾女（眾女是城邑的意思；本章下同），使他們任意待你。他們見你的淫行，為你羞恥。',
    '結16:28 你因貪色無厭，又與亞述人行淫，與他們行淫之後，仍不滿意，',
    '結16:29 並且多行淫亂，直到那貿易之地，就是迦勒底，你仍不滿意。',
    '結16:30 主耶和華說：你行這一切事，都是不知羞恥妓女所行的，可見你的心是何等懦弱！',
    '結16:31 因你在一切市口上建造圓頂花樓，在各街上做了高臺，你卻藐視賞賜，不像妓女。',
    '結16:32 哎！你這行淫的妻啊，寧肯接外人，不接丈夫。',
    '結16:33 凡妓女是得人贈送，你反倒贈送你所愛的人，賄賂他們從四圍來與你行淫。',
    '結16:34 你行淫與別的婦女相反，因為不是人從你行淫；你既贈送人，人並不贈送你；所以你與別的婦女相反。',
    '結16:35 你這妓女啊，要聽耶和華的話。',
    '結16:36 主耶和華如此說：因你的污穢傾洩了，你與你所愛的行淫露出下體，又因你拜一切可憎的偶像，流兒女的血獻給他，',
    '結16:37 我就要將你一切相歡相愛的和你一切所恨的都聚集來，從四圍攻擊你；又將你的下體露出，使他們看盡了。',
    '結16:38 我也要審判你，好像官長審判淫婦和流人血的婦女一樣。我因忿怒忌恨，使流血的罪歸到你身上。',
    '結16:39 我又要將你交在他們手中；他們必拆毀你的圓頂花樓，毀壞你的高臺，剝去你的衣服，奪取你的華美寶器，留下你赤身露體。',
    '結16:40 他們也必帶多人來攻擊你，用石頭打死你，用刀劍刺透你，',
    '結16:41 用火焚燒你的房屋，在許多婦人眼前向你施行審判。我必使你不再行淫，也不再贈送與人。',
    '結16:42 這樣，我就止息向你發的忿怒，我的忌恨也要離開你，我要安靜不再惱怒。',
    '結16:43 因你不追念你幼年的日子，在這一切的事上向我發烈怒，所以我必照你所行的報應在你頭上，你就不再貪淫，行那一切可憎的事。這是主耶和華說的。',
    '結16:44 凡說俗語的必用俗語攻擊你，說：母親怎樣，女兒也怎樣。',
    '結16:45 你正是你母親的女兒，厭棄丈夫和兒女；你正是你姊妹的姊妹，厭棄丈夫和兒女。你母親是赫人，你父親是亞摩利人。',
    '結16:46 你的姊姊是撒瑪利亞，他和他的眾女住在你左邊；你的妹妹是所多瑪，他和他的眾女住在你右邊。',
    '結16:47 你沒有效法他們的行為，也沒有照他們可憎的事去做，你以那為小事，你一切所行的倒比他們更壞。',
    '結16:48 主耶和華說：我指著我的永生起誓，你妹妹所多瑪與他的眾女尚未行你和你眾女所行的事。',
    '結16:49 看哪，你妹妹所多瑪的罪孽是這樣：他和他的眾女都心驕氣傲，糧食飽足，大享安逸，並沒有扶助困苦和窮乏人的手。',
    '結16:50 他們狂傲，在我面前行可憎的事，我看見便將他們除掉。',
    '結16:51 撒瑪利亞沒有犯你一半的罪，你行可憎的事比他更多，使你的姊妹因你所行一切可憎的事，倒顯為義。',
    '結16:52 你既斷定你姊妹為義（為義：或譯當受羞辱），就要擔當自己的羞辱；因你所犯的罪比他們更為可憎，他們就比你更顯為義；你既使你的姊妹顯為義，你就要抱愧擔當自己的羞辱。',
    '結16:53 我必叫他們被擄的歸回，就是叫所多瑪和他的眾女，撒瑪利亞和他的眾女，並你們中間被擄的，都要歸回，',
    '結16:54 好使你擔當自己的羞辱，並因你一切所行的使他們得安慰，你就抱愧。',
    '結16:55 你的妹妹所多瑪和他的眾女必歸回原位；撒瑪利亞和他的眾女，你和你的眾女，也必歸回原位。',
    '結16:56 在你驕傲的日子，你的惡行沒有顯露以先，你的口就不提你的妹妹所多瑪。那受了凌辱的亞蘭眾女和亞蘭四圍非利士的眾女都恨惡你，藐視你。',
    '結16:57 併於上節。',
    '結16:58 耶和華說：你貪淫和可憎的事，你已經擔當了。',
    '結16:59 主耶和華如此說：你這輕看誓言、背棄盟約的，我必照你所行的待你。',
    '結16:60 然而我要追念在你幼年時與你所立的約，也要與你立定永約。',
    '結16:61 你接待你姊姊和你妹妹的時候，你要追念你所行的，自覺慚愧；並且我要將他們賜你為女兒，卻不是按著前約。',
    '結16:62 我要堅定與你所立的約（你就知道我是耶和華），',
    '結16:63 好使你在我赦免你一切所行的時候，心裡追念，自覺抱愧，又因你的羞辱就不再開口。這是主耶和華說的。',
    '結17:1 耶和華的話臨到我說：',
    '結17:2 人子啊，你要向以色列家出謎語，設比喻，',
    '結17:3 說主耶和華如此說：有一大鷹，翅膀大，翎毛長，羽毛豐滿，彩色俱備，來到利巴嫩，將香柏樹梢擰去，',
    '結17:4 就是折去香柏樹儘尖的嫩枝，叼到貿易之地，放在買賣城中；',
    '結17:5 又將以色列地的枝子栽於肥田裡，插在大水旁，如插柳樹，',
    '結17:6 就漸漸生長，成為蔓延矮小的葡萄樹。其枝轉向那鷹，其根在鷹以下，於是成了葡萄樹，生出枝子，發出小枝。',
    '結17:7 又有一大鷹，翅膀大，羽毛多。這葡萄樹從栽種的畦中向這鷹彎過根來，發出枝子，好得他的澆灌。',
    '結17:8 這樹栽於肥田多水的旁邊，好生枝子，結果子，成為佳美的葡萄樹。',
    '結17:9 你要說，主耶和華如此說：這葡萄樹豈能發旺呢﹖鷹豈不拔出他的根來，芟除他的果子，使他枯乾，使他發的嫩葉都枯乾了嗎﹖也不用大力和多民，就拔出他的根來。',
    '結17:10 葡萄樹雖然栽種，豈能發旺呢﹖一經東風，豈不全然枯乾嗎﹖必在生長的畦中枯乾了。',
    '結17:11 耶和華的話臨到我說：',
    '結17:12 你對那悖逆之家說：你們不知道這些事是什麼意思嗎﹖你要告訴他們說，巴比倫王曾到耶路撒冷，將其中的君王和首領帶到巴比倫自己那裡去。',
    '結17:13 從以色列的宗室中取一人與他立約，使他發誓，並將國中有勢力的人擄去，',
    '結17:14 使國低微不能自強，惟因守盟約得以存立。',
    '結17:15 他卻背叛巴比倫王，打發使者往埃及去，要他們給他馬匹和多民。他豈能亨通呢﹖行這樣事的人豈能逃脫呢﹖他背約豈能逃脫呢﹖',
    '結17:16 他輕看向王所起的誓，背棄王與他所立的約。主耶和華說：我指著我的永生起誓，他定要死在立他作王、巴比倫王的京都。',
    '結17:17 敵人築壘造臺，與他打仗的時候，為要剪除多人，法老雖領大軍隊和大群眾，還是不能幫助他。',
    '結17:18 他輕看誓言，背棄盟約，已經投降，卻又做這一切的事，他必不能逃脫。',
    '結17:19 所以主耶和華如此說：我指著我的永生起誓，他既輕看指我所起的誓，背棄指我所立的約，我必要使這罪歸在他頭上。',
    '結17:20 我必將我的網撒在他身上，他必在我的網羅中纏住。我必帶他到巴比倫，並要在那裡因他干犯我的罪刑罰他。',
    '結17:21 他的一切軍隊，凡逃跑的，都必倒在刀下；所剩下的，也必分散四方（方：原文是風）。你們就知道說這話的是我─耶和華。',
    '結17:22 主耶和華如此說：我要將香柏樹梢擰去栽上，就是從儘尖的嫩枝中折一嫩枝，栽於極高的山上；',
    '結17:23 在以色列高處的山栽上。他就生枝子，結果子，成為佳美的香柏樹，各類飛鳥都必宿在其下，就是宿在枝子的蔭下。',
    '結17:24 田野的樹木都必知道我─耶和華使高樹矮小，矮樹高大；青樹枯乾，枯樹發旺。我─耶和華如此說，也如此行了。',
    '結18:1 耶和華的話又臨到我說：',
    '結18:2 你們在以色列地怎麼用這俗語說父親吃了酸葡萄，兒子的牙酸倒了呢﹖',
    '結18:3 主耶和華說：我指著我的永生起誓，你們在以色列中，必不再有用這俗語的因由。',
    '結18:4 看哪，世人都是屬我的；為父的怎樣屬我，為子的也照樣屬我；犯罪的，他必死亡。',
    '結18:5 人若是公義，且行正直與合理的事：',
    '結18:6 未曾在山上吃過祭偶像之物，未曾仰望以色列家的偶像，未曾玷污鄰舍的妻，未曾在婦人的經期內親近他，',
    '結18:7 未曾虧負人，乃將欠債之人的當頭還給他；未曾搶奪人的物件，卻將食物給飢餓的人吃，將衣服給赤身的人穿；',
    '結18:8 未曾向借錢的弟兄取利，也未曾向借糧的弟兄多要，縮手不作罪孽，在兩人之間，按至理判斷；',
    '結18:9 遵行我的律例，謹守我的典章，按誠實行事─這人是公義的，必定存活。這是主耶和華說的。',
    '結18:10 他若生一個兒子，作強盜，是流人血的，不行以上所說之善，反行其中之惡，乃在山上吃過祭偶像之物，並玷污鄰舍的妻，',
    '結18:11 併於上節。',
    '結18:12 虧負困苦和窮乏的人，搶奪人的物，未曾將當頭還給人，仰望偶像，並行可憎的事，',
    '結18:13 向借錢的弟兄取利，向借糧的弟兄多要─這人豈能存活呢﹖他必不能存活。他行這一切可憎的事，必要死亡，他的罪（原文是血）必歸到他身上。',
    '結18:14 他若生一個兒子，見父親所犯的一切罪便懼怕（有古卷：思量），不照樣去做；',
    '結18:15 未曾在山上吃過祭偶像之物，未曾仰望以色列家的偶像，未曾玷污鄰舍的妻，',
    '結18:16 未曾虧負人，未曾取人的當頭，未曾搶奪人的物件，卻將食物給飢餓的人吃，將衣服給赤身的人穿，',
    '結18:17 縮手不害貧窮人，未曾向借錢的弟兄取利，也未曾向借糧的弟兄多要；他順從我的典章，遵行我的律例，就不因父親的罪孽死亡，定要存活。',
    '結18:18 至於他父親；因為欺人太甚，搶奪弟兄，在本國的民中行不善，他必因自己的罪孽死亡。',
    '結18:19 你們還說：兒子為何不擔當父親的罪孽呢﹖兒子行正直與合理的事，謹守遵行我的一切律例，他必定存活。',
    '結18:20 惟有犯罪的，他必死亡。兒子必不擔當父親的罪孽，父親也不擔當兒子的罪孽。義人的善果必歸自己，惡人的惡報也必歸自己。',
    '結18:21 惡人若回頭離開所做的一切罪惡，謹守我一切的律例，行正直與合理的事，他必定存活，不致死亡。',
    '結18:22 他所犯的一切罪過都不被記念，因所行的義，他必存活。',
    '結18:23 主耶和華說：惡人死亡，豈是我喜悅的嗎﹖不是喜悅他回頭離開所行的道存活嗎﹖',
    '結18:24 義人若轉離義行而作罪孽，照著惡人所行一切可憎的事而行，他豈能存活嗎﹖他所行的一切義都不被記念；他必因所犯的罪、所行的惡死亡。',
    '結18:25 你們還說：主的道不公平！以色列家啊，你們當聽，我的道豈不公平嗎﹖你們的道豈不是不公平嗎﹖',
    '結18:26 義人若轉離義行而作罪孽死亡，他是因所作的罪孽死亡。',
    '結18:27 再者，惡人若回頭離開所行的惡，行正直與合理的事，他必將性命救活了。',
    '結18:28 因為他思量，回頭離開所犯的一切罪過，必定存活，不致死亡。',
    '結18:29 以色列家還說：主的道不公平！以色列家啊，我的道豈不公平嗎﹖你們的道豈不是不公平嗎﹖',
    '結18:30 所以主耶和華說：以色列家啊，我必按你們各人所行的審判你們。你們當回頭離開所犯的一切罪過。這樣，罪孽必不使你們敗亡。',
    '結18:31 你們要將所犯的一切罪過盡行拋棄，自做一個新心和新靈。以色列家啊，你們何必死亡呢﹖',
    '結18:32 主耶和華說：我不喜悅那死人之死，所以你們當回頭而存活。',
    '結19:1 你當為以色列的王作起哀歌，',
    '結19:2 說：你的母親是什麼呢﹖是個母獅子，蹲伏在獅子中間，在少壯獅子中養育小獅子。',
    '結19:3 在他小獅子中養大一個，成了少壯獅子，學會抓食而吃人。',
    '結19:4 列國聽見了就把他捉在他們的坑中，用鉤子拉到埃及地去。',
    '結19:5 母獅見自己等候失了指望，就從他小獅子中又將一個養為少壯獅子。',
    '結19:6 他在眾獅子中走來走去，成了少壯獅子，學會抓食而吃人。',
    '結19:7 他知道列國的宮殿，又使他們的城邑變為荒場；因他咆哮的聲音，遍地和其中所有的就都荒廢。',
    '結19:8 於是四圍邦國各省的人來攻擊他，將網撒在他身上，捉在他們的坑中。',
    '結19:9 他們用鉤子鉤住他，將他放在籠中，帶到巴比倫王那裡，將他放入堅固之所，使他的聲音在以色列山上不再聽見。',
    '結19:10 你的母親先前如葡萄樹，極其茂盛（原文是在你血中），栽於水旁。因為水多，就多結果子，滿生枝子；',
    '結19:11 生出堅固的枝幹，可作掌權者的杖。這枝幹高舉在茂密的枝中，而且他生長高大，枝子繁多，遠遠可見。',
    '結19:12 但這葡萄樹因忿怒被拔出摔在地上；東風吹乾其上的果子，堅固的枝幹折斷枯乾，被火燒毀了；',
    '結19:13 如今栽於曠野乾旱無水之地。',
    '結19:14 火也從他枝幹中發出，燒滅果子，以致沒有堅固的枝幹可做掌權者的杖。這是哀歌，也必用以作哀歌。',
    '結20:1 第七年五月初十日，有以色列的幾個長老來求問耶和華，坐在我面前。',
    '結20:2 耶和華的話臨到我說：',
    '結20:3 人子啊，你要告訴以色列的長老說，主耶和華如此說：你們來是求問我嗎﹖主耶和華說：我指著我的永生起誓，我必不被你們求問。',
    '結20:4 人子啊，你要審問審問他們嗎﹖你當使他們知道他們列祖那些可憎的事，',
    '結20:5 對他們說，主耶和華如此說：當日我揀選以色列，向雅各家的後裔起誓，在埃及地將自己向他們顯現，說：我是耶和華─你們的神。',
    '結20:6 那日我向他們起誓，必領他們出埃及地，到我為他們察看的流奶與蜜之地；那地在萬國中是有榮耀的。',
    '結20:7 我對他們說，你們各人要拋棄眼所喜愛那可憎之物，不可因埃及的偶像玷污自己。我是耶和華─你們的神。',
    '結20:8 他們卻悖逆我，不肯聽從我，不拋棄他們眼所喜愛那可憎之物，不離棄埃及的偶像。我就說，我要將我的忿怒傾在他們身上，在埃及地向他們成就我怒中所定的。',
    '結20:9 我卻為我名的緣故沒有這樣行，免得我名在他們所住的列國人眼前被褻瀆；我領他們出埃及地，在這列國人的眼前將自己向他們顯現。',
    '結20:10 這樣，我就使他們出埃及地，領他們到曠野，',
    '結20:11 將我的律例賜給他們，將我的典章指示他們；人若遵行就必因此活著。',
    '結20:12 又將我的安息日賜給他們，好在我與他們中間為證據，使他們知道我─耶和華是叫他們成為聖的。',
    '結20:13 以色列家卻在曠野悖逆我，不順從我的律例，厭棄我的典章（人若遵行就必因此活著），大大干犯我的安息日。我就說，要在曠野將我的忿怒傾在他們身上，滅絕他們。',
    '結20:14 我卻為我名的緣故，沒有這樣行，免得我的名在我領他們出埃及的列國人眼前被褻瀆。',
    '結20:15 並且我在曠野向他們起誓，必不領他們進入我所賜給他們流奶與蜜之地（那地在萬國中是有榮耀的）；',
    '結20:16 因為他們厭棄我的典章，不順從我的律例，干犯我的安息日，他們的心隨從自己的偶像。',
    '結20:17 雖然如此，我眼仍顧惜他們，不毀滅他們，不在曠野將他們滅絕淨盡。',
    '結20:18 我在曠野對他們的兒女說：不要遵行你們父親的律例，不要謹守他們的惡規，也不要因他們的偶像玷污自己。',
    '結20:19 我是耶和華─你們的神，你們要順從我的律例，謹守遵行我的典章，',
    '結20:20 且以我的安息日為聖。這日在我與你們中間為證據，使你們知道我是耶和華─你們的神。',
    '結20:21 只是他們的兒女悖逆我，不順從我的律例，也不謹守遵行我的典章（人若遵行就必因此活著），干犯我的安息日。我就說，要將我的忿怒傾在他們身上，在曠野向他們成就我怒中所定的。',
    '結20:22 雖然如此，我卻為我名的緣故縮手沒有這樣行，免得我的名在我領他們出埃及的列國人眼前被褻瀆。',
    '結20:23 並且我在曠野向他們起誓，必將他們分散在列國，四散在列邦；',
    '結20:24 因為他們不遵行我的典章，竟厭棄我的律例，干犯我的安息日，眼目仰望他們父親的偶像。',
    '結20:25 我也任他們遵行不美的律例，謹守不能使人活著的惡規。',
    '結20:26 因他們將一切頭生的經火，我就任憑他們在這供獻的事上玷污自己，好叫他們淒涼，使他們知道我是耶和華。',
    '結20:27 人子啊，你要告訴以色列家說，主耶和華如此說：你們的列祖在得罪我的事上褻瀆我；',
    '結20:28 因為我領他們到了我起誓應許賜給他們的地，他們看見各高山、各茂密樹，就在那裡獻祭，奉上惹我發怒的供物，也在那裡焚燒馨香的祭牲，並澆上奠祭。',
    '結20:29 我就對他們說：你們所上的那高處叫什麼呢﹖（那高處的名字叫巴麻直到今日。）',
    '結20:30 所以你要對以色列家說，主耶和華如此說：你們仍照你們列祖所行的玷污自己嗎﹖仍照他們可憎的事行邪淫嗎﹖',
    '結20:31 你們奉上供物使你們兒子經火的時候，仍將一切偶像玷污自己，直到今日嗎﹖以色列家啊，我豈被你們求問嗎﹖主耶和華說：我指著我的永生起誓，我必不被你們求問。',
    '結20:32 你們說：我們要像外邦人和列國的宗族一樣，去事奉木頭與石頭。你們所起的這心意萬不能成就。',
    '結20:33 主耶和華說：我指著我的永生起誓，我總要作王，用大能的手和伸出來的膀臂，並傾出來的忿怒，治理你們。',
    '結20:34 我必用大能的手和伸出來的膀臂，並傾出來的忿怒，將你們從萬民中領出來，從分散的列國內聚集你們。',
    '結20:35 我必帶你們到外邦人的曠野，在那裡當面刑罰你們。',
    '結20:36 我怎樣在埃及地的曠野刑罰你們的列祖，也必照樣刑罰你們。這是主耶和華說的。',
    '結20:37 我必使你們從杖下經過，使你們被約拘束。',
    '結20:38 我必從你們中間除淨叛逆和得罪我的人，將他們從所寄居的地方領出來，他們卻不得入以色列地。你們就知道我是耶和華。',
    '結20:39 以色列家啊，至於你們，主耶和華如此說：從此以後若不聽從我，就任憑你們去事奉偶像，只是不可再因你們的供物和偶像褻瀆我的聖名。',
    '結20:40 主耶和華說：在我的聖山，就是以色列高處的山，所有以色列的全家都要事奉我。我要在那裡悅納你們，向你們要供物和初熟的土產，並一切的聖物。',
    '結20:41 我從萬民中領你們出來，從分散的列國內聚集你們，那時我必悅納你們好像馨香之祭，要在外邦人眼前在你們身上顯為聖。',
    '結20:42 我領你們進入以色列地，就是我起誓應許賜給你們列祖之地，那時你們就知道我是耶和華。',
    '結20:43 你們在那裡要追念玷污自己的行動作為，又要因所做的一切惡事厭惡自己。',
    '結20:44 主耶和華說：以色列家啊，我為我名的緣故，不照著你們的惡行和你們的壞事待你們；你們就知道我是耶和華。',
    '結20:45 耶和華的話臨到我說：',
    '結20:46 人子啊，你要面向南方，向南滴下預言攻擊南方田野的樹林。',
    '結20:47 對南方的樹林說，要聽耶和華的話。主耶和華如此說：我必使火在你中間著起，燒滅你中間的一切青樹和枯樹，猛烈的火焰必不熄滅。從南到北，人的臉面都被燒焦。',
    '結20:48 凡有血氣的都必知道是我─耶和華使火著起，這火必不熄滅。',
    '結20:49 於是我說：哎！主耶和華啊，人都指著我說：他豈不是說比喻的嗎﹖',
    '結21:1 耶和華的話臨到我說：',
    '結21:2 人子啊，你要面向耶路撒冷和聖所滴下預言，攻擊以色列地。',
    '結21:3 對以色列地說，耶和華如此說：我與你為敵，並要拔刀出鞘，從你中間將義人和惡人一併剪除。',
    '結21:4 我既要從你中間剪除義人和惡人，所以我的刀要出鞘，自南至北攻擊一切有血氣的；',
    '結21:5 一切有血氣的就知道我─耶和華已經拔刀出鞘，必不再入鞘。',
    '結21:6 人子啊，你要歎息，在他們眼前彎著腰，苦苦地歎息。',
    '結21:7 他們問你說：為何歎息呢﹖你就說：因為有風聲、災禍要來。人心都必消化，手都發軟，精神衰敗，膝弱如水。看哪，這災禍臨近，必然成就。這是主耶和華說的。',
    '結21:8 耶和華的話臨到我說：',
    '結21:9 人子啊，你要預言。耶和華吩咐我如此說：有刀、有刀，是磨快擦亮的；',
    '結21:10 磨快為要行殺戮，擦亮為要像閃電。我們豈可快樂嗎﹖罰我子的杖藐視各樹。',
    '結21:11 這刀已經交給人擦亮，為要應手使用。這刀已經磨快擦亮，好交在行殺戮的人手中。',
    '結21:12 人子啊，你要呼喊哀號，因為這刀臨到我的百姓和以色列一切的首領。他們和我的百姓都交在刀下，所以你要拍腿歎息。',
    '結21:13 有試驗的事；若那藐視的杖歸於無有，怎麼樣呢﹖這是主耶和華說的。',
    '結21:14 人子啊，你要拍掌預言。我─耶和華要使這刀，就是致死傷的刀，一連三次加倍刺人，進入他們的內屋，使大人受死傷的就是這刀。',
    '結21:15 我設立這恐嚇人的刀，攻擊他們的一切城門，使他們的心消化，加增他們跌倒的事。哎！這刀造得像閃電，磨得尖利，要行殺戮。',
    '結21:16 刀啊，你歸在右邊，擺在左邊；你面向哪方，就向那方殺戮。',
    '結21:17 我也要拍掌，並要使我的忿怒止息。這是我─耶和華說的。',
    '結21:18 耶和華的話又臨到我說：',
    '結21:19 人子啊，你要定出兩條路，好使巴比倫王的刀來。這兩條路必從一地分出來，又要在通城的路口上畫出一隻手來。',
    '結21:20 你要定出一條路，使刀來到亞捫人的拉巴；又要定出一條路，使刀來到猶大的堅固城耶路撒冷。',
    '結21:21 因為巴比倫王站在岔路那裡，在兩條路口上要占卜。他搖籤（原文是箭）求問神像，察看犧牲的肝；',
    '結21:22 在右手中拿著為耶路撒冷占卜的籤，使他安設撞城錘，張口叫殺，揚聲吶喊，築壘造臺，以撞城錘，攻打城門。',
    '結21:23 據那些曾起誓的猶大人看來，這是虛假的占卜；但巴比倫王要使他們想起罪孽，以致將他們捉住。',
    '結21:24 主耶和華如此說：因你們的過犯顯露，使你們的罪孽被記念，以致你們的罪惡在行為上都彰顯出來；又因你們被記念，就被捉住。',
    '結21:25 你這受死傷行惡的以色列王啊，罪孽的盡頭到了，受報的日子已到。',
    '結21:26 主耶和華如此說：當除掉冠，摘下冕，景況必不再像先前；要使卑者升為高，使高者降為卑。',
    '結21:27 我要將這國傾覆，傾覆，而又傾覆；這國也必不再有，直等到那應得的人來到，我就賜給他。',
    '結21:28 人子啊，要發預言說：主耶和華論到亞捫人和他們的凌辱，吩咐我如此說：有刀，有拔出來的刀，已經擦亮，為行殺戮，使他像閃電以行吞滅。',
    '結21:29 人為你見虛假的異象，行謊詐的占卜，使你倒在受死傷之惡人的頸項上。他們罪孽到了盡頭，受報的日子已到。',
    '結21:30 你將刀收入鞘吧！在你受造之處、生長之地，我必刑罰你。',
    '結21:31 我必將我的惱恨倒在你身上，將我烈怒的火噴在你身上；又將你交在善於殺滅的畜類人手中。',
    '結21:32 你必當柴被火焚燒，你的血必流在國中，你必不再被記念，因為這是我─耶和華說的。',
    '結22:1 耶和華的話又臨到我說：',
    '結22:2 人子啊，你要審問審問這流人血的城嗎﹖當使他知道他一切可憎的事。',
    '結22:3 你要說，主耶和華如此說：哎！這城有流人血的事在其中，叫他受報的日期來到，又做偶像玷污自己，陷害自己。',
    '結22:4 你因流了人的血，就為有罪；你做了偶像，就玷污自己，使你受報之日臨近，報應之年來到。所以我叫你受列國的凌辱和列邦的譏誚。',
    '結22:5 你這名臭、多亂的城啊，那些離你近、離你遠的都必譏誚你。',
    '結22:6 看哪，以色列的首領各逞其能，在你中間流人之血。',
    '結22:7 在你中間有輕慢父母的，有欺壓寄居的，有虧負孤兒寡婦的。',
    '結22:8 你藐視了我的聖物，干犯了我的安息日。',
    '結22:9 在你中間有讒謗人、流人血的；有在山上吃過祭偶像之物的，有行淫亂的。',
    '結22:10 在你中間有露繼母下體羞辱父親的，有玷辱月經不潔淨之婦人的。',
    '結22:11 這人與鄰舍的妻行可憎的事；那人貪淫玷污兒婦；還有玷辱同父之姊妹的。',
    '結22:12 在你中間有為流人血受賄賂的；有向借錢的弟兄取利，向借糧的弟兄多要的。且因貪得無饜，欺壓鄰舍奪取財物，竟忘了我。這是主耶和華說的。',
    '結22:13 看哪，我因你所得不義之財和你中間所流的血，就拍掌歎息。',
    '結22:14 到了我懲罰你的日子，你的心還能忍受嗎﹖你的手還能有力嗎﹖我─耶和華說了這話，就必照著行。',
    '結22:15 我必將你分散在列國，四散在列邦。我也必從你中間除掉你的污穢。',
    '結22:16 你必在列國人的眼前因自己所行的被褻瀆，你就知道我是耶和華。',
    '結22:17 耶和華的話臨到我說：',
    '結22:18 人子啊，以色列家在我看為渣滓。他們都是爐中的銅、錫、鐵、鉛，都是銀渣滓。',
    '結22:19 所以主耶和華如此說：因你們都成為渣滓，我必聚集你們在耶路撒冷中。',
    '結22:20 人怎樣將銀、銅、鐵、鉛、錫聚在爐中，吹火鎔化；照樣，我也要發怒氣和忿怒，將你們聚集放在城中，鎔化你們。',
    '結22:21 我必聚集你們，把我烈怒的火吹在你們身上，你們就在其中鎔化。',
    '結22:22 銀子怎樣鎔化在爐中，你們也必照樣鎔化在城中，你們就知道我─耶和華是將忿怒倒在你們身上了。',
    '結22:23 耶和華的話臨到我說：',
    '結22:24 人子啊，你要對這地說：你是未得潔淨之地，在惱恨的日子也沒有雨下在你以上。',
    '結22:25 其中的先知同謀背叛，如咆哮的獅子抓撕掠物。他們吞滅人民，搶奪財寶，使這地多有寡婦。',
    '結22:26 其中的祭司強解我的律法，褻瀆我的聖物，不分別聖的和俗的，也不使人分辨潔淨的和不潔淨的，又遮眼不顧我的安息日；我也在他們中間被褻慢。',
    '結22:27 其中的首領彷彿豺狼抓撕掠物，殺人流血，傷害人命，要得不義之財。',
    '結22:28 其中的先知為百姓用未泡透的灰抹牆，就是為他們見虛假的異象，用謊詐的占卜，說：主耶和華如此說，其實耶和華沒有說。',
    '結22:29 國內眾民一味地欺壓，慣行搶奪，虧負困苦窮乏的，背理欺壓寄居的。',
    '結22:30 我在他們中間尋找一人重修牆垣，在我面前為這國站在破口防堵，使我不滅絕這國，卻找不著一個。',
    '結22:31 所以我將惱恨倒在他們身上，用烈怒的火滅了他們，照他們所行的報應在他們頭上。這是主耶和華說的。',
    '結23:1 耶和華的話又臨到我說：',
    '結23:2 人子啊，有兩個女子，是一母所生，',
    '結23:3 他們在埃及行邪淫，在幼年時行邪淫。他們在那裡作處女的時候，有人擁抱他們的懷，撫摸他們的乳。',
    '結23:4 他們的名字，姊姊名叫阿荷拉，妹妹名叫阿荷利巴。他們都歸於我，生了兒女。論到他們的名字，阿荷拉就是撒瑪利亞，阿荷利巴就是耶路撒冷。',
    '結23:5 阿荷拉歸我之後行邪淫，貪戀所愛的人，就是他的鄰邦亞述人。',
    '結23:6 這些人都穿藍衣，作省長、副省長，都騎著馬，是可愛的少年人。',
    '結23:7 阿荷拉就與亞述人中最美的男子放縱淫行，他因所戀愛之人的一切偶像，玷污自己。',
    '結23:8 自從在埃及的時候，他就沒有離開淫亂，因為他年幼作處女的時候，埃及人與他行淫，撫摸他的乳，縱慾與他行淫。',
    '結23:9 因此，我將他交在他所愛的人手中，就是他所戀愛的亞述人手中。',
    '結23:10 他們就露了他的下體，擄掠他的兒女，用刀殺了他，使他在婦女中留下臭名，因他們向他施行審判。',
    '結23:11 他妹妹阿荷利巴雖然看見了，卻還貪戀，比他姊姊更醜；行淫亂比他姊姊更多。',
    '結23:12 他貪戀鄰邦的亞述人，就是穿極華美的衣服，騎著馬的省長、副省長，都是可愛的少年人。',
    '結23:13 我看見他被玷污了，他姊妹二人同行一路。',
    '結23:14 阿荷利巴又加增淫行，因他看見人像畫在牆上，就是用丹色所畫迦勒底人的像，',
    '結23:15 腰間繫著帶子，頭上有下垂的裹頭巾，都是軍長的形狀，仿照巴比倫人的形像；他們的故土就是迦勒底。',
    '結23:16 阿荷利巴一看見就貪戀他們，打發使者往迦勒底去見他們。',
    '結23:17 巴比倫人就來登他愛情的床，與他行淫玷污他。他被玷污，隨後心裡與他們生疏。',
    '結23:18 這樣，他顯露淫行，又顯露下體；我心就與他生疏，像先前與他姊姊生疏一樣。',
    '結23:19 他還加增他的淫行，追念他幼年在埃及地行邪淫的日子，',
    '結23:20 貪戀情人身壯精足，如驢如馬。',
    '結23:21 這樣，你就想起你幼年的淫行。那時，埃及人擁抱你的懷，撫摸你的乳。',
    '結23:22 阿荷利巴啊，主耶和華如此說：我必激動你先愛而後生疏的人來攻擊你。我必使他們來，在你四圍攻擊你。',
    '結23:23 所來的就是巴比倫人、迦勒底的眾人、比割人、書亞人、哥亞人，同著他們的還有亞述眾人，乃是作省長、副省長、作軍長有名聲的，都騎著馬，是可愛的少年人。',
    '結23:24 他們必帶兵器、戰車、輜重車，率領大眾來攻擊你。他們要拿大小盾牌，頂盔擺陣，在你四圍攻擊你。我要將審判的事交給他們，他們必按著自己的條例審判你。',
    '結23:25 我必以忌恨攻擊你；他們必以忿怒辦你。他們必割去你的鼻子和耳朵；你遺留（或譯：餘剩；下同）的人必倒在刀下。他們必擄去你的兒女；你所遺留的必被火焚燒。',
    '結23:26 他們必剝去你的衣服，奪取你華美的寶器。',
    '結23:27 這樣，我必使你的淫行和你從埃及地染來的淫亂止息了，使你不再仰望亞述，也不再追念埃及。',
    '結23:28 主耶和華如此說：我必將你交在你所恨惡的人手中，就是你心與他生疏的人手中。',
    '結23:29 他們必以恨惡辦你，奪取你一切勞碌得來的，留下你赤身露體。你淫亂的下體，連你的淫行，帶你的淫亂，都被顯露。',
    '結23:30 人必向你行這些事；因為你隨從外邦人行邪淫，被他們的偶像玷污了。',
    '結23:31 你走了你姊姊所走的路，所以我必將他的杯交在你手中。',
    '結23:32 主耶和華如此說：你必喝你姊姊所喝的杯；那杯又深又廣，盛得甚多，使你被人嗤笑譏刺。',
    '結23:33 你必酩酊大醉，滿有愁苦，喝乾你姊姊撒瑪利亞的杯，就是令人驚駭淒涼的杯。',
    '結23:34 你必喝這杯，以致喝盡。杯破又齦杯片，撕裂自己的乳；因為這事我曾說過。這是主耶和華說的。',
    '結23:35 主耶和華如此說：因你忘記我，將我丟在背後，所以你要擔當你淫行和淫亂的報應。',
    '結23:36 耶和華又對我說：人子啊，你要審問阿荷拉與阿荷利巴嗎﹖當指出他們所行可憎的事。',
    '結23:37 他們行淫，手中有殺人的血，又與偶像行淫，並使他們為我所生的兒女經火燒給偶像。',
    '結23:38 此外，他們還有向我所行的，就是同日玷污我的聖所，干犯我的安息日。',
    '結23:39 他們殺了兒女獻與偶像，當天又入我的聖所，將聖所褻瀆了。他們在我殿中所行的乃是如此。',
    '結23:40 況且你們二婦打發使者去請遠方人。使者到他們那裡，他們就來了。你們為他們沐浴己身，粉飾眼目，佩戴妝飾，',
    '結23:41 坐在華美的床上，前面擺設桌案，將我的香料膏油擺在其上。',
    '結23:42 在那裡有群眾安逸歡樂的聲音，並有粗俗的人和酒徒從曠野同來，把鐲子戴在二婦的手上，把華冠戴在他們的頭上。',
    '結23:43 我論這行淫衰老的婦人說：現在人還要與他行淫，他也要與人行淫。',
    '結23:44 人與阿荷拉，並阿荷利巴二淫婦茍合，好像與妓女苟合。',
    '結23:45 必有義人，照審判淫婦和流人血的婦人之例，審判他們；因為他們是淫婦，手中有殺人的血。',
    '結23:46 主耶和華如此說：我必使多人來攻擊他們，使他們拋來拋去，被人搶奪。',
    '結23:47 這些人必用石頭打死他們，用刀劍殺害他們，又殺戮他們的兒女，用火焚燒他們的房屋。',
    '結23:48 這樣，我必使淫行從境內止息，好叫一切婦人都受警戒，不效法你們的淫行。',
    '結23:49 人必照著你們的淫行報應你們；你們要擔當拜偶像的罪，就知道我是主耶和華。',
    '結24:1 第九年十月初十日，耶和華的話又臨到我說：',
    '結24:2 人子啊，今日正是巴比倫王就近耶路撒冷的日子，你要將這日記下，',
    '結24:3 要向這悖逆之家設比喻說，主耶和華如此說：將鍋放在火上，放好了，就倒水在其中；',
    '結24:4 將肉塊，就是一切肥美的肉塊、腿，和肩都聚在其中，拿美好的骨頭把鍋裝滿；',
    '結24:5 取羊群中最好的，將柴堆在鍋下，使鍋開滾，好把骨頭煮在其中。',
    '結24:6 主耶和華如此說：禍哉！這流人血的城，就是長鏽的鍋。其中的鏽未曾除掉，須要將肉塊從其中一一取出來，不必為他拈鬮。',
    '結24:7 城中所流的血倒在淨光的磐石上，不倒在地上，用土掩蓋。',
    '結24:8 這城中所流的血倒在淨光的磐石上，不得掩蓋，乃是出於我，為要發忿怒施行報應。',
    '結24:9 所以主耶和華如此說：禍哉！這流人血的城，我也必大堆火柴，',
    '結24:10 添上木柴，使火著旺，將肉煮爛，把湯熬濃，使骨頭烤焦；',
    '結24:11 把鍋倒空坐在炭火上，使鍋燒熱，使銅燒紅，鎔化其中的污穢，除淨其上的鏽。',
    '結24:12 這鍋勞碌疲乏，所長的大鏽仍未除掉；這鏽就是用火也不能除掉。',
    '結24:13 在你污穢中有淫行，我潔淨你，你卻不潔淨。你的污穢再不能潔淨，直等我向你發的忿怒止息。',
    '結24:14 我─耶和華說過的必定成就，必照話而行，必不返回，必不顧惜，也不後悔。人必照你的舉動行為審判你。這是主耶和華說的。',
    '結24:15 耶和華的話又臨到我說：',
    '結24:16 人子啊，我要將你眼目所喜愛的忽然取去，你卻不可悲哀哭泣，也不可流淚，',
    '結24:17 只可歎息，不可出聲，不可辦理喪事；頭上仍勒裹頭巾，腳上仍穿鞋，不可蒙著嘴唇，也不可吃弔喪的食物。',
    '結24:18 於是我將這事早晨告訴百姓，晚上我的妻就死了。次日早晨我便遵命而行。',
    '結24:19 百姓問我說：你這樣行與我們有什麼關係，你不告訴我們嗎﹖',
    '結24:20 我回答他們：耶和華的話臨到我說：',
    '結24:21 你告訴以色列家，主耶和華如此說：我必使我的聖所，就是你們勢力所誇耀、眼裡所喜愛、心中所愛惜的被褻瀆，並且你們所遺留的兒女必倒在刀下。',
    '結24:22 那時，你們必行我僕人所行的，不蒙著嘴唇，也不吃弔喪的食物。',
    '結24:23 你們仍要頭上勒裹頭巾，腳上穿鞋；不可悲哀哭泣。你們必因自己的罪孽相對歎息，漸漸消滅。',
    '結24:24 以西結必這樣為你們作預兆；凡他所行的，你們也必照樣行。那事來到，你們就知道我是主耶和華。',
    '結24:25 人子啊，我除掉他們所倚靠、所歡喜的榮耀，並眼中所喜愛、心裡所重看的兒女。',
    '結24:26 那日逃脫的人豈不來到你這裡，使你耳聞這事嗎﹖',
    '結24:27 你必向逃脫的人開口說話，不再啞口。你必這樣為他們作預兆，他們就知道我是耶和華。',
    '結25:1 耶和華的話臨到我說：',
    '結25:2 人子啊，你要面向亞捫人說預言，攻擊他們，',
    '結25:3 說：你們當聽主耶和華的話。主耶和華如此說：我的聖所被褻瀆，以色列地變荒涼，猶大家被擄掠；那時，你便因這些事說：阿哈！',
    '結25:4 所以我必將你的地交給東方人為業；他們必在你的地上安營居住，吃你的果子，喝你的奶。',
    '結25:5 我必使拉巴為駱駝場，使亞捫人的地為羊群躺臥之處，你們就知道我是耶和華。',
    '結25:6 主耶和華如此說：因你拍手頓足，以滿心的恨惡向以色列地歡喜，',
    '結25:7 所以我伸手攻擊你，將你交給列國作為擄物。我必從萬民中剪除你，使你從萬國中敗亡。我必除滅你，你就知道我是耶和華。',
    '結25:8 主耶和華如此說：因摩押和西珥人說：看哪，猶大家與列國無異，',
    '結25:9 所以我要破開摩押邊界上的城邑，就是摩押人看為本國之榮耀的伯耶西末、巴力免、基列亭，',
    '結25:10 好使東方人來攻擊亞捫人。我必將亞捫人之地交給他們為業，使亞捫人在列國中不再被記念。',
    '結25:11 我必向摩押施行審判，他們就知道我是耶和華。',
    '結25:12 主耶和華如此說：因為以東報仇雪恨，攻擊猶大家，向他們報仇，大大有罪，',
    '結25:13 所以主耶和華如此說：我必伸手攻擊以東，剪除人與牲畜，使以東從提幔起，人必倒在刀下，地要變為荒涼，直到底但。',
    '結25:14 我必藉我民以色列的手報復以東；以色列民必照我的怒氣，按我的忿怒在以東施報，以東人就知道是我施報。這是主耶和華說的。',
    '結25:15 主耶和華如此說：因非利士人向猶大人報仇，就是以恨惡的心報仇雪恨，永懷仇恨，要毀滅他們，',
    '結25:16 所以主耶和華如此說：我必伸手攻擊非利士人，剪除基利提人，滅絕沿海剩下的居民。',
    '結25:17 我向他們大施報應，發怒斥責他們。我報復他們的時候，他們就知道我是耶和華。',
    '結26:1 第十一年十一月初一日，耶和華的話臨到我說：',
    '結26:2 人子啊，因推羅向耶路撒冷說：阿哈，那作眾民之門的已經破壞，向我開放；他既變為荒場，我必豐盛。',
    '結26:3 所以，主耶和華如此說：推羅啊，我必與你為敵，使許多國民上來攻擊你，如同海使波浪湧上來一樣。',
    '結26:4 他們必破壞推羅的牆垣，拆毀他的城樓。我也要刮淨塵土，使他成為淨光的磐石。',
    '結26:5 他必在海中作曬網的地方，也必成為列國的擄物。這是主耶和華說的。',
    '結26:6 屬推羅城邑的居民（原文是田間的眾女；八節同）必被刀劍殺滅，他們就知道我是耶和華。',
    '結26:7 主耶和華如此說：我必使諸王之王的巴比倫王尼布甲尼撒率領馬匹車輛、馬兵、軍隊，和許多人民從北方來攻擊你推羅。',
    '結26:8 他必用刀劍殺滅屬你城邑的居民，也必造臺築壘舉盾牌攻擊你。',
    '結26:9 他必安設撞城錘攻破你的牆垣，用鐵器拆毀你的城樓。',
    '結26:10 因他的馬匹眾多，塵土揚起遮蔽你。他進入你的城門，好像人進入已有破口之城。那時，你的牆垣必因騎馬的和戰車、輜重車的響聲震動。',
    '結26:11 他的馬蹄必踐踏你一切的街道，他必用刀殺戮你的居民；你堅固的柱子（或譯：柱像）必倒在地上。',
    '結26:12 人必以你的財寶為擄物，以你的貨財為掠物，破壞你的牆垣，拆毀你華美的房屋，將你的石頭、木頭、塵土都拋在水中。',
    '結26:13 我必使你唱歌的聲音止息，人也不再聽見你彈琴的聲音。',
    '結26:14 我必使你成為淨光的磐石，作曬網的地方；你不得再被建造，因為這是主耶和華說的。',
    '結26:15 主耶和華對推羅如此說：在你中間行殺戮，受傷之人唉哼的時候，因你傾倒的響聲，海島豈不都震動嗎﹖',
    '結26:16 那時靠海的君王必都下位，除去朝服，脫下花衣，披上戰兢，坐在地上，時刻發抖，為你驚駭。',
    '結26:17 他們必為你作起哀歌說：你這有名之城，素為航海之人居住，在海上為最堅固的；平日你和居民使一切住在那裡的人無不驚恐；現在何竟毀滅了﹖',
    '結26:18 如今在你這傾覆的日子，海島都必戰兢；海中的群島見你歸於無有就都驚惶。',
    '結26:19 主耶和華如此說：推羅啊，我使你變為荒涼，如無人居住的城邑；又使深水漫過你，大水淹沒你。',
    '結26:20 那時，我要叫你下入陰府，與古時的人一同在地的深處、久已荒涼之地居住，使你不再有居民。我也要在活人之地顯榮耀（我也……榮耀：或譯在活人之地不再有榮耀）。',
    '結26:21 我必叫你令人驚恐，不再存留於世；人雖尋找你，卻永尋不見。這是主耶和華說的。',
    '結27:1 耶和華的話又臨到我說：',
    '結27:2 人子啊，要為推羅作起哀歌，',
    '結27:3 說：你居住海口，是眾民的商埠；你的交易通到許多的海島。主耶和華如此說：推羅啊，你曾說：我是全然美麗的。',
    '結27:4 你的境界在海中，造你的使你全然美麗。',
    '結27:5 他們用示尼珥的松樹做你的一切板，用利巴嫩的香柏樹做桅杆，',
    '結27:6 用巴珊的橡樹做你的槳，用象牙鑲嵌基提海島的黃楊木為坐板（或譯：艙板）。',
    '結27:7 你的篷帆是用埃及繡花細麻布做的，可以做你的大旗；你的涼棚是用以利沙島的藍色、紫色布做的。',
    '結27:8 西頓和亞發的居民作你盪槳的。推羅啊，你中間的智慧人作掌舵的。',
    '結27:9 迦巴勒的老者和聰明人都在你中間作補縫的；一切泛海的船隻和水手都在你中間經營交易的事。',
    '結27:10 波斯人、路德人、弗人在你軍營中作戰士；他們在你中間懸掛盾牌和頭盔，彰顯你的尊榮。',
    '結27:11 亞發人和你的軍隊都在你四圍的牆上，你的望樓也有勇士；他們懸掛盾牌，成全你的美麗。',
    '結27:12 他施人因你多有各類的財物，就作你的客商，拿銀、鐵、錫、鉛兌換你的貨物。',
    '結27:13 雅完人、土巴人、米設人都與你交易；他們用人口和銅器兌換你的貨物。',
    '結27:14 陀迦瑪族用馬和戰馬並騾子兌換你的貨物。',
    '結27:15 底但人與你交易，許多海島作你的碼頭；他們拿象牙、烏木與你兌換（或譯：進貢）。',
    '結27:16 亞蘭人因你的工作很多，就作你的客商；他們用綠寶石、紫色布繡貨、細麻布、珊瑚、紅寶石兌換你的貨物。',
    '結27:17 猶大和以色列地的人都與你交易；他們用米匿的麥子、餅、蜜、油、乳香兌換你的貨物。',
    '結27:18 大馬色人因你的工作很多，又因你多有各類的財物，就拿黑本酒和白羊毛與你交易。',
    '結27:19 威但人和雅完人拿紡成的線、亮鐵、桂皮、菖蒲兌換你的貨物。',
    '結27:20 底但人用高貴的毯子、鞍、屜與你交易。',
    '結27:21 亞拉伯人和基達的一切首領都作你的客商，用羊羔、公綿羊、公山羊與你交易。',
    '結27:22 示巴和拉瑪的商人與你交易，他們用各類上好的香料、各類的寶石，和黃金兌換你的貨物。',
    '結27:23 哈蘭人、干尼人、伊甸人、示巴的商人，和亞述人、基抹人與你交易。',
    '結27:24 這些商人以美好的貨物包在繡花藍色包袱內，又有華麗的衣服裝在香柏木的箱子裡，用繩捆著與你交易。',
    '結27:25 他施的船隻接連成幫為你運貨，你便在海中豐富極其榮華。',
    '結27:26 盪槳的已經把你盪到大水之處，東風在海中將你打破。',
    '結27:27 你的資財、物件、貨物、水手、掌舵的、補縫的、經營交易的，並你中間的戰士和人民，在你破壞的日子必都沉在海中。',
    '結27:28 你掌舵的呼號之聲一發，郊野都必震動。',
    '結27:29 凡盪槳的和水手，並一切泛海掌舵的，都必下船登岸。',
    '結27:30 他們必為你放聲痛哭，把塵土撒在頭上，在灰中打滾；',
    '結27:31 又為你使頭上光禿，用麻布束腰，號咷痛哭，苦苦悲哀。',
    '結27:32 他們哀號的時候，為你作起哀歌哀哭，說：有何城如推羅﹖有何城如他在海中成為寂寞的呢﹖',
    '結27:33 你由海上運出貨物，就使許多國民充足；你以許多資財、貨物使地上的君王豐富。',
    '結27:34 你在深水中被海浪打破的時候，你的貨物和你中間的一切人民，就都沉下去了。',
    '結27:35 海島的居民為你驚奇；他們的君王都甚恐慌，面帶愁容。',
    '結27:36 各國民中的客商都向你發嘶聲；你令人驚恐，不再存留於世，直到永遠。',
    '結28:1 耶和華的話又臨到我說：',
    '結28:2 人子啊，你對推羅君王說，主耶和華如此說：因你心裡高傲，說：我是神；我在海中坐神之位。你雖然居心自比神，也不過是人，並不是神！',
    '結28:3 看哪，你比但以理更有智慧，什麼祕事都不能向你隱藏。',
    '結28:4 你靠自己的智慧聰明得了金銀財寶，收入庫中。',
    '結28:5 你靠自己的大智慧和貿易增添資財，又因資財心裡高傲。',
    '結28:6 所以主耶和華如此說：因你居心自比神，',
    '結28:7 我必使外邦人，就是列國中的強暴人臨到你這裡；他們必拔刀砍壞你用智慧得來的美物，褻瀆你的榮光。',
    '結28:8 他們必使你下坑；你必死在海中，與被殺的人一樣。',
    '結28:9 在殺你的人面前你還能說我是神嗎﹖其實你在殺害你的人手中，不過是人，並不是神。',
    '結28:10 你必死在外邦人手中，與未受割禮（或譯：不潔；下同）的人一樣，因為這是主耶和華說的。',
    '結28:11 耶和華的話臨到我說：',
    '結28:12 人子啊，你為推羅王作起哀歌，說主耶和華如此說：你無所不備，智慧充足，全然美麗。',
    '結28:13 你曾在伊甸神的園中，佩戴各樣寶石，就是紅寶石、紅璧璽、金鋼石、水蒼玉、紅瑪瑙、碧玉、藍寶石、綠寶石、紅玉，和黃金；又有精美的鼓笛在你那裡，都是在你受造之日預備齊全的。',
    '結28:14 你是那受膏遮掩約櫃的基路伯；我將你安置在神的聖山上；你在發光如火的寶石中間往來。',
    '結28:15 你從受造之日所行的都完全，後來在你中間又察出不義。',
    '結28:16 因你貿易很多，就被強暴的事充滿，以致犯罪，所以我因你褻瀆聖地，就從神的山驅逐你。遮掩約櫃的基路伯啊，我已將你從發光如火的寶石中除滅。',
    '結28:17 你因美麗心中高傲，又因榮光敗壞智慧，我已將你摔倒在地，使你倒在君王面前，好叫他們目睹眼見。',
    '結28:18 你因罪孽眾多，貿易不公，就褻瀆你那裡的聖所。故此，我使火從你中間發出，燒滅你，使你在所有觀看的人眼前變為地上的爐灰。',
    '結28:19 各國民中，凡認識你的，都必為你驚奇。你令人驚恐，不再存留於世，直到永遠。',
    '結28:20 耶和華的話臨到我說：',
    '結28:21 人子啊，你要向西頓預言攻擊他，',
    '結28:22 說主耶和華如此說：西頓哪，我與你為敵，我必在你中間得榮耀。我在你中間施行審判、顯為聖的時候，人就知道我是耶和華。',
    '結28:23 我必使瘟疫進入西頓，使血流在他街上。被殺的必在其中仆倒，四圍有刀劍臨到他，人就知道我是耶和華。',
    '結28:24 四圍恨惡以色列家的人，必不再向他們作刺人的荊棘，傷人的蒺藜，人就知道我是主耶和華。',
    '結28:25 主耶和華如此說：我將分散在萬民中的以色列家招聚回來，向他們在列邦人眼前顯為聖的時候，他們就在我賜給我僕人雅各之地，仍然居住。',
    '結28:26 他們要在這地上安然居住。我向四圍恨惡他們的眾人施行審判以後，他們要蓋造房屋，栽種葡萄園，安然居住，就知道我是耶和華─他們的神。',
    '結29:1 第十年十月十二日，耶和華的話臨到我說：',
    '結29:2 人子啊，你要向埃及王法老預言攻擊他和埃及全地，',
    '結29:3 說主耶和華如此說：埃及王法老啊，我與你這臥在自己河中的大魚為敵。你曾說：這河是我的，是我為自己造的。',
    '結29:4 我─耶和華必用鉤子鉤住你的腮頰，又使江河中的魚貼住你的鱗甲；我必將你和所有貼住你鱗甲的魚，從江河中拉上來，',
    '結29:5 把你並江河中的魚都拋在曠野；你必倒在田間，不被收殮，不被掩埋。我已將你給地上野獸、空中飛鳥作食物。',
    '結29:6 埃及一切的居民，因向以色列家成了蘆葦的杖，就知道我是耶和華。',
    '結29:7 他們用手持住你，你就斷折，傷了他們的肩；他們倚靠你，你就斷折，閃了他們的腰。',
    '結29:8 所以主耶和華如此說：我必使刀劍臨到你，從你中間將人與牲畜剪除。',
    '結29:9 埃及地必荒廢淒涼，他們就知道我是耶和華。因為法老說：這河是我的，是我所造的，',
    '結29:10 所以我必與你並你的江河為敵，使埃及地，從色弗尼塔直到古實境界，全然荒廢淒涼。',
    '結29:11 人的腳、獸的蹄都不經過，四十年之久並無人居住。',
    '結29:12 我必使埃及地在荒涼的國中成為荒涼，使埃及城在荒廢的城中變為荒廢，共有四十年。我必將埃及人分散在列國，四散在列邦。',
    '結29:13 主耶和華如此說：滿了四十年，我必招聚分散在各國民中的埃及人。',
    '結29:14 我必叫埃及被擄的人回來，使他們歸回本地巴忒羅。在那裡必成為低微的國，',
    '結29:15 必為列國中最低微的，也不再自高於列國之上。我必減少他們，以致不再轄制列國。',
    '結29:16 埃及必不再作以色列家所倚靠的；以色列家仰望埃及人的時候，便思念罪孽。他們就知道我是主耶和華。',
    '結29:17 二十七年正月初一日，耶和華的話臨到我說：',
    '結29:18 人子啊，巴比倫王尼布甲尼撒使他的軍兵大大效勞，攻打推羅，以致頭都光禿，肩都磨破；然而他和他的軍兵攻打推羅，並沒有從那裡得什麼酬勞。',
    '結29:19 所以主耶和華如此說：我必將埃及地賜給巴比倫王尼布甲尼撒；他必擄掠埃及群眾，搶其中的財為擄物，奪其中的貨為掠物，這就可以作他軍兵的酬勞。',
    '結29:20 我將埃及地賜給他，酬他所效的勞，因王與軍兵是為我勤勞。這是主耶和華說的。',
    '結29:21 當那日，我必使以色列家的角發生，又必使你─以西結在他們中間得以開口；他們就知道我是耶和華。',
    '結30:1 耶和華的話又臨到我說：',
    '結30:2 人子啊，你要發預言說，主耶和華如此說：哀哉這日！你們應當哭號。',
    '結30:3 因為耶和華的日子臨近，就是密雲之日，列國受罰之期。',
    '結30:4 必有刀劍臨到埃及；在埃及被殺之人仆倒的時候，古實人就有痛苦，人民必被擄掠，基址必被拆毀。',
    '結30:5 古實人、弗人（或譯：呂彼亞）、路德人、雜族的人民，並古巴人，以及同盟之地的人都要與埃及人一同倒在刀下。',
    '結30:6 耶和華如此說：扶助埃及的也必傾倒。埃及因勢力而有的驕傲必降低微；其中的人民，從色弗尼塔起（見二十九章十節）必倒在刀下。這是主耶和華說的。',
    '結30:7 埃及地在荒涼的國中必成為荒涼；埃及城在荒廢的城中也變為荒廢。',
    '結30:8 我在埃及中使火著起；幫助埃及的，都被滅絕。那時，他們就知道我是耶和華。',
    '結30:9 到那日，必有使者坐船，從我面前出去，使安逸無慮的古實人驚懼；必有痛苦臨到他們，好像埃及遭災的日子一樣。看哪，這事臨近了！',
    '結30:10 主耶和華如此說：我必藉巴比倫王尼布甲尼撒的手，除滅埃及眾人。',
    '結30:11 他和隨從他的人，就是列國中強暴的，必進來毀滅這地。他們必拔刀攻擊埃及，使遍地有被殺的人。',
    '結30:12 我必使江河乾涸，將地賣在惡人的手中；我必藉外邦人的手，使這地和其中所有的變為淒涼。這是我─耶和華說的。',
    '結30:13 主耶和華如此說：我必毀滅偶像，從挪弗除滅神像；必不再有君王出自埃及地。我要使埃及地的人懼怕。',
    '結30:14 我必使巴忒羅荒涼，在瑣安中使火著起，向挪施行審判。',
    '結30:15 我必將我的忿怒倒在埃及的保障上，就是訓上，並要剪除挪的眾人。',
    '結30:16 我必在埃及中使火著起；訓必大大痛苦；挪必被攻破；挪弗白日（或譯：終日）見仇敵。',
    '結30:17 亞文和比伯實的少年人必倒在刀下；這些城的人必被擄掠。',
    '結30:18 我在答比匿折斷埃及的諸軛，使他因勢力而有的驕傲在其中止息。那時，日光必退去；至於這城，必有密雲遮蔽，其中的女子必被擄掠。',
    '結30:19 我必這樣向埃及施行審判，他們就知道我是耶和華。',
    '結30:20 十一年正月初七日，耶和華的話臨到我說：',
    '結30:21 人子啊，我已打折埃及王法老的膀臂；沒有敷藥，也沒有用布纏好，使他有力持刀。',
    '結30:22 所以主耶和華如此說：看哪，我與埃及王法老為敵，必將他有力的膀臂和已打折的膀臂全行打斷，使刀從他手中墜落。',
    '結30:23 我必將埃及人分散在列國，四散在列邦。',
    '結30:24 我必使巴比倫王的膀臂有力，將我的刀交在他手中；卻要打斷法老的膀臂，他就在巴比倫王面前唉哼，如同受死傷的人一樣。',
    '結30:25 我必扶持巴比倫王的膀臂，法老的膀臂卻要下垂；我將我的刀交在巴比倫王手中，他必舉刀攻擊埃及地，他們就知道我是耶和華。',
    '結30:26 我必將埃及人分散在列國，四散在列邦；他們就知道我是耶和華。',
    '結31:1 十一年三月初一日，耶和華的話臨到我說：',
    '結31:2 人子啊，你要向埃及王法老和他的眾人說：在威勢上誰能與你相比呢﹖',
    '結31:3 亞述王曾如利巴嫩中的香柏樹，枝條榮美，影密如林，極其高大，樹尖插入雲中。',
    '結31:4 眾水使他生長；深水使他長大。所栽之地有江河圍流，汊出的水道延到田野諸樹。',
    '結31:5 所以他高大超過田野諸樹；發旺的時候，枝子繁多，因得大水之力枝條長長。',
    '結31:6 空中的飛鳥都在枝子上搭窩；田野的走獸都在枝條下生子；所有大國的人民都在他蔭下居住。',
    '結31:7 樹大條長，成為榮美，因為根在眾水之旁。',
    '結31:8 神園中的香柏樹不能遮蔽他；松樹不及他的枝子；楓樹不及他的枝條；神園中的樹都沒有他榮美。',
    '結31:9 我使他的枝條蕃多，成為榮美，以致神伊甸園中的樹都嫉妒他。',
    '結31:10 所以主耶和華如此說：因他高大，樹尖插入雲中，心驕氣傲，',
    '結31:11 我就必將他交給列國中大有威勢的人；他必定辦他。我因他的罪惡，已經驅逐他。',
    '結31:12 外邦人，就是列邦中強暴的，將他砍斷棄掉。他的枝條落在山間和一切谷中，他的枝子折斷，落在地的一切河旁。地上的眾民已經走去，離開他的蔭下。',
    '結31:13 空中的飛鳥都要宿在這敗落的樹上，田野的走獸都要臥在他的枝條下，',
    '結31:14 好使水旁的諸樹不因高大而自尊，也不將樹尖插入雲中，並且那些得水滋潤、有勢力的，也不得高大自立。因為他們在世人中，和下坑的人都被交與死亡，到陰府去了。',
    '結31:15 主耶和華如此說：他下陰間的那日，我便使人悲哀。我為他遮蓋深淵，使江河凝結，大水停流；我也使利巴嫩為他悽慘，田野的諸樹都因他發昏。',
    '結31:16 我將他扔到陰間，與下坑的人一同下去。那時，列國聽見他墜落的響聲就都震動，並且伊甸的一切樹─就是利巴嫩得水滋潤、最佳最美的樹─都在陰府受了安慰。',
    '結31:17 他們也與他同下陰間，到被殺的人那裡。他們曾作他的膀臂，在列國中他的蔭下居住。',
    '結31:18 在這樣榮耀威勢上，在伊甸園諸樹中，誰能與你相比呢﹖然而你要與伊甸的諸樹一同下到陰府，在未受割禮的人中，與被殺的人一同躺臥。法老和他的群眾乃是如此。這是主耶和華說的。',
    '結32:1 十二年十二月初一日，耶和華的話臨到我說：',
    '結32:2 人子啊，你要為埃及王法老作哀歌，說：從前你在列國中，如同少壯獅子；現在你卻像海中的大魚。你衝出江河，用爪攪動諸水，使江河渾濁。',
    '結32:3 主耶和華如此說：我必用多國的人民，將我的網撒在你身上，把你拉上來。',
    '結32:4 我必將你丟在地上，拋在田野，使空中的飛鳥都落在你身上，使遍地的野獸吃你得飽。',
    '結32:5 我必將你的肉丟在山間，用你高大的屍首填滿山谷。',
    '結32:6 我又必用你的血澆灌你所游泳之地，漫過山頂；河道都必充滿。',
    '結32:7 我將你撲滅的時候，要把天遮蔽，使眾星昏暗，以密雲遮掩太陽，月亮也不放光。',
    '結32:8 我必使天上的亮光都在你以上變為昏暗，使你的地上黑暗。這是主耶和華說的。',
    '結32:9 我使你敗亡的風聲傳到你所不認識的各國。那時，我必使多民的心因你愁煩。',
    '結32:10 我在許多國民和君王面前向你掄我的刀，國民就必因你驚奇，君王也必因你極其恐慌。在你仆倒的日子，他們各人為自己的性命時刻戰兢。',
    '結32:11 主耶和華如此說：巴比倫王的刀必臨到你。',
    '結32:12 我必藉勇士的刀使你的眾民仆倒；這勇士都是列國中強暴的。他們必使埃及的驕傲歸於無有；埃及的眾民必被滅絕。',
    '結32:13 我必從埃及多水旁除滅所有的走獸；人腳獸蹄必不再攪渾這水。',
    '結32:14 那時，我必使埃及河澄清，江河像油緩流。這是主耶和華說的。',
    '結32:15 我使埃及地變為荒廢淒涼；這地缺少從前所充滿的，又擊殺其中一切的居民。那時，他們就知道我是耶和華。',
    '結32:16 人必用這哀歌去哀哭，列國的女子為埃及和他的群眾也必以此悲哀。這是主耶和華說的。',
    '結32:17 十二年十二月十五日，耶和華的話臨到我說：',
    '結32:18 人子啊，你要為埃及群眾哀號，又要將埃及和有名之國的女子，並下坑的人，一同扔到陰府去。',
    '結32:19 你埃及的美麗勝過誰呢﹖你下去與未受割禮的人一同躺臥吧！',
    '結32:20 他們必在被殺的人中仆到。他被交給刀劍，要把他和他的群眾拉去。',
    '結32:21 強盛的勇士要在陰間對埃及王和幫助他的說話；他們是未受割禮被殺的人，已經下去，躺臥不動。',
    '結32:22 亞述和他的眾民都在那裡，他民的墳墓在他四圍；他們都是被殺倒在刀下的。',
    '結32:23 他們的墳墓在坑中極深之處。他的眾民在他墳墓的四圍，都是被殺倒在刀下的；他們曾在活人之地使人驚恐。',
    '結32:24 以攔也在那裡，他的群眾在他墳墓的四圍，都是被殺倒在刀下、未受割禮而下陰府的；他們曾在活人之地使人驚恐，並且與下坑的人一同擔當羞辱。',
    '結32:25 人給他和他的群眾在被殺的人中設立床榻。他民的墳墓在他四圍，他們都是未受割禮被刀殺的；他們曾在活人之地使人驚恐，並且與下坑的人一同擔當羞辱。以攔已經放在被殺的人中。',
    '結32:26 米設、土巴，和他們的群眾都在那裡。他民的墳墓在他四圍，他們都是未受割禮被刀殺的；他們曾在活人之地使人驚恐。',
    '結32:27 他們不得與那未受割禮仆倒的勇士一同躺臥；這些勇士帶著兵器下陰間，頭枕刀劍，骨頭上有本身的罪孽；他們曾在活人之地使勇士驚恐。',
    '結32:28 法老啊，你必在未受割禮的人中敗壞，與那些被殺的人一同躺臥。',
    '結32:29 以東也在那裡。他君王和一切首領雖然仗著勢力，還是放在被殺的人中；他們必與未受割禮的和下坑的人一同躺臥。',
    '結32:30 在那裡有北方的眾王子和一切西頓人，都與被殺的人下去。他們雖然仗著勢力使人驚恐，還是蒙羞。他們未受割禮，和被刀殺的一同躺臥，與下坑的人一同擔當羞辱。',
    '結32:31 法老看見他們，便為他被殺的軍隊受安慰。這是主耶和華說的。',
    '結32:32 我任憑法老在活人之地使人驚恐，法老和他的群眾必放在未受割禮和被殺的人中。這是主耶和華說的。',
    '結33:1 耶和華的話臨到我說：',
    '結33:2 人子啊，你要告訴本國的子民說：我使刀劍臨到哪一國，那一國的民從他們中間選立一人為守望的。',
    '結33:3 他見刀劍臨到那地，若吹角警戒眾民，',
    '結33:4 凡聽見角聲不受警戒的，刀劍若來除滅了他，他的罪（原文是血）就必歸到自己的頭上。',
    '結33:5 他聽見角聲，不受警戒，他的罪必歸到自己的身上；他若受警戒，便是救了自己的性命。',
    '結33:6 倘若守望的人見刀劍臨到，不吹角，以致民不受警戒，刀劍來殺了他們中間的一個人，他雖然死在罪孽之中，我卻要向守望的人討他喪命的罪（原文是血）。',
    '結33:7 人子啊，我照樣立你作以色列家守望的人。所以你要聽我口中的話，替我警戒他們。',
    '結33:8 我對惡人說：惡人哪，你必要死！你─以西結若不開口警戒惡人，使他離開所行的道，這惡人必死在罪孽之中，我卻要向你討他喪命的罪（原文是血）。',
    '結33:9 倘若你警戒惡人轉離所行的道，他仍不轉離，他必死在罪孽之中，你卻救自己脫離了罪。',
    '結33:10 人子啊，你要對以色列家說：你們常說：我們的過犯罪惡在我們身上，我們必因此消滅，怎能存活呢﹖',
    '結33:11 你對他們說，主耶和華說：我指著我的永生起誓，我斷不喜悅惡人死亡，惟喜悅惡人轉離所行的道而活。以色列家啊，你們轉回，轉回吧！離開惡道，何必死亡呢﹖',
    '結33:12 人子啊，你要對本國的人民說：義人的義，在犯罪之日不能救他；至於惡人的惡，在他轉離惡行之日也不能使他傾倒；義人在犯罪之日也不能因他的義存活。',
    '結33:13 我對義人說：你必定存活！他若倚靠他的義而作罪孽，他所行的義都不被記念。他必因所作的罪孽死亡。',
    '結33:14 再者，我對惡人說：你必定死亡！他若轉離他的罪，行正直與合理的事：',
    '結33:15 還人的當頭和所搶奪的，遵行生命的律例，不作罪孽，他必定存活，不致死亡。',
    '結33:16 他所犯的一切罪必不被記念。他行了正直與合理的事，必定存活。',
    '結33:17 你本國的子民還說：主的道不公平。其實他們的道不公平。',
    '結33:18 義人轉離他的義而作罪孽，就必因此死亡。',
    '結33:19 惡人轉離他的惡，行正直與合理的事，就必因此存活。',
    '結33:20 你們還說：主的道不公平。以色列家啊，我必按你們各人所行的審判你們。',
    '結33:21 我們被擄之後十二年十月初五日，有人從耶路撒冷逃到我這裡，說：城已攻破。',
    '結33:22 逃來的人未到前一日的晚上，耶和華的靈（原文是手）降在我身上，開我的口。到第二日早晨，那人來到我這裡，我口就開了，不再緘默。',
    '結33:23 耶和華的話臨到我說：',
    '結33:24 人子啊，住在以色列荒廢之地的人說：亞伯拉罕獨自一人能得這地為業，我們人數眾多，這地更是給我們為業的。',
    '結33:25 所以你要對他們說，主耶和華如此說：你們吃帶血的物，仰望偶像，並且殺人流血，你們還能得這地為業嗎﹖',
    '結33:26 你們倚仗自己的刀劍行可憎的事，人人玷污鄰舍的妻，你們還能得這地為業嗎﹖',
    '結33:27 你要對他們這樣說，主耶和華如此說：我指著我的永生起誓，在荒場中的，必倒在刀下；在田野間的，必交給野獸吞吃；在保障和洞裡的，必遭瘟疫而死。',
    '結33:28 我必使這地荒涼，令人驚駭；他因勢力而有的驕傲也必止息。以色列的山都必荒涼，無人經過。',
    '結33:29 我因他們所行一切可憎的事使地荒涼，令人驚駭。那時，他們就知道我是耶和華。',
    '結33:30 人子啊，你本國的子民在牆垣旁邊、在房屋門口談論你。弟兄對弟兄彼此說：來吧！聽聽有什麼話從耶和華而出。',
    '結33:31 他們來到你這裡如同民來聚會，坐在你面前彷彿是我的民。他們聽你的話卻不去行；因為他們的口多顯愛情，心卻追隨財利。',
    '結33:32 他們看你如善於奏樂、聲音幽雅之人所唱的雅歌，他們聽你的話卻不去行。',
    '結33:33 看哪，所說的快要應驗；應驗了，他們就知道在他們中間有了先知。',
    '結34:1 耶和華的話臨到我說：',
    '結34:2 人子啊，你要向以色列的牧人發預言，攻擊他們，說，主耶和華如此說：禍哉！以色列的牧人只知牧養自己。牧人豈不當牧養群羊嗎﹖',
    '結34:3 你們吃脂油、穿羊毛、宰肥壯的，卻不牧養群羊。',
    '結34:4 瘦弱的，你們沒有養壯；有病的，你們沒有醫治；受傷的，你們沒有纏裹；被逐的，你們沒有領回；失喪的，你們沒有尋找；但用強暴嚴嚴地轄制。',
    '結34:5 因無牧人，羊就分散；既分散，便作了一切野獸的食物。',
    '結34:6 我的羊在諸山間、在各高岡上流離，在全地上分散，無人去尋，無人去找。',
    '結34:7 所以，你們這些牧人要聽耶和華的話。',
    '結34:8 主耶和華說：我指著我的永生起誓，我的羊因無牧人就成為掠物，也作了一切野獸的食物。我的牧人不尋找我的羊；這些牧人只知牧養自己，並不牧養我的羊。',
    '結34:9 所以你們這些牧人要聽耶和華的話。',
    '結34:10 主耶和華如此說：我必與牧人為敵，必向他們的手追討我的羊，使他們不再牧放群羊；牧人也不再牧養自己。我必救我的羊脫離他們的口，不再作他們的食物。',
    '結34:11 主耶和華如此說：看哪，我必親自尋找我的羊，將他們尋見。',
    '結34:12 牧人在羊群四散的日子怎樣尋找他的羊，我必照樣尋找我的羊。這些羊在密雲黑暗的日子散到各處，我必從那裡救回他們來。',
    '結34:13 我必從萬民中領出他們，從各國內聚集他們，引導他們歸回故土，也必在以色列山上─一切溪水旁邊、境內一切可居之處─牧養他們。',
    '結34:14 我必在美好的草場牧養他們。他們的圈必在以色列高處的山上，他們必在佳美之圈中躺臥，也在以色列山肥美的草場吃草。',
    '結34:15 主耶和華說：我必親自作我羊的牧人，使他們得以躺臥。',
    '結34:16 失喪的，我必尋找；被逐的，我必領回；受傷的，我必纏裹；有病的，我必醫治；只是肥的壯的，我必除滅，也要秉公牧養他們。',
    '結34:17 我的羊群哪，論到你們，主耶和華如此說：我必在羊與羊中間、公綿羊與公山羊中間施行判斷。',
    '結34:18 你們這些肥壯的羊，在美好的草場吃草還以為小事嗎﹖剩下的草，你們竟用蹄踐踏了；你們喝清水，剩下的水，你們竟用蹄攪渾了。',
    '結34:19 至於我的羊，只得吃你們所踐踏的，喝你們所攪渾的。',
    '結34:20 所以，主耶和華如此說：我必在肥羊和瘦羊中間施行判斷。',
    '結34:21 因為你們用脅用肩擁擠一切瘦弱的，又用角牴觸，以致使他們四散。',
    '結34:22 所以，我必拯救我的群羊不再作掠物；我也必在羊和羊中間施行判斷。',
    '結34:23 我必立一牧人照管他們，牧養他們，就是我的僕人大衛。他必牧養他們，作他們的牧人。',
    '結34:24 我─耶和華必作他們的神，我的僕人大衛必在他們中間作王。這是耶和華說的。',
    '結34:25 我必與他們立平安的約，使惡獸從境內斷絕，他們就必安居在曠野，躺臥在林中。',
    '結34:26 我必使他們與我山的四圍成為福源，我也必叫時雨落下，必有福如甘霖而降。',
    '結34:27 田野的樹必結果，地也必有出產；他們必在故土安然居住。我折斷他們所負的軛，救他們脫離那以他們為奴之人的手；那時，他們就知道我是耶和華。',
    '結34:28 他們必不再作外邦人的掠物，地上的野獸也不再吞吃他們；卻要安然居住，無人驚嚇。',
    '結34:29 我必給他們興起有名的植物；他們在境內不再為饑荒所滅，也不再受外邦人的羞辱，',
    '結34:30 必知道我、耶和華─他們的神是與他們同在的，並知道他們─以色列家是我的民。這是主耶和華說的。',
    '結34:31 你們作我的羊，我草場上的羊，乃是以色列人，我也是你們的神。這是主耶和華說的。',
    '結35:1 耶和華的話又臨到我說：',
    '結35:2 人子啊，你要面向西珥山發預言，攻擊他，',
    '結35:3 對他說，主耶和華如此說：西珥山哪，我與你為敵，必向你伸手攻擊你，使你荒涼，令人驚駭。',
    '結35:4 我必使你的城邑變為荒場，成為淒涼。你就知道我是耶和華。',
    '結35:5 因為你永懷仇恨，在以色列人遭災、罪孽到了盡頭的時候，將他們交與刀劍，',
    '結35:6 所以主耶和華說：我指著我的永生起誓，我必使你遭遇流血的報應，罪（原文是血；本節同）必追趕你；你既不恨惡殺人流血，所以這罪必追趕你。',
    '結35:7 我必使西珥山荒涼，令人驚駭，來往經過的人我必剪除。',
    '結35:8 我必使西珥山滿有被殺的人。被刀殺的，必倒在你小山和山谷，並一切的溪水中。',
    '結35:9 我必使你永遠荒涼，使你的城邑無人居住，你的民就知道我是耶和華。',
    '結35:10 因為你曾說：這二國這二邦必歸於我，我必得為業（其實耶和華仍在那裡），',
    '結35:11 所以主耶和華說：我指著我的永生起誓，我必照你的怒氣和你從仇恨中向他們所發的嫉妒待你。我審判你的時候，必將自己顯明在他們中間。',
    '結35:12 你也必知道我─耶和華聽見了你的一切毀謗，就是你攻擊以色列山的話，說：這些山荒涼，是歸我們吞滅的。',
    '結35:13 你們也用口向我誇大，增添與我反對的話，我都聽見了。',
    '結35:14 主耶和華如此說：全地歡樂的時候，我必使你荒涼。',
    '結35:15 你怎樣因以色列家的地業荒涼而喜樂，我必照你所行的待你。西珥山哪，你和以東全地必都荒涼。你們就知道我是耶和華。',
    '結36:1 人子啊，你要對以色列山發預言說：以色列山哪，要聽耶和華的話。',
    '結36:2 主耶和華如此說：因仇敵說：阿哈！這永久的山岡都歸我們為業了！',
    '結36:3 所以要發預言說，主耶和華如此說：因為敵人使你荒涼，四圍吞吃，好叫你歸與其餘的外邦人為業，並且多嘴多舌的人提起你來，百姓也說你有臭名。',
    '結36:4 故此，以色列山要聽主耶和華的話。大山小岡、水溝山谷、荒廢之地、被棄之城，為四圍其餘的外邦人所佔據、所譏刺的，',
    '結36:5 主耶和華對你們如此說：我真發憤恨如火，責備那其餘的外邦人和以東的眾人。他們快樂滿懷，心存恨惡，將我的地歸自己為業，又看為被棄的掠物。',
    '結36:6 所以，你要指著以色列地說預言，對大山小岡、水溝山谷說，主耶和華如此說：我發憤恨和忿怒說，因你們曾受外邦人的羞辱，',
    '結36:7 所以我起誓說：你們四圍的外邦人總要擔當自己的羞辱。這是主耶和華說的。',
    '結36:8 以色列山哪，你必發枝條，為我的民以色列結果子，因為他們快要來到。',
    '結36:9 看哪，我是幫助你的，也必向你轉意，使你得以耕種。',
    '結36:10 我必使以色列全家的人數在你上面增多，城邑有人居住，荒場再被建造。',
    '結36:11 我必使人和牲畜在你上面加增；他們必生養眾多。我要使你照舊有人居住，並要賜福與你比先前更多，你就知道我是耶和華。',
    '結36:12 我必使人，就是我的民以色列，行在你上面。他們必得你為業；你也不再使他們喪子。',
    '結36:13 主耶和華如此說：因為人對你說：你是吞吃人的，又使國民喪子，',
    '結36:14 所以主耶和華說：你必不再吞吃人，也不再使國民喪子。',
    '結36:15 我使你不再聽見各國的羞辱，不再受萬民的辱罵，也不再使國民絆跌。這是主耶和華說的。',
    '結36:16 耶和華的話又臨到我說：',
    '結36:17 人子啊，以色列家住在本地的時候，在行動作為上玷污那地。他們的行為在我面前，好像正在經期的婦人那樣污穢。',
    '結36:18 所以我因他們在那地上流人的血，又因他們以偶像玷污那地，就把我的忿怒傾在他們身上。',
    '結36:19 我將他們分散在列國，四散在列邦，按他們的行動作為懲罰他們。',
    '結36:20 他們到了所去的列國，就使我的聖名被褻瀆；因為人談論他們說，這是耶和華的民，是從耶和華的地出來的。',
    '結36:21 我卻顧惜我的聖名，就是以色列家在所到的列國中所褻瀆的。',
    '結36:22 所以，你要對以色列家說，主耶和華如此說：以色列家啊，我行這事不是為你們，乃是為我的聖名，就是在你們到的列國中所褻瀆的。',
    '結36:23 我要使我的大名顯為聖；這名在列國中已被褻瀆，就是你們在他們中間所褻瀆的。我在他們眼前，在你們身上顯為聖的時候，他們就知道我是耶和華。這是主耶和華說的。',
    '結36:24 我必從各國收取你們，從列邦聚集你們，引導你們歸回本地。',
    '結36:25 我必用清水灑在你們身上，你們就潔淨了。我要潔淨你們，使你們脫離一切的污穢，棄掉一切的偶像。',
    '結36:26 我也要賜給你們一個新心，將新靈放在你們裡面，又從你們的肉體中除掉石心，賜給你們肉心。',
    '結36:27 我必將我的靈放在你們裡面，使你們順從我的律例，謹守遵行我的典章。',
    '結36:28 你們必住在我所賜給你們列祖之地。你們要作我的子民，我要作你們的神。',
    '結36:29 我必救你們脫離一切的污穢，也必命五穀豐登，不使你們遭遇饑荒。',
    '結36:30 我必使樹木多結果子，田地多出土產，好叫你們不再因饑荒受外邦人的譏誚。',
    '結36:31 那時，你們必追想你們的惡行和你們不善的作為，就因你們的罪孽和可憎的事厭惡自己。',
    '結36:32 主耶和華說：你們要知道，我這樣行不是為你們。以色列家啊，當為自己的行為抱愧蒙羞。',
    '結36:33 主耶和華如此說：我潔淨你們，使你們脫離一切罪孽的日子，必使城邑有人居住，荒場再被建造。',
    '結36:34 過路的人雖看為荒廢之地，現今這荒廢之地仍得耕種。',
    '結36:35 他們必說：這先前為荒廢之地，現在成如伊甸園；這荒廢淒涼、毀壞的城邑現在堅固有人居住。',
    '結36:36 那時，在你們四圍其餘的外邦人必知道我─耶和華修造那毀壞之處，培植那荒廢之地。我─耶和華說過，也必成就。',
    '結36:37 主耶和華如此說：我要加增以色列家的人數，多如羊群。他們必為這事向我求問，我要給他們成就。',
    '結36:38 耶路撒冷在守節作祭物所獻的羊群怎樣多，照樣，荒涼的城邑必被人群充滿。他們就知道我是耶和華。',
    '結37:1 耶和華的靈（原文是手）降在我身上。耶和華藉他的靈帶我出去，將我放在平原中；這平原遍滿骸骨。',
    '結37:2 他使我從骸骨的四圍經過，誰知在平原的骸骨甚多，而且極其枯乾。',
    '結37:3 他對我說：人子啊，這些骸骨能復活嗎﹖我說：主耶和華啊，你是知道的。',
    '結37:4 他又對我說：你向這些骸骨發預言說：枯乾的骸骨啊，要聽耶和華的話。',
    '結37:5 主耶和華對這些骸骨如此說：我必使氣息進入你們裡面，你們就要活了。',
    '結37:6 我必給你們加上筋，使你們長肉，又將皮遮蔽你們，使氣息進入你們裡面，你們就要活了；你們便知道我是耶和華。',
    '結37:7 於是，我遵命說預言。正說預言的時候，不料，有響聲，有地震；骨與骨互相聯絡。',
    '結37:8 我觀看，見骸骨上有筋，也長了肉，又有皮遮蔽其上，只是還沒有氣息。',
    '結37:9 主對我說：人子啊，你要發預言，向風發預言，說主耶和華如此說：氣息啊，要從四方（原文是風）而來，吹在這些被殺的人身上，使他們活了。',
    '結37:10 於是我遵命說預言，氣息就進入骸骨，骸骨便活了，並且站起來，成為極大的軍隊。',
    '結37:11 主對我說：人子啊，這些骸骨就是以色列全家。他們說：我們的骨頭枯乾了，我們的指望失去了，我們滅絕淨盡了。',
    '結37:12 所以你要發預言對他們說，主耶和華如此說：我的民哪，我必開你們的墳墓，使你們從墳墓中出來，領你們進入以色列地。',
    '結37:13 我的民哪，我開你們的墳墓，使你們從墳墓中出來，你們就知道我是耶和華。',
    '結37:14 我必將我的靈放在你們裡面，你們就要活了。我將你們安置在本地，你們就知道我─耶和華如此說，也如此成就了。這是耶和華說的。',
    '結37:15 耶和華的話又臨到我說：',
    '結37:16 人子啊，你要取一根木杖，在其上寫為猶大和他的同伴以色列人；又取一根木杖，在其上寫為約瑟，就是為以法蓮，又為他的同伴以色列全家。',
    '結37:17 你要使這兩根木杖接連為一，在你手中成為一根。',
    '結37:18 你本國的子民問你說：這是什麼意思﹖你不指示我們嗎﹖',
    '結37:19 你就對他們說：主耶和華如此說：我要將約瑟和他同伴以色列支派的杖，就是那在以法蓮手中的，與猶大的杖一同接連為一，在我手中成為一根。',
    '結37:20 你所寫的那兩根杖要在他們眼前拿在手中，',
    '結37:21 要對他們說，主耶和華如此說：我要將以色列人從他們所到的各國收取，又從四圍聚集他們，引導他們歸回本地。',
    '結37:22 我要使他們在那地，在以色列山上成為一國，有一王作他們眾民的王。他們不再為二國，決不再分為二國；',
    '結37:23 也不再因偶像和可憎的物，並一切的罪過玷污自己。我卻要救他們出離一切的住處，就是他們犯罪的地方；我要潔淨他們，如此，他們要作我的子民，我要作他們的神。',
    '結37:24 我的僕人大衛必作他們的王；眾民必歸一個牧人。他們必順從我的典章，謹守遵行我的律例。',
    '結37:25 他們必住在我賜給我僕人雅各的地上，就是你們列祖所住之地。他們和他們的子孫，並子孫的子孫，都永遠住在那裡。我的僕人大衛必作他們的王，直到永遠。',
    '結37:26 並且我要與他們立平安的約，作為永約。我也要將他們安置在本地，使他們的人數增多，又在他們中間設立我的聖所，直到永遠。',
    '結37:27 我的居所必在他們中間；我要作他們的神，他們要作我的子民。',
    '結37:28 我的聖所在以色列人中間直到永遠，外邦人就必知道我是叫以色列成為聖的耶和華。',
    '結38:1 耶和華的話臨到我說：',
    '結38:2 人子啊，你要面向瑪各地的歌革，就是羅施、米設、土巴的王發預言攻擊他，',
    '結38:3 說主耶和華如此說：羅施、米設、土巴的王歌革啊，我與你為敵。',
    '結38:4 我必用鉤子鉤住你的腮頰，調轉你，將你和你的軍兵、馬匹、馬兵帶出來，都披掛整齊，成了大隊，有大小盾牌，各拿刀劍。',
    '結38:5 波斯人、古實人，和弗人（又作呂彼亞人），各拿盾牌，頭上戴盔；',
    '結38:6 歌篾人和他的軍隊，北方極處的陀迦瑪族和他的軍隊，這許多國的民都同著你。',
    '結38:7 那聚集到你這裡的各隊都當準備；你自己也要準備，作他們的大帥。',
    '結38:8 過了多日，你必被差派。到末後之年，你必來到脫離刀劍從列國收回之地，到以色列常久荒涼的山上；但那從列國中招聚出來的必在其上安然居住。',
    '結38:9 你和你的軍隊，並同著你許多國的民，必如暴風上來，如密雲遮蓋地面。',
    '結38:10 主耶和華如此說：到那時，你心必起意念，圖謀惡計，',
    '結38:11 說：我要上那無城牆的鄉村，我要到那安靜的民那裡，他們都沒有城牆，無門、無閂，安然居住。',
    '結38:12 我去要搶財為擄物，奪貨為掠物，反手攻擊那從前荒涼、現在有人居住之地，又攻擊那住世界中間、從列國招聚、得了牲畜財貨的民。',
    '結38:13 示巴人、底但人、他施的客商，和其間的少壯獅子都必問你說：你來要搶財為擄物嗎﹖你聚集軍隊要奪貨為掠物嗎﹖要奪取金銀，擄去牲畜、財貨嗎﹖要搶奪許多財寶為擄物嗎﹖',
    '結38:14 人子啊，你要因此發預言，對歌革說，主耶和華如此說：到我民以色列安然居住之日，你豈不知道嗎﹖',
    '結38:15 你必從本地，從北方的極處率領許多國的民來，都騎著馬，乃一大隊極多的軍兵。',
    '結38:16 歌革啊，你必上來攻擊我的民以色列，如密雲遮蓋地面。末後的日子，我必帶你來攻擊我的地，到我在外邦人眼前，在你身上顯為聖的時候，好叫他們認識我。',
    '結38:17 主耶和華如此說：我在古時藉我的僕人以色列的先知所說的，就是你嗎﹖當日他們多年預言我必帶你來攻擊以色列人。',
    '結38:18 主耶和華說：歌革上來攻擊以色列地的時候，我的怒氣要從鼻孔裡發出。',
    '結38:19 我發憤恨和烈怒如火說：那日在以色列地必有大震動，',
    '結38:20 甚至海中的魚、天空的鳥、田野的獸，並地上的一切昆蟲，和其上的眾人，因見我的面就都震動；山嶺必崩裂，陡巖必塌陷，牆垣都必坍倒。',
    '結38:21 主耶和華說：我必命我的諸山發刀劍來攻擊歌革；人都要用刀劍殺害弟兄。',
    '結38:22 我必用瘟疫和流血的事刑罰他。我也必將暴雨、大雹與火，並硫磺降與他和他的軍隊，並他所率領的眾民。',
    '結38:23 我必顯為大，顯為聖，在多國人的眼前顯現；他們就知道我是耶和華。',
    '結39:1 人子啊，你要向歌革發預言攻擊他，說主耶和華如此說：羅施、米設、土巴的王歌革啊，我與你為敵。',
    '結39:2 我必調轉你，領你前往，使你從北方的極處上來，帶你到以色列的山上。',
    '結39:3 我必從你左手打落你的弓，從你右手打掉你的箭。',
    '結39:4 你和你的軍隊，並同著你的列國人，都必倒在以色列的山上。我必將你給各類的鷙鳥和田野的走獸作食物。',
    '結39:5 你必倒在田野，因為我曾說過。這是主耶和華說的。',
    '結39:6 我要降火在瑪各和海島安然居住的人身上，他們就知道我是耶和華。',
    '結39:7 我要在我民以色列中顯出我的聖名，也不容我的聖名再被褻瀆，列國人就知道我是耶和華─以色列中的聖者。',
    '結39:8 主耶和華說：這日事情臨近，也必成就，乃是我所說的日子。',
    '結39:9 住以色列城邑的人必出去撿器械，就是大小盾牌、弓箭、梃杖、槍矛，都當柴燒火，直燒七年，',
    '結39:10 甚至他們不必從田野撿柴，也不必從樹林伐木；因為他們要用器械燒火，並且搶奪那搶奪他們的人，擄掠那擄掠他們的人。這是主耶和華說的。',
    '結39:11 當那日，我必將以色列地的谷，就是海東人所經過的谷，賜給歌革為墳地，使經過的人到此停步。在那裡人必葬埋歌革和他的群眾，就稱那地為哈們歌革谷。',
    '結39:12 以色列家的人必用七個月葬埋他們，為要潔淨全地。',
    '結39:13 全地的居民都必葬埋他們。當我得榮耀的日子，這事必叫他們得名聲。這是主耶和華說的。',
    '結39:14 他們必分派人時常巡查遍地，與過路的人一同葬埋那剩在地面上的屍首，好潔淨全地。過了七個月，他們還要巡查。',
    '結39:15 巡查遍地的人要經過全地，見有人的骸骨，就在旁邊立一標記，等葬埋的人來將骸骨葬在哈們歌革谷。',
    '結39:16 他們必這樣潔淨那地，並有一城名叫哈摩那。',
    '結39:17 人子啊，主耶和華如此說：你要對各類的飛鳥和田野的走獸說：你們聚集來吧，要從四方聚到我為你們獻祭之地，就是在以色列山上獻大祭之地，好叫你們吃肉、喝血。',
    '結39:18 你們必吃勇士的肉，喝地上首領的血，就如吃公綿羊、羊羔、公山羊、公牛，都是巴珊的肥畜。',
    '結39:19 你們吃我為你們所獻的祭，必吃飽了脂油，喝醉了血。',
    '結39:20 你們必在我席上飽吃馬匹和坐車的人，並勇士和一切的戰士。這是主耶和華說的。',
    '結39:21 我必顯我的榮耀在列國中；萬民就必看見我所行的審判與我在他們身上所加的手。',
    '結39:22 這樣，從那日以後，以色列家必知道我是耶和華─他們的神。',
    '結39:23 列國人也必知道以色列家被擄掠是因他們的罪孽。他們得罪我，我就掩面不顧，將他們交在敵人手中，他們便都倒在刀下。',
    '結39:24 我是照他們的污穢和罪過待他們，並且我掩面不顧他們。',
    '結39:25 主耶和華如此說：我要使雅各被擄的人歸回，要憐憫以色列全家，又為我的聖名發熱心。',
    '結39:26 他們在本地安然居住，無人驚嚇，是我將他們從萬民中領回，從仇敵之地召來。我在許多國的民眼前，在他們身上顯為聖的時候，他們要擔當自己的羞辱和干犯我的一切罪。',
    '結39:27 併於上節。',
    '結39:28 因我使他們被擄到外邦人中，後又聚集他們歸回本地，他們就知道我是耶和華─他們的神；我必不再留他們一人在外邦。',
    '結39:29 我也不再掩面不顧他們，因我已將我的靈澆灌以色列家。這是主耶和華說的。',
    '結40:1 我們被擄掠第二十五年，耶路撒冷城攻破後十四年，正在年初，月之初十日，耶和華的靈（原文是手）降在我身上，他把我帶到以色列地。',
    '結40:2 在神的異象中帶我到以色列地，安置在至高的山上；在山上的南邊有彷彿一座城建立。',
    '結40:3 他帶我到那裡，見有一人，顏色（原文是形狀）如銅，手拿麻繩和量度的竿，站在門口。',
    '結40:4 那人對我說：人子啊，凡我所指示你的，你都要用眼看，用耳聽，並要放在心上。我帶你到這裡來，特為要指示你；凡你所見的，你都要告訴以色列家。',
    '結40:5 我見殿四圍有牆。那人手拿量度的竿，長六肘，每肘是一肘零一掌。他用竿量牆，厚一竿，高一竿。',
    '結40:6 他到了朝東的門，就上門的臺階，量門的這檻，寬一竿；又量門的那檻，寬一竿。',
    '結40:7 又有衛房，每房長一竿，寬一竿，相隔五肘。門檻，就是挨著向殿的廊門檻，寬一竿。',
    '結40:8 他又量向殿門的廊子，寬一竿。',
    '結40:9 又量門廊，寬八肘，牆柱厚二肘；那門的廊子向著殿。',
    '結40:10 東門洞有衛房：這旁三間，那旁三間，都是一樣的尺寸；這邊的柱子和那邊的柱子，也是一樣的尺寸。',
    '結40:11 他量門口，寬十肘，長十三肘。',
    '結40:12 衛房前展出的境界：這邊一肘，那邊一肘；衛房這邊六肘，那邊六肘。',
    '結40:13 又量門洞，從這衛房頂的後檐到那衛房頂的後檐，寬二十五肘；衛房門與門相對。',
    '結40:14 又量（原文是造）廊子六十肘（七十士譯本是二十肘），牆柱外是院子，有廊為界，在門洞兩邊。',
    '結40:15 從大門口到內廊前，共五十肘。',
    '結40:16 衛房和門洞兩旁柱間並廊子，都有嚴緊的窗櫺；裡邊都有窗櫺，柱上有雕刻的棕樹。',
    '結40:17 他帶我到外院，見院的四圍有鋪石地；鋪石地上有屋子三十間。',
    '結40:18 鋪石地，就是矮鋪石地在各門洞兩旁，以門洞的長短為度。',
    '結40:19 他從下門量到內院外，共寬一百肘，東面北面都是如此。',
    '結40:20 他量外院朝北的門，長寬若干。',
    '結40:21 門洞的衛房，這旁三間，那旁三間。門洞的柱子和廊子，與第一門的尺寸一樣。門洞長五十肘，寬二十五肘。',
    '結40:22 其窗櫺和廊子，並雕刻的棕樹，與朝東的門尺寸一樣。登七層臺階上到這門，前面有廊子。',
    '結40:23 內院有門與這門相對，北面東面都是如此。他從這門量到那門，共一百肘。',
    '結40:24 他帶我往南去，見朝南有門，又照先前的尺寸量門洞的柱子和廊子。',
    '結40:25 門洞兩旁與廊子的周圍都有窗櫺，和先量的窗櫺一樣。門洞長五十肘，寬二十五肘。',
    '結40:26 登七層臺階上到這門，前面有廊子；柱上有雕刻的棕樹，這邊一棵，那邊一棵。',
    '結40:27 內院朝南有門。從這門量到朝南的那門，共一百肘。',
    '結40:28 他帶我從南門到內院，就照先前的尺寸量南門。',
    '結40:29 衛房和柱子，並廊子都照先前的尺寸。門洞兩旁與廊子的周圍都有窗櫺。門洞長五十肘，寬二十五肘。',
    '結40:30 周圍有廊子，長二十五肘，寬五肘。',
    '結40:31 廊子朝著外院，柱上有雕刻的棕樹。登八層臺階上到這門。',
    '結40:32 他帶我到內院的東面，就照先前的尺寸量東門。',
    '結40:33 衛房和柱子，並廊子都照先前的尺寸。門洞兩旁與廊子的周圍都有窗櫺。門洞長五十肘，寬二十五肘。',
    '結40:34 廊子朝著外院。門洞兩旁的柱子都有雕刻的棕樹。登八層臺階上到這門。',
    '結40:35 他帶我到北門，就照先前的尺寸量那門，',
    '結40:36 就是量衛房和柱子，並廊子。門洞周圍都有窗櫺；門洞長五十肘，寬二十五肘。',
    '結40:37 廊柱朝著外院。門洞兩旁的柱子都有雕刻的棕樹。登八層臺階上到這門。',
    '結40:38 門洞的柱旁有屋子和門；祭司（原文是他們）在那裡洗燔祭牲。',
    '結40:39 在門廊內，這邊有兩張桌子，那邊有兩張桌子，在其上可以宰殺燔祭牲、贖罪祭牲，和贖愆祭牲。',
    '結40:40 上到朝北的門口，這邊有兩張桌子，門廊那邊也有兩張桌子。',
    '結40:41 門這邊有四張桌子，那邊有四張桌子，共八張；在其上祭司宰殺犧牲。',
    '結40:42 為燔祭牲有四張桌子，是鑿過的石頭做成的，長一肘半，寬一肘半，高一肘。祭司將宰殺燔祭牲和平安祭牲所用的器皿放在其上。',
    '結40:43 有鉤子，寬一掌，釘在廊內的四圍。桌子上有犧牲的肉。',
    '結40:44 在北門旁，內院裡有屋子，為歌唱的人而設。這屋子朝南（南：原文是東）；在南門旁，又有一間朝北。',
    '結40:45 他對我說：這朝南的屋子是為看守殿宇的祭司；',
    '結40:46 那朝北的屋子是為看守祭壇的祭司。這些祭司是利未人中撒督的子孫，近前來事奉耶和華的。',
    '結40:47 他又量內院，長一百肘，寬一百肘，是見方的。祭壇在殿前。',
    '結40:48 於是他帶我到殿前的廊子，量廊子的牆柱。這面厚五肘，那面厚五肘。門兩旁，這邊三肘，那邊三肘。',
    '結40:49 廊子長二十肘，寬十一肘。上廊子有臺階。靠近牆柱又有柱子，這邊一根，那邊一根。',
    '結41:1 他帶我到殿那裡量牆柱：這面厚六肘，那面厚六肘，寬窄與會幕相同。',
    '結41:2 門口寬十肘。門兩旁，這邊五肘，那邊五肘。他量殿長四十肘，寬二十肘。',
    '結41:3 他到內殿量牆柱，各厚二肘。門口寬六肘，門兩旁各寬七肘。',
    '結41:4 他量內殿，長二十肘，寬二十肘。他對我說：這是至聖所。',
    '結41:5 他又量殿牆，厚六肘；圍著殿有旁屋，各寬四肘。',
    '結41:6 旁屋有三層，層疊而上，每層排列三十間。旁屋的梁木擱在殿牆坎上，免得插入殿牆。',
    '結41:7 這圍殿的旁屋越高越寬；因旁屋圍殿懸疊而上，所以越上越寬，從下一層，由中一層，到上一層。',
    '結41:8 我又見圍著殿有高月臺。旁屋的根基，高足一竿，就是六大肘。',
    '結41:9 旁屋的外牆厚五肘。旁屋之外還有餘地。',
    '結41:10 在旁屋與對面的房屋中間有空地，寬二十肘。',
    '結41:11 旁屋的門都向餘地：一門向北，一門向南。周圍的餘地寬五肘。',
    '結41:12 在西面空地之後有房子，寬七十肘，長九十肘，牆四圍厚五肘。',
    '結41:13 這樣，他量殿，長一百肘，又量空地和那房子並牆，共長一百肘。',
    '結41:14 殿的前面和兩旁的空地，寬一百肘。',
    '結41:15 他量空地後面的那房子，並兩旁的樓廊，共長一百肘。',
    '結41:16 內殿、院廊、門檻、嚴緊的窗櫺，並對著門檻的三層樓廊，從地到窗櫺（窗櫺都有蔽子），',
    '結41:17 直到門以上，就是到內殿和外殿內外四圍牆壁，都按尺寸用木板遮蔽。',
    '結41:18 牆上雕刻基路伯和棕樹。每二基路伯中間有一棵棕樹，每基路伯有二臉。',
    '結41:19 這邊有人臉向著棕樹，那邊有獅子臉向著棕樹，殿內周圍都是如此。',
    '結41:20 從地至門以上，都有基路伯和棕樹。殿牆就是這樣。',
    '結41:21 殿的門柱是方的。至聖所的前面，形狀和殿的形狀一樣。',
    '結41:22 壇是木頭做的，高三肘，長二肘。壇角和壇面，並四旁，都是木頭做的。他對我說：這是耶和華面前的桌子。',
    '結41:23 殿和至聖所的門各有兩扇。',
    '結41:24 每扇分兩扇，這兩扇是摺疊的。這邊門分兩扇，那邊門也分兩扇。',
    '結41:25 殿的門扇上雕刻基路伯和棕樹，與刻在牆上的一般。在外頭廊前有木檻。',
    '結41:26 廊這邊那邊都有嚴緊的窗櫺和棕樹；殿的旁屋和檻就是這樣。',
    '結42:1 他帶我出來向北，到外院，又帶我進入聖屋；這聖屋一排順著空地，一排與北邊鋪石地之屋相對。',
    '結42:2 這聖屋長一百肘，寬五十肘，有向北的門。',
    '結42:3 對著內院那二十肘寬之空地，又對著外院的鋪石地，在第三層樓上有樓廊對著樓廊。',
    '結42:4 在聖屋前有一條夾道，寬十肘，長一百肘。房門都向北。',
    '結42:5 聖屋因為樓廊佔去些地方，所以上層比中下兩層窄些。',
    '結42:6 聖屋有三層，卻無柱子，不像外院的屋子有柱子；所以上層比中下兩層更窄。',
    '結42:7 聖屋外，東邊有牆，靠著外院，長五十肘。',
    '結42:8 靠著外院的聖屋長五十肘。殿北面的聖屋長一百肘。',
    '結42:9 在聖屋以下，東頭有進入之處，就是從外院進入之處。',
    '結42:10 向南（原文是東）在內院牆裡有聖屋，一排與鋪石地之屋相對，一排順著空地。',
    '結42:11 這聖屋前的夾道與北邊聖屋的夾道長寬一樣；出入之處與北屋門的樣式相同。',
    '結42:12 正在牆前、夾道的東頭，有門可以進入，與向南聖屋的門一樣。',
    '結42:13 他對我說：順著空地的南屋北屋，都是聖屋；親近耶和華的祭司當在那裡吃至聖的物，也當在那裡放至聖的物，就是素祭、贖罪祭，和贖愆祭，因此處為聖。',
    '結42:14 祭司進去出了聖所的時候，不可直到外院，但要在聖屋放下他們供職的衣服，因為是聖衣；要穿上別的衣服才可以到屬民的外院。',
    '結42:15 他量完了內殿，就帶我出朝東的門，量院的四圍。',
    '結42:16 他用量度的竿量四圍，量東面五百肘（原文是竿；本章下同），',
    '結42:17 用竿量北面五百肘，',
    '結42:18 用竿量南面五百肘，',
    '結42:19 又轉到西面，用竿量五百肘。',
    '結42:20 他量四面，四圍有牆，長五百肘，寬五百肘，為要分別聖地與俗地。',
    '結43:1 以後，他帶我到一座門，就是朝東的門。',
    '結43:2 以色列神的榮光從東而來。他的聲音如同多水的聲音；地就因他的榮耀發光。',
    '結43:3 其狀如從前他來滅城的時候我所見的異象，那異象如我在迦巴魯河邊所見的異象，我就俯伏在地。',
    '結43:4 耶和華的榮光從朝東的門照入殿中。',
    '結43:5 靈將我舉起，帶入內院，不料，耶和華的榮光充滿了殿。',
    '結43:6 我聽見有一位從殿中對我說話。有一人站在我旁邊。',
    '結43:7 他對我說：人子啊，這是我寶座之地，是我腳掌所踏之地。我要在這裡住，在以色列人中直到永遠。以色列家和他們的君王必不再玷污我的聖名，就是行邪淫、在錫安的高處葬埋他們君王的屍首，',
    '結43:8 使他們的門檻挨近我的門檻，他們的門框挨近我的門框；他們與我中間僅隔一牆，並且行可憎的事，玷污了我的聖名，所以我發怒滅絕他們。',
    '結43:9 現在他們當從我面前遠除邪淫和他們君王的屍首，我就住在他們中間直到永遠。',
    '結43:10 人子啊，你要將這殿指示以色列家，使他們因自己的罪孽慚愧，也要他們量殿的尺寸。',
    '結43:11 他們若因自己所行的一切事慚愧，你就將殿的規模、樣式、出入之處，和一切形狀、典章、禮儀、法則指示他們，在他們眼前寫上，使他們遵照殿的一切規模典章去做。',
    '結43:12 殿的法則乃是如此：殿在山頂上，四圍的全界要稱為至聖。這就是殿的法則。',
    '結43:13 以下量祭壇，是以肘為度（這肘是一肘零一掌）。底座高一肘，邊寬一肘，四圍起邊高一掌，這是壇的座。',
    '結43:14 從底座到下層磴臺，高二肘，邊寬一肘。從小磴臺到大磴臺，高四肘，邊寬一肘。',
    '結43:15 壇上的供臺，高四肘。供臺的四拐角上都有角。',
    '結43:16 供臺長十二肘，寬十二肘，四面見方。',
    '結43:17 磴臺長十四肘，寬十四肘，四面見方。四圍起邊高半肘，底座四圍的邊寬一肘。臺階朝東。',
    '結43:18 他對我說：人子啊，主耶和華如此說：建造祭壇，為要在其上獻燔祭灑血，造成的時候典章如下：',
    '結43:19 主耶和華說，你要將一隻公牛犢作為贖罪祭，給祭司利未人撒督的後裔，就是那親近我、事奉我的。',
    '結43:20 你要取些公牛的血，抹在壇的四角和磴臺的四拐角，並四圍所起的邊上。你這樣潔淨壇，壇就潔淨了。',
    '結43:21 你又要將那作贖罪祭的公牛犢燒在殿外、聖地之外預定之處。',
    '結43:22 次日，要將無殘疾的公山羊獻為贖罪祭；要潔淨壇，像用公牛犢潔淨的一樣。',
    '結43:23 潔淨了壇，就要將一隻無殘疾的公牛犢和羊群中一隻無殘疾的公綿羊',
    '結43:24 奉到耶和華前。祭司要撒鹽在其上，獻與耶和華為燔祭。',
    '結43:25 七日內，每日要預備一隻公山羊為贖罪祭，也要預備一隻公牛犢和羊群中的一隻公綿羊，都要沒有殘疾的。',
    '結43:26 七日祭司潔淨壇，壇就潔淨了；要這樣把壇分別為聖。',
    '結43:27 滿了七日，自八日以後，祭司要在壇上獻你們的燔祭和平安祭；我必悅納你們。這是主耶和華說的。',
    '結44:1 他又帶我回到聖地朝東的外門；那門關閉了。',
    '結44:2 耶和華對我說：這門必須關閉，不可敞開，誰也不可由其中進入；因為耶和華─以色列的神已經由其中進入，所以必須關閉。',
    '結44:3 至於王，他必按王的位分，坐在其內，在耶和華面前吃餅。他必由這門的廊而入，也必由此而出。',
    '結44:4 他又帶我由北門來到殿前。我觀看，見耶和華的榮光充滿耶和華的殿，我就俯伏在地。',
    '結44:5 耶和華對我說：人子啊，我對你所說耶和華殿中的一切典章法則，你要放在心上，用眼看，用耳聽，並要留心殿宇和聖地一切出入之處。',
    '結44:6 你要對那悖逆的以色列家說，主耶和華如此說：以色列家啊，你們行一切可憎的事，當夠了吧！',
    '結44:7 你們把我的食物，就是脂油和血獻上的時候，將身心未受割禮的外邦人領進我的聖地，玷污了我的殿；又背了我的約，在你們一切可憎的事上，加上這一層。',
    '結44:8 你們也沒有看守我的聖物，卻派別人在聖地替你們看守我所吩咐你們的。',
    '結44:9 主耶和華如此說：以色列中的外邦人，就是身心未受割禮的，都不可入我的聖地。',
    '結44:10 當以色列人走迷的時候，有利未人遠離我，就是走迷離開我、隨從他們的偶像，他們必擔當自己的罪孽。',
    '結44:11 然而他們必在我的聖地當僕役，照管殿門，在殿中供職；必為民宰殺燔祭牲和平安祭牲，必站在民前伺候他們。',
    '結44:12 因為這些利未人曾在偶像前伺候這民，成了以色列家罪孽的絆腳石，所以我向他們起誓：他們必擔當自己的罪孽。這是主耶和華說的。',
    '結44:13 他們不可親近我，給我供祭司的職分，也不可挨近我的一件聖物，就是至聖的物；他們卻要擔當自己的羞辱和所行可憎之事的報應。',
    '結44:14 然而我要使他們看守殿宇，辦理其中的一切事，並做其內一切當做之工。',
    '結44:15 以色列人走迷離開我的時候，祭司利未人撒督的子孫仍看守我的聖所。他們必親近我，事奉我，並且侍立在我面前，將脂油與血獻給我。這是主耶和華說的。',
    '結44:16 他們必進入我的聖所，就近我的桌前事奉我，守我所吩咐的。',
    '結44:17 他們進內院門必穿細麻衣。在內院門和殿內供職的時候不可穿羊毛衣服。',
    '結44:18 他們頭上要戴細麻布裹頭巾，腰穿細麻布褲子；不可穿使身體出汗的衣服。',
    '結44:19 他們出到外院的民那裡，當脫下供職的衣服，放在聖屋內，穿上別的衣服，免得因聖衣使民成聖。',
    '結44:20 不可剃頭，也不可容髮綹長長，只可剪髮。',
    '結44:21 祭司進內院的時候都不可喝酒。',
    '結44:22 不可娶寡婦和被休的婦人為妻，只可娶以色列後裔中的處女，或是祭司遺留的寡婦。',
    '結44:23 他們要使我的民知道聖俗的分別，又使他們分辨潔淨的和不潔淨的。',
    '結44:24 有爭訟的事，他們應當站立判斷，要按我的典章判斷。在我一切的節期必守我的律法、條例，也必以我的安息日為聖日。',
    '結44:25 他們不可挨近死屍沾染自己，只可為父親、母親、兒子、女兒、弟兄，和未嫁人的姊妹沾染自己。',
    '結44:26 祭司潔淨之後，必再計算七日。',
    '結44:27 當他進內院，進聖所，在聖所中事奉的日子，要為自己獻贖罪祭。這是主耶和華說的。',
    '結44:28 祭司必有產業，我是他們的產業。不可在以色列中給他們基業；我是他們的基業。',
    '結44:29 素祭、贖罪祭，和贖愆祭他們都可以吃，以色列中一切永獻的物都要歸他們。',
    '結44:30 首先初熟之物和一切所獻的供物都要歸給祭司。你們也要用初熟的麥子磨麵給祭司；這樣，福氣就必臨到你們的家了。',
    '結44:31 無論是鳥是獸，凡自死的，或是撕裂的，祭司都不可吃。',
    '結45:1 你們拈鬮分地為業，要獻上一分給耶和華為聖供地，長二萬五千肘，寬一萬肘。這分以內，四圍都為聖地。',
    '結45:2 其中有作為聖所之地，長五百肘，寬五百肘，四面見方。四圍再有五十肘為郊野之地。',
    '結45:3 要以肘為度量地，長二萬五千肘，寬一萬肘。其中有聖所，是至聖的。',
    '結45:4 這是全地的一分聖地，要歸與供聖所職事的祭司，就是親近事奉耶和華的，作為他們房屋之地與聖所之聖地。',
    '結45:5 又有一分，長二萬五千肘，寬一萬肘，要歸與在殿中供職的利未人，作為二十間房屋之業。',
    '結45:6 也要分定屬城的地業，寬五千肘，長二萬五千肘，挨著那分聖供地，要歸以色列全家。',
    '結45:7 歸王之地要在聖供地和屬城之地的兩旁，就是聖供地和屬城之地的旁邊，西至西頭，東至東頭，從西到東，其長與每支派的分一樣。',
    '結45:8 這地在以色列中必歸王為業。我所立的王必不再欺壓我的民，卻要按支派將地分給以色列家。',
    '結45:9 主耶和華如此說：以色列的王啊，你們應當知足，要除掉強暴和搶奪的事，施行公平和公義，不再勒索我的民。這是主耶和華說的。',
    '結45:10 你們要用公道天平、公道伊法、公道罷特。',
    '結45:11 伊法與罷特大小要一樣。罷特可盛賀梅珥十分之一，伊法也可盛賀梅珥十分之一，都以賀梅珥的大小為準。',
    '結45:12 舍客勒是二十季拉；二十舍客勒，二十五舍客勒，十五舍客勒，為你們的彌那。',
    '結45:13 你們當獻的供物乃是這樣：一賀梅珥麥子要獻伊法六分之一；一賀梅珥大麥要獻伊法六分之一。',
    '結45:14 你們獻所分定的油，按油的罷特，一柯珥油要獻罷特十分之一（原來十罷特就是一賀梅珥）。',
    '結45:15 從以色列滋潤的草場上每二百羊中，要獻一隻羊羔。這都可作素祭、燔祭、平安祭，為民贖罪。這是主耶和華說的。',
    '結45:16 此地的民都要奉上這供物給以色列中的王。',
    '結45:17 王的本分是在節期、月朔、安息日，就是以色列家一切的節期，奉上燔祭、素祭、奠祭。他要預備贖罪祭、素祭、燔祭，和平安祭，為以色列家贖罪。',
    '結45:18 主耶和華如此說：正月初一日，你要取無殘疾的公牛犢，潔淨聖所。',
    '結45:19 祭司要取些贖罪祭牲的血，抹在殿的門柱上和壇磴臺的四角上，並內院的門框上。',
    '結45:20 本月初七日（七十士譯本是七月初一日）也要為誤犯罪的和愚蒙犯罪的如此行，為殿贖罪。',
    '結45:21 正月十四日，你們要守逾越節，守節七日，要吃無酵餅。',
    '結45:22 當日，王要為自己和國內的眾民預備一隻公牛作贖罪祭。',
    '結45:23 這節的七日，每日他要為耶和華預備無殘疾的公牛七隻、公綿羊七隻為燔祭。每日又要預備公山羊一隻為贖罪祭。',
    '結45:24 他也要預備素祭，就是為一隻公牛同獻一伊法細麵，為一隻公綿羊同獻一伊法細麵，每一伊法細麵加油一欣。',
    '結45:25 七月十五日守節的時候，七日他都要如此行，照逾越節的贖罪祭、燔祭、素祭，和油的條例一樣。',
    '結46:1 主耶和華如此說：內院朝東的門，在辦理事務的六日內必須關閉；惟有安息日和月朔必須敞開。',
    '結46:2 王要從這門的廊進入，站在門框旁邊。祭司要為他預備燔祭和平安祭，他就要在門檻那裡敬拜，然後出去。這門直到晚上不可關閉。',
    '結46:3 在安息日和月朔，國內的居民要在這門口，耶和華面前敬拜。',
    '結46:4 安息日，王所獻與耶和華的燔祭要用無殘疾的羊羔六隻，無殘疾的公綿羊一隻；',
    '結46:5 同獻的素祭要為公綿羊獻一伊法細麵，為羊羔照他的力量而獻，一伊法細麵加油一欣。',
    '結46:6 當月朔，要獻無殘疾的公牛犢一隻，羊羔六隻，公綿羊一隻，都要無殘疾的。',
    '結46:7 他也要預備素祭，為公牛獻一伊法細麵，為公綿羊獻一伊法細麵，為羊羔照他的力量而獻，一伊法細麵加油一欣。',
    '結46:8 王進入的時候必由這門的廊而入，也必由此而出。',
    '結46:9 在各節期，國內居民朝見耶和華的時候，從北門進入敬拜的，必由南門而出；從南門進入的，必由北門而出。不可從所入的門而出，必要直往前行，由對門而出。',
    '結46:10 民進入，王也要在民中進入；民出去，王也要一同出去。',
    '結46:11 在節期和聖會的日子同獻的素祭，要為一隻公牛獻一伊法細麵，為一隻公綿羊獻一伊法細麵，為羊羔照他的力量而獻，一伊法細麵加油一欣。',
    '結46:12 王預備甘心獻的燔祭或平安祭，就是向耶和華甘心獻的，當有人為他開朝東的門。他就預備燔祭和平安祭，與安息日預備的一樣，獻畢就出去。他出去之後，當有人將門關閉。',
    '結46:13 每日，你要預備無殘疾一歲的羊羔一隻，獻與耶和華為燔祭；要每早晨預備。',
    '結46:14 每早晨也要預備同獻的素祭，細麵一伊法六分之一，並油一欣三分之一，調和細麵。這素祭要常獻與耶和華為永遠的定例。',
    '結46:15 每早晨要這樣預備羊羔、素祭，並油為常獻的燔祭。',
    '結46:16 主耶和華如此說：王若將產業賜給他的兒子，就成了他兒子的產業，那是他們承受為業的。',
    '結46:17 倘若王將一分產業賜給他的臣僕，就成了他臣僕的產業；到自由之年仍要歸與王。至於王的產業，必歸與他的兒子。',
    '結46:18 王不可奪取民的產業，以致驅逐他們離開所承受的；他要從自己的地業中，將產業賜給他兒子，免得我的民分散，各人離開所承受的。',
    '結46:19 那帶我的，將我從門旁進入之處、領進為祭司預備的聖屋，是朝北的，見後頭西邊有一塊地。',
    '結46:20 他對我說：這是祭司煮贖愆祭、贖罪祭，烤素祭之地，免得帶到外院，使民成聖。',
    '結46:21 他又帶我到外院，使我經過院子的四拐角，見每拐角各有一個院子。',
    '結46:22 院子四拐角的院子，周圍有牆，每院長四十肘，寬三十肘。四拐角院子的尺寸都是一樣，',
    '結46:23 其中周圍有一排房子，房子內有煮肉的地方。',
    '結46:24 他對我說：這都是煮肉的房子，殿內的僕役要在這裡煮民的祭物。',
    '結47:1 他帶我回到殿門，見殿的門檻下有水往東流出（原來殿面朝東）。這水從檻下，由殿的右邊，在祭壇的南邊往下流。',
    '結47:2 他帶我出北門，又領我從外邊轉到朝東的外門，見水從右邊流出。',
    '結47:3 他手拿準繩往東出去的時候，量了一千肘，使我逿過水，水到踝子骨。',
    '結47:4 他又量了一千肘，使我逿過水，水就到膝；再量了一千肘，使我逿過水，水便到腰；',
    '結47:5 又量了一千肘，水便成了河，使我不能逿過。因為水勢漲起，成為可洑的水，不可逿的河。',
    '結47:6 他對我說：人子啊，你看見了什麼﹖他就帶我回到河邊。',
    '結47:7 我回到河邊的時候，見在河這邊與那邊的岸上有極多的樹木。',
    '結47:8 他對我說：這水往東方流去，必下到亞拉巴，直到海。所發出來的水必流入鹽海，使水變甜（原文是得醫治；下同）。',
    '結47:9 這河水所到之處，凡滋生的動物都必生活，並且因這流來的水必有極多的魚，海水也變甜了。這河水所到之處，百物都必生活。',
    '結47:10 必有漁夫站在河邊，從隱基底直到隱以革蓮，都作曬（或譯：張）網之處。那魚各從其類，好像大海的魚甚多。',
    '結47:11 只是泥濘之地與窪濕之處不得治好，必為鹽地。',
    '結47:12 在河這邊與那邊的岸上必生長各類的樹木；其果可作食物，葉子不枯乾，果子不斷絕。每月必結新果子，因為這水是從聖所流出來的。樹上的果子必作食物，葉子乃為治病。',
    '結47:13 主耶和華如此說：你們要照地的境界，按以色列十二支派分地為業。約瑟必得兩分。',
    '結47:14 你們承受這地為業，要彼此均分；因為我曾起誓應許將這地賜與你們的列祖；這地必歸你們為業。',
    '結47:15 地的四界乃是如此：北界從大海往希特倫，直到西達達口。',
    '結47:16 又往哈馬、比羅他、西伯蓮（西伯蓮在大馬色與哈馬兩界中間），到浩蘭邊界的哈撒哈提干。',
    '結47:17 這樣，境界從海邊往大馬色地界上的哈薩以難，北邊以哈馬地為界。這是北界。',
    '結47:18 東界在浩蘭、大馬色、基列，和以色列地的中間，就是約但河。你們要從北界量到東海。這是東界。',
    '結47:19 南界是從他瑪到米利巴加低斯的水，延到埃及小河，直到大海。這是南界。',
    '結47:20 西界就是大海，從南界直到哈馬口對面之地。這是西界。',
    '結47:21 你們要按著以色列的支派彼此分這地。',
    '結47:22 要拈鬮分這地為業，歸與自己和你們中間寄居的外人，就是在你們中間生養兒女的外人。你們要看他們如同以色列人中所生的一樣；他們在以色列支派中要與你們同得地業',
    '結47:23 外人寄居在哪支派中，你們就在那裡分給他地業。這是主耶和華說的。',
    '結48:1 眾支派按名所得之地記在下面：從北頭，由希特倫往哈馬口，到大馬色地界上的哈薩以難。北邊靠著哈馬地（各支派的地都有東西的邊界），是但的一分。',
    '結48:2 挨著但的地界，從東到西，是亞設的一分。',
    '結48:3 挨著亞設的地界，從東到西，是拿弗他利的一分。',
    '結48:4 挨著拿弗他利的地界，從東到西，是瑪拿西的一分。',
    '結48:5 挨著瑪拿西的地界，從東到西，是以法蓮的一分。',
    '結48:6 挨著以法蓮的地界，從東到西，是流便的一分。',
    '結48:7 挨著流便的地界，從東到西，是猶大的一分。',
    '結48:8 挨著猶大的地界，從東到西，必有你們所當獻的供地，寬二萬五千肘。從東界到西界，長短與各分之地相同，聖地當在其中。',
    '結48:9 你們獻與耶和華的供地要長二萬五千肘，寬一萬肘。',
    '結48:10 這聖供地要歸與祭司，北長二萬五千肘，西寬一萬肘，東寬一萬肘，南長二萬五千肘。耶和華的聖地當在其中。',
    '結48:11 這地要歸與撒督的子孫中成為聖的祭司，就是那守我所吩咐的。當以色列人走迷的時候，他們不像那些利未人走迷了。',
    '結48:12 這要歸與他們為供地，是全地中至聖的。供地挨著利未人的地界。',
    '結48:13 利未人所得的地要長二萬五千肘，寬一萬肘，與祭司的地界相等，都長二萬五千肘，寬一萬肘。',
    '結48:14 這地不可賣，不可換，初熟之物也不可歸與別人，因為是歸耶和華為聖的。',
    '結48:15 這二萬五千肘前面所剩下五千肘寬之地要作俗用，作為造城蓋房郊野之地。城要在當中。',
    '結48:16 城的尺寸乃是如此：北面四千五百肘，南面四千五百肘，東面四千五百肘，西面四千五百肘。',
    '結48:17 城必有郊野，向北二百五十肘，向南二百五十肘，向東二百五十肘，向西二百五十肘。',
    '結48:18 靠著聖供地的餘地，東長一萬肘，西長一萬肘，要與聖供地相等；其中的土產要作城內工人的食物。',
    '結48:19 所有以色列支派中，在城內做工的，都要耕種這地。',
    '結48:20 你們所獻的聖供地連歸城之地，是四方的：長二萬五千肘，寬二萬五千肘。',
    '結48:21 聖供地連歸城之地，兩邊的餘地要歸與王。供地東邊，南北二萬五千肘，東至東界，西邊南北二萬五千肘，西至西界，與各分之地相同，都要歸王。聖供地和殿的聖地要在其中，',
    '結48:22 並且利未人之地，與歸城之地的東西兩邊延長之地（這兩地在王地中間），就是在猶大和便雅憫兩界中間，要歸與王。',
    '結48:23 論到其餘的支派，從東到西，是便雅憫的一分。',
    '結48:24 挨著便雅憫的地界，從東到西，是西緬的一分。',
    '結48:25 挨著西緬的地界，從東到西，是以薩迦的一分。',
    '結48:26 挨著以薩迦的地界，從東到西，是西布倫的一分。',
    '結48:27 挨著西布倫的地界，從東到西，是迦得的一分。',
    '結48:28 迦得地的南界是從他瑪到米利巴加低斯的水，延到埃及小河，直到大海。',
    '結48:29 這就是你們要拈鬮分給以色列支派為業之地，乃是他們各支派所得之分。這是主耶和華說的。',
    '結48:30 城的北面四千五百肘。出城之處如下；',
    '結48:31 城的各門要按以色列支派的名字。北面有三門，一為流便門，一為猶大門，一為利未門；',
    '結48:32 東面四千五百肘，有三門，一為約瑟門，一為便雅憫門，一為但門；',
    '結48:33 南面四千五百肘，有三門，一為西緬門，一為以薩迦門，一為西布倫門；',
    '結48:34 西面四千五百肘，有三門，一為迦得門，一為亞設門，一為拿弗他利門。',
    '結48:35 城四圍共一萬八千肘。從此以後，這城的名字必稱為耶和華的所在。',
    '但1:1 猶大王約雅敬在位第三年，巴比倫王尼布甲尼撒來到耶路撒冷，將城圍困。',
    '但1:2 主將猶大王約雅敬，並神殿中器皿的幾分交付他手。他就把這器皿帶到示拿地，收入他神的廟裡，放在他神的庫中。',
    '但1:3 王吩咐太監長亞施毘拿，從以色列人的宗室和貴冑中帶進幾個人來，',
    '但1:4 就是年少沒有殘疾、相貌俊美、通達各樣學問、知識聰明俱備、足能侍立在王宮裡的，要教他們迦勒底的文字言語。',
    '但1:5 王派定將自己所用的膳和所飲的酒，每日賜他們一分，養他們三年。滿了三年，好叫他們在王面前侍立。',
    '但1:6 他們中間有猶大族的人：但以理、哈拿尼雅、米沙利、亞撒利雅。',
    '但1:7 太監長給他們起名：稱但以理為伯提沙撒，稱哈拿尼雅為沙得拉，稱米沙利為米煞，稱亞撒利雅為亞伯尼歌。',
    '但1:8 但以理卻立志不以王的膳和王所飲的酒玷污自己，所以求太監長容他不玷污自己。',
    '但1:9 神使但以理在太監長眼前蒙恩惠，受憐憫。',
    '但1:10 太監長對但以理說：我懼怕我主我王，他已經派定你們的飲食；倘若他見你們的面貌比你們同歲的少年人肌瘦，怎麼好呢﹖這樣，你們就使我的頭在王那裡難保。',
    '但1:11 但以理對太監長所派管理但以理、哈拿尼雅、米沙利、亞撒利雅的委辦說：',
    '但1:12 求你試試僕人們十天，給我們素菜吃，白水喝，',
    '但1:13 然後看看我們的面貌和用王膳那少年人的面貌，就照你所看的待僕人吧！',
    '但1:14 委辦便允准他們這件事，試看他們十天。',
    '但1:15 過了十天，見他們的面貌比用王膳的一切少年人更加俊美肥胖。',
    '但1:16 於是委辦撤去派他們用的膳，飲的酒，給他們素菜吃。',
    '但1:17 這四個少年人，神在各樣文字學問（學問：原文是智慧）上賜給他們聰明知識；但以理又明白各樣的異象和夢兆。',
    '但1:18 尼布甲尼撒王預定帶進少年人來的日期滿了，太監長就把他們帶到王面前。',
    '但1:19 王與他們談論，見少年人中無一人能比但以理、哈拿尼雅、米沙利、亞撒利雅，所以留他們在王面前侍立。',
    '但1:20 王考問他們一切事，就見他們的智慧聰明比通國的術士和用法術的勝過十倍。',
    '但1:21 到古列王元年，但以理還在。',
    '但2:1 尼布甲尼撒在位第二年，他做了夢，心裡煩亂，不能睡覺。',
    '但2:2 王吩咐人將術士、用法術的、行邪術的，和迦勒底人召來，要他們將王的夢告訴王，他們就來站在王前。',
    '但2:3 王對他們說：我做了一夢，心裡煩亂，要知道這是什麼夢。',
    '但2:4 迦勒底人用亞蘭的言語對王說：願王萬歲！請將那夢告訴僕人，僕人就可以講解。',
    '但2:5 王回答迦勒底人說：夢我已經忘了（或譯：我已定命；八節同），你們若不將夢和夢的講解告訴我，就必被凌遲，你們的房屋必成為糞堆；',
    '但2:6 你們若將夢和夢的講解告訴我，就必從我這裡得贈品和賞賜，並大尊榮。現在你們要將夢和夢的講解告訴我。',
    '但2:7 他們第二次對王說：請王將夢告訴僕人，僕人就可以講解。',
    '但2:8 王回答說：我准知道你們是故意遲延，因為你們知道那夢我已經忘了。',
    '但2:9 你們若不將夢告訴我，只有一法待你們；因為你們預備了謊言亂語向我說，要等候時勢改變。現在你們要將夢告訴我，因我知道你們能將夢的講解告訴我。',
    '但2:10 迦勒底人在王面前回答說：世上沒有人能將王所問的事說出來；因為沒有君王、大臣、掌權的向術士，或用法術的，或迦勒底人問過這樣的事。',
    '但2:11 王所問的事甚難。除了不與世人同居的神明，沒有人在王面前能說出來。',
    '但2:12 因此，王氣忿忿地大發烈怒，吩咐滅絕巴比倫所有的哲士。',
    '但2:13 於是命令發出，哲士將要見殺，人就尋找但以理和他的同伴，要殺他們。',
    '但2:14 王的護衛長亞略出來，要殺巴比倫的哲士，但以理就用婉言回答他，',
    '但2:15 向王的護衛長亞略說：王的命令為何這樣緊急呢﹖亞略就將情節告訴但以理。',
    '但2:16 但以理遂進去求王寬限，就可以將夢的講解告訴王。',
    '但2:17 但以理回到他的居所，將這事告訴他的同伴哈拿尼雅、米沙利、亞撒利雅，',
    '但2:18 要他們祈求天上的神施憐憫，將這奧祕的事指明，免得但以理和他的同伴與巴比倫其餘的哲士一同滅亡。',
    '但2:19 這奧祕的事就在夜間異象中給但以理顯明，但以理便稱頌天上的神。',
    '但2:20 但以理說：神的名是應當稱頌的！從亙古直到永遠，因為智慧能力都屬乎他。',
    '但2:21 他改變時候、日期，廢王，立王，將智慧賜與智慧人，將知識賜與聰明人。',
    '但2:22 他顯明深奧隱祕的事，知道暗中所有的，光明也與他同居。',
    '但2:23 我列祖的神啊，我感謝你，讚美你，因你將智慧才能賜給我，允准我們所求的，把王的事給我們指明。',
    '但2:24 於是，但以理進去見亞略，就是王所派滅絕巴比倫哲士的，對他說：不要滅絕巴比倫的哲士，求你領我到王面前，我要將夢的講解告訴王。',
    '但2:25 亞略就急忙將但以理領到王面前，對王說：我在被擄的猶大人中遇見一人，他能將夢的講解告訴王。',
    '但2:26 王問稱為伯提沙撒的但以理說：你能將我所做的夢和夢的講解告訴我嗎﹖',
    '但2:27 但以理在王面前回答說：王所問的那奧祕事，哲士、用法術的、術士、觀兆的都不能告訴王；',
    '但2:28 只有一位在天上的神能顯明奧祕的事。他已將日後必有的事指示尼布甲尼撒王。你的夢和你在床上腦中的異象是這樣：',
    '但2:29 王啊，你在床上想到後來的事，那顯明奧祕事的主把將來必有的事指示你。',
    '但2:30 至於那奧祕的事顯明給我，並非因我的智慧勝過一切活人，乃為使王知道夢的講解和心裡的思念。',
    '但2:31 王啊，你夢見一個大像，這像甚高，極其光耀，站在你面前，形狀甚是可怕。',
    '但2:32 這像的頭是精金的，胸膛和膀臂是銀的，肚腹和腰是銅的，',
    '但2:33 腿是鐵的，腳是半鐵半泥的。',
    '但2:34 你觀看，見有一塊非人手鑿出來的石頭打在這像半鐵半泥的腳上，把腳砸碎；',
    '但2:35 於是金、銀、銅、鐵、泥都一同砸得粉碎，成如夏天禾場上的糠粃，被風吹散，無處可尋。打碎這像的石頭變成一座大山，充滿天下。',
    '但2:36 這就是那夢。我們在王面前要講解那夢。',
    '但2:37 王啊，你是諸王之王。天上的神已將國度、權柄、能力、尊榮都賜給你。',
    '但2:38 凡世人所住之地的走獸，並天空的飛鳥，他都交付你手，使你掌管這一切。你就是那金頭。',
    '但2:39 在你以後必另興一國，不及於你；又有第三國，就是銅的，必掌管天下。',
    '但2:40 第四國，必堅壯如鐵，鐵能打碎剋制百物，又能壓碎一切，那國也必打碎壓制列國。',
    '但2:41 你既見像的腳和腳指頭，一半是窰匠的泥，一半是鐵，那國將來也必分開。你既見鐵與泥攙雜，那國也必有鐵的力量。',
    '但2:42 那腳指頭，既是半鐵半泥，那國也必半強半弱。',
    '但2:43 你既見鐵與泥攙雜，那國民也必與各種人攙雜，卻不能彼此相合，正如鐵與泥不能相合一樣。',
    '但2:44 當那列王在位的時候，天上的神必另立一國，永不敗壞，也不歸別國的人，卻要打碎滅絕那一切國，這國必存到永遠。',
    '但2:45 你既看見非人手鑿出來的一塊石頭從山而出，打碎金、銀、銅、鐵、泥，那就是至大的神把後來必有的事給王指明。這夢準是這樣，這講解也是確實的。',
    '但2:46 當時，尼布甲尼撒王俯伏在地，向但以理下拜，並且吩咐人給他奉上供物和香品。',
    '但2:47 王對但以理說：你既能顯明這奧祕的事，你們的神誠然是萬神之神、萬王之主，又是顯明奧祕事的。',
    '但2:48 於是王高擡但以理，賞賜他許多上等禮物，派他管理巴比倫全省，又立他為總理，掌管巴比倫的一切哲士。',
    '但2:49 但以理求王，王就派沙得拉、米煞、亞伯尼歌管理巴比倫省的事務，只是但以理常在朝中侍立。',
    '但3:1 尼布甲尼撒王造了一個金像，高六十肘，寬六肘，立在巴比倫省杜拉平原。',
    '但3:2 尼布甲尼撒王差人將總督、欽差、巡撫、臬司、藩司、謀士、法官，和各省的官員都召了來，為尼布甲尼撒王所立的像行開光之禮。',
    '但3:3 於是總督、欽差、巡撫、臬司、藩司、謀士、法官，和各省的官員都聚集了來，要為尼布甲尼撒王所立的像行開光之禮，就站在尼布甲尼撒所立的像前。',
    '但3:4 那時傳令的大聲呼叫說：各方、各國、各族（原文是舌：下同）的人哪，有令傳與你們：',
    '但3:5 你們一聽見角、笛、琵琶、琴、瑟、笙，和各樣樂器的聲音，就當俯伏敬拜尼布甲尼撒王所立的金像。',
    '但3:6 凡不俯伏敬拜的，必立時扔在烈火的窰中。',
    '但3:7 因此各方、各國、各族的人民一聽見角、笛、琵琶、琴、瑟，和各樣樂器的聲音，就都俯伏敬拜尼布甲尼撒王所立的金像。',
    '但3:8 那時，有幾個迦勒底人進前來控告猶大人。',
    '但3:9 他們對尼布甲尼撒王說：願王萬歲！',
    '但3:10 王啊，你曾降旨說，凡聽見角、笛、琵琶、琴、瑟、笙，和各樣樂器聲音的都當俯伏敬拜金像。',
    '但3:11 凡不俯伏敬拜的，必扔在烈火的窰中。',
    '但3:12 現在有幾個猶大人，就是王所派管理巴比倫省事務的沙得拉、米煞、亞伯尼歌；王啊，這些人不理你，不事奉你的神，也不敬拜你所立的金像。',
    '但3:13 當時，尼布甲尼撒沖沖大怒，吩咐人把沙得拉、米煞、亞伯尼歌帶過來，他們就把那些人帶到王面前。',
    '但3:14 尼布甲尼撒問他們說：沙得拉、米煞、亞伯尼歌，你們不事奉我的神，也不敬拜我所立的金像，是故意的嗎﹖',
    '但3:15 你們再聽見角、笛、琵琶、琴、瑟、笙，和各樣樂器的聲音，若俯伏敬拜我所造的像，卻還可以；若不敬拜，必立時扔在烈火的窰中，有何神能救你們脫離我手呢﹖',
    '但3:16 沙得拉、米煞、亞伯尼歌對王說：尼布甲尼撒啊，這件事我們不必回答你；',
    '但3:17 即便如此，我們所事奉的神能將我們從烈火的窰中救出來。王啊，他也必救我們脫離你的手；',
    '但3:18 即或不然，王啊，你當知道我們決不事奉你的神，也不敬拜你所立的金像。',
    '但3:19 當時，尼布甲尼撒怒氣填胸，向沙得拉、米煞、亞伯尼歌變了臉色，吩咐人把窰燒熱，比尋常更加七倍；',
    '但3:20 又吩咐他軍中的幾個壯士，將沙得拉、米煞、亞伯尼歌捆起來，扔在烈火的窰中。',
    '但3:21 這三人穿著褲子、內袍、外衣，和別的衣服，被捆起來扔在烈火的窰中。',
    '但3:22 因為王命緊急，窰又甚熱，那擡沙得拉、米煞、亞伯尼歌的人都被火焰燒死。',
    '但3:23 沙得拉、米煞、亞伯尼歌這三個人都被捆著落在烈火的窰中。',
    '但3:24 那時，尼布甲尼撒王驚奇，急忙起來，對謀士說：我捆起來扔在火裡的不是三個人嗎﹖他們回答王說：王啊，是。',
    '但3:25 王說：看哪，我見有四個人，並沒有捆綁，在火中遊行，也沒有受傷；那第四個的相貌好像神子。',
    '但3:26 於是，尼布甲尼撒就近烈火窰門，說：至高神的僕人沙得拉、米煞、亞伯尼歌出來，上這裡來吧！沙得拉、米煞、亞伯尼歌就從火中出來了。',
    '但3:27 那些總督、欽差、巡撫，和王的謀士一同聚集看這三個人，見火無力傷他們的身體，頭髮也沒有燒焦，衣裳也沒有變色，並沒有火燎的氣味。',
    '但3:28 尼布甲尼撒說：沙得拉、米煞、亞伯尼歌的神是應當稱頌的！他差遣使者救護倚靠他的僕人，他們不遵王命，捨去己身，在他們神以外不肯事奉敬拜別神。',
    '但3:29 現在我降旨，無論何方、何國、何族的人，謗讟沙得拉、米煞、亞伯尼歌之神的，必被凌遲，他的房屋必成糞堆，因為沒有別神能這樣施行拯救。',
    '但3:30 那時王在巴比倫省，高升了沙得拉、米煞、亞伯尼歌。',
    '但4:1 尼布甲尼撒王曉諭住在全地各方、各國、各族的人說：願你們大享平安！',
    '但4:2 我樂意將至高的神向我所行的神蹟奇事宣揚出來。',
    '但4:3 他的神蹟何其大！他的奇事何其盛！他的國是永遠的；他的權柄存到萬代！',
    '但4:4 我尼布甲尼撒安居在宮中，平順在殿內。',
    '但4:5 我做了一夢，使我懼怕。我在床上的思念，並腦中的異象，使我驚惶。',
    '但4:6 所以我降旨召巴比倫的一切哲士到我面前，叫他們把夢的講解告訴我。',
    '但4:7 於是那些術士、用法術的、迦勒底人、觀兆的都進來，我將那夢告訴了他們，他們卻不能把夢的講解告訴我。',
    '但4:8 末後那照我神的名，稱為伯提沙撒的但以理來到我面前，他裡頭有聖神的靈，我將夢告訴他說：',
    '但4:9 術士的領袖伯提沙撒啊，因我知道你裡頭有聖神的靈，什麼奧祕的事都不能使你為難。現在要把我夢中所見的異象和夢的講解告訴我。',
    '但4:10 我在床上腦中的異象是這樣：我看見地當中有一棵樹，極其高大。',
    '但4:11 那樹漸長，而且堅固，高得頂天，從地極都能看見，',
    '但4:12 葉子華美，果子甚多，可作眾生的食物；田野的走獸臥在蔭下，天空的飛鳥宿在枝上；凡有血氣的都從這樹得食。',
    '但4:13 我在床上腦中的異象，見有一位守望的聖者從天而降。',
    '但4:14 大聲呼叫說：伐倒這樹！砍下枝子！搖掉葉子！拋散果子！使走獸離開樹下，飛鳥躲開樹枝。',
    '但4:15 樹丕卻要留在地內，用鐵圈和銅圈箍住，在田野的青草中讓天露滴濕，使他與地上的獸一同吃草，',
    '但4:16 使他的心改變，不如人心；給他一個獸心，使他經過七期（期：或譯年；本章同）。',
    '但4:17 這是守望者所發的命，聖者所出的令，好叫世人知道至高者在人的國中掌權，要將國賜與誰就賜與誰，或立極卑微的人執掌國權。',
    '但4:18 這是我─尼布甲尼撒王所做的夢。伯提沙撒啊，你要說明這夢的講解；因為我國中的一切哲士都不能將夢的講解告訴我，惟獨你能，因你裡頭有聖神的靈。',
    '但4:19 於是稱為伯提沙撒的但以理驚訝片時，心意驚惶。王說：伯提沙撒啊，不要因夢和夢的講解驚惶。伯提沙撒回答說：我主啊，願這夢歸與恨惡你的人，講解歸與你的敵人。',
    '但4:20 你所見的樹漸長，而且堅固，高得頂天，從地極都能看見；',
    '但4:21 葉子華美，果子甚多，可作眾生的食物；田野的走獸住在其下；天空的飛鳥宿在枝上。',
    '但4:22 王啊，這漸長又堅固的樹就是你。你的威勢漸長及天，你的權柄管到地極。',
    '但4:23 王既看見一位守望的聖者從天而降，說：將這樹砍伐毀壞，樹丕卻要留在地內，用鐵圈和銅圈箍住；在田野的青草中，讓天露滴濕，使他與地上的獸一同吃草，直到經過七期。',
    '但4:24 王啊，講解就是這樣：臨到我主我王的事是出於至高者的命。',
    '但4:25 你必被趕出離開世人，與野地的獸同居，吃草如牛，被天露滴濕，且要經過七期。等你知道至高者在人的國中掌權，要將國賜與誰就賜與誰。',
    '但4:26 守望者既吩咐存留樹丕，等你知道諸天掌權，以後你的國必定歸你。',
    '但4:27 王啊，求你悅納我的諫言，以施行公義斷絕罪過，以憐憫窮人除掉罪孽，或者你的平安可以延長。',
    '但4:28 這事都臨到尼布甲尼撒王。',
    '但4:29 過了十二個月，他遊行在巴比倫王宮裡（原文是上）。',
    '但4:30 他說：這大巴比倫不是我用大能大力建為京都，要顯我威嚴的榮耀嗎﹖',
    '但4:31 這話在王口中尚未說完，有聲音從天降下，說：尼布甲尼撒王啊，有話對你說，你的國位離開你了。',
    '但4:32 你必被趕出離開世人，與野地的獸同居，吃草如牛，且要經過七期。等你知道至高者在人的國中掌權，要將國賜與誰就賜與誰。',
    '但4:33 當時這話就應驗在尼布甲尼撒的身上，他被趕出離開世人，吃草如牛，身被天露滴濕，頭髮長長，好像鷹毛；指甲長長，如同鳥爪。',
    '但4:34 日子滿足，我─尼布甲尼撒舉目望天，我的聰明復歸於我，我便稱頌至高者，讚美尊敬活到永遠的神。他的權柄是永有的；他的國存到萬代。',
    '但4:35 世上所有的居民都算為虛無；在天上的萬軍和世上的居民中，他都憑自己的意旨行事。無人能攔住他手，或問他說，你做什麼呢﹖',
    '但4:36 那時，我的聰明復歸於我，為我國的榮耀、威嚴，和光耀也都復歸於我；並且我的謀士和大臣也來朝見我。我又得堅立在國位上，至大的權柄加增於我。',
    '但4:37 現在我─尼布甲尼撒讚美、尊崇、恭敬天上的王；因為他所做的全都誠實，他所行的也都公平。那行動驕傲的，他能降為卑。',
    '但5:1 伯沙撒王為他的一千大臣設擺盛筵，與這一千人對面飲酒。',
    '但5:2 伯沙撒歡飲之間，吩咐人將他父（或譯：祖；下同）尼布甲尼撒從耶路撒冷殿中所掠的金銀器皿拿來，王與大臣、皇后、妃嬪好用這器皿飲酒。',
    '但5:3 於是他們把耶路撒冷神殿庫房中所掠的金器皿拿來，王和大臣、皇后、妃嬪就用這器皿飲酒。',
    '但5:4 他們飲酒，讚美金、銀、銅、鐵、木、石所造的神。',
    '但5:5 當時，忽有人的指頭顯出，在王宮與燈臺相對的粉牆上寫字。王看見寫字的指頭',
    '但5:6 就變了臉色，心意驚惶，腰骨好像脫節，雙膝彼此相碰，',
    '但5:7 大聲吩咐將用法術的和迦勒底人並觀兆的領進來，對巴比倫的哲士說，誰能讀這文字，把講解告訴我，他必身穿紫袍，項帶金鍊，在我國中位列第三。',
    '但5:8 於是王的一切哲士都進來，卻不能讀那文字，也不能把講解告訴王。',
    '但5:9 伯沙撒王就甚驚惶，臉色改變，他的大臣也都驚奇。',
    '但5:10 太后（或譯：皇后；下同）因王和他大臣所說的話，就進入宴宮，說：願王萬歲！你心意不要驚惶，臉面不要變色。',
    '但5:11 在你國中有一人，他裡頭有聖神的靈，你父在世的日子，這人心中光明，又有聰明智慧，好像神的智慧。你父尼布甲尼撒王，就是王的父，立他為術士、用法術的，和迦勒底人，並觀兆的領袖。',
    '但5:12 在他裡頭有美好的靈性，又有知識聰明，能圓夢，釋謎語，解疑惑。這人名叫但以理，尼布甲尼撒王又稱他為伯提沙撒，現在可以召他來，他必解明這意思。',
    '但5:13 但以理就被領到王前。王問但以理說：你是被擄之猶大人中的但以理嗎﹖就是我父王從猶大擄來的嗎﹖',
    '但5:14 我聽說你裡頭有神的靈，心中光明，又有聰明和美好的智慧。',
    '但5:15 現在哲士和用法術的都領到我面前，為叫他們讀這文字，把講解告訴我，無奈他們都不能把講解說出來。',
    '但5:16 我聽說你善於講解，能解疑惑；現在你若能讀這文字，把講解告訴我，就必身穿紫袍，項戴金鍊，在我國中位列第三。',
    '但5:17 但以理在王面前回答說：你的贈品可以歸你自己，你的賞賜可以歸給別人；我卻要為王讀這文字，把講解告訴王。',
    '但5:18 王啊，至高的神曾將國位、大權、榮耀、威嚴賜與你父尼布甲尼撒；',
    '但5:19 因神所賜他的大權，各方、各國、各族的人都在他面前戰兢恐懼。他可以隨意生殺，隨意升降。',
    '但5:20 但他心高氣傲，靈也剛愎，甚至行事狂傲，就被革去王位，奪去榮耀。',
    '但5:21 他被趕出離開世人，他的心變如獸心，與野驢同居，吃草如牛，身被天露滴濕，等他知道至高的神在人的國中掌權，憑自己的意旨立人治國。',
    '但5:22 伯沙撒啊，你是他的兒子（或譯：孫子），你雖知道這一切，你心仍不自卑，',
    '但5:23 竟向天上的主自高，使人將他殿中的器皿拿到你面前，你和大臣、皇后、妃嬪用這器皿飲酒。你又讚美那不能看、不能聽、無知無識、金、銀、銅、鐵、木、石所造的神，卻沒有將榮耀歸與那手中有你氣息，管理你一切行動的神。',
    '但5:24 因此從神那裡顯出指頭來寫這文字。',
    '但5:25 所寫的文字是：彌尼，彌尼，提客勒，烏法珥新。',
    '但5:26 講解是這樣：彌尼，就是神已經數算你國的年日到此完畢。',
    '但5:27 提客勒，就是你被稱在天平裡，顯出你的虧欠。',
    '但5:28 毘勒斯（與烏法珥新同義），就是你的國分裂，歸與瑪代人和波斯人。',
    '但5:29 伯沙撒下令，人就把紫袍給但以理穿上，把金鍊給他戴在頸項上，又傳令使他在國中位列第三。',
    '但5:30 當夜，迦勒底王伯沙撒被殺。',
    '但5:31 瑪代人大利烏年六十二歲，取了迦勒底國。',
    '但6:1 大利烏隨心所願，立一百二十個總督，治理通國。',
    '但6:2 又在他們以上立總長三人（但以理在其中），使總督在他們三人面前回覆事務，免得王受虧損。',
    '但6:3 因這但以理有美好的靈性，所以顯然超乎其餘的總長和總督，王又想立他治理通國。',
    '但6:4 那時，總長和總督尋找但以理誤國的把柄，為要參他；只是找不著他的錯誤過失，因他忠心辦事，毫無錯誤過失。',
    '但6:5 那些人便說：我們要找參這但以理的把柄，除非在他神的律法中就尋不著。',
    '但6:6 於是，總長和總督紛紛聚集來見王，說：願大利烏王萬歲！',
    '但6:7 國中的總長、欽差、總督、謀士，和巡撫彼此商議，要立一條堅定的禁令（或譯：求王下旨要立一條……），三十日內，不拘何人，若在王以外，或向神或向人求什麼，就必扔在獅子坑中。',
    '但6:8 王啊，現在求你立這禁令，加蓋玉璽，使禁令決不更改；照瑪代和波斯人的例是不可更改的。',
    '但6:9 於是大利烏王立這禁令，加蓋玉璽。',
    '但6:10 但以理知道這禁令蓋了玉璽，就到自己家裡（他樓上的窗戶開向耶路撒冷），一日三次，雙膝跪在他神面前，禱告感謝，與素常一樣。',
    '但6:11 那些人就紛紛聚集，見但以理在他神面前祈禱懇求。',
    '但6:12 他們便進到王前，提王的禁令，說：王啊，三十日內不拘何人，若在王以外，或向神或向人求什麼，必被扔在獅子坑中。王不是在這禁令上蓋了玉璽嗎﹖王回答說：實有這事，照瑪代和波斯人的例是不可更改的。',
    '但6:13 他們對王說：王啊，那被擄之猶大人中的但以理不理你，也不遵你蓋了玉璽的禁令，他竟一日三次祈禱。',
    '但6:14 王聽見這話，就甚愁煩，一心要救但以理，籌劃解救他，直到日落的時候。',
    '但6:15 那些人就紛紛聚集來見王，說：王啊，當知道瑪代人和波斯人有例，凡王所立的禁令和律例都不可更改。',
    '但6:16 王下令，人就把但以理帶來，扔在獅子坑中。王對但以理說：你所常事奉的神，他必救你。',
    '但6:17 有人搬石頭放在坑口，王用自己的璽和大臣的印，封閉那坑，使懲辦但以理的事毫無更改。',
    '但6:18 王回宮，終夜禁食，無人拿樂器到他面前，並且睡不著覺。',
    '但6:19 次日黎明，王就起來，急忙往獅子坑那裡去。',
    '但6:20 臨近坑邊，哀聲呼叫但以理，對但以理說：永生神的僕人但以理啊，你所常事奉的神能救你脫離獅子嗎﹖',
    '但6:21 但以理對王說：願王萬歲！',
    '但6:22 我的神差遣使者，封住獅子的口，叫獅子不傷我；因我在神面前無辜，我在王面前也沒有行過虧損的事。',
    '但6:23 王就甚喜樂，吩咐人將但以理從坑裡繫上來。於是但以理從坑裡被繫上來，身上毫無傷損，因為信靠他的神。',
    '但6:24 王下令，人就把那些控告但以理的人，連他們的妻子兒女都帶來，扔在獅子坑中。他們還沒有到坑底，獅子就抓住（原文是勝了）他們，咬碎他們的骨頭。',
    '但6:25 那時，大利烏王傳旨，曉諭住在全地各方、各國、各族的人說：願你們大享平安！',
    '但6:26 現在我降旨曉諭我所統轄的全國人民，要在但以理的神面前，戰兢恐懼。因為他是永遠長存的活神，他的國永不敗壞；他的權柄永存無極！',
    '但6:27 他護庇人，搭救人，在天上地下施行神蹟奇事，救了但以理脫離獅子的口。',
    '但6:28 如此，這但以理，當大利烏王在位的時候和波斯王古列在位的時候，大享亨通。',
    '但7:1 巴比倫王伯沙撒元年，但以理在床上做夢，見了腦中的異象，就記錄這夢，述說其中的大意。',
    '但7:2 但以理說：我夜裡見異象，看見天的四風陡起，颳在大海之上。',
    '但7:3 有四個大獸從海中上來，形狀各有不同：',
    '但7:4 頭一個像獅子，有鷹的翅膀；我正觀看的時候，獸的翅膀被拔去，獸從地上得立起來，用兩腳站立，像人一樣，又得了人心。',
    '但7:5 又有一獸如熊，就是第二獸，旁跨而坐，口齒內啣著三根肋骨。有吩咐這獸的說：起來吞吃多肉。',
    '但7:6 此後我觀看，又有一獸如豹，背上有鳥的四個翅膀；這獸有四個頭，又得了權柄。',
    '但7:7 其後我在夜間的異象中觀看，見第四獸甚是可怕，極其強壯，大有力量，有大鐵牙，吞吃嚼碎，所剩下的用腳踐踏。這獸與前三獸大不相同，頭有十角。',
    '但7:8 我正觀看這些角，見其中又長起一個小角；先前的角中有三角在這角前，連根被他拔出來。這角有眼，像人的眼，有口說誇大的話。',
    '但7:9 我觀看，見有寶座設立，上頭坐著亙古常在者。他的衣服潔白如雪，頭髮如純淨的羊毛。寶座乃火焰，其輪乃烈火。',
    '但7:10 從他面前有火，像河發出；事奉他的有千千，在他面前侍立的有萬萬；他坐著要行審判，案卷都展開了。',
    '但7:11 那時我觀看，見那獸因小角說誇大話的聲音被殺，身體損壞，扔在火中焚燒。',
    '但7:12 其餘的獸，權柄都被奪去，生命卻仍存留，直到所定的時候和日期。',
    '但7:13 我在夜間的異象中觀看，見有一位像人子的，駕著天雲而來，被領到亙古常在者面前，',
    '但7:14 得了權柄、榮耀、國度，使各方、各國、各族的人都事奉他。他的權柄是永遠的，不能廢去；他的國必不敗壞。',
    '但7:15 至於我─但以理，我的靈在我裡面愁煩，我腦中的異象使我驚惶。',
    '但7:16 我就近一位侍立者，問他這一切的真情。他就告訴我，將那事的講解給我說明。',
    '但7:17 這四個大獸就是四王將要在世上興起。',
    '但7:18 然而，至高者的聖民，必要得國享受，直到永永遠遠。',
    '但7:19 那時我願知道第四獸的真情，他為何與那三獸的真情大不相同，甚是可怕，有鐵牙銅爪，吞吃嚼碎，所剩下的用腳踐踏；',
    '但7:20 頭有十角和那另長的一角，在這角前有三角被他打落。這角有眼，有說誇大話的口，形狀強橫，過於他的同類。',
    '但7:21 我觀看，見這角與聖民爭戰，勝了他們。',
    '但7:22 直到亙古常在者來給至高者的聖民伸冤，聖民得國的時候就到了。',
    '但7:23 那侍立者這樣說：第四獸就是世上必有的第四國，與一切國大不相同，必吞吃全地，並且踐踏嚼碎。',
    '但7:24 至於那十角，就是從這國中必興起的十王，後來又興起一王，與先前的不同；他必制伏三王。',
    '但7:25 他必向至高者說誇大的話，必折磨至高者的聖民，必想改變節期和律法。聖民必交付他手一載、二載、半載。',
    '但7:26 然而，審判者必坐著行審判；他的權柄必被奪去，毀壞，滅絕，一直到底。',
    '但7:27 國度、權柄，和天下諸國的大權必賜給至高者的聖民。他的國是永遠的；一切掌權的都必事奉他，順從他。',
    '但7:28 那事至此完畢。至於我─但以理，心中甚是驚惶，臉色也改變了，卻將那事存記在心。',
    '但8:1 伯沙撒王在位第三年，有異象現與我─但以理，是在先前所見的異象之後。',
    '但8:2 我見了異象的時候，我以為在以攔省書珊城（或譯：宮）中；我見異象又如在烏萊河邊。',
    '但8:3 我舉目觀看，見有雙角的公綿羊站在河邊，兩角都高。這角高過那角，更高的是後長的。',
    '但8:4 我見那公綿羊往西、往北、往南牴觸。獸在他面前都站立不住，也沒有能救護脫離他手的；但他任意而行，自高自大。',
    '但8:5 我正思想的時候，見有一隻公山羊從西而來，遍行全地，腳不沾塵。這山羊兩眼當中有一非常的角。',
    '但8:6 他往我所看見、站在河邊有雙角的公綿羊那裡去，大發忿怒，向他直闖。',
    '但8:7 我見公山羊就近公綿羊，向他發烈怒，牴觸他，折斷他的兩角。綿羊在他面前站立不住；他將綿羊觸倒在地，用腳踐踏，沒有能救綿羊脫離他手的。',
    '但8:8 這山羊極其自高自大，正強盛的時候，那大角折斷了，又在角根上向天的四方（原文是風）長出四個非常的角來。',
    '但8:9 四角之中有一角長出一個小角，向南、向東、向榮美之地，漸漸成為強大。',
    '但8:10 他漸漸強大，高及天象，將些天象和星宿拋落在地，用腳踐踏。',
    '但8:11 並且他自高自大，以為高及天象之君；除掉常獻給君的燔祭，毀壞君的聖所。',
    '但8:12 因罪過的緣故，有軍旅和常獻的燔祭交付他。他將真理拋在地上，任意而行，無不順利。',
    '但8:13 我聽見有一位聖者說話，又有一位聖者問那說話的聖者說：這除掉常獻的燔祭和施行毀壞的罪過，將聖所與軍旅（或譯：以色列的軍）踐踏的異象，要到幾時才應驗呢﹖',
    '但8:14 他對我說：到二千三百日，聖所就必潔淨。',
    '但8:15 我─但以理見了這異象，願意明白其中的意思。忽有一位形狀像人的站在我面前。',
    '但8:16 我又聽見烏萊河兩岸中有人聲呼叫說：加百列啊，要使此人明白這異象。',
    '但8:17 他便來到我所站的地方。他一來，我就驚慌俯伏在地；他對我說：人子啊，你要明白，因為這是關乎末後的異象。',
    '但8:18 他與我說話的時候，我面伏在地沉睡；他就摸我，扶我站起來，',
    '但8:19 說：我要指示你惱怒臨完必有的事，因為這是關乎末後的定期。',
    '但8:20 你所看見雙角的公綿羊，就是瑪代和波斯王。',
    '但8:21 那公山羊就是希利尼王（希利尼：原文是雅完；下同）；兩眼當中的大角就是頭一王。',
    '但8:22 至於那折斷了的角，在其根上又長出四角，這四角就是四國，必從這國裡興起來，只是權勢都不及他。',
    '但8:23 這四國末時，犯法的人罪惡滿盈，必有一王興起，面貌凶惡，能用雙關的詐語。',
    '但8:24 他的權柄必大，卻不是因自己的能力；他必行非常的毀滅，事情順利，任意而行；又必毀滅有能力的和聖民。',
    '但8:25 他用權術成就手中的詭計，心裡自高自大，在人坦然無備的時候，毀滅多人；又要站起來攻擊萬君之君，至終卻非因人手而滅亡。',
    '但8:26 所說二千三百日的異象是真的，但你要將這異象封住，因為關乎後來許多的日子。',
    '但8:27 於是我─但以理昏迷不醒，病了數日，然後起來辦理王的事務。我因這異象驚奇，卻無人能明白其中的意思。',
    '但9:1 瑪代族亞哈隨魯的兒子大利烏立為迦勒底國的王元年，',
    '但9:2 就是他在位第一年，我但以理從書上得知耶和華的話臨到先知耶利米，論耶路撒冷荒涼的年數，七十年為滿。',
    '但9:3 我便禁食，披麻蒙灰，定意向主神祈禱懇求。',
    '但9:4 我向耶和華─我的神祈禱、認罪，說：主啊，大而可畏的神，向愛主、守主誡命的人守約施慈愛。',
    '但9:5 我們犯罪作孽，行惡叛逆，偏離你的誡命典章，',
    '但9:6 沒有聽從你僕人眾先知奉你名向我們君王、首領、列祖，和國中一切百姓所說的話。',
    '但9:7 主啊，你是公義的，我們是臉上蒙羞的；因我們猶大人和耶路撒冷的居民，並以色列眾人，或在近處，或在遠處，被你趕到各國的人，都得罪了你，正如今日一樣。',
    '但9:8 主啊，我們和我們的君王、首領、列祖因得罪了你，就都臉上蒙羞。',
    '但9:9 主─我們的神是憐憫饒恕人的，我們卻違背了他，',
    '但9:10 也沒有聽從耶和華─我們神的話，沒有遵行他藉僕人眾先知向我們所陳明的律法。',
    '但9:11 以色列眾人都犯了你的律法，偏行，不聽從你的話；因此，在你僕人摩西律法上所寫的咒詛和誓言都傾在我們身上，因我們得罪了神。',
    '但9:12 他使大災禍臨到我們，成就了警戒我們和審判我們官長的話；原來在普天之下未曾行過像在耶路撒冷所行的。',
    '但9:13 這一切災禍臨到我們身上是照摩西律法上所寫的，我們卻沒有求耶和華─我們神的恩典，使我們回頭離開罪孽，明白你的真理。',
    '但9:14 所以耶和華留意使這災禍臨到我們身上，因為耶和華─我們的神在他所行的事上都是公義；我們並沒有聽從他的話。',
    '但9:15 主─我們的神啊，你曾用大能的手領你的子民出埃及地，使自己得了名，正如今日一樣。我們犯了罪，作了惡。',
    '但9:16 主啊，求你按你的大仁大義，使你的怒氣和忿怒轉離你的城耶路撒冷，就是你的聖山。耶路撒冷和你的子民，因我們的罪惡和我們列祖的罪孽被四圍的人羞辱。',
    '但9:17 我們的神啊，現在求你垂聽僕人的祈禱懇求，為自己使臉光照你荒涼的聖所。',
    '但9:18 我的神啊，求你側耳而聽，睜眼而看，眷顧我們荒涼之地和稱為你名下的城。我們在你面前懇求，原不是因自己的義，乃因你的大憐憫。',
    '但9:19 求主垂聽，求主赦免，求主應允而行，為你自己不要遲延。我的神啊，因這城和這民都是稱為你名下的。',
    '但9:20 我說話，禱告，承認我的罪和本國之民以色列的罪，為我神的聖山，在耶和華─我神面前懇求。',
    '但9:21 我正禱告的時候，先前在異象中所見的那位加百列，奉命迅速飛來，約在獻晚祭的時候，按手在我身上。',
    '但9:22 他指教我說：但以理啊，現在我出來要使你有智慧，有聰明。',
    '但9:23 你初懇求的時候，就發出命令，我來告訴你，因你大蒙眷愛；所以你要思想明白這以下的事和異象。',
    '但9:24 為你本國之民和你聖城，已經定了七十個七。要止住罪過，除淨罪惡，贖盡罪孽，引進（或譯：彰顯）永義，封住異象和預言，並膏至聖者（者：或譯所）。',
    '但9:25 你當知道，當明白，從出令重新建造耶路撒冷，直到有受膏君的時候，必有七個七和六十二個七。正在艱難的時候，耶路撒冷城連街帶濠都必重新建造。',
    '但9:26 過了六十二個七，那（或譯：有）受膏者必被剪除，一無所有；必有一王的民來毀滅這城和聖所，至終必如洪水沖沒。必有爭戰，一直到底，荒涼的事已經定了。',
    '但9:27 一七之內，他必與許多人堅定盟約；一七之半，他必使祭祀與供獻止息。那行毀壞可憎的（或譯：使地荒涼的）如飛而來，並且有忿怒傾在那行毀壞的身上（或譯：傾在那荒涼之地），直到所定的結局。',
    '但10:1 波斯王古列第三年，有事顯給稱為伯提沙撒的但以理。這事是真的，是指著大爭戰；但以理通達這事，明白這異象。',
    '但10:2 當那時，我─但以理悲傷了三個七日。',
    '但10:3 美味我沒有吃，酒肉沒有入我的口，也沒有用油抹我的身，直到滿了三個七日。',
    '但10:4 正月二十四日，我在希底結大河邊，',
    '但10:5 舉目觀看，見有一人身穿細麻衣，腰束烏法精金帶。',
    '但10:6 他身體如水蒼玉，面貌如閃電，眼目如火把，手和腳如光明的銅，說話的聲音如大眾的聲音。',
    '但10:7 這異象惟有我─但以理一人看見，同著我的人沒有看見。他們卻大大戰兢，逃跑隱藏，',
    '但10:8 只剩下我一人。我見了這大異象便渾身無力，面貌失色，毫無氣力。',
    '但10:9 我卻聽見他說話的聲音，一聽見就面伏在地沉睡了。',
    '但10:10 忽然，有一手按在我身上，使我用膝和手掌支持微起。',
    '但10:11 他對我說：大蒙眷愛的但以理啊，要明白我與你所說的話，只管站起來，因為我現在奉差遣來到你這裡。他對我說這話，我便戰戰兢兢地立起來。',
    '但10:12 他就說：但以理啊，不要懼怕！因為從你第一日專心求明白將來的事，又在你神面前刻苦己心，你的言語已蒙應允；我是因你的言語而來。',
    '但10:13 但波斯國的魔君攔阻我二十一日。忽然有大君（就是天使長；二十一節同）中的一位米迦勒來幫助我，我就停留在波斯諸王那裡。',
    '但10:14 現在我來，要使你明白本國之民日後必遭遇的事，因為這異象關乎後來許多的日子。',
    '但10:15 他向我這樣說，我就臉面朝地，啞口無聲。',
    '但10:16 不料，有一位像人的，摸我的嘴唇，我便開口向那站在我面前的說：我主啊，因見這異象，我大大愁苦，毫無氣力。',
    '但10:17 我主的僕人怎能與我主說話呢﹖我一見異象就渾身無力，毫無氣息。',
    '但10:18 有一位形狀像人的又摸我，使我有力量。',
    '但10:19 他說：大蒙眷愛的人哪，不要懼怕，願你平安！你總要堅強。他一向我說話，我便覺得有力量，說：我主請說，因你使我有力量。',
    '但10:20 他就說：你知道我為何來見你嗎﹖現在我要回去與波斯的魔君爭戰，我去後，希利尼（原文是雅完）的魔君必來。',
    '但10:21 但我要將那錄在真確書上的事告訴你。除了你們的大君米迦勒之外，沒有幫助我抵擋這兩魔君的。',
    '但11:1 又說：當瑪代王大利烏元年，我曾起來扶助米迦勒，使他堅強。',
    '但11:2 現在我將真事指示你：波斯還有三王興起，第四王必富足遠勝諸王。他因富足成為強盛，就必激動大眾攻擊希利尼國。',
    '但11:3 必有一個勇敢的王興起，執掌大權，隨意而行。',
    '但11:4 他興起的時候，他的國必破裂，向天的四方（方：原文是風）分開，卻不歸他的後裔，治國的權勢也都不及他；因為他的國必被拔出，歸與他後裔之外的人。',
    '但11:5 南方的王必強盛，他將帥中必有一個比他更強盛，執掌權柄，他的權柄甚大。',
    '但11:6 過些年後，他們必互相連合，南方王的女兒必就了北方王來立約；但這女子幫助之力存立不住，王和他所倚靠之力也不能存立。這女子和引導他來的，並生他的，以及當時扶助他的，都必交與死地。',
    '但11:7 但這女子的本家（原文是根）必另生一子（子：原文是枝）繼續王位，他必率領軍隊進入北方王的保障，攻擊他們，而且得勝；',
    '但11:8 並將他們的神像和鑄成的偶像，與金銀的寶器掠到埃及去。數年之內，他不去攻擊北方的王。',
    '但11:9 北方的王（原文是他）必入南方王的國，卻要仍回本地。',
    '但11:10 北方王（原文是他）的二子必動干戈，招聚許多軍兵。這軍兵前去，如洪水氾濫，又必再去爭戰，直到南方王的保障。',
    '但11:11 南方王必發烈怒，出來與北方王爭戰，擺列大軍；北方王的軍兵必交付他手。',
    '但11:12 他的眾軍高傲，他的心也必自高；他雖使數萬人仆倒，卻不得常勝。',
    '但11:13 北方王必回來擺列大軍，比先前的更多。滿了所定的年數，他必率領大軍，帶極多的軍裝來。',
    '但11:14 那時，必有許多人起來攻擊南方王，並且你本國的強暴人必興起，要應驗那異象，他們卻要敗亡。',
    '但11:15 北方王必來築壘攻取堅固城；南方的軍兵必站立不住，就是選擇的精兵（原文是民）也無力站住。',
    '但11:16 來攻擊他的，必任意而行，無人在北方王（原文是他）面前站立得住。他必站在那榮美之地，用手施行毀滅。',
    '但11:17 他必定意用全國之力而來，立公正的約，照約而行，將自己的女兒給南方王為妻，想要敗壞他（或譯：埃及），這計卻不得成就，於自己毫無益處。',
    '但11:18 其後他必轉回奪取了許多海島。但有一大帥，除掉他令人受的羞辱，並且使這羞辱歸他本身。',
    '但11:19 他就必轉向本地的保障，卻要絆跌仆倒，歸於無有。',
    '但11:20 那時，必有一人興起接續他為王，使橫征暴斂的人通行國中的榮美地。這王不多日就必滅亡，卻不因忿怒，也不因爭戰。',
    '但11:21 必有一個卑鄙的人興起接續為王，人未曾將國的尊榮給他，他卻趁人坦然無備的時候，用諂媚的話得國。',
    '但11:22 必有無數的軍兵勢如洪水，在他面前沖沒敗壞；同盟的君也必如此。',
    '但11:23 與那君結盟之後，他必行詭詐，因為他必上來以微小的軍（原文是民）成為強盛。',
    '但11:24 趁人坦然無備的時候，他必來到國中極肥美之地，行他列祖和他列祖之祖所未曾行的，將擄物、掠物，和財寶散給眾人，又要設計攻打保障，然而這都是暫時的。',
    '但11:25 他必奮勇向前，率領大軍攻擊南方王；南方王也必以極大極強的軍兵與他爭戰，卻站立不住，因為有人設計謀害南方王。',
    '但11:26 吃王膳的，必敗壞他；他的軍隊必被沖沒，而且被殺的甚多。',
    '但11:27 至於這二王，他們心懷惡計，同席說謊，計謀卻不成就；因為到了定期，事就了結。',
    '但11:28 北方王（原文是他）必帶許多財寶回往本國，他的心反對聖約，任意而行，回到本地。',
    '但11:29 到了定期，他必返回，來到南方。後一次卻不如前一次，',
    '但11:30 因為基提戰船必來攻擊他，他就喪膽而回，又要惱恨聖約，任意而行；他必回來聯絡背棄聖約的人。',
    '但11:31 他必興兵，這兵必褻瀆聖地，就是保障，除掉常獻的燔祭，設立那行毀壞可憎的。',
    '但11:32 作惡違背聖約的人，他必用巧言勾引；惟獨認識神的子民必剛強行事。',
    '但11:33 民間的智慧人必訓誨多人；然而他們多日必倒在刀下，或被火燒，或被擄掠搶奪。',
    '但11:34 他們仆倒的時候，稍得扶助，卻有許多人用諂媚的話親近他們。',
    '但11:35 智慧人中有些仆倒的，為要熬煉其餘的人，使他們清淨潔白，直到末了；因為到了定期，事就了結。',
    '但11:36 王必任意而行，自高自大，超過所有的神，又用奇異的話攻擊萬神之神。他必行事亨通，直到主的忿怒完畢，因為所定的事必然成就。',
    '但11:37 他必不顧他列祖的神，也不顧婦女所羨慕的神，無論何神他都不顧；因為他必自大，高過一切。',
    '但11:38 他倒要敬拜保障的神，用金、銀、寶石和可愛之物敬奉他列祖所不認識的神。',
    '但11:39 他必靠外邦神的幫助，攻破最堅固的保障。凡承認他的，他必將榮耀加給他們，使他們管轄許多人，又為賄賂分地與他們。',
    '但11:40 到末了，南方王要與他交戰。北方王必用戰車、馬兵，和許多戰船，勢如暴風來攻擊他，也必進入列國，如洪水氾濫。',
    '但11:41 又必進入那榮美之地，有許多國就被傾覆，但以東人、摩押人，和一大半亞捫人必脫離他的手。',
    '但11:42 他必伸手攻擊列國；埃及地也不得脫離。',
    '但11:43 他必把持埃及的金銀財寶和各樣的寶物。呂彼亞人和古實人都必跟從他。',
    '但11:44 但從東方和北方必有消息擾亂他，他就大發烈怒出去，要將多人殺滅淨盡。',
    '但11:45 他必在海和榮美的聖山中間設立他如宮殿的帳幕；然而到了他的結局，必無人能幫助他。',
    '但12:1 那時，保佑你本國之民的天使長（原文是大君）米迦勒必站起來，並且有大艱難，從有國以來直到此時，沒有這樣的。你本國的民中，凡名錄在冊上的，必得拯救。',
    '但12:2 睡在塵埃中的，必有多人復醒。其中有得永生的，有受羞辱永遠被憎惡的。',
    '但12:3 智慧人必發光如同天上的光；那使多人歸義的，必發光如星，直到永永遠遠。',
    '但12:4 但以理啊，你要隱藏這話，封閉這書，直到末時。必有多人來往奔跑（或譯：切心研究），知識就必增長。',
    '但12:5 我─但以理觀看，見另有兩個人站立：一個在河這邊，一個在河那邊。',
    '但12:6 有一個問那站在河水以上、穿細麻衣的說：這奇異的事到幾時才應驗呢﹖',
    '但12:7 我聽見那站在河水以上、穿細麻衣的，向天舉起左右手，指著活到永遠的主起誓說：要到一載、二載、半載，打破聖民權力的時候，這一切事就都應驗了。',
    '但12:8 我聽見這話，卻不明白，就說：我主啊，這些事的結局是怎樣呢﹖',
    '但12:9 他說：但以理啊，你只管去；因為這話已經隱藏封閉，直到末時。',
    '但12:10 必有許多人使自己清淨潔白，且被熬煉；但惡人仍必行惡，一切惡人都不明白，惟獨智慧人能明白。',
    '但12:11 從除掉常獻的燔祭，並設立那行毀壞可憎之物的時候，必有一千二百九十日。',
    '但12:12 等到一千三百三十五日的，那人便為有福。',
    '但12:13 你且去等候結局，因為你必安歇。到了末期，你必起來，享受你的福分。',
    '何1:1 當烏西雅、約坦、亞哈斯、希西家作猶大王，約阿施的兒子耶羅波安作以色列王的時候，耶和華的話臨到備利的兒子何西阿。',
    '何1:2 耶和華初次與何西阿說話，對他說：你去娶淫婦為妻，也收那從淫亂所生的兒女；因為這地大行淫亂，離棄耶和華。',
    '何1:3 於是，何西阿去娶了滴拉音的女兒歌篾。這婦人懷孕，給他生了一個兒子。',
    '何1:4 耶和華對何西阿說：給他起名叫耶斯列；因為再過片時，我必討耶戶家在耶斯列殺人流血的罪，也必使以色列家的國滅絕。',
    '何1:5 到那日，我必在耶斯列平原折斷以色列的弓。',
    '何1:6 歌篾又懷孕生了一個女兒，耶和華對何西阿說：給他起名叫羅路哈瑪（就是不蒙憐憫的意思）；因為我必不再憐憫以色列家，決不赦免他們。',
    '何1:7 我卻要憐憫猶大家，使他們靠耶和華─他們的神得救，不使他們靠弓、刀、爭戰、馬匹，與馬兵得救。',
    '何1:8 歌篾給羅路哈瑪斷奶以後，又懷孕生了一個兒子。',
    '何1:9 耶和華說：給他起名叫羅阿米（就是非我民的意思）；因為你們不作我的子民，我也不作你們的神。',
    '何1:10 然而，以色列的人數必如海沙，不可量，不可數。從前在什麼地方對他們說你們不是我的子民，將來在那裡必對他們說你們是永生神的兒子。',
    '何1:11 猶大人和以色列人必一同聚集，為自己立一個首領，從這地上去（或譯：從被擄之地上來），因為耶斯列的日子必為大日。',
    '何2:1 你們要稱你們的弟兄為阿米（就是我民的意思），稱你們的姊妹為路哈瑪（就是蒙憐憫的意思）。',
    '何2:2 你們要與你們的母親大大爭辯；因為他不是我的妻子，我也不是他的丈夫。叫他除掉臉上的淫像和胸間的淫態，',
    '何2:3 免得我剝他的衣服，使他赤體，與才生的時候一樣，使他如曠野，如乾旱之地，因渴而死。',
    '何2:4 我必不憐憫他的兒女，因為他們是從淫亂而生的。',
    '何2:5 他們的母親行了淫亂，懷他們的母做了可羞恥的事，因為他說：我要隨從所愛的；我的餅、水、羊毛、麻、油、酒都是他們給的。',
    '何2:6 因此，我必用荊棘堵塞他的道，築牆擋住他，使他找不著路。',
    '何2:7 他必追隨所愛的，卻追不上；他必尋找他們，卻尋不見，便說：我要歸回前夫，因我那時的光景比如今還好。',
    '何2:8 他不知道是我給他五穀、新酒，和油，又加增他的金銀；他卻以此供奉（或譯：製造）巴力。',
    '何2:9 因此到了收割的日子，出酒的時候，我必將我的五穀新酒收回，也必將他應當遮體的羊毛和麻奪回來。',
    '何2:10 如今我必在他所愛的眼前顯露他的醜態；必無人能救他脫離我的手。',
    '何2:11 我也必使他的宴樂、節期、月朔、安息日，並他的一切大會都止息了。',
    '何2:12 我也必毀壞他的葡萄樹和無花果樹，就是他說這是我所愛的給我為賞賜的。我必使這些樹變為荒林，為田野的走獸所吃。',
    '何2:13 我必追討他素日給諸巴力燒香的罪；那時他佩帶耳環和別樣妝飾，隨從他所愛的，卻忘記我。這是耶和華說的。',
    '何2:14 後來我必勸導他，領他到曠野，對他說安慰的話。',
    '何2:15 他從那裡出來，我必賜他葡萄園，又賜他亞割谷作為指望的門。他必在那裡應聲（或譯：歌唱），與幼年的日子一樣，與從埃及地上來的時候相同。',
    '何2:16 耶和華說：那日你必稱呼我伊施（就是我夫的意思），不再稱呼我巴力（就是我主的意思）；',
    '何2:17 因為我必從我民的口中除掉諸巴力的名號，這名號不再提起。',
    '何2:18 當那日，我必為我的民，與田野的走獸和空中的飛鳥，並地上的昆蟲立約；又必在國中折斷弓刀，止息爭戰，使他們安然躺臥。',
    '何2:19 我必聘你永遠歸我為妻，以仁義、公平、慈愛、憐憫聘你歸我；',
    '何2:20 也以誠實聘你歸我，你就必認識我─耶和華。',
    '何2:21 耶和華說：那日我必應允，我必應允天，天必應允地；',
    '何2:22 地必應允五穀、新酒，和油，這些必應允耶斯列民（耶斯列就是神栽種的意思）。',
    '何2:23 我必將他種在這地。素不蒙憐憫的，我必憐憫；本非我民的，我必對他說：你是我的民；他必說：你是我的神。',
    '何3:1 耶和華對我說：你再去愛一個淫婦，就是他情人所愛的；好像以色列人，雖然偏向別神，喜愛葡萄餅，耶和華還是愛他們。',
    '何3:2 我便用銀子十五舍客勒，大麥一賀梅珥半，買他歸我。',
    '何3:3 我對他說：你當多日為我獨居，不可行淫，不可歸別人為妻，我向你也必這樣。',
    '何3:4 以色列人也必多日獨居，無君王，無首領，無祭祀，無柱像，無以弗得，無家中的神像。',
    '何3:5 後來以色列人必歸回（或譯：回心轉意），尋求他們的神─耶和華和他們的王大衛。在末後的日子，必以敬畏的心歸向耶和華，領受他的恩惠。',
    '何4:1 以色列人哪，你們當聽耶和華的話。耶和華與這地的居民爭辯，因這地上無誠實，無良善，無人認識神。',
    '何4:2 但起假誓，不踐前言，殺害，偷盜，姦淫，行強暴，殺人流血，接連不斷。',
    '何4:3 因此，這地悲哀，其上的民、田野的獸、空中的鳥必都衰微，海中的魚也必消滅。',
    '何4:4 然而，人都不必爭辯，也不必指責，因為這民與抗拒祭司的人一樣。',
    '何4:5 你這祭司必日間跌倒；先知也必夜間與你一同跌倒；我必滅絕你的母親。',
    '何4:6 我的民因無知識而滅亡。你棄掉知識，我也必棄掉你，使你不再給我作祭司。你既忘了你神的律法，我也必忘記你的兒女。',
    '何4:7 祭司越發增多，就越發得罪我；我必使他們的榮耀變為羞辱。',
    '何4:8 他們吃我民的贖罪祭，滿心願意我民犯罪。',
    '何4:9 將來民如何，祭司也必如何；我必因他們所行的懲罰他們，照他們所做的報應他們。',
    '何4:10 他們吃，卻不得飽；行淫，而不得立後；因為他們離棄耶和華，不遵他的命。',
    '何4:11 姦淫和酒，並新酒，奪去人的心。',
    '何4:12 我的民求問木偶，以為木杖能指示他們；因為他們的淫心使他們失迷，他們就行淫離棄神，不守約束，',
    '何4:13 在各山頂，各高岡的橡樹、楊樹、栗樹之下，獻祭燒香，因為樹影美好。所以，你們的女兒淫亂，你們的新婦（或譯：兒婦；下同）行淫。',
    '何4:14 你們的女兒淫亂，你們的新婦行淫，我卻不懲罰他們；因為你們自己離群與娼妓同居，與妓女一同獻祭。這無知的民必致傾倒。',
    '何4:15 以色列啊，你雖然行淫，猶大卻不可犯罪。不要往吉甲去，不要上到伯亞文，也不要指著永生的耶和華起誓。',
    '何4:16 以色列倔強，猶如倔強的母牛；現在耶和華要放他們，如同放羊羔在寬闊之地。',
    '何4:17 以法蓮親近偶像，任憑他吧！',
    '何4:18 他們所喝的已經發酸，他們時常行淫，他們的官長最愛羞恥的事。',
    '何4:19 風把他們裹在翅膀裡；他們因所獻的祭必致蒙羞。',
    '何5:1 眾祭司啊，要聽我的話！以色列家啊，要留心聽！王家啊，要側耳而聽！審判要臨到你們，因你們在米斯巴如網羅，在他泊山如鋪張的網。',
    '何5:2 這些悖逆的人肆行殺戮，罪孽極深；我卻斥責他們眾人。',
    '何5:3 以法蓮為我所知；以色列不能向我隱藏。以法蓮哪，現在你行淫了，以色列被玷污了。',
    '何5:4 他們所行的使他們不能歸向神；因有淫心在他們裡面，他們也不認識耶和華。',
    '何5:5 以色列的驕傲當面見證自己。故此，以色列和以法蓮必因自己的罪孽跌倒；猶大也必與他們一同跌倒。',
    '何5:6 他們必牽著牛羊去尋求耶和華，卻尋不見；他已經轉去離開他們。',
    '何5:7 他們向耶和華行事詭詐，生了私子。到了月朔，他們與他們的地業必被吞滅。',
    '何5:8 你們當在基比亞吹角，在拉瑪吹號，在伯亞文吹出大聲，說：便雅憫哪，有仇敵在你後頭！',
    '何5:9 在責罰的日子，以法蓮必變為荒場；我在以色列支派中，指示將來必成的事。',
    '何5:10 猶大的首領如同挪移地界的人，我必將忿怒倒在他們身上，如水一般。',
    '何5:11 以法蓮因樂從人的命令，就受欺壓，被審判壓碎。',
    '何5:12 我使以法蓮如蟲蛀之物，使猶大家如朽爛之木。',
    '何5:13 以法蓮見自己有病，猶大見自己有傷，他們就打發人往亞述去見耶雷布王，他卻不能醫治你們，不能治好你們的傷。',
    '何5:14 我必向以法蓮如獅子，向猶大家如少壯獅子。我必撕裂而去，我要奪去，無人搭救。',
    '何5:15 我要回到原處，等他們自覺有罪（或譯：承認己罪），尋求我面；他們在急難的時候必切切尋求我。',
    '何6:1 來吧，我們歸向耶和華！他撕裂我們，也必醫治；他打傷我們，也必纏裹。',
    '何6:2 過兩天他必使我們甦醒，第三天他必使我們興起，我們就在他面前得以存活。',
    '何6:3 我們務要認識耶和華，竭力追求認識他。他出現確如晨光；他必臨到我們像甘雨，像滋潤田地的春雨。',
    '何6:4 主說：以法蓮哪，我可向你怎樣行呢﹖猶大啊，我可向你怎樣做呢﹖因為你們的良善如同早晨的雲霧，又如速散的甘露。',
    '何6:5 因此，我藉先知砍伐他們，以我口中的話殺戮他們；我施行的審判如光發出。',
    '何6:6 我喜愛良善（或譯：憐恤），不喜愛祭祀；喜愛認識神，勝於燔祭。',
    '何6:7 他們卻如亞當背約，在境內向我行事詭詐。',
    '何6:8 基列是作孽之人的城，被血沾染。',
    '何6:9 強盜成群，怎樣埋伏殺人，祭司結黨，也照樣在示劍的路上殺戮，行了邪惡。',
    '何6:10 在以色列家，我見了可憎的事；在以法蓮那裡有淫行，以色列被玷污。',
    '何6:11 猶大啊，我使被擄之民歸回的時候，必有為你所命定的收場。',
    '何7:1 我想醫治以色列的時候，以法蓮的罪孽和撒瑪利亞的罪惡就顯露出來。他們行事虛謊，內有賊人入室偷竊，外有強盜成群騷擾。',
    '何7:2 他們心裡並不思想我記念他們的一切惡；他們所行的現在纏繞他們，都在我面前。',
    '何7:3 他們行惡使君王歡喜，說謊使首領喜樂。',
    '何7:4 他們都是行淫的，像火爐被烤餅的燒熱，從摶麵到發麵的時候，暫不使火著旺。',
    '何7:5 在我們王宴樂的日子，首領因酒的烈性成病；王與褻慢人拉手。',
    '何7:6 首領埋伏的時候，心中熱如火爐，就如烤餅的整夜睡臥，到了早晨火氣炎炎。',
    '何7:7 眾民也熱如火爐，燒滅他們的官長。他們的君王都仆倒而死；他們中間無一人求告我。',
    '何7:8 以法蓮與列邦人攙雜；以法蓮是沒有翻過的餅。',
    '何7:9 外邦人吞吃他勞力得來的，他卻不知道；頭髮斑白，他也不覺得。',
    '何7:10 以色列的驕傲當面見證自己，雖遭遇這一切，他們仍不歸向耶和華─他們的神，也不尋求他。',
    '何7:11 以法蓮好像鴿子愚蠢無知；他們求告埃及，投奔亞述。',
    '何7:12 他們去的時候，我必將我的網撒在他們身上；我要打下他們，如同空中的鳥。我必按他們會眾所聽見的懲罰他們。',
    '何7:13 他們因離棄我，必定有禍；因違背我，必被毀滅。我雖要救贖他們，他們卻向我說謊。',
    '何7:14 他們並不誠心哀求我，乃在床上呼號；他們為求五穀新酒聚集，仍然悖逆我。',
    '何7:15 我雖教導他們，堅固他們的膀臂，他們竟圖謀抗拒我。',
    '何7:16 他們歸向，卻不歸向至上者；他們如同翻背的弓。他們的首領必因舌頭的狂傲倒在刀下；這在埃及地必作人的譏笑。',
    '何8:1 你用口吹角吧！敵人如鷹來攻打耶和華的家；因為這民違背我的約，干犯我的律法。',
    '何8:2 他們必呼叫我說：我的神啊，我們以色列認識你了。',
    '何8:3 以色列丟棄良善（或譯：福分）；仇敵必追逼他。',
    '何8:4 他們立君王，卻不由我；他們立首領，我卻不認。他們用金銀為自己製造偶像，以致被剪除。',
    '何8:5 撒瑪利亞啊，耶和華已經丟棄你的牛犢；我的怒氣向拜牛犢的人發作。他們到幾時方能無罪呢﹖',
    '何8:6 這牛犢出於以色列，是匠人所造的，並不是神。撒瑪利亞的牛犢必被打碎。',
    '何8:7 他們所種的是風，所收的是暴風；所種的不成禾稼，就是發苗也不結實；即便結實，外邦人必吞吃。',
    '何8:8 以色列被吞吃；現今在列國中，好像人不喜悅的器皿。',
    '何8:9 他們投奔亞述，如同獨行的野驢；以法蓮賄買朋黨。',
    '何8:10 他們雖在列邦中賄買人，現在我卻要聚集懲罰他們；他們因君王和首領所加的重擔日漸衰微。',
    '何8:11 以法蓮增添祭壇取罪；因此，祭壇使他犯罪。',
    '何8:12 我為他寫了律法萬條，他卻以為與他毫無關涉。',
    '何8:13 至於獻給我的祭物，他們自食其肉，耶和華卻不悅納他們。現在必記念他們的罪孽，追討他們的罪惡；他們必歸回埃及。',
    '何8:14 以色列忘記造他的主，建造宮殿；猶大多造堅固城，我卻要降火焚燒他的城邑，燒滅其中的宮殿。',
    '何9:1 以色列啊，不要像外邦人歡喜快樂；因為你行邪淫離棄你的神，在各穀場上如妓女喜愛賞賜。',
    '何9:2 穀場和酒醡都不夠以色列人使用；新酒也必缺乏。',
    '何9:3 他們必不得住耶和華的地；以法蓮卻要歸回埃及，必在亞述吃不潔淨的食物。',
    '何9:4 他們必不得向耶和華奠酒，即便奠酒也不蒙悅納。他們的祭物必如居喪者的食物，凡吃的必被玷污；因他們的食物只為自己的口腹，必不奉入耶和華的殿。',
    '何9:5 在大會的日子，到耶和華的節期，你們怎樣行呢﹖',
    '何9:6 看哪，他們逃避災難；埃及人必收殮他們的屍首，摩弗人必葬埋他們的骸骨。他們用銀子做的美物上必長蒺藜；他們的帳棚中必生荊棘。',
    '何9:7 以色列人必知道降罰的日子臨近，報應的時候來到。民說：作先知的是愚昧；受靈感的是狂妄，皆因他們多多作孽，大懷怨恨。',
    '何9:8 以法蓮曾作我神守望的；至於先知，在他一切的道上作為捕鳥人的網羅，在他神的家中懷怨恨。',
    '何9:9 以法蓮深深地敗壞，如在基比亞的日子一樣。耶和華必記念他們的罪孽，追討他們的罪惡。',
    '何9:10 主說：我遇見以色列如葡萄在曠野；我看見你們的列祖如無花果樹上春季初熟的果子。他們卻來到巴力毘珥專拜那可羞恥的，就成為可憎惡的，與他們所愛的一樣。',
    '何9:11 至於以法蓮人，他們的榮耀必如鳥飛去，必不生產，不懷胎，不成孕。',
    '何9:12 縱然養大兒女，我卻必使他們喪子，甚至不留一個。我離棄他們，他們就有禍了。',
    '何9:13 我看以法蓮如推羅栽於美地。以法蓮卻要將自己的兒女帶出來，交與行殺戮的人。',
    '何9:14 耶和華啊，求你加給他們─加什麼呢﹖要使他們胎墜乳乾。',
    '何9:15 耶和華說：他們一切的惡事都在吉甲；我在那裡憎惡他們。因他們所行的惡，我必從我地上趕出他們去，不再憐愛他們；他們的首領都是悖逆的。',
    '何9:16 以法蓮受責罰，根本枯乾，必不能結果，即或生產，我必殺他們所生的愛子。',
    '何9:17 我的神必棄絕他們，因為他們不聽從他；他們也必飄流在列國中。',
    '何10:1 以色列是茂盛的葡萄樹，結果繁多。果子越多，就越增添祭壇；地土越肥美，就越造美麗的柱像。',
    '何10:2 他們心懷二意，現今要定為有罪。耶和華必拆毀他們的祭壇，毀壞他們的柱像。',
    '何10:3 他們必說：我們沒有王，因為我們不敬畏耶和華。王能為我們做什麼呢﹖',
    '何10:4 他們為立約說謊言，起假誓；因此，災罰如苦菜滋生在田間的犁溝中。',
    '何10:5 撒瑪利亞的居民必因伯亞文的牛犢驚恐；崇拜牛犢的民和喜愛牛犢的祭司都必因榮耀離開他，為他悲哀。',
    '何10:6 人必將牛犢帶到亞述當作禮物，獻給耶雷布王。以法蓮必蒙羞；以色列必因自己的計謀慚愧。',
    '何10:7 至於撒瑪利亞，他的王必滅沒，如水面的沫子一樣。',
    '何10:8 伯亞文的邱壇─就是以色列取罪的地方必被毀滅；荊棘和蒺藜必長在他們的祭壇上。他們必對大山說：遮蓋我們！對小山說：倒在我們身上！',
    '何10:9 以色列啊，你從基比亞的日子以來時常犯罪。你們的先人曾站在那裡，現今住基比亞的人以為攻擊罪孽之輩的戰事臨不到自己。',
    '何10:10 我必隨意懲罰他們。他們為兩樣的罪所纏；列邦的民必聚集攻擊他們。',
    '何10:11 以法蓮是馴良的母牛犢，喜愛踹穀，我卻將軛加在他肥美的頸項上，我要使以法蓮拉套（或作：被騎）。猶大必耕田；雅各必耙地。',
    '何10:12 你們要為自己栽種公義，就能收割慈愛。現今正是尋求耶和華的時候；你們要開墾荒地，等他臨到，使公義如雨降在你們身上。',
    '何10:13 你們耕種的是奸惡，收割的是罪孽，吃的是謊話的果子。因你倚靠自己的行為，仰賴勇士眾多，',
    '何10:14 所以在這民中必有鬨嚷之聲，你一切的保障必被拆毀，就如沙勒幔在爭戰的日子拆毀伯亞比勒，將其中的母子一同摔死。',
    '何10:15 因他們的大惡，伯特利必使你們遭遇如此。到了黎明，以色列的王必全然滅絕。',
    '何11:1 以色列年幼的時候，我愛他，就從埃及召出我的兒子來。',
    '何11:2 先知越發招呼他們，他們越發走開，向諸巴力獻祭，給雕刻的偶像燒香。',
    '何11:3 我原教導以法蓮行走，用膀臂抱著他們，他們卻不知道是我醫治他們。',
    '何11:4 我用慈繩（慈：原文是人的）愛索牽引他們；我待他們如人放鬆牛的兩腮夾板，把糧食放在他們面前。',
    '何11:5 他們必不歸回埃及地，亞述人卻要作他們的王，因他們不肯歸向我。',
    '何11:6 刀劍必臨到他們的城邑，毀壞門閂，把人吞滅，都因他們隨從自己的計謀。',
    '何11:7 我的民偏要背道離開我；眾先知雖然招呼他們歸向至上的主，卻無人尊崇主。',
    '何11:8 以法蓮哪，我怎能捨棄你﹖以色列啊，我怎能棄絕你﹖我怎能使你如押瑪﹖怎能使你如洗扁﹖我回心轉意，我的憐愛大大發動。',
    '何11:9 我必不發猛烈的怒氣，也不再毀滅以法蓮。因我是神，並非世人，是你們中間的聖者；我必不在怒中臨到你們。',
    '何11:10 耶和華必如獅子吼叫，子民必跟隨他。他一吼叫，他們就從西方急速而來。',
    '何11:11 他們必如雀鳥從埃及急速而來，又如鴿子從亞述地來到。我必使他們住自己的房屋。這是耶和華說的。',
    '何11:12 以法蓮用謊話，以色列家用詭計圍繞我；猶大卻靠神掌權，向聖者有忠心（或譯：猶大向神，向誠實的聖者猶疑不定）。',
    '何12:1 以法蓮吃風，且追趕東風，時常增添虛謊和強暴，與亞述立約，把油送到埃及。',
    '何12:2 耶和華與猶大爭辯，必照雅各所行的懲罰他，按他所做的報應他。',
    '何12:3 他在腹中抓住哥哥的腳跟，壯年的時候與神較力，',
    '何12:4 與天使較力，並且得勝，哭泣懇求，在伯特利遇見耶和華。耶和華─萬軍之神在那裡曉諭我們以色列人；耶和華是他可記念的名。',
    '何12:5 併於上節。',
    '何12:6 所以你當歸向你的神，謹守仁愛、公平，常常等候你的神。',
    '何12:7 以法蓮是商人，手裡有詭詐的天平，愛行欺騙。',
    '何12:8 以法蓮說：我果然成了富足，得了財寶；我所勞碌得來的，人必不見有什麼不義，可算為罪的。',
    '何12:9 自從你出埃及地以來，我就是耶和華─你的神；我必使你再住帳棚，如在大會的日子一樣。',
    '何12:10 我已曉諭眾先知，並且加增默示，藉先知設立比喻。',
    '何12:11 基列人沒有罪孽嗎﹖他們全然是虛假的。人在吉甲獻牛犢為祭，他們的祭壇好像田間犁溝中的亂堆。',
    '何12:12 從前雅各逃到亞蘭地，以色列為得妻服事人，為得妻與人放羊。',
    '何12:13 耶和華藉先知領以色列從埃及上來；以色列也藉先知而得保存。',
    '何12:14 以法蓮大大惹動主怒，所以他流血的罪必歸在他身上。主必將那因以法蓮所受的羞辱歸還他。',
    '何13:1 從前以法蓮說話，人都戰兢，他在以色列中居處高位；但他在事奉巴力的事上犯罪就死了。',
    '何13:2 現今他們罪上加罪，用銀子為自己鑄造偶像，就是照自己的聰明製造，都是匠人的工作。有人論說，獻祭的人可以向牛犢親嘴。',
    '何13:3 因此，他們必如早晨的雲霧，又如速散的甘露，像場上的糠粃被狂風吹去，又像煙氣騰於窗外。',
    '何13:4 自從你出埃及地以來，我就是耶和華─你的神。在我以外，你不可認識別神；除我以外並沒有救主。',
    '何13:5 我曾在曠野乾旱之地認識你。',
    '何13:6 這些民照我所賜的食物得了飽足；既得飽足，心就高傲，忘記了我。',
    '何13:7 因此，我向他們如獅子，又如豹伏在道旁。',
    '何13:8 我遇見他們必像丟崽子的母熊，撕裂他們的胸膛（或譯：心膜）。在那裡，我必像母獅吞吃他們；野獸必撕裂他們。',
    '何13:9 以色列啊，你與我反對，就是反對幫助你的，自取敗壞。',
    '何13:10 你曾求我說：給我立王和首領。現在你的王在哪裡呢﹖治理你的在哪裡呢﹖讓他在你所有的城中拯救你吧！',
    '何13:11 我在怒氣中將王賜你，又在烈怒中將王廢去。',
    '何13:12 以法蓮的罪孽包裹；他的罪惡收藏。',
    '何13:13 產婦的疼痛必臨到他身上；他是無智慧之子，到了產期不當遲延。',
    '何13:14 我必救贖他們脫離陰間，救贖他們脫離死亡。死亡啊，你的災害在哪裡呢﹖陰間哪，你的毀滅在哪裡呢﹖在我眼前絕無後悔之事。',
    '何13:15 他在弟兄中雖然茂盛，必有東風颳來，就是耶和華的風從曠野上來。他的泉源必乾；他的源頭必竭；仇敵必擄掠他所積蓄的一切寶器。',
    '何13:16 撒瑪利亞必擔當自己的罪，因為悖逆他的神。他必倒在刀下；嬰孩必被摔死；孕婦必被剖開。',
    '何14:1 以色列啊，你要歸向耶和華─你的神；你是因自己的罪孽跌倒了。',
    '何14:2 當歸向耶和華，用言語禱告他說：求你除淨罪孽，悅納善行；這樣，我們就把嘴唇的祭代替牛犢獻上。',
    '何14:3 我們不向亞述求救，不騎埃及的馬，也不再對我們手所造的說：你是我們的神。因為孤兒在你─耶和華那裡得蒙憐憫。',
    '何14:4 我必醫治他們背道的病，甘心愛他們；因為我的怒氣向他們轉消。',
    '何14:5 我必向以色列如甘露；他必如百合花開放，如利巴嫩的樹木扎根。',
    '何14:6 他的枝條必延長；他的榮華如橄欖樹；他的香氣如利巴嫩的香柏樹。',
    '何14:7 曾住在他蔭下的必歸回，發旺如五穀，開花如葡萄樹。他的香氣如利巴嫩的酒。',
    '何14:8 以法蓮必說：我與偶像還有什麼關涉呢﹖我─耶和華回答他，也必顧念他。我如青翠的松樹；你的果子從我而得。',
    '何14:9 誰是智慧人，可以明白這些事；誰是通達人，可以知道這一切。因為，耶和華的道是正直的；義人必在其中行走，罪人卻在其上跌倒。',
    '珥1:1 耶和華的話臨到毘土珥的兒子約珥。',
    '珥1:2 老年人哪，當聽我的話；國中的居民哪，都要側耳而聽。在你們的日子，或你們列祖的日子，曾有這樣的事嗎﹖',
    '珥1:3 你們要將這事傳與子，子傳與孫，孫傳與後代。',
    '珥1:4 剪蟲剩下的，蝗蟲來吃；蝗蟲剩下的，蝻子來吃；蝻子剩下的，螞蚱來吃。',
    '珥1:5 酒醉的人哪，要清醒哭泣；好酒的人哪，都要為甜酒哀號，因為從你們的口中斷絕了。',
    '珥1:6 有一隊蝗蟲（原文是民）又強盛又無數，侵犯我的地；他的牙齒如獅子的牙齒，大牙如母獅的大牙。',
    '珥1:7 他毀壞我的葡萄樹，剝了我無花果樹的皮，剝盡而丟棄，使枝條露白。',
    '珥1:8 我的民哪，你當哀號，像處女腰束麻布，為幼年的丈夫哀號。',
    '珥1:9 素祭和奠祭從耶和華的殿中斷絕；事奉耶和華的祭司都悲哀。',
    '珥1:10 田荒涼，地悲哀；因為五穀毀壞，新酒乾竭，油也缺乏。',
    '珥1:11 農夫啊，你們要慚愧；修理葡萄園的啊，你們要哀號；因為大麥小麥與田間的莊稼都滅絕了。',
    '珥1:12 葡萄樹枯乾；無花果樹衰殘。石榴樹、棕樹、蘋果樹，連田野一切的樹木也都枯乾；眾人的喜樂盡都消滅。',
    '珥1:13 祭司啊，你們當腰束麻布痛哭；伺候祭壇的啊，你們要哀號；事奉我神的啊，你們要來披上麻布過夜，因為素祭和奠祭從你們神的殿中斷絕了。',
    '珥1:14 你們要分定禁食的日子，宣告嚴肅會，招聚長老和國中的一切居民到耶和華─你們神的殿，向耶和華哀求。',
    '珥1:15 哀哉！耶和華的日子臨近了。這日來到，好像毀滅從全能者來到。',
    '珥1:16 糧食不是在我們眼前斷絕了嗎﹖歡喜快樂不是從我們神的殿中止息了嗎﹖',
    '珥1:17 穀種在土塊下朽爛；倉也荒涼，廩也破壞；因為五穀枯乾了。',
    '珥1:18 牲畜哀鳴；牛群混亂，因為無草；羊群也受了困苦。',
    '珥1:19 耶和華啊，我向你求告，因為火燒滅曠野的草場；火焰燒盡田野的樹木。',
    '珥1:20 田野的走獸向你發喘；因為溪水乾涸，火也燒滅曠野的草場。',
    '珥2:1 你們要在錫安吹角，在我聖山吹出大聲。國中的居民都要發顫；因為耶和華的日子將到，已經臨近。',
    '珥2:2 那日是黑暗、幽冥、密雲、烏黑的日子，好像晨光鋪滿山嶺。有一隊蝗蟲（原文是民）又大又強；從來沒有這樣的，以後直到萬代也必沒有。',
    '珥2:3 他們前面如火燒滅，後面如火焰燒盡。未到以前，地如伊甸園；過去以後，成了荒涼的曠野；沒有一樣能躲避他們的。',
    '珥2:4 他們的形狀如馬，奔跑如馬兵。',
    '珥2:5 在山頂蹦跳的響聲如車輛的響聲，又如火焰燒碎稭的響聲，好像強盛的民擺陣預備打仗。',
    '珥2:6 他們一來，眾民傷慟，臉都變色。',
    '珥2:7 他們如勇士奔跑，像戰士爬城；各都步行，不亂隊伍。',
    '珥2:8 彼此並不擁擠，向前各行其路，直闖兵器，不偏左右。',
    '珥2:9 他們蹦上城，躥上牆，爬上房屋，進入窗戶如同盜賊。',
    '珥2:10 他們一來，地震天動，日月昏暗，星宿無光。',
    '珥2:11 耶和華在他軍旅前發聲，他的隊伍甚大；成就他命的是強盛者。因為耶和華的日子大而可畏，誰能當得起呢﹖',
    '珥2:12 耶和華說：雖然如此，你們應當禁食、哭泣、悲哀，一心歸向我。',
    '珥2:13 你們要撕裂心腸，不撕裂衣服。歸向耶和華─你們的神；因為他有恩典，有憐憫，不輕易發怒，有豐盛的慈愛，並且後悔不降所說的災。',
    '珥2:14 或者他轉意後悔，留下餘福，就是留下獻給耶和華─你們神的素祭和奠祭，也未可知。',
    '珥2:15 你們要在錫安吹角，分定禁食的日子，宣告嚴肅會。',
    '珥2:16 聚集眾民，使會眾自潔：招聚老者，聚集孩童和吃奶的；使新郎出離洞房，新婦出離內室。',
    '珥2:17 事奉耶和華的祭司要在廊子和祭壇中間哭泣，說：耶和華啊，求你顧惜你的百姓，不要使你的產業受羞辱，列邦管轄他們。為何容列國的人說：他們的神在哪裡呢﹖',
    '珥2:18 耶和華就為自己的地發熱心，憐恤他的百姓。',
    '珥2:19 耶和華應允他的百姓說：我必賜給你們五穀、新酒，和油，使你們飽足；我也不再使你們受列國的羞辱；',
    '珥2:20 卻要使北方來的軍隊遠離你們，將他們趕到乾旱荒廢之地：前隊趕入東海，後隊趕入西海；因為他們所行的大惡（原文是事），臭氣上升，腥味騰空。',
    '珥2:21 地土啊，不要懼怕；要歡喜快樂，因為耶和華行了大事。',
    '珥2:22 田野的走獸啊，不要懼怕；因為，曠野的草發生，樹木結果，無花果樹、葡萄樹也都效力。',
    '珥2:23 錫安的民哪，你們要快樂，為耶和華─你們的神歡喜；因他賜給你們合宜的秋雨，為你們降下甘霖，就是秋雨、春雨，和先前一樣。',
    '珥2:24 禾場必滿了麥子；酒醡與油醡必有新酒和油盈溢。',
    '珥2:25 我打發到你們中間的大軍隊，就是蝗蟲、蝻子、螞蚱、剪蟲，那些年所吃的，我要補還你們。',
    '珥2:26 你們必多吃而得飽足，就讚美為你們行奇妙事之耶和華─你們神的名。我的百姓必永遠不致羞愧。',
    '珥2:27 你們必知道我是在以色列中間，又知道我是耶和華─你們的神；在我以外並無別神。我的百姓必永遠不致羞愧。',
    '珥2:28 以後，我要將我的靈澆灌凡有血氣的。你們的兒女要說預言；你們的老年人要做異夢，少年人要見異象。',
    '珥2:29 在那些日子，我要將我的靈澆灌我的僕人和使女。',
    '珥2:30 在天上地下，我要顯出奇事，有血，有火，有煙柱。',
    '珥2:31 日頭要變為黑暗，月亮要變為血，這都在耶和華大而可畏的日子未到以前。',
    '珥2:32 到那時候，凡求告耶和華名的就必得救；因為照耶和華所說的，在錫安山，耶路撒冷必有逃脫的人，在剩下的人中必有耶和華所召的。',
    '珥3:1 到那日，我使猶大和耶路撒冷被擄之人歸回的時候，',
    '珥3:2 我要聚集萬民，帶他們下到約沙法谷，在那裡施行審判；因為他們將我的百姓，就是我的產業以色列，分散在列國中，又分取我的地土，',
    '珥3:3 且為我的百姓拈鬮，將童子換妓女，賣童女買酒喝。',
    '珥3:4 推羅、西頓，和非利士四境的人哪，你們與我何干﹖你們要報復我嗎﹖若報復我，我必使報應速速歸到你們的頭上。',
    '珥3:5 你們既然奪取我的金銀，又將我可愛的寶物帶入你們宮殿（或譯：廟中），',
    '珥3:6 並將猶大人和耶路撒冷人賣給希利尼人（原文是雅完人），使他們遠離自己的境界。',
    '珥3:7 我必激動他們離開你們所賣到之地，又必使報應歸到你們的頭上。',
    '珥3:8 我必將你們的兒女賣在猶大人的手中，他們必賣給遠方示巴國的人。這是耶和華說的。',
    '珥3:9 當在萬民中宣告說：要預備打仗；激動勇士，使一切戰士上前來。',
    '珥3:10 要將犁頭打成刀劍，將鐮刀打成戈矛；軟弱的要說：我有勇力。',
    '珥3:11 四圍的列國啊，你們要速速地來，一同聚集。耶和華啊，求你使你的大能者降臨。',
    '珥3:12 萬民都當興起，上到約沙法谷；因為我必坐在那裡，審判四圍的列國。',
    '珥3:13 開鐮吧！因為莊稼熟了；踐踏吧！因為酒醡滿了。酒池盈溢；他們的罪惡甚大。',
    '珥3:14 許多許多的人在斷定谷，因為耶和華的日子臨近斷定谷。',
    '珥3:15 日月昏暗，星宿無光。',
    '珥3:16 耶和華必從錫安吼叫，從耶路撒冷發聲，天地就震動。耶和華卻要作他百姓的避難所，作以色列人的保障。',
    '珥3:17 你們就知道我是耶和華─你們的神，且又住在錫安─我的聖山。那時，耶路撒冷必成為聖；外邦人不再從其中經過。',
    '珥3:18 到那日，大山要滴甜酒；小山要流奶子；猶大溪河都有水流。必有泉源從耶和華的殿中流出來，滋潤什亭谷。',
    '珥3:19 埃及必然荒涼，以東變為悽涼的曠野，都因向猶大人所行的強暴，又因在本地流無辜人的血。',
    '珥3:20 但猶大必存到永遠；耶路撒冷必存到萬代。',
    '珥3:21 我未曾報復（或譯：洗除；下同）流血的罪，現在我要報復，因為耶和華住在錫安。',
    '摩1:1 當猶大王烏西雅，以色列王約阿施的兒子耶羅波安在位的時候，大地震前二年，提哥亞牧人中的阿摩司得默示論以色列。',
    '摩1:2 他說：耶和華必從錫安吼叫，從耶路撒冷發聲；牧人的草場要悲哀；迦密的山頂要枯乾。',
    '摩1:3 耶和華如此說：大馬色三番四次地犯罪，我必不免去他的刑罰；因為他以打糧食的鐵器打過基列。',
    '摩1:4 我卻要降火在哈薛的家中，燒滅便哈達的宮殿。',
    '摩1:5 我必折斷大馬色的門閂，剪除亞文平原的居民和伯伊甸掌權的。亞蘭人必被擄到吉珥。這是耶和華說的。',
    '摩1:6 耶和華如此說：迦薩三番四次地犯罪，我必不免去他的刑罰；因為他擄掠眾民交給以東。',
    '摩1:7 我卻要降火在迦薩的城內，燒滅其中的宮殿。',
    '摩1:8 我必剪除亞實突的居民和亞實基倫掌權的，也必反手攻擊以革倫。非利士人所餘剩的必都滅亡。這是主耶和華說的。',
    '摩1:9 耶和華如此說：推羅三番四次地犯罪，我必不免去他的刑罰；因為他將眾民交給以東，並不記念弟兄的盟約。',
    '摩1:10 我卻要降火在推羅的城內，燒滅其中的宮殿。',
    '摩1:11 耶和華如此說：以東三番四次地犯罪，我必不免去他的刑罰；因為他拿刀追趕兄弟，毫無憐憫，發怒撕裂，永懷忿怒。',
    '摩1:12 我卻要降火在提幔，燒滅波斯拉的宮殿。',
    '摩1:13 耶和華如此說：亞捫人三番四次地犯罪，我必不免去他們的刑罰；因為他們剖開基列的孕婦，擴張自己的境界。',
    '摩1:14 我卻要在爭戰吶喊的日子，旋風狂暴的時候，點火在拉巴的城內，燒滅其中的宮殿。',
    '摩1:15 他們的王和首領必一同被擄去。這是耶和華說的。',
    '摩2:1 耶和華如此說：摩押三番四次地犯罪，我必不免去他的刑罰；因為他將以東王的骸骨焚燒成灰。',
    '摩2:2 我卻要降火在摩押，燒滅加略的宮殿。摩押必在鬨嚷吶喊吹角之中死亡。',
    '摩2:3 我必剪除摩押中的審判者，將其中的一切首領和他一同殺戮。這是耶和華說的。',
    '摩2:4 耶和華如此說：猶大人三番四次地犯罪，我必不免去他們的刑罰；因為他們厭棄耶和華的訓誨，不遵守他的律例。他們列祖所隨從虛假的偶像使他們走迷了。',
    '摩2:5 我卻要降火在猶大，燒滅耶路撒冷的宮殿。',
    '摩2:6 耶和華如此說：以色列人三番四次地犯罪，我必不免去他們的刑罰；因他們為銀子賣了義人，為一雙鞋賣了窮人。',
    '摩2:7 他們見窮人頭上所蒙的灰也都垂涎，阻礙謙卑人的道路。父子同一個女子行淫，褻瀆我的聖名。',
    '摩2:8 他們在各壇旁鋪人所當的衣服，臥在其上，又在他們神的廟中喝受罰之人的酒。',
    '摩2:9 我從以色列人面前除滅亞摩利人。他雖高大如香柏樹，堅固如橡樹，我卻上滅他的果子，下絕他的根本。',
    '摩2:10 我也將你們從埃及地領上來，在曠野引導你們四十年，使你們得亞摩利人之地為業。',
    '摩2:11 我從你們子弟中興起先知，又從你們少年人中興起拿細耳人。以色列人哪，不是這樣嗎﹖這是耶和華說的。',
    '摩2:12 你們卻給拿細耳人酒喝，囑咐先知說：不要說預言。',
    '摩2:13 看哪，在你們所住之地，我必壓你們，如同裝滿禾捆的車壓物一樣。',
    '摩2:14 快跑的不能逃脫；有力的不能用力；剛勇的也不能自救。',
    '摩2:15 拿弓的不能站立；腿快的不能逃脫；騎馬的也不能自救。',
    '摩2:16 到那日，勇士中最有膽量的，必赤身逃跑。這是耶和華說的。',
    '摩3:1 以色列人哪，你們全家是我從埃及地領上來的，當聽耶和華攻擊你們的話：',
    '摩3:2 在地上萬族中，我只認識你們；因此，我必追討你們的一切罪孽。',
    '摩3:3 二人若不同心，豈能同行呢﹖',
    '摩3:4 獅子若非抓食，豈能在林中咆哮呢﹖少壯獅子若無所得，豈能從洞中發聲呢﹖',
    '摩3:5 若沒有機檻，雀鳥豈能陷在網羅裡呢﹖網羅若無所得，豈能從地上翻起呢﹖',
    '摩3:6 城中若吹角，百姓豈不驚恐呢﹖災禍若臨到一城，豈非耶和華所降的嗎﹖',
    '摩3:7 主耶和華若不將奧祕指示他的僕人─眾先知，就一無所行。',
    '摩3:8 獅子吼叫，誰不懼怕呢﹖主耶和華發命，誰能不說預言呢﹖',
    '摩3:9 要在亞實突的宮殿中和埃及地的宮殿裡傳揚說：你們要聚集在撒瑪利亞的山上，就看見城中有何等大的擾亂與欺壓的事。',
    '摩3:10 那些以強暴搶奪財物、積蓄在自己家中的人不知道行正直的事。這是耶和華說的。',
    '摩3:11 所以主耶和華如此說：敵人必來圍攻這地，使你的勢力衰微，搶掠你的家宅。',
    '摩3:12 耶和華如此說：牧人怎樣從獅子口中搶回兩條羊腿或半個耳朵，住撒瑪利亞的以色列人躺臥在床角上或鋪繡花毯的榻上，他們得救也不過如此。',
    '摩3:13 主耶和華─萬軍之神說：當聽這話，警戒雅各家。',
    '摩3:14 我討以色列罪的日子，也要討伯特利祭壇的罪；壇角必被砍下，墜落於地。',
    '摩3:15 我要拆毀過冬和過夏的房屋。象牙的房屋也必毀滅；高大的房屋都歸無有。這是耶和華說的。',
    '摩4:1 你們住撒瑪利亞山如巴珊母牛的啊，當聽我的話─你們欺負貧寒的，壓碎窮乏的，對家主說：拿酒來，我們喝吧！',
    '摩4:2 主耶和華指著自己的聖潔起誓說：日子快到，人必用鉤子將你們鉤去，用魚鉤將你們餘剩的鉤去。',
    '摩4:3 你們各人必從破口直往前行，投入哈門。這是耶和華說的。',
    '摩4:4 以色列人哪，任你們往伯特利去犯罪，到吉甲加增罪過；每日早晨獻上你們的祭物，每三日奉上你們的十分之一。',
    '摩4:5 任你們獻有酵的感謝祭，把甘心祭宣傳報告給眾人，因為是你們所喜愛的。這是主耶和華說的。',
    '摩4:6 我使你們在一切城中牙齒乾淨，在你們各處糧食缺乏，你們仍不歸向我。這是耶和華說的。',
    '摩4:7 在收割的前三月，我使雨停止，不降在你們那裡；我降雨在這城，不降雨在那城；這塊地有雨，那塊地無雨；無雨的就枯乾了。',
    '摩4:8 這樣，兩三城的人湊到一城去找水，卻喝不足；你們仍不歸向我。這是耶和華說的。',
    '摩4:9 我以旱風、霉爛攻擊你們，你們園中許多菜蔬、葡萄樹、無花果樹、橄欖樹都被剪蟲所吃；你們仍不歸向我。這是耶和華說的。',
    '摩4:10 我降瘟疫在你們中間，像在埃及一樣；用刀殺戮你們的少年人，使你們的馬匹被擄掠，營中屍首的臭氣撲鼻；你們仍不歸向我。這是耶和華說的。',
    '摩4:11 我傾覆你們中間的城邑，如同我從前傾覆所多瑪、蛾摩拉一樣，使你們好像從火中抽出來的一根柴；你們仍不歸向我。這是耶和華說的。',
    '摩4:12 以色列啊，我必向你如此行；以色列啊，我既這樣行，你當預備迎見你的神。',
    '摩4:13 那創山、造風、將心意指示人、使晨光變為幽暗、腳踏在地之高處的，他的名是耶和華─萬軍之神。',
    '摩5:1 以色列家啊，要聽我為你們所作的哀歌：',
    '摩5:2 以色列民（原文是處女）跌倒，不得再起；躺在地上，無人攙扶。',
    '摩5:3 主耶和華如此說：以色列家的城發出一千兵的，只剩一百；發出一百的，只剩十個。',
    '摩5:4 耶和華向以色列家如此說：你們要尋求我，就必存活。',
    '摩5:5 不要往伯特利尋求，不要進入吉甲，不要過到別是巴；因為吉甲必被擄掠，伯特利也必歸於無有。',
    '摩5:6 要尋求耶和華，就必存活，免得他在約瑟家像火發出，在伯特利焚燒，無人撲滅。',
    '摩5:7 你們這使公平變為茵蔯、將公義丟棄於地的，',
    '摩5:8 要尋求那造昴星和參星，使死蔭變為晨光，使白日變為黑夜，命海水來澆在地上的─耶和華是他的名；',
    '摩5:9 他使力強的忽遭滅亡，以致保障遭遇毀壞。',
    '摩5:10 你們怨恨那在城門口責備人的，憎惡那說正直話的。',
    '摩5:11 你們踐踏貧民，向他們勒索麥子；你們用鑿過的石頭建造房屋，卻不得住在其內；栽種美好的葡萄園，卻不得喝所出的酒。',
    '摩5:12 我知道你們的罪過何等多，你們的罪惡何等大。你們苦待義人，收受賄賂，在城門口屈枉窮乏人。',
    '摩5:13 所以通達人見這樣的時勢必靜默不言，因為時勢真惡。',
    '摩5:14 你們要求善，不要求惡，就必存活。這樣，耶和華─萬軍之神必照你們所說的與你們同在。',
    '摩5:15 要惡惡好善，在城門口秉公行義；或者耶和華─萬軍之神向約瑟的餘民施恩。',
    '摩5:16 主耶和華─萬軍之神如此說：在一切寬闊處必有哀號的聲音；在各街市上必有人說：哀哉！哀哉！又必叫農夫來哭號，叫善唱哀歌的來舉哀。',
    '摩5:17 在各葡萄園必有哀號的聲音，因為我必從你中間經過。這是耶和華說的。',
    '摩5:18 想望耶和華日子來到的有禍了！你們為何想望耶和華的日子呢﹖那日黑暗沒有光明，',
    '摩5:19 景況好像人躲避獅子又遇見熊，或是進房屋以手靠牆，就被蛇咬。',
    '摩5:20 耶和華的日子不是黑暗沒有光明嗎﹖不是幽暗毫無光輝嗎﹖',
    '摩5:21 我厭惡你們的節期，也不喜悅你們的嚴肅會。',
    '摩5:22 你們雖然向我獻燔祭和素祭，我卻不悅納，也不顧你們用肥畜獻的平安祭；',
    '摩5:23 要使你們歌唱的聲音遠離我，因為我不聽你們彈琴的響聲。',
    '摩5:24 惟願公平如大水滾滾，使公義如江河滔滔。',
    '摩5:25 以色列家啊，你們在曠野四十年，豈是將祭物和供物獻給我呢﹖',
    '摩5:26 你們擡著為自己所造之摩洛的帳幕和偶像的龕，並你們的神星。',
    '摩5:27 所以我要把你們擄到大馬色以外。這是耶和華、名為萬軍之神說的。',
    '摩6:1 國為列國之首，人最著名，且為以色列家所歸向，在錫安和撒瑪利亞山安逸無慮的，有禍了！',
    '摩6:2 你們要過到甲尼察看，從那裡往大城哈馬去，又下到非利士人的迦特，看那些國比你們的國還強嗎﹖境界比你們的境界還寬嗎﹖',
    '摩6:3 你們以為降禍的日子還遠，坐在位上盡行強暴（或譯：行強暴使審判臨近）。',
    '摩6:4 你們躺臥在象牙床上，舒身在榻上，吃群中的羊羔，棚裡的牛犢；',
    '摩6:5 彈琴鼓瑟唱消閑的歌曲，為自己製造樂器，如同大衛所造的；',
    '摩6:6 以大碗喝酒，用上等的油抹身，卻不為約瑟的苦難擔憂。',
    '摩6:7 所以這些人必在被擄的人中首先被擄；舒身的人荒宴之樂必消滅了。',
    '摩6:8 主耶和華─萬軍之神指著自己起誓說：我憎惡雅各的榮華，厭棄他的宮殿；因此，我必將城和其中所有的都交付敵人。',
    '摩6:9 那時，若在一房之內剩下十個人，也都必死。',
    '摩6:10 死人的伯叔，就是燒他屍首的，要將這屍首搬到房外，問房屋內間的人說：你那裡還有人沒有﹖他必說：沒有；又說：不要作聲，因為我們不可提耶和華的名。',
    '摩6:11 看哪，耶和華出令，大房就被攻破，小屋就被打裂。',
    '摩6:12 馬豈能在崖石上奔跑﹖人豈能在那裡用牛耕種呢﹖你們卻使公平變為苦膽，使公義的果子變為茵蔯。',
    '摩6:13 你們喜愛虛浮的事，自誇說：我們不是憑自己的力量取了角嗎﹖',
    '摩6:14 耶和華、萬軍之神說：以色列家啊，我必興起一國攻擊你們；他們必欺壓你們，從哈馬口直到亞拉巴的河。',
    '摩7:1 主耶和華指示我一件事：為王割菜（或譯：草）之後，菜又發生；剛發生的時候，主造蝗蟲。',
    '摩7:2 蝗蟲吃盡那地的青物，我就說：主耶和華啊，求你赦免；因為雅各微弱，他怎能站立得住呢﹖',
    '摩7:3 耶和華就後悔說：這災可以免了。',
    '摩7:4 主耶和華又指示我一件事：他命火來懲罰以色列，火就吞滅深淵，險些將地燒滅。',
    '摩7:5 我就說：主耶和華啊，求你止息；因為雅各微弱，他怎能站立得住呢﹖',
    '摩7:6 耶和華就後悔說：這災也可免了。',
    '摩7:7 他又指示我一件事：有一道牆是按準繩建築的，主手拿準繩站在其上。',
    '摩7:8 耶和華對我說：阿摩司啊，你看見什麼﹖我說：看見準繩。主說：我要吊起準繩在我民以色列中，我必不再寬恕他們。',
    '摩7:9 以撒的邱壇必然淒涼，以色列的聖所必然荒廢。我必興起，用刀攻擊耶羅波安的家。',
    '摩7:10 伯特利的祭司亞瑪謝打發人到以色列王耶羅波安那裡，說：阿摩司在以色列家中圖謀背叛你；他所說的一切話，這國擔當不起；',
    '摩7:11 因為阿摩司如此說：耶羅波安必被刀殺，以色列民定被擄去離開本地。',
    '摩7:12 亞瑪謝又對阿摩司說：你這先見哪，要逃往猶大地去，在那裡糊口，在那裡說預言，',
    '摩7:13 卻不要在伯特利再說預言；因為這裡有王的聖所，有王的宮殿。',
    '摩7:14 阿摩司對亞瑪謝說：我原不是先知，也不是先知的門徒（原文是兒子）。我是牧人，又是修理桑樹的。',
    '摩7:15 耶和華選召我，使我不跟從羊群，對我說：你去向我民以色列說預言。',
    '摩7:16 亞瑪謝啊，現在你要聽耶和華的話。你說：不要向以色列說預言，也不要向以撒家滴下預言。',
    '摩7:17 所以耶和華如此說：你的妻子必在城中作妓女，你的兒女必倒在刀下；你的地必有人用繩子量了分取，你自己必死在污穢之地。以色列民定被擄去離開本地。',
    '摩8:1 主耶和華又指示我一件事：我看見一筐夏天的果子。',
    '摩8:2 他說：阿摩司啊，你看見什麼﹖我說：看見一筐夏天的果子。耶和華說：我民以色列的結局到了，我必不再寬恕他們。',
    '摩8:3 主耶和華說：那日，殿中的詩歌變為哀號；必有許多屍首在各處拋棄，無人作聲。',
    '摩8:4 你們這些要吞吃窮乏人、使困苦人衰敗的，當聽我的話！',
    '摩8:5 你們說：月朔幾時過去，我們好賣糧；安息日幾時過去，我們好擺開麥子；賣出用小升斗，收銀用大戥子，用詭詐的天平欺哄人，',
    '摩8:6 好用銀子買貧寒人，用一雙鞋換窮乏人，將壞了的麥子賣給人。',
    '摩8:7 耶和華指著雅各的榮耀起誓說：他們的一切行為，我必永遠不忘。',
    '摩8:8 地豈不因這事震動﹖其上的居民不也悲哀嗎﹖地必全然像尼羅河漲起，如同埃及河湧上落下。',
    '摩8:9 主耶和華說：到那日，我必使日頭在午間落下，使地在白晝黑暗。',
    '摩8:10 我必使你們的節期變為悲哀，歌曲變為哀歌。眾人腰束麻布，頭上光禿，使這場悲哀如喪獨生子，至終如痛苦的日子一樣。',
    '摩8:11 主耶和華說：日子將到，我必命饑荒降在地上。人飢餓非因無餅，乾渴非因無水，乃因不聽耶和華的話。',
    '摩8:12 他們必飄流，從這海到那海，從北邊到東邊，往來奔跑，尋求耶和華的話，卻尋不著。',
    '摩8:13 當那日，美貌的處女和少年的男子必因乾渴發昏。',
    '摩8:14 那指著撒瑪利亞牛犢（原文是罪）起誓的說：但哪，我們指著你那裡的活神起誓；又說：我們指著別是巴的神道（神：原文是活）起誓。這些人都必仆倒，永不再起來。',
    '摩9:1 我看見主站在祭壇旁邊；他說：你要擊打柱頂，使門檻震動，打碎柱頂，落在眾人頭上；所剩下的人，我必用刀殺戮，無一人能逃避，無一人能逃脫。',
    '摩9:2 他們雖然挖透陰間，我的手必取出他們來；雖然爬上天去，我必拿下他們來；',
    '摩9:3 雖然藏在迦密山頂，我必搜尋，捉出他們來；雖然從我眼前藏在海底，我必命蛇咬他們；',
    '摩9:4 雖被仇敵擄去，我必命刀劍殺戮他們；我必向他們定住眼目，降禍不降福。',
    '摩9:5 主─萬軍之耶和華摸地，地就消化，凡住在地上的都必悲哀。地必全然像尼羅河漲起，如同埃及河落下。',
    '摩9:6 那在天上建造樓閣、在地上安定穹蒼、命海水澆在地上的─耶和華是他的名。',
    '摩9:7 耶和華說：以色列人哪，我豈不看你們如古實人嗎﹖我豈不是領以色列人出埃及地，領非利士人出迦斐託，領亞蘭人出吉珥嗎﹖',
    '摩9:8 主耶和華的眼目察看這有罪的國，必將這國從地上滅絕，卻不將雅各家滅絕淨盡。這是耶和華說的。',
    '摩9:9 我必出令，將以色列家分散在列國中，好像用篩子篩穀，連一粒也不落在地上。',
    '摩9:10 我民中的一切罪人說：災禍必追不上我們，也迎不著我們。他們必死在刀下。',
    '摩9:11 到那日，我必建立大衛倒塌的帳幕，堵住其中的破口，把那破壞的建立起來，重新修造，像古時一樣，',
    '摩9:12 使以色列人得以東所餘剩的和所有稱為我名下的國。此乃行這事的耶和華說的。',
    '摩9:13 耶和華說：日子將到，耕種的必接續收割的；踹葡萄的必接續撒種的；大山要滴下甜酒；小山都必流奶（原文是消化，見約珥三章十八節）。',
    '摩9:14 我必使我民以色列被擄的歸回；他們必重修荒廢的城邑居住，栽種葡萄園，喝其中所出的酒，修造果木園，吃其中的果子。',
    '摩9:15 我要將他們栽於本地，他們不再從我所賜給他們的地上拔出來。這是耶和華─你的神說的。',
    '俄1:1 俄巴底亞得了耶和華的默示。論以東說：我從耶和華那裡聽見信息，並有使者被差往列國去，說：起來吧，一同起來與以東爭戰！',
    '俄1:2 我使你─以東在列國中為最小的，被人大大藐視。',
    '俄1:3 住在山穴中、居所在高處的啊，你因狂傲自欺，心裡說：誰能將我拉下地去呢﹖',
    '俄1:4 你雖如大鷹高飛，在星宿之間搭窩，我必從那裡拉下你來。這是耶和華說的。',
    '俄1:5 盜賊若來在你那裡，或強盜夜間而來─你何竟被剪除─豈不偷竊直到夠了呢﹖摘葡萄的若來到你那裡，豈不剩下些葡萄呢﹖',
    '俄1:6 以掃的隱密處何竟被搜尋﹖他隱藏的寶物何竟被查出﹖',
    '俄1:7 與你結盟的都送你上路，直到交界；與你和好的欺騙你，且勝過你；與你一同吃飯的設下網羅陷害你；在你心裡毫無聰明。',
    '俄1:8 耶和華說：到那日，我豈不從以東除滅智慧人﹖從以掃山除滅聰明人﹖',
    '俄1:9 提幔哪，你的勇士必驚惶，甚至以掃山的人都被殺戮剪除。',
    '俄1:10 因你向兄弟雅各行強暴，羞愧必遮蓋你，你也必永遠斷絕。',
    '俄1:11 當外人擄掠雅各的財物，外邦人進入他的城門，為耶路撒冷拈鬮的日子，你竟站在一旁，像與他們同夥。',
    '俄1:12 你兄弟遭難的日子，你不當瞪眼看著；猶大人被滅的日子，你不當因此歡樂；他們遭難的日子，你不當說狂傲的話。',
    '俄1:13 我民遭災的日子，你不當進他們的城門；他們遭災的日子，你不當瞪眼看著他們受苦；他們遭災的日子，你不當伸手搶他們的財物；',
    '俄1:14 你不當站在岔路口剪除他們中間逃脫的；他們遭難的日子，你不當將他們剩下的人交付仇敵。',
    '俄1:15 耶和華降罰的日子臨近萬國。你怎樣行，他也必照樣向你行；你的報應必歸到你頭上。',
    '俄1:16 你們猶大人在我聖山怎樣喝了苦杯，萬國也必照樣常常地喝；且喝且咽，他們就歸於無有。',
    '俄1:17 在錫安山必有逃脫的人，那山也必成聖；雅各家必得原有的產業。',
    '俄1:18 雅各家必成為大火；約瑟家必為火焰；以掃家必如碎稭；火必將他燒著吞滅。以掃家必無餘剩的。這是耶和華說的。',
    '俄1:19 南地的人必得以掃山；高原的人必得非利士地，也得以法蓮地和撒瑪利亞地；便雅憫人必得基列。',
    '俄1:20 在迦南人中被擄的以色列眾人必得地直到撒勒法；在西法拉中被擄的耶路撒冷人必得南地的城邑。',
    '俄1:21 必有拯救者上到錫安山，審判以掃山；國度就歸耶和華了。',
    '拿1:1 耶和華的話臨到亞米太的兒子約拿，說：',
    '拿1:2 你起來往尼尼微大城去，向其中的居民呼喊，因為他們的惡達到我面前。',
    '拿1:3 約拿卻起來，逃往他施去躲避耶和華；下到約帕，遇見一隻船，要往他施去。他就給了船價，上了船，要與船上的人同往他施去躲避耶和華。',
    '拿1:4 然而耶和華使海中起大風，海就狂風大作，甚至船幾乎破壞。',
    '拿1:5 水手便懼怕，各人哀求自己的神。他們將船上的貨物拋在海中，為要使船輕些。約拿已下到底艙，躺臥沉睡。',
    '拿1:6 船主到他那裡對他說：你這沉睡的人哪，為何這樣呢﹖起來，求告你的神，或者神顧念我們，使我們不致滅亡。',
    '拿1:7 船上的人彼此說：來吧，我們掣籤，看看這災臨到我們是因誰的緣故。於是他們掣籤，掣出約拿來。',
    '拿1:8 眾人對他說：請你告訴我們，這災臨到我們是因誰的緣故﹖你以何事為業﹖你從哪裡來﹖你是哪一國﹖屬哪一族的人﹖',
    '拿1:9 他說：我是希伯來人。我敬畏耶和華─那創造滄海旱地之天上的神。',
    '拿1:10 他們就大大懼怕，對他說：你做的是什麼事呢﹖他們已經知道他躲避耶和華，因為他告訴了他們。',
    '拿1:11 他們問他說：我們當向你怎樣行，使海浪平靜呢﹖這話是因海浪越發翻騰。',
    '拿1:12 他對他們說：你們將我擡起來，拋在海中，海就平靜了；我知道你們遭這大風是因我的緣故。',
    '拿1:13 然而那些人竭力盪槳，要把船攏岸，卻是不能，因為海浪越發向他們翻騰。',
    '拿1:14 他們便求告耶和華說：耶和華啊，我們懇求你，不要因這人的性命使我們死亡，不要使流無辜血的罪歸與我們；因為你─耶和華是隨自己的意旨行事。',
    '拿1:15 他們遂將約拿擡起，拋在海中，海的狂浪就平息了。',
    '拿1:16 那些人便大大敬畏耶和華，向耶和華獻祭，並且許願。',
    '拿1:17 耶和華安排一條大魚吞了約拿，他在魚腹中三日三夜。',
    '拿2:1 約拿在魚腹中禱告耶和華─他的神，',
    '拿2:2 說：我遭遇患難求告耶和華，你就應允我；從陰間的深處呼求，你就俯聽我的聲音。',
    '拿2:3 你將我投下深淵，就是海的深處；大水環繞我，你的波浪洪濤都漫過我身。',
    '拿2:4 我說：我從你眼前雖被驅逐，我仍要仰望你的聖殿。',
    '拿2:5 諸水環繞我，幾乎淹沒我；深淵圍住我；海草纏繞我的頭。',
    '拿2:6 我下到山根，地的門將我永遠關住。耶和華─我的神啊，你卻將我的性命從坑中救出來。',
    '拿2:7 我心在我裡面發昏的時候，我就想念耶和華。我的禱告進入你的聖殿，達到你的面前。',
    '拿2:8 那信奉虛無之神的人，離棄憐愛他們的主；',
    '拿2:9 但我必用感謝的聲音獻祭與你。我所許的願，我必償還。救恩出於耶和華。',
    '拿2:10 耶和華吩咐魚，魚就把約拿吐在旱地上。',
    '拿3:1 耶和華的話二次臨到約拿說：',
    '拿3:2 你起來！往尼尼微大城去，向其中的居民宣告我所吩咐你的話。',
    '拿3:3 約拿便照耶和華的話起來，往尼尼微去。這尼尼微是極大的城，有三日的路程。',
    '拿3:4 約拿進城走了一日，宣告說：再等四十日，尼尼微必傾覆了！',
    '拿3:5 尼尼微人信服神，便宣告禁食，從最大的到至小的都穿麻衣（或譯：披上麻布）。',
    '拿3:6 這信息傳到尼尼微王的耳中，他就下了寶座，脫下朝服，披上麻布，坐在灰中。',
    '拿3:7 他又使人遍告尼尼微通城，說：王和大臣有令，人不可嘗什麼，牲畜、牛羊不可吃草，也不可喝水。',
    '拿3:8 人與牲畜都當披上麻布；人要切切求告神。各人回頭離開所行的惡道，丟棄手中的強暴。',
    '拿3:9 或者神轉意後悔，不發烈怒，使我們不致滅亡，也未可知。',
    '拿3:10 於是神察看他們的行為，見他們離開惡道，他就後悔，不把所說的災禍降與他們了。',
    '拿4:1 這事約拿大大不悅，且甚發怒，',
    '拿4:2 就禱告耶和華說：耶和華啊，我在本國的時候豈不是這樣說嗎﹖我知道你是有恩典、有憐憫的神，不輕易發怒，有豐盛的慈愛，並且後悔不降所說的災，所以我急速逃往他施去。',
    '拿4:3 耶和華啊，現在求你取我的命吧！因為我死了比活著還好。',
    '拿4:4 耶和華說：你這樣發怒合乎理嗎﹖',
    '拿4:5 於是約拿出城，坐在城的東邊，在那裡為自己搭了一座棚，坐在棚的蔭下，要看看那城究竟如何。',
    '拿4:6 耶和華神安排一棵蓖麻，使其發生高過約拿，影兒遮蓋他的頭，救他脫離苦楚；約拿因這棵蓖麻大大喜樂。',
    '拿4:7 次日黎明，神卻安排一條蟲子咬這蓖麻，以致枯槁。',
    '拿4:8 日頭出來的時候，神安排炎熱的東風，日頭曝曬約拿的頭，使他發昏，他就為自己求死，說：我死了比活著還好！',
    '拿4:9 神對約拿說：你因這棵蓖麻發怒合乎理嗎﹖他說：我發怒以至於死，都合乎理！',
    '拿4:10 耶和華說：這蓖麻不是你栽種的，也不是你培養的；一夜發生，一夜乾死，你尚且愛惜；',
    '拿4:11 何況這尼尼微大城，其中不能分辨左手右手的有十二萬多人，並有許多牲畜，我豈能不愛惜呢﹖',
    '彌1:1 當猶大王約坦、亞哈斯、希西家在位的時候，摩利沙人彌迦得耶和華的默示，論撒瑪利亞和耶路撒冷。',
    '彌1:2 萬民哪，你們都要聽！地和其上所有的，也都要側耳而聽！主耶和華從他的聖殿要見證你們的不是。',
    '彌1:3 看哪，耶和華出了他的居所，降臨步行地的高處。',
    '彌1:4 眾山在他以下必消化，諸谷必崩裂，如蠟化在火中，如水沖下山坡。',
    '彌1:5 這都因雅各的罪過，以色列家的罪惡。雅各的罪過在哪裡呢﹖豈不是在撒瑪利亞嗎﹖猶大的邱壇在哪裡呢﹖豈不是在耶路撒冷嗎﹖',
    '彌1:6 所以我必使撒瑪利亞變為田野的亂堆，又作為種葡萄之處；也必將他的石頭倒在谷中，露出根基來。',
    '彌1:7 他一切雕刻的偶像必被打碎；他所得的財物必被火燒；所有的偶像我必毀滅；因為是從妓女雇價所聚來的，後必歸為妓女的雇價。',
    '彌1:8 先知說：因此我必大聲哀號，赤腳露體而行；又要呼號如野狗，哀鳴如鴕鳥。',
    '彌1:9 因為撒瑪利亞的傷痕無法醫治，延及猶大和耶路撒冷我民的城門。',
    '彌1:10 不要在迦特報告這事，總不要哭泣；我在伯亞弗拉滾於灰塵之中。',
    '彌1:11 沙斐的居民哪，你們要赤身蒙羞過去。撒南的居民不敢出來。伯以薛人的哀哭使你們無處可站。',
    '彌1:12 瑪律的居民心甚憂急，切望得好處，因為災禍從耶和華那裡臨到耶路撒冷的城門。',
    '彌1:13 拉吉的居民哪，要用快馬套車；錫安民（原文是女子）的罪由你而起；以色列人的罪過在你那裡顯出。',
    '彌1:14 猶大啊，你要將禮物送給摩利設迦特。亞革悉的眾族必用詭詐待以色列諸王。',
    '彌1:15 瑪利沙的居民哪，我必使那奪取你的來到你這裡；以色列的尊貴人（原文是榮耀）必到亞杜蘭。',
    '彌1:16 猶大啊，要為你所喜愛的兒女剪除你的頭髮，使頭光禿，要大大地光禿，如同禿鷹，因為他們都被擄去離開你。',
    '彌2:1 禍哉，那些在床上圖謀罪孽、造作奸惡的！天一發亮，因手有能力就行出來了。',
    '彌2:2 他們貪圖田地就佔據，貪圖房屋便奪取；他們欺壓人，霸佔房屋和產業。',
    '彌2:3 所以耶和華如此說：我籌劃災禍降與這族；這禍在你們的頸項上不能解脫；你們也不能昂首而行，因為這時勢是惡的。',
    '彌2:4 到那日，必有人向你們提起悲慘的哀歌，譏刺說：我們全然敗落了！耶和華將我們的分轉歸別人，何竟使這分離開我們﹖他將我們的田地分給悖逆的人。',
    '彌2:5 所以在耶和華的會中，你必沒有人拈鬮拉準繩。',
    '彌2:6 他們（或譯：假先知）說：你們不可說預言；不可向這些人說預言，不住地羞辱我們。',
    '彌2:7 雅各家啊，豈可說耶和華的心不忍耐嗎（或譯：心腸狹窄嗎）﹖這些事是他所行的嗎﹖我─耶和華的言語豈不是於行動正直的人有益嗎﹖',
    '彌2:8 然而，近來我的民興起如仇敵，從那些安然經過不願打仗之人身上剝去外衣。',
    '彌2:9 你們將我民中的婦人從安樂家中趕出，又將我的榮耀從他們的小孩子盡行奪去。',
    '彌2:10 你們起來去吧！這不是你們安息之所；因為污穢使人（或譯：地）毀滅，而且大大毀滅。',
    '彌2:11 若有人心存虛假，用謊言說：我要向你們預言得清酒和濃酒。那人就必作這民的先知。',
    '彌2:12 雅各家啊，我必要聚集你們，必要招聚以色列剩下的人，安置在一處，如波斯拉的羊，又如草場上的羊群；因為人數眾多就必大大喧嘩。',
    '彌2:13 開路的（或譯：破城的）在他們前面上去；他們直闖過城門，從城門出去。他們的王在前面行；耶和華引導他們。',
    '彌3:1 我說：雅各的首領，以色列家的官長啊，你們要聽！你們不當知道公平嗎﹖',
    '彌3:2 你們惡善好惡，從人身上剝皮，從人骨頭上剔肉，',
    '彌3:3 吃我民的肉，剝他們的皮，打折他們的骨頭，分成塊子像要下鍋，又像釜中的肉。',
    '彌3:4 到了遭災的時候，這些人必哀求耶和華，他卻不應允他們。那時他必照他們所行的惡事向他們掩面。',
    '彌3:5 論到使我民走差路的先知─他們牙齒有所嚼的，他們就呼喊說：平安了！凡不供給他們吃的，他們就預備攻擊他（預備攻擊他：或譯說必遭遇刀兵）─耶和華如此說：',
    '彌3:6 你們必遭遇黑夜，以致不見異象；又必遭遇幽暗，以致不能占卜。日頭必向你們沉落，白晝變為黑暗。',
    '彌3:7 先見必抱愧，占卜的必蒙羞，都必摀著嘴唇，因為神不應允他們。',
    '彌3:8 至於我，我藉耶和華的靈，滿有力量、公平、才能，可以向雅各說明他的過犯，向以色列指出他的罪惡。',
    '彌3:9 雅各家的首領、以色列家的官長啊，當聽我的話！你們厭惡公平，在一切事上屈枉正直；',
    '彌3:10 以人血建立錫安，以罪孽建造耶路撒冷。',
    '彌3:11 首領為賄賂行審判；祭司為雇價施訓誨；先知為銀錢行占卜。他們卻倚賴耶和華，說：耶和華不是在我們中間嗎﹖災禍必不臨到我們。',
    '彌3:12 所以因你們的緣故，錫安必被耕種像一塊田，耶路撒冷必變為亂堆；這殿的山必像叢林的高處。',
    '彌4:1 末後的日子，耶和華殿的山必堅立，超乎諸山，高舉過於萬嶺；萬民都要流歸這山。',
    '彌4:2 必有許多國的民前往，說：來吧，我們登耶和華的山，奔雅各神的殿。主必將他的道教訓我們；我們也要行他的路。因為訓誨必出於錫安；耶和華的言語必出於耶路撒冷。',
    '彌4:3 他必在多國的民中施行審判，為遠方強盛的國斷定是非。他們要將刀打成犁頭，把槍打成鐮刀。這國不舉刀攻擊那國；他們也不再學習戰事。',
    '彌4:4 人人都要坐在自己葡萄樹下和無花果樹下，無人驚嚇。這是萬軍之耶和華親口說的。',
    '彌4:5 萬民各奉己神的名而行；我們卻永永遠遠奉耶和華─我們神的名而行。',
    '彌4:6 耶和華說：到那日，我必聚集瘸腿的，招聚被趕出的和我所懲治的。',
    '彌4:7 我必使瘸腿的為餘剩之民，使趕到遠方的為強盛之民。耶和華要在錫安山作王治理他們，從今直到永遠。',
    '彌4:8 你這羊群的高臺、錫安城（原文是女子）的山哪，從前的權柄─就是耶路撒冷民（原文是女子）的國權─必歸與你。',
    '彌4:9 現在你為何大聲哭號呢﹖疼痛抓住你彷彿產難的婦人，是因你中間沒有君王嗎﹖你的謀士滅亡了嗎﹖',
    '彌4:10 錫安的民（原文是女子）哪，你要疼痛劬勞，彷彿產難的婦人；因為你必從城裡出來，住在田野，到巴比倫去。在那裡要蒙解救；在那裡耶和華必救贖你脫離仇敵的手。',
    '彌4:11 現在有許多國的民聚集攻擊你，說：願錫安被玷污！願我們親眼見他遭報！',
    '彌4:12 他們卻不知道耶和華的意念，也不明白他的籌劃。他聚集他們，好像把禾捆聚到禾場一樣。',
    '彌4:13 錫安的民（原文作女子）哪，起來踹穀吧！我必使你的角成為鐵，使你的蹄成為銅。你必打碎多國的民，將他們的財獻與耶和華，將他們的貨獻與普天下的主。',
    '彌5:1 成群的民（原文是女子）哪，現在你要聚集成隊；因為仇敵圍攻我們，要用杖擊打以色列審判者的臉。',
    '彌5:2 伯利恆、以法他啊，你在猶大諸城中為小，將來必有一位從你那裡出來，在以色列中為我作掌權的；他的根源從亙古，從太初就有。',
    '彌5:3 耶和華必將以色列人交付敵人，直等那生產的婦人生下子來。那時掌權者（原文是他）其餘的弟兄必歸到以色列人那裡。',
    '彌5:4 他必起來，倚靠耶和華的大能，並耶和華─他神之名的威嚴，牧養他的羊群。他們要安然居住；因為他必日見尊大，直到地極。',
    '彌5:5 這位必作我們的平安。當亞述人進入我們的地境，踐踏宮殿的時候，我們就立起七個牧者，八個首領攻擊他。',
    '彌5:6 他們必用刀劍毀壞亞述地和寧錄地的關口。亞述人進入我們的地境踐踏的時候，他必拯救我們。',
    '彌5:7 雅各餘剩的人必在多國的民中，如從耶和華那裡降下的露水，又如甘霖降在草上；不仗賴人力，也不等候世人之功。',
    '彌5:8 雅各餘剩的人必在多國多民中，如林間百獸中的獅子，又如少壯獅子在羊群中。他若經過就必踐踏撕裂，無人搭救。',
    '彌5:9 願你的手舉起，高過敵人！願你的仇敵都被剪除！',
    '彌5:10 耶和華說：到那日，我必從你中間剪除馬匹，毀壞車輛，',
    '彌5:11 也必從你國中除滅城邑，拆毀一切的保障，',
    '彌5:12 又必除掉你手中的邪術；你那裡也不再有占卜的。',
    '彌5:13 我必從你中間除滅雕刻的偶像和柱像，你就不再跪拜自己手所造的。',
    '彌5:14 我必從你中間拔出木偶，又毀滅你的城邑。',
    '彌5:15 我也必在怒氣和忿怒中向那不聽從的列國施報。',
    '彌6:1 以色列人哪，當聽耶和華的話！要起來向山嶺爭辯，使岡陵聽你的話。',
    '彌6:2 山嶺和地永久的根基啊，要聽耶和華爭辯的話！因為耶和華要與他的百姓爭辯，與以色列爭論。',
    '彌6:3 我的百姓啊，我向你做了什麼呢﹖我在什麼事上使你厭煩﹖你可以對我證明。',
    '彌6:4 我曾將你從埃及地領出來，從作奴僕之家救贖你；我也差遣摩西、亞倫，和米利暗在你前面行。',
    '彌6:5 我的百姓啊，你們當追念摩押王巴勒所設的謀和比珥的兒子巴蘭回答他的話，並你們從什亭到吉甲所遇見的事，好使你們知道耶和華公義的作為。',
    '彌6:6 我朝見耶和華，在至高神面前跪拜，當獻上什麼呢﹖豈可獻一歲的牛犢為燔祭嗎﹖',
    '彌6:7 耶和華豈喜悅千千的公羊，或是萬萬的油河嗎﹖我豈可為自己的罪過獻我的長子嗎﹖為心中的罪惡獻我身所生的嗎﹖',
    '彌6:8 世人哪，耶和華已指示你何為善。他向你所要的是什麼呢﹖只要你行公義，好憐憫，存謙卑的心，與你的神同行。',
    '彌6:9 耶和華向這城呼叫，智慧人必敬畏他的名。你們當聽是誰派定刑杖的懲罰。',
    '彌6:10 惡人家中不仍有非義之財和可惡的小升斗嗎﹖',
    '彌6:11 我若用不公道的天平和囊中詭詐的法碼，豈可算為清潔呢﹖',
    '彌6:12 城裡的富戶滿行強暴；其中的居民也說謊言，口中的舌頭是詭詐的。',
    '彌6:13 因此，我擊打你，使你的傷痕甚重，使你因你的罪惡荒涼。',
    '彌6:14 你要吃，卻吃不飽；你的虛弱必顯在你中間。你必挪去，卻不得救護；所救護的，我必交給刀劍。',
    '彌6:15 你必撒種，卻不得收割；踹橄欖，卻不得油抹身；踹葡萄，卻不得酒喝。',
    '彌6:16 因為你守暗利的惡規，行亞哈家一切所行的，順從他們的計謀；因此，我必使你荒涼，使你的居民令人嗤笑，你們也必擔當我民的羞辱。',
    '彌7:1 哀哉！我（或譯：以色列）好像夏天的果子已被收盡，又像摘了葡萄所剩下的，沒有一掛可吃的；我心羨慕初熟的無花果。',
    '彌7:2 地上虔誠人滅盡；世間沒有正直人；各人埋伏，要殺人流血，都用網羅獵取弟兄。',
    '彌7:3 他們雙手作惡；君王徇情面，審判官要賄賂；位分大的吐出惡意，都彼此結聯行惡。',
    '彌7:4 他們最好的，不過是蒺藜；最正直的，不過是荊棘籬笆。你守望者說，降罰的日子已經來到。他們必擾亂不安。',
    '彌7:5 不要倚賴鄰舍；不要信靠密友。要守住你的口；不要向你懷中的妻提說。',
    '彌7:6 因為，兒子藐視父親；女兒抗拒母親；媳婦抗拒婆婆；人的仇敵就是自己家裡的人。',
    '彌7:7 至於我，我要仰望耶和華，要等候那救我的神；我的神必應允我。',
    '彌7:8 我的仇敵啊，不要向我誇耀。我雖跌倒，卻要起來；我雖坐在黑暗裡，耶和華卻作我的光。',
    '彌7:9 我要忍受耶和華的惱怒；因我得罪了他，直等他為我辨屈，為我伸冤。他必領我到光明中；我必得見他的公義。',
    '彌7:10 那時我的仇敵，就是曾對我說耶和華─你神在哪裡的，他一看見這事就被羞愧遮蓋。我必親眼見他遭報；他必被踐踏，如同街上的泥土。',
    '彌7:11 以色列啊，日子必到，你的牆垣必重修；到那日，你的境界必開展（或譯：命令必傳到遠方）。',
    '彌7:12 當那日，人必從亞述，從埃及的城邑，從埃及到大河，從這海到那海，從這山到那山，都歸到你這裡。',
    '彌7:13 然而，這地因居民的緣故，又因他們行事的結果，必然荒涼。',
    '彌7:14 求耶和華在迦密山的樹林中，用你的杖牧放你獨居的民，就是你產業的羊群。求你容他們在巴珊和基列得食物，像古時一樣。',
    '彌7:15 耶和華說：我要把奇事顯給他們看，好像出埃及地的時候一樣。',
    '彌7:16 列國看見這事就必為自己的勢力慚愧；他們必用手摀口，掩耳不聽。',
    '彌7:17 他們必舔土如蛇，又如土中腹行的物，戰戰兢兢地出他們的營寨。他們必戰懼投降耶和華，也必因我們的神而懼怕。',
    '彌7:18 神啊，有何神像你，赦免罪孽，饒恕你產業之餘民的罪過，不永遠懷怒，喜愛施恩﹖',
    '彌7:19 必再憐憫我們，將我們的罪孽踏在腳下，又將我們的一切罪投於深海。',
    '彌7:20 你必按古時起誓應許我們列祖的話，向雅各發誠實，向亞伯拉罕施慈愛。',
    '鴻1:1 論尼尼微的默示，就是伊勒歌斯人那鴻所得的默示。',
    '鴻1:2 耶和華是忌邪施報的神。耶和華施報大有忿怒；向他的敵人施報，向他的仇敵懷怒。',
    '鴻1:3 耶和華不輕易發怒，大有能力，萬不以有罪的為無罪。他乘旋風和暴風而來，雲彩為他腳下的塵土。',
    '鴻1:4 他斥責海，使海乾了，使一切江河乾涸。巴珊和迦密的樹林衰殘；利巴嫩的花草也衰殘了。',
    '鴻1:5 大山因他震動；小山也都消化。大地在他面前突起；世界和住在其間的也都如此。',
    '鴻1:6 他發忿恨，誰能立得住呢﹖他發烈怒，誰能當得起呢﹖他的忿怒如火傾倒；磐石因他崩裂。',
    '鴻1:7 耶和華本為善，在患難的日子為人的保障，並且認得那些投靠他的人。',
    '鴻1:8 但他必以漲溢的洪水淹沒尼尼微，又驅逐仇敵進入黑暗。',
    '鴻1:9 尼尼微人哪，設何謀攻擊耶和華呢﹖他必將你們滅絕淨盡；災難不再興起。',
    '鴻1:10 你們像叢雜的荊棘，像喝醉了的人，又如枯乾的碎稭全然燒滅。',
    '鴻1:11 有一人從你那裡出來，圖謀邪惡，設惡計攻擊耶和華。',
    '鴻1:12 耶和華如此說：尼尼微雖然勢力充足，人數繁多，也被剪除，歸於無有。猶大啊，我雖然使你受苦，卻不再使你受苦。',
    '鴻1:13 現在我必從你頸項上折斷他的軛，扭開他的繩索。',
    '鴻1:14 耶和華已經出令，指著尼尼微說：你名下的人必不留後；我必從你神的廟中除滅雕刻的偶像和鑄造的偶像；我必因你鄙陋，使你歸於墳墓。',
    '鴻1:15 看哪，有報好信傳平安之人的腳登山，說：猶大啊，可以守你的節期，還你所許的願吧！因為那惡人不再從你中間經過，他已滅絕淨盡了。',
    '鴻2:1 尼尼微啊，那打碎邦國的上來攻擊你。你要看守保障，謹防道路，使腰強壯，大大勉力。',
    '鴻2:2 （耶和華復興雅各的榮華，好像以色列的榮華一樣；因為使地空虛的，已經使雅各和以色列空虛，將他們的葡萄枝毀壞了。）',
    '鴻2:3 他勇士的盾牌是紅的，精兵都穿朱紅衣服。在他預備爭戰的日子，戰車上的鋼鐵閃爍如火，柏木把的槍也掄起來了。',
    '鴻2:4 車輛在街上（或譯：城外）急行，在寬闊處奔來奔去，形狀如火把，飛跑如閃電。',
    '鴻2:5 尼尼微王招聚他的貴冑；他們步行絆跌，速上城牆，預備擋牌。',
    '鴻2:6 河閘開放，宮殿沖沒。',
    '鴻2:7 王后蒙羞，被人擄去；宮女搥胸，哀鳴如鴿。此乃命定之事。',
    '鴻2:8 尼尼微自古以來充滿人民，如同聚水的池子；現在居民卻都逃跑。雖有人呼喊說：站住！站住！卻無人回顧。',
    '鴻2:9 你們搶掠金銀吧！因為所積蓄的無窮，華美的寶器無數。',
    '鴻2:10 尼尼微現在空虛荒涼，人心消化，雙膝相碰，腰都疼痛，臉都變色。',
    '鴻2:11 獅子的洞和少壯獅子餵養之處在哪裡呢﹖公獅母獅小獅遊行、無人驚嚇之地在哪裡呢﹖',
    '鴻2:12 公獅為小獅撕碎許多食物，為母獅掐死活物，把撕碎的、掐死的充滿他的洞穴。',
    '鴻2:13 萬軍之耶和華說：我與你為敵，必將你的車輛焚燒成煙，刀劍也必吞滅你的少壯獅子。我必從地上除滅你所撕碎的，你使者的聲音必不再聽見。',
    '鴻3:1 禍哉！這流人血的城，充滿謊詐和強暴─搶奪的事總不止息。',
    '鴻3:2 鞭聲響亮，車輪轟轟，馬匹踢跳，車輛奔騰，',
    '鴻3:3 馬兵爭先，刀劍發光，槍矛閃爍，被殺的甚多，屍首成了大堆，屍骸無數，人碰著而跌倒，',
    '鴻3:4 都因那美貌的妓女多有淫行，慣行邪術，藉淫行誘惑列國，用邪術誘惑（原文是賣）多族。',
    '鴻3:5 萬軍之耶和華說：我與你為敵；我必揭起你的衣襟，蒙在你臉上，使列國看見你的赤體，使列邦觀看你的醜陋。',
    '鴻3:6 我必將可憎污穢之物拋在你身上，辱沒你，為眾目所觀。',
    '鴻3:7 凡看見你的，都必逃跑離開你，說：尼尼微荒涼了！有誰為你悲傷呢﹖我何處尋得安慰你的人呢﹖',
    '鴻3:8 你豈比挪亞們強呢﹖挪亞們坐落在眾河之間，周圍有水；海（指尼羅河）作他的濠溝，又作他的城牆。',
    '鴻3:9 古實和埃及是他無窮的力量；弗人和路比族是他的幫手。',
    '鴻3:10 但他被遷移，被擄去；他的嬰孩在各市口上也被摔死。人為他的尊貴人拈鬮；他所有的大人都被鍊子鎖著。',
    '鴻3:11 你也必喝醉，必被埋藏，並因仇敵的緣故尋求避難所。',
    '鴻3:12 你一切保障必像無花果樹上初熟的無花果，若一搖撼就落在想吃之人的口中。',
    '鴻3:13 你地上的人民如同婦女；你國中的關口向仇敵敞開；你的門閂被火焚燒。',
    '鴻3:14 你要打水預備受困；要堅固你的保障，踹土和泥，修補磚窰。',
    '鴻3:15 在那裡，火必燒滅你；刀必殺戮你，吞滅你如同蝻子。任你加增人數多如蝻子，多如蝗蟲吧！',
    '鴻3:16 你增添商賈，多過天上的星；蝻子吃盡而去。',
    '鴻3:17 你的首領多如蝗蟲；你的軍長彷彿成群的螞蚱，天涼的時候齊落在籬笆上，日頭一出便都飛去，人不知道落在何處。',
    '鴻3:18 亞述王啊，你的牧人睡覺；你的貴冑安歇；你的人民散在山間，無人招聚。',
    '鴻3:19 你的損傷無法醫治；你的傷痕極其重大。凡聽你信息的必都因此向你拍掌。你所行的惡誰沒有時常遭遇呢﹖',
    '哈1:1 先知哈巴谷所得的默示。',
    '哈1:2 他說：耶和華啊！我呼求你，你不應允，要到幾時呢﹖我因強暴哀求你，你還不拯救。',
    '哈1:3 你為何使我看見罪孽﹖你為何看著奸惡而不理呢﹖毀滅和強暴在我面前，又起了爭端和相鬥的事。',
    '哈1:4 因此律法放鬆，公理也不顯明，惡人圍困義人，所以公理顯然顛倒。',
    '哈1:5 耶和華說：你們要向列國中觀看，大大驚奇；因為在你們的時候，我行一件事，雖有人告訴你們，你們總是不信。',
    '哈1:6 我必興起迦勒底人，就是那殘忍暴躁之民，通行遍地，佔據那不屬自己的住處。',
    '哈1:7 他威武可畏，判斷和勢力都任意發出。',
    '哈1:8 他的馬比豹更快，比晚上的豺狼更猛。馬兵踴躍爭先，都從遠方而來；他們飛跑如鷹抓食，',
    '哈1:9 都為行強暴而來，定住臉面向前，將擄掠的人聚集，多如塵沙。',
    '哈1:10 他們譏誚君王，笑話首領，嗤笑一切保障，築壘攻取。',
    '哈1:11 他以自己的勢力為神，像風猛然掃過，顯為有罪。',
    '哈1:12 耶和華─我的神，我的聖者啊，你不是從亙古而有嗎﹖我們必不致死。耶和華啊，你派定他為要刑罰人；磐石啊，你設立他為要懲治人。',
    '哈1:13 你眼目清潔，不看邪僻，不看奸惡；行詭詐的，你為何看著不理呢﹖惡人吞滅比自己公義的，你為何靜默不語呢﹖',
    '哈1:14 你為何使人如海中的魚，又如沒有管轄的爬物呢﹖',
    '哈1:15 他用鉤鉤住，用網捕獲，用拉網聚集他們；因此，他歡喜快樂，',
    '哈1:16 就向網獻祭，向網燒香，因他由此得肥美的分和富裕的食物。',
    '哈1:17 他豈可屢次倒空網羅，將列國的人時常殺戮，毫不顧惜呢﹖',
    '哈2:1 我要站在守望所，立在望樓上觀看，看耶和華對我說什麼話，我可用什麼話向他訴冤（向他訴冤：或譯回答所疑問的）。',
    '哈2:2 他對我說：將這默示明明地寫在版上，使讀的人容易讀（或譯：隨跑隨讀）。',
    '哈2:3 因為這默示有一定的日期，快要應驗，並不虛謊。雖然遲延，還要等候；因為必然臨到，不再遲延。',
    '哈2:4 迦勒底人自高自大，心不正直；惟義人因信得生。',
    '哈2:5 迦勒底人因酒詭詐，狂傲，不住在家中，擴充心欲，好像陰間。他如死不能知足，聚集萬國，堆積萬民都歸自己。',
    '哈2:6 這些國的民豈不都要提起詩歌並俗語譏刺他說：禍哉！迦勒底人，你增添不屬自己的財物，多多取人的當頭，要到幾時為止呢﹖',
    '哈2:7 咬傷你的豈不忽然起來，擾害你的豈不興起，你就作他們的擄物嗎﹖',
    '哈2:8 因你搶奪許多的國，殺人流血，向國內的城並城中一切居民施行強暴，所以各國剩下的民都必搶奪你。',
    '哈2:9 為本家積蓄不義之財、在高處搭窩、指望免災的有禍了！',
    '哈2:10 你圖謀剪除多國的民，犯了罪，使你的家蒙羞，自害己命。',
    '哈2:11 牆裡的石頭必呼叫；房內的棟梁必應聲。',
    '哈2:12 以人血建城、以罪孽立邑的有禍了！',
    '哈2:13 眾民所勞碌得來的被火焚燒，列國由勞乏而得的歸於虛空，不都是出於萬軍之耶和華嗎﹖',
    '哈2:14 認識耶和華榮耀的知識要充滿遍地，好像水充滿洋海一般。',
    '哈2:15 給人酒喝、又加上毒物、使他喝醉、好看見他下體的有禍了！',
    '哈2:16 你滿受羞辱，不得榮耀；你也喝吧，顯出是未受割禮的！耶和華右手的杯必傳到你那裡；你的榮耀就變為大大地羞辱。',
    '哈2:17 你向利巴嫩行強暴與殘害驚嚇野獸的事必遮蓋你；因你殺人流血，向國內的城並城中一切居民施行強暴。',
    '哈2:18 雕刻的偶像，人將他刻出來，有什麼益處呢﹖鑄造的偶像就是虛謊的師傅。製造者倚靠這啞巴偶像有什麼益處呢﹖',
    '哈2:19 對木偶說：醒起！對啞巴石像說：起來！那人有禍了！這個還能教訓人嗎﹖看哪，是包裹金銀的，其中毫無氣息。',
    '哈2:20 惟耶和華在他的聖殿中；全地的人都當在他面前肅敬靜默。',
    '哈3:1 先知哈巴谷的禱告，調用流離歌。',
    '哈3:2 耶和華啊，我聽見你的名聲（或譯：言語）就懼怕。耶和華啊，求你在這些年間復興你的作為，在這些年間顯明出來；在發怒的時候以憐憫為念。',
    '哈3:3 神從提幔而來；聖者從巴蘭山臨到。（細拉）他的榮光遮蔽諸天；頌讚充滿大地。',
    '哈3:4 他的輝煌如同日光；從他手裡射出光線，在其中藏著他的能力。',
    '哈3:5 在他前面有瘟疫流行；在他腳下有熱症發出。',
    '哈3:6 他站立，量了大地（或譯：使地震動），觀看，趕散萬民。永久的山崩裂；長存的嶺塌陷；他的作為與古時一樣。',
    '哈3:7 我見古珊的帳棚遭難，米甸的幔子戰兢。',
    '哈3:8 耶和華啊，你乘在馬上，坐在得勝的車上，豈是不喜悅江河、向江河發怒氣、向洋海發憤恨嗎﹖',
    '哈3:9 你的弓全然顯露，向眾支派所起的誓都是可信的。（細拉）你以江河分開大地。',
    '哈3:10 山嶺見你，無不戰懼；大水氾濫過去，深淵發聲，洶湧翻騰（原文是向上舉手）。',
    '哈3:11 因你的箭射出發光，你的槍閃出光耀，日月都在本宮停住。',
    '哈3:12 你發憤恨通行大地，發怒氣責打列國，如同打糧。',
    '哈3:13 你出來要拯救你的百姓，拯救你的受膏者，打破惡人家長的頭，露出他的腳（原文是根基），直到頸項。（細拉）',
    '哈3:14 你用敵人的戈矛刺透他戰士的頭；他們來如旋風，要將我們分散。他們所喜愛的是暗中吞吃貧民。',
    '哈3:15 你乘馬踐踏紅海，就是踐踏洶湧的大水。',
    '哈3:16 我聽見耶和華的聲音，身體戰兢，嘴唇發顫，骨中朽爛；我在所立之處戰兢。我只可安靜等候災難之日臨到，犯境之民上來。',
    '哈3:17 雖然無花果樹不發旺，葡萄樹不結果，橄欖樹也不效力，田地不出糧食，圈中絕了羊，棚內也沒有牛；',
    '哈3:18 然而，我要因耶和華歡欣，因救我的神喜樂。',
    '哈3:19 主耶和華是我的力量；他使我的腳快如母鹿的蹄，又使我穩行在高處。這歌交與伶長，用絲弦的樂器。',
    '番1:1 當猶大王亞們的兒子約西亞在位的時候，耶和華的話臨到希西家的玄孫，亞瑪利雅的曾孫，基大利的孫子，古示的兒子西番雅。',
    '番1:2 耶和華說：我必從地上除滅萬類。',
    '番1:3 我必除滅人和牲畜，與空中的鳥、海裡的魚，以及絆腳石和惡人；我必將人從地上剪除。這是耶和華說的。',
    '番1:4 我必伸手攻擊猶大和耶路撒冷的一切居民，也必從這地方剪除所剩下的巴力，並基瑪林的名和祭司，',
    '番1:5 與那些在房頂上敬拜天上萬象的，並那些敬拜耶和華指著他起誓，又指著瑪勒堪起誓的，',
    '番1:6 與那些轉去不跟從耶和華的，和不尋求耶和華也不訪問他的。',
    '番1:7 你要在主耶和華面前靜默無聲，因為耶和華的日子快到。耶和華已經預備祭物，將他的客分別為聖。',
    '番1:8 到了我─耶和華獻祭的日子，必懲罰首領和王子，並一切穿外邦衣服的。',
    '番1:9 到那日，我必懲罰一切跳過門檻、將強暴和詭詐得來之物充滿主人房屋的。',
    '番1:10 耶和華說：當那日，從魚門必發出悲哀的聲音，從二城發出哀號的聲音，從山間發出大破裂的響聲。',
    '番1:11 瑪革提施的居民哪，你們要哀號，因為迦南的商民都滅亡了！凡搬運銀子的都被剪除。',
    '番1:12 那時，我必用燈巡查耶路撒冷；我必懲罰那些如酒在渣滓上澄清的；他們心裡說：耶和華必不降福，也不降禍。',
    '番1:13 他們的財寶必成為掠物；他們的房屋必變為荒場。他們必建造房屋，卻不得住在其內；栽種葡萄園，卻不得喝所出的酒。',
    '番1:14 耶和華的大日臨近，臨近而且甚快，乃是耶和華日子的風聲；勇士必痛痛地哭號。',
    '番1:15 那日是忿怒的日子，是急難困苦的日子，是荒廢淒涼的日子，是黑暗幽冥、密雲烏黑的日子，',
    '番1:16 是吹角吶喊的日子，要攻擊堅固城和高大的城樓。',
    '番1:17 我必使災禍臨到人身上，使他們行走如同瞎眼的，因為得罪了我。他們的血必倒出如灰塵；他們的肉必拋棄如糞土。',
    '番1:18 當耶和華發怒的日子，他們的金銀不能救他們；他的忿怒如火必燒滅全地，毀滅這地的一切居民，而且大大毀滅。',
    '番2:1 不知羞恥的國民哪，你們應當聚集！趁命令沒有發出，日子過去如風前的糠，耶和華的烈怒未臨到你們，他發怒的日子未到以先，你們應當聚集前來。',
    '番2:2 併於上節。',
    '番2:3 世上遵守耶和華典章的謙卑人哪，你們都當尋求耶和華！當尋求公義謙卑，或者在耶和華發怒的日子可以隱藏起來。',
    '番2:4 迦薩必致見棄；亞實基倫必然荒涼。人在正午必趕出亞實突的民；以革倫也被拔出根來。',
    '番2:5 住沿海之地的基利提族有禍了！迦南、非利士人之地啊，耶和華的話與你反對，說：我必毀滅你，以致無人居住。',
    '番2:6 沿海之地要變為草場，其上有牧人的住處和羊群的圈。',
    '番2:7 這地必為猶大家剩下的人所得；他們必在那裡牧放群羊，晚上必躺臥在亞實基倫的房屋中；因為耶和華─他們的神必眷顧他們，使他們被擄的人歸回。',
    '番2:8 我聽見摩押人的毀謗和亞捫人的辱罵，就是毀謗我的百姓，自誇自大，侵犯他們的境界。',
    '番2:9 萬軍之耶和華─以色列的神說：我指著我的永生起誓：摩押必像所多瑪，亞捫人必像蛾摩拉，都變為刺草、鹽坑、永遠荒廢之地。我百姓所剩下的必擄掠他們；我國中所餘剩的必得著他們的地。',
    '番2:10 這事臨到他們是因他們驕傲，自誇自大，毀謗萬軍之耶和華的百姓。',
    '番2:11 耶和華必向他們顯可畏之威，因他必叫世上的諸神瘦弱。列國海島的居民各在自己的地方敬拜他。',
    '番2:12 古實人哪，你們必被我的刀所殺。',
    '番2:13 耶和華必伸手攻擊北方，毀滅亞述，使尼尼微荒涼，又乾旱如曠野。',
    '番2:14 群畜，就是各國（國：或譯類）的走獸必臥在其中；鵜鶘和箭豬要宿在柱頂上。在窗戶內有鳴叫的聲音；門檻都必毀壞，香柏木已經露出。',
    '番2:15 這是素來歡樂安然居住的城，心裡說：惟有我，除我以外再沒有別的；現在何竟荒涼成為野獸躺臥之處！凡經過的人都必搖手嗤笑他。',
    '番3:1 這悖逆、污穢、欺壓的城有禍了！',
    '番3:2 他不聽從命令，不領受訓誨，不倚靠耶和華，不親近他的神。',
    '番3:3 他中間的首領是咆哮的獅子；他的審判官是晚上的豺狼，一點食物也不留到早晨。',
    '番3:4 他的先知是虛浮詭詐的人；他的祭司褻瀆聖所，強解律法。',
    '番3:5 耶和華在他中間是公義的，斷不做非義的事，每早晨顯明他的公義，無日不然；只是不義的人不知羞恥。',
    '番3:6 我─耶和華已經除滅列國的民；他們的城樓毀壞。我使他們的街道荒涼，以致無人經過；他們的城邑毀滅，以致無人，也無居民。',
    '番3:7 我說：你只要敬畏我，領受訓誨；如此，你的住處不致照我所擬定的除滅。只是你們從早起來就在一切事上敗壞自己。',
    '番3:8 耶和華說：你們要等候我，直到我興起擄掠的日子；因為我已定意招聚列國，聚集列邦，將我的惱怒─就是我的烈怒都傾在他們身上。我的忿怒如火，必燒滅全地。',
    '番3:9 那時，我必使萬民用清潔的言語好求告我─耶和華的名，同心合意地事奉我。',
    '番3:10 祈禱我的，就是我所分散的民（原文是女子；下同），必從古實河外來，給我獻供物。',
    '番3:11 當那日，你必不因你一切得罪我的事自覺羞愧；因為那時我必從你中間除掉矜誇高傲之輩，你也不再於我的聖山狂傲。',
    '番3:12 我卻要在你中間留下困苦貧寒的民；他們必投靠我─耶和華的名。',
    '番3:13 以色列所剩下的人必不作罪孽，不說謊言，口中也沒有詭詐的舌頭；而且吃喝躺臥，無人驚嚇。',
    '番3:14 錫安的民哪，應當歌唱！以色列啊，應當歡呼！耶路撒冷的民哪，應當滿心歡喜快樂！',
    '番3:15 耶和華已經除去你的刑罰，趕出你的仇敵。以色列的王─耶和華在你中間；你必不再懼怕災禍。',
    '番3:16 當那日，必有話向耶路撒冷說：不要懼怕！錫安哪；不要手軟！',
    '番3:17 耶和華─你的神是施行拯救、大有能力的主。他在你中間必因你歡欣喜樂，默然愛你，且因你喜樂而歡呼。',
    '番3:18 那些屬你、為無大會愁煩、因你擔當羞辱的，我必聚集他們。',
    '番3:19 那時，我必罰辦一切苦待你的人，又拯救你瘸腿的，聚集你被趕出的。那些在全地受羞辱的，我必使他們得稱讚，有名聲。',
    '番3:20 那時，我必領你們進來，聚集你們；我使你們被擄之人歸回的時候，就必使你們在地上的萬民中有名聲，得稱讚。這是耶和華說的。',
    '該1:1 大利烏王第二年六月初一日，耶和華的話藉先知哈該向猶大省長撒拉鐵的兒子所羅巴伯和約撒答的兒子大祭司約書亞說：',
    '該1:2 萬軍之耶和華如此說：這百姓說，建造耶和華殿的時候尚未來到。',
    '該1:3 那時耶和華的話臨到先知哈該說：',
    '該1:4 這殿仍然荒涼，你們自己還住天花板的房屋嗎﹖',
    '該1:5 現在萬軍之耶和華如此說：你們要省察自己的行為。',
    '該1:6 你們撒的種多，收的卻少；你們吃，卻不得飽；喝，卻不得足；穿衣服，卻不得暖；得工錢的，將工錢裝在破漏的囊中。',
    '該1:7 萬軍之耶和華如此說：你們要省察自己的行為。',
    '該1:8 你們要上山取木料，建造這殿，我就因此喜樂，且得榮耀。這是耶和華說的。',
    '該1:9 你們盼望多得，所得的卻少；你們收到家中，我就吹去。這是為什麼呢﹖因為我的殿荒涼，你們各人卻顧（原文是奔）自己的房屋。這是萬軍之耶和華說的。',
    '該1:10 所以為你們的緣故，天就不降甘露，地也不出土產。',
    '該1:11 我命乾旱臨到地土、山岡、五穀、新酒，和油，並地上的出產、人民、牲畜，以及人手一切勞碌得來的。',
    '該1:12 那時，撒拉鐵的兒子所羅巴伯和約撒答的兒子大祭司約書亞，並剩下的百姓，都聽從耶和華─他們神的話和先知哈該奉耶和華─他們神差來所說的話；百姓也在耶和華面前存敬畏的心。',
    '該1:13 耶和華的使者哈該奉耶和華差遣對百姓說：耶和華說：我與你們同在。',
    '該1:14 耶和華激動猶大省長撒拉鐵的兒子所羅巴伯和約撒答的兒子大祭司約書亞，並剩下之百姓的心，他們就來為萬軍之耶和華─他們神的殿做工。',
    '該1:15 這是在大利烏王第二年六月二十四日。',
    '該2:1 七月二十一日，耶和華的話臨到先知哈該說：',
    '該2:2 你要曉諭猶大省長撒拉鐵的兒子所羅巴伯和約撒答的兒子大祭司約書亞，並剩下的百姓，說：',
    '該2:3 你們中間存留的，有誰見過這殿從前的榮耀呢﹖現在你們看著如何﹖豈不在眼中看如無有嗎﹖',
    '該2:4 耶和華說：所羅巴伯啊，雖然如此，你當剛強！約撒答的兒子大祭司約書亞啊，你也當剛強！這地的百姓，你們都當剛強做工，因為我與你們同在。這是萬軍之耶和華說的。',
    '該2:5 這是照著你們出埃及我與你們立約的話。那時，我的靈住在你們中間，你們不要懼怕。',
    '該2:6 萬軍之耶和華如此說：過不多時，我必再一次震動天地、滄海，與旱地。',
    '該2:7 我必震動萬國；萬國的珍寶必都運來（或譯：萬國所羨慕的必來到），我就使這殿滿了榮耀。這是萬軍之耶和華說的。',
    '該2:8 萬軍之耶和華說：銀子是我的，金子也是我的。',
    '該2:9 這殿後來的榮耀必大過先前的榮耀；在這地方我必賜平安。這是萬軍之耶和華說的。',
    '該2:10 大利烏王第二年九月二十四日，耶和華的話臨到先知哈該說：',
    '該2:11 萬軍之耶和華如此說：你要向祭司問律法，',
    '該2:12 說：若有人用衣襟兜聖肉，這衣襟挨著餅，或湯，或酒，或油，或別的食物，便算為聖嗎﹖祭司說：不算為聖。',
    '該2:13 哈該又說：若有人因摸死屍染了污穢，然後挨著這些物的哪一樣，這物算污穢嗎﹖祭司說：必算污穢。',
    '該2:14 於是哈該說：耶和華說：這民這國，在我面前也是如此；他們手下的各樣工作都是如此；他們在壇上所獻的也是如此。',
    '該2:15 現在你們要追想，此日以前，耶和華的殿沒有一塊石頭壘在石頭上的光景。',
    '該2:16 在那一切日子，有人來到穀堆，想得二十斗，只得了十斗。有人來到酒池，想得五十桶，只得了二十桶。',
    '該2:17 在你們手下的各樣工作上，我以旱風、霉爛、冰雹攻擊你們，你們仍不歸向我。這是耶和華說的。',
    '該2:18 你們要追想此日以前，就是從這九月二十四日起，追想到立耶和華殿根基的日子。',
    '該2:19 倉裡有穀種嗎﹖葡萄樹、無花果樹、石榴樹、橄欖樹都沒有結果子。從今日起，我必賜福與你們。',
    '該2:20 這月二十四日，耶和華的話二次臨到哈該說：',
    '該2:21 你要告訴猶大省長所羅巴伯說：我必震動天地。',
    '該2:22 我必傾覆列國的寶座，除滅列邦的勢力，並傾覆戰車和坐在其上的。馬必跌倒，騎馬的敗落，各人被弟兄的刀所殺。',
    '該2:23 萬軍之耶和華說：我僕人撒拉鐵的兒子所羅巴伯啊，到那日，我必以你為印，因我揀選了你。這是萬軍之耶和華說的。',
    '亞1:1 大利烏王第二年八月，耶和華的話臨到易多的孫子、比利家的兒子先知撒迦利亞，說：',
    '亞1:2 耶和華曾向你們列祖大大發怒。',
    '亞1:3 所以你要對以色列人說，萬軍之耶和華如此說：你們要轉向我，我就轉向你們。這是萬軍之耶和華說的。',
    '亞1:4 不要效法你們列祖。從前的先知呼叫他們說，萬軍之耶和華如此說：你們要回頭離開你們的惡道惡行。他們卻不聽，也不順從我。這是耶和華說的。',
    '亞1:5 你們的列祖在哪裡呢﹖那些先知能永遠存活嗎﹖',
    '亞1:6 只是我的言語和律例，就是所吩咐我僕人眾先知的，豈不臨到你們列祖嗎﹖他們就回頭，說：萬軍之耶和華定意按我們的行動作為向我們怎樣行，他已照樣行了。',
    '亞1:7 大利烏第二年十一月，就是細罷特月二十四日，耶和華的話臨到易多的孫子、比利家的兒子先知撒迦利亞，說：',
    '亞1:8 我夜間觀看，見一人騎著紅馬，站在窪地番石榴樹中間。在他身後又有紅馬、黃馬，和白馬。',
    '亞1:9 我對與我說話的天使說：主啊，這是什麼意思﹖他說：我要指示你這是什麼意思。',
    '亞1:10 那站在番石榴樹中間的人說：這是奉耶和華差遣在遍地走來走去的。',
    '亞1:11 那些騎馬的對站在番石榴樹中間耶和華的使者說：我們已在遍地走來走去，見全地都安息平靜。',
    '亞1:12 於是，耶和華的使者說：萬軍之耶和華啊，你惱恨耶路撒冷和猶大的城邑已經七十年，你不施憐憫要到幾時呢﹖',
    '亞1:13 耶和華就用美善的安慰話回答那與我說話的天使。',
    '亞1:14 與我說話的天使對我說：你要宣告說，萬軍之耶和華如此說：我為耶路撒冷為錫安，心裡極其火熱。',
    '亞1:15 我甚惱怒那安逸的列國，因我從前稍微惱怒我民，他們就加害過分。',
    '亞1:16 所以耶和華如此說：現今我回到耶路撒冷，仍施憐憫，我的殿必重建在其中，準繩必拉在耶路撒冷之上。這是萬軍之耶和華說的。',
    '亞1:17 你要再宣告說，萬軍之耶和華如此說：我的城邑必再豐盛發達。耶和華必再安慰錫安，揀選耶路撒冷。',
    '亞1:18 我舉目觀看，見有四角。',
    '亞1:19 我就問與我說話的天使說：這是什麼意思﹖他回答說：這是打散猶大、以色列，和耶路撒冷的角。',
    '亞1:20 耶和華又指四個匠人給我看。',
    '亞1:21 我說：他們來做什麼呢﹖他說：這是打散猶大的角，使人不敢擡頭；但這些匠人來威嚇列國，打掉他們的角，就是舉起打散猶大地的角。',
    '亞2:1 我又舉目觀看，見一人手拿準繩。',
    '亞2:2 我說：你往哪裡去﹖他對我說：要去量耶路撒冷，看有多寬多長。',
    '亞2:3 與我說話的天使去的時候，又有一位天使迎著他來，',
    '亞2:4 對他說：你跑去告訴那少年人說，耶路撒冷必有人居住，好像無城牆的鄉村，因為人民和牲畜甚多。',
    '亞2:5 耶和華說：我要作耶路撒冷四圍的火城，並要作其中的榮耀。',
    '亞2:6 耶和華說：我從前分散你們在天的四方（原文是猶如天的四風），現在你們要從北方之地逃回。這是耶和華說的。',
    '亞2:7 與巴比倫人同住的錫安民哪，應當逃脫。',
    '亞2:8 萬軍之耶和華說，在顯出榮耀之後，差遣我去懲罰那擄掠你們的列國，摸你們的就是摸他眼中的瞳人。',
    '亞2:9 看哪，我（或譯：他）要向他們掄手，他們就必作服事他們之人的擄物，你們便知道萬軍之耶和華差遣我了。',
    '亞2:10 錫安城啊，應當歡樂歌唱，因為我來要住在你中間。這是耶和華說的。',
    '亞2:11 那時，必有許多國歸附耶和華，作他（原文是我）的子民。他（原文是我）要住在你中間，你就知道萬軍之耶和華差遣我到你那裡去了。',
    '亞2:12 耶和華必收回猶大作他聖地的分，也必再揀選耶路撒冷。',
    '亞2:13 凡有血氣的都當在耶和華面前靜默無聲；因為他興起，從聖所出來了。',
    '亞3:1 天使（原文是他）又指給我看：大祭司約書亞站在耶和華的使者面前；撒但也站在約書亞的右邊，與他作對。',
    '亞3:2 耶和華向撒但說：撒但哪，耶和華責備你！就是揀選耶路撒冷的耶和華責備你！這不是從火中抽出來的一根柴嗎﹖',
    '亞3:3 約書亞穿著污穢的衣服站在使者面前。',
    '亞3:4 使者吩咐站在面前的說：你們要脫去他污穢的衣服；又對約書亞說：我使你脫離罪孽，要給你穿上華美的衣服。',
    '亞3:5 我說：要將潔淨的冠冕戴在他頭上。他們就把潔淨的冠冕戴在他頭上，給他穿上華美的衣服，耶和華的使者在旁邊站立。',
    '亞3:6 耶和華的使者告誡約書亞說：',
    '亞3:7 萬軍之耶和華如此說：你若遵行我的道，謹守我的命令，你就可以管理我的家，看守我的院宇；我也要使你在這些站立的人中間來往。',
    '亞3:8 大祭司約書亞啊，你和坐在你面前的同伴都當聽。（他們是作預兆的。）我必使我僕人大衛的苗裔發出。',
    '亞3:9 看哪，我在約書亞面前所立的石頭，在一塊石頭上有七眼。萬軍之耶和華說：我要親自雕刻這石頭，並要在一日之間除掉這地的罪孽。',
    '亞3:10 當那日，你們各人要請鄰舍坐在葡萄樹和無花果樹下。這是萬軍之耶和華說的。',
    '亞4:1 那與我說話的天使又來叫醒我，好像人睡覺被喚醒一樣。',
    '亞4:2 他問我說：你看見了什麼﹖我說：我看見了一個純金的燈臺，頂上有盞燈，燈臺上有七盞燈，每盞有七個管子。',
    '亞4:3 旁邊有兩棵橄欖樹，一棵在燈盞的右邊，一棵在燈盞的左邊。',
    '亞4:4 我問與我說話的天使說：主啊，這是什麼意思﹖',
    '亞4:5 與我說話的天使回答我說：你不知道這是什麼意思嗎﹖我說：主啊，我不知道。',
    '亞4:6 他對我說：這是耶和華指示所羅巴伯的。萬軍之耶和華說：不是倚靠勢力，不是倚靠才能，乃是倚靠我的靈方能成事。',
    '亞4:7 大山哪，你算什麼呢﹖在所羅巴伯面前，你必成為平地。他必搬出一塊石頭，安在殿頂上。人且大聲歡呼說：願恩惠恩惠歸與這殿（殿：或譯石）！',
    '亞4:8 耶和華的話又臨到我說：',
    '亞4:9 所羅巴伯的手立了這殿的根基，他的手也必完成這工，你就知道萬軍之耶和華差遣我到你們這裡來了。',
    '亞4:10 誰藐視這日的事為小呢﹖這七眼乃是耶和華的眼睛，遍察全地，見所羅巴伯手拿線鉈就歡喜。',
    '亞4:11 我又問天使說：這燈臺左右的兩棵橄欖樹是什麼意思﹖',
    '亞4:12 我二次問他說：這兩根橄欖枝在兩個流出金色油的金嘴旁邊是什麼意思﹖',
    '亞4:13 他對我說：你不知道這是什麼意思嗎﹖我說：主啊，我不知道。',
    '亞4:14 他說：這是兩個受膏者站在普天下主的旁邊。',
    '亞5:1 我又舉目觀看，見有一飛行的書卷。',
    '亞5:2 他問我說：你看見什麼﹖我回答說：我看見一飛行的書卷，長二十肘，寬十肘。',
    '亞5:3 他對我說：這是發出行在遍地上的咒詛。凡偷竊的必按卷上這面的話除滅；凡起假誓的必按卷上那面的話除滅。',
    '亞5:4 萬軍之耶和華說：我必使這書卷出去，進入偷竊人的家和指我名起假誓人的家，必常在他家裡，連房屋帶木石都毀滅了。',
    '亞5:5 與我說話的天使出來，對我說：你要舉目觀看，見所出來的是什麼﹖',
    '亞5:6 我說：這是什麼呢﹖他說：這出來的是量器。他又說：這是惡人在遍地的形狀。',
    '亞5:7 （我見有一片圓鉛被舉起來。）這坐在量器中的是個婦人。',
    '亞5:8 天使說：這是罪惡。他就把婦人扔在量器中，將那片圓鉛扔在量器的口上。',
    '亞5:9 我又舉目觀看，見有兩個婦人出來，在他們翅膀中有風，飛得甚快，翅膀如同鸛鳥的翅膀。他們將量器擡起來，懸在天地中間。',
    '亞5:10 我問與我說話的天使說：他們要將量器擡到哪裡去呢﹖',
    '亞5:11 他對我說：要往示拿地去，為他蓋造房屋；等房屋齊備，就把他安置在自己的地方。',
    '亞6:1 我又舉目觀看，見有四輛車從兩山中間出來；那山是銅山。',
    '亞6:2 第一輛車套著紅馬，第二輛車套著黑馬。',
    '亞6:3 第三輛車套著白馬，第四輛車套著有斑點的壯馬。',
    '亞6:4 我就問與我說話的天使說：主啊，這是什麼意思﹖',
    '亞6:5 天使回答我說：這是天的四風，是從普天下的主面前出來的。',
    '亞6:6 套著黑馬的車往北方去，白馬跟隨在後；有斑點的馬往南方去。',
    '亞6:7 壯馬出來，要在遍地走來走去。天使說：你們只管在遍地走來走去。他們就照樣行了。',
    '亞6:8 他又呼叫我說：看哪，往北方去的已在北方安慰我的心。',
    '亞6:9 耶和華的話臨到我說：',
    '亞6:10 你要從被擄之人中取黑玳、多比雅、耶大雅的金銀。這三人是從巴比倫來到西番雅的兒子約西亞的家裡。當日你要進他的家，',
    '亞6:11 取這金銀做冠冕，戴在約撒答的兒子大祭司約書亞的頭上，',
    '亞6:12 對他說，萬軍之耶和華如此說：看哪，那名稱為大衛苗裔的，他要在本處長起來，並要建造耶和華的殿。',
    '亞6:13 他要建造耶和華的殿，並擔負尊榮，坐在位上掌王權；又必在位上作祭司，使兩職之間籌定和平。',
    '亞6:14 這冠冕要歸希連（就是黑玳）、多比雅、耶大雅，和西番雅的兒子賢（就是約西亞），放在耶和華的殿裡為記念。',
    '亞6:15 遠方的人也要來建造耶和華的殿，你們就知道萬軍之耶和華差遣我到你們這裡來。你們若留意聽從耶和華─你們神的話，這事必然成就。',
    '亞7:1 大利烏王第四年九月，就是基斯流月初四日，耶和華的話臨到撒迦利亞。',
    '亞7:2 那時伯特利人已經打發沙利亞和利堅米勒，並跟從他們的人，去懇求耶和華的恩，',
    '亞7:3 並問萬軍之耶和華殿中的祭司和先知說：我歷年以來，在五月間哭泣齋戒，現在還當這樣行嗎﹖',
    '亞7:4 萬軍之耶和華的話就臨到我說：',
    '亞7:5 你要宣告國內的眾民和祭司，說：你們這七十年，在五月、七月禁食悲哀，豈是絲毫向我禁食嗎﹖',
    '亞7:6 你們吃喝，不是為自己吃，為自己喝嗎﹖',
    '亞7:7 當耶路撒冷和四圍的城邑有居民，正興盛，南地高原有人居住的時候，耶和華藉從前的先知所宣告的話，你們不當聽嗎﹖',
    '亞7:8 耶和華的話又臨到撒迦利亞說：',
    '亞7:9 萬軍之耶和華曾對你們的列祖如此說：要按至理判斷，各人以慈愛憐憫弟兄。',
    '亞7:10 不可欺壓寡婦、孤兒、寄居的，和貧窮人。誰都不可心裡謀害弟兄。',
    '亞7:11 他們卻不肯聽從，扭轉肩頭，塞耳不聽，',
    '亞7:12 使心硬如金鋼石，不聽律法和萬軍之耶和華用靈藉從前的先知所說的話。故此，萬軍之耶和華大發烈怒。',
    '亞7:13 萬軍之耶和華說：我曾呼喚他們，他們不聽；將來他們呼求我，我也不聽！',
    '亞7:14 我必以旋風吹散他們到素不認識的萬國中。這樣，他們的地就荒涼，甚至無人來往經過，因為他們使美好之地荒涼了。',
    '亞8:1 萬軍之耶和華的話臨到我說：',
    '亞8:2 萬軍之耶和華如此說：我為錫安心裡極其火熱，我為他火熱，向他的仇敵發烈怒。',
    '亞8:3 耶和華如此說：我現在回到錫安，要住在耶路撒冷中。耶路撒冷必稱為誠實的城，萬軍之耶和華的山必稱為聖山。',
    '亞8:4 萬軍之耶和華如此說：將來必有年老的男女坐在耶路撒冷街上，因為年紀老邁就手拿柺杖。',
    '亞8:5 城中街上必滿有男孩女孩玩耍。',
    '亞8:6 萬軍之耶和華如此說：到那日，這事在餘剩的民眼中看為希奇，在我眼中也看為希奇嗎﹖這是萬軍之耶和華說的。',
    '亞8:7 萬軍之耶和華如此說：我要從東方從西方救回我的民。',
    '亞8:8 我要領他們來，使他們住在耶路撒冷中。他們要作我的子民，我要作他們的神，都憑誠實和公義。',
    '亞8:9 萬軍之耶和華如此說：當建造萬軍之耶和華的殿，立根基之日的先知所說的話，現在你們聽見，應當手裡強壯。',
    '亞8:10 那日以先，人得不著雇價，牲畜也是如此；且因敵人的緣故，出入之人不得平安，乃因我使眾人互相攻擊。',
    '亞8:11 但如今，我待這餘剩的民必不像從前。這是萬軍之耶和華說的。',
    '亞8:12 因為他們必平安撒種，葡萄樹必結果子，地土必有出產，天也必降甘露。我要使這餘剩的民享受這一切的福。',
    '亞8:13 猶大家和以色列家啊，你們從前在列國中怎樣成為可咒詛的；照樣，我要拯救你們，使人稱你們為有福的（或譯：使你們叫人得福）。你們不要懼怕，手要強壯。',
    '亞8:14 萬軍之耶和華如此說：你們列祖惹我發怒的時候，我怎樣定意降禍，並不後悔。',
    '亞8:15 現在我照樣定意施恩與耶路撒冷和猶大家，你們不要懼怕。',
    '亞8:16 你們所當行的是這樣：各人與鄰舍說話誠實，在城門口按至理判斷，使人和睦。',
    '亞8:17 誰都不可心裡謀害鄰舍，也不可喜愛起假誓，因為這些事都為我所恨惡。這是耶和華說的。',
    '亞8:18 萬軍之耶和華的話臨到我說：',
    '亞8:19 萬軍之耶和華如此說：四月、五月禁食的日子，七月、十月禁食的日子，必變為猶大家歡喜快樂的日子和歡樂的節期；所以你們要喜愛誠實與和平。',
    '亞8:20 萬軍之耶和華如此說：將來必有列國的人和多城的居民來到。',
    '亞8:21 這城的居民必到那城，說：我們要快去懇求耶和華的恩，尋求萬軍之耶和華；我也要去。',
    '亞8:22 必有列邦的人和強國的民來到耶路撒冷尋求萬軍之耶和華，懇求耶和華的恩。',
    '亞8:23 萬軍之耶和華如此說：在那些日子，必有十個人從列國諸族（原文是方言）中出來，拉住一個猶大人的衣襟，說：我們要與你們同去，因為我們聽見神與你們同在了。',
    '亞9:1 耶和華的默示應驗在哈得拉地大馬色─世人和以色列各支派的眼目都仰望耶和華─',
    '亞9:2 和靠近的哈馬，並推羅、西頓；因為這二城的人大有智慧。',
    '亞9:3 推羅為自己修築保障，積蓄銀子如塵沙，堆起精金如街上的泥土。',
    '亞9:4 主必趕出他，打敗他海上的權利；他必被火燒滅。',
    '亞9:5 亞實基倫看見必懼怕；迦薩看見甚痛苦；以革倫因失了盼望蒙羞。迦薩必不再有君王；亞實基倫也不再有居民。',
    '亞9:6 私生子（或譯：外族人）必住在亞實突；我必除滅非利士人的驕傲。',
    '亞9:7 我必除去他口中帶血之肉和牙齒內可憎之物。他必作為餘剩的人歸與我們的神，必在猶大像族長；以革倫人必如耶布斯人。',
    '亞9:8 我必在我家的四圍安營，使敵軍不得任意往來，暴虐的人也不再經過，因為我親眼看顧我的家。',
    '亞9:9 錫安的民哪，應當大大喜樂；耶路撒冷的民哪，應當歡呼。看哪，你的王來到你這裡！他是公義的，並且施行拯救，謙謙和和地騎著驢，就是騎著驢的駒子。',
    '亞9:10 我必除滅以法蓮的戰車和耶路撒冷的戰馬；爭戰的弓也必除滅。他必向列國講和平；他的權柄必從這海管到那海，從大河管到地極。',
    '亞9:11 錫安哪，我因與你立約的血，將你中間被擄而囚的人從無水的坑中釋放出來。',
    '亞9:12 你們被囚而有指望的人都要轉回保障。我今日說明，我必加倍賜福給你們。',
    '亞9:13 我拿猶大作上弦的弓；我拿以法蓮為張弓的箭。錫安哪，我要激發你的眾子，攻擊希利尼（原文是雅完）的眾子，使你如勇士的刀。',
    '亞9:14 耶和華必顯現在他們以上；他的箭必射出像閃電。主耶和華必吹角，乘南方的旋風而行。',
    '亞9:15 萬軍之耶和華必保護他們；他們必吞滅仇敵，踐踏彈石。他們必喝血吶喊，猶如飲酒；他們必像盛滿血的碗，又像壇的四角滿了血。',
    '亞9:16 當那日，耶和華─他們的神必看他的民如群羊，拯救他們；因為他們必像冠冕上的寶石，高舉在他的地以上（或譯：在他的地上發光輝）。',
    '亞9:17 他的恩慈何等大！他的榮美何其盛！五穀健壯少男；新酒培養處女。',
    '亞10:1 當春雨的時候，你們要向發閃電的耶和華求雨。他必為眾人降下甘霖，使田園生長菜蔬。',
    '亞10:2 因為，家神所言的是虛空；卜士所見的是虛假；做夢者所說的是假夢。他們白白地安慰人，所以眾人如羊流離，因無牧人就受苦。',
    '亞10:3 我的怒氣向牧人發作；我必懲罰公山羊；因我─萬軍之耶和華眷顧自己的羊群，就是猶大家，必使他們如駿馬在陣上。',
    '亞10:4 房角石、釘子、爭戰的弓，和一切掌權的都從他而出。',
    '亞10:5 他們必如勇士在陣上將仇敵踐踏在街上的泥土中。他們必爭戰，因為耶和華與他們同在；騎馬的也必羞愧。',
    '亞10:6 我要堅固猶大家，拯救約瑟家，要領他們歸回。我要憐恤他們；他們必像未曾棄絕的一樣，都因我是耶和華─他們的神，我必應允他們的禱告。',
    '亞10:7 以法蓮人必如勇士；他們心中暢快如同喝酒；他們的兒女必看見而快活；他們的心必因耶和華喜樂。',
    '亞10:8 我要發嘶聲，聚集他們，因我已經救贖他們。他們的人數必加增，如從前加增一樣。',
    '亞10:9 我雖然（或譯：必）播散他們在列國中，他們必在遠方記念我。他們與兒女都必存活，且得歸回。',
    '亞10:10 我必再領他們出埃及地，招聚他們出亞述，領他們到基列和利巴嫩；這地尚且不夠他們居住。',
    '亞10:11 耶和華必經過苦海，擊打海浪，使尼羅河的深處都枯乾。亞述的驕傲必致卑微；埃及的權柄必然滅沒。',
    '亞10:12 我必使他們倚靠我，得以堅固；一舉一動必奉我的名。這是耶和華說的。',
    '亞11:1 利巴嫩哪，開開你的門，任火燒滅你的香柏樹。',
    '亞11:2 松樹啊，應當哀號；因為香柏樹傾倒，佳美的樹毀壞。巴珊的橡樹啊，應當哀號，因為茂盛的樹林已經倒了。',
    '亞11:3 聽啊，有牧人哀號的聲音，因他們榮華的草場毀壞了。有少壯獅子咆哮的聲音，因約但河旁的叢林荒廢了。',
    '亞11:4 耶和華─我的神如此說：你─撒迦利亞要牧養這將宰的群羊。',
    '亞11:5 買他們的宰了他們，以自己為無罪；賣他們的說：耶和華是應當稱頌的，因我成為富足。牧養他們的並不憐恤他們。',
    '亞11:6 耶和華說：我不再憐恤這地的居民，必將這民交給各人的鄰舍和他們王的手中。他們必毀滅這地，我也不救這民脫離他們的手。',
    '亞11:7 於是，我牧養這將宰的群羊，就是群中最困苦的羊。我拿著兩根杖，一根我稱為榮美，一根我稱為聯索。這樣，我牧養了群羊。',
    '亞11:8 一月之內，我除滅三個牧人，因為我的心厭煩他們；他們的心也憎嫌我。',
    '亞11:9 我就說：我不牧養你們。要死的，由他死；要喪亡的，由他喪亡；餘剩的，由他們彼此相食。',
    '亞11:10 我折斷那稱為榮美的杖，表明我廢棄與萬民所立的約。',
    '亞11:11 當日就廢棄了。這樣，那些仰望我的困苦羊就知道所說的是耶和華的話。',
    '亞11:12 我對他們說：你們若以為美，就給我工價。不然，就罷了！於是他們給了三十塊錢作為我的工價。',
    '亞11:13 耶和華吩咐我說：要把眾人所估定美好的價值丟給窰戶。我便將這三十塊錢，在耶和華的殿中丟給窰戶了。',
    '亞11:14 我又折斷稱為聯索的那根杖，表明我廢棄猶大與以色列弟兄的情誼。',
    '亞11:15 耶和華又吩咐我說：你再取愚昧人所用的器具，',
    '亞11:16 因我要在這地興起一個牧人。他不看顧喪亡的，不尋找分散的，不醫治受傷的，也不牧養強壯的；卻要吃肥羊的肉，撕裂他的蹄子。',
    '亞11:17 無用的牧人丟棄羊群有禍了！刀必臨到他的膀臂和右眼上。他的膀臂必全然枯乾；他的右眼也必昏暗失明。',
    '亞12:1 耶和華論以色列的默示。鋪張諸天、建立地基、造人裡面之靈的耶和華說：',
    '亞12:2 我必使耶路撒冷被圍困的時候，向四圍列國的民成為令人昏醉的杯；這默示也論到猶大（或譯：猶大也是如此）。',
    '亞12:3 那日，我必使耶路撒冷向聚集攻擊他的萬民當作一塊重石頭；凡舉起的必受重傷。',
    '亞12:4 耶和華說：到那日，我必使一切馬匹驚惶，使騎馬的顛狂。我必看顧猶大家，使列國的一切馬匹瞎眼。',
    '亞12:5 猶大的族長必心裡說：耶路撒冷的居民倚靠萬軍之耶和華─他們的神，就作我們的能力。',
    '亞12:6 那日，我必使猶大的族長如火盆在木柴中，又如火把在禾捆裡；他們必左右燒滅四圍列國的民。耶路撒冷人必仍住本處，就是耶路撒冷。',
    '亞12:7 耶和華必先拯救猶大的帳棚，免得大衛家的榮耀和耶路撒冷居民的榮耀勝過猶大。',
    '亞12:8 那日，耶和華必保護耶路撒冷的居民。他們中間軟弱的必如大衛；大衛的家必如神，如行在他們前面之耶和華的使者。',
    '亞12:9 那日，我必定意滅絕來攻擊耶路撒冷各國的民。',
    '亞12:10 我必將那施恩叫人懇求的靈，澆灌大衛家和耶路撒冷的居民。他們必仰望我（或譯：他；本節同），就是他們所扎的；必為我悲哀，如喪獨生子，又為我愁苦，如喪長子。',
    '亞12:11 那日，耶路撒冷必有大大的悲哀，如米吉多平原之哈達臨門的悲哀。',
    '亞12:12 境內一家一家地都必悲哀。大衛家，男的獨在一處，女的獨在一處。拿單家，男的獨在一處，女的獨在一處。',
    '亞12:13 利未家，男的獨在一處，女的獨在一處。示每家，男的獨在一處，女的獨在一處。',
    '亞12:14 其餘的各家，男的獨在一處，女的獨在一處。',
    '亞13:1 那日，必給大衛家和耶路撒冷的居民開一個泉源，洗除罪惡與污穢。',
    '亞13:2 萬軍之耶和華說：那日，我必從地上除滅偶像的名，不再被人記念；也必使這地不再有假先知與污穢的靈。',
    '亞13:3 若再有人說預言，生他的父母必對他說：你不得存活，因為你託耶和華的名說假預言。生他的父母在他說預言的時候，要將他刺透。',
    '亞13:4 那日，凡作先知說預言的必因他所論的異象羞愧，不再穿毛衣哄騙人。',
    '亞13:5 他必說：我不是先知，我是耕地的；我從幼年作人的奴僕。',
    '亞13:6 必有人問他說：你兩臂中間是什麼傷呢﹖他必回答說：這是我在親友家中所受的傷。',
    '亞13:7 萬軍之耶和華說：刀劍哪，應當興起，攻擊我的牧人和我的同伴。擊打牧人，羊就分散；我必反手加在微小者的身上。',
    '亞13:8 耶和華說：這全地的人，三分之二必剪除而死，三分之一仍必存留。',
    '亞13:9 我要使這三分之一經火，熬煉他們，如熬煉銀子；試煉他們，如試煉金子。他們必求告我的名，我必應允他們。我要說：這是我的子民。他們也要說：耶和華是我們的神。',
    '亞14:1 耶和華的日子臨近，你的財物必被搶掠，在你中間分散。',
    '亞14:2 因為我必聚集萬國與耶路撒冷爭戰，城必被攻取，房屋被搶奪，婦女被玷污，城中的民一半被擄去；剩下的民仍在城中，不致剪除。',
    '亞14:3 那時，耶和華必出去與那些國爭戰，好像從前爭戰一樣。',
    '亞14:4 那日，他的腳必站在耶路撒冷前面朝東的橄欖山上。這山必從中間分裂，自東至西成為極大的谷。山的一半向北挪移，一半向南挪移。',
    '亞14:5 你們要從我山的谷中逃跑，因為山谷必延到亞薩。你們逃跑，必如猶大王烏西雅年間的人逃避大地震一樣。耶和華─我的神必降臨，有一切聖者同來。',
    '亞14:6 那日，必沒有光，三光必退縮。',
    '亞14:7 那日，必是耶和華所知道的，不是白晝，也不是黑夜，到了晚上才有光明。',
    '亞14:8 那日，必有活水從耶路撒冷出來，一半往東海流，一半往西海流；冬夏都是如此。',
    '亞14:9 耶和華必作全地的王。那日耶和華必為獨一無二的，他的名也是獨一無二的。',
    '亞14:10 全地，從迦巴直到耶路撒冷南方的臨門，要變為亞拉巴。耶路撒冷必仍居高位，就是從便雅憫門到第一門之處，又到角門，並從哈楠業樓，直到王的酒醡。',
    '亞14:11 人必住在其中，不再有咒詛。耶路撒冷人必安然居住。',
    '亞14:12 耶和華用災殃攻擊那與耶路撒冷爭戰的列國人，必是這樣：他們兩腳站立的時候，肉必消沒，眼在眶中乾癟，舌在口中潰爛。',
    '亞14:13 那日，耶和華必使他們大大擾亂。他們各人彼此揪住，舉手攻擊。',
    '亞14:14 猶大也必在耶路撒冷爭戰。那時四圍各國的財物，就是許多金銀衣服，必被收聚。',
    '亞14:15 那臨到馬匹、騾子、駱駝、驢，和營中一切牲畜的災殃是與那災殃一般。',
    '亞14:16 所有來攻擊耶路撒冷列國中剩下的人，必年年上來敬拜大君王─萬軍之耶和華，並守住棚節。',
    '亞14:17 地上萬族中，凡不上耶路撒冷敬拜大君王─萬軍之耶和華的，必無雨降在他們的地上。',
    '亞14:18 埃及族若不上來，雨也不降在他們的地上；凡不上來守住棚節的列國人，耶和華也必用這災攻擊他們。',
    '亞14:19 這就是埃及的刑罰和那不上來守住棚節之列國的刑罰。',
    '亞14:20 當那日，馬的鈴鐺上必有歸耶和華為聖的這句話。耶和華殿內的鍋必如祭壇前的碗一樣。',
    '亞14:21 凡耶路撒冷和猶大的鍋都必歸萬軍之耶和華為聖。凡獻祭的都必來取這鍋，煮肉在其中。當那日，在萬軍之耶和華的殿中必不再有迦南人。',
    '瑪1:1 耶和華藉瑪拉基傳給以色列的默示。',
    '瑪1:2 耶和華說：我曾愛你們。你們卻說：你在何事上愛我們呢﹖耶和華說：以掃不是雅各的哥哥嗎﹖我卻愛雅各，',
    '瑪1:3 惡以掃，使他的山嶺荒涼，把他的地業交給曠野的野狗。',
    '瑪1:4 以東人說：我們現在雖被毀壞，卻要重建荒廢之處。萬軍之耶和華如此說：任他們建造，我必拆毀；人必稱他們的地為罪惡之境；稱他們的民為耶和華永遠惱怒之民。',
    '瑪1:5 你們必親眼看見，也必說：願耶和華在以色列境界之外被尊為大！',
    '瑪1:6 藐視我名的祭司啊，萬軍之耶和華對你們說：兒子尊敬父親，僕人敬畏主人；我既為父親，尊敬我的在哪裡呢﹖我既為主人，敬畏我的在哪裡呢﹖你們卻說：我們在何事上藐視你的名呢﹖',
    '瑪1:7 你們將污穢的食物獻在我的壇上，且說：我們在何事上污穢你呢﹖因你們說，耶和華的桌子是可藐視的。',
    '瑪1:8 你們將瞎眼的獻為祭物，這不為惡嗎﹖將瘸腿的、有病的獻上，這不為惡嗎﹖你獻給你的省長，他豈喜悅你，豈能看你的情面嗎﹖這是萬軍之耶和華說的。',
    '瑪1:9 現在我勸你們懇求神，他好施恩與我們。這妄獻的事，既由你們經手，他豈能看你們的情面嗎﹖這是萬軍之耶和華說的。',
    '瑪1:10 甚願你們中間有一人關上殿門，免得你們徒然在我壇上燒火。萬軍之耶和華說：我不喜悅你們，也不從你們手中收納供物。',
    '瑪1:11 萬軍之耶和華說：從日出之地到日落之處，我的名在外邦中必尊為大。在各處，人必奉我的名燒香，獻潔淨的供物，因為我的名在外邦中必尊為大。',
    '瑪1:12 你們卻褻瀆我的名，說：耶和華的桌子是污穢的，其上的食物是可藐視的。',
    '瑪1:13 你們又說：這些事何等煩瑣！並嗤之以鼻。這是萬軍之耶和華說的。你們把搶奪的、瘸腿的、有病的拿來獻上為祭。我豈能從你們手中收納呢﹖這是耶和華說的。',
    '瑪1:14 行詭詐的在群中有公羊，他許願卻用有殘疾的獻給主，這人是可咒詛的。因為我是大君王，我的名在外邦中是可畏的。這是萬軍之耶和華說的。',
    '瑪2:1 眾祭司啊，這誡命是傳給你們的。',
    '瑪2:2 萬軍之耶和華說：你們若不聽從，也不放在心上，將榮耀歸與我的名，我就使咒詛臨到你們，使你們的福分變為咒詛；因你們不把誡命放在心上，我已經咒詛你們了。',
    '瑪2:3 我必斥責你們的種子，又把你們犧牲的糞抹你們的臉上；你們要與糞一同除掉。',
    '瑪2:4 你們就知道我傳這誡命給你們，使我與利未（或譯：利未人）所立的約可以常存。這是萬軍之耶和華說的。',
    '瑪2:5 我曾與他立生命和平安的約。我將這兩樣賜給他，使他存敬畏的心，他就敬畏我，懼怕我的名。',
    '瑪2:6 真實的律法在他口中，他嘴裡沒有不義的話。他以平安和正直與我同行，使多人回頭離開罪孽。',
    '瑪2:7 祭司的嘴裡當存知識，人也當由他口中尋求律法，因為他是萬軍之耶和華的使者。',
    '瑪2:8 你們卻偏離正道，使許多人在律法上跌倒。你們廢棄我與利未所立的約。這是萬軍之耶和華說的。',
    '瑪2:9 所以我使你們被眾人藐視，看為下賤；因你們不守我的道，竟在律法上瞻徇情面。',
    '瑪2:10 我們豈不都是一位父嗎﹖豈不是一位神所造的嗎﹖我們各人怎麼以詭詐待弟兄，背棄了神與我們列祖所立的約呢﹖',
    '瑪2:11 猶大人行事詭詐，並且在以色列和耶路撒冷中行一件可憎的事；因為猶大人褻瀆耶和華所喜愛的聖潔（或譯：聖地），娶事奉外邦神的女子為妻。',
    '瑪2:12 凡行這事的，無論何人（何人：原文是叫醒的，答應的），就是獻供物給萬軍之耶和華，耶和華也必從雅各的帳棚中剪除他。',
    '瑪2:13 你們又行了一件這樣的事，使前妻歎息哭泣的眼淚遮蓋耶和華的壇，以致耶和華不再看顧那供物，也不樂意從你們手中收納。',
    '瑪2:14 你們還說：這是為什麼呢﹖因耶和華在你和你幼年所娶的妻中間作見證。他雖是你的配偶，又是你盟約的妻，你卻以詭詐待他。',
    '瑪2:15 雖然神有靈的餘力能造多人，他不是單造一人嗎﹖為何只造一人呢﹖乃是他願人得虔誠的後裔。所以當謹守你們的心，誰也不可以詭詐待幼年所娶的妻。',
    '瑪2:16 耶和華─以色列的神說：休妻的事和以強暴待妻的人都是我所恨惡的！所以當謹守你們的心，不可行詭詐。這是萬軍之耶和華說的。',
    '瑪2:17 你們用言語煩瑣耶和華，你們還說：我們在何事上煩瑣他呢﹖因為你們說：凡行惡的，耶和華眼看為善，並且他喜悅他們；或說：公義的神在哪裡呢﹖',
    '瑪3:1 萬軍之耶和華說：我要差遣我的使者在我前面預備道路。你們所尋求的主必忽然進入他的殿；立約的使者，就是你們所仰慕的，快要來到。',
    '瑪3:2 他來的日子，誰能當得起呢﹖他顯現的時候，誰能立得住呢﹖因為他如煉金之人的火，如漂布之人的鹼。',
    '瑪3:3 他必坐下如煉淨銀子的，必潔淨利未人，熬煉他們像金銀一樣；他們就憑公義獻供物給耶和華。',
    '瑪3:4 那時，猶大和耶路撒冷所獻的供物必蒙耶和華悅納，彷彿古時之日、上古之年。',
    '瑪3:5 萬軍之耶和華說：我必臨近你們，施行審判。我必速速作見證，警戒行邪術的、犯姦淫的、起假誓的、虧負人之工價的、欺壓寡婦孤兒的、屈枉寄居的，和不敬畏我的。',
    '瑪3:6 因我─耶和華是不改變的，所以你們雅各之子沒有滅亡。',
    '瑪3:7 萬軍之耶和華說：從你們列祖的日子以來，你們常常偏離我的典章而不遵守。現在你們要轉向我，我就轉向你們。你們卻問說：我們如何才是轉向呢﹖',
    '瑪3:8 人豈可奪取神之物呢﹖你們竟奪取我的供物。你們卻說：我們在何事上奪取你的供物呢﹖就是你們在當納的十分之一和當獻的供物上。',
    '瑪3:9 因你們通國的人都奪取我的供物，咒詛就臨到你們身上。',
    '瑪3:10 萬軍之耶和華說：你們要將當納的十分之一全然送入倉庫，使我家有糧，以此試試我，是否為你們敞開天上的窗戶，傾福與你們，甚至無處可容。',
    '瑪3:11 萬軍之耶和華說：我必為你們斥責蝗蟲（原文是吞噬者），不容他毀壞你們的土產。你們田間的葡萄樹在未熟之先也不掉果子。',
    '瑪3:12 萬軍之耶和華說：萬國必稱你們為有福的，因你們的地必成為喜樂之地。',
    '瑪3:13 耶和華說：你們用話頂撞我，你們還說：我們用什麼話頂撞了你呢﹖',
    '瑪3:14 你們說：事奉神是徒然的，遵守神所吩咐的，在萬軍之耶和華面前苦苦齋戒，有什麼益處呢﹖',
    '瑪3:15 如今我們稱狂傲的人為有福，並且行惡的人得建立；他們雖然試探神，卻得脫離災難。',
    '瑪3:16 那時，敬畏耶和華的彼此談論，耶和華側耳而聽，且有記念冊在他面前，記錄那敬畏耶和華、思念他名的人。',
    '瑪3:17 萬軍之耶和華說：在我所定的日子，他們必屬我，特特歸我。我必憐恤他們，如同人憐恤服事自己的兒子。',
    '瑪3:18 那時你們必歸回，將善人和惡人，事奉神的和不事奉神的，分別出來。',
    '瑪4:1 萬軍之耶和華說：那日臨近，勢如燒著的火爐，凡狂傲的和行惡的必如碎稭，在那日必被燒盡，根本枝條一無存留。',
    '瑪4:2 但向你們敬畏我名的人必有公義的日頭出現，其光線（原文是翅膀）有醫治之能。你們必出來跳躍如圈裡的肥犢。',
    '瑪4:3 你們必踐踏惡人；在我所定的日子，他們必如灰塵在你們腳掌之下。這是萬軍之耶和華說的。',
    '瑪4:4 你們當記念我僕人摩西的律法，就是我在何烈山為以色列眾人所吩咐他的律例典章。',
    '瑪4:5 看哪，耶和華大而可畏之日未到以前，我必差遣先知以利亞到你們那裡去。',
    '瑪4:6 他必使父親的心轉向兒女，兒女的心轉向父親，免得我來咒詛遍地。',
    '太1:1 亞伯拉罕的後裔，大衛的子孫（後裔，子孫：原文是兒子；下同）耶穌基督的家譜：',
    '太1:2 亞伯拉罕生以撒；以撒生雅各；雅各生猶大和他的弟兄；',
    '太1:3 猶大從他瑪氏生法勒斯和謝拉；法勒斯生希斯崙；希斯崙生亞蘭；',
    '太1:4 亞蘭生亞米拿達；亞米拿達生拿順；拿順生撒門；',
    '太1:5 撒門從喇合氏生波阿斯；波阿斯從路得氏生俄備得；俄備得生耶西；',
    '太1:6 耶西生大衛王。大衛從烏利亞的妻子生所羅門；',
    '太1:7 所羅門生羅波安；羅波安生亞比雅；亞比雅生亞撒；',
    '太1:8 亞撒生約沙法；約沙法生約蘭；約蘭生烏西雅；',
    '太1:9 烏西雅生約坦；約坦生亞哈斯；亞哈斯生希西家；',
    '太1:10 希西家生瑪拿西；瑪拿西生亞們；亞們生約西亞；',
    '太1:11 百姓被遷到巴比倫的時候，約西亞生耶哥尼雅和他的弟兄。',
    '太1:12 遷到巴比倫之後，耶哥尼雅生撒拉鐵；撒拉鐵生所羅巴伯；',
    '太1:13 所羅巴伯生亞比玉；亞比玉生以利亞敬；以利亞敬生亞所；',
    '太1:14 亞所生撒督；撒督生亞金；亞金生以律；',
    '太1:15 以律生以利亞撒；以利亞撒生馬但；馬但生雅各；',
    '太1:16 雅各生約瑟，就是馬利亞的丈夫。那稱為基督的耶穌是從馬利亞生的。',
    '太1:17 這樣，從亞伯拉罕到大衛共有十四代；從大衛到遷至巴比倫的時候也有十四代；從遷至巴比倫的時候到基督又有十四代。',
    '太1:18 耶穌基督降生的事記在下面：他母親馬利亞已經許配了約瑟，還沒有迎娶，馬利亞就從聖靈懷了孕。',
    '太1:19 他丈夫約瑟是個義人，不願意明明的羞辱他，想要暗暗的把他休了。',
    '太1:20 正思念這事的時候，有主的使者向他夢中顯現，說：大衛的子孫約瑟，不要怕！只管娶過你的妻子馬利亞來，因他所懷的孕是從聖靈來的。',
    '太1:21 他將要生一個兒子，你要給他起名叫耶穌，因他要將自己的百姓從罪惡裡救出來。',
    '太1:22 這一切的事成就是要應驗主藉先知所說的話，',
    '太1:23 說：必有童女懷孕生子；人要稱他的名為以馬內利。（以馬內利翻出來就是神與我們同在。）',
    '太1:24 約瑟醒了，起來，就遵著主使者的吩咐把妻子娶過來；',
    '太1:25 只是沒有和他同房，等他生了兒子（有古卷：等他生了頭胎的兒子），就給他起名叫耶穌。',
    '太2:1 當希律王的時候，耶穌生在猶太的伯利恆。有幾個博士從東方來到耶路撒冷，說：',
    '太2:2 那生下來作猶太人之王的在哪裡﹖我們在東方看見他的星，特來拜他。',
    '太2:3 希律王聽見了，就心裡不安；耶路撒冷合城的人也都不安。',
    '太2:4 他就召齊了祭司長和民間的文士，問他們說：基督當生在何處﹖',
    '太2:5 他們回答說：在猶太的伯利恆。因為有先知記著，說：',
    '太2:6 猶大地的伯利恆啊，你在猶大諸城中並不是最小的；因為將來有一位君王要從你那裡出來，牧養我以色列民。',
    '太2:7 當下，希律暗暗的召了博士來，細問那星是什麼時候出現的，',
    '太2:8 就差他們往伯利恆去，說：你們去仔細尋訪那小孩子，尋到了，就來報信，我也好去拜他。',
    '太2:9 他們聽見王的話就去了。在東方所看見的那星忽然在他們前頭行，直行到小孩子的地方，就在上頭停住了。',
    '太2:10 他們看見那星，就大大的歡喜；',
    '太2:11 進了房子，看見小孩子和他母親馬利亞，就俯伏拜那小孩子，揭開寶盒，拿黃金、乳香、沒藥為禮物獻給他。',
    '太2:12 博士因為在夢中被主指示不要回去見希律，就從別的路回本地去了。',
    '太2:13 他們去後，有主的使者向約瑟夢中顯現，說：起來！帶著小孩子同他母親逃往埃及，住在那裡，等我吩咐你；因為希律必尋找小孩子，要除滅他。',
    '太2:14 約瑟就起來，夜間帶著小孩子和他母親往埃及去，',
    '太2:15 住在那裡，直到希律死了。這是要應驗主藉先知所說的話，說：我從埃及召出我的兒子來。',
    '太2:16 希律見自己被博士愚弄，就大大發怒，差人將伯利恆城裡並四境所有的男孩，照著他向博士仔細查問的時候，凡兩歲以裡的，都殺盡了。',
    '太2:17 這就應了先知耶利米的話，說：',
    '太2:18 在拉瑪聽見號咷大哭的聲音，是拉結哭他兒女，不肯受安慰，因為他們都不在了。',
    '太2:19 希律死了以後，有主的使者在埃及向約瑟夢中顯現，說：',
    '太2:20 起來！帶著小孩子和他母親往以色列地去，因為要害小孩子性命的人已經死了。',
    '太2:21 約瑟就起來，把小孩子和他母親帶到以色列地去；',
    '太2:22 只因聽見亞基老接著他父親希律作了猶太王，就怕往那裡去，又在夢中被主指示，便往加利利境內去了，',
    '太2:23 到了一座城，名叫拿撒勒，就住在那裡。這是要應驗先知所說，他將稱為拿撒勒人的話了。',
    '太3:1 那時，有施洗的約翰出來，在猶太的曠野傳道，說：',
    '太3:2 天國近了，你們應當悔改！',
    '太3:3 這人就是先知以賽亞所說的。他說：在曠野有人聲喊著說：預備主的道，修直他的路！',
    '太3:4 這約翰身穿駱駝毛的衣服，腰束皮帶，吃的是蝗蟲、野蜜。',
    '太3:5 那時，耶路撒冷和猶太全地，並約但河一帶地方的人，都出去到約翰那裡，',
    '太3:6 承認他們的罪，在約但河裡受他的洗。',
    '太3:7 約翰看見許多法利賽人和撒都該人也來受洗，就對他們說：毒蛇的種類！誰指示你們逃避將來的忿怒呢﹖',
    '太3:8 你們要結出果子來，與悔改的心相稱。',
    '太3:9 不要自己心裡說：有亞伯拉罕為我們的祖宗。我告訴你們，神能從這些石頭中給亞伯拉罕興起子孫來。',
    '太3:10 現在斧子已經放在樹根上，凡不結好果子的樹就砍下來，丟在火裡。',
    '太3:11 我是用水給你們施洗，叫你們悔改。但那在我以後來的，能力比我更大，我就是給他提鞋也不配。他要用聖靈與火給你們施洗。',
    '太3:12 他手裡拿著簸箕，要揚淨他的場，把麥子收在倉裡，把糠用不滅的火燒盡了。',
    '太3:13 當下耶穌從加利利來到約但河，見了約翰，要受他的洗。',
    '太3:14 約翰想要攔住他，說：我當受你的洗，你反倒上我這裡來嗎﹖',
    '太3:15 耶穌回答說：你暫且許我，因為我們理當這樣盡諸般的義（或作：禮）。於是約翰許了他。',
    '太3:16 耶穌受了洗，隨即從水裡上來。天忽然為他開了，他就看見神的靈彷彿鴿子降下，落在他身上。',
    '太3:17 從天上有聲音說：這是我的愛子，我所喜悅的。',
    '太4:1 當時，耶穌被聖靈引到曠野，受魔鬼的試探。',
    '太4:2 他禁食四十晝夜，後來就餓了。',
    '太4:3 那試探人的進前來，對他說：你若是神的兒子，可以吩咐這些石頭變成食物。',
    '太4:4 耶穌卻回答說：經上記著說：人活著，不是單靠食物，乃是靠神口裡所出的一切話。',
    '太4:5 魔鬼就帶他進了聖城，叫他站在殿頂（頂：原文是翅）上，',
    '太4:6 對他說：你若是神的兒子，可以跳下去，因為經上記著說：主要為你吩咐他的使者用手托著你，免得你的腳碰在石頭上。',
    '太4:7 耶穌對他說：經上又記著說：不可試探主─你的神。',
    '太4:8 魔鬼又帶他上了一座最高的山，將世上的萬國與萬國的榮華都指給他看，',
    '太4:9 對他說：你若俯伏拜我，我就把這一切都賜給你。',
    '太4:10 耶穌說：撒但（撒但就是抵擋的意思，乃魔鬼的別名），退去吧！因為經上記著說：當拜主你的神，單要事奉他。',
    '太4:11 於是，魔鬼離了耶穌，有天使來伺候他。',
    '太4:12 耶穌聽見約翰下了監，就退到加利利去；',
    '太4:13 後又離開拿撒勒，往迦百農去，就住在那裡。那地方靠海，在西布倫和拿弗他利的邊界上。',
    '太4:14 這是要應驗先知以賽亞的話，',
    '太4:15 說：西布倫地，拿弗他利地，就是沿海的路，約但河外，外邦人的加利利地。',
    '太4:16 那坐在黑暗裡的百姓看見了大光；坐在死蔭之地的人有光發現照著他們。',
    '太4:17 從那時候，耶穌就傳起道來，說：天國近了，你們應當悔改！',
    '太4:18 耶穌在加利利海邊行走，看見弟兄二人，就是那稱呼彼得的西門和他兄弟安得烈，在海裡撒網；他們本是打魚的。',
    '太4:19 耶穌對他們說：來跟從我，我要叫你們得人如得魚一樣。',
    '太4:20 他們就立刻捨了網，跟從了他。',
    '太4:21 從那裡往前走，又看見弟兄二人，就是西庇太的兒子雅各和他兄弟約翰，同他們的父親西庇太在船上補網，耶穌就招呼他們，',
    '太4:22 他們立刻捨了船，別了父親，跟從了耶穌。',
    '太4:23 耶穌走遍加利利，在各會堂裡教訓人，傳天國的福音，醫治百姓各樣的病症。',
    '太4:24 他的名聲就傳遍了敘利亞。那裡的人把一切害病的，就是害各樣疾病、各樣疼痛的和被鬼附的、癲癇的、癱瘓的，都帶了來，耶穌就治好了他們。',
    '太4:25 當下，有許多人從加利利、低加波利、耶路撒冷、猶太、約但河外來跟著他。',
    '太5:1 耶穌看見這許多的人，就上了山，既已坐下，門徒到他跟前來，',
    '太5:2 他就開口教訓他們，說：',
    '太5:3 虛心的人有福了！因為天國是他們的。',
    '太5:4 哀慟的人有福了！因為他們必得安慰。',
    '太5:5 溫柔的人有福了！因為他們必承受地土。',
    '太5:6 飢渴慕義的人有福了！因為他們必得飽足。',
    '太5:7 憐恤人的人有福了！因為他們必蒙憐恤。',
    '太5:8 清心的人有福了！因為他們必得見神。',
    '太5:9 使人和睦的人有福了！因為他們必稱為神的兒子。',
    '太5:10 為義受逼迫的人有福了！因為天國是他們的。',
    '太5:11 人若因我辱罵你們，逼迫你們，捏造各樣壞話毀謗你們，你們就有福了！',
    '太5:12 應當歡喜快樂，因為你們在天上的賞賜是大的。在你們以前的先知，人也是這樣逼迫他們。',
    '太5:13 你們是世上的鹽。鹽若失了味，怎能叫他再鹹呢﹖以後無用，不過丟在外面，被人踐踏了。',
    '太5:14 你們是世上的光。城造在山上是不能隱藏的。',
    '太5:15 人點燈，不放在斗底下，是放在燈臺上，就照亮一家的人。',
    '太5:16 你們的光也當這樣照在人前，叫他們看見你們的好行為，便將榮耀歸給你們在天上的父。',
    '太5:17 莫想我來要廢掉律法和先知。我來不是要廢掉，乃是要成全。',
    '太5:18 我實在告訴你們，就是到天地都廢去了，律法的一點一畫也不能廢去，都要成全。',
    '太5:19 所以，無論何人廢掉這誡命中最小的一條，又教訓人這樣做，他在天國要稱為最小的。但無論何人遵行這誡命，又教訓人遵行，他在天國要稱為大的。',
    '太5:20 我告訴你們，你們的義若不勝於文士和法利賽人的義，斷不能進天國。',
    '太5:21 你們聽見有吩咐古人的話，說：不可殺人；又說：凡殺人的難免受審判。',
    '太5:22 只是我告訴你們：凡（有古卷在凡字下加：無緣無故地）向弟兄動怒的，難免受審斷；凡罵弟兄是拉加的，難免公會的審斷；凡罵弟兄是魔利的，難免地獄的火。',
    '太5:23 所以，你在祭壇上獻禮物的時候，若想起弟兄向你懷怨，',
    '太5:24 就把禮物留在壇前，先去同弟兄和好，然後來獻禮物。',
    '太5:25 你同告你的對頭還在路上，就趕緊與他和息，恐怕他把你送給審判官，審判官交付衙役，你就下在監裡了。',
    '太5:26 我實在告訴你，若有一文錢沒有還清，你斷不能從那裡出來。',
    '太5:27 你們聽見有話說：不可姦淫。',
    '太5:28 只是我告訴你們，凡看見婦女就動淫念的，這人心裡已經與他犯姦淫了。',
    '太5:29 若是你的右眼叫你跌倒，就剜出來丟掉，寧可失去百體中的一體，不叫全身丟在地獄裡。',
    '太5:30 若是右手叫你跌倒，就砍下來丟掉，寧可失去百體中的一體，不叫全身下入地獄。',
    '太5:31 又有話說：人若休妻，就當給他休書。',
    '太5:32 只是我告訴你們，凡休妻的，若不是為淫亂的緣故，就是叫他作淫婦了；人若娶這被休的婦人，也是犯姦淫了。',
    '太5:33 你們又聽見有吩咐古人的話，說：不可背誓，所起的誓總要向主謹守。',
    '太5:34 只是我告訴你們，什麼誓都不可起。不可指著天起誓，因為天是神的座位；',
    '太5:35 不可指著地起誓，因為地是他的腳凳；也不可指著耶路撒冷起誓，因為耶路撒冷是大君的京城；',
    '太5:36 又不可指著你的頭起誓，因為你不能使一根頭髮變黑變白了。',
    '太5:37 你們的話，是，就說是；不是，就說不是；若再多說，就是出於那惡者（或作：就是從惡裡出來的）。',
    '太5:38 你們聽見有話說：以眼還眼，以牙還牙。',
    '太5:39 只是我告訴你們，不要與惡人作對。有人打你的右臉，連左臉也轉過來由他打；',
    '太5:40 有人想要告你，要拿你的裡衣，連外衣也由他拿去；',
    '太5:41 有人強逼你走一里路，你就同他走二里；',
    '太5:42 有求你的，就給他；有向你借貸的，不可推辭。',
    '太5:43 你們聽見有話說：當愛你的鄰舍，恨你的仇敵。',
    '太5:44 只是我告訴你們，要愛你們的仇敵，為那逼迫你們的禱告。',
    '太5:45 這樣就可以作你們天父的兒子；因為他叫日頭照好人，也照歹人；降雨給義人，也給不義的人。',
    '太5:46 你們若單愛那愛你們的人，有什麼賞賜呢﹖就是稅吏不也是這樣行嗎﹖',
    '太5:47 你們若單請你弟兄的安，比人有什麼長處呢﹖就是外邦人不也是這樣行嗎﹖',
    '太5:48 所以，你們要完全，像你們的天父完全一樣。',
    '太6:1 你們要小心，不可將善事行在人的面前，故意叫他們看見，若是這樣，就不能得你們天父的賞賜了。',
    '太6:2 所以，你施捨的時候，不可在你前面吹號，像那假冒為善的人在會堂裡和街道上所行的，故意要得人的榮耀。我實在告訴你們，他們已經得了他們的賞賜。',
    '太6:3 你施捨的時候，不要叫左手知道右手所做的，',
    '太6:4 要叫你施捨的事行在暗中。你父在暗中察看，必然報答你（有古卷：必在明處報答你）。',
    '太6:5 你們禱告的時候，不可像那假冒為善的人，愛站在會堂裡和十字路口上禱告，故意叫人看見。我實在告訴你們，他們已經得了他們的賞賜。',
    '太6:6 你禱告的時候，要進你的內屋，關上門，禱告你在暗中的父；你父在暗中察看，必然報答你。',
    '太6:7 你們禱告，不可像外邦人，用許多重複話，他們以為話多了必蒙垂聽。',
    '太6:8 你們不可效法他們；因為你們沒有祈求以先，你們所需用的，你們的父早已知道了。',
    '太6:9 所以，你們禱告要這樣說：我們在天上的父：願人都尊你的名為聖。',
    '太6:10 願你的國降臨；願你的旨意行在地上，如同行在天上。',
    '太6:11 我們日用的飲食，今日賜給我們。',
    '太6:12 免我們的債，如同我們免了人的債。',
    '太6:13 不叫我們遇見試探；救我們脫離兇惡（或作：脫離惡者）。因為國度、權柄、榮耀，全是你的，直到永遠。阿們（有古卷沒有因為……阿們等字）！',
    '太6:14 你們饒恕人的過犯，你們的天父也必饒恕你們的過犯；',
    '太6:15 你們不饒恕人的過犯，你們的天父也必不饒恕你們的過犯。',
    '太6:16 你們禁食的時候，不可像那假冒為善的人，臉上帶著愁容；因為他們把臉弄得難看，故意叫人看出他們是禁食。我實在告訴你們，他們已經得了他們的賞賜。',
    '太6:17 你禁食的時候，要梳頭洗臉，',
    '太6:18 不叫人看出你禁食來，只叫你暗中的父看見；你父在暗中察看，必然報答你。',
    '太6:19 不要為自己積儹財寶在地上；地上有蟲子咬，能銹壞，也有賊挖窟窿來偷。',
    '太6:20 只要積儹財寶在天上；天上沒有蟲子咬，不能銹壞，也沒有賊挖窟窿來偷。',
    '太6:21 因為你的財寶在哪裡，你的心也在那裡。',
    '太6:22 眼睛就是身上的燈。你的眼睛若瞭亮，全身就光明；',
    '太6:23 你的眼睛若昏花，全身就黑暗。你裡頭的光若黑暗了，那黑暗是何等大呢！',
    '太6:24 一個人不能事奉兩個主；不是惡這個，愛那個，就是重這個，輕那個。你們不能又事奉神，又事奉瑪門（瑪門：財利的意思）。',
    '太6:25 所以我告訴你們，不要為生命憂慮吃什麼，喝什麼；為身體憂慮穿什麼。生命不勝於飲食嗎﹖身體不勝於衣裳嗎﹖',
    '太6:26 你們看那天上的飛鳥，也不種，也不收，也不積蓄在倉裡，你們的天父尚且養活他。你們不比飛鳥貴重得多嗎﹖',
    '太6:27 你們哪一個能用思慮使壽數多加一刻呢（或作：使身量多加一肘呢）﹖',
    '太6:28 何必為衣裳憂慮呢﹖你想野地裡的百合花怎麼長起來；他也不勞苦，也不紡線。',
    '太6:29 然而我告訴你們，就是所羅門極榮華的時候，他所穿戴的，還不如這花一朵呢！',
    '太6:30 你們這小信的人哪！野地裡的草今天還在，明天就丟在爐裡，神還給他這樣的妝飾，何況你們呢！',
    '太6:31 所以，不要憂慮說：吃什麼﹖喝什麼﹖穿什麼﹖',
    '太6:32 這都是外邦人所求的，你們需用的這一切東西，你們的天父是知道的。',
    '太6:33 你們要先求他的國和他的義，這些東西都要加給你們了。',
    '太6:34 所以，不要為明天憂慮，因為明天自有明天的憂慮；一天的難處一天當就夠了。',
    '太7:1 你們不要論斷人，免得你們被論斷。',
    '太7:2 因為你們怎樣論斷人，也必怎樣被論斷；你們用什麼量器量給人，也必用什麼量器量給你們。',
    '太7:3 為什麼看見你弟兄眼中有刺，卻不想自己眼中有梁木呢﹖',
    '太7:4 你自己眼中有梁木，怎能對你弟兄說：容我去掉你眼中的刺呢﹖',
    '太7:5 你這假冒為善的人！先去掉自己眼中的梁木，然後才能看得清楚，去掉你弟兄眼中的刺。',
    '太7:6 不要把聖物給狗，也不要把你們的珍珠丟在豬前，恐怕他踐踏了珍珠，轉過來咬你們。',
    '太7:7 你們祈求，就給你們；尋找，就尋見；叩門，就給你們開門。',
    '太7:8 因為凡祈求的，就得著；尋找的，就尋見；叩門的，就給他開門。',
    '太7:9 你們中間誰有兒子求餅，反給他石頭呢﹖',
    '太7:10 求魚，反給他蛇呢﹖',
    '太7:11 你們雖然不好，尚且知道拿好東西給兒女，何況你們在天上的父，豈不更把好東西給求他的人嗎﹖',
    '太7:12 所以，無論何事，你們願意人怎樣待你們，你們也要怎樣待人，因為這就是律法和先知的道理。',
    '太7:13 你們要進窄門。因為引到滅亡，那門是寬的，路是大的，進去的人也多；',
    '太7:14 引到永生，那門是窄的，路是小的，找著的人也少。',
    '太7:15 你們要防備假先知。他們到你們這裡來，外面披著羊皮，裡面卻是殘暴的狼。',
    '太7:16 憑著他們的果子，就可以認出他們來。荊棘上豈能摘葡萄呢﹖蒺藜裡豈能摘無花果呢﹖',
    '太7:17 這樣，凡好樹都結好果子，惟獨壞樹結壞果子。',
    '太7:18 好樹不能結壞果子；壞樹不能結好果子。',
    '太7:19 凡不結好果子的樹就砍下來，丟在火裡。',
    '太7:20 所以，憑著他們的果子就可以認出他們來。',
    '太7:21 凡稱呼我主啊，主啊的人不能都進天國；惟獨遵行我天父旨意的人才能進去。',
    '太7:22 當那日必有許多人對我說：主啊，主啊，我們不是奉你的名傳道，奉你的名趕鬼，奉你的名行許多異能嗎﹖',
    '太7:23 我就明明的告訴他們說：我從來不認識你們，你們這些作惡的人，離開我去吧！',
    '太7:24 所以，凡聽見我這話就去行的，好比一個聰明人，把房子蓋在磐石上；',
    '太7:25 雨淋，水沖，風吹，撞著那房子，房子總不倒塌，因為根基立在磐石上。',
    '太7:26 凡聽見我這話不去行的，好比一個無知的人，把房子蓋在沙土上；',
    '太7:27 雨淋，水沖，風吹，撞著那房子，房子就倒塌了，並且倒塌得很大。',
    '太7:28 耶穌講完了這些話，眾人都希奇他的教訓；',
    '太7:29 因為他教訓他們，正像有權柄的人，不像他們的文士。',
    '太8:1 耶穌下了山，有許多人跟著他。',
    '太8:2 有一個長大痲瘋的來拜他，說：主若肯，必能叫我潔淨了。',
    '太8:3 耶穌伸手摸他，說：我肯，你潔淨了吧！他的大痲瘋立刻就潔淨了。',
    '太8:4 耶穌對他說：你切不可告訴人，只要去把身體給祭司察看，獻上摩西所吩咐的禮物，對眾人作證據。',
    '太8:5 耶穌進了迦百農，有一個百夫長進前來，求他說：',
    '太8:6 主啊，我的僕人害癱瘓病，躺在家裡，甚是疼苦。',
    '太8:7 耶穌說：我去醫治他。',
    '太8:8 百夫長回答說：主啊，你到我舍下，我不敢當；只要你說一句話，我的僕人就必好了。',
    '太8:9 因為我在人的權下，也有兵在我以下；對這個說：去！他就去；對那個說：來！他就來；對我的僕人說：你做這事！他就去做。',
    '太8:10 耶穌聽見就希奇，對跟從的人說：我實在告訴你們，這麼大的信心，就是在以色列中，我也沒有遇見過。',
    '太8:11 我又告訴你們，從東從西，將有許多人來，在天國裡與亞伯拉罕、以撒、雅各一同坐席；',
    '太8:12 惟有本國的子民竟被趕到外邊黑暗裡去，在那裡必要哀哭切齒了。',
    '太8:13 耶穌對百夫長說：你回去吧！照你的信心，給你成全了。那時，他的僕人就好了。',
    '太8:14 耶穌到了彼得家裡，見彼得的岳母害熱病躺著。',
    '太8:15 耶穌把他的手一摸，熱就退了；他就起來服事耶穌。',
    '太8:16 到了晚上，有人帶著許多被鬼附的來到耶穌跟前，他只用一句話就把鬼都趕出去，並且治好了一切有病的人。',
    '太8:17 這是要應驗先知以賽亞的話，說：他代替我們的軟弱，擔當我們的疾病。',
    '太8:18 耶穌見許多人圍著他，就吩咐渡到那邊去。',
    '太8:19 有一個文士來，對他說：夫子，你無論往哪裡去，我要跟從你。',
    '太8:20 耶穌說：狐狸有洞，天空的飛鳥有窩，人子卻沒有枕頭的地方。',
    '太8:21 又有一個門徒對耶穌說：主啊，容我先回去埋葬我的父親。',
    '太8:22 耶穌說：任憑死人埋葬他們的死人；你跟從我吧！',
    '太8:23 耶穌上了船，門徒跟著他。',
    '太8:24 海裡忽然起了暴風，甚至船被波浪掩蓋；耶穌卻睡著了。',
    '太8:25 門徒來叫醒了他，說：主啊，救我們，我們喪命啦！',
    '太8:26 耶穌說：你們這小信的人哪，為什麼膽怯呢﹖於是起來，斥責風和海，風和海就大大的平靜了。',
    '太8:27 眾人希奇，說：這是怎樣的人﹖連風和海也聽從他了！',
    '太8:28 耶穌既渡到那邊去，來到加大拉人的地方，就有兩個被鬼附的人從墳塋裡出來迎著他，極其兇猛，甚至沒有人能從那條路上經過。',
    '太8:29 他們喊著說：神的兒子，我們與你有什麼相干﹖時候還沒有到，你就上這裡來叫我們受苦嗎﹖',
    '太8:30 離他們很遠，有一大群豬吃食。',
    '太8:31 鬼就央求耶穌，說：若把我們趕出去，就打發我們進入豬群吧！',
    '太8:32 耶穌說：去吧！鬼就出來，進入豬群。全群忽然闖下山崖，投在海裡淹死了。',
    '太8:33 放豬的就逃跑進城，將這一切事和被鬼附的人所遭遇的都告訴人。',
    '太8:34 合城的人都出來迎見耶穌，既見了就央求他離開他們的境界。',
    '太9:1 耶穌上了船，渡過海，來到自己的城裡。',
    '太9:2 有人用褥子擡著一個癱子到耶穌跟前來。耶穌見他們的信心，就對癱子說：小子，放心吧！你的罪赦了。',
    '太9:3 有幾個文士心裡說：這個人說僭妄的話了。',
    '太9:4 耶穌知道他們的心意，就說：你們為什麼心裡懷著惡念呢﹖',
    '太9:5 或說：你的罪赦了，或說：你起來行走，哪一樣容易呢﹖',
    '太9:6 但要叫你們知道，人子在地上有赦罪的權柄；就對癱子說：起來！拿你的褥子回家去吧。',
    '太9:7 那人就起來，回家去了。',
    '太9:8 眾人看見都驚奇，就歸榮耀與神，因為他將這樣的權柄賜給人。',
    '太9:9 耶穌從那裡往前走，看見一個人名叫馬太，坐在稅關上，就對他說：你跟從我來。他就起來跟從了耶穌。',
    '太9:10 耶穌在屋裡坐席的時候，有好些稅吏和罪人來，與耶穌和他的門徒一同坐席。',
    '太9:11 法利賽人看見，就對耶穌的門徒說：你們的先生為什麼和稅吏並罪人一同吃飯呢﹖',
    '太9:12 耶穌聽見，就說：康健的人用不著醫生，有病的人才用得著。',
    '太9:13 經上說：我喜愛憐恤，不喜愛祭祀。這句話的意思，你們且去揣摩。我來本不是召義人，乃是召罪人。',
    '太9:14 那時，約翰的門徒來見耶穌，說：我們和法利賽人常常禁食，你的門徒倒不禁食，這是為什麼呢﹖',
    '太9:15 耶穌對他們說：新郎和陪伴之人同在的時候，陪伴之人豈能哀慟呢﹖但日子將到，新郎要離開他們，那時候他們就要禁食。',
    '太9:16 沒有人把新布補在舊衣服上；因為所補上的反帶壞了那衣服，破的就更大了。',
    '太9:17 也沒有人把新酒裝在舊皮袋裡；若是這樣，皮袋就裂開，酒漏出來，連皮袋也壞了。惟獨把新酒裝在新皮袋裡，兩樣就都保全了。',
    '太9:18 耶穌說這話的時候，有一個管會堂的來拜他，說：我女兒剛才死了，求你去按手在他身上，他就必活了。',
    '太9:19 耶穌便起來跟著他去；門徒也跟了去。',
    '太9:20 有一個女人，患了十二年的血漏，來到耶穌背後，摸他的衣裳繸子；',
    '太9:21 因為他心裡說：我只摸他的衣裳，就必痊癒。',
    '太9:22 耶穌轉過來，看見他，就說：女兒，放心！你的信救了你。從那時候，女人就痊癒了。',
    '太9:23 耶穌到了管會堂的家裡，看見有吹手，又有許多人亂嚷，',
    '太9:24 就說：退去吧！這閨女不是死了，是睡著了。他們就嗤笑他。',
    '太9:25 眾人既被攆出，耶穌就進去，拉著閨女的手，閨女便起來了。',
    '太9:26 於是這風聲傳遍了那地方。',
    '太9:27 耶穌從那裡往前走，有兩個瞎子跟著他，喊叫說：大衛的子孫，可憐我們吧！',
    '太9:28 耶穌進了房子，瞎子就來到他跟前。耶穌說：你們信我能做這事嗎﹖他們說：主啊，我們信。',
    '太9:29 耶穌就摸他們的眼睛，說：照著你們的信給你們成全了吧。',
    '太9:30 他們的眼睛就開了。耶穌切切的囑咐他們說：你們要小心，不可叫人知道。',
    '太9:31 他們出去，竟把他的名聲傳遍了那地方。',
    '太9:32 他們出去的時候，有人將鬼所附的一個啞巴帶到耶穌跟前來。',
    '太9:33 鬼被趕出去，啞巴就說出話來。眾人都希奇，說：在以色列中，從來沒有見過這樣的事。',
    '太9:34 法利賽人卻說：他是靠著鬼王趕鬼。',
    '太9:35 耶穌走遍各城各鄉，在會堂裡教訓人，宣講天國的福音，又醫治各樣的病症。',
    '太9:36 他看見許多的人，就憐憫他們；因為他們困苦流離，如同羊沒有牧人一般。',
    '太9:37 於是對門徒說：要收的莊稼多，做工的人少。',
    '太9:38 所以，你們當求莊稼的主打發工人出去收他的莊稼。',
    '太10:1 耶穌叫了十二個門徒來，給他們權柄，能趕逐污鬼，並醫治各樣的病症。',
    '太10:2 這十二使徒的名：頭一個叫西門、又稱彼得，還有他兄弟安得烈，西庇太的兒子雅各和雅各的兄弟約翰，',
    '太10:3 腓力和巴多羅買，多馬和稅吏馬太，亞勒腓的兒子雅各，和達太，',
    '太10:4 奮銳黨的西門，還有賣耶穌的加略人猶大。',
    '太10:5 耶穌差這十二個人去，吩咐他們說：外邦人的路，你們不要走；撒瑪利亞人的城，你們不要進；',
    '太10:6 寧可往以色列家迷失的羊那裡去。',
    '太10:7 隨走隨傳，說天國近了！',
    '太10:8 醫治病人，叫死人復活，叫長大痲瘋的潔淨，把鬼趕出去。你們白白的得來，也要白白的捨去。',
    '太10:9 腰袋裡不要帶金銀銅錢。',
    '太10:10 行路不要帶口袋；不要帶兩件褂子，也不要帶鞋和柺杖。因為工人得飲食是應當的。',
    '太10:11 你們無論進哪一城，哪一村，要打聽那裡誰是好人，就住在他家，直住到走的時候。',
    '太10:12 進他家裡去，要請他的安。',
    '太10:13 那家若配得平安，你們所求的平安就必臨到那家；若不配得，你們所求的平安仍歸你們。',
    '太10:14 凡不接待你們、不聽你們話的人，你們離開那家，或是那城的時候，就把腳上的塵土跺下去。',
    '太10:15 我實在告訴你們，當審判的日子，所多瑪和蛾摩拉所受的，比那城還容易受呢！',
    '太10:16 我差你們去，如同羊進入狼群；所以你們要靈巧像蛇，馴良像鴿子。',
    '太10:17 你們要防備人；因為他們要把你們交給公會，也要在會堂裡鞭打你們，',
    '太10:18 並且你們要為我的緣故被送到諸侯君王面前，對他們和外邦人作見證。',
    '太10:19 你們被交的時候，不要思慮怎樣說話，或說什麼話。到那時候，必賜給你們當說的話；',
    '太10:20 因為不是你們自己說的，乃是你們父的靈在你們裡頭說的。',
    '太10:21 弟兄要把弟兄，父親要把兒子，送到死地；兒女要與父母為敵，害死他們；',
    '太10:22 並且你們要為我的名被眾人恨惡。惟有忍耐到底的必然得救。',
    '太10:23 有人在這城裡逼迫你們，就逃到那城裡去。我實在告訴你們，以色列的城邑，你們還沒有走遍，人子就到了。',
    '太10:24 學生不能高過先生；僕人不能高過主人。',
    '太10:25 學生和先生一樣，僕人和主人一樣，也就罷了。人既罵家主是別西卜（別西卜：是鬼王的名），何況他的家人呢﹖',
    '太10:26 所以，不要怕他們；因為掩蓋的事沒有不露出來的，隱藏的事沒有不被人知道的。',
    '太10:27 我在暗中告訴你們的，你們要在明處說出來；你們耳中所聽的，要在房上宣揚出來。',
    '太10:28 那殺身體，不能殺靈魂的，不要怕他們；惟有能把身體和靈魂都滅在地獄裡的，正要怕他。',
    '太10:29 兩個麻雀不是賣一分銀子嗎﹖若是你們的父不許，一個也不能掉在地上；',
    '太10:30 就是你們的頭髮也都被數過了。',
    '太10:31 所以，不要懼怕，你們比許多麻雀還貴重！',
    '太10:32 凡在人面前認我的，我在我天上的父面前也必認他；',
    '太10:33 凡在人面前不認我的，我在我天上的父面前也必不認他。',
    '太10:34 你們不要想我來是叫地上太平；我來並不是叫地上太平，乃是叫地上動刀兵。',
    '太10:35 因為我來是叫人與父親生疏，女兒與母親生疏，媳婦與婆婆生疏。',
    '太10:36 人的仇敵就是自己家裡的人。',
    '太10:37 愛父母過於愛我的，不配作我的門徒；愛兒女過於愛我的，不配作我的門徒；',
    '太10:38 不背著他的十字架跟從我的，也不配作我的門徒。',
    '太10:39 得著生命的，將要失喪生命；為我失喪生命的，將要得著生命。',
    '太10:40 人接待你們就是接待我；接待我就是接待那差我來的。',
    '太10:41 人因為先知的名接待先知，必得先知所得的賞賜；人因為義人的名接待義人，必得義人所得的賞賜。',
    '太10:42 無論何人，因為門徒的名，只把一杯涼水給這小子裡的一個喝，我實在告訴你們，這人不能不得賞賜。',
    '太11:1 耶穌吩咐完了十二個門徒，就離開那裡，往各城去傳道，教訓人。',
    '太11:2 約翰在監裡聽見基督所做的事，就打發兩個門徒去，',
    '太11:3 問他說：那將要來的是你嗎﹖還是我們等候別人呢﹖',
    '太11:4 耶穌回答說：你們去，把所聽見，所看見的事告訴約翰。',
    '太11:5 就是瞎子看見，瘸子行走，長大痲瘋的潔淨，聾子聽見，死人復活，窮人有福音傳給他們。',
    '太11:6 凡不因我跌倒的就有福了！',
    '太11:7 他們走的時候，耶穌就對眾人講論約翰說：你們從前出到曠野是要看什麼呢﹖要看風吹動的蘆葦嗎﹖',
    '太11:8 你們出去到底是要看什麼﹖要看穿細軟衣服的人嗎﹖那穿細軟衣服的人是在王宮裡。',
    '太11:9 你們出去究竟是為什麼﹖是要看先知嗎﹖我告訴你們，是的，他比先知大多了。',
    '太11:10 經上記著說：我要差遣我的使者在你前面預備道路，所說的就是這個人。',
    '太11:11 我實在告訴你們，凡婦人所生的，沒有一個興起來大過施洗約翰的；然而天國裡最小的比他還大。',
    '太11:12 從施洗約翰的時候到如今，天國是努力進入的，努力的人就得著了。',
    '太11:13 因為眾先知和律法說預言，到約翰為止。',
    '太11:14 你們若肯領受，這人就是那應當來的以利亞。',
    '太11:15 有耳可聽的，就應當聽！',
    '太11:16 我可用什麼比這世代呢﹖好像孩童坐在街市上招呼同伴，說：',
    '太11:17 我們向你們吹笛，你們不跳舞；我們向你們舉哀，你們不捶胸。',
    '太11:18 約翰來了，也不吃也不喝，人就說他是被鬼附著的；',
    '太11:19 人子來了，也吃也喝，人又說他是貪食好酒的人，是稅吏和罪人的朋友。但智慧之子總以智慧為是（有古卷：但智慧在行為上就顯為是）。',
    '太11:20 耶穌在諸城中行了許多異能，那些城的人終不悔改，就在那時候責備他們，說：',
    '太11:21 哥拉汛哪，你有禍了！伯賽大啊，你有禍了！因為在你們中間所行的異能，若行在推羅、西頓，他們早已披麻蒙灰悔改了。',
    '太11:22 但我告訴你們，當審判的日子，推羅、西頓所受的，比你們還容易受呢！',
    '太11:23 迦百農啊，你已經升到天上（或作：你將要升到天上嗎），將來必墜落陰間；因為在你那裡所行的異能，若行在所多瑪，他還可以存到今日。',
    '太11:24 但我告訴你們，當審判的日子，所多瑪所受的，比你還容易受呢！',
    '太11:25 那時，耶穌說：父啊，天地的主，我感謝你！因為你將這些事向聰明通達人就藏起來，向嬰孩就顯出來。',
    '太11:26 父啊，是的，因為你的美意本是如此。',
    '太11:27 一切所有的，都是我父交付我的；除了父，沒有人知道子；除了子和子所願意指示的，沒有人知道父。',
    '太11:28 凡勞苦擔重擔的人可以到我這裡來，我就使你們得安息。',
    '太11:29 我心裡柔和謙卑，你們當負我的軛，學我的樣式；這樣，你們心裡就必得享安息。',
    '太11:30 因為我的軛是容易的，我的擔子是輕省的。',
    '太12:1 那時，耶穌在安息日從麥地經過。他的門徒餓了，就掐起麥穗來吃。',
    '太12:2 法利賽人看見，就對耶穌說：看哪，你的門徒做安息日不可做的事了！',
    '太12:3 耶穌對他們說：經上記著大衛和跟從他的人飢餓之時所做的事，你們沒有念過嗎﹖',
    '太12:4 他怎麼進了神的殿，吃了陳設餅，這餅不是他和跟從他的人可以吃得，惟獨祭司才可以吃。',
    '太12:5 再者，律法上所記的，當安息日，祭司在殿裡犯了安息日還是沒有罪，你們沒有念過嗎﹖',
    '太12:6 但我告訴你們，在這裡有一人比殿更大。',
    '太12:7 我喜愛憐恤，不喜愛祭祀。你們若明白這話的意思，就不將無罪的當作有罪的了。',
    '太12:8 因為人子是安息日的主。',
    '太12:9 耶穌離開那地方，進了一個會堂。',
    '太12:10 那裡有一個人枯乾了一隻手。有人問耶穌說：安息日治病可以不可以﹖意思是要控告他。',
    '太12:11 耶穌說：你們中間誰有一隻羊，當安息日掉在坑裡，不把他抓住，拉上來呢﹖',
    '太12:12 人比羊何等貴重呢！所以，在安息日做善事是可以的。',
    '太12:13 於是對那人說：伸出手來！他把手一伸，手就復了原，和那隻手一樣。',
    '太12:14 法利賽人出去，商議怎樣可以除滅耶穌。',
    '太12:15 耶穌知道了，就離開那裡，有許多人跟著他。他把其中有病的人都治好了；',
    '太12:16 又囑咐他們，不要給他傳名。',
    '太12:17 這是要應驗先知以賽亞的話，說：',
    '太12:18 看哪！我的僕人，我所揀選，所親愛，心裡所喜悅的，我要將我的靈賜給他；他必將公理傳給外邦。',
    '太12:19 他不爭競，不喧嚷；街上也沒有人聽見他的聲音。',
    '太12:20 壓傷的蘆葦，他不折斷；將殘的燈火，他不吹滅；等他施行公理，叫公理得勝。',
    '太12:21 外邦人都要仰望他的名。',
    '太12:22 當下，有人將一個被鬼附著、又瞎又啞的人帶到耶穌那裡，耶穌就醫治他，甚至那啞巴又能說話，又能看見。',
    '太12:23 眾人都驚奇，說：這不是大衛的子孫嗎﹖',
    '太12:24 但法利賽人聽見，就說：這個人趕鬼，無非是靠著鬼王別西卜啊。',
    '太12:25 耶穌知道他們的意念，就對他們說：凡一國自相紛爭，就成為荒場；一城一家自相紛爭，必站立不住；',
    '太12:26 若撒但趕逐撒但，就是自相紛爭，他的國怎能站得住呢﹖',
    '太12:27 我若靠著別西卜趕鬼，你們的子弟趕鬼又靠著誰呢﹖這樣，他們就要斷定你們的是非。',
    '太12:28 我若靠著神的靈趕鬼，這就是神的國臨到你們了。',
    '太12:29 人怎能進壯士家裡，搶奪他的家具呢﹖除非先捆住那壯士，才可以搶奪他的家財。',
    '太12:30 不與我相合的，就是敵我的；不同我收聚的，就是分散的。',
    '太12:31 所以我告訴你們：人一切的罪和褻瀆的話都可得赦免，惟獨褻瀆聖靈，總不得赦免。',
    '太12:32 凡說話干犯人子的，還可得赦免；惟獨說話干犯聖靈的，今世來世總不得赦免。',
    '太12:33 你們或以為樹好，果子也好；樹壞，果子也壞；因為看果子就可以知道樹。',
    '太12:34 毒蛇的種類！你們既是惡人，怎能說出好話來呢﹖因為心裡所充滿的，口裡就說出來。',
    '太12:35 善人從他心裡所存的善就發出善來；惡人從他心裡所存的惡就發出惡來。',
    '太12:36 我又告訴你們，凡人所說的閒話，當審判的日子，必要句句供出來；',
    '太12:37 因為要憑你的話定你為義，也要憑你的話定你有罪。',
    '太12:38 當時，有幾個文士和法利賽人對耶穌說：夫子，我們願意你顯個神蹟給我們看。',
    '太12:39 耶穌回答說：一個邪惡淫亂的世代求看神蹟，除了先知約拿的神蹟以外，再沒有神蹟給他們看。',
    '太12:40 約拿三日三夜在大魚肚腹中，人子也要這樣三日三夜在地裡頭。',
    '太12:41 當審判的時候，尼尼微人要起來定這世代的罪，因為尼尼微人聽了約拿所傳的就悔改了。看哪，在這裡有一人比約拿更大！',
    '太12:42 當審判的時候，南方的女王要起來定這世代的罪，因為他從地極而來，要聽所羅門的智慧話。看哪！在這裡有一人比所羅門更大。',
    '太12:43 污鬼離了人身，就在無水之地過來過去，尋求安歇之處，卻尋不著。',
    '太12:44 於是說：我要回到我所出來的屋裡去。到了，就看見裡面空閒，打掃乾淨，修飾好了，',
    '太12:45 便去另帶了七個比自己更惡的鬼來，都進去住在那裡。那人末後的景況比先前更不好了。這邪惡的世代也要如此。',
    '太12:46 耶穌還對眾人說話的時候，不料他母親和他弟兄站在外邊，要與他說話。',
    '太12:47 有人告訴他說：看哪，你母親和你弟兄站在外邊，要與你說話。',
    '太12:48 他卻回答那人說：誰是我的母親﹖誰是我的弟兄﹖',
    '太12:49 就伸手指著門徒，說：看哪，我的母親，我的弟兄。',
    '太12:50 凡遵行我天父旨意的人，就是我的弟兄姊妹和母親了。',
    '太13:1 當那一天，耶穌從房子裡出來，坐在海邊。',
    '太13:2 有許多人到他那裡聚集，他只得上船坐下，眾人都站在岸上。',
    '太13:3 他用比喻對他們講許多道理，說：有一個撒種的出去撒種；',
    '太13:4 撒的時候，有落在路旁的，飛鳥來吃盡了；',
    '太13:5 有落在土淺石頭地上的，土既不深，發苗最快，',
    '太13:6 日頭出來一曬，因為沒有根，就枯乾了；',
    '太13:7 有落在荊棘裡的，荊棘長起來，把他擠住了；',
    '太13:8 又有落在好土裡的，就結實，有一百倍的，有六十倍的，有三十倍的。',
    '太13:9 有耳可聽的，就應當聽！',
    '太13:10 門徒進前來，問耶穌說：對眾人講話，為什麼用比喻呢﹖',
    '太13:11 耶穌回答說：因為天國的奧祕只叫你們知道，不叫他們知道。',
    '太13:12 凡有的，還要加給他，叫他有餘；凡沒有的，連他所有的，也要奪去。',
    '太13:13 所以我用比喻對他們講，是因他們看也看不見，聽也聽不見，也不明白。',
    '太13:14 在他們身上，正應了以賽亞的預言，說：你們聽是要聽見，卻不明白；看是要看見，卻不曉得；',
    '太13:15 因為這百姓油蒙了心，耳朵發沉，眼睛閉著，恐怕眼睛看見，耳朵聽見，心裡明白，回轉過來，我就醫治他們。',
    '太13:16 但你們的眼睛是有福的，因為看見了；你們的耳朵也是有福的，因為聽見了。',
    '太13:17 我實在告訴你們，從前有許多先知和義人要看你們所看的，卻沒有看見，要聽你們所聽的，卻沒有聽見。',
    '太13:18 所以，你們當聽這撒種的比喻。',
    '太13:19 凡聽見天國道理不明白的，那惡者就來，把所撒在他心裡的奪了去；這就是撒在路旁的了。',
    '太13:20 撒在石頭地上的，就是人聽了道，當下歡喜領受，',
    '太13:21 只因心裡沒有根，不過是暫時的，及至為道遭了患難，或是受了逼迫，立刻就跌倒了。',
    '太13:22 撒在荊棘裡的，就是人聽了道，後來有世上的思慮、錢財的迷惑把道擠住了，不能結實。',
    '太13:23 撒在好地上的，就是人聽道明白了，後來結實，有一百倍的，有六十倍的，有三十倍的。',
    '太13:24 耶穌又設個比喻對他們說：天國好像人撒好種在田裡，',
    '太13:25 及至人睡覺的時候，有仇敵來，將稗子撒在麥子裡就走了。',
    '太13:26 到長苗吐穗的時候，稗子也顯出來。',
    '太13:27 田主的僕人來告訴他說：主啊，你不是撒好種在田裡嗎﹖從哪裡來的稗子呢﹖',
    '太13:28 主人說：這是仇敵做的。僕人說：你要我們去薅出來嗎﹖',
    '太13:29 主人說：不必，恐怕薅稗子，連麥子也拔出來。',
    '太13:30 容這兩樣一齊長，等著收割。當收割的時候，我要對收割的人說，先將稗子薅出來，捆成捆，留著燒；惟有麥子要收在倉裡。',
    '太13:31 他又設個比喻對他們說：天國好像一粒芥菜種，有人拿去種在田裡。',
    '太13:32 這原是百種裡最小的，等到長起來，卻比各樣的菜都大，且成了樹，天上的飛鳥來宿在他的枝上。',
    '太13:33 他又對他們講個比喻說：天國好像麵酵，有婦人拿來，藏在三斗麵裡，直等全團都發起來。',
    '太13:34 這都是耶穌用比喻對眾人說的話；若不用比喻，就不對他們說什麼。',
    '太13:35 這是要應驗先知的話，說：我要開口用比喻，把創世以來所隱藏的事發明出來。',
    '太13:36 當下，耶穌離開眾人，進了房子。他的門徒進前來，說：請把田間稗子的比喻講給我們聽。',
    '太13:37 他回答說：那撒好種的就是人子；',
    '太13:38 田地就是世界；好種就是天國之子；稗子就是那惡者之子；',
    '太13:39 撒稗子的仇敵就是魔鬼；收割的時候就是世界的末了；收割的人就是天使。',
    '太13:40 將稗子薅出來用火焚燒，世界的末了也要如此。',
    '太13:41 人子要差遣使者，把一切叫人跌倒的和作惡的，從他國裡挑出來，',
    '太13:42 丟在火爐裡；在那裡必要哀哭切齒了。',
    '太13:43 那時，義人在他們父的國裡，要發出光來，像太陽一樣。有耳可聽的，就應當聽！',
    '太13:44 天國好像寶貝藏在地裡，人遇見了就把他藏起來，歡歡喜喜的去變賣一切所有的，買這塊地。',
    '太13:45 天國又好像買賣人尋找好珠子，',
    '太13:46 遇見一顆重價的珠子，就去變賣他一切所有的，買了這顆珠子。',
    '太13:47 天國又好像網撒在海裡，聚攏各樣水族，',
    '太13:48 網既滿了，人就拉上岸來，坐下，揀好的收在器具裡，將不好的丟棄了。',
    '太13:49 世界的末了也要這樣。天使要出來，從義人中把惡人分別出來，',
    '太13:50 丟在火爐裡；在那裡必要哀哭切齒了。',
    '太13:51 耶穌說：這一切的話你們都明白了嗎﹖他們說：我們明白了。',
    '太13:52 他說：凡文士受教作天國的門徒，就像一個家主從他庫裡拿出新舊的東西來。',
    '太13:53 耶穌說完了這些比喻，就離開那裡，',
    '太13:54 來到自己的家鄉，在會堂裡教訓人，甚至他們都希奇，說：這人從哪裡有這等智慧和異能呢﹖',
    '太13:55 這不是木匠的兒子嗎﹖他母親不是叫馬利亞嗎﹖他弟兄們不是叫雅各、約西（有古卷：約瑟）、西門、猶大嗎﹖',
    '太13:56 他妹妹們不是都在我們這裡嗎﹖這人從哪裡有這一切的事呢﹖',
    '太13:57 他們就厭棄他（厭棄他：原文是因他跌倒）。耶穌對他們說：大凡先知，除了本地本家之外，沒有不被人尊敬的。',
    '太13:58 耶穌因為他們不信，就在那裡不多行異能了。',
    '太14:1 那時，分封的王希律聽見耶穌的名聲，',
    '太14:2 就對臣僕說：這是施洗的約翰從死裡復活，所以這些異能從他裡面發出來。',
    '太14:3 起先，希律為他兄弟腓力的妻子希羅底的緣故，把約翰拿住，鎖在監裡。',
    '太14:4 因為約翰曾對他說：你娶這婦人是不合理的。',
    '太14:5 希律就想要殺他，只是怕百姓，因為他們以約翰為先知。',
    '太14:6 到了希律的生日，希羅底的女兒在眾人面前跳舞，使希律歡喜。',
    '太14:7 希律就起誓，應許隨他所求的給他。',
    '太14:8 女兒被母親所使，就說：請把施洗約翰的頭放在盤子裡，拿來給我。',
    '太14:9 王便憂愁，但因他所起的誓，又因同席的人，就吩咐給他；',
    '太14:10 於是打發人去，在監裡斬了約翰，',
    '太14:11 把頭放在盤子裡，拿來給了女子；女子拿去給他母親。',
    '太14:12 約翰的門徒來，把屍首領去埋葬了，就去告訴耶穌。',
    '太14:13 耶穌聽見了，就上船從那裡獨自退到野地裡去。眾人聽見，就從各城裡步行跟隨他。',
    '太14:14 耶穌出來，見有許多的人，就憐憫他們，治好了他們的病人。',
    '太14:15 天將晚的時候，門徒進前來，說：這是野地，時候已經過了，請叫眾人散開，他們好往村子裡去，自己買吃的。',
    '太14:16 耶穌說：不用他們去，你們給他們吃吧！',
    '太14:17 門徒說：我們這裡只有五個餅，兩條魚。',
    '太14:18 耶穌說：拿過來給我。',
    '太14:19 於是吩咐眾人坐在草地上，就拿著這五個餅，兩條魚，望著天祝福，擘開餅，遞給門徒，門徒又遞給眾人。',
    '太14:20 他們都吃，並且吃飽了；把剩下的零碎收拾起來，裝滿了十二個籃子。',
    '太14:21 吃的人，除了婦女孩子，約有五千。',
    '太14:22 耶穌隨即催門徒上船，先渡到那邊去，等他叫眾人散開。',
    '太14:23 散了眾人以後，他就獨自上山去禱告。到了晚上，只有他一人在那裡。',
    '太14:24 那時船在海中，因風不順，被浪搖撼。',
    '太14:25 夜裡四更天，耶穌在海面上走，往門徒那裡去。',
    '太14:26 門徒看見他在海面上走，就驚慌了，說：是個鬼怪！便害怕，喊叫起來。',
    '太14:27 耶穌連忙對他們說：你們放心！是我，不要怕！',
    '太14:28 彼得說：主，如果是你，請叫我從水面上走到你那裡去。',
    '太14:29 耶穌說：你來吧。彼得就從船上下去，在水面上走，要到耶穌那裡去；',
    '太14:30 只因見風甚大，就害怕，將要沉下去，便喊著說：主啊，救我！',
    '太14:31 耶穌趕緊伸手拉住他，說：你這小信的人哪，為什麼疑惑呢﹖',
    '太14:32 他們上了船，風就住了。',
    '太14:33 在船上的人都拜他，說：你真是神的兒子了。',
    '太14:34 他們過了海，來到革尼撒勒地方。',
    '太14:35 那裡的人一認出是耶穌，就打發人到周圍地方去，把所有的病人帶到他那裡，',
    '太14:36 只求耶穌准他們摸他的衣裳繸子；摸著的人就都好了。',
    '太15:1 那時，有法利賽人和文士從耶路撒冷來見耶穌，說：',
    '太15:2 你的門徒為什麼犯古人的遺傳呢﹖因為吃飯的時候，他們不洗手。',
    '太15:3 耶穌回答說：你們為什麼因著你們的遺傳犯神的誡命呢﹖',
    '太15:4 神說：當孝敬父母；又說：咒罵父母的，必治死他。',
    '太15:5 你們倒說：無論何人對父母說：我所當奉給你的已經作了供獻，',
    '太15:6 他就可以不孝敬父母。這就是你們藉著遺傳，廢了神的誡命。',
    '太15:7 假冒為善的人哪，以賽亞指著你們說的預言是不錯的。他說：',
    '太15:8 這百姓用嘴唇尊敬我，心卻遠離我；',
    '太15:9 他們將人的吩咐當作道理教導人，所以拜我也是枉然。',
    '太15:10 耶穌就叫了眾人來，對他們說：你們要聽，也要明白。',
    '太15:11 入口的不能污穢人，出口的乃能污穢人。',
    '太15:12 當時，門徒進前來對他說：法利賽人聽見這話，不服（原文是跌倒），你知道嗎﹖',
    '太15:13 耶穌回答說：凡栽種的物，若不是我天父栽種的，必要拔出來。',
    '太15:14 任憑他們吧！他們是瞎眼領路的；若是瞎子領瞎子，兩個人都要掉在坑裡。',
    '太15:15 彼得對耶穌說：請將這比喻講給我們聽。',
    '太15:16 耶穌說：你們到如今還不明白嗎﹖',
    '太15:17 豈不知凡入口的，是運到肚子裡，又落在茅廁裡嗎﹖',
    '太15:18 惟獨出口的，是從心裡發出來的，這才污穢人。',
    '太15:19 因為從心裡發出來的，有惡念、兇殺、姦淫、苟合、偷盜、妄證、謗讟。',
    '太15:20 這都是污穢人的；至於不洗手吃飯，那卻不污穢人。',
    '太15:21 耶穌離開那裡，退到推羅、西頓的境內去。',
    '太15:22 有一個迦南婦人，從那地方出來，喊著說：主啊，大衛的子孫，可憐我！我女兒被鬼附得甚苦。',
    '太15:23 耶穌卻一言不答。門徒進前來，求他說：這婦人在我們後頭喊叫，請打發他走吧。',
    '太15:24 耶穌說：我奉差遣不過是到以色列家迷失的羊那裡去。',
    '太15:25 那婦人來拜他，說：主啊，幫助我！',
    '太15:26 他回答說：不好拿兒女的餅丟給狗吃。',
    '太15:27 婦人說：主啊，不錯；但是狗也吃他主人桌子上掉下來的碎渣兒。',
    '太15:28 耶穌說：婦人，你的信心是大的！照你所要的，給你成全了吧。從那時候，他女兒就好了。',
    '太15:29 耶穌離開那地方，來到靠近加利利的海邊，就上山坐下。',
    '太15:30 有許多人到他那裡，帶著瘸子、瞎子、啞巴、有殘疾的，和好些別的病人，都放在他腳前；他就治好了他們。',
    '太15:31 甚至眾人都希奇；因為看見啞巴說話，殘疾的痊癒，瘸子行走，瞎子看見，他們就歸榮耀給以色列的神。',
    '太15:32 耶穌叫門徒來，說：我憐憫這眾人，因為他們同我在這裡已經三天，也沒有吃的了。我不願意叫他們餓著回去，恐怕在路上困乏。',
    '太15:33 門徒說：我們在這野地，哪裡有這麼多的餅叫這許多人吃飽呢﹖',
    '太15:34 耶穌說：你們有多少餅﹖他們說：有七個，還有幾條小魚。',
    '太15:35 他就吩咐眾人坐在地上，',
    '太15:36 拿著這七個餅和幾條魚，祝謝了，擘開，遞給門徒；門徒又遞給眾人。',
    '太15:37 眾人都吃，並且吃飽了，收拾剩下的零碎，裝滿了七個筐子。',
    '太15:38 吃的人，除了婦女孩子，共有四千。',
    '太15:39 耶穌叫眾人散去，就上船，來到馬加丹的境界。',
    '太16:1 法利賽人和撒都該人來試探耶穌，請他從天上顯個神蹟給他們看。',
    '太16:2 耶穌回答說：晚上天發紅，你們就說：天必要晴。',
    '太16:3 早晨天發紅，又發黑，你們就說：今日必有風雨。你們知道分辨天上的氣色，倒不能分辨這時候的神蹟。',
    '太16:4 一個邪惡淫亂的世代求神蹟，除了約拿的神蹟以外，再沒有神蹟給他看。耶穌就離開他們去了。',
    '太16:5 門徒渡到那邊去，忘了帶餅。',
    '太16:6 耶穌對他們說：你們要謹慎，防備法利賽人和撒都該人的酵。',
    '太16:7 門徒彼此議論說：這是因為我們沒有帶餅吧。',
    '太16:8 耶穌看出來，就說：你們這小信的人，為什麼因為沒有餅彼此議論呢﹖',
    '太16:9 你們還不明白嗎﹖不記得那五個餅分給五千人、又收拾了多少籃子的零碎嗎﹖',
    '太16:10 也不記得那七個餅分給四千人、又收拾了多少筐子的零碎嗎﹖',
    '太16:11 我對你們說：要防備法利賽人和撒都該人的酵，這話不是指著餅說的，你們怎麼不明白呢﹖',
    '太16:12 門徒這才曉得他說的不是叫他們防備餅的酵，乃是防備法利賽人和撒都該人的教訓。',
    '太16:13 耶穌到了該撒利亞腓立比的境內，就問門徒說：人說我（有古卷沒有我字）人子是誰﹖',
    '太16:14 他們說：有人說是施洗的約翰；有人說是以利亞；又有人說是耶利米或是先知裡的一位。',
    '太16:15 耶穌說：你們說我是誰﹖',
    '太16:16 西門彼得回答說：你是基督，是永生神的兒子。',
    '太16:17 耶穌對他說：西門巴約拿，你是有福的！因為這不是屬血肉的指示你的，乃是我在天上的父指示的。',
    '太16:18 我還告訴你，你是彼得，我要把我的教會建造在這磐石上；陰間的權柄（權柄：原文是門），不能勝過他。',
    '太16:19 我要把天國的鑰匙給你，凡你在地上所捆綁的，在天上也要捆綁；凡你在地上所釋放的，在天上也要釋放。',
    '太16:20 當下，耶穌囑咐門徒，不可對人說他是基督。',
    '太16:21 從此，耶穌才指示門徒，他必須上耶路撒冷去，受長老、祭司長、文士許多的苦，並且被殺，第三日復活。',
    '太16:22 彼得就拉著他，勸他說：主啊，萬不可如此！這事必不臨到你身上。',
    '太16:23 耶穌轉過來，對彼得說：撒但，退我後邊去吧！你是絆我腳的；因為你不體貼神的意思，只體貼人的意思。',
    '太16:24 於是耶穌對門徒說：若有人要跟從我，就當捨己，背起他的十字架來跟從我。',
    '太16:25 因為，凡要救自己生命（生命：或作靈魂；下同）的，必喪掉生命；凡為我喪掉生命的，必得著生命。',
    '太16:26 人若賺得全世界，賠上自己的生命，有什麼益處呢﹖人還能拿什麼換生命呢﹖',
    '太16:27 人子要在他父的榮耀裡，同著眾使者降臨；那時候，他要照各人的行為報應各人。',
    '太16:28 我實在告訴你們，站在這裡的，有人在沒嘗死味以前必看見人子降臨在他的國裡。',
    '太17:1 過了六天，耶穌帶著彼得、雅各，和雅各的兄弟約翰，暗暗的上了高山，',
    '太17:2 就在他們面前變了形像，臉面明亮如日頭，衣裳潔白如光。',
    '太17:3 忽然，有摩西、以利亞向他們顯現，同耶穌說話。',
    '太17:4 彼得對耶穌說：主啊，我們在這裡真好！你若願意，我就在這裡搭三座棚，一座為你，一座為摩西，一座為以利亞。',
    '太17:5 說話之間，忽然有一朵光明的雲彩遮蓋他們，且有聲音從雲彩裡出來，說：這是我的愛子，我所喜悅的。你們要聽他！',
    '太17:6 門徒聽見﹐就俯伏在地，極其害怕。',
    '太17:7 耶穌進前來，摸他們，說：起來，不要害怕！',
    '太17:8 他們舉目不見一人，只見耶穌在那裡。',
    '太17:9 下山的時候，耶穌吩咐他們說：人子還沒有從死裡復活，你們不要將所看見的告訴人。',
    '太17:10 門徒問耶穌說：文士為什麼說以利亞必須先來﹖',
    '太17:11 耶穌回答說：以利亞固然先來，並要復興萬事；',
    '太17:12 只是我告訴你們，以利亞已經來了，人卻不認識他，竟任意待他。人子也將要這樣受他們的害。',
    '太17:13 門徒這才明白耶穌所說的是指著施洗的約翰。',
    '太17:14 耶穌和門徒到了眾人那裡，有一個人來見耶穌，跪下，說：',
    '太17:15 主啊，憐憫我的兒子。他害癲癇的病很苦，屢次跌在火裡，屢次跌在水裡。',
    '太17:16 我帶他到你門徒那裡，他們卻不能醫治他。',
    '太17:17 耶穌說：噯！這又不信又悖謬的世代啊，我在你們這裡要到幾時呢﹖我忍耐你們要到幾時呢﹖把他帶到我這裡來吧！',
    '太17:18 耶穌斥責那鬼，鬼就出來；從此孩子就痊癒了。',
    '太17:19 門徒暗暗的到耶穌跟前，說：我們為什麼不能趕出那鬼呢﹖',
    '太17:20 耶穌說：是因你們的信心小。我實在告訴你們，你們若有信心，像一粒芥菜種，就是對這座山說：你從這邊挪到那邊。他也必挪去；並且你們沒有一件不能做的事了。',
    '太17:21 至於這一類的鬼，若不禱告、禁食，他就不出來（或作：不能趕他出來）。',
    '太17:22 他們還住在加利利的時候，耶穌對門徒說：人子將要被交在人手裡。',
    '太17:23 他們要殺害他，第三日他要復活。門徒就大大的憂愁。',
    '太17:24 到了迦百農，有收丁稅的人來見彼得，說：你們的先生不納丁稅（丁稅約有半塊錢）嗎﹖',
    '太17:25 彼得說：納。他進了屋子，耶穌先向他說：西門﹐你的意思如何﹖世上的君王向誰徵收關稅、丁稅﹖是向自己的兒子呢﹖是向外人呢﹖',
    '太17:26 彼得說：是向外人。耶穌說：既然如此，兒子就可以免稅了。',
    '太17:27 但恐怕觸犯（觸犯：原文是絆倒）他們，你且往海邊去釣魚，把先釣上來的魚拿起來，開了他的口，必得一塊錢，可以拿去給他們，作你我的稅銀。',
    '太18:1 當時，門徒進前來，問耶穌說：天國裡誰是最大的﹖',
    '太18:2 耶穌便叫一個小孩子來，使他站在他們當中，',
    '太18:3 說：我實在告訴你們，你們若不回轉，變成小孩子的樣式，斷不得進天國。',
    '太18:4 所以，凡自己謙卑像這小孩子的，他在天國裡就是最大的。',
    '太18:5 凡為我的名接待一個像這小孩子的，就是接待我。',
    '太18:6 凡使這信我的一個小子跌倒的，倒不如把大磨石拴在這人的頸項上，沉在深海裡。',
    '太18:7 這世界有禍了，因為將人絆倒；絆倒人的事是免不了的，但那絆倒人的有禍了！',
    '太18:8 倘若你一隻手，或是一隻腳，叫你跌倒，就砍下來丟掉。你缺一隻手，或是一隻腳，進入永生，強如有兩手兩腳被丟在永火裡。',
    '太18:9 倘若你一隻眼叫你跌倒，就把他剜出來丟掉。你只有一隻眼進入永生，強如有兩隻眼被丟在地獄的火裡。',
    '太18:10 你們要小心，不可輕看這小子裡的一個；我告訴你們，他們的使者在天上，常見我天父的面。（有古卷在此有',
    '太18:11 人子來，為要拯救失喪的人。）',
    '太18:12 一個人若有一百隻羊，一隻走迷了路，你們的意思如何﹖他豈不撇下這九十九隻，往山裡去找那隻迷路的羊嗎﹖',
    '太18:13 若是找著了，我實在告訴你們，他為這一隻羊歡喜，比為那沒有迷路的九十九隻歡喜還大呢！',
    '太18:14 你們在天上的父也是這樣，不願意這小子裡失喪一個。',
    '太18:15 倘若你的弟兄得罪你，你就去，趁著只有他和你在一處的時候，指出他的錯來。他若聽你，你便得了你的弟兄；',
    '太18:16 他若不聽，你就另外帶一兩個人同去，要憑兩三個人的口作見證，句句都可定準。',
    '太18:17 若是不聽他們，就告訴教會；若是不聽教會，就看他像外邦人和稅吏一樣。',
    '太18:18 我實在告訴你們，凡你們在地上所捆綁的，在天上也要捆綁；凡你們在地上所釋放的，在天上也要釋放。',
    '太18:19 我又告訴你們，若是你們中間有兩個人在地上同心合意的求什麼事，我在天上的父必為他們成全。',
    '太18:20 因為無論在哪裡，有兩三個人奉我的名聚會，那裡就有我在他們中間。',
    '太18:21 那時，彼得進前來，對耶穌說：主啊，我弟兄得罪我，我當饒恕他幾次呢﹖到七次可以嗎﹖',
    '太18:22 耶穌說：我對你說，不是到七次，乃是到七十個七次。',
    '太18:23 天國好像一個王要和他僕人算帳。',
    '太18:24 才算的時候，有人帶了一個欠一千萬銀子的來。',
    '太18:25 因為他沒有什麼償還之物，主人吩咐把他和他妻子兒女，並一切所有的都賣了償還。',
    '太18:26 那僕人就俯伏拜他，說：主啊，寬容我，將來我都要還清。',
    '太18:27 那僕人的主人就動了慈心，把他釋放了，並且免了他的債。',
    '太18:28 那僕人出來，遇見他的一個同伴欠他十兩銀子，便揪著他，掐住他的喉嚨，說：你把所欠的還我！',
    '太18:29 他的同伴就俯伏央求他，說：寬容我吧，將來我必還清。',
    '太18:30 他不肯，竟去把他下在監裡，等他還了所欠的債。',
    '太18:31 眾同伴看見他所做的事就甚憂愁，去把這事都告訴了主人。',
    '太18:32 於是主人叫了他來，對他說：你這惡奴才！你央求我，我就把你所欠的都免了，',
    '太18:33 你不應當憐恤你的同伴，像我憐恤你嗎﹖',
    '太18:34 主人就大怒，把他交給掌刑的，等他還清了所欠的債。',
    '太18:35 你們各人若不從心裡饒恕你的弟兄，我天父也要這樣待你們了。',
    '太19:1 耶穌說完了這些話，就離開加利利，來到猶太的境界約但河外。',
    '太19:2 有許多人跟著他，他就在那裡把他們的病人治好了。',
    '太19:3 有法利賽人來試探耶穌，說：人無論什麼緣故都可以休妻嗎﹖',
    '太19:4 耶穌回答說：那起初造人的，是造男造女，',
    '太19:5 並且說：因此，人要離開父母，與妻子連合，二人成為一體。這經你們沒有念過嗎﹖',
    '太19:6 既然如此，夫妻不再是兩個人，乃是一體的了。所以，神配合的，人不可分開。',
    '太19:7 法利賽人說：這樣，摩西為什麼吩咐給妻子休書，就可以休他呢﹖',
    '太19:8 耶穌說：摩西因為你們的心硬，所以許你們休妻，但起初並不是這樣。',
    '太19:9 我告訴你們，凡休妻另娶的，若不是為淫亂的緣故，就是犯姦淫了；有人娶那被休的婦人，也是犯姦淫了。',
    '太19:10 門徒對耶穌說：人和妻子既是這樣，倒不如不娶。',
    '太19:11 耶穌說：這話不是人都能領受的，惟獨賜給誰，誰才能領受。',
    '太19:12 因為有生來是閹人，也有被人閹的，並有為天國的緣故自閹的。這話誰能領受就可以領受。',
    '太19:13 那時，有人帶著小孩子來見耶穌，要耶穌給他們按手禱告，門徒就責備那些人。',
    '太19:14 耶穌說：讓小孩子到我這裡來，不要禁止他們；因為在天國的，正是這樣的人。',
    '太19:15 耶穌給他們按手，就離開那地方去了。',
    '太19:16 有一個人來見耶穌，說：夫子（有古卷：良善的夫子），我該做什麼善事才能得永生﹖',
    '太19:17 耶穌對他說：你為什麼以善事問我呢﹖只有一位是善的（有古卷：你為什麼稱我是良善的﹖除了神以外，沒有一個良善的）。你若要進入永生，就當遵守誡命。',
    '太19:18 他說：什麼誡命﹖耶穌說：就是不可殺人；不可姦淫；不可偷盜；不可作假見證；',
    '太19:19 當孝敬父母，又當愛人如己。',
    '太19:20 那少年人說：這一切我都遵守了，還缺少什麼呢﹖',
    '太19:21 耶穌說：你若願意作完全人，可去變賣你所有的，分給窮人，就必有財寶在天上；你還要來跟從我。',
    '太19:22 那少年人聽見這話，就憂憂愁愁的走了，因為他的產業很多。',
    '太19:23 耶穌對門徒說：我實在告訴你們，財主進天國是難的。',
    '太19:24 我又告訴你們，駱駝穿過針的眼，比財主進神的國還容易呢！',
    '太19:25 門徒聽見這話，就希奇得很，說：這樣誰能得救呢﹖',
    '太19:26 耶穌看著他們，說：在人這是不能的，在神凡事都能。',
    '太19:27 彼得就對他說：看哪，我們已經撇下所有的跟從你，將來我們要得什麼呢﹖',
    '太19:28 耶穌說：我實在告訴你們，你們這跟從我的人，到復興的時候，人子坐在他榮耀的寶座上，你們也要坐在十二個寶座上，審判以色列十二個支派。',
    '太19:29 凡為我的名撇下房屋，或是弟兄、姊妹、父親、母親、（有古卷在此有：妻子）兒女、田地的，必要得著百倍，並且承受永生。',
    '太19:30 然而，有許多在前的，將要在後；在後的，將要在前。',
    '太20:1 因為天國好像家主清早去雇人進他的葡萄園做工，',
    '太20:2 和工人講定一天一錢銀子，就打發他們進葡萄園去。',
    '太20:3 約在巳初出去，看見市上還有閒站的人，',
    '太20:4 就對他們說：你們也進葡萄園去，所當給的，我必給你們。他們也進去了。',
    '太20:5 約在午正和申初又出去，也是這樣行。',
    '太20:6 約在酉初出去，看見還有人站在那裡，就問他們說：你們為什麼整天在這裡閒站呢﹖',
    '太20:7 他們說：因為沒有人雇我們。他說：你們也進葡萄園去。',
    '太20:8 到了晚上，園主對管事的說：叫工人都來，給他們工錢，從後來的起，到先來的為止。',
    '太20:9 約在酉初雇的人來了，各人得了一錢銀子。',
    '太20:10 及至那先雇的來了，他們以為必要多得；誰知也是各得一錢。',
    '太20:11 他們得了，就埋怨家主說：',
    '太20:12 我們整天勞苦受熱，那後來的只做了一小時，你竟叫他們和我們一樣嗎﹖',
    '太20:13 家主回答其中的一人說：朋友，我不虧負你，你與我講定的不是一錢銀子嗎﹖',
    '太20:14 拿你的走吧！我給那後來的和給你一樣，這是我願意的。',
    '太20:15 我的東西難道不可隨我的意思用嗎﹖因為我作好人，你就紅了眼嗎﹖',
    '太20:16 這樣，那在後的，將要在前；在前的，將要在後了。（有古卷在此有：因為被召的人多，選上的人少。）',
    '太20:17 耶穌上耶路撒冷去的時候，在路上把十二個門徒帶到一邊，對他們說：',
    '太20:18 看哪，我們上耶路撒冷去，人子要被交給祭司長和文士。他們要定他死罪，',
    '太20:19 又交給外邦人，將他戲弄，鞭打，釘在十字架上；第三日他要復活。',
    '太20:20 那時，西庇太兒子的母親同他兩個兒子上前來拜耶穌，求他一件事。',
    '太20:21 耶穌說：你要什麼呢﹖他說：願你叫我這兩個兒子在你國裡，一個坐在你右邊，一個坐在你左邊。',
    '太20:22 耶穌回答說：你們不知道所求的是什麼；我將要喝的杯，你們能喝嗎﹖他們說：我們能。',
    '太20:23 耶穌說：我所喝的杯，你們必要喝；只是坐在我的左右，不是我可以賜的，乃是我父為誰預備的，就賜給誰。',
    '太20:24 那十個門徒聽見，就惱怒他們弟兄二人。',
    '太20:25 耶穌叫了他們來，說：你們知道外邦人有君王為主治理他們，有大臣操權管束他們。',
    '太20:26 只是在你們中間，不可這樣；你們中間誰願為大，就必作你們的用人；',
    '太20:27 誰願為首，就必作你們的僕人。',
    '太20:28 正如人子來，不是要受人的服事，乃是要服事人，並且要捨命，作多人的贖價。',
    '太20:29 他們出耶利哥的時候，有極多的人跟隨他。',
    '太20:30 有兩個瞎子坐在路旁，聽說是耶穌經過，就喊著說：主啊，大衛的子孫，可憐我們吧！',
    '太20:31 眾人責備他們，不許他們作聲；他們卻越發喊著說：主啊，大衛的子孫，可憐我們吧！',
    '太20:32 耶穌就站住，叫他們來，說：要我為你們做什麼﹖',
    '太20:33 他們說：主啊，要我們的眼睛能看見！',
    '太20:34 耶穌就動了慈心，把他們的眼睛一摸，他們立刻看見，就跟從了耶穌。',
    '太21:1 耶穌和門徒將近耶路撒冷，到了伯法其，在橄欖山那裡。',
    '太21:2 耶穌就打發兩個門徒，對他們說：你們往對面村子裡去，必看見一匹驢拴在那裡，還有驢駒同在一處；你們解開，牽到我這裡來。',
    '太21:3 若有人對你們說什麼，你們就說：主要用他。那人必立時讓你們牽來。',
    '太21:4 這事成就是要應驗先知的話，說：',
    '太21:5 要對錫安的居民（原文是女子）說：看哪，你的王來到你這裡，是溫柔的，又騎著驢，就是騎著驢駒子。',
    '太21:6 門徒就照耶穌所吩咐的去行，',
    '太21:7 牽了驢和驢駒來，把自己的衣服搭在上面，耶穌就騎上。',
    '太21:8 眾人多半把衣服鋪在路上；還有人砍下樹枝來鋪在路上。',
    '太21:9 前行後隨的眾人喊著說：和散那（原有求救的意思，在此是稱頌的話）歸於大衛的子孫！奉主名來的是應當稱頌的！高高在上和散那！',
    '太21:10 耶穌既進了耶路撒冷，合城都驚動了，說：這是誰﹖',
    '太21:11 眾人說：這是加利利拿撒勒的先知耶穌。',
    '太21:12 耶穌進了神的殿，趕出殿裡一切做買賣的人，推倒兌換銀錢之人的桌子，和賣鴿子之人的凳子；',
    '太21:13 對他們說：經上記著說：我的殿必稱為禱告的殿，你們倒使他成為賊窩了。',
    '太21:14 在殿裡有瞎子、瘸子到耶穌跟前，他就治好了他們。',
    '太21:15 祭司長和文士看見耶穌所行的奇事，又見小孩子在殿裡喊著說：和散那歸於大衛的子孫！就甚惱怒，',
    '太21:16 對他說：這些人所說的，你聽見了嗎﹖耶穌說：是的。經上說你從嬰孩和吃奶的口中完全了讚美的話，你們沒有念過嗎﹖',
    '太21:17 於是離開他們，出城到伯大尼去，在那裡住宿。',
    '太21:18 早晨回城的時候，他餓了，',
    '太21:19 看見路旁有一棵無花果樹，就走到跟前，在樹上找不著什麼，不過有葉子，就對樹說：從今以後，你永不結果子。那無花果樹就立刻枯乾了。',
    '太21:20 門徒看見了﹐便希奇說：無花果樹怎麼立刻枯乾了呢﹖',
    '太21:21 耶穌回答說：我實在告訴你們，你們若有信心，不疑惑，不但能行無花果樹上所行的事，就是對這座山說：你挪開此地，投在海裡！也必成就。',
    '太21:22 你們禱告，無論求什麼，只要信，就必得著。',
    '太21:23 耶穌進了殿，正教訓人的時候，祭司長和民間的長老來問他說：你仗著什麼權柄做這些事﹖給你這權柄的是誰呢﹖',
    '太21:24 耶穌回答說：我也要問你們一句話，你們若告訴我，我就告訴你們我仗著什麼權柄做這些事。',
    '太21:25 約翰的洗禮是從哪裡來的﹖是從天上來的﹖是從人間來的呢﹖他們彼此商議說：我們若說從天上來，他必對我們說：這樣，你們為什麼不信他呢﹖',
    '太21:26 若說從人間來，我們又怕百姓，因為他們都以約翰為先知。',
    '太21:27 於是回答耶穌說：我們不知道。耶穌說：我也不告訴你們我仗著什麼權柄做這些事。',
    '太21:28 又說：一個人有兩個兒子。他來對大兒子說：我兒，你今天到葡萄園裡去做工。',
    '太21:29 他回答說：我不去，以後自己懊悔，就去了。',
    '太21:30 又來對小兒子也是這樣說。他回答說：父啊，我去，他卻不去。',
    '太21:31 你們想，這兩個兒子是哪一個遵行父命呢﹖他們說：大兒子。耶穌說：我實在告訴你們，稅吏和娼妓倒比你們先進神的國。',
    '太21:32 因為約翰遵著義路到你們這裡來，你們卻不信他；稅吏和娼妓倒信他。你們看見了，後來還是不懊悔去信他。',
    '太21:33 你們再聽一個比喻：有個家主栽了一個葡萄園，周圍圈上籬笆，裡面挖了一個壓酒池，蓋了一座樓，租給園戶，就往外國去了。',
    '太21:34 收果子的時候近了，就打發僕人到園戶那裡去收果子。',
    '太21:35 園戶拿住僕人，打了一個，殺了一個，用石頭打死一個。',
    '太21:36 主人又打發別的僕人去，比先前更多；園戶還是照樣待他們。',
    '太21:37 後來打發他的兒子到他們那裡去，意思說：他們必尊敬我的兒子。',
    '太21:38 不料，園戶看見他兒子，就彼此說：這是承受產業的。來吧，我們殺他，佔他的產業！',
    '太21:39 他們就拿住他，推出葡萄園外，殺了。',
    '太21:40 園主來的時候要怎樣處治這些園戶呢﹖',
    '太21:41 他們說：要下毒手除滅那些惡人，將葡萄園另租給那按著時候交果子的園戶。',
    '太21:42 耶穌說：經上寫著：匠人所棄的石頭已作了房角的頭塊石頭。這是主所做的，在我們眼中看為希奇。這經你們沒有念過嗎﹖',
    '太21:43 所以我告訴你們，神的國必從你們奪去，賜給那能結果子的百姓。',
    '太21:44 誰掉在這石頭上，必要跌碎；這石頭掉在誰的身上，就要把誰砸得稀爛。',
    '太21:45 祭司長和法利賽人聽見他的比喻，就看出他是指著他們說的。',
    '太21:46 他們想要捉拿他，只是怕眾人，因為眾人以他為先知。',
    '太22:1 耶穌又用比喻對他們說：',
    '太22:2 天國好比一個王為他兒子擺設娶親的筵席，',
    '太22:3 就打發僕人去，請那些被召的人來赴席，他們卻不肯來。',
    '太22:4 王又打發別的僕人，說：你們告訴那被召的人，我的筵席已經預備好了，牛和肥畜已經宰了，各樣都齊備，請你們來赴席。',
    '太22:5 那些人不理就走了；一個到自己田裡去；一個做買賣去；',
    '太22:6 其餘的拿住僕人，凌辱他們，把他們殺了。',
    '太22:7 王就大怒，發兵除滅那些兇手，燒毀他們的城。',
    '太22:8 於是對僕人說：喜筵已經齊備，只是所召的人不配。',
    '太22:9 所以你們要往岔路口上去，凡遇見的，都召來赴席。',
    '太22:10 那些僕人就出去，到大路上，凡遇見的，不論善惡都召聚了來，筵席上就坐滿了客。',
    '太22:11 王進來觀看賓客，見那裡有一個沒有穿禮服的，',
    '太22:12 就對他說：朋友，你到這裡來怎麼不穿禮服呢﹖那人無言可答。',
    '太22:13 於是王對使喚的人說：捆起他的手腳來，把他丟在外邊的黑暗裡；在那裡必要哀哭切齒了。',
    '太22:14 因為被召的人多，選上的人少。',
    '太22:15 當時，法利賽人出去商議，怎樣就著耶穌的話陷害他，',
    '太22:16 就打發他們的門徒同希律黨的人去見耶穌，說：夫子，我們知道你是誠實人，並且誠誠實實傳神的道，什麼人你都不徇情面，因為你不看人的外貌。',
    '太22:17 請告訴我們，你的意見如何﹖納稅給該撒可以不可以﹖',
    '太22:18 耶穌看出他們的惡意，就說：假冒為善的人哪，為什麼試探我﹖',
    '太22:19 拿一個上稅的錢給我看！他們就拿一個銀錢來給他。',
    '太22:20 耶穌說：這像和這號是誰的﹖',
    '太22:21 他們說：是該撒的。耶穌說：這樣，該撒的物當歸給該撒；神的物當歸給神。',
    '太22:22 他們聽見就希奇，離開他走了。',
    '太22:23 撒都該人常說沒有復活的事。那天，他們來問耶穌說：',
    '太22:24 夫子，摩西說：人若死了，沒有孩子，他兄弟當娶他的妻，為哥哥生子立後。',
    '太22:25 從前，在我們這裡有弟兄七人，第一個娶了妻，死了，沒有孩子，撇下妻子給兄弟。',
    '太22:26 第二、第三、直到第七個，都是如此。',
    '太22:27 末後，婦人也死了。',
    '太22:28 這樣，當復活的時候，他是七個人中哪一個的妻子呢﹖因為他們都娶過他。',
    '太22:29 耶穌回答說：你們錯了；因為不明白聖經，也不曉得神的大能。',
    '太22:30 當復活的時候，人也不娶也不嫁，乃像天上的使者一樣。',
    '太22:31 論到死人復活，神在經上向你們所說的，你們沒有念過嗎﹖',
    '太22:32 他說：我是亞伯拉罕的神，以撒的神，雅各的神。神不是死人的神，乃是活人的神。',
    '太22:33 眾人聽見這話，就希奇他的教訓。',
    '太22:34 法利賽人聽見耶穌堵住了撒都該人的口，他們就聚集。',
    '太22:35 內中有一個人是律法師，要試探耶穌，就問他說：',
    '太22:36 夫子，律法上的誡命，哪一條是最大的呢﹖',
    '太22:37 耶穌對他說：你要盡心、盡性、盡意愛主─你的神。',
    '太22:38 這是誡命中的第一，且是最大的。',
    '太22:39 其次也相倣，就是要愛人如己。',
    '太22:40 這兩條誡命是律法和先知一切道理的總綱。',
    '太22:41 法利賽人聚集的時候，耶穌問他們說：',
    '太22:42 論到基督，你們的意見如何﹖他是誰的子孫呢﹖他們回答說：是大衛的子孫。',
    '太22:43 耶穌說：這樣，大衛被聖靈感動，怎麼還稱他為主，說：',
    '太22:44 主對我主說：你坐在我的右邊，等我把你仇敵放在你的腳下。',
    '太22:45 大衛既稱他為主，他怎麼又是大衛的子孫呢﹖',
    '太22:46 他們沒有一個人能回答一言。從那日以後，也沒有人敢再問他什麼。',
    '太23:1 那時﹐耶穌對眾人和門徒講論，',
    '太23:2 說：文士和法利賽人坐在摩西的位上，',
    '太23:3 凡他們所吩咐你們的，你們都要謹守遵行；但不要效法他們的行為；因為他們能說，不能行。',
    '太23:4 他們把難擔的重擔捆起來，擱在人的肩上，但自己一個指頭也不肯動。',
    '太23:5 他們一切所做的事都是要叫人看見，所以將佩戴的經文做寬了，衣裳的繸子做長了，',
    '太23:6 喜愛筵席上的首座，會堂裡的高位，',
    '太23:7 又喜愛人在街市上問他安，稱呼他拉比（拉比就是夫子）。',
    '太23:8 但你們不要受拉比的稱呼，因為只有一位是你們的夫子；你們都是弟兄。',
    '太23:9 也不要稱呼地上的人為父，因為只有一位是你們的父，就是在天上的父。',
    '太23:10 也不要受師尊的稱呼，因為只有一位是你們的師尊，就是基督。',
    '太23:11 你們中間誰為大，誰就要作你們的用人。',
    '太23:12 凡自高的，必降為卑；自卑的，必升為高。',
    '太23:13 你們這假冒為善的文士和法利賽人有禍了！因為你們正當人前，把天國的門關了，自己不進去，正要進去的人，你們也不容他們進去。（有古卷在此有',
    '太23:14 你們這假冒為善的文士和法利賽人有禍了！因為你們侵吞寡婦的家產，假意做很長的禱告，所以要受更重的刑罰。）',
    '太23:15 你們這假冒為善的文士和法利賽人有禍了！因為你們走遍洋海陸地，勾引一個人入教，既入了教，卻使他作地獄之子，比你們還加倍。',
    '太23:16 你們這瞎眼領路的有禍了！你們說：凡指著殿起誓的，這算不得什麼；只是凡指著殿中金子起誓的，他就該謹守。',
    '太23:17 你們這無知瞎眼的人哪，什麼是大的﹖是金子呢﹖還是叫金子成聖的殿呢﹖',
    '太23:18 你們又說：凡指著壇起誓的，這算不得什麼；只是凡指著壇上禮物起誓的，他就該謹守。',
    '太23:19 你們這瞎眼的人哪，什麼是大的﹖是禮物呢﹖還是叫禮物成聖的壇呢﹖',
    '太23:20 所以，人指著壇起誓，就是指著壇和壇上一切所有的起誓；',
    '太23:21 人指著殿起誓，就是指著殿和那住在殿裡的起誓；',
    '太23:22 人指著天起誓，就是指著神的寶座和那坐在上面的起誓。',
    '太23:23 你們這假冒為善的文士和法利賽人有禍了！因為你們將薄荷、茴香、芹菜，獻上十分之一，那律法上更重的事，就是公義、憐憫、信實，反倒不行了。這更重的是你們當行的；那也是不可不行的。',
    '太23:24 你們這瞎眼領路的，蠓蟲你們就濾出來，駱駝你們倒吞下去。',
    '太23:25 你們這假冒為善的文士和法利賽人有禍了！因為你們洗淨杯盤的外面，裡面卻盛滿了勒索和放蕩。',
    '太23:26 你這瞎眼的法利賽人，先洗淨杯盤的裡面，好叫外面也乾淨了。',
    '太23:27 你們這假冒為善的文士和法利賽人有禍了！因為你們好像粉飾的墳墓，外面好看，裡面卻裝滿了死人的骨頭和一切的污穢。',
    '太23:28 你們也是如此，在人前，外面顯出公義來，裡面卻裝滿了假善和不法的事。',
    '太23:29 你們這假冒為善的文士和法利賽人有禍了！因為你們建造先知的墳，修飾義人的墓，說：',
    '太23:30 若是我們在我們祖宗的時候，必不和他們同流先知的血。',
    '太23:31 這就是你們自己證明是殺害先知者的子孫了。',
    '太23:32 你們去充滿你們祖宗的惡貫吧！',
    '太23:33 你們這些蛇類、毒蛇之種啊，怎能逃脫地獄的刑罰呢﹖',
    '太23:34 所以我差遣先知和智慧人並文士到你們這裡來，有的你們要殺害，要釘十字架；有的你們要在會堂裡鞭打，從這城追逼到那城，',
    '太23:35 叫世上所流義人的血都歸到你們身上，從義人亞伯的血起，直到你們在殿和壇中間所殺的巴拉加的兒子撒迦利亞的血為止。',
    '太23:36 我實在告訴你們，這一切的罪都要歸到這世代了。',
    '太23:37 耶路撒冷啊，耶路撒冷啊，你常殺害先知，又用石頭打死那奉差遣到你這裡來的人。我多次願意聚集你的兒女，好像母雞把小雞聚集在翅膀底下，只是你們不願意。',
    '太23:38 看哪，你們的家成為荒場留給你們。',
    '太23:39 我告訴你們，從今以後，你們不得再見我，直等到你們說：奉主名來的是應當稱頌的。',
    '太24:1 耶穌出了聖殿，正走的時候，門徒進前來，把殿宇指給他看。',
    '太24:2 耶穌對他們說：你們不是看見這殿宇嗎﹖我實在告訴你們，將來在這裡沒有一塊石頭留在石頭上，不被拆毀了。',
    '太24:3 耶穌在橄欖山上坐著，門徒暗暗的來說：請告訴我們，什麼時候有這些事﹖你降臨和世界的末了有什麼預兆呢﹖',
    '太24:4 耶穌回答說：你們要謹慎，免得有人迷惑你們。',
    '太24:5 因為將來有好些人冒我的名來，說：我是基督，並且要迷惑許多人。',
    '太24:6 你們也要聽見打仗和打仗的風聲，總不要驚慌；因為這些事是必須有的，只是末期還沒有到。',
    '太24:7 民要攻打民，國要攻打國；多處必有饑荒、地震。',
    '太24:8 這都是災難（災難：原文是生產之難）的起頭。',
    '太24:9 那時，人要把你們陷在患難裡，也要殺害你們；你們又要為我的名被萬民恨惡。',
    '太24:10 那時，必有許多人跌倒，也要彼此陷害，彼此恨惡；',
    '太24:11 且有好些假先知起來，迷惑多人。',
    '太24:12 只因不法的事增多，許多人的愛心才漸漸冷淡了。',
    '太24:13 惟有忍耐到底的，必然得救。',
    '太24:14 這天國的福音要傳遍天下，對萬民作見證，然後末期才來到。',
    '太24:15 你們看見先知但以理所說的那行毀壞可憎的站在聖地（讀這經的人須要會意）。',
    '太24:16 那時，在猶太的，應當逃到山上；',
    '太24:17 在房上的，不要下來拿家裡的東西；',
    '太24:18 在田裡的，也不要回去取衣裳。',
    '太24:19 當那些日子，懷孕的和奶孩子的有禍了。',
    '太24:20 你們應當祈求，叫你們逃走的時候，不遇見冬天或是安息日。',
    '太24:21 因為那時必有大災難，從世界的起頭直到如今，沒有這樣的災難，後來也必沒有。',
    '太24:22 若不減少那日子，凡有血氣的總沒有一個得救的；只是為選民，那日子必減少了。',
    '太24:23 那時，若有人對你們說：基督在這裡，或說：基督在那裡，你們不要信！',
    '太24:24 因為假基督、假先知將要起來，顯大神蹟、大奇事，倘若能行，連選民也就迷惑了。',
    '太24:25 看哪，我預先告訴你們了。',
    '太24:26 若有人對你們說：看哪，基督在曠野裡，你們不要出去！或說：看哪，基督在內屋中，你們不要信！',
    '太24:27 閃電從東邊發出，直照到西邊。人子降臨，也要這樣。',
    '太24:28 屍首在哪裡，鷹也必聚在那裡。',
    '太24:29 那些日子的災難一過去，日頭就變黑了，月亮也不放光，眾星要從天上墜落，天勢都要震動。',
    '太24:30 那時，人子的兆頭要顯在天上，地上的萬族都要哀哭。他們要看見人子，有能力，有大榮耀，駕著天上的雲降臨。',
    '太24:31 他要差遣使者，用號筒的大聲，將他的選民，從四方（方：原文是風），從天這邊到天那邊，都招聚了來。',
    '太24:32 你們可以從無花果樹學個比方：當樹枝發嫩長葉的時候，你們就知道夏天近了。',
    '太24:33 這樣，你們看見這一切的事，也該知道人子近了，正在門口了。',
    '太24:34 我實在告訴你們，這世代還沒有過去，這些事都要成就。',
    '太24:35 天地要廢去，我的話卻不能廢去。',
    '太24:36 但那日子，那時辰，沒有人知道，連天上的使者也不知道，子也不知道，惟獨父知道。',
    '太24:37 挪亞的日子怎樣，人子降臨也要怎樣。',
    '太24:38 當洪水以前的日子，人照常吃喝嫁娶，直到挪亞進方舟的那日；',
    '太24:39 不知不覺洪水來了，把他們全都沖去。人子降臨也要這樣。',
    '太24:40 那時，兩個人在田裡，取去一個，撇下一個。',
    '太24:41 兩個女人推磨，取去一個，撇下一個。',
    '太24:42 所以，你們要警醒，因為不知道你們的主是哪一天來到。',
    '太24:43 家主若知道幾更天有賊來，就必警醒，不容人挖透房屋；這是你們所知道的。',
    '太24:44 所以，你們也要預備，因為你們想不到的時候，人子就來了。',
    '太24:45 誰是忠心有見識的僕人，為主人所派，管理家裡的人，按時分糧給他們呢﹖',
    '太24:46 主人來到，看見他這樣行，那僕人就有福了。',
    '太24:47 我實在告訴你們，主人要派他管理一切所有的。',
    '太24:48 倘若那惡僕心裡說：我的主人必來得遲，',
    '太24:49 就動手打他的同伴，又和酒醉的人一同吃喝。',
    '太24:50 在想不到的日子，不知道的時辰，那僕人的主人要來，',
    '太24:51 重重地處治他（或作：把他腰斬了），定他和假冒為善的人同罪；在那裡必要哀哭切齒了。',
    '太25:1 那時，天國好比十個童女拿著燈出去迎接新郎。',
    '太25:2 其中有五個是愚拙的，五個是聰明的。',
    '太25:3 愚拙的拿著燈，卻不預備油；',
    '太25:4 聰明的拿著燈，又預備油在器皿裡。',
    '太25:5 新郎遲延的時候，他們都打盹，睡著了。',
    '太25:6 半夜有人喊著說：新郎來了，你們出來迎接他！',
    '太25:7 那些童女就都起來收拾燈。',
    '太25:8 愚拙的對聰明的說：請分點油給我們，因為我們的燈要滅了。',
    '太25:9 聰明的回答說：恐怕不夠你我用的；不如你們自己到賣油的那裡去買吧。',
    '太25:10 他們去買的時候，新郎到了。那預備好了的，同他進去坐席，門就關了。',
    '太25:11 其餘的童女隨後也來了，說：主啊，主啊，給我們開門！',
    '太25:12 他卻回答說：我實在告訴你們，我不認識你們。',
    '太25:13 所以，你們要警醒；因為那日子，那時辰，你們不知道。',
    '太25:14 天國又好比一個人要往外國去，就叫了僕人來，把他的家業交給他們，',
    '太25:15 按著各人的才幹給他們銀子：一個給了五千，一個給了二千，一個給了一千，就往外國去了。',
    '太25:16 那領五千的隨即拿去做買賣，另外賺了五千。',
    '太25:17 那領二千的也照樣另賺了二千。',
    '太25:18 但那領一千的去掘開地，把主人的銀子埋藏了。',
    '太25:19 過了許久，那些僕人的主人來了，和他們算帳。',
    '太25:20 那領五千銀子的又帶著那另外的五千來，說：主啊，你交給我五千銀子。請看，我又賺了五千。',
    '太25:21 主人說：好，你這又良善又忠心的僕人，你在不多的事上有忠心，我要把許多事派你管理；可以進來享受你主人的快樂。',
    '太25:22 那領二千的也來，說：主啊，你交給我二千銀子。請看，我又賺了二千。',
    '太25:23 主人說：好，你這又良善又忠心的僕人，你在不多的事上有忠心，我要把許多事派你管理；可以進來享受你主人的快樂。',
    '太25:24 那領一千的也來，說：主啊，我知道你是忍心的人，沒有種的地方要收割，沒有散的地方要聚斂，',
    '太25:25 我就害怕，去把你的一千銀子埋藏在地裡。請看，你的原銀子在這裡。',
    '太25:26 主人回答說：你這又惡又懶的僕人，你既知道我沒有種的地方要收割，沒有散的地方要聚斂，',
    '太25:27 就當把我的銀子放給兌換銀錢的人，到我來的時候，可以連本帶利收回。',
    '太25:28 奪過他這一千來，給那有一萬的。',
    '太25:29 因為凡有的，還要加給他，叫他有餘；沒有的，連他所有的也要奪過來。',
    '太25:30 把這無用的僕人丟在外面黑暗裡；在那裡必要哀哭切齒了。',
    '太25:31 當人子在他榮耀裡、同著眾天使降臨的時候，要坐在他榮耀的寶座上。',
    '太25:32 萬民都要聚集在他面前。他要把他們分別出來，好像牧羊的分別綿羊山羊一般，',
    '太25:33 把綿羊安置在右邊，山羊在左邊。',
    '太25:34 於是王要向那右邊的說：你們這蒙我父賜福的，可來承受那創世以來為你們所預備的國；',
    '太25:35 因為我餓了，你們給我吃，渴了，你們給我喝；我作客旅，你們留我住；',
    '太25:36 我赤身露體，你們給我穿；我病了、你們看顧我；我在監裡，你們來看我。',
    '太25:37 義人就回答說：主啊，我們什麼時候見你餓了，給你吃，渴了，給你喝﹖',
    '太25:38 什麼時候見你作客旅，留你住，或是赤身露體，給你穿﹖',
    '太25:39 又什麼時候見你病了，或是在監裡，來看你呢﹖',
    '太25:40 王要回答說：我實在告訴你們，這些事你們既做在我這弟兄中一個最小的身上，就是做在我身上了。',
    '太25:41 王又要向那左邊的說：你們這被咒詛的人，離開我！進入那為魔鬼和他的使者所預備的永火裡去！',
    '太25:42 因為我餓了，你們不給我吃，渴了，你們不給我喝；',
    '太25:43 我作客旅，你們不留我住；我赤身露體，你們不給我穿；我病了，我在監裡，你們不來看顧我。',
    '太25:44 他們也要回答說：主啊，我們什麼時候見你餓了，或渴了，或作客旅，或赤身露體，或病了，或在監裡，不伺候你呢﹖',
    '太25:45 王要回答說：我實在告訴你們，這些事你們既不做在我這弟兄中一個最小的身上，就是不做在我身上了。',
    '太25:46 這些人要往永刑裡去；那些義人要往永生裡去。',
    '太26:1 耶穌說完了這一切的話，就對門徒說：',
    '太26:2 你們知道，過兩天是逾越節，人子將要被交給人，釘在十字架上。',
    '太26:3 那時，祭司長和民間的長老聚集在大祭司稱為該亞法的院裡。',
    '太26:4 大家商議要用詭計拿住耶穌，殺他，',
    '太26:5 只是說：當節的日子不可，恐怕民間生亂。',
    '太26:6 耶穌在伯大尼長大痲瘋的西門家裡，',
    '太26:7 有一個女人拿著一玉瓶極貴的香膏來，趁耶穌坐席的時候，澆在他的頭上。',
    '太26:8 門徒看見就很不喜悅，說：何用這樣的枉費呢！',
    '太26:9 這香膏可以賣許多錢，賙濟窮人。',
    '太26:10 耶穌看出他們的意思，就說：為什麼難為這女人呢﹖他在我身上做的是一件美事。',
    '太26:11 因為常有窮人和你們同在；只是你們不常有我。',
    '太26:12 他將這香膏澆在我身上是為我安葬做的。',
    '太26:13 我實在告訴你們，普天之下，無論在什麼地方傳這福音，也要述說這女人所行的，作個記念。',
    '太26:14 當下，十二門徒裡有一個稱為加略人猶大的，去見祭司長，',
    '太26:15 說：我把他交給你們，你們願意給我多少錢﹖他們就給了他三十塊錢。',
    '太26:16 從那時候，他就找機會要把耶穌交給他們。',
    '太26:17 除酵節的第一天，門徒來問耶穌說：你吃逾越節的筵席，要我們在哪裡給你預備﹖',
    '太26:18 耶穌說：你們進城去，到某人那裡，對他說：夫子說：我的時候快到了，我與門徒要在你家裡守逾越節。',
    '太26:19 門徒遵著耶穌所吩咐的就去預備了逾越節的筵席。',
    '太26:20 到了晚上，耶穌和十二個門徒坐席。',
    '太26:21 正吃的時候，耶穌說：我實在告訴你們，你們中間有一個人要賣我了。',
    '太26:22 他們就甚憂愁，一個一個的問他說：主，是我嗎﹖',
    '太26:23 耶穌回答說：同我蘸手在盤子裡的，就是他要賣我。',
    '太26:24 人子必要去世，正如經上指著他所寫的；但賣人子的人有禍了！那人不生在世上倒好。',
    '太26:25 賣耶穌的猶大問他說：拉比，是我嗎﹖耶穌說：你說的是。',
    '太26:26 他們吃的時候，耶穌拿起餅來，祝福，就擘開，遞給門徒，說：你們拿著吃，這是我的身體；',
    '太26:27 又拿起杯來，祝謝了，遞給他們，說：你們都喝這個；',
    '太26:28 因為這是我立約的血，為多人流出來，使罪得赦。',
    '太26:29 但我告訴你們，從今以後，我不再喝這葡萄汁，直到我在我父的國裡同你們喝新的那日子。',
    '太26:30 他們唱了詩，就出來往橄欖山去。',
    '太26:31 那時，耶穌對他們說：今夜，你們為我的緣故都要跌倒。因為經上記著說：我要擊打牧人，羊就分散了。',
    '太26:32 但我復活以後，要在你們以先往加利利去。',
    '太26:33 彼得說：眾人雖然為你的緣故跌倒，我卻永不跌倒。',
    '太26:34 耶穌說：我實在告訴你，今夜雞叫以先，你要三次不認我。',
    '太26:35 彼得說：我就是必須和你同死，也總不能不認你。眾門徒都是這樣說。',
    '太26:36 耶穌同門徒來到一個地方，名叫客西馬尼，就對他們說：你們坐在這裡，等我到那邊去禱告。',
    '太26:37 於是帶著彼得和西庇太的兩個兒子同去，就憂愁起來，極其難過，',
    '太26:38 便對他們說：我心裡甚是憂傷，幾乎要死；你們在這裡等候，和我一同警醒。',
    '太26:39 他就稍往前走，俯伏在地，禱告說：我父啊，倘若可行，求你叫這杯離開我。然而，不要照我的意思，只要照你的意思。',
    '太26:40 來到門徒那裡，見他們睡著了，就對彼得說：怎麼樣﹖你們不能同我警醒片時嗎﹖',
    '太26:41 總要警醒禱告，免得入了迷惑。你們心靈固然願意，肉體卻軟弱了。',
    '太26:42 第二次又去禱告說：我父啊，這杯若不能離開我，必要我喝，就願你的意旨成全。',
    '太26:43 又來，見他們睡著了，因為他們的眼睛困倦。',
    '太26:44 耶穌又離開他們去了。第三次禱告，說的話還是與先前一樣。',
    '太26:45 於是來到門徒那裡，對他們說：現在你們仍然睡覺安歇吧（吧：或作嗎﹖）！時候到了，人子被賣在罪人手裡了。',
    '太26:46 起來！我們走吧。看哪，賣我的人近了。',
    '太26:47 說話之間，那十二個門徒裡的猶大來了，並有許多人帶著刀棒，從祭司長和民間的長老那裡與他同來。',
    '太26:48 那賣耶穌的給了他們一個暗號，說：我與誰親嘴，誰就是他。你們可以拿住他。',
    '太26:49 猶大隨即到耶穌跟前，說：請拉比安，就與他親嘴。',
    '太26:50 耶穌對他說：朋友，你來要做的事，就做吧。於是那些人上前，下手拿住耶穌。',
    '太26:51 有跟隨耶穌的一個人伸手拔出刀來，將大祭司的僕人砍了一刀，削掉了他一個耳朵。',
    '太26:52 耶穌對他說：收刀入鞘吧！凡動刀的，必死在刀下。',
    '太26:53 你想，我不能求我父現在為我差遣十二營多天使來嗎﹖',
    '太26:54 若是這樣，經上所說，事情必須如此的話怎麼應驗呢﹖',
    '太26:55 當時，耶穌對眾人說：你們帶著刀棒出來拿我，如同拿強盜嗎﹖我天天坐在殿裡教訓人，你們並沒有拿我。',
    '太26:56 但這一切的事成就了，為要應驗先知書上的話。當下，門徒都離開他逃走了。',
    '太26:57 拿耶穌的人把他帶到大祭司該亞法那裡去；文士和長老已經在那裡聚會。',
    '太26:58 彼得遠遠的跟著耶穌，直到大祭司的院子，進到裡面，就和差役同坐，要看這事到底怎樣。',
    '太26:59 祭司長和全公會尋找假見證控告耶穌，要治死他。',
    '太26:60 雖有好些人來作假見證，總得不著實據。末後有兩個人前來，說：',
    '太26:61 這個人曾說：我能拆毀神的殿，三日內又建造起來。',
    '太26:62 大祭司就站起來，對耶穌說：你什麼都不回答嗎﹖這些人作見證告你的是什麼呢﹖',
    '太26:63 耶穌卻不言語。大祭司對他說：我指著永生神叫你起誓告訴我們，你是神的兒子基督不是﹖',
    '太26:64 耶穌對他說：你說的是。然而，我告訴你們，後來你們要看見人子坐在那權能者的右邊，駕著天上的雲降臨。',
    '太26:65 大祭司就撕開衣服，說：他說了僭妄的話，我們何必再用見證人呢﹖這僭妄的話，現在你們都聽見了。',
    '太26:66 你們的意見如何﹖他們回答說：他是該死的。',
    '太26:67 他們就吐唾沫在他臉上，用拳頭打他；也有用手掌打他的，說：',
    '太26:68 基督啊！你是先知，告訴我們打你的是誰﹖',
    '太26:69 彼得在外面院子裡坐著，有一個使女前來，說：你素來也是同那加利利人耶穌一夥的。',
    '太26:70 彼得在眾人面前卻不承認，說：我不知道你說的是什麼！',
    '太26:71 既出去，到了門口，又有一個使女看見他，就對那裡的人說：這個人也是同拿撒勒人耶穌一夥的。',
    '太26:72 彼得又不承認，並且起誓說：我不認得那個人。',
    '太26:73 過了不多的時候，旁邊站著的人前來，對彼得說：你真是他們一黨的，你的口音把你露出來了。',
    '太26:74 彼得就發咒起誓的說：我不認得那個人。立時，雞就叫了。',
    '太26:75 彼得想起耶穌所說的話：雞叫以先，你要三次不認我。他就出去痛哭。',
    '太27:1 到了早晨，眾祭司長和民間的長老大家商議要治死耶穌，',
    '太27:2 就把他捆綁，解去，交給巡撫彼拉多。',
    '太27:3 這時候，賣耶穌的猶大看見耶穌已經定了罪，就後悔，把那三十塊錢拿回來給祭司長和長老，說：',
    '太27:4 我賣了無辜之人的血是有罪了。他們說：那與我們有什麼相干﹖你自己承當吧！',
    '太27:5 猶大就把那銀錢丟在殿裡，出去吊死了。',
    '太27:6 祭司長拾起銀錢來，說：這是血價，不可放在庫裡。',
    '太27:7 他們商議，就用那銀錢買了窰戶的一塊田，為要埋葬外鄉人。',
    '太27:8 所以那塊田直到今日還叫做血田。',
    '太27:9 這就應驗了先知耶利米的話，說：他們用那三十塊錢，就是被估定之人的價錢，是以色列人中所估定的，',
    '太27:10 買了窰戶的一塊田；這是照著主所吩咐我的。',
    '太27:11 耶穌站在巡撫面前；巡撫問他說：你是猶太人的王嗎﹖耶穌說：你說的是。',
    '太27:12 他被祭司長和長老控告的時候，什麼都不回答。',
    '太27:13 彼拉多就對他說：他們作見證告你這麼多的事，你沒有聽見嗎﹖',
    '太27:14 耶穌仍不回答，連一句話也不說，以致巡撫甚覺希奇。',
    '太27:15 巡撫有一個常例，每逢這節期，隨眾人所要的釋放一個囚犯給他們。',
    '太27:16 當時有一個出名的囚犯叫巴拉巴。',
    '太27:17 眾人聚集的時候，彼拉多就對他們說：你們要我釋放哪一個給你們﹖是巴拉巴呢﹖是稱為基督的耶穌呢﹖',
    '太27:18 巡撫原知道他們是因為嫉妒才把他解了來。',
    '太27:19 正坐堂的時候，他的夫人打發人來說：這義人的事，你一點不可管，因為我今天在夢中為他受了許多的苦。',
    '太27:20 祭司長和長老挑唆眾人，求釋放巴拉巴，除滅耶穌。',
    '太27:21 巡撫對眾人說：這兩個人，你們要我釋放哪一個給你們呢﹖他們說：巴拉巴。',
    '太27:22 彼拉多說：這樣，那稱為基督的耶穌我怎麼辦他呢﹖他們都說：把他釘十字架！',
    '太27:23 巡撫說：為什麼呢﹖他做了什麼惡事呢﹖他們便極力的喊著說：把他釘十字架！',
    '太27:24 彼拉多見說也無濟於事，反要生亂，就拿水在眾人面前洗手，說：流這義人的血，罪不在我，你們承當吧。',
    '太27:25 眾人都回答說：他的血歸到我們和我們的子孫身上。',
    '太27:26 於是彼拉多釋放巴拉巴給他們，把耶穌鞭打了，交給人釘十字架。',
    '太27:27 巡撫的兵就把耶穌帶進衙門，叫全營的兵都聚集在他那裡。',
    '太27:28 他們給他脫了衣服，穿上一件朱紅色袍子，',
    '太27:29 用荊棘編做冠冕，戴在他頭上，拿一根葦子放在他右手裡，跪在他面前，戲弄他，說：恭喜，猶太人的王啊！',
    '太27:30 又吐唾沫在他臉上，拿葦子打他的頭。',
    '太27:31 戲弄完了，就給他脫了袍子，仍穿上他自己的衣服，帶他出去，要釘十字架。',
    '太27:32 他們出來的時候，遇見一個古利奈人，名叫西門，就勉強他同去，好背著耶穌的十字架。',
    '太27:33 到了一個地方名叫各各他，意思就是髑髏地。',
    '太27:34 兵丁拿苦膽調和的酒給耶穌喝。他嘗了，就不肯喝。',
    '太27:35 他們既將他釘在十字架上，就拈鬮分他的衣服，',
    '太27:36 又坐在那裡看守他。',
    '太27:37 在他頭以上安一個牌子，寫著他的罪狀，說：這是猶太人的王耶穌。',
    '太27:38 當時，有兩個強盜和他同釘十字架，一個在右邊，一個在左邊。',
    '太27:39 從那裡經過的人譏誚他，搖著頭，說：',
    '太27:40 你這拆毀聖殿、三日又建造起來的，可以救自己吧！你如果是神的兒子，就從十字架上下來吧！',
    '太27:41 祭司長和文士並長老也是這樣戲弄他，說：',
    '太27:42 他救了別人，不能救自己。他是以色列的王，現在可以從十字架上下來，我們就信他。',
    '太27:43 他倚靠神，神若喜悅他，現在可以救他；因為他曾說：我是神的兒子。',
    '太27:44 那和他同釘的強盜也是這樣的譏誚他。',
    '太27:45 從午正到申初，遍地都黑暗了。',
    '太27:46 約在申初，耶穌大聲喊著說：以利！以利！拉馬撒巴各大尼﹖就是說：我的神！我的神！為什麼離棄我﹖',
    '太27:47 站在那裡的人，有的聽見就說：這個人呼叫以利亞呢！',
    '太27:48 內中有一個人趕緊跑去，拿海絨蘸滿了醋，綁在葦子上，送給他喝。',
    '太27:49 其餘的人說：且等著，看以利亞來救他不來。',
    '太27:50 耶穌又大聲喊叫，氣就斷了。',
    '太27:51 忽然，殿裡的幔子從上到下裂為兩半，地也震動，磐石也崩裂，',
    '太27:52 墳墓也開了，已睡聖徒的身體多有起來的。',
    '太27:53 到耶穌復活以後，他們從墳墓裡出來，進了聖城，向許多人顯現。',
    '太27:54 百夫長和一同看守耶穌的人看見地震並所經歷的事，就極其害怕，說：這真是神的兒子了！',
    '太27:55 有好些婦女在那裡，遠遠的觀看；他們是從加利利跟隨耶穌來服事他的。',
    '太27:56 內中有抹大拉的馬利亞，又有雅各和約西的母親馬利亞，並有西庇太兩個兒子的母親。',
    '太27:57 到了晚上，有一個財主，名叫約瑟，是亞利馬太來的，他也是耶穌的門徒。',
    '太27:58 這人去見彼拉多，求耶穌的身體；彼拉多就吩咐給他。',
    '太27:59 約瑟取了身體，用乾淨細麻布裹好，',
    '太27:60 安放在自己的新墳墓裡，就是他鑿在磐石裡的。他又把大石頭滾到墓門口，就去了。',
    '太27:61 有抹大拉的馬利亞和那個馬利亞在那裡，對著墳墓坐著。',
    '太27:62 次日，就是預備日的第二天，祭司長和法利賽人聚集來見彼拉多，說：',
    '太27:63 大人，我們記得那誘惑人的還活著的時候曾說：三日後我要復活。',
    '太27:64 因此，請吩咐人將墳墓把守妥當，直到第三日，恐怕他的門徒來，把他偷了去，就告訴百姓說：他從死裡復活了。這樣，那後來的迷惑比先前的更利害了！',
    '太27:65 彼拉多說：你們有看守的兵，去吧！盡你們所能的把守妥當。',
    '太27:66 他們就帶著看守的兵同去，封了石頭，將墳墓把守妥當。',
    '太28:1 安息日將盡，七日的頭一日，天快亮的時候，抹大拉的馬利亞和那個馬利亞來看墳墓。',
    '太28:2 忽然，地大震動；因為有主的使者從天上下來，把石頭滾開，坐在上面。',
    '太28:3 他的像貌如同閃電，衣服潔白如雪。',
    '太28:4 看守的人就因他嚇得渾身亂戰，甚至和死人一樣。',
    '太28:5 天使對婦女說：不要害怕！我知道你們是尋找那釘十字架的耶穌。',
    '太28:6 他不在這裡，照他所說的，已經復活了。你們來看安放主的地方。',
    '太28:7 快去告訴他的門徒，說他從死裡復活了，並且在你們以先往加利利去，在那裡你們要見他。看哪，我已經告訴你們了。',
    '太28:8 婦女們就急忙離開墳墓，又害怕，又大大的歡喜，跑去要報給他的門徒。',
    '太28:9 忽然，耶穌遇見他們，說：願你們平安！他們就上前抱住他的腳拜他。',
    '太28:10 耶穌對他們說：不要害怕！你們去告訴我的弟兄，叫他們往加利利去，在那裡必見我。',
    '太28:11 他們去的時候，看守的兵有幾個進城去，將所經歷的事都報給祭司長。',
    '太28:12 祭司長和長老聚集商議，就拿許多銀錢給兵丁，說：',
    '太28:13 你們要這樣說：夜間我們睡覺的時候，他的門徒來，把他偷去了。',
    '太28:14 倘若這話被巡撫聽見，有我們勸他，保你們無事。',
    '太28:15 兵丁受了銀錢，就照所囑咐他們的去行。這話就傳說在猶太人中間，直到今日。',
    '太28:16 十一個門徒往加利利去，到了耶穌約定的山上。',
    '太28:17 他們見了耶穌就拜他，然而還有人疑惑。',
    '太28:18 耶穌進前來，對他們說：天上地下所有的權柄都賜給我了。',
    '太28:19 所以，你們要去，使萬民作我的門徒，奉父、子、聖靈的名給他們施洗（或作：給他們施洗，歸於父、子、聖靈的名）。',
    '太28:20 凡我所吩咐你們的，都教訓他們遵守，我就常與你們同在，直到世界的末了。',
    '可1:1 神的兒子，耶穌基督福音的起頭。',
    '可1:2 正如先知以賽亞（有古卷無以賽亞三個字）書上記著說：看哪，我要差遣我的使者在你前面，預備道路。',
    '可1:3 在曠野有人聲喊著說：預備主的道，修直他的路。',
    '可1:4 照這話，約翰來了，在曠野施洗，傳悔改的洗禮，使罪得赦。',
    '可1:5 猶太全地和耶路撒冷的人都出去到約翰那裡，承認他們的罪，在約但河裡受他的洗。',
    '可1:6 約翰穿駱駝毛的衣服，腰束皮帶，吃的是蝗蟲、野蜜。',
    '可1:7 他傳道說：有一位在我以後來的，能力比我更大，我就是彎腰給他解鞋帶也是不配的。',
    '可1:8 我是用水給你們施洗，他卻要用聖靈給你們施洗。',
    '可1:9 那時，耶穌從加利利的拿撒勒來，在約但河裡受了約翰的洗。',
    '可1:10 他從水裡一上來，就看見天裂開了，聖靈彷彿鴿子，降在他身上。',
    '可1:11 又有聲音從天上來，說：你是我的愛子，我喜悅你。',
    '可1:12 聖靈就把耶穌催到曠野裡去。',
    '可1:13 他在曠野四十天，受撒但的試探，並與野獸同在一處，且有天使來伺候他。',
    '可1:14 約翰下監以後，耶穌來到加利利，宣傳神的福音，',
    '可1:15 說：日期滿了，神的國近了。你們當悔改，信福音！',
    '可1:16 耶穌順著加利利的海邊走，看見西門和西門的兄弟安得烈在海裡撒網；他們本是打魚的。',
    '可1:17 耶穌對他們說：來跟從我，我要叫你們得人如得魚一樣。',
    '可1:18 他們就立刻捨了網，跟從了他。',
    '可1:19 耶穌稍往前走，又見西庇太的兒子雅各和雅各的兄弟約翰在船上補網。',
    '可1:20 耶穌隨即招呼他們，他們就把父親西庇太和雇工人留在船上，跟從耶穌去了。',
    '可1:21 到了迦百農，耶穌就在安息日進了會堂教訓人。',
    '可1:22 眾人很希奇他的教訓；因為他教訓他們，正像有權柄的人，不像文士。',
    '可1:23 在會堂裡，有一個人被污鬼附著。他喊叫說：',
    '可1:24 拿撒勒人耶穌，我們與你有什麼相干﹖你來滅我們嗎﹖我知道你是誰，乃是神的聖者。',
    '可1:25 耶穌責備他說：不要作聲！從這人身上出來吧。',
    '可1:26 污鬼叫那人抽了一陣瘋，大聲喊叫，就出來了。',
    '可1:27 眾人都驚訝，以致彼此對問說：這是什麼事﹖是個新道理啊！他用權柄吩咐污鬼，連污鬼也聽從了他。',
    '可1:28 耶穌的名聲就傳遍了加利利的四方。',
    '可1:29 他們一出會堂，就同著雅各、約翰，進了西門和安得烈的家。',
    '可1:30 西門的岳母正害熱病躺著，就有人告訴耶穌。',
    '可1:31 耶穌進前拉著他的手，扶他起來，熱就退了，他就服事他們。',
    '可1:32 天晚日落的時候，有人帶著一切害病的，和被鬼附的，來到耶穌跟前。',
    '可1:33 合城的人都聚集在門前。',
    '可1:34 耶穌治好了許多害各樣病的人，又趕出許多鬼，不許鬼說話，因為鬼認識他。',
    '可1:35 次日早晨，天未亮的時候，耶穌起來，到曠野地方去，在那裡禱告。',
    '可1:36 西門和同伴追了他去，',
    '可1:37 遇見了就對他說：眾人都找你。',
    '可1:38 耶穌對他們說：我們可以往別處去，到鄰近的鄉村，我也好在那裡傳道，因為我是為這事出來的。',
    '可1:39 於是在加利利全地，進了會堂，傳道，趕鬼。',
    '可1:40 有一個長大痲瘋的來求耶穌，向他跪下，說：你若肯，必能叫我潔淨了。',
    '可1:41 耶穌動了慈心，就伸手摸他，說：我肯，你潔淨了吧！',
    '可1:42 大痲瘋即時離開他，他就潔淨了。',
    '可1:43 耶穌嚴嚴的囑咐他，就打發他走，',
    '可1:44 對他說：你要謹慎，什麼話都不可告訴人，只要去把身體給祭司察看，又因為你潔淨了，獻上摩西所吩咐的禮物，對眾人作證據。',
    '可1:45 那人出去，倒說許多的話，把這件事傳揚開了，叫耶穌以後不得再明明的進城，只好在外邊曠野地方。人從各處都就了他來。',
    '可2:1 過了些日子，耶穌又進了迦百農。人聽見他在房子裡，',
    '可2:2 就有許多人聚集，甚至連門前都沒有空地；耶穌就對他們講道。',
    '可2:3 有人帶著一個癱子來見耶穌，是用四個人擡來的；',
    '可2:4 因為人多，不得近前，就把耶穌所在的房子，拆了房頂，既拆通了，就把癱子連所躺臥的褥子都縋下來。',
    '可2:5 耶穌見他們的信心，就對癱子說：小子，你的罪赦了。',
    '可2:6 有幾個文士坐在那裡，心裡議論，說：',
    '可2:7 這個人為什麼這樣說呢﹖他說僭妄的話了。除了神以外，誰能赦罪呢﹖',
    '可2:8 耶穌心中知道他們心裡這樣議論，就說：你們心裡為什麼這樣議論呢﹖',
    '可2:9 或對癱子說你的罪赦了，或說起來！拿你的褥子行走；哪一樣容易呢﹖',
    '可2:10 但要叫你們知道，人子在地上有赦罪的權柄。就對癱子說：',
    '可2:11 我吩咐你，起來！拿你的褥子回家去吧。',
    '可2:12 那人就起來，立刻拿著褥子，當眾人面前出去了，以致眾人都驚奇，歸榮耀與神，說：我們從來沒有見過這樣的事！',
    '可2:13 耶穌又出到海邊去，眾人都就了他來，他便教訓他們。',
    '可2:14 耶穌經過的時候，看見亞勒腓的兒子利未坐在稅關上，就對他說：你跟從我來。他就起來，跟從了耶穌。',
    '可2:15 耶穌在利未家裡坐席的時候，有好些稅吏和罪人與耶穌並門徒一同坐席；因為這樣的人多，他們也跟隨耶穌。',
    '可2:16 法利賽人中的文士（有古卷：文士和法利賽人）看見耶穌和罪人並稅吏一同吃飯，就對他門徒說：他和稅吏並罪人一同吃喝嗎﹖',
    '可2:17 耶穌聽見，就對他們說：康健的人用不著醫生，有病的人才用得著。我來本不是召義人，乃是召罪人。',
    '可2:18 當下，約翰的門徒和法利賽人禁食。他們來問耶穌說：約翰的門徒和法利賽人的門徒禁食，你的門徒倒不禁食，這是為什麼呢﹖',
    '可2:19 耶穌對他們說：新郎和陪伴之人同在的時候，陪伴之人豈能禁食呢﹖新郎還同在，他們不能禁食。',
    '可2:20 但日子將到，新郎要離開他們，那日他們就要禁食。',
    '可2:21 沒有人把新布縫在舊衣服上，恐怕所補上的新布帶壞了舊衣服，破的就更大了。',
    '可2:22 也沒有人把新酒裝在舊皮袋裡，恐怕酒把皮袋裂開，酒和皮袋就都壞了；惟把新酒裝在新皮袋裡。',
    '可2:23 耶穌當安息日從麥地經過。他門徒行路的時候，掐了麥穗。',
    '可2:24 法利賽人對耶穌說：看哪，他們在安息日為什麼做不可做的事呢﹖',
    '可2:25 耶穌對他們說：經上記著大衛和跟從他的人缺乏飢餓之時所做的事，你們沒有念過嗎﹖',
    '可2:26 他當亞比亞他作大祭司的時候，怎麼進了神的殿，吃了陳設餅，又給跟從他的人吃。這餅除了祭司以外，人都不可吃。',
    '可2:27 又對他們說：安息日是為人設立的，人不是為安息日設立的。',
    '可2:28 所以，人子也是安息日的主。',
    '可3:1 耶穌又進了會堂，在那裡有一個人枯乾了一隻手。',
    '可3:2 眾人窺探耶穌，在安息日醫治不醫治，意思是要控告耶穌。',
    '可3:3 耶穌對那枯乾一隻手的人說：起來，站在當中。',
    '可3:4 又問眾人說：在安息日行善行惡，救命害命，哪樣是可以的呢﹖他們都不作聲。',
    '可3:5 耶穌怒目周圍看他們，憂愁他們的心剛硬，就對那人說：伸出手來！他把手一伸，手就復了原。',
    '可3:6 法利賽人出去，同希律一黨的人商議怎樣可以除滅耶穌。',
    '可3:7 耶穌和門徒退到海邊去，有許多人從加利利跟隨他。',
    '可3:8 還有許多人聽見他所做的大事，就從猶太、耶路撒冷、以土買、約但河外，並推羅、西頓的四方來到他那裡。',
    '可3:9 他因為人多，就吩咐門徒叫一隻小船伺候著，免得眾人擁擠他。',
    '可3:10 他治好了許多人，所以凡有災病的，都擠進來要摸他。',
    '可3:11 污鬼無論何時看見他，就俯伏在他面前，喊著說：你是神的兒子。',
    '可3:12 耶穌再三的囑咐他們，不要把他顯露出來。',
    '可3:13 耶穌上了山，隨自己的意思叫人來；他們便來到他那裡。',
    '可3:14 他就設立十二個人，要他們常和自己同在，也要差他們去傳道，',
    '可3:15 並給他們權柄趕鬼。',
    '可3:16 這十二個人有西門─耶穌又給他起名叫彼得，',
    '可3:17 還有西庇太的兒子雅各和雅各的兄弟約翰，又給這兩個人起名叫半尼其，就是雷子的意思，',
    '可3:18 又有安得烈、腓力、巴多羅買、馬太、多馬、亞勒腓的兒子雅各、和達太，並奮銳黨的西門；',
    '可3:19 還有賣耶穌的加略人猶大。',
    '可3:20 耶穌進了一個屋子，眾人又聚集，甚至他連飯也顧不得吃。',
    '可3:21 耶穌的親屬聽見，就出來要拉住他，因為他們說他癲狂了。',
    '可3:22 從耶路撒冷下來的文士說：他是被別西卜附著；又說：他是靠著鬼王趕鬼。',
    '可3:23 耶穌叫他們來，用比喻對他們說：撒但怎能趕出撒但呢﹖',
    '可3:24 若一國自相紛爭，那國就站立不住；',
    '可3:25 若一家自相紛爭，那家就站立不住。',
    '可3:26 若撒但自相攻打紛爭，他就站立不住，必要滅亡。',
    '可3:27 沒有人能進壯士家裡，搶奪他的家具；必先捆住那壯士，才可以搶奪他的家。',
    '可3:28 我實在告訴你們，世人一切的罪和一切褻瀆的話都可得赦免；',
    '可3:29 凡褻瀆聖靈的，卻永不得赦免，乃要擔當永遠的罪。',
    '可3:30 這話是因為他們說：他是被污鬼附著的。',
    '可3:31 當下，耶穌的母親和弟兄來，站在外邊，打發人去叫他。',
    '可3:32 有許多人在耶穌周圍坐著，他們就告訴他說：看哪，你母親和你弟兄在外邊找你。',
    '可3:33 耶穌回答說：誰是我的母親﹖誰是我的弟兄﹖',
    '可3:34 就四面觀看那周圍坐著的人，說：看哪，我的母親，我的弟兄。',
    '可3:35 凡遵行神旨意的人就是我的弟兄姊妹和母親了。',
    '可4:1 耶穌又在海邊教訓人。有許多人到他那裡聚集，他只得上船坐下。船在海裡，眾人都靠近海，站在岸上。',
    '可4:2 耶穌就用比喻教訓他們許多道理。在教訓之間，對他們說：',
    '可4:3 你們聽啊！有一個撒種的出去撒種。',
    '可4:4 撒的時候，有落在路旁的，飛鳥來吃盡了；',
    '可4:5 有落在土淺石頭地上的，土既不深，發苗最快，',
    '可4:6 日頭出來一曬，因為沒有根，就枯乾了；',
    '可4:7 有落在荊棘裡的，荊棘長起來，把他擠住了，就不結實；',
    '可4:8 又有落在好土裡的，就發生長大，結實有三十倍的，有六十倍的，有一百倍的；',
    '可4:9 又說：有耳可聽的，就應當聽！',
    '可4:10 無人的時候，跟隨耶穌的人和十二個門徒問他這比喻的意思。',
    '可4:11 耶穌對他們說：神國的奧祕只叫你們知道，若是對外人講，凡事就用比喻，',
    '可4:12 叫他們看是看見，卻不曉得；聽是聽見，卻不明白；恐怕他們回轉過來，就得赦免。',
    '可4:13 又對他們說：你們不明白這比喻嗎﹖這樣怎能明白一切的比喻呢﹖',
    '可4:14 撒種之人所撒的就是道。',
    '可4:15 那撒在路旁的，就是人聽了道，撒但立刻來，把撒在他心裡的道奪了去。',
    '可4:16 那撒在石頭地上的，就是人聽了道，立刻歡喜領受，',
    '可4:17 但他心裡沒有根，不過是暫時的，及至為道遭了患難，或是受了逼迫，立刻就跌倒了。',
    '可4:18 還有那撒在荊棘裡的，就是人聽了道，',
    '可4:19 後來有世上的思慮、錢財的迷惑，和別樣的私慾進來，把道擠住了，就不能結實。',
    '可4:20 那撒在好地上的，就是人聽道，又領受，並且結實，有三十倍的，有六十倍的，有一百倍的。',
    '可4:21 耶穌又對他們說：人拿燈來，豈是要放在斗底下，床底下，不放在燈臺上嗎﹖',
    '可4:22 因為掩藏的事，沒有不顯出來的；隱瞞的事，沒有不露出來的。',
    '可4:23 有耳可聽的，就應當聽！',
    '可4:24 又說：你們所聽的要留心。你們用什麼量器量給人，也必用什麼量器量給你們，並且要多給你們。',
    '可4:25 因為有的，還要給他；沒有的，連他所有的也要奪去。',
    '可4:26 又說：神的國如同人把種撒在地上。',
    '可4:27 黑夜睡覺，白日起來，這種就發芽漸長，那人卻不曉得如何這樣。',
    '可4:28 地生五穀是出於自然的：先發苗，後長穗，再後穗上結成飽滿的子粒；',
    '可4:29 穀既熟了，就用鐮刀去割，因為收成的時候到了。',
    '可4:30 又說：神的國，我們可用什麼比較呢﹖可用什麼比喻表明呢﹖',
    '可4:31 好像一粒芥菜種，種在地裡的時候，雖比地上的百種都小，',
    '可4:32 但種上以後，就長起來，比各樣的菜都大，又長出大枝來，甚至天上的飛鳥可以宿在他的蔭下。',
    '可4:33 耶穌用許多這樣的比喻，照他們所能聽的，對他們講道。',
    '可4:34 若不用比喻，就不對他們講；沒有人的時候，就把一切的道講給門徒聽。',
    '可4:35 當那天晚上，耶穌對門徒說：我們渡到那邊去吧。',
    '可4:36 門徒離開眾人，耶穌仍在船上，他們就把他一同帶去；也有別的船和他同行。',
    '可4:37 忽然起了暴風，波浪打入船內，甚至船要滿了水。',
    '可4:38 耶穌在船尾上，枕著枕頭睡覺。門徒叫醒了他，說：夫子！我們喪命，你不顧嗎﹖',
    '可4:39 耶穌醒了，斥責風，向海說：住了吧！靜了吧！風就止住，大大的平靜了。',
    '可4:40 耶穌對他們說：為什麼膽怯﹖你們還沒有信心嗎﹖',
    '可4:41 他們就大大的懼怕，彼此說：這到底是誰，連風和海也聽從他了。',
    '可5:1 他們來到海那邊格拉森人的地方。',
    '可5:2 耶穌一下船，就有一個被污鬼附著的人從墳塋裡出來迎著他。',
    '可5:3 那人常住在墳塋裡，沒有人能捆住他，就是用鐵鍊也不能；',
    '可5:4 因為人屢次用腳鐐和鐵鍊捆鎖他，鐵鍊竟被他掙斷了，腳鐐也被他弄碎了；總沒有人能制伏他。',
    '可5:5 他晝夜常在墳塋裡和山中喊叫，又用石頭砍自己。',
    '可5:6 他遠遠的看見耶穌，就跑過去拜他，',
    '可5:7 大聲呼叫說：至高神的兒子耶穌，我與你有什麼相干﹖我指著神懇求你，不要叫我受苦！',
    '可5:8 是因耶穌曾吩咐他說：污鬼啊，從這人身上出來吧！',
    '可5:9 耶穌問他說：你名叫什麼﹖回答說：我名叫群，因為我們多的緣故；',
    '可5:10 就再三的求耶穌，不要叫他們離開那地方。',
    '可5:11 在那裡山坡上，有一大群豬吃食；',
    '可5:12 鬼就央求耶穌說：求你打發我們往豬群裡，附著豬去。',
    '可5:13 耶穌准了他們，污鬼就出來，進入豬裡去。於是那群豬闖下山崖，投在海裡，淹死了。豬的數目約有二千。',
    '可5:14 放豬的就逃跑了，去告訴城裡和鄉下的人。眾人就來，要看是什麼事。',
    '可5:15 他們來到耶穌那裡，看見那被鬼附著的人，就是從前被群鬼所附的，坐著，穿上衣服，心裡明白過來，他們就害怕。',
    '可5:16 看見這事的，便將鬼附之人所遇見的和那群豬的事都告訴了眾人；',
    '可5:17 眾人就央求耶穌離開他們的境界。',
    '可5:18 耶穌上船的時候，那從前被鬼附著的人懇求和耶穌同在。',
    '可5:19 耶穌不許，卻對他說：你回家去，到你的親屬那裡，將主為你所做的是何等大的事，是怎樣憐憫你，都告訴他們。',
    '可5:20 那人就走了，在低加波利傳揚耶穌為他做了何等大的事，眾人就都希奇。',
    '可5:21 耶穌坐船又渡到那邊去，就有許多人到他那裡聚集；他正在海邊上。',
    '可5:22 有一個管會堂的人，名叫睚魯，來見耶穌，就俯伏在他腳前，',
    '可5:23 再三的求他，說：我的小女兒快要死了，求你去按手在他身上，使他痊癒，得以活了。',
    '可5:24 耶穌就和他同去。有許多人跟隨擁擠他。',
    '可5:25 有一個女人，患了十二年的血漏，',
    '可5:26 在好些醫生手裡受了許多的苦，又花盡了他所有的，一點也不見好，病勢反倒更重了。',
    '可5:27 他聽見耶穌的事，就從後頭來，雜在眾人中間，摸耶穌的衣裳，',
    '可5:28 意思說：我只摸他的衣裳，就必痊癒。',
    '可5:29 於是他血漏的源頭立刻乾了；他便覺得身上的災病好了。',
    '可5:30 耶穌頓時心裡覺得有能力從自己身上出去，就在眾人中間轉過來，說：誰摸我的衣裳﹖',
    '可5:31 門徒對他說：你看眾人擁擠你，還說誰摸我嗎﹖',
    '可5:32 耶穌周圍觀看，要見做這事的女人。',
    '可5:33 那女人知道在自己身上所成的事，就恐懼戰兢，來俯伏在耶穌跟前，將實情全告訴他。',
    '可5:34 耶穌對他說：女兒，你的信救了你，平平安安地回去吧！你的災病痊癒了。',
    '可5:35 還說話的時候，有人從管會堂的家裡來，說：你的女兒死了，何必還勞動先生呢﹖',
    '可5:36 耶穌聽見所說的話，就對管會堂的說：不要怕，只要信！',
    '可5:37 於是帶著彼得、雅各、和雅各的兄弟約翰同去，不許別人跟隨他。',
    '可5:38 他們來到管會堂的家裡；耶穌看見那裡亂嚷，並有人大大的哭泣哀號，',
    '可5:39 進到裡面，就對他們說：為什麼亂嚷哭泣呢﹖孩子不是死了，是睡著了。',
    '可5:40 他們就嗤笑耶穌。耶穌把他們都攆出去，就帶著孩子的父母，和跟隨的人進了孩子所在的地方，',
    '可5:41 就拉著孩子的手，對他說：大利大，古米！翻出來就是說：閨女，我吩咐你起來！',
    '可5:42 那閨女立時起來走。他們就大大的驚奇；閨女已經十二歲了。',
    '可5:43 耶穌切切的囑咐他們，不要叫人知道這事，又吩咐給他東西吃。',
    '可6:1 耶穌離開那裡，來到自己的家鄉；門徒也跟從他。',
    '可6:2 到了安息日，他在會堂裡教訓人。眾人聽見，就甚希奇，說：這人從哪裡有這些事呢﹖所賜給他的是什麼智慧﹖他手所做的是何等的異能呢﹖',
    '可6:3 這不是那木匠嗎﹖不是馬利亞的兒子雅各、約西、猶大、西門的長兄嗎﹖他妹妹們不也是在我們這裡嗎﹖他們就厭棄他（厭棄他：原文是因他跌倒）。',
    '可6:4 耶穌對他們說：大凡先知，除了本地、親屬、本家之外，沒有不被人尊敬的。',
    '可6:5 耶穌就在那裡不得行什麼異能，不過按手在幾個病人身上，治好他們。',
    '可6:6 他也詫異他們不信，就往周圍鄉村教訓人去了。',
    '可6:7 耶穌叫了十二個門徒來，差遣他們兩個兩個的出去，也賜給他們權柄，制伏污鬼；',
    '可6:8 並且囑咐他們：行路的時候不要帶食物和口袋，腰袋裡也不要帶錢，除了柺杖以外，什麼都不要帶；',
    '可6:9 只要穿鞋，也不要穿兩件掛子，',
    '可6:10 又對他們說：你們無論到何處，進了人的家，就住在那裡，直到離開那地方。',
    '可6:11 何處的人不接待你們，不聽你們，你們離開那裡的時候，就把腳上的塵土跺下去，對他們作見證。',
    '可6:12 門徒就出去傳道，叫人悔改，',
    '可6:13 又趕出許多的鬼，用油抹了許多病人，治好他們。',
    '可6:14 耶穌的名聲傳揚出來。希律王聽見了，就說：施洗的約翰從死裡復活了，所以這些異能由他裡面發出來。',
    '可6:15 但別人說：是以利亞。又有人說：是先知，正像先知中的一位。',
    '可6:16 希律聽見卻說：是我所斬的約翰，他復活了。',
    '可6:17 先是希律為他兄弟腓力的妻子希羅底的緣故，差人去拿住約翰，鎖在監裡，因為希律已經娶了那婦人。',
    '可6:18 約翰曾對希律說：你娶你兄弟的妻子是不合理的。',
    '可6:19 於是希羅底懷恨他，想要殺他，只是不能；',
    '可6:20 因為希律知道約翰是義人，是聖人，所以敬畏他，保護他，聽他講論，就多照著行（有古卷：游移不定），並且樂意聽他。',
    '可6:21 有一天，恰巧是希律的生日，希律擺設筵席，請了大臣和千夫長，並加利利作首領的。',
    '可6:22 希羅底的女兒進來跳舞，使希律和同席的人都歡喜。王就對女子說：你隨意向我求什麼，我必給你；',
    '可6:23 又對他起誓說：隨你向我求什麼，就是我國的一半，我也必給你。',
    '可6:24 他就出去對他母親說：我可以求什麼呢﹖他母親說：施洗約翰的頭。',
    '可6:25 他就急忙進去見王，求他說：我願王立時把施洗約翰的頭放在盤子裡給我。',
    '可6:26 王就甚憂愁；但因他所起的誓，又因同席的人，就不肯推辭，',
    '可6:27 隨即差一個護衛兵，吩咐拿約翰的頭來。護衛兵就去，在監裡斬了約翰，',
    '可6:28 把頭放在盤子裡，拿來給女子，女子就給他母親。',
    '可6:29 約翰的門徒聽見了，就來把他的屍首領去，葬在墳墓裡。',
    '可6:30 使徒聚集到耶穌那裡，將一切所做的事、所傳的道全告訴他。',
    '可6:31 他就說：你們來，同我暗暗的到曠野地方去歇一歇。這是因為來往的人多，他們連吃飯也沒有工夫。',
    '可6:32 他們就坐船，暗暗的往曠野地方去。',
    '可6:33 眾人看見他們去，有許多認識他們的，就從各城步行，一同跑到那裡，比他們先趕到了。',
    '可6:34 耶穌出來，見有許多的人，就憐憫他們，因為他們如同羊沒有牧人一般，於是開口教訓他們許多道理。',
    '可6:35 天已經晚了，門徒進前來，說：這是野地，天已經晚了，',
    '可6:36 請叫眾人散開，他們好往四面鄉村裡去，自己買什麼吃。',
    '可6:37 耶穌回答說：你們給他們吃吧。門徒說：我們可以去買二十兩銀子的餅，給他們吃嗎﹖',
    '可6:38 耶穌說：你們有多少餅，可以去看看。他們知道了，就說：五個餅，兩條魚。',
    '可6:39 耶穌吩咐他們，叫眾人一幫一幫的坐在青草地上。',
    '可6:40 眾人就一排一排的坐下，有一百一排的，有五十一排的。',
    '可6:41 耶穌拿著這五個餅，兩條魚，望著天祝福，擘開餅，遞給門徒，擺在眾人面前，也把那兩條魚分給眾人。',
    '可6:42 他們都吃，並且吃飽了。',
    '可6:43 門徒就把碎餅碎魚收拾起來，裝滿了十二個籃子。',
    '可6:44 吃餅的男人共有五千。',
    '可6:45 耶穌隨即催門徒上船，先渡到那邊伯賽大去，等他叫眾人散開。',
    '可6:46 他既辭別了他們，就往山上去禱告。',
    '可6:47 到了晚上，船在海中，耶穌獨自在岸上；',
    '可6:48 看見門徒因風不順，搖櫓甚苦。夜裡約有四更天，就在海面上走，往他們那裡去，意思要走過他們去。',
    '可6:49 但門徒看見他在海面上走，以為是鬼怪，就喊叫起來；',
    '可6:50 因為他們都看見了他，且甚驚慌。耶穌連忙對他們說：你們放心！是我，不要怕！',
    '可6:51 於是到他們那裡，上了船，風就住了；他們心裡十分驚奇。',
    '可6:52 這是因為他們不明白那分餅的事，心裡還是愚頑。',
    '可6:53 既渡過去，來到革尼撒勒地方，就靠了岸，',
    '可6:54 一下船，眾人認得是耶穌，',
    '可6:55 就跑遍那一帶地方，聽見他在何處，便將有病的人用褥子擡到那裡。',
    '可6:56 凡耶穌所到的地方，或村中，或城裡，或鄉間，他們都將病人放在街市上，求耶穌只容他們摸他的衣裳繸子；凡摸著的人就都好了。',
    '可7:1 有法利賽人和幾個文士從耶路撒冷來，到耶穌那裡聚集。',
    '可7:2 他們曾看見他的門徒中有人用俗手，就是沒有洗的手，吃飯。',
    '可7:3 （原來法利賽人和猶太人都拘守古人的遺傳，若不仔細洗手就不吃飯；',
    '可7:4 從市上來，若不洗浴也不吃飯；還有好些別的規矩，他們歷代拘守，就是洗杯、罐、銅器等物。）',
    '可7:5 法利賽人和文士問他說：你的門徒為什麼不照古人的遺傳，用俗手吃飯呢﹖',
    '可7:6 耶穌說：以賽亞指著你們假冒為善之人所說的預言是不錯的。如經上說：這百姓用嘴唇尊敬我，心卻遠離我。',
    '可7:7 他們將人的吩咐當作道理教導人，所以拜我也是枉然。',
    '可7:8 你們是離棄神的誡命，拘守人的遺傳；',
    '可7:9 又說：你們誠然是廢棄神的誡命，要守自己的遺傳。',
    '可7:10 摩西說：當孝敬父母；又說：咒罵父母的，必治死他。',
    '可7:11 你們倒說：人若對父母說：我所當奉給你的，已經作了各耳板（各耳板就是供獻的意思），',
    '可7:12 以後你們就不容他再奉養父母。',
    '可7:13 這就是你們承接遺傳，廢了神的道。你們還做許多這樣的事。',
    '可7:14 耶穌又叫眾人來，對他們說：你們都要聽我的話，也要明白。',
    '可7:15 從外面進去的不能污穢人，惟有從裡面出來的乃能污穢人。（有古卷在此有：',
    '可7:16 有耳可聽的，就應當聽！）',
    '可7:17 耶穌離開眾人，進了屋子，門徒就問他這比喻的意思。',
    '可7:18 耶穌對他們說：你們也是這樣不明白嗎﹖豈不曉得凡從外面進入的，不能污穢人，',
    '可7:19 因為不是入他的心，乃是入他的肚腹，又落到茅廁裡。這是說，各樣的食物都是潔淨的；',
    '可7:20 又說：從人裡面出來的，那才能污穢人；',
    '可7:21 因為從裡面，就是從人心裡，發出惡念、苟合、',
    '可7:22 偷盜、兇殺、姦淫、貪婪、邪惡、詭詐、淫蕩、嫉妒、謗讟、驕傲、狂妄。',
    '可7:23 這一切的惡都是從裡面出來，且能污穢人。',
    '可7:24 耶穌從那裡起身，往推羅、西頓的境內去，進了一家，不願意人知道，卻隱藏不住。',
    '可7:25 當下，有一個婦人，他的小女兒被污鬼附著，聽見耶穌的事，就來俯伏在他腳前。',
    '可7:26 這婦人是希利尼人，屬敘利腓尼基族。他求耶穌趕出那鬼離開他的女兒。',
    '可7:27 耶穌對他說：讓兒女們先吃飽，不好拿兒女的餅丟給狗吃。',
    '可7:28 婦人回答說：主啊，不錯；但是狗在桌子底下也吃孩子們的碎渣兒。',
    '可7:29 耶穌對他說：因這句話，你回去吧；鬼已經離開你的女兒了。',
    '可7:30 他就回家去，見小孩子躺在床上，鬼已經出去了。',
    '可7:31 耶穌又離了推羅的境界，經過西頓，就從低加波利境內來到加利利海。',
    '可7:32 有人帶著一個耳聾舌結的人來見耶穌，求他按手在他身上。',
    '可7:33 耶穌領他離開眾人，到一邊去，就用指頭探他的耳朵，吐唾沫抹他的舌頭，',
    '可7:34 望天歎息，對他說：以法大！就是說：開了吧！',
    '可7:35 他的耳朵就開了，舌結也解了，說話也清楚了。',
    '可7:36 耶穌囑咐他們不要告訴人；但他越發囑咐，他們越發傳揚開了。',
    '可7:37 眾人分外希奇，說：他所做的事都好，他連聾子也叫他們聽見，啞巴也叫他們說話。',
    '可8:1 那時，又有許多人聚集，並沒有什麼吃的。耶穌叫門徒來，說：',
    '可8:2 我憐憫這眾人；因為他們同我在這裡已經三天，也沒有吃的了。',
    '可8:3 我若打發他們餓著回家，就必在路上困乏，因為其中有從遠處來的。',
    '可8:4 門徒回答說：在這野地，從哪裡能得餅，叫這些人吃飽呢﹖',
    '可8:5 耶穌問他們說：你們有多少餅﹖他們說：七個。',
    '可8:6 他吩咐眾人坐在地上，就拿著這七個餅祝謝了，擘開，遞給門徒，叫他們擺開，門徒就擺在眾人面前。',
    '可8:7 又有幾條小魚；耶穌祝了福，就吩咐也擺在眾人面前。',
    '可8:8 眾人都吃，並且吃飽了，收拾剩下的零碎，有七筐子。',
    '可8:9 人數約有四千。耶穌打發他們走了，',
    '可8:10 隨即同門徒上船，來到大瑪努他境內。',
    '可8:11 法利賽人出來盤問耶穌，求他從天上顯個神蹟給他們看，想要試探他。',
    '可8:12 耶穌心裡深深的歎息，說：這世代為什麼求神蹟呢﹖我實在告訴你們，沒有神蹟給這世代看。',
    '可8:13 他就離開他們，又上船往海那邊去了。',
    '可8:14 門徒忘了帶餅；在船上除了一個餅，沒有別的食物。',
    '可8:15 耶穌囑咐他們說：你們要謹慎，防備法利賽人的酵和希律的酵。',
    '可8:16 他們彼此議論說：這是因為我們沒有餅吧。',
    '可8:17 耶穌看出來，就說：你們為什麼因為沒有餅就議論呢﹖你們還不省悟，還不明白嗎﹖你們的心還是愚頑嗎﹖',
    '可8:18 你們有眼睛，看不見嗎﹖有耳朵，聽不見嗎﹖也不記得嗎﹖',
    '可8:19 我擘開那五個餅分給五千人，你們收拾的零碎裝滿了多少籃子呢﹖他們說：十二個。',
    '可8:20 又擘開那七個餅分給四千人，你們收拾的零碎裝滿了多少筐子呢﹖他們說：七個。',
    '可8:21 耶穌說：你們還是不明白嗎﹖',
    '可8:22 他們來到伯賽大，有人帶一個瞎子來，求耶穌摸他。',
    '可8:23 耶穌拉著瞎子的手，領他到村外，就吐唾沫在他眼睛上，按手在他身上，問他說：你看見什麼了﹖',
    '可8:24 他就擡頭一看，說：我看見人了；他們好像樹木，並且行走。',
    '可8:25 隨後又按手在他眼睛上，他定睛一看，就復了原，樣樣都看得清楚了。',
    '可8:26 耶穌打發他回家，說：連這村子你也不要進去。',
    '可8:27 耶穌和門徒出去，往該撒利亞腓立比的村莊去；在路上問門徒說：人說我是誰﹖',
    '可8:28 他們說：有人說是施洗的約翰；有人說是以利亞；又有人說是先知裡的一位。',
    '可8:29 又問他們說：你們說我是誰﹖彼得回答說：你是基督。',
    '可8:30 耶穌就禁戒他們，不要告訴人。',
    '可8:31 從此，他教訓他們說：人子必須受許多的苦，被長老、祭司長，和文士棄絕，並且被殺，過三天復活。',
    '可8:32 耶穌明明的說這話，彼得就拉著他，勸他。',
    '可8:33 耶穌轉過來，看著門徒，就責備彼得說：撒但，退我後邊去吧！因為你不體貼神的意思，只體貼人的意思。',
    '可8:34 於是叫眾人和門徒來，對他們說：若有人要跟從我，就當捨己，背起他的十字架來跟從我。',
    '可8:35 因為，凡要救自己生命（或作：靈魂；下同）的，必喪掉生命；凡為我和福音喪掉生命的，必救了生命。',
    '可8:36 人就是賺得全世界，賠上自己的生命，有什麼益處呢﹖',
    '可8:37 人還能拿什麼換生命呢﹖',
    '可8:38 凡在這淫亂罪惡的世代，把我和我的道當作可恥的，人子在他父的榮耀裡，同聖天使降臨的時候，也要把那人當作可恥的。',
    '可9:1 耶穌又對他們說：我實在告訴你們，站在這裡的，有人在沒嘗死味以前，必要看見神的國大有能力臨到。',
    '可9:2 過了六天，耶穌帶著彼得、雅各、約翰暗暗的上了高山，就在他們面前變了形像，',
    '可9:3 衣服放光，極其潔白，地上漂布的，沒有一個能漂得那樣白。',
    '可9:4 忽然，有以利亞同摩西向他們顯現，並且和耶穌說話。',
    '可9:5 彼得對耶穌說：拉比（就是夫子），我們在這裡真好！可以搭三座棚，一座為你，一座為摩西，一座為以利亞。',
    '可9:6 彼得不知道說什麼才好，因為他們甚是懼怕。',
    '可9:7 有一朵雲彩來遮蓋他們；也有聲音從雲彩裡出來，說：這是我的愛子，你們要聽他。',
    '可9:8 門徒忽然周圍一看，不再見一人，只見耶穌同他們在那裡。',
    '可9:9 下山的時候，耶穌囑咐他們說：人子還沒有從死裡復活，你們不要將所看見的告訴人。',
    '可9:10 門徒將這話存記在心，彼此議論從死裡復活是什麼意思。',
    '可9:11 他們就問耶穌說：文士為什麼說以利亞必須先來﹖',
    '可9:12 耶穌說：以利亞固然先來復興萬事；經上不是指著人子說，他要受許多的苦被人輕慢呢﹖',
    '可9:13 我告訴你們，以利亞已經來了，他們也任意待他，正如經上所指著他的話。',
    '可9:14 耶穌到了門徒那裡，看見有許多人圍著他們，又有文士和他們辯論。',
    '可9:15 眾人一見耶穌，都甚希奇，就跑上去問他的安。',
    '可9:16 耶穌問他們說：你們和他們辯論的是什麼﹖',
    '可9:17 眾人中間有一個人回答說：夫子，我帶了我的兒子到你這裡來，他被啞巴鬼附著。',
    '可9:18 無論在哪裡，鬼捉弄他，把他摔倒，他就口中流沫，咬牙切齒，身體枯乾。我請過你的門徒把鬼趕出去，他們卻是不能。',
    '可9:19 耶穌說：噯！不信的世代啊，我在你們這裡要到幾時呢﹖我忍耐你們要到幾時呢﹖把他帶到我這裡來吧。',
    '可9:20 他們就帶了他來。他一見耶穌，鬼便叫他重重地抽瘋，倒在地上，翻來覆去，口中流沫。',
    '可9:21 耶穌問他父親說：他得這病有多少日子呢﹖回答說：從小的時候。',
    '可9:22 鬼屢次把他扔在火裡、水裡，要滅他。你若能做什麼，求你憐憫我們，幫助我們。',
    '可9:23 耶穌對他說：你若能信，在信的人，凡事都能。',
    '可9:24 孩子的父親立時喊著說（有古卷：立時流淚地喊著說）：我信！但我信不足，求主幫助。',
    '可9:25 耶穌看見眾人都跑上來，就斥責那污鬼說：你這聾啞的鬼，我吩咐你從他裡頭出來，再不要進去！',
    '可9:26 那鬼喊叫，使孩子大大的抽了一陣瘋，就出來了。孩子好像死了一般。以致眾人多半說：他是死了。',
    '可9:27 但耶穌拉著他的手，扶他起來，他就站起來了。',
    '可9:28 耶穌進了屋子，門徒就暗暗的問他說：我們為什麼不能趕出他去呢﹖',
    '可9:29 耶穌說：非用禱告（有古卷在此有：禁食二字），這一類的鬼總不能出來（或作：不能趕他出來）。',
    '可9:30 他們離開那地方，經過加利利；耶穌不願意人知道。',
    '可9:31 於是教訓門徒，說：人子將要被交在人手裡，他們要殺害他；被殺以後，過三天他要復活。',
    '可9:32 門徒卻不明白這話，又不敢問他。',
    '可9:33 他們來到迦百農，耶穌在屋裡問門徒說：你們在路上議論的是什麼﹖',
    '可9:34 門徒不作聲，因為他們在路上彼此爭論誰為大。',
    '可9:35 耶穌坐下，叫十二個門徒來，說：若有人願意作首先的，他必作眾人末後的，作眾人的用人。',
    '可9:36 於是領過一個小孩子來，叫他站在門徒中間，又抱起他來，對他們說：',
    '可9:37 凡為我名接待一個像這小孩子的，就是接待我；凡接待我的，不是接待我，乃是接待那差我來的。',
    '可9:38 約翰對耶穌說：夫子，我們看見一個人奉你的名趕鬼，我們就禁止他，因為他不跟從我們。',
    '可9:39 耶穌說：不要禁止他；因為沒有人奉我名行異能，反倒輕易毀謗我。',
    '可9:40 不敵擋我們的，就是幫助我們的。',
    '可9:41 凡因你們是屬基督，給你們一杯水喝的，我實在告訴你們，他不能不得賞賜。',
    '可9:42 凡使這信我的一個小子跌倒的，倒不如把大磨石拴在這人的頸項上，扔在海裡。',
    '可9:43 倘若你一隻手叫你跌倒，就把他砍下來；',
    '可9:44 你缺了肢體進入永生，強如有兩隻手落到地獄，入那不滅的火裡去。',
    '可9:45 倘若你一隻腳叫你跌倒，就把他砍下來；',
    '可9:46 你瘸腿進入永生，強如有兩隻腳被丟在地獄裡。',
    '可9:47 倘若你一隻眼叫你跌倒，就去掉他；你只有一隻眼進入神的國，強如有兩隻眼被丟在地獄裡。',
    '可9:48 在那裡，蟲是不死的，火是不滅的。',
    '可9:49 因為必用火當鹽醃各人。（有古卷在此有：凡祭物必用鹽醃。）',
    '可9:50 鹽本是好的，若失了味，可用什麼叫他再鹹呢﹖你們裡頭應當有鹽，彼此和睦。',
    '可10:1 耶穌從那裡起身，來到猶太的境界並約但河外。眾人又聚集到他那裡，他又照常教訓他們。',
    '可10:2 有法利賽人來問他說：人休妻可以不可以﹖意思要試探他。',
    '可10:3 耶穌回答說：摩西吩咐你們的是什麼﹖',
    '可10:4 他們說：摩西許人寫了休書便可以休妻。',
    '可10:5 耶穌說：摩西因為你們的心硬，所以寫這條例給你們；',
    '可10:6 但從起初創造的時候，神造人是造男造女。',
    '可10:7 因此，人要離開父母，與妻子連合，二人成為一體。',
    '可10:8 既然如此，夫妻不再是兩個人，乃是一體的了。',
    '可10:9 所以神配合的，人不可分開。',
    '可10:10 到了屋裡，門徒就問他這事。',
    '可10:11 耶穌對他們說：凡休妻另娶的，就是犯姦淫，辜負他的妻子；',
    '可10:12 妻子若離棄丈夫另嫁，也是犯姦淫了。',
    '可10:13 有人帶著小孩子來見耶穌，要耶穌摸他們，門徒便責備那些人。',
    '可10:14 耶穌看見就惱怒，對門徒說：讓小孩子到我這裡來，不要禁止他們；因為在神國的，正是這樣的人。',
    '可10:15 我實在告訴你們，凡要承受神國的，若不像小孩子，斷不能進去。',
    '可10:16 於是抱著小孩子，給他們按手，為他們祝福。',
    '可10:17 耶穌出來行路的時候，有一個人跑來，跪在他面前，問他說：良善的夫子，我當做什麼事才可以承受永生﹖',
    '可10:18 耶穌對他說：你為什麼稱我是良善的﹖除了神一位之外，再沒有良善的。',
    '可10:19 誡命你是曉得的：不可殺人；不可姦淫；不可偷盜；不可作假見證；不可虧負人；當孝敬父母。',
    '可10:20 他對耶穌說：夫子，這一切我從小都遵守了。',
    '可10:21 耶穌看著他，就愛他，對他說：你還缺少一件：去變賣你所有的，分給窮人，就必有財寶在天上；你還要來跟從我。',
    '可10:22 他聽見這話，臉上就變了色，憂憂愁愁的走了，因為他的產業很多。',
    '可10:23 耶穌周圍一看，對門徒說：有錢財的人進神的國是何等的難哪！',
    '可10:24 門徒希奇他的話。耶穌又對他們說：小子，倚靠錢財的人進神的國是何等的難哪！',
    '可10:25 駱駝穿過針的眼，比財主進神的國還容易呢。',
    '可10:26 門徒就分外希奇，對他說：這樣誰能得救呢﹖',
    '可10:27 耶穌看著他們，說：在人是不能，在神卻不然，因為神凡事都能。',
    '可10:28 彼得就對他說：看哪，我們已經撇下所有的跟從你了。',
    '可10:29 耶穌說：我實在告訴你們，人為我和福音撇下房屋，或是弟兄、姊妹、父母、兒女、田地，',
    '可10:30 沒有不在今世得百倍的，就是房屋、弟兄、姊妹、母親、兒女、田地，並且要受逼迫，在來世必得永生。',
    '可10:31 然而，有許多在前的，將要在後，在後的，將要在前。',
    '可10:32 他們行路上耶路撒冷去。耶穌在前頭走，門徒就希奇，跟從的人也害怕。耶穌又叫過十二個門徒來，把自己將要遭遇的事告訴他們說：',
    '可10:33 看哪，我們上耶路撒冷去，人子將要被交給祭司長和文士，他們要定他死罪，交給外邦人。',
    '可10:34 他們要戲弄他，吐唾沫在他臉上，鞭打他，殺害他。過了三天，他要復活。',
    '可10:35 西庇太的兒子雅各、約翰進前來，對耶穌說：夫子，我們無論求你什麼，願你給我們做。',
    '可10:36 耶穌說：要我給你們做什麼﹖',
    '可10:37 他們說：賜我們在你的榮耀裡，一個坐在你右邊，一個坐在你左邊。',
    '可10:38 耶穌說：你們不知道所求的是什麼，我所喝的杯，你們能喝嗎﹖我所受的洗，你們能受嗎﹖',
    '可10:39 他們說：我們能。耶穌說：我所喝的杯，你們也要喝；我所受的洗，你們也要受；',
    '可10:40 只是坐在我的左右，不是我可以賜的，乃是為誰預備的，就賜給誰。',
    '可10:41 那十個門徒聽見，就惱怒雅各、約翰。',
    '可10:42 耶穌叫他們來，對他們說：你們知道，外邦人有尊為君王的，治理他們，有大臣操權管束他們。',
    '可10:43 只是在你們中間，不是這樣。你們中間，誰願為大，就必作你們的用人；',
    '可10:44 在你們中間，誰願為首，就必作眾人的僕人。',
    '可10:45 因為人子來，並不是要受人的服事，乃是要服事人，並且要捨命作多人的贖價。',
    '可10:46 到了耶利哥；耶穌同門徒並許多人出耶利哥的時候，有一個討飯的瞎子，是底買的兒子巴底買，坐在路旁。',
    '可10:47 他聽見是拿撒勒的耶穌，就喊著說：大衛的子孫耶穌啊！可憐我吧！',
    '可10:48 有許多人責備他，不許他作聲。他卻越發大聲喊著說：大衛的子孫哪，可憐我吧！',
    '可10:49 耶穌就站住，說：叫過他來。他們就叫那瞎子，對他說：放心，起來！他叫你啦。',
    '可10:50 瞎子就丟下衣服，跳起來，走到耶穌那裡。',
    '可10:51 耶穌說：要我為你做什麼﹖瞎子說：拉波尼（就是夫子），我要能看見。',
    '可10:52 耶穌說：你去吧！你的信救了你了。瞎子立刻看見了，就在路上跟隨耶穌。',
    '可11:1 耶穌和門徒將近耶路撒冷，到了伯法其和伯大尼，在橄欖山那裡；耶穌就打發兩個門徒，',
    '可11:2 對他們說：你們往對面村子裡去，一進去的時候，必看見一匹驢駒拴在那裡，是從來沒有人騎過的，可以解開，牽來。',
    '可11:3 若有人對你們說：為什麼做這事﹖你們就說：主要用他。那人必立時讓你們牽來。',
    '可11:4 他們去了，便看見一匹驢駒拴在門外街道上，就把他解開。',
    '可11:5 在那裡站著的人，有幾個說：你們解驢駒做什麼﹖',
    '可11:6 門徒照著耶穌所說的回答，那些人就任憑他們牽去了。',
    '可11:7 他們把驢駒牽到耶穌那裡，把自己的衣服搭在上面，耶穌就騎上。',
    '可11:8 有許多人把衣服鋪在路上，也有人把田間的樹枝砍下來，鋪在路上。',
    '可11:9 前行後隨的人都喊著說：和散那（和散那：原有求救的意思，在此乃是稱頌的話）！奉主名來的是應當稱頌的！',
    '可11:10 那將要來的我祖大衛之國是應當稱頌的！高高在上和散那！',
    '可11:11 耶穌進了耶路撒冷，入了聖殿，周圍看了各樣物件。天色已晚，就和十二個門徒出城，往伯大尼去了。',
    '可11:12 第二天，他們從伯大尼出來，耶穌餓了。',
    '可11:13 遠遠的看見一棵無花果樹，樹上有葉子，就往那裡去，或者在樹上可以找著什麼。到了樹下，竟找不著什麼，不過有葉子，因為不是收無花果的時候。',
    '可11:14 耶穌就對樹說：從今以後，永沒有人吃你的果子。他的門徒也聽見了。',
    '可11:15 他們來到耶路撒冷。耶穌進入聖殿，趕出殿裡做買賣的人，推倒兌換銀錢之人的桌子，和賣鴿子之人的凳子；',
    '可11:16 也不許人拿著器具從殿裡經過；',
    '可11:17 便教訓他們說：經上不是記著說：我的殿必稱為萬國禱告的殿嗎﹖你們倒使他成為賊窩了。',
    '可11:18 祭司長和文士聽見這話，就想法子要除滅耶穌，卻又怕他，因為眾人都希奇他的教訓。',
    '可11:19 每天晚上，耶穌出城去。',
    '可11:20 早晨，他們從那裡經過，看見無花果樹連根都枯乾了。',
    '可11:21 彼得想起耶穌的話來，就對他說：拉比，請看！你所咒詛的無花果樹，已經枯乾了。',
    '可11:22 耶穌回答說：你們當信服神。',
    '可11:23 我實在告訴你們，無論何人對這座山說：你挪開此地，投在海裡！他若心裡不疑惑，只信他所說的必成，就必給他成了。',
    '可11:24 所以我告訴你們，凡你們禱告祈求的，無論是什麼，只要信是得著的，就必得著。',
    '可11:25 你們站著禱告的時候，若想起有人得罪你們，就當饒恕他，好叫你們在天上的父也饒恕你們的過犯。',
    '可11:26 你們若不饒恕人，你們在天上的父也不饒恕你們的過犯。（有古卷無此節）',
    '可11:27 他們又來到耶路撒冷。耶穌在殿裡行走的時候，祭司長和文士並長老進前來，',
    '可11:28 問他說：你仗著什麼權柄做這些事﹖給你這權柄的是誰呢﹖',
    '可11:29 耶穌對他們說：我要問你們一句話，你們回答我，我就告訴你們我仗著什麼權柄做這些事。',
    '可11:30 約翰的洗禮是從天上來的﹖是從人間來的呢﹖你們可以回答我。',
    '可11:31 他們彼此商議說：我們若說從天上來，他必說：這樣，你們為什麼不信他呢﹖',
    '可11:32 若說從人間來，卻又怕百姓，因為眾人真以約翰為先知。',
    '可11:33 於是回答耶穌說：我們不知道。耶穌說：我也不告訴你們我仗著什麼權柄做這些事。',
    '可12:1 耶穌就用比喻對他們說：有人栽了一個葡萄園，周圍圈上籬笆，挖了一個壓酒池，蓋了一座樓，租給園戶，就往外國去了。',
    '可12:2 到了時候，打發一個僕人到園戶那裡，要從園戶收葡萄園的果子。',
    '可12:3 園戶拿住他，打了他，叫他空手回去。',
    '可12:4 再打發一個僕人到他們那裡。他們打傷他的頭，並且凌辱他。',
    '可12:5 又打發一個僕人去，他們就殺了他。後又打發好些僕人去，有被他們打的，有被他們殺的。',
    '可12:6 園主還有一位是他的愛子，末後又打發他去，意思說：他們必尊敬我的兒子。',
    '可12:7 不料，那些園戶彼此說：這是承受產業的。來吧，我們殺他，產業就歸我們了！',
    '可12:8 於是拿住他，殺了他，把他丟在園外。',
    '可12:9 這樣，葡萄園的主人要怎麼辦呢﹖他要來除滅那些園戶，將葡萄園轉給別人。',
    '可12:10 經上寫著說：匠人所棄的石頭，已作了房角的頭塊石頭。',
    '可12:11 這是主所做的，在我們眼中看為希奇。這經你們沒有念過嗎﹖',
    '可12:12 他們看出這比喻是指著他們說的，就想要捉拿他，只是懼怕百姓，於是離開他走了。',
    '可12:13 後來，他們打發幾個法利賽人和幾個希律黨的人到耶穌那裡，要就著他的話陷害他。',
    '可12:14 他們來了，就對他說：夫子，我們知道你是誠實的，什麼人你都不徇情面；因為你不看人的外貌，乃是誠誠實實傳神的道。納稅給該撒可以不可以﹖',
    '可12:15 我們該納不該納﹖耶穌知道他們的假意，就對他們說：你們為什麼試探我﹖拿一個銀錢來給我看！',
    '可12:16 他們就拿了來。耶穌說：這像和這號是誰的﹖他們說：是該撒的。',
    '可12:17 耶穌說：該撒的物當歸給該撒，神的物當歸給神。他們就很希奇他。',
    '可12:18 撒都該人常說沒有復活的事。他們來問耶穌說：',
    '可12:19 夫子，摩西為我們寫著說：人若死了，撇下妻子，沒有孩子，他兄弟當娶他的妻，為哥哥生子立後。',
    '可12:20 有弟兄七人，第一個娶了妻，死了，沒有留下孩子。',
    '可12:21 第二個娶了他，也死了，沒有留下孩子。第三個也是這樣。',
    '可12:22 那七個人都沒有留下孩子；末了，那婦人也死了。',
    '可12:23 當復活的時候，他是哪一個的妻子呢﹖因為他們七個人都娶過他。',
    '可12:24 耶穌說：你們所以錯了，豈不是因為不明白聖經，不曉得神的大能嗎﹖',
    '可12:25 人從死裡復活，也不娶也不嫁，乃像天上的使者一樣。',
    '可12:26 論到死人復活，你們沒有念過摩西的書荊棘篇上所載的嗎﹖神對摩西說：我是亞伯拉罕的神，以撒的神，雅各的神。',
    '可12:27 神不是死人的神，乃是活人的神。你們是大錯了。',
    '可12:28 有一個文士來，聽見他們辯論，曉得耶穌回答的好，就問他說：誡命中哪是第一要緊的呢﹖',
    '可12:29 耶穌回答說：第一要緊的就是說：以色列啊，你要聽，主─我們神是獨一的主。',
    '可12:30 你要盡心、盡性、盡意、盡力愛主─你的神。',
    '可12:31 其次就是說：要愛人如己。再沒有比這兩條誡命更大的了。',
    '可12:32 那文士對耶穌說：夫子說，神是一位，實在不錯；除了他以外，再沒有別的神；',
    '可12:33 並且盡心、盡智、盡力愛他，又愛人如己，就比一切燔祭和各樣祭祀好的多。',
    '可12:34 耶穌見他回答的有智慧，就對他說：你離神的國不遠了。從此以後，沒有人敢再問他什麼。',
    '可12:35 耶穌在殿裡教訓人，就問他們說：文士怎麼說基督是大衛的子孫呢﹖',
    '可12:36 大衛被聖靈感動，說：主對我主說，你坐在我的右邊，等我使你仇敵作你的腳凳。',
    '可12:37 大衛既自己稱他為主，他怎麼又是大衛的子孫呢﹖眾人都喜歡聽他。',
    '可12:38 耶穌在教訓之間，說：你們要防備文士；他們好穿長衣遊行，喜愛人在街市上問他們的安，',
    '可12:39 又喜愛會堂裡的高位，筵席上的首座。',
    '可12:40 他們侵吞寡婦的家產，假意做很長的禱告。這些人要受更重的刑罰！',
    '可12:41 耶穌對銀庫坐著，看眾人怎樣投錢入庫。有好些財主往裡投了若干的錢。',
    '可12:42 有一個窮寡婦來，往裡投了兩個小錢，就是一個大錢。',
    '可12:43 耶穌叫門徒來，說：我實在告訴你們，這窮寡婦投入庫裡的，比眾人所投的更多。',
    '可12:44 因為，他們都是自己有餘，拿出來投在裡頭；但這寡婦是自己不足，把他一切養生的都投上了。',
    '可13:1 耶穌從殿裡出來的時候，有一個門徒對他說：夫子，請看，這是何等的石頭！何等的殿宇！',
    '可13:2 耶穌對他說：你看見這大殿宇嗎﹖將來在這裡沒有一塊石頭留在石頭上，不被拆毀了。',
    '可13:3 耶穌在橄欖山上對聖殿而坐，彼得、雅各、約翰，和安得烈暗暗的問他說：',
    '可13:4 請告訴我們，什麼時候有這些事呢﹖這一切事將成的時候有什麼預兆呢﹖',
    '可13:5 耶穌說：你們要謹慎，免得有人迷惑你們。',
    '可13:6 將來有好些人冒我的名來，說：我是基督，並且要迷惑許多人。',
    '可13:7 你們聽見打仗和打仗的風聲，不要驚慌。這些事是必須有的，只是末期還沒有到。',
    '可13:8 民要攻打民，國要攻打國；多處必有地震、饑荒。這都是災難（災難：原文是生產之難）的起頭。',
    '可13:9 但你們要謹慎；因為人要把你們交給公會，並且你們在會堂裡要受鞭打，又為我的緣故站在諸侯與君王面前，對他們作見證。',
    '可13:10 然而，福音必須先傳給萬民。',
    '可13:11 人把你們拉去交官的時候，不要預先思慮說什麼；到那時候，賜給你們什麼話，你們就說什麼；因為說話的不是你們，乃是聖靈。',
    '可13:12 弟兄要把弟兄，父親要把兒子，送到死地；兒女要起來與父母為敵，害死他們；',
    '可13:13 並且你們要為我的名被眾人恨惡。惟有忍耐到底的，必然得救。',
    '可13:14 你們看見那行毀壞可憎的，站在不當站的地方（讀這經的人須要會意）。那時，在猶太的，應當逃到山上；',
    '可13:15 在房上的，不要下來，也不要進去拿家裡的東西；',
    '可13:16 在田裡的，也不要回去取衣裳。',
    '可13:17 當那些日子，懷孕的和奶孩子的有禍了！',
    '可13:18 你們應當祈求，叫這些事不在冬天臨到。',
    '可13:19 因為在那些日子必有災難，自從神創造萬物直到如今，並沒有這樣的災難，後來也必沒有。',
    '可13:20 若不是主減少那日子，凡有血氣的，總沒有一個得救的；只是為主的選民，他將那日子減少了。',
    '可13:21 那時若有人對你們說：看哪，基督在這裡，或說：基督在那裡，你們不要信！',
    '可13:22 因為假基督、假先知將要起來，顯神蹟奇事，倘若能行，就把選民迷惑了。',
    '可13:23 你們要謹慎。看哪，凡事我都預先告訴你們了。',
    '可13:24 在那些日子，那災難以後，日頭要變黑了，月亮也不放光，',
    '可13:25 眾星要從天上墜落，天勢都要震動。',
    '可13:26 那時，他們（馬太二十四章三十節是地上的萬族）要看見人子有大能力、大榮耀，駕雲降臨。',
    '可13:27 他要差遣天使，把他的選民，從四方（方：原文是風），從地極直到天邊，都招聚了來。',
    '可13:28 你們可以從無花果樹學個比方：當樹枝發嫩長葉的時候，你們就知道夏天近了。',
    '可13:29 這樣，你們幾時看見這些事成就，也該知道人子（人子：或作神的國）近了，正在門口了。',
    '可13:30 我實在告訴你們，這世代還沒有過去，這些事都要成就。',
    '可13:31 天地要廢去，我的話卻不能廢去。',
    '可13:32 但那日子，那時辰，沒有人知道，連天上的使者也不知道，子也不知道，惟有父知道。',
    '可13:33 你們要謹慎，警醒祈禱，因為你們不曉得那日期幾時來到。',
    '可13:34 這事正如一個人離開本家，寄居外邦，把權柄交給僕人，分派各人當做的工，又吩咐看門的警醒。',
    '可13:35 所以，你們要警醒；因為你們不知道家主什麼時候來，或晚上，或半夜，或雞叫，或早晨；',
    '可13:36 恐怕他忽然來到，看見你們睡著了。',
    '可13:37 我對你們所說的話，也是對眾人說：要警醒！',
    '可14:1 過兩天是逾越節，又是除酵節，祭司長和文士想法子怎麼用詭計捉拿耶穌，殺他。',
    '可14:2 只是說：當節的日子不可，恐怕百姓生亂。',
    '可14:3 耶穌在伯大尼長大痲瘋的西門家裡坐席的時候，有一個女人拿著一玉瓶至貴的真哪噠香膏來，打破玉瓶，把膏澆在耶穌的頭上。',
    '可14:4 有幾個人心中很不喜悅，說：何用這樣枉費香膏呢﹖',
    '可14:5 這香膏可以賣三十多兩銀子賙濟窮人。他們就向那女人生氣。',
    '可14:6 耶穌說：由他吧！為什麼難為他呢﹖他在我身上做的是一件美事。',
    '可14:7 因為常有窮人和你們同在，要向他們行善隨時都可以；只是你們不常有我。',
    '可14:8 他所做的，是盡他所能的；他是為我安葬的事把香膏預先澆在我身上。',
    '可14:9 我實在告訴你們，普天之下，無論在什麼地方傳這福音，也要述說這女人所做的，以為記念。',
    '可14:10 十二門徒之中，有一個加略人猶大去見祭司長，要把耶穌交給他們。',
    '可14:11 他們聽見就歡喜，又應許給他銀子；他就尋思如何得便把耶穌交給他們。',
    '可14:12 除酵節的第一天，就是宰逾越羊羔的那一天，門徒對耶穌說：你吃逾越節的筵席要我們往哪裡去預備呢﹖',
    '可14:13 耶穌就打發兩個門徒，對他們說：你們進城去，必有人拿著一瓶水迎面而來，你們就跟著他。',
    '可14:14 他進哪家去，你們就對那家的主人說：夫子說：客房在哪裡﹖我與門徒好在那裡吃逾越節的筵席。',
    '可14:15 他必指給你們擺設整齊的一間大樓，你們就在那裡為我們預備。',
    '可14:16 門徒出去，進了城，所遇見的正如耶穌所說的。他們就預備了逾越節的筵席。',
    '可14:17 到了晚上，耶穌和十二個門徒都來了。',
    '可14:18 他們坐席正吃的時候，耶穌說：我實在告訴你們，你們中間有一個與我同吃的人要賣我了。',
    '可14:19 他們就憂愁起來，一個一個的問他說：是我嗎﹖',
    '可14:20 耶穌對他們說：是十二個門徒中同我蘸手在盤子裡的那個人。',
    '可14:21 人子必要去世，正如經上指著他所寫的；但賣人子的人有禍了！那人不生在世上倒好。',
    '可14:22 他們吃的時候，耶穌拿起餅來，祝了福，就擘開，遞給他們，說：你們拿著吃，這是我的身體；',
    '可14:23 又拿起杯來，祝謝了，遞給他們；他們都喝了。',
    '可14:24 耶穌說：這是我立約的血，為多人流出來的。',
    '可14:25 我實在告訴你們，我不再喝這葡萄汁，直到我在神的國裡喝新的那日子。',
    '可14:26 他們唱了詩，就出來，往橄欖山去。',
    '可14:27 耶穌對他們說：你們都要跌倒了，因為經上記著說：我要擊打牧人，羊就分散了。',
    '可14:28 但我復活以後，要在你們以先往加利利去。',
    '可14:29 彼得說：眾人雖然跌倒，我總不能。',
    '可14:30 耶穌對他說：我實在告訴你，就在今天夜裡，雞叫兩遍以先，你要三次不認我。',
    '可14:31 彼得卻極力的說：我就是必須和你同死，也總不能不認你。眾門徒都是這樣說。',
    '可14:32 他們來到一個地方，名叫客西馬尼。耶穌對門徒說：你們坐在這裡，等我禱告。',
    '可14:33 於是帶著彼得、雅各、約翰同去，就驚恐起來，極其難過，',
    '可14:34 對他們說：我心裡甚是憂傷，幾乎要死；你們在這裡等候，警醒。',
    '可14:35 他就稍往前走，俯伏在地，禱告說：倘若可行，便叫那時候過去。',
    '可14:36 他說：阿爸！父啊！在你凡事都能；求你將這杯撤去。然而，不要從我的意思，只要從你的意思。',
    '可14:37 耶穌回來，見他們睡著了，就對彼得說：西門，你睡覺嗎﹖不能警醒片時嗎﹖',
    '可14:38 總要警醒禱告，免得入了迷惑。你們心靈固然願意，肉體卻軟弱了。',
    '可14:39 耶穌又去禱告，說的話還是與先前一樣，',
    '可14:40 又來見他們睡著了，因為他們的眼睛甚是困倦；他們也不知道怎麼回答。',
    '可14:41 第三次來，對他們說：現在你們仍然睡覺安歇吧（或作嗎﹖）！夠了，時候到了。看哪，人子被賣在罪人手裡了。',
    '可14:42 起來！我們走吧。看哪，那賣我的人近了。',
    '可14:43 說話之間，忽然那十二個門徒裡的猶大來了，並有許多人帶著刀棒，從祭司長和文士並長老那裡與他同來。',
    '可14:44 賣耶穌的人曾給他們一個暗號，說：我與誰親嘴，誰就是他。你們把他拿住，牢牢靠靠的帶去。',
    '可14:45 猶大來了，隨即到耶穌跟前，說：拉比，便與他親嘴。',
    '可14:46 他們就下手拿住他。',
    '可14:47 旁邊站著的人，有一個拔出刀來，將大祭司的僕人砍了一刀，削掉了他一個耳朵。',
    '可14:48 耶穌對他們說：你們帶著刀棒出來拿我，如同拿強盜嗎﹖',
    '可14:49 我天天教訓人，同你們在殿裡，你們並沒有拿我。但這事成就，為要應驗經上的話。',
    '可14:50 門徒都離開他，逃走了。',
    '可14:51 有一個少年人，赤身披著一塊麻布，跟隨耶穌，眾人就捉拿他。',
    '可14:52 他卻丟了麻布，赤身逃走了。',
    '可14:53 他們把耶穌帶到大祭司那裡，又有眾祭司長和長老並文士都來和大祭司一同聚集。',
    '可14:54 彼得遠遠的跟著耶穌，一直進入大祭司的院裡，和差役一同坐在火光裡烤火。',
    '可14:55 祭司長和全公會尋找見證控告耶穌，要治死他，卻尋不著。',
    '可14:56 因為有好些人作假見證告他，只是他們的見證各不相合。',
    '可14:57 又有幾個人站起來作假見證告他，說：',
    '可14:58 我們聽見他說：我要拆毀這人手所造的殿，三日內就另造一座不是人手所造的。',
    '可14:59 他們就是這麼作見證，也是各不相合。',
    '可14:60 大祭司起來站在中間，問耶穌說：你什麼都不回答嗎﹖這些人作見證告你的是什麼呢﹖',
    '可14:61 耶穌卻不言語，一句也不回答。大祭司又問他說：你是那當稱頌者的兒子基督不是﹖',
    '可14:62 耶穌說：我是。你們必看見人子坐在那權能者的右邊，駕著天上的雲降臨。',
    '可14:63 大祭司就撕開衣服，說：我們何必再用見證人呢﹖',
    '可14:64 你們已經聽見他這僭妄的話了。你們的意見如何﹖他們都定他該死的罪。',
    '可14:65 就有人吐唾沫在他臉上，又蒙著他的臉，用拳頭打他，對他說：你說預言吧！差役接過他來，用手掌打他。',
    '可14:66 彼得在下邊院子裡；來了大祭司的一個使女，',
    '可14:67 見彼得烤火，就看著他，說：你素來也是同拿撒勒人耶穌一夥的。',
    '可14:68 彼得卻不承認，說：我不知道，也不明白你說的是什麼。於是出來，到了前院，雞就叫了。',
    '可14:69 那使女看見他，又對旁邊站著的人說：這也是他們一黨的。',
    '可14:70 彼得又不承認。過了不多的時候，旁邊站著的人又對彼得說：你真是他們一黨的！因為你是加利利人。',
    '可14:71 彼得就發咒起誓的說：我不認得你們說的這個人。',
    '可14:72 立時雞叫了第二遍。彼得想起耶穌對他所說的話：雞叫兩遍以先，你要三次不認我。思想起來，就哭了。',
    '可15:1 一到早晨，祭司長和長老、文士、全公會的人大家商議，就把耶穌捆綁，解去交給彼拉多。',
    '可15:2 彼拉多問他說：你是猶太人的王嗎﹖耶穌回答說：你說的是。',
    '可15:3 祭司長告他許多的事。',
    '可15:4 彼拉多又問他說：你看，他們告你這麼多的事，你什麼都不回答嗎﹖',
    '可15:5 耶穌仍不回答，以致彼拉多覺得希奇。',
    '可15:6 每逢這節期，巡撫照眾人所求的，釋放一個囚犯給他們。',
    '可15:7 有一個人名叫巴拉巴，和作亂的人一同捆綁。他們作亂的時候，曾殺過人。',
    '可15:8 眾人上去求巡撫，照常例給他們辦。',
    '可15:9 彼拉多說：你們要我釋放猶太人的王給你們嗎﹖',
    '可15:10 他原曉得，祭司長是因為嫉妒才把耶穌解了來。',
    '可15:11 只是祭司長挑唆眾人，寧可釋放巴拉巴給他們。',
    '可15:12 彼拉多又說：那麼樣，你們所稱為猶太人的王，我怎麼辦他呢﹖',
    '可15:13 他們又喊著說：把他釘十字架！',
    '可15:14 彼拉多說：為什麼呢﹖他做了什麼惡事呢﹖他們便極力的喊著說：把他釘十字架！',
    '可15:15 彼拉多要叫眾人喜悅，就釋放巴拉巴給他們，將耶穌鞭打了，交給人釘十字架。',
    '可15:16 兵丁把耶穌帶進衙門院裡，叫齊了全營的兵。',
    '可15:17 他們給他穿上紫袍，又用荊棘編做冠冕給他戴上，',
    '可15:18 就慶賀他說：恭喜，猶太人的王啊！',
    '可15:19 又拿一根葦子打他的頭，吐唾沫在他臉上，屈膝拜他。',
    '可15:20 戲弄完了，就給他脫了紫袍，仍穿上他自己的衣服，帶他出去，要釘十字架。',
    '可15:21 有一個古利奈人西門，就是亞力山大和魯孚的父親，從鄉下來，經過那地方，他們就勉強他同去，好背著耶穌的十字架。',
    '可15:22 他們帶耶穌到了各各他地方（各各他翻出來就是髑髏地），',
    '可15:23 拿沒藥調和的酒給耶穌，他卻不受。',
    '可15:24 於是將他釘在十字架上，拈鬮分他的衣服，看是誰得什麼。',
    '可15:25 釘他在十字架上是巳初的時候。',
    '可15:26 在上面有他的罪狀，寫的是：猶太人的王。',
    '可15:27 他們又把兩個強盜和他同釘十字架，一個在右邊，一個在左邊。（有古卷在此有：',
    '可15:28 這就應了經上的話說：他被列在罪犯之中。）',
    '可15:29 從那裡經過的人辱罵他，搖著頭說：咳！你這拆毀聖殿、三日又建造起來的，',
    '可15:30 可以救自己，從十字架上下來吧！',
    '可15:31 祭司長和文士也是這樣戲弄他，彼此說：他救了別人，不能救自己。',
    '可15:32 以色列的王基督，現在可以從十字架上下來，叫我們看見，就信了。那和他同釘的人也是譏誚他。',
    '可15:33 從午正到申初，遍地都黑暗了。',
    '可15:34 申初的時候，耶穌大聲喊著說：以羅伊！以羅伊！拉馬撒巴各大尼﹖翻出來就是：我的神！我的神！為什麼離棄我﹖',
    '可15:35 旁邊站著的人，有的聽見就說：看哪，他叫以利亞呢！',
    '可15:36 有一個人跑去，把海絨蘸滿了醋，綁在葦子上，送給他喝，說：且等著，看以利亞來不來把他取下。',
    '可15:37 耶穌大聲喊叫，氣就斷了。',
    '可15:38 殿裡的幔子從上到下裂為兩半。',
    '可15:39 對面站著的百夫長看見耶穌這樣喊叫（有古卷沒有喊叫二字）斷氣，就說：這人真是神的兒子！',
    '可15:40 還有些婦女遠遠的觀看；內中有抹大拉的馬利亞，又有小雅各和約西的母親馬利亞，並有撒羅米，',
    '可15:41 就是耶穌在加利利的時候，跟隨他、服事他的那些人，還有同耶穌上耶路撒冷的好些婦女在那裡觀看。',
    '可15:42 到了晚上，因為這是預備日，就是安息日的前一日，',
    '可15:43 有亞利馬太的約瑟前來，他是尊貴的議士，也是等候神國的。他放膽進去見彼拉多，求耶穌的身體；',
    '可15:44 彼拉多詫異耶穌已經死了，便叫百夫長來，問他耶穌死了久不久。',
    '可15:45 既從百夫長得知實情，就把耶穌的屍首賜給約瑟。',
    '可15:46 約瑟買了細麻布，把耶穌取下來，用細麻布裹好，安放在磐石中鑿出來的墳墓裡，又滾過一塊石頭來擋住墓門。',
    '可15:47 抹大拉的馬利亞和約西的母親馬利亞都看見安放他的地方。',
    '可16:1 過了安息日，抹大拉的馬利亞和雅各的母親馬利亞並撒羅米，買了香膏要去膏耶穌的身體。',
    '可16:2 七日的第一日清早，出太陽的時候，他們來到墳墓那裡，',
    '可16:3 彼此說：誰給我們把石頭從墓門滾開呢﹖',
    '可16:4 那石頭原來很大，他們擡頭一看，卻見石頭已經滾開了。',
    '可16:5 他們進了墳墓，看見一個少年人坐在右邊，穿著白袍，就甚驚恐。',
    '可16:6 那少年人對他們說：不要驚恐！你們尋找那釘十字架的拿撒勒人耶穌，他已經復活了，不在這裡。請看安放他的地方。',
    '可16:7 你們可以去告訴他的門徒和彼得，說：他在你們以先往加利利去。在那裡你們要見他，正如他從前所告訴你們的。',
    '可16:8 他們就出來，從墳墓那裡逃跑，又發抖又驚奇，什麼也不告訴人，因為他們害怕。',
    '可16:9 在七日的第一日清早，耶穌復活了，就先向抹大拉的馬利亞顯現。耶穌從他身上曾趕出七個鬼。',
    '可16:10 他去告訴那向來跟隨耶穌的人；那時他們正哀慟哭泣。',
    '可16:11 他們聽見耶穌活了，被馬利亞看見，卻是不信。',
    '可16:12 這事以後，門徒中間有兩個人往鄉下去。走路的時候，耶穌變了形像，向他們顯現。',
    '可16:13 他們就去告訴其餘的門徒；其餘的門徒也是不信。',
    '可16:14 後來，十一個門徒坐席的時候，耶穌向他們顯現，責備他們不信，心裡剛硬，因為他們不信那些在他復活以後看見他的人。',
    '可16:15 他又對他們說：你們往普天下去，傳福音給萬民（萬民：原文是凡受造的）聽。',
    '可16:16 信而受洗的，必然得救；不信的，必被定罪。',
    '可16:17 信的人必有神蹟隨著他們，就是奉我的名趕鬼；說新方言；',
    '可16:18 手能拿蛇；若喝了什麼毒物，也必不受害；手按病人，病人就必好了。',
    '可16:19 主耶穌和他們說完了話，後來被接到天上，坐在神的右邊。',
    '可16:20 門徒出去，到處宣傳福音。主和他們同工，用神蹟隨著，證實所傳的道。阿們！',
    '路1:1 提阿非羅大人哪，有好些人提筆作書，述說在我們中間所成就的事，是照傳道的人從起初親眼看見又傳給我們的。',
    '路1:2 併於上節。',
    '路1:3 這些事我既從起頭都詳細考察了，就定意要按著次序寫給你，',
    '路1:4 使你知道所學之道都是確實的。',
    '路1:5 當猶太王希律的時候，亞比雅班裡有一個祭司，名叫撒迦利亞；他妻子是亞倫的後人，名叫以利沙伯。',
    '路1:6 他們二人在神面前都是義人，遵行主的一切誡命禮儀，沒有可指摘的，',
    '路1:7 只是沒有孩子；因為以利沙伯不生育，兩個人又年紀老邁了。',
    '路1:8 撒迦利亞按班次在神面前供祭司的職分，',
    '路1:9 照祭司的規矩掣籤，得進主殿燒香。',
    '路1:10 燒香的時候，眾百姓在外面禱告。',
    '路1:11 有主的使者站在香壇的右邊，向他顯現。',
    '路1:12 撒迦利亞看見，就驚慌害怕。',
    '路1:13 天使對他說：撒迦利亞，不要害怕，因為你的祈禱已經被聽見了。你的妻子以利沙伯要給你生一個兒子，你要給他起名叫約翰。',
    '路1:14 你必歡喜快樂；有許多人因他出世，也必喜樂。',
    '路1:15 他在主面前將要為大，淡酒濃酒都不喝，從母腹裡就被聖靈充滿了。',
    '路1:16 他要使許多以色列人回轉，歸於主─他們的神。',
    '路1:17 他必有以利亞的心志能力，行在主的前面，叫為父的心轉向兒女，叫悖逆的人轉從義人的智慧，又為主預備合用的百姓。',
    '路1:18 撒迦利亞對天使說：我憑著什麼可知道這事呢﹖我已經老了，我的妻子也年紀老邁了。',
    '路1:19 天使回答說：我是站在神面前的加百列，奉差而來對你說話，將這好信息報給你。',
    '路1:20 到了時候，這話必然應驗；只因你不信，你必啞巴，不能說話，直到這事成就的日子。',
    '路1:21 百姓等候撒迦利亞，詫異他許久在殿裡。',
    '路1:22 及至他出來，不能和他們說話，他們就知道他在殿裡見了異象；因為他直向他們打手式，竟成了啞巴。',
    '路1:23 他供職的日子已滿，就回家去了。',
    '路1:24 這些日子以後，他的妻子以利沙伯懷了孕，就隱藏了五個月，',
    '路1:25 說：主在眷顧我的日子，這樣看待我，要把我在人間的羞恥除掉。',
    '路1:26 到了第六個月，天使加百列奉神的差遣往加利利的一座城去，這城名叫拿撒勒，',
    '路1:27 到一個童女那裡，是已經許配大衛家的一個人，名叫約瑟。童女的名字叫馬利亞；',
    '路1:28 天使進去，對他說：蒙大恩的女子，我問你安，主和你同在了！',
    '路1:29 馬利亞因這話就很驚慌，又反覆思想這樣問安是什麼意思。',
    '路1:30 天使對他說：馬利亞，不要怕！你在神面前已經蒙恩了。',
    '路1:31 你要懷孕生子，可以給他起名叫耶穌。',
    '路1:32 他要為大，稱為至高者的兒子；主神要把他祖大衛的位給他。',
    '路1:33 他要作雅各家的王，直到永遠；他的國也沒有窮盡。',
    '路1:34 馬利亞對天使說：我沒有出嫁，怎麼有這事呢﹖',
    '路1:35 天使回答說：聖靈要臨到你身上，至高者的能力要蔭庇你，因此所要生的聖者必稱為神的兒子（或作：所要生的，必稱為聖，稱為神的兒子）。',
    '路1:36 況且你的親戚以利沙伯，在年老的時候也懷了男胎，就是那素來稱為不生育的，現在有孕六個月了。',
    '路1:37 因為，出於神的話，沒有一句不帶能力的。',
    '路1:38 馬利亞說：我是主的使女，情願照你的話成就在我身上。天使就離開他去了。',
    '路1:39 那時候，馬利亞起身，急忙往山地裡去，來到猶大的一座城；',
    '路1:40 進了撒迦利亞的家，問以利沙伯安。',
    '路1:41 以利沙伯一聽馬利亞問安，所懷的胎就在腹裡跳動。以利沙伯且被聖靈充滿，',
    '路1:42 高聲喊著說：你在婦女中是有福的！你所懷的胎也是有福的！',
    '路1:43 我主的母到我這裡來，這是從哪裡得的呢﹖',
    '路1:44 因為你問安的聲音一入我耳，我腹裡的胎就歡喜跳動。',
    '路1:45 這相信的女子是有福的！因為主對他所說的話都要應驗。',
    '路1:46 馬利亞說：我心尊主為大；',
    '路1:47 我靈以神我的救主為樂；',
    '路1:48 因為他顧念他使女的卑微；從今以後，萬代要稱我有福。',
    '路1:49 那有權能的，為我成就了大事；他的名為聖。',
    '路1:50 他憐憫敬畏他的人，直到世世代代。',
    '路1:51 他用膀臂施展大能；那狂傲的人正心裡妄想就被他趕散了。',
    '路1:52 他叫有權柄的失位，叫卑賤的升高；',
    '路1:53 叫飢餓的得飽美食，叫富足的空手回去。',
    '路1:54 他扶助了他的僕人以色列，',
    '路1:55 為要記念亞伯拉罕和他的後裔，施憐憫直到永遠，正如從前對我們列祖所說的話。',
    '路1:56 馬利亞和以利沙伯同住，約有三個月，就回家去了。',
    '路1:57 以利沙伯的產期到了，就生了一個兒子。',
    '路1:58 鄰里親族聽見主向他大施憐憫，就和他一同歡樂。',
    '路1:59 到了第八日，他們來要給孩子行割禮，並要照他父親的名字叫他撒迦利亞。',
    '路1:60 他母親說：不可！要叫他約翰。',
    '路1:61 他們說：你親族中沒有叫這名字的。',
    '路1:62 他們就向他父親打手式，問他要叫這孩子什麼名字。',
    '路1:63 他要了一塊寫字的板，就寫上，說：他的名字是約翰。他們便都希奇。',
    '路1:64 撒迦利亞的口立時開了，舌頭也舒展了，就說出話來，稱頌神。',
    '路1:65 周圍居住的人都懼怕；這一切的事就傳遍了猶太的山地。',
    '路1:66 凡聽見的人都將這事放在心裡，說：這個孩子將來怎麼樣呢﹖因為有主與他同在。',
    '路1:67 他父親撒迦利亞被聖靈充滿了，就預言說：',
    '路1:68 主─以色列的神是應當稱頌的！因他眷顧他的百姓，為他們施行救贖，',
    '路1:69 在他僕人大衛家中，為我們興起了拯救的角，',
    '路1:70 正如主藉著從創世以來聖先知的口所說的話，',
    '路1:71 拯救我們脫離仇敵和一切恨我們之人的手，',
    '路1:72 向我們列祖施憐憫，記念他的聖約─',
    '路1:73 就是他對我們祖宗亞伯拉罕所起的誓─',
    '路1:74 叫我們既從仇敵手中被救出來，',
    '路1:75 就可以終身在他面前，坦然無懼的用聖潔、公義事奉他。',
    '路1:76 孩子啊！你要稱為至高者的先知；因為你要行在主的前面，預備他的道路，',
    '路1:77 叫他的百姓因罪得赦，就知道救恩。',
    '路1:78 因我們神憐憫的心腸，叫清晨的日光從高天臨到我們，',
    '路1:79 要照亮坐在黑暗中死蔭裡的人，把我們的腳引到平安的路上。',
    '路1:80 那孩子漸漸長大，心靈強健，住在曠野，直到他顯明在以色列人面前的日子。',
    '路2:1 當那些日子，該撒亞古士督有旨意下來，叫天下人民都報名上冊。',
    '路2:2 這是居里扭作敘利亞巡撫的時候，頭一次行報名上冊的事。',
    '路2:3 眾人各歸各城，報名上冊。',
    '路2:4 約瑟也從加利利的拿撒勒城上猶太去，到了大衛的城，名叫伯利恆，因他本是大衛一族一家的人，',
    '路2:5 要和他所聘之妻馬利亞一同報名上冊。那時馬利亞的身孕已經重了。',
    '路2:6 他們在那裡的時候，馬利亞的產期到了，',
    '路2:7 就生了頭胎的兒子，用布包起來，放在馬槽裡，因為客店裡沒有地方。',
    '路2:8 在伯利恆之野地裡有牧羊的人，夜間按著更次看守羊群。',
    '路2:9 有主的使者站在他們旁邊，主的榮光四面照著他們；牧羊的人就甚懼怕。',
    '路2:10 那天使對他們說：不要懼怕！我報給你們大喜的信息，是關乎萬民的；',
    '路2:11 因今天在大衛的城裡，為你們生了救主，就是主基督。',
    '路2:12 你們要看見一個嬰孩，包著布，臥在馬槽裡，那就是記號了。',
    '路2:13 忽然，有一大隊天兵同那天使讚美神說：',
    '路2:14 在至高之處榮耀歸與神！在地上平安歸與他所喜悅的人（有古卷作：喜悅歸與人）！',
    '路2:15 眾天使離開他們，升天去了。牧羊的人彼此說：我們往伯利恆去，看看所成的事，就是主所指示我們的。',
    '路2:16 他們急忙去了，就尋見馬利亞和約瑟，又有那嬰孩臥在馬槽裡；',
    '路2:17 既然看見，就把天使論這孩子的話傳開了。',
    '路2:18 凡聽見的，就詫異牧羊之人對他們所說的話。',
    '路2:19 馬利亞卻把這一切的事存在心裡，反覆思想。',
    '路2:20 牧羊的人回去了，因所聽見所看見的一切事，正如天使向他們所說的，就歸榮耀與神，讚美他。',
    '路2:21 滿了八天，就給孩子行割禮，與他起名叫耶穌；這就是沒有成胎以前，天使所起的名。',
    '路2:22 按摩西律法滿了潔淨的日子，他們帶著孩子上耶路撒冷去，要把他獻與主。',
    '路2:23 （正如主的律法上所記：凡頭生的男子必稱聖歸主；）',
    '路2:24 又要照主的律法上所說，或用一對斑鳩，或用兩隻雛鴿獻祭。',
    '路2:25 在耶路撒冷有一個人，名叫西面；這人又公義又虔誠，素常盼望以色列的安慰者來到，又有聖靈在他身上。',
    '路2:26 他得了聖靈的啟示，知道自己未死以前，必看見主所立的基督。',
    '路2:27 他受了聖靈的感動，進入聖殿，正遇見耶穌的父母抱著孩子進來，要照律法的規矩辦理。',
    '路2:28 西面就用手接過他來，稱頌神說：',
    '路2:29 主啊！如今可以照你的話，釋放僕人安然去世；',
    '路2:30 因為我的眼睛已經看見你的救恩─',
    '路2:31 就是你在萬民面前所預備的：',
    '路2:32 是照亮外邦人的光，又是你民以色列的榮耀。',
    '路2:33 孩子的父母因這論耶穌的話就希奇。',
    '路2:34 西面給他們祝福，又對孩子的母親馬利亞說：這孩子被立，是要叫以色列中許多人跌倒，許多人興起；又要作毀謗的話柄，叫許多人心裡的意念顯露出來；你自己的心也要被刀刺透。',
    '路2:35 併於上節。',
    '路2:36 又有女先知，名叫亞拿，是亞設支派法內力的女兒，年紀已經老邁，從作童女出嫁的時候，同丈夫住了七年就寡居了，',
    '路2:37 現在已經八十四歲（或作：就寡居了八十四年），並不離開聖殿，禁食祈求，晝夜事奉神。',
    '路2:38 正當那時，他進前來稱謝神，將孩子的事對一切盼望耶路撒冷得救贖的人講說。',
    '路2:39 約瑟和馬利亞照主的律法辦完了一切的事，就回加利利，到自己的城拿撒勒去了。',
    '路2:40 孩子漸漸長大，強健起來，充滿智慧，又有神的恩在他身上。',
    '路2:41 每年到逾越節，他父母就上耶路撒冷去。',
    '路2:42 當他十二歲的時候，他們按著節期的規矩上去。',
    '路2:43 守滿了節期，他們回去，孩童耶穌仍舊在耶路撒冷。他的父母並不知道，',
    '路2:44 以為他在同行的人中間，走了一天的路程，就在親族和熟識的人中找他，',
    '路2:45 既找不著，就回耶路撒冷去找他。',
    '路2:46 過了三天，就遇見他在殿裡，坐在教師中間，一面聽，一面問。',
    '路2:47 凡聽見他的，都希奇他的聰明和他的應對。',
    '路2:48 他父母看見就很希奇。他母親對他說：我兒！為什麼向我們這樣行呢﹖看哪！你父親和我傷心來找你！',
    '路2:49 耶穌說：為什麼找我呢﹖豈不知我應當以我父的事為念嗎（或作：豈不知我應當在我父的家裡嗎）﹖',
    '路2:50 他所說的這話，他們不明白。',
    '路2:51 他就同他們下去，回到拿撒勒，並且順從他們。他母親把這一切的事都存在心裡。',
    '路2:52 耶穌的智慧和身量（或作：年紀），並神和人喜愛他的心，都一齊增長。',
    '路3:1 該撒提庇留在位第十五年，本丟彼拉多作猶太巡撫，希律作加利利分封的王，他兄弟腓力作以土利亞和特拉可尼地方分封的王，呂撒聶作亞比利尼分封的王，',
    '路3:2 亞那和該亞法作大祭司。那時，撒迦利亞的兒子約翰在曠野裡，神的話臨到他。',
    '路3:3 他就來到約但河一帶地方，宣講悔改的洗禮，使罪得赦。',
    '路3:4 正如先知以賽亞書上所記的話，說：在曠野有人聲喊著說：預備主的道，修直他的路！',
    '路3:5 一切山窪都要填滿；大小山岡都要削平！彎彎曲曲的地方要改為正直；高高低低的道路要改為平坦！',
    '路3:6 凡有血氣的，都要見神的救恩！',
    '路3:7 約翰對那出來要受他洗的眾人說：毒蛇的種類！誰指示你們逃避將來的忿怒呢﹖',
    '路3:8 你們要結出果子來，與悔改的心相稱。不要自己心裡說：有亞伯拉罕為我們的祖宗。我告訴你們，神能從這些石頭中，給亞伯拉罕興起子孫來。',
    '路3:9 現在斧子已經放在樹根上，凡不結好果子的樹就砍下來，丟在火裡。',
    '路3:10 眾人問他說：這樣，我們當做什麼呢﹖',
    '路3:11 約翰回答說：有兩件衣裳的，就分給那沒有的；有食物的，也當這樣行。',
    '路3:12 又有稅吏來要受洗，問他說：夫子，我們當做什麼呢﹖',
    '路3:13 約翰說：除了例定的數目，不要多取。',
    '路3:14 又有兵丁問他說：我們當做什麼呢﹖約翰說：不要以強暴待人，也不要訛詐人，自己有錢糧就當知足。',
    '路3:15 百姓指望基督來的時候，人都心裡猜疑，或者約翰是基督。',
    '路3:16 約翰說：我是用水給你們施洗，但有一位能力比我更大的要來，我就是給他解鞋帶也不配。他要用聖靈與火給你們施洗。',
    '路3:17 他手裡拿著簸箕，要揚淨他的場，把麥子收在倉裡，把糠用不滅的火燒盡了。',
    '路3:18 約翰又用許多別的話勸百姓，向他們傳福音。',
    '路3:19 只是分封的王希律，因他兄弟之妻希羅底的緣故，並因他所行的一切惡事，受了約翰的責備；',
    '路3:20 又另外添了一件，就是把約翰收在監裡。',
    '路3:21 眾百姓都受了洗，耶穌也受了洗。正禱告的時候，天就開了，',
    '路3:22 聖靈降臨在他身上，形狀彷彿鴿子；又有聲音從天上來，說：你是我的愛子，我喜悅你。',
    '路3:23 耶穌開頭傳道，年紀約有三十歲。依人看來，他是約瑟的兒子；約瑟是希里的兒子；',
    '路3:24 希里是瑪塔的兒子；瑪塔是利未的兒子；利未是麥基的兒子；麥基是雅拿的兒子；雅拿是約瑟的兒子；',
    '路3:25 約瑟是瑪他提亞的兒子；瑪他提亞是亞摩斯的兒子；亞摩斯是拿鴻的兒子；拿鴻是以斯利的兒子；以斯利是拿該的兒子；',
    '路3:26 拿該是瑪押的兒子；瑪押是瑪他提亞的兒子；瑪他提亞是西美的兒子；西美是約瑟的兒子；約瑟是猶大的兒子；猶大是約亞拿的兒子；',
    '路3:27 約亞拿是利撒的兒子；利撒是所羅巴伯的兒子；所羅巴伯是撒拉鐵的兒子；撒拉鐵是尼利的兒子；尼利是麥基的兒子；',
    '路3:28 麥基是亞底的兒子；亞底是哥桑的兒子；哥桑是以摩當的兒子；以摩當是珥的兒子；珥是約細的兒子；',
    '路3:29 約細是以利以謝的兒子；以利以謝是約令的兒子；約令是瑪塔的兒子；瑪塔是利未的兒子；',
    '路3:30 利未是西緬的兒子；西緬是猶大的兒子；猶大是約瑟的兒子；約瑟是約南的兒子；約南是以利亞敬的兒子；',
    '路3:31 以利亞敬是米利亞的兒子；米利亞是買南的兒子；買南是瑪達他的兒子；瑪達他是拿單的兒子；拿單是大衛的兒子；',
    '路3:32 大衛是耶西的兒子；耶西是俄備得的兒子；俄備得是波阿斯的兒子；波阿斯是撒門的兒子；撒門是拿順的兒子；',
    '路3:33 拿順是亞米拿達的兒子；亞米拿達是亞蘭的兒子；亞蘭是希斯崙的兒子；希斯崙是法勒斯的兒子；法勒斯是猶大的兒子；',
    '路3:34 猶大是雅各的兒子；雅各是以撒的兒子；以撒是亞伯拉罕的兒子；亞伯拉罕是他拉的兒子；他拉是拿鶴的兒子；',
    '路3:35 拿鶴是西鹿的兒子；西鹿是拉吳的兒子；拉吳是法勒的兒子；法勒是希伯的兒子；希伯是沙拉的兒子；',
    '路3:36 沙拉是該南的兒子；該南是亞法撒的兒子；亞法撒是閃的兒子；閃是挪亞的兒子；挪亞是拉麥的兒子；',
    '路3:37 拉麥是瑪土撒拉的兒子；瑪土撒拉是以諾的兒子；以諾是雅列的兒子；雅列是瑪勒列的兒子；瑪勒列是該南的兒子；該南是以挪士的兒子；',
    '路3:38 以挪士是塞特的兒子；塞特是亞當的兒子；亞當是神的兒子。',
    '路4:1 耶穌被聖靈充滿，從約但河回來，聖靈將他引到曠野，四十天受魔鬼的試探。',
    '路4:2 那些日子沒有吃什麼；日子滿了，他就餓了。',
    '路4:3 魔鬼對他說：你若是神的兒子，可以吩咐這塊石頭變成食物。',
    '路4:4 耶穌回答說：經上記著說：人活著不是單靠食物，乃是靠神口裡所出的一切話。',
    '路4:5 魔鬼又領他上了高山，霎時間把天下的萬國都指給他看，',
    '路4:6 對他說：這一切權柄、榮華，我都要給你，因為這原是交付我的，我願意給誰就給誰。',
    '路4:7 你若在我面前下拜，這都要歸你。',
    '路4:8 耶穌說：經上記著說：當拜主─你的神，單要事奉他。',
    '路4:9 魔鬼又領他到耶路撒冷去，叫他站在殿頂（頂：原文是翅）上，對他說：你若是神的兒子，可以從這裡跳下去；',
    '路4:10 因為經上記著說：主要為你吩咐他的使者保護你；',
    '路4:11 他們要用手托著你，免得你的腳碰在石頭上。',
    '路4:12 耶穌對他說：經上說：不可試探主─你的神。',
    '路4:13 魔鬼用完了各樣的試探，就暫時離開耶穌。',
    '路4:14 耶穌滿有聖靈的能力，回到加利利；他的名聲就傳遍了四方。',
    '路4:15 他在各會堂裡教訓人，眾人都稱讚他。',
    '路4:16 耶穌來到拿撒勒，就是他長大的地方。在安息日，照他平常的規矩進了會堂，站起來要念聖經。',
    '路4:17 有人把先知以賽亞的書交給他，他就打開，找到一處寫著說：',
    '路4:18 主的靈在我身上，因為他用膏膏我，叫我傳福音給貧窮的人；差遣我報告：被擄的得釋放，瞎眼的得看見，叫那受壓制的得自由，',
    '路4:19 報告神悅納人的禧年。',
    '路4:20 於是把書捲起來，交還執事，就坐下。會堂裡的人都定睛看他。',
    '路4:21 耶穌對他們說：今天這經應驗在你們耳中了。',
    '路4:22 眾人都稱讚他，並希奇他口中所出的恩言；又說：這不是約瑟的兒子嗎﹖',
    '路4:23 耶穌對他們說：你們必引這俗語向我說：醫生，你醫治自己吧！我們聽見你在迦百農所行的事，也當行在你自己家鄉裡；',
    '路4:24 又說：我實在告訴你們，沒有先知在自己家鄉被人悅納的。',
    '路4:25 我對你們說實話，當以利亞的時候，天閉塞了三年零六個月，遍地有大饑荒，那時，以色列中有許多寡婦，',
    '路4:26 以利亞並沒有奉差往他們一個人那裡去，只奉差往西頓的撒勒法一個寡婦那裡去。',
    '路4:27 先知以利沙的時候，以色列中有許多長大痲瘋的，但內中除了敘利亞國的乃縵，沒有一個得潔淨的。',
    '路4:28 會堂裡的人聽見這話，都怒氣滿胸，',
    '路4:29 就起來攆他出城，他們的城造在山上；他們帶他到山崖，要把他推下去。',
    '路4:30 他卻從他們中間直行，過去了。',
    '路4:31 耶穌下到迦百農，就是加利利的一座城，在安息日教訓眾人。',
    '路4:32 他們很希奇他的教訓，因為他的話裡有權柄。',
    '路4:33 在會堂裡有一個人，被污鬼的精氣附著，大聲喊叫說：',
    '路4:34 唉！拿撒勒的耶穌，我們與你有什麼相干﹖你來滅我們嗎﹖我知道你是誰，乃是神的聖者。',
    '路4:35 耶穌責備他說：不要作聲，從這人身上出來吧！鬼把那人摔倒在眾人中間，就出來了，卻也沒有害他。',
    '路4:36 眾人都驚訝，彼此對問說：這是什麼道理呢﹖因為他用權柄能力吩咐污鬼，污鬼就出來。',
    '路4:37 於是耶穌的名聲傳遍了周圍地方。',
    '路4:38 耶穌出了會堂，進了西門的家。西門的岳母害熱病甚重，有人為他求耶穌。',
    '路4:39 耶穌站在他旁邊，斥責那熱病，熱就退了。他立刻起來服事他們。',
    '路4:40 日落的時候，凡有病人的，不論害什麼病，都帶到耶穌那裡。耶穌按手在他們各人身上，醫好他們。',
    '路4:41 又有鬼從好些人身上出來，喊著說：你是神的兒子。耶穌斥責他們，不許他們說話。因為他們知道他是基督。',
    '路4:42 天亮的時候，耶穌出來，走到曠野地方。眾人去找他，到了他那裡，要留住他，不要他離開他們。',
    '路4:43 但耶穌對他們說：我也必須在別城傳神國的福音，因我奉差原是為此。',
    '路4:44 於是耶穌在加利利的各會堂傳道。',
    '路5:1 耶穌站在革尼撒勒湖邊，眾人擁擠他，要聽神的道。',
    '路5:2 他見有兩隻船灣在湖邊；打魚的人卻離開船洗網去了。',
    '路5:3 有一隻船是西門的，耶穌就上去，請他把船撐開，稍微離岸，就坐下，從船上教訓眾人。',
    '路5:4 講完了，對西門說：把船開到水深之處，下網打魚。',
    '路5:5 西門說：夫子，我們整夜勞力，並沒有打著什麼。但依從你的話，我就下網。',
    '路5:6 他們下了網，就圈住許多魚，網險些裂開，',
    '路5:7 便招呼那隻船上的同伴來幫助。他們就來，把魚裝滿了兩隻船，甚至船要沉下去。',
    '路5:8 西門彼得看見，就俯伏在耶穌膝前，說：主啊！離開我，我是個罪人！',
    '路5:9 他和一切同在的人都驚訝這一網所打的魚。',
    '路5:10 他的夥伴西庇太的兒子雅各、約翰，也是這樣。耶穌對西門說：不要怕！從今以後，你要得人了。',
    '路5:11 他們把兩隻船攏了岸，就撇下所有的，跟從了耶穌。',
    '路5:12 有一回，耶穌在一個城裡，有人滿身長了大痲瘋，看見他，就俯伏在地，求他說：主若肯，必能叫我潔淨了。',
    '路5:13 耶穌伸手摸他，說：我肯，你潔淨了吧！大痲瘋立刻就離了他的身。',
    '路5:14 耶穌囑咐他：你切不可告訴人，只要去把身體給祭司察看，又要為你得了潔淨，照摩西所吩咐的獻上禮物，對眾人作證據。',
    '路5:15 但耶穌的名聲越發傳揚出去。有極多的人聚集來聽道，也指望醫治他們的病。',
    '路5:16 耶穌卻退到曠野去禱告。',
    '路5:17 有一天，耶穌教訓人，有法利賽人和教法師在旁邊坐著；他們是從加利利各鄉村和猶太並耶路撒冷來的。主的能力與耶穌同在，使他能醫治病人。',
    '路5:18 有人用褥子擡著一個癱子，要擡進去放在耶穌面前，',
    '路5:19 卻因人多，尋不出法子擡進去，就上了房頂，從瓦間把他連褥子縋到當中，正在耶穌面前。',
    '路5:20 耶穌見他們的信心，就對癱子說：你的罪赦了。',
    '路5:21 文士和法利賽人就議論說：這說僭妄話的是誰﹖除了神以外，誰能赦罪呢﹖',
    '路5:22 耶穌知道他們所議論的，就說：你們心裡議論的是什麼呢﹖',
    '路5:23 或說你的罪赦了，或說你起來行走，哪一樣容易呢﹖',
    '路5:24 但要叫你們知道，人子在地上有赦罪的權柄。就對癱子說：我吩咐你，起來，拿你的褥子回家去吧！',
    '路5:25 那人當眾人面前立刻起來，拿著他所躺臥的褥子回家去，歸榮耀與神。',
    '路5:26 眾人都驚奇，也歸榮耀與神，並且滿心懼怕，說：我們今日看見非常的事了。',
    '路5:27 這事以後，耶穌出去，看見一個稅吏，名叫利未，坐在稅關上，就對他說：你跟從我來。',
    '路5:28 他就撇下所有的，起來，跟從了耶穌。',
    '路5:29 利未在自己家裡為耶穌大擺筵席，有許多稅吏和別人與他們一同坐席。',
    '路5:30 法利賽人和文士就向耶穌的門徒發怨言說：你們為什麼和稅吏並罪人一同吃喝呢﹖',
    '路5:31 耶穌對他們說：無病的人用不著醫生；有病的人才用得著。',
    '路5:32 我來本不是召義人悔改，乃是召罪人悔改。',
    '路5:33 他們說：約翰的門徒屢次禁食祈禱，法利賽人的門徒也是這樣；惟獨你的門徒又吃又喝。',
    '路5:34 耶穌對他們說：新郎和陪伴之人同在的時候，豈能叫陪伴之人禁食呢﹖',
    '路5:35 但日子將到，新郎要離開他們，那日他們就要禁食了。',
    '路5:36 耶穌又設一個比喻，對他們說：沒有人把新衣服撕下一塊來補在舊衣服上；若是這樣，就把新的撕破了，並且所撕下來的那塊新的和舊的也不相稱。',
    '路5:37 也沒有人把新酒裝在舊皮袋裡；若是這樣，新酒必將皮袋裂開，酒便漏出來，皮袋也就壞了。',
    '路5:38 但新酒必須裝在新皮袋裡。',
    '路5:39 沒有人喝了陳酒又想喝新的；他總說陳的好。',
    '路6:1 有一個安息日，耶穌從麥地經過。他的門徒掐了麥穗，用手搓著吃。',
    '路6:2 有幾個法利賽人說：你們為什麼做安息日不可做的事呢﹖',
    '路6:3 耶穌對他們說：經上記著大衛和跟從他的人飢餓之時所做的事，連這個你們也沒有念過嗎﹖',
    '路6:4 他怎麼進了神的殿，拿陳設餅吃，又給跟從的人吃﹖這餅除了祭司以外，別人都不可吃。',
    '路6:5 又對他們說：人子是安息日的主。',
    '路6:6 又有一個安息日，耶穌進了會堂教訓人，在那裡有一個人右手枯乾了。',
    '路6:7 文士和法利賽人窺探耶穌，在安息日治病不治病，要得把柄去告他。',
    '路6:8 耶穌卻知道他們的意念，就對那枯乾一隻手的人說：起來！站在當中。那人就起來，站著。',
    '路6:9 耶穌對他們說：我問你們，在安息日行善行惡，救命害命，哪樣是可以的呢﹖',
    '路6:10 他就周圍看著他們眾人，對那人說：伸出手來！他把手一伸，手就復了原。',
    '路6:11 他們就滿心大怒，彼此商議怎樣處治耶穌。',
    '路6:12 那時，耶穌出去，上山禱告，整夜禱告神；',
    '路6:13 到了天亮，叫他的門徒來，就從他們中間挑選十二個人，稱他們為使徒。',
    '路6:14 這十二個人有西門，耶穌又給他起名叫彼得，還有他兄弟安得烈，又有雅各和約翰，腓力和巴多羅買，',
    '路6:15 馬太和多馬，亞勒腓的兒子雅各和奮銳黨的西門，',
    '路6:16 雅各的兒子（或作：兄弟）猶大，和賣主的加略人猶大。',
    '路6:17 耶穌和他們下了山，站在一塊平地上；同站的有許多門徒，又有許多百姓，從猶太全地和耶路撒冷，並推羅、西頓的海邊來，都要聽他講道，又指望醫治他們的病；',
    '路6:18 還有被污鬼纏磨的，也得了醫治。',
    '路6:19 眾人都想要摸他；因為有能力從他身上發出來，醫好了他們。',
    '路6:20 耶穌舉目看著門徒，說：你們貧窮的人有福了！因為神的國是你們的。',
    '路6:21 你們飢餓的人有福了！因為你們將要飽足。你們哀哭的人有福了！因為你們將要喜笑。',
    '路6:22 人為人子恨惡你們，拒絕你們，辱罵你們，棄掉你們的名，以為是惡，你們就有福了！',
    '路6:23 當那日，你們要歡喜跳躍，因為你們在天上的賞賜是大的。他們的祖宗待先知也是這樣。',
    '路6:24 但你們富足的人有禍了！因為你們受過你們的安慰。',
    '路6:25 你們飽足的人有禍了！因為你們將要飢餓。你們喜笑的人有禍了！因為你們將要哀慟哭泣。',
    '路6:26 人都說你們好的時候，你們就有禍了！因為他們的祖宗待假先知也是這樣。',
    '路6:27 只是我告訴你們這聽道的人，你們的仇敵，要愛他！恨你們的，要待他好！',
    '路6:28 咒詛你們的，要為他祝福！凌辱你們的，要為他禱告！',
    '路6:29 有人打你這邊的臉，連那邊的臉也由他打。有人奪你的外衣，連裡衣也由他拿去。',
    '路6:30 凡求你的，就給他。有人奪你的東西去，不用再要回來。',
    '路6:31 你們願意人怎樣待你們，你們也要怎樣待人。',
    '路6:32 你們若單愛那愛你們的人，有什麼可酬謝的呢﹖就是罪人也愛那愛他們的人。',
    '路6:33 你們若善待那善待你們的人，有什麼可酬謝的呢﹖就是罪人也是這樣行。',
    '路6:34 你們若借給人，指望從他收回，有什麼可酬謝的呢﹖就是罪人也借給罪人，要如數收回。',
    '路6:35 你們倒要愛仇敵，也要善待他們，並要借給人不指望償還，你們的賞賜就必大了，你們也必作至高者的兒子；因為他恩待那忘恩的和作惡的。',
    '路6:36 你們要慈悲，像你們的父慈悲一樣。',
    '路6:37 你們不要論斷人，就不被論斷；你們不要定人的罪，就不被定罪；你們要饒恕人，就必蒙饒恕（饒恕：原文作釋放）；',
    '路6:38 你們要給人，就必有給你們的，並且用十足的升斗，連搖帶按，上尖下流的倒在你們懷裡；因為你們用什麼量器量給人，也必用什麼量器量給你們。',
    '路6:39 耶穌又用比喻對他們說：瞎子豈能領瞎子，兩個人不是都要掉在坑裡嗎﹖',
    '路6:40 學生不能高過先生；凡學成了的不過和先生一樣。',
    '路6:41 為什麼看見你弟兄眼中有刺，卻不想自己眼中有梁木呢﹖',
    '路6:42 你不見自己眼中有梁木，怎能對你弟兄說：容我去掉你眼中的刺呢﹖你這假冒為善的人！先去掉自己眼中的梁木，然後才能看得清楚，去掉你弟兄眼中的刺。',
    '路6:43 因為，沒有好樹結壞果子，也沒有壞樹結好果子。',
    '路6:44 凡樹木看果子，就可以認出他來。人不是從荊棘上摘無花果，也不是從蒺藜裡摘葡萄。',
    '路6:45 善人從他心裡所存的善就發出善來；惡人從他心裡所存的惡就發出惡來；因為心裡所充滿的，口裡就說出來。',
    '路6:46 你們為什麼稱呼我主啊，主啊，卻不遵我的話行呢﹖',
    '路6:47 凡到我這裡來，聽見我的話就去行的，我要告訴你們他像什麼人：',
    '路6:48 他像一個人蓋房子，深深的挖地，把根基安在磐石上；到發大水的時候，水沖那房子，房子總不能搖動，因為根基立在磐石上（有古卷：因為蓋造得好）。',
    '路6:49 惟有聽見不去行的，就像一個人在土地上蓋房子，沒有根基；水一沖，隨即倒塌了，並且那房子壞的很大。',
    '路7:1 耶穌對百姓講完了這一切的話，就進了迦百農。',
    '路7:2 有一個百夫長所寶貴的僕人害病，快要死了。',
    '路7:3 百夫長風聞耶穌的事，就託猶太人的幾個長老去求耶穌來救他的僕人。',
    '路7:4 他們到了耶穌那裡，就切切的求他說：你給他行這事是他所配得的；',
    '路7:5 因為他愛我們的百姓，給我們建造會堂。',
    '路7:6 耶穌就和他們同去。離那家不遠，百夫長託幾個朋友去見耶穌，對他說：主啊！不要勞動；因你到我舍下，我不敢當。',
    '路7:7 我也自以為不配去見你，只要你說一句話，我的僕人就必好了。',
    '路7:8 因為我在人的權下，也有兵在我以下，對這個說：去！他就去；對那個說：來！他就來；對我的僕人說：你做這事！他就去做。',
    '路7:9 耶穌聽見這話，就希奇他，轉身對跟隨的眾人說：我告訴你們，這麼大的信心，就是在以色列中，我也沒有遇見過。',
    '路7:10 那託來的人回到百夫長家裡，看見僕人已經好了。',
    '路7:11 過了不多時（有古卷：次日），耶穌往一座城去，這城名叫拿因，他的門徒和極多的人與他同行。',
    '路7:12 將近城門，有一個死人被擡出來。這人是他母親獨生的兒子；他母親又是寡婦。有城裡的許多人同著寡婦送殯。',
    '路7:13 主看見那寡婦，就憐憫他，對他說：不要哭！',
    '路7:14 於是進前按著槓，擡的人就站住了。耶穌說：少年人，我吩咐你，起來！',
    '路7:15 那死人就坐起，並且說話。耶穌便把他交給他母親。',
    '路7:16 眾人都驚奇，歸榮耀與神，說：有大先知在我們中間興起來了！又說：神眷顧了他的百姓！',
    '路7:17 他這事的風聲就傳遍了猶太和周圍地方。',
    '路7:18 約翰的門徒把這些事都告訴約翰。',
    '路7:19 他便叫了兩個門徒來，打發他們到主那裡去，說：那將要來的是你嗎﹖還是我們等候別人呢﹖',
    '路7:20 那兩個人來到耶穌那裡，說：施洗的約翰打發我們來問你：那將要來的是你嗎﹖還是我們等候別人呢﹖',
    '路7:21 正當那時候，耶穌治好了許多有疾病的，受災患的，被惡鬼附著的，又開恩叫好些瞎子能看見。',
    '路7:22 耶穌回答說：你們去，把所看見所聽見的事告訴約翰，就是瞎子看見，瘸子行走，長大痲瘋的潔淨，聾子聽見，死人復活，窮人有福音傳給他們。',
    '路7:23 凡不因我跌倒的，就有福了！',
    '路7:24 約翰所差來的人既走了，耶穌就對眾人講論約翰說：你們從前出去到曠野，是要看什麼呢﹖要看風吹動的蘆葦嗎﹖',
    '路7:25 你們出去，到底是要看什麼﹖要看穿細軟衣服的人嗎﹖那穿華麗衣服、宴樂度日的人是在王宮裡。',
    '路7:26 你們出去，究竟是要看什麼﹖要看先知嗎﹖我告訴你們，是的，他比先知大多了。',
    '路7:27 經上記著說：我要差遣我的使者在你前面預備道路，所說的就是這個人。',
    '路7:28 我告訴你們，凡婦人所生的，沒有一個大過約翰的；然而神國裡最小的比他還大。',
    '路7:29 眾百姓和稅吏既受過約翰的洗，聽見這話，就以神為義；',
    '路7:30 但法利賽人和律法師沒有受過約翰的洗，竟為自己廢棄了神的旨意。（29，30兩節或作：眾百姓和稅吏聽見了約翰的話，就受了他的洗，便以神為義；但法利賽人和律法師不受約翰的洗，竟為自己廢棄了神的旨意。）',
    '路7:31 主又說：這樣，我可用什麼比這世代的人呢﹖他們好像什麼呢﹖',
    '路7:32 好像孩童坐在街市上，彼此呼叫說：我們向你們吹笛，你們不跳舞；我們向你們舉哀，你們不啼哭。',
    '路7:33 施洗的約翰來，不吃餅，不喝酒，你們說他是被鬼附著的。',
    '路7:34 人子來，也吃也喝，你們說他是貪食好酒的人，是稅吏和罪人的朋友。',
    '路7:35 但智慧之子都以智慧為是。',
    '路7:36 有一個法利賽人請耶穌和他吃飯；耶穌就到法利賽人家裡去坐席。',
    '路7:37 那城裡有一個女人，是個罪人，知道耶穌在法利賽人家裡坐席，就拿著盛香膏的玉瓶，',
    '路7:38 站在耶穌背後，挨著他的腳哭，眼淚溼了耶穌的腳，就用自己的頭髮擦乾，又用嘴連連親他的腳，把香膏抹上。',
    '路7:39 請耶穌的法利賽人看見這事，心裡說：這人若是先知，必知道摸他的是誰，是個怎樣的女人，乃是個罪人。',
    '路7:40 耶穌對他說：西門！我有句話要對你說。西門說：夫子，請說。',
    '路7:41 耶穌說：一個債主有兩個人欠他的債；一個欠五十兩銀子，一個欠五兩銀子；',
    '路7:42 因為他們無力償還，債主就開恩免了他們兩個人的債。這兩個人哪一個更愛他呢﹖',
    '路7:43 西門回答說：我想是那多得恩免的人。耶穌說：你斷的不錯。',
    '路7:44 於是轉過來向著那女人，便對西門說：你看見這女人嗎﹖我進了你的家，你沒有給我水洗腳；但這女人用眼淚溼了我的腳，用頭髮擦乾。',
    '路7:45 你沒有與我親嘴；但這女人從我進來的時候就不住的用嘴親我的腳。',
    '路7:46 你沒有用油抹我的頭；但這女人用香膏抹我的腳。',
    '路7:47 所以我告訴你，他許多的罪都赦免了，因為他的愛多；但那赦免少的，他的愛就少。',
    '路7:48 於是對那女人說：你的罪赦免了。',
    '路7:49 同席的人心裡說：這是什麼人，竟赦免人的罪呢﹖',
    '路7:50 耶穌對那女人說：你的信救了你；平平安安地回去吧！',
    '路8:1 過了不多日，耶穌周遊各城各鄉傳道，宣講神國的福音。和他同去的有十二個門徒，',
    '路8:2 還有被惡鬼所附、被疾病所累、已經治好的幾個婦女，內中有稱為抹大拉的馬利亞，曾有七個鬼從他身上趕出來，',
    '路8:3 又有希律的家宰苦撒的妻子約亞拿，並蘇撒拿，和好些別的婦女，都是用自己的財物供給耶穌和門徒。',
    '路8:4 當許多人聚集、又有人從各城裡出來見耶穌的時候，耶穌就用比喻說：',
    '路8:5 有一個撒種的出去撒種。撒的時候，有落在路旁的，被人踐踏，天上的飛鳥又來吃盡了。',
    '路8:6 有落在磐石上的，一出來就枯乾了，因為得不著滋潤。',
    '路8:7 有落在荊棘裡的，荊棘一同生長，把他擠住了。',
    '路8:8 又有落在好土裡的，生長起來，結實百倍。耶穌說了這些話，就大聲說：有耳可聽的，就應當聽！',
    '路8:9 門徒問耶穌說：這比喻是什麼意思呢﹖',
    '路8:10 他說：神國的奧祕只叫你們知道；至於別人，就用比喻，叫他們看也看不見，聽也聽不明。',
    '路8:11 這比喻乃是這樣：種子就是神的道。',
    '路8:12 那些在路旁的，就是人聽了道，隨後魔鬼來，從他們心裡把道奪去，恐怕他們信了得救。',
    '路8:13 那些在磐石上的，就是人聽道，歡喜領受，但心中沒有根，不過暫時相信，及至遇見試煉就退後了。',
    '路8:14 那落在荊棘裡的，就是人聽了道，走開以後，被今生的思慮、錢財、宴樂擠住了，便結不出成熟的子粒來。',
    '路8:15 那落在好土裡的，就是人聽了道，持守在誠實善良的心裡，並且忍耐著結實。',
    '路8:16 沒有人點燈用器皿蓋上，或放在床底下，乃是放在燈臺上，叫進來的人看見亮光。',
    '路8:17 因為掩藏的事沒有不顯出來的；隱瞞的事沒有不露出來被人知道的。',
    '路8:18 所以，你們應當小心怎樣聽；因為凡有的，還要加給他；凡沒有的，連他自以為有的，也要奪去。',
    '路8:19 耶穌的母親和他弟兄來了，因為人多，不得到他跟前。',
    '路8:20 有人告訴他說：你母親和你弟兄站在外邊，要見你。',
    '路8:21 耶穌回答說：聽了神之道而遵行的人就是我的母親，我的弟兄了。',
    '路8:22 有一天，耶穌和門徒上了船，對門徒說：我們可以渡到湖那邊去。他們就開了船。',
    '路8:23 正行的時候，耶穌睡著了。湖上忽然起了暴風，船將滿了水，甚是危險。',
    '路8:24 門徒來叫醒了他，說：夫子！夫子！我們喪命啦！耶穌醒了，斥責那狂風大浪；風浪就止住，平靜了。',
    '路8:25 耶穌對他們說：你們的信心在哪裡呢﹖他們又懼怕又希奇，彼此說：這到底是誰﹖他吩咐風和水，連風和水也聽從他了。',
    '路8:26 他們到了格拉森（有古卷：加大拉）人的地方，就是加利利的對面。',
    '路8:27 耶穌上了岸，就有城裡一個被鬼附著的人迎面而來。這個人許久不穿衣服，不住房子，只住在墳塋裡。',
    '路8:28 他見了耶穌，就俯伏在他面前，大聲喊叫，說：至高神的兒子耶穌，我與你有什麼相干﹖求你不要叫我受苦！',
    '路8:29 是因耶穌曾吩咐污鬼從那人身上出來。原來這鬼屢次抓住他；他常被人看守，又被鐵鍊和腳鐐捆鎖，他竟把鎖鍊掙斷，被鬼趕到曠野去。',
    '路8:30 耶穌問他說：你名叫什麼﹖他說：我名叫群；這是因為附著他的鬼多。',
    '路8:31 鬼就央求耶穌，不要吩咐他們到無底坑裡去。',
    '路8:32 那裡有一大群豬在山上吃食。鬼央求耶穌，准他們進入豬裡去。耶穌准了他們，',
    '路8:33 鬼就從那人出來，進入豬裡去。於是那群豬闖下山崖，投在湖裡淹死了。',
    '路8:34 放豬的看見這事就逃跑了，去告訴城裡和鄉下的人。',
    '路8:35 眾人出來要看是什麼事；到了耶穌那裡，看見鬼所離開的那人，坐在耶穌腳前，穿著衣服，心裡明白過來，他們就害怕。',
    '路8:36 看見這事的便將被鬼附著的人怎麼得救告訴他們。',
    '路8:37 格拉森四圍的人，因為害怕得很，都求耶穌離開他們；耶穌就上船回去了。',
    '路8:38 鬼所離開的那人懇求和耶穌同在；耶穌卻打發他回去，說：',
    '路8:39 你回家去，傳說神為你做了何等大的事。他就去，滿城裡傳揚耶穌為他做了何等大的事。',
    '路8:40 耶穌回來的時候，眾人迎接他，因為他們都等候他。',
    '路8:41 有一個管會堂的，名叫睚魯，來俯伏在耶穌腳前，求耶穌到他家裡去；',
    '路8:42 因他有一個獨生女兒，約有十二歲，快要死了。耶穌去的時候，眾人擁擠他。',
    '路8:43 有一個女人，患了十二年的血漏，在醫生手裡花盡了他一切養生的，並沒有一人能醫好他。',
    '路8:44 他來到耶穌背後，摸他的衣裳繸子，血漏立刻就止住了。',
    '路8:45 耶穌說：摸我的是誰﹖眾人都不承認。彼得和同行的人都說：夫子，眾人擁擁擠擠緊靠著你。（有古卷在此有：你還問摸我的是誰嗎﹖）',
    '路8:46 耶穌說：總有人摸我，因我覺得有能力從我身上出去。',
    '路8:47 那女人知道不能隱藏，就戰戰兢兢的來俯伏在耶穌腳前，把摸他的緣故和怎樣立刻得好了，當著眾人都說出來。',
    '路8:48 耶穌對他說：女兒，你的信救了你；平平安安地去吧！',
    '路8:49 還說話的時候，有人從管會堂的家裡來，說：你的女兒死了，不要勞動夫子。',
    '路8:50 耶穌聽見就對他說：不要怕，只要信！你的女兒就必得救。',
    '路8:51 耶穌到了他的家，除了彼得、約翰、雅各，和女兒的父母，不許別人同他進去。',
    '路8:52 眾人都為這女兒哀哭捶胸。耶穌說：不要哭。他不是死了，是睡著了。',
    '路8:53 他們曉得女兒已經死了，就嗤笑耶穌。',
    '路8:54 耶穌拉著他的手，呼叫說：女兒，起來吧！',
    '路8:55 他的靈魂便回來，他就立刻起來了。耶穌吩咐給他東西吃。',
    '路8:56 他的父母驚奇得很；耶穌囑咐他們，不要把所做的事告訴人。',
    '路9:1 耶穌叫齊了十二個門徒，給他們能力、權柄，制伏一切的鬼，醫治各樣的病，',
    '路9:2 又差遣他們去宣傳神國的道，醫治病人，',
    '路9:3 對他們說：行路的時候，不要帶柺杖和口袋，不要帶食物和銀子，也不要帶兩件褂子。',
    '路9:4 無論進哪一家，就住在那裡，也從那裡起行。',
    '路9:5 凡不接待你們的，你們離開那城的時候，要把腳上的塵土跺下去，見證他們的不是。',
    '路9:6 門徒就出去，走遍各鄉宣傳福音，到處治病。',
    '路9:7 分封的王希律聽見耶穌所做的一切事，就游移不定；因為有人說：是約翰從死裡復活；',
    '路9:8 又有人說：是以利亞顯現；還有人說：是古時的一個先知又活了。',
    '路9:9 希律說：約翰我已經斬了，這卻是什麼人﹖我竟聽見他這樣的事呢﹖就想要見他。',
    '路9:10 使徒回來，將所做的事告訴耶穌，耶穌就帶他們暗暗的離開那裡，往一座城去；那城名叫伯賽大。',
    '路9:11 但眾人知道了，就跟著他去；耶穌便接待他們，對他們講論神國的道，醫治那些需醫的人。',
    '路9:12 日頭快要平西，十二個門徒來對他說：請叫眾人散開，他們好往四面鄉村裡去借宿找吃的，因為我們這裡是野地。',
    '路9:13 耶穌說：你們給他們吃吧！門徒說：我們不過有五個餅，兩條魚，若不去為這許多人買食物就不夠。',
    '路9:14 那時，人數約有五千。耶穌對門徒說：叫他們一排一排的坐下，每排大約五十個人。',
    '路9:15 門徒就如此行，叫眾人都坐下。',
    '路9:16 耶穌拿著這五個餅，兩條魚，望著天祝福，擘開，遞給門徒，擺在眾人面前。',
    '路9:17 他們就吃，並且都吃飽了；把剩下的零碎收拾起來，裝滿了十二籃子。',
    '路9:18 耶穌自己禱告的時候，門徒也同他在那裡。耶穌問他們說：眾人說我是誰﹖',
    '路9:19 他們說：有人說是施洗的約翰；有人說是以利亞；還有人說是古時的一個先知又活了。',
    '路9:20 耶穌說：你們說我是誰﹖彼得回答說：是神所立的基督。',
    '路9:21 耶穌切切的囑咐他們，不可將這事告訴人，',
    '路9:22 又說：人子必須受許多的苦，被長老、祭司長、和文士棄絕，並且被殺，第三日復活。',
    '路9:23 耶穌又對眾人說：若有人要跟從我，就當捨己，天天背起他的十字架來跟從我。',
    '路9:24 因為，凡要救自己生命（生命：或作靈魂；下同）的，必喪掉生命；凡為我喪掉生命的，必救了生命。',
    '路9:25 人若賺得全世界，卻喪了自己，賠上自己，有什麼益處呢﹖',
    '路9:26 凡把我和我的道當作可恥的，人子在自己的榮耀裡，並天父與聖天使的榮耀裡降臨的時候，也要把那人當作可恥的。',
    '路9:27 我實在告訴你們，站在這裡的，有人在沒嘗死味以前，必看見神的國。',
    '路9:28 說了這話以後約有八天，耶穌帶著彼得、約翰、雅各上山去禱告。',
    '路9:29 正禱告的時候，他的面貌就改變了，衣服潔白放光。',
    '路9:30 忽然有摩西、以利亞兩個人同耶穌說話；',
    '路9:31 他們在榮光裡顯現，談論耶穌去世的事，就是他在耶路撒冷將要成的事。',
    '路9:32 彼得和他的同伴都打盹，既清醒了，就看見耶穌的榮光，並同他站著的那兩個人。',
    '路9:33 二人正要和耶穌分離的時候，彼得對耶穌說：夫子，我們在這裡真好！可以搭三座棚，一座為你，一座為摩西，一座為以利亞。他卻不知道所說的是什麼。',
    '路9:34 說這話的時候，有一朵雲彩來遮蓋他們；他們進入雲彩裡就懼怕。',
    '路9:35 有聲音從雲彩裡出來，說：這是我的兒子，我所揀選的（有古卷：這是我的愛子），你們要聽他。',
    '路9:36 聲音住了，只見耶穌一人在那裡。當那些日子，門徒不提所看見的事，一樣也不告訴人。',
    '路9:37 第二天，他們下了山，就有許多人迎見耶穌。',
    '路9:38 其中有一人喊叫說：夫子！求你看顧我的兒子，因為他是我的獨生子。',
    '路9:39 他被鬼抓住就忽然喊叫；鬼又叫他抽瘋，口中流沫，並且重重地傷害他，難以離開他。',
    '路9:40 我求過你的門徒，把鬼趕出去，他們卻是不能。',
    '路9:41 耶穌說：噯！這又不信又悖謬的世代啊，我在你們這裡，忍耐你們要到幾時呢﹖將你的兒子帶到這裡來吧！',
    '路9:42 正來的時候，鬼把他摔倒，叫他重重地抽瘋。耶穌就斥責那污鬼，把孩子治好了，交給他父親。',
    '路9:43 眾人都詫異神的大能（大能：或作威榮）。耶穌所做的一切事，眾人正希奇的時候，耶穌對門徒說：',
    '路9:44 你們要把這些話存在耳中，因為人子將要被交在人手裡。',
    '路9:45 他們不明白這話，意思乃是隱藏的，叫他們不能明白，他們也不敢問這話的意思。',
    '路9:46 門徒中間起了議論，誰將為大。',
    '路9:47 耶穌看出他們心中的議論，就領一個小孩子來，叫他站在自己旁邊，',
    '路9:48 對他們說：凡為我名接待這小孩子的，就是接待我；凡接待我的，就是接待那差我來的。你們中間最小的，他便為大。',
    '路9:49 約翰說：夫子，我們看見一個人奉你的名趕鬼，我們就禁止他，因為他不與我們一同跟從你。',
    '路9:50 耶穌說：不要禁止他；因為不敵擋你們的，就是幫助你們的。',
    '路9:51 耶穌被接上升的日子將到，他就定意向耶路撒冷去，',
    '路9:52 便打發使者在他前頭走。他們到了撒瑪利亞的一個村莊，要為他預備。',
    '路9:53 那裡的人不接待他，因他面向耶路撒冷去。',
    '路9:54 他的門徒雅各、約翰看見了，就說：主啊，你要我們吩咐火從天上降下來燒滅他們，像以利亞所做的（有古卷無「像以利亞所做的」數字）嗎﹖',
    '路9:55 耶穌轉身責備兩個門徒，說：你們的心如何，你們並不知道。',
    '路9:56 人子來不是要滅人的性命（或作：靈魂；下同），是要救人的性命。說著就往別的村莊去了（有古卷只有五十五節首句，五十六節末句）。',
    '路9:57 他們走路的時候，有一人對耶穌說：你無論往哪裡去，我要跟從你。',
    '路9:58 耶穌說：狐狸有洞，天空的飛鳥有窩，只是人子沒有枕頭的地方。',
    '路9:59 又對一個人說：跟從我來！那人說：主，容我先回去埋葬我的父親。',
    '路9:60 耶穌說：任憑死人埋葬他們的死人，你只管去傳揚神國的道。',
    '路9:61 又有一人說：主，我要跟從你，但容我先去辭別我家裡的人。',
    '路9:62 耶穌說：手扶著犁向後看的，不配進神的國。',
    '路10:1 這事以後，主又設立七十個人，差遣他們兩個兩個的在他前面，往自己所要到的各城各地方去，',
    '路10:2 就對他們說：要收的莊稼多，做工的人少。所以，你們當求莊稼的主打發工人出去收他的莊稼。',
    '路10:3 你們去吧！我差你們出去，如同羊羔進入狼群。',
    '路10:4 不要帶錢囊，不要帶口袋，不要帶鞋；在路上也不要問人的安。',
    '路10:5 無論進哪一家，先要說：願這一家平安。',
    '路10:6 那裡若有當得平安的人（當得平安的人：原文是平安之子），你們所求的平安就必臨到那家；不然，就歸與你們了。',
    '路10:7 你們要住在那家，吃喝他們所供給的，因為工人得工價是應當的；不要從這家搬到那家。',
    '路10:8 無論進哪一城，人若接待你們，給你們擺上什麼，你們就吃什麼。',
    '路10:9 要醫治那城裡的病人，對他們說：神的國臨近你們了。',
    '路10:10 無論進哪一城，人若不接待你們，你們就到街上去，',
    '路10:11 說：就是你們城裡的塵土黏在我們的腳上，我們也當著你們擦去。雖然如此，你們該知道神的國臨近了。',
    '路10:12 我告訴你們，當審判的日子，所多瑪所受的，比那城還容易受呢！',
    '路10:13 哥拉汛哪，你有禍了！伯賽大啊，你有禍了！因為在你們中間所行的異能若行在推羅、西頓，他們早已披麻蒙灰，坐在地上悔改了。',
    '路10:14 當審判的日子，推羅、西頓所受的，比你們還容易受呢！',
    '路10:15 迦百農啊，你已經升到天上（或作：你將要升到天上嗎），將來必推下陰間。',
    '路10:16 又對門徒說：聽從你們的就是聽從我；棄絕你們的就是棄絕我；棄絕我的就是棄絕那差我來的。',
    '路10:17 那七十個人歡歡喜喜的回來，說：主啊！因你的名，就是鬼也服了我們。',
    '路10:18 耶穌對他們說：我曾看見撒但從天上墜落，像閃電一樣。',
    '路10:19 我已經給你們權柄可以踐踏蛇和蠍子，又勝過仇敵一切的能力，斷沒有什麼能害你們。',
    '路10:20 然而，不要因鬼服了你們就歡喜，要因你們的名記錄在天上歡喜。',
    '路10:21 正當那時，耶穌被聖靈感動就歡樂，說：父啊，天地的主，我感謝你！因為你將這些事向聰明通達人就藏起來，向嬰孩就顯出來。父啊！是的，因為你的美意本是如此。',
    '路10:22 一切所有的都是我父交付我的；除了父，沒有人知道子是誰；除了子和子所願意指示的，沒有人知道父是誰。',
    '路10:23 耶穌轉身暗暗的對門徒說：看見你們所看見的，那眼睛就有福了。',
    '路10:24 我告訴你們，從前有許多先知和君王要看你們所看的，卻沒有看見，要聽你們所聽的，卻沒有聽見。',
    '路10:25 有一個律法師起來試探耶穌，說：夫子！我該做什麼才可以承受永生﹖',
    '路10:26 耶穌對他說：律法上寫的是什麼﹖你念的是怎樣呢﹖',
    '路10:27 他回答說：你要盡心、盡性、盡力、盡意愛主─你的神；又要愛鄰舍如同自己。',
    '路10:28 耶穌說：你回答的是；你這樣行，就必得永生。',
    '路10:29 那人要顯明自己有理，就對耶穌說：誰是我的鄰舍呢﹖',
    '路10:30 耶穌回答說：有一個人從耶路撒冷下耶利哥去，落在強盜手中。他們剝去他的衣裳，把他打個半死，就丟下他走了。',
    '路10:31 偶然有一個祭司從這條路下來，看見他就從那邊過去了。',
    '路10:32 又有一個利未人來到這地方，看見他，也照樣從那邊過去了。',
    '路10:33 惟有一個撒瑪利亞人行路來到那裡，看見他就動了慈心，',
    '路10:34 上前用油和酒倒在他的傷處，包裹好了，扶他騎上自己的牲口，帶到店裡去照應他。',
    '路10:35 第二天拿出二錢銀子來，交給店主，說：你且照應他；此外所費用的，我回來必還你。',
    '路10:36 你想，這三個人哪一個是落在強盜手中的鄰舍呢﹖',
    '路10:37 他說：是憐憫他的。耶穌說：你去照樣行吧。',
    '路10:38 他們走路的時候，耶穌進了一個村莊。有一個女人，名叫馬大，接他到自己家裡。',
    '路10:39 他有一個妹子，名叫馬利亞，在耶穌腳前坐著聽他的道。',
    '路10:40 馬大伺候的事多，心裡忙亂，就進前來，說：主啊，我的妹子留下我一個人伺候，你不在意嗎﹖請吩咐他來幫助我。',
    '路10:41 耶穌回答說：馬大！馬大！你為許多的事思慮煩擾，',
    '路10:42 但是不可少的只有一件；馬利亞已經選擇那上好的福分，是不能奪去的。',
    '路11:1 耶穌在一個地方禱告；禱告完了，有個門徒對他說：求主教導我們禱告，像約翰教導他的門徒。',
    '路11:2 耶穌說：你們禱告的時候，要說：我們在天上的父（有古卷只作：父啊）：願人都尊你的名為聖。願你的國降臨；願你的旨意行在地上，如同行在天上（有古卷無願你的旨意云云）。',
    '路11:3 我們日用的飲食，天天賜給我們。',
    '路11:4 赦免我們的罪，因為我們也赦免凡虧欠我們的人。不叫我們遇見試探；救我們脫離兇惡（有古卷無末句）。',
    '路11:5 耶穌又說：你們中間誰有一個朋友半夜到他那裡去，說：朋友！請借給我三個餅；',
    '路11:6 因為我有一個朋友行路，來到我這裡，我沒有什麼給他擺上。',
    '路11:7 那人在裡面回答說：不要攪擾我，門已經關閉，孩子們也同我在床上了，我不能起來給你。',
    '路11:8 我告訴你們，雖不因他是朋友起來給他，但因他情詞迫切的直求，就必起來照他所需用的給他。',
    '路11:9 我又告訴你們，你們祈求，就給你們；尋找，就尋見；叩門，就給你們開門。',
    '路11:10 因為，凡祈求的，就得著；尋找的，就尋見；叩門的，就給他開門。',
    '路11:11 你們中間作父親的，誰有兒子求餅，反給他石頭呢﹖求魚，反拿蛇當魚給他呢﹖',
    '路11:12 求雞蛋，反給他蠍子呢﹖',
    '路11:13 你們雖然不好，尚且知道拿好東西給兒女；何況天父，豈不更將聖靈給求他的人嗎﹖',
    '路11:14 耶穌趕出一個叫人啞巴的鬼，鬼出去了，啞巴就說出話來；眾人都希奇。',
    '路11:15 內中卻有人說：他是靠著鬼王別西卜趕鬼。',
    '路11:16 又有人試探耶穌，向他求從天上來的神蹟。',
    '路11:17 他曉得他們的意念，便對他們說：凡一國自相紛爭，就成為荒場；凡一家自相紛爭，就必敗落。',
    '路11:18 若撒但自相紛爭，他的國怎能站得住呢﹖因為你們說我是靠著別西卜趕鬼。',
    '路11:19 我若靠著別西卜趕鬼，你們的子弟趕鬼又靠著誰呢﹖這樣，他們就要斷定你們的是非。',
    '路11:20 我若靠著神的能力趕鬼，這就是神的國臨到你們了。',
    '路11:21 壯士披掛整齊，看守自己的住宅，他所有的都平安無事；',
    '路11:22 但有一個比他更壯的來，勝過他，就奪去他所倚靠的盔甲兵器，又分了他的贓。',
    '路11:23 不與我相合的，就是敵我的；不同我收聚的，就是分散的。',
    '路11:24 污鬼離了人身，就在無水之地過來過去，尋求安歇之處；既尋不著，便說：我要回到我所出來的屋裡去。',
    '路11:25 到了，就看見裡面打掃乾淨，修飾好了，',
    '路11:26 便去另帶了七個比自己更惡的鬼來，都進去住在那裡。那人末後的景況比先前更不好了。',
    '路11:27 耶穌正說這話的時候，眾人中間有一個女人大聲說：懷你胎的和乳養你的有福了！',
    '路11:28 耶穌說：是，卻還不如聽神之道而遵守的人有福。',
    '路11:29 當眾人聚集的時候，耶穌開講說：這世代是一個邪惡的世代。他們求看神蹟，除了約拿的神蹟以外，再沒有神蹟給他們看。',
    '路11:30 約拿怎樣為尼尼微人成了神蹟，人子也要照樣為這世代的人成了神蹟。',
    '路11:31 當審判的時候，南方的女王要起來定這世代的罪；因為他從地極而來，要聽所羅門的智慧話。看哪！在這裡有一人比所羅門更大。',
    '路11:32 當審判的時候，尼尼微人要起來定這世代的罪，因為尼尼微人聽了約拿所傳的就悔改了。看哪！在這裡有一人比約拿更大。',
    '路11:33 沒有人點燈放在地窨子裡，或是斗底下，總是放在燈臺上，使進來的人得見亮光。',
    '路11:34 你眼睛就是身上的燈。你的眼睛若瞭亮，全身就光明；眼睛若昏花，全身就黑暗。',
    '路11:35 所以，你要省察，恐怕你裡頭的光或者黑暗了。',
    '路11:36 若是你全身光明，毫無黑暗，就必全然光明，如同燈的明光照亮你。',
    '路11:37 說話的時候，有一個法利賽人請耶穌同他吃飯，耶穌就進去坐席。',
    '路11:38 這法利賽人看見耶穌飯前不洗手便詫異。',
    '路11:39 主對他說：如今你們法利賽人洗淨杯盤的外面，你們裡面卻滿了勒索和邪惡。',
    '路11:40 無知的人哪，造外面的，不也造裡面嗎﹖',
    '路11:41 只要把裡面的施捨給人，凡物於你們就都潔淨了。',
    '路11:42 你們法利賽人有禍了！因為你們將薄荷、芸香並各樣菜蔬獻上十分之一，那公義和愛神的事反倒不行了。這原是你們當行的；那也是不可不行的。',
    '路11:43 你們法利賽人有禍了！因為你們喜愛會堂裡的首位，又喜愛人在街市上問你們的安。',
    '路11:44 你們有禍了！因為你們如同不顯露的墳墓，走在上面的人並不知道。',
    '路11:45 律法師中有一個回答耶穌說：夫子！你這樣說也把我們糟蹋了。',
    '路11:46 耶穌說：你們律法師也有禍了！因為你們把難擔的擔子放在人身上，自己一個指頭卻不肯動。',
    '路11:47 你們有禍了！因為你們修造先知的墳墓，那先知正是你們的祖宗所殺的。',
    '路11:48 可見你們祖宗所做的事，你們又證明又喜歡；因為他們殺了先知，你們修造先知的墳墓。',
    '路11:49 所以，神用智慧（用智慧：或作的智者）曾說：我要差遣先知和使徒到他們那裡去，有的他們要殺害，有的他們要逼迫，',
    '路11:50 使創世以來所流眾先知血的罪都要問在這世代的人身上，',
    '路11:51 就是從亞伯的血起，直到被殺在壇和殿中間撒迦利亞的血為止。我實在告訴你們，這都要問在這世代的人身上。',
    '路11:52 你們律法師有禍了！因為你們把知識的鑰匙奪了去，自己不進去，正要進去的人你們也阻擋他們。',
    '路11:53 耶穌從那裡出來，文士和法利賽人就極力的催逼他，引動他多說話，',
    '路11:54 私下窺聽，要拿他的話柄。',
    '路12:1 這時，有幾萬人聚集，甚至彼此踐踏。耶穌開講，先對門徒說：你們要防備法利賽人的酵，就是假冒為善。',
    '路12:2 掩蓋的事沒有不露出來的；隱藏的事，沒有不被人知道的。',
    '路12:3 因此，你們在暗中所說的，將要在明處被人聽見；在內室附耳所說的，將要在房上被人宣揚。',
    '路12:4 我的朋友，我對你們說，那殺身體以後不能再做什麼的，不要怕他們。',
    '路12:5 我要指示你們當怕的是誰：當怕那殺了以後又有權柄丟在地獄裡的。我實在告訴你們，正要怕他。',
    '路12:6 五個麻雀不是賣二分銀子嗎﹖但在神面前，一個也不忘記；',
    '路12:7 就是你們的頭髮，也都被數過了。不要懼怕，你們比許多麻雀還貴重！',
    '路12:8 我又告訴你們，凡在人面前認我的，人子在神的使者面前也必認他；',
    '路12:9 在人面前不認我的，人子在神的使者面前也必不認他。',
    '路12:10 凡說話干犯人子的，還可得赦免；惟獨褻瀆聖靈的，總不得赦免。',
    '路12:11 人帶你們到會堂，並官府和有權柄的人面前，不要思慮怎麼分訴，說什麼話；',
    '路12:12 因為正在那時候，聖靈要指教你們當說的話。',
    '路12:13 眾人中有一個人對耶穌說：夫子！請你吩咐我的兄長和我分開家業。',
    '路12:14 耶穌說：你這個人！誰立我作你們斷事的官，給你們分家業呢﹖',
    '路12:15 於是對眾人說：你們要謹慎自守，免去一切的貪心，因為人的生命不在乎家道豐富。',
    '路12:16 就用比喻對他們說：有一個財主田產豐盛；',
    '路12:17 自己心裡思想說：我的出產沒有地方收藏，怎麼辦呢﹖',
    '路12:18 又說：我要這麼辦：要把我的倉房拆了，另蓋更大的，在那裡好收藏我一切的糧食和財物，',
    '路12:19 然後要對我的靈魂說：靈魂哪，你有許多財物積存，可作多年的費用，只管安安逸逸的吃喝快樂吧！',
    '路12:20 神卻對他說：無知的人哪，今夜必要你的靈魂；你所預備的要歸誰呢﹖',
    '路12:21 凡為自己積財，在神面前卻不富足的，也是這樣。',
    '路12:22 耶穌又對門徒說：所以我告訴你們，不要為生命憂慮吃什麼，為身體憂慮穿什麼；',
    '路12:23 因為生命勝於飲食，身體勝於衣裳。',
    '路12:24 你想烏鴉，也不種也不收，又沒有倉又沒有庫，神尚且養活他。你們比飛鳥是何等的貴重呢！',
    '路12:25 你們哪一個能用思慮使壽數多加一刻呢（或作：使身量多加一肘呢）﹖',
    '路12:26 這最小的事，你們尚且不能做，為什麼還憂慮其餘的事呢﹖',
    '路12:27 你想百合花怎麼長起來；他也不勞苦，也不紡線。然而我告訴你們，就是所羅門極榮華的時候，他所穿戴的，還不如這花一朵呢！',
    '路12:28 你們這小信的人哪，野地裡的草今天還在，明天就丟在爐裡，神還給他這樣的妝飾，何況你們呢！',
    '路12:29 你們不要求吃什麼，喝什麼，也不要掛心；',
    '路12:30 這都是外邦人所求的。你們必須用這些東西，你們的父是知道的。',
    '路12:31 你們只要求他的國，這些東西就必加給你們了。',
    '路12:32 你們這小群，不要懼怕，因為你們的父樂意把國賜給你們。',
    '路12:33 你們要變賣所有的賙濟人，為自己預備永不壞的錢囊，用不盡的財寶在天上，就是賊不能近、蟲不能蛀的地方。',
    '路12:34 因為，你們的財寶在哪裡，你們的心也在那裡。',
    '路12:35 你們腰裡要束上帶，燈也要點著，',
    '路12:36 自己好像僕人等候主人從婚姻的筵席上回來。他來到，叩門，就立刻給他開門。',
    '路12:37 主人來了，看見僕人警醒，那僕人就有福了。我實在告訴你們，主人必叫他們坐席，自己束上帶，進前伺候他們。',
    '路12:38 或是二更天來，或是三更天來，看見僕人這樣，那僕人就有福了。',
    '路12:39 家主若知道賊什麼時候來，就必警醒，不容賊挖透房屋，這是你們所知道的。',
    '路12:40 你們也要預備；因為你們想不到的時候，人子就來了。',
    '路12:41 彼得說：主啊，這比喻是為我們說的呢﹖還是為眾人呢﹖',
    '路12:42 主說：誰是那忠心有見識的管家，主人派他管理家裡的人，按時分糧給他們呢﹖',
    '路12:43 主人來到，看見僕人這樣行，那僕人就有福了。',
    '路12:44 我實在告訴你們，主人要派他管理一切所有的。',
    '路12:45 那僕人若心裡說：我的主人必來得遲，就動手打僕人和使女，並且吃喝醉酒；',
    '路12:46 在他想不到的日子，不知道的時辰，那僕人的主人要來，重重地處治他（或作：把他腰軋了），定他和不忠心的人同罪。',
    '路12:47 僕人知道主人的意思，卻不預備，又不順他的意思行，那僕人必多受責打；',
    '路12:48 惟有那不知道的，做了當受責打的事，必少受責打；因為多給誰，就向誰多取；多託誰，就向誰多要。',
    '路12:49 我來要把火丟在地上，倘若已經著起來，不也是我所願意的嗎﹖',
    '路12:50 我有當受的洗還沒有成就，我是何等的迫切呢﹖',
    '路12:51 你們以為我來，是叫地上太平嗎﹖我告訴你們，不是，乃是叫人紛爭。',
    '路12:52 從今以後，一家五個人將要紛爭：三個人和兩個人相爭，兩個人和三個人相爭；',
    '路12:53 父親和兒子相爭，兒子和父親相爭；母親和女兒相爭，女兒和母親相爭；婆婆和媳婦相爭，媳婦和婆婆相爭。',
    '路12:54 耶穌又對眾人說：你們看見西邊起了雲彩，就說：要下一陣雨；果然就有。',
    '路12:55 起了南風，就說：將要燥熱；也就有了。',
    '路12:56 假冒為善的人哪，你們知道分辨天地的氣色，怎麼不知道分辨這時候呢﹖',
    '路12:57 你們又為何不自己審量什麼是合理的呢﹖',
    '路12:58 你同告你的對頭去見官，還在路上，務要盡力的和他了結；恐怕他拉你到官面前，官交付差役，差役把你下在監裡。',
    '路12:59 我告訴你，若有半文錢沒有還清，你斷不能從那裡出來。',
    '路13:1 正當那時，有人將彼拉多使加利利人的血攙雜在他們祭物中的事告訴耶穌。',
    '路13:2 耶穌說；你們以為這些加利利人比眾加利利人更有罪，所以受這害嗎﹖',
    '路13:3 我告訴你們，不是的！你們若不悔改，都要如此滅亡！',
    '路13:4 從前西羅亞樓倒塌了，壓死十八個人；你們以為那些人比一切住在耶路撒冷的人更有罪嗎﹖',
    '路13:5 我告訴你們，不是的！你們若不悔改，都要如此滅亡！',
    '路13:6 於是用比喻說：一個人有一棵無花果樹栽在葡萄園裡。他來到樹前找果子，卻找不著。',
    '路13:7 就對管園的說：看哪，我這三年來到這無花果樹前找果子，竟找不著。把他砍了吧，何必白佔地土呢！',
    '路13:8 管園的說：主啊，今年且留著，等我周圍掘開土，加上糞；',
    '路13:9 以後若結果子便罷，不然再把他砍了。',
    '路13:10 安息日，耶穌在會堂裡教訓人。',
    '路13:11 有一個女人被鬼附著，病了十八年，腰彎得一點直不起來。',
    '路13:12 耶穌看見，便叫過他來，對他說：女人，你脫離這病了！',
    '路13:13 於是用兩隻手按著他；他立刻直起腰來，就歸榮耀與神。',
    '路13:14 管會堂的因為耶穌在安息日治病，就氣忿忿的對眾人說：有六日應當做工；那六日之內可以來求醫，在安息日卻不可。',
    '路13:15 主說：假冒為善的人哪，難道你們各人在安息日不解開槽上的牛、驢，牽去飲嗎﹖',
    '路13:16 況且這女人本是亞伯拉罕的後裔，被撒但捆綁了這十八年，不當在安息日解開他的綁嗎﹖',
    '路13:17 耶穌說這話，他的敵人都慚愧了；眾人因他所行一切榮耀的事，就都歡喜了。',
    '路13:18 耶穌說：神的國好像什麼﹖我拿什麼來比較呢﹖',
    '路13:19 好像一粒芥菜種，有人拿去種在園子裡，長大成樹，天上的飛鳥宿在他的枝上。',
    '路13:20 又說：我拿什麼來比神的國呢﹖',
    '路13:21 好比麵酵，有婦人拿來藏在三斗麵裡，直等全團都發起來。',
    '路13:22 耶穌往耶路撒冷去，在所經過的各城各鄉教訓人。',
    '路13:23 有一個人問他說：主啊，得救的人少嗎﹖',
    '路13:24 耶穌對眾人說：你們要努力進窄門。我告訴你們，將來有許多人想要進去，卻是不能。',
    '路13:25 及至家主起來關了門，你們站在外面叩門，說：主啊，給我們開門！他就回答說：我不認識你們，不曉得你們是哪裡來的！',
    '路13:26 那時，你們要說：我們在你面前吃過喝過，你也在我們的街上教訓過人。',
    '路13:27 他要說：我告訴你們，我不曉得你們是哪裡來的。你們這一切作惡的人，離開我去吧！',
    '路13:28 你們要看見亞伯拉罕、以撒、雅各，和眾先知都在神的國裡，你們卻被趕到外面，在那裡必要哀哭切齒了。',
    '路13:29 從東、從西、從南、從北將有人來，在神的國裡坐席。',
    '路13:30 只是有在後的，將要在前；有在前的，將要在後。',
    '路13:31 正當那時，有幾個法利賽人來對耶穌說：離開這裡去吧，因為希律想要殺你。',
    '路13:32 耶穌說：你們去告訴那個狐狸說：今天、明天我趕鬼治病，第三天我的事就成全了。',
    '路13:33 雖然這樣，今天、明天、後天，我必須前行，因為先知在耶路撒冷之外喪命是不能的。',
    '路13:34 耶路撒冷啊！耶路撒冷啊！你常殺害先知，又用石頭打死那奉差遣到你這裡來的人。我多次願意聚集你的兒女，好像母雞把小雞聚集在翅膀底下，只是你們不願意。',
    '路13:35 看哪，你們的家成為荒場留給你們。我告訴你們，從今以後你們不得再見我，直等到你們說：奉主名來的是應當稱頌的。',
    '路14:1 安息日，耶穌到一個法利賽人的首領家裡去吃飯，他們就窺探他。',
    '路14:2 在他面前有一個患水臌的人。',
    '路14:3 耶穌對律法師和法利賽人說：安息日治病，可以不可以﹖',
    '路14:4 他們卻不言語。耶穌就治好那人，叫他走了；',
    '路14:5 便對他們說：你們中間誰有驢或有牛，在安息日掉在井裡，不立時拉他上來呢﹖',
    '路14:6 他們不能對答這話。',
    '路14:7 耶穌見所請的客揀擇首位，就用比喻對他們說：',
    '路14:8 你被人請去赴婚姻的筵席，不要坐在首位上，恐怕有比你尊貴的客被他請來；',
    '路14:9 那請你們的人前來對你說：讓座給這一位吧！你就羞羞慚慚的退到末位上去了。',
    '路14:10 你被請的時候，就去坐在末位上，好叫那請你的人來對你說：朋友，請上坐。那時，你在同席的人面前就有光彩了。',
    '路14:11 因為，凡自高的，必降為卑，自卑的，必升為高。',
    '路14:12 耶穌又對請他的人說：你擺設午飯或晚飯，不要請你的朋友、弟兄、親屬，和富足的鄰舍，恐怕他們也請你，你就得了報答。',
    '路14:13 你擺設筵席，倒要請那貧窮的、殘廢的、瘸腿的、瞎眼的，你就有福了！',
    '路14:14 因為他們沒有什麼可報答你。到義人復活的時候，你要得著報答。',
    '路14:15 同席的有一人聽見這話，就對耶穌說：在神國裡吃飯的有福了！',
    '路14:16 耶穌對他說：有一人擺設大筵席，請了許多客。',
    '路14:17 到了坐席的時候，打發僕人去對所請的人說：請來吧！樣樣都齊備了。',
    '路14:18 眾人一口同音的推辭。頭一個說：我買了一塊地，必須去看看。請你准我辭了。',
    '路14:19 又有一個說：我買了五對牛，要去試一試。請你准我辭了。',
    '路14:20 又有一個說：我才娶了妻，所以不能去。',
    '路14:21 那僕人回來，把這事都告訴了主人。家主就動怒，對僕人說：快出去，到城裡大街小巷，領那貧窮的、殘廢的、瞎眼的、瘸腿的來。',
    '路14:22 僕人說：主啊，你所吩咐的已經辦了，還有空座。',
    '路14:23 主人對僕人說，你出去到路上和籬笆那裡，勉強人進來，坐滿我的屋子。',
    '路14:24 我告訴你們，先前所請的人，沒有一個得嘗我的筵席。',
    '路14:25 有極多的人和耶穌同行。他轉過來對他們說：',
    '路14:26 人到我這裡來，若不愛我勝過愛（愛我勝過愛：原文是恨）自己的父母、妻子、兒女、弟兄、姊妹，和自己的性命，就不能作我的門徒。',
    '路14:27 凡不背著自己十字架跟從我的，也不能作我的門徒。',
    '路14:28 你們哪一個要蓋一座樓，不先坐下算計花費，能蓋成不能呢﹖',
    '路14:29 恐怕安了地基，不能成功，看見的人都笑話他，說：',
    '路14:30 這個人開了工，卻不能完工。',
    '路14:31 或是一個王出去和別的王打仗，豈不先坐下酌量，能用一萬兵去敵那領二萬兵來攻打他的嗎﹖',
    '路14:32 若是不能，就趁敵人還遠的時候，派使者去求和息的條款。',
    '路14:33 這樣，你們無論什麼人，若不撇下一切所有的，就不能作我的門徒。',
    '路14:34 鹽本是好的；鹽若失了味，可用什麼叫他再鹹呢﹖',
    '路14:35 或用在田裡，或堆在糞裡，都不合式，只好丟在外面。有耳可聽的，就應當聽！',
    '路15:1 眾稅吏和罪人都挨近耶穌，要聽他講道。',
    '路15:2 法利賽人和文士私下議論說：這個人接待罪人，又同他們吃飯。',
    '路15:3 耶穌就用比喻說：',
    '路15:4 你們中間誰有一百隻羊失去一隻，不把這九十九隻撇在曠野、去找那失去的羊，直到找著呢﹖',
    '路15:5 找著了，就歡歡喜喜的扛在肩上，回到家裡，',
    '路15:6 就請朋友鄰舍來，對他們說：我失去的羊已經找著了，你們和我一同歡喜吧！',
    '路15:7 我告訴你們，一個罪人悔改，在天上也要這樣為他歡喜，較比為九十九個不用悔改的義人歡喜更大。',
    '路15:8 或是一個婦人有十塊錢，若失落一塊，豈不點上燈，打掃屋子，細細的找，直到找著嗎﹖',
    '路15:9 找著了，就請朋友鄰舍來，對他們說：我失落的那塊錢已經找著了，你們和我一同歡喜吧！',
    '路15:10 我告訴你們，一個罪人悔改，在神的使者面前也是這樣為他歡喜。',
    '路15:11 耶穌又說：一個人有兩個兒子。',
    '路15:12 小兒子對父親說：父親，請你把我應得的家業分給我。他父親就把產業分給他們。',
    '路15:13 過了不多幾日，小兒子就把他一切所有的都收拾起來，往遠方去了。在那裡任意放蕩，浪費資財。',
    '路15:14 既耗盡了一切所有的，又遇著那地方大遭饑荒，就窮苦起來。',
    '路15:15 於是去投靠那地方的一個人；那人打發他到田裡去放豬。',
    '路15:16 他恨不得拿豬所吃的豆莢充飢，也沒有人給他。',
    '路15:17 他醒悟過來，就說：我父親有多少的雇工，口糧有餘，我倒在這裡餓死嗎﹖',
    '路15:18 我要起來，到我父親那裡去，向他說：父親！我得罪了天，又得罪了你；',
    '路15:19 從今以後，我不配稱為你的兒子，把我當作一個雇工吧！',
    '路15:20 於是起來，往他父親那裡去。相離還遠，他父親看見，就動了慈心，跑去抱著他的頸項，連連與他親嘴。',
    '路15:21 兒子說：父親！我得罪了天，又得罪了你；從今以後，我不配稱為你的兒子。',
    '路15:22 父親卻吩咐僕人說：把那上好的袍子快拿出來給他穿；把戒指戴在他指頭上；把鞋穿在他腳上；',
    '路15:23 把那肥牛犢牽來宰了，我們可以吃喝快樂；',
    '路15:24 因為我這個兒子是死而復活，失而又得的。他們就快樂起來。',
    '路15:25 那時，大兒子正在田裡。他回來，離家不遠，聽見作樂跳舞的聲音，',
    '路15:26 便叫過一個僕人來，問是什麼事。',
    '路15:27 僕人說：你兄弟來了；你父親因為得他無災無病的回來，把肥牛犢宰了。',
    '路15:28 大兒子卻生氣，不肯進去；他父親就出來勸他。',
    '路15:29 他對父親說：我服事你這多年，從來沒有違背過你的命，你並沒有給我一隻山羊羔，叫我和朋友一同快樂。',
    '路15:30 但你這個兒子和娼妓吞盡了你的產業，他一來了，你倒為他宰了肥牛犢。',
    '路15:31 父親對他說：兒啊！你常和我同在，我一切所有的都是你的；',
    '路15:32 只是你這個兄弟是死而復活、失而又得的，所以我們理當歡喜快樂。',
    '路16:1 耶穌又對門徒說：有一個財主的管家，別人向他主人告他浪費主人的財物。',
    '路16:2 主人叫他來，對他說：我聽見你這事怎麼樣呢﹖把你所經管的交代明白，因你不能再作我的管家。',
    '路16:3 那管家心裡說：主人辭我，不用我再作管家，我將來做什麼﹖鋤地呢﹖無力；討飯呢﹖怕羞。',
    '路16:4 我知道怎麼行，好叫人在我不作管家之後，接我到他們家裡去。',
    '路16:5 於是把欠他主人債的，一個一個的叫了來，問頭一個說：你欠我主人多少﹖',
    '路16:6 他說：一百簍（每簍約五十斤）油。管家說：拿你的帳，快坐下，寫五十。',
    '路16:7 又問一個說：你欠多少﹖他說：一百石麥子。管家說：拿你的帳，寫八十。',
    '路16:8 主人就誇獎這不義的管家做事聰明。因為今世之子，在世事之上，較比光明之子更加聰明。',
    '路16:9 我又告訴你們，要藉著那不義的錢財結交朋友，到了錢財無用的時候，他們可以接你們到永存的帳幕裡去。',
    '路16:10 人在最小的事上忠心，在大事上也忠心；在最小的事上不義，在大事上也不義。',
    '路16:11 倘若你們在不義的錢財上不忠心，誰還把那真實的錢財託付你們呢﹖',
    '路16:12 倘若你們在別人的東西上不忠心，誰還把你們自己的東西給你們呢﹖',
    '路16:13 一個僕人不能事奉兩個主；不是惡這個愛那個，就是重這個輕那個。你們不能又事奉神，又事奉瑪門。',
    '路16:14 法利賽人是貪愛錢財的，他們聽見這一切話，就嗤笑耶穌。',
    '路16:15 耶穌對他們說：你們是在人面前自稱為義的，你們的心，神卻知道；因為人所尊貴的，是神看為可憎惡的。',
    '路16:16 律法和先知到約翰為止，從此神國的福音傳開了，人人努力要進去。',
    '路16:17 天地廢去較比律法的一點一畫落空還容易。',
    '路16:18 凡休妻另娶的就是犯姦淫；娶被休之妻的也是犯姦淫。',
    '路16:19 有一個財主穿著紫色袍和細麻布衣服，天天奢華宴樂。',
    '路16:20 又有一個討飯的，名叫拉撒路，渾身生瘡，被人放在財主門口，',
    '路16:21 要得財主桌子上掉下來的零碎充飢；並且狗來餂他的瘡。',
    '路16:22 後來那討飯的死了，被天使帶去放在亞伯拉罕的懷裡。財主也死了，並且埋葬了。',
    '路16:23 他在陰間受痛苦，舉目遠遠的望見亞伯拉罕，又望見拉撒路在他懷裡，',
    '路16:24 就喊著說：我祖亞伯拉罕哪，可憐我吧！打發拉撒路來，用指頭尖蘸點水，涼涼我的舌頭；因為我在這火焰裡，極其痛苦。',
    '路16:25 亞伯拉罕說：兒啊，你該回想你生前享過福，拉撒路也受過苦；如今他在這裡得安慰，你倒受痛苦。',
    '路16:26 不但這樣，並且在你我之間，有深淵限定，以致人要從這邊過到你們那邊是不能的；要從那邊過到我們這邊也是不能的。',
    '路16:27 財主說：我祖啊！既是這樣，求你打發拉撒路到我父家去；',
    '路16:28 因為我還有五個弟兄，他可以對他們作見證，免得他們也來到這痛苦的地方。',
    '路16:29 亞伯拉罕說：他們有摩西和先知的話可以聽從。',
    '路16:30 他說：我祖亞伯拉罕哪，不是的，若有一個從死裡復活的，到他們那裡去的，他們必要悔改。',
    '路16:31 亞伯拉罕說：若不聽從摩西和先知的話，就是有一個從死裡復活的，他們也是不聽勸。',
    '路17:1 耶穌又對門徒說：絆倒人的事是免不了的；但那絆倒人的有禍了。',
    '路17:2 就是把磨石拴在這人的頸項上，丟在海裡，還強如他把這小子裡的一個絆倒了。',
    '路17:3 你們要謹慎！若是你的弟兄得罪你，就勸戒他；他若懊悔，就饒恕他。',
    '路17:4 倘若他一天七次得罪你，又七次回轉，說：我懊悔了，你總要饒恕他。',
    '路17:5 使徒對主說：求主加增我們的信心。',
    '路17:6 主說：你們若有信心像一粒芥菜種，就是對這棵桑樹說：你要拔起根來，栽在海裡，他也必聽從你們。',
    '路17:7 你們誰有僕人耕地或是放羊，從田裡回來，就對他說：你快來坐下吃飯呢﹖',
    '路17:8 豈不對他說：你給我預備晚飯，束上帶子伺候我，等我吃喝完了，你才可以吃喝嗎﹖',
    '路17:9 僕人照所吩咐的去做，主人還謝謝他嗎﹖',
    '路17:10 這樣，你們做完了一切所吩咐的，只當說：我們是無用的僕人，所做的本是我們應分做的。',
    '路17:11 耶穌往耶路撒冷去，經過撒瑪利亞和加利利。',
    '路17:12 進入一個村子，有十個長大痲瘋的，迎面而來，遠遠的站著，',
    '路17:13 高聲說：耶穌，夫子，可憐我們吧！',
    '路17:14 耶穌看見，就對他們說：你們去把身體給祭司察看。他們去的時候就潔淨了。',
    '路17:15 內中有一個見自己已經好了，就回來大聲歸榮耀與神，',
    '路17:16 又俯伏在耶穌腳前感謝他；這人是撒瑪利亞人。',
    '路17:17 耶穌說：潔淨了的不是十個人嗎﹖那九個在哪裡呢﹖',
    '路17:18 除了這外族人，再沒有別人回來歸榮耀與神嗎﹖',
    '路17:19 就對那人說：起來，走吧！你的信救了你了。',
    '路17:20 法利賽人問：神的國幾時來到﹖耶穌回答說：神的國來到不是眼所能見的。',
    '路17:21 人也不得說：看哪，在這裡！看哪，在那裡！因為神的國就在你們心裡（心裡：或作中間）。',
    '路17:22 他又對門徒說：日子將到，你們巴不得看見人子的一個日子，卻不得看見。',
    '路17:23 人將要對你們說：看哪，在那裡！看哪，在這裡！你們不要出去，也不要跟隨他們！',
    '路17:24 因為人子在他降臨的日子，好像閃電從天這邊一閃直照到天那邊。',
    '路17:25 只是他必須先受許多苦，又被這世代棄絕。',
    '路17:26 挪亞的日子怎樣，人子的日子也要怎樣。',
    '路17:27 那時候的人又吃又喝，又娶又嫁，到挪亞進方舟的那日，洪水就來，把他們全都滅了。',
    '路17:28 又好像羅得的日子；人又吃又喝，又買又賣，又耕種又蓋造。',
    '路17:29 到羅得出所多瑪的那日，就有火與硫磺從天上降下來，把他們全都滅了。',
    '路17:30 人子顯現的日子也要這樣。',
    '路17:31 當那日，人在房上，器具在屋裡，不要下來拿；人在田裡，也不要回家。',
    '路17:32 你們要回想羅得的妻子。',
    '路17:33 凡想要保全生命的，必喪掉生命；凡喪掉生命的，必救活生命。',
    '路17:34 我對你們說，當那一夜，兩個人在一個床上，要取去一個，撇下一個。',
    '路17:35 兩個女人一同推磨；要取去一個，撇下一個。（有古卷在此有：',
    '路17:36 兩個人在田裡，要取去一個，撇下一個。）',
    '路17:37 門徒說：主啊，在哪裡有這事呢﹖耶穌說：屍首在哪裡，鷹也必聚在那裡。',
    '路18:1 耶穌設一個比喻，是要人常常禱告，不可灰心。',
    '路18:2 說：某城裡有一個官，不懼怕神，也不尊重世人。',
    '路18:3 那城裡有個寡婦，常到他那裡，說：我有一個對頭，求你給我伸冤。',
    '路18:4 他多日不准。後來心裡說：我雖不懼怕神，也不尊重世人，',
    '路18:5 只因這寡婦煩擾我，我就給他伸冤吧，免得他常來纏磨我！',
    '路18:6 主說：你們聽這不義之官所說的話。',
    '路18:7 神的選民晝夜呼籲他，他縱然為他們忍了多時，豈不終久給他們伸冤嗎﹖',
    '路18:8 我告訴你們，要快快的給他們伸冤了。然而，人子來的時候，遇得見世上有信德嗎﹖',
    '路18:9 耶穌向那些仗著自己是義人，藐視別人的，設一個比喻，',
    '路18:10 說：有兩個人上殿裡去禱告：一個是法利賽人，一個是稅吏。',
    '路18:11 法利賽人站著，自言自語的禱告說：神啊，我感謝你，我不像別人勒索、不義、姦淫，也不像這個稅吏。',
    '路18:12 我一個禮拜禁食兩次，凡我所得的都捐上十分之一。',
    '路18:13 那稅吏遠遠的站著，連舉目望天也不敢，只捶著胸說：神啊，開恩可憐我這個罪人！',
    '路18:14 我告訴你們，這人回家去比那人倒算為義了；因為，凡自高的，必降為卑；自卑的，必升為高。',
    '路18:15 有人抱著自己的嬰孩來見耶穌，要他摸他們；門徒看見就責備那些人。',
    '路18:16 耶穌卻叫他們來，說：讓小孩子到我這裡來，不要禁止他們；因為在神國的正是這樣的人。',
    '路18:17 我實在告訴你們，凡要承受神國的，若不像小孩子，斷不能進去。',
    '路18:18 有一個官問耶穌說：良善的夫子，我該做什麼事才可以承受永生﹖',
    '路18:19 耶穌對他說：你為什麼稱我是良善的﹖除了神一位之外，再沒有良善的。',
    '路18:20 誡命你是曉得的：不可姦淫；不可殺人；不可偷盜；不可作假見證；當孝敬父母。',
    '路18:21 那人說：這一切我從小都遵守了。',
    '路18:22 耶穌聽見了，就說：你還缺少一件：要變賣你一切所有的，分給窮人，就必有財寶在天上；你還要來跟從我。',
    '路18:23 他聽見這話，就甚憂愁，因為他很富足。',
    '路18:24 耶穌看見他，就說：有錢財的人進神的國是何等的難哪！',
    '路18:25 駱駝穿過針的眼比財主進神的國還容易呢！',
    '路18:26 聽見的人說：這樣，誰能得救呢﹖',
    '路18:27 耶穌說：在人所不能的事，在神卻能。',
    '路18:28 彼得說：看哪，我們已經撇下自己所有的跟從你了。',
    '路18:29 耶穌說：我實在告訴你們，人為神的國撇下房屋，或是妻子、弟兄、父母、兒女，',
    '路18:30 沒有在今世不得百倍，在來世不得永生的。',
    '路18:31 耶穌帶著十二個門徒，對他們說：看哪，我們上耶路撒冷去，先知所寫的一切事都要成就在人子身上。',
    '路18:32 他將要被交給外邦人，他們要戲弄他，凌辱他，吐唾沫在他臉上，',
    '路18:33 並要鞭打他，殺害他；第三日他要復活。',
    '路18:34 這些事門徒一樣也不懂得，意思乃是隱藏的；他們不曉得所說的是什麼。',
    '路18:35 耶穌將近耶利哥的時候，有一個瞎子坐在路旁討飯。',
    '路18:36 聽見許多人經過，就問是什麼事。',
    '路18:37 他們告訴他，是拿撒勒人耶穌經過。',
    '路18:38 他就呼叫說：大衛的子孫耶穌啊，可憐我吧！',
    '路18:39 在前頭走的人就責備他，不許他作聲；他卻越發喊叫說：大衛的子孫，可憐我吧！',
    '路18:40 耶穌站住，吩咐把他領過來，到了跟前，就問他說：',
    '路18:41 你要我為你做什麼﹖他說：主啊，我要能看見。',
    '路18:42 耶穌說：你可以看見！你的信救了你了。',
    '路18:43 瞎子立刻看見了，就跟隨耶穌，一路歸榮耀與神。眾人看見這事，也讚美神。',
    '路19:1 耶穌進了耶利哥，正經過的時候，',
    '路19:2 有一個人名叫撒該，作稅吏長，是個財主。',
    '路19:3 他要看看耶穌是怎樣的人；只因人多，他的身量又矮，所以不得看見，',
    '路19:4 就跑到前頭，爬上桑樹，要看耶穌，因為耶穌必從那裡經過。',
    '路19:5 耶穌到了那裡，擡頭一看，對他說：撒該，快下來！今天我必住在你家裡。',
    '路19:6 他就急忙下來，歡歡喜喜的接待耶穌。',
    '路19:7 眾人看見，都私下議論說：他竟到罪人家裡去住宿。',
    '路19:8 撒該站著對主說：主啊，我把所有的一半給窮人；我若訛詐了誰，就還他四倍。',
    '路19:9 耶穌說：今天救恩到了這家，因為他也是亞伯拉罕的子孫。',
    '路19:10 人子來，為要尋找，拯救失喪的人。',
    '路19:11 眾人正在聽見這些話的時候，耶穌因為將近耶路撒冷，又因他們以為神的國快要顯出來，就另設一個比喻，說：',
    '路19:12 有一個貴冑往遠方去，要得國回來，',
    '路19:13 便叫了他的十個僕人來，交給他們十錠（錠：原文作彌拿約銀十兩）銀子，說：你們去做生意，直等我回來。',
    '路19:14 他本國的人卻恨他，打發使者隨後去，說：我們不願意這個人作我們的王。',
    '路19:15 他既得國回來，就吩咐叫那領銀子的僕人來，要知道他們做生意賺了多少。',
    '路19:16 頭一個上來，說：主啊，你的一錠銀子已經賺了十錠。',
    '路19:17 主人說：好！良善的僕人，你既在最小的事上有忠心，可以有權柄管十座城。',
    '路19:18 第二個來，說：主啊！你的一錠銀子，已經賺了五錠。',
    '路19:19 主人說：你也可以管五座城。',
    '路19:20 又有一個來說：主啊，看哪，你的一錠銀子在這裡，我把他包在手巾裡存著。',
    '路19:21 我原是怕你，因為你是嚴厲的人；沒有放下的，還要去拿；沒有種下的，還要去收。',
    '路19:22 主人對他說：你這惡僕，我要憑你的口定你的罪。你既知道我是嚴厲的人，沒有放下的，還要去拿，沒有種下的，還要去收，',
    '路19:23 為什麼不把我的銀子交給銀行，等我來的時候，連本帶利都可以要回來呢﹖',
    '路19:24 就對旁邊站著的人說：奪過他這一錠來，給那有十錠的。',
    '路19:25 他們說：主啊，他已經有十錠了。',
    '路19:26 主人說：我告訴你們，凡有的，還要加給他；沒有的，連他所有的也要奪過來。',
    '路19:27 至於我那些仇敵，不要我作他們王的，把他們拉來，在我面前殺了吧！',
    '路19:28 耶穌說完了這話，就在前面走，上耶路撒冷去。',
    '路19:29 將近伯法其和伯大尼，在一座山名叫橄欖山那裡，就打發兩個門徒，說：',
    '路19:30 你們往對面村子裡去，進去的時候，必看見一匹驢駒拴在那裡，是從來沒有人騎過的，可以解開牽來。',
    '路19:31 若有人問為什麼解他，你們就說：主要用他。',
    '路19:32 打發的人去了，所遇見的正如耶穌所說的。',
    '路19:33 他們解驢駒的時候，主人問他們說：解驢駒做什麼﹖',
    '路19:34 他們說：主要用他。',
    '路19:35 他們牽到耶穌那裡，把自己的衣服搭在上面，扶著耶穌騎上。',
    '路19:36 走的時候，眾人把衣服鋪在路上。',
    '路19:37 將近耶路撒冷，正下橄欖山的時候，眾門徒因所見過的一切異能，都歡樂起來，大聲讚美神，',
    '路19:38 說：奉主名來的王是應當稱頌的！在天上有和平；在至高之處有榮光。',
    '路19:39 眾人中有幾個法利賽人對耶穌說：夫子，責備你的門徒吧！',
    '路19:40 耶穌說：我告訴你們，若是他們閉口不說，這些石頭必要呼叫起來。',
    '路19:41 耶穌快到耶路撒冷，看見城，就為他哀哭，',
    '路19:42 說：巴不得你在這日子知道關係你平安的事；無奈這事現在是隱藏的，叫你的眼看不出來。',
    '路19:43 因為日子將到，你的仇敵必築起土壘，周圍環繞你，四面困住你，',
    '路19:44 並要掃滅你和你裡頭的兒女，連一塊石頭也不留在石頭上，因你不知道眷顧你的時候。',
    '路19:45 耶穌進了殿，趕出裡頭做買賣的人，',
    '路19:46 對他們說：經上說：我的殿必作禱告的殿，你們倒使他成為賊窩了。',
    '路19:47 耶穌天天在殿裡教訓人。祭司長和文士與百姓的尊長都想要殺他，',
    '路19:48 但尋不出法子來，因為百姓都側耳聽他。',
    '路20:1 有一天，耶穌在殿裡教訓百姓，講福音的時候，祭司長和文士並長老上前來，',
    '路20:2 問他說：你告訴我們，你仗著什麼權柄做這些事﹖給你這權柄的是誰呢﹖',
    '路20:3 耶穌回答說：我也要問你們一句話，你們且告訴我。',
    '路20:4 約翰的洗禮是從天上來的﹖是從人間來的呢﹖',
    '路20:5 他們彼此商議說：我們若說從天上來，他必說：你們為什麼不信他呢﹖',
    '路20:6 若說從人間來，百姓都要用石頭打死我們，因為他們信約翰是先知。',
    '路20:7 於是回答說：不知道是從哪裡來的。',
    '路20:8 耶穌說：我也不告訴你們，我仗著什麼權柄做這些事。',
    '路20:9 耶穌就設比喻對百姓說：有人栽了一個葡萄園，租給園戶，就往外國去住了許久。',
    '路20:10 到了時候，打發一個僕人到園戶那裡去，叫他們把園中當納的果子交給他；園戶竟打了他，叫他空手回去。',
    '路20:11 又打發一個僕人去，他們也打了他，並且凌辱他，叫他空手回去。',
    '路20:12 又打發第三個僕人去，他們也打傷了他，把他推出去了。',
    '路20:13 園主說：我怎麼辦呢﹖我要打發我的愛子去，或者他們尊敬他。',
    '路20:14 不料，園戶看見他，就彼此商量說：這是承受產業的，我們殺他吧，使產業歸於我們！',
    '路20:15 於是把他推出葡萄園外，殺了。這樣，葡萄園的主人要怎樣處治他們呢﹖',
    '路20:16 他要來除滅這些園戶，將葡萄園轉給別人。聽見的人說：這是萬不可的！',
    '路20:17 耶穌看著他們說：經上記著：匠人所棄的石頭已作了房角的頭塊石頭。這是什麼意思呢﹖',
    '路20:18 凡掉在那石頭上的，必要跌碎；那石頭掉在誰的身上，就要把誰砸得稀爛。',
    '路20:19 文士和祭司長看出這比喻是指著他們說的，當時就想要下手拿他，只是懼怕百姓。',
    '路20:20 於是窺探耶穌，打發奸細裝作好人，要在他的話上得把柄，好將他交在巡撫的政權之下。',
    '路20:21 奸細就問耶穌說：夫子，我們曉得你所講所傳都是正道，也不取人的外貌，乃是誠誠實實傳神的道。',
    '路20:22 我們納稅給該撒，可以不可以﹖',
    '路20:23 耶穌看出他們的詭詐，就對他們說：',
    '路20:24 拿一個銀錢來給我看。這像和這號是誰的﹖他們說：是該撒的。',
    '路20:25 耶穌說：這樣，該撒的物當歸給該撒，神的物當歸給神。',
    '路20:26 他們當著百姓，在這話上得不著把柄，又希奇他的應對，就閉口無言了。',
    '路20:27 撒都該人常說沒有復活的事。有幾個來問耶穌說：',
    '路20:28 夫子！摩西為我們寫著說：人若有妻無子就死了，他兄弟當娶他的妻，為哥哥生子立後。',
    '路20:29 有弟兄七人，第一個娶了妻，沒有孩子死了；',
    '路20:30 第二個、第三個也娶過他；',
    '路20:31 那七個人都娶過他，沒有留下孩子就死了。',
    '路20:32 後來婦人也死了。',
    '路20:33 這樣，當復活的時候，他是哪一個的妻子呢﹖因為他們七個人都娶過他。',
    '路20:34 耶穌說：這世界的人有娶有嫁；',
    '路20:35 惟有算為配得那世界，與從死裡復活的人也不娶也不嫁；',
    '路20:36 因為他們不能再死，和天使一樣；既是復活的人，就為神的兒子。',
    '路20:37 至於死人復活，摩西在荊棘篇上，稱主是亞伯拉罕的神，以撒的神，雅各的神，就指示明白了。',
    '路20:38 神原不是死人的神，乃是活人的神；因為在他那裡（那裡：或作看來），人都是活的。',
    '路20:39 有幾個文士說：夫子！你說得好。',
    '路20:40 以後他們不敢再問他什麼。',
    '路20:41 耶穌對他們說：人怎麼說基督是大衛的子孫呢﹖',
    '路20:42 詩篇上大衛自己說：主對我主說：你坐在我的右邊，',
    '路20:43 等我使你仇敵作你的腳凳。',
    '路20:44 大衛既稱他為主，他怎麼又是大衛的子孫呢﹖',
    '路20:45 眾百姓聽的時候，耶穌對門徒說：',
    '路20:46 你們要防備文士。他們好穿長衣遊行，喜愛人在街市上問他們安，又喜愛會堂裡的高位，筵席上的首座；',
    '路20:47 他們侵吞寡婦的家產，假意作很長的禱告。這些人要受更重的刑罰！',
    '路21:1 耶穌擡頭觀看，見財主把捐項投在庫裡，',
    '路21:2 又見一個窮寡婦投了兩個小錢，',
    '路21:3 就說：我實在告訴你們，這窮寡婦所投的比眾人還多；',
    '路21:4 因為眾人都是自己有餘，拿出來投在捐項裡，但這寡婦是自己不足，把他一切養生的都投上了。',
    '路21:5 有人談論聖殿是用美石和供物妝飾的；',
    '路21:6 耶穌就說：論到你們所看見的這一切，將來日子到了，在這裡沒有一塊石頭留在石頭上，不被拆毀了。',
    '路21:7 他們問他說：夫子！什麼時候有這事呢﹖這事將到的時候有什麼預兆呢﹖',
    '路21:8 耶穌說：你們要謹慎，不要受迷惑；因為將來有好些人冒我的名來，說：我是基督，又說：時候近了，你們不要跟從他們！',
    '路21:9 你們聽見打仗和擾亂的事，不要驚惶；因為這些事必須先有，只是末期不能立時就到。',
    '路21:10 當時，耶穌對他們說：民要攻打民，國要攻打國；',
    '路21:11 地要大大震動，多處必有饑荒、瘟疫，又有可怕的異象和大神蹟從天上顯現。',
    '路21:12 但這一切的事以先，人要下手拿住你們，逼迫你們，把你們交給會堂，並且收在監裡，又為我的名拉你們到君王諸侯面前。',
    '路21:13 但這些事終必為你們的見證。',
    '路21:14 所以，你們當立定心意，不要預先思想怎樣分訴；',
    '路21:15 因為我必賜你們口才、智慧，是你們一切敵人所敵不住、駁不倒的。',
    '路21:16 連你們的父母、弟兄、親族、朋友也要把你們交官；你們也有被他們害死的。',
    '路21:17 你們要為我的名被眾人恨惡，',
    '路21:18 然而，你們連一根頭髮也必不損壞。',
    '路21:19 你們常存忍耐，就必保全靈魂（或作：必得生命）。',
    '路21:20 你們看見耶路撒冷被兵圍困，就可知道他成荒場的日子近了。',
    '路21:21 那時，在猶太的應當逃到山上；在城裡的應當出來；在鄉下的不要進城；',
    '路21:22 因為這是報應的日子，使經上所寫的都得應驗。',
    '路21:23 當那些日子，懷孕的和奶孩子的有禍了！因為將有大災難降在這地方，也有震怒臨到這百姓。',
    '路21:24 他們要倒在刀下，又被擄到各國去。耶路撒冷要被外邦人踐踏，直到外邦人的日期滿了。',
    '路21:25 日、月、星辰要顯出異兆，地上的邦國也有困苦；因海中波浪的響聲，就慌慌不定。',
    '路21:26 天勢都要震動，人想起那將要臨到世界的事，就都嚇得魂不附體。',
    '路21:27 那時，他們要看見人子有能力，有大榮耀駕雲降臨。',
    '路21:28 一有這些事，你們就當挺身昂首，因為你們得贖的日子近了。',
    '路21:29 耶穌又設比喻對他們說：你們看無花果樹和各樣的樹；他發芽的時候，你們一看見，自然曉得夏天近了。',
    '路21:30 併於上節。',
    '路21:31 這樣，你們看見這些事漸漸的成就，也該曉得神的國近了。',
    '路21:32 我實在告訴你們，這世代還沒有過去，這些事都要成就。',
    '路21:33 天地要廢去，我的話卻不能廢去。',
    '路21:34 你們要謹慎，恐怕因貪食、醉酒，並今生的思慮累住你們的心，那日子就如同網羅忽然臨到你們；',
    '路21:35 因為那日子要這樣臨到全地上一切居住的人。',
    '路21:36 你們要時時警醒，常常祈求，使你們能逃避這一切要來的事，得以站立在人子面前。',
    '路21:37 耶穌每日在殿裡教訓人，每夜出城在一座山，名叫橄欖山住宿。',
    '路21:38 眾百姓清早上聖殿，到耶穌那裡，要聽他講道。',
    '路22:1 除酵節，又名逾越節，近了。',
    '路22:2 祭司長和文士想法子怎麼才能殺害耶穌，是因他們懼怕百姓。',
    '路22:3 這時，撒但入了那稱為加略人猶大的心；他本是十二門徒裡的一個。',
    '路22:4 他去和祭司長並守殿官商量，怎麼可以把耶穌交給他們。',
    '路22:5 他們歡喜，就約定給他銀子。',
    '路22:6 他應允了，就找機會，要趁眾人不在跟前的時候把耶穌交給他們。',
    '路22:7 除酵節，須宰逾越羊羔的那一天到了。',
    '路22:8 耶穌打發彼得、約翰，說：你們去為我們預備逾越節的筵席，好叫我們吃。',
    '路22:9 他們問他說：要我們在哪裡預備﹖',
    '路22:10 耶穌說：你們進了城，必有人拿著一瓶水迎面而來，你們就跟著他，到他所進的房子裡去，',
    '路22:11 對那家的主人說：夫子說：客房在哪裡﹖我與門徒好在那裡吃逾越節的筵席。',
    '路22:12 他必指給你們擺設整齊的一間大樓，你們就在那裡預備。',
    '路22:13 他們去了，所遇見的正如耶穌所說的；他們就預備了逾越節的筵席。',
    '路22:14 時候到了，耶穌坐席，使徒也和他同坐。',
    '路22:15 耶穌對他們說：我很願意在受害以先和你們吃這逾越節的筵席。',
    '路22:16 我告訴你們，我不再吃這筵席，直到成就在神的國裡。',
    '路22:17 耶穌接過杯來，祝謝了，說：你們拿這個，大家分著喝。',
    '路22:18 我告訴你們，從今以後，我不再喝這葡萄汁，直等神的國來到。',
    '路22:19 又拿起餅來，祝謝了，就擘開，遞給他們，說：這是我的身體，為你們捨的，你們也應當如此行，為的是記念我。',
    '路22:20 飯後也照樣拿起杯來，說：這杯是用我血所立的新約，是為你們流出來的。',
    '路22:21 看哪！那賣我之人的手與我一同在桌子上。',
    '路22:22 人子固然要照所預定的去世，但賣人子的人有禍了！',
    '路22:23 他們就彼此對問，是哪一個要做這事。',
    '路22:24 門徒起了爭論，他們中間哪一個可算為大。',
    '路22:25 耶穌說：外邦人有君王為主治理他們，那掌權管他們的稱為恩主。',
    '路22:26 但你們不可這樣；你們裡頭為大的，倒要像年幼的；為首領的，倒要像服事人的。',
    '路22:27 是誰為大﹖是坐席的呢﹖是服事人的呢﹖不是坐席的大嗎﹖然而，我在你們中間如同服事人的。',
    '路22:28 我在磨煉之中，常和我同在的就是你們。',
    '路22:29 我將國賜給你們，正如我父賜給我一樣，',
    '路22:30 叫你們在我國裡，坐在我的席上吃喝，並且坐在寶座上，審判以色列十二個支派。',
    '路22:31 主又說：西門！西門！撒但想要得著你們，好篩你們像篩麥子一樣；',
    '路22:32 但我已經為你祈求，叫你不至於失了信心，你回頭以後，要堅固你的弟兄。',
    '路22:33 彼得說：主啊，我就是同你下監，同你受死，也是甘心！',
    '路22:34 耶穌說：彼得，我告訴你，今日雞還沒有叫，你要三次說不認得我。',
    '路22:35 耶穌又對他們說：我差你們出去的時候，沒有錢囊，沒有口袋，沒有鞋，你們缺少什麼沒有﹖他們說：沒有。',
    '路22:36 耶穌說：但如今有錢囊的可以帶著，有口袋的也可以帶著，沒有刀的要賣衣服買刀。',
    '路22:37 我告訴你們，經上寫著說：他被列在罪犯之中。這話必應驗在我身上；因為那關係我的事必然成就。',
    '路22:38 他們說：主啊，請看！這裡有兩把刀。耶穌說：夠了。',
    '路22:39 耶穌出來，照常往橄欖山去，門徒也跟隨他。',
    '路22:40 到了那地方，就對他們說：你們要禱告，免得入了迷惑。',
    '路22:41 於是離開他們約有扔一塊石頭那麼遠，跪下禱告，',
    '路22:42 說：父啊！你若願意，就把這杯撤去；然而，不要成就我的意思，只要成就你的意思。',
    '路22:43 有一位天使從天上顯現，加添他的力量。',
    '路22:44 耶穌極其傷痛，禱告更加懇切，汗珠如大血點滴在地上。',
    '路22:45 禱告完了，就起來，到門徒那裡，見他們因為憂愁都睡著了，',
    '路22:46 就對他們說：你們為什麼睡覺呢﹖起來禱告，免得入了迷惑！',
    '路22:47 說話之間，來了許多人。那十二個門徒裡名叫猶大的，走在前頭，就近耶穌，要與他親嘴。',
    '路22:48 耶穌對他說：猶大！你用親嘴的暗號賣人子嗎﹖',
    '路22:49 左右的人見光景不好，就說：主啊！我們拿刀砍可以不可以﹖',
    '路22:50 內中有一個人把大祭司的僕人砍了一刀，削掉了他的右耳。',
    '路22:51 耶穌說：到了這個地步，由他們吧！就摸那人的耳朵，把他治好了。',
    '路22:52 耶穌對那些來拿他的祭司長和守殿官並長老說：你們帶著刀棒出來拿我，如同拿強盜嗎﹖',
    '路22:53 我天天同你們在殿裡，你們不下手拿我。現在卻是你們的時候，黑暗掌權了。',
    '路22:54 他們拿住耶穌，把他帶到大祭司的宅裡。彼得遠遠的跟著。',
    '路22:55 他們在院子裡生了火，一同坐著；彼得也坐在他們中間。',
    '路22:56 有一個使女看見彼得坐在火光裡，就定睛看他，說：這個人素來也是同那人一夥的。',
    '路22:57 彼得卻不承認，說：女子，我不認得他。',
    '路22:58 過了不多的時候，又有一個人看見他，說：你也是他們一黨的。彼得說：你這個人！我不是。',
    '路22:59 約過了一小時，又有一個人極力的說：他實在是同那人一夥的，因為他也是加利利人。',
    '路22:60 彼得說：你這個人！我不曉得你說的是什麼！正說話之間，雞就叫了。',
    '路22:61 主轉過身來看彼得。彼得便想起主對他所說的話：今日雞叫以先，你要三次不認我。',
    '路22:62 他就出去痛哭。',
    '路22:63 看守耶穌的人戲弄他，打他，',
    '路22:64 又蒙著他的眼，問他說：你是先知，告訴我們打你的是誰﹖',
    '路22:65 他們還用許多別的話辱罵他。',
    '路22:66 天一亮，民間的眾長老連祭司長帶文士都聚會，把耶穌帶到他們的公會裡，',
    '路22:67 說：你若是基督，就告訴我們。耶穌說：我若告訴你們，你們也不信；',
    '路22:68 我若問你們，你們也不回答。',
    '路22:69 從今以後，人子要坐在神權能的右邊。',
    '路22:70 他們都說：這樣，你是神的兒子嗎﹖耶穌說：你們所說的是。',
    '路22:71 他們說：何必再用見證呢﹖他親口所說的，我們都親自聽見了。',
    '路23:1 眾人都起來，把耶穌解到彼拉多面前，',
    '路23:2 就告他說：我們見這人誘惑國民，禁止納稅給該撒，並說自己是基督，是王。',
    '路23:3 彼拉多問耶穌說：你是猶太人的王嗎﹖耶穌回答說：你說的是。',
    '路23:4 彼拉多對祭司長和眾人說：我查不出這人有什麼罪來。',
    '路23:5 但他們越發極力的說：他煽惑百姓，在猶太遍地傳道，從加利利起，直到這裡了。',
    '路23:6 彼拉多一聽見，就問：這人是加利利人嗎﹖',
    '路23:7 既曉得耶穌屬希律所管，就把他送到希律那裡去。那時希律正在耶路撒冷。',
    '路23:8 希律看見耶穌，就很歡喜；因為聽見過他的事，久已想要見他，並且指望看他行一件神蹟。',
    '路23:9 於是問他許多的話；耶穌卻一言不答。',
    '路23:10 祭司長和文士都站著，極力的告他。',
    '路23:11 希律和他的兵丁就藐視耶穌，戲弄他，給他穿上華麗衣服，把他送回彼拉多那裡去。',
    '路23:12 從前希律和彼拉多彼此有仇，在那一天就成了朋友。',
    '路23:13 彼拉多傳齊了祭司長和官府並百姓，',
    '路23:14 就對他們說：你們解這人到我這裡，說他是誘惑百姓的。看哪，我也曾將你們告他的事，在你們面前審問他，並沒有查出他什麼罪來；',
    '路23:15 就是希律也是如此，所以把他送回來。可見他沒有做什麼該死的事。',
    '路23:16 故此，我要責打他，把他釋放了。（有古卷在此有：',
    '路23:17 每逢這節期，巡撫必須釋放一個囚犯給他們。）',
    '路23:18 眾人卻一齊喊著說：除掉這個人！釋放巴拉巴給我們！',
    '路23:19 這巴拉巴是因在城裡作亂殺人，下在監裡的。',
    '路23:20 彼拉多願意釋放耶穌，就又勸解他們。',
    '路23:21 無奈他們喊著說：釘他十字架！釘他十字架！',
    '路23:22 彼拉多第三次對他們說：為什麼呢﹖這人做了什麼惡事呢﹖我並沒有查出他什麼該死的罪來。所以，我要責打他，把他釋放了。',
    '路23:23 他們大聲催逼彼拉多，求他把耶穌釘在十字架上。他們的聲音就得了勝。',
    '路23:24 彼拉多這才照他們所求的定案，',
    '路23:25 把他們所求的那作亂殺人、下在監裡的釋放了，把耶穌交給他們，任憑他們的意思行。',
    '路23:26 帶耶穌去的時候，有一個古利奈人西門，從鄉下來；他們就抓住他，把十字架擱在他身上，叫他背著跟隨耶穌。',
    '路23:27 有許多百姓跟隨耶穌，內中有好些婦女；婦女們為他號咷痛哭。',
    '路23:28 耶穌轉身對他們說：耶路撒冷的女子，不要為我哭，當為自己和自己的兒女哭。',
    '路23:29 因為日子要到，人必說：不生育的，和未曾懷胎的，未曾乳養嬰孩的，有福了！',
    '路23:30 那時，人要向大山說：倒在我們身上！向小山說：遮蓋我們！',
    '路23:31 這些事既行在有汁水的樹上，那枯乾的樹將來怎麼樣呢﹖',
    '路23:32 又有兩個犯人，和耶穌一同帶來處死。',
    '路23:33 到了一個地方，名叫髑髏地，就在那裡把耶穌釘在十字架上，又釘了兩個犯人：一個在左邊，一個在右邊。',
    '路23:34 當下耶穌說：父啊！赦免他們；因為他們所做的，他們不曉得。兵丁就拈鬮分他的衣服。',
    '路23:35 百姓站在那裡觀看。官府也嗤笑他，說：他救了別人；他若是基督，神所揀選的，可以救自己吧！',
    '路23:36 兵丁也戲弄他，上前拿醋送給他喝，',
    '路23:37 說：你若是猶太人的王，可以救自己吧！',
    '路23:38 在耶穌以上有一個牌子（有古卷在此有：用希利尼、羅馬、希伯來的文字）寫著：這是猶太人的王。',
    '路23:39 那同釘的兩個犯人有一個譏誚他，說：你不是基督嗎﹖可以救自己和我們吧！',
    '路23:40 那一個就應聲責備他，說：你既是一樣受刑的，還不怕神嗎﹖',
    '路23:41 我們是應該的，因我們所受的與我們所做的相稱，但這個人沒有做過一件不好的事。',
    '路23:42 就說：耶穌啊，你得國降臨的時候，求你記念我！',
    '路23:43 耶穌對他說：我實在告訴你，今日你要同我在樂園裡了。',
    '路23:44 那時約有午正，遍地都黑暗了，直到申初，',
    '路23:45 日頭變黑了；殿裡的幔子從當中裂為兩半。',
    '路23:46 耶穌大聲喊著說：父啊！我將我的靈魂交在你手裡。說了這話，氣就斷了。',
    '路23:47 百夫長看見所成的事，就歸榮耀與神，說：這真是個義人！',
    '路23:48 聚集觀看的眾人見了這所成的事都捶著胸回去了。',
    '路23:49 還有一切與耶穌熟識的人，和從加利利跟著他來的婦女們，都遠遠的站著看這些事。',
    '路23:50 有一個人名叫約瑟，是個議士，為人善良公義；',
    '路23:51 眾人所謀所為，他並沒有附從。他本是猶太、亞利馬太城裡素常盼望神國的人。',
    '路23:52 這人去見彼拉多，求耶穌的身體，',
    '路23:53 就取下來，用細麻布裹好，安放在石頭鑿成的墳墓裡；那裡頭從來沒有葬過人。',
    '路23:54 那日是預備日，安息日也快到了。',
    '路23:55 那些從加利利和耶穌同來的婦女跟在後面，看見了墳墓和他的身體怎樣安放。',
    '路23:56 他們就回去，預備了香料香膏。他們在安息日，便遵著誡命安息了。',
    '路24:1 七日的頭一日，黎明的時候，那些婦女帶著所預備的香料來到墳墓前，',
    '路24:2 看見石頭已經從墳墓滾開了，',
    '路24:3 他們就進去，只是不見主耶穌的身體。',
    '路24:4 正在猜疑之間，忽然有兩個人站在旁邊，衣服放光。',
    '路24:5 婦女們驚怕，將臉伏地。那兩個人就對他們說：為什麼在死人中找活人呢﹖',
    '路24:6 他不在這裡，已經復活了。當記念他還在加利利的時候怎樣告訴你們，',
    '路24:7 說：人子必須被交在罪人手裡，釘在十字架上，第三日復活。',
    '路24:8 他們就想起耶穌的話來，',
    '路24:9 便從墳墓那裡回去，把這一切事告訴十一個使徒和其餘的人。',
    '路24:10 那告訴使徒的就是抹大拉的馬利亞和約亞拿，並雅各的母親馬利亞，還有與他們在一處的婦女。',
    '路24:11 他們這些話，使徒以為是胡言，就不相信。',
    '路24:12 彼得起來，跑到墳墓前，低頭往裡看，見細麻布獨在一處，就回去了，心裡希奇所成的事。',
    '路24:13 正當那日，門徒中有兩個人往一個村子去；這村子名叫以馬忤斯，離耶路撒冷約有二十五里。',
    '路24:14 他們彼此談論所遇見的這一切事。',
    '路24:15 正談論相問的時候，耶穌親自就近他們，和他們同行；',
    '路24:16 只是他們的眼睛迷糊了，不認識他。',
    '路24:17 耶穌對他們說：你們走路彼此談論的是什麼事呢﹖他們就站住，臉上帶著愁容。',
    '路24:18 二人中有一個名叫革流巴的回答說：你在耶路撒冷作客，還不知道這幾天在那裡所出的事嗎﹖',
    '路24:19 耶穌說：什麼事呢﹖他們說：就是拿撒勒人耶穌的事。他是個先知，在神和眾百姓面前，說話行事都有大能。',
    '路24:20 祭司長和我們的官府竟把他解去，定了死罪，釘在十字架上。',
    '路24:21 但我們素來所盼望、要贖以色列民的就是他！不但如此，而且這事成就，現在已經三天了。',
    '路24:22 再者，我們中間有幾個婦女使我們驚奇；他們清早到了墳墓那裡，',
    '路24:23 不見他的身體，就回來告訴我們，說看見了天使顯現，說他活了。',
    '路24:24 又有我們的幾個人往墳墓那裡去，所遇見的正如婦女們所說的，只是沒有看見他。',
    '路24:25 耶穌對他們說：無知的人哪，先知所說的一切話，你們的心信得太遲鈍了。',
    '路24:26 基督這樣受害，又進入他的榮耀，豈不是應當的嗎﹖',
    '路24:27 於是從摩西和眾先知起，凡經上所指著自己的話都給他們講解明白了。',
    '路24:28 將近他們所去的村子，耶穌好像還要往前行，',
    '路24:29 他們卻強留他，說：時候晚了，日頭已經平西了，請你同我們住下吧！耶穌就進去，要同他們住下。',
    '路24:30 到了坐席的時候，耶穌拿起餅來，祝謝了，擘開，遞給他們。',
    '路24:31 他們的眼睛明亮了，這才認出他來。忽然耶穌不見了。',
    '路24:32 他們彼此說：在路上，他和我們說話，給我們講解聖經的時候，我們的心豈不是火熱的嗎﹖',
    '路24:33 他們就立時起身，回耶路撒冷去，正遇見十一個使徒和他們的同人聚集在一處，',
    '路24:34 說：主果然復活，已經現給西門看了。',
    '路24:35 兩個人就把路上所遇見，和擘餅的時候怎麼被他們認出來的事，都述說了一遍。',
    '路24:36 正說這話的時候，耶穌親自站在他們當中，說：願你們平安！',
    '路24:37 他們卻驚慌害怕，以為所看見的是魂。',
    '路24:38 耶穌說：你們為什麼愁煩﹖為什麼心裡起疑念呢﹖',
    '路24:39 你們看我的手，我的腳，就知道實在是我了。摸我看看！魂無骨無肉，你們看，我是有的。',
    '路24:40 說了這話，就把手和腳給他們看。',
    '路24:41 他們正喜得不敢信，並且希奇；耶穌就說：你們這裡有什麼吃的沒有﹖',
    '路24:42 他們便給他一片燒魚。（有古卷在此有：和一塊蜜房。）',
    '路24:43 他接過來，在他們面前吃了。',
    '路24:44 耶穌對他們說：這就是我從前與你們同在之時所告訴你們的話說：摩西的律法、先知的書，和詩篇上所記的，凡指著我的話都必須應驗。',
    '路24:45 於是耶穌開他們的心竅，使他們能明白聖經，',
    '路24:46 又對他們說：照經上所寫的，基督必受害，第三日從死裡復活，',
    '路24:47 並且人要奉他的名傳悔改、赦罪的道，從耶路撒冷起直傳到萬邦。',
    '路24:48 你們就是這些事的見證。',
    '路24:49 我要將我父所應許的降在你們身上，你們要在城裡等候，直到你們領受從上頭來的能力。',
    '路24:50 耶穌領他們到伯大尼的對面，就舉手給他們祝福。',
    '路24:51 正祝福的時候，他就離開他們，被帶到天上去了。',
    '路24:52 他們就拜他，大大的歡喜，回耶路撒冷去，',
    '路24:53 常在殿裡稱頌神。',
    '約1:1 太初有道，道與神同在，道就是神。',
    '約1:2 這道太初與神同在。',
    '約1:3 萬物是藉著他造的；凡被造的，沒有一樣不是藉著他造的。',
    '約1:4 生命在他裡頭，這生命就是人的光。',
    '約1:5 光照在黑暗裡，黑暗卻不接受光。',
    '約1:6 有一個人，是從神那裡差來的，名叫約翰。',
    '約1:7 這人來，為要作見證，就是為光作見證，叫眾人因他可以信。',
    '約1:8 他不是那光，乃是要為光作見證。',
    '約1:9 那光是真光，照亮一切生在世上的人。',
    '約1:10 他在世界，世界也是藉著他造的，世界卻不認識他。',
    '約1:11 他到自己的地方來，自己的人倒不接待他。',
    '約1:12 凡接待他的，就是信他名的人，他就賜他們權柄，作神的兒女。',
    '約1:13 這等人不是從血氣生的，不是從情慾生的，也不是從人意生的，乃是從神生的。',
    '約1:14 道成了肉身，住在我們中間，充充滿滿的有恩典有真理。我們也見過他的榮光，正是父獨生子的榮光。',
    '約1:15 約翰為他作見證，喊著說：這就是我曾說：那在我以後來的，反成了在我以前的，因他本來在我以前。',
    '約1:16 從他豐滿的恩典裡，我們都領受了，而且恩上加恩。',
    '約1:17 律法本是藉著摩西傳的；恩典和真理都是由耶穌基督來的。',
    '約1:18 從來沒有人看見神，只有在父懷裡的獨生子將他表明出來。',
    '約1:19 約翰所作的見證記在下面：猶太人從耶路撒冷差祭司和利未人到約翰那裡，問他說：你是誰﹖',
    '約1:20 他就明說，並不隱瞞，明說：我不是基督。',
    '約1:21 他們又問他說：這樣，你是誰呢﹖是以利亞嗎﹖他說：我不是。是那先知嗎﹖他回答說：不是。',
    '約1:22 於是他們說：你到底是誰，叫我們好回覆差我們來的人。你自己說，你是誰﹖',
    '約1:23 他說：我就是那在曠野有人聲喊著說：修直主的道路，正如先知以賽亞所說的。',
    '約1:24 那些人是法利賽人差來的（或作：那差來的是法利賽人）；',
    '約1:25 他們就問他說：你既不是基督，不是以利亞，也不是那先知，為什麼施洗呢﹖',
    '約1:26 約翰回答說：我是用水施洗，但有一位站在你們中間，是你們不認識的，',
    '約1:27 就是那在我以後來的，我給他解鞋帶也不配。',
    '約1:28 這是在約但河外伯大尼（有古卷：伯大巴喇），約翰施洗的地方作的見證。',
    '約1:29 次日，約翰看見耶穌來到他那裡，就說：看哪，神的羔羊，除去（或作：背負）世人罪孽的！',
    '約1:30 這就是我曾說：有一位在我以後來、反成了在我以前的，因他本來在我以前。',
    '約1:31 我先前不認識他，如今我來用水施洗，為要叫他顯明給以色列人。',
    '約1:32 約翰又作見證說：我曾看見聖靈，彷彿鴿子從天降下，住在他的身上。',
    '約1:33 我先前不認識他，只是那差我來用水施洗的、對我說：你看見聖靈降下來，住在誰的身上，誰就是用聖靈施洗的。',
    '約1:34 我看見了，就證明這是神的兒子。',
    '約1:35 再次日，約翰同兩個門徒站在那裡。',
    '約1:36 他見耶穌行走，就說：看哪！這是神的羔羊！',
    '約1:37 兩個門徒聽見他的話，就跟從了耶穌。',
    '約1:38 耶穌轉過身來，看見他們跟著，就問他們說：你們要什麼﹖他們說：拉比，在哪裡住﹖（拉比翻出來就是夫子。）',
    '約1:39 耶穌說：你們來看。他們就去看他在哪裡住，這一天便與他同住；那時約有申正了。',
    '約1:40 聽見約翰的話跟從耶穌的那兩個人，一個是西門彼得的兄弟安得烈。',
    '約1:41 他先找著自己的哥哥西門，對他說：我們遇見彌賽亞了。（彌賽亞翻出來就是基督。）',
    '約1:42 於是領他去見耶穌。耶穌看著他，說：你是約翰的兒子西門（約翰在馬太16：17稱約拿），你要稱為磯法。（磯法翻出來就是彼得。）',
    '約1:43 又次日，耶穌想要往加利利去，遇見腓力，就對他說：來跟從我吧。',
    '約1:44 這腓力是伯賽大人，和安得烈、彼得同城。',
    '約1:45 腓力找著拿但業，對他說：摩西在律法上所寫的和眾先知所記的那一位，我們遇見了，就是約瑟的兒子拿撒勒人耶穌。',
    '約1:46 拿但業對他說：拿撒勒還能出什麼好的嗎﹖腓力說：你來看！',
    '約1:47 耶穌看見拿但業來，就指著他說：看哪，這是個真以色列人，他心裡是沒有詭詐的。',
    '約1:48 拿但業對耶穌說：你從哪裡知道我呢﹖耶穌回答說：腓力還沒有招呼你，你在無花果樹底下，我就看見你了。',
    '約1:49 拿但業說：拉比，你是神的兒子，你是以色列的王！',
    '約1:50 耶穌對他說：因為我說在無花果樹底下看見你，你就信嗎﹖你將要看見比這更大的事；',
    '約1:51 又說：我實實在在的告訴你們，你們將要看見天開了，神的使者上去下來在人子身上。',
    '約2:1 第三日，在加利利的迦拿有娶親的筵席，耶穌的母親在那裡。',
    '約2:2 耶穌和他的門徒也被請去赴席。',
    '約2:3 酒用盡了，耶穌的母親對他說：他們沒有酒了。',
    '約2:4 耶穌說：母親（原文作婦人），我與你有什麼相干﹖我的時候還沒有到。',
    '約2:5 他母親對用人說：他告訴你們什麼，你們就做什麼。',
    '約2:6 照猶太人潔淨的規矩，有六口石缸擺在那裡，每口可以盛兩三桶水。',
    '約2:7 耶穌對用人說：把缸倒滿了水。他們就倒滿了，直到缸口。',
    '約2:8 耶穌又說：現在可以舀出來，送給管筵席的。他們就送了去。',
    '約2:9 管筵席的嘗了那水變的酒，並不知道是哪裡來的，只有舀水的用人知道。管筵席的便叫新郎來，',
    '約2:10 對他說：人都是先擺上好酒，等客喝足了，才擺上次的，你倒把好酒留到如今！',
    '約2:11 這是耶穌所行的頭一件神蹟，是在加利利的迦拿行的，顯出他的榮耀來；他的門徒就信他了。',
    '約2:12 這事以後，耶穌與他的母親、弟兄、和門徒都下迦百農去，在那裡住了不多幾日。',
    '約2:13 猶太人的逾越節近了，耶穌就上耶路撒冷去。',
    '約2:14 看見殿裡有賣牛、羊、鴿子的，並有兌換銀錢的人坐在那裡，',
    '約2:15 耶穌就拿繩子做成鞭子，把牛羊都趕出殿去，倒出兌換銀錢之人的銀錢，推翻他們的桌子，',
    '約2:16 又對賣鴿子的說：把這些東西拿去！不要將我父的殿當作買賣的地方。',
    '約2:17 他的門徒就想起經上記著說：我為你的殿心裡焦急，如同火燒。',
    '約2:18 因此猶太人問他說：你既做這些事，還顯什麼神蹟給我們看呢﹖',
    '約2:19 耶穌回答說：你們拆毀這殿，我三日內要再建立起來。',
    '約2:20 猶太人便說：這殿是四十六年才造成的，你三日內就再建立起來嗎﹖',
    '約2:21 但耶穌這話是以他的身體為殿。',
    '約2:22 所以到他從死裡復活以後，門徒就想起他說過這話，便信了聖經和耶穌所說的。',
    '約2:23 當耶穌在耶路撒冷過逾越節的時候，有許多人看見他所行的神蹟，就信了他的名。',
    '約2:24 耶穌卻不將自己交託他們；因為他知道萬人，',
    '約2:25 也用不著誰見證人怎樣，因他知道人心裡所存的。',
    '約3:1 有一個法利賽人，名叫尼哥底母，是猶太人的官。',
    '約3:2 這人夜裡來見耶穌，說：拉比，我們知道你是由神那裡來作師傅的；因為你所行的神蹟，若沒有神同在，無人能行。',
    '約3:3 耶穌回答說：我實實在在的告訴你，人若不重生，就不能見神的國。',
    '約3:4 尼哥底母說：人已經老了，如何能重生呢﹖豈能再進母腹生出來嗎﹖',
    '約3:5 耶穌說：我實實在在的告訴你，人若不是從水和聖靈生的，就不能進神的國。',
    '約3:6 從肉身生的就是肉身；從靈生的就是靈。',
    '約3:7 我說：你們必須重生，你不要以為希奇。',
    '約3:8 風隨著意思吹，你聽見風的響聲，卻不曉得從哪裡來，往哪裡去；凡從聖靈生的，也是如此。',
    '約3:9 尼哥底母問他說：怎能有這事呢﹖',
    '約3:10 耶穌回答說：你是以色列人的先生，還不明白這事嗎﹖',
    '約3:11 我實實在在的告訴你，我們所說的是我們知道的；我們所見證的是我們見過的；你們卻不領受我們的見證。',
    '約3:12 我對你們說地上的事，你們尚且不信，若說天上的事，如何能信呢﹖',
    '約3:13 除了從天降下、仍舊在天的人子，沒有人升過天。',
    '約3:14 摩西在曠野怎樣舉蛇，人子也必照樣被舉起來，',
    '約3:15 叫一切信他的都得永生（或作：叫一切信的人在他裡面得永生）。',
    '約3:16 神愛世人，甚至將他的獨生子賜給他們，叫一切信他的，不致滅亡，反得永生。',
    '約3:17 因為神差他的兒子降世，不是要定世人的罪（或作：審判世人；下同），乃是要叫世人因他得救。',
    '約3:18 信他的人，不被定罪；不信的人，罪已經定了，因為他不信神獨生子的名。',
    '約3:19 光來到世間，世人因自己的行為是惡的，不愛光，倒愛黑暗，定他們的罪就是在此。',
    '約3:20 凡作惡的便恨光，並不來就光，恐怕他的行為受責備。',
    '約3:21 但行真理的必來就光，要顯明他所行的是靠神而行。',
    '約3:22 這事以後，耶穌和門徒到了猶太地，在那裡居住，施洗。',
    '約3:23 約翰在靠近撒冷的哀嫩也施洗；因為那裡水多，眾人都去受洗。',
    '約3:24 那時約翰還沒有下在監裡。',
    '約3:25 約翰的門徒和一個猶太人辯論潔淨的禮，',
    '約3:26 就來見約翰，說：拉比，從前同你在約但河外、你所見證的那位，現在施洗，眾人都往他那裡去了。',
    '約3:27 約翰說：若不是從天上賜的，人就不能得什麼。',
    '約3:28 我曾說：我不是基督，是奉差遣在他前面的，你們自己可以給我作見證。',
    '約3:29 娶新婦的就是新郎；新郎的朋友站著，聽見新郎的聲音就甚喜樂。故此，我這喜樂滿足了。',
    '約3:30 他必興旺，我必衰微。',
    '約3:31 從天上來的是在萬有之上；從地上來的是屬乎地，他所說的也是屬乎地。從天上來的是在萬有之上。',
    '約3:32 他將所見所聞的見證出來，只是沒有人領受他的見證。',
    '約3:33 那領受他見證的，就印上印，證明神是真的。',
    '約3:34 神所差來的就說神的話，因為神賜聖靈給他是沒有限量的。',
    '約3:35 父愛子，已將萬有交在他手裡。',
    '約3:36 信子的人有永生；不信子的人得不著永生（原文作不得見永生），神的震怒常在他身上。',
    '約4:1 主知道法利賽人聽見他收門徒，施洗，比約翰還多，',
    '約4:2 （其實不是耶穌親自施洗，乃是他的門徒施洗，）',
    '約4:3 他就離了猶太，又往加利利去。',
    '約4:4 必須經過撒瑪利亞，',
    '約4:5 於是到了撒瑪利亞的一座城，名叫敘加，靠近雅各給他兒子約瑟的那塊地。',
    '約4:6 在那裡有雅各井；耶穌因走路困乏，就坐在井旁。那時約有午正。',
    '約4:7 有一個撒瑪利亞的婦人來打水。耶穌對他說：請你給我水喝。',
    '約4:8 （那時門徒進城買食物去了。）',
    '約4:9 撒瑪利亞的婦人對他說：你既是猶太人，怎麼向我一個撒瑪利亞婦人要水喝呢﹖原來猶太人和撒瑪利亞人沒有來往。',
    '約4:10 耶穌回答說：你若知道神的恩賜，和對你說給我水喝的是誰，你必早求他，他也必早給了你活水。',
    '約4:11 婦人說：先生，沒有打水的器具，井又深，你從哪裡得活水呢﹖',
    '約4:12 我們的祖宗雅各將這井留給我們，他自己和兒子並牲畜也都喝這井裡的水，難道你比他還大嗎﹖',
    '約4:13 耶穌回答說：凡喝這水的還要再渴；',
    '約4:14 人若喝我所賜的水就永遠不渴。我所賜的水要在他裡頭成為泉源，直湧到永生。',
    '約4:15 婦人說：先生，請把這水賜給我，叫我不渴，也不用來這麼遠打水。',
    '約4:16 耶穌說：你去叫你丈夫也到這裡來。',
    '約4:17 婦人說：我沒有丈夫。耶穌說：你說沒有丈夫是不錯的。',
    '約4:18 你已經有五個丈夫，你現在有的並不是你的丈夫。你這話是真的。',
    '約4:19 婦人說：先生，我看出你是先知。',
    '約4:20 我們的祖宗在這山上禮拜，你們倒說，應當禮拜的地方是在耶路撒冷。',
    '約4:21 耶穌說：婦人，你當信我。時候將到，你們拜父，也不在這山上，也不在耶路撒冷。',
    '約4:22 你們所拜的，你們不知道；我們所拜的，我們知道，因為救恩是從猶太人出來的。',
    '約4:23 時候將到，如今就是了，那真正拜父的，要用心靈和誠實拜他，因為父要這樣的人拜他。',
    '約4:24 神是個靈（或無個字），所以拜他的必須用心靈和誠實拜他。',
    '約4:25 婦人說：我知道彌賽亞（就是那稱為基督的）要來；他來了，必將一切的事都告訴我們。',
    '約4:26 耶穌說：這和你說話的就是他！',
    '約4:27 當下門徒回來，就希奇耶穌和一個婦人說話；只是沒有人說：你是要什麼﹖或說：你為什麼和他說話﹖',
    '約4:28 那婦人就留下水罐子，往城裡去，對眾人說：',
    '約4:29 你們來看！有一個人將我素來所行的一切事都給我說出來了，莫非這就是基督嗎﹖',
    '約4:30 眾人就出城，往耶穌那裡去。',
    '約4:31 這其間，門徒對耶穌說：拉比，請吃。',
    '約4:32 耶穌說：我有食物吃，是你們不知道的。',
    '約4:33 門徒就彼此對問說：莫非有人拿什麼給他吃嗎﹖',
    '約4:34 耶穌說：我的食物就是遵行差我來者的旨意，做成他的工。',
    '約4:35 你們豈不說到收割的時候還有四個月嗎﹖我告訴你們，舉目向田觀看，莊稼已經熟了（原文是發白），可以收割了。',
    '約4:36 收割的人得工價，積蓄五穀到永生，叫撒種的和收割的一同快樂。',
    '約4:37 俗語說：那人撒種，這人收割，這話可見是真的。',
    '約4:38 我差你們去收你們所沒有勞苦的；別人勞苦，你們享受他們所勞苦的。',
    '約4:39 那城裡有好些撒瑪利亞人信了耶穌，因為那婦人作見證說：他將我素來所行的一切事都給我說出來了。',
    '約4:40 於是撒瑪利亞人來見耶穌，求他在他們那裡住下，他便在那裡住了兩天。',
    '約4:41 因耶穌的話，信的人就更多了，',
    '約4:42 便對婦人說：現在我們信，不是因為你的話，是我們親自聽見了，知道這真是救世主。',
    '約4:43 過了那兩天，耶穌離了那地方，往加利利去。',
    '約4:44 因為耶穌自己作過見證說：先知在本地是沒有人尊敬的。',
    '約4:45 到了加利利，加利利人既然看見他在耶路撒冷過節所行的一切事，就接待他，因為他們也是上去過節。',
    '約4:46 耶穌又到了加利利的迦拿，就是他從前變水為酒的地方。有一個大臣，他的兒子在迦百農患病。',
    '約4:47 他聽見耶穌從猶太到了加利利，就來見他，求他下去醫治他的兒子，因為他兒子快要死了。',
    '約4:48 耶穌就對他說：若不看見神蹟奇事，你們總是不信。',
    '約4:49 那大臣說：先生，求你趁著我的孩子還沒有死就下去。',
    '約4:50 耶穌對他說：回去吧，你的兒子活了！那人信耶穌所說的話就回去了。',
    '約4:51 正下去的時候，他的僕人迎見他，說他的兒子活了。',
    '約4:52 他就問什麼時候見好的。他們說：昨日未時熱就退了。',
    '約4:53 他便知道這正是耶穌對他說你兒子活了的時候；他自己和全家就都信了。',
    '約4:54 這是耶穌在加利利行的第二件神蹟，是他從猶太回去以後行的。',
    '約5:1 這事以後，到了猶太人的一個節期，耶穌就上耶路撒冷去。',
    '約5:2 在耶路撒冷，靠近羊門有一個池子，希伯來話叫做畢士大，旁邊有五個廊子；',
    '約5:3 裡面躺著瞎眼的、瘸腿的、血氣枯乾的許多病人。（有古卷在此有：等候水動；',
    '約5:4 因為有天使按時下池子攪動那水，水動之後，誰先下去，無論害什麼病就痊癒了。）',
    '約5:5 在那裡有一個人，病了三十八年。',
    '約5:6 耶穌看見他躺著，知道他病了許久，就問他說：你要痊癒嗎﹖',
    '約5:7 病人回答說：先生，水動的時候，沒有人把我放在池子裡；我正去的時候，就有別人比我先下去。',
    '約5:8 耶穌對他說：起來，拿你的褥子走吧！',
    '約5:9 那人立刻痊癒，就拿起褥子來走了。',
    '約5:10 那天是安息日，所以猶太人對那醫好的人說：今天是安息日，你拿褥子是不可的。',
    '約5:11 他卻回答說：那使我痊癒的，對我說：拿你的褥子走吧。',
    '約5:12 他們問他說：對你說拿褥子走的是什麼人﹖',
    '約5:13 那醫好的人不知道是誰；因為那裡的人多，耶穌已經躲開了。',
    '約5:14 後來耶穌在殿裡遇見他，對他說：你已經痊癒了，不要再犯罪，恐怕你遭遇的更加利害。',
    '約5:15 那人就去告訴猶太人，使他痊癒的是耶穌。',
    '約5:16 所以猶太人逼迫耶穌，因為他在安息日做了這事。',
    '約5:17 耶穌就對他們說：我父做事直到如今，我也做事。',
    '約5:18 所以猶太人越發想要殺他；因他不但犯了安息日，並且稱神為他的父，將自己和神當作平等。',
    '約5:19 耶穌對他們說：我實實在在的告訴你們，子憑著自己不能做什麼，惟有看見父所做的，子才能做；父所做的事，子也照樣做。',
    '約5:20 父愛子，將自己所做的一切事指給他看，還要將比這更大的事指給他看，叫你們希奇。',
    '約5:21 父怎樣叫死人起來，使他們活著，子也照樣隨自己的意思使人活著。',
    '約5:22 父不審判什麼人，乃將審判的事全交與子，',
    '約5:23 叫人都尊敬子如同尊敬父一樣。不尊敬子的，就是不尊敬差子來的父。',
    '約5:24 我實實在在的告訴你們，那聽我話、又信差我來者的，就有永生；不至於定罪，是已經出死入生了。',
    '約5:25 我實實在在的告訴你們，時候將到，現在就是了，死人要聽見神兒子的聲音，聽見的人就要活了。',
    '約5:26 因為父怎樣在自己有生命，就賜給他兒子也照樣在自己有生命，',
    '約5:27 並且因為他是人子，就賜給他行審判的權柄。',
    '約5:28 你們不要把這事看作希奇。時候要到，凡在墳墓裡的，都要聽見他的聲音，就出來；',
    '約5:29 行善的，復活得生；作惡的，復活定罪。',
    '約5:30 我憑著自己不能做什麼，我怎麼聽見就怎麼審判。我的審判也是公平的；因為我不求自己的意思，只求那差我來者的意思。',
    '約5:31 我若為自己作見證，我的見證就不真。',
    '約5:32 另有一位給我作見證，我也知道他給我作的見證是真的。',
    '約5:33 你們曾差人到約翰那裡，他為真理作過見證。',
    '約5:34 其實，我所受的見證不是從人來的；然而，我說這些話，為要叫你們得救。',
    '約5:35 約翰是點著的明燈，你們情願暫時喜歡他的光。',
    '約5:36 但我有比約翰更大的見證；因為父交給我要我成就的事，就是我所做的事，這便見證我是父所差來的。',
    '約5:37 差我來的父也為我作過見證。你們從來沒有聽見他的聲音，也沒有看見他的形像。',
    '約5:38 你們並沒有他的道存在心裡；因為他所差來的，你們不信。',
    '約5:39 你們查考聖經（或作：應當查考聖經），因你們以為內中有永生；給我作見證的就是這經。',
    '約5:40 然而，你們不肯到我這裡來得生命。',
    '約5:41 我不受從人來的榮耀。',
    '約5:42 但我知道，你們心裡沒有神的愛。',
    '約5:43 我奉我父的名來，你們並不接待我；若有別人奉自己的名來，你們倒要接待他。',
    '約5:44 你們互相受榮耀，卻不求從獨一之神來的榮耀，怎能信我呢﹖',
    '約5:45 不要想我在父面前要告你們；有一位告你們的，就是你們所仰賴的摩西。',
    '約5:46 你們如果信摩西，也必信我，因為他書上有指著我寫的話。',
    '約5:47 你們若不信他的書，怎能信我的話呢﹖',
    '約6:1 這事以後，耶穌渡過加利利海，就是提比哩亞海。',
    '約6:2 有許多人因為看見他在病人身上所行的神蹟，就跟隨他。',
    '約6:3 耶穌上了山，和門徒一同坐在那裡。',
    '約6:4 那時猶太人的逾越節近了。',
    '約6:5 耶穌舉目看見許多人來，就對腓力說：我們從哪裡買餅叫這些人吃呢﹖',
    '約6:6 他說這話是要試驗腓力；他自己原知道要怎樣行。',
    '約6:7 腓力回答說：就是二十兩銀子的餅，叫他們各人吃一點也是不夠的。',
    '約6:8 有一個門徒，就是西門彼得的兄弟安得烈，對耶穌說：',
    '約6:9 在這裡有一個孩童，帶著五個大麥餅、兩條魚，只是分給這許多人還算什麼呢﹖',
    '約6:10 耶穌說：你們叫眾人坐下。原來那地方的草多，眾人就坐下，數目約有五千。',
    '約6:11 耶穌拿起餅來，祝謝了，就分給那坐著的人；分魚也是這樣，都隨著他們所要的。',
    '約6:12 他們吃飽了，耶穌對門徒說：把剩下的零碎收拾起來，免得有糟蹋的。',
    '約6:13 他們便將那五個大麥餅的零碎，就是眾人吃了剩下的，收拾起來，裝滿了十二個籃子。',
    '約6:14 眾人看見耶穌所行的神蹟，就說：這真是那要到世間來的先知！',
    '約6:15 耶穌既知道眾人要來強逼他作王，就獨自又退到山上去了。',
    '約6:16 到了晚上，他的門徒下海邊去，',
    '約6:17 上了船，要過海往迦百農去。天已經黑了，耶穌還沒有來到他們那裡。',
    '約6:18 忽然狂風大作，海就翻騰起來。',
    '約6:19 門徒搖櫓，約行了十里多路，看見耶穌在海面上走，漸漸近了船，他們就害怕。',
    '約6:20 耶穌對他們說：是我，不要怕！',
    '約6:21 門徒就喜歡接他上船，船立時到了他們所要去的地方。',
    '約6:22 第二日，站在海那邊的眾人知道那裡沒有別的船，只有一隻小船，又知道耶穌沒有同他的門徒上船，乃是門徒自己去的。',
    '約6:23 然而，有幾隻小船從提比哩亞來，靠近主祝謝後分餅給人吃的地方。',
    '約6:24 眾人見耶穌和門徒都不在那裡，就上了船，往迦百農去找耶穌。',
    '約6:25 既在海那邊找著了，就對他說：拉比，是幾時到這裡來的﹖',
    '約6:26 耶穌回答說：我實實在在的告訴你們，你們找我，並不是因見了神蹟，乃是因吃餅得飽。',
    '約6:27 不要為那必壞的食物勞力，要為那存到永生的食物勞力，就是人子要賜給你們的，因為人子是父神所印證的。',
    '約6:28 眾人問他說：我們當行什麼，才算做神的工呢﹖',
    '約6:29 耶穌回答說：信神所差來的，這就是做神的工。',
    '約6:30 他們又說：你行什麼神蹟，叫我們看見就信你；你到底做什麼事呢﹖',
    '約6:31 我們的祖宗在曠野吃過嗎哪，如經上寫著說：他從天上賜下糧來給他們吃。',
    '約6:32 耶穌說：我實實在在的告訴你們，那從天上來的糧不是摩西賜給你們的，乃是我父將天上來的真糧賜給你們。',
    '約6:33 因為神的糧就是那從天上降下來、賜生命給世界的。',
    '約6:34 他們說：主啊，常將這糧賜給我們！',
    '約6:35 耶穌說：我就是生命的糧。到我這裡來的，必定不餓；信我的，永遠不渴。',
    '約6:36 只是我對你們說過，你們已經看見我，還是不信。',
    '約6:37 凡父所賜給我的人必到我這裡來；到我這裡來的，我總不丟棄他。',
    '約6:38 因為我從天上降下來，不是要按自己的意思行，乃是要按那差我來者的意思行。',
    '約6:39 差我來者的意思就是：他所賜給我的，叫我一個也不失落，在末日卻叫他復活。',
    '約6:40 因為我父的意思是叫一切見子而信的人得永生，並且在末日我要叫他復活。',
    '約6:41 猶太人因為耶穌說我是從天上降下來的糧，就私下議論他，',
    '約6:42 說：這不是約瑟的兒子耶穌嗎﹖他的父母我們豈不認得嗎﹖他如今怎麼說我是從天上降下來的呢﹖',
    '約6:43 耶穌回答說：你們不要大家議論。',
    '約6:44 若不是差我來的父吸引人，就沒有能到我這裡來的；到我這裡來的，在末日我要叫他復活。',
    '約6:45 在先知書上寫著說：他們都要蒙神的教訓。凡聽見父之教訓又學習的，就到我這裡來。',
    '約6:46 這不是說有人看見過父；惟獨從神來的，他看見過父。',
    '約6:47 我實實在在的告訴你們，信的人有永生。',
    '約6:48 我就是生命的糧。',
    '約6:49 你們的祖宗在曠野吃過嗎哪，還是死了。',
    '約6:50 這是從天上降下來的糧，叫人吃了就不死。',
    '約6:51 我是從天上降下來生命的糧；人若吃這糧，就必永遠活著。我所要賜的糧就是我的肉，為世人之生命所賜的。',
    '約6:52 因此，猶太人彼此爭論說：這個人怎能把他的肉給我們吃呢﹖',
    '約6:53 耶穌說：我實實在在的告訴你們，你們若不吃人子的肉，不喝人子的血，就沒有生命在你們裡面。',
    '約6:54 吃我肉、喝我血的人就有永生，在末日我要叫他復活。',
    '約6:55 我的肉真是可吃的，我的血真是可喝的。',
    '約6:56 吃我肉、喝我血的人常在我裡面，我也常在他裡面。',
    '約6:57 永活的父怎樣差我來，我又因父活著；照樣，吃我肉的人也要因我活著。',
    '約6:58 這就是從天上降下來的糧。吃這糧的人就永遠活著，不像你們的祖宗吃過嗎哪還是死了。',
    '約6:59 這些話是耶穌在迦百農會堂裡教訓人說的。',
    '約6:60 他的門徒中有好些人聽見了，就說：這話甚難，誰能聽呢﹖',
    '約6:61 耶穌心裡知道門徒為這話議論，就對他們說：這話是叫你們厭棄（原文是跌倒）嗎﹖',
    '約6:62 倘或你們看見人子升到他原來所在之處，怎麼樣呢﹖',
    '約6:63 叫人活著的乃是靈，肉體是無益的。我對你們所說的話就是靈，就是生命。',
    '約6:64 只是你們中間有不信的人。耶穌從起頭就知道誰不信他，誰要賣他。',
    '約6:65 耶穌又說：所以我對你們說過，若不是蒙我父的恩賜，沒有人能到我這裡來。',
    '約6:66 從此，他門徒中多有退去的，不再和他同行。',
    '約6:67 耶穌就對那十二個門徒說：你們也要去嗎﹖',
    '約6:68 西門彼得回答說：主啊，你有永生之道，我們還歸從誰呢﹖',
    '約6:69 我們已經信了，又知道你是神的聖者。',
    '約6:70 耶穌說：我不是揀選了你們十二個門徒嗎﹖但你們中間有一個是魔鬼。',
    '約6:71 耶穌這話是指著加略人西門的兒子猶大說的；他本是十二個門徒裡的一個，後來要賣耶穌的。',
    '約7:1 這事以後，耶穌在加利利遊行，不願在猶太遊行，因為猶太人想要殺他。',
    '約7:2 當時猶太人的住棚節近了。',
    '約7:3 耶穌的弟兄就對他說：你離開這裡上猶太去吧，叫你的門徒也看見你所行的事。',
    '約7:4 人要顯揚名聲，沒有在暗處行事的；你如果行這些事，就當將自己顯明給世人看。',
    '約7:5 因為連他的弟兄說這話，是因為不信他。',
    '約7:6 耶穌就對他們說：我的時候還沒有到；你們的時候常是方便的。',
    '約7:7 世人不能恨你們，卻是恨我，因為我指證他們所做的事是惡的。',
    '約7:8 你們上去過節吧，我現在不上去過這節，因為我的時候還沒有滿。',
    '約7:9 耶穌說了這話，仍舊住在加利利。',
    '約7:10 但他弟兄上去以後，他也上去過節，不是明去，似乎是暗去的。',
    '約7:11 正在節期，猶太人尋找耶穌，說：他在哪裡﹖',
    '約7:12 眾人為他紛紛議論，有的說：他是好人。有的說：不然，他是迷惑眾人的。',
    '約7:13 只是沒有人明明的講論他，因為怕猶太人。',
    '約7:14 到了節期，耶穌上殿裡去教訓人。',
    '約7:15 猶太人就希奇，說：這個人沒有學過，怎麼明白書呢﹖',
    '約7:16 耶穌說：我的教訓不是我自己的，乃是那差我來者的。',
    '約7:17 人若立志遵著他的旨意行，就必曉得這教訓或是出於神，或是我憑著自己說的。',
    '約7:18 人憑著自己說，是求自己的榮耀；惟有求那差他來者的榮耀，這人是真的，在他心裡沒有不義。',
    '約7:19 摩西豈不是傳律法給你們嗎﹖你們卻沒有一個人守律法。為什麼想要殺我呢﹖',
    '約7:20 眾人回答說：你是被鬼附著了！誰想要殺你﹖',
    '約7:21 耶穌說：我做了一件事，你們都以為希奇。',
    '約7:22 摩西傳割禮給你們（其實不是從摩西起的，乃是從祖先起的），因此你們也在安息日給人行割禮。',
    '約7:23 人若在安息日受割禮，免得違背摩西的律法，我在安息日叫一個人全然好了，你們就向我生氣嗎﹖',
    '約7:24 不可按外貌斷定是非，總要按公平斷定是非。',
    '約7:25 耶路撒冷人中有的說：這不是他們想要殺的人嗎﹖',
    '約7:26 你看他還明明的講道，他們也不向他說什麼，難道官長真知道這是基督嗎﹖',
    '約7:27 然而，我們知道這個人從哪裡來；只是基督來的時候，沒有人知道他從哪裡來。',
    '約7:28 那時，耶穌在殿裡教訓人，大聲說：你們也知道我，也知道我從哪裡來；我來並不是由於自己。但那差我來的是真的。你們不認識他，',
    '約7:29 我卻認識他；因為我是從他來的，他也是差了我來。',
    '約7:30 他們就想要捉拿耶穌；只是沒有人下手，因為他的時候還沒有到。',
    '約7:31 但眾人中間有好些信他的，說：基督來的時候，他所行的神蹟豈能比這人所行的更多嗎﹖',
    '約7:32 法利賽人聽見眾人為耶穌這樣紛紛議論，祭司長和法利賽人就打發差役去捉拿他。',
    '約7:33 於是耶穌說：我還有不多的時候和你們同在，以後就回到差我來的那裡去。',
    '約7:34 你們要找我，卻找不著；我所在的地方你們不能到。',
    '約7:35 猶太人就彼此對問說：這人要往哪裡去，叫我們找不著呢﹖難道他要往散住希利尼中的猶太人那裡去教訓希利尼人嗎﹖',
    '約7:36 他說：你們要找我，卻找不著；我所在的地方，你們不能到，這話是什麼意思呢﹖',
    '約7:37 節期的末日，就是最大之日，耶穌站著高聲說：人若渴了，可以到我這裡來喝。',
    '約7:38 信我的人就如經上所說：從他腹中要流出活水的江河來。',
    '約7:39 耶穌這話是指著信他之人要受聖靈說的。那時還沒有賜下聖靈來，因為耶穌尚未得著榮耀。',
    '約7:40 眾人聽見這話，有的說：這真是那先知。',
    '約7:41 有的說：這是基督。但也有的說：基督豈是從加利利出來的嗎﹖',
    '約7:42 經上豈不是說基督是大衛的後裔，從大衛本鄉伯利恆出來的嗎﹖',
    '約7:43 於是眾人因著耶穌起了紛爭。',
    '約7:44 其中有人要捉拿他，只是無人下手。',
    '約7:45 差役回到祭司長和法利賽人那裡。他們對差役說；你們為什麼沒有帶他來呢﹖',
    '約7:46 差役回答說：從來沒有像他這樣說話的！',
    '約7:47 法利賽人說：你們也受了迷惑嗎﹖',
    '約7:48 官長或是法利賽人豈有信他的呢﹖',
    '約7:49 但這些不明白律法的百姓是被咒詛的！',
    '約7:50 內中有尼哥底母，就是從前去見耶穌的，對他們說：',
    '約7:51 不先聽本人的口供，不知道他所做的事，難道我們的律法還定他的罪嗎﹖',
    '約7:52 他們回答說：你也是出於加利利嗎﹖你且去查考，就可知道加利利沒有出過先知。',
    '約7:53 併於上節。',
    '約8:1 於是各人都回家去了；耶穌卻往橄欖山去，',
    '約8:2 清早又回到殿裡。眾百姓都到他那裡去，他就坐下，教訓他們。',
    '約8:3 文士和法利賽人帶著一個行淫時被拿的婦人來，叫他站在當中，',
    '約8:4 就對耶穌說：夫子，這婦人是正行淫之時被拿的。',
    '約8:5 摩西在律法上吩咐我們把這樣的婦人用石頭打死。你說該把他怎麼樣呢﹖',
    '約8:6 他們說這話，乃試探耶穌，要得著告他的把柄。耶穌卻彎著腰，用指頭在地上畫字。',
    '約8:7 他們還是不住的問他，耶穌就直起腰來，對他們說：你們中間誰是沒有罪的，誰就可以先拿石頭打他。',
    '約8:8 於是又彎著腰，用指頭在地上畫字。',
    '約8:9 他們聽見這話，就從老到少，一個一個的都出去了，只剩下耶穌一人，還有那婦人仍然站在當中。',
    '約8:10 耶穌就直起腰來，對他說：婦人，那些人在哪裡呢﹖沒有人定你的罪嗎﹖',
    '約8:11 他說：主啊，沒有。耶穌說：我也不定你的罪。去吧，從此不要再犯罪了！',
    '約8:12 耶穌又對眾人說：我是世界的光。跟從我的，就不在黑暗裡走，必要得著生命的光。',
    '約8:13 法利賽人對他說：你是為自己作見證，你的見證不真。',
    '約8:14 耶穌說：我雖然為自己作見證，我的見證還是真的；因我知道我從哪裡來，往哪裡去；你們卻不知道我從哪裡來，往哪裡去。',
    '約8:15 你們是以外貌（原文是憑肉身）判斷人，我卻不判斷人。',
    '約8:16 就是判斷人，我的判斷也是真的；因為不是我獨自在這裡，還有差我來的父與我同在。',
    '約8:17 你們的律法上也記著說：兩個人的見證是真的。',
    '約8:18 我是為自己作見證，還有差我來的父也是為我作見證。',
    '約8:19 他們就問他說：你的父在哪裡﹖耶穌回答說：你們不認識我，也不認識我的父；若是認識我，也就認識我的父。',
    '約8:20 這些話是耶穌在殿裡的庫房、教訓人時所說的，也沒有人拿他，因為他的時候還沒有到。',
    '約8:21 耶穌又對他們說：我要去了，你們要找我，並且你們要死在罪中。我所去的地方，你們不能到。',
    '約8:22 猶太人說：他說：我所去的地方，你們不能到，難道他要自盡嗎﹖',
    '約8:23 耶穌對他們說：你們是從下頭來的，我是從上頭來的；你們是屬這世界的，我不是屬這世界的。',
    '約8:24 所以我對你們說，你們要死在罪中。你們若不信我是基督，必要死在罪中。',
    '約8:25 他們就問他說：你是誰﹖耶穌對他們說：就是我從起初所告訴你們的。',
    '約8:26 我有許多事講論你們，判斷你們；但那差我來的是真的，我在他那裡所聽見的，我就傳給世人。',
    '約8:27 他們不明白耶穌是指著父說的。',
    '約8:28 所以耶穌說：你們舉起人子以後，必知道我是基督，並且知道我沒有一件事是憑著自己做的。我說這些話乃是照著父所教訓我的。',
    '約8:29 那差我來的是與我同在；他沒有撇下我獨自在這裡，因為我常做他所喜悅的事。',
    '約8:30 耶穌說這話的時候，就有許多人信他。',
    '約8:31 耶穌對信他的猶太人說：你們若常常遵守我的道，就真是我的門徒；',
    '約8:32 你們必曉得真理，真理必叫你們得以自由。',
    '約8:33 他們回答說：我們是亞伯拉罕的後裔，從來沒有作過誰的奴僕。你怎麼說你們必得自由呢﹖',
    '約8:34 耶穌回答說：我實實在在的告訴你們，所有犯罪的就是罪的奴僕。',
    '約8:35 奴僕不能永遠住在家裡；兒子是永遠住在家裡。',
    '約8:36 所以天父的兒子若叫你們自由，你們就真自由了。',
    '約8:37 我知道你們是亞伯拉罕的子孫，你們卻想要殺我，因為你們心裡容不下我的道。',
    '約8:38 我所說的是在我父那裡看見的；你們所行的是在你們的父那裡聽見的。',
    '約8:39 他們說：我們的父就是亞伯拉罕。耶穌說：你們若是亞伯拉罕的兒子，就必行亞伯拉罕所行的事。',
    '約8:40 我將在神那裡所聽見的真理告訴了你們，現在你們卻想要殺我，這不是亞伯拉罕所行的事。',
    '約8:41 你們是行你們父所行的事。他們說：我們不是從淫亂生的；我們只有一位父，就是神。',
    '約8:42 耶穌說：倘若神是你們的父，你們就必愛我；因為我本是出於神，也是從神而來，並不是由著自己來，乃是他差我來。',
    '約8:43 你們為什麼不明白我的話呢﹖無非是因你們不能聽我的道。',
    '約8:44 你們是出於你們的父魔鬼，你們父的私慾你們偏要行。他從起初是殺人的，不守真理，因他心裡沒有真理。他說謊是出於自己；因他本來是說謊的，也是說謊之人的父。',
    '約8:45 我將真理告訴你們，你們就因此不信我。',
    '約8:46 你們中間誰能指證我有罪呢﹖我既然將真理告訴你們，為什麼不信我呢﹖',
    '約8:47 出於神的，必聽神的話；你們不聽，因為你們不是出於神。',
    '約8:48 猶太人回答說：我們說你是撒瑪利亞人，並且是鬼附著的，這話豈不正對嗎﹖',
    '約8:49 耶穌說：我不是鬼附著的；我尊敬我的父，你們倒輕慢我。',
    '約8:50 我不求自己的榮耀，有一位為我求榮耀、定是非的。',
    '約8:51 我實實在在的告訴你們，人若遵守我的道，就永遠不見死。',
    '約8:52 猶太人對他說：現在我們知道你是鬼附著的。亞伯拉罕死了，眾先知也死了，你還說：人若遵守我的道，就永遠不嘗死味。',
    '約8:53 難道你比我們的祖宗亞伯拉罕還大嗎﹖他死了，眾先知也死了，你將自己當作什麼人呢﹖',
    '約8:54 耶穌回答說：我若榮耀自己，我的榮耀就算不得什麼；榮耀我的乃是我的父，就是你們所說是你們的神。',
    '約8:55 你們未曾認識他；我卻認識他。我若說不認識他，我就是說謊的，像你們一樣；但我認識他，也遵守他的道。',
    '約8:56 你們的祖宗亞伯拉罕歡歡喜喜的仰望我的日子，既看見了就快樂。',
    '約8:57 猶太人說：你還沒有五十歲，豈見過亞伯拉罕呢﹖',
    '約8:58 耶穌說：我實實在在的告訴你們，還沒有亞伯拉罕就有了我。',
    '約8:59 於是他們拿石頭要打他；耶穌卻躲藏，從殿裡出去了。',
    '約9:1 耶穌過去的時候，看見一個人生來是瞎眼的。',
    '約9:2 門徒問耶穌說：拉比，這人生來是瞎眼的，是誰犯了罪﹖是這人呢﹖是他父母呢﹖',
    '約9:3 耶穌回答說：也不是這人犯了罪，也不是他父母犯了罪，是要在他身上顯出神的作為來。',
    '約9:4 趁著白日，我們必須做那差我來者的工；黑夜將到，就沒有人能做工了。',
    '約9:5 我在世上的時候，是世上的光。',
    '約9:6 耶穌說了這話，就吐唾沫在地上，用唾沫和泥抹在瞎子的眼睛上，',
    '約9:7 對他說：你往西羅亞池子裡去洗（西羅亞翻出來就是奉差遣）。他去一洗，回頭就看見了。',
    '約9:8 他的鄰舍和那素常見他是討飯的，就說：這不是那從前坐著討飯的人嗎﹖',
    '約9:9 有人說：是他；又有人說；不是，卻是像他。他自己說：是我。',
    '約9:10 他們對他說：你的眼睛是怎麼開的呢﹖',
    '約9:11 他回答說：有一個人，名叫耶穌，他和泥抹我的眼睛，對我說：你往西羅亞池子去洗。我去一洗，就看見了。',
    '約9:12 他們說：那個人在哪裡﹖他說：我不知道。',
    '約9:13 他們把從前瞎眼的人帶到法利賽人那裡。',
    '約9:14 耶穌和泥開他眼睛的日子是安息日。',
    '約9:15 法利賽人也問他是怎麼得看見的。瞎子對他們說：他把泥抹在我的眼睛上，我去一洗，就看見了。',
    '約9:16 法利賽人中有的說：這個人不是從神來的，因為他不守安息日。又有人說：一個罪人怎能行這樣的神蹟呢﹖他們就起了紛爭。',
    '約9:17 他們又對瞎子說：他既然開了你的眼睛，你說他是怎樣的人呢﹖他說：是個先知。',
    '約9:18 猶太人不信他從前是瞎眼，後來能看見的，等到叫了他的父母來，',
    '約9:19 問他們說：這是你們的兒子嗎﹖你們說他生來是瞎眼的，如今怎麼能看見了呢﹖',
    '約9:20 他父母回答說：他是我們的兒子，生來就瞎眼，這是我們知道的。',
    '約9:21 至於他如今怎麼能看見，我們卻不知道；是誰開了他的眼睛，我們也不知道。他已經成了人，你們問他吧，他自己必能說。',
    '約9:22 他父母說這話，是怕猶太人；因為猶太人已經商議定了，若有認耶穌是基督的，要把他趕出會堂。',
    '約9:23 因此他父母說：他已經成了人，你們問他吧。',
    '約9:24 所以法利賽人第二次叫了那從前瞎眼的人來，對他說：你該將榮耀歸給神，我們知道這人是個罪人。',
    '約9:25 他說：他是個罪人不是，我不知道；有一件事我知道，從前我是眼瞎的，如今能看見了。',
    '約9:26 他們就問他說：他向你做什麼﹖是怎麼開了你的眼睛呢﹖',
    '約9:27 他回答說：我方才告訴你們，你們不聽，為什麼又要聽呢﹖莫非你們也要作他的門徒嗎﹖',
    '約9:28 他們就罵他說：你是他的門徒；我們是摩西的門徒。',
    '約9:29 神對摩西說話是我們知道的；只是這個人，我們不知道他從哪裡來！',
    '約9:30 那人回答說：他開了我的眼睛，你們竟不知道他從哪裡來，這真是奇怪！',
    '約9:31 我們知道神不聽罪人，惟有敬奉神、遵行他旨意的，神才聽他。',
    '約9:32 從創世以來，未曾聽見有人把生來是瞎子的眼睛開了。',
    '約9:33 這人若不是從神來的，什麼也不能做。',
    '約9:34 他們回答說：你全然生在罪孽中，還要教訓我們嗎﹖於是把他趕出去了。',
    '約9:35 耶穌聽說他們把他趕出去，後來遇見他，就說：你信神的兒子嗎﹖',
    '約9:36 他回答說：主啊，誰是神的兒子，叫我信他呢﹖',
    '約9:37 耶穌說：你已經看見他，現在和你說話的就是他。',
    '約9:38 他說：主啊，我信！就拜耶穌。',
    '約9:39 耶穌說：我為審判到這世上來，叫不能看見的，可以看見；能看見的，反瞎了眼。',
    '約9:40 同他在那裡的法利賽人聽見這話，就說：難道我們也瞎了眼嗎﹖',
    '約9:41 耶穌對他們說：你們若瞎了眼，就沒有罪了；但如今你們說我們能看見，所以你們的罪還在。',
    '約10:1 我實實在在的告訴你們，人進羊圈，不從門進去，倒從別處爬進去，那人就是賊，就是強盜。',
    '約10:2 從門進去的，才是羊的牧人。',
    '約10:3 看門的就給他開門；羊也聽他的聲音。他按著名叫自己的羊，把羊領出來。',
    '約10:4 既放出自己的羊來，就在前頭走，羊也跟著他，因為認得他的聲音。',
    '約10:5 羊不跟著生人；因為不認得他的聲音。必要逃跑。',
    '約10:6 耶穌將這比喻告訴他們，但他們不明白所說的是什麼意思。',
    '約10:7 所以，耶穌又對他們說：我實實在在的告訴你們，我就是羊的門。',
    '約10:8 凡在我以先來的都是賊，是強盜；羊卻不聽他們。',
    '約10:9 我就是門；凡從我進來的，必然得救，並且出入得草吃。',
    '約10:10 盜賊來，無非要偷竊，殺害，毀壞；我來了，是要叫羊（或作：人）得生命，並且得的更豐盛。',
    '約10:11 我是好牧人；好牧人為羊捨命。',
    '約10:12 若是雇工，不是牧人，羊也不是他自己的，他看見狼來，就撇下羊逃走；狼抓住羊，趕散了羊群。',
    '約10:13 雇工逃走，因他是雇工，並不顧念羊。',
    '約10:14 我是好牧人；我認識我的羊，我的羊也認識我，',
    '約10:15 正如父認識我，我也認識父一樣；並且我為羊捨命。',
    '約10:16 我另外有羊，不是這圈裡的；我必須領他們來，他們也要聽我的聲音，並且要合成一群，歸一個牧人了。',
    '約10:17 我父愛我；因我將命捨去，好再取回來。',
    '約10:18 沒有人奪我的命去，是我自己捨的。我有權柄捨了，也有權柄取回來。這是我從我父所受的命令。',
    '約10:19 猶太人為這些話又起了紛爭。',
    '約10:20 內中有好些人說：他是被鬼附著，而且瘋了，為什麼聽他呢﹖',
    '約10:21 又有人說：這不是鬼附之人所說的話。鬼豈能叫瞎子的眼睛開了呢﹖',
    '約10:22 在耶路撒冷有修殿節，是冬天的時候。',
    '約10:23 耶穌在殿裡所羅門的廊下行走。',
    '約10:24 猶太人圍著他，說：你叫我們猶疑不定到幾時呢﹖你若是基督，就明明的告訴我們。',
    '約10:25 耶穌回答說：我已經告訴你們，你們不信。我奉我父之名所行的事可以為我作見證；',
    '約10:26 只是你們不信，因為你們不是我的羊。',
    '約10:27 我的羊聽我的聲音，我也認識他們，他們也跟著我。',
    '約10:28 我又賜給他們永生；他們永不滅亡，誰也不能從我手裡把他們奪去。',
    '約10:29 我父把羊賜給我，他比萬有都大，誰也不能從我父手裡把他們奪去。',
    '約10:30 我與父原為一。',
    '約10:31 猶太人又拿起石頭來要打他。',
    '約10:32 耶穌對他們說：我從父顯出許多善事給你們看，你們是為哪一件拿石頭打我呢﹖',
    '約10:33 猶太人回答說：我們不是為善事拿石頭打你，是為你說僭妄的話；又為你是個人，反將自己當作神。',
    '約10:34 耶穌說：你們的律法上豈不是寫著我曾說你們是神嗎﹖',
    '約10:35 經上的話是不能廢的；若那些承受神道的人尚且稱為神，',
    '約10:36 父所分別為聖、又差到世間來的，他自稱是神的兒子，你們還向他說你說僭妄的話嗎﹖',
    '約10:37 我若不行我父的事，你們就不必信我；',
    '約10:38 我若行了，你們縱然不信我，也當信這些事，叫你們又知道又明白父在我裡面，我也在父裡面。',
    '約10:39 他們又要拿他，他卻逃出他們的手走了。',
    '約10:40 耶穌又往約但河外去，到了約翰起初施洗的地方，就住在那裡。',
    '約10:41 有許多人來到他那裡。他們說：約翰一件神蹟沒有行過，但約翰指著這人所說的一切話都是真的。',
    '約10:42 在那裡，信耶穌的人就多了。',
    '約11:1 有一個患病的人，名叫拉撒路，住在伯大尼，就是馬利亞和他姊姊馬大的村莊。',
    '約11:2 這馬利亞就是那用香膏抹主，又用頭髮擦他腳的；患病的拉撒路是他的兄弟。',
    '約11:3 他姊妹兩個就打發人去見耶穌，說：主啊，你所愛的人病了。',
    '約11:4 耶穌聽見，就說：這病不至於死，乃是為神的榮耀，叫神的兒子因此得榮耀。',
    '約11:5 耶穌素來愛馬大和他妹子並拉撒路。',
    '約11:6 聽見拉撒路病了。就在所居之地仍住了兩天。',
    '約11:7 然後對門徒說：我們再往猶太去吧。',
    '約11:8 門徒說：拉比，猶太人近來要拿石頭打你，你還往那裡去嗎﹖',
    '約11:9 耶穌回答說：白日不是有十二小時嗎﹖人在白日走路，就不至跌倒，因為看見這世上的光。',
    '約11:10 若在黑夜走路，就必跌倒，因為他沒有光。',
    '約11:11 耶穌說了這話，隨後對他們說：我們的朋友拉撒路睡了，我去叫醒他。',
    '約11:12 門徒說：主啊，他若睡了，就必好了。',
    '約11:13 耶穌這話是指著他死說的，他們卻以為是說照常睡了。',
    '約11:14 耶穌就明明的告訴他們說：拉撒路死了。',
    '約11:15 我沒有在那裡就歡喜，這是為你們的緣故，好叫你們相信。如今我們可以往他那裡去吧。',
    '約11:16 多馬，又稱為低土馬，就對那同作門徒的說：我們也去和他同死吧。',
    '約11:17 耶穌到了，就知道拉撒路在墳墓裡已經四天了。',
    '約11:18 伯大尼離耶路撒冷不遠，約有六里路。',
    '約11:19 有好些猶太人來看馬大和馬利亞，要為他們的兄弟安慰他們。',
    '約11:20 馬大聽見耶穌來了，就出去迎接他；馬利亞卻仍然坐在家裡。',
    '約11:21 馬大對耶穌說：主啊，你若早在這裡，我兄弟必不死。',
    '約11:22 就是現在，我也知道，你無論向神求什麼，神也必賜給你。',
    '約11:23 耶穌說：你兄弟必然復活。',
    '約11:24 馬大說：我知道在末日復活的時候，他必復活。',
    '約11:25 耶穌對他說：復活在我，生命也在我。信我的人雖然死了，也必復活，',
    '約11:26 凡活著信我的人必永遠不死。你信這話嗎﹖',
    '約11:27 馬大說：主啊，是的，我信你是基督，是神的兒子，就是那要臨到世界的。',
    '約11:28 馬大說了這話，就回去暗暗的叫他妹子馬利亞，說：夫子來了，叫你。',
    '約11:29 馬利亞聽見了，就急忙起來，到耶穌那裡去。',
    '約11:30 那時，耶穌還沒有進村子，仍在馬大迎接他的地方。',
    '約11:31 那些同馬利亞在家裡安慰他的猶太人，見他急忙起來出去，就跟著他，以為他要往墳墓那裡去哭。',
    '約11:32 馬利亞到了耶穌那裡，看見他，就俯伏在他腳前，說：主啊，你若早在這裡，我兄弟必不死。',
    '約11:33 耶穌看見他哭，並看見與他同來的猶太人也哭，就心裡悲歎，又甚憂愁，',
    '約11:34 便說：你們把他安放在哪裡﹖他們回答說：請主來看。',
    '約11:35 耶穌哭了。',
    '約11:36 猶太人就說：你看他愛這人是何等懇切。',
    '約11:37 其中有人說：他既然開了瞎子的眼睛，豈不能叫這人不死嗎﹖',
    '約11:38 耶穌又心裡悲歎，來到墳墓前；那墳墓是個洞，有一塊石頭擋著。',
    '約11:39 耶穌說：你們把石頭挪開。那死人的姊姊馬大對他說：主啊，他現在必是臭了，因為他死了已經四天了。',
    '約11:40 耶穌說：我不是對你說過，你若信，就必看見神的榮耀嗎﹖',
    '約11:41 他們就把石頭挪開。耶穌舉目望天，說：父啊，我感謝你，因為你已經聽我。',
    '約11:42 我也知道你常聽我，但我說這話是為周圍站著的眾人，叫他們信是你差了我來。',
    '約11:43 說了這話，就大聲呼叫說：拉撒路出來！',
    '約11:44 那死人就出來了，手腳裹著布，臉上包著手巾。耶穌對他們說，解開，叫他走！',
    '約11:45 那些來看馬利亞的猶太人見了耶穌所做的事，就多有信他的；',
    '約11:46 但其中也有去見法利賽人的，將耶穌所做的事告訴他們。',
    '約11:47 祭司長和法利賽人聚集公會，說：這人行好些神蹟，我們怎麼辦呢﹖',
    '約11:48 若這樣由著他，人人都要信他，羅馬人也要來奪我們的地土和我們的百姓。',
    '約11:49 內中有一個人，名叫該亞法，本年作大祭司，對他們說：你們不知道什麼。',
    '約11:50 獨不想一個人替百姓死，免得通國滅亡，就是你們的益處。',
    '約11:51 他這話不是出於自己，是因他本年作大祭司，所以預言耶穌將要替這一國死；',
    '約11:52 也不但替這一國死，並要將神四散的子民都聚集歸一。',
    '約11:53 從那日起，他們就商議要殺耶穌。',
    '約11:54 所以，耶穌不再顯然行在猶太人中間，就離開那裡往靠近曠野的地方去，到了一座城，名叫以法蓮，就在那裡和門徒同住。',
    '約11:55 猶太人的逾越節近了，有許多人從鄉下上耶路撒冷去，要在節前潔淨自己。',
    '約11:56 他們就尋找耶穌，站在殿裡彼此說：你們的意思如何，他不來過節嗎﹖',
    '約11:57 那時，祭司長和法利賽人早已吩咐說，若有人知道耶穌在哪裡，就要報明，好去拿他。',
    '約12:1 逾越節前六日，耶穌來到伯大尼，就是他叫拉撒路從死裡復活之處。',
    '約12:2 有人在那裡給耶穌預備筵席；馬大伺候，拉撒路也在那同耶穌坐席的人中。',
    '約12:3 馬利亞就拿著一斤極貴的真哪噠香膏，抹耶穌的腳，又用自己頭髮去擦，屋裡就滿了膏的香氣。',
    '約12:4 有一個門徒，就是那將要賣耶穌的加略人猶大，',
    '約12:5 說：這香膏為什麼不賣三十兩銀子賙濟窮人呢﹖',
    '約12:6 他說這話，並不是掛念窮人，乃因他是個賊，又帶著錢囊，常取其中所存的。',
    '約12:7 耶穌說：由他吧！他是為我安葬之日存留的。',
    '約12:8 因為常有窮人和你們同在，只是你們不常有我。',
    '約12:9 有許多猶太人知道耶穌在那裡，就來了，不但是為耶穌的緣故，也是要看他從死裡所復活的拉撒路。',
    '約12:10 但祭司長商議連拉撒路也要殺了；',
    '約12:11 因有好些猶太人為拉撒路的緣故，回去信了耶穌。',
    '約12:12 第二天，有許多上來過節的人聽見耶穌將到耶路撒冷，',
    '約12:13 就拿著棕樹枝出去迎接他，喊著說：和散那！奉主名來的以色列王是應當稱頌的！',
    '約12:14 耶穌得了一個驢駒，就騎上，如經上所記的說：',
    '約12:15 錫安的民（原文作女子）哪，不要懼怕！你的王騎著驢駒來了。',
    '約12:16 這些事門徒起先不明白，等到耶穌得了榮耀以後才想起這話是指著他寫的，並且眾人果然向他這樣行了。',
    '約12:17 當耶穌呼喚拉撒路，叫他從死復活出墳墓的時候，同耶穌在那裡的眾人就作見證。',
    '約12:18 眾人因聽見耶穌行了這神蹟，就去迎接他。',
    '約12:19 法利賽人彼此說：看哪，你們是徒勞無益，世人都隨從他去了。',
    '約12:20 那時，上來過節禮拜的人中，有幾個希利尼人。',
    '約12:21 他們來見加利利伯賽大的腓力，求他說：先生，我們願意見耶穌。',
    '約12:22 腓力去告訴安得烈，安得烈同腓力去告訴耶穌。',
    '約12:23 耶穌說：人子得榮耀的時候到了。',
    '約12:24 我實實在在的告訴你們，一粒麥子不落在地裡死了，仍舊是一粒，若是死了，就結出許多子粒來。',
    '約12:25 愛惜自己生命的，就失喪生命；在這世上恨惡自己生命的，就要保守生命到永生。',
    '約12:26 若有人服事我，就當跟從我；我在哪裡，服事我的人也要在那裡；若有人服事我，我父必尊重他。',
    '約12:27 我現在心裡憂愁，我說什麼才好呢﹖父啊，救我脫離這時候；但我原是為這時候來的。',
    '約12:28 父啊，願你榮耀你的名！當時就有聲音從天上來，說：我已經榮耀了我的名，還要再榮耀。',
    '約12:29 站在旁邊的眾人聽見，就說：打雷了。還有人說：有天使對他說話。',
    '約12:30 耶穌說：這聲音不是為我，是為你們來的。',
    '約12:31 現在這世界受審判，這世界的王要被趕出去。',
    '約12:32 我若從地上被舉起來，就要吸引萬人來歸我。',
    '約12:33 耶穌這話原是指著自己將要怎樣死說的。',
    '約12:34 眾人回答說：我們聽見律法上有話說，基督是永存的，你怎麼說人子必須被舉起來呢﹖這人子是誰呢﹖',
    '約12:35 耶穌對他們說：光在你們中間還有不多的時候，應當趁著有光行走，免得黑暗臨到你們；那在黑暗裡行走的，不知道往何處去。',
    '約12:36 你們應當趁著有光，信從這光，使你們成為光明之子。耶穌說了這話，就離開他們隱藏了。',
    '約12:37 他雖然在他們面前行了許多神蹟，他們還是不信他。',
    '約12:38 這是要應驗先知以賽亞的話，說：主啊，我們所傳的有誰信呢﹖主的膀臂向誰顯露呢﹖',
    '約12:39 他們所以不能信，因為以賽亞又說：',
    '約12:40 主叫他們瞎了眼，硬了心，免得他們眼睛看見，心裡明白，回轉過來，我就醫治他們。',
    '約12:41 以賽亞因為看見他的榮耀，就指著他說這話。',
    '約12:42 雖然如此，官長中卻有好些信他的，只因法利賽人的緣故，就不承認，恐怕被趕出會堂。',
    '約12:43 這是因他們愛人的榮耀過於愛神的榮耀。',
    '約12:44 耶穌大聲說：信我的，不是信我，乃是信那差我來的。',
    '約12:45 人看見我，就是看見那差我來的。',
    '約12:46 我到世上來，乃是光，叫凡信我的，不住在黑暗裡。',
    '約12:47 若有人聽見我的話不遵守，我不審判他。我來本不是要審判世界，乃是要拯救世界。',
    '約12:48 棄絕我、不領受我話的人，有審判他的─就是我所講的道在末日要審判他。',
    '約12:49 因為我沒有憑著自己講，惟有差我來的父已經給我命令，叫我說什麼，講什麼。',
    '約12:50 我也知道他的命令就是永生。故此，我所講的話正是照著父對我所說的。',
    '約13:1 逾越節以前，耶穌知道自己離世歸父的時候到了。他既然愛世間屬自己的人，就愛他們到底。',
    '約13:2 吃晚飯的時候，魔鬼已將賣耶穌的意思放在西門的兒子加略人猶大心裡。',
    '約13:3 耶穌知道父已將萬有交在他手裡，且知道自己是從神出來的，又要歸到神那裡去，',
    '約13:4 就離席站起來，脫了衣服，拿一條手巾束腰，',
    '約13:5 隨後把水倒在盆裡，就洗門徒的腳，並用自己所束的手巾擦乾。',
    '約13:6 挨到西門彼得，彼得對他說：主啊，你洗我的腳嗎﹖',
    '約13:7 耶穌回答說：我所做的，你如今不知道，後來必明白。',
    '約13:8 彼得說：你永不可洗我的腳！耶穌說：我若不洗你，你就與我無分了。',
    '約13:9 西門彼得說：主啊，不但我的腳，連手和頭也要洗。',
    '約13:10 耶穌說：凡洗過澡的人，只要把腳一洗，全身就乾淨了。你們是乾淨的，然而不都是乾淨的。',
    '約13:11 耶穌原知道要賣他的是誰，所以說：你們不都是乾淨的。',
    '約13:12 耶穌洗完了他們的腳，就穿上衣服，又坐下，對他們說：我向你們所做的，你們明白嗎﹖',
    '約13:13 你們稱呼我夫子，稱呼我主，你們說的不錯，我本來是。',
    '約13:14 我是你們的主，你們的夫子，尚且洗你們的腳，你們也當彼此洗腳。',
    '約13:15 我給你們作了榜樣，叫你們照著我向你們所做的去做。',
    '約13:16 我實實在在的告訴你們，僕人不能大於主人，差人也不能大於差他的人。',
    '約13:17 你們既知道這事，若是去行就有福了。',
    '約13:18 我這話不是指著你們眾人說的，我知道我所揀選的是誰。現在要應驗經上的話，說：同我吃飯的人用腳踢我。',
    '約13:19 如今事情還沒有成就，我要先告訴你們，叫你們到事情成就的時候可以信我是基督。',
    '約13:20 我實實在在的告訴你們，有人接待我所差遣的，就是接待我；接待我，就是接待那差遣我的。',
    '約13:21 耶穌說了這話，心裡憂愁，就明說：我實實在在的告訴你們，你們中間有一個人要賣我了。',
    '約13:22 門徒彼此對看，猜不透所說的是誰。',
    '約13:23 有一個門徒，是耶穌所愛的，側身挨近耶穌的懷裡。',
    '約13:24 西門彼得點頭對他說：你告訴我們，主是指著誰說的。',
    '約13:25 那門徒便就勢靠著耶穌的胸膛，問他說：主啊，是誰呢﹖',
    '約13:26 耶穌回答說：我蘸一點餅給誰，就是誰。耶穌就蘸了一點餅，遞給加略人西門的兒子猶大。',
    '約13:27 他吃了以後，撒但就入了他的心。耶穌便對他說：你所做的，快做吧！',
    '約13:28 同席的人沒有一個知道是為什麼對他說這話。',
    '約13:29 有人因猶大帶著錢囊，以為耶穌是對他說：你去買我們過節所應用的東西，或是叫他拿什麼賙濟窮人。',
    '約13:30 猶大受了那點餅，立刻就出去。那時候是夜間了。',
    '約13:31 他既出去，耶穌就說：如今人子得了榮耀，神在人子身上也得了榮耀。',
    '約13:32 神要因自己榮耀人子，並且要快快的榮耀他。',
    '約13:33 小子們，我還有不多的時候與你們同在；後來你們要找我，但我所去的地方你們不能到。這話我曾對猶太人說過，如今也照樣對你們說。',
    '約13:34 我賜給你們一條新命令，乃是叫你們彼此相愛；我怎樣愛你們，你們也要怎樣相愛。',
    '約13:35 你們若有彼此相愛的心，眾人因此就認出你們是我的門徒了。',
    '約13:36 西門彼得問耶穌說：主往哪裡去﹖耶穌回答說：我所去的地方，你現在不能跟我去，後來卻要跟我去。',
    '約13:37 彼得說：主啊，我為什麼現在不能跟你去﹖我願意為你捨命！',
    '約13:38 耶穌說：你願意為我捨命嗎﹖我實實在在的告訴你，雞叫以先，你要三次不認我。',
    '約14:1 你們心裡不要憂愁；你們信神，也當信我。',
    '約14:2 在我父的家裡有許多住處；若是沒有，我就早已告訴你們了。我去原是為你們預備地方去。',
    '約14:3 我若去為你們預備了地方，就必再來接你們到我那裡去，我在哪裡，叫你們也在那裡。',
    '約14:4 我往哪裡去，你們知道；那條路，你們也知道（有古卷作：我往哪裡去，你們知道那條路）。',
    '約14:5 多馬對他說：主啊，我們不知道你往哪裡去，怎麼知道那條路呢﹖',
    '約14:6 耶穌說我就是道路、真理、生命；若不藉著我，沒有人能到父那裡去。',
    '約14:7 你們若認識我，也就認識我的父。從今以後，你們認識他，並且已經看見他。',
    '約14:8 腓力對他說：求主將父顯給我們看，我們就知足了。',
    '約14:9 耶穌對他說：腓力，我與你們同在這樣長久，你還不認識我嗎﹖人看見了我，就是看見了父；你怎麼說將父顯給我們看呢﹖',
    '約14:10 我在父裡面，父在我裡面，你不信嗎﹖我對你們所說的話，不是憑著自己說的，乃是住在我裡面的父做他自己的事。',
    '約14:11 你們當信我，我在父裡面，父在我裡面；即或不信，也當因我所做的事信我。',
    '約14:12 我實實在在的告訴你們，我所做的事，信我的人也要做，並且要做比這更大的事，因為我往父那裡去。',
    '約14:13 你們奉我的名無論求什麼，我必成就，叫父因兒子得榮耀。',
    '約14:14 你們若奉我的名求什麼，我必成就。',
    '約14:15 你們若愛我，就必遵守我的命令。',
    '約14:16 我要求父，父就另外賜給你們一位保惠師（或作：訓慰師；下同），叫他永遠與你們同在，',
    '約14:17 就是真理的聖靈，乃世人不能接受的；因為不見他，也不認識他。你們卻認識他，因他常與你們同在，也要在你們裡面。',
    '約14:18 我不撇下你們為孤兒，我必到你們這裡來。',
    '約14:19 還有不多的時候，世人不再看見我，你們卻看見我；因為我活著，你們也要活著。',
    '約14:20 到那日，你們就知道我在父裡面，你們在我裡面，我也在你們裡面。',
    '約14:21 有了我的命令又遵守的，這人就是愛我的；愛我的必蒙我父愛他，我也要愛他，並且要向他顯現。',
    '約14:22 猶大（不是加略人猶大）問耶穌說：主啊，為什麼要向我們顯現，不向世人顯現呢﹖',
    '約14:23 耶穌回答說：人若愛我，就必遵守我的道；我父也必愛他，並且我們要到他那裡去，與他同住。',
    '約14:24 不愛我的人就不遵守我的道。你們所聽見的道不是我的，乃是差我來之父的道。',
    '約14:25 我還與你們同住的時候，已將這些話對你們說了。',
    '約14:26 但保惠師，就是父因我的名所要差來的聖靈，他要將一切的事指教你們，並且要叫你們想起我對你們所說的一切話。',
    '約14:27 我留下平安給你們；我將我的平安賜給你們。我所賜的，不像世人所賜的。你們心裡不要憂愁，也不要膽怯。',
    '約14:28 你們聽見我對你們說了，我去還要到你們這裡來。你們若愛我，因我到父那裡去，就必喜樂，因為父是比我大的。',
    '約14:29 現在事情還沒有成就，我預先告訴你們，叫你們到事情成就的時候就可以信。',
    '約14:30 以後我不再和你們多說話，因為這世界的王將到。他在我裡面是毫無所有；',
    '約14:31 但要叫世人知道我愛父，並且父怎樣吩咐我，我就怎樣行。起來，我們走吧！',
    '約15:1 我是真葡萄樹，我父是栽培的人。',
    '約15:2 凡屬我不結果子的枝子，他就剪去；凡結果子的，他就修理乾淨，使枝子結果子更多。',
    '約15:3 現在你們因我講給你們的道，已經乾淨了。',
    '約15:4 你們要常在我裡面，我也常在你們裡面。枝子若不常在葡萄樹上，自己就不能結果子；你們若不常在我裡面，也是這樣。',
    '約15:5 我是葡萄樹，你們是枝子。常在我裡面的，我也常在他裡面，這人就多結果子；因為離了我，你們就不能做什麼。',
    '約15:6 人若不常在我裡面，就像枝子丟在外面枯乾，人拾起來，扔在火裡燒了。',
    '約15:7 你們若常在我裡面，我的話也常在你們裡面，凡你們所願意的，祈求，就給你們成就。',
    '約15:8 你們多結果子，我父就因此得榮耀，你們也就是我的門徒了。',
    '約15:9 我愛你們，正如父愛我一樣；你們要常在我的愛裡。',
    '約15:10 你們若遵守我的命令，就常在我的愛裡，正如我遵守了我父的命令，常在他的愛裡。',
    '約15:11 這些事我已經對你們說了，是要叫我的喜樂存在你們心裡，並叫你們的喜樂可以滿足。',
    '約15:12 你們要彼此相愛，像我愛你們一樣；這就是我的命令。',
    '約15:13 人為朋友捨命，人的愛心沒有比這個大的。',
    '約15:14 你們若遵行我所吩咐的，就是我的朋友了。',
    '約15:15 以後我不再稱你們為僕人，因僕人不知道主人所做的事。我乃稱你們為朋友；因我從我父所聽見的，已經都告訴你們了。',
    '約15:16 不是你們揀選了我，是我揀選了你們，並且分派你們去結果子，叫你們的果子常存，使你們奉我的名，無論向父求什麼，他就賜給你們。',
    '約15:17 我這樣吩咐你們，是要叫你們彼此相愛。',
    '約15:18 世人若恨你們，你們知道（或作：該知道），恨你們以先已經恨我了。',
    '約15:19 你們若屬世界，世界必愛屬自己的；只因你們不屬世界，乃是我從世界中揀選了你們，所以世界就恨你們。',
    '約15:20 你們要記念我從前對你們所說的話：僕人不能大於主人。他們若逼迫了我，也要逼迫你們；若遵守了我的話，也要遵守你們的話。',
    '約15:21 但他們因我的名要向你們行這一切的事，因為他們不認識那差我來的。',
    '約15:22 我若沒有來教訓他們，他們就沒有罪；但如今他們的罪無可推諉了。',
    '約15:23 恨我的，也恨我的父。',
    '約15:24 我若沒有在他們中間行過別人未曾行的事，他們就沒有罪；但如今連我與我的父，他們也看見也恨惡了。',
    '約15:25 這要應驗他們律法上所寫的話，說：他們無故的恨我。',
    '約15:26 但我要從父那裡差保惠師來，就是從父出來真理的聖靈；他來了，就要為我作見證。',
    '約15:27 你們也要作見證，因為你們從起頭就與我同在。',
    '約16:1 我已將這些事告訴你們，使你們不至於跌倒。',
    '約16:2 人要把你們趕出會堂，並且時候將到，凡殺你們的就以為是事奉神。',
    '約16:3 他們這樣行，是因未曾認識父，也未曾認識我。',
    '約16:4 我將這事告訴你們，是叫你們到了時候可以想起我對你們說過了。我起先沒有將這事告訴你們，因為我與你們同在。',
    '約16:5 現今我往差我來的父那裡去，你們中間並沒有人問我：你往哪裡去﹖',
    '約16:6 只因我將這事告訴你們，你們就滿心憂愁。',
    '約16:7 然而，我將真情告訴你們，我去是於你們有益的；我若不去，保惠師就不到你們這裡來；我若去，就差他來。',
    '約16:8 他既來了，就要叫世人為罪、為義、為審判，自己責備自己。',
    '約16:9 為罪，是因他們不信我；',
    '約16:10 為義，是因我往父那裡去，你們就不再見我；',
    '約16:11 為審判，是因這世界的王受了審判。',
    '約16:12 我還有好些事要告訴你們，但你們現在擔當不了（或作：不能領會）。',
    '約16:13 只等真理的聖靈來了，他要引導你們明白（原文作進入）一切的真理；因為他不是憑自己說的，乃是把他所聽見的都說出來，並要把將來的事告訴你們。',
    '約16:14 他要榮耀我，因為他要將受於我的告訴你們。',
    '約16:15 凡父所有的，都是我的；所以我說，他要將受於我的告訴你們。',
    '約16:16 等不多時，你們就不得見我；再等不多時，你們還要見我。',
    '約16:17 有幾個門徒就彼此說：他對我們說：等不多時，你們就不得見我；再等不多時，你們還要見我；又說：因我往父那裡去。這是什麼意思呢﹖',
    '約16:18 門徒彼此說：他說等不多時到底是什麼意思呢﹖我們不明白他所說的話。',
    '約16:19 耶穌看出他們要問他，就說：我說等不多時，你們就不得見我；再等不多時，你們還要見我，你們為這話彼此相問嗎﹖',
    '約16:20 我實實在在的告訴你們，你們將要痛哭、哀號，世人倒要喜樂；你們將要憂愁，然而你們的憂愁要變為喜樂。',
    '約16:21 婦人生產的時候就憂愁，因為他的時候到了；既生了孩子，就不再記念那苦楚，因為歡喜世上生了一個人。',
    '約16:22 你們現在也是憂愁，但我要再見你們，你們的心就喜樂了；這喜樂也沒有人能奪去。',
    '約16:23 到那日，你們什麼也就不問我了。我實實在在的告訴你們，你們若向父求什麼，他必因我的名賜給你們。',
    '約16:24 向來你們沒有奉我的名求什麼，如今你們求，就必得著，叫你們的喜樂可以滿足。',
    '約16:25 這些事，我是用比喻對你們說的；時候將到，我不再用比喻對你們說，乃要將父明明的告訴你們。',
    '約16:26 到那日，你們要奉我的名祈求；我並不對你們說，我要為你們求父。',
    '約16:27 父自己愛你們；因為你們已經愛我，又信我是從父出來的。',
    '約16:28 我從父出來，到了世界；我又離開世界，往父那裡去。',
    '約16:29 門徒說：如今你是明說，並不用比喻了。',
    '約16:30 現在我們曉得你凡事都知道，也不用人問你，因此我們信你是從神出來的。',
    '約16:31 耶穌說：現在你們信嗎﹖',
    '約16:32 看哪，時候將到，且是已經到了，你們要分散，各歸自己的地方去，留下我獨自一人；其實我不是獨自一人，因為有父與我同在。',
    '約16:33 我將這些事告訴你們，是要叫你們在我裡面有平安。在世上，你們有苦難；但你們可以放心，我已經勝了世界。',
    '約17:1 耶穌說了這話，就舉目望天，說：父啊，時候到了，願你榮耀你的兒子，使兒子也榮耀你；',
    '約17:2 正如你曾賜給他權柄管理凡有血氣的，叫他將永生賜給你所賜給他的人。',
    '約17:3 認識你─獨一的真神，並且認識你所差來的耶穌基督，這就是永生。',
    '約17:4 我在地上已經榮耀你，你所託付我的事，我已成全了。',
    '約17:5 父啊，現在求你使我同你享榮耀，就是未有世界以先，我同你所有的榮耀。',
    '約17:6 你從世上賜給我的人，我已將你的名顯明與他們。他們本是你的，你將他們賜給我，他們也遵守了你的道。',
    '約17:7 如今他們知道，凡你所賜給我的，都是從你那裡來的；',
    '約17:8 因為你所賜給我的道，我已經賜給他們，他們也領受了，又確實知道，我是從你出來的，並且信你差了我來。',
    '約17:9 我為他們祈求，不為世人祈求，卻為你所賜給我的人祈求，因他們本是你的。',
    '約17:10 凡是我的，都是你的；你的也是我的，並且我因他們得了榮耀。',
    '約17:11 從今以後，我不在世上，他們卻在世上；我往你那裡去。聖父啊，求你因你所賜給我的名保守他們，叫他們合而為一像我們一樣。',
    '約17:12 我與他們同在的時候，因你所賜給我的名保守了他們，我也護衛了他們；其中除了那滅亡之子，沒有一個滅亡的，好叫經上的話得應驗。',
    '約17:13 現在我往你那裡去，我還在世上說這話，是叫他們心裡充滿我的喜樂。',
    '約17:14 我已將你的道賜給他們。世界又恨他們；因為他們不屬世界，正如我不屬世界一樣。',
    '約17:15 我不求你叫他們離開世界，只求你保守他們脫離那惡者（或作：脫離罪惡）。',
    '約17:16 他們不屬世界，正如我不屬世界一樣。',
    '約17:17 求你用真理使他們成聖；你的道就是真理。',
    '約17:18 你怎樣差我到世上，我也照樣差他們到世上。',
    '約17:19 我為他們的緣故，自己分別為聖，叫他們也因真理成聖。',
    '約17:20 我不但為這些人祈求，也為那些因他們的話信我的人祈求，',
    '約17:21 使他們都合而為一。正如你父在我裡面，我在你裡面，使他們也在我們裡面，叫世人可以信你差了我來。',
    '約17:22 你所賜給我的榮耀，我已賜給他們，使他們合而為一，像我們合而為一。',
    '約17:23 我在他們裡面，你在我裡面，使他們完完全全的合而為一，叫世人知道你差了我來，也知道你愛他們如同愛我一樣。',
    '約17:24 父啊，我在哪裡，願你所賜給我的人也同我在那裡，叫他們看見你所賜給我的榮耀；因為創立世界以前，你已經愛我了。',
    '約17:25 公義的父啊，世人未曾認識你，我卻認識你；這些人也知道你差了我來。',
    '約17:26 我已將你的名指示他們，還要指示他們，使你所愛我的愛在他們裡面，我也在他們裡面。',
    '約18:1 耶穌說了這話，就同門徒出去，過了汲淪溪。在那裡有一個園子，他和門徒進去了。',
    '約18:2 賣耶穌的猶大也知道那地方，因為耶穌和門徒屢次上那裡去聚集。',
    '約18:3 猶大領了一隊兵，和祭司長並法利賽人的差役，拿著燈籠、火把、兵器，就來到園裡。',
    '約18:4 耶穌知道將要臨到自己的一切事，就出來對他們說：你們找誰﹖',
    '約18:5 他們回答說：找拿撒勒人耶穌。耶穌說：我就是。賣他的猶大也同他們站在那裡。',
    '約18:6 耶穌一說我就是，他們就退後倒在地上。',
    '約18:7 他又問他們說：你們找誰﹖他們說：找拿撒勒人耶穌。',
    '約18:8 耶穌說：我已經告訴你們，我就是。你們若找我，就讓這些人去吧。',
    '約18:9 這要應驗耶穌從前的話，說：你所賜給我的人，我沒有失落一個。',
    '約18:10 西門彼得帶著一把刀，就拔出來，將大祭司的僕人砍了一刀，削掉他的右耳；那僕人名叫馬勒古。',
    '約18:11 耶穌就對彼得說：收刀入鞘吧，我父所給我的那杯，我豈可不喝呢﹖',
    '約18:12 那隊兵和千夫長，並猶太人的差役就拿住耶穌，把他捆綁了，',
    '約18:13 先帶到亞那面前，因為亞那是本年作大祭司該亞法的岳父。',
    '約18:14 這該亞法就是從前向猶太人發議論說一個人替百姓死是有益的那位。',
    '約18:15 西門彼得跟著耶穌，還有一個門徒跟著。那門徒是大祭司所認識的，他就同耶穌進了大祭司的院子。',
    '約18:16 彼得卻站在門外。大祭司所認識的那個門徒出來，和看門的使女說了一聲，就領彼得進去。',
    '約18:17 那看門的使女對彼得說：你不也是這人的門徒嗎﹖他說：我不是。',
    '約18:18 僕人和差役因為天冷，就生了炭火，站在那裡烤火；彼得也同他們站著烤火。',
    '約18:19 大祭司就以耶穌的門徒和他的教訓盤問他。',
    '約18:20 耶穌回答說：我從來是明明的對世人說話。我常在會堂和殿裡，就是猶太人聚集的地方教訓人；我在暗地裡並沒有說什麼。',
    '約18:21 你為什麼問我呢﹖可以問那聽見的人，我對他們說的是什麼；我所說的，他們都知道。',
    '約18:22 耶穌說了這話，旁邊站著的一個差役用手掌打他，說：你這樣回答大祭司嗎﹖',
    '約18:23 耶穌說：我若說的不是，你可以指證那不是；我若說的是，你為什麼打我呢﹖',
    '約18:24 亞那就把耶穌解到大祭司該亞法那裡，仍是捆著解去的。',
    '約18:25 西門彼得正站著烤火，有人對他說：你不也是他的門徒嗎﹖彼得不承認，說：我不是。',
    '約18:26 有大祭司的一個僕人，是彼得削掉耳朵那人的親屬，說：我不是看見你同他在園子裡嗎﹖',
    '約18:27 彼得又不承認。立時雞就叫了。',
    '約18:28 眾人將耶穌從該亞法那裡往衙門內解去，那時天還早。他們自己卻不進衙門，恐怕染了污穢，不能吃逾越節的筵席。',
    '約18:29 彼拉多就出來，到他們那裡，說：你們告這人是為什麼事呢﹖',
    '約18:30 他們回答說：這人若不是作惡的，我們就不把他交給你。',
    '約18:31 彼拉多說：你們自己帶他去，按著你們的律法審問他吧。猶太人說：我們沒有殺人的權柄。',
    '約18:32 這要應驗耶穌所說自己將要怎樣死的話了。',
    '約18:33 彼拉多又進了衙門，叫耶穌來，對他說：你是猶太人的王嗎﹖',
    '約18:34 耶穌回答說：這話是你自己說的，還是別人論我對你說的呢﹖',
    '約18:35 彼拉多說：我豈是猶太人呢﹖你本國的人和祭司長把你交給我。你做了什麼事呢﹖',
    '約18:36 耶穌回答說：我的國不屬這世界；我的國若屬這世界，我的臣僕必要爭戰，使我不至於被交給猶太人。只是我的國不屬這世界。',
    '約18:37 彼拉多就對他說：這樣，你是王嗎﹖耶穌回答說：你說我是王。我為此而生，也為此來到世間，特為給真理作見證。凡屬真理的人就聽我的話。',
    '約18:38 彼拉多說：真理是什麼呢﹖說了這話，又出來到猶太人那裡，對他們說：我查不出他有什麼罪來。',
    '約18:39 但你們有個規矩，在逾越節要我給你們釋放一個人，你們要我給你們釋放猶太人的王嗎﹖',
    '約18:40 他們又喊著說：不要這人，要巴拉巴！這巴拉巴是個強盜。',
    '約19:1 當下彼拉多將耶穌鞭打了。',
    '約19:2 兵丁用荊棘編做冠冕戴在他頭上，給他穿上紫袍，',
    '約19:3 又挨近他，說：恭喜，猶太人的王啊！他們就用手掌打他。',
    '約19:4 彼拉多又出來對眾人說：我帶他出來見你們，叫你們知道我查不出他有什麼罪來。',
    '約19:5 耶穌出來，戴著荊棘冠冕，穿著紫袍。彼拉多對他們說：你們看這個人！',
    '約19:6 祭司長和差役看見他，就喊著說：釘他十字架！釘他十字架！彼拉多說：你們自己把他釘十字架吧！我查不出他有什麼罪來。',
    '約19:7 猶太人回答說：我們有律法，按那律法，他是該死的，因他以自己為神的兒子。',
    '約19:8 彼拉多聽見這話，越發害怕，',
    '約19:9 又進衙門，對耶穌說：你是哪裡來的﹖耶穌卻不回答。',
    '約19:10 彼拉多說：你不對我說話嗎﹖你豈不知我有權柄釋放你，也有權柄把你釘十字架嗎﹖',
    '約19:11 耶穌回答說：若不是從上頭賜給你的，你就毫無權柄辦我。所以，把我交給你的那人罪更重了。',
    '約19:12 從此，彼拉多想要釋放耶穌，無奈猶太人喊著說：你若釋放這個人，就不是該撒的忠臣（原文作朋友）。凡以自己為王的，就是背叛該撒了。',
    '約19:13 彼拉多聽見這話，就帶耶穌出來，到了一個地方，名叫鋪華石處，希伯來話叫厄巴大，就在那裡坐堂。',
    '約19:14 那日是預備逾越節的日子，約有午正。彼拉多對猶太人說：看哪，這是你們的王！',
    '約19:15 他們喊著說：除掉他！除掉他！釘他在十字架上！彼拉多說：我可以把你們的王釘十字架嗎﹖祭司長回答說：除了該撒，我們沒有王。',
    '約19:16 於是彼拉多將耶穌交給他們去釘十字架。',
    '約19:17 他們就把耶穌帶了去。耶穌背著自己的十字架出來，到了一個地方，名叫髑髏地，希伯來話叫各各他。',
    '約19:18 他們就在那裡釘他在十字架上，還有兩個人和他一同釘著，一邊一個，耶穌在中間。',
    '約19:19 彼拉多又用牌子寫了一個名號，安在十字架上，寫的是：猶太人的王，拿撒勒人耶穌。',
    '約19:20 有許多猶太人念這名號；因為耶穌被釘十字架的地方與城相近，並且是用希伯來、羅馬、希利尼三樣文字寫的。',
    '約19:21 猶太人的祭司長就對彼拉多說：不要寫猶太人的王，要寫他自己說：我是猶太人的王。',
    '約19:22 彼拉多說：我所寫的，我已經寫上了。',
    '約19:23 兵丁既然將耶穌釘在十字架上，就拿他的衣服分為四分，每兵一分；又拿他的裡衣，這件裡衣原來沒有縫兒，是上下一片織成的。',
    '約19:24 他們就彼此說：我們不要撕開，只要拈鬮，看誰得著。這要應驗經上的話說：他們分了我的外衣，為我的裡衣拈鬮。兵丁果然做了這事。',
    '約19:25 站在耶穌十字架旁邊的，有他母親與他母親的姊妹，並革羅罷的妻子馬利亞，和抹大拉的馬利亞。',
    '約19:26 耶穌見母親和他所愛的那門徒站在旁邊，就對他母親說：母親（原文作婦人），看，你的兒子！',
    '約19:27 又對那門徒說：看，你的母親！從此，那門徒就接他到自己家裡去了。',
    '約19:28 這事以後，耶穌知道各樣的事已經成了，為要使經上的話應驗，就說：我渴了。',
    '約19:29 有一個器皿盛滿了醋，放在那裡；他們就拿海絨蘸滿了醋，綁在牛膝草上，送到他口。',
    '約19:30 耶穌嘗（原文作受）了那醋，就說：成了！便低下頭，將靈魂交付神了。',
    '約19:31 猶太人因這日是預備日，又因那安息日是個大日，就求彼拉多叫人打斷他們的腿，把他們拿去，免得屍首當安息日留在十字架上。',
    '約19:32 於是兵丁來，把頭一個人的腿，並與耶穌同釘第二個人的腿，都打斷了。',
    '約19:33 只是來到耶穌那裡，見他已經死了，就不打斷他的腿。',
    '約19:34 惟有一個兵拿槍扎他的肋旁，隨即有血和水流出來。',
    '約19:35 看見這事的那人就作見證─他的見證也是真的，並且他知道自己所說的是真的─叫你們也可以信。',
    '約19:36 這些事成了，為要應驗經上的話說：他的骨頭一根也不可折斷。',
    '約19:37 經上又有一句說：他們要仰望自己所扎的人。',
    '約19:38 這些事以後，有亞利馬太人約瑟，是耶穌的門徒，只因怕猶太人，就暗暗的作門徒。他來求彼拉多，要把耶穌的身體領去。彼拉多允准，他就把耶穌的身體領去了。',
    '約19:39 又有尼哥底母，就是先前夜裡去見耶穌的，帶著沒藥和沉香約有一百斤前來。',
    '約19:40 他們就照猶太人殯葬的規矩，把耶穌的身體用細麻布加上香料裹好了。',
    '約19:41 在耶穌釘十字架的地方有一個園子，園子裡有一座新墳墓，是從來沒有葬過人的。',
    '約19:42 只因是猶太人的預備日，又因那墳墓近，他們就把耶穌安放在那裡。',
    '約20:1 七日的第一日清早，天還黑的時候，抹大拉的馬利亞來到墳墓那裡，看見石頭從墳墓挪開了，',
    '約20:2 就跑來見西門彼得和耶穌所愛的那個門徒，對他們說：有人把主從墳墓裡挪了去，我們不知道放在哪裡。',
    '約20:3 彼得和那門徒就出來，往墳墓那裡去。',
    '約20:4 兩個人同跑，那門徒比彼得跑的更快，先到了墳墓，',
    '約20:5 低頭往裡看，就見細麻布還放在那裡，只是沒有進去。',
    '約20:6 西門彼得隨後也到了，進墳墓裡去，就看見細麻布還放在那裡，',
    '約20:7 又看見耶穌的裹頭巾沒有和細麻布放在一處，是另在一處捲著。',
    '約20:8 先到墳墓的那門徒也進去，看見就信了。',
    '約20:9 因為他們還不明白聖經的意思，就是耶穌必要從死裡復活。',
    '約20:10 於是兩個門徒回自己的住處去了。',
    '約20:11 馬利亞卻站在墳墓外面哭。哭的時候，低頭往墳墓裡看，',
    '約20:12 就見兩個天使，穿著白衣，在安放耶穌身體的地方坐著，一個在頭，一個在腳。',
    '約20:13 天使對他說：婦人，你為什麼哭﹖他說：因為有人把我主挪了去，我不知道放在哪裡。',
    '約20:14 說了這話，就轉過身來，看見耶穌站在那裡，卻不知道是耶穌。',
    '約20:15 耶穌問他說：婦人，為什麼哭﹖你找誰呢﹖馬利亞以為是看園的，就對他說：先生，若是你把他移了去，請告訴我，你把他放在哪裡，我便去取他。',
    '約20:16 耶穌說：馬利亞。馬利亞就轉過來，用希伯來話對他說：拉波尼！（拉波尼就是夫子的意思。）',
    '約20:17 耶穌說：不要摸我，因我還沒有升上去見我的父。你往我弟兄那裡去，告訴他們說，我要升上去見我的父，也是你們的父，見我的神，也是你們的神。',
    '約20:18 抹大拉的馬利亞就去告訴門徒說：我已經看見了主。他又將主對他說的這話告訴他們。',
    '約20:19 那日（就是七日的第一日）晚上，門徒所在的地方，因怕猶太人，門都關了。耶穌來，站在當中，對他們說：願你們平安！',
    '約20:20 說了這話，就把手和肋旁指給他們看。門徒看見主，就喜樂了。',
    '約20:21 耶穌又對他們說：願你們平安！父怎樣差遣了我，我也照樣差遣你們。',
    '約20:22 說了這話，就向他們吹一口氣，說：你們受聖靈！',
    '約20:23 你們赦免誰的罪，誰的罪就赦免了；你們留下誰的罪，誰的罪就留下了。',
    '約20:24 那十二個門徒中，有稱為低土馬的多馬；耶穌來的時候，他沒有和他們同在。',
    '約20:25 那些門徒就對他說：我們已經看見主了。多馬卻說：我非看見他手上的釘痕，用指頭探入那釘痕，又用手探入他的肋旁，我總不信。',
    '約20:26 過了八日，門徒又在屋裡，多馬也和他們同在，門都關了。耶穌來，站在當中說：願你們平安！',
    '約20:27 就對多馬說：伸過你的指頭來，摸（原文是看）我的手；伸出你的手來，探入我的肋旁。不要疑惑，總要信。',
    '約20:28 多馬說：我的主！我的神！',
    '約20:29 耶穌對他說：你因看見了我才信；那沒有看見就信的有福了。',
    '約20:30 耶穌在門徒面前另外行了許多神蹟，沒有記在這書上。',
    '約20:31 但記這些事要叫你們信耶穌是基督，是神的兒子，並且叫你們信了他，就可以因他的名得生命。',
    '約21:1 這些事以後，耶穌在提比哩亞海邊又向門徒顯現。他怎樣顯現記在下面：',
    '約21:2 有西門彼得和稱為低土馬的多馬，並加利利的迦拿人拿但業，還有西庇太的兩個兒子，又有兩個門徒，都在一處。',
    '約21:3 西門彼得對他們說：我打魚去。他們說：我們也和你同去。他們就出去，上了船；那一夜並沒有打著什麼。',
    '約21:4 天將亮的時候，耶穌站在岸上，門徒卻不知道是耶穌。',
    '約21:5 耶穌就對他們說：小子！你們有吃的沒有﹖他們回答說：沒有。',
    '約21:6 耶穌說：你們把網撒在船的右邊，就必得著。他們便撒下網去，竟拉不上來了，因為魚甚多。',
    '約21:7 耶穌所愛的那門徒對彼得說：是主！那時西門彼得赤著身子，一聽見是主，就束上一件外衣，跳在海裡。',
    '約21:8 其餘的門徒離岸不遠，約有二百肘（古代以肘為尺，一肘約有今時尺半），就在小船上把那網魚拉過來。',
    '約21:9 他們上了岸，就看見那裡有炭火，上面有魚，又有餅。',
    '約21:10 耶穌對他們說：把剛才打的魚拿幾條來。',
    '約21:11 西門彼得就去（或作：上船），把網拉到岸上。那網滿了大魚，共一百五十三條；魚雖這樣多，網卻沒有破。',
    '約21:12 耶穌說：你們來吃早飯。門徒中沒有一個敢問他：你是誰﹖因為知道是主。',
    '約21:13 耶穌就來拿餅和魚給他們。',
    '約21:14 耶穌從死裡復活以後，向門徒顯現，這是第三次。',
    '約21:15 他們吃完了早飯，耶穌對西門彼得說：約翰（在太16：17稱約拿）的兒子西門，你愛我比這些更深嗎﹖彼得說：主啊，是的，你知道我愛你。耶穌對他說：你餵養我的小羊。',
    '約21:16 耶穌第二次又對他說：約翰的兒子西門，你愛我嗎﹖彼得說：主啊，是的，你知道我愛你。耶穌說：你牧養我的羊。',
    '約21:17 第三次對他說：約翰的兒子西門﹐你愛我嗎﹖彼得因為耶穌第三次對他說你愛我嗎，就憂愁，對耶穌說：主啊，你是無所不知的；你知道我愛你。耶穌說：你餵養我的羊。',
    '約21:18 我實實在在的告訴你，你年少的時候，自己束上帶子，隨意往來；但年老的時候，你要伸出手來，別人要把你束上，帶你到不願意去的地方。',
    '約21:19 耶穌說這話是指著彼得要怎樣死，榮耀神。說了這話，就對他說：你跟從我吧！',
    '約21:20 彼得轉過來，看見耶穌所愛的那門徒跟著，（就是在晚飯的時候，靠著耶穌胸膛說：「主啊，賣你的是誰﹖」的那門徒。）',
    '約21:21 彼得看見他，就問耶穌說：主啊，這人將來如何﹖',
    '約21:22 耶穌對他說：我若要他等到我來的時候，與你何干﹖你跟從我吧！',
    '約21:23 於是這話傳在弟兄中間，說那門徒不死。其實，耶穌不是說他不死，乃是說：我若要他等到我來的時候，與你何干﹖',
    '約21:24 為這些事作見證，並且記載這些事的就是這門徒；我們也知道他的見證是真的。',
    '約21:25 耶穌所行的事還有許多，若是一一的都寫出來，我想，所寫的書就是世界也容不下了。',
    '徒1:1 提阿非羅啊，我已經作了前書，論到耶穌開頭一切所行所教訓的，',
    '徒1:2 直到他藉著聖靈吩咐所揀選的使徒，以後被接上升的日子為止。',
    '徒1:3 他受害之後，用許多的憑據將自己活活的顯給使徒看，四十天之久向他們顯現，講說神國的事。',
    '徒1:4 耶穌和他們聚集的時候，囑咐他們說：不要離開耶路撒冷，要等候父所應許的，就是你們聽見我說過的。',
    '徒1:5 約翰是用水施洗，但不多幾日，你們要受聖靈的洗。',
    '徒1:6 他們聚集的時候，問耶穌說：主啊，你復興以色列國就在這時候嗎﹖',
    '徒1:7 耶穌對他們說：父憑著自己的權柄所定的時候、日期，不是你們可以知道的。',
    '徒1:8 但聖靈降臨在你們身上，你們就必得著能力，並要在耶路撒冷、猶太全地，和撒瑪利亞，直到地極，作我的見證。',
    '徒1:9 說了這話，他們正看的時候，他就被取上升，有一朵雲彩把他接去，便看不見他了。',
    '徒1:10 當他往上去，他們定睛望天的時候，忽然有兩個人身穿白衣，站在旁邊，說：',
    '徒1:11 加利利人哪，你們為什麼站著望天呢﹖這離開你們被接升天的耶穌，你們見他怎樣往天上去，他還要怎樣來。',
    '徒1:12 有一座山，名叫橄欖山，離耶路撒冷不遠，約有安息日可走的路程。當下，門徒從那裡回耶路撒冷去，',
    '徒1:13 進了城，就上了所住的一間樓房；在那裡有彼得、約翰、雅各、安得烈、腓力、多馬、巴多羅買、馬太、亞勒腓的兒子雅各、奮銳黨的西門，和雅各的兒子（或作：兄弟）猶大。',
    '徒1:14 這些人同著幾個婦人和耶穌的母親馬利亞，並耶穌的弟兄，都同心合意的恆切禱告。',
    '徒1:15 那時，有許多人聚會，約有一百二十名，彼得就在弟兄中間站起來，說：',
    '徒1:16 弟兄們！聖靈藉大衛的口，在聖經上預言領人捉拿耶穌的猶大，這話是必須應驗的。',
    '徒1:17 他本來列在我們數中，並且在使徒的職任上得了一分。',
    '徒1:18 這人用他作惡的工價買了一塊田，以後身子仆倒，肚腹崩裂，腸子都流出來。',
    '徒1:19 住在耶路撒冷的眾人都知道這事，所以按著他們那裡的話給那塊田起名叫亞革大馬，就是血田的意思。',
    '徒1:20 因為詩篇上寫著，說：願他的住處變為荒場，無人在內居住；又說：願別人得他的職分。',
    '徒1:21 所以，主耶穌在我們中間始終出入的時候，',
    '徒1:22 就是從約翰施洗起，直到主離開我們被接上升的日子為止，必須從那常與我們作伴的人中立一位與我們同作耶穌復活的見證。',
    '徒1:23 於是選舉兩個人，就是那叫做巴撒巴，又稱呼猶士都的約瑟，和馬提亞。',
    '徒1:24 眾人就禱告說：主啊，你知道萬人的心，求你從這兩個人中，指明你所揀選的是誰，叫他得這使徒的位分。這位分猶大已經丟棄，往自己的地方去了。',
    '徒1:25 併於上節。',
    '徒1:26 於是眾人為他們搖籤，搖出馬提亞來；他就和十一個使徒同列。',
    '徒2:1 五旬節到了，門徒都聚集在一處。',
    '徒2:2 忽然，從天上有響聲下來，好像一陣大風吹過，充滿了他們所坐的屋子，',
    '徒2:3 又有舌頭如火焰顯現出來，分開落在他們各人頭上。',
    '徒2:4 他們就都被聖靈充滿，按著聖靈所賜的口才說起別國的話來。',
    '徒2:5 那時，有虔誠的猶太人從天下各國來，住在耶路撒冷。',
    '徒2:6 這聲音一響，眾人都來聚集，各人聽見門徒用眾人的鄉談說話，就甚納悶；',
    '徒2:7 都驚訝希奇說：看哪，這說話的不都是加利利人嗎﹖',
    '徒2:8 我們各人，怎麼聽見他們說我們生來所用的鄉談呢﹖',
    '徒2:9 我們帕提亞人、瑪代人、以攔人，和住在米所波大米、猶太、加帕多家、本都、亞西亞、',
    '徒2:10 弗呂家、旁非利亞、埃及的人，並靠近古利奈的呂彼亞一帶地方的人，從羅馬來的客旅中，或是猶太人，或是進猶太教的人，',
    '徒2:11 革哩底和亞拉伯人，都聽見他們用我們的鄉談，講說神的大作為。',
    '徒2:12 眾人就都驚訝猜疑，彼此說：這是什麼意思呢﹖',
    '徒2:13 還有人譏誚說：他們無非是新酒灌滿了。',
    '徒2:14 彼得和十一個使徒站起，高聲說：猶太人和一切住在耶路撒冷的人哪，這件事你們當知道，也當側耳聽我的話。',
    '徒2:15 你們想這些人是醉了；其實不是醉了，因為時候剛到巳初。',
    '徒2:16 這正是先知約珥所說的：',
    '徒2:17 神說：在末後的日子，我要將我的靈澆灌凡有血氣的。你們的兒女要說預言；你們的少年人要見異象；老年人要做異夢。',
    '徒2:18 在那些日子，我要將我的靈澆灌我的僕人和使女，他們就要說預言。',
    '徒2:19 在天上、我要顯出奇事；在地下、我要顯出神蹟；有血，有火，有煙霧。',
    '徒2:20 日頭要變為黑暗，月亮要變為血；這都在主大而明顯的日子未到以前。',
    '徒2:21 到那時候，凡求告主名的，就必得救。',
    '徒2:22 以色列人哪，請聽我的話：神藉著拿撒勒人耶穌在你們中間施行異能、奇事、神蹟，將他證明出來，這是你們自己知道的。',
    '徒2:23 他既按著神的定旨先見被交與人，你們就藉著無法之人的手，把他釘在十字架上，殺了。',
    '徒2:24 神卻將死的痛苦解釋了，叫他復活，因為他原不能被死拘禁。',
    '徒2:25 大衛指著他說：我看見主常在我眼前；他在我右邊，叫我不至於搖動。',
    '徒2:26 所以，我心裡歡喜，我的靈（原文是舌）快樂；並且我的肉身要安居在指望中。',
    '徒2:27 因你必不將我的靈魂撇在陰間，也不叫你的聖者見朽壞。',
    '徒2:28 你已將生命的道路指示我，必叫我因見你的面（或作：叫我在你面前）得著滿足的快樂。',
    '徒2:29 弟兄們！先祖大衛的事，我可以明明的對你們說：他死了，也葬埋了，並且他的墳墓直到今日還在我們這裡。',
    '徒2:30 大衛既是先知，又曉得神曾向他起誓，要從他的後裔中立一位坐在他的寶座上，',
    '徒2:31 就預先看明這事，講論基督復活說：他的靈魂不撇在陰間；他的肉身也不見朽壞。',
    '徒2:32 這耶穌，神已經叫他復活了，我們都為這事作見證。',
    '徒2:33 他既被神的右手高舉（或作：他既高舉在神的右邊），又從父受了所應許的聖靈，就把你們所看見所聽見的，澆灌下來。',
    '徒2:34 大衛並沒有升到天上，但自己說：主對我主說：你坐在我的右邊，',
    '徒2:35 等我使你仇敵作你的腳凳。',
    '徒2:36 故此，以色列全家當確實的知道，你們釘在十字架上的這位耶穌，神已經立他為主，為基督了。',
    '徒2:37 眾人聽見這話，覺得扎心，就對彼得和其餘的使徒說：弟兄們，我們當怎樣行﹖',
    '徒2:38 彼得說：你們各人要悔改，奉耶穌基督的名受洗，叫你們的罪得赦，就必領受所賜的聖靈；',
    '徒2:39 因為這應許是給你們和你們的兒女，並一切在遠方的人，就是主─我們神所召來的。',
    '徒2:40 彼得還用許多話作見證，勸勉他們說：你們當救自己脫離這彎曲的世代。',
    '徒2:41 於是領受他話的人就受了洗。那一天，門徒約添了三千人，',
    '徒2:42 都恆心遵守使徒的教訓，彼此交接，擘餅，祈禱。',
    '徒2:43 眾人都懼怕；使徒又行了許多奇事神蹟。',
    '徒2:44 信的人都在一處，凡物公用；',
    '徒2:45 並且賣了田產，家業，照各人所需用的分給各人。',
    '徒2:46 他們天天同心合意恆切的在殿裡，且在家中擘餅，存著歡喜、誠實的心用飯，',
    '徒2:47 讚美神，得眾民的喜愛。主將得救的人天天加給他們。',
    '徒3:1 申初禱告的時候，彼得、約翰上聖殿去。',
    '徒3:2 有一個人，生來是瘸腿的，天天被人擡來，放在殿的一個門口，那門名叫美門，要求進殿的人賙濟。',
    '徒3:3 他看見彼得、約翰將要進殿，就求他們賙濟。',
    '徒3:4 彼得約翰定睛看他；彼得說：你看我們！',
    '徒3:5 那人就留意看他們，指望得著什麼。',
    '徒3:6 彼得說：金銀我都沒有，只把我所有的給你：我奉拿撒勒人耶穌基督的名，叫你起來行走！',
    '徒3:7 於是拉著他的右手，扶他起來；他的腳和踝子骨立刻健壯了，',
    '徒3:8 就跳起來，站著，又行走，同他們進了殿，走著，跳著，讚美神。',
    '徒3:9 百姓都看見他行走，讚美神；',
    '徒3:10 認得他是那素常坐在殿的美門口求賙濟的，就因他所遇著的事滿心希奇、驚訝。',
    '徒3:11 那人正在稱為所羅門的廊下，拉著彼得、約翰；眾百姓一齊跑到他們那裡，很覺希奇。',
    '徒3:12 彼得看見，就對百姓說：以色列人哪，為什麼把這事當作希奇呢﹖為什麼定睛看我們，以為我們憑自己的能力和虔誠使這人行走呢﹖',
    '徒3:13 亞伯拉罕、以撒、雅各的神，就是我們列祖的神，已經榮耀了他的僕人（或作：兒子）耶穌；你們卻把他交付彼拉多。彼拉多定意要釋放他，你們竟在彼拉多面前棄絕了他。',
    '徒3:14 你們棄絕了那聖潔公義者，反求著釋放一個兇手給你們。',
    '徒3:15 你們殺了那生命的主，神卻叫他從死裡復活了；我們都是為這事作見證。',
    '徒3:16 我們因信他的名，他的名便叫你們所看見所認識的這人健壯了；正是他所賜的信心，叫這人在你們眾人面前全然好了。',
    '徒3:17 弟兄們，我曉得你們做這事是出於不知，你們的官長也是如此。',
    '徒3:18 但神曾藉眾先知的口，預言基督將要受害，就這樣應驗了。',
    '徒3:19 所以，你們當悔改歸正，使你們的罪得以塗抹，這樣，那安舒的日子就必從主面前來到；',
    '徒3:20 主也必差遣所預定給你們的基督耶穌降臨。',
    '徒3:21 天必留他，等到萬物復興的時候，就是神從創世以來、藉著聖先知的口所說的。',
    '徒3:22 摩西曾說：主─神要從你們弟兄中間給你們興起一位先知像我，凡他向你們所說的，你們都要聽從。',
    '徒3:23 凡不聽從那先知的，必要從民中全然滅絕。',
    '徒3:24 從撒母耳以來的眾先知，凡說預言的，也都說到這些日子。',
    '徒3:25 你們是先知的子孫，也承受神與你們祖宗所立的約，就是對亞伯拉罕說：地上萬族都要因你的後裔得福。',
    '徒3:26 神既興起他的僕人（或作：兒子），就先差他到你們這裡來，賜福給你們，叫你們各人回轉，離開罪惡。',
    '徒4:1 使徒對百姓說話的時候，祭司們和守殿官，並撒都該人忽然來了。',
    '徒4:2 因他們教訓百姓，本著耶穌，傳說死人復活，就很煩惱，',
    '徒4:3 於是下手拿住他們；因為天已經晚了，就把他們押到第二天。',
    '徒4:4 但聽道之人有許多信的，男丁數目約到五千。',
    '徒4:5 第二天，官府、長老，和文士在耶路撒冷聚會，',
    '徒4:6 又有大祭司亞那和該亞法、約翰、亞力山大，並大祭司的親族都在那裡，',
    '徒4:7 叫使徒站在當中，就問他們說：你們用什麼能力，奉誰的名做這事呢﹖',
    '徒4:8 那時彼得被聖靈充滿，對他們說：',
    '徒4:9 治民的官府和長老啊，倘若今日因為在殘疾人身上所行的善事查問我們他是怎麼得了痊癒，',
    '徒4:10 你們眾人和以色列百姓都當知道，站在你們面前的這人得痊癒是因你們所釘十字架、神叫他從死裡復活的拿撒勒人耶穌基督的名。',
    '徒4:11 他是你們匠人所棄的石頭，已成了房角的頭塊石頭。',
    '徒4:12 除他以外，別無拯救；因為在天下人間，沒有賜下別的名，我們可以靠著得救。',
    '徒4:13 他們見彼得、約翰的膽量，又看出他們原是沒有學問的小民，就希奇，認明他們是跟過耶穌的；',
    '徒4:14 又看見那治好了的人和他們一同站著，就無話可駁。',
    '徒4:15 於是吩咐他們從公會出去，就彼此商議說：',
    '徒4:16 我們當怎樣辦這兩個人呢﹖因為他們誠然行了一件明顯的神蹟，凡住耶路撒冷的人都知道，我們也不能說沒有。',
    '徒4:17 惟恐這事越發傳揚在民間，我們必須恐嚇他們，叫他們不再奉這名對人講論。',
    '徒4:18 於是叫了他們來，禁止他們總不可奉耶穌的名講論教訓人。',
    '徒4:19 彼得、約翰說：聽從你們，不聽從神，這在神面前合理不合理，你們自己酌量吧！',
    '徒4:20 我們所看見所聽見的，不能不說。',
    '徒4:21 官長為百姓的緣故，想不出法子刑罰他們，又恐嚇一番，把他們釋放了。這是因眾人為所行的奇事都歸榮耀與神。',
    '徒4:22 原來藉著神蹟醫好的那人有四十多歲了。',
    '徒4:23 二人既被釋放，就到會友那裡去，把祭司長和長老所說的話都告訴他們。',
    '徒4:24 他們聽見了，就同心合意的高聲向神說：主啊！你是造天、地、海，和其中萬物的，',
    '徒4:25 你曾藉著聖靈，託你僕人─我們祖宗大衛的口，說：外邦為什麼爭鬧﹖萬民為什麼謀算虛妄的事﹖',
    '徒4:26 世上的君王一齊起來，臣宰也聚集，要敵擋主，並主的受膏者（或作：基督）。',
    '徒4:27 希律和本丟彼拉多，外邦人和以色列民，果然在這城裡聚集，要攻打你所膏的聖僕（僕：或作子）耶穌，',
    '徒4:28 成就你手和你意旨所預定必有的事。',
    '徒4:29 他們恐嚇我們，現在求主鑒察，一面叫你僕人大放膽量講你的道，一面伸出你的手來醫治疾病，並且使神蹟奇事因著你聖僕（僕：或作子）耶穌的名行出來。',
    '徒4:30 併於上節。',
    '徒4:31 禱告完了，聚會的地方震動，他們就都被聖靈充滿，放膽講論神的道。',
    '徒4:32 那許多信的人都是一心一意的，沒有一人說他的東西有一樣是自己的，都是大家公用。',
    '徒4:33 使徒大有能力，見證主耶穌復活；眾人也都蒙大恩。',
    '徒4:34 內中也沒有一個缺乏的，因為人人將田產房屋都賣了，把所賣的價銀拿來，放在使徒腳前，',
    '徒4:35 照各人所需用的，分給各人。',
    '徒4:36 有一個利未人，生在居比路，名叫約瑟，使徒稱他為巴拿巴（巴拿巴翻出來就是勸慰子）。',
    '徒4:37 他有田地，也賣了，把價銀拿來，放在使徒腳前。',
    '徒5:1 有一個人，名叫亞拿尼亞，同他的妻子撒非喇賣了田產，',
    '徒5:2 把價銀私自留下幾分，他的妻子也知道，其餘的幾分拿來放在使徒腳前。',
    '徒5:3 彼得說：亞拿尼亞！為什麼撒但充滿了你的心，叫你欺哄聖靈，把田地的價銀私自留下幾分呢﹖',
    '徒5:4 田地還沒有賣，不是你自己的嗎﹖既賣了，價銀不是你作主嗎﹖你怎麼心裡起這意念呢﹖你不是欺哄人，是欺哄神了。',
    '徒5:5 亞拿尼亞聽見這話，就仆倒，斷了氣；聽見的人都甚懼怕。',
    '徒5:6 有些少年人起來，把他包裹，擡出去埋葬了。',
    '徒5:7 約過了三小時，他的妻子進來，還不知道這事。',
    '徒5:8 彼得對他說：你告訴我，你們賣田地的價銀就是這些嗎﹖他說：就是這些。',
    '徒5:9 彼得說：你們為什麼同心試探主的靈呢﹖埋葬你丈夫之人的腳已到門口，他們也要把你擡出去。',
    '徒5:10 婦人立刻仆倒在彼得腳前，斷了氣。那些少年人進來，見他已經死了，就擡出去，埋在他丈夫旁邊。',
    '徒5:11 全教會和聽見這事的人都甚懼怕。',
    '徒5:12 主藉使徒的手在民間行了許多神蹟奇事；他們（或作：信的人）都同心合意的在所羅門的廊下。',
    '徒5:13 其餘的人沒有一個敢貼近他們，百姓卻尊重他們。',
    '徒5:14 信而歸主的人越發增添，連男帶女很多。',
    '徒5:15 甚至有人將病人擡到街上，放在床上或褥子上，指望彼得過來的時候，或者得他的影兒照在什麼人身上。',
    '徒5:16 還有許多人帶著病人和被污鬼纏磨的，從耶路撒冷四圍的城邑來，全都得了醫治。',
    '徒5:17 大祭司和他的一切同人，就是撒都該教門的人，都起來，滿心忌恨，',
    '徒5:18 就下手拿住使徒，收在外監。',
    '徒5:19 但主的使者夜間開了監門，領他們出來，',
    '徒5:20 說：你們去站在殿裡，把這生命的道都講給百姓聽。',
    '徒5:21 使徒聽了這話，天將亮的時候就進殿裡去教訓人。大祭司和他的同人來了，叫齊公會的人，和以色列族的眾長老，就差人到監裡去，要把使徒提出來。',
    '徒5:22 但差役到了，不見他們在監裡，就回來稟報說：',
    '徒5:23 我們看見監牢關得極妥當，看守的人也站在門外；及至開了門，裡面一個人都不見。',
    '徒5:24 守殿官和祭司長聽見這話，心裡犯難，不知這事將來如何。',
    '徒5:25 有一個人來稟報說：你們收在監裡的人，現在站在殿裡教訓百姓。',
    '徒5:26 於是守殿官和差役去帶使徒來，並沒有用強暴，因為怕百姓用石頭打他們。',
    '徒5:27 帶到了，便叫使徒站在公會前；大祭司問他們說：',
    '徒5:28 我們不是嚴嚴的禁止你們，不可奉這名教訓人嗎﹖你們倒把你們的道理充滿了耶路撒冷，想要叫這人的血歸到我們身上！',
    '徒5:29 彼得和眾使徒回答說：順從神，不順從人，是應當的。',
    '徒5:30 你們掛在木頭上殺害的耶穌，我們祖宗的神已經叫他復活。',
    '徒5:31 神且用右手將他高舉（或作：他就是神高舉在自己的右邊），叫他作君王，作救主，將悔改的心和赦罪的恩賜給以色列人。',
    '徒5:32 我們為這事作見證；神賜給順從之人的聖靈也為這事作見證。',
    '徒5:33 公會的人聽見就極其惱怒，想要殺他們。',
    '徒5:34 但有一個法利賽人，名叫迦瑪列，是眾百姓所敬重的教法師，在公會中站起來，吩咐人把使徒暫且帶到外面去，',
    '徒5:35 就對眾人說：以色列人哪，論到這些人，你們應當小心怎樣辦理。',
    '徒5:36 從前丟大起來，自誇為大；附從他的人約有四百，他被殺後，附從他的全都散了，歸於無有。',
    '徒5:37 此後，報名上冊的時候，又有加利利的猶大起來，引誘些百姓跟從他；他也滅亡，附從他的人也都四散了。',
    '徒5:38 現在，我勸你們不要管這些人，任憑他們吧！他們所謀的、所行的，若是出於人，必要敗壞；',
    '徒5:39 若是出於神，你們就不能敗壞他們，恐怕你們倒是攻擊神了。',
    '徒5:40 公會的人聽從了他，便叫使徒來，把他們打了，又吩咐他們不可奉耶穌的名講道，就把他們釋放了。',
    '徒5:41 他們離開公會，心裡歡喜，因被算是配為這名受辱。',
    '徒5:42 他們就每日在殿裡、在家裡、不住的教訓人，傳耶穌是基督。',
    '徒6:1 那時，門徒增多，有說希利尼話的猶太人向希伯來人發怨言，因為在天天的供給上忽略了他們的寡婦。',
    '徒6:2 十二使徒叫眾門徒來，對他們說：我們撇下神的道去管理飯食，原是不合宜的。',
    '徒6:3 所以弟兄們，當從你們中間選出七個有好名聲、被聖靈充滿、智慧充足的人，我們就派他們管理這事。',
    '徒6:4 但我們要專心以祈禱、傳道為事。',
    '徒6:5 大眾都喜悅這話，就揀選了司提反，乃是大有信心、聖靈充滿的人，又揀選腓利、伯羅哥羅、尼迦挪、提門、巴米拿，並進猶太教的安提阿人尼哥拉，',
    '徒6:6 叫他們站在使徒面前。使徒禱告了，就按手在他們頭上。',
    '徒6:7 神的道興旺起來；在耶路撒冷門徒數目加增的甚多，也有許多祭司信從了這道。',
    '徒6:8 司提反滿得恩惠、能力，在民間行了大奇事和神蹟。',
    '徒6:9 當時有稱利百地拿會堂的幾個人，並有古利奈、亞力山太、基利家、亞西亞、各處會堂的幾個人，都起來和司提反辯論。',
    '徒6:10 司提反是以智慧和聖靈說話，眾人敵擋不住，',
    '徒6:11 就買出人來說：我們聽見他說謗讟摩西和神的話。',
    '徒6:12 他們又聳動了百姓、長老，並文士，就忽然來捉拿他，把他帶到公會去，',
    '徒6:13 設下假見證，說：這個人說話，不住的蹧踐聖所和律法。',
    '徒6:14 我們曾聽見他說：這拿撒勒人耶穌要毀壞此地，也要改變摩西所交給我們的規條。',
    '徒6:15 在公會裡坐著的人都定睛看他，見他的面貌，好像天使的面貌。',
    '徒7:1 大祭司就說：這些事果然有嗎﹖',
    '徒7:2 司提反說：諸位父兄請聽！當日我們的祖宗亞伯拉罕在米所波大米還未住哈蘭的時候，榮耀的神向他顯現，',
    '徒7:3 對他說：你要離開本地和親族，往我所要指示你的地方去。',
    '徒7:4 他就離開迦勒底人之地，住在哈蘭。他父親死了以後，神使他從那裡搬到你們現在所住之地。',
    '徒7:5 在這地方，神並沒有給他產業，連立足之地也沒有給他；但應許要將這地賜給他和他的後裔為業；那時他還沒有兒子。',
    '徒7:6 神說：他的後裔必寄居外邦，那裡的人要叫他們作奴僕，苦待他們四百年。',
    '徒7:7 神又說：使他們作奴僕的那國，我要懲罰。以後他們要出來，在這地方事奉我。',
    '徒7:8 神又賜他割禮的約。於是亞伯拉罕生了以撒，第八日給他行了割禮。以撒生雅各，雅各生十二位先祖。',
    '徒7:9 先祖嫉妒約瑟，把他賣到埃及去；神卻與他同在，',
    '徒7:10 救他脫離一切苦難，又使他在埃及王法老面前得恩典，有智慧。法老就派他作埃及國的宰相兼管全家。',
    '徒7:11 後來埃及和迦南全地遭遇饑荒，大受艱難，我們的祖宗就絕了糧。',
    '徒7:12 雅各聽見在埃及有糧，就打發我們的祖宗初次往那裡去。',
    '徒7:13 第二次約瑟與弟兄們相認，他的親族也被法老知道了。',
    '徒7:14 約瑟就打發弟兄請父親雅各和全家七十五個人都來。',
    '徒7:15 於是雅各下了埃及，後來他和我們的祖宗都死在那裡；',
    '徒7:16 又被帶到示劍，葬於亞伯拉罕在示劍用銀子從哈抹子孫買來的墳墓裡。',
    '徒7:17 及至神應許亞伯拉罕的日期將到，以色列民在埃及興盛眾多，',
    '徒7:18 直到有不曉得約瑟的新王興起。',
    '徒7:19 他用詭計待我們的宗族，苦害我們的祖宗，叫他們丟棄嬰孩，使嬰孩不能存活。',
    '徒7:20 那時，摩西生下來，俊美非凡，在他父親家裡撫養了三個月。',
    '徒7:21 他被丟棄的時候，法老的女兒拾了去，養為自己的兒子。',
    '徒7:22 摩西學了埃及人一切的學問，說話行事都有才能。',
    '徒7:23 他將到四十歲，心中起意去看望他的弟兄以色列人；',
    '徒7:24 到了那裡，見他們一個人受冤屈，就護庇他，為那受欺壓的人報仇，打死了那埃及人。',
    '徒7:25 他以為弟兄必明白神是藉他的手搭救他們；他們卻不明白。',
    '徒7:26 第二天，遇見兩個以色列人爭鬥，就勸他們和睦，說：你們二位是弟兄，為什麼彼此欺負呢﹖',
    '徒7:27 那欺負鄰舍的把他推開，說：誰立你作我們的首領和審判官呢﹖',
    '徒7:28 難道你要殺我，像昨天殺那埃及人嗎﹖',
    '徒7:29 摩西聽見這話就逃走了，寄居於米甸；在那裡生了兩個兒子。',
    '徒7:30 過了四十年，在西乃山的曠野，有一位天使從荊棘火焰中向摩西顯現。',
    '徒7:31 摩西見了那異象，便覺希奇，正進前觀看的時候，有主的聲音說：',
    '徒7:32 我是你列祖的神，就是亞伯拉罕的神，以撒的神，雅各的神。摩西戰戰兢兢，不敢觀看。',
    '徒7:33 主對他說：把你腳上的鞋脫下來；因為你所站之地是聖地。',
    '徒7:34 我的百姓在埃及所受的困苦，我實在看見了，他們悲歎的聲音，我也聽見了。我下來要救他們。你來！我要差你往埃及去。',
    '徒7:35 這摩西就是百姓棄絕說誰立你作我們的首領和審判官的；神卻藉那在荊棘中顯現之使者的手差派他作首領、作救贖的。',
    '徒7:36 這人領百姓出來，在埃及，在紅海、在曠野，四十年間行了奇事神蹟。',
    '徒7:37 那曾對以色列人說神要從你們弟兄中間給你們興起一位先知像我的，就是這位摩西。',
    '徒7:38 這人曾在曠野會中和西乃山上，與那對他說話的天使同在，又與我們的祖宗同在，並且領受活潑的聖言傳給我們。',
    '徒7:39 我們的祖宗不肯聽從，反棄絕他，心裡歸向埃及，',
    '徒7:40 對亞倫說：你且為我們造些神像，在我們前面引路；因為領我們出埃及地的那個摩西，我們不知道他遭了什麼事。',
    '徒7:41 那時，他們造了一個牛犢，又拿祭物獻給那像，歡喜自己手中的工作。',
    '徒7:42 神就轉臉不顧，任憑他們事奉天上的日月星辰，正如先知書上所寫的說：以色列家啊，你們四十年間在曠野，豈是將犧牲和祭物獻給我嗎﹖',
    '徒7:43 你們擡著摩洛的帳幕和理番神的星，就是你們所造為要敬拜的像。因此，我要把你們遷到巴比倫外去。',
    '徒7:44 我們的祖宗在曠野，有法櫃的帳幕，是神吩咐摩西叫他照所看見的樣式做的。',
    '徒7:45 這帳幕，我們的祖宗相繼承受。當神在他們面前趕出外邦人去的時候，他們同約書亞把帳幕搬進承受為業之地，直存到大衛的日子。',
    '徒7:46 大衛在神面前蒙恩，祈求為雅各的神預備居所；',
    '徒7:47 卻是所羅門為神造成殿宇。',
    '徒7:48 其實，至高者並不住人手所造的，就如先知所言：',
    '徒7:49 主說：天是我的座位，地是我的腳凳；你們要為我造何等的殿宇﹖哪裡是我安息的地方呢﹖',
    '徒7:50 這一切不都是我手所造的嗎﹖',
    '徒7:51 你們這硬著頸項、心與耳未受割禮的人，常時抗拒聖靈！你們的祖宗怎樣，你們也怎樣。',
    '徒7:52 哪一個先知不是你們祖宗逼迫呢﹖他們也把預先傳說那義者要來的人殺了；如今你們又把那義者賣了，殺了。',
    '徒7:53 你們受了天使所傳的律法，竟不遵守。',
    '徒7:54 眾人聽見這話就極其惱怒，向司提反咬牙切齒。',
    '徒7:55 但司提反被聖靈充滿，定睛望天，看見神的榮耀，又看見耶穌站在神的右邊，',
    '徒7:56 就說：我看見天開了，人子站在神的右邊。',
    '徒7:57 眾人大聲喊叫，摀著耳朵，齊心擁上前去，',
    '徒7:58 把他推到城外，用石頭打他。作見證的人把衣裳放在一個少年人名叫掃羅的腳前。',
    '徒7:59 他們正用石頭打的時候，司提反呼籲主說：求主耶穌接收我的靈魂！',
    '徒7:60 又跪下大聲喊著說：主啊，不要將這罪歸於他們！說了這話，就睡了。掃羅也喜悅他被害。',
    '徒8:1 從這日起，耶路撒冷的教會大遭逼迫，除了使徒以外，門徒都分散在猶太和撒瑪利亞各處。',
    '徒8:2 有虔誠的人把司提反埋葬了，為他捶胸大哭。',
    '徒8:3 掃羅卻殘害教會，進各人的家，拉著男女下在監裡。',
    '徒8:4 那些分散的人往各處去傳道。',
    '徒8:5 腓利下撒瑪利亞城去，宣講基督。',
    '徒8:6 眾人聽見了，又看見腓利所行的神蹟，就同心合意的聽從他的話。',
    '徒8:7 因為有許多人被污鬼附著，那些鬼大聲呼叫，從他們身上出來；還有許多癱瘓的，瘸腿的，都得了醫治。',
    '徒8:8 在那城裡，就大有歡喜。',
    '徒8:9 有一個人，名叫西門，向來在那城裡行邪術，妄自尊大，使撒瑪利亞的百姓驚奇；',
    '徒8:10 無論大小都聽從他，說：這人就是那稱為神的大能者。',
    '徒8:11 他們聽從他，因他久用邪術，使他們驚奇。',
    '徒8:12 及至他們信了腓利所傳神國的福音和耶穌基督的名，連男帶女就受了洗。',
    '徒8:13 西門自己也信了；既受了洗，就常與腓利在一處，看見他所行的神蹟和大異能，就甚驚奇。',
    '徒8:14 使徒在耶路撒冷聽見撒瑪利亞人領受了神的道，就打發彼得、約翰往他們那裡去。',
    '徒8:15 兩個人到了，就為他們禱告，要叫他們受聖靈。',
    '徒8:16 因為聖靈還沒有降在他們一個人身上，他們只奉主耶穌的名受了洗。',
    '徒8:17 於是使徒按手在他們頭上，他們就受了聖靈。',
    '徒8:18 西門看見使徒按手，便有聖靈賜下，就拿錢給使徒，',
    '徒8:19 說：把這權柄也給我，叫我手按著誰，誰就可以受聖靈。',
    '徒8:20 彼得說：你的銀子和你一同滅亡吧！因你想神的恩賜是可以用錢買的。',
    '徒8:21 你在這道上無分無關；因為在神面前，你的心不正。',
    '徒8:22 你當懊悔你這罪惡，祈求主，或者你心裡的意念可得赦免。',
    '徒8:23 我看出你正在苦膽之中，被罪惡捆綁。',
    '徒8:24 西門說：願你們為我求主，叫你們所說的，沒有一樣臨到我身上。',
    '徒8:25 使徒既證明主道，而且傳講，就回耶路撒冷去，一路在撒瑪利亞好些村莊傳揚福音。',
    '徒8:26 有主的一個使者對腓利說：起來！向南走，往那從耶路撒冷下迦薩的路上去。那路是曠野。',
    '徒8:27 腓利就起身去了，不料，有一個埃提阿伯（即古實，見賽18:1）人，是個有大權的太監，在埃提阿伯女王干大基的手下總管銀庫，他上耶路撒冷禮拜去了。',
    '徒8:28 現在回來，在車上坐著，念先知以賽亞的書。',
    '徒8:29 聖靈對腓利說：你去！貼近那車走。',
    '徒8:30 腓利就跑到太監那裡，聽見他念先知以賽亞的書，便問他說：你所念的，你明白嗎﹖',
    '徒8:31 他說：沒有人指教我，怎能明白呢﹖於是請腓利上車，與他同坐。',
    '徒8:32 他所念的那段經，說：他像羊被牽到宰殺之地，又像羊羔在剪毛的人手下無聲；他也是這樣不開口。',
    '徒8:33 他卑微的時候，人不按公義審判他（原文是他的審判被奪去）；誰能述說他的世代，因為他的生命從地上奪去。',
    '徒8:34 太監對腓利說：請問，先知說這話是指著誰﹖是指著自己呢﹖是指著別人呢﹖',
    '徒8:35 腓利就開口從這經上起，對他傳講耶穌。',
    '徒8:36 二人正往前走，到了有水的地方，太監說：看哪，這裡有水，我受洗有什麼妨礙呢﹖（有古卷在此有：',
    '徒8:37 腓利說：你若是一心相信，就可以。他回答說：我信耶穌基督是神的兒子。）',
    '徒8:38 於是吩咐車站住，腓利和太監二人同下水裡去，腓利就給他施洗。',
    '徒8:39 從水裡上來，主的靈把腓利提了去，太監也不再見他了，就歡歡喜喜的走路。',
    '徒8:40 後來有人在亞鎖都遇見腓利；他走遍那地方，在各城宣傳福音，直到該撒利亞。',
    '徒9:1 掃羅仍然向主的門徒口吐威嚇兇殺的話，去見大祭司，',
    '徒9:2 求文書給大馬色的各會堂，若是找著信奉這道的人，無論男女，都准他捆綁帶到耶路撒冷。',
    '徒9:3 掃羅行路，將到大馬色，忽然從天上發光，四面照著他；',
    '徒9:4 他就仆倒在地，聽見有聲音對他說：掃羅！掃羅！你為什麼逼迫我﹖',
    '徒9:5 他說：主啊！你是誰﹖主說：我就是你所逼迫的耶穌。',
    '徒9:6 起來！進城去，你所當做的事，必有人告訴你。',
    '徒9:7 同行的人站在那裡，說不出話來，聽見聲音，卻看不見人。',
    '徒9:8 掃羅從地上起來，睜開眼睛，竟不能看見什麼。有人拉他的手，領他進了大馬色；',
    '徒9:9 三日不能看見，也不吃也不喝。',
    '徒9:10 當下，在大馬色有一個門徒，名叫亞拿尼亞。主在異象中對他說：亞拿尼亞。他說：主，我在這裡。',
    '徒9:11 主對他說：起來！往直街去，在猶大的家裡，訪問一個大數人，名叫掃羅。他正禱告，',
    '徒9:12 又看見了一個人，名叫亞拿尼亞，進來按手在他身上，叫他能看見。',
    '徒9:13 亞拿尼亞回答說：主啊，我聽見許多人說：這人怎樣在耶路撒冷多多苦害你的聖徒，',
    '徒9:14 並且他在這裡有從祭司長得來的權柄捆綁一切求告你名的人。',
    '徒9:15 主對亞拿尼亞說：你只管去！他是我所揀選的器皿，要在外邦人和君王，並以色列人面前宣揚我的名。',
    '徒9:16 我也要指示他，為我的名必須受許多的苦難。',
    '徒9:17 亞拿尼亞就去了，進入那家，把手按在掃羅身上，說：兄弟掃羅，在你來的路上向你顯現的主，就是耶穌，打發我來，叫你能看見，又被聖靈充滿。',
    '徒9:18 掃羅的眼睛上，好像有鱗立刻掉下來，他就能看見。於是起來受了洗；',
    '徒9:19 吃過飯就健壯了。掃羅和大馬色的門徒同住了些日子，',
    '徒9:20 就在各會堂裡宣傳耶穌，說他是神的兒子。',
    '徒9:21 凡聽見的人都驚奇，說：在耶路撒冷殘害求告這名的，不是這人嗎﹖並且他到這裡來，特要捆綁他們，帶到祭司長那裡。',
    '徒9:22 但掃羅越發有能力，駁倒住大馬色的猶太人，證明耶穌是基督。',
    '徒9:23 過了好些日子，猶太人商議要殺掃羅，',
    '徒9:24 但他們的計謀被掃羅知道了。他們又晝夜在城門守候，要殺他。',
    '徒9:25 他的門徒就在夜間用筐子把他從城牆上縋下去。',
    '徒9:26 掃羅到了耶路撒冷，想與門徒結交，他們卻都怕他，不信他是門徒。',
    '徒9:27 惟有巴拿巴接待他，領去見使徒，把他在路上怎麼看見主，主怎麼向他說話，他在大馬色怎麼奉耶穌的名放膽傳道，都述說出來。',
    '徒9:28 於是掃羅在耶路撒冷和門徒出入來往，',
    '徒9:29 奉主的名放膽傳道，並與說希利尼話的猶太人講論辯駁；他們卻想法子要殺他。',
    '徒9:30 弟兄們知道了就送他下該撒利亞，打發他往大數去。',
    '徒9:31 那時，猶太、加利利、撒瑪利亞各處的教會都得平安，被建立；凡事敬畏主，蒙聖靈的安慰，人數就增多了。',
    '徒9:32 彼得周流四方的時候，也到了居住呂大的聖徒那裡；',
    '徒9:33 遇見一個人，名叫以尼雅，得了癱瘓，在褥子上躺臥八年。',
    '徒9:34 彼得對他說：以尼雅，耶穌基督醫好你了；起來！收拾你的褥子。他就立刻起來了。',
    '徒9:35 凡住呂大和沙崙的人都看見了他，就歸服主。',
    '徒9:36 在約帕有一個女徒，名叫大比大，翻希利尼話就是多加（就是羚羊的意思）；他廣行善事，多施賙濟。',
    '徒9:37 當時，他患病而死，有人把他洗了，停在樓上。',
    '徒9:38 呂大原與約帕相近；門徒聽見彼得在那裡，就打發兩個人去見他，央求他說：快到我們那裡去，不要耽延。',
    '徒9:39 彼得就起身和他們同去；到了，便有人領他上樓。眾寡婦都站在彼得旁邊哭，拿多加與他們同在時所做的裡衣外衣給他看。',
    '徒9:40 彼得叫他們都出去，就跪下禱告，轉身對著死人說：大比大，起來！他就睜開眼睛，見了彼得，便坐起來。',
    '徒9:41 彼得伸手扶他起來，叫眾聖徒和寡婦進去，把多加活活的交給他們。',
    '徒9:42 這事傳遍了約帕，就有許多人信了主。',
    '徒9:43 此後，彼得在約帕一個硝皮匠西門的家裡住了多日。',
    '徒10:1 在該撒利亞有一個人，名叫哥尼流，是義大利營的百夫長。',
    '徒10:2 他是個虔誠人，他和全家都敬畏神，多多賙濟百姓，常常禱告神。',
    '徒10:3 有一天，約在申初，他在異象中明明看見神的一個使者進去，到他那裡，說：哥尼流。',
    '徒10:4 哥尼流定睛看他，驚怕說：主啊，什麼事呢﹖天使說：你的禱告和你的賙濟達到神面前，已蒙記念了。',
    '徒10:5 現在你當打發人往約帕去，請那稱呼彼得的西門來。',
    '徒10:6 他住在海邊一個硝皮匠西門的家裡，房子在海邊上。',
    '徒10:7 向他說話的天使去後，哥尼流叫了兩個家人和常伺候他的一個虔誠兵來，',
    '徒10:8 把這事都述說給他們聽，就打發他們往約帕去。',
    '徒10:9 第二天，他們行路將近那城。彼得約在午正，上房頂去禱告，',
    '徒10:10 覺得餓了，想要吃。那家的人正預備飯的時候，彼得魂遊象外，',
    '徒10:11 看見天開了，有一物降下，好像一塊大布，繫著四角，縋在地上，',
    '徒10:12 裡面有地上各樣四足的走獸和昆蟲，並天上的飛鳥；',
    '徒10:13 又有聲音向他說：彼得，起來，宰了吃！',
    '徒10:14 彼得卻說：主啊，這是不可的！凡俗物和不潔淨的物，我從來沒有吃過。',
    '徒10:15 第二次有聲音向他說：神所潔淨的，你不可當作俗物。',
    '徒10:16 這樣一連三次，那物隨即收回天上去了。',
    '徒10:17 彼得心裡正在猜疑之間，不知所看見的異象是什麼意思。哥尼流所差來的人已經訪問到西門的家，站在門外，',
    '徒10:18 喊著問：有稱呼彼得的西門住在這裡沒有﹖',
    '徒10:19 彼得還思想那異象的時候，聖靈向他說：有三個人來找你。',
    '徒10:20 起來，下去，和他們同往，不要疑惑，因為是我差他們來的。',
    '徒10:21 於是彼得下去見那些人，說：我就是你們所找的人。你們來是為什麼緣故﹖',
    '徒10:22 他們說：百夫長哥尼流是個義人，敬畏神，為猶太通國所稱讚。他蒙一位聖天使指示，叫他請你到他家裡去，聽你的話。',
    '徒10:23 彼得就請他們進去，住了一宿。次日，起身和他們同去，還有約帕的幾個弟兄同著他去；',
    '徒10:24 又次日，他們進入該撒利亞，哥尼流已經請了他的親屬密友等候他們。',
    '徒10:25 彼得一進去，哥尼流就迎接他，俯伏在他腳前拜他。',
    '徒10:26 彼得卻拉他，說：你起來，我也是人。',
    '徒10:27 彼得和他說著話進去，見有好些人在那裡聚集，',
    '徒10:28 就對他們說：你們知道，猶太人和別國的人親近來往本是不合例的，但神已經指示我，無論什麼人都不可看作俗而不潔淨的。',
    '徒10:29 所以我被請的時候，就不推辭而來。現在請問：你們叫我來有什麼意思呢﹖',
    '徒10:30 哥尼流說：前四天，這個時候，我在家中守著申初的禱告，忽然有一個人穿著光明的衣裳，站在我面前，',
    '徒10:31 說：哥尼流，你的禱告已蒙垂聽，你的賙濟達到神面前已蒙記念了。',
    '徒10:32 你當打發人往約帕去，請那稱呼彼得的西門來，他住在海邊一個硝皮匠西門的家裡。',
    '徒10:33 所以我立時打發人去請你。你來了很好；現今我們都在神面前，要聽主所吩咐你的一切話。',
    '徒10:34 彼得就開口說：我真看出神是不偏待人。',
    '徒10:35 原來，各國中那敬畏主、行義的人都為主所悅納。',
    '徒10:36 神藉著耶穌基督（他是萬有的主）傳和平的福音，將這道賜給以色列人。',
    '徒10:37 這話在約翰宣傳洗禮以後，從加利利起，傳遍了猶太。',
    '徒10:38 神怎樣以聖靈和能力膏拿撒勒人耶穌，這都是你們知道的。他周流四方，行善事，醫好凡被魔鬼壓制的人，因為神與他同在。',
    '徒10:39 他在猶太人之地，並耶路撒冷所行的一切事，有我們作見證。他們竟把他掛在木頭上殺了。',
    '徒10:40 第三日，神叫他復活，顯現出來；',
    '徒10:41 不是顯現給眾人看，乃是顯現給神預先所揀選為他作見證的人看，就是我們這些在他從死裡復活以後和他同吃同喝的人。',
    '徒10:42 他吩咐我們傳道給眾人，證明他是神所立定的，要作審判活人、死人的主。',
    '徒10:43 眾先知也為他作見證說：凡信他的人必因他的名得蒙赦罪。',
    '徒10:44 彼得還說這話的時候，聖靈降在一切聽道的人身上。',
    '徒10:45 那些奉割禮、和彼得同來的信徒，見聖靈的恩賜也澆在外邦人身上，就都希奇；',
    '徒10:46 因聽見他們說方言，稱讚神為大。',
    '徒10:47 於是彼得說：這些人既受了聖靈，與我們一樣，誰能禁止用水給他們施洗呢﹖',
    '徒10:48 就吩咐奉耶穌基督的名給他們施洗。他們又請彼得住了幾天。',
    '徒11:1 使徒和在猶太的眾弟兄聽說外邦人也領受了神的道。',
    '徒11:2 及至彼得上了耶路撒冷，那些奉割禮的門徒和他爭辯說：',
    '徒11:3 你進入未受割禮之人的家和他們一同吃飯了。',
    '徒11:4 彼得就開口把這事挨次給他們講解說：',
    '徒11:5 我在約帕城裡禱告的時候，魂遊象外，看見異象，有一物降下，好像一塊大布，繫著四角，從天縋下，直來到我跟前。',
    '徒11:6 我定睛觀看，見內中有地上四足的牲畜和野獸、昆蟲，並天上的飛鳥。',
    '徒11:7 我且聽見有聲音向我說：彼得，起來，宰了吃！',
    '徒11:8 我說：主啊，這是不可的！凡俗而不潔淨的物從來沒有入過我的口。',
    '徒11:9 第二次，有聲音從天上說：神所潔淨的，你不可當作俗物。',
    '徒11:10 這樣一連三次，就都收回天上去了。',
    '徒11:11 正當那時，有三個人站在我們所住的房門前，是從該撒利亞差來見我的。',
    '徒11:12 聖靈吩咐我和他們同去，不要疑惑（或作：不要分別等類）。同著我去的，還有這六位弟兄；我們都進了那人的家，',
    '徒11:13 那人就告訴我們，他如何看見一位天使，站在他屋裡，說：你打發人往約帕去，請那稱呼彼得的西門來；',
    '徒11:14 他有話告訴你，可以叫你和你的全家得救。',
    '徒11:15 我一開講，聖靈便降在他們身上，正像當初降在我們身上一樣。',
    '徒11:16 我就想起主的話說：約翰是用水施洗，但你們要受聖靈的洗。',
    '徒11:17 神既然給他們恩賜，像在我們信主耶穌基督的時候給了我們一樣；我是誰，能攔阻神呢！',
    '徒11:18 眾人聽見這話，就不言語了，只歸榮耀與神，說：這樣看來，神也賜恩給外邦人，叫他們悔改得生命了。',
    '徒11:19 那些因司提反的事遭患難四散的門徒直走到腓尼基和居比路，並安提阿；他們不向別人講道，只向猶太人講。',
    '徒11:20 但內中有居比路和古利奈人，他們到了安提阿也向希利尼人傳講主耶穌（有古卷作：也向說希利尼話的猶太人傳講主耶穌）。',
    '徒11:21 主與他們同在，信而歸主的人就很多了。',
    '徒11:22 這風聲傳到耶路撒冷教會人的耳中，他們就打發巴拿巴出去，走到安提阿為止。',
    '徒11:23 他到了那裡，看見神所賜的恩就歡喜，勸勉眾人，立定心志，恆久靠主。',
    '徒11:24 這巴拿巴原是個好人，被聖靈充滿，大有信心。於是有許多人歸服了主。',
    '徒11:25 他又往大數去找掃羅，',
    '徒11:26 找著了，就帶他到安提阿去。他們足有一年的工夫和教會一同聚集，教訓了許多人。門徒稱為基督徒是從安提阿起首。',
    '徒11:27 當那些日子，有幾位先知從耶路撒冷下到安提阿。',
    '徒11:28 內中有一位，名叫亞迦布，站起來，藉著聖靈指明天下將有大饑荒。這事到革老丟年間果然有了。',
    '徒11:29 於是門徒定意照各人的力量捐錢，送去供給住在猶太的弟兄。',
    '徒11:30 他們就這樣行，把捐項託巴拿巴和掃羅送到眾長老那裡。',
    '徒12:1 那時，希律王下手苦害教會中幾個人，',
    '徒12:2 用刀殺了約翰的哥哥雅各。',
    '徒12:3 他見猶太人喜歡這事，又去捉拿彼得。那時正是除酵的日子。',
    '徒12:4 希律拿了彼得，收在監裡，交付四班兵丁看守，每班四個人，意思要在逾越節後把他提出來，當著百姓辦他。',
    '徒12:5 於是彼得被囚在監裡；教會卻為他切切的禱告神。',
    '徒12:6 希律將要提他出來的前一夜，彼得被兩條鐵鍊鎖著，睡在兩個兵丁當中；看守的人也在門外看守。',
    '徒12:7 忽然，有主的一個使者站在旁邊，屋裡有光照耀，天使拍彼得的肋旁，拍醒了他，說：快快起來！那鐵鍊就從他手上脫落下來。',
    '徒12:8 天使對他說：束上帶子，穿上鞋。他就那樣做。天使又說：披上外衣，跟著我來。',
    '徒12:9 彼得就出來跟著他，不知道天使所做是真的，只當見了異象。',
    '徒12:10 過了第一層第二層監牢，就來到臨街的鐵門，那門自己開了。他們出來，走過一條街，天使便離開他去了。',
    '徒12:11 彼得醒悟過來，說：我現在真知道主差遣他的使者，救我脫離希律的手和猶太百姓一切所盼望的。',
    '徒12:12 想了一想，就往那稱呼馬可的約翰、他母親馬利亞家去，在那裡有好些人聚集禱告。',
    '徒12:13 彼得敲外門，有一個使女，名叫羅大，出來探聽，',
    '徒12:14 聽得是彼得的聲音，就歡喜的顧不得開門，跑進去告訴眾人說：彼得站在門外。',
    '徒12:15 他們說：你是瘋了！使女極力的說：真是他！他們說：必是他的天使！',
    '徒12:16 彼得不住的敲門。他們開了門，看見他，就甚驚奇。',
    '徒12:17 彼得擺手，不要他們作聲，就告訴他們主怎樣領他出監；又說：你們把這事告訴雅各和眾弟兄。於是出去，往別處去了。',
    '徒12:18 到了天亮，兵丁擾亂得很，不知道彼得往哪裡去了。',
    '徒12:19 希律找他，找不著，就審問看守的人，吩咐把他們拉去殺了。後來希律離開猶太，下該撒利亞去，住在那裡。',
    '徒12:20 希律惱怒推羅、西頓的人。他們那一帶地方是從王的地土得糧，因此就託了王的內侍臣伯拉斯都的情，一心來求和。',
    '徒12:21 希律在所定的日子，穿上朝服，坐在位上，對他們講論一番。',
    '徒12:22 百姓喊著說：這是神的聲音，不是人的聲音。',
    '徒12:23 希律不歸榮耀給神，所以主的使者立刻罰他，他被蟲所咬，氣就絕了。',
    '徒12:24 神的道日見興旺，越發廣傳。',
    '徒12:25 巴拿巴和掃羅辦完了他們供給的事，就從耶路撒冷回來，帶著稱呼馬可的約翰同去。',
    '徒13:1 在安提阿的教會中，有幾位先知和教師，就是巴拿巴和稱呼尼結的西面、古利奈人路求，與分封之王希律同養的馬念，並掃羅。',
    '徒13:2 他們事奉主、禁食的時候，聖靈說：要為我分派巴拿巴和掃羅，去做我召他們所做的工。',
    '徒13:3 於是禁食禱告，按手在他們頭上，就打發他們去了。',
    '徒13:4 他們既被聖靈差遣，就下到西流基，從那裡坐船往居比路去。',
    '徒13:5 到了撒拉米，就在猶太人各會堂裡傳講神的道，也有約翰作他們的幫手。',
    '徒13:6 經過全島，直到帕弗，在那裡遇見一個有法術，假充先知的猶太人，名叫巴耶穌。',
    '徒13:7 這人常和方伯士求保羅同在。士求保羅是個通達人，他請了巴拿巴和掃羅來，要聽神的道。',
    '徒13:8 只是那行法術的以呂馬（這名翻出來就是行法術的意思）敵擋使徒，要叫方伯不信真道。',
    '徒13:9 掃羅又名保羅，被聖靈充滿，定睛看他，',
    '徒13:10 說：你這充滿各樣詭詐奸惡，魔鬼的兒子，眾善的仇敵，你混亂主的正道還不止住嗎﹖',
    '徒13:11 現在主的手加在你身上，你要瞎眼，暫且不見日光。他的眼睛立刻昏蒙黑暗，四下裡求人拉著手領他。',
    '徒13:12 方伯看見所做的事，很希奇主的道，就信了。',
    '徒13:13 保羅和他的同人從帕弗開船，來到旁非利亞的別加，約翰就離開他們，回耶路撒冷去。',
    '徒13:14 他們離了別加往前行，來到彼西底的安提阿，在安息日進會堂坐下。',
    '徒13:15 讀完了律法和先知的書，管會堂的，叫人過去，對他們說：二位兄台，若有什麼勸勉眾人的話，請說。',
    '徒13:16 保羅就站起來，舉手，說：以色列人和一切敬畏神的人，請聽。',
    '徒13:17 這以色列民的神揀選了我們的祖宗，當民寄居埃及的時候擡舉他們，用大能的手領他們出來；',
    '徒13:18 又在曠野容忍（或作：撫養）他們，約有四十年。',
    '徒13:19 既滅了迦南地七族的人，就把那地分給他們為業；',
    '徒13:20 此後給他們設立士師，約有四百五十年，直到先知撒母耳的時候。',
    '徒13:21 後來他們求一個王，神就將便雅憫支派中基士的兒子掃羅，給他們作王四十年。',
    '徒13:22 既廢了掃羅，就選立大衛作他們的王，又為他作見證說：我尋得耶西的兒子大衛，他是合我心意的人，凡事要遵行我的旨意。',
    '徒13:23 從這人的後裔中，神已經照著所應許的，為以色列人立了一位救主，就是耶穌。',
    '徒13:24 在他沒有出來以先，約翰向以色列眾民宣講悔改的洗禮。',
    '徒13:25 約翰將行盡他的程途說：你們以為我是誰﹖我不是基督；只是有一位在我以後來的，我解他腳上的鞋帶也是不配的。',
    '徒13:26 弟兄們，亞伯拉罕的子孫和你們中間敬畏神的人哪，這救世的道是傳給我們的。',
    '徒13:27 耶路撒冷居住的人和他們的官長，因為不認識基督，也不明白每安息日所讀眾先知的書，就把基督定了死罪，正應了先知的預言；',
    '徒13:28 雖然查不出他有當死的罪來，還是求彼拉多殺他；',
    '徒13:29 既成就了經上指著他所記的一切話，就把他從木頭上取下來，放在墳墓裡。',
    '徒13:30 神卻叫他從死裡復活。',
    '徒13:31 那從加利利同他上耶路撒冷的人多日看見他，這些人如今在民間是他的見證。',
    '徒13:32 我們也報好信息給你們，就是那應許祖宗的話，',
    '徒13:33 神已經向我們這作兒女的應驗，叫耶穌復活了。正如詩篇第二篇上記著說：你是我的兒子，我今日生你。',
    '徒13:34 論到神叫他從死裡復活，不再歸於朽壞，就這樣說：我必將所應許大衛那聖潔、可靠的恩典賜給你們。',
    '徒13:35 又有一篇上說：你必不叫你的聖者見朽壞。',
    '徒13:36 大衛在世的時候遵行了神的旨意，就睡了（或作：大衛按神的旨意服事了他那一世的人，就睡了），歸到他祖宗那裡，已見朽壞；',
    '徒13:37 惟獨神所復活的，他並未見朽壞。',
    '徒13:38 所以，弟兄們，你們當曉得：赦罪的道是由這人傳給你們的。',
    '徒13:39 你們靠摩西的律法，在一切不得稱義的事上信靠這人，就都得稱義了。',
    '徒13:40 所以，你們務要小心，免得先知書上所說的臨到你們。',
    '徒13:41 主說：你們這輕慢的人要觀看，要驚奇，要滅亡；因為在你們的時候，我行一件事，雖有人告訴你們，你們總是不信。',
    '徒13:42 他們出會堂的時候，眾人請他們到下安息日再講這話給他們聽。',
    '徒13:43 散會以後，猶太人和敬虔進猶太教的人多有跟從保羅、巴拿巴的。二人對他們講道，勸他們務要恆久在神的恩中。',
    '徒13:44 到下安息日，合城的人幾乎都來聚集，要聽神的道。',
    '徒13:45 但猶太人看見人這樣多，就滿心嫉妒，硬駁保羅所說的話，並且毀謗。',
    '徒13:46 保羅和巴拿巴放膽說：神的道先講給你們原是應當的；只因你們棄絕這道，斷定自己不配得永生，我們就轉向外邦人去。',
    '徒13:47 因為主曾這樣吩咐我們說：我已經立你作外邦人的光，叫你施行救恩，直到地極。',
    '徒13:48 外邦人聽見這話，就歡喜了，讚美神的道；凡預定得永生的人都信了。',
    '徒13:49 於是主的道傳遍了那一帶地方。',
    '徒13:50 但猶太人挑唆虔敬、尊貴的婦女和城內有名望的人，逼迫保羅、巴拿巴，將他們趕出境外。',
    '徒13:51 二人對著眾人跺下腳上的塵土，就往以哥念去了。',
    '徒13:52 門徒滿心喜樂，又被聖靈充滿。',
    '徒14:1 二人在以哥念同進猶太人的會堂，在那裡講的，叫猶太人和希利尼人信的很多。',
    '徒14:2 但那不順從的猶太人聳動外邦人，叫他們心裡惱恨弟兄。',
    '徒14:3 二人在那裡住了多日，倚靠主放膽講道；主藉他們的手施行神蹟奇事，證明他的恩道。',
    '徒14:4 城裡的眾人就分了黨，有附從猶太人的，有附從使徒的。',
    '徒14:5 那時，外邦人和猶太人，並他們的官長，一齊擁上來，要凌辱使徒，用石頭打他們。',
    '徒14:6 使徒知道了，就逃往呂高尼的路司得、特庇兩個城和周圍地方去，',
    '徒14:7 在那裡傳福音。',
    '徒14:8 路司得城裡坐著一個兩腳無力的人，生來是瘸腿的，從來沒有走過。',
    '徒14:9 他聽保羅講道，保羅定睛看他，見他有信心，可得痊癒，',
    '徒14:10 就大聲說：你起來，兩腳站直！那人就跳起來，而且行走。',
    '徒14:11 眾人看見保羅所做的事，就用呂高尼的話大聲說：有神藉著人形降臨在我們中間了。',
    '徒14:12 於是稱巴拿巴為丟斯，稱保羅為希耳米，因為他說話領首。',
    '徒14:13 有城外丟斯廟的祭司牽著牛，拿著花圈，來到門前，要同眾人向使徒獻祭。',
    '徒14:14 巴拿巴、保羅二使徒聽見，就撕開衣裳，跳進眾人中間，喊著說：',
    '徒14:15 諸君，為什麼做這事呢﹖我們也是人，性情和你們一樣。我們傳福音給你們，是叫你們離棄這些虛妄，歸向那創造天、地、海、和其中萬物的永生神。',
    '徒14:16 他在從前的世代，任憑萬國各行其道；',
    '徒14:17 然而為自己未嘗不顯出證據來，就如常施恩惠，從天降雨，賞賜豐年，叫你們飲食飽足，滿心喜樂。',
    '徒14:18 二人說了這些話，僅僅的攔住眾人不獻祭與他們。',
    '徒14:19 但有些猶太人從安提阿和以哥念來，挑唆眾人，就用石頭打保羅，以為他是死了，便拖到城外。',
    '徒14:20 門徒正圍著他，他就起來，走進城去。第二天，同巴拿巴往特庇去，',
    '徒14:21 對那城裡的人傳了福音，使好些人作門徒，就回路司得、以哥念、安提阿去，',
    '徒14:22 堅固門徒的心，勸他們恆守所信的道；又說：我們進入神的國，必須經歷許多艱難。',
    '徒14:23 二人在各教會中選立了長老，又禁食禱告，就把他們交託所信的主。',
    '徒14:24 二人經過彼西底，來到旁非利亞。',
    '徒14:25 在別加講了道，就下亞大利去，',
    '徒14:26 從那裡坐船，往安提阿去。當初，他們被眾人所託、蒙神之恩，要辦現在所做之工，就是在這地方。',
    '徒14:27 到了那裡，聚集了會眾，就述說神藉他們所行的一切事，並神怎樣為外邦人開了信道的門。',
    '徒14:28 二人就在那裡同門徒住了多日。',
    '徒15:1 有幾個人從猶太下來，教訓弟兄們說：你們若不按摩西的規條受割禮，不能得救。',
    '徒15:2 保羅、巴拿巴與他們大大的紛爭辯論；眾門徒就定規，叫保羅、巴拿巴和本會中幾個人，為所辯論的，上耶路撒冷去見使徒和長老。',
    '徒15:3 於是教會送他們起行。他們經過腓尼基、撒瑪利亞，隨處傳說外邦人歸主的事，叫眾弟兄都甚歡喜。',
    '徒15:4 到了耶路撒冷，教會和使徒並長老都接待他們，他們就述說神同他們所行的一切事。',
    '徒15:5 惟有幾個信徒、是法利賽教門的人，起來說：必須給外邦人行割禮，吩咐他們遵守摩西的律法。',
    '徒15:6 使徒和長老聚會商議這事；',
    '徒15:7 辯論已經多了，彼得就起來，說：諸位弟兄，你們知道神早已在你們中間揀選了我，叫外邦人從我口中得聽福音之道，而且相信。',
    '徒15:8 知道人心的神也為他們作了見證，賜聖靈給他們，正如給我們一樣；',
    '徒15:9 又藉著信潔淨了他們的心，並不分他們我們。',
    '徒15:10 現在為什麼試探神，要把我們祖宗和我們所不能負的軛放在門徒的頸項上呢﹖',
    '徒15:11 我們得救乃是因主耶穌的恩，和他們一樣，這是我們所信的。',
    '徒15:12 眾人都默默無聲，聽巴拿巴和保羅述說神藉他們在外邦人中所行的神蹟奇事。',
    '徒15:13 他們住了聲，雅各就說：諸位弟兄，請聽我的話。',
    '徒15:14 方才西門述說神當初怎樣眷顧外邦人，從他們中間選取百姓歸於自己的名下；',
    '徒15:15 眾先知的話也與這意思相合。',
    '徒15:16 正如經上所寫的：此後，我要回來，重新修造大衛倒塌的帳幕，把那破壞的重新修造建立起來，',
    '徒15:17 叫餘剩的人，就是凡稱為我名下的外邦人，都尋求主。',
    '徒15:18 這話是從創世以來，顯明這事的主說的。',
    '徒15:19 所以據我的意見，不可難為那歸服神的外邦人；',
    '徒15:20 只要寫信，吩咐他們禁戒偶像的污穢和姦淫，並勒死的牲畜和血。',
    '徒15:21 因為從古以來，摩西的書在各城有人傳講，每逢安息日，在會堂裡誦讀。',
    '徒15:22 那時，使徒和長老並全教會定意從他們中間揀選人，差他們和保羅、巴拿巴同往安提阿去；所揀選的就是稱呼巴撒巴的猶大和西拉。這兩個人在弟兄中是作首領的。',
    '徒15:23 於是寫信交付他們，內中說：使徒和作長老的弟兄們問安提阿、敘利亞、基利家外邦眾弟兄的安。',
    '徒15:24 我們聽說，有幾個人從我們這裡出去，用言語攪擾你們，惑亂你們的心。（有古卷在此有：你們必須受割禮，守摩西的律法。）其實我們並沒有吩咐他們。',
    '徒15:25 所以，我們同心定意，揀選幾個人，差他們同我們所親愛的巴拿巴和保羅往你們那裡去。',
    '徒15:26 這二人是為我主耶穌基督的名不顧性命的。',
    '徒15:27 我們就差了猶大和西拉，他們也要親口訴說這些事。',
    '徒15:28 因為聖靈和我們定意不將別的重擔放在你們身上；惟有幾件事是不可少的，',
    '徒15:29 就是禁戒祭偶像的物和血，並勒死的牲畜和姦淫。這幾件你們若能自己禁戒不犯就好了。願你們平安！',
    '徒15:30 他們既奉了差遣，就下安提阿去，聚集眾人，交付書信。',
    '徒15:31 眾人念了，因為信上安慰的話就歡喜了。',
    '徒15:32 猶大和西拉也是先知，就用許多話勸勉弟兄，堅固他們。',
    '徒15:33 住了些日子，弟兄們打發他們平平安安地回到差遣他們的人那裡去。（有古卷在此有：',
    '徒15:34 惟有西拉定意仍住在那裡。）',
    '徒15:35 但保羅和巴拿巴仍住在安提阿，和許多別人一同教訓人，傳主的道。',
    '徒15:36 過了些日子，保羅對巴拿巴說：我們可以回到從前宣傳主道的各城，看望弟兄們景況如何。',
    '徒15:37 巴拿巴有意要帶稱呼馬可的約翰同去；',
    '徒15:38 但保羅因為馬可從前在旁非利亞離開他們，不和他們同去做工，就以為不可帶他去。',
    '徒15:39 於是二人起了爭論，甚至彼此分開。巴拿巴帶著馬可，坐船往居比路去；',
    '徒15:40 保羅揀選了西拉，也出去，蒙弟兄們把他交於主的恩中。',
    '徒15:41 他就走遍敘利亞、基利家，堅固眾教會。',
    '徒16:1 保羅來到特庇，又到路司得。在那裡有一個門徒，名叫提摩太，是信主之猶太婦人的兒子，他父親卻是希利尼人。',
    '徒16:2 路司得和以哥念的弟兄都稱讚他。',
    '徒16:3 保羅要帶他同去，只因那些地方的猶太人都知道他父親是希利尼人，就給他行了割禮。',
    '徒16:4 他們經過各城，把耶路撒冷使徒和長老所定的條規交給門徒遵守。',
    '徒16:5 於是眾教會信心越發堅固，人數天天加增。',
    '徒16:6 聖靈既然禁止他們在亞西亞講道，他們就經過弗呂家、加拉太一帶地方。',
    '徒16:7 到了每西亞的邊界，他們想要往庇推尼去，耶穌的靈卻不許。',
    '徒16:8 他們就越過每西亞，下到特羅亞去。',
    '徒16:9 在夜間有異象現與保羅。有一個馬其頓人站著求他說：請你過到馬其頓來幫助我們。',
    '徒16:10 保羅既看見這異象，我們隨即想要往馬其頓去，以為神召我們傳福音給那裡的人聽。',
    '徒16:11 於是從特羅亞開船，一直行到撒摩特喇，第二天到了尼亞波利。',
    '徒16:12 從那裡來到腓立比，就是馬其頓這一方的頭一個城，也是羅馬的駐防城。我們在這城裡住了幾天。',
    '徒16:13 當安息日，我們出城門，到了河邊，知道那裡有一個禱告的地方，我們就坐下對那聚會的婦女講道。',
    '徒16:14 有一個賣紫色布疋的婦人，名叫呂底亞，是推雅推喇城的人，素來敬拜神。他聽見了，主就開導他的心，叫他留心聽保羅所講的話。',
    '徒16:15 他和他一家既領了洗，便求我們說：你們若以為我是真信主的（或作：你們若以為我是忠心事主的），請到我家裡來住。於是強留我們。',
    '徒16:16 後來，我們往那禱告的地方去。有一個使女迎著面來，他被巫鬼所附，用法術，叫他主人們大得財利。',
    '徒16:17 他跟隨保羅和我們，喊著說：這些人是至高神的僕人，對你們傳說救人的道。',
    '徒16:18 他一連多日這樣喊叫，保羅就心中厭煩，轉身對那鬼說：我奉耶穌基督的名，吩咐你從他身上出來！那鬼當時就出來了。',
    '徒16:19 使女的主人們見得利的指望沒有了，便揪住保羅和西拉，拉他們到市上去見首領；',
    '徒16:20 又帶到官長面前說：這些人原是猶太人，竟騷擾我們的城，',
    '徒16:21 傳我們羅馬人所不可受不可行的規矩。',
    '徒16:22 眾人就一同起來攻擊他們。官長吩咐剝了他們的衣裳，用棍打；',
    '徒16:23 打了許多棍，便將他們下在監裡，囑咐禁卒嚴緊看守。',
    '徒16:24 禁卒領了這樣的命，就把他們下在內監裡，兩腳上了木狗。',
    '徒16:25 約在半夜，保羅和西拉禱告，唱詩讚美神，眾囚犯也側耳而聽。',
    '徒16:26 忽然，地大震動，甚至監牢的地基都搖動了，監門立刻全開，眾囚犯的鎖鍊也都鬆開了。',
    '徒16:27 禁卒一醒，看見監門全開，以為囚犯已經逃走，就拔刀要自殺。',
    '徒16:28 保羅大聲呼叫說：不要傷害自己！我們都在這裡。',
    '徒16:29 禁卒叫人拿燈來，就跳進去，戰戰兢兢的俯伏在保羅、西拉面前；',
    '徒16:30 又領他們出來，說：二位先生，我當怎樣行才可以得救﹖',
    '徒16:31 他們說：當信主耶穌，你和你一家都必得救。',
    '徒16:32 他們就把主的道講給他和他全家的人聽。',
    '徒16:33 當夜，就在那時候，禁卒把他們帶去，洗他們的傷；他和屬乎他的人立時都受了洗。',
    '徒16:34 於是禁卒領他們上自己家裡去，給他們擺上飯。他和全家，因為信了神，都很喜樂。',
    '徒16:35 到了天亮，官長打發差役來，說：釋放那兩個人吧。',
    '徒16:36 禁卒就把這話告訴保羅說：官長打發人來叫釋放你們，如今可以出監，平平安安地去吧。',
    '徒16:37 保羅卻說：我們是羅馬人，並沒有定罪，他們就在眾人面前打了我們，又把我們下在監裡，現在要私下攆我們出去嗎﹖這是不行的。叫他們自己來領我們出去吧！',
    '徒16:38 差役把這話回稟官長。官長聽見他們是羅馬人，就害怕了，',
    '徒16:39 於是來勸他們，領他們出來，請他們離開那城。',
    '徒16:40 二人出了監，往呂底亞家裡去；見了弟兄們，勸慰他們一番，就走了。',
    '徒17:1 保羅和西拉經過暗妃波里、亞波羅尼亞，來到帖撒羅尼迦，在那裡有猶太人的會堂。',
    '徒17:2 保羅照他素常的規矩進去，一連三個安息日，本著聖經與他們辯論，',
    '徒17:3 講解陳明基督必須受害，從死裡復活；又說：我所傳與你們的這位耶穌就是基督。',
    '徒17:4 他們中間有些人聽了勸，就附從保羅和西拉，並有許多虔敬的希利尼人，尊貴的婦女也不少。',
    '徒17:5 但那不信的猶太人心裡嫉妒，招聚了些市井匪類，搭夥成群，聳動合城的人闖進耶孫的家，要將保羅、西拉帶到百姓那裡。',
    '徒17:6 找不著他們，就把耶孫和幾個弟兄拉到地方官那裡，喊叫說：那攪亂天下的也到這裡來了，',
    '徒17:7 耶孫收留他們。這些人都違背該撒的命令，說另有一個王耶穌。',
    '徒17:8 眾人和地方官聽見這話，就驚慌了；',
    '徒17:9 於是取了耶孫和其餘之人的保狀，就釋放了他們。',
    '徒17:10 弟兄們隨即在夜間打發保羅和西拉往庇哩亞去。二人到了，就進入猶太人的會堂。',
    '徒17:11 這地方的人賢於帖撒羅尼迦的人，甘心領受這道，天天考查聖經，要曉得這道是與不是。',
    '徒17:12 所以他們中間多有相信的，又有希利尼尊貴的婦女，男子也不少。',
    '徒17:13 但帖撒羅尼迦的猶太人知道保羅又在庇哩亞傳神的道，也就往那裡去，聳動攪擾眾人。',
    '徒17:14 當時弟兄們便打發保羅往海邊去，西拉和提摩太仍住在庇哩亞。',
    '徒17:15 送保羅的人帶他到了雅典，既領了保羅的命，叫西拉和提摩太速速到他這裡來，就回去了。',
    '徒17:16 保羅在雅典等候他們的時候，看見滿城都是偶像，就心裡著急；',
    '徒17:17 於是在會堂裡與猶太人和虔敬的人，並每日在市上所遇見的人，辯論。',
    '徒17:18 還有以彼古羅和斯多亞兩門的學士，與他爭論。有的說：這胡言亂語的要說什麼﹖有的說：他似乎是傳說外邦鬼神的。這話是因保羅傳講耶穌與復活的道。',
    '徒17:19 他們就把他帶到亞略巴古，說：你所講的這新道，我們也可以知道嗎﹖',
    '徒17:20 因為你有些奇怪的事傳到我們耳中，我們願意知道這些事是什麼意思。',
    '徒17:21 （雅典人和住在那裡的客人都不顧別的事，只將新聞說說聽聽。）',
    '徒17:22 保羅站在亞略巴古當中，說：眾位雅典人哪，我看你們凡事很敬畏鬼神。',
    '徒17:23 我遊行的時候，觀看你們所敬拜的，遇見一座壇，上面寫著未識之神。你們所不認識而敬拜的，我現在告訴你們。',
    '徒17:24 創造宇宙和其中萬物的神，既是天地的主，就不住人手所造的殿，',
    '徒17:25 也不用人手服事，好像缺少什麼；自己倒將生命、氣息、萬物，賜給萬人。',
    '徒17:26 他從一本（有古卷作血脈）造出萬族的人，住在全地上，並且預先定準他們的年限和所住的疆界，',
    '徒17:27 要叫他們尋求神，或者可以揣摩而得，其實他離我們各人不遠；',
    '徒17:28 我們生活、動作、存留，都在乎他。就如你們作詩的，有人說：我們也是他所生的。',
    '徒17:29 我們既是神所生的，就不當以為神的神性像人用手藝、心思所雕刻的金、銀、石。',
    '徒17:30 世人蒙昧無知的時候，神並不監察，如今卻吩咐各處的人都要悔改。',
    '徒17:31 因為他已經定了日子，要藉著他所設立的人按公義審判天下，並且叫他從死裡復活，給萬人作可信的憑據。',
    '徒17:32 眾人聽見從死裡復活的話，就有譏誚他的；又有人說：我們再聽你講這個吧！',
    '徒17:33 於是保羅從他們當中出去了。',
    '徒17:34 但有幾個人貼近他，信了主，其中有亞略巴古的官丟尼修，並一個婦人，名叫大馬哩，還有別人一同信從。',
    '徒18:1 這事以後，保羅離了雅典，來到哥林多。',
    '徒18:2 遇見一個猶太人，名叫亞居拉，他生在本都；因為革老丟命猶太人都離開羅馬，新近帶著妻百基拉，從義大利來。保羅就投奔了他們。',
    '徒18:3 他們本是製造帳棚為業。保羅因與他們同業，就和他們同住做工。',
    '徒18:4 每逢安息日，保羅在會堂裡辯論，勸化猶太人和希利尼人。',
    '徒18:5 西拉和提摩太從馬其頓來的時候，保羅為道迫切，向猶太人證明耶穌是基督。',
    '徒18:6 他們既抗拒、毀謗，保羅就抖著衣裳，說：你們的罪（原文作血）歸到你們自己頭上，與我無干（原文是我卻乾淨）。從今以後，我要往外邦人那裡去。',
    '徒18:7 於是離開那裡，到了一個人的家中；這人名叫提多猶士都，是敬拜神的，他的家靠近會堂。',
    '徒18:8 管會堂的基利司布和全家都信了主，還有許多哥林多人聽了，就相信受洗。',
    '徒18:9 夜間，主在異象中對保羅說：不要怕，只管講，不要閉口，',
    '徒18:10 有我與你同在，必沒有人下手害你，因為在這城裡我有許多的百姓。',
    '徒18:11 保羅在那裡住了一年零六個月，將神的道教訓他們。',
    '徒18:12 到迦流作亞該亞方伯的時候，猶太人同心起來攻擊保羅，拉他到公堂，',
    '徒18:13 說：這個人勸人不按著律法敬拜神。',
    '徒18:14 保羅剛要開口，迦流就對猶太人說：你們這些猶太人！如果是為冤枉或奸惡的事，我理當耐性聽你們。',
    '徒18:15 但所爭論的，若是關乎言語、名目，和你們的律法，你們自己去辦吧！這樣的事我不願意審問；',
    '徒18:16 就把他們攆出公堂。',
    '徒18:17 眾人便揪住管會堂的所提尼，在堂前打他。這些事迦流都不管。',
    '徒18:18 保羅又住了多日，就辭別了弟兄，坐船往敘利亞去；百基拉、亞居拉和他同去。他因為許過願，就在堅革哩剪了頭髮。',
    '徒18:19 到了以弗所，保羅就把他們留在那裡，自己進了會堂，和猶太人辯論。',
    '徒18:20 眾人請他多住些日子，他卻不允，',
    '徒18:21 就辭別他們，說：神若許我，我還要回到你們這裡；於是開船離了以弗所。',
    '徒18:22 在該撒利亞下了船，就上耶路撒冷去問教會安，隨後下安提阿去。',
    '徒18:23 住了些日子，又離開那裡，挨次經過加拉太和弗呂家地方，堅固眾門徒。',
    '徒18:24 有一個猶太人，名叫亞波羅，來到以弗所。他生在亞力山太，是有學問（或作：口才）的，最能講解聖經。',
    '徒18:25 這人已經在主的道上受了教訓，心裡火熱，將耶穌的事詳細講論教訓人；只是他單曉得約翰的洗禮。',
    '徒18:26 他在會堂裡放膽講道；百基拉，亞居拉聽見，就接他來，將神的道給他講解更加詳細。',
    '徒18:27 他想要往亞該亞去，弟兄們就勉勵他，並寫信請門徒接待他（或作：弟兄們就寫信勸門徒接待他）。他到了那裡，多幫助那蒙恩信主的人，',
    '徒18:28 在眾人面前極有能力駁倒猶太人，引聖經證明耶穌是基督。',
    '徒19:1 亞波羅在哥林多的時候，保羅經過了上邊一帶地方，就來到以弗所；在那裡遇見幾個門徒，',
    '徒19:2 問他們說：你們信的時候受了聖靈沒有﹖他們回答說：沒有，也未曾聽見有聖靈賜下來。',
    '徒19:3 保羅說：這樣，你們受的是什麼洗呢﹖他們說：是約翰的洗。',
    '徒19:4 保羅說：約翰所行的是悔改的洗，告訴百姓當信那在他以後要來的，就是耶穌。',
    '徒19:5 他們聽見這話，就奉主耶穌的名受洗。',
    '徒19:6 保羅按手在他們頭上，聖靈便降在他們身上，他們就說方言，又說預言（或作：又講道）',
    '徒19:7 一共約有十二個人。',
    '徒19:8 保羅進會堂，放膽講道，一連三個月，辯論神國的事，勸化眾人。',
    '徒19:9 後來，有些人心裡剛硬不信，在眾人面前毀謗這道，保羅就離開他們，也叫門徒與他們分離，便在推喇奴的學房天天辯論。',
    '徒19:10 這樣有兩年之久，叫一切住在亞西亞的，無論是猶太人，是希利尼人，都聽見主的道。',
    '徒19:11 神藉保羅的手行了些非常的奇事；',
    '徒19:12 甚至有人從保羅身上拿手巾或圍裙放在病人身上，病就退了，惡鬼也出去了。',
    '徒19:13 那時，有幾個遊行各處、念咒趕鬼的猶太人，向那被惡鬼附的人擅自稱主耶穌的名，說：我奉保羅所傳的耶穌勒令你們出來！',
    '徒19:14 做這事的，有猶太祭司長士基瓦的七個兒子。',
    '徒19:15 惡鬼回答他們說：耶穌我認識，保羅我也知道。你們卻是誰呢﹖',
    '徒19:16 惡鬼所附的人就跳在他們身上，勝了其中二人，制伏他們，叫他們赤著身子受了傷，從那房子裡逃出去了。',
    '徒19:17 凡住在以弗所的，無論是猶太人，是希利尼人，都知道這事，也都懼怕；主耶穌的名從此就尊大了。',
    '徒19:18 那已經信的，多有人來承認訴說自己所行的事。',
    '徒19:19 平素行邪術的，也有許多人把書拿來，堆積在眾人面前焚燒。他們算計書價，便知道共合五萬塊錢。',
    '徒19:20 主的道大大興旺，而且得勝，就是這樣。',
    '徒19:21 這些事完了，保羅心裡定意經過了馬其頓、亞該亞，就往耶路撒冷去；又說：我到了那裡以後，也必須往羅馬去看看。',
    '徒19:22 於是從幫助他的人中打發提摩太、以拉都二人往馬其頓去，自己暫時等在亞西亞。',
    '徒19:23 那時，因為這道起的擾亂不小。',
    '徒19:24 有一個銀匠，名叫底米丟，是製造亞底米神銀龕的，他使這樣手藝人生意發達。',
    '徒19:25 他聚集他們和同行的工人，說：眾位，你們知道我們是倚靠這生意發財。',
    '徒19:26 這保羅不但在以弗所，也幾乎在亞西亞全地，引誘迷惑許多人，說：人手所做的，不是神。這是你們所看見所聽見的。',
    '徒19:27 這樣，不獨我們這事業被人藐視，就是大女神亞底米的廟也要被人輕忽，連亞西亞全地和普天下所敬拜的大女神之威榮也要消滅了。',
    '徒19:28 眾人聽見，就怒氣填胸，喊著說：大哉，以弗所人的亞底米啊！',
    '徒19:29 滿城都轟動起來。眾人拿住與保羅同行的馬其頓人該猶和亞里達古，齊心擁進戲園裡去。',
    '徒19:30 保羅想要進去，到百姓那裡，門徒卻不許他去。',
    '徒19:31 還有亞西亞幾位首領，是保羅的朋友，打發人來勸他，不要冒險到戲園裡去。',
    '徒19:32 聚集的人紛紛亂亂，有喊叫這個的，有喊叫那個的，大半不知道是為什麼聚集。',
    '徒19:33 有人把亞力山大從眾人中帶出來，猶太人推他往前，亞力山大就擺手，要向百姓分訴；',
    '徒19:34 只因他們認出他是猶太人，就大家同聲喊著說：大哉！以弗所人的亞底米啊。如此約有兩小時。',
    '徒19:35 那城裡的書記安撫了眾人，就說：以弗所人哪，誰不知道以弗所人的城是看守大亞底米的廟和從丟斯那裡落下來的像呢﹖',
    '徒19:36 這事既是駁不倒的，你們就當安靜，不可造次。',
    '徒19:37 你們把這些人帶來，他們並沒有偷竊廟中之物，也沒有謗讟我們的女神。',
    '徒19:38 若是底米丟和他同行的人有控告人的事，自有放告的日子（或作：自有公堂），也有方伯可以彼此對告。',
    '徒19:39 你們若問別的事，就可以照常例聚集斷定。',
    '徒19:40 今日的擾亂本是無緣無故，我們難免被查問。論到這樣聚眾，我們也說不出所以然來。',
    '徒19:41 說了這話，便叫眾人散去。',
    '徒20:1 亂定之後，保羅請門徒來，勸勉他們，就辭別起行，往馬其頓去。',
    '徒20:2 走遍了那一帶地方，用許多話勸勉門徒（或作：眾人），然後來到希利尼。',
    '徒20:3 在那裡住了三個月，將要坐船往敘利亞去，猶太人設計要害他，他就定意從馬其頓回去。',
    '徒20:4 同他到亞西亞去的，有庇哩亞人畢羅斯的兒子所巴特，帖撒羅尼迦人亞里達古和西公都，還有特庇人該猶，並提摩太，又有亞西亞人推基古和特羅非摩。',
    '徒20:5 這些人先走，在特羅亞等候我們。',
    '徒20:6 過了除酵的日子，我們從腓立比開船，五天到了特羅亞，和他們相會，在那裡住了七天。',
    '徒20:7 七日的第一日，我們聚會擘餅的時候，保羅因為要次日起行，就與他們講論，直講到半夜。',
    '徒20:8 我們聚會的那座樓上，有好些燈燭。',
    '徒20:9 有一個少年人，名叫猶推古，坐在窗臺上，困倦沉睡。保羅講了多時，少年人睡熟了，就從三層樓上掉下去；扶起他來，已經死了。',
    '徒20:10 保羅下去，伏在他身上，抱著他，說：你們不要發慌，他的靈魂還在身上。',
    '徒20:11 保羅又上去，擘餅，吃了，談論許久，直到天亮，這才走了。',
    '徒20:12 有人把那童子活活的領來，得的安慰不小。',
    '徒20:13 我們先上船，開往亞朔去，意思要在那裡接保羅；因為他是這樣安排的，他自己打算要步行。',
    '徒20:14 他既在亞朔與我們相會，我們就接他上船，來到米推利尼。',
    '徒20:15 從那裡開船，次日到了基阿的對面；又次日，在撒摩靠岸；又次日，來到米利都。',
    '徒20:16 乃因保羅早已定意越過以弗所，免得在亞西亞耽延，他急忙前走，巴不得趕五旬節能到耶路撒冷。',
    '徒20:17 保羅從米利都打發人往以弗所去，請教會的長老來。',
    '徒20:18 他們來了，保羅就說：你們知道，自從我到亞西亞的日子以來，在你們中間始終為人如何，',
    '徒20:19 服事主，凡事謙卑，眼中流淚，又因猶太人的謀害，經歷試煉。',
    '徒20:20 你們也知道，凡於你們有益的，我沒有一樣避諱不說的，或在眾人面前，或在各人家裡，我都教導你們；',
    '徒20:21 又對猶太人和希利尼人證明當向神悔改，信靠我主耶穌基督。',
    '徒20:22 現在我往耶路撒冷去，心甚迫切（原文是心被捆綁），不知道在那裡要遇見什麼事；',
    '徒20:23 但知道聖靈在各城裡向我指證，說有捆鎖與患難等待我。',
    '徒20:24 我卻不以性命為念，也不看為寶貴，只要行完我的路程，成就我從主耶穌所領受的職事，證明神恩惠的福音。',
    '徒20:25 我素常在你們中間來往，傳講神國的道；如今我曉得，你們以後都不得再見我的面了。',
    '徒20:26 所以我今日向你們證明，你們中間無論何人死亡，罪不在我身上（原文是我於眾人的血是潔淨的）。',
    '徒20:27 因為神的旨意，我並沒有一樣避諱不傳給你們的。',
    '徒20:28 聖靈立你們作全群的監督，你們就當為自己謹慎，也為全群謹慎，牧養神的教會，就是他用自己血所買來的（或作：救贖的）。',
    '徒20:29 我知道，我去之後必有兇暴的豺狼進入你們中間，不愛惜羊群。',
    '徒20:30 就是你們中間，也必有人起來說悖謬的話，要引誘門徒跟從他們。',
    '徒20:31 所以你們應當警醒，記念我三年之久晝夜不住的流淚、勸戒你們各人。',
    '徒20:32 如今我把你們交託神和他恩惠的道；這道能建立你們，叫你們和一切成聖的人同得基業。',
    '徒20:33 我未曾貪圖一個人的金、銀、衣服。',
    '徒20:34 我這兩隻手常供給我和同人的需用，這是你們自己知道的。',
    '徒20:35 我凡事給你們作榜樣，叫你們知道應當這樣勞苦，扶助軟弱的人，又當記念主耶穌的話，說：施比受更為有福。',
    '徒20:36 保羅說完了這話，就跪下同眾人禱告。',
    '徒20:37 眾人痛哭，抱著保羅的頸項，和他親嘴。',
    '徒20:38 叫他們最傷心的，就是他說：以後不能再見我的面那句話，於是送他上船去了。',
    '徒21:1 我們離別了眾人，就開船一直行到哥士。第二天到了羅底，從那裡到帕大喇，',
    '徒21:2 遇見一隻船要往腓尼基去，就上船起行。',
    '徒21:3 望見居比路，就從南邊行過，往敘利亞去，我們就在推羅上岸，因為船要在那裡卸貨。',
    '徒21:4 找著了門徒，就在那裡住了七天。他們被聖靈感動，對保羅說：不要上耶路撒冷去。',
    '徒21:5 過了這幾天，我們就起身前行。他們眾人同妻子兒女，送我們到城外，我們都跪在岸上禱告，彼此辭別。',
    '徒21:6 我們上了船，他們就回家去了。',
    '徒21:7 我們從推羅行盡了水路，來到多利買，就問那裡的弟兄安，和他們同住了一天。',
    '徒21:8 第二天，我們離開那裡，來到該撒利亞，就進了傳福音的腓利家裡，和他同住。他是那七個執事裡的一個。',
    '徒21:9 他有四個女兒，都是處女，是說預言的。',
    '徒21:10 我們在那裡多住了幾天，有一個先知，名叫亞迦布，從猶太下來，',
    '徒21:11 到了我們這裡，就拿保羅的腰帶捆上自己的手腳，說：聖靈說：猶太人在耶路撒冷，要如此捆綁這腰帶的主人，把他交在外邦人手裡。',
    '徒21:12 我們和那本地的人聽見這話，都苦勸保羅不要上耶路撒冷去。',
    '徒21:13 保羅說：你們為什麼這樣痛哭，使我心碎呢﹖我為主耶穌的名，不但被人捆綁，就是死在耶路撒冷也是願意的。',
    '徒21:14 保羅既不聽勸，我們便住了口，只說：願主的旨意成就，便了。',
    '徒21:15 過了幾日，我們收拾行李上耶路撒冷去。',
    '徒21:16 有該撒利亞的幾個門徒和我們同去，帶我們到一個久為（久為：或作老）門徒的家裡，叫我們與他同住；他名叫拿孫，是居比路人。',
    '徒21:17 到了耶路撒冷，弟兄們歡歡喜喜的接待我們。',
    '徒21:18 第二天，保羅同我們去見雅各；長老們也都在那裡。',
    '徒21:19 保羅問了他們安，便將神用他傳教，在外邦人中間所行之事，一一的述說了。',
    '徒21:20 他們聽見，就歸榮耀與神，對保羅說：兄台，你看猶太人中信主的有多少萬，並且都為律法熱心。',
    '徒21:21 他們聽見人說：你教訓一切在外邦的猶太人離棄摩西，對他們說：不要給孩子行割禮，也不要遵行條規。',
    '徒21:22 眾人必聽見你來了，這可怎麼辦呢﹖',
    '徒21:23 你就照著我們的話行吧﹖我們這裡有四個人，都有願在身。',
    '徒21:24 你帶他們去，與他們一同行潔淨的禮，替他們拿出規費，叫他們得以剃頭。這樣，眾人就可知道，先前所聽見你的事都是虛的；並可知道，你自己為人，循規蹈矩，遵行律法。',
    '徒21:25 至於信主的外邦人，我們已經寫信擬定，叫他們謹忌那祭偶像之物，和血，並勒死的牲畜，與姦淫。',
    '徒21:26 於是保羅帶著那四個人，第二天與他們一同行了潔淨的禮，進了殿，報明潔淨的日期滿足，只等祭司為他們各人獻祭。',
    '徒21:27 那七日將完，從亞西亞來的猶太人看見保羅在殿裡，就聳動了眾人，下手拿他，',
    '徒21:28 喊叫說：以色列人來幫助，這就是在各處教訓眾人蹧踐我們百姓和律法，並這地方的。他又帶著希利尼人進殿，污穢了這聖地。',
    '徒21:29 這話是因他們曾看見以弗所人特羅非摩同保羅在城裡，以為保羅帶他進了殿。',
    '徒21:30 合城都震動，百姓一齊跑來，拿住保羅，拉他出殿，殿門立刻都關了。',
    '徒21:31 他們正想要殺他，有人報信給營裡的千夫長說：耶路撒冷合城都亂了。',
    '徒21:32 千夫長立時帶著兵丁和幾個百夫長，跑下去到他們那裡。他們見了千夫長和兵丁，就止住不打保羅。',
    '徒21:33 於是千夫長上前拿住他，吩咐用兩條鐵鍊捆鎖；又問他是什麼人，做的是什麼事。',
    '徒21:34 眾人有喊叫這個的，有喊叫那個的；千夫長因為這樣亂嚷，得不著實情，就吩咐人將保羅帶進營樓去。',
    '徒21:35 到了臺階上，眾人擠得兇猛，兵丁只得將保羅擡起來。',
    '徒21:36 眾人跟在後面，喊著說：除掉他！',
    '徒21:37 將要帶他進營樓，保羅對千夫長說：我對你說句話可以不可以﹖他說：你懂得希利尼話嗎﹖',
    '徒21:38 你莫非是從前作亂、帶領四千兇徒往曠野去的那埃及人嗎﹖',
    '徒21:39 保羅說：我本是猶太人，生在基利家的大數，並不是無名小城的人。求你准我對百姓說話。',
    '徒21:40 千夫長准了。保羅就站在臺階上，向百姓擺手，他們都靜默無聲，保羅便用希伯來話對他們說：',
    '徒22:1 諸位父兄請聽，我現在對你們分訴。',
    '徒22:2 眾人聽他說的是希伯來話，就更加安靜了。',
    '徒22:3 保羅說：我原是猶太人，生在基利家的大數，長在這城裡，在迦瑪列門下，按著我們祖宗嚴緊的律法受教，熱心事奉神，像你們眾人今日一樣。',
    '徒22:4 我也曾逼迫奉這道的人，直到死地，無論男女都鎖拿下監。',
    '徒22:5 這是大祭司和眾長老都可以給我作見證的。我又領了他們達與弟兄的書信，往大馬色去，要把在那裡奉這道的人鎖拿，帶到耶路撒冷受刑。',
    '徒22:6 我將到大馬色，正走的時候，約在晌午，忽然從天上發大光，四面照著我。',
    '徒22:7 我就仆倒在地，聽見有聲音對我說：掃羅！掃羅！你為什麼逼迫我﹖',
    '徒22:8 我回答說：主啊，你是誰﹖他說：我就是你所逼迫的拿撒勒人耶穌。',
    '徒22:9 與我同行的人看見了那光，卻沒有聽明那位對我說話的聲音。',
    '徒22:10 我說：主啊，我當做什麼﹖主說：起來，進大馬色去，在那裡，要將所派你做的一切事告訴你。',
    '徒22:11 我因那光的榮耀不能看見，同行的人就拉著我手進了大馬色。',
    '徒22:12 那裡有一個人，名叫亞拿尼亞，按著律法是虔誠人，為一切住在那裡的猶太人所稱讚。',
    '徒22:13 他來見我，站在旁邊，對我說：兄弟掃羅，你可以看見。我當時往上一看，就看見了他。',
    '徒22:14 他又說：我們祖宗的神揀選了你，叫你明白他的旨意，又得見那義者，聽他口中所出的聲音。',
    '徒22:15 因為你要將所看見的，所聽見的，對著萬人為他作見證。',
    '徒22:16 現在你為什麼耽延呢﹖起來，求告他的名受洗，洗去你的罪。',
    '徒22:17 後來，我回到耶路撒冷，在殿裡禱告的時候，魂遊象外，',
    '徒22:18 看見主向我說：你趕緊的離開耶路撒冷，不可遲延；因你為我作的見證，這裡的人必不領受。',
    '徒22:19 我就說：主啊，他們知道我從前把信你的人收在監裡，又在各會堂裡鞭打他們。',
    '徒22:20 並且你的見證人司提反被害流血的時候，我也站在旁邊歡喜；又看守害死他之人的衣裳。',
    '徒22:21 主向我說：你去吧！我要差你遠遠的往外邦人那裡去。',
    '徒22:22 眾人聽他說到這句話，就高聲說：這樣的人，從世上除掉他吧！他是不當活著的。',
    '徒22:23 眾人喧嚷，摔掉衣裳，把塵土向空中揚起來。',
    '徒22:24 千夫長就吩咐將保羅帶進營樓去，叫人用鞭子拷問他，要知道他們向他這樣喧嚷是為什麼緣故。',
    '徒22:25 剛用皮條捆上，保羅對旁邊站著的百夫長說：人是羅馬人，又沒有定罪，你們就鞭打他，有這個例嗎﹖',
    '徒22:26 百夫長聽見這話，就去見千夫長，告訴他說：你要做什麼﹖這人是羅馬人。',
    '徒22:27 千夫長就來問保羅說：你告訴我，你是羅馬人嗎﹖保羅說：是。',
    '徒22:28 千夫長說：我用許多銀子才入了羅馬的民籍。保羅說：我生來就是。',
    '徒22:29 於是那些要拷問保羅的人就離開他去了。千夫長既知道他是羅馬人，又因為捆綁了他，也害怕了。',
    '徒22:30 第二天，千夫長為要知道猶太人控告保羅的實情，便解開他，吩咐祭司長和全公會的人都聚集，將保羅帶下來，叫他站在他們面前。',
    '徒23:1 保羅定睛看著公會的人，說：弟兄們，我在神面前行事為人都是憑著良心，直到今日。',
    '徒23:2 大祭司亞拿尼亞就吩咐旁邊站著的人打他的嘴。',
    '徒23:3 保羅對他說：你這粉飾的牆，神要打你！你坐堂為的是按律法審問我，你竟違背律法，吩咐人打我嗎﹖',
    '徒23:4 站在旁邊的人說：你辱罵神的大祭司嗎﹖',
    '徒23:5 保羅說：弟兄們，我不曉得他是大祭司；經上記著說：不可毀謗你百姓的官長。',
    '徒23:6 保羅看出大眾一半是撒都該人，一半是法利賽人，就在公會中大聲說：弟兄們，我是法利賽人，也是法利賽人的子孫。我現在受審問，是為盼望死人復活。',
    '徒23:7 說了這話，法利賽人和撒都該人就爭論起來，會眾分為兩黨。',
    '徒23:8 因為撒都該人說，沒有復活，也沒有天使和鬼魂；法利賽人卻說，兩樣都有。',
    '徒23:9 於是大大的喧嚷起來。有幾個法利賽黨的文士站起來爭辯說：我們看不出這人有什麼惡處，倘若有鬼魂或是天使對他說過話，怎麼樣呢﹖',
    '徒23:10 那時大起爭吵，千夫長恐怕保羅被他們扯碎了，就吩咐兵丁下去，把他從眾人當中搶出來，帶進營樓去。',
    '徒23:11 當夜，主站在保羅旁邊，說：放心吧！你怎樣在耶路撒冷為我作見證，也必怎樣在羅馬為我作見證。',
    '徒23:12 到了天亮，猶太人同謀起誓，說：若不先殺保羅就不吃不喝。',
    '徒23:13 這樣同心起誓的有四十多人。',
    '徒23:14 他們來見祭司長和長老，說：我們已經起了一個大誓，若不先殺保羅就不吃什麼。',
    '徒23:15 現在你們和公會要知會千夫長，叫他帶下保羅到你們這裡來，假作要詳細察考他的事；我們已經預備好了，不等他來到跟前就殺他。',
    '徒23:16 保羅的外甥聽見他們設下埋伏，就來到營樓裡告訴保羅。',
    '徒23:17 保羅請一個百夫長來，說：你領這少年人去見千夫長，他有事告訴他。',
    '徒23:18 於是把他領去見千夫長，說：被囚的保羅請我到他那裡，求我領這少年人來見你；他有事告訴你。',
    '徒23:19 千夫長就拉著他的手，走到一旁，私下問他說：你有什麼事告訴我呢﹖',
    '徒23:20 他說：猶太人已經約定，要求你明天帶下保羅到公會裡去，假作要詳細查問他的事。',
    '徒23:21 你切不要隨從他們；因為他們有四十多人埋伏，已經起誓說：若不先殺保羅就不吃不喝。現在預備好了，只等你應允。',
    '徒23:22 於是千夫長打發少年人走，囑咐他說：不要告訴人你將這事報給我了。',
    '徒23:23 千夫長便叫了兩個百夫長來，說：預備步兵二百，馬兵七十，長槍手二百，今夜亥初往該撒利亞去；',
    '徒23:24 也要預備牲口叫保羅騎上，護送到巡撫腓力斯那裡去。',
    '徒23:25 千夫長又寫了文書，',
    '徒23:26 大略說：革老丟呂西亞，請巡撫腓力斯大人安。',
    '徒23:27 這人被猶太人拿住，將要殺害，我得知他是羅馬人，就帶兵丁下去救他出來。',
    '徒23:28 因要知道他們告他的緣故，我就帶他下到他們的公會去，',
    '徒23:29 便查知他被告是因他們律法的辯論，並沒有什麼該死該綁的罪名。',
    '徒23:30 後來有人把要害他的計謀告訴我，我就立時解他到你那裡去，又吩咐告他的人在你面前告他。（有古卷在此有：願你平安！）',
    '徒23:31 於是，兵丁照所吩咐他們的，將保羅夜裡帶到安提帕底。',
    '徒23:32 第二天，讓馬兵護送，他們就回營樓去。',
    '徒23:33 馬兵來到該撒利亞，把文書呈給巡撫，便叫保羅站在他面前。',
    '徒23:34 巡撫看了文書，問保羅是哪省的人，既曉得他是基利家人，',
    '徒23:35 就說：等告你的人來到，我要細聽你的事；便吩咐人把他看守在希律的衙門裡。',
    '徒24:1 過了五天，大祭司亞拿尼亞同幾個長老，和一個辯士帖土羅下來，向巡撫控告保羅。',
    '徒24:2 保羅被提了來，帖土羅就告他說：',
    '徒24:3 腓力斯大人，我們因你得以大享太平，並且這一國的弊病，因著你的先見得以更正了；我們隨時隨地滿心感謝不盡。',
    '徒24:4 惟恐多說，你嫌煩絮，只求你寬容聽我們說幾句話。',
    '徒24:5 我們看這個人，如同瘟疫一般，是鼓動普天下眾猶太人生亂的，又是拿撒勒教黨裡的一個頭目，',
    '徒24:6 連聖殿他也想要污穢；我們把他捉住了。（有古卷在此有：要按我們的律法審問，',
    '徒24:7 不料千夫長呂西亞前來，甚是強橫，從我們手中把他奪去，吩咐告他的人到你這裡來。）',
    '徒24:8 你自己究問他，就可以知道我們告他的一切事了。',
    '徒24:9 眾猶太人也隨著告他說：事情誠然是這樣。',
    '徒24:10 巡撫點頭叫保羅說話。他就說：我知道你在這國裡斷事多年，所以我樂意為自己分訴。',
    '徒24:11 你查問就可以知道，從我上耶路撒冷禮拜到今日不過有十二天。',
    '徒24:12 他們並沒有看見我在殿裡，或是在會堂裡，或是在城裡，和人辯論，聳動眾人。',
    '徒24:13 他們現在所告我的事並不能對你證實了。',
    '徒24:14 但有一件事，我向你承認，就是他們所稱為異端的道，我正按著那道事奉我祖宗的神，又信合乎律法的和先知書上一切所記載的，',
    '徒24:15 並且靠著神，盼望死人，無論善惡，都要復活，就是他們自己也有這個盼望。',
    '徒24:16 我因此自己勉勵，對神對人，常存無虧的良心。',
    '徒24:17 過了幾年，我帶著賙濟本國的捐項和供獻的物上去。',
    '徒24:18 正獻的時候，他們看見我在殿裡已經潔淨了，並沒有聚眾，也沒有吵嚷，惟有幾個從亞西亞來的猶太人。',
    '徒24:19 他們若有告我的事，就應當到你面前來告我。',
    '徒24:20 即或不然，這些人若看出我站在公會前，有妄為的地方，他們自己也可以說明。',
    '徒24:21 縱然有，也不過一句話，就是我站在他們中間大聲說：我今日在你們面前受審，是為死人復活的道理。',
    '徒24:22 腓力斯本是詳細曉得這道，就支吾他們說：且等千夫長呂西亞下來，我要審斷你們的事。',
    '徒24:23 於是吩咐百夫長看守保羅，並且寬待他，也不攔阻他的親友來供給他。',
    '徒24:24 過了幾天，腓力斯和他夫人─猶太的女子土西拉─一同來到，就叫了保羅來，聽他講論信基督耶穌的道。',
    '徒24:25 保羅講論公義、節制，和將來的審判。腓力斯甚覺恐懼，說：你暫且去吧，等我得便再叫你來。',
    '徒24:26 腓力斯又指望保羅送他銀錢，所以屢次叫他來，和他談論。',
    '徒24:27 過了兩年，波求非斯都接了腓力斯的任；腓力斯要討猶太人的喜歡，就留保羅在監裡。',
    '徒25:1 非斯都到了任，過了三天，就從該撒利亞上耶路撒冷去。',
    '徒25:2 祭司長和猶太人的首領向他控告保羅，',
    '徒25:3 又央告他，求他的情，將保羅提到耶路撒冷來，他們要在路上埋伏殺害他。',
    '徒25:4 非斯都卻回答說：保羅押在該撒利亞，我自己快要往那裡去；',
    '徒25:5 又說：你們中間有權勢的人與我一同下去，那人若有什麼不是，就可以告他。',
    '徒25:6 非斯都在他們那裡住了不過十天八天，就下該撒利亞去；第二天坐堂，吩咐將保羅提上來。',
    '徒25:7 保羅來了，那些從耶路撒冷下來的猶太人周圍站著，將許多重大的事控告他，都是不能證實的。',
    '徒25:8 保羅分訴說：無論猶太人的律法，或是聖殿，或是該撒，我都沒有干犯。',
    '徒25:9 但非斯都要討猶太人的喜歡，就問保羅說：你願意上耶路撒冷去，在那裡聽我審斷這事嗎﹖',
    '徒25:10 保羅說：我站在該撒的堂前，這就是我應當受審的地方。我向猶太人並沒有行過什麼不義的事，這也是你明明知道的。',
    '徒25:11 我若行了不義的事，犯了什麼該死的罪，就是死，我也不辭。他們所告我的事若都不實，就沒有人可以把我交給他們。我要上告於該撒。',
    '徒25:12 非斯都和議會商量了，就說：你既上告於該撒，可以往該撒那裡去。',
    '徒25:13 過了些日子，亞基帕王和百尼基氏來到該撒利亞，問非斯都安。',
    '徒25:14 在那裡住了多日，非斯都將保羅的事告訴王，說：這裡有一個人，是腓力斯留在監裡的。',
    '徒25:15 我在耶路撒冷的時候，祭司長和猶太的長老將他的事稟報了我，求我定他的罪。',
    '徒25:16 我對他們說，無論什麼人，被告還沒有和原告對質，未得機會分訴所告他的事，就先定他的罪，這不是羅馬人的條例。',
    '徒25:17 及至他們都來到這裡，我就不耽延，第二天便坐堂，吩咐把那人提上來。',
    '徒25:18 告他的人站著告他；所告的，並沒有我所逆料的那等惡事。',
    '徒25:19 不過是有幾樣辯論，為他們自己敬鬼神的事，又為一個人名叫耶穌，是已經死了，保羅卻說他是活著的。',
    '徒25:20 這些事當怎樣究問，我心裡作難，所以問他說：你願意上耶路撒冷去，在那裡為這些事聽審嗎﹖',
    '徒25:21 但保羅求我留下他，要聽皇上審斷，我就吩咐把他留下，等我解他到該撒那裡去。',
    '徒25:22 亞基帕對非斯都說：我自己也願聽這人辯論。非斯都說：明天你可以聽。',
    '徒25:23 第二天，亞基帕和百尼基大張威勢而來，同著眾千夫長和城裡的尊貴人進了公廳。非斯都吩咐一聲，就有人將保羅帶進來。',
    '徒25:24 非斯都說：亞基帕王和在這裡的諸位啊，你們看這人，就是一切猶太人，在耶路撒冷和這裡，曾向我懇求、呼叫說：不可容他再活著。',
    '徒25:25 但我查明他沒有犯什麼該死的罪，並且他自己上告於皇帝，所以我定意把他解去。',
    '徒25:26 論到這人，我沒有確實的事可以奏明主上。因此，我帶他到你們面前，也特意帶他到你亞基帕王面前，為要在查問之後有所陳奏。',
    '徒25:27 據我看來，解送囚犯，不指明他的罪案是不合理的。',
    '徒26:1 亞基帕對保羅說：准你為自己辯明。於是保羅伸手分訴，說：',
    '徒26:2 亞基帕王啊，猶太人所告我的一切事，今日得在你面前分訴，實為萬幸；',
    '徒26:3 更可幸的，是你熟悉猶太人的規矩和他們的辯論；所以求你耐心聽我。',
    '徒26:4 我從起初在本國的民中，並在耶路撒冷，自幼為人如何，猶太人都知道。',
    '徒26:5 他們若肯作見證就曉得，我從起初是按著我們教中最嚴緊的教門作了法利賽人。',
    '徒26:6 現在我站在這裡受審，是因為指望神向我們祖宗所應許的；',
    '徒26:7 這應許，我們十二個支派，晝夜切切的事奉神，都指望得著。王啊，我被猶太人控告，就是因這指望。',
    '徒26:8 神叫死人復活，你們為什麼看作不可信的呢﹖',
    '徒26:9 從前我自己以為應當多方攻擊拿撒勒人耶穌的名，',
    '徒26:10 我在耶路撒冷也曾這樣行了。既從祭司長得了權柄，我就把許多聖徒囚在監裡。他們被殺，我也出名定案。',
    '徒26:11 在各會堂，我屢次用刑強逼他們說褻瀆的話，又分外惱恨他們，甚至追逼他們，直到外邦的城邑。',
    '徒26:12 那時，我領了祭司長的權柄和命令，往大馬色去。',
    '徒26:13 王啊，我在路上，晌午的時候，看見從天發光，比日頭還亮，四面照著我並與我同行的人。',
    '徒26:14 我們都仆倒在地，我就聽見有聲音用希伯來話向我說：掃羅！掃羅！為什麼逼迫我﹖你用腳踢刺是難的！',
    '徒26:15 我說：主啊，你是誰﹖主說：我就是你所逼迫的耶穌。',
    '徒26:16 你起來站著，我特意向你顯現，要派你作執事，作見證，將你所看見的事和我將要指示你的事證明出來。；',
    '徒26:17 我也要救你脫離百姓和外邦人的手。',
    '徒26:18 我差你到他們那裡去，要叫他們的眼睛得開，從黑暗中歸向光明，從撒但權下歸向神；又因信我，得蒙赦罪，和一切成聖的人同得基業。',
    '徒26:19 亞基帕王啊，我故此沒有違背那從天上來的異象；',
    '徒26:20 先在大馬色，後在耶路撒冷和猶太全地，以及外邦，勸勉他們應當悔改歸向神，行事與悔改的心相稱。',
    '徒26:21 因此，猶太人在殿裡拿住我，想要殺我。',
    '徒26:22 然而我蒙神的幫助，直到今日還站得住，對著尊貴、卑賤、老幼作見證；所講的並不外乎眾先知和摩西所說將來必成的事，',
    '徒26:23 就是基督必須受害，並且因從死裡復活，要首先把光明的道傳給百姓和外邦人。',
    '徒26:24 保羅這樣分訴，非斯都大聲說：保羅，你癲狂了吧。你的學問太大，反叫你癲狂了！',
    '徒26:25 保羅說：非斯都大人，我不是癲狂，我說的乃是真實明白話。',
    '徒26:26 王也曉得這些事，所以我向王放膽直言，我深信這些事沒有一件向王隱藏的，因都不是在背地裡做的。',
    '徒26:27 亞基帕王啊，你信先知嗎﹖我知道你是信的。',
    '徒26:28 亞基帕對保羅說：你想少微一勸，便叫我作基督徒啊（或作：你這樣勸我，幾乎叫我作基督徒了）！',
    '徒26:29 保羅說：無論是少勸是多勸，我向神所求的，不但你一個人，就是今天一切聽我的，都要像我一樣，只是不要像我有這些鎖鍊。',
    '徒26:30 於是，王和巡撫並百尼基與同坐的人都起來，',
    '徒26:31 退到裡面，彼此談論說：這人並沒有犯什麼該死該綁的罪。',
    '徒26:32 亞基帕又對非斯都說：這人若沒有上告於該撒，就可以釋放了。',
    '徒27:1 非斯都既然定規了，叫我們坐船往義大利去，便將保羅和別的囚犯交給御營裡的一個百夫長，名叫猶流。',
    '徒27:2 有一隻亞大米田的船，要沿著亞西亞一帶地方的海邊走，我們就上了那船開行；有馬其頓的帖撒羅尼迦人亞里達古和我們同去。',
    '徒27:3 第二天，到了西頓；猶流寬待保羅，准他往朋友那裡去，受他們的照應。',
    '徒27:4 從那裡又開船，因為風不順，就貼著居比路背風岸行去。',
    '徒27:5 過了基利家、旁非利亞前面的海，就到了呂家的每拉。',
    '徒27:6 在那裡，百夫長遇見一隻亞力山大的船，要往義大利去，便叫我們上了那船。',
    '徒27:7 一連多日，船行得慢，僅僅來到革尼土的對面。因為被風攔阻，就貼著革哩底背風岸，從撒摩尼對面行過。',
    '徒27:8 我們沿岸行走，僅僅來到一個地方，名叫佳澳；離那裡不遠，有拉西亞城。',
    '徒27:9 走的日子多了，已經過了禁食的節期，行船又危險，保羅就勸眾人說：',
    '徒27:10 眾位，我看這次行船，不但貨物和船要受傷損，大遭破壞，連我們的性命也難保。',
    '徒27:11 但百夫長信從掌船的和船主，不信從保羅所說的。',
    '徒27:12 且因在這海口過冬不便，船上的人就多半說：不如開船離開這地方，或者能到非尼基過冬。非尼基是革哩底的一個海口，一面朝東北，一面朝東南。',
    '徒27:13 這時，微微起了南風，他們以為得意，就起了錨，貼近革哩底行去。',
    '徒27:14 不多幾時，狂風從島上撲下來；那風名叫友拉革羅。',
    '徒27:15 船被風抓住，敵不住風，我們就任風颳去。',
    '徒27:16 貼著一個小島的背風岸奔行，那島名叫高大，在那裡僅僅收住了小船。',
    '徒27:17 既然把小船拉上來，就用纜索捆綁船底，又恐怕在賽耳底沙灘上擱了淺，就落下篷來，任船飄去。',
    '徒27:18 我們被風浪逼得甚急，第二天眾人就把貨物拋在海裡。',
    '徒27:19 到第三天，他們又親手把船上的器具拋棄了。',
    '徒27:20 太陽和星辰多日不顯露，又有狂風大浪催逼，我們得救的指望就都絕了。',
    '徒27:21 眾人多日沒有吃什麼，保羅就出來站在他們中間，說：眾位，你們本該聽我的話，不離開革哩底，免得遭這樣的傷損破壞。',
    '徒27:22 現在我還勸你們放心，你們的性命一個也不失喪，惟獨失喪這船。',
    '徒27:23 因我所屬所事奉的神，他的使者昨夜站在我旁邊，說：',
    '徒27:24 保羅，不要害怕，你必定站在該撒面前，並且與你同船的人，神都賜給你了。',
    '徒27:25 所以眾位可以放心，我信神他怎樣對我說：事情也要怎樣成就。',
    '徒27:26 只是我們必要撞在一個島上。',
    '徒27:27 到了第十四天夜間，船在亞底亞海飄來飄去。約到半夜，水手以為漸近旱地，',
    '徒27:28 就探深淺，探得有十二丈；稍往前行，又探深淺，探得有九丈。',
    '徒27:29 恐怕撞在石頭上，就從船尾拋下四個錨，盼望天亮。',
    '徒27:30 水手想要逃出船去，把小船放在海裡，假作要從船頭拋錨的樣子。',
    '徒27:31 保羅對百夫長和兵丁說：這些人若不等在船上，你們必不能得救。',
    '徒27:32 於是兵丁砍斷小船的繩子，由他飄去。',
    '徒27:33 天漸亮的時候，保羅勸眾人都吃飯，說：你們懸望忍餓不吃什麼，已經十四天了。',
    '徒27:34 所以我勸你們吃飯，這是關乎你們救命的事；因為你們各人連一根頭髮也不至於損壞。',
    '徒27:35 保羅說了這話，就拿著餅，在眾人面前祝謝了神，擘開吃。',
    '徒27:36 於是他們都放下心，也就吃了。',
    '徒27:37 我們在船上的共有二百七十六個人。',
    '徒27:38 他們吃飽了，就把船上的麥子拋在海裡，為要叫船輕一點。',
    '徒27:39 到了天亮，他們不認識那地方，但見一個海灣，有岸可登，就商議能把船攏進去不能。',
    '徒27:40 於是砍斷纜索，棄錨在海裡；同時也鬆開舵繩，拉起頭篷，順著風向岸行去。',
    '徒27:41 但遇著兩水夾流的地方，就把船擱了淺；船頭膠住不動，船尾被浪的猛力衝壞。',
    '徒27:42 兵丁的意思要把囚犯殺了，恐怕有洑水脫逃的。',
    '徒27:43 但百夫長要救保羅，不准他們任意而行，就吩咐會洑水的，跳下水去先上岸；',
    '徒27:44 其餘的人可以用板子或船上的零碎東西上岸。這樣，眾人都得了救，上了岸。',
    '徒28:1 我們既已得救，才知道那島名叫米利大。',
    '徒28:2 土人看待我們，有非常的情分；因為當時下雨，天氣又冷，就生火接待我們眾人。',
    '徒28:3 那時，保羅拾起一捆柴，放在火上，有一條毒蛇，因為熱了出來，咬住他的手。',
    '徒28:4 土人看見那毒蛇懸在他手上，就彼此說：這人必是個兇手，雖然從海裡救上來，天理還不容他活著。',
    '徒28:5 保羅竟把那毒蛇甩在火裡，並沒有受傷。',
    '徒28:6 土人想他必要腫起來，或是忽然仆倒死了；看了多時，見他無害，就轉念，說：他是個神。',
    '徒28:7 離那地方不遠，有田產是島長部百流的；他接納我們，盡情款待三日。',
    '徒28:8 當時，部百流的父親患熱病和痢疾躺著。保羅進去，為他禱告，按手在他身上，治好了他。',
    '徒28:9 從此，島上其餘的病人也來，得了醫治。',
    '徒28:10 他們又多方的尊敬我們；到了開船的時候，也把我們所需用的送到船上。',
    '徒28:11 過了三個月，我們上了亞力山大的船往前行；這船以丟斯雙子為記，是在那海島過了冬的。',
    '徒28:12 到了敘拉古，我們停泊三日；',
    '徒28:13 又從那裡繞行，來到利基翁。過了一天，起了南風，第二天就來到部丟利。',
    '徒28:14 在那裡遇見弟兄們，請我們與他們同住了七天。這樣，我們來到羅馬。',
    '徒28:15 那裡的弟兄們一聽見我們的信息就出來，到亞比烏市和三館地方迎接我們。保羅見了他們，就感謝神，放心壯膽。',
    '徒28:16 進了羅馬城，（有古卷在此有：百夫長把眾囚犯交給御營的統領，惟有）保羅蒙准和一個看守他的兵另住在一處。',
    '徒28:17 過了三天，保羅請猶太人的首領來。他們來了，就對他們說：弟兄們，我雖沒有做什麼事干犯本國的百姓和我們祖宗的規條，卻被鎖綁，從耶路撒冷解在羅馬人的手裡。',
    '徒28:18 他們審問了我，就願意釋放我；因為在我身上，並沒有該死的罪。',
    '徒28:19 無奈猶太人不服，我不得已，只好上告於該撒，並非有什麼事要控告我本國的百姓。',
    '徒28:20 因此，我請你們來見面說話，我原為以色列人所指望的，被這鍊子捆鎖。',
    '徒28:21 他們說：我們並沒有接著從猶太來論你的信，也沒有弟兄到這裡來報給我們說你有什麼不好處。',
    '徒28:22 但我們願意聽你的意見如何；因為這教門，我們曉得是到處被毀謗的。',
    '徒28:23 他們和保羅約定了日子，就有許多人到他的寓處來。保羅從早到晚，對他們講論這事，證明神國的道，引摩西的律法和先知的書，以耶穌的事勸勉他們。',
    '徒28:24 他所說的話，有信的，有不信的。',
    '徒28:25 他們彼此不合，就散了；未散以先，保羅說了一句話，說：聖靈藉先知以賽亞向你們祖宗所說的話是不錯的。',
    '徒28:26 他說：你去告訴這百姓說：你們聽是要聽見，卻不明白；看是要看見，卻不曉得；',
    '徒28:27 因為這百姓油蒙了心，耳朵發沉，眼睛閉著；恐怕眼睛看見，耳朵聽見，心裡明白，回轉過來，我就醫治他們。',
    '徒28:28 所以你們當知道，神這救恩，如今傳給外邦人，他們也必聽受。（有古卷在此有：',
    '徒28:29 保羅說了這話，猶太人議論紛紛的就走了。）',
    '徒28:30 保羅在自己所租的房子裡住了足足兩年。凡來見他的人，他全都接待，',
    '徒28:31 放膽傳講神國的道，將主耶穌基督的事教導人，並沒有人禁止。',
    '羅1:1 耶穌基督的僕人保羅，奉召為使徒，特派傳神的福音。',
    '羅1:2 這福音是神從前藉眾先知在聖經上所應許的，',
    '羅1:3 論到他兒子─我主耶穌基督。按肉體說，是從大衛後裔生的；',
    '羅1:4 按聖善的靈說，因從死裡復活，以大能顯明是神的兒子。',
    '羅1:5 我們從他受了恩惠並使徒的職分，在萬國之中叫人為他的名信服真道；',
    '羅1:6 其中也有你們這蒙召屬耶穌基督的人。',
    '羅1:7 我寫信給你們在羅馬、為神所愛、奉召作聖徒的眾人。願恩惠、平安從我們的父神並主耶穌基督歸與你們！',
    '羅1:8 第一，我靠著耶穌基督，為你們眾人感謝我的神，因你們的信德傳遍了天下。',
    '羅1:9 我在他兒子福音上，用心靈所事奉的神，可以見證我怎樣不住的提到你們；',
    '羅1:10 在禱告之間常常懇求，或者照神的旨意，終能得平坦的道路往你們那裡去。',
    '羅1:11 因為我切切的想見你們，要把些屬靈的恩賜分給你們，使你們可以堅固。',
    '羅1:12 這樣，我在你們中間，因你與我彼此的信心，就可以同得安慰。',
    '羅1:13 弟兄們，我不願意你們不知道，我屢次定意往你們那裡去，要在你們中間得些果子，如同在其餘的外邦人中一樣；只是到如今仍有阻隔。',
    '羅1:14 無論是希利尼人、化外人、聰明人、愚拙人，我都欠他們的債，',
    '羅1:15 所以情願盡我的力量，將福音也傳給你們在羅馬的人。',
    '羅1:16 我不以福音為恥；這福音本是神的大能，要救一切相信的，先是猶太人，後是希利尼人。',
    '羅1:17 因為神的義正在這福音上顯明出來；這義是本於信，以致於信。如經上所記：義人必因信得生。',
    '羅1:18 原來，神的忿怒從天上顯明在一切不虔不義的人身上，就是那些行不義阻擋真理的人。',
    '羅1:19 神的事情，人所能知道的，原顯明在人心裡，因為神已經給他們顯明。',
    '羅1:20 自從造天地以來，神的永能和神性是明明可知的，雖是眼不能見，但藉著所造之物就可以曉得，叫人無可推諉。',
    '羅1:21 因為，他們雖然知道神，卻不當作神榮耀他，也不感謝他。他們的思念變為虛妄，無知的心就昏暗了。',
    '羅1:22 自稱為聰明，反成了愚拙，',
    '羅1:23 將不能朽壞之神的榮耀變為偶像，彷彿必朽壞的人和飛禽、走獸、昆蟲的樣式。',
    '羅1:24 所以，神任憑他們逞著心裡的情慾行污穢的事，以致彼此玷辱自己的身體。',
    '羅1:25 他們將神的真實變為虛謊，去敬拜事奉受造之物，不敬奉那造物的主；主乃是可稱頌的，直到永遠。阿們！',
    '羅1:26 因此，神任憑他們放縱可羞恥的情慾。他們的女人把順性的用處變為逆性的用處；',
    '羅1:27 男人也是如此，棄了女人順性的用處，慾火攻心，彼此貪戀，男和男行可羞恥的事，就在自己身上受這妄為當得的報應。',
    '羅1:28 他們既然故意不認識神，神就任憑他們存邪僻的心，行那些不合理的事；',
    '羅1:29 裝滿了各樣不義、邪惡、貪婪、惡毒（或作：陰毒），滿心是嫉妒、兇殺、爭競、詭詐、毒恨；',
    '羅1:30 又是讒毀的、背後說人的、怨恨神的（或作：被神所憎惡的）、侮慢人的、狂傲的、自誇的、捏造惡事的、違背父母的。',
    '羅1:31 無知的，背約的，無親情的，不憐憫人的。',
    '羅1:32 他們雖知道神判定行這樣事的人是當死的，然而他們不但自己去行，還喜歡別人去行。',
    '羅2:1 你這論斷人的，無論你是誰，也無可推諉。你在什麼事上論斷人，就在什麼事上定自己的罪；因你這論斷人的，自己所行卻和別人一樣。',
    '羅2:2 我們知道這樣行的人，神必照真理審判他。',
    '羅2:3 你這人哪，你論斷行這樣事的人，自己所行的卻和別人一樣，你以為能逃脫神的審判嗎﹖',
    '羅2:4 還是你藐視他豐富的恩慈、寬容、忍耐，不曉得他的恩慈是領你悔改呢﹖',
    '羅2:5 你竟任著你剛硬不悔改的心，為自己積蓄忿怒，以致神震怒，顯他公義審判的日子來到。',
    '羅2:6 他必照各人的行為報應各人。',
    '羅2:7 凡恆心行善、尋求榮耀、尊貴和不能朽壞之福的，就以永生報應他們；',
    '羅2:8 惟有結黨、不順從真理、反順從不義的，就以忿怒、惱恨報應他們。',
    '羅2:9 將患難、困苦加給一切作惡的人，先是猶太人，後是希利尼人；',
    '羅2:10 卻將榮耀、尊貴、平安加給一切行善的人，先是猶太人，後是希利尼人。',
    '羅2:11 因為神不偏待人。',
    '羅2:12 凡沒有律法犯了罪的，也必不按律法滅亡；凡在律法以下犯了罪的，也必按律法受審判。',
    '羅2:13 （原來在神面前，不是聽律法的為義，乃是行律法的稱義。',
    '羅2:14 沒有律法的外邦人若順著本性行律法上的事，他們雖然沒有律法，自己就是自己的律法。',
    '羅2:15 這是顯出律法的功用刻在他們心裡，他們是非之心同作見證，並且他們的思念互相較量，或以為是，或以為非。）',
    '羅2:16 就在神藉耶穌基督審判人隱祕事的日子，照著我的福音所言。',
    '羅2:17 你稱為猶太人，又倚靠律法，且指著神誇口；',
    '羅2:18 既從律法中受了教訓，就曉得神的旨意，也能分別是非（或作：也喜愛那美好的事）；',
    '羅2:19 又深信自己是給瞎子領路的，是黑暗中人的光，',
    '羅2:20 是蠢笨人的師傅，是小孩子的先生，在律法上有知識和真理的模範。',
    '羅2:21 你既是教導別人，還不教導自己嗎﹖你講說人不可偷竊，自己還偷竊嗎﹖',
    '羅2:22 你說人不可姦淫，自己還姦淫嗎﹖你厭惡偶像，自己還偷竊廟中之物嗎﹖',
    '羅2:23 你指著律法誇口，自己倒犯律法，玷辱神嗎﹖',
    '羅2:24 神的名在外邦人中，因你們受了褻瀆，正如經上所記的。',
    '羅2:25 你若是行律法的，割禮固然於你有益；若是犯律法的，你的割禮就算不得割禮。',
    '羅2:26 所以那未受割禮的，若遵守律法的條例，他雖然未受割禮，豈不算是有割禮嗎﹖',
    '羅2:27 而且那本來未受割禮的，若能全守律法，豈不是要審判你這有儀文和割禮竟犯律法的人嗎﹖',
    '羅2:28 因為外面作猶太人的，不是真猶太人；外面肉身的割禮，也不是真割禮。',
    '羅2:29 惟有裡面作的，才是真猶太人；真割禮也是心裡的，在乎靈，不在乎儀文。這人的稱讚不是從人來的，乃是從神來的。',
    '羅3:1 這樣說來，猶太人有什麼長處﹖割禮有什麼益處呢﹖',
    '羅3:2 凡事大有好處：第一是神的聖言交託他們。',
    '羅3:3 即便有不信的，這有何妨呢﹖難道他們的不信就廢掉神的信嗎﹖',
    '羅3:4 斷乎不能！不如說，神是真實的，人都是虛謊的。如經上所記：你責備人的時候，顯為公義；被人議論的時候，可以得勝。',
    '羅3:5 我且照著人的常話說，我們的不義若顯出神的義來，我們可以怎麼說呢﹖神降怒，是他不義嗎﹖',
    '羅3:6 斷乎不是！若是這樣，神怎能審判世界呢﹖',
    '羅3:7 若神的真實，因我的虛謊越發顯出他的榮耀，為什麼我還受審判，好像罪人呢﹖',
    '羅3:8 為什麼不說，我們可以作惡以成善呢﹖這是毀謗我們的人說我們有這話。這等人定罪是該當的。',
    '羅3:9 這卻怎麼樣呢﹖我們比他們強嗎﹖決不是的！因我們已經證明，猶太人和希利尼人都在罪惡之下。',
    '羅3:10 就如經上所記：沒有義人，連一個也沒有。',
    '羅3:11 沒有明白的；沒有尋求神的；',
    '羅3:12 都是偏離正路，一同變為無用。沒有行善的，連一個也沒有。',
    '羅3:13 他們的喉嚨是敞開的墳墓；他們用舌頭弄詭詐，嘴唇裡有虺蛇的毒氣，',
    '羅3:14 滿口是咒罵苦毒。',
    '羅3:15 殺人流血，他們的腳飛跑，',
    '羅3:16 所經過的路便行殘害暴虐的事。',
    '羅3:17 平安的路，他們未曾知道；',
    '羅3:18 他們眼中不怕神。',
    '羅3:19 我們曉得律法上的話都是對律法以下之人說的，好塞住各人的口，叫普世的人都伏在神審判之下。',
    '羅3:20 所以凡有血氣的，沒有一個因行律法能在神面前稱義，因為律法本是叫人知罪。',
    '羅3:21 但如今，神的義在律法以外已經顯明出來，有律法和先知為證：',
    '羅3:22 就是神的義，因信耶穌基督加給一切相信的人，並沒有分別。',
    '羅3:23 因為世人都犯了罪，虧缺了神的榮耀；',
    '羅3:24 如今卻蒙神的恩典，因基督耶穌的救贖，就白白的稱義。',
    '羅3:25 神設立耶穌作挽回祭，是憑著耶穌的血，藉著人的信，要顯明神的義；因為他用忍耐的心寬容人先時所犯的罪，',
    '羅3:26 好在今時顯明他的義，使人知道他自己為義，也稱信耶穌的人為義。',
    '羅3:27 既是這樣，哪裡能誇口呢﹖沒有可誇的了。用何法沒有的呢﹖是用立功之法嗎﹖不是，乃用信主之法。',
    '羅3:28 所以（有古卷：因為）我們看定了：人稱義是因著信，不在乎遵行律法。',
    '羅3:29 難道神只作猶太人的神嗎﹖不也是作外邦人的神嗎﹖是的，也作外邦人的神。',
    '羅3:30 神既是一位，他就要因信稱那受割禮的為義，也要因信稱那未受割禮的為義。',
    '羅3:31 這樣，我們因信廢了律法嗎﹖斷乎不是！更是堅固律法。',
    '羅4:1 如此說來，我們的祖宗亞伯拉罕憑著肉體得了什麼呢﹖',
    '羅4:2 倘若亞伯拉罕是因行為稱義，就有可誇的；只是在神面前並無可誇。',
    '羅4:3 經上說什麼呢﹖說：亞伯拉罕信神，這就算為他的義。',
    '羅4:4 做工的得工價，不算恩典，乃是該得的；',
    '羅4:5 惟有不做工的，只信稱罪人為義的神，他的信就算為義。',
    '羅4:6 正如大衛稱那在行為以外蒙神算為義的人是有福的。',
    '羅4:7 他說：得赦免其過、遮蓋其罪的，這人是有福的。',
    '羅4:8 主不算為有罪的，這人是有福的。',
    '羅4:9 如此看來，這福是單加給那受割禮的人嗎﹖不也是加給那未受割禮的人嗎﹖因我們所說，亞伯拉罕的信，就算為他的義，',
    '羅4:10 是怎麼算的呢﹖是在他受割禮的時候呢﹖是在他未受割禮的時候呢﹖不是在受割禮的時候，乃是在未受割禮的時候。',
    '羅4:11 並且他受了割禮的記號，作他未受割禮的時候因信稱義的印證，叫他作一切未受割禮而信之人的父，使他們也算為義；',
    '羅4:12 又作受割禮之人的父，就是那些不但受割禮，並且按我們的祖宗亞伯拉罕未受割禮而信之蹤跡去行的人。',
    '羅4:13 因為神應許亞伯拉罕和他後裔，必得承受世界，不是因律法，乃是因信而得的義。',
    '羅4:14 若是屬乎律法的人才得為後嗣，信就歸於虛空，應許也就廢棄了。',
    '羅4:15 因為律法是惹動忿怒的（或作：叫人受刑的）；哪裡沒有律法，那裡就沒有過犯。',
    '羅4:16 所以人得為後嗣是本乎信，因此就屬乎恩，叫應許定然歸給一切後裔；不但歸給那屬乎律法的，也歸給那效法亞伯拉罕之信的。',
    '羅4:17 亞伯拉罕所信的，是那叫死人復活、使無變為有的神，他在主面前作我們世人的父。如經上所記：我已經立你作多國的父。',
    '羅4:18 他在無可指望的時候，因信仍有指望，就得以作多國的父，正如先前所說，你的後裔將要如此。',
    '羅4:19 他將近百歲的時候，雖然想到自己的身體如同已死，撒拉的生育已經斷絕，他的信心還是不軟弱；',
    '羅4:20 並且仰望神的應許，總沒有因不信心裡起疑惑，反倒因信心裡得堅固，將榮耀歸給神，',
    '羅4:21 且滿心相信神所應許的必能做成。',
    '羅4:22 所以，這就算為他的義。',
    '羅4:23 算為他義的這句話不是單為他寫的，',
    '羅4:24 也是為我們將來得算為義之人寫的，就是我們這信神使我們的主耶穌從死裡復活的人。',
    '羅4:25 耶穌被交給人，是為我們的過犯；復活，是為叫我們稱義（或作：耶穌是為我們的過犯交付了，是為我們稱義復活了）。',
    '羅5:1 我們既因信稱義，就藉著我們的主耶穌基督得與神相和。',
    '羅5:2 我們又藉著他，因信得進入現在所站的這恩典中，並且歡歡喜喜盼望神的榮耀。',
    '羅5:3 不但如此，就是在患難中也是歡歡喜喜的；因為知道患難生忍耐，',
    '羅5:4 忍耐生老練，老練生盼望；',
    '羅5:5 盼望不至於羞恥，因為所賜給我們的聖靈將神的愛澆灌在我們心裡。',
    '羅5:6 因我們還軟弱的時候，基督就按所定的日期為罪人死。',
    '羅5:7 為義人死，是少有的；為仁人死、或者有敢做的。',
    '羅5:8 惟有基督在我們還作罪人的時候為我們死，神的愛就在此向我們顯明了。',
    '羅5:9 現在我們既靠著他的血稱義，就更要藉著他免去神的忿怒。',
    '羅5:10 因為我們作仇敵的時候，且藉著神兒子的死，得與神和好；既已和好，就更要因他的生得救了。',
    '羅5:11 不但如此，我們既藉著我主耶穌基督得與神和好，也就藉著他以神為樂。',
    '羅5:12 這就如罪是從一人入了世界，死又是從罪來的；於是死就臨到眾人，因為眾人都犯了罪。',
    '羅5:13 沒有律法之先，罪已經在世上；但沒有律法，罪也不算罪。',
    '羅5:14 然而從亞當到摩西，死就作了王，連那些不與亞當犯一樣罪過的，也在他的權下。亞當乃是那以後要來之人的預像。',
    '羅5:15 只是過犯不如恩賜，若因一人的過犯，眾人都死了，何況神的恩典，與那因耶穌基督一人恩典中的賞賜，豈不更加倍的臨到眾人嗎﹖',
    '羅5:16 因一人犯罪就定罪，也不如恩賜，原來審判是由一人而定罪，恩賜乃是由許多過犯而稱義。',
    '羅5:17 若因一人的過犯，死就因這一人作了王，何況那些受洪恩又蒙所賜之義的，豈不更要因耶穌基督一人在生命中作王嗎﹖',
    '羅5:18 如此說來，因一次的過犯，眾人都被定罪；照樣，因一次的義行，眾人也就被稱義得生命了。',
    '羅5:19 因一人的悖逆，眾人成為罪人；照樣，因一人的順從，眾人也成為義了。',
    '羅5:20 律法本是外添的，叫過犯顯多；只是罪在哪裡顯多，恩典就更顯多了。',
    '羅5:21 就如罪作王叫人死；照樣，恩典也藉著義作王，叫人因我們的主耶穌基督得永生。',
    '羅6:1 這樣，怎麼說呢﹖我們可以仍在罪中、叫恩典顯多嗎﹖',
    '羅6:2 斷乎不可！我們在罪上死了的人豈可仍在罪中活著呢﹖',
    '羅6:3 豈不知我們這受洗歸入基督耶穌的人是受洗歸入他的死嗎﹖',
    '羅6:4 所以，我們藉著洗禮歸入死，和他一同埋葬，原是叫我們一舉一動有新生的樣式，像基督藉著父的榮耀從死裡復活一樣。',
    '羅6:5 我們若在他死的形狀上與他聯合，也要在他復活的形狀上與他聯合；',
    '羅6:6 因為知道我們的舊人和他同釘十字架，使罪身滅絕，叫我們不再作罪的奴僕；',
    '羅6:7 因為已死的人是脫離了罪。',
    '羅6:8 我們若是與基督同死，就信必與他同活。',
    '羅6:9 因為知道基督既從死裡復活，就不再死，死也不再作他的主了。',
    '羅6:10 他死是向罪死了，只有一次；他活是向神活著。',
    '羅6:11 這樣，你們向罪也當看自己是死的；向神在基督耶穌裡，卻當看自己是活的。',
    '羅6:12 所以，不要容罪在你們必死的身上作王，使你們順從身子的私慾。',
    '羅6:13 也不要將你們的肢體獻給罪作不義的器具；倒要像從死裡復活的人，將自己獻給神，並將肢體作義的器具獻給神。',
    '羅6:14 罪必不能作你們的主，因你們不在律法之下，乃在恩典之下。',
    '羅6:15 這卻怎麼樣呢﹖我們在恩典之下，不在律法之下，就可以犯罪嗎﹖斷乎不可！',
    '羅6:16 豈不曉得你們獻上自己作奴僕，順從誰，就作誰的奴僕嗎﹖或作罪的奴僕，以至於死；或作順命的奴僕，以至成義。',
    '羅6:17 感謝神！因為你們從前雖然作罪的奴僕，現今卻從心裡順服了所傳給你們道理的模範。',
    '羅6:18 你們既從罪裡得了釋放，就作了義的奴僕。',
    '羅6:19 我因你們肉體的軟弱，就照人的常話對你們說。你們從前怎樣將肢體獻給不潔不法作奴僕，以至於不法；現今也要照樣將肢體獻給義作奴僕，以至於成聖。',
    '羅6:20 因為你們作罪之奴僕的時候，就不被義約束了。',
    '羅6:21 你們現今所看為羞恥的事，當日有什麼果子呢﹖那些事的結局就是死。',
    '羅6:22 但現今，你們既從罪裡得了釋放，作了神的奴僕，就有成聖的果子，那結局就是永生。',
    '羅6:23 因為罪的工價乃是死；惟有神的恩賜，在我們的主基督耶穌裡，乃是永生。',
    '羅7:1 弟兄們，我現在對明白律法的人說，你們豈不曉得律法管人是在活著的時候嗎﹖',
    '羅7:2 就如女人有了丈夫，丈夫還活著，就被律法約束；丈夫若死了，就脫離了丈夫的律法。',
    '羅7:3 所以丈夫活著，他若歸於別人，便叫淫婦；丈夫若死了，他就脫離了丈夫的律法，雖然歸於別人，也不是淫婦。',
    '羅7:4 我的弟兄們，這樣說來，你們藉著基督的身體，在律法上也是死了，叫你們歸於別人，就是歸於那從死裡復活的，叫我們結果子給神。',
    '羅7:5 因為我們屬肉體的時候，那因律法而生的惡慾就在我們肢體中發動，以致結成死亡的果子。',
    '羅7:6 但我們既然在捆我們的律法上死了，現今就脫離了律法，叫我們服事主，要按著心靈（心靈：或作聖靈）的新樣，不按著儀文的舊樣。',
    '羅7:7 這樣，我們可說什麼呢﹖律法是罪嗎﹖斷乎不是！只是非因律法，我就不知何為罪。非律法說不可起貪心，我就不知何為貪心。',
    '羅7:8 然而罪趁著機會，就藉著誡命叫諸般的貪心在我裡頭發動；因為沒有律法，罪是死的。',
    '羅7:9 我以前沒有律法是活著的；但是誡命來到，罪又活了，我就死了。',
    '羅7:10 那本來叫人活的誡命，反倒叫我死；',
    '羅7:11 因為罪趁著機會，就藉著誡命引誘我，並且殺了我。',
    '羅7:12 這樣看來，律法是聖潔的，誡命也是聖潔、公義、良善的。',
    '羅7:13 既然如此，那良善的是叫我死嗎﹖斷乎不是！叫我死的乃是罪。但罪藉著那良善的叫我死，就顯出真是罪，叫罪因著誡命更顯出是惡極了。',
    '羅7:14 我們原曉得律法是屬乎靈的，但我是屬乎肉體的，是已經賣給罪了。',
    '羅7:15 因為我所做的，我自己不明白；我所願意的，我並不做；我所恨惡的，我倒去做。',
    '羅7:16 若我所做的，是我所不願意的，我就應承律法是善的。',
    '羅7:17 既是這樣，就不是我做的，乃是住在我裡頭的罪做的。',
    '羅7:18 我也知道在我裡頭，就是我肉體之中，沒有良善。因為，立志為善由得我，只是行出來由不得我。',
    '羅7:19 故此，我所願意的善，我反不做；我所不願意的惡，我倒去做。',
    '羅7:20 若我去做所不願意做的，就不是我做的，乃是住在我裡頭的罪做的。',
    '羅7:21 我覺得有個律，就是我願意為善的時候，便有惡與我同在。',
    '羅7:22 因為按著我裡面的意思（原文是人），我是喜歡神的律；',
    '羅7:23 但我覺得肢體中另有個律和我心中的律交戰，把我擄去，叫我附從那肢體中犯罪的律。',
    '羅7:24 我真是苦啊！誰能救我脫離這取死的身體呢﹖',
    '羅7:25 感謝神，靠著我們的主耶穌基督就能脫離了。這樣看來，我以內心順服神的律，我肉體卻順服罪的律了。',
    '羅8:1 如今，那些在基督耶穌裡的就不定罪了。',
    '羅8:2 因為賜生命聖靈的律，在基督耶穌裡釋放了我，使我脫離罪和死的律了。',
    '羅8:3 律法既因肉體軟弱，有所不能行的，神就差遣自己的兒子，成為罪身的形狀，作了贖罪祭，在肉體中定了罪案，',
    '羅8:4 使律法的義成就在我們這不隨從肉體、只隨從聖靈的人身上。',
    '羅8:5 因為隨從肉體的人體貼肉體的事，隨從聖靈的人體貼聖靈的事。',
    '羅8:6 體貼肉體的，就是死；體貼聖靈的，乃是生命、平安。',
    '羅8:7 原來體貼肉體的，就是與神為仇；因為不服神的律法，也是不能服，',
    '羅8:8 而且屬肉體的人不能得神的喜歡。',
    '羅8:9 如果神的靈住在你們心裡，你們就不屬肉體，乃屬聖靈了。人若沒有基督的靈，就不是屬基督的。',
    '羅8:10 基督若在你們心裡，身體就因罪而死，心靈卻因義而活。',
    '羅8:11 然而，叫耶穌從死裡復活者的靈若住在你們心裡，那叫基督耶穌從死裡復活的，也必藉著住在你們心裡的聖靈，使你們必死的身體又活過來。',
    '羅8:12 弟兄們，這樣看來，我們並不是欠肉體的債去順從肉體活著。',
    '羅8:13 你們若順從肉體活著，必要死；若靠著聖靈治死身體的惡行，必要活著。',
    '羅8:14 因為凡被神的靈引導的，都是神的兒子。',
    '羅8:15 你們所受的，不是奴僕的心，仍舊害怕；所受的，乃是兒子的心，因此我們呼叫：阿爸！父！',
    '羅8:16 聖靈與我們的心同證我們是神的兒女；',
    '羅8:17 既是兒女，便是後嗣，就是神的後嗣，和基督同作後嗣。如果我們和他一同受苦，也必和他一同得榮耀。',
    '羅8:18 我想，現在的苦楚若比起將來要顯於我們的榮耀就不足介意了。',
    '羅8:19 受造之物切望等候神的眾子顯出來。',
    '羅8:20 因為受造之物服在虛空之下，不是自己願意，乃是因那叫他如此的。',
    '羅8:21 但受造之物仍然指望脫離敗壞的轄制，得享（享：原文是入）神兒女自由的榮耀。',
    '羅8:22 我們知道一切受造之物一同歎息、勞苦，直到如今。',
    '羅8:23 不但如此，就是我們這有聖靈初結果子的，也是自己心裡歎息，等候得著兒子的名分，乃是我們的身體得贖。',
    '羅8:24 我們得救是在乎盼望；只是所見的盼望不是盼望，誰還盼望他所見的呢（有古卷作：人所看見的何必再盼望呢）﹖',
    '羅8:25 但我們若盼望那所不見的，就必忍耐等候。',
    '羅8:26 況且我們的軟弱有聖靈幫助，我們本不曉得當怎樣禱告，只是聖靈親自用說不出來的歎息替我們禱告。',
    '羅8:27 鑒察人心的，曉得聖靈的意思，因為聖靈照著神的旨意替聖徒祈求。',
    '羅8:28 我們曉得萬事都互相效力，叫愛神的人得益處，就是按他旨意被召的人。',
    '羅8:29 因為他預先所知道的人，就預先定下效法他兒子的模樣，使他兒子在許多弟兄中作長子。',
    '羅8:30 預先所定下的人又召他們來；所召來的人又稱他們為義；所稱為義的人又叫他們得榮耀。',
    '羅8:31 既是這樣，還有什麼說的呢﹖神若幫助我們，誰能敵擋我們呢﹖',
    '羅8:32 神既不愛惜自己的兒子，為我們眾人捨了，豈不也把萬物和他一同白白的賜給我們嗎﹖',
    '羅8:33 誰能控告神所揀選的人呢﹖有神稱他們為義了（或作：是稱他們為義的神嗎）',
    '羅8:34 誰能定他們的罪呢﹖有基督耶穌已經死了，而且從死裡復活，現今在神的右邊，也替我們祈求（有基督....或作是已經死了，而且從死裡復活，現今在神的右邊，也替我們祈求的基督耶穌嗎）',
    '羅8:35 誰能使我們與基督的愛隔絕呢﹖難道是患難嗎﹖是困苦嗎﹖是逼迫嗎﹖是飢餓嗎﹖是赤身露體嗎﹖是危險嗎﹖是刀劍嗎﹖',
    '羅8:36 如經上所記：我們為你的緣故終日被殺；人看我們如將宰的羊。',
    '羅8:37 然而，靠著愛我們的主，在這一切的事上已經得勝有餘了。',
    '羅8:38 因為我深信無論是死，是生，是天使，是掌權的，是有能的，是現在的事，是將來的事，',
    '羅8:39 是高處的，是低處的，是別的受造之物，都不能叫我們與神的愛隔絕；這愛是在我們的主基督耶穌裡的。',
    '羅9:1 我在基督裡說真話，並不謊言，有我良心被聖靈感動，給我作見證；',
    '羅9:2 我是大有憂愁，心裡時常傷痛；',
    '羅9:3 為我弟兄，我骨肉之親，就是自己被咒詛，與基督分離，我也願意。',
    '羅9:4 他們是以色列人；那兒子的名分、榮耀、諸約、律法、禮儀、應許都是他們的。',
    '羅9:5 列祖就是他們的祖宗，按肉體說，基督也是從他們出來的，他是在萬有之上，永遠可稱頌的神。阿們！',
    '羅9:6 這不是說神的話落了空。因為從以色列生的不都是以色列人，',
    '羅9:7 也不因為是亞伯拉罕的後裔就都作他的兒女；惟獨從以撒生的才要稱為你的後裔。',
    '羅9:8 這就是說，肉身所生的兒女不是神的兒女，惟獨那應許的兒女才算是後裔。',
    '羅9:9 因為所應許的話是這樣說：到明年這時候我要來，撒拉必生一個兒子。',
    '羅9:10 不但如此，還有利百加，既從一個人，就是從我們的祖宗以撒懷了孕，',
    '羅9:11 （雙子還沒有生下來，善惡還沒有做出來，只因要顯明神揀選人的旨意，不在乎人的行為，乃在乎召人的主。）',
    '羅9:12 神就對利百加說：將來大的要服事小的。',
    '羅9:13 正如經上所記：雅各是我所愛的；以掃是我所惡的。',
    '羅9:14 這樣，我們可說什麼呢﹖難道神有什麼不公平嗎﹖斷乎沒有！',
    '羅9:15 因他對摩西說：我要憐憫誰就憐憫誰，要恩待誰就恩待誰。',
    '羅9:16 據此看來，這不在乎那定意的，也不在乎那奔跑的，只在乎發憐憫的神。',
    '羅9:17 因為經上有話向法老說：我將你興起來，特要在你身上彰顯我的權能，並要使我的名傳遍天下。',
    '羅9:18 如此看來，神要憐憫誰就憐憫誰，要叫誰剛硬就叫誰剛硬。',
    '羅9:19 這樣，你必對我說：他為什麼還指責人呢﹖有誰抗拒他的旨意呢﹖',
    '羅9:20 你這個人哪，你是誰，竟敢向神強嘴呢﹖受造之物豈能對造他的說：你為什麼這樣造我呢﹖',
    '羅9:21 窰匠難道沒有權柄從一團泥裡拿一塊做成貴重的器皿，又拿一塊做成卑賤的器皿嗎﹖',
    '羅9:22 倘若神要顯明他的忿怒，彰顯他的權能，就多多忍耐寬容那可怒預備遭毀滅的器皿，',
    '羅9:23 又要將他豐盛的榮耀彰顯在那蒙憐憫早預備得榮耀的器皿上。',
    '羅9:24 這器皿就是我們被神所召的，不但是從猶太人中，也是從外邦人中。這有什麼不可呢﹖',
    '羅9:25 就像神在何西阿書上說：那本來不是我子民的，我要稱為我的子民；本來不是蒙愛的，我要稱為蒙愛的。',
    '羅9:26 從前在什麼地方對他們說：你們不是我的子民，將來就在那裡稱他們為永生神的兒子。',
    '羅9:27 以賽亞指著以色列人喊著說：以色列人雖多如海沙，得救的不過是剩下的餘數；',
    '羅9:28 因為主要在世上施行他的話，叫他的話都成全，速速的完結。',
    '羅9:29 又如以賽亞先前說過：若不是萬軍之主給我們存留餘種，我們早已像所多瑪，蛾摩拉的樣子了。',
    '羅9:30 這樣，我們可說什麼呢﹖那本來不追求義的外邦人反得了義，就是因信而得的義。',
    '羅9:31 但以色列人追求律法的義，反得不著律法的義。',
    '羅9:32 這是什麼緣故呢﹖是因為他們不憑著信心求，只憑著行為求，他們正跌在那絆腳石上。',
    '羅9:33 就如經上所記：我在錫安放一塊絆腳的石頭，跌人的磐石；信靠他的人必不至於羞愧。',
    '羅10:1 弟兄們，我心裡所願的，向神所求的，是要以色列人得救。',
    '羅10:2 我可以證明他們向神有熱心，但不是按著真知識；',
    '羅10:3 因為不知道神的義，想要立自己的義，就不服神的義了。',
    '羅10:4 律法的總結就是基督，使凡信他的都得著義。',
    '羅10:5 摩西寫著說：人若行那出於律法的義，就必因此活著。',
    '羅10:6 惟有出於信心的義如此說：你不要心裡說：誰要升到天上去呢﹖就是要領下基督來；',
    '羅10:7 誰要下到陰間去呢﹖就是要領基督從死裡上來。',
    '羅10:8 他到底怎麼說呢﹖他說：這道離你不遠，正在你口裡，在你心裡。（就是我們所傳信主的道。）',
    '羅10:9 你若口裡認耶穌為主，心裡信神叫他從死裡復活，就必得救。',
    '羅10:10 因為人心裡相信，就可以稱義；口裡承認，就可以得救。',
    '羅10:11 經上說：凡信他的人必不至於羞愧。',
    '羅10:12 猶太人和希利尼人並沒有分別，因為眾人同有一位主；他也厚待一切求告他的人。',
    '羅10:13 因為凡求告主名的，就必得救。',
    '羅10:14 然而，人未曾信他，怎能求他呢﹖未曾聽見他，怎能信他呢﹖沒有傳道的，怎能聽見呢﹖',
    '羅10:15 若沒有奉差遣，怎能傳道呢﹖如經上所記：報福音、傳喜信的人，他們的腳蹤何等佳美。',
    '羅10:16 只是人沒有都聽從福音，因為以賽亞說：主啊，我們所傳的有誰信呢﹖',
    '羅10:17 可見信道是從聽道來的，聽道是從基督的話來的。',
    '羅10:18 但我說，人沒有聽見嗎﹖誠然聽見了。他們的聲音傳遍天下；他們的言語傳到地極。',
    '羅10:19 我再說，以色列人不知道嗎﹖先有摩西說：我要用那不成子民的，惹動你們的憤恨；我要用那無知的民觸動你們的怒氣。',
    '羅10:20 又有以賽亞放膽說：沒有尋找我的，我叫他們遇見；沒有訪問我的，我向他們顯現。',
    '羅10:21 至於以色列人，他說：我整天伸手招呼那悖逆頂嘴的百姓。',
    '羅11:1 我且說，神棄絕了他的百姓嗎﹖斷乎沒有！因為我也是以色列人，亞伯拉罕的後裔，屬便雅憫支派的。',
    '羅11:2 神並沒有棄絕他預先所知道的百姓。你們豈不曉得經上論到以利亞是怎麼說的呢﹖他在神面前怎樣控告以色列人說：',
    '羅11:3 主啊，他們殺了你的先知，拆了你的祭壇，只剩下我一個人，他們還要尋索我的命。',
    '羅11:4 神的回話是怎麼說的呢﹖他說：我為自己留下七千人，是未曾向巴力屈膝的。',
    '羅11:5 如今也是這樣，照著揀選的恩典，還有所留的餘數。',
    '羅11:6 既是出於恩典，就不在乎行為；不然，恩典就不是恩典了。',
    '羅11:7 這是怎麼樣呢﹖以色列人所求的，他們沒有得著，惟有蒙揀選的人得著了；其餘的就成了頑梗不化的。',
    '羅11:8 如經上所記：神給他們昏迷的心，眼睛不能看見，耳朵不能聽見，直到今日。',
    '羅11:9 大衛也說：願他們的筵席變為網羅，變為機檻，變為絆腳石，作他們的報應。',
    '羅11:10 願他們的眼睛昏矇，不得看見；願你時常彎下他們的腰。',
    '羅11:11 我且說，他們失腳是要他們跌倒嗎﹖斷乎不是！反倒因他們的過失，救恩便臨到外邦人，要激動他們發憤。',
    '羅11:12 若他們的過失，為天下的富足，他們的缺乏，為外邦人的富足；何況他們的豐滿呢﹖',
    '羅11:13 我對你們外邦人說這話；因我是外邦人的使徒，所以敬重（原文作：榮耀）我的職分，',
    '羅11:14 或者可以激動我骨肉之親發憤，好救他們一些人。',
    '羅11:15 若他們被丟棄，天下就得與神和好；他們被收納，豈不是死而復生嗎﹖',
    '羅11:16 所獻的新麵若是聖潔，全團也就聖潔了；樹根若是聖潔，樹枝也就聖潔了。',
    '羅11:17 若有幾根枝子被折下來，你這野橄欖得接在其中，一同得著橄欖根的肥汁，',
    '羅11:18 你就不可向舊枝子誇口；若是誇口，當知道不是你托著根，乃是根托著你。',
    '羅11:19 你若說，那枝子被折下來是特為叫我接上。',
    '羅11:20 不錯！他們因為不信，所以被折下來；你因為信，所以立得住；你不可自高，反要懼怕。',
    '羅11:21 神既不愛惜原來的枝子，也必不愛惜你。',
    '羅11:22 可見神的恩慈和嚴厲，向那跌倒的人是嚴厲的，向你是有恩慈的；只要你長久在他的恩慈裡，不然，你也要被砍下來。',
    '羅11:23 而且他們若不是長久不信，仍要被接上，因為神能夠把他們從新接上。',
    '羅11:24 你是從那天生的野橄欖上砍下來的，尚且逆著性得接在好橄欖上，何況這本樹的枝子，要接在本樹上呢！',
    '羅11:25 弟兄們，我不願意你們不知道這奧祕（恐怕你們自以為聰明），就是以色列人有幾分是硬心的，等到外邦人的數目添滿了，',
    '羅11:26 於是以色列全家都要得救。如經上所記：必有一位救主從錫安出來，要消除雅各家的一切罪惡；',
    '羅11:27 又說：我除去他們罪的時候，這就是我與他們所立的約。',
    '羅11:28 就著福音說，他們為你們的緣故是仇敵；就著揀選說，他們為列祖的緣故是蒙愛的。',
    '羅11:29 因為神的恩賜和選召是沒有後悔的。',
    '羅11:30 你們從前不順服神，如今因他們的不順服，你們倒蒙了憐恤。',
    '羅11:31 這樣，他們也是不順服，叫他們因著施給你們的憐恤，現在也就蒙憐恤。',
    '羅11:32 因為神將眾人都圈在不順服之中，特意要憐恤眾人。',
    '羅11:33 深哉，神豐富的智慧和知識！他的判斷何其難測！他的蹤跡何其難尋！',
    '羅11:34 誰知道主的心﹖誰作過他的謀士呢﹖',
    '羅11:35 誰是先給了他，使他後來償還呢﹖',
    '羅11:36 因為萬有都是本於他，倚靠他，歸於他。願榮耀歸給他，直到永遠。阿們！',
    '羅12:1 所以弟兄們，我以神的慈悲勸你們，將身體獻上，當作活祭，是聖潔的，是神所喜悅的；你們如此事奉乃是理所當然的。',
    '羅12:2 不要效法這個世界，只要心意更新而變化，叫你們察驗何為神的善良、純全、可喜悅的旨意。',
    '羅12:3 我憑著所賜我的恩對你們各人說：不要看自己過於所當看的，要照著神所分給各人信心的大小，看得合乎中道。',
    '羅12:4 正如我們一個身子上有好些肢體，肢體也不都是一樣的用處。',
    '羅12:5 我們這許多人，在基督裡成為一身，互相聯絡作肢體，也是如此。',
    '羅12:6 按我們所得的恩賜，各有不同。或說預言，就當照著信心的程度說預言，',
    '羅12:7 或作執事，就當專一執事；或作教導的，就當專一教導；',
    '羅12:8 或作勸化的，就當專一勸化；施捨的，就當誠實；治理的，就當殷勤；憐憫人的，就當甘心。',
    '羅12:9 愛人不可虛假；惡要厭惡，善要親近。',
    '羅12:10 愛弟兄，要彼此親熱；恭敬人，要彼此推讓。',
    '羅12:11 殷勤不可懶惰。要心裡火熱，常常服事主。',
    '羅12:12 在指望中要喜樂，在患難中要忍耐，禱告要恆切。',
    '羅12:13 聖徒缺乏要幫補；客要一味的款待。',
    '羅12:14 逼迫你們的，要給他們祝福；只要祝福，不可咒詛。',
    '羅12:15 與喜樂的人要同樂；與哀哭的人要同哭。',
    '羅12:16 要彼此同心；不要志氣高大，倒要俯就卑微的人（人：或作事）；不要自以為聰明。',
    '羅12:17 不要以惡報惡；眾人以為美的事要留心去做。',
    '羅12:18 若是能行，總要盡力與眾人和睦。',
    '羅12:19 親愛的弟兄，不要自己伸冤，寧可讓步，聽憑主怒（或作：讓人發怒）；因為經上記著：主說：伸冤在我；我必報應。',
    '羅12:20 所以，你的仇敵若餓了，就給他吃，若渴了，就給他喝；因為你這樣行就是把炭火堆在他的頭上。',
    '羅12:21 你不可為惡所勝，反要以善勝惡。',
    '羅13:1 在上有權柄的，人人當順服他，因為沒有權柄不是出於神的。凡掌權的都是神所命的。',
    '羅13:2 所以，抗拒掌權的就是抗拒神的命；抗拒的必自取刑罰。',
    '羅13:3 作官的原不是叫行善的懼怕，乃是叫作惡的懼怕。你願意不懼怕掌權的嗎﹖你只要行善，就可得他的稱讚；',
    '羅13:4 因為他是神的用人，是於你有益的。你若作惡，卻當懼怕；因為他不是空空的佩劍，他是神的用人，是伸冤的，刑罰那作惡的。',
    '羅13:5 所以你們必須順服，不但是因為刑罰，也是因為良心。',
    '羅13:6 你們納糧，也為這個緣故；因他們是神的差役，常常特管這事。',
    '羅13:7 凡人所當得的，就給他。當得糧的，給他納糧；當得稅的，給他上稅；當懼怕的，懼怕他；當恭敬的，恭敬他。',
    '羅13:8 凡事都不可虧欠人，惟有彼此相愛要常以為虧欠；因為愛人的，就完全了律法。',
    '羅13:9 像那不可姦淫，不可殺人，不可偷盜，不可貪婪，或有別的誡命，都包在愛人如己這一句話之內了。',
    '羅13:10 愛是不加害與人的，所以愛就完全了律法。',
    '羅13:11 再者，你們曉得現今就是該趁早睡醒的時候；因為我們得救，現今比初信的時候更近了。',
    '羅13:12 黑夜已深，白晝將近；我們就當脫去暗昧的行為，帶上光明的兵器。',
    '羅13:13 行事為人要端正，好像行在白晝。不可荒宴醉酒，不可好色邪蕩，不可爭競嫉妒；',
    '羅13:14 總要披戴主耶穌基督，不要為肉體安排，去放縱私慾。',
    '羅14:1 信心軟弱的，你們要接納，但不要辯論所疑惑的事。',
    '羅14:2 有人信百物都可吃；但那軟弱的，只吃蔬菜。',
    '羅14:3 吃的人不可輕看不吃的人；不吃的人不可論斷吃的人；因為神已經收納他了。',
    '羅14:4 你是誰，竟論斷別人的僕人呢﹖他或站住，或跌倒，自有他的主人在；而且他也必要站住，因為主能使他站住。',
    '羅14:5 有人看這日比那日強；有人看日日都是一樣。只是各人心裡要意見堅定。',
    '羅14:6 守日的人是為主守的；吃的人是為主吃的，因他感謝神；不吃的人是為主不吃的，也感謝神。',
    '羅14:7 我們沒有一個人為自己活，也沒有一個人為自己死。',
    '羅14:8 我們若活著，是為主而活；若死了，是為主而死。所以，我們或活或死總是主的人。',
    '羅14:9 因此基督死了又活了，為要作死人並活人的主。',
    '羅14:10 你這個人，為什麼論斷弟兄呢﹖又為什麼輕看弟兄呢﹖因我們都要站在神的臺前。',
    '羅14:11 經上寫著：主說：我憑著我的永生起誓：萬膝必向我跪拜；萬口必向我承認。',
    '羅14:12 這樣看來，我們各人必要將自己的事在神面前說明。',
    '羅14:13 所以，我們不可再彼此論斷，寧可定意誰也不給弟兄放下絆腳跌人之物。',
    '羅14:14 我憑著主耶穌確知深信，凡物本來沒有不潔淨的；惟獨人以為不潔淨的，在他就不潔淨了。',
    '羅14:15 你若因食物叫弟兄憂愁，就不是按著愛人的道理行。基督已經替他死，你不可因你的食物叫他敗壞。',
    '羅14:16 不可叫你的善被人毀謗；',
    '羅14:17 因為神的國不在乎吃喝，只在乎公義、和平，並聖靈中的喜樂。',
    '羅14:18 在這幾樣上服事基督的，就為神所喜悅，又為人所稱許。',
    '羅14:19 所以，我們務要追求和睦的事與彼此建立德行的事。',
    '羅14:20 不可因食物毀壞神的工程。凡物固然潔淨，但有人因食物叫人跌倒，就是他的罪了。',
    '羅14:21 無論是吃肉，是喝酒，是什麼別的事，叫弟兄跌倒，一概不做才好。',
    '羅14:22 你有信心，就當在神面前守著。人在自己以為可行的事上能不自責，就有福了。',
    '羅14:23 若有疑心而吃的，就必有罪，因為他吃不是出於信心。凡不出於信心的都是罪。',
    '羅15:1 我們堅固的人應該擔代不堅固人的軟弱，不求自己的喜悅。',
    '羅15:2 我們各人務要叫鄰舍喜悅，使他得益處，建立德行。',
    '羅15:3 因為基督也不求自己的喜悅，如經上所記：辱罵你人的辱罵都落在我身上。',
    '羅15:4 從前所寫的聖經都是為教訓我們寫的，叫我們因聖經所生的忍耐和安慰可以得著盼望。',
    '羅15:5 但願賜忍耐安慰的神叫你們彼此同心，效法基督耶穌，',
    '羅15:6 一心一口榮耀神─我們主耶穌基督的父！',
    '羅15:7 所以，你們要彼此接納，如同基督接納你們一樣，使榮耀歸與神。',
    '羅15:8 我說，基督是為神真理作了受割禮人的執事，要證實所應許列祖的話，',
    '羅15:9 並叫外邦人因他的憐憫榮耀神。如經上所記：因此，我要在外邦中稱讚你，歌頌你的名；',
    '羅15:10 又說：你們外邦人當與主的百姓一同歡樂；',
    '羅15:11 又說：外邦啊，你們當讚美主！萬民哪，你們都當頌讚他！',
    '羅15:12 又有以賽亞說：將來有耶西的根，就是那興起來要治理外邦的；外邦人要仰望他。',
    '羅15:13 但願使人有盼望的神，因信將諸般的喜樂、平安充滿你們的心，使你們藉著聖靈的能力大有盼望。',
    '羅15:14 弟兄們，我自己也深信你們是滿有良善，充足了諸般的知識，也能彼此勸戒。',
    '羅15:15 但我稍微放膽寫信給你們，是要提醒你們的記性，特因神所給我的恩典，',
    '羅15:16 使我為外邦人作基督耶穌的僕役，作神福音的祭司，叫所獻上的外邦人，因著聖靈成為聖潔，可蒙悅納。',
    '羅15:17 所以論到神的事，我在基督耶穌裡有可誇的。',
    '羅15:18 除了基督藉我做的那些事，我什麼都不敢提，只提他藉我言語作為，用神蹟奇事的能力，並聖靈的能力，使外邦人順服；',
    '羅15:19 甚至我從耶路撒冷，直轉到以利哩古，到處傳了基督的福音。',
    '羅15:20 我立了志向，不在基督的名被稱過的地方傳福音，免得建造在別人的根基上。',
    '羅15:21 就如經上所記：未曾聞知他信息的，將要看見；未曾聽過的，將要明白。',
    '羅15:22 我因多次被攔阻，總不得到你們那裡去。',
    '羅15:23 但如今，在這裡再沒有可傳的地方，而且這好幾年，我切心想望到士班雅去的時候，可以到你們那裡，',
    '羅15:24 盼望從你們那裡經過，得見你們，先與你們彼此交往，心裡稍微滿足，然後蒙你們送行。',
    '羅15:25 但現在，我往耶路撒冷去供給聖徒。',
    '羅15:26 因為馬其頓和亞該亞人樂意湊出捐項給耶路撒冷聖徒中的窮人。',
    '羅15:27 這固然是他們樂意的，其實也算是所欠的債；因外邦人既然在他們屬靈的好處上有分，就當把養身之物供給他們。',
    '羅15:28 等我辦完了這事，把這善果向他們交付明白，我就要路過你們那裡，往士班雅去。',
    '羅15:29 我也曉得去的時候，必帶著基督豐盛的恩典而去。',
    '羅15:30 弟兄們，我藉著我們主耶穌基督，又藉著聖靈的愛，勸你們與我一同竭力，為我祈求神，',
    '羅15:31 叫我脫離在猶太不順從的人，也叫我為耶路撒冷所辦的捐項可蒙聖徒悅納，',
    '羅15:32 並叫我順著神的旨意，歡歡喜喜的到你們那裡，與你們同得安息。',
    '羅15:33 願賜平安的神常和你們眾人同在。阿們！',
    '羅16:1 我對你們舉薦我們的姊妹非比，他是堅革哩教會中的女執事。',
    '羅16:2 請你們為主接待他，合乎聖徒的體統。他在何事上要你們幫助，你們就幫助他，因他素來幫助許多人，也幫助了我。',
    '羅16:3 問百基拉和亞居拉安。他們在基督耶穌裡與我同工，',
    '羅16:4 也為我的命將自己的頸項置之度外。不但我感謝他們，就是外邦的眾教會也感謝他們。',
    '羅16:5 又問在他們家中的教會安。問我所親愛的以拜尼土安；他在亞西亞是歸基督初結的果子。',
    '羅16:6 又問馬利亞安；他為你們多受勞苦。',
    '羅16:7 又問我親屬與我一同坐監的安多尼古和猶尼亞安；他們在使徒中是有名望的，也是比我先在基督裡。',
    '羅16:8 又問我在主裡面所親愛的暗伯利安。',
    '羅16:9 又問在基督裡與我們同工的耳巴奴，並我所親愛的士大古安。',
    '羅16:10 又問在基督裡經過試驗的亞比利安。問亞利多布家裡的人安。',
    '羅16:11 又問我親屬希羅天安。問拿其數家在主裡的人安。',
    '羅16:12 又問為主勞苦的土非拿氏和土富撒氏安。問可親愛為主多受勞苦的彼息氏安。',
    '羅16:13 又問在主蒙揀選的魯孚和他母親安；他的母親就是我的母親。',
    '羅16:14 又問亞遜其土、弗勒干、黑米、八羅巴、黑馬，並與他們在一處的弟兄們安。',
    '羅16:15 又問非羅羅古和猶利亞，尼利亞和他姊妹，同阿林巴並與他們在一處的眾聖徒安。',
    '羅16:16 你們親嘴問安，彼此務要聖潔。基督的眾教會都問你們安。',
    '羅16:17 弟兄們，那些離間你們、叫你們跌倒、背乎所學之道的人，我勸你們要留意躲避他們。',
    '羅16:18 因為這樣的人不服事我們的主基督，只服事自己的肚腹，用花言巧語誘惑那些老實人的心。',
    '羅16:19 你們的順服已經傳於眾人，所以我為你們歡喜；但我願意你們在善上聰明，在惡上愚拙。',
    '羅16:20 賜平安的神快要將撒但踐踏在你們腳下。願我主耶穌基督的恩常和你們同在！',
    '羅16:21 與我同工的提摩太，和我的親屬路求、耶孫、所西巴德，問你們安。',
    '羅16:22 我這代筆寫信的德丟，在主裡面問你們安。',
    '羅16:23 那接待我、也接待全教會的該猶問你們安。',
    '羅16:24 城內管銀庫的以拉都，和兄弟括土問你們安。',
    '羅16:25 惟有神能照我所傳的福音和所講的耶穌基督，並照永古隱藏不言的奧祕，堅固你們的心。',
    '羅16:26 這奧祕如今顯明出來，而且按著永生神的命，藉眾先知的書指示萬國的民，使他們信服真道。',
    '羅16:27 願榮耀因耶穌基督歸與獨一全智的神，直到永遠。阿們！',
    '林前1:1 奉神旨意，蒙召作耶穌基督使徒的保羅，同兄弟所提尼，',
    '林前1:2 寫信給在哥林多神的教會，就是在基督耶穌裡成聖、蒙召作聖徒的，以及所有在各處求告我主耶穌基督之名的人。基督是他們的主，也是我們的主。',
    '林前1:3 願恩惠、平安從神我們的父並主耶穌基督歸與你們。',
    '林前1:4 我常為你們感謝我的神，因神在基督耶穌裡所賜給你們的恩惠；',
    '林前1:5 又因你們在他裡面凡事富足，口才、知識都全備，',
    '林前1:6 正如我為基督作的見證，在你們心裡得以堅固，',
    '林前1:7 以致你們在恩賜上沒有一樣不及人的，等候我們的主耶穌基督顯現。',
    '林前1:8 他也必堅固你們到底，叫你們在我們主耶穌基督的日子無可責備。',
    '林前1:9 神是信實的，你們原是被他所召，好與他兒子─我們的主耶穌基督一同得分。',
    '林前1:10 弟兄們，我藉我們主耶穌基督的名勸你們都說一樣的話。你們中間也不可分黨，只要一心一意，彼此相合。',
    '林前1:11 因為革來氏家裡的人曾對我提起弟兄們來，說你們中間有紛爭。',
    '林前1:12 我的意思就是你們各人說：我是屬保羅的；我是屬亞波羅的；我是屬磯法的；我是屬基督的。',
    '林前1:13 基督是分開的嗎﹖保羅為你們釘了十字架嗎﹖你們是奉保羅的名受了洗嗎﹖',
    '林前1:14 我感謝神，除了基利司布並該猶以外，我沒有給你們一個人施洗；',
    '林前1:15 免得有人說，你們是奉我的名受洗。',
    '林前1:16 我也給司提反家施過洗，此外給別人施洗沒有，我卻記不清。',
    '林前1:17 基督差遣我，原不是為施洗，乃是為傳福音，並不用智慧的言語，免得基督的十字架落了空。',
    '林前1:18 因為十字架的道理，在那滅亡的人為愚拙；在我們得救的人，卻為神的大能。',
    '林前1:19 就如經上所記：我要滅絕智慧人的智慧，廢棄聰明人的聰明。',
    '林前1:20 智慧人在哪裡﹖文士在哪裡﹖這世上的辯士在哪裡﹖神豈不是叫這世上的智慧變成愚拙嗎﹖',
    '林前1:21 世人憑自己的智慧，既不認識神，神就樂意用人所當作愚拙的道理，拯救那些信的人；這就是神的智慧了。',
    '林前1:22 猶太人是要神蹟，希利尼人是求智慧，',
    '林前1:23 我們卻是傳釘十字架的基督，在猶太人為絆腳石，在外邦人為愚拙；',
    '林前1:24 但在那蒙召的，無論是猶太人、希利尼人，基督總為神的能力，神的智慧。',
    '林前1:25 因神的愚拙總比人智慧，神的軟弱總比人強壯。',
    '林前1:26 弟兄們哪，可見你們蒙召的，按著肉體有智慧的不多，有能力的不多，有尊貴的也不多。',
    '林前1:27 神卻揀選了世上愚拙的，叫有智慧的羞愧；又揀選了世上軟弱的，叫那強壯的羞愧。',
    '林前1:28 神也揀選了世上卑賤的，被人厭惡的，以及那無有的，為要廢掉那有的。',
    '林前1:29 使一切有血氣的，在神面前一個也不能自誇。',
    '林前1:30 但你們得在基督耶穌裡，是本乎神，神又使他成為我們的智慧、公義、聖潔、救贖。',
    '林前1:31 如經上所記：誇口的，當指著主誇口。',
    '林前2:1 弟兄們，從前我到你們那裡去，並沒有用高言大智對你們宣傳神的奧祕。',
    '林前2:2 因為我曾定了主意，在你們中間不知道別的，只知道耶穌基督並他釘十字架。',
    '林前2:3 我在你們那裡，又軟弱又懼怕，又甚戰兢。',
    '林前2:4 我說的話、講的道，不是用智慧委婉的言語，乃是用聖靈和大能的明證，',
    '林前2:5 叫你們的信不在乎人的智慧，只在乎神的大能。',
    '林前2:6 然而，在完全的人中，我們也講智慧。但不是這世上的智慧，也不是這世上有權有位、將要敗亡之人的智慧。',
    '林前2:7 我們講的，乃是從前所隱藏、神奧祕的智慧，就是神在萬世以前預定使我們得榮耀的。',
    '林前2:8 這智慧世上有權有位的人沒有一個知道的、他們若知道，就不把榮耀的主釘在十字架上了。',
    '林前2:9 如經上所記：神為愛他的人所預備的是眼睛未曾看見，耳朵未曾聽見，人心也未曾想到的。',
    '林前2:10 只有神藉著聖靈向我們顯明了，因為聖靈參透萬事，就是神深奧的事也參透了。',
    '林前2:11 除了在人裡頭的靈，誰知道人的事；像這樣，除了神的靈，也沒有人知道神的事。',
    '林前2:12 我們所領受的，並不是世上的靈，乃是從神來的靈，叫我們能知道神開恩賜給我們的事。',
    '林前2:13 並且我們講說這些事，不是用人智慧所指教的言語，乃是用聖靈所指教的言語，將屬靈的話解釋屬靈的事（或作：將屬靈的事講與屬靈的人）。',
    '林前2:14 然而，屬血氣的人不領會神聖靈的事，反倒以為愚拙，並且不能知道，因為這些事惟有屬靈的人才能看透。',
    '林前2:15 屬靈的人能看透萬事，卻沒有一人能看透了他。',
    '林前2:16 誰曾知道主的心去教導他呢﹖但我們是有基督的心了。',
    '林前3:1 弟兄們，我從前對你們說話，不能把你們當作屬靈的，只得把你們當作屬肉體，在基督裡為嬰孩的。',
    '林前3:2 我是用奶餵你們，沒有用飯餵你們。那時你們不能吃，就是如今還是不能。',
    '林前3:3 你們仍是屬肉體的，因為在你們中間有嫉妒、紛爭，這豈不是屬乎肉體、照著世人的樣子行嗎﹖',
    '林前3:4 有說：我是屬保羅的；有說：我是屬亞波羅的。這豈不是你們和世人一樣嗎﹖',
    '林前3:5 亞波羅算什麼﹖保羅算什麼﹖無非是執事，照主所賜給他們各人的，引導你們相信。',
    '林前3:6 我栽種了，亞波羅澆灌了，惟有神叫他生長。',
    '林前3:7 可見栽種的，算不得什麼，澆灌的，也算不得什麼；只在那叫他生長的神。',
    '林前3:8 栽種的和澆灌的，都是一樣，但將來各人要照自己的工夫得自己的賞賜。',
    '林前3:9 因為我們是與神同工的；你們是神所耕種的田地，所建造的房屋。',
    '林前3:10 我照神所給我的恩，好像一個聰明的工頭，立好了根基，有別人在上面建造；只是各人要謹慎怎樣在上面建造。',
    '林前3:11 因為那已經立好的根基就是耶穌基督，此外沒有人能立別的根基。',
    '林前3:12 若有人用金、銀、寶石、草木，禾稭在這根基上建造，',
    '林前3:13 各人的工程必然顯露，因為那日子要將他表明出來，有火發現；這火要試驗各人的工程怎樣。',
    '林前3:14 人在那根基上所建造的工程若存得住，他就要得賞賜。',
    '林前3:15 人的工程若被燒了，他就要受虧損，自己卻要得救；雖然得救，乃像從火裡經過的一樣。',
    '林前3:16 豈不知你們是神的殿，神的靈住在你們裡頭嗎﹖',
    '林前3:17 若有人毀壞神的殿，神必要毀壞那人；因為神的殿是聖的，這殿就是你們。',
    '林前3:18 人不可自欺。你們中間若有人在這世界自以為有智慧，倒不如變作愚拙，好成為有智慧的。',
    '林前3:19 因這世界的智慧，在神看是愚拙。如經上記著說：主叫有智慧的，中了自己的詭計；',
    '林前3:20 又說：主知道智慧人的意念是虛妄的。',
    '林前3:21 所以無論誰，都不可拿人誇口，因為萬有全是你們的。',
    '林前3:22 或保羅，或亞波羅，或磯法，或世界，或生，或死，或現今的事，或將來的事，全是你們的；',
    '林前3:23 並且你們是屬基督的，基督又是屬神的。',
    '林前4:1 人應當以我們為基督的執事，為神奧祕事的管家。',
    '林前4:2 所求於管家的，是要他有忠心。',
    '林前4:3 我被你們論斷，或被別人論斷，我都以為極小的事；連我自己也不論斷自己。',
    '林前4:4 我雖不覺得自己有錯，卻也不能因此得以稱義；但判斷我的乃是主。',
    '林前4:5 所以，時候未到，什麼都不要論斷，只等主來，他要照出暗中的隱情，顯明人心的意念。那時，各人要從神那裡得著稱讚。',
    '林前4:6 弟兄們，我為你們的緣故，拿這些事轉比自己和亞波羅，叫你們效法我們不可過於聖經所記，免得你們自高自大，貴重這個，輕看那個。',
    '林前4:7 使你與人不同的是誰呢﹖你有什麼不是領受的呢？若是領受的，為何自誇，彷彿不是領受的呢﹖',
    '林前4:8 你們已經飽足了！已經豐富了！不用我們，自己就作王了！我願意你們果真作王，叫我們也得與你們一同作王。',
    '林前4:9 我想神把我們使徒明明列在末後，好像定死罪的囚犯；因為我們成了一臺戲，給世人和天使觀看。',
    '林前4:10 我們為基督的緣故算是愚拙的，你們在基督裡倒是聰明的；我們軟弱，你們倒強壯；你們有榮耀，我們倒被藐視。',
    '林前4:11 直到如今，我們還是又飢又渴，又赤身露體，又挨打，又沒有一定的住處，',
    '林前4:12 並且勞苦，親手做工。被人咒罵，我們就祝福；被人逼迫，我們就忍受；',
    '林前4:13 被人毀謗，我們就善勸。直到如今，人還把我們看作世界上的污穢，萬物中的渣滓。',
    '林前4:14 我寫這話，不是叫你們羞愧，乃是警戒你們，好像我所親愛的兒女一樣。',
    '林前4:15 你們學基督的，師傅雖有一萬，為父的卻是不多，因我在基督耶穌裡用福音生了你們。',
    '林前4:16 所以，我求你們效法我。',
    '林前4:17 因此我已打發提摩太到你們那裡去。他在主裡面，是我所親愛，有忠心的兒子。他必提醒你們，記念我在基督裡怎樣行事，在各處各教會中怎樣教導人。',
    '林前4:18 有些人自高自大，以為我不到你們那裡去；',
    '林前4:19 然而，主若許我，我必快到你們那裡去，並且我所要知道的，不是那些自高自大之人的言語，乃是他們的權能。',
    '林前4:20 因為神的國不在乎言語，乃在乎權能。',
    '林前4:21 你們願意怎麼樣呢﹖是願意我帶著刑杖到你們那裡去呢﹖還是要我存慈愛溫柔的心呢﹖',
    '林前5:1 風聞在你們中間有淫亂的事。這樣的淫亂連外邦人中也沒有，就是有人收了他的繼母。',
    '林前5:2 你們還是自高自大，並不哀痛，把行這事的人從你們中間趕出去。',
    '林前5:3 我身子雖不在你們那裡，心卻在你們那裡，好像我親自與你們同在，已經判斷了行這事的人。',
    '林前5:4 就是你們聚會的時候，我的心也同在。奉我們主耶穌的名，並用我們主耶穌的權能，',
    '林前5:5 要把這樣的人交給撒但，敗壞他的肉體，使他的靈魂在主耶穌的日子可以得救。',
    '林前5:6 你們這自誇是不好的。豈不知一點麵酵能使全團發起來嗎﹖',
    '林前5:7 你們既是無酵的麵，應當把舊酵除淨，好使你們成為新團；因為我們逾越節的羔羊基督已經被殺獻祭了。',
    '林前5:8 所以，我們守這節不可用舊酵，也不可用惡毒（或作：陰毒）、邪惡的酵，只用誠實真正的無酵餅。',
    '林前5:9 我先前寫信給你們說，不可與淫亂的人相交。',
    '林前5:10 此話不是指這世上一概行淫亂的，或貪婪的，勒索的，或拜偶像的；若是這樣，你們除非離開世界方可。',
    '林前5:11 但如今我寫信給你們說，若有稱為弟兄是行淫亂的，或貪婪的，或拜偶像的，或辱罵的，或醉酒的，或勒索的，這樣的人不可與他相交，就是與他吃飯都不可。',
    '林前5:12 因為審判教外的人與我何干﹖教內的人豈不是你們審判的嗎﹖',
    '林前5:13 至於外人有神審判他們。你們應當把那惡人從你們中間趕出去。',
    '林前6:1 你們中間有彼此相爭的事，怎敢在不義的人面前求審，不在聖徒面前求審呢﹖',
    '林前6:2 豈不知聖徒要審判世界嗎﹖若世界為你們所審，難道你們不配審判這最小的事嗎﹖',
    '林前6:3 豈不知我們要審判天使嗎﹖何況今生的事呢﹖',
    '林前6:4 既是這樣，你們若有今生的事當審判，是派教會所輕看的人審判嗎﹖',
    '林前6:5 我說這話是要叫你們羞恥。難道你們中間沒有一個智慧人能審斷弟兄們的事嗎﹖',
    '林前6:6 你們竟是弟兄與弟兄告狀，而且告在不信主的人面前。',
    '林前6:7 你們彼此告狀，這已經是你們的大錯了。為什麼不情願受欺呢﹖為什麼不情願吃虧呢﹖',
    '林前6:8 你們倒是欺壓人、虧負人，況且所欺壓所虧負的就是弟兄。',
    '林前6:9 你們豈不知不義的人不能承受神的國嗎﹖不要自欺！無論是淫亂的、拜偶像的、姦淫的、作孌童的、親男色的、',
    '林前6:10 偷竊的、貪婪的、醉酒的、辱罵的、勒索的，都不能承受神的國。',
    '林前6:11 你們中間也有人從前是這樣；但如今你們奉主耶穌基督的名，並藉著我們神的靈，已經洗淨，成聖，稱義了。',
    '林前6:12 凡事我都可行，但不都有益處。凡事我都可行，但無論哪一件，我總不受他的轄制。',
    '林前6:13 食物是為肚腹，肚腹是為食物；但神要叫這兩樣都廢壞。身子不是為淫亂，乃是為主；主也是為身子。',
    '林前6:14 並且神已經叫主復活，也要用自己的能力叫我們復活。',
    '林前6:15 豈不知你們的身子是基督的肢體嗎﹖我可以將基督的肢體作為娼妓的肢體嗎﹖斷乎不可！',
    '林前6:16 豈不知與娼妓聯合的，便是與他成為一體嗎﹖因為主說﹕二人要成為一體。',
    '林前6:17 但與主聯合的，便是與主成為一靈。',
    '林前6:18 你們要逃避淫行。人所犯的，無論什麼罪，都在身子以外，惟有行淫的，是得罪自己的身子。',
    '林前6:19 豈不知你們的身子就是聖靈的殿嗎﹖這聖靈是從神而來，住在你們裡頭的；並且你們不是自己的人；',
    '林前6:20 因為你們是重價買來的。所以，要在你們的身子上榮耀神。',
    '林前7:1 論到你們信上所提的事，我說男不近女倒好。',
    '林前7:2 但要免淫亂的事，男子當各有自己的妻子；女子也當各有自己的丈夫。',
    '林前7:3 丈夫當用合宜之分待妻子；妻子待丈夫也要如此。',
    '林前7:4 妻子沒有權柄主張自己的身子，乃在丈夫；丈夫也沒有權柄主張自己的身子，乃在妻子。',
    '林前7:5 夫妻不可彼此虧負，除非兩相情願，暫時分房，為要專心禱告方可；以後仍要同房，免得撒但趁著你們情不自禁，引誘你們。',
    '林前7:6 我說這話，原是准你們的，不是命你們的。',
    '林前7:7 我願意眾人像我一樣；只是各人領受神的恩賜，一個是這樣，一個是那樣。',
    '林前7:8 我對著沒有嫁娶的和寡婦說，若他們常像我就好。',
    '林前7:9 倘若自己禁止不住，就可以嫁娶。與其慾火攻心，倒不如嫁娶為妙。',
    '林前7:10 至於那已經嫁娶的，我吩咐他們；其實不是我吩咐，乃是主吩咐說：妻子不可離開丈夫，',
    '林前7:11 若是離開了，不可再嫁，或是仍同丈夫和好。丈夫也不可離棄妻子。',
    '林前7:12 我對其餘的人說，不是主說，倘若某弟兄有不信的妻子，妻子也情願和他同住，他就不要離棄妻子。',
    '林前7:13 妻子有不信的丈夫，丈夫也情願和他同住，他就不要離棄丈夫。',
    '林前7:14 因為不信的丈夫就因著妻子成了聖潔，並且不信的妻子就因著丈夫（原文是弟兄）成了聖潔；不然，你們的兒女就不潔淨，但如今他們是聖潔的了。',
    '林前7:15 倘若那不信的人要離去，就由他離去吧！無論是弟兄，是姊妹，遇著這樣的事都不必拘束。神召我們原是要我們和睦。',
    '林前7:16 你這作妻子的，怎麼知道不能救你的丈夫呢﹖你這作丈夫的，怎麼知道不能救你的妻子呢﹖',
    '林前7:17 只要照主所分給各人的，和神所召各人的而行。我吩咐各教會都是這樣。',
    '林前7:18 有人已受割禮蒙召呢，就不要廢割禮；有人未受割禮蒙召呢，就不要受割禮。',
    '林前7:19 受割禮算不得什麼，不受割禮也算不得什麼，只要守神的誡命就是了。',
    '林前7:20 各人蒙召的時候是什麼身分，仍要守住這身分。',
    '林前7:21 你是作奴隸蒙召的嗎﹖不要因此憂慮；若能以自由，就求自由更好。',
    '林前7:22 因為作奴僕蒙召於主的，就是主所釋放的人；作自由之人蒙召的，就是基督的奴僕。',
    '林前7:23 你們是重價買來的，不要作人的奴僕。',
    '林前7:24 弟兄們，你們各人蒙召的時候是什麼身分，仍要在神面前守住這身分。',
    '林前7:25 論到童身的人，我沒有主的命令，但我既蒙主憐恤能作忠心的人，就把自己的意見告訴你們。',
    '林前7:26 因現今的艱難，據我看來，人不如守素安常才好。',
    '林前7:27 你有妻子纏著呢，就不要求脫離；你沒有妻子纏著呢，就不要求妻子。',
    '林前7:28 你若娶妻，並不是犯罪；處女若出嫁，也不是犯罪。然而這等人肉身必受苦難，我卻願意你們免這苦難。',
    '林前7:29 弟兄們，我對你們說，時候減少了。從此以後，那有妻子的，要像沒有妻子；',
    '林前7:30 哀哭的，要像不哀哭；快樂的，要像不快樂；置買的，要像無有所得；',
    '林前7:31 用世物的，要像不用世物，因為這世界的樣子將要過去了。',
    '林前7:32 我願你們無所掛慮。沒有娶妻的，是為主的事掛慮，想怎樣叫主喜悅。',
    '林前7:33 娶了妻的，是為世上的事掛慮，想怎樣叫妻子喜悅。',
    '林前7:34 婦人和處女也有分別。沒有出嫁的，是為主的事掛慮，要身體、靈魂都聖潔；已經出嫁的，是為世上的事掛慮，想怎樣叫丈夫喜悅。',
    '林前7:35 我說這話是為你們的益處，不是要牢籠你們，乃是要叫你們行合宜的事，得以殷勤服事主，沒有分心的事。',
    '林前7:36 若有人以為自己待他的女兒不合宜，女兒也過了年歲，事又當行，他就可隨意辦理，不算有罪，叫二人成親就是了。',
    '林前7:37 倘若人心裡堅定，沒有不得已的事，並且由得自己作主，心裡又決定了留下女兒不出嫁，如此行也好。',
    '林前7:38 這樣看來，叫自己的女兒出嫁是好，不叫他出嫁更是好。',
    '林前7:39 丈夫活著的時候，妻子是被約束的；丈夫若死了，妻子就可以自由，隨意再嫁，只是要嫁這在主裡面的人。',
    '林前7:40 然而按我的意見，若常守節更有福氣。我也想自己是被神的靈感動了。',
    '林前8:1 論到祭偶像之物，我們曉得我們都有知識。但知識是叫人自高自大，惟有愛心能造就人。',
    '林前8:2 若有人以為自己知道什麼，按他所當知道的，他仍是不知道。',
    '林前8:3 若有人愛神，這人乃是神所知道的。',
    '林前8:4 論到吃祭偶像之物，我們知道偶像在世上算不得什麼，也知道神只有一位，再沒有別的神。',
    '林前8:5 雖有稱為神的，或在天，或在地，就如那許多的神，許多的主；',
    '林前8:6 然而我們只有一位神，就是父，萬物都本於他；我們也歸於他─並有一位主，就是耶穌基督─萬物都是藉著他有的；我們也是藉著他有的。',
    '林前8:7 但人不都有這等知識。有人到如今因拜慣了偶像，就以為所吃的是祭偶像之物。他們的良心既然軟弱，也就污穢了。',
    '林前8:8 其實食物不能叫神看中我們，因為我們不吃也無損，吃也無益。',
    '林前8:9 只是你們要謹慎，恐怕你們這自由竟成了那軟弱人的絆腳石。',
    '林前8:10 若有人見你這有知識的，在偶像的廟裡坐席，這人的良心，若是軟弱，豈不放膽去吃那祭偶像之物嗎﹖',
    '林前8:11 因此，基督為他死的那軟弱弟兄，也就因你的知識沉淪了。',
    '林前8:12 你們這樣得罪弟兄們，傷了他們軟弱的良心，就是得罪基督。',
    '林前8:13 所以，食物若叫我弟兄跌倒，我就永遠不吃肉，免得叫我弟兄跌倒了。',
    '林前9:1 我不是自由的嗎﹖我不是使徒嗎﹖我不是見過我們的主耶穌嗎﹖你們不是我在主裡面所做之工嗎﹖',
    '林前9:2 假若在別人，我不是使徒，在你們，我總是使徒，因為你們在主裡正是我作使徒的印證。',
    '林前9:3 我對那盤問我的人就是這樣分訴：',
    '林前9:4 難道我們沒有權柄靠福音吃喝嗎﹖',
    '林前9:5 難道我們沒有權柄娶信主的姊妹為妻，帶著一同往來，彷彿其餘的使徒和主的弟兄並磯法一樣嗎﹖',
    '林前9:6 獨有我與巴拿巴沒有權柄不做工嗎﹖',
    '林前9:7 有誰當兵自備糧餉呢﹖有誰栽葡萄園不吃園裡的果子呢﹖有誰牧養牛羊不吃牛羊的奶呢﹖',
    '林前9:8 我說這話，豈是照人的意見；律法不也是這樣說嗎﹖',
    '林前9:9 就如摩西的律法記著說：牛在場上踹穀的時候，不可籠住他的嘴。難道神所掛念的是牛嗎﹖',
    '林前9:10 不全是為我們說的嗎﹖分明是為我們說的。因為耕種的當存著指望去耕種；打場的也當存得糧的指望去打場。',
    '林前9:11 我們若把屬靈的種子撒在你們中間，就是從你們收割奉養肉身之物，這還算大事嗎﹖',
    '林前9:12 若別人在你們身上有這權柄，何況我們呢﹖然而，我們沒有用過這權柄，倒凡事忍受，免得基督的福音被阻隔。',
    '林前9:13 你們豈不知為聖事勞碌的就吃殿中的物嗎﹖伺候祭壇的就分領壇上的物嗎﹖',
    '林前9:14 主也是這樣命定，叫傳福音的靠著福音養生。',
    '林前9:15 但這權柄我全沒有用過。我寫這話，並非要你們這樣待我，因為我寧可死也不叫人使我所誇的落了空。',
    '林前9:16 我傳福音原沒有可誇的，因為我是不得已的。若不傳福音，我便有禍了。',
    '林前9:17 我若甘心做這事，就有賞賜；若不甘心，責任卻已經託付我了。',
    '林前9:18 既是這樣，我的賞賜是什麼呢﹖就是我傳福音的時候叫人不花錢得福音，免得用盡我傳福音的權柄。',
    '林前9:19 我雖是自由的，無人轄管；然而我甘心作了眾人的僕人，為要多得人。',
    '林前9:20 向猶太人，我就作猶太人，為要得猶太人；向律法以下的人，我雖不在律法以下，還是作律法以下的人，為要得律法以下的人。',
    '林前9:21 向沒有律法的人，我就作沒有律法的人，為要得沒有律法的人；其實我在神面前，不是沒有律法；在基督面前，正在律法之下。',
    '林前9:22 向軟弱的人，我就作軟弱的人，為要得軟弱的人。向什麼樣的人，我就作什麼樣的人。無論如何，總要救些人。',
    '林前9:23 凡我所行的，都是為福音的緣故，為要與人同得這福音的好處。',
    '林前9:24 豈不知在場上賽跑的都跑，但得獎賞的只有一人﹖你們也當這樣跑，好叫你們得著獎賞。',
    '林前9:25 凡較力爭勝的，諸事都有節制，他們不過是要得能壞的冠冕；我們卻是要得不能壞的冠冕。',
    '林前9:26 所以，我奔跑不像無定向的；我鬥拳不像打空氣的。',
    '林前9:27 我是攻克己身，叫身服我，恐怕我傳福音給別人，自己反被棄絕了。',
    '林前10:1 弟兄們，我不願意你們不曉得，我們的祖宗從前都在雲下，都從海中經過，',
    '林前10:2 都在雲裡、海裡受洗歸了摩西；',
    '林前10:3 並且都吃了一樣的靈食，',
    '林前10:4 也都喝了一樣的靈水。所喝的，是出於隨著他們的靈磐石；那磐石就是基督。',
    '林前10:5 但他們中間多半是神不喜歡的人，所以在曠野倒斃。',
    '林前10:6 這些事都是我們的鑑戒，叫我們不要貪戀惡事，像他們那樣貪戀的；',
    '林前10:7 也不要拜偶像，像他們有人拜的。如經上所記：百姓坐下吃喝，起來玩耍。',
    '林前10:8 我們也不要行姦淫，像他們有人行的，一天就倒斃了二萬三千人；',
    '林前10:9 也不要試探主（有古卷：基督），像他們有人試探的，就被蛇所滅。',
    '林前10:10 你們也不要發怨言，像他們有發怨言的，就被滅命的所滅。',
    '林前10:11 他們遭遇這些事，都要作為鑑戒；並且寫在經上，正是警戒我們這末世的人。',
    '林前10:12 所以，自己以為站得穩的，須要謹慎，免得跌倒。',
    '林前10:13 你們所遇見的試探，無非是人所能受的。神是信實的，必不叫你們受試探過於所能受的；在受試探的時候，總要給你們開一條出路，叫你們能忍受得住。',
    '林前10:14 我所親愛的弟兄啊，你們要逃避拜偶像的事。',
    '林前10:15 我好像對明白人說的，你們要審察我的話。',
    '林前10:16 我們所祝福的杯，豈不是同領基督的血嗎﹖我們所擘開的餅，豈不是同領基督的身體嗎﹖',
    '林前10:17 我們雖多，仍是一個餅，一個身體，因為我們都是分受這一個餅。',
    '林前10:18 你們看屬肉體的以色列人，那吃祭物的豈不是在祭壇上有分嗎﹖',
    '林前10:19 我是怎麼說呢﹖豈是說祭偶像之物算得什麼呢﹖或說偶像算得什麼呢﹖',
    '林前10:20 我乃是說，外邦人所獻的祭是祭鬼，不是祭神。我不願意你們與鬼相交。',
    '林前10:21 你們不能喝主的杯又喝鬼的杯，不能吃主的筵席又吃鬼的筵席。',
    '林前10:22 我們可惹主的憤恨嗎﹖我們比他還有能力嗎﹖',
    '林前10:23 凡事都可行，但不都有益處。凡事都可行，但不都造就人。',
    '林前10:24 無論何人，不要求自己的益處，乃要求別人的益處。',
    '林前10:25 凡市上所賣的，你們只管吃，不要為良心的緣故問什麼話，',
    '林前10:26 因為地和其中所充滿的都屬乎主。',
    '林前10:27 倘有一個不信的人請你們赴席，你們若願意去，凡擺在你們面前的，只管吃，不要為良心的緣故問什麼話。',
    '林前10:28 若有人對你們說：這是獻過祭的物，就要為那告訴你們的人，並為良心的緣故不吃。',
    '林前10:29 我說的良心不是你的，乃是他的。我這自由為什麼被別人的良心論斷呢﹖',
    '林前10:30 我若謝恩而吃，為什麼因我謝恩的物被人毀謗呢﹖',
    '林前10:31 所以，你們或吃或喝，無論做什麼，都要為榮耀神而行。',
    '林前10:32 不拘是猶太人，是希利尼人，是神的教會，你們都不要使他跌倒；',
    '林前10:33 就好像我凡事都叫眾人喜歡，不求自己的益處，只求眾人的益處，叫他們得救。',
    '林前11:1 你們該效法我，像我效法基督一樣。',
    '林前11:2 我稱讚你們，因你們凡事記念我，又堅守我所傳給你們的。',
    '林前11:3 我願意你們知道，基督是各人的頭；男人是女人的頭；神是基督的頭。',
    '林前11:4 凡男人禱告或是講道（或作：說預言；下同），若蒙著頭，就羞辱自己的頭。',
    '林前11:5 凡女人禱告或是講道，若不蒙著頭，就羞辱自己的頭，因為這就如同剃了頭髮一樣。',
    '林前11:6 女人若不蒙著頭，就該剪了頭髮；女人若以剪髮、剃髮為羞愧，就該蒙著頭。',
    '林前11:7 男人本不該蒙著頭，因為他是神的形像和榮耀；但女人是男人的榮耀。',
    '林前11:8 起初，男人不是由女人而出，女人乃是由男人而出。',
    '林前11:9 並且男人不是為女人造的；女人乃是為男人造的。',
    '林前11:10 因此，女人為天使的緣故，應當在頭上有服權柄的記號。',
    '林前11:11 然而照主的安排，女也不是無男，男也不是無女。',
    '林前11:12 因為女人原是由男人而出，男人也是由女人而出；但萬有都是出乎神。',
    '林前11:13 你們自己審察，女人禱告神，不蒙著頭是合宜的嗎﹖',
    '林前11:14 你們的本性不也指示你們，男人若有長頭髮，便是他的羞辱嗎﹖',
    '林前11:15 但女人有長頭髮，乃是他的榮耀，因為這頭髮是給他作蓋頭的。',
    '林前11:16 若有人想要辯駁，我們卻沒有這樣的規矩，神的眾教會也是沒有的。',
    '林前11:17 我現今吩咐你們的話，不是稱讚你們；因為你們聚會不是受益，乃是招損。',
    '林前11:18 第一，我聽說，你們聚會的時候彼此分門別類，我也稍微的信這話。',
    '林前11:19 在你們中間不免有分門結黨的事，好叫那些有經驗的人顯明出來。',
    '林前11:20 你們聚會的時候，算不得吃主的晚餐；',
    '林前11:21 因為吃的時候，各人先吃自己的飯，甚至這個飢餓，那個酒醉。',
    '林前11:22 你們要吃喝，難道沒有家嗎﹖還是藐視神的教會，叫那沒有的羞愧呢﹖我向你們可怎麼說呢﹖可因此稱讚你們嗎﹖我不稱讚！',
    '林前11:23 我當日傳給你們的，原是從主領受的，就是主耶穌被賣的那一夜，拿起餅來，',
    '林前11:24 祝謝了，就擘開，說：這是我的身體，為你們捨（有古卷：擘開）的，你們應當如此行，為的是記念我。',
    '林前11:25 飯後，也照樣拿起杯來，說：這杯是用我的血所立的新約，你們每逢喝的時候，要如此行，為的是記念我。',
    '林前11:26 你們每逢吃這餅，喝這杯，是表明主的死，直等到他來。',
    '林前11:27 所以，無論何人，不按理吃主的餅，喝主的杯，就是干犯主的身、主的血了。',
    '林前11:28 人應當自己省察，然後吃這餅、喝這杯。',
    '林前11:29 因為人吃喝，若不分辨是主的身體，就是吃喝自己的罪了。',
    '林前11:30 因此，在你們中間有好些軟弱的與患病的，死（原文是睡）的也不少。',
    '林前11:31 我們若是先分辨自己，就不至於受審。',
    '林前11:32 我們受審的時候，乃是被主懲治，免得我們和世人一同定罪。',
    '林前11:33 所以我弟兄們，你們聚會吃的時候，要彼此等待。',
    '林前11:34 若有人飢餓，可以在家裡先吃，免得你們聚會，自己取罪。其餘的事，我來的時候再安排。',
    '林前12:1 弟兄們，論到屬靈的恩賜，我不願意你們不明白。',
    '林前12:2 你們作外邦人的時候，隨事被牽引，受迷惑，去服事那啞巴偶像，這是你們知道的。',
    '林前12:3 所以我告訴你們，被神的靈感動的，沒有說耶穌是可咒詛的；若不是被聖靈感動的，也沒有能說耶穌是主的。',
    '林前12:4 恩賜原有分別，聖靈卻是一位。',
    '林前12:5 職事也有分別，主卻是一位。',
    '林前12:6 功用也有分別，神卻是一位，在眾人裡面運行一切的事。',
    '林前12:7 聖靈顯在各人身上，是叫人得益處。',
    '林前12:8 這人蒙聖靈賜他智慧的言語，那人也蒙這位聖靈賜他知識的言語，',
    '林前12:9 又有一人蒙這位聖靈賜他信心，還有一人蒙這位聖靈賜他醫病的恩賜，',
    '林前12:10 又叫一人能行異能，又叫一人能作先知，又叫一人能辨別諸靈，又叫一人能說方言，又叫一人能翻方言。',
    '林前12:11 這一切都是這位聖靈所運行、隨己意分給各人的。',
    '林前12:12 就如身子是一個，卻有許多肢體；而且肢體雖多，仍是一個身子；基督也是這樣。',
    '林前12:13 我們不拘是猶太人，是希利尼人，是為奴的，是自主的，都從一位聖靈受洗，成了一個身體，飲於一位聖靈。',
    '林前12:14 身子原不是一個肢體，乃是許多肢體。',
    '林前12:15 設若腳說：我不是手，所以不屬乎身子；他不能因此就不屬乎身子。',
    '林前12:16 設若耳說：我不是眼，所以不屬乎身子；他也不能因此就不屬乎身子。',
    '林前12:17 若全身是眼，從哪裡聽聲呢﹖若全身是耳，從哪裡聞味呢﹖',
    '林前12:18 但如今，神隨自己的意思把肢體俱各安排在身上了。',
    '林前12:19 若都是一個肢體，身子在哪裡呢﹖',
    '林前12:20 但如今肢體是多的，身子卻是一個。',
    '林前12:21 眼不能對手說：我用不著你；頭也不能對腳說：我用不著你。',
    '林前12:22 不但如此，身上肢體人以為軟弱的，更是不可少的。',
    '林前12:23 身上肢體，我們看為不體面的，越發給他加上體面；不俊美的，越發得著俊美。',
    '林前12:24 我們俊美的肢體，自然用不著裝飾；但神配搭這身子，把加倍的體面給那有缺欠的肢體，',
    '林前12:25 免得身上分門別類，總要肢體彼此相顧。',
    '林前12:26 若一個肢體受苦，所有的肢體就一同受苦；若一個肢體得榮耀，所有的肢體就一同快樂。',
    '林前12:27 你們就是基督的身子，並且各自作肢體。',
    '林前12:28 神在教會所設立的：第一是使徒，第二是先知，第三是教師，其次是行異能的，再次是得恩賜醫病的，幫助人的，治理事的，說方言的。',
    '林前12:29 豈都是使徒嗎﹖豈都是先知嗎﹖豈都是教師嗎﹖豈都是行異能的嗎﹖',
    '林前12:30 豈都是得恩賜醫病的嗎﹖豈都是說方言的嗎﹖豈都是翻方言的嗎﹖',
    '林前12:31 你們要切切的求那更大的恩賜。我現今把最妙的道指示你們。',
    '林前13:1 我若能說萬人的方言，並天使的話語，卻沒有愛，我就成了鳴的鑼，響的鈸一般。',
    '林前13:2 我若有先知講道之能，也明白各樣的奧祕，各樣的知識，而且有全備的信，叫我能夠移山，卻沒有愛，我就算不得什麼。',
    '林前13:3 我若將所有的賙濟窮人，又捨己身叫人焚燒，卻沒有愛，仍然於我無益。',
    '林前13:4 愛是恆久忍耐，又有恩慈；愛是不嫉妒；愛是不自誇，不張狂，',
    '林前13:5 不做害羞的事，不求自己的益處，不輕易發怒，不計算人的惡，',
    '林前13:6 不喜歡不義，只喜歡真理；',
    '林前13:7 凡事包容，凡事相信，凡事盼望，凡事忍耐。',
    '林前13:8 愛是永不止息。先知講道之能終必歸於無有；說方言之能終必停止；知識也終必歸於無有。',
    '林前13:9 我們現在所知道的有限，先知所講的也有限，',
    '林前13:10 等那完全的來到，這有限的必歸於無有了。',
    '林前13:11 我作孩子的時候，話語像孩子，心思像孩子，意念像孩子，既成了人，就把孩子的事丟棄了。',
    '林前13:12 我們如今彷彿對著鏡子觀看，糢糊不清（原文作：如同猜謎）；到那時就要面對面了。我如今所知道的有限，到那時就全知道，如同主知道我一樣。',
    '林前13:13 如今常存的有信，有望，有愛這三樣，其中最大的是愛。',
    '林前14:1 你們要追求愛，也要切慕屬靈的恩賜，其中更要羨慕的，是作先知講道（原文作：是說預言；下同）',
    '林前14:2 那說方言的，原不是對人說，乃是對神說，因為沒有人聽出來。然而，他在心靈裡卻是講說各樣的奧祕。',
    '林前14:3 但作先知講道的，是對人說，要造就、安慰、勸勉人。',
    '林前14:4 說方言的，是造就自己；作先知講道的，乃是造就教會。',
    '林前14:5 我願意你們都說方言，更願意你們作先知講道；因為說方言的，若不翻出來，使教會被造就，那作先知講道的，就比他強了。',
    '林前14:6 弟兄們，我到你們那裡去，若只說方言，不用啟示，或知識，或預言，或教訓，給你們講解，我於你們有什麼益處呢﹖',
    '林前14:7 就是那有聲無氣的物，或簫，或琴，若發出來的聲音沒有分別，怎能知道所吹所彈的是什麼呢﹖',
    '林前14:8 若吹無定的號聲，誰能預備打仗呢﹖',
    '林前14:9 你們也是如此。舌頭若不說容易明白的話，怎能知道所說的是什麼呢﹖這就是向空說話了。',
    '林前14:10 世上的聲音，或者甚多，卻沒有一樣是無意思的。',
    '林前14:11 我若不明白那聲音的意思，這說話的人必以我為化外之人，我也以他為化外之人。',
    '林前14:12 你們也是如此，既是切慕屬靈的恩賜，就當求多得造就教會的恩賜。',
    '林前14:13 所以那說方言的，就當求著能翻出來。',
    '林前14:14 我若用方言禱告，是我的靈禱告，但我的悟性沒有果效。',
    '林前14:15 這卻怎麼樣呢﹖我要用靈禱告，也要用悟性禱告；我要用靈歌唱，也要用悟性歌唱。',
    '林前14:16 不然，你用靈祝謝，那在座不通方言的人，既然不明白你的話，怎能在你感謝的時候說阿們呢﹖',
    '林前14:17 你感謝的固然是好，無奈不能造就別人。',
    '林前14:18 我感謝神，我說方言比你們眾人還多。',
    '林前14:19 但在教會中，寧可用悟性說五句教導人的話，強如說萬句方言。',
    '林前14:20 弟兄們，在心志上不要作小孩子。然而，在惡事上要作嬰孩，在心志上總要作大人。',
    '林前14:21 律法上記著：主說：我要用外邦人的舌頭和外邦人的嘴唇向這百姓說話；雖然如此，他們還是不聽從我。',
    '林前14:22 這樣看來，說方言不是為信的人作證據，乃是為不信的人；作先知講道不是為不信的人作證據，乃是為信的人。',
    '林前14:23 所以，全教會聚在一處的時候，若都說方言，偶然有不通方言的，或是不信的人進來，豈不說你們癲狂了嗎﹖',
    '林前14:24 若都作先知講道，偶然有不信的，或是不通方言的人進來，就被眾人勸醒，被眾人審明，',
    '林前14:25 他心裡的隱情顯露出來，就必將臉伏地，敬拜神，說：神真是在你們中間了。',
    '林前14:26 弟兄們，這卻怎麼樣呢﹖你們聚會的時候，各人或有詩歌，或有教訓，或有啟示，或有方言，或有翻出來的話，凡事都當造就人。',
    '林前14:27 若有說方言的，只好兩個人，至多三個人，且要輪流著說，也要一個人翻出來。',
    '林前14:28 若沒有人翻，就當在會中閉口，只對自己和神說就是了。',
    '林前14:29 至於作先知講道的，只好兩個人或是三個人，其餘的就當慎思明辨。',
    '林前14:30 若旁邊坐著的得了啟示，那先說話的就當閉口不言。',
    '林前14:31 因為你們都可以一個一個的作先知講道，叫眾人學道理，叫眾人得勸勉。',
    '林前14:32 先知的靈原是順服先知的；',
    '林前14:33 因為神不是叫人混亂，乃是叫人安靜。',
    '林前14:34 婦女在會中要閉口不言，像在聖徒的眾教會一樣，因為不准他們說話。他們總要順服，正如律法所說的。',
    '林前14:35 他們若要學什麼，可以在家裡問自己的丈夫，因為婦女在會中說話原是可恥的。',
    '林前14:36 神的道理豈是從你們出來嗎﹖豈是單臨到你們嗎﹖',
    '林前14:37 若有人以為自己是先知，或是屬靈的，就該知道，我所寫給你們的是主的命令。',
    '林前14:38 若有不知道的，就由他不知道吧！',
    '林前14:39 所以我弟兄們，你們要切慕作先知講道，也不要禁止說方言。',
    '林前14:40 凡事都要規規矩矩的按著次序行。',
    '林前15:1 弟兄們，我如今把先前所傳給你們的福音告訴你們知道；這福音你們也領受了，又靠著站立得住，',
    '林前15:2 並且你們若不是徒然相信，能以持守我所傳給你們的，就必因這福音得救。',
    '林前15:3 我當日所領受又傳給你們的：第一，就是基督照聖經所說，為我們的罪死了，',
    '林前15:4 而且埋葬了；又照聖經所說，第三天復活了，',
    '林前15:5 並且顯給磯法看，然後顯給十二使徒看；',
    '林前15:6 後來一時顯給五百多弟兄看，其中一大半到如今還在，卻也有已經睡了的。',
    '林前15:7 以後顯給雅各看，再顯給眾使徒看，',
    '林前15:8 末了也顯給我看；我如同未到產期而生的人一般。',
    '林前15:9 我原是使徒中最小的，不配稱為使徒，因為我從前逼迫神的教會。',
    '林前15:10 然而，我今日成了何等人，是蒙神的恩才成的，並且他所賜我的恩不是徒然的。我比眾使徒格外勞苦；這原不是我，乃是神的恩與我同在。',
    '林前15:11 不拘是我，是眾使徒，我們如此傳，你們也如此信了。',
    '林前15:12 既傳基督是從死裡復活了，怎麼在你們中間有人說沒有死人復活的事呢﹖',
    '林前15:13 若沒有死人復活的事，基督也就沒有復活了。',
    '林前15:14 若基督沒有復活，我們所傳的便是枉然，你們所信的也是枉然；',
    '林前15:15 並且明顯我們是為神妄作見證的，因我們見證神是叫基督復活了。若死人真不復活，神也就沒有叫基督復活了。',
    '林前15:16 因為死人若不復活，基督也就沒有復活了。',
    '林前15:17 基督若沒有復活，你們的信便是徒然，你們仍在罪裡。',
    '林前15:18 就是在基督裡睡了的人也滅亡了。',
    '林前15:19 我們若靠基督，只在今生有指望，就算比眾人更可憐。',
    '林前15:20 但基督已經從死裡復活，成為睡了之人初熟的果子。',
    '林前15:21 死既是因一人而來，死人復活也是因一人而來。',
    '林前15:22 在亞當裡眾人都死了；照樣，在基督裡眾人也都要復活。',
    '林前15:23 但各人是按著自己的次序復活：初熟的果子是基督；以後，在他來的時候，是那些屬基督的。',
    '林前15:24 再後，末期到了，那時基督既將一切執政的、掌權的、有能的、都毀滅了，就把國交與父神。',
    '林前15:25 因為基督必要作王，等神把一切仇敵都放在他的腳下。',
    '林前15:26 儘末了所毀滅的仇敵，就是死。',
    '林前15:27 因為經上說：神叫萬物都服在他的腳下。既說萬物都服了他，明顯那叫萬物服他的，不在其內了。',
    '林前15:28 萬物既服了他，那時子也要自己服那叫萬物服他的，叫神在萬物之上，為萬物之主。',
    '林前15:29 不然，那些為死人受洗的，將來怎樣呢﹖若死人總不復活，因何為他們受洗呢﹖',
    '林前15:30 我們又因何時刻冒險呢﹖',
    '林前15:31 弟兄們，我在我主基督耶穌裡，指著你們所誇的口極力的說，我是天天冒死。',
    '林前15:32 我若當日像尋常人，在以弗所同野獸戰鬥，那於我有什麼益處呢﹖若死人不復活，我們就吃吃喝喝吧！因為明天要死了。',
    '林前15:33 你們不要自欺；濫交是敗壞善行。',
    '林前15:34 你們要醒悟為善，不要犯罪，因為有人不認識神。我說這話是要叫你們羞愧。',
    '林前15:35 或有人問：死人怎樣復活，帶著什麼身體來呢﹖',
    '林前15:36 無知的人哪，你所種的，若不死就不能生。',
    '林前15:37 並且你所種的不是那將來的形體，不過是子粒，即如麥子，或是別樣的穀。',
    '林前15:38 但神隨自己的意思給他一個形體，並叫各等子粒各有自己的形體。',
    '林前15:39 凡肉體各有不同：人是一樣，獸又是一樣，鳥又是一樣，魚又是一樣。',
    '林前15:40 有天上的形體，也有地上的形體；但天上形體的榮光是一樣，地上形體的榮光又是一樣。',
    '林前15:41 日有日的榮光，月有月的榮光，星有星的榮光。這星和那星的榮光也有分別。',
    '林前15:42 死人復活也是這樣：所種的是必朽壞的，復活的是不朽壞的；',
    '林前15:43 所種的是羞辱的，復活的是榮耀的；所種的是軟弱的，復活的是強壯的；',
    '林前15:44 所種的是血氣的身體，復活的是靈性的身體。若有血氣的身體，也必有靈性的身體。',
    '林前15:45 經上也是這樣記著說：首先的人亞當成了有靈（靈：或作血氣）的活人；末後的亞當成了叫人活的靈。',
    '林前15:46 但屬靈的不在先，屬血氣的在先，以後才有屬靈的。',
    '林前15:47 頭一個人是出於地，乃屬土；第二個人是出於天。',
    '林前15:48 那屬土的怎樣，凡屬土的也就怎樣；屬天的怎樣，凡屬天的也就怎樣。',
    '林前15:49 我們既有屬土的形狀，將來也必有屬天的形狀。',
    '林前15:50 弟兄們，我告訴你們說，血肉之體不能承受神的國，必朽壞的不能承受不朽壞的。',
    '林前15:51 我如今把一件奧祕的事告訴你們：我們不是都要睡覺，乃是都要改變，',
    '林前15:52 就在一霎時，眨眼之間，號筒末次吹響的時候。因號筒要響，死人要復活成為不朽壞的，我們也要改變。',
    '林前15:53 這必朽壞的總要變成（變成：原文是穿；下同）不朽壞的，這必死的總要變成不死的。',
    '林前15:54 這必朽壞的既變成不朽壞的，這必死的既變成不死的，那時經上所記死被得勝吞滅的話就應驗了。',
    '林前15:55 死啊！你得勝的權勢在哪裡﹖死啊！你的毒鉤在哪裡﹖',
    '林前15:56 死的毒鉤就是罪，罪的權勢就是律法。',
    '林前15:57 感謝神，使我們藉著我們的主耶穌基督得勝。',
    '林前15:58 所以，我親愛的弟兄們，你們務要堅固，不可搖動，常常竭力多做主工；因為知道，你們的勞苦在主裡面不是徒然的。',
    '林前16:1 論到為聖徒捐錢，我從前怎樣吩咐加拉太的眾教會，你們也當怎樣行。',
    '林前16:2 每逢七日的第一日，各人要照自己的進項抽出來留著，免得我來的時候現湊。',
    '林前16:3 及至我來到了，你們寫信舉薦誰，我就打發他們，把你們的捐資送到耶路撒冷去。',
    '林前16:4 若我也該去，他們可以和我同去。',
    '林前16:5 我要從馬其頓經過；既經過了，就要到你們那裡去，',
    '林前16:6 或者和你們同住幾時，或者也過冬。無論我往哪裡去，你們就可以給我送行。',
    '林前16:7 我如今不願意路過見你們；主若許我，我就指望和你們同住幾時。',
    '林前16:8 但我要仍舊住在以弗所，直等到五旬節；',
    '林前16:9 因為有寬大又有功效的門為我開了，並且反對的人也多。',
    '林前16:10 若是提摩太來到，你們要留心，叫他在你們那裡無所懼怕；因為他勞力做主的工，像我一樣。',
    '林前16:11 所以，無論誰都不可藐視他，只要送他平安前行，叫他到我這裡來，因我指望他和弟兄們同來。',
    '林前16:12 至於兄弟亞波羅，我再三的勸他同弟兄們到你們那裡去；但這時他決不願意去，幾時有了機會他必去。',
    '林前16:13 你們務要警醒，在真道上站立得穩，要作大丈夫，要剛強。',
    '林前16:14 凡你們所做的都要憑愛心而做。',
    '林前16:15 弟兄們，你們曉得司提反一家，是亞該亞初結的果子，並且他們專以服事聖徒為念。',
    '林前16:16 我勸你們順服這樣的人，並一切同工同勞的人。',
    '林前16:17 司提反和福徒拿都，並亞該古到這裡來，我很喜歡；因為你們待我有不及之處，他們補上了。',
    '林前16:18 他們叫我和你們心裡都快活。這樣的人，你們務要敬重。',
    '林前16:19 亞西亞的眾教會問你們安。亞居拉和百基拉並在他們家裡的教會，因主多多的問你們安。',
    '林前16:20 眾弟兄都問你們安。你們要親嘴問安，彼此務要聖潔。',
    '林前16:21 我─保羅親筆問安。',
    '林前16:22 若有人不愛主，這人可詛可咒。主必要來！',
    '林前16:23 願主耶穌基督的恩常與你們眾人同在！',
    '林前16:24 我在基督耶穌裡的愛與你們眾人同在。阿們！',
    '林後1:1 奉神旨意作基督耶穌使徒的保羅和兄弟提摩太，寫信給在哥林多神的教會，並亞該亞遍處的眾聖徒。',
    '林後1:2 願恩惠、平安從神我們的父和主耶穌基督歸與你們！',
    '林後1:3 願頌讚歸與我們的主耶穌基督的父神，就是發慈悲的父，賜各樣安慰的神。',
    '林後1:4 我們在一切患難中，他就安慰我們，叫我們能用神所賜的安慰去安慰那遭各樣患難的人。',
    '林後1:5 我們既多受基督的苦楚，就靠基督多得安慰。',
    '林後1:6 我們受患難呢，是為叫你們得安慰，得拯救；我們得安慰呢，也是為叫你們得安慰；這安慰能叫你們忍受我們所受的那樣苦楚。',
    '林後1:7 我們為你們所存的盼望是確定的，因為知道你們既是同受苦楚，也必同得安慰。',
    '林後1:8 弟兄們，我們不要你們不曉得，我們從前在亞西亞遭遇苦難，被壓太重，力不能勝，甚至連活命的指望都絕了；',
    '林後1:9 自己心裡也斷定是必死的，叫我們不靠自己，只靠叫死人復活的神。',
    '林後1:10 他曾救我們脫離那極大的死亡，現在仍要救我們，並且我們指望他將來還要救我們。',
    '林後1:11 你們以祈禱幫助我們，好叫許多人為我們謝恩，就是為我們因許多人所得的恩。',
    '林後1:12 我們所誇的是自己的良心，見證我們憑著神的聖潔和誠實；在世為人不靠人的聰明，乃靠神的恩惠，向你們更是這樣。',
    '林後1:13 我們現在寫給你們的話，並不外乎你們所念的，所認識的，我也盼望你們到底還是要認識；',
    '林後1:14 正如你們已經有幾分認識我們，以我們誇口，好像我們在我們主耶穌的日子以你們誇口一樣。',
    '林後1:15 我既然這樣深信，就早有意到你們那裡去，叫你們再得益處；',
    '林後1:16 也要從你們那裡經過，往馬其頓去，再從馬其頓回到你們那裡，叫你們給我送行往猶太去。',
    '林後1:17 我有此意，豈是反覆不定嗎﹖我所起的意，豈是從情慾起的，叫我忽是忽非嗎﹖',
    '林後1:18 我指著信實的神說，我們向你們所傳的道，並沒有是而又非的。',
    '林後1:19 因為我和西拉並提摩太，在你們中間所傳神的兒子耶穌基督，總沒有是而又非的，在他只有一是。',
    '林後1:20 神的應許，不論有多少，在基督都是是的。所以藉著他也都是實在（實在：原文是阿們）的，叫神因我們得榮耀。',
    '林後1:21 那在基督裡堅固我們和你們，並且膏我們的就是神。',
    '林後1:22 他又用印印了我們，並賜聖靈在我們心裡作憑據（原文是質）。',
    '林後1:23 我呼籲神給我的心作見證，我沒有往哥林多去是為要寬容你們。',
    '林後1:24 我們並不是轄管你們的信心，乃是幫助你們的快樂，因為你們憑信才站立得住。',
    '林後2:1 我自己定了主意再到你們那裡去，必須大家沒有憂愁。',
    '林後2:2 倘若我叫你們憂愁，除了我叫那憂愁的人以外，誰能叫我快樂呢﹖',
    '林後2:3 我曾把這事寫給你們，恐怕我到的時候，應該叫我快樂的那些人，反倒叫我憂愁。我也深信，你們眾人都以我的快樂為自己的快樂。',
    '林後2:4 我先前心裡難過痛苦，多多的流淚，寫信給你們，不是叫你們憂愁，乃是叫你們知道我格外的疼愛你們。',
    '林後2:5 若有叫人憂愁的，他不但叫我憂愁，也是叫你們眾人有幾分憂愁。我說幾分，恐怕說得太重。',
    '林後2:6 這樣的人受了眾人的責罰也就夠了，',
    '林後2:7 倒不如赦免他，安慰他，免得他憂愁太過，甚至沉淪了。',
    '林後2:8 所以我勸你們，要向他顯出堅定不移的愛心來。',
    '林後2:9 為此我先前也寫信給你們，要試驗你們，看你們凡事順從不順從。',
    '林後2:10 你們赦免誰，我也赦免誰。我若有所赦免的，是在基督面前為你們赦免的；',
    '林後2:11 免得撒但趁著機會勝過我們，因我們並非不曉得他的詭計。',
    '林後2:12 我從前為基督的福音到了特羅亞，主也給我開了門。',
    '林後2:13 那時，因為沒有遇見兄弟提多，我心裡不安，便辭別那裡的人往馬其頓去了。',
    '林後2:14 感謝神！常帥領我們在基督裡誇勝，並藉著我們在各處顯揚那因認識基督而有的香氣。',
    '林後2:15 因為我們在神面前，無論在得救的人身上或滅亡的人身上，都有基督馨香之氣。',
    '林後2:16 在這等人，就作了死的香氣叫他死；在那等人，就作了活的香氣叫他活。這事誰能當得起呢﹖',
    '林後2:17 我們不像那許多人，為利混亂神的道；乃是由於誠實，由於神，在神面前憑著基督講道。',
    '林後3:1 我們豈是又舉薦自己嗎﹖豈像別人用人的薦信給你們或用你們的薦信給人嗎﹖',
    '林後3:2 你們就是我們的薦信，寫在我們的心裡，被眾人所知道所念誦的。',
    '林後3:3 你們明顯是基督的信，藉著我們修成的。不是用墨寫的，乃是用永生神的靈寫的；不是寫在石版上，乃是寫在心版上。',
    '林後3:4 我們因基督，所以在神面前才有這樣的信心。',
    '林後3:5 並不是我們憑自己能承擔什麼事；我們所能承擔的，乃是出於神。',
    '林後3:6 他叫我們能承當這新約的執事，不是憑著字句，乃是憑著精意；因為那字句是叫人死，精意（或作：聖靈）是叫人活。',
    '林後3:7 那用字刻在石頭上屬死的職事尚且有榮光，甚至以色列人因摩西面上的榮光，不能定睛看他的臉；這榮光原是漸漸退去的，',
    '林後3:8 何況那屬靈的職事豈不更有榮光嗎﹖',
    '林後3:9 若是定罪的職事有榮光，那稱義的職事榮光就越發大了。',
    '林後3:10 那從前有榮光的，因這極大的榮光就算不得有榮光了；',
    '林後3:11 若那廢掉的有榮光，這長存的就更有榮光了。',
    '林後3:12 我們既有這樣的盼望，就大膽講說，',
    '林後3:13 不像摩西將帕子蒙在臉上，叫以色列人不能定睛看到那將廢者的結局。',
    '林後3:14 但他們的心地剛硬，直到今日誦讀舊約的時候，這帕子還沒有揭去。這帕子在基督裡已經廢去了。',
    '林後3:15 然而直到今日，每逢誦讀摩西書的時候，帕子還在他們心上。',
    '林後3:16 但他們的心幾時歸向主，帕子就幾時除去了。',
    '林後3:17 主就是那靈；主的靈在哪裡，那裡就得以自由。',
    '林後3:18 我們眾人既然敞著臉得以看見主的榮光，好像從鏡子裡返照，就變成主的形狀，榮上加榮，如同從主的靈變成的。',
    '林後4:1 我們既然蒙憐憫，受了這職分，就不喪膽，',
    '林後4:2 乃將那些暗昧可恥的事棄絕了；不行詭詐，不謬講神的道理，只將真理表明出來，好在神面前把自己薦與各人的良心。',
    '林後4:3 如果我們的福音蒙蔽，就是蒙蔽在滅亡的人身上。',
    '林後4:4 此等不信之人被這世界的神弄瞎了心眼，不叫基督榮耀福音的光照著他們。基督本是神的像。',
    '林後4:5 我們原不是傳自己，乃是傳基督耶穌為主，並且自己因耶穌作你們的僕人。',
    '林後4:6 那吩咐光從黑暗裡照出來的神，已經照在我們心裡，叫我們得知神榮耀的光顯在耶穌基督的面上。',
    '林後4:7 我們有這寶貝放在瓦器裡，要顯明這莫大的能力是出於神，不是出於我們。',
    '林後4:8 我們四面受敵，卻不被困住；心裡作難，卻不至失望；',
    '林後4:9 遭逼迫，卻不被丟棄；打倒了，卻不至死亡。',
    '林後4:10 身上常帶著耶穌的死，使耶穌的生也顯明在我們身上。',
    '林後4:11 因為我們這活著的人是常為耶穌被交於死地，使耶穌的生在我們這必死的身上顯明出來。',
    '林後4:12 這樣看來，死是在我們身上發動，生卻在你們身上發動。',
    '林後4:13 但我們既有信心，正如經上記著說：我因信，所以如此說話。我們也信，所以也說話。',
    '林後4:14 自己知道那叫主耶穌復活的，也必叫我們與耶穌一同復活，並且叫我們與你們一同站在他面前。',
    '林後4:15 凡事都是為你們，好叫恩惠因人多越發加增，感謝格外顯多，以致榮耀歸與神。',
    '林後4:16 所以，我們不喪膽。外體雖然毀壞，內心卻一天新似一天。',
    '林後4:17 我們這至暫至輕的苦楚，要為我們成就極重無比、永遠的榮耀。',
    '林後4:18 原來我們不是顧念所見的，乃是顧念所不見的；因為所見的是暫時的，所不見的是永遠的。',
    '林後5:1 我們原知道，我們這地上的帳棚若拆毀了，必得神所造，不是人手所造，在天上永存的房屋。',
    '林後5:2 我們在這帳棚裡歎息，深想得那從天上來的房屋，好像穿上衣服；',
    '林後5:3 倘若穿上，被遇見的時候就不至於赤身了。',
    '林後5:4 我們在這帳棚裡歎息勞苦，並非願意脫下這個，乃是願意穿上那個，好叫這必死的被生命吞滅了。',
    '林後5:5 為此，培植我們的就是神，他又賜給我們聖靈作憑據（原文是質）。',
    '林後5:6 所以，我們時常坦然無懼，並且曉得我們住在身內，便與主相離。',
    '林後5:7 因我們行事為人是憑著信心，不是憑著眼見。',
    '林後5:8 我們坦然無懼，是更願意離開身體與主同住。',
    '林後5:9 所以，無論是住在身內，離開身外，我們立了志向，要得主的喜悅。',
    '林後5:10 因為我們眾人必要在基督臺前顯露出來，叫各人按著本身所行的，或善或惡受報。',
    '林後5:11 我們既知道主是可畏的，所以勸人。但我們在神面前是顯明的，盼望在你們的良心裡也是顯明的。',
    '林後5:12 我們不是向你們再舉薦自己，乃是叫你們因我們有可誇之處，好對那憑外貌不憑內心誇口的人，有言可答。',
    '林後5:13 我們若果顛狂，是為神；若果謹守，是為你們。',
    '林後5:14 原來基督的愛激勵我們；因我們想，一人既替眾人死，眾人就都死了；',
    '林後5:15 並且他替眾人死，是叫那些活著的人不再為自己活，乃為替他們死而復活的主活。',
    '林後5:16 所以，我們從今以後，不憑著外貌（原文是肉體；本節同）認人了。雖然憑著外貌認過基督，如今卻不再這樣認他了。',
    '林後5:17 若有人在基督裡，他就是新造的人，舊事已過，都變成新的了。',
    '林後5:18 一切都是出於神；他藉著基督使我們與他和好，又將勸人與他和好的職分賜給我們。',
    '林後5:19 這就是神在基督裡，叫世人與自己和好，不將他們的過犯歸到他們身上，並且將這和好的道理託付了我們。',
    '林後5:20 所以，我們作基督的使者，就好像神藉我們勸你們一般。我們替基督求你們與神和好。',
    '林後5:21 神使那無罪（無罪：原文是不知罪）的，替我們成為罪，好叫我們在他裡面成為神的義。',
    '林後6:1 我們與神同工的，也勸你們不可徒受他的恩典。',
    '林後6:2 因為他說：在悅納的時候，我應允了你；在拯救的日子，我搭救了你。看哪！現在正是悅納的時候；現在正是拯救的日子。',
    '林後6:3 我們凡事都不叫人有妨礙，免得這職分被人毀謗；',
    '林後6:4 反倒在各樣的事上表明自己是神的用人，就如在許多的忍耐、患難、窮乏、困苦、',
    '林後6:5 鞭打、監禁、擾亂、勤勞、警醒、不食、',
    '林後6:6 廉潔、知識、恆忍、恩慈、聖靈的感化、無偽的愛心、',
    '林後6:7 真實的道理、神的大能；仁義的兵器在左在右；',
    '林後6:8 榮耀、羞辱，惡名、美名；似乎是誘惑人的，卻是誠實的；',
    '林後6:9 似乎不為人所知，卻是人所共知的；似乎要死，卻是活著的；似乎受責罰，卻是不至喪命的；',
    '林後6:10 似乎憂愁，卻是常常快樂的；似乎貧窮，卻是叫許多人富足的；似乎一無所有，卻是樣樣都有的。',
    '林後6:11 哥林多人哪，我們向你們，口是張開的，心是寬宏的。',
    '林後6:12 你們狹窄，原不在乎我們，是在乎自己的心腸狹窄。',
    '林後6:13 你們也要照樣用寬宏的心報答我。我這話正像對自己的孩子說的。',
    '林後6:14 你們和不信的原不相配，不要同負一軛。義和不義有什麼相交呢﹖光明和黑暗有什麼相通呢﹖',
    '林後6:15 基督和彼列（彼列就是撒但的別名）有什麼相和呢﹖信主的和不信主的有什麼相干呢﹖',
    '林後6:16 神的殿和偶像有什麼相同呢﹖因為我們是永生神的殿，就如神曾說：我要在他們中間居住，在他們中間來往；我要作他們的神；他們要作我的子民。',
    '林後6:17 又說：你們務要從他們中間出來，與他們分別；不要沾不潔淨的物，我就收納你們。',
    '林後6:18 我要作你們的父；你們要作我的兒女。這是全能的主說的。',
    '林後7:1 親愛的弟兄啊，我們既有這等應許，就當潔淨自己，除去身體、靈魂一切的污穢，敬畏神，得以成聖。',
    '林後7:2 你們要心地寬大收納我們。我們未曾虧負誰，未曾敗壞誰，未曾佔誰的便宜。',
    '林後7:3 我說這話，不是要定你們的罪。我已經說過，你們常在我們心裡，情願與你們同生同死。',
    '林後7:4 我大大的放膽，向你們說話；我因你們多多誇口，滿得安慰；我們在一切患難中分外的快樂。',
    '林後7:5 我們從前就是到了馬其頓的時候，身體也不得安寧，周圍遭患難，外有爭戰，內有懼怕。',
    '林後7:6 但那安慰喪氣之人的神藉著提多來安慰了我們；',
    '林後7:7 不但藉著他來，也藉著他從你們所得的安慰，安慰了我們；因他把你們的想念、哀慟，和向我的熱心，都告訴了我，叫我更加歡喜。',
    '林後7:8 我先前寫信叫你們憂愁，我後來雖然懊悔，如今卻不懊悔；因我知道，那信叫你們憂愁不過是暫時的。',
    '林後7:9 如今我歡喜，不是因你們憂愁，是因你們從憂愁中生出懊悔來。你們依著神的意思憂愁，凡事就不至於因我們受虧損了。',
    '林後7:10 因為依著神的意思憂愁，就生出沒有後悔的懊悔來。以致得救；但世俗的憂愁是叫人死。',
    '林後7:11 你看，你們依著神的意思憂愁，從此就生出何等的慇懃、自訴、自恨、恐懼、想念、熱心、責罰（或作：自責）。在這一切事上，你們都表明自己是潔淨的。',
    '林後7:12 我雖然從前寫信給你們，卻不是為那虧負人的，也不是為那受人虧負的，乃要在神面前把你們顧念我們的熱心表明出來。',
    '林後7:13 故此，我們得了安慰。並且在安慰之中，因你們眾人使提多心裡暢快歡喜，我們就更加歡喜了。',
    '林後7:14 我若對提多誇獎了你們什麼，也覺得沒有慚愧；因我對提多誇獎你們的話成了真的，正如我對你們所說的話也都是真的。',
    '林後7:15 並且提多想起你們眾人的順服，是怎樣恐懼戰兢的接待他，他愛你們的心腸就越發熱了。',
    '林後7:16 我如今歡喜，能在凡事上為你們放心。',
    '林後8:1 弟兄們，我把神賜給馬其頓眾教會的恩告訴你們，',
    '林後8:2 就是他們在患難中受大試煉的時候，仍有滿足的快樂，在極窮之間還格外顯出他們樂捐的厚恩。',
    '林後8:3 我可以證明，他們是按著力量，而且也過了力量，自己甘心樂意的捐助，',
    '林後8:4 再三的求我們，准他們在這供給聖徒的恩情上有分；',
    '林後8:5 並且他們所做的，不但照我們所想望的，更照神的旨意先把自己獻給主，又歸附了我們。',
    '林後8:6 因此我勸提多，既然在你們中間開辦這慈惠的事，就當辦成了。',
    '林後8:7 你們既然在信心、口才、知識、熱心，和待我們的愛心上，都格外顯出滿足來，就當在這慈惠的事上也格外顯出滿足來。',
    '林後8:8 我說這話，不是吩咐你們，乃是藉著別人的熱心試驗你們愛心的實在。',
    '林後8:9 你們知道我們主耶穌基督的恩典：他本來富足，卻為你們成了貧窮，叫你們因他的貧窮，可以成為富足。',
    '林後8:10 我在這事上把我的意見告訴你們，是於你們有益；因為你們下手辦這事，而且起此心意，已經有一年了，',
    '林後8:11 如今就當辦成這事。既有願做的心，也當照你們所有的去辦成。',
    '林後8:12 因為人若有願做的心，必蒙悅納，乃是照他所有的，並不是照他所無的。',
    '林後8:13 我原不是要別人輕省，你們受累，',
    '林後8:14 乃要均平，就是要你們的富餘，現在可以補他們的不足，使他們的富餘，將來也可以補你們的不足，這就均平了。',
    '林後8:15 如經上所記：多收的也沒有餘；少收的也沒有缺。',
    '林後8:16 多謝神，感動提多的心，叫他待你們殷勤，像我一樣。',
    '林後8:17 他固然是聽了我的勸，但自己更是熱心，情願往你們那裡去。',
    '林後8:18 我們還打發一位兄弟和他同去，這人在福音上得了眾教會的稱讚。',
    '林後8:19 不但這樣，他也被眾教會挑選，和我們同行，把所託與我們的這捐貲送到了，可以榮耀主，又表明我們樂意的心。',
    '林後8:20 這就免得有人因我們收的捐銀很多，就挑我們的不是。',
    '林後8:21 我們留心行光明的事，不但在主面前，就在人面前也是這樣。',
    '林後8:22 我們又打發一位兄弟同去；這人的熱心，我們在許多事上屢次試驗過。現在他因為深信你們，就更加熱心了。',
    '林後8:23 論到提多，他是我的同伴，一同為你們勞碌的。論到那兩位兄弟，他們是眾教會的使者，是基督的榮耀。',
    '林後8:24 所以，你們務要在眾教會面前顯明你們愛心的憑據，並我所誇獎你們的憑據。',
    '林後9:1 論到供給聖徒的事，我不必寫信給你們；',
    '林後9:2 因為我知道你們樂意的心，常對馬其頓人誇獎你們，說亞該亞人預備好了，已經有一年了；並且你們的熱心激動了許多人。',
    '林後9:3 但我打發那幾位弟兄去，要叫你們照我的話預備妥當；免得我們在這事上誇獎你們的話落了空。',
    '林後9:4 萬一有馬其頓人與我同去，見你們沒有預備，就叫我們所確信的，反成了羞愧；你們羞愧，更不用說了。',
    '林後9:5 因此，我想不得不求那幾位弟兄先到你們那裡去，把從前所應許的捐貲預備妥當，就顯出你們所捐的是出於樂意，不是出於勉強。',
    '林後9:6 少種的少收，多種的多收，這話是真的。',
    '林後9:7 各人要隨本心所酌定的，不要作難，不要勉強，因為捐得樂意的人是神所喜愛的。',
    '林後9:8 神能將各樣的恩惠多多的加給你們，使你們凡事常常充足，能多行各樣善事。',
    '林後9:9 如經上所記：他施捨錢財，賙濟貧窮；他的仁義存到永遠。',
    '林後9:10 那賜種給撒種的，賜糧給人吃的，必多多加給你們種地的種子，又增添你們仁義的果子；',
    '林後9:11 叫你們凡事富足，可以多多施捨，就藉著我們使感謝歸於神。',
    '林後9:12 因為辦這供給的事，不但補聖徒的缺乏，而且叫許多人越發感謝神。',
    '林後9:13 他們從這供給的事上得了憑據，知道你們承認基督順服他的福音，多多的捐錢給他們和眾人，便將榮耀歸與神。',
    '林後9:14 他們也因神極大的恩賜顯在你們心裡，就切切的想念你們，為你們祈禱。',
    '林後9:15 感謝神，因他有說不盡的恩賜！',
    '林後10:1 我保羅，就是與你們見面的時候是謙卑的，不在你們那裡的時候向你們是勇敢的，如今親自藉著基督的溫柔、和平勸你們。',
    '林後10:2 有人以為我是憑著血氣行事，我也以為必須用勇敢待這等人；求你們不要叫我在你們那裡的時候，有這樣的勇敢。',
    '林後10:3 因為我們雖然在血氣中行事，卻不憑著血氣爭戰。',
    '林後10:4 我們爭戰的兵器本不是屬血氣的，乃是在神面前有能力，可以攻破堅固的營壘，',
    '林後10:5 將各樣的計謀，各樣攔阻人認識神的那些自高之事，一概攻破了，又將人所有的心意奪回，使他都順服基督。',
    '林後10:6 並且我已經預備好了，等你們十分順服的時候，要責罰那一切不順服的人。',
    '林後10:7 你們是看眼前的嗎﹖倘若有人自信是屬基督的，他要再想想，他如何屬基督，我們也是如何屬基督的。',
    '林後10:8 主賜給我們權柄，是要造就你們，並不是要敗壞你們；我就是為這權柄稍微誇口，也不至於慚愧。',
    '林後10:9 我說這話，免得你們以為我寫信是要威嚇你們；',
    '林後10:10 因為有人說：他的信又沉重又厲害，及至見面，卻是氣貌不揚，言語粗俗的。',
    '林後10:11 這等人當想，我們不在那裡的時候，信上的言語如何，見面的時候，行事也必如何。',
    '林後10:12 因為我們不敢將自己和那自薦的人同列相比。他們用自己度量自己，用自己比較自己，乃是不通達的。',
    '林後10:13 我們不願意分外誇口，只要照神所量給我們的界限搆到你們那裡。',
    '林後10:14 我們並非過了自己的界限，好像搆不到你們那裡；因為我們早到你們那裡，傳了基督的福音。',
    '林後10:15 我們不仗著別人所勞碌的，分外誇口；但指望你們信心增長的時候，所量給我們的界限，就可以因著你們更加開展，',
    '林後10:16 得以將福音傳到你們以外的地方；並不是在別人界限之內，藉著他現成的事誇口。',
    '林後10:17 但誇口的，當指著主誇口。',
    '林後10:18 因為蒙悅納的，不是自己稱許的，乃是主所稱許的。',
    '林後11:1 但願你們寬容我這一點愚妄，其實你們原是寬容我的。',
    '林後11:2 我為你們起的憤恨，原是神那樣的憤恨。因為我曾把你們許配一個丈夫，要把你們如同貞潔的童女，獻給基督。',
    '林後11:3 我只怕你們的心或偏於邪，失去那向基督所存純一清潔的心，就像蛇用詭詐誘惑了夏娃一樣。',
    '林後11:4 假如有人來另傳一個耶穌，不是我們所傳過的；或者你們另受一個靈，不是你們所受過的；或者另得一個福音，不是你們所得過的；你們容讓他也就罷了。',
    '林後11:5 但我想，我一點不在那些最大的使徒以下。',
    '林後11:6 我的言語雖然粗俗，我的知識卻不粗俗。這是我們在凡事上向你們眾人顯明出來的。',
    '林後11:7 我因為白白傳神的福音給你們，就自居卑微，叫你們高升，這算是我犯罪嗎﹖',
    '林後11:8 我虧負了別的教會，向他們取了工價來給你們效力。',
    '林後11:9 我在你們那裡缺乏的時候，並沒有累著你們一個人；因我所缺乏的，那從馬其頓來的弟兄們都補足了。我向來凡事謹守，後來也必謹守，總不至於累著你們。',
    '林後11:10 既有基督的誠實在我裡面，就無人能在亞該亞一帶地方阻擋我這自誇。',
    '林後11:11 為什麼呢﹖是因我不愛你們嗎﹖這有神知道。',
    '林後11:12 我現在所做的，後來還要做，為要斷絕那些尋機會人的機會，使他們在所誇的事上也不過與我們一樣。',
    '林後11:13 那等人是假使徒，行事詭詐，裝作基督使徒的模樣。',
    '林後11:14 這也不足為怪，因為連撒但也裝作光明的天使。',
    '林後11:15 所以他的差役，若裝作仁義的差役，也不算希奇。他們的結局必然照著他們的行為。',
    '林後11:16 我再說，人不可把我看作愚妄的。縱然如此，也要把我當作愚妄人接納，叫我可以略略自誇。',
    '林後11:17 我說的話不是奉主命說的，乃是像愚妄人放膽自誇；',
    '林後11:18 既有好些人憑著血氣自誇，我也要自誇了。',
    '林後11:19 你們既是精明人，就能甘心忍耐愚妄人。',
    '林後11:20 假若有人強你們作奴僕，或侵吞你們，或擄掠你們，或侮慢你們，或打你們的臉，你們都能忍耐他。',
    '林後11:21 我說這話是羞辱自己，好像我們從前是軟弱的。然而，人在何事上勇敢，（我說句愚妄話，）我也勇敢。',
    '林後11:22 他們是希伯來人嗎﹖我也是。他們是以色列人嗎﹖我也是。他們是亞伯拉罕的後裔嗎﹖我也是。',
    '林後11:23 他們是基督的僕人嗎﹖（我說句狂話，）我更是。我比他們多受勞苦，多下監牢，受鞭打是過重的，冒死是屢次有的。',
    '林後11:24 被猶太人鞭打五次，每次四十減去一下；',
    '林後11:25 被棍打了三次；被石頭打了一次，遇著船壞三次，一晝一夜在深海裡。',
    '林後11:26 又屢次行遠路，遭江河的危險、盜賊的危險，同族的危險、外邦人的危險、城裡的危險、曠野的危險、海中的危險、假弟兄的危險。',
    '林後11:27 受勞碌、受困苦，多次不得睡，又飢又渴，多次不得食，受寒冷，赤身露體。',
    '林後11:28 除了這外面的事，還有為眾教會掛心的事，天天壓在我身上。',
    '林後11:29 有誰軟弱，我不軟弱呢﹖有誰跌倒，我不焦急呢﹖',
    '林後11:30 我若必須自誇，就誇那關乎我軟弱的事便了。',
    '林後11:31 那永遠可稱頌之主耶穌的父神知道我不說謊。',
    '林後11:32 在大馬色亞哩達王手下的提督把守大馬色城，要捉拿我，',
    '林後11:33 我就從窗戶中，在筐子裡，從城牆上被人縋下去，脫離了他的手。',
    '林後12:1 我自誇固然無益，但我是不得已的。如今我要說到主的顯現和啟示。',
    '林後12:2 我認得一個在基督裡的人，他前十四年被提到第三層天上去；或在身內，我不知道；或在身外，我也不知道；只有神知道。',
    '林後12:3 我認得這人；或在身內，或在身外，我都不知道，只有神知道。',
    '林後12:4 他被提到樂園裡，聽見隱祕的言語，是人不可說的。',
    '林後12:5 為這人，我要誇口；但是為我自己，除了我的軟弱以外，我並不誇口。',
    '林後12:6 我就是願意誇口也不算狂，因為我必說實話；只是我禁止不說，恐怕有人把我看高了，過於他在我身上所看見所聽見的。',
    '林後12:7 又恐怕我因所得的啟示甚大，就過於自高，所以有一根刺加在我肉體上，就是撒但的差役要攻擊我，免得我過於自高。',
    '林後12:8 為這事，我三次求過主，叫這刺離開我。',
    '林後12:9 他對我說：我的恩典夠你用的，因為我的能力是在人的軟弱上顯得完全。所以，我更喜歡誇自己的軟弱，好叫基督的能力覆庇我。',
    '林後12:10 我為基督的緣故，就以軟弱、凌辱、急難、逼迫、困苦為可喜樂的；因我什麼時候軟弱，什麼時候就剛強了。',
    '林後12:11 我成了愚妄人，是被你們強逼的。我本該被你們稱許才是。我雖算不了什麼，卻沒有一件事在那些最大的使徒以下。',
    '林後12:12 我在你們中間，用百般的忍耐，藉著神蹟、奇事、異能，顯出使徒的憑據來。',
    '林後12:13 除了我不累著你們這一件事，你們還有什麼事不及別的教會呢﹖這不公之處，求你們饒恕我吧。',
    '林後12:14 如今，我打算第三次到你們那裡去，也必不累著你們；因我所求的是你們，不是你們的財物。兒女不該為父母積財，父母該為兒女積財。',
    '林後12:15 我也甘心樂意為你們的靈魂費財費力。難道我越發愛你們，就越發少得你們的愛嗎﹖',
    '林後12:16 罷了，我自己並沒有累著你們，你們卻有人說，我是詭詐，用心計牢籠你們。',
    '林後12:17 我所差到你們那裡去的人，我藉著他們一個人佔過你們的便宜嗎﹖',
    '林後12:18 我勸了提多到你們那裡去；又差那位兄弟與他同去。提多佔過你們的便宜嗎﹖我們行事，不同是一個心靈（或作：聖靈）嗎﹖不同是一個腳蹤嗎﹖',
    '林後12:19 你們到如今，還想我們是向你們分訴；我們本是在基督裡當神面前說話。親愛的弟兄啊，一切的事都是為造就你們。',
    '林後12:20 我怕我再來的時候，見你們不合我所想望的，你們見我也不合你們所想望的；又怕有紛爭、嫉妒、惱怒、結黨、毀謗、讒言、狂傲、混亂的事。',
    '林後12:21 且怕我來的時候，我的神叫我在你們面前慚愧，又因許多人從前犯罪，行污穢、姦淫、邪蕩的事不肯悔改，我就憂愁。',
    '林後13:1 這是我第三次要到你們那裡去。憑兩三個人的口作見證，句句都要定準。',
    '林後13:2 我從前說過，如今不在你們那裡又說，正如我第二次見你們的時候所說的一樣，就是對那犯了罪的和其餘的人說：我若再來，必不寬容。',
    '林後13:3 你們既然尋求基督在我裡面說話的憑據，我必不寬容。因為，基督在你們身上不是軟弱的，在你們裡面是有大能的。',
    '林後13:4 他因軟弱被釘在十字架上，卻因神的大能仍然活著。我們也是這樣同他軟弱，但因神向你們所顯的大能，也必與他同活。',
    '林後13:5 你們總要自己省察有信心沒有，也要自己試驗。豈不知你們若不是可棄絕的，就有耶穌基督在你們心裡嗎﹖',
    '林後13:6 我卻盼望你們曉得，我們不是可棄絕的人。',
    '林後13:7 我們求神，叫你們一件惡事都不做；這不是要顯明我們是蒙悅納的，是要你們行事端正，任憑人看我們是被棄絕的吧！',
    '林後13:8 我們凡事不能敵擋真理，只能扶助真理。',
    '林後13:9 即使我們軟弱，你們剛強，我們也歡喜；並且我們所求的，就是你們作完全人。',
    '林後13:10 所以，我不在你們那裡的時候，把這話寫給你們，好叫我見你們的時候，不用照主所給我的權柄嚴厲的待你們；這權柄原是為造就人，並不是為敗壞人。',
    '林後13:11 還有末了的話：願弟兄們都喜樂。要作完全人；要受安慰；要同心合意；要彼此和睦。如此，仁愛和平的神必常與你們同在。',
    '林後13:12 你們親嘴問安，彼此務要聖潔。',
    '林後13:13 眾聖徒都問你們安。',
    '林後13:14 願主耶穌基督的恩惠、神的慈愛、聖靈的感動，常與你們眾人同在！',
    '加1:1 作使徒的保羅（不是由於人，也不是藉著人，乃是藉著耶穌基督，與叫他從死裡復活的父神）',
    '加1:2 和一切與我同在的眾弟兄，寫信給加拉太的各教會。',
    '加1:3 願恩惠、平安從父神與我們的主耶穌基督歸與你們！',
    '加1:4 基督照我們父神的旨意，為我們的罪捨己，要救我們脫離這罪惡的世代。',
    '加1:5 但願榮耀歸於神，直到永永遠遠。阿們！',
    '加1:6 我希奇你們這麼快離開那藉著基督之恩召你們的，去從別的福音。',
    '加1:7 那並不是福音，不過有些人攪擾你們，要把基督的福音更改了。',
    '加1:8 但無論是我們，是天上來的使者，若傳福音給你們，與我們所傳給你們的不同，他就應當被咒詛。',
    '加1:9 我們已經說了，現在又說，若有人傳福音給你們，與你們所領受的不同，他就應當被咒詛。',
    '加1:10 我現在是要得人的心呢﹖還是要得神的心呢﹖我豈是討人的喜歡嗎﹖若仍舊討人的喜歡，我就不是基督的僕人了。',
    '加1:11 弟兄們，我告訴你們，我素來所傳的福音不是出於人的意思。',
    '加1:12 因為我不是從人領受的，也不是人教導我的，乃是從耶穌基督啟示來的。',
    '加1:13 你們聽見我從前在猶太教中所行的事，怎樣極力逼迫殘害神的教會。',
    '加1:14 我又在猶太教中，比我本國許多同歲的人更有長進，為我祖宗的遺傳更加熱心。',
    '加1:15 然而，那把我從母腹裡分別出來、又施恩召我的神，',
    '加1:16 既然樂意將他兒子啟示在我心裡，叫我把他傳在外邦人中，我就沒有與屬血氣的人商量，',
    '加1:17 也沒有上耶路撒冷去見那些比我先作使徒的，惟獨往亞拉伯去，後又回到大馬色。',
    '加1:18 過了三年，才上耶路撒冷去見磯法，和他同住了十五天。',
    '加1:19 至於別的使徒，除了主的兄弟雅各，我都沒有看見。',
    '加1:20 我寫給你們的不是謊話，這是我在神面前說的。',
    '加1:21 以後我到了敘利亞和基利家境內。',
    '加1:22 那時，猶太信基督的各教會都沒有見過我的面。',
    '加1:23 不過聽說那從前逼迫我們的，現在傳揚他原先所殘害的真道。',
    '加1:24 他們就為我的緣故，歸榮耀給神。',
    '加2:1 過了十四年，我同巴拿巴又上耶路撒冷去，並帶著提多同去。',
    '加2:2 我是奉啟示上去的，把我在外邦人中所傳的福音，對弟兄們陳說；卻是背地裡對那有名望之人說的，惟恐我現在，或是從前，徒然奔跑。',
    '加2:3 但與我同去的提多，雖是希利尼人，也沒有勉強他受割禮；',
    '加2:4 因為有偷著引進來的假弟兄，私下窺探我們在基督耶穌裡的自由，要叫我們作奴僕。',
    '加2:5 我們就是一刻的工夫也沒有容讓順服他們，為要叫福音的真理仍存在你們中間。',
    '加2:6 至於那些有名望的，不論他是何等人，都與我無干。神不以外貌取人。那些有名望的，並沒有加增我什麼，',
    '加2:7 反倒看見了主託我傳福音給那未受割禮的人，正如託彼得傳福音給那受割禮的人。',
    '加2:8 （那感動彼得、叫他為受割禮之人作使徒的，也感動我，叫我為外邦人作使徒；）',
    '加2:9 又知道所賜給我的恩典，那稱為教會柱石的雅各、磯法、約翰，就向我和巴拿巴用右手行相交之禮，叫我們往外邦人那裡去，他們往受割禮的人那裡去。',
    '加2:10 只是願意我們記念窮人；這也是我本來熱心去行的。',
    '加2:11 後來，磯法到了安提阿；因他有可責之處，我就當面抵擋他。',
    '加2:12 從雅各那裡來的人未到以先，他和外邦人一同吃飯，及至他們來到，他因怕奉割禮的人，就退去與外邦人隔開了。',
    '加2:13 其餘的猶太人也都隨著他裝假，甚至連巴拿巴也隨夥裝假。',
    '加2:14 但我一看見他們行的不正，與福音的真理不合，就在眾人面前對磯法說：你既是猶太人，若隨外邦人行事，不隨猶太人行事，怎麼還勉強外邦人隨猶太人呢﹖',
    '加2:15 我們這生來的猶太人，不是外邦的罪人；',
    '加2:16 既知道人稱義不是因行律法，乃是因信耶穌基督，連我們也信了基督耶穌，使我們因信基督稱義，不因行律法稱義；因為凡有血氣的，沒有一人因行律法稱義。',
    '加2:17 我們若求在基督裡稱義，卻仍舊是罪人，難道基督是叫人犯罪的嗎﹖斷乎不是！',
    '加2:18 我素來所拆毀的，若重新建造，這就證明自己是犯罪的人。',
    '加2:19 我因律法，就向律法死了，叫我可以向神活著。',
    '加2:20 我已經與基督同釘十字架，現在活著的不再是我，乃是基督在我裡面活著；並且我如今在肉身活著，是因信神的兒子而活；他是愛我，為我捨己。',
    '加2:21 我不廢掉神的恩；義若是藉著律法得的，基督就是徒然死了。',
    '加3:1 無知的加拉太人哪，耶穌基督釘十字架，已經活畫在你們眼前，誰又迷惑了你們呢﹖',
    '加3:2 我只要問你們這一件：你們受了聖靈，是因行律法呢﹖是因聽信福音呢﹖',
    '加3:3 你們既靠聖靈入門，如今還靠肉身成全嗎﹖你們是這樣的無知嗎﹖',
    '加3:4 你們受苦如此之多，都是徒然的嗎﹖難道果真是徒然的嗎﹖',
    '加3:5 那賜給你們聖靈，又在你們中間行異能的，是因你們行律法呢﹖是因你們聽信福音呢﹖',
    '加3:6 正如亞伯拉罕信神，這就算為他的義。',
    '加3:7 所以，你們要知道：那以信為本的人，就是亞伯拉罕的子孫。',
    '加3:8 並且聖經既然預先看明，神要叫外邦人因信稱義，就早已傳福音給亞伯拉罕，說：萬國都必因你得福。',
    '加3:9 可見那以信為本的人和有信心的亞伯拉罕一同得福。',
    '加3:10 凡以行律法為本的，都是被咒詛的；因為經上記著：凡不常照律法書上所記一切之事去行的，就被咒詛。',
    '加3:11 沒有一個人靠著律法在神面前稱義，這是明顯的；因為經上說，義人必因信得生。',
    '加3:12 律法原不本乎信，只說：行這些事的，就必因此活著。',
    '加3:13 基督既為我們受（原文是成）了咒詛，就贖出我們脫離律法的咒詛；因為經上記著：凡掛在木頭上都是被咒詛的。',
    '加3:14 這便叫亞伯拉罕的福，因基督耶穌可以臨到外邦人，使我們因信得著所應許的聖靈。',
    '加3:15 弟兄們，我且照著人的常話說：雖然是人的文約，若已經立定了，就沒有能廢棄或加增的。',
    '加3:16 所應許的原是向亞伯拉罕和他子孫說的。神並不是說眾子孫，指著許多人，乃是說你那一個子孫，指著一個人，就是基督。',
    '加3:17 我是這麼說，神預先所立的約，不能被那四百三十年以後的律法廢掉，叫應許歸於虛空。',
    '加3:18 因為承受產業，若本乎律法，就不本乎應許；但神是憑著應許把產業賜給亞伯拉罕。',
    '加3:19 這樣說來，律法是為什麼有的呢﹖原是為過犯添上的，等候那蒙應許的子孫來到，並且是藉天使經中保之手設立的。',
    '加3:20 但中保本不是為一面作的；神卻是一位。',
    '加3:21 這樣，律法是與神的應許反對嗎﹖斷乎不是！若曾傳一個能叫人得生的律法，義就誠然本乎律法了。',
    '加3:22 但聖經把眾人都圈在罪裡，使所應許的福因信耶穌基督，歸給那信的人。',
    '加3:23 但這因信得救的理還未來以先，我們被看守在律法之下，直圈到那將來的真道顯明出來。',
    '加3:24 這樣，律法是我們訓蒙的師傅，引我們到基督那裡，使我們因信稱義。',
    '加3:25 但這因信得救的理既然來到，我們從此就不在師傅的手下了。',
    '加3:26 所以，你們因信基督耶穌都是神的兒子。',
    '加3:27 你們受洗歸入基督的都是披戴基督了。',
    '加3:28 並不分猶太人、希利尼人，自主的、為奴的，或男或女，因為你們在基督耶穌裡都成為一了。',
    '加3:29 你們既屬乎基督，就是亞伯拉罕的後裔，是照著應許承受產業的了。',
    '加4:1 我說那承受產業的，雖然是全業的主人，但為孩童的時候卻與奴僕毫無分別，',
    '加4:2 乃在師傅和管家的手下，直等他父親預定的時候來到。',
    '加4:3 我們為孩童的時候，受管於世俗小學之下，也是如此。',
    '加4:4 及至時候滿足，神就差遣他的兒子，為女子所生，且生在律法以下，',
    '加4:5 要把律法以下的人贖出來，叫我們得著兒子的名分。',
    '加4:6 你們既為兒子，神就差他兒子的靈進入你們（原文作我們）的心，呼叫：阿爸！父！',
    '加4:7 可見，從此以後，你不是奴僕，乃是兒子了；既是兒子，就靠著神為後嗣。',
    '加4:8 但從前你們不認識神的時候，是給那些本來不是神的作奴僕；',
    '加4:9 現在你們既然認識神，更可說是被神所認識的，怎麼還要歸回那懦弱無用的小學，情願再給他作奴僕呢﹖',
    '加4:10 你們謹守日子、月分、節期、年分。',
    '加4:11 我為你們害怕、惟恐我在你們身上是枉費了工夫。',
    '加4:12 弟兄們，我勸你們要像我一樣，因為我也像你們一樣。你們一點沒有虧負我。',
    '加4:13 你們知道我頭一次傳福音給你們，是因為身體有疾病。',
    '加4:14 你們為我身體的緣故受試煉，沒有輕看我，也沒有厭棄我，反倒接待我，如同神的使者，如同基督耶穌。',
    '加4:15 你們當日所誇的福氣在哪裡呢﹖那時你們若能行，就是把自己的眼睛剜出來給我，也都情願。這是我可以給你們作見證的。',
    '加4:16 如今我將真理告訴你們，就成了你們的仇敵嗎﹖',
    '加4:17 那些人熱心待你們，卻不是好意，是要離間你們（原文是把你們關在外面），叫你們熱心待他們。',
    '加4:18 在善事上，常用熱心待人原是好的，卻不單我與你們同在的時候才這樣。',
    '加4:19 我小子啊，我為你們再受生產之苦，直等到基督成形在你們心裡。',
    '加4:20 我巴不得現今在你們那裡，改換口氣，因我為你們心裡作難。',
    '加4:21 你們這願意在律法以下的人，請告訴我，你們豈沒有聽見律法嗎﹖',
    '加4:22 因為律法上記著，亞伯拉罕有兩個兒子，一個是使女生的，一個是自主之婦人生的。',
    '加4:23 然而，那使女所生的是按著血氣生的；那自主之婦人所生的是憑著應許生的。',
    '加4:24 這都是比方：那兩個婦人就是兩約。一約是出於西乃山，生子為奴，乃是夏甲。',
    '加4:25 這夏甲二字是指著亞拉伯的西乃山，與現在的耶路撒冷同類，因耶路撒冷和他的兒女都是為奴的。',
    '加4:26 但那在上的耶路撒冷是自主的，他是我們的母。',
    '加4:27 因為經上記著：不懷孕、不生養的，你要歡樂；未曾經過產難的，你要高聲歡呼；因為沒有丈夫的，比有丈夫的兒女更多。',
    '加4:28 弟兄們，我們是憑著應許作兒女，如同以撒一樣。',
    '加4:29 當時，那按著血氣生的逼迫了那按著聖靈生的，現在也是這樣。',
    '加4:30 然而經上是怎麼說的呢﹖是說：把使女和他兒子趕出去！因為使女的兒子不可與自主婦人的兒子一同承受產業。',
    '加4:31 弟兄們，這樣看來，我們不是使女的兒女，乃是自主婦人的兒女了。',
    '加5:1 基督釋放了我們，叫我們得以自由。所以要站立得穩，不要再被奴僕的軛挾制。',
    '加5:2 我保羅告訴你們，若受割禮，基督就於你們無益了。',
    '加5:3 我再指著凡受割禮的人確實的說，他是欠著行全律法的債。',
    '加5:4 你們這要靠律法稱義的，是與基督隔絕，從恩典中墜落了。',
    '加5:5 我們靠著聖靈，憑著信心，等候所盼望的義。',
    '加5:6 原來在基督耶穌裡，受割禮不受割禮全無功效，惟獨使人生發仁愛的信心才有功效。',
    '加5:7 你們向來跑得好，有誰攔阻你們，叫你們不順從真理呢﹖',
    '加5:8 這樣的勸導不是出於那召你們的。',
    '加5:9 一點麵酵能使全團都發起來。',
    '加5:10 我在主裡很信你們必不懷別樣的心；但攪擾你們的，無論是誰，必擔當他的罪名。',
    '加5:11 弟兄們，我若仍舊傳割禮，為什麼還受逼迫呢﹖若是這樣，那十字架討厭的地方就沒有了。',
    '加5:12 恨不得那攪亂你們的人把自己割絕了。',
    '加5:13 弟兄們，你們蒙召是要得自由，只是不可將你們的自由當作放縱情慾的機會，總要用愛心互相服事。',
    '加5:14 因為全律法都包在愛人如己這一句話之內了。',
    '加5:15 你們要謹慎，若相咬相吞，只怕要彼此消滅了。',
    '加5:16 我說，你們當順著聖靈而行，就不放縱肉體的情慾了。',
    '加5:17 因為情慾和聖靈相爭，聖靈和情慾相爭，這兩個是彼此相敵，使你們不能做所願意做的。',
    '加5:18 但你們若被聖靈引導，就不在律法以下。',
    '加5:19 情慾的事都是顯而易見的，就如姦淫、污穢、邪蕩、',
    '加5:20 拜偶像、邪術、仇恨、爭競、忌恨、惱怒、結黨、紛爭、異端、',
    '加5:21 嫉妒（有古卷在此有：兇殺二字）、醉酒、荒宴等類。我從前告訴你們，現在又告訴你們，行這樣事的人必不能承受神的國。',
    '加5:22 聖靈所結的果子，就是仁愛、喜樂、和平、忍耐、恩慈、良善、信實、',
    '加5:23 溫柔、節制。這樣的事沒有律法禁止。',
    '加5:24 凡屬基督耶穌的人，是已經把肉體連肉體的邪情私慾同釘在十字架上了。',
    '加5:25 我們若是靠聖靈得生，就當靠聖靈行事。',
    '加5:26 不要貪圖虛名，彼此惹氣，互相嫉妒。',
    '加6:1 弟兄們，若有人偶然被過犯所勝，你們屬靈的人就當用溫柔的心把他挽回過來；又當自己小心，恐怕也被引誘。',
    '加6:2 你們各人的重擔要互相擔當，如此，就完全了基督的律法。',
    '加6:3 人若無有，自己還以為有，就是自欺了。',
    '加6:4 各人應當察驗自己的行為；這樣，他所誇的就專在自己，不在別人了，',
    '加6:5 因為各人必擔當自己的擔子。',
    '加6:6 在道理上受教的，當把一切需用的供給施教的人。',
    '加6:7 不要自欺，神是輕慢不得的。人種的是什麼，收的也是什麼。',
    '加6:8 順著情慾撒種的，必從情慾收敗壞；順著聖靈撒種的，必從聖靈收永生。',
    '加6:9 我們行善，不可喪志；若不灰心，到了時候就要收成。',
    '加6:10 所以，有了機會就當向眾人行善，向信徒一家的人更當這樣。',
    '加6:11 請看我親手寫給你們的字是何等的大呢！',
    '加6:12 凡希圖外貌體面的人都勉強你們受割禮，無非是怕自己為基督的十字架受逼迫。',
    '加6:13 他們那些受割禮的，連自己也不守律法；他們願意你們受割禮，不過要藉著你們的肉體誇口。',
    '加6:14 但我斷不以別的誇口，只誇我們主耶穌基督的十字架；因這十字架，就我而論，世界已經釘在十字架上；就世界而論，我已經釘在十字架上。',
    '加6:15 受割禮不受割禮都無關緊要，要緊的就是作新造的人。',
    '加6:16 凡照此理而行的，願平安、憐憫加給他們，和神的以色列民。',
    '加6:17 從今以後，人都不要攪擾我，因為我身上帶著耶穌的印記。',
    '加6:18 弟兄們，願我主耶穌基督的恩常在你們心裡。阿們！',
    '弗1:1 奉神旨意，作基督耶穌使徒的保羅，寫信給在以弗所的聖徒，就是在基督耶穌裡有忠心的人。',
    '弗1:2 願恩惠、平安從神我們的父和主耶穌基督歸與你們！',
    '弗1:3 願頌讚歸與我們主耶穌基督的父神！他在基督裡曾賜給我們天上各樣屬靈的福氣：',
    '弗1:4 就如神從創立世界以前，在基督裡揀選了我們，使我們在他面前成為聖潔，無有瑕疵；',
    '弗1:5 又因愛我們，就按著自己意旨所喜悅的，預定我們藉著耶穌基督得兒子的名分，',
    '弗1:6 使他榮耀的恩典得著稱讚；這恩典是他在愛子裡所賜給我們的。',
    '弗1:7 我們藉這愛子的血得蒙救贖，過犯得以赦免，乃是照他豐富的恩典。',
    '弗1:8 這恩典是神用諸般智慧聰明，充充足足賞給我們的；',
    '弗1:9 都是照他自己所預定的美意，叫我們知道他旨意的奧祕，',
    '弗1:10 要照所安排的，在日期滿足的時候，使天上、地上、一切所有的都在基督裡面同歸於一。',
    '弗1:11 我們也在他裡面得（或作：成）了基業；這原是那位隨己意行、做萬事的，照著他旨意所預定的，',
    '弗1:12 叫他的榮耀從我們這首先在基督裡有盼望的人可以得著稱讚。',
    '弗1:13 你們既聽見真理的道，就是那叫你們得救的福音，也信了基督，既然信他，就受了所應許的聖靈為印記。',
    '弗1:14 這聖靈是我們得基業的憑據（原文作：質），直等到神之民（原文作：產業）被贖，使他的榮耀得著稱讚。',
    '弗1:15 因此，我既聽見你們信從主耶穌，親愛眾聖徒，',
    '弗1:16 就為你們不住的感謝神。禱告的時候，常提到你們，',
    '弗1:17 求我們主耶穌基督的神，榮耀的父，將那賜人智慧和啟示的靈賞給你們，使你們真知道他，',
    '弗1:18 並且照明你們心中的眼睛，使你們知道他的恩召有何等指望，他在聖徒中得的基業有何等豐盛的榮耀；',
    '弗1:19 並知道他向我們這信的人所顯的能力是何等浩大，',
    '弗1:20 就是照他在基督身上所運行的大能大力，使他從死裡復活，叫他在天上坐在自己的右邊，',
    '弗1:21 遠超過一切執政的、掌權的、有能的、主治的，和一切有名的；不但是今世的，連來世的也都超過了。',
    '弗1:22 又將萬有服在他的腳下，使他為教會作萬有之首。',
    '弗1:23 教會是他的身體，是那充滿萬有者所充滿的。',
    '弗2:1 你們死在過犯罪惡之中，他叫你們活過來。',
    '弗2:2 那時，你們在其中行事為人，隨從今世的風俗，順服空中掌權者的首領，就是現今在悖逆之子心中運行的邪靈。',
    '弗2:3 我們從前也都在他們中間，放縱肉體的私慾，隨著肉體和心中所喜好的去行，本為可怒之子，和別人一樣。',
    '弗2:4 然而，神既有豐富的憐憫，因他愛我們的大愛，',
    '弗2:5 當我們死在過犯中的時候，便叫我們與基督一同活過來。你們得救是本乎恩。',
    '弗2:6 他又叫我們與基督耶穌一同復活，一同坐在天上，',
    '弗2:7 要將他極豐富的恩典，就是他在基督耶穌裡向我們所施的恩慈，顯明給後來的世代看。',
    '弗2:8 你們得救是本乎恩，也因著信；這並不是出於自己，乃是神所賜的；',
    '弗2:9 也不是出於行為，免得有人自誇。',
    '弗2:10 我們原是他的工作，在基督耶穌裡造成的，為要叫我們行善，就是神所預備叫我們行的。',
    '弗2:11 所以你們應當記念：你們從前按肉體是外邦人，是稱為沒受割禮的；這名原是那些憑人手在肉身上稱為受割禮之人所起的。',
    '弗2:12 那時，你們與基督無關，在以色列國民以外，在所應許的諸約上是局外人，並且活在世上沒有指望，沒有神。',
    '弗2:13 你們從前遠離神的人，如今卻在基督耶穌裡，靠著他的血，已經得親近了。',
    '弗2:14 因他使我們和睦（原文作：因他是我們的和睦），將兩下合而為一，拆毀了中間隔斷的牆；',
    '弗2:15 而且以自己的身體廢掉冤仇，就是那記在律法上的規條，為要將兩下藉著自己造成一個新人，如此便成就了和睦。',
    '弗2:16 既在十字架上滅了冤仇，便藉這十字架使兩下歸為一體，與神和好了，',
    '弗2:17 並且來傳和平的福音給你們遠處的人，也給那近處的人。',
    '弗2:18 因為我們兩下藉著他被一個聖靈所感，得以進到父面前。',
    '弗2:19 這樣，你們不再作外人和客旅，是與聖徒同國，是神家裡的人了；',
    '弗2:20 並且被建造在使徒和先知的根基上，有基督耶穌自己為房角石，',
    '弗2:21 各（或作：全）房靠他聯絡得合式，漸漸成為主的聖殿。',
    '弗2:22 你們也靠他同被建造，成為神藉著聖靈居住的所在。',
    '弗3:1 因此，我─保羅為你們外邦人作了基督耶穌被囚的，替你們祈禱（此句乃照對十四節所加）。',
    '弗3:2 諒必你們曾聽見神賜恩給我，將關切你們的職分託付我，',
    '弗3:3 用啟示使我知道福音的奧祕，正如我以前略略寫過的。',
    '弗3:4 你們念了，就能曉得我深知基督的奧祕。',
    '弗3:5 這奧祕在以前的世代沒有叫人知道，像如今藉著聖靈啟示他的聖使徒和先知一樣。',
    '弗3:6 這奧祕就是外邦人在基督耶穌裡，藉著福音，得以同為後嗣，同為一體，同蒙應許。',
    '弗3:7 我作了這福音的執事，是照神的恩賜，這恩賜是照他運行的大能賜給我的。',
    '弗3:8 我本來比眾聖徒中最小的還小，然而他還賜我這恩典，叫我把基督那測不透的豐富傳給外邦人，',
    '弗3:9 又使眾人都明白，這歷代以來隱藏在創造萬物之神裡的奧祕是如何安排的，',
    '弗3:10 為要藉著教會使天上執政的、掌權的，現在得知神百般的智慧。',
    '弗3:11 這是照神從萬世以前，在我們主基督耶穌裡所定的旨意。',
    '弗3:12 我們因信耶穌，就在他裡面放膽無懼，篤信不疑的來到神面前。',
    '弗3:13 所以，我求你們不要因我為你們所受的患難喪膽，這原是你們的榮耀。',
    '弗3:14 因此，我在父面前屈膝，',
    '弗3:15 （天上地上的各（或作：全）家，都是從他得名。）',
    '弗3:16 求他按著他豐盛的榮耀，藉著他的靈，叫你們心裡的力量剛強起來，',
    '弗3:17 使基督因你們的信，住在你們心裡，叫你們的愛心有根有基，',
    '弗3:18 能以和眾聖徒一同明白基督的愛是何等長闊高深，',
    '弗3:19 並知道這愛是過於人所能測度的，便叫神一切所充滿的，充滿了你們。',
    '弗3:20 神能照著運行在我們心裡的大力充充足足的成就一切，超過我們所求所想的。',
    '弗3:21 但願他在教會中，並在基督耶穌裡，得著榮耀，直到世世代代，永永遠遠。阿們！',
    '弗4:1 我為主被囚的勸你們：既然蒙召，行事為人就當與蒙召的恩相稱。',
    '弗4:2 凡事謙虛、溫柔、忍耐，用愛心互相寬容，',
    '弗4:3 用和平彼此聯絡，竭力保守聖靈所賜合而為一的心。',
    '弗4:4 身體只有一個，聖靈只有一個，正如你們蒙召同有一個指望。',
    '弗4:5 一主，一信，一洗，',
    '弗4:6 一神，就是眾人的父，超乎眾人之上，貫乎眾人之中，也住在眾人之內。',
    '弗4:7 我們各人蒙恩，都是照基督所量給各人的恩賜。',
    '弗4:8 所以經上說：他升上高天的時候，擄掠了仇敵，將各樣的恩賜賞給人。',
    '弗4:9 （既說升上，豈不是先降在地下嗎﹖',
    '弗4:10 那降下的，就是遠升諸天之上要充滿萬有的。）',
    '弗4:11 他所賜的，有使徒，有先知，有傳福音的，有牧師和教師，',
    '弗4:12 為要成全聖徒，各盡其職，建立基督的身體，',
    '弗4:13 直等到我們眾人在真道上同歸於一，認識神的兒子，得以長大成人，滿有基督長成的身量，',
    '弗4:14 使我們不再作小孩子，中了人的詭計和欺騙的法術，被一切異教之風搖動，飄來飄去，就隨從各樣的異端；',
    '弗4:15 惟用愛心說誠實話，凡事長進，連於元首基督，',
    '弗4:16 全身都靠他聯絡得合式，百節各按各職，照著各體的功用彼此相助，便叫身體漸漸增長，在愛中建立自己。',
    '弗4:17 所以我說，且在主裡確實的說，你們行事不要再像外邦人存虛妄的心行事。',
    '弗4:18 他們心地昏昧，與神所賜的生命隔絕了，都因自己無知，心裡剛硬；',
    '弗4:19 良心既然喪盡，就放縱私慾，貪行種種的污穢。',
    '弗4:20 你們學了基督，卻不是這樣。',
    '弗4:21 如果你們聽過他的道，領了他的教，學了他的真理，',
    '弗4:22 就要脫去你們從前行為上的舊人，這舊人是因私慾的迷惑漸漸變壞的；',
    '弗4:23 又要將你們的心志改換一新，',
    '弗4:24 並且穿上新人；這新人是照著神的形像造的，有真理的仁義和聖潔。',
    '弗4:25 所以你們要棄絕謊言，各人與鄰舍說實話，因為我們是互相為肢體。',
    '弗4:26 生氣卻不要犯罪；不可含怒到日落，',
    '弗4:27 也不可給魔鬼留地步。',
    '弗4:28 從前偷竊的，不要再偷；總要勞力，親手做正經事，就可有餘分給那缺少的人。',
    '弗4:29 污穢的言語一句不可出口，只要隨事說造就人的好話，叫聽見的人得益處。',
    '弗4:30 不要叫神的聖靈擔憂；你們原是受了他的印記，等候得贖的日子來到。',
    '弗4:31 一切苦毒、惱恨、忿怒、嚷鬧、毀謗，並一切的惡毒（或作：陰毒），都當從你們中間除掉；',
    '弗4:32 並要以恩慈相待，存憐憫的心，彼此饒恕，正如神在基督裡饒恕了你們一樣。',
    '弗5:1 所以，你們該效法神，好像蒙慈愛的兒女一樣。',
    '弗5:2 也要憑愛心行事，正如基督愛我們，為我們捨了自己，當作馨香的供物和祭物，獻與神。',
    '弗5:3 至於淫亂並一切污穢，或是貪婪，在你們中間連提都不可，方合聖徒的體統。',
    '弗5:4 淫詞、妄語，和戲笑的話都不相宜；總要說感謝的話。',
    '弗5:5 因為你們確實的知道，無論是淫亂的，是污穢的，是有貪心的，在基督和神的國裡都是無分的。有貪心的，就與拜偶像的一樣。',
    '弗5:6 不要被人虛浮的話欺哄；因這些事，神的忿怒必臨到那悖逆之子。',
    '弗5:7 所以，你們不要與他們同夥。',
    '弗5:8 從前你們是暗昧的，但如今在主裡面是光明的，行事為人就當像光明的子女。',
    '弗5:9 光明所結的果子就是一切良善、公義、誠實。',
    '弗5:10 總要察驗何為主所喜悅的事。',
    '弗5:11 那暗昧無益的事，不要與人同行，倒要責備行這事的人；',
    '弗5:12 因為他們暗中所行的，就是提起來也是可恥的。',
    '弗5:13 凡事受了責備，就被光顯明出來，因為一切能顯明的就是光。',
    '弗5:14 所以主說：你這睡著的人當醒過來，從死裡復活！基督就要光照你了。',
    '弗5:15 你們要謹慎行事，不要像愚昧人，當像智慧人。',
    '弗5:16 要愛惜光陰，因為現今的世代邪惡。',
    '弗5:17 不要作糊塗人，要明白主的旨意如何。',
    '弗5:18 不要醉酒，酒能使人放蕩；乃要被聖靈充滿。',
    '弗5:19 當用詩章、頌詞、靈歌、彼此對說，口唱心和的讚美主。',
    '弗5:20 凡事要奉我們主耶穌基督的名常常感謝父神。',
    '弗5:21 又當存敬畏基督的心，彼此順服。',
    '弗5:22 你們作妻子的，當順服自己的丈夫，如同順服主。',
    '弗5:23 因為丈夫是妻子的頭，如同基督是教會的頭；他又是教會全體的救主。',
    '弗5:24 教會怎樣順服基督，妻子也要怎樣凡事順服丈夫。',
    '弗5:25 你們作丈夫的，要愛你們的妻子，正如基督愛教會，為教會捨己。',
    '弗5:26 要用水藉著道把教會洗淨，成為聖潔，',
    '弗5:27 可以獻給自己，作個榮耀的教會，毫無玷污、皺紋等類的病，乃是聖潔沒有瑕疵的。',
    '弗5:28 丈夫也當照樣愛妻子，如同愛自己的身子；愛妻子便是愛自己了。',
    '弗5:29 從來沒有人恨惡自己的身子，總是保養顧惜，正像基督待教會一樣，',
    '弗5:30 因我們是他身上的肢體（有古卷在此有：就是他的骨他的肉）。',
    '弗5:31 為這個緣故，人要離開父母，與妻子連合，二人成為一體。',
    '弗5:32 這是極大的奧祕，但我是指著基督和教會說的。',
    '弗5:33 然而，你們各人都當愛妻子，如同愛自己一樣。妻子也當敬重他的丈夫。',
    '弗6:1 你們作兒女的，要在主裡聽從父母，這是理所當然的。',
    '弗6:2 要孝敬父母，使你得福，在世長壽。這是第一條帶應許的誡命。',
    '弗6:3 併於上節。',
    '弗6:4 你們作父親的，不要惹兒女的氣，只要照著主的教訓和警戒養育他們。',
    '弗6:5 你們作僕人的，要懼怕戰兢，用誠實的心聽從你們肉身的主人，好像聽從基督一般。',
    '弗6:6 不要只在眼前事奉，像是討人喜歡的，要像基督的僕人，從心裡遵行神的旨意。',
    '弗6:7 甘心事奉，好像服事主，不像服事人。',
    '弗6:8 因為曉得各人所行的善事，不論是為奴的，是自主的，都必按所行的得主的賞賜。',
    '弗6:9 你們作主人的，待僕人也是一理，不要威嚇他們。因為知道，他們和你們同有一位主在天上；他並不偏待人。',
    '弗6:10 我還有末了的話：你們要靠著主，倚賴他的大能大力作剛強的人。',
    '弗6:11 要穿戴神所賜的全副軍裝，就能抵擋魔鬼的詭計。',
    '弗6:12 因我們並不是與屬血氣的爭戰（原文作摔跤；下同），乃是與那些執政的、掌權的、管轄這幽暗世界的，以及天空屬靈氣的惡魔爭戰。',
    '弗6:13 所以，要拿起神所賜的全副軍裝，好在磨難的日子抵擋仇敵，並且成就了一切，還能站立得住。',
    '弗6:14 所以要站穩了，用真理當作帶子束腰，用公義當作護心鏡遮胸，',
    '弗6:15 又用平安的福音當作預備走路的鞋穿在腳上。',
    '弗6:16 此外，又拿著信德當作籐牌，可以滅盡那惡者一切的火箭；',
    '弗6:17 並戴上救恩的頭盔，拿著聖靈的寶劍，就是神的道；',
    '弗6:18 靠著聖靈，隨時多方禱告祈求；並要在此警醒不倦，為眾聖徒祈求，',
    '弗6:19 也為我祈求，使我得著口才，能以放膽開口講明福音的奧祕，',
    '弗6:20 我為這福音的奧祕作了帶鎖鍊的使者，並使我照著當盡的本分放膽講論。',
    '弗6:21 今有所親愛、忠心事奉主的兄弟推基古，他要把我的事情，並我的景況如何全告訴你們，叫你們知道。',
    '弗6:22 我特意打發他到你們那裡去，好叫你們知道我們的光景，又叫他安慰你們的心。',
    '弗6:23 願平安、仁愛、信心從父神和主耶穌基督歸與弟兄們！',
    '弗6:24 並願所有誠心愛我們主耶穌基督的人都蒙恩惠！',
    '腓1:1 基督耶穌的僕人保羅和提摩太寫信給凡住腓立比、在基督耶穌裡的眾聖徒，和諸位監督，諸位執事。',
    '腓1:2 願恩惠、平安從神我們的父並主耶穌基督歸與你們！',
    '腓1:3 我每逢想念你們，就感謝我的神；',
    '腓1:4 每逢為你們眾人祈求的時候，常是歡歡喜喜的祈求。',
    '腓1:5 因為從頭一天直到如今，你們是同心合意的興旺福音。',
    '腓1:6 我深信那在你們心裡動了善工的，必成全這工，直到耶穌基督的日子。',
    '腓1:7 我為你們眾人有這樣的意念，原是應當的；因你們常在我心裡，無論我是在捆鎖之中，是辯明證實福音的時候，你們都與我一同得恩。',
    '腓1:8 我體會基督耶穌的心腸，切切的想念你們眾人；這是神可以給我作見證的。',
    '腓1:9 我所禱告的，就是要你們的愛心在知識和各樣見識上多而又多，',
    '腓1:10 使你們能分別是非（或作：喜愛那美好的事），作誠實無過的人，直到基督的日子；',
    '腓1:11 並靠著耶穌基督結滿了仁義的果子，叫榮耀稱讚歸與神。',
    '腓1:12 弟兄們，我願意你們知道，我所遭遇的事更是叫福音興旺，',
    '腓1:13 以致我受的捆鎖在御營全軍和其餘的人中，已經顯明是為基督的緣故。',
    '腓1:14 並且那在主裡的弟兄多半因我受的捆鎖就篤信不疑，越發放膽傳神的道，無所懼怕。',
    '腓1:15 有的傳基督是出於嫉妒紛爭，也有的是出於好意。',
    '腓1:16 這一等是出於愛心，知道我是為辯明福音設立的；',
    '腓1:17 那一等傳基督是出於結黨，並不誠實，意思要加增我捆鎖的苦楚。',
    '腓1:18 這有何妨呢﹖或是假意，或是真心，無論怎樣，基督究竟被傳開了。為此，我就歡喜，並且還要歡喜；',
    '腓1:19 因為我知道，這事藉著你們的祈禱和耶穌基督之靈的幫助，終必叫我得救。',
    '腓1:20 照著我所切慕、所盼望的，沒有一事叫我羞愧。只要凡事放膽，無論是生是死，總叫基督在我身上照常顯大。',
    '腓1:21 因我活著就是基督，我死了就有益處。',
    '腓1:22 但我在肉身活著，若成就我工夫的果子，我就不知道該挑選什麼。',
    '腓1:23 我正在兩難之間，情願離世與基督同在，因為這是好得無比的。',
    '腓1:24 然而，我在肉身活著，為你們更是要緊的。',
    '腓1:25 我既然這樣深信，就知道仍要住在世間，且與你們眾人同住，使你們在所信的道上又長進又喜樂，',
    '腓1:26 叫你們在基督耶穌裡的歡樂，因我再到你們那裡去，就越發加增。',
    '腓1:27 只要你們行事為人與基督的福音相稱，叫我或來見你們，或不在你們那裡，可以聽見你們的景況，知道你們同有一個心志，站立得穩，為所信的福音齊心努力。',
    '腓1:28 凡事不怕敵人的驚嚇，這是證明他們沉淪，你們得救都是出於神。',
    '腓1:29 因為你們蒙恩，不但得以信服基督，並要為他受苦。',
    '腓1:30 你們的爭戰，就與你們在我身上從前所看見、現在所聽見的一樣。',
    '腓2:1 所以，在基督裡若有什麼勸勉，愛心有什麼安慰，聖靈有什麼交通，心中有什麼慈悲憐憫，',
    '腓2:2 你們就要意念相同，愛心相同，有一樣的心思，有一樣的意念，使我的喜樂可以滿足。',
    '腓2:3 凡事不可結黨，不可貪圖虛浮的榮耀；只要存心謙卑，各人看別人比自己強。',
    '腓2:4 各人不要單顧自己的事，也要顧別人的事。',
    '腓2:5 你們當以基督耶穌的心為心：',
    '腓2:6 他本有神的形像，不以自己與神同等為強奪的；',
    '腓2:7 反倒虛己，取了奴僕的形像，成為人的樣式；',
    '腓2:8 既有人的樣子，就自己卑微，存心順服，以至於死，且死在十字架上。',
    '腓2:9 所以，神將他升為至高，又賜給他那超乎萬名之上的名，',
    '腓2:10 叫一切在天上的、地上的，和地底下的，因耶穌的名無不屈膝，',
    '腓2:11 無不口稱耶穌基督為主，使榮耀歸與父神。',
    '腓2:12 這樣看來，我親愛的弟兄，你們既是常順服的，不但我在你們那裡，就是我如今不在你們那裡，更是順服的，就當恐懼戰兢做成你們得救的工夫。',
    '腓2:13 因為你們立志行事都是神在你們心裡運行，為要成就他的美意。',
    '腓2:14 凡所行的，都不要發怨言，起爭論，',
    '腓2:15 使你們無可指摘，誠實無偽，在這彎曲悖謬的世代作神無瑕疵的兒女。你們顯在這世代中，好像明光照耀，',
    '腓2:16 將生命的道表明出來，叫我在基督的日子好誇我沒有空跑，也沒有徒勞。',
    '腓2:17 我以你們的信心為供獻的祭物，我若被澆奠在其上，也是喜樂，並且與你們眾人一同喜樂。',
    '腓2:18 你們也要照樣喜樂，並且與我一同喜樂。',
    '腓2:19 我靠主耶穌指望快打發提摩太去見你們，叫我知道你們的事，心裡就得著安慰。',
    '腓2:20 因為我沒有別人與我同心，實在掛念你們的事。',
    '腓2:21 別人都求自己的事，並不求耶穌基督的事。',
    '腓2:22 但你們知道提摩太的明證；他興旺福音，與我同勞，待我像兒子待父親一樣。',
    '腓2:23 所以，我一看出我的事要怎樣了結，就盼望立刻打發他去；',
    '腓2:24 但我靠著主自信我也必快去。',
    '腓2:25 然而，我想必須打發以巴弗提到你們那裡去。他是我的兄弟，與我一同做工，一同當兵，是你們所差遣的，也是供給我需用的。',
    '腓2:26 他很想念你們眾人，並且極其難過，因為你們聽見他病了。',
    '腓2:27 他實在是病了，幾乎要死；然而神憐恤他，不但憐恤他，也憐恤我，免得我憂上加憂。',
    '腓2:28 所以我越發急速打發他去，叫你們再見他，就可以喜樂，我也可以少些憂愁。',
    '腓2:29 故此，你們要在主裡歡歡樂樂的接待他，而且要尊重這樣的人；',
    '腓2:30 因他為做基督的工夫，幾乎至死，不顧性命，要補足你們供給我的不及之處。',
    '腓3:1 弟兄們，我還有話說，你們要靠主喜樂。我把這話再寫給你們，於我並不為難，於你們卻是妥當。',
    '腓3:2 應當防備犬類，防備作惡的，防備妄自行割的。',
    '腓3:3 因為真受割禮的，乃是我們這以神的靈敬拜、在基督耶穌裡誇口、不靠著肉體的。',
    '腓3:4 其實，我也可以靠肉體；若是別人想他可以靠肉體，我更可以靠著了。',
    '腓3:5 我第八天受割禮；我是以色列族、便雅憫支派的人，是希伯來人所生的希伯來人。就律法說，我是法利賽人；',
    '腓3:6 就熱心說，我是逼迫教會的；就律法上的義說，我是無可指摘的。',
    '腓3:7 只是我先前以為於我有益的，我現在因基督都當作有損的。',
    '腓3:8 不但如此，我也將萬事當作有損的，因我以認識我主基督耶穌為至寶。我為他已經丟棄萬事，看作糞土，為要得著基督；',
    '腓3:9 並且得以在他裡面，不是有自己因律法而得的義，乃是有信基督的義，就是因信神而來的義，',
    '腓3:10 使我認識基督，曉得他復活的大能，並且曉得和他一同受苦，效法他的死，',
    '腓3:11 或者我也得以從死裡復活。',
    '腓3:12 這不是說我已經得著了，已經完全了；我乃是竭力追求，或者可以得著基督耶穌所以得著我的（或作：所要我得的）。',
    '腓3:13 弟兄們，我不是以為自己已經得著了；我只有一件事，就是忘記背後，努力面前的，',
    '腓3:14 向著標竿直跑，要得神在基督耶穌裡從上面召我來得的獎賞。',
    '腓3:15 所以我們中間，凡是完全人總要存這樣的心；若在什麼事上存別樣的心，神也必以此指示你們。',
    '腓3:16 然而，我們到了什麼地步，就當照著什麼地步行。',
    '腓3:17 弟兄們，你們要一同效法我，也當留意看那些照我們榜樣行的人。',
    '腓3:18 因為有許多人行事是基督十字架的仇敵。我屢次告訴你們，現在又流淚的告訴你們：',
    '腓3:19 他們的結局就是沉淪；他們的神就是自己的肚腹。他們以自己的羞辱為榮耀，專以地上的事為念。',
    '腓3:20 我們卻是天上的國民，並且等候救主，就是主耶穌基督從天上降臨。',
    '腓3:21 他要按著那能叫萬有歸服自己的大能，將我們這卑賤的身體改變形狀，和他自己榮耀的身體相似。',
    '腓4:1 我所親愛、所想念的弟兄們，你們就是我的喜樂，我的冠冕。我親愛的弟兄，你們應當靠主站立得穩。',
    '腓4:2 我勸友阿爹和循都基，要在主裡同心。',
    '腓4:3 我也求你這真實同負一軛的，幫助這兩個女人，因為他們在福音上曾與我一同勞苦；還有革利免，並其餘和我一同做工的，他們的名字都在生命冊上。',
    '腓4:4 你們要靠主常常喜樂。我再說，你們要喜樂。',
    '腓4:5 當叫眾人知道你們謙讓的心。主已經近了。',
    '腓4:6 應當一無掛慮，只要凡事藉著禱告、祈求，和感謝，將你們所要的告訴神。',
    '腓4:7 神所賜、出人意外的平安必在基督耶穌裡保守你們的心懷意念。',
    '腓4:8 弟兄們，我還有未盡的話：凡是真實的、可敬的、公義的、清潔的、可愛的、有美名的，若有什麼德行，若有什麼稱讚，這些事你們都要思念。',
    '腓4:9 你們在我身上所學習的，所領受的，所聽見的，所看見的，這些事你們都要去行，賜平安的神就必與你們同在。',
    '腓4:10 我靠主大大的喜樂，因為你們思念我的心如今又發生；你們向來就思念我，只是沒得機會。',
    '腓4:11 我並不是因缺乏說這話；我無論在什麼景況都可以知足，這是我已經學會了。',
    '腓4:12 我知道怎樣處卑賤，也知道怎樣處豐富；或飽足，或飢餓；或有餘，或缺乏，隨事隨在，我都得了祕訣。',
    '腓4:13 我靠著那加給我力量的，凡事都能做。',
    '腓4:14 然而，你們和我同受患難原是美事。',
    '腓4:15 腓立比人哪，你們也知道我初傳福音離了馬其頓的時候，論到授受的事，除了你們以外，並沒有別的教會供給我。',
    '腓4:16 就是我在帖撒羅尼迦，你們也一次兩次的打發人供給我的需用。',
    '腓4:17 我並不求什麼餽送，所求的就是你們的果子漸漸增多，歸在你們的帳上。',
    '腓4:18 但我樣樣都有，並且有餘。我已經充足，因我從以巴弗提受了你們的餽送，當作極美的香氣，為神所收納、所喜悅的祭物。',
    '腓4:19 我的神必照他榮耀的豐富，在基督耶穌裡，使你們一切所需用的都充足。',
    '腓4:20 願榮耀歸給我們的父神，直到永永遠遠。阿們！',
    '腓4:21 請問在基督耶穌裡的各位聖徒安。在我這裡的眾弟兄都問你們安。',
    '腓4:22 眾聖徒都問你們安。在該撒家裡的人特特的問你們安。',
    '腓4:23 願主耶穌基督的恩常在你們心裡！',
    '西1:1 奉神旨意，作基督耶穌使徒的保羅和兄弟提摩太',
    '西1:2 寫信給歌羅西的聖徒，在基督裡有忠心的弟兄。願恩惠、平安從神我們的父歸與你們！',
    '西1:3 我們感謝神、我們主耶穌基督的父，常常為你們禱告；',
    '西1:4 因聽見你們在基督耶穌裡的信心，並向眾聖徒的愛心，',
    '西1:5 是為那給你們存在天上的盼望；這盼望就是你們從前在福音真理的道上所聽見的。',
    '西1:6 這福音傳到你們那裡，也傳到普天之下，並且結果，增長，如同在你們中間，自從你們聽見福音，真知道神恩惠的日子一樣。',
    '西1:7 正如你們從我們所親愛、一同作僕人的以巴弗所學的。他為我們（有古卷：你們）作了基督忠心的執事，',
    '西1:8 也把你們因聖靈所存的愛心告訴了我們。',
    '西1:9 因此，我們自從聽見的日子，也就為你們不住的禱告祈求，願你們在一切屬靈的智慧悟性上，滿心知道神的旨意；',
    '西1:10 好叫你們行事為人對得起主，凡事蒙他喜悅，在一切善事上結果子，漸漸的多知道神；',
    '西1:11 照他榮耀的權能，得以在各樣的力上加力，好叫你們凡事歡歡喜喜的忍耐寬容；',
    '西1:12 又感謝父，叫我們能與眾聖徒在光明中同得基業。',
    '西1:13 他救了我們脫離黑暗的權勢，把我們遷到他愛子的國裡；',
    '西1:14 我們在愛子裡得蒙救贖，罪過得以赦免。',
    '西1:15 愛子是那不能看見之神的像，是首生的，在一切被造的以先。',
    '西1:16 因為萬有都是靠他造的，無論是天上的，地上的；能看見的，不能看見的；或是有位的，主治的，執政的，掌權的；一概都是藉著他造的，又是為他造的。',
    '西1:17 他在萬有之先；萬有也靠他而立。',
    '西1:18 他也是教會全體之首。他是元始，是從死裡首先復生的，使他可以在凡事上居首位。',
    '西1:19 因為父喜歡叫一切的豐盛在他裡面居住。',
    '西1:20 既然藉著他在十字架上所流的血成就了和平，便藉著他叫萬有─無論是地上的、天上的─都與自己和好了。',
    '西1:21 你們從前與神隔絕，因著惡行，心裡與他為敵。',
    '西1:22 但如今他藉著基督的肉身受死，叫你們與自己和好，都成了聖潔，沒有瑕疵，無可責備，把你們引到自己面前。',
    '西1:23 只要你們在所信的道上恆心，根基穩固，堅定不移，不至被引動失去（原文是離開）福音的盼望。這福音就是你們所聽過的，也是傳與普天下萬人聽的（原文是凡受造的），我保羅也作了這福音的執事。',
    '西1:24 現在我為你們受苦，倒覺歡樂；並且為基督的身體，就是為教會，要在我肉身上補滿基督患難的缺欠。',
    '西1:25 我照神為你們所賜我的職分作了教會的執事，要把神的道理傳得全備，',
    '西1:26 這道理就是歷世歷代所隱藏的奧祕；但如今向他的聖徒顯明了。',
    '西1:27 神願意叫他們知道，這奧祕在外邦人中有何等豐盛的榮耀，就是基督在你們心裡成了有榮耀的盼望。',
    '西1:28 我們傳揚他，是用諸般的智慧，勸戒各人，教導各人，要把各人在基督裡完完全全的引到神面前。',
    '西1:29 我也為此勞苦，照著他在我裡面運用的大能盡心竭力。',
    '西2:1 我願意你們曉得，我為你們和老底嘉人，並一切沒有與我親自見面的人，是何等的盡心竭力；',
    '西2:2 要叫他們的心得安慰，因愛心互相聯絡，以致豐豐足足在悟性中有充足的信心，使他們真知神的奧祕，就是基督；',
    '西2:3 所積蓄的一切智慧知識，都在他裡面藏著。',
    '西2:4 我說這話，免得有人用花言巧語迷惑你們。',
    '西2:5 我身子雖與你們相離，心卻與你們同在，見你們循規蹈矩，信基督的心也堅固，我就歡喜了。',
    '西2:6 你們既然接受了主基督耶穌，就當遵他而行，',
    '西2:7 在他裡面生根建造，信心堅固，正如你們所領的教訓，感謝的心也更增長了。',
    '西2:8 你們要謹慎，恐怕有人用他的理學和虛空的妄言，不照著基督，乃照人間的遺傳和世上的小學就把你們擄去。',
    '西2:9 因為神本性一切的豐盛都有形有體的居住在基督裡面，',
    '西2:10 你們在他裡面也得了豐盛。他是各樣執政掌權者的元首。',
    '西2:11 你們在他裡面也受了不是人手所行的割禮，乃是基督使你們脫去肉體情慾的割禮。',
    '西2:12 你們既受洗與他一同埋葬，也就在此與他一同復活，都因信那叫他從死裡復活神的功用。',
    '西2:13 你們從前在過犯和未受割禮的肉體中死了，神赦免了你們（或作：我們）一切過犯，便叫你們與基督一同活過來；',
    '西2:14 又塗抹了在律例上所寫攻擊我們，有礙於我們的字據，把他撤去，釘在十字架上。',
    '西2:15 既將一切執政的、掌權的擄來，明顯給眾人看，就仗著十字架誇勝。',
    '西2:16 所以，不拘在飲食上，或節期、月朔、安息日都不可讓人論斷你們。',
    '西2:17 這些原是後事的影兒；那形體卻是基督。',
    '西2:18 不可讓人因著故意謙虛和敬拜天使，就奪去你們的獎賞。這等人拘泥在所見過的（有古卷作：這等人窺察所沒有見過的），隨著自己的慾心，無故的自高自大，',
    '西2:19 不持定元首。全身既然靠著他，筋節得以相助聯絡，就因神大得長進。',
    '西2:20 你們若是與基督同死，脫離了世上的小學，為什麼仍像在世俗中活著、服從那不可拿、不可嘗、不可摸等類的規條呢﹖',
    '西2:21 併於上節。',
    '西2:22 這都是照人所吩咐、所教導的。說到這一切，正用的時候就都敗壞了。',
    '西2:23 這些規條使人徒有智慧之名，用私意崇拜，自表謙卑，苦待己身，其實在克制肉體的情慾上是毫無功效。',
    '西3:1 所以，你們若真與基督一同復活，就當求在上面的事；那裡有基督坐在神的右邊。',
    '西3:2 你們要思念上面的事，不要思念地上的事。',
    '西3:3 因為你們已經死了，你們的生命與基督一同藏在神裡面。',
    '西3:4 基督是我們的生命，他顯現的時候，你們也要與他一同顯現在榮耀裡。',
    '西3:5 所以，要治死你們在地上的肢體，就如淫亂、污穢、邪情、惡慾，和貪婪。貪婪就與拜偶像一樣。',
    '西3:6 因這些事，神的忿怒必臨到那悖逆之子。',
    '西3:7 當你們在這些事中活著的時候，也曾這樣行過。',
    '西3:8 但現在你們要棄絕這一切的事，以及惱恨、忿怒、惡毒（或作：陰毒）、毀謗，並口中污穢的言語。',
    '西3:9 不要彼此說謊；因你們已經脫去舊人和舊人的行為，',
    '西3:10 穿上了新人。這新人在知識上漸漸更新，正如造他主的形像。',
    '西3:11 在此並不分希利尼人、猶太人，受割禮的、未受割禮的，化外人，西古提人，為奴的、自主的，惟有基督是包括一切，又住在各人之內。',
    '西3:12 所以，你們既是神的選民，聖潔蒙愛的人，就要存（原文作穿；下同）憐憫、恩慈、謙虛、溫柔、忍耐的心。',
    '西3:13 倘若這人與那人有嫌隙，總要彼此包容，彼此饒恕；主怎樣饒恕了你們，你們也要怎樣饒恕人。',
    '西3:14 在這一切之外，要存著愛心，愛心就是聯絡全德的。',
    '西3:15 又要叫基督的平安在你們心裡作主；你們也為此蒙召，歸為一體；且要存感謝的心。',
    '西3:16 當用各樣的智慧，把基督的道理豐豐富富的存在心裡（或作：當把基督的道理豐豐富富的存在心裡，以各樣的智慧），用詩章、頌詞、靈歌，彼此教導，互相勸戒，心被恩感，歌頌神。',
    '西3:17 無論做什麼，或說話或行事，都要奉主耶穌的名，藉著他感謝父神。',
    '西3:18 你們作妻子的，當順服自己的丈夫，這在主裡面是相宜的。',
    '西3:19 你們作丈夫的，要愛你們的妻子，不可苦待他們。',
    '西3:20 你們作兒女的，要凡事聽從父母，因為這是主所喜悅的。',
    '西3:21 你們作父親的，不要惹兒女的氣，恐怕他們失了志氣。',
    '西3:22 你們作僕人的，要凡事聽從你們肉身的主人，不要只在眼前事奉，像是討人喜歡的，總要存心誠實敬畏主。',
    '西3:23 無論做什麼，都要從心裡做，像是給主做的，不是給人做的，',
    '西3:24 因你們知道從主那裡必得著基業為賞賜；你們所事奉的乃是主基督。',
    '西3:25 那行不義的必受不義的報應；主並不偏待人。',
    '西4:1 你們作主人的，要公公平平的待僕人，因為知道你們也有一位主在天上。',
    '西4:2 你們要恆切禱告，在此警醒感恩。',
    '西4:3 也要為我們禱告，求神給我們開傳道的門，能以講基督的奧祕（我為此被捆鎖），',
    '西4:4 叫我按著所該說的話將這奧祕發明出來。',
    '西4:5 你們要愛惜光陰，用智慧與外人交往。',
    '西4:6 你們的言語要常常帶著和氣，好像用鹽調和，就可知道該怎樣回答各人。',
    '西4:7 有我親愛的兄弟推基古要將我一切的事都告訴你們。他是忠心的執事，和我一同作主的僕人，',
    '西4:8 我特意打發他到你們那裡去，好叫你們知道我們的光景，又叫他安慰你們的心。',
    '西4:9 我又打發一位親愛忠心的兄弟阿尼西母同去；他也是你們那裡的人。他們要把這裡一切的事都告訴你們。',
    '西4:10 與我一同坐監的亞里達古問你們安。巴拿巴的表弟馬可也問你們安。（說到這馬可，你們已經受了吩咐；他若到了你們那裡，你們就接待他。）',
    '西4:11 耶數又稱為猶士都，也問你們安。奉割禮的人中，只有這三個人是為神的國與我一同做工的，也是叫我心裡得安慰的。',
    '西4:12 有你們那裡的人，作基督耶穌僕人的以巴弗問你們安。他在禱告之間，常為你們竭力的祈求，願你們在神一切的旨意上得以完全，信心充足，能站立得穩。',
    '西4:13 他為你們和老底嘉並希拉波立的弟兄多多的勞苦，這是我可以給他作見證的。',
    '西4:14 所親愛的醫生路加和底馬問你們安。',
    '西4:15 請問老底嘉的弟兄和寧法，並他家裡的教會安。',
    '西4:16 你們念了這書信，便交給老底嘉的教會，叫他們也念；你們也要念從老底嘉來的書信。',
    '西4:17 要對亞基布說：務要謹慎，盡你從主所受的職分。',
    '西4:18 我保羅親筆問你們安。你們要記念我的捆鎖。願恩惠常與你們同在！',
    '帖前1:1 保羅、西拉、提摩太寫信給帖撒羅尼迦在父神和主耶穌基督裡的教會。願恩惠平安歸與你們！',
    '帖前1:2 我們為你們眾人常常感謝神，禱告的時候提到你們，',
    '帖前1:3 在神我們的父面前，不住的記念你們因信心所做的工夫，因愛心所受的勞苦，因盼望我們主耶穌基督所存的忍耐。',
    '帖前1:4 被神所愛的弟兄啊，我知道你們是蒙揀選的；',
    '帖前1:5 因為我們的福音傳到你們那裡，不獨在乎言語，也在乎權能和聖靈，並充足的信心，正如你們知道、我們在你們那裡，為你們的緣故是怎樣為人。',
    '帖前1:6 並且你們在大難之中，蒙了聖靈所賜的喜樂，領受真道就效法我們，也效法了主；',
    '帖前1:7 甚至你們作了馬其頓和亞該亞所有信主之人的榜樣。',
    '帖前1:8 因為主的道從你們那裡已經傳揚出來。你們向神的信心不但在馬其頓和亞該亞，就是在各處也都傳開了；所以不用我們說什麼話。',
    '帖前1:9 因為他們自己已經報明我們是怎樣進到你們那裡，你們是怎樣離棄偶像，歸向神，要服事那又真又活的神，',
    '帖前1:10 等候他兒子從天降臨，就是他從死裡復活的─那位救我們脫離將來忿怒的耶穌。',
    '帖前2:1 弟兄們，你們自己原曉得我們進到你們那裡並不是徒然的。',
    '帖前2:2 我們從前在腓立比被害受辱，這是你們知道的；然而還是靠我們的神放開膽量，在大爭戰中把神的福音傳給你們。',
    '帖前2:3 我們的勸勉不是出於錯誤，不是出於污穢，也不是用詭詐。',
    '帖前2:4 但神既然驗中了我們，把福音託付我們，我們就照樣講，不是要討人喜歡，乃是要討那察驗我們心的神喜歡。',
    '帖前2:5 因為我們從來沒有用過諂媚的話，這是你們知道的；也沒有藏著貪心，這是神可以作見證的。',
    '帖前2:6 我們作基督的使徒，雖然可以叫人尊重，卻沒有向你們或向別人求榮耀；',
    '帖前2:7 只在你們中間存心溫柔，如同母親乳養自己的孩子。',
    '帖前2:8 我們既是這樣愛你們，不但願意將神的福音給你們，連自己的性命也願意給你們，因你們是我們所疼愛的。',
    '帖前2:9 弟兄們，你們記念我們的辛苦勞碌，晝夜做工，傳神的福音給你們，免得叫你們一人受累。',
    '帖前2:10 我們向你們信主的人，是何等聖潔、公義、無可指摘，有你們作見證，也有神作見證。',
    '帖前2:11 你們也曉得我們怎樣勸勉你們，安慰你們，囑咐你們各人，好像父親待自己的兒女一樣，',
    '帖前2:12 要叫你們行事對得起那召你們進他國、得他榮耀的神。',
    '帖前2:13 為此，我們也不住的感謝神，因你們聽見我們所傳神的道就領受了；不以為是人的道，乃以為是神的道。這道實在是神的，並且運行在你們信主的人心中。',
    '帖前2:14 弟兄們，你們曾效法猶太中在基督耶穌裡神的各教會；因為你們也受了本地人的苦害，像他們受了猶太人的苦害一樣。',
    '帖前2:15 這猶太人殺了主耶穌和先知，又把我們趕出去。他們不得神的喜悅，且與眾人為敵；',
    '帖前2:16 不許我們傳道給外邦人使外邦人得救，常常充滿自己的罪惡。神的忿怒臨在他們身上已經到了極處。',
    '帖前2:17 弟兄們，我們暫時與你們離別，是面目離別，心裡卻不離別；我們極力的想法子，很願意見你們的面。',
    '帖前2:18 所以我們有意到你們那裡；我保羅有一兩次要去，只是撒但阻擋了我們。',
    '帖前2:19 我們的盼望和喜樂，並所誇的冠冕是什麼呢﹖豈不是我們主耶穌來的時候，你們在他面前站立得住嗎﹖',
    '帖前2:20 因為你們就是我們的榮耀，我們的喜樂。',
    '帖前3:1 我們既不能再忍，就願意獨自等在雅典，',
    '帖前3:2 打發我們的兄弟在基督福音上作神執事的（有古卷作：與神同工的）提摩太前去，堅固你們，並在你們所信的道上勸慰你們，',
    '帖前3:3 免得有人被諸般患難搖動。因為你們自己知道我們受患難原是命定的。',
    '帖前3:4 我們在你們那裡的時候，預先告訴你們，我們必受患難，以後果然應驗了，你們也知道。',
    '帖前3:5 為此，我既不能再忍，就打發人去，要曉得你們的信心如何，恐怕那誘惑人的到底誘惑了你們，叫我們的勞苦歸於徒然。',
    '帖前3:6 但提摩太剛才從你們那裡回來，將你們信心和愛心的好消息報給我們，又說你們常常記念我們，切切的想見我們，如同我們想見你們一樣。',
    '帖前3:7 所以弟兄們，我們在一切困苦患難之中，因著你們的信心就得了安慰。',
    '帖前3:8 你們若靠主站立得穩，我們就活了。',
    '帖前3:9 我們在神面前，因著你們甚是喜樂，為這一切喜樂，可用何等的感謝為你們報答神呢﹖',
    '帖前3:10 我們晝夜切切的祈求，要見你們的面，補滿你們信心的不足。',
    '帖前3:11 願神我們的父和我們的主耶穌一直引領我們到你們那裡去。',
    '帖前3:12 又願主叫你們彼此相愛的心，並愛眾人的心都能增長、充足，如同我們愛你們一樣；',
    '帖前3:13 好使你們當我們主耶穌同他眾聖徒來的時候，在我們父神面前，心裡堅固，成為聖潔，無可責備。',
    '帖前4:1 弟兄們，我還有話說：我們靠著主耶穌求你們，勸你們，你們既然受了我們的教訓，知道該怎樣行可以討神的喜悅，就要照你們現在所行的更加勉勵。',
    '帖前4:2 你們原曉得我們憑主耶穌傳給你們什麼命令。',
    '帖前4:3 神的旨意就是要你們成為聖潔，遠避淫行；',
    '帖前4:4 要你們各人曉得怎樣用聖潔、尊貴守著自己的身體。',
    '帖前4:5 不放縱私慾的邪情，像那不認識神的外邦人。',
    '帖前4:6 不要一個人在這事上越分，欺負他的弟兄；因為這一類的事，主必報應，正如我預先對你們說過，又切切囑咐你們的。',
    '帖前4:7 神召我們，本不是要我們沾染污穢，乃是要我們成為聖潔。',
    '帖前4:8 所以那棄絕的，不是棄絕人，乃是棄絕那賜聖靈給你們的神。',
    '帖前4:9 論到弟兄們相愛，不用人寫信給你們；因為你們自己蒙了神的教訓，叫你們彼此相愛。',
    '帖前4:10 你們向馬其頓全地的眾弟兄固然是這樣行，但我勸弟兄們要更加勉勵。',
    '帖前4:11 又要立志作安靜人，辦自己的事，親手做工，正如我們從前所吩咐你們的，',
    '帖前4:12 叫你們可以向外人行事端正，自己也就沒有什麼缺乏了。',
    '帖前4:13 論到睡了的人，我們不願意弟兄們不知道，恐怕你們憂傷，像那些沒有指望的人一樣。',
    '帖前4:14 我們若信耶穌死而復活了，那已經在耶穌裡睡了的人，神也必將他與耶穌一同帶來。',
    '帖前4:15 我們現在照主的話告訴你們一件事：我們這活著還存留到主降臨的人，斷不能在那已經睡了的人之先。',
    '帖前4:16 因為主必親自從天降臨，有呼叫的聲音和天使長的聲音，又有神的號吹響；那在基督裡死了的人必先復活。',
    '帖前4:17 以後我們這活著還存留的人必和他們一同被提到雲裡，在空中與主相遇。這樣，我們就要和主永遠同在。',
    '帖前4:18 所以，你們當用這些話彼此勸慰。',
    '帖前5:1 弟兄們，論到時候、日期，不用寫信給你們；',
    '帖前5:2 因為你們自己明明曉得，主的日子來到，好像夜間的賊一樣。',
    '帖前5:3 人正說平安穩妥的時候，災禍忽然臨到他們，如同產難臨到懷胎的婦人一樣。他們絕不能逃脫。',
    '帖前5:4 弟兄們，你們卻不在黑暗裡，叫那日子臨到你們像賊一樣。',
    '帖前5:5 你們都是光明之子，都是白晝之子。我們不是屬黑夜的，也不是屬幽暗的。',
    '帖前5:6 所以我們不要睡覺像別人一樣，總要警醒謹守。',
    '帖前5:7 因為睡了的人是在夜間睡，醉了的人是在夜間醉。',
    '帖前5:8 但我們既然屬乎白晝，就應當謹守，把信和愛當作護心鏡遮胸，把得救的盼望當作頭盔戴上。',
    '帖前5:9 因為神不是預定我們受刑，乃是預定我們藉著我們主耶穌基督得救。',
    '帖前5:10 他替我們死，叫我們無論醒著、睡著，都與他同活。',
    '帖前5:11 所以，你們該彼此勸慰，互相建立，正如你們素常所行的。',
    '帖前5:12 弟兄們，我們勸你們敬重那在你們中間勞苦的人，就是在主裡面治理你們、勸戒你們的。',
    '帖前5:13 又因他們所做的工，用愛心格外尊重他們。你們也要彼此和睦。',
    '帖前5:14 我們又勸弟兄們，要警戒不守規矩的人，勉勵灰心的人，扶助軟弱的人，也要向眾人忍耐。',
    '帖前5:15 你們要謹慎，無論是誰都不可以惡報惡；或是彼此相待，或是待眾人，常要追求良善。',
    '帖前5:16 要常常喜樂，',
    '帖前5:17 不住的禱告，',
    '帖前5:18 凡事謝恩；因為這是神在基督耶穌裡向你們所定的旨意。',
    '帖前5:19 不要消滅聖靈的感動；',
    '帖前5:20 不要藐視先知的講論。',
    '帖前5:21 但要凡事察驗，善美的要持守，',
    '帖前5:22 各樣的惡事要禁戒不做。',
    '帖前5:23 願賜平安的神親自使你們全然成聖！又願你們的靈與魂與身子得蒙保守，在我主耶穌基督降臨的時候，完全無可指摘！',
    '帖前5:24 那召你們的本是信實的，他必成就這事。',
    '帖前5:25 請弟兄們為我們禱告。',
    '帖前5:26 與眾弟兄親嘴問安，務要聖潔。',
    '帖前5:27 我指著主囑咐你們，要把這信念給眾弟兄聽。',
    '帖前5:28 願我主耶穌基督的恩常與你們同在！',
    '帖後1:1 保羅、西拉、提摩太寫信給帖撒羅尼迦在神我們的父與主耶穌基督裡的教會。',
    '帖後1:2 願恩惠、平安從父神和主耶穌基督歸與你們！',
    '帖後1:3 弟兄們，我們該為你們常常感謝神，這本是合宜的；因你們的信心格外增長，並且你們眾人彼此相愛的心也都充足。',
    '帖後1:4 甚至我們在神的各教會裡為你們誇口，都因你們在所受的一切逼迫患難中，仍舊存忍耐和信心。',
    '帖後1:5 這正是神公義判斷的明證，叫你們可算配得神的國；你們就是為這國受苦。',
    '帖後1:6 神既是公義的，就必將患難報應那加患難給你們的人；',
    '帖後1:7 也必使你們這受患難的人與我們同得平安。那時，主耶穌同他有能力的天使從天上在火焰中顯現，',
    '帖後1:8 要報應那不認識神和那不聽從我主耶穌福音的人。',
    '帖後1:9 他們要受刑罰，就是永遠沉淪，離開主的面和他權能的榮光。',
    '帖後1:10 這正是主降臨、要在他聖徒的身上得榮耀，又在一切信的人身上顯為希奇的那日子。（我們對你們作的見證，你們也信了。）',
    '帖後1:11 因此，我們常為你們禱告，願我們的神看你們配得過所蒙的召，又用大能成就你們一切所羨慕的良善和一切因信心所做的工夫；',
    '帖後1:12 叫我們主耶穌的名在你們身上得榮耀，你們也在他身上得榮耀，都照著我們的神並主耶穌基督的恩。',
    '帖後2:1 弟兄們，論到我們主耶穌基督降臨和我們到他那裡聚集，',
    '帖後2:2 我勸你們：無論有靈、有言語、有冒我名的書信，說主的日子現在（或作：就）到了，不要輕易動心，也不要驚慌。',
    '帖後2:3 人不拘用什麼法子，你們總不要被他誘惑；因為那日子以前，必有離道反教的事，並有那大罪人，就是沉淪之子，顯露出來。',
    '帖後2:4 他是抵擋主，高擡自己，超過一切稱為神的和一切受人敬拜的，甚至坐在神的殿裡，自稱是神。',
    '帖後2:5 我還在你們那裡的時候，曾把這些事告訴你們，你們不記得嗎﹖',
    '帖後2:6 現在你們也知道，那攔阻他的是什麼，是叫他到了的時候才可以顯露。',
    '帖後2:7 因為那不法的隱意已經發動，只是現在有一個攔阻的，等到那攔阻的被除去，',
    '帖後2:8 那時這不法的人必顯露出來。主耶穌要用口中的氣滅絕他，用降臨的榮光廢掉他。',
    '帖後2:9 這不法的人來，是照撒但的運動，行各樣的異能、神蹟，和一切虛假的奇事，',
    '帖後2:10 並且在那沉淪的人身上行各樣出於不義的詭詐；因他們不領受愛真理的心，使他們得救。',
    '帖後2:11 故此，神就給他們一個生發錯誤的心，叫他們信從虛謊，',
    '帖後2:12 使一切不信真理、倒喜愛不義的人都被定罪。',
    '帖後2:13 主所愛的弟兄們哪，我們本該常為你們感謝神；因為他從起初揀選了你們，叫你們因信真道，又被聖靈感動，成為聖潔，能以得救。',
    '帖後2:14 神藉我們所傳的福音召你們到這地步，好得著我們主耶穌基督的榮光。',
    '帖後2:15 所以，弟兄們，你們要站立得穩，凡所領受的教訓，不拘是我們口傳的，是信上寫的，都要堅守。',
    '帖後2:16 但願我們主耶穌基督和那愛我們、開恩將永遠的安慰並美好的盼望賜給我們的父神，',
    '帖後2:17 安慰你們的心，並且在一切善行善言上堅固你們。',
    '帖後3:1 弟兄們，我還有話說：請你們為我們禱告，好叫主的道理快快行開，得著榮耀，正如在你們中間一樣。',
    '帖後3:2 也叫我們脫離無理之惡人的手，因為人不都是有信心。',
    '帖後3:3 但主是信實的，要堅固你們，保護你們脫離那惡者（或作：脫離兇惡）。',
    '帖後3:4 我們靠主深信，你們現在是遵行我們所吩咐的，後來也必要遵行。',
    '帖後3:5 願主引導你們的心，叫你們愛神，並學基督的忍耐。',
    '帖後3:6 弟兄們，我們奉主耶穌基督的名吩咐你們，凡有弟兄不按規矩而行，不遵守從我們所受的教訓，就當遠離他。',
    '帖後3:7 你們自己原知道應當怎樣效法我們。因為我們在你們中間，未嘗不按規矩而行，',
    '帖後3:8 也未嘗白吃人的飯，倒是辛苦勞碌，晝夜做工，免得叫你們一人受累。',
    '帖後3:9 這並不是因我們沒有權柄，乃是要給你們作榜樣，叫你們效法我們。',
    '帖後3:10 我們在你們那裡的時候，曾吩咐你們說，若有人不肯做工，就不可吃飯。',
    '帖後3:11 因我們聽說，在你們中間有人不按規矩而行，什麼工都不做，反倒專管閒事。',
    '帖後3:12 我們靠主耶穌基督吩咐、勸戒這樣的人，要安靜做工，吃自己的飯。',
    '帖後3:13 弟兄們，你們行善不可喪志。',
    '帖後3:14 若有人不聽從我們這信上的話，要記下他，不和他交往，叫他自覺羞愧。',
    '帖後3:15 但不要以他為仇人，要勸他如弟兄。',
    '帖後3:16 願賜平安的主隨時隨事親自給你們平安！願主常與你們眾人同在！',
    '帖後3:17 我保羅親筆問你們安。凡我的信都以此為記，我的筆跡就是這樣。',
    '帖後3:18 願我們主耶穌基督的恩常與你們眾人同在！',
    '提前1:1 奉我們救主神和我們的盼望基督耶穌之命，作基督耶穌使徒的保羅，',
    '提前1:2 寫信給那因信主作我真兒子的提摩太。願恩惠、憐憫、平安從父神和我們主基督耶穌歸與你！',
    '提前1:3 我往馬其頓去的時候，曾勸你仍住在以弗所，好囑咐那幾個人不可傳異教，',
    '提前1:4 也不可聽從荒渺無憑的話語和無窮的家譜；這等事只生辯論，並不發明神在信上所立的章程。',
    '提前1:5 但命令的總歸就是愛；這愛是從清潔的心和無虧的良心，無偽的信心生出來的。',
    '提前1:6 有人偏離這些，反去講虛浮的話，',
    '提前1:7 想要作教法師，卻不明白自己所講說的所論定的。',
    '提前1:8 我們知道律法原是好的，只要人用得合宜；',
    '提前1:9 因為律法不是為義人設立的，乃是為不法和不服的，不虔誠和犯罪的，不聖潔和戀世俗的，弒父母和殺人的，',
    '提前1:10 行淫和親男色的，搶人口和說謊話的，並起假誓的，或是為別樣敵正道的事設立的。',
    '提前1:11 這是照著可稱頌之神交託我榮耀福音說的。',
    '提前1:12 我感謝那給我力量的我們主基督耶穌，因他以我有忠心，派我服事他。',
    '提前1:13 我從前是褻瀆神的，逼迫人的，侮慢人的；然而我還蒙了憐憫，因我是不信不明白的時候而做的。',
    '提前1:14 並且我主的恩是格外豐盛，使我在基督耶穌裡有信心和愛心。',
    '提前1:15 基督耶穌降世，為要拯救罪人。這話是可信的，是十分可佩服的。在罪人中我是個罪魁。',
    '提前1:16 然而，我蒙了憐憫，是因耶穌基督要在我這罪魁身上顯明他一切的忍耐，給後來信他得永生的人作榜樣。',
    '提前1:17 但願尊貴、榮耀歸與那不能朽壞、不能看見、永世的君王、獨一的神，直到永永遠遠。阿們！',
    '提前1:18 我兒提摩太啊，我照從前指著你的預言，將這命令交託你，叫你因此可以打那美好的仗。',
    '提前1:19 常存信心和無虧的良心。有人丟棄良心，就在真道上如同船破壞了一般。',
    '提前1:20 其中有許米乃和亞力山大；我已經把他們交給撒但，使他們受責罰就不再謗瀆了。',
    '提前2:1 我勸你，第一要為萬人懇求、禱告、代求、祝謝；',
    '提前2:2 為君王和一切在位的，也該如此，使我們可以敬虔、端正、平安無事的度日。',
    '提前2:3 這是好的，在神我們救主面前可蒙悅納。',
    '提前2:4 他願意萬人得救，明白真道。',
    '提前2:5 因為只有一位神，在神和人中間，只有一位中保，乃是降世為人的基督耶穌；',
    '提前2:6 他捨自己作萬人的贖價，到了時候，這事必證明出來。',
    '提前2:7 我為此奉派作傳道的，作使徒，作外邦人的師傅，教導他們相信，學習真道。我說的是真話，並不是謊言。',
    '提前2:8 我願男人無忿怒，無爭論（或作：疑惑），舉起聖潔的手，隨處禱告。',
    '提前2:9 又願女人廉恥、自守，以正派衣裳為妝飾，不以編髮、黃金、珍珠，和貴價的衣裳為妝飾；',
    '提前2:10 只要有善行，這才與自稱是敬神的女人相宜。',
    '提前2:11 女人要沉靜學道，一味的順服。',
    '提前2:12 我不許女人講道，也不許他轄管男人，只要沉靜。',
    '提前2:13 因為先造的是亞當，後造的是夏娃；',
    '提前2:14 且不是亞當被引誘，乃是女人被引誘，陷在罪裡。',
    '提前2:15 然而，女人若常存信心、愛心，又聖潔自守，就必在生產上得救。',
    '提前3:1 人若想要得監督的職分，就是羨慕善工。這話是可信的。',
    '提前3:2 作監督的，必須無可指責，只作一個婦人的丈夫，有節制，自守，端正，樂意接待遠人，善於教導；',
    '提前3:3 不因酒滋事，不打人，只要溫和，不爭競，不貪財；',
    '提前3:4 好好管理自己的家，使兒女凡事端莊順服（或作：端端莊莊地使兒女順服）。',
    '提前3:5 人若不知道管理自己的家，焉能照管神的教會呢﹖',
    '提前3:6 初入教的不可作監督，恐怕他自高自大，就落在魔鬼所受的刑罰裡。',
    '提前3:7 監督也必須在教外有好名聲，恐怕被人毀謗，落在魔鬼的網羅裡。',
    '提前3:8 作執事的，也是如此：必須端莊，不一口兩舌，不好喝酒，不貪不義之財；',
    '提前3:9 要存清潔的良心，固守真道的奧祕。',
    '提前3:10 這等人也要先受試驗，若沒有可責之處，然後叫他們作執事。',
    '提前3:11 女執事（原文是女人）也是如此：必須端莊，不說讒言，有節制，凡事忠心。',
    '提前3:12 執事只要作一個婦人的丈夫，好好管理兒女和自己的家。',
    '提前3:13 因為善作執事的，自己就得到美好的地步，並且在基督耶穌裡的真道上大有膽量。',
    '提前3:14 我指望快到你那裡去，所以先將這些事寫給你。',
    '提前3:15 倘若我耽延日久，你也可以知道在神的家中當怎樣行。這家就是永生神的教會，真理的柱石和根基。',
    '提前3:16 大哉，敬虔的奧祕！無人不以為然：就是神在肉身顯現，被聖靈稱義（或作：在靈性稱義），被天使看見，被傳於外邦，被世人信服，被接在榮耀裡。',
    '提前4:1 聖靈明說，在後來的時候，必有人離棄真道，聽從那引誘人的邪靈和鬼魔的道理。',
    '提前4:2 這是因為說謊之人的假冒；這等人的良心如同被熱鐵烙慣了一般。',
    '提前4:3 他們禁止嫁娶，又禁戒食物（或作：又叫人戒葷），就是神所造、叫那信而明白真道的人感謝著領受的。',
    '提前4:4 凡神所造的物都是好的，若感謝著領受，就沒有一樣可棄的，',
    '提前4:5 都因神的道和人的祈求成為聖潔了。',
    '提前4:6 你若將這些事提醒弟兄們，便是基督耶穌的好執事，在真道的話語和你向來所服從的善道上得了教育。',
    '提前4:7 只是要棄絕那世俗的言語和老婦荒渺的話，在敬虔上操練自己。',
    '提前4:8 操練身體，益處還少；惟獨敬虔，凡事都有益處，因有今生和來生的應許。',
    '提前4:9 這話是可信的，是十分可佩服的。',
    '提前4:10 我們勞苦努力，正是為此，因我們的指望在乎永生的神；他是萬人的救主，更是信徒的救主。',
    '提前4:11 這些事，你要吩咐人，也要教導人。',
    '提前4:12 不可叫人小看你年輕，總要在言語、行為、愛心、信心、清潔上，都作信徒的榜樣。',
    '提前4:13 你要以宣讀、勸勉、教導為念，直等到我來。',
    '提前4:14 你不要輕忽所得的恩賜，就是從前藉著預言、在眾長老按手的時候賜給你的。',
    '提前4:15 這些事你要殷勤去做，並要在此專心，使眾人看出你的長進來。',
    '提前4:16 你要謹慎自己和自己的教訓，要在這些事上恆心；因為這樣行，又能救自己，又能救聽你的人。',
    '提前5:1 不可嚴責老年人，只要勸他如同父親；勸少年人如同弟兄；',
    '提前5:2 勸老年婦女如同母親；勸少年婦女如同姊妹；總要清清潔潔的。',
    '提前5:3 要尊敬那真為寡婦的。',
    '提前5:4 若寡婦有兒女，或有孫子孫女，便叫他們先在自己家中學著行孝，報答親恩，因為這在神面前是可悅納的。',
    '提前5:5 那獨居無靠、真為寡婦的，是仰賴神，晝夜不住的祈求禱告。',
    '提前5:6 但那好宴樂的寡婦正活著的時候也是死的。',
    '提前5:7 這些事你要囑咐他們，叫他們無可指責。',
    '提前5:8 人若不看顧親屬，就是背了真道，比不信的人還不好，不看顧自己家裡的人，更是如此。',
    '提前5:9 寡婦記在冊子上，必須年紀到六十歲，從來只作一個丈夫的妻子，',
    '提前5:10 又有行善的名聲，就如養育兒女，接待遠人，洗聖徒的腳，救濟遭難的人，竭力行各樣善事。',
    '提前5:11 至於年輕的寡婦，就可以辭他；因為他們的情慾發動，違背基督的時候就想要嫁人。',
    '提前5:12 他們被定罪，是因廢棄了當初所許的願；',
    '提前5:13 並且他們又習慣懶惰，挨家閒遊；不但是懶惰，又說長道短，好管閒事，說些不當說的話。',
    '提前5:14 所以我願意年輕的寡婦嫁人，生養兒女，治理家務，不給敵人辱罵的把柄。',
    '提前5:15 因為已經有轉去隨從撒但的。',
    '提前5:16 信主的婦女，若家中有寡婦，自己就當救濟他們，不可累著教會，好使教會能救濟那真無倚靠的寡婦。',
    '提前5:17 那善於管理教會的長老，當以為配受加倍的敬奉；那勞苦傳道教導人的，更當如此。',
    '提前5:18 因為經上說：牛在場上踹穀的時候，不可籠住他的嘴；又說：工人得工價是應當的。',
    '提前5:19 控告長老的呈子，非有兩三個見證就不要收。',
    '提前5:20 犯罪的人，當在眾人面前責備他，叫其餘的人也可以懼怕。',
    '提前5:21 我在神和基督耶穌並蒙揀選的天使面前囑咐你：要遵守這些話，不可存成見，行事也不可有偏心。',
    '提前5:22 給人行按手的禮，不可急促；不要在別人的罪上有分，要保守自己清潔。',
    '提前5:23 因你胃口不清，屢次患病，再不要照常喝水，可以稍微用點酒。',
    '提前5:24 有些人的罪是明顯的，如同先到審判案前；有些人的罪是隨後跟了去的。',
    '提前5:25 這樣，善行也有明顯的，那不明顯的也不能隱藏。',
    '提前6:1 凡在軛下作僕人的，當以自己主人配受十分的恭敬，免得神的名和道理被人褻瀆。',
    '提前6:2 僕人有信道的主人，不可因為與他是弟兄就輕看他；更要加意服事他；因為得服事之益處的，是信道蒙愛的。你要以此教訓人，勸勉人。',
    '提前6:3 若有人傳異教，不服從我們主耶穌基督純正的話與那合乎敬虔的道理，',
    '提前6:4 他是自高自大，一無所知，專好問難，爭辯言詞，從此就生出嫉妒、紛爭、毀謗、妄疑，',
    '提前6:5 並那壞了心術、失喪真理之人的爭競。他們以敬虔為得利的門路。',
    '提前6:6 然而，敬虔加上知足的心便是大利了；',
    '提前6:7 因為我們沒有帶什麼到世上來，也不能帶什麼去。',
    '提前6:8 只要有衣有食，就當知足。',
    '提前6:9 但那些想要發財的人，就陷在迷惑、落在網羅和許多無知有害的私慾裡，叫人沉在敗壞和滅亡中。',
    '提前6:10 貪財是萬惡之根。有人貪戀錢財，就被引誘離了真道，用許多愁苦把自己刺透了。',
    '提前6:11 但你這屬神的人要逃避這些事，追求公義、敬虔、信心、愛心、忍耐、溫柔。',
    '提前6:12 你要為真道打那美好的仗，持定永生。你為此被召，也在許多見證人面前，已經作了那美好的見證。',
    '提前6:13 我在叫萬物生活的神面前，並在向本丟彼拉多作過那美好見證的基督耶穌面前囑咐你：',
    '提前6:14 要守這命令，毫不玷污，無可指責，直到我們的主耶穌基督顯現。',
    '提前6:15 到了日期，那可稱頌、獨有權能的萬王之王、萬主之主，',
    '提前6:16 就是那獨一不死、住在人不能靠近的光裡，是人未曾看見、也是不能看見的，要將他顯明出來。但願尊貴和永遠的權能都歸給他。阿們！',
    '提前6:17 你要囑咐那些今世富足的人，不要自高，也不要倚靠無定的錢財；只要倚靠那厚賜百物給我們享受的神。',
    '提前6:18 又要囑咐他們行善，在好事上富足，甘心施捨，樂意供給（或作：體貼）人，',
    '提前6:19 為自己積成美好的根基，預備將來，叫他們持定那真正的生命。',
    '提前6:20 提摩太啊，你要保守所託付你的，躲避世俗的虛談和那敵真道、似是而非的學問。',
    '提前6:21 已經有人自稱有這學問，就偏離了真道。願恩惠常與你們同在！',
    '提後1:1 奉神旨意，照著在基督耶穌裡生命的應許，作基督耶穌使徒的保羅，',
    '提後1:2 寫信給我親愛的兒子提摩太。願恩惠、憐憫、平安從父神和我們主基督耶穌歸與你！',
    '提後1:3 我感謝神，就是我接續祖先用清潔的良心所事奉的神。祈禱的時候，不住的想念你，',
    '提後1:4 記念你的眼淚，晝夜切切的想要見你，好叫我滿心快樂。',
    '提後1:5 想到你心裡無偽之信，這信是先在你外祖母羅以和你母親友尼基心裡的，我深信也在你的心裡。',
    '提後1:6 為此我提醒你，使你將神藉我按手所給你的恩賜再如火挑旺起來。',
    '提後1:7 因為神賜給我們，不是膽怯的心，乃是剛強、仁愛、謹守的心。',
    '提後1:8 你不要以給我們的主作見證為恥，也不要以我這為主被囚的為恥；總要按神的能力，與我為福音同受苦難。',
    '提後1:9 神救了我們，以聖召召我們，不是按我們的行為，乃是按他的旨意和恩典；這恩典是萬古之先，在基督耶穌裡賜給我們的，',
    '提後1:10 但如今藉著我們救主基督耶穌的顯現才表明出來了。他已經把死廢去，藉著福音，將不能壞的生命彰顯出來。',
    '提後1:11 我為這福音奉派作傳道的，作使徒，作師傅。',
    '提後1:12 為這緣故，我也受這些苦難。然而我不以為恥；因為知道我所信的是誰，也深信他能保全我所交付他的（或作：他所交託我的），直到那日。',
    '提後1:13 你從我聽的那純正話語的規模，要用在基督耶穌裡的信心和愛心，常常守著。',
    '提後1:14 從前所交託你的善道，你要靠著那住在我們裡面的聖靈牢牢的守著。',
    '提後1:15 凡在亞西亞的人都離棄我，這是你知道的，其中有腓吉路和黑摩其尼。',
    '提後1:16 願主憐憫阿尼色弗一家的人；因他屢次使我暢快，不以我的鎖鍊為恥，',
    '提後1:17 反倒在羅馬的時候，殷勤的找我，並且找著了。',
    '提後1:18 願主使他在那日得主的憐憫。他在以弗所怎樣多多的服事我，是你明明知道的。',
    '提後2:1 我兒啊，你要在基督耶穌的恩典上剛強起來。',
    '提後2:2 你在許多見證人面前聽見我所教訓的，也要交託那忠心能教導別人的人。',
    '提後2:3 你要和我同受苦難，好像基督耶穌的精兵。',
    '提後2:4 凡在軍中當兵的，不將世務纏身，好叫那招他當兵的人喜悅。',
    '提後2:5 人若在場上比武，非按規矩，就不能得冠冕。',
    '提後2:6 勞力的農夫，理當先得糧食。',
    '提後2:7 我所說的話你要思想，因為凡事主必給你聰明。',
    '提後2:8 你要記念耶穌基督乃是大衛的後裔，他從死裡復活，正合乎我所傳的福音。',
    '提後2:9 我為這福音受苦難，甚至被捆綁，像犯人一樣。然而神的道卻不被捆綁。',
    '提後2:10 所以我為選民凡事忍耐，叫他們也可以得著那在基督耶穌裡的救恩和永遠的榮耀。',
    '提後2:11 有可信的話說：我們若與基督同死，也必與他同活；',
    '提後2:12 我們若能忍耐，也必和他一同作王；我們若不認他，他也必不認我們；',
    '提後2:13 我們縱然失信，他仍是可信的，因為他不能背乎自己。',
    '提後2:14 你要使眾人回想這些事，在主面前囑咐他們：不可為言語爭辯；這是沒有益處的，只能敗壞聽見的人。',
    '提後2:15 你當竭力在神面前得蒙喜悅，作無愧的工人，按著正意分解真理的道。',
    '提後2:16 但要遠避世俗的虛談，因為這等人必進到更不敬虔的地步。',
    '提後2:17 他們的話如同毒瘡，越爛越大；其中有許米乃和腓理徒，',
    '提後2:18 他們偏離了真道，說復活的事已過，就敗壞好些人的信心。',
    '提後2:19 然而，神堅固的根基立住了；上面有這印記說：主認識誰是他的人；又說：凡稱呼主名的人總要離開不義。',
    '提後2:20 在大戶人家，不但有金器銀器，也有木器瓦器；有作為貴重的，有作為卑賤的。',
    '提後2:21 人若自潔，脫離卑賤的事，就必作貴重的器皿，成為聖潔，合乎主用，預備行各樣的善事。',
    '提後2:22 你要逃避少年的私慾，同那清心禱告主的人追求公義、信德、仁愛、和平。',
    '提後2:23 惟有那愚拙無學問的辯論，總要棄絕，因為知道這等事是起爭競的。',
    '提後2:24 然而主的僕人不可爭競，只要溫溫和和的待眾人，善於教導，存心忍耐，',
    '提後2:25 用溫柔勸戒那抵擋的人；或者神給他們悔改的心，可以明白真道，',
    '提後2:26 叫他們這已經被魔鬼任意擄去的，可以醒悟，脫離他的網羅。',
    '提後3:1 你該知道，末世必有危險的日子來到。',
    '提後3:2 因為那時人要專顧自己、貪愛錢財、自誇、狂傲、謗讟、違背父母、忘恩負義、心不聖潔、',
    '提後3:3 無親情、不解怨、好說讒言、不能自約、性情兇暴、不愛良善、',
    '提後3:4 賣主賣友、任意妄為、自高自大、愛宴樂、不愛神，',
    '提後3:5 有敬虔的外貌，卻背了敬虔的實意；這等人你要躲開。',
    '提後3:6 那偷進人家、牢籠無知婦女的，正是這等人。這些婦女擔負罪惡，被各樣的私慾引誘，',
    '提後3:7 常常學習，終久不能明白真道。',
    '提後3:8 從前雅尼和佯庇怎樣敵擋摩西，這等人也怎樣敵擋真道。他們的心地壞了，在真道上是可廢棄的。',
    '提後3:9 然而他們不能再這樣敵擋；因為他們的愚昧必在眾人面前顯露出來，像那二人一樣。',
    '提後3:10 但你已經服從了我的教訓、品行、志向、信心、寬容、愛心、忍耐，',
    '提後3:11 以及我在安提阿、以哥念、路司得所遭遇的逼迫，苦難。我所忍受是何等的逼迫；但從這一切苦難中，主都把我救出來了。',
    '提後3:12 不但如此，凡立志在基督耶穌裡敬虔度日的也都要受逼迫。',
    '提後3:13 只是作惡的和迷惑人的，必越久越惡，他欺哄人，也被人欺哄。',
    '提後3:14 但你所學習的，所確信的，要存在心裡；因為你知道是跟誰學的，',
    '提後3:15 並且知道你是從小明白聖經，這聖經能使你因信基督耶穌，有得救的智慧。',
    '提後3:16 聖經都是神所默示的（或作：凡神所默示的聖經），於教訓、督責、使人歸正、教導人學義都是有益的，',
    '提後3:17 叫屬神的人得以完全，預備行各樣的善事。',
    '提後4:1 我在神面前，並在將來審判活人死人的基督耶穌面前，憑著他的顯現和他的國度囑咐你：',
    '提後4:2 務要傳道，無論得時不得時，總要專心；並用百般的忍耐，各樣的教訓，責備人、警戒人、勸勉人。',
    '提後4:3 因為時候要到，人必厭煩純正的道理，耳朵發癢，就隨從自己的情慾，增添好些師傅，',
    '提後4:4 並且掩耳不聽真道，偏向荒渺的言語。',
    '提後4:5 你卻要凡事謹慎，忍受苦難，作傳道的工夫，盡你的職分。',
    '提後4:6 我現在被澆奠，我離世的時候到了。',
    '提後4:7 那美好的仗我已經打過了，當跑的路我已經跑盡了，所信的道我已經守住了。',
    '提後4:8 從此以後，有公義的冠冕為我存留，就是按著公義審判的主到了那日要賜給我的；不但賜給我，也賜給凡愛慕他顯現的人。',
    '提後4:9 你要趕緊的到我這裡來。',
    '提後4:10 因為底馬貪愛現今的世界，就離棄我往帖撒羅尼迦去了，革勒士往加拉太去，提多往撻馬太去，',
    '提後4:11 獨有路加在我這裡。你來的時候，要把馬可帶來，因為他在傳道（或作：服事我）的事上於我有益處。',
    '提後4:12 我已經打發推基古往以弗所去。',
    '提後4:13 我在特羅亞留於加布的那件外衣，你來的時候可以帶來，那些書也要帶來，更要緊的是那些皮卷。',
    '提後4:14 銅匠亞力山大多多的害我；主必照他所行的報應他。',
    '提後4:15 你也要防備他，因為他極力敵擋了我們的話。',
    '提後4:16 我初次申訴，沒有人前來幫助，竟都離棄我；但願這罪不歸與他們。',
    '提後4:17 惟有主站在我旁邊，加給我力量，使福音被我盡都傳明，叫外邦人都聽見；我也從獅子口裡被救出來。',
    '提後4:18 主必救我脫離諸般的兇惡，也必救我進他的天國。願榮耀歸給他，直到永永遠遠。阿們。',
    '提後4:19 問百基拉、亞居拉，和阿尼色弗一家的人安。',
    '提後4:20 以拉都在哥林多住下了。特羅非摩病了，我就留他在米利都。',
    '提後4:21 你要趕緊在冬天以前到我這裡來。有友布羅、布田、利奴、革老底亞，和眾弟兄都問你安。',
    '提後4:22 願主與你的靈同在。願恩惠常與你們同在！',
    '多1:1 神的僕人，耶穌基督的使徒保羅，憑著神選民的信心與敬虔真理的知識，',
    '多1:2 盼望那無謊言的神在萬古之先所應許的永生，',
    '多1:3 到了日期，藉著傳揚的工夫把他的道顯明了；這傳揚的責任是按著神我們救主的命令交託了我。',
    '多1:4 現在寫信給提多，就是照著我們共信之道作我真兒子的。願恩惠、平安從父神和我們的救主基督耶穌歸與你！',
    '多1:5 我從前留你在革哩底，是要你將那沒有辦完的事都辦整齊了，又照我所吩咐你的，在各城設立長老。',
    '多1:6 若有無可指責的人，只作一個婦人的丈夫，兒女也是信主的，沒有人告他們是放蕩不服約束的，就可以設立。',
    '多1:7 監督既是神的管家，必須無可指責，不任性，不暴躁，不因酒滋事，不打人，不貪無義之財；',
    '多1:8 樂意接待遠人，好善，莊重，公平，聖潔自持；',
    '多1:9 堅守所教真實的道理，就能將純正的教訓勸化人，又能把爭辯的人駁倒了。',
    '多1:10 因為有許多人不服約束，說虛空話欺哄人；那奉割禮的更是這樣。',
    '多1:11 這些人的口總要堵住。他們因貪不義之財，將不該教導的教導人，敗壞人的全家。',
    '多1:12 有革哩底人中的一個本地先知說：革哩底人常說謊話，乃是惡獸，又饞又懶。',
    '多1:13 這個見證是真的。所以，你要嚴嚴的責備他們，使他們在真道上純全無疵，',
    '多1:14 不聽猶太人荒渺的言語和離棄真道之人的誡命。',
    '多1:15 在潔淨的人，凡物都潔淨；在污穢不信的人，什麼都不潔淨，連心地和天良也都污穢了。',
    '多1:16 他們說是認識神，行事卻和他相背；本是可憎惡的，是悖逆的，在各樣善事上是可廢棄的。',
    '多2:1 但你所講的總要合乎那純正的道理。',
    '多2:2 勸老年人要有節制、端莊、自守，在信心、愛心、忍耐上都要純全無疵。',
    '多2:3 又勸老年婦人，舉止行動要恭敬，不說讒言，不給酒作奴僕，用善道教訓人，',
    '多2:4 好指教少年婦人，愛丈夫，愛兒女，',
    '多2:5 謹守，貞潔，料理家務，待人有恩，順服自己的丈夫，免得神的道理被毀謗。',
    '多2:6 又勸少年人要謹守。',
    '多2:7 你自己凡事要顯出善行的榜樣；在教訓上要正直、端莊，',
    '多2:8 言語純全，無可指責，叫那反對的人，既無處可說我們的不是，便自覺羞愧。',
    '多2:9 勸僕人要順服自己的主人，凡事討他的喜歡，不可頂撞他，',
    '多2:10 不可私拿東西；要顯為忠誠，以致凡事尊榮我們救主神的道。',
    '多2:11 因為神救眾人的恩典已經顯明出來，',
    '多2:12 教訓我們除去不敬虔的心和世俗的情慾，在今世自守、公義、敬虔度日，',
    '多2:13 等候所盼望的福，並等候至大的神和我們（或作：神─我們）救主耶穌基督的榮耀顯現。',
    '多2:14 他為我們捨了自己，要贖我們脫離一切罪惡，又潔淨我們，特作自己的子民，熱心為善。',
    '多2:15 這些事你要講明，勸戒人，用各等權柄責備人；不可叫人輕看你。',
    '多3:1 你要提醒眾人，叫他們順服作官的、掌權的，遵他的命，預備行各樣的善事。',
    '多3:2 不要毀謗，不要爭競，總要和平，向眾人大顯溫柔。',
    '多3:3 我們從前也是無知、悖逆、受迷惑、服事各樣私慾，和宴樂，常存惡毒（或作：陰毒）嫉妒的心，是可恨的，又是彼此相恨。',
    '多3:4 但到了神─我們救主的恩慈和他向人所施的慈愛顯明的時候，',
    '多3:5 他便救了我們；並不是因我們自己所行的義，乃是照他的憐憫，藉著重生的洗和聖靈的更新。',
    '多3:6 聖靈就是神藉著耶穌基督我們救主厚厚澆灌在我們身上的，',
    '多3:7 好叫我們因他的恩得稱為義，可以憑著永生的盼望成為後嗣（或作：可以憑著盼望承受永生）。',
    '多3:8 這話是可信的。我也願你把這些事切切實實的講明，使那些已信神的人留心做正經事業（或作：留心行善）。這都是美事，並且於人有益。',
    '多3:9 要遠避無知的辯論和家譜的空談，以及紛爭，並因律法而起的爭競，因為這都是虛妄無益的。',
    '多3:10 分門結黨的人，警戒過一兩次，就要棄絕他。',
    '多3:11 因為知道這等人已經背道，犯了罪，自己明知不是，還是去做。',
    '多3:12 我打發亞提馬或是推基古到你那裡去的時候，你要趕緊往尼哥波立去見我，因為我已經定意在那裡過冬。',
    '多3:13 你要趕緊給律師西納和亞波羅送行，叫他們沒有缺乏。',
    '多3:14 並且我們的人要學習正經事業（或作：要學習行善），預備所需用的，免得不結果子。',
    '多3:15 同我在一處的人都問你安。請代問那些因有信心愛我們的人安。願恩惠常與你們眾人同在！',
    '門1:1 為基督耶穌被囚的保羅，同兄弟提摩太寫信給我們所親愛的同工腓利門，',
    '門1:2 和妹子亞腓亞並與我們同當兵的亞基布，以及在你家的教會。',
    '門1:3 願恩惠、平安從神我們的父和主耶穌基督歸與你們！',
    '門1:4 我禱告的時候提到你，常為你感謝我的神；',
    '門1:5 因聽說你的愛心並你向主耶穌和眾聖徒的信心（或作：因聽說你向主耶穌和眾聖徒有愛心有信心）。',
    '門1:6 願你與人所同有的信心顯出功效，使人知道你們各樣善事都是為基督做的。',
    '門1:7 兄弟啊，我為你的愛心，大有快樂，大得安慰，因眾聖徒的心從你得了暢快。',
    '門1:8 我雖然靠著基督能放膽吩咐你合宜的事；',
    '門1:9 然而像我這有年紀的保羅，現在又是為基督耶穌被囚的，寧可憑著愛心求你，',
    '門1:10 就是為我在捆鎖中所生的兒子阿尼西母（就是有益處的意思）求你。',
    '門1:11 他從前於你沒有益處，但如今於你我都有益處。',
    '門1:12 我現在打發他親自回你那裡去，他是我心上的人。',
    '門1:13 我本來有意將他留下，在我為福音所受的捆鎖中替你伺候我。',
    '門1:14 但不知道你的意思，我就不願意這樣行，叫你的善行不是出於勉強，乃是出於甘心。',
    '門1:15 他暫時離開你，或者是叫你永遠得著他，',
    '門1:16 不再是奴僕，乃是高過奴僕，是親愛的兄弟。在我實在是如此，何況在你呢！這也不拘是按肉體說，是按主說，',
    '門1:17 你若以我為同伴，就收納他，如同收納我一樣。',
    '門1:18 他若虧負你，或欠你什麼，都歸在我的帳上，',
    '門1:19 我必償還。這是我保羅親筆寫的。我並不用對你說，連你自己也是虧欠於我。',
    '門1:20 兄弟啊，望你使我在主裡因你得快樂（或作：益處）並望你使我的心在基督裡得暢快。',
    '門1:21 我寫信給你，深信你必順服，知道你所要行的，必過於我所說的。',
    '門1:22 此外你還要給我預備住處；因為我盼望藉著你們的禱告，必蒙恩到你們那裡去。',
    '門1:23 為基督耶穌與我同坐監的以巴弗問你安。',
    '門1:24 與我同工的馬可、亞里達古、底馬、路加、也都問你安。',
    '門1:25 願我們主耶穌基督的恩常在你的心裡。阿們！',
    '來1:1 神既在古時藉著眾先知多次多方的曉諭列祖，',
    '來1:2 就在這末世藉著他兒子曉諭我們；又早已立他為承受萬有的，也曾藉著他創造諸世界。',
    '來1:3 他是神榮耀所發的光輝，是神本體的真像，常用他權能的命令托住萬有。他洗淨了人的罪，就坐在高天至大者的右邊。',
    '來1:4 他所承受的名，既比天使的名更尊貴，就遠超過天使。',
    '來1:5 所有的天使，神從來對哪一個說，你是我的兒子，我今日生你﹖又指著哪一個說：我要作他的父，他要作我的子﹖',
    '來1:6 再者，神使長子到世上來的時候（或作：神再使長子到世上來的時候），就說：神的使者都要拜他。',
    '來1:7 論到使者，又說：神以風為使者，以火焰為僕役；',
    '來1:8 論到子卻說：神啊，你的寶座是永永遠遠的；你的國權是正直的。',
    '來1:9 你喜愛公義，恨惡罪惡；所以神，就是你的神，用喜樂油膏你，勝過膏你的同伴；',
    '來1:10 又說：主啊，你起初立了地的根基；天也是你手所造的。',
    '來1:11 天地都要滅沒，你卻要長存。天地都要像衣服漸漸舊了；',
    '來1:12 你要將天地捲起來，像一件外衣，天地就都改變了。惟有你永不改變；你的年數沒有窮盡。',
    '來1:13 所有的天使，神從來對哪一個說：你坐在我的右邊，等我使你仇敵作你的腳凳﹖',
    '來1:14 天使豈不都是服役的靈、奉差遣為那將要承受救恩的人效力嗎﹖',
    '來2:1 所以，我們當越發鄭重所聽見的道理，恐怕我們隨流失去。',
    '來2:2 那藉著天使所傳的話既是確定的；凡干犯悖逆的都受了該受的報應。',
    '來2:3 我們若忽略這麼大的救恩，怎能逃罪呢﹖這救恩起先是主親自講的，後來是聽見的人給我們證實了。',
    '來2:4 神又按自己的旨意，用神蹟、奇事和百般的異能，並聖靈的恩賜，同他們作見證。',
    '來2:5 我們所說將來的世界，神原沒有交給天使管轄。',
    '來2:6 但有人在經上某處證明說：人算什麼，你竟顧念他﹖世人算什麼，你竟眷顧他﹖',
    '來2:7 你叫他比天使微小一點（或作：你叫他暫時比天使小），賜他榮耀尊貴為冠冕，並將你手所造的都派他管理，',
    '來2:8 叫萬物都服在他的腳下。既叫萬物都服他，就沒有剩下一樣不服他的。只是如今我們還不見萬物都服他。',
    '來2:9 惟獨見那成為比天使小一點的耶穌（或作：惟獨見耶穌暫時比天使小）；因為受死的苦，就得了尊貴榮耀為冠冕，叫他因著神的恩，為人人嘗了死味。',
    '來2:10 原來那為萬物所屬為萬物所本的，要領許多的兒子進榮耀裡去，使救他們的元帥，因受苦難得以完全，本是合宜的。',
    '來2:11 因那使人成聖的和那些得以成聖的，都是出於一。所以，他稱他們為弟兄也不以為恥，',
    '來2:12 說：我要將你的名傳與我的弟兄，在會中我要頌揚你；',
    '來2:13 又說：我要倚賴他；又說：看哪，我與神所給我的兒女。',
    '來2:14 兒女既同有血肉之體，他也照樣親自成了血肉之體，特要藉著死敗壞那掌死權的，就是魔鬼，',
    '來2:15 並要釋放那些一生因怕死而為奴僕的人。',
    '來2:16 他並不救拔天使，乃是救拔亞伯拉罕的後裔。',
    '來2:17 所以，他凡事該與他的弟兄相同，為要在神的事上成為慈悲忠信的大祭司，為百姓的罪獻上挽回祭。',
    '來2:18 他自己既然被試探而受苦，就能搭救被試探的人。',
    '來3:1 同蒙天召的聖潔弟兄啊，你們應當思想我們所認為使者、為大祭司的耶穌。',
    '來3:2 他為那設立他的盡忠，如同摩西在神的全家盡忠一樣。',
    '來3:3 他比摩西算是更配多得榮耀，好像建造房屋的比房屋更尊榮；',
    '來3:4 因為房屋都必有人建造，但建造萬物的就是神。',
    '來3:5 摩西為僕人，在神的全家誠然盡忠，為要證明將來必傳說的事。',
    '來3:6 但基督為兒子，治理神的家；我們若將可誇的盼望和膽量堅持到底，便是他的家了。',
    '來3:7 聖靈有話說：你們今日若聽他的話，',
    '來3:8 就不可硬著心，像在曠野惹他發怒、試探他的時候一樣。',
    '來3:9 在那裡，你們的祖宗試我探我，並且觀看我的作為有四十年之久。',
    '來3:10 所以，我厭煩那世代的人，說：他們心裡常常迷糊，竟不曉得我的作為！',
    '來3:11 我就在怒中起誓說；他們斷不可進入我的安息。',
    '來3:12 弟兄們，你們要謹慎，免得你們中間或有人存著不信的惡心，把永生神離棄了。',
    '來3:13 總要趁著還有今日，天天彼此相勸，免得你們中間有人被罪迷惑，心裡就剛硬了。',
    '來3:14 我們若將起初確實的信心堅持到底，就在基督裡有分了。',
    '來3:15 經上說：你們今日若聽他的話，就不可硬著心，像惹他發怒的日子一樣。',
    '來3:16 那時，聽見他話惹他發怒的是誰呢﹖豈不是跟著摩西從埃及出來的眾人嗎﹖',
    '來3:17 神四十年之久，又厭煩誰呢﹖豈不是那些犯罪、屍首倒在曠野的人嗎﹖',
    '來3:18 又向誰起誓，不容他們進入他的安息呢﹖豈不是向那些不信從的人嗎﹖',
    '來3:19 這樣看來，他們不能進入安息是因為不信的緣故了。',
    '來4:1 我們既蒙留下，有進入他安息的應許，就當畏懼，免得我們（原文是你們）中間或有人似乎是趕不上了。',
    '來4:2 因為有福音傳給我們，像傳給他們一樣；只是所聽見的道於他們無益，因為他們沒有信心與所聽見的道調和。',
    '來4:3 但我們已經相信的人得以進入那安息，正如神所說：我在怒中起誓說：他們斷不可進入我的安息！其實造物之工，從創世以來已經成全了。',
    '來4:4 論到第七日，有一處說，到第七日神就歇了他一切的工。',
    '來4:5 又有一處說：他們斷不可進入我的安息！',
    '來4:6 既有必進安息的人，那先前聽見福音的，因為不信從，不得進去。',
    '來4:7 所以過了多年，就在大衛的書上，又限定一日，如以上所引的說：你們今日若聽他的話，就不可硬著心。',
    '來4:8 若是約書亞已叫他們享了安息，後來神就不再提別的日子了。',
    '來4:9 這樣看來，必另有一安息日的安息為神的子民存留。',
    '來4:10 因為那進入安息的，乃是歇了自己的工，正如神歇了他的工一樣。',
    '來4:11 所以，我們務必竭力進入那安息，免得有人學那不信從的樣子跌倒了。',
    '來4:12 神的道是活潑的，是有功效的，比一切兩刃的劍更快，甚至魂與靈，骨節與骨髓，都能刺入、剖開，連心中的思念和主意都能辨明。',
    '來4:13 並且被造的沒有一樣在他面前不顯然的；原來萬物在那與我們有關係的主眼前，都是赤露敞開的。',
    '來4:14 我們既然有一位已經升入高天尊榮的大祭司，就是神的兒子耶穌，便當持定所承認的道。',
    '來4:15 因我們的大祭司並非不能體恤我們的軟弱。他也曾凡事受過試探，與我們一樣，只是他沒有犯罪。',
    '來4:16 所以，我們只管坦然無懼的來到施恩的寶座前，為要得憐恤，蒙恩惠，作隨時的幫助。',
    '來5:1 凡從人間挑選的大祭司，是奉派替人辦理屬神的事，為要獻上禮物和贖罪祭（或作：要為罪獻上禮物和祭物）。',
    '來5:2 他能體諒那愚蒙的和失迷的人，因為他自己也是被軟弱所困。',
    '來5:3 故此，他理當為百姓和自己獻祭贖罪。',
    '來5:4 這大祭司的尊榮，沒有人自取。惟要蒙神所召，像亞倫一樣。',
    '來5:5 如此，基督也不是自取榮耀作大祭司，乃是在乎向他說你是我的兒子，我今日生你的那一位；',
    '來5:6 就如經上又有一處說：你是照著麥基洗德的等次永遠為祭司。',
    '來5:7 基督在肉體的時候，既大聲哀哭，流淚禱告，懇求那能救他免死的主，就因他的虔誠蒙了應允。',
    '來5:8 他雖然為兒子，還是因所受的苦難學了順從。',
    '來5:9 他既得以完全，就為凡順從他的人成了永遠得救的根源、',
    '來5:10 並蒙神照著麥基洗德的等次稱他為大祭司。',
    '來5:11 論到麥基洗德，我們有好些話，並且難以解明，因為你們聽不進去。',
    '來5:12 看你們學習的工夫，本該作師傅，誰知還得有人將神聖言小學的開端另教導你們，並且成了那必須吃奶，不能吃乾糧的人。',
    '來5:13 凡只能吃奶的都不熟練仁義的道理，因為他是嬰孩；',
    '來5:14 惟獨長大成人的才能吃乾糧；他們的心竅習練得通達，就能分辨好歹了。',
    '來6:1 所以，我們應當離開基督道理的開端，竭力進到完全的地步，不必再立根基，就如那懊悔死行，信靠神、',
    '來6:2 各樣洗禮、按手之禮、死人復活，以及永遠審判各等教訓。',
    '來6:3 神若許我們，我們必如此行。',
    '來6:4 論到那些已經蒙了光照、嘗過天恩的滋味、又於聖靈有分，',
    '來6:5 並嘗過神善道的滋味、覺悟來世權能的人，',
    '來6:6 若是離棄道理，就不能叫他們從新懊悔了。因為他們把神的兒子重釘十字架，明明的羞辱他。',
    '來6:7 就如一塊田地，吃過屢次下的雨水，生長菜蔬，合乎耕種的人用，就從神得福；',
    '來6:8 若長荊棘和蒺藜，必被廢棄，近於咒詛，結局就是焚燒。',
    '來6:9 親愛的弟兄們，我們雖是這樣說，卻深信你們的行為強過這些，而且近乎得救。',
    '來6:10 因為神並非不公義，竟忘記你們所做的工和你們為他名所顯的愛心，就是先前伺候聖徒，如今還是伺候。',
    '來6:11 我們願你們各人都顯出這樣的殷勤，使你們有滿足的指望，一直到底。',
    '來6:12 並且不懈怠，總要效法那些憑信心和忍耐承受應許的人。',
    '來6:13 當初神應許亞伯拉罕的時候，因為沒有比自己更大可以指著起誓的，就指著自己起誓，說：',
    '來6:14 論福，我必賜大福給你；論子孫，我必叫你的子孫多起來。',
    '來6:15 這樣，亞伯拉罕既恆久忍耐，就得了所應許的。',
    '來6:16 人都是指著比自己大的起誓，並且以起誓為實據，了結各樣的爭論。',
    '來6:17 照樣，神願意為那承受應許的人格外顯明他的旨意是不更改的，就起誓為證。',
    '來6:18 藉這兩件不更改的事，神決不能說謊，好叫我們這逃往避難所、持定擺在我們前頭指望的人可以大得勉勵。',
    '來6:19 我們有這指望，如同靈魂的錨，又堅固又牢靠，且通入幔內。',
    '來6:20 作先鋒的耶穌，既照著麥基洗德的等次成了永遠的大祭司，就為我們進入幔內。',
    '來7:1 這麥基洗德就是撒冷王，又是至高神的祭司，本是長遠為祭司的。他當亞伯拉罕殺敗諸王回來的時候，就迎接他，給他祝福。',
    '來7:2 亞伯拉罕也將自己所得來的，取十分之一給他。他頭一個名翻出來就是仁義王，他又名撒冷王，就是平安王的意思。',
    '來7:3 他無父，無母，無族譜，無生之始，無命之終，乃是與神的兒子相似。',
    '來7:4 你們想一想，先祖亞伯拉罕將自己所擄來上等之物取十分之一給他，這人是何等尊貴呢！',
    '來7:5 那得祭司職任的利未子孫，領命照例向百姓取十分之一，這百姓是自己的弟兄，雖是從亞伯拉罕身（原文是腰）中生的，還是照例取十分之一；',
    '來7:6 獨有麥基洗德，不與他們同譜，倒收納亞伯拉罕的十分之一，為那蒙應許的亞伯拉罕祝福。',
    '來7:7 從來位分大的給位分小的祝福，這是駁不倒的理。',
    '來7:8 在這裡收十分之一的都是必死的人；但在那裡收十分之一的，有為他作見證的說，他是活的；',
    '來7:9 並且可說那受十分之一的利未，也是藉著亞伯拉罕納了十分之一。',
    '來7:10 因為麥基洗德迎接亞伯拉罕的時候，利未已經在他先祖的身（原文是腰）中。',
    '來7:11 從前百姓在利未人祭司職任以下受律法，倘若藉這職任能得完全，又何用另外興起一位祭司，照麥基洗德的等次，不照亞倫的等次呢﹖',
    '來7:12 祭司的職任既已更改，律法也必須更改。',
    '來7:13 因為這話所指的人本屬別的支派，那支派裡從來沒有一人伺候祭壇。',
    '來7:14 我們的主分明是從猶大出來的；但這支派，摩西並沒有提到祭司。',
    '來7:15 倘若照麥基洗德的樣式，另外興起一位祭司來，我的話更是顯而易見的了。',
    '來7:16 他成為祭司，並不是照屬肉體的條例，乃是照無窮（原文是不能毀壞）之生命的大能。',
    '來7:17 因為有給他作見證的說：你是照著麥基洗德的等次永遠為祭司。',
    '來7:18 先前的條例，因軟弱無益，所以廢掉了，',
    '來7:19 （律法原來一無所成）就引進了更美的指望；靠這指望，我們便可以進到神面前。',
    '來7:20 再者，耶穌為祭司，並不是不起誓立的。',
    '來7:21 至於那些祭司，原不是起誓立的，只有耶穌是起誓立的；因為那立他的對他說：主起了誓，決不後悔，你是永遠為祭司。',
    '來7:22 既是起誓立的，耶穌就作了更美之約的中保。',
    '來7:23 那些成為祭司的，數目本來多，是因為有死阻隔，不能長久。',
    '來7:24 這位既是永遠常存的，他祭司的職任就長久不更換。',
    '來7:25 凡靠著他進到神面前的人，他都能拯救到底；因為他是長遠活著，替他們祈求。',
    '來7:26 像這樣聖潔、無邪惡、無玷污、遠離罪人、高過諸天的大祭司，原是與我們合宜的。',
    '來7:27 他不像那些大祭司，每日必須先為自己的罪，後為百姓的罪獻祭；因為他只一次將自己獻上，就把這事成全了。',
    '來7:28 律法本是立軟弱的人為大祭司；但在律法以後起誓的話，是立兒子為大祭司，乃是成全到永遠的。',
    '來8:1 我們所講的事，其中第一要緊的，就是我們有這樣的大祭司，已經坐在天上至大者寶座的右邊，',
    '來8:2 在聖所，就是真帳幕裡，作執事；這帳幕是主所支的，不是人所支的。',
    '來8:3 凡大祭司都是為獻禮物和祭物設立的，所以這位大祭司也必須有所獻的。',
    '來8:4 他若在地上，必不得為祭司，因為已經有照律法獻禮物的祭司。',
    '來8:5 他們供奉的事本是天上事的形狀和影像，正如摩西將要造帳幕的時候，蒙神警戒他，說：你要謹慎，作各樣的物件都要照著在山上指示你的樣式。',
    '來8:6 如今耶穌所得的職任是更美的，正如他作更美之約的中保；這約原是憑更美之應許立的。',
    '來8:7 那前約若沒有瑕疵，就無處尋求後約了。',
    '來8:8 所以主指責他的百姓說（或作：所以主指前約的缺欠說）：日子將到，我要與以色列家和猶大家另立新約，',
    '來8:9 不像我拉著他們祖宗的手，領他們出埃及的時候，與他們所立的約。因為他們不恆心守我的約，我也不理他們。這是主說的。',
    '來8:10 主又說：那些日子以後，我與以色列家所立的約乃是這樣：我要將我的律法放在他們裡面，寫在他們心上；我要作他們的神；他們要作我的子民。',
    '來8:11 他們不用各人教導自己的鄉鄰和自己的弟兄，說：你該認識主；因為他們從最小的到至大的，都必認識我。',
    '來8:12 我要寬恕他們的不義，不再記念他們的罪愆。',
    '來8:13 既說新約。就以前約為舊了；但那漸舊漸衰的，就必快歸無有了。',
    '來9:1 原來前約有禮拜的條例和屬世界的聖幕。',
    '來9:2 因為有預備的帳幕，頭一層叫做聖所，裡面有燈臺、桌子，和陳設餅。',
    '來9:3 第二幔子後又有一層帳幕，叫做至聖所，',
    '來9:4 有金香爐（或作：壇），有包金的約櫃，櫃裡有盛嗎哪的金罐和亞倫發過芽的杖，並兩塊約版；',
    '來9:5 櫃上面有榮耀基路伯的影罩著施恩（原文作：蔽罪）座。這幾件我現在不能一一細說。',
    '來9:6 這些物件既如此預備齊了，眾祭司就常進頭一層帳幕，行拜神的禮。',
    '來9:7 至於第二層帳幕，惟有大祭司一年一次獨自進去，沒有不帶著血為自己和百姓的過錯獻上。',
    '來9:8 聖靈用此指明，頭一層帳幕仍存的時候，進入至聖所的路還未顯明。',
    '來9:9 那頭一層帳幕作現今的一個表樣，所獻的禮物和祭物，就著良心說，都不能叫禮拜的人得以完全。',
    '來9:10 這些事，連那飲食和諸般洗濯的規矩，都不過是屬肉體的條例，命定到振興的時候為止。',
    '來9:11 但現在基督已經來到，作了將來美事的大祭司，經過那更大更全備的帳幕，不是人手所造、也不是屬乎這世界的；',
    '來9:12 並且不用山羊和牛犢的血，乃用自己的血，只一次進入聖所，成了永遠贖罪的事。',
    '來9:13 若山羊和公牛的血，並母牛犢的灰，灑在不潔的人身上，尚且叫人成聖，身體潔淨，',
    '來9:14 何況基督藉著永遠的靈，將自己無瑕無疵獻給神，他的血豈不更能洗淨你們的心（原文是良心），除去你們的死行，使你們事奉那永生神嗎﹖',
    '來9:15 為此，他作了新約的中保，既然受死贖了人在前約之時所犯的罪過，便叫蒙召之人得著所應許永遠的產業。',
    '來9:16 凡有遺命必須等到留遺命（遺命：原文與約字同）的人死了；',
    '來9:17 因為人死了，遺命才有效力，若留遺命的尚在，那遺命還有用處嗎﹖',
    '來9:18 所以，前約也不是不用血立的；',
    '來9:19 因為摩西當日照著律法將各樣誡命傳給眾百姓，就拿朱紅色絨和牛膝草，把牛犢山羊的血和水灑在書上，又灑在眾百姓身上，說：',
    '來9:20 這血就是神與你們立約的憑據。',
    '來9:21 他又照樣把血灑在帳幕和各樣器皿上。',
    '來9:22 按著律法，凡物差不多都是用血潔淨的；若不流血，罪就不得赦免了。',
    '來9:23 照著天上樣式作的物件必須用這些祭物去潔淨；但那天上的本物自然當用更美的祭物去潔淨。',
    '來9:24 因為基督並不是進了人手所造的聖所（這不過是真聖所的影像），乃是進了天堂，如今為我們顯在神面前；',
    '來9:25 也不是多次將自己獻上，像那大祭司每年帶著牛羊的血（牛羊的血：原文作不是自己的血）進入聖所，',
    '來9:26 如果這樣，他從創世以來，就必多次受苦了。但如今在這末世顯現一次，把自己獻為祭，好除掉罪。',
    '來9:27 按著定命，人人都有一死，死後且有審判。',
    '來9:28 像這樣，基督既然一次被獻，擔當了多人的罪，將來要向那等候他的人第二次顯現，並與罪無關，乃是為拯救他們。',
    '來10:1 律法既是將來美事的影兒，不是本物的真像，總不能藉著每年常獻一樣的祭物叫那近前來的人得以完全。',
    '來10:2 若不然，獻祭的事豈不早已止住了嗎﹖因為禮拜的人，良心既被潔淨，就不再覺得有罪了。',
    '來10:3 但這些祭物是叫人每年想起罪來；',
    '來10:4 因為公牛和山羊的血，斷不能除罪。',
    '來10:5 所以基督到世上來的時候，就說：神啊，祭物和禮物是你不願意的；你曾給我預備了身體。',
    '來10:6 燔祭和贖罪祭是你不喜歡的。',
    '來10:7 那時我說：神啊，我來了，為要照你的旨意行；我的事在經卷上已經記載了。',
    '來10:8 以上說：祭物和禮物，燔祭和贖罪祭，是你不願意的，也是你不喜歡的（這都是按著律法獻的）；',
    '來10:9 後又說：我來了為要照你的旨意行；可見他是除去在先的，為要立定在後的。',
    '來10:10 我們憑這旨意，靠耶穌基督，只一次獻上他的身體，就得以成聖。',
    '來10:11 凡祭司天天站著事奉神，屢次獻上一樣的祭物，這祭物永不能除罪。',
    '來10:12 但基督獻了一次永遠的贖罪祭，就在神的右邊坐下了。',
    '來10:13 從此，等候他仇敵成了他的腳凳。',
    '來10:14 因為他一次獻祭，便叫那得以成聖的人永遠完全。',
    '來10:15 聖靈也對我們作見證；因為他既已說過：',
    '來10:16 主說：那些日子以後，我與他們所立的約乃是這樣：我要將我的律法寫在他們心上，又要放在他們的裡面。',
    '來10:17 以後就說：我不再記念他們的罪愆和他們的過犯。',
    '來10:18 這些罪過既已赦免，就不用再為罪獻祭了。',
    '來10:19 弟兄們，我們既因耶穌的血得以坦然進入至聖所，',
    '來10:20 是藉著他給我們開了一條又新又活的路，從幔子經過，這幔子就是他的身體。',
    '來10:21 又有一位大祭司治理神的家！',
    '來10:22 並我們心中天良的虧欠已經灑去，身體用清水洗淨了，就當存著誠心和充足的信心來到神面前；',
    '來10:23 也要堅守我們所承認的指望，不至搖動，因為那應許我們的是信實的。',
    '來10:24 又要彼此相顧，激發愛心，勉勵行善。',
    '來10:25 你們不可停止聚會，好像那些停止慣了的人，倒要彼此勸勉，既知道（原文是看見）那日子臨近，就更當如此。',
    '來10:26 因為我們得知真道以後，若故意犯罪，贖罪的祭就再沒有了；',
    '來10:27 惟有戰懼等候審判和那燒滅眾敵人的烈火。',
    '來10:28 人干犯摩西的律法，憑兩三個見證人，尚且不得憐恤而死，',
    '來10:29 何況人踐踏神的兒子，將那使他成聖之約的血當作平常，又褻慢施恩的聖靈，你們想，他要受的刑罰該怎樣加重呢！',
    '來10:30 因為我們知道誰說：伸冤在我，我必報應；又說：主要審判他的百姓。',
    '來10:31 落在永生神的手裡，真是可怕的！',
    '來10:32 你們要追念往日，蒙了光照以後所忍受大爭戰的各樣苦難：',
    '來10:33 一面被毀謗，遭患難，成了戲景，叫眾人觀看；一面陪伴那些受這樣苦難的人。',
    '來10:34 因為你們體恤了那些被捆鎖的人，並且你們的家業被人搶去，也甘心忍受，知道自己有更美長存的家業。',
    '來10:35 所以，你們不可丟棄勇敢的心；存這樣的心必得大賞賜。',
    '來10:36 你們必須忍耐，使你們行完了神的旨意，就可以得著所應許的。',
    '來10:37 因為還有一點點時候，那要來的就來，並不遲延；',
    '來10:38 只是義人（有古卷：我的義人）必因信得生。他若退後，我心裡就不喜歡他。',
    '來10:39 我們卻不是退後入沉淪的那等人，乃是有信心以致靈魂得救的人。',
    '來11:1 信就是所望之事的實底，是未見之事的確據。',
    '來11:2 古人在這信上得了美好的證據。',
    '來11:3 我們因著信，就知道諸世界是藉神話造成的；這樣，所看見的，並不是從顯然之物造出來的。',
    '來11:4 亞伯因著信，獻祭與神，比該隱所獻的更美，因此便得了稱義的見證，就是神指他禮物作的見證。他雖然死了，卻因這信，仍舊說話。',
    '來11:5 以諾因著信，被接去，不至於見死，人也找不著他，因為神已經把他接去了；只是他被接去以先，已經得了神喜悅他的明證。',
    '來11:6 人非有信，就不能得神的喜悅；因為到神面前來的人必須信有神，且信他賞賜那尋求他的人。',
    '來11:7 挪亞因著信，既蒙神指示他未見的事，動了敬畏的心，預備了一隻方舟，使他全家得救。因此就定了那世代的罪，自己也承受了那從信而來的義。',
    '來11:8 亞伯拉罕因著信，蒙召的時候就遵命出去，往將來要得為業的地方去；出去的時候，還不知往哪裡去。',
    '來11:9 他因著信，就在所應許之地作客，好像在異地居住帳棚，與那同蒙一個應許的以撒、雅各一樣。',
    '來11:10 因為他等候那座有根基的城，就是神所經營所建造的。',
    '來11:11 因著信，連撒拉自己，雖然過了生育的歲數，還能懷孕，因他以為那應許他的是可信的。',
    '來11:12 所以從一個彷彿已死的人就生出子孫，如同天上的星那樣眾多，海邊的沙那樣無數。',
    '來11:13 這些人都是存著信心死的，並沒有得著所應許的；卻從遠處望見，且歡喜迎接，又承認自己在世上是客旅，是寄居的。',
    '來11:14 說這樣話的人是表明自己要找一個家鄉。',
    '來11:15 他們若想念所離開的家鄉，還有可以回去的機會。',
    '來11:16 他們卻羨慕一個更美的家鄉，就是在天上的。所以神被稱為他們的神，並不以為恥，因為他已經給他們預備了一座城。',
    '來11:17 亞伯拉罕因著信，被試驗的時候，就把以撒獻上；這便是那歡喜領受應許的，將自己獨生的兒子獻上。',
    '來11:18 論到這兒子，曾有話說：從以撒生的才要稱為你的後裔。',
    '來11:19 他以為神還能叫人從死裡復活；他也彷彿從死中得回他的兒子來。',
    '來11:20 以撒因著信，就指著將來的事給雅各、以掃祝福。',
    '來11:21 雅各因著信，臨死的時候，給約瑟的兩個兒子各自祝福，扶著杖頭敬拜神。',
    '來11:22 約瑟因著信，臨終的時候，提到以色列族將來要出埃及，並為自己的骸骨留下遺命。',
    '來11:23 摩西生下來，他的父母見他是個俊美的孩子，就因著信，把他藏了三個月，並不怕王命。',
    '來11:24 摩西因著信，長大了就不肯稱為法老女兒之子。',
    '來11:25 他寧可和神的百姓同受苦害，也不願暫時享受罪中之樂。',
    '來11:26 他看為基督受的凌辱比埃及的財物更寶貴，因他想望所要得的賞賜。',
    '來11:27 他因著信，就離開埃及，不怕王怒；因為他恆心忍耐，如同看見那不能看見的主。',
    '來11:28 他因著信，就守（或作：立）逾越節，行灑血的禮，免得那滅長子的臨近以色列人。',
    '來11:29 他們因著信，過紅海如行乾地；埃及人試著要過去，就被吞滅了。',
    '來11:30 以色列人因著信，圍繞耶利哥城七日，城牆就倒塌了。',
    '來11:31 妓女喇合因著信，曾和和平平的接待探子，就不與那些不順從的人一同滅亡。',
    '來11:32 我又何必再說呢﹖若要一一細說，基甸、巴拉、參孫、耶弗他、大衛、撒母耳，和眾先知的事，時候就不夠了。',
    '來11:33 他們因著信，制伏了敵國，行了公義，得了應許，堵了獅子的口，',
    '來11:34 滅了烈火的猛勢，脫了刀劍的鋒刃；軟弱變為剛強，爭戰顯出勇敢，打退外邦的全軍。',
    '來11:35 有婦人得自己的死人復活。又有人忍受嚴刑，不肯苟且得釋放（原文是贖），為要得著更美的復活。',
    '來11:36 又有人忍受戲弄、鞭打、捆鎖、監禁、各等的磨煉，',
    '來11:37 被石頭打死，被鋸鋸死，受試探，被刀殺，披著綿羊山羊的皮各處奔跑，受窮乏、患難、苦害，',
    '來11:38 在曠野、山嶺、山洞、地穴，飄流無定，本是世界不配有的人。',
    '來11:39 這些人都是因信得了美好的證據，卻仍未得著所應許的；',
    '來11:40 因為神給我們預備了更美的事，叫他們若不與我們同得，就不能完全。',
    '來12:1 我們既有這許多的見證人，如同雲彩圍著我們，就當放下各樣的重擔，脫去容易纏累我們的罪，存心忍耐，奔那擺在我們前頭的路程，',
    '來12:2 仰望為我們信心創始成終的耶穌（或作：仰望那將真道創始成終的耶穌）。他因那擺在前面的喜樂，就輕看羞辱，忍受了十字架的苦難，便坐在神寶座的右邊。',
    '來12:3 那忍受罪人這樣頂撞的，你們要思想，免得疲倦灰心。',
    '來12:4 你們與罪惡相爭，還沒有抵擋到流血的地步。',
    '來12:5 你們又忘了那勸你們如同勸兒子的話，說：我兒，你不可輕看主的管教，被他責備的時候也不可灰心；',
    '來12:6 因為主所愛的，他必管教，又鞭打凡所收納的兒子。',
    '來12:7 你們所忍受的，是神管教你們，待你們如同待兒子。焉有兒子不被父親管教的呢﹖',
    '來12:8 管教原是眾子所共受的，你們若不受管教，就是私子，不是兒子了。',
    '來12:9 再者，我們曾有生身的父管教我們，我們尚且敬重他，何況萬靈的父，我們豈不更當順服他得生嗎﹖',
    '來12:10 生身的父都是暫隨己意管教我們；惟有萬靈的父管教我們，是要我們得益處，使我們在他的聖潔上有分。',
    '來12:11 凡管教的事，當時不覺得快樂，反覺得愁苦；後來卻為那經練過的人結出平安的果子，就是義。',
    '來12:12 所以，你們要把下垂的手、發酸的腿、挺起來；',
    '來12:13 也要為自己的腳，把道路修直了，使瘸子不致歪腳（或作：差路），反得痊癒。',
    '來12:14 你們要追求與眾人和睦，並要追求聖潔；非聖潔沒有人能見主。',
    '來12:15 又要謹慎，恐怕有人失了神的恩；恐怕有毒根生出來擾亂你們，因此叫眾人沾染污穢；',
    '來12:16 恐怕有淫亂的，有貪戀世俗如以掃的，他因一點食物把自己長子的名分賣了。',
    '來12:17 後來想要承受父所祝的福，竟被棄絕，雖然號哭切求，卻得不著門路使他父親的心意回轉。這是你們知道的。',
    '來12:18 你們原不是來到那能摸的山；此山有火焰、密雲、黑暗、暴風、',
    '來12:19 角聲與說話的聲音。那些聽見這聲音的，都求不要再向他們說話；',
    '來12:20 因為他們當不起所命他們的話，說：靠近這山的，即便是走獸，也要用石頭打死。',
    '來12:21 所見的極其可怕，甚至摩西說：我甚是恐懼戰兢。',
    '來12:22 你們乃是來到錫安山，永生神的城邑，就是天上的耶路撒冷。那裡有千萬的天使，',
    '來12:23 有名錄在天上諸長子之會所共聚的總會，有審判眾人的神和被成全之義人的靈魂，',
    '來12:24 並新約的中保耶穌，以及所灑的血；這血所說的比亞伯的血所說的更美。',
    '來12:25 你們總要謹慎，不可棄絕那向你們說話的。因為，那些棄絕在地上警戒他們的尚且不能逃罪，何況我們違背那從天上警戒我們的呢﹖',
    '來12:26 當時他的聲音震動了地，但如今他應許說：再一次我不單要震動地，還要震動天。',
    '來12:27 這再一次的話，是指明被震動的，就是受造之物都要挪去，使那不被震動的常存。',
    '來12:28 所以我們既得了不能震動的國，就當感恩，照神所喜悅的，用虔誠、敬畏的心事奉神。',
    '來12:29 因為我們的神乃是烈火。',
    '來13:1 你們務要常存弟兄相愛的心。',
    '來13:2 不可忘記用愛心接待客旅；因為曾有接待客旅的，不知不覺就接待了天使。',
    '來13:3 你們要記念被捆綁的人，好像與他們同受捆綁；也要記念遭苦害的人，想到自己也在肉身之內。',
    '來13:4 婚姻，人人都當尊重，床也不可污穢；因為苟合行淫的人，神必要審判。',
    '來13:5 你們存心不可貪愛錢財，要以自己所有的為足；因為主曾說：我總不撇下你，也不丟棄你。',
    '來13:6 所以我們可以放膽說：主是幫助我的，我必不懼怕；人能把我怎麼樣呢﹖',
    '來13:7 從前引導你們、傳神之道給你們的人，你們要想念他們，效法他們的信心，留心看他們為人的結局。',
    '來13:8 耶穌基督，昨日、今日、一直到永遠、是一樣的。',
    '來13:9 你們不要被那諸般怪異的教訓勾引了去；因為人心靠恩得堅固才是好的，並不是靠飲食。那在飲食上專心的從來沒有得著益處。',
    '來13:10 我們有一祭壇，上面的祭物是那些在帳幕中供職的人不可同吃的。',
    '來13:11 原來牲畜的血被大祭司帶入聖所作贖罪祭；牲畜的身子被燒在營外。',
    '來13:12 所以，耶穌要用自己的血叫百姓成聖，也就在城門外受苦。',
    '來13:13 這樣，我們也當出到營外，就了他去，忍受他所受的凌辱。',
    '來13:14 我們在這裡本沒有常存的城，乃是尋求那將來的城。',
    '來13:15 我們應當靠著耶穌，常常以頌讚為祭獻給神，這就是那承認主名之人嘴唇的果子。',
    '來13:16 只是不可忘記行善和捐輸的事；因為這樣的祭，是神所喜悅的。',
    '來13:17 你們要依從那些引導你們的，且要順服；因他們為你們的靈魂時刻警醒，好像那將來交帳的人。你們要使他們交的時候有快樂，不致憂愁；若憂愁就於你們無益了。',
    '來13:18 請你們為我們禱告，因我們自覺良心無虧，願意凡事按正道而行。',
    '來13:19 我更求你們為我禱告，使我快些回到你們那裡去。',
    '來13:20 但願賜平安的神，就是那憑永約之血、使群羊的大牧人─我主耶穌從死裡復活的神，',
    '來13:21 在各樣善事上成全你們，叫你們遵行他的旨意；又藉著耶穌基督在你們心裡行他所喜悅的事。願榮耀歸給他，直到永永遠遠。阿們！',
    '來13:22 弟兄們，我略略寫信給你們，望你們聽我勸勉的話。',
    '來13:23 你們該知道，我們的兄弟提摩太已經釋放了；他若快來，我必同他去見你們。',
    '來13:24 請你們問引導你們的諸位和眾聖徒安。從義大利來的人也問你們安。',
    '來13:25 願恩惠常與你們眾人同在。阿們！',
    '雅1:1 作神和主耶穌基督僕人的雅各請散住十二個支派之人的安。',
    '雅1:2 我的弟兄們，你們落在百般試煉中，都要以為大喜樂；',
    '雅1:3 因為知道你們的信心經過試驗，就生忍耐。',
    '雅1:4 但忍耐也當成功，使你們成全、完備，毫無缺欠。',
    '雅1:5 你們中間若有缺少智慧的，應當求那厚賜與眾人、也不斥責人的神，主就必賜給他。',
    '雅1:6 只要憑著信心求，一點不疑惑；因為那疑惑的人，就像海中的波浪，被風吹動翻騰。',
    '雅1:7 這樣的人不要想從主那裡得什麼。',
    '雅1:8 心懷二意的人，在他一切所行的路上都沒有定見。',
    '雅1:9 卑微的弟兄升高，就該喜樂；',
    '雅1:10 富足的降卑，也該如此；因為他必要過去，如同草上的花一樣。',
    '雅1:11 太陽出來，熱風颳起，草就枯乾，花也凋謝，美容就消沒了；那富足的人，在他所行的事上也要這樣衰殘。',
    '雅1:12 忍受試探的人是有福的，因為他經過試驗以後，必得生命的冠冕，這是主應許給那些愛他之人的。',
    '雅1:13 人被試探，不可說：我是被神試探；因為神不能被惡試探，他也不試探人。',
    '雅1:14 但各人被試探，乃是被自己的私慾牽引誘惑的。',
    '雅1:15 私慾既懷了胎，就生出罪來；罪既長成，就生出死來。',
    '雅1:16 我親愛的弟兄們，不要看錯了。',
    '雅1:17 各樣美善的恩賜和各樣全備的賞賜都是從上頭來的，從眾光之父那裡降下來的；在他並沒有改變，也沒有轉動的影兒。',
    '雅1:18 他按自己的旨意，用真道生了我們，叫我們在他所造的萬物中好像初熟的果子。',
    '雅1:19 我親愛的弟兄們，這是你們所知道的，但你們各人要快快的聽，慢慢的說，慢慢的動怒，',
    '雅1:20 因為人的怒氣並不成就神的義。',
    '雅1:21 所以你們要脫去一切的污穢和盈餘的邪惡，存溫柔的心領受那所栽種的道，就是能救你們靈魂的道。',
    '雅1:22 只是你們要行道，不要單單聽道，自己欺哄自己。',
    '雅1:23 因為聽道而不行道的，就像人對著鏡子看自己本來的面目，',
    '雅1:24 看見，走後，隨即忘了他的相貌如何。',
    '雅1:25 惟有詳細察看那全備、使人自由之律法的，並且時常如此，這人既不是聽了就忘，乃是實在行出來，就在他所行的事上必然得福。',
    '雅1:26 若有人自以為虔誠，卻不勒住他的舌頭，反欺哄自己的心，這人的虔誠是虛的。',
    '雅1:27 在神我們的父面前，那清潔沒有玷污的虔誠，就是看顧在患難中的孤兒寡婦，並且保守自己不沾染世俗。',
    '雅2:1 我的弟兄們，你們信奉我們榮耀的主耶穌基督，便不可按著外貌待人。',
    '雅2:2 若有一個人帶著金戒指，穿著華美衣服，進你們的會堂去；又有一個窮人穿著骯髒衣服也進去；',
    '雅2:3 你們就重看那穿華美衣服的人，說：請坐在這好位上；又對那窮人說：你站在那裡，或坐在我腳凳下邊。',
    '雅2:4 這豈不是你們偏心待人，用惡意斷定人嗎﹖',
    '雅2:5 我親愛的弟兄們，請聽，神豈不是揀選了世上的貧窮人，叫他們在信上富足，並承受他所應許給那些愛他之人的國嗎﹖',
    '雅2:6 你們反倒羞辱貧窮人。那富足人豈不是欺壓你們，拉你們到公堂去嗎﹖',
    '雅2:7 他們不是褻瀆你們所敬奉（所敬奉：或作被稱）的尊名嗎﹖',
    '雅2:8 經上記著說：要愛人如己。你們若全守這至尊的律法，才是好的。',
    '雅2:9 但你們若按外貌待人，便是犯罪，被律法定為犯法的。',
    '雅2:10 因為凡遵守全律法的，只在一條上跌倒，他就是犯了眾條。',
    '雅2:11 原來那說不可姦淫的，也說不可殺人；你就是不姦淫，卻殺人，仍是成了犯律法的。',
    '雅2:12 你們既然要按使人自由的律法受審判，就該照這律法說話行事。',
    '雅2:13 因為那不憐憫人的，也要受無憐憫的審判；憐憫原是向審判誇勝。',
    '雅2:14 我的弟兄們，若有人說自己有信心，卻沒有行為，有什麼益處呢﹖這信心能救他嗎﹖',
    '雅2:15 若是弟兄或是姊妹，赤身露體，又缺了日用的飲食；',
    '雅2:16 你們中間有人對他們說：平平安安地去吧！願你們穿得暖，吃得飽；卻不給他們身體所需用的，這有什麼益處呢﹖',
    '雅2:17 這樣，信心若沒有行為就是死的。',
    '雅2:18 必有人說：你有信心，我有行為；你將你沒有行為的信心指給我看，我便藉著我的行為，將我的信心指給你看。',
    '雅2:19 你信神只有一位，你信的不錯；鬼魔也信，卻是戰驚。',
    '雅2:20 虛浮的人哪，你願意知道沒有行為的信心是死的嗎﹖',
    '雅2:21 我們的祖宗亞伯拉罕把他兒子以撒獻在壇上，豈不是因行為稱義嗎﹖',
    '雅2:22 可見信心是與他的行為並行，而且信心因著行為才得成全。',
    '雅2:23 這就應驗經上所說：亞伯拉罕信神，這就算為他的義。他又得稱為神的朋友。',
    '雅2:24 這樣看來，人稱義是因著行為，不是單因著信。',
    '雅2:25 妓女喇合接待使者，又放他們從別的路上出去，不也是一樣因行為稱義嗎﹖',
    '雅2:26 身體沒有靈魂是死的，信心沒有行為也是死的。',
    '雅3:1 我的弟兄們，不要多人作師傅，因為曉得我們要受更重的判斷。',
    '雅3:2 原來我們在許多事上都有過失；若有人在話語上沒有過失，他就是完全人，也能勒住自己的全身。',
    '雅3:3 我們若把嚼環放在馬嘴裡，叫他順服，就能調動他的全身。',
    '雅3:4 看哪，船隻雖然甚大，又被大風催逼，只用小小的舵，就隨著掌舵的意思轉動。',
    '雅3:5 這樣，舌頭在百體裡也是最小的，卻能說大話。看哪，最小的火能點著最大的樹林。',
    '雅3:6 舌頭就是火，在我們百體中，舌頭是個罪惡的世界，能污穢全身，也能把生命的輪子點起來，並且是從地獄裡點著的。',
    '雅3:7 各類的走獸，飛禽，昆蟲，水族，本來都可以制伏，也已經被人制伏了；',
    '雅3:8 惟獨舌頭沒有人能制伏，是不止息的惡物，滿了害死人的毒氣。',
    '雅3:9 我們用舌頭頌讚那為主、為父的，又用舌頭咒詛那照著神形像被造的人；',
    '雅3:10 頌讚和咒詛從一個口裡出來！我的弟兄們，這是不應當的！',
    '雅3:11 泉源從一個眼裡能發出甜苦兩樣的水嗎﹖',
    '雅3:12 我的弟兄們，無花果樹能生橄欖嗎﹖葡萄樹能結無花果嗎﹖鹹水裡也不能發出甜水來。',
    '雅3:13 你們中間誰是有智慧有見識的呢﹖他就當在智慧的溫柔上顯出他的善行來。',
    '雅3:14 你們心裡若懷著苦毒的嫉妒和紛爭，就不可自誇，也不可說謊話抵擋真道。',
    '雅3:15 這樣的智慧不是從上頭來的，乃是屬地的，屬情慾的，屬鬼魔的。',
    '雅3:16 在何處有嫉妒、紛爭，就在何處有擾亂和各樣的壞事。',
    '雅3:17 惟獨從上頭來的智慧，先是清潔，後是和平，溫良柔順，滿有憐憫，多結善果，沒有偏見，沒有假冒。',
    '雅3:18 並且使人和平的，是用和平所栽種的義果。',
    '雅4:1 你們中間的爭戰鬥毆是從哪裡來的呢﹖不是從你們百體中戰鬥之私慾來的嗎﹖',
    '雅4:2 你們貪戀，還是得不著；你們殺害嫉妒，又鬥毆爭戰，也不能得。你們得不著，是因為你們不求。',
    '雅4:3 你們求也得不著，是因為你們妄求，要浪費在你們的宴樂中。',
    '雅4:4 你們這些淫亂的人（原文作：淫婦）哪，豈不知與世俗為友就是與神為敵嗎﹖所以凡想要與世俗為友的，就是與神為敵了。',
    '雅4:5 你們想經上所說是徒然的嗎﹖神所賜、住在我們裡面的靈，是戀愛至於嫉妒嗎﹖',
    '雅4:6 但他賜更多的恩典，所以經上說：神阻擋驕傲的人，賜恩給謙卑的人。',
    '雅4:7 故此你們要順服神。務要抵擋魔鬼，魔鬼就必離開你們逃跑了。',
    '雅4:8 你們親近神，神就必親近你們。有罪的人哪，要潔淨你們的手！心懷二意的人哪，要清潔你們的心！',
    '雅4:9 你們要愁苦、悲哀、哭泣，將喜笑變作悲哀，歡樂變作愁悶。',
    '雅4:10 務要在主面前自卑，主就必叫你們升高。',
    '雅4:11 弟兄們，你們不可彼此批評。人若批評弟兄，論斷弟兄，就是批評律法，論斷律法。你若論斷律法，就不是遵行律法，乃是判斷人的。',
    '雅4:12 設立律法和判斷人的，只有一位，就是那能救人也能滅人的。你是誰，竟敢論斷別人呢﹖',
    '雅4:13 嗐！你們有話說：今天明天我們要往某城裡去，在那裡住一年，做買賣得利。',
    '雅4:14 其實明天如何，你們還不知道。你們的生命是什麼呢﹖你們原來是一片雲霧，出現少時就不見了。',
    '雅4:15 你們只當說：主若願意，我們就可以活著，也可以做這事，或做那事。',
    '雅4:16 現今你們竟以張狂誇口；凡這樣誇口都是惡的。',
    '雅4:17 人若知道行善，卻不去行，這就是他的罪了。',
    '雅5:1 嗐！你們這些富足人哪，應當哭泣、號咷，因為將有苦難臨到你們身上。',
    '雅5:2 你們的財物壞了，衣服也被蟲子咬了。',
    '雅5:3 你們的金銀都長了銹；那銹要證明你們的不是，又要吃你們的肉，如同火燒。你們在這末世只知積儹錢財。',
    '雅5:4 工人給你們收割莊稼，你們虧欠他們的工錢，這工錢有聲音呼叫，並且那收割之人的冤聲已經入了萬軍之主的耳了。',
    '雅5:5 你們在世上享美福，好宴樂，當宰殺的日子竟嬌養你們的心。',
    '雅5:6 你們定了義人的罪，把他殺害，他也不抵擋你們。',
    '雅5:7 弟兄們哪，你們要忍耐，直到主來。看哪，農夫忍耐等候地裡寶貴的出產，直到得了秋雨春雨。',
    '雅5:8 你們也當忍耐，堅固你們的心；因為主來的日子近了。',
    '雅5:9 弟兄們，你們不要彼此埋怨，免得受審判。看哪，審判的主站在門前了。',
    '雅5:10 弟兄們，你們要把那先前奉主名說話的眾先知當作能受苦能忍耐的榜樣。',
    '雅5:11 那先前忍耐的人，我們稱他們是有福的。你們聽見過約伯的忍耐，也知道主給他的結局，明顯主是滿心憐憫，大有慈悲。',
    '雅5:12 我的弟兄們，最要緊的是不可起誓；不可指著天起誓，也不可指著地起誓，無論何誓都不可起。你們說話，是，就說是；不是，就說不是，免得你們落在審判之下。',
    '雅5:13 你們中間有受苦的呢，他就該禱告；有喜樂的呢，他就該歌頌。',
    '雅5:14 你們中間有病了的呢，他就該請教會的長老來；他們可以奉主的名用油抹他，為他禱告。',
    '雅5:15 出於信心的祈禱要救那病人，主必叫他起來；他若犯了罪，也必蒙赦免。',
    '雅5:16 所以你們要彼此認罪，互相代求，使你們可以得醫治。義人祈禱所發的力量是大有功效的。',
    '雅5:17 以利亞與我們是一樣性情的人，他懇切禱告，求不要下雨，雨就三年零六個月不下在地上。',
    '雅5:18 他又禱告，天就降下雨來，地也生出土產。',
    '雅5:19 我的弟兄們，你們中間若有失迷真道的，有人使他回轉，',
    '雅5:20 這人該知道：叫一個罪人從迷路上轉回便是救一個靈魂不死，並且遮蓋許多的罪。',
    '彼前1:1 耶穌基督的使徒彼得寫信給那分散在本都、加拉太、加帕多家、亞西亞、庇推尼寄居的，',
    '彼前1:2 就是照父神的先見被揀選、藉著聖靈得成聖潔，以致順服耶穌基督，又蒙他血所灑的人。願恩惠、平安多多的加給你們。',
    '彼前1:3 願頌讚歸與我們主耶穌基督的父神！他曾照自己的大憐憫，藉耶穌基督從死裡復活，重生了我們，叫我們有活潑的盼望，',
    '彼前1:4 可以得著不能朽壞、不能玷污、不能衰殘、為你們存留在天上的基業。',
    '彼前1:5 你們這因信蒙神能力保守的人，必能得著所預備，到末世要顯現的救恩。',
    '彼前1:6 因此，你們是大有喜樂；但如今，在百般的試煉中暫時憂愁，',
    '彼前1:7 叫你們的信心既被試驗，就比那被火試驗仍然能壞的金子更顯寶貴，可以在耶穌基督顯現的時候得著稱讚、榮耀、尊貴。',
    '彼前1:8 你們雖然沒有見過他，卻是愛他；如今雖不得看見，卻因信他就有說不出來、滿有榮光的大喜樂；',
    '彼前1:9 並且得著你們信心的果效，就是靈魂的救恩。',
    '彼前1:10 論到這救恩，那預先說你們要得恩典的眾先知早已詳細的尋求考察，',
    '彼前1:11 就是考察在他們心裡基督的靈，預先證明基督受苦難，後來得榮耀，是指著什麼時候，並怎樣的時候。',
    '彼前1:12 他們得了啟示，知道他們所傳講（原文作服事）的一切事，不是為自己，乃是為你們。那靠著從天上差來的聖靈傳福音給你們的人，現在將這些事報給你們；天使也願意詳細察看這些事。',
    '彼前1:13 所以要約束你們的心（原文作束上你們心中的腰），謹慎自守，專心盼望耶穌基督顯現的時候所帶來給你們的恩。',
    '彼前1:14 你們既作順命的兒女，就不要效法從前蒙昧無知的時候那放縱私慾的樣子。',
    '彼前1:15 那召你們的既是聖潔，你們在一切所行的事上也要聖潔。',
    '彼前1:16 因為經上記著說：你們要聖潔，因為我是聖潔的。',
    '彼前1:17 你們既稱那不偏待人，按各人行為審判人的主為父，就當存敬畏的心度你們在世寄居的日子，',
    '彼前1:18 知道你們得贖，脫去你們祖宗所傳流虛妄的行為，不是憑著能壞的金銀等物，',
    '彼前1:19 乃是憑著基督的寶血，如同無瑕疵、無玷污的羔羊之血。',
    '彼前1:20 基督在創世以前是預先被神知道的，卻在這末世才為你們顯現。',
    '彼前1:21 你們也因著他，信那叫他從死裡復活、又給他榮耀的神，叫你們的信心和盼望都在於神。',
    '彼前1:22 你們既因順從真理，潔淨了自己的心，以致愛弟兄沒有虛假，就當從心裡（從心裡：有古卷是從清潔的心）彼此切實相愛。',
    '彼前1:23 你們蒙了重生，不是由於能壞的種子，乃是由於不能壞的種子，是藉著神活潑常存的道。',
    '彼前1:24 因為凡有血氣的，盡都如草；他的美榮都像草上的花。草必枯乾，花必凋謝；',
    '彼前1:25 惟有主的道是永存的。所傳給你們的福音就是這道。',
    '彼前2:1 所以，你們既除去一切的惡毒（或作陰毒）、詭詐，並假善、嫉妒，和一切毀謗的話，',
    '彼前2:2 就要愛慕那純淨的靈奶，像才生的嬰孩愛慕奶一樣，叫你們因此漸長，以致得救。',
    '彼前2:3 你們若嘗過主恩的滋味，就必如此。',
    '彼前2:4 主乃活石，固然是被人所棄的，卻是被神所揀選、所寶貴的。',
    '彼前2:5 你們來到主面前，也就像活石，被建造成為靈宮，作聖潔的祭司，藉著耶穌基督奉獻神所悅納的靈祭。',
    '彼前2:6 因為經上說：看哪，我把所揀選、所寶貴的房角石安放在錫安；信靠他的人必不至於羞愧。',
    '彼前2:7 所以，他在你們信的人就為寶貴，在那不信的人有話說：匠人所棄的石頭已作了房角的頭塊石頭。',
    '彼前2:8 又說：作了絆腳的石頭，跌人的磐石。他們既不順從，就在道理上絆跌（或作：他們絆跌都因不順從道理）；他們這樣絆跌也是預定的。',
    '彼前2:9 惟有你們是被揀選的族類，是有君尊的祭司，是聖潔的國度，是屬神的子民，要叫你們宣揚那召你們出黑暗入奇妙光明者的美德。',
    '彼前2:10 你們從前算不得子民，現在卻作了神的子民；從前未曾蒙憐恤，現在卻蒙了憐恤。',
    '彼前2:11 親愛的弟兄啊，你們是客旅，是寄居的。我勸你們要禁戒肉體的私慾；這私慾是與靈魂爭戰的。',
    '彼前2:12 你們在外邦人中，應當品行端正，叫那些毀謗你們是作惡的，因看見你們的好行為，便在鑒察（或作：眷顧）的日子歸榮耀給神。',
    '彼前2:13 你們為主的緣故，要順服人的一切制度，或是在上的君王，',
    '彼前2:14 或是君王所派罰惡賞善的臣宰。',
    '彼前2:15 因為神的旨意原是要你們行善，可以堵住那糊塗無知人的口。',
    '彼前2:16 你們雖是自由的，卻不可藉著自由遮蓋惡毒（或作：陰毒），總要作神的僕人。',
    '彼前2:17 務要尊敬眾人，親愛教中的弟兄，敬畏神，尊敬君王。',
    '彼前2:18 你們作僕人的，凡事要存敬畏的心順服主人；不但順服那善良溫和的，就是那乖僻的也要順服。',
    '彼前2:19 倘若人為叫良心對得住神，就忍受冤屈的苦楚，這是可喜愛的。',
    '彼前2:20 你們若因犯罪受責打，能忍耐，有什麼可誇的呢﹖但你們若因行善受苦，能忍耐，這在神看是可喜愛的。',
    '彼前2:21 你們蒙召原是為此；因基督也為你們受過苦，給你們留下榜樣，叫你們跟隨他的腳蹤行。',
    '彼前2:22 他並沒有犯罪，口裡也沒有詭詐。',
    '彼前2:23 他被罵不還口；受害不說威嚇的話，只將自己交託那按公義審判人的主。',
    '彼前2:24 他被掛在木頭上，親身擔當了我們的罪，使我們既然在罪上死，就得以在義上活。因他受的鞭傷，你們便得了醫治。',
    '彼前2:25 你們從前好像迷路的羊，如今卻歸到你們靈魂的牧人監督了。',
    '彼前3:1 你們作妻子的要順服自己的丈夫；這樣，若有不信從道理的丈夫，他們雖然不聽道，也可以因妻子的品行被感化過來；',
    '彼前3:2 這正是因看見你們有貞潔的品行和敬畏的心。',
    '彼前3:3 你們不要以外面的辮頭髮，戴金飾，穿美衣為妝飾，',
    '彼前3:4 只要以裡面存著長久溫柔，安靜的心為妝飾；這在神面前是極寶貴的。',
    '彼前3:5 因為古時仰賴神的聖潔婦人正是以此為妝飾，順服自己的丈夫，',
    '彼前3:6 就如撒拉聽從亞伯拉罕，稱他為主。你們若行善，不因恐嚇而害怕，便是撒拉的女兒了。',
    '彼前3:7 你們作丈夫的，也要按情理（原文是知識）和妻子同住；因他比你軟弱（比你軟弱：原文作是軟弱的器皿），與你一同承受生命之恩的，所以要敬重他。這樣，便叫你們的禱告沒有阻礙。',
    '彼前3:8 總而言之，你們都要同心，彼此體恤，相愛如弟兄，存慈憐謙卑的心。',
    '彼前3:9 不以惡報惡，以辱罵還辱罵，倒要祝福；因你們是為此蒙召，好叫你們承受福氣。',
    '彼前3:10 因為經上說：人若愛生命，願享美福，須要禁止舌頭不出惡言，嘴唇不說詭詐的話；',
    '彼前3:11 也要離惡行善；尋求和睦，一心追趕。',
    '彼前3:12 因為，主的眼看顧義人；主的耳聽他們的祈禱。惟有行惡的人，主向他們變臉。',
    '彼前3:13 你們若是熱心行善，有誰害你們呢﹖',
    '彼前3:14 你們就是為義受苦，也是有福的。不要怕人的威嚇（或作：所怕的），也不要驚慌；',
    '彼前3:15 只要心裡尊主基督為聖。有人問你們心中盼望的緣由，就要常作準備，以溫柔、敬畏的心回答各人；',
    '彼前3:16 存著無虧的良心，叫你們在何事上被毀謗，就在何事上可以叫那誣賴你們在基督裡有好品行的人自覺羞愧。',
    '彼前3:17 神的旨意若是叫你們因行善受苦，總強如因行惡受苦。',
    '彼前3:18 因基督也曾一次為罪受苦（有古卷作：受死），就是義的代替不義的，為要引我們到神面前。按著肉體說，他被治死；按著靈性說，他復活了。',
    '彼前3:19 他藉這靈曾去傳道給那些在監獄裡的靈聽，',
    '彼前3:20 就是那從前在挪亞預備方舟、神容忍等待的時候，不信從的人。當時進入方舟，藉著水得救的不多，只有八個人。',
    '彼前3:21 這水所表明的洗禮，現在藉著耶穌基督復活也拯救你們；這洗禮本不在乎除掉肉體的污穢，只求在神面前有無虧的良心。',
    '彼前3:22 耶穌已經進入天堂，在神的右邊；眾天使和有權柄的，並有能力的，都服從了他。',
    '彼前4:1 基督既在肉身受苦，你們也當將這樣的心志作為兵器，因為在肉身受過苦的，就已經與罪斷絕了。',
    '彼前4:2 你們存這樣的心，從今以後就可以不從人的情慾，只從神的旨意在世度餘下的光陰。',
    '彼前4:3 因為往日隨從外邦人的心意行邪淫、惡慾、醉酒、荒宴、群飲，並可惡拜偶像的事，時候已經夠了。',
    '彼前4:4 他們在這些事上，見你們不與他們同奔那放蕩無度的路，就以為怪，毀謗你們。',
    '彼前4:5 他們必在那將要審判活人死人的主面前交帳。',
    '彼前4:6 為此，就是死人也曾有福音傳給他們，要叫他們的肉體按著人受審判，他們的靈性卻靠神活著。',
    '彼前4:7 萬物的結局近了。所以，你們要謹慎自守，警醒禱告。',
    '彼前4:8 最要緊的是彼此切實相愛，因為愛能遮掩許多的罪。',
    '彼前4:9 你們要互相款待，不發怨言。',
    '彼前4:10 各人要照所得的恩賜彼此服事，作神百般恩賜的好管家。',
    '彼前4:11 若有講道的，要按著神的聖言講；若有服事人的，要按著神所賜的力量服事，叫神在凡事上因耶穌基督得榮耀。原來榮耀、權能都是他的，直到永永遠遠。阿們！',
    '彼前4:12 親愛的弟兄啊，有火煉的試驗臨到你們，不要以為奇怪（似乎是遭遇非常的事），',
    '彼前4:13 倒要歡喜；因為你們是與基督一同受苦，使你們在他榮耀顯現的時候，也可以歡喜快樂。',
    '彼前4:14 你們若為基督的名受辱罵，便是有福的；因為神榮耀的靈常住在你們身上。',
    '彼前4:15 你們中間卻不可有人因為殺人、偷竊、作惡、好管閒事而受苦。',
    '彼前4:16 若為作基督徒受苦，卻不要羞恥，倒要因這名歸榮耀給神。',
    '彼前4:17 因為時候到了，審判要從神的家起首。若是先從我們起首，那不信從神福音的人將有何等的結局呢﹖',
    '彼前4:18 若是義人僅僅得救，那不虔敬和犯罪的人將有何地可站呢﹖',
    '彼前4:19 所以那照神旨意受苦的人要一心為善，將自己靈魂交與那信實的造化之主。',
    '彼前5:1 我這作長老、作基督受苦的見證、同享後來所要顯現之榮耀的，勸你們中間與我同作長老的人：',
    '彼前5:2 務要牧養在你們中間神的群羊，按著神旨意照管他們；不是出於勉強，乃是出於甘心；也不是因為貪財，乃是出於樂意；',
    '彼前5:3 也不是轄制所託付你們的，乃是作群羊的榜樣。',
    '彼前5:4 到了牧長顯現的時候，你們必得那永不衰殘的榮耀冠冕。',
    '彼前5:5 你們年幼的，也要順服年長的。就是你們眾人也都要以謙卑束腰，彼此順服；因為神阻擋驕傲的人，賜恩給謙卑的人。',
    '彼前5:6 所以，你們要自卑，服在神大能的手下，到了時候他必叫你們升高。',
    '彼前5:7 你們要將一切的憂慮卸給神，因為他顧念你們。',
    '彼前5:8 務要謹守，警醒。因為你們的仇敵魔鬼，如同吼叫的獅子，遍地遊行，尋找可吞吃的人。',
    '彼前5:9 你們要用堅固的信心抵擋他，因為知道你們在世上的眾弟兄也是經歷這樣的苦難。',
    '彼前5:10 那賜諸般恩典的神曾在基督裡召你們，得享他永遠的榮耀，等你們暫受苦難之後，必要親自成全你們，堅固你們，賜力量給你們。',
    '彼前5:11 願權能歸給他，直到永永遠遠。阿們！',
    '彼前5:12 我略略的寫了這信，託我所看為忠心的兄弟西拉轉交你們，勸勉你們，又證明這恩是神的真恩。你們務要在這恩上站立得住。',
    '彼前5:13 在巴比倫與你們同蒙揀選的教會問你們安。我兒子馬可也問你們安。',
    '彼前5:14 你們要用愛心彼此親嘴問安。願平安歸與你們凡在基督裡的人！',
    '彼後1:1 作耶穌基督僕人和使徒的西門彼得寫信給那因我們的神和（有古卷沒有和字）救主耶穌基督之義，與我們同得一樣寶貴信心的人。',
    '彼後1:2 願恩惠、平安因你們認識神和我們主耶穌多多的加給你們。',
    '彼後1:3 神的神能已將一切關乎生命和虔敬的事賜給我們，皆因我們認識那用自己榮耀和美德召我們的主。',
    '彼後1:4 因此，他已將又寶貴又極大的應許賜給我們，叫我們既脫離世上從情慾來的敗壞，就得與神的性情有分。',
    '彼後1:5 正因這緣故，你們要分外的殷勤；有了信心，又要加上德行；有了德行，又要加上知識；',
    '彼後1:6 有了知識，又要加上節制；有了節制，又要加上忍耐；有了忍耐，又要加上虔敬；',
    '彼後1:7 有了虔敬，又要加上愛弟兄的心；有了愛弟兄的心，又要加上愛眾人的心；',
    '彼後1:8 你們若充充足足的有這幾樣，就必使你們在認識我們的主耶穌基督上不至於閒懶不結果子了。',
    '彼後1:9 人若沒有這幾樣，就是眼瞎，只看見近處的，忘了他舊日的罪已經得了潔淨。',
    '彼後1:10 所以弟兄們，應當更加殷勤，使你們所蒙的恩召和揀選堅定不移。你們若行這幾樣，就永不失腳。',
    '彼後1:11 這樣，必叫你們豐豐富富的得以進入我們主─救主耶穌基督永遠的國。',
    '彼後1:12 你們雖然曉得這些事，並且在你們已有的真道上堅固，我卻要將這些事常常提醒你們。',
    '彼後1:13 我以為應當趁我還在這帳棚的時候提醒你們，激發你們。',
    '彼後1:14 因為知道我脫離這帳棚的時候快到了，正如我們主耶穌基督所指示我的。',
    '彼後1:15 並且我要盡心竭力，使你們在我去世以後時常記念這些事。',
    '彼後1:16 我們從前將我們主耶穌基督的大能和他降臨的事告訴你們，並不是隨從乖巧捏造的虛言，乃是親眼見過他的威榮。',
    '彼後1:17 他從父神得尊貴榮耀的時候，從極大榮光之中有聲音出來，向他說：這是我的愛子，我所喜悅的。',
    '彼後1:18 我們同他在聖山的時候，親自聽見這聲音從天上出來。',
    '彼後1:19 我們並有先知更確的預言，如同燈照在暗處。你們在這預言上留意，直等到天發亮，晨星在你們心裡出現的時候，才是好的。',
    '彼後1:20 第一要緊的，該知道經上所有的預言沒有可隨私意解說的；',
    '彼後1:21 因為預言從來沒有出於人意的，乃是人被聖靈感動，說出神的話來。',
    '彼後2:1 從前在百姓中有假先知起來，將來在你們中間也必有假師傅，私自引進陷害人的異端，連買他們的主他們也不承認，自取速速的滅亡。',
    '彼後2:2 將有許多人隨從他們邪淫的行為，便叫真道因他們的緣故被毀謗。',
    '彼後2:3 他們因有貪心，要用捏造的言語在你們身上取利。他們的刑罰，自古以來並不遲延；他們的滅亡也必速速來到（原文是不打盹）。',
    '彼後2:4 就是天使犯了罪，神也沒有寬容，曾把他們丟在地獄，交在黑暗坑中，等候審判。',
    '彼後2:5 神也沒有寬容上古的世代，曾叫洪水臨到那不敬虔的世代，卻保護了傳義道的挪亞一家八口。',
    '彼後2:6 又判定所多瑪、蛾摩拉，將二城傾覆，焚燒成灰，作為後世不敬虔人的鑑戒；',
    '彼後2:7 只搭救了那常為惡人淫行憂傷的義人羅得。',
    '彼後2:8 因為那義人住在他們中間，看見聽見他們不法的事，他的義心就天天傷痛。',
    '彼後2:9 主知道搭救敬虔的人脫離試探，把不義的人留在刑罰之下，等候審判的日子。',
    '彼後2:10 那些隨肉身、縱污穢的情慾、輕慢主治之人的，更是如此。他們膽大任性，毀謗在尊位的，也不知懼怕。',
    '彼後2:11 就是天使，雖然力量權能更大，還不用毀謗的話在主面前告他們。',
    '彼後2:12 但這些人好像沒有靈性，生來就是畜類，以備捉拿宰殺的。他們毀謗所不曉得的事，正在敗壞人的時候，自己必遭遇敗壞。',
    '彼後2:13 行的不義，就得了不義的工價。這些人喜愛白晝宴樂，他們已被玷污，又有瑕疵，正與你們一同坐席，就以自己的詭詐為快樂。',
    '彼後2:14 他們滿眼是淫色（原文是淫婦），止不住犯罪，引誘那心不堅固的人，心中習慣了貪婪，正是被咒詛的種類。',
    '彼後2:15 他們離棄正路，就走差了，隨從比珥之子巴蘭的路。巴蘭就是那貪愛不義之工價的先知，',
    '彼後2:16 他卻為自己的過犯受了責備；那不能說話的驢以人言攔阻先知的狂妄。',
    '彼後2:17 這些人是無水的井，是狂風催逼的霧氣，有墨黑的幽暗為他們存留。',
    '彼後2:18 他們說虛妄矜誇的大話，用肉身的情慾和邪淫的事引誘那些剛才脫離妄行的人。',
    '彼後2:19 他們應許人得以自由，自己卻作敗壞的奴僕，因為人被誰制伏就是誰的奴僕。',
    '彼後2:20 倘若他們因認識主─救主耶穌基督，得以脫離世上的污穢，後來又在其中被纏住、制伏，他們末後的景況就比先前更不好了。',
    '彼後2:21 他們曉得義路，竟背棄了傳給他們的聖命，倒不如不曉得為妙。',
    '彼後2:22 俗語說得真不錯：狗所吐的，他轉過來又吃；豬洗淨了又回到泥裡去滾；這話在他們身上正合式。',
    '彼後3:1 親愛的弟兄啊，我現在寫給你們的是第二封信。這兩封都是提醒你們，激發你們誠實的心，',
    '彼後3:2 叫你們記念聖先知預先所說的話和主救主的命令，就是使徒所傳給你們的。',
    '彼後3:3 第一要緊的，該知道在末世必有好譏誚的人隨從自己的私慾出來譏誚說：',
    '彼後3:4 主要降臨的應許在哪裡呢﹖因為從列祖睡了以來，萬物與起初創造的時候仍是一樣。',
    '彼後3:5 他們故意忘記，從太古，憑神的命有了天，並從水而出、藉水而成的地。',
    '彼後3:6 故此，當時的世界被水淹沒就消滅了。',
    '彼後3:7 但現在的天地還是憑著那命存留，直留到不敬虔之人受審判遭沉淪的日子，用火焚燒。',
    '彼後3:8 親愛的弟兄啊，有一件事你們不可忘記，就是主看一日如千年，千年如一日。',
    '彼後3:9 主所應許的尚未成就，有人以為他是耽延，其實不是耽延，乃是寬容你們，不願有一人沉淪，乃願人人都悔改。',
    '彼後3:10 但主的日子要像賊來到一樣。那日，天必大有響聲廢去，有形質的都要被烈火銷化，地和其上的物都要燒盡了。',
    '彼後3:11 這一切既然都要如此銷化，你們為人該當怎樣聖潔，怎樣敬虔，',
    '彼後3:12 切切仰望神的日子來到。在那日，天被火燒就銷化了，有形質的都要被烈火鎔化。',
    '彼後3:13 但我們照他的應許，盼望新天新地，有義居在其中。',
    '彼後3:14 親愛的弟兄啊，你們既盼望這些事，就當殷勤，使自己沒有玷污，無可指摘，安然見主；',
    '彼後3:15 並且要以我主長久忍耐為得救的因由，就如我們所親愛的兄弟保羅，照著所賜給他的智慧寫了信給你們。',
    '彼後3:16 他一切的信上也都是講論這事。信中有些難明白的，那無學問、不堅固的人強解，如強解別的經書一樣，就自取沉淪。',
    '彼後3:17 親愛的弟兄啊，你們既然預先知道這事，就當防備，恐怕被惡人的錯謬誘惑，就從自己堅固的地步上墜落。',
    '彼後3:18 你們卻要在我們主─救主耶穌基督的恩典和知識上有長進。願榮耀歸給他，從今直到永遠。阿們！',
    '約一1:1 論到從起初原有的生命之道，就是我們所聽見、所看見、親眼看過、親手摸過的。',
    '約一1:2 （這生命已經顯現出來，我們也看見過，現在又作見證，將原與父同在、且顯現與我們那永遠的生命、傳給你們。）',
    '約一1:3 我們將所看見、所聽見的傳給你們，使你們與我們相交。我們乃是與父並他兒子耶穌基督相交的。',
    '約一1:4 我們將這些話寫給你們，使你們（有古卷作：我們）的喜樂充足。',
    '約一1:5 神就是光，在他毫無黑暗。這是我們從主所聽見、又報給你們的信息。',
    '約一1:6 我們若說是與神相交，卻仍在黑暗裡行，就是說謊話，不行真理了。',
    '約一1:7 我們若在光明中行，如同神在光明中，就彼此相交，他兒子耶穌的血也洗淨我們一切的罪。',
    '約一1:8 我們若說自己無罪，便是自欺，真理不在我們心裡了。',
    '約一1:9 我們若認自己的罪，神是信實的，是公義的，必要赦免我們的罪，洗淨我們一切的不義。',
    '約一1:10 我們若說自己沒有犯過罪，便是以神為說謊的，他的道也不在我們心裡了。',
    '約一2:1 我小子們哪，我將這些話寫給你們，是要叫你們不犯罪。若有人犯罪，在父那裡我們有一位中保，就是那義者耶穌基督。',
    '約一2:2 他為我們的罪作了挽回祭，不是單為我們的罪，也是為普天下人的罪。',
    '約一2:3 我們若遵守他的誡命，就曉得是認識他。',
    '約一2:4 人若說我認識他，卻不遵守他的誡命，便是說謊話的，真理也不在他心裡了。',
    '約一2:5 凡遵守主道的，愛神的心在他裡面實在是完全的。從此我們知道我們是在主裡面。',
    '約一2:6 人若說他住在主裡面，就該自己照主所行的去行。',
    '約一2:7 親愛的弟兄啊，我寫給你們的，不是一條新命令，乃是你們從起初所受的舊命令；這舊命令就是你們所聽見的道。',
    '約一2:8 再者，我寫給你們的，是一條新命令，在主是真的，在你們也是真的；因為黑暗漸漸過去，真光已經照耀。',
    '約一2:9 人若說自己在光明中，卻恨他的弟兄，他到如今還是在黑暗裡。',
    '約一2:10 愛弟兄的，就是住在光明中，在他並沒有絆跌的緣由。',
    '約一2:11 惟獨恨弟兄的，是在黑暗裡，且在黑暗裡行，也不知道往哪裡去，因為黑暗叫他眼睛瞎了。',
    '約一2:12 小子們哪，我寫信給你們，因為你們的罪藉著主名得了赦免。',
    '約一2:13 父老啊，我寫信給你們，因為你們認識那從起初原有的。少年人哪，我寫信給你們，因為你們勝了那惡者。小子們哪，我曾寫信給你們，因為你們認識父。',
    '約一2:14 父老啊，我曾寫信給你們，因為，你們認識那從起初原有的。少年人哪，我曾寫信給你們；因為，你們剛強，神的道常存在你們心裡；你們也勝了那惡者。',
    '約一2:15 不要愛世界和世界上的事。人若愛世界，愛父的心就不在他裡面了。',
    '約一2:16 因為凡世界上的事，就像肉體的情慾，眼目的情慾，並今生的驕傲，都不是從父來的，乃是從世界來的。',
    '約一2:17 這世界和其上的情慾都要過去，惟獨遵行神旨意的，是永遠常存。',
    '約一2:18 小子們哪，如今是末時了。你們曾聽見說，那敵基督的要來；現在已經有好些敵基督的出來了，從此我們就知道如今是末時了。',
    '約一2:19 他們從我們中間出去，卻不是屬我們的；若是屬我們的，就必仍舊與我們同在；他們出去，顯明都不是屬我們的。',
    '約一2:20 你們從那聖者受了恩膏，並且知道這一切的事（或作：都有知識）。',
    '約一2:21 我寫信給你們，不是因你們不知道真理，正是因你們知道，並且知道沒有虛謊是從真理出來的。',
    '約一2:22 誰是說謊話的呢﹖不是那不認耶穌為基督的嗎﹖不認父與子的，這就是敵基督的。',
    '約一2:23 凡不認子的，就沒有父；認子的，連父也有了。',
    '約一2:24 論到你們，務要將那從起初所聽見的，常存在心裡。若將從起初所聽見的存在心裡，你們就必住在子裡面，也必住在父裡面。',
    '約一2:25 主所應許我們的就是永生。',
    '約一2:26 我將這些話寫給你們，是指著那引誘你們的人說的。',
    '約一2:27 你們從主所受的恩膏常存在你們心裡，並不用人教訓你們，自有主的恩膏在凡事上教訓你們。這恩膏是真的，不是假的；你們要按這恩膏的教訓住在主裡面。',
    '約一2:28 小子們哪，你們要住在主裡面。這樣，他若顯現，我們就可以坦然無懼；當他來的時候，在他面前也不至於慚愧。',
    '約一2:29 你們若知道他是公義的，就知道凡行公義之人都是他所生的。',
    '約一3:1 你看父賜給我們是何等的慈愛，使我們得稱為神的兒女；我們也真是他的兒女。世人所以不認識我們，是因未曾認識他。',
    '約一3:2 親愛的弟兄啊，我們現在是神的兒女，將來如何，還未顯明，但我們知道，主若顯現，我們必要像他、因為必得見他的真體。',
    '約一3:3 凡向他有這指望的，就潔淨自己，像他潔淨一樣。',
    '約一3:4 凡犯罪的，就是違背律法；違背律法就是罪。',
    '約一3:5 你們知道主曾顯現，是要除掉人的罪；在他並沒有罪。',
    '約一3:6 凡住在他裡面的，就不犯罪；凡犯罪的，是未曾看見他，也未曾認識他。',
    '約一3:7 小子們哪，不要被人誘惑，行義的才是義人，正如主是義的一樣。',
    '約一3:8 犯罪的是屬魔鬼，因為魔鬼從起初就犯罪。神的兒子顯現出來，為要除滅魔鬼的作為。',
    '約一3:9 凡從神生的，就不犯罪，因神的道（原文作種）存在他心裡；他也不能犯罪，因為他是由神生的。',
    '約一3:10 從此就顯出誰是神的兒女，誰是魔鬼的兒女。凡不行義的就不屬神，不愛弟兄的也是如此。',
    '約一3:11 我們應當彼此相愛。這就是你們從起初所聽見的命令。',
    '約一3:12 不可像該隱；他是屬那惡者，殺了他的兄弟。為什麼殺了他呢﹖因自己的行為是惡的，兄弟的行為是善的。',
    '約一3:13 弟兄們，世人若恨你們，不要以為希奇。',
    '約一3:14 我們因為愛弟兄，就曉得是已經出死入生了。沒有愛心的，仍住在死中。',
    '約一3:15 凡恨他弟兄的，就是殺人的；你們曉得凡殺人的，沒有永生存在他裡面。',
    '約一3:16 主為我們捨命，我們從此就知道何為愛；我們也當為弟兄捨命。',
    '約一3:17 凡有世上財物的，看見弟兄窮乏，卻塞住憐恤的心，愛神的心怎能存在他裡面呢﹖',
    '約一3:18 小子們哪，我們相愛，不要只在言語和舌頭上，總要在行為和誠實上。',
    '約一3:19 從此就知道我們是屬真理的，並且我們的心在神面前可以安穩。',
    '約一3:20 我們的心若責備我們，神比我們的心大，一切事沒有不知道的。',
    '約一3:21 親愛的弟兄啊，我們的心若不責備我們，就可以向神坦然無懼了。',
    '約一3:22 並且我們一切所求的，就從他得著；因為我們遵守他的命令，行他所喜悅的事。',
    '約一3:23 神的命令就是叫我們信他兒子耶穌基督的名，且照他所賜給我們的命令彼此相愛。',
    '約一3:24 遵守神命令的，就住在神裡面；神也住在他裡面。我們所以知道神住在我們裡面是因他所賜給我們的聖靈。',
    '約一4:1 親愛的弟兄啊，一切的靈，你們不可都信，總要試驗那些靈是出於神的不是，因為世上有許多假先知已經出來了。',
    '約一4:2 凡靈認耶穌基督是成了肉身來的，就是出於神的；從此你們可以認出神的靈來。',
    '約一4:3 凡靈不認耶穌，就不是出於神；這是那敵基督者的靈。你們從前聽見他要來，現在已經在世上了。',
    '約一4:4 小子們哪，你們是屬神的，並且勝了他們；因為那在你們裡面的，比那在世界上的更大。',
    '約一4:5 他們是屬世界的，所以論世界的事，世人也聽從他們。',
    '約一4:6 我們是屬神的，認識神的就聽從我們；不屬神的就不聽從我們。從此我們可以認出真理的靈和謬妄的靈來。',
    '約一4:7 親愛的弟兄啊，我們應當彼此相愛，因為愛是從神來的。凡有愛心的，都是由神而生，並且認識神。',
    '約一4:8 沒有愛心的，就不認識神，因為神就是愛。',
    '約一4:9 神差他獨生子到世間來，使我們藉著他得生，神愛我們的心在此就顯明了。',
    '約一4:10 不是我們愛神，乃是神愛我們，差他的兒子為我們的罪作了挽回祭，這就是愛了。',
    '約一4:11 親愛的弟兄啊，神既是這樣愛我們，我們也當彼此相愛。',
    '約一4:12 從來沒有人見過神，我們若彼此相愛，神就住在我們裡面，愛他的心在我們裡面得以完全了。',
    '約一4:13 神將他的靈賜給我們，從此就知道我們是住在他裡面，他也住在我們裡面。',
    '約一4:14 父差子作世人的救主；這是我們所看見且作見證的。',
    '約一4:15 凡認耶穌為神兒子的，神就住在他裡面，他也住在神裡面。',
    '約一4:16 神愛我們的心，我們也知道也信。神就是愛；住在愛裡面的，就是住在神裡面，神也住在他裡面。',
    '約一4:17 這樣，愛在我們裡面得以完全，我們就可以在審判的日子坦然無懼。因為他如何，我們在這世上也如何。',
    '約一4:18 愛裡沒有懼怕；愛既完全，就把懼怕除去。因為懼怕裡含著刑罰，懼怕的人在愛裡未得完全。',
    '約一4:19 我們愛，因為神先愛我們。',
    '約一4:20 人若說我愛神，卻恨他的弟兄，就是說謊話的；不愛他所看見的弟兄，就不能愛沒有看見的神（有古卷作：怎能愛沒有看見的神呢）。',
    '約一4:21 愛神的，也當愛弟兄，這是我們從神所受的命令。',
    '約一5:1 凡信耶穌是基督的，都是從神而生，凡愛生他之神的，也必愛從神生的。',
    '約一5:2 我們若愛神，又遵守他的誡命，從此就知道我們愛神的兒女。',
    '約一5:3 我們遵守神的誡命，這就是愛他了，並且他的誡命不是難守的。',
    '約一5:4 因為凡從神生的，就勝過世界；使我們勝了世界的，就是我們的信心。',
    '約一5:5 勝過世界的是誰呢﹖不是那信耶穌是神兒子的嗎﹖',
    '約一5:6 這藉著水和血而來的，就是耶穌基督；不是單用水，乃是用水又用血，',
    '約一5:7 並且有聖靈作見證，因為聖靈就是真理。',
    '約一5:8 作見證的原來有三：就是聖靈、水，與血，這三樣也都歸於一。',
    '約一5:9 我們既領受人的見證，神的見證更該領受了（該領受：原文作大），因神的見證是為他兒子作的。',
    '約一5:10 信神兒子的，就有這見證在他心裡；不信神的，就是將神當作說謊的，因不信神為他兒子作的見證。',
    '約一5:11 這見證就是神賜給我們永生；這永生也是在他兒子裡面。',
    '約一5:12 人有了神的兒子就有生命，沒有神的兒子就沒有生命。',
    '約一5:13 我將這些話寫給你們信奉神兒子之名的人，要叫你們知道自己有永生。',
    '約一5:14 我們若照他的旨意求什麼，他就聽我們，這是我們向他所存坦然無懼的心。',
    '約一5:15 既然知道他聽我們一切所求的，就知道我們所求於他的，無不得著。',
    '約一5:16 人若看見弟兄犯了不至於死的罪，就當為他祈求，神必將生命賜給他；有至於死的罪，我不說當為這罪祈求。',
    '約一5:17 凡不義的事都是罪，也有不至於死的罪。',
    '約一5:18 我們知道凡從神生的，必不犯罪，從神生的，必保守自己（有古卷作：那從神生的必保護他），那惡者也就無法害他。',
    '約一5:19 我們知道，我們是屬神的，全世界都臥在那惡者手下。',
    '約一5:20 我們也知道，神的兒子已經來到，且將智慧賜給我們，使我們認識那位真實的，我們也在那位真實的裡面，就是在他兒子耶穌基督裡面。這是真神，也是永生。',
    '約一5:21 小子們哪，你們要自守，遠避偶像！',
    '約二1:1 作長老的寫信給蒙揀選的太太（或作：教會；下同），和他的兒女，就是我誠心所愛的；不但我愛，也是一切知道真理之人所愛的。',
    '約二1:2 愛你們是為真理的緣故，這真理存在我們裡面，也必永遠與我們同在。',
    '約二1:3 恩惠，憐憫，平安從父神和他兒子耶穌基督在真理和愛心上必常與我們同在！',
    '約二1:4 我見你的兒女，有照我們從父所受之命令遵行真理的，就甚歡喜。',
    '約二1:5 太太啊，我現在勸你，我們大家要彼此相愛。這並不是我寫一條新命令給你，乃是我們從起初所受的命令。',
    '約二1:6 我們若照他的命令行，這就是愛。你們從起初所聽見當行的，就是這命令。',
    '約二1:7 因為世上有許多迷惑人的出來，他們不認耶穌基督是成了肉身來的；這就是那迷惑人、敵基督的。',
    '約二1:8 你們要小心，不要失去你們（有古卷：我們）所做的工，乃要得著滿足的賞賜。',
    '約二1:9 凡越過基督的教訓、不常守著的，就沒有神；常守這教訓的，就有父又有子。',
    '約二1:10 若有人到你們那裡，不是傳這教訓，不要接他到家裡，也不要問他的安；',
    '約二1:11 因為問他安的，就在他的惡行上有分。',
    '約二1:12 我還有許多事要寫給你們，卻不願意用紙墨寫出來，但盼望到你們那裡，與你們當面談論，使你們的喜樂滿足。',
    '約二1:13 你那蒙揀選之姊妹的兒女都問你安。',
    '約三1:1 作長老的寫信給親愛的該猶，就是我誠心所愛的。',
    '約三1:2 親愛的兄弟啊，我願你凡事興盛，身體健壯，正如你的靈魂興盛一樣。',
    '約三1:3 有弟兄來證明你心裡存的真理，正如你按真理而行，我就甚喜樂。',
    '約三1:4 我聽見我的兒女們按真理而行，我的喜樂就沒有比這個大的。',
    '約三1:5 親愛的兄弟啊，凡你向作客旅之弟兄所行的都是忠心的。',
    '約三1:6 他們在教會面前證明了你的愛；你若配得過神，幫助他們往前行，這就好了。',
    '約三1:7 因他們是為主的名（原文是那名）出外，對於外邦人一無所取。',
    '約三1:8 所以我們應該接待這樣的人，叫我們與他們一同為真理做工。',
    '約三1:9 我曾略略的寫信給教會，但那在教會中好為首的丟特腓不接待我們。',
    '約三1:10 所以我若去，必要提說他所行的事，就是他用惡言妄論我們。還不以此為足，他自己不接待弟兄，有人願意接待，他也禁止，並且將接待弟兄的人趕出教會。',
    '約三1:11 親愛的兄弟啊，不要效法惡，只要效法善。行善的屬乎神；行惡的未曾見過神。',
    '約三1:12 低米丟行善，有眾人給他作見證，又有真理給他作見證；就是我們也給他作見證。你也知道我們的見證是真的。',
    '約三1:13 我原有許多事要寫給你，卻不願意用筆墨寫給你，',
    '約三1:14 但盼望快快的見你，我們就當面談論。',
    '約三1:15 願你平安。眾位朋友都問你安。請你替我按著姓名問眾位朋友安。',
    '猶1:1 耶穌基督的僕人，雅各的弟兄猶大，寫信給那被召、在父神裡蒙愛、為耶穌基督保守的人。',
    '猶1:2 願憐恤、平安、慈愛多多的加給你們。',
    '猶1:3 親愛的弟兄啊，我想盡心寫信給你們，論我們同得救恩的時候，就不得不寫信勸你們，要為從前一次交付聖徒的真道竭力的爭辯。',
    '猶1:4 因為有些人偷著進來，就是自古被定受刑罰的，是不虔誠的，將我們神的恩變作放縱情慾的機會，並且不認獨一的主宰─我們（或作和我們）主耶穌基督。',
    '猶1:5 從前主救了他的百姓出埃及地，後來就把那些不信的滅絕了。這一切的事，你們雖然都知道，我卻仍要提醒你們。',
    '猶1:6 又有不守本位、離開自己住處的天使，主用鎖鍊把他們永遠拘留在黑暗裡，等候大日的審判。',
    '猶1:7 又如所多瑪、蛾摩拉和周圍城邑的人，也照他們一味的行淫，隨從逆性的情慾，就受永火的刑罰，作為鑑戒。',
    '猶1:8 這些做夢的人也像他們污穢身體，輕慢主治的，毀謗在尊位的。',
    '猶1:9 天使長米迦勒為摩西的屍首與魔鬼爭辯的時候，尚且不敢用毀謗的話罪責他，只說：主責備你吧！',
    '猶1:10 但這些人毀謗他們所不知道的。他們本性所知道的事與那沒有靈性的畜類一樣，在這事上竟敗壞了自己。',
    '猶1:11 他們有禍了！因為走了該隱的道路，又為利往巴蘭的錯謬裡直奔，並在可拉的背叛中滅亡了。',
    '猶1:12 這樣的人在你們的愛席上與你們同吃的時候，正是礁石（或作：玷污）。他們作牧人，只知餵養自己，無所懼怕；是沒有雨的雲彩，被風飄蕩；是秋天沒有果子的樹，死而又死，連根被拔出來；',
    '猶1:13 是海裡的狂浪，湧出自己可恥的沫子來；是流蕩的星，有墨黑的幽暗為他們永遠存留。',
    '猶1:14 亞當的七世孫以諾，曾預言這些人說：看哪，主帶著他的千萬聖者降臨，',
    '猶1:15 要在眾人身上行審判，證實那一切不敬虔的人，所妄行一切不敬虔的事，又證實不敬虔之罪人所說頂撞他的剛愎話。',
    '猶1:16 這些人是私下議論，常發怨言的，隨從自己的情慾而行，口中說誇大的話，為得便宜諂媚人。',
    '猶1:17 親愛的弟兄啊，你們要記念我們主耶穌基督之使徒從前所說的話。',
    '猶1:18 他們曾對你們說過，末世必有好譏誚的人隨從自己不敬虔的私慾而行。',
    '猶1:19 這就是那些引人結黨、屬乎血氣、沒有聖靈的人。',
    '猶1:20 親愛的弟兄啊，你們卻要在至聖的真道上造就自己，在聖靈裡禱告，',
    '猶1:21 保守自己常在神的愛中，仰望我們主耶穌基督的憐憫，直到永生。',
    '猶1:22 有些人存疑心，你們要憐憫他們；',
    '猶1:23 有些人你們要從火中搶出來，搭救他們；有些人你們要存懼怕的心憐憫他們，連那被情慾沾染的衣服也當厭惡。',
    '猶1:24 那能保守你們不失腳、叫你們無瑕無疵、歡歡喜喜站在他榮耀之前的我們的救主─獨一的神，',
    '猶1:25 願榮耀、威嚴、能力、權柄，因我們的主耶穌基督歸與他，從萬古以前並現今，直到永永遠遠。阿們。',
    '啟1:1 耶穌基督的啟示，就是神賜給他，叫他將必要快成的事指示他的眾僕人。他就差遣使者曉諭他的僕人約翰。',
    '啟1:2 約翰便將神的道和耶穌基督的見證，凡自己所看見的都證明出來。',
    '啟1:3 念這書上預言的和那些聽見又遵守其中所記載的，都是有福的，因為日期近了。',
    '啟1:4 約翰寫信給亞西亞的七個教會。但願從那昔在、今在、以後永在的神，和他寶座前的七靈，',
    '啟1:5 並那誠實作見證的、從死裡首先復活、為世上君王元首的耶穌基督，有恩惠、平安歸與你們！他愛我們，用自己的血使我們脫離（有古卷作：洗去）罪惡，',
    '啟1:6 又使我們成為國民，作他父神的祭司。但願榮耀、權能歸給他，直到永永遠遠。阿們！',
    '啟1:7 看哪，他駕雲降臨！眾目要看見他，連刺他的人也要看見他；地上的萬族都要因他哀哭。這話是真實的。阿們！',
    '啟1:8 主神說：我是阿拉法，我是俄梅戛（阿拉法，俄梅戛：是希利尼字母首末二字），是昔在、今在、以後永在的全能者。',
    '啟1:9 我─約翰就是你們的弟兄，和你們在耶穌的患難、國度、忍耐裡一同有分，為神的道，並為給耶穌作的見證，曾在那名叫拔摩的海島上。',
    '啟1:10 當主日，我被聖靈感動，聽見在我後面有大聲音如吹號，說：',
    '啟1:11 你所看見的當寫在書上，達與以弗所、士每拿、別迦摩、推雅推喇、撒狄、非拉鐵非、老底嘉、那七個教會。',
    '啟1:12 我轉過身來，要看是誰發聲與我說話；既轉過來，就看見七個金燈臺。',
    '啟1:13 燈臺中間有一位好像人子，身穿長衣，直垂到腳，胸間束著金帶。',
    '啟1:14 他的頭與髮皆白，如白羊毛，如雪；眼目如同火焰；',
    '啟1:15 腳好像在爐中鍛鍊光明的銅；聲音如同眾水的聲音。',
    '啟1:16 他右手拿著七星，從他口中出來一把兩刃的利劍；面貌如同烈日放光。',
    '啟1:17 我一看見，就仆倒在他腳前，像死了一樣。他用右手按著我，說：不要懼怕！我是首先的，我是末後的，',
    '啟1:18 又是那存活的；我曾死過，現在又活了，直活到永永遠遠；並且拿著死亡和陰間的鑰匙。',
    '啟1:19 所以你要把所看見的，和現在的事，並將來必成的事，都寫出來。',
    '啟1:20 論到你所看見、在我右手中的七星和七個金燈臺的奧祕，那七星就是七個教會的使者，七燈臺就是七個教會。',
    '啟2:1 你要寫信給以弗所教會的使者，說：那右手拿著七星、在七個金燈臺中間行走的，說：',
    '啟2:2 我知道你的行為、勞碌、忍耐，也知道你不能容忍惡人。你也曾試驗那自稱為使徒卻不是使徒的，看出他們是假的來。',
    '啟2:3 你也能忍耐，曾為我的名勞苦，並不乏倦。',
    '啟2:4 然而有一件事我要責備你，就是你把起初的愛心離棄了。',
    '啟2:5 所以，應當回想你是從哪裡墜落的，並要悔改，行起初所行的事。你若不悔改，我就臨到你那裡，把你的燈臺從原處挪去。',
    '啟2:6 然而你還有一件可取的事，就是你恨惡尼哥拉一黨人的行為，這也是我所恨惡的。',
    '啟2:7 聖靈向眾教會所說的話，凡有耳的，就應當聽！得勝的，我必將神樂園中生命樹的果子賜給他吃。',
    '啟2:8 你要寫信給士每拿教會的使者，說：那首先的、末後的、死過又活的，說：',
    '啟2:9 我知道你的患難，你的貧窮（你卻是富足的），也知道那自稱是猶太人所說的毀謗話，其實他們不是猶太人，乃是撒但一會的人。',
    '啟2:10 你將要受的苦你不用怕。魔鬼要把你們中間幾個人下在監裡，叫你們被試煉，你們必受患難十日。你務要至死忠心，我就賜給你那生命的冠冕。',
    '啟2:11 聖靈向眾教會所說的話，凡有耳的，就應當聽！得勝的，必不受第二次死的害。',
    '啟2:12 你要寫信給別迦摩教會的使者，說：那有兩刃利劍的，說：',
    '啟2:13 我知道你的居所，就是有撒但座位之處；當我忠心的見證人安提帕在你們中間、撒但所住的地方被殺之時，你還堅守我的名，沒有棄絕我的道。',
    '啟2:14 然而，有幾件事我要責備你：因為在你那裡有人服從了巴蘭的教訓；這巴蘭曾教導巴勒將絆腳石放在以色列人面前，叫他們吃祭偶像之物，行姦淫的事。',
    '啟2:15 你那裡也有人照樣服從了尼哥拉一黨人的教訓。',
    '啟2:16 所以，你當悔改；若不悔改，我就快臨到你那裡，用我口中的劍攻擊他們。',
    '啟2:17 聖靈向眾教會所說的話，凡有耳的，就應當聽！得勝的，我必將那隱藏的嗎哪賜給他，並賜他一塊白石，石上寫著新名；除了那領受的以外，沒有人能認識。',
    '啟2:18 你要寫信給推雅推喇教會的使者，說：那眼目如火焰、腳像光明銅的神之子說：',
    '啟2:19 我知道你的行為、愛心、信心、勤勞、忍耐，又知道你末後所行的善事，比起初所行的更多。',
    '啟2:20 然而，有一件事我要責備你，就是你容讓那自稱是先知的婦人耶洗別教導我的僕人，引誘他們行姦淫，吃祭偶像之物。',
    '啟2:21 我曾給他悔改的機會，他卻不肯悔改他的淫行。',
    '啟2:22 看哪，我要叫他病臥在床。那些與他行淫的人，若不悔改所行的，我也要叫他們同受大患難。',
    '啟2:23 我又要殺死他的黨類（原文是兒女），叫眾教會知道，我是那察看人肺腑心腸的，並要照你們的行為報應你們各人。',
    '啟2:24 至於你們推雅推喇其餘的人，就是一切不從那教訓、不曉得他們素常所說撒但深奧之理的人，我告訴你們，我不將別的擔子放在你們身上。',
    '啟2:25 但你們已經有的，總要持守，直等到我來。',
    '啟2:26 那得勝又遵守我命令到底的，我要賜給他權柄制伏列國；',
    '啟2:27 他必用鐵杖轄管（轄管：原文是牧）他們，將他們如同窰戶的瓦器打得粉碎，像我從我父領受的權柄一樣。',
    '啟2:28 我又要把晨星賜給他。',
    '啟2:29 聖靈向眾教會所說的話，凡有耳的，就應當聽！',
    '啟3:1 你要寫信給撒狄教會的使者，說：那有神的七靈和七星的，說：我知道你的行為，按名你是活的，其實是死的。',
    '啟3:2 你要警醒，堅固那剩下將要衰微（原文是死）的；因我見你的行為，在我神面前，沒有一樣是完全的。',
    '啟3:3 所以要回想你是怎樣領受、怎樣聽見的、又要遵守，並要悔改。若不警醒，我必臨到你那裡，如同賊一樣。我幾時臨到，你也決不能知道。',
    '啟3:4 然而在撒狄，你還有幾名是未曾污穢自己衣服的，他們要穿白衣與我同行，因為他們是配得過的。',
    '啟3:5 凡得勝的必這樣穿白衣，我也必不從生命冊上塗抹他的名；且要在我父面前，和我父眾使者面前，認他的名。',
    '啟3:6 聖靈向眾教會所說的話，凡有耳的，就應當聽！',
    '啟3:7 你要寫信給非拉鐵非教會的使者，說：那聖潔、真實、拿著大衛的鑰匙、開了就沒有人能關、關了就沒有人能開的，說：',
    '啟3:8 我知道你的行為，你略有一點力量，也曾遵守我的道，沒有棄絕我的名。看哪，我在你面前給你一個敞開的門，是無人能關的。',
    '啟3:9 那撒但一會的，自稱是猶太人，其實不是猶太人，乃是說謊話的，我要使他們來，在你腳前下拜，也使他們知道我是已經愛你了。',
    '啟3:10 你既遵守我忍耐的道，我必在普天下人受試煉的時候，保守你免去你的試煉。',
    '啟3:11 我必快來，你要持守你所有的，免得人奪去你的冠冕。',
    '啟3:12 得勝的，我要叫他在我神殿中作柱子，他也必不再從那裡出去。我又要將我神的名和我神城的名（這城就是從天上、從我神那裡降下來的新耶路撒冷），並我的新名，都寫在他上面。',
    '啟3:13 聖靈向眾教會所說的話，凡有耳的，就應當聽！',
    '啟3:14 你要寫信給老底嘉教會的使者，說：那為阿們的，為誠信真實見證的，在神創造萬物之上為元首的，說：',
    '啟3:15 我知道你的行為，你也不冷也不熱；我巴不得你或冷或熱。',
    '啟3:16 你既如溫水，也不冷也不熱，所以我必從我口中把你吐出去。',
    '啟3:17 你說：我是富足，已經發了財，一樣都不缺；卻不知道你是那困苦、可憐、貧窮、瞎眼、赤身的。',
    '啟3:18 我勸你向我買火煉的金子，叫你富足；又買白衣穿上，叫你赤身的羞恥不露出來；又買眼藥擦你的眼睛，使你能看見。',
    '啟3:19 凡我所疼愛的，我就責備管教他；所以你要發熱心，也要悔改。',
    '啟3:20 看哪，我站在門外叩門，若有聽見我聲音就開門的，我要進到他那裡去，我與他，他與我一同坐席。',
    '啟3:21 得勝的，我要賜他在我寶座上與我同坐，就如我得了勝，在我父的寶座上與他同坐一般。',
    '啟3:22 聖靈向眾教會所說的話，凡有耳的，就應當聽！',
    '啟4:1 此後，我觀看，見天上有門開了。我初次聽見好像吹號的聲音，對我說：你上到這裡來，我要將以後必成的事指示你。',
    '啟4:2 我立刻被聖靈感動，見有一個寶座安置在天上，又有一位坐在寶座上。',
    '啟4:3 看那坐著的，好像碧玉和紅寶石；又有虹圍著寶座，好像綠寶石。',
    '啟4:4 寶座的周圍又有二十四個座位；其上坐著二十四位長老，身穿白衣，頭上戴著金冠冕。',
    '啟4:5 有閃電、聲音、雷轟從寶座中發出；又有七盞火燈在寶座前點著；這七燈就是神的七靈。',
    '啟4:6 寶座前好像一個玻璃海，如同水晶。寶座中和寶座周圍有四個活物，前後遍體都滿了眼睛。',
    '啟4:7 第一個活物像獅子，第二個像牛犢，第三個臉面像人，第四個像飛鷹。',
    '啟4:8 四活物各有六個翅膀，遍體內外都滿了眼睛。他們晝夜不住的說：聖哉！聖哉！聖哉！主神是昔在、今在、以後永在的全能者。',
    '啟4:9 每逢四活物將榮耀、尊貴、感謝歸給那坐在寶座上、活到永永遠遠者的時候，',
    '啟4:10 那二十四位長老就俯伏在坐寶座的面前敬拜那活到永永遠遠的，又把他們的冠冕放在寶座前，說：',
    '啟4:11 我們的主，我們的神，你是配得榮耀、尊貴、權柄的；因為你創造了萬物，並且萬物是因你的旨意被創造而有的。',
    '啟5:1 我看見坐寶座的右手中有書卷，裡外都寫著字，用七印封嚴了。',
    '啟5:2 我又看見一位大力的天使大聲宣傳說：有誰配展開那書卷，揭開那七印呢﹖',
    '啟5:3 在天上、地上、地底下，沒有能展開、能觀看那書卷的。',
    '啟5:4 因為沒有配展開、配觀看那書卷的，我就大哭。',
    '啟5:5 長老中有一位對我說：不要哭。看哪，猶大支派中的獅子，大衛的根，他已得勝，能以展開那書卷，揭開那七印。',
    '啟5:6 我又看見寶座與四活物，並長老之中有羔羊站立，像是被殺過的，有七角七眼，就是神的七靈，奉差遣往普天下去的。',
    '啟5:7 這羔羊前來，從坐寶座的右手裡拿了書卷。',
    '啟5:8 他既拿了書卷，四活物和二十四位長老就俯伏在羔羊面前，各拿著琴和盛滿了香的金爐；這香就是眾聖徒的祈禱。',
    '啟5:9 他們唱新歌，說：你配拿書卷，配揭開七印；因為你曾被殺，用自己的血從各族、各方、各民、各國中買了人來，叫他們歸於神，',
    '啟5:10 又叫他們成為國民，作祭司歸於神，在地上執掌王權。',
    '啟5:11 我又看見且聽見，寶座與活物並長老的周圍有許多天使的聲音；他們的數目有千千萬萬，',
    '啟5:12 大聲說：曾被殺的羔羊是配得權柄、豐富、智慧、能力、尊貴、榮耀、頌讚的。',
    '啟5:13 我又聽見在天上、地上、地底下、滄海裡，和天地間一切所有被造之物，都說：但願頌讚、尊貴、榮耀、權勢都歸給坐寶座的和羔羊，直到永永遠遠！',
    '啟5:14 四活物就說：阿們！眾長老也俯伏敬拜。',
    '啟6:1 我看見羔羊揭開七印中第一印的時候，就聽見四活物中的一個活物，聲音如雷，說：你來！',
    '啟6:2 我就觀看，見有一匹白馬；騎在馬上的，拿著弓，並有冠冕賜給他。他便出來，勝了又要勝。',
    '啟6:3 揭開第二印的時候，我聽見第二個活物說：你來。',
    '啟6:4 就另有一匹馬出來，是紅的，有權柄給了那騎馬的，可以從地上奪去太平，使人彼此相殺；又有一把大刀賜給他。',
    '啟6:5 揭開第三印的時候，我聽見第三個活物說：你來！我就觀看，見有一匹黑馬；騎在馬上的，手裡拿著天平。',
    '啟6:6 我聽見在四活物中似乎有聲音說：一錢銀子買一升麥子，一錢銀子買三升大麥；油和酒不可糟蹋。',
    '啟6:7 揭開第四印的時候，我聽見第四個活物說：你來！',
    '啟6:8 我就觀看，見有一匹灰色馬；騎在馬上的，名字叫做死，陰府也隨著他；有權柄賜給他們，可以用刀劍、饑荒、瘟疫（或作：死亡）、野獸，殺害地上四分之一的人。',
    '啟6:9 揭開第五印的時候，我看見在祭壇底下，有為神的道、並為作見證被殺之人的靈魂，',
    '啟6:10 大聲喊著說：聖潔真實的主啊，你不審判住在地上的人，給我們伸流血的冤，要等到幾時呢﹖',
    '啟6:11 於是有白衣賜給他們各人；又有話對他們說，還要安息片時，等著一同作僕人的和他們的弟兄也像他們被殺，滿足了數目。',
    '啟6:12 揭開第六印的時候，我又看見地大震動，日頭變黑像毛布，滿月變紅像血，',
    '啟6:13 天上的星辰墜落於地，如同無花果樹被大風搖動，落下未熟的果子一樣。',
    '啟6:14 天就挪移，好像書卷被捲起來；山嶺海島都被挪移離開本位。',
    '啟6:15 地上的君王、臣宰、將軍、富戶、壯士，和一切為奴的、自主的，都藏在山洞和巖石穴裡，',
    '啟6:16 向山和巖石說：倒在我們身上吧！把我們藏起來，躲避坐寶座者的面目和羔羊的忿怒；',
    '啟6:17 因為他們忿怒的大日到了，誰能站得住呢﹖',
    '啟7:1 此後，我看見四位天使站在地的四角，執掌地上四方的風，叫風不吹在地上、海上，和樹上。',
    '啟7:2 我又看見另有一位天使，從日出之地上來，拿著永生神的印。他就向那得著權柄能傷害地和海的四位天使大聲喊著說：',
    '啟7:3 地與海並樹木，你們不可傷害，等我們印了我們神眾僕人的額。',
    '啟7:4 我聽見以色列人各支派中受印的數目有十四萬四千。',
    '啟7:5 猶大支派中受印的有一萬二千；流便支派中有一萬二千；迦得支派中有一萬二千；',
    '啟7:6 亞設支派中有一萬二千；拿弗他利支派中有一萬二千；瑪拿西支派中有一萬二千；',
    '啟7:7 西緬支派中有一萬二千；利未支派中有一萬二千；以薩迦支派中有一萬二千；',
    '啟7:8 西布倫支派中有一萬二千；約瑟支派中有一萬二千；便雅憫支派中受印的有一萬二千。',
    '啟7:9 此後，我觀看，見有許多的人，沒有人能數過來，是從各國、各族、各民、各方來的，站在寶座和羔羊面前，身穿白衣，手拿棕樹枝，',
    '啟7:10 大聲喊著說：願救恩歸與坐在寶座上我們的神，也歸與羔羊！',
    '啟7:11 眾天使都站在寶座和眾長老並四活物的周圍，在寶座前，面伏於地，敬拜神，',
    '啟7:12 說：阿們！頌讚、榮耀、智慧、感謝、尊貴、權柄、大力都歸與我們的神，直到永永遠遠。阿們！',
    '啟7:13 長老中有一位問我說：這些穿白衣的是誰﹖是從哪裡來的﹖',
    '啟7:14 我對他說：我主，你知道。他向我說：這些人是從大患難中出來的，曾用羔羊的血把衣裳洗白淨了。',
    '啟7:15 所以，他們在神寶座前，晝夜在他殿中事奉他。坐寶座的要用帳幕覆庇他們。',
    '啟7:16 他們不再飢，不再渴；日頭和炎熱也必不傷害他們。',
    '啟7:17 因為寶座中的羔羊必牧養他們，領他們到生命水的泉源；神也必擦去他們一切的眼淚。',
    '啟8:1 羔羊揭開第七印的時候，天上寂靜約有二刻。',
    '啟8:2 我看見那站在神面前的七位天使，有七枝號賜給他們。',
    '啟8:3 另有一位天使，拿著金香爐來，站在祭壇旁邊。有許多香賜給他，要和眾聖徒的祈禱一同獻在寶座前的金壇上。',
    '啟8:4 那香的煙和眾聖徒的祈禱從天使的手中一同升到神面前。',
    '啟8:5 天使拿著香爐，盛滿了壇上的火，倒在地上；隨有雷轟、大聲、閃電、地震。',
    '啟8:6 拿著七枝號的七位天使就預備要吹。',
    '啟8:7 第一位天使吹號，就有雹子與火攙著血丟在地上；地的三分之一和樹的三分之一被燒了，一切的青草也被燒了。',
    '啟8:8 第二位天使吹號，就有彷彿火燒著的大山扔在海中；海的三分之一變成血，',
    '啟8:9 海中的活物死了三分之一，船隻也壞了三分之一。',
    '啟8:10 第三位天使吹號，就有燒著的大星，好像火把從天上落下來，落在江河的三分之一和眾水的泉源上。',
    '啟8:11 這星名叫茵蔯。眾水的三分之一變為茵蔯；因水變苦，就死了許多人。',
    '啟8:12 第四位天使吹號，日頭的三分之一，月亮的三分之一、星辰的三分之一都被擊打，以致日月星的三分之一黑暗了，白晝的三分之一沒有光，黑夜也是這樣。',
    '啟8:13 我又看見一個鷹飛在空中，並聽見他大聲說：三位天使要吹那其餘的號。你們住在地上的民，禍哉！禍哉！禍哉！',
    '啟9:1 第五位天使吹號，我就看見一個星從天落到地上，有無底坑的鑰匙賜給他。',
    '啟9:2 他開了無底坑，便有煙從坑裡往上冒，好像大火爐的煙；日頭和天空都因這煙昏暗了。',
    '啟9:3 有蝗蟲從煙中出來，飛到地上；有能力賜給他們，好像地上蠍子的能力一樣，',
    '啟9:4 並且吩咐他們說，不可傷害地上的草和各樣青物，並一切樹木，惟獨要傷害額上沒有神印記的人。',
    '啟9:5 但不許蝗蟲害死他們，只叫他們受痛苦五個月。這痛苦就像蠍子螫人的痛苦一樣。',
    '啟9:6 在那些日子，人要求死，決不得死；願意死，死卻遠避他們。',
    '啟9:7 蝗蟲的形狀，好像預備出戰的馬一樣，頭上戴的好像金冠冕，臉面好像男人的臉面，',
    '啟9:8 頭髮像女人的頭髮，牙齒像獅子的牙齒。',
    '啟9:9 胸前有甲，好像鐵甲。他們翅膀的聲音，好像許多車馬奔跑上陣的聲音。',
    '啟9:10 有尾巴像蠍子，尾巴上的毒鉤能傷人五個月。',
    '啟9:11 有無底坑的使者作他們的王，按著希伯來話，名叫亞巴頓，希利尼話，名叫亞玻倫。',
    '啟9:12 第一樣災禍過去了，還有兩樣災禍要來。',
    '啟9:13 第六位天使吹號，我就聽見有聲音從神面前金壇的四角出來，',
    '啟9:14 吩咐那吹號的第六位天使，說：把那捆綁在伯拉大河的四個使者釋放了。',
    '啟9:15 那四個使者就被釋放；他們原是預備好了，到某年某月某日某時，要殺人的三分之一。',
    '啟9:16 馬軍有二萬萬；他們的數目我聽見了。',
    '啟9:17 我在異象中看見那些馬和騎馬的，騎馬的胸前有甲如火，與紫瑪瑙並硫磺。馬的頭好像獅子頭，有火、有煙、有硫磺從馬的口中出來。',
    '啟9:18 口中所出來的火與煙並硫磺，這三樣災殺了人的三分之一。',
    '啟9:19 這馬的能力是在口裡和尾巴上；因這尾巴像蛇，並且有頭用以害人。',
    '啟9:20 其餘未曾被這些災所殺的人仍舊不悔改自己手所做的，還是去拜鬼魔和那些不能看、不能聽、不能走，金、銀、銅、木、石的偶像，',
    '啟9:21 又不悔改他們那些兇殺、邪術、姦淫、偷竊的事。',
    '啟10:1 我又看見另有一位大力的天使從天降下，披著雲彩，頭上有虹，臉面像日頭，兩腳像火柱。',
    '啟10:2 他手裡拿著小書卷，是展開的。他右腳踏海，左腳踏地，',
    '啟10:3 大聲呼喊，好像獅子吼叫。呼喊完了，就有七雷發聲。',
    '啟10:4 七雷發聲之後，我正要寫出來，就聽見從天上有聲音說：七雷所說的，你要封上，不可寫出來。',
    '啟10:5 我所看見的那踏海踏地的天使向天舉起右手來，',
    '啟10:6 指著那創造天和天上之物，地和地上之物，海和海中之物，直活到永永遠遠的，起誓說：不再有時日了（或作：不再耽延了）。',
    '啟10:7 但在第七位天使吹號發聲的時候，神的奧祕就成全了，正如神所傳給他僕人眾先知的佳音。',
    '啟10:8 我先前從天上所聽見的那聲音又吩咐我說：你去，把那踏海踏地之天使手中展開的小書卷取過來。',
    '啟10:9 我就走到天使那裡，對他說：請你把小書卷給我。他對我說：你拿著吃盡了，便叫你肚子發苦，然而在你口中要甜如蜜。',
    '啟10:10 我從天使手中把小書卷接過來，吃盡了，在我口中果然甜如蜜，吃了以後，肚子覺得發苦了。',
    '啟10:11 天使（原文是他們）對我說：你必指著多民、多國、多方、多王再說預言。',
    '啟11:1 有一根葦子賜給我，當作量度的杖，且有話說：起來！將神的殿和祭壇，並在殿中禮拜的人都量一量。',
    '啟11:2 只是殿外的院子要留下不用量，因為這是給了外邦人的；他們要踐踏聖城四十二個月。',
    '啟11:3 我要使我那兩個見證人，穿著毛衣，傳道一千二百六十天。',
    '啟11:4 他們就是那兩棵橄欖樹，兩個燈臺，立在世界之主面前的。',
    '啟11:5 若有人想要害他們，就有火從他們口中出來，燒滅仇敵。凡想要害他們的都必這樣被殺。',
    '啟11:6 這二人有權柄，在他們傳道的日子叫天閉塞不下雨；又有權柄叫水變為血，並且能隨時隨意用各樣的災殃攻擊世界。',
    '啟11:7 他們作完見證的時候，那從無底坑裡上來的獸必與他們交戰，並且得勝，把他們殺了。',
    '啟11:8 他們的屍首就倒在大城裡的街上；這城按著靈意叫所多瑪，又叫埃及，就是他們的主釘十字架之處。',
    '啟11:9 從各民、各族、各方、各國中，有人觀看他們的屍首三天半，又不許把屍首放在墳墓裡。',
    '啟11:10 住在地上的人就為他們歡喜快樂，互相餽送禮物，因這兩位先知曾叫住在地上的人受痛苦。',
    '啟11:11 過了這三天半，有生氣從神那裡進入他們裡面，他們就站起來；看見他們的人甚是害怕。',
    '啟11:12 兩位先知聽見有大聲音從天上來，對他們說：上到這裡來。他們就駕著雲上了天，他們的仇敵也看見了。',
    '啟11:13 正在那時候，地大震動，城就倒塌了十分之一，因地震而死的有七千人；其餘的都恐懼，歸榮耀給天上的神。',
    '啟11:14 第二樣災禍過去，第三樣災禍快到了。',
    '啟11:15 第七位天使吹號，天上就有大聲音說：世上的國成了我主和主基督的國；他要作王，直到永永遠遠。',
    '啟11:16 在神面前，坐在自己位上的二十四位長老，就面伏於地，敬拜神，',
    '啟11:17 說：昔在、今在的主神─全能者啊，我們感謝你！因你執掌大權作王了。',
    '啟11:18 外邦發怒，你的忿怒也臨到了；審判死人的時候也到了。你的僕人眾先知和眾聖徒，凡敬畏你名的人，連大帶小得賞賜的時候也到了。你敗壞那些敗壞世界之人的時候也就到了。',
    '啟11:19 當時，神天上的殿開了，在他殿中現出他的約櫃。隨後有閃電、聲音、雷轟、地震、大雹。',
    '啟12:1 天上現出大異象來：有一個婦人身披日頭，腳踏月亮，頭戴十二星的冠冕。',
    '啟12:2 他懷了孕，在生產的艱難中疼痛呼叫。',
    '啟12:3 天上又現出異象來：有一條大紅龍，七頭十角；七頭上戴著七個冠冕。',
    '啟12:4 他的尾巴拖拉著天上星辰的三分之一，摔在地上。龍就站在那將要生產的婦人面前，等他生產之後，要吞吃他的孩子。',
    '啟12:5 婦人生了一個男孩子，是將來要用鐵杖轄管（轄管：原文是牧）萬國的；他的孩子被提到神寶座那裡去了。',
    '啟12:6 婦人就逃到曠野，在那裡有神給他預備的地方，使他被養活一千二百六十天。',
    '啟12:7 在天上就有了爭戰。米迦勒同他的使者與龍爭戰，龍也同他的使者去爭戰，',
    '啟12:8 並沒有得勝，天上再沒有他們的地方。',
    '啟12:9 大龍就是那古蛇，名叫魔鬼，又叫撒但，是迷惑普天下的。他被摔在地上，他的使者也一同被摔下去。',
    '啟12:10 我聽見在天上有大聲音說：我神的救恩、能力、國度、並他基督的權柄，現在都來到了！因為那在我們神面前晝夜控告我們弟兄的，已經被摔下去了。',
    '啟12:11 弟兄勝過他，是因羔羊的血和自己所見證的道。他們雖至於死，也不愛惜性命。',
    '啟12:12 所以，諸天和住在其中的，你們都快樂吧！只是地與海有禍了！因為魔鬼知道自己的時候不多，就氣忿忿的下到你們那裡去了。',
    '啟12:13 龍見自己被摔在地上，就逼迫那生男孩子的婦人。',
    '啟12:14 於是有大鷹的兩個翅膀賜給婦人，叫他能飛到曠野，到自己的地方，躲避那蛇；他在那裡被養活一載二載半載。',
    '啟12:15 蛇就在婦人身後，從口中吐出水來，像河一樣，要將婦人沖去。',
    '啟12:16 地卻幫助婦人，開口吞了從龍口吐出來的水（原文作河）。',
    '啟12:17 龍向婦人發怒，去與他其餘的兒女爭戰，這兒女就是那守神誡命、為耶穌作見證的。那時龍就站在海邊的沙上。',
    '啟13:1 我又看見一個獸從海中上來，有十角七頭，在十角上戴著十個冠冕，七頭上有褻瀆的名號。',
    '啟13:2 我所看見的獸，形狀像豹，腳像熊的腳，口像獅子的口。那龍將自己的能力、座位、和大權柄都給了他。',
    '啟13:3 我看見獸的七頭中，有一個似乎受了死傷，那死傷卻醫好了。全地的人都希奇跟從那獸，',
    '啟13:4 又拜那龍─因為他將自己的權柄給了獸，也拜獸，說：誰能比這獸，誰能與他交戰呢﹖',
    '啟13:5 又賜給他說誇大褻瀆話的口，又有權柄賜給他，可以任意而行四十二個月。',
    '啟13:6 獸就開口向神說褻瀆的話，褻瀆神的名並他的帳幕，以及那些住在天上的。',
    '啟13:7 又任憑他與聖徒爭戰，並且得勝；也把權柄賜給他，制伏各族、各民、各方、各國。',
    '啟13:8 凡住在地上、名字從創世以來沒有記在被殺之羔羊生命冊上的人，都要拜他。',
    '啟13:9 凡有耳的，就應當聽！',
    '啟13:10 擄掠人的，必被擄掠；用刀殺人的，必被刀殺。聖徒的忍耐和信心就是在此。',
    '啟13:11 我又看見另有一個獸從地中上來有兩角如同羊羔，說話好像龍。',
    '啟13:12 他在頭一個獸面前，施行頭一個獸所有的權柄，並且叫地和住在地上的人拜那死傷醫好的頭一個獸。',
    '啟13:13 又行大奇事，甚至在人面前，叫火從天降在地上。',
    '啟13:14 他因賜給他權柄在獸面前能行奇事，就迷惑住在地上的人，說：要給那受刀傷還活著的獸作個像。',
    '啟13:15 又有權柄賜給他，叫獸像有生氣，並且能說話，又叫所有不拜獸像的人都被殺害。',
    '啟13:16 他又叫眾人，無論大小、貧富、自主的、為奴的，都在右手上或是在額上受一個印記。',
    '啟13:17 除了那受印記、有了獸名或有獸名數目的，都不得做買賣。',
    '啟13:18 在這裡有智慧：凡有聰明的，可以算計獸的數目；因為這是人的數目，他的數目是六百六十六。',
    '啟14:1 我又觀看，見羔羊站在錫安山，同他又有十四萬四千人，都有他的名和他父的名寫在額上。',
    '啟14:2 我聽見從天上有聲音，像眾水的聲音和大雷的聲音，並且我所聽見的好像彈琴的所彈的琴聲。',
    '啟14:3 他們在寶座前，並在四活物和眾長老前唱歌，彷彿是新歌；除了從地上買來的那十四萬四千人以外，沒有人能學這歌。',
    '啟14:4 這些人未曾沾染婦女，他們原是童身。羔羊無論往哪裡去，他們都跟隨他。他們是從人間買來的，作初熟的果子歸與神和羔羊。',
    '啟14:5 在他們口中察不出謊言來；他們是沒有瑕疵的。',
    '啟14:6 我又看見另有一位天使飛在空中，有永遠的福音要傳給住在地上的人，就是各國、各族、各方、各民。',
    '啟14:7 他大聲說：應當敬畏神，將榮耀歸給他！因他施行審判的時候已經到了。應當敬拜那創造天地海和眾水泉源的。',
    '啟14:8 又有第二位天使接著說：叫萬民喝邪淫、大怒之酒的巴比倫大城傾倒了！傾倒了！',
    '啟14:9 又有第三位天使接著他們，大聲說：若有人拜獸和獸像，在額上或在手上受了印記，',
    '啟14:10 這人也必喝神大怒的酒；此酒斟在神忿怒的杯中純一不雜。他要在聖天使和羔羊面前，在火與硫磺之中受痛苦。',
    '啟14:11 他受痛苦的煙往上冒，直到永永遠遠。那些拜獸和獸像，受他名之印記的，晝夜不得安寧。',
    '啟14:12 聖徒的忍耐就在此；他們是守神誡命和耶穌真道的。',
    '啟14:13 我聽見從天上有聲音說：你要寫下：從今以後，在主裡面而死的人有福了！聖靈說：是的，他們息了自己的勞苦，做工的果效也隨著他們。',
    '啟14:14 我又觀看，見有一片白雲，雲上坐著一位好像人子，頭上戴著金冠冕，手裡拿著快鐮刀。',
    '啟14:15 又有一位天使從殿中出來，向那坐在雲上的大聲喊著說：伸出你的鐮刀來收割；因為收割的時候已經到了，地上的莊稼已經熟透了。',
    '啟14:16 那坐在雲上的，就把鐮刀扔在地上，地上的莊稼就被收割了。',
    '啟14:17 又有一位天使從天上的殿中出來，他也拿著快鐮刀。',
    '啟14:18 又有一位天使從祭壇中出來，是有權柄管火的，向拿著快鐮刀的大聲喊著說：伸出快鐮刀來，收取地上葡萄樹的果子，因為葡萄熟透了！',
    '啟14:19 那天使就把鐮刀扔在地上，收取了地上的葡萄，丟在神忿怒的大酒醡中。',
    '啟14:20 那酒醡踹在城外，就有血從酒醡裡流出來，高到馬的嚼環，遠有六百里。',
    '啟15:1 我又看見在天上有異象，大而且奇，就是七位天使掌管末了的七災，因為神的大怒在這七災中發盡了。',
    '啟15:2 我看見彷彿有玻璃海，其中有火攙雜。又看見那些勝了獸和獸的像並他名字數目的人，都站在玻璃海上，拿著神的琴，',
    '啟15:3 唱神僕人摩西的歌，和羔羊的歌，說：主神─全能者啊，你的作為大哉！奇哉！萬世（或作：國）之王啊，你的道途義哉！誠哉！',
    '啟15:4 主啊，誰敢不敬畏你，不將榮耀歸與你的名呢﹖因為獨有你是聖的。萬民都要來在你面前敬拜，因你公義的作為已經顯出來了。',
    '啟15:5 此後，我看見在天上那存法櫃的殿開了。',
    '啟15:6 那掌管七災的七位天使從殿中出來，穿著潔白光明的細麻衣（細麻衣；有古卷是寶石），胸間束著金帶。',
    '啟15:7 四活物中有一個把盛滿了活到永永遠遠之神大怒的七個金碗給了那七位天使。',
    '啟15:8 因神的榮耀和能力，殿中充滿了煙。於是沒有人能以進殿，直等到那七位天使所降的七災完畢了。',
    '啟16:1 我聽見有大聲音從殿中出來，向那七位天使說：你們去，把盛神大怒的七碗倒在地上。',
    '啟16:2 第一位天使便去，把碗倒在地上，就有惡而且毒的瘡生在那些有獸印記、拜獸像的人身上。',
    '啟16:3 第二位天使把碗倒在海裡，海就變成血，好像死人的血，海中的活物都死了。',
    '啟16:4 第三位天使把碗倒在江河與眾水的泉源裡，水就變成血了。',
    '啟16:5 我聽見掌管眾水的天使說：昔在、今在的聖者啊，你這樣判斷是公義的；',
    '啟16:6 他們曾流聖徒與先知的血，現在你給他們血喝；這是他們所該受的。',
    '啟16:7 我又聽見祭壇中有聲音說：是的，主神─全能者啊，你的判斷義哉！誠哉！',
    '啟16:8 第四位天使把碗倒在日頭上，叫日頭能用火烤人。',
    '啟16:9 人被大熱所烤，就褻瀆那有權掌管這些災的神之名，並不悔改將榮耀歸給神。',
    '啟16:10 第五位天使把碗倒在獸的座位上，獸的國就黑暗了。人因疼痛就咬自己的舌頭；',
    '啟16:11 又因所受的疼痛，和生的瘡，就褻瀆天上的神，並不悔改所行的。',
    '啟16:12 第六位天使把碗倒在伯拉大河上，河水就乾了，要給那從日出之地所來的眾王預備道路。',
    '啟16:13 我又看見三個污穢的靈，好像青蛙，從龍口、獸口並假先知的口中出來。',
    '啟16:14 他們本是鬼魔的靈，施行奇事，出去到普天下眾王那裡，叫他們在神全能者的大日聚集爭戰。',
    '啟16:15 （看哪，我來像賊一樣。那警醒、看守衣服、免得赤身而行、叫人見他羞恥的有福了！）',
    '啟16:16 那三個鬼魔便叫眾王聚集在一處，希伯來話叫做哈米吉多頓。',
    '啟16:17 第七位天使把碗倒在空中，就有大聲音從殿中的寶座上出來，說：成了！',
    '啟16:18 又有閃電、聲音、雷轟、大地震，自從地上有人以來，沒有這樣大、這樣厲害的地震。',
    '啟16:19 那大城裂為三段，列國的城也都倒塌了；神也想起巴比倫大城來，要把那盛自己烈怒的酒杯遞給他。',
    '啟16:20 各海島都逃避了，眾山也不見了。',
    '啟16:21 又有大雹子從天落在人身上，每一個約重一他連得（一他連得約有九十斤）。為這雹子的災極大，人就褻瀆神。',
    '啟17:1 拿著七碗的七位天使中，有一位前來對我說：你到這裡來，我將坐在眾水上的大淫婦所要受的刑罰指給你看。',
    '啟17:2 地上的君王與他行淫，住在地上的人喝醉了他淫亂的酒。',
    '啟17:3 我被聖靈感動，天使帶我到曠野去，我就看見一個女人騎在朱紅色的獸上；那獸有七頭十角，遍體有褻瀆的名號。',
    '啟17:4 那女人穿著紫色和朱紅色的衣服，用金子、寶石、珍珠為妝飾；手拿金杯，杯中盛滿了可憎之物，就是他淫亂的污穢。',
    '啟17:5 在他額上有名寫著說：奧祕哉！大巴比倫，作世上的淫婦和一切可憎之物的母。',
    '啟17:6 我又看見那女人喝醉了聖徒的血和為耶穌作見證之人的血。我看見他，就大大的希奇。',
    '啟17:7 天使對我說：你為什麼希奇呢﹖我要將這女人和馱著他的那七頭十角獸的奧祕告訴你。',
    '啟17:8 你所看見的獸，先前有，如今沒有，將要從無底坑裡上來，又要歸於沉淪。凡住在地上、名字從創世以來沒有記在生命冊上的，見先前有、如今沒有、以後再有的獸，就必希奇。',
    '啟17:9 智慧的心在此可以思想。那七頭就是女人所坐的七座山，',
    '啟17:10 又是七位王；五位已經傾倒了，一位還在，一位還沒有來到；他來的時候，必須暫時存留。',
    '啟17:11 那先前有如今沒有的獸，就是第八位；他也和那七位同列，並且歸於沉淪。',
    '啟17:12 你所看見的那十角就是十王；他們還沒有得國，但他們一時之間要和獸同得權柄，與王一樣。',
    '啟17:13 他們同心合意將自己的能力、權柄給那獸。',
    '啟17:14 他們與羔羊爭戰，羔羊必勝過他們，因為羔羊是萬主之主、萬王之王。同著羔羊的，就是蒙召、被選、有忠心的，也必得勝。',
    '啟17:15 天使又對我說，你所看見那淫婦坐的眾水，就是多民、多人、多國、多方。',
    '啟17:16 你所看見的那十角與獸必恨這淫婦，使他冷落赤身，又要吃他的肉，用火將他燒盡。',
    '啟17:17 因為神使諸王同心合意，遵行他的旨意，把自己的國給那獸，直等到神的話都應驗了。',
    '啟17:18 你所看見的那女人就是管轄地上眾王的大城。',
    '啟18:1 此後，我看見另有一位有大權柄的天使從天降下，地就因他的榮耀發光。',
    '啟18:2 他大聲喊著說：巴比倫大城傾倒了！傾倒了！成了鬼魔的住處和各樣污穢之靈的巢穴（或作：牢獄；下同），並各樣污穢可憎之雀鳥的巢穴。',
    '啟18:3 因為列國都被他邪淫大怒的酒傾倒了。地上的君王與他行淫；地上的客商因他奢華太過就發了財。',
    '啟18:4 我又聽見從天上有聲音說：我的民哪，你們要從那城出來，免得與他一同有罪，受他所受的災殃；',
    '啟18:5 因他的罪惡滔天；他的不義神已經想起來了。',
    '啟18:6 他怎樣待人，也要怎樣待他，按他所行的加倍的報應他；用他調酒的杯加倍的調給他喝。',
    '啟18:7 他怎樣榮耀自己，怎樣奢華，也當叫他照樣痛苦悲哀，因他心裡說：我坐了皇后的位，並不是寡婦，決不至於悲哀。',
    '啟18:8 所以在一天之內，他的災殃要一齊來到，就是死亡、悲哀、饑荒。他又要被火燒盡了，因為審判他的主神大有能力。',
    '啟18:9 地上的君王，素來與他行淫、一同奢華的，看見燒他的煙，就必為他哭泣哀號。',
    '啟18:10 因怕他的痛苦，就遠遠的站著說：哀哉！哀哉！巴比倫大城，堅固的城啊，一時之間你的刑罰就來到了。',
    '啟18:11 地上的客商也都為他哭泣悲哀，因為沒有人再買他們的貨物了；',
    '啟18:12 這貨物就是金、銀、寶石、珍珠、細麻布、紫色料、綢子、朱紅色料、各樣香木、各樣象牙的器皿、各樣極寶貴的木頭，和銅、鐵、漢白玉的器皿，',
    '啟18:13 並肉桂、荳蔻、香料、香膏、乳香、酒、油、細麵、麥子、牛、羊、車、馬，和奴僕、人口。',
    '啟18:14 巴比倫哪，你所貪愛的果子離開了你；你一切的珍饈美味，和華美的物件也從你中間毀滅，決不能再見了。',
    '啟18:15 販賣這些貨物、藉著他發了財的客商，因怕他的痛苦，就遠遠的站著哭泣悲哀，說：',
    '啟18:16 哀哉！哀哉！這大城啊，素常穿著細麻、紫色、朱紅色的衣服，又用金子、寶石，和珍珠為妝飾。',
    '啟18:17 一時之間，這麼大的富厚就歸於無有了。凡船主和坐船往各處去的，並眾水手，連所有靠海為業的，都遠遠的站著，',
    '啟18:18 看見燒他的煙，就喊著說：有何城能比這大城呢﹖',
    '啟18:19 他們又把塵土撒在頭上，哭泣悲哀，喊著說：哀哉！哀哉！這大城啊。凡有船在海中的，都因他的珍寶成了富足！他在一時之間就成了荒場！',
    '啟18:20 天哪，眾聖徒、眾使徒、眾先知啊，你們都要因他歡喜，因為神已經在他身上伸了你們的冤。',
    '啟18:21 有一位大力的天使舉起一塊石頭，好像大磨石，扔在海裡，說：巴比倫大城也必這樣猛力的被扔下去，決不能再見了。',
    '啟18:22 彈琴、作樂、吹笛、吹號的聲音，在你中間決不能再聽見；各行手藝人在你中間決不能再遇見；推磨的聲音在你中間決不能再聽見；',
    '啟18:23 燈光在你中間決不能再照耀；新郎和新婦的聲音，在你中間決不能再聽見。你的客商原來是地上的尊貴人；萬國也被你的邪術迷惑了。',
    '啟18:24 先知和聖徒，並地上一切被殺之人的血，都在這城裡看見了。',
    '啟19:1 此後，我聽見好像群眾在天上大聲說：哈利路亞（就是要讚美耶和華的意思）！救恩、榮耀、權能都屬乎我們的神！',
    '啟19:2 他的判斷是真實公義的；因他判斷了那用淫行敗壞世界的大淫婦，並且向淫婦討流僕人血的罪，給他們伸冤。',
    '啟19:3 又說：哈利路亞！燒淫婦的煙往上冒，直到永永遠遠。',
    '啟19:4 那二十四位長老與四活物就俯伏敬拜坐寶座的神，說：阿們！哈利路亞！',
    '啟19:5 有聲音從寶座出來說：神的眾僕人哪，凡敬畏他的，無論大小，都要讚美我們的神！',
    '啟19:6 我聽見好像群眾的聲音，眾水的聲音，大雷的聲音，說：哈利路亞！因為主─我們的神、全能者作王了。',
    '啟19:7 我們要歡喜快樂，將榮耀歸給他。因為，羔羊婚娶的時候到了；新婦也自己預備好了，',
    '啟19:8 就蒙恩得穿光明潔白的細麻衣。（這細麻衣就是聖徒所行的義。）',
    '啟19:9 天使吩咐我說：你要寫上：凡被請赴羔羊之婚筵的有福了！又對我說：這是神真實的話。',
    '啟19:10 我就俯伏在他腳前要拜他。他說：千萬不可！我和你，並你那些為耶穌作見證的弟兄同是作僕人的，你要敬拜神。因為預言中的靈意乃是為耶穌作見證。',
    '啟19:11 我觀看，見天開了。有一匹白馬，騎在馬上的稱為誠信真實，他審判，爭戰，都按著公義。',
    '啟19:12 他的眼睛如火焰，他頭上戴著許多冠冕；又有寫著的名字，除了他自己沒有人知道。',
    '啟19:13 他穿著濺了血的衣服；他的名稱為神之道。',
    '啟19:14 在天上的眾軍騎著白馬，穿著細麻衣，又白又潔，跟隨他。',
    '啟19:15 有利劍從他口中出來，可以擊殺列國。他必用鐵杖轄管（轄管：原文是牧）他們，並要踹全能神烈怒的酒醡。',
    '啟19:16 在他衣服和大腿上有名寫著說：萬王之王，萬主之主。',
    '啟19:17 我又看見一位天使站在日頭中，向天空所飛的鳥大聲喊著說：你們聚集來赴神的大筵席，',
    '啟19:18 可以吃君王與將軍的肉，壯士與馬和騎馬者的肉，並一切自主的為奴的，以及大小人民的肉。',
    '啟19:19 我看見那獸和地上的君王，並他們的眾軍都聚集，要與騎白馬的並他的軍兵爭戰。',
    '啟19:20 那獸被擒拿；那在獸面前曾行奇事、迷惑受獸印記和拜獸像之人的假先知，也與獸同被擒拿。他們兩個就活活的被扔在燒著硫磺的火湖裡；',
    '啟19:21 其餘的被騎白馬者口中出來的劍殺了；飛鳥都吃飽了他們的肉。',
    '啟20:1 我又看見一位天使從天降下，手裡拿著無底坑的鑰匙和一條大鍊子。',
    '啟20:2 他捉住那龍，就是古蛇，又叫魔鬼，也叫撒但，把他捆綁一千年，',
    '啟20:3 扔在無底坑裡，將無底坑關閉，用印封上，使他不得再迷惑列國。等到那一千年完了，以後必須暫時釋放他。',
    '啟20:4 我又看見幾個寶座，也有坐在上面的，並有審判的權柄賜給他們。我又看見那些因為給耶穌作見證，並為神之道被斬者的靈魂，和那沒有拜過獸與獸像，也沒有在額上和手上受過他印記之人的靈魂，他們都復活了，與基督一同作王一千年。',
    '啟20:5 這是頭一次的復活。（其餘的死人還沒有復活，直等那一千年完了。）',
    '啟20:6 在頭一次復活有分的有福了，聖潔了！第二次的死在他們身上沒有權柄。他們必作神和基督的祭司，並要與基督一同作王一千年。',
    '啟20:7 那一千年完了，撒但必從監牢裡被釋放，',
    '啟20:8 出來要迷惑地上四方（原文是角）的列國，就是歌革和瑪各，叫他們聚集爭戰。他們的人數多如海沙。',
    '啟20:9 他們上來遍滿了全地，圍住聖徒的營與蒙愛的城，就有火從天降下，燒滅了他們。',
    '啟20:10 那迷惑他們的魔鬼被扔在硫磺的火湖裡，就是獸和假先知所在的地方。他們必晝夜受痛苦，直到永永遠遠。',
    '啟20:11 我又看見一個白色的大寶座與坐在上面的；從他面前天地都逃避，再無可見之處了。',
    '啟20:12 我又看見死了的人，無論大小，都站在寶座前。案卷展開了，並且另有一卷展開，就是生命冊。死了的人都憑著這些案卷所記載的，照他們所行的受審判。',
    '啟20:13 於是海交出其中的死人；死亡和陰間也交出其中的死人；他們都照各人所行的受審判。',
    '啟20:14 死亡和陰間也被扔在火湖裡；這火湖就是第二次的死。',
    '啟20:15 若有人名字沒記在生命冊上，他就被扔在火湖裡。',
    '啟21:1 我又看見一個新天新地；因為先前的天地已經過去了，海也不再有了。',
    '啟21:2 我又看見聖城新耶路撒冷由神那裡從天而降，預備好了，就如新婦妝飾整齊，等候丈夫。',
    '啟21:3 我聽見有大聲音從寶座出來說：看哪，神的帳幕在人間。他要與人同住，他們要作他的子民。神要親自與他們同在，作他們的神。',
    '啟21:4 神要擦去他們一切的眼淚；不再有死亡，也不再有悲哀、哭號、疼痛，因為以前的事都過去了。',
    '啟21:5 坐寶座的說：看哪，我將一切都更新了！又說：你要寫上；因這些話是可信的，是真實的。',
    '啟21:6 他又對我說：都成了！我是阿拉法，我是俄梅戛；我是初，我是終。我要將生命泉的水白白賜給那口渴的人喝。',
    '啟21:7 得勝的，必承受這些為業：我要作他的神，他要作我的兒子。',
    '啟21:8 惟有膽怯的、不信的、可憎的、殺人的、淫亂的、行邪術的、拜偶像的，和一切說謊話的，他們的分就在燒著硫磺的火湖裡；這是第二次的死。',
    '啟21:9 拿著七個金碗、盛滿末後七災的七位天使中，有一位來對我說：你到這裡來，我要將新婦，就是羔羊的妻，指給你看。',
    '啟21:10 我被聖靈感動，天使就帶我到一座高大的山，將那由神那裡、從天而降的聖城耶路撒冷指示我。',
    '啟21:11 城中有神的榮耀；城的光輝如同極貴的寶石，好像碧玉，明如水晶。',
    '啟21:12 有高大的牆，有十二個門，門上有十二位天使；門上又寫著以色列十二個支派的名字。',
    '啟21:13 東邊有三門、北邊有三門、南邊有三門、西邊有三門。',
    '啟21:14 城牆有十二根基，根基上有羔羊十二使徒的名字。',
    '啟21:15 對我說話的，拿著金葦子當尺，要量那城和城門城牆。',
    '啟21:16 城是四方的，長寬一樣。天使用葦子量那城，共有四千里，長、寬、高都是一樣；',
    '啟21:17 又量了城牆，按著人的尺寸，就是天使的尺寸，共有一百四十四肘。',
    '啟21:18 牆是碧玉造的；城是精金的，如同明淨的玻璃。',
    '啟21:19 城牆的根基是用各樣寶石修飾的：第一根基是碧玉；第二是藍寶石；第三是綠瑪瑙；第四是綠寶石；',
    '啟21:20 第五是紅瑪瑙；第六是紅寶石；第七是黃璧璽；第八是水蒼玉；第九是紅璧璽；第十是翡翠；第十一是紫瑪瑙；第十二是紫晶。',
    '啟21:21 十二個門是十二顆珍珠，每門是一顆珍珠。城內的街道是精金，好像明透的玻璃。',
    '啟21:22 我未見城內有殿，因主神─全能者和羔羊為城的殿。',
    '啟21:23 那城內又不用日月光照；因有神的榮耀光照，又有羔羊為城的燈。',
    '啟21:24 列國要在城的光裡行走；地上的君王必將自己的榮耀歸與那城。',
    '啟21:25 城門白晝總不關閉，在那裡原沒有黑夜。',
    '啟21:26 人必將列國的榮耀、尊貴歸與那城。',
    '啟21:27 凡不潔淨的，並那行可憎與虛謊之事的，總不得進那城；只有名字寫在羔羊生命冊上的才得進去。',
    '啟22:1 天使又指示我在城內街道當中一道生命水的河，明亮如水晶，從神和羔羊的寶座流出來。',
    '啟22:2 在河這邊與那邊有生命樹，結十二樣（或作：回）果子，每月都結果子；樹上的葉子乃為醫治萬民。',
    '啟22:3 以後再沒有咒詛；在城裡有神和羔羊的寶座；他的僕人都要事奉他，',
    '啟22:4 也要見他的面。他的名字必寫在他們的額上。',
    '啟22:5 不再有黑夜；他們也不用燈光、日光，因為主神要光照他們。他們要作王，直到永永遠遠。',
    '啟22:6 天使又對我說：這些話是真實可信的。主就是眾先知被感之靈的神，差遣他的使者，將那必要快成的事指示他僕人。',
    '啟22:7 看哪，我必快來！凡遵守這書上預言的有福了！',
    '啟22:8 這些事是我約翰所聽見、所看見的；我既聽見、看見了，就在指示我的天使腳前俯伏要拜他。',
    '啟22:9 他對我說：千萬不可！我與你和你的弟兄眾先知，並那些守這書上言語的人，同是作僕人的。你要敬拜神。',
    '啟22:10 他又對我說：不可封了這書上的預言，因為日期近了。',
    '啟22:11 不義的，叫他仍舊不義；污穢的，叫他仍舊污穢；為義的，叫他仍舊為義；聖潔的，叫他仍舊聖潔。',
    '啟22:12 看哪，我必快來！賞罰在我，要照各人所行的報應他。',
    '啟22:13 我是阿拉法，我是俄梅戛；我是首先的，我是末後的；我是初，我是終。',
    '啟22:14 那些洗淨自己衣服的有福了！可得權柄能到生命樹那裡，也能從門進城。',
    '啟22:15 城外有那些犬類、行邪術的、淫亂的、殺人的、拜偶像的，並一切喜好說謊言、編造虛謊的。',
    '啟22:16 我─耶穌差遣我的使者為眾教會將這些事向你們證明。我是大衛的根，又是他的後裔。我是明亮的晨星。',
    '啟22:17 聖靈和新婦都說：來！聽見的人也該說：來！口渴的人也當來；願意的，都可以白白取生命的水喝。',
    '啟22:18 我向一切聽見這書上預言的作見證，若有人在這預言上加添什麼，神必將寫在這書上的災禍加在他身上；',
    '啟22:19 這書上的預言，若有人刪去什麼，神必從這書上所寫的生命樹和聖城刪去他的分。',
    '啟22:20 證明這事的說：是了，我必快來！阿們！主耶穌啊，我願你來！',
    '啟22:21 願主耶穌的恩惠常與眾聖徒同在。阿們！'
];
